/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		49:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + {"0":"e08f5469436239c5b121","1":"af333ba15e16bea9443c","2":"40474002f87c388462af","3":"ddc1331a61c5edf2e960","4":"277175c36639f9bd9799","5":"ebc3bd0d4f90b7cadb56","6":"df99baefd7f3410ebb08","7":"c6d6dd52f7a188a85447","8":"cbd5d96eadc5c7b899d8","9":"816ee4702396a170cc25","10":"e8802ea656f25e64c64f","11":"6034de58d4da56b298b8","12":"91007d5ad214f10fbec1","13":"58b5d625d35fa2bb5376","14":"4fbed9ead06f03427531","15":"34277041392ce076411d","16":"ac02f2cb97196b7e04da","17":"7f86d7fac878bacad275","18":"f391e3c6e20137627846","19":"ed2c4bb7aa7971573b49","20":"4353c314fd391fc07938","21":"7fa756bfb236c650b6a2","22":"ed7b6dfda9851355a264","23":"78a2f661ed7565c7ade0","24":"4c6dce92ce0408ac851b","25":"75679ecc77fb8b0a55a8","26":"38a128c3ecb66c6ec181","27":"f8d2a5b52980dcd75353","28":"11ba833b175ef222f4a8","29":"5502f271a8131d7df30b","30":"2c429b2e044dfce76cfe","31":"fb0225545f2177c48f38","32":"9bfd56df40450f3dcfcb","33":"31d8c4f5bc857fcb84ef","34":"bec4a184ef240d10d527","35":"cba3dfbd672ae5312831","36":"eb1ae71d0445649239d7","37":"4545cdb187ac862c39b7","38":"a396f92262a3b3a05b3a","39":"caf1e3d692f2c84f4944","40":"73bf69a91a4679d8018e","41":"222507a23b25dffb9357","42":"4ba11da6d61c535a0126","43":"221b17c24e7ffa38576c","44":"68d0662096b3c53e68a4","45":"42cc74a68439ad3ba71d","46":"7debf70389481231c361","47":"e4f11ff804946819d036","48":"e216b528662ab8a41fd1"}[chunkId] + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var jQuery = __webpack_require__(2);
	var targetEnv = __webpack_require__(3);
	if (targetEnv.isBrowser) {
	    // johng, 2015-12: this is needed, at minimum, for integration tests
	    // to trigger the 'pliLoadedScripts' event. It is also needed to
	    // expose '$' as a global window variable for debugging purposes. We
	    // could have done this using browserify-shim, but that would make it
	    // available as a global variable in node/non-browser contexts.
	    // Consider moving this to window.dbg.$ at some point.
	    global.$ = jQuery;
	    // milang, 2015-12: This global is needed to properly initialize
	    // "velocity-animate" below in "jQuery plugin" mode
	    global.jQuery = jQuery;
	    /* tslint:disable */
	    __webpack_require__(4);
	}
	module.exports = jQuery;
	

	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*!
	 * jQuery JavaScript Library v2.1.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-04-28T16:01Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//
	
	var arr = [];
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		// Use the correct document accordingly with window argument (sandbox)
		document = window.document,
	
		version = "2.1.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		// (You can seed the arguments with an array of args, but this is
		// only used internally.)
		each: function( callback, args ) {
			return jQuery.each( this, callback, args );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map(this, function( elem, i ) {
				return callback.call( elem, i, elem );
			}));
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor(null);
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[0] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
			// Only deal with non-null/undefined values
			if ( (options = arguments[ i ]) != null ) {
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray(src) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject(src) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend({
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type(obj) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
		},
	
		isPlainObject: function( obj ) {
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			if ( obj.constructor &&
					!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
				return false;
			}
	
			// If the function hasn't returned already, we're confident that
			// |obj| is a plain object, created by {} or constructed with new Object
			return true;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call(obj) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf("use strict") === 1 ) {
					script = document.createElement("script");
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		// args is for internal usage only
		each: function( obj, callback, args ) {
			var value,
				i = 0,
				length = obj.length,
				isArray = isArraylike( obj );
	
			if ( args ) {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				}
	
			// A special, fast, case for the most common use of each
			} else {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArraylike( Object(arr) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var value,
				i = 0,
				length = elems.length,
				isArray = isArraylike( elems ),
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	});
	
	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	});
	
	function isArraylike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		if ( obj.nodeType === 1 && length ) {
			return true;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.0-pre
	 * http://sizzlejs.com/
	 *
	 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-12-16
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
		// http://www.w3.org/TR/css3-syntax/#characters
		characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Loosely modeled on CSS identifier characters
		// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
		// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = characterEncoding.replace( "w", "w#" ),
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + characterEncoding + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + characterEncoding + ")" ),
			"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
			"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var match, elem, m, nodeType,
			// QSA vars
			i, groups, old, nid, newContext, newSelector;
	
		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
	
		context = context || document;
		results = results || [];
		nodeType = context.nodeType;
	
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		if ( !seed && documentIsHTML ) {
	
			// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
				// Speed-up: Sizzle("#ID")
				if ( (m = match[1]) ) {
					if ( nodeType === 9 ) {
						elem = context.getElementById( m );
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document (jQuery #6963)
						if ( elem && elem.parentNode ) {
							// Handle the case where IE, Opera, and Webkit return items
							// by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}
					} else {
						// Context is not a document
						if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
							contains( context, elem ) && elem.id === m ) {
							results.push( elem );
							return results;
						}
					}
	
				// Speed-up: Sizzle("TAG")
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;
	
				// Speed-up: Sizzle(".CLASS")
				} else if ( (m = match[3]) && support.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}
	
			// QSA path
			if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
				nid = old = expando;
				newContext = context;
				newSelector = nodeType !== 1 && selector;
	
				// qSA works strangely on Element-rooted queries
				// We can work around this by specifying an extra ID on the root
				// and working up from there (Thanks to Andrew Dupont for the technique)
				// IE 8 doesn't work on object elements
				if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
					groups = tokenize( selector );
	
					if ( (old = context.getAttribute("id")) ) {
						nid = old.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", nid );
					}
					nid = "[id='" + nid + "'] ";
	
					i = groups.length;
					while ( i-- ) {
						groups[i] = nid + toSelector( groups[i] );
					}
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
					newSelector = groups.join(",");
				}
	
				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch(qsaError) {
					} finally {
						if ( !old ) {
							context.removeAttribute("id");
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = attrs.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// If no document and documentElement is available, return
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Set our document
		document = doc;
		docElem = doc.documentElement;
		parent = doc.defaultView;
	
		// Support: IE>8
		// If iframe document is assigned to "document" variable and if iframe has been reloaded,
		// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
		// IE6-8 do not support the defaultView property so parent will be undefined
		if ( parent && parent !== parent.top ) {
			// IE11 does not have attachEvent, so all must suffer
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Support tests
		---------------------------------------------------------------------- */
		documentIsHTML = !isXML( doc );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( doc.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( doc.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					return m && m.parentNode ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\f]' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = doc.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully does not implement inclusive descendent
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === doc ? -1 :
					b === doc ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return doc;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, outerCache, node, diff, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || (parent[ expando ] = {});
								cache = outerCache[ type ] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = cache[0] === dirruns && cache[2];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							// Use previously-cached element index if available
							} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
								diff = cache[1];
	
							// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
							} else {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
										// Cache the index of each encountered element
										if ( useCache ) {
											(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
										}
	
										if ( node === elem ) {
											break;
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
							if ( (oldCache = outerCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context !== document && context;
				}
	
				// Add elements passing elementMatchers directly to results
				// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// Apply set filters to unmatched elements
				matchedCount += i;
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is no seed and only one group
		if ( match.length === 1 ) {
	
			// Take a shortcut and set the context if the root selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			});
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			});
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
		});
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			}));
	};
	
	jQuery.fn.extend({
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter(function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				}) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow(this, selector || [], false) );
		},
		not: function( selector ) {
			return this.pushStack( winnow(this, selector || [], true) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	});
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && (match[1] || !context) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[1] ) {
						context = context instanceof jQuery ? context[0] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[1],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[2] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[0] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || rootjQuery ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[0] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof rootjQuery.ready !== "undefined" ?
					rootjQuery.ready( selector ) :
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.extend({
		dir: function( elem, dir, until ) {
			var matched = [],
				truncate = until !== undefined;
	
			while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
				if ( elem.nodeType === 1 ) {
					if ( truncate && jQuery( elem ).is( until ) ) {
						break;
					}
					matched.push( elem );
				}
			}
			return matched;
		},
	
		sibling: function( n, elem ) {
			var matched = [];
	
			for ( ; n; n = n.nextSibling ) {
				if ( n.nodeType === 1 && n !== elem ) {
					matched.push( n );
				}
			}
	
			return matched;
		}
	});
	
	jQuery.fn.extend({
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter(function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[i] ) ) {
						return true;
					}
				}
			});
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
					// Always skip document fragments
					if ( cur.nodeType < 11 && (pos ?
						pos.index(cur) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector(cur, selectors)) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.unique(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter(selector)
			);
		}
	});
	
	function sibling( cur, dir ) {
		while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each({
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return jQuery.dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return jQuery.dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return jQuery.dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return jQuery.sibling( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.unique( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	});
	var rnotwhite = (/\S+/g);
	
	
	
	// String to Object options format cache
	var optionsCache = {};
	
	// Convert String-formatted options into Object-formatted ones and store in cache
	function createOptions( options ) {
		var object = optionsCache[ options ] = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		});
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			( optionsCache[ options ] || createOptions( options ) ) :
			jQuery.extend( {}, options );
	
		var // Last fire value (for non-forgettable lists)
			memory,
			// Flag to know if list was already fired
			fired,
			// Flag to know if list is currently firing
			firing,
			// First callback to fire (used internally by add and fireWith)
			firingStart,
			// End of the loop when firing
			firingLength,
			// Index of currently firing callback (modified by remove if needed)
			firingIndex,
			// Actual callback list
			list = [],
			// Stack of fire calls for repeatable lists
			stack = !options.once && [],
			// Fire callbacks
			fire = function( data ) {
				memory = options.memory && data;
				fired = true;
				firingIndex = firingStart || 0;
				firingStart = 0;
				firingLength = list.length;
				firing = true;
				for ( ; list && firingIndex < firingLength; firingIndex++ ) {
					if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
						memory = false; // To prevent further calls using add
						break;
					}
				}
				firing = false;
				if ( list ) {
					if ( stack ) {
						if ( stack.length ) {
							fire( stack.shift() );
						}
					} else if ( memory ) {
						list = [];
					} else {
						self.disable();
					}
				}
			},
			// Actual Callbacks object
			self = {
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
						// First, we save the current length
						var start = list.length;
						(function add( args ) {
							jQuery.each( args, function( _, arg ) {
								var type = jQuery.type( arg );
								if ( type === "function" ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && type !== "string" ) {
									// Inspect recursively
									add( arg );
								}
							});
						})( arguments );
						// Do we need to add the callbacks to the
						// current firing batch?
						if ( firing ) {
							firingLength = list.length;
						// With memory, if we're not firing then
						// we should call right away
						} else if ( memory ) {
							firingStart = start;
							fire( memory );
						}
					}
					return this;
				},
				// Remove a callback from the list
				remove: function() {
					if ( list ) {
						jQuery.each( arguments, function( _, arg ) {
							var index;
							while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
								list.splice( index, 1 );
								// Handle firing indexes
								if ( firing ) {
									if ( index <= firingLength ) {
										firingLength--;
									}
									if ( index <= firingIndex ) {
										firingIndex--;
									}
								}
							}
						});
					}
					return this;
				},
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
				},
				// Remove all callbacks from the list
				empty: function() {
					list = [];
					firingLength = 0;
					return this;
				},
				// Have the list do nothing anymore
				disable: function() {
					list = stack = memory = undefined;
					return this;
				},
				// Is it disabled?
				disabled: function() {
					return !list;
				},
				// Lock the list in its current state
				lock: function() {
					stack = undefined;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				// Is it locked?
				locked: function() {
					return !stack;
				},
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( list && ( !fired || stack ) ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						if ( firing ) {
							stack.push( args );
						} else {
							fire( args );
						}
					}
					return this;
				},
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend({
	
		Deferred: function( func ) {
			var tuples = [
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks("memory") ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred(function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[1] ](function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.done( newDefer.resolve )
											.fail( newDefer.reject )
											.progress( newDefer.notify );
									} else {
										newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
									}
								});
							});
							fns = null;
						}).promise();
					},
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[1] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(function() {
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[0] ] = function() {
					deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[0] + "With" ] = list.fireWith;
			});
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject )
							.progress( updateFunc( i, progressContexts, progressValues ) );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	});
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend({
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	});
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed, false );
		window.removeEventListener( "load", completed, false );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called after the browser event has already occurred.
			// We once tried to use readyState "interactive" here, but it caused issues like the one
			// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
			if ( document.readyState === "complete" ) {
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed, false );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed, false );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[0], key ) : emptyGet;
	};
	
	
	/**
	 * Determines whether an object can have data
	 */
	jQuery.acceptData = function( owner ) {
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	function Data() {
		// Support: Android<4,
		// Old WebKit does not have Object.preventExtensions/freeze method,
		// return new empty object instead with no [[set]] accessor
		Object.defineProperty( this.cache = {}, 0, {
			get: function() {
				return {};
			}
		});
	
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	Data.accepts = jQuery.acceptData;
	
	Data.prototype = {
		key: function( owner ) {
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return the key for a frozen object.
			if ( !Data.accepts( owner ) ) {
				return 0;
			}
	
			var descriptor = {},
				// Check if the owner object already has a cache key
				unlock = owner[ this.expando ];
	
			// If not, create one
			if ( !unlock ) {
				unlock = Data.uid++;
	
				// Secure it in a non-enumerable, non-writable property
				try {
					descriptor[ this.expando ] = { value: unlock };
					Object.defineProperties( owner, descriptor );
	
				// Support: Android<4
				// Fallback to a less secure definition
				} catch ( e ) {
					descriptor[ this.expando ] = unlock;
					jQuery.extend( owner, descriptor );
				}
			}
	
			// Ensure the cache object
			if ( !this.cache[ unlock ] ) {
				this.cache[ unlock ] = {};
			}
	
			return unlock;
		},
		set: function( owner, data, value ) {
			var prop,
				// There may be an unlock assigned to this node,
				// if there is no entry for this "owner", create one inline
				// and set the unlock as though an owner entry had always existed
				unlock = this.key( owner ),
				cache = this.cache[ unlock ];
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
				// Fresh assignments by object are shallow copied
				if ( jQuery.isEmptyObject( cache ) ) {
					jQuery.extend( this.cache[ unlock ], data );
				// Otherwise, copy the properties one-by-one to the cache object
				} else {
					for ( prop in data ) {
						cache[ prop ] = data[ prop ];
					}
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			// Either a valid cache is found, or will be created.
			// New caches will be created and the unlock returned,
			// allowing direct access to the newly created
			// empty data object. A valid owner object must be provided.
			var cache = this.cache[ this.key( owner ) ];
	
			return key === undefined ?
				cache : cache[ key ];
		},
		access: function( owner, key, value ) {
			var stored;
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					((key && typeof key === "string") && value === undefined) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase(key) );
			}
	
			// [*]When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				unlock = this.key( owner ),
				cache = this.cache[ unlock ];
	
			if ( key === undefined ) {
				this.cache[ unlock ] = {};
	
			} else {
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
		},
		hasData: function( owner ) {
			return !jQuery.isEmptyObject(
				this.cache[ owner[ this.expando ] ] || {}
			);
		},
		discard: function( owner ) {
			if ( owner[ this.expando ] ) {
				delete this.cache[ owner[ this.expando ] ];
			}
		}
	};
	var data_priv = new Data();
	
	var data_user = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch( e ) {}
	
				// Make sure we set the data so it isn't changed later
				data_user.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend({
		hasData: function( elem ) {
			return data_user.hasData( elem ) || data_priv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return data_user.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			data_user.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to data_priv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return data_priv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			data_priv.remove( elem, name );
		}
	});
	
	jQuery.fn.extend({
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = data_user.get( elem );
	
					if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice(5) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						data_priv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each(function() {
					data_user.set( this, key );
				});
			}
	
			return access( this, function( value ) {
				var data,
					camelKey = jQuery.camelCase( key );
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
					// Attempt to get data from the cache
					// with the key as-is
					data = data_user.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to get data from the cache
					// with the key camelized
					data = data_user.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each(function() {
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = data_user.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					data_user.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf("-") !== -1 && data !== undefined ) {
						data_user.set( this, key, value );
					}
				});
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each(function() {
				data_user.remove( this, key );
			});
		}
	});
	
	
	jQuery.extend({
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = data_priv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = data_priv.access( elem, type, jQuery.makeArray(data) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return data_priv.get( elem, key ) || data_priv.access( elem, key, {
				empty: jQuery.Callbacks("once memory").add(function() {
					data_priv.remove( elem, [ type + "queue", key ] );
				})
			});
		}
	});
	
	jQuery.fn.extend({
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[0], type );
			}
	
			return data === undefined ?
				this :
				this.each(function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[0] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				});
		},
		dequeue: function( type ) {
			return this.each(function() {
				jQuery.dequeue( this, type );
			});
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = data_priv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	});
	var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
		};
	
	var rcheckableType = (/^(?:checkbox|radio)$/i);
	
	
	
	(function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	})();
	var strundefined = typeof undefined;
	
	
	
	support.focusinBubbles = "onfocusin" in window;
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = data_priv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !(events = elemData.events) ) {
				events = elemData.events = {};
			}
			if ( !(eventHandle = elemData.handle) ) {
				eventHandle = elemData.handle = function( e ) {
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend({
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join(".")
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !(handlers = events[ type ]) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = data_priv.hasData( elem ) && data_priv.get( elem );
	
			if ( !elemData || !(events = elemData.events) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
				data_priv.remove( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf(".") >= 0 ) {
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split(".");
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf(":") < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join(".");
			event.namespace_re = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === (elem.ownerDocument || document) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
					jQuery.acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[0] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
								.apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( (event.result = ret) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			// Avoid non-left-click bubbling in Firefox (#3861)
			if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.disabled !== true || event.type !== "click" ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) >= 0 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push({ elem: cur, handlers: matches });
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split(" "),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		simulate: function( type, elem, event, bubble ) {
			// Piggyback on a donor event to simulate a different one.
			// Fake originalEvent to avoid donor's stopPropagation, but if the
			// simulated event prevents default then we do the same on the donor.
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true,
					originalEvent: {}
				}
			);
			if ( bubble ) {
				jQuery.event.trigger( e, null, elem );
			} else {
				jQuery.event.dispatch.call( elem, e );
			}
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle, false );
		}
	};
	
	jQuery.Event = function( src, props ) {
		// Allow instantiation without the 'new' keyword
		if ( !(this instanceof jQuery.Event) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && e.preventDefault ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && e.stopPropagation ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// Support: Chrome 15+
	jQuery.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mousenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	});
	
	// Support: Firefox, Chrome, Safari
	// Create "bubbling" focus and blur events
	if ( !support.focusinBubbles ) {
		jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
					jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
				};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = data_priv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = data_priv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						data_priv.remove( doc, fix );
	
					} else {
						data_priv.access( doc, fix, attaches );
					}
				}
			};
		});
	}
	
	jQuery.fn.extend({
	
		on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
			var origFn, type;
	
			// Types can be a map of types/handlers
			if ( typeof types === "object" ) {
				// ( types-Object, selector, data )
				if ( typeof selector !== "string" ) {
					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for ( type in types ) {
					this.on( type, selector, data, types[ type ], one );
				}
				return this;
			}
	
			if ( data == null && fn == null ) {
				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if ( fn == null ) {
				if ( typeof selector === "string" ) {
					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {
					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if ( fn === false ) {
				fn = returnFalse;
			} else if ( !fn ) {
				return this;
			}
	
			if ( one === 1 ) {
				origFn = fn;
				fn = function( event ) {
					// Can use an empty set, since event contains the info
					jQuery().off( event );
					return origFn.apply( this, arguments );
				};
				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
			}
			return this.each( function() {
				jQuery.event.add( this, types, fn, data, selector );
			});
		},
		one: function( types, selector, data, fn ) {
			return this.on( types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each(function() {
				jQuery.event.remove( this, types, fn, selector );
			});
		},
	
		trigger: function( type, data ) {
			return this.each(function() {
				jQuery.event.trigger( type, data, this );
			});
		},
		triggerHandler: function( type, data ) {
			var elem = this[0];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	});
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
		rtagName = /<([\w:]+)/,
		rhtml = /<|&#?\w+;/,
		rnoInnerhtml = /<(?:script|style|link)/i,
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptType = /^$|\/(?:java|ecma)script/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	
		// We have to close these tags to support XHTML (#13200)
		wrapMap = {
	
			// Support: IE9
			option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
			thead: [ 1, "<table>", "</table>" ],
			col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
			tr: [ 2, "<table><tbody>", "</tbody></table>" ],
			td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
			_default: [ 0, "", "" ]
		};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: 1.x compatibility
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName("tbody")[0] ||
				elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute("type");
		}
	
		return elem;
	}
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			data_priv.set(
				elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( data_priv.hasData( src ) ) {
			pdataOld = data_priv.access( src );
			pdataCur = data_priv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( data_user.hasData( src ) ) {
			udataOld = data_user.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			data_user.set( dest, udataCur );
		}
	}
	
	function getAll( context, tag ) {
		var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
				context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	jQuery.extend({
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		buildFragment: function( elems, context, scripts, selection ) {
			var elem, tmp, tag, wrap, contains, j,
				fragment = context.createDocumentFragment(),
				nodes = [],
				i = 0,
				l = elems.length;
	
			for ( ; i < l; i++ ) {
				elem = elems[ i ];
	
				if ( elem || elem === 0 ) {
	
					// Add nodes directly
					if ( jQuery.type( elem ) === "object" ) {
						// Support: QtWebKit, PhantomJS
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
					// Convert non-html into a text node
					} else if ( !rhtml.test( elem ) ) {
						nodes.push( context.createTextNode( elem ) );
	
					// Convert html into DOM nodes
					} else {
						tmp = tmp || fragment.appendChild( context.createElement("div") );
	
						// Deserialize a standard representation
						tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
						wrap = wrapMap[ tag ] || wrapMap._default;
						tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];
	
						// Descend through wrappers to the right content
						j = wrap[ 0 ];
						while ( j-- ) {
							tmp = tmp.lastChild;
						}
	
						// Support: QtWebKit, PhantomJS
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, tmp.childNodes );
	
						// Remember the top-level container
						tmp = fragment.firstChild;
	
						// Ensure the created nodes are orphaned (#12392)
						tmp.textContent = "";
					}
				}
			}
	
			// Remove wrapper from fragment
			fragment.textContent = "";
	
			i = 0;
			while ( (elem = nodes[ i++ ]) ) {
	
				// #4087 - If origin and destination elements are the same, and this is
				// that element, do not do anything
				if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
					continue;
				}
	
				contains = jQuery.contains( elem.ownerDocument, elem );
	
				// Append to fragment
				tmp = getAll( fragment.appendChild( elem ), "script" );
	
				// Preserve script evaluation history
				if ( contains ) {
					setGlobalEval( tmp );
				}
	
				// Capture executables
				if ( scripts ) {
					j = 0;
					while ( (elem = tmp[ j++ ]) ) {
						if ( rscriptType.test( elem.type || "" ) ) {
							scripts.push( elem );
						}
					}
				}
			}
	
			return fragment;
		},
	
		cleanData: function( elems ) {
			var data, elem, type, key,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
				if ( jQuery.acceptData( elem ) ) {
					key = elem[ data_priv.expando ];
	
					if ( key && (data = data_priv.cache[ key ]) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
						if ( data_priv.cache[ key ] ) {
							// Discard any remaining `private` data
							delete data_priv.cache[ key ];
						}
					}
				}
				// Discard any remaining `user` data
				delete data_user.cache[ elem[ data_user.expando ] ];
			}
		}
	});
	
	jQuery.fn.extend({
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each(function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					});
			}, null, value, arguments.length );
		},
	
		append: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			});
		},
	
		prepend: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			});
		},
	
		before: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			});
		},
	
		after: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			});
		},
	
		remove: function( selector, keepData /* Internal Use Only */ ) {
			var elem,
				elems = selector ? jQuery.filter( selector, this ) : this,
				i = 0;
	
			for ( ; (elem = elems[i]) != null; i++ ) {
				if ( !keepData && elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem ) );
				}
	
				if ( elem.parentNode ) {
					if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
						setGlobalEval( getAll( elem, "script" ) );
					}
					elem.parentNode.removeChild( elem );
				}
			}
	
			return this;
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; (elem = this[i]) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map(function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			});
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = value.replace( rxhtmlTag, "<$1></$2>" );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var arg = arguments[ 0 ];
	
			// Make the changes, replacing each context element with the new content
			this.domManip( arguments, function( elem ) {
				arg = this.parentNode;
	
				jQuery.cleanData( getAll( this ) );
	
				if ( arg ) {
					arg.replaceChild( elem, this );
				}
			});
	
			// Force removal if there was no new content (e.g., from empty arguments)
			return arg && (arg.length || arg.nodeType) ? this : this.remove();
		},
	
		detach: function( selector ) {
			return this.remove( selector, true );
		},
	
		domManip: function( args, callback ) {
	
			// Flatten any nested arrays
			args = concat.apply( [], args );
	
			var fragment, first, scripts, hasScripts, node, doc,
				i = 0,
				l = this.length,
				set = this,
				iNoClone = l - 1,
				value = args[ 0 ],
				isFunction = jQuery.isFunction( value );
	
			// We can't cloneNode fragments that contain checked, in WebKit
			if ( isFunction ||
					( l > 1 && typeof value === "string" &&
						!support.checkClone && rchecked.test( value ) ) ) {
				return this.each(function( index ) {
					var self = set.eq( index );
					if ( isFunction ) {
						args[ 0 ] = value.call( this, index, self.html() );
					}
					self.domManip( args, callback );
				});
			}
	
			if ( l ) {
				fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
				first = fragment.firstChild;
	
				if ( fragment.childNodes.length === 1 ) {
					fragment = first;
				}
	
				if ( first ) {
					scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
					hasScripts = scripts.length;
	
					// Use the original fragment for the last item instead of the first because it can end up
					// being emptied incorrectly in certain situations (#8070).
					for ( ; i < l; i++ ) {
						node = fragment;
	
						if ( i !== iNoClone ) {
							node = jQuery.clone( node, true, true );
	
							// Keep references to cloned scripts for later restoration
							if ( hasScripts ) {
								// Support: QtWebKit
								// jQuery.merge because push.apply(_, arraylike) throws
								jQuery.merge( scripts, getAll( node, "script" ) );
							}
						}
	
						callback.call( this[ i ], node, i );
					}
	
					if ( hasScripts ) {
						doc = scripts[ scripts.length - 1 ].ownerDocument;
	
						// Reenable scripts
						jQuery.map( scripts, restoreScript );
	
						// Evaluate executable scripts on first document insertion
						for ( i = 0; i < hasScripts; i++ ) {
							node = scripts[ i ];
							if ( rscriptType.test( node.type || "" ) &&
								!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {
	
								if ( node.src ) {
									// Optional AJAX dependency, but won't run scripts if not present
									if ( jQuery._evalUrl ) {
										jQuery._evalUrl( node.src );
									}
								} else {
									jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
								}
							}
						}
					}
				}
			}
	
			return this;
		}
	});
	
	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	});
	
	
	var iframe,
		elemdisplay = {};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var style,
			elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			// getDefaultComputedStyle might be reliably used only on attached element
			display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?
	
				// Use of this method is a temporary fix (more like optimization) until something better comes along,
				// since it was removed from specification and supported only in FF
				style.display : jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = (/^margin/);
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			if ( elem.ownerDocument.defaultView.opener ) {
				return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
			}
	
			return window.getComputedStyle( elem, null );
		};
	
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
		}
	
		if ( computed ) {
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// Support: iOS < 6
			// A tribute to the "awesome hack by Dean Edwards"
			// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
			// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
			if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
			// Support: IE
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return (this.get = hookFn).apply( this, arguments );
			}
		};
	}
	
	
	(function() {
		var pixelPositionVal, boxSizingReliableVal,
			docElem = document.documentElement,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
			"position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computePixelPositionAndBoxSizingReliable() {
			div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
				"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
				"border:1px;padding:1px;width:4px;position:absolute";
			div.innerHTML = "";
			docElem.appendChild( container );
	
			var divStyle = window.getComputedStyle( div, null );
			pixelPositionVal = divStyle.top !== "1%";
			boxSizingReliableVal = divStyle.width === "4px";
	
			docElem.removeChild( container );
		}
	
		// Support: node.js jsdom
		// Don't assume that getComputedStyle is a property of the global object
		if ( window.getComputedStyle ) {
			jQuery.extend( support, {
				pixelPosition: function() {
	
					// This test is executed only once but we still do memoizing
					// since we can use the boxSizingReliable pre-computing.
					// No need to check if the test was already performed, though.
					computePixelPositionAndBoxSizingReliable();
					return pixelPositionVal;
				},
				boxSizingReliable: function() {
					if ( boxSizingReliableVal == null ) {
						computePixelPositionAndBoxSizingReliable();
					}
					return boxSizingReliableVal;
				},
				reliableMarginRight: function() {
	
					// Support: Android 2.3
					// Check if div with explicit width and no margin-right incorrectly
					// gets computed margin-right based on width of container. (#3333)
					// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
					// This support function is only executed once so no memoizing is needed.
					var ret,
						marginDiv = div.appendChild( document.createElement( "div" ) );
	
					// Reset CSS: box-sizing; display; margin; border; padding
					marginDiv.style.cssText = div.style.cssText =
						// Support: Firefox<29, Android 2.3
						// Vendor-prefix box-sizing
						"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
						"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
					marginDiv.style.marginRight = marginDiv.style.width = "0";
					div.style.width = "1px";
					docElem.appendChild( container );
	
					ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );
	
					docElem.removeChild( container );
					div.removeChild( marginDiv );
	
					return ret;
				}
			});
		}
	})();
	
	
	// A method for quickly swapping in/out CSS properties to get correct calculations.
	jQuery.swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var
		// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
		rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( style, name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in style ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[0].toUpperCase() + name.slice(1),
			origName = name,
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in style ) {
				return name;
			}
		}
	
		return origName;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
			// If we already have the right measurement, avoid augmentation
			4 :
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test(val) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = data_priv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend({
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && (ret = rrelNum.exec( value )) ) {
					value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number, add 'px' to the (except for certain CSS properties)
				if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
					value += "px";
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
					style[ name ] = value;
				}
	
			} else {
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
			}
			return val;
		}
	});
	
	jQuery.each([ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
						jQuery.swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						}) :
						getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	});
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return jQuery.swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	});
	
	jQuery.fn.extend({
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each(function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			});
		}
	});
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || "swing";
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				if ( tween.elem[ tween.prop ] != null &&
					(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		}
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
		rrun = /queueHooks$/,
		animationPrefilters = [ defaultPrefilter ],
		tweeners = {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value ),
					target = tween.cur(),
					parts = rfxnum.exec( value ),
					unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
					// Starting value computation is required for potential unit mismatches
					start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
						rfxnum.exec( jQuery.css( tween.elem, prop ) ),
					scale = 1,
					maxIterations = 20;
	
				if ( start && start[ 3 ] !== unit ) {
					// Trust units reported by jQuery.css
					unit = unit || start[ 3 ];
	
					// Make sure we update the tween properties later on
					parts = parts || [];
	
					// Iteratively approximate from a nonzero starting point
					start = +target || 1;
	
					do {
						// If previous iteration zeroed out, double until we get *something*.
						// Use string for doubling so we don't accidentally see scale as unchanged below
						scale = scale || ".5";
	
						// Adjust and apply
						start = start / scale;
						jQuery.style( tween.elem, prop, start + unit );
	
					// Update scale, tolerating zero or NaN from tween.cur(),
					// break the loop if scale is unchanged or perfect, or if we've just had enough
					} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
				}
	
				// Update tween properties
				if ( parts ) {
					start = tween.start = +start || +target || 0;
					tween.unit = unit;
					// If a +=/-= token was provided, we're doing a relative animation
					tween.end = parts[ 1 ] ?
						start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
						+parts[ 2 ];
				}
	
				return tween;
			} ]
		};
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		setTimeout(function() {
			fxNow = undefined;
		});
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( (tween = collection[ index ].call( animation, prop, value )) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = data_priv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always(function() {
				// Ensure the complete handler is called before this completes
				anim.always(function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				});
			});
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always(function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			});
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = data_priv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done(function() {
					jQuery( elem ).hide();
				});
			}
			anim.done(function() {
				var prop;
	
				data_priv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			});
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = animationPrefilters.length,
			deferred = jQuery.Deferred().always( function() {
				// Don't match elem in the :animated selector
				delete tick.elem;
			}),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ]);
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise({
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, { specialEasing: {} }, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			}),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			})
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.split(" ");
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				tweeners[ prop ] = tweeners[ prop ] || [];
				tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				animationPrefilters.unshift( callback );
			} else {
				animationPrefilters.push( callback );
			}
		}
	});
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend({
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || data_priv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each(function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = data_priv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			});
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each(function() {
				var index,
					data = data_priv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			});
		}
	});
	
	jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	});
	
	// Generate shortcuts for custom animations
	jQuery.each({
		slideDown: genFx("show"),
		slideUp: genFx("hide"),
		slideToggle: genFx("toggle"),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	});
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = setTimeout( next, time );
			hooks.stop = function() {
				clearTimeout( timeout );
			};
		});
	};
	
	
	(function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	})();
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend({
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each(function() {
				jQuery.removeAttr( this, name );
			});
		}
	});
	
	jQuery.extend({
		attr: function( elem, name, value ) {
			var hooks, ret,
				nType = elem.nodeType;
	
			// don't get/set attributes on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === strundefined ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
	
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
	
				} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
					return ret;
	
				} else {
					elem.setAttribute( name, value + "" );
					return value;
				}
	
			} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
				return ret;
	
			} else {
				ret = jQuery.find.attr( elem, name );
	
				// Non-existent attributes return null, we normalize to undefined
				return ret == null ?
					undefined :
					ret;
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( (name = attrNames[i++]) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		}
	});
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	});
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i;
	
	jQuery.fn.extend({
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each(function() {
				delete this[ jQuery.propFix[ name ] || name ];
			});
		}
	});
	
	jQuery.extend({
		propFix: {
			"for": "htmlFor",
			"class": "className"
		},
	
		prop: function( elem, name, value ) {
			var ret, hooks, notxml,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			notxml = nType !== 1 || !jQuery.isXMLDoc( elem );
	
			if ( notxml ) {
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
					ret :
					( elem[ name ] = value );
	
			} else {
				return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
					ret :
					elem[ name ];
			}
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
					return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
						elem.tabIndex :
						-1;
				}
			}
		}
	});
	
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			}
		};
	}
	
	jQuery.each([
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	});
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	jQuery.fn.extend({
		addClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				proceed = typeof value === "string" && value,
				i = 0,
				len = this.length;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).addClass( value.call( this, j, this.className ) );
				});
			}
	
			if ( proceed ) {
				// The disjunction here is for better compressibility (see removeClass)
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						" "
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				proceed = arguments.length === 0 || typeof value === "string" && value,
				i = 0,
				len = this.length;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).removeClass( value.call( this, j, this.className ) );
				});
			}
			if ( proceed ) {
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						""
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = value ? jQuery.trim( cur ) : "";
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( i ) {
					jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
				});
			}
	
			return this.each(function() {
				if ( type === "string" ) {
					// Toggle individual class names
					var className,
						i = 0,
						self = jQuery( this ),
						classNames = value.match( rnotwhite ) || [];
	
					while ( (className = classNames[ i++ ]) ) {
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( type === strundefined || type === "boolean" ) {
					if ( this.className ) {
						// store className if set
						data_priv.set( this, "__className__", this.className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
				}
			});
		},
	
		hasClass: function( selector ) {
			var className = " " + selector + " ",
				i = 0,
				l = this.length;
			for ( ; i < l; i++ ) {
				if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
					return true;
				}
			}
	
			return false;
		}
	});
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend({
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[0];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
						// Handle most common string cases
						ret.replace(rreturn, "") :
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each(function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					});
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			});
		}
	});
	
	jQuery.extend({
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						jQuery.trim( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE6-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	});
	
	// Radios and checkboxes getter/setter
	jQuery.each([ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute("value") === null ? "on" : elem.value;
			};
		}
	});
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	});
	
	jQuery.fn.extend({
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		},
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
		}
	});
	
	
	var nonce = jQuery.now();
	
	var rquery = (/\?/);
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			tmp = new DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Document location
		ajaxLocation = window.location.href,
	
		// Segment location into parts
		ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
				// For each dataType in the dataTypeExpression
				while ( (dataType = dataTypes[i++]) ) {
					// Prepend if requested
					if ( dataType[0] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						(structure[ dataType ] = structure[ dataType ] || []).unshift( func );
	
					// Otherwise append
					} else {
						(structure[ dataType ] = structure[ dataType ] || []).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			});
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend({
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /xml/,
				html: /html/,
				json: /json/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
				// URL without anti-cache param
				cacheURL,
				// Response headers
				responseHeadersString,
				responseHeaders,
				// timeout handle
				timeoutTimer,
				// Cross-domain detection vars
				parts,
				// To know if global events are to be dispatched
				fireGlobals,
				// Loop variable
				i,
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
				// Callbacks context
				callbackContext = s.context || s,
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks("once memory"),
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
				// The jqXHR state
				state = 0,
				// Default abort message
				strAbort = "canceled",
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( (match = rheaders.exec( responseHeadersString )) ) {
									responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
				.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger("ajaxStart");
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
					s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = setTimeout(function() {
						jqXHR.abort("timeout");
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader("Last-Modified");
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader("etag");
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger("ajaxStop");
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	});
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			return jQuery.ajax({
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			});
		};
	});
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax({
			url: url,
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		});
	};
	
	
	jQuery.fn.extend({
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each(function( i ) {
					jQuery( this ).wrapAll( html.call(this, i) );
				});
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map(function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				}).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each(function( i ) {
					jQuery( this ).wrapInner( html.call(this, i) );
				});
			}
	
			return this.each(function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			});
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each(function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
			});
		},
	
		unwrap: function() {
			return this.parent().each(function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			}).end();
		}
	});
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
	};
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
				}
			});
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			});
	
		} else {
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend({
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map(function() {
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			})
			.filter(function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			})
			.map(function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						}) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			}).get();
		}
	});
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new XMLHttpRequest();
		} catch( e ) {}
	};
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSuccessStatus = {
			// file protocol always yields status code 0, assume 200
			0: 200,
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE9
	// Open requests must be manually aborted on unload (#5280)
	// See https://support.microsoft.com/kb/2856746 for more info
	if ( window.attachEvent ) {
		window.attachEvent( "onunload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]();
			}
		});
	}
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport(function( options ) {
		var callback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;
	
					xhr.open( options.type, options.url, options.async, options.username, options.password );
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers["X-Requested-With"] ) {
						headers["X-Requested-With"] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								delete xhrCallbacks[ id ];
								callback = xhr.onload = xhr.onerror = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
									complete(
										// file: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
										// Support: IE9
										// Accessing binary-data responseText throws an exception
										// (#11426)
										typeof xhr.responseText === "string" ? {
											text: xhr.responseText
										} : undefined,
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					xhr.onerror = callback("error");
	
					// Create the abort callback
					callback = xhrCallbacks[ id ] = callback("abort");
	
					try {
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	});
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /(?:java|ecma)script/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	});
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	});
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery("<script>").prop({
						async: true,
						charset: s.scriptCharset,
						src: s.url
					}).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	});
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	});
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters["script json"] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always(function() {
				// Restore preexisting value
				window[ callbackName ] = overwritten;
	
				// Save back as free
				if ( s[ callbackName ] ) {
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			});
	
			// Delegate to script
			return "script";
		}
	});
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context, defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[1] ) ];
		}
	
		parsed = jQuery.buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf(" ");
	
		if ( off >= 0 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax({
				url: url,
	
				// if "type" variable is undefined, then "GET" method will be used
				type: type,
				dataType: "html",
				data: params
			}).done(function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			}).complete( callback && function( jqXHR, status ) {
				self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
			});
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	});
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep(jQuery.timers, function( fn ) {
			return elem === fn.elem;
		}).length;
	};
	
	
	
	
	var docElem = window.document.documentElement;
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf("auto") > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
				options = options.call( elem, i, curOffset );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend({
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each(function( i ) {
						jQuery.offset.setOffset( this, options, i );
					});
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// Support: BlackBerry 5, iOS 3 (original iPhone)
			// If we don't have gBCR, just use 0,0 rather than error
			if ( typeof elem.getBoundingClientRect !== strundefined ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		offsetParent: function() {
			return this.map(function() {
				var offsetParent = this.offsetParent || docElem;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || docElem;
			});
		}
	});
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : window.pageXOffset,
						top ? val : window.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	});
	
	// Support: Safari<7+, Chrome<37+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	});
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		});
	});
	
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( typeof define === "function" && define.amd ) {
		define( "jquery", [], function() {
			return jQuery;
		});
	}
	
	
	
	
	var
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === strundefined ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	
	}));
	


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	module.exports = {
	  target: 'webpack',
	  isBrowser: true
	};
	


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*! VelocityJS.org (1.3.1). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */
	
	/*************************
	 Velocity jQuery Shim
	 *************************/
	
	/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */
	
	/* This file contains the jQuery functions that Velocity relies on, thereby removing Velocity's dependency on a full copy of jQuery, and allowing it to work in any environment. */
	/* These shimmed functions are only used if jQuery isn't present. If both this shim and jQuery are loaded, Velocity defaults to jQuery proper. */
	/* Browser support: Using this shim instead of jQuery proper removes support for IE8. */
	
	(function(window) {
		"use strict";
		/***************
		 Setup
		 ***************/
	
		/* If jQuery is already loaded, there's no point in loading this shim. */
		if (window.jQuery) {
			return;
		}
	
		/* jQuery base. */
		var $ = function(selector, context) {
			return new $.fn.init(selector, context);
		};
	
		/********************
		 Private Methods
		 ********************/
	
		/* jQuery */
		$.isWindow = function(obj) {
			/* jshint eqeqeq: false */
			return obj && obj === obj.window;
		};
	
		/* jQuery */
		$.type = function(obj) {
			if (!obj) {
				return obj + "";
			}
	
			return typeof obj === "object" || typeof obj === "function" ?
					class2type[toString.call(obj)] || "object" :
					typeof obj;
		};
	
		/* jQuery */
		$.isArray = Array.isArray || function(obj) {
			return $.type(obj) === "array";
		};
	
		/* jQuery */
		function isArraylike(obj) {
			var length = obj.length,
					type = $.type(obj);
	
			if (type === "function" || $.isWindow(obj)) {
				return false;
			}
	
			if (obj.nodeType === 1 && length) {
				return true;
			}
	
			return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
		}
	
		/***************
		 $ Methods
		 ***************/
	
		/* jQuery: Support removed for IE<9. */
		$.isPlainObject = function(obj) {
			var key;
	
			if (!obj || $.type(obj) !== "object" || obj.nodeType || $.isWindow(obj)) {
				return false;
			}
	
			try {
				if (obj.constructor &&
						!hasOwn.call(obj, "constructor") &&
						!hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
					return false;
				}
			} catch (e) {
				return false;
			}
	
			for (key in obj) {
			}
	
			return key === undefined || hasOwn.call(obj, key);
		};
	
		/* jQuery */
		$.each = function(obj, callback, args) {
			var value,
					i = 0,
					length = obj.length,
					isArray = isArraylike(obj);
	
			if (args) {
				if (isArray) {
					for (; i < length; i++) {
						value = callback.apply(obj[i], args);
	
						if (value === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (!obj.hasOwnProperty(i)) {
							continue;
						}
						value = callback.apply(obj[i], args);
	
						if (value === false) {
							break;
						}
					}
				}
	
			} else {
				if (isArray) {
					for (; i < length; i++) {
						value = callback.call(obj[i], i, obj[i]);
	
						if (value === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (!obj.hasOwnProperty(i)) {
							continue;
						}
						value = callback.call(obj[i], i, obj[i]);
	
						if (value === false) {
							break;
						}
					}
				}
			}
	
			return obj;
		};
	
		/* Custom */
		$.data = function(node, key, value) {
			/* $.getData() */
			if (value === undefined) {
				var getId = node[$.expando],
						store = getId && cache[getId];
	
				if (key === undefined) {
					return store;
				} else if (store) {
					if (key in store) {
						return store[key];
					}
				}
				/* $.setData() */
			} else if (key !== undefined) {
				var setId = node[$.expando] || (node[$.expando] = ++$.uuid);
	
				cache[setId] = cache[setId] || {};
				cache[setId][key] = value;
	
				return value;
			}
		};
	
		/* Custom */
		$.removeData = function(node, keys) {
			var id = node[$.expando],
					store = id && cache[id];
	
			if (store) {
				// Cleanup the entire store if no keys are provided.
				if (!keys) {
					delete cache[id];
				} else {
					$.each(keys, function(_, key) {
						delete store[key];
					});
				}
			}
		};
	
		/* jQuery */
		$.extend = function() {
			var src, copyIsArray, copy, name, options, clone,
					target = arguments[0] || {},
					i = 1,
					length = arguments.length,
					deep = false;
	
			if (typeof target === "boolean") {
				deep = target;
	
				target = arguments[i] || {};
				i++;
			}
	
			if (typeof target !== "object" && $.type(target) !== "function") {
				target = {};
			}
	
			if (i === length) {
				target = this;
				i--;
			}
	
			for (; i < length; i++) {
				if ((options = arguments[i])) {
					for (name in options) {
						if (!options.hasOwnProperty(name)) {
							continue;
						}
						src = target[name];
						copy = options[name];
	
						if (target === copy) {
							continue;
						}
	
						if (deep && copy && ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && $.isArray(src) ? src : [];
	
							} else {
								clone = src && $.isPlainObject(src) ? src : {};
							}
	
							target[name] = $.extend(deep, clone, copy);
	
						} else if (copy !== undefined) {
							target[name] = copy;
						}
					}
				}
			}
	
			return target;
		};
	
		/* jQuery 1.4.3 */
		$.queue = function(elem, type, data) {
			function $makeArray(arr, results) {
				var ret = results || [];
	
				if (arr) {
					if (isArraylike(Object(arr))) {
						/* $.merge */
						(function(first, second) {
							var len = +second.length,
									j = 0,
									i = first.length;
	
							while (j < len) {
								first[i++] = second[j++];
							}
	
							if (len !== len) {
								while (second[j] !== undefined) {
									first[i++] = second[j++];
								}
							}
	
							first.length = i;
	
							return first;
						})(ret, typeof arr === "string" ? [arr] : arr);
					} else {
						[].push.call(ret, arr);
					}
				}
	
				return ret;
			}
	
			if (!elem) {
				return;
			}
	
			type = (type || "fx") + "queue";
	
			var q = $.data(elem, type);
	
			if (!data) {
				return q || [];
			}
	
			if (!q || $.isArray(data)) {
				q = $.data(elem, type, $makeArray(data));
			} else {
				q.push(data);
			}
	
			return q;
		};
	
		/* jQuery 1.4.3 */
		$.dequeue = function(elems, type) {
			/* Custom: Embed element iteration. */
			$.each(elems.nodeType ? [elems] : elems, function(i, elem) {
				type = type || "fx";
	
				var queue = $.queue(elem, type),
						fn = queue.shift();
	
				if (fn === "inprogress") {
					fn = queue.shift();
				}
	
				if (fn) {
					if (type === "fx") {
						queue.unshift("inprogress");
					}
	
					fn.call(elem, function() {
						$.dequeue(elem, type);
					});
				}
			});
		};
	
		/******************
		 $.fn Methods
		 ******************/
	
		/* jQuery */
		$.fn = $.prototype = {
			init: function(selector) {
				/* Just return the element wrapped inside an array; don't proceed with the actual jQuery node wrapping process. */
				if (selector.nodeType) {
					this[0] = selector;
	
					return this;
				} else {
					throw new Error("Not a DOM node.");
				}
			},
			offset: function() {
				/* jQuery altered code: Dropped disconnected DOM node checking. */
				var box = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {top: 0, left: 0};
	
				return {
					top: box.top + (window.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
					left: box.left + (window.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
				};
			},
			position: function() {
				/* jQuery */
				function offsetParentFn(elem) {
					var offsetParent = elem.offsetParent || document;
	
					while (offsetParent && (offsetParent.nodeType.toLowerCase !== "html" && offsetParent.style.position === "static")) {
						offsetParent = offsetParent.offsetParent;
					}
	
					return offsetParent || document;
				}
	
				/* Zepto */
				var elem = this[0],
						offsetParent = offsetParentFn(elem),
						offset = this.offset(),
						parentOffset = /^(?:body|html)$/i.test(offsetParent.nodeName) ? {top: 0, left: 0} : $(offsetParent).offset();
	
				offset.top -= parseFloat(elem.style.marginTop) || 0;
				offset.left -= parseFloat(elem.style.marginLeft) || 0;
	
				if (offsetParent.style) {
					parentOffset.top += parseFloat(offsetParent.style.borderTopWidth) || 0;
					parentOffset.left += parseFloat(offsetParent.style.borderLeftWidth) || 0;
				}
	
				return {
					top: offset.top - parentOffset.top,
					left: offset.left - parentOffset.left
				};
			}
		};
	
		/**********************
		 Private Variables
		 **********************/
	
		/* For $.data() */
		var cache = {};
		$.expando = "velocity" + (new Date().getTime());
		$.uuid = 0;
	
		/* For $.queue() */
		var class2type = {},
				hasOwn = class2type.hasOwnProperty,
				toString = class2type.toString;
	
		var types = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
		for (var i = 0; i < types.length; i++) {
			class2type["[object " + types[i] + "]"] = types[i].toLowerCase();
		}
	
		/* Makes $(node) possible, without having to call init. */
		$.fn.init.prototype = $.fn;
	
		/* Globalize Velocity onto the window, and assign its Utilities property. */
		window.Velocity = {Utilities: $};
	})(window);
	
	/******************
	 Velocity.js
	 ******************/
	
	(function(factory) {
		"use strict";
		/* CommonJS module. */
		if (typeof module === "object" && typeof module.exports === "object") {
			module.exports = factory();
			/* AMD module. */
		} else if (typeof define === "function" && define.amd) {
			define(factory);
			/* Browser globals. */
		} else {
			factory();
		}
	}(function() {
		"use strict";
		return function(global, window, document, undefined) {
	
			/***************
			 Summary
			 ***************/
	
			/*
			 - CSS: CSS stack that works independently from the rest of Velocity.
			 - animate(): Core animation method that iterates over the targeted elements and queues the incoming call onto each element individually.
			 - Pre-Queueing: Prepare the element for animation by instantiating its data cache and processing the call's options.
			 - Queueing: The logic that runs once the call has reached its point of execution in the element's $.queue() stack.
			 Most logic is placed here to avoid risking it becoming stale (if the element's properties have changed).
			 - Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
			 - tick(): The single requestAnimationFrame loop responsible for tweening all in-progress calls.
			 - completeCall(): Handles the cleanup process for each Velocity call.
			 */
	
			/*********************
			 Helper Functions
			 *********************/
	
			/* IE detection. Gist: https://gist.github.com/julianshapiro/9098609 */
			var IE = (function() {
				if (document.documentMode) {
					return document.documentMode;
				} else {
					for (var i = 7; i > 4; i--) {
						var div = document.createElement("div");
	
						div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";
	
						if (div.getElementsByTagName("span").length) {
							div = null;
	
							return i;
						}
					}
				}
	
				return undefined;
			})();
	
			/* rAF shim. Gist: https://gist.github.com/julianshapiro/9497513 */
			var rAFShim = (function() {
				var timeLast = 0;
	
				return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
					var timeCurrent = (new Date()).getTime(),
							timeDelta;
	
					/* Dynamically set delay on a per-tick basis to match 60fps. */
					/* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
					timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
					timeLast = timeCurrent + timeDelta;
	
					return setTimeout(function() {
						callback(timeCurrent + timeDelta);
					}, timeDelta);
				};
			})();
	
			/* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
			function compactSparseArray(array) {
				var index = -1,
						length = array ? array.length : 0,
						result = [];
	
				while (++index < length) {
					var value = array[index];
	
					if (value) {
						result.push(value);
					}
				}
	
				return result;
			}
	
			function sanitizeElements(elements) {
				/* Unwrap jQuery/Zepto objects. */
				if (Type.isWrapped(elements)) {
					elements = [].slice.call(elements);
					/* Wrap a single element in an array so that $.each() can iterate with the element instead of its node's children. */
				} else if (Type.isNode(elements)) {
					elements = [elements];
				}
	
				return elements;
			}
	
			var Type = {
				isString: function(variable) {
					return (typeof variable === "string");
				},
				isArray: Array.isArray || function(variable) {
					return Object.prototype.toString.call(variable) === "[object Array]";
				},
				isFunction: function(variable) {
					return Object.prototype.toString.call(variable) === "[object Function]";
				},
				isNode: function(variable) {
					return variable && variable.nodeType;
				},
				/* Copyright Martin Bohm. MIT License: https://gist.github.com/Tomalak/818a78a226a0738eaade */
				isNodeList: function(variable) {
					return typeof variable === "object" &&
							/^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(variable)) &&
							variable.length !== undefined &&
							(variable.length === 0 || (typeof variable[0] === "object" && variable[0].nodeType > 0));
				},
				/* Determine if variable is a wrapped jQuery or Zepto element. */
				isWrapped: function(variable) {
					return variable && (variable.jquery || (window.Zepto && window.Zepto.zepto.isZ(variable)));
				},
				isSVG: function(variable) {
					return window.SVGElement && (variable instanceof window.SVGElement);
				},
				isEmptyObject: function(variable) {
					for (var name in variable) {
						if (variable.hasOwnProperty(name)) {
							return false;
						}
					}
	
					return true;
				}
			};
	
			/*****************
			 Dependencies
			 *****************/
	
			var $,
					isJQuery = false;
	
			if (global.fn && global.fn.jquery) {
				$ = global;
				isJQuery = true;
			} else {
				$ = window.Velocity.Utilities;
			}
	
			if (IE <= 8 && !isJQuery) {
				throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
			} else if (IE <= 7) {
				/* Revert to jQuery's $.animate(), and lose Velocity's extra features. */
				jQuery.fn.velocity = jQuery.fn.animate;
	
				/* Now that $.fn.velocity is aliased, abort this Velocity declaration. */
				return;
			}
	
			/*****************
			 Constants
			 *****************/
	
			var DURATION_DEFAULT = 400,
					EASING_DEFAULT = "swing";
	
			/*************
			 State
			 *************/
	
			var Velocity = {
				/* Container for page-wide Velocity state data. */
				State: {
					/* Detect mobile devices to determine if mobileHA should be turned on. */
					isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
					/* The mobileHA option's behavior changes on older Android devices (Gingerbread, versions 2.3.3-2.3.7). */
					isAndroid: /Android/i.test(navigator.userAgent),
					isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
					isChrome: window.chrome,
					isFirefox: /Firefox/i.test(navigator.userAgent),
					/* Create a cached element for re-use when checking for CSS property prefixes. */
					prefixElement: document.createElement("div"),
					/* Cache every prefix match to avoid repeating lookups. */
					prefixMatches: {},
					/* Cache the anchor used for animating window scrolling. */
					scrollAnchor: null,
					/* Cache the browser-specific property names associated with the scroll anchor. */
					scrollPropertyLeft: null,
					scrollPropertyTop: null,
					/* Keep track of whether our RAF tick is running. */
					isTicking: false,
					/* Container for every in-progress call to Velocity. */
					calls: []
				},
				/* Velocity's custom CSS stack. Made global for unit testing. */
				CSS: { /* Defined below. */},
				/* A shim of the jQuery utility functions used by Velocity -- provided by Velocity's optional jQuery shim. */
				Utilities: $,
				/* Container for the user's custom animation redirects that are referenced by name in place of the properties map argument. */
				Redirects: { /* Manually registered by the user. */},
				Easings: { /* Defined below. */},
				/* Attempt to use ES6 Promises by default. Users can override this with a third-party promises library. */
				Promise: window.Promise,
				/* Velocity option defaults, which can be overriden by the user. */
				defaults: {
					queue: "",
					duration: DURATION_DEFAULT,
					easing: EASING_DEFAULT,
					begin: undefined,
					complete: undefined,
					progress: undefined,
					display: undefined,
					visibility: undefined,
					loop: false,
					delay: false,
					mobileHA: true,
					/* Advanced: Set to false to prevent property values from being cached between consecutive Velocity-initiated chain calls. */
					_cacheValues: true
				},
				/* A design goal of Velocity is to cache data wherever possible in order to avoid DOM requerying. Accordingly, each element has a data cache. */
				init: function(element) {
					$.data(element, "velocity", {
						/* Store whether this is an SVG element, since its properties are retrieved and updated differently than standard HTML elements. */
						isSVG: Type.isSVG(element),
						/* Keep track of whether the element is currently being animated by Velocity.
						 This is used to ensure that property values are not transferred between non-consecutive (stale) calls. */
						isAnimating: false,
						/* A reference to the element's live computedStyle object. Learn more here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
						computedStyle: null,
						/* Tween data is cached for each animation on the element so that data can be passed across calls --
						 in particular, end values are used as subsequent start values in consecutive Velocity calls. */
						tweensContainer: null,
						/* The full root property values of each CSS hook being animated on this element are cached so that:
						 1) Concurrently-animating hooks sharing the same root can have their root values' merged into one while tweening.
						 2) Post-hook-injection root values can be transferred over to consecutively chained Velocity calls as starting root values. */
						rootPropertyValueCache: {},
						/* A cache for transform updates, which must be manually flushed via CSS.flushTransformCache(). */
						transformCache: {}
					});
				},
				/* A parallel to jQuery's $.css(), used for getting/setting Velocity's hooked CSS properties. */
				hook: null, /* Defined below. */
				/* Velocity-wide animation time remapping for testing purposes. */
				mock: false,
				version: {major: 1, minor: 3, patch: 1},
				/* Set to 1 or 2 (most verbose) to output debug info to console. */
				debug: false
			};
	
			/* Retrieve the appropriate scroll anchor and property name for the browser: https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY */
			if (window.pageYOffset !== undefined) {
				Velocity.State.scrollAnchor = window;
				Velocity.State.scrollPropertyLeft = "pageXOffset";
				Velocity.State.scrollPropertyTop = "pageYOffset";
			} else {
				Velocity.State.scrollAnchor = document.documentElement || document.body.parentNode || document.body;
				Velocity.State.scrollPropertyLeft = "scrollLeft";
				Velocity.State.scrollPropertyTop = "scrollTop";
			}
	
			/* Shorthand alias for jQuery's $.data() utility. */
			function Data(element) {
				/* Hardcode a reference to the plugin name. */
				var response = $.data(element, "velocity");
	
				/* jQuery <=1.4.2 returns null instead of undefined when no match is found. We normalize this behavior. */
				return response === null ? undefined : response;
			}
	
			/**************
			 Easing
			 **************/
	
			/* Step easing generator. */
			function generateStep(steps) {
				return function(p) {
					return Math.round(p * steps) * (1 / steps);
				};
			}
	
			/* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
			function generateBezier(mX1, mY1, mX2, mY2) {
				var NEWTON_ITERATIONS = 4,
						NEWTON_MIN_SLOPE = 0.001,
						SUBDIVISION_PRECISION = 0.0000001,
						SUBDIVISION_MAX_ITERATIONS = 10,
						kSplineTableSize = 11,
						kSampleStepSize = 1.0 / (kSplineTableSize - 1.0),
						float32ArraySupported = "Float32Array" in window;
	
				/* Must contain four arguments. */
				if (arguments.length !== 4) {
					return false;
				}
	
				/* Arguments must be numbers. */
				for (var i = 0; i < 4; ++i) {
					if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) {
						return false;
					}
				}
	
				/* X values must be in the [0, 1] range. */
				mX1 = Math.min(mX1, 1);
				mX2 = Math.min(mX2, 1);
				mX1 = Math.max(mX1, 0);
				mX2 = Math.max(mX2, 0);
	
				var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	
				function A(aA1, aA2) {
					return 1.0 - 3.0 * aA2 + 3.0 * aA1;
				}
				function B(aA1, aA2) {
					return 3.0 * aA2 - 6.0 * aA1;
				}
				function C(aA1) {
					return 3.0 * aA1;
				}
	
				function calcBezier(aT, aA1, aA2) {
					return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
				}
	
				function getSlope(aT, aA1, aA2) {
					return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
				}
	
				function newtonRaphsonIterate(aX, aGuessT) {
					for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
						var currentSlope = getSlope(aGuessT, mX1, mX2);
	
						if (currentSlope === 0.0) {
							return aGuessT;
						}
	
						var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
						aGuessT -= currentX / currentSlope;
					}
	
					return aGuessT;
				}
	
				function calcSampleValues() {
					for (var i = 0; i < kSplineTableSize; ++i) {
						mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
					}
				}
	
				function binarySubdivide(aX, aA, aB) {
					var currentX, currentT, i = 0;
	
					do {
						currentT = aA + (aB - aA) / 2.0;
						currentX = calcBezier(currentT, mX1, mX2) - aX;
						if (currentX > 0.0) {
							aB = currentT;
						} else {
							aA = currentT;
						}
					} while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	
					return currentT;
				}
	
				function getTForX(aX) {
					var intervalStart = 0.0,
							currentSample = 1,
							lastSample = kSplineTableSize - 1;
	
					for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
						intervalStart += kSampleStepSize;
					}
	
					--currentSample;
	
					var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]),
							guessForT = intervalStart + dist * kSampleStepSize,
							initialSlope = getSlope(guessForT, mX1, mX2);
	
					if (initialSlope >= NEWTON_MIN_SLOPE) {
						return newtonRaphsonIterate(aX, guessForT);
					} else if (initialSlope === 0.0) {
						return guessForT;
					} else {
						return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
					}
				}
	
				var _precomputed = false;
	
				function precompute() {
					_precomputed = true;
					if (mX1 !== mY1 || mX2 !== mY2) {
						calcSampleValues();
					}
				}
	
				var f = function(aX) {
					if (!_precomputed) {
						precompute();
					}
					if (mX1 === mY1 && mX2 === mY2) {
						return aX;
					}
					if (aX === 0) {
						return 0;
					}
					if (aX === 1) {
						return 1;
					}
	
					return calcBezier(getTForX(aX), mY1, mY2);
				};
	
				f.getControlPoints = function() {
					return [{x: mX1, y: mY1}, {x: mX2, y: mY2}];
				};
	
				var str = "generateBezier(" + [mX1, mY1, mX2, mY2] + ")";
				f.toString = function() {
					return str;
				};
	
				return f;
			}
	
			/* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
			/* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
			 then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
			var generateSpringRK4 = (function() {
				function springAccelerationForState(state) {
					return (-state.tension * state.x) - (state.friction * state.v);
				}
	
				function springEvaluateStateWithDerivative(initialState, dt, derivative) {
					var state = {
						x: initialState.x + derivative.dx * dt,
						v: initialState.v + derivative.dv * dt,
						tension: initialState.tension,
						friction: initialState.friction
					};
	
					return {dx: state.v, dv: springAccelerationForState(state)};
				}
	
				function springIntegrateState(state, dt) {
					var a = {
						dx: state.v,
						dv: springAccelerationForState(state)
					},
					b = springEvaluateStateWithDerivative(state, dt * 0.5, a),
							c = springEvaluateStateWithDerivative(state, dt * 0.5, b),
							d = springEvaluateStateWithDerivative(state, dt, c),
							dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx),
							dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
	
					state.x = state.x + dxdt * dt;
					state.v = state.v + dvdt * dt;
	
					return state;
				}
	
				return function springRK4Factory(tension, friction, duration) {
	
					var initState = {
						x: -1,
						v: 0,
						tension: null,
						friction: null
					},
					path = [0],
							time_lapsed = 0,
							tolerance = 1 / 10000,
							DT = 16 / 1000,
							have_duration, dt, last_state;
	
					tension = parseFloat(tension) || 500;
					friction = parseFloat(friction) || 20;
					duration = duration || null;
	
					initState.tension = tension;
					initState.friction = friction;
	
					have_duration = duration !== null;
	
					/* Calculate the actual time it takes for this animation to complete with the provided conditions. */
					if (have_duration) {
						/* Run the simulation without a duration. */
						time_lapsed = springRK4Factory(tension, friction);
						/* Compute the adjusted time delta. */
						dt = time_lapsed / duration * DT;
					} else {
						dt = DT;
					}
	
					while (true) {
						/* Next/step function .*/
						last_state = springIntegrateState(last_state || initState, dt);
						/* Store the position. */
						path.push(1 + last_state.x);
						time_lapsed += 16;
						/* If the change threshold is reached, break. */
						if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) {
							break;
						}
					}
	
					/* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
					 computed path and returns a snapshot of the position according to a given percentComplete. */
					return !have_duration ? time_lapsed : function(percentComplete) {
						return path[ (percentComplete * (path.length - 1)) | 0 ];
					};
				};
			}());
	
			/* jQuery easings. */
			Velocity.Easings = {
				linear: function(p) {
					return p;
				},
				swing: function(p) {
					return 0.5 - Math.cos(p * Math.PI) / 2;
				},
				/* Bonus "spring" easing, which is a less exaggerated version of easeInOutElastic. */
				spring: function(p) {
					return 1 - (Math.cos(p * 4.5 * Math.PI) * Math.exp(-p * 6));
				}
			};
	
			/* CSS3 and Robert Penner easings. */
			$.each(
					[
						["ease", [0.25, 0.1, 0.25, 1.0]],
						["ease-in", [0.42, 0.0, 1.00, 1.0]],
						["ease-out", [0.00, 0.0, 0.58, 1.0]],
						["ease-in-out", [0.42, 0.0, 0.58, 1.0]],
						["easeInSine", [0.47, 0, 0.745, 0.715]],
						["easeOutSine", [0.39, 0.575, 0.565, 1]],
						["easeInOutSine", [0.445, 0.05, 0.55, 0.95]],
						["easeInQuad", [0.55, 0.085, 0.68, 0.53]],
						["easeOutQuad", [0.25, 0.46, 0.45, 0.94]],
						["easeInOutQuad", [0.455, 0.03, 0.515, 0.955]],
						["easeInCubic", [0.55, 0.055, 0.675, 0.19]],
						["easeOutCubic", [0.215, 0.61, 0.355, 1]],
						["easeInOutCubic", [0.645, 0.045, 0.355, 1]],
						["easeInQuart", [0.895, 0.03, 0.685, 0.22]],
						["easeOutQuart", [0.165, 0.84, 0.44, 1]],
						["easeInOutQuart", [0.77, 0, 0.175, 1]],
						["easeInQuint", [0.755, 0.05, 0.855, 0.06]],
						["easeOutQuint", [0.23, 1, 0.32, 1]],
						["easeInOutQuint", [0.86, 0, 0.07, 1]],
						["easeInExpo", [0.95, 0.05, 0.795, 0.035]],
						["easeOutExpo", [0.19, 1, 0.22, 1]],
						["easeInOutExpo", [1, 0, 0, 1]],
						["easeInCirc", [0.6, 0.04, 0.98, 0.335]],
						["easeOutCirc", [0.075, 0.82, 0.165, 1]],
						["easeInOutCirc", [0.785, 0.135, 0.15, 0.86]]
					], function(i, easingArray) {
				Velocity.Easings[easingArray[0]] = generateBezier.apply(null, easingArray[1]);
			});
	
			/* Determine the appropriate easing type given an easing input. */
			function getEasing(value, duration) {
				var easing = value;
	
				/* The easing option can either be a string that references a pre-registered easing,
				 or it can be a two-/four-item array of integers to be converted into a bezier/spring function. */
				if (Type.isString(value)) {
					/* Ensure that the easing has been assigned to jQuery's Velocity.Easings object. */
					if (!Velocity.Easings[value]) {
						easing = false;
					}
				} else if (Type.isArray(value) && value.length === 1) {
					easing = generateStep.apply(null, value);
				} else if (Type.isArray(value) && value.length === 2) {
					/* springRK4 must be passed the animation's duration. */
					/* Note: If the springRK4 array contains non-numbers, generateSpringRK4() returns an easing
					 function generated with default tension and friction values. */
					easing = generateSpringRK4.apply(null, value.concat([duration]));
				} else if (Type.isArray(value) && value.length === 4) {
					/* Note: If the bezier array contains non-numbers, generateBezier() returns false. */
					easing = generateBezier.apply(null, value);
				} else {
					easing = false;
				}
	
				/* Revert to the Velocity-wide default easing type, or fall back to "swing" (which is also jQuery's default)
				 if the Velocity-wide default has been incorrectly modified. */
				if (easing === false) {
					if (Velocity.Easings[Velocity.defaults.easing]) {
						easing = Velocity.defaults.easing;
					} else {
						easing = EASING_DEFAULT;
					}
				}
	
				return easing;
			}
	
			/*****************
			 CSS Stack
			 *****************/
	
			/* The CSS object is a highly condensed and performant CSS stack that fully replaces jQuery's.
			 It handles the validation, getting, and setting of both standard CSS properties and CSS property hooks. */
			/* Note: A "CSS" shorthand is aliased so that our code is easier to read. */
			var CSS = Velocity.CSS = {
				/*************
				 RegEx
				 *************/
	
				RegEx: {
					isHex: /^#([A-f\d]{3}){1,2}$/i,
					/* Unwrap a property value's surrounding text, e.g. "rgba(4, 3, 2, 1)" ==> "4, 3, 2, 1" and "rect(4px 3px 2px 1px)" ==> "4px 3px 2px 1px". */
					valueUnwrap: /^[A-z]+\((.*)\)$/i,
					wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
					/* Split a multi-value property into an array of subvalues, e.g. "rgba(4, 3, 2, 1) 4px 3px 2px 1px" ==> [ "rgba(4, 3, 2, 1)", "4px", "3px", "2px", "1px" ]. */
					valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/ig
				},
				/************
				 Lists
				 ************/
	
				Lists: {
					colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
					transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
					transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"]
				},
				/************
				 Hooks
				 ************/
	
				/* Hooks allow a subproperty (e.g. "boxShadowBlur") of a compound-value CSS property
				 (e.g. "boxShadow: X Y Blur Spread Color") to be animated as if it were a discrete property. */
				/* Note: Beyond enabling fine-grained property animation, hooking is necessary since Velocity only
				 tweens properties with single numeric values; unlike CSS transitions, Velocity does not interpolate compound-values. */
				Hooks: {
					/********************
					 Registration
					 ********************/
	
					/* Templates are a concise way of indicating which subproperties must be individually registered for each compound-value CSS property. */
					/* Each template consists of the compound-value's base name, its constituent subproperty names, and those subproperties' default values. */
					templates: {
						"textShadow": ["Color X Y Blur", "black 0px 0px 0px"],
						"boxShadow": ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
						"clip": ["Top Right Bottom Left", "0px 0px 0px 0px"],
						"backgroundPosition": ["X Y", "0% 0%"],
						"transformOrigin": ["X Y Z", "50% 50% 0px"],
						"perspectiveOrigin": ["X Y", "50% 50%"]
					},
					/* A "registered" hook is one that has been converted from its template form into a live,
					 tweenable property. It contains data to associate it with its root property. */
					registered: {
						/* Note: A registered hook looks like this ==> textShadowBlur: [ "textShadow", 3 ],
						 which consists of the subproperty's name, the associated root property's name,
						 and the subproperty's position in the root's value. */
					},
					/* Convert the templates into individual hooks then append them to the registered object above. */
					register: function() {
						/* Color hooks registration: Colors are defaulted to white -- as opposed to black -- since colors that are
						 currently set to "transparent" default to their respective template below when color-animated,
						 and white is typically a closer match to transparent than black is. An exception is made for text ("color"),
						 which is almost always set closer to black than white. */
						for (var i = 0; i < CSS.Lists.colors.length; i++) {
							var rgbComponents = (CSS.Lists.colors[i] === "color") ? "0 0 0 1" : "255 255 255 1";
							CSS.Hooks.templates[CSS.Lists.colors[i]] = ["Red Green Blue Alpha", rgbComponents];
						}
	
						var rootProperty,
								hookTemplate,
								hookNames;
	
						/* In IE, color values inside compound-value properties are positioned at the end the value instead of at the beginning.
						 Thus, we re-arrange the templates accordingly. */
						if (IE) {
							for (rootProperty in CSS.Hooks.templates) {
								if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
									continue;
								}
								hookTemplate = CSS.Hooks.templates[rootProperty];
								hookNames = hookTemplate[0].split(" ");
	
								var defaultValues = hookTemplate[1].match(CSS.RegEx.valueSplit);
	
								if (hookNames[0] === "Color") {
									/* Reposition both the hook's name and its default value to the end of their respective strings. */
									hookNames.push(hookNames.shift());
									defaultValues.push(defaultValues.shift());
	
									/* Replace the existing template for the hook's root property. */
									CSS.Hooks.templates[rootProperty] = [hookNames.join(" "), defaultValues.join(" ")];
								}
							}
						}
	
						/* Hook registration. */
						for (rootProperty in CSS.Hooks.templates) {
							if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
								continue;
							}
							hookTemplate = CSS.Hooks.templates[rootProperty];
							hookNames = hookTemplate[0].split(" ");
	
							for (var j in hookNames) {
								if (!hookNames.hasOwnProperty(j)) {
									continue;
								}
								var fullHookName = rootProperty + hookNames[j],
										hookPosition = j;
	
								/* For each hook, register its full name (e.g. textShadowBlur) with its root property (e.g. textShadow)
								 and the hook's position in its template's default value string. */
								CSS.Hooks.registered[fullHookName] = [rootProperty, hookPosition];
							}
						}
					},
					/*****************************
					 Injection and Extraction
					 *****************************/
	
					/* Look up the root property associated with the hook (e.g. return "textShadow" for "textShadowBlur"). */
					/* Since a hook cannot be set directly (the browser won't recognize it), style updating for hooks is routed through the hook's root property. */
					getRoot: function(property) {
						var hookData = CSS.Hooks.registered[property];
	
						if (hookData) {
							return hookData[0];
						} else {
							/* If there was no hook match, return the property name untouched. */
							return property;
						}
					},
					/* Convert any rootPropertyValue, null or otherwise, into a space-delimited list of hook values so that
					 the targeted hook can be injected or extracted at its standard position. */
					cleanRootPropertyValue: function(rootProperty, rootPropertyValue) {
						/* If the rootPropertyValue is wrapped with "rgb()", "clip()", etc., remove the wrapping to normalize the value before manipulation. */
						if (CSS.RegEx.valueUnwrap.test(rootPropertyValue)) {
							rootPropertyValue = rootPropertyValue.match(CSS.RegEx.valueUnwrap)[1];
						}
	
						/* If rootPropertyValue is a CSS null-value (from which there's inherently no hook value to extract),
						 default to the root's default value as defined in CSS.Hooks.templates. */
						/* Note: CSS null-values include "none", "auto", and "transparent". They must be converted into their
						 zero-values (e.g. textShadow: "none" ==> textShadow: "0px 0px 0px black") for hook manipulation to proceed. */
						if (CSS.Values.isCSSNullValue(rootPropertyValue)) {
							rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
						}
	
						return rootPropertyValue;
					},
					/* Extracted the hook's value from its root property's value. This is used to get the starting value of an animating hook. */
					extractValue: function(fullHookName, rootPropertyValue) {
						var hookData = CSS.Hooks.registered[fullHookName];
	
						if (hookData) {
							var hookRoot = hookData[0],
									hookPosition = hookData[1];
	
							rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);
	
							/* Split rootPropertyValue into its constituent hook values then grab the desired hook at its standard position. */
							return rootPropertyValue.toString().match(CSS.RegEx.valueSplit)[hookPosition];
						} else {
							/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
							return rootPropertyValue;
						}
					},
					/* Inject the hook's value into its root property's value. This is used to piece back together the root property
					 once Velocity has updated one of its individually hooked values through tweening. */
					injectValue: function(fullHookName, hookValue, rootPropertyValue) {
						var hookData = CSS.Hooks.registered[fullHookName];
	
						if (hookData) {
							var hookRoot = hookData[0],
									hookPosition = hookData[1],
									rootPropertyValueParts,
									rootPropertyValueUpdated;
	
							rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);
	
							/* Split rootPropertyValue into its individual hook values, replace the targeted value with hookValue,
							 then reconstruct the rootPropertyValue string. */
							rootPropertyValueParts = rootPropertyValue.toString().match(CSS.RegEx.valueSplit);
							rootPropertyValueParts[hookPosition] = hookValue;
							rootPropertyValueUpdated = rootPropertyValueParts.join(" ");
	
							return rootPropertyValueUpdated;
						} else {
							/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
							return rootPropertyValue;
						}
					}
				},
				/*******************
				 Normalizations
				 *******************/
	
				/* Normalizations standardize CSS property manipulation by pollyfilling browser-specific implementations (e.g. opacity)
				 and reformatting special properties (e.g. clip, rgba) to look like standard ones. */
				Normalizations: {
					/* Normalizations are passed a normalization target (either the property's name, its extracted value, or its injected value),
					 the targeted element (which may need to be queried), and the targeted property value. */
					registered: {
						clip: function(type, element, propertyValue) {
							switch (type) {
								case "name":
									return "clip";
									/* Clip needs to be unwrapped and stripped of its commas during extraction. */
								case "extract":
									var extracted;
	
									/* If Velocity also extracted this value, skip extraction. */
									if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
										extracted = propertyValue;
									} else {
										/* Remove the "rect()" wrapper. */
										extracted = propertyValue.toString().match(CSS.RegEx.valueUnwrap);
	
										/* Strip off commas. */
										extracted = extracted ? extracted[1].replace(/,(\s+)?/g, " ") : propertyValue;
									}
	
									return extracted;
									/* Clip needs to be re-wrapped during injection. */
								case "inject":
									return "rect(" + propertyValue + ")";
							}
						},
						blur: function(type, element, propertyValue) {
							switch (type) {
								case "name":
									return Velocity.State.isFirefox ? "filter" : "-webkit-filter";
								case "extract":
									var extracted = parseFloat(propertyValue);
	
									/* If extracted is NaN, meaning the value isn't already extracted. */
									if (!(extracted || extracted === 0)) {
										var blurComponent = propertyValue.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
	
										/* If the filter string had a blur component, return just the blur value and unit type. */
										if (blurComponent) {
											extracted = blurComponent[1];
											/* If the component doesn't exist, default blur to 0. */
										} else {
											extracted = 0;
										}
									}
	
									return extracted;
									/* Blur needs to be re-wrapped during injection. */
								case "inject":
									/* For the blur effect to be fully de-applied, it needs to be set to "none" instead of 0. */
									if (!parseFloat(propertyValue)) {
										return "none";
									} else {
										return "blur(" + propertyValue + ")";
									}
							}
						},
						/* <=IE8 do not support the standard opacity property. They use filter:alpha(opacity=INT) instead. */
						opacity: function(type, element, propertyValue) {
							if (IE <= 8) {
								switch (type) {
									case "name":
										return "filter";
									case "extract":
										/* <=IE8 return a "filter" value of "alpha(opacity=\d{1,3})".
										 Extract the value and convert it to a decimal value to match the standard CSS opacity property's formatting. */
										var extracted = propertyValue.toString().match(/alpha\(opacity=(.*)\)/i);
	
										if (extracted) {
											/* Convert to decimal value. */
											propertyValue = extracted[1] / 100;
										} else {
											/* When extracting opacity, default to 1 since a null value means opacity hasn't been set. */
											propertyValue = 1;
										}
	
										return propertyValue;
									case "inject":
										/* Opacified elements are required to have their zoom property set to a non-zero value. */
										element.style.zoom = 1;
	
										/* Setting the filter property on elements with certain font property combinations can result in a
										 highly unappealing ultra-bolding effect. There's no way to remedy this throughout a tween, but dropping the
										 value altogether (when opacity hits 1) at leasts ensures that the glitch is gone post-tweening. */
										if (parseFloat(propertyValue) >= 1) {
											return "";
										} else {
											/* As per the filter property's spec, convert the decimal value to a whole number and wrap the value. */
											return "alpha(opacity=" + parseInt(parseFloat(propertyValue) * 100, 10) + ")";
										}
								}
								/* With all other browsers, normalization is not required; return the same values that were passed in. */
							} else {
								switch (type) {
									case "name":
										return "opacity";
									case "extract":
										return propertyValue;
									case "inject":
										return propertyValue;
								}
							}
						}
					},
					/*****************************
					 Batched Registrations
					 *****************************/
	
					/* Note: Batched normalizations extend the CSS.Normalizations.registered object. */
					register: function() {
	
						/*****************
						 Transforms
						 *****************/
	
						/* Transforms are the subproperties contained by the CSS "transform" property. Transforms must undergo normalization
						 so that they can be referenced in a properties map by their individual names. */
						/* Note: When transforms are "set", they are actually assigned to a per-element transformCache. When all transform
						 setting is complete complete, CSS.flushTransformCache() must be manually called to flush the values to the DOM.
						 Transform setting is batched in this way to improve performance: the transform style only needs to be updated
						 once when multiple transform subproperties are being animated simultaneously. */
						/* Note: IE9 and Android Gingerbread have support for 2D -- but not 3D -- transforms. Since animating unsupported
						 transform properties results in the browser ignoring the *entire* transform string, we prevent these 3D values
						 from being normalized for these browsers so that tweening skips these properties altogether
						 (since it will ignore them as being unsupported by the browser.) */
						if ((!IE || IE > 9) && !Velocity.State.isGingerbread) {
							/* Note: Since the standalone CSS "perspective" property and the CSS transform "perspective" subproperty
							 share the same name, the latter is given a unique token within Velocity: "transformPerspective". */
							CSS.Lists.transformsBase = CSS.Lists.transformsBase.concat(CSS.Lists.transforms3D);
						}
	
						for (var i = 0; i < CSS.Lists.transformsBase.length; i++) {
							/* Wrap the dynamically generated normalization function in a new scope so that transformName's value is
							 paired with its respective function. (Otherwise, all functions would take the final for loop's transformName.) */
							(function() {
								var transformName = CSS.Lists.transformsBase[i];
	
								CSS.Normalizations.registered[transformName] = function(type, element, propertyValue) {
									switch (type) {
										/* The normalized property name is the parent "transform" property -- the property that is actually set in CSS. */
										case "name":
											return "transform";
											/* Transform values are cached onto a per-element transformCache object. */
										case "extract":
											/* If this transform has yet to be assigned a value, return its null value. */
											if (Data(element) === undefined || Data(element).transformCache[transformName] === undefined) {
												/* Scale CSS.Lists.transformsBase default to 1 whereas all other transform properties default to 0. */
												return /^scale/i.test(transformName) ? 1 : 0;
												/* When transform values are set, they are wrapped in parentheses as per the CSS spec.
												 Thus, when extracting their values (for tween calculations), we strip off the parentheses. */
											}
											return Data(element).transformCache[transformName].replace(/[()]/g, "");
										case "inject":
											var invalid = false;
	
											/* If an individual transform property contains an unsupported unit type, the browser ignores the *entire* transform property.
											 Thus, protect users from themselves by skipping setting for transform values supplied with invalid unit types. */
											/* Switch on the base transform type; ignore the axis by removing the last letter from the transform's name. */
											switch (transformName.substr(0, transformName.length - 1)) {
												/* Whitelist unit types for each transform. */
												case "translate":
													invalid = !/(%|px|em|rem|vw|vh|\d)$/i.test(propertyValue);
													break;
													/* Since an axis-free "scale" property is supported as well, a little hack is used here to detect it by chopping off its last letter. */
												case "scal":
												case "scale":
													/* Chrome on Android has a bug in which scaled elements blur if their initial scale
													 value is below 1 (which can happen with forcefeeding). Thus, we detect a yet-unset scale property
													 and ensure that its first value is always 1. More info: http://stackoverflow.com/questions/10417890/css3-animations-with-transform-causes-blurred-elements-on-webkit/10417962#10417962 */
													if (Velocity.State.isAndroid && Data(element).transformCache[transformName] === undefined && propertyValue < 1) {
														propertyValue = 1;
													}
	
													invalid = !/(\d)$/i.test(propertyValue);
													break;
												case "skew":
													invalid = !/(deg|\d)$/i.test(propertyValue);
													break;
												case "rotate":
													invalid = !/(deg|\d)$/i.test(propertyValue);
													break;
											}
	
											if (!invalid) {
												/* As per the CSS spec, wrap the value in parentheses. */
												Data(element).transformCache[transformName] = "(" + propertyValue + ")";
											}
	
											/* Although the value is set on the transformCache object, return the newly-updated value for the calling code to process as normal. */
											return Data(element).transformCache[transformName];
									}
								};
							})();
						}
	
						/*************
						 Colors
						 *************/
	
						/* Since Velocity only animates a single numeric value per property, color animation is achieved by hooking the individual RGBA components of CSS color properties.
						 Accordingly, color values must be normalized (e.g. "#ff0000", "red", and "rgb(255, 0, 0)" ==> "255 0 0 1") so that their components can be injected/extracted by CSS.Hooks logic. */
						for (var j = 0; j < CSS.Lists.colors.length; j++) {
							/* Wrap the dynamically generated normalization function in a new scope so that colorName's value is paired with its respective function.
							 (Otherwise, all functions would take the final for loop's colorName.) */
							(function() {
								var colorName = CSS.Lists.colors[j];
	
								/* Note: In IE<=8, which support rgb but not rgba, color properties are reverted to rgb by stripping off the alpha component. */
								CSS.Normalizations.registered[colorName] = function(type, element, propertyValue) {
									switch (type) {
										case "name":
											return colorName;
											/* Convert all color values into the rgb format. (Old IE can return hex values and color names instead of rgb/rgba.) */
										case "extract":
											var extracted;
	
											/* If the color is already in its hookable form (e.g. "255 255 255 1") due to having been previously extracted, skip extraction. */
											if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
												extracted = propertyValue;
											} else {
												var converted,
														colorNames = {
															black: "rgb(0, 0, 0)",
															blue: "rgb(0, 0, 255)",
															gray: "rgb(128, 128, 128)",
															green: "rgb(0, 128, 0)",
															red: "rgb(255, 0, 0)",
															white: "rgb(255, 255, 255)"
														};
	
												/* Convert color names to rgb. */
												if (/^[A-z]+$/i.test(propertyValue)) {
													if (colorNames[propertyValue] !== undefined) {
														converted = colorNames[propertyValue];
													} else {
														/* If an unmatched color name is provided, default to black. */
														converted = colorNames.black;
													}
													/* Convert hex values to rgb. */
												} else if (CSS.RegEx.isHex.test(propertyValue)) {
													converted = "rgb(" + CSS.Values.hexToRgb(propertyValue).join(" ") + ")";
													/* If the provided color doesn't match any of the accepted color formats, default to black. */
												} else if (!(/^rgba?\(/i.test(propertyValue))) {
													converted = colorNames.black;
												}
	
												/* Remove the surrounding "rgb/rgba()" string then replace commas with spaces and strip
												 repeated spaces (in case the value included spaces to begin with). */
												extracted = (converted || propertyValue).toString().match(CSS.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
											}
	
											/* So long as this isn't <=IE8, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
											if ((!IE || IE > 8) && extracted.split(" ").length === 3) {
												extracted += " 1";
											}
	
											return extracted;
										case "inject":
											/* If this is IE<=8 and an alpha component exists, strip it off. */
											if (IE <= 8) {
												if (propertyValue.split(" ").length === 4) {
													propertyValue = propertyValue.split(/\s+/).slice(0, 3).join(" ");
												}
												/* Otherwise, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
											} else if (propertyValue.split(" ").length === 3) {
												propertyValue += " 1";
											}
	
											/* Re-insert the browser-appropriate wrapper("rgb/rgba()"), insert commas, and strip off decimal units
											 on all values but the fourth (R, G, and B only accept whole numbers). */
											return (IE <= 8 ? "rgb" : "rgba") + "(" + propertyValue.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
									}
								};
							})();
						}
					}
				},
				/************************
				 CSS Property Names
				 ************************/
	
				Names: {
					/* Camelcase a property name into its JavaScript notation (e.g. "background-color" ==> "backgroundColor").
					 Camelcasing is used to normalize property names between and across calls. */
					camelCase: function(property) {
						return property.replace(/-(\w)/g, function(match, subMatch) {
							return subMatch.toUpperCase();
						});
					},
					/* For SVG elements, some properties (namely, dimensional ones) are GET/SET via the element's HTML attributes (instead of via CSS styles). */
					SVGAttribute: function(property) {
						var SVGAttributes = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
	
						/* Certain browsers require an SVG transform to be applied as an attribute. (Otherwise, application via CSS is preferable due to 3D support.) */
						if (IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) {
							SVGAttributes += "|transform";
						}
	
						return new RegExp("^(" + SVGAttributes + ")$", "i").test(property);
					},
					/* Determine whether a property should be set with a vendor prefix. */
					/* If a prefixed version of the property exists, return it. Otherwise, return the original property name.
					 If the property is not at all supported by the browser, return a false flag. */
					prefixCheck: function(property) {
						/* If this property has already been checked, return the cached value. */
						if (Velocity.State.prefixMatches[property]) {
							return [Velocity.State.prefixMatches[property], true];
						} else {
							var vendors = ["", "Webkit", "Moz", "ms", "O"];
	
							for (var i = 0, vendorsLength = vendors.length; i < vendorsLength; i++) {
								var propertyPrefixed;
	
								if (i === 0) {
									propertyPrefixed = property;
								} else {
									/* Capitalize the first letter of the property to conform to JavaScript vendor prefix notation (e.g. webkitFilter). */
									propertyPrefixed = vendors[i] + property.replace(/^\w/, function(match) {
										return match.toUpperCase();
									});
								}
	
								/* Check if the browser supports this property as prefixed. */
								if (Type.isString(Velocity.State.prefixElement.style[propertyPrefixed])) {
									/* Cache the match. */
									Velocity.State.prefixMatches[property] = propertyPrefixed;
	
									return [propertyPrefixed, true];
								}
							}
	
							/* If the browser doesn't support this property in any form, include a false flag so that the caller can decide how to proceed. */
							return [property, false];
						}
					}
				},
				/************************
				 CSS Property Values
				 ************************/
	
				Values: {
					/* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
					hexToRgb: function(hex) {
						var shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
								longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
								rgbParts;
	
						hex = hex.replace(shortformRegex, function(m, r, g, b) {
							return r + r + g + g + b + b;
						});
	
						rgbParts = longformRegex.exec(hex);
	
						return rgbParts ? [parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16)] : [0, 0, 0];
					},
					isCSSNullValue: function(value) {
						/* The browser defaults CSS values that have not been set to either 0 or one of several possible null-value strings.
						 Thus, we check for both falsiness and these special strings. */
						/* Null-value checking is performed to default the special strings to 0 (for the sake of tweening) or their hook
						 templates as defined as CSS.Hooks (for the sake of hook injection/extraction). */
						/* Note: Chrome returns "rgba(0, 0, 0, 0)" for an undefined color whereas IE returns "transparent". */
						return (!value || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(value));
					},
					/* Retrieve a property's default unit type. Used for assigning a unit type when one is not supplied by the user. */
					getUnitType: function(property) {
						if (/^(rotate|skew)/i.test(property)) {
							return "deg";
						} else if (/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(property)) {
							/* The above properties are unitless. */
							return "";
						} else {
							/* Default to px for all other properties. */
							return "px";
						}
					},
					/* HTML elements default to an associated display type when they're not set to display:none. */
					/* Note: This function is used for correctly setting the non-"none" display value in certain Velocity redirects, such as fadeIn/Out. */
					getDisplayType: function(element) {
						var tagName = element && element.tagName.toString().toLowerCase();
	
						if (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(tagName)) {
							return "inline";
						} else if (/^(li)$/i.test(tagName)) {
							return "list-item";
						} else if (/^(tr)$/i.test(tagName)) {
							return "table-row";
						} else if (/^(table)$/i.test(tagName)) {
							return "table";
						} else if (/^(tbody)$/i.test(tagName)) {
							return "table-row-group";
							/* Default to "block" when no match is found. */
						} else {
							return "block";
						}
					},
					/* The class add/remove functions are used to temporarily apply a "velocity-animating" class to elements while they're animating. */
					addClass: function(element, className) {
						if (element.classList) {
							element.classList.add(className);
						} else {
							element.className += (element.className.length ? " " : "") + className;
						}
					},
					removeClass: function(element, className) {
						if (element.classList) {
							element.classList.remove(className);
						} else {
							element.className = element.className.toString().replace(new RegExp("(^|\\s)" + className.split(" ").join("|") + "(\\s|$)", "gi"), " ");
						}
					}
				},
				/****************************
				 Style Getting & Setting
				 ****************************/
	
				/* The singular getPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
				getPropertyValue: function(element, property, rootPropertyValue, forceStyleLookup) {
					/* Get an element's computed property value. */
					/* Note: Retrieving the value of a CSS property cannot simply be performed by checking an element's
					 style attribute (which only reflects user-defined values). Instead, the browser must be queried for a property's
					 *computed* value. You can read more about getComputedStyle here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
					function computePropertyValue(element, property) {
						/* When box-sizing isn't set to border-box, height and width style values are incorrectly computed when an
						 element's scrollbars are visible (which expands the element's dimensions). Thus, we defer to the more accurate
						 offsetHeight/Width property, which includes the total dimensions for interior, border, padding, and scrollbar.
						 We subtract border and padding to get the sum of interior + scrollbar. */
						var computedValue = 0;
	
						/* IE<=8 doesn't support window.getComputedStyle, thus we defer to jQuery, which has an extensive array
						 of hacks to accurately retrieve IE8 property values. Re-implementing that logic here is not worth bloating the
						 codebase for a dying browser. The performance repercussions of using jQuery here are minimal since
						 Velocity is optimized to rarely (and sometimes never) query the DOM. Further, the $.css() codepath isn't that slow. */
						if (IE <= 8) {
							computedValue = $.css(element, property); /* GET */
							/* All other browsers support getComputedStyle. The returned live object reference is cached onto its
							 associated element so that it does not need to be refetched upon every GET. */
						} else {
							/* Browsers do not return height and width values for elements that are set to display:"none". Thus, we temporarily
							 toggle display to the element type's default value. */
							var toggleDisplay = false;
	
							if (/^(width|height)$/.test(property) && CSS.getPropertyValue(element, "display") === 0) {
								toggleDisplay = true;
								CSS.setPropertyValue(element, "display", CSS.Values.getDisplayType(element));
							}
	
							var revertDisplay = function() {
								if (toggleDisplay) {
									CSS.setPropertyValue(element, "display", "none");
								}
							};
	
							if (!forceStyleLookup) {
								if (property === "height" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
									var contentBoxHeight = element.offsetHeight - (parseFloat(CSS.getPropertyValue(element, "borderTopWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderBottomWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingTop")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingBottom")) || 0);
									revertDisplay();
	
									return contentBoxHeight;
								} else if (property === "width" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
									var contentBoxWidth = element.offsetWidth - (parseFloat(CSS.getPropertyValue(element, "borderLeftWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderRightWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingLeft")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingRight")) || 0);
									revertDisplay();
	
									return contentBoxWidth;
								}
							}
	
							var computedStyle;
	
							/* For elements that Velocity hasn't been called on directly (e.g. when Velocity queries the DOM on behalf
							 of a parent of an element its animating), perform a direct getComputedStyle lookup since the object isn't cached. */
							if (Data(element) === undefined) {
								computedStyle = window.getComputedStyle(element, null); /* GET */
								/* If the computedStyle object has yet to be cached, do so now. */
							} else if (!Data(element).computedStyle) {
								computedStyle = Data(element).computedStyle = window.getComputedStyle(element, null); /* GET */
								/* If computedStyle is cached, use it. */
							} else {
								computedStyle = Data(element).computedStyle;
							}
	
							/* IE and Firefox do not return a value for the generic borderColor -- they only return individual values for each border side's color.
							 Also, in all browsers, when border colors aren't all the same, a compound value is returned that Velocity isn't setup to parse.
							 So, as a polyfill for querying individual border side colors, we just return the top border's color and animate all borders from that value. */
							if (property === "borderColor") {
								property = "borderTopColor";
							}
	
							/* IE9 has a bug in which the "filter" property must be accessed from computedStyle using the getPropertyValue method
							 instead of a direct property lookup. The getPropertyValue method is slower than a direct lookup, which is why we avoid it by default. */
							if (IE === 9 && property === "filter") {
								computedValue = computedStyle.getPropertyValue(property); /* GET */
							} else {
								computedValue = computedStyle[property];
							}
	
							/* Fall back to the property's style value (if defined) when computedValue returns nothing,
							 which can happen when the element hasn't been painted. */
							if (computedValue === "" || computedValue === null) {
								computedValue = element.style[property];
							}
	
							revertDisplay();
						}
	
						/* For top, right, bottom, and left (TRBL) values that are set to "auto" on elements of "fixed" or "absolute" position,
						 defer to jQuery for converting "auto" to a numeric value. (For elements with a "static" or "relative" position, "auto" has the same
						 effect as being set to 0, so no conversion is necessary.) */
						/* An example of why numeric conversion is necessary: When an element with "position:absolute" has an untouched "left"
						 property, which reverts to "auto", left's value is 0 relative to its parent element, but is often non-zero relative
						 to its *containing* (not parent) element, which is the nearest "position:relative" ancestor or the viewport (and always the viewport in the case of "position:fixed"). */
						if (computedValue === "auto" && /^(top|right|bottom|left)$/i.test(property)) {
							var position = computePropertyValue(element, "position"); /* GET */
	
							/* For absolute positioning, jQuery's $.position() only returns values for top and left;
							 right and bottom will have their "auto" value reverted to 0. */
							/* Note: A jQuery object must be created here since jQuery doesn't have a low-level alias for $.position().
							 Not a big deal since we're currently in a GET batch anyway. */
							if (position === "fixed" || (position === "absolute" && /top|left/i.test(property))) {
								/* Note: jQuery strips the pixel unit from its returned values; we re-add it here to conform with computePropertyValue's behavior. */
								computedValue = $(element).position()[property] + "px"; /* GET */
							}
						}
	
						return computedValue;
					}
	
					var propertyValue;
	
					/* If this is a hooked property (e.g. "clipLeft" instead of the root property of "clip"),
					 extract the hook's value from a normalized rootPropertyValue using CSS.Hooks.extractValue(). */
					if (CSS.Hooks.registered[property]) {
						var hook = property,
								hookRoot = CSS.Hooks.getRoot(hook);
	
						/* If a cached rootPropertyValue wasn't passed in (which Velocity always attempts to do in order to avoid requerying the DOM),
						 query the DOM for the root property's value. */
						if (rootPropertyValue === undefined) {
							/* Since the browser is now being directly queried, use the official post-prefixing property name for this lookup. */
							rootPropertyValue = CSS.getPropertyValue(element, CSS.Names.prefixCheck(hookRoot)[0]); /* GET */
						}
	
						/* If this root has a normalization registered, peform the associated normalization extraction. */
						if (CSS.Normalizations.registered[hookRoot]) {
							rootPropertyValue = CSS.Normalizations.registered[hookRoot]("extract", element, rootPropertyValue);
						}
	
						/* Extract the hook's value. */
						propertyValue = CSS.Hooks.extractValue(hook, rootPropertyValue);
	
						/* If this is a normalized property (e.g. "opacity" becomes "filter" in <=IE8) or "translateX" becomes "transform"),
						 normalize the property's name and value, and handle the special case of transforms. */
						/* Note: Normalizing a property is mutually exclusive from hooking a property since hook-extracted values are strictly
						 numerical and therefore do not require normalization extraction. */
					} else if (CSS.Normalizations.registered[property]) {
						var normalizedPropertyName,
								normalizedPropertyValue;
	
						normalizedPropertyName = CSS.Normalizations.registered[property]("name", element);
	
						/* Transform values are calculated via normalization extraction (see below), which checks against the element's transformCache.
						 At no point do transform GETs ever actually query the DOM; initial stylesheet values are never processed.
						 This is because parsing 3D transform matrices is not always accurate and would bloat our codebase;
						 thus, normalization extraction defaults initial transform values to their zero-values (e.g. 1 for scaleX and 0 for translateX). */
						if (normalizedPropertyName !== "transform") {
							normalizedPropertyValue = computePropertyValue(element, CSS.Names.prefixCheck(normalizedPropertyName)[0]); /* GET */
	
							/* If the value is a CSS null-value and this property has a hook template, use that zero-value template so that hooks can be extracted from it. */
							if (CSS.Values.isCSSNullValue(normalizedPropertyValue) && CSS.Hooks.templates[property]) {
								normalizedPropertyValue = CSS.Hooks.templates[property][1];
							}
						}
	
						propertyValue = CSS.Normalizations.registered[property]("extract", element, normalizedPropertyValue);
					}
	
					/* If a (numeric) value wasn't produced via hook extraction or normalization, query the DOM. */
					if (!/^[\d-]/.test(propertyValue)) {
						/* For SVG elements, dimensional properties (which SVGAttribute() detects) are tweened via
						 their HTML attribute values instead of their CSS style values. */
						var data = Data(element);
	
						if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
							/* Since the height/width attribute values must be set manually, they don't reflect computed values.
							 Thus, we use use getBBox() to ensure we always get values for elements with undefined height/width attributes. */
							if (/^(height|width)$/i.test(property)) {
								/* Firefox throws an error if .getBBox() is called on an SVG that isn't attached to the DOM. */
								try {
									propertyValue = element.getBBox()[property];
								} catch (error) {
									propertyValue = 0;
								}
								/* Otherwise, access the attribute value directly. */
							} else {
								propertyValue = element.getAttribute(property);
							}
						} else {
							propertyValue = computePropertyValue(element, CSS.Names.prefixCheck(property)[0]); /* GET */
						}
					}
	
					/* Since property lookups are for animation purposes (which entails computing the numeric delta between start and end values),
					 convert CSS null-values to an integer of value 0. */
					if (CSS.Values.isCSSNullValue(propertyValue)) {
						propertyValue = 0;
					}
	
					if (Velocity.debug >= 2) {
						console.log("Get " + property + ": " + propertyValue);
					}
	
					return propertyValue;
				},
				/* The singular setPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
				setPropertyValue: function(element, property, propertyValue, rootPropertyValue, scrollData) {
					var propertyName = property;
	
					/* In order to be subjected to call options and element queueing, scroll animation is routed through Velocity as if it were a standard CSS property. */
					if (property === "scroll") {
						/* If a container option is present, scroll the container instead of the browser window. */
						if (scrollData.container) {
							scrollData.container["scroll" + scrollData.direction] = propertyValue;
							/* Otherwise, Velocity defaults to scrolling the browser window. */
						} else {
							if (scrollData.direction === "Left") {
								window.scrollTo(propertyValue, scrollData.alternateValue);
							} else {
								window.scrollTo(scrollData.alternateValue, propertyValue);
							}
						}
					} else {
						/* Transforms (translateX, rotateZ, etc.) are applied to a per-element transformCache object, which is manually flushed via flushTransformCache().
						 Thus, for now, we merely cache transforms being SET. */
						if (CSS.Normalizations.registered[property] && CSS.Normalizations.registered[property]("name", element) === "transform") {
							/* Perform a normalization injection. */
							/* Note: The normalization logic handles the transformCache updating. */
							CSS.Normalizations.registered[property]("inject", element, propertyValue);
	
							propertyName = "transform";
							propertyValue = Data(element).transformCache[property];
						} else {
							/* Inject hooks. */
							if (CSS.Hooks.registered[property]) {
								var hookName = property,
										hookRoot = CSS.Hooks.getRoot(property);
	
								/* If a cached rootPropertyValue was not provided, query the DOM for the hookRoot's current value. */
								rootPropertyValue = rootPropertyValue || CSS.getPropertyValue(element, hookRoot); /* GET */
	
								propertyValue = CSS.Hooks.injectValue(hookName, propertyValue, rootPropertyValue);
								property = hookRoot;
							}
	
							/* Normalize names and values. */
							if (CSS.Normalizations.registered[property]) {
								propertyValue = CSS.Normalizations.registered[property]("inject", element, propertyValue);
								property = CSS.Normalizations.registered[property]("name", element);
							}
	
							/* Assign the appropriate vendor prefix before performing an official style update. */
							propertyName = CSS.Names.prefixCheck(property)[0];
	
							/* A try/catch is used for IE<=8, which throws an error when "invalid" CSS values are set, e.g. a negative width.
							 Try/catch is avoided for other browsers since it incurs a performance overhead. */
							if (IE <= 8) {
								try {
									element.style[propertyName] = propertyValue;
								} catch (error) {
									if (Velocity.debug) {
										console.log("Browser does not support [" + propertyValue + "] for [" + propertyName + "]");
									}
								}
								/* SVG elements have their dimensional properties (width, height, x, y, cx, etc.) applied directly as attributes instead of as styles. */
								/* Note: IE8 does not support SVG elements, so it's okay that we skip it for SVG animation. */
							} else {
								var data = Data(element);
	
								if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
									/* Note: For SVG attributes, vendor-prefixed property names are never used. */
									/* Note: Not all CSS properties can be animated via attributes, but the browser won't throw an error for unsupported properties. */
									element.setAttribute(property, propertyValue);
								} else {
									element.style[propertyName] = propertyValue;
								}
							}
	
							if (Velocity.debug >= 2) {
								console.log("Set " + property + " (" + propertyName + "): " + propertyValue);
							}
						}
					}
	
					/* Return the normalized property name and value in case the caller wants to know how these values were modified before being applied to the DOM. */
					return [propertyName, propertyValue];
				},
				/* To increase performance by batching transform updates into a single SET, transforms are not directly applied to an element until flushTransformCache() is called. */
				/* Note: Velocity applies transform properties in the same order that they are chronogically introduced to the element's CSS styles. */
				flushTransformCache: function(element) {
					var transformString = "",
							data = Data(element);
	
					/* Certain browsers require that SVG transforms be applied as an attribute. However, the SVG transform attribute takes a modified version of CSS's transform string
					 (units are dropped and, except for skewX/Y, subproperties are merged into their master property -- e.g. scaleX and scaleY are merged into scale(X Y). */
					if ((IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) && data && data.isSVG) {
						/* Since transform values are stored in their parentheses-wrapped form, we use a helper function to strip out their numeric values.
						 Further, SVG transform properties only take unitless (representing pixels) values, so it's okay that parseFloat() strips the unit suffixed to the float value. */
						var getTransformFloat = function(transformProperty) {
							return parseFloat(CSS.getPropertyValue(element, transformProperty));
						};
	
						/* Create an object to organize all the transforms that we'll apply to the SVG element. To keep the logic simple,
						 we process *all* transform properties -- even those that may not be explicitly applied (since they default to their zero-values anyway). */
						var SVGTransforms = {
							translate: [getTransformFloat("translateX"), getTransformFloat("translateY")],
							skewX: [getTransformFloat("skewX")], skewY: [getTransformFloat("skewY")],
							/* If the scale property is set (non-1), use that value for the scaleX and scaleY values
							 (this behavior mimics the result of animating all these properties at once on HTML elements). */
							scale: getTransformFloat("scale") !== 1 ? [getTransformFloat("scale"), getTransformFloat("scale")] : [getTransformFloat("scaleX"), getTransformFloat("scaleY")],
							/* Note: SVG's rotate transform takes three values: rotation degrees followed by the X and Y values
							 defining the rotation's origin point. We ignore the origin values (default them to 0). */
							rotate: [getTransformFloat("rotateZ"), 0, 0]
						};
	
						/* Iterate through the transform properties in the user-defined property map order.
						 (This mimics the behavior of non-SVG transform animation.) */
						$.each(Data(element).transformCache, function(transformName) {
							/* Except for with skewX/Y, revert the axis-specific transform subproperties to their axis-free master
							 properties so that they match up with SVG's accepted transform properties. */
							if (/^translate/i.test(transformName)) {
								transformName = "translate";
							} else if (/^scale/i.test(transformName)) {
								transformName = "scale";
							} else if (/^rotate/i.test(transformName)) {
								transformName = "rotate";
							}
	
							/* Check that we haven't yet deleted the property from the SVGTransforms container. */
							if (SVGTransforms[transformName]) {
								/* Append the transform property in the SVG-supported transform format. As per the spec, surround the space-delimited values in parentheses. */
								transformString += transformName + "(" + SVGTransforms[transformName].join(" ") + ")" + " ";
	
								/* After processing an SVG transform property, delete it from the SVGTransforms container so we don't
								 re-insert the same master property if we encounter another one of its axis-specific properties. */
								delete SVGTransforms[transformName];
							}
						});
					} else {
						var transformValue,
								perspective;
	
						/* Transform properties are stored as members of the transformCache object. Concatenate all the members into a string. */
						$.each(Data(element).transformCache, function(transformName) {
							transformValue = Data(element).transformCache[transformName];
	
							/* Transform's perspective subproperty must be set first in order to take effect. Store it temporarily. */
							if (transformName === "transformPerspective") {
								perspective = transformValue;
								return true;
							}
	
							/* IE9 only supports one rotation type, rotateZ, which it refers to as "rotate". */
							if (IE === 9 && transformName === "rotateZ") {
								transformName = "rotate";
							}
	
							transformString += transformName + transformValue + " ";
						});
	
						/* If present, set the perspective subproperty first. */
						if (perspective) {
							transformString = "perspective" + perspective + " " + transformString;
						}
					}
	
					CSS.setPropertyValue(element, "transform", transformString);
				}
			};
	
			/* Register hooks and normalizations. */
			CSS.Hooks.register();
			CSS.Normalizations.register();
	
			/* Allow hook setting in the same fashion as jQuery's $.css(). */
			Velocity.hook = function(elements, arg2, arg3) {
				var value;
	
				elements = sanitizeElements(elements);
	
				$.each(elements, function(i, element) {
					/* Initialize Velocity's per-element data cache if this element hasn't previously been animated. */
					if (Data(element) === undefined) {
						Velocity.init(element);
					}
	
					/* Get property value. If an element set was passed in, only return the value for the first element. */
					if (arg3 === undefined) {
						if (value === undefined) {
							value = Velocity.CSS.getPropertyValue(element, arg2);
						}
						/* Set property value. */
					} else {
						/* sPV returns an array of the normalized propertyName/propertyValue pair used to update the DOM. */
						var adjustedSet = Velocity.CSS.setPropertyValue(element, arg2, arg3);
	
						/* Transform properties don't automatically set. They have to be flushed to the DOM. */
						if (adjustedSet[0] === "transform") {
							Velocity.CSS.flushTransformCache(element);
						}
	
						value = adjustedSet;
					}
				});
	
				return value;
			};
	
			/*****************
			 Animation
			 *****************/
	
			var animate = function() {
				var opts;
	
				/******************
				 Call Chain
				 ******************/
	
				/* Logic for determining what to return to the call stack when exiting out of Velocity. */
				function getChain() {
					/* If we are using the utility function, attempt to return this call's promise. If no promise library was detected,
					 default to null instead of returning the targeted elements so that utility function's return value is standardized. */
					if (isUtility) {
						return promiseData.promise || null;
						/* Otherwise, if we're using $.fn, return the jQuery-/Zepto-wrapped element set. */
					} else {
						return elementsWrapped;
					}
				}
	
				/*************************
				 Arguments Assignment
				 *************************/
	
				/* To allow for expressive CoffeeScript code, Velocity supports an alternative syntax in which "elements" (or "e"), "properties" (or "p"), and "options" (or "o")
				 objects are defined on a container object that's passed in as Velocity's sole argument. */
				/* Note: Some browsers automatically populate arguments with a "properties" object. We detect it by checking for its default "names" property. */
				var syntacticSugar = (arguments[0] && (arguments[0].p || (($.isPlainObject(arguments[0].properties) && !arguments[0].properties.names) || Type.isString(arguments[0].properties)))),
						/* Whether Velocity was called via the utility function (as opposed to on a jQuery/Zepto object). */
						isUtility,
						/* When Velocity is called via the utility function ($.Velocity()/Velocity()), elements are explicitly
						 passed in as the first parameter. Thus, argument positioning varies. We normalize them here. */
						elementsWrapped,
						argumentIndex;
	
				var elements,
						propertiesMap,
						options;
	
				/* Detect jQuery/Zepto elements being animated via the $.fn method. */
				if (Type.isWrapped(this)) {
					isUtility = false;
	
					argumentIndex = 0;
					elements = this;
					elementsWrapped = this;
					/* Otherwise, raw elements are being animated via the utility function. */
				} else {
					isUtility = true;
	
					argumentIndex = 1;
					elements = syntacticSugar ? (arguments[0].elements || arguments[0].e) : arguments[0];
				}
	
				elements = sanitizeElements(elements);
	
				if (!elements) {
					return;
				}
	
				if (syntacticSugar) {
					propertiesMap = arguments[0].properties || arguments[0].p;
					options = arguments[0].options || arguments[0].o;
				} else {
					propertiesMap = arguments[argumentIndex];
					options = arguments[argumentIndex + 1];
				}
	
				/* The length of the element set (in the form of a nodeList or an array of elements) is defaulted to 1 in case a
				 single raw DOM element is passed in (which doesn't contain a length property). */
				var elementsLength = elements.length,
						elementsIndex = 0;
	
				/***************************
				 Argument Overloading
				 ***************************/
	
				/* Support is included for jQuery's argument overloading: $.animate(propertyMap [, duration] [, easing] [, complete]).
				 Overloading is detected by checking for the absence of an object being passed into options. */
				/* Note: The stop and finish actions do not accept animation options, and are therefore excluded from this check. */
				if (!/^(stop|finish|finishAll)$/i.test(propertiesMap) && !$.isPlainObject(options)) {
					/* The utility function shifts all arguments one position to the right, so we adjust for that offset. */
					var startingArgumentPosition = argumentIndex + 1;
	
					options = {};
	
					/* Iterate through all options arguments */
					for (var i = startingArgumentPosition; i < arguments.length; i++) {
						/* Treat a number as a duration. Parse it out. */
						/* Note: The following RegEx will return true if passed an array with a number as its first item.
						 Thus, arrays are skipped from this check. */
						if (!Type.isArray(arguments[i]) && (/^(fast|normal|slow)$/i.test(arguments[i]) || /^\d/.test(arguments[i]))) {
							options.duration = arguments[i];
							/* Treat strings and arrays as easings. */
						} else if (Type.isString(arguments[i]) || Type.isArray(arguments[i])) {
							options.easing = arguments[i];
							/* Treat a function as a complete callback. */
						} else if (Type.isFunction(arguments[i])) {
							options.complete = arguments[i];
						}
					}
				}
	
				/***************
				 Promises
				 ***************/
	
				var promiseData = {
					promise: null,
					resolver: null,
					rejecter: null
				};
	
				/* If this call was made via the utility function (which is the default method of invocation when jQuery/Zepto are not being used), and if
				 promise support was detected, create a promise object for this call and store references to its resolver and rejecter methods. The resolve
				 method is used when a call completes naturally or is prematurely stopped by the user. In both cases, completeCall() handles the associated
				 call cleanup and promise resolving logic. The reject method is used when an invalid set of arguments is passed into a Velocity call. */
				/* Note: Velocity employs a call-based queueing architecture, which means that stopping an animating element actually stops the full call that
				 triggered it -- not that one element exclusively. Similarly, there is one promise per call, and all elements targeted by a Velocity call are
				 grouped together for the purposes of resolving and rejecting a promise. */
				if (isUtility && Velocity.Promise) {
					promiseData.promise = new Velocity.Promise(function(resolve, reject) {
						promiseData.resolver = resolve;
						promiseData.rejecter = reject;
					});
				}
	
				/*********************
				 Action Detection
				 *********************/
	
				/* Velocity's behavior is categorized into "actions": Elements can either be specially scrolled into view,
				 or they can be started, stopped, or reversed. If a literal or referenced properties map is passed in as Velocity's
				 first argument, the associated action is "start". Alternatively, "scroll", "reverse", or "stop" can be passed in instead of a properties map. */
				var action;
	
				switch (propertiesMap) {
					case "scroll":
						action = "scroll";
						break;
	
					case "reverse":
						action = "reverse";
						break;
	
					case "finish":
					case "finishAll":
					case "stop":
						/*******************
						 Action: Stop
						 *******************/
	
						/* Clear the currently-active delay on each targeted element. */
						$.each(elements, function(i, element) {
							if (Data(element) && Data(element).delayTimer) {
								/* Stop the timer from triggering its cached next() function. */
								clearTimeout(Data(element).delayTimer.setTimeout);
	
								/* Manually call the next() function so that the subsequent queue items can progress. */
								if (Data(element).delayTimer.next) {
									Data(element).delayTimer.next();
								}
	
								delete Data(element).delayTimer;
							}
	
							/* If we want to finish everything in the queue, we have to iterate through it
							 and call each function. This will make them active calls below, which will
							 cause them to be applied via the duration setting. */
							if (propertiesMap === "finishAll" && (options === true || Type.isString(options))) {
								/* Iterate through the items in the element's queue. */
								$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
									/* The queue array can contain an "inprogress" string, which we skip. */
									if (Type.isFunction(item)) {
										item();
									}
								});
	
								/* Clearing the $.queue() array is achieved by resetting it to []. */
								$.queue(element, Type.isString(options) ? options : "", []);
							}
						});
	
						var callsToStop = [];
	
						/* When the stop action is triggered, the elements' currently active call is immediately stopped. The active call might have
						 been applied to multiple elements, in which case all of the call's elements will be stopped. When an element
						 is stopped, the next item in its animation queue is immediately triggered. */
						/* An additional argument may be passed in to clear an element's remaining queued calls. Either true (which defaults to the "fx" queue)
						 or a custom queue string can be passed in. */
						/* Note: The stop command runs prior to Velocity's Queueing phase since its behavior is intended to take effect *immediately*,
						 regardless of the element's current queue state. */
	
						/* Iterate through every active call. */
						$.each(Velocity.State.calls, function(i, activeCall) {
							/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
							if (activeCall) {
								/* Iterate through the active call's targeted elements. */
								$.each(activeCall[1], function(k, activeElement) {
									/* If true was passed in as a secondary argument, clear absolutely all calls on this element. Otherwise, only
									 clear calls associated with the relevant queue. */
									/* Call stopping logic works as follows:
									 - options === true --> stop current default queue calls (and queue:false calls), including remaining queued ones.
									 - options === undefined --> stop current queue:"" call and all queue:false calls.
									 - options === false --> stop only queue:false calls.
									 - options === "custom" --> stop current queue:"custom" call, including remaining queued ones (there is no functionality to only clear the currently-running queue:"custom" call). */
									var queueName = (options === undefined) ? "" : options;
	
									if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
										return true;
									}
	
									/* Iterate through the calls targeted by the stop command. */
									$.each(elements, function(l, element) {
										/* Check that this call was applied to the target element. */
										if (element === activeElement) {
											/* Optionally clear the remaining queued calls. If we're doing "finishAll" this won't find anything,
											 due to the queue-clearing above. */
											if (options === true || Type.isString(options)) {
												/* Iterate through the items in the element's queue. */
												$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
													/* The queue array can contain an "inprogress" string, which we skip. */
													if (Type.isFunction(item)) {
														/* Pass the item's callback a flag indicating that we want to abort from the queue call.
														 (Specifically, the queue will resolve the call's associated promise then abort.)  */
														item(null, true);
													}
												});
	
												/* Clearing the $.queue() array is achieved by resetting it to []. */
												$.queue(element, Type.isString(options) ? options : "", []);
											}
	
											if (propertiesMap === "stop") {
												/* Since "reverse" uses cached start values (the previous call's endValues), these values must be
												 changed to reflect the final value that the elements were actually tweened to. */
												/* Note: If only queue:false animations are currently running on an element, it won't have a tweensContainer
												 object. Also, queue:false animations can't be reversed. */
												var data = Data(element);
												if (data && data.tweensContainer && queueName !== false) {
													$.each(data.tweensContainer, function(m, activeTween) {
														activeTween.endValue = activeTween.currentValue;
													});
												}
	
												callsToStop.push(i);
											} else if (propertiesMap === "finish" || propertiesMap === "finishAll") {
												/* To get active tweens to finish immediately, we forcefully shorten their durations to 1ms so that
												 they finish upon the next rAf tick then proceed with normal call completion logic. */
												activeCall[2].duration = 1;
											}
										}
									});
								});
							}
						});
	
						/* Prematurely call completeCall() on each matched active call. Pass an additional flag for "stop" to indicate
						 that the complete callback and display:none setting should be skipped since we're completing prematurely. */
						if (propertiesMap === "stop") {
							$.each(callsToStop, function(i, j) {
								completeCall(j, true);
							});
	
							if (promiseData.promise) {
								/* Immediately resolve the promise associated with this stop call since stop runs synchronously. */
								promiseData.resolver(elements);
							}
						}
	
						/* Since we're stopping, and not proceeding with queueing, exit out of Velocity. */
						return getChain();
	
					default:
						/* Treat a non-empty plain object as a literal properties map. */
						if ($.isPlainObject(propertiesMap) && !Type.isEmptyObject(propertiesMap)) {
							action = "start";
	
							/****************
							 Redirects
							 ****************/
	
							/* Check if a string matches a registered redirect (see Redirects above). */
						} else if (Type.isString(propertiesMap) && Velocity.Redirects[propertiesMap]) {
							opts = $.extend({}, options);
	
							var durationOriginal = opts.duration,
									delayOriginal = opts.delay || 0;
	
							/* If the backwards option was passed in, reverse the element set so that elements animate from the last to the first. */
							if (opts.backwards === true) {
								elements = $.extend(true, [], elements).reverse();
							}
	
							/* Individually trigger the redirect for each element in the set to prevent users from having to handle iteration logic in their redirect. */
							$.each(elements, function(elementIndex, element) {
								/* If the stagger option was passed in, successively delay each element by the stagger value (in ms). Retain the original delay value. */
								if (parseFloat(opts.stagger)) {
									opts.delay = delayOriginal + (parseFloat(opts.stagger) * elementIndex);
								} else if (Type.isFunction(opts.stagger)) {
									opts.delay = delayOriginal + opts.stagger.call(element, elementIndex, elementsLength);
								}
	
								/* If the drag option was passed in, successively increase/decrease (depending on the presense of opts.backwards)
								 the duration of each element's animation, using floors to prevent producing very short durations. */
								if (opts.drag) {
									/* Default the duration of UI pack effects (callouts and transitions) to 1000ms instead of the usual default duration of 400ms. */
									opts.duration = parseFloat(durationOriginal) || (/^(callout|transition)/.test(propertiesMap) ? 1000 : DURATION_DEFAULT);
	
									/* For each element, take the greater duration of: A) animation completion percentage relative to the original duration,
									 B) 75% of the original duration, or C) a 200ms fallback (in case duration is already set to a low value).
									 The end result is a baseline of 75% of the redirect's duration that increases/decreases as the end of the element set is approached. */
									opts.duration = Math.max(opts.duration * (opts.backwards ? 1 - elementIndex / elementsLength : (elementIndex + 1) / elementsLength), opts.duration * 0.75, 200);
								}
	
								/* Pass in the call's opts object so that the redirect can optionally extend it. It defaults to an empty object instead of null to
								 reduce the opts checking logic required inside the redirect. */
								Velocity.Redirects[propertiesMap].call(element, element, opts || {}, elementIndex, elementsLength, elements, promiseData.promise ? promiseData : undefined);
							});
	
							/* Since the animation logic resides within the redirect's own code, abort the remainder of this call.
							 (The performance overhead up to this point is virtually non-existant.) */
							/* Note: The jQuery call chain is kept intact by returning the complete element set. */
							return getChain();
						} else {
							var abortError = "Velocity: First argument (" + propertiesMap + ") was not a property map, a known action, or a registered redirect. Aborting.";
	
							if (promiseData.promise) {
								promiseData.rejecter(new Error(abortError));
							} else {
								console.log(abortError);
							}
	
							return getChain();
						}
				}
	
				/**************************
				 Call-Wide Variables
				 **************************/
	
				/* A container for CSS unit conversion ratios (e.g. %, rem, and em ==> px) that is used to cache ratios across all elements
				 being animated in a single Velocity call. Calculating unit ratios necessitates DOM querying and updating, and is therefore
				 avoided (via caching) wherever possible. This container is call-wide instead of page-wide to avoid the risk of using stale
				 conversion metrics across Velocity animations that are not immediately consecutively chained. */
				var callUnitConversionData = {
					lastParent: null,
					lastPosition: null,
					lastFontSize: null,
					lastPercentToPxWidth: null,
					lastPercentToPxHeight: null,
					lastEmToPx: null,
					remToPx: null,
					vwToPx: null,
					vhToPx: null
				};
	
				/* A container for all the ensuing tween data and metadata associated with this call. This container gets pushed to the page-wide
				 Velocity.State.calls array that is processed during animation ticking. */
				var call = [];
	
				/************************
				 Element Processing
				 ************************/
	
				/* Element processing consists of three parts -- data processing that cannot go stale and data processing that *can* go stale (i.e. third-party style modifications):
				 1) Pre-Queueing: Element-wide variables, including the element's data storage, are instantiated. Call options are prepared. If triggered, the Stop action is executed.
				 2) Queueing: The logic that runs once this call has reached its point of execution in the element's $.queue() stack. Most logic is placed here to avoid risking it becoming stale.
				 3) Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
				 `elementArrayIndex` allows passing index of the element in the original array to value functions.
				 If `elementsIndex` were used instead the index would be determined by the elements' per-element queue.
				 */
				function processElement(element, elementArrayIndex) {
	
					/*************************
					 Part I: Pre-Queueing
					 *************************/
	
					/***************************
					 Element-Wide Variables
					 ***************************/
	
					var /* The runtime opts object is the extension of the current call's options and Velocity's page-wide option defaults. */
							opts = $.extend({}, Velocity.defaults, options),
							/* A container for the processed data associated with each property in the propertyMap.
							 (Each property in the map produces its own "tween".) */
							tweensContainer = {},
							elementUnitConversionData;
	
					/******************
					 Element Init
					 ******************/
	
					if (Data(element) === undefined) {
						Velocity.init(element);
					}
	
					/******************
					 Option: Delay
					 ******************/
	
					/* Since queue:false doesn't respect the item's existing queue, we avoid injecting its delay here (it's set later on). */
					/* Note: Velocity rolls its own delay function since jQuery doesn't have a utility alias for $.fn.delay()
					 (and thus requires jQuery element creation, which we avoid since its overhead includes DOM querying). */
					if (parseFloat(opts.delay) && opts.queue !== false) {
						$.queue(element, opts.queue, function(next) {
							/* This is a flag used to indicate to the upcoming completeCall() function that this queue entry was initiated by Velocity. See completeCall() for further details. */
							Velocity.velocityQueueEntryFlag = true;
	
							/* The ensuing queue item (which is assigned to the "next" argument that $.queue() automatically passes in) will be triggered after a setTimeout delay.
							 The setTimeout is stored so that it can be subjected to clearTimeout() if this animation is prematurely stopped via Velocity's "stop" command. */
							Data(element).delayTimer = {
								setTimeout: setTimeout(next, parseFloat(opts.delay)),
								next: next
							};
						});
					}
	
					/*********************
					 Option: Duration
					 *********************/
	
					/* Support for jQuery's named durations. */
					switch (opts.duration.toString().toLowerCase()) {
						case "fast":
							opts.duration = 200;
							break;
	
						case "normal":
							opts.duration = DURATION_DEFAULT;
							break;
	
						case "slow":
							opts.duration = 600;
							break;
	
						default:
							/* Remove the potential "ms" suffix and default to 1 if the user is attempting to set a duration of 0 (in order to produce an immediate style change). */
							opts.duration = parseFloat(opts.duration) || 1;
					}
	
					/************************
					 Global Option: Mock
					 ************************/
	
					if (Velocity.mock !== false) {
						/* In mock mode, all animations are forced to 1ms so that they occur immediately upon the next rAF tick.
						 Alternatively, a multiplier can be passed in to time remap all delays and durations. */
						if (Velocity.mock === true) {
							opts.duration = opts.delay = 1;
						} else {
							opts.duration *= parseFloat(Velocity.mock) || 1;
							opts.delay *= parseFloat(Velocity.mock) || 1;
						}
					}
	
					/*******************
					 Option: Easing
					 *******************/
	
					opts.easing = getEasing(opts.easing, opts.duration);
	
					/**********************
					 Option: Callbacks
					 **********************/
	
					/* Callbacks must functions. Otherwise, default to null. */
					if (opts.begin && !Type.isFunction(opts.begin)) {
						opts.begin = null;
					}
	
					if (opts.progress && !Type.isFunction(opts.progress)) {
						opts.progress = null;
					}
	
					if (opts.complete && !Type.isFunction(opts.complete)) {
						opts.complete = null;
					}
	
					/*********************************
					 Option: Display & Visibility
					 *********************************/
	
					/* Refer to Velocity's documentation (VelocityJS.org/#displayAndVisibility) for a description of the display and visibility options' behavior. */
					/* Note: We strictly check for undefined instead of falsiness because display accepts an empty string value. */
					if (opts.display !== undefined && opts.display !== null) {
						opts.display = opts.display.toString().toLowerCase();
	
						/* Users can pass in a special "auto" value to instruct Velocity to set the element to its default display value. */
						if (opts.display === "auto") {
							opts.display = Velocity.CSS.Values.getDisplayType(element);
						}
					}
	
					if (opts.visibility !== undefined && opts.visibility !== null) {
						opts.visibility = opts.visibility.toString().toLowerCase();
					}
	
					/**********************
					 Option: mobileHA
					 **********************/
	
					/* When set to true, and if this is a mobile device, mobileHA automatically enables hardware acceleration (via a null transform hack)
					 on animating elements. HA is removed from the element at the completion of its animation. */
					/* Note: Android Gingerbread doesn't support HA. If a null transform hack (mobileHA) is in fact set, it will prevent other tranform subproperties from taking effect. */
					/* Note: You can read more about the use of mobileHA in Velocity's documentation: VelocityJS.org/#mobileHA. */
					opts.mobileHA = (opts.mobileHA && Velocity.State.isMobile && !Velocity.State.isGingerbread);
	
					/***********************
					 Part II: Queueing
					 ***********************/
	
					/* When a set of elements is targeted by a Velocity call, the set is broken up and each element has the current Velocity call individually queued onto it.
					 In this way, each element's existing queue is respected; some elements may already be animating and accordingly should not have this current Velocity call triggered immediately. */
					/* In each queue, tween data is processed for each animating property then pushed onto the call-wide calls array. When the last element in the set has had its tweens processed,
					 the call array is pushed to Velocity.State.calls for live processing by the requestAnimationFrame tick. */
					function buildQueue(next) {
						var data, lastTweensContainer;
	
						/*******************
						 Option: Begin
						 *******************/
	
						/* The begin callback is fired once per call -- not once per elemenet -- and is passed the full raw DOM element set as both its context and its first argument. */
						if (opts.begin && elementsIndex === 0) {
							/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
							try {
								opts.begin.call(elements, elements);
							} catch (error) {
								setTimeout(function() {
									throw error;
								}, 1);
							}
						}
	
						/*****************************************
						 Tween Data Construction (for Scroll)
						 *****************************************/
	
						/* Note: In order to be subjected to chaining and animation options, scroll's tweening is routed through Velocity as if it were a standard CSS property animation. */
						if (action === "scroll") {
							/* The scroll action uniquely takes an optional "offset" option -- specified in pixels -- that offsets the targeted scroll position. */
							var scrollDirection = (/^x$/i.test(opts.axis) ? "Left" : "Top"),
									scrollOffset = parseFloat(opts.offset) || 0,
									scrollPositionCurrent,
									scrollPositionCurrentAlternate,
									scrollPositionEnd;
	
							/* Scroll also uniquely takes an optional "container" option, which indicates the parent element that should be scrolled --
							 as opposed to the browser window itself. This is useful for scrolling toward an element that's inside an overflowing parent element. */
							if (opts.container) {
								/* Ensure that either a jQuery object or a raw DOM element was passed in. */
								if (Type.isWrapped(opts.container) || Type.isNode(opts.container)) {
									/* Extract the raw DOM element from the jQuery wrapper. */
									opts.container = opts.container[0] || opts.container;
									/* Note: Unlike other properties in Velocity, the browser's scroll position is never cached since it so frequently changes
									 (due to the user's natural interaction with the page). */
									scrollPositionCurrent = opts.container["scroll" + scrollDirection]; /* GET */
	
									/* $.position() values are relative to the container's currently viewable area (without taking into account the container's true dimensions
									 -- say, for example, if the container was not overflowing). Thus, the scroll end value is the sum of the child element's position *and*
									 the scroll container's current scroll position. */
									scrollPositionEnd = (scrollPositionCurrent + $(element).position()[scrollDirection.toLowerCase()]) + scrollOffset; /* GET */
									/* If a value other than a jQuery object or a raw DOM element was passed in, default to null so that this option is ignored. */
								} else {
									opts.container = null;
								}
							} else {
								/* If the window itself is being scrolled -- not a containing element -- perform a live scroll position lookup using
								 the appropriate cached property names (which differ based on browser type). */
								scrollPositionCurrent = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + scrollDirection]]; /* GET */
								/* When scrolling the browser window, cache the alternate axis's current value since window.scrollTo() doesn't let us change only one value at a time. */
								scrollPositionCurrentAlternate = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + (scrollDirection === "Left" ? "Top" : "Left")]]; /* GET */
	
								/* Unlike $.position(), $.offset() values are relative to the browser window's true dimensions -- not merely its currently viewable area --
								 and therefore end values do not need to be compounded onto current values. */
								scrollPositionEnd = $(element).offset()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
							}
	
							/* Since there's only one format that scroll's associated tweensContainer can take, we create it manually. */
							tweensContainer = {
								scroll: {
									rootPropertyValue: false,
									startValue: scrollPositionCurrent,
									currentValue: scrollPositionCurrent,
									endValue: scrollPositionEnd,
									unitType: "",
									easing: opts.easing,
									scrollData: {
										container: opts.container,
										direction: scrollDirection,
										alternateValue: scrollPositionCurrentAlternate
									}
								},
								element: element
							};
	
							if (Velocity.debug) {
								console.log("tweensContainer (scroll): ", tweensContainer.scroll, element);
							}
	
							/******************************************
							 Tween Data Construction (for Reverse)
							 ******************************************/
	
							/* Reverse acts like a "start" action in that a property map is animated toward. The only difference is
							 that the property map used for reverse is the inverse of the map used in the previous call. Thus, we manipulate
							 the previous call to construct our new map: use the previous map's end values as our new map's start values. Copy over all other data. */
							/* Note: Reverse can be directly called via the "reverse" parameter, or it can be indirectly triggered via the loop option. (Loops are composed of multiple reverses.) */
							/* Note: Reverse calls do not need to be consecutively chained onto a currently-animating element in order to operate on cached values;
							 there is no harm to reverse being called on a potentially stale data cache since reverse's behavior is simply defined
							 as reverting to the element's values as they were prior to the previous *Velocity* call. */
						} else if (action === "reverse") {
							data = Data(element);
	
							/* Abort if there is no prior animation data to reverse to. */
							if (!data) {
								return;
							}
	
							if (!data.tweensContainer) {
								/* Dequeue the element so that this queue entry releases itself immediately, allowing subsequent queue entries to run. */
								$.dequeue(element, opts.queue);
	
								return;
							} else {
								/*********************
								 Options Parsing
								 *********************/
	
								/* If the element was hidden via the display option in the previous call,
								 revert display to "auto" prior to reversal so that the element is visible again. */
								if (data.opts.display === "none") {
									data.opts.display = "auto";
								}
	
								if (data.opts.visibility === "hidden") {
									data.opts.visibility = "visible";
								}
	
								/* If the loop option was set in the previous call, disable it so that "reverse" calls aren't recursively generated.
								 Further, remove the previous call's callback options; typically, users do not want these to be refired. */
								data.opts.loop = false;
								data.opts.begin = null;
								data.opts.complete = null;
	
								/* Since we're extending an opts object that has already been extended with the defaults options object,
								 we remove non-explicitly-defined properties that are auto-assigned values. */
								if (!options.easing) {
									delete opts.easing;
								}
	
								if (!options.duration) {
									delete opts.duration;
								}
	
								/* The opts object used for reversal is an extension of the options object optionally passed into this
								 reverse call plus the options used in the previous Velocity call. */
								opts = $.extend({}, data.opts, opts);
	
								/*************************************
								 Tweens Container Reconstruction
								 *************************************/
	
								/* Create a deepy copy (indicated via the true flag) of the previous call's tweensContainer. */
								lastTweensContainer = $.extend(true, {}, data ? data.tweensContainer : null);
	
								/* Manipulate the previous tweensContainer by replacing its end values and currentValues with its start values. */
								for (var lastTween in lastTweensContainer) {
									/* In addition to tween data, tweensContainers contain an element property that we ignore here. */
									if (lastTweensContainer.hasOwnProperty(lastTween) && lastTween !== "element") {
										var lastStartValue = lastTweensContainer[lastTween].startValue;
	
										lastTweensContainer[lastTween].startValue = lastTweensContainer[lastTween].currentValue = lastTweensContainer[lastTween].endValue;
										lastTweensContainer[lastTween].endValue = lastStartValue;
	
										/* Easing is the only option that embeds into the individual tween data (since it can be defined on a per-property basis).
										 Accordingly, every property's easing value must be updated when an options object is passed in with a reverse call.
										 The side effect of this extensibility is that all per-property easing values are forcefully reset to the new value. */
										if (!Type.isEmptyObject(options)) {
											lastTweensContainer[lastTween].easing = opts.easing;
										}
	
										if (Velocity.debug) {
											console.log("reverse tweensContainer (" + lastTween + "): " + JSON.stringify(lastTweensContainer[lastTween]), element);
										}
									}
								}
	
								tweensContainer = lastTweensContainer;
							}
	
							/*****************************************
							 Tween Data Construction (for Start)
							 *****************************************/
	
						} else if (action === "start") {
	
							/*************************
							 Value Transferring
							 *************************/
	
							/* If this queue entry follows a previous Velocity-initiated queue entry *and* if this entry was created
							 while the element was in the process of being animated by Velocity, then this current call is safe to use
							 the end values from the prior call as its start values. Velocity attempts to perform this value transfer
							 process whenever possible in order to avoid requerying the DOM. */
							/* If values aren't transferred from a prior call and start values were not forcefed by the user (more on this below),
							 then the DOM is queried for the element's current values as a last resort. */
							/* Note: Conversely, animation reversal (and looping) *always* perform inter-call value transfers; they never requery the DOM. */
	
							data = Data(element);
	
							/* The per-element isAnimating flag is used to indicate whether it's safe (i.e. the data isn't stale)
							 to transfer over end values to use as start values. If it's set to true and there is a previous
							 Velocity call to pull values from, do so. */
							if (data && data.tweensContainer && data.isAnimating === true) {
								lastTweensContainer = data.tweensContainer;
							}
	
							/***************************
							 Tween Data Calculation
							 ***************************/
	
							/* This function parses property data and defaults endValue, easing, and startValue as appropriate. */
							/* Property map values can either take the form of 1) a single value representing the end value,
							 or 2) an array in the form of [ endValue, [, easing] [, startValue] ].
							 The optional third parameter is a forcefed startValue to be used instead of querying the DOM for
							 the element's current value. Read Velocity's docmentation to learn more about forcefeeding: VelocityJS.org/#forcefeeding */
							var parsePropertyValue = function(valueData, skipResolvingEasing) {
								var endValue, easing, startValue;
	
								/* Handle the array format, which can be structured as one of three potential overloads:
								 A) [ endValue, easing, startValue ], B) [ endValue, easing ], or C) [ endValue, startValue ] */
								if (Type.isArray(valueData)) {
									/* endValue is always the first item in the array. Don't bother validating endValue's value now
									 since the ensuing property cycling logic does that. */
									endValue = valueData[0];
	
									/* Two-item array format: If the second item is a number, function, or hex string, treat it as a
									 start value since easings can only be non-hex strings or arrays. */
									if ((!Type.isArray(valueData[1]) && /^[\d-]/.test(valueData[1])) || Type.isFunction(valueData[1]) || CSS.RegEx.isHex.test(valueData[1])) {
										startValue = valueData[1];
										/* Two or three-item array: If the second item is a non-hex string or an array, treat it as an easing. */
									} else if ((Type.isString(valueData[1]) && !CSS.RegEx.isHex.test(valueData[1])) || Type.isArray(valueData[1])) {
										easing = skipResolvingEasing ? valueData[1] : getEasing(valueData[1], opts.duration);
	
										/* Don't bother validating startValue's value now since the ensuing property cycling logic inherently does that. */
										if (valueData[2] !== undefined) {
											startValue = valueData[2];
										}
									}
									/* Handle the single-value format. */
								} else {
									endValue = valueData;
								}
	
								/* Default to the call's easing if a per-property easing type was not defined. */
								if (!skipResolvingEasing) {
									easing = easing || opts.easing;
								}
	
								/* If functions were passed in as values, pass the function the current element as its context,
								 plus the element's index and the element set's size as arguments. Then, assign the returned value. */
								if (Type.isFunction(endValue)) {
									endValue = endValue.call(element, elementArrayIndex, elementsLength);
								}
	
								if (Type.isFunction(startValue)) {
									startValue = startValue.call(element, elementArrayIndex, elementsLength);
								}
	
								/* Allow startValue to be left as undefined to indicate to the ensuing code that its value was not forcefed. */
								return [endValue || 0, easing, startValue];
							};
	
							/* Cycle through each property in the map, looking for shorthand color properties (e.g. "color" as opposed to "colorRed"). Inject the corresponding
							 colorRed, colorGreen, and colorBlue RGB component tweens into the propertiesMap (which Velocity understands) and remove the shorthand property. */
							$.each(propertiesMap, function(property, value) {
								/* Find shorthand color properties that have been passed a hex string. */
								if (RegExp("^" + CSS.Lists.colors.join("$|^") + "$").test(CSS.Names.camelCase(property))) {
									/* Parse the value data for each shorthand. */
									var valueData = parsePropertyValue(value, true),
											endValue = valueData[0],
											easing = valueData[1],
											startValue = valueData[2];
	
									if (CSS.RegEx.isHex.test(endValue)) {
										/* Convert the hex strings into their RGB component arrays. */
										var colorComponents = ["Red", "Green", "Blue"],
												endValueRGB = CSS.Values.hexToRgb(endValue),
												startValueRGB = startValue ? CSS.Values.hexToRgb(startValue) : undefined;
	
										/* Inject the RGB component tweens into propertiesMap. */
										for (var i = 0; i < colorComponents.length; i++) {
											var dataArray = [endValueRGB[i]];
	
											if (easing) {
												dataArray.push(easing);
											}
	
											if (startValueRGB !== undefined) {
												dataArray.push(startValueRGB[i]);
											}
	
											propertiesMap[CSS.Names.camelCase(property) + colorComponents[i]] = dataArray;
										}
	
										/* Remove the intermediary shorthand property entry now that we've processed it. */
										delete propertiesMap[property];
									}
								}
							});
	
							/* Create a tween out of each property, and append its associated data to tweensContainer. */
							for (var property in propertiesMap) {
	
								if (!propertiesMap.hasOwnProperty(property)) {
									continue;
								}
								/**************************
								 Start Value Sourcing
								 **************************/
	
								/* Parse out endValue, easing, and startValue from the property's data. */
								var valueData = parsePropertyValue(propertiesMap[property]),
										endValue = valueData[0],
										easing = valueData[1],
										startValue = valueData[2];
	
								/* Now that the original property name's format has been used for the parsePropertyValue() lookup above,
								 we force the property to its camelCase styling to normalize it for manipulation. */
								property = CSS.Names.camelCase(property);
	
								/* In case this property is a hook, there are circumstances where we will intend to work on the hook's root property and not the hooked subproperty. */
								var rootProperty = CSS.Hooks.getRoot(property),
										rootPropertyValue = false;
	
								/* Other than for the dummy tween property, properties that are not supported by the browser (and do not have an associated normalization) will
								 inherently produce no style changes when set, so they are skipped in order to decrease animation tick overhead.
								 Property support is determined via prefixCheck(), which returns a false flag when no supported is detected. */
								/* Note: Since SVG elements have some of their properties directly applied as HTML attributes,
								 there is no way to check for their explicit browser support, and so we skip skip this check for them. */
								if ((!data || !data.isSVG) && rootProperty !== "tween" && CSS.Names.prefixCheck(rootProperty)[1] === false && CSS.Normalizations.registered[rootProperty] === undefined) {
									if (Velocity.debug) {
										console.log("Skipping [" + rootProperty + "] due to a lack of browser support.");
									}
									continue;
								}
	
								/* If the display option is being set to a non-"none" (e.g. "block") and opacity (filter on IE<=8) is being
								 animated to an endValue of non-zero, the user's intention is to fade in from invisible, thus we forcefeed opacity
								 a startValue of 0 if its startValue hasn't already been sourced by value transferring or prior forcefeeding. */
								if (((opts.display !== undefined && opts.display !== null && opts.display !== "none") || (opts.visibility !== undefined && opts.visibility !== "hidden")) && /opacity|filter/.test(property) && !startValue && endValue !== 0) {
									startValue = 0;
								}
	
								/* If values have been transferred from the previous Velocity call, extract the endValue and rootPropertyValue
								 for all of the current call's properties that were *also* animated in the previous call. */
								/* Note: Value transferring can optionally be disabled by the user via the _cacheValues option. */
								if (opts._cacheValues && lastTweensContainer && lastTweensContainer[property]) {
									if (startValue === undefined) {
										startValue = lastTweensContainer[property].endValue + lastTweensContainer[property].unitType;
									}
	
									/* The previous call's rootPropertyValue is extracted from the element's data cache since that's the
									 instance of rootPropertyValue that gets freshly updated by the tweening process, whereas the rootPropertyValue
									 attached to the incoming lastTweensContainer is equal to the root property's value prior to any tweening. */
									rootPropertyValue = data.rootPropertyValueCache[rootProperty];
									/* If values were not transferred from a previous Velocity call, query the DOM as needed. */
								} else {
									/* Handle hooked properties. */
									if (CSS.Hooks.registered[property]) {
										if (startValue === undefined) {
											rootPropertyValue = CSS.getPropertyValue(element, rootProperty); /* GET */
											/* Note: The following getPropertyValue() call does not actually trigger a DOM query;
											 getPropertyValue() will extract the hook from rootPropertyValue. */
											startValue = CSS.getPropertyValue(element, property, rootPropertyValue);
											/* If startValue is already defined via forcefeeding, do not query the DOM for the root property's value;
											 just grab rootProperty's zero-value template from CSS.Hooks. This overwrites the element's actual
											 root property value (if one is set), but this is acceptable since the primary reason users forcefeed is
											 to avoid DOM queries, and thus we likewise avoid querying the DOM for the root property's value. */
										} else {
											/* Grab this hook's zero-value template, e.g. "0px 0px 0px black". */
											rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
										}
										/* Handle non-hooked properties that haven't already been defined via forcefeeding. */
									} else if (startValue === undefined) {
										startValue = CSS.getPropertyValue(element, property); /* GET */
									}
								}
	
								/**************************
								 Value Data Extraction
								 **************************/
	
								var separatedValue,
										endValueUnitType,
										startValueUnitType,
										operator = false;
	
								/* Separates a property value into its numeric value and its unit type. */
								var separateValue = function(property, value) {
									var unitType,
											numericValue;
	
									numericValue = (value || "0")
											.toString()
											.toLowerCase()
											/* Match the unit type at the end of the value. */
											.replace(/[%A-z]+$/, function(match) {
												/* Grab the unit type. */
												unitType = match;
	
												/* Strip the unit type off of value. */
												return "";
											});
	
									/* If no unit type was supplied, assign one that is appropriate for this property (e.g. "deg" for rotateZ or "px" for width). */
									if (!unitType) {
										unitType = CSS.Values.getUnitType(property);
									}
	
									return [numericValue, unitType];
								};
	
								/* Separate startValue. */
								separatedValue = separateValue(property, startValue);
								startValue = separatedValue[0];
								startValueUnitType = separatedValue[1];
	
								/* Separate endValue, and extract a value operator (e.g. "+=", "-=") if one exists. */
								separatedValue = separateValue(property, endValue);
								endValue = separatedValue[0].replace(/^([+-\/*])=/, function(match, subMatch) {
									operator = subMatch;
	
									/* Strip the operator off of the value. */
									return "";
								});
								endValueUnitType = separatedValue[1];
	
								/* Parse float values from endValue and startValue. Default to 0 if NaN is returned. */
								startValue = parseFloat(startValue) || 0;
								endValue = parseFloat(endValue) || 0;
	
								/***************************************
								 Property-Specific Value Conversion
								 ***************************************/
	
								/* Custom support for properties that don't actually accept the % unit type, but where pollyfilling is trivial and relatively foolproof. */
								if (endValueUnitType === "%") {
									/* A %-value fontSize/lineHeight is relative to the parent's fontSize (as opposed to the parent's dimensions),
									 which is identical to the em unit's behavior, so we piggyback off of that. */
									if (/^(fontSize|lineHeight)$/.test(property)) {
										/* Convert % into an em decimal value. */
										endValue = endValue / 100;
										endValueUnitType = "em";
										/* For scaleX and scaleY, convert the value into its decimal format and strip off the unit type. */
									} else if (/^scale/.test(property)) {
										endValue = endValue / 100;
										endValueUnitType = "";
										/* For RGB components, take the defined percentage of 255 and strip off the unit type. */
									} else if (/(Red|Green|Blue)$/i.test(property)) {
										endValue = (endValue / 100) * 255;
										endValueUnitType = "";
									}
								}
	
								/***************************
								 Unit Ratio Calculation
								 ***************************/
	
								/* When queried, the browser returns (most) CSS property values in pixels. Therefore, if an endValue with a unit type of
								 %, em, or rem is animated toward, startValue must be converted from pixels into the same unit type as endValue in order
								 for value manipulation logic (increment/decrement) to proceed. Further, if the startValue was forcefed or transferred
								 from a previous call, startValue may also not be in pixels. Unit conversion logic therefore consists of two steps:
								 1) Calculating the ratio of %/em/rem/vh/vw relative to pixels
								 2) Converting startValue into the same unit of measurement as endValue based on these ratios. */
								/* Unit conversion ratios are calculated by inserting a sibling node next to the target node, copying over its position property,
								 setting values with the target unit type then comparing the returned pixel value. */
								/* Note: Even if only one of these unit types is being animated, all unit ratios are calculated at once since the overhead
								 of batching the SETs and GETs together upfront outweights the potential overhead
								 of layout thrashing caused by re-querying for uncalculated ratios for subsequently-processed properties. */
								/* Todo: Shift this logic into the calls' first tick instance so that it's synced with RAF. */
								var calculateUnitRatios = function() {
	
									/************************
									 Same Ratio Checks
									 ************************/
	
									/* The properties below are used to determine whether the element differs sufficiently from this call's
									 previously iterated element to also differ in its unit conversion ratios. If the properties match up with those
									 of the prior element, the prior element's conversion ratios are used. Like most optimizations in Velocity,
									 this is done to minimize DOM querying. */
									var sameRatioIndicators = {
										myParent: element.parentNode || document.body, /* GET */
										position: CSS.getPropertyValue(element, "position"), /* GET */
										fontSize: CSS.getPropertyValue(element, "fontSize") /* GET */
									},
									/* Determine if the same % ratio can be used. % is based on the element's position value and its parent's width and height dimensions. */
									samePercentRatio = ((sameRatioIndicators.position === callUnitConversionData.lastPosition) && (sameRatioIndicators.myParent === callUnitConversionData.lastParent)),
											/* Determine if the same em ratio can be used. em is relative to the element's fontSize. */
											sameEmRatio = (sameRatioIndicators.fontSize === callUnitConversionData.lastFontSize);
	
									/* Store these ratio indicators call-wide for the next element to compare against. */
									callUnitConversionData.lastParent = sameRatioIndicators.myParent;
									callUnitConversionData.lastPosition = sameRatioIndicators.position;
									callUnitConversionData.lastFontSize = sameRatioIndicators.fontSize;
	
									/***************************
									 Element-Specific Units
									 ***************************/
	
									/* Note: IE8 rounds to the nearest pixel when returning CSS values, thus we perform conversions using a measurement
									 of 100 (instead of 1) to give our ratios a precision of at least 2 decimal values. */
									var measurement = 100,
											unitRatios = {};
	
									if (!sameEmRatio || !samePercentRatio) {
										var dummy = data && data.isSVG ? document.createElementNS("http://www.w3.org/2000/svg", "rect") : document.createElement("div");
	
										Velocity.init(dummy);
										sameRatioIndicators.myParent.appendChild(dummy);
	
										/* To accurately and consistently calculate conversion ratios, the element's cascaded overflow and box-sizing are stripped.
										 Similarly, since width/height can be artificially constrained by their min-/max- equivalents, these are controlled for as well. */
										/* Note: Overflow must be also be controlled for per-axis since the overflow property overwrites its per-axis values. */
										$.each(["overflow", "overflowX", "overflowY"], function(i, property) {
											Velocity.CSS.setPropertyValue(dummy, property, "hidden");
										});
										Velocity.CSS.setPropertyValue(dummy, "position", sameRatioIndicators.position);
										Velocity.CSS.setPropertyValue(dummy, "fontSize", sameRatioIndicators.fontSize);
										Velocity.CSS.setPropertyValue(dummy, "boxSizing", "content-box");
	
										/* width and height act as our proxy properties for measuring the horizontal and vertical % ratios. */
										$.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(i, property) {
											Velocity.CSS.setPropertyValue(dummy, property, measurement + "%");
										});
										/* paddingLeft arbitrarily acts as our proxy property for the em ratio. */
										Velocity.CSS.setPropertyValue(dummy, "paddingLeft", measurement + "em");
	
										/* Divide the returned value by the measurement to get the ratio between 1% and 1px. Default to 1 since working with 0 can produce Infinite. */
										unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth = (parseFloat(CSS.getPropertyValue(dummy, "width", null, true)) || 1) / measurement; /* GET */
										unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight = (parseFloat(CSS.getPropertyValue(dummy, "height", null, true)) || 1) / measurement; /* GET */
										unitRatios.emToPx = callUnitConversionData.lastEmToPx = (parseFloat(CSS.getPropertyValue(dummy, "paddingLeft")) || 1) / measurement; /* GET */
	
										sameRatioIndicators.myParent.removeChild(dummy);
									} else {
										unitRatios.emToPx = callUnitConversionData.lastEmToPx;
										unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth;
										unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight;
									}
	
									/***************************
									 Element-Agnostic Units
									 ***************************/
	
									/* Whereas % and em ratios are determined on a per-element basis, the rem unit only needs to be checked
									 once per call since it's exclusively dependant upon document.body's fontSize. If this is the first time
									 that calculateUnitRatios() is being run during this call, remToPx will still be set to its default value of null,
									 so we calculate it now. */
									if (callUnitConversionData.remToPx === null) {
										/* Default to browsers' default fontSize of 16px in the case of 0. */
										callUnitConversionData.remToPx = parseFloat(CSS.getPropertyValue(document.body, "fontSize")) || 16; /* GET */
									}
	
									/* Similarly, viewport units are %-relative to the window's inner dimensions. */
									if (callUnitConversionData.vwToPx === null) {
										callUnitConversionData.vwToPx = parseFloat(window.innerWidth) / 100; /* GET */
										callUnitConversionData.vhToPx = parseFloat(window.innerHeight) / 100; /* GET */
									}
	
									unitRatios.remToPx = callUnitConversionData.remToPx;
									unitRatios.vwToPx = callUnitConversionData.vwToPx;
									unitRatios.vhToPx = callUnitConversionData.vhToPx;
	
									if (Velocity.debug >= 1) {
										console.log("Unit ratios: " + JSON.stringify(unitRatios), element);
									}
									return unitRatios;
								};
	
								/********************
								 Unit Conversion
								 ********************/
	
								/* The * and / operators, which are not passed in with an associated unit, inherently use startValue's unit. Skip value and unit conversion. */
								if (/[\/*]/.test(operator)) {
									endValueUnitType = startValueUnitType;
									/* If startValue and endValue differ in unit type, convert startValue into the same unit type as endValue so that if endValueUnitType
									 is a relative unit (%, em, rem), the values set during tweening will continue to be accurately relative even if the metrics they depend
									 on are dynamically changing during the course of the animation. Conversely, if we always normalized into px and used px for setting values, the px ratio
									 would become stale if the original unit being animated toward was relative and the underlying metrics change during the animation. */
									/* Since 0 is 0 in any unit type, no conversion is necessary when startValue is 0 -- we just start at 0 with endValueUnitType. */
								} else if ((startValueUnitType !== endValueUnitType) && startValue !== 0) {
									/* Unit conversion is also skipped when endValue is 0, but *startValueUnitType* must be used for tween values to remain accurate. */
									/* Note: Skipping unit conversion here means that if endValueUnitType was originally a relative unit, the animation won't relatively
									 match the underlying metrics if they change, but this is acceptable since we're animating toward invisibility instead of toward visibility,
									 which remains past the point of the animation's completion. */
									if (endValue === 0) {
										endValueUnitType = startValueUnitType;
									} else {
										/* By this point, we cannot avoid unit conversion (it's undesirable since it causes layout thrashing).
										 If we haven't already, we trigger calculateUnitRatios(), which runs once per element per call. */
										elementUnitConversionData = elementUnitConversionData || calculateUnitRatios();
	
										/* The following RegEx matches CSS properties that have their % values measured relative to the x-axis. */
										/* Note: W3C spec mandates that all of margin and padding's properties (even top and bottom) are %-relative to the *width* of the parent element. */
										var axis = (/margin|padding|left|right|width|text|word|letter/i.test(property) || /X$/.test(property) || property === "x") ? "x" : "y";
	
										/* In order to avoid generating n^2 bespoke conversion functions, unit conversion is a two-step process:
										 1) Convert startValue into pixels. 2) Convert this new pixel value into endValue's unit type. */
										switch (startValueUnitType) {
											case "%":
												/* Note: translateX and translateY are the only properties that are %-relative to an element's own dimensions -- not its parent's dimensions.
												 Velocity does not include a special conversion process to account for this behavior. Therefore, animating translateX/Y from a % value
												 to a non-% value will produce an incorrect start value. Fortunately, this sort of cross-unit conversion is rarely done by users in practice. */
												startValue *= (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
												break;
	
											case "px":
												/* px acts as our midpoint in the unit conversion process; do nothing. */
												break;
	
											default:
												startValue *= elementUnitConversionData[startValueUnitType + "ToPx"];
										}
	
										/* Invert the px ratios to convert into to the target unit. */
										switch (endValueUnitType) {
											case "%":
												startValue *= 1 / (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
												break;
	
											case "px":
												/* startValue is already in px, do nothing; we're done. */
												break;
	
											default:
												startValue *= 1 / elementUnitConversionData[endValueUnitType + "ToPx"];
										}
									}
								}
	
								/*********************
								 Relative Values
								 *********************/
	
								/* Operator logic must be performed last since it requires unit-normalized start and end values. */
								/* Note: Relative *percent values* do not behave how most people think; while one would expect "+=50%"
								 to increase the property 1.5x its current value, it in fact increases the percent units in absolute terms:
								 50 points is added on top of the current % value. */
								switch (operator) {
									case "+":
										endValue = startValue + endValue;
										break;
	
									case "-":
										endValue = startValue - endValue;
										break;
	
									case "*":
										endValue = startValue * endValue;
										break;
	
									case "/":
										endValue = startValue / endValue;
										break;
								}
	
								/**************************
								 tweensContainer Push
								 **************************/
	
								/* Construct the per-property tween object, and push it to the element's tweensContainer. */
								tweensContainer[property] = {
									rootPropertyValue: rootPropertyValue,
									startValue: startValue,
									currentValue: startValue,
									endValue: endValue,
									unitType: endValueUnitType,
									easing: easing
								};
	
								if (Velocity.debug) {
									console.log("tweensContainer (" + property + "): " + JSON.stringify(tweensContainer[property]), element);
								}
							}
	
							/* Along with its property data, store a reference to the element itself onto tweensContainer. */
							tweensContainer.element = element;
						}
	
						/*****************
						 Call Push
						 *****************/
	
						/* Note: tweensContainer can be empty if all of the properties in this call's property map were skipped due to not
						 being supported by the browser. The element property is used for checking that the tweensContainer has been appended to. */
						if (tweensContainer.element) {
							/* Apply the "velocity-animating" indicator class. */
							CSS.Values.addClass(element, "velocity-animating");
	
							/* The call array houses the tweensContainers for each element being animated in the current call. */
							call.push(tweensContainer);
	
							data = Data(element);
	
							if (data) {
								/* Store the tweensContainer and options if we're working on the default effects queue, so that they can be used by the reverse command. */
								if (opts.queue === "") {
	
									data.tweensContainer = tweensContainer;
									data.opts = opts;
								}
	
								/* Switch on the element's animating flag. */
								data.isAnimating = true;
							}
	
							/* Once the final element in this call's element set has been processed, push the call array onto
							 Velocity.State.calls for the animation tick to immediately begin processing. */
							if (elementsIndex === elementsLength - 1) {
								/* Add the current call plus its associated metadata (the element set and the call's options) onto the global call container.
								 Anything on this call container is subjected to tick() processing. */
								Velocity.State.calls.push([call, elements, opts, null, promiseData.resolver]);
	
								/* If the animation tick isn't running, start it. (Velocity shuts it off when there are no active calls to process.) */
								if (Velocity.State.isTicking === false) {
									Velocity.State.isTicking = true;
	
									/* Start the tick loop. */
									tick();
								}
							} else {
								elementsIndex++;
							}
						}
					}
	
					/* When the queue option is set to false, the call skips the element's queue and fires immediately. */
					if (opts.queue === false) {
						/* Since this buildQueue call doesn't respect the element's existing queue (which is where a delay option would have been appended),
						 we manually inject the delay property here with an explicit setTimeout. */
						if (opts.delay) {
							setTimeout(buildQueue, opts.delay);
						} else {
							buildQueue();
						}
						/* Otherwise, the call undergoes element queueing as normal. */
						/* Note: To interoperate with jQuery, Velocity uses jQuery's own $.queue() stack for queuing logic. */
					} else {
						$.queue(element, opts.queue, function(next, clearQueue) {
							/* If the clearQueue flag was passed in by the stop command, resolve this call's promise. (Promises can only be resolved once,
							 so it's fine if this is repeatedly triggered for each element in the associated call.) */
							if (clearQueue === true) {
								if (promiseData.promise) {
									promiseData.resolver(elements);
								}
	
								/* Do not continue with animation queueing. */
								return true;
							}
	
							/* This flag indicates to the upcoming completeCall() function that this queue entry was initiated by Velocity.
							 See completeCall() for further details. */
							Velocity.velocityQueueEntryFlag = true;
	
							buildQueue(next);
						});
					}
	
					/*********************
					 Auto-Dequeuing
					 *********************/
	
					/* As per jQuery's $.queue() behavior, to fire the first non-custom-queue entry on an element, the element
					 must be dequeued if its queue stack consists *solely* of the current call. (This can be determined by checking
					 for the "inprogress" item that jQuery prepends to active queue stack arrays.) Regardless, whenever the element's
					 queue is further appended with additional items -- including $.delay()'s or even $.animate() calls, the queue's
					 first entry is automatically fired. This behavior contrasts that of custom queues, which never auto-fire. */
					/* Note: When an element set is being subjected to a non-parallel Velocity call, the animation will not begin until
					 each one of the elements in the set has reached the end of its individually pre-existing queue chain. */
					/* Note: Unfortunately, most people don't fully grasp jQuery's powerful, yet quirky, $.queue() function.
					 Lean more here: http://stackoverflow.com/questions/1058158/can-somebody-explain-jquery-queue-to-me */
					if ((opts.queue === "" || opts.queue === "fx") && $.queue(element)[0] !== "inprogress") {
						$.dequeue(element);
					}
				}
	
				/**************************
				 Element Set Iteration
				 **************************/
	
				/* If the "nodeType" property exists on the elements variable, we're animating a single element.
				 Place it in an array so that $.each() can iterate over it. */
				$.each(elements, function(i, element) {
					/* Ensure each element in a set has a nodeType (is a real element) to avoid throwing errors. */
					if (Type.isNode(element)) {
						processElement(element, i);
					}
				});
	
				/******************
				 Option: Loop
				 ******************/
	
				/* The loop option accepts an integer indicating how many times the element should loop between the values in the
				 current call's properties map and the element's property values prior to this call. */
				/* Note: The loop option's logic is performed here -- after element processing -- because the current call needs
				 to undergo its queue insertion prior to the loop option generating its series of constituent "reverse" calls,
				 which chain after the current call. Two reverse calls (two "alternations") constitute one loop. */
				opts = $.extend({}, Velocity.defaults, options);
				opts.loop = parseInt(opts.loop, 10);
				var reverseCallsCount = (opts.loop * 2) - 1;
	
				if (opts.loop) {
					/* Double the loop count to convert it into its appropriate number of "reverse" calls.
					 Subtract 1 from the resulting value since the current call is included in the total alternation count. */
					for (var x = 0; x < reverseCallsCount; x++) {
						/* Since the logic for the reverse action occurs inside Queueing and therefore this call's options object
						 isn't parsed until then as well, the current call's delay option must be explicitly passed into the reverse
						 call so that the delay logic that occurs inside *Pre-Queueing* can process it. */
						var reverseOptions = {
							delay: opts.delay,
							progress: opts.progress
						};
	
						/* If a complete callback was passed into this call, transfer it to the loop redirect's final "reverse" call
						 so that it's triggered when the entire redirect is complete (and not when the very first animation is complete). */
						if (x === reverseCallsCount - 1) {
							reverseOptions.display = opts.display;
							reverseOptions.visibility = opts.visibility;
							reverseOptions.complete = opts.complete;
						}
	
						animate(elements, "reverse", reverseOptions);
					}
				}
	
				/***************
				 Chaining
				 ***************/
	
				/* Return the elements back to the call chain, with wrapped elements taking precedence in case Velocity was called via the $.fn. extension. */
				return getChain();
			};
	
			/* Turn Velocity into the animation function, extended with the pre-existing Velocity object. */
			Velocity = $.extend(animate, Velocity);
			/* For legacy support, also expose the literal animate method. */
			Velocity.animate = animate;
	
			/**************
			 Timing
			 **************/
	
			/* Ticker function. */
			var ticker = window.requestAnimationFrame || rAFShim;
	
			/* Inactive browser tabs pause rAF, which results in all active animations immediately sprinting to their completion states when the tab refocuses.
			 To get around this, we dynamically switch rAF to setTimeout (which the browser *doesn't* pause) when the tab loses focus. We skip this for mobile
			 devices to avoid wasting battery power on inactive tabs. */
			/* Note: Tab focus detection doesn't work on older versions of IE, but that's okay since they don't support rAF to begin with. */
			if (!Velocity.State.isMobile && document.hidden !== undefined) {
				document.addEventListener("visibilitychange", function() {
					/* Reassign the rAF function (which the global tick() function uses) based on the tab's focus state. */
					if (document.hidden) {
						ticker = function(callback) {
							/* The tick function needs a truthy first argument in order to pass its internal timestamp check. */
							return setTimeout(function() {
								callback(true);
							}, 16);
						};
	
						/* The rAF loop has been paused by the browser, so we manually restart the tick. */
						tick();
					} else {
						ticker = window.requestAnimationFrame || rAFShim;
					}
				});
			}
	
			/************
			 Tick
			 ************/
	
			/* Note: All calls to Velocity are pushed to the Velocity.State.calls array, which is fully iterated through upon each tick. */
			function tick(timestamp) {
				/* An empty timestamp argument indicates that this is the first tick occurence since ticking was turned on.
				 We leverage this metadata to fully ignore the first tick pass since RAF's initial pass is fired whenever
				 the browser's next tick sync time occurs, which results in the first elements subjected to Velocity
				 calls being animated out of sync with any elements animated immediately thereafter. In short, we ignore
				 the first RAF tick pass so that elements being immediately consecutively animated -- instead of simultaneously animated
				 by the same Velocity call -- are properly batched into the same initial RAF tick and consequently remain in sync thereafter. */
				if (timestamp) {
					/* We ignore RAF's high resolution timestamp since it can be significantly offset when the browser is
					 under high stress; we opt for choppiness over allowing the browser to drop huge chunks of frames. */
					var timeCurrent = (new Date()).getTime();
	
					/********************
					 Call Iteration
					 ********************/
	
					var callsLength = Velocity.State.calls.length;
	
					/* To speed up iterating over this array, it is compacted (falsey items -- calls that have completed -- are removed)
					 when its length has ballooned to a point that can impact tick performance. This only becomes necessary when animation
					 has been continuous with many elements over a long period of time; whenever all active calls are completed, completeCall() clears Velocity.State.calls. */
					if (callsLength > 10000) {
						Velocity.State.calls = compactSparseArray(Velocity.State.calls);
						callsLength = Velocity.State.calls.length;
					}
	
					/* Iterate through each active call. */
					for (var i = 0; i < callsLength; i++) {
						/* When a Velocity call is completed, its Velocity.State.calls entry is set to false. Continue on to the next call. */
						if (!Velocity.State.calls[i]) {
							continue;
						}
	
						/************************
						 Call-Wide Variables
						 ************************/
	
						var callContainer = Velocity.State.calls[i],
								call = callContainer[0],
								opts = callContainer[2],
								timeStart = callContainer[3],
								firstTick = !!timeStart,
								tweenDummyValue = null;
	
						/* If timeStart is undefined, then this is the first time that this call has been processed by tick().
						 We assign timeStart now so that its value is as close to the real animation start time as possible.
						 (Conversely, had timeStart been defined when this call was added to Velocity.State.calls, the delay
						 between that time and now would cause the first few frames of the tween to be skipped since
						 percentComplete is calculated relative to timeStart.) */
						/* Further, subtract 16ms (the approximate resolution of RAF) from the current time value so that the
						 first tick iteration isn't wasted by animating at 0% tween completion, which would produce the
						 same style value as the element's current value. */
						if (!timeStart) {
							timeStart = Velocity.State.calls[i][3] = timeCurrent - 16;
						}
	
						/* The tween's completion percentage is relative to the tween's start time, not the tween's start value
						 (which would result in unpredictable tween durations since JavaScript's timers are not particularly accurate).
						 Accordingly, we ensure that percentComplete does not exceed 1. */
						var percentComplete = Math.min((timeCurrent - timeStart) / opts.duration, 1);
	
						/**********************
						 Element Iteration
						 **********************/
	
						/* For every call, iterate through each of the elements in its set. */
						for (var j = 0, callLength = call.length; j < callLength; j++) {
							var tweensContainer = call[j],
									element = tweensContainer.element;
	
							/* Check to see if this element has been deleted midway through the animation by checking for the
							 continued existence of its data cache. If it's gone, skip animating this element. */
							if (!Data(element)) {
								continue;
							}
	
							var transformPropertyExists = false;
	
							/**********************************
							 Display & Visibility Toggling
							 **********************************/
	
							/* If the display option is set to non-"none", set it upfront so that the element can become visible before tweening begins.
							 (Otherwise, display's "none" value is set in completeCall() once the animation has completed.) */
							if (opts.display !== undefined && opts.display !== null && opts.display !== "none") {
								if (opts.display === "flex") {
									var flexValues = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];
	
									$.each(flexValues, function(i, flexValue) {
										CSS.setPropertyValue(element, "display", flexValue);
									});
								}
	
								CSS.setPropertyValue(element, "display", opts.display);
							}
	
							/* Same goes with the visibility option, but its "none" equivalent is "hidden". */
							if (opts.visibility !== undefined && opts.visibility !== "hidden") {
								CSS.setPropertyValue(element, "visibility", opts.visibility);
							}
	
							/************************
							 Property Iteration
							 ************************/
	
							/* For every element, iterate through each property. */
							for (var property in tweensContainer) {
								/* Note: In addition to property tween data, tweensContainer contains a reference to its associated element. */
								if (tweensContainer.hasOwnProperty(property) && property !== "element") {
									var tween = tweensContainer[property],
											currentValue,
											/* Easing can either be a pre-genereated function or a string that references a pre-registered easing
											 on the Velocity.Easings object. In either case, return the appropriate easing *function*. */
											easing = Type.isString(tween.easing) ? Velocity.Easings[tween.easing] : tween.easing;
	
									/******************************
									 Current Value Calculation
									 ******************************/
	
									/* If this is the last tick pass (if we've reached 100% completion for this tween),
									 ensure that currentValue is explicitly set to its target endValue so that it's not subjected to any rounding. */
									if (percentComplete === 1) {
										currentValue = tween.endValue;
										/* Otherwise, calculate currentValue based on the current delta from startValue. */
									} else {
										var tweenDelta = tween.endValue - tween.startValue;
										currentValue = tween.startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));
	
										/* If no value change is occurring, don't proceed with DOM updating. */
										if (!firstTick && (currentValue === tween.currentValue)) {
											continue;
										}
									}
	
									tween.currentValue = currentValue;
	
									/* If we're tweening a fake 'tween' property in order to log transition values, update the one-per-call variable so that
									 it can be passed into the progress callback. */
									if (property === "tween") {
										tweenDummyValue = currentValue;
									} else {
										/******************
										 Hooks: Part I
										 ******************/
										var hookRoot;
	
										/* For hooked properties, the newly-updated rootPropertyValueCache is cached onto the element so that it can be used
										 for subsequent hooks in this call that are associated with the same root property. If we didn't cache the updated
										 rootPropertyValue, each subsequent update to the root property in this tick pass would reset the previous hook's
										 updates to rootPropertyValue prior to injection. A nice performance byproduct of rootPropertyValue caching is that
										 subsequently chained animations using the same hookRoot but a different hook can use this cached rootPropertyValue. */
										if (CSS.Hooks.registered[property]) {
											hookRoot = CSS.Hooks.getRoot(property);
	
											var rootPropertyValueCache = Data(element).rootPropertyValueCache[hookRoot];
	
											if (rootPropertyValueCache) {
												tween.rootPropertyValue = rootPropertyValueCache;
											}
										}
	
										/*****************
										 DOM Update
										 *****************/
	
										/* setPropertyValue() returns an array of the property name and property value post any normalization that may have been performed. */
										/* Note: To solve an IE<=8 positioning bug, the unit type is dropped when setting a property value of 0. */
										var adjustedSetData = CSS.setPropertyValue(element, /* SET */
												property,
												tween.currentValue + (parseFloat(currentValue) === 0 ? "" : tween.unitType),
												tween.rootPropertyValue,
												tween.scrollData);
	
										/*******************
										 Hooks: Part II
										 *******************/
	
										/* Now that we have the hook's updated rootPropertyValue (the post-processed value provided by adjustedSetData), cache it onto the element. */
										if (CSS.Hooks.registered[property]) {
											/* Since adjustedSetData contains normalized data ready for DOM updating, the rootPropertyValue needs to be re-extracted from its normalized form. ?? */
											if (CSS.Normalizations.registered[hookRoot]) {
												Data(element).rootPropertyValueCache[hookRoot] = CSS.Normalizations.registered[hookRoot]("extract", null, adjustedSetData[1]);
											} else {
												Data(element).rootPropertyValueCache[hookRoot] = adjustedSetData[1];
											}
										}
	
										/***************
										 Transforms
										 ***************/
	
										/* Flag whether a transform property is being animated so that flushTransformCache() can be triggered once this tick pass is complete. */
										if (adjustedSetData[0] === "transform") {
											transformPropertyExists = true;
										}
	
									}
								}
							}
	
							/****************
							 mobileHA
							 ****************/
	
							/* If mobileHA is enabled, set the translate3d transform to null to force hardware acceleration.
							 It's safe to override this property since Velocity doesn't actually support its animation (hooks are used in its place). */
							if (opts.mobileHA) {
								/* Don't set the null transform hack if we've already done so. */
								if (Data(element).transformCache.translate3d === undefined) {
									/* All entries on the transformCache object are later concatenated into a single transform string via flushTransformCache(). */
									Data(element).transformCache.translate3d = "(0px, 0px, 0px)";
	
									transformPropertyExists = true;
								}
							}
	
							if (transformPropertyExists) {
								CSS.flushTransformCache(element);
							}
						}
	
						/* The non-"none" display value is only applied to an element once -- when its associated call is first ticked through.
						 Accordingly, it's set to false so that it isn't re-processed by this call in the next tick. */
						if (opts.display !== undefined && opts.display !== "none") {
							Velocity.State.calls[i][2].display = false;
						}
						if (opts.visibility !== undefined && opts.visibility !== "hidden") {
							Velocity.State.calls[i][2].visibility = false;
						}
	
						/* Pass the elements and the timing data (percentComplete, msRemaining, timeStart, tweenDummyValue) into the progress callback. */
						if (opts.progress) {
							opts.progress.call(callContainer[1],
									callContainer[1],
									percentComplete,
									Math.max(0, (timeStart + opts.duration) - timeCurrent),
									timeStart,
									tweenDummyValue);
						}
	
						/* If this call has finished tweening, pass its index to completeCall() to handle call cleanup. */
						if (percentComplete === 1) {
							completeCall(i);
						}
					}
				}
	
				/* Note: completeCall() sets the isTicking flag to false when the last call on Velocity.State.calls has completed. */
				if (Velocity.State.isTicking) {
					ticker(tick);
				}
			}
	
			/**********************
			 Call Completion
			 **********************/
	
			/* Note: Unlike tick(), which processes all active calls at once, call completion is handled on a per-call basis. */
			function completeCall(callIndex, isStopped) {
				/* Ensure the call exists. */
				if (!Velocity.State.calls[callIndex]) {
					return false;
				}
	
				/* Pull the metadata from the call. */
				var call = Velocity.State.calls[callIndex][0],
						elements = Velocity.State.calls[callIndex][1],
						opts = Velocity.State.calls[callIndex][2],
						resolver = Velocity.State.calls[callIndex][4];
	
				var remainingCallsExist = false;
	
				/*************************
				 Element Finalization
				 *************************/
	
				for (var i = 0, callLength = call.length; i < callLength; i++) {
					var element = call[i].element;
	
					/* If the user set display to "none" (intending to hide the element), set it now that the animation has completed. */
					/* Note: display:none isn't set when calls are manually stopped (via Velocity("stop"). */
					/* Note: Display gets ignored with "reverse" calls and infinite loops, since this behavior would be undesirable. */
					if (!isStopped && !opts.loop) {
						if (opts.display === "none") {
							CSS.setPropertyValue(element, "display", opts.display);
						}
	
						if (opts.visibility === "hidden") {
							CSS.setPropertyValue(element, "visibility", opts.visibility);
						}
					}
	
					/* If the element's queue is empty (if only the "inprogress" item is left at position 0) or if its queue is about to run
					 a non-Velocity-initiated entry, turn off the isAnimating flag. A non-Velocity-initiatied queue entry's logic might alter
					 an element's CSS values and thereby cause Velocity's cached value data to go stale. To detect if a queue entry was initiated by Velocity,
					 we check for the existence of our special Velocity.queueEntryFlag declaration, which minifiers won't rename since the flag
					 is assigned to jQuery's global $ object and thus exists out of Velocity's own scope. */
					var data = Data(element);
	
					if (opts.loop !== true && ($.queue(element)[1] === undefined || !/\.velocityQueueEntryFlag/i.test($.queue(element)[1]))) {
						/* The element may have been deleted. Ensure that its data cache still exists before acting on it. */
						if (data) {
							data.isAnimating = false;
							/* Clear the element's rootPropertyValueCache, which will become stale. */
							data.rootPropertyValueCache = {};
	
							var transformHAPropertyExists = false;
							/* If any 3D transform subproperty is at its default value (regardless of unit type), remove it. */
							$.each(CSS.Lists.transforms3D, function(i, transformName) {
								var defaultValue = /^scale/.test(transformName) ? 1 : 0,
										currentValue = data.transformCache[transformName];
	
								if (data.transformCache[transformName] !== undefined && new RegExp("^\\(" + defaultValue + "[^.]").test(currentValue)) {
									transformHAPropertyExists = true;
	
									delete data.transformCache[transformName];
								}
							});
	
							/* Mobile devices have hardware acceleration removed at the end of the animation in order to avoid hogging the GPU's memory. */
							if (opts.mobileHA) {
								transformHAPropertyExists = true;
								delete data.transformCache.translate3d;
							}
	
							/* Flush the subproperty removals to the DOM. */
							if (transformHAPropertyExists) {
								CSS.flushTransformCache(element);
							}
	
							/* Remove the "velocity-animating" indicator class. */
							CSS.Values.removeClass(element, "velocity-animating");
						}
					}
	
					/*********************
					 Option: Complete
					 *********************/
	
					/* Complete is fired once per call (not once per element) and is passed the full raw DOM element set as both its context and its first argument. */
					/* Note: Callbacks aren't fired when calls are manually stopped (via Velocity("stop"). */
					if (!isStopped && opts.complete && !opts.loop && (i === callLength - 1)) {
						/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
						try {
							opts.complete.call(elements, elements);
						} catch (error) {
							setTimeout(function() {
								throw error;
							}, 1);
						}
					}
	
					/**********************
					 Promise Resolving
					 **********************/
	
					/* Note: Infinite loops don't return promises. */
					if (resolver && opts.loop !== true) {
						resolver(elements);
					}
	
					/****************************
					 Option: Loop (Infinite)
					 ****************************/
	
					if (data && opts.loop === true && !isStopped) {
						/* If a rotateX/Y/Z property is being animated by 360 deg with loop:true, swap tween start/end values to enable
						 continuous iterative rotation looping. (Otherise, the element would just rotate back and forth.) */
						$.each(data.tweensContainer, function(propertyName, tweenContainer) {
							if (/^rotate/.test(propertyName) && ((parseFloat(tweenContainer.startValue) - parseFloat(tweenContainer.endValue)) % 360 === 0)) {
								var oldStartValue = tweenContainer.startValue;
	
								tweenContainer.startValue = tweenContainer.endValue;
								tweenContainer.endValue = oldStartValue;
							}
	
							if (/^backgroundPosition/.test(propertyName) && parseFloat(tweenContainer.endValue) === 100 && tweenContainer.unitType === "%") {
								tweenContainer.endValue = 0;
								tweenContainer.startValue = 100;
							}
						});
	
						Velocity(element, "reverse", {loop: true, delay: opts.delay});
					}
	
					/***************
					 Dequeueing
					 ***************/
	
					/* Fire the next call in the queue so long as this call's queue wasn't set to false (to trigger a parallel animation),
					 which would have already caused the next call to fire. Note: Even if the end of the animation queue has been reached,
					 $.dequeue() must still be called in order to completely clear jQuery's animation queue. */
					if (opts.queue !== false) {
						$.dequeue(element, opts.queue);
					}
				}
	
				/************************
				 Calls Array Cleanup
				 ************************/
	
				/* Since this call is complete, set it to false so that the rAF tick skips it. This array is later compacted via compactSparseArray().
				 (For performance reasons, the call is set to false instead of being deleted from the array: http://www.html5rocks.com/en/tutorials/speed/v8/) */
				Velocity.State.calls[callIndex] = false;
	
				/* Iterate through the calls array to determine if this was the final in-progress animation.
				 If so, set a flag to end ticking and clear the calls array. */
				for (var j = 0, callsLength = Velocity.State.calls.length; j < callsLength; j++) {
					if (Velocity.State.calls[j] !== false) {
						remainingCallsExist = true;
	
						break;
					}
				}
	
				if (remainingCallsExist === false) {
					/* tick() will detect this flag upon its next iteration and subsequently turn itself off. */
					Velocity.State.isTicking = false;
	
					/* Clear the calls array so that its length is reset. */
					delete Velocity.State.calls;
					Velocity.State.calls = [];
				}
			}
	
			/******************
			 Frameworks
			 ******************/
	
			/* Both jQuery and Zepto allow their $.fn object to be extended to allow wrapped elements to be subjected to plugin calls.
			 If either framework is loaded, register a "velocity" extension pointing to Velocity's core animate() method.  Velocity
			 also registers itself onto a global container (window.jQuery || window.Zepto || window) so that certain features are
			 accessible beyond just a per-element scope. This master object contains an .animate() method, which is later assigned to $.fn
			 (if jQuery or Zepto are present). Accordingly, Velocity can both act on wrapped DOM elements and stand alone for targeting raw DOM elements. */
			global.Velocity = Velocity;
	
			if (global !== window) {
				/* Assign the element function to Velocity's core animate() method. */
				global.fn.velocity = animate;
				/* Assign the object function's defaults to Velocity's global defaults object. */
				global.fn.velocity.defaults = Velocity.defaults;
			}
	
			/***********************
			 Packaged Redirects
			 ***********************/
	
			/* slideUp, slideDown */
			$.each(["Down", "Up"], function(i, direction) {
				Velocity.Redirects["slide" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
					var opts = $.extend({}, options),
							begin = opts.begin,
							complete = opts.complete,
							computedValues = {height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: ""},
					inlineValues = {};
	
					if (opts.display === undefined) {
						/* Show the element before slideDown begins and hide the element after slideUp completes. */
						/* Note: Inline elements cannot have dimensions animated, so they're reverted to inline-block. */
						opts.display = (direction === "Down" ? (Velocity.CSS.Values.getDisplayType(element) === "inline" ? "inline-block" : "block") : "none");
					}
	
					opts.begin = function() {
						/* If the user passed in a begin callback, fire it now. */
						if (begin) {
							begin.call(elements, elements);
						}
	
						/* Cache the elements' original vertical dimensional property values so that we can animate back to them. */
						for (var property in computedValues) {
							if (!computedValues.hasOwnProperty(property)) {
								continue;
							}
							inlineValues[property] = element.style[property];
	
							/* For slideDown, use forcefeeding to animate all vertical properties from 0. For slideUp,
							 use forcefeeding to start from computed values and animate down to 0. */
							var propertyValue = Velocity.CSS.getPropertyValue(element, property);
							computedValues[property] = (direction === "Down") ? [propertyValue, 0] : [0, propertyValue];
						}
	
						/* Force vertical overflow content to clip so that sliding works as expected. */
						inlineValues.overflow = element.style.overflow;
						element.style.overflow = "hidden";
					};
	
					opts.complete = function() {
						/* Reset element to its pre-slide inline values once its slide animation is complete. */
						for (var property in inlineValues) {
							if (inlineValues.hasOwnProperty(property)) {
								element.style[property] = inlineValues[property];
							}
						}
	
						/* If the user passed in a complete callback, fire it now. */
						if (complete) {
							complete.call(elements, elements);
						}
						if (promiseData) {
							promiseData.resolver(elements);
						}
					};
	
					Velocity(element, computedValues, opts);
				};
			});
	
			/* fadeIn, fadeOut */
			$.each(["In", "Out"], function(i, direction) {
				Velocity.Redirects["fade" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
					var opts = $.extend({}, options),
							originalComplete = opts.complete,
							propertiesMap = {opacity: (direction === "In") ? 1 : 0};
	
					/* Since redirects are triggered individually for each element in the animated set, avoid repeatedly triggering
					 callbacks by firing them only when the final element has been reached. */
					if (elementsIndex !== elementsSize - 1) {
						opts.complete = opts.begin = null;
					} else {
						opts.complete = function() {
							if (originalComplete) {
								originalComplete.call(elements, elements);
							}
	
							if (promiseData) {
								promiseData.resolver(elements);
							}
						};
					}
	
					/* If a display was passed in, use it. Otherwise, default to "none" for fadeOut or the element-specific default for fadeIn. */
					/* Note: We allow users to pass in "null" to skip display setting altogether. */
					if (opts.display === undefined) {
						opts.display = (direction === "In" ? "auto" : "none");
					}
	
					Velocity(this, propertiesMap, opts);
				};
			});
	
			return Velocity;
		}((window.jQuery || window.Zepto || window), window, document);
	}));
	
	/******************
	 Known Issues
	 ******************/
	
	/* The CSS spec mandates that the translateX/Y/Z transforms are %-relative to the element itself -- not its parent.
	 Velocity, however, doesn't make this distinction. Thus, converting to or from the % unit with these subproperties
	 will produce an inaccurate conversion value. The same issue exists with the cx/cy attributes of SVG circles and ellipses. */
	


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var pli_1 = __webpack_require__(6);
	var call_1 = __webpack_require__(8);
	pli_1.pli.call = call_1.default;
	if (pli_1.pli.config.isBrowser) {
	    global.Pli = pli_1.pli;
	}
	module.exports = pli_1.pli;
	

	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var $ = __webpack_require__(2);
	var R = __webpack_require__(7);
	var targetEnv = __webpack_require__(3);
	/**
	 * Container for properties and methods that are visible in all child windows
	 * (without having to traverse parent hierarchy). Available as "Pli.global".
	 *
	 * STRONGLY DEPRECATED.
	 * TODO: delete as part of the next major release
	 */
	var PliGlobal = (function () {
	    function PliGlobal() {
	    }
	    return PliGlobal;
	}());
	/**
	 * Describes Pli system used by this client application.
	 */
	var PliSingleton = (function () {
	    /**
	     * Creates a new instance of Pli singleton for the current window.
	     * This Pli instance will be chained to a parent Pli instance (if any).
	     *
	     * Each window will have exactly one instance of this class,
	     * available via "Pli" global variable (this has been deprecated,
	     * please use imports instead).
	     */
	    function PliSingleton(loaderWindow, config) {
	        this.config = config || { appVersion: "", isBrowser: false, rootPath: "" };
	        this.config.appVersion = loaderWindow.PliAppVersion || "";
	        this.config.isBrowser = targetEnv.isBrowser;
	        this.config.rootPath = this.config.rootPath || "";
	        this.loaderWindow = loaderWindow;
	        this.parentPli = (this.config.ignoreParentPli ? null : findAlreadyDefinedPli(loaderWindow));
	        this.rootPli = (this.parentPli ? this.parentPli.rootPli : this);
	        // setup prototype ihneritance chain to parent global object; STRONGLY DEPRECATED
	        // TODO: delete as part of the next major release
	        if (this.parentPli) {
	            PliGlobal.prototype = this.parentPli.global;
	            this.global = new PliGlobal();
	            if (!this.global.config) {
	                this.global = R.merge(this.global, this.parentPli.global || {});
	            }
	        }
	        else {
	            this.global = new PliGlobal();
	            this.global.rootPli = this;
	            this.global.config = R.clone(this.config); // make a copy of window-specific config
	            PliGlobal.prototype.resolveUrl = this.resolveUrl;
	        }
	    }
	    /**
	     * Recursively searches the parent instances looking for one that has the specified property (ignores current instance).
	     * @returns {T}
	     *     The found component (value of the specified property) or null.
	     */
	    PliSingleton.prototype.findComponent = function (key) {
	        var parentPli = this.parentPli;
	        return parentPli ? (parentPli[key] || parentPli.findComponent(key)) : null;
	    };
	    /**
	     * Resolves relative URL path to an absolute path (recognizes "~" and "~~").
	     * - "~" is root of the web application
	     * - "~~" is root of the current context/installation (can be the same as "~")
	     *
	     * Example:
	     *
	     * If rootPath is "/mysite/" and contextRootPath is not defined:
	     * - resolveUrl("~/Page.html") => "/mysite/Page.html"
	     * - resolveUrl("~~/Page.html") => "/mysite/Page.html"
	     *
	     * If root path is "/mysite/" and contextRootPath is "/mysite/japan"
	     * - resolveUrl("~/Page.html") => "/mysite/Page.html"
	     * - resolveUrl("~~/Page.html") => "/mysite/japan/Page.html"
	     */
	    PliSingleton.prototype.resolveUrl = function (url) {
	        var index = 1;
	        var contextRootPath;
	        if (url.length > 0 && url.charAt(0) === "~") {
	            if (url.charAt(1) === "~") {
	                index = 2;
	                contextRootPath = this.config.contextRootPath;
	            }
	            if (url.length > index && (url.charAt(index) === "/" || url.charAt(index) === "\\")) {
	                index = index + 1;
	            }
	            return (contextRootPath
	                ? this.resolveUrl(contextRootPath.concat(url.slice(index)))
	                : (this.config.rootPath || "").concat(url.slice(index)));
	        }
	        return url;
	    };
	    return PliSingleton;
	}());
	exports.PliSingleton = PliSingleton;
	/**
	 * Recursively traverses all parent and opener windows, looking for window.Pli object.
	 * Returns the closest window.Pli object or null if not found.
	 */
	function findAlreadyDefinedPli(wnd) {
	    var found;
	    try {
	        found = wnd.Pli;
	        if (found) {
	            return found;
	        }
	    }
	    catch (ex) {
	        return null;
	    }
	    if (wnd.parent && wnd.parent !== wnd) {
	        found = findAlreadyDefinedPli(wnd.parent);
	        if (found) {
	            return found;
	        }
	    }
	    if (wnd.opener) {
	        found = findAlreadyDefinedPli(wnd.opener);
	        if (found) {
	            return found;
	        }
	    }
	    if (wnd.dialogArguments) {
	        if (wnd.dialogArguments.parentPli) {
	            return wnd.dialogArguments.parentPli;
	        }
	        if (wnd.dialogArguments.Window) {
	            return findAlreadyDefinedPli(wnd.dialogArguments.Window);
	        }
	    }
	    return null;
	}
	exports.pli = new PliSingleton(global, targetEnv.isBrowser ? $("body").data("pliConfig") : null);
	

	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	//  Ramda v0.19.1
	//  https://github.com/ramda/ramda
	//  (c) 2013-2016 Scott Sauyet, Michael Hurley, and David Chambers
	//  Ramda may be freely distributed under the MIT license.
	
	;(function() {
	
	  'use strict';
	
	  /**
	     * A special placeholder value used to specify "gaps" within curried functions,
	     * allowing partial application of any combination of arguments, regardless of
	     * their positions.
	     *
	     * If `g` is a curried ternary function and `_` is `R.__`, the following are
	     * equivalent:
	     *
	     *   - `g(1, 2, 3)`
	     *   - `g(_, 2, 3)(1)`
	     *   - `g(_, _, 3)(1)(2)`
	     *   - `g(_, _, 3)(1, 2)`
	     *   - `g(_, 2, _)(1, 3)`
	     *   - `g(_, 2)(1)(3)`
	     *   - `g(_, 2)(1, 3)`
	     *   - `g(_, 2)(_, 3)(1)`
	     *
	     * @constant
	     * @memberOf R
	     * @since v0.6.0
	     * @category Function
	     * @example
	     *
	     *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
	     *      greet('Alice'); //=> 'Hello, Alice!'
	     */
	    var __ = { '@@functional/placeholder': true };
	
	    /* eslint-disable no-unused-vars */
	    var _arity = function _arity(n, fn) {
	        /* eslint-disable no-unused-vars */
	        switch (n) {
	        case 0:
	            return function () {
	                return fn.apply(this, arguments);
	            };
	        case 1:
	            return function (a0) {
	                return fn.apply(this, arguments);
	            };
	        case 2:
	            return function (a0, a1) {
	                return fn.apply(this, arguments);
	            };
	        case 3:
	            return function (a0, a1, a2) {
	                return fn.apply(this, arguments);
	            };
	        case 4:
	            return function (a0, a1, a2, a3) {
	                return fn.apply(this, arguments);
	            };
	        case 5:
	            return function (a0, a1, a2, a3, a4) {
	                return fn.apply(this, arguments);
	            };
	        case 6:
	            return function (a0, a1, a2, a3, a4, a5) {
	                return fn.apply(this, arguments);
	            };
	        case 7:
	            return function (a0, a1, a2, a3, a4, a5, a6) {
	                return fn.apply(this, arguments);
	            };
	        case 8:
	            return function (a0, a1, a2, a3, a4, a5, a6, a7) {
	                return fn.apply(this, arguments);
	            };
	        case 9:
	            return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
	                return fn.apply(this, arguments);
	            };
	        case 10:
	            return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
	                return fn.apply(this, arguments);
	            };
	        default:
	            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	        }
	    };
	
	    var _arrayFromIterator = function _arrayFromIterator(iter) {
	        var list = [];
	        var next;
	        while (!(next = iter.next()).done) {
	            list.push(next.value);
	        }
	        return list;
	    };
	
	    var _cloneRegExp = function _cloneRegExp(pattern) {
	        return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
	    };
	
	    var _complement = function _complement(f) {
	        return function () {
	            return !f.apply(this, arguments);
	        };
	    };
	
	    /**
	     * Private `concat` function to merge two array-like objects.
	     *
	     * @private
	     * @param {Array|Arguments} [set1=[]] An array-like object.
	     * @param {Array|Arguments} [set2=[]] An array-like object.
	     * @return {Array} A new, merged array.
	     * @example
	     *
	     *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	     */
	    var _concat = function _concat(set1, set2) {
	        set1 = set1 || [];
	        set2 = set2 || [];
	        var idx;
	        var len1 = set1.length;
	        var len2 = set2.length;
	        var result = [];
	        idx = 0;
	        while (idx < len1) {
	            result[result.length] = set1[idx];
	            idx += 1;
	        }
	        idx = 0;
	        while (idx < len2) {
	            result[result.length] = set2[idx];
	            idx += 1;
	        }
	        return result;
	    };
	
	    var _containsWith = function _containsWith(pred, x, list) {
	        var idx = 0;
	        var len = list.length;
	        while (idx < len) {
	            if (pred(x, list[idx])) {
	                return true;
	            }
	            idx += 1;
	        }
	        return false;
	    };
	
	    var _filter = function _filter(fn, list) {
	        var idx = 0;
	        var len = list.length;
	        var result = [];
	        while (idx < len) {
	            if (fn(list[idx])) {
	                result[result.length] = list[idx];
	            }
	            idx += 1;
	        }
	        return result;
	    };
	
	    var _forceReduced = function _forceReduced(x) {
	        return {
	            '@@transducer/value': x,
	            '@@transducer/reduced': true
	        };
	    };
	
	    var _has = function _has(prop, obj) {
	        return Object.prototype.hasOwnProperty.call(obj, prop);
	    };
	
	    var _identity = function _identity(x) {
	        return x;
	    };
	
	    var _isArguments = function () {
	        var toString = Object.prototype.toString;
	        return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
	            return toString.call(x) === '[object Arguments]';
	        } : function _isArguments(x) {
	            return _has('callee', x);
	        };
	    }();
	
	    /**
	     * Tests whether or not an object is an array.
	     *
	     * @private
	     * @param {*} val The object to test.
	     * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	     * @example
	     *
	     *      _isArray([]); //=> true
	     *      _isArray(null); //=> false
	     *      _isArray({}); //=> false
	     */
	    var _isArray = Array.isArray || function _isArray(val) {
	        return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
	    };
	
	    /**
	     * Determine if the passed argument is an integer.
	     *
	     * @private
	     * @param {*} n
	     * @category Type
	     * @return {Boolean}
	     */
	    var _isInteger = Number.isInteger || function _isInteger(n) {
	        return n << 0 === n;
	    };
	
	    var _isNumber = function _isNumber(x) {
	        return Object.prototype.toString.call(x) === '[object Number]';
	    };
	
	    var _isObject = function _isObject(x) {
	        return Object.prototype.toString.call(x) === '[object Object]';
	    };
	
	    var _isPlaceholder = function _isPlaceholder(a) {
	        return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
	    };
	
	    var _isRegExp = function _isRegExp(x) {
	        return Object.prototype.toString.call(x) === '[object RegExp]';
	    };
	
	    var _isString = function _isString(x) {
	        return Object.prototype.toString.call(x) === '[object String]';
	    };
	
	    var _isTransformer = function _isTransformer(obj) {
	        return typeof obj['@@transducer/step'] === 'function';
	    };
	
	    var _map = function _map(fn, functor) {
	        var idx = 0;
	        var len = functor.length;
	        var result = Array(len);
	        while (idx < len) {
	            result[idx] = fn(functor[idx]);
	            idx += 1;
	        }
	        return result;
	    };
	
	    var _of = function _of(x) {
	        return [x];
	    };
	
	    var _pipe = function _pipe(f, g) {
	        return function () {
	            return g.call(this, f.apply(this, arguments));
	        };
	    };
	
	    var _pipeP = function _pipeP(f, g) {
	        return function () {
	            var ctx = this;
	            return f.apply(ctx, arguments).then(function (x) {
	                return g.call(ctx, x);
	            });
	        };
	    };
	
	    // \b matches word boundary; [\b] matches backspace
	    var _quote = function _quote(s) {
	        var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b')    // \b matches word boundary; [\b] matches backspace
	    .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
	        return '"' + escaped.replace(/"/g, '\\"') + '"';
	    };
	
	    var _reduced = function _reduced(x) {
	        return x && x['@@transducer/reduced'] ? x : {
	            '@@transducer/value': x,
	            '@@transducer/reduced': true
	        };
	    };
	
	    /**
	     * An optimized, private array `slice` implementation.
	     *
	     * @private
	     * @param {Arguments|Array} args The array or arguments object to consider.
	     * @param {Number} [from=0] The array index to slice from, inclusive.
	     * @param {Number} [to=args.length] The array index to slice to, exclusive.
	     * @return {Array} A new, sliced array.
	     * @example
	     *
	     *      _slice([1, 2, 3, 4, 5], 1, 3); //=> [2, 3]
	     *
	     *      var firstThreeArgs = function(a, b, c, d) {
	     *        return _slice(arguments, 0, 3);
	     *      };
	     *      firstThreeArgs(1, 2, 3, 4); //=> [1, 2, 3]
	     */
	    var _slice = function _slice(args, from, to) {
	        switch (arguments.length) {
	        case 1:
	            return _slice(args, 0, args.length);
	        case 2:
	            return _slice(args, from, args.length);
	        default:
	            var list = [];
	            var idx = 0;
	            var len = Math.max(0, Math.min(args.length, to) - from);
	            while (idx < len) {
	                list[idx] = args[from + idx];
	                idx += 1;
	            }
	            return list;
	        }
	    };
	
	    /**
	     * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	     */
	    var _toISOString = function () {
	        var pad = function pad(n) {
	            return (n < 10 ? '0' : '') + n;
	        };
	        return typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
	            return d.toISOString();
	        } : function _toISOString(d) {
	            return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
	        };
	    }();
	
	    var _xfBase = {
	        init: function () {
	            return this.xf['@@transducer/init']();
	        },
	        result: function (result) {
	            return this.xf['@@transducer/result'](result);
	        }
	    };
	
	    var _xwrap = function () {
	        function XWrap(fn) {
	            this.f = fn;
	        }
	        XWrap.prototype['@@transducer/init'] = function () {
	            throw new Error('init not implemented on XWrap');
	        };
	        XWrap.prototype['@@transducer/result'] = function (acc) {
	            return acc;
	        };
	        XWrap.prototype['@@transducer/step'] = function (acc, x) {
	            return this.f(acc, x);
	        };
	        return function _xwrap(fn) {
	            return new XWrap(fn);
	        };
	    }();
	
	    var _aperture = function _aperture(n, list) {
	        var idx = 0;
	        var limit = list.length - (n - 1);
	        var acc = new Array(limit >= 0 ? limit : 0);
	        while (idx < limit) {
	            acc[idx] = _slice(list, idx, idx + n);
	            idx += 1;
	        }
	        return acc;
	    };
	
	    /**
	     * Similar to hasMethod, this checks whether a function has a [methodname]
	     * function. If it isn't an array it will execute that function otherwise it
	     * will default to the ramda implementation.
	     *
	     * @private
	     * @param {Function} fn ramda implemtation
	     * @param {String} methodname property to check for a custom implementation
	     * @return {Object} Whatever the return value of the method is.
	     */
	    var _checkForMethod = function _checkForMethod(methodname, fn) {
	        return function () {
	            var length = arguments.length;
	            if (length === 0) {
	                return fn();
	            }
	            var obj = arguments[length - 1];
	            return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, _slice(arguments, 0, length - 1));
	        };
	    };
	
	    /**
	     * Optimized internal one-arity curry function.
	     *
	     * @private
	     * @category Function
	     * @param {Function} fn The function to curry.
	     * @return {Function} The curried function.
	     */
	    var _curry1 = function _curry1(fn) {
	        return function f1(a) {
	            if (arguments.length === 0 || _isPlaceholder(a)) {
	                return f1;
	            } else {
	                return fn.apply(this, arguments);
	            }
	        };
	    };
	
	    /**
	     * Optimized internal two-arity curry function.
	     *
	     * @private
	     * @category Function
	     * @param {Function} fn The function to curry.
	     * @return {Function} The curried function.
	     */
	    var _curry2 = function _curry2(fn) {
	        return function f2(a, b) {
	            switch (arguments.length) {
	            case 0:
	                return f2;
	            case 1:
	                return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
	                    return fn(a, _b);
	                });
	            default:
	                return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
	                    return fn(_a, b);
	                }) : _isPlaceholder(b) ? _curry1(function (_b) {
	                    return fn(a, _b);
	                }) : fn(a, b);
	            }
	        };
	    };
	
	    /**
	     * Optimized internal three-arity curry function.
	     *
	     * @private
	     * @category Function
	     * @param {Function} fn The function to curry.
	     * @return {Function} The curried function.
	     */
	    var _curry3 = function _curry3(fn) {
	        return function f3(a, b, c) {
	            switch (arguments.length) {
	            case 0:
	                return f3;
	            case 1:
	                return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
	                    return fn(a, _b, _c);
	                });
	            case 2:
	                return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
	                    return fn(_a, b, _c);
	                }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
	                    return fn(a, _b, _c);
	                }) : _curry1(function (_c) {
	                    return fn(a, b, _c);
	                });
	            default:
	                return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
	                    return fn(_a, _b, c);
	                }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
	                    return fn(_a, b, _c);
	                }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
	                    return fn(a, _b, _c);
	                }) : _isPlaceholder(a) ? _curry1(function (_a) {
	                    return fn(_a, b, c);
	                }) : _isPlaceholder(b) ? _curry1(function (_b) {
	                    return fn(a, _b, c);
	                }) : _isPlaceholder(c) ? _curry1(function (_c) {
	                    return fn(a, b, _c);
	                }) : fn(a, b, c);
	            }
	        };
	    };
	
	    /**
	     * Internal curryN function.
	     *
	     * @private
	     * @category Function
	     * @param {Number} length The arity of the curried function.
	     * @param {Array} received An array of arguments received thus far.
	     * @param {Function} fn The function to curry.
	     * @return {Function} The curried function.
	     */
	    var _curryN = function _curryN(length, received, fn) {
	        return function () {
	            var combined = [];
	            var argsIdx = 0;
	            var left = length;
	            var combinedIdx = 0;
	            while (combinedIdx < received.length || argsIdx < arguments.length) {
	                var result;
	                if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
	                    result = received[combinedIdx];
	                } else {
	                    result = arguments[argsIdx];
	                    argsIdx += 1;
	                }
	                combined[combinedIdx] = result;
	                if (!_isPlaceholder(result)) {
	                    left -= 1;
	                }
	                combinedIdx += 1;
	            }
	            return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
	        };
	    };
	
	    /**
	     * Returns a function that dispatches with different strategies based on the
	     * object in list position (last argument). If it is an array, executes [fn].
	     * Otherwise, if it has a function with [methodname], it will execute that
	     * function (functor case). Otherwise, if it is a transformer, uses transducer
	     * [xf] to return a new transformer (transducer case). Otherwise, it will
	     * default to executing [fn].
	     *
	     * @private
	     * @param {String} methodname property to check for a custom implementation
	     * @param {Function} xf transducer to initialize if object is transformer
	     * @param {Function} fn default ramda implementation
	     * @return {Function} A function that dispatches on object in list position
	     */
	    var _dispatchable = function _dispatchable(methodname, xf, fn) {
	        return function () {
	            var length = arguments.length;
	            if (length === 0) {
	                return fn();
	            }
	            var obj = arguments[length - 1];
	            if (!_isArray(obj)) {
	                var args = _slice(arguments, 0, length - 1);
	                if (typeof obj[methodname] === 'function') {
	                    return obj[methodname].apply(obj, args);
	                }
	                if (_isTransformer(obj)) {
	                    var transducer = xf.apply(null, args);
	                    return transducer(obj);
	                }
	            }
	            return fn.apply(this, arguments);
	        };
	    };
	
	    var _dropLastWhile = function dropLastWhile(pred, list) {
	        var idx = list.length - 1;
	        while (idx >= 0 && pred(list[idx])) {
	            idx -= 1;
	        }
	        return _slice(list, 0, idx + 1);
	    };
	
	    var _xall = function () {
	        function XAll(f, xf) {
	            this.xf = xf;
	            this.f = f;
	            this.all = true;
	        }
	        XAll.prototype['@@transducer/init'] = _xfBase.init;
	        XAll.prototype['@@transducer/result'] = function (result) {
	            if (this.all) {
	                result = this.xf['@@transducer/step'](result, true);
	            }
	            return this.xf['@@transducer/result'](result);
	        };
	        XAll.prototype['@@transducer/step'] = function (result, input) {
	            if (!this.f(input)) {
	                this.all = false;
	                result = _reduced(this.xf['@@transducer/step'](result, false));
	            }
	            return result;
	        };
	        return _curry2(function _xall(f, xf) {
	            return new XAll(f, xf);
	        });
	    }();
	
	    var _xany = function () {
	        function XAny(f, xf) {
	            this.xf = xf;
	            this.f = f;
	            this.any = false;
	        }
	        XAny.prototype['@@transducer/init'] = _xfBase.init;
	        XAny.prototype['@@transducer/result'] = function (result) {
	            if (!this.any) {
	                result = this.xf['@@transducer/step'](result, false);
	            }
	            return this.xf['@@transducer/result'](result);
	        };
	        XAny.prototype['@@transducer/step'] = function (result, input) {
	            if (this.f(input)) {
	                this.any = true;
	                result = _reduced(this.xf['@@transducer/step'](result, true));
	            }
	            return result;
	        };
	        return _curry2(function _xany(f, xf) {
	            return new XAny(f, xf);
	        });
	    }();
	
	    var _xaperture = function () {
	        function XAperture(n, xf) {
	            this.xf = xf;
	            this.pos = 0;
	            this.full = false;
	            this.acc = new Array(n);
	        }
	        XAperture.prototype['@@transducer/init'] = _xfBase.init;
	        XAperture.prototype['@@transducer/result'] = function (result) {
	            this.acc = null;
	            return this.xf['@@transducer/result'](result);
	        };
	        XAperture.prototype['@@transducer/step'] = function (result, input) {
	            this.store(input);
	            return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
	        };
	        XAperture.prototype.store = function (input) {
	            this.acc[this.pos] = input;
	            this.pos += 1;
	            if (this.pos === this.acc.length) {
	                this.pos = 0;
	                this.full = true;
	            }
	        };
	        XAperture.prototype.getCopy = function () {
	            return _concat(_slice(this.acc, this.pos), _slice(this.acc, 0, this.pos));
	        };
	        return _curry2(function _xaperture(n, xf) {
	            return new XAperture(n, xf);
	        });
	    }();
	
	    var _xdrop = function () {
	        function XDrop(n, xf) {
	            this.xf = xf;
	            this.n = n;
	        }
	        XDrop.prototype['@@transducer/init'] = _xfBase.init;
	        XDrop.prototype['@@transducer/result'] = _xfBase.result;
	        XDrop.prototype['@@transducer/step'] = function (result, input) {
	            if (this.n > 0) {
	                this.n -= 1;
	                return result;
	            }
	            return this.xf['@@transducer/step'](result, input);
	        };
	        return _curry2(function _xdrop(n, xf) {
	            return new XDrop(n, xf);
	        });
	    }();
	
	    var _xdropLast = function () {
	        function XDropLast(n, xf) {
	            this.xf = xf;
	            this.pos = 0;
	            this.full = false;
	            this.acc = new Array(n);
	        }
	        XDropLast.prototype['@@transducer/init'] = _xfBase.init;
	        XDropLast.prototype['@@transducer/result'] = function (result) {
	            this.acc = null;
	            return this.xf['@@transducer/result'](result);
	        };
	        XDropLast.prototype['@@transducer/step'] = function (result, input) {
	            if (this.full) {
	                result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
	            }
	            this.store(input);
	            return result;
	        };
	        XDropLast.prototype.store = function (input) {
	            this.acc[this.pos] = input;
	            this.pos += 1;
	            if (this.pos === this.acc.length) {
	                this.pos = 0;
	                this.full = true;
	            }
	        };
	        return _curry2(function _xdropLast(n, xf) {
	            return new XDropLast(n, xf);
	        });
	    }();
	
	    var _xdropRepeatsWith = function () {
	        function XDropRepeatsWith(pred, xf) {
	            this.xf = xf;
	            this.pred = pred;
	            this.lastValue = undefined;
	            this.seenFirstValue = false;
	        }
	        XDropRepeatsWith.prototype['@@transducer/init'] = function () {
	            return this.xf['@@transducer/init']();
	        };
	        XDropRepeatsWith.prototype['@@transducer/result'] = function (result) {
	            return this.xf['@@transducer/result'](result);
	        };
	        XDropRepeatsWith.prototype['@@transducer/step'] = function (result, input) {
	            var sameAsLast = false;
	            if (!this.seenFirstValue) {
	                this.seenFirstValue = true;
	            } else if (this.pred(this.lastValue, input)) {
	                sameAsLast = true;
	            }
	            this.lastValue = input;
	            return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	        };
	        return _curry2(function _xdropRepeatsWith(pred, xf) {
	            return new XDropRepeatsWith(pred, xf);
	        });
	    }();
	
	    var _xdropWhile = function () {
	        function XDropWhile(f, xf) {
	            this.xf = xf;
	            this.f = f;
	        }
	        XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
	        XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
	        XDropWhile.prototype['@@transducer/step'] = function (result, input) {
	            if (this.f) {
	                if (this.f(input)) {
	                    return result;
	                }
	                this.f = null;
	            }
	            return this.xf['@@transducer/step'](result, input);
	        };
	        return _curry2(function _xdropWhile(f, xf) {
	            return new XDropWhile(f, xf);
	        });
	    }();
	
	    var _xfilter = function () {
	        function XFilter(f, xf) {
	            this.xf = xf;
	            this.f = f;
	        }
	        XFilter.prototype['@@transducer/init'] = _xfBase.init;
	        XFilter.prototype['@@transducer/result'] = _xfBase.result;
	        XFilter.prototype['@@transducer/step'] = function (result, input) {
	            return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	        };
	        return _curry2(function _xfilter(f, xf) {
	            return new XFilter(f, xf);
	        });
	    }();
	
	    var _xfind = function () {
	        function XFind(f, xf) {
	            this.xf = xf;
	            this.f = f;
	            this.found = false;
	        }
	        XFind.prototype['@@transducer/init'] = _xfBase.init;
	        XFind.prototype['@@transducer/result'] = function (result) {
	            if (!this.found) {
	                result = this.xf['@@transducer/step'](result, void 0);
	            }
	            return this.xf['@@transducer/result'](result);
	        };
	        XFind.prototype['@@transducer/step'] = function (result, input) {
	            if (this.f(input)) {
	                this.found = true;
	                result = _reduced(this.xf['@@transducer/step'](result, input));
	            }
	            return result;
	        };
	        return _curry2(function _xfind(f, xf) {
	            return new XFind(f, xf);
	        });
	    }();
	
	    var _xfindIndex = function () {
	        function XFindIndex(f, xf) {
	            this.xf = xf;
	            this.f = f;
	            this.idx = -1;
	            this.found = false;
	        }
	        XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
	        XFindIndex.prototype['@@transducer/result'] = function (result) {
	            if (!this.found) {
	                result = this.xf['@@transducer/step'](result, -1);
	            }
	            return this.xf['@@transducer/result'](result);
	        };
	        XFindIndex.prototype['@@transducer/step'] = function (result, input) {
	            this.idx += 1;
	            if (this.f(input)) {
	                this.found = true;
	                result = _reduced(this.xf['@@transducer/step'](result, this.idx));
	            }
	            return result;
	        };
	        return _curry2(function _xfindIndex(f, xf) {
	            return new XFindIndex(f, xf);
	        });
	    }();
	
	    var _xfindLast = function () {
	        function XFindLast(f, xf) {
	            this.xf = xf;
	            this.f = f;
	        }
	        XFindLast.prototype['@@transducer/init'] = _xfBase.init;
	        XFindLast.prototype['@@transducer/result'] = function (result) {
	            return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
	        };
	        XFindLast.prototype['@@transducer/step'] = function (result, input) {
	            if (this.f(input)) {
	                this.last = input;
	            }
	            return result;
	        };
	        return _curry2(function _xfindLast(f, xf) {
	            return new XFindLast(f, xf);
	        });
	    }();
	
	    var _xfindLastIndex = function () {
	        function XFindLastIndex(f, xf) {
	            this.xf = xf;
	            this.f = f;
	            this.idx = -1;
	            this.lastIdx = -1;
	        }
	        XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
	        XFindLastIndex.prototype['@@transducer/result'] = function (result) {
	            return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
	        };
	        XFindLastIndex.prototype['@@transducer/step'] = function (result, input) {
	            this.idx += 1;
	            if (this.f(input)) {
	                this.lastIdx = this.idx;
	            }
	            return result;
	        };
	        return _curry2(function _xfindLastIndex(f, xf) {
	            return new XFindLastIndex(f, xf);
	        });
	    }();
	
	    var _xmap = function () {
	        function XMap(f, xf) {
	            this.xf = xf;
	            this.f = f;
	        }
	        XMap.prototype['@@transducer/init'] = _xfBase.init;
	        XMap.prototype['@@transducer/result'] = _xfBase.result;
	        XMap.prototype['@@transducer/step'] = function (result, input) {
	            return this.xf['@@transducer/step'](result, this.f(input));
	        };
	        return _curry2(function _xmap(f, xf) {
	            return new XMap(f, xf);
	        });
	    }();
	
	    var _xtake = function () {
	        function XTake(n, xf) {
	            this.xf = xf;
	            this.n = n;
	        }
	        XTake.prototype['@@transducer/init'] = _xfBase.init;
	        XTake.prototype['@@transducer/result'] = _xfBase.result;
	        XTake.prototype['@@transducer/step'] = function (result, input) {
	            if (this.n === 0) {
	                return _reduced(result);
	            } else {
	                this.n -= 1;
	                return this.xf['@@transducer/step'](result, input);
	            }
	        };
	        return _curry2(function _xtake(n, xf) {
	            return new XTake(n, xf);
	        });
	    }();
	
	    var _xtakeWhile = function () {
	        function XTakeWhile(f, xf) {
	            this.xf = xf;
	            this.f = f;
	        }
	        XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
	        XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
	        XTakeWhile.prototype['@@transducer/step'] = function (result, input) {
	            return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
	        };
	        return _curry2(function _xtakeWhile(f, xf) {
	            return new XTakeWhile(f, xf);
	        });
	    }();
	
	    /**
	     * Adds two numbers. Equivalent to `a + b` but curried.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Math
	     * @sig Number -> Number -> Number
	     * @param {Number} a
	     * @param {Number} b
	     * @return {Number}
	     * @see R.subtract
	     * @example
	     *
	     *      R.add(2, 3);       //=>  5
	     *      R.add(7)(10);      //=> 17
	     */
	    var add = _curry2(function add(a, b) {
	        return a + b;
	    });
	
	    /**
	     * Applies a function to the value at the given index of an array, returning a
	     * new copy of the array with the element at the given index replaced with the
	     * result of the function application.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category List
	     * @sig (a -> a) -> Number -> [a] -> [a]
	     * @param {Function} fn The function to apply.
	     * @param {Number} idx The index.
	     * @param {Array|Arguments} list An array-like object whose value
	     *        at the supplied index will be replaced.
	     * @return {Array} A copy of the supplied array-like object with
	     *         the element at index `idx` replaced with the value
	     *         returned by applying `fn` to the existing element.
	     * @see R.update
	     * @example
	     *
	     *      R.adjust(R.add(10), 1, [0, 1, 2]);     //=> [0, 11, 2]
	     *      R.adjust(R.add(10))(1)([0, 1, 2]);     //=> [0, 11, 2]
	     */
	    var adjust = _curry3(function adjust(fn, idx, list) {
	        if (idx >= list.length || idx < -list.length) {
	            return list;
	        }
	        var start = idx < 0 ? list.length : 0;
	        var _idx = start + idx;
	        var _list = _concat(list);
	        _list[_idx] = fn(list[_idx]);
	        return _list;
	    });
	
	    /**
	     * Returns `true` if all elements of the list match the predicate, `false` if
	     * there are any that don't.
	     *
	     * Dispatches to the `all` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> Boolean
	     * @param {Function} fn The predicate function.
	     * @param {Array} list The array to consider.
	     * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
	     *         otherwise.
	     * @see R.any, R.none, R.transduce
	     * @example
	     *
	     *      var lessThan2 = R.flip(R.lt)(2);
	     *      var lessThan3 = R.flip(R.lt)(3);
	     *      R.all(lessThan2)([1, 2]); //=> false
	     *      R.all(lessThan3)([1, 2]); //=> true
	     */
	    var all = _curry2(_dispatchable('all', _xall, function all(fn, list) {
	        var idx = 0;
	        while (idx < list.length) {
	            if (!fn(list[idx])) {
	                return false;
	            }
	            idx += 1;
	        }
	        return true;
	    }));
	
	    /**
	     * Returns a function that always returns the given value. Note that for
	     * non-primitives the value returned is a reference to the original value.
	     *
	     * This function is known as `const`, `constant`, or `K` (for K combinator) in
	     * other languages and libraries.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig a -> (* -> a)
	     * @param {*} val The value to wrap in a function
	     * @return {Function} A Function :: * -> val.
	     * @example
	     *
	     *      var t = R.always('Tee');
	     *      t(); //=> 'Tee'
	     */
	    var always = _curry1(function always(val) {
	        return function () {
	            return val;
	        };
	    });
	
	    /**
	     * Returns `true` if both arguments are `true`; `false` otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Logic
	     * @sig * -> * -> *
	     * @param {Boolean} a A boolean value
	     * @param {Boolean} b A boolean value
	     * @return {Boolean} `true` if both arguments are `true`, `false` otherwise
	     * @see R.both
	     * @example
	     *
	     *      R.and(true, true); //=> true
	     *      R.and(true, false); //=> false
	     *      R.and(false, true); //=> false
	     *      R.and(false, false); //=> false
	     */
	    var and = _curry2(function and(a, b) {
	        return a && b;
	    });
	
	    /**
	     * Returns `true` if at least one of elements of the list match the predicate,
	     * `false` otherwise.
	     *
	     * Dispatches to the `any` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> Boolean
	     * @param {Function} fn The predicate function.
	     * @param {Array} list The array to consider.
	     * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	     *         otherwise.
	     * @see R.all, R.none, R.transduce
	     * @example
	     *
	     *      var lessThan0 = R.flip(R.lt)(0);
	     *      var lessThan2 = R.flip(R.lt)(2);
	     *      R.any(lessThan0)([1, 2]); //=> false
	     *      R.any(lessThan2)([1, 2]); //=> true
	     */
	    var any = _curry2(_dispatchable('any', _xany, function any(fn, list) {
	        var idx = 0;
	        while (idx < list.length) {
	            if (fn(list[idx])) {
	                return true;
	            }
	            idx += 1;
	        }
	        return false;
	    }));
	
	    /**
	     * Returns a new list, composed of n-tuples of consecutive elements If `n` is
	     * greater than the length of the list, an empty list is returned.
	     *
	     * Dispatches to the `aperture` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.12.0
	     * @category List
	     * @sig Number -> [a] -> [[a]]
	     * @param {Number} n The size of the tuples to create
	     * @param {Array} list The list to split into `n`-tuples
	     * @return {Array} The new list.
	     * @see R.transduce
	     * @example
	     *
	     *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
	     *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
	     *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
	     */
	    var aperture = _curry2(_dispatchable('aperture', _xaperture, _aperture));
	
	    /**
	     * Returns a new list containing the contents of the given list, followed by
	     * the given element.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig a -> [a] -> [a]
	     * @param {*} el The element to add to the end of the new list.
	     * @param {Array} list The list whose contents will be added to the beginning of the output
	     *        list.
	     * @return {Array} A new list containing the contents of the old list followed by `el`.
	     * @see R.prepend
	     * @example
	     *
	     *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	     *      R.append('tests', []); //=> ['tests']
	     *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	     */
	    var append = _curry2(function append(el, list) {
	        return _concat(list, [el]);
	    });
	
	    /**
	     * Applies function `fn` to the argument list `args`. This is useful for
	     * creating a fixed-arity function from a variadic function. `fn` should be a
	     * bound function if context is significant.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.7.0
	     * @category Function
	     * @sig (*... -> a) -> [*] -> a
	     * @param {Function} fn
	     * @param {Array} args
	     * @return {*}
	     * @see R.call, R.unapply
	     * @example
	     *
	     *      var nums = [1, 2, 3, -99, 42, 6, 7];
	     *      R.apply(Math.max, nums); //=> 42
	     */
	    var apply = _curry2(function apply(fn, args) {
	        return fn.apply(this, args);
	    });
	
	    /**
	     * Makes a shallow clone of an object, setting or overriding the specified
	     * property with the given value. Note that this copies and flattens prototype
	     * properties onto the new object as well. All non-primitive properties are
	     * copied by reference.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category Object
	     * @sig String -> a -> {k: v} -> {k: v}
	     * @param {String} prop the property name to set
	     * @param {*} val the new value
	     * @param {Object} obj the object to clone
	     * @return {Object} a new object similar to the original except for the specified property.
	     * @see R.dissoc
	     * @example
	     *
	     *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	     */
	    var assoc = _curry3(function assoc(prop, val, obj) {
	        var result = {};
	        for (var p in obj) {
	            result[p] = obj[p];
	        }
	        result[prop] = val;
	        return result;
	    });
	
	    /**
	     * Makes a shallow clone of an object, setting or overriding the nodes required
	     * to create the given path, and placing the specific value at the tail end of
	     * that path. Note that this copies and flattens prototype properties onto the
	     * new object as well. All non-primitive properties are copied by reference.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category Object
	     * @sig [String] -> a -> {k: v} -> {k: v}
	     * @param {Array} path the path to set
	     * @param {*} val the new value
	     * @param {Object} obj the object to clone
	     * @return {Object} a new object similar to the original except along the specified path.
	     * @see R.dissocPath
	     * @example
	     *
	     *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	     */
	    var assocPath = _curry3(function assocPath(path, val, obj) {
	        switch (path.length) {
	        case 0:
	            return val;
	        case 1:
	            return assoc(path[0], val, obj);
	        default:
	            return assoc(path[0], assocPath(_slice(path, 1), val, Object(obj[path[0]])), obj);
	        }
	    });
	
	    /**
	     * Creates a function that is bound to a context.
	     * Note: `R.bind` does not provide the additional argument-binding capabilities of
	     * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	     *
	     * @func
	     * @memberOf R
	     * @since v0.6.0
	     * @category Function
	     * @category Object
	     * @sig (* -> *) -> {*} -> (* -> *)
	     * @param {Function} fn The function to bind to context
	     * @param {Object} thisObj The context to bind `fn` to
	     * @return {Function} A function that will execute in the context of `thisObj`.
	     * @see R.partial
	     */
	    var bind = _curry2(function bind(fn, thisObj) {
	        return _arity(fn.length, function () {
	            return fn.apply(thisObj, arguments);
	        });
	    });
	
	    /**
	     * A function wrapping calls to the two functions in an `&&` operation,
	     * returning the result of the first function if it is false-y and the result
	     * of the second function otherwise. Note that this is short-circuited,
	     * meaning that the second function will not be invoked if the first returns a
	     * false-y value.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.12.0
	     * @category Logic
	     * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	     * @param {Function} f a predicate
	     * @param {Function} g another predicate
	     * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	     * @see R.and
	     * @example
	     *
	     *      var gt10 = x => x > 10;
	     *      var even = x => x % 2 === 0;
	     *      var f = R.both(gt10, even);
	     *      f(100); //=> true
	     *      f(101); //=> false
	     */
	    var both = _curry2(function both(f, g) {
	        return function _both() {
	            return f.apply(this, arguments) && g.apply(this, arguments);
	        };
	    });
	
	    /**
	     * Makes a comparator function out of a function that reports whether the first
	     * element is less than the second.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig (a, b -> Boolean) -> (a, b -> Number)
	     * @param {Function} pred A predicate function of arity two.
	     * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`.
	     * @example
	     *
	     *      var cmp = R.comparator((a, b) => a.age < b.age);
	     *      var people = [
	     *        // ...
	     *      ];
	     *      R.sort(cmp, people);
	     */
	    var comparator = _curry1(function comparator(pred) {
	        return function (a, b) {
	            return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
	        };
	    });
	
	    /**
	     * Returns a function, `fn`, which encapsulates if/else-if/else logic.
	     * `R.cond` takes a list of [predicate, transform] pairs. All of the arguments
	     * to `fn` are applied to each of the predicates in turn until one returns a
	     * "truthy" value, at which point `fn` returns the result of applying its
	     * arguments to the corresponding transformer. If none of the predicates
	     * matches, `fn` returns undefined.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.6.0
	     * @category Logic
	     * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
	     * @param {Array} pairs
	     * @return {Function}
	     * @example
	     *
	     *      var fn = R.cond([
	     *        [R.equals(0),   R.always('water freezes at 0°C')],
	     *        [R.equals(100), R.always('water boils at 100°C')],
	     *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
	     *      ]);
	     *      fn(0); //=> 'water freezes at 0°C'
	     *      fn(50); //=> 'nothing special happens at 50°C'
	     *      fn(100); //=> 'water boils at 100°C'
	     */
	    var cond = _curry1(function cond(pairs) {
	        return function () {
	            var idx = 0;
	            while (idx < pairs.length) {
	                if (pairs[idx][0].apply(this, arguments)) {
	                    return pairs[idx][1].apply(this, arguments);
	                }
	                idx += 1;
	            }
	        };
	    });
	
	    /**
	     * Counts the elements of a list according to how many match each value of a
	     * key generated by the supplied function. Returns an object mapping the keys
	     * produced by `fn` to the number of occurrences in the list. Note that all
	     * keys are coerced to strings because of how JavaScript objects work.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig (a -> String) -> [a] -> {*}
	     * @param {Function} fn The function used to map values to keys.
	     * @param {Array} list The list to count elements from.
	     * @return {Object} An object mapping keys to number of occurrences in the list.
	     * @example
	     *
	     *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
	     *      var letters = R.split('', 'abcABCaaaBBc');
	     *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
	     *      R.countBy(R.toLower)(letters);   //=> {'a': 5, 'b': 4, 'c': 3}
	     */
	    var countBy = _curry2(function countBy(fn, list) {
	        var counts = {};
	        var len = list.length;
	        var idx = 0;
	        while (idx < len) {
	            var key = fn(list[idx]);
	            counts[key] = (_has(key, counts) ? counts[key] : 0) + 1;
	            idx += 1;
	        }
	        return counts;
	    });
	
	    /**
	     * Returns a curried equivalent of the provided function, with the specified
	     * arity. The curried function has two unusual capabilities. First, its
	     * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	     * following are equivalent:
	     *
	     *   - `g(1)(2)(3)`
	     *   - `g(1)(2, 3)`
	     *   - `g(1, 2)(3)`
	     *   - `g(1, 2, 3)`
	     *
	     * Secondly, the special placeholder value `R.__` may be used to specify
	     * "gaps", allowing partial application of any combination of arguments,
	     * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	     * following are equivalent:
	     *
	     *   - `g(1, 2, 3)`
	     *   - `g(_, 2, 3)(1)`
	     *   - `g(_, _, 3)(1)(2)`
	     *   - `g(_, _, 3)(1, 2)`
	     *   - `g(_, 2)(1)(3)`
	     *   - `g(_, 2)(1, 3)`
	     *   - `g(_, 2)(_, 3)(1)`
	     *
	     * @func
	     * @memberOf R
	     * @since v0.5.0
	     * @category Function
	     * @sig Number -> (* -> a) -> (* -> a)
	     * @param {Number} length The arity for the returned function.
	     * @param {Function} fn The function to curry.
	     * @return {Function} A new, curried function.
	     * @see R.curry
	     * @example
	     *
	     *      var sumArgs = (...args) => R.sum(args);
	     *
	     *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	     *      var f = curriedAddFourNumbers(1, 2);
	     *      var g = f(3);
	     *      g(4); //=> 10
	     */
	    var curryN = _curry2(function curryN(length, fn) {
	        if (length === 1) {
	            return _curry1(fn);
	        }
	        return _arity(length, _curryN(length, [], fn));
	    });
	
	    /**
	     * Decrements its argument.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Math
	     * @sig Number -> Number
	     * @param {Number} n
	     * @return {Number}
	     * @see R.inc
	     * @example
	     *
	     *      R.dec(42); //=> 41
	     */
	    var dec = add(-1);
	
	    /**
	     * Returns the second argument if it is not `null`, `undefined` or `NaN`
	     * otherwise the first argument is returned.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category Logic
	     * @sig a -> b -> a | b
	     * @param {a} val The default value.
	     * @param {b} val The value to return if it is not null or undefined
	     * @return {*} The the second value or the default value
	     * @example
	     *
	     *      var defaultTo42 = R.defaultTo(42);
	     *
	     *      defaultTo42(null);  //=> 42
	     *      defaultTo42(undefined);  //=> 42
	     *      defaultTo42('Ramda');  //=> 'Ramda'
	     *      defaultTo42(parseInt('string')); //=> 42
	     */
	    var defaultTo = _curry2(function defaultTo(d, v) {
	        return v == null || v !== v ? d : v;
	    });
	
	    /**
	     * Finds the set (i.e. no duplicates) of all elements in the first list not
	     * contained in the second list. Duplication is determined according to the
	     * value returned by applying the supplied predicate to two list elements.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
	     * @param {Function} pred A predicate used to test whether two items are equal.
	     * @param {Array} list1 The first list.
	     * @param {Array} list2 The second list.
	     * @return {Array} The elements in `list1` that are not in `list2`.
	     * @see R.difference
	     * @example
	     *
	     *      function cmp(x, y) => x.a === y.a;
	     *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
	     *      var l2 = [{a: 3}, {a: 4}];
	     *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
	     */
	    var differenceWith = _curry3(function differenceWith(pred, first, second) {
	        var out = [];
	        var idx = 0;
	        var firstLen = first.length;
	        while (idx < firstLen) {
	            if (!_containsWith(pred, first[idx], second) && !_containsWith(pred, first[idx], out)) {
	                out.push(first[idx]);
	            }
	            idx += 1;
	        }
	        return out;
	    });
	
	    /**
	     * Returns a new object that does not contain a `prop` property.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category Object
	     * @sig String -> {k: v} -> {k: v}
	     * @param {String} prop the name of the property to dissociate
	     * @param {Object} obj the object to clone
	     * @return {Object} a new object similar to the original but without the specified property
	     * @see R.assoc
	     * @example
	     *
	     *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	     */
	    var dissoc = _curry2(function dissoc(prop, obj) {
	        var result = {};
	        for (var p in obj) {
	            if (p !== prop) {
	                result[p] = obj[p];
	            }
	        }
	        return result;
	    });
	
	    /**
	     * Makes a shallow clone of an object, omitting the property at the given path.
	     * Note that this copies and flattens prototype properties onto the new object
	     * as well. All non-primitive properties are copied by reference.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.11.0
	     * @category Object
	     * @sig [String] -> {k: v} -> {k: v}
	     * @param {Array} path the path to set
	     * @param {Object} obj the object to clone
	     * @return {Object} a new object without the property at path
	     * @see R.assocPath
	     * @example
	     *
	     *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
	     */
	    var dissocPath = _curry2(function dissocPath(path, obj) {
	        switch (path.length) {
	        case 0:
	            return obj;
	        case 1:
	            return dissoc(path[0], obj);
	        default:
	            var head = path[0];
	            var tail = _slice(path, 1);
	            return obj[head] == null ? obj : assoc(head, dissocPath(tail, obj[head]), obj);
	        }
	    });
	
	    /**
	     * Divides two numbers. Equivalent to `a / b`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Math
	     * @sig Number -> Number -> Number
	     * @param {Number} a The first value.
	     * @param {Number} b The second value.
	     * @return {Number} The result of `a / b`.
	     * @see R.multiply
	     * @example
	     *
	     *      R.divide(71, 100); //=> 0.71
	     *
	     *      var half = R.divide(R.__, 2);
	     *      half(42); //=> 21
	     *
	     *      var reciprocal = R.divide(1);
	     *      reciprocal(4);   //=> 0.25
	     */
	    var divide = _curry2(function divide(a, b) {
	        return a / b;
	    });
	
	    /**
	     * Returns a new list containing the last `n` elements of a given list, passing
	     * each value to the supplied predicate function, skipping elements while the
	     * predicate function returns `true`. The predicate function is passed one
	     * argument: *(value)*.
	     *
	     * Dispatches to the `dropWhile` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> [a]
	     * @param {Function} fn The function called per iteration.
	     * @param {Array} list The collection to iterate over.
	     * @return {Array} A new array.
	     * @see R.takeWhile, R.transduce, R.addIndex
	     * @example
	     *
	     *      var lteTwo = x => x <= 2;
	     *
	     *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
	     */
	    var dropWhile = _curry2(_dispatchable('dropWhile', _xdropWhile, function dropWhile(pred, list) {
	        var idx = 0;
	        var len = list.length;
	        while (idx < len && pred(list[idx])) {
	            idx += 1;
	        }
	        return _slice(list, idx);
	    }));
	
	    /**
	     * A function wrapping calls to the two functions in an `||` operation,
	     * returning the result of the first function if it is truth-y and the result
	     * of the second function otherwise. Note that this is short-circuited,
	     * meaning that the second function will not be invoked if the first returns a
	     * truth-y value.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.12.0
	     * @category Logic
	     * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	     * @param {Function} f a predicate
	     * @param {Function} g another predicate
	     * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	     * @see R.or
	     * @example
	     *
	     *      var gt10 = x => x > 10;
	     *      var even = x => x % 2 === 0;
	     *      var f = R.either(gt10, even);
	     *      f(101); //=> true
	     *      f(8); //=> true
	     */
	    var either = _curry2(function either(f, g) {
	        return function _either() {
	            return f.apply(this, arguments) || g.apply(this, arguments);
	        };
	    });
	
	    /**
	     * Returns the empty value of its argument's type. Ramda defines the empty
	     * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	     * types are supported if they define `<Type>.empty` and/or
	     * `<Type>.prototype.empty`.
	     *
	     * Dispatches to the `empty` method of the first argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.3.0
	     * @category Function
	     * @sig a -> a
	     * @param {*} x
	     * @return {*}
	     * @example
	     *
	     *      R.empty(Just(42));      //=> Nothing()
	     *      R.empty([1, 2, 3]);     //=> []
	     *      R.empty('unicorns');    //=> ''
	     *      R.empty({x: 1, y: 2});  //=> {}
	     */
	    // else
	    var empty = _curry1(function empty(x) {
	        return x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : _isArray(x) ? [] : _isString(x) ? '' : _isObject(x) ? {} : _isArguments(x) ? function () {
	            return arguments;
	        }() : // else
	        void 0;
	    });
	
	    /**
	     * Creates a new object by recursively evolving a shallow copy of `object`,
	     * according to the `transformation` functions. All non-primitive properties
	     * are copied by reference.
	     *
	     * A `transformation` function will not be invoked if its corresponding key
	     * does not exist in the evolved object.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Object
	     * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	     * @param {Object} transformations The object specifying transformation functions to apply
	     *        to the object.
	     * @param {Object} object The object to be transformed.
	     * @return {Object} The transformed object.
	     * @example
	     *
	     *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	     *      var transformations = {
	     *        firstName: R.trim,
	     *        lastName: R.trim, // Will not get invoked.
	     *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	     *      };
	     *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	     */
	    var evolve = _curry2(function evolve(transformations, object) {
	        var result = {};
	        var transformation, key, type;
	        for (key in object) {
	            transformation = transformations[key];
	            type = typeof transformation;
	            result[key] = type === 'function' ? transformation(object[key]) : type === 'object' ? evolve(transformations[key], object[key]) : object[key];
	        }
	        return result;
	    });
	
	    /**
	     * Returns the first element of the list which matches the predicate, or
	     * `undefined` if no element matches.
	     *
	     * Dispatches to the `find` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> a | undefined
	     * @param {Function} fn The predicate function used to determine if the element is the
	     *        desired one.
	     * @param {Array} list The array to consider.
	     * @return {Object} The element found, or `undefined`.
	     * @see R.transduce
	     * @example
	     *
	     *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	     *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	     *      R.find(R.propEq('a', 4))(xs); //=> undefined
	     */
	    var find = _curry2(_dispatchable('find', _xfind, function find(fn, list) {
	        var idx = 0;
	        var len = list.length;
	        while (idx < len) {
	            if (fn(list[idx])) {
	                return list[idx];
	            }
	            idx += 1;
	        }
	    }));
	
	    /**
	     * Returns the index of the first element of the list which matches the
	     * predicate, or `-1` if no element matches.
	     *
	     * Dispatches to the `findIndex` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.1
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> Number
	     * @param {Function} fn The predicate function used to determine if the element is the
	     * desired one.
	     * @param {Array} list The array to consider.
	     * @return {Number} The index of the element found, or `-1`.
	     * @see R.transduce
	     * @example
	     *
	     *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	     *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
	     *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
	     */
	    var findIndex = _curry2(_dispatchable('findIndex', _xfindIndex, function findIndex(fn, list) {
	        var idx = 0;
	        var len = list.length;
	        while (idx < len) {
	            if (fn(list[idx])) {
	                return idx;
	            }
	            idx += 1;
	        }
	        return -1;
	    }));
	
	    /**
	     * Returns the last element of the list which matches the predicate, or
	     * `undefined` if no element matches.
	     *
	     * Dispatches to the `findLast` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.1
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> a | undefined
	     * @param {Function} fn The predicate function used to determine if the element is the
	     * desired one.
	     * @param {Array} list The array to consider.
	     * @return {Object} The element found, or `undefined`.
	     * @see R.transduce
	     * @example
	     *
	     *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	     *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
	     *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
	     */
	    var findLast = _curry2(_dispatchable('findLast', _xfindLast, function findLast(fn, list) {
	        var idx = list.length - 1;
	        while (idx >= 0) {
	            if (fn(list[idx])) {
	                return list[idx];
	            }
	            idx -= 1;
	        }
	    }));
	
	    /**
	     * Returns the index of the last element of the list which matches the
	     * predicate, or `-1` if no element matches.
	     *
	     * Dispatches to the `findLastIndex` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.1
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> Number
	     * @param {Function} fn The predicate function used to determine if the element is the
	     * desired one.
	     * @param {Array} list The array to consider.
	     * @return {Number} The index of the element found, or `-1`.
	     * @see R.transduce
	     * @example
	     *
	     *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	     *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
	     *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
	     */
	    var findLastIndex = _curry2(_dispatchable('findLastIndex', _xfindLastIndex, function findLastIndex(fn, list) {
	        var idx = list.length - 1;
	        while (idx >= 0) {
	            if (fn(list[idx])) {
	                return idx;
	            }
	            idx -= 1;
	        }
	        return -1;
	    }));
	
	    /**
	     * Iterate over an input `list`, calling a provided function `fn` for each
	     * element in the list.
	     *
	     * `fn` receives one argument: *(value)*.
	     *
	     * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	     * arrays), unlike the native `Array.prototype.forEach` method. For more
	     * details on this behavior, see:
	     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	     *
	     * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	     * the original array. In some libraries this function is named `each`.
	     *
	     * Dispatches to the `forEach` method of the second argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.1
	     * @category List
	     * @sig (a -> *) -> [a] -> [a]
	     * @param {Function} fn The function to invoke. Receives one argument, `value`.
	     * @param {Array} list The list to iterate over.
	     * @return {Array} The original list.
	     * @see R.addIndex
	     * @example
	     *
	     *      var printXPlusFive = x => console.log(x + 5);
	     *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	     *      //-> 6
	     *      //-> 7
	     *      //-> 8
	     */
	    var forEach = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
	        var len = list.length;
	        var idx = 0;
	        while (idx < len) {
	            fn(list[idx]);
	            idx += 1;
	        }
	        return list;
	    }));
	
	    /**
	     * Creates a new object out of a list key-value pairs.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.3.0
	     * @category List
	     * @sig [[k,v]] -> {k: v}
	     * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
	     * @return {Object} The object made by pairing up `keys` and `values`.
	     * @see R.toPairs, R.pair
	     * @example
	     *
	     *      R.fromPairs([['a', 1], ['b', 2],  ['c', 3]]); //=> {a: 1, b: 2, c: 3}
	     */
	    var fromPairs = _curry1(function fromPairs(pairs) {
	        var idx = 0;
	        var len = pairs.length;
	        var out = {};
	        while (idx < len) {
	            if (_isArray(pairs[idx]) && pairs[idx].length) {
	                out[pairs[idx][0]] = pairs[idx][1];
	            }
	            idx += 1;
	        }
	        return out;
	    });
	
	    /**
	     * Returns `true` if the first argument is greater than the second; `false`
	     * otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig Ord a => a -> a -> Boolean
	     * @param {*} a
	     * @param {*} b
	     * @return {Boolean}
	     * @see R.lt
	     * @example
	     *
	     *      R.gt(2, 1); //=> true
	     *      R.gt(2, 2); //=> false
	     *      R.gt(2, 3); //=> false
	     *      R.gt('a', 'z'); //=> false
	     *      R.gt('z', 'a'); //=> true
	     */
	    var gt = _curry2(function gt(a, b) {
	        return a > b;
	    });
	
	    /**
	     * Returns `true` if the first argument is greater than or equal to the second;
	     * `false` otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig Ord a => a -> a -> Boolean
	     * @param {Number} a
	     * @param {Number} b
	     * @return {Boolean}
	     * @see R.lte
	     * @example
	     *
	     *      R.gte(2, 1); //=> true
	     *      R.gte(2, 2); //=> true
	     *      R.gte(2, 3); //=> false
	     *      R.gte('a', 'z'); //=> false
	     *      R.gte('z', 'a'); //=> true
	     */
	    var gte = _curry2(function gte(a, b) {
	        return a >= b;
	    });
	
	    /**
	     * Returns whether or not an object has an own property with the specified name
	     *
	     * @func
	     * @memberOf R
	     * @since v0.7.0
	     * @category Object
	     * @sig s -> {s: x} -> Boolean
	     * @param {String} prop The name of the property to check for.
	     * @param {Object} obj The object to query.
	     * @return {Boolean} Whether the property exists.
	     * @example
	     *
	     *      var hasName = R.has('name');
	     *      hasName({name: 'alice'});   //=> true
	     *      hasName({name: 'bob'});     //=> true
	     *      hasName({});                //=> false
	     *
	     *      var point = {x: 0, y: 0};
	     *      var pointHas = R.has(R.__, point);
	     *      pointHas('x');  //=> true
	     *      pointHas('y');  //=> true
	     *      pointHas('z');  //=> false
	     */
	    var has = _curry2(_has);
	
	    /**
	     * Returns whether or not an object or its prototype chain has a property with
	     * the specified name
	     *
	     * @func
	     * @memberOf R
	     * @since v0.7.0
	     * @category Object
	     * @sig s -> {s: x} -> Boolean
	     * @param {String} prop The name of the property to check for.
	     * @param {Object} obj The object to query.
	     * @return {Boolean} Whether the property exists.
	     * @example
	     *
	     *      function Rectangle(width, height) {
	     *        this.width = width;
	     *        this.height = height;
	     *      }
	     *      Rectangle.prototype.area = function() {
	     *        return this.width * this.height;
	     *      };
	     *
	     *      var square = new Rectangle(2, 2);
	     *      R.hasIn('width', square);  //=> true
	     *      R.hasIn('area', square);  //=> true
	     */
	    var hasIn = _curry2(function hasIn(prop, obj) {
	        return prop in obj;
	    });
	
	    /**
	     * Returns true if its arguments are identical, false otherwise. Values are
	     * identical if they reference the same memory. `NaN` is identical to `NaN`;
	     * `0` and `-0` are not identical.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.15.0
	     * @category Relation
	     * @sig a -> a -> Boolean
	     * @param {*} a
	     * @param {*} b
	     * @return {Boolean}
	     * @example
	     *
	     *      var o = {};
	     *      R.identical(o, o); //=> true
	     *      R.identical(1, 1); //=> true
	     *      R.identical(1, '1'); //=> false
	     *      R.identical([], []); //=> false
	     *      R.identical(0, -0); //=> false
	     *      R.identical(NaN, NaN); //=> true
	     */
	    // SameValue algorithm
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Step 6.a: NaN == NaN
	    var identical = _curry2(function identical(a, b) {
	        // SameValue algorithm
	        if (a === b) {
	            // Steps 1-5, 7-10
	            // Steps 6.b-6.e: +0 != -0
	            return a !== 0 || 1 / a === 1 / b;
	        } else {
	            // Step 6.a: NaN == NaN
	            return a !== a && b !== b;
	        }
	    });
	
	    /**
	     * A function that does nothing but return the parameter supplied to it. Good
	     * as a default or placeholder function.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig a -> a
	     * @param {*} x The value to return.
	     * @return {*} The input value, `x`.
	     * @example
	     *
	     *      R.identity(1); //=> 1
	     *
	     *      var obj = {};
	     *      R.identity(obj) === obj; //=> true
	     */
	    var identity = _curry1(_identity);
	
	    /**
	     * Creates a function that will process either the `onTrue` or the `onFalse`
	     * function depending upon the result of the `condition` predicate.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category Logic
	     * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	     * @param {Function} condition A predicate function
	     * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	     * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	     * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	     *                    function depending upon the result of the `condition` predicate.
	     * @see R.unless, R.when
	     * @example
	     *
	     *      var incCount = R.ifElse(
	     *        R.has('count'),
	     *        R.over(R.lensProp('count'), R.inc),
	     *        R.assoc('count', 1)
	     *      );
	     *      incCount({});           //=> { count: 1 }
	     *      incCount({ count: 1 }); //=> { count: 2 }
	     */
	    var ifElse = _curry3(function ifElse(condition, onTrue, onFalse) {
	        return curryN(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
	            return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	        });
	    });
	
	    /**
	     * Increments its argument.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Math
	     * @sig Number -> Number
	     * @param {Number} n
	     * @return {Number}
	     * @see R.dec
	     * @example
	     *
	     *      R.inc(42); //=> 43
	     */
	    var inc = add(1);
	
	    /**
	     * Inserts the supplied element into the list, at index `index`. _Note that
	     * this is not destructive_: it returns a copy of the list with the changes.
	     * <small>No lists have been harmed in the application of this function.</small>
	     *
	     * @func
	     * @memberOf R
	     * @since v0.2.2
	     * @category List
	     * @sig Number -> a -> [a] -> [a]
	     * @param {Number} index The position to insert the element
	     * @param {*} elt The element to insert into the Array
	     * @param {Array} list The list to insert into
	     * @return {Array} A new Array with `elt` inserted at `index`.
	     * @example
	     *
	     *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	     */
	    var insert = _curry3(function insert(idx, elt, list) {
	        idx = idx < list.length && idx >= 0 ? idx : list.length;
	        var result = _slice(list);
	        result.splice(idx, 0, elt);
	        return result;
	    });
	
	    /**
	     * Inserts the sub-list into the list, at index `index`. _Note that this is not
	     * destructive_: it returns a copy of the list with the changes.
	     * <small>No lists have been harmed in the application of this function.</small>
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category List
	     * @sig Number -> [a] -> [a] -> [a]
	     * @param {Number} index The position to insert the sub-list
	     * @param {Array} elts The sub-list to insert into the Array
	     * @param {Array} list The list to insert the sub-list into
	     * @return {Array} A new Array with `elts` inserted starting at `index`.
	     * @example
	     *
	     *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
	     */
	    var insertAll = _curry3(function insertAll(idx, elts, list) {
	        idx = idx < list.length && idx >= 0 ? idx : list.length;
	        return _concat(_concat(_slice(list, 0, idx), elts), _slice(list, idx));
	    });
	
	    /**
	     * Creates a new list with the separator interposed between elements.
	     *
	     * Dispatches to the `intersperse` method of the second argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category List
	     * @sig a -> [a] -> [a]
	     * @param {*} separator The element to add to the list.
	     * @param {Array} list The list to be interposed.
	     * @return {Array} The new list.
	     * @example
	     *
	     *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
	     */
	    var intersperse = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
	        var out = [];
	        var idx = 0;
	        var length = list.length;
	        while (idx < length) {
	            if (idx === length - 1) {
	                out.push(list[idx]);
	            } else {
	                out.push(list[idx], separator);
	            }
	            idx += 1;
	        }
	        return out;
	    }));
	
	    /**
	     * See if an object (`val`) is an instance of the supplied constructor. This
	     * function will check up the inheritance chain, if any.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.3.0
	     * @category Type
	     * @sig (* -> {*}) -> a -> Boolean
	     * @param {Object} ctor A constructor
	     * @param {*} val The value to test
	     * @return {Boolean}
	     * @example
	     *
	     *      R.is(Object, {}); //=> true
	     *      R.is(Number, 1); //=> true
	     *      R.is(Object, 1); //=> false
	     *      R.is(String, 's'); //=> true
	     *      R.is(String, new String('')); //=> true
	     *      R.is(Object, new String('')); //=> true
	     *      R.is(Object, 's'); //=> false
	     *      R.is(Number, {}); //=> false
	     */
	    var is = _curry2(function is(Ctor, val) {
	        return val != null && val.constructor === Ctor || val instanceof Ctor;
	    });
	
	    /**
	     * Tests whether or not an object is similar to an array.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.5.0
	     * @category Type
	     * @category List
	     * @sig * -> Boolean
	     * @param {*} x The object to test.
	     * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	     * @example
	     *
	     *      R.isArrayLike([]); //=> true
	     *      R.isArrayLike(true); //=> false
	     *      R.isArrayLike({}); //=> false
	     *      R.isArrayLike({length: 10}); //=> false
	     *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	     */
	    var isArrayLike = _curry1(function isArrayLike(x) {
	        if (_isArray(x)) {
	            return true;
	        }
	        if (!x) {
	            return false;
	        }
	        if (typeof x !== 'object') {
	            return false;
	        }
	        if (x instanceof String) {
	            return false;
	        }
	        if (x.nodeType === 1) {
	            return !!x.length;
	        }
	        if (x.length === 0) {
	            return true;
	        }
	        if (x.length > 0) {
	            return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	        }
	        return false;
	    });
	
	    /**
	     * Checks if the input value is `null` or `undefined`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Type
	     * @sig * -> Boolean
	     * @param {*} x The value to test.
	     * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	     * @example
	     *
	     *      R.isNil(null); //=> true
	     *      R.isNil(undefined); //=> true
	     *      R.isNil(0); //=> false
	     *      R.isNil([]); //=> false
	     */
	    var isNil = _curry1(function isNil(x) {
	        return x == null;
	    });
	
	    /**
	     * Returns a list containing the names of all the enumerable own properties of
	     * the supplied object.
	     * Note that the order of the output array is not guaranteed to be consistent
	     * across different JS platforms.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @sig {k: v} -> [k]
	     * @param {Object} obj The object to extract properties from
	     * @return {Array} An array of the object's own properties.
	     * @example
	     *
	     *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	     */
	    // cover IE < 9 keys issues
	    // Safari bug
	    var keys = function () {
	        // cover IE < 9 keys issues
	        var hasEnumBug = !{ toString: null }.propertyIsEnumerable('toString');
	        var nonEnumerableProps = [
	            'constructor',
	            'valueOf',
	            'isPrototypeOf',
	            'toString',
	            'propertyIsEnumerable',
	            'hasOwnProperty',
	            'toLocaleString'
	        ];
	        // Safari bug
	        var hasArgsEnumBug = function () {
	            'use strict';
	            return arguments.propertyIsEnumerable('length');
	        }();
	        var contains = function contains(list, item) {
	            var idx = 0;
	            while (idx < list.length) {
	                if (list[idx] === item) {
	                    return true;
	                }
	                idx += 1;
	            }
	            return false;
	        };
	        return typeof Object.keys === 'function' && !hasArgsEnumBug ? _curry1(function keys(obj) {
	            return Object(obj) !== obj ? [] : Object.keys(obj);
	        }) : _curry1(function keys(obj) {
	            if (Object(obj) !== obj) {
	                return [];
	            }
	            var prop, nIdx;
	            var ks = [];
	            var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	            for (prop in obj) {
	                if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	                    ks[ks.length] = prop;
	                }
	            }
	            if (hasEnumBug) {
	                nIdx = nonEnumerableProps.length - 1;
	                while (nIdx >= 0) {
	                    prop = nonEnumerableProps[nIdx];
	                    if (_has(prop, obj) && !contains(ks, prop)) {
	                        ks[ks.length] = prop;
	                    }
	                    nIdx -= 1;
	                }
	            }
	            return ks;
	        });
	    }();
	
	    /**
	     * Returns a list containing the names of all the properties of the supplied
	     * object, including prototype properties.
	     * Note that the order of the output array is not guaranteed to be consistent
	     * across different JS platforms.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.2.0
	     * @category Object
	     * @sig {k: v} -> [k]
	     * @param {Object} obj The object to extract properties from
	     * @return {Array} An array of the object's own and prototype properties.
	     * @example
	     *
	     *      var F = function() { this.x = 'X'; };
	     *      F.prototype.y = 'Y';
	     *      var f = new F();
	     *      R.keysIn(f); //=> ['x', 'y']
	     */
	    var keysIn = _curry1(function keysIn(obj) {
	        var prop;
	        var ks = [];
	        for (prop in obj) {
	            ks[ks.length] = prop;
	        }
	        return ks;
	    });
	
	    /**
	     * Returns the number of elements in the array by returning `list.length`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.3.0
	     * @category List
	     * @sig [a] -> Number
	     * @param {Array} list The array to inspect.
	     * @return {Number} The length of the array.
	     * @example
	     *
	     *      R.length([]); //=> 0
	     *      R.length([1, 2, 3]); //=> 3
	     */
	    var length = _curry1(function length(list) {
	        return list != null && is(Number, list.length) ? list.length : NaN;
	    });
	
	    /**
	     * Returns `true` if the first argument is less than the second; `false`
	     * otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig Ord a => a -> a -> Boolean
	     * @param {*} a
	     * @param {*} b
	     * @return {Boolean}
	     * @see R.gt
	     * @example
	     *
	     *      R.lt(2, 1); //=> false
	     *      R.lt(2, 2); //=> false
	     *      R.lt(2, 3); //=> true
	     *      R.lt('a', 'z'); //=> true
	     *      R.lt('z', 'a'); //=> false
	     */
	    var lt = _curry2(function lt(a, b) {
	        return a < b;
	    });
	
	    /**
	     * Returns `true` if the first argument is less than or equal to the second;
	     * `false` otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig Ord a => a -> a -> Boolean
	     * @param {Number} a
	     * @param {Number} b
	     * @return {Boolean}
	     * @see R.gte
	     * @example
	     *
	     *      R.lte(2, 1); //=> false
	     *      R.lte(2, 2); //=> true
	     *      R.lte(2, 3); //=> true
	     *      R.lte('a', 'z'); //=> true
	     *      R.lte('z', 'a'); //=> false
	     */
	    var lte = _curry2(function lte(a, b) {
	        return a <= b;
	    });
	
	    /**
	     * The mapAccum function behaves like a combination of map and reduce; it
	     * applies a function to each element of a list, passing an accumulating
	     * parameter from left to right, and returning a final value of this
	     * accumulator together with the new list.
	     *
	     * The iterator function receives two arguments, *acc* and *value*, and should
	     * return a tuple *[acc, value]*.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category List
	     * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
	     * @param {Function} fn The function to be called on every element of the input `list`.
	     * @param {*} acc The accumulator value.
	     * @param {Array} list The list to iterate over.
	     * @return {*} The final, accumulated value.
	     * @see R.addIndex
	     * @example
	     *
	     *      var digits = ['1', '2', '3', '4'];
	     *      var append = (a, b) => [a + b, a + b];
	     *
	     *      R.mapAccum(append, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
	     */
	    var mapAccum = _curry3(function mapAccum(fn, acc, list) {
	        var idx = 0;
	        var len = list.length;
	        var result = [];
	        var tuple = [acc];
	        while (idx < len) {
	            tuple = fn(tuple[0], list[idx]);
	            result[idx] = tuple[1];
	            idx += 1;
	        }
	        return [
	            tuple[0],
	            result
	        ];
	    });
	
	    /**
	     * The mapAccumRight function behaves like a combination of map and reduce; it
	     * applies a function to each element of a list, passing an accumulating
	     * parameter from right to left, and returning a final value of this
	     * accumulator together with the new list.
	     *
	     * Similar to `mapAccum`, except moves through the input list from the right to
	     * the left.
	     *
	     * The iterator function receives two arguments, *acc* and *value*, and should
	     * return a tuple *[acc, value]*.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category List
	     * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
	     * @param {Function} fn The function to be called on every element of the input `list`.
	     * @param {*} acc The accumulator value.
	     * @param {Array} list The list to iterate over.
	     * @return {*} The final, accumulated value.
	     * @see R.addIndex
	     * @example
	     *
	     *      var digits = ['1', '2', '3', '4'];
	     *      var append = (a, b) => [a + b, a + b];
	     *
	     *      R.mapAccumRight(append, 0, digits); //=> ['04321', ['04321', '0432', '043', '04']]
	     */
	    var mapAccumRight = _curry3(function mapAccumRight(fn, acc, list) {
	        var idx = list.length - 1;
	        var result = [];
	        var tuple = [acc];
	        while (idx >= 0) {
	            tuple = fn(tuple[0], list[idx]);
	            result[idx] = tuple[1];
	            idx -= 1;
	        }
	        return [
	            tuple[0],
	            result
	        ];
	    });
	
	    /**
	     * Tests a regular expression against a String. Note that this function will
	     * return an empty array when there are no matches. This differs from
	     * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
	     * which returns `null` when there are no matches.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category String
	     * @sig RegExp -> String -> [String | Undefined]
	     * @param {RegExp} rx A regular expression.
	     * @param {String} str The string to match against
	     * @return {Array} The list of matches or empty array.
	     * @see R.test
	     * @example
	     *
	     *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
	     *      R.match(/a/, 'b'); //=> []
	     *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
	     */
	    var match = _curry2(function match(rx, str) {
	        return str.match(rx) || [];
	    });
	
	    /**
	     * mathMod behaves like the modulo operator should mathematically, unlike the
	     * `%` operator (and by extension, R.modulo). So while "-17 % 5" is -2,
	     * mathMod(-17, 5) is 3. mathMod requires Integer arguments, and returns NaN
	     * when the modulus is zero or negative.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.3.0
	     * @category Math
	     * @sig Number -> Number -> Number
	     * @param {Number} m The dividend.
	     * @param {Number} p the modulus.
	     * @return {Number} The result of `b mod a`.
	     * @example
	     *
	     *      R.mathMod(-17, 5);  //=> 3
	     *      R.mathMod(17, 5);   //=> 2
	     *      R.mathMod(17, -5);  //=> NaN
	     *      R.mathMod(17, 0);   //=> NaN
	     *      R.mathMod(17.2, 5); //=> NaN
	     *      R.mathMod(17, 5.3); //=> NaN
	     *
	     *      var clock = R.mathMod(R.__, 12);
	     *      clock(15); //=> 3
	     *      clock(24); //=> 0
	     *
	     *      var seventeenMod = R.mathMod(17);
	     *      seventeenMod(3);  //=> 2
	     *      seventeenMod(4);  //=> 1
	     *      seventeenMod(10); //=> 7
	     */
	    var mathMod = _curry2(function mathMod(m, p) {
	        if (!_isInteger(m)) {
	            return NaN;
	        }
	        if (!_isInteger(p) || p < 1) {
	            return NaN;
	        }
	        return (m % p + p) % p;
	    });
	
	    /**
	     * Returns the larger of its two arguments.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig Ord a => a -> a -> a
	     * @param {*} a
	     * @param {*} b
	     * @return {*}
	     * @see R.maxBy, R.min
	     * @example
	     *
	     *      R.max(789, 123); //=> 789
	     *      R.max('a', 'b'); //=> 'b'
	     */
	    var max = _curry2(function max(a, b) {
	        return b > a ? b : a;
	    });
	
	    /**
	     * Takes a function and two values, and returns whichever value produces the
	     * larger result when passed to the provided function.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category Relation
	     * @sig Ord b => (a -> b) -> a -> a -> a
	     * @param {Function} f
	     * @param {*} a
	     * @param {*} b
	     * @return {*}
	     * @see R.max, R.minBy
	     * @example
	     *
	     *      //  square :: Number -> Number
	     *      var square = n => n * n;
	     *
	     *      R.maxBy(square, -3, 2); //=> -3
	     *
	     *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
	     *      R.reduce(R.maxBy(square), 0, []); //=> 0
	     */
	    var maxBy = _curry3(function maxBy(f, a, b) {
	        return f(b) > f(a) ? b : a;
	    });
	
	    /**
	     * Creates a new object with the own properties of the two provided objects. If
	     * a key exists in both objects, the provided function is applied to the key
	     * and the values associated with the key in each object, with the result being
	     * used as the value associated with the key in the returned object. The key
	     * will be excluded from the returned object if the resulting value is
	     * `undefined`.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category Object
	     * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
	     * @param {Function} fn
	     * @param {Object} l
	     * @param {Object} r
	     * @return {Object}
	     * @see R.merge, R.mergeWith
	     * @example
	     *
	     *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	     *      R.mergeWithKey(concatValues,
	     *                     { a: true, thing: 'foo', values: [10, 20] },
	     *                     { b: true, thing: 'bar', values: [15, 35] });
	     *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
	     */
	    var mergeWithKey = _curry3(function mergeWithKey(fn, l, r) {
	        var result = {};
	        var k;
	        for (k in l) {
	            if (_has(k, l)) {
	                result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
	            }
	        }
	        for (k in r) {
	            if (_has(k, r) && !_has(k, result)) {
	                result[k] = r[k];
	            }
	        }
	        return result;
	    });
	
	    /**
	     * Returns the smaller of its two arguments.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig Ord a => a -> a -> a
	     * @param {*} a
	     * @param {*} b
	     * @return {*}
	     * @see R.minBy, R.max
	     * @example
	     *
	     *      R.min(789, 123); //=> 123
	     *      R.min('a', 'b'); //=> 'a'
	     */
	    var min = _curry2(function min(a, b) {
	        return b < a ? b : a;
	    });
	
	    /**
	     * Takes a function and two values, and returns whichever value produces the
	     * smaller result when passed to the provided function.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category Relation
	     * @sig Ord b => (a -> b) -> a -> a -> a
	     * @param {Function} f
	     * @param {*} a
	     * @param {*} b
	     * @return {*}
	     * @see R.min, R.maxBy
	     * @example
	     *
	     *      //  square :: Number -> Number
	     *      var square = n => n * n;
	     *
	     *      R.minBy(square, -3, 2); //=> 2
	     *
	     *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
	     *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
	     */
	    var minBy = _curry3(function minBy(f, a, b) {
	        return f(b) < f(a) ? b : a;
	    });
	
	    /**
	     * Divides the second parameter by the first and returns the remainder. Note
	     * that this function preserves the JavaScript-style behavior for modulo. For
	     * mathematical modulo see `mathMod`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.1
	     * @category Math
	     * @sig Number -> Number -> Number
	     * @param {Number} a The value to the divide.
	     * @param {Number} b The pseudo-modulus
	     * @return {Number} The result of `b % a`.
	     * @see R.mathMod
	     * @example
	     *
	     *      R.modulo(17, 3); //=> 2
	     *      // JS behavior:
	     *      R.modulo(-17, 3); //=> -2
	     *      R.modulo(17, -3); //=> 2
	     *
	     *      var isOdd = R.modulo(R.__, 2);
	     *      isOdd(42); //=> 0
	     *      isOdd(21); //=> 1
	     */
	    var modulo = _curry2(function modulo(a, b) {
	        return a % b;
	    });
	
	    /**
	     * Multiplies two numbers. Equivalent to `a * b` but curried.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Math
	     * @sig Number -> Number -> Number
	     * @param {Number} a The first value.
	     * @param {Number} b The second value.
	     * @return {Number} The result of `a * b`.
	     * @see R.divide
	     * @example
	     *
	     *      var double = R.multiply(2);
	     *      var triple = R.multiply(3);
	     *      double(3);       //=>  6
	     *      triple(4);       //=> 12
	     *      R.multiply(2, 5);  //=> 10
	     */
	    var multiply = _curry2(function multiply(a, b) {
	        return a * b;
	    });
	
	    /**
	     * Wraps a function of any arity (including nullary) in a function that accepts
	     * exactly `n` parameters. Any extraneous parameters will not be passed to the
	     * supplied function.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig Number -> (* -> a) -> (* -> a)
	     * @param {Number} n The desired arity of the new function.
	     * @param {Function} fn The function to wrap.
	     * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	     *         arity `n`.
	     * @example
	     *
	     *      var takesTwoArgs = (a, b) => [a, b];
	     *
	     *      takesTwoArgs.length; //=> 2
	     *      takesTwoArgs(1, 2); //=> [1, 2]
	     *
	     *      var takesOneArg = R.nAry(1, takesTwoArgs);
	     *      takesOneArg.length; //=> 1
	     *      // Only `n` arguments are passed to the wrapped function
	     *      takesOneArg(1, 2); //=> [1, undefined]
	     */
	    var nAry = _curry2(function nAry(n, fn) {
	        switch (n) {
	        case 0:
	            return function () {
	                return fn.call(this);
	            };
	        case 1:
	            return function (a0) {
	                return fn.call(this, a0);
	            };
	        case 2:
	            return function (a0, a1) {
	                return fn.call(this, a0, a1);
	            };
	        case 3:
	            return function (a0, a1, a2) {
	                return fn.call(this, a0, a1, a2);
	            };
	        case 4:
	            return function (a0, a1, a2, a3) {
	                return fn.call(this, a0, a1, a2, a3);
	            };
	        case 5:
	            return function (a0, a1, a2, a3, a4) {
	                return fn.call(this, a0, a1, a2, a3, a4);
	            };
	        case 6:
	            return function (a0, a1, a2, a3, a4, a5) {
	                return fn.call(this, a0, a1, a2, a3, a4, a5);
	            };
	        case 7:
	            return function (a0, a1, a2, a3, a4, a5, a6) {
	                return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
	            };
	        case 8:
	            return function (a0, a1, a2, a3, a4, a5, a6, a7) {
	                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
	            };
	        case 9:
	            return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
	                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
	            };
	        case 10:
	            return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
	                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
	            };
	        default:
	            throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	        }
	    });
	
	    /**
	     * Negates its argument.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Math
	     * @sig Number -> Number
	     * @param {Number} n
	     * @return {Number}
	     * @example
	     *
	     *      R.negate(42); //=> -42
	     */
	    var negate = _curry1(function negate(n) {
	        return -n;
	    });
	
	    /**
	     * Returns `true` if no elements of the list match the predicate, `false`
	     * otherwise.
	     *
	     * Dispatches to the `any` method of the second argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.12.0
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> Boolean
	     * @param {Function} fn The predicate function.
	     * @param {Array} list The array to consider.
	     * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	     * @see R.all, R.any
	     * @example
	     *
	     *      var isEven = n => n % 2 === 0;
	     *
	     *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	     *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
	     */
	    var none = _curry2(_complement(_dispatchable('any', _xany, any)));
	
	    /**
	     * A function that returns the `!` of its argument. It will return `true` when
	     * passed false-y value, and `false` when passed a truth-y one.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Logic
	     * @sig * -> Boolean
	     * @param {*} a any value
	     * @return {Boolean} the logical inverse of passed argument.
	     * @see R.complement
	     * @example
	     *
	     *      R.not(true); //=> false
	     *      R.not(false); //=> true
	     *      R.not(0); => true
	     *      R.not(1); => false
	     */
	    var not = _curry1(function not(a) {
	        return !a;
	    });
	
	    /**
	     * Returns the nth element of the given list or string. If n is negative the
	     * element at index length + n is returned.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig Number -> [a] -> a | Undefined
	     * @sig Number -> String -> String
	     * @param {Number} offset
	     * @param {*} list
	     * @return {*}
	     * @example
	     *
	     *      var list = ['foo', 'bar', 'baz', 'quux'];
	     *      R.nth(1, list); //=> 'bar'
	     *      R.nth(-1, list); //=> 'quux'
	     *      R.nth(-99, list); //=> undefined
	     *
	     *      R.nth('abc', 2); //=> 'c'
	     *      R.nth('abc', 3); //=> ''
	     */
	    var nth = _curry2(function nth(offset, list) {
	        var idx = offset < 0 ? list.length + offset : offset;
	        return _isString(list) ? list.charAt(idx) : list[idx];
	    });
	
	    /**
	     * Returns a function which returns its nth argument.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Function
	     * @sig Number -> *... -> *
	     * @param {Number} n
	     * @return {Function}
	     * @example
	     *
	     *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
	     *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
	     */
	    var nthArg = _curry1(function nthArg(n) {
	        return function () {
	            return nth(n, arguments);
	        };
	    });
	
	    /**
	     * Creates an object containing a single key:value pair.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.18.0
	     * @category Object
	     * @sig String -> a -> {String:a}
	     * @param {String} key
	     * @param {*} val
	     * @return {Object}
	     * @see R.pair
	     * @example
	     *
	     *      var matchPhrases = R.compose(
	     *        R.objOf('must'),
	     *        R.map(R.objOf('match_phrase'))
	     *      );
	     *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	     */
	    var objOf = _curry2(function objOf(key, val) {
	        var obj = {};
	        obj[key] = val;
	        return obj;
	    });
	
	    /**
	     * Returns a singleton array containing the value provided.
	     *
	     * Note this `of` is different from the ES6 `of`; See
	     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	     *
	     * @func
	     * @memberOf R
	     * @since v0.3.0
	     * @category Function
	     * @sig a -> [a]
	     * @param {*} x any value
	     * @return {Array} An array wrapping `x`.
	     * @example
	     *
	     *      R.of(null); //=> [null]
	     *      R.of([42]); //=> [[42]]
	     */
	    var of = _curry1(_of);
	
	    /**
	     * Accepts a function `fn` and returns a function that guards invocation of
	     * `fn` such that `fn` can only ever be called once, no matter how many times
	     * the returned function is invoked. The first value calculated is returned in
	     * subsequent invocations.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig (a... -> b) -> (a... -> b)
	     * @param {Function} fn The function to wrap in a call-only-once wrapper.
	     * @return {Function} The wrapped function.
	     * @example
	     *
	     *      var addOneOnce = R.once(x => x + 1);
	     *      addOneOnce(10); //=> 11
	     *      addOneOnce(addOneOnce(50)); //=> 11
	     */
	    var once = _curry1(function once(fn) {
	        var called = false;
	        var result;
	        return _arity(fn.length, function () {
	            if (called) {
	                return result;
	            }
	            called = true;
	            result = fn.apply(this, arguments);
	            return result;
	        });
	    });
	
	    /**
	     * Returns `true` if one or both of its arguments are `true`. Returns `false`
	     * if both arguments are `false`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Logic
	     * @sig * -> * -> *
	     * @param {Boolean} a A boolean value
	     * @param {Boolean} b A boolean value
	     * @return {Boolean} `true` if one or both arguments are `true`, `false` otherwise
	     * @see R.either
	     * @example
	     *
	     *      R.or(true, true); //=> true
	     *      R.or(true, false); //=> true
	     *      R.or(false, true); //=> true
	     *      R.or(false, false); //=> false
	     */
	    var or = _curry2(function or(a, b) {
	        return a || b;
	    });
	
	    /**
	     * Returns the result of "setting" the portion of the given data structure
	     * focused by the given lens to the result of applying the given function to
	     * the focused value.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category Object
	     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	     * @sig Lens s a -> (a -> a) -> s -> s
	     * @param {Lens} lens
	     * @param {*} v
	     * @param {*} x
	     * @return {*}
	     * @see R.prop, R.lensIndex, R.lensProp
	     * @example
	     *
	     *      var headLens = R.lensIndex(0);
	     *
	     *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	     */
	    var over = function () {
	        var Identity = function (x) {
	            return {
	                value: x,
	                map: function (f) {
	                    return Identity(f(x));
	                }
	            };
	        };
	        return _curry3(function over(lens, f, x) {
	            return lens(function (y) {
	                return Identity(f(y));
	            })(x).value;
	        });
	    }();
	
	    /**
	     * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.18.0
	     * @category List
	     * @sig a -> b -> (a,b)
	     * @param {*} fst
	     * @param {*} snd
	     * @return {Array}
	     * @see R.createMapEntry, R.of
	     * @example
	     *
	     *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
	     */
	    var pair = _curry2(function pair(fst, snd) {
	        return [
	            fst,
	            snd
	        ];
	    });
	
	    /**
	     * Retrieve the value at a given path.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.2.0
	     * @category Object
	     * @sig [String] -> {k: v} -> v | Undefined
	     * @param {Array} path The path to use.
	     * @param {Object} obj The object to retrieve the nested property from.
	     * @return {*} The data at `path`.
	     * @example
	     *
	     *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	     *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	     */
	    var path = _curry2(function path(paths, obj) {
	        var val = obj;
	        var idx = 0;
	        while (idx < paths.length) {
	            if (val == null) {
	                return;
	            }
	            val = val[paths[idx]];
	            idx += 1;
	        }
	        return val;
	    });
	
	    /**
	     * If the given, non-null object has a value at the given path, returns the
	     * value at that path. Otherwise returns the provided default value.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.18.0
	     * @category Object
	     * @sig a -> [String] -> Object -> a
	     * @param {*} d The default value.
	     * @param {Array} p The path to use.
	     * @param {Object} obj The object to retrieve the nested property from.
	     * @return {*} The data at `path` of the supplied object or the default value.
	     * @example
	     *
	     *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	     *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	     */
	    var pathOr = _curry3(function pathOr(d, p, obj) {
	        return defaultTo(d, path(p, obj));
	    });
	
	    /**
	     * Returns `true` if the specified object property at given path satisfies the
	     * given predicate; `false` otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category Logic
	     * @sig (a -> Boolean) -> [String] -> Object -> Boolean
	     * @param {Function} pred
	     * @param {Array} propPath
	     * @param {*} obj
	     * @return {Boolean}
	     * @see R.propSatisfies, R.path
	     * @example
	     *
	     *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
	     */
	    var pathSatisfies = _curry3(function pathSatisfies(pred, propPath, obj) {
	        return propPath.length > 0 && pred(path(propPath, obj));
	    });
	
	    /**
	     * Returns a partial copy of an object containing only the keys specified. If
	     * the key does not exist, the property is ignored.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @sig [k] -> {k: v} -> {k: v}
	     * @param {Array} names an array of String property names to copy onto a new object
	     * @param {Object} obj The object to copy from
	     * @return {Object} A new object with only properties from `names` on it.
	     * @see R.omit, R.props
	     * @example
	     *
	     *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	     *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	     */
	    var pick = _curry2(function pick(names, obj) {
	        var result = {};
	        var idx = 0;
	        while (idx < names.length) {
	            if (names[idx] in obj) {
	                result[names[idx]] = obj[names[idx]];
	            }
	            idx += 1;
	        }
	        return result;
	    });
	
	    /**
	     * Similar to `pick` except that this one includes a `key: undefined` pair for
	     * properties that don't exist.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @sig [k] -> {k: v} -> {k: v}
	     * @param {Array} names an array of String property names to copy onto a new object
	     * @param {Object} obj The object to copy from
	     * @return {Object} A new object with only properties from `names` on it.
	     * @see R.pick
	     * @example
	     *
	     *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	     *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
	     */
	    var pickAll = _curry2(function pickAll(names, obj) {
	        var result = {};
	        var idx = 0;
	        var len = names.length;
	        while (idx < len) {
	            var name = names[idx];
	            result[name] = obj[name];
	            idx += 1;
	        }
	        return result;
	    });
	
	    /**
	     * Returns a partial copy of an object containing only the keys that satisfy
	     * the supplied predicate.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category Object
	     * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
	     * @param {Function} pred A predicate to determine whether or not a key
	     *        should be included on the output object.
	     * @param {Object} obj The object to copy from
	     * @return {Object} A new object with only properties that satisfy `pred`
	     *         on it.
	     * @see R.pick, R.filter
	     * @example
	     *
	     *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	     *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	     */
	    var pickBy = _curry2(function pickBy(test, obj) {
	        var result = {};
	        for (var prop in obj) {
	            if (test(obj[prop], prop, obj)) {
	                result[prop] = obj[prop];
	            }
	        }
	        return result;
	    });
	
	    /**
	     * Returns a new list with the given element at the front, followed by the
	     * contents of the list.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig a -> [a] -> [a]
	     * @param {*} el The item to add to the head of the output list.
	     * @param {Array} list The array to add to the tail of the output list.
	     * @return {Array} A new array.
	     * @see R.append
	     * @example
	     *
	     *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	     */
	    var prepend = _curry2(function prepend(el, list) {
	        return _concat([el], list);
	    });
	
	    /**
	     * Returns a function that when supplied an object returns the indicated
	     * property of that object, if it exists.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @sig s -> {s: a} -> a | Undefined
	     * @param {String} p The property name
	     * @param {Object} obj The object to query
	     * @return {*} The value at `obj.p`.
	     * @example
	     *
	     *      R.prop('x', {x: 100}); //=> 100
	     *      R.prop('x', {}); //=> undefined
	     */
	    var prop = _curry2(function prop(p, obj) {
	        return obj[p];
	    });
	
	    /**
	     * If the given, non-null object has an own property with the specified name,
	     * returns the value of that property. Otherwise returns the provided default
	     * value.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.6.0
	     * @category Object
	     * @sig a -> String -> Object -> a
	     * @param {*} val The default value.
	     * @param {String} p The name of the property to return.
	     * @param {Object} obj The object to query.
	     * @return {*} The value of given property of the supplied object or the default value.
	     * @example
	     *
	     *      var alice = {
	     *        name: 'ALICE',
	     *        age: 101
	     *      };
	     *      var favorite = R.prop('favoriteLibrary');
	     *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	     *
	     *      favorite(alice);  //=> undefined
	     *      favoriteWithDefault(alice);  //=> 'Ramda'
	     */
	    var propOr = _curry3(function propOr(val, p, obj) {
	        return obj != null && _has(p, obj) ? obj[p] : val;
	    });
	
	    /**
	     * Returns `true` if the specified object property satisfies the given
	     * predicate; `false` otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category Logic
	     * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	     * @param {Function} pred
	     * @param {String} name
	     * @param {*} obj
	     * @return {Boolean}
	     * @see R.propEq, R.propIs
	     * @example
	     *
	     *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	     */
	    var propSatisfies = _curry3(function propSatisfies(pred, name, obj) {
	        return pred(obj[name]);
	    });
	
	    /**
	     * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	     * order.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @sig [k] -> {k: v} -> [v]
	     * @param {Array} ps The property names to fetch
	     * @param {Object} obj The object to query
	     * @return {Array} The corresponding values or partially applied function.
	     * @example
	     *
	     *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	     *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	     *
	     *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	     *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	     */
	    var props = _curry2(function props(ps, obj) {
	        var len = ps.length;
	        var out = [];
	        var idx = 0;
	        while (idx < len) {
	            out[idx] = obj[ps[idx]];
	            idx += 1;
	        }
	        return out;
	    });
	
	    /**
	     * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig Number -> Number -> [Number]
	     * @param {Number} from The first number in the list.
	     * @param {Number} to One more than the last number in the list.
	     * @return {Array} The list of numbers in tthe set `[a, b)`.
	     * @example
	     *
	     *      R.range(1, 5);    //=> [1, 2, 3, 4]
	     *      R.range(50, 53);  //=> [50, 51, 52]
	     */
	    var range = _curry2(function range(from, to) {
	        if (!(_isNumber(from) && _isNumber(to))) {
	            throw new TypeError('Both arguments to range must be numbers');
	        }
	        var result = [];
	        var n = from;
	        while (n < to) {
	            result.push(n);
	            n += 1;
	        }
	        return result;
	    });
	
	    /**
	     * Returns a single item by iterating through the list, successively calling
	     * the iterator function and passing it an accumulator value and the current
	     * value from the array, and then passing the result to the next call.
	     *
	     * Similar to `reduce`, except moves through the input list from the right to
	     * the left.
	     *
	     * The iterator function receives two values: *(acc, value)*
	     *
	     * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
	     * arrays), unlike the native `Array.prototype.reduce` method. For more details
	     * on this behavior, see:
	     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig (a,b -> a) -> a -> [b] -> a
	     * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	     *        current element from the array.
	     * @param {*} acc The accumulator value.
	     * @param {Array} list The list to iterate over.
	     * @return {*} The final, accumulated value.
	     * @see R.addIndex
	     * @example
	     *
	     *      var pairs = [ ['a', 1], ['b', 2], ['c', 3] ];
	     *      var flattenPairs = (acc, pair) => acc.concat(pair);
	     *
	     *      R.reduceRight(flattenPairs, [], pairs); //=> [ 'c', 3, 'b', 2, 'a', 1 ]
	     */
	    var reduceRight = _curry3(function reduceRight(fn, acc, list) {
	        var idx = list.length - 1;
	        while (idx >= 0) {
	            acc = fn(acc, list[idx]);
	            idx -= 1;
	        }
	        return acc;
	    });
	
	    /**
	     * Returns a value wrapped to indicate that it is the final value of the reduce
	     * and transduce functions. The returned value should be considered a black
	     * box: the internal structure is not guaranteed to be stable.
	     *
	     * Note: this optimization is unavailable to functions not explicitly listed
	     * above. For instance, it is not currently supported by reduceRight.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.15.0
	     * @category List
	     * @sig a -> *
	     * @param {*} x The final value of the reduce.
	     * @return {*} The wrapped value.
	     * @see R.reduce, R.transduce
	     * @example
	     *
	     *      R.reduce(
	     *        R.pipe(R.add, R.when(R.gte(R.__, 10), R.reduced)),
	     *        0,
	     *        [1, 2, 3, 4, 5]) // 10
	     */
	    var reduced = _curry1(_reduced);
	
	    /**
	     * Removes the sub-list of `list` starting at index `start` and containing
	     * `count` elements. _Note that this is not destructive_: it returns a copy of
	     * the list with the changes.
	     * <small>No lists have been harmed in the application of this function.</small>
	     *
	     * @func
	     * @memberOf R
	     * @since v0.2.2
	     * @category List
	     * @sig Number -> Number -> [a] -> [a]
	     * @param {Number} start The position to start removing elements
	     * @param {Number} count The number of elements to remove
	     * @param {Array} list The list to remove from
	     * @return {Array} A new Array with `count` elements from `start` removed.
	     * @example
	     *
	     *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
	     */
	    var remove = _curry3(function remove(start, count, list) {
	        return _concat(_slice(list, 0, Math.min(start, list.length)), _slice(list, Math.min(list.length, start + count)));
	    });
	
	    /**
	     * Replace a substring or regex match in a string with a replacement.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.7.0
	     * @category String
	     * @sig RegExp|String -> String -> String -> String
	     * @param {RegExp|String} pattern A regular expression or a substring to match.
	     * @param {String} replacement The string to replace the matches with.
	     * @param {String} str The String to do the search and replacement in.
	     * @return {String} The result.
	     * @example
	     *
	     *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
	     *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
	     *
	     *      // Use the "g" (global) flag to replace all occurrences:
	     *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
	     */
	    var replace = _curry3(function replace(regex, replacement, str) {
	        return str.replace(regex, replacement);
	    });
	
	    /**
	     * Returns a new list or string with the elements or characters in reverse
	     * order.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig [a] -> [a]
	     * @sig String -> String
	     * @param {Array|String} list
	     * @return {Array|String}
	     * @example
	     *
	     *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	     *      R.reverse([1, 2]);     //=> [2, 1]
	     *      R.reverse([1]);        //=> [1]
	     *      R.reverse([]);         //=> []
	     *
	     *      R.reverse('abc');      //=> 'cba'
	     *      R.reverse('ab');       //=> 'ba'
	     *      R.reverse('a');        //=> 'a'
	     *      R.reverse('');         //=> ''
	     */
	    var reverse = _curry1(function reverse(list) {
	        return _isString(list) ? list.split('').reverse().join('') : _slice(list).reverse();
	    });
	
	    /**
	     * Scan is similar to reduce, but returns a list of successively reduced values
	     * from the left
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category List
	     * @sig (a,b -> a) -> a -> [b] -> [a]
	     * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	     *        current element from the array
	     * @param {*} acc The accumulator value.
	     * @param {Array} list The list to iterate over.
	     * @return {Array} A list of all intermediately reduced values.
	     * @example
	     *
	     *      var numbers = [1, 2, 3, 4];
	     *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
	     */
	    var scan = _curry3(function scan(fn, acc, list) {
	        var idx = 0;
	        var len = list.length;
	        var result = [acc];
	        while (idx < len) {
	            acc = fn(acc, list[idx]);
	            result[idx + 1] = acc;
	            idx += 1;
	        }
	        return result;
	    });
	
	    /**
	     * Returns the result of "setting" the portion of the given data structure
	     * focused by the given lens to the given value.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category Object
	     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	     * @sig Lens s a -> a -> s -> s
	     * @param {Lens} lens
	     * @param {*} v
	     * @param {*} x
	     * @return {*}
	     * @see R.prop, R.lensIndex, R.lensProp
	     * @example
	     *
	     *      var xLens = R.lensProp('x');
	     *
	     *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	     *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	     */
	    var set = _curry3(function set(lens, v, x) {
	        return over(lens, always(v), x);
	    });
	
	    /**
	     * Returns the elements of the given list or string (or object with a `slice`
	     * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	     *
	     * Dispatches to the `slice` method of the third argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.4
	     * @category List
	     * @sig Number -> Number -> [a] -> [a]
	     * @sig Number -> Number -> String -> String
	     * @param {Number} fromIndex The start index (inclusive).
	     * @param {Number} toIndex The end index (exclusive).
	     * @param {*} list
	     * @return {*}
	     * @example
	     *
	     *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	     *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	     *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	     *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	     *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	     */
	    var slice = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	        return Array.prototype.slice.call(list, fromIndex, toIndex);
	    }));
	
	    /**
	     * Returns a copy of the list, sorted according to the comparator function,
	     * which should accept two values at a time and return a negative number if the
	     * first value is smaller, a positive number if it's larger, and zero if they
	     * are equal. Please note that this is a **copy** of the list. It does not
	     * modify the original.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig (a,a -> Number) -> [a] -> [a]
	     * @param {Function} comparator A sorting function :: a -> b -> Int
	     * @param {Array} list The list to sort
	     * @return {Array} a new array with its elements sorted by the comparator function.
	     * @example
	     *
	     *      var diff = function(a, b) { return a - b; };
	     *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
	     */
	    var sort = _curry2(function sort(comparator, list) {
	        return _slice(list).sort(comparator);
	    });
	
	    /**
	     * Sorts the list according to the supplied function.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig Ord b => (a -> b) -> [a] -> [a]
	     * @param {Function} fn
	     * @param {Array} list The list to sort.
	     * @return {Array} A new list sorted by the keys generated by `fn`.
	     * @example
	     *
	     *      var sortByFirstItem = R.sortBy(R.prop(0));
	     *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
	     *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
	     *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
	     *      var alice = {
	     *        name: 'ALICE',
	     *        age: 101
	     *      };
	     *      var bob = {
	     *        name: 'Bob',
	     *        age: -10
	     *      };
	     *      var clara = {
	     *        name: 'clara',
	     *        age: 314.159
	     *      };
	     *      var people = [clara, bob, alice];
	     *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
	     */
	    var sortBy = _curry2(function sortBy(fn, list) {
	        return _slice(list).sort(function (a, b) {
	            var aa = fn(a);
	            var bb = fn(b);
	            return aa < bb ? -1 : aa > bb ? 1 : 0;
	        });
	    });
	
	    /**
	     * Splits a given list or string at a given index.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category List
	     * @sig Number -> [a] -> [[a], [a]]
	     * @sig Number -> String -> [String, String]
	     * @param {Number} index The index where the array/string is split.
	     * @param {Array|String} array The array/string to be split.
	     * @return {Array}
	     * @example
	     *
	     *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
	     *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
	     *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
	     */
	    var splitAt = _curry2(function splitAt(index, array) {
	        return [
	            slice(0, index, array),
	            slice(index, length(array), array)
	        ];
	    });
	
	    /**
	     * Splits a collection into slices of the specified length.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category List
	     * @sig Number -> [a] -> [[a]]
	     * @sig Number -> String -> [String]
	     * @param {Number} n
	     * @param {Array} list
	     * @return {Array}
	     * @example
	     *
	     *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
	     *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
	     */
	    var splitEvery = _curry2(function splitEvery(n, list) {
	        if (n <= 0) {
	            throw new Error('First argument to splitEvery must be a positive integer');
	        }
	        var result = [];
	        var idx = 0;
	        while (idx < list.length) {
	            result.push(slice(idx, idx += n, list));
	        }
	        return result;
	    });
	
	    /**
	     * Takes a list and a predicate and returns a pair of lists with the following properties:
	     *
	     *  - the result of concatenating the two output lists is equivalent to the input list;
	     *  - none of the elements of the first output list satisfies the predicate; and
	     *  - if the second output list is non-empty, its first element satisfies the predicate.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> [[a], [a]]
	     * @param {Function} pred The predicate that determines where the array is split.
	     * @param {Array} list The array to be split.
	     * @return {Array}
	     * @example
	     *
	     *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
	     */
	    var splitWhen = _curry2(function splitWhen(pred, list) {
	        var idx = 0;
	        var len = list.length;
	        var prefix = [];
	        while (idx < len && !pred(list[idx])) {
	            prefix.push(list[idx]);
	            idx += 1;
	        }
	        return [
	            prefix,
	            _slice(list, idx)
	        ];
	    });
	
	    /**
	     * Subtracts two numbers. Equivalent to `a - b` but curried.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Math
	     * @sig Number -> Number -> Number
	     * @param {Number} a The first value.
	     * @param {Number} b The second value.
	     * @return {Number} The result of `a - b`.
	     * @see R.add
	     * @example
	     *
	     *      R.subtract(10, 8); //=> 2
	     *
	     *      var minus5 = R.subtract(R.__, 5);
	     *      minus5(17); //=> 12
	     *
	     *      var complementaryAngle = R.subtract(90);
	     *      complementaryAngle(30); //=> 60
	     *      complementaryAngle(72); //=> 18
	     */
	    var subtract = _curry2(function subtract(a, b) {
	        return a - b;
	    });
	
	    /**
	     * Returns all but the first element of the given list or string (or object
	     * with a `tail` method).
	     *
	     * Dispatches to the `slice` method of the first argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig [a] -> [a]
	     * @sig String -> String
	     * @param {*} list
	     * @return {*}
	     * @see R.head, R.init, R.last
	     * @example
	     *
	     *      R.tail([1, 2, 3]);  //=> [2, 3]
	     *      R.tail([1, 2]);     //=> [2]
	     *      R.tail([1]);        //=> []
	     *      R.tail([]);         //=> []
	     *
	     *      R.tail('abc');  //=> 'bc'
	     *      R.tail('ab');   //=> 'b'
	     *      R.tail('a');    //=> ''
	     *      R.tail('');     //=> ''
	     */
	    var tail = _checkForMethod('tail', slice(1, Infinity));
	
	    /**
	     * Returns the first `n` elements of the given list, string, or
	     * transducer/transformer (or object with a `take` method).
	     *
	     * Dispatches to the `take` method of the second argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig Number -> [a] -> [a]
	     * @sig Number -> String -> String
	     * @param {Number} n
	     * @param {*} list
	     * @return {*}
	     * @see R.drop
	     * @example
	     *
	     *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
	     *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	     *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	     *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	     *      R.take(3, 'ramda');               //=> 'ram'
	     *
	     *      var personnel = [
	     *        'Dave Brubeck',
	     *        'Paul Desmond',
	     *        'Eugene Wright',
	     *        'Joe Morello',
	     *        'Gerry Mulligan',
	     *        'Bob Bates',
	     *        'Joe Dodge',
	     *        'Ron Crotty'
	     *      ];
	     *
	     *      var takeFive = R.take(5);
	     *      takeFive(personnel);
	     *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
	     */
	    var take = _curry2(_dispatchable('take', _xtake, function take(n, xs) {
	        return slice(0, n < 0 ? Infinity : n, xs);
	    }));
	
	    /**
	     * Returns a new list containing the last `n` elements of a given list, passing
	     * each value to the supplied predicate function, and terminating when the
	     * predicate function returns `false`. Excludes the element that caused the
	     * predicate function to fail. The predicate function is passed one argument:
	     * *(value)*.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> [a]
	     * @param {Function} fn The function called per iteration.
	     * @param {Array} list The collection to iterate over.
	     * @return {Array} A new array.
	     * @see R.dropLastWhile, R.addIndex
	     * @example
	     *
	     *      var isNotOne = x => x !== 1;
	     *
	     *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
	     */
	    var takeLastWhile = _curry2(function takeLastWhile(fn, list) {
	        var idx = list.length - 1;
	        while (idx >= 0 && fn(list[idx])) {
	            idx -= 1;
	        }
	        return _slice(list, idx + 1, Infinity);
	    });
	
	    /**
	     * Returns a new list containing the first `n` elements of a given list,
	     * passing each value to the supplied predicate function, and terminating when
	     * the predicate function returns `false`. Excludes the element that caused the
	     * predicate function to fail. The predicate function is passed one argument:
	     * *(value)*.
	     *
	     * Dispatches to the `takeWhile` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> [a]
	     * @param {Function} fn The function called per iteration.
	     * @param {Array} list The collection to iterate over.
	     * @return {Array} A new array.
	     * @see R.dropWhile, R.transduce, R.addIndex
	     * @example
	     *
	     *      var isNotFour = x => x !== 4;
	     *
	     *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
	     */
	    var takeWhile = _curry2(_dispatchable('takeWhile', _xtakeWhile, function takeWhile(fn, list) {
	        var idx = 0;
	        var len = list.length;
	        while (idx < len && fn(list[idx])) {
	            idx += 1;
	        }
	        return _slice(list, 0, idx);
	    }));
	
	    /**
	     * Runs the given function with the supplied object, then returns the object.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig (a -> *) -> a -> a
	     * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
	     * @param {*} x
	     * @return {*} `x`.
	     * @example
	     *
	     *      var sayX = x => console.log('x is ' + x);
	     *      R.tap(sayX, 100); //=> 100
	     *      //-> 'x is 100'
	     */
	    var tap = _curry2(function tap(fn, x) {
	        fn(x);
	        return x;
	    });
	
	    /**
	     * Calls an input function `n` times, returning an array containing the results
	     * of those function calls.
	     *
	     * `fn` is passed one argument: The current value of `n`, which begins at `0`
	     * and is gradually incremented to `n - 1`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.2.3
	     * @category List
	     * @sig (Number -> a) -> Number -> [a]
	     * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
	     * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
	     * @return {Array} An array containing the return values of all calls to `fn`.
	     * @example
	     *
	     *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
	     */
	    var times = _curry2(function times(fn, n) {
	        var len = Number(n);
	        var idx = 0;
	        var list;
	        if (len < 0 || isNaN(len)) {
	            throw new RangeError('n must be a non-negative number');
	        }
	        list = new Array(len);
	        while (idx < len) {
	            list[idx] = fn(idx);
	            idx += 1;
	        }
	        return list;
	    });
	
	    /**
	     * Converts an object into an array of key, value arrays. Only the object's
	     * own properties are used.
	     * Note that the order of the output array is not guaranteed to be consistent
	     * across different JS platforms.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.4.0
	     * @category Object
	     * @sig {String: *} -> [[String,*]]
	     * @param {Object} obj The object to extract from
	     * @return {Array} An array of key, value arrays from the object's own properties.
	     * @see R.fromPairs
	     * @example
	     *
	     *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	     */
	    var toPairs = _curry1(function toPairs(obj) {
	        var pairs = [];
	        for (var prop in obj) {
	            if (_has(prop, obj)) {
	                pairs[pairs.length] = [
	                    prop,
	                    obj[prop]
	                ];
	            }
	        }
	        return pairs;
	    });
	
	    /**
	     * Converts an object into an array of key, value arrays. The object's own
	     * properties and prototype properties are used. Note that the order of the
	     * output array is not guaranteed to be consistent across different JS
	     * platforms.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.4.0
	     * @category Object
	     * @sig {String: *} -> [[String,*]]
	     * @param {Object} obj The object to extract from
	     * @return {Array} An array of key, value arrays from the object's own
	     *         and prototype properties.
	     * @example
	     *
	     *      var F = function() { this.x = 'X'; };
	     *      F.prototype.y = 'Y';
	     *      var f = new F();
	     *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
	     */
	    var toPairsIn = _curry1(function toPairsIn(obj) {
	        var pairs = [];
	        for (var prop in obj) {
	            pairs[pairs.length] = [
	                prop,
	                obj[prop]
	            ];
	        }
	        return pairs;
	    });
	
	    /**
	     * Transposes the rows and columns of a 2D list.
	     * When passed a list of `n` lists of length `x`,
	     * returns a list of `x` lists of length `n`.
	     *
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category List
	     * @sig [[a]] -> [[a]]
	     * @param {Array} list A 2D list
	     * @return {Array} A 2D list
	     * @example
	     *
	     *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
	     *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	     *
	     * If some of the rows are shorter than the following rows, their elements are skipped:
	     *
	     *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
	     */
	    var transpose = _curry1(function transpose(outerlist) {
	        var i = 0;
	        var result = [];
	        while (i < outerlist.length) {
	            var innerlist = outerlist[i];
	            var j = 0;
	            while (j < innerlist.length) {
	                if (typeof result[j] === 'undefined') {
	                    result[j] = [];
	                }
	                result[j].push(innerlist[j]);
	                j += 1;
	            }
	            i += 1;
	        }
	        return result;
	    });
	
	    /**
	     * Removes (strips) whitespace from both ends of the string.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.6.0
	     * @category String
	     * @sig String -> String
	     * @param {String} str The string to trim.
	     * @return {String} Trimmed version of `str`.
	     * @example
	     *
	     *      R.trim('   xyz  '); //=> 'xyz'
	     *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
	     */
	    var trim = function () {
	        var ws = '\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' + '\u2029\uFEFF';
	        var zeroWidth = '\u200B';
	        var hasProtoTrim = typeof String.prototype.trim === 'function';
	        if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
	            return _curry1(function trim(str) {
	                var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
	                var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
	                return str.replace(beginRx, '').replace(endRx, '');
	            });
	        } else {
	            return _curry1(function trim(str) {
	                return str.trim();
	            });
	        }
	    }();
	
	    /**
	     * Gives a single-word string description of the (native) type of a value,
	     * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	     * attempt to distinguish user Object types any further, reporting them all as
	     * 'Object'.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category Type
	     * @sig (* -> {*}) -> String
	     * @param {*} val The value to test
	     * @return {String}
	     * @example
	     *
	     *      R.type({}); //=> "Object"
	     *      R.type(1); //=> "Number"
	     *      R.type(false); //=> "Boolean"
	     *      R.type('s'); //=> "String"
	     *      R.type(null); //=> "Null"
	     *      R.type([]); //=> "Array"
	     *      R.type(/[A-z]/); //=> "RegExp"
	     */
	    var type = _curry1(function type(val) {
	        return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
	    });
	
	    /**
	     * Takes a function `fn`, which takes a single array argument, and returns a
	     * function which:
	     *
	     *   - takes any number of positional arguments;
	     *   - passes these arguments to `fn` as an array; and
	     *   - returns the result.
	     *
	     * In other words, R.unapply derives a variadic function from a function which
	     * takes an array. R.unapply is the inverse of R.apply.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category Function
	     * @sig ([*...] -> a) -> (*... -> a)
	     * @param {Function} fn
	     * @return {Function}
	     * @see R.apply
	     * @example
	     *
	     *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	     */
	    var unapply = _curry1(function unapply(fn) {
	        return function () {
	            return fn(_slice(arguments));
	        };
	    });
	
	    /**
	     * Wraps a function of any arity (including nullary) in a function that accepts
	     * exactly 1 parameter. Any extraneous parameters will not be passed to the
	     * supplied function.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.2.0
	     * @category Function
	     * @sig (* -> b) -> (a -> b)
	     * @param {Function} fn The function to wrap.
	     * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	     *         arity 1.
	     * @example
	     *
	     *      var takesTwoArgs = function(a, b) {
	     *        return [a, b];
	     *      };
	     *      takesTwoArgs.length; //=> 2
	     *      takesTwoArgs(1, 2); //=> [1, 2]
	     *
	     *      var takesOneArg = R.unary(takesTwoArgs);
	     *      takesOneArg.length; //=> 1
	     *      // Only 1 argument is passed to the wrapped function
	     *      takesOneArg(1, 2); //=> [1, undefined]
	     */
	    var unary = _curry1(function unary(fn) {
	        return nAry(1, fn);
	    });
	
	    /**
	     * Returns a function of arity `n` from a (manually) curried function.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category Function
	     * @sig Number -> (a -> b) -> (a -> c)
	     * @param {Number} length The arity for the returned function.
	     * @param {Function} fn The function to uncurry.
	     * @return {Function} A new function.
	     * @see R.curry
	     * @example
	     *
	     *      var addFour = a => b => c => d => a + b + c + d;
	     *
	     *      var uncurriedAddFour = R.uncurryN(4, addFour);
	     *      uncurriedAddFour(1, 2, 3, 4); //=> 10
	     */
	    var uncurryN = _curry2(function uncurryN(depth, fn) {
	        return curryN(depth, function () {
	            var currentDepth = 1;
	            var value = fn;
	            var idx = 0;
	            var endIdx;
	            while (currentDepth <= depth && typeof value === 'function') {
	                endIdx = currentDepth === depth ? arguments.length : idx + value.length;
	                value = value.apply(this, _slice(arguments, idx, endIdx));
	                currentDepth += 1;
	                idx = endIdx;
	            }
	            return value;
	        });
	    });
	
	    /**
	     * Builds a list from a seed value. Accepts an iterator function, which returns
	     * either false to stop iteration or an array of length 2 containing the value
	     * to add to the resulting list and the seed to be used in the next call to the
	     * iterator function.
	     *
	     * The iterator function receives one argument: *(seed)*.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category List
	     * @sig (a -> [b]) -> * -> [b]
	     * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
	     *        either false to quit iteration or an array of length two to proceed. The element
	     *        at index 0 of this array will be added to the resulting array, and the element
	     *        at index 1 will be passed to the next call to `fn`.
	     * @param {*} seed The seed value.
	     * @return {Array} The final list.
	     * @example
	     *
	     *      var f = n => n > 50 ? false : [-n, n + 10];
	     *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
	     */
	    var unfold = _curry2(function unfold(fn, seed) {
	        var pair = fn(seed);
	        var result = [];
	        while (pair && pair.length) {
	            result[result.length] = pair[0];
	            pair = fn(pair[1]);
	        }
	        return result;
	    });
	
	    /**
	     * Returns a new list containing only one copy of each element in the original
	     * list, based upon the value returned by applying the supplied predicate to
	     * two list elements. Prefers the first item if two items compare equal based
	     * on the predicate.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.2.0
	     * @category List
	     * @sig (a, a -> Boolean) -> [a] -> [a]
	     * @param {Function} pred A predicate used to test whether two items are equal.
	     * @param {Array} list The array to consider.
	     * @return {Array} The list of unique items.
	     * @example
	     *
	     *      var strEq = R.eqBy(String);
	     *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
	     *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
	     *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
	     *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
	     */
	    var uniqWith = _curry2(function uniqWith(pred, list) {
	        var idx = 0;
	        var len = list.length;
	        var result = [];
	        var item;
	        while (idx < len) {
	            item = list[idx];
	            if (!_containsWith(pred, item, result)) {
	                result[result.length] = item;
	            }
	            idx += 1;
	        }
	        return result;
	    });
	
	    /**
	     * Tests the final argument by passing it to the given predicate function. If
	     * the predicate is not satisfied, the function will return the result of
	     * calling the `whenFalseFn` function with the same argument. If the predicate
	     * is satisfied, the argument is returned as is.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.18.0
	     * @category Logic
	     * @sig (a -> Boolean) -> (a -> a) -> a -> a
	     * @param {Function} pred        A predicate function
	     * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	     *                               to a falsy value.
	     * @param {*}        x           An object to test with the `pred` function and
	     *                               pass to `whenFalseFn` if necessary.
	     * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	     * @see R.ifElse, R.when
	     * @example
	     *
	     *      // coerceArray :: (a|[a]) -> [a]
	     *      var coerceArray = R.unless(R.isArrayLike, R.of);
	     *      coerceArray([1, 2, 3]); //=> [1, 2, 3]
	     *      coerceArray(1);         //=> [1]
	     */
	    var unless = _curry3(function unless(pred, whenFalseFn, x) {
	        return pred(x) ? x : whenFalseFn(x);
	    });
	
	    /**
	     * Returns a new copy of the array with the element at the provided index
	     * replaced with the given value.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category List
	     * @sig Number -> a -> [a] -> [a]
	     * @param {Number} idx The index to update.
	     * @param {*} x The value to exist at the given index of the returned array.
	     * @param {Array|Arguments} list The source array-like object to be updated.
	     * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
	     * @see R.adjust
	     * @example
	     *
	     *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
	     *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
	     */
	    var update = _curry3(function update(idx, x, list) {
	        return adjust(always(x), idx, list);
	    });
	
	    /**
	     * Accepts a function `fn` and a list of transformer functions and returns a
	     * new curried function. When the new function is invoked, it calls the
	     * function `fn` with parameters consisting of the result of calling each
	     * supplied handler on successive arguments to the new function.
	     *
	     * If more arguments are passed to the returned function than transformer
	     * functions, those arguments are passed directly to `fn` as additional
	     * parameters. If you expect additional arguments that don't need to be
	     * transformed, although you can ignore them, it's best to pass an identity
	     * function so that the new function reports the correct arity.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	     * @param {Function} fn The function to wrap.
	     * @param {Array} transformers A list of transformer functions
	     * @return {Function} The wrapped function.
	     * @example
	     *
	     *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	     *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	     *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	     *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	     */
	    var useWith = _curry2(function useWith(fn, transformers) {
	        return curryN(transformers.length, function () {
	            var args = [];
	            var idx = 0;
	            while (idx < transformers.length) {
	                args.push(transformers[idx].call(this, arguments[idx]));
	                idx += 1;
	            }
	            return fn.apply(this, args.concat(_slice(arguments, transformers.length)));
	        });
	    });
	
	    /**
	     * Returns a list of all the enumerable own properties of the supplied object.
	     * Note that the order of the output array is not guaranteed across different
	     * JS platforms.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @sig {k: v} -> [v]
	     * @param {Object} obj The object to extract values from
	     * @return {Array} An array of the values of the object's own properties.
	     * @example
	     *
	     *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
	     */
	    var values = _curry1(function values(obj) {
	        var props = keys(obj);
	        var len = props.length;
	        var vals = [];
	        var idx = 0;
	        while (idx < len) {
	            vals[idx] = obj[props[idx]];
	            idx += 1;
	        }
	        return vals;
	    });
	
	    /**
	     * Returns a list of all the properties, including prototype properties, of the
	     * supplied object.
	     * Note that the order of the output array is not guaranteed to be consistent
	     * across different JS platforms.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.2.0
	     * @category Object
	     * @sig {k: v} -> [v]
	     * @param {Object} obj The object to extract values from
	     * @return {Array} An array of the values of the object's own and prototype properties.
	     * @example
	     *
	     *      var F = function() { this.x = 'X'; };
	     *      F.prototype.y = 'Y';
	     *      var f = new F();
	     *      R.valuesIn(f); //=> ['X', 'Y']
	     */
	    var valuesIn = _curry1(function valuesIn(obj) {
	        var prop;
	        var vs = [];
	        for (prop in obj) {
	            vs[vs.length] = obj[prop];
	        }
	        return vs;
	    });
	
	    /**
	     * Returns a "view" of the given data structure, determined by the given lens.
	     * The lens's focus determines which portion of the data structure is visible.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category Object
	     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	     * @sig Lens s a -> s -> a
	     * @param {Lens} lens
	     * @param {*} x
	     * @return {*}
	     * @see R.prop, R.lensIndex, R.lensProp
	     * @example
	     *
	     *      var xLens = R.lensProp('x');
	     *
	     *      R.view(xLens, {x: 1, y: 2});  //=> 1
	     *      R.view(xLens, {x: 4, y: 2});  //=> 4
	     */
	    var view = function () {
	        var Const = function (x) {
	            return {
	                value: x,
	                map: function () {
	                    return this;
	                }
	            };
	        };
	        return _curry2(function view(lens, x) {
	            return lens(Const)(x).value;
	        });
	    }();
	
	    /**
	     * Tests the final argument by passing it to the given predicate function. If
	     * the predicate is satisfied, the function will return the result of calling
	     * the `whenTrueFn` function with the same argument. If the predicate is not
	     * satisfied, the argument is returned as is.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.18.0
	     * @category Logic
	     * @sig (a -> Boolean) -> (a -> a) -> a -> a
	     * @param {Function} pred       A predicate function
	     * @param {Function} whenTrueFn A function to invoke when the `condition`
	     *                              evaluates to a truthy value.
	     * @param {*}        x          An object to test with the `pred` function and
	     *                              pass to `whenTrueFn` if necessary.
	     * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
	     * @see R.ifElse, R.unless
	     * @example
	     *
	     *      // truncate :: String -> String
	     *      var truncate = R.when(
	     *        R.propSatisfies(R.gt(R.__, 10), 'length'),
	     *        R.pipe(R.take(10), R.append('…'), R.join(''))
	     *      );
	     *      truncate('12345');         //=> '12345'
	     *      truncate('0123456789ABC'); //=> '0123456789…'
	     */
	    var when = _curry3(function when(pred, whenTrueFn, x) {
	        return pred(x) ? whenTrueFn(x) : x;
	    });
	
	    /**
	     * Takes a spec object and a test object; returns true if the test satisfies
	     * the spec. Each of the spec's own properties must be a predicate function.
	     * Each predicate is applied to the value of the corresponding property of the
	     * test object. `where` returns true if all the predicates return true, false
	     * otherwise.
	     *
	     * `where` is well suited to declaratively expressing constraints for other
	     * functions such as `filter` and `find`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.1
	     * @category Object
	     * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
	     * @param {Object} spec
	     * @param {Object} testObj
	     * @return {Boolean}
	     * @example
	     *
	     *      // pred :: Object -> Boolean
	     *      var pred = R.where({
	     *        a: R.equals('foo'),
	     *        b: R.complement(R.equals('bar')),
	     *        x: R.gt(_, 10),
	     *        y: R.lt(_, 20)
	     *      });
	     *
	     *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
	     *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
	     *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
	     *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
	     *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
	     */
	    var where = _curry2(function where(spec, testObj) {
	        for (var prop in spec) {
	            if (_has(prop, spec) && !spec[prop](testObj[prop])) {
	                return false;
	            }
	        }
	        return true;
	    });
	
	    /**
	     * Wrap a function inside another to allow you to make adjustments to the
	     * parameters, or do other processing either before the internal function is
	     * called or with its results.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig (a... -> b) -> ((a... -> b) -> a... -> c) -> (a... -> c)
	     * @param {Function} fn The function to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @return {Function} The wrapped function.
	     * @example
	     *
	     *      var greet = name => 'Hello ' + name;
	     *
	     *      var shoutedGreet = R.wrap(greet, (gr, name) => gr(name).toUpperCase());
	     *
	     *      shoutedGreet("Kathy"); //=> "HELLO KATHY"
	     *
	     *      var shortenedGreet = R.wrap(greet, function(gr, name) {
	     *        return gr(name.substring(0, 3));
	     *      });
	     *      shortenedGreet("Robert"); //=> "Hello Rob"
	     */
	    var wrap = _curry2(function wrap(fn, wrapper) {
	        return curryN(fn.length, function () {
	            return wrapper.apply(this, _concat([fn], arguments));
	        });
	    });
	
	    /**
	     * Creates a new list out of the two supplied by creating each possible pair
	     * from the lists.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig [a] -> [b] -> [[a,b]]
	     * @param {Array} as The first list.
	     * @param {Array} bs The second list.
	     * @return {Array} The list made by combining each possible pair from
	     *         `as` and `bs` into pairs (`[a, b]`).
	     * @example
	     *
	     *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
	     */
	    // = xprodWith(prepend); (takes about 3 times as long...)
	    var xprod = _curry2(function xprod(a, b) {
	        // = xprodWith(prepend); (takes about 3 times as long...)
	        var idx = 0;
	        var ilen = a.length;
	        var j;
	        var jlen = b.length;
	        var result = [];
	        while (idx < ilen) {
	            j = 0;
	            while (j < jlen) {
	                result[result.length] = [
	                    a[idx],
	                    b[j]
	                ];
	                j += 1;
	            }
	            idx += 1;
	        }
	        return result;
	    });
	
	    /**
	     * Creates a new list out of the two supplied by pairing up equally-positioned
	     * items from both lists. The returned list is truncated to the length of the
	     * shorter of the two input lists.
	     * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig [a] -> [b] -> [[a,b]]
	     * @param {Array} list1 The first array to consider.
	     * @param {Array} list2 The second array to consider.
	     * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
	     * @example
	     *
	     *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	     */
	    var zip = _curry2(function zip(a, b) {
	        var rv = [];
	        var idx = 0;
	        var len = Math.min(a.length, b.length);
	        while (idx < len) {
	            rv[idx] = [
	                a[idx],
	                b[idx]
	            ];
	            idx += 1;
	        }
	        return rv;
	    });
	
	    /**
	     * Creates a new object out of a list of keys and a list of values.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.3.0
	     * @category List
	     * @sig [String] -> [*] -> {String: *}
	     * @param {Array} keys The array that will be properties on the output object.
	     * @param {Array} values The list of values on the output object.
	     * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
	     * @example
	     *
	     *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
	     */
	    var zipObj = _curry2(function zipObj(keys, values) {
	        var idx = 0;
	        var len = keys.length;
	        var out = {};
	        while (idx < len) {
	            out[keys[idx]] = values[idx];
	            idx += 1;
	        }
	        return out;
	    });
	
	    /**
	     * Creates a new list out of the two supplied by applying the function to each
	     * equally-positioned pair in the lists. The returned list is truncated to the
	     * length of the shorter of the two input lists.
	     *
	     * @function
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig (a,b -> c) -> [a] -> [b] -> [c]
	     * @param {Function} fn The function used to combine the two elements into one value.
	     * @param {Array} list1 The first array to consider.
	     * @param {Array} list2 The second array to consider.
	     * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
	     *         using `fn`.
	     * @example
	     *
	     *      var f = (x, y) => {
	     *        // ...
	     *      };
	     *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
	     *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
	     */
	    var zipWith = _curry3(function zipWith(fn, a, b) {
	        var rv = [];
	        var idx = 0;
	        var len = Math.min(a.length, b.length);
	        while (idx < len) {
	            rv[idx] = fn(a[idx], b[idx]);
	            idx += 1;
	        }
	        return rv;
	    });
	
	    /**
	     * A function that always returns `false`. Any passed in parameters are ignored.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Function
	     * @sig * -> Boolean
	     * @param {*}
	     * @return {Boolean}
	     * @see R.always, R.T
	     * @example
	     *
	     *      R.F(); //=> false
	     */
	    var F = always(false);
	
	    /**
	     * A function that always returns `true`. Any passed in parameters are ignored.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Function
	     * @sig * -> Boolean
	     * @param {*}
	     * @return {Boolean}
	     * @see R.always, R.F
	     * @example
	     *
	     *      R.T(); //=> true
	     */
	    var T = always(true);
	
	    /**
	     * Copies an object.
	     *
	     * @private
	     * @param {*} value The value to be copied
	     * @param {Array} refFrom Array containing the source references
	     * @param {Array} refTo Array containing the copied source references
	     * @return {*} The copied value.
	     */
	    var _clone = function _clone(value, refFrom, refTo) {
	        var copy = function copy(copiedValue) {
	            var len = refFrom.length;
	            var idx = 0;
	            while (idx < len) {
	                if (value === refFrom[idx]) {
	                    return refTo[idx];
	                }
	                idx += 1;
	            }
	            refFrom[idx + 1] = value;
	            refTo[idx + 1] = copiedValue;
	            for (var key in value) {
	                copiedValue[key] = _clone(value[key], refFrom, refTo);
	            }
	            return copiedValue;
	        };
	        switch (type(value)) {
	        case 'Object':
	            return copy({});
	        case 'Array':
	            return copy([]);
	        case 'Date':
	            return new Date(value.valueOf());
	        case 'RegExp':
	            return _cloneRegExp(value);
	        default:
	            return value;
	        }
	    };
	
	    var _createPartialApplicator = function _createPartialApplicator(concat) {
	        return _curry2(function (fn, args) {
	            return _arity(Math.max(0, fn.length - args.length), function () {
	                return fn.apply(this, concat(args, arguments));
	            });
	        });
	    };
	
	    var _dropLast = function dropLast(n, xs) {
	        return take(n < xs.length ? xs.length - n : 0, xs);
	    };
	
	    // Values of other types are only equal if identical.
	    var _equals = function _equals(a, b, stackA, stackB) {
	        if (identical(a, b)) {
	            return true;
	        }
	        if (type(a) !== type(b)) {
	            return false;
	        }
	        if (a == null || b == null) {
	            return false;
	        }
	        if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	            return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
	        }
	        switch (type(a)) {
	        case 'Arguments':
	        case 'Array':
	        case 'Object':
	            break;
	        case 'Boolean':
	        case 'Number':
	        case 'String':
	            if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	                return false;
	            }
	            break;
	        case 'Date':
	            if (!identical(a.valueOf(), b.valueOf())) {
	                return false;
	            }
	            break;
	        case 'Error':
	            return a.name === b.name && a.message === b.message;
	        case 'RegExp':
	            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
	                return false;
	            }
	            break;
	        case 'Map':
	        case 'Set':
	            if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
	                return false;
	            }
	            break;
	        case 'Int8Array':
	        case 'Uint8Array':
	        case 'Uint8ClampedArray':
	        case 'Int16Array':
	        case 'Uint16Array':
	        case 'Int32Array':
	        case 'Uint32Array':
	        case 'Float32Array':
	        case 'Float64Array':
	            break;
	        case 'ArrayBuffer':
	            break;
	        default:
	            // Values of other types are only equal if identical.
	            return false;
	        }
	        var keysA = keys(a);
	        if (keysA.length !== keys(b).length) {
	            return false;
	        }
	        var idx = stackA.length - 1;
	        while (idx >= 0) {
	            if (stackA[idx] === a) {
	                return stackB[idx] === b;
	            }
	            idx -= 1;
	        }
	        stackA.push(a);
	        stackB.push(b);
	        idx = keysA.length - 1;
	        while (idx >= 0) {
	            var key = keysA[idx];
	            if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
	                return false;
	            }
	            idx -= 1;
	        }
	        stackA.pop();
	        stackB.pop();
	        return true;
	    };
	
	    /**
	     * `_makeFlat` is a helper function that returns a one-level or fully recursive
	     * function based on the flag passed in.
	     *
	     * @private
	     */
	    var _makeFlat = function _makeFlat(recursive) {
	        return function flatt(list) {
	            var value, jlen, j;
	            var result = [];
	            var idx = 0;
	            var ilen = list.length;
	            while (idx < ilen) {
	                if (isArrayLike(list[idx])) {
	                    value = recursive ? flatt(list[idx]) : list[idx];
	                    j = 0;
	                    jlen = value.length;
	                    while (j < jlen) {
	                        result[result.length] = value[j];
	                        j += 1;
	                    }
	                } else {
	                    result[result.length] = list[idx];
	                }
	                idx += 1;
	            }
	            return result;
	        };
	    };
	
	    var _reduce = function () {
	        function _arrayReduce(xf, acc, list) {
	            var idx = 0;
	            var len = list.length;
	            while (idx < len) {
	                acc = xf['@@transducer/step'](acc, list[idx]);
	                if (acc && acc['@@transducer/reduced']) {
	                    acc = acc['@@transducer/value'];
	                    break;
	                }
	                idx += 1;
	            }
	            return xf['@@transducer/result'](acc);
	        }
	        function _iterableReduce(xf, acc, iter) {
	            var step = iter.next();
	            while (!step.done) {
	                acc = xf['@@transducer/step'](acc, step.value);
	                if (acc && acc['@@transducer/reduced']) {
	                    acc = acc['@@transducer/value'];
	                    break;
	                }
	                step = iter.next();
	            }
	            return xf['@@transducer/result'](acc);
	        }
	        function _methodReduce(xf, acc, obj) {
	            return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
	        }
	        var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
	        return function _reduce(fn, acc, list) {
	            if (typeof fn === 'function') {
	                fn = _xwrap(fn);
	            }
	            if (isArrayLike(list)) {
	                return _arrayReduce(fn, acc, list);
	            }
	            if (typeof list.reduce === 'function') {
	                return _methodReduce(fn, acc, list);
	            }
	            if (list[symIterator] != null) {
	                return _iterableReduce(fn, acc, list[symIterator]());
	            }
	            if (typeof list.next === 'function') {
	                return _iterableReduce(fn, acc, list);
	            }
	            throw new TypeError('reduce: list must be array or iterable');
	        };
	    }();
	
	    var _xdropLastWhile = function () {
	        function XDropLastWhile(fn, xf) {
	            this.f = fn;
	            this.retained = [];
	            this.xf = xf;
	        }
	        XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
	        XDropLastWhile.prototype['@@transducer/result'] = function (result) {
	            this.retained = null;
	            return this.xf['@@transducer/result'](result);
	        };
	        XDropLastWhile.prototype['@@transducer/step'] = function (result, input) {
	            return this.f(input) ? this.retain(result, input) : this.flush(result, input);
	        };
	        XDropLastWhile.prototype.flush = function (result, input) {
	            result = _reduce(this.xf['@@transducer/step'], result, this.retained);
	            this.retained = [];
	            return this.xf['@@transducer/step'](result, input);
	        };
	        XDropLastWhile.prototype.retain = function (result, input) {
	            this.retained.push(input);
	            return result;
	        };
	        return _curry2(function _xdropLastWhile(fn, xf) {
	            return new XDropLastWhile(fn, xf);
	        });
	    }();
	
	    var _xgroupBy = function () {
	        function XGroupBy(f, xf) {
	            this.xf = xf;
	            this.f = f;
	            this.inputs = {};
	        }
	        XGroupBy.prototype['@@transducer/init'] = _xfBase.init;
	        XGroupBy.prototype['@@transducer/result'] = function (result) {
	            var key;
	            for (key in this.inputs) {
	                if (_has(key, this.inputs)) {
	                    result = this.xf['@@transducer/step'](result, this.inputs[key]);
	                    if (result['@@transducer/reduced']) {
	                        result = result['@@transducer/value'];
	                        break;
	                    }
	                }
	            }
	            this.inputs = null;
	            return this.xf['@@transducer/result'](result);
	        };
	        XGroupBy.prototype['@@transducer/step'] = function (result, input) {
	            var key = this.f(input);
	            this.inputs[key] = this.inputs[key] || [
	                key,
	                []
	            ];
	            this.inputs[key][1] = append(input, this.inputs[key][1]);
	            return result;
	        };
	        return _curry2(function _xgroupBy(f, xf) {
	            return new XGroupBy(f, xf);
	        });
	    }();
	
	    /**
	     * Creates a new list iteration function from an existing one by adding two new
	     * parameters to its callback function: the current index, and the entire list.
	     *
	     * This would turn, for instance, Ramda's simple `map` function into one that
	     * more closely resembles `Array.prototype.map`. Note that this will only work
	     * for functions in which the iteration callback function is the first
	     * parameter, and where the list is the last parameter. (This latter might be
	     * unimportant if the list parameter is not used.)
	     *
	     * @func
	     * @memberOf R
	     * @since v0.15.0
	     * @category Function
	     * @category List
	     * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
	     * @param {Function} fn A list iteration function that does not pass index or list to its callback
	     * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	     * @example
	     *
	     *      var mapIndexed = R.addIndex(R.map);
	     *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	     *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	     */
	    var addIndex = _curry1(function addIndex(fn) {
	        return curryN(fn.length, function () {
	            var idx = 0;
	            var origFn = arguments[0];
	            var list = arguments[arguments.length - 1];
	            var args = _slice(arguments);
	            args[0] = function () {
	                var result = origFn.apply(this, _concat(arguments, [
	                    idx,
	                    list
	                ]));
	                idx += 1;
	                return result;
	            };
	            return fn.apply(this, args);
	        });
	    });
	
	    /**
	     * Wraps a function of any arity (including nullary) in a function that accepts
	     * exactly 2 parameters. Any extraneous parameters will not be passed to the
	     * supplied function.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.2.0
	     * @category Function
	     * @sig (* -> c) -> (a, b -> c)
	     * @param {Function} fn The function to wrap.
	     * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	     *         arity 2.
	     * @example
	     *
	     *      var takesThreeArgs = function(a, b, c) {
	     *        return [a, b, c];
	     *      };
	     *      takesThreeArgs.length; //=> 3
	     *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
	     *
	     *      var takesTwoArgs = R.binary(takesThreeArgs);
	     *      takesTwoArgs.length; //=> 2
	     *      // Only 2 arguments are passed to the wrapped function
	     *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
	     */
	    var binary = _curry1(function binary(fn) {
	        return nAry(2, fn);
	    });
	
	    /**
	     * Creates a deep copy of the value which may contain (nested) `Array`s and
	     * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are not
	     * copied, but assigned by their reference.
	     *
	     * Dispatches to a `clone` method if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @sig {*} -> {*}
	     * @param {*} value The object or array to clone
	     * @return {*} A new object or array.
	     * @example
	     *
	     *      var objects = [{}, {}, {}];
	     *      var objectsClone = R.clone(objects);
	     *      objects[0] === objectsClone[0]; //=> false
	     */
	    var clone = _curry1(function clone(value) {
	        return value != null && typeof value.clone === 'function' ? value.clone() : _clone(value, [], []);
	    });
	
	    /**
	     * Returns a curried equivalent of the provided function. The curried function
	     * has two unusual capabilities. First, its arguments needn't be provided one
	     * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	     * following are equivalent:
	     *
	     *   - `g(1)(2)(3)`
	     *   - `g(1)(2, 3)`
	     *   - `g(1, 2)(3)`
	     *   - `g(1, 2, 3)`
	     *
	     * Secondly, the special placeholder value `R.__` may be used to specify
	     * "gaps", allowing partial application of any combination of arguments,
	     * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	     * following are equivalent:
	     *
	     *   - `g(1, 2, 3)`
	     *   - `g(_, 2, 3)(1)`
	     *   - `g(_, _, 3)(1)(2)`
	     *   - `g(_, _, 3)(1, 2)`
	     *   - `g(_, 2)(1)(3)`
	     *   - `g(_, 2)(1, 3)`
	     *   - `g(_, 2)(_, 3)(1)`
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig (* -> a) -> (* -> a)
	     * @param {Function} fn The function to curry.
	     * @return {Function} A new, curried function.
	     * @see R.curryN
	     * @example
	     *
	     *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	     *
	     *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	     *      var f = curriedAddFourNumbers(1, 2);
	     *      var g = f(3);
	     *      g(4); //=> 10
	     */
	    var curry = _curry1(function curry(fn) {
	        return curryN(fn.length, fn);
	    });
	
	    /**
	     * Returns all but the first `n` elements of the given list, string, or
	     * transducer/transformer (or object with a `drop` method).
	     *
	     * Dispatches to the `drop` method of the second argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig Number -> [a] -> [a]
	     * @sig Number -> String -> String
	     * @param {Number} n
	     * @param {*} list
	     * @return {*}
	     * @see R.take, R.transduce
	     * @example
	     *
	     *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	     *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
	     *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
	     *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
	     *      R.drop(3, 'ramda');               //=> 'da'
	     */
	    var drop = _curry2(_dispatchable('drop', _xdrop, function drop(n, xs) {
	        return slice(Math.max(0, n), Infinity, xs);
	    }));
	
	    /**
	     * Returns a list containing all but the last `n` elements of the given `list`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category List
	     * @sig Number -> [a] -> [a]
	     * @sig Number -> String -> String
	     * @param {Number} n The number of elements of `xs` to skip.
	     * @param {Array} xs The collection to consider.
	     * @return {Array}
	     * @see R.takeLast
	     * @example
	     *
	     *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	     *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
	     *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
	     *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
	     *      R.dropLast(3, 'ramda');               //=> 'ra'
	     */
	    var dropLast = _curry2(_dispatchable('dropLast', _xdropLast, _dropLast));
	
	    /**
	     * Returns a new list containing all but last the`n` elements of a given list,
	     * passing each value from the right to the supplied predicate function,
	     * skipping elements while the predicate function returns `true`. The predicate
	     * function is passed one argument: (value)*.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> [a]
	     * @param {Function} fn The function called per iteration.
	     * @param {Array} list The collection to iterate over.
	     * @return {Array} A new array.
	     * @see R.takeLastWhile, R.addIndex
	     * @example
	     *
	     *      var lteThree = x => x <= 3;
	     *
	     *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
	     */
	    var dropLastWhile = _curry2(_dispatchable('dropLastWhile', _xdropLastWhile, _dropLastWhile));
	
	    /**
	     * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	     * cyclical data structures.
	     *
	     * Dispatches symmetrically to the `equals` methods of both arguments, if
	     * present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.15.0
	     * @category Relation
	     * @sig a -> b -> Boolean
	     * @param {*} a
	     * @param {*} b
	     * @return {Boolean}
	     * @example
	     *
	     *      R.equals(1, 1); //=> true
	     *      R.equals(1, '1'); //=> false
	     *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	     *
	     *      var a = {}; a.v = a;
	     *      var b = {}; b.v = b;
	     *      R.equals(a, b); //=> true
	     */
	    var equals = _curry2(function equals(a, b) {
	        return _equals(a, b, [], []);
	    });
	
	    /**
	     * Takes a predicate and a "filterable", and returns a new filterable of the
	     * same type containing the members of the given filterable which satisfy the
	     * given predicate.
	     *
	     * Dispatches to the `filter` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig Filterable f => (a -> Boolean) -> f a -> f a
	     * @param {Function} pred
	     * @param {Array} filterable
	     * @return {Array}
	     * @see R.reject, R.transduce, R.addIndex
	     * @example
	     *
	     *      var isEven = n => n % 2 === 0;
	     *
	     *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	     *
	     *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	     */
	    // else
	    var filter = _curry2(_dispatchable('filter', _xfilter, function (pred, filterable) {
	        return _isObject(filterable) ? _reduce(function (acc, key) {
	            if (pred(filterable[key])) {
	                acc[key] = filterable[key];
	            }
	            return acc;
	        }, {}, keys(filterable)) : // else
	        _filter(pred, filterable);
	    }));
	
	    /**
	     * Returns a new list by pulling every item out of it (and all its sub-arrays)
	     * and putting them in a new array, depth-first.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig [a] -> [b]
	     * @param {Array} list The array to consider.
	     * @return {Array} The flattened list.
	     * @see R.unnest
	     * @example
	     *
	     *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
	     *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	     */
	    var flatten = _curry1(_makeFlat(true));
	
	    /**
	     * Returns a new function much like the supplied one, except that the first two
	     * arguments' order is reversed.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
	     * @param {Function} fn The function to invoke with its first two parameters reversed.
	     * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	     * @example
	     *
	     *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	     *
	     *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	     *
	     *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	     */
	    var flip = _curry1(function flip(fn) {
	        return curry(function (a, b) {
	            var args = _slice(arguments);
	            args[0] = b;
	            args[1] = a;
	            return fn.apply(this, args);
	        });
	    });
	
	    /**
	     * Splits a list into sub-lists stored in an object, based on the result of
	     * calling a String-returning function on each element, and grouping the
	     * results according to values returned.
	     *
	     * Dispatches to the `groupBy` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig (a -> String) -> [a] -> {String: [a]}
	     * @param {Function} fn Function :: a -> String
	     * @param {Array} list The array to group
	     * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
	     *         that produced that key when passed to `fn`.
	     * @see R.transduce
	     * @example
	     *
	     *      var byGrade = R.groupBy(function(student) {
	     *        var score = student.score;
	     *        return score < 65 ? 'F' :
	     *               score < 70 ? 'D' :
	     *               score < 80 ? 'C' :
	     *               score < 90 ? 'B' : 'A';
	     *      });
	     *      var students = [{name: 'Abby', score: 84},
	     *                      {name: 'Eddy', score: 58},
	     *                      // ...
	     *                      {name: 'Jack', score: 69}];
	     *      byGrade(students);
	     *      // {
	     *      //   'A': [{name: 'Dianne', score: 99}],
	     *      //   'B': [{name: 'Abby', score: 84}]
	     *      //   // ...,
	     *      //   'F': [{name: 'Eddy', score: 58}]
	     *      // }
	     */
	    var groupBy = _curry2(_dispatchable('groupBy', _xgroupBy, function groupBy(fn, list) {
	        return _reduce(function (acc, elt) {
	            var key = fn(elt);
	            acc[key] = append(elt, acc[key] || (acc[key] = []));
	            return acc;
	        }, {}, list);
	    }));
	
	    /**
	     * Returns the first element of the given list or string. In some libraries
	     * this function is named `first`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig [a] -> a | Undefined
	     * @sig String -> String
	     * @param {Array|String} list
	     * @return {*}
	     * @see R.tail, R.init, R.last
	     * @example
	     *
	     *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	     *      R.head([]); //=> undefined
	     *
	     *      R.head('abc'); //=> 'a'
	     *      R.head(''); //=> ''
	     */
	    var head = nth(0);
	
	    /**
	     * Given a function that generates a key, turns a list of objects into an
	     * object indexing the objects by the given key. Note that if multiple
	     * objects generate the same value for the indexing key only the last value
	     * will be included in the generated object.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category List
	     * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
	     * @param {Function} fn Function :: a -> String
	     * @param {Array} array The array of objects to index
	     * @return {Object} An object indexing each array element by the given property.
	     * @example
	     *
	     *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
	     *      R.indexBy(R.prop('id'), list);
	     *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
	     */
	    var indexBy = _curry2(function indexBy(fn, list) {
	        return _reduce(function (acc, elem) {
	            var key = fn(elem);
	            acc[key] = elem;
	            return acc;
	        }, {}, list);
	    });
	
	    /**
	     * Returns all but the last element of the given list or string.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category List
	     * @sig [a] -> [a]
	     * @sig String -> String
	     * @param {*} list
	     * @return {*}
	     * @see R.last, R.head, R.tail
	     * @example
	     *
	     *      R.init([1, 2, 3]);  //=> [1, 2]
	     *      R.init([1, 2]);     //=> [1]
	     *      R.init([1]);        //=> []
	     *      R.init([]);         //=> []
	     *
	     *      R.init('abc');  //=> 'ab'
	     *      R.init('ab');   //=> 'a'
	     *      R.init('a');    //=> ''
	     *      R.init('');     //=> ''
	     */
	    var init = slice(0, -1);
	
	    /**
	     * Combines two lists into a set (i.e. no duplicates) composed of those
	     * elements common to both lists. Duplication is determined according to the
	     * value returned by applying the supplied predicate to two list elements.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
	     * @param {Function} pred A predicate function that determines whether
	     *        the two supplied elements are equal.
	     * @param {Array} list1 One list of items to compare
	     * @param {Array} list2 A second list of items to compare
	     * @return {Array} A new list containing those elements common to both lists.
	     * @see R.intersection
	     * @example
	     *
	     *      var buffaloSpringfield = [
	     *        {id: 824, name: 'Richie Furay'},
	     *        {id: 956, name: 'Dewey Martin'},
	     *        {id: 313, name: 'Bruce Palmer'},
	     *        {id: 456, name: 'Stephen Stills'},
	     *        {id: 177, name: 'Neil Young'}
	     *      ];
	     *      var csny = [
	     *        {id: 204, name: 'David Crosby'},
	     *        {id: 456, name: 'Stephen Stills'},
	     *        {id: 539, name: 'Graham Nash'},
	     *        {id: 177, name: 'Neil Young'}
	     *      ];
	     *
	     *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
	     *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	     */
	    var intersectionWith = _curry3(function intersectionWith(pred, list1, list2) {
	        var results = [];
	        var idx = 0;
	        while (idx < list1.length) {
	            if (_containsWith(pred, list1[idx], list2)) {
	                results[results.length] = list1[idx];
	            }
	            idx += 1;
	        }
	        return uniqWith(pred, results);
	    });
	
	    /**
	     * Same as R.invertObj, however this accounts for objects with duplicate values
	     * by putting the values into an array.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Object
	     * @sig {s: x} -> {x: [ s, ... ]}
	     * @param {Object} obj The object or array to invert
	     * @return {Object} out A new object with keys
	     * in an array.
	     * @example
	     *
	     *      var raceResultsByFirstName = {
	     *        first: 'alice',
	     *        second: 'jake',
	     *        third: 'alice',
	     *      };
	     *      R.invert(raceResultsByFirstName);
	     *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
	     */
	    var invert = _curry1(function invert(obj) {
	        var props = keys(obj);
	        var len = props.length;
	        var idx = 0;
	        var out = {};
	        while (idx < len) {
	            var key = props[idx];
	            var val = obj[key];
	            var list = _has(val, out) ? out[val] : out[val] = [];
	            list[list.length] = key;
	            idx += 1;
	        }
	        return out;
	    });
	
	    /**
	     * Returns a new object with the keys of the given object as values, and the
	     * values of the given object, which are coerced to strings, as keys. Note
	     * that the last key found is preferred when handling the same value.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Object
	     * @sig {s: x} -> {x: s}
	     * @param {Object} obj The object or array to invert
	     * @return {Object} out A new object
	     * @example
	     *
	     *      var raceResults = {
	     *        first: 'alice',
	     *        second: 'jake'
	     *      };
	     *      R.invertObj(raceResults);
	     *      //=> { 'alice': 'first', 'jake':'second' }
	     *
	     *      // Alternatively:
	     *      var raceResults = ['alice', 'jake'];
	     *      R.invertObj(raceResults);
	     *      //=> { 'alice': '0', 'jake':'1' }
	     */
	    var invertObj = _curry1(function invertObj(obj) {
	        var props = keys(obj);
	        var len = props.length;
	        var idx = 0;
	        var out = {};
	        while (idx < len) {
	            var key = props[idx];
	            out[obj[key]] = key;
	            idx += 1;
	        }
	        return out;
	    });
	
	    /**
	     * Returns `true` if the given value is its type's empty value; `false`
	     * otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Logic
	     * @sig a -> Boolean
	     * @param {*} x
	     * @return {Boolean}
	     * @see R.empty
	     * @example
	     *
	     *      R.isEmpty([1, 2, 3]);   //=> false
	     *      R.isEmpty([]);          //=> true
	     *      R.isEmpty('');          //=> true
	     *      R.isEmpty(null);        //=> false
	     *      R.isEmpty({});          //=> true
	     *      R.isEmpty({length: 0}); //=> false
	     */
	    var isEmpty = _curry1(function isEmpty(x) {
	        return x != null && equals(x, empty(x));
	    });
	
	    /**
	     * Returns the last element of the given list or string.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.4
	     * @category List
	     * @sig [a] -> a | Undefined
	     * @sig String -> String
	     * @param {*} list
	     * @return {*}
	     * @see R.init, R.head, R.tail
	     * @example
	     *
	     *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	     *      R.last([]); //=> undefined
	     *
	     *      R.last('abc'); //=> 'c'
	     *      R.last(''); //=> ''
	     */
	    var last = nth(-1);
	
	    /**
	     * Returns the position of the last occurrence of an item in an array, or -1 if
	     * the item is not included in the array. `R.equals` is used to determine
	     * equality.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig a -> [a] -> Number
	     * @param {*} target The item to find.
	     * @param {Array} xs The array to search in.
	     * @return {Number} the index of the target, or -1 if the target is not found.
	     * @see R.indexOf
	     * @example
	     *
	     *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
	     *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
	     */
	    var lastIndexOf = _curry2(function lastIndexOf(target, xs) {
	        if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
	            return xs.lastIndexOf(target);
	        } else {
	            var idx = xs.length - 1;
	            while (idx >= 0) {
	                if (equals(xs[idx], target)) {
	                    return idx;
	                }
	                idx -= 1;
	            }
	            return -1;
	        }
	    });
	
	    /**
	     * Takes a function and
	     * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	     * applies the function to each of the functor's values, and returns
	     * a functor of the same shape.
	     *
	     * Ramda provides suitable `map` implementations for `Array` and `Object`,
	     * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	     *
	     * Dispatches to the `map` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * Also treats functions as functors and will compose them together.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig Functor f => (a -> b) -> f a -> f b
	     * @param {Function} fn The function to be called on every element of the input `list`.
	     * @param {Array} list The list to be iterated over.
	     * @return {Array} The new list.
	     * @see R.transduce, R.addIndex
	     * @example
	     *
	     *      var double = x => x * 2;
	     *
	     *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	     *
	     *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	     */
	    var map = _curry2(_dispatchable('map', _xmap, function map(fn, functor) {
	        switch (Object.prototype.toString.call(functor)) {
	        case '[object Function]':
	            return curryN(functor.length, function () {
	                return fn.call(this, functor.apply(this, arguments));
	            });
	        case '[object Object]':
	            return _reduce(function (acc, key) {
	                acc[key] = fn(functor[key]);
	                return acc;
	            }, {}, keys(functor));
	        default:
	            return _map(fn, functor);
	        }
	    }));
	
	    /**
	     * An Object-specific version of `map`. The function is applied to three
	     * arguments: *(value, key, obj)*. If only the value is significant, use
	     * `map` instead.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Object
	     * @sig ((*, String, Object) -> *) -> Object -> Object
	     * @param {Function} fn
	     * @param {Object} obj
	     * @return {Object}
	     * @see R.map
	     * @example
	     *
	     *      var values = { x: 1, y: 2, z: 3 };
	     *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
	     *
	     *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
	     */
	    var mapObjIndexed = _curry2(function mapObjIndexed(fn, obj) {
	        return _reduce(function (acc, key) {
	            acc[key] = fn(obj[key], key, obj);
	            return acc;
	        }, {}, keys(obj));
	    });
	
	    /**
	     * Creates a new object with the own properties of the two provided objects. If
	     * a key exists in both objects, the provided function is applied to the values
	     * associated with the key in each object, with the result being used as the
	     * value associated with the key in the returned object. The key will be
	     * excluded from the returned object if the resulting value is `undefined`.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category Object
	     * @sig (a -> a -> a) -> {a} -> {a} -> {a}
	     * @param {Function} fn
	     * @param {Object} l
	     * @param {Object} r
	     * @return {Object}
	     * @see R.merge, R.mergeWithKey
	     * @example
	     *
	     *      R.mergeWith(R.concat,
	     *                  { a: true, values: [10, 20] },
	     *                  { b: true, values: [15, 35] });
	     *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
	     */
	    var mergeWith = _curry3(function mergeWith(fn, l, r) {
	        return mergeWithKey(function (_, _l, _r) {
	            return fn(_l, _r);
	        }, l, r);
	    });
	
	    /**
	     * Takes a function `f` and a list of arguments, and returns a function `g`.
	     * When applied, `g` returns the result of applying `f` to the arguments
	     * provided initially followed by the arguments provided to `g`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category Function
	     * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
	     * @param {Function} f
	     * @param {Array} args
	     * @return {Function}
	     * @see R.partialRight
	     * @example
	     *
	     *      var multiply = (a, b) => a * b;
	     *      var double = R.partial(multiply, [2]);
	     *      double(2); //=> 4
	     *
	     *      var greet = (salutation, title, firstName, lastName) =>
	     *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	     *
	     *      var sayHello = R.partial(greet, ['Hello']);
	     *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
	     *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
	     */
	    var partial = _createPartialApplicator(_concat);
	
	    /**
	     * Takes a function `f` and a list of arguments, and returns a function `g`.
	     * When applied, `g` returns the result of applying `f` to the arguments
	     * provided to `g` followed by the arguments provided initially.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category Function
	     * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
	     * @param {Function} f
	     * @param {Array} args
	     * @return {Function}
	     * @see R.partial
	     * @example
	     *
	     *      var greet = (salutation, title, firstName, lastName) =>
	     *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	     *
	     *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
	     *
	     *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
	     */
	    var partialRight = _createPartialApplicator(flip(_concat));
	
	    /**
	     * Takes a predicate and a list and returns the pair of lists of elements which
	     * do and do not satisfy the predicate, respectively.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.4
	     * @category List
	     * @sig (a -> Boolean) -> [a] -> [[a],[a]]
	     * @param {Function} pred A predicate to determine which array the element belongs to.
	     * @param {Array} list The array to partition.
	     * @return {Array} A nested array, containing first an array of elements that satisfied the predicate,
	     *         and second an array of elements that did not satisfy.
	     * @see R.filter, R.reject
	     * @example
	     *
	     *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
	     *      //=> [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
	     */
	    var partition = _curry2(function partition(pred, list) {
	        return _reduce(function (acc, elt) {
	            var xs = acc[pred(elt) ? 0 : 1];
	            xs[xs.length] = elt;
	            return acc;
	        }, [
	            [],
	            []
	        ], list);
	    });
	
	    /**
	     * Determines whether a nested path on an object has a specific value, in
	     * `R.equals` terms. Most likely used to filter a list.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.7.0
	     * @category Relation
	     * @sig [String] -> * -> {String: *} -> Boolean
	     * @param {Array} path The path of the nested property to use
	     * @param {*} val The value to compare the nested property with
	     * @param {Object} obj The object to check the nested property in
	     * @return {Boolean} `true` if the value equals the nested object property,
	     *         `false` otherwise.
	     * @example
	     *
	     *      var user1 = { address: { zipCode: 90210 } };
	     *      var user2 = { address: { zipCode: 55555 } };
	     *      var user3 = { name: 'Bob' };
	     *      var users = [ user1, user2, user3 ];
	     *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
	     *      R.filter(isFamous, users); //=> [ user1 ]
	     */
	    var pathEq = _curry3(function pathEq(_path, val, obj) {
	        return equals(path(_path, obj), val);
	    });
	
	    /**
	     * Returns a new list by plucking the same named property off all objects in
	     * the list supplied.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig k -> [{k: v}] -> [v]
	     * @param {Number|String} key The key name to pluck off of each object.
	     * @param {Array} list The array to consider.
	     * @return {Array} The list of values for the given key.
	     * @see R.props
	     * @example
	     *
	     *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	     *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	     */
	    var pluck = _curry2(function pluck(p, list) {
	        return map(prop(p), list);
	    });
	
	    /**
	     * Reasonable analog to SQL `select` statement.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @category Relation
	     * @sig [k] -> [{k: v}] -> [{k: v}]
	     * @param {Array} props The property names to project
	     * @param {Array} objs The objects to query
	     * @return {Array} An array of objects with just the `props` properties.
	     * @example
	     *
	     *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
	     *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
	     *      var kids = [abby, fred];
	     *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
	     */
	    // passing `identity` gives correct arity
	    var project = useWith(_map, [
	        pickAll,
	        identity
	    ]);
	
	    /**
	     * Returns `true` if the specified object property is equal, in `R.equals`
	     * terms, to the given value; `false` otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig String -> a -> Object -> Boolean
	     * @param {String} name
	     * @param {*} val
	     * @param {*} obj
	     * @return {Boolean}
	     * @see R.equals, R.propSatisfies
	     * @example
	     *
	     *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	     *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	     *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	     *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	     *      var kids = [abby, fred, rusty, alois];
	     *      var hasBrownHair = R.propEq('hair', 'brown');
	     *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	     */
	    var propEq = _curry3(function propEq(name, val, obj) {
	        return propSatisfies(equals(val), name, obj);
	    });
	
	    /**
	     * Returns `true` if the specified object property is of the given type;
	     * `false` otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category Type
	     * @sig Type -> String -> Object -> Boolean
	     * @param {Function} type
	     * @param {String} name
	     * @param {*} obj
	     * @return {Boolean}
	     * @see R.is, R.propSatisfies
	     * @example
	     *
	     *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
	     *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
	     *      R.propIs(Number, 'x', {});            //=> false
	     */
	    var propIs = _curry3(function propIs(type, name, obj) {
	        return propSatisfies(is(type), name, obj);
	    });
	
	    /**
	     * Returns a single item by iterating through the list, successively calling
	     * the iterator function and passing it an accumulator value and the current
	     * value from the array, and then passing the result to the next call.
	     *
	     * The iterator function receives two values: *(acc, value)*. It may use
	     * `R.reduced` to shortcut the iteration.
	     *
	     * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	     * arrays), unlike the native `Array.prototype.reduce` method. For more details
	     * on this behavior, see:
	     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	     *
	     * Dispatches to the `reduce` method of the third argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig ((a, b) -> a) -> a -> [b] -> a
	     * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	     *        current element from the array.
	     * @param {*} acc The accumulator value.
	     * @param {Array} list The list to iterate over.
	     * @return {*} The final, accumulated value.
	     * @see R.reduced, R.addIndex
	     * @example
	     *
	     *      var numbers = [1, 2, 3];
	     *      var add = (a, b) => a + b;
	     *
	     *      R.reduce(add, 10, numbers); //=> 16
	     */
	    var reduce = _curry3(_reduce);
	
	    /**
	     * The complement of `filter`.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig Filterable f => (a -> Boolean) -> f a -> f a
	     * @param {Function} pred
	     * @param {Array} filterable
	     * @return {Array}
	     * @see R.filter, R.transduce, R.addIndex
	     * @example
	     *
	     *      var isOdd = (n) => n % 2 === 1;
	     *
	     *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	     *
	     *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	     */
	    var reject = _curry2(function reject(pred, filterable) {
	        return filter(_complement(pred), filterable);
	    });
	
	    /**
	     * Returns a fixed list of size `n` containing a specified identical value.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.1
	     * @category List
	     * @sig a -> n -> [a]
	     * @param {*} value The value to repeat.
	     * @param {Number} n The desired size of the output list.
	     * @return {Array} A new array containing `n` `value`s.
	     * @example
	     *
	     *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
	     *
	     *      var obj = {};
	     *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
	     *      repeatedObjs[0] === repeatedObjs[1]; //=> true
	     */
	    var repeat = _curry2(function repeat(value, n) {
	        return times(always(value), n);
	    });
	
	    /**
	     * Adds together all the elements of a list.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Math
	     * @sig [Number] -> Number
	     * @param {Array} list An array of numbers
	     * @return {Number} The sum of all the numbers in the list.
	     * @see R.reduce
	     * @example
	     *
	     *      R.sum([2,4,6,8,100,1]); //=> 121
	     */
	    var sum = reduce(add, 0);
	
	    /**
	     * Returns a new list containing the last `n` elements of the given list.
	     * If `n > list.length`, returns a list of `list.length` elements.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category List
	     * @sig Number -> [a] -> [a]
	     * @sig Number -> String -> String
	     * @param {Number} n The number of elements to return.
	     * @param {Array} xs The collection to consider.
	     * @return {Array}
	     * @see R.dropLast
	     * @example
	     *
	     *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
	     *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	     *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	     *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	     *      R.takeLast(3, 'ramda');               //=> 'mda'
	     */
	    var takeLast = _curry2(function takeLast(n, xs) {
	        return drop(n >= 0 ? xs.length - n : 0, xs);
	    });
	
	    /**
	     * Initializes a transducer using supplied iterator function. Returns a single
	     * item by iterating through the list, successively calling the transformed
	     * iterator function and passing it an accumulator value and the current value
	     * from the array, and then passing the result to the next call.
	     *
	     * The iterator function receives two values: *(acc, value)*. It will be
	     * wrapped as a transformer to initialize the transducer. A transformer can be
	     * passed directly in place of an iterator function. In both cases, iteration
	     * may be stopped early with the `R.reduced` function.
	     *
	     * A transducer is a function that accepts a transformer and returns a
	     * transformer and can be composed directly.
	     *
	     * A transformer is an an object that provides a 2-arity reducing iterator
	     * function, step, 0-arity initial value function, init, and 1-arity result
	     * extraction function, result. The step function is used as the iterator
	     * function in reduce. The result function is used to convert the final
	     * accumulator into the return type and in most cases is R.identity. The init
	     * function can be used to provide an initial accumulator, but is ignored by
	     * transduce.
	     *
	     * The iteration is performed with R.reduce after initializing the transducer.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.12.0
	     * @category List
	     * @sig (c -> c) -> (a,b -> a) -> a -> [b] -> a
	     * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	     * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	     *        current element from the array. Wrapped as transformer, if necessary, and used to
	     *        initialize the transducer
	     * @param {*} acc The initial accumulator value.
	     * @param {Array} list The list to iterate over.
	     * @return {*} The final, accumulated value.
	     * @see R.reduce, R.reduced, R.into
	     * @example
	     *
	     *      var numbers = [1, 2, 3, 4];
	     *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	     *
	     *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
	     */
	    var transduce = curryN(4, function transduce(xf, fn, acc, list) {
	        return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
	    });
	
	    /**
	     * Combines two lists into a set (i.e. no duplicates) composed of the elements
	     * of each list. Duplication is determined according to the value returned by
	     * applying the supplied predicate to two list elements.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
	     * @param {Function} pred A predicate used to test whether two items are equal.
	     * @param {Array} list1 The first list.
	     * @param {Array} list2 The second list.
	     * @return {Array} The first and second lists concatenated, with
	     *         duplicates removed.
	     * @see R.union
	     * @example
	     *
	     *      var l1 = [{a: 1}, {a: 2}];
	     *      var l2 = [{a: 1}, {a: 4}];
	     *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
	     */
	    var unionWith = _curry3(function unionWith(pred, list1, list2) {
	        return uniqWith(pred, _concat(list1, list2));
	    });
	
	    /**
	     * Takes a spec object and a test object; returns true if the test satisfies
	     * the spec, false otherwise. An object satisfies the spec if, for each of the
	     * spec's own properties, accessing that property of the object gives the same
	     * value (in `R.equals` terms) as accessing that property of the spec.
	     *
	     * `whereEq` is a specialization of [`where`](#where).
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category Object
	     * @sig {String: *} -> {String: *} -> Boolean
	     * @param {Object} spec
	     * @param {Object} testObj
	     * @return {Boolean}
	     * @see R.where
	     * @example
	     *
	     *      // pred :: Object -> Boolean
	     *      var pred = R.whereEq({a: 1, b: 2});
	     *
	     *      pred({a: 1});              //=> false
	     *      pred({a: 1, b: 2});        //=> true
	     *      pred({a: 1, b: 2, c: 3});  //=> true
	     *      pred({a: 1, b: 1});        //=> false
	     */
	    var whereEq = _curry2(function whereEq(spec, testObj) {
	        return where(map(equals, spec), testObj);
	    });
	
	    var _flatCat = function () {
	        var preservingReduced = function (xf) {
	            return {
	                '@@transducer/init': _xfBase.init,
	                '@@transducer/result': function (result) {
	                    return xf['@@transducer/result'](result);
	                },
	                '@@transducer/step': function (result, input) {
	                    var ret = xf['@@transducer/step'](result, input);
	                    return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
	                }
	            };
	        };
	        return function _xcat(xf) {
	            var rxf = preservingReduced(xf);
	            return {
	                '@@transducer/init': _xfBase.init,
	                '@@transducer/result': function (result) {
	                    return rxf['@@transducer/result'](result);
	                },
	                '@@transducer/step': function (result, input) {
	                    return !isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
	                }
	            };
	        };
	    }();
	
	    // Array.prototype.indexOf doesn't exist below IE9
	    // manually crawl the list to distinguish between +0 and -0
	    // NaN
	    // non-zero numbers can utilise Set
	    // all these types can utilise Set
	    // null can utilise Set
	    // anything else not covered above, defer to R.equals
	    var _indexOf = function _indexOf(list, a, idx) {
	        var inf, item;
	        // Array.prototype.indexOf doesn't exist below IE9
	        if (typeof list.indexOf === 'function') {
	            switch (typeof a) {
	            case 'number':
	                if (a === 0) {
	                    // manually crawl the list to distinguish between +0 and -0
	                    inf = 1 / a;
	                    while (idx < list.length) {
	                        item = list[idx];
	                        if (item === 0 && 1 / item === inf) {
	                            return idx;
	                        }
	                        idx += 1;
	                    }
	                    return -1;
	                } else if (a !== a) {
	                    // NaN
	                    while (idx < list.length) {
	                        item = list[idx];
	                        if (typeof item === 'number' && item !== item) {
	                            return idx;
	                        }
	                        idx += 1;
	                    }
	                    return -1;
	                }
	                // non-zero numbers can utilise Set
	                return list.indexOf(a, idx);
	            // all these types can utilise Set
	            case 'string':
	            case 'boolean':
	            case 'function':
	            case 'undefined':
	                return list.indexOf(a, idx);
	            case 'object':
	                if (a === null) {
	                    // null can utilise Set
	                    return list.indexOf(a, idx);
	                }
	            }
	        }
	        // anything else not covered above, defer to R.equals
	        while (idx < list.length) {
	            if (equals(list[idx], a)) {
	                return idx;
	            }
	            idx += 1;
	        }
	        return -1;
	    };
	
	    var _xchain = _curry2(function _xchain(f, xf) {
	        return map(f, _flatCat(xf));
	    });
	
	    /**
	     * Takes a list of predicates and returns a predicate that returns true for a
	     * given list of arguments if every one of the provided predicates is satisfied
	     * by those arguments.
	     *
	     * The function returned is a curried function whose arity matches that of the
	     * highest-arity predicate.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Logic
	     * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	     * @param {Array} preds
	     * @return {Function}
	     * @see R.anyPass
	     * @example
	     *
	     *      var isQueen = R.propEq('rank', 'Q');
	     *      var isSpade = R.propEq('suit', '♠︎');
	     *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
	     *
	     *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	     *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	     */
	    var allPass = _curry1(function allPass(preds) {
	        return curryN(reduce(max, 0, pluck('length', preds)), function () {
	            var idx = 0;
	            var len = preds.length;
	            while (idx < len) {
	                if (!preds[idx].apply(this, arguments)) {
	                    return false;
	                }
	                idx += 1;
	            }
	            return true;
	        });
	    });
	
	    /**
	     * Returns `true` if all elements are unique, in `R.equals` terms, otherwise
	     * `false`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.18.0
	     * @category List
	     * @sig [a] -> Boolean
	     * @param {Array} list The array to consider.
	     * @return {Boolean} `true` if all elements are unique, else `false`.
	     * @example
	     *
	     *      R.allUniq(['1', 1]); //=> true
	     *      R.allUniq([1, 1]);   //=> false
	     *      R.allUniq([[42], [42]]); //=> false
	     */
	    var allUniq = _curry1(function allUniq(list) {
	        var len = list.length;
	        var idx = 0;
	        while (idx < len) {
	            if (_indexOf(list, list[idx], idx + 1) >= 0) {
	                return false;
	            }
	            idx += 1;
	        }
	        return true;
	    });
	
	    /**
	     * Takes a list of predicates and returns a predicate that returns true for a
	     * given list of arguments if at least one of the provided predicates is
	     * satisfied by those arguments.
	     *
	     * The function returned is a curried function whose arity matches that of the
	     * highest-arity predicate.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Logic
	     * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	     * @param {Array} preds
	     * @return {Function}
	     * @see R.allPass
	     * @example
	     *
	     *      var gte = R.anyPass([R.gt, R.equals]);
	     *
	     *      gte(3, 2); //=> true
	     *      gte(2, 2); //=> true
	     *      gte(2, 3); //=> false
	     */
	    var anyPass = _curry1(function anyPass(preds) {
	        return curryN(reduce(max, 0, pluck('length', preds)), function () {
	            var idx = 0;
	            var len = preds.length;
	            while (idx < len) {
	                if (preds[idx].apply(this, arguments)) {
	                    return true;
	                }
	                idx += 1;
	            }
	            return false;
	        });
	    });
	
	    /**
	     * ap applies a list of functions to a list of values.
	     *
	     * Dispatches to the `ap` method of the second argument, if present. Also
	     * treats functions as applicatives.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.3.0
	     * @category Function
	     * @sig [f] -> [a] -> [f a]
	     * @param {Array} fns An array of functions
	     * @param {Array} vs An array of values
	     * @return {Array} An array of results of applying each of `fns` to all of `vs` in turn.
	     * @example
	     *
	     *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	     */
	    // else
	    var ap = _curry2(function ap(applicative, fn) {
	        return typeof applicative.ap === 'function' ? applicative.ap(fn) : typeof applicative === 'function' ? curryN(Math.max(applicative.length, fn.length), function () {
	            return applicative.apply(this, arguments)(fn.apply(this, arguments));
	        }) : // else
	        _reduce(function (acc, f) {
	            return _concat(acc, map(f, fn));
	        }, [], applicative);
	    });
	
	    /**
	     * Returns the result of calling its first argument with the remaining
	     * arguments. This is occasionally useful as a converging function for
	     * `R.converge`: the left branch can produce a function while the right branch
	     * produces a value to be passed to that function as an argument.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category Function
	     * @sig (*... -> a),*... -> a
	     * @param {Function} fn The function to apply to the remaining arguments.
	     * @param {...*} args Any number of positional arguments.
	     * @return {*}
	     * @see R.apply
	     * @example
	     *
	     *      var indentN = R.pipe(R.times(R.always(' ')),
	     *                           R.join(''),
	     *                           R.replace(/^(?!$)/gm));
	     *
	     *      var format = R.converge(R.call, [
	     *                                  R.pipe(R.prop('indent'), indentN),
	     *                                  R.prop('value')
	     *                              ]);
	     *
	     *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
	     */
	    var call = curry(function call(fn) {
	        return fn.apply(this, _slice(arguments, 1));
	    });
	
	    /**
	     * `chain` maps a function over a list and concatenates the results. `chain`
	     * is also known as `flatMap` in some libraries
	     *
	     * Dispatches to the `chain` method of the second argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.3.0
	     * @category List
	     * @sig (a -> [b]) -> [a] -> [b]
	     * @param {Function} fn
	     * @param {Array} list
	     * @return {Array}
	     * @example
	     *
	     *      var duplicate = n => [n, n];
	     *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
	     */
	    var chain = _curry2(_dispatchable('chain', _xchain, function chain(fn, monad) {
	        if (typeof monad === 'function') {
	            return function () {
	                return monad.call(this, fn.apply(this, arguments)).apply(this, arguments);
	            };
	        }
	        return _makeFlat(false)(map(fn, monad));
	    }));
	
	    /**
	     * Turns a list of Functors into a Functor of a list, applying a mapping
	     * function to the elements of the list along the way.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category List
	     * @sig Functor f => (a -> f b) -> (x -> f x) -> [a] -> f [b]
	     * @param {Function} fn The transformation function
	     * @param {Function} of A function that returns the data type to return
	     * @param {Array} list An array of functors of the same type
	     * @return {*}
	     * @see R.traverse
	     * @deprecated since v0.19.0
	     * @example
	     *
	     *      var add10 = R.map(R.add(10));
	     *      R.commuteMap(add10, R.of, [[1], [2, 3]]);   //=> [[11, 12], [11, 13]]
	     *      R.commuteMap(add10, R.of, [[1, 2], [3]]);   //=> [[11, 13], [12, 13]]
	     *      R.commuteMap(add10, R.of, [[1], [2], [3]]); //=> [[11, 12, 13]]
	     *      R.commuteMap(add10, Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([11, 12, 13])
	     *      R.commuteMap(add10, Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	     *
	     *      var fetch = url => Future((rej, res) => http.get(url, res).on('error', rej));
	     *      R.commuteMap(fetch, Future.of, [
	     *        'http://ramdajs.com',
	     *        'http://github.com/ramda'
	     *      ]); //=> Future([IncomingMessage, IncomingMessage])
	     */
	    var commuteMap = _curry3(function commuteMap(fn, of, list) {
	        function consF(acc, x) {
	            return ap(map(prepend, fn(x)), acc);
	        }
	        return reduceRight(consF, of([]), list);
	    });
	
	    /**
	     * Wraps a constructor function inside a curried function that can be called
	     * with the same arguments and returns the same type. The arity of the function
	     * returned is specified to allow using variadic constructor functions.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.4.0
	     * @category Function
	     * @sig Number -> (* -> {*}) -> (* -> {*})
	     * @param {Number} n The arity of the constructor function.
	     * @param {Function} Fn The constructor function to wrap.
	     * @return {Function} A wrapped, curried constructor function.
	     * @example
	     *
	     *      // Variadic constructor function
	     *      var Widget = () => {
	     *        this.children = Array.prototype.slice.call(arguments);
	     *        // ...
	     *      };
	     *      Widget.prototype = {
	     *        // ...
	     *      };
	     *      var allConfigs = [
	     *        // ...
	     *      ];
	     *      R.map(R.constructN(1, Widget), allConfigs); // a list of Widgets
	     */
	    var constructN = _curry2(function constructN(n, Fn) {
	        if (n > 10) {
	            throw new Error('Constructor with greater than ten arguments');
	        }
	        if (n === 0) {
	            return function () {
	                return new Fn();
	            };
	        }
	        return curry(nAry(n, function ($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	            switch (arguments.length) {
	            case 1:
	                return new Fn($0);
	            case 2:
	                return new Fn($0, $1);
	            case 3:
	                return new Fn($0, $1, $2);
	            case 4:
	                return new Fn($0, $1, $2, $3);
	            case 5:
	                return new Fn($0, $1, $2, $3, $4);
	            case 6:
	                return new Fn($0, $1, $2, $3, $4, $5);
	            case 7:
	                return new Fn($0, $1, $2, $3, $4, $5, $6);
	            case 8:
	                return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	            case 9:
	                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	            case 10:
	                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	            }
	        }));
	    });
	
	    /**
	     * Accepts a converging function and a list of branching functions and returns
	     * a new function. When invoked, this new function is applied to some
	     * arguments, each branching function is applied to those same arguments. The
	     * results of each branching function are passed as arguments to the converging
	     * function to produce the return value.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.4.2
	     * @category Function
	     * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
	     * @param {Function} after A function. `after` will be invoked with the return values of
	     *        `fn1` and `fn2` as its arguments.
	     * @param {Array} functions A list of functions.
	     * @return {Function} A new function.
	     * @example
	     *
	     *      var add = (a, b) => a + b;
	     *      var multiply = (a, b) => a * b;
	     *      var subtract = (a, b) => a - b;
	     *
	     *      //≅ multiply( add(1, 2), subtract(1, 2) );
	     *      R.converge(multiply, [add, subtract])(1, 2); //=> -3
	     *
	     *      var add3 = (a, b, c) => a + b + c;
	     *      R.converge(add3, [multiply, add, subtract])(1, 2); //=> 4
	     */
	    var converge = _curry2(function converge(after, fns) {
	        return curryN(Math.max.apply(Math, pluck('length', fns)), function () {
	            var args = arguments;
	            var context = this;
	            return after.apply(context, _map(function (fn) {
	                return fn.apply(context, args);
	            }, fns));
	        });
	    });
	
	    /**
	     * Returns a new list without any consecutively repeating elements. Equality is
	     * determined by applying the supplied predicate two consecutive elements. The
	     * first element in a series of equal element is the one being preserved.
	     *
	     * Dispatches to the `dropRepeatsWith` method of the second argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category List
	     * @sig (a, a -> Boolean) -> [a] -> [a]
	     * @param {Function} pred A predicate used to test whether two items are equal.
	     * @param {Array} list The array to consider.
	     * @return {Array} `list` without repeating elements.
	     * @see R.transduce
	     * @example
	     *
	     *      var lengthEq = (x, y) => Math.abs(x) === Math.abs(y);
	     *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	     *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	     */
	    var dropRepeatsWith = _curry2(_dispatchable('dropRepeatsWith', _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	        var result = [];
	        var idx = 1;
	        var len = list.length;
	        if (len !== 0) {
	            result[0] = list[0];
	            while (idx < len) {
	                if (!pred(last(result), list[idx])) {
	                    result[result.length] = list[idx];
	                }
	                idx += 1;
	            }
	        }
	        return result;
	    }));
	
	    /**
	     * Takes a function and two values in its domain and returns `true` if the
	     * values map to the same value in the codomain; `false` otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.18.0
	     * @category Relation
	     * @sig (a -> b) -> a -> a -> Boolean
	     * @param {Function} f
	     * @param {*} x
	     * @param {*} y
	     * @return {Boolean}
	     * @example
	     *
	     *      R.eqBy(Math.abs, 5, -5); //=> true
	     */
	    var eqBy = _curry3(function eqBy(f, x, y) {
	        return equals(f(x), f(y));
	    });
	
	    /**
	     * Reports whether two objects have the same value, in `R.equals` terms, for
	     * the specified property. Useful as a curried predicate.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @sig k -> {k: v} -> {k: v} -> Boolean
	     * @param {String} prop The name of the property to compare
	     * @param {Object} obj1
	     * @param {Object} obj2
	     * @return {Boolean}
	     *
	     * @example
	     *
	     *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
	     *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
	     *      R.eqProps('a', o1, o2); //=> false
	     *      R.eqProps('c', o1, o2); //=> true
	     */
	    var eqProps = _curry3(function eqProps(prop, obj1, obj2) {
	        return equals(obj1[prop], obj2[prop]);
	    });
	
	    /**
	     * Returns the position of the first occurrence of an item in an array, or -1
	     * if the item is not included in the array. `R.equals` is used to determine
	     * equality.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig a -> [a] -> Number
	     * @param {*} target The item to find.
	     * @param {Array} xs The array to search in.
	     * @return {Number} the index of the target, or -1 if the target is not found.
	     * @see R.lastIndexOf
	     * @example
	     *
	     *      R.indexOf(3, [1,2,3,4]); //=> 2
	     *      R.indexOf(10, [1,2,3,4]); //=> -1
	     */
	    var indexOf = _curry2(function indexOf(target, xs) {
	        return typeof xs.indexOf === 'function' && !_isArray(xs) ? xs.indexOf(target) : _indexOf(xs, target, 0);
	    });
	
	    /**
	     * juxt applies a list of functions to a list of values.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category Function
	     * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
	     * @param {Array} fns An array of functions
	     * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
	     * @example
	     *
	     *      var range = R.juxt([Math.min, Math.max]);
	     *      range(3, 4, 9, -3); //=> [-3, 9]
	     */
	    var juxt = _curry1(function juxt(fns) {
	        return function () {
	            return map(apply(__, arguments), fns);
	        };
	    });
	
	    /**
	     * Returns a lens for the given getter and setter functions. The getter "gets"
	     * the value of the focus; the setter "sets" the value of the focus. The setter
	     * should not mutate the data structure.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category Object
	     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	     * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	     * @param {Function} getter
	     * @param {Function} setter
	     * @return {Lens}
	     * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	     * @example
	     *
	     *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
	     *
	     *      R.view(xLens, {x: 1, y: 2});            //=> 1
	     *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	     *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	     */
	    var lens = _curry2(function lens(getter, setter) {
	        return function (f) {
	            return function (s) {
	                return map(function (v) {
	                    return setter(v, s);
	                }, f(getter(s)));
	            };
	        };
	    });
	
	    /**
	     * Returns a lens whose focus is the specified index.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category Object
	     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	     * @sig Number -> Lens s a
	     * @param {Number} n
	     * @return {Lens}
	     * @see R.view, R.set, R.over
	     * @example
	     *
	     *      var headLens = R.lensIndex(0);
	     *
	     *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
	     *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
	     *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
	     */
	    var lensIndex = _curry1(function lensIndex(n) {
	        return lens(nth(n), update(n));
	    });
	
	    /**
	     * Returns a lens whose focus is the specified path.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category Object
	     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	     * @sig [String] -> Lens s a
	     * @param {Array} path The path to use.
	     * @return {Lens}
	     * @see R.view, R.set, R.over
	     * @example
	     *
	     *      var xyLens = R.lensPath(['x', 'y']);
	     *
	     *      R.view(xyLens, {x: {y: 2, z: 3}});            //=> 2
	     *      R.set(xyLens, 4, {x: {y: 2, z: 3}});          //=> {x: {y: 4, z: 3}}
	     *      R.over(xyLens, R.negate, {x: {y: 2, z: 3}});  //=> {x: {y: -2, z: 3}}
	     */
	    var lensPath = _curry1(function lensPath(p) {
	        return lens(path(p), assocPath(p));
	    });
	
	    /**
	     * Returns a lens whose focus is the specified property.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category Object
	     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	     * @sig String -> Lens s a
	     * @param {String} k
	     * @return {Lens}
	     * @see R.view, R.set, R.over
	     * @example
	     *
	     *      var xLens = R.lensProp('x');
	     *
	     *      R.view(xLens, {x: 1, y: 2});            //=> 1
	     *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	     *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	     */
	    var lensProp = _curry1(function lensProp(k) {
	        return lens(prop(k), assoc(k));
	    });
	
	    /**
	     * "lifts" a function to be the specified arity, so that it may "map over" that
	     * many lists (or other objects that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply)).
	     *
	     * @func
	     * @memberOf R
	     * @since v0.7.0
	     * @category Function
	     * @sig Number -> (*... -> *) -> ([*]... -> [*])
	     * @param {Function} fn The function to lift into higher context
	     * @return {Function} The lifted function.
	     * @see R.lift
	     * @example
	     *
	     *      var madd3 = R.liftN(3, R.curryN(3, (...args) => R.sum(args)));
	     *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	     */
	    var liftN = _curry2(function liftN(arity, fn) {
	        var lifted = curryN(arity, fn);
	        return curryN(arity, function () {
	            return _reduce(ap, map(lifted, arguments[0]), _slice(arguments, 1));
	        });
	    });
	
	    /**
	     * Returns the mean of the given list of numbers.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category Math
	     * @sig [Number] -> Number
	     * @param {Array} list
	     * @return {Number}
	     * @example
	     *
	     *      R.mean([2, 7, 9]); //=> 6
	     *      R.mean([]); //=> NaN
	     */
	    var mean = _curry1(function mean(list) {
	        return sum(list) / list.length;
	    });
	
	    /**
	     * Returns the median of the given list of numbers.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category Math
	     * @sig [Number] -> Number
	     * @param {Array} list
	     * @return {Number}
	     * @example
	     *
	     *      R.median([2, 9, 7]); //=> 7
	     *      R.median([7, 2, 10, 9]); //=> 8
	     *      R.median([]); //=> NaN
	     */
	    var median = _curry1(function median(list) {
	        var len = list.length;
	        if (len === 0) {
	            return NaN;
	        }
	        var width = 2 - len % 2;
	        var idx = (len - width) / 2;
	        return mean(_slice(list).sort(function (a, b) {
	            return a < b ? -1 : a > b ? 1 : 0;
	        }).slice(idx, idx + width));
	    });
	
	    /**
	     * Create a new object with the own properties of the first object merged with
	     * the own properties of the second object. If a key exists in both objects,
	     * the value from the second object will be used.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @sig {k: v} -> {k: v} -> {k: v}
	     * @param {Object} l
	     * @param {Object} r
	     * @return {Object}
	     * @see R.mergeWith, R.mergeWithKey
	     * @example
	     *
	     *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	     *      //=> { 'name': 'fred', 'age': 40 }
	     *
	     *      var resetToDefault = R.merge(R.__, {x: 0});
	     *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	     */
	    var merge = mergeWith(function (l, r) {
	        return r;
	    });
	
	    /**
	     * Merges a list of objects together into one object.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category List
	     * @sig [{k: v}] -> {k: v}
	     * @param {Array} list An array of objects
	     * @return {Object} A merged object.
	     * @see R.reduce
	     * @example
	     *
	     *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	     *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	     */
	    var mergeAll = _curry1(function mergeAll(list) {
	        return reduce(merge, {}, list);
	    });
	
	    /**
	     * Performs left-to-right function composition. The leftmost function may have
	     * any arity; the remaining functions must be unary.
	     *
	     * In some libraries this function is named `sequence`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	     * @param {...Function} functions
	     * @return {Function}
	     * @see R.compose
	     * @example
	     *
	     *      var f = R.pipe(Math.pow, R.negate, R.inc);
	     *
	     *      f(3, 4); // -(3^4) + 1
	     */
	    var pipe = function pipe() {
	        if (arguments.length === 0) {
	            throw new Error('pipe requires at least one argument');
	        }
	        return _arity(arguments[0].length, reduce(_pipe, arguments[0], tail(arguments)));
	    };
	
	    /**
	     * Performs left-to-right composition of one or more Promise-returning
	     * functions. The leftmost function may have any arity; the remaining functions
	     * must be unary.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category Function
	     * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
	     * @param {...Function} functions
	     * @return {Function}
	     * @see R.composeP
	     * @example
	     *
	     *      //  followersForUser :: String -> Promise [User]
	     *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
	     */
	    var pipeP = function pipeP() {
	        if (arguments.length === 0) {
	            throw new Error('pipeP requires at least one argument');
	        }
	        return _arity(arguments[0].length, reduce(_pipeP, arguments[0], tail(arguments)));
	    };
	
	    /**
	     * Multiplies together all the elements of a list.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Math
	     * @sig [Number] -> Number
	     * @param {Array} list An array of numbers
	     * @return {Number} The product of all the numbers in the list.
	     * @see R.reduce
	     * @example
	     *
	     *      R.product([2,4,6,8,100,1]); //=> 38400
	     */
	    var product = reduce(multiply, 1);
	
	    /**
	     * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
	     * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
	     * Applicative of Traversable.
	     *
	     * Dispatches to the `sequence` method of the second argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category List
	     * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
	     * @param {Function} of
	     * @param {*} traversable
	     * @return {*}
	     * @see R.traverse
	     * @example
	     *
	     *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	     *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	     *
	     *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
	     *      R.sequence(R.of, Nothing());       //=> [Nothing()]
	     */
	    var sequence = _curry2(function sequence(of, traversable) {
	        return typeof traversable.sequence === 'function' ? traversable.sequence(of) : reduceRight(function (acc, x) {
	            return ap(map(prepend, x), acc);
	        }, of([]), traversable);
	    });
	
	    /**
	     * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
	     * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
	     * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
	     * into an Applicative of Traversable.
	     *
	     * Dispatches to the `sequence` method of the third argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category List
	     * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
	     * @param {Function} of
	     * @param {Function} f
	     * @param {*} traversable
	     * @return {*}
	     * @see R.sequence
	     * @example
	     *
	     *      R.traverse(Maybe.of, R.negate, [Just(1), Just(2), Just(3)]);   //=> Just([-1, -2, -3])
	     *      R.traverse(Maybe.of, R.negate, [Just(1), Just(2), Nothing()]); //=> Nothing()
	     *
	     *      R.traverse(R.of, R.negate, Just([1, 2, 3])); //=> [Just(-1), Just(-2), Just(-3)]
	     *      R.traverse(R.of, R.negate, Nothing());       //=> [Nothing()]
	     */
	    var traverse = _curry3(function traverse(of, f, traversable) {
	        return sequence(of, map(f, traversable));
	    });
	
	    /**
	     * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
	     * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
	     *
	     * @func
	     * @memberOf R
	     * @since v0.3.0
	     * @category List
	     * @sig Chain c => c (c a) -> c a
	     * @param {*} list
	     * @return {*}
	     * @see R.flatten, R.chain
	     * @example
	     *
	     *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
	     *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
	     */
	    var unnest = chain(_identity);
	
	    var _contains = function _contains(a, list) {
	        return _indexOf(list, a, 0) >= 0;
	    };
	
	    var _stepCat = function () {
	        var _stepCatArray = {
	            '@@transducer/init': Array,
	            '@@transducer/step': function (xs, x) {
	                return _concat(xs, [x]);
	            },
	            '@@transducer/result': _identity
	        };
	        var _stepCatString = {
	            '@@transducer/init': String,
	            '@@transducer/step': function (a, b) {
	                return a + b;
	            },
	            '@@transducer/result': _identity
	        };
	        var _stepCatObject = {
	            '@@transducer/init': Object,
	            '@@transducer/step': function (result, input) {
	                return merge(result, isArrayLike(input) ? objOf(input[0], input[1]) : input);
	            },
	            '@@transducer/result': _identity
	        };
	        return function _stepCat(obj) {
	            if (_isTransformer(obj)) {
	                return obj;
	            }
	            if (isArrayLike(obj)) {
	                return _stepCatArray;
	            }
	            if (typeof obj === 'string') {
	                return _stepCatString;
	            }
	            if (typeof obj === 'object') {
	                return _stepCatObject;
	            }
	            throw new Error('Cannot create transformer for ' + obj);
	        };
	    }();
	
	    //  mapPairs :: (Object, [String]) -> [String]
	    var _toString = function _toString(x, seen) {
	        var recur = function recur(y) {
	            var xs = seen.concat([x]);
	            return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	        };
	        //  mapPairs :: (Object, [String]) -> [String]
	        var mapPairs = function (obj, keys) {
	            return _map(function (k) {
	                return _quote(k) + ': ' + recur(obj[k]);
	            }, keys.slice().sort());
	        };
	        switch (Object.prototype.toString.call(x)) {
	        case '[object Arguments]':
	            return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	        case '[object Array]':
	            return '[' + _map(recur, x).concat(mapPairs(x, reject(function (k) {
	                return /^\d+$/.test(k);
	            }, keys(x)))).join(', ') + ']';
	        case '[object Boolean]':
	            return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	        case '[object Date]':
	            return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	        case '[object Null]':
	            return 'null';
	        case '[object Number]':
	            return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	        case '[object String]':
	            return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	        case '[object Undefined]':
	            return 'undefined';
	        default:
	            if (typeof x.toString === 'function') {
	                var repr = x.toString();
	                if (repr !== '[object Object]') {
	                    return repr;
	                }
	            }
	            return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	        }
	    };
	
	    /**
	     * Turns a list of Functors into a Functor of a list.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.8.0
	     * @category List
	     * @sig Functor f => (x -> f x) -> [f a] -> f [a]
	     * @param {Function} of A function that returns the data type to return
	     * @param {Array} list An array of functors of the same type
	     * @return {*}
	     * @see R.sequence
	     * @deprecated since v0.19.0
	     * @example
	     *
	     *      R.commute(R.of, [[1], [2, 3]]);   //=> [[1, 2], [1, 3]]
	     *      R.commute(R.of, [[1, 2], [3]]);   //=> [[1, 3], [2, 3]]
	     *      R.commute(R.of, [[1], [2], [3]]); //=> [[1, 2, 3]]
	     *      R.commute(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	     *      R.commute(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	     */
	    var commute = commuteMap(identity);
	
	    /**
	     * Performs right-to-left function composition. The rightmost function may have
	     * any arity; the remaining functions must be unary.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	     * @param {...Function} functions
	     * @return {Function}
	     * @see R.pipe
	     * @example
	     *
	     *      var f = R.compose(R.inc, R.negate, Math.pow);
	     *
	     *      f(3, 4); // -(3^4) + 1
	     */
	    var compose = function compose() {
	        if (arguments.length === 0) {
	            throw new Error('compose requires at least one argument');
	        }
	        return pipe.apply(this, reverse(arguments));
	    };
	
	    /**
	     * Returns the right-to-left Kleisli composition of the provided functions,
	     * each of which must return a value of a type supported by [`chain`](#chain).
	     *
	     * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category Function
	     * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (m a -> m z)
	     * @param {...Function}
	     * @return {Function}
	     * @see R.pipeK
	     * @example
	     *
	     *      //  parseJson :: String -> Maybe *
	     *      //  get :: String -> Object -> Maybe *
	     *
	     *      //  getStateCode :: Maybe String -> Maybe String
	     *      var getStateCode = R.composeK(
	     *        R.compose(Maybe.of, R.toUpper),
	     *        get('state'),
	     *        get('address'),
	     *        get('user'),
	     *        parseJson
	     *      );
	     *
	     *      getStateCode(Maybe.of('{"user":{"address":{"state":"ny"}}}'));
	     *      //=> Just('NY')
	     *      getStateCode(Maybe.of('[Invalid JSON]'));
	     *      //=> Nothing()
	     */
	    var composeK = function composeK() {
	        return compose.apply(this, prepend(identity, map(chain, arguments)));
	    };
	
	    /**
	     * Performs right-to-left composition of one or more Promise-returning
	     * functions. The rightmost function may have any arity; the remaining
	     * functions must be unary.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.10.0
	     * @category Function
	     * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
	     * @param {...Function} functions
	     * @return {Function}
	     * @see R.pipeP
	     * @example
	     *
	     *      //  followersForUser :: String -> Promise [User]
	     *      var followersForUser = R.composeP(db.getFollowers, db.getUserById);
	     */
	    var composeP = function composeP() {
	        if (arguments.length === 0) {
	            throw new Error('composeP requires at least one argument');
	        }
	        return pipeP.apply(this, reverse(arguments));
	    };
	
	    /**
	     * Wraps a constructor function inside a curried function that can be called
	     * with the same arguments and returns the same type.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig (* -> {*}) -> (* -> {*})
	     * @param {Function} Fn The constructor function to wrap.
	     * @return {Function} A wrapped, curried constructor function.
	     * @example
	     *
	     *      // Constructor function
	     *      var Widget = config => {
	     *        // ...
	     *      };
	     *      Widget.prototype = {
	     *        // ...
	     *      };
	     *      var allConfigs = [
	     *        // ...
	     *      ];
	     *      R.map(R.construct(Widget), allConfigs); // a list of Widgets
	     */
	    var construct = _curry1(function construct(Fn) {
	        return constructN(Fn.length, Fn);
	    });
	
	    /**
	     * Returns `true` if the specified value is equal, in `R.equals` terms, to at
	     * least one element of the given list; `false` otherwise.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig a -> [a] -> Boolean
	     * @param {Object} a The item to compare against.
	     * @param {Array} list The array to consider.
	     * @return {Boolean} `true` if the item is in the list, `false` otherwise.
	     * @see R.any
	     * @example
	     *
	     *      R.contains(3, [1, 2, 3]); //=> true
	     *      R.contains(4, [1, 2, 3]); //=> false
	     *      R.contains([42], [[42]]); //=> true
	     */
	    var contains = _curry2(_contains);
	
	    /**
	     * Finds the set (i.e. no duplicates) of all elements in the first list not
	     * contained in the second list.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig [*] -> [*] -> [*]
	     * @param {Array} list1 The first list.
	     * @param {Array} list2 The second list.
	     * @return {Array} The elements in `list1` that are not in `list2`.
	     * @see R.differenceWith
	     * @example
	     *
	     *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
	     *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
	     */
	    var difference = _curry2(function difference(first, second) {
	        var out = [];
	        var idx = 0;
	        var firstLen = first.length;
	        while (idx < firstLen) {
	            if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
	                out[out.length] = first[idx];
	            }
	            idx += 1;
	        }
	        return out;
	    });
	
	    /**
	     * Returns a new list without any consecutively repeating elements. `R.equals`
	     * is used to determine equality.
	     *
	     * Dispatches to the `dropRepeats` method of the first argument, if present.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category List
	     * @sig [a] -> [a]
	     * @param {Array} list The array to consider.
	     * @return {Array} `list` without repeating elements.
	     * @see R.transduce
	     * @example
	     *
	     *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
	     */
	    var dropRepeats = _curry1(_dispatchable('dropRepeats', _xdropRepeatsWith(equals), dropRepeatsWith(equals)));
	
	    /**
	     * Transforms the items of the list with the transducer and appends the
	     * transformed items to the accumulator using an appropriate iterator function
	     * based on the accumulator type.
	     *
	     * The accumulator can be an array, string, object or a transformer. Iterated
	     * items will be appended to arrays and concatenated to strings. Objects will
	     * be merged directly or 2-item arrays will be merged as key, value pairs.
	     *
	     * The accumulator can also be a transformer object that provides a 2-arity
	     * reducing iterator function, step, 0-arity initial value function, init, and
	     * 1-arity result extraction function result. The step function is used as the
	     * iterator function in reduce. The result function is used to convert the
	     * final accumulator into the return type and in most cases is R.identity. The
	     * init function is used to provide the initial accumulator.
	     *
	     * The iteration is performed with R.reduce after initializing the transducer.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.12.0
	     * @category List
	     * @sig a -> (b -> b) -> [c] -> a
	     * @param {*} acc The initial accumulator value.
	     * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	     * @param {Array} list The list to iterate over.
	     * @return {*} The final, accumulated value.
	     * @example
	     *
	     *      var numbers = [1, 2, 3, 4];
	     *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	     *
	     *      R.into([], transducer, numbers); //=> [2, 3]
	     *
	     *      var intoArray = R.into([]);
	     *      intoArray(transducer, numbers); //=> [2, 3]
	     */
	    var into = _curry3(function into(acc, xf, list) {
	        return _isTransformer(acc) ? _reduce(xf(acc), acc['@@transducer/init'](), list) : _reduce(xf(_stepCat(acc)), acc, list);
	    });
	
	    /**
	     * "lifts" a function of arity > 1 so that it may "map over" an Array or other
	     * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	     *
	     * @func
	     * @memberOf R
	     * @since v0.7.0
	     * @category Function
	     * @sig (*... -> *) -> ([*]... -> [*])
	     * @param {Function} fn The function to lift into higher context
	     * @return {Function} The lifted function.
	     * @see R.liftN
	     * @example
	     *
	     *      var madd3 = R.lift(R.curry((a, b, c) => a + b + c));
	     *
	     *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	     *
	     *      var madd5 = R.lift(R.curry((a, b, c, d, e) => a + b + c + d + e));
	     *
	     *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	     */
	    var lift = _curry1(function lift(fn) {
	        return liftN(fn.length, fn);
	    });
	
	    /**
	     * Returns a partial copy of an object omitting the keys specified.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Object
	     * @sig [String] -> {String: *} -> {String: *}
	     * @param {Array} names an array of String property names to omit from the new object
	     * @param {Object} obj The object to copy from
	     * @return {Object} A new object with properties from `names` not on it.
	     * @see R.pick
	     * @example
	     *
	     *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
	     */
	    var omit = _curry2(function omit(names, obj) {
	        var result = {};
	        for (var prop in obj) {
	            if (!_contains(prop, names)) {
	                result[prop] = obj[prop];
	            }
	        }
	        return result;
	    });
	
	    /**
	     * Returns the left-to-right Kleisli composition of the provided functions,
	     * each of which must return a value of a type supported by [`chain`](#chain).
	     *
	     * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category Function
	     * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (m a -> m z)
	     * @param {...Function}
	     * @return {Function}
	     * @see R.composeK
	     * @example
	     *
	     *      //  parseJson :: String -> Maybe *
	     *      //  get :: String -> Object -> Maybe *
	     *
	     *      //  getStateCode :: Maybe String -> Maybe String
	     *      var getStateCode = R.pipeK(
	     *        parseJson,
	     *        get('user'),
	     *        get('address'),
	     *        get('state'),
	     *        R.compose(Maybe.of, R.toUpper)
	     *      );
	     *
	     *      getStateCode(Maybe.of('{"user":{"address":{"state":"ny"}}}'));
	     *      //=> Just('NY')
	     *      getStateCode(Maybe.of('[Invalid JSON]'));
	     *      //=> Nothing()
	     */
	    var pipeK = function pipeK() {
	        return composeK.apply(this, reverse(arguments));
	    };
	
	    /**
	     * Returns the string representation of the given value. `eval`'ing the output
	     * should result in a value equivalent to the input value. Many of the built-in
	     * `toString` methods do not satisfy this requirement.
	     *
	     * If the given value is an `[object Object]` with a `toString` method other
	     * than `Object.prototype.toString`, this method is invoked with no arguments
	     * to produce the return value. This means user-defined constructor functions
	     * can provide a suitable `toString` method. For example:
	     *
	     *     function Point(x, y) {
	     *       this.x = x;
	     *       this.y = y;
	     *     }
	     *
	     *     Point.prototype.toString = function() {
	     *       return 'new Point(' + this.x + ', ' + this.y + ')';
	     *     };
	     *
	     *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	     *
	     * @func
	     * @memberOf R
	     * @since v0.14.0
	     * @category String
	     * @sig * -> String
	     * @param {*} val
	     * @return {String}
	     * @example
	     *
	     *      R.toString(42); //=> '42'
	     *      R.toString('abc'); //=> '"abc"'
	     *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	     *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	     *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	     */
	    var toString = _curry1(function toString(val) {
	        return _toString(val, []);
	    });
	
	    /**
	     * Returns a new list containing only one copy of each element in the original
	     * list, based upon the value returned by applying the supplied function to
	     * each list element. Prefers the first item if the supplied function produces
	     * the same value on two items. `R.equals` is used for comparison.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.16.0
	     * @category List
	     * @sig (a -> b) -> [a] -> [a]
	     * @param {Function} fn A function used to produce a value to use during comparisons.
	     * @param {Array} list The array to consider.
	     * @return {Array} The list of unique items.
	     * @example
	     *
	     *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
	     */
	    /* globals Set */
	    // distinguishing between +0 and -0 is not supported by Set
	    /* falls through */
	    // these types can all utilise Set
	    // prevent scan for null by tracking as a boolean
	    /* falls through */
	    // scan through all previously applied items
	    var uniqBy = _curry2(/* globals Set */
	    typeof Set === 'undefined' ? function uniqBy(fn, list) {
	        var idx = 0;
	        var applied = [];
	        var result = [];
	        var appliedItem, item;
	        while (idx < list.length) {
	            item = list[idx];
	            appliedItem = fn(item);
	            if (!_contains(appliedItem, applied)) {
	                result.push(item);
	                applied.push(appliedItem);
	            }
	            idx += 1;
	        }
	        return result;
	    } : function uniqBySet(fn, list) {
	        var set = new Set();
	        var applied = [];
	        var prevSetSize = 0;
	        var result = [];
	        var nullExists = false;
	        var negZeroExists = false;
	        var idx = 0;
	        var appliedItem, item, newSetSize;
	        while (idx < list.length) {
	            item = list[idx];
	            appliedItem = fn(item);
	            switch (typeof appliedItem) {
	            case 'number':
	                // distinguishing between +0 and -0 is not supported by Set
	                if (appliedItem === 0 && !negZeroExists && 1 / appliedItem === -Infinity) {
	                    negZeroExists = true;
	                    result.push(item);
	                    break;
	                }
	            /* falls through */
	            case 'string':
	            case 'boolean':
	            case 'function':
	            case 'undefined':
	                // these types can all utilise Set
	                set.add(appliedItem);
	                newSetSize = set.size;
	                if (newSetSize > prevSetSize) {
	                    result.push(item);
	                    prevSetSize = newSetSize;
	                }
	                break;
	            case 'object':
	                if (appliedItem === null) {
	                    if (!nullExists) {
	                        // prevent scan for null by tracking as a boolean
	                        nullExists = true;
	                        result.push(null);
	                    }
	                    break;
	                }
	            /* falls through */
	            default:
	                // scan through all previously applied items
	                if (!_contains(appliedItem, applied)) {
	                    applied.push(appliedItem);
	                    result.push(item);
	                }
	            }
	            idx += 1;
	        }
	        return result;
	    });
	
	    /**
	     * Returns a new list without values in the first argument.
	     * `R.equals` is used to determine equality.
	     *
	     * Acts as a transducer if a transformer is given in list position.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category List
	     * @sig [a] -> [a] -> [a]
	     * @param {Array} list1 The values to be removed from `list2`.
	     * @param {Array} list2 The array to remove values from.
	     * @return {Array} The new array without values in `list1`.
	     * @see R.transduce
	     * @example
	     *
	     *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	     */
	    var without = _curry2(function (xs, list) {
	        return reject(flip(_contains)(xs), list);
	    });
	
	    /**
	     * Takes a function `f` and returns a function `g` such that:
	     *
	     *   - applying `g` to zero or more arguments will give __true__ if applying
	     *     the same arguments to `f` gives a logical __false__ value; and
	     *
	     *   - applying `g` to zero or more arguments will give __false__ if applying
	     *     the same arguments to `f` gives a logical __true__ value.
	     *
	     * `R.complement` will work on all other functors as well.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.12.0
	     * @category Logic
	     * @sig (*... -> *) -> (*... -> Boolean)
	     * @param {Function} f
	     * @return {Function}
	     * @see R.not
	     * @example
	     *
	     *      var isEven = n => n % 2 === 0;
	     *      var isOdd = R.complement(isEven);
	     *      isOdd(21); //=> true
	     *      isOdd(42); //=> false
	     */
	    var complement = lift(not);
	
	    /**
	     * Turns a named method with a specified arity into a function that can be
	     * called directly supplied with arguments and a target object.
	     *
	     * The returned function is curried and accepts `arity + 1` parameters where
	     * the final parameter is the target object.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	     * @param {Number} arity Number of arguments the returned function should take
	     *        before the target object.
	     * @param {String} method Name of the method to call.
	     * @return {Function} A new curried function.
	     * @example
	     *
	     *      var sliceFrom = R.invoker(1, 'slice');
	     *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	     *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	     *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	     */
	    var invoker = _curry2(function invoker(arity, method) {
	        return curryN(arity + 1, function () {
	            var target = arguments[arity];
	            if (target != null && is(Function, target[method])) {
	                return target[method].apply(target, _slice(arguments, 0, arity));
	            }
	            throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	        });
	    });
	
	    /**
	     * Returns a string made by inserting the `separator` between each element and
	     * concatenating all the elements into a single string.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig String -> [a] -> String
	     * @param {Number|String} separator The string used to separate the elements.
	     * @param {Array} xs The elements to join into a string.
	     * @return {String} str The string made by concatenating `xs` with `separator`.
	     * @see R.split
	     * @example
	     *
	     *      var spacer = R.join(' ');
	     *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	     *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	     */
	    var join = invoker(1, 'join');
	
	    /**
	     * Creates a new function that, when invoked, caches the result of calling `fn`
	     * for a given argument set and returns the result. Subsequent calls to the
	     * memoized `fn` with the same argument set will not result in an additional
	     * call to `fn`; instead, the cached result for that set of arguments will be
	     * returned.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Function
	     * @sig (*... -> a) -> (*... -> a)
	     * @param {Function} fn The function to memoize.
	     * @return {Function} Memoized version of `fn`.
	     * @example
	     *
	     *      var count = 0;
	     *      var factorial = R.memoize(n => {
	     *        count += 1;
	     *        return R.product(R.range(1, n + 1));
	     *      });
	     *      factorial(5); //=> 120
	     *      factorial(5); //=> 120
	     *      factorial(5); //=> 120
	     *      count; //=> 1
	     */
	    var memoize = _curry1(function memoize(fn) {
	        var cache = {};
	        return _arity(fn.length, function () {
	            var key = toString(arguments);
	            if (!_has(key, cache)) {
	                cache[key] = fn.apply(this, arguments);
	            }
	            return cache[key];
	        });
	    });
	
	    /**
	     * Splits a string into an array of strings based on the given
	     * separator.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category String
	     * @sig (String | RegExp) -> String -> [String]
	     * @param {String|RegExp} sep The pattern.
	     * @param {String} str The string to separate into an array.
	     * @return {Array} The array of strings from `str` separated by `str`.
	     * @see R.join
	     * @example
	     *
	     *      var pathComponents = R.split('/');
	     *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
	     *
	     *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
	     */
	    var split = invoker(1, 'split');
	
	    /**
	     * Determines whether a given string matches a given regular expression.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.12.0
	     * @category String
	     * @sig RegExp -> String -> Boolean
	     * @param {RegExp} pattern
	     * @param {String} str
	     * @return {Boolean}
	     * @see R.match
	     * @example
	     *
	     *      R.test(/^x/, 'xyz'); //=> true
	     *      R.test(/^y/, 'xyz'); //=> false
	     */
	    var test = _curry2(function test(pattern, str) {
	        if (!_isRegExp(pattern)) {
	            throw new TypeError('\u2018test\u2019 requires a value of type RegExp as its first argument; received ' + toString(pattern));
	        }
	        return _cloneRegExp(pattern).test(str);
	    });
	
	    /**
	     * The lower case version of a string.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category String
	     * @sig String -> String
	     * @param {String} str The string to lower case.
	     * @return {String} The lower case version of `str`.
	     * @see R.toUpper
	     * @example
	     *
	     *      R.toLower('XYZ'); //=> 'xyz'
	     */
	    var toLower = invoker(0, 'toLowerCase');
	
	    /**
	     * The upper case version of a string.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.9.0
	     * @category String
	     * @sig String -> String
	     * @param {String} str The string to upper case.
	     * @return {String} The upper case version of `str`.
	     * @see R.toLower
	     * @example
	     *
	     *      R.toUpper('abc'); //=> 'ABC'
	     */
	    var toUpper = invoker(0, 'toUpperCase');
	
	    /**
	     * Returns a new list containing only one copy of each element in the original
	     * list. `R.equals` is used to determine equality.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig [a] -> [a]
	     * @param {Array} list The array to consider.
	     * @return {Array} The list of unique items.
	     * @example
	     *
	     *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
	     *      R.uniq([1, '1']);     //=> [1, '1']
	     *      R.uniq([[42], [42]]); //=> [[42]]
	     */
	    var uniq = uniqBy(identity);
	
	    /**
	     * Returns the result of concatenating the given lists or strings.
	     *
	     * Dispatches to the `concat` method of the second argument, if present.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category List
	     * @sig [a] -> [a] -> [a]
	     * @sig String -> String -> String
	     * @param {Array|String} a
	     * @param {Array|String} b
	     * @return {Array|String}
	     *
	     * @example
	     *
	     *      R.concat([], []); //=> []
	     *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	     *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	     */
	    var concat = flip(invoker(1, 'concat'));
	
	    /**
	     * Combines two lists into a set (i.e. no duplicates) composed of those
	     * elements common to both lists.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig [*] -> [*] -> [*]
	     * @param {Array} list1 The first list.
	     * @param {Array} list2 The second list.
	     * @return {Array} The list of elements found in both `list1` and `list2`.
	     * @see R.intersectionWith
	     * @example
	     *
	     *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
	     */
	    var intersection = _curry2(function intersection(list1, list2) {
	        return uniq(_filter(flip(_contains)(list1), list2));
	    });
	
	    /**
	     * Finds the set (i.e. no duplicates) of all elements contained in the first or
	     * second list, but not both.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category Relation
	     * @sig [*] -> [*] -> [*]
	     * @param {Array} list1 The first list.
	     * @param {Array} list2 The second list.
	     * @return {Array} The elements in `list1` or `list2`, but not both.
	     * @see R.symmetricDifferenceWith
	     * @example
	     *
	     *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
	     *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
	     */
	    var symmetricDifference = _curry2(function symmetricDifference(list1, list2) {
	        return concat(difference(list1, list2), difference(list2, list1));
	    });
	
	    /**
	     * Finds the set (i.e. no duplicates) of all elements contained in the first or
	     * second list, but not both. Duplication is determined according to the value
	     * returned by applying the supplied predicate to two list elements.
	     *
	     * @func
	     * @memberOf R
	     * @since 0.19.1
	     * @since 0.19.0
	     * @category Relation
	     * @sig (a -> a -> Boolean) -> [a] -> [a] -> [a]
	     * @param {Function} pred A predicate used to test whether two items are equal.
	     * @param {Array} list1 The first list.
	     * @param {Array} list2 The second list.
	     * @return {Array} The elements in `list1` or `list2`, but not both.
	     * @see R.symmetricDifference
	     * @example
	     *
	     *      var eqA = R.eqBy(R.prop('a'));
	     *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
	     *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
	     *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
	     */
	    var symmetricDifferenceWith = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
	        return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
	    });
	
	    /**
	     * Combines two lists into a set (i.e. no duplicates) composed of the elements
	     * of each list.
	     *
	     * @func
	     * @memberOf R
	     * @since v0.1.0
	     * @category Relation
	     * @sig [*] -> [*] -> [*]
	     * @param {Array} as The first list.
	     * @param {Array} bs The second list.
	     * @return {Array} The first and second lists concatenated, with
	     *         duplicates removed.
	     * @example
	     *
	     *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
	     */
	    var union = _curry2(compose(uniq, _concat));
	
	    var R = {
	        F: F,
	        T: T,
	        __: __,
	        add: add,
	        addIndex: addIndex,
	        adjust: adjust,
	        all: all,
	        allPass: allPass,
	        allUniq: allUniq,
	        always: always,
	        and: and,
	        any: any,
	        anyPass: anyPass,
	        ap: ap,
	        aperture: aperture,
	        append: append,
	        apply: apply,
	        assoc: assoc,
	        assocPath: assocPath,
	        binary: binary,
	        bind: bind,
	        both: both,
	        call: call,
	        chain: chain,
	        clone: clone,
	        commute: commute,
	        commuteMap: commuteMap,
	        comparator: comparator,
	        complement: complement,
	        compose: compose,
	        composeK: composeK,
	        composeP: composeP,
	        concat: concat,
	        cond: cond,
	        construct: construct,
	        constructN: constructN,
	        contains: contains,
	        converge: converge,
	        countBy: countBy,
	        curry: curry,
	        curryN: curryN,
	        dec: dec,
	        defaultTo: defaultTo,
	        difference: difference,
	        differenceWith: differenceWith,
	        dissoc: dissoc,
	        dissocPath: dissocPath,
	        divide: divide,
	        drop: drop,
	        dropLast: dropLast,
	        dropLastWhile: dropLastWhile,
	        dropRepeats: dropRepeats,
	        dropRepeatsWith: dropRepeatsWith,
	        dropWhile: dropWhile,
	        either: either,
	        empty: empty,
	        eqBy: eqBy,
	        eqProps: eqProps,
	        equals: equals,
	        evolve: evolve,
	        filter: filter,
	        find: find,
	        findIndex: findIndex,
	        findLast: findLast,
	        findLastIndex: findLastIndex,
	        flatten: flatten,
	        flip: flip,
	        forEach: forEach,
	        fromPairs: fromPairs,
	        groupBy: groupBy,
	        gt: gt,
	        gte: gte,
	        has: has,
	        hasIn: hasIn,
	        head: head,
	        identical: identical,
	        identity: identity,
	        ifElse: ifElse,
	        inc: inc,
	        indexBy: indexBy,
	        indexOf: indexOf,
	        init: init,
	        insert: insert,
	        insertAll: insertAll,
	        intersection: intersection,
	        intersectionWith: intersectionWith,
	        intersperse: intersperse,
	        into: into,
	        invert: invert,
	        invertObj: invertObj,
	        invoker: invoker,
	        is: is,
	        isArrayLike: isArrayLike,
	        isEmpty: isEmpty,
	        isNil: isNil,
	        join: join,
	        juxt: juxt,
	        keys: keys,
	        keysIn: keysIn,
	        last: last,
	        lastIndexOf: lastIndexOf,
	        length: length,
	        lens: lens,
	        lensIndex: lensIndex,
	        lensPath: lensPath,
	        lensProp: lensProp,
	        lift: lift,
	        liftN: liftN,
	        lt: lt,
	        lte: lte,
	        map: map,
	        mapAccum: mapAccum,
	        mapAccumRight: mapAccumRight,
	        mapObjIndexed: mapObjIndexed,
	        match: match,
	        mathMod: mathMod,
	        max: max,
	        maxBy: maxBy,
	        mean: mean,
	        median: median,
	        memoize: memoize,
	        merge: merge,
	        mergeAll: mergeAll,
	        mergeWith: mergeWith,
	        mergeWithKey: mergeWithKey,
	        min: min,
	        minBy: minBy,
	        modulo: modulo,
	        multiply: multiply,
	        nAry: nAry,
	        negate: negate,
	        none: none,
	        not: not,
	        nth: nth,
	        nthArg: nthArg,
	        objOf: objOf,
	        of: of,
	        omit: omit,
	        once: once,
	        or: or,
	        over: over,
	        pair: pair,
	        partial: partial,
	        partialRight: partialRight,
	        partition: partition,
	        path: path,
	        pathEq: pathEq,
	        pathOr: pathOr,
	        pathSatisfies: pathSatisfies,
	        pick: pick,
	        pickAll: pickAll,
	        pickBy: pickBy,
	        pipe: pipe,
	        pipeK: pipeK,
	        pipeP: pipeP,
	        pluck: pluck,
	        prepend: prepend,
	        product: product,
	        project: project,
	        prop: prop,
	        propEq: propEq,
	        propIs: propIs,
	        propOr: propOr,
	        propSatisfies: propSatisfies,
	        props: props,
	        range: range,
	        reduce: reduce,
	        reduceRight: reduceRight,
	        reduced: reduced,
	        reject: reject,
	        remove: remove,
	        repeat: repeat,
	        replace: replace,
	        reverse: reverse,
	        scan: scan,
	        sequence: sequence,
	        set: set,
	        slice: slice,
	        sort: sort,
	        sortBy: sortBy,
	        split: split,
	        splitAt: splitAt,
	        splitEvery: splitEvery,
	        splitWhen: splitWhen,
	        subtract: subtract,
	        sum: sum,
	        symmetricDifference: symmetricDifference,
	        symmetricDifferenceWith: symmetricDifferenceWith,
	        tail: tail,
	        take: take,
	        takeLast: takeLast,
	        takeLastWhile: takeLastWhile,
	        takeWhile: takeWhile,
	        tap: tap,
	        test: test,
	        times: times,
	        toLower: toLower,
	        toPairs: toPairs,
	        toPairsIn: toPairsIn,
	        toString: toString,
	        toUpper: toUpper,
	        transduce: transduce,
	        transpose: transpose,
	        traverse: traverse,
	        trim: trim,
	        type: type,
	        unapply: unapply,
	        unary: unary,
	        uncurryN: uncurryN,
	        unfold: unfold,
	        union: union,
	        unionWith: unionWith,
	        uniq: uniq,
	        uniqBy: uniqBy,
	        uniqWith: uniqWith,
	        unless: unless,
	        unnest: unnest,
	        update: update,
	        useWith: useWith,
	        values: values,
	        valuesIn: valuesIn,
	        view: view,
	        when: when,
	        where: where,
	        whereEq: whereEq,
	        without: without,
	        wrap: wrap,
	        xprod: xprod,
	        zip: zip,
	        zipObj: zipObj,
	        zipWith: zipWith
	    };
	  /* eslint-env amd */
	
	  /* TEST_ENTRY_POINT */
	
	  if (true) {
	    module.exports = R;
	  } else if (typeof define === 'function' && define.amd) {
	    define(function() { return R; });
	  } else {
	    this.R = R;
	  }
	
	}.call(this));
	


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var $ = __webpack_require__(1);
	var pli_1 = __webpack_require__(6);
	/**
	 * Current function to call when "pliCall" receives "401 Unauthorized" response.
	 *
	 * Set to null by default (no action, fail the call).
	 * Can be set for all calls using "setDefaultSignIn" exported function.
	 * Can be overridden for one call in "settings.customSignIn".
	 */
	var defaultSignIn = null;
	/**
	 * Sets default sign-in handler to the specified value (must be a function or null).
	 *
	 * @returns {PliCallSignInHandler}
	 *     Value of parameter "handler" (allows chaining).
	 */
	function setDefaultSignInHandler(handler) {
	    if (handler !== null && typeof handler !== "function") {
	        throw new Error("Default sign-in handler must be a function or null.");
	    }
	    defaultSignIn = handler;
	    return handler;
	}
	exports.setDefaultSignInHandler = setDefaultSignInHandler;
	/**
	 * Handles sign-in notifications (called from "pliCallFailed"-s subscription).
	 *
	 * We expect subscribable returned by sign-in handler to notify us with
	 * boolean value when sign-in process is complete (new authentication
	 * cookie has been issued) or cancelled (user gave up).
	 *
	 * This handler will retry the Pli call that triggered the sign-in handler
	 * (when the subscribable notification value, "signInSucceeded", is "true")
	 * or fail the call (when "signInSucceeded" is "false"). Any other value
	 * will be ignored (e.g. if the source observable is reset to "null" or "undefined").
	 */
	function pliCallSignInDone(signInSucceeded, // value that sign-in subscribable notified us with
	    signInSubscription, errorResponse, settings, xhrSettings, callPromise, callPromiseController) {
	    // ignore non-boolean values
	    if (typeof signInSucceeded !== "boolean") {
	        return false;
	    }
	    // subscription is not needed anymore (if any)
	    if (signInSubscription) {
	        signInSubscription.dispose();
	    }
	    // retry or fail
	    if (signInSucceeded) {
	        pliCallExecute(settings, xhrSettings, callPromise, callPromiseController); // retry the call
	    }
	    else {
	        callPromiseController.reject(errorResponse);
	    }
	    return true;
	}
	/**
	 * Handles failed JQuery XHR response for a Pli call (called from "pliCallExecute"-s fail handler).
	 *
	 * Special handling (based on HTTP status):
	 * - "412: Precondition Failed" will redirect the current window/tab/iframe to the URL specified
	 * - "401: Unauthorized" will use sign-in handler to give user a chance to re-authenticate (then retry the call)
	 */
	function pliCallFailed(xhr, textStatus, errorThrown, settings, xhrSettings, callPromise, callPromiseController) {
	    // make sure result is always an object
	    var result = (typeof xhr.responseJSON !== "object" || xhr.responseJSON === null
	        ? { value: xhr.responseJSON }
	        : xhr.responseJSON);
	    // "412: Precondition Failed" + a valid response object => redirect
	    if (xhr.status === 412 && result.redirectLocation) {
	        location.replace(result.redirectLocation);
	        return;
	    }
	    // create an object compatible with "PliCallResponse" interface
	    if (!result.message) {
	        result.message = "XHR call failed (status: \"".concat(textStatus).concat("\", error: \"").concat(errorThrown).concat("\")");
	    }
	    var errorResponse = {
	        clientErrorThrown: errorThrown,
	        clientStatus: textStatus,
	        clientXhr: xhr,
	        isError: true,
	        owner: settings.owner,
	        result: result
	    };
	    // "401: Unauthorized" (use sign-in handler, if any)
	    var unauthenticatedStatusCode = pli_1.pli.config.unauthenticatedStatusCode || 401;
	    if (xhr.status === unauthenticatedStatusCode && !settings.ignoreUnauthenticated) {
	        var signInHandler = settings.customSignIn || defaultSignIn;
	        if (signInHandler) {
	            // trigger sign-in handler
	            var signInDone = signInHandler({ deferClosingUntil: settings.deferSignInUiClosingUntil, serverData: result });
	            // wait for sign-in handler to be done
	            if (ko.isSubscribable(signInDone)) {
	                var signInDoneValue = signInDone.peek();
	                if (typeof (signInDoneValue) === "boolean") {
	                    pliCallSignInDone(signInDoneValue, /* signInSubscription */ null, errorResponse, settings, xhrSettings, callPromise, callPromiseController);
	                }
	                else if (signInDoneValue === null) {
	                    var signInDoneSubscription_1 = signInDone.subscribe(function (signInSucceeded) {
	                        return pliCallSignInDone(signInSucceeded, signInDoneSubscription_1, errorResponse, settings, xhrSettings, callPromise, callPromiseController);
	                    });
	                }
	                else {
	                    throw new Error("Sign-in handler was expected to return an observable set to \"null\" or a boolean value, was: " + JSON.stringify(signInDoneValue));
	                }
	            }
	            else if (signInDone === null) {
	                pliCallSignInDone(/* signInSucceeded */ false, /* signInSubscription */ null, errorResponse, settings, xhrSettings, callPromise, callPromiseController);
	            }
	            else {
	                throw new Error("Sign-in handler was expected to return null or an observable");
	            }
	            // we are done processing the current call; either we have
	            // already failed it (if sign in handler gave up on us)
	            // or we retried/failed it (if sign in handler completed
	            // synchronously) or we will retry/fail the call in
	            // the future when sign in handler signals its "done" observable
	            return;
	        }
	    }
	    // notify promise observers
	    callPromiseController.reject(errorResponse);
	}
	/**
	 * Handles successful JQuery XHR response for a Pli call (called from "pliCallExecute"-s done handler).
	 *
	 * This function builds an object compatible with "PliCallResponse" interface
	 * and resolves the specified promise (notifying all promise observers).
	 */
	function pliCallSucceeded(data, textStatus, xhr, owner, callPromiseController) {
	    callPromiseController.resolve({
	        clientStatus: textStatus,
	        clientXhr: xhr,
	        isError: false,
	        owner: owner,
	        result: data
	    });
	}
	/**
	 * Invokes the specified call as JQuery XHR request + setup response handlers (called by "pliCall" and "pliCallSignInDone").
	 *
	 * Recursive entry point for Pli calls. The same call can be retried
	 * multiple times by calling this function with the same parameters
	 * (for example when retrying a call after sign-in authentication).
	 */
	function pliCallExecute(settings, xhrSettings, callPromise, callPromiseController) {
	    callPromise.xhr = $.ajax(xhrSettings.url, xhrSettings);
	    var initialXhrState = callPromise.xhr.state(); // http://api.jquery.com/deferred.state/
	    if (initialXhrState !== "rejected") {
	        callPromise.xhr.done(function (data, textStatus, xhr) {
	            return pliCallSucceeded(data, textStatus, xhr, settings.owner, callPromiseController);
	        });
	    }
	    if (initialXhrState !== "resolved") {
	        callPromise.xhr.fail(function (xhr, textStatus, errorThrown) {
	            return pliCallFailed(xhr, textStatus, errorThrown, settings, xhrSettings, callPromise, callPromiseController);
	        });
	    }
	}
	/**
	 * Initiates an HTTP (Ajax) request that executes a function on PLI server.
	 * Uses JSON for data transport to server (request) and from server (response).
	 *
	 * @param {PliCallSettings<TRequestData, TOwner>} settings
	 *     Defines name, data and other parameters of the PLI call.
	 *
	 * @returns {PliCallPromise<TResponseData, TOwner>}
	 *     jQuery promise object that will be resolved/rejected when the call is finished
	 *     (http://api.jquery.com/deferred.promise/).
	 *
	 *     Returned object also includes a property 'xhr' that references
	 *     the underlying jQuery.ajax jqXHR request/promise object
	 *     (http://api.jquery.com/jQuery.ajax/#jqXHR) that can be used to abort the PLI call.
	 */
	function pliCall(settings) {
	    // validate settings object
	    if (typeof settings !== "object" || typeof settings.name !== "string") {
	        throw new Error("pliCall: Expected \"PliCallSettings.name\" to contain PLI call name.");
	    }
	    if (settings.ignoreForbidden !== undefined) {
	        throw new Error("pliCall: \"PliCallSettings.ignoreForbidden\" is not supported anymore, use \"ignoreUnauthenticated\" instead.");
	    }
	    if (pliCall.logOn !== undefined) {
	        throw new Error("pliCall: \"pliCall.logOn\" is not supported anymore, use \"PliCallSettings.customSignIn\" instead.");
	    }
	    // build XHR settings
	    var requestJsonData = (typeof settings.jsonData === "string" // encode data as JSON string (if needed)
	        ? settings.jsonData
	        : JSON.stringify(settings.data === undefined ? null : settings.data));
	    var headers = settings.headers || pli_1.pli.config.defaultHeaders || {};
	    if (typeof location !== "undefined") {
	        headers["X-Pli-App-Url"] = location.href;
	    }
	    var xhrSettings = {
	        url: pli_1.pli.resolveUrl("~/Pli/Call/").concat(encodeURIComponent(settings.name)),
	        type: "POST",
	        async: !settings.sync,
	        contentType: "application/json; charset=utf-8",
	        dataType: "json",
	        headers: headers,
	        data: requestJsonData
	    };
	    // execute the call
	    var callPromiseController = $.Deferred(); // used in success/failure handlers to resolve/reject "callPromise"
	    var callPromise = callPromiseController.promise();
	    pliCallExecute(settings, xhrSettings, callPromise, callPromiseController); // mutates "callPromise", setting "xhr" property
	    return callPromise;
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = pliCall;
	



/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*!
	 * Knockout JavaScript library v3.4.0
	 * (c) Steven Sanderson - http://knockoutjs.com/
	 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
	 */
	
	(function(){
	var DEBUG=true;
	(function(undefined){
	    // (0, eval)('this') is a robust way of getting a reference to the global object
	    // For details, see http://stackoverflow.com/questions/14119988/return-this-0-evalthis/14120023#14120023
	    var window = this || (0, eval)('this'),
	        document = window['document'],
	        navigator = window['navigator'],
	        jQueryInstance = window["jQuery"],
	        JSON = window["JSON"];
	(function(factory) {
	    // Support three module loading scenarios
	    if (typeof define === 'function' && define['amd']) {
	        // [1] AMD anonymous module
	        define(['exports', 'require'], factory);
	    } else if (typeof exports === 'object' && typeof module === 'object') {
	        // [2] CommonJS/Node.js
	        factory(module['exports'] || exports);  // module.exports is for Node.js
	    } else {
	        // [3] No module loader (plain <script> tag) - put directly in global namespace
	        factory(window['ko'] = {});
	    }
	}(function(koExports, amdRequire){
	// Internally, all KO objects are attached to koExports (even the non-exported ones whose names will be minified by the closure compiler).
	// In the future, the following "ko" variable may be made distinct from "koExports" so that private objects are not externally reachable.
	var ko = typeof koExports !== 'undefined' ? koExports : {};
	// Google Closure Compiler helpers (used only to make the minified file smaller)
	ko.exportSymbol = function(koPath, object) {
	    var tokens = koPath.split(".");
	
	    // In the future, "ko" may become distinct from "koExports" (so that non-exported objects are not reachable)
	    // At that point, "target" would be set to: (typeof koExports !== "undefined" ? koExports : ko)
	    var target = ko;
	
	    for (var i = 0; i < tokens.length - 1; i++)
	        target = target[tokens[i]];
	    target[tokens[tokens.length - 1]] = object;
	};
	ko.exportProperty = function(owner, publicName, object) {
	    owner[publicName] = object;
	};
	ko.version = "3.4.0";
	
	ko.exportSymbol('version', ko.version);
	// For any options that may affect various areas of Knockout and aren't directly associated with data binding.
	ko.options = {
	    'deferUpdates': false,
	    'useOnlyNativeEvents': false
	};
	
	//ko.exportSymbol('options', ko.options);   // 'options' isn't minified
	ko.utils = (function () {
	    function objectForEach(obj, action) {
	        for (var prop in obj) {
	            if (obj.hasOwnProperty(prop)) {
	                action(prop, obj[prop]);
	            }
	        }
	    }
	
	    function extend(target, source) {
	        if (source) {
	            for(var prop in source) {
	                if(source.hasOwnProperty(prop)) {
	                    target[prop] = source[prop];
	                }
	            }
	        }
	        return target;
	    }
	
	    function setPrototypeOf(obj, proto) {
	        obj.__proto__ = proto;
	        return obj;
	    }
	
	    var canSetPrototype = ({ __proto__: [] } instanceof Array);
	    var canUseSymbols = !DEBUG && typeof Symbol === 'function';
	
	    // Represent the known event types in a compact way, then at runtime transform it into a hash with event name as key (for fast lookup)
	    var knownEvents = {}, knownEventTypesByEventName = {};
	    var keyEventTypeName = (navigator && /Firefox\/2/i.test(navigator.userAgent)) ? 'KeyboardEvent' : 'UIEvents';
	    knownEvents[keyEventTypeName] = ['keyup', 'keydown', 'keypress'];
	    knownEvents['MouseEvents'] = ['click', 'dblclick', 'mousedown', 'mouseup', 'mousemove', 'mouseover', 'mouseout', 'mouseenter', 'mouseleave'];
	    objectForEach(knownEvents, function(eventType, knownEventsForType) {
	        if (knownEventsForType.length) {
	            for (var i = 0, j = knownEventsForType.length; i < j; i++)
	                knownEventTypesByEventName[knownEventsForType[i]] = eventType;
	        }
	    });
	    var eventsThatMustBeRegisteredUsingAttachEvent = { 'propertychange': true }; // Workaround for an IE9 issue - https://github.com/SteveSanderson/knockout/issues/406
	
	    // Detect IE versions for bug workarounds (uses IE conditionals, not UA string, for robustness)
	    // Note that, since IE 10 does not support conditional comments, the following logic only detects IE < 10.
	    // Currently this is by design, since IE 10+ behaves correctly when treated as a standard browser.
	    // If there is a future need to detect specific versions of IE10+, we will amend this.
	    var ieVersion = document && (function() {
	        var version = 3, div = document.createElement('div'), iElems = div.getElementsByTagName('i');
	
	        // Keep constructing conditional HTML blocks until we hit one that resolves to an empty fragment
	        while (
	            div.innerHTML = '<!--[if gt IE ' + (++version) + ']><i></i><![endif]-->',
	            iElems[0]
	        ) {}
	        return version > 4 ? version : undefined;
	    }());
	    var isIe6 = ieVersion === 6,
	        isIe7 = ieVersion === 7;
	
	    function isClickOnCheckableElement(element, eventType) {
	        if ((ko.utils.tagNameLower(element) !== "input") || !element.type) return false;
	        if (eventType.toLowerCase() != "click") return false;
	        var inputType = element.type;
	        return (inputType == "checkbox") || (inputType == "radio");
	    }
	
	    // For details on the pattern for changing node classes
	    // see: https://github.com/knockout/knockout/issues/1597
	    var cssClassNameRegex = /\S+/g;
	
	    function toggleDomNodeCssClass(node, classNames, shouldHaveClass) {
	        var addOrRemoveFn;
	        if (classNames) {
	            if (typeof node.classList === 'object') {
	                addOrRemoveFn = node.classList[shouldHaveClass ? 'add' : 'remove'];
	                ko.utils.arrayForEach(classNames.match(cssClassNameRegex), function(className) {
	                    addOrRemoveFn.call(node.classList, className);
	                });
	            } else if (typeof node.className['baseVal'] === 'string') {
	                // SVG tag .classNames is an SVGAnimatedString instance
	                toggleObjectClassPropertyString(node.className, 'baseVal', classNames, shouldHaveClass);
	            } else {
	                // node.className ought to be a string.
	                toggleObjectClassPropertyString(node, 'className', classNames, shouldHaveClass);
	            }
	        }
	    }
	
	    function toggleObjectClassPropertyString(obj, prop, classNames, shouldHaveClass) {
	        // obj/prop is either a node/'className' or a SVGAnimatedString/'baseVal'.
	        var currentClassNames = obj[prop].match(cssClassNameRegex) || [];
	        ko.utils.arrayForEach(classNames.match(cssClassNameRegex), function(className) {
	            ko.utils.addOrRemoveItem(currentClassNames, className, shouldHaveClass);
	        });
	        obj[prop] = currentClassNames.join(" ");
	    }
	
	    return {
	        fieldsIncludedWithJsonPost: ['authenticity_token', /^__RequestVerificationToken(_.*)?$/],
	
	        arrayForEach: function (array, action) {
	            for (var i = 0, j = array.length; i < j; i++)
	                action(array[i], i);
	        },
	
	        arrayIndexOf: function (array, item) {
	            if (typeof Array.prototype.indexOf == "function")
	                return Array.prototype.indexOf.call(array, item);
	            for (var i = 0, j = array.length; i < j; i++)
	                if (array[i] === item)
	                    return i;
	            return -1;
	        },
	
	        arrayFirst: function (array, predicate, predicateOwner) {
	            for (var i = 0, j = array.length; i < j; i++)
	                if (predicate.call(predicateOwner, array[i], i))
	                    return array[i];
	            return null;
	        },
	
	        arrayRemoveItem: function (array, itemToRemove) {
	            var index = ko.utils.arrayIndexOf(array, itemToRemove);
	            if (index > 0) {
	                array.splice(index, 1);
	            }
	            else if (index === 0) {
	                array.shift();
	            }
	        },
	
	        arrayGetDistinctValues: function (array) {
	            array = array || [];
	            var result = [];
	            for (var i = 0, j = array.length; i < j; i++) {
	                if (ko.utils.arrayIndexOf(result, array[i]) < 0)
	                    result.push(array[i]);
	            }
	            return result;
	        },
	
	        arrayMap: function (array, mapping) {
	            array = array || [];
	            var result = [];
	            for (var i = 0, j = array.length; i < j; i++)
	                result.push(mapping(array[i], i));
	            return result;
	        },
	
	        arrayFilter: function (array, predicate) {
	            array = array || [];
	            var result = [];
	            for (var i = 0, j = array.length; i < j; i++)
	                if (predicate(array[i], i))
	                    result.push(array[i]);
	            return result;
	        },
	
	        arrayPushAll: function (array, valuesToPush) {
	            if (valuesToPush instanceof Array)
	                array.push.apply(array, valuesToPush);
	            else
	                for (var i = 0, j = valuesToPush.length; i < j; i++)
	                    array.push(valuesToPush[i]);
	            return array;
	        },
	
	        addOrRemoveItem: function(array, value, included) {
	            var existingEntryIndex = ko.utils.arrayIndexOf(ko.utils.peekObservable(array), value);
	            if (existingEntryIndex < 0) {
	                if (included)
	                    array.push(value);
	            } else {
	                if (!included)
	                    array.splice(existingEntryIndex, 1);
	            }
	        },
	
	        canSetPrototype: canSetPrototype,
	
	        extend: extend,
	
	        setPrototypeOf: setPrototypeOf,
	
	        setPrototypeOfOrExtend: canSetPrototype ? setPrototypeOf : extend,
	
	        objectForEach: objectForEach,
	
	        objectMap: function(source, mapping) {
	            if (!source)
	                return source;
	            var target = {};
	            for (var prop in source) {
	                if (source.hasOwnProperty(prop)) {
	                    target[prop] = mapping(source[prop], prop, source);
	                }
	            }
	            return target;
	        },
	
	        emptyDomNode: function (domNode) {
	            while (domNode.firstChild) {
	                ko.removeNode(domNode.firstChild);
	            }
	        },
	
	        moveCleanedNodesToContainerElement: function(nodes) {
	            // Ensure it's a real array, as we're about to reparent the nodes and
	            // we don't want the underlying collection to change while we're doing that.
	            var nodesArray = ko.utils.makeArray(nodes);
	            var templateDocument = (nodesArray[0] && nodesArray[0].ownerDocument) || document;
	
	            var container = templateDocument.createElement('div');
	            for (var i = 0, j = nodesArray.length; i < j; i++) {
	                container.appendChild(ko.cleanNode(nodesArray[i]));
	            }
	            return container;
	        },
	
	        cloneNodes: function (nodesArray, shouldCleanNodes) {
	            for (var i = 0, j = nodesArray.length, newNodesArray = []; i < j; i++) {
	                var clonedNode = nodesArray[i].cloneNode(true);
	                newNodesArray.push(shouldCleanNodes ? ko.cleanNode(clonedNode) : clonedNode);
	            }
	            return newNodesArray;
	        },
	
	        setDomNodeChildren: function (domNode, childNodes) {
	            ko.utils.emptyDomNode(domNode);
	            if (childNodes) {
	                for (var i = 0, j = childNodes.length; i < j; i++)
	                    domNode.appendChild(childNodes[i]);
	            }
	        },
	
	        replaceDomNodes: function (nodeToReplaceOrNodeArray, newNodesArray) {
	            var nodesToReplaceArray = nodeToReplaceOrNodeArray.nodeType ? [nodeToReplaceOrNodeArray] : nodeToReplaceOrNodeArray;
	            if (nodesToReplaceArray.length > 0) {
	                var insertionPoint = nodesToReplaceArray[0];
	                var parent = insertionPoint.parentNode;
	                for (var i = 0, j = newNodesArray.length; i < j; i++)
	                    parent.insertBefore(newNodesArray[i], insertionPoint);
	                for (var i = 0, j = nodesToReplaceArray.length; i < j; i++) {
	                    ko.removeNode(nodesToReplaceArray[i]);
	                }
	            }
	        },
	
	        fixUpContinuousNodeArray: function(continuousNodeArray, parentNode) {
	            // Before acting on a set of nodes that were previously outputted by a template function, we have to reconcile
	            // them against what is in the DOM right now. It may be that some of the nodes have already been removed, or that
	            // new nodes might have been inserted in the middle, for example by a binding. Also, there may previously have been
	            // leading comment nodes (created by rewritten string-based templates) that have since been removed during binding.
	            // So, this function translates the old "map" output array into its best guess of the set of current DOM nodes.
	            //
	            // Rules:
	            //   [A] Any leading nodes that have been removed should be ignored
	            //       These most likely correspond to memoization nodes that were already removed during binding
	            //       See https://github.com/knockout/knockout/pull/440
	            //   [B] Any trailing nodes that have been remove should be ignored
	            //       This prevents the code here from adding unrelated nodes to the array while processing rule [C]
	            //       See https://github.com/knockout/knockout/pull/1903
	            //   [C] We want to output a continuous series of nodes. So, ignore any nodes that have already been removed,
	            //       and include any nodes that have been inserted among the previous collection
	
	            if (continuousNodeArray.length) {
	                // The parent node can be a virtual element; so get the real parent node
	                parentNode = (parentNode.nodeType === 8 && parentNode.parentNode) || parentNode;
	
	                // Rule [A]
	                while (continuousNodeArray.length && continuousNodeArray[0].parentNode !== parentNode)
	                    continuousNodeArray.splice(0, 1);
	
	                // Rule [B]
	                while (continuousNodeArray.length > 1 && continuousNodeArray[continuousNodeArray.length - 1].parentNode !== parentNode)
	                    continuousNodeArray.length--;
	
	                // Rule [C]
	                if (continuousNodeArray.length > 1) {
	                    var current = continuousNodeArray[0], last = continuousNodeArray[continuousNodeArray.length - 1];
	                    // Replace with the actual new continuous node set
	                    continuousNodeArray.length = 0;
	                    while (current !== last) {
	                        continuousNodeArray.push(current);
	                        current = current.nextSibling;
	                    }
	                    continuousNodeArray.push(last);
	                }
	            }
	            return continuousNodeArray;
	        },
	
	        setOptionNodeSelectionState: function (optionNode, isSelected) {
	            // IE6 sometimes throws "unknown error" if you try to write to .selected directly, whereas Firefox struggles with setAttribute. Pick one based on browser.
	            if (ieVersion < 7)
	                optionNode.setAttribute("selected", isSelected);
	            else
	                optionNode.selected = isSelected;
	        },
	
	        stringTrim: function (string) {
	            return string === null || string === undefined ? '' :
	                string.trim ?
	                    string.trim() :
	                    string.toString().replace(/^[\s\xa0]+|[\s\xa0]+$/g, '');
	        },
	
	        stringStartsWith: function (string, startsWith) {
	            string = string || "";
	            if (startsWith.length > string.length)
	                return false;
	            return string.substring(0, startsWith.length) === startsWith;
	        },
	
	        domNodeIsContainedBy: function (node, containedByNode) {
	            if (node === containedByNode)
	                return true;
	            if (node.nodeType === 11)
	                return false; // Fixes issue #1162 - can't use node.contains for document fragments on IE8
	            if (containedByNode.contains)
	                return containedByNode.contains(node.nodeType === 3 ? node.parentNode : node);
	            if (containedByNode.compareDocumentPosition)
	                return (containedByNode.compareDocumentPosition(node) & 16) == 16;
	            while (node && node != containedByNode) {
	                node = node.parentNode;
	            }
	            return !!node;
	        },
	
	        domNodeIsAttachedToDocument: function (node) {
	            return ko.utils.domNodeIsContainedBy(node, node.ownerDocument.documentElement);
	        },
	
	        anyDomNodeIsAttachedToDocument: function(nodes) {
	            return !!ko.utils.arrayFirst(nodes, ko.utils.domNodeIsAttachedToDocument);
	        },
	
	        tagNameLower: function(element) {
	            // For HTML elements, tagName will always be upper case; for XHTML elements, it'll be lower case.
	            // Possible future optimization: If we know it's an element from an XHTML document (not HTML),
	            // we don't need to do the .toLowerCase() as it will always be lower case anyway.
	            return element && element.tagName && element.tagName.toLowerCase();
	        },
	
	        catchFunctionErrors: function (delegate) {
	            return ko['onError'] ? function () {
	                try {
	                    return delegate.apply(this, arguments);
	                } catch (e) {
	                    ko['onError'] && ko['onError'](e);
	                    throw e;
	                }
	            } : delegate;
	        },
	
	        setTimeout: function (handler, timeout) {
	            return setTimeout(ko.utils.catchFunctionErrors(handler), timeout);
	        },
	
	        deferError: function (error) {
	            setTimeout(function () {
	                ko['onError'] && ko['onError'](error);
	                throw error;
	            }, 0);
	        },
	
	        registerEventHandler: function (element, eventType, handler) {
	            var wrappedHandler = ko.utils.catchFunctionErrors(handler);
	
	            var mustUseAttachEvent = ieVersion && eventsThatMustBeRegisteredUsingAttachEvent[eventType];
	            if (!ko.options['useOnlyNativeEvents'] && !mustUseAttachEvent && jQueryInstance) {
	                jQueryInstance(element)['bind'](eventType, wrappedHandler);
	            } else if (!mustUseAttachEvent && typeof element.addEventListener == "function")
	                element.addEventListener(eventType, wrappedHandler, false);
	            else if (typeof element.attachEvent != "undefined") {
	                var attachEventHandler = function (event) { wrappedHandler.call(element, event); },
	                    attachEventName = "on" + eventType;
	                element.attachEvent(attachEventName, attachEventHandler);
	
	                // IE does not dispose attachEvent handlers automatically (unlike with addEventListener)
	                // so to avoid leaks, we have to remove them manually. See bug #856
	                ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
	                    element.detachEvent(attachEventName, attachEventHandler);
	                });
	            } else
	                throw new Error("Browser doesn't support addEventListener or attachEvent");
	        },
	
	        triggerEvent: function (element, eventType) {
	            if (!(element && element.nodeType))
	                throw new Error("element must be a DOM node when calling triggerEvent");
	
	            // For click events on checkboxes and radio buttons, jQuery toggles the element checked state *after* the
	            // event handler runs instead of *before*. (This was fixed in 1.9 for checkboxes but not for radio buttons.)
	            // IE doesn't change the checked state when you trigger the click event using "fireEvent".
	            // In both cases, we'll use the click method instead.
	            var useClickWorkaround = isClickOnCheckableElement(element, eventType);
	
	            if (!ko.options['useOnlyNativeEvents'] && jQueryInstance && !useClickWorkaround) {
	                jQueryInstance(element)['trigger'](eventType);
	            } else if (typeof document.createEvent == "function") {
	                if (typeof element.dispatchEvent == "function") {
	                    var eventCategory = knownEventTypesByEventName[eventType] || "HTMLEvents";
	                    var event = document.createEvent(eventCategory);
	                    event.initEvent(eventType, true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, element);
	                    element.dispatchEvent(event);
	                }
	                else
	                    throw new Error("The supplied element doesn't support dispatchEvent");
	            } else if (useClickWorkaround && element.click) {
	                element.click();
	            } else if (typeof element.fireEvent != "undefined") {
	                element.fireEvent("on" + eventType);
	            } else {
	                throw new Error("Browser doesn't support triggering events");
	            }
	        },
	
	        unwrapObservable: function (value) {
	            return ko.isObservable(value) ? value() : value;
	        },
	
	        peekObservable: function (value) {
	            return ko.isObservable(value) ? value.peek() : value;
	        },
	
	        toggleDomNodeCssClass: toggleDomNodeCssClass,
	
	        setTextContent: function(element, textContent) {
	            var value = ko.utils.unwrapObservable(textContent);
	            if ((value === null) || (value === undefined))
	                value = "";
	
	            // We need there to be exactly one child: a text node.
	            // If there are no children, more than one, or if it's not a text node,
	            // we'll clear everything and create a single text node.
	            var innerTextNode = ko.virtualElements.firstChild(element);
	            if (!innerTextNode || innerTextNode.nodeType != 3 || ko.virtualElements.nextSibling(innerTextNode)) {
	                ko.virtualElements.setDomNodeChildren(element, [element.ownerDocument.createTextNode(value)]);
	            } else {
	                innerTextNode.data = value;
	            }
	
	            ko.utils.forceRefresh(element);
	        },
	
	        setElementName: function(element, name) {
	            element.name = name;
	
	            // Workaround IE 6/7 issue
	            // - https://github.com/SteveSanderson/knockout/issues/197
	            // - http://www.matts411.com/post/setting_the_name_attribute_in_ie_dom/
	            if (ieVersion <= 7) {
	                try {
	                    element.mergeAttributes(document.createElement("<input name='" + element.name + "'/>"), false);
	                }
	                catch(e) {} // For IE9 with doc mode "IE9 Standards" and browser mode "IE9 Compatibility View"
	            }
	        },
	
	        forceRefresh: function(node) {
	            // Workaround for an IE9 rendering bug - https://github.com/SteveSanderson/knockout/issues/209
	            if (ieVersion >= 9) {
	                // For text nodes and comment nodes (most likely virtual elements), we will have to refresh the container
	                var elem = node.nodeType == 1 ? node : node.parentNode;
	                if (elem.style)
	                    elem.style.zoom = elem.style.zoom;
	            }
	        },
	
	        ensureSelectElementIsRenderedCorrectly: function(selectElement) {
	            // Workaround for IE9 rendering bug - it doesn't reliably display all the text in dynamically-added select boxes unless you force it to re-render by updating the width.
	            // (See https://github.com/SteveSanderson/knockout/issues/312, http://stackoverflow.com/questions/5908494/select-only-shows-first-char-of-selected-option)
	            // Also fixes IE7 and IE8 bug that causes selects to be zero width if enclosed by 'if' or 'with'. (See issue #839)
	            if (ieVersion) {
	                var originalWidth = selectElement.style.width;
	                selectElement.style.width = 0;
	                selectElement.style.width = originalWidth;
	            }
	        },
	
	        range: function (min, max) {
	            min = ko.utils.unwrapObservable(min);
	            max = ko.utils.unwrapObservable(max);
	            var result = [];
	            for (var i = min; i <= max; i++)
	                result.push(i);
	            return result;
	        },
	
	        makeArray: function(arrayLikeObject) {
	            var result = [];
	            for (var i = 0, j = arrayLikeObject.length; i < j; i++) {
	                result.push(arrayLikeObject[i]);
	            };
	            return result;
	        },
	
	        createSymbolOrString: function(identifier) {
	            return canUseSymbols ? Symbol(identifier) : identifier;
	        },
	
	        isIe6 : isIe6,
	        isIe7 : isIe7,
	        ieVersion : ieVersion,
	
	        getFormFields: function(form, fieldName) {
	            var fields = ko.utils.makeArray(form.getElementsByTagName("input")).concat(ko.utils.makeArray(form.getElementsByTagName("textarea")));
	            var isMatchingField = (typeof fieldName == 'string')
	                ? function(field) { return field.name === fieldName }
	                : function(field) { return fieldName.test(field.name) }; // Treat fieldName as regex or object containing predicate
	            var matches = [];
	            for (var i = fields.length - 1; i >= 0; i--) {
	                if (isMatchingField(fields[i]))
	                    matches.push(fields[i]);
	            };
	            return matches;
	        },
	
	        parseJson: function (jsonString) {
	            if (typeof jsonString == "string") {
	                jsonString = ko.utils.stringTrim(jsonString);
	                if (jsonString) {
	                    if (JSON && JSON.parse) // Use native parsing where available
	                        return JSON.parse(jsonString);
	                    return (new Function("return " + jsonString))(); // Fallback on less safe parsing for older browsers
	                }
	            }
	            return null;
	        },
	
	        stringifyJson: function (data, replacer, space) {   // replacer and space are optional
	            if (!JSON || !JSON.stringify)
	                throw new Error("Cannot find JSON.stringify(). Some browsers (e.g., IE < 8) don't support it natively, but you can overcome this by adding a script reference to json2.js, downloadable from http://www.json.org/json2.js");
	            return JSON.stringify(ko.utils.unwrapObservable(data), replacer, space);
	        },
	
	        postJson: function (urlOrForm, data, options) {
	            options = options || {};
	            var params = options['params'] || {};
	            var includeFields = options['includeFields'] || this.fieldsIncludedWithJsonPost;
	            var url = urlOrForm;
	
	            // If we were given a form, use its 'action' URL and pick out any requested field values
	            if((typeof urlOrForm == 'object') && (ko.utils.tagNameLower(urlOrForm) === "form")) {
	                var originalForm = urlOrForm;
	                url = originalForm.action;
	                for (var i = includeFields.length - 1; i >= 0; i--) {
	                    var fields = ko.utils.getFormFields(originalForm, includeFields[i]);
	                    for (var j = fields.length - 1; j >= 0; j--)
	                        params[fields[j].name] = fields[j].value;
	                }
	            }
	
	            data = ko.utils.unwrapObservable(data);
	            var form = document.createElement("form");
	            form.style.display = "none";
	            form.action = url;
	            form.method = "post";
	            for (var key in data) {
	                // Since 'data' this is a model object, we include all properties including those inherited from its prototype
	                var input = document.createElement("input");
	                input.type = "hidden";
	                input.name = key;
	                input.value = ko.utils.stringifyJson(ko.utils.unwrapObservable(data[key]));
	                form.appendChild(input);
	            }
	            objectForEach(params, function(key, value) {
	                var input = document.createElement("input");
	                input.type = "hidden";
	                input.name = key;
	                input.value = value;
	                form.appendChild(input);
	            });
	            document.body.appendChild(form);
	            options['submitter'] ? options['submitter'](form) : form.submit();
	            setTimeout(function () { form.parentNode.removeChild(form); }, 0);
	        }
	    }
	}());
	
	ko.exportSymbol('utils', ko.utils);
	ko.exportSymbol('utils.arrayForEach', ko.utils.arrayForEach);
	ko.exportSymbol('utils.arrayFirst', ko.utils.arrayFirst);
	ko.exportSymbol('utils.arrayFilter', ko.utils.arrayFilter);
	ko.exportSymbol('utils.arrayGetDistinctValues', ko.utils.arrayGetDistinctValues);
	ko.exportSymbol('utils.arrayIndexOf', ko.utils.arrayIndexOf);
	ko.exportSymbol('utils.arrayMap', ko.utils.arrayMap);
	ko.exportSymbol('utils.arrayPushAll', ko.utils.arrayPushAll);
	ko.exportSymbol('utils.arrayRemoveItem', ko.utils.arrayRemoveItem);
	ko.exportSymbol('utils.extend', ko.utils.extend);
	ko.exportSymbol('utils.fieldsIncludedWithJsonPost', ko.utils.fieldsIncludedWithJsonPost);
	ko.exportSymbol('utils.getFormFields', ko.utils.getFormFields);
	ko.exportSymbol('utils.peekObservable', ko.utils.peekObservable);
	ko.exportSymbol('utils.postJson', ko.utils.postJson);
	ko.exportSymbol('utils.parseJson', ko.utils.parseJson);
	ko.exportSymbol('utils.registerEventHandler', ko.utils.registerEventHandler);
	ko.exportSymbol('utils.stringifyJson', ko.utils.stringifyJson);
	ko.exportSymbol('utils.range', ko.utils.range);
	ko.exportSymbol('utils.toggleDomNodeCssClass', ko.utils.toggleDomNodeCssClass);
	ko.exportSymbol('utils.triggerEvent', ko.utils.triggerEvent);
	ko.exportSymbol('utils.unwrapObservable', ko.utils.unwrapObservable);
	ko.exportSymbol('utils.objectForEach', ko.utils.objectForEach);
	ko.exportSymbol('utils.addOrRemoveItem', ko.utils.addOrRemoveItem);
	ko.exportSymbol('utils.setTextContent', ko.utils.setTextContent);
	ko.exportSymbol('unwrap', ko.utils.unwrapObservable); // Convenient shorthand, because this is used so commonly
	
	if (!Function.prototype['bind']) {
	    // Function.prototype.bind is a standard part of ECMAScript 5th Edition (December 2009, http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf)
	    // In case the browser doesn't implement it natively, provide a JavaScript implementation. This implementation is based on the one in prototype.js
	    Function.prototype['bind'] = function (object) {
	        var originalFunction = this;
	        if (arguments.length === 1) {
	            return function () {
	                return originalFunction.apply(object, arguments);
	            };
	        } else {
	            var partialArgs = Array.prototype.slice.call(arguments, 1);
	            return function () {
	                var args = partialArgs.slice(0);
	                args.push.apply(args, arguments);
	                return originalFunction.apply(object, args);
	            };
	        }
	    };
	}
	
	ko.utils.domData = new (function () {
	    var uniqueId = 0;
	    var dataStoreKeyExpandoPropertyName = "__ko__" + (new Date).getTime();
	    var dataStore = {};
	
	    function getAll(node, createIfNotFound) {
	        var dataStoreKey = node[dataStoreKeyExpandoPropertyName];
	        var hasExistingDataStore = dataStoreKey && (dataStoreKey !== "null") && dataStore[dataStoreKey];
	        if (!hasExistingDataStore) {
	            if (!createIfNotFound)
	                return undefined;
	            dataStoreKey = node[dataStoreKeyExpandoPropertyName] = "ko" + uniqueId++;
	            dataStore[dataStoreKey] = {};
	        }
	        return dataStore[dataStoreKey];
	    }
	
	    return {
	        get: function (node, key) {
	            var allDataForNode = getAll(node, false);
	            return allDataForNode === undefined ? undefined : allDataForNode[key];
	        },
	        set: function (node, key, value) {
	            if (value === undefined) {
	                // Make sure we don't actually create a new domData key if we are actually deleting a value
	                if (getAll(node, false) === undefined)
	                    return;
	            }
	            var allDataForNode = getAll(node, true);
	            allDataForNode[key] = value;
	        },
	        clear: function (node) {
	            var dataStoreKey = node[dataStoreKeyExpandoPropertyName];
	            if (dataStoreKey) {
	                delete dataStore[dataStoreKey];
	                node[dataStoreKeyExpandoPropertyName] = null;
	                return true; // Exposing "did clean" flag purely so specs can infer whether things have been cleaned up as intended
	            }
	            return false;
	        },
	
	        nextKey: function () {
	            return (uniqueId++) + dataStoreKeyExpandoPropertyName;
	        }
	    };
	})();
	
	ko.exportSymbol('utils.domData', ko.utils.domData);
	ko.exportSymbol('utils.domData.clear', ko.utils.domData.clear); // Exporting only so specs can clear up after themselves fully
	
	ko.utils.domNodeDisposal = new (function () {
	    var domDataKey = ko.utils.domData.nextKey();
	    var cleanableNodeTypes = { 1: true, 8: true, 9: true };       // Element, Comment, Document
	    var cleanableNodeTypesWithDescendants = { 1: true, 9: true }; // Element, Document
	
	    function getDisposeCallbacksCollection(node, createIfNotFound) {
	        var allDisposeCallbacks = ko.utils.domData.get(node, domDataKey);
	        if ((allDisposeCallbacks === undefined) && createIfNotFound) {
	            allDisposeCallbacks = [];
	            ko.utils.domData.set(node, domDataKey, allDisposeCallbacks);
	        }
	        return allDisposeCallbacks;
	    }
	    function destroyCallbacksCollection(node) {
	        ko.utils.domData.set(node, domDataKey, undefined);
	    }
	
	    function cleanSingleNode(node) {
	        // Run all the dispose callbacks
	        var callbacks = getDisposeCallbacksCollection(node, false);
	        if (callbacks) {
	            callbacks = callbacks.slice(0); // Clone, as the array may be modified during iteration (typically, callbacks will remove themselves)
	            for (var i = 0; i < callbacks.length; i++)
	                callbacks[i](node);
	        }
	
	        // Erase the DOM data
	        ko.utils.domData.clear(node);
	
	        // Perform cleanup needed by external libraries (currently only jQuery, but can be extended)
	        ko.utils.domNodeDisposal["cleanExternalData"](node);
	
	        // Clear any immediate-child comment nodes, as these wouldn't have been found by
	        // node.getElementsByTagName("*") in cleanNode() (comment nodes aren't elements)
	        if (cleanableNodeTypesWithDescendants[node.nodeType])
	            cleanImmediateCommentTypeChildren(node);
	    }
	
	    function cleanImmediateCommentTypeChildren(nodeWithChildren) {
	        var child, nextChild = nodeWithChildren.firstChild;
	        while (child = nextChild) {
	            nextChild = child.nextSibling;
	            if (child.nodeType === 8)
	                cleanSingleNode(child);
	        }
	    }
	
	    return {
	        addDisposeCallback : function(node, callback) {
	            if (typeof callback != "function")
	                throw new Error("Callback must be a function");
	            getDisposeCallbacksCollection(node, true).push(callback);
	        },
	
	        removeDisposeCallback : function(node, callback) {
	            var callbacksCollection = getDisposeCallbacksCollection(node, false);
	            if (callbacksCollection) {
	                ko.utils.arrayRemoveItem(callbacksCollection, callback);
	                if (callbacksCollection.length == 0)
	                    destroyCallbacksCollection(node);
	            }
	        },
	
	        cleanNode : function(node) {
	            // First clean this node, where applicable
	            if (cleanableNodeTypes[node.nodeType]) {
	                cleanSingleNode(node);
	
	                // ... then its descendants, where applicable
	                if (cleanableNodeTypesWithDescendants[node.nodeType]) {
	                    // Clone the descendants list in case it changes during iteration
	                    var descendants = [];
	                    ko.utils.arrayPushAll(descendants, node.getElementsByTagName("*"));
	                    for (var i = 0, j = descendants.length; i < j; i++)
	                        cleanSingleNode(descendants[i]);
	                }
	            }
	            return node;
	        },
	
	        removeNode : function(node) {
	            ko.cleanNode(node);
	            if (node.parentNode)
	                node.parentNode.removeChild(node);
	        },
	
	        "cleanExternalData" : function (node) {
	            // Special support for jQuery here because it's so commonly used.
	            // Many jQuery plugins (including jquery.tmpl) store data using jQuery's equivalent of domData
	            // so notify it to tear down any resources associated with the node & descendants here.
	            if (jQueryInstance && (typeof jQueryInstance['cleanData'] == "function"))
	                jQueryInstance['cleanData']([node]);
	        }
	    };
	})();
	ko.cleanNode = ko.utils.domNodeDisposal.cleanNode; // Shorthand name for convenience
	ko.removeNode = ko.utils.domNodeDisposal.removeNode; // Shorthand name for convenience
	ko.exportSymbol('cleanNode', ko.cleanNode);
	ko.exportSymbol('removeNode', ko.removeNode);
	ko.exportSymbol('utils.domNodeDisposal', ko.utils.domNodeDisposal);
	ko.exportSymbol('utils.domNodeDisposal.addDisposeCallback', ko.utils.domNodeDisposal.addDisposeCallback);
	ko.exportSymbol('utils.domNodeDisposal.removeDisposeCallback', ko.utils.domNodeDisposal.removeDisposeCallback);
	(function () {
	    var none = [0, "", ""],
	        table = [1, "<table>", "</table>"],
	        tbody = [2, "<table><tbody>", "</tbody></table>"],
	        tr = [3, "<table><tbody><tr>", "</tr></tbody></table>"],
	        select = [1, "<select multiple='multiple'>", "</select>"],
	        lookup = {
	            'thead': table,
	            'tbody': table,
	            'tfoot': table,
	            'tr': tbody,
	            'td': tr,
	            'th': tr,
	            'option': select,
	            'optgroup': select
	        },
	
	        // This is needed for old IE if you're *not* using either jQuery or innerShiv. Doesn't affect other cases.
	        mayRequireCreateElementHack = ko.utils.ieVersion <= 8;
	
	    function getWrap(tags) {
	        var m = tags.match(/^<([a-z]+)[ >]/);
	        return (m && lookup[m[1]]) || none;
	    }
	
	    function simpleHtmlParse(html, documentContext) {
	        documentContext || (documentContext = document);
	        var windowContext = documentContext['parentWindow'] || documentContext['defaultView'] || window;
	
	        // Based on jQuery's "clean" function, but only accounting for table-related elements.
	        // If you have referenced jQuery, this won't be used anyway - KO will use jQuery's "clean" function directly
	
	        // Note that there's still an issue in IE < 9 whereby it will discard comment nodes that are the first child of
	        // a descendant node. For example: "<div><!-- mycomment -->abc</div>" will get parsed as "<div>abc</div>"
	        // This won't affect anyone who has referenced jQuery, and there's always the workaround of inserting a dummy node
	        // (possibly a text node) in front of the comment. So, KO does not attempt to workaround this IE issue automatically at present.
	
	        // Trim whitespace, otherwise indexOf won't work as expected
	        var tags = ko.utils.stringTrim(html).toLowerCase(), div = documentContext.createElement("div"),
	            wrap = getWrap(tags),
	            depth = wrap[0];
	
	        // Go to html and back, then peel off extra wrappers
	        // Note that we always prefix with some dummy text, because otherwise, IE<9 will strip out leading comment nodes in descendants. Total madness.
	        var markup = "ignored<div>" + wrap[1] + html + wrap[2] + "</div>";
	        if (typeof windowContext['innerShiv'] == "function") {
	            // Note that innerShiv is deprecated in favour of html5shiv. We should consider adding
	            // support for html5shiv (except if no explicit support is needed, e.g., if html5shiv
	            // somehow shims the native APIs so it just works anyway)
	            div.appendChild(windowContext['innerShiv'](markup));
	        } else {
	            if (mayRequireCreateElementHack) {
	                // The document.createElement('my-element') trick to enable custom elements in IE6-8
	                // only works if we assign innerHTML on an element associated with that document.
	                documentContext.appendChild(div);
	            }
	
	            div.innerHTML = markup;
	
	            if (mayRequireCreateElementHack) {
	                div.parentNode.removeChild(div);
	            }
	        }
	
	        // Move to the right depth
	        while (depth--)
	            div = div.lastChild;
	
	        return ko.utils.makeArray(div.lastChild.childNodes);
	    }
	
	    function jQueryHtmlParse(html, documentContext) {
	        // jQuery's "parseHTML" function was introduced in jQuery 1.8.0 and is a documented public API.
	        if (jQueryInstance['parseHTML']) {
	            return jQueryInstance['parseHTML'](html, documentContext) || []; // Ensure we always return an array and never null
	        } else {
	            // For jQuery < 1.8.0, we fall back on the undocumented internal "clean" function.
	            var elems = jQueryInstance['clean']([html], documentContext);
	
	            // As of jQuery 1.7.1, jQuery parses the HTML by appending it to some dummy parent nodes held in an in-memory document fragment.
	            // Unfortunately, it never clears the dummy parent nodes from the document fragment, so it leaks memory over time.
	            // Fix this by finding the top-most dummy parent element, and detaching it from its owner fragment.
	            if (elems && elems[0]) {
	                // Find the top-most parent element that's a direct child of a document fragment
	                var elem = elems[0];
	                while (elem.parentNode && elem.parentNode.nodeType !== 11 /* i.e., DocumentFragment */)
	                    elem = elem.parentNode;
	                // ... then detach it
	                if (elem.parentNode)
	                    elem.parentNode.removeChild(elem);
	            }
	
	            return elems;
	        }
	    }
	
	    ko.utils.parseHtmlFragment = function(html, documentContext) {
	        return jQueryInstance ?
	            jQueryHtmlParse(html, documentContext) :   // As below, benefit from jQuery's optimisations where possible
	            simpleHtmlParse(html, documentContext);  // ... otherwise, this simple logic will do in most common cases.
	    };
	
	    ko.utils.setHtml = function(node, html) {
	        ko.utils.emptyDomNode(node);
	
	        // There's no legitimate reason to display a stringified observable without unwrapping it, so we'll unwrap it
	        html = ko.utils.unwrapObservable(html);
	
	        if ((html !== null) && (html !== undefined)) {
	            if (typeof html != 'string')
	                html = html.toString();
	
	            // jQuery contains a lot of sophisticated code to parse arbitrary HTML fragments,
	            // for example <tr> elements which are not normally allowed to exist on their own.
	            // If you've referenced jQuery we'll use that rather than duplicating its code.
	            if (jQueryInstance) {
	                jQueryInstance(node)['html'](html);
	            } else {
	                // ... otherwise, use KO's own parsing logic.
	                var parsedNodes = ko.utils.parseHtmlFragment(html, node.ownerDocument);
	                for (var i = 0; i < parsedNodes.length; i++)
	                    node.appendChild(parsedNodes[i]);
	            }
	        }
	    };
	})();
	
	ko.exportSymbol('utils.parseHtmlFragment', ko.utils.parseHtmlFragment);
	ko.exportSymbol('utils.setHtml', ko.utils.setHtml);
	
	ko.memoization = (function () {
	    var memos = {};
	
	    function randomMax8HexChars() {
	        return (((1 + Math.random()) * 0x100000000) | 0).toString(16).substring(1);
	    }
	    function generateRandomId() {
	        return randomMax8HexChars() + randomMax8HexChars();
	    }
	    function findMemoNodes(rootNode, appendToArray) {
	        if (!rootNode)
	            return;
	        if (rootNode.nodeType == 8) {
	            var memoId = ko.memoization.parseMemoText(rootNode.nodeValue);
	            if (memoId != null)
	                appendToArray.push({ domNode: rootNode, memoId: memoId });
	        } else if (rootNode.nodeType == 1) {
	            for (var i = 0, childNodes = rootNode.childNodes, j = childNodes.length; i < j; i++)
	                findMemoNodes(childNodes[i], appendToArray);
	        }
	    }
	
	    return {
	        memoize: function (callback) {
	            if (typeof callback != "function")
	                throw new Error("You can only pass a function to ko.memoization.memoize()");
	            var memoId = generateRandomId();
	            memos[memoId] = callback;
	            return "<!--[ko_memo:" + memoId + "]-->";
	        },
	
	        unmemoize: function (memoId, callbackParams) {
	            var callback = memos[memoId];
	            if (callback === undefined)
	                throw new Error("Couldn't find any memo with ID " + memoId + ". Perhaps it's already been unmemoized.");
	            try {
	                callback.apply(null, callbackParams || []);
	                return true;
	            }
	            finally { delete memos[memoId]; }
	        },
	
	        unmemoizeDomNodeAndDescendants: function (domNode, extraCallbackParamsArray) {
	            var memos = [];
	            findMemoNodes(domNode, memos);
	            for (var i = 0, j = memos.length; i < j; i++) {
	                var node = memos[i].domNode;
	                var combinedParams = [node];
	                if (extraCallbackParamsArray)
	                    ko.utils.arrayPushAll(combinedParams, extraCallbackParamsArray);
	                ko.memoization.unmemoize(memos[i].memoId, combinedParams);
	                node.nodeValue = ""; // Neuter this node so we don't try to unmemoize it again
	                if (node.parentNode)
	                    node.parentNode.removeChild(node); // If possible, erase it totally (not always possible - someone else might just hold a reference to it then call unmemoizeDomNodeAndDescendants again)
	            }
	        },
	
	        parseMemoText: function (memoText) {
	            var match = memoText.match(/^\[ko_memo\:(.*?)\]$/);
	            return match ? match[1] : null;
	        }
	    };
	})();
	
	ko.exportSymbol('memoization', ko.memoization);
	ko.exportSymbol('memoization.memoize', ko.memoization.memoize);
	ko.exportSymbol('memoization.unmemoize', ko.memoization.unmemoize);
	ko.exportSymbol('memoization.parseMemoText', ko.memoization.parseMemoText);
	ko.exportSymbol('memoization.unmemoizeDomNodeAndDescendants', ko.memoization.unmemoizeDomNodeAndDescendants);
	ko.tasks = (function () {
	    var scheduler,
	        taskQueue = [],
	        taskQueueLength = 0,
	        nextHandle = 1,
	        nextIndexToProcess = 0;
	
	    if (window['MutationObserver']) {
	        // Chrome 27+, Firefox 14+, IE 11+, Opera 15+, Safari 6.1+
	        // From https://github.com/petkaantonov/bluebird * Copyright (c) 2014 Petka Antonov * License: MIT
	        scheduler = (function (callback) {
	            var div = document.createElement("div");
	            new MutationObserver(callback).observe(div, {attributes: true});
	            return function () { div.classList.toggle("foo"); };
	        })(scheduledProcess);
	    } else if (document && "onreadystatechange" in document.createElement("script")) {
	        // IE 6-10
	        // From https://github.com/YuzuJS/setImmediate * Copyright (c) 2012 Barnesandnoble.com, llc, Donavon West, and Domenic Denicola * License: MIT
	        scheduler = function (callback) {
	            var script = document.createElement("script");
	            script.onreadystatechange = function () {
	                script.onreadystatechange = null;
	                document.documentElement.removeChild(script);
	                script = null;
	                callback();
	            };
	            document.documentElement.appendChild(script);
	        };
	    } else {
	        scheduler = function (callback) {
	            setTimeout(callback, 0);
	        };
	    }
	
	    function processTasks() {
	        if (taskQueueLength) {
	            // Each mark represents the end of a logical group of tasks and the number of these groups is
	            // limited to prevent unchecked recursion.
	            var mark = taskQueueLength, countMarks = 0;
	
	            // nextIndexToProcess keeps track of where we are in the queue; processTasks can be called recursively without issue
	            for (var task; nextIndexToProcess < taskQueueLength; ) {
	                if (task = taskQueue[nextIndexToProcess++]) {
	                    if (nextIndexToProcess > mark) {
	                        if (++countMarks >= 5000) {
	                            nextIndexToProcess = taskQueueLength;   // skip all tasks remaining in the queue since any of them could be causing the recursion
	                            ko.utils.deferError(Error("'Too much recursion' after processing " + countMarks + " task groups."));
	                            break;
	                        }
	                        mark = taskQueueLength;
	                    }
	                    try {
	                        task();
	                    } catch (ex) {
	                        ko.utils.deferError(ex);
	                    }
	                }
	            }
	        }
	    }
	
	    function scheduledProcess() {
	        processTasks();
	
	        // Reset the queue
	        nextIndexToProcess = taskQueueLength = taskQueue.length = 0;
	    }
	
	    function scheduleTaskProcessing() {
	        ko.tasks['scheduler'](scheduledProcess);
	    }
	
	    var tasks = {
	        'scheduler': scheduler,     // Allow overriding the scheduler
	
	        schedule: function (func) {
	            if (!taskQueueLength) {
	                scheduleTaskProcessing();
	            }
	
	            taskQueue[taskQueueLength++] = func;
	            return nextHandle++;
	        },
	
	        cancel: function (handle) {
	            var index = handle - (nextHandle - taskQueueLength);
	            if (index >= nextIndexToProcess && index < taskQueueLength) {
	                taskQueue[index] = null;
	            }
	        },
	
	        // For testing only: reset the queue and return the previous queue length
	        'resetForTesting': function () {
	            var length = taskQueueLength - nextIndexToProcess;
	            nextIndexToProcess = taskQueueLength = taskQueue.length = 0;
	            return length;
	        },
	
	        runEarly: processTasks
	    };
	
	    return tasks;
	})();
	
	ko.exportSymbol('tasks', ko.tasks);
	ko.exportSymbol('tasks.schedule', ko.tasks.schedule);
	//ko.exportSymbol('tasks.cancel', ko.tasks.cancel);  "cancel" isn't minified
	ko.exportSymbol('tasks.runEarly', ko.tasks.runEarly);
	ko.extenders = {
	    'throttle': function(target, timeout) {
	        // Throttling means two things:
	
	        // (1) For dependent observables, we throttle *evaluations* so that, no matter how fast its dependencies
	        //     notify updates, the target doesn't re-evaluate (and hence doesn't notify) faster than a certain rate
	        target['throttleEvaluation'] = timeout;
	
	        // (2) For writable targets (observables, or writable dependent observables), we throttle *writes*
	        //     so the target cannot change value synchronously or faster than a certain rate
	        var writeTimeoutInstance = null;
	        return ko.dependentObservable({
	            'read': target,
	            'write': function(value) {
	                clearTimeout(writeTimeoutInstance);
	                writeTimeoutInstance = ko.utils.setTimeout(function() {
	                    target(value);
	                }, timeout);
	            }
	        });
	    },
	
	    'rateLimit': function(target, options) {
	        var timeout, method, limitFunction;
	
	        if (typeof options == 'number') {
	            timeout = options;
	        } else {
	            timeout = options['timeout'];
	            method = options['method'];
	        }
	
	        // rateLimit supersedes deferred updates
	        target._deferUpdates = false;
	
	        limitFunction = method == 'notifyWhenChangesStop' ?  debounce : throttle;
	        target.limit(function(callback) {
	            return limitFunction(callback, timeout);
	        });
	    },
	
	    'deferred': function(target, options) {
	        if (options !== true) {
	            throw new Error('The \'deferred\' extender only accepts the value \'true\', because it is not supported to turn deferral off once enabled.')
	        }
	
	        if (!target._deferUpdates) {
	            target._deferUpdates = true;
	            target.limit(function (callback) {
	                var handle;
	                return function () {
	                    ko.tasks.cancel(handle);
	                    handle = ko.tasks.schedule(callback);
	                    target['notifySubscribers'](undefined, 'dirty');
	                };
	            });
	        }
	    },
	
	    'notify': function(target, notifyWhen) {
	        target["equalityComparer"] = notifyWhen == "always" ?
	            null :  // null equalityComparer means to always notify
	            valuesArePrimitiveAndEqual;
	    }
	};
	
	var primitiveTypes = { 'undefined':1, 'boolean':1, 'number':1, 'string':1 };
	function valuesArePrimitiveAndEqual(a, b) {
	    var oldValueIsPrimitive = (a === null) || (typeof(a) in primitiveTypes);
	    return oldValueIsPrimitive ? (a === b) : false;
	}
	
	function throttle(callback, timeout) {
	    var timeoutInstance;
	    return function () {
	        if (!timeoutInstance) {
	            timeoutInstance = ko.utils.setTimeout(function () {
	                timeoutInstance = undefined;
	                callback();
	            }, timeout);
	        }
	    };
	}
	
	function debounce(callback, timeout) {
	    var timeoutInstance;
	    return function () {
	        clearTimeout(timeoutInstance);
	        timeoutInstance = ko.utils.setTimeout(callback, timeout);
	    };
	}
	
	function applyExtenders(requestedExtenders) {
	    var target = this;
	    if (requestedExtenders) {
	        ko.utils.objectForEach(requestedExtenders, function(key, value) {
	            var extenderHandler = ko.extenders[key];
	            if (typeof extenderHandler == 'function') {
	                target = extenderHandler(target, value) || target;
	            }
	        });
	    }
	    return target;
	}
	
	ko.exportSymbol('extenders', ko.extenders);
	
	ko.subscription = function (target, callback, disposeCallback) {
	    this._target = target;
	    this.callback = callback;
	    this.disposeCallback = disposeCallback;
	    this.isDisposed = false;
	    ko.exportProperty(this, 'dispose', this.dispose);
	};
	ko.subscription.prototype.dispose = function () {
	    this.isDisposed = true;
	    this.disposeCallback();
	};
	
	ko.subscribable = function () {
	    ko.utils.setPrototypeOfOrExtend(this, ko_subscribable_fn);
	    ko_subscribable_fn.init(this);
	}
	
	var defaultEvent = "change";
	
	// Moved out of "limit" to avoid the extra closure
	function limitNotifySubscribers(value, event) {
	    if (!event || event === defaultEvent) {
	        this._limitChange(value);
	    } else if (event === 'beforeChange') {
	        this._limitBeforeChange(value);
	    } else {
	        this._origNotifySubscribers(value, event);
	    }
	}
	
	var ko_subscribable_fn = {
	    init: function(instance) {
	        instance._subscriptions = {};
	        instance._versionNumber = 1;
	    },
	
	    subscribe: function (callback, callbackTarget, event) {
	        var self = this;
	
	        event = event || defaultEvent;
	        var boundCallback = callbackTarget ? callback.bind(callbackTarget) : callback;
	
	        var subscription = new ko.subscription(self, boundCallback, function () {
	            ko.utils.arrayRemoveItem(self._subscriptions[event], subscription);
	            if (self.afterSubscriptionRemove)
	                self.afterSubscriptionRemove(event);
	        });
	
	        if (self.beforeSubscriptionAdd)
	            self.beforeSubscriptionAdd(event);
	
	        if (!self._subscriptions[event])
	            self._subscriptions[event] = [];
	        self._subscriptions[event].push(subscription);
	
	        return subscription;
	    },
	
	    "notifySubscribers": function (valueToNotify, event) {
	        event = event || defaultEvent;
	        if (event === defaultEvent) {
	            this.updateVersion();
	        }
	        if (this.hasSubscriptionsForEvent(event)) {
	            try {
	                ko.dependencyDetection.begin(); // Begin suppressing dependency detection (by setting the top frame to undefined)
	                for (var a = this._subscriptions[event].slice(0), i = 0, subscription; subscription = a[i]; ++i) {
	                    // In case a subscription was disposed during the arrayForEach cycle, check
	                    // for isDisposed on each subscription before invoking its callback
	                    if (!subscription.isDisposed)
	                        subscription.callback(valueToNotify);
	                }
	            } finally {
	                ko.dependencyDetection.end(); // End suppressing dependency detection
	            }
	        }
	    },
	
	    getVersion: function () {
	        return this._versionNumber;
	    },
	
	    hasChanged: function (versionToCheck) {
	        return this.getVersion() !== versionToCheck;
	    },
	
	    updateVersion: function () {
	        ++this._versionNumber;
	    },
	
	    limit: function(limitFunction) {
	        var self = this, selfIsObservable = ko.isObservable(self),
	            ignoreBeforeChange, previousValue, pendingValue, beforeChange = 'beforeChange';
	
	        if (!self._origNotifySubscribers) {
	            self._origNotifySubscribers = self["notifySubscribers"];
	            self["notifySubscribers"] = limitNotifySubscribers;
	        }
	
	        var finish = limitFunction(function() {
	            self._notificationIsPending = false;
	
	            // If an observable provided a reference to itself, access it to get the latest value.
	            // This allows computed observables to delay calculating their value until needed.
	            if (selfIsObservable && pendingValue === self) {
	                pendingValue = self();
	            }
	            ignoreBeforeChange = false;
	            if (self.isDifferent(previousValue, pendingValue)) {
	                self._origNotifySubscribers(previousValue = pendingValue);
	            }
	        });
	
	        self._limitChange = function(value) {
	            self._notificationIsPending = ignoreBeforeChange = true;
	            pendingValue = value;
	            finish();
	        };
	        self._limitBeforeChange = function(value) {
	            if (!ignoreBeforeChange) {
	                previousValue = value;
	                self._origNotifySubscribers(value, beforeChange);
	            }
	        };
	    },
	
	    hasSubscriptionsForEvent: function(event) {
	        return this._subscriptions[event] && this._subscriptions[event].length;
	    },
	
	    getSubscriptionsCount: function (event) {
	        if (event) {
	            return this._subscriptions[event] && this._subscriptions[event].length || 0;
	        } else {
	            var total = 0;
	            ko.utils.objectForEach(this._subscriptions, function(eventName, subscriptions) {
	                if (eventName !== 'dirty')
	                    total += subscriptions.length;
	            });
	            return total;
	        }
	    },
	
	    isDifferent: function(oldValue, newValue) {
	        return !this['equalityComparer'] || !this['equalityComparer'](oldValue, newValue);
	    },
	
	    extend: applyExtenders
	};
	
	ko.exportProperty(ko_subscribable_fn, 'subscribe', ko_subscribable_fn.subscribe);
	ko.exportProperty(ko_subscribable_fn, 'extend', ko_subscribable_fn.extend);
	ko.exportProperty(ko_subscribable_fn, 'getSubscriptionsCount', ko_subscribable_fn.getSubscriptionsCount);
	
	// For browsers that support proto assignment, we overwrite the prototype of each
	// observable instance. Since observables are functions, we need Function.prototype
	// to still be in the prototype chain.
	if (ko.utils.canSetPrototype) {
	    ko.utils.setPrototypeOf(ko_subscribable_fn, Function.prototype);
	}
	
	ko.subscribable['fn'] = ko_subscribable_fn;
	
	
	ko.isSubscribable = function (instance) {
	    return instance != null && typeof instance.subscribe == "function" && typeof instance["notifySubscribers"] == "function";
	};
	
	ko.exportSymbol('subscribable', ko.subscribable);
	ko.exportSymbol('isSubscribable', ko.isSubscribable);
	
	ko.computedContext = ko.dependencyDetection = (function () {
	    var outerFrames = [],
	        currentFrame,
	        lastId = 0;
	
	    // Return a unique ID that can be assigned to an observable for dependency tracking.
	    // Theoretically, you could eventually overflow the number storage size, resulting
	    // in duplicate IDs. But in JavaScript, the largest exact integral value is 2^53
	    // or 9,007,199,254,740,992. If you created 1,000,000 IDs per second, it would
	    // take over 285 years to reach that number.
	    // Reference http://blog.vjeux.com/2010/javascript/javascript-max_int-number-limits.html
	    function getId() {
	        return ++lastId;
	    }
	
	    function begin(options) {
	        outerFrames.push(currentFrame);
	        currentFrame = options;
	    }
	
	    function end() {
	        currentFrame = outerFrames.pop();
	    }
	
	    return {
	        begin: begin,
	
	        end: end,
	
	        registerDependency: function (subscribable) {
	            if (currentFrame) {
	                if (!ko.isSubscribable(subscribable))
	                    throw new Error("Only subscribable things can act as dependencies");
	                currentFrame.callback.call(currentFrame.callbackTarget, subscribable, subscribable._id || (subscribable._id = getId()));
	            }
	        },
	
	        ignore: function (callback, callbackTarget, callbackArgs) {
	            try {
	                begin();
	                return callback.apply(callbackTarget, callbackArgs || []);
	            } finally {
	                end();
	            }
	        },
	
	        getDependenciesCount: function () {
	            if (currentFrame)
	                return currentFrame.computed.getDependenciesCount();
	        },
	
	        isInitial: function() {
	            if (currentFrame)
	                return currentFrame.isInitial;
	        }
	    };
	})();
	
	ko.exportSymbol('computedContext', ko.computedContext);
	ko.exportSymbol('computedContext.getDependenciesCount', ko.computedContext.getDependenciesCount);
	ko.exportSymbol('computedContext.isInitial', ko.computedContext.isInitial);
	
	ko.exportSymbol('ignoreDependencies', ko.ignoreDependencies = ko.dependencyDetection.ignore);
	var observableLatestValue = ko.utils.createSymbolOrString('_latestValue');
	
	ko.observable = function (initialValue) {
	    function observable() {
	        if (arguments.length > 0) {
	            // Write
	
	            // Ignore writes if the value hasn't changed
	            if (observable.isDifferent(observable[observableLatestValue], arguments[0])) {
	                observable.valueWillMutate();
	                observable[observableLatestValue] = arguments[0];
	                observable.valueHasMutated();
	            }
	            return this; // Permits chained assignments
	        }
	        else {
	            // Read
	            ko.dependencyDetection.registerDependency(observable); // The caller only needs to be notified of changes if they did a "read" operation
	            return observable[observableLatestValue];
	        }
	    }
	
	    observable[observableLatestValue] = initialValue;
	
	    // Inherit from 'subscribable'
	    if (!ko.utils.canSetPrototype) {
	        // 'subscribable' won't be on the prototype chain unless we put it there directly
	        ko.utils.extend(observable, ko.subscribable['fn']);
	    }
	    ko.subscribable['fn'].init(observable);
	
	    // Inherit from 'observable'
	    ko.utils.setPrototypeOfOrExtend(observable, observableFn);
	
	    if (ko.options['deferUpdates']) {
	        ko.extenders['deferred'](observable, true);
	    }
	
	    return observable;
	}
	
	// Define prototype for observables
	var observableFn = {
	    'equalityComparer': valuesArePrimitiveAndEqual,
	    peek: function() { return this[observableLatestValue]; },
	    valueHasMutated: function () { this['notifySubscribers'](this[observableLatestValue]); },
	    valueWillMutate: function () { this['notifySubscribers'](this[observableLatestValue], 'beforeChange'); }
	};
	
	// Note that for browsers that don't support proto assignment, the
	// inheritance chain is created manually in the ko.observable constructor
	if (ko.utils.canSetPrototype) {
	    ko.utils.setPrototypeOf(observableFn, ko.subscribable['fn']);
	}
	
	var protoProperty = ko.observable.protoProperty = '__ko_proto__';
	observableFn[protoProperty] = ko.observable;
	
	ko.hasPrototype = function(instance, prototype) {
	    if ((instance === null) || (instance === undefined) || (instance[protoProperty] === undefined)) return false;
	    if (instance[protoProperty] === prototype) return true;
	    return ko.hasPrototype(instance[protoProperty], prototype); // Walk the prototype chain
	};
	
	ko.isObservable = function (instance) {
	    return ko.hasPrototype(instance, ko.observable);
	}
	ko.isWriteableObservable = function (instance) {
	    // Observable
	    if ((typeof instance == 'function') && instance[protoProperty] === ko.observable)
	        return true;
	    // Writeable dependent observable
	    if ((typeof instance == 'function') && (instance[protoProperty] === ko.dependentObservable) && (instance.hasWriteFunction))
	        return true;
	    // Anything else
	    return false;
	}
	
	ko.exportSymbol('observable', ko.observable);
	ko.exportSymbol('isObservable', ko.isObservable);
	ko.exportSymbol('isWriteableObservable', ko.isWriteableObservable);
	ko.exportSymbol('isWritableObservable', ko.isWriteableObservable);
	ko.exportSymbol('observable.fn', observableFn);
	ko.exportProperty(observableFn, 'peek', observableFn.peek);
	ko.exportProperty(observableFn, 'valueHasMutated', observableFn.valueHasMutated);
	ko.exportProperty(observableFn, 'valueWillMutate', observableFn.valueWillMutate);
	ko.observableArray = function (initialValues) {
	    initialValues = initialValues || [];
	
	    if (typeof initialValues != 'object' || !('length' in initialValues))
	        throw new Error("The argument passed when initializing an observable array must be an array, or null, or undefined.");
	
	    var result = ko.observable(initialValues);
	    ko.utils.setPrototypeOfOrExtend(result, ko.observableArray['fn']);
	    return result.extend({'trackArrayChanges':true});
	};
	
	ko.observableArray['fn'] = {
	    'remove': function (valueOrPredicate) {
	        var underlyingArray = this.peek();
	        var removedValues = [];
	        var predicate = typeof valueOrPredicate == "function" && !ko.isObservable(valueOrPredicate) ? valueOrPredicate : function (value) { return value === valueOrPredicate; };
	        for (var i = 0; i < underlyingArray.length; i++) {
	            var value = underlyingArray[i];
	            if (predicate(value)) {
	                if (removedValues.length === 0) {
	                    this.valueWillMutate();
	                }
	                removedValues.push(value);
	                underlyingArray.splice(i, 1);
	                i--;
	            }
	        }
	        if (removedValues.length) {
	            this.valueHasMutated();
	        }
	        return removedValues;
	    },
	
	    'removeAll': function (arrayOfValues) {
	        // If you passed zero args, we remove everything
	        if (arrayOfValues === undefined) {
	            var underlyingArray = this.peek();
	            var allValues = underlyingArray.slice(0);
	            this.valueWillMutate();
	            underlyingArray.splice(0, underlyingArray.length);
	            this.valueHasMutated();
	            return allValues;
	        }
	        // If you passed an arg, we interpret it as an array of entries to remove
	        if (!arrayOfValues)
	            return [];
	        return this['remove'](function (value) {
	            return ko.utils.arrayIndexOf(arrayOfValues, value) >= 0;
	        });
	    },
	
	    'destroy': function (valueOrPredicate) {
	        var underlyingArray = this.peek();
	        var predicate = typeof valueOrPredicate == "function" && !ko.isObservable(valueOrPredicate) ? valueOrPredicate : function (value) { return value === valueOrPredicate; };
	        this.valueWillMutate();
	        for (var i = underlyingArray.length - 1; i >= 0; i--) {
	            var value = underlyingArray[i];
	            if (predicate(value))
	                underlyingArray[i]["_destroy"] = true;
	        }
	        this.valueHasMutated();
	    },
	
	    'destroyAll': function (arrayOfValues) {
	        // If you passed zero args, we destroy everything
	        if (arrayOfValues === undefined)
	            return this['destroy'](function() { return true });
	
	        // If you passed an arg, we interpret it as an array of entries to destroy
	        if (!arrayOfValues)
	            return [];
	        return this['destroy'](function (value) {
	            return ko.utils.arrayIndexOf(arrayOfValues, value) >= 0;
	        });
	    },
	
	    'indexOf': function (item) {
	        var underlyingArray = this();
	        return ko.utils.arrayIndexOf(underlyingArray, item);
	    },
	
	    'replace': function(oldItem, newItem) {
	        var index = this['indexOf'](oldItem);
	        if (index >= 0) {
	            this.valueWillMutate();
	            this.peek()[index] = newItem;
	            this.valueHasMutated();
	        }
	    }
	};
	
	// Note that for browsers that don't support proto assignment, the
	// inheritance chain is created manually in the ko.observableArray constructor
	if (ko.utils.canSetPrototype) {
	    ko.utils.setPrototypeOf(ko.observableArray['fn'], ko.observable['fn']);
	}
	
	// Populate ko.observableArray.fn with read/write functions from native arrays
	// Important: Do not add any additional functions here that may reasonably be used to *read* data from the array
	// because we'll eval them without causing subscriptions, so ko.computed output could end up getting stale
	ko.utils.arrayForEach(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (methodName) {
	    ko.observableArray['fn'][methodName] = function () {
	        // Use "peek" to avoid creating a subscription in any computed that we're executing in the context of
	        // (for consistency with mutating regular observables)
	        var underlyingArray = this.peek();
	        this.valueWillMutate();
	        this.cacheDiffForKnownOperation(underlyingArray, methodName, arguments);
	        var methodCallResult = underlyingArray[methodName].apply(underlyingArray, arguments);
	        this.valueHasMutated();
	        // The native sort and reverse methods return a reference to the array, but it makes more sense to return the observable array instead.
	        return methodCallResult === underlyingArray ? this : methodCallResult;
	    };
	});
	
	// Populate ko.observableArray.fn with read-only functions from native arrays
	ko.utils.arrayForEach(["slice"], function (methodName) {
	    ko.observableArray['fn'][methodName] = function () {
	        var underlyingArray = this();
	        return underlyingArray[methodName].apply(underlyingArray, arguments);
	    };
	});
	
	ko.exportSymbol('observableArray', ko.observableArray);
	var arrayChangeEventName = 'arrayChange';
	ko.extenders['trackArrayChanges'] = function(target, options) {
	    // Use the provided options--each call to trackArrayChanges overwrites the previously set options
	    target.compareArrayOptions = {};
	    if (options && typeof options == "object") {
	        ko.utils.extend(target.compareArrayOptions, options);
	    }
	    target.compareArrayOptions['sparse'] = true;
	
	    // Only modify the target observable once
	    if (target.cacheDiffForKnownOperation) {
	        return;
	    }
	    var trackingChanges = false,
	        cachedDiff = null,
	        arrayChangeSubscription,
	        pendingNotifications = 0,
	        underlyingBeforeSubscriptionAddFunction = target.beforeSubscriptionAdd,
	        underlyingAfterSubscriptionRemoveFunction = target.afterSubscriptionRemove;
	
	    // Watch "subscribe" calls, and for array change events, ensure change tracking is enabled
	    target.beforeSubscriptionAdd = function (event) {
	        if (underlyingBeforeSubscriptionAddFunction)
	            underlyingBeforeSubscriptionAddFunction.call(target, event);
	        if (event === arrayChangeEventName) {
	            trackChanges();
	        }
	    };
	    // Watch "dispose" calls, and for array change events, ensure change tracking is disabled when all are disposed
	    target.afterSubscriptionRemove = function (event) {
	        if (underlyingAfterSubscriptionRemoveFunction)
	            underlyingAfterSubscriptionRemoveFunction.call(target, event);
	        if (event === arrayChangeEventName && !target.hasSubscriptionsForEvent(arrayChangeEventName)) {
	            arrayChangeSubscription.dispose();
	            trackingChanges = false;
	        }
	    };
	
	    function trackChanges() {
	        // Calling 'trackChanges' multiple times is the same as calling it once
	        if (trackingChanges) {
	            return;
	        }
	
	        trackingChanges = true;
	
	        // Intercept "notifySubscribers" to track how many times it was called.
	        var underlyingNotifySubscribersFunction = target['notifySubscribers'];
	        target['notifySubscribers'] = function(valueToNotify, event) {
	            if (!event || event === defaultEvent) {
	                ++pendingNotifications;
	            }
	            return underlyingNotifySubscribersFunction.apply(this, arguments);
	        };
	
	        // Each time the array changes value, capture a clone so that on the next
	        // change it's possible to produce a diff
	        var previousContents = [].concat(target.peek() || []);
	        cachedDiff = null;
	        arrayChangeSubscription = target.subscribe(function(currentContents) {
	            // Make a copy of the current contents and ensure it's an array
	            currentContents = [].concat(currentContents || []);
	
	            // Compute the diff and issue notifications, but only if someone is listening
	            if (target.hasSubscriptionsForEvent(arrayChangeEventName)) {
	                var changes = getChanges(previousContents, currentContents);
	            }
	
	            // Eliminate references to the old, removed items, so they can be GCed
	            previousContents = currentContents;
	            cachedDiff = null;
	            pendingNotifications = 0;
	
	            if (changes && changes.length) {
	                target['notifySubscribers'](changes, arrayChangeEventName);
	            }
	        });
	    }
	
	    function getChanges(previousContents, currentContents) {
	        // We try to re-use cached diffs.
	        // The scenarios where pendingNotifications > 1 are when using rate-limiting or the Deferred Updates
	        // plugin, which without this check would not be compatible with arrayChange notifications. Normally,
	        // notifications are issued immediately so we wouldn't be queueing up more than one.
	        if (!cachedDiff || pendingNotifications > 1) {
	            cachedDiff = ko.utils.compareArrays(previousContents, currentContents, target.compareArrayOptions);
	        }
	
	        return cachedDiff;
	    }
	
	    target.cacheDiffForKnownOperation = function(rawArray, operationName, args) {
	        // Only run if we're currently tracking changes for this observable array
	        // and there aren't any pending deferred notifications.
	        if (!trackingChanges || pendingNotifications) {
	            return;
	        }
	        var diff = [],
	            arrayLength = rawArray.length,
	            argsLength = args.length,
	            offset = 0;
	
	        function pushDiff(status, value, index) {
	            return diff[diff.length] = { 'status': status, 'value': value, 'index': index };
	        }
	        switch (operationName) {
	            case 'push':
	                offset = arrayLength;
	            case 'unshift':
	                for (var index = 0; index < argsLength; index++) {
	                    pushDiff('added', args[index], offset + index);
	                }
	                break;
	
	            case 'pop':
	                offset = arrayLength - 1;
	            case 'shift':
	                if (arrayLength) {
	                    pushDiff('deleted', rawArray[offset], offset);
	                }
	                break;
	
	            case 'splice':
	                // Negative start index means 'from end of array'. After that we clamp to [0...arrayLength].
	                // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice
	                var startIndex = Math.min(Math.max(0, args[0] < 0 ? arrayLength + args[0] : args[0]), arrayLength),
	                    endDeleteIndex = argsLength === 1 ? arrayLength : Math.min(startIndex + (args[1] || 0), arrayLength),
	                    endAddIndex = startIndex + argsLength - 2,
	                    endIndex = Math.max(endDeleteIndex, endAddIndex),
	                    additions = [], deletions = [];
	                for (var index = startIndex, argsIndex = 2; index < endIndex; ++index, ++argsIndex) {
	                    if (index < endDeleteIndex)
	                        deletions.push(pushDiff('deleted', rawArray[index], index));
	                    if (index < endAddIndex)
	                        additions.push(pushDiff('added', args[argsIndex], index));
	                }
	                ko.utils.findMovesInArrayComparison(deletions, additions);
	                break;
	
	            default:
	                return;
	        }
	        cachedDiff = diff;
	    };
	};
	var computedState = ko.utils.createSymbolOrString('_state');
	
	ko.computed = ko.dependentObservable = function (evaluatorFunctionOrOptions, evaluatorFunctionTarget, options) {
	    if (typeof evaluatorFunctionOrOptions === "object") {
	        // Single-parameter syntax - everything is on this "options" param
	        options = evaluatorFunctionOrOptions;
	    } else {
	        // Multi-parameter syntax - construct the options according to the params passed
	        options = options || {};
	        if (evaluatorFunctionOrOptions) {
	            options["read"] = evaluatorFunctionOrOptions;
	        }
	    }
	    if (typeof options["read"] != "function")
	        throw Error("Pass a function that returns the value of the ko.computed");
	
	    var writeFunction = options["write"];
	    var state = {
	        latestValue: undefined,
	        isStale: true,
	        isBeingEvaluated: false,
	        suppressDisposalUntilDisposeWhenReturnsFalse: false,
	        isDisposed: false,
	        pure: false,
	        isSleeping: false,
	        readFunction: options["read"],
	        evaluatorFunctionTarget: evaluatorFunctionTarget || options["owner"],
	        disposeWhenNodeIsRemoved: options["disposeWhenNodeIsRemoved"] || options.disposeWhenNodeIsRemoved || null,
	        disposeWhen: options["disposeWhen"] || options.disposeWhen,
	        domNodeDisposalCallback: null,
	        dependencyTracking: {},
	        dependenciesCount: 0,
	        evaluationTimeoutInstance: null
	    };
	
	    function computedObservable() {
	        if (arguments.length > 0) {
	            if (typeof writeFunction === "function") {
	                // Writing a value
	                writeFunction.apply(state.evaluatorFunctionTarget, arguments);
	            } else {
	                throw new Error("Cannot write a value to a ko.computed unless you specify a 'write' option. If you wish to read the current value, don't pass any parameters.");
	            }
	            return this; // Permits chained assignments
	        } else {
	            // Reading the value
	            ko.dependencyDetection.registerDependency(computedObservable);
	            if (state.isStale || (state.isSleeping && computedObservable.haveDependenciesChanged())) {
	                computedObservable.evaluateImmediate();
	            }
	            return state.latestValue;
	        }
	    }
	
	    computedObservable[computedState] = state;
	    computedObservable.hasWriteFunction = typeof writeFunction === "function";
	
	    // Inherit from 'subscribable'
	    if (!ko.utils.canSetPrototype) {
	        // 'subscribable' won't be on the prototype chain unless we put it there directly
	        ko.utils.extend(computedObservable, ko.subscribable['fn']);
	    }
	    ko.subscribable['fn'].init(computedObservable);
	
	    // Inherit from 'computed'
	    ko.utils.setPrototypeOfOrExtend(computedObservable, computedFn);
	
	    if (options['pure']) {
	        state.pure = true;
	        state.isSleeping = true;     // Starts off sleeping; will awake on the first subscription
	        ko.utils.extend(computedObservable, pureComputedOverrides);
	    } else if (options['deferEvaluation']) {
	        ko.utils.extend(computedObservable, deferEvaluationOverrides);
	    }
	
	    if (ko.options['deferUpdates']) {
	        ko.extenders['deferred'](computedObservable, true);
	    }
	
	    if (DEBUG) {
	        // #1731 - Aid debugging by exposing the computed's options
	        computedObservable["_options"] = options;
	    }
	
	    if (state.disposeWhenNodeIsRemoved) {
	        // Since this computed is associated with a DOM node, and we don't want to dispose the computed
	        // until the DOM node is *removed* from the document (as opposed to never having been in the document),
	        // we'll prevent disposal until "disposeWhen" first returns false.
	        state.suppressDisposalUntilDisposeWhenReturnsFalse = true;
	
	        // disposeWhenNodeIsRemoved: true can be used to opt into the "only dispose after first false result"
	        // behaviour even if there's no specific node to watch. In that case, clear the option so we don't try
	        // to watch for a non-node's disposal. This technique is intended for KO's internal use only and shouldn't
	        // be documented or used by application code, as it's likely to change in a future version of KO.
	        if (!state.disposeWhenNodeIsRemoved.nodeType) {
	            state.disposeWhenNodeIsRemoved = null;
	        }
	    }
	
	    // Evaluate, unless sleeping or deferEvaluation is true
	    if (!state.isSleeping && !options['deferEvaluation']) {
	        computedObservable.evaluateImmediate();
	    }
	
	    // Attach a DOM node disposal callback so that the computed will be proactively disposed as soon as the node is
	    // removed using ko.removeNode. But skip if isActive is false (there will never be any dependencies to dispose).
	    if (state.disposeWhenNodeIsRemoved && computedObservable.isActive()) {
	        ko.utils.domNodeDisposal.addDisposeCallback(state.disposeWhenNodeIsRemoved, state.domNodeDisposalCallback = function () {
	            computedObservable.dispose();
	        });
	    }
	
	    return computedObservable;
	};
	
	// Utility function that disposes a given dependencyTracking entry
	function computedDisposeDependencyCallback(id, entryToDispose) {
	    if (entryToDispose !== null && entryToDispose.dispose) {
	        entryToDispose.dispose();
	    }
	}
	
	// This function gets called each time a dependency is detected while evaluating a computed.
	// It's factored out as a shared function to avoid creating unnecessary function instances during evaluation.
	function computedBeginDependencyDetectionCallback(subscribable, id) {
	    var computedObservable = this.computedObservable,
	        state = computedObservable[computedState];
	    if (!state.isDisposed) {
	        if (this.disposalCount && this.disposalCandidates[id]) {
	            // Don't want to dispose this subscription, as it's still being used
	            computedObservable.addDependencyTracking(id, subscribable, this.disposalCandidates[id]);
	            this.disposalCandidates[id] = null; // No need to actually delete the property - disposalCandidates is a transient object anyway
	            --this.disposalCount;
	        } else if (!state.dependencyTracking[id]) {
	            // Brand new subscription - add it
	            computedObservable.addDependencyTracking(id, subscribable, state.isSleeping ? { _target: subscribable } : computedObservable.subscribeToDependency(subscribable));
	        }
	    }
	}
	
	var computedFn = {
	    "equalityComparer": valuesArePrimitiveAndEqual,
	    getDependenciesCount: function () {
	        return this[computedState].dependenciesCount;
	    },
	    addDependencyTracking: function (id, target, trackingObj) {
	        if (this[computedState].pure && target === this) {
	            throw Error("A 'pure' computed must not be called recursively");
	        }
	
	        this[computedState].dependencyTracking[id] = trackingObj;
	        trackingObj._order = this[computedState].dependenciesCount++;
	        trackingObj._version = target.getVersion();
	    },
	    haveDependenciesChanged: function () {
	        var id, dependency, dependencyTracking = this[computedState].dependencyTracking;
	        for (id in dependencyTracking) {
	            if (dependencyTracking.hasOwnProperty(id)) {
	                dependency = dependencyTracking[id];
	                if (dependency._target.hasChanged(dependency._version)) {
	                    return true;
	                }
	            }
	        }
	    },
	    markDirty: function () {
	        // Process "dirty" events if we can handle delayed notifications
	        if (this._evalDelayed && !this[computedState].isBeingEvaluated) {
	            this._evalDelayed();
	        }
	    },
	    isActive: function () {
	        return this[computedState].isStale || this[computedState].dependenciesCount > 0;
	    },
	    respondToChange: function () {
	        // Ignore "change" events if we've already scheduled a delayed notification
	        if (!this._notificationIsPending) {
	            this.evaluatePossiblyAsync();
	        }
	    },
	    subscribeToDependency: function (target) {
	        if (target._deferUpdates && !this[computedState].disposeWhenNodeIsRemoved) {
	            var dirtySub = target.subscribe(this.markDirty, this, 'dirty'),
	                changeSub = target.subscribe(this.respondToChange, this);
	            return {
	                _target: target,
	                dispose: function () {
	                    dirtySub.dispose();
	                    changeSub.dispose();
	                }
	            };
	        } else {
	            return target.subscribe(this.evaluatePossiblyAsync, this);
	        }
	    },
	    evaluatePossiblyAsync: function () {
	        var computedObservable = this,
	            throttleEvaluationTimeout = computedObservable['throttleEvaluation'];
	        if (throttleEvaluationTimeout && throttleEvaluationTimeout >= 0) {
	            clearTimeout(this[computedState].evaluationTimeoutInstance);
	            this[computedState].evaluationTimeoutInstance = ko.utils.setTimeout(function () {
	                computedObservable.evaluateImmediate(true /*notifyChange*/);
	            }, throttleEvaluationTimeout);
	        } else if (computedObservable._evalDelayed) {
	            computedObservable._evalDelayed();
	        } else {
	            computedObservable.evaluateImmediate(true /*notifyChange*/);
	        }
	    },
	    evaluateImmediate: function (notifyChange) {
	        var computedObservable = this,
	            state = computedObservable[computedState],
	            disposeWhen = state.disposeWhen;
	
	        if (state.isBeingEvaluated) {
	            // If the evaluation of a ko.computed causes side effects, it's possible that it will trigger its own re-evaluation.
	            // This is not desirable (it's hard for a developer to realise a chain of dependencies might cause this, and they almost
	            // certainly didn't intend infinite re-evaluations). So, for predictability, we simply prevent ko.computeds from causing
	            // their own re-evaluation. Further discussion at https://github.com/SteveSanderson/knockout/pull/387
	            return;
	        }
	
	        // Do not evaluate (and possibly capture new dependencies) if disposed
	        if (state.isDisposed) {
	            return;
	        }
	
	        if (state.disposeWhenNodeIsRemoved && !ko.utils.domNodeIsAttachedToDocument(state.disposeWhenNodeIsRemoved) || disposeWhen && disposeWhen()) {
	            // See comment above about suppressDisposalUntilDisposeWhenReturnsFalse
	            if (!state.suppressDisposalUntilDisposeWhenReturnsFalse) {
	                computedObservable.dispose();
	                return;
	            }
	        } else {
	            // It just did return false, so we can stop suppressing now
	            state.suppressDisposalUntilDisposeWhenReturnsFalse = false;
	        }
	
	        state.isBeingEvaluated = true;
	        try {
	            this.evaluateImmediate_CallReadWithDependencyDetection(notifyChange);
	        } finally {
	            state.isBeingEvaluated = false;
	        }
	
	        if (!state.dependenciesCount) {
	            computedObservable.dispose();
	        }
	    },
	    evaluateImmediate_CallReadWithDependencyDetection: function (notifyChange) {
	        // This function is really just part of the evaluateImmediate logic. You would never call it from anywhere else.
	        // Factoring it out into a separate function means it can be independent of the try/catch block in evaluateImmediate,
	        // which contributes to saving about 40% off the CPU overhead of computed evaluation (on V8 at least).
	
	        var computedObservable = this,
	            state = computedObservable[computedState];
	
	        // Initially, we assume that none of the subscriptions are still being used (i.e., all are candidates for disposal).
	        // Then, during evaluation, we cross off any that are in fact still being used.
	        var isInitial = state.pure ? undefined : !state.dependenciesCount,   // If we're evaluating when there are no previous dependencies, it must be the first time
	            dependencyDetectionContext = {
	                computedObservable: computedObservable,
	                disposalCandidates: state.dependencyTracking,
	                disposalCount: state.dependenciesCount
	            };
	
	        ko.dependencyDetection.begin({
	            callbackTarget: dependencyDetectionContext,
	            callback: computedBeginDependencyDetectionCallback,
	            computed: computedObservable,
	            isInitial: isInitial
	        });
	
	        state.dependencyTracking = {};
	        state.dependenciesCount = 0;
	
	        var newValue = this.evaluateImmediate_CallReadThenEndDependencyDetection(state, dependencyDetectionContext);
	
	        if (computedObservable.isDifferent(state.latestValue, newValue)) {
	            if (!state.isSleeping) {
	                computedObservable["notifySubscribers"](state.latestValue, "beforeChange");
	            }
	
	            state.latestValue = newValue;
	
	            if (state.isSleeping) {
	                computedObservable.updateVersion();
	            } else if (notifyChange) {
	                computedObservable["notifySubscribers"](state.latestValue);
	            }
	        }
	
	        if (isInitial) {
	            computedObservable["notifySubscribers"](state.latestValue, "awake");
	        }
	    },
	    evaluateImmediate_CallReadThenEndDependencyDetection: function (state, dependencyDetectionContext) {
	        // This function is really part of the evaluateImmediate_CallReadWithDependencyDetection logic.
	        // You'd never call it from anywhere else. Factoring it out means that evaluateImmediate_CallReadWithDependencyDetection
	        // can be independent of try/finally blocks, which contributes to saving about 40% off the CPU
	        // overhead of computed evaluation (on V8 at least).
	
	        try {
	            var readFunction = state.readFunction;
	            return state.evaluatorFunctionTarget ? readFunction.call(state.evaluatorFunctionTarget) : readFunction();
	        } finally {
	            ko.dependencyDetection.end();
	
	            // For each subscription no longer being used, remove it from the active subscriptions list and dispose it
	            if (dependencyDetectionContext.disposalCount && !state.isSleeping) {
	                ko.utils.objectForEach(dependencyDetectionContext.disposalCandidates, computedDisposeDependencyCallback);
	            }
	
	            state.isStale = false;
	        }
	    },
	    peek: function () {
	        // Peek won't re-evaluate, except while the computed is sleeping or to get the initial value when "deferEvaluation" is set.
	        var state = this[computedState];
	        if ((state.isStale && !state.dependenciesCount) || (state.isSleeping && this.haveDependenciesChanged())) {
	            this.evaluateImmediate();
	        }
	        return state.latestValue;
	    },
	    limit: function (limitFunction) {
	        // Override the limit function with one that delays evaluation as well
	        ko.subscribable['fn'].limit.call(this, limitFunction);
	        this._evalDelayed = function () {
	            this._limitBeforeChange(this[computedState].latestValue);
	
	            this[computedState].isStale = true; // Mark as dirty
	
	            // Pass the observable to the "limit" code, which will access it when
	            // it's time to do the notification.
	            this._limitChange(this);
	        }
	    },
	    dispose: function () {
	        var state = this[computedState];
	        if (!state.isSleeping && state.dependencyTracking) {
	            ko.utils.objectForEach(state.dependencyTracking, function (id, dependency) {
	                if (dependency.dispose)
	                    dependency.dispose();
	            });
	        }
	        if (state.disposeWhenNodeIsRemoved && state.domNodeDisposalCallback) {
	            ko.utils.domNodeDisposal.removeDisposeCallback(state.disposeWhenNodeIsRemoved, state.domNodeDisposalCallback);
	        }
	        state.dependencyTracking = null;
	        state.dependenciesCount = 0;
	        state.isDisposed = true;
	        state.isStale = false;
	        state.isSleeping = false;
	        state.disposeWhenNodeIsRemoved = null;
	    }
	};
	
	var pureComputedOverrides = {
	    beforeSubscriptionAdd: function (event) {
	        // If asleep, wake up the computed by subscribing to any dependencies.
	        var computedObservable = this,
	            state = computedObservable[computedState];
	        if (!state.isDisposed && state.isSleeping && event == 'change') {
	            state.isSleeping = false;
	            if (state.isStale || computedObservable.haveDependenciesChanged()) {
	                state.dependencyTracking = null;
	                state.dependenciesCount = 0;
	                state.isStale = true;
	                computedObservable.evaluateImmediate();
	            } else {
	                // First put the dependencies in order
	                var dependeciesOrder = [];
	                ko.utils.objectForEach(state.dependencyTracking, function (id, dependency) {
	                    dependeciesOrder[dependency._order] = id;
	                });
	                // Next, subscribe to each one
	                ko.utils.arrayForEach(dependeciesOrder, function (id, order) {
	                    var dependency = state.dependencyTracking[id],
	                        subscription = computedObservable.subscribeToDependency(dependency._target);
	                    subscription._order = order;
	                    subscription._version = dependency._version;
	                    state.dependencyTracking[id] = subscription;
	                });
	            }
	            if (!state.isDisposed) {     // test since evaluating could trigger disposal
	                computedObservable["notifySubscribers"](state.latestValue, "awake");
	            }
	        }
	    },
	    afterSubscriptionRemove: function (event) {
	        var state = this[computedState];
	        if (!state.isDisposed && event == 'change' && !this.hasSubscriptionsForEvent('change')) {
	            ko.utils.objectForEach(state.dependencyTracking, function (id, dependency) {
	                if (dependency.dispose) {
	                    state.dependencyTracking[id] = {
	                        _target: dependency._target,
	                        _order: dependency._order,
	                        _version: dependency._version
	                    };
	                    dependency.dispose();
	                }
	            });
	            state.isSleeping = true;
	            this["notifySubscribers"](undefined, "asleep");
	        }
	    },
	    getVersion: function () {
	        // Because a pure computed is not automatically updated while it is sleeping, we can't
	        // simply return the version number. Instead, we check if any of the dependencies have
	        // changed and conditionally re-evaluate the computed observable.
	        var state = this[computedState];
	        if (state.isSleeping && (state.isStale || this.haveDependenciesChanged())) {
	            this.evaluateImmediate();
	        }
	        return ko.subscribable['fn'].getVersion.call(this);
	    }
	};
	
	var deferEvaluationOverrides = {
	    beforeSubscriptionAdd: function (event) {
	        // This will force a computed with deferEvaluation to evaluate when the first subscription is registered.
	        if (event == 'change' || event == 'beforeChange') {
	            this.peek();
	        }
	    }
	};
	
	// Note that for browsers that don't support proto assignment, the
	// inheritance chain is created manually in the ko.computed constructor
	if (ko.utils.canSetPrototype) {
	    ko.utils.setPrototypeOf(computedFn, ko.subscribable['fn']);
	}
	
	// Set the proto chain values for ko.hasPrototype
	var protoProp = ko.observable.protoProperty; // == "__ko_proto__"
	ko.computed[protoProp] = ko.observable;
	computedFn[protoProp] = ko.computed;
	
	ko.isComputed = function (instance) {
	    return ko.hasPrototype(instance, ko.computed);
	};
	
	ko.isPureComputed = function (instance) {
	    return ko.hasPrototype(instance, ko.computed)
	        && instance[computedState] && instance[computedState].pure;
	};
	
	ko.exportSymbol('computed', ko.computed);
	ko.exportSymbol('dependentObservable', ko.computed);    // export ko.dependentObservable for backwards compatibility (1.x)
	ko.exportSymbol('isComputed', ko.isComputed);
	ko.exportSymbol('isPureComputed', ko.isPureComputed);
	ko.exportSymbol('computed.fn', computedFn);
	ko.exportProperty(computedFn, 'peek', computedFn.peek);
	ko.exportProperty(computedFn, 'dispose', computedFn.dispose);
	ko.exportProperty(computedFn, 'isActive', computedFn.isActive);
	ko.exportProperty(computedFn, 'getDependenciesCount', computedFn.getDependenciesCount);
	
	ko.pureComputed = function (evaluatorFunctionOrOptions, evaluatorFunctionTarget) {
	    if (typeof evaluatorFunctionOrOptions === 'function') {
	        return ko.computed(evaluatorFunctionOrOptions, evaluatorFunctionTarget, {'pure':true});
	    } else {
	        evaluatorFunctionOrOptions = ko.utils.extend({}, evaluatorFunctionOrOptions);   // make a copy of the parameter object
	        evaluatorFunctionOrOptions['pure'] = true;
	        return ko.computed(evaluatorFunctionOrOptions, evaluatorFunctionTarget);
	    }
	}
	ko.exportSymbol('pureComputed', ko.pureComputed);
	
	(function() {
	    var maxNestedObservableDepth = 10; // Escape the (unlikely) pathalogical case where an observable's current value is itself (or similar reference cycle)
	
	    ko.toJS = function(rootObject) {
	        if (arguments.length == 0)
	            throw new Error("When calling ko.toJS, pass the object you want to convert.");
	
	        // We just unwrap everything at every level in the object graph
	        return mapJsObjectGraph(rootObject, function(valueToMap) {
	            // Loop because an observable's value might in turn be another observable wrapper
	            for (var i = 0; ko.isObservable(valueToMap) && (i < maxNestedObservableDepth); i++)
	                valueToMap = valueToMap();
	            return valueToMap;
	        });
	    };
	
	    ko.toJSON = function(rootObject, replacer, space) {     // replacer and space are optional
	        var plainJavaScriptObject = ko.toJS(rootObject);
	        return ko.utils.stringifyJson(plainJavaScriptObject, replacer, space);
	    };
	
	    function mapJsObjectGraph(rootObject, mapInputCallback, visitedObjects) {
	        visitedObjects = visitedObjects || new objectLookup();
	
	        rootObject = mapInputCallback(rootObject);
	        var canHaveProperties = (typeof rootObject == "object") && (rootObject !== null) && (rootObject !== undefined) && (!(rootObject instanceof RegExp)) && (!(rootObject instanceof Date)) && (!(rootObject instanceof String)) && (!(rootObject instanceof Number)) && (!(rootObject instanceof Boolean));
	        if (!canHaveProperties)
	            return rootObject;
	
	        var outputProperties = rootObject instanceof Array ? [] : {};
	        visitedObjects.save(rootObject, outputProperties);
	
	        visitPropertiesOrArrayEntries(rootObject, function(indexer) {
	            var propertyValue = mapInputCallback(rootObject[indexer]);
	
	            switch (typeof propertyValue) {
	                case "boolean":
	                case "number":
	                case "string":
	                case "function":
	                    outputProperties[indexer] = propertyValue;
	                    break;
	                case "object":
	                case "undefined":
	                    var previouslyMappedValue = visitedObjects.get(propertyValue);
	                    outputProperties[indexer] = (previouslyMappedValue !== undefined)
	                        ? previouslyMappedValue
	                        : mapJsObjectGraph(propertyValue, mapInputCallback, visitedObjects);
	                    break;
	            }
	        });
	
	        return outputProperties;
	    }
	
	    function visitPropertiesOrArrayEntries(rootObject, visitorCallback) {
	        if (rootObject instanceof Array) {
	            for (var i = 0; i < rootObject.length; i++)
	                visitorCallback(i);
	
	            // For arrays, also respect toJSON property for custom mappings (fixes #278)
	            if (typeof rootObject['toJSON'] == 'function')
	                visitorCallback('toJSON');
	        } else {
	            for (var propertyName in rootObject) {
	                visitorCallback(propertyName);
	            }
	        }
	    };
	
	    function objectLookup() {
	        this.keys = [];
	        this.values = [];
	    };
	
	    objectLookup.prototype = {
	        constructor: objectLookup,
	        save: function(key, value) {
	            var existingIndex = ko.utils.arrayIndexOf(this.keys, key);
	            if (existingIndex >= 0)
	                this.values[existingIndex] = value;
	            else {
	                this.keys.push(key);
	                this.values.push(value);
	            }
	        },
	        get: function(key) {
	            var existingIndex = ko.utils.arrayIndexOf(this.keys, key);
	            return (existingIndex >= 0) ? this.values[existingIndex] : undefined;
	        }
	    };
	})();
	
	ko.exportSymbol('toJS', ko.toJS);
	ko.exportSymbol('toJSON', ko.toJSON);
	(function () {
	    var hasDomDataExpandoProperty = '__ko__hasDomDataOptionValue__';
	
	    // Normally, SELECT elements and their OPTIONs can only take value of type 'string' (because the values
	    // are stored on DOM attributes). ko.selectExtensions provides a way for SELECTs/OPTIONs to have values
	    // that are arbitrary objects. This is very convenient when implementing things like cascading dropdowns.
	    ko.selectExtensions = {
	        readValue : function(element) {
	            switch (ko.utils.tagNameLower(element)) {
	                case 'option':
	                    if (element[hasDomDataExpandoProperty] === true)
	                        return ko.utils.domData.get(element, ko.bindingHandlers.options.optionValueDomDataKey);
	                    return ko.utils.ieVersion <= 7
	                        ? (element.getAttributeNode('value') && element.getAttributeNode('value').specified ? element.value : element.text)
	                        : element.value;
	                case 'select':
	                    return element.selectedIndex >= 0 ? ko.selectExtensions.readValue(element.options[element.selectedIndex]) : undefined;
	                default:
	                    return element.value;
	            }
	        },
	
	        writeValue: function(element, value, allowUnset) {
	            switch (ko.utils.tagNameLower(element)) {
	                case 'option':
	                    switch(typeof value) {
	                        case "string":
	                            ko.utils.domData.set(element, ko.bindingHandlers.options.optionValueDomDataKey, undefined);
	                            if (hasDomDataExpandoProperty in element) { // IE <= 8 throws errors if you delete non-existent properties from a DOM node
	                                delete element[hasDomDataExpandoProperty];
	                            }
	                            element.value = value;
	                            break;
	                        default:
	                            // Store arbitrary object using DomData
	                            ko.utils.domData.set(element, ko.bindingHandlers.options.optionValueDomDataKey, value);
	                            element[hasDomDataExpandoProperty] = true;
	
	                            // Special treatment of numbers is just for backward compatibility. KO 1.2.1 wrote numerical values to element.value.
	                            element.value = typeof value === "number" ? value : "";
	                            break;
	                    }
	                    break;
	                case 'select':
	                    if (value === "" || value === null)       // A blank string or null value will select the caption
	                        value = undefined;
	                    var selection = -1;
	                    for (var i = 0, n = element.options.length, optionValue; i < n; ++i) {
	                        optionValue = ko.selectExtensions.readValue(element.options[i]);
	                        // Include special check to handle selecting a caption with a blank string value
	                        if (optionValue == value || (optionValue == "" && value === undefined)) {
	                            selection = i;
	                            break;
	                        }
	                    }
	                    if (allowUnset || selection >= 0 || (value === undefined && element.size > 1)) {
	                        element.selectedIndex = selection;
	                    }
	                    break;
	                default:
	                    if ((value === null) || (value === undefined))
	                        value = "";
	                    element.value = value;
	                    break;
	            }
	        }
	    };
	})();
	
	ko.exportSymbol('selectExtensions', ko.selectExtensions);
	ko.exportSymbol('selectExtensions.readValue', ko.selectExtensions.readValue);
	ko.exportSymbol('selectExtensions.writeValue', ko.selectExtensions.writeValue);
	ko.expressionRewriting = (function () {
	    var javaScriptReservedWords = ["true", "false", "null", "undefined"];
	
	    // Matches something that can be assigned to--either an isolated identifier or something ending with a property accessor
	    // This is designed to be simple and avoid false negatives, but could produce false positives (e.g., a+b.c).
	    // This also will not properly handle nested brackets (e.g., obj1[obj2['prop']]; see #911).
	    var javaScriptAssignmentTarget = /^(?:[$_a-z][$\w]*|(.+)(\.\s*[$_a-z][$\w]*|\[.+\]))$/i;
	
	    function getWriteableValue(expression) {
	        if (ko.utils.arrayIndexOf(javaScriptReservedWords, expression) >= 0)
	            return false;
	        var match = expression.match(javaScriptAssignmentTarget);
	        return match === null ? false : match[1] ? ('Object(' + match[1] + ')' + match[2]) : expression;
	    }
	
	    // The following regular expressions will be used to split an object-literal string into tokens
	
	        // These two match strings, either with double quotes or single quotes
	    var stringDouble = '"(?:[^"\\\\]|\\\\.)*"',
	        stringSingle = "'(?:[^'\\\\]|\\\\.)*'",
	        // Matches a regular expression (text enclosed by slashes), but will also match sets of divisions
	        // as a regular expression (this is handled by the parsing loop below).
	        stringRegexp = '/(?:[^/\\\\]|\\\\.)*/\w*',
	        // These characters have special meaning to the parser and must not appear in the middle of a
	        // token, except as part of a string.
	        specials = ',"\'{}()/:[\\]',
	        // Match text (at least two characters) that does not contain any of the above special characters,
	        // although some of the special characters are allowed to start it (all but the colon and comma).
	        // The text can contain spaces, but leading or trailing spaces are skipped.
	        everyThingElse = '[^\\s:,/][^' + specials + ']*[^\\s' + specials + ']',
	        // Match any non-space character not matched already. This will match colons and commas, since they're
	        // not matched by "everyThingElse", but will also match any other single character that wasn't already
	        // matched (for example: in "a: 1, b: 2", each of the non-space characters will be matched by oneNotSpace).
	        oneNotSpace = '[^\\s]',
	
	        // Create the actual regular expression by or-ing the above strings. The order is important.
	        bindingToken = RegExp(stringDouble + '|' + stringSingle + '|' + stringRegexp + '|' + everyThingElse + '|' + oneNotSpace, 'g'),
	
	        // Match end of previous token to determine whether a slash is a division or regex.
	        divisionLookBehind = /[\])"'A-Za-z0-9_$]+$/,
	        keywordRegexLookBehind = {'in':1,'return':1,'typeof':1};
	
	    function parseObjectLiteral(objectLiteralString) {
	        // Trim leading and trailing spaces from the string
	        var str = ko.utils.stringTrim(objectLiteralString);
	
	        // Trim braces '{' surrounding the whole object literal
	        if (str.charCodeAt(0) === 123) str = str.slice(1, -1);
	
	        // Split into tokens
	        var result = [], toks = str.match(bindingToken), key, values = [], depth = 0;
	
	        if (toks) {
	            // Append a comma so that we don't need a separate code block to deal with the last item
	            toks.push(',');
	
	            for (var i = 0, tok; tok = toks[i]; ++i) {
	                var c = tok.charCodeAt(0);
	                // A comma signals the end of a key/value pair if depth is zero
	                if (c === 44) { // ","
	                    if (depth <= 0) {
	                        result.push((key && values.length) ? {key: key, value: values.join('')} : {'unknown': key || values.join('')});
	                        key = depth = 0;
	                        values = [];
	                        continue;
	                    }
	                // Simply skip the colon that separates the name and value
	                } else if (c === 58) { // ":"
	                    if (!depth && !key && values.length === 1) {
	                        key = values.pop();
	                        continue;
	                    }
	                // A set of slashes is initially matched as a regular expression, but could be division
	                } else if (c === 47 && i && tok.length > 1) {  // "/"
	                    // Look at the end of the previous token to determine if the slash is actually division
	                    var match = toks[i-1].match(divisionLookBehind);
	                    if (match && !keywordRegexLookBehind[match[0]]) {
	                        // The slash is actually a division punctuator; re-parse the remainder of the string (not including the slash)
	                        str = str.substr(str.indexOf(tok) + 1);
	                        toks = str.match(bindingToken);
	                        toks.push(',');
	                        i = -1;
	                        // Continue with just the slash
	                        tok = '/';
	                    }
	                // Increment depth for parentheses, braces, and brackets so that interior commas are ignored
	                } else if (c === 40 || c === 123 || c === 91) { // '(', '{', '['
	                    ++depth;
	                } else if (c === 41 || c === 125 || c === 93) { // ')', '}', ']'
	                    --depth;
	                // The key will be the first token; if it's a string, trim the quotes
	                } else if (!key && !values.length && (c === 34 || c === 39)) { // '"', "'"
	                    tok = tok.slice(1, -1);
	                }
	                values.push(tok);
	            }
	        }
	        return result;
	    }
	
	    // Two-way bindings include a write function that allow the handler to update the value even if it's not an observable.
	    var twoWayBindings = {};
	
	    function preProcessBindings(bindingsStringOrKeyValueArray, bindingOptions) {
	        bindingOptions = bindingOptions || {};
	
	        function processKeyValue(key, val) {
	            var writableVal;
	            function callPreprocessHook(obj) {
	                return (obj && obj['preprocess']) ? (val = obj['preprocess'](val, key, processKeyValue)) : true;
	            }
	            if (!bindingParams) {
	                if (!callPreprocessHook(ko['getBindingHandler'](key)))
	                    return;
	
	                if (twoWayBindings[key] && (writableVal = getWriteableValue(val))) {
	                    // For two-way bindings, provide a write method in case the value
	                    // isn't a writable observable.
	                    propertyAccessorResultStrings.push("'" + key + "':function(_z){" + writableVal + "=_z}");
	                }
	            }
	            // Values are wrapped in a function so that each value can be accessed independently
	            if (makeValueAccessors) {
	                val = 'function(){return ' + val + ' }';
	            }
	            resultStrings.push("'" + key + "':" + val);
	        }
	
	        var resultStrings = [],
	            propertyAccessorResultStrings = [],
	            makeValueAccessors = bindingOptions['valueAccessors'],
	            bindingParams = bindingOptions['bindingParams'],
	            keyValueArray = typeof bindingsStringOrKeyValueArray === "string" ?
	                parseObjectLiteral(bindingsStringOrKeyValueArray) : bindingsStringOrKeyValueArray;
	
	        ko.utils.arrayForEach(keyValueArray, function(keyValue) {
	            processKeyValue(keyValue.key || keyValue['unknown'], keyValue.value);
	        });
	
	        if (propertyAccessorResultStrings.length)
	            processKeyValue('_ko_property_writers', "{" + propertyAccessorResultStrings.join(",") + " }");
	
	        return resultStrings.join(",");
	    }
	
	    return {
	        bindingRewriteValidators: [],
	
	        twoWayBindings: twoWayBindings,
	
	        parseObjectLiteral: parseObjectLiteral,
	
	        preProcessBindings: preProcessBindings,
	
	        keyValueArrayContainsKey: function(keyValueArray, key) {
	            for (var i = 0; i < keyValueArray.length; i++)
	                if (keyValueArray[i]['key'] == key)
	                    return true;
	            return false;
	        },
	
	        // Internal, private KO utility for updating model properties from within bindings
	        // property:            If the property being updated is (or might be) an observable, pass it here
	        //                      If it turns out to be a writable observable, it will be written to directly
	        // allBindings:         An object with a get method to retrieve bindings in the current execution context.
	        //                      This will be searched for a '_ko_property_writers' property in case you're writing to a non-observable
	        // key:                 The key identifying the property to be written. Example: for { hasFocus: myValue }, write to 'myValue' by specifying the key 'hasFocus'
	        // value:               The value to be written
	        // checkIfDifferent:    If true, and if the property being written is a writable observable, the value will only be written if
	        //                      it is !== existing value on that writable observable
	        writeValueToProperty: function(property, allBindings, key, value, checkIfDifferent) {
	            if (!property || !ko.isObservable(property)) {
	                var propWriters = allBindings.get('_ko_property_writers');
	                if (propWriters && propWriters[key])
	                    propWriters[key](value);
	            } else if (ko.isWriteableObservable(property) && (!checkIfDifferent || property.peek() !== value)) {
	                property(value);
	            }
	        }
	    };
	})();
	
	ko.exportSymbol('expressionRewriting', ko.expressionRewriting);
	ko.exportSymbol('expressionRewriting.bindingRewriteValidators', ko.expressionRewriting.bindingRewriteValidators);
	ko.exportSymbol('expressionRewriting.parseObjectLiteral', ko.expressionRewriting.parseObjectLiteral);
	ko.exportSymbol('expressionRewriting.preProcessBindings', ko.expressionRewriting.preProcessBindings);
	
	// Making bindings explicitly declare themselves as "two way" isn't ideal in the long term (it would be better if
	// all bindings could use an official 'property writer' API without needing to declare that they might). However,
	// since this is not, and has never been, a public API (_ko_property_writers was never documented), it's acceptable
	// as an internal implementation detail in the short term.
	// For those developers who rely on _ko_property_writers in their custom bindings, we expose _twoWayBindings as an
	// undocumented feature that makes it relatively easy to upgrade to KO 3.0. However, this is still not an official
	// public API, and we reserve the right to remove it at any time if we create a real public property writers API.
	ko.exportSymbol('expressionRewriting._twoWayBindings', ko.expressionRewriting.twoWayBindings);
	
	// For backward compatibility, define the following aliases. (Previously, these function names were misleading because
	// they referred to JSON specifically, even though they actually work with arbitrary JavaScript object literal expressions.)
	ko.exportSymbol('jsonExpressionRewriting', ko.expressionRewriting);
	ko.exportSymbol('jsonExpressionRewriting.insertPropertyAccessorsIntoJson', ko.expressionRewriting.preProcessBindings);
	(function() {
	    // "Virtual elements" is an abstraction on top of the usual DOM API which understands the notion that comment nodes
	    // may be used to represent hierarchy (in addition to the DOM's natural hierarchy).
	    // If you call the DOM-manipulating functions on ko.virtualElements, you will be able to read and write the state
	    // of that virtual hierarchy
	    //
	    // The point of all this is to support containerless templates (e.g., <!-- ko foreach:someCollection -->blah<!-- /ko -->)
	    // without having to scatter special cases all over the binding and templating code.
	
	    // IE 9 cannot reliably read the "nodeValue" property of a comment node (see https://github.com/SteveSanderson/knockout/issues/186)
	    // but it does give them a nonstandard alternative property called "text" that it can read reliably. Other browsers don't have that property.
	    // So, use node.text where available, and node.nodeValue elsewhere
	    var commentNodesHaveTextProperty = document && document.createComment("test").text === "<!--test-->";
	
	    var startCommentRegex = commentNodesHaveTextProperty ? /^<!--\s*ko(?:\s+([\s\S]+))?\s*-->$/ : /^\s*ko(?:\s+([\s\S]+))?\s*$/;
	    var endCommentRegex =   commentNodesHaveTextProperty ? /^<!--\s*\/ko\s*-->$/ : /^\s*\/ko\s*$/;
	    var htmlTagsWithOptionallyClosingChildren = { 'ul': true, 'ol': true };
	
	    function isStartComment(node) {
	        return (node.nodeType == 8) && startCommentRegex.test(commentNodesHaveTextProperty ? node.text : node.nodeValue);
	    }
	
	    function isEndComment(node) {
	        return (node.nodeType == 8) && endCommentRegex.test(commentNodesHaveTextProperty ? node.text : node.nodeValue);
	    }
	
	    function getVirtualChildren(startComment, allowUnbalanced) {
	        var currentNode = startComment;
	        var depth = 1;
	        var children = [];
	        while (currentNode = currentNode.nextSibling) {
	            if (isEndComment(currentNode)) {
	                depth--;
	                if (depth === 0)
	                    return children;
	            }
	
	            children.push(currentNode);
	
	            if (isStartComment(currentNode))
	                depth++;
	        }
	        if (!allowUnbalanced)
	            throw new Error("Cannot find closing comment tag to match: " + startComment.nodeValue);
	        return null;
	    }
	
	    function getMatchingEndComment(startComment, allowUnbalanced) {
	        var allVirtualChildren = getVirtualChildren(startComment, allowUnbalanced);
	        if (allVirtualChildren) {
	            if (allVirtualChildren.length > 0)
	                return allVirtualChildren[allVirtualChildren.length - 1].nextSibling;
	            return startComment.nextSibling;
	        } else
	            return null; // Must have no matching end comment, and allowUnbalanced is true
	    }
	
	    function getUnbalancedChildTags(node) {
	        // e.g., from <div>OK</div><!-- ko blah --><span>Another</span>, returns: <!-- ko blah --><span>Another</span>
	        //       from <div>OK</div><!-- /ko --><!-- /ko -->,             returns: <!-- /ko --><!-- /ko -->
	        var childNode = node.firstChild, captureRemaining = null;
	        if (childNode) {
	            do {
	                if (captureRemaining)                   // We already hit an unbalanced node and are now just scooping up all subsequent nodes
	                    captureRemaining.push(childNode);
	                else if (isStartComment(childNode)) {
	                    var matchingEndComment = getMatchingEndComment(childNode, /* allowUnbalanced: */ true);
	                    if (matchingEndComment)             // It's a balanced tag, so skip immediately to the end of this virtual set
	                        childNode = matchingEndComment;
	                    else
	                        captureRemaining = [childNode]; // It's unbalanced, so start capturing from this point
	                } else if (isEndComment(childNode)) {
	                    captureRemaining = [childNode];     // It's unbalanced (if it wasn't, we'd have skipped over it already), so start capturing
	                }
	            } while (childNode = childNode.nextSibling);
	        }
	        return captureRemaining;
	    }
	
	    ko.virtualElements = {
	        allowedBindings: {},
	
	        childNodes: function(node) {
	            return isStartComment(node) ? getVirtualChildren(node) : node.childNodes;
	        },
	
	        emptyNode: function(node) {
	            if (!isStartComment(node))
	                ko.utils.emptyDomNode(node);
	            else {
	                var virtualChildren = ko.virtualElements.childNodes(node);
	                for (var i = 0, j = virtualChildren.length; i < j; i++)
	                    ko.removeNode(virtualChildren[i]);
	            }
	        },
	
	        setDomNodeChildren: function(node, childNodes) {
	            if (!isStartComment(node))
	                ko.utils.setDomNodeChildren(node, childNodes);
	            else {
	                ko.virtualElements.emptyNode(node);
	                var endCommentNode = node.nextSibling; // Must be the next sibling, as we just emptied the children
	                for (var i = 0, j = childNodes.length; i < j; i++)
	                    endCommentNode.parentNode.insertBefore(childNodes[i], endCommentNode);
	            }
	        },
	
	        prepend: function(containerNode, nodeToPrepend) {
	            if (!isStartComment(containerNode)) {
	                if (containerNode.firstChild)
	                    containerNode.insertBefore(nodeToPrepend, containerNode.firstChild);
	                else
	                    containerNode.appendChild(nodeToPrepend);
	            } else {
	                // Start comments must always have a parent and at least one following sibling (the end comment)
	                containerNode.parentNode.insertBefore(nodeToPrepend, containerNode.nextSibling);
	            }
	        },
	
	        insertAfter: function(containerNode, nodeToInsert, insertAfterNode) {
	            if (!insertAfterNode) {
	                ko.virtualElements.prepend(containerNode, nodeToInsert);
	            } else if (!isStartComment(containerNode)) {
	                // Insert after insertion point
	                if (insertAfterNode.nextSibling)
	                    containerNode.insertBefore(nodeToInsert, insertAfterNode.nextSibling);
	                else
	                    containerNode.appendChild(nodeToInsert);
	            } else {
	                // Children of start comments must always have a parent and at least one following sibling (the end comment)
	                containerNode.parentNode.insertBefore(nodeToInsert, insertAfterNode.nextSibling);
	            }
	        },
	
	        firstChild: function(node) {
	            if (!isStartComment(node))
	                return node.firstChild;
	            if (!node.nextSibling || isEndComment(node.nextSibling))
	                return null;
	            return node.nextSibling;
	        },
	
	        nextSibling: function(node) {
	            if (isStartComment(node))
	                node = getMatchingEndComment(node);
	            if (node.nextSibling && isEndComment(node.nextSibling))
	                return null;
	            return node.nextSibling;
	        },
	
	        hasBindingValue: isStartComment,
	
	        virtualNodeBindingValue: function(node) {
	            var regexMatch = (commentNodesHaveTextProperty ? node.text : node.nodeValue).match(startCommentRegex);
	            return regexMatch ? regexMatch[1] : null;
	        },
	
	        normaliseVirtualElementDomStructure: function(elementVerified) {
	            // Workaround for https://github.com/SteveSanderson/knockout/issues/155
	            // (IE <= 8 or IE 9 quirks mode parses your HTML weirdly, treating closing </li> tags as if they don't exist, thereby moving comment nodes
	            // that are direct descendants of <ul> into the preceding <li>)
	            if (!htmlTagsWithOptionallyClosingChildren[ko.utils.tagNameLower(elementVerified)])
	                return;
	
	            // Scan immediate children to see if they contain unbalanced comment tags. If they do, those comment tags
	            // must be intended to appear *after* that child, so move them there.
	            var childNode = elementVerified.firstChild;
	            if (childNode) {
	                do {
	                    if (childNode.nodeType === 1) {
	                        var unbalancedTags = getUnbalancedChildTags(childNode);
	                        if (unbalancedTags) {
	                            // Fix up the DOM by moving the unbalanced tags to where they most likely were intended to be placed - *after* the child
	                            var nodeToInsertBefore = childNode.nextSibling;
	                            for (var i = 0; i < unbalancedTags.length; i++) {
	                                if (nodeToInsertBefore)
	                                    elementVerified.insertBefore(unbalancedTags[i], nodeToInsertBefore);
	                                else
	                                    elementVerified.appendChild(unbalancedTags[i]);
	                            }
	                        }
	                    }
	                } while (childNode = childNode.nextSibling);
	            }
	        }
	    };
	})();
	ko.exportSymbol('virtualElements', ko.virtualElements);
	ko.exportSymbol('virtualElements.allowedBindings', ko.virtualElements.allowedBindings);
	ko.exportSymbol('virtualElements.emptyNode', ko.virtualElements.emptyNode);
	//ko.exportSymbol('virtualElements.firstChild', ko.virtualElements.firstChild);     // firstChild is not minified
	ko.exportSymbol('virtualElements.insertAfter', ko.virtualElements.insertAfter);
	//ko.exportSymbol('virtualElements.nextSibling', ko.virtualElements.nextSibling);   // nextSibling is not minified
	ko.exportSymbol('virtualElements.prepend', ko.virtualElements.prepend);
	ko.exportSymbol('virtualElements.setDomNodeChildren', ko.virtualElements.setDomNodeChildren);
	(function() {
	    var defaultBindingAttributeName = "data-bind";
	
	    ko.bindingProvider = function() {
	        this.bindingCache = {};
	    };
	
	    ko.utils.extend(ko.bindingProvider.prototype, {
	        'nodeHasBindings': function(node) {
	            switch (node.nodeType) {
	                case 1: // Element
	                    return node.getAttribute(defaultBindingAttributeName) != null
	                        || ko.components['getComponentNameForNode'](node);
	                case 8: // Comment node
	                    return ko.virtualElements.hasBindingValue(node);
	                default: return false;
	            }
	        },
	
	        'getBindings': function(node, bindingContext) {
	            var bindingsString = this['getBindingsString'](node, bindingContext),
	                parsedBindings = bindingsString ? this['parseBindingsString'](bindingsString, bindingContext, node) : null;
	            return ko.components.addBindingsForCustomElement(parsedBindings, node, bindingContext, /* valueAccessors */ false);
	        },
	
	        'getBindingAccessors': function(node, bindingContext) {
	            var bindingsString = this['getBindingsString'](node, bindingContext),
	                parsedBindings = bindingsString ? this['parseBindingsString'](bindingsString, bindingContext, node, { 'valueAccessors': true }) : null;
	            return ko.components.addBindingsForCustomElement(parsedBindings, node, bindingContext, /* valueAccessors */ true);
	        },
	
	        // The following function is only used internally by this default provider.
	        // It's not part of the interface definition for a general binding provider.
	        'getBindingsString': function(node, bindingContext) {
	            switch (node.nodeType) {
	                case 1: return node.getAttribute(defaultBindingAttributeName);   // Element
	                case 8: return ko.virtualElements.virtualNodeBindingValue(node); // Comment node
	                default: return null;
	            }
	        },
	
	        // The following function is only used internally by this default provider.
	        // It's not part of the interface definition for a general binding provider.
	        'parseBindingsString': function(bindingsString, bindingContext, node, options) {
	            try {
	                var bindingFunction = createBindingsStringEvaluatorViaCache(bindingsString, this.bindingCache, options);
	                return bindingFunction(bindingContext, node);
	            } catch (ex) {
	                ex.message = "Unable to parse bindings.\nBindings value: " + bindingsString + "\nMessage: " + ex.message;
	                throw ex;
	            }
	        }
	    });
	
	    ko.bindingProvider['instance'] = new ko.bindingProvider();
	
	    function createBindingsStringEvaluatorViaCache(bindingsString, cache, options) {
	        var cacheKey = bindingsString + (options && options['valueAccessors'] || '');
	        return cache[cacheKey]
	            || (cache[cacheKey] = createBindingsStringEvaluator(bindingsString, options));
	    }
	
	    function createBindingsStringEvaluator(bindingsString, options) {
	        // Build the source for a function that evaluates "expression"
	        // For each scope variable, add an extra level of "with" nesting
	        // Example result: with(sc1) { with(sc0) { return (expression) } }
	        var rewrittenBindings = ko.expressionRewriting.preProcessBindings(bindingsString, options),
	            functionBody = "with($context){with($data||{}){return{" + rewrittenBindings + "}}}";
	        return new Function("$context", "$element", functionBody);
	    }
	})();
	
	ko.exportSymbol('bindingProvider', ko.bindingProvider);
	(function () {
	    ko.bindingHandlers = {};
	
	    // The following element types will not be recursed into during binding.
	    var bindingDoesNotRecurseIntoElementTypes = {
	        // Don't want bindings that operate on text nodes to mutate <script> and <textarea> contents,
	        // because it's unexpected and a potential XSS issue.
	        // Also bindings should not operate on <template> elements since this breaks in Internet Explorer
	        // and because such elements' contents are always intended to be bound in a different context
	        // from where they appear in the document.
	        'script': true,
	        'textarea': true,
	        'template': true
	    };
	
	    // Use an overridable method for retrieving binding handlers so that a plugins may support dynamically created handlers
	    ko['getBindingHandler'] = function(bindingKey) {
	        return ko.bindingHandlers[bindingKey];
	    };
	
	    // The ko.bindingContext constructor is only called directly to create the root context. For child
	    // contexts, use bindingContext.createChildContext or bindingContext.extend.
	    ko.bindingContext = function(dataItemOrAccessor, parentContext, dataItemAlias, extendCallback) {
	
	        // The binding context object includes static properties for the current, parent, and root view models.
	        // If a view model is actually stored in an observable, the corresponding binding context object, and
	        // any child contexts, must be updated when the view model is changed.
	        function updateContext() {
	            // Most of the time, the context will directly get a view model object, but if a function is given,
	            // we call the function to retrieve the view model. If the function accesses any observables or returns
	            // an observable, the dependency is tracked, and those observables can later cause the binding
	            // context to be updated.
	            var dataItemOrObservable = isFunc ? dataItemOrAccessor() : dataItemOrAccessor,
	                dataItem = ko.utils.unwrapObservable(dataItemOrObservable);
	
	            if (parentContext) {
	                // When a "parent" context is given, register a dependency on the parent context. Thus whenever the
	                // parent context is updated, this context will also be updated.
	                if (parentContext._subscribable)
	                    parentContext._subscribable();
	
	                // Copy $root and any custom properties from the parent context
	                ko.utils.extend(self, parentContext);
	
	                // Because the above copy overwrites our own properties, we need to reset them.
	                // During the first execution, "subscribable" isn't set, so don't bother doing the update then.
	                if (subscribable) {
	                    self._subscribable = subscribable;
	                }
	            } else {
	                self['$parents'] = [];
	                self['$root'] = dataItem;
	
	                // Export 'ko' in the binding context so it will be available in bindings and templates
	                // even if 'ko' isn't exported as a global, such as when using an AMD loader.
	                // See https://github.com/SteveSanderson/knockout/issues/490
	                self['ko'] = ko;
	            }
	            self['$rawData'] = dataItemOrObservable;
	            self['$data'] = dataItem;
	            if (dataItemAlias)
	                self[dataItemAlias] = dataItem;
	
	            // The extendCallback function is provided when creating a child context or extending a context.
	            // It handles the specific actions needed to finish setting up the binding context. Actions in this
	            // function could also add dependencies to this binding context.
	            if (extendCallback)
	                extendCallback(self, parentContext, dataItem);
	
	            return self['$data'];
	        }
	        function disposeWhen() {
	            return nodes && !ko.utils.anyDomNodeIsAttachedToDocument(nodes);
	        }
	
	        var self = this,
	            isFunc = typeof(dataItemOrAccessor) == "function" && !ko.isObservable(dataItemOrAccessor),
	            nodes,
	            subscribable = ko.dependentObservable(updateContext, null, { disposeWhen: disposeWhen, disposeWhenNodeIsRemoved: true });
	
	        // At this point, the binding context has been initialized, and the "subscribable" computed observable is
	        // subscribed to any observables that were accessed in the process. If there is nothing to track, the
	        // computed will be inactive, and we can safely throw it away. If it's active, the computed is stored in
	        // the context object.
	        if (subscribable.isActive()) {
	            self._subscribable = subscribable;
	
	            // Always notify because even if the model ($data) hasn't changed, other context properties might have changed
	            subscribable['equalityComparer'] = null;
	
	            // We need to be able to dispose of this computed observable when it's no longer needed. This would be
	            // easy if we had a single node to watch, but binding contexts can be used by many different nodes, and
	            // we cannot assume that those nodes have any relation to each other. So instead we track any node that
	            // the context is attached to, and dispose the computed when all of those nodes have been cleaned.
	
	            // Add properties to *subscribable* instead of *self* because any properties added to *self* may be overwritten on updates
	            nodes = [];
	            subscribable._addNode = function(node) {
	                nodes.push(node);
	                ko.utils.domNodeDisposal.addDisposeCallback(node, function(node) {
	                    ko.utils.arrayRemoveItem(nodes, node);
	                    if (!nodes.length) {
	                        subscribable.dispose();
	                        self._subscribable = subscribable = undefined;
	                    }
	                });
	            };
	        }
	    }
	
	    // Extend the binding context hierarchy with a new view model object. If the parent context is watching
	    // any observables, the new child context will automatically get a dependency on the parent context.
	    // But this does not mean that the $data value of the child context will also get updated. If the child
	    // view model also depends on the parent view model, you must provide a function that returns the correct
	    // view model on each update.
	    ko.bindingContext.prototype['createChildContext'] = function (dataItemOrAccessor, dataItemAlias, extendCallback) {
	        return new ko.bindingContext(dataItemOrAccessor, this, dataItemAlias, function(self, parentContext) {
	            // Extend the context hierarchy by setting the appropriate pointers
	            self['$parentContext'] = parentContext;
	            self['$parent'] = parentContext['$data'];
	            self['$parents'] = (parentContext['$parents'] || []).slice(0);
	            self['$parents'].unshift(self['$parent']);
	            if (extendCallback)
	                extendCallback(self);
	        });
	    };
	
	    // Extend the binding context with new custom properties. This doesn't change the context hierarchy.
	    // Similarly to "child" contexts, provide a function here to make sure that the correct values are set
	    // when an observable view model is updated.
	    ko.bindingContext.prototype['extend'] = function(properties) {
	        // If the parent context references an observable view model, "_subscribable" will always be the
	        // latest view model object. If not, "_subscribable" isn't set, and we can use the static "$data" value.
	        return new ko.bindingContext(this._subscribable || this['$data'], this, null, function(self, parentContext) {
	            // This "child" context doesn't directly track a parent observable view model,
	            // so we need to manually set the $rawData value to match the parent.
	            self['$rawData'] = parentContext['$rawData'];
	            ko.utils.extend(self, typeof(properties) == "function" ? properties() : properties);
	        });
	    };
	
	    // Returns the valueAccesor function for a binding value
	    function makeValueAccessor(value) {
	        return function() {
	            return value;
	        };
	    }
	
	    // Returns the value of a valueAccessor function
	    function evaluateValueAccessor(valueAccessor) {
	        return valueAccessor();
	    }
	
	    // Given a function that returns bindings, create and return a new object that contains
	    // binding value-accessors functions. Each accessor function calls the original function
	    // so that it always gets the latest value and all dependencies are captured. This is used
	    // by ko.applyBindingsToNode and getBindingsAndMakeAccessors.
	    function makeAccessorsFromFunction(callback) {
	        return ko.utils.objectMap(ko.dependencyDetection.ignore(callback), function(value, key) {
	            return function() {
	                return callback()[key];
	            };
	        });
	    }
	
	    // Given a bindings function or object, create and return a new object that contains
	    // binding value-accessors functions. This is used by ko.applyBindingsToNode.
	    function makeBindingAccessors(bindings, context, node) {
	        if (typeof bindings === 'function') {
	            return makeAccessorsFromFunction(bindings.bind(null, context, node));
	        } else {
	            return ko.utils.objectMap(bindings, makeValueAccessor);
	        }
	    }
	
	    // This function is used if the binding provider doesn't include a getBindingAccessors function.
	    // It must be called with 'this' set to the provider instance.
	    function getBindingsAndMakeAccessors(node, context) {
	        return makeAccessorsFromFunction(this['getBindings'].bind(this, node, context));
	    }
	
	    function validateThatBindingIsAllowedForVirtualElements(bindingName) {
	        var validator = ko.virtualElements.allowedBindings[bindingName];
	        if (!validator)
	            throw new Error("The binding '" + bindingName + "' cannot be used with virtual elements")
	    }
	
	    function applyBindingsToDescendantsInternal (bindingContext, elementOrVirtualElement, bindingContextsMayDifferFromDomParentElement) {
	        var currentChild,
	            nextInQueue = ko.virtualElements.firstChild(elementOrVirtualElement),
	            provider = ko.bindingProvider['instance'],
	            preprocessNode = provider['preprocessNode'];
	
	        // Preprocessing allows a binding provider to mutate a node before bindings are applied to it. For example it's
	        // possible to insert new siblings after it, and/or replace the node with a different one. This can be used to
	        // implement custom binding syntaxes, such as {{ value }} for string interpolation, or custom element types that
	        // trigger insertion of <template> contents at that point in the document.
	        if (preprocessNode) {
	            while (currentChild = nextInQueue) {
	                nextInQueue = ko.virtualElements.nextSibling(currentChild);
	                preprocessNode.call(provider, currentChild);
	            }
	            // Reset nextInQueue for the next loop
	            nextInQueue = ko.virtualElements.firstChild(elementOrVirtualElement);
	        }
	
	        while (currentChild = nextInQueue) {
	            // Keep a record of the next child *before* applying bindings, in case the binding removes the current child from its position
	            nextInQueue = ko.virtualElements.nextSibling(currentChild);
	            applyBindingsToNodeAndDescendantsInternal(bindingContext, currentChild, bindingContextsMayDifferFromDomParentElement);
	        }
	    }
	
	    function applyBindingsToNodeAndDescendantsInternal (bindingContext, nodeVerified, bindingContextMayDifferFromDomParentElement) {
	        var shouldBindDescendants = true;
	
	        // Perf optimisation: Apply bindings only if...
	        // (1) We need to store the binding context on this node (because it may differ from the DOM parent node's binding context)
	        //     Note that we can't store binding contexts on non-elements (e.g., text nodes), as IE doesn't allow expando properties for those
	        // (2) It might have bindings (e.g., it has a data-bind attribute, or it's a marker for a containerless template)
	        var isElement = (nodeVerified.nodeType === 1);
	        if (isElement) // Workaround IE <= 8 HTML parsing weirdness
	            ko.virtualElements.normaliseVirtualElementDomStructure(nodeVerified);
	
	        var shouldApplyBindings = (isElement && bindingContextMayDifferFromDomParentElement)             // Case (1)
	                               || ko.bindingProvider['instance']['nodeHasBindings'](nodeVerified);       // Case (2)
	        if (shouldApplyBindings)
	            shouldBindDescendants = applyBindingsToNodeInternal(nodeVerified, null, bindingContext, bindingContextMayDifferFromDomParentElement)['shouldBindDescendants'];
	
	        if (shouldBindDescendants && !bindingDoesNotRecurseIntoElementTypes[ko.utils.tagNameLower(nodeVerified)]) {
	            // We're recursing automatically into (real or virtual) child nodes without changing binding contexts. So,
	            //  * For children of a *real* element, the binding context is certainly the same as on their DOM .parentNode,
	            //    hence bindingContextsMayDifferFromDomParentElement is false
	            //  * For children of a *virtual* element, we can't be sure. Evaluating .parentNode on those children may
	            //    skip over any number of intermediate virtual elements, any of which might define a custom binding context,
	            //    hence bindingContextsMayDifferFromDomParentElement is true
	            applyBindingsToDescendantsInternal(bindingContext, nodeVerified, /* bindingContextsMayDifferFromDomParentElement: */ !isElement);
	        }
	    }
	
	    var boundElementDomDataKey = ko.utils.domData.nextKey();
	
	
	    function topologicalSortBindings(bindings) {
	        // Depth-first sort
	        var result = [],                // The list of key/handler pairs that we will return
	            bindingsConsidered = {},    // A temporary record of which bindings are already in 'result'
	            cyclicDependencyStack = []; // Keeps track of a depth-search so that, if there's a cycle, we know which bindings caused it
	        ko.utils.objectForEach(bindings, function pushBinding(bindingKey) {
	            if (!bindingsConsidered[bindingKey]) {
	                var binding = ko['getBindingHandler'](bindingKey);
	                if (binding) {
	                    // First add dependencies (if any) of the current binding
	                    if (binding['after']) {
	                        cyclicDependencyStack.push(bindingKey);
	                        ko.utils.arrayForEach(binding['after'], function(bindingDependencyKey) {
	                            if (bindings[bindingDependencyKey]) {
	                                if (ko.utils.arrayIndexOf(cyclicDependencyStack, bindingDependencyKey) !== -1) {
	                                    throw Error("Cannot combine the following bindings, because they have a cyclic dependency: " + cyclicDependencyStack.join(", "));
	                                } else {
	                                    pushBinding(bindingDependencyKey);
	                                }
	                            }
	                        });
	                        cyclicDependencyStack.length--;
	                    }
	                    // Next add the current binding
	                    result.push({ key: bindingKey, handler: binding });
	                }
	                bindingsConsidered[bindingKey] = true;
	            }
	        });
	
	        return result;
	    }
	
	    function applyBindingsToNodeInternal(node, sourceBindings, bindingContext, bindingContextMayDifferFromDomParentElement) {
	        // Prevent multiple applyBindings calls for the same node, except when a binding value is specified
	        var alreadyBound = ko.utils.domData.get(node, boundElementDomDataKey);
	        if (!sourceBindings) {
	            if (alreadyBound) {
	                throw Error("You cannot apply bindings multiple times to the same element.");
	            }
	            ko.utils.domData.set(node, boundElementDomDataKey, true);
	        }
	
	        // Optimization: Don't store the binding context on this node if it's definitely the same as on node.parentNode, because
	        // we can easily recover it just by scanning up the node's ancestors in the DOM
	        // (note: here, parent node means "real DOM parent" not "virtual parent", as there's no O(1) way to find the virtual parent)
	        if (!alreadyBound && bindingContextMayDifferFromDomParentElement)
	            ko.storedBindingContextForNode(node, bindingContext);
	
	        // Use bindings if given, otherwise fall back on asking the bindings provider to give us some bindings
	        var bindings;
	        if (sourceBindings && typeof sourceBindings !== 'function') {
	            bindings = sourceBindings;
	        } else {
	            var provider = ko.bindingProvider['instance'],
	                getBindings = provider['getBindingAccessors'] || getBindingsAndMakeAccessors;
	
	            // Get the binding from the provider within a computed observable so that we can update the bindings whenever
	            // the binding context is updated or if the binding provider accesses observables.
	            var bindingsUpdater = ko.dependentObservable(
	                function() {
	                    bindings = sourceBindings ? sourceBindings(bindingContext, node) : getBindings.call(provider, node, bindingContext);
	                    // Register a dependency on the binding context to support observable view models.
	                    if (bindings && bindingContext._subscribable)
	                        bindingContext._subscribable();
	                    return bindings;
	                },
	                null, { disposeWhenNodeIsRemoved: node }
	            );
	
	            if (!bindings || !bindingsUpdater.isActive())
	                bindingsUpdater = null;
	        }
	
	        var bindingHandlerThatControlsDescendantBindings;
	        if (bindings) {
	            // Return the value accessor for a given binding. When bindings are static (won't be updated because of a binding
	            // context update), just return the value accessor from the binding. Otherwise, return a function that always gets
	            // the latest binding value and registers a dependency on the binding updater.
	            var getValueAccessor = bindingsUpdater
	                ? function(bindingKey) {
	                    return function() {
	                        return evaluateValueAccessor(bindingsUpdater()[bindingKey]);
	                    };
	                } : function(bindingKey) {
	                    return bindings[bindingKey];
	                };
	
	            // Use of allBindings as a function is maintained for backwards compatibility, but its use is deprecated
	            function allBindings() {
	                return ko.utils.objectMap(bindingsUpdater ? bindingsUpdater() : bindings, evaluateValueAccessor);
	            }
	            // The following is the 3.x allBindings API
	            allBindings['get'] = function(key) {
	                return bindings[key] && evaluateValueAccessor(getValueAccessor(key));
	            };
	            allBindings['has'] = function(key) {
	                return key in bindings;
	            };
	
	            // First put the bindings into the right order
	            var orderedBindings = topologicalSortBindings(bindings);
	
	            // Go through the sorted bindings, calling init and update for each
	            ko.utils.arrayForEach(orderedBindings, function(bindingKeyAndHandler) {
	                // Note that topologicalSortBindings has already filtered out any nonexistent binding handlers,
	                // so bindingKeyAndHandler.handler will always be nonnull.
	                var handlerInitFn = bindingKeyAndHandler.handler["init"],
	                    handlerUpdateFn = bindingKeyAndHandler.handler["update"],
	                    bindingKey = bindingKeyAndHandler.key;
	
	                if (node.nodeType === 8) {
	                    validateThatBindingIsAllowedForVirtualElements(bindingKey);
	                }
	
	                try {
	                    // Run init, ignoring any dependencies
	                    if (typeof handlerInitFn == "function") {
	                        ko.dependencyDetection.ignore(function() {
	                            var initResult = handlerInitFn(node, getValueAccessor(bindingKey), allBindings, bindingContext['$data'], bindingContext);
	
	                            // If this binding handler claims to control descendant bindings, make a note of this
	                            if (initResult && initResult['controlsDescendantBindings']) {
	                                if (bindingHandlerThatControlsDescendantBindings !== undefined)
	                                    throw new Error("Multiple bindings (" + bindingHandlerThatControlsDescendantBindings + " and " + bindingKey + ") are trying to control descendant bindings of the same element. You cannot use these bindings together on the same element.");
	                                bindingHandlerThatControlsDescendantBindings = bindingKey;
	                            }
	                        });
	                    }
	
	                    // Run update in its own computed wrapper
	                    if (typeof handlerUpdateFn == "function") {
	                        ko.dependentObservable(
	                            function() {
	                                handlerUpdateFn(node, getValueAccessor(bindingKey), allBindings, bindingContext['$data'], bindingContext);
	                            },
	                            null,
	                            { disposeWhenNodeIsRemoved: node }
	                        );
	                    }
	                } catch (ex) {
	                    ex.message = "Unable to process binding \"" + bindingKey + ": " + bindings[bindingKey] + "\"\nMessage: " + ex.message;
	                    throw ex;
	                }
	            });
	        }
	
	        return {
	            'shouldBindDescendants': bindingHandlerThatControlsDescendantBindings === undefined
	        };
	    };
	
	    var storedBindingContextDomDataKey = ko.utils.domData.nextKey();
	    ko.storedBindingContextForNode = function (node, bindingContext) {
	        if (arguments.length == 2) {
	            ko.utils.domData.set(node, storedBindingContextDomDataKey, bindingContext);
	            if (bindingContext._subscribable)
	                bindingContext._subscribable._addNode(node);
	        } else {
	            return ko.utils.domData.get(node, storedBindingContextDomDataKey);
	        }
	    }
	
	    function getBindingContext(viewModelOrBindingContext) {
	        return viewModelOrBindingContext && (viewModelOrBindingContext instanceof ko.bindingContext)
	            ? viewModelOrBindingContext
	            : new ko.bindingContext(viewModelOrBindingContext);
	    }
	
	    ko.applyBindingAccessorsToNode = function (node, bindings, viewModelOrBindingContext) {
	        if (node.nodeType === 1) // If it's an element, workaround IE <= 8 HTML parsing weirdness
	            ko.virtualElements.normaliseVirtualElementDomStructure(node);
	        return applyBindingsToNodeInternal(node, bindings, getBindingContext(viewModelOrBindingContext), true);
	    };
	
	    ko.applyBindingsToNode = function (node, bindings, viewModelOrBindingContext) {
	        var context = getBindingContext(viewModelOrBindingContext);
	        return ko.applyBindingAccessorsToNode(node, makeBindingAccessors(bindings, context, node), context);
	    };
	
	    ko.applyBindingsToDescendants = function(viewModelOrBindingContext, rootNode) {
	        if (rootNode.nodeType === 1 || rootNode.nodeType === 8)
	            applyBindingsToDescendantsInternal(getBindingContext(viewModelOrBindingContext), rootNode, true);
	    };
	
	    ko.applyBindings = function (viewModelOrBindingContext, rootNode) {
	        // If jQuery is loaded after Knockout, we won't initially have access to it. So save it here.
	        if (!jQueryInstance && window['jQuery']) {
	            jQueryInstance = window['jQuery'];
	        }
	
	        if (rootNode && (rootNode.nodeType !== 1) && (rootNode.nodeType !== 8))
	            throw new Error("ko.applyBindings: first parameter should be your view model; second parameter should be a DOM node");
	        rootNode = rootNode || window.document.body; // Make "rootNode" parameter optional
	
	        applyBindingsToNodeAndDescendantsInternal(getBindingContext(viewModelOrBindingContext), rootNode, true);
	    };
	
	    // Retrieving binding context from arbitrary nodes
	    ko.contextFor = function(node) {
	        // We can only do something meaningful for elements and comment nodes (in particular, not text nodes, as IE can't store domdata for them)
	        switch (node.nodeType) {
	            case 1:
	            case 8:
	                var context = ko.storedBindingContextForNode(node);
	                if (context) return context;
	                if (node.parentNode) return ko.contextFor(node.parentNode);
	                break;
	        }
	        return undefined;
	    };
	    ko.dataFor = function(node) {
	        var context = ko.contextFor(node);
	        return context ? context['$data'] : undefined;
	    };
	
	    ko.exportSymbol('bindingHandlers', ko.bindingHandlers);
	    ko.exportSymbol('applyBindings', ko.applyBindings);
	    ko.exportSymbol('applyBindingsToDescendants', ko.applyBindingsToDescendants);
	    ko.exportSymbol('applyBindingAccessorsToNode', ko.applyBindingAccessorsToNode);
	    ko.exportSymbol('applyBindingsToNode', ko.applyBindingsToNode);
	    ko.exportSymbol('contextFor', ko.contextFor);
	    ko.exportSymbol('dataFor', ko.dataFor);
	})();
	(function(undefined) {
	    var loadingSubscribablesCache = {}, // Tracks component loads that are currently in flight
	        loadedDefinitionsCache = {};    // Tracks component loads that have already completed
	
	    ko.components = {
	        get: function(componentName, callback) {
	            var cachedDefinition = getObjectOwnProperty(loadedDefinitionsCache, componentName);
	            if (cachedDefinition) {
	                // It's already loaded and cached. Reuse the same definition object.
	                // Note that for API consistency, even cache hits complete asynchronously by default.
	                // You can bypass this by putting synchronous:true on your component config.
	                if (cachedDefinition.isSynchronousComponent) {
	                    ko.dependencyDetection.ignore(function() { // See comment in loaderRegistryBehaviors.js for reasoning
	                        callback(cachedDefinition.definition);
	                    });
	                } else {
	                    ko.tasks.schedule(function() { callback(cachedDefinition.definition); });
	                }
	            } else {
	                // Join the loading process that is already underway, or start a new one.
	                loadComponentAndNotify(componentName, callback);
	            }
	        },
	
	        clearCachedDefinition: function(componentName) {
	            delete loadedDefinitionsCache[componentName];
	        },
	
	        _getFirstResultFromLoaders: getFirstResultFromLoaders
	    };
	
	    function getObjectOwnProperty(obj, propName) {
	        return obj.hasOwnProperty(propName) ? obj[propName] : undefined;
	    }
	
	    function loadComponentAndNotify(componentName, callback) {
	        var subscribable = getObjectOwnProperty(loadingSubscribablesCache, componentName),
	            completedAsync;
	        if (!subscribable) {
	            // It's not started loading yet. Start loading, and when it's done, move it to loadedDefinitionsCache.
	            subscribable = loadingSubscribablesCache[componentName] = new ko.subscribable();
	            subscribable.subscribe(callback);
	
	            beginLoadingComponent(componentName, function(definition, config) {
	                var isSynchronousComponent = !!(config && config['synchronous']);
	                loadedDefinitionsCache[componentName] = { definition: definition, isSynchronousComponent: isSynchronousComponent };
	                delete loadingSubscribablesCache[componentName];
	
	                // For API consistency, all loads complete asynchronously. However we want to avoid
	                // adding an extra task schedule if it's unnecessary (i.e., the completion is already
	                // async).
	                //
	                // You can bypass the 'always asynchronous' feature by putting the synchronous:true
	                // flag on your component configuration when you register it.
	                if (completedAsync || isSynchronousComponent) {
	                    // Note that notifySubscribers ignores any dependencies read within the callback.
	                    // See comment in loaderRegistryBehaviors.js for reasoning
	                    subscribable['notifySubscribers'](definition);
	                } else {
	                    ko.tasks.schedule(function() {
	                        subscribable['notifySubscribers'](definition);
	                    });
	                }
	            });
	            completedAsync = true;
	        } else {
	            subscribable.subscribe(callback);
	        }
	    }
	
	    function beginLoadingComponent(componentName, callback) {
	        getFirstResultFromLoaders('getConfig', [componentName], function(config) {
	            if (config) {
	                // We have a config, so now load its definition
	                getFirstResultFromLoaders('loadComponent', [componentName, config], function(definition) {
	                    callback(definition, config);
	                });
	            } else {
	                // The component has no config - it's unknown to all the loaders.
	                // Note that this is not an error (e.g., a module loading error) - that would abort the
	                // process and this callback would not run. For this callback to run, all loaders must
	                // have confirmed they don't know about this component.
	                callback(null, null);
	            }
	        });
	    }
	
	    function getFirstResultFromLoaders(methodName, argsExceptCallback, callback, candidateLoaders) {
	        // On the first call in the stack, start with the full set of loaders
	        if (!candidateLoaders) {
	            candidateLoaders = ko.components['loaders'].slice(0); // Use a copy, because we'll be mutating this array
	        }
	
	        // Try the next candidate
	        var currentCandidateLoader = candidateLoaders.shift();
	        if (currentCandidateLoader) {
	            var methodInstance = currentCandidateLoader[methodName];
	            if (methodInstance) {
	                var wasAborted = false,
	                    synchronousReturnValue = methodInstance.apply(currentCandidateLoader, argsExceptCallback.concat(function(result) {
	                        if (wasAborted) {
	                            callback(null);
	                        } else if (result !== null) {
	                            // This candidate returned a value. Use it.
	                            callback(result);
	                        } else {
	                            // Try the next candidate
	                            getFirstResultFromLoaders(methodName, argsExceptCallback, callback, candidateLoaders);
	                        }
	                    }));
	
	                // Currently, loaders may not return anything synchronously. This leaves open the possibility
	                // that we'll extend the API to support synchronous return values in the future. It won't be
	                // a breaking change, because currently no loader is allowed to return anything except undefined.
	                if (synchronousReturnValue !== undefined) {
	                    wasAborted = true;
	
	                    // Method to suppress exceptions will remain undocumented. This is only to keep
	                    // KO's specs running tidily, since we can observe the loading got aborted without
	                    // having exceptions cluttering up the console too.
	                    if (!currentCandidateLoader['suppressLoaderExceptions']) {
	                        throw new Error('Component loaders must supply values by invoking the callback, not by returning values synchronously.');
	                    }
	                }
	            } else {
	                // This candidate doesn't have the relevant handler. Synchronously move on to the next one.
	                getFirstResultFromLoaders(methodName, argsExceptCallback, callback, candidateLoaders);
	            }
	        } else {
	            // No candidates returned a value
	            callback(null);
	        }
	    }
	
	    // Reference the loaders via string name so it's possible for developers
	    // to replace the whole array by assigning to ko.components.loaders
	    ko.components['loaders'] = [];
	
	    ko.exportSymbol('components', ko.components);
	    ko.exportSymbol('components.get', ko.components.get);
	    ko.exportSymbol('components.clearCachedDefinition', ko.components.clearCachedDefinition);
	})();
	(function(undefined) {
	
	    // The default loader is responsible for two things:
	    // 1. Maintaining the default in-memory registry of component configuration objects
	    //    (i.e., the thing you're writing to when you call ko.components.register(someName, ...))
	    // 2. Answering requests for components by fetching configuration objects
	    //    from that default in-memory registry and resolving them into standard
	    //    component definition objects (of the form { createViewModel: ..., template: ... })
	    // Custom loaders may override either of these facilities, i.e.,
	    // 1. To supply configuration objects from some other source (e.g., conventions)
	    // 2. Or, to resolve configuration objects by loading viewmodels/templates via arbitrary logic.
	
	    var defaultConfigRegistry = {};
	
	    ko.components.register = function(componentName, config) {
	        if (!config) {
	            throw new Error('Invalid configuration for ' + componentName);
	        }
	
	        if (ko.components.isRegistered(componentName)) {
	            throw new Error('Component ' + componentName + ' is already registered');
	        }
	
	        defaultConfigRegistry[componentName] = config;
	    };
	
	    ko.components.isRegistered = function(componentName) {
	        return defaultConfigRegistry.hasOwnProperty(componentName);
	    };
	
	    ko.components.unregister = function(componentName) {
	        delete defaultConfigRegistry[componentName];
	        ko.components.clearCachedDefinition(componentName);
	    };
	
	    ko.components.defaultLoader = {
	        'getConfig': function(componentName, callback) {
	            var result = defaultConfigRegistry.hasOwnProperty(componentName)
	                ? defaultConfigRegistry[componentName]
	                : null;
	            callback(result);
	        },
	
	        'loadComponent': function(componentName, config, callback) {
	            var errorCallback = makeErrorCallback(componentName);
	            possiblyGetConfigFromAmd(errorCallback, config, function(loadedConfig) {
	                resolveConfig(componentName, errorCallback, loadedConfig, callback);
	            });
	        },
	
	        'loadTemplate': function(componentName, templateConfig, callback) {
	            resolveTemplate(makeErrorCallback(componentName), templateConfig, callback);
	        },
	
	        'loadViewModel': function(componentName, viewModelConfig, callback) {
	            resolveViewModel(makeErrorCallback(componentName), viewModelConfig, callback);
	        }
	    };
	
	    var createViewModelKey = 'createViewModel';
	
	    // Takes a config object of the form { template: ..., viewModel: ... }, and asynchronously convert it
	    // into the standard component definition format:
	    //    { template: <ArrayOfDomNodes>, createViewModel: function(params, componentInfo) { ... } }.
	    // Since both template and viewModel may need to be resolved asynchronously, both tasks are performed
	    // in parallel, and the results joined when both are ready. We don't depend on any promises infrastructure,
	    // so this is implemented manually below.
	    function resolveConfig(componentName, errorCallback, config, callback) {
	        var result = {},
	            makeCallBackWhenZero = 2,
	            tryIssueCallback = function() {
	                if (--makeCallBackWhenZero === 0) {
	                    callback(result);
	                }
	            },
	            templateConfig = config['template'],
	            viewModelConfig = config['viewModel'];
	
	        if (templateConfig) {
	            possiblyGetConfigFromAmd(errorCallback, templateConfig, function(loadedConfig) {
	                ko.components._getFirstResultFromLoaders('loadTemplate', [componentName, loadedConfig], function(resolvedTemplate) {
	                    result['template'] = resolvedTemplate;
	                    tryIssueCallback();
	                });
	            });
	        } else {
	            tryIssueCallback();
	        }
	
	        if (viewModelConfig) {
	            possiblyGetConfigFromAmd(errorCallback, viewModelConfig, function(loadedConfig) {
	                ko.components._getFirstResultFromLoaders('loadViewModel', [componentName, loadedConfig], function(resolvedViewModel) {
	                    result[createViewModelKey] = resolvedViewModel;
	                    tryIssueCallback();
	                });
	            });
	        } else {
	            tryIssueCallback();
	        }
	    }
	
	    function resolveTemplate(errorCallback, templateConfig, callback) {
	        if (typeof templateConfig === 'string') {
	            // Markup - parse it
	            callback(ko.utils.parseHtmlFragment(templateConfig));
	        } else if (templateConfig instanceof Array) {
	            // Assume already an array of DOM nodes - pass through unchanged
	            callback(templateConfig);
	        } else if (isDocumentFragment(templateConfig)) {
	            // Document fragment - use its child nodes
	            callback(ko.utils.makeArray(templateConfig.childNodes));
	        } else if (templateConfig['element']) {
	            var element = templateConfig['element'];
	            if (isDomElement(element)) {
	                // Element instance - copy its child nodes
	                callback(cloneNodesFromTemplateSourceElement(element));
	            } else if (typeof element === 'string') {
	                // Element ID - find it, then copy its child nodes
	                var elemInstance = document.getElementById(element);
	                if (elemInstance) {
	                    callback(cloneNodesFromTemplateSourceElement(elemInstance));
	                } else {
	                    errorCallback('Cannot find element with ID ' + element);
	                }
	            } else {
	                errorCallback('Unknown element type: ' + element);
	            }
	        } else {
	            errorCallback('Unknown template value: ' + templateConfig);
	        }
	    }
	
	    function resolveViewModel(errorCallback, viewModelConfig, callback) {
	        if (typeof viewModelConfig === 'function') {
	            // Constructor - convert to standard factory function format
	            // By design, this does *not* supply componentInfo to the constructor, as the intent is that
	            // componentInfo contains non-viewmodel data (e.g., the component's element) that should only
	            // be used in factory functions, not viewmodel constructors.
	            callback(function (params /*, componentInfo */) {
	                return new viewModelConfig(params);
	            });
	        } else if (typeof viewModelConfig[createViewModelKey] === 'function') {
	            // Already a factory function - use it as-is
	            callback(viewModelConfig[createViewModelKey]);
	        } else if ('instance' in viewModelConfig) {
	            // Fixed object instance - promote to createViewModel format for API consistency
	            var fixedInstance = viewModelConfig['instance'];
	            callback(function (params, componentInfo) {
	                return fixedInstance;
	            });
	        } else if ('viewModel' in viewModelConfig) {
	            // Resolved AMD module whose value is of the form { viewModel: ... }
	            resolveViewModel(errorCallback, viewModelConfig['viewModel'], callback);
	        } else {
	            errorCallback('Unknown viewModel value: ' + viewModelConfig);
	        }
	    }
	
	    function cloneNodesFromTemplateSourceElement(elemInstance) {
	        switch (ko.utils.tagNameLower(elemInstance)) {
	            case 'script':
	                return ko.utils.parseHtmlFragment(elemInstance.text);
	            case 'textarea':
	                return ko.utils.parseHtmlFragment(elemInstance.value);
	            case 'template':
	                // For browsers with proper <template> element support (i.e., where the .content property
	                // gives a document fragment), use that document fragment.
	                if (isDocumentFragment(elemInstance.content)) {
	                    return ko.utils.cloneNodes(elemInstance.content.childNodes);
	                }
	        }
	
	        // Regular elements such as <div>, and <template> elements on old browsers that don't really
	        // understand <template> and just treat it as a regular container
	        return ko.utils.cloneNodes(elemInstance.childNodes);
	    }
	
	    function isDomElement(obj) {
	        if (window['HTMLElement']) {
	            return obj instanceof HTMLElement;
	        } else {
	            return obj && obj.tagName && obj.nodeType === 1;
	        }
	    }
	
	    function isDocumentFragment(obj) {
	        if (window['DocumentFragment']) {
	            return obj instanceof DocumentFragment;
	        } else {
	            return obj && obj.nodeType === 11;
	        }
	    }
	
	    function possiblyGetConfigFromAmd(errorCallback, config, callback) {
	        if (typeof config['require'] === 'string') {
	            // The config is the value of an AMD module
	            if (amdRequire || window['require']) {
	                (amdRequire || window['require'])([config['require']], callback);
	            } else {
	                errorCallback('Uses require, but no AMD loader is present');
	            }
	        } else {
	            callback(config);
	        }
	    }
	
	    function makeErrorCallback(componentName) {
	        return function (message) {
	            throw new Error('Component \'' + componentName + '\': ' + message);
	        };
	    }
	
	    ko.exportSymbol('components.register', ko.components.register);
	    ko.exportSymbol('components.isRegistered', ko.components.isRegistered);
	    ko.exportSymbol('components.unregister', ko.components.unregister);
	
	    // Expose the default loader so that developers can directly ask it for configuration
	    // or to resolve configuration
	    ko.exportSymbol('components.defaultLoader', ko.components.defaultLoader);
	
	    // By default, the default loader is the only registered component loader
	    ko.components['loaders'].push(ko.components.defaultLoader);
	
	    // Privately expose the underlying config registry for use in old-IE shim
	    ko.components._allRegisteredComponents = defaultConfigRegistry;
	})();
	(function (undefined) {
	    // Overridable API for determining which component name applies to a given node. By overriding this,
	    // you can for example map specific tagNames to components that are not preregistered.
	    ko.components['getComponentNameForNode'] = function(node) {
	        var tagNameLower = ko.utils.tagNameLower(node);
	        if (ko.components.isRegistered(tagNameLower)) {
	            // Try to determine that this node can be considered a *custom* element; see https://github.com/knockout/knockout/issues/1603
	            if (tagNameLower.indexOf('-') != -1 || ('' + node) == "[object HTMLUnknownElement]" || (ko.utils.ieVersion <= 8 && node.tagName === tagNameLower)) {
	                return tagNameLower;
	            }
	        }
	    };
	
	    ko.components.addBindingsForCustomElement = function(allBindings, node, bindingContext, valueAccessors) {
	        // Determine if it's really a custom element matching a component
	        if (node.nodeType === 1) {
	            var componentName = ko.components['getComponentNameForNode'](node);
	            if (componentName) {
	                // It does represent a component, so add a component binding for it
	                allBindings = allBindings || {};
	
	                if (allBindings['component']) {
	                    // Avoid silently overwriting some other 'component' binding that may already be on the element
	                    throw new Error('Cannot use the "component" binding on a custom element matching a component');
	                }
	
	                var componentBindingValue = { 'name': componentName, 'params': getComponentParamsFromCustomElement(node, bindingContext) };
	
	                allBindings['component'] = valueAccessors
	                    ? function() { return componentBindingValue; }
	                    : componentBindingValue;
	            }
	        }
	
	        return allBindings;
	    }
	
	    var nativeBindingProviderInstance = new ko.bindingProvider();
	
	    function getComponentParamsFromCustomElement(elem, bindingContext) {
	        var paramsAttribute = elem.getAttribute('params');
	
	        if (paramsAttribute) {
	            var params = nativeBindingProviderInstance['parseBindingsString'](paramsAttribute, bindingContext, elem, { 'valueAccessors': true, 'bindingParams': true }),
	                rawParamComputedValues = ko.utils.objectMap(params, function(paramValue, paramName) {
	                    return ko.computed(paramValue, null, { disposeWhenNodeIsRemoved: elem });
	                }),
	                result = ko.utils.objectMap(rawParamComputedValues, function(paramValueComputed, paramName) {
	                    var paramValue = paramValueComputed.peek();
	                    // Does the evaluation of the parameter value unwrap any observables?
	                    if (!paramValueComputed.isActive()) {
	                        // No it doesn't, so there's no need for any computed wrapper. Just pass through the supplied value directly.
	                        // Example: "someVal: firstName, age: 123" (whether or not firstName is an observable/computed)
	                        return paramValue;
	                    } else {
	                        // Yes it does. Supply a computed property that unwraps both the outer (binding expression)
	                        // level of observability, and any inner (resulting model value) level of observability.
	                        // This means the component doesn't have to worry about multiple unwrapping. If the value is a
	                        // writable observable, the computed will also be writable and pass the value on to the observable.
	                        return ko.computed({
	                            'read': function() {
	                                return ko.utils.unwrapObservable(paramValueComputed());
	                            },
	                            'write': ko.isWriteableObservable(paramValue) && function(value) {
	                                paramValueComputed()(value);
	                            },
	                            disposeWhenNodeIsRemoved: elem
	                        });
	                    }
	                });
	
	            // Give access to the raw computeds, as long as that wouldn't overwrite any custom param also called '$raw'
	            // This is in case the developer wants to react to outer (binding) observability separately from inner
	            // (model value) observability, or in case the model value observable has subobservables.
	            if (!result.hasOwnProperty('$raw')) {
	                result['$raw'] = rawParamComputedValues;
	            }
	
	            return result;
	        } else {
	            // For consistency, absence of a "params" attribute is treated the same as the presence of
	            // any empty one. Otherwise component viewmodels need special code to check whether or not
	            // 'params' or 'params.$raw' is null/undefined before reading subproperties, which is annoying.
	            return { '$raw': {} };
	        }
	    }
	
	    // --------------------------------------------------------------------------------
	    // Compatibility code for older (pre-HTML5) IE browsers
	
	    if (ko.utils.ieVersion < 9) {
	        // Whenever you preregister a component, enable it as a custom element in the current document
	        ko.components['register'] = (function(originalFunction) {
	            return function(componentName) {
	                document.createElement(componentName); // Allows IE<9 to parse markup containing the custom element
	                return originalFunction.apply(this, arguments);
	            }
	        })(ko.components['register']);
	
	        // Whenever you create a document fragment, enable all preregistered component names as custom elements
	        // This is needed to make innerShiv/jQuery HTML parsing correctly handle the custom elements
	        document.createDocumentFragment = (function(originalFunction) {
	            return function() {
	                var newDocFrag = originalFunction(),
	                    allComponents = ko.components._allRegisteredComponents;
	                for (var componentName in allComponents) {
	                    if (allComponents.hasOwnProperty(componentName)) {
	                        newDocFrag.createElement(componentName);
	                    }
	                }
	                return newDocFrag;
	            };
	        })(document.createDocumentFragment);
	    }
	})();(function(undefined) {
	
	    var componentLoadingOperationUniqueId = 0;
	
	    ko.bindingHandlers['component'] = {
	        'init': function(element, valueAccessor, ignored1, ignored2, bindingContext) {
	            var currentViewModel,
	                currentLoadingOperationId,
	                disposeAssociatedComponentViewModel = function () {
	                    var currentViewModelDispose = currentViewModel && currentViewModel['dispose'];
	                    if (typeof currentViewModelDispose === 'function') {
	                        currentViewModelDispose.call(currentViewModel);
	                    }
	                    currentViewModel = null;
	                    // Any in-flight loading operation is no longer relevant, so make sure we ignore its completion
	                    currentLoadingOperationId = null;
	                },
	                originalChildNodes = ko.utils.makeArray(ko.virtualElements.childNodes(element));
	
	            ko.utils.domNodeDisposal.addDisposeCallback(element, disposeAssociatedComponentViewModel);
	
	            ko.computed(function () {
	                var value = ko.utils.unwrapObservable(valueAccessor()),
	                    componentName, componentParams;
	
	                if (typeof value === 'string') {
	                    componentName = value;
	                } else {
	                    componentName = ko.utils.unwrapObservable(value['name']);
	                    componentParams = ko.utils.unwrapObservable(value['params']);
	                }
	
	                if (!componentName) {
	                    throw new Error('No component name specified');
	                }
	
	                var loadingOperationId = currentLoadingOperationId = ++componentLoadingOperationUniqueId;
	                ko.components.get(componentName, function(componentDefinition) {
	                    // If this is not the current load operation for this element, ignore it.
	                    if (currentLoadingOperationId !== loadingOperationId) {
	                        return;
	                    }
	
	                    // Clean up previous state
	                    disposeAssociatedComponentViewModel();
	
	                    // Instantiate and bind new component. Implicitly this cleans any old DOM nodes.
	                    if (!componentDefinition) {
	                        throw new Error('Unknown component \'' + componentName + '\'');
	                    }
	                    cloneTemplateIntoElement(componentName, componentDefinition, element);
	                    var componentViewModel = createViewModel(componentDefinition, element, originalChildNodes, componentParams),
	                        childBindingContext = bindingContext['createChildContext'](componentViewModel, /* dataItemAlias */ undefined, function(ctx) {
	                            ctx['$component'] = componentViewModel;
	                            ctx['$componentTemplateNodes'] = originalChildNodes;
	                        });
	                    currentViewModel = componentViewModel;
	                    ko.applyBindingsToDescendants(childBindingContext, element);
	                });
	            }, null, { disposeWhenNodeIsRemoved: element });
	
	            return { 'controlsDescendantBindings': true };
	        }
	    };
	
	    ko.virtualElements.allowedBindings['component'] = true;
	
	    function cloneTemplateIntoElement(componentName, componentDefinition, element) {
	        var template = componentDefinition['template'];
	        if (!template) {
	            throw new Error('Component \'' + componentName + '\' has no template');
	        }
	
	        var clonedNodesArray = ko.utils.cloneNodes(template);
	        ko.virtualElements.setDomNodeChildren(element, clonedNodesArray);
	    }
	
	    function createViewModel(componentDefinition, element, originalChildNodes, componentParams) {
	        var componentViewModelFactory = componentDefinition['createViewModel'];
	        return componentViewModelFactory
	            ? componentViewModelFactory.call(componentDefinition, componentParams, { 'element': element, 'templateNodes': originalChildNodes })
	            : componentParams; // Template-only component
	    }
	
	})();
	var attrHtmlToJavascriptMap = { 'class': 'className', 'for': 'htmlFor' };
	ko.bindingHandlers['attr'] = {
	    'update': function(element, valueAccessor, allBindings) {
	        var value = ko.utils.unwrapObservable(valueAccessor()) || {};
	        ko.utils.objectForEach(value, function(attrName, attrValue) {
	            attrValue = ko.utils.unwrapObservable(attrValue);
	
	            // To cover cases like "attr: { checked:someProp }", we want to remove the attribute entirely
	            // when someProp is a "no value"-like value (strictly null, false, or undefined)
	            // (because the absence of the "checked" attr is how to mark an element as not checked, etc.)
	            var toRemove = (attrValue === false) || (attrValue === null) || (attrValue === undefined);
	            if (toRemove)
	                element.removeAttribute(attrName);
	
	            // In IE <= 7 and IE8 Quirks Mode, you have to use the Javascript property name instead of the
	            // HTML attribute name for certain attributes. IE8 Standards Mode supports the correct behavior,
	            // but instead of figuring out the mode, we'll just set the attribute through the Javascript
	            // property for IE <= 8.
	            if (ko.utils.ieVersion <= 8 && attrName in attrHtmlToJavascriptMap) {
	                attrName = attrHtmlToJavascriptMap[attrName];
	                if (toRemove)
	                    element.removeAttribute(attrName);
	                else
	                    element[attrName] = attrValue;
	            } else if (!toRemove) {
	                element.setAttribute(attrName, attrValue.toString());
	            }
	
	            // Treat "name" specially - although you can think of it as an attribute, it also needs
	            // special handling on older versions of IE (https://github.com/SteveSanderson/knockout/pull/333)
	            // Deliberately being case-sensitive here because XHTML would regard "Name" as a different thing
	            // entirely, and there's no strong reason to allow for such casing in HTML.
	            if (attrName === "name") {
	                ko.utils.setElementName(element, toRemove ? "" : attrValue.toString());
	            }
	        });
	    }
	};
	(function() {
	
	ko.bindingHandlers['checked'] = {
	    'after': ['value', 'attr'],
	    'init': function (element, valueAccessor, allBindings) {
	        var checkedValue = ko.pureComputed(function() {
	            // Treat "value" like "checkedValue" when it is included with "checked" binding
	            if (allBindings['has']('checkedValue')) {
	                return ko.utils.unwrapObservable(allBindings.get('checkedValue'));
	            } else if (allBindings['has']('value')) {
	                return ko.utils.unwrapObservable(allBindings.get('value'));
	            }
	
	            return element.value;
	        });
	
	        function updateModel() {
	            // This updates the model value from the view value.
	            // It runs in response to DOM events (click) and changes in checkedValue.
	            var isChecked = element.checked,
	                elemValue = useCheckedValue ? checkedValue() : isChecked;
	
	            // When we're first setting up this computed, don't change any model state.
	            if (ko.computedContext.isInitial()) {
	                return;
	            }
	
	            // We can ignore unchecked radio buttons, because some other radio
	            // button will be getting checked, and that one can take care of updating state.
	            if (isRadio && !isChecked) {
	                return;
	            }
	
	            var modelValue = ko.dependencyDetection.ignore(valueAccessor);
	            if (valueIsArray) {
	                var writableValue = rawValueIsNonArrayObservable ? modelValue.peek() : modelValue;
	                if (oldElemValue !== elemValue) {
	                    // When we're responding to the checkedValue changing, and the element is
	                    // currently checked, replace the old elem value with the new elem value
	                    // in the model array.
	                    if (isChecked) {
	                        ko.utils.addOrRemoveItem(writableValue, elemValue, true);
	                        ko.utils.addOrRemoveItem(writableValue, oldElemValue, false);
	                    }
	
	                    oldElemValue = elemValue;
	                } else {
	                    // When we're responding to the user having checked/unchecked a checkbox,
	                    // add/remove the element value to the model array.
	                    ko.utils.addOrRemoveItem(writableValue, elemValue, isChecked);
	                }
	                if (rawValueIsNonArrayObservable && ko.isWriteableObservable(modelValue)) {
	                    modelValue(writableValue);
	                }
	            } else {
	                ko.expressionRewriting.writeValueToProperty(modelValue, allBindings, 'checked', elemValue, true);
	            }
	        };
	
	        function updateView() {
	            // This updates the view value from the model value.
	            // It runs in response to changes in the bound (checked) value.
	            var modelValue = ko.utils.unwrapObservable(valueAccessor());
	
	            if (valueIsArray) {
	                // When a checkbox is bound to an array, being checked represents its value being present in that array
	                element.checked = ko.utils.arrayIndexOf(modelValue, checkedValue()) >= 0;
	            } else if (isCheckbox) {
	                // When a checkbox is bound to any other value (not an array), being checked represents the value being trueish
	                element.checked = modelValue;
	            } else {
	                // For radio buttons, being checked means that the radio button's value corresponds to the model value
	                element.checked = (checkedValue() === modelValue);
	            }
	        };
	
	        var isCheckbox = element.type == "checkbox",
	            isRadio = element.type == "radio";
	
	        // Only bind to check boxes and radio buttons
	        if (!isCheckbox && !isRadio) {
	            return;
	        }
	
	        var rawValue = valueAccessor(),
	            valueIsArray = isCheckbox && (ko.utils.unwrapObservable(rawValue) instanceof Array),
	            rawValueIsNonArrayObservable = !(valueIsArray && rawValue.push && rawValue.splice),
	            oldElemValue = valueIsArray ? checkedValue() : undefined,
	            useCheckedValue = isRadio || valueIsArray;
	
	        // IE 6 won't allow radio buttons to be selected unless they have a name
	        if (isRadio && !element.name)
	            ko.bindingHandlers['uniqueName']['init'](element, function() { return true });
	
	        // Set up two computeds to update the binding:
	
	        // The first responds to changes in the checkedValue value and to element clicks
	        ko.computed(updateModel, null, { disposeWhenNodeIsRemoved: element });
	        ko.utils.registerEventHandler(element, "click", updateModel);
	
	        // The second responds to changes in the model value (the one associated with the checked binding)
	        ko.computed(updateView, null, { disposeWhenNodeIsRemoved: element });
	
	        rawValue = undefined;
	    }
	};
	ko.expressionRewriting.twoWayBindings['checked'] = true;
	
	ko.bindingHandlers['checkedValue'] = {
	    'update': function (element, valueAccessor) {
	        element.value = ko.utils.unwrapObservable(valueAccessor());
	    }
	};
	
	})();var classesWrittenByBindingKey = '__ko__cssValue';
	ko.bindingHandlers['css'] = {
	    'update': function (element, valueAccessor) {
	        var value = ko.utils.unwrapObservable(valueAccessor());
	        if (value !== null && typeof value == "object") {
	            ko.utils.objectForEach(value, function(className, shouldHaveClass) {
	                shouldHaveClass = ko.utils.unwrapObservable(shouldHaveClass);
	                ko.utils.toggleDomNodeCssClass(element, className, shouldHaveClass);
	            });
	        } else {
	            value = ko.utils.stringTrim(String(value || '')); // Make sure we don't try to store or set a non-string value
	            ko.utils.toggleDomNodeCssClass(element, element[classesWrittenByBindingKey], false);
	            element[classesWrittenByBindingKey] = value;
	            ko.utils.toggleDomNodeCssClass(element, value, true);
	        }
	    }
	};
	ko.bindingHandlers['enable'] = {
	    'update': function (element, valueAccessor) {
	        var value = ko.utils.unwrapObservable(valueAccessor());
	        if (value && element.disabled)
	            element.removeAttribute("disabled");
	        else if ((!value) && (!element.disabled))
	            element.disabled = true;
	    }
	};
	
	ko.bindingHandlers['disable'] = {
	    'update': function (element, valueAccessor) {
	        ko.bindingHandlers['enable']['update'](element, function() { return !ko.utils.unwrapObservable(valueAccessor()) });
	    }
	};
	// For certain common events (currently just 'click'), allow a simplified data-binding syntax
	// e.g. click:handler instead of the usual full-length event:{click:handler}
	function makeEventHandlerShortcut(eventName) {
	    ko.bindingHandlers[eventName] = {
	        'init': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
	            var newValueAccessor = function () {
	                var result = {};
	                result[eventName] = valueAccessor();
	                return result;
	            };
	            return ko.bindingHandlers['event']['init'].call(this, element, newValueAccessor, allBindings, viewModel, bindingContext);
	        }
	    }
	}
	
	ko.bindingHandlers['event'] = {
	    'init' : function (element, valueAccessor, allBindings, viewModel, bindingContext) {
	        var eventsToHandle = valueAccessor() || {};
	        ko.utils.objectForEach(eventsToHandle, function(eventName) {
	            if (typeof eventName == "string") {
	                ko.utils.registerEventHandler(element, eventName, function (event) {
	                    var handlerReturnValue;
	                    var handlerFunction = valueAccessor()[eventName];
	                    if (!handlerFunction)
	                        return;
	
	                    try {
	                        // Take all the event args, and prefix with the viewmodel
	                        var argsForHandler = ko.utils.makeArray(arguments);
	                        viewModel = bindingContext['$data'];
	                        argsForHandler.unshift(viewModel);
	                        handlerReturnValue = handlerFunction.apply(viewModel, argsForHandler);
	                    } finally {
	                        if (handlerReturnValue !== true) { // Normally we want to prevent default action. Developer can override this be explicitly returning true.
	                            if (event.preventDefault)
	                                event.preventDefault();
	                            else
	                                event.returnValue = false;
	                        }
	                    }
	
	                    var bubble = allBindings.get(eventName + 'Bubble') !== false;
	                    if (!bubble) {
	                        event.cancelBubble = true;
	                        if (event.stopPropagation)
	                            event.stopPropagation();
	                    }
	                });
	            }
	        });
	    }
	};
	// "foreach: someExpression" is equivalent to "template: { foreach: someExpression }"
	// "foreach: { data: someExpression, afterAdd: myfn }" is equivalent to "template: { foreach: someExpression, afterAdd: myfn }"
	ko.bindingHandlers['foreach'] = {
	    makeTemplateValueAccessor: function(valueAccessor) {
	        return function() {
	            var modelValue = valueAccessor(),
	                unwrappedValue = ko.utils.peekObservable(modelValue);    // Unwrap without setting a dependency here
	
	            // If unwrappedValue is the array, pass in the wrapped value on its own
	            // The value will be unwrapped and tracked within the template binding
	            // (See https://github.com/SteveSanderson/knockout/issues/523)
	            if ((!unwrappedValue) || typeof unwrappedValue.length == "number")
	                return { 'foreach': modelValue, 'templateEngine': ko.nativeTemplateEngine.instance };
	
	            // If unwrappedValue.data is the array, preserve all relevant options and unwrap again value so we get updates
	            ko.utils.unwrapObservable(modelValue);
	            return {
	                'foreach': unwrappedValue['data'],
	                'as': unwrappedValue['as'],
	                'includeDestroyed': unwrappedValue['includeDestroyed'],
	                'afterAdd': unwrappedValue['afterAdd'],
	                'beforeRemove': unwrappedValue['beforeRemove'],
	                'afterRender': unwrappedValue['afterRender'],
	                'beforeMove': unwrappedValue['beforeMove'],
	                'afterMove': unwrappedValue['afterMove'],
	                'templateEngine': ko.nativeTemplateEngine.instance
	            };
	        };
	    },
	    'init': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
	        return ko.bindingHandlers['template']['init'](element, ko.bindingHandlers['foreach'].makeTemplateValueAccessor(valueAccessor));
	    },
	    'update': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
	        return ko.bindingHandlers['template']['update'](element, ko.bindingHandlers['foreach'].makeTemplateValueAccessor(valueAccessor), allBindings, viewModel, bindingContext);
	    }
	};
	ko.expressionRewriting.bindingRewriteValidators['foreach'] = false; // Can't rewrite control flow bindings
	ko.virtualElements.allowedBindings['foreach'] = true;
	var hasfocusUpdatingProperty = '__ko_hasfocusUpdating';
	var hasfocusLastValue = '__ko_hasfocusLastValue';
	ko.bindingHandlers['hasfocus'] = {
	    'init': function(element, valueAccessor, allBindings) {
	        var handleElementFocusChange = function(isFocused) {
	            // Where possible, ignore which event was raised and determine focus state using activeElement,
	            // as this avoids phantom focus/blur events raised when changing tabs in modern browsers.
	            // However, not all KO-targeted browsers (Firefox 2) support activeElement. For those browsers,
	            // prevent a loss of focus when changing tabs/windows by setting a flag that prevents hasfocus
	            // from calling 'blur()' on the element when it loses focus.
	            // Discussion at https://github.com/SteveSanderson/knockout/pull/352
	            element[hasfocusUpdatingProperty] = true;
	            var ownerDoc = element.ownerDocument;
	            if ("activeElement" in ownerDoc) {
	                var active;
	                try {
	                    active = ownerDoc.activeElement;
	                } catch(e) {
	                    // IE9 throws if you access activeElement during page load (see issue #703)
	                    active = ownerDoc.body;
	                }
	                isFocused = (active === element);
	            }
	            var modelValue = valueAccessor();
	            ko.expressionRewriting.writeValueToProperty(modelValue, allBindings, 'hasfocus', isFocused, true);
	
	            //cache the latest value, so we can avoid unnecessarily calling focus/blur in the update function
	            element[hasfocusLastValue] = isFocused;
	            element[hasfocusUpdatingProperty] = false;
	        };
	        var handleElementFocusIn = handleElementFocusChange.bind(null, true);
	        var handleElementFocusOut = handleElementFocusChange.bind(null, false);
	
	        ko.utils.registerEventHandler(element, "focus", handleElementFocusIn);
	        ko.utils.registerEventHandler(element, "focusin", handleElementFocusIn); // For IE
	        ko.utils.registerEventHandler(element, "blur",  handleElementFocusOut);
	        ko.utils.registerEventHandler(element, "focusout",  handleElementFocusOut); // For IE
	    },
	    'update': function(element, valueAccessor) {
	        var value = !!ko.utils.unwrapObservable(valueAccessor());
	
	        if (!element[hasfocusUpdatingProperty] && element[hasfocusLastValue] !== value) {
	            value ? element.focus() : element.blur();
	
	            // In IE, the blur method doesn't always cause the element to lose focus (for example, if the window is not in focus).
	            // Setting focus to the body element does seem to be reliable in IE, but should only be used if we know that the current
	            // element was focused already.
	            if (!value && element[hasfocusLastValue]) {
	                element.ownerDocument.body.focus();
	            }
	
	            // For IE, which doesn't reliably fire "focus" or "blur" events synchronously
	            ko.dependencyDetection.ignore(ko.utils.triggerEvent, null, [element, value ? "focusin" : "focusout"]);
	        }
	    }
	};
	ko.expressionRewriting.twoWayBindings['hasfocus'] = true;
	
	ko.bindingHandlers['hasFocus'] = ko.bindingHandlers['hasfocus']; // Make "hasFocus" an alias
	ko.expressionRewriting.twoWayBindings['hasFocus'] = true;
	ko.bindingHandlers['html'] = {
	    'init': function() {
	        // Prevent binding on the dynamically-injected HTML (as developers are unlikely to expect that, and it has security implications)
	        return { 'controlsDescendantBindings': true };
	    },
	    'update': function (element, valueAccessor) {
	        // setHtml will unwrap the value if needed
	        ko.utils.setHtml(element, valueAccessor());
	    }
	};
	// Makes a binding like with or if
	function makeWithIfBinding(bindingKey, isWith, isNot, makeContextCallback) {
	    ko.bindingHandlers[bindingKey] = {
	        'init': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
	            var didDisplayOnLastUpdate,
	                savedNodes;
	            ko.computed(function() {
	                var dataValue = ko.utils.unwrapObservable(valueAccessor()),
	                    shouldDisplay = !isNot !== !dataValue, // equivalent to isNot ? !dataValue : !!dataValue
	                    isFirstRender = !savedNodes,
	                    needsRefresh = isFirstRender || isWith || (shouldDisplay !== didDisplayOnLastUpdate);
	
	                if (needsRefresh) {
	                    // Save a copy of the inner nodes on the initial update, but only if we have dependencies.
	                    if (isFirstRender && ko.computedContext.getDependenciesCount()) {
	                        savedNodes = ko.utils.cloneNodes(ko.virtualElements.childNodes(element), true /* shouldCleanNodes */);
	                    }
	
	                    if (shouldDisplay) {
	                        if (!isFirstRender) {
	                            ko.virtualElements.setDomNodeChildren(element, ko.utils.cloneNodes(savedNodes));
	                        }
	                        ko.applyBindingsToDescendants(makeContextCallback ? makeContextCallback(bindingContext, dataValue) : bindingContext, element);
	                    } else {
	                        ko.virtualElements.emptyNode(element);
	                    }
	
	                    didDisplayOnLastUpdate = shouldDisplay;
	                }
	            }, null, { disposeWhenNodeIsRemoved: element });
	            return { 'controlsDescendantBindings': true };
	        }
	    };
	    ko.expressionRewriting.bindingRewriteValidators[bindingKey] = false; // Can't rewrite control flow bindings
	    ko.virtualElements.allowedBindings[bindingKey] = true;
	}
	
	// Construct the actual binding handlers
	makeWithIfBinding('if');
	makeWithIfBinding('ifnot', false /* isWith */, true /* isNot */);
	makeWithIfBinding('with', true /* isWith */, false /* isNot */,
	    function(bindingContext, dataValue) {
	        return bindingContext['createChildContext'](dataValue);
	    }
	);
	var captionPlaceholder = {};
	ko.bindingHandlers['options'] = {
	    'init': function(element) {
	        if (ko.utils.tagNameLower(element) !== "select")
	            throw new Error("options binding applies only to SELECT elements");
	
	        // Remove all existing <option>s.
	        while (element.length > 0) {
	            element.remove(0);
	        }
	
	        // Ensures that the binding processor doesn't try to bind the options
	        return { 'controlsDescendantBindings': true };
	    },
	    'update': function (element, valueAccessor, allBindings) {
	        function selectedOptions() {
	            return ko.utils.arrayFilter(element.options, function (node) { return node.selected; });
	        }
	
	        var selectWasPreviouslyEmpty = element.length == 0,
	            multiple = element.multiple,
	            previousScrollTop = (!selectWasPreviouslyEmpty && multiple) ? element.scrollTop : null,
	            unwrappedArray = ko.utils.unwrapObservable(valueAccessor()),
	            valueAllowUnset = allBindings.get('valueAllowUnset') && allBindings['has']('value'),
	            includeDestroyed = allBindings.get('optionsIncludeDestroyed'),
	            arrayToDomNodeChildrenOptions = {},
	            captionValue,
	            filteredArray,
	            previousSelectedValues = [];
	
	        if (!valueAllowUnset) {
	            if (multiple) {
	                previousSelectedValues = ko.utils.arrayMap(selectedOptions(), ko.selectExtensions.readValue);
	            } else if (element.selectedIndex >= 0) {
	                previousSelectedValues.push(ko.selectExtensions.readValue(element.options[element.selectedIndex]));
	            }
	        }
	
	        if (unwrappedArray) {
	            if (typeof unwrappedArray.length == "undefined") // Coerce single value into array
	                unwrappedArray = [unwrappedArray];
	
	            // Filter out any entries marked as destroyed
	            filteredArray = ko.utils.arrayFilter(unwrappedArray, function(item) {
	                return includeDestroyed || item === undefined || item === null || !ko.utils.unwrapObservable(item['_destroy']);
	            });
	
	            // If caption is included, add it to the array
	            if (allBindings['has']('optionsCaption')) {
	                captionValue = ko.utils.unwrapObservable(allBindings.get('optionsCaption'));
	                // If caption value is null or undefined, don't show a caption
	                if (captionValue !== null && captionValue !== undefined) {
	                    filteredArray.unshift(captionPlaceholder);
	                }
	            }
	        } else {
	            // If a falsy value is provided (e.g. null), we'll simply empty the select element
	        }
	
	        function applyToObject(object, predicate, defaultValue) {
	            var predicateType = typeof predicate;
	            if (predicateType == "function")    // Given a function; run it against the data value
	                return predicate(object);
	            else if (predicateType == "string") // Given a string; treat it as a property name on the data value
	                return object[predicate];
	            else                                // Given no optionsText arg; use the data value itself
	                return defaultValue;
	        }
	
	        // The following functions can run at two different times:
	        // The first is when the whole array is being updated directly from this binding handler.
	        // The second is when an observable value for a specific array entry is updated.
	        // oldOptions will be empty in the first case, but will be filled with the previously generated option in the second.
	        var itemUpdate = false;
	        function optionForArrayItem(arrayEntry, index, oldOptions) {
	            if (oldOptions.length) {
	                previousSelectedValues = !valueAllowUnset && oldOptions[0].selected ? [ ko.selectExtensions.readValue(oldOptions[0]) ] : [];
	                itemUpdate = true;
	            }
	            var option = element.ownerDocument.createElement("option");
	            if (arrayEntry === captionPlaceholder) {
	                ko.utils.setTextContent(option, allBindings.get('optionsCaption'));
	                ko.selectExtensions.writeValue(option, undefined);
	            } else {
	                // Apply a value to the option element
	                var optionValue = applyToObject(arrayEntry, allBindings.get('optionsValue'), arrayEntry);
	                ko.selectExtensions.writeValue(option, ko.utils.unwrapObservable(optionValue));
	
	                // Apply some text to the option element
	                var optionText = applyToObject(arrayEntry, allBindings.get('optionsText'), optionValue);
	                ko.utils.setTextContent(option, optionText);
	            }
	            return [option];
	        }
	
	        // By using a beforeRemove callback, we delay the removal until after new items are added. This fixes a selection
	        // problem in IE<=8 and Firefox. See https://github.com/knockout/knockout/issues/1208
	        arrayToDomNodeChildrenOptions['beforeRemove'] =
	            function (option) {
	                element.removeChild(option);
	            };
	
	        function setSelectionCallback(arrayEntry, newOptions) {
	            if (itemUpdate && valueAllowUnset) {
	                // The model value is authoritative, so make sure its value is the one selected
	                // There is no need to use dependencyDetection.ignore since setDomNodeChildrenFromArrayMapping does so already.
	                ko.selectExtensions.writeValue(element, ko.utils.unwrapObservable(allBindings.get('value')), true /* allowUnset */);
	            } else if (previousSelectedValues.length) {
	                // IE6 doesn't like us to assign selection to OPTION nodes before they're added to the document.
	                // That's why we first added them without selection. Now it's time to set the selection.
	                var isSelected = ko.utils.arrayIndexOf(previousSelectedValues, ko.selectExtensions.readValue(newOptions[0])) >= 0;
	                ko.utils.setOptionNodeSelectionState(newOptions[0], isSelected);
	
	                // If this option was changed from being selected during a single-item update, notify the change
	                if (itemUpdate && !isSelected) {
	                    ko.dependencyDetection.ignore(ko.utils.triggerEvent, null, [element, "change"]);
	                }
	            }
	        }
	
	        var callback = setSelectionCallback;
	        if (allBindings['has']('optionsAfterRender') && typeof allBindings.get('optionsAfterRender') == "function") {
	            callback = function(arrayEntry, newOptions) {
	                setSelectionCallback(arrayEntry, newOptions);
	                ko.dependencyDetection.ignore(allBindings.get('optionsAfterRender'), null, [newOptions[0], arrayEntry !== captionPlaceholder ? arrayEntry : undefined]);
	            }
	        }
	
	        ko.utils.setDomNodeChildrenFromArrayMapping(element, filteredArray, optionForArrayItem, arrayToDomNodeChildrenOptions, callback);
	
	        ko.dependencyDetection.ignore(function () {
	            if (valueAllowUnset) {
	                // The model value is authoritative, so make sure its value is the one selected
	                ko.selectExtensions.writeValue(element, ko.utils.unwrapObservable(allBindings.get('value')), true /* allowUnset */);
	            } else {
	                // Determine if the selection has changed as a result of updating the options list
	                var selectionChanged;
	                if (multiple) {
	                    // For a multiple-select box, compare the new selection count to the previous one
	                    // But if nothing was selected before, the selection can't have changed
	                    selectionChanged = previousSelectedValues.length && selectedOptions().length < previousSelectedValues.length;
	                } else {
	                    // For a single-select box, compare the current value to the previous value
	                    // But if nothing was selected before or nothing is selected now, just look for a change in selection
	                    selectionChanged = (previousSelectedValues.length && element.selectedIndex >= 0)
	                        ? (ko.selectExtensions.readValue(element.options[element.selectedIndex]) !== previousSelectedValues[0])
	                        : (previousSelectedValues.length || element.selectedIndex >= 0);
	                }
	
	                // Ensure consistency between model value and selected option.
	                // If the dropdown was changed so that selection is no longer the same,
	                // notify the value or selectedOptions binding.
	                if (selectionChanged) {
	                    ko.utils.triggerEvent(element, "change");
	                }
	            }
	        });
	
	        // Workaround for IE bug
	        ko.utils.ensureSelectElementIsRenderedCorrectly(element);
	
	        if (previousScrollTop && Math.abs(previousScrollTop - element.scrollTop) > 20)
	            element.scrollTop = previousScrollTop;
	    }
	};
	ko.bindingHandlers['options'].optionValueDomDataKey = ko.utils.domData.nextKey();
	ko.bindingHandlers['selectedOptions'] = {
	    'after': ['options', 'foreach'],
	    'init': function (element, valueAccessor, allBindings) {
	        ko.utils.registerEventHandler(element, "change", function () {
	            var value = valueAccessor(), valueToWrite = [];
	            ko.utils.arrayForEach(element.getElementsByTagName("option"), function(node) {
	                if (node.selected)
	                    valueToWrite.push(ko.selectExtensions.readValue(node));
	            });
	            ko.expressionRewriting.writeValueToProperty(value, allBindings, 'selectedOptions', valueToWrite);
	        });
	    },
	    'update': function (element, valueAccessor) {
	        if (ko.utils.tagNameLower(element) != "select")
	            throw new Error("values binding applies only to SELECT elements");
	
	        var newValue = ko.utils.unwrapObservable(valueAccessor()),
	            previousScrollTop = element.scrollTop;
	
	        if (newValue && typeof newValue.length == "number") {
	            ko.utils.arrayForEach(element.getElementsByTagName("option"), function(node) {
	                var isSelected = ko.utils.arrayIndexOf(newValue, ko.selectExtensions.readValue(node)) >= 0;
	                if (node.selected != isSelected) {      // This check prevents flashing of the select element in IE
	                    ko.utils.setOptionNodeSelectionState(node, isSelected);
	                }
	            });
	        }
	
	        element.scrollTop = previousScrollTop;
	    }
	};
	ko.expressionRewriting.twoWayBindings['selectedOptions'] = true;
	ko.bindingHandlers['style'] = {
	    'update': function (element, valueAccessor) {
	        var value = ko.utils.unwrapObservable(valueAccessor() || {});
	        ko.utils.objectForEach(value, function(styleName, styleValue) {
	            styleValue = ko.utils.unwrapObservable(styleValue);
	
	            if (styleValue === null || styleValue === undefined || styleValue === false) {
	                // Empty string removes the value, whereas null/undefined have no effect
	                styleValue = "";
	            }
	
	            element.style[styleName] = styleValue;
	        });
	    }
	};
	ko.bindingHandlers['submit'] = {
	    'init': function (element, valueAccessor, allBindings, viewModel, bindingContext) {
	        if (typeof valueAccessor() != "function")
	            throw new Error("The value for a submit binding must be a function");
	        ko.utils.registerEventHandler(element, "submit", function (event) {
	            var handlerReturnValue;
	            var value = valueAccessor();
	            try { handlerReturnValue = value.call(bindingContext['$data'], element); }
	            finally {
	                if (handlerReturnValue !== true) { // Normally we want to prevent default action. Developer can override this be explicitly returning true.
	                    if (event.preventDefault)
	                        event.preventDefault();
	                    else
	                        event.returnValue = false;
	                }
	            }
	        });
	    }
	};
	ko.bindingHandlers['text'] = {
	    'init': function() {
	        // Prevent binding on the dynamically-injected text node (as developers are unlikely to expect that, and it has security implications).
	        // It should also make things faster, as we no longer have to consider whether the text node might be bindable.
	        return { 'controlsDescendantBindings': true };
	    },
	    'update': function (element, valueAccessor) {
	        ko.utils.setTextContent(element, valueAccessor());
	    }
	};
	ko.virtualElements.allowedBindings['text'] = true;
	(function () {
	
	if (window && window.navigator) {
	    var parseVersion = function (matches) {
	        if (matches) {
	            return parseFloat(matches[1]);
	        }
	    };
	
	    // Detect various browser versions because some old versions don't fully support the 'input' event
	    var operaVersion = window.opera && window.opera.version && parseInt(window.opera.version()),
	        userAgent = window.navigator.userAgent,
	        safariVersion = parseVersion(userAgent.match(/^(?:(?!chrome).)*version\/([^ ]*) safari/i)),
	        firefoxVersion = parseVersion(userAgent.match(/Firefox\/([^ ]*)/));
	}
	
	// IE 8 and 9 have bugs that prevent the normal events from firing when the value changes.
	// But it does fire the 'selectionchange' event on many of those, presumably because the
	// cursor is moving and that counts as the selection changing. The 'selectionchange' event is
	// fired at the document level only and doesn't directly indicate which element changed. We
	// set up just one event handler for the document and use 'activeElement' to determine which
	// element was changed.
	if (ko.utils.ieVersion < 10) {
	    var selectionChangeRegisteredName = ko.utils.domData.nextKey(),
	        selectionChangeHandlerName = ko.utils.domData.nextKey();
	    var selectionChangeHandler = function(event) {
	        var target = this.activeElement,
	            handler = target && ko.utils.domData.get(target, selectionChangeHandlerName);
	        if (handler) {
	            handler(event);
	        }
	    };
	    var registerForSelectionChangeEvent = function (element, handler) {
	        var ownerDoc = element.ownerDocument;
	        if (!ko.utils.domData.get(ownerDoc, selectionChangeRegisteredName)) {
	            ko.utils.domData.set(ownerDoc, selectionChangeRegisteredName, true);
	            ko.utils.registerEventHandler(ownerDoc, 'selectionchange', selectionChangeHandler);
	        }
	        ko.utils.domData.set(element, selectionChangeHandlerName, handler);
	    };
	}
	
	ko.bindingHandlers['textInput'] = {
	    'init': function (element, valueAccessor, allBindings) {
	
	        var previousElementValue = element.value,
	            timeoutHandle,
	            elementValueBeforeEvent;
	
	        var updateModel = function (event) {
	            clearTimeout(timeoutHandle);
	            elementValueBeforeEvent = timeoutHandle = undefined;
	
	            var elementValue = element.value;
	            if (previousElementValue !== elementValue) {
	                // Provide a way for tests to know exactly which event was processed
	                if (DEBUG && event) element['_ko_textInputProcessedEvent'] = event.type;
	                previousElementValue = elementValue;
	                ko.expressionRewriting.writeValueToProperty(valueAccessor(), allBindings, 'textInput', elementValue);
	            }
	        };
	
	        var deferUpdateModel = function (event) {
	            if (!timeoutHandle) {
	                // The elementValueBeforeEvent variable is set *only* during the brief gap between an
	                // event firing and the updateModel function running. This allows us to ignore model
	                // updates that are from the previous state of the element, usually due to techniques
	                // such as rateLimit. Such updates, if not ignored, can cause keystrokes to be lost.
	                elementValueBeforeEvent = element.value;
	                var handler = DEBUG ? updateModel.bind(element, {type: event.type}) : updateModel;
	                timeoutHandle = ko.utils.setTimeout(handler, 4);
	            }
	        };
	
	        // IE9 will mess up the DOM if you handle events synchronously which results in DOM changes (such as other bindings);
	        // so we'll make sure all updates are asynchronous
	        var ieUpdateModel = ko.utils.ieVersion == 9 ? deferUpdateModel : updateModel;
	
	        var updateView = function () {
	            var modelValue = ko.utils.unwrapObservable(valueAccessor());
	
	            if (modelValue === null || modelValue === undefined) {
	                modelValue = '';
	            }
	
	            if (elementValueBeforeEvent !== undefined && modelValue === elementValueBeforeEvent) {
	                ko.utils.setTimeout(updateView, 4);
	                return;
	            }
	
	            // Update the element only if the element and model are different. On some browsers, updating the value
	            // will move the cursor to the end of the input, which would be bad while the user is typing.
	            if (element.value !== modelValue) {
	                previousElementValue = modelValue;  // Make sure we ignore events (propertychange) that result from updating the value
	                element.value = modelValue;
	            }
	        };
	
	        var onEvent = function (event, handler) {
	            ko.utils.registerEventHandler(element, event, handler);
	        };
	
	        if (DEBUG && ko.bindingHandlers['textInput']['_forceUpdateOn']) {
	            // Provide a way for tests to specify exactly which events are bound
	            ko.utils.arrayForEach(ko.bindingHandlers['textInput']['_forceUpdateOn'], function(eventName) {
	                if (eventName.slice(0,5) == 'after') {
	                    onEvent(eventName.slice(5), deferUpdateModel);
	                } else {
	                    onEvent(eventName, updateModel);
	                }
	            });
	        } else {
	            if (ko.utils.ieVersion < 10) {
	                // Internet Explorer <= 8 doesn't support the 'input' event, but does include 'propertychange' that fires whenever
	                // any property of an element changes. Unlike 'input', it also fires if a property is changed from JavaScript code,
	                // but that's an acceptable compromise for this binding. IE 9 does support 'input', but since it doesn't fire it
	                // when using autocomplete, we'll use 'propertychange' for it also.
	                onEvent('propertychange', function(event) {
	                    if (event.propertyName === 'value') {
	                        ieUpdateModel(event);
	                    }
	                });
	
	                if (ko.utils.ieVersion == 8) {
	                    // IE 8 has a bug where it fails to fire 'propertychange' on the first update following a value change from
	                    // JavaScript code. It also doesn't fire if you clear the entire value. To fix this, we bind to the following
	                    // events too.
	                    onEvent('keyup', updateModel);      // A single keystoke
	                    onEvent('keydown', updateModel);    // The first character when a key is held down
	                }
	                if (ko.utils.ieVersion >= 8) {
	                    // Internet Explorer 9 doesn't fire the 'input' event when deleting text, including using
	                    // the backspace, delete, or ctrl-x keys, clicking the 'x' to clear the input, dragging text
	                    // out of the field, and cutting or deleting text using the context menu. 'selectionchange'
	                    // can detect all of those except dragging text out of the field, for which we use 'dragend'.
	                    // These are also needed in IE8 because of the bug described above.
	                    registerForSelectionChangeEvent(element, ieUpdateModel);  // 'selectionchange' covers cut, paste, drop, delete, etc.
	                    onEvent('dragend', deferUpdateModel);
	                }
	            } else {
	                // All other supported browsers support the 'input' event, which fires whenever the content of the element is changed
	                // through the user interface.
	                onEvent('input', updateModel);
	
	                if (safariVersion < 5 && ko.utils.tagNameLower(element) === "textarea") {
	                    // Safari <5 doesn't fire the 'input' event for <textarea> elements (it does fire 'textInput'
	                    // but only when typing). So we'll just catch as much as we can with keydown, cut, and paste.
	                    onEvent('keydown', deferUpdateModel);
	                    onEvent('paste', deferUpdateModel);
	                    onEvent('cut', deferUpdateModel);
	                } else if (operaVersion < 11) {
	                    // Opera 10 doesn't always fire the 'input' event for cut, paste, undo & drop operations.
	                    // We can try to catch some of those using 'keydown'.
	                    onEvent('keydown', deferUpdateModel);
	                } else if (firefoxVersion < 4.0) {
	                    // Firefox <= 3.6 doesn't fire the 'input' event when text is filled in through autocomplete
	                    onEvent('DOMAutoComplete', updateModel);
	
	                    // Firefox <=3.5 doesn't fire the 'input' event when text is dropped into the input.
	                    onEvent('dragdrop', updateModel);       // <3.5
	                    onEvent('drop', updateModel);           // 3.5
	                }
	            }
	        }
	
	        // Bind to the change event so that we can catch programmatic updates of the value that fire this event.
	        onEvent('change', updateModel);
	
	        ko.computed(updateView, null, { disposeWhenNodeIsRemoved: element });
	    }
	};
	ko.expressionRewriting.twoWayBindings['textInput'] = true;
	
	// textinput is an alias for textInput
	ko.bindingHandlers['textinput'] = {
	    // preprocess is the only way to set up a full alias
	    'preprocess': function (value, name, addBinding) {
	        addBinding('textInput', value);
	    }
	};
	
	})();ko.bindingHandlers['uniqueName'] = {
	    'init': function (element, valueAccessor) {
	        if (valueAccessor()) {
	            var name = "ko_unique_" + (++ko.bindingHandlers['uniqueName'].currentIndex);
	            ko.utils.setElementName(element, name);
	        }
	    }
	};
	ko.bindingHandlers['uniqueName'].currentIndex = 0;
	ko.bindingHandlers['value'] = {
	    'after': ['options', 'foreach'],
	    'init': function (element, valueAccessor, allBindings) {
	        // If the value binding is placed on a radio/checkbox, then just pass through to checkedValue and quit
	        if (element.tagName.toLowerCase() == "input" && (element.type == "checkbox" || element.type == "radio")) {
	            ko.applyBindingAccessorsToNode(element, { 'checkedValue': valueAccessor });
	            return;
	        }
	
	        // Always catch "change" event; possibly other events too if asked
	        var eventsToCatch = ["change"];
	        var requestedEventsToCatch = allBindings.get("valueUpdate");
	        var propertyChangedFired = false;
	        var elementValueBeforeEvent = null;
	
	        if (requestedEventsToCatch) {
	            if (typeof requestedEventsToCatch == "string") // Allow both individual event names, and arrays of event names
	                requestedEventsToCatch = [requestedEventsToCatch];
	            ko.utils.arrayPushAll(eventsToCatch, requestedEventsToCatch);
	            eventsToCatch = ko.utils.arrayGetDistinctValues(eventsToCatch);
	        }
	
	        var valueUpdateHandler = function() {
	            elementValueBeforeEvent = null;
	            propertyChangedFired = false;
	            var modelValue = valueAccessor();
	            var elementValue = ko.selectExtensions.readValue(element);
	            ko.expressionRewriting.writeValueToProperty(modelValue, allBindings, 'value', elementValue);
	        }
	
	        // Workaround for https://github.com/SteveSanderson/knockout/issues/122
	        // IE doesn't fire "change" events on textboxes if the user selects a value from its autocomplete list
	        var ieAutoCompleteHackNeeded = ko.utils.ieVersion && element.tagName.toLowerCase() == "input" && element.type == "text"
	                                       && element.autocomplete != "off" && (!element.form || element.form.autocomplete != "off");
	        if (ieAutoCompleteHackNeeded && ko.utils.arrayIndexOf(eventsToCatch, "propertychange") == -1) {
	            ko.utils.registerEventHandler(element, "propertychange", function () { propertyChangedFired = true });
	            ko.utils.registerEventHandler(element, "focus", function () { propertyChangedFired = false });
	            ko.utils.registerEventHandler(element, "blur", function() {
	                if (propertyChangedFired) {
	                    valueUpdateHandler();
	                }
	            });
	        }
	
	        ko.utils.arrayForEach(eventsToCatch, function(eventName) {
	            // The syntax "after<eventname>" means "run the handler asynchronously after the event"
	            // This is useful, for example, to catch "keydown" events after the browser has updated the control
	            // (otherwise, ko.selectExtensions.readValue(this) will receive the control's value *before* the key event)
	            var handler = valueUpdateHandler;
	            if (ko.utils.stringStartsWith(eventName, "after")) {
	                handler = function() {
	                    // The elementValueBeforeEvent variable is non-null *only* during the brief gap between
	                    // a keyX event firing and the valueUpdateHandler running, which is scheduled to happen
	                    // at the earliest asynchronous opportunity. We store this temporary information so that
	                    // if, between keyX and valueUpdateHandler, the underlying model value changes separately,
	                    // we can overwrite that model value change with the value the user just typed. Otherwise,
	                    // techniques like rateLimit can trigger model changes at critical moments that will
	                    // override the user's inputs, causing keystrokes to be lost.
	                    elementValueBeforeEvent = ko.selectExtensions.readValue(element);
	                    ko.utils.setTimeout(valueUpdateHandler, 0);
	                };
	                eventName = eventName.substring("after".length);
	            }
	            ko.utils.registerEventHandler(element, eventName, handler);
	        });
	
	        var updateFromModel = function () {
	            var newValue = ko.utils.unwrapObservable(valueAccessor());
	            var elementValue = ko.selectExtensions.readValue(element);
	
	            if (elementValueBeforeEvent !== null && newValue === elementValueBeforeEvent) {
	                ko.utils.setTimeout(updateFromModel, 0);
	                return;
	            }
	
	            var valueHasChanged = (newValue !== elementValue);
	
	            if (valueHasChanged) {
	                if (ko.utils.tagNameLower(element) === "select") {
	                    var allowUnset = allBindings.get('valueAllowUnset');
	                    var applyValueAction = function () {
	                        ko.selectExtensions.writeValue(element, newValue, allowUnset);
	                    };
	                    applyValueAction();
	
	                    if (!allowUnset && newValue !== ko.selectExtensions.readValue(element)) {
	                        // If you try to set a model value that can't be represented in an already-populated dropdown, reject that change,
	                        // because you're not allowed to have a model value that disagrees with a visible UI selection.
	                        ko.dependencyDetection.ignore(ko.utils.triggerEvent, null, [element, "change"]);
	                    } else {
	                        // Workaround for IE6 bug: It won't reliably apply values to SELECT nodes during the same execution thread
	                        // right after you've changed the set of OPTION nodes on it. So for that node type, we'll schedule a second thread
	                        // to apply the value as well.
	                        ko.utils.setTimeout(applyValueAction, 0);
	                    }
	                } else {
	                    ko.selectExtensions.writeValue(element, newValue);
	                }
	            }
	        };
	
	        ko.computed(updateFromModel, null, { disposeWhenNodeIsRemoved: element });
	    },
	    'update': function() {} // Keep for backwards compatibility with code that may have wrapped value binding
	};
	ko.expressionRewriting.twoWayBindings['value'] = true;
	ko.bindingHandlers['visible'] = {
	    'update': function (element, valueAccessor) {
	        var value = ko.utils.unwrapObservable(valueAccessor());
	        var isCurrentlyVisible = !(element.style.display == "none");
	        if (value && !isCurrentlyVisible)
	            element.style.display = "";
	        else if ((!value) && isCurrentlyVisible)
	            element.style.display = "none";
	    }
	};
	// 'click' is just a shorthand for the usual full-length event:{click:handler}
	makeEventHandlerShortcut('click');
	// If you want to make a custom template engine,
	//
	// [1] Inherit from this class (like ko.nativeTemplateEngine does)
	// [2] Override 'renderTemplateSource', supplying a function with this signature:
	//
	//        function (templateSource, bindingContext, options) {
	//            // - templateSource.text() is the text of the template you should render
	//            // - bindingContext.$data is the data you should pass into the template
	//            //   - you might also want to make bindingContext.$parent, bindingContext.$parents,
	//            //     and bindingContext.$root available in the template too
	//            // - options gives you access to any other properties set on "data-bind: { template: options }"
	//            // - templateDocument is the document object of the template
	//            //
	//            // Return value: an array of DOM nodes
	//        }
	//
	// [3] Override 'createJavaScriptEvaluatorBlock', supplying a function with this signature:
	//
	//        function (script) {
	//            // Return value: Whatever syntax means "Evaluate the JavaScript statement 'script' and output the result"
	//            //               For example, the jquery.tmpl template engine converts 'someScript' to '${ someScript }'
	//        }
	//
	//     This is only necessary if you want to allow data-bind attributes to reference arbitrary template variables.
	//     If you don't want to allow that, you can set the property 'allowTemplateRewriting' to false (like ko.nativeTemplateEngine does)
	//     and then you don't need to override 'createJavaScriptEvaluatorBlock'.
	
	ko.templateEngine = function () { };
	
	ko.templateEngine.prototype['renderTemplateSource'] = function (templateSource, bindingContext, options, templateDocument) {
	    throw new Error("Override renderTemplateSource");
	};
	
	ko.templateEngine.prototype['createJavaScriptEvaluatorBlock'] = function (script) {
	    throw new Error("Override createJavaScriptEvaluatorBlock");
	};
	
	ko.templateEngine.prototype['makeTemplateSource'] = function(template, templateDocument) {
	    // Named template
	    if (typeof template == "string") {
	        templateDocument = templateDocument || document;
	        var elem = templateDocument.getElementById(template);
	        if (!elem)
	            throw new Error("Cannot find template with ID " + template);
	        return new ko.templateSources.domElement(elem);
	    } else if ((template.nodeType == 1) || (template.nodeType == 8)) {
	        // Anonymous template
	        return new ko.templateSources.anonymousTemplate(template);
	    } else
	        throw new Error("Unknown template type: " + template);
	};
	
	ko.templateEngine.prototype['renderTemplate'] = function (template, bindingContext, options, templateDocument) {
	    var templateSource = this['makeTemplateSource'](template, templateDocument);
	    return this['renderTemplateSource'](templateSource, bindingContext, options, templateDocument);
	};
	
	ko.templateEngine.prototype['isTemplateRewritten'] = function (template, templateDocument) {
	    // Skip rewriting if requested
	    if (this['allowTemplateRewriting'] === false)
	        return true;
	    return this['makeTemplateSource'](template, templateDocument)['data']("isRewritten");
	};
	
	ko.templateEngine.prototype['rewriteTemplate'] = function (template, rewriterCallback, templateDocument) {
	    var templateSource = this['makeTemplateSource'](template, templateDocument);
	    var rewritten = rewriterCallback(templateSource['text']());
	    templateSource['text'](rewritten);
	    templateSource['data']("isRewritten", true);
	};
	
	ko.exportSymbol('templateEngine', ko.templateEngine);
	
	ko.templateRewriting = (function () {
	    var memoizeDataBindingAttributeSyntaxRegex = /(<([a-z]+\d*)(?:\s+(?!data-bind\s*=\s*)[a-z0-9\-]+(?:=(?:\"[^\"]*\"|\'[^\']*\'|[^>]*))?)*\s+)data-bind\s*=\s*(["'])([\s\S]*?)\3/gi;
	    var memoizeVirtualContainerBindingSyntaxRegex = /<!--\s*ko\b\s*([\s\S]*?)\s*-->/g;
	
	    function validateDataBindValuesForRewriting(keyValueArray) {
	        var allValidators = ko.expressionRewriting.bindingRewriteValidators;
	        for (var i = 0; i < keyValueArray.length; i++) {
	            var key = keyValueArray[i]['key'];
	            if (allValidators.hasOwnProperty(key)) {
	                var validator = allValidators[key];
	
	                if (typeof validator === "function") {
	                    var possibleErrorMessage = validator(keyValueArray[i]['value']);
	                    if (possibleErrorMessage)
	                        throw new Error(possibleErrorMessage);
	                } else if (!validator) {
	                    throw new Error("This template engine does not support the '" + key + "' binding within its templates");
	                }
	            }
	        }
	    }
	
	    function constructMemoizedTagReplacement(dataBindAttributeValue, tagToRetain, nodeName, templateEngine) {
	        var dataBindKeyValueArray = ko.expressionRewriting.parseObjectLiteral(dataBindAttributeValue);
	        validateDataBindValuesForRewriting(dataBindKeyValueArray);
	        var rewrittenDataBindAttributeValue = ko.expressionRewriting.preProcessBindings(dataBindKeyValueArray, {'valueAccessors':true});
	
	        // For no obvious reason, Opera fails to evaluate rewrittenDataBindAttributeValue unless it's wrapped in an additional
	        // anonymous function, even though Opera's built-in debugger can evaluate it anyway. No other browser requires this
	        // extra indirection.
	        var applyBindingsToNextSiblingScript =
	            "ko.__tr_ambtns(function($context,$element){return(function(){return{ " + rewrittenDataBindAttributeValue + " } })()},'" + nodeName.toLowerCase() + "')";
	        return templateEngine['createJavaScriptEvaluatorBlock'](applyBindingsToNextSiblingScript) + tagToRetain;
	    }
	
	    return {
	        ensureTemplateIsRewritten: function (template, templateEngine, templateDocument) {
	            if (!templateEngine['isTemplateRewritten'](template, templateDocument))
	                templateEngine['rewriteTemplate'](template, function (htmlString) {
	                    return ko.templateRewriting.memoizeBindingAttributeSyntax(htmlString, templateEngine);
	                }, templateDocument);
	        },
	
	        memoizeBindingAttributeSyntax: function (htmlString, templateEngine) {
	            return htmlString.replace(memoizeDataBindingAttributeSyntaxRegex, function () {
	                return constructMemoizedTagReplacement(/* dataBindAttributeValue: */ arguments[4], /* tagToRetain: */ arguments[1], /* nodeName: */ arguments[2], templateEngine);
	            }).replace(memoizeVirtualContainerBindingSyntaxRegex, function() {
	                return constructMemoizedTagReplacement(/* dataBindAttributeValue: */ arguments[1], /* tagToRetain: */ "<!-- ko -->", /* nodeName: */ "#comment", templateEngine);
	            });
	        },
	
	        applyMemoizedBindingsToNextSibling: function (bindings, nodeName) {
	            return ko.memoization.memoize(function (domNode, bindingContext) {
	                var nodeToBind = domNode.nextSibling;
	                if (nodeToBind && nodeToBind.nodeName.toLowerCase() === nodeName) {
	                    ko.applyBindingAccessorsToNode(nodeToBind, bindings, bindingContext);
	                }
	            });
	        }
	    }
	})();
	
	
	// Exported only because it has to be referenced by string lookup from within rewritten template
	ko.exportSymbol('__tr_ambtns', ko.templateRewriting.applyMemoizedBindingsToNextSibling);
	(function() {
	    // A template source represents a read/write way of accessing a template. This is to eliminate the need for template loading/saving
	    // logic to be duplicated in every template engine (and means they can all work with anonymous templates, etc.)
	    //
	    // Two are provided by default:
	    //  1. ko.templateSources.domElement       - reads/writes the text content of an arbitrary DOM element
	    //  2. ko.templateSources.anonymousElement - uses ko.utils.domData to read/write text *associated* with the DOM element, but
	    //                                           without reading/writing the actual element text content, since it will be overwritten
	    //                                           with the rendered template output.
	    // You can implement your own template source if you want to fetch/store templates somewhere other than in DOM elements.
	    // Template sources need to have the following functions:
	    //   text() 			- returns the template text from your storage location
	    //   text(value)		- writes the supplied template text to your storage location
	    //   data(key)			- reads values stored using data(key, value) - see below
	    //   data(key, value)	- associates "value" with this template and the key "key". Is used to store information like "isRewritten".
	    //
	    // Optionally, template sources can also have the following functions:
	    //   nodes()            - returns a DOM element containing the nodes of this template, where available
	    //   nodes(value)       - writes the given DOM element to your storage location
	    // If a DOM element is available for a given template source, template engines are encouraged to use it in preference over text()
	    // for improved speed. However, all templateSources must supply text() even if they don't supply nodes().
	    //
	    // Once you've implemented a templateSource, make your template engine use it by subclassing whatever template engine you were
	    // using and overriding "makeTemplateSource" to return an instance of your custom template source.
	
	    ko.templateSources = {};
	
	    // ---- ko.templateSources.domElement -----
	
	    // template types
	    var templateScript = 1,
	        templateTextArea = 2,
	        templateTemplate = 3,
	        templateElement = 4;
	
	    ko.templateSources.domElement = function(element) {
	        this.domElement = element;
	
	        if (element) {
	            var tagNameLower = ko.utils.tagNameLower(element);
	            this.templateType =
	                tagNameLower === "script" ? templateScript :
	                tagNameLower === "textarea" ? templateTextArea :
	                    // For browsers with proper <template> element support, where the .content property gives a document fragment
	                tagNameLower == "template" && element.content && element.content.nodeType === 11 ? templateTemplate :
	                templateElement;
	        }
	    }
	
	    ko.templateSources.domElement.prototype['text'] = function(/* valueToWrite */) {
	        var elemContentsProperty = this.templateType === templateScript ? "text"
	                                 : this.templateType === templateTextArea ? "value"
	                                 : "innerHTML";
	
	        if (arguments.length == 0) {
	            return this.domElement[elemContentsProperty];
	        } else {
	            var valueToWrite = arguments[0];
	            if (elemContentsProperty === "innerHTML")
	                ko.utils.setHtml(this.domElement, valueToWrite);
	            else
	                this.domElement[elemContentsProperty] = valueToWrite;
	        }
	    };
	
	    var dataDomDataPrefix = ko.utils.domData.nextKey() + "_";
	    ko.templateSources.domElement.prototype['data'] = function(key /*, valueToWrite */) {
	        if (arguments.length === 1) {
	            return ko.utils.domData.get(this.domElement, dataDomDataPrefix + key);
	        } else {
	            ko.utils.domData.set(this.domElement, dataDomDataPrefix + key, arguments[1]);
	        }
	    };
	
	    var templatesDomDataKey = ko.utils.domData.nextKey();
	    function getTemplateDomData(element) {
	        return ko.utils.domData.get(element, templatesDomDataKey) || {};
	    }
	    function setTemplateDomData(element, data) {
	        ko.utils.domData.set(element, templatesDomDataKey, data);
	    }
	
	    ko.templateSources.domElement.prototype['nodes'] = function(/* valueToWrite */) {
	        var element = this.domElement;
	        if (arguments.length == 0) {
	            var templateData = getTemplateDomData(element),
	                containerData = templateData.containerData;
	            return containerData || (
	                this.templateType === templateTemplate ? element.content :
	                this.templateType === templateElement ? element :
	                undefined);
	        } else {
	            var valueToWrite = arguments[0];
	            setTemplateDomData(element, {containerData: valueToWrite});
	        }
	    };
	
	    // ---- ko.templateSources.anonymousTemplate -----
	    // Anonymous templates are normally saved/retrieved as DOM nodes through "nodes".
	    // For compatibility, you can also read "text"; it will be serialized from the nodes on demand.
	    // Writing to "text" is still supported, but then the template data will not be available as DOM nodes.
	
	    ko.templateSources.anonymousTemplate = function(element) {
	        this.domElement = element;
	    }
	    ko.templateSources.anonymousTemplate.prototype = new ko.templateSources.domElement();
	    ko.templateSources.anonymousTemplate.prototype.constructor = ko.templateSources.anonymousTemplate;
	    ko.templateSources.anonymousTemplate.prototype['text'] = function(/* valueToWrite */) {
	        if (arguments.length == 0) {
	            var templateData = getTemplateDomData(this.domElement);
	            if (templateData.textData === undefined && templateData.containerData)
	                templateData.textData = templateData.containerData.innerHTML;
	            return templateData.textData;
	        } else {
	            var valueToWrite = arguments[0];
	            setTemplateDomData(this.domElement, {textData: valueToWrite});
	        }
	    };
	
	    ko.exportSymbol('templateSources', ko.templateSources);
	    ko.exportSymbol('templateSources.domElement', ko.templateSources.domElement);
	    ko.exportSymbol('templateSources.anonymousTemplate', ko.templateSources.anonymousTemplate);
	})();
	(function () {
	    var _templateEngine;
	    ko.setTemplateEngine = function (templateEngine) {
	        if ((templateEngine != undefined) && !(templateEngine instanceof ko.templateEngine))
	            throw new Error("templateEngine must inherit from ko.templateEngine");
	        _templateEngine = templateEngine;
	    }
	
	    function invokeForEachNodeInContinuousRange(firstNode, lastNode, action) {
	        var node, nextInQueue = firstNode, firstOutOfRangeNode = ko.virtualElements.nextSibling(lastNode);
	        while (nextInQueue && ((node = nextInQueue) !== firstOutOfRangeNode)) {
	            nextInQueue = ko.virtualElements.nextSibling(node);
	            action(node, nextInQueue);
	        }
	    }
	
	    function activateBindingsOnContinuousNodeArray(continuousNodeArray, bindingContext) {
	        // To be used on any nodes that have been rendered by a template and have been inserted into some parent element
	        // Walks through continuousNodeArray (which *must* be continuous, i.e., an uninterrupted sequence of sibling nodes, because
	        // the algorithm for walking them relies on this), and for each top-level item in the virtual-element sense,
	        // (1) Does a regular "applyBindings" to associate bindingContext with this node and to activate any non-memoized bindings
	        // (2) Unmemoizes any memos in the DOM subtree (e.g., to activate bindings that had been memoized during template rewriting)
	
	        if (continuousNodeArray.length) {
	            var firstNode = continuousNodeArray[0],
	                lastNode = continuousNodeArray[continuousNodeArray.length - 1],
	                parentNode = firstNode.parentNode,
	                provider = ko.bindingProvider['instance'],
	                preprocessNode = provider['preprocessNode'];
	
	            if (preprocessNode) {
	                invokeForEachNodeInContinuousRange(firstNode, lastNode, function(node, nextNodeInRange) {
	                    var nodePreviousSibling = node.previousSibling;
	                    var newNodes = preprocessNode.call(provider, node);
	                    if (newNodes) {
	                        if (node === firstNode)
	                            firstNode = newNodes[0] || nextNodeInRange;
	                        if (node === lastNode)
	                            lastNode = newNodes[newNodes.length - 1] || nodePreviousSibling;
	                    }
	                });
	
	                // Because preprocessNode can change the nodes, including the first and last nodes, update continuousNodeArray to match.
	                // We need the full set, including inner nodes, because the unmemoize step might remove the first node (and so the real
	                // first node needs to be in the array).
	                continuousNodeArray.length = 0;
	                if (!firstNode) { // preprocessNode might have removed all the nodes, in which case there's nothing left to do
	                    return;
	                }
	                if (firstNode === lastNode) {
	                    continuousNodeArray.push(firstNode);
	                } else {
	                    continuousNodeArray.push(firstNode, lastNode);
	                    ko.utils.fixUpContinuousNodeArray(continuousNodeArray, parentNode);
	                }
	            }
	
	            // Need to applyBindings *before* unmemoziation, because unmemoization might introduce extra nodes (that we don't want to re-bind)
	            // whereas a regular applyBindings won't introduce new memoized nodes
	            invokeForEachNodeInContinuousRange(firstNode, lastNode, function(node) {
	                if (node.nodeType === 1 || node.nodeType === 8)
	                    ko.applyBindings(bindingContext, node);
	            });
	            invokeForEachNodeInContinuousRange(firstNode, lastNode, function(node) {
	                if (node.nodeType === 1 || node.nodeType === 8)
	                    ko.memoization.unmemoizeDomNodeAndDescendants(node, [bindingContext]);
	            });
	
	            // Make sure any changes done by applyBindings or unmemoize are reflected in the array
	            ko.utils.fixUpContinuousNodeArray(continuousNodeArray, parentNode);
	        }
	    }
	
	    function getFirstNodeFromPossibleArray(nodeOrNodeArray) {
	        return nodeOrNodeArray.nodeType ? nodeOrNodeArray
	                                        : nodeOrNodeArray.length > 0 ? nodeOrNodeArray[0]
	                                        : null;
	    }
	
	    function executeTemplate(targetNodeOrNodeArray, renderMode, template, bindingContext, options) {
	        options = options || {};
	        var firstTargetNode = targetNodeOrNodeArray && getFirstNodeFromPossibleArray(targetNodeOrNodeArray);
	        var templateDocument = (firstTargetNode || template || {}).ownerDocument;
	        var templateEngineToUse = (options['templateEngine'] || _templateEngine);
	        ko.templateRewriting.ensureTemplateIsRewritten(template, templateEngineToUse, templateDocument);
	        var renderedNodesArray = templateEngineToUse['renderTemplate'](template, bindingContext, options, templateDocument);
	
	        // Loosely check result is an array of DOM nodes
	        if ((typeof renderedNodesArray.length != "number") || (renderedNodesArray.length > 0 && typeof renderedNodesArray[0].nodeType != "number"))
	            throw new Error("Template engine must return an array of DOM nodes");
	
	        var haveAddedNodesToParent = false;
	        switch (renderMode) {
	            case "replaceChildren":
	                ko.virtualElements.setDomNodeChildren(targetNodeOrNodeArray, renderedNodesArray);
	                haveAddedNodesToParent = true;
	                break;
	            case "replaceNode":
	                ko.utils.replaceDomNodes(targetNodeOrNodeArray, renderedNodesArray);
	                haveAddedNodesToParent = true;
	                break;
	            case "ignoreTargetNode": break;
	            default:
	                throw new Error("Unknown renderMode: " + renderMode);
	        }
	
	        if (haveAddedNodesToParent) {
	            activateBindingsOnContinuousNodeArray(renderedNodesArray, bindingContext);
	            if (options['afterRender'])
	                ko.dependencyDetection.ignore(options['afterRender'], null, [renderedNodesArray, bindingContext['$data']]);
	        }
	
	        return renderedNodesArray;
	    }
	
	    function resolveTemplateName(template, data, context) {
	        // The template can be specified as:
	        if (ko.isObservable(template)) {
	            // 1. An observable, with string value
	            return template();
	        } else if (typeof template === 'function') {
	            // 2. A function of (data, context) returning a string
	            return template(data, context);
	        } else {
	            // 3. A string
	            return template;
	        }
	    }
	
	    ko.renderTemplate = function (template, dataOrBindingContext, options, targetNodeOrNodeArray, renderMode) {
	        options = options || {};
	        if ((options['templateEngine'] || _templateEngine) == undefined)
	            throw new Error("Set a template engine before calling renderTemplate");
	        renderMode = renderMode || "replaceChildren";
	
	        if (targetNodeOrNodeArray) {
	            var firstTargetNode = getFirstNodeFromPossibleArray(targetNodeOrNodeArray);
	
	            var whenToDispose = function () { return (!firstTargetNode) || !ko.utils.domNodeIsAttachedToDocument(firstTargetNode); }; // Passive disposal (on next evaluation)
	            var activelyDisposeWhenNodeIsRemoved = (firstTargetNode && renderMode == "replaceNode") ? firstTargetNode.parentNode : firstTargetNode;
	
	            return ko.dependentObservable( // So the DOM is automatically updated when any dependency changes
	                function () {
	                    // Ensure we've got a proper binding context to work with
	                    var bindingContext = (dataOrBindingContext && (dataOrBindingContext instanceof ko.bindingContext))
	                        ? dataOrBindingContext
	                        : new ko.bindingContext(ko.utils.unwrapObservable(dataOrBindingContext));
	
	                    var templateName = resolveTemplateName(template, bindingContext['$data'], bindingContext),
	                        renderedNodesArray = executeTemplate(targetNodeOrNodeArray, renderMode, templateName, bindingContext, options);
	
	                    if (renderMode == "replaceNode") {
	                        targetNodeOrNodeArray = renderedNodesArray;
	                        firstTargetNode = getFirstNodeFromPossibleArray(targetNodeOrNodeArray);
	                    }
	                },
	                null,
	                { disposeWhen: whenToDispose, disposeWhenNodeIsRemoved: activelyDisposeWhenNodeIsRemoved }
	            );
	        } else {
	            // We don't yet have a DOM node to evaluate, so use a memo and render the template later when there is a DOM node
	            return ko.memoization.memoize(function (domNode) {
	                ko.renderTemplate(template, dataOrBindingContext, options, domNode, "replaceNode");
	            });
	        }
	    };
	
	    ko.renderTemplateForEach = function (template, arrayOrObservableArray, options, targetNode, parentBindingContext) {
	        // Since setDomNodeChildrenFromArrayMapping always calls executeTemplateForArrayItem and then
	        // activateBindingsCallback for added items, we can store the binding context in the former to use in the latter.
	        var arrayItemContext;
	
	        // This will be called by setDomNodeChildrenFromArrayMapping to get the nodes to add to targetNode
	        var executeTemplateForArrayItem = function (arrayValue, index) {
	            // Support selecting template as a function of the data being rendered
	            arrayItemContext = parentBindingContext['createChildContext'](arrayValue, options['as'], function(context) {
	                context['$index'] = index;
	            });
	
	            var templateName = resolveTemplateName(template, arrayValue, arrayItemContext);
	            return executeTemplate(null, "ignoreTargetNode", templateName, arrayItemContext, options);
	        }
	
	        // This will be called whenever setDomNodeChildrenFromArrayMapping has added nodes to targetNode
	        var activateBindingsCallback = function(arrayValue, addedNodesArray, index) {
	            activateBindingsOnContinuousNodeArray(addedNodesArray, arrayItemContext);
	            if (options['afterRender'])
	                options['afterRender'](addedNodesArray, arrayValue);
	
	            // release the "cache" variable, so that it can be collected by
	            // the GC when its value isn't used from within the bindings anymore.
	            arrayItemContext = null;
	        };
	
	        return ko.dependentObservable(function () {
	            var unwrappedArray = ko.utils.unwrapObservable(arrayOrObservableArray) || [];
	            if (typeof unwrappedArray.length == "undefined") // Coerce single value into array
	                unwrappedArray = [unwrappedArray];
	
	            // Filter out any entries marked as destroyed
	            var filteredArray = ko.utils.arrayFilter(unwrappedArray, function(item) {
	                return options['includeDestroyed'] || item === undefined || item === null || !ko.utils.unwrapObservable(item['_destroy']);
	            });
	
	            // Call setDomNodeChildrenFromArrayMapping, ignoring any observables unwrapped within (most likely from a callback function).
	            // If the array items are observables, though, they will be unwrapped in executeTemplateForArrayItem and managed within setDomNodeChildrenFromArrayMapping.
	            ko.dependencyDetection.ignore(ko.utils.setDomNodeChildrenFromArrayMapping, null, [targetNode, filteredArray, executeTemplateForArrayItem, options, activateBindingsCallback]);
	
	        }, null, { disposeWhenNodeIsRemoved: targetNode });
	    };
	
	    var templateComputedDomDataKey = ko.utils.domData.nextKey();
	    function disposeOldComputedAndStoreNewOne(element, newComputed) {
	        var oldComputed = ko.utils.domData.get(element, templateComputedDomDataKey);
	        if (oldComputed && (typeof(oldComputed.dispose) == 'function'))
	            oldComputed.dispose();
	        ko.utils.domData.set(element, templateComputedDomDataKey, (newComputed && newComputed.isActive()) ? newComputed : undefined);
	    }
	
	    ko.bindingHandlers['template'] = {
	        'init': function(element, valueAccessor) {
	            // Support anonymous templates
	            var bindingValue = ko.utils.unwrapObservable(valueAccessor());
	            if (typeof bindingValue == "string" || bindingValue['name']) {
	                // It's a named template - clear the element
	                ko.virtualElements.emptyNode(element);
	            } else if ('nodes' in bindingValue) {
	                // We've been given an array of DOM nodes. Save them as the template source.
	                // There is no known use case for the node array being an observable array (if the output
	                // varies, put that behavior *into* your template - that's what templates are for), and
	                // the implementation would be a mess, so assert that it's not observable.
	                var nodes = bindingValue['nodes'] || [];
	                if (ko.isObservable(nodes)) {
	                    throw new Error('The "nodes" option must be a plain, non-observable array.');
	                }
	                var container = ko.utils.moveCleanedNodesToContainerElement(nodes); // This also removes the nodes from their current parent
	                new ko.templateSources.anonymousTemplate(element)['nodes'](container);
	            } else {
	                // It's an anonymous template - store the element contents, then clear the element
	                var templateNodes = ko.virtualElements.childNodes(element),
	                    container = ko.utils.moveCleanedNodesToContainerElement(templateNodes); // This also removes the nodes from their current parent
	                new ko.templateSources.anonymousTemplate(element)['nodes'](container);
	            }
	            return { 'controlsDescendantBindings': true };
	        },
	        'update': function (element, valueAccessor, allBindings, viewModel, bindingContext) {
	            var value = valueAccessor(),
	                dataValue,
	                options = ko.utils.unwrapObservable(value),
	                shouldDisplay = true,
	                templateComputed = null,
	                templateName;
	
	            if (typeof options == "string") {
	                templateName = value;
	                options = {};
	            } else {
	                templateName = options['name'];
	
	                // Support "if"/"ifnot" conditions
	                if ('if' in options)
	                    shouldDisplay = ko.utils.unwrapObservable(options['if']);
	                if (shouldDisplay && 'ifnot' in options)
	                    shouldDisplay = !ko.utils.unwrapObservable(options['ifnot']);
	
	                dataValue = ko.utils.unwrapObservable(options['data']);
	            }
	
	            if ('foreach' in options) {
	                // Render once for each data point (treating data set as empty if shouldDisplay==false)
	                var dataArray = (shouldDisplay && options['foreach']) || [];
	                templateComputed = ko.renderTemplateForEach(templateName || element, dataArray, options, element, bindingContext);
	            } else if (!shouldDisplay) {
	                ko.virtualElements.emptyNode(element);
	            } else {
	                // Render once for this single data point (or use the viewModel if no data was provided)
	                var innerBindingContext = ('data' in options) ?
	                    bindingContext['createChildContext'](dataValue, options['as']) :  // Given an explitit 'data' value, we create a child binding context for it
	                    bindingContext;                                                        // Given no explicit 'data' value, we retain the same binding context
	                templateComputed = ko.renderTemplate(templateName || element, innerBindingContext, options, element);
	            }
	
	            // It only makes sense to have a single template computed per element (otherwise which one should have its output displayed?)
	            disposeOldComputedAndStoreNewOne(element, templateComputed);
	        }
	    };
	
	    // Anonymous templates can't be rewritten. Give a nice error message if you try to do it.
	    ko.expressionRewriting.bindingRewriteValidators['template'] = function(bindingValue) {
	        var parsedBindingValue = ko.expressionRewriting.parseObjectLiteral(bindingValue);
	
	        if ((parsedBindingValue.length == 1) && parsedBindingValue[0]['unknown'])
	            return null; // It looks like a string literal, not an object literal, so treat it as a named template (which is allowed for rewriting)
	
	        if (ko.expressionRewriting.keyValueArrayContainsKey(parsedBindingValue, "name"))
	            return null; // Named templates can be rewritten, so return "no error"
	        return "This template engine does not support anonymous templates nested within its templates";
	    };
	
	    ko.virtualElements.allowedBindings['template'] = true;
	})();
	
	ko.exportSymbol('setTemplateEngine', ko.setTemplateEngine);
	ko.exportSymbol('renderTemplate', ko.renderTemplate);
	// Go through the items that have been added and deleted and try to find matches between them.
	ko.utils.findMovesInArrayComparison = function (left, right, limitFailedCompares) {
	    if (left.length && right.length) {
	        var failedCompares, l, r, leftItem, rightItem;
	        for (failedCompares = l = 0; (!limitFailedCompares || failedCompares < limitFailedCompares) && (leftItem = left[l]); ++l) {
	            for (r = 0; rightItem = right[r]; ++r) {
	                if (leftItem['value'] === rightItem['value']) {
	                    leftItem['moved'] = rightItem['index'];
	                    rightItem['moved'] = leftItem['index'];
	                    right.splice(r, 1);         // This item is marked as moved; so remove it from right list
	                    failedCompares = r = 0;     // Reset failed compares count because we're checking for consecutive failures
	                    break;
	                }
	            }
	            failedCompares += r;
	        }
	    }
	};
	
	ko.utils.compareArrays = (function () {
	    var statusNotInOld = 'added', statusNotInNew = 'deleted';
	
	    // Simple calculation based on Levenshtein distance.
	    function compareArrays(oldArray, newArray, options) {
	        // For backward compatibility, if the third arg is actually a bool, interpret
	        // it as the old parameter 'dontLimitMoves'. Newer code should use { dontLimitMoves: true }.
	        options = (typeof options === 'boolean') ? { 'dontLimitMoves': options } : (options || {});
	        oldArray = oldArray || [];
	        newArray = newArray || [];
	
	        if (oldArray.length < newArray.length)
	            return compareSmallArrayToBigArray(oldArray, newArray, statusNotInOld, statusNotInNew, options);
	        else
	            return compareSmallArrayToBigArray(newArray, oldArray, statusNotInNew, statusNotInOld, options);
	    }
	
	    function compareSmallArrayToBigArray(smlArray, bigArray, statusNotInSml, statusNotInBig, options) {
	        var myMin = Math.min,
	            myMax = Math.max,
	            editDistanceMatrix = [],
	            smlIndex, smlIndexMax = smlArray.length,
	            bigIndex, bigIndexMax = bigArray.length,
	            compareRange = (bigIndexMax - smlIndexMax) || 1,
	            maxDistance = smlIndexMax + bigIndexMax + 1,
	            thisRow, lastRow,
	            bigIndexMaxForRow, bigIndexMinForRow;
	
	        for (smlIndex = 0; smlIndex <= smlIndexMax; smlIndex++) {
	            lastRow = thisRow;
	            editDistanceMatrix.push(thisRow = []);
	            bigIndexMaxForRow = myMin(bigIndexMax, smlIndex + compareRange);
	            bigIndexMinForRow = myMax(0, smlIndex - 1);
	            for (bigIndex = bigIndexMinForRow; bigIndex <= bigIndexMaxForRow; bigIndex++) {
	                if (!bigIndex)
	                    thisRow[bigIndex] = smlIndex + 1;
	                else if (!smlIndex)  // Top row - transform empty array into new array via additions
	                    thisRow[bigIndex] = bigIndex + 1;
	                else if (smlArray[smlIndex - 1] === bigArray[bigIndex - 1])
	                    thisRow[bigIndex] = lastRow[bigIndex - 1];                  // copy value (no edit)
	                else {
	                    var northDistance = lastRow[bigIndex] || maxDistance;       // not in big (deletion)
	                    var westDistance = thisRow[bigIndex - 1] || maxDistance;    // not in small (addition)
	                    thisRow[bigIndex] = myMin(northDistance, westDistance) + 1;
	                }
	            }
	        }
	
	        var editScript = [], meMinusOne, notInSml = [], notInBig = [];
	        for (smlIndex = smlIndexMax, bigIndex = bigIndexMax; smlIndex || bigIndex;) {
	            meMinusOne = editDistanceMatrix[smlIndex][bigIndex] - 1;
	            if (bigIndex && meMinusOne === editDistanceMatrix[smlIndex][bigIndex-1]) {
	                notInSml.push(editScript[editScript.length] = {     // added
	                    'status': statusNotInSml,
	                    'value': bigArray[--bigIndex],
	                    'index': bigIndex });
	            } else if (smlIndex && meMinusOne === editDistanceMatrix[smlIndex - 1][bigIndex]) {
	                notInBig.push(editScript[editScript.length] = {     // deleted
	                    'status': statusNotInBig,
	                    'value': smlArray[--smlIndex],
	                    'index': smlIndex });
	            } else {
	                --bigIndex;
	                --smlIndex;
	                if (!options['sparse']) {
	                    editScript.push({
	                        'status': "retained",
	                        'value': bigArray[bigIndex] });
	                }
	            }
	        }
	
	        // Set a limit on the number of consecutive non-matching comparisons; having it a multiple of
	        // smlIndexMax keeps the time complexity of this algorithm linear.
	        ko.utils.findMovesInArrayComparison(notInBig, notInSml, !options['dontLimitMoves'] && smlIndexMax * 10);
	
	        return editScript.reverse();
	    }
	
	    return compareArrays;
	})();
	
	ko.exportSymbol('utils.compareArrays', ko.utils.compareArrays);
	(function () {
	    // Objective:
	    // * Given an input array, a container DOM node, and a function from array elements to arrays of DOM nodes,
	    //   map the array elements to arrays of DOM nodes, concatenate together all these arrays, and use them to populate the container DOM node
	    // * Next time we're given the same combination of things (with the array possibly having mutated), update the container DOM node
	    //   so that its children is again the concatenation of the mappings of the array elements, but don't re-map any array elements that we
	    //   previously mapped - retain those nodes, and just insert/delete other ones
	
	    // "callbackAfterAddingNodes" will be invoked after any "mapping"-generated nodes are inserted into the container node
	    // You can use this, for example, to activate bindings on those nodes.
	
	    function mapNodeAndRefreshWhenChanged(containerNode, mapping, valueToMap, callbackAfterAddingNodes, index) {
	        // Map this array value inside a dependentObservable so we re-map when any dependency changes
	        var mappedNodes = [];
	        var dependentObservable = ko.dependentObservable(function() {
	            var newMappedNodes = mapping(valueToMap, index, ko.utils.fixUpContinuousNodeArray(mappedNodes, containerNode)) || [];
	
	            // On subsequent evaluations, just replace the previously-inserted DOM nodes
	            if (mappedNodes.length > 0) {
	                ko.utils.replaceDomNodes(mappedNodes, newMappedNodes);
	                if (callbackAfterAddingNodes)
	                    ko.dependencyDetection.ignore(callbackAfterAddingNodes, null, [valueToMap, newMappedNodes, index]);
	            }
	
	            // Replace the contents of the mappedNodes array, thereby updating the record
	            // of which nodes would be deleted if valueToMap was itself later removed
	            mappedNodes.length = 0;
	            ko.utils.arrayPushAll(mappedNodes, newMappedNodes);
	        }, null, { disposeWhenNodeIsRemoved: containerNode, disposeWhen: function() { return !ko.utils.anyDomNodeIsAttachedToDocument(mappedNodes); } });
	        return { mappedNodes : mappedNodes, dependentObservable : (dependentObservable.isActive() ? dependentObservable : undefined) };
	    }
	
	    var lastMappingResultDomDataKey = ko.utils.domData.nextKey(),
	        deletedItemDummyValue = ko.utils.domData.nextKey();
	
	    ko.utils.setDomNodeChildrenFromArrayMapping = function (domNode, array, mapping, options, callbackAfterAddingNodes) {
	        // Compare the provided array against the previous one
	        array = array || [];
	        options = options || {};
	        var isFirstExecution = ko.utils.domData.get(domNode, lastMappingResultDomDataKey) === undefined;
	        var lastMappingResult = ko.utils.domData.get(domNode, lastMappingResultDomDataKey) || [];
	        var lastArray = ko.utils.arrayMap(lastMappingResult, function (x) { return x.arrayEntry; });
	        var editScript = ko.utils.compareArrays(lastArray, array, options['dontLimitMoves']);
	
	        // Build the new mapping result
	        var newMappingResult = [];
	        var lastMappingResultIndex = 0;
	        var newMappingResultIndex = 0;
	
	        var nodesToDelete = [];
	        var itemsToProcess = [];
	        var itemsForBeforeRemoveCallbacks = [];
	        var itemsForMoveCallbacks = [];
	        var itemsForAfterAddCallbacks = [];
	        var mapData;
	
	        function itemMovedOrRetained(editScriptIndex, oldPosition) {
	            mapData = lastMappingResult[oldPosition];
	            if (newMappingResultIndex !== oldPosition)
	                itemsForMoveCallbacks[editScriptIndex] = mapData;
	            // Since updating the index might change the nodes, do so before calling fixUpContinuousNodeArray
	            mapData.indexObservable(newMappingResultIndex++);
	            ko.utils.fixUpContinuousNodeArray(mapData.mappedNodes, domNode);
	            newMappingResult.push(mapData);
	            itemsToProcess.push(mapData);
	        }
	
	        function callCallback(callback, items) {
	            if (callback) {
	                for (var i = 0, n = items.length; i < n; i++) {
	                    if (items[i]) {
	                        ko.utils.arrayForEach(items[i].mappedNodes, function(node) {
	                            callback(node, i, items[i].arrayEntry);
	                        });
	                    }
	                }
	            }
	        }
	
	        for (var i = 0, editScriptItem, movedIndex; editScriptItem = editScript[i]; i++) {
	            movedIndex = editScriptItem['moved'];
	            switch (editScriptItem['status']) {
	                case "deleted":
	                    if (movedIndex === undefined) {
	                        mapData = lastMappingResult[lastMappingResultIndex];
	
	                        // Stop tracking changes to the mapping for these nodes
	                        if (mapData.dependentObservable) {
	                            mapData.dependentObservable.dispose();
	                            mapData.dependentObservable = undefined;
	                        }
	
	                        // Queue these nodes for later removal
	                        if (ko.utils.fixUpContinuousNodeArray(mapData.mappedNodes, domNode).length) {
	                            if (options['beforeRemove']) {
	                                newMappingResult.push(mapData);
	                                itemsToProcess.push(mapData);
	                                if (mapData.arrayEntry === deletedItemDummyValue) {
	                                    mapData = null;
	                                } else {
	                                    itemsForBeforeRemoveCallbacks[i] = mapData;
	                                }
	                            }
	                            if (mapData) {
	                                nodesToDelete.push.apply(nodesToDelete, mapData.mappedNodes);
	                            }
	                        }
	                    }
	                    lastMappingResultIndex++;
	                    break;
	
	                case "retained":
	                    itemMovedOrRetained(i, lastMappingResultIndex++);
	                    break;
	
	                case "added":
	                    if (movedIndex !== undefined) {
	                        itemMovedOrRetained(i, movedIndex);
	                    } else {
	                        mapData = { arrayEntry: editScriptItem['value'], indexObservable: ko.observable(newMappingResultIndex++) };
	                        newMappingResult.push(mapData);
	                        itemsToProcess.push(mapData);
	                        if (!isFirstExecution)
	                            itemsForAfterAddCallbacks[i] = mapData;
	                    }
	                    break;
	            }
	        }
	
	        // Store a copy of the array items we just considered so we can difference it next time
	        ko.utils.domData.set(domNode, lastMappingResultDomDataKey, newMappingResult);
	
	        // Call beforeMove first before any changes have been made to the DOM
	        callCallback(options['beforeMove'], itemsForMoveCallbacks);
	
	        // Next remove nodes for deleted items (or just clean if there's a beforeRemove callback)
	        ko.utils.arrayForEach(nodesToDelete, options['beforeRemove'] ? ko.cleanNode : ko.removeNode);
	
	        // Next add/reorder the remaining items (will include deleted items if there's a beforeRemove callback)
	        for (var i = 0, nextNode = ko.virtualElements.firstChild(domNode), lastNode, node; mapData = itemsToProcess[i]; i++) {
	            // Get nodes for newly added items
	            if (!mapData.mappedNodes)
	                ko.utils.extend(mapData, mapNodeAndRefreshWhenChanged(domNode, mapping, mapData.arrayEntry, callbackAfterAddingNodes, mapData.indexObservable));
	
	            // Put nodes in the right place if they aren't there already
	            for (var j = 0; node = mapData.mappedNodes[j]; nextNode = node.nextSibling, lastNode = node, j++) {
	                if (node !== nextNode)
	                    ko.virtualElements.insertAfter(domNode, node, lastNode);
	            }
	
	            // Run the callbacks for newly added nodes (for example, to apply bindings, etc.)
	            if (!mapData.initialized && callbackAfterAddingNodes) {
	                callbackAfterAddingNodes(mapData.arrayEntry, mapData.mappedNodes, mapData.indexObservable);
	                mapData.initialized = true;
	            }
	        }
	
	        // If there's a beforeRemove callback, call it after reordering.
	        // Note that we assume that the beforeRemove callback will usually be used to remove the nodes using
	        // some sort of animation, which is why we first reorder the nodes that will be removed. If the
	        // callback instead removes the nodes right away, it would be more efficient to skip reordering them.
	        // Perhaps we'll make that change in the future if this scenario becomes more common.
	        callCallback(options['beforeRemove'], itemsForBeforeRemoveCallbacks);
	
	        // Replace the stored values of deleted items with a dummy value. This provides two benefits: it marks this item
	        // as already "removed" so we won't call beforeRemove for it again, and it ensures that the item won't match up
	        // with an actual item in the array and appear as "retained" or "moved".
	        for (i = 0; i < itemsForBeforeRemoveCallbacks.length; ++i) {
	            if (itemsForBeforeRemoveCallbacks[i]) {
	                itemsForBeforeRemoveCallbacks[i].arrayEntry = deletedItemDummyValue;
	            }
	        }
	
	        // Finally call afterMove and afterAdd callbacks
	        callCallback(options['afterMove'], itemsForMoveCallbacks);
	        callCallback(options['afterAdd'], itemsForAfterAddCallbacks);
	    }
	})();
	
	ko.exportSymbol('utils.setDomNodeChildrenFromArrayMapping', ko.utils.setDomNodeChildrenFromArrayMapping);
	ko.nativeTemplateEngine = function () {
	    this['allowTemplateRewriting'] = false;
	}
	
	ko.nativeTemplateEngine.prototype = new ko.templateEngine();
	ko.nativeTemplateEngine.prototype.constructor = ko.nativeTemplateEngine;
	ko.nativeTemplateEngine.prototype['renderTemplateSource'] = function (templateSource, bindingContext, options, templateDocument) {
	    var useNodesIfAvailable = !(ko.utils.ieVersion < 9), // IE<9 cloneNode doesn't work properly
	        templateNodesFunc = useNodesIfAvailable ? templateSource['nodes'] : null,
	        templateNodes = templateNodesFunc ? templateSource['nodes']() : null;
	
	    if (templateNodes) {
	        return ko.utils.makeArray(templateNodes.cloneNode(true).childNodes);
	    } else {
	        var templateText = templateSource['text']();
	        return ko.utils.parseHtmlFragment(templateText, templateDocument);
	    }
	};
	
	ko.nativeTemplateEngine.instance = new ko.nativeTemplateEngine();
	ko.setTemplateEngine(ko.nativeTemplateEngine.instance);
	
	ko.exportSymbol('nativeTemplateEngine', ko.nativeTemplateEngine);
	(function() {
	    ko.jqueryTmplTemplateEngine = function () {
	        // Detect which version of jquery-tmpl you're using. Unfortunately jquery-tmpl
	        // doesn't expose a version number, so we have to infer it.
	        // Note that as of Knockout 1.3, we only support jQuery.tmpl 1.0.0pre and later,
	        // which KO internally refers to as version "2", so older versions are no longer detected.
	        var jQueryTmplVersion = this.jQueryTmplVersion = (function() {
	            if (!jQueryInstance || !(jQueryInstance['tmpl']))
	                return 0;
	            // Since it exposes no official version number, we use our own numbering system. To be updated as jquery-tmpl evolves.
	            try {
	                if (jQueryInstance['tmpl']['tag']['tmpl']['open'].toString().indexOf('__') >= 0) {
	                    // Since 1.0.0pre, custom tags should append markup to an array called "__"
	                    return 2; // Final version of jquery.tmpl
	                }
	            } catch(ex) { /* Apparently not the version we were looking for */ }
	
	            return 1; // Any older version that we don't support
	        })();
	
	        function ensureHasReferencedJQueryTemplates() {
	            if (jQueryTmplVersion < 2)
	                throw new Error("Your version of jQuery.tmpl is too old. Please upgrade to jQuery.tmpl 1.0.0pre or later.");
	        }
	
	        function executeTemplate(compiledTemplate, data, jQueryTemplateOptions) {
	            return jQueryInstance['tmpl'](compiledTemplate, data, jQueryTemplateOptions);
	        }
	
	        this['renderTemplateSource'] = function(templateSource, bindingContext, options, templateDocument) {
	            templateDocument = templateDocument || document;
	            options = options || {};
	            ensureHasReferencedJQueryTemplates();
	
	            // Ensure we have stored a precompiled version of this template (don't want to reparse on every render)
	            var precompiled = templateSource['data']('precompiled');
	            if (!precompiled) {
	                var templateText = templateSource['text']() || "";
	                // Wrap in "with($whatever.koBindingContext) { ... }"
	                templateText = "{{ko_with $item.koBindingContext}}" + templateText + "{{/ko_with}}";
	
	                precompiled = jQueryInstance['template'](null, templateText);
	                templateSource['data']('precompiled', precompiled);
	            }
	
	            var data = [bindingContext['$data']]; // Prewrap the data in an array to stop jquery.tmpl from trying to unwrap any arrays
	            var jQueryTemplateOptions = jQueryInstance['extend']({ 'koBindingContext': bindingContext }, options['templateOptions']);
	
	            var resultNodes = executeTemplate(precompiled, data, jQueryTemplateOptions);
	            resultNodes['appendTo'](templateDocument.createElement("div")); // Using "appendTo" forces jQuery/jQuery.tmpl to perform necessary cleanup work
	
	            jQueryInstance['fragments'] = {}; // Clear jQuery's fragment cache to avoid a memory leak after a large number of template renders
	            return resultNodes;
	        };
	
	        this['createJavaScriptEvaluatorBlock'] = function(script) {
	            return "{{ko_code ((function() { return " + script + " })()) }}";
	        };
	
	        this['addTemplate'] = function(templateName, templateMarkup) {
	            document.write("<script type='text/html' id='" + templateName + "'>" + templateMarkup + "<" + "/script>");
	        };
	
	        if (jQueryTmplVersion > 0) {
	            jQueryInstance['tmpl']['tag']['ko_code'] = {
	                open: "__.push($1 || '');"
	            };
	            jQueryInstance['tmpl']['tag']['ko_with'] = {
	                open: "with($1) {",
	                close: "} "
	            };
	        }
	    };
	
	    ko.jqueryTmplTemplateEngine.prototype = new ko.templateEngine();
	    ko.jqueryTmplTemplateEngine.prototype.constructor = ko.jqueryTmplTemplateEngine;
	
	    // Use this one by default *only if jquery.tmpl is referenced*
	    var jqueryTmplTemplateEngineInstance = new ko.jqueryTmplTemplateEngine();
	    if (jqueryTmplTemplateEngineInstance.jQueryTmplVersion > 0)
	        ko.setTemplateEngine(jqueryTmplTemplateEngineInstance);
	
	    ko.exportSymbol('jqueryTmplTemplateEngine', ko.jqueryTmplTemplateEngine);
	})();
	}));
	}());
	})();
	


/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var BoolAdvancedSearchItem = __webpack_require__(12);
	var DefaultAdvancedSearchItem = __webpack_require__(14);
	var PicklistAdvancedSearchItem = __webpack_require__(23);
	var RangeAdvancedSearchItem = __webpack_require__(448);
	var StringAdvancedSearchItem = __webpack_require__(453);
	
	module.exports = __webpack_require__(454);
	module.exports.types = {
	    bool: BoolAdvancedSearchItem,
	    date: RangeAdvancedSearchItem.date,
	    default: DefaultAdvancedSearchItem,
	    initializeRangeAdvancedSearch: RangeAdvancedSearchItem.initializeRangeAdvancedSearch,
	    number: RangeAdvancedSearchItem.number,
	    picklist: PicklistAdvancedSearchItem,
	    string: StringAdvancedSearchItem
	};
	


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var stringUtil = __webpack_require__(13);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// BoolAdvancedSearchItem template
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	
	//-------------------------------------------
	// Represents error value the operator observable is set to
	// when load method phrase argument can not be parsed to boolean.
	var operatorErrorValue = "";
	
	
	//-------------------------------------------
	function BoolAdvancedSearchItem() {
	    if (!(this instanceof BoolAdvancedSearchItem)) { return new BoolAdvancedSearchItem(); } // if new was not used, force it now
	
	    // extras
	    this.extras = function boolAdvancedSearchItemExtras() { return; };
	    this.extras.isError = ko.pureComputed(this._computeIsError, this);
	
	    // indicates how the bool fields are searched
	    // - `is true` include any items with `true` value
	    // - `is false` excludes any items with `falsy` values
	    this.operator = ko.observable(BoolAdvancedSearchItem.defaultValue);
	}
	
	
	//-------------------------------------------
	// Gets the id used by the browser to uniquely
	// identify the dom element.
	BoolAdvancedSearchItem.prototype.templateId = "boolAdvancedSearchItem";
	
	
	//-------------------------------------------
	// Default value for BoolAdvancedSearchItem property select.
	BoolAdvancedSearchItem.prototype.defaultValue = "true";
	
	
	//-------------------------------------------
	// Loads the value of this view-model from the
	// advancedSearch item.
	BoolAdvancedSearchItem.prototype.load = function boolAdvancedSearchItemLoad(phrase) {
	
	    if (typeof phrase !== "string") {
	        throw new Error("phrase argument must be of string type.");
	    }
	
	    // parse phrase
	    var result = stringUtil.parseBoolean(phrase);
	
	    // set known or error (empty) operator
	    this.operator(result !== null ? result.toString() : operatorErrorValue);
	};
	
	
	//-------------------------------------------
	// Saves the value of this view-model to the
	// advancedSearch item. Expects `this` to be the advancedSearch item.
	BoolAdvancedSearchItem.prototype.save = function boolAdvancedSearchItemSave() {
	    return [this.operator(), false];
	};
	
	
	//-------------------------------------------
	BoolAdvancedSearchItem.prototype._computeIsError = function boolAdvancedSearchItemIsError() {
	    return this.operator() === operatorErrorValue;
	};
	
	module.exports = BoolAdvancedSearchItem;
	


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var knockout_1 = __webpack_require__(9);
	// Test for an empty (or whitespace) string
	var emptyTestRegex = new RegExp("^\\s*$");
	// Regular expression to match regular expression special characters for escaping in toRegExLiteral
	var toLiteralRegex = new RegExp("[\\\\\\[\\]\\^\\{\\}\\<\\>\\-\\$\\.\\?\\*\\(\\)\\|\\+]", "g");
	/**
	 * Builds a regex that prefix-matches all phrases of a search string.
	 *
	 * @param search
	 *     String containing the words that will be prefix-matched.
	 * @returns
	 *     Regular expression that prefix-matches all phrases in the search string.
	 */
	function buildPrefixMatcher(search) {
	    var phrases = (search || "").split(" ");
	    var reconstructed = "";
	    for (var _i = 0, phrases_1 = phrases; _i < phrases_1.length; _i++) {
	        var phrase = phrases_1[_i];
	        var p = phrase.trim();
	        if (p.length !== 0) {
	            reconstructed += "(?=.*\\b" + toRegExLiteral(p) + ")";
	        }
	    }
	    return new RegExp(reconstructed, "i");
	}
	exports.buildPrefixMatcher = buildPrefixMatcher;
	/**
	 * Create regular expression that tests for strings starting with the specified value, case-insensitive.
	 *
	 * @param prefix
	 *     String to match.
	 * @returns
	 *     Regular expression instance.
	 */
	function createSearchRegexFor(prefix) {
	    return new RegExp("^" + toRegExLiteral(prefix), "i"); // case insensitive
	}
	exports.createSearchRegexFor = createSearchRegexFor;
	/**
	 * Determines whether the specified value is an "empty" string.
	 *
	 * "null", "undefined", "empty" and "whitespace" are all considered empty.
	 *
	 * @param value
	 *     Value to check.
	 * @returns
	 *     true/false if passed value is an empty string. Non-string values are
	 *     considered to be "empty" strings and return true.
	 */
	function isNullOrWhitespace(value) {
	    return (typeof value !== "string" || emptyTestRegex.test(value));
	}
	exports.isNullOrWhitespace = isNullOrWhitespace;
	/**
	 * Converts string value to a boolean.
	 *
	 * Mimics "BoolType.TryParseExact" behavior.
	 *
	 * @param value
	 *     Value to parse as a boolean.
	 * @returns
	 *     true/false if passed value is a string that can be parsed, "null" otherwise.
	 */
	function parseBoolean(value) {
	    if (typeof value !== "string") {
	        return null;
	    }
	    switch (value.toUpperCase()) {
	        case "-1":
	        case "1":
	        case "Y":
	        case "YES":
	        case "T":
	        case "TRUE":
	        case "ON":
	        case "OK":
	            return true;
	        case "0":
	        case "N":
	        case "NO":
	        case "F":
	        case "FALSE":
	            return false;
	        default:
	            return null;
	    }
	}
	exports.parseBoolean = parseBoolean;
	/**
	 * Escape special regex characters so that they are matched literally.
	 *
	 * (E.g. a string containing "." will match dot, not any character, at that position).
	 *
	 * @param value
	 *     String to convert to literal regex.
	 * @returns
	 *     A string that can be used in a RegExp object for matching literal values.
	 */
	function toRegExLiteral(value) {
	    return value.toString().replace(toLiteralRegex, function (c) { return "\\" + c; });
	}
	exports.toRegExLiteral = toRegExLiteral;
	/**
	 * Removes leading and trailing whitespace from the given string.
	 *
	 * Code is modified from https://github.com/knockout/knockout/blob/master/src/utils.js.
	 *
	 * @param value
	 *     The string or observable to trim.
	 * @returns
	 *     The trimmed string or an empty string if input is null or undefined.
	 */
	function trim(value) {
	    var strValue = knockout_1.unwrap(value);
	    return (strValue === null || strValue === undefined)
	        ? ""
	        : (strValue.trim ? strValue.trim() : strValue.toString().replace(/^[\s\xa0]+|[\s\xa0]+$/g, ""));
	}
	exports.trim = trim;
	



/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var pliObservable = __webpack_require__(15);
	var stringUtil = __webpack_require__(13);
	
	var shared = __webpack_require__(22);
	
	/**
	 * @constructor
	 * @this {DefaultAdvancedSearchItem}
	 */
	function DefaultAdvancedSearchItem() {
	    if (!(this instanceof DefaultAdvancedSearchItem)) { return new DefaultAdvancedSearchItem(); } // if new was not used, force it now
	
	    // indicates how the fields are searched
	    // - `contains` includes any items with partial matches (default)
	    // - `not contain` excludes any items with partial matches
	    this.operator = ko.observable("contains");
	
	    // contains value of the phrase to match
	    this.value = pliObservable();
	}
	
	
	/**
	 * @member {string}
	 * stores the DOM ID of the template
	 */
	DefaultAdvancedSearchItem.prototype.templateId = "defaultAdvancedSearchItem";
	
	/**
	 * Loads the value of this view-model from the advancedSearch item
	 * @param {string} phrase
	 * @param {bool} not
	 */
	DefaultAdvancedSearchItem.prototype.load = function defaultAdvancedSearchItemLoad(phrase, not) {
	    var textValue, operatorValue = "contains"; // default is "contains"
	
	    if (not) {
	        operatorValue = "not contain";
	        textValue = phrase.replace(shared.removeSurroundingWildcards, "");
	    } else if (stringUtil.isNullOrWhitespace(phrase)) {
	        textValue = "";
	    } else {
	        phrase = phrase.trim();
	        textValue = phrase.replace(shared.removeSurroundingWildcards, "");
	    }
	
	    this.operator(operatorValue);
	    this.value.load(textValue);
	};
	
	
	/**
	 * Saves the value of this view-model to the advancedSearch item
	 * @returns {Array} - [0] is `phrase`, [1] is `not`
	 */
	DefaultAdvancedSearchItem.prototype.save = function defaultAdvancedSearchItemSave() {
	    var phrase, not,
	        operator = this.operator(),
	        value = this.value();
	    value = stringUtil.isNullOrWhitespace(value) ? "" : value;
	
	    phrase = (value === ""
	        ? value
	        : value.replace(shared.removeSurroundingWildcards, ""));
	    not = operator === "not contain";
	
	    return [phrase, not];
	};
	
	module.exports = DefaultAdvancedSearchItem;
	


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var pli = __webpack_require__(5);
	
	if (__webpack_require__(3).isBrowser) {
	    __webpack_require__(16);
	}
	
	module.exports = pli.observable = ko.observablePliTextBox = __webpack_require__(20);
	


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var TextBoxController = __webpack_require__(17);
	
	ko.bindingHandlers.pliTextBox = {
	    requireController: TextBoxController.prototype._requireController,
	
	    init: TextBoxController.prototype._koInit,
	    update: TextBoxController.prototype._koUpdate
	};
	


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser:true, todo:true*/
	"use strict";
	
	var ko = __webpack_require__(9);
	var R = __webpack_require__(7);
	
	var $ = __webpack_require__(1);
	
	if (__webpack_require__(3).isBrowser) {
	    // Provides synthetic 'input' events as 'textchange' events
	    // TODO: Remove when IE9 support is officially dropped
	    __webpack_require__(18);
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// TextBoxController class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Create a new instance of text box controller
	// (during "pliTextBox" binding initialization).
	//
	// Methods called "on...$" (e.g. "onFocus$")
	// expect TextBoxController reference to be
	// passed via "e.data", not "this" (this is
	// the standard way to pass context to event
	// handlers when using jQuery's "$.on(...)").
	function TextBoxController(element, valueAccessor, allBindings) {
	    // define properties
	    this.observable = this._verifyNewObservable(valueAccessor());
	    this.$input = $(element);
	    this.$root = this.$input.closest(".pliControl");
	    this.$icon = this.$root.find("i");
	    this.$errorText = this.$root.find("b.withError");
	    this.customFormat = allBindings.get("pliTextBoxFormat");
	    this.eventStream = null;
	    this.isFocused = false;
	    this._applyChanges = this._applyChanges.bind(this);
	    this._applyChangesTimerId = null;
	    this._updateDelayInMillisecs = allBindings.get("pliTextBoxUpdateDelay");
	    if (typeof this._updateDelayInMillisecs !== "number") {
	        this._updateDelayInMillisecs = (this.observable.behaviourData && this.observable.behaviourData.updateDelay);
	        if (typeof this._updateDelayInMillisecs !== "number") {
	            this._updateDelayInMillisecs = 500;
	        }
	    }
	
	    // bind to view
	    if (this.observable._initBinding(this, allBindings) !== false) { // explicit check for "false", do not replace with falsy
	        // handle icon clicks
	        this.$icon.on("mousedown", this, this.showSelectionForm$);
	
	        // handle user-initiated changes
	        // TODO: `textchange` -> `input` when IE9 support is completely dropped
	        this.$input.on("change textchange", this, this.onChange$);
	
	        // mark as focused when user enters
	        this.$input.on("focus", this, this.onFocus$);
	
	        // reformat value when user leaves
	        this.$input.on("blur", this, this.onBlur$);
	
	        // add support for custom shortcuts
	        this.$input.on("keydown", this, this.onKeyDown$);
	    }
	
	    // update view with initial observable value
	    this.observable._addController(this);
	    this.updateView(true); // ignore focus
	    this.observable._updateBinding(this, allBindings);
	
	    // set placeholder
	    if (element.tagName.toLowerCase() === 'input') {
	        var placeholder = (this.observable.behaviourData && this.observable.behaviourData.placeholder)
	            || this.$input.attr('data-placeholder');
	        if (placeholder) {
	            this._setPlaceholder(placeholder);
	        }
	    }
	}
	
	
	//-------------------------------------------
	// Return true when the bound HTML element is
	// enabled (when its value can be changed,
	// i.e. when it is not disabled or readonly).
	TextBoxController.prototype.isEnabled = function textBoxControllerIsEnabled() {
	    return !this.$input.is(":disabled, [readonly]");
	};
	
	
	//-------------------------------------------
	// Reformat bound HTML element when user leaves
	// and mark this controller as not focused.
	//
	// Expects "e.data" to point to TextBoxController
	// (intended for use with "$.on('event', controller, onBlur$)".
	TextBoxController.prototype.onBlur$ = function textBoxControllerOnBlur$(e) {
	    var controller = e.data;
	    controller.isFocused = false;
	    controller._applyChanges(true); // skip view update
	    controller.observable._updateView();
	};
	
	
	//-------------------------------------------
	// Update bound observable (called when
	// bound HTML element changes).
	//
	// Expects "e.data" to point to TextBoxController
	// (intended for use with "$.on('event', controller, onChange$)".
	TextBoxController.prototype.onChange$ = function textBoxControllerOnChange$(e) {
	    var controller = e.data;
	    if (controller._updateDelayInMillisecs <= 0) {
	        controller._applyChanges(false, true); // do not skip view update, force apply (run now even without timer ID)
	    } else {
	        if (controller._applyChangesTimerId !== null) { window.clearTimeout(controller._applyChangesTimerId); }
	        controller._applyChangesTimerId = window.setTimeout(controller._applyChanges, controller._updateDelayInMillisecs);
	    }
	};
	
	
	//-------------------------------------------
	// Mark this controller as focused.
	//
	// Expects "e.data" to point to TextBoxController
	// (intended for use with "$.on('event', controller, onFocus$)".
	TextBoxController.prototype.onFocus$ = function textBoxControllerOnFocus$(e) {
	    var controller = e.data;
	    controller._applyChanges(); // will update view if there are pending changes
	    controller.isFocused = true;
	};
	
	
	//-------------------------------------------
	// Recognize and handle "pliTextBox"
	// keyboard shortcuts.
	//
	// Expects "e.data" to point to TextBoxController
	// (intended for use with "$.on('event', controller, onKeyDown$)".
	TextBoxController.prototype.onKeyDown$ = function textBoxControllerOnKeyDown$(e) {
	    switch (e.which) {
	    case 114: // F3 (show context menu)
	        return e.data.showSelectionForm$(e);
	    }
	};
	
	
	//-------------------------------------------
	// If current observable supports
	// selection form, show it now.
	//
	// Expects "e.data" to point to TextBoxController
	// (intended for use with "$.on('event', controller, showSelectionForm$)".
	TextBoxController.prototype.showSelectionForm$ = function textBoxControllerShowSelectionForm$(e) {
	    var controller = e.data;
	    if (typeof controller.observable.show === "function" && controller.isEnabled()) {
	        controller._applyChanges();
	        var result = controller.observable.show({
	            onShowDone: controller._showSelectionFormDone,
	            onShowDoneContext: controller,
	            $input: controller.$input
	        });
	        if (result === false && this._preventDefault) { // explicit check for "false", do not replace with falsy
	            this._preventDefault(e);
	        }
	        return result;
	    }
	};
	
	
	//-------------------------------------------
	// Update bound HTML element.
	TextBoxController.prototype.updateView = function textBoxControllerUpdateView(ignoreFocus) {
	    var o = this.observable;
	    var withError = !o.isValid.peek();
	    if (withError && !this.$errorText.length) {
	        this.$errorText = $("<b class=\"withError\"></b>");
	        this.$root.append(this.$errorText);
	    }
	
	    this.$errorText.text(o._errorMessage || "");
	    this.$root.toggleClass("withError", withError);
	
	    if (ignoreFocus || !this.isFocused) {
	        this.updateViewValue();
	    }
	};
	
	
	//-------------------------------------------
	// Synchronize value of the bound HTML element
	// with the current observable value (called
	// from "updateView" method).
	TextBoxController.prototype.updateViewValue = function textBoxControllerUpdateViewValue() {
	    var value = this.observable.format(this.customFormat);
	    this.$input.val(value);
	};
	
	
	//-------------------------------------------
	// If no change is pending ("_applyChangesTimerId"),
	// does nothing (unless "forceApply" is true).
	// Also ignores spurious change events (mostly
	// happens in IE, we get notified of change but
	// the value has not really changed).
	//
	// If a change is pending, will notify underlying
	// observable (using "_loadText") and then update
	// view  (if "_loadText" made any changes).
	TextBoxController.prototype._applyChanges = function textBoxControllerApplyChanges(skipViewUpdate, forceApply) {
	    // cancel pending change requests
	    if (this._applyChangesTimerId !== null) {
	        window.clearTimeout(this._applyChangesTimerId);
	        this._applyChangesTimerId = null;
	    } else {
	        if (!forceApply) { return; } // if no change request is pending and we are not force-applying, we are done
	    }
	
	    // filter out spurious change events
	    var targetValue = this.observable.peekValue();
	    if (targetValue === null) { targetValue = ""; }
	    var inputValueStr = this.$input.val() || "";
	    if (inputValueStr === targetValue) { return; }
	
	    // activate and update the linked observable
	    this.observable._isActivated = true;
	    var updateNeeded = this.observable._loadText(inputValueStr);
	    if (updateNeeded && !skipViewUpdate) {
	        this.observable._updateView();
	    }
	};
	
	
	//-------------------------------------------
	// Key that is used to store controller
	// object as a property of bound HTML element
	// (similar technique is used by built-in
	// Knockout bindings, they are using
	// "__ko__" prefix).
	TextBoxController.prototype._elementKey = "__kopli__textbox";
	
	
	//-------------------------------------------
	// Initialize new "pliTextBox" binding by creating
	// a new controller object and storing it as
	// a property of the bound element.
	//
	// This is a "static" method, do not use "this".
	TextBoxController.prototype._koInit = function textBoxControllerKoInit(element, valueAccessor, allBindings) {
	    element[TextBoxController.prototype._elementKey] = new TextBoxController(element, valueAccessor, allBindings);
	};
	
	
	//-------------------------------------------
	// Update value of HTML element bound by
	// "pliTextBox" binding (this method will be
	// called by Knockout when bound observable
	// sends a change notification or when
	// the observable itself changes).
	//
	// This is a "static" method, do not use "this".
	TextBoxController.prototype._koUpdate = function textBoxControllerKoUpdate(element, valueAccessor, allBindings) {
	    var controller = TextBoxController.prototype._requireController(element);
	
	    var o = valueAccessor();
	    if (controller.observable !== o) {
	        controller.observable._removeController(controller); // old observable
	        controller.observable = controller._verifyNewObservable(o);
	        controller.observable._addController(controller); // new observable
	        controller.observable._updateBinding(controller, allBindings);
	        controller.updateView(true); // ignore focus
	    }
	};
	
	
	//-------------------------------------------
	// If the current browser is Internet Explorer
	// 8 or older, this method will be defined
	// and will contain IE-specific code that
	// will prevent default for special keys
	// (like F3). In other browsers this method
	// will be null (not defined).
	TextBoxController.prototype._preventDefault = (function createPreventDefault() {
	    if ((document.documentMode || 100) > 8) { return null; } // most browsers don't need this hack
	
	    return function iePreventDefault(e) {
	        try { e.originalEvent.keyCode = 0; } catch (ignore) {}
	    };
	}());
	
	
	//-------------------------------------------
	// Get controller associated with the specified
	// element. Throws an error if the specified
	// element is not associated with a controller.
	//
	// This is a "static" method, do not use "this".
	TextBoxController.prototype._requireController = function textBoxControllerRequireController(element) {
	    var controller = (element && element[TextBoxController.prototype._elementKey]);
	    if (!controller) { throw new Error("Target element has not been bound using \"pliTextBox\" binding"); }
	    return controller;
	};
	
	
	//-------------------------------------------
	TextBoxController.prototype._setPlaceholder = function textBoxControllerSetPlaceholder(placeholder) {
	    this.$input.attr(
	        "placeholder",
	        typeof placeholder === "function" ? placeholder() : placeholder
	    );
	    if (ko.isSubscribable(placeholder)) {
	        placeholder.subscribe(R.partial(this.$input.attr, ["placeholder"]), this.$input);
	    }
	};
	
	
	//-------------------------------------------
	// Callback invoked when the selection form
	// shown using "show" method is closed
	// (either accepting value or cancelling).
	TextBoxController.prototype._showSelectionFormDone = function textBoxControllerShowSelectionFormDone(v) {
	    if (v === undefined) {
	        return this.observable.peek();
	    }
	
	    this.observable.load(v);
	    this.observable._updateView(true); // ignore focus
	};
	
	
	//-------------------------------------------
	// Make sure the specified observable "o"
	// is a valid textbox observable (i.e. is
	// itself an observable and has "_loadText"
	// and other required methods).
	//
	// Called when observable object changes
	// (not value of the observable, but the
	// observable itself; this will happen
	// when more complex bindings are used,
	// e.g. "dois.current().area" -- every
	// time "current" changes, "area" observable
	// will change as well, so the same view
	// element is now bound to a different
	// viewmodel object).
	TextBoxController.prototype._verifyNewObservable = function textBoxControllerVerifyNewObservable(o) {
	    if (!ko.isWriteableObservable(o)) { throw new Error("Target of \"pliTextBox\" binding must be a writeable observable (did you use \"pli.observable\"?)"); }
	    if (!ko.isObservable(o.isValid)) { throw new Error("Target of \"pliTextBox\" binding must have a \"isValid\" observable (did you use \"pli.observable\"?)"); }
	    if (typeof o._addController !== "function") { throw new Error("Target of \"pliTextBox\" binding must have a \"_addController\" method (did you use \"pli.observable\"?)"); }
	    if (typeof o._loadText !== "function") { throw new Error("Target of \"pliTextBox\" binding must have a \"_loadText\" method (did you use \"pli.observable\"?)"); }
	    if (typeof o._initBinding !== "function") { throw new Error("Target of \"pliTextBox\" binding must have a \"_initBinding\" method (did you use \"pli.observable\"?)"); }
	    if (typeof o._removeController !== "function") { throw new Error("Target of \"pliTextBox\" binding must have a \"_removeController\" method (did you use \"pli.observable\"?)"); }
	    if (typeof o._updateView !== "function") { throw new Error("Target of \"pliTextBox\" binding must have a \"_updateView\" method (did you use \"pli.observable\"?)"); }
	    return o;
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Public
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = TextBoxController;
	


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(global, module) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	
	; jQuery = global.jQuery = __webpack_require__(2);
	; var __browserify_shim_require__=require;(function browserifyShim(module, define, require) {
	/**
	 * jQuery "splendid textchange" plugin, v1.2 alpha2
	 * http://benalpert.com/2013/06/18/a-near-perfect-oninput-shim-for-ie-8-and-9.html
	 *
	 * (c) 2013 Ben Alpert, released under the MIT license
	 */
	
	/*global jQuery: false */
	/*jslint browser: true */
	
	(function initSplendidTextChange($) {
	    "use strict";
	
	    // Determine if this is a modern browser (i.e. not IE 9 or older);
	    // if it is, the "input" event is exactly what we want so simply
	    // mirror it as "textchange" event
	    var testNode = document.createElement("input");
	    var isInputSupported = (testNode.oninput !== undefined &&
	        ((document.documentMode || 100) > 9));
	    if (isInputSupported) {
	        $(document).on("input", function mirrorInputEvent(e) {
	            $(e.target).trigger("textchange");
	        });
	
	        return;
	    }
	
	
	    // ********* OLD IE (9 and older) *********
	
	    var queueEventTargetForNotification = null;
	    var activeElement = null;
	    var notificationQueue = [];
	    var watchedEvents = "keyup keydown";
	        // 90% of the time, keydown and keyup aren't necessary. IE 8 fails
	        // to fire propertychange on the first input event after setting
	        // `value` from a script and fires only keydown, keypress, keyup.
	        // Catching keyup usually gets it and catching keydown lets us fire
	        // an event for the first keystroke if user does a key repeat
	        // (it'll be a little delayed: right before the second keystroke).
	
	
	    // Return true if the specified element can generate
	    // change notifications (i.e. can be used by users to input values).
	    function hasInputCapabilities(elem) {
	        // The HTML5 spec lists many more types than `text` and `password` on
	        // which the input event is triggered but none of them exist in IE 8 or
	        // 9, so we don't check them here
	        return (
	            (elem.nodeName === "INPUT" &&
	                (elem.type === "text" || elem.type === "password")) ||
	            elem.nodeName === "TEXTAREA"
	        );
	    }
	
	
	    // Update the specified target so that we can track its value changes.
	    // Returns true if extensions were successfully installed, false otherwise.
	    function installValueExtensionsOn(target) {
	        if (target.valueExtensions) {
	            return true;
	        }
	        if (!hasInputCapabilities(target)) {
	            return false;
	        }
	
	        // add extensions container
	        target.valueExtensions = {
	            current: null // not setting "current" initially (to "target.value") allows drag & drop operations (from outside the control) to send change notifications
	        };
	
	        // attempt to override "target.value" property
	        // so that it prevents "propertychange" event from firing
	        // (for consistency with "input" event behaviour)
	        if (target.constructor && target.constructor.prototype) { // target.constructor is undefined in quirks mode
	            var descriptor = Object.getOwnPropertyDescriptor(target.constructor.prototype, "value");
	            Object.defineProperty(target, "value", { // override once, never delete
	                get: function () {
	                    return descriptor.get.call(this);
	                },
	                set: function (val) {
	                    target.valueExtensions.current = val;
	                    descriptor.set.call(this, val);
	                }
	            });
	        }
	
	        // subscribe once, never unsubcribe
	        $(target)
	            .on("propertychange", queueEventTargetForNotification)
	            .on("dragend", function onSplendidDragend(e) {
	                window.setTimeout(function onSplendidDragendDelayed() {
	                    queueEventTargetForNotification(e);
	                }, 0);
	            });
	
	        return true;
	    }
	
	
	    // Fire "textchange" event for each queued element whose value changed.
	    function processNotificationQueue() {
	        // remember the current notification queue (for processing)
	        // + create a new queue so that if "textchange" event handlers
	        // cause new notification requests to be queued, they will be
	        // added to the new queue and handled in the next tick
	        var q = notificationQueue;
	        notificationQueue = [];
	
	        var target, targetValue, i, l;
	        for (i = 0, l = q.length; i < l; i += 1) {
	            target = q[i];
	            targetValue = target.value;
	            if (target.valueExtensions.current !== targetValue) {
	                target.valueExtensions.current = targetValue;
	                $(target).trigger("textchange");
	            }
	        }
	    }
	
	
	    // If target element of the specified event has not yet been
	    // queued for notification, queue it now.
	    queueEventTargetForNotification = function queueEventTargetForNotification(e) {
	        var target = e.target;
	        if (installValueExtensionsOn(target) && target.valueExtensions.current !== target.value) {
	            var i, l;
	            for (i = 0, l = notificationQueue.length; i < l; i += 1) {
	                if (notificationQueue[i] === target) {
	                    break;
	                }
	            }
	            if (i >= l) { // "target" is not yet queued
	                notificationQueue.push(target);
	
	                if (l === 0) { // we just queued the first item, schedule processor in the next tick
	                    window.setTimeout(processNotificationQueue, 0);
	                }
	            }
	        }
	    };
	
	
	    // Mark the specified target element as "active" and add event listeners to it.
	    function startWatching(target) {
	        activeElement = target;
	        $(activeElement).on(watchedEvents, queueEventTargetForNotification);
	    }
	
	
	    // Remove the event listeners from the "active" element and set "active" to null.
	    function stopWatching() {
	        if (activeElement) {
	            $(activeElement).off(watchedEvents, queueEventTargetForNotification);
	            activeElement = null;
	        }
	    }
	
	
	    // In IE 8, we can capture almost all .value changes by adding a
	    // propertychange handler (in "installValueExtensionsOn").
	    //
	    // In IE 9, propertychange/input fires for most input events but is buggy
	    // and doesn't fire when text is deleted, but conveniently,
	    // "selectionchange" appears to fire in all of the remaining cases so
	    // we catch those.
	    //
	    // In either case, we don't want to call the event handler if the
	    // value is changed from JS so we redefine a setter for `.value`
	    // that allows us to ignore those changes (in "installValueExtensionsOn").
	    $(document)
	        .on("focusin", function onSplendidFocusin(e) {
	            // stopWatching() should be a noop here but we call it just in
	            // case we missed a blur event somehow.
	            stopWatching();
	
	            if (installValueExtensionsOn(e.target)) {
	                startWatching(e.target);
	            }
	        })
	
	        .on("focusout", stopWatching)
	
	        .on("input", queueEventTargetForNotification)
	
	        .on("selectionchange", function onSplendidSelectionChange(e) {
	            // IE sets "e.target" to "document" in "onselectionchange"
	            // event (not very useful); use document.selection instead
	            // to determine actual target element
	            if (document.selection) {
	                var r = document.selection.createRange();
	                if (r) {
	                    var p = r.parentElement();
	                    if (p) {
	                        e.target = p;
	                        queueEventTargetForNotification(e);
	                    }
	                }
	            }
	        });
	
	}(jQuery));
	
	}).call(global, module, undefined, undefined);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(19)(module)))

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}
	


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint todo: true */
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var numberUtil = __webpack_require__(21);
	var stringUtil = __webpack_require__(13);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Utility
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Create a function that will get error message
	// from "this.behaviourData" or use the specified
	// default message if not defined in "this.behaviourData".
	function createGetErrorMessage(behaviourDataProperty, defaultMessage) {
	    return function getErrorMessage() {
	        var behaviourData = this.behaviourData;
	        return (behaviourData && behaviourData[behaviourDataProperty]) || defaultMessage;
	    };
	}
	
	
	//-------------------------------------------
	// Extract the custom format from the specified
	// "behaviourData" or return the default
	// (if not specified by "behaviourData").
	function getCustomFormatOrDefault(behaviourData, defaultFormat) {
	    if (typeof behaviourData === "string") { return behaviourData; }
	    return (behaviourData && typeof behaviourData.format === "string")
	        ? behaviourData.format
	        : defaultFormat;
	}
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "NumericBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Behaviour that ensures "this" observable
	// resolves to a numeric value or null.
	function NumericBehaviour() {
	    return this; // keep JSLint happy
	}
	
	
	//-------------------------------------------
	NumericBehaviour.prototype.format = function numericBehaviourFormat(value, format) {
	    return (numberUtil.isNumber(value)
	        ? numberUtil.formatNumber(value, format || getCustomFormatOrDefault(this.behaviourData))
	        : "");
	};
	
	
	//-------------------------------------------
	NumericBehaviour.prototype.parse = function numericBehaviourParse(value) {
	    var num = numberUtil.parseNumber(value);
	    return (isNaN(num) ? NumericBehaviour.prototype._getErrorMessage : num);
	};
	
	
	//-------------------------------------------
	NumericBehaviour.prototype.validate = function numericBehaviourValidate(value) {
	    var isValid = (value === null || value === undefined || numberUtil.isNumber(value));
	    return (isValid ? null : NumericBehaviour.prototype._getErrorMessage);
	};
	
	
	//-------------------------------------------
	NumericBehaviour.prototype._getErrorMessage = createGetErrorMessage("errorNumericValue", "Invalid number");
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "RepeatedValueBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Behaviour that ensures "this" observable
	// resolves to a value that is the same as
	// another value (source specified in "behaviourData").
	function RepeatedValueBehaviour() {
	    this.defer = true;
	}
	
	
	//-------------------------------------------
	RepeatedValueBehaviour.prototype.init = function repeatedValueBehaviourInit() {
	    if (!this.behaviourData) { throw new Error("RepeatedValueBehaviour requires \"behaviourData.source\""); }
	    var source = this.behaviourData.source;
	    if (!ko.isSubscribable(source)) { throw new Error("RepeatedValueBehaviour requires \"behaviourData.source\" that is a Knockout subscribable"); }
	    source.subscribe(RepeatedValueBehaviour.prototype._revalidate, this);
	    if (!ko.isObservable(source.isValid)) { throw new Error("RepeatedValueBehaviour requires \"behaviourData.source.isValid\" that is a Knockout observable"); }
	};
	
	
	//-------------------------------------------
	RepeatedValueBehaviour.prototype.validate = function repeatedValueBehaviourValidate(value) {
	    var source = this.behaviourData.source;
	    return (!source.isValid.peek() || source.peek() === value
	        ? null
	        : RepeatedValueBehaviour.prototype._getErrorMessage);
	};
	
	
	//-------------------------------------------
	RepeatedValueBehaviour.prototype._getErrorMessage = createGetErrorMessage("errorRepeatedValue", "Value does not match");
	
	
	//-------------------------------------------
	RepeatedValueBehaviour.prototype._revalidate = function repeatedValueBehaviourRevalidate() {
	    if (this._isActivated) {
	        this.validate();
	    }
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "RequiredBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Behaviour that ensures "this" observable
	// resolves to non-null value.
	//
	// "behaviourData.requiredWhen" is an optional
	// function that can be specified to limit/throttle
	// "required" validation. It is expected
	// to match the following interface:
	//
	// interface RequiredWhenPredicate {
	//     (): boolean;
	// }
	//
	// When specified, "behaviourData.requiredWhen"
	// will be wrapped in a Knockout pure computed
	// (i.e. it will be rerun when any observable it
	// depends on changes). Each change to the result
	// of this computed will trigger revalidation.
	//
	// Examples:
	//
	// // always validate non-nullness of "a"
	// var a = pli.observable("", null, pli.observable.behaviours.required);
	//
	// // only validate non-nullness of "b" when "a" is set to a valid number that is greater than 10
	// var a = pli.observable(null, null, pli.observable.behaviours.numeric);
	// var b = pli.observable(
	//     "",
	//     { requiredWhen: () => a.isValid() && a() > 10 },
	//     pli.observable.behaviours.required);
	//
	// // only validate non-nullness of "c" when both "a" and "b" are valid
	// var a = pli.observable(null, null, pli.observable.behaviours.numeric);
	// var b = pli.observable(null, null, pli.observable.behaviours.numeric);
	// var c = pli.observable(
	//     "",
	//     { requiredWhen: () => a.isValid() && b.isValid() },
	//     pli.observable.behaviours.required);
	//
	function RequiredBehaviour() {
	    this.defer = true;
	}
	
	
	//-------------------------------------------
	RequiredBehaviour.prototype.init = function requiredBehaviourInit() {
	    var requiredWhen = (this.behaviourData && this.behaviourData.requiredWhen);
	    if (requiredWhen) {
	        if (typeof requiredWhen !== "function") { throw new Error("RequiredBehaviour requires \"behaviourData.requiredWhen\" to be a function"); }
	        this.behaviourData.requiredWhenComputed = ko.pureComputed(RequiredBehaviour.prototype._evaluateRequiredWhen, this);
	        this.behaviourData.requiredWhenComputed.subscribe(RequiredBehaviour.prototype._revalidate, this);
	    }
	};
	
	
	//-------------------------------------------
	RequiredBehaviour.prototype.validate = function requiredBehaviourValidate(value) {
	    // only proceed when "requiredWhen" is happy (or there is no "requiredWhen")
	    // (result of last evaluation of "requiredWhen" is stored in "requiredWhenComputed")
	    var requiredWhenComputed = (this.behaviourData && this.behaviourData.requiredWhenComputed);
	    if (requiredWhenComputed && !requiredWhenComputed()) {
	        return null; // skip this validation, reporting it as valid for now
	    }
	
	    // check for empty string, empty array, and null/undefined
	    var isValid = (typeof value === "string"
	        ? !stringUtil.isNullOrWhitespace(value)
	        : Array.isArray(value)
	            ? value.length !== 0
	            : value !== null && value !== undefined);
	    return (isValid ? null : RequiredBehaviour.prototype._getErrorMessage);
	};
	
	
	//-------------------------------------------
	RequiredBehaviour.prototype._getErrorMessage = createGetErrorMessage("errorRequiredValue", "Required value");
	
	
	//-------------------------------------------
	RequiredBehaviour.prototype._evaluateRequiredWhen = function requiredBehaviourEvaluateRequiredWhen() {
	    return !!this.behaviourData.requiredWhen();
	};
	
	
	//-------------------------------------------
	RequiredBehaviour.prototype._revalidate = function requiredBehaviourRevalidate() {
	    if (this._isActivated) {
	        this.validate();
	    }
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "ValidateBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Behaviour that ensures the specified validation
	// function runs when "this" observable is validated.
	function ValidateBehaviour(validateFunction) {
	    this.defer = !!validateFunction.defer;
	    this.validate = validateFunction;
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "PliTextBoxObservable" class (and helper functions)
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// If source contains definition of the specified
	// method, make sure target does not contain
	// it yet and then add it to target.
	function extractSingleBehaviourMethod(source, target, functionName) {
	    if (typeof source[functionName] === "function") {
	        if (typeof target[functionName] === "function") { throw new Error("Only one behaviour with \"" + functionName + "\" method is allowed"); }
	        target[functionName] = source[functionName];
	    }
	}
	
	
	/**
	 * Return normalized version of the specified value:
	 * - undefined => null
	 * - null => null
	 * - (dateValue) => new Date(dateValue) -- clone date values because
	 *     they are mutable objects so changes made by Pli observable
	 *     would immediately change caller's value as well (when referencing
	 *     the same instance)
	 * - (value) => (value)
	 */
	function normalizeValue(value) {
	    return (value instanceof Date)
	        ? new Date(value)
	        : (value === undefined ? null : value);
	}
	
	
	//-------------------------------------------
	// Recursively load behaviours from the specified
	// source + trigger init methods (in the context
	// of the specified "observable").
	function loadBehaviours(source, target, observable) {
	    var behaviour, i;
	
	    // check for registered behaviour
	    if (typeof source === "string") {
	        behaviour = ko.observablePliTextBox.behaviours[source];
	        if (!behaviour) { throw new Error("Behaviour \"".concat(source, "\" is not known (did you register it in \"ko.observablePliTextBox.behaviours\"?)")); }
	        loadBehaviours(behaviour, target, observable);
	
	    // check for validate behaviour
	    } else if (typeof source === "function") {
	        loadBehaviours(new ValidateBehaviour(source), target, observable);
	
	    // check for an array
	    } else if (Object.prototype.toString.call(source) === "[object Array]") {
	        for (i = 0; i < source.length; i += 1) {
	            loadBehaviours(source[i], target, observable);
	        }
	
	    // check for behaviour object
	    } else if (source && typeof source === "object") {
	        target.push(source);
	        extractSingleBehaviourMethod(source, target, "format");
	        extractSingleBehaviourMethod(source, target, "initBinding");
	        extractSingleBehaviourMethod(source, target, "parse");
	        extractSingleBehaviourMethod(source, target, "show");
	        extractSingleBehaviourMethod(source, target, "updateBinding");
	        if (typeof source.init === "function") {
	            source.init.call(observable);
	        }
	    }
	
	    return target;
	}
	
	
	//-------------------------------------------
	// Create a function that calls "targetFn"
	// (preserving "this" context) and ensuring
	// that "this._internalUpdate" will be
	// true while "targetFn" is running (preventing
	// execution of "_onObservableChanged").
	function createInternalUpdateGuard(targetFn) {
	    return function internalUpdateGuard() {
	        var originalValue = this._internalUpdate;
	        this._internalUpdate = true;
	        try {
	            return targetFn.apply(this, arguments);
	        } finally {
	            this._internalUpdate = originalValue;
	        }
	    };
	}
	
	
	//-------------------------------------------
	// Find index of the specified controller in
	// the specified collection of controllers.
	function findControllerIndex(c, controllers) {
	    var i, l;
	    for (i = 0, l = controllers.length; i < l; i += 1) {
	        if (c === controllers[i]) {
	            return i;
	        }
	    }
	    return -1;
	}
	
	
	//-------------------------------------------
	// Initialize a new instance of PliTextBoxObservable.
	// See: https://github.com/pandell/Pli/wiki/Text-Box-Observable#configuration
	function PliTextBoxObservable(initialValue, behaviourData) {
	    // properties
	    var allowUndefined = (behaviourData && behaviourData.allowUndefined);
	    var o = ko.observable(allowUndefined && initialValue === undefined ? undefined : null);
	    o.behaviourData = normalizeValue(behaviourData);
	    o.isValid = ko.observable(true);
	    o._behaviours = [];
	    o._controllers = [];
	    o._internalUpdate = false;
	    o._isActivated = false;
	    o._errorMessage = null;
	    o._raw = null; // will only be not-null (string) when parsing fails
	
	    // methods
	    var p = PliTextBoxObservable.prototype;
	    o.format = p.format;
	    o.load = p.load;
	    o.peekValue = p.peekValue;
	    o.reset = p.reset;
	    o.setErrorMessage = p.setErrorMessage;
	    o.show = p.show;
	    o.validate = p.validate;
	    o._addController = p._addController;
	    o._initBinding = p._initBinding;
	    o._loadText = p._loadText;
	    o._removeController = p._removeController;
	    o._updateBinding = p._updateBinding;
	    o._updateView = p._updateView;
	
	    // make sure state is updated when main observable changes
	    o.subscribe(p._onObservableChanged, o);
	
	    // load and initialize behaviours
	    var behavioursSpec = Array.prototype.slice.call(arguments, 2);
	    behavioursSpec.unshift(o.behaviourData && o.behaviourData.behaviours); // [behaviourData.behaviours, argument[2], ..., argument[n]]
	    loadBehaviours(behavioursSpec, o._behaviours, o);
	
	    // set initial value of our new observable
	    o(allowUndefined ? initialValue : normalizeValue(initialValue)); // will trigger validation and updateView if not null
	    return o;
	}
	
	
	//-------------------------------------------
	// Convert current value of this observable to
	// a string using the specified or the default
	// format. If current value is not valid, returns
	// the source string (before validation/parsing).
	//
	// Does not mutate state.
	PliTextBoxObservable.prototype.format = function textBoxObservableFormat(customFormat) {
	    var value = this.peek();
	    if (value === null || value === undefined) {
	        return (this._raw || "");
	    }
	
	    return (this._behaviours.format
	        ? this._behaviours.format.call(this, value, customFormat)
	        : value.toString());
	};
	
	
	//-------------------------------------------
	// Loads the value of the observable using either a parsed or raw value.
	// See: https://github.com/pandell/Pli/wiki/Text-Box-Observable#load-method
	//
	// Uses internal update guard (see "createInternalUpdateGuard").
	PliTextBoxObservable.prototype.load = createInternalUpdateGuard(
	    function textBoxObservableLoad(value, ignoreFocus) {
	        // update root observable + _raw
	        var allowUndefined = (this.behaviourData && this.behaviourData.allowUndefined);
	        value = (allowUndefined ? value : normalizeValue(value));
	        var errorSpec = PliTextBoxObservable.prototype._validateValue.call(this, value);
	        var updateNeeded;
	        if (errorSpec === null) { // specified value is valid, set it (and reset validation error, if any)
	            updateNeeded = (PliTextBoxObservable.prototype._applyErrorSpec.call(this, null) || this.peek() !== value);
	            this._raw = null;
	            this(value); // "_onObservableChanged" will be skipped because of internal update guard
	        } else { // specified value is not valid, set it as text (will attempt to parse & validate it)
	            updateNeeded = PliTextBoxObservable.prototype._loadText.call(this, value);
	        }
	
	        // update view (if needed)
	        if (updateNeeded) {
	            this._updateView(ignoreFocus);
	        }
	    }
	);
	
	
	//-------------------------------------------
	// Return value of "this" observable using
	// "observable.peek" if not null; otherwise
	// return last (string) value that we
	// attempted to parse.
	PliTextBoxObservable.prototype.peekValue = function textBoxObservablePeekValue() {
	    var v = this.peek();
	    return (v === null ? this._raw : v);
	};
	
	
	//-------------------------------------------
	// Clear the state and value of "this" observable.
	// See: https://github.com/pandell/Pli/wiki/Text-Box-Observable#reset-method
	//
	// Uses internal update guard (see "createInternalUpdateGuard").
	PliTextBoxObservable.prototype.reset = createInternalUpdateGuard(
	    function textBoxObservableReset(skipUpdateView, resetRaw, resetValue) {
	        if (this._isActivated || !this.isValid.peek() || this.peekValue() !== null) {
	            PliTextBoxObservable.prototype._applyErrorSpec.call(this, null); // reset validation error (if any)
	            this._isActivated = false;
	            this._raw = (resetRaw === undefined ? null : resetRaw);
	            this(resetValue === undefined ? null : resetValue); // "_onObservableChanged" will be skipped because of internal update guard
	            if (!skipUpdateView) {
	                this._updateView(true); // true -> ignoreFocus (i.e., update view even if currently focused)
	            }
	        }
	    }
	);
	
	
	//-------------------------------------------
	// Set the error mesage for "this" observable.
	// See: https://github.com/pandell/Pli/wiki/Text-Box-Observable#seterrormessage-method
	PliTextBoxObservable.prototype.setErrorMessage = function textBoxObservableSetErrorMessage(errorSpec) {
	    var updateNeeded = PliTextBoxObservable.prototype._applyErrorSpec.call(this, errorSpec);
	    if (updateNeeded) {
	        this._updateView();
	    }
	
	    return !this.isValid.peek();
	};
	
	
	//-------------------------------------------
	// Display selection for for "this" observable
	// (if defined by one of its behaviours).
	// See: https://github.com/pandell/Pli/wiki/Text-Box-Observable#show-method
	//
	// settings.onShowDone: (required, function)
	//     reference of a function that will be called
	//     when selection form is closed; the function
	//     will receive selected value as parameter
	//     (or "undefined" if the form was cancelled)
	//
	// settings.onShowDoneContext: (optional, object)
	//     optional object that will be used to set
	//     context ("this") in "settings.onShowDone"
	//     function (when called).
	//
	// settings.$input: (optional, jQuery object)
	//     DOM element that triggered this "show" call;
	//     can be used for position calculation, focus
	//     restoration, etc.
	PliTextBoxObservable.prototype.show = function textBoxObservableShow(settings) {
	    if (this._behaviours.show) {
	        if (!settings || typeof settings.onShowDone !== "function") { throw new Error("settings.onShowDone is required (function)"); }
	        return this._behaviours.show.call(
	            this, // preserve "this"
	            settings
	        );
	    }
	};
	
	
	//-------------------------------------------
	// Verify that the value of "this" observable is correct.
	// See: https://github.com/pandell/Pli/wiki/Text-Box-Observable#validate-method
	PliTextBoxObservable.prototype.validate = function textBoxObservableValidate(skipActivation) {
	    // apply pending changes (there should be
	    // at most one controller with pending
	    // changes at any time, but we need to check
	    // them all); this will ensure that we are
	    // validating the right value
	    var i, l;
	    for (i = 0, l = this._controllers.length; i < l; i += 1) {
	        this._controllers[i]._applyChanges(); // will do nothing if this controller has no pending changes
	    }
	
	    if (!skipActivation) {
	        this._isActivated = true;
	    }
	
	    var value = this.peek();
	    if (value !== null || this._raw === null) { // only re-validate if value parsing succeeded
	        var errorSpec = PliTextBoxObservable.prototype._validateValue.call(this, value);
	        this.setErrorMessage(errorSpec);
	    }
	
	    return this.isValid.peek();
	};
	
	
	//-------------------------------------------
	// Add the specified controller to this
	// observable's controllers collection.
	PliTextBoxObservable.prototype._addController = function textBoxObservableAddController(c) {
	    if (findControllerIndex(c, this._controllers) === -1) {
	        this._controllers.push(c);
	    }
	};
	
	
	//-------------------------------------------
	// Update validation-error state of "this" observable.
	// Returns true if state of this observable changed
	// (i.e. view update is needed), false otherwise.
	PliTextBoxObservable.prototype._applyErrorSpec = function textBoxObservableApplyErrorSpec(errorSpec) {
	    var isValid, message;
	    if (errorSpec) {
	        isValid = false;
	        message = (typeof errorSpec === "function" ? errorSpec.call(this) : errorSpec.toString());
	        message = (message || "Unknown error");
	    } else {
	        isValid = true;
	        message = null;
	    }
	
	    if (isValid !== this.isValid.peek() || message !== this._errorMessage) {
	        this._errorMessage = message;
	        this.isValid(isValid);
	        return true;
	    }
	
	    return false;
	};
	
	
	//-------------------------------------------
	// Allow one of the behaviours associated with
	// this text box observable to contribute
	// to binding initialization.
	PliTextBoxObservable.prototype._initBinding = function textBoxObservableInitBinding(textBoxController, allBindings) {
	    if (this._behaviours.initBinding) {
	        return this._behaviours.initBinding.call(this, textBoxController, allBindings);
	    }
	};
	
	
	//-------------------------------------------
	// Load the specified text as value of this
	// observable. Attempts to parse the text
	// using behaviour parser (if any). Returns
	// true if state of this observable changed
	// (i.e. view update is needed), false otherwise.
	//
	// Uses internal update guard (see "createInternalUpdateGuard").
	PliTextBoxObservable.prototype._loadText = createInternalUpdateGuard(
	    function textBoxObservableLoadText(text) {
	        if (text !== null && text !== undefined) {
	            text = text.toString();
	        }
	
	        // step 1: parse text
	        var value = text;
	        var raw = null;
	        var updateNeeded = false;
	        var validationNeeded = true;
	        if (typeof this._behaviours.parse === "function") {
	            value = this._behaviours.parse.call(this, value);
	            if (typeof value === "function") { // parsing failed
	                updateNeeded = PliTextBoxObservable.prototype._applyErrorSpec.call(this, value);
	                validationNeeded = false;
	                value = null;
	                raw = text;
	            }
	        }
	
	        // step 2: validate (if needed)
	        if (validationNeeded) {
	            var errorSpec = PliTextBoxObservable.prototype._validateValue.call(this, value);
	            updateNeeded = PliTextBoxObservable.prototype._applyErrorSpec.call(this, errorSpec);
	        }
	
	        // step 3: update main observable and _raw (if needed)
	        if (this.peek() !== value || (value === null && this._raw !== raw)) {
	            updateNeeded = true;
	            this._raw = raw;
	            this(value); // "_onObservableChanged" will be skipped because of internal update guard
	        }
	
	        return updateNeeded;
	    }
	);
	
	
	//-------------------------------------------
	// Synchronize state of "this" observable
	// with its new value.
	//
	// Performs no actions if called due to the actions
	// of a function wrapped by the internal update guard
	// (see "createInternalUpdateGuard").
	PliTextBoxObservable.prototype._onObservableChanged = function textBoxObservableOnObservableChanged(value) {
	    var o = this;
	    if (o._internalUpdate) { return; }
	
	    if (value === undefined && (!o.behaviourData || !o.behaviourData.allowUndefined)) {
	        throw new Error("Invalid value, \"ko.observablePliTextBox\" does not accept \"undefined\" by default -- either use \"load\" method or set \"behaviourData.allowUndefined\"");
	    }
	    if (PliTextBoxObservable.prototype._validateValue.call(o, value) !== null) {
	        throw new Error("Invalid value, \"ko.observablePliTextBox\" only accepts valid values -- please use \"load\" method instead");
	    }
	
	    o._raw = null;
	    PliTextBoxObservable.prototype._applyErrorSpec.call(o, null); // reset last validation error (if any)
	    o._updateView();
	};
	
	
	//-------------------------------------------
	// Remove the specified controller from "this"
	// observable's collection of controllers.
	PliTextBoxObservable.prototype._removeController = function textBoxObservableRemoveController(c) {
	    var i = findControllerIndex(c, this._controllers);
	    if (i !== -1) {
	        this._controllers.splice(i, 1);
	    }
	};
	
	
	/**
	 * Allows one of the behaviours associated with this text box observable to contribute to binding update.
	 *
	 * @param textBoxController
	 *      Associated TextBoxController instance.
	 * @param allBindings
	 *      Knockout 'allBindings' property passed to update handler.
	 * @returns
	 *      Value returned by updateBinding behaviour if defined; otherwise 'undefined'.
	 */
	PliTextBoxObservable.prototype._updateBinding = function textBoxObservableUpdateBinding(textBoxController, allBindings) {
	    if (this._behaviours.updateBinding) {
	        return this._behaviours.updateBinding.call(this, textBoxController, allBindings);
	    }
	};
	
	
	//-------------------------------------------
	// Update view of all controllers currently
	// associated with this observable.
	PliTextBoxObservable.prototype._updateView = function textBoxObservableUpdateView() {
	    var i, l, c;
	    for (i = 0, l = this._controllers.length; i < l; i += 1) {
	        c = this._controllers[i];
	        c.updateView.apply(c, arguments);
	    }
	};
	
	
	//-------------------------------------------
	// Validate the specified value against all
	// behaviours of "this" observable.
	//
	// Does not mutate state, only returns an
	// errorSpec (null if valid, function or
	// a string otherwise).
	PliTextBoxObservable.prototype._validateValue = function textBoxObservableValidateValue(value) {
	    var activated = this._isActivated;
	    var behaviours = this._behaviours;
	
	    var i, l, b, errorSpec;
	    for (i = 0, l = behaviours.length; i < l; i += 1) {
	        b = behaviours[i];
	        if (b && (activated || !b.defer) && typeof b.validate === "function") {
	            errorSpec = b.validate.call(this, value);
	            if (errorSpec !== null) {
	                return errorSpec;
	            }
	        }
	    }
	    return null;
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	PliTextBoxObservable.shared = {
	    createGetErrorMessage: createGetErrorMessage,
	    getCustomFormatOrDefault: getCustomFormatOrDefault
	};
	PliTextBoxObservable.behaviours = {
	    numeric: new NumericBehaviour(),
	    repeatedValue: new RepeatedValueBehaviour(),
	    required: new RequiredBehaviour()
	};
	
	module.exports = PliTextBoxObservable;
	


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	// Regex used to remove valid non-numeric digits (whitespace, commas, $, %)
	var validCharactersRegex = new RegExp("[\\s\\$%,]+", "g");
	// Regex used to split every third number moving right to left
	var splitNumericRegex = new RegExp("(?=(?:\\d{3})+$)", "g");
	/**
	 * Checks the value to make sure it is a number.
	 * @returns {boolean}
	 *     true/false if the value is a number.
	 */
	function isNumber(value) {
	    return typeof value === "number" && !isNaN(value);
	}
	exports.isNumber = isNumber;
	/**
	 * Parse the specified value (assumed to be a string or null/undefined).
	 * @returns {number}
	 *      The parsed number, or NaN if parsing fails.
	 */
	function parseNumber(value) {
	    if (value === null || value === undefined) {
	        return null;
	    }
	    value = value.toString().replace(validCharactersRegex, "");
	    if (!value.length) {
	        return null;
	    }
	    var acctNeg = value.charAt(0) === "(" && value.charAt(value.length - 1) === ")";
	    if (acctNeg) {
	        value = "-".concat(value.substring(1, value.length - 1));
	    }
	    return Number(value);
	}
	exports.parseNumber = parseNumber;
	/**
	 * Format the specified number to the specified format.
	 * @returns {string}
	 *      The formatted string.
	 */
	function formatNumber(value, format) {
	    if (!isNumber(value)) {
	        return "";
	    }
	    if (typeof format === "string" && format.length > 0) {
	        var isAcct = format.charAt(0) === "(" && format.charAt(format.length - 1) === ")";
	        if (isAcct) {
	            format = format.substring(1, format.length - 1);
	        }
	        var formatType = format.charAt(0), precision = parseInt(format.substring(1), 10), parsed = isNumber(precision) ? value.toFixed(precision) : value;
	        switch (formatType) {
	            case "C":
	            case "c":
	                if (isAcct) {
	                    return (parsed < 0 ? "($" : "$").concat(addCommas(parsed), (parsed < 0 ? ")" : ""));
	                }
	                else {
	                    return (parsed < 0 ? "-$" : "$").concat(addCommas(parsed));
	                }
	            case "P":
	            case "p":
	                if (isAcct) {
	                    return (parsed < 0 ? "(" : "").concat(addCommas(parsed), (parsed < 0 ? ")" : ""), " %");
	                }
	                else {
	                    return (parsed < 0 ? "-" : "").concat(addCommas(parsed), " %");
	                }
	            case "N":
	            case "n":
	            default:
	                if (isAcct) {
	                    return (parsed < 0 ? "(".concat(parsed.toString().slice(1), ")") : parsed.toString());
	                }
	                return "".concat(parsed.toString());
	        }
	    }
	    return "".concat(value.toString());
	}
	exports.formatNumber = formatNumber;
	/**
	 * Add commas to the number.
	 * @returns {string}
	 *      String formatted with commas.
	 * @example
	 *      5000.2512 => "5,000.2512"
	 *      5000      => "5,000"
	 */
	function addCommas(value) {
	    var v = value.toString(), n = v[0] === "-", s = (n ? v.slice(1) : v).split("."), b = (s[0] || "").split(splitNumericRegex).join(",");
	    return s[1] !== undefined ? b.concat(".", s[1]) : b;
	}
	



/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	var R = __webpack_require__(7);
	
	
	/**
	 * Returns true if the unwrapped "this" contains the word "empty".
	 */
	/*function containsEmpty(this: MaybeObservable<string>): boolean {*/
	function containsEmpty() {
	    /*jshint validthis:true*/
	    return ko.unwrap(this).indexOf("empty") >= 0;
	}
	
	//-------------------------------------------
	// Ensures subscriptions are created using
	// ko.toJS when "this._internalUpdate" is true.
	// "targetFn" is always called.
	function createInternalSubscription(name, targetFn) {
	    var properties = name.split(".");
	    return function internalEnsureSubscription() {
	        var i, l, item = this;
	        for (i = 0, l = properties.length; i < l; i += 1) {
	            item = item[properties[i]];
	            if (item === undefined) { break; }
	        }
	        if (this._internalUpdate) { ko.toJS(item); }
	        return targetFn.apply(this, arguments);
	    };
	}
	
	//-------------------------------------------
	// Create a function that calls "targetFn"
	// (preserving "this" context) and ensuring
	// that "this._internalUpdate" will be
	// true while "targetFn" is running (preventing
	// execution of "_onObservableChanged").
	function createInternalUpdateGuard(targetFn) {
	    return function internalUpdateGuard() {
	        if (this._internalUpdate) { return; }
	        var originalValue = this._internalUpdate;
	        this._internalUpdate = true;
	        try {
	            return targetFn.apply(this, arguments);
	        } finally {
	            this._internalUpdate = originalValue;
	        }
	    };
	}
	
	//-------------------------------------------
	// Builds a list of functions to resolve paths specified,
	// ending with a function that returns the `defaultValue`.
	var getPathResolvers = R.compose(
	        R.flatten, // flatten R.map and R.compose results into plain list of functions
	        R.ap([
	            R.compose(
	                R.map(R.compose(R.path, R.split("."))), // create R.path call for every path in sequence
	                R.filter(R.compose(R.identical("String"), R.type)), // filter non-stringy paths
	                R.tail // treat tail as list of paths
	            ),
	            R.compose(R.always, R.head) // treat first element as defaultValue
	        ]),
	        R.of // transform arguments array to [arguments] for R.ap call input
	    );
	
	//-------------------------------------------
	// Creates a function that will resolve the value using the paths supplied
	// until a defined value of string type is found. If no value is found
	// the defaultValue is returned. defaultValue is expected to be of string type.
	//
	// Example.
	// var resolver = createResolverFunction("", "defaultValue", "viewModel.defaultValue", "viewModel.prototype.defaultValue");
	// resolver({ defaultValue: "yep" }); // => "yep"
	function createDefaultValueResolverFunction(defaultValue) {
	
	    if (defaultValue === undefined) { throw new Error("defaultValue must be defined"); }
	    if (typeof defaultValue !== "string") { throw new Error("defaultValue must be of string type"); }
	
	    // Builds a function that executes each of the functions above until
	    // a `defined` value is found.
	    return R.compose(
	        R.head,
	        R.filter(R.compose(R.identical("String"), R.type)),
	        R.ap(getPathResolvers(arguments)),
	        R.of
	    );
	}
	
	module.exports = {
	    containsEmpty: containsEmpty,
	    createInternalSubscription: createInternalSubscription,
	    createInternalUpdateGuard: createInternalUpdateGuard,
	    removeSurroundingWildcards: new RegExp("^\\*|\\*$", "g"),
	    createDefaultValueResolverFunction: createDefaultValueResolverFunction
	};
	


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var pliObservable = __webpack_require__(15);
	var stringUtil = __webpack_require__(13);
	
	__webpack_require__(24);
	
	var shared = __webpack_require__(22);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// PicklistAdvancedSearchItem template
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	var splitPicklistRegex = new RegExp("([^\\\\\\][^;]|\\\\;)+", "g");
	
	//-------------------------------------------
	function PicklistAdvancedSearchItem(behaviourData) {
	    if (!(this instanceof PicklistAdvancedSearchItem)) { return new PicklistAdvancedSearchItem(behaviourData); } // if new was not used, force it now
	
	    // indicates how the string fields are searched
	    // - `is` include any items with exact matches (default)
	    // - `contains` includes any items with partial matches
	    // - `is not` excludes any items with exact matches
	    // - `is empty` includes items that do not have a value (`enableEmpty` must be set on behaviourData)
	    // - `is not empty` includes items that have any value (`enableEmpty` must be set on behaviourData)
	    this.operator = ko.observable("is");
	
	    this.value = pliObservable(); // contains value of the phrase to match
	    this.selected = pliObservable(null, behaviourData, "multiselect"); // contains the value if picklist
	
	    // extras
	    this.extras = function picklistAdvancedSearchItemExtras() { return; };
	    this.extras.enableEmpty = !!(behaviourData && behaviourData.enableEmpty);
	    this.extras.isEmpty = ko.pureComputed(shared.containsEmpty, this.operator);
	}
	
	
	//-------------------------------------------
	PicklistAdvancedSearchItem.prototype.templateId = "picklistAdvancedSearchItem";
	
	
	//-------------------------------------------
	// Loads the picklist advancedSearch view model from the
	// phrase specified.
	PicklistAdvancedSearchItem.prototype.load = function picklistAdvancedSearchItemLoad(phrase, not) {
	    var selectedValue = null,
	        textValue = "",
	        operatorValue = "is";
	
	    if (not) {
	        if (phrase === "[empty]") {
	            operatorValue = "is not empty";
	        } else {
	            operatorValue = "not";
	            selectedValue = this._split(phrase);
	        }
	    } else if (!stringUtil.isNullOrWhitespace(phrase)) {
	        phrase = phrase.trim();
	        var withoutWildcards = phrase.replace(shared.removeSurroundingWildcards, "");
	        if (phrase === "[empty]") {
	            operatorValue = "is empty";
	        } else if (withoutWildcards[0] !== phrase[0] && withoutWildcards[textValue.length - 1] !== phrase[phrase.length - 1]) { // test for contains if both leading/trailing characters have changed (* removed)
	            operatorValue = "contains";
	            textValue = withoutWildcards;
	        } else {
	            selectedValue = this._split(phrase);
	        }
	    }
	
	    this.operator(operatorValue);
	    this.value.load(textValue);
	    this.selected.load(selectedValue);
	};
	
	
	//-------------------------------------------
	// Returns the string representation of the search
	// phrase based on the currently selected view-model.
	PicklistAdvancedSearchItem.prototype.save = function picklistAdvancedSearchItemSave() {
	    var phrase, not,
	        value = this.value(),
	        selected = this.selected(),
	        operator = this.operator();
	
	    switch (operator) {
	    case "not":
	        phrase = this._join(selected);
	        not = true;
	        break;
	    case "contains":
	        if (!stringUtil.isNullOrWhitespace(value)) {
	            phrase = "*".concat(value.replace(shared.removeSurroundingWildcards, ""), "*");
	        } else {
	            phrase = "";
	        }
	        not = false;
	        break;
	    case "is":
	        phrase = this._join(selected);
	        not = false;
	        break;
	    case "is empty":
	        phrase = "[empty]";
	        not = false;
	        break;
	    case "is not empty":
	        phrase = "[empty]";
	        not = true;
	        break;
	    default:
	        phrase = "";
	        not = false;
	        break;
	    }
	
	    return [phrase, not];
	};
	
	
	//-------------------------------------------
	// Joins the array of selected pick-list items
	// also encodes any `;` (semi-colons).
	PicklistAdvancedSearchItem.prototype._join = function picklistAdvancedSearchItemJoin(selected) {
	    if (Array.isArray(selected)) {
	        var i, l, items = selected.slice();
	        for (i = 0, l = items.length; i < l; i += 1) {
	            items[i] = items[i].replace(";", "\\;");
	        }
	        return items.join(";");
	    }
	    return null;
	};
	
	
	//-------------------------------------------
	// Splits the string representation of pick-list
	// items and decodes any `\;`.
	PicklistAdvancedSearchItem.prototype._split = function picklistAdvancedSearchItemSplit(phrase) {
	    if (!stringUtil.isNullOrWhitespace(phrase)) {
	        var i, l, selected = phrase.match(splitPicklistRegex);
	        for (i = 0, l = selected.length; i < l; i += 1) {
	            selected[i] = "".concat(selected[i]).replace("\\;", ";");
	        }
	        return selected;
	    }
	    return null;
	};
	
	module.exports = PicklistAdvancedSearchItem;
	


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var pliTextBoxObservable = __webpack_require__(15);
	__webpack_require__(25);
	
	if (__webpack_require__(3).isBrowser) {
	    __webpack_require__(443);
	    ko.bindingHandlers.virtualScroll = __webpack_require__(444);
	}
	
	module.exports = pliTextBoxObservable.behaviours.multiselect = __webpack_require__(445);
	


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var pliObservable = __webpack_require__(15);
	var picklistBehaviour = __webpack_require__(26).behaviours.picklist;
	
	module.exports = pliObservable.behaviours.picklist = picklistBehaviour;
	


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint todo: true*/
	
	"use strict";
	
	var ko = __webpack_require__(9);
	var R = __webpack_require__(7);
	var Rx = __webpack_require__(27);
	
	var knockoutDataProvider = __webpack_require__(369);
	var DataState = __webpack_require__(378).DataState;
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	var QueryOrigin = __webpack_require__(378).QueryOrigin;
	var stateOfResponse = __webpack_require__(378).stateOfResponse;
	var stringUtil = __webpack_require__(13);
	
	var Shared = __webpack_require__(401);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "PicklistBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	/**
	 * Page-local state instance.
	 */
	var pageState = new Shared.PageState();
	
	/**
	 * Behaviour for a picklist type.
	 *
	 * This behaviour will introduce a new public property to target
	 * observable, "o.item". This observable will contain details of
	 * the selected item (usually row array from the data source) or null.
	 *
	 * "o.item" observable is useful when you need more information
	 * about the selected picklist item than its ID (which is stored
	 * as string value of the main observable).
	 */
	function PicklistBehaviour() {
	    return this; // keep JSLint happy
	}
	
	/**
	 * Initializes the picklist behaviour.
	 *
	 * @this PliTextBoxObservable
	 */
	PicklistBehaviour.prototype.init = function picklistBehaviourInit() {
	    // if no updateDelay was specified, default to 0
	    if (!this.behaviourData.updateDelay) {
	        this.behaviourData.updateDelay = 0;
	    }
	
	    // initialize picklist-specific properties
	    this.item = ko.observable(null);
	    this._displayIndex = this.behaviourData.displayValueIndex || 0;
	    this._idField = Shared.getIdField(this.behaviourData);
	    this._isBusy = false;
	    this._isFailed = false;
	    this._searchSubscription = null;
	
	    this._onDataUpdated = PicklistBehaviour.prototype._onDataUpdated.bind(this);
	    this._setItemObservable = PicklistBehaviour.prototype._setItemObservable.bind(this);
	
	    this._dataProvider = PicklistBehaviour.prototype._getDataProvider.call(this);
	    this._dataProvider
	        .search(Rx.Observable.of({}), QueryOrigin.Initial)
	        .map(function getOnDataUpdatedArgs(result, i) {
	            return [result, i === 0 /* initialUpdate */];
	        })
	        .subscribe(R.apply(this._onDataUpdated)); // R.apply will transform the array from getOnDataUpdatedArgs to individual arguments
	
	    this.subscribe(this._setItemObservable);
	};
	
	/**
	 * Convert bound DOM element to a Select2 picklist + setup all necessary event handlers.
	 *
	 * @param controller
	 *     TextBoxController instance.
	 * @this PliTextBoxObservable
	 */
	PicklistBehaviour.prototype.initBinding = function picklistBehaviourInitBinding(controller) {
	    if (controller.$input.length !== 1) { throw new Error("Expected exactly one binding target"); }
	
	    var placeholder = (this.behaviourData && this.behaviourData.placeholder) || controller.$input.attr("placeholder");
	
	    // Store event stream on controller. This allows target observable to
	    // change while still using the same event stream.
	    controller.eventStream = Shared.initializeSelect2(controller, R.merge({
	        allowClear: true,
	        getId: R.nthArg(1), // pull 'value' argument
	        pageState: pageState,
	        placeholder: placeholder
	    }, this.behaviourData.picklistSelect2Options || {})).publish(); // returns connectable observable
	
	    // TODO: when https://github.com/pandell/web-pli/issues/330 is tackled,
	    // the subscribable returned from "connect()" should be disposed when
	    // controller is disposed.
	    controller.eventStream.connect(); // begin publishing as hot observable (will not count references)
	};
	
	/**
	 * Attempt to parse an identifier value by looking it up in the current dataset.
	 *
	 * @param value
	 *      String value loaded into the picklist.
	 * @returns
	 *      The matching identifier if found; otherwise, an error provider function.
	 */
	PicklistBehaviour.prototype.parse = function picklistBehaviourParse(value) {
	    value = stringUtil.trim(value) || null; // normalize "value"
	    var found = this._dataProvider.findItem(value);
	    if (found.result === false) { // explicit check for "false", do not replace with falsy test
	        return (found.match === knockoutDataProvider.MatchResult.NoMatch
	            ? PicklistBehaviour.prototype._getErrorMessageInvalid
	            : PicklistBehaviour.prototype._getErrorMessageAmbiguous);
	    }
	
	    return found.result;
	};
	
	/**
	 * Display the picklist form for the current observable.
	 *
	 * Does not mutate state (but "picklistBehaviourOnShowDone"
	 * action will mutate state in the future if user selects a
	 * new value in picklist form).
	 *
	 * @param options
	 *     Options controlling the 'show' behaviour.
	 */
	PicklistBehaviour.prototype.show = function picklistBehaviourShow(options) {
	    var filterValue = pageState.openTextBoxQueryTerm;
	    if (pageState.openTextBox !== null) {
	        pageState.openTextBox.$input.select2("close");
	    }
	
	    // apply initial filtering if our observable
	    // has a value that does not uniquely identify
	    // a single item, but matches some items
	    var behaviourData = this.behaviourData || {};
	    var displayValueIndex = this._displayIndex;
	    var selectedItems = [];
	    var initialItem = this.item.peek();
	
	    if (initialItem) {
	        selectedItems.push(R.assoc(displayValueIndex, initialItem[displayValueIndex], {}));
	    }
	
	    // show picklist form
	    var observable = this;
	    pli.forms.registry.picklistForm.open({
	        dataProvider: this._dataProvider,
	        filterValue: filterValue,
	        filterDebounceTimeout: behaviourData.filterDebounceTimeout,
	        hideFilter: !!behaviourData.hideFilter,
	        idField: this._idField,
	        selectedItems: selectedItems,
	        createItem: behaviourData.createItem || behaviourData.onNewItem || null,
	        openSelectedItem: behaviourData.openSelectedItem || behaviourData.onOpenItem || null,
	        previewInit: behaviourData.previewInit || null,
	        containerCss: behaviourData.containerCss || null,
	        value: function picklistBehaviourOnShowDone(selectedItems) {
	            if (options.$input) {
	                options.$input.select2("focus");
	            }
	
	            var selectedValue; // default to undefined
	            if (typeof selectedItems === "object" && selectedItems.length) {
	                observable.item(selectedItems[0]);
	                selectedValue = selectedItems[0][displayValueIndex];
	            }
	
	            return options.onShowDone.call(options.onShowDoneContext, selectedValue);
	        },
	        text: behaviourData.text || null,
	        view: behaviourData.view || null
	    });
	
	    return false;
	};
	
	/**
	 * Set up query subscription when controller binding is updated.
	 *
	 * @param controller
	 *      TextBoxController instance.
	 */
	PicklistBehaviour.prototype.updateBinding = function picklistBehaviourUpdateBinding(controller) {
	    var targetObservable = this;
	    if (targetObservable._searchSubscription) {
	        targetObservable._searchSubscription.unsubscribe();
	        targetObservable._searchSubscription = null;
	    }
	
	    var eventStream = controller.eventStream;
	    if (!eventStream) {
	        throw new Error("\"controller.eventStream\" must contain an observable stream of select2 events.");
	    }
	    targetObservable._searchSubscription = targetObservable._dataProvider
	        .search(eventStream
	            .filter(R.propEq("type", "query"))
	            .map(function transformSelect2Options(e) {
	                // See http://select2.github.io/select2/#doc-query for QueryOptions interface documentation
	                var queryOptions = e.options;
	                return {
	                    context: R.merge(queryOptions, { pageState: pageState, rowIdIndex: targetObservable._displayIndex }),
	                    currentValue: targetObservable.peekValue(),
	                    filter: queryOptions.term
	                };
	            }))
	        .subscribe(Shared.processDataProviderResponse);
	};
	
	/**
	 * Validates a value supplied to a picklist.
	 *
	 * @param value
	 *     Identifier value to validate.
	 * @returns
	 *     'null' (valid) if the supplied identifier value is contained
	 *     in the current dataset; otherwise, returns an error provider function.
	 */
	PicklistBehaviour.prototype.validate = function picklistBehaviourValidate(value) {
	    var found = this._dataProvider.findItem(value);
	    if (found.match !== knockoutDataProvider.MatchResult.ExactMatch) {
	        return (found.match === knockoutDataProvider.MatchResult.NoMatch
	            ? PicklistBehaviour.prototype._getErrorMessageInvalid
	            : PicklistBehaviour.prototype._getErrorMessageAmbiguous);
	    }
	    return null;
	};
	
	/**
	 * @this PliTextBoxObservable
	 */
	PicklistBehaviour.prototype._getErrorMessageInvalid = pliObservable.shared.createGetErrorMessage("errorInvalidValue", "Invalid value");
	
	/**
	 * @this PliTextBoxObservable
	 */
	PicklistBehaviour.prototype._getErrorMessageAmbiguous = pliObservable.shared.createGetErrorMessage("errorAmbiguousValue", "More than one match");
	
	/**
	 * Gets the DataProvider instance providing us with the picklist data.
	 *
	 * @this PliTextBoxObservable
	 * @throws
	 *      If no provider was configured in "this.behaviourData"
	 * @returns
	 *      Knockout data provider.
	 */
	PicklistBehaviour.prototype._getDataProvider = function picklistBehaviourGetDataProvider() {
	    var behaviourData = this.behaviourData;
	    if (behaviourData) {
	        var settings = {
	            displayIndex: this._displayIndex,
	            exactMatchIgnoresCase: behaviourData.picklistValidationIgnoresCase,
	            filterLimit: behaviourData.picklistAutocompleteLimit,
	            itemFilterBuilder: behaviourData.itemFilterBuilder,
	            searchIndex: behaviourData.searchIndex
	                || (behaviourData.view && behaviourData.view.searchIndex)
	                || this._displayIndex
	        };
	        var source = null;
	
	        if (behaviourData.subscribe) { // check for the subscribe function instead of ko.isObservable (to handle cross window observables)
	            source = behaviourData;
	        } else if (behaviourData.picklistData && behaviourData.picklistData.subscribe) {
	            source = behaviourData.picklistData;
	        }
	        if (source) {
	            return knockoutDataProvider.createKnockoutDataProvider(source, settings);
	        }
	    }
	    throw new Error("\"behaviourData\" must contain a \"picklistData\" knockout observable.");
	};
	
	/**
	 * Update the state based on changes to the underlying data source.
	 *
	 * Parses the value if data has been loaded.
	 *
	 * @param dataResult
	 *      Response from the data provider.
	 * @this PliTextBoxObservable
	 */
	PicklistBehaviour.prototype._onDataUpdated = function picklistBehaviourOnDataUpdated(dataResult, initialUpdate) {
	    var updateNeeded = false;
	    var state = stateOfResponse(dataResult);
	    if (state === DataState.Ready) { // data is available now
	        updateNeeded = (this._isFailed || this._isBusy);
	        this._isFailed = false;
	        this._isBusy = false;
	    } else { // data is not available (either still loading or loading failed)
	        var isFailed = state === DataState.Error;
	        var isBusy = state === DataState.Busy;
	        updateNeeded = (this._isFailed !== isFailed || this._isBusy !== isBusy);
	        this._isFailed = isFailed;
	        this._isBusy = isBusy;
	    }
	
	    // ensure that 'parse' and 'validate' observable methods
	    // are not called during 'init'
	    if (initialUpdate !== true) { // explicit check, do not replace with "falsy"
	        updateNeeded = this._loadText(this.peekValue()) || updateNeeded;
	
	        if (updateNeeded) {
	            this._updateView();
	            this._setItemObservable(this.peekValue());
	        }
	    }
	};
	
	/**
	 * Sets the item observable based on a row ID value.
	 *
	 * @param value
	 *      String containing the current observable value.
	 */
	PicklistBehaviour.prototype._setItemObservable = function setPicklistItemObservable(value) {
	    this.item(this._dataProvider.findItem(value).item);
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	if (__webpack_require__(3).isBrowser) {
	    __webpack_require__(405);
	
	    var registerPicklistForm = __webpack_require__(406).registerPicklistForm;
	    var PicklistFormViewModel = __webpack_require__(441);
	
	    registerPicklistForm(PicklistFormViewModel);
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Public
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = {
	    behaviours: {
	        picklist: new PicklistBehaviour()
	    }
	};
	


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	/* tslint:disable:no-unused-variable */
	// Subject imported before Observable to bypass circular dependency issue since
	// Subject extends Observable and Observable references Subject in it's
	// definition
	var Subject_1 = __webpack_require__(28);
	exports.Subject = Subject_1.Subject;
	/* tslint:enable:no-unused-variable */
	var Observable_1 = __webpack_require__(29);
	exports.Observable = Observable_1.Observable;
	// statics
	/* tslint:disable:no-use-before-declare */
	__webpack_require__(45);
	__webpack_require__(49);
	__webpack_require__(52);
	__webpack_require__(64);
	__webpack_require__(68);
	__webpack_require__(71);
	__webpack_require__(73);
	__webpack_require__(76);
	__webpack_require__(84);
	__webpack_require__(87);
	__webpack_require__(90);
	__webpack_require__(92);
	__webpack_require__(94);
	__webpack_require__(97);
	__webpack_require__(106);
	__webpack_require__(109);
	__webpack_require__(111);
	__webpack_require__(115);
	__webpack_require__(117);
	__webpack_require__(119);
	__webpack_require__(122);
	__webpack_require__(125);
	__webpack_require__(128);
	__webpack_require__(131);
	__webpack_require__(135);
	//dom
	__webpack_require__(138);
	__webpack_require__(141);
	//operators
	__webpack_require__(149);
	__webpack_require__(151);
	__webpack_require__(153);
	__webpack_require__(155);
	__webpack_require__(157);
	__webpack_require__(159);
	__webpack_require__(161);
	__webpack_require__(163);
	__webpack_require__(165);
	__webpack_require__(166);
	__webpack_require__(167);
	__webpack_require__(169);
	__webpack_require__(172);
	__webpack_require__(175);
	__webpack_require__(177);
	__webpack_require__(179);
	__webpack_require__(181);
	__webpack_require__(183);
	__webpack_require__(185);
	__webpack_require__(187);
	__webpack_require__(189);
	__webpack_require__(191);
	__webpack_require__(193);
	__webpack_require__(195);
	__webpack_require__(197);
	__webpack_require__(199);
	__webpack_require__(201);
	__webpack_require__(203);
	__webpack_require__(205);
	__webpack_require__(208);
	__webpack_require__(210);
	__webpack_require__(212);
	__webpack_require__(214);
	__webpack_require__(216);
	__webpack_require__(219);
	__webpack_require__(224);
	__webpack_require__(226);
	__webpack_require__(228);
	__webpack_require__(230);
	__webpack_require__(232);
	__webpack_require__(234);
	__webpack_require__(236);
	__webpack_require__(238);
	__webpack_require__(240);
	__webpack_require__(242);
	__webpack_require__(244);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(253);
	__webpack_require__(255);
	__webpack_require__(259);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(263);
	__webpack_require__(266);
	__webpack_require__(268);
	__webpack_require__(270);
	__webpack_require__(273);
	__webpack_require__(275);
	__webpack_require__(277);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(281);
	__webpack_require__(283);
	__webpack_require__(285);
	__webpack_require__(287);
	__webpack_require__(289);
	__webpack_require__(291);
	__webpack_require__(293);
	__webpack_require__(295);
	__webpack_require__(297);
	__webpack_require__(299);
	__webpack_require__(301);
	__webpack_require__(303);
	__webpack_require__(313);
	__webpack_require__(315);
	__webpack_require__(317);
	__webpack_require__(319);
	__webpack_require__(321);
	__webpack_require__(323);
	__webpack_require__(325);
	__webpack_require__(327);
	__webpack_require__(329);
	__webpack_require__(331);
	__webpack_require__(333);
	__webpack_require__(335);
	__webpack_require__(337);
	__webpack_require__(339);
	__webpack_require__(341);
	__webpack_require__(343);
	__webpack_require__(345);
	__webpack_require__(347);
	__webpack_require__(349);
	__webpack_require__(351);
	__webpack_require__(353);
	__webpack_require__(355);
	__webpack_require__(356);
	/* tslint:disable:no-unused-variable */
	var Subscription_1 = __webpack_require__(34);
	exports.Subscription = Subscription_1.Subscription;
	var Subscriber_1 = __webpack_require__(32);
	exports.Subscriber = Subscriber_1.Subscriber;
	var AsyncSubject_1 = __webpack_require__(48);
	exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
	var ReplaySubject_1 = __webpack_require__(144);
	exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
	var BehaviorSubject_1 = __webpack_require__(272);
	exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
	var MulticastObservable_1 = __webpack_require__(257);
	exports.MulticastObservable = MulticastObservable_1.MulticastObservable;
	var ConnectableObservable_1 = __webpack_require__(258);
	exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
	var Notification_1 = __webpack_require__(83);
	exports.Notification = Notification_1.Notification;
	var EmptyError_1 = __webpack_require__(218);
	exports.EmptyError = EmptyError_1.EmptyError;
	var ArgumentOutOfRangeError_1 = __webpack_require__(207);
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	var ObjectUnsubscribedError_1 = __webpack_require__(43);
	exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
	var UnsubscriptionError_1 = __webpack_require__(39);
	exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
	var timeInterval_1 = __webpack_require__(332);
	exports.TimeInterval = timeInterval_1.TimeInterval;
	var timestamp_1 = __webpack_require__(338);
	exports.Timestamp = timestamp_1.Timestamp;
	var TestScheduler_1 = __webpack_require__(358);
	exports.TestScheduler = TestScheduler_1.TestScheduler;
	var VirtualTimeScheduler_1 = __webpack_require__(364);
	exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
	var AjaxObservable_1 = __webpack_require__(140);
	exports.AjaxResponse = AjaxObservable_1.AjaxResponse;
	exports.AjaxError = AjaxObservable_1.AjaxError;
	exports.AjaxTimeoutError = AjaxObservable_1.AjaxTimeoutError;
	var asap_1 = __webpack_require__(306);
	var async_1 = __webpack_require__(101);
	var queue_1 = __webpack_require__(145);
	var animationFrame_1 = __webpack_require__(365);
	var rxSubscriber_1 = __webpack_require__(41);
	var iterator_1 = __webpack_require__(62);
	var observable_1 = __webpack_require__(42);
	/* tslint:enable:no-unused-variable */
	/**
	 * @typedef {Object} Rx.Scheduler
	 * @property {Scheduler} queue Schedules on a queue in the current event frame
	 * (trampoline scheduler). Use this for iteration operations.
	 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
	 * fastest transport mechanism available, either Node.js' `process.nextTick()`
	 * or Web Worker MessageChannel or setTimeout or others. Use this for
	 * asynchronous conversions.
	 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
	 * time-based operations.
	 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
	 * Use this for synchronizing with the platform's painting
	 */
	var Scheduler = {
	    asap: asap_1.asap,
	    queue: queue_1.queue,
	    animationFrame: animationFrame_1.animationFrame,
	    async: async_1.async
	};
	exports.Scheduler = Scheduler;
	/**
	 * @typedef {Object} Rx.Symbol
	 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
	 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
	 * an object that has all of the traits of an Rx Subscriber, including the
	 * ability to add and remove subscriptions to the subscription chain and
	 * guarantees involving event triggering (can't "next" after unsubscription,
	 * etc).
	 * @property {Symbol|string} observable A symbol to use as a property name to
	 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
	 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
	 * to retrieve an iterator from an object.
	 */
	var Symbol = {
	    rxSubscriber: rxSubscriber_1.$$rxSubscriber,
	    observable: observable_1.$$observable,
	    iterator: iterator_1.$$iterator
	};
	exports.Symbol = Symbol;
	


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var Subscriber_1 = __webpack_require__(32);
	var Subscription_1 = __webpack_require__(34);
	var ObjectUnsubscribedError_1 = __webpack_require__(43);
	var SubjectSubscription_1 = __webpack_require__(44);
	var rxSubscriber_1 = __webpack_require__(41);
	/**
	 * @class SubjectSubscriber<T>
	 */
	var SubjectSubscriber = (function (_super) {
	    __extends(SubjectSubscriber, _super);
	    function SubjectSubscriber(destination) {
	        _super.call(this, destination);
	        this.destination = destination;
	    }
	    return SubjectSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SubjectSubscriber = SubjectSubscriber;
	/**
	 * @class Subject<T>
	 */
	var Subject = (function (_super) {
	    __extends(Subject, _super);
	    function Subject() {
	        _super.call(this);
	        this.observers = [];
	        this.closed = false;
	        this.isStopped = false;
	        this.hasError = false;
	        this.thrownError = null;
	    }
	    Subject.prototype[rxSubscriber_1.$$rxSubscriber] = function () {
	        return new SubjectSubscriber(this);
	    };
	    Subject.prototype.lift = function (operator) {
	        var subject = new AnonymousSubject(this, this);
	        subject.operator = operator;
	        return subject;
	    };
	    Subject.prototype.next = function (value) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        if (!this.isStopped) {
	            var observers = this.observers;
	            var len = observers.length;
	            var copy = observers.slice();
	            for (var i = 0; i < len; i++) {
	                copy[i].next(value);
	            }
	        }
	    };
	    Subject.prototype.error = function (err) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.hasError = true;
	        this.thrownError = err;
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].error(err);
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.complete = function () {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].complete();
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.unsubscribe = function () {
	        this.isStopped = true;
	        this.closed = true;
	        this.observers = null;
	    };
	    Subject.prototype._subscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
	        }
	    };
	    Subject.prototype.asObservable = function () {
	        var observable = new Observable_1.Observable();
	        observable.source = this;
	        return observable;
	    };
	    Subject.create = function (destination, source) {
	        return new AnonymousSubject(destination, source);
	    };
	    return Subject;
	}(Observable_1.Observable));
	exports.Subject = Subject;
	/**
	 * @class AnonymousSubject<T>
	 */
	var AnonymousSubject = (function (_super) {
	    __extends(AnonymousSubject, _super);
	    function AnonymousSubject(destination, source) {
	        _super.call(this);
	        this.destination = destination;
	        this.source = source;
	    }
	    AnonymousSubject.prototype.next = function (value) {
	        var destination = this.destination;
	        if (destination && destination.next) {
	            destination.next(value);
	        }
	    };
	    AnonymousSubject.prototype.error = function (err) {
	        var destination = this.destination;
	        if (destination && destination.error) {
	            this.destination.error(err);
	        }
	    };
	    AnonymousSubject.prototype.complete = function () {
	        var destination = this.destination;
	        if (destination && destination.complete) {
	            this.destination.complete();
	        }
	    };
	    AnonymousSubject.prototype._subscribe = function (subscriber) {
	        var source = this.source;
	        if (source) {
	            return this.source.subscribe(subscriber);
	        }
	        else {
	            return Subscription_1.Subscription.EMPTY;
	        }
	    };
	    return AnonymousSubject;
	}(Subject));
	exports.AnonymousSubject = AnonymousSubject;
	


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var root_1 = __webpack_require__(30);
	var toSubscriber_1 = __webpack_require__(31);
	var observable_1 = __webpack_require__(42);
	/**
	 * A representation of any set of values over any amount of time. This the most basic building block
	 * of RxJS.
	 *
	 * @class Observable<T>
	 */
	var Observable = (function () {
	    /**
	     * @constructor
	     * @param {Function} subscribe the function that is  called when the Observable is
	     * initially subscribed to. This function is given a Subscriber, to which new values
	     * can be `next`ed, or an `error` method can be called to raise an error, or
	     * `complete` can be called to notify of a successful completion.
	     */
	    function Observable(subscribe) {
	        this._isScalar = false;
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    /**
	     * Creates a new Observable, with this Observable as the source, and the passed
	     * operator defined as the new observable's operator.
	     * @method lift
	     * @param {Operator} operator the operator defining the operation to take on the observable
	     * @return {Observable} a new observable with the Operator applied
	     */
	    Observable.prototype.lift = function (operator) {
	        var observable = new Observable();
	        observable.source = this;
	        observable.operator = operator;
	        return observable;
	    };
	    /**
	     * Registers handlers for handling emitted values, error and completions from the observable, and
	     *  executes the observable's subscriber function, which will take action to set up the underlying data stream
	     * @method subscribe
	     * @param {PartialObserver|Function} observerOrNext (optional) either an observer defining all functions to be called,
	     *  or the first of three possible handlers, which is the handler for each value emitted from the observable.
	     * @param {Function} error (optional) a handler for a terminal event resulting from an error. If no error handler is provided,
	     *  the error will be thrown as unhandled
	     * @param {Function} complete (optional) a handler for a terminal event resulting from successful completion.
	     * @return {ISubscription} a subscription reference to the registered handlers
	     */
	    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
	        var operator = this.operator;
	        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
	        if (operator) {
	            operator.call(sink, this);
	        }
	        else {
	            sink.add(this._subscribe(sink));
	        }
	        if (sink.syncErrorThrowable) {
	            sink.syncErrorThrowable = false;
	            if (sink.syncErrorThrown) {
	                throw sink.syncErrorValue;
	            }
	        }
	        return sink;
	    };
	    /**
	     * @method forEach
	     * @param {Function} next a handler for each value emitted by the observable
	     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
	     * @return {Promise} a promise that either resolves on observable completion or
	     *  rejects with the handled error
	     */
	    Observable.prototype.forEach = function (next, PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	                PromiseCtor = root_1.root.Rx.config.Promise;
	            }
	            else if (root_1.root.Promise) {
	                PromiseCtor = root_1.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            var subscription = _this.subscribe(function (value) {
	                if (subscription) {
	                    // if there is a subscription, then we can surmise
	                    // the next handling is asynchronous. Any errors thrown
	                    // need to be rejected explicitly and unsubscribe must be
	                    // called manually
	                    try {
	                        next(value);
	                    }
	                    catch (err) {
	                        reject(err);
	                        subscription.unsubscribe();
	                    }
	                }
	                else {
	                    // if there is NO subscription, then we're getting a nexted
	                    // value synchronously during subscription. We can just call it.
	                    // If it errors, Observable's `subscribe` will ensure the
	                    // unsubscription logic is called, then synchronously rethrow the error.
	                    // After that, Promise will trap the error and send it
	                    // down the rejection path.
	                    next(value);
	                }
	            }, reject, resolve);
	        });
	    };
	    Observable.prototype._subscribe = function (subscriber) {
	        return this.source.subscribe(subscriber);
	    };
	    /**
	     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
	     * @method Symbol.observable
	     * @return {Observable} this instance of the observable
	     */
	    Observable.prototype[observable_1.$$observable] = function () {
	        return this;
	    };
	    // HACK: Since TypeScript inherits static properties too, we have to
	    // fight against TypeScript here so Subject can have a different static create signature
	    /**
	     * Creates a new cold Observable by calling the Observable constructor
	     * @static true
	     * @owner Observable
	     * @method create
	     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
	     * @return {Observable} a new cold observable
	     */
	    Observable.create = function (subscribe) {
	        return new Observable(subscribe);
	    };
	    return Observable;
	}());
	exports.Observable = Observable;
	


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var objectTypes = {
	    'boolean': false,
	    'function': true,
	    'object': true,
	    'number': false,
	    'string': false,
	    'undefined': false
	};
	exports.root = (objectTypes[typeof self] && self) || (objectTypes[typeof window] && window);
	/* tslint:disable:no-unused-variable */
	var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	var freeGlobal = objectTypes[typeof global] && global;
	if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal)) {
	    exports.root = freeGlobal;
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module), (function() { return this; }())))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Subscriber_1 = __webpack_require__(32);
	var rxSubscriber_1 = __webpack_require__(41);
	function toSubscriber(nextOrObserver, error, complete) {
	    if (nextOrObserver) {
	        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
	            return nextOrObserver;
	        }
	        if (nextOrObserver[rxSubscriber_1.$$rxSubscriber]) {
	            return nextOrObserver[rxSubscriber_1.$$rxSubscriber]();
	        }
	    }
	    if (!nextOrObserver && !error && !complete) {
	        return new Subscriber_1.Subscriber();
	    }
	    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	}
	exports.toSubscriber = toSubscriber;
	


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isFunction_1 = __webpack_require__(33);
	var Subscription_1 = __webpack_require__(34);
	var Observer_1 = __webpack_require__(40);
	var rxSubscriber_1 = __webpack_require__(41);
	/**
	 * Implements the {@link Observer} interface and extends the
	 * {@link Subscription} class. While the {@link Observer} is the public API for
	 * consuming the values of an {@link Observable}, all Observers get converted to
	 * a Subscriber, in order to provide Subscription-like capabilities such as
	 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
	 * implementing operators, but it is rarely used as a public API.
	 *
	 * @class Subscriber<T>
	 */
	var Subscriber = (function (_super) {
	    __extends(Subscriber, _super);
	    /**
	     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
	     * defined Observer or a `next` callback function.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     */
	    function Subscriber(destinationOrNext, error, complete) {
	        _super.call(this);
	        this.syncErrorValue = null;
	        this.syncErrorThrown = false;
	        this.syncErrorThrowable = false;
	        this.isStopped = false;
	        switch (arguments.length) {
	            case 0:
	                this.destination = Observer_1.empty;
	                break;
	            case 1:
	                if (!destinationOrNext) {
	                    this.destination = Observer_1.empty;
	                    break;
	                }
	                if (typeof destinationOrNext === 'object') {
	                    if (destinationOrNext instanceof Subscriber) {
	                        this.destination = destinationOrNext;
	                        this.destination.add(this);
	                    }
	                    else {
	                        this.syncErrorThrowable = true;
	                        this.destination = new SafeSubscriber(this, destinationOrNext);
	                    }
	                    break;
	                }
	            default:
	                this.syncErrorThrowable = true;
	                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
	                break;
	        }
	    }
	    Subscriber.prototype[rxSubscriber_1.$$rxSubscriber] = function () { return this; };
	    /**
	     * A static factory for a Subscriber, given a (potentially partial) definition
	     * of an Observer.
	     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
	     * Observer represented by the given arguments.
	     */
	    Subscriber.create = function (next, error, complete) {
	        var subscriber = new Subscriber(next, error, complete);
	        subscriber.syncErrorThrowable = false;
	        return subscriber;
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `next` from
	     * the Observable, with a value. The Observable may call this method 0 or more
	     * times.
	     * @param {T} [value] The `next` value.
	     * @return {void}
	     */
	    Subscriber.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._next(value);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `error` from
	     * the Observable, with an attached {@link Error}. Notifies the Observer that
	     * the Observable has experienced an error condition.
	     * @param {any} [err] The `error` exception.
	     * @return {void}
	     */
	    Subscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive a valueless notification of type
	     * `complete` from the Observable. Notifies the Observer that the Observable
	     * has finished sending push-based notifications.
	     * @return {void}
	     */
	    Subscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.isStopped = true;
	        _super.prototype.unsubscribe.call(this);
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    Subscriber.prototype._complete = function () {
	        this.destination.complete();
	        this.unsubscribe();
	    };
	    return Subscriber;
	}(Subscription_1.Subscription));
	exports.Subscriber = Subscriber;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SafeSubscriber = (function (_super) {
	    __extends(SafeSubscriber, _super);
	    function SafeSubscriber(_parent, observerOrNext, error, complete) {
	        _super.call(this);
	        this._parent = _parent;
	        var next;
	        var context = this;
	        if (isFunction_1.isFunction(observerOrNext)) {
	            next = observerOrNext;
	        }
	        else if (observerOrNext) {
	            context = observerOrNext;
	            next = observerOrNext.next;
	            error = observerOrNext.error;
	            complete = observerOrNext.complete;
	            if (isFunction_1.isFunction(context.unsubscribe)) {
	                this.add(context.unsubscribe.bind(context));
	            }
	            context.unsubscribe = this.unsubscribe.bind(this);
	        }
	        this._context = context;
	        this._next = next;
	        this._error = error;
	        this._complete = complete;
	    }
	    SafeSubscriber.prototype.next = function (value) {
	        if (!this.isStopped && this._next) {
	            var _parent = this._parent;
	            if (!_parent.syncErrorThrowable) {
	                this.__tryOrUnsub(this._next, value);
	            }
	            else if (this.__tryOrSetError(_parent, this._next, value)) {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _parent = this._parent;
	            if (this._error) {
	                if (!_parent.syncErrorThrowable) {
	                    this.__tryOrUnsub(this._error, err);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parent, this._error, err);
	                    this.unsubscribe();
	                }
	            }
	            else if (!_parent.syncErrorThrowable) {
	                this.unsubscribe();
	                throw err;
	            }
	            else {
	                _parent.syncErrorValue = err;
	                _parent.syncErrorThrown = true;
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            var _parent = this._parent;
	            if (this._complete) {
	                if (!_parent.syncErrorThrowable) {
	                    this.__tryOrUnsub(this._complete);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parent, this._complete);
	                    this.unsubscribe();
	                }
	            }
	            else {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            this.unsubscribe();
	            throw err;
	        }
	    };
	    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            parent.syncErrorValue = err;
	            parent.syncErrorThrown = true;
	            return true;
	        }
	        return false;
	    };
	    SafeSubscriber.prototype._unsubscribe = function () {
	        var _parent = this._parent;
	        this._context = null;
	        this._parent = null;
	        _parent.unsubscribe();
	    };
	    return SafeSubscriber;
	}(Subscriber));
	


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	function isFunction(x) {
	    return typeof x === 'function';
	}
	exports.isFunction = isFunction;
	


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var isArray_1 = __webpack_require__(35);
	var isObject_1 = __webpack_require__(36);
	var isFunction_1 = __webpack_require__(33);
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var UnsubscriptionError_1 = __webpack_require__(39);
	/**
	 * Represents a disposable resource, such as the execution of an Observable. A
	 * Subscription has one important method, `unsubscribe`, that takes no argument
	 * and just disposes the resource held by the subscription.
	 *
	 * Additionally, subscriptions may be grouped together through the `add()`
	 * method, which will attach a child Subscription to the current Subscription.
	 * When a Subscription is unsubscribed, all its children (and its grandchildren)
	 * will be unsubscribed as well.
	 *
	 * @class Subscription
	 */
	var Subscription = (function () {
	    /**
	     * @param {function(): void} [unsubscribe] A function describing how to
	     * perform the disposal of resources when the `unsubscribe` method is called.
	     */
	    function Subscription(unsubscribe) {
	        /**
	         * A flag to indicate whether this Subscription has already been unsubscribed.
	         * @type {boolean}
	         */
	        this.closed = false;
	        if (unsubscribe) {
	            this._unsubscribe = unsubscribe;
	        }
	    }
	    /**
	     * Disposes the resources held by the subscription. May, for instance, cancel
	     * an ongoing Observable execution or cancel any other type of work that
	     * started when the Subscription was created.
	     * @return {void}
	     */
	    Subscription.prototype.unsubscribe = function () {
	        var hasErrors = false;
	        var errors;
	        if (this.closed) {
	            return;
	        }
	        this.closed = true;
	        var _a = this, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
	        this._subscriptions = null;
	        if (isFunction_1.isFunction(_unsubscribe)) {
	            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
	            if (trial === errorObject_1.errorObject) {
	                hasErrors = true;
	                (errors = errors || []).push(errorObject_1.errorObject.e);
	            }
	        }
	        if (isArray_1.isArray(_subscriptions)) {
	            var index = -1;
	            var len = _subscriptions.length;
	            while (++index < len) {
	                var sub = _subscriptions[index];
	                if (isObject_1.isObject(sub)) {
	                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
	                    if (trial === errorObject_1.errorObject) {
	                        hasErrors = true;
	                        errors = errors || [];
	                        var err = errorObject_1.errorObject.e;
	                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
	                            errors = errors.concat(err.errors);
	                        }
	                        else {
	                            errors.push(err);
	                        }
	                    }
	                }
	            }
	        }
	        if (hasErrors) {
	            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
	        }
	    };
	    /**
	     * Adds a tear down to be called during the unsubscribe() of this
	     * Subscription.
	     *
	     * If the tear down being added is a subscription that is already
	     * unsubscribed, is the same reference `add` is being called on, or is
	     * `Subscription.EMPTY`, it will not be added.
	     *
	     * If this subscription is already in an `closed` state, the passed
	     * tear down logic will be executed immediately.
	     *
	     * @param {TeardownLogic} teardown The additional logic to execute on
	     * teardown.
	     * @return {Subscription} Returns the Subscription used or created to be
	     * added to the inner subscriptions list. This Subscription can be used with
	     * `remove()` to remove the passed teardown logic from the inner subscriptions
	     * list.
	     */
	    Subscription.prototype.add = function (teardown) {
	        if (!teardown || (teardown === Subscription.EMPTY)) {
	            return Subscription.EMPTY;
	        }
	        if (teardown === this) {
	            return this;
	        }
	        var sub = teardown;
	        switch (typeof teardown) {
	            case 'function':
	                sub = new Subscription(teardown);
	            case 'object':
	                if (sub.closed || typeof sub.unsubscribe !== 'function') {
	                    break;
	                }
	                else if (this.closed) {
	                    sub.unsubscribe();
	                }
	                else {
	                    (this._subscriptions || (this._subscriptions = [])).push(sub);
	                }
	                break;
	            default:
	                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
	        }
	        return sub;
	    };
	    /**
	     * Removes a Subscription from the internal list of subscriptions that will
	     * unsubscribe during the unsubscribe process of this Subscription.
	     * @param {Subscription} subscription The subscription to remove.
	     * @return {void}
	     */
	    Subscription.prototype.remove = function (subscription) {
	        // HACK: This might be redundant because of the logic in `add()`
	        if (subscription == null || (subscription === this) || (subscription === Subscription.EMPTY)) {
	            return;
	        }
	        var subscriptions = this._subscriptions;
	        if (subscriptions) {
	            var subscriptionIndex = subscriptions.indexOf(subscription);
	            if (subscriptionIndex !== -1) {
	                subscriptions.splice(subscriptionIndex, 1);
	            }
	        }
	    };
	    Subscription.EMPTY = (function (empty) {
	        empty.closed = true;
	        return empty;
	    }(new Subscription()));
	    return Subscription;
	}());
	exports.Subscription = Subscription;
	


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
	


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	function isObject(x) {
	    return x != null && typeof x === 'object';
	}
	exports.isObject = isObject;
	


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var errorObject_1 = __webpack_require__(38);
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        return tryCatchTarget.apply(this, arguments);
	    }
	    catch (e) {
	        errorObject_1.errorObject.e = e;
	        return errorObject_1.errorObject;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	exports.tryCatch = tryCatch;
	;
	


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	// typeof any so that it we don't have to cast when comparing a result to the error object
	exports.errorObject = { e: {} };
	


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when one or more errors have occurred during the
	 * `unsubscribe` of a {@link Subscription}.
	 */
	var UnsubscriptionError = (function (_super) {
	    __extends(UnsubscriptionError, _super);
	    function UnsubscriptionError(errors) {
	        _super.call(this);
	        this.errors = errors;
	        var err = Error.call(this, errors ?
	            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
	        this.name = err.name = 'UnsubscriptionError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return UnsubscriptionError;
	}(Error));
	exports.UnsubscriptionError = UnsubscriptionError;
	


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	exports.empty = {
	    closed: true,
	    next: function (value) { },
	    error: function (err) { throw err; },
	    complete: function () { }
	};
	


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var root_1 = __webpack_require__(30);
	var Symbol = root_1.root.Symbol;
	exports.$$rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
	    Symbol.for('rxSubscriber') : '@@rxSubscriber';
	


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var root_1 = __webpack_require__(30);
	function getSymbolObservable(context) {
	    var $$observable;
	    var Symbol = context.Symbol;
	    if (typeof Symbol === 'function') {
	        if (Symbol.observable) {
	            $$observable = Symbol.observable;
	        }
	        else {
	            $$observable = Symbol('observable');
	            Symbol.observable = $$observable;
	        }
	    }
	    else {
	        $$observable = '@@observable';
	    }
	    return $$observable;
	}
	exports.getSymbolObservable = getSymbolObservable;
	exports.$$observable = getSymbolObservable(root_1.root);
	


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an action is invalid because the object has been
	 * unsubscribed.
	 *
	 * @see {@link Subject}
	 * @see {@link BehaviorSubject}
	 *
	 * @class ObjectUnsubscribedError
	 */
	var ObjectUnsubscribedError = (function (_super) {
	    __extends(ObjectUnsubscribedError, _super);
	    function ObjectUnsubscribedError() {
	        var err = _super.call(this, 'object unsubscribed');
	        this.name = err.name = 'ObjectUnsubscribedError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return ObjectUnsubscribedError;
	}(Error));
	exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
	


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(34);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubjectSubscription = (function (_super) {
	    __extends(SubjectSubscription, _super);
	    function SubjectSubscription(subject, subscriber) {
	        _super.call(this);
	        this.subject = subject;
	        this.subscriber = subscriber;
	        this.closed = false;
	    }
	    SubjectSubscription.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.closed = true;
	        var subject = this.subject;
	        var observers = subject.observers;
	        this.subject = null;
	        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
	            return;
	        }
	        var subscriberIndex = observers.indexOf(this.subscriber);
	        if (subscriberIndex !== -1) {
	            observers.splice(subscriberIndex, 1);
	        }
	    };
	    return SubjectSubscription;
	}(Subscription_1.Subscription));
	exports.SubjectSubscription = SubjectSubscription;
	


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var bindCallback_1 = __webpack_require__(46);
	Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
	


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var BoundCallbackObservable_1 = __webpack_require__(47);
	exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
	


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var AsyncSubject_1 = __webpack_require__(48);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var BoundCallbackObservable = (function (_super) {
	    __extends(BoundCallbackObservable, _super);
	    function BoundCallbackObservable(callbackFunc, selector, args, scheduler) {
	        _super.call(this);
	        this.callbackFunc = callbackFunc;
	        this.selector = selector;
	        this.args = args;
	        this.scheduler = scheduler;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Converts a callback API to a function that returns an Observable.
	     *
	     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
	     * it will return a function `g` that when called as `g(x)` will output an
	     * Observable.</span>
	     *
	     * `bindCallback` is not an operator because its input and output are not
	     * Observables. The input is a function `func` with some parameters, but the
	     * last parameter must be a callback function that `func` calls when it is
	     * done. The output of `bindCallback` is a function that takes the same
	     * parameters as `func`, except the last one (the callback). When the output
	     * function is called with arguments, it will return an Observable where the
	     * results will be delivered to.
	     *
	     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
	     * // Suppose we have jQuery.getJSON('/my/url', callback)
	     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
	     * var result = getJSONAsObservable('/my/url');
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link bindNodeCallback}
	     * @see {@link from}
	     * @see {@link fromPromise}
	     *
	     * @param {function} func Function with a callback as the last parameter.
	     * @param {function} selector A function which takes the arguments from the
	     * callback and maps those a value to emit on the output Observable.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * callbacks.
	     * @return {function(...params: *): Observable} A function which returns the
	     * Observable that delivers the same values the callback would deliver.
	     * @static true
	     * @name bindCallback
	     * @owner Observable
	     */
	    BoundCallbackObservable.create = function (func, selector, scheduler) {
	        if (selector === void 0) { selector = undefined; }
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            return new BoundCallbackObservable(func, selector, args, scheduler);
	        };
	    };
	    BoundCallbackObservable.prototype._subscribe = function (subscriber) {
	        var callbackFunc = this.callbackFunc;
	        var args = this.args;
	        var scheduler = this.scheduler;
	        var subject = this.subject;
	        if (!scheduler) {
	            if (!subject) {
	                subject = this.subject = new AsyncSubject_1.AsyncSubject();
	                var handler = function handlerFn() {
	                    var innerArgs = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        innerArgs[_i - 0] = arguments[_i];
	                    }
	                    var source = handlerFn.source;
	                    var selector = source.selector, subject = source.subject;
	                    if (selector) {
	                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                        if (result_1 === errorObject_1.errorObject) {
	                            subject.error(errorObject_1.errorObject.e);
	                        }
	                        else {
	                            subject.next(result_1);
	                            subject.complete();
	                        }
	                    }
	                    else {
	                        subject.next(innerArgs.length === 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    }
	                };
	                // use named function instance to avoid closure.
	                handler.source = this;
	                var result = tryCatch_1.tryCatch(callbackFunc).apply(this, args.concat(handler));
	                if (result === errorObject_1.errorObject) {
	                    subject.error(errorObject_1.errorObject.e);
	                }
	            }
	            return subject.subscribe(subscriber);
	        }
	        else {
	            return scheduler.schedule(BoundCallbackObservable.dispatch, 0, { source: this, subscriber: subscriber });
	        }
	    };
	    BoundCallbackObservable.dispatch = function (state) {
	        var self = this;
	        var source = state.source, subscriber = state.subscriber;
	        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
	        var subject = source.subject;
	        if (!subject) {
	            subject = source.subject = new AsyncSubject_1.AsyncSubject();
	            var handler = function handlerFn() {
	                var innerArgs = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    innerArgs[_i - 0] = arguments[_i];
	                }
	                var source = handlerFn.source;
	                var selector = source.selector, subject = source.subject;
	                if (selector) {
	                    var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                    if (result_2 === errorObject_1.errorObject) {
	                        self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	                    }
	                    else {
	                        self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
	                    }
	                }
	                else {
	                    var value = innerArgs.length === 1 ? innerArgs[0] : innerArgs;
	                    self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
	                }
	            };
	            // use named function to pass values in without closure
	            handler.source = source;
	            var result = tryCatch_1.tryCatch(callbackFunc).apply(this, args.concat(handler));
	            if (result === errorObject_1.errorObject) {
	                subject.error(errorObject_1.errorObject.e);
	            }
	        }
	        self.add(subject.subscribe(subscriber));
	    };
	    return BoundCallbackObservable;
	}(Observable_1.Observable));
	exports.BoundCallbackObservable = BoundCallbackObservable;
	function dispatchNext(arg) {
	    var value = arg.value, subject = arg.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(arg) {
	    var err = arg.err, subject = arg.subject;
	    subject.error(err);
	}
	


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var Subscription_1 = __webpack_require__(34);
	/**
	 * @class AsyncSubject<T>
	 */
	var AsyncSubject = (function (_super) {
	    __extends(AsyncSubject, _super);
	    function AsyncSubject() {
	        _super.apply(this, arguments);
	        this.value = null;
	        this.hasNext = false;
	        this.hasCompleted = false;
	    }
	    AsyncSubject.prototype._subscribe = function (subscriber) {
	        if (this.hasCompleted && this.hasNext) {
	            subscriber.next(this.value);
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    AsyncSubject.prototype.next = function (value) {
	        if (!this.hasCompleted) {
	            this.value = value;
	            this.hasNext = true;
	        }
	    };
	    AsyncSubject.prototype.complete = function () {
	        this.hasCompleted = true;
	        if (this.hasNext) {
	            _super.prototype.next.call(this, this.value);
	        }
	        _super.prototype.complete.call(this);
	    };
	    return AsyncSubject;
	}(Subject_1.Subject));
	exports.AsyncSubject = AsyncSubject;
	


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var bindNodeCallback_1 = __webpack_require__(50);
	Observable_1.Observable.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
	


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var BoundNodeCallbackObservable_1 = __webpack_require__(51);
	exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
	


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var AsyncSubject_1 = __webpack_require__(48);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var BoundNodeCallbackObservable = (function (_super) {
	    __extends(BoundNodeCallbackObservable, _super);
	    function BoundNodeCallbackObservable(callbackFunc, selector, args, scheduler) {
	        _super.call(this);
	        this.callbackFunc = callbackFunc;
	        this.selector = selector;
	        this.args = args;
	        this.scheduler = scheduler;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Converts a Node.js-style callback API to a function that returns an
	     * Observable.
	     *
	     * <span class="informal">It's just like {@link bindCallback}, but the
	     * callback is expected to be of type `callback(error, result)`.</span>
	     *
	     * `bindNodeCallback` is not an operator because its input and output are not
	     * Observables. The input is a function `func` with some parameters, but the
	     * last parameter must be a callback function that `func` calls when it is
	     * done. The callback function is expected to follow Node.js conventions,
	     * where the first argument to the callback is an error, while remaining
	     * arguments are the callback result. The output of `bindNodeCallback` is a
	     * function that takes the same parameters as `func`, except the last one (the
	     * callback). When the output function is called with arguments, it will
	     * return an Observable where the results will be delivered to.
	     *
	     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
	     * import * as fs from 'fs';
	     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
	     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link bindCallback}
	     * @see {@link from}
	     * @see {@link fromPromise}
	     *
	     * @param {function} func Function with a callback as the last parameter.
	     * @param {function} selector A function which takes the arguments from the
	     * callback and maps those a value to emit on the output Observable.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * callbacks.
	     * @return {function(...params: *): Observable} A function which returns the
	     * Observable that delivers the same values the Node.js callback would
	     * deliver.
	     * @static true
	     * @name bindNodeCallback
	     * @owner Observable
	     */
	    BoundNodeCallbackObservable.create = function (func, selector, scheduler) {
	        if (selector === void 0) { selector = undefined; }
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            return new BoundNodeCallbackObservable(func, selector, args, scheduler);
	        };
	    };
	    BoundNodeCallbackObservable.prototype._subscribe = function (subscriber) {
	        var callbackFunc = this.callbackFunc;
	        var args = this.args;
	        var scheduler = this.scheduler;
	        var subject = this.subject;
	        if (!scheduler) {
	            if (!subject) {
	                subject = this.subject = new AsyncSubject_1.AsyncSubject();
	                var handler = function handlerFn() {
	                    var innerArgs = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        innerArgs[_i - 0] = arguments[_i];
	                    }
	                    var source = handlerFn.source;
	                    var selector = source.selector, subject = source.subject;
	                    var err = innerArgs.shift();
	                    if (err) {
	                        subject.error(err);
	                    }
	                    else if (selector) {
	                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                        if (result_1 === errorObject_1.errorObject) {
	                            subject.error(errorObject_1.errorObject.e);
	                        }
	                        else {
	                            subject.next(result_1);
	                            subject.complete();
	                        }
	                    }
	                    else {
	                        subject.next(innerArgs.length === 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    }
	                };
	                // use named function instance to avoid closure.
	                handler.source = this;
	                var result = tryCatch_1.tryCatch(callbackFunc).apply(this, args.concat(handler));
	                if (result === errorObject_1.errorObject) {
	                    subject.error(errorObject_1.errorObject.e);
	                }
	            }
	            return subject.subscribe(subscriber);
	        }
	        else {
	            return scheduler.schedule(dispatch, 0, { source: this, subscriber: subscriber });
	        }
	    };
	    return BoundNodeCallbackObservable;
	}(Observable_1.Observable));
	exports.BoundNodeCallbackObservable = BoundNodeCallbackObservable;
	function dispatch(state) {
	    var self = this;
	    var source = state.source, subscriber = state.subscriber;
	    // XXX: cast to `any` to access to the private field in `source`.
	    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
	    var subject = source.subject;
	    if (!subject) {
	        subject = source.subject = new AsyncSubject_1.AsyncSubject();
	        var handler = function handlerFn() {
	            var innerArgs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                innerArgs[_i - 0] = arguments[_i];
	            }
	            var source = handlerFn.source;
	            var selector = source.selector, subject = source.subject;
	            var err = innerArgs.shift();
	            if (err) {
	                subject.error(err);
	            }
	            else if (selector) {
	                var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                if (result_2 === errorObject_1.errorObject) {
	                    self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	                }
	                else {
	                    self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
	                }
	            }
	            else {
	                var value = innerArgs.length === 1 ? innerArgs[0] : innerArgs;
	                self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
	            }
	        };
	        // use named function to pass values in without closure
	        handler.source = source;
	        var result = tryCatch_1.tryCatch(callbackFunc).apply(this, args.concat(handler));
	        if (result === errorObject_1.errorObject) {
	            subject.error(errorObject_1.errorObject.e);
	        }
	    }
	    self.add(subject.subscribe(subscriber));
	}
	function dispatchNext(arg) {
	    var value = arg.value, subject = arg.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(arg) {
	    var err = arg.err, subject = arg.subject;
	    subject.error(err);
	}
	


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var combineLatest_1 = __webpack_require__(53);
	Observable_1.Observable.combineLatest = combineLatest_1.combineLatest;
	


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var isScheduler_1 = __webpack_require__(54);
	var isArray_1 = __webpack_require__(35);
	var ArrayObservable_1 = __webpack_require__(55);
	var combineLatest_1 = __webpack_require__(58);
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from all the Observables passed as
	 * arguments. This is done by subscribing to each Observable, in order, and
	 * collecting an array of each of the most recent values any time any of the
	 * input Observables emits, then either taking that array and passing it as
	 * arguments to an optional `project` function and emitting the return value of
	 * that, or just emitting the array of recent values directly if there is no
	 * `project` function.
	 *
	 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {Observable} observable1 An input Observable to combine with the
	 * source Observable.
	 * @param {Observable} observable2 An input Observable to combine with the
	 * source Observable. More than one input Observables may be given as argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @param {Scheduler} [scheduler=null] The Scheduler to use for subscribing to
	 * each input Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @static true
	 * @name combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = null;
	    var scheduler = null;
	    if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
	        scheduler = observables.pop();
	    }
	    if (typeof observables[observables.length - 1] === 'function') {
	        project = observables.pop();
	    }
	    // if the first and only other argument besides the resultSelector is an array
	    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0];
	    }
	    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new combineLatest_1.CombineLatestOperator(project));
	}
	exports.combineLatest = combineLatest;
	


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	function isScheduler(value) {
	    return value && typeof value.schedule === 'function';
	}
	exports.isScheduler = isScheduler;
	


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var ScalarObservable_1 = __webpack_require__(56);
	var EmptyObservable_1 = __webpack_require__(57);
	var isScheduler_1 = __webpack_require__(54);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayObservable = (function (_super) {
	    __extends(ArrayObservable, _super);
	    function ArrayObservable(array, scheduler) {
	        _super.call(this);
	        this.array = array;
	        this.scheduler = scheduler;
	        if (!scheduler && array.length === 1) {
	            this._isScalar = true;
	            this.value = array[0];
	        }
	    }
	    ArrayObservable.create = function (array, scheduler) {
	        return new ArrayObservable(array, scheduler);
	    };
	    /**
	     * Creates an Observable that emits some values you specify as arguments,
	     * immediately one after the other, and then emits a complete notification.
	     *
	     * <span class="informal">Emits the arguments you provide, then completes.
	     * </span>
	     *
	     * <img src="./img/of.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the arguments given, and the complete notification thereafter. It can
	     * be used for composing with other Observables, such as with {@link concat}.
	     * By default, it uses a `null` Scheduler, which means the `next`
	     * notifications are sent synchronously, although with a different Scheduler
	     * it is possible to determine when those notifications will be delivered.
	     *
	     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
	     * var numbers = Rx.Observable.of(10, 20, 30);
	     * var letters = Rx.Observable.of('a', 'b', 'c');
	     * var interval = Rx.Observable.interval(1000);
	     * var result = numbers.concat(letters).concat(interval);
	     * result.subscribe(x => console.log(x));
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link never}
	     * @see {@link throw}
	     *
	     * @param {...T} values Arguments that represent `next` values to be emitted.
	     * @param {Scheduler} [scheduler] A {@link Scheduler} to use for scheduling
	     * the emissions of the `next` notifications.
	     * @return {Observable<T>} An Observable that emits each given input value.
	     * @static true
	     * @name of
	     * @owner Observable
	     */
	    ArrayObservable.of = function () {
	        var array = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            array[_i - 0] = arguments[_i];
	        }
	        var scheduler = array[array.length - 1];
	        if (isScheduler_1.isScheduler(scheduler)) {
	            array.pop();
	        }
	        else {
	            scheduler = null;
	        }
	        var len = array.length;
	        if (len > 1) {
	            return new ArrayObservable(array, scheduler);
	        }
	        else if (len === 1) {
	            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
	        }
	        else {
	            return new EmptyObservable_1.EmptyObservable(scheduler);
	        }
	    };
	    ArrayObservable.dispatch = function (state) {
	        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
	        if (index >= count) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(array[index]);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    ArrayObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var array = this.array;
	        var count = array.length;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ArrayObservable.dispatch, 0, {
	                array: array, index: index, count: count, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < count && !subscriber.closed; i++) {
	                subscriber.next(array[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayObservable;
	}(Observable_1.Observable));
	exports.ArrayObservable = ArrayObservable;
	


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ScalarObservable = (function (_super) {
	    __extends(ScalarObservable, _super);
	    function ScalarObservable(value, scheduler) {
	        _super.call(this);
	        this.value = value;
	        this.scheduler = scheduler;
	        this._isScalar = true;
	        if (scheduler) {
	            this._isScalar = false;
	        }
	    }
	    ScalarObservable.create = function (value, scheduler) {
	        return new ScalarObservable(value, scheduler);
	    };
	    ScalarObservable.dispatch = function (state) {
	        var done = state.done, value = state.value, subscriber = state.subscriber;
	        if (done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(value);
	        if (subscriber.closed) {
	            return;
	        }
	        state.done = true;
	        this.schedule(state);
	    };
	    ScalarObservable.prototype._subscribe = function (subscriber) {
	        var value = this.value;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ScalarObservable.dispatch, 0, {
	                done: false, value: value, subscriber: subscriber
	            });
	        }
	        else {
	            subscriber.next(value);
	            if (!subscriber.closed) {
	                subscriber.complete();
	            }
	        }
	    };
	    return ScalarObservable;
	}(Observable_1.Observable));
	exports.ScalarObservable = ScalarObservable;
	


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var EmptyObservable = (function (_super) {
	    __extends(EmptyObservable, _super);
	    function EmptyObservable(scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer and immediately
	     * emits a complete notification.
	     *
	     * <span class="informal">Just emits 'complete', and nothing else.
	     * </span>
	     *
	     * <img src="./img/empty.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the complete notification. It can be used for composing with other
	     * Observables, such as in a {@link mergeMap}.
	     *
	     * @example <caption>Emit the number 7, then complete.</caption>
	     * var result = Rx.Observable.empty().startWith(7);
	     * result.subscribe(x => console.log(x));
	     *
	     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
	     * var interval = Rx.Observable.interval(1000);
	     * var result = interval.mergeMap(x =>
	     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
	     * );
	     * result.subscribe(x => console.log(x));
	     *
	     * @see {@link create}
	     * @see {@link never}
	     * @see {@link of}
	     * @see {@link throw}
	     *
	     * @param {Scheduler} [scheduler] A {@link Scheduler} to use for scheduling
	     * the emission of the complete notification.
	     * @return {Observable} An "empty" Observable: emits only the complete
	     * notification.
	     * @static true
	     * @name empty
	     * @owner Observable
	     */
	    EmptyObservable.create = function (scheduler) {
	        return new EmptyObservable(scheduler);
	    };
	    EmptyObservable.dispatch = function (arg) {
	        var subscriber = arg.subscriber;
	        subscriber.complete();
	    };
	    EmptyObservable.prototype._subscribe = function (subscriber) {
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
	        }
	        else {
	            subscriber.complete();
	        }
	    };
	    return EmptyObservable;
	}(Observable_1.Observable));
	exports.EmptyObservable = EmptyObservable;
	


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ArrayObservable_1 = __webpack_require__(55);
	var isArray_1 = __webpack_require__(35);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	var none = {};
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from this Observable with values from
	 * Observables passed as arguments. This is done by subscribing to each
	 * Observable, in order, and collecting an array of each of the most recent
	 * values any time any of the input Observables emits, then either taking that
	 * array and passing it as arguments to an optional `project` function and
	 * emitting the return value of that, or just emitting the array of recent
	 * values directly if there is no `project` function.
	 *
	 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {Observable} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = null;
	    if (typeof observables[observables.length - 1] === 'function') {
	        project = observables.pop();
	    }
	    // if the first and only other argument besides the resultSelector is an array
	    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0];
	    }
	    observables.unshift(this);
	    return new ArrayObservable_1.ArrayObservable(observables).lift(new CombineLatestOperator(project));
	}
	exports.combineLatest = combineLatest;
	/* tslint:enable:max-line-length */
	var CombineLatestOperator = (function () {
	    function CombineLatestOperator(project) {
	        this.project = project;
	    }
	    CombineLatestOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new CombineLatestSubscriber(subscriber, this.project));
	    };
	    return CombineLatestOperator;
	}());
	exports.CombineLatestOperator = CombineLatestOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CombineLatestSubscriber = (function (_super) {
	    __extends(CombineLatestSubscriber, _super);
	    function CombineLatestSubscriber(destination, project) {
	        _super.call(this, destination);
	        this.project = project;
	        this.active = 0;
	        this.values = [];
	        this.observables = [];
	    }
	    CombineLatestSubscriber.prototype._next = function (observable) {
	        this.values.push(none);
	        this.observables.push(observable);
	    };
	    CombineLatestSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            this.active = len;
	            this.toRespond = len;
	            for (var i = 0; i < len; i++) {
	                var observable = observables[i];
	                this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
	        if ((this.active -= 1) === 0) {
	            this.destination.complete();
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var values = this.values;
	        var oldVal = values[outerIndex];
	        var toRespond = !this.toRespond
	            ? 0
	            : oldVal === none ? --this.toRespond : this.toRespond;
	        values[outerIndex] = innerValue;
	        if (toRespond === 0) {
	            if (this.project) {
	                this._tryProject(values);
	            }
	            else {
	                this.destination.next(values.slice());
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype._tryProject = function (values) {
	        var result;
	        try {
	            result = this.project.apply(this, values);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return CombineLatestSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.CombineLatestSubscriber = CombineLatestSubscriber;
	


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var OuterSubscriber = (function (_super) {
	    __extends(OuterSubscriber, _super);
	    function OuterSubscriber() {
	        _super.apply(this, arguments);
	    }
	    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(innerValue);
	    };
	    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.destination.error(error);
	    };
	    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.destination.complete();
	    };
	    return OuterSubscriber;
	}(Subscriber_1.Subscriber));
	exports.OuterSubscriber = OuterSubscriber;
	


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var root_1 = __webpack_require__(30);
	var isArray_1 = __webpack_require__(35);
	var isPromise_1 = __webpack_require__(61);
	var Observable_1 = __webpack_require__(29);
	var iterator_1 = __webpack_require__(62);
	var InnerSubscriber_1 = __webpack_require__(63);
	var observable_1 = __webpack_require__(42);
	function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
	    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
	    if (destination.closed) {
	        return null;
	    }
	    if (result instanceof Observable_1.Observable) {
	        if (result._isScalar) {
	            destination.next(result.value);
	            destination.complete();
	            return null;
	        }
	        else {
	            return result.subscribe(destination);
	        }
	    }
	    if (isArray_1.isArray(result)) {
	        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
	            destination.next(result[i]);
	        }
	        if (!destination.closed) {
	            destination.complete();
	        }
	    }
	    else if (isPromise_1.isPromise(result)) {
	        result.then(function (value) {
	            if (!destination.closed) {
	                destination.next(value);
	                destination.complete();
	            }
	        }, function (err) { return destination.error(err); })
	            .then(null, function (err) {
	            // Escaping the Promise trap: globally throw unhandled errors
	            root_1.root.setTimeout(function () { throw err; });
	        });
	        return destination;
	    }
	    else if (typeof result[iterator_1.$$iterator] === 'function') {
	        var iterator = result[iterator_1.$$iterator]();
	        do {
	            var item = iterator.next();
	            if (item.done) {
	                destination.complete();
	                break;
	            }
	            destination.next(item.value);
	            if (destination.closed) {
	                break;
	            }
	        } while (true);
	    }
	    else if (typeof result[observable_1.$$observable] === 'function') {
	        var obs = result[observable_1.$$observable]();
	        if (typeof obs.subscribe !== 'function') {
	            destination.error(new Error('invalid observable'));
	        }
	        else {
	            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
	        }
	    }
	    else {
	        destination.error(new TypeError('unknown type returned'));
	    }
	    return null;
	}
	exports.subscribeToResult = subscribeToResult;
	


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	function isPromise(value) {
	    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
	}
	exports.isPromise = isPromise;
	


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var root_1 = __webpack_require__(30);
	var Symbol = root_1.root.Symbol;
	if (typeof Symbol === 'function') {
	    if (Symbol.iterator) {
	        exports.$$iterator = Symbol.iterator;
	    }
	    else if (typeof Symbol.for === 'function') {
	        exports.$$iterator = Symbol.for('iterator');
	    }
	}
	else {
	    if (root_1.root.Set && typeof new root_1.root.Set()['@@iterator'] === 'function') {
	        // Bug for mozilla version
	        exports.$$iterator = '@@iterator';
	    }
	    else if (root_1.root.Map) {
	        // es6-shim specific logic
	        var keys = Object.getOwnPropertyNames(root_1.root.Map.prototype);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (key !== 'entries' && key !== 'size' && root_1.root.Map.prototype[key] === root_1.root.Map.prototype['entries']) {
	                exports.$$iterator = key;
	                break;
	            }
	        }
	    }
	    else {
	        exports.$$iterator = '@@iterator';
	    }
	}
	


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var InnerSubscriber = (function (_super) {
	    __extends(InnerSubscriber, _super);
	    function InnerSubscriber(parent, outerValue, outerIndex) {
	        _super.call(this);
	        this.parent = parent;
	        this.outerValue = outerValue;
	        this.outerIndex = outerIndex;
	        this.index = 0;
	    }
	    InnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
	    };
	    InnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error, this);
	        this.unsubscribe();
	    };
	    InnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete(this);
	        this.unsubscribe();
	    };
	    return InnerSubscriber;
	}(Subscriber_1.Subscriber));
	exports.InnerSubscriber = InnerSubscriber;
	


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var concat_1 = __webpack_require__(65);
	Observable_1.Observable.concat = concat_1.concat;
	


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var concat_1 = __webpack_require__(66);
	exports.concat = concat_1.concatStatic;
	


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var isScheduler_1 = __webpack_require__(54);
	var ArrayObservable_1 = __webpack_require__(55);
	var mergeAll_1 = __webpack_require__(67);
	/**
	 * Creates an output Observable which sequentially emits all values from every
	 * given input Observable after the current Observable.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * Joins this Observable with multiple other Observables by subscribing to them
	 * one at a time, starting with the source, and merging their results into the
	 * output Observable. Will wait for each Observable to complete before moving
	 * on to the next.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = timer.concat(sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Concatenate 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = timer1.concat(timer2, timer3);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {Observable} other An input Observable to concatenate after the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional Scheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @method concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return concatStatic.apply(void 0, [this].concat(observables));
	}
	exports.concat = concat;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from every
	 * given input Observable after the current Observable.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * Joins multiple Observables together by subscribing to them one at a time and
	 * merging their results into the output Observable. Will wait for each
	 * Observable to complete before moving on to the next.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = Rx.Observable.concat(timer, sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Concatenate 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = Rx.Observable.concat(timer1, timer2, timer3);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {Observable} input1 An input Observable to concatenate with others.
	 * @param {Observable} input2 An input Observable to concatenate with others.
	 * More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional Scheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @static true
	 * @name concat
	 * @owner Observable
	 */
	function concatStatic() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var scheduler = null;
	    var args = observables;
	    if (isScheduler_1.isScheduler(args[observables.length - 1])) {
	        scheduler = args.pop();
	    }
	    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new mergeAll_1.MergeAllOperator(1));
	}
	exports.concatStatic = concatStatic;
	


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Converts a higher-order Observable into a first-order Observable which
	 * concurrently delivers all values that are emitted on the inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables.</span>
	 *
	 * <img src="./img/mergeAll.png" width="100%">
	 *
	 * `mergeAll` subscribes to an Observable that emits Observables, also known as
	 * a higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, it subscribes to that and delivers all the values from the
	 * inner Observable on the output Observable. The output Observable only
	 * completes once all inner Observables have completed. Any error delivered by
	 * a inner Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var firstOrder = higherOrder.mergeAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
	 * var firstOrder = higherOrder.mergeAll(2);
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link merge}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits values coming from all the
	 * inner Observables emitted by the source Observable.
	 * @method mergeAll
	 * @owner Observable
	 */
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return this.lift(new MergeAllOperator(concurrent));
	}
	exports.mergeAll = mergeAll;
	var MergeAllOperator = (function () {
	    function MergeAllOperator(concurrent) {
	        this.concurrent = concurrent;
	    }
	    MergeAllOperator.prototype.call = function (observer, source) {
	        return source._subscribe(new MergeAllSubscriber(observer, this.concurrent));
	    };
	    return MergeAllOperator;
	}());
	exports.MergeAllOperator = MergeAllOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeAllSubscriber = (function (_super) {
	    __extends(MergeAllSubscriber, _super);
	    function MergeAllSubscriber(destination, concurrent) {
	        _super.call(this, destination);
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	    }
	    MergeAllSubscriber.prototype._next = function (observable) {
	        if (this.active < this.concurrent) {
	            this.active++;
	            this.add(subscribeToResult_1.subscribeToResult(this, observable));
	        }
	        else {
	            this.buffer.push(observable);
	        }
	    };
	    MergeAllSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeAllSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeAllSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeAllSubscriber = MergeAllSubscriber;
	


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var defer_1 = __webpack_require__(69);
	Observable_1.Observable.defer = defer_1.defer;
	


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var DeferObservable_1 = __webpack_require__(70);
	exports.defer = DeferObservable_1.DeferObservable.create;
	


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var subscribeToResult_1 = __webpack_require__(60);
	var OuterSubscriber_1 = __webpack_require__(59);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var DeferObservable = (function (_super) {
	    __extends(DeferObservable, _super);
	    function DeferObservable(observableFactory) {
	        _super.call(this);
	        this.observableFactory = observableFactory;
	    }
	    /**
	     * Creates an Observable that, on subscribe, calls an Observable factory to
	     * make an Observable for each new Observer.
	     *
	     * <span class="informal">Creates the Observable lazily, that is, only when it
	     * is subscribed.
	     * </span>
	     *
	     * <img src="./img/defer.png" width="100%">
	     *
	     * `defer` allows you to create the Observable only when the Observer
	     * subscribes, and create a fresh Observable for each Observer. It waits until
	     * an Observer subscribes to it, and then it generates an Observable,
	     * typically with an Observable factory function. It does this afresh for each
	     * subscriber, so although each subscriber may think it is subscribing to the
	     * same Observable, in fact each subscriber gets its own individual
	     * Observable.
	     *
	     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
	     * var clicksOrInterval = Rx.Observable.defer(function () {
	     *   if (Math.random() > 0.5) {
	     *     return Rx.Observable.fromEvent(document, 'click');
	     *   } else {
	     *     return Rx.Observable.interval(1000);
	     *   }
	     * });
	     * clicksOrInterval.subscribe(x => console.log(x));
	     *
	     * @see {@link create}
	     *
	     * @param {function(): Observable|Promise} observableFactory The Observable
	     * factory function to invoke for each Observer that subscribes to the output
	     * Observable. May also return a Promise, which will be converted on the fly
	     * to an Observable.
	     * @return {Observable} An Observable whose Observers' subscriptions trigger
	     * an invocation of the given Observable factory function.
	     * @static true
	     * @name defer
	     * @owner Observable
	     */
	    DeferObservable.create = function (observableFactory) {
	        return new DeferObservable(observableFactory);
	    };
	    DeferObservable.prototype._subscribe = function (subscriber) {
	        return new DeferSubscriber(subscriber, this.observableFactory);
	    };
	    return DeferObservable;
	}(Observable_1.Observable));
	exports.DeferObservable = DeferObservable;
	var DeferSubscriber = (function (_super) {
	    __extends(DeferSubscriber, _super);
	    function DeferSubscriber(destination, factory) {
	        _super.call(this, destination);
	        this.factory = factory;
	        this.tryDefer();
	    }
	    DeferSubscriber.prototype.tryDefer = function () {
	        try {
	            this._callFactory();
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    DeferSubscriber.prototype._callFactory = function () {
	        var result = this.factory();
	        if (result) {
	            this.add(subscribeToResult_1.subscribeToResult(this, result));
	        }
	    };
	    return DeferSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var empty_1 = __webpack_require__(72);
	Observable_1.Observable.empty = empty_1.empty;
	


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var EmptyObservable_1 = __webpack_require__(57);
	exports.empty = EmptyObservable_1.EmptyObservable.create;
	


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var forkJoin_1 = __webpack_require__(74);
	Observable_1.Observable.forkJoin = forkJoin_1.forkJoin;
	


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ForkJoinObservable_1 = __webpack_require__(75);
	exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
	


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var EmptyObservable_1 = __webpack_require__(57);
	var isArray_1 = __webpack_require__(35);
	var subscribeToResult_1 = __webpack_require__(60);
	var OuterSubscriber_1 = __webpack_require__(59);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ForkJoinObservable = (function (_super) {
	    __extends(ForkJoinObservable, _super);
	    function ForkJoinObservable(sources, resultSelector) {
	        _super.call(this);
	        this.sources = sources;
	        this.resultSelector = resultSelector;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * @param sources
	     * @return {any}
	     * @static true
	     * @name forkJoin
	     * @owner Observable
	     */
	    ForkJoinObservable.create = function () {
	        var sources = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            sources[_i - 0] = arguments[_i];
	        }
	        if (sources === null || arguments.length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        var resultSelector = null;
	        if (typeof sources[sources.length - 1] === 'function') {
	            resultSelector = sources.pop();
	        }
	        // if the first and only other argument besides the resultSelector is an array
	        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
	        if (sources.length === 1 && isArray_1.isArray(sources[0])) {
	            sources = sources[0];
	        }
	        if (sources.length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        return new ForkJoinObservable(sources, resultSelector);
	    };
	    ForkJoinObservable.prototype._subscribe = function (subscriber) {
	        return new ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
	    };
	    return ForkJoinObservable;
	}(Observable_1.Observable));
	exports.ForkJoinObservable = ForkJoinObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ForkJoinSubscriber = (function (_super) {
	    __extends(ForkJoinSubscriber, _super);
	    function ForkJoinSubscriber(destination, sources, resultSelector) {
	        _super.call(this, destination);
	        this.sources = sources;
	        this.resultSelector = resultSelector;
	        this.completed = 0;
	        this.haveValues = 0;
	        var len = sources.length;
	        this.total = len;
	        this.values = new Array(len);
	        for (var i = 0; i < len; i++) {
	            var source = sources[i];
	            var innerSubscription = subscribeToResult_1.subscribeToResult(this, source, null, i);
	            if (innerSubscription) {
	                innerSubscription.outerIndex = i;
	                this.add(innerSubscription);
	            }
	        }
	    }
	    ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values[outerIndex] = innerValue;
	        if (!innerSub._hasValue) {
	            innerSub._hasValue = true;
	            this.haveValues++;
	        }
	    };
	    ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
	        var destination = this.destination;
	        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
	        var len = values.length;
	        if (!innerSub._hasValue) {
	            destination.complete();
	            return;
	        }
	        this.completed++;
	        if (this.completed !== len) {
	            return;
	        }
	        if (haveValues === len) {
	            var value = resultSelector ? resultSelector.apply(this, values) : values;
	            destination.next(value);
	        }
	        destination.complete();
	    };
	    return ForkJoinSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var from_1 = __webpack_require__(77);
	Observable_1.Observable.from = from_1.from;
	


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var FromObservable_1 = __webpack_require__(78);
	exports.from = FromObservable_1.FromObservable.create;
	


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isArray_1 = __webpack_require__(35);
	var isPromise_1 = __webpack_require__(61);
	var PromiseObservable_1 = __webpack_require__(79);
	var IteratorObservable_1 = __webpack_require__(80);
	var ArrayObservable_1 = __webpack_require__(55);
	var ArrayLikeObservable_1 = __webpack_require__(81);
	var iterator_1 = __webpack_require__(62);
	var Observable_1 = __webpack_require__(29);
	var observeOn_1 = __webpack_require__(82);
	var observable_1 = __webpack_require__(42);
	var isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromObservable = (function (_super) {
	    __extends(FromObservable, _super);
	    function FromObservable(ish, scheduler) {
	        _super.call(this, null);
	        this.ish = ish;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable from an Array, an array-like object, a Promise, an
	     * iterable object, or an Observable-like object.
	     *
	     * <span class="informal">Converts almost anything to an Observable.</span>
	     *
	     * <img src="./img/from.png" width="100%">
	     *
	     * Convert various other objects and data types into Observables. `from`
	     * converts a Promise or an array-like or an
	     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
	     * object into an Observable that emits the items in that promise or array or
	     * iterable. A String, in this context, is treated as an array of characters.
	     * Observable-like objects (contains a function named with the ES2015 Symbol
	     * for Observable) can also be converted through this operator.
	     *
	     * @example <caption>Converts an array to an Observable</caption>
	     * var array = [10, 20, 30];
	     * var result = Rx.Observable.from(array);
	     * result.subscribe(x => console.log(x));
	     *
	     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
	     * function* generateDoubles(seed) {
	     *   var i = seed;
	     *   while (true) {
	     *     yield i;
	     *     i = 2 * i; // double it
	     *   }
	     * }
	     *
	     * var iterator = generateDoubles(3);
	     * var result = Rx.Observable.from(iterator).take(10);
	     * result.subscribe(x => console.log(x));
	     *
	     * @see {@link create}
	     * @see {@link fromEvent}
	     * @see {@link fromEventPattern}
	     * @see {@link fromPromise}
	     *
	     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
	     * Observable-like, an Array, an iterable or an array-like object to be
	     * converted.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * emissions of values.
	     * @return {Observable<T>} The Observable whose values are originally from the
	     * input object that was converted.
	     * @static true
	     * @name from
	     * @owner Observable
	     */
	    FromObservable.create = function (ish, scheduler) {
	        if (ish != null) {
	            if (typeof ish[observable_1.$$observable] === 'function') {
	                if (ish instanceof Observable_1.Observable && !scheduler) {
	                    return ish;
	                }
	                return new FromObservable(ish, scheduler);
	            }
	            else if (isArray_1.isArray(ish)) {
	                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
	            }
	            else if (isPromise_1.isPromise(ish)) {
	                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
	            }
	            else if (typeof ish[iterator_1.$$iterator] === 'function' || typeof ish === 'string') {
	                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
	            }
	            else if (isArrayLike(ish)) {
	                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
	            }
	        }
	        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
	    };
	    FromObservable.prototype._subscribe = function (subscriber) {
	        var ish = this.ish;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            return ish[observable_1.$$observable]().subscribe(subscriber);
	        }
	        else {
	            return ish[observable_1.$$observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
	        }
	    };
	    return FromObservable;
	}(Observable_1.Observable));
	exports.FromObservable = FromObservable;
	


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(29);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var PromiseObservable = (function (_super) {
	    __extends(PromiseObservable, _super);
	    function PromiseObservable(promise, scheduler) {
	        _super.call(this);
	        this.promise = promise;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Converts a Promise to an Observable.
	     *
	     * <span class="informal">Returns an Observable that just emits the Promise's
	     * resolved value, then completes.</span>
	     *
	     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
	     * Observable. If the Promise resolves with a value, the output Observable
	     * emits that resolved value as a `next`, and then completes. If the Promise
	     * is rejected, then the output Observable emits the corresponding Error.
	     *
	     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
	     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link bindCallback}
	     * @see {@link from}
	     *
	     * @param {Promise<T>} promise The promise to be converted.
	     * @param {Scheduler} [scheduler] An optional Scheduler to use for scheduling
	     * the delivery of the resolved value (or the rejection).
	     * @return {Observable<T>} An Observable which wraps the Promise.
	     * @static true
	     * @name fromPromise
	     * @owner Observable
	     */
	    PromiseObservable.create = function (promise, scheduler) {
	        return new PromiseObservable(promise, scheduler);
	    };
	    PromiseObservable.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var promise = this.promise;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    subscriber.next(this.value);
	                    subscriber.complete();
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.next(value);
	                        subscriber.complete();
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.error(err);
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root_1.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	        else {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root_1.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	    };
	    return PromiseObservable;
	}(Observable_1.Observable));
	exports.PromiseObservable = PromiseObservable;
	function dispatchNext(arg) {
	    var value = arg.value, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.next(value);
	        subscriber.complete();
	    }
	}
	function dispatchError(arg) {
	    var err = arg.err, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.error(err);
	    }
	}
	


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(29);
	var iterator_1 = __webpack_require__(62);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IteratorObservable = (function (_super) {
	    __extends(IteratorObservable, _super);
	    function IteratorObservable(iterator, scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	        if (iterator == null) {
	            throw new Error('iterator cannot be null.');
	        }
	        this.iterator = getIterator(iterator);
	    }
	    IteratorObservable.create = function (iterator, scheduler) {
	        return new IteratorObservable(iterator, scheduler);
	    };
	    IteratorObservable.dispatch = function (state) {
	        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
	        if (hasError) {
	            subscriber.error(state.error);
	            return;
	        }
	        var result = iterator.next();
	        if (result.done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(result.value);
	        state.index = index + 1;
	        if (subscriber.closed) {
	            return;
	        }
	        this.schedule(state);
	    };
	    IteratorObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(IteratorObservable.dispatch, 0, {
	                index: index, iterator: iterator, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                var result = iterator.next();
	                if (result.done) {
	                    subscriber.complete();
	                    break;
	                }
	                else {
	                    subscriber.next(result.value);
	                }
	                if (subscriber.closed) {
	                    break;
	                }
	            } while (true);
	        }
	    };
	    return IteratorObservable;
	}(Observable_1.Observable));
	exports.IteratorObservable = IteratorObservable;
	var StringIterator = (function () {
	    function StringIterator(str, idx, len) {
	        if (idx === void 0) { idx = 0; }
	        if (len === void 0) { len = str.length; }
	        this.str = str;
	        this.idx = idx;
	        this.len = len;
	    }
	    StringIterator.prototype[iterator_1.$$iterator] = function () { return (this); };
	    StringIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.str.charAt(this.idx++)
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return StringIterator;
	}());
	var ArrayIterator = (function () {
	    function ArrayIterator(arr, idx, len) {
	        if (idx === void 0) { idx = 0; }
	        if (len === void 0) { len = toLength(arr); }
	        this.arr = arr;
	        this.idx = idx;
	        this.len = len;
	    }
	    ArrayIterator.prototype[iterator_1.$$iterator] = function () { return this; };
	    ArrayIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.arr[this.idx++]
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return ArrayIterator;
	}());
	function getIterator(obj) {
	    var i = obj[iterator_1.$$iterator];
	    if (!i && typeof obj === 'string') {
	        return new StringIterator(obj);
	    }
	    if (!i && obj.length !== undefined) {
	        return new ArrayIterator(obj);
	    }
	    if (!i) {
	        throw new TypeError('object is not iterable');
	    }
	    return obj[iterator_1.$$iterator]();
	}
	var maxSafeInteger = Math.pow(2, 53) - 1;
	function toLength(o) {
	    var len = +o.length;
	    if (isNaN(len)) {
	        return 0;
	    }
	    if (len === 0 || !numberIsFinite(len)) {
	        return len;
	    }
	    len = sign(len) * Math.floor(Math.abs(len));
	    if (len <= 0) {
	        return 0;
	    }
	    if (len > maxSafeInteger) {
	        return maxSafeInteger;
	    }
	    return len;
	}
	function numberIsFinite(value) {
	    return typeof value === 'number' && root_1.root.isFinite(value);
	}
	function sign(value) {
	    var valueAsNumber = +value;
	    if (valueAsNumber === 0) {
	        return valueAsNumber;
	    }
	    if (isNaN(valueAsNumber)) {
	        return valueAsNumber;
	    }
	    return valueAsNumber < 0 ? -1 : 1;
	}
	


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var ScalarObservable_1 = __webpack_require__(56);
	var EmptyObservable_1 = __webpack_require__(57);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayLikeObservable = (function (_super) {
	    __extends(ArrayLikeObservable, _super);
	    function ArrayLikeObservable(arrayLike, scheduler) {
	        _super.call(this);
	        this.arrayLike = arrayLike;
	        this.scheduler = scheduler;
	        if (!scheduler && arrayLike.length === 1) {
	            this._isScalar = true;
	            this.value = arrayLike[0];
	        }
	    }
	    ArrayLikeObservable.create = function (arrayLike, scheduler) {
	        var length = arrayLike.length;
	        if (length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else if (length === 1) {
	            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
	        }
	        else {
	            return new ArrayLikeObservable(arrayLike, scheduler);
	        }
	    };
	    ArrayLikeObservable.dispatch = function (state) {
	        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
	        if (subscriber.closed) {
	            return;
	        }
	        if (index >= length) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(arrayLike[index]);
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    ArrayLikeObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
	        var length = arrayLike.length;
	        if (scheduler) {
	            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
	                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < length && !subscriber.closed; i++) {
	                subscriber.next(arrayLike[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayLikeObservable;
	}(Observable_1.Observable));
	exports.ArrayLikeObservable = ArrayLikeObservable;
	


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var Notification_1 = __webpack_require__(83);
	/**
	 * @see {@link Notification}
	 *
	 * @param scheduler
	 * @param delay
	 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
	 * @method observeOn
	 * @owner Observable
	 */
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return this.lift(new ObserveOnOperator(scheduler, delay));
	}
	exports.observeOn = observeOn;
	var ObserveOnOperator = (function () {
	    function ObserveOnOperator(scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
	    };
	    return ObserveOnOperator;
	}());
	exports.ObserveOnOperator = ObserveOnOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ObserveOnSubscriber = (function (_super) {
	    __extends(ObserveOnSubscriber, _super);
	    function ObserveOnSubscriber(destination, scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnSubscriber.dispatch = function (arg) {
	        var notification = arg.notification, destination = arg.destination;
	        notification.observe(destination);
	    };
	    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
	        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
	    };
	    ObserveOnSubscriber.prototype._next = function (value) {
	        this.scheduleMessage(Notification_1.Notification.createNext(value));
	    };
	    ObserveOnSubscriber.prototype._error = function (err) {
	        this.scheduleMessage(Notification_1.Notification.createError(err));
	    };
	    ObserveOnSubscriber.prototype._complete = function () {
	        this.scheduleMessage(Notification_1.Notification.createComplete());
	    };
	    return ObserveOnSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ObserveOnSubscriber = ObserveOnSubscriber;
	var ObserveOnMessage = (function () {
	    function ObserveOnMessage(notification, destination) {
	        this.notification = notification;
	        this.destination = destination;
	    }
	    return ObserveOnMessage;
	}());
	exports.ObserveOnMessage = ObserveOnMessage;
	


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	/**
	 * Represents a push-based event or value that an {@link Observable} can emit.
	 * This class is particularly useful for operators that manage notifications,
	 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
	 * others. Besides wrapping the actual delivered value, it also annotates it
	 * with metadata of, for instance, what type of push message it is (`next`,
	 * `error`, or `complete`).
	 *
	 * @see {@link materialize}
	 * @see {@link dematerialize}
	 * @see {@link observeOn}
	 *
	 * @class Notification<T>
	 */
	var Notification = (function () {
	    function Notification(kind, value, exception) {
	        this.kind = kind;
	        this.value = value;
	        this.exception = exception;
	        this.hasValue = kind === 'N';
	    }
	    /**
	     * Delivers to the given `observer` the value wrapped by this Notification.
	     * @param {Observer} observer
	     * @return
	     */
	    Notification.prototype.observe = function (observer) {
	        switch (this.kind) {
	            case 'N':
	                return observer.next && observer.next(this.value);
	            case 'E':
	                return observer.error && observer.error(this.exception);
	            case 'C':
	                return observer.complete && observer.complete();
	        }
	    };
	    /**
	     * Given some {@link Observer} callbacks, deliver the value represented by the
	     * current Notification to the correctly corresponding callback.
	     * @param {function(value: T): void} next An Observer `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.do = function (next, error, complete) {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return next && next(this.value);
	            case 'E':
	                return error && error(this.exception);
	            case 'C':
	                return complete && complete();
	        }
	    };
	    /**
	     * Takes an Observer or its individual callback functions, and calls `observe`
	     * or `do` methods accordingly.
	     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
	     * the `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.accept = function (nextOrObserver, error, complete) {
	        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
	            return this.observe(nextOrObserver);
	        }
	        else {
	            return this.do(nextOrObserver, error, complete);
	        }
	    };
	    /**
	     * Returns a simple Observable that just delivers the notification represented
	     * by this Notification instance.
	     * @return {any}
	     */
	    Notification.prototype.toObservable = function () {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return Observable_1.Observable.of(this.value);
	            case 'E':
	                return Observable_1.Observable.throw(this.exception);
	            case 'C':
	                return Observable_1.Observable.empty();
	        }
	        throw new Error('unexpected notification kind value');
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `next` from a
	     * given value.
	     * @param {T} value The `next` value.
	     * @return {Notification<T>} The "next" Notification representing the
	     * argument.
	     */
	    Notification.createNext = function (value) {
	        if (typeof value !== 'undefined') {
	            return new Notification('N', value);
	        }
	        return this.undefinedValueNotification;
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `error` from a
	     * given error.
	     * @param {any} [err] The `error` exception.
	     * @return {Notification<T>} The "error" Notification representing the
	     * argument.
	     */
	    Notification.createError = function (err) {
	        return new Notification('E', undefined, err);
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `complete`.
	     * @return {Notification<any>} The valueless "complete" Notification.
	     */
	    Notification.createComplete = function () {
	        return this.completeNotification;
	    };
	    Notification.completeNotification = new Notification('C');
	    Notification.undefinedValueNotification = new Notification('N', undefined);
	    return Notification;
	}());
	exports.Notification = Notification;
	


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var fromEvent_1 = __webpack_require__(85);
	Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
	


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var FromEventObservable_1 = __webpack_require__(86);
	exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
	


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var tryCatch_1 = __webpack_require__(37);
	var isFunction_1 = __webpack_require__(33);
	var errorObject_1 = __webpack_require__(38);
	var Subscription_1 = __webpack_require__(34);
	function isNodeStyleEventEmmitter(sourceObj) {
	    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
	}
	function isJQueryStyleEventEmitter(sourceObj) {
	    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
	}
	function isNodeList(sourceObj) {
	    return !!sourceObj && sourceObj.toString() === '[object NodeList]';
	}
	function isHTMLCollection(sourceObj) {
	    return !!sourceObj && sourceObj.toString() === '[object HTMLCollection]';
	}
	function isEventTarget(sourceObj) {
	    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
	}
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromEventObservable = (function (_super) {
	    __extends(FromEventObservable, _super);
	    function FromEventObservable(sourceObj, eventName, selector, options) {
	        _super.call(this);
	        this.sourceObj = sourceObj;
	        this.eventName = eventName;
	        this.selector = selector;
	        this.options = options;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Creates an Observable that emits events of a specific type coming from the
	     * given event target.
	     *
	     * <span class="informal">Creates an Observable from DOM events, or Node
	     * EventEmitter events or others.</span>
	     *
	     * <img src="./img/fromEvent.png" width="100%">
	     *
	     * Creates an Observable by attaching an event listener to an "event target",
	     * which may be an object with `addEventListener` and `removeEventListener`,
	     * a Node.js EventEmitter, a jQuery style EventEmitter, a NodeList from the
	     * DOM, or an HTMLCollection from the DOM. The event handler is attached when
	     * the output Observable is subscribed, and removed when the Subscription is
	     * unsubscribed.
	     *
	     * @example <caption>Emits clicks happening on the DOM document</caption>
	     * var clicks = Rx.Observable.fromEvent(document, 'click');
	     * clicks.subscribe(x => console.log(x));
	     *
	     * @see {@link from}
	     * @see {@link fromEventPattern}
	     *
	     * @param {EventTargetLike} target The DOMElement, event target, Node.js
	     * EventEmitter, NodeList or HTMLCollection to attach the event handler to.
	     * @param {string} eventName The event name of interest, being emitted by the
	     * `target`.
	     * @parm {EventListenerOptions} [options] Options to pass through to addEventListener
	     * @param {SelectorMethodSignature<T>} [selector] An optional function to
	     * post-process results. It takes the arguments from the event handler and
	     * should return a single value.
	     * @return {Observable<T>}
	     * @static true
	     * @name fromEvent
	     * @owner Observable
	     */
	    FromEventObservable.create = function (target, eventName, options, selector) {
	        if (isFunction_1.isFunction(options)) {
	            selector = options;
	            options = undefined;
	        }
	        return new FromEventObservable(target, eventName, selector, options);
	    };
	    FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
	        var unsubscribe;
	        if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
	            for (var i = 0, len = sourceObj.length; i < len; i++) {
	                FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
	            }
	        }
	        else if (isEventTarget(sourceObj)) {
	            var source_1 = sourceObj;
	            sourceObj.addEventListener(eventName, handler, options);
	            unsubscribe = function () { return source_1.removeEventListener(eventName, handler); };
	        }
	        else if (isJQueryStyleEventEmitter(sourceObj)) {
	            var source_2 = sourceObj;
	            sourceObj.on(eventName, handler);
	            unsubscribe = function () { return source_2.off(eventName, handler); };
	        }
	        else if (isNodeStyleEventEmmitter(sourceObj)) {
	            var source_3 = sourceObj;
	            sourceObj.addListener(eventName, handler);
	            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
	        }
	        subscriber.add(new Subscription_1.Subscription(unsubscribe));
	    };
	    FromEventObservable.prototype._subscribe = function (subscriber) {
	        var sourceObj = this.sourceObj;
	        var eventName = this.eventName;
	        var options = this.options;
	        var selector = this.selector;
	        var handler = selector ? function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
	            if (result === errorObject_1.errorObject) {
	                subscriber.error(errorObject_1.errorObject.e);
	            }
	            else {
	                subscriber.next(result);
	            }
	        } : function (e) { return subscriber.next(e); };
	        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
	    };
	    return FromEventObservable;
	}(Observable_1.Observable));
	exports.FromEventObservable = FromEventObservable;
	


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var fromEventPattern_1 = __webpack_require__(88);
	Observable_1.Observable.fromEventPattern = fromEventPattern_1.fromEventPattern;
	


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var FromEventPatternObservable_1 = __webpack_require__(89);
	exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
	


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var Subscription_1 = __webpack_require__(34);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromEventPatternObservable = (function (_super) {
	    __extends(FromEventPatternObservable, _super);
	    function FromEventPatternObservable(addHandler, removeHandler, selector) {
	        _super.call(this);
	        this.addHandler = addHandler;
	        this.removeHandler = removeHandler;
	        this.selector = selector;
	    }
	    /**
	     * Creates an Observable from an API based on addHandler/removeHandler
	     * functions.
	     *
	     * <span class="informal">Converts any addHandler/removeHandler API to an
	     * Observable.</span>
	     *
	     * <img src="./img/fromEventPattern.png" width="100%">
	     *
	     * Creates an Observable by using the `addHandler` and `removeHandler`
	     * functions to add and remove the handlers, with an optional selector
	     * function to project the event arguments to a result. The `addHandler` is
	     * called when the output Observable is subscribed, and `removeHandler` is
	     * called when the Subscription is unsubscribed.
	     *
	     * @example <caption>Emits clicks happening on the DOM document</caption>
	     * function addClickHandler(handler) {
	     *   document.addEventListener('click', handler);
	     * }
	     *
	     * function removeClickHandler(handler) {
	     *   document.removeEventListener('click', handler);
	     * }
	     *
	     * var clicks = Rx.Observable.fromEventPattern(
	     *   addClickHandler,
	     *   removeClickHandler
	     * );
	     * clicks.subscribe(x => console.log(x));
	     *
	     * @see {@link from}
	     * @see {@link fromEvent}
	     *
	     * @param {function(handler: Function): any} addHandler A function that takes
	     * a `handler` function as argument and attaches it somehow to the actual
	     * source of events.
	     * @param {function(handler: Function): void} removeHandler A function that
	     * takes a `handler` function as argument and removes it in case it was
	     * previously attached using `addHandler`.
	     * @param {function(...args: any): T} [selector] An optional function to
	     * post-process results. It takes the arguments from the event handler and
	     * should return a single value.
	     * @return {Observable<T>}
	     * @static true
	     * @name fromEventPattern
	     * @owner Observable
	     */
	    FromEventPatternObservable.create = function (addHandler, removeHandler, selector) {
	        return new FromEventPatternObservable(addHandler, removeHandler, selector);
	    };
	    FromEventPatternObservable.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var removeHandler = this.removeHandler;
	        var handler = !!this.selector ? function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            _this._callSelector(subscriber, args);
	        } : function (e) { subscriber.next(e); };
	        this._callAddHandler(handler, subscriber);
	        subscriber.add(new Subscription_1.Subscription(function () {
	            //TODO: determine whether or not to forward to error handler
	            removeHandler(handler);
	        }));
	    };
	    FromEventPatternObservable.prototype._callSelector = function (subscriber, args) {
	        try {
	            var result = this.selector.apply(this, args);
	            subscriber.next(result);
	        }
	        catch (e) {
	            subscriber.error(e);
	        }
	    };
	    FromEventPatternObservable.prototype._callAddHandler = function (handler, errorSubscriber) {
	        try {
	            this.addHandler(handler);
	        }
	        catch (e) {
	            errorSubscriber.error(e);
	        }
	    };
	    return FromEventPatternObservable;
	}(Observable_1.Observable));
	exports.FromEventPatternObservable = FromEventPatternObservable;
	


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var fromPromise_1 = __webpack_require__(91);
	Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
	


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var PromiseObservable_1 = __webpack_require__(79);
	exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
	


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var GenerateObservable_1 = __webpack_require__(93);
	Observable_1.Observable.generate = GenerateObservable_1.GenerateObservable.create;
	


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var isScheduler_1 = __webpack_require__(54);
	var selfSelector = function (value) { return value; };
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var GenerateObservable = (function (_super) {
	    __extends(GenerateObservable, _super);
	    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
	        _super.call(this);
	        this.initialState = initialState;
	        this.condition = condition;
	        this.iterate = iterate;
	        this.resultSelector = resultSelector;
	        this.scheduler = scheduler;
	    }
	    GenerateObservable.create = function (initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
	        if (arguments.length == 1) {
	            return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || selfSelector, initialStateOrOptions.scheduler);
	        }
	        if (resultSelectorOrObservable === undefined || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
	            return new GenerateObservable(initialStateOrOptions, condition, iterate, selfSelector, resultSelectorOrObservable);
	        }
	        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
	    };
	    GenerateObservable.prototype._subscribe = function (subscriber) {
	        var state = this.initialState;
	        if (this.scheduler) {
	            return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
	                subscriber: subscriber,
	                iterate: this.iterate,
	                condition: this.condition,
	                resultSelector: this.resultSelector,
	                state: state });
	        }
	        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
	        do {
	            if (condition) {
	                var conditionResult = void 0;
	                try {
	                    conditionResult = condition(state);
	                }
	                catch (err) {
	                    subscriber.error(err);
	                    return;
	                }
	                if (!conditionResult) {
	                    subscriber.complete();
	                    break;
	                }
	            }
	            var value = void 0;
	            try {
	                value = resultSelector(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	            subscriber.next(value);
	            if (subscriber.closed) {
	                break;
	            }
	            try {
	                state = iterate(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	        } while (true);
	    };
	    GenerateObservable.dispatch = function (state) {
	        var subscriber = state.subscriber, condition = state.condition;
	        if (subscriber.closed) {
	            return;
	        }
	        if (state.needIterate) {
	            try {
	                state.state = state.iterate(state.state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	        }
	        else {
	            state.needIterate = true;
	        }
	        if (condition) {
	            var conditionResult = void 0;
	            try {
	                conditionResult = condition(state.state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	            if (!conditionResult) {
	                subscriber.complete();
	                return;
	            }
	            if (subscriber.closed) {
	                return;
	            }
	        }
	        var value;
	        try {
	            value = state.resultSelector(state.state);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return;
	        }
	        if (subscriber.closed) {
	            return;
	        }
	        subscriber.next(value);
	        if (subscriber.closed) {
	            return;
	        }
	        return this.schedule(state);
	    };
	    return GenerateObservable;
	}(Observable_1.Observable));
	exports.GenerateObservable = GenerateObservable;
	


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var if_1 = __webpack_require__(95);
	Observable_1.Observable.if = if_1._if;
	


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var IfObservable_1 = __webpack_require__(96);
	exports._if = IfObservable_1.IfObservable.create;
	


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var subscribeToResult_1 = __webpack_require__(60);
	var OuterSubscriber_1 = __webpack_require__(59);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IfObservable = (function (_super) {
	    __extends(IfObservable, _super);
	    function IfObservable(condition, thenSource, elseSource) {
	        _super.call(this);
	        this.condition = condition;
	        this.thenSource = thenSource;
	        this.elseSource = elseSource;
	    }
	    IfObservable.create = function (condition, thenSource, elseSource) {
	        return new IfObservable(condition, thenSource, elseSource);
	    };
	    IfObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
	        return new IfSubscriber(subscriber, condition, thenSource, elseSource);
	    };
	    return IfObservable;
	}(Observable_1.Observable));
	exports.IfObservable = IfObservable;
	var IfSubscriber = (function (_super) {
	    __extends(IfSubscriber, _super);
	    function IfSubscriber(destination, condition, thenSource, elseSource) {
	        _super.call(this, destination);
	        this.condition = condition;
	        this.thenSource = thenSource;
	        this.elseSource = elseSource;
	        this.tryIf();
	    }
	    IfSubscriber.prototype.tryIf = function () {
	        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
	        var result;
	        try {
	            result = condition();
	            var source = result ? thenSource : elseSource;
	            if (source) {
	                this.add(subscribeToResult_1.subscribeToResult(this, source));
	            }
	            else {
	                this._complete();
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    return IfSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var interval_1 = __webpack_require__(98);
	Observable_1.Observable.interval = interval_1.interval;
	


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var IntervalObservable_1 = __webpack_require__(99);
	exports.interval = IntervalObservable_1.IntervalObservable.create;
	


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isNumeric_1 = __webpack_require__(100);
	var Observable_1 = __webpack_require__(29);
	var async_1 = __webpack_require__(101);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IntervalObservable = (function (_super) {
	    __extends(IntervalObservable, _super);
	    function IntervalObservable(period, scheduler) {
	        if (period === void 0) { period = 0; }
	        if (scheduler === void 0) { scheduler = async_1.async; }
	        _super.call(this);
	        this.period = period;
	        this.scheduler = scheduler;
	        if (!isNumeric_1.isNumeric(period) || period < 0) {
	            this.period = 0;
	        }
	        if (!scheduler || typeof scheduler.schedule !== 'function') {
	            this.scheduler = async_1.async;
	        }
	    }
	    /**
	     * Creates an Observable that emits sequential numbers every specified
	     * interval of time, on a specified Scheduler.
	     *
	     * <span class="informal">Emits incremental numbers periodically in time.
	     * </span>
	     *
	     * <img src="./img/interval.png" width="100%">
	     *
	     * `interval` returns an Observable that emits an infinite sequence of
	     * ascending integers, with a constant interval of time of your choosing
	     * between those emissions. The first emission is not sent immediately, but
	     * only after the first period has passed. By default, this operator uses the
	     * `async` Scheduler to provide a notion of time, but you may pass any
	     * Scheduler to it.
	     *
	     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
	     * var numbers = Rx.Observable.interval(1000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link timer}
	     * @see {@link delay}
	     *
	     * @param {number} [period=0] The interval size in milliseconds (by default)
	     * or the time unit determined by the scheduler's clock.
	     * @param {Scheduler} [scheduler=async] The Scheduler to use for scheduling
	     * the emission of values, and providing a notion of "time".
	     * @return {Observable} An Observable that emits a sequential number each time
	     * interval.
	     * @static true
	     * @name interval
	     * @owner Observable
	     */
	    IntervalObservable.create = function (period, scheduler) {
	        if (period === void 0) { period = 0; }
	        if (scheduler === void 0) { scheduler = async_1.async; }
	        return new IntervalObservable(period, scheduler);
	    };
	    IntervalObservable.dispatch = function (state) {
	        var index = state.index, subscriber = state.subscriber, period = state.period;
	        subscriber.next(index);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index += 1;
	        this.schedule(state, period);
	    };
	    IntervalObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var period = this.period;
	        var scheduler = this.scheduler;
	        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
	            index: index, subscriber: subscriber, period: period
	        }));
	    };
	    return IntervalObservable;
	}(Observable_1.Observable));
	exports.IntervalObservable = IntervalObservable;
	


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var isArray_1 = __webpack_require__(35);
	function isNumeric(val) {
	    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
	    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	    // subtraction forces infinities to NaN
	    // adding 1 corrects loss of precision from parseFloat (#15100)
	    return !isArray_1.isArray(val) && (val - parseFloat(val) + 1) >= 0;
	}
	exports.isNumeric = isNumeric;
	;
	


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var AsyncAction_1 = __webpack_require__(102);
	var AsyncScheduler_1 = __webpack_require__(104);
	exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
	


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(30);
	var Action_1 = __webpack_require__(103);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AsyncAction = (function (_super) {
	    __extends(AsyncAction, _super);
	    function AsyncAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	        this.pending = false;
	    }
	    AsyncAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (this.closed) {
	            return this;
	        }
	        // Always replace the current state with the new state.
	        this.state = state;
	        // Set the pending flag indicating that this action has been scheduled, or
	        // has recursively rescheduled itself.
	        this.pending = true;
	        var id = this.id;
	        var scheduler = this.scheduler;
	        //
	        // Important implementation note:
	        //
	        // Actions only execute once by default, unless rescheduled from within the
	        // scheduled callback. This allows us to implement single and repeat
	        // actions via the same code path, without adding API surface area, as well
	        // as mimic traditional recursion but across asynchronous boundaries.
	        //
	        // However, JS runtimes and timers distinguish between intervals achieved by
	        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
	        // serial `setTimeout` calls can be individually delayed, which delays
	        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
	        // guarantee the interval callback will be invoked more precisely to the
	        // interval period, regardless of load.
	        //
	        // Therefore, we use `setInterval` to schedule single and repeat actions.
	        // If the action reschedules itself with the same delay, the interval is not
	        // canceled. If the action doesn't reschedule, or reschedules with a
	        // different delay, the interval will be canceled after scheduled callback
	        // execution.
	        //
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, delay);
	        }
	        this.delay = delay;
	        // If this action has already an async Id, don't request a new one.
	        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
	        return this;
	    };
	    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
	    };
	    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If this action is rescheduled with the same delay time, don't clear the interval id.
	        if (delay !== null && this.delay === delay) {
	            return id;
	        }
	        // Otherwise, if the action's delay time is different from the current delay,
	        // clear the interval id
	        return root_1.root.clearInterval(id) && undefined || undefined;
	    };
	    /**
	     * Immediately executes this action and the `work` it contains.
	     * @return {any}
	     */
	    AsyncAction.prototype.execute = function (state, delay) {
	        if (this.closed) {
	            return new Error('executing a cancelled action');
	        }
	        this.pending = false;
	        var error = this._execute(state, delay);
	        if (error) {
	            return error;
	        }
	        else if (this.pending === false && this.id != null) {
	            // Dequeue if the action didn't reschedule itself. Don't call
	            // unsubscribe(), because the action could reschedule later.
	            // For example:
	            // ```
	            // scheduler.schedule(function doWork(counter) {
	            //   /* ... I'm a busy worker bee ... */
	            //   var originalAction = this;
	            //   /* wait 100ms before rescheduling the action */
	            //   setTimeout(function () {
	            //     originalAction.schedule(counter + 1);
	            //   }, 100);
	            // }, 1000);
	            // ```
	            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
	        }
	    };
	    AsyncAction.prototype._execute = function (state, delay) {
	        var errored = false;
	        var errorValue = undefined;
	        try {
	            this.work(state);
	        }
	        catch (e) {
	            errored = true;
	            errorValue = !!e && e || new Error(e);
	        }
	        if (errored) {
	            this.unsubscribe();
	            return errorValue;
	        }
	    };
	    AsyncAction.prototype._unsubscribe = function () {
	        var id = this.id;
	        var scheduler = this.scheduler;
	        var actions = scheduler.actions;
	        var index = actions.indexOf(this);
	        this.work = null;
	        this.delay = null;
	        this.state = null;
	        this.pending = false;
	        this.scheduler = null;
	        if (index !== -1) {
	            actions.splice(index, 1);
	        }
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, null);
	        }
	    };
	    return AsyncAction;
	}(Action_1.Action));
	exports.AsyncAction = AsyncAction;
	


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(34);
	/**
	 * A unit of work to be executed in a {@link Scheduler}. An action is typically
	 * created from within a Scheduler and an RxJS user does not need to concern
	 * themselves about creating and manipulating an Action.
	 *
	 * ```ts
	 * class Action<T> extends Subscription {
	 *   new (scheduler: Scheduler, work: (state?: T) => void);
	 *   schedule(state?: T, delay: number = 0): Subscription;
	 * }
	 * ```
	 *
	 * @class Action<T>
	 */
	var Action = (function (_super) {
	    __extends(Action, _super);
	    function Action(scheduler, work) {
	        _super.call(this);
	    }
	    /**
	     * Schedules this action on its parent Scheduler for execution. May be passed
	     * some context object, `state`. May happen at some point in the future,
	     * according to the `delay` parameter, if specified.
	     * @param {T} [state] Some contextual data that the `work` function uses when
	     * called by the Scheduler.
	     * @param {number} [delay] Time to wait before executing the work, where the
	     * time unit is implicit and defined by the Scheduler.
	     * @return {void}
	     */
	    Action.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        return this;
	    };
	    return Action;
	}(Subscription_1.Subscription));
	exports.Action = Action;
	


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Scheduler_1 = __webpack_require__(105);
	var AsyncScheduler = (function (_super) {
	    __extends(AsyncScheduler, _super);
	    function AsyncScheduler() {
	        _super.apply(this, arguments);
	        this.actions = [];
	        /**
	         * A flag to indicate whether the Scheduler is currently executing a batch of
	         * queued actions.
	         * @type {boolean}
	         */
	        this.active = false;
	        /**
	         * An internal ID used to track the latest asynchronous task such as those
	         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
	         * others.
	         * @type {any}
	         */
	        this.scheduled = undefined;
	    }
	    AsyncScheduler.prototype.flush = function (action) {
	        var actions = this.actions;
	        if (this.active) {
	            actions.push(action);
	            return;
	        }
	        var error;
	        this.active = true;
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (action = actions.shift()); // exhaust the scheduler queue
	        this.active = false;
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsyncScheduler;
	}(Scheduler_1.Scheduler));
	exports.AsyncScheduler = AsyncScheduler;
	


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	/**
	 * An execution context and a data structure to order tasks and schedule their
	 * execution. Provides a notion of (potentially virtual) time, through the
	 * `now()` getter method.
	 *
	 * Each unit of work in a Scheduler is called an {@link Action}.
	 *
	 * ```ts
	 * class Scheduler {
	 *   now(): number;
	 *   schedule(work, delay?, state?): Subscription;
	 * }
	 * ```
	 *
	 * @class Scheduler
	 */
	var Scheduler = (function () {
	    function Scheduler(SchedulerAction, now) {
	        if (now === void 0) { now = Scheduler.now; }
	        this.SchedulerAction = SchedulerAction;
	        this.now = now;
	    }
	    /**
	     * Schedules a function, `work`, for execution. May happen at some point in
	     * the future, according to the `delay` parameter, if specified. May be passed
	     * some context object, `state`, which will be passed to the `work` function.
	     *
	     * The given arguments will be processed an stored as an Action object in a
	     * queue of actions.
	     *
	     * @param {function(state: ?T): ?Subscription} work A function representing a
	     * task, or some unit of work to be executed by the Scheduler.
	     * @param {number} [delay] Time to wait before executing the work, where the
	     * time unit is implicit and defined by the Scheduler itself.
	     * @param {T} [state] Some contextual data that the `work` function uses when
	     * called by the Scheduler.
	     * @return {Subscription} A subscription in order to be able to unsubscribe
	     * the scheduled work.
	     */
	    Scheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) { delay = 0; }
	        return new this.SchedulerAction(this, work).schedule(state, delay);
	    };
	    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
	    return Scheduler;
	}());
	exports.Scheduler = Scheduler;
	


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var merge_1 = __webpack_require__(107);
	Observable_1.Observable.merge = merge_1.merge;
	


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var merge_1 = __webpack_require__(108);
	exports.merge = merge_1.mergeStatic;
	


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ArrayObservable_1 = __webpack_require__(55);
	var mergeAll_1 = __webpack_require__(67);
	var isScheduler_1 = __webpack_require__(54);
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (either the source or an
	 * Observable given as argument), and simply forwards (without doing any
	 * transformation) all the values from all the input Observables to the output
	 * Observable. The output Observable only completes once all input Observables
	 * have completed. Any error delivered by an input Observable will be immediately
	 * emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = clicks.merge(timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = timer1.merge(timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {Observable} other An input Observable to merge with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The Scheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} an Observable that emits items that are the result of
	 * every input Observable.
	 * @method merge
	 * @owner Observable
	 */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    observables.unshift(this);
	    return mergeStatic.apply(this, observables);
	}
	exports.merge = merge;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (as arguments), and simply
	 * forwards (without doing any transformation) all the values from all the input
	 * Observables to the output Observable. The output Observable only completes
	 * once all input Observables have completed. Any error delivered by an input
	 * Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {Observable} input1 An input Observable to merge with others.
	 * @param {Observable} input2 An input Observable to merge with others.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The Scheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} an Observable that emits items that are the result of
	 * every input Observable.
	 * @static true
	 * @name merge
	 * @owner Observable
	 */
	function mergeStatic() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var concurrent = Number.POSITIVE_INFINITY;
	    var scheduler = null;
	    var last = observables[observables.length - 1];
	    if (isScheduler_1.isScheduler(last)) {
	        scheduler = observables.pop();
	        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
	            concurrent = observables.pop();
	        }
	    }
	    else if (typeof last === 'number') {
	        concurrent = observables.pop();
	    }
	    if (observables.length === 1) {
	        return observables[0];
	    }
	    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new mergeAll_1.MergeAllOperator(concurrent));
	}
	exports.mergeStatic = mergeStatic;
	


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var race_1 = __webpack_require__(110);
	Observable_1.Observable.race = race_1.raceStatic;
	


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isArray_1 = __webpack_require__(35);
	var ArrayObservable_1 = __webpack_require__(55);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Returns an Observable that mirrors the first source Observable to emit an item
	 * from the combination of this Observable and supplied Observables
	 * @param {...Observables} ...observables sources used to race for which Observable emits first.
	 * @return {Observable} an Observable that mirrors the output of the first Observable to emit an item.
	 * @method race
	 * @owner Observable
	 */
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    // if the only argument is an array, it was most likely called with
	    // `pair([obs1, obs2, ...])`
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0];
	    }
	    observables.unshift(this);
	    return raceStatic.apply(this, observables);
	}
	exports.race = race;
	function raceStatic() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    // if the only argument is an array, it was most likely called with
	    // `pair([obs1, obs2, ...])`
	    if (observables.length === 1) {
	        if (isArray_1.isArray(observables[0])) {
	            observables = observables[0];
	        }
	        else {
	            return observables[0];
	        }
	    }
	    return new ArrayObservable_1.ArrayObservable(observables).lift(new RaceOperator());
	}
	exports.raceStatic = raceStatic;
	var RaceOperator = (function () {
	    function RaceOperator() {
	    }
	    RaceOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new RaceSubscriber(subscriber));
	    };
	    return RaceOperator;
	}());
	exports.RaceOperator = RaceOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RaceSubscriber = (function (_super) {
	    __extends(RaceSubscriber, _super);
	    function RaceSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasFirst = false;
	        this.observables = [];
	        this.subscriptions = [];
	    }
	    RaceSubscriber.prototype._next = function (observable) {
	        this.observables.push(observable);
	    };
	    RaceSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            for (var i = 0; i < len; i++) {
	                var observable = observables[i];
	                var subscription = subscribeToResult_1.subscribeToResult(this, observable, observable, i);
	                if (this.subscriptions) {
	                    this.subscriptions.push(subscription);
	                    this.add(subscription);
	                }
	            }
	            this.observables = null;
	        }
	    };
	    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (!this.hasFirst) {
	            this.hasFirst = true;
	            for (var i = 0; i < this.subscriptions.length; i++) {
	                if (i !== outerIndex) {
	                    var subscription = this.subscriptions[i];
	                    subscription.unsubscribe();
	                    this.remove(subscription);
	                }
	            }
	            this.subscriptions = null;
	        }
	        this.destination.next(innerValue);
	    };
	    return RaceSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.RaceSubscriber = RaceSubscriber;
	


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var never_1 = __webpack_require__(112);
	Observable_1.Observable.never = never_1.never;
	


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var NeverObservable_1 = __webpack_require__(113);
	exports.never = NeverObservable_1.NeverObservable.create;
	


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var noop_1 = __webpack_require__(114);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var NeverObservable = (function (_super) {
	    __extends(NeverObservable, _super);
	    function NeverObservable() {
	        _super.call(this);
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer.
	     *
	     * <span class="informal">An Observable that never emits anything.</span>
	     *
	     * <img src="./img/never.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that emits
	     * neither values nor errors nor the completion notification. It can be used
	     * for testing purposes or for composing with other Observables. Please not
	     * that by never emitting a complete notification, this Observable keeps the
	     * subscription from being disposed automatically. Subscriptions need to be
	     * manually disposed.
	     *
	     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
	     * function info() {
	     *   console.log('Will not be called');
	     * }
	     * var result = Rx.Observable.never().startWith(7);
	     * result.subscribe(x => console.log(x), info, info);
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link of}
	     * @see {@link throw}
	     *
	     * @return {Observable} A "never" Observable: never emits anything.
	     * @static true
	     * @name never
	     * @owner Observable
	     */
	    NeverObservable.create = function () {
	        return new NeverObservable();
	    };
	    NeverObservable.prototype._subscribe = function (subscriber) {
	        noop_1.noop();
	    };
	    return NeverObservable;
	}(Observable_1.Observable));
	exports.NeverObservable = NeverObservable;
	


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	/* tslint:disable:no-empty */
	function noop() { }
	exports.noop = noop;
	


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var of_1 = __webpack_require__(116);
	Observable_1.Observable.of = of_1.of;
	


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ArrayObservable_1 = __webpack_require__(55);
	exports.of = ArrayObservable_1.ArrayObservable.of;
	


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var onErrorResumeNext_1 = __webpack_require__(118);
	Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
	


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FromObservable_1 = __webpack_require__(78);
	var isArray_1 = __webpack_require__(35);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	function onErrorResumeNext() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    return this.lift(new OnErrorResumeNextOperator(nextSources));
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	/* tslint:enable:max-line-length */
	function onErrorResumeNextStatic() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    var source = null;
	    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    source = nextSources.shift();
	    return new FromObservable_1.FromObservable(source, null).lift(new OnErrorResumeNextOperator(nextSources));
	}
	exports.onErrorResumeNextStatic = onErrorResumeNextStatic;
	var OnErrorResumeNextOperator = (function () {
	    function OnErrorResumeNextOperator(nextSources) {
	        this.nextSources = nextSources;
	    }
	    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
	    };
	    return OnErrorResumeNextOperator;
	}());
	var OnErrorResumeNextSubscriber = (function (_super) {
	    __extends(OnErrorResumeNextSubscriber, _super);
	    function OnErrorResumeNextSubscriber(destination, nextSources) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.nextSources = nextSources;
	    }
	    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype._error = function (err) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype._complete = function () {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
	        var next = this.nextSources.shift();
	        if (next) {
	            this.add(subscribeToResult_1.subscribeToResult(this, next));
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return OnErrorResumeNextSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var pairs_1 = __webpack_require__(120);
	Observable_1.Observable.pairs = pairs_1.pairs;
	


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var PairsObservable_1 = __webpack_require__(121);
	exports.pairs = PairsObservable_1.PairsObservable.create;
	


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	function dispatch(state) {
	    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
	    if (index === length) {
	        subscriber.complete();
	        return;
	    }
	    var key = keys[index];
	    subscriber.next([key, obj[key]]);
	    state.index = index + 1;
	    this.schedule(state);
	}
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var PairsObservable = (function (_super) {
	    __extends(PairsObservable, _super);
	    function PairsObservable(obj, scheduler) {
	        _super.call(this);
	        this.obj = obj;
	        this.scheduler = scheduler;
	        this.keys = Object.keys(obj);
	    }
	    /**
	     * Convert an object into an observable sequence of [key, value] pairs
	     * using an optional Scheduler to enumerate the object.
	     *
	     * @example <caption>Converts a javascript object to an Observable</caption>
	     * var obj = {
	     *   foo: 42,
	     *   bar: 56,
	     *   baz: 78
	     * };
	     *
	     * var source = Rx.Observable.pairs(obj);
	     *
	     * var subscription = source.subscribe(
	     *   function (x) {
	     *     console.log('Next: %s', x);
	     *   },
	     *   function (err) {
	     *     console.log('Error: %s', err);
	     *   },
	     *   function () {
	     *     console.log('Completed');
	     *   });
	     *
	     * @param {Object} obj The object to inspect and turn into an
	     * Observable sequence.
	     * @param {Scheduler} [scheduler] An optional Scheduler to run the
	     * enumeration of the input sequence on.
	     * @returns {(Observable<Array<string | T>>)} An observable sequence of
	     * [key, value] pairs from the object.
	     */
	    PairsObservable.create = function (obj, scheduler) {
	        return new PairsObservable(obj, scheduler);
	    };
	    PairsObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
	        var length = keys.length;
	        if (scheduler) {
	            return scheduler.schedule(dispatch, 0, {
	                obj: this.obj, keys: keys, length: length, index: 0, subscriber: subscriber
	            });
	        }
	        else {
	            for (var idx = 0; idx < length; idx++) {
	                var key = keys[idx];
	                subscriber.next([key, this.obj[key]]);
	            }
	            subscriber.complete();
	        }
	    };
	    return PairsObservable;
	}(Observable_1.Observable));
	exports.PairsObservable = PairsObservable;
	


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var range_1 = __webpack_require__(123);
	Observable_1.Observable.range = range_1.range;
	


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var RangeObservable_1 = __webpack_require__(124);
	exports.range = RangeObservable_1.RangeObservable.create;
	


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var RangeObservable = (function (_super) {
	    __extends(RangeObservable, _super);
	    function RangeObservable(start, count, scheduler) {
	        _super.call(this);
	        this.start = start;
	        this._count = count;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits a sequence of numbers within a specified
	     * range.
	     *
	     * <span class="informal">Emits a sequence of numbers in a range.</span>
	     *
	     * <img src="./img/range.png" width="100%">
	     *
	     * `range` operator emits a range of sequential integers, in order, where you
	     * select the `start` of the range and its `length`. By default, uses no
	     * Scheduler and just delivers the notifications synchronously, but may use
	     * an optional Scheduler to regulate those deliveries.
	     *
	     * @example <caption>Emits the numbers 1 to 10</caption>
	     * var numbers = Rx.Observable.range(1, 10);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link timer}
	     * @see {@link interval}
	     *
	     * @param {number} [start=0] The value of the first integer in the sequence.
	     * @param {number} [count=0] The number of sequential integers to generate.
	     * @param {Scheduler} [scheduler] A {@link Scheduler} to use for scheduling
	     * the emissions of the notifications.
	     * @return {Observable} An Observable of numbers that emits a finite range of
	     * sequential integers.
	     * @static true
	     * @name range
	     * @owner Observable
	     */
	    RangeObservable.create = function (start, count, scheduler) {
	        if (start === void 0) { start = 0; }
	        if (count === void 0) { count = 0; }
	        return new RangeObservable(start, count, scheduler);
	    };
	    RangeObservable.dispatch = function (state) {
	        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
	        if (index >= count) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(start);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index = index + 1;
	        state.start = start + 1;
	        this.schedule(state);
	    };
	    RangeObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var start = this.start;
	        var count = this._count;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(RangeObservable.dispatch, 0, {
	                index: index, count: count, start: start, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                if (index++ >= count) {
	                    subscriber.complete();
	                    break;
	                }
	                subscriber.next(start++);
	                if (subscriber.closed) {
	                    break;
	                }
	            } while (true);
	        }
	    };
	    return RangeObservable;
	}(Observable_1.Observable));
	exports.RangeObservable = RangeObservable;
	


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var using_1 = __webpack_require__(126);
	Observable_1.Observable.using = using_1.using;
	


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var UsingObservable_1 = __webpack_require__(127);
	exports.using = UsingObservable_1.UsingObservable.create;
	


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var subscribeToResult_1 = __webpack_require__(60);
	var OuterSubscriber_1 = __webpack_require__(59);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var UsingObservable = (function (_super) {
	    __extends(UsingObservable, _super);
	    function UsingObservable(resourceFactory, observableFactory) {
	        _super.call(this);
	        this.resourceFactory = resourceFactory;
	        this.observableFactory = observableFactory;
	    }
	    UsingObservable.create = function (resourceFactory, observableFactory) {
	        return new UsingObservable(resourceFactory, observableFactory);
	    };
	    UsingObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
	        var resource;
	        try {
	            resource = resourceFactory();
	            return new UsingSubscriber(subscriber, resource, observableFactory);
	        }
	        catch (err) {
	            subscriber.error(err);
	        }
	    };
	    return UsingObservable;
	}(Observable_1.Observable));
	exports.UsingObservable = UsingObservable;
	var UsingSubscriber = (function (_super) {
	    __extends(UsingSubscriber, _super);
	    function UsingSubscriber(destination, resource, observableFactory) {
	        _super.call(this, destination);
	        this.resource = resource;
	        this.observableFactory = observableFactory;
	        destination.add(resource);
	        this.tryUse();
	    }
	    UsingSubscriber.prototype.tryUse = function () {
	        try {
	            var source = this.observableFactory.call(this, this.resource);
	            if (source) {
	                this.add(subscribeToResult_1.subscribeToResult(this, source));
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    return UsingSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var throw_1 = __webpack_require__(129);
	Observable_1.Observable.throw = throw_1._throw;
	


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ErrorObservable_1 = __webpack_require__(130);
	exports._throw = ErrorObservable_1.ErrorObservable.create;
	


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ErrorObservable = (function (_super) {
	    __extends(ErrorObservable, _super);
	    function ErrorObservable(error, scheduler) {
	        _super.call(this);
	        this.error = error;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer and immediately
	     * emits an error notification.
	     *
	     * <span class="informal">Just emits 'error', and nothing else.
	     * </span>
	     *
	     * <img src="./img/throw.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the error notification. It can be used for composing with other
	     * Observables, such as in a {@link mergeMap}.
	     *
	     * @example <caption>Emit the number 7, then emit an error.</caption>
	     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @example <caption>Map and flattens numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
	     * var interval = Rx.Observable.interval(1000);
	     * var result = interval.mergeMap(x =>
	     *   x === 13 ?
	     *     Rx.Observable.throw('Thirteens are bad') :
	     *     Rx.Observable.of('a', 'b', 'c')
	     * );
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link never}
	     * @see {@link of}
	     *
	     * @param {any} error The particular Error to pass to the error notification.
	     * @param {Scheduler} [scheduler] A {@link Scheduler} to use for scheduling
	     * the emission of the error notification.
	     * @return {Observable} An error Observable: emits only the error notification
	     * using the given error argument.
	     * @static true
	     * @name throw
	     * @owner Observable
	     */
	    ErrorObservable.create = function (error, scheduler) {
	        return new ErrorObservable(error, scheduler);
	    };
	    ErrorObservable.dispatch = function (arg) {
	        var error = arg.error, subscriber = arg.subscriber;
	        subscriber.error(error);
	    };
	    ErrorObservable.prototype._subscribe = function (subscriber) {
	        var error = this.error;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ErrorObservable.dispatch, 0, {
	                error: error, subscriber: subscriber
	            });
	        }
	        else {
	            subscriber.error(error);
	        }
	    };
	    return ErrorObservable;
	}(Observable_1.Observable));
	exports.ErrorObservable = ErrorObservable;
	


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var timer_1 = __webpack_require__(132);
	Observable_1.Observable.timer = timer_1.timer;
	


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var TimerObservable_1 = __webpack_require__(133);
	exports.timer = TimerObservable_1.TimerObservable.create;
	


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isNumeric_1 = __webpack_require__(100);
	var Observable_1 = __webpack_require__(29);
	var async_1 = __webpack_require__(101);
	var isScheduler_1 = __webpack_require__(54);
	var isDate_1 = __webpack_require__(134);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var TimerObservable = (function (_super) {
	    __extends(TimerObservable, _super);
	    function TimerObservable(dueTime, period, scheduler) {
	        if (dueTime === void 0) { dueTime = 0; }
	        _super.call(this);
	        this.period = -1;
	        this.dueTime = 0;
	        if (isNumeric_1.isNumeric(period)) {
	            this.period = Number(period) < 1 && 1 || Number(period);
	        }
	        else if (isScheduler_1.isScheduler(period)) {
	            scheduler = period;
	        }
	        if (!isScheduler_1.isScheduler(scheduler)) {
	            scheduler = async_1.async;
	        }
	        this.scheduler = scheduler;
	        this.dueTime = isDate_1.isDate(dueTime) ?
	            (+dueTime - this.scheduler.now()) :
	            dueTime;
	    }
	    /**
	     * Creates an Observable that starts emitting after an `initialDelay` and
	     * emits ever increasing numbers after each `period` of time thereafter.
	     *
	     * <span class="informal">Its like {@link interval}, but you can specify when
	     * should the emissions start.</span>
	     *
	     * <img src="./img/timer.png" width="100%">
	     *
	     * `timer` returns an Observable that emits an infinite sequence of ascending
	     * integers, with a constant interval of time, `period` of your choosing
	     * between those emissions. The first emission happens after the specified
	     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
	     * operator uses the `async` Scheduler to provide a notion of time, but you
	     * may pass any Scheduler to it. If `period` is not specified, the output
	     * Observable emits only one value, `0`. Otherwise, it emits an infinite
	     * sequence.
	     *
	     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
	     * var numbers = Rx.Observable.timer(3000, 1000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @example <caption>Emits one number after five seconds</caption>
	     * var numbers = Rx.Observable.timer(5000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link interval}
	     * @see {@link delay}
	     *
	     * @param {number|Date} initialDelay The initial delay time to wait before
	     * emitting the first value of `0`.
	     * @param {number} [period] The period of time between emissions of the
	     * subsequent numbers.
	     * @param {Scheduler} [scheduler=async] The Scheduler to use for scheduling
	     * the emission of values, and providing a notion of "time".
	     * @return {Observable} An Observable that emits a `0` after the
	     * `initialDelay` and ever increasing numbers after each `period` of time
	     * thereafter.
	     * @static true
	     * @name timer
	     * @owner Observable
	     */
	    TimerObservable.create = function (initialDelay, period, scheduler) {
	        if (initialDelay === void 0) { initialDelay = 0; }
	        return new TimerObservable(initialDelay, period, scheduler);
	    };
	    TimerObservable.dispatch = function (state) {
	        var index = state.index, period = state.period, subscriber = state.subscriber;
	        var action = this;
	        subscriber.next(index);
	        if (subscriber.closed) {
	            return;
	        }
	        else if (period === -1) {
	            return subscriber.complete();
	        }
	        state.index = index + 1;
	        action.schedule(state, period);
	    };
	    TimerObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
	        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
	            index: index, period: period, subscriber: subscriber
	        });
	    };
	    return TimerObservable;
	}(Observable_1.Observable));
	exports.TimerObservable = TimerObservable;
	


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	function isDate(value) {
	    return value instanceof Date && !isNaN(+value);
	}
	exports.isDate = isDate;
	


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var zip_1 = __webpack_require__(136);
	Observable_1.Observable.zip = zip_1.zip;
	


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var zip_1 = __webpack_require__(137);
	exports.zip = zip_1.zipStatic;
	


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ArrayObservable_1 = __webpack_require__(55);
	var isArray_1 = __webpack_require__(35);
	var Subscriber_1 = __webpack_require__(32);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	var iterator_1 = __webpack_require__(62);
	/**
	 * @param observables
	 * @return {Observable<R>}
	 * @method zip
	 * @owner Observable
	 */
	function zipProto() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    observables.unshift(this);
	    return zipStatic.apply(this, observables);
	}
	exports.zipProto = zipProto;
	/* tslint:enable:max-line-length */
	/**
	 * @param observables
	 * @return {Observable<R>}
	 * @static true
	 * @name zip
	 * @owner Observable
	 */
	function zipStatic() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = observables[observables.length - 1];
	    if (typeof project === 'function') {
	        observables.pop();
	    }
	    return new ArrayObservable_1.ArrayObservable(observables).lift(new ZipOperator(project));
	}
	exports.zipStatic = zipStatic;
	var ZipOperator = (function () {
	    function ZipOperator(project) {
	        this.project = project;
	    }
	    ZipOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new ZipSubscriber(subscriber, this.project));
	    };
	    return ZipOperator;
	}());
	exports.ZipOperator = ZipOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ZipSubscriber = (function (_super) {
	    __extends(ZipSubscriber, _super);
	    function ZipSubscriber(destination, project, values) {
	        if (values === void 0) { values = Object.create(null); }
	        _super.call(this, destination);
	        this.index = 0;
	        this.iterators = [];
	        this.active = 0;
	        this.project = (typeof project === 'function') ? project : null;
	        this.values = values;
	    }
	    ZipSubscriber.prototype._next = function (value) {
	        var iterators = this.iterators;
	        var index = this.index++;
	        if (isArray_1.isArray(value)) {
	            iterators.push(new StaticArrayIterator(value));
	        }
	        else if (typeof value[iterator_1.$$iterator] === 'function') {
	            iterators.push(new StaticIterator(value[iterator_1.$$iterator]()));
	        }
	        else {
	            iterators.push(new ZipBufferIterator(this.destination, this, value, index));
	        }
	    };
	    ZipSubscriber.prototype._complete = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        this.active = len;
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (iterator.stillUnsubscribed) {
	                this.add(iterator.subscribe(iterator, i));
	            }
	            else {
	                this.active--; // not an observable
	            }
	        }
	    };
	    ZipSubscriber.prototype.notifyInactive = function () {
	        this.active--;
	        if (this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    ZipSubscriber.prototype.checkIterators = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        var destination = this.destination;
	        // abort if not all of them have values
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
	                return;
	            }
	        }
	        var shouldComplete = false;
	        var args = [];
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            var result = iterator.next();
	            // check to see if it's completed now that you've gotten
	            // the next value.
	            if (iterator.hasCompleted()) {
	                shouldComplete = true;
	            }
	            if (result.done) {
	                destination.complete();
	                return;
	            }
	            args.push(result.value);
	        }
	        if (this.project) {
	            this._tryProject(args);
	        }
	        else {
	            destination.next(args);
	        }
	        if (shouldComplete) {
	            destination.complete();
	        }
	    };
	    ZipSubscriber.prototype._tryProject = function (args) {
	        var result;
	        try {
	            result = this.project.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return ZipSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ZipSubscriber = ZipSubscriber;
	var StaticIterator = (function () {
	    function StaticIterator(iterator) {
	        this.iterator = iterator;
	        this.nextResult = iterator.next();
	    }
	    StaticIterator.prototype.hasValue = function () {
	        return true;
	    };
	    StaticIterator.prototype.next = function () {
	        var result = this.nextResult;
	        this.nextResult = this.iterator.next();
	        return result;
	    };
	    StaticIterator.prototype.hasCompleted = function () {
	        var nextResult = this.nextResult;
	        return nextResult && nextResult.done;
	    };
	    return StaticIterator;
	}());
	var StaticArrayIterator = (function () {
	    function StaticArrayIterator(array) {
	        this.array = array;
	        this.index = 0;
	        this.length = 0;
	        this.length = array.length;
	    }
	    StaticArrayIterator.prototype[iterator_1.$$iterator] = function () {
	        return this;
	    };
	    StaticArrayIterator.prototype.next = function (value) {
	        var i = this.index++;
	        var array = this.array;
	        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
	    };
	    StaticArrayIterator.prototype.hasValue = function () {
	        return this.array.length > this.index;
	    };
	    StaticArrayIterator.prototype.hasCompleted = function () {
	        return this.array.length === this.index;
	    };
	    return StaticArrayIterator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ZipBufferIterator = (function (_super) {
	    __extends(ZipBufferIterator, _super);
	    function ZipBufferIterator(destination, parent, observable, index) {
	        _super.call(this, destination);
	        this.parent = parent;
	        this.observable = observable;
	        this.index = index;
	        this.stillUnsubscribed = true;
	        this.buffer = [];
	        this.isComplete = false;
	    }
	    ZipBufferIterator.prototype[iterator_1.$$iterator] = function () {
	        return this;
	    };
	    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
	    //    this is legit because `next()` will never be called by a subscription in this case.
	    ZipBufferIterator.prototype.next = function () {
	        var buffer = this.buffer;
	        if (buffer.length === 0 && this.isComplete) {
	            return { value: null, done: true };
	        }
	        else {
	            return { value: buffer.shift(), done: false };
	        }
	    };
	    ZipBufferIterator.prototype.hasValue = function () {
	        return this.buffer.length > 0;
	    };
	    ZipBufferIterator.prototype.hasCompleted = function () {
	        return this.buffer.length === 0 && this.isComplete;
	    };
	    ZipBufferIterator.prototype.notifyComplete = function () {
	        if (this.buffer.length > 0) {
	            this.isComplete = true;
	            this.parent.notifyInactive();
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.buffer.push(innerValue);
	        this.parent.checkIterators();
	    };
	    ZipBufferIterator.prototype.subscribe = function (value, index) {
	        return subscribeToResult_1.subscribeToResult(this, this.observable, this, index);
	    };
	    return ZipBufferIterator;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var ajax_1 = __webpack_require__(139);
	Observable_1.Observable.ajax = ajax_1.ajax;
	


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var AjaxObservable_1 = __webpack_require__(140);
	exports.ajax = AjaxObservable_1.AjaxObservable.create;
	


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(30);
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var Observable_1 = __webpack_require__(29);
	var Subscriber_1 = __webpack_require__(32);
	function getCORSRequest() {
	    if (root_1.root.XMLHttpRequest) {
	        var xhr = new root_1.root.XMLHttpRequest();
	        if ('withCredentials' in xhr) {
	            xhr.withCredentials = !!this.withCredentials;
	        }
	        return xhr;
	    }
	    else if (!!root_1.root.XDomainRequest) {
	        return new root_1.root.XDomainRequest();
	    }
	    else {
	        throw new Error('CORS is not supported by your browser');
	    }
	}
	function getXMLHttpRequest() {
	    if (root_1.root.XMLHttpRequest) {
	        return new root_1.root.XMLHttpRequest();
	    }
	    else {
	        var progId = void 0;
	        try {
	            var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
	            for (var i = 0; i < 3; i++) {
	                try {
	                    progId = progIds[i];
	                    if (new root_1.root.ActiveXObject(progId)) {
	                        break;
	                    }
	                }
	                catch (e) {
	                }
	            }
	            return new root_1.root.ActiveXObject(progId);
	        }
	        catch (e) {
	            throw new Error('XMLHttpRequest is not supported by your browser');
	        }
	    }
	}
	function ajaxGet(url, headers) {
	    if (headers === void 0) { headers = null; }
	    return new AjaxObservable({ method: 'GET', url: url, headers: headers });
	}
	exports.ajaxGet = ajaxGet;
	;
	function ajaxPost(url, body, headers) {
	    return new AjaxObservable({ method: 'POST', url: url, body: body, headers: headers });
	}
	exports.ajaxPost = ajaxPost;
	;
	function ajaxDelete(url, headers) {
	    return new AjaxObservable({ method: 'DELETE', url: url, headers: headers });
	}
	exports.ajaxDelete = ajaxDelete;
	;
	function ajaxPut(url, body, headers) {
	    return new AjaxObservable({ method: 'PUT', url: url, body: body, headers: headers });
	}
	exports.ajaxPut = ajaxPut;
	;
	function ajaxGetJSON(url, headers) {
	    return new AjaxObservable({ method: 'GET', url: url, responseType: 'json', headers: headers }).map(function (x) { return x.response; });
	}
	exports.ajaxGetJSON = ajaxGetJSON;
	;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var AjaxObservable = (function (_super) {
	    __extends(AjaxObservable, _super);
	    function AjaxObservable(urlOrRequest) {
	        _super.call(this);
	        var request = {
	            async: true,
	            createXHR: function () {
	                return this.crossDomain ? getCORSRequest.call(this) : getXMLHttpRequest();
	            },
	            crossDomain: false,
	            withCredentials: false,
	            headers: {},
	            method: 'GET',
	            responseType: 'json',
	            timeout: 0
	        };
	        if (typeof urlOrRequest === 'string') {
	            request.url = urlOrRequest;
	        }
	        else {
	            for (var prop in urlOrRequest) {
	                if (urlOrRequest.hasOwnProperty(prop)) {
	                    request[prop] = urlOrRequest[prop];
	                }
	            }
	        }
	        this.request = request;
	    }
	    AjaxObservable.prototype._subscribe = function (subscriber) {
	        return new AjaxSubscriber(subscriber, this.request);
	    };
	    /**
	     * Creates an observable for an Ajax request with either a request object with
	     * url, headers, etc or a string for a URL.
	     *
	     * @example
	     * source = Rx.Observable.ajax('/products');
	     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
	     *
	     * @param {string|Object} request Can be one of the following:
	     *   A string of the URL to make the Ajax call.
	     *   An object with the following properties
	     *   - url: URL of the request
	     *   - body: The body of the request
	     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
	     *   - async: Whether the request is async
	     *   - headers: Optional headers
	     *   - crossDomain: true if a cross domain request, else false
	     *   - createXHR: a function to override if you need to use an alternate
	     *   XMLHttpRequest implementation.
	     *   - resultSelector: a function to use to alter the output value type of
	     *   the Observable. Gets {@link AjaxResponse} as an argument.
	     * @return {Observable} An observable sequence containing the XMLHttpRequest.
	     * @static true
	     * @name ajax
	     * @owner Observable
	    */
	    AjaxObservable.create = (function () {
	        var create = function (urlOrRequest) {
	            return new AjaxObservable(urlOrRequest);
	        };
	        create.get = ajaxGet;
	        create.post = ajaxPost;
	        create.delete = ajaxDelete;
	        create.put = ajaxPut;
	        create.getJSON = ajaxGetJSON;
	        return create;
	    })();
	    return AjaxObservable;
	}(Observable_1.Observable));
	exports.AjaxObservable = AjaxObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AjaxSubscriber = (function (_super) {
	    __extends(AjaxSubscriber, _super);
	    function AjaxSubscriber(destination, request) {
	        _super.call(this, destination);
	        this.request = request;
	        this.done = false;
	        var headers = request.headers = request.headers || {};
	        // force CORS if requested
	        if (!request.crossDomain && !headers['X-Requested-With']) {
	            headers['X-Requested-With'] = 'XMLHttpRequest';
	        }
	        // ensure content type is set
	        if (!('Content-Type' in headers) && !(root_1.root.FormData && request.body instanceof root_1.root.FormData) && typeof request.body !== 'undefined') {
	            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
	        }
	        // properly serialize body
	        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
	        this.send();
	    }
	    AjaxSubscriber.prototype.next = function (e) {
	        this.done = true;
	        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
	        var response = new AjaxResponse(e, xhr, request);
	        destination.next(response);
	    };
	    AjaxSubscriber.prototype.send = function () {
	        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
	        var createXHR = request.createXHR;
	        var xhr = tryCatch_1.tryCatch(createXHR).call(request);
	        if (xhr === errorObject_1.errorObject) {
	            this.error(errorObject_1.errorObject.e);
	        }
	        else {
	            this.xhr = xhr;
	            // open XHR first
	            var result = void 0;
	            if (user) {
	                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
	            }
	            else {
	                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async);
	            }
	            if (result === errorObject_1.errorObject) {
	                this.error(errorObject_1.errorObject.e);
	                return null;
	            }
	            // timeout and responseType can be set once the XHR is open
	            xhr.timeout = request.timeout;
	            xhr.responseType = request.responseType;
	            // set headers
	            this.setHeaders(xhr, headers);
	            // now set up the events
	            this.setupEvents(xhr, request);
	            // finally send the request
	            if (body) {
	                xhr.send(body);
	            }
	            else {
	                xhr.send();
	            }
	        }
	        return xhr;
	    };
	    AjaxSubscriber.prototype.serializeBody = function (body, contentType) {
	        if (!body || typeof body === 'string') {
	            return body;
	        }
	        else if (root_1.root.FormData && body instanceof root_1.root.FormData) {
	            return body;
	        }
	        if (contentType) {
	            var splitIndex = contentType.indexOf(';');
	            if (splitIndex !== -1) {
	                contentType = contentType.substring(0, splitIndex);
	            }
	        }
	        switch (contentType) {
	            case 'application/x-www-form-urlencoded':
	                return Object.keys(body).map(function (key) { return (encodeURI(key) + "=" + encodeURI(body[key])); }).join('&');
	            case 'application/json':
	                return JSON.stringify(body);
	            default:
	                return body;
	        }
	    };
	    AjaxSubscriber.prototype.setHeaders = function (xhr, headers) {
	        for (var key in headers) {
	            if (headers.hasOwnProperty(key)) {
	                xhr.setRequestHeader(key, headers[key]);
	            }
	        }
	    };
	    AjaxSubscriber.prototype.setupEvents = function (xhr, request) {
	        var progressSubscriber = request.progressSubscriber;
	        xhr.ontimeout = function xhrTimeout(e) {
	            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
	            if (progressSubscriber) {
	                progressSubscriber.error(e);
	            }
	            subscriber.error(new AjaxTimeoutError(this, request)); //TODO: Make betterer.
	        };
	        xhr.ontimeout.request = request;
	        xhr.ontimeout.subscriber = this;
	        xhr.ontimeout.progressSubscriber = progressSubscriber;
	        if (xhr.upload && 'withCredentials' in xhr && root_1.root.XDomainRequest) {
	            if (progressSubscriber) {
	                xhr.onprogress = function xhrProgress(e) {
	                    var progressSubscriber = xhrProgress.progressSubscriber;
	                    progressSubscriber.next(e);
	                };
	                xhr.onprogress.progressSubscriber = progressSubscriber;
	            }
	            xhr.onerror = function xhrError(e) {
	                var _a = xhrError, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
	                if (progressSubscriber) {
	                    progressSubscriber.error(e);
	                }
	                subscriber.error(new AjaxError('ajax error', this, request));
	            };
	            xhr.onerror.request = request;
	            xhr.onerror.subscriber = this;
	            xhr.onerror.progressSubscriber = progressSubscriber;
	        }
	        xhr.onreadystatechange = function xhrReadyStateChange(e) {
	            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
	            if (this.readyState === 4) {
	                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	                var status_1 = this.status === 1223 ? 204 : this.status;
	                var response = (this.responseType === 'text' ? (this.response || this.responseText) : this.response);
	                // fix status code when it is 0 (0 status is undocumented).
	                // Occurs when accessing file resources or on Android 4.1 stock browser
	                // while retrieving files from application cache.
	                if (status_1 === 0) {
	                    status_1 = response ? 200 : 0;
	                }
	                if (200 <= status_1 && status_1 < 300) {
	                    if (progressSubscriber) {
	                        progressSubscriber.complete();
	                    }
	                    subscriber.next(e);
	                    subscriber.complete();
	                }
	                else {
	                    if (progressSubscriber) {
	                        progressSubscriber.error(e);
	                    }
	                    subscriber.error(new AjaxError('ajax error ' + status_1, this, request));
	                }
	            }
	        };
	        xhr.onreadystatechange.subscriber = this;
	        xhr.onreadystatechange.progressSubscriber = progressSubscriber;
	        xhr.onreadystatechange.request = request;
	    };
	    AjaxSubscriber.prototype.unsubscribe = function () {
	        var _a = this, done = _a.done, xhr = _a.xhr;
	        if (!done && xhr && xhr.readyState !== 4) {
	            xhr.abort();
	        }
	        _super.prototype.unsubscribe.call(this);
	    };
	    return AjaxSubscriber;
	}(Subscriber_1.Subscriber));
	exports.AjaxSubscriber = AjaxSubscriber;
	/**
	 * A normalized AJAX response.
	 *
	 * @see {@link ajax}
	 *
	 * @class AjaxResponse
	 */
	var AjaxResponse = (function () {
	    function AjaxResponse(originalEvent, xhr, request) {
	        this.originalEvent = originalEvent;
	        this.xhr = xhr;
	        this.request = request;
	        this.status = xhr.status;
	        this.responseType = xhr.responseType || request.responseType;
	        switch (this.responseType) {
	            case 'json':
	                if ('response' in xhr) {
	                    //IE does not support json as responseType, parse it internally
	                    this.response = xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || '');
	                }
	                else {
	                    this.response = JSON.parse(xhr.responseText || '');
	                }
	                break;
	            case 'xml':
	                this.response = xhr.responseXML;
	                break;
	            case 'text':
	            default:
	                this.response = ('response' in xhr) ? xhr.response : xhr.responseText;
	                break;
	        }
	    }
	    return AjaxResponse;
	}());
	exports.AjaxResponse = AjaxResponse;
	/**
	 * A normalized AJAX error.
	 *
	 * @see {@link ajax}
	 *
	 * @class AjaxError
	 */
	var AjaxError = (function (_super) {
	    __extends(AjaxError, _super);
	    function AjaxError(message, xhr, request) {
	        _super.call(this, message);
	        this.message = message;
	        this.xhr = xhr;
	        this.request = request;
	        this.status = xhr.status;
	    }
	    return AjaxError;
	}(Error));
	exports.AjaxError = AjaxError;
	/**
	 * @see {@link ajax}
	 *
	 * @class AjaxTimeoutError
	 */
	var AjaxTimeoutError = (function (_super) {
	    __extends(AjaxTimeoutError, _super);
	    function AjaxTimeoutError(xhr, request) {
	        _super.call(this, 'ajax timeout', xhr, request);
	    }
	    return AjaxTimeoutError;
	}(AjaxError));
	exports.AjaxTimeoutError = AjaxTimeoutError;
	


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var webSocket_1 = __webpack_require__(142);
	Observable_1.Observable.webSocket = webSocket_1.webSocket;
	


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var WebSocketSubject_1 = __webpack_require__(143);
	exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
	


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var Subscriber_1 = __webpack_require__(32);
	var Observable_1 = __webpack_require__(29);
	var Subscription_1 = __webpack_require__(34);
	var root_1 = __webpack_require__(30);
	var ReplaySubject_1 = __webpack_require__(144);
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var assign_1 = __webpack_require__(148);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var WebSocketSubject = (function (_super) {
	    __extends(WebSocketSubject, _super);
	    function WebSocketSubject(urlConfigOrSource, destination) {
	        if (urlConfigOrSource instanceof Observable_1.Observable) {
	            _super.call(this, destination, urlConfigOrSource);
	        }
	        else {
	            _super.call(this);
	            this.WebSocketCtor = root_1.root.WebSocket;
	            this._output = new Subject_1.Subject();
	            if (typeof urlConfigOrSource === 'string') {
	                this.url = urlConfigOrSource;
	            }
	            else {
	                // WARNING: config object could override important members here.
	                assign_1.assign(this, urlConfigOrSource);
	            }
	            if (!this.WebSocketCtor) {
	                throw new Error('no WebSocket constructor can be found');
	            }
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	    }
	    WebSocketSubject.prototype.resultSelector = function (e) {
	        return JSON.parse(e.data);
	    };
	    /**
	     * @param urlConfigOrSource
	     * @return {WebSocketSubject}
	     * @static true
	     * @name webSocket
	     * @owner Observable
	     */
	    WebSocketSubject.create = function (urlConfigOrSource) {
	        return new WebSocketSubject(urlConfigOrSource);
	    };
	    WebSocketSubject.prototype.lift = function (operator) {
	        var sock = new WebSocketSubject(this, this.destination);
	        sock.operator = operator;
	        return sock;
	    };
	    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
	    WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
	        var self = this;
	        return new Observable_1.Observable(function (observer) {
	            var result = tryCatch_1.tryCatch(subMsg)();
	            if (result === errorObject_1.errorObject) {
	                observer.error(errorObject_1.errorObject.e);
	            }
	            else {
	                self.next(result);
	            }
	            var subscription = self.subscribe(function (x) {
	                var result = tryCatch_1.tryCatch(messageFilter)(x);
	                if (result === errorObject_1.errorObject) {
	                    observer.error(errorObject_1.errorObject.e);
	                }
	                else if (result) {
	                    observer.next(x);
	                }
	            }, function (err) { return observer.error(err); }, function () { return observer.complete(); });
	            return function () {
	                var result = tryCatch_1.tryCatch(unsubMsg)();
	                if (result === errorObject_1.errorObject) {
	                    observer.error(errorObject_1.errorObject.e);
	                }
	                else {
	                    self.next(result);
	                }
	                subscription.unsubscribe();
	            };
	        });
	    };
	    WebSocketSubject.prototype._connectSocket = function () {
	        var _this = this;
	        var WebSocketCtor = this.WebSocketCtor;
	        var socket = this.protocol ?
	            new WebSocketCtor(this.url, this.protocol) :
	            new WebSocketCtor(this.url);
	        this.socket = socket;
	        var subscription = new Subscription_1.Subscription(function () {
	            _this.socket = null;
	            if (socket && socket.readyState === 1) {
	                socket.close();
	            }
	        });
	        var observer = this._output;
	        socket.onopen = function (e) {
	            var openObserver = _this.openObserver;
	            if (openObserver) {
	                openObserver.next(e);
	            }
	            var queue = _this.destination;
	            _this.destination = Subscriber_1.Subscriber.create(function (x) { return socket.readyState === 1 && socket.send(x); }, function (e) {
	                var closingObserver = _this.closingObserver;
	                if (closingObserver) {
	                    closingObserver.next(undefined);
	                }
	                if (e && e.code) {
	                    socket.close(e.code, e.reason);
	                }
	                else {
	                    observer.error(new TypeError('WebSocketSubject.error must be called with an object with an error code, ' +
	                        'and an optional reason: { code: number, reason: string }'));
	                }
	                _this.destination = new ReplaySubject_1.ReplaySubject();
	                _this.socket = null;
	            }, function () {
	                var closingObserver = _this.closingObserver;
	                if (closingObserver) {
	                    closingObserver.next(undefined);
	                }
	                socket.close();
	                _this.destination = new ReplaySubject_1.ReplaySubject();
	                _this.socket = null;
	            });
	            if (queue && queue instanceof ReplaySubject_1.ReplaySubject) {
	                subscription.add(queue.subscribe(_this.destination));
	            }
	        };
	        socket.onerror = function (e) { return observer.error(e); };
	        socket.onclose = function (e) {
	            var closeObserver = _this.closeObserver;
	            if (closeObserver) {
	                closeObserver.next(e);
	            }
	            if (e.wasClean) {
	                observer.complete();
	            }
	            else {
	                observer.error(e);
	            }
	        };
	        socket.onmessage = function (e) {
	            var result = tryCatch_1.tryCatch(_this.resultSelector)(e);
	            if (result === errorObject_1.errorObject) {
	                observer.error(errorObject_1.errorObject.e);
	            }
	            else {
	                observer.next(result);
	            }
	        };
	    };
	    WebSocketSubject.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var source = this.source;
	        if (source) {
	            return source.subscribe(subscriber);
	        }
	        if (!this.socket) {
	            this._connectSocket();
	        }
	        var subscription = new Subscription_1.Subscription();
	        subscription.add(this._output.subscribe(subscriber));
	        subscription.add(function () {
	            var socket = _this.socket;
	            if (_this._output.observers.length === 0 && socket && socket.readyState === 1) {
	                socket.close();
	                _this.socket = null;
	            }
	        });
	        return subscription;
	    };
	    WebSocketSubject.prototype.unsubscribe = function () {
	        var _a = this, source = _a.source, socket = _a.socket;
	        if (socket && socket.readyState === 1) {
	            socket.close();
	            this.socket = null;
	        }
	        _super.prototype.unsubscribe.call(this);
	        if (!source) {
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	    };
	    return WebSocketSubject;
	}(Subject_1.AnonymousSubject));
	exports.WebSocketSubject = WebSocketSubject;
	


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var queue_1 = __webpack_require__(145);
	var observeOn_1 = __webpack_require__(82);
	/**
	 * @class ReplaySubject<T>
	 */
	var ReplaySubject = (function (_super) {
	    __extends(ReplaySubject, _super);
	    function ReplaySubject(bufferSize, windowTime, scheduler) {
	        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
	        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
	        _super.call(this);
	        this.scheduler = scheduler;
	        this._events = [];
	        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
	        this._windowTime = windowTime < 1 ? 1 : windowTime;
	    }
	    ReplaySubject.prototype.next = function (value) {
	        var now = this._getNow();
	        this._events.push(new ReplayEvent(now, value));
	        this._trimBufferThenGetEvents();
	        _super.prototype.next.call(this, value);
	    };
	    ReplaySubject.prototype._subscribe = function (subscriber) {
	        var _events = this._trimBufferThenGetEvents();
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
	        }
	        var len = _events.length;
	        for (var i = 0; i < len && !subscriber.closed; i++) {
	            subscriber.next(_events[i].value);
	        }
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    ReplaySubject.prototype._getNow = function () {
	        return (this.scheduler || queue_1.queue).now();
	    };
	    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
	        var now = this._getNow();
	        var _bufferSize = this._bufferSize;
	        var _windowTime = this._windowTime;
	        var _events = this._events;
	        var eventsCount = _events.length;
	        var spliceCount = 0;
	        // Trim events that fall out of the time window.
	        // Start at the front of the list. Break early once
	        // we encounter an event that falls within the window.
	        while (spliceCount < eventsCount) {
	            if ((now - _events[spliceCount].time) < _windowTime) {
	                break;
	            }
	            spliceCount++;
	        }
	        if (eventsCount > _bufferSize) {
	            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
	        }
	        if (spliceCount > 0) {
	            _events.splice(0, spliceCount);
	        }
	        return _events;
	    };
	    return ReplaySubject;
	}(Subject_1.Subject));
	exports.ReplaySubject = ReplaySubject;
	var ReplayEvent = (function () {
	    function ReplayEvent(time, value) {
	        this.time = time;
	        this.value = value;
	    }
	    return ReplayEvent;
	}());
	


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var QueueAction_1 = __webpack_require__(146);
	var QueueScheduler_1 = __webpack_require__(147);
	exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
	


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(102);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var QueueAction = (function (_super) {
	    __extends(QueueAction, _super);
	    function QueueAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    QueueAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay > 0) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.delay = delay;
	        this.state = state;
	        this.scheduler.flush(this);
	        return this;
	    };
	    QueueAction.prototype.execute = function (state, delay) {
	        return (delay > 0 || this.closed) ?
	            _super.prototype.execute.call(this, state, delay) :
	            this._execute(state, delay);
	    };
	    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay is greater than 0, enqueue as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Otherwise flush the scheduler starting with this action.
	        return scheduler.flush(this);
	    };
	    return QueueAction;
	}(AsyncAction_1.AsyncAction));
	exports.QueueAction = QueueAction;
	


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(104);
	var QueueScheduler = (function (_super) {
	    __extends(QueueScheduler, _super);
	    function QueueScheduler() {
	        _super.apply(this, arguments);
	    }
	    return QueueScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.QueueScheduler = QueueScheduler;
	


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var root_1 = __webpack_require__(30);
	var Object = root_1.root.Object;
	if (typeof Object.assign != 'function') {
	    (function () {
	        Object.assign = function assignPolyfill(target) {
	            var sources = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                sources[_i - 1] = arguments[_i];
	            }
	            if (target === undefined || target === null) {
	                throw new TypeError('cannot convert undefined or null to object');
	            }
	            var output = Object(target);
	            var len = sources.length;
	            for (var index = 0; index < len; index++) {
	                var source = sources[index];
	                if (source !== undefined && source !== null) {
	                    for (var key in source) {
	                        if (source.hasOwnProperty(key)) {
	                            output[key] = source[key];
	                        }
	                    }
	                }
	            }
	            return output;
	        };
	    })();
	}
	exports.assign = Object.assign;
	


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var buffer_1 = __webpack_require__(150);
	Observable_1.Observable.prototype.buffer = buffer_1.buffer;
	


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Buffers the source Observable values until `closingNotifier` emits.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when another Observable emits.</span>
	 *
	 * <img src="./img/buffer.png" width="100%">
	 *
	 * Buffers the incoming Observable values until the given `closingNotifier`
	 * Observable emits a value, at which point it emits the buffer on the output
	 * Observable and starts a new buffer internally, awaiting the next time
	 * `closingNotifier` emits.
	 *
	 * @example <caption>On every click, emit array of most recent interval events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var buffered = interval.buffer(clicks);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link window}
	 *
	 * @param {Observable<any>} closingNotifier An Observable that signals the
	 * buffer to be emitted on the output Observable.
	 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
	 * values.
	 * @method buffer
	 * @owner Observable
	 */
	function buffer(closingNotifier) {
	    return this.lift(new BufferOperator(closingNotifier));
	}
	exports.buffer = buffer;
	var BufferOperator = (function () {
	    function BufferOperator(closingNotifier) {
	        this.closingNotifier = closingNotifier;
	    }
	    BufferOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
	    };
	    return BufferOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferSubscriber = (function (_super) {
	    __extends(BufferSubscriber, _super);
	    function BufferSubscriber(destination, closingNotifier) {
	        _super.call(this, destination);
	        this.buffer = [];
	        this.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
	    }
	    BufferSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var buffer = this.buffer;
	        this.buffer = [];
	        this.destination.next(buffer);
	    };
	    return BufferSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var bufferCount_1 = __webpack_require__(152);
	Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
	


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Buffers the source Observable values until the size hits the maximum
	 * `bufferSize` given.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when its size reaches `bufferSize`.</span>
	 *
	 * <img src="./img/bufferCount.png" width="100%">
	 *
	 * Buffers a number of values from the source Observable by `bufferSize` then
	 * emits the buffer and clears it, and starts a new buffer each
	 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
	 * `null`, then new buffers are started immediately at the start of the source
	 * and when each buffer closes and is emitted.
	 *
	 * @example <caption>Emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>On every click, emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2, 1);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link pairwise}
	 * @see {@link windowCount}
	 *
	 * @param {number} bufferSize The maximum size of the buffer emitted.
	 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
	 * For example if `startBufferEvery` is `2`, then a new buffer will be started
	 * on every other value from the source. A new buffer is started at the
	 * beginning of the source by default.
	 * @return {Observable<T[]>} An Observable of arrays of buffered values.
	 * @method bufferCount
	 * @owner Observable
	 */
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) { startBufferEvery = null; }
	    return this.lift(new BufferCountOperator(bufferSize, startBufferEvery));
	}
	exports.bufferCount = bufferCount;
	var BufferCountOperator = (function () {
	    function BufferCountOperator(bufferSize, startBufferEvery) {
	        this.bufferSize = bufferSize;
	        this.startBufferEvery = startBufferEvery;
	    }
	    BufferCountOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new BufferCountSubscriber(subscriber, this.bufferSize, this.startBufferEvery));
	    };
	    return BufferCountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferCountSubscriber = (function (_super) {
	    __extends(BufferCountSubscriber, _super);
	    function BufferCountSubscriber(destination, bufferSize, startBufferEvery) {
	        _super.call(this, destination);
	        this.bufferSize = bufferSize;
	        this.startBufferEvery = startBufferEvery;
	        this.buffers = [[]];
	        this.count = 0;
	    }
	    BufferCountSubscriber.prototype._next = function (value) {
	        var count = (this.count += 1);
	        var destination = this.destination;
	        var bufferSize = this.bufferSize;
	        var startBufferEvery = (this.startBufferEvery == null) ? bufferSize : this.startBufferEvery;
	        var buffers = this.buffers;
	        var len = buffers.length;
	        var remove = -1;
	        if (count % startBufferEvery === 0) {
	            buffers.push([]);
	        }
	        for (var i = 0; i < len; i++) {
	            var buffer = buffers[i];
	            buffer.push(value);
	            if (buffer.length === bufferSize) {
	                remove = i;
	                destination.next(buffer);
	            }
	        }
	        if (remove !== -1) {
	            buffers.splice(remove, 1);
	        }
	    };
	    BufferCountSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        var buffers = this.buffers;
	        while (buffers.length > 0) {
	            var buffer = buffers.shift();
	            if (buffer.length > 0) {
	                destination.next(buffer);
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferCountSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var bufferTime_1 = __webpack_require__(154);
	Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
	


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(101);
	var Subscriber_1 = __webpack_require__(32);
	var isScheduler_1 = __webpack_require__(54);
	/**
	 * Buffers the source Observable values for a specific time period.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * those arrays periodically in time.</span>
	 *
	 * <img src="./img/bufferTime.png" width="100%">
	 *
	 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
	 * Unless the optional argument `bufferCreationInterval` is given, it emits and
	 * resets the buffer every `bufferTimeSpan` milliseconds. If
	 * `bufferCreationInterval` is given, this operator opens the buffer every
	 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
	 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
	 * `maxBufferSize` is specified, the buffer will be closed either after
	 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
	 *
	 * @example <caption>Every second, emit an array of the recent click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(1000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(2000, 5000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link windowTime}
	 *
	 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
	 * @param {number} [bufferCreationInterval] The interval at which to start new
	 * buffers.
	 * @param {number} [maxBufferSize] The maximum buffer size.
	 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
	 * intervals that determine buffer boundaries.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferTime
	 * @owner Observable
	 */
	function bufferTime(bufferTimeSpan) {
	    var length = arguments.length;
	    var scheduler = async_1.async;
	    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
	        scheduler = arguments[arguments.length - 1];
	        length--;
	    }
	    var bufferCreationInterval = null;
	    if (length >= 2) {
	        bufferCreationInterval = arguments[1];
	    }
	    var maxBufferSize = Number.POSITIVE_INFINITY;
	    if (length >= 3) {
	        maxBufferSize = arguments[2];
	    }
	    return this.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
	}
	exports.bufferTime = bufferTime;
	var BufferTimeOperator = (function () {
	    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        this.bufferTimeSpan = bufferTimeSpan;
	        this.bufferCreationInterval = bufferCreationInterval;
	        this.maxBufferSize = maxBufferSize;
	        this.scheduler = scheduler;
	    }
	    BufferTimeOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
	    };
	    return BufferTimeOperator;
	}());
	var Context = (function () {
	    function Context() {
	        this.buffer = [];
	    }
	    return Context;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferTimeSubscriber = (function (_super) {
	    __extends(BufferTimeSubscriber, _super);
	    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        _super.call(this, destination);
	        this.bufferTimeSpan = bufferTimeSpan;
	        this.bufferCreationInterval = bufferCreationInterval;
	        this.maxBufferSize = maxBufferSize;
	        this.scheduler = scheduler;
	        this.contexts = [];
	        var context = this.openContext();
	        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
	        if (this.timespanOnly) {
	            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
	            this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	        else {
	            var closeState = { subscriber: this, context: context };
	            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: this, scheduler: scheduler };
	            this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
	            this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
	        }
	    }
	    BufferTimeSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        var filledBufferContext;
	        for (var i = 0; i < len; i++) {
	            var context = contexts[i];
	            var buffer = context.buffer;
	            buffer.push(value);
	            if (buffer.length == this.maxBufferSize) {
	                filledBufferContext = context;
	            }
	        }
	        if (filledBufferContext) {
	            this.onBufferFull(filledBufferContext);
	        }
	    };
	    BufferTimeSubscriber.prototype._error = function (err) {
	        this.contexts.length = 0;
	        _super.prototype._error.call(this, err);
	    };
	    BufferTimeSubscriber.prototype._complete = function () {
	        var _a = this, contexts = _a.contexts, destination = _a.destination;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            destination.next(context.buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    BufferTimeSubscriber.prototype._unsubscribe = function () {
	        this.contexts = null;
	    };
	    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
	        this.closeContext(context);
	        var closeAction = context.closeAction;
	        closeAction.unsubscribe();
	        this.remove(closeAction);
	        if (this.timespanOnly) {
	            context = this.openContext();
	            var bufferTimeSpan = this.bufferTimeSpan;
	            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
	            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	    };
	    BufferTimeSubscriber.prototype.openContext = function () {
	        var context = new Context();
	        this.contexts.push(context);
	        return context;
	    };
	    BufferTimeSubscriber.prototype.closeContext = function (context) {
	        this.destination.next(context.buffer);
	        var contexts = this.contexts;
	        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
	        if (spliceIndex >= 0) {
	            contexts.splice(contexts.indexOf(context), 1);
	        }
	    };
	    return BufferTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchBufferTimeSpanOnly(state) {
	    var subscriber = state.subscriber;
	    var prevContext = state.context;
	    if (prevContext) {
	        subscriber.closeContext(prevContext);
	    }
	    if (!subscriber.closed) {
	        state.context = subscriber.openContext();
	        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
	    }
	}
	function dispatchBufferCreation(state) {
	    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
	    var context = subscriber.openContext();
	    var action = this;
	    if (!subscriber.closed) {
	        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
	        action.schedule(state, bufferCreationInterval);
	    }
	}
	function dispatchBufferClose(arg) {
	    var subscriber = arg.subscriber, context = arg.context;
	    subscriber.closeContext(context);
	}
	


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var bufferToggle_1 = __webpack_require__(156);
	Observable_1.Observable.prototype.bufferToggle = bufferToggle_1.bufferToggle;
	


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(34);
	var subscribeToResult_1 = __webpack_require__(60);
	var OuterSubscriber_1 = __webpack_require__(59);
	/**
	 * Buffers the source Observable values starting from an emission from
	 * `openings` and ending when the output of `closingSelector` emits.
	 *
	 * <span class="informal">Collects values from the past as an array. Starts
	 * collecting only when `opening` emits, and calls the `closingSelector`
	 * function to get an Observable that tells when to close the buffer.</span>
	 *
	 * <img src="./img/bufferToggle.png" width="100%">
	 *
	 * Buffers values from the source by opening the buffer via signals from an
	 * Observable provided to `openings`, and closing and sending the buffers when
	 * a Subscribable or Promise returned by the `closingSelector` function emits.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var buffered = clicks.bufferToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferWhen}
	 * @see {@link windowToggle}
	 *
	 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
	 * buffers.
	 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
	 * which, when it emits, signals that the associated buffer should be emitted
	 * and cleared.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferToggle
	 * @owner Observable
	 */
	function bufferToggle(openings, closingSelector) {
	    return this.lift(new BufferToggleOperator(openings, closingSelector));
	}
	exports.bufferToggle = bufferToggle;
	var BufferToggleOperator = (function () {
	    function BufferToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    BufferToggleOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return BufferToggleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferToggleSubscriber = (function (_super) {
	    __extends(BufferToggleSubscriber, _super);
	    function BufferToggleSubscriber(destination, openings, closingSelector) {
	        _super.call(this, destination);
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	        this.contexts = [];
	        this.add(subscribeToResult_1.subscribeToResult(this, openings));
	    }
	    BufferToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        for (var i = 0; i < len; i++) {
	            contexts[i].buffer.push(value);
	        }
	    };
	    BufferToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            context.subscription.unsubscribe();
	            context.buffer = null;
	            context.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._error.call(this, err);
	    };
	    BufferToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            this.destination.next(context.buffer);
	            context.subscription.unsubscribe();
	            context.buffer = null;
	            context.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._complete.call(this);
	    };
	    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
	    };
	    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.closeBuffer(innerSub.context);
	    };
	    BufferToggleSubscriber.prototype.openBuffer = function (value) {
	        try {
	            var closingSelector = this.closingSelector;
	            var closingNotifier = closingSelector.call(this, value);
	            if (closingNotifier) {
	                this.trySubscribe(closingNotifier);
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
	        var contexts = this.contexts;
	        if (contexts && context) {
	            var buffer = context.buffer, subscription = context.subscription;
	            this.destination.next(buffer);
	            contexts.splice(contexts.indexOf(context), 1);
	            this.remove(subscription);
	            subscription.unsubscribe();
	        }
	    };
	    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
	        var contexts = this.contexts;
	        var buffer = [];
	        var subscription = new Subscription_1.Subscription();
	        var context = { buffer: buffer, subscription: subscription };
	        contexts.push(context);
	        var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
	        if (!innerSubscription || innerSubscription.closed) {
	            this.closeBuffer(context);
	        }
	        else {
	            innerSubscription.context = context;
	            this.add(innerSubscription);
	            subscription.add(innerSubscription);
	        }
	    };
	    return BufferToggleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var bufferWhen_1 = __webpack_require__(158);
	Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
	


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(34);
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Buffers the source Observable values, using a factory function of closing
	 * Observables to determine when to close, emit, and reset the buffer.
	 *
	 * <span class="informal">Collects values from the past as an array. When it
	 * starts collecting values, it calls a function that returns an Observable that
	 * tells when to close the buffer and restart collecting.</span>
	 *
	 * <img src="./img/bufferWhen.png" width="100%">
	 *
	 * Opens a buffer immediately, then closes the buffer when the observable
	 * returned by calling `closingSelector` function emits a value. When it closes
	 * the buffer, it immediately opens a new buffer and repeats the process.
	 *
	 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferWhen(() =>
	 *   Rx.Observable.interval(1000 + Math.random() * 4000)
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link windowWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals buffer closure.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferWhen
	 * @owner Observable
	 */
	function bufferWhen(closingSelector) {
	    return this.lift(new BufferWhenOperator(closingSelector));
	}
	exports.bufferWhen = bufferWhen;
	var BufferWhenOperator = (function () {
	    function BufferWhenOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    BufferWhenOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
	    };
	    return BufferWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferWhenSubscriber = (function (_super) {
	    __extends(BufferWhenSubscriber, _super);
	    function BufferWhenSubscriber(destination, closingSelector) {
	        _super.call(this, destination);
	        this.closingSelector = closingSelector;
	        this.subscribing = false;
	        this.openBuffer();
	    }
	    BufferWhenSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferWhenSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    BufferWhenSubscriber.prototype._unsubscribe = function () {
	        this.buffer = null;
	        this.subscribing = false;
	    };
	    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openBuffer();
	    };
	    BufferWhenSubscriber.prototype.notifyComplete = function () {
	        if (this.subscribing) {
	            this.complete();
	        }
	        else {
	            this.openBuffer();
	        }
	    };
	    BufferWhenSubscriber.prototype.openBuffer = function () {
	        var closingSubscription = this.closingSubscription;
	        if (closingSubscription) {
	            this.remove(closingSubscription);
	            closingSubscription.unsubscribe();
	        }
	        var buffer = this.buffer;
	        if (this.buffer) {
	            this.destination.next(buffer);
	        }
	        this.buffer = [];
	        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
	        if (closingNotifier === errorObject_1.errorObject) {
	            this.error(errorObject_1.errorObject.e);
	        }
	        else {
	            closingSubscription = new Subscription_1.Subscription();
	            this.closingSubscription = closingSubscription;
	            this.add(closingSubscription);
	            this.subscribing = true;
	            closingSubscription.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
	            this.subscribing = false;
	        }
	    };
	    return BufferWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var cache_1 = __webpack_require__(160);
	Observable_1.Observable.prototype.cache = cache_1.cache;
	


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var ReplaySubject_1 = __webpack_require__(144);
	/**
	 * @param bufferSize
	 * @param windowTime
	 * @param scheduler
	 * @return {Observable<any>}
	 * @method cache
	 * @owner Observable
	 */
	function cache(bufferSize, windowTime, scheduler) {
	    if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
	    if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
	    var subject;
	    var source = this;
	    var refs = 0;
	    var outerSub;
	    var getSubject = function () {
	        subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
	        return subject;
	    };
	    return new Observable_1.Observable(function (observer) {
	        if (!subject) {
	            subject = getSubject();
	            outerSub = source.subscribe(function (value) { return subject.next(value); }, function (err) {
	                var s = subject;
	                subject = null;
	                s.error(err);
	            }, function () { return subject.complete(); });
	        }
	        refs++;
	        if (!subject) {
	            subject = getSubject();
	        }
	        var innerSub = subject.subscribe(observer);
	        return function () {
	            refs--;
	            if (innerSub) {
	                innerSub.unsubscribe();
	            }
	            if (refs === 0) {
	                outerSub.unsubscribe();
	            }
	        };
	    });
	}
	exports.cache = cache;
	


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var catch_1 = __webpack_require__(162);
	Observable_1.Observable.prototype.catch = catch_1._catch;
	


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
	 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
	 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
	 *  is returned by the `selector` will be used to continue the observable chain.
	 * @return {Observable} an observable that originates from either the source or the observable returned by the
	 *  catch `selector` function.
	 * @method catch
	 * @owner Observable
	 */
	function _catch(selector) {
	    var operator = new CatchOperator(selector);
	    var caught = this.lift(operator);
	    return (operator.caught = caught);
	}
	exports._catch = _catch;
	var CatchOperator = (function () {
	    function CatchOperator(selector) {
	        this.selector = selector;
	    }
	    CatchOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
	    };
	    return CatchOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CatchSubscriber = (function (_super) {
	    __extends(CatchSubscriber, _super);
	    function CatchSubscriber(destination, selector, caught) {
	        _super.call(this, destination);
	        this.selector = selector;
	        this.caught = caught;
	    }
	    // NOTE: overriding `error` instead of `_error` because we don't want
	    // to have this flag this subscriber as `isStopped`.
	    CatchSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var result = void 0;
	            try {
	                result = this.selector(err, this.caught);
	            }
	            catch (err) {
	                this.destination.error(err);
	                return;
	            }
	            this.unsubscribe();
	            this.destination.remove(this);
	            subscribeToResult_1.subscribeToResult(this, result);
	        }
	    };
	    return CatchSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var combineAll_1 = __webpack_require__(164);
	Observable_1.Observable.prototype.combineAll = combineAll_1.combineAll;
	


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var combineLatest_1 = __webpack_require__(58);
	/**
	 * Converts a higher-order Observable into a first-order Observable by waiting
	 * for the outer Observable to complete, then applying {@link combineLatest}.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by applying
	 * {@link combineLatest} when the Observable-of-Observables completes.</span>
	 *
	 * <img src="./img/combineAll.png" width="100%">
	 *
	 * Takes an Observable of Observables, and collects all Observables from it.
	 * Once the outer Observable completes, it subscribes to all collected
	 * Observables and combines their values using the {@link combineLatest}
	 * strategy, such that:
	 * - Every time an inner Observable emits, the output Observable emits.
	 * - When the returned observable emits, it emits all of the latest values by:
	 *   - If a `project` function is provided, it is called with each recent value
	 *     from each inner Observable in whatever order they arrived, and the result
	 *     of the `project` function is what is emitted by the output Observable.
	 *   - If there is no `project` function, an array of all of the most recent
	 *     values is emitted by the output Observable.
	 *
	 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev =>
	 *   Rx.Observable.interval(Math.random()*2000).take(3)
	 * ).take(2);
	 * var result = higherOrder.combineAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 * @see {@link mergeAll}
	 *
	 * @param {function} [project] An optional function to map the most recent
	 * values from each inner Observable into a new result. Takes each of the most
	 * recent values from each collected inner Observable as arguments, in order.
	 * @return {Observable} An Observable of projected results or arrays of recent
	 * values.
	 * @method combineAll
	 * @owner Observable
	 */
	function combineAll(project) {
	    return this.lift(new combineLatest_1.CombineLatestOperator(project));
	}
	exports.combineAll = combineAll;
	


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var combineLatest_1 = __webpack_require__(58);
	Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
	


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var concat_1 = __webpack_require__(66);
	Observable_1.Observable.prototype.concat = concat_1.concat;
	


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var concatAll_1 = __webpack_require__(168);
	Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
	


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var mergeAll_1 = __webpack_require__(67);
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * concatenating the inner Observables in order.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by putting one
	 * inner Observable after the other.</span>
	 *
	 * <img src="./img/concatAll.png" width="100%">
	 *
	 * Joins every Observable emitted by the source (a higher-order Observable), in
	 * a serial fashion. It subscribes to each inner Observable only after the
	 * previous inner Observable has completed, and merges all of their values into
	 * the returned observable.
	 *
	 * __Warning:__ If the source Observable emits Observables quickly and
	 * endlessly, and the inner Observables it emits generally complete slower than
	 * the source emits, you can run into memory issues as the incoming Observables
	 * collect in an unbounded buffer.
	 *
	 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
	 * var firstOrder = higherOrder.concatAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concat}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable emitting values from all the inner
	 * Observables concatenated.
	 * @method concatAll
	 * @owner Observable
	 */
	function concatAll() {
	    return this.lift(new mergeAll_1.MergeAllOperator(1));
	}
	exports.concatAll = concatAll;
	


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var concatMap_1 = __webpack_require__(170);
	Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
	


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var mergeMap_1 = __webpack_require__(171);
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, in a serialized fashion waiting for each one to complete before
	 * merging the next.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link concatAll}.</span>
	 *
	 * <img src="./img/concatMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each new inner Observable is
	 * concatenated with the previous inner Observable.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMapTo}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): Observable} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} an observable of values merged from the projected
	 * Observables as they were subscribed to, one at a time. Optionally, these
	 * values may have been projected from a passed `projectResult` argument.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking values from each projected inner
	 * Observable sequentially.
	 * @method concatMap
	 * @owner Observable
	 */
	function concatMap(project, resultSelector) {
	    return this.lift(new mergeMap_1.MergeMapOperator(project, resultSelector, 1));
	}
	exports.concatMap = concatMap;
	


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var subscribeToResult_1 = __webpack_require__(60);
	var OuterSubscriber_1 = __webpack_require__(59);
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link mergeAll}.</span>
	 *
	 * <img src="./img/mergeMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger.
	 *
	 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
	 * var letters = Rx.Observable.of('a', 'b', 'c');
	 * var result = letters.mergeMap(x =>
	 *   Rx.Observable.interval(1000).map(i => x+i)
	 * );
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): Observable} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and merging the results of the Observables obtained
	 * from this transformation.
	 * @method mergeMap
	 * @owner Observable
	 */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	        resultSelector = null;
	    }
	    return this.lift(new MergeMapOperator(project, resultSelector, concurrent));
	}
	exports.mergeMap = mergeMap;
	var MergeMapOperator = (function () {
	    function MergeMapOperator(project, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	    }
	    MergeMapOperator.prototype.call = function (observer, source) {
	        return source._subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
	    };
	    return MergeMapOperator;
	}());
	exports.MergeMapOperator = MergeMapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeMapSubscriber = (function (_super) {
	    __extends(MergeMapSubscriber, _super);
	    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeMapSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            this._tryNext(value);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapSubscriber.prototype._tryNext = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.active++;
	        this._innerSub(result, value, index);
	    };
	    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeMapSubscriber = MergeMapSubscriber;
	


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var concatMapTo_1 = __webpack_require__(173);
	Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
	


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var mergeMapTo_1 = __webpack_require__(174);
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in a serialized fashion on the output Observable.
	 *
	 * <span class="informal">It's like {@link concatMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/concatMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. Each new `innerObservable`
	 * instance emitted on the output Observable is concatenated with the previous
	 * `innerObservable` instance.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
	 * set to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link mergeMapTo}
	 * @see {@link switchMapTo}
	 *
	 * @param {Observable} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An observable of values merged together by joining the
	 * passed observable with itself, one after the other, for each value emitted
	 * from the source.
	 * @method concatMapTo
	 * @owner Observable
	 */
	function concatMapTo(innerObservable, resultSelector) {
	    return this.lift(new mergeMapTo_1.MergeMapToOperator(innerObservable, resultSelector, 1));
	}
	exports.concatMapTo = concatMapTo;
	


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in the output Observable.
	 *
	 * <span class="informal">It's like {@link mergeMap}, but maps each value always
	 * to the same inner Observable.</span>
	 *
	 * <img src="./img/mergeMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then merges those resulting Observables into one
	 * single Observable, which is the output Observable.
	 *
	 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 * @see {@link switchMapTo}
	 *
	 * @param {Observable} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable.
	 * @method mergeMapTo
	 * @owner Observable
	 */
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	        resultSelector = null;
	    }
	    return this.lift(new MergeMapToOperator(innerObservable, resultSelector, concurrent));
	}
	exports.mergeMapTo = mergeMapTo;
	// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
	//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
	var MergeMapToOperator = (function () {
	    function MergeMapToOperator(ish, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        this.ish = ish;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	    }
	    MergeMapToOperator.prototype.call = function (observer, source) {
	        return source._subscribe(new MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
	    };
	    return MergeMapToOperator;
	}());
	exports.MergeMapToOperator = MergeMapToOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeMapToSubscriber = (function (_super) {
	    __extends(MergeMapToSubscriber, _super);
	    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        _super.call(this, destination);
	        this.ish = ish;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeMapToSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            var resultSelector = this.resultSelector;
	            var index = this.index++;
	            var ish = this.ish;
	            var destination = this.destination;
	            this.active++;
	            this._innerSub(ish, destination, resultSelector, value, index);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapToSubscriber.prototype._innerSub = function (ish, destination, resultSelector, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeMapToSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    MergeMapToSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        var result;
	        try {
	            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        destination.next(result);
	    };
	    MergeMapToSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    MergeMapToSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapToSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeMapToSubscriber = MergeMapToSubscriber;
	


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var count_1 = __webpack_require__(176);
	Observable_1.Observable.prototype.count = count_1.count;
	


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Counts the number of emissions on the source and emits that number when the
	 * source completes.
	 *
	 * <span class="informal">Tells how many values were emitted, when the source
	 * completes.</span>
	 *
	 * <img src="./img/count.png" width="100%">
	 *
	 * `count` transforms an Observable that emits values into an Observable that
	 * emits a single value that represents the number of values emitted by the
	 * source Observable. If the source Observable terminates with an error, `count`
	 * will pass this error notification along without emitting an value first. If
	 * the source Observable does not terminate at all, `count` will neither emit
	 * a value nor terminate. This operator takes an optional `predicate` function
	 * as argument, in which case the output emission will represent the number of
	 * source values that matched `true` with the `predicate`.
	 *
	 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var secondsBeforeClick = seconds.takeUntil(clicks);
	 * var result = secondsBeforeClick.count();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
	 * var numbers = Rx.Observable.range(1, 7);
	 * var result = numbers.count(i => i % 2 === 1);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link max}
	 * @see {@link min}
	 * @see {@link reduce}
	 *
	 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
	 * boolean function to select what values are to be counted. It is provided with
	 * arguments of:
	 * - `value`: the value from the source Observable.
	 * - `index`: the (zero-based) "index" of the value from the source Observable.
	 * - `source`: the source Observable instance itself.
	 * @return {Observable} An Observable of one number that represents the count as
	 * described above.
	 * @method count
	 * @owner Observable
	 */
	function count(predicate) {
	    return this.lift(new CountOperator(predicate, this));
	}
	exports.count = count;
	var CountOperator = (function () {
	    function CountOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    CountOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
	    };
	    return CountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CountSubscriber = (function (_super) {
	    __extends(CountSubscriber, _super);
	    function CountSubscriber(destination, predicate, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.count = 0;
	        this.index = 0;
	    }
	    CountSubscriber.prototype._next = function (value) {
	        if (this.predicate) {
	            this._tryPredicate(value);
	        }
	        else {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._tryPredicate = function (value) {
	        var result;
	        try {
	            result = this.predicate(value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._complete = function () {
	        this.destination.next(this.count);
	        this.destination.complete();
	    };
	    return CountSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var dematerialize_1 = __webpack_require__(178);
	Observable_1.Observable.prototype.dematerialize = dematerialize_1.dematerialize;
	


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Converts an Observable of {@link Notification} objects into the emissions
	 * that they represent.
	 *
	 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
	 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
	 *
	 * <img src="./img/dematerialize.png" width="100%">
	 *
	 * `dematerialize` is assumed to operate an Observable that only emits
	 * {@link Notification} objects as `next` emissions, and does not emit any
	 * `error`. Such Observable is the output of a `materialize` operation. Those
	 * notifications are then unwrapped using the metadata they contain, and emitted
	 * as `next`, `error`, and `complete` on the output Observable.
	 *
	 * Use this operator in conjunction with {@link materialize}.
	 *
	 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
	 * var notifA = new Rx.Notification('N', 'A');
	 * var notifB = new Rx.Notification('N', 'B');
	 * var notifE = new Rx.Notification('E', void 0,
	 *   new TypeError('x.toUpperCase is not a function')
	 * );
	 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
	 * var upperCase = materialized.dematerialize();
	 * upperCase.subscribe(x => console.log(x), e => console.error(e));
	 *
	 * @see {@link Notification}
	 * @see {@link materialize}
	 *
	 * @return {Observable} An Observable that emits items and notifications
	 * embedded in Notification objects emitted by the source Observable.
	 * @method dematerialize
	 * @owner Observable
	 */
	function dematerialize() {
	    return this.lift(new DeMaterializeOperator());
	}
	exports.dematerialize = dematerialize;
	var DeMaterializeOperator = (function () {
	    function DeMaterializeOperator() {
	    }
	    DeMaterializeOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new DeMaterializeSubscriber(subscriber));
	    };
	    return DeMaterializeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DeMaterializeSubscriber = (function (_super) {
	    __extends(DeMaterializeSubscriber, _super);
	    function DeMaterializeSubscriber(destination) {
	        _super.call(this, destination);
	    }
	    DeMaterializeSubscriber.prototype._next = function (value) {
	        value.observe(this.destination);
	    };
	    return DeMaterializeSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var debounce_1 = __webpack_require__(180);
	Observable_1.Observable.prototype.debounce = debounce_1.debounce;
	


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * determined by another Observable has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link debounceTime}, but the time span of
	 * emission silence is determined by a second Observable.</span>
	 *
	 * <img src="./img/debounce.png" width="100%">
	 *
	 * `debounce` delays values emitted by the source Observable, but drops previous
	 * pending delayed emissions if a new value arrives on the source Observable.
	 * This operator keeps track of the most recent value from the source
	 * Observable, and spawns a duration Observable by calling the
	 * `durationSelector` function. The value is emitted only when the duration
	 * Observable emits a value or completes, and if no other value was emitted on
	 * the source Observable since the duration Observable was spawned. If a new
	 * value appears before the duration Observable emits, the previous value will
	 * be dropped and will not be emitted on the output Observable.
	 *
	 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
	 * delay-like operator since output emissions do not necessarily occur at the
	 * same time as they did on the source Observable.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): Observable|Promise} durationSelector A function
	 * that receives a value from the source Observable, for computing the timeout
	 * duration for each source value, returned as an Observable or a Promise.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified duration Observable returned by
	 * `durationSelector`, and may drop some values if they occur too frequently.
	 * @method debounce
	 * @owner Observable
	 */
	function debounce(durationSelector) {
	    return this.lift(new DebounceOperator(durationSelector));
	}
	exports.debounce = debounce;
	var DebounceOperator = (function () {
	    function DebounceOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    DebounceOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
	    };
	    return DebounceOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DebounceSubscriber = (function (_super) {
	    __extends(DebounceSubscriber, _super);
	    function DebounceSubscriber(destination, durationSelector) {
	        _super.call(this, destination);
	        this.durationSelector = durationSelector;
	        this.hasValue = false;
	        this.durationSubscription = null;
	    }
	    DebounceSubscriber.prototype._next = function (value) {
	        try {
	            var result = this.durationSelector.call(this, value);
	            if (result) {
	                this._tryNext(value, result);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DebounceSubscriber.prototype._complete = function () {
	        this.emitValue();
	        this.destination.complete();
	    };
	    DebounceSubscriber.prototype._tryNext = function (value, duration) {
	        var subscription = this.durationSubscription;
	        this.value = value;
	        this.hasValue = true;
	        if (subscription) {
	            subscription.unsubscribe();
	            this.remove(subscription);
	        }
	        subscription = subscribeToResult_1.subscribeToResult(this, duration);
	        if (!subscription.closed) {
	            this.add(this.durationSubscription = subscription);
	        }
	    };
	    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            var value = this.value;
	            var subscription = this.durationSubscription;
	            if (subscription) {
	                this.durationSubscription = null;
	                subscription.unsubscribe();
	                this.remove(subscription);
	            }
	            this.value = null;
	            this.hasValue = false;
	            _super.prototype._next.call(this, value);
	        }
	    };
	    return DebounceSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var debounceTime_1 = __webpack_require__(182);
	Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
	


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var async_1 = __webpack_require__(101);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link delay}, but passes only the most
	 * recent value from each burst of emissions.</span>
	 *
	 * <img src="./img/debounceTime.png" width="100%">
	 *
	 * `debounceTime` delays values emitted by the source Observable, but drops
	 * previous pending delayed emissions if a new value arrives on the source
	 * Observable. This operator keeps track of the most recent value from the
	 * source Observable, and emits that only when `dueTime` enough time has passed
	 * without any other value appearing on the source Observable. If a new value
	 * appears before `dueTime` silence occurs, the previous value will be dropped
	 * and will not be emitted on the output Observable.
	 *
	 * This is a rate-limiting operator, because it is impossible for more than one
	 * value to be emitted in any time window of duration `dueTime`, but it is also
	 * a delay-like operator since output emissions do not occur at the same time as
	 * they did on the source Observable. Optionally takes a {@link Scheduler} for
	 * managing timers.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounceTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} dueTime The timeout duration in milliseconds (or the time
	 * unit determined internally by the optional `scheduler`) for the window of
	 * time required to wait for emission silence before emitting the most recent
	 * source value.
	 * @param {Scheduler} [scheduler=async] The {@link Scheduler} to use for
	 * managing the timers that handle the timeout for each value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified `dueTime`, and may drop some values if they occur
	 * too frequently.
	 * @method debounceTime
	 * @owner Observable
	 */
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return this.lift(new DebounceTimeOperator(dueTime, scheduler));
	}
	exports.debounceTime = debounceTime;
	var DebounceTimeOperator = (function () {
	    function DebounceTimeOperator(dueTime, scheduler) {
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	    }
	    DebounceTimeOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
	    };
	    return DebounceTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DebounceTimeSubscriber = (function (_super) {
	    __extends(DebounceTimeSubscriber, _super);
	    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
	        _super.call(this, destination);
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	        this.debouncedSubscription = null;
	        this.lastValue = null;
	        this.hasValue = false;
	    }
	    DebounceTimeSubscriber.prototype._next = function (value) {
	        this.clearDebounce();
	        this.lastValue = value;
	        this.hasValue = true;
	        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
	    };
	    DebounceTimeSubscriber.prototype._complete = function () {
	        this.debouncedNext();
	        this.destination.complete();
	    };
	    DebounceTimeSubscriber.prototype.debouncedNext = function () {
	        this.clearDebounce();
	        if (this.hasValue) {
	            this.destination.next(this.lastValue);
	            this.lastValue = null;
	            this.hasValue = false;
	        }
	    };
	    DebounceTimeSubscriber.prototype.clearDebounce = function () {
	        var debouncedSubscription = this.debouncedSubscription;
	        if (debouncedSubscription !== null) {
	            this.remove(debouncedSubscription);
	            debouncedSubscription.unsubscribe();
	            this.debouncedSubscription = null;
	        }
	    };
	    return DebounceTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(subscriber) {
	    subscriber.debouncedNext();
	}
	


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var defaultIfEmpty_1 = __webpack_require__(184);
	Observable_1.Observable.prototype.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
	


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Emits a given value if the source Observable completes without emitting any
	 * `next` value, otherwise mirrors the source Observable.
	 *
	 * <span class="informal">If the source Observable turns out to be empty, then
	 * this operator will emit a default value.</span>
	 *
	 * <img src="./img/defaultIfEmpty.png" width="100%">
	 *
	 * `defaultIfEmpty` emits the values emitted by the source Observable or a
	 * specified default value if the source Observable is empty (completes without
	 * having emitted any `next` value).
	 *
	 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
	 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link empty}
	 * @see {@link last}
	 *
	 * @param {any} [defaultValue=null] The default value used if the source
	 * Observable is empty.
	 * @return {Observable} An Observable that emits either the specified
	 * `defaultValue` if the source Observable emits no items, or the values emitted
	 * by the source Observable.
	 * @method defaultIfEmpty
	 * @owner Observable
	 */
	function defaultIfEmpty(defaultValue) {
	    if (defaultValue === void 0) { defaultValue = null; }
	    return this.lift(new DefaultIfEmptyOperator(defaultValue));
	}
	exports.defaultIfEmpty = defaultIfEmpty;
	var DefaultIfEmptyOperator = (function () {
	    function DefaultIfEmptyOperator(defaultValue) {
	        this.defaultValue = defaultValue;
	    }
	    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
	    };
	    return DefaultIfEmptyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DefaultIfEmptySubscriber = (function (_super) {
	    __extends(DefaultIfEmptySubscriber, _super);
	    function DefaultIfEmptySubscriber(destination, defaultValue) {
	        _super.call(this, destination);
	        this.defaultValue = defaultValue;
	        this.isEmpty = true;
	    }
	    DefaultIfEmptySubscriber.prototype._next = function (value) {
	        this.isEmpty = false;
	        this.destination.next(value);
	    };
	    DefaultIfEmptySubscriber.prototype._complete = function () {
	        if (this.isEmpty) {
	            this.destination.next(this.defaultValue);
	        }
	        this.destination.complete();
	    };
	    return DefaultIfEmptySubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var delay_1 = __webpack_require__(186);
	Observable_1.Observable.prototype.delay = delay_1.delay;
	


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(101);
	var isDate_1 = __webpack_require__(134);
	var Subscriber_1 = __webpack_require__(32);
	var Notification_1 = __webpack_require__(83);
	/**
	 * Delays the emission of items from the source Observable by a given timeout or
	 * until a given Date.
	 *
	 * <span class="informal">Time shifts each item by some specified amount of
	 * milliseconds.</span>
	 *
	 * <img src="./img/delay.png" width="100%">
	 *
	 * If the delay argument is a Number, this operator time shifts the source
	 * Observable by that amount of time expressed in milliseconds. The relative
	 * time intervals between the values are preserved.
	 *
	 * If the delay argument is a Date, this operator time shifts the start of the
	 * Observable execution until the given date occurs.
	 *
	 * @example <caption>Delay each click by one second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @example <caption>Delay all clicks until a future date happens</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var date = new Date('March 15, 2050 12:00:00'); // in the future
	 * var delayedClicks = clicks.delay(date); // click emitted only after that date
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 *
	 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
	 * a `Date` until which the emission of the source items is delayed.
	 * @param {Scheduler} [scheduler=async] The Scheduler to use for
	 * managing the timers that handle the time-shift for each item.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified timeout or Date.
	 * @method delay
	 * @owner Observable
	 */
	function delay(delay, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var absoluteDelay = isDate_1.isDate(delay);
	    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
	    return this.lift(new DelayOperator(delayFor, scheduler));
	}
	exports.delay = delay;
	var DelayOperator = (function () {
	    function DelayOperator(delay, scheduler) {
	        this.delay = delay;
	        this.scheduler = scheduler;
	    }
	    DelayOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
	    };
	    return DelayOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DelaySubscriber = (function (_super) {
	    __extends(DelaySubscriber, _super);
	    function DelaySubscriber(destination, delay, scheduler) {
	        _super.call(this, destination);
	        this.delay = delay;
	        this.scheduler = scheduler;
	        this.queue = [];
	        this.active = false;
	        this.errored = false;
	    }
	    DelaySubscriber.dispatch = function (state) {
	        var source = state.source;
	        var queue = source.queue;
	        var scheduler = state.scheduler;
	        var destination = state.destination;
	        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
	            queue.shift().notification.observe(destination);
	        }
	        if (queue.length > 0) {
	            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
	            this.schedule(state, delay_1);
	        }
	        else {
	            source.active = false;
	        }
	    };
	    DelaySubscriber.prototype._schedule = function (scheduler) {
	        this.active = true;
	        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
	            source: this, destination: this.destination, scheduler: scheduler
	        }));
	    };
	    DelaySubscriber.prototype.scheduleNotification = function (notification) {
	        if (this.errored === true) {
	            return;
	        }
	        var scheduler = this.scheduler;
	        var message = new DelayMessage(scheduler.now() + this.delay, notification);
	        this.queue.push(message);
	        if (this.active === false) {
	            this._schedule(scheduler);
	        }
	    };
	    DelaySubscriber.prototype._next = function (value) {
	        this.scheduleNotification(Notification_1.Notification.createNext(value));
	    };
	    DelaySubscriber.prototype._error = function (err) {
	        this.errored = true;
	        this.queue = [];
	        this.destination.error(err);
	    };
	    DelaySubscriber.prototype._complete = function () {
	        this.scheduleNotification(Notification_1.Notification.createComplete());
	    };
	    return DelaySubscriber;
	}(Subscriber_1.Subscriber));
	var DelayMessage = (function () {
	    function DelayMessage(time, notification) {
	        this.time = time;
	        this.notification = notification;
	    }
	    return DelayMessage;
	}());
	


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var delayWhen_1 = __webpack_require__(188);
	Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
	


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var Observable_1 = __webpack_require__(29);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Delays the emission of items from the source Observable by a given time span
	 * determined by the emissions of another Observable.
	 *
	 * <span class="informal">It's like {@link delay}, but the time span of the
	 * delay duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/delayWhen.png" width="100%">
	 *
	 * `delayWhen` time shifts each emitted value from the source Observable by a
	 * time span determined by another Observable. When the source emits a value,
	 * the `delayDurationSelector` function is called with the source value as
	 * argument, and should return an Observable, called the "duration" Observable.
	 * The source value is emitted on the output Observable only when the duration
	 * Observable emits a value or completes.
	 *
	 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
	 * is an Observable. When `subscriptionDelay` emits its first value or
	 * completes, the source Observable is subscribed to and starts behaving like
	 * described in the previous paragraph. If `subscriptionDelay` is not provided,
	 * `delayWhen` will subscribe to the source Observable as soon as the output
	 * Observable is subscribed.
	 *
	 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delayWhen(event =>
	 *   Rx.Observable.interval(Math.random() * 5000)
	 * );
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounce}
	 * @see {@link delay}
	 *
	 * @param {function(value: T): Observable} delayDurationSelector A function that
	 * returns an Observable for each value emitted by the source Observable, which
	 * is then used to delay the emission of that item on the output Observable
	 * until the Observable returned from this function emits a value.
	 * @param {Observable} subscriptionDelay An Observable that triggers the
	 * subscription to the source Observable once it emits any value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by an amount of time specified by the Observable returned by
	 * `delayDurationSelector`.
	 * @method delayWhen
	 * @owner Observable
	 */
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    if (subscriptionDelay) {
	        return new SubscriptionDelayObservable(this, subscriptionDelay)
	            .lift(new DelayWhenOperator(delayDurationSelector));
	    }
	    return this.lift(new DelayWhenOperator(delayDurationSelector));
	}
	exports.delayWhen = delayWhen;
	var DelayWhenOperator = (function () {
	    function DelayWhenOperator(delayDurationSelector) {
	        this.delayDurationSelector = delayDurationSelector;
	    }
	    DelayWhenOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
	    };
	    return DelayWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DelayWhenSubscriber = (function (_super) {
	    __extends(DelayWhenSubscriber, _super);
	    function DelayWhenSubscriber(destination, delayDurationSelector) {
	        _super.call(this, destination);
	        this.delayDurationSelector = delayDurationSelector;
	        this.completed = false;
	        this.delayNotifierSubscriptions = [];
	        this.values = [];
	    }
	    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(outerValue);
	        this.removeSubscription(innerSub);
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
	        var value = this.removeSubscription(innerSub);
	        if (value) {
	            this.destination.next(value);
	        }
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype._next = function (value) {
	        try {
	            var delayNotifier = this.delayDurationSelector(value);
	            if (delayNotifier) {
	                this.tryDelay(delayNotifier, value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DelayWhenSubscriber.prototype._complete = function () {
	        this.completed = true;
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
	        subscription.unsubscribe();
	        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
	        var value = null;
	        if (subscriptionIdx !== -1) {
	            value = this.values[subscriptionIdx];
	            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
	            this.values.splice(subscriptionIdx, 1);
	        }
	        return value;
	    };
	    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
	        var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
	        this.add(notifierSubscription);
	        this.delayNotifierSubscriptions.push(notifierSubscription);
	        this.values.push(value);
	    };
	    DelayWhenSubscriber.prototype.tryComplete = function () {
	        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
	            this.destination.complete();
	        }
	    };
	    return DelayWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubscriptionDelayObservable = (function (_super) {
	    __extends(SubscriptionDelayObservable, _super);
	    function SubscriptionDelayObservable(source, subscriptionDelay) {
	        _super.call(this);
	        this.source = source;
	        this.subscriptionDelay = subscriptionDelay;
	    }
	    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
	        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
	    };
	    return SubscriptionDelayObservable;
	}(Observable_1.Observable));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubscriptionDelaySubscriber = (function (_super) {
	    __extends(SubscriptionDelaySubscriber, _super);
	    function SubscriptionDelaySubscriber(parent, source) {
	        _super.call(this);
	        this.parent = parent;
	        this.source = source;
	        this.sourceSubscribed = false;
	    }
	    SubscriptionDelaySubscriber.prototype._next = function (unused) {
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype._error = function (err) {
	        this.unsubscribe();
	        this.parent.error(err);
	    };
	    SubscriptionDelaySubscriber.prototype._complete = function () {
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
	        if (!this.sourceSubscribed) {
	            this.sourceSubscribed = true;
	            this.unsubscribe();
	            this.source.subscribe(this.parent);
	        }
	    };
	    return SubscriptionDelaySubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var distinct_1 = __webpack_require__(190);
	Observable_1.Observable.prototype.distinct = distinct_1.distinct;
	


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 * If a comparator function is not provided, an equality check is used by default.
	 * As the internal HashSet of this operator grows larger and larger, care should be taken in the domain of inputs this operator may see.
	 * An optional parameter is also provided such that an Observable can be provided to queue the internal HashSet to flush the values it holds.
	 * @param {function} [compare] optional comparison function called to test if an item is distinct from previous items in the source.
	 * @param {Observable} [flushes] optional Observable for flushing the internal HashSet of the operator.
	 * @return {Observable} an Observable that emits items from the source Observable with distinct values.
	 * @method distinct
	 * @owner Observable
	 */
	function distinct(compare, flushes) {
	    return this.lift(new DistinctOperator(compare, flushes));
	}
	exports.distinct = distinct;
	var DistinctOperator = (function () {
	    function DistinctOperator(compare, flushes) {
	        this.compare = compare;
	        this.flushes = flushes;
	    }
	    DistinctOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new DistinctSubscriber(subscriber, this.compare, this.flushes));
	    };
	    return DistinctOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DistinctSubscriber = (function (_super) {
	    __extends(DistinctSubscriber, _super);
	    function DistinctSubscriber(destination, compare, flushes) {
	        _super.call(this, destination);
	        this.values = [];
	        if (typeof compare === 'function') {
	            this.compare = compare;
	        }
	        if (flushes) {
	            this.add(subscribeToResult_1.subscribeToResult(this, flushes));
	        }
	    }
	    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values.length = 0;
	    };
	    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    DistinctSubscriber.prototype._next = function (value) {
	        var found = false;
	        var values = this.values;
	        var len = values.length;
	        try {
	            for (var i = 0; i < len; i++) {
	                if (this.compare(values[i], value)) {
	                    found = true;
	                    return;
	                }
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.values.push(value);
	        this.destination.next(value);
	    };
	    DistinctSubscriber.prototype.compare = function (x, y) {
	        return x === y;
	    };
	    return DistinctSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.DistinctSubscriber = DistinctSubscriber;
	


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var distinctKey_1 = __webpack_require__(192);
	Observable_1.Observable.prototype.distinctKey = distinctKey_1.distinctKey;
	


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var distinct_1 = __webpack_require__(190);
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items,
	 * using a property accessed by using the key provided to check if the two items are distinct.
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 * If a comparator function is not provided, an equality check is used by default.
	 * As the internal HashSet of this operator grows larger and larger, care should be taken in the domain of inputs this operator may see.
	 * An optional parameter is also provided such that an Observable can be provided to queue the internal HashSet to flush the values it holds.
	 * @param {string} key string key for object property lookup on each item.
	 * @param {function} [compare] optional comparison function called to test if an item is distinct from previous items in the source.
	 * @param {Observable} [flushes] optional Observable for flushing the internal HashSet of the operator.
	 * @return {Observable} an Observable that emits items from the source Observable with distinct values.
	 * @method distinctKey
	 * @owner Observable
	 */
	function distinctKey(key, compare, flushes) {
	    return distinct_1.distinct.call(this, function (x, y) {
	        if (compare) {
	            return compare(x[key], y[key]);
	        }
	        return x[key] === y[key];
	    }, flushes);
	}
	exports.distinctKey = distinctKey;
	


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var distinctUntilChanged_1 = __webpack_require__(194);
	Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
	


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 * If a comparator function is not provided, an equality check is used by default.
	 * @param {function} [compare] optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} an Observable that emits items from the source Observable with distinct values.
	 * @method distinctUntilChanged
	 * @owner Observable
	 */
	function distinctUntilChanged(compare, keySelector) {
	    return this.lift(new DistinctUntilChangedOperator(compare, keySelector));
	}
	exports.distinctUntilChanged = distinctUntilChanged;
	var DistinctUntilChangedOperator = (function () {
	    function DistinctUntilChangedOperator(compare, keySelector) {
	        this.compare = compare;
	        this.keySelector = keySelector;
	    }
	    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
	    };
	    return DistinctUntilChangedOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DistinctUntilChangedSubscriber = (function (_super) {
	    __extends(DistinctUntilChangedSubscriber, _super);
	    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.hasKey = false;
	        if (typeof compare === 'function') {
	            this.compare = compare;
	        }
	    }
	    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
	        return x === y;
	    };
	    DistinctUntilChangedSubscriber.prototype._next = function (value) {
	        var keySelector = this.keySelector;
	        var key = value;
	        if (keySelector) {
	            key = tryCatch_1.tryCatch(this.keySelector)(value);
	            if (key === errorObject_1.errorObject) {
	                return this.destination.error(errorObject_1.errorObject.e);
	            }
	        }
	        var result = false;
	        if (this.hasKey) {
	            result = tryCatch_1.tryCatch(this.compare)(this.key, key);
	            if (result === errorObject_1.errorObject) {
	                return this.destination.error(errorObject_1.errorObject.e);
	            }
	        }
	        else {
	            this.hasKey = true;
	        }
	        if (Boolean(result) === false) {
	            this.key = key;
	            this.destination.next(value);
	        }
	    };
	    return DistinctUntilChangedSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var distinctUntilKeyChanged_1 = __webpack_require__(196);
	Observable_1.Observable.prototype.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
	


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var distinctUntilChanged_1 = __webpack_require__(194);
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
	 * using a property accessed by using the key provided to check if the two items are distinct.
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 * If a comparator function is not provided, an equality check is used by default.
	 * @param {string} key string key for object property lookup on each item.
	 * @param {function} [compare] optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} an Observable that emits items from the source Observable with distinct values based on the key specified.
	 * @method distinctUntilKeyChanged
	 * @owner Observable
	 */
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilChanged_1.distinctUntilChanged.call(this, function (x, y) {
	        if (compare) {
	            return compare(x[key], y[key]);
	        }
	        return x[key] === y[key];
	    });
	}
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
	


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var do_1 = __webpack_require__(198);
	Observable_1.Observable.prototype.do = do_1._do;
	


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Perform a side effect for every emission on the source Observable, but return
	 * an Observable that is identical to the source.
	 *
	 * <span class="informal">Intercepts each emission on the source and runs a
	 * function, but returns an output which is identical to the source.</span>
	 *
	 * <img src="./img/do.png" width="100%">
	 *
	 * Returns a mirrored Observable of the source Observable, but modified so that
	 * the provided Observer is called to perform a side effect for every value,
	 * error, and completion emitted by the source. Any errors that are thrown in
	 * the aforementioned Observer or handlers are safely sent down the error path
	 * of the output Observable.
	 *
	 * This operator is useful for debugging your Observables for the correct values
	 * or performing other side effects.
	 *
	 * Note: this is different to a `subscribe` on the Observable. If the Observable
	 * returned by `do` is not subscribed, the side effects specified by the
	 * Observer will never happen. `do` therefore simply spies on existing
	 * execution, it does not trigger an execution to happen like `subscribe` does.
	 *
	 * @example <caption>Map every every click to the clientX position of that click, while also logging the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks
	 *   .do(ev => console.log(ev))
	 *   .map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 * @see {@link subscribe}
	 *
	 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
	 * callback for `next`.
	 * @param {function} [error] Callback for errors in the source.
	 * @param {function} [complete] Callback for the completion of the source.
	 * @return {Observable} An Observable identical to the source, but runs the
	 * specified Observer or callback(s) for each item.
	 * @method do
	 * @name do
	 * @owner Observable
	 */
	function _do(nextOrObserver, error, complete) {
	    return this.lift(new DoOperator(nextOrObserver, error, complete));
	}
	exports._do = _do;
	var DoOperator = (function () {
	    function DoOperator(nextOrObserver, error, complete) {
	        this.nextOrObserver = nextOrObserver;
	        this.error = error;
	        this.complete = complete;
	    }
	    DoOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
	    };
	    return DoOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DoSubscriber = (function (_super) {
	    __extends(DoSubscriber, _super);
	    function DoSubscriber(destination, nextOrObserver, error, complete) {
	        _super.call(this, destination);
	        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	        safeSubscriber.syncErrorThrowable = true;
	        this.add(safeSubscriber);
	        this.safeSubscriber = safeSubscriber;
	    }
	    DoSubscriber.prototype._next = function (value) {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.next(value);
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.next(value);
	        }
	    };
	    DoSubscriber.prototype._error = function (err) {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.error(err);
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.error(err);
	        }
	    };
	    DoSubscriber.prototype._complete = function () {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.complete();
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return DoSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var exhaust_1 = __webpack_require__(200);
	Observable_1.Observable.prototype.exhaust = exhaust_1.exhaust;
	


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Converts a higher-order Observable into a first-order Observable by dropping
	 * inner Observables while the previous inner Observable has not yet completed.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * next inner Observables while the current inner is still executing.</span>
	 *
	 * <img src="./img/exhaust.png" width="100%">
	 *
	 * `exhaust` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable begins emitting the items emitted by that
	 * inner Observable. So far, it behaves like {@link mergeAll}. However,
	 * `exhaust` ignores every new inner Observable if the previous Observable has
	 * not yet completed. Once that one completes, it will accept and flatten the
	 * next inner Observable and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var result = higherOrder.exhaust();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link switch}
	 * @see {@link mergeAll}
	 * @see {@link exhaustMap}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} Returns an Observable that takes a source of Observables
	 * and propagates the first observable exclusively until it completes before
	 * subscribing to the next.
	 * @method exhaust
	 * @owner Observable
	 */
	function exhaust() {
	    return this.lift(new SwitchFirstOperator());
	}
	exports.exhaust = exhaust;
	var SwitchFirstOperator = (function () {
	    function SwitchFirstOperator() {
	    }
	    SwitchFirstOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SwitchFirstSubscriber(subscriber));
	    };
	    return SwitchFirstOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchFirstSubscriber = (function (_super) {
	    __extends(SwitchFirstSubscriber, _super);
	    function SwitchFirstSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasCompleted = false;
	        this.hasSubscription = false;
	    }
	    SwitchFirstSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.hasSubscription = true;
	            this.add(subscribeToResult_1.subscribeToResult(this, value));
	        }
	    };
	    SwitchFirstSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	    };
	    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return SwitchFirstSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var exhaustMap_1 = __webpack_require__(202);
	Observable_1.Observable.prototype.exhaustMap = exhaustMap_1.exhaustMap;
	


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable only if the previous projected Observable has completed.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link exhaust}.</span>
	 *
	 * <img src="./img/exhaustMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. When it projects a source value to
	 * an Observable, the output Observable begins emitting the items emitted by
	 * that projected Observable. However, `exhaustMap` ignores every new projected
	 * Observable if the previous projected Observable has not yet completed. Once
	 * that one completes, it will accept and flatten the next projected Observable
	 * and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaust}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): Observable} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable containing projected Observables
	 * of each item of the source, ignoring projected Observables that start before
	 * their preceding Observable has completed.
	 * @method exhaustMap
	 * @owner Observable
	 */
	function exhaustMap(project, resultSelector) {
	    return this.lift(new SwitchFirstMapOperator(project, resultSelector));
	}
	exports.exhaustMap = exhaustMap;
	var SwitchFirstMapOperator = (function () {
	    function SwitchFirstMapOperator(project, resultSelector) {
	        this.project = project;
	        this.resultSelector = resultSelector;
	    }
	    SwitchFirstMapOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
	    };
	    return SwitchFirstMapOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchFirstMapSubscriber = (function (_super) {
	    __extends(SwitchFirstMapSubscriber, _super);
	    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.hasSubscription = false;
	        this.hasCompleted = false;
	        this.index = 0;
	    }
	    SwitchFirstMapSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.tryNext(value);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.tryNext = function (value) {
	        var index = this.index++;
	        var destination = this.destination;
	        try {
	            var result = this.project(value, index);
	            this.hasSubscription = true;
	            this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
	        }
	        catch (err) {
	            destination.error(err);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        try {
	            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	            destination.next(result);
	        }
	        catch (err) {
	            destination.error(err);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    SwitchFirstMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return SwitchFirstMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var expand_1 = __webpack_require__(204);
	Observable_1.Observable.prototype.expand = expand_1.expand;
	


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Recursively projects each source value to an Observable which is merged in
	 * the output Observable.
	 *
	 * <span class="informal">It's similar to {@link mergeMap}, but applies the
	 * projection function to every source value as well as every output value.
	 * It's recursive.</span>
	 *
	 * <img src="./img/expand.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger. *Expand* will re-emit on the output
	 * Observable every source value. Then, each output value is given to the
	 * `project` function which returns an inner Observable to be merged on the
	 * output Observable. Those output values resulting from the projection are also
	 * given to the `project` function to produce new output values. This is how
	 * *expand* behaves recursively.
	 *
	 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var powersOfTwo = clicks
	 *   .mapTo(1)
	 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
	 *   .take(10);
	 * powersOfTwo.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 *
	 * @param {function(value: T, index: number) => Observable} project A function
	 * that, when applied to an item emitted by the source or the output Observable,
	 * returns an Observable.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The Scheduler to use for subscribing to
	 * each projected inner Observable.
	 * @return {Observable} An Observable that emits the source values and also
	 * result of applying the projection function to each value emitted on the
	 * output Observable and and merging the results of the Observables obtained
	 * from this transformation.
	 * @method expand
	 * @owner Observable
	 */
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (scheduler === void 0) { scheduler = undefined; }
	    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
	    return this.lift(new ExpandOperator(project, concurrent, scheduler));
	}
	exports.expand = expand;
	var ExpandOperator = (function () {
	    function ExpandOperator(project, concurrent, scheduler) {
	        this.project = project;
	        this.concurrent = concurrent;
	        this.scheduler = scheduler;
	    }
	    ExpandOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
	    };
	    return ExpandOperator;
	}());
	exports.ExpandOperator = ExpandOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ExpandSubscriber = (function (_super) {
	    __extends(ExpandSubscriber, _super);
	    function ExpandSubscriber(destination, project, concurrent, scheduler) {
	        _super.call(this, destination);
	        this.project = project;
	        this.concurrent = concurrent;
	        this.scheduler = scheduler;
	        this.index = 0;
	        this.active = 0;
	        this.hasCompleted = false;
	        if (concurrent < Number.POSITIVE_INFINITY) {
	            this.buffer = [];
	        }
	    }
	    ExpandSubscriber.dispatch = function (arg) {
	        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
	        subscriber.subscribeToProjection(result, value, index);
	    };
	    ExpandSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (destination.closed) {
	            this._complete();
	            return;
	        }
	        var index = this.index++;
	        if (this.active < this.concurrent) {
	            destination.next(value);
	            var result = tryCatch_1.tryCatch(this.project)(value, index);
	            if (result === errorObject_1.errorObject) {
	                destination.error(errorObject_1.errorObject.e);
	            }
	            else if (!this.scheduler) {
	                this.subscribeToProjection(result, value, index);
	            }
	            else {
	                var state = { subscriber: this, result: result, value: value, index: index };
	                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
	            }
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
	        this.active++;
	        this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
	    };
	    ExpandSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this._next(innerValue);
	    };
	    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer && buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    return ExpandSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.ExpandSubscriber = ExpandSubscriber;
	


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var elementAt_1 = __webpack_require__(206);
	Observable_1.Observable.prototype.elementAt = elementAt_1.elementAt;
	


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var ArgumentOutOfRangeError_1 = __webpack_require__(207);
	/**
	 * Emits the single value at the specified `index` in a sequence of emissions
	 * from the source Observable.
	 *
	 * <span class="informal">Emits only the i-th value, then completes.</span>
	 *
	 * <img src="./img/elementAt.png" width="100%">
	 *
	 * `elementAt` returns an Observable that emits the item at the specified
	 * `index` in the source Observable, or a default value if that `index` is out
	 * of range and the `default` argument is provided. If the `default` argument is
	 * not given and the `index` is out of range, the output Observable will emit an
	 * `ArgumentOutOfRangeError` error.
	 *
	 * @example <caption>Emit only the third click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.elementAt(2);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link skip}
	 * @see {@link single}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
	 * Observable has completed before emitting the i-th `next` notification.
	 *
	 * @param {number} index Is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {T} [defaultValue] The default value returned for missing indices.
	 * @return {Observable} An Observable that emits a single item, if it is found.
	 * Otherwise, will emit the default value if given. If not, then emits an error.
	 * @method elementAt
	 * @owner Observable
	 */
	function elementAt(index, defaultValue) {
	    return this.lift(new ElementAtOperator(index, defaultValue));
	}
	exports.elementAt = elementAt;
	var ElementAtOperator = (function () {
	    function ElementAtOperator(index, defaultValue) {
	        this.index = index;
	        this.defaultValue = defaultValue;
	        if (index < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    ElementAtOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new ElementAtSubscriber(subscriber, this.index, this.defaultValue));
	    };
	    return ElementAtOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ElementAtSubscriber = (function (_super) {
	    __extends(ElementAtSubscriber, _super);
	    function ElementAtSubscriber(destination, index, defaultValue) {
	        _super.call(this, destination);
	        this.index = index;
	        this.defaultValue = defaultValue;
	    }
	    ElementAtSubscriber.prototype._next = function (x) {
	        if (this.index-- === 0) {
	            this.destination.next(x);
	            this.destination.complete();
	        }
	    };
	    ElementAtSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.index >= 0) {
	            if (typeof this.defaultValue !== 'undefined') {
	                destination.next(this.defaultValue);
	            }
	            else {
	                destination.error(new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError);
	            }
	        }
	        destination.complete();
	    };
	    return ElementAtSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an element was queried at a certain index of an
	 * Observable, but no such index or position exists in that sequence.
	 *
	 * @see {@link elementAt}
	 * @see {@link take}
	 * @see {@link takeLast}
	 *
	 * @class ArgumentOutOfRangeError
	 */
	var ArgumentOutOfRangeError = (function (_super) {
	    __extends(ArgumentOutOfRangeError, _super);
	    function ArgumentOutOfRangeError() {
	        var err = _super.call(this, 'argument out of range');
	        this.name = err.name = 'ArgumentOutOfRangeError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return ArgumentOutOfRangeError;
	}(Error));
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
	


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var filter_1 = __webpack_require__(209);
	Observable_1.Observable.prototype.filter = filter_1.filter;
	


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Filter items emitted by the source Observable by only emitting those that
	 * satisfy a specified predicate.
	 *
	 * <span class="informal">Like
	 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
	 * it only emits a value from the source if it passes a criterion function.</span>
	 *
	 * <img src="./img/filter.png" width="100%">
	 *
	 * Similar to the well-known `Array.prototype.filter` method, this operator
	 * takes values from the source Observable, passes them through a `predicate`
	 * function and only emits those values that yielded `true`.
	 *
	 * @example <caption>Emit only click events whose target was a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
	 * clicksOnDivs.subscribe(x => console.log(x));
	 *
	 * @see {@link distinct}
	 * @see {@link distinctKey}
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 * @see {@link ignoreElements}
	 * @see {@link partition}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted, if `false` the value is not passed to the output
	 * Observable. The `index` parameter is the number `i` for the i-th source
	 * emission that has happened since the subscription, starting from the number
	 * `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of values from the source that were
	 * allowed by the `predicate` function.
	 * @method filter
	 * @owner Observable
	 */
	function filter(predicate, thisArg) {
	    return this.lift(new FilterOperator(predicate, thisArg));
	}
	exports.filter = filter;
	var FilterOperator = (function () {
	    function FilterOperator(predicate, thisArg) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	    }
	    FilterOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
	    };
	    return FilterOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FilterSubscriber = (function (_super) {
	    __extends(FilterSubscriber, _super);
	    function FilterSubscriber(destination, predicate, thisArg) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.count = 0;
	        this.predicate = predicate;
	    }
	    // the try catch block below is left specifically for
	    // optimization and perf reasons. a tryCatcher is not necessary here.
	    FilterSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.destination.next(value);
	        }
	    };
	    return FilterSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var finally_1 = __webpack_require__(211);
	Observable_1.Observable.prototype.finally = finally_1._finally;
	


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var Subscription_1 = __webpack_require__(34);
	/**
	 * Returns an Observable that mirrors the source Observable, but will call a specified function when
	 * the source terminates on complete or error.
	 * @param {function} callback function to be called when source terminates.
	 * @return {Observable} an Observable that mirrors the source, but will call the specified function on termination.
	 * @method finally
	 * @owner Observable
	 */
	function _finally(callback) {
	    return this.lift(new FinallyOperator(callback));
	}
	exports._finally = _finally;
	var FinallyOperator = (function () {
	    function FinallyOperator(callback) {
	        this.callback = callback;
	    }
	    FinallyOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new FinallySubscriber(subscriber, this.callback));
	    };
	    return FinallyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FinallySubscriber = (function (_super) {
	    __extends(FinallySubscriber, _super);
	    function FinallySubscriber(destination, callback) {
	        _super.call(this, destination);
	        this.add(new Subscription_1.Subscription(callback));
	    }
	    return FinallySubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var find_1 = __webpack_require__(213);
	Observable_1.Observable.prototype.find = find_1.find;
	


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Emits only the first value emitted by the source Observable that meets some
	 * condition.
	 *
	 * <span class="informal">Finds the first value that passes some test and emits
	 * that.</span>
	 *
	 * <img src="./img/find.png" width="100%">
	 *
	 * `find` searches for the first item in the source Observable that matches the
	 * specified condition embodied by the `predicate`, and returns the first
	 * occurrence in the source. Unlike {@link first}, the `predicate` is required
	 * in `find`, and does not emit an error if a valid value is not found.
	 *
	 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link first}
	 * @see {@link findIndex}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable<T>} An Observable of the first item that matches the
	 * condition.
	 * @method find
	 * @owner Observable
	 */
	function find(predicate, thisArg) {
	    if (typeof predicate !== 'function') {
	        throw new TypeError('predicate is not a function');
	    }
	    return this.lift(new FindValueOperator(predicate, this, false, thisArg));
	}
	exports.find = find;
	var FindValueOperator = (function () {
	    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
	        this.predicate = predicate;
	        this.source = source;
	        this.yieldIndex = yieldIndex;
	        this.thisArg = thisArg;
	    }
	    FindValueOperator.prototype.call = function (observer, source) {
	        return source._subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
	    };
	    return FindValueOperator;
	}());
	exports.FindValueOperator = FindValueOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FindValueSubscriber = (function (_super) {
	    __extends(FindValueSubscriber, _super);
	    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.yieldIndex = yieldIndex;
	        this.thisArg = thisArg;
	        this.index = 0;
	    }
	    FindValueSubscriber.prototype.notifyComplete = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	    };
	    FindValueSubscriber.prototype._next = function (value) {
	        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
	        var index = this.index++;
	        try {
	            var result = predicate.call(thisArg || this, value, index, this.source);
	            if (result) {
	                this.notifyComplete(this.yieldIndex ? index : value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    FindValueSubscriber.prototype._complete = function () {
	        this.notifyComplete(this.yieldIndex ? -1 : undefined);
	    };
	    return FindValueSubscriber;
	}(Subscriber_1.Subscriber));
	exports.FindValueSubscriber = FindValueSubscriber;
	


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var findIndex_1 = __webpack_require__(215);
	Observable_1.Observable.prototype.findIndex = findIndex_1.findIndex;
	


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var find_1 = __webpack_require__(213);
	/**
	 * Emits only the index of the first value emitted by the source Observable that
	 * meets some condition.
	 *
	 * <span class="informal">It's like {@link find}, but emits the index of the
	 * found value, not the value itself.</span>
	 *
	 * <img src="./img/findIndex.png" width="100%">
	 *
	 * `findIndex` searches for the first item in the source Observable that matches
	 * the specified condition embodied by the `predicate`, and returns the
	 * (zero-based) index of the first occurrence in the source. Unlike
	 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
	 * an error if a valid value is not found.
	 *
	 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link first}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of the index of the first item that
	 * matches the condition.
	 * @method find
	 * @owner Observable
	 */
	function findIndex(predicate, thisArg) {
	    return this.lift(new find_1.FindValueOperator(predicate, this, true, thisArg));
	}
	exports.findIndex = findIndex;
	


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var first_1 = __webpack_require__(217);
	Observable_1.Observable.prototype.first = first_1.first;
	


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var EmptyError_1 = __webpack_require__(218);
	/**
	 * Emits only the first value (or the first value that meets some condition)
	 * emitted by the source Observable.
	 *
	 * <span class="informal">Emits only the first value. Or emits only the first
	 * value that passes some test.</span>
	 *
	 * <img src="./img/first.png" width="100%">
	 *
	 * If called with no arguments, `first` emits the first value of the source
	 * Observable, then completes. If called with a `predicate` function, `first`
	 * emits the first value of the source that matches the specified condition. It
	 * may also take a `resultSelector` function to produce the output value from
	 * the input value, and a `defaultValue` to emit in case the source completes
	 * before it is able to emit a valid value. Throws an error if `defaultValue`
	 * was not provided and a matching element is not found.
	 *
	 * @example <caption>Emit only the first click that happens on the DOM</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Emits the first click that happens on a DIV</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link take}
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
	 * An optional function called with each item to test for condition matching.
	 * @param {function(value: T, index: number): R} [resultSelector] A function to
	 * produce the value on the output Observable based on the values
	 * and the indices of the source Observable. The arguments passed to this
	 * function are:
	 * - `value`: the value that was emitted on the source.
	 * - `index`: the "index" of the value from the source.
	 * @param {R} [defaultValue] The default value emitted in case no valid value
	 * was found on the source.
	 * @return {Observable<T|R>} an Observable of the first item that matches the
	 * condition.
	 * @method first
	 * @owner Observable
	 */
	function first(predicate, resultSelector, defaultValue) {
	    return this.lift(new FirstOperator(predicate, resultSelector, defaultValue, this));
	}
	exports.first = first;
	var FirstOperator = (function () {
	    function FirstOperator(predicate, resultSelector, defaultValue, source) {
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	    }
	    FirstOperator.prototype.call = function (observer, source) {
	        return source._subscribe(new FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
	    };
	    return FirstOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FirstSubscriber = (function (_super) {
	    __extends(FirstSubscriber, _super);
	    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	        this.index = 0;
	        this.hasCompleted = false;
	    }
	    FirstSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this._tryPredicate(value, index);
	        }
	        else {
	            this._emit(value, index);
	        }
	    };
	    FirstSubscriber.prototype._tryPredicate = function (value, index) {
	        var result;
	        try {
	            result = this.predicate(value, index, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this._emit(value, index);
	        }
	    };
	    FirstSubscriber.prototype._emit = function (value, index) {
	        if (this.resultSelector) {
	            this._tryResultSelector(value, index);
	            return;
	        }
	        this._emitFinal(value);
	    };
	    FirstSubscriber.prototype._tryResultSelector = function (value, index) {
	        var result;
	        try {
	            result = this.resultSelector(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this._emitFinal(result);
	    };
	    FirstSubscriber.prototype._emitFinal = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	        this.hasCompleted = true;
	    };
	    FirstSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
	            destination.next(this.defaultValue);
	            destination.complete();
	        }
	        else if (!this.hasCompleted) {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return FirstSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an Observable or a sequence was queried but has no
	 * elements.
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link single}
	 *
	 * @class EmptyError
	 */
	var EmptyError = (function (_super) {
	    __extends(EmptyError, _super);
	    function EmptyError() {
	        var err = _super.call(this, 'no elements in sequence');
	        this.name = err.name = 'EmptyError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return EmptyError;
	}(Error));
	exports.EmptyError = EmptyError;
	


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var groupBy_1 = __webpack_require__(220);
	Observable_1.Observable.prototype.groupBy = groupBy_1.groupBy;
	


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var Subscription_1 = __webpack_require__(34);
	var Observable_1 = __webpack_require__(29);
	var Subject_1 = __webpack_require__(28);
	var Map_1 = __webpack_require__(221);
	var FastMap_1 = __webpack_require__(223);
	/**
	 * Groups the items emitted by an Observable according to a specified criterion,
	 * and emits these grouped items as `GroupedObservables`, one
	 * {@link GroupedObservable} per group.
	 *
	 * <img src="./img/groupBy.png" width="100%">
	 *
	 * @param {function(value: T): K} keySelector a function that extracts the key
	 * for each item.
	 * @param {function(value: T): R} [elementSelector] a function that extracts the
	 * return element for each item.
	 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
	 * a function that returns an Observable to determine how long each group should
	 * exist.
	 * @return {Observable<GroupedObservable<K,R>>} an Observable that emits
	 * GroupedObservables, each of which corresponds to a unique key value and each
	 * of which emits those items from the source Observable that share that key
	 * value.
	 * @method groupBy
	 * @owner Observable
	 */
	function groupBy(keySelector, elementSelector, durationSelector) {
	    return this.lift(new GroupByOperator(this, keySelector, elementSelector, durationSelector));
	}
	exports.groupBy = groupBy;
	var GroupByOperator = (function () {
	    function GroupByOperator(source, keySelector, elementSelector, durationSelector) {
	        this.source = source;
	        this.keySelector = keySelector;
	        this.elementSelector = elementSelector;
	        this.durationSelector = durationSelector;
	    }
	    GroupByOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector));
	    };
	    return GroupByOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var GroupBySubscriber = (function (_super) {
	    __extends(GroupBySubscriber, _super);
	    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.elementSelector = elementSelector;
	        this.durationSelector = durationSelector;
	        this.groups = null;
	        this.attemptedToUnsubscribe = false;
	        this.count = 0;
	    }
	    GroupBySubscriber.prototype._next = function (value) {
	        var key;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            this.error(err);
	            return;
	        }
	        this._group(value, key);
	    };
	    GroupBySubscriber.prototype._group = function (value, key) {
	        var groups = this.groups;
	        if (!groups) {
	            groups = this.groups = typeof key === 'string' ? new FastMap_1.FastMap() : new Map_1.Map();
	        }
	        var group = groups.get(key);
	        var element;
	        if (this.elementSelector) {
	            try {
	                element = this.elementSelector(value);
	            }
	            catch (err) {
	                this.error(err);
	            }
	        }
	        else {
	            element = value;
	        }
	        if (!group) {
	            groups.set(key, group = new Subject_1.Subject());
	            var groupedObservable = new GroupedObservable(key, group, this);
	            this.destination.next(groupedObservable);
	            if (this.durationSelector) {
	                var duration = void 0;
	                try {
	                    duration = this.durationSelector(new GroupedObservable(key, group));
	                }
	                catch (err) {
	                    this.error(err);
	                    return;
	                }
	                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
	            }
	        }
	        if (!group.closed) {
	            group.next(element);
	        }
	    };
	    GroupBySubscriber.prototype._error = function (err) {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.error(err);
	            });
	            groups.clear();
	        }
	        this.destination.error(err);
	    };
	    GroupBySubscriber.prototype._complete = function () {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.complete();
	            });
	            groups.clear();
	        }
	        this.destination.complete();
	    };
	    GroupBySubscriber.prototype.removeGroup = function (key) {
	        this.groups.delete(key);
	    };
	    GroupBySubscriber.prototype.unsubscribe = function () {
	        if (!this.closed && !this.attemptedToUnsubscribe) {
	            this.attemptedToUnsubscribe = true;
	            if (this.count === 0) {
	                _super.prototype.unsubscribe.call(this);
	            }
	        }
	    };
	    return GroupBySubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var GroupDurationSubscriber = (function (_super) {
	    __extends(GroupDurationSubscriber, _super);
	    function GroupDurationSubscriber(key, group, parent) {
	        _super.call(this);
	        this.key = key;
	        this.group = group;
	        this.parent = parent;
	    }
	    GroupDurationSubscriber.prototype._next = function (value) {
	        this._complete();
	    };
	    GroupDurationSubscriber.prototype._error = function (err) {
	        var group = this.group;
	        if (!group.closed) {
	            group.error(err);
	        }
	        this.parent.removeGroup(this.key);
	    };
	    GroupDurationSubscriber.prototype._complete = function () {
	        var group = this.group;
	        if (!group.closed) {
	            group.complete();
	        }
	        this.parent.removeGroup(this.key);
	    };
	    return GroupDurationSubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * An Observable representing values belonging to the same group represented by
	 * a common key. The values emitted by a GroupedObservable come from the source
	 * Observable. The common key is available as the field `key` on a
	 * GroupedObservable instance.
	 *
	 * @class GroupedObservable<K, T>
	 */
	var GroupedObservable = (function (_super) {
	    __extends(GroupedObservable, _super);
	    function GroupedObservable(key, groupSubject, refCountSubscription) {
	        _super.call(this);
	        this.key = key;
	        this.groupSubject = groupSubject;
	        this.refCountSubscription = refCountSubscription;
	    }
	    GroupedObservable.prototype._subscribe = function (subscriber) {
	        var subscription = new Subscription_1.Subscription();
	        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
	        if (refCountSubscription && !refCountSubscription.closed) {
	            subscription.add(new InnerRefCountSubscription(refCountSubscription));
	        }
	        subscription.add(groupSubject.subscribe(subscriber));
	        return subscription;
	    };
	    return GroupedObservable;
	}(Observable_1.Observable));
	exports.GroupedObservable = GroupedObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var InnerRefCountSubscription = (function (_super) {
	    __extends(InnerRefCountSubscription, _super);
	    function InnerRefCountSubscription(parent) {
	        _super.call(this);
	        this.parent = parent;
	        parent.count++;
	    }
	    InnerRefCountSubscription.prototype.unsubscribe = function () {
	        var parent = this.parent;
	        if (!parent.closed && !this.closed) {
	            _super.prototype.unsubscribe.call(this);
	            parent.count -= 1;
	            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
	                parent.unsubscribe();
	            }
	        }
	    };
	    return InnerRefCountSubscription;
	}(Subscription_1.Subscription));
	


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var root_1 = __webpack_require__(30);
	var MapPolyfill_1 = __webpack_require__(222);
	exports.Map = root_1.root.Map || (function () { return MapPolyfill_1.MapPolyfill; })();
	


/***/ }),
/* 222 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var MapPolyfill = (function () {
	    function MapPolyfill() {
	        this.size = 0;
	        this._values = [];
	        this._keys = [];
	    }
	    MapPolyfill.prototype.get = function (key) {
	        var i = this._keys.indexOf(key);
	        return i === -1 ? undefined : this._values[i];
	    };
	    MapPolyfill.prototype.set = function (key, value) {
	        var i = this._keys.indexOf(key);
	        if (i === -1) {
	            this._keys.push(key);
	            this._values.push(value);
	            this.size++;
	        }
	        else {
	            this._values[i] = value;
	        }
	        return this;
	    };
	    MapPolyfill.prototype.delete = function (key) {
	        var i = this._keys.indexOf(key);
	        if (i === -1) {
	            return false;
	        }
	        this._values.splice(i, 1);
	        this._keys.splice(i, 1);
	        this.size--;
	        return true;
	    };
	    MapPolyfill.prototype.clear = function () {
	        this._keys.length = 0;
	        this._values.length = 0;
	        this.size = 0;
	    };
	    MapPolyfill.prototype.forEach = function (cb, thisArg) {
	        for (var i = 0; i < this.size; i++) {
	            cb.call(thisArg, this._values[i], this._keys[i]);
	        }
	    };
	    return MapPolyfill;
	}());
	exports.MapPolyfill = MapPolyfill;
	


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var FastMap = (function () {
	    function FastMap() {
	        this.values = {};
	    }
	    FastMap.prototype.delete = function (key) {
	        this.values[key] = null;
	        return true;
	    };
	    FastMap.prototype.set = function (key, value) {
	        this.values[key] = value;
	        return this;
	    };
	    FastMap.prototype.get = function (key) {
	        return this.values[key];
	    };
	    FastMap.prototype.forEach = function (cb, thisArg) {
	        var values = this.values;
	        for (var key in values) {
	            if (values.hasOwnProperty(key) && values[key] !== null) {
	                cb.call(thisArg, values[key], key);
	            }
	        }
	    };
	    FastMap.prototype.clear = function () {
	        this.values = {};
	    };
	    return FastMap;
	}());
	exports.FastMap = FastMap;
	


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var ignoreElements_1 = __webpack_require__(225);
	Observable_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
	


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var noop_1 = __webpack_require__(114);
	/**
	 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
	 *
	 * <img src="./img/ignoreElements.png" width="100%">
	 *
	 * @return {Observable} an empty Observable that only calls `complete`
	 * or `error`, based on which one is called by the source Observable.
	 * @method ignoreElements
	 * @owner Observable
	 */
	function ignoreElements() {
	    return this.lift(new IgnoreElementsOperator());
	}
	exports.ignoreElements = ignoreElements;
	;
	var IgnoreElementsOperator = (function () {
	    function IgnoreElementsOperator() {
	    }
	    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new IgnoreElementsSubscriber(subscriber));
	    };
	    return IgnoreElementsOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var IgnoreElementsSubscriber = (function (_super) {
	    __extends(IgnoreElementsSubscriber, _super);
	    function IgnoreElementsSubscriber() {
	        _super.apply(this, arguments);
	    }
	    IgnoreElementsSubscriber.prototype._next = function (unused) {
	        noop_1.noop();
	    };
	    return IgnoreElementsSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var isEmpty_1 = __webpack_require__(227);
	Observable_1.Observable.prototype.isEmpty = isEmpty_1.isEmpty;
	


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
	 *
	 * <img src="./img/isEmpty.png" width="100%">
	 *
	 * @return {Observable} an Observable that emits a Boolean.
	 * @method isEmpty
	 * @owner Observable
	 */
	function isEmpty() {
	    return this.lift(new IsEmptyOperator());
	}
	exports.isEmpty = isEmpty;
	var IsEmptyOperator = (function () {
	    function IsEmptyOperator() {
	    }
	    IsEmptyOperator.prototype.call = function (observer, source) {
	        return source._subscribe(new IsEmptySubscriber(observer));
	    };
	    return IsEmptyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var IsEmptySubscriber = (function (_super) {
	    __extends(IsEmptySubscriber, _super);
	    function IsEmptySubscriber(destination) {
	        _super.call(this, destination);
	    }
	    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
	        var destination = this.destination;
	        destination.next(isEmpty);
	        destination.complete();
	    };
	    IsEmptySubscriber.prototype._next = function (value) {
	        this.notifyComplete(false);
	    };
	    IsEmptySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return IsEmptySubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var audit_1 = __webpack_require__(229);
	Observable_1.Observable.prototype.audit = audit_1.audit;
	


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Ignores source values for a duration determined by another Observable, then
	 * emits the most recent value from the source Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link auditTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/audit.png" width="100%">
	 *
	 * `audit` is similar to `throttle`, but emits the last value from the silenced
	 * time window, instead of the first value. `audit` emits the most recent value
	 * from the source Observable on the output Observable as soon as its internal
	 * timer becomes disabled, and ignores source values while the timer is enabled.
	 * Initially, the timer is disabled. As soon as the first source value arrives,
	 * the timer is enabled by calling the `durationSelector` function with the
	 * source value, which returns the "duration" Observable. When the duration
	 * Observable emits a value or completes, the timer is disabled, then the most
	 * recent source value is emitted on the output Observable, and this process
	 * repeats for the next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): Observable|Promise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration, returned as an Observable or a Promise.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method audit
	 * @owner Observable
	 */
	function audit(durationSelector) {
	    return this.lift(new AuditOperator(durationSelector));
	}
	exports.audit = audit;
	var AuditOperator = (function () {
	    function AuditOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    AuditOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new AuditSubscriber(subscriber, this.durationSelector));
	    };
	    return AuditOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AuditSubscriber = (function (_super) {
	    __extends(AuditSubscriber, _super);
	    function AuditSubscriber(destination, durationSelector) {
	        _super.call(this, destination);
	        this.durationSelector = durationSelector;
	        this.hasValue = false;
	    }
	    AuditSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	        if (!this.throttled) {
	            var duration = tryCatch_1.tryCatch(this.durationSelector)(value);
	            if (duration === errorObject_1.errorObject) {
	                this.destination.error(errorObject_1.errorObject.e);
	            }
	            else {
	                this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
	            }
	        }
	    };
	    AuditSubscriber.prototype.clearThrottle = function () {
	        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = null;
	            throttled.unsubscribe();
	        }
	        if (hasValue) {
	            this.value = null;
	            this.hasValue = false;
	            this.destination.next(value);
	        }
	    };
	    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
	        this.clearThrottle();
	    };
	    AuditSubscriber.prototype.notifyComplete = function () {
	        this.clearThrottle();
	    };
	    return AuditSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var auditTime_1 = __webpack_require__(231);
	Observable_1.Observable.prototype.auditTime = auditTime_1.auditTime;
	


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(101);
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Ignores source values for `duration` milliseconds, then emits the most recent
	 * value from the source Observable, then repeats this process.
	 *
	 * <span class="informal">When it sees a source values, it ignores that plus
	 * the next ones for `duration` milliseconds, and then it emits the most recent
	 * value from the source.</span>
	 *
	 * <img src="./img/auditTime.png" width="100%">
	 *
	 * `auditTime` is similar to `throttleTime`, but emits the last value from the
	 * silenced time window, instead of the first value. `auditTime` emits the most
	 * recent value from the source Observable on the output Observable as soon as
	 * its internal timer becomes disabled, and ignores source values while the
	 * timer is enabled. Initially, the timer is disabled. As soon as the first
	 * source value arrives, the timer is enabled. After `duration` milliseconds (or
	 * the time unit determined internally by the optional `scheduler`) has passed,
	 * the timer is disabled, then the most recent source value is emitted on the
	 * output Observable, and this process repeats for the next source value.
	 * Optionally takes a {@link Scheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.auditTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} duration Time to wait before emitting the most recent source
	 * value, measured in milliseconds or the time unit determined internally
	 * by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link Scheduler} to use for
	 * managing the timers that handle the rate-limiting behavior.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method auditTime
	 * @owner Observable
	 */
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return this.lift(new AuditTimeOperator(duration, scheduler));
	}
	exports.auditTime = auditTime;
	var AuditTimeOperator = (function () {
	    function AuditTimeOperator(duration, scheduler) {
	        this.duration = duration;
	        this.scheduler = scheduler;
	    }
	    AuditTimeOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new AuditTimeSubscriber(subscriber, this.duration, this.scheduler));
	    };
	    return AuditTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AuditTimeSubscriber = (function (_super) {
	    __extends(AuditTimeSubscriber, _super);
	    function AuditTimeSubscriber(destination, duration, scheduler) {
	        _super.call(this, destination);
	        this.duration = duration;
	        this.scheduler = scheduler;
	        this.hasValue = false;
	    }
	    AuditTimeSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	        if (!this.throttled) {
	            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, this));
	        }
	    };
	    AuditTimeSubscriber.prototype.clearThrottle = function () {
	        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = null;
	            throttled.unsubscribe();
	        }
	        if (hasValue) {
	            this.value = null;
	            this.hasValue = false;
	            this.destination.next(value);
	        }
	    };
	    return AuditTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(subscriber) {
	    subscriber.clearThrottle();
	}
	


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var last_1 = __webpack_require__(233);
	Observable_1.Observable.prototype.last = last_1.last;
	


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var EmptyError_1 = __webpack_require__(218);
	/**
	 * Returns an Observable that emits only the last item emitted by the source Observable.
	 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
	 * the last item from the source Observable, the resulting Observable will emit the last item
	 * from the source Observable that satisfies the predicate.
	 *
	 * <img src="./img/last.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {function} predicate - the condition any source emitted item has to satisfy.
	 * @return {Observable} an Observable that emits only the last item satisfying the given condition
	 * from the source, or an NoSuchElementException if no such items are emitted.
	 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
	 * @method last
	 * @owner Observable
	 */
	function last(predicate, resultSelector, defaultValue) {
	    return this.lift(new LastOperator(predicate, resultSelector, defaultValue, this));
	}
	exports.last = last;
	var LastOperator = (function () {
	    function LastOperator(predicate, resultSelector, defaultValue, source) {
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	    }
	    LastOperator.prototype.call = function (observer, source) {
	        return source._subscribe(new LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
	    };
	    return LastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var LastSubscriber = (function (_super) {
	    __extends(LastSubscriber, _super);
	    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	        this.hasValue = false;
	        this.index = 0;
	        if (typeof defaultValue !== 'undefined') {
	            this.lastValue = defaultValue;
	            this.hasValue = true;
	        }
	    }
	    LastSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this._tryPredicate(value, index);
	        }
	        else {
	            if (this.resultSelector) {
	                this._tryResultSelector(value, index);
	                return;
	            }
	            this.lastValue = value;
	            this.hasValue = true;
	        }
	    };
	    LastSubscriber.prototype._tryPredicate = function (value, index) {
	        var result;
	        try {
	            result = this.predicate(value, index, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            if (this.resultSelector) {
	                this._tryResultSelector(value, index);
	                return;
	            }
	            this.lastValue = value;
	            this.hasValue = true;
	        }
	    };
	    LastSubscriber.prototype._tryResultSelector = function (value, index) {
	        var result;
	        try {
	            result = this.resultSelector(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.lastValue = result;
	        this.hasValue = true;
	    };
	    LastSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.hasValue) {
	            destination.next(this.lastValue);
	            destination.complete();
	        }
	        else {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return LastSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var let_1 = __webpack_require__(235);
	Observable_1.Observable.prototype.let = let_1.letProto;
	Observable_1.Observable.prototype.letBind = let_1.letProto;
	


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	/**
	 * @param func
	 * @return {Observable<R>}
	 * @method let
	 * @owner Observable
	 */
	function letProto(func) {
	    return func(this);
	}
	exports.letProto = letProto;
	


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var every_1 = __webpack_require__(237);
	Observable_1.Observable.prototype.every = every_1.every;
	


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
	 * @param {function} predicate a function for determining if an item meets a specified condition.
	 * @param {any} [thisArg] optional object to use for `this` in the callback
	 * @return {Observable} an Observable of booleans that determines if all items of the source Observable meet the condition specified.
	 * @method every
	 * @owner Observable
	 */
	function every(predicate, thisArg) {
	    return this.lift(new EveryOperator(predicate, thisArg, this));
	}
	exports.every = every;
	var EveryOperator = (function () {
	    function EveryOperator(predicate, thisArg, source) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.source = source;
	    }
	    EveryOperator.prototype.call = function (observer, source) {
	        return source._subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
	    };
	    return EveryOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var EverySubscriber = (function (_super) {
	    __extends(EverySubscriber, _super);
	    function EverySubscriber(destination, predicate, thisArg, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.source = source;
	        this.index = 0;
	        this.thisArg = thisArg || this;
	    }
	    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
	        this.destination.next(everyValueMatch);
	        this.destination.complete();
	    };
	    EverySubscriber.prototype._next = function (value) {
	        var result = false;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (!result) {
	            this.notifyComplete(false);
	        }
	    };
	    EverySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return EverySubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var map_1 = __webpack_require__(239);
	Observable_1.Observable.prototype.map = map_1.map;
	


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Applies a given `project` function to each value emitted by the source
	 * Observable, and emits the resulting values as an Observable.
	 *
	 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
	 * it passes each source value through a transformation function to get
	 * corresponding output values.</span>
	 *
	 * <img src="./img/map.png" width="100%">
	 *
	 * Similar to the well known `Array.prototype.map` function, this operator
	 * applies a projection to each value and emits that projection in the output
	 * Observable.
	 *
	 * @example <caption>Map every every click to the clientX position of that click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks.map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link mapTo}
	 * @see {@link pluck}
	 *
	 * @param {function(value: T, index: number): R} project The function to apply
	 * to each `value` emitted by the source Observable. The `index` parameter is
	 * the number `i` for the i-th emission that has happened since the
	 * subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to define what `this` is in the
	 * `project` function.
	 * @return {Observable<R>} An Observable that emits the values from the source
	 * Observable transformed by the given `project` function.
	 * @method map
	 * @owner Observable
	 */
	function map(project, thisArg) {
	    if (typeof project !== 'function') {
	        throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
	    }
	    return this.lift(new MapOperator(project, thisArg));
	}
	exports.map = map;
	var MapOperator = (function () {
	    function MapOperator(project, thisArg) {
	        this.project = project;
	        this.thisArg = thisArg;
	    }
	    MapOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
	    };
	    return MapOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MapSubscriber = (function (_super) {
	    __extends(MapSubscriber, _super);
	    function MapSubscriber(destination, project, thisArg) {
	        _super.call(this, destination);
	        this.project = project;
	        this.count = 0;
	        this.thisArg = thisArg || this;
	    }
	    // NOTE: This looks unoptimized, but it's actually purposefully NOT
	    // using try/catch optimizations.
	    MapSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.project.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return MapSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var mapTo_1 = __webpack_require__(241);
	Observable_1.Observable.prototype.mapTo = mapTo_1.mapTo;
	


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Emits the given constant value on the output Observable every time the source
	 * Observable emits a value.
	 *
	 * <span class="informal">Like {@link map}, but it maps every source value to
	 * the same output value every time.</span>
	 *
	 * <img src="./img/mapTo.png" width="100%">
	 *
	 * Takes a constant `value` as argument, and emits that whenever the source
	 * Observable emits a value. In other words, ignores the actual source value,
	 * and simply uses the emission moment to know when to emit the given `value`.
	 *
	 * @example <caption>Map every every click to the string 'Hi'</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var greetings = clicks.mapTo('Hi');
	 * greetings.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {any} value The value to map each source value to.
	 * @return {Observable} An Observable that emits the given `value` every time
	 * the source Observable emits something.
	 * @method mapTo
	 * @owner Observable
	 */
	function mapTo(value) {
	    return this.lift(new MapToOperator(value));
	}
	exports.mapTo = mapTo;
	var MapToOperator = (function () {
	    function MapToOperator(value) {
	        this.value = value;
	    }
	    MapToOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new MapToSubscriber(subscriber, this.value));
	    };
	    return MapToOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MapToSubscriber = (function (_super) {
	    __extends(MapToSubscriber, _super);
	    function MapToSubscriber(destination, value) {
	        _super.call(this, destination);
	        this.value = value;
	    }
	    MapToSubscriber.prototype._next = function (x) {
	        this.destination.next(this.value);
	    };
	    return MapToSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var materialize_1 = __webpack_require__(243);
	Observable_1.Observable.prototype.materialize = materialize_1.materialize;
	


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var Notification_1 = __webpack_require__(83);
	/**
	 * Represents all of the notifications from the source Observable as `next`
	 * emissions marked with their original types within {@link Notification}
	 * objects.
	 *
	 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
	 * {@link Notification} objects, emitted as `next` on the output Observable.
	 * </span>
	 *
	 * <img src="./img/materialize.png" width="100%">
	 *
	 * `materialize` returns an Observable that emits a `next` notification for each
	 * `next`, `error`, or `complete` emission of the source Observable. When the
	 * source Observable emits `complete`, the output Observable will emit `next` as
	 * a Notification of type "complete", and then it will emit `complete` as well.
	 * When the source Observable emits `error`, the output will emit `next` as a
	 * Notification of type "error", and then `complete`.
	 *
	 * This operator is useful for producing metadata of the source Observable, to
	 * be consumed as `next` emissions. Use it in conjunction with
	 * {@link dematerialize}.
	 *
	 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
	 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
	 * var upperCase = letters.map(x => x.toUpperCase());
	 * var materialized = upperCase.materialize();
	 * materialized.subscribe(x => console.log(x));
	 *
	 * @see {@link Notification}
	 * @see {@link dematerialize}
	 *
	 * @return {Observable<Notification<T>>} An Observable that emits
	 * {@link Notification} objects that wrap the original emissions from the source
	 * Observable with metadata.
	 * @method materialize
	 * @owner Observable
	 */
	function materialize() {
	    return this.lift(new MaterializeOperator());
	}
	exports.materialize = materialize;
	var MaterializeOperator = (function () {
	    function MaterializeOperator() {
	    }
	    MaterializeOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new MaterializeSubscriber(subscriber));
	    };
	    return MaterializeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MaterializeSubscriber = (function (_super) {
	    __extends(MaterializeSubscriber, _super);
	    function MaterializeSubscriber(destination) {
	        _super.call(this, destination);
	    }
	    MaterializeSubscriber.prototype._next = function (value) {
	        this.destination.next(Notification_1.Notification.createNext(value));
	    };
	    MaterializeSubscriber.prototype._error = function (err) {
	        var destination = this.destination;
	        destination.next(Notification_1.Notification.createError(err));
	        destination.complete();
	    };
	    MaterializeSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        destination.next(Notification_1.Notification.createComplete());
	        destination.complete();
	    };
	    return MaterializeSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var max_1 = __webpack_require__(245);
	Observable_1.Observable.prototype.max = max_1.max;
	


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var reduce_1 = __webpack_require__(246);
	/**
	 * The Max operator operates on an Observable that emits numbers (or items that can be evaluated as numbers),
	 * and when source Observable completes it emits a single item: the item with the largest number.
	 *
	 * <img src="./img/max.png" width="100%">
	 *
	 * @param {Function} optional comparer function that it will use instead of its default to compare the value of two
	 * items.
	 * @return {Observable} an Observable that emits item with the largest number.
	 * @method max
	 * @owner Observable
	 */
	function max(comparer) {
	    var max = (typeof comparer === 'function')
	        ? comparer
	        : function (x, y) { return x > y ? x : y; };
	    return this.lift(new reduce_1.ReduceOperator(max));
	}
	exports.max = max;
	


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Applies an accumulator function over the source Observable, and returns the
	 * accumulated result when the source completes, given an optional seed value.
	 *
	 * <span class="informal">Combines together all values emitted on the source,
	 * using an accumulator function that knows how to join a new source value into
	 * the accumulation from the past.</span>
	 *
	 * <img src="./img/reduce.png" width="100%">
	 *
	 * Like
	 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
	 * `reduce` applies an `accumulator` function against an accumulation and each
	 * value of the source Observable (from the past) to reduce it to a single
	 * value, emitted on the output Observable. Note that `reduce` will only emit
	 * one value, only when the source Observable completes. It is equivalent to
	 * applying operator {@link scan} followed by operator {@link last}.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
	 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
	 *   .takeUntil(Rx.Observable.interval(5000));
	 * var ones = clicksInFiveSeconds.mapTo(1);
	 * var seed = 0;
	 * var count = ones.reduce((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link count}
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link scan}
	 *
	 * @param {function(acc: R, value: T): R} accumulator The accumulator function
	 * called on each source value.
	 * @param {R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @return {Observable<R>} An Observable that emits a single value that is the
	 * result of accumulating the values emitted by the source Observable.
	 * @method reduce
	 * @owner Observable
	 */
	function reduce(accumulator, seed) {
	    return this.lift(new ReduceOperator(accumulator, seed));
	}
	exports.reduce = reduce;
	var ReduceOperator = (function () {
	    function ReduceOperator(accumulator, seed) {
	        this.accumulator = accumulator;
	        this.seed = seed;
	    }
	    ReduceOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new ReduceSubscriber(subscriber, this.accumulator, this.seed));
	    };
	    return ReduceOperator;
	}());
	exports.ReduceOperator = ReduceOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ReduceSubscriber = (function (_super) {
	    __extends(ReduceSubscriber, _super);
	    function ReduceSubscriber(destination, accumulator, seed) {
	        _super.call(this, destination);
	        this.accumulator = accumulator;
	        this.hasValue = false;
	        this.acc = seed;
	        this.accumulator = accumulator;
	        this.hasSeed = typeof seed !== 'undefined';
	    }
	    ReduceSubscriber.prototype._next = function (value) {
	        if (this.hasValue || (this.hasValue = this.hasSeed)) {
	            this._tryReduce(value);
	        }
	        else {
	            this.acc = value;
	            this.hasValue = true;
	        }
	    };
	    ReduceSubscriber.prototype._tryReduce = function (value) {
	        var result;
	        try {
	            result = this.accumulator(this.acc, value);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.acc = result;
	    };
	    ReduceSubscriber.prototype._complete = function () {
	        if (this.hasValue || this.hasSeed) {
	            this.destination.next(this.acc);
	        }
	        this.destination.complete();
	    };
	    return ReduceSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ReduceSubscriber = ReduceSubscriber;
	


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var merge_1 = __webpack_require__(108);
	Observable_1.Observable.prototype.merge = merge_1.merge;
	


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var mergeAll_1 = __webpack_require__(67);
	Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
	


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var mergeMap_1 = __webpack_require__(171);
	Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
	Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
	


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var mergeMapTo_1 = __webpack_require__(174);
	Observable_1.Observable.prototype.flatMapTo = mergeMapTo_1.mergeMapTo;
	Observable_1.Observable.prototype.mergeMapTo = mergeMapTo_1.mergeMapTo;
	


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var mergeScan_1 = __webpack_require__(252);
	Observable_1.Observable.prototype.mergeScan = mergeScan_1.mergeScan;
	


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var subscribeToResult_1 = __webpack_require__(60);
	var OuterSubscriber_1 = __webpack_require__(59);
	/**
	 * @param project
	 * @param seed
	 * @param concurrent
	 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
	 * @method mergeScan
	 * @owner Observable
	 */
	function mergeScan(project, seed, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return this.lift(new MergeScanOperator(project, seed, concurrent));
	}
	exports.mergeScan = mergeScan;
	var MergeScanOperator = (function () {
	    function MergeScanOperator(project, seed, concurrent) {
	        this.project = project;
	        this.seed = seed;
	        this.concurrent = concurrent;
	    }
	    MergeScanOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new MergeScanSubscriber(subscriber, this.project, this.seed, this.concurrent));
	    };
	    return MergeScanOperator;
	}());
	exports.MergeScanOperator = MergeScanOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeScanSubscriber = (function (_super) {
	    __extends(MergeScanSubscriber, _super);
	    function MergeScanSubscriber(destination, project, acc, concurrent) {
	        _super.call(this, destination);
	        this.project = project;
	        this.acc = acc;
	        this.concurrent = concurrent;
	        this.hasValue = false;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeScanSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            var index = this.index++;
	            var ish = tryCatch_1.tryCatch(this.project)(this.acc, value);
	            var destination = this.destination;
	            if (ish === errorObject_1.errorObject) {
	                destination.error(errorObject_1.errorObject.e);
	            }
	            else {
	                this.active++;
	                this._innerSub(ish, value, index);
	            }
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeScanSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	    };
	    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var destination = this.destination;
	        this.acc = innerValue;
	        this.hasValue = true;
	        destination.next(innerValue);
	    };
	    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	    };
	    return MergeScanSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeScanSubscriber = MergeScanSubscriber;
	


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var min_1 = __webpack_require__(254);
	Observable_1.Observable.prototype.min = min_1.min;
	


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var reduce_1 = __webpack_require__(246);
	/**
	 * The Min operator operates on an Observable that emits numbers (or items that can be evaluated as numbers),
	 * and when source Observable completes it emits a single item: the item with the smallest number.
	 *
	 * <img src="./img/min.png" width="100%">
	 *
	 * @param {Function} optional comparer function that it will use instead of its default to compare the value of two items.
	 * @return {Observable<R>} an Observable that emits item with the smallest number.
	 * @method min
	 * @owner Observable
	 */
	function min(comparer) {
	    var min = (typeof comparer === 'function')
	        ? comparer
	        : function (x, y) { return x < y ? x : y; };
	    return this.lift(new reduce_1.ReduceOperator(min));
	}
	exports.min = min;
	


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var multicast_1 = __webpack_require__(256);
	Observable_1.Observable.prototype.multicast = multicast_1.multicast;
	


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var MulticastObservable_1 = __webpack_require__(257);
	var ConnectableObservable_1 = __webpack_require__(258);
	/**
	 * Returns an Observable that emits the results of invoking a specified selector on items
	 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
	 *
	 * <img src="./img/multicast.png" width="100%">
	 *
	 * @param {Function|Subject} Factory function to create an intermediate subject through
	 * which the source sequence's elements will be multicast to the selector function
	 * or Subject to push source elements into.
	 * @param {Function} Optional selector function that can use the multicasted source stream
	 * as many times as needed, without causing multiple subscriptions to the source stream.
	 * Subscribers to the given source will receive all notifications of the source from the
	 * time of the subscription forward.
	 * @return {Observable} an Observable that emits the results of invoking the selector
	 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
	 * the underlying stream.
	 * @method multicast
	 * @owner Observable
	 */
	function multicast(subjectOrSubjectFactory, selector) {
	    var subjectFactory;
	    if (typeof subjectOrSubjectFactory === 'function') {
	        subjectFactory = subjectOrSubjectFactory;
	    }
	    else {
	        subjectFactory = function subjectFactory() {
	            return subjectOrSubjectFactory;
	        };
	    }
	    return !selector ?
	        new ConnectableObservable_1.ConnectableObservable(this, subjectFactory) :
	        new MulticastObservable_1.MulticastObservable(this, subjectFactory, selector);
	}
	exports.multicast = multicast;
	


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var ConnectableObservable_1 = __webpack_require__(258);
	var MulticastObservable = (function (_super) {
	    __extends(MulticastObservable, _super);
	    function MulticastObservable(source, subjectFactory, selector) {
	        _super.call(this);
	        this.source = source;
	        this.subjectFactory = subjectFactory;
	        this.selector = selector;
	    }
	    MulticastObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, selector = _a.selector, source = _a.source;
	        var connectable = new ConnectableObservable_1.ConnectableObservable(source, this.subjectFactory);
	        var subscription = selector(connectable).subscribe(subscriber);
	        subscription.add(connectable.connect());
	        return subscription;
	    };
	    return MulticastObservable;
	}(Observable_1.Observable));
	exports.MulticastObservable = MulticastObservable;
	


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var Observable_1 = __webpack_require__(29);
	var Subscriber_1 = __webpack_require__(32);
	var Subscription_1 = __webpack_require__(34);
	/**
	 * @class ConnectableObservable<T>
	 */
	var ConnectableObservable = (function (_super) {
	    __extends(ConnectableObservable, _super);
	    function ConnectableObservable(source, subjectFactory) {
	        _super.call(this);
	        this.source = source;
	        this.subjectFactory = subjectFactory;
	        this._refCount = 0;
	    }
	    ConnectableObservable.prototype._subscribe = function (subscriber) {
	        return this.getSubject().subscribe(subscriber);
	    };
	    ConnectableObservable.prototype.getSubject = function () {
	        var subject = this._subject;
	        if (!subject || subject.isStopped) {
	            this._subject = this.subjectFactory();
	        }
	        return this._subject;
	    };
	    ConnectableObservable.prototype.connect = function () {
	        var connection = this._connection;
	        if (!connection) {
	            connection = this._connection = new Subscription_1.Subscription();
	            connection.add(this.source
	                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
	            if (connection.closed) {
	                this._connection = null;
	                connection = Subscription_1.Subscription.EMPTY;
	            }
	            else {
	                this._connection = connection;
	            }
	        }
	        return connection;
	    };
	    ConnectableObservable.prototype.refCount = function () {
	        return this.lift(new RefCountOperator(this));
	    };
	    return ConnectableObservable;
	}(Observable_1.Observable));
	exports.ConnectableObservable = ConnectableObservable;
	var ConnectableSubscriber = (function (_super) {
	    __extends(ConnectableSubscriber, _super);
	    function ConnectableSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    ConnectableSubscriber.prototype._error = function (err) {
	        this._unsubscribe();
	        _super.prototype._error.call(this, err);
	    };
	    ConnectableSubscriber.prototype._complete = function () {
	        this._unsubscribe();
	        _super.prototype._complete.call(this);
	    };
	    ConnectableSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (connectable) {
	            this.connectable = null;
	            var connection = connectable._connection;
	            connectable._refCount = 0;
	            connectable._subject = null;
	            connectable._connection = null;
	            if (connection) {
	                connection.unsubscribe();
	            }
	        }
	    };
	    return ConnectableSubscriber;
	}(Subject_1.SubjectSubscriber));
	var RefCountOperator = (function () {
	    function RefCountOperator(connectable) {
	        this.connectable = connectable;
	    }
	    RefCountOperator.prototype.call = function (subscriber, source) {
	        var connectable = this.connectable;
	        connectable._refCount++;
	        var refCounter = new RefCountSubscriber(subscriber, connectable);
	        var subscription = source._subscribe(refCounter);
	        if (!refCounter.closed) {
	            refCounter.connection = connectable.connect();
	        }
	        return subscription;
	    };
	    return RefCountOperator;
	}());
	var RefCountSubscriber = (function (_super) {
	    __extends(RefCountSubscriber, _super);
	    function RefCountSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    RefCountSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (!connectable) {
	            this.connection = null;
	            return;
	        }
	        this.connectable = null;
	        var refCount = connectable._refCount;
	        if (refCount <= 0) {
	            this.connection = null;
	            return;
	        }
	        connectable._refCount = refCount - 1;
	        if (refCount > 1) {
	            this.connection = null;
	            return;
	        }
	        ///
	        // Compare the local RefCountSubscriber's connection Subscription to the
	        // connection Subscription on the shared ConnectableObservable. In cases
	        // where the ConnectableObservable source synchronously emits values, and
	        // the RefCountSubscriber's dowstream Observers synchronously unsubscribe,
	        // execution continues to here before the RefCountOperator has a chance to
	        // supply the RefCountSubscriber with the shared connection Subscription.
	        // For example:
	        // ```
	        // Observable.range(0, 10)
	        //   .publish()
	        //   .refCount()
	        //   .take(5)
	        //   .subscribe();
	        // ```
	        // In order to account for this case, RefCountSubscriber should only dispose
	        // the ConnectableObservable's shared connection Subscription if the
	        // connection Subscription exists, *and* either:
	        //   a. RefCountSubscriber doesn't have a reference to the shared connection
	        //      Subscription yet, or,
	        //   b. RefCountSubscriber's connection Subscription reference is identical
	        //      to the shared connection Subscription
	        ///
	        var connection = this.connection;
	        var sharedConnection = connectable._connection;
	        this.connection = null;
	        if (sharedConnection && (!connection || sharedConnection === connection)) {
	            sharedConnection.unsubscribe();
	        }
	    };
	    return RefCountSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var observeOn_1 = __webpack_require__(82);
	Observable_1.Observable.prototype.observeOn = observeOn_1.observeOn;
	


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var onErrorResumeNext_1 = __webpack_require__(118);
	Observable_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var pairwise_1 = __webpack_require__(262);
	Observable_1.Observable.prototype.pairwise = pairwise_1.pairwise;
	


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Groups pairs of consecutive emissions together and emits them as an array of
	 * two values.
	 *
	 * <span class="informal">Puts the current value and previous value together as
	 * an array, and emits that.</span>
	 *
	 * <img src="./img/pairwise.png" width="100%">
	 *
	 * The Nth emission from the source Observable will cause the output Observable
	 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
	 * pair. For this reason, `pairwise` emits on the second and subsequent
	 * emissions from the source Observable, but not on the first emission, because
	 * there is no previous value in that case.
	 *
	 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var pairs = clicks.pairwise();
	 * var distance = pairs.map(pair => {
	 *   var x0 = pair[0].clientX;
	 *   var y0 = pair[0].clientY;
	 *   var x1 = pair[1].clientX;
	 *   var y1 = pair[1].clientY;
	 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
	 * });
	 * distance.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 *
	 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
	 * consecutive values from the source Observable.
	 * @method pairwise
	 * @owner Observable
	 */
	function pairwise() {
	    return this.lift(new PairwiseOperator());
	}
	exports.pairwise = pairwise;
	var PairwiseOperator = (function () {
	    function PairwiseOperator() {
	    }
	    PairwiseOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new PairwiseSubscriber(subscriber));
	    };
	    return PairwiseOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var PairwiseSubscriber = (function (_super) {
	    __extends(PairwiseSubscriber, _super);
	    function PairwiseSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasPrev = false;
	    }
	    PairwiseSubscriber.prototype._next = function (value) {
	        if (this.hasPrev) {
	            this.destination.next([this.prev, value]);
	        }
	        else {
	            this.hasPrev = true;
	        }
	        this.prev = value;
	    };
	    return PairwiseSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var partition_1 = __webpack_require__(264);
	Observable_1.Observable.prototype.partition = partition_1.partition;
	


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var not_1 = __webpack_require__(265);
	var filter_1 = __webpack_require__(209);
	/**
	 * Splits the source Observable into two, one with values that satisfy a
	 * predicate, and another with values that don't satisfy the predicate.
	 *
	 * <span class="informal">It's like {@link filter}, but returns two Observables:
	 * one like the output of {@link filter}, and the other with values that did not
	 * pass the condition.</span>
	 *
	 * <img src="./img/partition.png" width="100%">
	 *
	 * `partition` outputs an array with two Observables that partition the values
	 * from the source Observable through the given `predicate` function. The first
	 * Observable in that array emits source values for which the predicate argument
	 * returns true. The second Observable emits source values for which the
	 * predicate returns false. The first behaves like {@link filter} and the second
	 * behaves like {@link filter} with the predicate negated.
	 *
	 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
	 * var clicksOnDivs = parts[0];
	 * var clicksElsewhere = parts[1];
	 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
	 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
	 *
	 * @see {@link filter}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted on the first Observable in the returned array, if
	 * `false` the value is emitted on the second Observable in the array. The
	 * `index` parameter is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
	 * with values that passed the predicate, and another with values that did not
	 * pass the predicate.
	 * @method partition
	 * @owner Observable
	 */
	function partition(predicate, thisArg) {
	    return [
	        filter_1.filter.call(this, predicate),
	        filter_1.filter.call(this, not_1.not(predicate, thisArg))
	    ];
	}
	exports.partition = partition;
	


/***/ }),
/* 265 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	function not(pred, thisArg) {
	    function notPred() {
	        return !(notPred.pred.apply(notPred.thisArg, arguments));
	    }
	    notPred.pred = pred;
	    notPred.thisArg = thisArg;
	    return notPred;
	}
	exports.not = not;
	


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var pluck_1 = __webpack_require__(267);
	Observable_1.Observable.prototype.pluck = pluck_1.pluck;
	


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var map_1 = __webpack_require__(239);
	/**
	 * Maps each source value (an object) to its specified nested property.
	 *
	 * <span class="informal">Like {@link map}, but meant only for picking one of
	 * the nested properties of every emitted object.</span>
	 *
	 * <img src="./img/pluck.png" width="100%">
	 *
	 * Given a list of strings describing a path to an object property, retrieves
	 * the value of a specified nested property from all values in the source
	 * Observable. If a property can't be resolved, it will return `undefined` for
	 * that value.
	 *
	 * @example <caption>Map every every click to the tagName of the clicked target element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var tagNames = clicks.pluck('target', 'tagName');
	 * tagNames.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {...string} properties The nested properties to pluck from each source
	 * value (an object).
	 * @return {Observable} Returns a new Observable of property values from the
	 * source values.
	 * @method pluck
	 * @owner Observable
	 */
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i - 0] = arguments[_i];
	    }
	    var length = properties.length;
	    if (length === 0) {
	        throw new Error('list of properties cannot be empty.');
	    }
	    return map_1.map.call(this, plucker(properties, length));
	}
	exports.pluck = pluck;
	function plucker(props, length) {
	    var mapper = function (x) {
	        var currentProp = x;
	        for (var i = 0; i < length; i++) {
	            var p = currentProp[props[i]];
	            if (typeof p !== 'undefined') {
	                currentProp = p;
	            }
	            else {
	                return undefined;
	            }
	        }
	        return currentProp;
	    };
	    return mapper;
	}
	


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var publish_1 = __webpack_require__(269);
	Observable_1.Observable.prototype.publish = publish_1.publish;
	


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Subject_1 = __webpack_require__(28);
	var multicast_1 = __webpack_require__(256);
	/**
	 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
	 * before it begins emitting items to those Observers that have subscribed to it.
	 *
	 * <img src="./img/publish.png" width="100%">
	 *
	 * @param {Function} Optional selector function which can use the multicasted source sequence as many times as needed,
	 * without causing multiple subscriptions to the source sequence.
	 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
	 * @return a ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
	 * @method publish
	 * @owner Observable
	 */
	function publish(selector) {
	    return selector ? multicast_1.multicast.call(this, function () { return new Subject_1.Subject(); }, selector) :
	        multicast_1.multicast.call(this, new Subject_1.Subject());
	}
	exports.publish = publish;
	


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var publishBehavior_1 = __webpack_require__(271);
	Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
	


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var BehaviorSubject_1 = __webpack_require__(272);
	var multicast_1 = __webpack_require__(256);
	/**
	 * @param value
	 * @return {ConnectableObservable<T>}
	 * @method publishBehavior
	 * @owner Observable
	 */
	function publishBehavior(value) {
	    return multicast_1.multicast.call(this, new BehaviorSubject_1.BehaviorSubject(value));
	}
	exports.publishBehavior = publishBehavior;
	


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var ObjectUnsubscribedError_1 = __webpack_require__(43);
	/**
	 * @class BehaviorSubject<T>
	 */
	var BehaviorSubject = (function (_super) {
	    __extends(BehaviorSubject, _super);
	    function BehaviorSubject(_value) {
	        _super.call(this);
	        this._value = _value;
	    }
	    Object.defineProperty(BehaviorSubject.prototype, "value", {
	        get: function () {
	            return this.getValue();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BehaviorSubject.prototype._subscribe = function (subscriber) {
	        var subscription = _super.prototype._subscribe.call(this, subscriber);
	        if (subscription && !subscription.closed) {
	            subscriber.next(this._value);
	        }
	        return subscription;
	    };
	    BehaviorSubject.prototype.getValue = function () {
	        if (this.hasError) {
	            throw this.thrownError;
	        }
	        else if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else {
	            return this._value;
	        }
	    };
	    BehaviorSubject.prototype.next = function (value) {
	        _super.prototype.next.call(this, this._value = value);
	    };
	    return BehaviorSubject;
	}(Subject_1.Subject));
	exports.BehaviorSubject = BehaviorSubject;
	


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var publishReplay_1 = __webpack_require__(274);
	Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
	


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ReplaySubject_1 = __webpack_require__(144);
	var multicast_1 = __webpack_require__(256);
	/**
	 * @param bufferSize
	 * @param windowTime
	 * @param scheduler
	 * @return {ConnectableObservable<T>}
	 * @method publishReplay
	 * @owner Observable
	 */
	function publishReplay(bufferSize, windowTime, scheduler) {
	    if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
	    if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
	    return multicast_1.multicast.call(this, new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler));
	}
	exports.publishReplay = publishReplay;
	


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var publishLast_1 = __webpack_require__(276);
	Observable_1.Observable.prototype.publishLast = publishLast_1.publishLast;
	


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var AsyncSubject_1 = __webpack_require__(48);
	var multicast_1 = __webpack_require__(256);
	/**
	 * @return {ConnectableObservable<T>}
	 * @method publishLast
	 * @owner Observable
	 */
	function publishLast() {
	    return multicast_1.multicast.call(this, new AsyncSubject_1.AsyncSubject());
	}
	exports.publishLast = publishLast;
	


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var race_1 = __webpack_require__(110);
	Observable_1.Observable.prototype.race = race_1.race;
	


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var reduce_1 = __webpack_require__(246);
	Observable_1.Observable.prototype.reduce = reduce_1.reduce;
	


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var repeat_1 = __webpack_require__(280);
	Observable_1.Observable.prototype.repeat = repeat_1.repeat;
	


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var EmptyObservable_1 = __webpack_require__(57);
	/**
	 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times,
	 * on a particular Scheduler.
	 *
	 * <img src="./img/repeat.png" width="100%">
	 *
	 * @param {Scheduler} [scheduler] the Scheduler to emit the items on.
	 * @param {number} [count] the number of times the source Observable items are repeated, a count of 0 will yield
	 * an empty Observable.
	 * @return {Observable} an Observable that repeats the stream of items emitted by the source Observable at most
	 * count times.
	 * @method repeat
	 * @owner Observable
	 */
	function repeat(count) {
	    if (count === void 0) { count = -1; }
	    if (count === 0) {
	        return new EmptyObservable_1.EmptyObservable();
	    }
	    else if (count < 0) {
	        return this.lift(new RepeatOperator(-1, this));
	    }
	    else {
	        return this.lift(new RepeatOperator(count - 1, this));
	    }
	}
	exports.repeat = repeat;
	var RepeatOperator = (function () {
	    function RepeatOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RepeatOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
	    };
	    return RepeatOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RepeatSubscriber = (function (_super) {
	    __extends(RepeatSubscriber, _super);
	    function RepeatSubscriber(destination, count, source) {
	        _super.call(this, destination);
	        this.count = count;
	        this.source = source;
	    }
	    RepeatSubscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.complete.call(this);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            this.unsubscribe();
	            this.isStopped = false;
	            this.closed = false;
	            source.subscribe(this);
	        }
	    };
	    return RepeatSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var retry_1 = __webpack_require__(282);
	Observable_1.Observable.prototype.retry = retry_1.retry;
	


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Returns an Observable that mirrors the source Observable, resubscribing to it if it calls `error` and the
	 * predicate returns true for that specific exception and retry count.
	 * If the source Observable calls `error`, this method will resubscribe to the source Observable for a maximum of
	 * count resubscriptions (given as a number parameter) rather than propagating the `error` call.
	 *
	 * <img src="./img/retry.png" width="100%">
	 *
	 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
	 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
	 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
	 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
	 * @param {number} number of retry attempts before failing.
	 * @return {Observable} the source Observable modified with the retry logic.
	 * @method retry
	 * @owner Observable
	 */
	function retry(count) {
	    if (count === void 0) { count = -1; }
	    return this.lift(new RetryOperator(count, this));
	}
	exports.retry = retry;
	var RetryOperator = (function () {
	    function RetryOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RetryOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new RetrySubscriber(subscriber, this.count, this.source));
	    };
	    return RetryOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RetrySubscriber = (function (_super) {
	    __extends(RetrySubscriber, _super);
	    function RetrySubscriber(destination, count, source) {
	        _super.call(this, destination);
	        this.count = count;
	        this.source = source;
	    }
	    RetrySubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.error.call(this, err);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            this.unsubscribe();
	            this.isStopped = false;
	            this.closed = false;
	            source.subscribe(this);
	        }
	    };
	    return RetrySubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var retryWhen_1 = __webpack_require__(284);
	Observable_1.Observable.prototype.retryWhen = retryWhen_1.retryWhen;
	


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Returns an Observable that emits the same values as the source observable with the exception of an `error`.
	 * An `error` will cause the emission of the Throwable that cause the error to the Observable returned from
	 * notificationHandler. If that Observable calls onComplete or `error` then retry will call `complete` or `error`
	 * on the child subscription. Otherwise, this Observable will resubscribe to the source observable, on a particular
	 * Scheduler.
	 *
	 * <img src="./img/retryWhen.png" width="100%">
	 *
	 * @param {notificationHandler} receives an Observable of notifications with which a user can `complete` or `error`,
	 * aborting the retry.
	 * @param {scheduler} the Scheduler on which to subscribe to the source Observable.
	 * @return {Observable} the source Observable modified with retry logic.
	 * @method retryWhen
	 * @owner Observable
	 */
	function retryWhen(notifier) {
	    return this.lift(new RetryWhenOperator(notifier, this));
	}
	exports.retryWhen = retryWhen;
	var RetryWhenOperator = (function () {
	    function RetryWhenOperator(notifier, source) {
	        this.notifier = notifier;
	        this.source = source;
	    }
	    RetryWhenOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
	    };
	    return RetryWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RetryWhenSubscriber = (function (_super) {
	    __extends(RetryWhenSubscriber, _super);
	    function RetryWhenSubscriber(destination, notifier, source) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.source = source;
	    }
	    RetryWhenSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var errors = this.errors;
	            var retries = this.retries;
	            var retriesSubscription = this.retriesSubscription;
	            if (!retries) {
	                errors = new Subject_1.Subject();
	                retries = tryCatch_1.tryCatch(this.notifier)(errors);
	                if (retries === errorObject_1.errorObject) {
	                    return _super.prototype.error.call(this, errorObject_1.errorObject.e);
	                }
	                retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
	            }
	            else {
	                this.errors = null;
	                this.retriesSubscription = null;
	            }
	            this.unsubscribe();
	            this.closed = false;
	            this.errors = errors;
	            this.retries = retries;
	            this.retriesSubscription = retriesSubscription;
	            errors.next(err);
	        }
	    };
	    RetryWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
	        if (errors) {
	            errors.unsubscribe();
	            this.errors = null;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = null;
	        }
	        this.retries = null;
	    };
	    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
	        this.errors = null;
	        this.retries = null;
	        this.retriesSubscription = null;
	        this.unsubscribe();
	        this.isStopped = false;
	        this.closed = false;
	        this.errors = errors;
	        this.retries = retries;
	        this.retriesSubscription = retriesSubscription;
	        this.source.subscribe(this);
	    };
	    return RetryWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var sample_1 = __webpack_require__(286);
	Observable_1.Observable.prototype.sample = sample_1.sample;
	


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Emits the most recently emitted value from the source Observable whenever
	 * another Observable, the `notifier`, emits.
	 *
	 * <span class="informal">It's like {@link sampleTime}, but samples whenever
	 * the `notifier` Observable emits something.</span>
	 *
	 * <img src="./img/sample.png" width="100%">
	 *
	 * Whenever the `notifier` Observable emits a value or completes, `sample`
	 * looks at the source Observable and emits whichever value it has most recently
	 * emitted since the previous sampling, unless the source has not emitted
	 * anything since the previous sampling. The `notifier` is subscribed to as soon
	 * as the output Observable is subscribed.
	 *
	 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = seconds.sample(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {Observable<any>} notifier The Observable to use for sampling the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable whenever the notifier Observable
	 * emits value or completes.
	 * @method sample
	 * @owner Observable
	 */
	function sample(notifier) {
	    return this.lift(new SampleOperator(notifier));
	}
	exports.sample = sample;
	var SampleOperator = (function () {
	    function SampleOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SampleOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SampleSubscriber(subscriber, this.notifier));
	    };
	    return SampleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SampleSubscriber = (function (_super) {
	    __extends(SampleSubscriber, _super);
	    function SampleSubscriber(destination, notifier) {
	        _super.call(this, destination);
	        this.hasValue = false;
	        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
	    }
	    SampleSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	    };
	    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.value);
	        }
	    };
	    return SampleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var sampleTime_1 = __webpack_require__(288);
	Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
	


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var async_1 = __webpack_require__(101);
	/**
	 * Emits the most recently emitted value from the source Observable within
	 * periodic time intervals.
	 *
	 * <span class="informal">Samples the source Observable at periodic time
	 * intervals, emitting what it samples.</span>
	 *
	 * <img src="./img/sampleTime.png" width="100%">
	 *
	 * `sampleTime` periodically looks at the source Observable and emits whichever
	 * value it has most recently emitted since the previous sampling, unless the
	 * source has not emitted anything since the previous sampling. The sampling
	 * happens periodically in time every `period` milliseconds (or the time unit
	 * defined by the optional `scheduler` argument). The sampling starts as soon as
	 * the output Observable is subscribed.
	 *
	 * @example <caption>Every second, emit the most recent click at most once</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.sampleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {number} period The sampling period expressed in milliseconds or the
	 * time unit determined internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link Scheduler} to use for
	 * managing the timers that handle the sampling.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable at the specified time interval.
	 * @method sampleTime
	 * @owner Observable
	 */
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return this.lift(new SampleTimeOperator(period, scheduler));
	}
	exports.sampleTime = sampleTime;
	var SampleTimeOperator = (function () {
	    function SampleTimeOperator(period, scheduler) {
	        this.period = period;
	        this.scheduler = scheduler;
	    }
	    SampleTimeOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
	    };
	    return SampleTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SampleTimeSubscriber = (function (_super) {
	    __extends(SampleTimeSubscriber, _super);
	    function SampleTimeSubscriber(destination, period, scheduler) {
	        _super.call(this, destination);
	        this.period = period;
	        this.scheduler = scheduler;
	        this.hasValue = false;
	        this.add(scheduler.schedule(dispatchNotification, period, { subscriber: this, period: period }));
	    }
	    SampleTimeSubscriber.prototype._next = function (value) {
	        this.lastValue = value;
	        this.hasValue = true;
	    };
	    SampleTimeSubscriber.prototype.notifyNext = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.lastValue);
	        }
	    };
	    return SampleTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNotification(state) {
	    var subscriber = state.subscriber, period = state.period;
	    subscriber.notifyNext();
	    this.schedule(state, period);
	}
	


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var scan_1 = __webpack_require__(290);
	Observable_1.Observable.prototype.scan = scan_1.scan;
	


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Applies an accumulator function over the source Observable, and returns each
	 * intermediate result, with an optional seed value.
	 *
	 * <span class="informal">It's like {@link reduce}, but emits the current
	 * accumulation whenever the source emits a value.</span>
	 *
	 * <img src="./img/scan.png" width="100%">
	 *
	 * Combines together all values emitted on the source, using an accumulator
	 * function that knows how to join a new source value into the accumulation from
	 * the past. Is similar to {@link reduce}, but emits the intermediate
	 * accumulations.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var ones = clicks.mapTo(1);
	 * var seed = 0;
	 * var count = ones.scan((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link reduce}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator
	 * The accumulator function called on each source value.
	 * @param {T|R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method scan
	 * @owner Observable
	 */
	function scan(accumulator, seed) {
	    return this.lift(new ScanOperator(accumulator, seed));
	}
	exports.scan = scan;
	var ScanOperator = (function () {
	    function ScanOperator(accumulator, seed) {
	        this.accumulator = accumulator;
	        this.seed = seed;
	    }
	    ScanOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed));
	    };
	    return ScanOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ScanSubscriber = (function (_super) {
	    __extends(ScanSubscriber, _super);
	    function ScanSubscriber(destination, accumulator, seed) {
	        _super.call(this, destination);
	        this.accumulator = accumulator;
	        this.index = 0;
	        this.accumulatorSet = false;
	        this.seed = seed;
	        this.accumulatorSet = typeof seed !== 'undefined';
	    }
	    Object.defineProperty(ScanSubscriber.prototype, "seed", {
	        get: function () {
	            return this._seed;
	        },
	        set: function (value) {
	            this.accumulatorSet = true;
	            this._seed = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScanSubscriber.prototype._next = function (value) {
	        if (!this.accumulatorSet) {
	            this.seed = value;
	            this.destination.next(value);
	        }
	        else {
	            return this._tryNext(value);
	        }
	    };
	    ScanSubscriber.prototype._tryNext = function (value) {
	        var index = this.index++;
	        var result;
	        try {
	            result = this.accumulator(this.seed, value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	        this.seed = result;
	        this.destination.next(result);
	    };
	    return ScanSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var share_1 = __webpack_require__(292);
	Observable_1.Observable.prototype.share = share_1.share;
	


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var multicast_1 = __webpack_require__(256);
	var Subject_1 = __webpack_require__(28);
	function shareSubjectFactory() {
	    return new Subject_1.Subject();
	}
	/**
	 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
	 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
	 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
	 * This is an alias for .publish().refCount().
	 *
	 * <img src="./img/share.png" width="100%">
	 *
	 * @return {Observable<T>} an Observable that upon connection causes the source Observable to emit items to its Observers
	 * @method share
	 * @owner Observable
	 */
	function share() {
	    return multicast_1.multicast.call(this, shareSubjectFactory).refCount();
	}
	exports.share = share;
	;
	


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var single_1 = __webpack_require__(294);
	Observable_1.Observable.prototype.single = single_1.single;
	


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var EmptyError_1 = __webpack_require__(218);
	/**
	 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
	 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
	 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
	 *
	 * <img src="./img/single.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {Function} a predicate function to evaluate items emitted by the source Observable.
	 * @return {Observable<T>} an Observable that emits the single item emitted by the source Observable that matches
	 * the predicate.
	 .
	 * @method single
	 * @owner Observable
	 */
	function single(predicate) {
	    return this.lift(new SingleOperator(predicate, this));
	}
	exports.single = single;
	var SingleOperator = (function () {
	    function SingleOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    SingleOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
	    };
	    return SingleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SingleSubscriber = (function (_super) {
	    __extends(SingleSubscriber, _super);
	    function SingleSubscriber(destination, predicate, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.seenValue = false;
	        this.index = 0;
	    }
	    SingleSubscriber.prototype.applySingleValue = function (value) {
	        if (this.seenValue) {
	            this.destination.error('Sequence contains more than one element');
	        }
	        else {
	            this.seenValue = true;
	            this.singleValue = value;
	        }
	    };
	    SingleSubscriber.prototype._next = function (value) {
	        var predicate = this.predicate;
	        this.index++;
	        if (predicate) {
	            this.tryNext(value);
	        }
	        else {
	            this.applySingleValue(value);
	        }
	    };
	    SingleSubscriber.prototype.tryNext = function (value) {
	        try {
	            var result = this.predicate(value, this.index, this.source);
	            if (result) {
	                this.applySingleValue(value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    SingleSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.index > 0) {
	            destination.next(this.seenValue ? this.singleValue : undefined);
	            destination.complete();
	        }
	        else {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return SingleSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var skip_1 = __webpack_require__(296);
	Observable_1.Observable.prototype.skip = skip_1.skip;
	


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Returns an Observable that skips `n` items emitted by an Observable.
	 *
	 * <img src="./img/skip.png" width="100%">
	 *
	 * @param {Number} the `n` of times, items emitted by source Observable should be skipped.
	 * @return {Observable} an Observable that skips values emitted by the source Observable.
	 *
	 * @method skip
	 * @owner Observable
	 */
	function skip(total) {
	    return this.lift(new SkipOperator(total));
	}
	exports.skip = skip;
	var SkipOperator = (function () {
	    function SkipOperator(total) {
	        this.total = total;
	    }
	    SkipOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SkipSubscriber(subscriber, this.total));
	    };
	    return SkipOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipSubscriber = (function (_super) {
	    __extends(SkipSubscriber, _super);
	    function SkipSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.count = 0;
	    }
	    SkipSubscriber.prototype._next = function (x) {
	        if (++this.count > this.total) {
	            this.destination.next(x);
	        }
	    };
	    return SkipSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var skipUntil_1 = __webpack_require__(298);
	Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
	


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
	 *
	 * <img src="./img/skipUntil.png" width="100%">
	 *
	 * @param {Observable} the second Observable that has to emit an item before the source Observable's elements begin to
	 * be mirrored by the resulting Observable.
	 * @return {Observable<T>} an Observable that skips items from the source Observable until the second Observable emits
	 * an item, then emits the remaining items.
	 * @method skipUntil
	 * @owner Observable
	 */
	function skipUntil(notifier) {
	    return this.lift(new SkipUntilOperator(notifier));
	}
	exports.skipUntil = skipUntil;
	var SkipUntilOperator = (function () {
	    function SkipUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SkipUntilOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SkipUntilSubscriber(subscriber, this.notifier));
	    };
	    return SkipUntilOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipUntilSubscriber = (function (_super) {
	    __extends(SkipUntilSubscriber, _super);
	    function SkipUntilSubscriber(destination, notifier) {
	        _super.call(this, destination);
	        this.hasValue = false;
	        this.isInnerStopped = false;
	        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
	    }
	    SkipUntilSubscriber.prototype._next = function (value) {
	        if (this.hasValue) {
	            _super.prototype._next.call(this, value);
	        }
	    };
	    SkipUntilSubscriber.prototype._complete = function () {
	        if (this.isInnerStopped) {
	            _super.prototype._complete.call(this);
	        }
	        else {
	            this.unsubscribe();
	        }
	    };
	    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.hasValue = true;
	    };
	    SkipUntilSubscriber.prototype.notifyComplete = function () {
	        this.isInnerStopped = true;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    return SkipUntilSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var skipWhile_1 = __webpack_require__(300);
	Observable_1.Observable.prototype.skipWhile = skipWhile_1.skipWhile;
	


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
	 * true, but emits all further source items as soon as the condition becomes false.
	 *
	 * <img src="./img/skipWhile.png" width="100%">
	 *
	 * @param {Function} predicate - a function to test each item emitted from the source Observable.
	 * @return {Observable<T>} an Observable that begins emitting items emitted by the source Observable when the
	 * specified predicate becomes false.
	 * @method skipWhile
	 * @owner Observable
	 */
	function skipWhile(predicate) {
	    return this.lift(new SkipWhileOperator(predicate));
	}
	exports.skipWhile = skipWhile;
	var SkipWhileOperator = (function () {
	    function SkipWhileOperator(predicate) {
	        this.predicate = predicate;
	    }
	    SkipWhileOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
	    };
	    return SkipWhileOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipWhileSubscriber = (function (_super) {
	    __extends(SkipWhileSubscriber, _super);
	    function SkipWhileSubscriber(destination, predicate) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.skipping = true;
	        this.index = 0;
	    }
	    SkipWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (this.skipping) {
	            this.tryCallPredicate(value);
	        }
	        if (!this.skipping) {
	            destination.next(value);
	        }
	    };
	    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
	        try {
	            var result = this.predicate(value, this.index++);
	            this.skipping = Boolean(result);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    return SkipWhileSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var startWith_1 = __webpack_require__(302);
	Observable_1.Observable.prototype.startWith = startWith_1.startWith;
	


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ArrayObservable_1 = __webpack_require__(55);
	var ScalarObservable_1 = __webpack_require__(56);
	var EmptyObservable_1 = __webpack_require__(57);
	var concat_1 = __webpack_require__(66);
	var isScheduler_1 = __webpack_require__(54);
	/**
	 * Returns an Observable that emits the items in a specified Iterable before it begins to emit items emitted by the
	 * source Observable.
	 *
	 * <img src="./img/startWith.png" width="100%">
	 *
	 * @param {Values} an Iterable that contains the items you want the modified Observable to emit first.
	 * @return {Observable} an Observable that emits the items in the specified Iterable and then emits the items
	 * emitted by the source Observable.
	 * @method startWith
	 * @owner Observable
	 */
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i - 0] = arguments[_i];
	    }
	    var scheduler = array[array.length - 1];
	    if (isScheduler_1.isScheduler(scheduler)) {
	        array.pop();
	    }
	    else {
	        scheduler = null;
	    }
	    var len = array.length;
	    if (len === 1) {
	        return concat_1.concatStatic(new ScalarObservable_1.ScalarObservable(array[0], scheduler), this);
	    }
	    else if (len > 1) {
	        return concat_1.concatStatic(new ArrayObservable_1.ArrayObservable(array, scheduler), this);
	    }
	    else {
	        return concat_1.concatStatic(new EmptyObservable_1.EmptyObservable(scheduler), this);
	    }
	}
	exports.startWith = startWith;
	


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var subscribeOn_1 = __webpack_require__(304);
	Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
	


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var SubscribeOnObservable_1 = __webpack_require__(305);
	/**
	 * Asynchronously subscribes Observers to this Observable on the specified Scheduler.
	 *
	 * <img src="./img/subscribeOn.png" width="100%">
	 *
	 * @param {Scheduler} the Scheduler to perform subscription actions on.
	 * @return {Observable<T>} the source Observable modified so that its subscriptions happen on the specified Scheduler
	 .
	 * @method subscribeOn
	 * @owner Observable
	 */
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return new SubscribeOnObservable_1.SubscribeOnObservable(this, delay, scheduler);
	}
	exports.subscribeOn = subscribeOn;
	


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var asap_1 = __webpack_require__(306);
	var isNumeric_1 = __webpack_require__(100);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var SubscribeOnObservable = (function (_super) {
	    __extends(SubscribeOnObservable, _super);
	    function SubscribeOnObservable(source, delayTime, scheduler) {
	        if (delayTime === void 0) { delayTime = 0; }
	        if (scheduler === void 0) { scheduler = asap_1.asap; }
	        _super.call(this);
	        this.source = source;
	        this.delayTime = delayTime;
	        this.scheduler = scheduler;
	        if (!isNumeric_1.isNumeric(delayTime) || delayTime < 0) {
	            this.delayTime = 0;
	        }
	        if (!scheduler || typeof scheduler.schedule !== 'function') {
	            this.scheduler = asap_1.asap;
	        }
	    }
	    SubscribeOnObservable.create = function (source, delay, scheduler) {
	        if (delay === void 0) { delay = 0; }
	        if (scheduler === void 0) { scheduler = asap_1.asap; }
	        return new SubscribeOnObservable(source, delay, scheduler);
	    };
	    SubscribeOnObservable.dispatch = function (arg) {
	        var source = arg.source, subscriber = arg.subscriber;
	        return source.subscribe(subscriber);
	    };
	    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
	        var delay = this.delayTime;
	        var source = this.source;
	        var scheduler = this.scheduler;
	        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
	            source: source, subscriber: subscriber
	        });
	    };
	    return SubscribeOnObservable;
	}(Observable_1.Observable));
	exports.SubscribeOnObservable = SubscribeOnObservable;
	


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var AsapAction_1 = __webpack_require__(307);
	var AsapScheduler_1 = __webpack_require__(312);
	exports.asap = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
	


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Immediate_1 = __webpack_require__(308);
	var AsyncAction_1 = __webpack_require__(102);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AsapAction = (function (_super) {
	    __extends(AsapAction, _super);
	    function AsapAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay is greater than 0, request as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Push the action to the end of the scheduler queue.
	        scheduler.actions.push(this);
	        // If a microtask has already been scheduled, don't schedule another
	        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
	        // the current scheduled microtask id.
	        return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
	    };
	    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, recycle as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        // If the scheduler queue is empty, cancel the requested microtask and
	        // set the scheduled flag to undefined so the next AsapAction will schedule
	        // its own.
	        if (scheduler.actions.length === 0) {
	            Immediate_1.Immediate.clearImmediate(id);
	            scheduler.scheduled = undefined;
	        }
	        // Return undefined so the action knows to request a new async id if it's rescheduled.
	        return undefined;
	    };
	    return AsapAction;
	}(AsyncAction_1.AsyncAction));
	exports.AsapAction = AsapAction;
	


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(clearImmediate, setImmediate) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/**
	Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
	*/
	"use strict";
	var root_1 = __webpack_require__(30);
	var ImmediateDefinition = (function () {
	    function ImmediateDefinition(root) {
	        this.root = root;
	        if (root.setImmediate && typeof root.setImmediate === 'function') {
	            this.setImmediate = root.setImmediate.bind(root);
	            this.clearImmediate = root.clearImmediate.bind(root);
	        }
	        else {
	            this.nextHandle = 1;
	            this.tasksByHandle = {};
	            this.currentlyRunningATask = false;
	            // Don't get fooled by e.g. browserify environments.
	            if (this.canUseProcessNextTick()) {
	                // For Node.js before 0.9
	                this.setImmediate = this.createProcessNextTickSetImmediate();
	            }
	            else if (this.canUsePostMessage()) {
	                // For non-IE10 modern browsers
	                this.setImmediate = this.createPostMessageSetImmediate();
	            }
	            else if (this.canUseMessageChannel()) {
	                // For web workers, where supported
	                this.setImmediate = this.createMessageChannelSetImmediate();
	            }
	            else if (this.canUseReadyStateChange()) {
	                // For IE 6–8
	                this.setImmediate = this.createReadyStateChangeSetImmediate();
	            }
	            else {
	                // For older browsers
	                this.setImmediate = this.createSetTimeoutSetImmediate();
	            }
	            var ci = function clearImmediate(handle) {
	                delete clearImmediate.instance.tasksByHandle[handle];
	            };
	            ci.instance = this;
	            this.clearImmediate = ci;
	        }
	    }
	    ImmediateDefinition.prototype.identify = function (o) {
	        return this.root.Object.prototype.toString.call(o);
	    };
	    ImmediateDefinition.prototype.canUseProcessNextTick = function () {
	        return this.identify(this.root.process) === '[object process]';
	    };
	    ImmediateDefinition.prototype.canUseMessageChannel = function () {
	        return Boolean(this.root.MessageChannel);
	    };
	    ImmediateDefinition.prototype.canUseReadyStateChange = function () {
	        var document = this.root.document;
	        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
	    };
	    ImmediateDefinition.prototype.canUsePostMessage = function () {
	        var root = this.root;
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `root.postMessage` means something completely different and can't be used for this purpose.
	        if (root.postMessage && !root.importScripts) {
	            var postMessageIsAsynchronous_1 = true;
	            var oldOnMessage = root.onmessage;
	            root.onmessage = function () {
	                postMessageIsAsynchronous_1 = false;
	            };
	            root.postMessage('', '*');
	            root.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous_1;
	        }
	        return false;
	    };
	    // This function accepts the same arguments as setImmediate, but
	    // returns a function that requires no arguments.
	    ImmediateDefinition.prototype.partiallyApplied = function (handler) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var fn = function result() {
	            var _a = result, handler = _a.handler, args = _a.args;
	            if (typeof handler === 'function') {
	                handler.apply(undefined, args);
	            }
	            else {
	                (new Function('' + handler))();
	            }
	        };
	        fn.handler = handler;
	        fn.args = args;
	        return fn;
	    };
	    ImmediateDefinition.prototype.addFromSetImmediateArguments = function (args) {
	        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
	        return this.nextHandle++;
	    };
	    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createPostMessageSetImmediate = function () {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	        var root = this.root;
	        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
	        var onGlobalMessage = function globalMessageHandler(event) {
	            var instance = globalMessageHandler.instance;
	            if (event.source === root &&
	                typeof event.data === 'string' &&
	                event.data.indexOf(messagePrefix) === 0) {
	                instance.runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	        onGlobalMessage.instance = this;
	        root.addEventListener('message', onGlobalMessage, false);
	        var fn = function setImmediate() {
	            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.postMessage(messagePrefix + handle, '*');
	            return handle;
	        };
	        fn.instance = this;
	        fn.messagePrefix = messagePrefix;
	        return fn;
	    };
	    ImmediateDefinition.prototype.runIfPresent = function (handle) {
	        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (this.currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // 'too much recursion' error.
	            this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
	        }
	        else {
	            var task = this.tasksByHandle[handle];
	            if (task) {
	                this.currentlyRunningATask = true;
	                try {
	                    task();
	                }
	                finally {
	                    this.clearImmediate(handle);
	                    this.currentlyRunningATask = false;
	                }
	            }
	        }
	    };
	    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function () {
	        var _this = this;
	        var channel = new this.root.MessageChannel();
	        channel.port1.onmessage = function (event) {
	            var handle = event.data;
	            _this.runIfPresent(handle);
	        };
	        var fn = function setImmediate() {
	            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            channel.port2.postMessage(handle);
	            return handle;
	        };
	        fn.channel = channel;
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var root = instance.root;
	            var doc = root.document;
	            var html = doc.documentElement;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement('script');
	            script.onreadystatechange = function () {
	                instance.runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    return ImmediateDefinition;
	}());
	exports.ImmediateDefinition = ImmediateDefinition;
	exports.Immediate = new ImmediateDefinition(root_1.root);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(309).clearImmediate, __webpack_require__(309).setImmediate))

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(310);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(311)))

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(104);
	var AsapScheduler = (function (_super) {
	    __extends(AsapScheduler, _super);
	    function AsapScheduler() {
	        _super.apply(this, arguments);
	    }
	    AsapScheduler.prototype.flush = function () {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        var action = actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsapScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AsapScheduler = AsapScheduler;
	


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var switch_1 = __webpack_require__(314);
	Observable_1.Observable.prototype.switch = switch_1._switch;
	


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * subscribing to only the most recently emitted of those inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * previous inner Observable once a new one appears.</span>
	 *
	 * <img src="./img/switch.png" width="100%">
	 *
	 * `switch` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable subscribes to the inner Observable and
	 * begins emitting the items emitted by that. So far, it behaves
	 * like {@link mergeAll}. However, when a new inner Observable is emitted,
	 * `switch` unsubscribes from the earlier-emitted inner Observable and
	 * subscribes to the new inner Observable and begins emitting items from it. It
	 * continues to behave like this for subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * // Each click event is mapped to an Observable that ticks every second
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var switched = higherOrder.switch();
	 * // The outcome is that `switched` is essentially a timer that restarts
	 * // on every click. The interval Observables from older clicks do not merge
	 * // with the current interval Observable.
	 * switched.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switchMap}
	 * @see {@link switchMapTo}
	 * @see {@link zipAll}
	 *
	 * @return {Observable<T>} An Observable that emits the items emitted by the
	 * Observable most recently emitted by the source Observable.
	 * @method switch
	 * @name switch
	 * @owner Observable
	 */
	function _switch() {
	    return this.lift(new SwitchOperator());
	}
	exports._switch = _switch;
	var SwitchOperator = (function () {
	    function SwitchOperator() {
	    }
	    SwitchOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SwitchSubscriber(subscriber));
	    };
	    return SwitchOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchSubscriber = (function (_super) {
	    __extends(SwitchSubscriber, _super);
	    function SwitchSubscriber(destination) {
	        _super.call(this, destination);
	        this.active = 0;
	        this.hasCompleted = false;
	    }
	    SwitchSubscriber.prototype._next = function (value) {
	        this.unsubscribeInner();
	        this.active++;
	        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, value));
	    };
	    SwitchSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    SwitchSubscriber.prototype.unsubscribeInner = function () {
	        this.active = this.active > 0 ? this.active - 1 : 0;
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	            this.remove(innerSubscription);
	        }
	    };
	    SwitchSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(innerValue);
	    };
	    SwitchSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    SwitchSubscriber.prototype.notifyComplete = function () {
	        this.unsubscribeInner();
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    return SwitchSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var switchMap_1 = __webpack_require__(316);
	Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
	


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, emitting values only from the most recently projected Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link switch}.</span>
	 *
	 * <img src="./img/switchMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each time it observes one of these
	 * inner Observables, the output Observable begins emitting the items emitted by
	 * that inner Observable. When a new inner Observable is emitted, `switchMap`
	 * stops emitting items from the earlier-emitted inner Observable and begins
	 * emitting items from the new one. It continues to behave like this for
	 * subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switch}
	 * @see {@link switchMapTo}
	 *
	 * @param {function(value: T, ?index: number): Observable} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking only the values from the most recently
	 * projected inner Observable.
	 * @method switchMap
	 * @owner Observable
	 */
	function switchMap(project, resultSelector) {
	    return this.lift(new SwitchMapOperator(project, resultSelector));
	}
	exports.switchMap = switchMap;
	var SwitchMapOperator = (function () {
	    function SwitchMapOperator(project, resultSelector) {
	        this.project = project;
	        this.resultSelector = resultSelector;
	    }
	    SwitchMapOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
	    };
	    return SwitchMapOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchMapSubscriber = (function (_super) {
	    __extends(SwitchMapSubscriber, _super);
	    function SwitchMapSubscriber(destination, project, resultSelector) {
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.index = 0;
	    }
	    SwitchMapSubscriber.prototype._next = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (error) {
	            this.destination.error(error);
	            return;
	        }
	        this._innerSub(result, value, index);
	    };
	    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
	    };
	    SwitchMapSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = null;
	    };
	    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.innerSubscription = null;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return SwitchMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var switchMapTo_1 = __webpack_require__(318);
	Observable_1.Observable.prototype.switchMapTo = switchMapTo_1.switchMapTo;
	


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Projects each source value to the same Observable which is flattened multiple
	 * times with {@link switch} in the output Observable.
	 *
	 * <span class="informal">It's like {@link switchMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/switchMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. The output Observables
	 * emits values only from the most recently emitted instance of
	 * `innerObservable`.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link switch}
	 * @see {@link switchMap}
	 * @see {@link mergeMapTo}
	 *
	 * @param {Observable} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` every time a value is emitted on the source Observable.
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable, and taking only the values
	 * from the most recently projected inner Observable.
	 * @method switchMapTo
	 * @owner Observable
	 */
	function switchMapTo(innerObservable, resultSelector) {
	    return this.lift(new SwitchMapToOperator(innerObservable, resultSelector));
	}
	exports.switchMapTo = switchMapTo;
	var SwitchMapToOperator = (function () {
	    function SwitchMapToOperator(observable, resultSelector) {
	        this.observable = observable;
	        this.resultSelector = resultSelector;
	    }
	    SwitchMapToOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
	    };
	    return SwitchMapToOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchMapToSubscriber = (function (_super) {
	    __extends(SwitchMapToSubscriber, _super);
	    function SwitchMapToSubscriber(destination, inner, resultSelector) {
	        _super.call(this, destination);
	        this.inner = inner;
	        this.resultSelector = resultSelector;
	        this.index = 0;
	    }
	    SwitchMapToSubscriber.prototype._next = function (value) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, this.inner, value, this.index++));
	    };
	    SwitchMapToSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapToSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = null;
	    };
	    SwitchMapToSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.innerSubscription = null;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    SwitchMapToSubscriber.prototype.tryResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        var result;
	        try {
	            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        destination.next(result);
	    };
	    return SwitchMapToSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var take_1 = __webpack_require__(320);
	Observable_1.Observable.prototype.take = take_1.take;
	


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var ArgumentOutOfRangeError_1 = __webpack_require__(207);
	var EmptyObservable_1 = __webpack_require__(57);
	/**
	 * Emits only the first `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Takes the first `count` values from the source, then
	 * completes.</span>
	 *
	 * <img src="./img/take.png" width="100%">
	 *
	 * `take` returns an Observable that emits only the first `count` values emitted
	 * by the source Observable. If the source emits fewer than `count` values then
	 * all of its values are emitted. After that, it completes, regardless if the
	 * source completes.
	 *
	 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var five = interval.take(5);
	 * five.subscribe(x => console.log(x));
	 *
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of `next` values to emit.
	 * @return {Observable<T>} An Observable that emits only the first `count`
	 * values emitted by the source Observable, or all of the values from the source
	 * if the source emits fewer than `count` values.
	 * @method take
	 * @owner Observable
	 */
	function take(count) {
	    if (count === 0) {
	        return new EmptyObservable_1.EmptyObservable();
	    }
	    else {
	        return this.lift(new TakeOperator(count));
	    }
	}
	exports.take = take;
	var TakeOperator = (function () {
	    function TakeOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    TakeOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new TakeSubscriber(subscriber, this.total));
	    };
	    return TakeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeSubscriber = (function (_super) {
	    __extends(TakeSubscriber, _super);
	    function TakeSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.count = 0;
	    }
	    TakeSubscriber.prototype._next = function (value) {
	        var total = this.total;
	        if (++this.count <= total) {
	            this.destination.next(value);
	            if (this.count === total) {
	                this.destination.complete();
	                this.unsubscribe();
	            }
	        }
	    };
	    return TakeSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var takeLast_1 = __webpack_require__(322);
	Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
	


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var ArgumentOutOfRangeError_1 = __webpack_require__(207);
	var EmptyObservable_1 = __webpack_require__(57);
	/**
	 * Emits only the last `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Remembers the latest `count` values, then emits those
	 * only when the source completes.</span>
	 *
	 * <img src="./img/takeLast.png" width="100%">
	 *
	 * `takeLast` returns an Observable that emits at most the last `count` values
	 * emitted by the source Observable. If the source emits fewer than `count`
	 * values then all of its values are emitted. This operator must wait until the
	 * `complete` notification emission from the source in order to emit the `next`
	 * values on the output Observable, because otherwise it is impossible to know
	 * whether or not more values will be emitted on the source. For this reason,
	 * all values are emitted synchronously, followed by the complete notification.
	 *
	 * @example <caption>Take the last 3 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 100);
	 * var lastThree = many.takeLast(3);
	 * lastThree.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of values to emit from the end of
	 * the sequence of values emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits at most the last count
	 * values emitted by the source Observable.
	 * @method takeLast
	 * @owner Observable
	 */
	function takeLast(count) {
	    if (count === 0) {
	        return new EmptyObservable_1.EmptyObservable();
	    }
	    else {
	        return this.lift(new TakeLastOperator(count));
	    }
	}
	exports.takeLast = takeLast;
	var TakeLastOperator = (function () {
	    function TakeLastOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    TakeLastOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new TakeLastSubscriber(subscriber, this.total));
	    };
	    return TakeLastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeLastSubscriber = (function (_super) {
	    __extends(TakeLastSubscriber, _super);
	    function TakeLastSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.ring = new Array();
	        this.count = 0;
	    }
	    TakeLastSubscriber.prototype._next = function (value) {
	        var ring = this.ring;
	        var total = this.total;
	        var count = this.count++;
	        if (ring.length < total) {
	            ring.push(value);
	        }
	        else {
	            var index = count % total;
	            ring[index] = value;
	        }
	    };
	    TakeLastSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        var count = this.count;
	        if (count > 0) {
	            var total = this.count >= this.total ? this.total : this.count;
	            var ring = this.ring;
	            for (var i = 0; i < total; i++) {
	                var idx = (count++) % total;
	                destination.next(ring[idx]);
	            }
	        }
	        destination.complete();
	    };
	    return TakeLastSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var takeUntil_1 = __webpack_require__(324);
	Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
	


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Emits the values emitted by the source Observable until a `notifier`
	 * Observable emits a value.
	 *
	 * <span class="informal">Lets values pass until a second Observable,
	 * `notifier`, emits something. Then, it completes.</span>
	 *
	 * <img src="./img/takeUntil.png" width="100%">
	 *
	 * `takeUntil` subscribes and begins mirroring the source Observable. It also
	 * monitors a second Observable, `notifier` that you provide. If the `notifier`
	 * emits a value or a complete notification, the output Observable stops
	 * mirroring the source Observable and completes.
	 *
	 * @example <caption>Tick every second until the first click happens</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = interval.takeUntil(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @param {Observable} notifier The Observable whose first emitted value will
	 * cause the output Observable of `takeUntil` to stop emitting values from the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable until such time as `notifier` emits its first value.
	 * @method takeUntil
	 * @owner Observable
	 */
	function takeUntil(notifier) {
	    return this.lift(new TakeUntilOperator(notifier));
	}
	exports.takeUntil = takeUntil;
	var TakeUntilOperator = (function () {
	    function TakeUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    TakeUntilOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
	    };
	    return TakeUntilOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeUntilSubscriber = (function (_super) {
	    __extends(TakeUntilSubscriber, _super);
	    function TakeUntilSubscriber(destination, notifier) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
	    }
	    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.complete();
	    };
	    TakeUntilSubscriber.prototype.notifyComplete = function () {
	        // noop
	    };
	    return TakeUntilSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var takeWhile_1 = __webpack_require__(326);
	Observable_1.Observable.prototype.takeWhile = takeWhile_1.takeWhile;
	


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Emits values emitted by the source Observable so long as each value satisfies
	 * the given `predicate`, and then completes as soon as this `predicate` is not
	 * satisfied.
	 *
	 * <span class="informal">Takes values from the source only while they pass the
	 * condition given. When the first value does not satisfy, it completes.</span>
	 *
	 * <img src="./img/takeWhile.png" width="100%">
	 *
	 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
	 * emitted on the source is given to the `predicate` function which returns a
	 * boolean, representing a condition to be satisfied by the source values. The
	 * output Observable emits the source values until such time as the `predicate`
	 * returns false, at which point `takeWhile` stops mirroring the source
	 * Observable and completes the output Observable.
	 *
	 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.takeWhile(ev => ev.clientX > 200);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates a value emitted by the source Observable and returns a boolean.
	 * Also takes the (zero-based) index as the second argument.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable so long as each value satisfies the condition defined by the
	 * `predicate`, then completes.
	 * @method takeWhile
	 * @owner Observable
	 */
	function takeWhile(predicate) {
	    return this.lift(new TakeWhileOperator(predicate));
	}
	exports.takeWhile = takeWhile;
	var TakeWhileOperator = (function () {
	    function TakeWhileOperator(predicate) {
	        this.predicate = predicate;
	    }
	    TakeWhileOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new TakeWhileSubscriber(subscriber, this.predicate));
	    };
	    return TakeWhileOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeWhileSubscriber = (function (_super) {
	    __extends(TakeWhileSubscriber, _super);
	    function TakeWhileSubscriber(destination, predicate) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.index = 0;
	    }
	    TakeWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        var result;
	        try {
	            result = this.predicate(value, this.index++);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this.nextOrComplete(value, result);
	    };
	    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
	        var destination = this.destination;
	        if (Boolean(predicateResult)) {
	            destination.next(value);
	        }
	        else {
	            destination.complete();
	        }
	    };
	    return TakeWhileSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var throttle_1 = __webpack_require__(328);
	Observable_1.Observable.prototype.throttle = throttle_1.throttle;
	


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for a duration determined by another Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link throttleTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/throttle.png" width="100%">
	 *
	 * `throttle` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled by calling the `durationSelector` function with the source value,
	 * which returns the "duration" Observable. When the duration Observable emits a
	 * value or completes, the timer is disabled, and this process repeats for the
	 * next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {function(value: T): Observable|Promise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration for each source value, returned as an Observable or a Promise.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttle
	 * @owner Observable
	 */
	function throttle(durationSelector) {
	    return this.lift(new ThrottleOperator(durationSelector));
	}
	exports.throttle = throttle;
	var ThrottleOperator = (function () {
	    function ThrottleOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    ThrottleOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new ThrottleSubscriber(subscriber, this.durationSelector));
	    };
	    return ThrottleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ThrottleSubscriber = (function (_super) {
	    __extends(ThrottleSubscriber, _super);
	    function ThrottleSubscriber(destination, durationSelector) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.durationSelector = durationSelector;
	    }
	    ThrottleSubscriber.prototype._next = function (value) {
	        if (!this.throttled) {
	            this.tryDurationSelector(value);
	        }
	    };
	    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
	        var duration = null;
	        try {
	            duration = this.durationSelector(value);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.emitAndThrottle(value, duration);
	    };
	    ThrottleSubscriber.prototype.emitAndThrottle = function (value, duration) {
	        this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
	        this.destination.next(value);
	    };
	    ThrottleSubscriber.prototype._unsubscribe = function () {
	        var throttled = this.throttled;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = null;
	            throttled.unsubscribe();
	        }
	    };
	    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this._unsubscribe();
	    };
	    ThrottleSubscriber.prototype.notifyComplete = function () {
	        this._unsubscribe();
	    };
	    return ThrottleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var throttleTime_1 = __webpack_require__(330);
	Observable_1.Observable.prototype.throttleTime = throttleTime_1.throttleTime;
	


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var async_1 = __webpack_require__(101);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for `duration` milliseconds, then repeats this process.
	 *
	 * <span class="informal">Lets a value pass, then ignores source values for the
	 * next `duration` milliseconds.</span>
	 *
	 * <img src="./img/throttleTime.png" width="100%">
	 *
	 * `throttleTime` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled. After `duration` milliseconds (or the time unit determined
	 * internally by the optional `scheduler`) has passed, the timer is disabled,
	 * and this process repeats for the next source value. Optionally takes a
	 * {@link Scheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {number} duration Time to wait before emitting another value after
	 * emitting the last value, measured in milliseconds or the time unit determined
	 * internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link Scheduler} to use for
	 * managing the timers that handle the sampling.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttleTime
	 * @owner Observable
	 */
	function throttleTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return this.lift(new ThrottleTimeOperator(duration, scheduler));
	}
	exports.throttleTime = throttleTime;
	var ThrottleTimeOperator = (function () {
	    function ThrottleTimeOperator(duration, scheduler) {
	        this.duration = duration;
	        this.scheduler = scheduler;
	    }
	    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler));
	    };
	    return ThrottleTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ThrottleTimeSubscriber = (function (_super) {
	    __extends(ThrottleTimeSubscriber, _super);
	    function ThrottleTimeSubscriber(destination, duration, scheduler) {
	        _super.call(this, destination);
	        this.duration = duration;
	        this.scheduler = scheduler;
	    }
	    ThrottleTimeSubscriber.prototype._next = function (value) {
	        if (!this.throttled) {
	            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
	            this.destination.next(value);
	        }
	    };
	    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
	        var throttled = this.throttled;
	        if (throttled) {
	            throttled.unsubscribe();
	            this.remove(throttled);
	            this.throttled = null;
	        }
	    };
	    return ThrottleTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(arg) {
	    var subscriber = arg.subscriber;
	    subscriber.clearThrottle();
	}
	


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var timeInterval_1 = __webpack_require__(332);
	Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
	


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var async_1 = __webpack_require__(101);
	/**
	 * @param scheduler
	 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timeInterval
	 * @owner Observable
	 */
	function timeInterval(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return this.lift(new TimeIntervalOperator(scheduler));
	}
	exports.timeInterval = timeInterval;
	var TimeInterval = (function () {
	    function TimeInterval(value, interval) {
	        this.value = value;
	        this.interval = interval;
	    }
	    return TimeInterval;
	}());
	exports.TimeInterval = TimeInterval;
	;
	var TimeIntervalOperator = (function () {
	    function TimeIntervalOperator(scheduler) {
	        this.scheduler = scheduler;
	    }
	    TimeIntervalOperator.prototype.call = function (observer, source) {
	        return source._subscribe(new TimeIntervalSubscriber(observer, this.scheduler));
	    };
	    return TimeIntervalOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeIntervalSubscriber = (function (_super) {
	    __extends(TimeIntervalSubscriber, _super);
	    function TimeIntervalSubscriber(destination, scheduler) {
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	        this.lastTime = 0;
	        this.lastTime = scheduler.now();
	    }
	    TimeIntervalSubscriber.prototype._next = function (value) {
	        var now = this.scheduler.now();
	        var span = now - this.lastTime;
	        this.lastTime = now;
	        this.destination.next(new TimeInterval(value, span));
	    };
	    return TimeIntervalSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var timeout_1 = __webpack_require__(334);
	Observable_1.Observable.prototype.timeout = timeout_1.timeout;
	


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(101);
	var isDate_1 = __webpack_require__(134);
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * @param due
	 * @param errorToSend
	 * @param scheduler
	 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
	 * @method timeout
	 * @owner Observable
	 */
	function timeout(due, errorToSend, scheduler) {
	    if (errorToSend === void 0) { errorToSend = null; }
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var absoluteTimeout = isDate_1.isDate(due);
	    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
	    return this.lift(new TimeoutOperator(waitFor, absoluteTimeout, errorToSend, scheduler));
	}
	exports.timeout = timeout;
	var TimeoutOperator = (function () {
	    function TimeoutOperator(waitFor, absoluteTimeout, errorToSend, scheduler) {
	        this.waitFor = waitFor;
	        this.absoluteTimeout = absoluteTimeout;
	        this.errorToSend = errorToSend;
	        this.scheduler = scheduler;
	    }
	    TimeoutOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.errorToSend, this.scheduler));
	    };
	    return TimeoutOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeoutSubscriber = (function (_super) {
	    __extends(TimeoutSubscriber, _super);
	    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, errorToSend, scheduler) {
	        _super.call(this, destination);
	        this.absoluteTimeout = absoluteTimeout;
	        this.waitFor = waitFor;
	        this.errorToSend = errorToSend;
	        this.scheduler = scheduler;
	        this.index = 0;
	        this._previousIndex = 0;
	        this._hasCompleted = false;
	        this.scheduleTimeout();
	    }
	    Object.defineProperty(TimeoutSubscriber.prototype, "previousIndex", {
	        get: function () {
	            return this._previousIndex;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimeoutSubscriber.prototype, "hasCompleted", {
	        get: function () {
	            return this._hasCompleted;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TimeoutSubscriber.dispatchTimeout = function (state) {
	        var source = state.subscriber;
	        var currentIndex = state.index;
	        if (!source.hasCompleted && source.previousIndex === currentIndex) {
	            source.notifyTimeout();
	        }
	    };
	    TimeoutSubscriber.prototype.scheduleTimeout = function () {
	        var currentIndex = this.index;
	        this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, { subscriber: this, index: currentIndex });
	        this.index++;
	        this._previousIndex = currentIndex;
	    };
	    TimeoutSubscriber.prototype._next = function (value) {
	        this.destination.next(value);
	        if (!this.absoluteTimeout) {
	            this.scheduleTimeout();
	        }
	    };
	    TimeoutSubscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this._hasCompleted = true;
	    };
	    TimeoutSubscriber.prototype._complete = function () {
	        this.destination.complete();
	        this._hasCompleted = true;
	    };
	    TimeoutSubscriber.prototype.notifyTimeout = function () {
	        this.error(this.errorToSend || new Error('timeout'));
	    };
	    return TimeoutSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var timeoutWith_1 = __webpack_require__(336);
	Observable_1.Observable.prototype.timeoutWith = timeoutWith_1.timeoutWith;
	


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(101);
	var isDate_1 = __webpack_require__(134);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * @param due
	 * @param withObservable
	 * @param scheduler
	 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
	 * @method timeoutWith
	 * @owner Observable
	 */
	function timeoutWith(due, withObservable, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var absoluteTimeout = isDate_1.isDate(due);
	    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
	    return this.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
	}
	exports.timeoutWith = timeoutWith;
	var TimeoutWithOperator = (function () {
	    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
	        this.waitFor = waitFor;
	        this.absoluteTimeout = absoluteTimeout;
	        this.withObservable = withObservable;
	        this.scheduler = scheduler;
	    }
	    TimeoutWithOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
	    };
	    return TimeoutWithOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeoutWithSubscriber = (function (_super) {
	    __extends(TimeoutWithSubscriber, _super);
	    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
	        _super.call(this);
	        this.destination = destination;
	        this.absoluteTimeout = absoluteTimeout;
	        this.waitFor = waitFor;
	        this.withObservable = withObservable;
	        this.scheduler = scheduler;
	        this.timeoutSubscription = undefined;
	        this.index = 0;
	        this._previousIndex = 0;
	        this._hasCompleted = false;
	        destination.add(this);
	        this.scheduleTimeout();
	    }
	    Object.defineProperty(TimeoutWithSubscriber.prototype, "previousIndex", {
	        get: function () {
	            return this._previousIndex;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimeoutWithSubscriber.prototype, "hasCompleted", {
	        get: function () {
	            return this._hasCompleted;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TimeoutWithSubscriber.dispatchTimeout = function (state) {
	        var source = state.subscriber;
	        var currentIndex = state.index;
	        if (!source.hasCompleted && source.previousIndex === currentIndex) {
	            source.handleTimeout();
	        }
	    };
	    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
	        var currentIndex = this.index;
	        var timeoutState = { subscriber: this, index: currentIndex };
	        this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, timeoutState);
	        this.index++;
	        this._previousIndex = currentIndex;
	    };
	    TimeoutWithSubscriber.prototype._next = function (value) {
	        this.destination.next(value);
	        if (!this.absoluteTimeout) {
	            this.scheduleTimeout();
	        }
	    };
	    TimeoutWithSubscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this._hasCompleted = true;
	    };
	    TimeoutWithSubscriber.prototype._complete = function () {
	        this.destination.complete();
	        this._hasCompleted = true;
	    };
	    TimeoutWithSubscriber.prototype.handleTimeout = function () {
	        if (!this.closed) {
	            var withObservable = this.withObservable;
	            this.unsubscribe();
	            this.destination.add(this.timeoutSubscription = subscribeToResult_1.subscribeToResult(this, withObservable));
	        }
	    };
	    return TimeoutWithSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var timestamp_1 = __webpack_require__(338);
	Observable_1.Observable.prototype.timestamp = timestamp_1.timestamp;
	


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var async_1 = __webpack_require__(101);
	/**
	 * @param scheduler
	 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timestamp
	 * @owner Observable
	 */
	function timestamp(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return this.lift(new TimestampOperator(scheduler));
	}
	exports.timestamp = timestamp;
	var Timestamp = (function () {
	    function Timestamp(value, timestamp) {
	        this.value = value;
	        this.timestamp = timestamp;
	    }
	    return Timestamp;
	}());
	exports.Timestamp = Timestamp;
	;
	var TimestampOperator = (function () {
	    function TimestampOperator(scheduler) {
	        this.scheduler = scheduler;
	    }
	    TimestampOperator.prototype.call = function (observer, source) {
	        return source._subscribe(new TimestampSubscriber(observer, this.scheduler));
	    };
	    return TimestampOperator;
	}());
	var TimestampSubscriber = (function (_super) {
	    __extends(TimestampSubscriber, _super);
	    function TimestampSubscriber(destination, scheduler) {
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	    }
	    TimestampSubscriber.prototype._next = function (value) {
	        var now = this.scheduler.now();
	        this.destination.next(new Timestamp(value, now));
	    };
	    return TimestampSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var toArray_1 = __webpack_require__(340);
	Observable_1.Observable.prototype.toArray = toArray_1.toArray;
	


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
	 * @method toArray
	 * @owner Observable
	 */
	function toArray() {
	    return this.lift(new ToArrayOperator());
	}
	exports.toArray = toArray;
	var ToArrayOperator = (function () {
	    function ToArrayOperator() {
	    }
	    ToArrayOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new ToArraySubscriber(subscriber));
	    };
	    return ToArrayOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ToArraySubscriber = (function (_super) {
	    __extends(ToArraySubscriber, _super);
	    function ToArraySubscriber(destination) {
	        _super.call(this, destination);
	        this.array = [];
	    }
	    ToArraySubscriber.prototype._next = function (x) {
	        this.array.push(x);
	    };
	    ToArraySubscriber.prototype._complete = function () {
	        this.destination.next(this.array);
	        this.destination.complete();
	    };
	    return ToArraySubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var toPromise_1 = __webpack_require__(342);
	Observable_1.Observable.prototype.toPromise = toPromise_1.toPromise;
	


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var root_1 = __webpack_require__(30);
	/**
	 * @param PromiseCtor
	 * @return {Promise<T>}
	 * @method toPromise
	 * @owner Observable
	 */
	function toPromise(PromiseCtor) {
	    var _this = this;
	    if (!PromiseCtor) {
	        if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	            PromiseCtor = root_1.root.Rx.config.Promise;
	        }
	        else if (root_1.root.Promise) {
	            PromiseCtor = root_1.root.Promise;
	        }
	    }
	    if (!PromiseCtor) {
	        throw new Error('no Promise impl found');
	    }
	    return new PromiseCtor(function (resolve, reject) {
	        var value;
	        _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
	    });
	}
	exports.toPromise = toPromise;
	


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var window_1 = __webpack_require__(344);
	Observable_1.Observable.prototype.window = window_1.window;
	


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Branch out the source Observable values as a nested Observable whenever
	 * `windowBoundaries` emits.
	 *
	 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
	 * instead of an array.</span>
	 *
	 * <img src="./img/window.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping
	 * windows. It emits the current window and opens a new one whenever the
	 * Observable `windowBoundaries` emits an item. Because each window is an
	 * Observable, the output is a higher-order Observable.
	 *
	 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var result = clicks.window(interval)
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link buffer}
	 *
	 * @param {Observable<any>} windowBoundaries An Observable that completes the
	 * previous window and starts a new window.
	 * @return {Observable<Observable<T>>} An Observable of windows, which are
	 * Observables emitting values of the source Observable.
	 * @method window
	 * @owner Observable
	 */
	function window(windowBoundaries) {
	    return this.lift(new WindowOperator(windowBoundaries));
	}
	exports.window = window;
	var WindowOperator = (function () {
	    function WindowOperator(windowBoundaries) {
	        this.windowBoundaries = windowBoundaries;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        var windowSubscriber = new WindowSubscriber(subscriber);
	        var sourceSubscription = source._subscribe(windowSubscriber);
	        if (!sourceSubscription.closed) {
	            windowSubscriber.add(subscribeToResult_1.subscribeToResult(windowSubscriber, this.windowBoundaries));
	        }
	        return sourceSubscription;
	    };
	    return WindowOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowSubscriber = (function (_super) {
	    __extends(WindowSubscriber, _super);
	    function WindowSubscriber(destination) {
	        _super.call(this, destination);
	        this.window = new Subject_1.Subject();
	        destination.next(this.window);
	    }
	    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openWindow();
	    };
	    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
	        this._complete();
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	    };
	    WindowSubscriber.prototype._unsubscribe = function () {
	        this.window = null;
	    };
	    WindowSubscriber.prototype.openWindow = function () {
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var destination = this.destination;
	        var newWindow = this.window = new Subject_1.Subject();
	        destination.next(newWindow);
	    };
	    return WindowSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var windowCount_1 = __webpack_require__(346);
	Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
	


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(32);
	var Subject_1 = __webpack_require__(28);
	/**
	 * Branch out the source Observable values as a nested Observable with each
	 * nested Observable emitting at most `windowSize` values.
	 *
	 * <span class="informal">It's like {@link bufferCount}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowCount.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows every `startWindowEvery`
	 * items, each containing no more than `windowSize` items. When the source
	 * Observable completes or encounters an error, the output Observable emits
	 * the current window and propagates the notification from the source
	 * Observable. If `startWindowEvery` is not provided, then new windows are
	 * started immediately at the start of the source and when each window completes
	 * with size `windowSize`.
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(3)
	 *   .map(win => win.skip(1)) // skip first of every 3 clicks
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(2, 3)
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link bufferCount}
	 *
	 * @param {number} windowSize The maximum number of values emitted by each
	 * window.
	 * @param {number} [startWindowEvery] Interval at which to start a new window.
	 * For example if `startWindowEvery` is `2`, then a new window will be started
	 * on every other value from the source. A new window is started at the
	 * beginning of the source by default.
	 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
	 * are Observable of values.
	 * @method windowCount
	 * @owner Observable
	 */
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) { startWindowEvery = 0; }
	    return this.lift(new WindowCountOperator(windowSize, startWindowEvery));
	}
	exports.windowCount = windowCount;
	var WindowCountOperator = (function () {
	    function WindowCountOperator(windowSize, startWindowEvery) {
	        this.windowSize = windowSize;
	        this.startWindowEvery = startWindowEvery;
	    }
	    WindowCountOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
	    };
	    return WindowCountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowCountSubscriber = (function (_super) {
	    __extends(WindowCountSubscriber, _super);
	    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.windowSize = windowSize;
	        this.startWindowEvery = startWindowEvery;
	        this.windows = [new Subject_1.Subject()];
	        this.count = 0;
	        destination.next(this.windows[0]);
	    }
	    WindowCountSubscriber.prototype._next = function (value) {
	        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
	        var destination = this.destination;
	        var windowSize = this.windowSize;
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len && !this.closed; i++) {
	            windows[i].next(value);
	        }
	        var c = this.count - windowSize + 1;
	        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
	            windows.shift().complete();
	        }
	        if (++this.count % startWindowEvery === 0 && !this.closed) {
	            var window_1 = new Subject_1.Subject();
	            windows.push(window_1);
	            destination.next(window_1);
	        }
	    };
	    WindowCountSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().error(err);
	            }
	        }
	        this.destination.error(err);
	    };
	    WindowCountSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().complete();
	            }
	        }
	        this.destination.complete();
	    };
	    WindowCountSubscriber.prototype._unsubscribe = function () {
	        this.count = 0;
	        this.windows = null;
	    };
	    return WindowCountSubscriber;
	}(Subscriber_1.Subscriber));
	


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var windowTime_1 = __webpack_require__(348);
	Observable_1.Observable.prototype.windowTime = windowTime_1.windowTime;
	


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var async_1 = __webpack_require__(101);
	var Subscriber_1 = __webpack_require__(32);
	/**
	 * Branch out the source Observable values as a nested Observable periodically
	 * in time.
	 *
	 * <span class="informal">It's like {@link bufferTime}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowTime.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable starts a new window periodically, as
	 * determined by the `windowCreationInterval` argument. It emits each window
	 * after a fixed timespan, specified by the `windowTimeSpan` argument. When the
	 * source Observable completes or encounters an error, the output Observable
	 * emits the current window and propagates the notification from the source
	 * Observable. If `windowCreationInterval` is not provided, the output
	 * Observable starts a new window when the previous window of duration
	 * `windowTimeSpan` completes.
	 *
	 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowTime(1000)
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Every 5 seconds start a window 1 second long, and emit at most 2 click events per window</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowTime(1000, 5000)
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link bufferTime}
	 *
	 * @param {number} windowTimeSpan The amount of time to fill each window.
	 * @param {number} [windowCreationInterval] The interval at which to start new
	 * windows.
	 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
	 * intervals that determine window boundaries.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowTime
	 * @owner Observable
	 */
	function windowTime(windowTimeSpan, windowCreationInterval, scheduler) {
	    if (windowCreationInterval === void 0) { windowCreationInterval = null; }
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return this.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, scheduler));
	}
	exports.windowTime = windowTime;
	var WindowTimeOperator = (function () {
	    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, scheduler) {
	        this.windowTimeSpan = windowTimeSpan;
	        this.windowCreationInterval = windowCreationInterval;
	        this.scheduler = scheduler;
	    }
	    WindowTimeOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.scheduler));
	    };
	    return WindowTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowTimeSubscriber = (function (_super) {
	    __extends(WindowTimeSubscriber, _super);
	    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, scheduler) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.windowTimeSpan = windowTimeSpan;
	        this.windowCreationInterval = windowCreationInterval;
	        this.scheduler = scheduler;
	        this.windows = [];
	        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
	            var window_1 = this.openWindow();
	            var closeState = { subscriber: this, window: window_1, context: null };
	            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: this, scheduler: scheduler };
	            this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
	            this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
	        }
	        else {
	            var window_2 = this.openWindow();
	            var timeSpanOnlyState = { subscriber: this, window: window_2, windowTimeSpan: windowTimeSpan };
	            this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
	        }
	    }
	    WindowTimeSubscriber.prototype._next = function (value) {
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len; i++) {
	            var window_3 = windows[i];
	            if (!window_3.closed) {
	                window_3.next(value);
	            }
	        }
	    };
	    WindowTimeSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            windows.shift().error(err);
	        }
	        this.destination.error(err);
	    };
	    WindowTimeSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            var window_4 = windows.shift();
	            if (!window_4.closed) {
	                window_4.complete();
	            }
	        }
	        this.destination.complete();
	    };
	    WindowTimeSubscriber.prototype.openWindow = function () {
	        var window = new Subject_1.Subject();
	        this.windows.push(window);
	        var destination = this.destination;
	        destination.next(window);
	        return window;
	    };
	    WindowTimeSubscriber.prototype.closeWindow = function (window) {
	        window.complete();
	        var windows = this.windows;
	        windows.splice(windows.indexOf(window), 1);
	    };
	    return WindowTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchWindowTimeSpanOnly(state) {
	    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
	    if (window) {
	        window.complete();
	    }
	    state.window = subscriber.openWindow();
	    this.schedule(state, windowTimeSpan);
	}
	function dispatchWindowCreation(state) {
	    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
	    var window = subscriber.openWindow();
	    var action = this;
	    var context = { action: action, subscription: null };
	    var timeSpanState = { subscriber: subscriber, window: window, context: context };
	    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
	    action.add(context.subscription);
	    action.schedule(state, windowCreationInterval);
	}
	function dispatchWindowClose(arg) {
	    var subscriber = arg.subscriber, window = arg.window, context = arg.context;
	    if (context && context.action && context.subscription) {
	        context.action.remove(context.subscription);
	    }
	    subscriber.closeWindow(window);
	}
	


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var windowToggle_1 = __webpack_require__(350);
	Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
	


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var Subscription_1 = __webpack_require__(34);
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Branch out the source Observable values as a nested Observable starting from
	 * an emission from `openings` and ending when the output of `closingSelector`
	 * emits.
	 *
	 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowToggle.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows that contain those items
	 * emitted by the source Observable between the time when the `openings`
	 * Observable emits an item and when the Observable returned by
	 * `closingSelector` emits an item.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var result = clicks.windowToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * ).mergeAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowWhen}
	 * @see {@link bufferToggle}
	 *
	 * @param {Observable<O>} openings An observable of notifications to start new
	 * windows.
	 * @param {function(value: O): Observable} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns an Observable,
	 * which, when it emits (either `next` or `complete`), signals that the
	 * associated window should complete.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowToggle
	 * @owner Observable
	 */
	function windowToggle(openings, closingSelector) {
	    return this.lift(new WindowToggleOperator(openings, closingSelector));
	}
	exports.windowToggle = windowToggle;
	var WindowToggleOperator = (function () {
	    function WindowToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    WindowToggleOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return WindowToggleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowToggleSubscriber = (function (_super) {
	    __extends(WindowToggleSubscriber, _super);
	    function WindowToggleSubscriber(destination, openings, closingSelector) {
	        _super.call(this, destination);
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	        this.contexts = [];
	        this.add(this.openSubscription = subscribeToResult_1.subscribeToResult(this, openings, openings));
	    }
	    WindowToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        if (contexts) {
	            var len = contexts.length;
	            for (var i = 0; i < len; i++) {
	                contexts[i].window.next(value);
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.error(err);
	                context.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._error.call(this, err);
	    };
	    WindowToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.complete();
	                context.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    WindowToggleSubscriber.prototype._unsubscribe = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.unsubscribe();
	                context.subscription.unsubscribe();
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (outerValue === this.openings) {
	            var closingSelector = this.closingSelector;
	            var closingNotifier = tryCatch_1.tryCatch(closingSelector)(innerValue);
	            if (closingNotifier === errorObject_1.errorObject) {
	                return this.error(errorObject_1.errorObject.e);
	            }
	            else {
	                var window_1 = new Subject_1.Subject();
	                var subscription = new Subscription_1.Subscription();
	                var context = { window: window_1, subscription: subscription };
	                this.contexts.push(context);
	                var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
	                if (innerSubscription.closed) {
	                    this.closeWindow(this.contexts.length - 1);
	                }
	                else {
	                    innerSubscription.context = context;
	                    subscription.add(innerSubscription);
	                }
	                this.destination.next(window_1);
	            }
	        }
	        else {
	            this.closeWindow(this.contexts.indexOf(outerValue));
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyError = function (err) {
	        this.error(err);
	    };
	    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
	        if (inner !== this.openSubscription) {
	            this.closeWindow(this.contexts.indexOf(inner.context));
	        }
	    };
	    WindowToggleSubscriber.prototype.closeWindow = function (index) {
	        if (index === -1) {
	            return;
	        }
	        var contexts = this.contexts;
	        var context = contexts[index];
	        var window = context.window, subscription = context.subscription;
	        contexts.splice(index, 1);
	        window.complete();
	        subscription.unsubscribe();
	    };
	    return WindowToggleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var windowWhen_1 = __webpack_require__(352);
	Observable_1.Observable.prototype.windowWhen = windowWhen_1.windowWhen;
	


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var tryCatch_1 = __webpack_require__(37);
	var errorObject_1 = __webpack_require__(38);
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Branch out the source Observable values as a nested Observable using a
	 * factory function of closing Observables to determine when to start a new
	 * window.
	 *
	 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowWhen.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping windows.
	 * It emits the current window and opens a new one whenever the Observable
	 * produced by the specified `closingSelector` function emits an item. The first
	 * window is opened immediately when subscribing to the output Observable.
	 *
	 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks
	 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link bufferWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals (on either `next` or
	 * `complete`) when to close the previous window and start a new one.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowWhen
	 * @owner Observable
	 */
	function windowWhen(closingSelector) {
	    return this.lift(new WindowOperator(closingSelector));
	}
	exports.windowWhen = windowWhen;
	var WindowOperator = (function () {
	    function WindowOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new WindowSubscriber(subscriber, this.closingSelector));
	    };
	    return WindowOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowSubscriber = (function (_super) {
	    __extends(WindowSubscriber, _super);
	    function WindowSubscriber(destination, closingSelector) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.closingSelector = closingSelector;
	        this.openWindow();
	    }
	    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
	        if (this.closingNotification) {
	            this.closingNotification.unsubscribe();
	        }
	    };
	    WindowSubscriber.prototype.openWindow = function (innerSub) {
	        if (innerSub === void 0) { innerSub = null; }
	        if (innerSub) {
	            this.remove(innerSub);
	            innerSub.unsubscribe();
	        }
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var window = this.window = new Subject_1.Subject();
	        this.destination.next(window);
	        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
	        if (closingNotifier === errorObject_1.errorObject) {
	            var err = errorObject_1.errorObject.e;
	            this.destination.error(err);
	            this.window.error(err);
	        }
	        else {
	            this.add(this.closingNotification = subscribeToResult_1.subscribeToResult(this, closingNotifier));
	        }
	    };
	    return WindowSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var withLatestFrom_1 = __webpack_require__(354);
	Observable_1.Observable.prototype.withLatestFrom = withLatestFrom_1.withLatestFrom;
	


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(59);
	var subscribeToResult_1 = __webpack_require__(60);
	/**
	 * Combines the source Observable with other Observables to create an Observable
	 * whose values are calculated from the latest values of each, only when the
	 * source emits.
	 *
	 * <span class="informal">Whenever the source Observable emits a value, it
	 * computes a formula using that value plus the latest values from other input
	 * Observables, then emits the output of that formula.</span>
	 *
	 * <img src="./img/withLatestFrom.png" width="100%">
	 *
	 * `withLatestFrom` combines each value from the source Observable (the
	 * instance) with the latest values from the other input Observables only when
	 * the source emits a value, optionally using a `project` function to determine
	 * the value to be emitted on the output Observable. All input Observables must
	 * emit at least one value before the output Observable will emit a value.
	 *
	 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var result = clicks.withLatestFrom(timer);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 *
	 * @param {Observable} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Function} [project] Projection function for combining values
	 * together. Receives all values in order of the Observables passed, where the
	 * first parameter is a value from the source Observable. (e.g.
	 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
	 * passed, arrays will be emitted on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method withLatestFrom
	 * @owner Observable
	 */
	function withLatestFrom() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i - 0] = arguments[_i];
	    }
	    var project;
	    if (typeof args[args.length - 1] === 'function') {
	        project = args.pop();
	    }
	    var observables = args;
	    return this.lift(new WithLatestFromOperator(observables, project));
	}
	exports.withLatestFrom = withLatestFrom;
	/* tslint:enable:max-line-length */
	var WithLatestFromOperator = (function () {
	    function WithLatestFromOperator(observables, project) {
	        this.observables = observables;
	        this.project = project;
	    }
	    WithLatestFromOperator.prototype.call = function (subscriber, source) {
	        return source._subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
	    };
	    return WithLatestFromOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WithLatestFromSubscriber = (function (_super) {
	    __extends(WithLatestFromSubscriber, _super);
	    function WithLatestFromSubscriber(destination, observables, project) {
	        _super.call(this, destination);
	        this.observables = observables;
	        this.project = project;
	        this.toRespond = [];
	        var len = observables.length;
	        this.values = new Array(len);
	        for (var i = 0; i < len; i++) {
	            this.toRespond.push(i);
	        }
	        for (var i = 0; i < len; i++) {
	            var observable = observables[i];
	            this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
	        }
	    }
	    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values[outerIndex] = innerValue;
	        var toRespond = this.toRespond;
	        if (toRespond.length > 0) {
	            var found = toRespond.indexOf(outerIndex);
	            if (found !== -1) {
	                toRespond.splice(found, 1);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype.notifyComplete = function () {
	        // noop
	    };
	    WithLatestFromSubscriber.prototype._next = function (value) {
	        if (this.toRespond.length === 0) {
	            var args = [value].concat(this.values);
	            if (this.project) {
	                this._tryProject(args);
	            }
	            else {
	                this.destination.next(args);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype._tryProject = function (args) {
	        var result;
	        try {
	            result = this.project.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return WithLatestFromSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var zip_1 = __webpack_require__(137);
	Observable_1.Observable.prototype.zip = zip_1.zipProto;
	


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var Observable_1 = __webpack_require__(29);
	var zipAll_1 = __webpack_require__(357);
	Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
	


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var zip_1 = __webpack_require__(137);
	/**
	 * @param project
	 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
	 * @method zipAll
	 * @owner Observable
	 */
	function zipAll(project) {
	    return this.lift(new zip_1.ZipOperator(project));
	}
	exports.zipAll = zipAll;
	


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var Notification_1 = __webpack_require__(83);
	var ColdObservable_1 = __webpack_require__(359);
	var HotObservable_1 = __webpack_require__(363);
	var SubscriptionLog_1 = __webpack_require__(361);
	var VirtualTimeScheduler_1 = __webpack_require__(364);
	var TestScheduler = (function (_super) {
	    __extends(TestScheduler, _super);
	    function TestScheduler(assertDeepEqual) {
	        _super.call(this);
	        this.assertDeepEqual = assertDeepEqual;
	        this.hotObservables = [];
	        this.coldObservables = [];
	        this.flushTests = [];
	    }
	    TestScheduler.prototype.createTime = function (marbles) {
	        var indexOf = marbles.indexOf('|');
	        if (indexOf === -1) {
	            throw new Error('marble diagram for time should have a completion marker "|"');
	        }
	        return indexOf * TestScheduler.frameTimeFactor;
	    };
	    TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
	        if (marbles.indexOf('^') !== -1) {
	            throw new Error('cold observable cannot have subscription offset "^"');
	        }
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('cold observable cannot have unsubscription marker "!"');
	        }
	        var messages = TestScheduler.parseMarbles(marbles, values, error);
	        var cold = new ColdObservable_1.ColdObservable(messages, this);
	        this.coldObservables.push(cold);
	        return cold;
	    };
	    TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('hot observable cannot have unsubscription marker "!"');
	        }
	        var messages = TestScheduler.parseMarbles(marbles, values, error);
	        var subject = new HotObservable_1.HotObservable(messages, this);
	        this.hotObservables.push(subject);
	        return subject;
	    };
	    TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
	        var _this = this;
	        var messages = [];
	        observable.subscribe(function (value) {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createNext(value) });
	        }, function (err) {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createError(err) });
	        }, function () {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createComplete() });
	        });
	        return messages;
	    };
	    TestScheduler.prototype.expectObservable = function (observable, unsubscriptionMarbles) {
	        var _this = this;
	        if (unsubscriptionMarbles === void 0) { unsubscriptionMarbles = null; }
	        var actual = [];
	        var flushTest = { actual: actual, ready: false };
	        var unsubscriptionFrame = TestScheduler
	            .parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
	        var subscription;
	        this.schedule(function () {
	            subscription = observable.subscribe(function (x) {
	                var value = x;
	                // Support Observable-of-Observables
	                if (x instanceof Observable_1.Observable) {
	                    value = _this.materializeInnerObservable(value, _this.frame);
	                }
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createNext(value) });
	            }, function (err) {
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createError(err) });
	            }, function () {
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createComplete() });
	            });
	        }, 0);
	        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
	            this.schedule(function () { return subscription.unsubscribe(); }, unsubscriptionFrame);
	        }
	        this.flushTests.push(flushTest);
	        return {
	            toBe: function (marbles, values, errorValue) {
	                flushTest.ready = true;
	                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
	            }
	        };
	    };
	    TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
	        var flushTest = { actual: actualSubscriptionLogs, ready: false };
	        this.flushTests.push(flushTest);
	        return {
	            toBe: function (marbles) {
	                var marblesArray = (typeof marbles === 'string') ? [marbles] : marbles;
	                flushTest.ready = true;
	                flushTest.expected = marblesArray.map(function (marbles) {
	                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
	                });
	            }
	        };
	    };
	    TestScheduler.prototype.flush = function () {
	        var hotObservables = this.hotObservables;
	        while (hotObservables.length > 0) {
	            hotObservables.shift().setup();
	        }
	        _super.prototype.flush.call(this);
	        var readyFlushTests = this.flushTests.filter(function (test) { return test.ready; });
	        while (readyFlushTests.length > 0) {
	            var test = readyFlushTests.shift();
	            this.assertDeepEqual(test.actual, test.expected);
	        }
	    };
	    TestScheduler.parseMarblesAsSubscriptions = function (marbles) {
	        if (typeof marbles !== 'string') {
	            return new SubscriptionLog_1.SubscriptionLog(Number.POSITIVE_INFINITY);
	        }
	        var len = marbles.length;
	        var groupStart = -1;
	        var subscriptionFrame = Number.POSITIVE_INFINITY;
	        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
	        for (var i = 0; i < len; i++) {
	            var frame = i * this.frameTimeFactor;
	            var c = marbles[i];
	            switch (c) {
	                case '-':
	                case ' ':
	                    break;
	                case '(':
	                    groupStart = frame;
	                    break;
	                case ')':
	                    groupStart = -1;
	                    break;
	                case '^':
	                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) {
	                        throw new Error('found a second subscription point \'^\' in a ' +
	                            'subscription marble diagram. There can only be one.');
	                    }
	                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
	                    break;
	                case '!':
	                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
	                        throw new Error('found a second subscription point \'^\' in a ' +
	                            'subscription marble diagram. There can only be one.');
	                    }
	                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
	                    break;
	                default:
	                    throw new Error('there can only be \'^\' and \'!\' markers in a ' +
	                        'subscription marble diagram. Found instead \'' + c + '\'.');
	            }
	        }
	        if (unsubscriptionFrame < 0) {
	            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame);
	        }
	        else {
	            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
	        }
	    };
	    TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables) {
	        if (materializeInnerObservables === void 0) { materializeInnerObservables = false; }
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('conventional marble diagrams cannot have the ' +
	                'unsubscription marker "!"');
	        }
	        var len = marbles.length;
	        var testMessages = [];
	        var subIndex = marbles.indexOf('^');
	        var frameOffset = subIndex === -1 ? 0 : (subIndex * -this.frameTimeFactor);
	        var getValue = typeof values !== 'object' ?
	            function (x) { return x; } :
	            function (x) {
	                // Support Observable-of-Observables
	                if (materializeInnerObservables && values[x] instanceof ColdObservable_1.ColdObservable) {
	                    return values[x].messages;
	                }
	                return values[x];
	            };
	        var groupStart = -1;
	        for (var i = 0; i < len; i++) {
	            var frame = i * this.frameTimeFactor + frameOffset;
	            var notification = void 0;
	            var c = marbles[i];
	            switch (c) {
	                case '-':
	                case ' ':
	                    break;
	                case '(':
	                    groupStart = frame;
	                    break;
	                case ')':
	                    groupStart = -1;
	                    break;
	                case '|':
	                    notification = Notification_1.Notification.createComplete();
	                    break;
	                case '^':
	                    break;
	                case '#':
	                    notification = Notification_1.Notification.createError(errorValue || 'error');
	                    break;
	                default:
	                    notification = Notification_1.Notification.createNext(getValue(c));
	                    break;
	            }
	            if (notification) {
	                testMessages.push({ frame: groupStart > -1 ? groupStart : frame, notification: notification });
	            }
	        }
	        return testMessages;
	    };
	    return TestScheduler;
	}(VirtualTimeScheduler_1.VirtualTimeScheduler));
	exports.TestScheduler = TestScheduler;
	


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(29);
	var Subscription_1 = __webpack_require__(34);
	var SubscriptionLoggable_1 = __webpack_require__(360);
	var applyMixins_1 = __webpack_require__(362);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ColdObservable = (function (_super) {
	    __extends(ColdObservable, _super);
	    function ColdObservable(messages, scheduler) {
	        _super.call(this, function (subscriber) {
	            var observable = this;
	            var index = observable.logSubscribedFrame();
	            subscriber.add(new Subscription_1.Subscription(function () {
	                observable.logUnsubscribedFrame(index);
	            }));
	            observable.scheduleMessages(subscriber);
	            return subscriber;
	        });
	        this.messages = messages;
	        this.subscriptions = [];
	        this.scheduler = scheduler;
	    }
	    ColdObservable.prototype.scheduleMessages = function (subscriber) {
	        var messagesLength = this.messages.length;
	        for (var i = 0; i < messagesLength; i++) {
	            var message = this.messages[i];
	            subscriber.add(this.scheduler.schedule(function (_a) {
	                var message = _a.message, subscriber = _a.subscriber;
	                message.notification.observe(subscriber);
	            }, message.frame, { message: message, subscriber: subscriber }));
	        }
	    };
	    return ColdObservable;
	}(Observable_1.Observable));
	exports.ColdObservable = ColdObservable;
	applyMixins_1.applyMixins(ColdObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
	


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var SubscriptionLog_1 = __webpack_require__(361);
	var SubscriptionLoggable = (function () {
	    function SubscriptionLoggable() {
	        this.subscriptions = [];
	    }
	    SubscriptionLoggable.prototype.logSubscribedFrame = function () {
	        this.subscriptions.push(new SubscriptionLog_1.SubscriptionLog(this.scheduler.now()));
	        return this.subscriptions.length - 1;
	    };
	    SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
	        var subscriptionLogs = this.subscriptions;
	        var oldSubscriptionLog = subscriptionLogs[index];
	        subscriptionLogs[index] = new SubscriptionLog_1.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
	    };
	    return SubscriptionLoggable;
	}());
	exports.SubscriptionLoggable = SubscriptionLoggable;
	


/***/ }),
/* 361 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var SubscriptionLog = (function () {
	    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
	        if (unsubscribedFrame === void 0) { unsubscribedFrame = Number.POSITIVE_INFINITY; }
	        this.subscribedFrame = subscribedFrame;
	        this.unsubscribedFrame = unsubscribedFrame;
	    }
	    return SubscriptionLog;
	}());
	exports.SubscriptionLog = SubscriptionLog;
	


/***/ }),
/* 362 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	function applyMixins(derivedCtor, baseCtors) {
	    for (var i = 0, len = baseCtors.length; i < len; i++) {
	        var baseCtor = baseCtors[i];
	        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
	        for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
	            var name_1 = propertyKeys[j];
	            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
	        }
	    }
	}
	exports.applyMixins = applyMixins;
	


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(28);
	var Subscription_1 = __webpack_require__(34);
	var SubscriptionLoggable_1 = __webpack_require__(360);
	var applyMixins_1 = __webpack_require__(362);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var HotObservable = (function (_super) {
	    __extends(HotObservable, _super);
	    function HotObservable(messages, scheduler) {
	        _super.call(this);
	        this.messages = messages;
	        this.subscriptions = [];
	        this.scheduler = scheduler;
	    }
	    HotObservable.prototype._subscribe = function (subscriber) {
	        var subject = this;
	        var index = subject.logSubscribedFrame();
	        subscriber.add(new Subscription_1.Subscription(function () {
	            subject.logUnsubscribedFrame(index);
	        }));
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    HotObservable.prototype.setup = function () {
	        var subject = this;
	        var messagesLength = subject.messages.length;
	        /* tslint:disable:no-var-keyword */
	        for (var i = 0; i < messagesLength; i++) {
	            (function () {
	                var message = subject.messages[i];
	                /* tslint:enable */
	                subject.scheduler.schedule(function () { message.notification.observe(subject); }, message.frame);
	            })();
	        }
	    };
	    return HotObservable;
	}(Subject_1.Subject));
	exports.HotObservable = HotObservable;
	applyMixins_1.applyMixins(HotObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
	


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(102);
	var AsyncScheduler_1 = __webpack_require__(104);
	var VirtualTimeScheduler = (function (_super) {
	    __extends(VirtualTimeScheduler, _super);
	    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
	        var _this = this;
	        if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
	        if (maxFrames === void 0) { maxFrames = 750; }
	        _super.call(this, SchedulerAction, function () { return _this.frame; });
	        this.maxFrames = maxFrames;
	        this.frame = 0;
	        this.index = -1;
	    }
	    /**
	     * Prompt the Scheduler to execute all of its queued actions, therefore
	     * clearing its queue.
	     * @return {void}
	     */
	    VirtualTimeScheduler.prototype.flush = function () {
	        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
	        var error, action;
	        while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        }
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    VirtualTimeScheduler.frameTimeFactor = 10;
	    return VirtualTimeScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.VirtualTimeScheduler = VirtualTimeScheduler;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var VirtualAction = (function (_super) {
	    __extends(VirtualAction, _super);
	    function VirtualAction(scheduler, work, index) {
	        if (index === void 0) { index = scheduler.index += 1; }
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	        this.index = index;
	        this.index = scheduler.index = index;
	    }
	    VirtualAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        return !this.id ?
	            _super.prototype.schedule.call(this, state, delay) : this.add(new VirtualAction(this.scheduler, this.work)).schedule(state, delay);
	    };
	    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.delay = scheduler.frame + delay;
	        var actions = scheduler.actions;
	        actions.push(this);
	        actions.sort(VirtualAction.sortActions);
	        return true;
	    };
	    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return undefined;
	    };
	    VirtualAction.sortActions = function (a, b) {
	        if (a.delay === b.delay) {
	            if (a.index === b.index) {
	                return 0;
	            }
	            else if (a.index > b.index) {
	                return 1;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (a.delay > b.delay) {
	            return 1;
	        }
	        else {
	            return -1;
	        }
	    };
	    return VirtualAction;
	}(AsyncAction_1.AsyncAction));
	exports.VirtualAction = VirtualAction;
	


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var AnimationFrameAction_1 = __webpack_require__(366);
	var AnimationFrameScheduler_1 = __webpack_require__(368);
	exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
	


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(102);
	var AnimationFrame_1 = __webpack_require__(367);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AnimationFrameAction = (function (_super) {
	    __extends(AnimationFrameAction, _super);
	    function AnimationFrameAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay is greater than 0, request as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Push the action to the end of the scheduler queue.
	        scheduler.actions.push(this);
	        // If an animation frame has already been requested, don't request another
	        // one. If an animation frame hasn't been requested yet, request one. Return
	        // the current animation frame request id.
	        return scheduler.scheduled || (scheduler.scheduled = AnimationFrame_1.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
	    };
	    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, recycle as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        // If the scheduler queue is empty, cancel the requested animation frame and
	        // set the scheduled flag to undefined so the next AnimationFrameAction will
	        // request its own.
	        if (scheduler.actions.length === 0) {
	            AnimationFrame_1.AnimationFrame.cancelAnimationFrame(id);
	            scheduler.scheduled = undefined;
	        }
	        // Return undefined so the action knows to request a new async id if it's rescheduled.
	        return undefined;
	    };
	    return AnimationFrameAction;
	}(AsyncAction_1.AsyncAction));
	exports.AnimationFrameAction = AnimationFrameAction;
	


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var root_1 = __webpack_require__(30);
	var RequestAnimationFrameDefinition = (function () {
	    function RequestAnimationFrameDefinition(root) {
	        if (root.requestAnimationFrame) {
	            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
	        }
	        else if (root.mozRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
	        }
	        else if (root.webkitRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
	        }
	        else if (root.msRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
	        }
	        else if (root.oRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
	        }
	        else {
	            this.cancelAnimationFrame = root.clearTimeout.bind(root);
	            this.requestAnimationFrame = function (cb) { return root.setTimeout(cb, 1000 / 60); };
	        }
	    }
	    return RequestAnimationFrameDefinition;
	}());
	exports.RequestAnimationFrameDefinition = RequestAnimationFrameDefinition;
	exports.AnimationFrame = new RequestAnimationFrameDefinition(root_1.root);
	


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(104);
	var AnimationFrameScheduler = (function (_super) {
	    __extends(AnimationFrameScheduler, _super);
	    function AnimationFrameScheduler() {
	        _super.apply(this, arguments);
	    }
	    AnimationFrameScheduler.prototype.flush = function () {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        var action = actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AnimationFrameScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AnimationFrameScheduler = AnimationFrameScheduler;
	


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var ramda_1 = __webpack_require__(7);
	var Rx = __webpack_require__(27);
	var itemFilter_1 = __webpack_require__(370);
	var disposable_1 = __webpack_require__(375);
	var string_1 = __webpack_require__(13);
	var rx_1 = __webpack_require__(376);
	var _knockoutDataSearchInfo_1 = __webpack_require__(377);
	var dataProvider_1 = __webpack_require__(378);
	var shared_1 = __webpack_require__(379);
	/** Cold observable stream containing the empty value. */
	var emptyValueStream = Rx.Observable.of(dataProvider_1.emptyValue);
	/**
	 * Possible results for 'findItem'.
	 */
	(function (MatchResult) {
	    /**
	     * No matching item was found.
	     */
	    MatchResult[MatchResult["NoMatch"] = 0] = "NoMatch";
	    /**
	     * A single item was found.
	     */
	    MatchResult[MatchResult["ExactMatch"] = 1] = "ExactMatch";
	    /**
	     * Multiple matching items were found.
	     */
	    MatchResult[MatchResult["MultipleMatches"] = 2] = "MultipleMatches";
	})(exports.MatchResult || (exports.MatchResult = {}));
	var MatchResult = exports.MatchResult;
	/**
	 * Data provider implementation for wrapping a knockout observable.
	 */
	var KnockoutDataProvider = (function () {
	    /**
	     * KnockoutDataProvider constructor.
	     *
	     * @param source
	     *     Knockout observable containing a DataProviderResponse object.
	     * @param settings
	     *     Settings controlling the behaviour of the data provider.
	     */
	    function KnockoutDataProvider(source, settings) {
	        var _this = this;
	        this._debounceTime = typeof settings.debounceTime === "number" ? settings.debounceTime : shared_1.defaultDebounceTime;
	        this._itemFilterBuilder = settings.itemFilterBuilder || itemFilter_1.defaultItemFilterBuilder;
	        this._lastSearch = new _knockoutDataSearchInfo_1.KnockoutDataSearchInfo(settings.displayIndex, settings.exactMatchIgnoresCase);
	        this._limit = settings.filterLimit || 7;
	        this._searchIndex = settings.searchIndex;
	        this._stream =
	            (ko.isObservable(source)
	                ? rx_1.fromKnockoutObservable(source)
	                : Rx.Observable.of(source))
	                .map(function (r) { return r || dataProvider_1.emptyValue; }); // normalize undefined/null results
	        this.scheduler = settings.scheduler;
	        // Explicitly subscribe to _stream to ensure that "findItem" will
	        // always have the latest data. This is needed for legacy reasons.
	        this._stream.subscribe(function (r) {
	            _this._lastSearch.data = r.data;
	            _this._lastSearch.reset();
	        });
	    }
	    // -------------------------------------------------------------------------
	    // Public actions
	    // -------------------------------------------------------------------------
	    /**
	     * Finds an item by its identifier value.
	     *
	     * @param value
	     *     Identifier to search for based on the provider's searchIndex value.
	     * @returns
	     *     Object containing the found item (if exactly one), the match descriptor,
	     *     and the search result.
	     */
	    KnockoutDataProvider.prototype.findItem = function (value) {
	        var result = this._lastSearch.search(value);
	        var item = (result !== false && this._lastSearch.exactMatch && value !== null
	            ? this._lastSearch.getFoundRow(null)
	            : null);
	        var match = (result !== false && this._lastSearch.exactMatch
	            ? MatchResult.ExactMatch
	            : (this._lastSearch.nextIndex === -1
	                ? MatchResult.NoMatch
	                : MatchResult.MultipleMatches));
	        return { item: item, match: match, result: result };
	    };
	    /**
	     * Gets a stream of query results from the given stream of queries.
	     *
	     * For Initial- or Grid-origin queries, uses the itemFilterBuilder as
	     * a filtering method; for Select-origin queries, uses the (simpler) prefix
	     * filtering method.
	     *
	     * @param requestStream
	     *     Observable stream of incoming filter requests.
	     * @param origin?
	     *     The origin of the filter request.
	     * @returns
	     *     Observable stream of search results.
	     */
	    KnockoutDataProvider.prototype.search = function (requestStream, origin) {
	        var _this = this;
	        if (origin === void 0) { origin = dataProvider_1.QueryOrigin.Select; }
	        var settings = {
	            scheduler: this.scheduler,
	            debounceTime: origin === dataProvider_1.QueryOrigin.Grid ? this._debounceTime : 0
	        };
	        return shared_1.getDebouncedResponsesFor(Rx.Observable.combineLatest(this._stream, requestStream), function (_a) {
	            var response = _a[0], request = _a[1];
	            return _this._filterResponse(response, request, origin);
	        }, settings);
	    };
	    // -------------------------------------------------------------------------
	    // Protected
	    // -------------------------------------------------------------------------
	    /**
	     * Filters a data provider response based on a filter string and the query origin.
	     *
	     * Merges request context, if any, into response.
	     */
	    KnockoutDataProvider.prototype._filterResponse = function (response, request, origin) {
	        var responseStream = null;
	        switch (origin) {
	            case dataProvider_1.QueryOrigin.Initial:
	            case dataProvider_1.QueryOrigin.Grid:
	                responseStream = request.filter
	                    ? this._filterByBuilder(response, request.filter)
	                    : Rx.Observable.of(response);
	                break;
	            case dataProvider_1.QueryOrigin.Select:
	                responseStream = this._filterByPrefix(response, request.filter);
	                break;
	            default:
	                throw new Error("Unsupported QueryOrigin value: \"" + origin + "\"");
	        }
	        return responseStream.map(function (r) { return request.context ? ramda_1.merge(r, { context: request.context }) : r; });
	    };
	    // -------------------------------------------------------------------------
	    // Private
	    // -------------------------------------------------------------------------
	    /**
	     * Filter using the ItemFilterBuilder set for this provider instance.
	     */
	    KnockoutDataProvider.prototype._filterByBuilder = function (response, filter) {
	        var data = response.data;
	        // picklist data is not yet available
	        if (data === null) {
	            return emptyValueStream;
	        }
	        var itemFilter = this._itemFilterBuilder(data.items, [this._searchIndex]);
	        var itemFilterStream = Rx.Observable.bindCallback(itemFilter);
	        return itemFilterStream(filter).map(function (items) { return ({
	            data: ramda_1.merge(data, { items: items, resultCount: items.length }),
	            error: null
	        }); });
	    };
	    /**
	     * Fast filter that does a prefix match against the searchable column.
	     */
	    KnockoutDataProvider.prototype._filterByPrefix = function (response, filter) {
	        if (filter === void 0) { filter = ""; }
	        var data = response.data;
	        // picklist data is not yet available
	        if (data === null) {
	            return emptyValueStream;
	        }
	        // picklist data is available, find all matches
	        var regex = string_1.createSearchRegexFor(filter);
	        var items = [];
	        var i = -1;
	        var moreResults = false;
	        for (;;) {
	            i = this._lastSearch.findNextMatch(regex, i + 1);
	            if (i === -1) {
	                break;
	            }
	            if (this._limit > 0 && items.length >= this._limit) {
	                moreResults = true;
	                break;
	            }
	            items.push(data.items[i]);
	        }
	        return Rx.Observable.of({
	            data: ramda_1.merge(data, { items: items, resultCount: moreResults ? items.length + 1 : items.length }),
	            error: null
	        });
	    };
	    return KnockoutDataProvider;
	}());
	exports.KnockoutDataProvider = KnockoutDataProvider;
	/**
	 * Current Knockout data provider class. Updated by "useKnockoutDataProviderClass".
	 */
	var currentKnockoutDataProviderClass = KnockoutDataProvider;
	/**
	 * Creates an instance of current Knockout data provider (an override specified by "useKnockoutDataProviderClass" or "KnockoutDataProvider" if no override is active).
	 */
	function createKnockoutDataProvider(source, settings) {
	    return new currentKnockoutDataProviderClass(source, settings);
	}
	exports.createKnockoutDataProvider = createKnockoutDataProvider;
	/**
	 * Replaces default Knockout data provider class with the specified class until the returned disposable is disposed.
	 */
	function useKnockoutDataProviderClass(overrideClass) {
	    if (currentKnockoutDataProviderClass !== KnockoutDataProvider) {
	        throw new Error("Knockout data provider class has already been overridden, unable to override again.");
	    }
	    if (typeof overrideClass !== "function") {
	        throw new Error("Knockout data provider override class was expected to be a JavaScript function.");
	    }
	    currentKnockoutDataProviderClass = overrideClass;
	    return new disposable_1.ActionDisposable(function () { return currentKnockoutDataProviderClass = KnockoutDataProvider; });
	}
	exports.useKnockoutDataProviderClass = useKnockoutDataProviderClass;
	



/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var searchQuery_1 = __webpack_require__(371);
	var string_1 = __webpack_require__(13);
	/**
	 * Default item filter, using 'buildPrefixMatch' as the property/default value matcher.
	 */
	function defaultItemFilter(query, item, filterColumns) {
	    switch (query.type) {
	        case "and":
	            return defaultItemFilter(query.children[0], item, filterColumns)
	                && defaultItemFilter(query.children[1], item, filterColumns);
	        case "not":
	            return !defaultItemFilter(query.children[0], item, filterColumns);
	        case "or":
	            return defaultItemFilter(query.children[0], item, filterColumns)
	                || defaultItemFilter(query.children[1], item, filterColumns);
	        case "property":
	            var propertyMatcher = string_1.buildPrefixMatcher(query.phrase);
	            return propertyMatcher.test(getValue(item, query.property));
	        default:
	            var defaultMatcher = string_1.buildPrefixMatcher(query.phrase);
	            for (var _i = 0, filterColumns_1 = filterColumns; _i < filterColumns_1.length; _i++) {
	                var column = filterColumns_1[_i];
	                if (defaultMatcher.test(getValue(item, column))) {
	                    return true;
	                }
	            }
	            return false;
	    }
	}
	/**
	 * Unwraps the display value of an item at the given key.
	 */
	function getValue(item, key) {
	    var o = item[key];
	    if (o && typeof o.peekValue === "function") {
	        return o.peekValue();
	    }
	    if (o && typeof o.peek === "function") {
	        return o.peek();
	    }
	    return o;
	}
	/**
	 * Returns an item filter that uses 'searchquery' semantics with prefix-matching.
	 *
	 * @param items
	 *     Items to filter.
	 * @param filterColumns
	 *     Columns (keys/indices) that will be searched by default.
	 * @returns
	 *     ItemFilter function that invokes the supplied callback with the matching items.
	 */
	function defaultItemFilterBuilder(items, filterColumns) {
	    return function (filterValue, callback) {
	        var query = searchQuery_1.parse(filterValue);
	        try {
	            var matchingItems = items.filter(function (item) { return defaultItemFilter(query, item, filterColumns); });
	            callback(matchingItems);
	        }
	        catch (e) {
	            callback(e);
	        }
	    };
	}
	exports.defaultItemFilterBuilder = defaultItemFilterBuilder;
	



/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var stringUtil = __webpack_require__(13);
	
	var queryParser = __webpack_require__(372);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	// matches quotes globally
	var addQuotes = new RegExp('"', "g");
	
	// matches a string that needs quotes
	var needsQuotesRegex = new RegExp("[\\s:()]|^and$|^or$|^not$", "i");
	
	// matches quotes at the start/end and escaped quotes (\")
	var removeQuotesRegex = new RegExp('^(?:\\s*)"|(?:\\\\")|"(?:\\s*)$', "g");
	
	//-------------------------------------------
	function unquoteReplace(value) {
	    return (value === '"' ? "" : '"');
	}
	
	
	//-------------------------------------------
	function unquote(value) {
	    return (typeof value === "string"
	        ? value.replace(removeQuotesRegex, unquoteReplace)
	        : value);
	}
	
	
	//-------------------------------------------
	function quote(value) {
	    return (typeof value === "string" && needsQuotesRegex.test(value)
	        ? '"'.concat(value.replace(addQuotes, '\\"'), '"')
	        : value);
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// SearchQuery view-model
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Represents a structured search query.
	function SearchQuery(children, phrase, property, type) {
	    if (stringUtil.isNullOrWhitespace(type)) { throw new Error("type must be a string."); }
	
	    switch (type) {
	    case "and":
	    case "or":
	        if (!Array.isArray(children) || children.length < 2) { throw new Error("'and' and 'or' types must contain at least two items"); }
	        this.children = children;
	        this.type = type;
	        break;
	    case "not":
	        if (!Array.isArray(children) || children.length !== 1) { throw new Error("'not' type must contain exactly one item"); }
	        this.children = children;
	        this.type = type;
	        break;
	    case "property":
	        if (stringUtil.isNullOrWhitespace(property)) { throw new Error("'property' type must specify property"); }
	        this.phrase = phrase;
	        this.property = property;
	        this.type = type;
	        break;
	    default:
	        if (stringUtil.isNullOrWhitespace(phrase)) { throw new Error("'default' type must specify phrase"); }
	        this.property = "";
	        this.phrase = phrase;
	        this.type = "default";
	        break;
	    }
	}
	
	
	//-------------------------------------------
	SearchQuery.prototype.buildBinary = function searchQueryBuildBinary(type, children) {
	    var result;
	    switch (type) {
	    case "and":
	    case "not":
	    case "or":
	        result = new SearchQuery(
	            Array.isArray(children) ? children : [].splice.call(arguments, 1, arguments.length),
	            null,
	            null,
	            type
	        );
	        break;
	    default:
	        throw new Error("only 'and', 'not' and 'or' types are supported.");
	    }
	    return result;
	};
	
	
	//-------------------------------------------
	SearchQuery.prototype.buildPhrase = function searchQueryBuildPhrase(phrase) {
	    return new SearchQuery(null, phrase, null, "default");
	};
	
	
	//-------------------------------------------
	SearchQuery.prototype.buildProperty = function searchQueryBuildProperty(property, phrase) {
	    return new SearchQuery(null, phrase, property, "property");
	};
	
	
	//-------------------------------------------
	SearchQuery.prototype.load = function searchQueryLoad(value) {
	    var result = null;
	    if (!stringUtil.isNullOrWhitespace(value)) {
	        result = SearchQuery.prototype.buildPhrase(value);
	    } else if (Array.isArray(value)) {
	        if (value.length === 2) {
	            result = SearchQuery.prototype.buildProperty(value[0], value[1]);
	        }
	    } else if (typeof value === "object") {
	        var children, type, i, l;
	        if (Array.isArray(value.and)) {
	            type = "and";
	            children = value.and;
	        } else if (Array.isArray(value.or)) {
	            type = "or";
	            children = value.or;
	        } else if (value.not) {
	            type = "not";
	            children = [value.not];
	        }
	        if (type) {
	            for (i = 0, l = children.length; i < l; i += 1) {
	                children[i] = SearchQuery.prototype.load(children[i]);
	            }
	            result = SearchQuery.prototype.buildBinary(type, children);
	        }
	    }
	    return result;
	};
	
	
	//-------------------------------------------
	SearchQuery.prototype.parse = function searchQueryParse(s) {
	    return SearchQuery.prototype._loadParsed(queryParser.parse(s));
	};
	
	
	//-------------------------------------------
	SearchQuery.prototype.toString = function searchQueryToString() {
	    return SearchQuery.prototype._buildQuery(this);
	};
	
	
	//-------------------------------------------
	// Builds the string representation of a SearchQuery.
	SearchQuery.prototype._buildQuery = function searchQueryBuildQuery(query) {
	    switch (query.type) {
	    case "and":
	        return SearchQuery.prototype._buildQueryGroup(query.children, " AND ");
	    case "not":
	        var child = query.children[0],
	            parsed = SearchQuery.prototype._buildQuery(child);
	        return "NOT "
	            .concat(child.type === "and" || child.type === "or"
	                ? "(".concat(parsed, ")")
	                : parsed);
	    case "or":
	        return SearchQuery.prototype._buildQueryGroup(query.children, " OR ");
	    case "property":
	        return "".concat(quote(query.property), ":", quote(query.phrase));
	    default:
	        return quote(query.phrase);
	    }
	};
	
	
	//-------------------------------------------
	SearchQuery.prototype._buildQueryGroup = function searchQueryBuildQueryGroup(children, separator) {
	    if (!Array.isArray(children)) { return ""; }
	
	    var result = [], i, l,
	        child, parsed;
	    for (i = 0, l = children.length; i < l; i += 1) {
	        child = children[i];
	        parsed = SearchQuery.prototype._buildQuery(child);
	        result.push((child.type === "and" || child.type === "or" || child.type === "not")
	            ? "(".concat(parsed, ")")
	            : parsed);
	    }
	    return result.join(separator);
	};
	
	
	//-------------------------------------------
	// Loads the jison parsed result.
	SearchQuery.prototype._loadParsed = function searchQueryLoadParsed(s) {
	    var binaryOperator, left, right,
	        result = false;
	    if (!stringUtil.isNullOrWhitespace(s)) {
	        s = unquote(s);
	        result = stringUtil.isNullOrWhitespace(s) ? null : SearchQuery.prototype.buildPhrase(s);
	    } else if (Array.isArray(s)) {
	        switch (s.length) {
	        case 2:
	            result = SearchQuery.prototype.buildProperty(unquote(s[0]), unquote(s[1]));
	            break;
	        case 3:
	            binaryOperator = s[1] === "implied" ? "and" : s[1];
	            left = SearchQuery.prototype._loadParsed(s[0]);
	            right = SearchQuery.prototype._loadParsed(s[2]);
	            if (left === null || right === null) {
	                result = left || right;
	            } else if (left.type === binaryOperator && right.type === binaryOperator) {
	                result = SearchQuery.prototype.buildBinary(binaryOperator, left.children.concat(right.children));
	            } else if (left.type === binaryOperator) {
	                result = SearchQuery.prototype.buildBinary(binaryOperator, left.children.concat([right]));
	            } else if (right.type === binaryOperator) {
	                result = SearchQuery.prototype.buildBinary(binaryOperator, [left].concat(right.children));
	            } else {
	                result = SearchQuery.prototype.buildBinary(binaryOperator, [left, right]);
	            }
	            break;
	        }
	    } else if (typeof s === "object") {
	        if (s.brackets !== undefined) {
	            result = SearchQuery.prototype._loadParsed(s.brackets);
	        } else if (s.not !== undefined) {
	            result = SearchQuery.prototype.buildBinary("not", SearchQuery.prototype._loadParsed(s.not));
	        }
	    }
	    return result;
	};
	
	module.exports = {
	    buildBinary: SearchQuery.prototype.buildBinary,
	    buildPhrase: SearchQuery.prototype.buildPhrase,
	    buildProperty: SearchQuery.prototype.buildProperty,
	    load: SearchQuery.prototype.load,
	    parse: SearchQuery.prototype.parse
	};
	


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/* parser generated by jison 0.4.17 */
	/*
	  Returns a Parser object of the following structure:
	
	  Parser: {
	    yy: {}
	  }
	
	  Parser.prototype: {
	    yy: {},
	    trace: function(),
	    symbols_: {associative list: name ==> number},
	    terminals_: {associative list: number ==> name},
	    productions_: [...],
	    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
	    table: [...],
	    defaultActions: {...},
	    parseError: function(str, hash),
	    parse: function(input),
	
	    lexer: {
	        EOF: 1,
	        parseError: function(str, hash),
	        setInput: function(input),
	        input: function(),
	        unput: function(str),
	        more: function(),
	        less: function(n),
	        pastInput: function(),
	        upcomingInput: function(),
	        showPosition: function(),
	        test_match: function(regex_match_array, rule_index),
	        next: function(),
	        lex: function(),
	        begin: function(condition),
	        popState: function(),
	        _currentRules: function(),
	        topState: function(),
	        pushState: function(condition),
	
	        options: {
	            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
	            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
	            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
	        },
	
	        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
	        rules: [...],
	        conditions: {associative list: name ==> set},
	    }
	  }
	
	
	  token location info (@$, _$, etc.): {
	    first_line: n,
	    last_line: n,
	    first_column: n,
	    last_column: n,
	    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
	  }
	
	
	  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
	    text:        (matched text)
	    token:       (the produced terminal token, if any)
	    line:        (yylineno)
	  }
	  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
	    loc:         (yylloc)
	    expected:    (string describing the set of expected tokens)
	    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
	  }
	*/
	var parser = (function(){
	var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,5],$V1=[1,6],$V2=[1,9],$V3=[1,10],$V4=[1,14],$V5=[1,15],$V6=[5,7,8,9,10,11,15,16],$V7=[5,7,8,9,10,11,14,15,16];
	var parser = {trace: function trace() { },
	yy: {},
	symbols_: {"error":2,"expressions":3,"expression":4,"EOF":5,"binary":6,"AND":7,"OR":8,"NOT":9,"(":10,")":11,"phrase":12,"text":13,":":14,"WORD":15,"QUOTED":16,"$accept":0,"$end":1},
	terminals_: {2:"error",5:"EOF",7:"AND",8:"OR",9:"NOT",10:"(",11:")",14:":",15:"WORD",16:"QUOTED"},
	productions_: [0,[3,2],[3,2],[4,1],[4,2],[6,3],[6,3],[6,2],[6,3],[6,1],[12,3],[12,2],[12,1],[13,1],[13,1]],
	performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
	/* this == yyval */
	
	var $0 = $$.length - 1;
	switch (yystate) {
	case 1:
	 return $$[$0-1]; 
	break;
	case 2:
	 return false; 
	break;
	case 3: case 9: case 12:
	 this.$ = $$[$0]; 
	break;
	case 4:
	 this.$ = [$$[$0-1], "implied", $$[$0]]; 
	break;
	case 5:
	 this.$ = [$$[$0-2], "and", $$[$0]]; 
	break;
	case 6:
	 this.$ = [$$[$0-2], "or", $$[$0]]; 
	break;
	case 7:
	 this.$ = { not: $$[$0] }; 
	break;
	case 8:
	 this.$ = { brackets: $$[$0-1] }; 
	break;
	case 10:
	 this.$ = [$$[$0-2], $$[$0]]; 
	break;
	case 11:
	 this.$ = [$$[$0-1], ""]; 
	break;
	case 13: case 14:
	 this.$ = yytext; 
	break;
	}
	},
	table: [{2:[1,3],3:1,4:2,6:4,9:$V0,10:$V1,12:7,13:8,15:$V2,16:$V3},{1:[3]},{5:[1,11]},{5:[1,12]},{4:13,5:[2,3],6:4,7:$V4,8:$V5,9:$V0,10:$V1,12:7,13:8,15:$V2,16:$V3},{6:16,9:$V0,10:$V1,12:7,13:8,15:$V2,16:$V3},{6:17,9:$V0,10:$V1,12:7,13:8,15:$V2,16:$V3},o($V6,[2,9]),o($V6,[2,12],{14:[1,18]}),o($V7,[2,13]),o($V7,[2,14]),{1:[2,1]},{1:[2,2]},{5:[2,4]},{6:19,9:$V0,10:$V1,12:7,13:8,15:$V2,16:$V3},{6:20,9:$V0,10:$V1,12:7,13:8,15:$V2,16:$V3},o($V6,[2,7]),{7:$V4,8:$V5,11:[1,21]},o([5,7,8,9,10,11],[2,11],{13:22,15:$V2,16:$V3}),o($V6,[2,5]),o($V6,[2,6]),o($V6,[2,8]),o($V6,[2,10])],
	defaultActions: {11:[2,1],12:[2,2],13:[2,4]},
	parseError: function parseError(str, hash) {
	    if (hash.recoverable) {
	        this.trace(str);
	    } else {
	        function _parseError (msg, hash) {
	            this.message = msg;
	            this.hash = hash;
	        }
	        _parseError.prototype = Error;
	
	        throw new _parseError(str, hash);
	    }
	},
	parse: function parse(input) {
	    var self = this,
	        stack = [0],
	        tstack = [], // token stack
	        vstack = [null], // semantic value stack
	        lstack = [], // location stack
	        table = this.table,
	        yytext = '',
	        yylineno = 0,
	        yyleng = 0,
	        recovering = 0,
	        TERROR = 2,
	        EOF = 1;
	
	    var args = lstack.slice.call(arguments, 1);
	
	    //this.reductionCount = this.shiftCount = 0;
	
	    var lexer = Object.create(this.lexer);
	    var sharedState = { yy: {} };
	    // copy state
	    for (var k in this.yy) {
	      if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
	        sharedState.yy[k] = this.yy[k];
	      }
	    }
	
	    lexer.setInput(input, sharedState.yy);
	    sharedState.yy.lexer = lexer;
	    sharedState.yy.parser = this;
	    if (typeof lexer.yylloc == 'undefined') {
	        lexer.yylloc = {};
	    }
	    var yyloc = lexer.yylloc;
	    lstack.push(yyloc);
	
	    var ranges = lexer.options && lexer.options.ranges;
	
	    if (typeof sharedState.yy.parseError === 'function') {
	        this.parseError = sharedState.yy.parseError;
	    } else {
	        this.parseError = Object.getPrototypeOf(this).parseError;
	    }
	
	    function popStack (n) {
	        stack.length = stack.length - 2 * n;
	        vstack.length = vstack.length - n;
	        lstack.length = lstack.length - n;
	    }
	
	_token_stack:
	    var lex = function () {
	        var token;
	        token = lexer.lex() || EOF;
	        // if token isn't its numeric value, convert
	        if (typeof token !== 'number') {
	            token = self.symbols_[token] || token;
	        }
	        return token;
	    }
	
	    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
	    while (true) {
	        // retreive state number from top of stack
	        state = stack[stack.length - 1];
	
	        // use default actions if available
	        if (this.defaultActions[state]) {
	            action = this.defaultActions[state];
	        } else {
	            if (symbol === null || typeof symbol == 'undefined') {
	                symbol = lex();
	            }
	            // read action for current state and first input
	            action = table[state] && table[state][symbol];
	        }
	
	_handle_error:
	        // handle parse error
	        if (typeof action === 'undefined' || !action.length || !action[0]) {
	            var error_rule_depth;
	            var errStr = '';
	
	            // Return the rule stack depth where the nearest error rule can be found.
	            // Return FALSE when no error recovery rule was found.
	            function locateNearestErrorRecoveryRule(state) {
	                var stack_probe = stack.length - 1;
	                var depth = 0;
	
	                // try to recover from error
	                for(;;) {
	                    // check for error recovery rule in this state
	                    if ((TERROR.toString()) in table[state]) {
	                        return depth;
	                    }
	                    if (state === 0 || stack_probe < 2) {
	                        return false; // No suitable error recovery rule available.
	                    }
	                    stack_probe -= 2; // popStack(1): [symbol, action]
	                    state = stack[stack_probe];
	                    ++depth;
	                }
	            }
	
	            if (!recovering) {
	                // first see if there's any chance at hitting an error recovery rule:
	                error_rule_depth = locateNearestErrorRecoveryRule(state);
	
	                // Report error
	                expected = [];
	                for (p in table[state]) {
	                    if (this.terminals_[p] && p > TERROR) {
	                        expected.push("'"+this.terminals_[p]+"'");
	                    }
	                }
	                if (lexer.showPosition) {
	                    errStr = 'Parse error on line '+(yylineno+1)+":\n"+lexer.showPosition()+"\nExpecting "+expected.join(', ') + ", got '" + (this.terminals_[symbol] || symbol)+ "'";
	                } else {
	                    errStr = 'Parse error on line '+(yylineno+1)+": Unexpected " +
	                                  (symbol == EOF ? "end of input" :
	                                              ("'"+(this.terminals_[symbol] || symbol)+"'"));
	                }
	                this.parseError(errStr, {
	                    text: lexer.match,
	                    token: this.terminals_[symbol] || symbol,
	                    line: lexer.yylineno,
	                    loc: yyloc,
	                    expected: expected,
	                    recoverable: (error_rule_depth !== false)
	                });
	            } else if (preErrorSymbol !== EOF) {
	                error_rule_depth = locateNearestErrorRecoveryRule(state);
	            }
	
	            // just recovered from another error
	            if (recovering == 3) {
	                if (symbol === EOF || preErrorSymbol === EOF) {
	                    throw new Error(errStr || 'Parsing halted while starting to recover from another error.');
	                }
	
	                // discard current lookahead and grab another
	                yyleng = lexer.yyleng;
	                yytext = lexer.yytext;
	                yylineno = lexer.yylineno;
	                yyloc = lexer.yylloc;
	                symbol = lex();
	            }
	
	            // try to recover from error
	            if (error_rule_depth === false) {
	                throw new Error(errStr || 'Parsing halted. No suitable error recovery rule available.');
	            }
	            popStack(error_rule_depth);
	
	            preErrorSymbol = (symbol == TERROR ? null : symbol); // save the lookahead token
	            symbol = TERROR;         // insert generic error symbol as new lookahead
	            state = stack[stack.length-1];
	            action = table[state] && table[state][TERROR];
	            recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
	        }
	
	        // this shouldn't happen, unless resolve defaults are off
	        if (action[0] instanceof Array && action.length > 1) {
	            throw new Error('Parse Error: multiple actions possible at state: '+state+', token: '+symbol);
	        }
	
	        switch (action[0]) {
	            case 1: // shift
	                //this.shiftCount++;
	
	                stack.push(symbol);
	                vstack.push(lexer.yytext);
	                lstack.push(lexer.yylloc);
	                stack.push(action[1]); // push state
	                symbol = null;
	                if (!preErrorSymbol) { // normal execution/no error
	                    yyleng = lexer.yyleng;
	                    yytext = lexer.yytext;
	                    yylineno = lexer.yylineno;
	                    yyloc = lexer.yylloc;
	                    if (recovering > 0) {
	                        recovering--;
	                    }
	                } else {
	                    // error just occurred, resume old lookahead f/ before error
	                    symbol = preErrorSymbol;
	                    preErrorSymbol = null;
	                }
	                break;
	
	            case 2:
	                // reduce
	                //this.reductionCount++;
	
	                len = this.productions_[action[1]][1];
	
	                // perform semantic action
	                yyval.$ = vstack[vstack.length-len]; // default to $$ = $1
	                // default location, uses first token for firsts, last for lasts
	                yyval._$ = {
	                    first_line: lstack[lstack.length-(len||1)].first_line,
	                    last_line: lstack[lstack.length-1].last_line,
	                    first_column: lstack[lstack.length-(len||1)].first_column,
	                    last_column: lstack[lstack.length-1].last_column
	                };
	                if (ranges) {
	                  yyval._$.range = [lstack[lstack.length-(len||1)].range[0], lstack[lstack.length-1].range[1]];
	                }
	                r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));
	
	                if (typeof r !== 'undefined') {
	                    return r;
	                }
	
	                // pop off stack
	                if (len) {
	                    stack = stack.slice(0,-1*len*2);
	                    vstack = vstack.slice(0, -1*len);
	                    lstack = lstack.slice(0, -1*len);
	                }
	
	                stack.push(this.productions_[action[1]][0]);    // push nonterminal (reduce)
	                vstack.push(yyval.$);
	                lstack.push(yyval._$);
	                // goto new state = table[STATE][NONTERMINAL]
	                newState = table[stack[stack.length-2]][stack[stack.length-1]];
	                stack.push(newState);
	                break;
	
	            case 3:
	                // accept
	                return true;
	        }
	
	    }
	
	    return true;
	}};
	/* generated by jison-lex 0.3.4 */
	var lexer = (function(){
	var lexer = ({
	
	EOF:1,
	
	parseError:function parseError(str, hash) {
	        if (this.yy.parser) {
	            this.yy.parser.parseError(str, hash);
	        } else {
	            throw new Error(str);
	        }
	    },
	
	// resets the lexer, sets new input
	setInput:function (input, yy) {
	        this.yy = yy || this.yy || {};
	        this._input = input;
	        this._more = this._backtrack = this.done = false;
	        this.yylineno = this.yyleng = 0;
	        this.yytext = this.matched = this.match = '';
	        this.conditionStack = ['INITIAL'];
	        this.yylloc = {
	            first_line: 1,
	            first_column: 0,
	            last_line: 1,
	            last_column: 0
	        };
	        if (this.options.ranges) {
	            this.yylloc.range = [0,0];
	        }
	        this.offset = 0;
	        return this;
	    },
	
	// consumes and returns one char from the input
	input:function () {
	        var ch = this._input[0];
	        this.yytext += ch;
	        this.yyleng++;
	        this.offset++;
	        this.match += ch;
	        this.matched += ch;
	        var lines = ch.match(/(?:\r\n?|\n).*/g);
	        if (lines) {
	            this.yylineno++;
	            this.yylloc.last_line++;
	        } else {
	            this.yylloc.last_column++;
	        }
	        if (this.options.ranges) {
	            this.yylloc.range[1]++;
	        }
	
	        this._input = this._input.slice(1);
	        return ch;
	    },
	
	// unshifts one char (or a string) into the input
	unput:function (ch) {
	        var len = ch.length;
	        var lines = ch.split(/(?:\r\n?|\n)/g);
	
	        this._input = ch + this._input;
	        this.yytext = this.yytext.substr(0, this.yytext.length - len);
	        //this.yyleng -= len;
	        this.offset -= len;
	        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
	        this.match = this.match.substr(0, this.match.length - 1);
	        this.matched = this.matched.substr(0, this.matched.length - 1);
	
	        if (lines.length - 1) {
	            this.yylineno -= lines.length - 1;
	        }
	        var r = this.yylloc.range;
	
	        this.yylloc = {
	            first_line: this.yylloc.first_line,
	            last_line: this.yylineno + 1,
	            first_column: this.yylloc.first_column,
	            last_column: lines ?
	                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
	                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
	              this.yylloc.first_column - len
	        };
	
	        if (this.options.ranges) {
	            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
	        }
	        this.yyleng = this.yytext.length;
	        return this;
	    },
	
	// When called from action, caches matched text and appends it on next action
	more:function () {
	        this._more = true;
	        return this;
	    },
	
	// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
	reject:function () {
	        if (this.options.backtrack_lexer) {
	            this._backtrack = true;
	        } else {
	            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
	                text: "",
	                token: null,
	                line: this.yylineno
	            });
	
	        }
	        return this;
	    },
	
	// retain first n characters of the match
	less:function (n) {
	        this.unput(this.match.slice(n));
	    },
	
	// displays already matched input, i.e. for error messages
	pastInput:function () {
	        var past = this.matched.substr(0, this.matched.length - this.match.length);
	        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
	    },
	
	// displays upcoming input, i.e. for error messages
	upcomingInput:function () {
	        var next = this.match;
	        if (next.length < 20) {
	            next += this._input.substr(0, 20-next.length);
	        }
	        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
	    },
	
	// displays the character position where the lexing error occurred, i.e. for error messages
	showPosition:function () {
	        var pre = this.pastInput();
	        var c = new Array(pre.length + 1).join("-");
	        return pre + this.upcomingInput() + "\n" + c + "^";
	    },
	
	// test the lexed token: return FALSE when not a match, otherwise return token
	test_match:function (match, indexed_rule) {
	        var token,
	            lines,
	            backup;
	
	        if (this.options.backtrack_lexer) {
	            // save context
	            backup = {
	                yylineno: this.yylineno,
	                yylloc: {
	                    first_line: this.yylloc.first_line,
	                    last_line: this.last_line,
	                    first_column: this.yylloc.first_column,
	                    last_column: this.yylloc.last_column
	                },
	                yytext: this.yytext,
	                match: this.match,
	                matches: this.matches,
	                matched: this.matched,
	                yyleng: this.yyleng,
	                offset: this.offset,
	                _more: this._more,
	                _input: this._input,
	                yy: this.yy,
	                conditionStack: this.conditionStack.slice(0),
	                done: this.done
	            };
	            if (this.options.ranges) {
	                backup.yylloc.range = this.yylloc.range.slice(0);
	            }
	        }
	
	        lines = match[0].match(/(?:\r\n?|\n).*/g);
	        if (lines) {
	            this.yylineno += lines.length;
	        }
	        this.yylloc = {
	            first_line: this.yylloc.last_line,
	            last_line: this.yylineno + 1,
	            first_column: this.yylloc.last_column,
	            last_column: lines ?
	                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
	                         this.yylloc.last_column + match[0].length
	        };
	        this.yytext += match[0];
	        this.match += match[0];
	        this.matches = match;
	        this.yyleng = this.yytext.length;
	        if (this.options.ranges) {
	            this.yylloc.range = [this.offset, this.offset += this.yyleng];
	        }
	        this._more = false;
	        this._backtrack = false;
	        this._input = this._input.slice(match[0].length);
	        this.matched += match[0];
	        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
	        if (this.done && this._input) {
	            this.done = false;
	        }
	        if (token) {
	            return token;
	        } else if (this._backtrack) {
	            // recover context
	            for (var k in backup) {
	                this[k] = backup[k];
	            }
	            return false; // rule action called reject() implying the next rule should be tested instead.
	        }
	        return false;
	    },
	
	// return next match in input
	next:function () {
	        if (this.done) {
	            return this.EOF;
	        }
	        if (!this._input) {
	            this.done = true;
	        }
	
	        var token,
	            match,
	            tempMatch,
	            index;
	        if (!this._more) {
	            this.yytext = '';
	            this.match = '';
	        }
	        var rules = this._currentRules();
	        for (var i = 0; i < rules.length; i++) {
	            tempMatch = this._input.match(this.rules[rules[i]]);
	            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
	                match = tempMatch;
	                index = i;
	                if (this.options.backtrack_lexer) {
	                    token = this.test_match(tempMatch, rules[i]);
	                    if (token !== false) {
	                        return token;
	                    } else if (this._backtrack) {
	                        match = false;
	                        continue; // rule action called reject() implying a rule MISmatch.
	                    } else {
	                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
	                        return false;
	                    }
	                } else if (!this.options.flex) {
	                    break;
	                }
	            }
	        }
	        if (match) {
	            token = this.test_match(match, rules[index]);
	            if (token !== false) {
	                return token;
	            }
	            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
	            return false;
	        }
	        if (this._input === "") {
	            return this.EOF;
	        } else {
	            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
	                text: "",
	                token: null,
	                line: this.yylineno
	            });
	        }
	    },
	
	// return next match that has a token
	lex:function lex() {
	        var r = this.next();
	        if (r) {
	            return r;
	        } else {
	            return this.lex();
	        }
	    },
	
	// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
	begin:function begin(condition) {
	        this.conditionStack.push(condition);
	    },
	
	// pop the previously active lexer condition state off the condition stack
	popState:function popState() {
	        var n = this.conditionStack.length - 1;
	        if (n > 0) {
	            return this.conditionStack.pop();
	        } else {
	            return this.conditionStack[0];
	        }
	    },
	
	// produce the lexer rule set which is active for the currently active lexer condition state
	_currentRules:function _currentRules() {
	        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
	            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
	        } else {
	            return this.conditions["INITIAL"].rules;
	        }
	    },
	
	// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
	topState:function topState(n) {
	        n = this.conditionStack.length - 1 - Math.abs(n || 0);
	        if (n >= 0) {
	            return this.conditionStack[n];
	        } else {
	            return "INITIAL";
	        }
	    },
	
	// alias for begin(condition)
	pushState:function pushState(condition) {
	        this.begin(condition);
	    },
	
	// return the number of states currently on the stack
	stateStackSize:function stateStackSize() {
	        return this.conditionStack.length;
	    },
	options: {"case-insensitive":true},
	performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
	var YYSTATE=YY_START;
	switch($avoiding_name_collisions) {
	case 0:// skip whitespace
	break;
	case 1:return 7
	break;
	case 2:return 8
	break;
	case 3:return 9
	break;
	case 4:return 10
	break;
	case 5:return 11
	break;
	case 6:return 14
	break;
	case 7:return 16
	break;
	case 8:return 15
	break;
	case 9:return 5
	break;
	}
	},
	rules: [/^(?:\s+)/i,/^(?:and\b)/i,/^(?:or\b)/i,/^(?:not\b)/i,/^(?:\()/i,/^(?:\))/i,/^(?::)/i,/^(?:["]([^"\\]*(?:\\.[^"\\]*)*)["]*)/i,/^(?:[^\s:)"]+)/i,/^(?:$)/i],
	conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9],"inclusive":true}}
	});
	return lexer;
	})();
	parser.lexer = lexer;
	function Parser () {
	  this.yy = {};
	}
	Parser.prototype = parser;parser.Parser = Parser;
	return new Parser;
	})();
	
	
	if (true) {
	exports.parser = parser;
	exports.Parser = parser.Parser;
	exports.parse = function () { return parser.parse.apply(parser, arguments); };
	exports.main = function commonjsMain(args) {
	    if (!args[1]) {
	        console.log('Usage: '+args[0]+' FILE');
	        process.exit(1);
	    }
	    var source = __webpack_require__(373).readFileSync(__webpack_require__(374).normalize(args[1]), "utf8");
	    return exports.parser.parse(source);
	};
	if (typeof module !== 'undefined' && __webpack_require__.c[0] === module) {
	  exports.main(process.argv.slice(1));
	}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(311), __webpack_require__(19)(module)))

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(311)))

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	/**
	 * Disposes a Disposable or Subscription instance.
	 */
	function dispose(d) {
	    if (isDisposable(d)) {
	        d.dispose();
	    }
	    else if (isSubscription(d)) {
	        d.unsubscribe();
	    }
	}
	/**
	 * Disposable that runs the specified action in the specified
	 * (optional) "this" context during disposal.
	 */
	var ActionDisposable = (function () {
	    function ActionDisposable(action, context) {
	        this._action = action;
	        this._context = context;
	    }
	    ActionDisposable.prototype.dispose = function () {
	        this._action.call(this._context);
	    };
	    return ActionDisposable;
	}());
	exports.ActionDisposable = ActionDisposable;
	/**
	 * Represents a group of disposable resources that are disposed together (in order or registration).
	 */
	var CompositeDisposable = (function () {
	    function CompositeDisposable() {
	        var disposables = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            disposables[_i - 0] = arguments[_i];
	        }
	        this._disposed = false;
	        this._disposables = disposables.filter(function (d) { return d && (isDisposable(d) || isSubscription(d)); });
	    }
	    CompositeDisposable.prototype.add = function (disposable) {
	        if (disposable) {
	            if (this._disposed) {
	                dispose(disposable);
	            }
	            else {
	                this._disposables.push(disposable);
	            }
	        }
	        return disposable;
	    };
	    CompositeDisposable.prototype.dispose = function () {
	        this._disposed = true;
	        for (var _i = 0, _a = this._disposables; _i < _a.length; _i++) {
	            var d = _a[_i];
	            dispose(d);
	        }
	    };
	    return CompositeDisposable;
	}());
	exports.CompositeDisposable = CompositeDisposable;
	/**
	 * Call "dispose" function recursively on all objects that define it.
	 *
	 * If an object has a "dispose" method that returns boolean value "false",
	 * "disposeObject" will enumerate that object's properties and attempt
	 * to dispose them recursively. If "dispose" method returns anything
	 * else, no enumeration/automatic recursive disposal will take place
	 * for that object (this is the standard behaviour).
	 *
	 * @param o
	 *     Object to dispose.
	 * @param force
	 *     If falsy, "function" containers (i.e. properties of type "function"
	 *     that contain child properties, e.g. the "extras" property used by
	 *     "ViewModelInit.js" to prevent JSON serialization) will be ignored.
	 *     Otherwise ("force" is truthy) "function" containers will be included
	 *     in traversal and all their properties will be disposed.
	 * @returns
	 *     The disposed object.
	 */
	function disposeObject(o, force) {
	    if (force === void 0) { force = false; }
	    if (o) {
	        if (!o.dispose || (o.dispose() === false)) {
	            if (ko.isObservable(o)) {
	                if (o.indexOf) {
	                    disposeObject(o(), force); // in case of observableArray we want to dispose each item in the array (as opposed to properties of the observableArray function), thus "o()"
	                }
	            }
	            else if ((force && typeof o === "function") || typeof o === "object") {
	                // because "extras" can be declared as non-enumerable
	                // property (using "Object.defineProperty", e.g. in
	                // DocumentViewModel base class), the loop below
	                // will not catch it and we need to check for it
	                // manually to preserve the original "force" semantics
	                var skipExtrasInLoop = !!(force && o.extras);
	                for (var k in o) {
	                    if (o.hasOwnProperty(k)) {
	                        if (!skipExtrasInLoop || k !== "extras") {
	                            disposeObject(o[k], force);
	                        }
	                    }
	                }
	                if (skipExtrasInLoop) {
	                    disposeObject(o.extras, force);
	                }
	            }
	        }
	    }
	    return o;
	}
	exports.disposeObject = disposeObject;
	/**
	 * Type guard for compatibility with "Disposable".
	 */
	function isDisposable(d) {
	    return typeof d.dispose === "function";
	}
	exports.isDisposable = isDisposable;
	/**
	 * Type guard for compatibility with "AnonymousSubscription".
	 */
	function isSubscription(s) {
	    return typeof s.unsubscribe === "function";
	}
	exports.isSubscription = isSubscription;
	/**
	 * Disposes the specified guarded value after the specified action finishes (whether an exception is thrown or not).
	 */
	function using(guardedValue, action) {
	    if (guardedValue !== null && guardedValue !== undefined && !isDisposable(guardedValue) && !isSubscription(guardedValue)) {
	        throw new Error("using: Guarded value must implement \"dispose\" or \"unsubscribe\" method");
	    }
	    var result = undefined;
	    try {
	        result = action(guardedValue);
	    }
	    finally {
	        if (guardedValue) {
	            dispose(guardedValue);
	        }
	    }
	    return result;
	}
	exports.using = using;
	



/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var Rx = __webpack_require__(27);
	var call_1 = __webpack_require__(8);
	/**
	 * Returns an Rx.Observable that signals when the underlying ko.observable changes.
	 *
	 * @param source
	 *     Knockout observable or computed.
	 * @param omitInitialValue
	 *     When true, the initial value will not be published on the event stream. @default false.
	 * @returns
	 *     A cold Rx Observable stream containing changes to the source observable.
	 */
	function fromKnockoutObservable(source, omitInitialValue) {
	    if (omitInitialValue === void 0) { omitInitialValue = false; }
	    if (!ko.isObservable(source) && !ko.isComputed(source)) {
	        throw new Error("'source' must be a knockout observable.");
	    }
	    return new Rx.Observable(function createRxStreamForKnockoutObservable(observer) {
	        if (!omitInitialValue) {
	            // publish initial value
	            observer.next(source.peek());
	        }
	        // publish future values (and define how to cancel publishing)
	        var koSubscription = source.subscribe(observer.next, observer);
	        var rxSubscription = observer.add(koSubscription.dispose.bind(koSubscription));
	        // if the specified Knockout observable is disposable,
	        // override disposal to complete Rx stream in addition
	        // to the original disposal
	        var originalDispose = source.dispose;
	        if (typeof originalDispose === "function") {
	            source.dispose = function disposeRxStreamForKnockoutObservable() {
	                originalDispose.call(this);
	                observer.complete(); // "OnComplete" event + disposes (unsubscribes) all subscriptions, including "rxSubscription" which in turn disposes "koSubscription"
	            };
	        }
	        // allow caller to cancel publishing of future values
	        return rxSubscription;
	    });
	}
	exports.fromKnockoutObservable = fromKnockoutObservable;
	/**
	 * Returns an Rx.Observable that signals when the underlying PLI call completes.
	 *
	 * @param settings
	 *     PliCallSettings object containing the PLI call settings.
	 * @returns
	 *     A cold Rx Observable stream containing the PLI call result.
	 */
	function fromPliCall(settings) {
	    return new Rx.Observable(function createRxStreamForPliCall(observer) {
	        var promise = call_1.default(settings);
	        var rxSubscription = observer.add(function disposeRxStreamForPliCall() {
	            // try to abort any in-flight requests if
	            // 'unsubscribe' is called before completion
	            if (promise.state && promise.state() === "pending" && promise.xhr && promise.xhr.abort) {
	                promise.xhr.abort();
	            }
	        });
	        promise.always(function notifyRxStreamForPliCall(response) {
	            if (!rxSubscription.closed) {
	                if (response.isError && !settings.includeErrorsInResultStream) {
	                    observer.error(response);
	                }
	                else {
	                    observer.next(response);
	                    observer.complete();
	                }
	            }
	        });
	        return rxSubscription;
	    });
	}
	exports.fromPliCall = fromPliCall;
	



/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var string_1 = __webpack_require__(13);
	/**
	 * Helper class for searching through a list of KnockoutDataProvider results.
	 */
	var KnockoutDataSearchInfo = (function () {
	    function KnockoutDataSearchInfo(rowIdIndex, exactMatchIgnoresCase) {
	        this._rowIdIndex = rowIdIndex;
	        this._exactMatchIgnoresCase = !!exactMatchIgnoresCase;
	    }
	    /**
	     * Searches for the next match of the specified regular expression in data source starting at the specified index.
	     *
	     * @param regex
	     *     Expression to match.
	     * @param startingIndex
	     *     Data index to begin searching.
	     * @returns
	     *     Index of the next match.
	     */
	    KnockoutDataSearchInfo.prototype.findNextMatch = function (regex, startingIndex) {
	        var items = (this._data && this._data.items);
	        if (items) {
	            var rowIdIndex = this._rowIdIndex;
	            var l = items.length;
	            for (var i = startingIndex; i < l; i += 1) {
	                if (items[i][rowIdIndex].match(regex)) {
	                    return i;
	                }
	            }
	        }
	        return -1;
	    };
	    /**
	     * Returns row that uniquely matched search value last time search was run.
	     *
	     * @param defaultValue
	     *     Value to return if the search produced no results.
	     * @returns
	     *     Row that uniquely matched last search value; otherwise, default value.
	     */
	    KnockoutDataSearchInfo.prototype.getFoundRow = function (defaultValue) {
	        return (this._firstIndex !== -1 && this._nextIndex === -1
	            ? this._data.items[this._firstIndex]
	            : defaultValue);
	    };
	    /**
	     * Resets data source and invalidate result of last search.
	     */
	    KnockoutDataSearchInfo.prototype.reset = function () {
	        this._firstIndex = -1;
	        this._nextIndex = -1;
	        this._exactMatch = false;
	        this._sourceValue = null;
	    };
	    /**
	     * Searches for the specified value.
	     *
	     * @param value
	     *     Value to search for.
	     * @returns
	     *     "value" if data source is not available or searching for "null" value;
	     *     row ID if unique match is found; false otherwise.
	     */
	    KnockoutDataSearchInfo.prototype.search = function (value) {
	        // does it make sense to search?
	        if (value === null || !this._data) {
	            this.reset();
	            this._exactMatch = true;
	            return value;
	        }
	        // are we searching for the same value as last time?
	        var foundRow = this.getFoundRow(false);
	        var foundRowId = (foundRow && foundRow[this._rowIdIndex]);
	        if (this._sourceValue === value) {
	            return foundRowId;
	        }
	        if (foundRowId === value) {
	            this._sourceValue = value;
	            this._exactMatch = true;
	            return foundRowId;
	        }
	        // remember this search
	        this.reset();
	        this._sourceValue = value;
	        if (typeof value !== "string") {
	            return false;
	        }
	        // try to find an exact match
	        this._firstIndex = this._findExactMatch(value);
	        if (this._firstIndex !== -1) {
	            this._exactMatch = true;
	            return this.getFoundRow()[this._rowIdIndex];
	        }
	        // try to find a single non-exact match
	        var regex = string_1.createSearchRegexFor(value);
	        this._firstIndex = this.findNextMatch(regex, 0);
	        if (this._firstIndex !== -1) {
	            this._nextIndex = this.findNextMatch(regex, this._firstIndex + 1);
	            if (this._nextIndex === -1) {
	                return this.getFoundRow()[this._rowIdIndex];
	            }
	        }
	        // either none or multiple (> 1) non-exact matches found
	        return false;
	    };
	    Object.defineProperty(KnockoutDataSearchInfo.prototype, "data", {
	        get: function () { return this._data; },
	        set: function (value) { this._data = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(KnockoutDataSearchInfo.prototype, "exactMatch", {
	        get: function () { return this._exactMatch; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(KnockoutDataSearchInfo.prototype, "nextIndex", {
	        get: function () { return this._nextIndex; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Search for an exact match of the specified value in data source.
	     *
	     * @param value
	     *     Value to search for.
	     * @returns
	     *     Index of match, or -1 if not found.
	     */
	    KnockoutDataSearchInfo.prototype._findExactMatch = function (value) {
	        var rows = (this._data && this._data.items);
	        if (rows) {
	            var rowIdIndex = this._rowIdIndex;
	            var comparableTargetId = (this._exactMatchIgnoresCase ? value.toUpperCase() : value);
	            var itemsLength = rows.length;
	            for (var i = 0; i < itemsLength; i += 1) {
	                var rowId = rows[i][rowIdIndex];
	                if (comparableTargetId === (this._exactMatchIgnoresCase ? rowId.toUpperCase() : rowId)) {
	                    return i;
	                }
	            }
	        }
	        return -1;
	    };
	    return KnockoutDataSearchInfo;
	}());
	exports.KnockoutDataSearchInfo = KnockoutDataSearchInfo;
	



/***/ }),
/* 378 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	/**
	 * The state of a DataProviderResponse.
	 */
	(function (DataState) {
	    /**
	     * Data is available.
	     */
	    DataState[DataState["Ready"] = 0] = "Ready";
	    /**
	     * Data is not ready or in transit.
	     */
	    DataState[DataState["Busy"] = 1] = "Busy";
	    /**
	     * An error occurred when retrieving data.
	     */
	    DataState[DataState["Error"] = 2] = "Error";
	})(exports.DataState || (exports.DataState = {}));
	var DataState = exports.DataState;
	/**
	 * The origin of a data query.
	 */
	(function (QueryOrigin) {
	    /**
	     * Query is an initial data request.
	     */
	    QueryOrigin[QueryOrigin["Initial"] = 0] = "Initial";
	    /**
	     * Query originated from the 'select' dropdown.
	     */
	    QueryOrigin[QueryOrigin["Select"] = 1] = "Select";
	    /**
	     * Query originated from the picklist grid.
	     */
	    QueryOrigin[QueryOrigin["Grid"] = 2] = "Grid";
	})(exports.QueryOrigin || (exports.QueryOrigin = {}));
	var QueryOrigin = exports.QueryOrigin;
	/** Empty DataProviderValue (stored as const to avoid GC pressure). */
	exports.emptyValue = { data: null, error: null };
	/**
	 * Gets the DataState for a DataProviderResponse object.
	 */
	function stateOfResponse(result) {
	    if (result) {
	        if (result.error) {
	            return DataState.Error;
	        }
	        else if (result.data) {
	            return DataState.Ready;
	        }
	    }
	    return DataState.Busy;
	}
	exports.stateOfResponse = stateOfResponse;
	



/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var R = __webpack_require__(7);
	var rx_1 = __webpack_require__(376);
	/**
	 * Default number of milliseconds to throttle a search request.
	 */
	exports.defaultDebounceTime = 250;
	/**
	 * Transforms and debounces a stream of incoming requests into responses.
	 *
	 * @param requestStream
	 *     Observable stream of user request objects.
	 * @param queryProvider
	 *     Function that takes a request and produces an observable stream of responses.
	 * @param settings
	 *     Settings controlling stream behaviour.
	 * @returns
	 *     Observable stream of responses corresponding to the incoming requests.
	 */
	function getDebouncedResponsesFor(requestStream, queryProvider, settings) {
	    if (settings === void 0) { settings = {}; }
	    if (!requestStream) {
	        throw new Error("Expected 'requestStream' to be an Rx Observable.");
	    }
	    if (typeof queryProvider !== "function") {
	        throw new Error("Expected 'queryProvider' to be a function.");
	    }
	    var debounceTime = settings.debounceTime === undefined
	        ? exports.defaultDebounceTime
	        : settings.debounceTime;
	    var debouncedStream = debounceTime <= 0
	        ? requestStream
	        : requestStream.debounceTime(debounceTime, settings.scheduler);
	    return debouncedStream
	        .map(queryProvider)
	        .switch();
	}
	exports.getDebouncedResponsesFor = getDebouncedResponsesFor;
	/**
	 * Converts a (possibly erroneous) PliCallResponse to a DataProviderResponse.
	 */
	function toDataProviderResponse(response) {
	    return response.isError
	        ? { data: null, error: response.result.message }
	        : response.result;
	}
	/**
	 * Creates a DataProviderRequestHandler for a PLI call.
	 *
	 * Call settings will be passed into "fromPliCall". Values
	 * for "data" (or "jsonData") will be merged with the incoming
	 * request. Errors will be included in the result stream with
	 * "null" data and the error message passed from the server (if any).
	 *
	 * @param settings
	 *     PliCallSettings to use for each request.
	 * @returns
	 *     DataProviderRequestHandler function that produces an Observable
	 *     stream of DataProviderResponse values for each request.
	 */
	function pliCallRequestHandler(settings) {
	    var rxSettings = {
	        customSignIn: settings.customSignIn,
	        deferSignInUiClosingUntil: settings.deferSignInUiClosingUntil,
	        headers: settings.headers,
	        includeErrorsInResultStream: true,
	        ignoreUnauthenticated: settings.ignoreUnauthenticated,
	        name: settings.name,
	        owner: settings.owner
	    };
	    var data = settings.data || (settings.jsonData && JSON.parse(settings.jsonData)) || undefined;
	    var injectDataTo = (data ? R.merge(data) : R.identity);
	    return function (request) {
	        rxSettings.data = injectDataTo(request);
	        return rx_1.fromPliCall(rxSettings).map(toDataProviderResponse);
	    };
	}
	exports.pliCallRequestHandler = pliCallRequestHandler;
	



/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var pli = __webpack_require__(5);
	var keys = __webpack_require__(381);
	
	if (__webpack_require__(3).isBrowser) {
	    pli.dialog = __webpack_require__(383);
	    pli.forms = __webpack_require__(384);
	    pli.keys = new keys.PliKeys(keys.defaultConnector);
	    pli.menu = __webpack_require__(389);
	    pli.simpleDialogRegistry = __webpack_require__(390);
	
	    var setDefaultSignInHandler = __webpack_require__(8).setDefaultSignInHandler;
	    var createSignInHandler = pli.config.useLegacySignInHandler
	        ? __webpack_require__(391).createLegacySignInHandler
	        : __webpack_require__(391).createSignInHandler;
	
	    setDefaultSignInHandler(createSignInHandler(pli.forms.registry));
	}
	
	module.exports = pli;
	


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var $ = __webpack_require__(1);
	var keyMap_1 = __webpack_require__(382);
	/**
	 * Stack-based keyboard event handler registry.
	 */
	var PliKeys = (function () {
	    // -------------------------------------------------------------------------
	    // Public
	    // -------------------------------------------------------------------------
	    /**
	     * Creates an instance of PliKeys.
	     */
	    function PliKeys(connector) {
	        // -------------------------------------------------------------------------
	        // Private
	        // -------------------------------------------------------------------------
	        /** Schema for the current form (initially empty). */
	        this._schema = {};
	        /** Registered keymaps (initially empty). */
	        this._keymaps = {};
	        /** Queue of activated keymaps. */
	        this._activated = [];
	        if (typeof connector === "function") {
	            this.connectEventHandler(connector);
	        }
	    }
	    /**
	     * Set the specified keymap as the first keymap that gets chance to handle keyboard events.
	     *
	     * If there are other activated keymaps, they will have their
	     * chance to handle keyboard events after currently activated
	     * keymap (i.e. in most-recently-activated order). If you activate
	     * a keymap with special ID of null, a 'stop processing older keymaps'
	     * token will be added to queue of activated keymaps. This token
	     * can be removed by deactivating keymap with special ID of null.
	     *
	     * null is a separator that is meant for child forms. Consider the following
	     * activation stack:
	     *
	     * keymap: formB
	     * keymap: null
	     * keymap: formA-grid
	     * keymap: formA
	     * keymap: default
	     *
	     * A keypress event would be checked against formB and then default. Once formB
	     * is closed (e.g., modal popup dismissed), formB and null will be popped from
	     * the stack via deactivateKeymap. Key events would then be checked against
	     * formA-grid, then formA, and then default.
	     *
	     * @param id
	     *     Keymap identifier
	     */
	    PliKeys.prototype.activateKeymap = function (id) {
	        var keymap;
	        if (typeof id !== "string" && id !== null) {
	            throw new Error("Keymap ID must be a non-empty string or null");
	        }
	        if (id) {
	            keymap = this._keymaps[id];
	            if (!keymap) {
	                throw new Error("Keymap ID \"" + id + "\" has not been registered");
	            }
	        }
	        else {
	            keymap = null;
	        }
	        this._activated.push(keymap);
	    };
	    /**
	     * Connects the event handler to an event source.
	     *
	     * @param connector
	     *     Function that will receive the key event handler and connect it to the key event source.
	     */
	    PliKeys.prototype.connectEventHandler = function (connector) {
	        var _this = this;
	        if (typeof connector !== "function") {
	            throw new Error("Event handler connector must be a function");
	        }
	        connector(function (e) { return _this._handleKeydown(e); });
	    };
	    /**
	     * Stop handling keyboard events with the specified keymap.
	     *
	     * Only most-recently-activated keymap can be deactivated
	     * (i.e. keymaps must be deactivated in most-recently-activated
	     * order). If you deactivate a keymap with special ID of null,
	     * a 'stop processing older keymaps' token will be removed
	     * from queue of activated keymaps.
	     *
	     * @param id
	     *     Keymap identifier.
	     */
	    PliKeys.prototype.deactivateKeymap = function (id) {
	        if (typeof id !== "string" && id !== null) {
	            throw new Error("Keymap ID must be a non-empty string or null");
	        }
	        if (this._activated.length === 0) {
	            throw new Error("No keymaps are currently activated, unable to deactivate");
	        }
	        var keymap = (id ? this._keymaps[id] : null);
	        if (this._activated[this._activated.length - 1] !== keymap) {
	            throw new Error("The keymap you're trying to deactivate is different from the most-recently-activated keymap");
	        }
	        this._activated.pop();
	    };
	    /**
	     * Returns true if the specified keymap has been registered.
	     *
	     * @returns
	     *     True if the keymap has been registered using registerKeymap; false otherwise.
	     */
	    PliKeys.prototype.isKeymapRegistered = function (id) {
	        if (typeof id !== "string") {
	            throw new Error("Keymap ID must be a non-empty string");
	        }
	        return this._keymaps.hasOwnProperty(id);
	    };
	    /**
	     * Register keymap for possible activation.
	     *
	     * @param id
	     *     Keymap identifier.
	     * @param shortcutMap
	     *     A map of shortcut names to the actions they will perform.
	     */
	    PliKeys.prototype.registerKeymap = function (id, shortcutMap) {
	        if (typeof id !== "string") {
	            throw new Error("Keymap ID must be a non-empty string");
	        }
	        if (typeof shortcutMap !== "object" || shortcutMap === null) {
	            throw new Error("ShortcutMap must be a non-null object");
	        }
	        if (this._keymaps.hasOwnProperty(id)) {
	            throw new Error("Keymap ID \"" + id + "\" has already been registered");
	        }
	        this._keymaps[id] = new keyMap_1.default(shortcutMap, id, this._schema);
	    };
	    /**
	     * Set current schema to the specified value.
	     *
	     * A schema is a map that translates symbolic names to concrete
	     * shortcuts. Setting schema to an invalid value (e.g. undefined or null
	     * or any non-object value) will reset schema to empty schema.
	     *
	     * @example
	     * {
	     *     "save": "ctrl+s, command+s",
	     *     "open": "ctrl+o, command+o"
	     * }
	     *
	     * @param schema
	     *     Schema to set globally and in each keymap.
	     */
	    PliKeys.prototype.setSchema = function (schema) {
	        this._schema = {};
	        if (typeof schema === "object" && schema !== null) {
	            for (var k in schema) {
	                if (schema.hasOwnProperty(k)) {
	                    this._schema[k.toString().toLowerCase()] = schema[k];
	                }
	            }
	        }
	        for (var k in this._keymaps) {
	            if (this._keymaps.hasOwnProperty(k)) {
	                this._keymaps[k].setSchema(this._schema);
	            }
	        }
	    };
	    /**
	     * Unregister previously registered keymap.
	     *
	     * Keymaps can only be unregistered if they are currently not activated.
	     *
	     * @param id
	     *     Keymap identifier.
	     */
	    PliKeys.prototype.unregisterKeymap = function (id) {
	        if (typeof id !== "string") {
	            throw new Error("Keymap ID must be a non-empty string");
	        }
	        if (!this._keymaps.hasOwnProperty(id)) {
	            throw new Error("Keymap ID \"" + id + "\" has not been registered");
	        }
	        var keymap = this._keymaps[id];
	        for (var _i = 0, _a = this._activated; _i < _a.length; _i++) {
	            var activated = _a[_i];
	            if (activated === keymap) {
	                throw new Error("Keymap ID \"" + id + "\" must be deactivated before it can be unregistered");
	            }
	        }
	        delete this._keymaps[id];
	    };
	    /**
	     * Keydown event handler.
	     */
	    PliKeys.prototype._handleKeydown = function (event) {
	        var hash = keyMap_1.calculateHash(event);
	        for (var i = this._activated.length - 1; i > -2; i -= 1) {
	            var keymap = this._activated[i];
	            if (!keymap) {
	                keymap = this._keymaps["default"];
	                if (!keymap) {
	                    break;
	                }
	                i = -1; // we found a default keymap - set index so that next "for" loop iteration will break the loop
	            }
	            keymap.createLookup(); // if keymap's lookup is already created, will no nothing
	            var handler = keymap.lookup[hash];
	            var result = (handler === false ? false : (typeof handler === "function" ? handler(event) : null));
	            if (result === false) {
	                return false; // returning false from jQuery event handler will ensure that event default is prevented and propagation is stopped
	            }
	            if (event.isPropagationStopped()) {
	                break;
	            }
	        }
	        return null;
	    };
	    return PliKeys;
	}());
	exports.PliKeys = PliKeys;
	/**
	 * Keydown event handler for older IE browsers.
	 */
	function handleIEKeydown(event, handler) {
	    var $event = $.event.fix(event);
	    var result = handler($event);
	    if (result === false || $event.isDefaultPrevented()) {
	        try {
	            event.keyCode = 0;
	        }
	        catch (ignore) {
	        }
	    }
	    return result;
	}
	/**
	 * Default PliKeys::connectEventHandler connector for browser environments.
	 */
	function defaultConnector(handler) {
	    // disable help window popup in IE
	    var windowAny = window;
	    if (windowAny.onhelp !== undefined) {
	        windowAny.onhelp = function () { return false; };
	    }
	    // start listening to keyboard events
	    var documentAny = document;
	    if ((documentAny.documentMode || 100) < 11 && typeof documentAny.attachEvent === "function") {
	        // for more info about why we're using "attachEvent" in IE10 and older, please see:
	        // http://stackoverflow.com/questions/13443742/preventing-default-keystroke-actions-in-internet-explorer
	        // https://connect.microsoft.com/IE/feedback/details/780963/preventing-default-behavior-of-keyboard-shortcuts
	        documentAny.attachEvent("onkeydown", function (e) { return handleIEKeydown(e, handler); });
	    }
	    else {
	        $(document).keydown(handler);
	    }
	}
	exports.defaultConnector = defaultConnector;
	



/***/ }),
/* 382 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	/**
	 * Map of human-readable modifier names to their flag values
	 */
	exports.modifiers = {
	    "shift": 0x10000,
	    "alt": 0x20000,
	    "option": 0x20000,
	    "ctrl": 0x40000,
	    "control": 0x40000,
	    "meta": 0x80000,
	    "command": 0x80000,
	    "win": 0x80000 // alias for meta
	};
	/**
	 * Map of human-readable names of known key names to their ASCII values
	 */
	exports.codes = {
	    "backspace": 8,
	    "tab": 9,
	    "enter": 13,
	    "sleep": 19,
	    "escape": 27,
	    "esc": 27,
	    "space": 32,
	    "pageup": 33,
	    "pagedown": 34,
	    "end": 35,
	    "home": 36,
	    "left": 37,
	    "up": 38,
	    "right": 39,
	    "down": 40,
	    "insert": 45,
	    "delete": 46,
	    "0": 48,
	    "1": 49,
	    "2": 50,
	    "3": 51,
	    "4": 52,
	    "5": 53,
	    "6": 54,
	    "7": 55,
	    "8": 56,
	    "9": 57,
	    "a": 65,
	    "b": 66,
	    "c": 67,
	    "d": 68,
	    "e": 69,
	    "f": 70,
	    "g": 71,
	    "h": 72,
	    "i": 73,
	    "j": 74,
	    "k": 75,
	    "l": 76,
	    "m": 77,
	    "n": 78,
	    "o": 79,
	    "p": 80,
	    "q": 81,
	    "r": 82,
	    "s": 83,
	    "t": 84,
	    "u": 85,
	    "v": 86,
	    "w": 87,
	    "x": 88,
	    "y": 89,
	    "z": 90,
	    "numpad0": 96,
	    "numpad1": 97,
	    "numpad2": 98,
	    "numpad3": 99,
	    "numpad4": 100,
	    "numpad5": 101,
	    "numpad6": 102,
	    "numpad7": 103,
	    "numpad8": 104,
	    "numpad9": 105,
	    "numpad*": 106,
	    "numpad+": 107,
	    "numpad-": 109,
	    "numpad.": 110,
	    "numpad/": 111,
	    "f1": 112,
	    "f2": 113,
	    "f3": 114,
	    "f4": 115,
	    "f5": 116,
	    "f6": 117,
	    "f7": 118,
	    "f8": 119,
	    "f9": 120,
	    "f10": 121,
	    "f11": 122,
	    "f12": 123,
	    "<": 188,
	    ",": 188,
	    ">": 190,
	    ".": 190,
	    "[": 219,
	    "{": 219,
	    "]": 221,
	    "}": 221
	};
	/**
	 * Compute a numeric hash code (see modifiers)
	 * from shift, alt and ctrl keys.
	 */
	function calculateHash(event) {
	    return (event.which
	        + (event.shiftKey ? exports.modifiers["shift"] : 0)
	        + (event.altKey ? exports.modifiers["alt"] : 0)
	        + (event.ctrlKey ? exports.modifiers["ctrl"] : 0));
	}
	exports.calculateHash = calculateHash;
	/**
	 * TAction is usually a JQuery key event handler when
	 * used by pli/keys, or a string when used by ko-grid,
	 * but it is up to the caller to provide the action type.
	 */
	var KeyMap = (function () {
	    function KeyMap(shortcutMap, id, schema) {
	        /**
	         * Translated version of keymap, i.e. a map
	         * containing hash values as keys and handlers
	         * as values
	         */
	        this.lookup = null;
	        this.id = id;
	        this.shortcutMap = shortcutMap;
	        this.schema = schema || {};
	    }
	    /**
	     * Translate keymap handlers map (this.shortcutMap)
	     * into lookup map (this.lookup).
	     */
	    KeyMap.prototype.createLookup = function () {
	        var k, h, l;
	        if (this.lookup === null) {
	            this.lookup = l = {};
	            for (k in this.shortcutMap) {
	                if (this.shortcutMap.hasOwnProperty(k)) {
	                    h = KeyMap.parseShortcuts(k, this.schema);
	                    for (var i = 0; i < h.length; i += 1) {
	                        if (l.hasOwnProperty(h[i])) {
	                            throw new Error("Multiple handlers for the same shortcut (0x" + h[i].toString(16) + ") are not allowed");
	                        }
	                        l[h[i]] = this.shortcutMap[k];
	                    }
	                }
	            }
	        }
	    };
	    /**
	     * Parse the specified shortcuts string into
	     * an array of hashes (each hash will be a number
	     * that uniquely identifies a key-combination
	     * that could arrive in onkeydown event).
	     * References to schema entries (if a schema
	     * was set) will be resolved recursively
	     * (i.e. with schema { actionA: "actionB", actionB: "ctrl+B" }
	     * parsing "actionA" will return hash for "ctrl+B").
	     */
	    KeyMap.parseShortcuts = function (value, schema) {
	        var h = [];
	        var v = (value && value.toString().replace(/\s/g, "").toLowerCase()) || null;
	        KeyMap.parseSymbolicNames(v, v, h, schema || {});
	        return h;
	    };
	    /**
	     * Updates keymap's schema and resets lookup to null.
	     * This will cause handler maps to be re-translated into lookup maps when needed.
	     */
	    KeyMap.prototype.setSchema = function (schema) {
	        this.lookup = null;
	        this.schema = schema;
	    };
	    /**
	     * Parse one shortcut into a hash value
	     * (return value). Will throw Error(s)
	     * if unable to determine the hash value.
	     */
	    KeyMap.parseShortcut = function (value, original) {
	        var shortcutParts = value.split("+");
	        var shortcutPart, hash = 0, codeFound = false, h;
	        for (var i = 0; i < shortcutParts.length; i += 1) {
	            shortcutPart = shortcutParts[i];
	            if (shortcutPart) {
	                h = exports.modifiers[shortcutPart];
	                if (h) {
	                    hash |= h;
	                }
	                else {
	                    h = exports.codes[shortcutPart];
	                    if (h) {
	                        if (codeFound) {
	                            throw new Error("Shortcut \"".concat(value, "\" (original \"", original, "\") specifies more than one key name"));
	                        }
	                        codeFound = true;
	                        hash |= h;
	                    }
	                    else {
	                        throw new Error("Shortcut part \"".concat(shortcutPart, "\" in \"", value, "\" (original \"", original, "\") is neither modifier nor key nor schema name"));
	                    }
	                }
	            }
	        }
	        if (!codeFound) {
	            throw new Error("Shortcut \"".concat(value, "\" (original \"", original, "\") did not specify a key name"));
	        }
	        return hash;
	    };
	    /**
	     * Recursively translate all parts of a shortcuts string
	     * into hashes by first resolving schema (symbolic)
	     * names into shortcuts and then translating shortcuts
	     * into hash values (using parseShortcut).
	     */
	    KeyMap.parseSymbolicNames = function (value, original, hashArray, schema) {
	        var symbolicNames, symbolicName, translation;
	        if (value) {
	            symbolicNames = value.split(",");
	            for (var i = 0; i < symbolicNames.length; i += 1) {
	                symbolicName = symbolicNames[i];
	                if (symbolicName) {
	                    translation = schema[symbolicName];
	                    if (translation) {
	                        this.parseSymbolicNames(translation.toString().replace(/\s/g, "").toLowerCase(), original, hashArray, schema); // recursive call
	                    }
	                    else {
	                        hashArray.push(this.parseShortcut(symbolicName, original));
	                    }
	                }
	            }
	        }
	    };
	    return KeyMap;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = KeyMap;
	



/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true */
	
	"use strict";
	
	var R = __webpack_require__(7);
	
	var pli = __webpack_require__(5);
	
	var defaultOptions;
	
	/// <summary>
	/// Default options that are used by every Pli.dialog.open.
	/// Caller-provided options will override the default options.
	/// </summary>
	
	
	//-------------------------------------------
	function getGeneralFeature(options, key, name, assignment, separator) {
	    /// <summary>
	    /// </summary>
	    var value = options[key];
	    if (value) {
	        return name.concat(assignment, value, separator);
	    }
	    return "";
	}
	
	
	//-------------------------------------------
	function getMeasurementFeature(options, key, name, assignment, separator) {
	    /// <summary>
	    /// </summary>
	    var value = options[key];
	    if (typeof value === "number") {
	        return name.concat(assignment, value, "px", separator);
	    }
	    if (value) {
	        return name.concat(assignment, value, separator);
	    }
	    return "";
	}
	
	
	//-------------------------------------------
	function getBoolFeature(options, key, name, assignment, separator) {
	    /// <summary>
	    /// </summary>
	    var value = options[key];
	    if (typeof value === "boolean") {
	        return name.concat(assignment, value ? "yes" : "no", separator);
	    }
	    if (value) {
	        return name.concat(assignment, value, separator);
	    }
	    return "";
	}
	
	
	//-------------------------------------------
	function buildDialogFeatures(options) {
	    /// <summary>
	    /// Build features string that can be passed
	    /// to showModalDialog and showModelessDialog
	    /// functions. Recognized options are ...
	    /// </summary>
	    return (
	        "".concat(
	            getBoolFeature(options, "center", "center", ":", ";"),
	            getBoolFeature(options, "help", "help", ":", ";"),
	            getBoolFeature(options, "resizable", "resizable", ":", ";"),
	            getBoolFeature(options, "scroll", "scroll", ":", ";"),
	            getBoolFeature(options, "status", "status", ":", ";"),
	            getMeasurementFeature(options, "width", "dialogWidth", ":", ";"),
	            getMeasurementFeature(options, "height", "dialogHeight", ":", ";"),
	            getMeasurementFeature(options, "top", "dialogTop", ":", ";"),
	            getMeasurementFeature(options, "left", "dialogLeft", ":", ";")
	        )
	    );
	}
	
	
	//-------------------------------------------
	function buildWindowFeatures(options) {
	    /// <summary>
	    /// Build features string that can be passed
	    /// to open function. Recognized options are ...
	    /// </summary>
	    return (
	        "".concat(
	            getBoolFeature(options, "channelmode", "channelmode", "=", ","),
	            getBoolFeature(options, "fullscreen", "fullscreen", "=", ","),
	            getBoolFeature(options, "location", "location", "=", ","),
	            getBoolFeature(options, "menubar", "menubar", "=", ","),
	            getBoolFeature(options, "resizable", "resizable", "=", ","),
	            getBoolFeature(options, "scroll", "scrollbars", "=", ","),
	            getBoolFeature(options, "status", "status", "=", ","),
	            getBoolFeature(options, "toolbar", "toolbar", "=", ","),
	            getGeneralFeature(options, "width", "width", "=", ","),
	            getGeneralFeature(options, "height", "height", "=", ","),
	            getGeneralFeature(options, "top", "top", "=", ","),
	            getGeneralFeature(options, "left", "left", "=", ",")
	        )
	    );
	}
	
	
	//-------------------------------------------
	function addWindowDimensions(wnd, container) {
	    var htmlNode;
	
	    if (wnd) {
	        if (typeof wnd.innerWidth === "number") { // Non-IE
	            container.width = wnd.innerWidth;
	            container.height = wnd.innerHeight;
	            return container;
	        }
	        if (wnd.document && wnd.document.body) { // IE 4+ compatible
	            htmlNode = wnd.document.body.parentNode;
	            if (htmlNode && typeof htmlNode.offsetWidth === "number") {
	                container.width = htmlNode.offsetWidth;
	                container.height = htmlNode.offsetHeight;
	                return container;
	            }
	        }
	    }
	    container.width = -1;
	    container.height = -1;
	}
	
	
	//-------------------------------------------
	function openDialog(options, wnd) {
	    /// <summary>
	    /// </summary>
	    var windowType, url, args, position, topWindow, regInfo,
	        dialogRegistry = pli.dialogRegistry;
	
	    options = R.merge(defaultOptions, options || {});
	    url = ((!options.targetUrl || options.useLoader) ? pli.resolveUrl("~/Pli/DialogLoader.html") : pli.resolveUrl(options.targetUrl)); // decide whether to use dialog loader or specified URL
	    args = { parentPli: pli, options: options };
	
	    if (options.dialogId && dialogRegistry) { // if dialog registry is present and the new dialog is identifiable, register the new dialog now
	        regInfo = dialogRegistry.find(options.dialogId);
	        if (regInfo && regInfo.pli && regInfo.pli.dialogFocus) { // already registered with window opened and focuseable
	            regInfo.pli.dialogFocus();
	            return regInfo.pli.loaderWindow;
	        }
	        url = dialogRegistry.setDialogId(url, options.dialogId, options.useQueryString);
	        dialogRegistry.register(options.dialogId, { options: options });
	    }
	
	    wnd = wnd || window;
	    windowType = options.windowType || "modal";
	    switch (windowType.toLowerCase()) {
	    case "modal":
	        return wnd.showModalDialog(url, args, buildDialogFeatures(options));
	
	    case "modeless":
	        return wnd.showModelessDialog(url, args, buildDialogFeatures(options));
	
	    case "window":
	        topWindow = pli.rootPli.loaderWindow;
	        position = {
	            x: topWindow.screenLeft || topWindow.screenX || 0,
	            y: topWindow.screenTop || topWindow.screenY || 0
	        };
	        addWindowDimensions(topWindow, position);
	        if (!options.hasOwnProperty("left")) {
	            options.left = Math.max(0, position.x + Math.ceil((position.width - options.width) / 2));
	        }
	        if (!options.hasOwnProperty("top")) {
	            options.top = Math.max(0, position.y + Math.ceil((position.height - options.height) / 2) - 40); // "40" is a Bulgarian constant (account a little bit for browser chrome)
	        }
	        return wnd.open(url, "_blank", buildWindowFeatures(options));
	    }
	}
	
	
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	
	// determine default options (immediately on load)
	defaultOptions = R.merge(
	    { // hard-coded defaults (will be overriden by pli.config's "clientDefaultOptions", if any)
	        windowType: "modal",
	        width: 800,
	        height: 600,
	        resizable: false,
	        center: true,
	        scroll: false,
	        status: false,
	        help: false
	    },
	    pli.config.clientDefaultOptions || {}
	);
	
	
	// return object that will become Pli.dialog
	module.exports = {
	
	    open: openDialog
	    /// <summary>
	    /// Open a new dialog window (modal, modeless or window).
	    /// </summary>
	
	};
	


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true, todo: true */
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var pli = __webpack_require__(5);
	var $ = __webpack_require__(1);
	var activateStopBinding = __webpack_require__(385).activateStopBinding;
	var crumbIdUtil = __webpack_require__(387);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Side-effect imports and functions
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	__webpack_require__(388); // defines $.mask and $.overlay
	
	// This is needed because the "stopBinding" knockout binding is used in _FormsTemplate.cshtml
	activateStopBinding();
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	var rootForm = null,
	    lastActiveElement = null,
	    crumbsListBegin = null, // the first navigation crumb in the current crumbs linked list
	    crumbsListEnd = null, // the last navigation crumb in the current crumbs linked list
	    formsRegistry = {},
	    navigationPages = {};
	
	
	//-------------------------------------------
	function rewriteHrefs(navigationPage, hash, isDisabled) {
	    /// <summary>
	    /// Re-writes the href attribute with the correct hash.
	    /// href is removed for those pages that are disabled or
	    /// have a parent page that is disabled.
	    /// </summary>
	    var i, p, d = isDisabled || navigationPage.isDisabled;
	
	    navigationPage.activationHash = hash; // store the hash at the page level for re-writing urls when enabling/disabling a page.
	
	    if (!navigationPage.$activatedBy) {
	        navigationPage.$activatedBy = (navigationPage.activatedBy
	            ? $(navigationPage.activatedBy)
	            : $());
	    }
	    if (!navigationPage.$activationIndicatedBy) {
	        navigationPage.$activationIndicatedBy = (navigationPage.activationIndicatedBy
	            ? $(navigationPage.activationIndicatedBy)
	            : navigationPage.$activatedBy);
	    }
	
	    if (d) {
	        navigationPage.$activatedBy.removeAttr("href"); // IMPORTANT! don't use "removeProp" because it sets href to (string) "undefined", also don't use "prop('href', null)" because it doesn't work in IE; if the current page or a parent page is disabled remove the href attribute from all $activatedBy (this converts a hyperlink to a static text in all browsers)
	    } else {
	        navigationPage.$activatedBy.prop("href", hash); // otherwise set the current href property.
	    }
	
	    for (i = 0; i < navigationPage.children.length; i += 1) {
	        p = navigationPage.children[i];
	        rewriteHrefs(p, hash.concat("/", p.name), d); // recursive call (pass the disabled state to child controls).
	    }
	}
	
	
	//-------------------------------------------
	function validateNavigationData(lastData, newData) {
	    /// <summary>
	    /// Give client code a chance to mark the specified
	    /// newData object as valid (via an event
	    /// "pliInitializingFormData" on newData.form.$form).
	    /// A valid data structure is considered one that
	    /// contains a truthy value in either "value" or
	    /// "call" property. Returns newData if validation
	    /// succeeds, null otherwise.
	    /// </summary>
	    var e = new $.Event("pliInitializingFormData");
	    if (lastData) { newData.previous = lastData; lastData.next = newData; } // connect newData to lastData (if any lastData)
	    e.pli = { data: newData };
	    newData.form.$form.trigger(e);
	
	    if (!newData.value && !newData.call) { // if we didn't determine value right away and didn't start a PLI call to get the value, newData is not valid
	        if (lastData) { newData.previous = null; lastData.next = null; } // disconnect newData from lastData (if any lastData)
	        newData = null;
	    }
	
	    return newData;
	}
	
	
	//-------------------------------------------
	function activateNavigationCrumbDefault(crumb) {
	    /// <summary>
	    /// </summary>
	    var overlayApi, c, p, i, navigationPage = crumb.page;
	
	    // if (window.console) { window.console.log("(activateNavigationCrumb) Showing \"".concat(crumb.hash, "\"", navigationPage.form ? " (with HREF rewrite)" : "").replace(/%/g, "^"), crumb); } // current chrome has issues logging '%' character, remove the 'replace' call once this is fixed
	    if (navigationPage.keymap && pli.keys) {
	        if (navigationPage.keymapIgnoreParents || (navigationPage.form && navigationPage.form.keymapIgnoreParents)) { pli.keys.activateKeymap(null); }
	        pli.keys.activateKeymap(navigationPage.keymap);
	    }
	    if (navigationPage.form) {
	        rewriteHrefs(navigationPage, crumb.hash); // creates navigationPage.$activatedBy for all descendant navigation pages
	        if (!navigationPage.form.isRoot) {
	            if (navigationPage.form.isModal) { // modal (popup) form uses jQuery Tools Overlay
	                overlayApi = navigationPage.form.$form.data("overlay");
	                if (!overlayApi) {
	                    navigationPage.form.$form.overlay({
	                        oneInstance: false,
	                        left: "center",
	                        top: "center",
	                        speed: 150,
	                        closeOnClick: false,
	                        closeOnEsc: false,
	                        closeSpeed: 0
	                    });
	                    overlayApi = navigationPage.form.$form.data("overlay");
	                }
	
	                overlayApi.load();
	
	                // count number of crumbs from current "crumb" until beginning of the list
	                // (in "previous" direction, includes the initial crumb)
	                for (i = 1, c = crumb.previous; c; c = c.previous) {
	                    p = p || (c.page === crumb.page ? c : null);
	                    i += 1;
	                }
	                i = 1000 + (10 * i);
	                navigationPage.form.$form.css("z-index", i);
	                crumb.zIndex = i; // used by updateMaskPosition to move mask div just behind the last activated form (in z axis)
	
	                // if this form is already open and "getFormState" defined
	                // store the form state to restore later
	                if (p && typeof navigationPage.form.getFormState === "function") {
	                    p.formState = navigationPage.form.getFormState();
	                }
	
	            } else { // non-modal (inline) form
	                navigationPage.$page.addClass("active");
	            }
	        }
	    } else {
	        navigationPage.$page.addClass("active");
	    }
	
	    navigationPage.$activationIndicatedBy.addClass("active");
	    navigationPage.loadFocus();
	}
	
	
	//-------------------------------------------
	function activateNavigationCrumbs(initialCrumb, activeElements) {
	    /// <summary>
	    /// </summary>
	    var e, $p;
	
	    if (initialCrumb && initialCrumb.previous) {
	        initialCrumb.previous.page.saveFocus(activeElements);
	    }
	    while (initialCrumb) {
	        $p = initialCrumb.page.$page;
	        e = new $.Event("pliActivating");
	        e.pli = { crumb: initialCrumb };
	        $p.trigger(e);
	        if (!e.isDefaultPrevented()) {
	            activateNavigationCrumbDefault(initialCrumb);
	            e = new $.Event("pliActivated");
	            e.pli = { crumb: initialCrumb };
	            $p.trigger(e);
	        }
	        initialCrumb = initialCrumb.next;
	    }
	}
	
	
	//-------------------------------------------
	function areCrumbsValidAndEquivalent(c1, c2) {
	    /// <summary>
	    /// Returns true if both c1 and c2 are valid
	    /// crumbs (as opposed to null/undefined) and
	    /// they are equivalent, false otherwise.
	    /// Crumbs are considered equivalent if they
	    /// either have exactly the same hash value
	    /// (case insensitive) or of they point to
	    /// the same form (i.e. the hashes only differ
	    /// in form value part).
	    /// </summary>
	    if (!c1 || !c2) {
	        return false;
	    }
	
	    if (c1.hash.toLowerCase() !== c2.hash.toLowerCase()) {
	        if (!c1.page.form || !c2.page.form || c1.page.form !== c2.page.form) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	
	//-------------------------------------------
	function areCrumbsSame(c1, c2) {
	    return (c1 === c2 || (c1 && c2 && c1.inLocationHash && c2.inLocationHash && c1.hash.toLowerCase() === c2.hash.toLowerCase()));
	}
	
	
	//-------------------------------------------
	function createNavigationCrumbDefault(hashSegment, currentCrumb) {
	    /// <summary>
	    /// </summary>
	    var h, i, p, c, s, d = null, navigationPage = currentCrumb.page;
	
	    if (hashSegment) {
	        // are we transitioning to a child (inline) form?
	        if (navigationPage.defaultChildFormId) {
	            if (navigationPage.children.length > 0) { throw new Error("Navigation page \"".concat(navigationPage.id, "\" specifies a defaultChildFormId but also has child navigation pages (only one or the other is allowed)")); }
	            d = {
	                type: "PLI form data",
	                form: pli.forms.registry[navigationPage.defaultChildFormId],
	                id: crumbIdUtil.decode(hashSegment),
	                rawId: hashSegment
	            };
	            if (!d.form) { throw new Error("Navigation page \"".concat(navigationPage.id, "\" specifies an unknown form \"", navigationPage.defaultChildFormId, "\" in defaultChildFormId")); }
	        } else {
	            s = hashSegment.split(':');
	            if (s.length > 1) {
	                if (s.length > 2) { throw new Error("Hash segment \"".concat(hashSegment, "\" contains more than 2 parts separated by ':'")); }
	                d = {
	                    type: "PLI form data",
	                    form: pli.forms.registry[s[0]],
	                    id: crumbIdUtil.decode(s[1])
	                };
	                if (!d.form) { throw new Error("Hash segment \"".concat(hashSegment, "\" specifies an unknown form \"", s[0], "\"")); }
	            }
	        }
	        if (d) { // found a child form, let's create a crumb for it
	            if (!d.form.page.isDisabled) { // only create a crumb if the form is not disabled
	                c = currentCrumb;
	                while (c) { // make sure the requested form is not yet shown
	                    if (c.page.form && c.page.form.id === d.form.id) {
	                        throw new Error("Form \"".concat(d.form.id, "\" is already shown, unable to show again"));
	                    }
	                    c = c.previous;
	                }
	
	                d = validateNavigationData(currentCrumb.data, d);
	                if (d) {
	                    c = {
	                        type: "PLI navigation crumb",
	                        page: d.form.page,
	                        data: d,
	                        inLocationHash: true,
	                        hash: currentCrumb.hash.concat("/", hashSegment),
	                        previous: currentCrumb
	                    };
	                    currentCrumb.next = c;
	                    return c;
	                }
	            }
	            return null;
	        }
	
	        // we have a segment, find first child page that matches the segment
	        h = hashSegment.toLowerCase();
	        for (i = 0; i < navigationPage.children.length; i += 1) {
	            p = navigationPage.children[i];
	            if (!p.isDisabled && p.name.toLowerCase() === h) {
	                c = {
	                    type: "PLI navigation crumb",
	                    page: p,
	                    data: currentCrumb.data,
	                    inLocationHash: true,
	                    hash: currentCrumb.hash.concat("/", hashSegment),
	                    previous: currentCrumb
	                };
	                currentCrumb.next = c;
	                return c;
	            }
	        }
	    } else {
	        // we don't have a hash segment, attempt to find default child navigation page
	        for (i = 0; i < navigationPage.children.length; i += 1) {
	            p = navigationPage.children[i];
	            if (!p.isDisabled && p.isDefault) {
	                c = {
	                    type: "PLI navigation crumb",
	                    page: p,
	                    data: currentCrumb.data,
	                    inLocationHash: false,
	                    hash: currentCrumb.hash.concat("/", p.name),
	                    previous: currentCrumb
	                };
	                currentCrumb.next = c;
	                return createNavigationCrumbDefault(null, c) || c; // recursive call
	            }
	        }
	    }
	
	    return null;
	}
	
	
	//-------------------------------------------
	function createNavigationCrumb(hashSegment, currentCrumb) {
	    /// <summary>
	    /// </summary>
	    var c,
	        $p = currentCrumb.page.$page,
	        e = new $.Event("pliCreatingCrumb");
	    e.pli = { hashSegment: hashSegment, currentCrumb: currentCrumb, crumb: null };
	    $p.trigger(e);
	    if (e.isDefaultPrevented()) {
	        c = e.pli.crumb;
	    } else { // if default action on pliCreatingCrumb event was not prevented, run default creation function
	        c = createNavigationCrumbDefault(hashSegment, currentCrumb);
	        e = new $.Event("pliCreatedCrumb");
	        e.pli = { hashSegment: hashSegment, currentCrumb: currentCrumb, crumb: c };
	        $p.trigger(e);
	    }
	    return c;
	}
	
	
	//-------------------------------------------
	function deactivateNavigationCrumbDefault(crumb, activeCrumbsListEnd) {
	    /// <summary>
	    /// </summary>
	    var navigationPage = crumb.page;
	
	    // if (window.console) { window.console.log("(deactivateNavigationCrumb) Hiding \"".concat(crumb.hash, "\"").replace(/%/g, "^"), crumb); }
	    if (navigationPage.keymap && pli.keys) {
	        pli.keys.deactivateKeymap(navigationPage.keymap);
	        if (navigationPage.keymapIgnoreParents || (navigationPage.form && navigationPage.form.keymapIgnoreParents)) { pli.keys.deactivateKeymap(null); }
	    }
	    navigationPage.$activationIndicatedBy.removeClass("active"); // "navigationPage.$activationIndicatedBy" is always present (created during activation)
	    if (navigationPage.form) {
	        if (!navigationPage.form.isRoot) {
	            if (navigationPage.form.isModal) {
	
	                // Check if another instance of this page was opened
	                // (in "previous" direction, not including the initial crumb)
	                var activeCrumbWithSamePage = activeCrumbsListEnd;
	                while (activeCrumbWithSamePage) {
	                    if (activeCrumbWithSamePage.page === navigationPage) { break; }
	                    activeCrumbWithSamePage = activeCrumbWithSamePage.previous;
	                }
	                if (activeCrumbWithSamePage) {
	                    navigationPage.form.$form.css("z-index", activeCrumbWithSamePage.zIndex); // restore previous z-index
	                    if (typeof navigationPage.form.loadFormState === "function") { // restore form state (if supported)
	                        navigationPage.form.loadFormState(activeCrumbWithSamePage.formState);
	                        activeCrumbWithSamePage.formState = null;
	                    }
	                } else {
	                    var overlayApi = navigationPage.form.$form.data("overlay");
	                    if (overlayApi) { overlayApi.close(); }
	                    navigationPage.forgetFocus();
	                }
	
	            } else { // non-modal (inline) form
	                navigationPage.$page.removeClass("active");
	            }
	        }
	    } else if (navigationPage.$page) {
	        navigationPage.$page.removeClass("active");
	    }
	}
	
	
	//-------------------------------------------
	function deactivateNavigationCrumbs(initialCrumb, activeCrumbsListEnd) {
	    /// <summary>
	    /// </summary>
	    var e, $p, activeElements = null;
	
	    while (initialCrumb) {
	        $p = initialCrumb.page.$page;
	        e = new $.Event("pliDeactivating");
	        e.pli = { crumb: initialCrumb };
	        $p.trigger(e);
	        if (!e.isDefaultPrevented()) {
	            activeElements = initialCrumb.page.saveFocus(activeElements);
	            deactivateNavigationCrumbDefault(initialCrumb, activeCrumbsListEnd);
	            e = new $.Event("pliDeactivated");
	            e.pli = { crumb: initialCrumb };
	            $p.trigger(e);
	        }
	        initialCrumb = initialCrumb.previous;
	    }
	
	    return activeElements;
	}
	
	
	//-------------------------------------------
	function normalizeNavigationHash(hash, toLowerCase) {
	    /// <summary>
	    /// Normalize the specified hash value (make
	    /// sure it is a string, has no leading or
	    /// trailing whitespace and no trailing slashes).
	    /// The returned value can optionally be converted
	    /// to lower case (if toLowerCase is a truthy
	    /// value). Values "", "#" and "#/" will be
	    /// normalized to "#".
	    /// </summary>
	    var i;
	    if (hash === null) { // because of firefox bug, we can't use location.hash, so we will parse it out of href
	        hash = location.href;
	        i = hash.indexOf('#');
	        hash = (i < 0 ? "" : hash.substring(i)); // include '#'
	    }
	
	    hash = $.trim(hash).replace(/\/+$/, ""); //remove leading/trailing whitespace + remove trailing slashes
	    return (hash === ""
	        ? "#"
	        : toLowerCase
	            ? hash.toLowerCase()
	            : hash);
	}
	
	
	//-------------------------------------------
	function getCurrentForm(includeInlineForms) {
	    /// <summary>
	    /// Return the form object for the currently
	    /// active form (top of the stack of opened forms).
	    /// </summary>
	    var f, c = crumbsListEnd;
	    while (c) {
	        f = c.page.form;
	        if (f && (includeInlineForms || f.isModal || f.isRoot)) {
	            return f;
	        }
	        c = c.previous;
	    }
	    throw new Error("No current form found (should never happen)");
	}
	
	
	//-------------------------------------------
	function isNoHashFormActive() {
	    var c = crumbsListEnd;
	    while (c) {
	        if (!c.hash) {
	            return true;
	        }
	        c = c.previous;
	    }
	    return false;
	}
	
	
	//-------------------------------------------
	function updateMaskPosition() {
	    /// <summary>
	    /// Make sure the jquery tools mask is displayed
	    /// immediately below the latest visible modal
	    /// (popup) form. If no modal forms are visible,
	    /// make sure the mask is hidden.
	    /// </summary>
	    var c = crumbsListEnd,
	        $m = $.mask.getMask();
	    if (!$m) { // make sure mask has been initialized
	        $(document).mask({
	            color: '#f0f0f0',
	            opacity: 0.7,
	            loadSpeed: 0,
	            closeSpeed: 0,
	            closeOnClick: false,
	            closeOnEsc: false
	        });
	        $m = $.mask.getMask();
	    }
	
	    while (c) {
	        if (c.zIndex) { break; }
	        c = c.previous;
	    }
	    if (c) {
	        $.mask.load();
	        $m.css("z-index", c.zIndex - 1);
	    } else {
	        $.mask.close();
	    }
	}
	
	
	/**
	 * Detect changes to begin/end crumbs and indicate pending observable mutation.
	 *
	 * Must be called before "updateObservableCrumbs".
	 *
	 * @param newListBegin
	 *     Crumb that will be set as crumbs.begin.
	 * @param newListEnd
	 *     Crumb that will be set as crumbs.end.
	 * @returns
	 *     True if either being/end will change; false otherwise.
	 */
	function preupdateObservableCrumbs(newListBegin, newListEnd) {
	    var changed = false;
	    var observableCrumbs = ko.unwrap(pli.forms.crumbs);
	    if (observableCrumbs) {
	        var beginChanged = !areCrumbsSame(observableCrumbs.begin, newListBegin);
	        var endChanged = !areCrumbsSame(observableCrumbs.end, newListEnd);
	        changed = beginChanged || endChanged;
	        if (changed) {
	            pli.forms.crumbs.valueWillMutate();
	            observableCrumbs.beginChanged = beginChanged;
	            observableCrumbs.begin = newListBegin;
	            observableCrumbs.endChanged = endChanged;
	            observableCrumbs.end = newListEnd;
	            // Give subscribers a chance to react to new crumbs state
	            // before actually changing the value.
	            pli.forms.crumbs.notifySubscribers(observableCrumbs, "changing");
	        }
	    }
	    return changed;
	}
	
	
	/**
	 * Update observable crumbs if they are available and begin/end has changed.
	 *
	 * Must be called after "preupdateObservableCrumbs".
	 *
	 * @param changed
	 *     True if begin/end has changed; false otherwise (return value
	 *     from "preupdateObservableCrumbs").
	 */
	function updateObservableCrumbs(changed) {
	    if (changed) {
	        var observableCrumbs = ko.unwrap(pli.forms.crumbs);
	        if (observableCrumbs) {
	            pli.forms.crumbs.valueHasMutated();
	        }
	    }
	}
	
	
	//-------------------------------------------
	function closeForm(formId) {
	    /// <summary>
	    /// Close the specified form (if active).
	    /// Closing the root form will close the
	    /// browser window as well.
	    /// </summary>
	    var closingNoHashForm,
	        f = (typeof formId === "object" ? formId : pli.forms.registry[formId]),
	        c = crumbsListEnd;
	
	    // ensure requested form is active (shown)
	    while (c) {
	        if (c.page.form === f) { break; }
	        c = c.previous;
	    }
	    if (!c) {
	        return f; // not active, nothing to close
	    }
	
	    // closing the root form closes the whole window
	    if (f.isRoot) {
	        window.close();
	        return f;
	    }
	
	    // cut the crumbs chain into two (crumbs that will remain active and crumbs that will be deactivated) + deactivate
	    closingNoHashForm = !c.hash;
	    c = c.previous;
	    c.next.previous = null;
	    c.next = null;
	    deactivateNavigationCrumbs(crumbsListEnd, c);
	    crumbsListEnd = c;
	    updateMaskPosition();
	
	    // now update URL (hash)
	    if (closingNoHashForm) {
	        pli.forms.onHashChange(); // will call updateObservableCrumbs()
	    } else {
	        while (c) {
	            if (c.inLocationHash) {
	                if (normalizeNavigationHash(null, true) !== normalizeNavigationHash(c.hash, true)) {
	                    location.hash = c.hash; // will trigger onHashChange which will call updateObservableCrumbs()
	                }
	                break;
	            }
	            c = c.previous;
	        }
	    }
	    crumbsListEnd.page.loadFocus();
	    return f;
	}
	
	
	//-------------------------------------------
	function openForm(formId, formData) {
	    /// <summary>
	    /// </summary>
	    var h, // hash segment for the form being opened
	        c,
	        f = (typeof formId === "object" ? formId : pli.forms.registry[formId]), // form that is being opened
	        lastActiveCrumb = crumbsListEnd,
	        tailHash = null;
	
	    formData = formData || {};
	    if (!f || !f.page) { throw new Error("Unknown form \"".concat(formId, "\", unable to show")); }
	    if (f.page.isDisabled) { throw new Error("Form \"".concat(f.id, "\" is disabled, unable to open")); }
	    if (typeof formData !== "object") { throw new Error("Form data must be an object"); }
	
	    // update crumb markers (if needed)
	    if (formData.includeInHash && formData.replaceId) {
	        c = lastActiveCrumb;
	        while (c) {
	            if (c.page.form === f) { break; }
	            c = c.previous;
	        }
	        if (c) { // we found what to replace
	            lastActiveCrumb = c.previous; // if we matched root form, lastActiveCrumb will be undefined now
	            if (formData.replacePreservesCrumbsTail) {
	                tailHash = c.hash.length;
	                while (c.next && c.next.inLocationHash) {
	                    c = c.next;
	                }
	                tailHash = c.hash.substring(tailHash);
	            }
	        }
	    }
	
	    // determine new hash segment for the form being shown
	    h = (!lastActiveCrumb || lastActiveCrumb.page.defaultChildFormId === f.id
	        ? crumbIdUtil.encode(formData.id)
	        : f.id.concat(":", crumbIdUtil.encode(formData.id)));
	
	    // initiate form showing
	    if (formData.includeInHash) {
	        if (isNoHashFormActive()) {
	            if (window.console) { window.console.warn("A form that is not included in current hash is already open; can't open its child with includeInHash flag"); }
	            return;
	        }
	        h = (lastActiveCrumb ? lastActiveCrumb.hash.concat("/") : "#").concat(h);
	        if (tailHash) {
	            h = h.concat(tailHash);
	        }
	
	        // changing hash (whether history is updated or not)
	        // will trigger onHashChange that will trigger
	        // activation that will show form
	        if (formData.doNotUpdateHistory) {
	            location.replace(location.href.substring(0, location.href.indexOf("#")).concat(h));
	        } else {
	            location.hash = h;
	        }
	    } else {
	        c = {
	            type: "PLI navigation crumb",
	            page: f.page,
	            data: {
	                type: "PLI form data",
	                form: f,
	                value: formData
	            },
	            inLocationHash: false,
	            hash: "",
	            previous: crumbsListEnd
	        };
	        crumbsListEnd.next = c;
	        var changed = preupdateObservableCrumbs(crumbsListBegin, c);
	        activateNavigationCrumbs(c); // will show form
	        crumbsListEnd = c;
	        updateMaskPosition();
	        updateObservableCrumbs(changed);
	    }
	
	    return f;
	}
	
	
	//-------------------------------------------
	function resetActivationFocus() {
	    var $found, crumb = crumbsListEnd;
	    while (crumb) {
	        $found = crumb.page.findActivationFocus();
	        if ($found.length) {
	            $found.focus();
	            break;
	        }
	        crumb = crumb.previous;
	    }
	}
	
	
	//-------------------------------------------
	function onHashChange() {
	    /// <summary>
	    /// Triggered every time current page's
	    /// location.hash changes (the part after '#', e.g.
	    /// http://server/page#/hashSegmentA/hashSegmentB)
	    /// </summary>
	    var hash,
	        hashSegments,
	        current,
	        deactivationBegin = null,
	        deactivationEnd,
	        explicitHash,
	        activationBegin,
	        newListBegin,
	        newListEnd,
	        created,
	        i,
	        h = "",
	        d;
	
	    // do not allow hash changes while at least one no-hash form is active
	    if (isNoHashFormActive()) {
	        return;
	    }
	
	    // find how far can we follow current crumbs list with the new hash
	    hash = normalizeNavigationHash(null);
	    hashSegments = hash.split('/');
	    for (i = 0, current = crumbsListBegin; i < hashSegments.length && current; i += 1, current = current.next) {
	        h = i ? h.concat("/", hashSegments[i]) : hashSegments[0];
	        if (h.toLowerCase() !== current.hash.toLowerCase()) {
	            break;
	        }
	        current.inLocationHash = true; // current crumb could have been created as a default but now it's in hash explicitly
	    }
	    if (current && current.previous) {
	        activationBegin = null;
	        newListBegin = crumbsListBegin;
	        deactivationBegin = current;
	        deactivationEnd = crumbsListEnd;
	        current = current.previous;
	        if (current.next) { // break the linked list
	            current.next.previous = null;
	            current.next = null;
	        }
	        if (current.data && current.data.next) { // also break the data linked list
	            current.data.next.previous = null;
	            current.data.next = null;
	        }
	    } else {
	        if (!current && crumbsListEnd) { // we passed beyond the current crumbs list (in the for loop above the whole list matched current hash), let's reuse the whole list
	            current = crumbsListEnd;
	            activationBegin = null;
	            newListBegin = crumbsListBegin;
	            deactivationEnd = null;
	        } else { // need to start from scratch
	            d = {
	                type: "PLI form data",
	                form: rootForm,
	                id: crumbIdUtil.decode(hashSegments[0].substr(1)) // ignore the leading '#' in the first hash segment
	            };
	            validateNavigationData(null, d); // try validating data for the root form, but even if validation fails (null return value) continue with crumb creation
	
	            rewriteHrefs(rootForm.page, hashSegments[0]);
	            activationBegin = newListBegin = current = {
	                type: "PLI navigation crumb",
	                page: rootForm.page,
	                hash: hashSegments[0],
	                inLocationHash: true,
	                data: d
	            };
	            deactivationBegin = crumbsListBegin;
	            deactivationEnd = crumbsListEnd;
	            i = 1;
	        }
	    }
	
	    // add crumbs that didn't exist in current crumbs list
	    while (i < hashSegments.length) {
	        created = createNavigationCrumb(hashSegments[i], current);
	        if (!created) {
	            break;
	        }
	        activationBegin = activationBegin || created;
	        current = created;
	        i += 1;
	    }
	
	    // add crumbs for default navigation pages (if any)
	    created = createNavigationCrumb(null, current);
	    if (created) {
	        activationBegin = activationBegin || current.next;
	        current = created;
	    }
	    newListEnd = current;
	
	    // move deactivation/activation markers while
	    // they point to equivalent crumbs
	    while (true) {
	        if (!areCrumbsValidAndEquivalent(deactivationBegin, activationBegin)) {
	            break;
	        }
	        if (activationBegin.page.activationHash && (activationBegin.page.activationHash !== activationBegin.hash)) {
	            // activationBegin won't be reactivated, but the page's activation hash needs updating
	            rewriteHrefs(activationBegin.page, activationBegin.hash);
	        }
	        deactivationBegin = deactivationBegin.next;
	        activationBegin = activationBegin.next;
	    }
	    if (deactivationBegin) {
	        deactivationBegin.previous = null;
	    } else {
	        deactivationEnd = null;
	    }
	
	    // deactivate + activate now
	    i = null;
	    if (deactivationEnd) {
	        i = deactivateNavigationCrumbs(deactivationEnd); // returns an array of active elements that have not yet been "consumed" by saveFocus
	        current = (activationBegin && activationBegin.previous) || newListEnd;
	        current.page.loadFocus(); // before activation begins (if any), give last already activated crumb a chance to load its focus
	    }
	    activateNavigationCrumbs(activationBegin, i);
	
	    // navigate crumbs until finding first
	    // hash that is explictly inLocationHash
	    // (will result in root (#) if no other
	    // hash is found)
	    current = newListEnd;
	    while (current && !current.inLocationHash) {
	        current = current.previous;
	    }
	    explicitHash = current.hash;
	
	    // update href for all anchors activating pages in the new list
	    // (this is needed to preserve currently selected nested navigation
	    // pages when switching their parent)
	    current = newListBegin;
	    while (current) {
	        if (!current.page.disableHrefMemory && !(current.page.form && current.page.form.disableHrefMemory)) {
	            current.page.$activatedBy.prop("href", explicitHash);
	        }
	        current = current.next;
	    }
	
	    // now set the new crumbs list as the current one
	    crumbsListBegin = newListBegin;
	    crumbsListEnd = newListEnd;
	    var changed = preupdateObservableCrumbs(newListBegin, newListEnd);
	    updateMaskPosition();
	    updateObservableCrumbs(changed);
	    // if (window.console) { window.console.log("(onHashChange) Crumbs: ", crumbsListBegin, crumbsListEnd); }
	}
	
	
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	
	//-------------------------------------------
	// Store information about navigation page
	// (as specified in data-pli-navigation-page attribute
	// plus runtime properties).
	function NavigationPage(pageData, $page, id) {
	    if (!(this instanceof NavigationPage)) { // allow instantiation without the 'new' keyword
	        return new NavigationPage(pageData);
	    }
	
	    $.extend(this, pageData);
	    this.id = id;
	    this.$page = $page;
	    this.children = [];
	}
	
	
	//-------------------------------------------
	NavigationPage.prototype.type = "PLI navigation page";
	
	
	//-------------------------------------------
	// Enables this navigation page. If "value" is
	// specified, truthy value will enable this
	// page while falsy value will disable it.
	// Triggers URL rewrite for this navigation
	// page and all its descendant children pages.
	NavigationPage.prototype.enable = function enablePage(value) {
	    this.disable(!(value === undefined || value));
	};
	
	
	//-------------------------------------------
	// Disables this navigation page. If "value" is
	// specified, truthy value will disable this
	// page while falsy value will enable it.
	// Triggers URL rewrite for this navigation
	// page and all its descendant children pages.
	NavigationPage.prototype.disable = function disablePage(value) {
	    var isDisabled = (value === undefined || value);
	    this.isDisabled = isDisabled;
	    if (this.activationHash) {
	        rewriteHrefs(this, this.activationHash, isDisabled);
	    }
	    if (this.$activationIndicatedBy) {
	        this.$activationIndicatedBy.toggleClass("disabled", isDisabled);
	    }
	};
	
	
	//-------------------------------------------
	NavigationPage.prototype.findActivationFocus = function findActivationFocusOnPage() {
	    return this.$page.find(".focusOnActivate:visible:not(:disabled):not([readonly]):first");
	};
	
	
	//-------------------------------------------
	NavigationPage.prototype.saveFocus = function savePageFocus(activeElements) {
	    var i, l, $e;
	
	    if (!activeElements) {
	        activeElements = [$(document.activeElement)];
	        if (lastActiveElement) {
	            activeElements.push($(lastActiveElement));
	        }
	    }
	    for (i = 0, l = activeElements.length; i < l; i += 1) {
	        $e = activeElements[i];
	        if ($e.closest(this.$page).length) { // if current focused (active) element is a child of this navigation page
	            // if (window.console) { window.console.log("saveFocus for ", this.id, " is remembering: ", $e); }
	            this.$focus = $e;
	            activeElements = [];
	            break;
	        }
	    }
	    if (i === l) {
	        // if (window.console) { window.console.log("saveFocus for ", this.id, " found nothing"); }
	        this.$focus = null;
	    }
	    return activeElements;
	};
	
	
	//-------------------------------------------
	NavigationPage.prototype.loadFocus = function loadPageFocus() {
	    if (this.$focus) {
	        // if (window.console) { window.console.log("loadFocus for ", this.id, " is restoring focus to: ", this.$focus); }
	        this.$focus.focus();
	    } else {
	        var $f = this.findActivationFocus();
	        // if (window.console) { window.console.log("loadFocus for ", this.id, " found activation focus ", $f); }
	        $f.focus();
	    }
	};
	
	
	//-------------------------------------------
	NavigationPage.prototype.forgetFocus = function forgetPageFocus() {
	    var i, l;
	    // if (window.console) { window.console.log("forgetFocus for ", this.id); }
	    this.$focus = null;
	    for (i = 0, l = this.children.length; i < l; i += 1) {
	        this.children[i].forgetFocus();
	    }
	};
	
	
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	
	//-------------------------------------------
	// Store information about navigation form
	// (as specified in data-pli-form attribute
	// plus runtime properties).
	function NavigationForm(formData, $form) {
	    if (!(this instanceof NavigationForm)) { // allow instantiation without the 'new' keyword
	        return new NavigationForm(formData, $form);
	    }
	
	    $.extend(this, formData);
	    this.$form = $form;
	
	    var page = new NavigationPage(null, $form, this.id);
	    page.form = this;
	    page.keymap = this.keymap || null;
	    this.keymap = null; // we transferred the keymap (if any) property to the navigation page associated with this form
	    page.isDisabled = !!this.isDisabled; // convert truthy/falsey value to boolean
	    this.isDisabled = null; // we transferred the isDisabled (if any) flag to the navigation page associated with this form
	    page.defaultChildFormId = this.defaultChildFormId || null;
	    this.defaultChildFormId = null; // we transferred the defaultChildFormId (if any) string to the navigation page associated with this form
	
	    this.page = navigationPages[this.id] = page; // associate the newly created page with this form and add it to page registry
	}
	
	
	//-------------------------------------------
	NavigationForm.prototype.type = "PLI navigation form";
	
	
	//-------------------------------------------
	// Prevents "util/disposable.disposeObject" from entering an infinite loop.
	//
	// There is an infinite loop where every form points to
	// its navigation page which points back to the form.
	NavigationForm.prototype.dispose = function disposeNavigationForm() {
	    return;
	};
	
	
	//-------------------------------------------
	NavigationForm.prototype.open = function openNavigationForm(options) {
	    return openForm(this, options);
	};
	
	
	//-------------------------------------------
	NavigationForm.prototype.close = function closeNavigationForm() {
	    return closeForm(this);
	};
	
	
	//-------------------------------------------
	function addForm($form, data) {
	    var form = data || $form.data("pliForm");
	    if (typeof form !== "object") { throw new Error("Attribute data-pli-form must resolve to an object"); }
	    form.id = form.id || $form.prop("id"); // if "id" is not specified in data-pli-form attribute, use HTML ID property
	    if (typeof form.id !== "string") { throw new Error("Attribute data-pli-form must contain an object with string property 'id' or must belong to an element with HTML ID property"); }
	    if (formsRegistry.hasOwnProperty(form.id)) { throw new Error("Form \"".concat(form.id, "\" is defined multiple times on this page")); }
	    form = new NavigationForm(form, $form);
	    formsRegistry[form.id] = form; // add newly created form to forms registry
	    return form;
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	// add all forms on this HTML page to forms registry (and create a navigation page for each form + find root form)
	$("[data-pli-form]").each(function formApiInit() {
	    var $form = $(this), form = addForm($form);
	    if (!rootForm || form.isRoot) {
	        if (rootForm) { rootForm.isRoot = null; } // remove isRoot flag from previously selected root form (if any)
	        rootForm = form;
	        rootForm.isRoot = true; // make sure root form has the flag set
	    }
	});
	if (!rootForm) { throw new Error("No forms are defined on this HTML page"); }
	// if (window.console) { window.console.log("Found root form \"".concat(rootForm.id, "\": "), rootForm); }
	
	
	// add all navigation pages on this HTML page to navigation pages registry
	$("[data-pli-navigation-page]").each(function navigationPageInit() {
	    var $navigationPage = $(this),
	        navigationPage = $navigationPage.data("pliNavigationPage");
	
	    if (typeof navigationPage !== "object") { throw new Error("Attribute data-pli-navigation-page must resolve to an object"); }
	    if (typeof navigationPage.name !== "string") { throw new Error("Attribute data-pli-navigation-page must resolve to an object with string property 'name'"); }
	    if (typeof navigationPage.parentId !== "string") { throw new Error("Attribute data-pli-navigation-page must resolve to an object with string property 'parentId'"); }
	    navigationPage = new NavigationPage(navigationPage, $navigationPage, navigationPage.parentId.concat("_", navigationPage.name));
	    navigationPages[navigationPage.id] = navigationPage; // add newly created page to page registry
	    $navigationPage.data("pliNavigationPage", navigationPage); // update element with fully realized NavigationPage data
	});
	
	
	// connect navigation pages via parentId
	$.each(navigationPages, function navigationPageConnectParent() {
	    if (this.parentId) {
	        this.parent = navigationPages[this.parentId];
	        if (!this.parent) { throw new Error("Unable to find navigation parent \"".concat(this.parentId, "\"")); }
	        this.parent.children.push(this);
	    }
	});
	
	
	// process initial hash and make sure we react to all
	// subsequent hash changes once the page is ready
	// (i.e. images & co. might not have finished downloading
	// yet, but "meat" of the page is there (DOM, scripts) )
	$(document).on("pliLoadedScripts", function onLoadedScripts() {
	    $(".initiallyActive").removeClass("initiallyActive");
	    onHashChange();
	    $(window).on("hashchange", onHashChange);
	}).mousedown(function onMouseDown() {
	    lastActiveElement = document.activeElement;
	});
	
	
	// create and return export object that will become "Pli.forms"
	module.exports = {
	    getCurrentForm: getCurrentForm,
	    resetActivationFocus: resetActivationFocus,
	    add: addForm,
	    close: closeForm,
	    open: openForm,
	    root: rootForm,
	
	    // Collection of Pli forms indexed by form id
	    // (All HTML elements with the "data-pli-form" attribute are added to this collection when this file is loaded.)
	    registry: formsRegistry,
	    navigationPages: navigationPages,
	    onHashChange: onHashChange, // TODO: rename to "synchronizeHash" or something similar
	    crumbs: ko.observable({ beginChanged: false, begin: null, endChanged: false, end: null }) // TODO: make observable read-only from outside
	};
	


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var util_1 = __webpack_require__(386);
	var stopBinding = {
	    init: function () {
	        return { controlsDescendantBindings: true };
	    }
	};
	/**
	 * Activates the 'stopBinding' binding.
	 */
	function activateStopBinding() {
	    var handler = util_1.addBindingHandler("stopBinding", stopBinding);
	    if (!ko.virtualElements.allowedBindings["stopBinding"]) {
	        // Make stopBinding applicable to virtual elements also
	        // (see http://www.knockmeout.net/2012/05/quick-tip-skip-binding.html)
	        ko.virtualElements.allowedBindings["stopBinding"] = true;
	    }
	    return handler;
	}
	exports.activateStopBinding = activateStopBinding;
	



/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	/**
	 * Persistent dirty flag states.
	 */
	var DirtyState;
	(function (DirtyState) {
	    DirtyState[DirtyState["Unknown"] = 0] = "Unknown";
	    DirtyState[DirtyState["Clean"] = 1] = "Clean";
	    DirtyState[DirtyState["Suspended"] = 2] = "Suspended";
	    DirtyState[DirtyState["Dirty"] = 3] = "Dirty";
	})(DirtyState || (DirtyState = {}));
	;
	/**
	 * Attaches a Knockout binding handler to "ko.bindingHandlers".
	 *
	 * This function is safe to call multiple times. If it is called twice for the
	 * same binding, it will verify that the binding is as given. If so, it will
	 * continue and return the binding. If not, it will throw an error.
	 *
	 * @param name
	 *    Name of the binding handler.
	 * @param handler
	 *    Handler that defines "init" and/or "update" functions.
	 * @returns
	 *    Handler instance.
	 * @throws
	 *     If the specified binding name has already been assigned
	 *     to a different binding handler.
	 */
	function addBindingHandler(name, handler) {
	    if (typeof name !== "string" || name.length === 0) {
	        throw new Error("A name must be specified for the binding handler");
	    }
	    if (!ko.bindingHandlers[name]) {
	        ko.bindingHandlers[name] = handler;
	    }
	    else if (ko.bindingHandlers[name] !== handler) {
	        throw new Error("\"ko.bindingHandlers." + name + "\" has been hijacked, unable to activate");
	    }
	    return handler;
	}
	exports.addBindingHandler = addBindingHandler;
	/**
	 * Creates a KnockoutDirtyFlag that recalculates the 'dirty' state whenever a contained value changes.
	 *
	 * Inspired by http://www.knockmeout.net/2011/05/creating-smart-dirty-flag-in-knockoutjs.html
	 *
	 * @param root
	 *     The root object to track.
	 * @param isSuspended
	 *     Whether the dirty tracker starts in the 'suspended' state.
	 * @return
	 *     An KnockoutDirtyFlag observable indicating whether the root object is dirty.
	 */
	function createTrackingDirtyFlag(root, isSuspended) {
	    var originalJSON;
	    var resumeResetRequested = false;
	    var isSuspendedObservable = ko.observable(!!isSuspended);
	    // subscribe to all observables in root (recursively),
	    // which causes this dependent observable to re-evaluate
	    // every time any observable in "root" changes
	    var currentJSON = ko.computed(function () {
	        if (isSuspendedObservable()) {
	            return null; // while dirtyFlag is suspended, only subscribe to isSuspendedObservable changes
	        }
	        var rootJson = ko.toJSON(root); // subscribe to every observable in the model
	        if (resumeResetRequested) {
	            resumeResetRequested = false;
	            originalJSON(rootJson); // when this computation function finishes, dirtyTest function will run (subcribed to currentJSON); it will set isDirty to false (because both original and current JSON now point to the same value)
	        }
	        return rootJson;
	    });
	    // take snapshot of "root" at creation time
	    // (can be updated with "reset" function, see below)
	    originalJSON = ko.observable(currentJSON());
	    // initialize isDirty observable
	    var isDirty = ko.observable(false);
	    isDirty.originalJSON = originalJSON;
	    isDirty.currentJSON = currentJSON;
	    isDirty.reset = function () {
	        isDirty.resume(true);
	    };
	    isDirty.suspend = function () {
	        isSuspendedObservable(true);
	    };
	    isDirty.resume = function (resetOnResume) {
	        if (isSuspendedObservable()) {
	            resumeResetRequested = resetOnResume;
	            isSuspendedObservable(false);
	        }
	        else if (resetOnResume) {
	            originalJSON(currentJSON());
	            isDirty(false);
	        }
	    };
	    isDirty.isSuspended = function () {
	        return isSuspendedObservable.peek();
	    };
	    // recompute dirty flag each time currentJSON changes
	    currentJSON.subscribe(function dirtyTest() {
	        if (!isSuspendedObservable()) {
	            isDirty(currentJSON() !== originalJSON());
	        }
	    });
	    return isDirty;
	}
	/**
	 * Creates a KnockoutDirtyFlag that stops tracking the 'dirty' state after the first change.
	 * Even if the change is subsequently reverted, the 'dirty' state persists.
	 *
	 * @param root
	 *     The root object to track.
	 * @param isSuspended
	 *     Whether the dirty tracker starts in the 'suspended' state.
	 * @return
	 *     An KnockoutDirtyFlag observable indicating whether the root object is dirty.
	 */
	function createPersistentDirtyFlag(root, isSuspended) {
	    var isDirty = ko.observable(false);
	    var stateObservable = ko.observable(isSuspended ? DirtyState.Suspended : DirtyState.Unknown);
	    ko.computed(function persistentDirtyFlagChangeMonitor() {
	        switch (stateObservable()) {
	            case DirtyState.Unknown:
	                ko.toJS(root); // subscribe to every observable in the model
	                stateObservable(DirtyState.Clean);
	                isDirty(false);
	                break;
	            case DirtyState.Clean:
	                stateObservable(DirtyState.Dirty); // mark as dirty
	                isDirty(true);
	                break;
	            default:
	                break;
	        }
	    });
	    isDirty.currentJSON = function () { return ko.toJSON(root); }; // maintain interface of tracking dirty flag, as expected by InitViewModel
	    isDirty.suspend = function () {
	        stateObservable(DirtyState.Suspended);
	    };
	    isDirty.resume = function (resetOnResume) {
	        if (stateObservable.peek() === DirtyState.Suspended || resetOnResume) {
	            stateObservable(DirtyState.Unknown);
	        }
	    };
	    isDirty.reset = function () {
	        if (stateObservable.peek() !== DirtyState.Clean) {
	            stateObservable(DirtyState.Unknown);
	        }
	    };
	    isDirty.isSuspended = function () { return stateObservable.peek() === DirtyState.Suspended; };
	    return isDirty;
	}
	/**
	 * Creates a KnockoutDirtyFlag instance.
	 * @param root
	 *     Root object used to track changes.
	 * @param isSuspended
	 *     If true, starts in a 'suspended' state (does not track changes until 'resume' called).
	 * @param isPersistent
	 *     If true, 'dirty' state persists after the first change is detected and until 'reset' is called.
	 */
	function dirtyFlag(root, isSuspended, isPersistent) {
	    if (isSuspended === void 0) { isSuspended = false; }
	    if (isPersistent === void 0) { isPersistent = false; }
	    return isPersistent
	        ? createPersistentDirtyFlag(root, isSuspended)
	        : createTrackingDirtyFlag(root, isSuspended);
	}
	exports.dirtyFlag = dirtyFlag;
	



/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var R = __webpack_require__(7);
	var separatorChar = ",";
	function areIdSegmentsEqual(ids1, ids2) {
	    return (ids1 === null || ids1 === undefined
	        ? ids2 === null || ids2 === undefined
	        : typeof ids1 !== "string" || typeof ids2 !== "string"
	            ? ids1 === ids2
	            : ids1.toLowerCase() === ids2.toLowerCase());
	}
	/**
	 * Compares IDs for equality. IDs can either be single or composite keys.
	 */
	function areEqual(id1, id2) {
	    if (!Array.isArray(id1)) {
	        return !Array.isArray(id2) && areIdSegmentsEqual(id1, id2);
	    }
	    if (!Array.isArray(id2) || id1.length !== id2.length) {
	        return false;
	    }
	    for (var i = 0, l = id1.length; i < l; i += 1) {
	        if (!areIdSegmentsEqual(id1[i], id2[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.areEqual = areEqual;
	/**
	 * Decodes URI component encoded with "crumbId.encode" into individual segments.
	 *
	 * @param value {string}
	 *     Encoded URI fragment containing one or more segments
	 *     separated by the separator character (","). For example,
	 *     value "Hello%2C%20world,World%2C%20hello" will be
	 *     decoded into ["Hello, world", "World, hello"].
	 *
	 * @returns {string | string[]}
	 *     A string if result has a single segment, array of strings otherwise.
	 */
	function decode(value) {
	    if (typeof value !== "string") {
	        return "";
	    }
	    var result = R.map(decodeURIComponent, value.split(separatorChar));
	    return (result.length === 1 ? result[0] : result);
	}
	exports.decode = decode;
	/**
	 * Encodes a single segment of crumb ID into a URI component string.
	 */
	function encodeIdSegment(value) {
	    return (value === null || value === undefined
	        ? ""
	        : encodeURIComponent(value));
	}
	/**
	 * Encodes ID containing one (simple key) or more (composite key) segments into a single URI component.
	 *
	 * Try to keep the result as pretty (for humans) as possible.
	 * Accepts 0..N arguments; use one argument for regular keys,
	 * multiple arguments for composite keys.
	 */
	function encode(ids) {
	    return (arguments.length === 1 && Array.isArray(ids)
	        ? encode.apply(null, ids) // special case for "encodeId([1,2,3])", unwrapped to "encodeId(1,2,3)"
	        : R.join(separatorChar, R.map(encodeIdSegment, arguments)));
	}
	exports.encode = encode;
	/**
	 * Parses the specified crumb ID (typically created by "crumbId.decode", e.g. from "Forms.js") into a new "ParsedCrumbId" object.
	 */
	function parseDecodedCrumbId(decodedCrumbId) {
	    if (decodedCrumbId === undefined || decodedCrumbId === null) {
	        return { id: "", named: {}, anonymous: [] };
	    }
	    if (typeof decodedCrumbId === "string") {
	        return { id: decodedCrumbId, named: {}, anonymous: [] };
	    }
	    var result = {
	        id: "",
	        named: {},
	        anonymous: []
	    };
	    for (var _i = 0, decodedCrumbId_1 = decodedCrumbId; _i < decodedCrumbId_1.length; _i++) {
	        var crumbIdSegment = decodedCrumbId_1[_i];
	        if (!result.id) {
	            result.id = crumbIdSegment;
	        }
	        else {
	            var separator = crumbIdSegment.indexOf(":");
	            if (separator < 0) {
	                result.anonymous.push(crumbIdSegment);
	            }
	            else {
	                result.named[crumbIdSegment.substring(0, separator)] = crumbIdSegment.substring(separator + 1);
	            }
	        }
	    }
	    return result;
	}
	exports.parseDecodedCrumbId = parseDecodedCrumbId;
	/**
	 * Serializes "ParsedCrumbId" object into an array of crumb ID segments (which can be used as an input to "crumbId.encode" or "Forms.js/open" functions).
	 */
	function stringifyParsedCrumbId(parsedCrumbId) {
	    if (parsedCrumbId === undefined || parsedCrumbId === null) {
	        return [""];
	    }
	    return [parsedCrumbId.id]
	        .concat(parsedCrumbId.anonymous)
	        .concat(Object
	        .keys(parsedCrumbId.named)
	        .map(function (name) { return (name + ":" + parsedCrumbId.named[name]); }));
	}
	exports.stringifyParsedCrumbId = stringifyParsedCrumbId;
	



/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(global, module) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	
	; jQuery = global.jQuery = __webpack_require__(2);
	; var __browserify_shim_require__=require;(function browserifyShim(module, define, require) {
	/**
	 * jQuery Tools 1.2.8 alpha2
	 *
	 * Manual concatenation of:
	 * - src/overlay/overlay.js
	 * - src/toolbox/toolbox.expose.js
	 */
	
	/*global jQuery: false */
	/*jslint browser: true, white: true */
	
	(function($) {
	    "use strict";
	
	    var instances = [], effects = {};
	
	    // static constructs
	    $.tools = $.tools || {version: '1.2.8 alpha1'};
	
	    $.tools.overlay = {
	
	        addEffect: function(name, loadFn, closeFn) {
	            effects[name] = [loadFn, closeFn];
	        },
	
	        conf: {
	            close: null,
	            closeOnClick: true,
	            closeOnEsc: true,
	            closeSpeed: 'fast',
	            effect: 'default',
	
	            // since 1.2. fixed positioning not supported by IE6
	            fixed: (document.documentMode || 100) > 6,
	
	            left: 'center',
	            load: false, // 1.2
	            mask: null,
	            oneInstance: true,
	            speed: 'normal',
	            target: null, // target element to be overlayed. by default taken from [rel]
	            top: '10%'
	        }
	    };
	
	
	    // the default effect. nice and easy!
	    $.tools.overlay.addEffect('default',
	
	        /*
	            onLoad/onClose functions must be called otherwise none of the
	            user supplied callback methods won't be called
	        */
	        function(pos, onLoad) {
	
	            var conf = this.getConf(),
	                 w = $(window);
	
	            if (!conf.fixed)  {
	                pos.top += w.scrollTop();
	                pos.left += w.scrollLeft();
	            }
	
	            pos.position = conf.fixed ? 'fixed' : 'absolute';
	
	            // milang, 2014-01-28: when using jquery.animate-enhanced.js with jquery 1.11,
	            // fade* is resetting top/left position of overlay element; if we set "leaveTransforms"
	            // to true, this is not happening
	            // this.getOverlay().css(pos).fadeIn(conf.speed, onLoad);
	            this.getOverlay().css(pos).animate({ opacity: "show", leaveTransforms: true }, conf.speed, onLoad);
	
	        }, function(onClose) {
	            // this.getOverlay().fadeOut(this.getConf().closeSpeed, onClose);
	            this.getOverlay().animate({ opacity: "hide", leaveTransforms: true }, this.getConf().closeSpeed, onClose);
	        }
	    );
	
	
	    function Overlay(trigger, conf) {
	
	        // private variables
	        var self = this,
	            fire = trigger.add(self),
	            w = $(window),
	            closers,
	            overlay,
	            opened,
	            maskConf = $.tools.expose && (conf.mask || conf.expose),
	            uid = Math.random().toString().slice(10);
	
	
	        // mask configuration
	        if (maskConf) {
	            if (typeof maskConf === 'string') { maskConf = {color: maskConf}; }
	            maskConf.closeOnClick = maskConf.closeOnEsc = false;
	        }
	
	        // get overlay and trigger
	        var jq = conf.target || trigger.attr("rel") || trigger;
	        overlay = $(jq);
	        if (!overlay.length) { throw "Could not find Overlay: " + jq; }
	
	        // trigger's click event
	        if (trigger && trigger.index(overlay) === -1) {
	            trigger.click(function(e) {
	                self.load(e);
	                return e.preventDefault();
	            });
	        }
	
	        // API methods
	        $.extend(self, {
	
	            load: function(e) {
	
	                // can be opened only once
	                if (self.isOpened()) { return self; }
	
	                // find the effect
	                var eff = effects[conf.effect];
	                if (!eff) { throw "Overlay: cannot find effect : \"" + conf.effect + "\""; }
	
	                // close other instances?
	                if (conf.oneInstance) {
	                    $.each(instances, function() {
	                        this.close(e);
	                    });
	                }
	
	                // onBeforeLoad
	                e = e || $.Event();
	                e.type = "onBeforeLoad";
	                fire.trigger(e);
	                if (e.isDefaultPrevented()) { return self; }
	
	                // opened
	                opened = true;
	
	                // possible mask effect
	                if (maskConf) { $(overlay).expose(maskConf); }
	
	                // position & dimensions
	                var top = conf.top;
	                if (typeof top === 'string')  {
	                    if (top === 'center') {
	                        var oHeight = overlay.outerHeight(true);
	                        top = Math.round(Math.max((w.height() - oHeight) / 2, 0));
	                    } else { // treat as percentage
	                        top = Math.round(parseInt(top, 10) * w.height() / 100);
	                    }
	                }
	
	                var left = conf.left;
	                if (typeof left === 'string') {
	                    if (left === 'center') {
	                        var oWidth = overlay.outerWidth(true);
	                        left = Math.round(Math.max((w.width() - oWidth) / 2, 0));
	                    } else { // treat as percentage
	                        left = Math.round(parseInt(left, 10) * w.width() / 100);
	                    }
	                }
	
	
	                // load effect
	                eff[0].call(self, {top: top, left: left}, function() {
	                    if (opened) {
	                        e.type = "onLoad";
	                        fire.trigger(e);
	                    }
	                });
	
	                // mask.click closes overlay
	                if (maskConf && conf.closeOnClick) {
	                    $.mask.getMask().one("click", self.close);
	                }
	
	                // when window is clicked outside overlay, we close
	                if (conf.closeOnClick) {
	                    $(document).on("click." + uid, function(e) {
	                        if (!$(e.target).parents(overlay).length) {
	                            self.close(e);
	                        }
	                    });
	                }
	
	                // keyboard::escape
	                if (conf.closeOnEsc) {
	
	                    // one callback is enough if multiple instances are loaded simultaneously
	                    $(document).on("keydown." + uid, function(e) {
	                        if (e.keyCode === 27) {
	                            self.close(e);
	                        }
	                    });
	                }
	
	
	                return self;
	            },
	
	            close: function(e) {
	
	                if (!self.isOpened()) { return self; }
	
	                e = e || $.Event();
	                e.type = "onBeforeClose";
	                fire.trigger(e);
	                if (e.isDefaultPrevented()) { return; }
	
	                opened = false;
	
	                // close effect
	                effects[conf.effect][1].call(self, function() {
	                    e.type = "onClose";
	                    fire.trigger(e);
	                });
	
	                // unbind the keyboard / clicking actions
	                $(document).off("click." + uid + " keydown." + uid);
	
	                if (maskConf) {
	                    $.mask.close();
	                }
	
	                return self;
	            },
	
	            getOverlay: function() {
	                return overlay;
	            },
	
	            getTrigger: function() {
	                return trigger;
	            },
	
	            getClosers: function() {
	                return closers;
	            },
	
	            isOpened: function()  {
	                return opened;
	            },
	
	            // manipulate start, finish and speeds
	            getConf: function() {
	                return conf;
	            }
	
	        });
	
	        // callbacks
	        $.each(["onBeforeLoad", "onStart", "onLoad", "onBeforeClose", "onClose"], function () {
	
	            // configuration
	            var name = this;
	            if ($.isFunction(conf[name])) {
	                $(self).on(name, conf[name]);
	            }
	
	            // API
	            self[name] = function(fn) {
	                if (fn) { $(self).on(name, fn); }
	                return self;
	            };
	        });
	
	        // close button
	        closers = overlay.find(conf.close || ".close");
	
	        if (!closers.length && !conf.close) {
	            closers = $('<a class="close"></a>');
	            overlay.prepend(closers);
	        }
	
	        closers.click(function(e) {
	            self.close(e);
	        });
	
	        // autoload
	        if (conf.load) { self.load(); }
	
	    }
	
	    // jQuery plugin initialization
	    $.fn.overlay = function(conf) {
	
	        // already constructed --> return API
	        var el = this.data("overlay");
	        if (el) { return el; }
	
	        if ($.isFunction(conf)) {
	            conf = {onBeforeLoad: conf};
	        }
	
	        conf = $.extend(true, {}, $.tools.overlay.conf, conf);
	
	        this.each(function() {
	            el = new Overlay($(this), conf);
	            instances.push(el);
	            $(this).data("overlay", el);
	        });
	
	        return conf.api ? el: this;
	    };
	
	}(jQuery));
	
	(function($) {
	    "use strict";
	
	    var tool = {
	        conf: {
	            maskId: 'exposeMask',
	            loadSpeed: 'slow',
	            closeSpeed: 'fast',
	            closeOnClick: true,
	            closeOnEsc: true,
	
	            // css settings
	            zIndex: 9998,
	            opacity: 0.8,
	            startOpacity: 0,
	            color: '#fff',
	
	            // callbacks
	            onLoad: null,
	            onClose: null
	        }
	    };
	
	    // static constructs
	    $.tools.expose = tool;
	
	    function call(fn) {
	        if (fn) { return fn.call($.mask); }
	    }
	
	    var mask, exposed, loaded, config, overlayIndex;
	
	
	    $.mask = {
	
	        load: function(conf, els) {
	
	            // already loaded ?
	            if (loaded) { return this; }
	
	            // configuration
	            if (typeof conf === 'string') {
	                conf = {color: conf};
	            }
	
	            // use latest config
	            conf = conf || config;
	
	            config = conf = $.extend($.extend({}, tool.conf), conf);
	
	            // get the mask
	            mask = $("#" + conf.maskId);
	
	            // or create it
	            if (!mask.length) {
	                mask = $('<div/>').attr("id", conf.maskId);
	                $("body").append(mask);
	            }
	
	            mask.css({
	                position:'absolute',
	                top: 0,
	                left: 0,
	                right: 0,
	                bottom: 0,
	                display: 'none',
	                opacity: conf.startOpacity,
	                zIndex: conf.zIndex
	            });
	
	            if (conf.color) {
	                mask.css("backgroundColor", conf.color);
	            }
	
	            // onBeforeLoad
	            if (call(conf.onBeforeLoad) === false) {
	                return this;
	            }
	
	            // esc button
	            if (conf.closeOnEsc) {
	                $(document).on("keydown.mask", function(e) {
	                    if (e.keyCode === 27) {
	                        $.mask.close(e);
	                    }
	                });
	            }
	
	            // mask click closes
	            if (conf.closeOnClick) {
	                mask.on("click.mask", function(e)  {
	                    $.mask.close(e);
	                });
	            }
	
	            // exposed elements
	            if (els && els.length) {
	
	                overlayIndex = els.eq(0).css("zIndex");
	
	                // make sure element is positioned absolutely or relatively
	                $.each(els, function() {
	                    var el = $(this);
	                    if (!/relative|absolute|fixed/i.test(el.css("position"))) {
	                        el.css("position", "relative");
	                    }
	                });
	
	                // make elements sit on top of the mask
	                exposed = els.css({ zIndex: Math.max(conf.zIndex + 1, overlayIndex === 'auto' ? 0 : overlayIndex)});
	            }
	
	            // reveal mask
	            mask.css({display: 'block'}).fadeTo(conf.loadSpeed, conf.opacity, function() {
	                call(conf.onLoad);
	                loaded = "full";
	            });
	
	            loaded = true;
	            return this;
	        },
	
	        close: function() {
	            if (loaded) {
	
	                // onBeforeClose
	                if (call(config.onBeforeClose) === false) { return this; }
	
	                mask.fadeOut(config.closeSpeed, function()  {
	                    if (exposed) {
	                        exposed.css({zIndex: overlayIndex});
	                    }
	                    loaded = false;
	                    call(config.onClose);
	                });
	
	                // unbind various event listeners
	                $(document).off("keydown.mask");
	                mask.off("click.mask");
	                $(window).off("resize.mask");
	            }
	
	            return this;
	        },
	
	        fit: function() {
	            throw new Error("$.mask.fit has been deprecated");
	        },
	
	        getMask: function() {
	            return mask;
	        },
	
	        isLoaded: function(fully) {
	            return fully ? loaded === 'full' : loaded;
	        },
	
	        getConf: function() {
	            return config;
	        },
	
	        getExposed: function() {
	            return exposed;
	        }
	    };
	
	    $.fn.mask = function(conf) {
	        $.mask.load(conf);
	        return this;
	    };
	
	    $.fn.expose = function(conf) {
	        $.mask.load(conf, this);
	        return this;
	    };
	
	}(jQuery));
	
	}).call(global, module, undefined, undefined);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(19)(module)))

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true, unparam: true */
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var $ = __webpack_require__(1);
	var pli = __webpack_require__(5);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	var submenuShowTimeoutId = null,
	    lastShownMenu = null,
	    templatePrefix = "menu",
	    showMenuEvent = $.Callbacks(), // fires when a menu has been opened
	    hideMenuEvent = $.Callbacks(); // fires when a menu has been closed
	
	//-------------------------------------------
	// If any submenu show action is pending
	// (e.g. when hovering over menu item
	// with submenu), cancel it now.
	function cancelPendingSubmenuShow() {
	    if (submenuShowTimeoutId) {
	        window.clearTimeout(submenuShowTimeoutId);
	        submenuShowTimeoutId = null;
	    }
	}
	
	
	//-------------------------------------------
	// adds a template element into DOM if it doesn't exist
	function ensureTemplate(id, template) {
	    if ($('#' + id).length === 0) {
	        var templateStr = (typeof template === "string"
	            ? template
	            : template.join(""));
	        $("body").append("<script id=\"" + id + "\" type=\"text/html\">" + templateStr + "<\/script>");
	    }
	}
	
	
	//-------------------------------------------
	// Define built-in menu item templates and make
	// sure they are injected into the current DOM.
	function ensureMenuTemplates() {
	    /*jslint white: true */
	
	    // add menu knockout template
	    ensureTemplate(
	        templatePrefix.concat("Template"), [
	        "<ul class='pliMenu' data-bind='",
	            "template: { foreach: menuItems, name: function (menuItem) { return menuItem.templateId; } },",
	            "visible: visible,",
	            "style: { left: position().left + \"px\", top: position().top + \"px\" }",
	        "'></ul>"]);
	
	    // add button menu item knockout template
	    ensureTemplate(
	        templatePrefix.concat("Button"), [
	        "<li class='pliMenuItem' data-bind='visible: visible'>",
	            "<button class='pliMenuAction' data-bind='name: name, click: onClick, pliDisableButton: disabled, css: { pliActiveCmd: active }'>",
	                "<!-- ko if: sprite --><i class='pliMenuIcon' data-bind='css: sprite'></i><!-- /ko -->",
	                "<!-- ko if: hasSubmenu --><i class='pliMenuIcon arrow'></i><!-- /ko -->",
	                "<!-- ko text: title --><!-- /ko -->",
	            "</button>",
	            "<!-- ko if: hasSubmenu --><div data-bind='template: { name: \"menuTemplate\", data: submenu }'></div><!-- /ko -->",
	        "</li>"]);
	
	    // add label menu item knockout template
	    ensureTemplate(
	        templatePrefix.concat("Label"), [
	        "<li class='pliMenuItem' data-bind='visible: visible'>",
	            "<div class='pliMenuLabel'>",
	                "<!-- ko if: sprite --><i class='pliMenuIcon' data-bind='css: sprite'></i><!-- /ko -->",
	                "<!-- ko text: title --><!-- /ko -->",
	            "</div>",
	        "</li>"]);
	
	    // add error menu item knockout template
	    ensureTemplate(
	        templatePrefix.concat("Error"), [
	        "<li class='pliMenuItem' data-bind='visible: visible'>",
	            "<div class='pliMenuLabel error'>",
	                "<i class='pliMenuIcon sprite-warning-16'></i>",
	                "<!-- ko text: title --><!-- /ko -->",
	            "</div>",
	        "</li>"]);
	
	    // add separator menu item knockout template
	    ensureTemplate(
	        templatePrefix.concat("Separator"),
	        "<li class='pliMenuSeparator' data-bind='visible: visible'></li>");
	
	    /*jslint white: false */
	}
	
	
	//-------------------------------------------
	// For the specified positioning information
	// (as created by "findBestFitOffsetFor")
	// calculate candidate offsets, preferring
	// horizontal positioning (target element
	// appears to the left or right of the owner
	// element). Suitable for submenus.
	function getOffsetCandidatesWithHorizontalPreference(info) {
	    var left1 = info.ownerOffset.left + info.ownerWidth;
	    var left2 = info.ownerOffset.left - info.targetWidth + (info.ownerWidth ? 0 : 1); // if owner has no width, compensate by 1px
	    var top2 = info.ownerOffset.top - (info.targetHeight - (info.ownerHeight || 1)); // if owner has no height, compensate by 1px
	    return [
	        { left: left1, top: info.ownerOffset.top }, // "to the right and align top edge"
	        { left: left1, top: top2 }, // "to the right and align bottom edge"
	        { left: left2, top: info.ownerOffset.top }, // "to the left and align top edge"
	        { left: left2, top: top2 } // "to the left and align bottom edge"
	    ];
	}
	
	
	//-------------------------------------------
	// For the specified positioning information
	// (as created by "findBestFitOffsetFor")
	// calculate candidate offsets, preferring
	// vertical positioning (target element
	// appears above or below the owner element).
	// Suitable for toolbar (fixed) menus.
	function getOffsetCandidatesWithVerticalPreference(info) {
	    var left2 = info.ownerOffset.left - (info.targetWidth - (info.ownerWidth || 1)); // if owner has no width, compensate by 1px
	    var top1 = info.ownerOffset.top + info.ownerHeight;
	    var top2 = info.ownerOffset.top - info.targetHeight + (info.ownerHeight ? 0 : 1); // if owner has no height, compensate by 1px
	    return [
	        { left: info.ownerOffset.left, top: top1 }, // "align left edge and below"
	        { left: left2, top: top1 }, // "align right edge and below"
	        { left: info.ownerOffset.left, top: top2 }, // "align left edge and above"
	        { left: left2, top: top2 } // "align right edge and above"
	    ];
	}
	
	
	//-------------------------------------------
	// Find offset of top-left corner of target
	// element (relative to target element's offset
	// parent) that best fits in the current viewport.
	//
	// Terminology:
	// "viewport" - client area of browser window;
	//     assuming top-left corner is [0,0];
	//     when document scrollbars are in their
	//     initial position, viewport coordinates
	//     match document coordinates; once scrollbars
	//     move, the same viewport pixels show different
	//     parts of the document, depending on current
	//     scrollbar position)
	// "target" - element being positioned
	//     (e.g. context menu)
	// "owner" - element next to which "target"
	//     element will appear (usually button
	//     that made "target" visible or mouse
	//     right-click point)
	function findBestFitOffsetFor($target, $targetOffsetParent, $ownerOrPositionEvent, getCandidates) {
	    // determine viewport and target dimensions
	    var $window = $(window);
	    var info = {
	        viewportWidth: $window.width(),
	        viewportHeight: $window.height(),
	        targetWidth: $target.outerWidth(),
	        targetHeight: $target.outerHeight(),
	        ownerWidth: 0,
	        ownerHeight: 0,
	        ownerOffset: null
	    };
	
	    // determine owner dimensions and offset,
	    // adjusted to relative-to-viewport
	    // coordinate system
	    var $document = $(document),
	        documentScrollLeft = $document.scrollLeft(),
	        documentScrollTop = $document.scrollTop();
	    if (typeof $ownerOrPositionEvent.offset === "function") {
	        info.ownerWidth = $ownerOrPositionEvent.outerWidth();
	        info.ownerHeight = $ownerOrPositionEvent.outerHeight();
	        info.ownerOffset = $ownerOrPositionEvent.offset(); // relative-to-document (as per jQuery documentation)
	        info.ownerOffset.left = info.ownerOffset.left - documentScrollLeft; // adjust to relative-to-viewport
	        info.ownerOffset.top = info.ownerOffset.top - documentScrollTop; // adjust to relative-to-viewport
	    } else {
	        info.ownerOffset = {
	            left: $ownerOrPositionEvent.pageX - documentScrollLeft, // adjust to relative-to-viewport
	            top: $ownerOrPositionEvent.pageY - documentScrollTop // adjust to relative-to-viewport
	        };
	    }
	
	    // get & evaluate candidates
	    var i, l, selected, candidates = getCandidates(info);
	    for (i = 0, l = candidates.length; i < l; i += 1) {
	        selected = candidates[i];
	        if (selected.left >= 0 && selected.top >= 0 && info.viewportWidth - (selected.left + info.targetWidth) >= 0 && info.viewportHeight - (selected.top + info.targetHeight) >= 0) {
	            break;
	        }
	        selected = null;
	    }
	    if (!selected) {
	        selected = candidates[0]; // if no candidate fits, use the first one
	    }
	
	    // adjust selected candidate offset from relative-to-viewport
	    // to relative-to-target's-offset-parent coordinate system
	    var targetOffsetParentOffset = ($targetOffsetParent ? $targetOffsetParent.offset() : { left: 0, top: 0 }); // relative-to-document (as per jQuery documentation)
	    targetOffsetParentOffset.left = targetOffsetParentOffset.left - documentScrollLeft; // adjust to relative-to-viewport
	    targetOffsetParentOffset.top = targetOffsetParentOffset.top - documentScrollTop; // adjust to relative-to-viewport
	    selected.left = selected.left - targetOffsetParentOffset.left; // convert to relative-to-target's-offset-parent
	    selected.top = selected.top - targetOffsetParentOffset.top; // convert to relative-to-target's-offset-parent
	    return selected;
	}
	
	
	//-------------------------------------------
	// calculates position of static (non-context) menu
	function getStaticMenuPosition($triggerElement, $menuElement) {
	    return findBestFitOffsetFor($menuElement, null, $triggerElement, getOffsetCandidatesWithVerticalPreference);
	}
	
	
	//-------------------------------------------
	// calculates position of context menu
	function getContextMenuPosition(e, $menuElement) {
	    return findBestFitOffsetFor($menuElement, null, e, getOffsetCandidatesWithHorizontalPreference);
	}
	
	
	//-------------------------------------------
	// Calculate submenu position. Assumes that
	// submenu positioning container is
	// the specified "menuItemElement".
	function getSubmenuPosition($menuItemElement) {
	    return findBestFitOffsetFor($menuItemElement.find(".pliMenu"), $menuItemElement, $menuItemElement, getOffsetCandidatesWithHorizontalPreference);
	}
	
	
	//-------------------------------------------
	// Handle recognized mouse events on menu items.
	// Currently shows/hides submenus when mouse
	// hovers over menu items.
	function onMenuItemMouseEvent(e) {
	    // determine action(s) to take
	    var cancel = false;
	    var menuItemToShow = null;
	    switch (e.type) {
	    case "mouseenter":
	        menuItemToShow = ko.dataFor(e.target);
	        if (menuItemToShow && !menuItemToShow.parentMenu) { menuItemToShow = menuItemToShow.parentMenuItem; } // if event bubbled from element associted with submenu viewmodel, select MenuItem that showed that submenu
	        cancel = !!menuItemToShow;
	        break;
	    case "mouseleave": // cancel pending menu show
	        cancel = true;
	        break;
	    }
	
	    // run cancel action if needed
	    if (cancel) {
	        cancelPendingSubmenuShow();
	    }
	
	    // run show action if needed
	    if (menuItemToShow) {
	        menuItemToShow.parentMenu.updateActiveItems(); // make all items inactive on current menu
	        submenuShowTimeoutId = window.setTimeout(function () {
	            if (menuItemToShow.hasSubmenu()) {
	                menuItemToShow.showSubmenu(e);
	            } else {
	                menuItemToShow.parentMenu.hideSubmenusRecursive();
	            }
	        }, 500);
	    }
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// MenuItem class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// menu item view model
	function MenuItem(config, data, parent, MenuClass) {
	    this.config = config;
	    this.parentMenu = parent;
	    this.data = data;
	    this.templateId = templatePrefix.concat(data.type || "Button");
	    this.title = ko.observable(data.title || "");
	    this.name = ko.observable(data.name || "");
	    this.items = ko.observableArray(data.items);
	    this.visible = ko.observable(true);
	    this.disabled = ko.observable(!!data.disabled);
	    this.active = ko.observable(false);
	    this.sprite = ko.observable(data.sprite || "");
	    this.submenu = ko.observable(null);
	    this.hasSubmenu = ko.observable();
	
	    // handle submenu item changes
	    ko.computed(function () {
	        var items = this.items();
	        if (items && items.length) {
	            this.submenu(new MenuClass(this.config, items, this));
	            this.hasSubmenu(true);
	        } else {
	            this.submenu(null);
	            this.hasSubmenu(false);
	        }
	    }, this);
	}
	
	
	//-------------------------------------------
	// shows submenu
	MenuItem.prototype.showSubmenu = function menuItemShowSubmenu(e) {
	    cancelPendingSubmenuShow();
	    this.parentMenu.hideSubmenusRecursive();
	    if (this.disabled.peek()) { return; }
	    this.submenu().showMenuStrip(getSubmenuPosition($(e.target).closest("li")));
	};
	
	
	//-------------------------------------------
	// handles menu item click event
	MenuItem.prototype.onClick = function menuItemOnClick(item, e) {
	    if (this.hasSubmenu()) {
	        this.showSubmenu(e);
	    } else {
	        this.parentMenu.hideRoot();
	        // execute click handler
	        (this.data.click || this.config.click)(this, this.parentMenu.getRoot().currentContext, e);
	    }
	    e.stopPropagation();
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Menu class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// menu view model
	function Menu(config, items, parent) {
	    this.parentMenuItem = parent;
	    this.currentContext = null;
	    this.config = config;
	    this.visible = ko.observable(false);
	    this.items = ko.observableArray(items || []); // raw items
	    this.menuItems = ko.computed(Menu.prototype.getMenuItems, this);
	    this.position = ko.observable({ left: 0, top: 0 });
	}
	
	
	//-------------------------------------------
	// converts raw items into array of MenuItem objects
	Menu.prototype.getMenuItems = function menuGetMenuItems() {
	    var menuItems = [], i, l = this.items().length;
	    for (i = 0; i < l; i += 1) {
	        menuItems.push(new MenuItem(this.config, this.items()[i], this, Menu));
	    }
	    return menuItems;
	};
	
	
	//-------------------------------------------
	// return root menu
	Menu.prototype.getRoot = function menuGetRoot() {
	    var root = this;
	    while (root.parentMenuItem) {
	        root = root.parentMenuItem.parentMenu;
	    }
	    return root;
	};
	
	
	//-------------------------------------------
	// highlights active menu items only
	Menu.prototype.updateActiveItems = function menuUpdateActiveItems() {
	    // make all parent menu items active
	    var parentMenu = this;
	    while (parentMenu.parentMenuItem) {
	        parentMenu.parentMenuItem.active(true);
	        parentMenu = parentMenu.parentMenuItem.parentMenu;
	    }
	    // make all menu items on current menu inactive
	    $.each(this.menuItems(), function (i, mi) {
	        mi.active(false);
	    });
	};
	
	
	//-------------------------------------------
	// Shows menu element at given position.
	// The function loads menu items from server if there is need.
	// NOTE: position is passed as resolver function to
	// make it possible to recalculate position of
	// changed menu when it loads items from server
	Menu.prototype.show = function menuShow(positionResolver) {
	    // request menu items if there is call data and this is top level menu
	    if (this.config.itemsCallData && !this.parentMenuItem) {
	        // show loading message
	        this.items([{ type: "Label", title: "Loading...", sprite: "sprite-progress-15 sprite-spin" }]);
	
	        // do call to get menu items
	        var callData = this.config.itemsCallData(this.getRoot().currentContext);
	        callData.owner = this;
	        this.activeRequest = pli.call(callData);
	        this.activeRequest.always(function completeMenuItemsLoad(response) {
	            var menu = response.owner;
	            if (menu.activeRequest && menu.activeRequest.xhr === response.clientXhr) {
	                var menuItems;
	                if (response.isError) {
	                    if (window.console) { window.console.error("Failed to get menu items: ".concat(response.result.message), response); }
	
	                    menuItems = [
	                        { type: "Error", title: "Unable to load" },
	                        {
	                            title: "Reload",
	                            sprite: "sprite-refresh-16",
	                            click: function retryMenuItemsLoad() {
	                                menu.show(positionResolver);
	                                return false;
	                            }
	                        }
	                    ];
	                } else {
	                    menuItems = response.result;
	                }
	
	                menu.activeRequest = null;
	                menu.items(menuItems);
	                menu.position(positionResolver()); // show menu again with recalculated position because menu size's been changed
	            } // else { if (window.console) { window.console.warn("This get-menu-items server response is stale, ignoring", response); } }
	        });
	    }
	
	    this.showMenuStrip(positionResolver());
	};
	
	
	//-------------------------------------------
	// Makes menu visible if it has items
	Menu.prototype.showMenuStrip = function showMenuStrip(position) {
	    // show menu only when menu is not empty
	    if (this.menuItems().length > 0) {
	
	        // track last shown menu
	        lastShownMenu = this;
	
	        // reset active items and make parent menu item active
	        this.updateActiveItems();
	
	        // resolve new position
	        this.position(position);
	
	        // position and make menu visible
	        this.visible(true);
	
	        // notify subscribers about shown menu
	        showMenuEvent.fire(this);
	    }
	};
	
	
	//-------------------------------------------
	// hides menu, its submenus and cancels active request if there is one
	Menu.prototype.hide = function menuHide() {
	    this.activeRequest = null;
	    if (this.visible()) {
	        this.hideSubmenusRecursive();
	        this.visible(false);
	        hideMenuEvent.fire(this);
	    }
	};
	
	
	//-------------------------------------------
	// calls hide() method on root menu
	Menu.prototype.hideRoot = function menuHideRoot() {
	    this.getRoot().hide();
	};
	
	
	//-------------------------------------------
	// hides all submenus recursively
	Menu.prototype.hideSubmenusRecursive = function menuHideSubmenusRecursive() {
	    // hides all submenus from given menu level
	    $.each(this.menuItems(), function (i, mi) {
	        if (mi.hasSubmenu()) {
	            mi.submenu().hideSubmenusRecursive();
	            mi.submenu().hide();
	        }
	    });
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	function setup(config) {
	    // expected config members:
	    //   clickSelector - jQuery element that is going to be clicked to make menu appeared
	    //   rightClickSelector - jQuery element that is going to be right clicked make menu appeared
	    //   notifier - callback that's triggered when there is need to display menu
	    //   itemsCallData - call data to get menu items
	    //   items - menu items hierarchy:
	    //      title - display text
	    //      html - custom html
	    //      name - name
	    //      visible - visibility
	    //      type - Button, Label, Separator, Error or Custom
	    //      disabled
	    //      sprite - sprite CSS class
	    //      items - submenu items
	    //      click - custom menu item click handler
	    //   click - general menu items click handler
	
	    if (!config.clickSelector && !config.rightClickSelector && !config.notifier) {
	        throw new Error("Menu cannot be created because there is no information specified when to show one.");
	    }
	
	    // ensure menu templates are defined
	    ensureMenuTemplates();
	
	    // create & configure menu container
	    var emptyHandler = function () { return false; };
	    var $container = $("<!-- ko stopBinding: true --><div data-bind='template: { name: \"menuTemplate\" }'></div><!-- /ko -->").appendTo("body");
	    $container[1].oncontextmenu = emptyHandler; // disable default context menu for the menu element
	    $container.eq(1).on("mouseenter mouseleave", ".pliMenu > *", onMenuItemMouseEvent);
	
	    // create & bind menu viewmodel
	    if (!config.click) { config.click = emptyHandler; }
	    var menu = new Menu({ itemsCallData: config.itemsCallData, click: config.click }, config.items);
	    ko.applyBindings(menu, $container[1]);
	
	    // container is now populated with menu, so let's resolve its element
	    var $menuElement = $container.find(".pliMenu").first();
	
	    // handle right click selector
	    if (config.rightClickSelector) {
	        var $rightClickSelector = $(config.rightClickSelector);
	        $rightClickSelector[0].oncontextmenu = emptyHandler;
	        $rightClickSelector.on("mouseup", function (e) {
	            if (e.which === 3) { // right click
	                menu.currentContext = config.rightClickSelector;
	                menu.show(function () {
	                    return getContextMenuPosition(e, $menuElement);
	                });
	            }
	        });
	    }
	
	    // handle click selector
	    if (config.clickSelector) {
	        var $clickSelector = $(config.clickSelector);
	        $clickSelector.on("click", function () {
	            // NOTE: hack to make toolbar item active depending on whether its menu shown or not
	            showMenuEvent.add(function (sender) {
	                if (sender === menu) { $clickSelector.addClass("pliActiveCmd"); }
	            });
	            hideMenuEvent.add(function (sender) {
	                if (sender === menu) { $clickSelector.removeClass("pliActiveCmd"); }
	            });
	
	            menu.currentContext = $clickSelector;
	            menu.show(function () {
	                return getStaticMenuPosition($clickSelector, $menuElement);
	            });
	        });
	    }
	
	    // handle notifier
	    if (config.notifier) {
	        config.notifier.add(function (e, context) {
	            menu.currentContext = context;
	            menu.show(function () {
	                return getContextMenuPosition(e, $menuElement);
	            });
	        });
	    }
	
	    // handle document mousedown event to hide this menu and all its submenus
	    $(window.document).mousedown(function (e) {
	        // hide menu only when mousedown occured outside
	        if (!$container.has($(e.target)).length) {
	            menu.hide();
	        }
	    });
	
	    // resizing browser window will hide all active menus
	    $(window).resize(function () {
	        menu.hide();
	    });
	
	    // activate menu keymap on menu show, deactivate on hide
	    showMenuEvent.add(function menuActivateKeymap(shownMenu) {
	        if (shownMenu === menu) {
	            pli.keys.activateKeymap("pliMenu");
	        }
	    });
	    hideMenuEvent.add(function menuDeactivateKeymap(hiddenMenu) {
	        if (hiddenMenu === menu) {
	            pli.keys.deactivateKeymap("pliMenu");
	        }
	    });
	
	    // return menu view model
	    return menu;
	}
	
	if (!pli.keys) { throw new Error('Menu.js expects a PliKeys instance on "pli.keys" but none was found'); }
	
	// register a menu keymap (will be activated
	// when main menu is shown, deactivated when
	// main menu is hidden)
	pli.keys.registerKeymap("pliMenu", {
	    "Esc": function closeLastShownMenu() {
	        if (lastShownMenu) {
	            lastShownMenu.hide();
	            lastShownMenu = (lastShownMenu.parentMenuItem && lastShownMenu.parentMenuItem.parentMenu) || null;
	            return false;
	        }
	    }
	});
	
	
	// exported as "Pli.menu"
	module.exports = {
	    setup: setup,
	    templatePrefix: templatePrefix,
	
	    // export offset calculation from menu module for now
	    // (this is a good candidate for separate module in the future)
	    findBestFitOffsetFor: findBestFitOffsetFor,
	    getOffsetCandidatesWithHorizontalPreference: getOffsetCandidatesWithHorizontalPreference,
	    getOffsetCandidatesWithVerticalPreference: getOffsetCandidatesWithVerticalPreference
	};
	


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true */
	"use strict";
	
	// Implements automatic browser window management.
	// Features:
	//
	// 1. Focus an existing window instead of
	//    opening a new one every time
	// ---------
	// If a document is already displayed in a child
	// window, opening the same document should focus
	// the existing window instead of opening a new one.
	//
	// How to use:
	// a) Include "pli/forms" in your module
	// b) Define method "pli.dialogId". It is expected
	//    to return a string that will uniquely
	//    identify document loaded in current browser
	//    window, for example "documentType:documentId".
	// c) Specify "options.id" when calling
	//    Pli.dialog.open, for example:
	//    Pli.dialog.open({ targetUrl: "~/Invoice/123", id: "invoice:123" })
	//
	//
	// 2. Warn before closing a browser window
	//    (typically about unsaved data)
	// ---------
	// If a document is edited in a child window,
	// attempting to close this window should
	// either auto-save it or warn user about
	// unsaved changes. Simple dialog registry
	// will not only show warning for the window,
	// being closed, but warnings from all
	// descendant windows as well. For example,
	// if window A opened windows A1 and A2
	// and A1 has unsaved changes (but not A or A2),
	// attempting to close A will show warning
	// from A1.
	//
	// How to use:
	// a) Include "pli/forms" in your module
	// b) Define method "pli.dialogClosingMessage".
	//    It is expected to return a string
	//    that describes why this browser window
	//    can't be closed automatically.
	//
	//    Note that dialogClosingMessage function
	//    will be called with one argument, "isRootLevel".
	//    When true, current window initiated
	//    close action. If false, an ancestor
	//    window initiated close action.
	//
	//    Using this flag we can generate one
	//    messge version if window is being closed
	//    directly by user ("This invoice has
	//    unsaved changes") and another version
	//    if window is being closed by parent window,
	//    e.g. if landing page is being closed
	//    by user ("Invoice 123 has unsaved changes").
	//
	//
	// 3. Automatically close all descendant windows
	// ---------
	// When a browser window closes, all descendant
	// windows will be closed as well.
	//
	// How to use:
	// a) Include "pli/forms" in your module
	
	var $ = __webpack_require__(1);
	var pli = __webpack_require__(5);
	var dialog = __webpack_require__(383);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Class "SimpleDialogRegistry"
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function SimpleDialogRegistry() {
	    /// <summary>
	    /// Create new instance of simple dialog
	    /// registry (singleton per browser window).
	    /// Hijacks Pli.dialog.open and registers
	    /// handlers for window.onBeforeUnload
	    /// and window.onUnload events.
	    /// </summary>
	
	    this._isUnloading = false;
	    this._children = []; // collection of child Pli objects
	
	    // override Pli.dialog.open
	    this._originalOpen = dialog.open;
	    dialog.open = this._open.bind(this);
	
	    // handle (current) window closing
	    $(window)
	        .on("beforeunload", this._beforeUnload.bind(this))
	        .on("unload", this._unload.bind(this));
	}
	
	
	//---------------------------------------
	SimpleDialogRegistry.prototype._beforeUnload = function registryBeforeUnload() {
	    /// <summary>
	    /// Handle window.onBeforeUnload event.
	    /// Returns all warnings about unsaved
	    /// data etc from this window and all
	    /// its registered descendants. Returns
	    /// undefined if no warnings are found
	    /// (as per window.onBeforeUnload
	    /// event expectations).
	    /// </summary>
	
	    if (this._isUnloading) { // parent already received user's approval to close
	        return undefined;
	    }
	
	    var m = this._gatherMessages([], true);
	    return (m.length
	        ? m.join("\n\n")
	        : undefined);
	};
	
	
	//---------------------------------------
	SimpleDialogRegistry.prototype._findPli = function registryFindPli(id) {
	    /// <summary>
	    /// Find Pli object with the specified
	    /// ID (recursively search all registered
	    /// descendants). Returns null if no
	    /// such Pli object can be found.
	    /// </summary>
	
	    if (pli.dialogId && pli.dialogId() === id) {
	        return pli;
	    }
	    var i, l, p;
	    for (i = 0, l = this._children.length; i < l; i += 1) {
	        p = this._children[i].simpleDialogRegistry._findPli(id);
	        if (p) { return p; }
	    }
	    return null;
	};
	
	
	//---------------------------------------
	SimpleDialogRegistry.prototype._gatherMessages = function registryGatherMessages(result, isRootLevel) {
	    /// <summary>
	    /// Gather warnings about unsaved data etc
	    /// from this window and all registered
	    /// descendants.
	    /// </summary>
	
	    var i, l, m = pli.dialogClosingMessage && pli.dialogClosingMessage(isRootLevel);
	    if (m) { result.push(m); }
	    for (i = 0, l = this._children.length; i < l; i += 1) {
	        this._children[i].simpleDialogRegistry._gatherMessages(result, false);
	    }
	
	    return result;
	};
	
	
	//---------------------------------------
	SimpleDialogRegistry.prototype._open = function registryOpen(options, wnd) {
	    /// <summary>
	    /// This method replaces Pli.dialog.open.
	    /// It first tries to locate an existing
	    /// window with the requested ID (options.id).
	    /// If this lookup fails, original Pli.dialog.open
	    /// will be called to open a new window.
	    /// If lookup succeeds, associated browser
	    /// window is focused (unless prevented
	    /// by browser security).
	    /// </summary>
	
	    if (options.id) {
	        var foundPli = pli.rootPli.simpleDialogRegistry._findPli(options.id);
	        if (foundPli) {
	            foundPli.loaderWindow.focus();
	            return foundPli.loaderWindow;
	        }
	    }
	
	    // Requested ID was not found, open a new window
	    return this._originalOpen(options, wnd);
	};
	
	
	//---------------------------------------
	SimpleDialogRegistry.prototype._unload = function registryUnload() {
	    /// <summary>
	    /// Handle window.onUnload event.
	    /// Unregisters from parent's simple dialog
	    /// registry (if applicable) and force-closes
	    /// all registered descendant browser windows.
	    /// </summary>
	
	    var i, l;
	    if (!this._isUnloading && pli.parentPli) { // unregister from parent
	        i = $.inArray(pli, pli.parentPli.simpleDialogRegistry._children);
	        if (i >= 0) {
	            pli.parentPli.simpleDialogRegistry._children.splice(i, 1);
	        }
	    }
	
	    for (i = 0, l = this._children.length; i < l; i += 1) {
	        this._children[i].simpleDialogRegistry._isUnloading = true; // prevent close confirmations a.k.a. force-close (this window or its parent already received user's approval)
	        this._children[i].loaderWindow.close();
	    }
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	// register this window with parent; will be unregistered
	// in _unload method (window.onUnload event handler)
	if (pli.parentPli) {
	    pli.parentPli.simpleDialogRegistry._children.push(pli);
	}
	
	// create singleton for this browser window
	// (becomes Pli.simpleDialogRegistry).
	module.exports = new SimpleDialogRegistry();
	


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var signInForm_1 = __webpack_require__(392);
	/**
	 * Legacy sign-in handler that reloads the page, forcing a redirect to the sign-in form.
	 */
	function legacySignInHandler() {
	    location.reload(true);
	    return ko.observable(true);
	}
	/**
	 * Pli's built-in sign-in logic (compatible with "call.PliCallSignInHandler").
	 *
	 * Shows sign-in form and returns a subscribable that will notify
	 * subscribers when user sign-in succeeds.
	 */
	function signInHandler(pliFormsRegistry, settings) {
	    return signInForm_1.openSignInForm(settings).isDone; // show the form, use its "isDone" observable to get notified when the form closes
	}
	function createSignInHandler(pliFormsRegistry) {
	    return (function (settings) { return signInHandler(pliFormsRegistry, settings); });
	}
	exports.createSignInHandler = createSignInHandler;
	function createLegacySignInHandler() {
	    return legacySignInHandler;
	}
	exports.createLegacySignInHandler = createLegacySignInHandler;
	



/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var targetenv_1 = __webpack_require__(3);
	var popupForm_1 = __webpack_require__(393);
	var signInViewModel_1 = __webpack_require__(394);
	var animatedPage_1 = __webpack_require__(400);
	/**
	 * Implements built-in sign-in form handler.
	 *
	 * This form is displayed when server returns "401: Unauthorized" status
	 * and allows user to sign-in using the provided credentials.
	 */
	var SignInForm = (function (_super) {
	    __extends(SignInForm, _super);
	    /**
	     * Creates new instance of "SignInForm", validating and storing specified "originalForm" reference.
	     *
	     * Original form is expected to be the default form with ID "signIn",
	     * created during HTML page load by looking for elements that have
	     * "data-pli-form" attribute.
	     */
	    function SignInForm(originalForm, viewModelConstructor) {
	        _super.call(this, originalForm, viewModelConstructor);
	        /** Flag indicating whether open/close methods will use animations */
	        this._animate = null; // set in "open", reset in "close" (to null)
	        /** Subscription for current "active" value observer. */
	        this._viewModelActiveSubscription = null; // set in "open", disposed and reset in "_closeWhenViewModelDeactivated"
	        /** Current "done" observable. Returned from "isDone". */
	        this._viewModelDone = null; // set in "open", reset in "_closeWhenViewModelDeactivated"
	        if (targetenv_1.isBrowser) {
	            animatedPage_1.registerAnimatedPageBindingHandler();
	            this._$dialog = this.$form.find("#signInDialog");
	        }
	    }
	    /**
	     * Closes this form. Should not be called externally for this form (the form will auto-close when done).
	     *
	     * Closing of sign-in form can be controlled by specifying
	     * "settings.deferClosingUntil" when calling "open".
	     */
	    SignInForm.prototype.close = function () {
	        if (this._viewModelActiveSubscription) {
	            throw new Error("\"pli.forms.registry.signIn.close\" should not be called, the form will auto-close.");
	        }
	        return _super.prototype.close.call(this);
	    };
	    Object.defineProperty(SignInForm.prototype, "isDone", {
	        /**
	         * Gets observable that indicates completion of sign-in process by notifying observers with "true" value.
	         *
	         * Compatible with return value of "call.PliCallSignInHandler".
	         * Will fail if called before the first "open" or after auto-close.
	         */
	        get: function () {
	            if (this._viewModelDone === null) {
	                throw new Error("\"pli.forms.registry.signIn.isDone\" can only be called after \"open\"");
	            }
	            return this._viewModelDone;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Opens this form. Typically called by "pli/call" when "401: Unauthorized" response is received.
	     */
	    SignInForm.prototype.open = function (settings) {
	        return _super.prototype.open.call(this, settings);
	    };
	    // -------------------------------------------------------------------------
	    // Private
	    // -------------------------------------------------------------------------
	    /**
	     * Overrides "PopupForm"'s closing logic by starting a VelocityJS closing
	     * animation and only cleaning up once the animation has completed.
	     */
	    SignInForm.prototype._close = function (viewModel, originalForm) {
	        var _this = this;
	        if (targetenv_1.isBrowser) {
	            this._$dialog.velocity("reverse");
	            this.$form.velocity("reverse", {
	                complete: function () {
	                    _this._animate = null;
	                    _this.$form.removeClass("active");
	                    viewModel.reset();
	                }
	            });
	        }
	        else {
	            viewModel.reset();
	        }
	    };
	    /**
	     * Auto-closes this form when viewmodel's "active" computed property changes to false.
	     */
	    SignInForm.prototype._closeWhenViewModelDeactivated = function (viewModelActive) {
	        if (!viewModelActive) {
	            this._viewModelActiveSubscription.dispose();
	            this._viewModelActiveSubscription = null;
	            this._viewModelDone = null;
	            this.close();
	        }
	    };
	    /**
	     * Overrides "PopupForm"'s opening logic by starting a VelocityJS opening animation.
	     */
	    SignInForm.prototype._open = function (settings, viewModel, originalForm) {
	        var _this = this;
	        var activationInfo = viewModel.activate(settings);
	        this._viewModelDone = activationInfo.done;
	        if (activationInfo.active) {
	            this._viewModelActiveSubscription = activationInfo.active.subscribe(this._closeWhenViewModelDeactivated, this);
	            if (targetenv_1.isBrowser) {
	                this._animate = !(settings && settings.disableAnimation);
	                this.$form.css("opacity", 0).addClass("active").velocity({
	                    properties: { opacity: [1, 0] },
	                    options: {
	                        duration: this._animate ? 750 : 0,
	                        easing: "easeOutSine",
	                        complete: function () { return _this.$form.removeAttr("style"); }
	                    }
	                });
	                this._$dialog.css("opacity", 0).velocity({
	                    properties: { translateY: ["0px", "100px"], opacity: [1, 0, "linear"] },
	                    options: {
	                        duration: this._animate ? 500 : 0,
	                        easing: "easeOutSine",
	                        delay: 250,
	                        complete: function () { return _this._$dialog.removeAttr("style"); }
	                    }
	                });
	            }
	        }
	    };
	    return SignInForm;
	}(popupForm_1.PopupForm));
	exports.SignInForm = SignInForm;
	/**
	 * Opens sign-in form with the given settings.
	 *
	 * To use, render "signIn" form to the webpage by calling
	 * extension method "Pandell.Firestorm.WebLibrary.Pli.Razor.CreateSignInForm"
	 * in Razor (e.g. on "start.cshtml"). The signin form will then
	 * be used automatically when "401: Unauthorized" PLI call
	 * response is encountered.
	 */
	function openSignInForm(settings) {
	    var signInForm = popupForm_1.registerPopupForm("signIn", signInViewModel_1.SignInViewModel, SignInForm);
	    return signInForm.open(settings);
	}
	exports.openSignInForm = openSignInForm;
	



/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var targetenv_1 = __webpack_require__(3);
	var pli = __webpack_require__(5); // never import pli via "./index", it creates a cyclical dependency
	/**
	 * Replaces default form handler with PopupForm-based handler in "pli.forms.registry".
	 *
	 * Can be called multiple times, simply returns already
	 * registered form if called before.
	 */
	function registerPopupForm(formId, viewModelClass, popupFormClass) {
	    var registeredForm = pli.forms.registry[formId];
	    if (!registeredForm) {
	        throw new Error("Form \"" + formId + "\" has not been registered in \"Pli.forms.registry\" (did you call \"Create*Form\" in Razor?).");
	    }
	    if (registeredForm.type === "PLI navigation form") {
	        registeredForm = (popupFormClass
	            ? new popupFormClass(registeredForm, viewModelClass)
	            : new PopupForm(registeredForm, viewModelClass));
	        pli.forms.registry[formId] = registeredForm;
	    }
	    return registeredForm;
	}
	exports.registerPopupForm = registerPopupForm;
	/**
	 * Popup form handler.
	 *
	 * To customize open/close behaviour (e.g. to define a custom animation)
	 * define a subclass of "PopupForm" and then pass the subsclass
	 * as the 3rd parameter of "registerPopupForm".
	 *
	 * It is recommended that you export an "open{formId}" method from
	 * your viewmodel TypeScript file.
	 *
	 * @example
	 * // changePassword.ts
	 *
	 * export class ChangePasswordViewModel { ... } // exported for testing purposes
	 *
	 * export function openChangePasswordForm(settings: ChangePasswordFormSettings): PopupForm {
	 *     const changePasswordForm = registerPopupForm("changePassword", ChangePasswordViewModel);
	 *     return changePasswordForm.open(settings);
	 * }
	 */
	var PopupForm = (function () {
	    // -------------------------------------------------------------------------
	    // Construction & destruction
	    // -------------------------------------------------------------------------
	    /**
	     * Creates a new instance of "PopupForm", validating and storing specified "originalForm" and "viewModelConstructor" references.
	     *
	     * Original form is expected to be the default form created
	     * during HTML page load by looking for elements that have
	     * "data-pli-form" attribute. Original form is validated
	     * to force users of the form to render the form into
	     * the web page (typically by using a Razor extension
	     * method "Create{formId}Form").
	     *
	     * To test "PopupForm" and subclasses, use helper function
	     * "addToPliFormRegistry" from "util/testHelpers" to create
	     * a fake original form, allowing "PopupForm" constructor
	     * to get past the validation checks.
	     */
	    function PopupForm(originalForm, viewModelConstructor) {
	        /**
	         * Gets a flag indicating whether this form is HTML page's root form (readonly, always false).
	         */
	        this.isRoot = false;
	        /** Viewmodel used by this form. */
	        this._viewModel = null; // initialized in "open", lazy (readonly after initialization)
	        if (!originalForm) {
	            throw new Error("Original form must be specified.");
	        }
	        if (!originalForm.id) {
	            throw new Error("Specified original form must have a valid \"id\" property.");
	        }
	        if (!originalForm.$form) {
	            throw new Error("Specified original form for \"" + originalForm.id + "\" must have a valid \"$form\" property.");
	        }
	        if (originalForm.isRoot) {
	            throw new Error("Specified original form for \"" + originalForm.id + "\" must not be be a root form.");
	        }
	        if (typeof viewModelConstructor !== "function" || !viewModelConstructor) {
	            throw new Error("ViewModel constructor myst be specified in PopupForm.constructor.");
	        }
	        this.id = originalForm.id;
	        this.type = this.id + " (PLI navigation form)";
	        this.$form = originalForm.$form;
	        this._originalForm = originalForm;
	        this._viewModelConstructor = viewModelConstructor;
	    }
	    /**
	     * Prevents "util/disposable.disposeObject" from entering an infinite loop.
	     *
	     * There is an infinite loop where every form points to
	     * its navigation page which points back to the form.
	     */
	    PopupForm.prototype.dispose = function () {
	        return;
	    };
	    /**
	     * Closes this form.
	     *
	     * Subclasses should customize closing behaviour by overriding
	     * "_close" method, not this public "close".
	     */
	    PopupForm.prototype.close = function () {
	        if (pli.keys.isKeymapRegistered(this.id)) {
	            pli.keys.deactivateKeymap(this.id);
	        }
	        this._close(this._viewModel, this._originalForm);
	        return this;
	    };
	    /**
	     * Opens this form.
	     *
	     * Subclasses should customize opening behaviour by overriding
	     * "_open" method, not this public "open".
	     */
	    PopupForm.prototype.open = function (settings) {
	        if (!this._viewModel) {
	            this._viewModel = new this._viewModelConstructor(this.id, this.close.bind(this));
	            if (targetenv_1.isBrowser) {
	                ko.applyBindings(this._viewModel, this.$form[0]);
	            }
	        }
	        this._open(settings, this._viewModel, this._originalForm);
	        if (pli.keys.isKeymapRegistered(this.id)) {
	            pli.keys.activateKeymap(this.id);
	        }
	        return this;
	    };
	    // -------------------------------------------------------------------------
	    // Protected interface
	    // -------------------------------------------------------------------------
	    /** Overridable form-close logic. */
	    PopupForm.prototype._close = function (viewModel, originalForm) {
	        originalForm.close();
	        viewModel.reset();
	    };
	    /** Overridable form-open logic. */
	    PopupForm.prototype._open = function (settings, viewModel, originalForm) {
	        originalForm.open(settings);
	        viewModel.activate(settings);
	    };
	    return PopupForm;
	}());
	exports.PopupForm = PopupForm;
	



/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var shared = __webpack_require__(395);
	var signInPageMain_1 = __webpack_require__(396);
	var signInPageForgot_1 = __webpack_require__(397);
	var signInPageMessage_1 = __webpack_require__(398);
	var signInPageChangePassword_1 = __webpack_require__(399);
	var pli_1 = __webpack_require__(6);
	/**
	 * Viewmodel for the sign-in form (contains multiple pages).
	 *
	 * A page is a well-defined area of user-facing functionality (e.g. main page
	 * with username + password, forgotten username/password page with email, etc).
	 * One page can transition to any other page (using animation).
	 */
	var SignInViewModel = (function () {
	    /**
	     * Create a new instance of sign-in viewmodel, creating descriptors for all supported pages.
	     */
	    function SignInViewModel() {
	        // -------------------------------------------------------------------------
	        // Viewmodel properties
	        // -------------------------------------------------------------------------
	        /** Version of this web application (server build version). */
	        this.appVersion = pli_1.pli.config.appVersion;
	        /** Tracks currently selected page. */
	        this.currentPageId = ko.observable(0);
	        /** Collection of currently instantiated pages. */
	        this._pages = ko.observable(null); // readonly
	        // define supported pages
	        var pageRegistry = this._pageRegistry = {};
	        pageRegistry[shared.SignInPageId.None] = { componentName: "signInEmpty" };
	        pageRegistry[shared.SignInPageId.Main] = { componentName: "signInPageMain", pageType: signInPageMain_1.SignInPageMain };
	        pageRegistry[shared.SignInPageId.Forgot] = { componentName: "signInPageForgot", pageType: signInPageForgot_1.SignInPageForgot };
	        pageRegistry[shared.SignInPageId.LockedOut] = { componentName: "signInPageLockedOut", pageType: signInPageMessage_1.SignInPageMessage };
	        pageRegistry[shared.SignInPageId.ChangePassword] = { componentName: "signInPageChangePassword", pageType: signInPageChangePassword_1.SignInPageChangePassword };
	        // register components in Knockout
	        for (var pageId in pageRegistry) {
	            if (pageRegistry.hasOwnProperty(pageId)) {
	                var pageDescriptor = pageRegistry[pageId];
	                if (ko.components.isRegistered(pageDescriptor.componentName)) {
	                    ko.components.unregister(pageDescriptor.componentName);
	                }
	                ko.components.register(pageDescriptor.componentName, pageDescriptor.pageType
	                    ? { viewModel: this._createPageGetter(pageId), template: { element: pageDescriptor.componentName } }
	                    : { template: " " });
	            }
	        }
	    }
	    // -------------------------------------------------------------------------
	    // Viewmodel actions
	    // -------------------------------------------------------------------------
	    /**
	     * Activates main page of this viewmodel, getting it ready for user interaction.
	     */
	    SignInViewModel.prototype.activate = function (settings) {
	        var mainPage = this.getPage(shared.SignInPageId.Main);
	        if (!settings) {
	            settings = {};
	        }
	        if (settings.focusDelay === undefined) {
	            settings.focusDelay = 750;
	        } // sign-in form opening animation duration
	        return mainPage.activate(settings);
	    };
	    /**
	     * Gets viewmodel for the specified page.
	     */
	    SignInViewModel.prototype.getPage = function (pageId, skipCreation) {
	        var pages = this._pages();
	        var newPages = (pages ? pages : []);
	        var page = newPages[pageId];
	        var newPage = (page || skipCreation ? page : this._createPage(pageId, this));
	        if (page !== newPage) {
	            newPages[pageId] = newPage;
	            if (newPages !== pages) {
	                this._pages(newPages);
	            }
	            else {
	                this._pages.valueHasMutated();
	            }
	        }
	        return newPage;
	    };
	    /**
	     * Convert page ID to component name.
	     *
	     * If the specified page has not been instantiated yet, empty component
	     * will be used instead (with no viewmodel). Intended to be used in
	     * "component" binding, e.g. data-bind='component: pageAsComponent(1)'".
	     */
	    SignInViewModel.prototype.pageAsComponent = function (pageId) {
	        var page = this.getPage(pageId, /* skipCreation*/ true); // will be null if viewmodel for the specified page has not been created yet
	        var componentPageId = (page ? pageId : shared.SignInPageId.None);
	        return this._pageRegistry[componentPageId].componentName;
	    };
	    /**
	     * Clear all currently instantiated pages + set current page to "None".
	     *
	     * Typically called when sign-in-form close animation finishes.
	     * When pages are cleared, all Knockout components bound to them will
	     * be released as well (DOM nodes removed, viewmodels disposed).
	     */
	    SignInViewModel.prototype.reset = function () {
	        this.currentPageId(shared.SignInPageId.None);
	        this._pages(null);
	    };
	    /**
	     * Forward submit handler to the current page (if any).
	     */
	    SignInViewModel.prototype.submit = function () {
	        var currentPageId = Math.abs(this.currentPageId());
	        var currentPage = this.getPage(currentPageId, /* skipCreation */ true);
	        if (currentPage && currentPage.submit) {
	            return currentPage.submit();
	        }
	    };
	    // -------------------------------------------------------------------------
	    // Viewmodel actions
	    // -------------------------------------------------------------------------
	    /**
	     * Instantiate viewmodel for the page with the specified ID.
	     */
	    SignInViewModel.prototype._createPage = function (pageId, owner) {
	        var description = this._pageRegistry[pageId];
	        if (!description) {
	            throw new Error("Unknown sign-in page " + pageId);
	        }
	        return new description.pageType(owner, pageId);
	    };
	    /**
	     * Create a function that will create the specified page in the future.
	     *
	     * This is a separate method because we need to introduce closure on
	     * the current "pageId" value in a loop.
	     */
	    SignInViewModel.prototype._createPageGetter = function (pageId) {
	        var _this = this;
	        return function () { return _this.getPage(pageId); };
	    };
	    return SignInViewModel;
	}());
	exports.SignInViewModel = SignInViewModel;
	



/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var pliObservable = __webpack_require__(15);
	/**
	 * Create new instance of "TextBoxObservableWithFocus".
	 */
	function createTextBoxObservableWithFocus(initialValue, behaviourData, behaviour) {
	    var o = pliObservable(initialValue, behaviourData, behaviour);
	    o.hasFocus = ko.observable(false);
	    return o;
	}
	exports.createTextBoxObservableWithFocus = createTextBoxObservableWithFocus;
	/**
	 * Create new instance of "TextBoxObservableWithFocusAndVisibility".
	 */
	function createTextBoxObservableWithFocusAndVisibility(initialValue, behaviourData, behaviour) {
	    var o = createTextBoxObservableWithFocus(initialValue, behaviourData, behaviour);
	    o.visible = ko.observable(false);
	    return o;
	}
	exports.createTextBoxObservableWithFocusAndVisibility = createTextBoxObservableWithFocusAndVisibility;
	/**
	 * List of supported sign-in pages.
	 *
	 * A page is a well-defined area of user-facing functionality (e.g. main page
	 * with username + password, forgotten username/password page with email, etc).
	 * One page can transition to any other page (using animation).
	 */
	(function (SignInPageId) {
	    SignInPageId[SignInPageId["None"] = 0] = "None";
	    SignInPageId[SignInPageId["Main"] = 1] = "Main";
	    SignInPageId[SignInPageId["Forgot"] = 2] = "Forgot";
	    SignInPageId[SignInPageId["LockedOut"] = 3] = "LockedOut";
	    SignInPageId[SignInPageId["ChangePassword"] = 4] = "ChangePassword"; // 4
	})(exports.SignInPageId || (exports.SignInPageId = {}));
	var SignInPageId = exports.SignInPageId;
	/**
	 * Empty object (useful as a fallback for server data stored in observables).
	 * When used as a default observable value, setting it multiple times
	 * will not notify subscribers (because of reference equality), unlike when
	 * empty object literal is used, e.g. "response.result || {}".
	 */
	exports.emptyData = {};
	



/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var call_1 = __webpack_require__(8);
	var pliObservable = __webpack_require__(15);
	var shared = __webpack_require__(395);
	/**
	 * Main sign-in page (username + password).
	 *
	 * Tracks and validates username + password entered by user,
	 * then attempts to sign-in with those credentials on the server.
	 */
	var SignInPageMain = (function () {
	    function SignInPageMain(owner, pageId) {
	        // -------------------------------------------------------------------------
	        // Viewmodel properties
	        // -------------------------------------------------------------------------
	        /** Computed flag that will switch to true while busy indicator (spinner) should be displayed. */
	        this.busy = ko.pureComputed(this._calculateBusy, this);
	        /** Error message currently being displayed. */
	        this.error = ko.observable("");
	        /** Tracks visibility of server sign-in message. */
	        this.messageVisible = ko.observable(false);
	        /** Flag that tracks status of remember me checkbox. */
	        this.rememberMe = ko.observable(true);
	        /** Tracks sign-in name entered by user. */
	        this.username = shared.createTextBoxObservableWithFocus("", null, pliObservable.behaviours.required);
	        /** Tracks sign-in password entered by user. */
	        this.password = shared.createTextBoxObservableWithFocusAndVisibility("", null, pliObservable.behaviours.required);
	        /** Server response that caused main-page to be activated. */
	        this.serverData = ko.observable(shared.emptyData);
	        /**
	         * Observable that will be set to "true" when this viewmodel is activated and to "false" when deactivated.
	         * If "_deferClosingUntil" is set to an observable in "activate" method,
	         * deactivation will be deferred until "true" is signalled by "_deferClosingUntil".
	         */
	        this._active = ko.observable(false);
	        /** Reference to the current server call (sign-in request). */
	        this._call = ko.observable(null);
	        /**
	         * Observable that can be set in "activate" method (optional) that defers deactivation of this viewmodel.
	         * For more information see comments for "_active" property and "_autoDeactivate" method.
	         */
	        this._deferClosingUntil = ko.observable(null); // readonly
	        /**
	         * Flag that will be switched to "true" when server sign-in is successfully completed.
	         * (Set to "null" in "activate", to "true" in "_processResponse").
	         */
	        this._done = ko.observable(null);
	        this._owner = owner;
	        this._pageId = pageId;
	        ko.computed(this._autoDeactivate, this);
	    }
	    // -------------------------------------------------------------------------
	    // Viewmodel actions
	    // -------------------------------------------------------------------------
	    /**
	     * Transitions to this page + set initial focus.
	     */
	    SignInPageMain.prototype.activate = function (settings) {
	        var _this = this;
	        // validate settings
	        var focusDelay = 500; // default, duration of page transition
	        var deferClosingUntil = null;
	        if (settings) {
	            if (settings.focusDelay !== undefined) {
	                focusDelay = settings.focusDelay;
	            }
	            if (settings.deferClosingUntil !== undefined) {
	                deferClosingUntil = settings.deferClosingUntil;
	                if (deferClosingUntil !== null && !ko.isObservable(deferClosingUntil)) {
	                    throw new Error("settings.remainActiveUntil parameter must be undefined/null or an observable");
	                }
	            }
	        }
	        // set initial property values (if needed)
	        var activatingNow = false;
	        if (this._active()) {
	            this.error("");
	            this.username.setErrorMessage(null);
	            this.password.reset(false, "", "");
	        }
	        else {
	            activatingNow = true;
	            this._owner.currentPageId(shared.SignInPageId.None); // hide any previously activated page
	            this._call(null);
	            this._done(null);
	            this._active(true);
	            this._deferClosingUntil(deferClosingUntil || null);
	            this.error("");
	            this.username.reset(false, "", "");
	            this.password.reset(false, "", "");
	            this.serverData((settings && settings.serverData) || shared.emptyData);
	            this.messageVisible(!!(this.serverData().signInMessage));
	        }
	        // initiate page transition + set initial focus only when activating
	        // (opening) or transitioning between pages; in other words, do not
	        // do this if opening already open sign-in form, e.g. when multiple
	        // async calls concurrently get "401: Unauthorized" response
	        var transition = (settings && settings.transition);
	        if (activatingNow || typeof transition === "number") {
	            this._owner.currentPageId((transition || +1) * this._pageId);
	            if (focusDelay > 0) {
	                setTimeout(function () { return _this.username.hasFocus(true); }, focusDelay);
	            }
	            else {
	                this.username.hasFocus(true);
	            }
	        }
	        // return observable information that will notify subscribers when
	        // sign-in is done (unauthenticated call can be retried)
	        // and deactivated (sign-in form can be closed)
	        return {
	            active: activatingNow ? this._active : null,
	            done: this._done
	        };
	    };
	    /**
	     * Resets server message shown to the user.
	     */
	    SignInPageMain.prototype.clearMessage = function () {
	        this.messageVisible(false);
	        this.username.hasFocus(true);
	    };
	    /** Transitions to "Forgot Username" page. */
	    SignInPageMain.prototype.goToForgottenUsernamePage = function () {
	        if (this.busy()) {
	            return;
	        }
	        var cannotSignInPage = this._owner.getPage(shared.SignInPageId.Forgot);
	        cannotSignInPage.activate({ username: this.username(), serverData: this.serverData() });
	    };
	    /** Transitions to "Forgot Password" page. */
	    SignInPageMain.prototype.goToForgottenPasswordPage = function () {
	        if (this.busy()) {
	            return;
	        }
	        var cannotSignInPage = this._owner.getPage(shared.SignInPageId.Forgot);
	        cannotSignInPage.activate({ username: this.username(), serverData: this.serverData(), resetPassword: true });
	    };
	    /**
	     * Validates fields + initiates sign-in server call ("Pli-Authentication-SignIn").
	     */
	    SignInPageMain.prototype.submit = function () {
	        if (this.busy()) {
	            return;
	        }
	        this.username.validate();
	        this.password.validate();
	        var errorMessage = null;
	        if (!this.password.isValid() && !this.username.isValid()) {
	            this.username.hasFocus(true);
	            errorMessage = (this.serverData().passwordResetRequiresUsername ? "Missing username and password" : "Missing email and password");
	        }
	        else if (!this.username.isValid()) {
	            this.username.hasFocus(true);
	            errorMessage = (this.serverData().passwordResetRequiresUsername ? "Missing username" : "Missing email");
	        }
	        else if (!this.password.isValid()) {
	            this.password.hasFocus(true);
	            errorMessage = "Missing password";
	        }
	        if (errorMessage) {
	            this.error(errorMessage + ".\nPlease try again.");
	            return;
	        }
	        this.error("");
	        this._call(call_1.default({
	            owner: this,
	            name: "Pli-Authentication-SignIn",
	            data: {
	                username: this.username(),
	                password: this.password(),
	                rememberMe: this.rememberMe()
	            }
	        }));
	        this._call().always(SignInPageMain._processResponse);
	    };
	    /**
	     * Toggles value of "password.visible" + sets "password.hasFocus".
	     */
	    SignInPageMain.prototype.togglePasswordVisibility = function () {
	        this.password.visible(!this.password.visible());
	        this.password.hasFocus(true);
	    };
	    // -------------------------------------------------------------------------
	    // Private
	    // -------------------------------------------------------------------------
	    /**
	     * Automatically changes "_active" to false:
	     * - when "_done" is set to "true" (if "_deferClosingUntil" is null)
	     * - when "_done" is set to "true" and "_deferClosingUntil" is set to "true".
	     *
	     * Not using pureComputed because there are no explicit subscribers.
	     * This computed is simply running in the background observing "_done"
	     * and "_deferClosingUntil()", producing a side-effect
	     * (changing "_active") when appropriate.
	     */
	    SignInPageMain.prototype._autoDeactivate = function () {
	        if (this._done()) {
	            var deferClosingUntil = this._deferClosingUntil();
	            if (!deferClosingUntil || deferClosingUntil() === true) {
	                this._deferClosingUntil(null);
	                this._active(false);
	            }
	        }
	    };
	    /**
	     * Determines when this viewmodel is busy.
	     * (submission and page transitions are not allowed when busy)
	     */
	    SignInPageMain.prototype._calculateBusy = function () {
	        if (this._call()) {
	            return true;
	        }
	        if (this._done()) {
	            return true;
	        }
	        if (Math.abs(this._owner.currentPageId()) > shared.SignInPageId.Main) {
	            return true;
	        }
	        return false;
	    };
	    /**
	     * Processes result of sign-in server call ("Pli-Authentication-SignIn").
	     */
	    SignInPageMain._processResponse = function (response) {
	        if (response.owner._call().xhr !== response.clientXhr) {
	            console.warn("Ignoring response ", response);
	            return;
	        }
	        var focus = null;
	        if (response.isError) {
	            // is this a recognized error?
	            var recognizedError = false;
	            if (response.clientXhr.status === 403) {
	                if (response.result.changePassword) {
	                    recognizedError = true;
	                    var changePasswordPage = response.owner._owner.getPage(shared.SignInPageId.ChangePassword);
	                    changePasswordPage.activate({
	                        username: response.owner.username(),
	                        serverData: response.result.changePassword
	                    });
	                }
	                else if (response.result.lockedOut) {
	                    recognizedError = true;
	                    var lockedOutPage = response.owner._owner.getPage(shared.SignInPageId.LockedOut);
	                    lockedOutPage.activate({
	                        serverData: response.result.lockedOut
	                    });
	                }
	            }
	            // if not a recognized error, show it in UI
	            if (!recognizedError) {
	                var errorData = response.result;
	                response.owner.error(errorData.message + ".\nPlease try again.");
	                focus = response.owner.username.hasFocus;
	                if (errorData.validationErrors) {
	                    var message = void 0;
	                    message = errorData.validationErrors["password"];
	                    if (message) {
	                        response.owner.password.setErrorMessage(message);
	                        focus = response.owner.password.hasFocus;
	                    }
	                    message = errorData.validationErrors["username"];
	                    if (message) {
	                        response.owner.username.setErrorMessage(message);
	                        focus = response.owner.username.hasFocus;
	                    }
	                }
	            }
	        }
	        else {
	            response.owner._done(true);
	        }
	        response.owner._call(null);
	        if (focus) {
	            focus(true);
	        }
	    };
	    return SignInPageMain;
	}());
	exports.SignInPageMain = SignInPageMain;
	



/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var call_1 = __webpack_require__(8);
	var pliObservable = __webpack_require__(15);
	var shared = __webpack_require__(395);
	/**
	 * Viewmodel for reset-password page.
	 */
	var SignInPageForgot = (function () {
	    function SignInPageForgot(owner, pageId) {
	        // -------------------------------------------------------------------------
	        // Viewmodel properties
	        // -------------------------------------------------------------------------
	        /** Current server call or null (reset-password request). */
	        this.call = ko.observable(null);
	        /** Password-reset completion status (will be set to "true" when server call succeeds). */
	        this.done = ko.observable(false);
	        /** Tracks email entered by user. */
	        this.email = shared.createTextBoxObservableWithFocus("", null, pliObservable.behaviours.required);
	        /** Error message currently being displayed. */
	        this.error = ko.observable("");
	        /** Was password reset (true) or only username retrieval (false) requested in "activate" method? */
	        this.resetPassword = ko.observable(false);
	        /** Server response that caused forgot-page to be activated. */
	        this.serverData = ko.observable(shared.emptyData);
	        /** Flag that tracks focus of the submit button. */
	        this.submitFocus = ko.observable(false);
	        /** Tracks username entered by user. */
	        this.username = shared.createTextBoxObservableWithFocus("", null, pliObservable.behaviours.required);
	        this._owner = owner;
	        this._pageId = pageId;
	    }
	    // -------------------------------------------------------------------------
	    // Viewmodel actions
	    // -------------------------------------------------------------------------
	    /**
	     * Transitions to this page + set initial focus.
	     */
	    SignInPageForgot.prototype.activate = function (settings) {
	        this.call(null);
	        this.done(false);
	        this.error("");
	        this.resetPassword(!!(settings && settings.resetPassword));
	        this.serverData((settings && settings.serverData) || shared.emptyData);
	        var initialEmail = (this.serverData().passwordResetRequiresUsername ? "" : (settings && settings.username || ""));
	        this.email.reset(false, initialEmail, initialEmail);
	        var initialUsername = (this.serverData().passwordResetRequiresUsername ? (settings && settings.username || "") : "");
	        this.username.reset(false, initialUsername, initialUsername);
	        // initiate page transition
	        this._owner.currentPageId(this._pageId);
	        // set initial focus
	        var focusDelay = (settings && settings.focusDelay);
	        if (typeof focusDelay !== "number") {
	            focusDelay = 500;
	        }
	        var focusField = (this.resetPassword() && this.serverData().passwordResetRequiresUsername ? this.username : this.email);
	        if (focusDelay > 0) {
	            setTimeout(function () { return focusField.hasFocus(true); }, focusDelay);
	        }
	        else {
	            focusField.hasFocus(true);
	        }
	    };
	    /**
	     * Transition back to main page.
	     */
	    SignInPageForgot.prototype.cancel = function () {
	        if (this.call()) {
	            return;
	        }
	        var mainPage = this._owner.getPage(shared.SignInPageId.Main);
	        mainPage.activate({ transition: -1 });
	    };
	    /**
	     * Validate email + initiate username-retrieval/password-reset server call.
	     */
	    SignInPageForgot.prototype.submit = function () {
	        if (this.call()) {
	            return;
	        }
	        if (this.done()) {
	            var mainPage = this._owner.getPage(shared.SignInPageId.Main);
	            mainPage.activate({ transition: -1 });
	            return;
	        }
	        if (this.serverData().passwordResetRequiresUsername) {
	            if (this.resetPassword()) {
	                this.username.validate();
	            }
	            else {
	                this.username.setErrorMessage(null);
	            }
	            this.email.validate();
	        }
	        else {
	            this.username.setErrorMessage(null);
	            this.email.validate();
	        }
	        var errorMessage = null;
	        if (!this.username.isValid() && !this.email.isValid()) {
	            errorMessage = "Missing username and email";
	            this.username.hasFocus();
	        }
	        else if (!this.username.isValid()) {
	            errorMessage = "Missing username";
	            this.username.hasFocus();
	        }
	        else if (!this.email.isValid()) {
	            errorMessage = "Missing email";
	            this.email.hasFocus();
	        }
	        if (errorMessage) {
	            this.error(errorMessage + ".\nPlease try again.");
	            return;
	        }
	        this.error("");
	        if (this.resetPassword()) {
	            this.call(call_1.default({
	                owner: this,
	                name: "Pli-Authentication-ResetPassword",
	                data: { username: this.username(), email: this.email() }
	            }));
	        }
	        else {
	            this.call(call_1.default({
	                owner: this,
	                name: "Pli-Authentication-RetrieveUsername",
	                data: { email: this.email() }
	            }));
	        }
	        this.call().always(SignInPageForgot._processResponse);
	    };
	    // -------------------------------------------------------------------------
	    // Private
	    // -------------------------------------------------------------------------
	    /**
	     * Processes result of username-retrieval/password-reset server call.
	     */
	    SignInPageForgot._processResponse = function (response) {
	        if (response.owner.call().xhr !== response.clientXhr) {
	            console.warn("Ignoring response ", response);
	            return;
	        }
	        var focusObservable = null;
	        if (response.isError) {
	            var errorData = response.result;
	            response.owner.error(errorData.message + ".\nPlease try again.");
	            if (errorData.validationErrors) {
	                var message = void 0;
	                message = errorData.validationErrors["email"];
	                if (message) {
	                    response.owner.email.setErrorMessage(message);
	                }
	            }
	            focusObservable = (response.owner.resetPassword() && response.owner.serverData().passwordResetRequiresUsername
	                ? response.owner.username.hasFocus
	                : response.owner.email.hasFocus);
	        }
	        else {
	            response.owner.done(true);
	            focusObservable = response.owner.submitFocus;
	        }
	        response.owner.call(null);
	        focusObservable(true);
	    };
	    return SignInPageForgot;
	}());
	exports.SignInPageForgot = SignInPageForgot;
	



/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var shared = __webpack_require__(395);
	/**
	 * Viewmodel for text-only pages (pages showing a message to the user).
	 * Multiple components can use this viewmodel (account locked out, support info, etc).
	 */
	var SignInPageMessage = (function () {
	    function SignInPageMessage(owner, pageId) {
	        // -------------------------------------------------------------------------
	        // Viewmodel properties
	        // -------------------------------------------------------------------------
	        /** Flag tracking focus of "submit" button. */
	        this.submitFocus = ko.observable(false);
	        /** Server response that caused message-page to be activated. */
	        this.serverData = ko.observable(shared.emptyData);
	        this._owner = owner;
	        this._pageId = pageId;
	    }
	    // -------------------------------------------------------------------------
	    // Viewmodel actions
	    // -------------------------------------------------------------------------
	    /**
	     * Transitions to this page + set initial focus.
	     */
	    SignInPageMessage.prototype.activate = function (settings) {
	        var _this = this;
	        this.serverData((settings && settings.serverData) || shared.emptyData);
	        // initiate page transition
	        this._owner.currentPageId(this._pageId);
	        // set initial focus
	        var focusDelay = (settings && settings.focusDelay);
	        if (typeof focusDelay !== "number") {
	            focusDelay = 500;
	        }
	        if (focusDelay > 0) {
	            setTimeout(function () { return _this.submitFocus(true); }, focusDelay);
	        }
	        else {
	            this.submitFocus(true);
	        }
	    };
	    /**
	     * Transition back to main page.
	     */
	    SignInPageMessage.prototype.submit = function () {
	        var mainPage = this._owner.getPage(shared.SignInPageId.Main);
	        mainPage.activate({ transition: -1 });
	    };
	    return SignInPageMessage;
	}());
	exports.SignInPageMessage = SignInPageMessage;
	



/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var call_1 = __webpack_require__(8);
	var pliObservable = __webpack_require__(15);
	var shared = __webpack_require__(395);
	/**
	 * Viewmodel for sign-in page that forces user to change their password.
	 */
	var SignInPageChangePassword = (function () {
	    function SignInPageChangePassword(owner, pageId) {
	        // -------------------------------------------------------------------------
	        // Viewmodel properties
	        // -------------------------------------------------------------------------
	        /** Computed flag that will switch to true while busy indicator (spinner) should be displayed. */
	        this.busy = ko.pureComputed(this._calculateBusy, this);
	        /** Flag indicating that password has been changed successfully (when true). */
	        this.done = ko.observable(false);
	        /** Message to display when password is successfully changed. */
	        this.doneMessage = ko.observable("");
	        /** Error message currently being displayed. */
	        this.error = ko.observable("");
	        /** Tracks old password entered by user. */
	        this.oldPassword = shared.createTextBoxObservableWithFocus("", null, pliObservable.behaviours.required);
	        /** Tracks new password entered by user. */
	        this.newPassword = shared.createTextBoxObservableWithFocus("", null, pliObservable.behaviours.required);
	        /** Tracks repeated new password entered by user (to guard against mis-spelling). */
	        this.newPasswordAgain = shared.createTextBoxObservableWithFocusAndVisibility("", { source: this.newPassword }, pliObservable.behaviours.repeatedValue);
	        /** Server response that caused change-password-page to be activated. */
	        this.serverData = ko.observable(shared.emptyData);
	        /** Flag tracking focus of "submit" button. */
	        this.submitFocus = ko.observable(false);
	        /** Reference to the current server call (sign-in request). */
	        this._call = ko.observable(null); // readonly (observable)
	        this._owner = owner;
	        this._pageId = pageId;
	    }
	    // -------------------------------------------------------------------------
	    // Viewmodel actions
	    // -------------------------------------------------------------------------
	    /**
	     * Transition to this page + set initial focus.
	     */
	    SignInPageChangePassword.prototype.activate = function (settings) {
	        var _this = this;
	        // validate settings
	        if (!settings) {
	            throw new Error("SignInPageChangePassword.activate requires settings object");
	        }
	        if (typeof settings.username !== "string") {
	            throw new Error("SignInPageChangePassword.activate requires settings.username string");
	        }
	        var focusDelay = 500; // default, duration of page transition
	        if (settings.focusDelay !== undefined) {
	            focusDelay = settings.focusDelay;
	        }
	        // set initial property values
	        this._call(null);
	        this._username = settings.username;
	        this.done(false);
	        this.doneMessage("");
	        this.error("");
	        this.oldPassword.reset(false, "", "");
	        this.newPassword.reset(false, "", "");
	        this.newPasswordAgain.visible(true);
	        this.newPasswordAgain.reset(false, "", "");
	        this.serverData(settings.serverData || shared.emptyData);
	        // initiate page transition
	        this._owner.currentPageId(this._pageId);
	        // set initial focus
	        if (focusDelay > 0) {
	            setTimeout(function () { return _this.oldPassword.hasFocus(true); }, focusDelay);
	        }
	        else {
	            this.oldPassword.hasFocus(true);
	        }
	    };
	    /**
	     * Validate viewmodel + initiate server call to change user's password.
	     */
	    SignInPageChangePassword.prototype.submit = function () {
	        if (this.busy()) {
	            return;
	        }
	        if (this.done()) {
	            var mainPage = this._owner.getPage(shared.SignInPageId.Main);
	            mainPage.activate({ transition: -1 });
	            return;
	        }
	        this.oldPassword.validate();
	        this.newPassword.validate();
	        if (this.newPasswordAgain.visible()) {
	            this.newPasswordAgain.validate();
	        }
	        else {
	            this.newPasswordAgain.setErrorMessage(null);
	        }
	        var errorMessage = null;
	        if (this.oldPassword.isValid() && this.newPassword.isValid() && this.newPasswordAgain.isValid()) {
	            if (this.oldPassword() === this.newPassword()) {
	                errorMessage = "New password must be different from old password";
	                this.newPasswordAgain.reset(false, "", "");
	                this.newPassword.reset(false, "", "");
	                this.newPassword.setErrorMessage("Must be different from old password");
	                this.newPassword.hasFocus(true);
	            }
	        }
	        else if (!this.oldPassword.isValid() && !this.newPassword.isValid()) {
	            errorMessage = "Missing current and new passwords";
	            this.oldPassword.hasFocus(true);
	        }
	        else if (!this.oldPassword.isValid()) {
	            errorMessage = "Missing current password";
	            this.oldPassword.hasFocus(true);
	        }
	        else if (!this.newPassword.isValid()) {
	            errorMessage = "Missing new password";
	            this.newPassword.hasFocus(true);
	        }
	        else if (!this.newPasswordAgain.isValid()) {
	            errorMessage = "Repeated new password does not match";
	            this.newPasswordAgain.hasFocus(true);
	        }
	        if (errorMessage) {
	            this.error(errorMessage + ".\nPlease try again.");
	            return;
	        }
	        this.error("");
	        this._call(call_1.default({
	            owner: this,
	            name: "Pli-Authentication-ChangePassword",
	            data: {
	                username: this._username,
	                oldPassword: this.oldPassword(),
	                newPassword: this.newPassword()
	            }
	        }));
	        this._call().always(SignInPageChangePassword._processResponse);
	    };
	    /**
	     * Toggles value of "newPasswordAgain.visible" + sets "newPassword.hasFocus".
	     */
	    SignInPageChangePassword.prototype.togglePasswordVisibility = function () {
	        this.newPasswordAgain.visible(!this.newPasswordAgain.visible());
	        this.newPassword.hasFocus(true);
	    };
	    // -------------------------------------------------------------------------
	    // Private
	    // -------------------------------------------------------------------------
	    /**
	     * Determines when this viewmodel is busy.
	     */
	    SignInPageChangePassword.prototype._calculateBusy = function () {
	        return (!!this._call());
	    };
	    /**
	     * Processes result of change-password server call ("Pli-Authentication-ChangePassword").
	     */
	    SignInPageChangePassword._processResponse = function (response) {
	        var thisPage = response.owner;
	        if (thisPage._call().xhr !== response.clientXhr) {
	            console.warn("Ignoring response ", response);
	            return;
	        }
	        var focus = null;
	        if (response.isError) {
	            var errorData = response.result;
	            thisPage.error(errorData.message + ".\nPlease try again.");
	            focus = thisPage.oldPassword.hasFocus;
	            if (errorData.validationErrors) {
	                var message = void 0;
	                message = errorData.validationErrors["newPassword"];
	                if (message) {
	                    thisPage.newPassword.setErrorMessage(message);
	                    focus = thisPage.newPassword.hasFocus;
	                }
	                message = errorData.validationErrors["oldPassword"];
	                if (message) {
	                    thisPage.oldPassword.setErrorMessage(message);
	                    focus = thisPage.oldPassword.hasFocus;
	                }
	            }
	        }
	        else {
	            focus = thisPage.submitFocus;
	            thisPage.doneMessage((response.result && response.result.message) || "Your password was successfully changed.");
	            thisPage.done(true);
	        }
	        thisPage._call(null);
	        if (focus) {
	            focus(true);
	        }
	    };
	    return SignInPageChangePassword;
	}());
	exports.SignInPageChangePassword = SignInPageChangePassword;
	



/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	/**
	 * Implement knockout binding "pliAnimatedPage".
	 *
	 * The binding must be connected to an expression that returns
	 * 1-based indexes of pages to make visible (by using sliding animation).
	 * Value of 0 ("None") will hide all pages. When a positive
	 * page ID is specified, animation will be "forward" (new page slides
	 * in from the right edge). When a negative page ID is specified, animation
	 * will be "back" (new page slides in from the left edge).
	 */
	var AnimatedPageBindingHandler = (function () {
	    function AnimatedPageBindingHandler() {
	        /** Index of page that is currently visible to the user (or will become visible in the near future once animation queue has been cleared). */
	        this._currentPageId = 0; // changed in "update"
	    }
	    /**
	     * Finds element to animate and pages to be animated (as jQuery objects).
	     */
	    AnimatedPageBindingHandler.prototype.init = function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
	        this._$animation = $(element);
	        this._$pages = this._$animation.find(".pliAnimatedPage");
	    };
	    /**
	     * Changes "_currentPageId" to bound value.
	     * Triggers page animation to make the specified page visible.
	     *
	     * Page IDs are expected to be 1-based indexes. When a positive
	     * page ID is specified, animation will be "forward" (new page slides
	     * in from the right edge). When a negative page ID is specified, animation
	     * will be "back" (new page slides in from the left edge).
	     */
	    AnimatedPageBindingHandler.prototype.update = function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
	        var _this = this;
	        // validate new ID
	        var newPageId = ko.unwrap(valueAccessor());
	        if (typeof newPageId !== "number") {
	            throw new Error("\"pliAnimatedPage\" requires observable that resolves to a number");
	        }
	        var newPageIdAbs = (newPageId === null ? null : Math.abs(newPageId));
	        var oldPageId = this._currentPageId;
	        this._currentPageId = newPageIdAbs;
	        // if switching from/to "null", only change visibility
	        if (oldPageId === 0) {
	            if (newPageIdAbs !== 0) {
	                this._$pages.eq(newPageIdAbs - 1).addClass("active");
	            }
	            return;
	        }
	        if (newPageIdAbs === 0) {
	            if (oldPageId !== 0) {
	                this._$pages.eq(oldPageId - 1).removeClass("active");
	            }
	            return;
	        }
	        // if animation is required, queue it now
	        if (oldPageId !== newPageIdAbs) {
	            var forward_1 = (newPageId === newPageIdAbs);
	            this._$animation.velocity({
	                properties: {
	                    translateX: forward_1
	                        ? AnimatedPageBindingHandler._forwardTranslation
	                        : AnimatedPageBindingHandler._backTranslation
	                },
	                options: {
	                    duration: 500,
	                    easing: "easeOutCubic",
	                    begin: function () { return _this._startAnimation(oldPageId, newPageIdAbs, forward_1); },
	                    complete: function () { return _this._completeAnimation(oldPageId, newPageIdAbs, forward_1); }
	                }
	            });
	        }
	    };
	    // -------------------------------------------------------------------------
	    // Private
	    // -------------------------------------------------------------------------
	    /**
	     * Restore classes after animation has completed (only keep active page visible).
	     */
	    AnimatedPageBindingHandler.prototype._completeAnimation = function (from, to, forward) {
	        this._$animation.removeAttr("style");
	        if (forward) {
	            this._$pages.eq(from - 1).removeClass("active");
	            this._$pages.eq(to - 1).removeClass("next").addClass("active");
	        }
	        else {
	            this._$pages.eq(from - 1).removeClass("next");
	        }
	    };
	    /**
	     * Set classes before animation begins (make both from and to pages visible).
	     */
	    AnimatedPageBindingHandler.prototype._startAnimation = function (from, to, forward) {
	        if (forward) {
	            this._$pages.eq(to - 1).addClass("next");
	        }
	        else {
	            $.Velocity.hook(this._$animation, "translateX", "-50%"); // improves back animation in IE
	            this._$pages.eq(from - 1).removeClass("active").addClass("next");
	            this._$pages.eq(to - 1).addClass("active");
	        }
	    };
	    /** Velocity spec to use when moving pages to the right (new page emerging from left). */
	    AnimatedPageBindingHandler._backTranslation = ["0%", "-50%"];
	    /** Velocity spec to use when moving pages to the left (new page emerging from right). */
	    AnimatedPageBindingHandler._forwardTranslation = ["-50%", "0%"];
	    return AnimatedPageBindingHandler;
	}());
	/**
	 * Register "pliAnimatedPage" as a Knockout binding.
	 * After calling this function elements can use "pliAnimatedPage", e.g.:
	 * <div data-bind="pliAnimatedPage: pages.current">...</div>.
	 *
	 * This function can be called multiple times, handler is only
	 * registered on the first call (returns "true"), nothing
	 * is done afterwards (returns "false").
	 */
	function registerAnimatedPageBindingHandler() {
	    // check if already registered
	    if (ko.bindingHandlers["pliAnimatedPage"]) {
	        return false;
	    }
	    // create handler + bind its methods (because Knockout doesn't preserve "this" context)
	    var handler = new AnimatedPageBindingHandler();
	    handler.init = handler.init.bind(handler);
	    handler.update = handler.update.bind(handler);
	    ko.bindingHandlers["pliAnimatedPage"] = handler;
	    return true;
	}
	exports.registerAnimatedPageBindingHandler = registerAnimatedPageBindingHandler;
	



/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var $ = __webpack_require__(2);
	var ko = __webpack_require__(9);
	var R = __webpack_require__(7);
	var Rx = __webpack_require__(27);
	var dataProvider_1 = __webpack_require__(378);
	var pliDisableField_1 = __webpack_require__(402);
	var pliHasFocus_1 = __webpack_require__(403);
	var pliReadOnlyField_1 = __webpack_require__(404);
	var disposable_1 = __webpack_require__(375);
	/**
	 * Select2 callback result item indicating that an incomplete list of results is being displayed.
	 */
	var showMoreResult = { id: -1, text: "(Show more values... [F3])" };
	/**
	 * Select2 callback result indicating there were no matching results.
	 */
	var noResults = { more: false, results: [] };
	/**
	 * Tracks picklist state for the current page.
	 */
	var PageState = (function () {
	    function PageState() {
	        /**
	         * Reference to TextBoxController whose Select2 popup is currently open.
	         */
	        this.openTextBox = null;
	        /**
	         * Search term that was queried most recently,
	         */
	        this.openTextBoxQueryTerm = null;
	        /**
	         * Flag indicating whether Select2 popup key handler has already been installed on this page.
	         */
	        this.select2PopupKeyHandlerActive = false;
	    }
	    return PageState;
	}());
	exports.PageState = PageState;
	/**
	 * Returns the value to use for "idField" when opening a picklist form.
	 *
	 * @param behaviourData
	 *     Picklist behaviour data.
	 * @returns
	 *     Looks for values in the following order, returning the first defined value found:
	 *      - behaviourData.idField
	 *      - behaviourData.displayValueIndex
	 *      - constant string "id"
	 */
	function getIdField(behaviourData) {
	    return (behaviourData.idField !== undefined
	        ? behaviourData.idField
	        : (behaviourData.displayValueIndex !== undefined
	            ? behaviourData.displayValueIndex
	            : "id"));
	}
	exports.getIdField = getIdField;
	/**
	 * Initialize select2 on a controller's $input element.
	 *
	 * Initialization occurs on first event stream subscription. Unsubscription
	 * will clean up/destroy the select2 instance.
	 *
	 * @param controller
	 *     TextBoxController instance.
	 * @param options
	 *     Options that control select2 behaviour.
	 * @returns
	 *     Cold observable containing a stream of select2 events.
	 */
	function initializeSelect2(controller, options) {
	    return new Rx.Observable(function initializeSelect2EventStream(observer) {
	        var placeholder = options.placeholder;
	        // non-undefined value is needed to ensure the 'x'/clear button is rendered
	        options.placeholder = options.placeholder || " ";
	        // emit "query" events when query string is updated
	        options.query = function (queryOptions) {
	            observer.next({ type: "query", options: queryOptions });
	        };
	        // install Select2
	        controller.$input.select2(options);
	        // install event handlers on Select2 container
	        // (taking advantage of event bubbling)
	        var $select2 = controller.$input.select2("container");
	        $select2.on("keydown", controller, controller.onKeyDown$);
	        var $a = $select2.find("a");
	        var pageState = options.pageState;
	        var picklistIconClick = Rx.Observable
	            .fromEvent($select2.find("b"), "mousedown")
	            .filter(function (e) { return controller.$input.select2("opened"); });
	        var showMoreSelecting = Rx.Observable
	            .fromEvent(controller.$input, "select2-selecting")
	            .filter(function (e) { return e.object && e.object.id === -1; }) // matches "showMoreResult"
	            .do(function (e) { return e.preventDefault(); }); // prevent "showMoreResult" from being loaded
	        var disposables = new disposable_1.CompositeDisposable(
	        // fix current Select2 behaviour where when value
	        // is cleared by pressing the "x" button, focus
	        // is set to the <a> tag, not <input> tag;
	        // o is probably a Select2 bug and o fix
	        // can be deleted once Select2 behaviour is corrected
	        Rx.Observable
	            .fromEvent($a, "focus")
	            .subscribe(function (e) { return controller.$input.select2("focus"); }), 
	        // install picklist-form-icon click handler
	        // (needed for selection form to appear when
	        // picklist-form-icon, visible in Select2 popup,
	        // is clicked) and cancel selection when "Show more..." line
	        // is selected by user, (show picklist form instead)
	        Rx.Observable
	            .merge(picklistIconClick, showMoreSelecting)
	            .delay(0, options.scheduler) // defer until the next JavaScript engine tick
	            .subscribe(function (e) { return controller.showSelectionForm$(R.merge(e, { data: controller })); }), 
	        // keep "openTextBox" reference up to date with
	        // currently opened Select2 popup
	        Rx.Observable
	            .fromEvent(controller.$input, "select2-open")
	            .subscribe(function (_) { return pageState.openTextBox = controller; }), Rx.Observable
	            .fromEvent(controller.$input, "select2-close")
	            .subscribe(function (_) {
	            pageState.openTextBox = null;
	            pageState.openTextBoxQueryTerm = null;
	        }), 
	        // emit "item" events when a new item is selected
	        Rx.Observable
	            .fromEvent(controller.$input, "change textchange")
	            .subscribe(function (e) { return observer.next({ type: "item", controller: controller, item: e.added ? e.added.item : null }); }));
	        if (placeholder) {
	            setSelect2Placeholder(controller.$input, typeof placeholder === "string" ? placeholder : placeholder());
	            if (ko.isSubscribable(placeholder)) {
	                var placeholderObservable = placeholder;
	                disposables.add(placeholderObservable.subscribe(function (value) { return setSelect2Placeholder(controller.$input, value); }));
	            }
	        }
	        // install keydown handler for Select2 popup
	        // (needed for F3 to work when popup is visible)
	        if (!pageState.select2PopupKeyHandlerActive) {
	            var $i = $(".select2-input");
	            disposables.add(Rx.Observable.fromEvent($i, "keydown").subscribe(function (e) {
	                if (pageState.openTextBox !== null) {
	                    e.data = pageState.openTextBox;
	                    return pageState.openTextBox.onKeyDown$(e);
	                }
	            }));
	        }
	        // install on change handler and view updater
	        // that are compatible with Select2
	        controller._picklistSavedUpdateView = controller.updateView;
	        controller.updateView = function (ignoreFocus) { return controllerUpdateView.call(controller, options, ignoreFocus); };
	        controller._picklistSavedIsEnabled = controller.isEnabled;
	        controller.isEnabled = controllerIsEnabled;
	        // install focus registration and updating handlers
	        pliHasFocus_1.setFieldFocusRegistrator(controller.$input[0], function (handleElementFocusIn, handleElementFocusOut, element) {
	            ko.utils.registerEventHandler(element, "select2-focus", handleElementFocusIn);
	            ko.utils.registerEventHandler(element, "select2-blur", handleElementFocusOut);
	        });
	        pliHasFocus_1.setFieldFocusUpdater(controller.$input[0], function (focusToSet) {
	            if (focusToSet) {
	                controller.$input.select2("focus");
	            }
	            else {
	                controller.$input.data("select2").focusser.blur();
	            }
	        });
	        // install custom disabled and readonly update handlers
	        pliDisableField_1.setFieldDisabledUpdater(controller.$input[0], controllerUpdateDisabled);
	        pliReadOnlyField_1.setFieldReadonlyUpdater(controller.$input[0], controllerUpdateReadOnly);
	        return new Rx.Subscription(function () {
	            // Clean up select2 DOM enhancements/events
	            disposables.dispose();
	            $select2.off("keydown", controller.onKeyDown$);
	            controller.$input.select2("destroy");
	            // Restore saved controller methods
	            controller.updateView = controller._picklistSavedUpdateView;
	            controller.isEnabled = controller._picklistSavedIsEnabled;
	            // Remove custom binding updaters
	            pliDisableField_1.setFieldDisabledUpdater(controller.$input[0], null);
	            pliReadOnlyField_1.setFieldReadonlyUpdater(controller.$input[0], null);
	        });
	    });
	}
	exports.initializeSelect2 = initializeSelect2;
	/**
	 * Transforms responses from a DataProvider into select2-compatible objects.
	 *
	 * @param rowIdIndex
	 *     Result index containing display values.
	 * @param response
	 *     Data provider response.
	 */
	function processDataProviderResponse(response) {
	    var options = response.context;
	    var term = options.term;
	    options.pageState.openTextBoxQueryTerm = term;
	    if (dataProvider_1.stateOfResponse(response) === dataProvider_1.DataState.Busy) {
	        // if picklist data is not available, return one result that matches user's input
	        options.callback(term
	            ? mirrorUserInputResults(term)
	            : noResults);
	    }
	    else {
	        // picklist data is available, transform matches
	        var items = response.data.items;
	        var len = items.length;
	        var results = [];
	        for (var i = 0; i < len; i += 1) {
	            var item = items[i];
	            var itemId = item[options.rowIdIndex];
	            results.push({ index: i, id: itemId, text: itemId, item: item });
	        }
	        if (len > 0 && len < response.data.resultCount) {
	            results.push(showMoreResult);
	        }
	        options.callback(results.length === 0
	            ? noResults
	            : { more: false, results: results });
	    }
	}
	exports.processDataProviderResponse = processDataProviderResponse;
	/**
	 * Determine enabled state for select2 container.
	 * @this TextBoxController
	 */
	function controllerIsEnabled() {
	    var c = this;
	    return c.$input.select2("container").is(":not(.select2-container-disabled)");
	}
	/**
	 * Update disabled state for select2 element.
	 */
	function controllerUpdateDisabled(element, disabled) {
	    var controller = ko.bindingHandlers["pliTextBox"].requireController(element);
	    controller.$input.select2("enable", !disabled);
	}
	/**
	 * Update readonly state for select2 element.
	 */
	function controllerUpdateReadOnly(element, readOnly) {
	    var controller = ko.bindingHandlers["pliTextBox"].requireController(element);
	    controller.$input.select2("readonly", readOnly);
	}
	/**
	 * Update view for select2 element.
	 *
	 * @this TextBoxController
	 */
	function controllerUpdateView(options, ignoreFocus) {
	    var c = this;
	    var o = c.observable;
	    c.$root
	        .toggleClass("withProgress", o._isBusy)
	        .toggleClass("withFailure", o._isFailed);
	    // update Select2 selection to match state
	    // of "this" controller (if needed)
	    var d = c.$input.select2("data");
	    var value = o.peekValue();
	    var id = options.getId(c, value);
	    if (d === null || d.id !== id) {
	        c.$input.select2("data", id === null || id === undefined
	            ? null
	            : { id: id, text: id });
	    }
	    return c._picklistSavedUpdateView(ignoreFocus);
	}
	/**
	 * Select2 callback result that mirrors the text entered by the user.
	 *
	 * Used when the underlying data is not ready.
	 */
	function mirrorUserInputResults(term) {
	    return { more: false, results: [{ id: term, text: term }] };
	}
	/**
	 * Update data-placeholder on select2 element.
	 *
	 * This is required because data-* attributes have higher precedence than
	 * select2 options. Placeholder will not be updated until select2.setPlaceholder
	 * is called.
	 *
	 * @param $input
	 *     Select2 element.
	 * @param value
	 *     Placeholder value.
	 */
	function setSelect2Placeholder($input, value) {
	    $input.attr("data-placeholder", value);
	    $input.data("select2").setPlaceholder();
	}
	



/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var util_1 = __webpack_require__(386);
	var disableFieldUpdaterKey = "__kopli__disableFieldUpdater";
	function setFieldEnabledState(element, enabled) {
	    var updater = element[disableFieldUpdaterKey];
	    if (typeof updater === "function") {
	        updater(element, !enabled);
	    }
	    else {
	        ko.bindingHandlers.enable.update(element, function () { return enabled; });
	        ko.utils.toggleDomNodeCssClass(element.parentElement.parentElement, "disabled", !enabled);
	    }
	}
	exports.setFieldEnabledState = setFieldEnabledState;
	/** Set the function that should be used to make this element disabled. */
	function setFieldDisabledUpdater(element, updater) {
	    if (!element) {
	        throw new Error("pliDisableField: Target element is required.");
	    }
	    if (typeof updater !== "function") {
	        throw new Error("pliDisableField: Updater must be a function.");
	    }
	    element[disableFieldUpdaterKey] = updater;
	}
	exports.setFieldDisabledUpdater = setFieldDisabledUpdater;
	var pliDisableFieldBinding = {
	    update: function (element, valueAccessor) {
	        var enabled = !ko.unwrap(valueAccessor());
	        setFieldEnabledState(element, enabled);
	    }
	};
	/**
	 * Activates the 'pliDisableField' binding.
	 */
	function activatePliDisableFieldBinding() {
	    return util_1.addBindingHandler("pliDisableField", pliDisableFieldBinding);
	}
	exports.activatePliDisableFieldBinding = activatePliDisableFieldBinding;
	



/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var util_1 = __webpack_require__(386);
	var hasFocusUpdatingProperty = "__kopli_hasFocusUpdating";
	var hasFocusLastValue = "__kopli_hasFocusLastValue";
	var hasFocusRegistrator = "__kopli_hasFocusRegistrator";
	var hasFocusUpdater = "__kopli_hasFocusUpdater";
	/** Set the function that should be used to register for focus in and out events. */
	function setFieldFocusRegistrator(element, registrator) {
	    if (!element) {
	        throw new Error("pliHasFocus: Target element is required.");
	    }
	    if (typeof registrator !== "function") {
	        throw new Error("pliHasFocus: Registrator must be a function.");
	    }
	    element[hasFocusRegistrator] = registrator;
	}
	exports.setFieldFocusRegistrator = setFieldFocusRegistrator;
	/** Set the function that should be used to focus or blur an element. */
	function setFieldFocusUpdater(element, updater) {
	    if (!element) {
	        throw new Error("pliHasFocus: Target element is required.");
	    }
	    if (typeof updater !== "function") {
	        throw new Error("pliHasFocus: Updater must be a function.");
	    }
	    element[hasFocusUpdater] = updater;
	}
	exports.setFieldFocusUpdater = setFieldFocusUpdater;
	var pliHasFocusBinding = {
	    init: function (element, valueAccessor, allBindings) {
	        var focusRegistrator = element[hasFocusRegistrator];
	        if (typeof focusRegistrator === "function") {
	            if (typeof element[hasFocusUpdater] !== "function") {
	                throw new Error("pliHasFocus: If a focus registrator is assigned to an element, a focus updater must also be assigned.");
	            }
	            var handleElementFocusChange = function (isFocused) {
	                // Where possible, ignore which event was raised and determine focus state using activeElement,
	                // as this avoids phantom focus/blur events raised when changing tabs in modern browsers.
	                // However, not all KO-targeted browsers (Firefox 2) support activeElement. For those browsers,
	                // prevent a loss of focus when changing tabs/windows by setting a flag that prevents hasfocus
	                // from calling 'blur()' on the element when it loses focus.
	                // Discussion at https://github.com/SteveSanderson/knockout/pull/352
	                element[hasFocusUpdatingProperty] = true;
	                var ownerDoc = element.ownerDocument;
	                if (ownerDoc.hasOwnProperty("activeElement")) {
	                    var activeElement = void 0;
	                    try {
	                        activeElement = ownerDoc.activeElement;
	                    }
	                    catch (e) {
	                        // IE9 throws if you access activeElement during page load (see issue #703)
	                        activeElement = ownerDoc.body;
	                    }
	                    isFocused = (activeElement === element);
	                }
	                var modelValue = valueAccessor();
	                ko.expressionRewriting.writeValueToProperty(modelValue, allBindings, "pliHasFocus", isFocused, true);
	                // cache the latest value, so we can avoid unnecessarily calling focus/blur in the update function
	                element[hasFocusLastValue] = isFocused;
	                element[hasFocusUpdatingProperty] = false;
	            };
	            var handleElementFocusIn = handleElementFocusChange.bind(null, true);
	            var handleElementFocusOut = handleElementFocusChange.bind(null, false);
	            focusRegistrator(handleElementFocusIn, handleElementFocusOut, element);
	        }
	        else {
	            ko.bindingHandlers.hasfocus.init(element, valueAccessor, allBindings);
	        }
	    },
	    update: function (element, valueAccessor) {
	        var updater = element[hasFocusUpdater];
	        if (typeof updater === "function") {
	            var value = !!ko.unwrap(valueAccessor());
	            if (!element[hasFocusUpdatingProperty] && element[hasFocusLastValue] !== value) {
	                updater(value);
	            }
	        }
	        else {
	            ko.bindingHandlers.hasfocus.update(element, valueAccessor);
	        }
	    }
	};
	/**
	 * Activates the 'pliHasFocus' binding.
	 */
	function activatePliHasFocusBinding() {
	    var handler = util_1.addBindingHandler("pliHasFocus", pliHasFocusBinding);
	    if (!ko.expressionRewriting.twoWayBindings.pliHasFocus) {
	        ko.expressionRewriting.twoWayBindings.pliHasFocus = true;
	    }
	    return handler;
	}
	exports.activatePliHasFocusBinding = activatePliHasFocusBinding;
	



/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var $ = __webpack_require__(1);
	var util_1 = __webpack_require__(386);
	var readOnlyFieldUpdaterKey = "__kopli__readOnlyFieldUpdater";
	/** Set the function that should be used to make this element readonly. */
	function setFieldReadonlyUpdater(element, updater) {
	    if (!element) {
	        throw new Error("pliReadOnlyField: Target element is required.");
	    }
	    if (typeof updater !== "function") {
	        throw new Error("pliReadOnlyField: Updater must be a function.");
	    }
	    element[readOnlyFieldUpdaterKey] = updater;
	}
	exports.setFieldReadonlyUpdater = setFieldReadonlyUpdater;
	var pliReadOnlyFieldBinding = {
	    update: function (element, valueAccessor) {
	        var readOnly = ko.unwrap(valueAccessor());
	        var updater = element[readOnlyFieldUpdaterKey];
	        if (typeof updater === "function") {
	            return updater(element, readOnly);
	        }
	        $(element).prop("readonly", readOnly);
	        ko.utils.toggleDomNodeCssClass(element.parentElement.parentElement, "readOnly", readOnly);
	    }
	};
	/**
	 * Activates the 'pliReadOnlyField' binding.
	 */
	function activatePliReadOnlyFieldBinding() {
	    return util_1.addBindingHandler("pliReadOnlyField", pliReadOnlyFieldBinding);
	}
	exports.activatePliReadOnlyFieldBinding = activatePliReadOnlyFieldBinding;
	



/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(global, module) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	
	; jQuery = global.jQuery = __webpack_require__(2);
	; var __browserify_shim_require__=require;(function browserifyShim(module, define, require) {
	/*
	Copyright 2012 Igor Vaynberg
	
	Version: 3.5.4 Timestamp: Sun Aug 30 13:30:32 EDT 2015
	
	This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
	General Public License version 2 (the "GPL License"). You may choose either license to govern your
	use of this software only upon the condition that you accept all of the terms of either the Apache
	License or the GPL License.
	
	You may obtain a copy of the Apache License and the GPL License at:
	
	    http://www.apache.org/licenses/LICENSE-2.0
	    http://www.gnu.org/licenses/gpl-2.0.html
	
	Unless required by applicable law or agreed to in writing, software distributed under the
	Apache License or the GPL License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	CONDITIONS OF ANY KIND, either express or implied. See the Apache License and the GPL License for
	the specific language governing permissions and limitations under the Apache License and the GPL License.
	*/
	(function ($) {
	    if(typeof $.fn.each2 == "undefined") {
	        $.extend($.fn, {
	            /*
	            * 4-10 times faster .each replacement
	            * use it carefully, as it overrides jQuery context of element on each iteration
	            */
	            each2 : function (c) {
	                var j = $([0]), i = -1, l = this.length;
	                while (
	                    ++i < l
	                    && (j.context = j[0] = this[i])
	                    && c.call(j[0], i, j) !== false //"this"=DOM, i=index, j=jQuery object
	                );
	                return this;
	            }
	        });
	    }
	})(jQuery);
	
	(function ($, undefined) {
	    "use strict";
	    /*global document, window, jQuery, console */
	
	    if (window.Select2 !== undefined) {
	        return;
	    }
	
	    var AbstractSelect2, SingleSelect2, MultiSelect2, nextUid, sizer,
	        lastMousePosition={x:0,y:0}, $document, scrollBarDimensions,
	
	    KEY = {
	        TAB: 9,
	        ENTER: 13,
	        ESC: 27,
	        SPACE: 32,
	        LEFT: 37,
	        UP: 38,
	        RIGHT: 39,
	        DOWN: 40,
	        SHIFT: 16,
	        CTRL: 17,
	        ALT: 18,
	        PAGE_UP: 33,
	        PAGE_DOWN: 34,
	        HOME: 36,
	        END: 35,
	        BACKSPACE: 8,
	        DELETE: 46,
	        isArrow: function (k) {
	            k = k.which ? k.which : k;
	            switch (k) {
	            case KEY.LEFT:
	            case KEY.RIGHT:
	            case KEY.UP:
	            case KEY.DOWN:
	                return true;
	            }
	            return false;
	        },
	        isControl: function (e) {
	            var k = e.which;
	            switch (k) {
	            case KEY.SHIFT:
	            case KEY.CTRL:
	            case KEY.ALT:
	                return true;
	            }
	
	            if (e.metaKey) return true;
	
	            return false;
	        },
	        isFunctionKey: function (k) {
	            k = k.which ? k.which : k;
	            return k >= 112 && k <= 123;
	        }
	    },
	    MEASURE_SCROLLBAR_TEMPLATE = "<div class='select2-measure-scrollbar'></div>",
	
	    DIACRITICS = {"\u24B6":"A","\uFF21":"A","\u00C0":"A","\u00C1":"A","\u00C2":"A","\u1EA6":"A","\u1EA4":"A","\u1EAA":"A","\u1EA8":"A","\u00C3":"A","\u0100":"A","\u0102":"A","\u1EB0":"A","\u1EAE":"A","\u1EB4":"A","\u1EB2":"A","\u0226":"A","\u01E0":"A","\u00C4":"A","\u01DE":"A","\u1EA2":"A","\u00C5":"A","\u01FA":"A","\u01CD":"A","\u0200":"A","\u0202":"A","\u1EA0":"A","\u1EAC":"A","\u1EB6":"A","\u1E00":"A","\u0104":"A","\u023A":"A","\u2C6F":"A","\uA732":"AA","\u00C6":"AE","\u01FC":"AE","\u01E2":"AE","\uA734":"AO","\uA736":"AU","\uA738":"AV","\uA73A":"AV","\uA73C":"AY","\u24B7":"B","\uFF22":"B","\u1E02":"B","\u1E04":"B","\u1E06":"B","\u0243":"B","\u0182":"B","\u0181":"B","\u24B8":"C","\uFF23":"C","\u0106":"C","\u0108":"C","\u010A":"C","\u010C":"C","\u00C7":"C","\u1E08":"C","\u0187":"C","\u023B":"C","\uA73E":"C","\u24B9":"D","\uFF24":"D","\u1E0A":"D","\u010E":"D","\u1E0C":"D","\u1E10":"D","\u1E12":"D","\u1E0E":"D","\u0110":"D","\u018B":"D","\u018A":"D","\u0189":"D","\uA779":"D","\u01F1":"DZ","\u01C4":"DZ","\u01F2":"Dz","\u01C5":"Dz","\u24BA":"E","\uFF25":"E","\u00C8":"E","\u00C9":"E","\u00CA":"E","\u1EC0":"E","\u1EBE":"E","\u1EC4":"E","\u1EC2":"E","\u1EBC":"E","\u0112":"E","\u1E14":"E","\u1E16":"E","\u0114":"E","\u0116":"E","\u00CB":"E","\u1EBA":"E","\u011A":"E","\u0204":"E","\u0206":"E","\u1EB8":"E","\u1EC6":"E","\u0228":"E","\u1E1C":"E","\u0118":"E","\u1E18":"E","\u1E1A":"E","\u0190":"E","\u018E":"E","\u24BB":"F","\uFF26":"F","\u1E1E":"F","\u0191":"F","\uA77B":"F","\u24BC":"G","\uFF27":"G","\u01F4":"G","\u011C":"G","\u1E20":"G","\u011E":"G","\u0120":"G","\u01E6":"G","\u0122":"G","\u01E4":"G","\u0193":"G","\uA7A0":"G","\uA77D":"G","\uA77E":"G","\u24BD":"H","\uFF28":"H","\u0124":"H","\u1E22":"H","\u1E26":"H","\u021E":"H","\u1E24":"H","\u1E28":"H","\u1E2A":"H","\u0126":"H","\u2C67":"H","\u2C75":"H","\uA78D":"H","\u24BE":"I","\uFF29":"I","\u00CC":"I","\u00CD":"I","\u00CE":"I","\u0128":"I","\u012A":"I","\u012C":"I","\u0130":"I","\u00CF":"I","\u1E2E":"I","\u1EC8":"I","\u01CF":"I","\u0208":"I","\u020A":"I","\u1ECA":"I","\u012E":"I","\u1E2C":"I","\u0197":"I","\u24BF":"J","\uFF2A":"J","\u0134":"J","\u0248":"J","\u24C0":"K","\uFF2B":"K","\u1E30":"K","\u01E8":"K","\u1E32":"K","\u0136":"K","\u1E34":"K","\u0198":"K","\u2C69":"K","\uA740":"K","\uA742":"K","\uA744":"K","\uA7A2":"K","\u24C1":"L","\uFF2C":"L","\u013F":"L","\u0139":"L","\u013D":"L","\u1E36":"L","\u1E38":"L","\u013B":"L","\u1E3C":"L","\u1E3A":"L","\u0141":"L","\u023D":"L","\u2C62":"L","\u2C60":"L","\uA748":"L","\uA746":"L","\uA780":"L","\u01C7":"LJ","\u01C8":"Lj","\u24C2":"M","\uFF2D":"M","\u1E3E":"M","\u1E40":"M","\u1E42":"M","\u2C6E":"M","\u019C":"M","\u24C3":"N","\uFF2E":"N","\u01F8":"N","\u0143":"N","\u00D1":"N","\u1E44":"N","\u0147":"N","\u1E46":"N","\u0145":"N","\u1E4A":"N","\u1E48":"N","\u0220":"N","\u019D":"N","\uA790":"N","\uA7A4":"N","\u01CA":"NJ","\u01CB":"Nj","\u24C4":"O","\uFF2F":"O","\u00D2":"O","\u00D3":"O","\u00D4":"O","\u1ED2":"O","\u1ED0":"O","\u1ED6":"O","\u1ED4":"O","\u00D5":"O","\u1E4C":"O","\u022C":"O","\u1E4E":"O","\u014C":"O","\u1E50":"O","\u1E52":"O","\u014E":"O","\u022E":"O","\u0230":"O","\u00D6":"O","\u022A":"O","\u1ECE":"O","\u0150":"O","\u01D1":"O","\u020C":"O","\u020E":"O","\u01A0":"O","\u1EDC":"O","\u1EDA":"O","\u1EE0":"O","\u1EDE":"O","\u1EE2":"O","\u1ECC":"O","\u1ED8":"O","\u01EA":"O","\u01EC":"O","\u00D8":"O","\u01FE":"O","\u0186":"O","\u019F":"O","\uA74A":"O","\uA74C":"O","\u01A2":"OI","\uA74E":"OO","\u0222":"OU","\u24C5":"P","\uFF30":"P","\u1E54":"P","\u1E56":"P","\u01A4":"P","\u2C63":"P","\uA750":"P","\uA752":"P","\uA754":"P","\u24C6":"Q","\uFF31":"Q","\uA756":"Q","\uA758":"Q","\u024A":"Q","\u24C7":"R","\uFF32":"R","\u0154":"R","\u1E58":"R","\u0158":"R","\u0210":"R","\u0212":"R","\u1E5A":"R","\u1E5C":"R","\u0156":"R","\u1E5E":"R","\u024C":"R","\u2C64":"R","\uA75A":"R","\uA7A6":"R","\uA782":"R","\u24C8":"S","\uFF33":"S","\u1E9E":"S","\u015A":"S","\u1E64":"S","\u015C":"S","\u1E60":"S","\u0160":"S","\u1E66":"S","\u1E62":"S","\u1E68":"S","\u0218":"S","\u015E":"S","\u2C7E":"S","\uA7A8":"S","\uA784":"S","\u24C9":"T","\uFF34":"T","\u1E6A":"T","\u0164":"T","\u1E6C":"T","\u021A":"T","\u0162":"T","\u1E70":"T","\u1E6E":"T","\u0166":"T","\u01AC":"T","\u01AE":"T","\u023E":"T","\uA786":"T","\uA728":"TZ","\u24CA":"U","\uFF35":"U","\u00D9":"U","\u00DA":"U","\u00DB":"U","\u0168":"U","\u1E78":"U","\u016A":"U","\u1E7A":"U","\u016C":"U","\u00DC":"U","\u01DB":"U","\u01D7":"U","\u01D5":"U","\u01D9":"U","\u1EE6":"U","\u016E":"U","\u0170":"U","\u01D3":"U","\u0214":"U","\u0216":"U","\u01AF":"U","\u1EEA":"U","\u1EE8":"U","\u1EEE":"U","\u1EEC":"U","\u1EF0":"U","\u1EE4":"U","\u1E72":"U","\u0172":"U","\u1E76":"U","\u1E74":"U","\u0244":"U","\u24CB":"V","\uFF36":"V","\u1E7C":"V","\u1E7E":"V","\u01B2":"V","\uA75E":"V","\u0245":"V","\uA760":"VY","\u24CC":"W","\uFF37":"W","\u1E80":"W","\u1E82":"W","\u0174":"W","\u1E86":"W","\u1E84":"W","\u1E88":"W","\u2C72":"W","\u24CD":"X","\uFF38":"X","\u1E8A":"X","\u1E8C":"X","\u24CE":"Y","\uFF39":"Y","\u1EF2":"Y","\u00DD":"Y","\u0176":"Y","\u1EF8":"Y","\u0232":"Y","\u1E8E":"Y","\u0178":"Y","\u1EF6":"Y","\u1EF4":"Y","\u01B3":"Y","\u024E":"Y","\u1EFE":"Y","\u24CF":"Z","\uFF3A":"Z","\u0179":"Z","\u1E90":"Z","\u017B":"Z","\u017D":"Z","\u1E92":"Z","\u1E94":"Z","\u01B5":"Z","\u0224":"Z","\u2C7F":"Z","\u2C6B":"Z","\uA762":"Z","\u24D0":"a","\uFF41":"a","\u1E9A":"a","\u00E0":"a","\u00E1":"a","\u00E2":"a","\u1EA7":"a","\u1EA5":"a","\u1EAB":"a","\u1EA9":"a","\u00E3":"a","\u0101":"a","\u0103":"a","\u1EB1":"a","\u1EAF":"a","\u1EB5":"a","\u1EB3":"a","\u0227":"a","\u01E1":"a","\u00E4":"a","\u01DF":"a","\u1EA3":"a","\u00E5":"a","\u01FB":"a","\u01CE":"a","\u0201":"a","\u0203":"a","\u1EA1":"a","\u1EAD":"a","\u1EB7":"a","\u1E01":"a","\u0105":"a","\u2C65":"a","\u0250":"a","\uA733":"aa","\u00E6":"ae","\u01FD":"ae","\u01E3":"ae","\uA735":"ao","\uA737":"au","\uA739":"av","\uA73B":"av","\uA73D":"ay","\u24D1":"b","\uFF42":"b","\u1E03":"b","\u1E05":"b","\u1E07":"b","\u0180":"b","\u0183":"b","\u0253":"b","\u24D2":"c","\uFF43":"c","\u0107":"c","\u0109":"c","\u010B":"c","\u010D":"c","\u00E7":"c","\u1E09":"c","\u0188":"c","\u023C":"c","\uA73F":"c","\u2184":"c","\u24D3":"d","\uFF44":"d","\u1E0B":"d","\u010F":"d","\u1E0D":"d","\u1E11":"d","\u1E13":"d","\u1E0F":"d","\u0111":"d","\u018C":"d","\u0256":"d","\u0257":"d","\uA77A":"d","\u01F3":"dz","\u01C6":"dz","\u24D4":"e","\uFF45":"e","\u00E8":"e","\u00E9":"e","\u00EA":"e","\u1EC1":"e","\u1EBF":"e","\u1EC5":"e","\u1EC3":"e","\u1EBD":"e","\u0113":"e","\u1E15":"e","\u1E17":"e","\u0115":"e","\u0117":"e","\u00EB":"e","\u1EBB":"e","\u011B":"e","\u0205":"e","\u0207":"e","\u1EB9":"e","\u1EC7":"e","\u0229":"e","\u1E1D":"e","\u0119":"e","\u1E19":"e","\u1E1B":"e","\u0247":"e","\u025B":"e","\u01DD":"e","\u24D5":"f","\uFF46":"f","\u1E1F":"f","\u0192":"f","\uA77C":"f","\u24D6":"g","\uFF47":"g","\u01F5":"g","\u011D":"g","\u1E21":"g","\u011F":"g","\u0121":"g","\u01E7":"g","\u0123":"g","\u01E5":"g","\u0260":"g","\uA7A1":"g","\u1D79":"g","\uA77F":"g","\u24D7":"h","\uFF48":"h","\u0125":"h","\u1E23":"h","\u1E27":"h","\u021F":"h","\u1E25":"h","\u1E29":"h","\u1E2B":"h","\u1E96":"h","\u0127":"h","\u2C68":"h","\u2C76":"h","\u0265":"h","\u0195":"hv","\u24D8":"i","\uFF49":"i","\u00EC":"i","\u00ED":"i","\u00EE":"i","\u0129":"i","\u012B":"i","\u012D":"i","\u00EF":"i","\u1E2F":"i","\u1EC9":"i","\u01D0":"i","\u0209":"i","\u020B":"i","\u1ECB":"i","\u012F":"i","\u1E2D":"i","\u0268":"i","\u0131":"i","\u24D9":"j","\uFF4A":"j","\u0135":"j","\u01F0":"j","\u0249":"j","\u24DA":"k","\uFF4B":"k","\u1E31":"k","\u01E9":"k","\u1E33":"k","\u0137":"k","\u1E35":"k","\u0199":"k","\u2C6A":"k","\uA741":"k","\uA743":"k","\uA745":"k","\uA7A3":"k","\u24DB":"l","\uFF4C":"l","\u0140":"l","\u013A":"l","\u013E":"l","\u1E37":"l","\u1E39":"l","\u013C":"l","\u1E3D":"l","\u1E3B":"l","\u017F":"l","\u0142":"l","\u019A":"l","\u026B":"l","\u2C61":"l","\uA749":"l","\uA781":"l","\uA747":"l","\u01C9":"lj","\u24DC":"m","\uFF4D":"m","\u1E3F":"m","\u1E41":"m","\u1E43":"m","\u0271":"m","\u026F":"m","\u24DD":"n","\uFF4E":"n","\u01F9":"n","\u0144":"n","\u00F1":"n","\u1E45":"n","\u0148":"n","\u1E47":"n","\u0146":"n","\u1E4B":"n","\u1E49":"n","\u019E":"n","\u0272":"n","\u0149":"n","\uA791":"n","\uA7A5":"n","\u01CC":"nj","\u24DE":"o","\uFF4F":"o","\u00F2":"o","\u00F3":"o","\u00F4":"o","\u1ED3":"o","\u1ED1":"o","\u1ED7":"o","\u1ED5":"o","\u00F5":"o","\u1E4D":"o","\u022D":"o","\u1E4F":"o","\u014D":"o","\u1E51":"o","\u1E53":"o","\u014F":"o","\u022F":"o","\u0231":"o","\u00F6":"o","\u022B":"o","\u1ECF":"o","\u0151":"o","\u01D2":"o","\u020D":"o","\u020F":"o","\u01A1":"o","\u1EDD":"o","\u1EDB":"o","\u1EE1":"o","\u1EDF":"o","\u1EE3":"o","\u1ECD":"o","\u1ED9":"o","\u01EB":"o","\u01ED":"o","\u00F8":"o","\u01FF":"o","\u0254":"o","\uA74B":"o","\uA74D":"o","\u0275":"o","\u01A3":"oi","\u0223":"ou","\uA74F":"oo","\u24DF":"p","\uFF50":"p","\u1E55":"p","\u1E57":"p","\u01A5":"p","\u1D7D":"p","\uA751":"p","\uA753":"p","\uA755":"p","\u24E0":"q","\uFF51":"q","\u024B":"q","\uA757":"q","\uA759":"q","\u24E1":"r","\uFF52":"r","\u0155":"r","\u1E59":"r","\u0159":"r","\u0211":"r","\u0213":"r","\u1E5B":"r","\u1E5D":"r","\u0157":"r","\u1E5F":"r","\u024D":"r","\u027D":"r","\uA75B":"r","\uA7A7":"r","\uA783":"r","\u24E2":"s","\uFF53":"s","\u00DF":"s","\u015B":"s","\u1E65":"s","\u015D":"s","\u1E61":"s","\u0161":"s","\u1E67":"s","\u1E63":"s","\u1E69":"s","\u0219":"s","\u015F":"s","\u023F":"s","\uA7A9":"s","\uA785":"s","\u1E9B":"s","\u24E3":"t","\uFF54":"t","\u1E6B":"t","\u1E97":"t","\u0165":"t","\u1E6D":"t","\u021B":"t","\u0163":"t","\u1E71":"t","\u1E6F":"t","\u0167":"t","\u01AD":"t","\u0288":"t","\u2C66":"t","\uA787":"t","\uA729":"tz","\u24E4":"u","\uFF55":"u","\u00F9":"u","\u00FA":"u","\u00FB":"u","\u0169":"u","\u1E79":"u","\u016B":"u","\u1E7B":"u","\u016D":"u","\u00FC":"u","\u01DC":"u","\u01D8":"u","\u01D6":"u","\u01DA":"u","\u1EE7":"u","\u016F":"u","\u0171":"u","\u01D4":"u","\u0215":"u","\u0217":"u","\u01B0":"u","\u1EEB":"u","\u1EE9":"u","\u1EEF":"u","\u1EED":"u","\u1EF1":"u","\u1EE5":"u","\u1E73":"u","\u0173":"u","\u1E77":"u","\u1E75":"u","\u0289":"u","\u24E5":"v","\uFF56":"v","\u1E7D":"v","\u1E7F":"v","\u028B":"v","\uA75F":"v","\u028C":"v","\uA761":"vy","\u24E6":"w","\uFF57":"w","\u1E81":"w","\u1E83":"w","\u0175":"w","\u1E87":"w","\u1E85":"w","\u1E98":"w","\u1E89":"w","\u2C73":"w","\u24E7":"x","\uFF58":"x","\u1E8B":"x","\u1E8D":"x","\u24E8":"y","\uFF59":"y","\u1EF3":"y","\u00FD":"y","\u0177":"y","\u1EF9":"y","\u0233":"y","\u1E8F":"y","\u00FF":"y","\u1EF7":"y","\u1E99":"y","\u1EF5":"y","\u01B4":"y","\u024F":"y","\u1EFF":"y","\u24E9":"z","\uFF5A":"z","\u017A":"z","\u1E91":"z","\u017C":"z","\u017E":"z","\u1E93":"z","\u1E95":"z","\u01B6":"z","\u0225":"z","\u0240":"z","\u2C6C":"z","\uA763":"z","\u0386":"\u0391","\u0388":"\u0395","\u0389":"\u0397","\u038A":"\u0399","\u03AA":"\u0399","\u038C":"\u039F","\u038E":"\u03A5","\u03AB":"\u03A5","\u038F":"\u03A9","\u03AC":"\u03B1","\u03AD":"\u03B5","\u03AE":"\u03B7","\u03AF":"\u03B9","\u03CA":"\u03B9","\u0390":"\u03B9","\u03CC":"\u03BF","\u03CD":"\u03C5","\u03CB":"\u03C5","\u03B0":"\u03C5","\u03C9":"\u03C9","\u03C2":"\u03C3"};
	
	    $document = $(document);
	
	    nextUid=(function() { var counter=1; return function() { return counter++; }; }());
	
	
	    function reinsertElement(element) {
	        var placeholder = $(document.createTextNode(''));
	
	        element.before(placeholder);
	        placeholder.before(element);
	        placeholder.remove();
	    }
	
	    function stripDiacritics(str) {
	        // Used 'uni range + named function' from http://jsperf.com/diacritics/18
	        function match(a) {
	            return DIACRITICS[a] || a;
	        }
	
	        return str.replace(/[^\u0000-\u007E]/g, match);
	    }
	
	    function indexOf(value, array) {
	        var i = 0, l = array.length;
	        for (; i < l; i = i + 1) {
	            if (equal(value, array[i])) return i;
	        }
	        return -1;
	    }
	
	    function measureScrollbar () {
	        var $template = $( MEASURE_SCROLLBAR_TEMPLATE );
	        $template.appendTo(document.body);
	
	        var dim = {
	            width: $template.width() - $template[0].clientWidth,
	            height: $template.height() - $template[0].clientHeight
	        };
	        $template.remove();
	
	        return dim;
	    }
	
	    /**
	     * Compares equality of a and b
	     * @param a
	     * @param b
	     */
	    function equal(a, b) {
	        if (a === b) return true;
	        if (a === undefined || b === undefined) return false;
	        if (a === null || b === null) return false;
	        // Check whether 'a' or 'b' is a string (primitive or object).
	        // The concatenation of an empty string (+'') converts its argument to a string's primitive.
	        if (a.constructor === String) return a+'' === b+''; // a+'' - in case 'a' is a String object
	        if (b.constructor === String) return b+'' === a+''; // b+'' - in case 'b' is a String object
	        return false;
	    }
	
	    /**
	     * Splits the string into an array of values, transforming each value. An empty array is returned for nulls or empty
	     * strings
	     * @param string
	     * @param separator
	     */
	    function splitVal(string, separator, transform) {
	        var val, i, l;
	        if (string === null || string.length < 1) return [];
	        val = string.split(separator);
	        for (i = 0, l = val.length; i < l; i = i + 1) val[i] = transform(val[i]);
	        return val;
	    }
	
	    function getSideBorderPadding(element) {
	        return element.outerWidth(false) - element.width();
	    }
	
	    function installKeyUpChangeEvent(element) {
	        var key="keyup-change-value";
	        element.on("keydown", function () {
	            if ($.data(element, key) === undefined) {
	                $.data(element, key, element.val());
	            }
	        });
	        element.on("keyup", function () {
	            var val= $.data(element, key);
	            if (val !== undefined && element.val() !== val) {
	                $.removeData(element, key);
	                element.trigger("keyup-change");
	            }
	        });
	    }
	
	
	    /**
	     * filters mouse events so an event is fired only if the mouse moved.
	     *
	     * filters out mouse events that occur when mouse is stationary but
	     * the elements under the pointer are scrolled.
	     */
	    function installFilteredMouseMove(element) {
	        element.on("mousemove", function (e) {
	            var lastpos = lastMousePosition;
	            if (lastpos === undefined || lastpos.x !== e.pageX || lastpos.y !== e.pageY) {
	                $(e.target).trigger("mousemove-filtered", e);
	            }
	        });
	    }
	
	    /**
	     * Debounces a function. Returns a function that calls the original fn function only if no invocations have been made
	     * within the last quietMillis milliseconds.
	     *
	     * @param quietMillis number of milliseconds to wait before invoking fn
	     * @param fn function to be debounced
	     * @param ctx object to be used as this reference within fn
	     * @return debounced version of fn
	     */
	    function debounce(quietMillis, fn, ctx) {
	        ctx = ctx || undefined;
	        var timeout;
	        return function () {
	            var args = arguments;
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(function() {
	                fn.apply(ctx, args);
	            }, quietMillis);
	        };
	    }
	
	    function installDebouncedScroll(threshold, element) {
	        var notify = debounce(threshold, function (e) { element.trigger("scroll-debounced", e);});
	        element.on("scroll", function (e) {
	            if (indexOf(e.target, element.get()) >= 0) notify(e);
	        });
	    }
	
	    function focus($el) {
	        if ($el[0] === document.activeElement) return;
	
	        /* set the focus in a 0 timeout - that way the focus is set after the processing
	            of the current event has finished - which seems like the only reliable way
	            to set focus */
	        window.setTimeout(function() {
	            var el=$el[0], pos=$el.val().length, range;
	
	            $el.focus();
	
	            /* make sure el received focus so we do not error out when trying to manipulate the caret.
	                sometimes modals or others listeners may steal it after its set */
	            var isVisible = (el.offsetWidth > 0 || el.offsetHeight > 0);
	            if (isVisible && el === document.activeElement) {
	
	                /* after the focus is set move the caret to the end, necessary when we val()
	                    just before setting focus */
	                if(el.setSelectionRange)
	                {
	                    el.setSelectionRange(pos, pos);
	                }
	                else if (el.createTextRange) {
	                    range = el.createTextRange();
	                    range.collapse(false);
	                    range.select();
	                }
	            }
	        }, 0);
	    }
	
	    function getCursorInfo(el) {
	        el = $(el)[0];
	        var offset = 0;
	        var length = 0;
	        if ('selectionStart' in el) {
	            offset = el.selectionStart;
	            length = el.selectionEnd - offset;
	        } else if ('selection' in document) {
	            el.focus();
	            var sel = document.selection.createRange();
	            length = document.selection.createRange().text.length;
	            sel.moveStart('character', -el.value.length);
	            offset = sel.text.length - length;
	        }
	        return { offset: offset, length: length };
	    }
	
	    function killEvent(event) {
	        event.preventDefault();
	        event.stopPropagation();
	    }
	    function killEventImmediately(event) {
	        event.preventDefault();
	        event.stopImmediatePropagation();
	    }
	
	    function measureTextWidth(e) {
	        if (!sizer){
	            var style = e[0].currentStyle || window.getComputedStyle(e[0], null);
	            sizer = $(document.createElement("div")).css({
	                position: "absolute",
	                left: "-10000px",
	                top: "-10000px",
	                display: "none",
	                fontSize: style.fontSize,
	                fontFamily: style.fontFamily,
	                fontStyle: style.fontStyle,
	                fontWeight: style.fontWeight,
	                letterSpacing: style.letterSpacing,
	                textTransform: style.textTransform,
	                whiteSpace: "nowrap"
	            });
	            sizer.attr("class","select2-sizer");
	            $(document.body).append(sizer);
	        }
	        sizer.text(e.val());
	        return sizer.width();
	    }
	
	    function syncCssClasses(dest, src, adapter) {
	        var classes, replacements = [], adapted;
	
	        classes = $.trim(dest.attr("class"));
	
	        if (classes) {
	            classes = '' + classes; // for IE which returns object
	
	            $(classes.split(/\s+/)).each2(function() {
	                if (this.indexOf("select2-") === 0) {
	                    replacements.push(this);
	                }
	            });
	        }
	
	        classes = $.trim(src.attr("class"));
	
	        if (classes) {
	            classes = '' + classes; // for IE which returns object
	
	            $(classes.split(/\s+/)).each2(function() {
	                if (this.indexOf("select2-") !== 0) {
	                    adapted = adapter(this);
	
	                    if (adapted) {
	                        replacements.push(adapted);
	                    }
	                }
	            });
	        }
	
	        dest.attr("class", replacements.join(" "));
	    }
	
	
	    function markMatch(text, term, markup, escapeMarkup) {
	        var match=stripDiacritics(text.toUpperCase()).indexOf(stripDiacritics(term.toUpperCase())),
	            tl=term.length;
	
	        if (match<0) {
	            markup.push(escapeMarkup(text));
	            return;
	        }
	
	        markup.push(escapeMarkup(text.substring(0, match)));
	        markup.push("<span class='select2-match'>");
	        markup.push(escapeMarkup(text.substring(match, match + tl)));
	        markup.push("</span>");
	        markup.push(escapeMarkup(text.substring(match + tl, text.length)));
	    }
	
	    function defaultEscapeMarkup(markup) {
	        var replace_map = {
	            '\\': '&#92;',
	            '&': '&amp;',
	            '<': '&lt;',
	            '>': '&gt;',
	            '"': '&quot;',
	            "'": '&#39;',
	            "/": '&#47;'
	        };
	
	        return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
	            return replace_map[match];
	        });
	    }
	
	    /**
	     * Produces an ajax-based query function
	     *
	     * @param options object containing configuration parameters
	     * @param options.params parameter map for the transport ajax call, can contain such options as cache, jsonpCallback, etc. see $.ajax
	     * @param options.transport function that will be used to execute the ajax request. must be compatible with parameters supported by $.ajax
	     * @param options.url url for the data
	     * @param options.data a function(searchTerm, pageNumber, context) that should return an object containing query string parameters for the above url.
	     * @param options.dataType request data type: ajax, jsonp, other datatypes supported by jQuery's $.ajax function or the transport function if specified
	     * @param options.quietMillis (optional) milliseconds to wait before making the ajaxRequest, helps debounce the ajax function if invoked too often
	     * @param options.results a function(remoteData, pageNumber, query) that converts data returned form the remote request to the format expected by Select2.
	     *      The expected format is an object containing the following keys:
	     *      results array of objects that will be used as choices
	     *      more (optional) boolean indicating whether there are more results available
	     *      Example: {results:[{id:1, text:'Red'},{id:2, text:'Blue'}], more:true}
	     */
	    function ajax(options) {
	        var timeout, // current scheduled but not yet executed request
	            handler = null,
	            quietMillis = options.quietMillis || 100,
	            ajaxUrl = options.url,
	            self = this;
	
	        return function (query) {
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(function () {
	                var data = options.data, // ajax data function
	                    url = ajaxUrl, // ajax url string or function
	                    transport = options.transport || $.fn.select2.ajaxDefaults.transport,
	                    // deprecated - to be removed in 4.0  - use params instead
	                    deprecated = {
	                        type: options.type || 'GET', // set type of request (GET or POST)
	                        cache: options.cache || false,
	                        jsonpCallback: options.jsonpCallback||undefined,
	                        dataType: options.dataType||"json"
	                    },
	                    params = $.extend({}, $.fn.select2.ajaxDefaults.params, deprecated);
	
	                data = data ? data.call(self, query.term, query.page, query.context) : null;
	                url = (typeof url === 'function') ? url.call(self, query.term, query.page, query.context) : url;
	
	                if (handler && typeof handler.abort === "function") { handler.abort(); }
	
	                if (options.params) {
	                    if ($.isFunction(options.params)) {
	                        $.extend(params, options.params.call(self));
	                    } else {
	                        $.extend(params, options.params);
	                    }
	                }
	
	                $.extend(params, {
	                    url: url,
	                    dataType: options.dataType,
	                    data: data,
	                    success: function (data) {
	                        // TODO - replace query.page with query so users have access to term, page, etc.
	                        // added query as third paramter to keep backwards compatibility
	                        var results = options.results(data, query.page, query);
	                        query.callback(results);
	                    },
	                    error: function(jqXHR, textStatus, errorThrown){
	                        var results = {
	                            hasError: true,
	                            jqXHR: jqXHR,
	                            textStatus: textStatus,
	                            errorThrown: errorThrown
	                        };
	
	                        query.callback(results);
	                    }
	                });
	                handler = transport.call(self, params);
	            }, quietMillis);
	        };
	    }
	
	    /**
	     * Produces a query function that works with a local array
	     *
	     * @param options object containing configuration parameters. The options parameter can either be an array or an
	     * object.
	     *
	     * If the array form is used it is assumed that it contains objects with 'id' and 'text' keys.
	     *
	     * If the object form is used it is assumed that it contains 'data' and 'text' keys. The 'data' key should contain
	     * an array of objects that will be used as choices. These objects must contain at least an 'id' key. The 'text'
	     * key can either be a String in which case it is expected that each element in the 'data' array has a key with the
	     * value of 'text' which will be used to match choices. Alternatively, text can be a function(item) that can extract
	     * the text.
	     */
	    function local(options) {
	        var data = options, // data elements
	            dataText,
	            tmp,
	            text = function (item) { return ""+item.text; }; // function used to retrieve the text portion of a data item that is matched against the search
	
	         if ($.isArray(data)) {
	            tmp = data;
	            data = { results: tmp };
	        }
	
	         if ($.isFunction(data) === false) {
	            tmp = data;
	            data = function() { return tmp; };
	        }
	
	        var dataItem = data();
	        if (dataItem.text) {
	            text = dataItem.text;
	            // if text is not a function we assume it to be a key name
	            if (!$.isFunction(text)) {
	                dataText = dataItem.text; // we need to store this in a separate variable because in the next step data gets reset and data.text is no longer available
	                text = function (item) { return item[dataText]; };
	            }
	        }
	
	        return function (query) {
	            var t = query.term, filtered = { results: [] }, process;
	            if (t === "") {
	                query.callback(data());
	                return;
	            }
	
	            process = function(datum, collection) {
	                var group, attr;
	                datum = datum[0];
	                if (datum.children) {
	                    group = {};
	                    for (attr in datum) {
	                        if (datum.hasOwnProperty(attr)) group[attr]=datum[attr];
	                    }
	                    group.children=[];
	                    $(datum.children).each2(function(i, childDatum) { process(childDatum, group.children); });
	                    if (group.children.length || query.matcher(t, text(group), datum)) {
	                        collection.push(group);
	                    }
	                } else {
	                    if (query.matcher(t, text(datum), datum)) {
	                        collection.push(datum);
	                    }
	                }
	            };
	
	            $(data().results).each2(function(i, datum) { process(datum, filtered.results); });
	            query.callback(filtered);
	        };
	    }
	
	    // TODO javadoc
	    function tags(data) {
	        var isFunc = $.isFunction(data);
	        return function (query) {
	            var t = query.term, filtered = {results: []};
	            var result = isFunc ? data(query) : data;
	            if ($.isArray(result)) {
	                $(result).each(function () {
	                    var isObject = this.text !== undefined,
	                        text = isObject ? this.text : this;
	                    if (t === "" || query.matcher(t, text)) {
	                        filtered.results.push(isObject ? this : {id: this, text: this});
	                    }
	                });
	                query.callback(filtered);
	            }
	        };
	    }
	
	    /**
	     * Checks if the formatter function should be used.
	     *
	     * Throws an error if it is not a function. Returns true if it should be used,
	     * false if no formatting should be performed.
	     *
	     * @param formatter
	     */
	    function checkFormatter(formatter, formatterName) {
	        if ($.isFunction(formatter)) return true;
	        if (!formatter) return false;
	        if (typeof(formatter) === 'string') return true;
	        throw new Error(formatterName +" must be a string, function, or falsy value");
	    }
	
	  /**
	   * Returns a given value
	   * If given a function, returns its output
	   *
	   * @param val string|function
	   * @param context value of "this" to be passed to function
	   * @returns {*}
	   */
	    function evaluate(val, context) {
	        if ($.isFunction(val)) {
	            var args = Array.prototype.slice.call(arguments, 2);
	            return val.apply(context, args);
	        }
	        return val;
	    }
	
	    function countResults(results) {
	        var count = 0;
	        $.each(results, function(i, item) {
	            if (item.children) {
	                count += countResults(item.children);
	            } else {
	                count++;
	            }
	        });
	        return count;
	    }
	
	    /**
	     * Default tokenizer. This function uses breaks the input on substring match of any string from the
	     * opts.tokenSeparators array and uses opts.createSearchChoice to create the choice object. Both of those
	     * two options have to be defined in order for the tokenizer to work.
	     *
	     * @param input text user has typed so far or pasted into the search field
	     * @param selection currently selected choices
	     * @param selectCallback function(choice) callback tho add the choice to selection
	     * @param opts select2's opts
	     * @return undefined/null to leave the current input unchanged, or a string to change the input to the returned value
	     */
	    function defaultTokenizer(input, selection, selectCallback, opts) {
	        var original = input, // store the original so we can compare and know if we need to tell the search to update its text
	            dupe = false, // check for whether a token we extracted represents a duplicate selected choice
	            token, // token
	            index, // position at which the separator was found
	            i, l, // looping variables
	            separator; // the matched separator
	
	        if (!opts.createSearchChoice || !opts.tokenSeparators || opts.tokenSeparators.length < 1) return undefined;
	
	        while (true) {
	            index = -1;
	
	            for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
	                separator = opts.tokenSeparators[i];
	                index = input.indexOf(separator);
	                if (index >= 0) break;
	            }
	
	            if (index < 0) break; // did not find any token separator in the input string, bail
	
	            token = input.substring(0, index);
	            input = input.substring(index + separator.length);
	
	            if (token.length > 0) {
	                token = opts.createSearchChoice.call(this, token, selection);
	                if (token !== undefined && token !== null && opts.id(token) !== undefined && opts.id(token) !== null) {
	                    dupe = false;
	                    for (i = 0, l = selection.length; i < l; i++) {
	                        if (equal(opts.id(token), opts.id(selection[i]))) {
	                            dupe = true; break;
	                        }
	                    }
	
	                    if (!dupe) selectCallback(token);
	                }
	            }
	        }
	
	        if (original!==input) return input;
	    }
	
	    function cleanupJQueryElements() {
	        var self = this;
	
	        $.each(arguments, function (i, element) {
	            self[element].remove();
	            self[element] = null;
	        });
	    }
	
	    /**
	     * Creates a new class
	     *
	     * @param superClass
	     * @param methods
	     */
	    function clazz(SuperClass, methods) {
	        var constructor = function () {};
	        constructor.prototype = new SuperClass;
	        constructor.prototype.constructor = constructor;
	        constructor.prototype.parent = SuperClass.prototype;
	        constructor.prototype = $.extend(constructor.prototype, methods);
	        return constructor;
	    }
	
	    AbstractSelect2 = clazz(Object, {
	
	        // abstract
	        bind: function (func) {
	            var self = this;
	            return function () {
	                func.apply(self, arguments);
	            };
	        },
	
	        // abstract
	        init: function (opts) {
	            var results, search, resultsSelector = ".select2-results";
	
	            // prepare options
	            this.opts = opts = this.prepareOpts(opts);
	
	            this.id=opts.id;
	
	            // destroy if called on an existing component
	            if (opts.element.data("select2") !== undefined &&
	                opts.element.data("select2") !== null) {
	                opts.element.data("select2").destroy();
	            }
	
	            this.container = this.createContainer();
	
	            this.liveRegion = $('.select2-hidden-accessible');
	            if (this.liveRegion.length == 0) {
	                this.liveRegion = $("<span>", {
	                        role: "status",
	                        "aria-live": "polite"
	                    })
	                    .addClass("select2-hidden-accessible")
	                    .appendTo(document.body);
	            }
	
	            this.containerId="s2id_"+(opts.element.attr("id") || "autogen"+nextUid());
	            this.containerEventName= this.containerId
	                .replace(/([.])/g, '_')
	                .replace(/([;&,\-\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
	            this.container.attr("id", this.containerId);
	
	            this.container.attr("title", opts.element.attr("title"));
	
	            this.body = $(document.body);
	
	            syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
	
	            this.container.attr("style", opts.element.attr("style"));
	            this.container.css(evaluate(opts.containerCss, this.opts.element));
	            this.container.addClass(evaluate(opts.containerCssClass, this.opts.element));
	
	            this.elementTabIndex = this.opts.element.attr("tabindex");
	
	            // swap container for the element
	            this.opts.element
	                .data("select2", this)
	                .attr("tabindex", "-1")
	                .before(this.container)
	                .on("click.select2", killEvent); // do not leak click events
	
	            this.container.data("select2", this);
	
	            this.dropdown = this.container.find(".select2-drop");
	
	            syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
	
	            this.dropdown.addClass(evaluate(opts.dropdownCssClass, this.opts.element));
	            this.dropdown.data("select2", this);
	            this.dropdown.on("click", killEvent);
	
	            this.results = results = this.container.find(resultsSelector);
	            this.search = search = this.container.find("input.select2-input");
	
	            this.queryCount = 0;
	            this.resultsPage = 0;
	            this.context = null;
	
	            // initialize the container
	            this.initContainer();
	
	            this.container.on("click", killEvent);
	
	            installFilteredMouseMove(this.results);
	
	            this.dropdown.on("mousemove-filtered", resultsSelector, this.bind(this.highlightUnderEvent));
	            this.dropdown.on("touchstart touchmove touchend", resultsSelector, this.bind(function (event) {
	                this._touchEvent = true;
	                this.highlightUnderEvent(event);
	            }));
	            this.dropdown.on("touchmove", resultsSelector, this.bind(this.touchMoved));
	            this.dropdown.on("touchstart touchend", resultsSelector, this.bind(this.clearTouchMoved));
	
	            // Waiting for a click event on touch devices to select option and hide dropdown
	            // otherwise click will be triggered on an underlying element
	            this.dropdown.on('click', this.bind(function (event) {
	                if (this._touchEvent) {
	                    this._touchEvent = false;
	                    this.selectHighlighted();
	                }
	            }));
	
	            installDebouncedScroll(80, this.results);
	            this.dropdown.on("scroll-debounced", resultsSelector, this.bind(this.loadMoreIfNeeded));
	
	            // do not propagate change event from the search field out of the component
	            $(this.container).on("change", ".select2-input", function(e) {e.stopPropagation();});
	            $(this.dropdown).on("change", ".select2-input", function(e) {e.stopPropagation();});
	
	            // if jquery.mousewheel plugin is installed we can prevent out-of-bounds scrolling of results via mousewheel
	            if ($.fn.mousewheel) {
	                results.mousewheel(function (e, delta, deltaX, deltaY) {
	                    var top = results.scrollTop();
	                    if (deltaY > 0 && top - deltaY <= 0) {
	                        results.scrollTop(0);
	                        killEvent(e);
	                    } else if (deltaY < 0 && results.get(0).scrollHeight - results.scrollTop() + deltaY <= results.height()) {
	                        results.scrollTop(results.get(0).scrollHeight - results.height());
	                        killEvent(e);
	                    }
	                });
	            }
	
	            installKeyUpChangeEvent(search);
	            search.on("keyup-change input paste", this.bind(this.updateResults));
	            search.on("focus", function () { search.addClass("select2-focused"); });
	            search.on("blur", function () { search.removeClass("select2-focused");});
	
	            this.dropdown.on("mouseup", resultsSelector, this.bind(function (e) {
	                if ($(e.target).closest(".select2-result-selectable").length > 0) {
	                    this.highlightUnderEvent(e);
	                    this.selectHighlighted(e);
	                }
	            }));
	
	            // trap all mouse events from leaving the dropdown. sometimes there may be a modal that is listening
	            // for mouse events outside of itself so it can close itself. since the dropdown is now outside the select2's
	            // dom it will trigger the popup close, which is not what we want
	            // focusin can cause focus wars between modals and select2 since the dropdown is outside the modal.
	            this.dropdown.on("click mouseup mousedown touchstart touchend focusin", function (e) { e.stopPropagation(); });
	
	            this.lastSearchTerm = undefined;
	
	            if ($.isFunction(this.opts.initSelection)) {
	                // initialize selection based on the current value of the source element
	                this.initSelection();
	
	                // if the user has provided a function that can set selection based on the value of the source element
	                // we monitor the change event on the element and trigger it, allowing for two way synchronization
	                this.monitorSource();
	            }
	
	            if (opts.maximumInputLength !== null) {
	                this.search.attr("maxlength", opts.maximumInputLength);
	            }
	
	            var disabled = opts.element.prop("disabled");
	            if (disabled === undefined) disabled = false;
	            this.enable(!disabled);
	
	            var readonly = opts.element.prop("readonly");
	            if (readonly === undefined) readonly = false;
	            this.readonly(readonly);
	
	            // Calculate size of scrollbar
	            scrollBarDimensions = scrollBarDimensions || measureScrollbar();
	
	            this.autofocus = opts.element.prop("autofocus");
	            opts.element.prop("autofocus", false);
	            if (this.autofocus) this.focus();
	
	            this.search.attr("placeholder", opts.searchInputPlaceholder);
	        },
	
	        // abstract
	        destroy: function () {
	            var element=this.opts.element, select2 = element.data("select2"), self = this;
	
	            this.close();
	
	            if (element.length && element[0].detachEvent && self._sync) {
	                element.each(function () {
	                    if (self._sync) {
	                        this.detachEvent("onpropertychange", self._sync);
	                    }
	                });
	            }
	            if (this.propertyObserver) {
	                this.propertyObserver.disconnect();
	                this.propertyObserver = null;
	            }
	            this._sync = null;
	
	            if (select2 !== undefined) {
	                select2.container.remove();
	                select2.liveRegion.remove();
	                select2.dropdown.remove();
	                element.removeData("select2")
	                    .off(".select2");
	                if (!element.is("input[type='hidden']")) {
	                    element
	                        .show()
	                        .prop("autofocus", this.autofocus || false);
	                    if (this.elementTabIndex) {
	                        element.attr({tabindex: this.elementTabIndex});
	                    } else {
	                        element.removeAttr("tabindex");
	                    }
	                    element.show();
	                } else {
	                    element.css("display", "");
	                }
	            }
	
	            cleanupJQueryElements.call(this,
	                "container",
	                "liveRegion",
	                "dropdown",
	                "results",
	                "search"
	            );
	        },
	
	        // abstract
	        optionToData: function(element) {
	            if (element.is("option")) {
	                return {
	                    id:element.prop("value"),
	                    text:element.text(),
	                    element: element.get(),
	                    css: element.attr("class"),
	                    disabled: element.prop("disabled"),
	                    locked: equal(element.attr("locked"), "locked") || equal(element.data("locked"), true)
	                };
	            } else if (element.is("optgroup")) {
	                return {
	                    text:element.attr("label"),
	                    children:[],
	                    element: element.get(),
	                    css: element.attr("class")
	                };
	            }
	        },
	
	        // abstract
	        prepareOpts: function (opts) {
	            var element, select, idKey, ajaxUrl, self = this;
	
	            element = opts.element;
	
	            if (element.get(0).tagName.toLowerCase() === "select") {
	                this.select = select = opts.element;
	            }
	
	            if (select) {
	                // these options are not allowed when attached to a select because they are picked up off the element itself
	                $.each(["id", "multiple", "ajax", "query", "createSearchChoice", "initSelection", "data", "tags"], function () {
	                    if (this in opts) {
	                        throw new Error("Option '" + this + "' is not allowed for Select2 when attached to a <select> element.");
	                    }
	                });
	            }
	
	            opts.debug = opts.debug || $.fn.select2.defaults.debug;
	
	            // Warnings for options renamed/removed in Select2 4.0.0
	            // Only when it's enabled through debug mode
	            if (opts.debug && console && console.warn) {
	                // id was removed
	                if (opts.id != null) {
	                    console.warn(
	                        'Select2: The `id` option has been removed in Select2 4.0.0, ' +
	                        'consider renaming your `id` property or mapping the property before your data makes it to Select2. ' +
	                        'You can read more at https://select2.github.io/announcements-4.0.html#changed-id'
	                    );
	                }
	
	                // text was removed
	                if (opts.text != null) {
	                    console.warn(
	                        'Select2: The `text` option has been removed in Select2 4.0.0, ' +
	                        'consider renaming your `text` property or mapping the property before your data makes it to Select2. ' +
	                        'You can read more at https://select2.github.io/announcements-4.0.html#changed-id'
	                    );
	                }
	
	                // sortResults was renamed to results
	                if (opts.sortResults != null) {
	                    console.warn(
	                        'Select2: the `sortResults` option has been renamed to `sorter` in Select2 4.0.0. '
	                    );
	                }
	
	                // selectOnBlur was renamed to selectOnClose
	                if (opts.selectOnBlur != null) {
	                    console.warn(
	                        'Select2: The `selectOnBlur` option has been renamed to `selectOnClose` in Select2 4.0.0.'
	                    );
	                }
	
	                // ajax.results was renamed to ajax.processResults
	                if (opts.ajax != null && opts.ajax.results != null) {
	                    console.warn(
	                        'Select2: The `ajax.results` option has been renamed to `ajax.processResults` in Select2 4.0.0.'
	                    );
	                }
	
	                // format* options were renamed to language.*
	                if (opts.formatNoResults != null) {
	                    console.warn(
	                        'Select2: The `formatNoResults` option has been renamed to `language.noResults` in Select2 4.0.0.'
	                    );
	                }
	                if (opts.formatSearching != null) {
	                    console.warn(
	                        'Select2: The `formatSearching` option has been renamed to `language.searching` in Select2 4.0.0.'
	                    );
	                }
	                if (opts.formatInputTooShort != null) {
	                    console.warn(
	                        'Select2: The `formatInputTooShort` option has been renamed to `language.inputTooShort` in Select2 4.0.0.'
	                    );
	                }
	                if (opts.formatInputTooLong != null) {
	                    console.warn(
	                        'Select2: The `formatInputTooLong` option has been renamed to `language.inputTooLong` in Select2 4.0.0.'
	                    );
	                }
	                if (opts.formatLoading != null) {
	                    console.warn(
	                        'Select2: The `formatLoading` option has been renamed to `language.loadingMore` in Select2 4.0.0.'
	                    );
	                }
	                if (opts.formatSelectionTooBig != null) {
	                    console.warn(
	                        'Select2: The `formatSelectionTooBig` option has been renamed to `language.maximumSelected` in Select2 4.0.0.'
	                    );
	                }
	
	                if (opts.element.data('select2Tags')) {
	                    console.warn(
	                        'Select2: The `data-select2-tags` attribute has been renamed to `data-tags` in Select2 4.0.0.'
	                    );
	                }
	            }
	
	            // Aliasing options renamed in Select2 4.0.0
	
	            // data-select2-tags -> data-tags
	            if (opts.element.data('tags') != null) {
	                var elemTags = opts.element.data('tags');
	
	                // data-tags should actually be a boolean
	                if (!$.isArray(elemTags)) {
	                    elemTags = [];
	                }
	
	                opts.element.data('select2Tags', elemTags);
	            }
	
	            // sortResults -> sorter
	            if (opts.sorter != null) {
	                opts.sortResults = opts.sorter;
	            }
	
	            // selectOnBlur -> selectOnClose
	            if (opts.selectOnClose != null) {
	                opts.selectOnBlur = opts.selectOnClose;
	            }
	
	            // ajax.results -> ajax.processResults
	            if (opts.ajax != null) {
	                if ($.isFunction(opts.ajax.processResults)) {
	                    opts.ajax.results = opts.ajax.processResults;
	                }
	            }
	
	            // Formatters/language options
	            if (opts.language != null) {
	                var lang = opts.language;
	
	                // formatNoMatches -> language.noMatches
	                if ($.isFunction(lang.noMatches)) {
	                    opts.formatNoMatches = lang.noMatches;
	                }
	
	                // formatSearching -> language.searching
	                if ($.isFunction(lang.searching)) {
	                    opts.formatSearching = lang.searching;
	                }
	
	                // formatInputTooShort -> language.inputTooShort
	                if ($.isFunction(lang.inputTooShort)) {
	                    opts.formatInputTooShort = lang.inputTooShort;
	                }
	
	                // formatInputTooLong -> language.inputTooLong
	                if ($.isFunction(lang.inputTooLong)) {
	                    opts.formatInputTooLong = lang.inputTooLong;
	                }
	
	                // formatLoading -> language.loadingMore
	                if ($.isFunction(lang.loadingMore)) {
	                    opts.formatLoading = lang.loadingMore;
	                }
	
	                // formatSelectionTooBig -> language.maximumSelected
	                if ($.isFunction(lang.maximumSelected)) {
	                    opts.formatSelectionTooBig = lang.maximumSelected;
	                }
	            }
	
	            opts = $.extend({}, {
	                populateResults: function(container, results, query) {
	                    var populate, id=this.opts.id, liveRegion=this.liveRegion;
	
	                    populate=function(results, container, depth) {
	
	                        var i, l, result, selectable, disabled, compound, node, label, innerContainer, formatted;
	
	                        results = opts.sortResults(results, container, query);
	
	                        // collect the created nodes for bulk append
	                        var nodes = [];
	                        for (i = 0, l = results.length; i < l; i = i + 1) {
	
	                            result=results[i];
	
	                            disabled = (result.disabled === true);
	                            selectable = (!disabled) && (id(result) !== undefined);
	
	                            compound=result.children && result.children.length > 0;
	
	                            node=$("<li></li>");
	                            node.addClass("select2-results-dept-"+depth);
	                            node.addClass("select2-result");
	                            node.addClass(selectable ? "select2-result-selectable" : "select2-result-unselectable");
	                            if (disabled) { node.addClass("select2-disabled"); }
	                            if (compound) { node.addClass("select2-result-with-children"); }
	                            node.addClass(self.opts.formatResultCssClass(result));
	                            node.attr("role", "presentation");
	
	                            label=$(document.createElement("div"));
	                            label.addClass("select2-result-label");
	                            label.attr("id", "select2-result-label-" + nextUid());
	                            label.attr("role", "option");
	
	                            formatted=opts.formatResult(result, label, query, self.opts.escapeMarkup);
	                            if (formatted!==undefined) {
	                                label.html(formatted);
	                                node.append(label);
	                            }
	
	
	                            if (compound) {
	                                innerContainer=$("<ul></ul>");
	                                innerContainer.addClass("select2-result-sub");
	                                populate(result.children, innerContainer, depth+1);
	                                node.append(innerContainer);
	                            }
	
	                            node.data("select2-data", result);
	                            nodes.push(node[0]);
	                        }
	
	                        // bulk append the created nodes
	                        container.append(nodes);
	                        liveRegion.text(opts.formatMatches(results.length));
	                    };
	
	                    populate(results, container, 0);
	                }
	            }, $.fn.select2.defaults, opts);
	
	            if (typeof(opts.id) !== "function") {
	                idKey = opts.id;
	                opts.id = function (e) { return e[idKey]; };
	            }
	
	            if ($.isArray(opts.element.data("select2Tags"))) {
	                if ("tags" in opts) {
	                    throw "tags specified as both an attribute 'data-select2-tags' and in options of Select2 " + opts.element.attr("id");
	                }
	                opts.tags=opts.element.data("select2Tags");
	            }
	
	            if (select) {
	                opts.query = this.bind(function (query) {
	                    var data = { results: [], more: false },
	                        term = query.term,
	                        children, placeholderOption, process;
	
	                    process=function(element, collection) {
	                        var group;
	                        if (element.is("option")) {
	                            if (query.matcher(term, element.text(), element)) {
	                                collection.push(self.optionToData(element));
	                            }
	                        } else if (element.is("optgroup")) {
	                            group=self.optionToData(element);
	                            element.children().each2(function(i, elm) { process(elm, group.children); });
	                            if (group.children.length>0) {
	                                collection.push(group);
	                            }
	                        }
	                    };
	
	                    children=element.children();
	
	                    // ignore the placeholder option if there is one
	                    if (this.getPlaceholder() !== undefined && children.length > 0) {
	                        placeholderOption = this.getPlaceholderOption();
	                        if (placeholderOption) {
	                            children=children.not(placeholderOption);
	                        }
	                    }
	
	                    children.each2(function(i, elm) { process(elm, data.results); });
	
	                    query.callback(data);
	                });
	                // this is needed because inside val() we construct choices from options and their id is hardcoded
	                opts.id=function(e) { return e.id; };
	            } else {
	                if (!("query" in opts)) {
	                    if ("ajax" in opts) {
	                        ajaxUrl = opts.element.data("ajax-url");
	                        if (ajaxUrl && ajaxUrl.length > 0) {
	                            opts.ajax.url = ajaxUrl;
	                        }
	                        opts.query = ajax.call(opts.element, opts.ajax);
	                    } else if ("data" in opts) {
	                        opts.query = local(opts.data);
	                    } else if ("tags" in opts) {
	                        opts.query = tags(opts.tags);
	                        if (opts.createSearchChoice === undefined) {
	                            opts.createSearchChoice = function (term) { return {id: $.trim(term), text: $.trim(term)}; };
	                        }
	                        if (opts.initSelection === undefined) {
	                            opts.initSelection = function (element, callback) {
	                                var data = [];
	                                $(splitVal(element.val(), opts.separator, opts.transformVal)).each(function () {
	                                    var obj = { id: this, text: this },
	                                        tags = opts.tags;
	                                    if ($.isFunction(tags)) tags=tags();
	                                    $(tags).each(function() { if (equal(this.id, obj.id)) { obj = this; return false; } });
	                                    data.push(obj);
	                                });
	
	                                callback(data);
	                            };
	                        }
	                    }
	                }
	            }
	            if (typeof(opts.query) !== "function") {
	                throw "query function not defined for Select2 " + opts.element.attr("id");
	            }
	
	            if (opts.createSearchChoicePosition === 'top') {
	                opts.createSearchChoicePosition = function(list, item) { list.unshift(item); };
	            }
	            else if (opts.createSearchChoicePosition === 'bottom') {
	                opts.createSearchChoicePosition = function(list, item) { list.push(item); };
	            }
	            else if (typeof(opts.createSearchChoicePosition) !== "function")  {
	                throw "invalid createSearchChoicePosition option must be 'top', 'bottom' or a custom function";
	            }
	
	            return opts;
	        },
	
	        /**
	         * Monitor the original element for changes and update select2 accordingly
	         */
	        // abstract
	        monitorSource: function () {
	            var el = this.opts.element, observer, self = this;
	
	            el.on("change.select2", this.bind(function (e) {
	                if (this.opts.element.data("select2-change-triggered") !== true) {
	                    this.initSelection();
	                }
	            }));
	
	            this._sync = this.bind(function () {
	
	                // sync enabled state
	                var disabled = el.prop("disabled");
	                if (disabled === undefined) disabled = false;
	                this.enable(!disabled);
	
	                var readonly = el.prop("readonly");
	                if (readonly === undefined) readonly = false;
	                this.readonly(readonly);
	
	                if (this.container) {
	                    syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
	                    this.container.addClass(evaluate(this.opts.containerCssClass, this.opts.element));
	                }
	
	                if (this.dropdown) {
	                    syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
	                    this.dropdown.addClass(evaluate(this.opts.dropdownCssClass, this.opts.element));
	                }
	
	            });
	
	            // IE8-10 (IE9/10 won't fire propertyChange via attachEventListener)
	            if (el.length && el[0].attachEvent) {
	                el.each(function() {
	                    this.attachEvent("onpropertychange", self._sync);
	                });
	            }
	
	            // safari, chrome, firefox, IE11
	            observer = window.MutationObserver || window.WebKitMutationObserver|| window.MozMutationObserver;
	            if (observer !== undefined) {
	                if (this.propertyObserver) { delete this.propertyObserver; this.propertyObserver = null; }
	                this.propertyObserver = new observer(function (mutations) {
	                    $.each(mutations, self._sync);
	                });
	                this.propertyObserver.observe(el.get(0), { attributes:true, subtree:false });
	            }
	        },
	
	        // abstract
	        triggerSelect: function(data) {
	            var evt = $.Event("select2-selecting", { val: this.id(data), object: data, choice: data });
	            this.opts.element.trigger(evt);
	            return !evt.isDefaultPrevented();
	        },
	
	        /**
	         * Triggers the change event on the source element
	         */
	        // abstract
	        triggerChange: function (details) {
	
	            details = details || {};
	            details= $.extend({}, details, { type: "change", val: this.val() });
	            // prevents recursive triggering
	            this.opts.element.data("select2-change-triggered", true);
	            this.opts.element.trigger(details);
	            this.opts.element.data("select2-change-triggered", false);
	
	            // some validation frameworks ignore the change event and listen instead to keyup, click for selects
	            // so here we trigger the click event manually
	            this.opts.element.click();
	
	            // ValidationEngine ignores the change event and listens instead to blur
	            // so here we trigger the blur event manually if so desired
	            if (this.opts.blurOnChange)
	                this.opts.element.blur();
	        },
	
	        //abstract
	        isInterfaceEnabled: function()
	        {
	            return this.enabledInterface === true;
	        },
	
	        // abstract
	        enableInterface: function() {
	            var enabled = this._enabled && !this._readonly,
	                disabled = !enabled;
	
	            if (enabled === this.enabledInterface) return false;
	
	            this.container.toggleClass("select2-container-disabled", disabled);
	            this.close();
	            this.enabledInterface = enabled;
	
	            return true;
	        },
	
	        // abstract
	        enable: function(enabled) {
	            if (enabled === undefined) enabled = true;
	            if (this._enabled === enabled) return;
	            this._enabled = enabled;
	
	            this.opts.element.prop("disabled", !enabled);
	            this.enableInterface();
	        },
	
	        // abstract
	        disable: function() {
	            this.enable(false);
	        },
	
	        // abstract
	        readonly: function(enabled) {
	            if (enabled === undefined) enabled = false;
	            if (this._readonly === enabled) return;
	            this._readonly = enabled;
	
	            this.opts.element.prop("readonly", enabled);
	            this.enableInterface();
	        },
	
	        // abstract
	        opened: function () {
	            return (this.container) ? this.container.hasClass("select2-dropdown-open") : false;
	        },
	
	        // abstract
	        positionDropdown: function() {
	            var $dropdown = this.dropdown,
	                container = this.container,
	                offset = container.offset(),
	                height = container.outerHeight(false),
	                width = container.outerWidth(false),
	                dropHeight = $dropdown.outerHeight(false),
	                $window = $(window),
	                windowWidth = $window.width(),
	                windowHeight = $window.height(),
	                viewPortRight = $window.scrollLeft() + windowWidth,
	                viewportBottom = $window.scrollTop() + windowHeight,
	                dropTop = offset.top + height,
	                dropLeft = offset.left,
	                enoughRoomBelow = dropTop + dropHeight <= viewportBottom,
	                enoughRoomAbove = (offset.top - dropHeight) >= $window.scrollTop(),
	                dropWidth = $dropdown.outerWidth(false),
	                enoughRoomOnRight = function() {
	                    return dropLeft + dropWidth <= viewPortRight;
	                },
	                enoughRoomOnLeft = function() {
	                    return offset.left + viewPortRight + container.outerWidth(false)  > dropWidth;
	                },
	                aboveNow = $dropdown.hasClass("select2-drop-above"),
	                bodyOffset,
	                above,
	                changeDirection,
	                css,
	                resultsListNode;
	
	            // always prefer the current above/below alignment, unless there is not enough room
	            if (aboveNow) {
	                above = true;
	                if (!enoughRoomAbove && enoughRoomBelow) {
	                    changeDirection = true;
	                    above = false;
	                }
	            } else {
	                above = false;
	                if (!enoughRoomBelow && enoughRoomAbove) {
	                    changeDirection = true;
	                    above = true;
	                }
	            }
	
	            //if we are changing direction we need to get positions when dropdown is hidden;
	            if (changeDirection) {
	                $dropdown.hide();
	                offset = this.container.offset();
	                height = this.container.outerHeight(false);
	                width = this.container.outerWidth(false);
	                dropHeight = $dropdown.outerHeight(false);
	                viewPortRight = $window.scrollLeft() + windowWidth;
	                viewportBottom = $window.scrollTop() + windowHeight;
	                dropTop = offset.top + height;
	                dropLeft = offset.left;
	                dropWidth = $dropdown.outerWidth(false);
	                $dropdown.show();
	
	                // fix so the cursor does not move to the left within the search-textbox in IE
	                this.focusSearch();
	            }
	
	            if (this.opts.dropdownAutoWidth) {
	                resultsListNode = $('.select2-results', $dropdown)[0];
	                $dropdown.addClass('select2-drop-auto-width');
	                $dropdown.css('width', '');
	                // Add scrollbar width to dropdown if vertical scrollbar is present
	                dropWidth = $dropdown.outerWidth(false) + (resultsListNode.scrollHeight === resultsListNode.clientHeight ? 0 : scrollBarDimensions.width);
	                dropWidth > width ? width = dropWidth : dropWidth = width;
	                dropHeight = $dropdown.outerHeight(false);
	            }
	            else {
	                this.container.removeClass('select2-drop-auto-width');
	            }
	
	            //console.log("below/ droptop:", dropTop, "dropHeight", dropHeight, "sum", (dropTop+dropHeight)+" viewport bottom", viewportBottom, "enough?", enoughRoomBelow);
	            //console.log("above/ offset.top", offset.top, "dropHeight", dropHeight, "top", (offset.top-dropHeight), "scrollTop", this.body.scrollTop(), "enough?", enoughRoomAbove);
	
	            // fix positioning when body has an offset and is not position: static
	            if (this.body.css('position') !== 'static') {
	                bodyOffset = this.body.offset();
	                dropTop -= bodyOffset.top;
	                dropLeft -= bodyOffset.left;
	            }
	
	            if (!enoughRoomOnRight() && enoughRoomOnLeft()) {
	                dropLeft = offset.left + this.container.outerWidth(false) - dropWidth;
	            }
	
	            css =  {
	                left: dropLeft,
	                width: width
	            };
	
	            if (above) {
	                this.container.addClass("select2-drop-above");
	                $dropdown.addClass("select2-drop-above");
	                dropHeight = $dropdown.outerHeight(false);
	                css.top = offset.top - dropHeight;
	                css.bottom = 'auto';
	            }
	            else {
	                css.top = dropTop;
	                css.bottom = 'auto';
	                this.container.removeClass("select2-drop-above");
	                $dropdown.removeClass("select2-drop-above");
	            }
	            css = $.extend(css, evaluate(this.opts.dropdownCss, this.opts.element));
	
	            $dropdown.css(css);
	        },
	
	        // abstract
	        shouldOpen: function() {
	            var event;
	
	            if (this.opened()) return false;
	
	            if (this._enabled === false || this._readonly === true) return false;
	
	            event = $.Event("select2-opening");
	            this.opts.element.trigger(event);
	            return !event.isDefaultPrevented();
	        },
	
	        // abstract
	        clearDropdownAlignmentPreference: function() {
	            // clear the classes used to figure out the preference of where the dropdown should be opened
	            this.container.removeClass("select2-drop-above");
	            this.dropdown.removeClass("select2-drop-above");
	        },
	
	        /**
	         * Opens the dropdown
	         *
	         * @return {Boolean} whether or not dropdown was opened. This method will return false if, for example,
	         * the dropdown is already open, or if the 'open' event listener on the element called preventDefault().
	         */
	        // abstract
	        open: function () {
	
	            if (!this.shouldOpen()) return false;
	
	            this.opening();
	
	            // Only bind the document mousemove when the dropdown is visible
	            $document.on("mousemove.select2Event", function (e) {
	                lastMousePosition.x = e.pageX;
	                lastMousePosition.y = e.pageY;
	            });
	
	            return true;
	        },
	
	        /**
	         * Performs the opening of the dropdown
	         */
	        // abstract
	        opening: function() {
	            var cid = this.containerEventName,
	                scroll = "scroll." + cid,
	                resize = "resize."+cid,
	                orient = "orientationchange."+cid,
	                mask;
	
	            this.container.addClass("select2-dropdown-open").addClass("select2-container-active");
	
	            this.clearDropdownAlignmentPreference();
	
	            if(this.dropdown[0] !== this.body.children().last()[0]) {
	                this.dropdown.detach().appendTo(this.body);
	            }
	
	            // create the dropdown mask if doesn't already exist
	            mask = $("#select2-drop-mask");
	            if (mask.length === 0) {
	                mask = $(document.createElement("div"));
	                mask.attr("id","select2-drop-mask").attr("class","select2-drop-mask");
	                mask.hide();
	                mask.appendTo(this.body);
	                mask.on("mousedown touchstart click", function (e) {
	                    // Prevent IE from generating a click event on the body
	                    reinsertElement(mask);
	
	                    var dropdown = $("#select2-drop"), self;
	                    if (dropdown.length > 0) {
	                        self=dropdown.data("select2");
	                        if (self.opts.selectOnBlur) {
	                            self.selectHighlighted({noFocus: true});
	                        }
	                        self.close();
	                        e.preventDefault();
	                        e.stopPropagation();
	                    }
	                });
	            }
	
	            // ensure the mask is always right before the dropdown
	            if (this.dropdown.prev()[0] !== mask[0]) {
	                this.dropdown.before(mask);
	            }
	
	            // move the global id to the correct dropdown
	            $("#select2-drop").removeAttr("id");
	            this.dropdown.attr("id", "select2-drop");
	
	            // show the elements
	            mask.show();
	
	            this.positionDropdown();
	            this.dropdown.show();
	            this.positionDropdown();
	
	            this.dropdown.addClass("select2-drop-active");
	
	            // attach listeners to events that can change the position of the container and thus require
	            // the position of the dropdown to be updated as well so it does not come unglued from the container
	            var that = this;
	            this.container.parents().add(window).each(function () {
	                $(this).on(resize+" "+scroll+" "+orient, function (e) {
	                    if (that.opened()) that.positionDropdown();
	                });
	            });
	
	
	        },
	
	        // abstract
	        close: function () {
	            if (!this.opened()) return;
	
	            var cid = this.containerEventName,
	                scroll = "scroll." + cid,
	                resize = "resize."+cid,
	                orient = "orientationchange."+cid;
	
	            // unbind event listeners
	            this.container.parents().add(window).each(function () { $(this).off(scroll).off(resize).off(orient); });
	
	            this.clearDropdownAlignmentPreference();
	
	            $("#select2-drop-mask").hide();
	            this.dropdown.removeAttr("id"); // only the active dropdown has the select2-drop id
	            this.dropdown.hide();
	            this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active");
	            this.results.empty();
	
	            // Now that the dropdown is closed, unbind the global document mousemove event
	            $document.off("mousemove.select2Event");
	
	            this.clearSearch();
	            this.search.removeClass("select2-active");
	
	            // Remove the aria active descendant for highlighted element
	            this.search.removeAttr("aria-activedescendant");
	            this.opts.element.trigger($.Event("select2-close"));
	        },
	
	        /**
	         * Opens control, sets input value, and updates results.
	         */
	        // abstract
	        externalSearch: function (term) {
	            this.open();
	            this.search.val(term);
	            this.updateResults(false);
	        },
	
	        // abstract
	        clearSearch: function () {
	
	        },
	
	        /**
	         * @return {Boolean} Whether or not search value was changed.
	         * @private
	         */
	        prefillNextSearchTerm: function () {
	            // initializes search's value with nextSearchTerm (if defined by user)
	            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
	            if(this.search.val() !== "") {
	                return false;
	            }
	
	            var nextSearchTerm = this.opts.nextSearchTerm(this.data(), this.lastSearchTerm);
	            if(nextSearchTerm !== undefined){
	                this.search.val(nextSearchTerm);
	                this.search.select();
	                return true;
	            }
	
	            return false;
	        },
	
	        //abstract
	        getMaximumSelectionSize: function() {
	            return evaluate(this.opts.maximumSelectionSize, this.opts.element);
	        },
	
	        // abstract
	        ensureHighlightVisible: function () {
	            var results = this.results, children, index, child, hb, rb, y, more, topOffset;
	
	            index = this.highlight();
	
	            if (index < 0) return;
	
	            if (index == 0) {
	
	                // if the first element is highlighted scroll all the way to the top,
	                // that way any unselectable headers above it will also be scrolled
	                // into view
	
	                results.scrollTop(0);
	                return;
	            }
	
	            children = this.findHighlightableChoices().find('.select2-result-label');
	
	            child = $(children[index]);
	
	            topOffset = (child.offset() || {}).top || 0;
	
	            hb = topOffset + child.outerHeight(true);
	
	            // if this is the last child lets also make sure select2-more-results is visible
	            if (index === children.length - 1) {
	                more = results.find("li.select2-more-results");
	                if (more.length > 0) {
	                    hb = more.offset().top + more.outerHeight(true);
	                }
	            }
	
	            rb = results.offset().top + results.outerHeight(false);
	            if (hb > rb) {
	                results.scrollTop(results.scrollTop() + (hb - rb));
	            }
	            y = topOffset - results.offset().top;
	
	            // make sure the top of the element is visible
	            if (y < 0 && child.css('display') != 'none' ) {
	                results.scrollTop(results.scrollTop() + y); // y is negative
	            }
	        },
	
	        // abstract
	        findHighlightableChoices: function() {
	            return this.results.find(".select2-result-selectable:not(.select2-disabled):not(.select2-selected)");
	        },
	
	        // abstract
	        moveHighlight: function (delta) {
	            var choices = this.findHighlightableChoices(),
	                index = this.highlight();
	
	            while (index > -1 && index < choices.length) {
	                index += delta;
	                var choice = $(choices[index]);
	                if (choice.hasClass("select2-result-selectable") && !choice.hasClass("select2-disabled") && !choice.hasClass("select2-selected")) {
	                    this.highlight(index);
	                    break;
	                }
	            }
	        },
	
	        // abstract
	        highlight: function (index) {
	            var choices = this.findHighlightableChoices(),
	                choice,
	                data;
	
	            if (arguments.length === 0) {
	                return indexOf(choices.filter(".select2-highlighted")[0], choices.get());
	            }
	
	            if (index >= choices.length) index = choices.length - 1;
	            if (index < 0) index = 0;
	
	            this.removeHighlight();
	
	            choice = $(choices[index]);
	            choice.addClass("select2-highlighted");
	
	            // ensure assistive technology can determine the active choice
	            this.search.attr("aria-activedescendant", choice.find(".select2-result-label").attr("id"));
	
	            this.ensureHighlightVisible();
	
	            this.liveRegion.text(choice.text());
	
	            data = choice.data("select2-data");
	            if (data) {
	                this.opts.element.trigger({ type: "select2-highlight", val: this.id(data), choice: data });
	            }
	        },
	
	        removeHighlight: function() {
	            this.results.find(".select2-highlighted").removeClass("select2-highlighted");
	        },
	
	        touchMoved: function() {
	            this._touchMoved = true;
	        },
	
	        clearTouchMoved: function() {
	          this._touchMoved = false;
	        },
	
	        // abstract
	        countSelectableResults: function() {
	            return this.findHighlightableChoices().length;
	        },
	
	        // abstract
	        highlightUnderEvent: function (event) {
	            var el = $(event.target).closest(".select2-result-selectable");
	            if (el.length > 0 && !el.is(".select2-highlighted")) {
	                var choices = this.findHighlightableChoices();
	                this.highlight(choices.index(el));
	            } else if (el.length == 0) {
	                // if we are over an unselectable item remove all highlights
	                this.removeHighlight();
	            }
	        },
	
	        // abstract
	        loadMoreIfNeeded: function () {
	            var results = this.results,
	                more = results.find("li.select2-more-results"),
	                below, // pixels the element is below the scroll fold, below==0 is when the element is starting to be visible
	                page = this.resultsPage + 1,
	                self=this,
	                term=this.search.val(),
	                context=this.context;
	
	            if (more.length === 0) return;
	            below = more.offset().top - results.offset().top - results.height();
	
	            if (below <= this.opts.loadMorePadding) {
	                more.addClass("select2-active");
	                this.opts.query({
	                        element: this.opts.element,
	                        term: term,
	                        page: page,
	                        context: context,
	                        matcher: this.opts.matcher,
	                        callback: this.bind(function (data) {
	
	                    // ignore a response if the select2 has been closed before it was received
	                    if (!self.opened()) return;
	
	
	                    self.opts.populateResults.call(this, results, data.results, {term: term, page: page, context:context});
	                    self.postprocessResults(data, false, false);
	
	                    if (data.more===true) {
	                        more.detach().appendTo(results).html(self.opts.escapeMarkup(evaluate(self.opts.formatLoadMore, self.opts.element, page+1)));
	                        window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
	                    } else {
	                        more.remove();
	                    }
	                    self.positionDropdown();
	                    self.resultsPage = page;
	                    self.context = data.context;
	                    this.opts.element.trigger({ type: "select2-loaded", items: data });
	                })});
	            }
	        },
	
	        /**
	         * Default tokenizer function which does nothing
	         */
	        tokenize: function() {
	
	        },
	
	        /**
	         * @param initial whether or not this is the call to this method right after the dropdown has been opened
	         */
	        // abstract
	        updateResults: function (initial) {
	            var search = this.search,
	                results = this.results,
	                opts = this.opts,
	                data,
	                self = this,
	                input,
	                term = search.val(),
	                lastTerm = $.data(this.container, "select2-last-term"),
	                // sequence number used to drop out-of-order responses
	                queryNumber;
	
	            // prevent duplicate queries against the same term
	            if (initial !== true && lastTerm && equal(term, lastTerm)) return;
	
	            $.data(this.container, "select2-last-term", term);
	
	            // if the search is currently hidden we do not alter the results
	            if (initial !== true && (this.showSearchInput === false || !this.opened())) {
	                return;
	            }
	
	            function postRender() {
	                search.removeClass("select2-active");
	                self.positionDropdown();
	                if (results.find('.select2-no-results,.select2-selection-limit,.select2-searching').length) {
	                    self.liveRegion.text(results.text());
	                }
	                else {
	                    self.liveRegion.text(self.opts.formatMatches(results.find('.select2-result-selectable:not(".select2-selected")').length));
	                }
	            }
	
	            function render(html) {
	                results.html(html);
	                postRender();
	            }
	
	            queryNumber = ++this.queryCount;
	
	            var maxSelSize = this.getMaximumSelectionSize();
	            if (maxSelSize >=1) {
	                data = this.data();
	                if ($.isArray(data) && data.length >= maxSelSize && checkFormatter(opts.formatSelectionTooBig, "formatSelectionTooBig")) {
	                    render("<li class='select2-selection-limit'>" + evaluate(opts.formatSelectionTooBig, opts.element, maxSelSize) + "</li>");
	                    return;
	                }
	            }
	
	            if (search.val().length < opts.minimumInputLength) {
	                if (checkFormatter(opts.formatInputTooShort, "formatInputTooShort")) {
	                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooShort, opts.element, search.val(), opts.minimumInputLength) + "</li>");
	                } else {
	                    render("");
	                }
	                if (initial && this.showSearch) this.showSearch(true);
	                return;
	            }
	
	            if (opts.maximumInputLength && search.val().length > opts.maximumInputLength) {
	                if (checkFormatter(opts.formatInputTooLong, "formatInputTooLong")) {
	                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooLong, opts.element, search.val(), opts.maximumInputLength) + "</li>");
	                } else {
	                    render("");
	                }
	                return;
	            }
	
	            if (opts.formatSearching && this.findHighlightableChoices().length === 0) {
	                render("<li class='select2-searching'>" + evaluate(opts.formatSearching, opts.element) + "</li>");
	            }
	
	            search.addClass("select2-active");
	
	            this.removeHighlight();
	
	            // give the tokenizer a chance to pre-process the input
	            input = this.tokenize();
	            if (input != undefined && input != null) {
	                search.val(input);
	            }
	
	            this.resultsPage = 1;
	
	            opts.query({
	                element: opts.element,
	                    term: search.val(),
	                    page: this.resultsPage,
	                    context: null,
	                    matcher: opts.matcher,
	                    callback: this.bind(function (data) {
	                var def; // default choice
	
	                // ignore old responses
	                if (queryNumber != this.queryCount) {
	                  return;
	                }
	
	                // ignore a response if the select2 has been closed before it was received
	                if (!this.opened()) {
	                    this.search.removeClass("select2-active");
	                    return;
	                }
	
	                // handle ajax error
	                if(data.hasError !== undefined && checkFormatter(opts.formatAjaxError, "formatAjaxError")) {
	                    render("<li class='select2-ajax-error'>" + evaluate(opts.formatAjaxError, opts.element, data.jqXHR, data.textStatus, data.errorThrown) + "</li>");
	                    return;
	                }
	
	                // save context, if any
	                this.context = (data.context===undefined) ? null : data.context;
	                // create a default choice and prepend it to the list
	                if (this.opts.createSearchChoice && search.val() !== "") {
	                    def = this.opts.createSearchChoice.call(self, search.val(), data.results);
	                    if (def !== undefined && def !== null && self.id(def) !== undefined && self.id(def) !== null) {
	                        if ($(data.results).filter(
	                            function () {
	                                return equal(self.id(this), self.id(def));
	                            }).length === 0) {
	                            this.opts.createSearchChoicePosition(data.results, def);
	                        }
	                    }
	                }
	
	                if (data.results.length === 0 && checkFormatter(opts.formatNoMatches, "formatNoMatches")) {
	                    render("<li class='select2-no-results'>" + evaluate(opts.formatNoMatches, opts.element, search.val()) + "</li>");
	                    if(this.showSearch){
	                        this.showSearch(search.val());
	                    }
	                    return;
	                }
	
	                results.empty();
	                self.opts.populateResults.call(this, results, data.results, {term: search.val(), page: this.resultsPage, context:null});
	
	                if (data.more === true && checkFormatter(opts.formatLoadMore, "formatLoadMore")) {
	                    results.append("<li class='select2-more-results'>" + opts.escapeMarkup(evaluate(opts.formatLoadMore, opts.element, this.resultsPage)) + "</li>");
	                    window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
	                }
	
	                this.postprocessResults(data, initial);
	
	                postRender();
	
	                this.opts.element.trigger({ type: "select2-loaded", items: data });
	            })});
	        },
	
	        // abstract
	        cancel: function () {
	            this.close();
	        },
	
	        // abstract
	        blur: function () {
	            // if selectOnBlur == true, select the currently highlighted option
	            if (this.opts.selectOnBlur)
	                this.selectHighlighted({noFocus: true});
	
	            this.close();
	            this.container.removeClass("select2-container-active");
	            // synonymous to .is(':focus'), which is available in jquery >= 1.6
	            if (this.search[0] === document.activeElement) { this.search.blur(); }
	            this.clearSearch();
	            this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	        },
	
	        // abstract
	        focusSearch: function () {
	            focus(this.search);
	        },
	
	        // abstract
	        selectHighlighted: function (options) {
	            if (this._touchMoved) {
	              this.clearTouchMoved();
	              return;
	            }
	            var index=this.highlight(),
	                highlighted=this.results.find(".select2-highlighted"),
	                data = highlighted.closest('.select2-result').data("select2-data");
	
	            if (data) {
	                this.highlight(index);
	                this.onSelect(data, options);
	            } else if (options && options.noFocus) {
	                this.close();
	            }
	        },
	
	        // abstract
	        getPlaceholder: function () {
	            var placeholderOption;
	            return this.opts.element.attr("placeholder") ||
	                this.opts.element.attr("data-placeholder") || // jquery 1.4 compat
	                this.opts.element.data("placeholder") ||
	                this.opts.placeholder ||
	                ((placeholderOption = this.getPlaceholderOption()) !== undefined ? placeholderOption.text() : undefined);
	        },
	
	        // abstract
	        getPlaceholderOption: function() {
	            if (this.select) {
	                var firstOption = this.select.children('option').first();
	                if (this.opts.placeholderOption !== undefined ) {
	                    //Determine the placeholder option based on the specified placeholderOption setting
	                    return (this.opts.placeholderOption === "first" && firstOption) ||
	                           (typeof this.opts.placeholderOption === "function" && this.opts.placeholderOption(this.select));
	                } else if ($.trim(firstOption.text()) === "" && firstOption.val() === "") {
	                    //No explicit placeholder option specified, use the first if it's blank
	                    return firstOption;
	                }
	            }
	        },
	
	        /**
	         * Get the desired width for the container element.  This is
	         * derived first from option `width` passed to select2, then
	         * the inline 'style' on the original element, and finally
	         * falls back to the jQuery calculated element width.
	         */
	        // abstract
	        initContainerWidth: function () {
	            function resolveContainerWidth() {
	                var style, attrs, matches, i, l, attr;
	
	                if (this.opts.width === "off") {
	                    return null;
	                } else if (this.opts.width === "element"){
	                    return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
	                } else if (this.opts.width === "copy" || this.opts.width === "resolve") {
	                    // check if there is inline style on the element that contains width
	                    style = this.opts.element.attr('style');
	                    if (typeof(style) === "string") {
	                        attrs = style.split(';');
	                        for (i = 0, l = attrs.length; i < l; i = i + 1) {
	                            attr = attrs[i].replace(/\s/g, '');
	                            matches = attr.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);
	                            if (matches !== null && matches.length >= 1)
	                                return matches[1];
	                        }
	                    }
	
	                    if (this.opts.width === "resolve") {
	                        // next check if css('width') can resolve a width that is percent based, this is sometimes possible
	                        // when attached to input type=hidden or elements hidden via css
	                        style = this.opts.element.css('width');
	                        if (style.indexOf("%") > 0) return style;
	
	                        // finally, fallback on the calculated width of the element
	                        return (this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px');
	                    }
	
	                    return null;
	                } else if ($.isFunction(this.opts.width)) {
	                    return this.opts.width();
	                } else {
	                    return this.opts.width;
	               }
	            };
	
	            var width = resolveContainerWidth.call(this);
	            if (width !== null) {
	                this.container.css("width", width);
	            }
	        }
	    });
	
	    SingleSelect2 = clazz(AbstractSelect2, {
	
	        // single
	
	        createContainer: function () {
	            var container = $(document.createElement("div")).attr({
	                "class": "select2-container"
	            }).html([
	                "<a href='javascript:void(0)' class='select2-choice' tabindex='-1'>",
	                "   <span class='select2-chosen'>&#160;</span><abbr class='select2-search-choice-close'></abbr>",
	                "   <span class='select2-arrow' role='presentation'><b role='presentation'></b></span>",
	                "</a>",
	                "<label for='' class='select2-offscreen'></label>",
	                "<input class='select2-focusser select2-offscreen' type='text' aria-haspopup='true' role='button' />",
	                "<div class='select2-drop select2-display-none'>",
	                "   <div class='select2-search'>",
	                "       <label for='' class='select2-offscreen'></label>",
	                "       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input' role='combobox' aria-expanded='true'",
	                "       aria-autocomplete='list' />",
	                "   </div>",
	                "   <ul class='select2-results' role='listbox'>",
	                "   </ul>",
	                "</div>"].join(""));
	            return container;
	        },
	
	        // single
	        enableInterface: function() {
	            if (this.parent.enableInterface.apply(this, arguments)) {
	                this.focusser.prop("disabled", !this.isInterfaceEnabled());
	            }
	        },
	
	        // single
	        opening: function () {
	            var el, range, len;
	
	            if (this.opts.minimumResultsForSearch >= 0) {
	                this.showSearch(true);
	            }
	
	            this.parent.opening.apply(this, arguments);
	
	            if (this.showSearchInput !== false) {
	                // IE appends focusser.val() at the end of field :/ so we manually insert it at the beginning using a range
	                // all other browsers handle this just fine
	
	                this.search.val(this.focusser.val());
	            }
	            if (this.opts.shouldFocusInput(this)) {
	                this.search.focus();
	                // move the cursor to the end after focussing, otherwise it will be at the beginning and
	                // new text will appear *before* focusser.val()
	                el = this.search.get(0);
	                if (el.createTextRange) {
	                    range = el.createTextRange();
	                    range.collapse(false);
	                    range.select();
	                } else if (el.setSelectionRange) {
	                    len = this.search.val().length;
	                    el.setSelectionRange(len, len);
	                }
	            }
	
	            this.prefillNextSearchTerm();
	
	            this.focusser.prop("disabled", true).val("");
	            this.updateResults(true);
	            this.opts.element.trigger($.Event("select2-open"));
	        },
	
	        // single
	        close: function () {
	            if (!this.opened()) return;
	            this.parent.close.apply(this, arguments);
	
	            this.focusser.prop("disabled", false);
	
	            if (this.opts.shouldFocusInput(this)) {
	                this.focusser.focus();
	            }
	        },
	
	        // single
	        focus: function () {
	            if (this.opened()) {
	                this.close();
	            } else {
	                this.focusser.prop("disabled", false);
	                if (this.opts.shouldFocusInput(this)) {
	                    this.focusser.focus();
	                }
	            }
	        },
	
	        // single
	        isFocused: function () {
	            return this.container.hasClass("select2-container-active");
	        },
	
	        // single
	        cancel: function () {
	            this.parent.cancel.apply(this, arguments);
	            this.focusser.prop("disabled", false);
	
	            if (this.opts.shouldFocusInput(this)) {
	                this.focusser.focus();
	            }
	        },
	
	        // single
	        destroy: function() {
	            $("label[for='" + this.focusser.attr('id') + "']")
	                .attr('for', this.opts.element.attr("id"));
	            this.parent.destroy.apply(this, arguments);
	
	            cleanupJQueryElements.call(this,
	                "selection",
	                "focusser"
	            );
	        },
	
	        // single
	        initContainer: function () {
	
	            var selection,
	                container = this.container,
	                dropdown = this.dropdown,
	                idSuffix = nextUid(),
	                elementLabel;
	
	            if (this.opts.minimumResultsForSearch < 0) {
	                this.showSearch(false);
	            } else {
	                this.showSearch(true);
	            }
	
	            this.selection = selection = container.find(".select2-choice");
	
	            this.focusser = container.find(".select2-focusser");
	
	            // add aria associations
	            selection.find(".select2-chosen").attr("id", "select2-chosen-"+idSuffix);
	            this.focusser.attr("aria-labelledby", "select2-chosen-"+idSuffix);
	            this.results.attr("id", "select2-results-"+idSuffix);
	            this.search.attr("aria-owns", "select2-results-"+idSuffix);
	
	            // rewrite labels from original element to focusser
	            this.focusser.attr("id", "s2id_autogen"+idSuffix);
	
	            elementLabel = $("label[for='" + this.opts.element.attr("id") + "']");
	            this.opts.element.on('focus.select2', this.bind(function () { this.focus(); }));
	
	            this.focusser.prev()
	                .text(elementLabel.text())
	                .attr('for', this.focusser.attr('id'));
	
	            // Ensure the original element retains an accessible name
	            var originalTitle = this.opts.element.attr("title");
	            this.opts.element.attr("title", (originalTitle || elementLabel.text()));
	
	            this.focusser.attr("tabindex", this.elementTabIndex);
	
	            // write label for search field using the label from the focusser element
	            this.search.attr("id", this.focusser.attr('id') + '_search');
	
	            this.search.prev()
	                .text($("label[for='" + this.focusser.attr('id') + "']").text())
	                .attr('for', this.search.attr('id'));
	
	            this.search.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	
	                // filter 229 keyCodes (input method editor is processing key input)
	                if (229 == e.keyCode) return;
	
	                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
	                    // prevent the page from scrolling
	                    killEvent(e);
	                    return;
	                }
	
	                switch (e.which) {
	                    case KEY.UP:
	                    case KEY.DOWN:
	                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
	                        killEvent(e);
	                        return;
	                    case KEY.ENTER:
	                        this.selectHighlighted();
	                        killEvent(e);
	                        return;
	                    case KEY.TAB:
	                        this.selectHighlighted({noFocus: true});
	                        return;
	                    case KEY.ESC:
	                        this.cancel(e);
	                        killEvent(e);
	                        return;
	                }
	            }));
	
	            this.search.on("blur", this.bind(function(e) {
	                // a workaround for chrome to keep the search field focussed when the scroll bar is used to scroll the dropdown.
	                // without this the search field loses focus which is annoying
	                if (document.activeElement === this.body.get(0)) {
	                    window.setTimeout(this.bind(function() {
	                        if (this.opened() && this.results && this.results.length > 1) {
	                            this.search.focus();
	                        }
	                    }), 0);
	                }
	            }));
	
	            this.focusser.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	
	                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	                    return;
	                }
	
	                if (this.opts.openOnEnter === false && e.which === KEY.ENTER) {
	                    killEvent(e);
	                    return;
	                }
	
	                if (e.which == KEY.DOWN || e.which == KEY.UP
	                    || (e.which == KEY.ENTER && this.opts.openOnEnter)) {
	
	                    if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;
	
	                    this.open();
	                    killEvent(e);
	                    return;
	                }
	
	                if (e.which == KEY.DELETE || e.which == KEY.BACKSPACE) {
	                    if (this.opts.allowClear) {
	                        this.clear();
	                    }
	                    killEvent(e);
	                    return;
	                }
	            }));
	
	
	            installKeyUpChangeEvent(this.focusser);
	            this.focusser.on("keyup-change input", this.bind(function(e) {
	                if (this.opts.minimumResultsForSearch >= 0) {
	                    e.stopPropagation();
	                    if (this.opened()) return;
	                    this.open();
	                }
	            }));
	
	            selection.on("mousedown touchstart", "abbr", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) {
	                    return;
	                }
	
	                this.clear();
	                killEventImmediately(e);
	                this.close();
	
	                if (this.selection) {
	                    this.selection.focus();
	                }
	            }));
	
	            selection.on("mousedown touchstart", this.bind(function (e) {
	                // Prevent IE from generating a click event on the body
	                reinsertElement(selection);
	
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	
	                if (this.opened()) {
	                    this.close();
	                } else if (this.isInterfaceEnabled()) {
	                    this.open();
	                }
	
	                killEvent(e);
	            }));
	
	            dropdown.on("mousedown touchstart", this.bind(function() {
	                if (this.opts.shouldFocusInput(this)) {
	                    this.search.focus();
	                }
	            }));
	
	            selection.on("focus", this.bind(function(e) {
	                killEvent(e);
	            }));
	
	            this.focusser.on("focus", this.bind(function(){
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	            })).on("blur", this.bind(function() {
	                if (!this.opened()) {
	                    this.container.removeClass("select2-container-active");
	                    this.opts.element.trigger($.Event("select2-blur"));
	                }
	            }));
	            this.search.on("focus", this.bind(function(){
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	            }));
	
	            this.initContainerWidth();
	            this.opts.element.hide();
	            this.setPlaceholder();
	
	        },
	
	        // single
	        clear: function(triggerChange) {
	            var data=this.selection.data("select2-data");
	            if (data) { // guard against queued quick consecutive clicks
	                var evt = $.Event("select2-clearing");
	                this.opts.element.trigger(evt);
	                if (evt.isDefaultPrevented()) {
	                    return;
	                }
	                var placeholderOption = this.getPlaceholderOption();
	                this.opts.element.val(placeholderOption ? placeholderOption.val() : "");
	                this.selection.find(".select2-chosen").empty();
	                this.selection.removeData("select2-data");
	                this.setPlaceholder();
	
	                if (triggerChange !== false){
	                    this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
	                    this.triggerChange({removed:data});
	                }
	            }
	        },
	
	        /**
	         * Sets selection based on source element's value
	         */
	        // single
	        initSelection: function () {
	            var selected;
	            if (this.isPlaceholderOptionSelected()) {
	                this.updateSelection(null);
	                this.close();
	                this.setPlaceholder();
	            } else {
	                var self = this;
	                this.opts.initSelection.call(null, this.opts.element, function(selected){
	                    if (selected !== undefined && selected !== null) {
	                        self.updateSelection(selected);
	                        self.close();
	                        self.setPlaceholder();
	                        self.lastSearchTerm = self.search.val();
	                    }
	                });
	            }
	        },
	
	        isPlaceholderOptionSelected: function() {
	            var placeholderOption;
	            if (this.getPlaceholder() === undefined) return false; // no placeholder specified so no option should be considered
	            return ((placeholderOption = this.getPlaceholderOption()) !== undefined && placeholderOption.prop("selected"))
	                || (this.opts.element.val() === "")
	                || (this.opts.element.val() === undefined)
	                || (this.opts.element.val() === null);
	        },
	
	        // single
	        prepareOpts: function () {
	            var opts = this.parent.prepareOpts.apply(this, arguments),
	                self=this;
	
	            if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                // install the selection initializer
	                opts.initSelection = function (element, callback) {
	                    var selected = element.find("option").filter(function() { return this.selected && !this.disabled });
	                    // a single select box always has a value, no need to null check 'selected'
	                    callback(self.optionToData(selected));
	                };
	            } else if ("data" in opts) {
	                // install default initSelection when applied to hidden input and data is local
	                opts.initSelection = opts.initSelection || function (element, callback) {
	                    var id = element.val();
	                    //search in data by id, storing the actual matching item
	                    var match = null;
	                    opts.query({
	                        matcher: function(term, text, el){
	                            var is_match = equal(id, opts.id(el));
	                            if (is_match) {
	                                match = el;
	                            }
	                            return is_match;
	                        },
	                        callback: !$.isFunction(callback) ? $.noop : function() {
	                            callback(match);
	                        }
	                    });
	                };
	            }
	
	            return opts;
	        },
	
	        // single
	        getPlaceholder: function() {
	            // if a placeholder is specified on a single select without a valid placeholder option ignore it
	            if (this.select) {
	                if (this.getPlaceholderOption() === undefined) {
	                    return undefined;
	                }
	            }
	
	            return this.parent.getPlaceholder.apply(this, arguments);
	        },
	
	        // single
	        setPlaceholder: function () {
	            var placeholder = this.getPlaceholder();
	
	            if (this.isPlaceholderOptionSelected() && placeholder !== undefined) {
	
	                // check for a placeholder option if attached to a select
	                if (this.select && this.getPlaceholderOption() === undefined) return;
	
	                this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(placeholder));
	
	                this.selection.addClass("select2-default");
	
	                this.container.removeClass("select2-allowclear");
	            }
	        },
	
	        // single
	        postprocessResults: function (data, initial, noHighlightUpdate) {
	            var selected = 0, self = this, showSearchInput = true;
	
	            // find the selected element in the result list
	
	            this.findHighlightableChoices().each2(function (i, elm) {
	                if (equal(self.id(elm.data("select2-data")), self.opts.element.val())) {
	                    selected = i;
	                    return false;
	                }
	            });
	
	            // and highlight it
	            if (noHighlightUpdate !== false) {
	                if (initial === true && selected >= 0) {
	                    this.highlight(selected);
	                } else {
	                    this.highlight(0);
	                }
	            }
	
	            // hide the search box if this is the first we got the results and there are enough of them for search
	
	            if (initial === true) {
	                var min = this.opts.minimumResultsForSearch;
	                if (min >= 0) {
	                    this.showSearch(countResults(data.results) >= min);
	                }
	            }
	        },
	
	        // single
	        showSearch: function(showSearchInput) {
	            if (this.showSearchInput === showSearchInput) return;
	
	            this.showSearchInput = showSearchInput;
	
	            this.dropdown.find(".select2-search").toggleClass("select2-search-hidden", !showSearchInput);
	            this.dropdown.find(".select2-search").toggleClass("select2-offscreen", !showSearchInput);
	            //add "select2-with-searchbox" to the container if search box is shown
	            $(this.dropdown, this.container).toggleClass("select2-with-searchbox", showSearchInput);
	        },
	
	        // single
	        onSelect: function (data, options) {
	
	            if (!this.triggerSelect(data)) { return; }
	
	            var old = this.opts.element.val(),
	                oldData = this.data();
	
	            this.opts.element.val(this.id(data));
	            this.updateSelection(data);
	
	            this.opts.element.trigger({ type: "select2-selected", val: this.id(data), choice: data });
	
	            this.lastSearchTerm = this.search.val();
	            this.close();
	
	            if ((!options || !options.noFocus) && this.opts.shouldFocusInput(this)) {
	                this.focusser.focus();
	            }
	
	            if (!equal(old, this.id(data))) {
	                this.triggerChange({ added: data, removed: oldData });
	            }
	        },
	
	        // single
	        updateSelection: function (data) {
	
	            var container=this.selection.find(".select2-chosen"), formatted, cssClass;
	
	            this.selection.data("select2-data", data);
	
	            container.empty();
	            if (data !== null) {
	                formatted=this.opts.formatSelection(data, container, this.opts.escapeMarkup);
	            }
	            if (formatted !== undefined) {
	                container.append(formatted);
	            }
	            cssClass=this.opts.formatSelectionCssClass(data, container);
	            if (cssClass !== undefined) {
	                container.addClass(cssClass);
	            }
	
	            this.selection.removeClass("select2-default");
	
	            if (this.opts.allowClear && this.getPlaceholder() !== undefined) {
	                this.container.addClass("select2-allowclear");
	            }
	        },
	
	        // single
	        val: function () {
	            var val,
	                triggerChange = false,
	                data = null,
	                self = this,
	                oldData = this.data();
	
	            if (arguments.length === 0) {
	                return this.opts.element.val();
	            }
	
	            val = arguments[0];
	
	            if (arguments.length > 1) {
	                triggerChange = arguments[1];
	
	                if (this.opts.debug && console && console.warn) {
	                    console.warn(
	                        'Select2: The second option to `select2("val")` is not supported in Select2 4.0.0. ' +
	                        'The `change` event will always be triggered in 4.0.0.'
	                    );
	                }
	            }
	
	            if (this.select) {
	                if (this.opts.debug && console && console.warn) {
	                    console.warn(
	                        'Select2: Setting the value on a <select> using `select2("val")` is no longer supported in 4.0.0. ' +
	                        'You can use the `.val(newValue).trigger("change")` method provided by jQuery instead.'
	                    );
	                }
	
	                this.select
	                    .val(val)
	                    .find("option").filter(function() { return this.selected }).each2(function (i, elm) {
	                        data = self.optionToData(elm);
	                        return false;
	                    });
	                this.updateSelection(data);
	                this.setPlaceholder();
	                if (triggerChange) {
	                    this.triggerChange({added: data, removed:oldData});
	                }
	            } else {
	                // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
	                if (!val && val !== 0) {
	                    this.clear(triggerChange);
	                    return;
	                }
	                if (this.opts.initSelection === undefined) {
	                    throw new Error("cannot call val() if initSelection() is not defined");
	                }
	                this.opts.element.val(val);
	                this.opts.initSelection(this.opts.element, function(data){
	                    self.opts.element.val(!data ? "" : self.id(data));
	                    self.updateSelection(data);
	                    self.setPlaceholder();
	                    if (triggerChange) {
	                        self.triggerChange({added: data, removed:oldData});
	                    }
	                });
	            }
	        },
	
	        // single
	        clearSearch: function () {
	            this.search.val("");
	            this.focusser.val("");
	        },
	
	        // single
	        data: function(value) {
	            var data,
	                triggerChange = false;
	
	            if (arguments.length === 0) {
	                data = this.selection.data("select2-data");
	                if (data == undefined) data = null;
	                return data;
	            } else {
	                if (this.opts.debug && console && console.warn) {
	                    console.warn(
	                        'Select2: The `select2("data")` method can no longer set selected values in 4.0.0, ' +
	                        'consider using the `.val()` method instead.'
	                    );
	                }
	
	                if (arguments.length > 1) {
	                    triggerChange = arguments[1];
	                }
	                if (!value) {
	                    this.clear(triggerChange);
	                } else {
	                    data = this.data();
	                    this.opts.element.val(!value ? "" : this.id(value));
	                    this.updateSelection(value);
	                    if (triggerChange) {
	                        this.triggerChange({added: value, removed:data});
	                    }
	                }
	            }
	        }
	    });
	
	    MultiSelect2 = clazz(AbstractSelect2, {
	
	        // multi
	        createContainer: function () {
	            var container = $(document.createElement("div")).attr({
	                "class": "select2-container select2-container-multi"
	            }).html([
	                "<ul class='select2-choices'>",
	                "  <li class='select2-search-field'>",
	                "    <label for='' class='select2-offscreen'></label>",
	                "    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>",
	                "  </li>",
	                "</ul>",
	                "<div class='select2-drop select2-drop-multi select2-display-none'>",
	                "   <ul class='select2-results'>",
	                "   </ul>",
	                "</div>"].join(""));
	            return container;
	        },
	
	        // multi
	        prepareOpts: function () {
	            var opts = this.parent.prepareOpts.apply(this, arguments),
	                self=this;
	
	            // TODO validate placeholder is a string if specified
	            if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                // install the selection initializer
	                opts.initSelection = function (element, callback) {
	
	                    var data = [];
	
	                    element.find("option").filter(function() { return this.selected && !this.disabled }).each2(function (i, elm) {
	                        data.push(self.optionToData(elm));
	                    });
	                    callback(data);
	                };
	            } else if ("data" in opts) {
	                // install default initSelection when applied to hidden input and data is local
	                opts.initSelection = opts.initSelection || function (element, callback) {
	                    var ids = splitVal(element.val(), opts.separator, opts.transformVal);
	                    //search in data by array of ids, storing matching items in a list
	                    var matches = [];
	                    opts.query({
	                        matcher: function(term, text, el){
	                            var is_match = $.grep(ids, function(id) {
	                                return equal(id, opts.id(el));
	                            }).length;
	                            if (is_match) {
	                                matches.push(el);
	                            }
	                            return is_match;
	                        },
	                        callback: !$.isFunction(callback) ? $.noop : function() {
	                            // reorder matches based on the order they appear in the ids array because right now
	                            // they are in the order in which they appear in data array
	                            var ordered = [];
	                            for (var i = 0; i < ids.length; i++) {
	                                var id = ids[i];
	                                for (var j = 0; j < matches.length; j++) {
	                                    var match = matches[j];
	                                    if (equal(id, opts.id(match))) {
	                                        ordered.push(match);
	                                        matches.splice(j, 1);
	                                        break;
	                                    }
	                                }
	                            }
	                            callback(ordered);
	                        }
	                    });
	                };
	            }
	
	            return opts;
	        },
	
	        // multi
	        selectChoice: function (choice) {
	
	            var selected = this.container.find(".select2-search-choice-focus");
	            if (selected.length && choice && choice[0] == selected[0]) {
	
	            } else {
	                if (selected.length) {
	                    this.opts.element.trigger("choice-deselected", selected);
	                }
	                selected.removeClass("select2-search-choice-focus");
	                if (choice && choice.length) {
	                    this.close();
	                    choice.addClass("select2-search-choice-focus");
	                    this.opts.element.trigger("choice-selected", choice);
	                }
	            }
	        },
	
	        // multi
	        destroy: function() {
	            $("label[for='" + this.search.attr('id') + "']")
	                .attr('for', this.opts.element.attr("id"));
	            this.parent.destroy.apply(this, arguments);
	
	            cleanupJQueryElements.call(this,
	                "searchContainer",
	                "selection"
	            );
	        },
	
	        // multi
	        initContainer: function () {
	
	            var selector = ".select2-choices", selection;
	
	            this.searchContainer = this.container.find(".select2-search-field");
	            this.selection = selection = this.container.find(selector);
	
	            var _this = this;
	            this.selection.on("click", ".select2-container:not(.select2-container-disabled) .select2-search-choice:not(.select2-locked)", function (e) {
	                _this.search[0].focus();
	                _this.selectChoice($(this));
	            });
	
	            // rewrite labels from original element to focusser
	            this.search.attr("id", "s2id_autogen"+nextUid());
	
	            this.search.prev()
	                .text($("label[for='" + this.opts.element.attr("id") + "']").text())
	                .attr('for', this.search.attr('id'));
	            this.opts.element.on('focus.select2', this.bind(function () { this.focus(); }));
	
	            this.search.on("input paste", this.bind(function() {
	                if (this.search.attr('placeholder') && this.search.val().length == 0) return;
	                if (!this.isInterfaceEnabled()) return;
	                if (!this.opened()) {
	                    this.open();
	                }
	            }));
	
	            this.search.attr("tabindex", this.elementTabIndex);
	
	            this.keydowns = 0;
	            this.search.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	
	                ++this.keydowns;
	                var selected = selection.find(".select2-search-choice-focus");
	                var prev = selected.prev(".select2-search-choice:not(.select2-locked)");
	                var next = selected.next(".select2-search-choice:not(.select2-locked)");
	                var pos = getCursorInfo(this.search);
	
	                if (selected.length &&
	                    (e.which == KEY.LEFT || e.which == KEY.RIGHT || e.which == KEY.BACKSPACE || e.which == KEY.DELETE || e.which == KEY.ENTER)) {
	                    var selectedChoice = selected;
	                    if (e.which == KEY.LEFT && prev.length) {
	                        selectedChoice = prev;
	                    }
	                    else if (e.which == KEY.RIGHT) {
	                        selectedChoice = next.length ? next : null;
	                    }
	                    else if (e.which === KEY.BACKSPACE) {
	                        if (this.unselect(selected.first())) {
	                            this.search.width(10);
	                            selectedChoice = prev.length ? prev : next;
	                        }
	                    } else if (e.which == KEY.DELETE) {
	                        if (this.unselect(selected.first())) {
	                            this.search.width(10);
	                            selectedChoice = next.length ? next : null;
	                        }
	                    } else if (e.which == KEY.ENTER) {
	                        selectedChoice = null;
	                    }
	
	                    this.selectChoice(selectedChoice);
	                    killEvent(e);
	                    if (!selectedChoice || !selectedChoice.length) {
	                        this.open();
	                    }
	                    return;
	                } else if (((e.which === KEY.BACKSPACE && this.keydowns == 1)
	                    || e.which == KEY.LEFT) && (pos.offset == 0 && !pos.length)) {
	
	                    this.selectChoice(selection.find(".select2-search-choice:not(.select2-locked)").last());
	                    killEvent(e);
	                    return;
	                } else {
	                    this.selectChoice(null);
	                }
	
	                if (this.opened()) {
	                    switch (e.which) {
	                    case KEY.UP:
	                    case KEY.DOWN:
	                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
	                        killEvent(e);
	                        return;
	                    case KEY.ENTER:
	                        this.selectHighlighted();
	                        killEvent(e);
	                        return;
	                    case KEY.TAB:
	                        this.selectHighlighted({noFocus:true});
	                        this.close();
	                        return;
	                    case KEY.ESC:
	                        this.cancel(e);
	                        killEvent(e);
	                        return;
	                    }
	                }
	
	                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e)
	                 || e.which === KEY.BACKSPACE || e.which === KEY.ESC) {
	                    return;
	                }
	
	                if (e.which === KEY.ENTER) {
	                    if (this.opts.openOnEnter === false) {
	                        return;
	                    } else if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
	                        return;
	                    }
	                }
	
	                this.open();
	
	                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
	                    // prevent the page from scrolling
	                    killEvent(e);
	                }
	
	                if (e.which === KEY.ENTER) {
	                    // prevent form from being submitted
	                    killEvent(e);
	                }
	
	            }));
	
	            this.search.on("keyup", this.bind(function (e) {
	                this.keydowns = 0;
	                this.resizeSearch();
	            })
	            );
	
	            this.search.on("blur", this.bind(function(e) {
	                this.container.removeClass("select2-container-active");
	                this.search.removeClass("select2-focused");
	                this.selectChoice(null);
	                if (!this.opened()) this.clearSearch();
	                e.stopImmediatePropagation();
	                this.opts.element.trigger($.Event("select2-blur"));
	            }));
	
	            this.container.on("click", selector, this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	                if ($(e.target).closest(".select2-search-choice").length > 0) {
	                    // clicked inside a select2 search choice, do not open
	                    return;
	                }
	                this.selectChoice(null);
	                this.clearPlaceholder();
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.open();
	                this.focusSearch();
	                e.preventDefault();
	            }));
	
	            this.container.on("focus", selector, this.bind(function () {
	                if (!this.isInterfaceEnabled()) return;
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	                this.dropdown.addClass("select2-drop-active");
	                this.clearPlaceholder();
	            }));
	
	            this.initContainerWidth();
	            this.opts.element.hide();
	
	            // set the placeholder if necessary
	            this.clearSearch();
	        },
	
	        // multi
	        enableInterface: function() {
	            if (this.parent.enableInterface.apply(this, arguments)) {
	                this.search.prop("disabled", !this.isInterfaceEnabled());
	            }
	        },
	
	        // multi
	        initSelection: function () {
	            var data;
	            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
	                this.updateSelection([]);
	                this.close();
	                // set the placeholder if necessary
	                this.clearSearch();
	            }
	            if (this.select || this.opts.element.val() !== "") {
	                var self = this;
	                this.opts.initSelection.call(null, this.opts.element, function(data){
	                    if (data !== undefined && data !== null) {
	                        self.updateSelection(data);
	                        self.close();
	                        // set the placeholder if necessary
	                        self.clearSearch();
	                    }
	                });
	            }
	        },
	
	        // multi
	        clearSearch: function () {
	            var placeholder = this.getPlaceholder(),
	                maxWidth = this.getMaxSearchWidth();
	
	            if (placeholder !== undefined  && this.getVal().length === 0 && this.search.hasClass("select2-focused") === false) {
	                this.search.val(placeholder).addClass("select2-default");
	                // stretch the search box to full width of the container so as much of the placeholder is visible as possible
	                // we could call this.resizeSearch(), but we do not because that requires a sizer and we do not want to create one so early because of a firefox bug, see #944
	                this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
	            } else {
	                this.search.val("").width(10);
	            }
	        },
	
	        // multi
	        clearPlaceholder: function () {
	            if (this.search.hasClass("select2-default")) {
	                this.search.val("").removeClass("select2-default");
	            }
	        },
	
	        // multi
	        opening: function () {
	            this.clearPlaceholder(); // should be done before super so placeholder is not used to search
	            this.resizeSearch();
	
	            this.parent.opening.apply(this, arguments);
	
	            this.focusSearch();
	
	            this.prefillNextSearchTerm();
	            this.updateResults(true);
	
	            if (this.opts.shouldFocusInput(this)) {
	                this.search.focus();
	            }
	            this.opts.element.trigger($.Event("select2-open"));
	        },
	
	        // multi
	        close: function () {
	            if (!this.opened()) return;
	            this.parent.close.apply(this, arguments);
	        },
	
	        // multi
	        focus: function () {
	            this.close();
	            this.search.focus();
	        },
	
	        // multi
	        isFocused: function () {
	            return this.search.hasClass("select2-focused");
	        },
	
	        // multi
	        updateSelection: function (data) {
	            var ids = {}, filtered = [], self = this;
	
	            // filter out duplicates
	            $(data).each(function () {
	                if (!(self.id(this) in ids)) {
	                    ids[self.id(this)] = 0;
	                    filtered.push(this);
	                }
	            });
	
	            this.selection.find(".select2-search-choice").remove();
	            this.addSelectedChoice(filtered);
	            self.postprocessResults();
	        },
	
	        // multi
	        tokenize: function() {
	            var input = this.search.val();
	            input = this.opts.tokenizer.call(this, input, this.data(), this.bind(this.onSelect), this.opts);
	            if (input != null && input != undefined) {
	                this.search.val(input);
	                if (input.length > 0) {
	                    this.open();
	                }
	            }
	
	        },
	
	        // multi
	        onSelect: function (data, options) {
	
	            if (!this.triggerSelect(data) || data.text === "") { return; }
	
	            this.addSelectedChoice(data);
	
	            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });
	
	            // keep track of the search's value before it gets cleared
	            this.lastSearchTerm = this.search.val();
	
	            this.clearSearch();
	            this.updateResults();
	
	            if (this.select || !this.opts.closeOnSelect) this.postprocessResults(data, false, this.opts.closeOnSelect===true);
	
	            if (this.opts.closeOnSelect) {
	                this.close();
	                this.search.width(10);
	            } else {
	                if (this.countSelectableResults()>0) {
	                    this.search.width(10);
	                    this.resizeSearch();
	                    if (this.getMaximumSelectionSize() > 0 && this.val().length >= this.getMaximumSelectionSize()) {
	                        // if we reached max selection size repaint the results so choices
	                        // are replaced with the max selection reached message
	                        this.updateResults(true);
	                    } else {
	                        // initializes search's value with nextSearchTerm and update search result
	                        if (this.prefillNextSearchTerm()) {
	                            this.updateResults();
	                        }
	                    }
	                    this.positionDropdown();
	                } else {
	                    // if nothing left to select close
	                    this.close();
	                    this.search.width(10);
	                }
	            }
	
	            // since its not possible to select an element that has already been
	            // added we do not need to check if this is a new element before firing change
	            this.triggerChange({ added: data });
	
	            if (!options || !options.noFocus)
	                this.focusSearch();
	        },
	
	        // multi
	        cancel: function () {
	            this.close();
	            this.focusSearch();
	        },
	
	        addSelectedChoice: function (data) {
	            var val = this.getVal(), self = this;
	            $(data).each(function () {
	                val.push(self.createChoice(this));
	            });
	            this.setVal(val);
	        },
	
	        createChoice: function (data) {
	            var enableChoice = !data.locked,
	                enabledItem = $(
	                    "<li class='select2-search-choice'>" +
	                    "    <div></div>" +
	                    "    <a href='#' class='select2-search-choice-close' tabindex='-1'></a>" +
	                    "</li>"),
	                disabledItem = $(
	                    "<li class='select2-search-choice select2-locked'>" +
	                    "<div></div>" +
	                    "</li>");
	            var choice = enableChoice ? enabledItem : disabledItem,
	                id = this.id(data),
	                formatted,
	                cssClass;
	
	            formatted=this.opts.formatSelection(data, choice.find("div"), this.opts.escapeMarkup);
	            if (formatted != undefined) {
	                choice.find("div").replaceWith($("<div></div>").html(formatted));
	            }
	            cssClass=this.opts.formatSelectionCssClass(data, choice.find("div"));
	            if (cssClass != undefined) {
	                choice.addClass(cssClass);
	            }
	
	            if(enableChoice){
	              choice.find(".select2-search-choice-close")
	                  .on("mousedown", killEvent)
	                  .on("click dblclick", this.bind(function (e) {
	                  if (!this.isInterfaceEnabled()) return;
	
	                  this.unselect($(e.target));
	                  this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	                  killEvent(e);
	                  this.close();
	                  this.focusSearch();
	              })).on("focus", this.bind(function () {
	                  if (!this.isInterfaceEnabled()) return;
	                  this.container.addClass("select2-container-active");
	                  this.dropdown.addClass("select2-drop-active");
	              }));
	            }
	
	            choice.data("select2-data", data);
	            choice.insertBefore(this.searchContainer);
	
	            return id;
	        },
	
	        // multi
	        unselect: function (selected) {
	            var val = this.getVal(),
	                data,
	                index;
	            selected = selected.closest(".select2-search-choice");
	
	            if (selected.length === 0) {
	                throw "Invalid argument: " + selected + ". Must be .select2-search-choice";
	            }
	
	            data = selected.data("select2-data");
	
	            if (!data) {
	                // prevent a race condition when the 'x' is clicked really fast repeatedly the event can be queued
	                // and invoked on an element already removed
	                return;
	            }
	
	            var evt = $.Event("select2-removing");
	            evt.val = this.id(data);
	            evt.choice = data;
	            this.opts.element.trigger(evt);
	
	            if (evt.isDefaultPrevented()) {
	                return false;
	            }
	
	            while((index = indexOf(this.id(data), val)) >= 0) {
	                val.splice(index, 1);
	                this.setVal(val);
	                if (this.select) this.postprocessResults();
	            }
	
	            selected.remove();
	
	            this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
	            this.triggerChange({ removed: data });
	
	            return true;
	        },
	
	        // multi
	        postprocessResults: function (data, initial, noHighlightUpdate) {
	            var val = this.getVal(),
	                choices = this.results.find(".select2-result"),
	                compound = this.results.find(".select2-result-with-children"),
	                self = this;
	
	            choices.each2(function (i, choice) {
	                var id = self.id(choice.data("select2-data"));
	                if (indexOf(id, val) >= 0) {
	                    choice.addClass("select2-selected");
	                    // mark all children of the selected parent as selected
	                    choice.find(".select2-result-selectable").addClass("select2-selected");
	                }
	            });
	
	            compound.each2(function(i, choice) {
	                // hide an optgroup if it doesn't have any selectable children
	                if (!choice.is('.select2-result-selectable')
	                    && choice.find(".select2-result-selectable:not(.select2-selected)").length === 0) {
	                    choice.addClass("select2-selected");
	                }
	            });
	
	            if (this.highlight() == -1 && noHighlightUpdate !== false && this.opts.closeOnSelect === true){
	                self.highlight(0);
	            }
	
	            //If all results are chosen render formatNoMatches
	            if(!this.opts.createSearchChoice && !choices.filter('.select2-result:not(.select2-selected)').length > 0){
	                if(!data || data && !data.more && this.results.find(".select2-no-results").length === 0) {
	                    if (checkFormatter(self.opts.formatNoMatches, "formatNoMatches")) {
	                        this.results.append("<li class='select2-no-results'>" + evaluate(self.opts.formatNoMatches, self.opts.element, self.search.val()) + "</li>");
	                    }
	                }
	            }
	
	        },
	
	        // multi
	        getMaxSearchWidth: function() {
	            return this.selection.width() - getSideBorderPadding(this.search);
	        },
	
	        // multi
	        resizeSearch: function () {
	            var minimumWidth, left, maxWidth, containerLeft, searchWidth,
	                sideBorderPadding = getSideBorderPadding(this.search);
	
	            minimumWidth = measureTextWidth(this.search) + 10;
	
	            left = this.search.offset().left;
	
	            maxWidth = this.selection.width();
	            containerLeft = this.selection.offset().left;
	
	            searchWidth = maxWidth - (left - containerLeft) - sideBorderPadding;
	
	            if (searchWidth < minimumWidth) {
	                searchWidth = maxWidth - sideBorderPadding;
	            }
	
	            if (searchWidth < 40) {
	                searchWidth = maxWidth - sideBorderPadding;
	            }
	
	            if (searchWidth <= 0) {
	              searchWidth = minimumWidth;
	            }
	
	            this.search.width(Math.floor(searchWidth));
	        },
	
	        // multi
	        getVal: function () {
	            var val;
	            if (this.select) {
	                val = this.select.val();
	                return val === null ? [] : val;
	            } else {
	                val = this.opts.element.val();
	                return splitVal(val, this.opts.separator, this.opts.transformVal);
	            }
	        },
	
	        // multi
	        setVal: function (val) {
	            if (this.select) {
	                this.select.val(val);
	            } else {
	                var unique = [], valMap = {};
	                // filter out duplicates
	                $(val).each(function () {
	                    if (!(this in valMap)) {
	                        unique.push(this);
	                        valMap[this] = 0;
	                    }
	                });
	                this.opts.element.val(unique.length === 0 ? "" : unique.join(this.opts.separator));
	            }
	        },
	
	        // multi
	        buildChangeDetails: function (old, current) {
	            var current = current.slice(0),
	                old = old.slice(0);
	
	            // remove intersection from each array
	            for (var i = 0; i < current.length; i++) {
	                for (var j = 0; j < old.length; j++) {
	                    if (equal(this.opts.id(current[i]), this.opts.id(old[j]))) {
	                        current.splice(i, 1);
	                        i--;
	                        old.splice(j, 1);
	                        break;
	                    }
	                }
	            }
	
	            return {added: current, removed: old};
	        },
	
	
	        // multi
	        val: function (val, triggerChange) {
	            var oldData, self=this;
	
	            if (arguments.length === 0) {
	                return this.getVal();
	            }
	
	            oldData=this.data();
	            if (!oldData.length) oldData=[];
	
	            // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
	            if (!val && val !== 0) {
	                this.opts.element.val("");
	                this.updateSelection([]);
	                this.clearSearch();
	                if (triggerChange) {
	                    this.triggerChange({added: this.data(), removed: oldData});
	                }
	                return;
	            }
	
	            // val is a list of ids
	            this.setVal(val);
	
	            if (this.select) {
	                this.opts.initSelection(this.select, this.bind(this.updateSelection));
	                if (triggerChange) {
	                    this.triggerChange(this.buildChangeDetails(oldData, this.data()));
	                }
	            } else {
	                if (this.opts.initSelection === undefined) {
	                    throw new Error("val() cannot be called if initSelection() is not defined");
	                }
	
	                this.opts.initSelection(this.opts.element, function(data){
	                    var ids=$.map(data, self.id);
	                    self.setVal(ids);
	                    self.updateSelection(data);
	                    self.clearSearch();
	                    if (triggerChange) {
	                        self.triggerChange(self.buildChangeDetails(oldData, self.data()));
	                    }
	                });
	            }
	            this.clearSearch();
	        },
	
	        // multi
	        onSortStart: function() {
	            if (this.select) {
	                throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");
	            }
	
	            // collapse search field into 0 width so its container can be collapsed as well
	            this.search.width(0);
	            // hide the container
	            this.searchContainer.hide();
	        },
	
	        // multi
	        onSortEnd:function() {
	
	            var val=[], self=this;
	
	            // show search and move it to the end of the list
	            this.searchContainer.show();
	            // make sure the search container is the last item in the list
	            this.searchContainer.appendTo(this.searchContainer.parent());
	            // since we collapsed the width in dragStarted, we resize it here
	            this.resizeSearch();
	
	            // update selection
	            this.selection.find(".select2-search-choice").each(function() {
	                val.push(self.opts.id($(this).data("select2-data")));
	            });
	            this.setVal(val);
	            this.triggerChange();
	        },
	
	        // multi
	        data: function(values, triggerChange) {
	            var self=this, ids, old;
	            if (arguments.length === 0) {
	                 return this.selection
	                     .children(".select2-search-choice")
	                     .map(function() { return $(this).data("select2-data"); })
	                     .get();
	            } else {
	                old = this.data();
	                if (!values) { values = []; }
	                ids = $.map(values, function(e) { return self.opts.id(e); });
	                this.setVal(ids);
	                this.updateSelection(values);
	                this.clearSearch();
	                if (triggerChange) {
	                    this.triggerChange(this.buildChangeDetails(old, this.data()));
	                }
	            }
	        }
	    });
	
	    $.fn.select2 = function () {
	
	        var args = Array.prototype.slice.call(arguments, 0),
	            opts,
	            select2,
	            method, value, multiple,
	            allowedMethods = ["val", "destroy", "opened", "open", "close", "focus", "isFocused", "container", "dropdown", "onSortStart", "onSortEnd", "enable", "disable", "readonly", "positionDropdown", "data", "search"],
	            valueMethods = ["opened", "isFocused", "container", "dropdown"],
	            propertyMethods = ["val", "data"],
	            methodsMap = { search: "externalSearch" };
	
	        this.each(function () {
	            if (args.length === 0 || typeof(args[0]) === "object") {
	                opts = args.length === 0 ? {} : $.extend({}, args[0]);
	                opts.element = $(this);
	
	                if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                    multiple = opts.element.prop("multiple");
	                } else {
	                    multiple = opts.multiple || false;
	                    if ("tags" in opts) {opts.multiple = multiple = true;}
	                }
	
	                select2 = multiple ? new window.Select2["class"].multi() : new window.Select2["class"].single();
	                select2.init(opts);
	            } else if (typeof(args[0]) === "string") {
	
	                if (indexOf(args[0], allowedMethods) < 0) {
	                    throw "Unknown method: " + args[0];
	                }
	
	                value = undefined;
	                select2 = $(this).data("select2");
	                if (select2 === undefined) return;
	
	                method=args[0];
	
	                if (method === "container") {
	                    value = select2.container;
	                } else if (method === "dropdown") {
	                    value = select2.dropdown;
	                } else {
	                    if (methodsMap[method]) method = methodsMap[method];
	
	                    value = select2[method].apply(select2, args.slice(1));
	                }
	                if (indexOf(args[0], valueMethods) >= 0
	                    || (indexOf(args[0], propertyMethods) >= 0 && args.length == 1)) {
	                    return false; // abort the iteration, ready to return first matched value
	                }
	            } else {
	                throw "Invalid arguments to select2 plugin: " + args;
	            }
	        });
	        return (value === undefined) ? this : value;
	    };
	
	    // plugin defaults, accessible to users
	    $.fn.select2.defaults = {
	        debug: false,
	        width: "copy",
	        loadMorePadding: 0,
	        closeOnSelect: true,
	        openOnEnter: true,
	        containerCss: {},
	        dropdownCss: {},
	        containerCssClass: "",
	        dropdownCssClass: "",
	        formatResult: function(result, container, query, escapeMarkup) {
	            var markup=[];
	            markMatch(this.text(result), query.term, markup, escapeMarkup);
	            return markup.join("");
	        },
	        transformVal: function(val) {
	            return $.trim(val);
	        },
	        formatSelection: function (data, container, escapeMarkup) {
	            return data ? escapeMarkup(this.text(data)) : undefined;
	        },
	        sortResults: function (results, container, query) {
	            return results;
	        },
	        formatResultCssClass: function(data) {return data.css;},
	        formatSelectionCssClass: function(data, container) {return undefined;},
	        minimumResultsForSearch: 0,
	        minimumInputLength: 0,
	        maximumInputLength: null,
	        maximumSelectionSize: 0,
	        id: function (e) { return e == undefined ? null : e.id; },
	        text: function (e) {
	          if (e && this.data && this.data.text) {
	            if ($.isFunction(this.data.text)) {
	              return this.data.text(e);
	            } else {
	              return e[this.data.text];
	            }
	          } else {
	            return e.text;
	          }
	        },
	        matcher: function(term, text) {
	            return stripDiacritics(''+text).toUpperCase().indexOf(stripDiacritics(''+term).toUpperCase()) >= 0;
	        },
	        separator: ",",
	        tokenSeparators: [],
	        tokenizer: defaultTokenizer,
	        escapeMarkup: defaultEscapeMarkup,
	        blurOnChange: false,
	        selectOnBlur: false,
	        adaptContainerCssClass: function(c) { return c; },
	        adaptDropdownCssClass: function(c) { return null; },
	        nextSearchTerm: function(selectedObject, currentSearchTerm) { return undefined; },
	        searchInputPlaceholder: '',
	        createSearchChoicePosition: 'top',
	        shouldFocusInput: function (instance) {
	            // Attempt to detect touch devices
	            var supportsTouchEvents = (('ontouchstart' in window) ||
	                                       (navigator.msMaxTouchPoints > 0));
	
	            // Only devices which support touch events should be special cased
	            if (!supportsTouchEvents) {
	                return true;
	            }
	
	            // Never focus the input if search is disabled
	            if (instance.opts.minimumResultsForSearch < 0) {
	                return false;
	            }
	
	            return true;
	        }
	    };
	
	    $.fn.select2.locales = [];
	
	    $.fn.select2.locales['en'] = {
	         formatMatches: function (matches) { if (matches === 1) { return "One result is available, press enter to select it."; } return matches + " results are available, use up and down arrow keys to navigate."; },
	         formatNoMatches: function () { return "No matches found"; },
	         formatAjaxError: function (jqXHR, textStatus, errorThrown) { return "Loading failed"; },
	         formatInputTooShort: function (input, min) { var n = min - input.length; return "Please enter " + n + " or more character" + (n == 1 ? "" : "s"); },
	         formatInputTooLong: function (input, max) { var n = input.length - max; return "Please delete " + n + " character" + (n == 1 ? "" : "s"); },
	         formatSelectionTooBig: function (limit) { return "You can only select " + limit + " item" + (limit == 1 ? "" : "s"); },
	         formatLoadMore: function (pageNumber) { return "Loading more results…"; },
	         formatSearching: function () { return "Searching…"; }
	    };
	
	    $.extend($.fn.select2.defaults, $.fn.select2.locales['en']);
	
	    $.fn.select2.ajaxDefaults = {
	        transport: $.ajax,
	        params: {
	            type: "GET",
	            cache: false,
	            dataType: "json"
	        }
	    };
	
	    // exports
	    window.Select2 = {
	        query: {
	            ajax: ajax,
	            local: local,
	            tags: tags
	        }, util: {
	            debounce: debounce,
	            markMatch: markMatch,
	            escapeMarkup: defaultEscapeMarkup,
	            stripDiacritics: stripDiacritics
	        }, "class": {
	            "abstract": AbstractSelect2,
	            "single": SingleSelect2,
	            "multi": MultiSelect2
	        }
	    };
	
	}(jQuery));
	
	}).call(global, module, undefined, undefined);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(19)(module)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser:true, todo: true */
	"use strict";
	
	var ko = __webpack_require__(9);
	var R = __webpack_require__(7);
	
	var pli = __webpack_require__(380);
	
	// load knockout binding as a side-effect
	__webpack_require__(407);
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "PicklistForm" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	/**
	 * Create a new instance of picklist form, upgrading the specified original picklist form.
	 *
	 * PicklistForm is a singleton, so this constructor will only be called once (during initial
	 * JavaScript parsing and execution). This also means that using PicklistForm.prototype in
	 * this constructor is ok.
	 *
	 * @param {Object} originalForm
	 *      The picklist form registered in pli.forms.registry
	 */
	function PicklistForm(originalForm) {
	    // validate original form
	    if (typeof originalForm !== "object") { throw new Error("Form picklistForm has not been registered in Pli.forms.registry (did you call CreatePicklistForm?)"); }
	    if (originalForm.type !== "PLI navigation form") { throw new Error("Form picklistForm has already been upgraded by PicklistForm.js"); }
	
	    // preserve original form's methods and properties
	    PicklistForm.prototype._originalOpen = originalForm.open;
	    PicklistForm.prototype._originalClose = originalForm.close;
	    ko.utils.extend(this, originalForm);
	    this.page.form = this; // re-link navigation page to this form (was pointing to "originalForm" before assignment)
	
	    // bind all prototype methods to this singleton instance
	    var k;
	    for (k in PicklistForm.prototype) {
	        if (PicklistForm.prototype.hasOwnProperty(k) && typeof PicklistForm.prototype[k] === "function" && k !== "constructor") {
	            PicklistForm.prototype[k] = PicklistForm.prototype[k].bind(this);
	        }
	    }
	
	    // initialize fields that will be populated during first "open"
	    this._currentFilterValue = null;
	    this._currentOptions = null;
	    this._isTyping = false;
	    this._viewModel = null;
	    this._savedFormState = null;
	    this._searchStreamSubscription = null;
	
	    // set container data binding
	    // must be done here because we are not able to provide
	    // this via the Razor file
	    var containerDataBind = this.$form.attr("data-bind");
	    this.$form.attr("data-bind", (containerDataBind ? containerDataBind + ", " : "") + "css: resolveContainerCssWithState()");
	}
	
	
	/**
	 * Open this picklist form and initialize the view model.
	 *
	 * @param {Object} options
	 *      Options to initialize the grid and form.
	 * @param {string} options.containerCss
	 *      Extra CSS that will be applied to the form container.
	 * @param {function} options.createItem
	 *      Callback function that will be called when the 'Create Item' button is pressed.
	 * @param {Object} options.$element
	 *      jQuery element to restore focus to after closing the form.
	 * @param {number} options.filterDebounceTimeout
	 *      Debounce time in milliseconds for filtered queries.
	 * @param {string} options.filterValue
	 *      Initial value for the filter input.
	 * @param {boolean} options.hideFilter
	 *      If true, will hide the filter input using CSS.
	 * @param {Boolean} options.multiSelect
	 *      Whether to put the form in multi-select mode (default: false).
	 * @param {Function} options.openSelectedItem
	 *      Callback function that will be called when the 'Open Item' button is pressed.
	 * @param {Function} options.previewInit
	 *      Function that returns a view model for the preview pane.
	 * @param {Object[]} options.selectedItems
	 *      Item(s) that represent the initial selection.
	 * @param {Boolean} options.skipOpen
	 *      Skip this forms open and use the default open.
	 * @param {Object} options.text
	 *      Overrides for texts and labels (see PicklistFormViewModel.prototype._textDefaults).
	 * @param {Function} options.value
	 *      Callback function that will receive the result when the form is accepted.
	 * @param {Object} options.view
	 *      (deprecated - define grid options as part of picklist data) Custom view to define the grid.
	 * @return {Object}
	 *      Instance of this picklist form.
	 */
	PicklistForm.prototype.open = function openPicklistForm(options) {
	    if (typeof options !== "object") { throw new Error("PicklistForm.open requires options"); }
	
	    var keymap = {
	        "ctrl+space": R.partial(this._performGridAction, ["select", false]),
	        "down": R.partial(this._performGridAction, ["movenext", false]),
	        "enter": this._accept,
	        "end": R.partial(this._performGridAction, ["moveend", false]),
	        "esc": this._cancel,
	        "home": R.partial(this._performGridAction, ["movehome", false]),
	        "pagedown": R.partial(this._performGridAction, ["pagedown", false]),
	        "pageup": R.partial(this._performGridAction, ["pageup", false]),
	        "shift+down": R.partial(this._performGridAction, ["selectnext", false]),
	        "shift+end": R.partial(this._performGridAction, ["selectend", false]),
	        "shift+home": R.partial(this._performGridAction, ["selecthome", false]),
	        "shift+up": R.partial(this._performGridAction, ["selectprevious", false]),
	        "shift+tab": null,
	        "space": R.partial(this._performGridAction, ["select", true]),
	        "tab": null,
	        "up": R.partial(this._performGridAction, ["moveprevious", false])
	    };
	
	    var optionsWithShortcuts = R.merge(options, {
	        // set every action to 'null' for the keys defined in keymap;
	        // this will prevent the default SlickGrid action and use the above keymap
	        shortcutActions: R.map(R.always(null), keymap)
	    });
	
	    // initialize keymap
	    // must be done before calling "_originalOpen" to ensure
	    // keymaps for child forms are deactivated in correct order
	    if (!this.keymap) {
	        this.keymap = this.page.keymap = this.id;
	        pli.keys.registerKeymap(this.keymap, keymap);
	    }
	
	    // reset viewmodel to use the specified options
	    // on first open, also create + bind viewmodel;
	    // Must be done before call to "_originalOpen"
	    // so that the containerCss is correct and Forms.js
	    // can properly position the newly opened form
	    if (this._viewModel) {
	        // save the current form state before resetting
	        // so that when "_originalOpen" calls "getFormState"
	        // it will get the form state for the currently
	        // opened picklist and not the newly opened one
	        // (re-entrancy)
	        this._savedFormState = this._getFormState();
	
	        this._viewModel.reset(optionsWithShortcuts);
	    } else {
	        // initialize viewmodel
	        this._viewModel = this.createViewModel(this._originalClose);
	        this._viewModel.reset(optionsWithShortcuts); // it is important to reset viewmodel before applying bindings so that all bound properties are fully defined
	
	        this._viewModel.filter.subscribe(this._onViewModelFilterChanged, this);
	
	        ko.applyBindings(this._viewModel, this.$form[0]); // knockout expects plain DOM element, unwrap jQuery array to get it
	    }
	
	    // show picklist form on screen (unless skipped)
	    // keep in mind that Forms.js open ("_originalOpen")
	    // will call "getFormState" if picklist form
	    // is already opened (re-entrancy);
	    // expects return from "getFormState" to be that
	    // of the current opened picklist form, not the
	    // new one that is being opened
	    if (!options.skipOpen) {
	        this._originalOpen();
	    }
	
	    // clear the saved form state
	    this._savedFormState = null;
	
	    // if options specifies an element associated
	    // with this picklist (i.e. an input control where
	    // accepted values will go), make sure it is focused
	    // before showing picklist form (it might not be
	    // focused when user clicks the picklist button
	    // instead of using the F3 keyboard shortcut);
	    // Forms.js will remember the focused element
	    // when opening form, and will restore focus
	    // to it when the form is closed
	    if (options.$element) {
	        options.$element.focus();
	    }
	
	    // remember options controlling grid behaviour
	    this._currentFilterValue = optionsWithShortcuts.filterValue || "";
	    this._currentOptions = optionsWithShortcuts;
	    this._isTyping = false;
	
	    if (this._searchStreamSubscription !== null) { this._searchStreamSubscription.unsubscribe(); }
	    this._searchStreamSubscription = this._viewModel.searchStream.subscribe(this._onNewSearchResult.bind(this));
	
	    return this;
	};
	
	
	/**
	 * Close the picklist form
	 * @return {Object}
	 *      Instance of Picklistform
	 */
	PicklistForm.prototype.close = function closePicklistForm() {
	    this._cancel();
	    return this;
	};
	
	
	/**
	 * Extract current state of picklist form (enables re-entrancy).
	 * Will be called by Forms.js when picklist form is opened
	 * as direct or indirect modal child of another picklist form.
	 * @return {Object}
	 *      The current state of the form
	 */
	PicklistForm.prototype.getFormState = function getPicklistFormState() {
	    // if the form state was saved in the call to open,
	    // restore from that save rather than creating new
	    // data
	    if (this._savedFormState) {
	        return this._savedFormState;
	    }
	
	    return this._getFormState();
	};
	
	
	/**
	 * Restore picklist form state to the specified value (enables re-entrancy).
	 * Will be called by Forms.js when a child picklist form is closed.
	 * @param {Object} formState
	 *      State to restore
	 */
	PicklistForm.prototype.loadFormState = function loadPicklistFormState(formState) {
	    if (formState) {
	        this.open(formState);
	        this.page.$focus = formState.$focus || null;
	        this.$form.css("left", formState.positionLeft);
	        this.$form.css("top", formState.positionTop);
	    }
	};
	
	
	/**
	 * Accept currently selected grid items.
	 * If no items are selected or no grid has been created, does nothing.
	 */
	PicklistForm.prototype._accept = function acceptPicklistSelection() {
	    this._cleanup();
	    return (this._viewModel ? this._viewModel.accept() : false);
	};
	
	
	/**
	 * Cancel this picklist form (close it).
	 */
	PicklistForm.prototype._cancel = function acceptPicklistSelection() {
	    this._cleanup();
	    return (this._viewModel ? this._viewModel.cancel() : false);
	};
	
	
	/**
	 * Dispose any subscriptions held by the picklist form.
	 */
	PicklistForm.prototype._cleanup = function disposePicklistFormSubscriptions() {
	    if (this._searchStreamSubscription !== null) {
	        this._searchStreamSubscription.unsubscribe();
	        this._searchStreamSubscription = null;
	    }
	};
	
	
	/**
	 * Extract current state of picklist form (enables re-entrancy).
	 * @return {Object}
	 *      The current state of the form
	 */
	PicklistForm.prototype._getFormState = function getPicklistFormState() {
	    if (!this._viewModel) { return null; }
	
	    var formState = R.merge({}, this._currentOptions);
	    formState.$element = null;
	    formState.$focus = this.page.$focus;
	    formState.filterValue = this._currentFilterValue;
	    formState.positionLeft = this.$form.css("left");
	    formState.positionTop = this.$form.css("top");
	    formState.selectedItems = this._viewModel.getSelectedRowsAsItems();
	    formState.skipOpen = true;
	
	    return formState;
	};
	
	
	/**
	 * React to "_viewModel.searchStream" change notifications.
	 */
	PicklistForm.prototype._onNewSearchResult = function onPicklistNewSearchResult(result) {
	    var filterValue = result.request;
	
	    // after the throttled timeout, we are no longer typing
	    this._isTyping = false;
	
	    if (filterValue !== this._currentFilterValue) {
	        this._currentFilterValue = filterValue;
	    }
	};
	
	
	/**
	 * React to "_viewModel.filter" change notifications.
	 */
	PicklistForm.prototype._onViewModelFilterChanged = function onPicklistFilterChanged() {
	    // before the throttled timeout, any change counts as 'typing'
	    this._isTyping = true;
	};
	
	
	/**
	 * Performs a named grid action.
	 * @param {string} action
	 *      Name of the action to perform.
	 * @param {boolean} checkIsTyping
	 *      If true, will check the state of _isTyping before performing the grid action.
	 */
	PicklistForm.prototype._performGridAction = function performPicklistGridAction(action, checkIsTyping) {
	    if (!this._viewModel.grid) {
	        return true;
	    }
	
	    // multiselect
	    if (this._viewModel.grid.options().multiSelect) {
	        if (!checkIsTyping || !this._isTyping) {
	            this._viewModel.grid.apply({ action: action });
	        }
	
	        // allow events to bubble if we think the user is typing
	        // this is necessary for 'space' key to produce a space character
	        return this._isTyping;
	    }
	
	    // single select
	    if (!checkIsTyping) { // always allow 'space' in single-select
	        this._viewModel.grid.apply({ action: action });
	    }
	    return checkIsTyping;
	};
	
	
	/**
	 * Uniquely identify this singleton instance.
	 * Useful during debugging and when checking dependencies.
	 * @type {String}
	 */
	PicklistForm.prototype.type = "Picklist form (PLI navigation form)";
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	/**
	 * Upgrades the registered picklist form (created by Forms.js) to a fully functional one.
	 *
	 * @param createViewModel
	 *     Picklist viewmodel initializer.
	 */
	function registerPicklistForm(createViewModel) {
	    if (typeof pli.forms.registry.picklistForm !== "object") {
	        throw new Error("Form \"picklistForm\" has not been registered in \"Pli.forms.registry\" (did you call \"CreatePicklistForm\" in Razor?)");
	    }
	
	    pli.forms.registry.picklistForm = new PicklistForm(pli.forms.registry.picklistForm);
	    pli.forms.registry.picklistForm.createViewModel = createViewModel;
	}
	
	module.exports = {
	    PicklistForm: PicklistForm,
	    registerPicklistForm: registerPicklistForm
	};
	


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	__webpack_require__(408);
	module.exports = __webpack_require__(414);
	


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser:true, unparam:true, todo: true */
	
	"use strict";
	
	var ko = __webpack_require__(9);
	var R = __webpack_require__(7);
	var RowSelectionModel = __webpack_require__(409);
	var SlickEventHandler = __webpack_require__(410).EventHandler;
	var SlickGrid = __webpack_require__(411);
	
	var keyMapUtil = __webpack_require__(382);
	var GridViewModel = __webpack_require__(414);
	var GroupSelectionPlugin = __webpack_require__(440);
	var util = __webpack_require__(422);
	
	var KeyMap = keyMapUtil.default;
	
	//-------------------------------------------
	// Convert a dictionary of string:string keys and values to lower case
	function dictionaryToLower(dict) {
	    return R.reduce(
	        function dictionaryEntryToLower(target, key) {
	            target[R.toLower(key)] = R.toLower(dict[key] || "") || null;
	            return target;
	        },
	        {}, // seed - target object
	        R.keys(dict) // collection to "reduce"
	    );
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// GridBinding
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Create a new instance of the grid controller.
	function GridController(element, value) {
	    this.viewModel = ko.unwrap(value);
	    if (!(this.viewModel instanceof GridViewModel)) { throw new Error("valueAccessor object must be a viewModel."); }
	
	    this.columns = [];
	    this.element = element;
	    this.options = {
	        autoHeight: false,
	        forceFitColumns: false,
	        multiSelect: false
	    };
	
	    this._gridHandlers = new SlickEventHandler();
	    this._slickGrid = null;
	
	    this._pushGridStateSubscription = this.viewModel._pushGridState.subscribe(this._pushGridStateHandler, this);
	    this._pushGridStateHandler(this.viewModel._pushGridState.peek());
	}
	
	
	//-------------------------------------------
	// Cleans up the grid controller binding removing
	// the state subscription and view-model.
	GridController.prototype.dispose = function gridControllerDispose() {
	    this._disposeGrid();
	    this._pushGridStateSubscription.dispose();
	
	    // Preserve current state to ensure this viewmodel can be re-bound
	    // to this (or another) grid with the proper state
	    this.viewModel._pushGridState({
	        columns: this.columns,
	        focusedRow: this.focusedRow,
	        options: this.options,
	        scrollTop: this.scrollTop,
	        selectedIds: this.selectedIds,
	        sortCols: this.sortCols
	    });
	    this.viewModel = null;
	};
	
	
	//-------------------------------------------
	// Combines the passed grid options with the
	// default set of options.
	GridController.prototype._combineDefaultOptionsWith = R.merge({
	    disableFocusSinkTab: false,
	    disableKeyHandler: true, // prevents slick grid from registering a key handler
	    explicitInitialization: true,
	    idField: "id",
	    multiColumnSort: true,
	    multiSelect: false,
	    renderColumnFilterIcon: false,
	    rowHeight: 30
	});
	
	//-------------------------------------------
	// Combines the passed grid options with the
	// default set of options.
	GridController.prototype._combineDefaultShortcutsWith = R.merge({
	    "ctrl+a": "selectall",
	    "down": "movenext",
	    "end": "moveend",
	    "enter": "default",
	    "home": "movehome",
	    "left": "togglegroup",
	    "numpad1": "moveend",
	    "numpad2": "movenext",
	    "numpad3": "pagedown",
	    "numpad8": "moveprevious",
	    "numpad7": "movehome",
	    "numpad9": "pageup",
	    "pagedown": "pagedown",
	    "pageup": "pageup",
	    "right": "togglegroup",
	    "space": "select",
	    "shift+down": "selectnext",
	    "shift+end": "selectend",
	    "shift+home": "selecthome",
	    "shift+numpad2": "selectnext",
	    "shift+numpad8": "selectprevious",
	    "shift+tab": "moveprevious",
	    "shift+up": "selectprevious",
	    "tab": "movenext",
	    "up": "moveprevious"
	});
	
	
	//-------------------------------------------
	// Disposes slick.grid instance cleaning up
	// plug-ins and event handlers initialized by
	// `_initGrid`
	GridController.prototype._disposeGrid = function gridControllerDisposeGrid() {
	    this._gridHandlers.unsubscribeAll();
	    if (this._slickGrid !== null) {
	        this._slickGrid.destroy();
	        this._slickGrid = null;
	    }
	    if (this._resizeHandler) {
	        if (typeof window.removeEventListener === "function") {
	            window.removeEventListener("resize", this._resizeHandler, false);
	        } else {
	            window.detachEvent("onresize", this._resizeHandler);
	        }
	        this._resizeHandler = null;
	    }
	    this.element.removeEventListener("keydown", this._keydownHandler);
	};
	
	
	//-------------------------------------------
	// Key that is used to store controller
	// object as a property of bound HTML element
	// (similar technique is used by built-in
	// Knockout bindings, they are using
	// "__ko__" prefix).
	GridController.prototype._elementKey = "__kopli__grid";
	
	
	//-------------------------------------------
	// Prevents rendering checkbox for group totals.
	GridController.prototype._initCheckboxFormatter = function gridControllerInitCheckboxFormatter(formatter) {
	    return function (row, cell, value, columnDef, dataContext) {
	        return (dataContext.__groupTotals) ? "" : formatter.apply(this, arguments);
	    };
	};
	
	
	//-------------------------------------------
	// Adds the checkbox column if multiSelect is
	// enabled otherwise removes it.
	GridController.prototype._initColumns = function gridControllerInitColumns() {
	    var checkboxColumnId = (this.columns[0] && this.columns[0].id);
	    if (this.options.multiSelect) {
	        if (checkboxColumnId !== "_checkbox") {
	            var checkboxColumn = this._selectionPlugin.getCheckboxColumnDefinition();
	            checkboxColumn.formatter = this._initCheckboxFormatter(checkboxColumn.formatter);
	            this.columns.unshift(checkboxColumn);
	        }
	    } else if (checkboxColumnId === "_checkbox") {
	        this.columns.shift();
	    }
	    return this.columns;
	};
	
	
	//-------------------------------------------
	// Initializes slick.grid including event handlers,
	// plugins and selection model.  Can be disposed
	// using `_disposeGrid`.
	GridController.prototype._initGrid = function gridControllerInitGrid() {
	    this._selectionModel = new RowSelectionModel({ selectActiveRow: !this.options.multiSelect });
	    this._selectionPlugin = new GroupSelectionPlugin({ renderColumnFilterIcon: this.options.supportFilterColumn });
	    this._slickGrid = new SlickGrid(this.element, this.viewModel._dataView, this._initColumns(this.columns), this.options);
	
	    // NOTE: this is important to register this plugin before row selection one,
	    // because we need to not propagate some events in some cases
	    this._slickGrid.registerPlugin(this._selectionPlugin);
	
	    // register selection model
	    this._slickGrid.setSelectionModel(this._selectionModel);
	
	    if (this.selectedIds !== undefined) { this._selectionPlugin.selectRowsByIds(this.selectedIds); }
	    if (this.sortCols !== undefined) { this._slickGrid.setSortColumns(this.sortCols); }
	
	    // initialize slick.grid events
	    this._gridHandlers.subscribe(this._slickGrid.onActiveCellChanged, this._onActiveCellChanged.bind(this));
	    this._gridHandlers.subscribe(this._slickGrid.onClick, this._onClicked.bind(this));
	    var columnsUpdated = this._onColumnsUpdated.bind(this);
	    this._gridHandlers.subscribe(this._slickGrid.onColumnsReordered, columnsUpdated);
	    this._gridHandlers.subscribe(this._slickGrid.onColumnsResized, columnsUpdated);
	    if (this.options.supportItemContext) { this._gridHandlers.subscribe(this._slickGrid.onContextMenu, this._onRightClickedItem.bind(this)); }
	    this._gridHandlers.subscribe(this._slickGrid.onDblClick, this._onDoubleClicked.bind(this));
	    if (this.options.supportColumnContext) { this._gridHandlers.subscribe(this._slickGrid.onHeaderContextMenu, this._onRightClickedColumnHeader.bind(this)); }
	    this._gridHandlers.subscribe(this._slickGrid.onScroll, this._onScroll.bind(this));
	    this._gridHandlers.subscribe(this._slickGrid.onSort, this._onSort.bind(this));
	    if (this.options.supportFilterColumn) { this._gridHandlers.subscribe(this._selectionPlugin.onColumnFilterClick, this._onColumnFilterClicked.bind(this)); }
	    this._gridHandlers.subscribe(this._selectionPlugin.onSelectedIdsChange, this._onSelectionChanged.bind(this));
	
	    this._slickGrid.init();
	
	    // Focus needs to happen after the grid has been initialized
	    if (this.focusedRow !== undefined) { this._slickGrid.setActiveCell(this.focusedRow, 0); }
	
	    // Scroll top should override position set by focus/selection
	    if (this.scrollTop !== undefined) { this._slickGrid.scrollRowToTop(this.scrollTop / this.options.rowHeight); }
	
	    this._resizeHandler = util.debounce(this._slickGrid.resizeCanvas, 250);
	    if (typeof window.addEventListener === "function") {
	        window.addEventListener("resize", this._resizeHandler, false);
	    } else {
	        window.attachEvent("onresize", this._resizeHandler);
	    }
	
	    // Attach key handler to binding target
	    if (this.keyMap) {
	        this._keydownHandler = this._onKeyDown.bind(this);
	        this.element.addEventListener("keydown", this._keydownHandler);
	    }
	};
	
	
	//-------------------------------------------
	// Initialize new grid binding by creating
	// a new controller object and storing it as
	// a property of the bound element.
	//
	// This is a "static" method, do not use "this".
	GridController.prototype._koInit = function gridControllerKoInit(element, valueAccessor) {
	    element[GridController.prototype._elementKey] = new GridController(element, valueAccessor());
	};
	
	
	//-------------------------------------------
	// Update value of HTML element bound by
	// "grid" binding (this method will be
	// called by Knockout when bound observable
	// sends a change notification or when
	// the observable itself changes).
	//
	// This is a "static" method, do not use "this".
	GridController.prototype._koUpdate = function gridControllerKoUpdate(element, valueAccessor) {
	    var controller = GridController.prototype._requireController(element);
	    var viewModel = valueAccessor();
	    if (controller.viewModel !== viewModel) {
	        controller.dispose();
	        GridController.prototype._koInit(element, valueAccessor);
	    }
	};
	
	
	//-------------------------------------------
	// Handles slick.grid onActiveCellChanged.
	// Send active row to the view-model.
	GridController.prototype._onActiveCellChanged = function gridControllerOnActiveCellChanged(e, args) {
	    this.viewModel._applyGridState({ focusedRow: (args.row === undefined ? null : args.row) });
	};
	
	
	//-------------------------------------------
	// Handles slick.grid onClicked.
	GridController.prototype._onClicked = function gridControllerOnClicked(e, args) {
	    if (args) { this.viewModel._applyGridState({ itemClick: args.row, mouseX: e.pageX, mouseY: e.pageY }); }
	};
	
	
	//-------------------------------------------
	// Handles the click of the column header cell
	// filter icon.
	GridController.prototype._onColumnFilterClicked = function gridControllerOnColumnFilterClicked(e, args) {
	    if (args && args.column) {
	        this.viewModel._applyGridState({ filterColumn: args.column.id, mouseX: e.pageX, mouseY: e.pageY });
	    }
	};
	
	
	//-------------------------------------------
	// Handles slick.grid onColumnsReordered and
	// onColumnsResized events.
	// Send columns to the view-model, no need
	// to re-render.
	GridController.prototype._onColumnsUpdated = function gridControllerOnColumnsUpdated() {
	    this.viewModel._applyGridState({ columns: this._slickGrid.getColumns() });
	};
	
	
	//-------------------------------------------
	// Handles slick.grid onDoubleClicked event and
	// triggers the default action.
	GridController.prototype._onDoubleClicked = function gridControllerOnDoubleClicked(e, args) {
	    if (args) { this.viewModel._applyGridState({ defaultAction: args.row, mouseX: e.pageX, mouseY: e.pageY }); }
	};
	
	
	//-------------------------------------------
	// Handles the slick.grid onKeyDown event and
	// triggers the specified action.
	// A non-truthy action will disable the action.
	GridController.prototype._onKeyDown = function gridControllerOnKeyDown(e) {
	    var keyMap = this.keyMap;
	    var hash = keyMapUtil.calculateHash(e);
	    var action = keyMap.lookup[hash];
	
	    if (action) {
	        this._performAction(action);
	        // stop event bubbling
	        e.stopImmediatePropagation();
	        // prevent the browser's default action  (ie: select all)
	        e.preventDefault();
	    }
	};
	
	
	//-------------------------------------------
	// Handles slick.grid column header right clicked.
	GridController.prototype._onRightClickedColumnHeader = function gridControllerOnRightClickedColumnHeader(e, args) {
	    if (args && args.column) {
	        this.viewModel._applyGridState({ columnContext: args.column.id, mouseX: e.pageX, mouseY: e.pageY });
	    }
	    e.stopImmediatePropagation();
	    e.preventDefault();
	};
	
	
	//-------------------------------------------
	// Handles slick.grid item right clicked.
	GridController.prototype._onRightClickedItem = function gridControllerOnRightClickedItem(e, args) {
	    var cell = args.grid.getCellFromEvent(e);
	    if (args.grid.canCellBeSelected(cell.row, cell.cell)) {
	        this.viewModel._applyGridState({ itemContext: cell.row, mouseX: e.pageX, mouseY: e.pageY });
	    }
	    e.stopImmediatePropagation();
	    e.preventDefault();
	};
	
	
	//-------------------------------------------
	// Handles slick.grid onScroll event.  Send
	// scrollTop to viewModel.
	GridController.prototype._onScroll = function gridControllerOnScroll(e, args) {
	    this.viewModel._applyGridState({ scrollTop: args.scrollTop });
	};
	
	
	//-------------------------------------------
	// Handles slick.grid onSort event.  Sends
	// sorted columns to viewModel.
	GridController.prototype._onSort = function gridControllerOnSort(e, args) {
	    this.viewModel._applyGridState({ sortCols: args.sortCols });
	};
	
	
	//-------------------------------------------
	// Handles slick.grid onSort event.  Sends
	// sorted columns to viewModel.
	GridController.prototype._onSelectionChanged = function gridControllerOnSelectionChanged(e, args) {
	    this.viewModel._applyGridState({ selectedIds: args.ids });
	};
	
	
	//-------------------------------------------
	// Performs a grid action by name
	GridController.prototype._performAction = function gridControllerPerformAction(action) {
	    var item, cell, viewport, diff, row;
	    if (!action) { return; }
	
	    cell = this._slickGrid.getActiveCell();
	
	    switch (action.toLowerCase()) {
	    case "collapseallgroups":
	        this.viewModel._dataView.collapseAllGroups(null);
	        break;
	    case "default":
	        this.viewModel._applyGridState({ defaultAction: cell.row });
	        break;
	    case "expandallgroups":
	        this.viewModel._dataView.expandAllGroups(null);
	        break;
	    case "moveend":
	        this._selectionPlugin.navigateHomeOrEnd(false, false, this._slickGrid);
	        break;
	    case "movehome":
	        this._selectionPlugin.navigateHomeOrEnd(true, false, this._slickGrid);
	        break;
	    case "movenext":
	        this._slickGrid.navigateDown();
	        break;
	    case "moveprevious":
	        this._slickGrid.navigateUp();
	        break;
	    case "pagedown":
	        viewport = this._slickGrid.getViewport();
	        diff = viewport.bottom - viewport.top - 2;
	        row = cell.row + diff;
	        row = (row < this._slickGrid.getDataLength()) ? row : this._slickGrid.getDataLength() - 1;
	        this._slickGrid.gotoCell(this._selectionPlugin.getClosestFocusableRow(this._slickGrid, row, -1), 0);
	        if (row === this._slickGrid.getDataLength() - 1) {
	            this._slickGrid.scrollRowToTop(row);
	        }
	        break;
	    case "pageup":
	        viewport = this._slickGrid.getViewport();
	        diff = viewport.bottom - viewport.top - 2;
	        row = cell.row - diff;
	        row = (row >= 0) ? row : 0;
	        this._slickGrid.gotoCell(this._selectionPlugin.getClosestFocusableRow(this._slickGrid, row, 1), 0);
	        break;
	    case "select":
	        if (this.options.multiSelect) {
	            this._selectionPlugin.toggleRowSelection(cell.row);
	        }
	        break;
	    case "selectall":
	        if (this.options.multiSelect) {
	            this._selectionPlugin.selectAll(true);
	        }
	        break;
	    case "selectend":
	        this._selectionPlugin.navigateHomeOrEnd(false, true, this._slickGrid);
	        break;
	    case "selecthome":
	        this._selectionPlugin.navigateHomeOrEnd(true, true, this._slickGrid);
	        break;
	    case "selectnext":
	        this._selectionPlugin.navigateAndSelectUpOrDown(true, this._slickGrid);
	        break;
	    case "selectnone":
	        if (this.options.multiSelect) {
	            this._selectionPlugin.selectAll(false);
	        }
	        break;
	    case "selectprevious":
	        this._selectionPlugin.navigateAndSelectUpOrDown(false, this._slickGrid);
	        break;
	    case "togglegroup":
	        if (cell) {
	            item = this._slickGrid.getDataItem(cell.row);
	            if (item.__group) {
	                this._selectionPlugin.toggleGroup(item, this._slickGrid, this);
	            }
	        }
	        break;
	    default:
	        throw new Error("Unrecognized action: " + action);
	    }
	};
	
	
	
	//-------------------------------------------
	// Subscription handler for `_pushGridState`
	// observable that notifies the grid binding
	// that the state of the grid has changed.
	GridController.prototype._pushGridStateHandler = function gridControllerPushGridStateHandler(value) {
	    var isDisabled = (value.options !== undefined
	        ? value.options.disabled
	        : this.options.disabled === undefined ? true : this.options.disabled);
	    var multiSelectChanged = (value.options !== undefined && value.options.multiSelect !== this.options.multiSelect);
	
	    // update internal state
	    if (value.options !== undefined) {
	        this.options = this._combineDefaultOptionsWith(value.options);
	        if (value.options.shortcutActions === null) {
	            this.keyMap = null;
	        } else {
	            var shortcutActions = this._combineDefaultShortcutsWith(dictionaryToLower(value.options.shortcutActions));
	
	            this.keyMap = new KeyMap(shortcutActions);
	            this.keyMap.createLookup();
	            this.options.disableFocusSinkTab = this.keyMap.lookup[keyMapUtil.codes.tab] === null;
	        }
	    }
	
	    if (value.columns !== undefined) { this.columns = value.columns; }
	    if (value.focusedRow !== undefined) { this.focusedRow = value.focusedRow; }
	    if (value.scrollTop !== undefined) { this.scrollTop = value.scrollTop; }
	    if (value.selectedIds !== undefined) { this.selectedIds = value.selectedIds; }
	    if (value.sortCols !== undefined) { this.sortCols = value.sortCols; }
	
	    // destroy existing grid if it exists
	    if (isDisabled) {
	        this._disposeGrid();
	        this.options.disabled = true;
	
	    // create new
	    } else if (this._slickGrid === null) {
	        this._initGrid();
	
	    // re-initialize if multi-select has changed.
	    } else if (multiSelectChanged) {
	        this._disposeGrid();
	        this._initGrid();
	
	    // update existing
	    } else {
	        if (value.columns !== undefined) { this._slickGrid.setColumns(this._initColumns(this.columns)); }
	        if (value.focusedRow !== undefined) { this._slickGrid.setActiveCell(this.focusedRow, 0); }
	        if (value.options !== undefined) { this._slickGrid.setOptions(this.options); }
	        if (value.resize !== undefined) { this._slickGrid.resizeCanvas(); }
	        if (value.invalidate !== undefined) { this._slickGrid.invalidate(); }
	        if (value.scrollTop !== undefined) { this._slickGrid.scrollRowToTop(this.scrollTop / this.options.rowHeight); }
	        if (value.selectedIds !== undefined) { this._selectionPlugin.selectRowsByIds(this.selectedIds); }
	        if (value.sortCols !== undefined) { this._slickGrid.setSortColumns(this.sortCols); }
	        if (value.action !== undefined) { this._performAction(value.action); }
	    }
	
	};
	
	
	//-------------------------------------------
	// Get controller associated with the specified
	// element. Throws an error if the specified
	// element is not associated with a controller.
	//
	// This is a "static" method, do not use "this".
	GridController.prototype._requireController = function gridControllerRequireController(element) {
	    var controller = (element && element[GridController.prototype._elementKey]);
	    if (!controller) { throw new Error("Target element has not been bound using \"grid\" binding"); }
	    return controller;
	};
	
	
	module.exports = ko.bindingHandlers.grid = {
	    init: GridController.prototype._koInit,
	    update: GridController.prototype._koUpdate
	};
	


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	var Slick = __webpack_require__(410);
	var $ = __webpack_require__(2);
	
	module.exports = RowSelectionModel;
	
	// register namespace
	$.extend(true, window, {
	  "Slick": {
	    "RowSelectionModel": RowSelectionModel
	  }
	});
	
	function RowSelectionModel(options) {
	  var _grid;
	  var _ranges = [];
	  var _self = this;
	  var _handler = new Slick.EventHandler();
	  var _inHandler;
	  var _options;
	  var _defaults = {
	    selectActiveRow: true
	  };
	
	  function init(grid) {
	    _options = $.extend(true, {}, _defaults, options);
	    _grid = grid;
	    _handler.subscribe(_grid.onActiveCellChanged,
	        wrapHandler(handleActiveCellChange));
	    _handler.subscribe(_grid.onKeyDown,
	        wrapHandler(handleKeyDown));
	    _handler.subscribe(_grid.onClick,
	        wrapHandler(handleClick));
	  }
	
	  function destroy() {
	    _handler.unsubscribeAll();
	  }
	
	  function wrapHandler(handler) {
	    return function () {
	      if (!_inHandler) {
	        _inHandler = true;
	        handler.apply(this, arguments);
	        _inHandler = false;
	      }
	    };
	  }
	
	  function rangesToRows(ranges) {
	    var rows = [];
	    for (var i = 0; i < ranges.length; i++) {
	      for (var j = ranges[i].fromRow; j <= ranges[i].toRow; j++) {
	        rows.push(j);
	      }
	    }
	    return rows;
	  }
	
	  function rowsToRanges(rows) {
	    var ranges = [];
	    var lastCell = _grid.getColumns().length - 1;
	    for (var i = 0; i < rows.length; i++) {
	      ranges.push(new Slick.Range(rows[i], 0, rows[i], lastCell));
	    }
	    return ranges;
	  }
	
	  function getRowsRange(from, to) {
	    var i, rows = [];
	    for (i = from; i <= to; i++) {
	      rows.push(i);
	    }
	    for (i = to; i < from; i++) {
	      rows.push(i);
	    }
	    return rows;
	  }
	
	  function getSelectedRows() {
	    return rangesToRows(_ranges);
	  }
	
	  function setSelectedRows(rows) {
	    setSelectedRanges(rowsToRanges(rows));
	  }
	
	  function setSelectedRanges(ranges) {
	    _ranges = ranges;
	    _self.onSelectedRangesChanged.notify(_ranges);
	  }
	
	  function getSelectedRanges() {
	    return _ranges;
	  }
	
	  function handleActiveCellChange(e, data) {
	    if (_options.selectActiveRow && data.row != null) {
	      setSelectedRanges([new Slick.Range(data.row, 0, data.row, _grid.getColumns().length - 1)]);
	    }
	  }
	
	  function handleKeyDown(e) {
	    var activeRow = _grid.getActiveCell();
	    if (activeRow && e.shiftKey && !e.ctrlKey && !e.altKey && !e.metaKey && (e.which == 38 || e.which == 40)) {
	      var selectedRows = getSelectedRows();
	      selectedRows.sort(function (x, y) {
	        return x - y
	      });
	
	      if (!selectedRows.length) {
	        selectedRows = [activeRow.row];
	      }
	
	      var top = selectedRows[0];
	      var bottom = selectedRows[selectedRows.length - 1];
	      var active;
	
	      if (e.which == 40) {
	        active = activeRow.row < bottom || top == bottom ? ++bottom : ++top;
	      } else {
	        active = activeRow.row < bottom ? --bottom : --top;
	      }
	
	      if (active >= 0 && active < _grid.getDataLength()) {
	        _grid.scrollRowIntoView(active);
	        _ranges = rowsToRanges(getRowsRange(top, bottom));
	        setSelectedRanges(_ranges);
	      }
	
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  }
	
	  function handleClick(e) {
	    var cell = _grid.getCellFromEvent(e);
	    if (!cell || !_grid.canCellBeActive(cell.row, cell.cell)) {
	      return false;
	    }
	
	    if (!_grid.getOptions().multiSelect || (
	        !e.ctrlKey && !e.shiftKey && !e.metaKey)) {
	      return false;
	    }
	
	    var selection = rangesToRows(_ranges);
	    var idx = $.inArray(cell.row, selection);
	
	    if (idx === -1 && (e.ctrlKey || e.metaKey)) {
	      selection.push(cell.row);
	      _grid.setActiveCell(cell.row, cell.cell);
	    } else if (idx !== -1 && (e.ctrlKey || e.metaKey)) {
	      selection = $.grep(selection, function (o, i) {
	        return (o !== cell.row);
	      });
	      _grid.setActiveCell(cell.row, cell.cell);
	    } else if (selection.length && e.shiftKey) {
	      var last = selection.pop();
	      var from = Math.min(cell.row, last);
	      var to = Math.max(cell.row, last);
	      selection = [];
	      for (var i = from; i <= to; i++) {
	        if (i !== last) {
	          selection.push(i);
	        }
	      }
	      selection.push(last);
	      _grid.setActiveCell(cell.row, cell.cell);
	    }
	
	    _ranges = rowsToRanges(selection);
	    setSelectedRanges(_ranges);
	    e.stopImmediatePropagation();
	
	    return true;
	  }
	
	  $.extend(this, {
	    "getSelectedRows": getSelectedRows,
	    "setSelectedRows": setSelectedRows,
	
	    "getSelectedRanges": getSelectedRanges,
	    "setSelectedRanges": setSelectedRanges,
	
	    "init": init,
	    "destroy": destroy,
	
	    "onSelectedRangesChanged": new Slick.Event()
	  });
	}
	


/***/ }),
/* 410 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/***
	 * Contains core SlickGrid classes.
	 * @module Core
	 * @namespace Slick
	 */
	
	module.exports = {
	  "Event": Event,
	  "EventData": EventData,
	  "EventHandler": EventHandler,
	  "Range": Range,
	  "NonDataRow": NonDataItem,
	  "Group": Group,
	  "GroupTotals": GroupTotals,
	  "EditorLock": EditorLock,
	
	  /***
	     * A global singleton editor lock.
	     * @class GlobalEditorLock
	     * @static
	     * @constructor
	  */
	  "GlobalEditorLock": new EditorLock()
	};
	
	/***
	 * An event object for passing data to event handlers and letting them control propagation.
	 * <p>This is pretty much identical to how W3C and jQuery implement events.</p>
	 * @class EventData
	 * @constructor
	 */
	function EventData() {
	  var isPropagationStopped = false;
	  var isImmediatePropagationStopped = false;
	
	  /***
	   * Stops event from propagating up the DOM tree.
	   * @method stopPropagation
	   */
	  this.stopPropagation = function () {
	    isPropagationStopped = true;
	  };
	
	  /***
	   * Returns whether stopPropagation was called on this event object.
	   * @method isPropagationStopped
	   * @return {Boolean}
	   */
	  this.isPropagationStopped = function () {
	    return isPropagationStopped;
	  };
	
	  /***
	   * Prevents the rest of the handlers from being executed.
	   * @method stopImmediatePropagation
	   */
	  this.stopImmediatePropagation = function () {
	    isImmediatePropagationStopped = true;
	  };
	
	  /***
	   * Returns whether stopImmediatePropagation was called on this event object.\
	   * @method isImmediatePropagationStopped
	   * @return {Boolean}
	   */
	  this.isImmediatePropagationStopped = function () {
	    return isImmediatePropagationStopped;
	  }
	}
	
	/***
	 * A simple publisher-subscriber implementation.
	 * @class Event
	 * @constructor
	 */
	function Event() {
	  var handlers = [];
	
	  /***
	   * Adds an event handler to be called when the event is fired.
	   * <p>Event handler will receive two arguments - an <code>EventData</code> and the <code>data</code>
	   * object the event was fired with.<p>
	   * @method subscribe
	   * @param fn {Function} Event handler.
	   */
	  this.subscribe = function (fn) {
	    handlers.push(fn);
	  };
	
	  /***
	   * Removes an event handler added with <code>subscribe(fn)</code>.
	   * @method unsubscribe
	   * @param fn {Function} Event handler to be removed.
	   */
	  this.unsubscribe = function (fn) {
	    for (var i = handlers.length - 1; i >= 0; i--) {
	      if (handlers[i] === fn) {
	        handlers.splice(i, 1);
	      }
	    }
	  };
	
	  /***
	   * Fires an event notifying all subscribers.
	   * @method notify
	   * @param args {Object} Additional data object to be passed to all handlers.
	   * @param e {EventData}
	   *      Optional.
	   *      An <code>EventData</code> object to be passed to all handlers.
	   *      For DOM events, an existing W3C/jQuery event object can be passed in.
	   * @param scope {Object}
	   *      Optional.
	   *      The scope ("this") within which the handler will be executed.
	   *      If not specified, the scope will be set to the <code>Event</code> instance.
	   */
	  this.notify = function (args, e, scope) {
	    e = e || new EventData();
	    scope = scope || this;
	
	    var returnValue;
	    for (var i = 0; i < handlers.length && !(e.isPropagationStopped() || e.isImmediatePropagationStopped()); i++) {
	      returnValue = handlers[i].call(scope, e, args);
	    }
	
	    return returnValue;
	  };
	}
	
	function EventHandler() {
	  var handlers = [];
	
	  this.subscribe = function (event, handler) {
	    handlers.push({
	      event: event,
	      handler: handler
	    });
	    event.subscribe(handler);
	
	    return this;  // allow chaining
	  };
	
	  this.unsubscribe = function (event, handler) {
	    var i = handlers.length;
	    while (i--) {
	      if (handlers[i].event === event &&
	          handlers[i].handler === handler) {
	        handlers.splice(i, 1);
	        event.unsubscribe(handler);
	        return;
	      }
	    }
	
	    return this;  // allow chaining
	  };
	
	  this.unsubscribeAll = function () {
	    var i = handlers.length;
	    while (i--) {
	      handlers[i].event.unsubscribe(handlers[i].handler);
	    }
	    handlers = [];
	
	    return this;  // allow chaining
	  }
	}
	
	/***
	 * A structure containing a range of cells.
	 * @class Range
	 * @constructor
	 * @param fromRow {Integer} Starting row.
	 * @param fromCell {Integer} Starting cell.
	 * @param toRow {Integer} Optional. Ending row. Defaults to <code>fromRow</code>.
	 * @param toCell {Integer} Optional. Ending cell. Defaults to <code>fromCell</code>.
	 */
	function Range(fromRow, fromCell, toRow, toCell) {
	  if (toRow === undefined && toCell === undefined) {
	    toRow = fromRow;
	    toCell = fromCell;
	  }
	
	  /***
	   * @property fromRow
	   * @type {Integer}
	   */
	  this.fromRow = Math.min(fromRow, toRow);
	
	  /***
	   * @property fromCell
	   * @type {Integer}
	   */
	  this.fromCell = Math.min(fromCell, toCell);
	
	  /***
	   * @property toRow
	   * @type {Integer}
	   */
	  this.toRow = Math.max(fromRow, toRow);
	
	  /***
	   * @property toCell
	   * @type {Integer}
	   */
	  this.toCell = Math.max(fromCell, toCell);
	
	  /***
	   * Returns whether a range represents a single row.
	   * @method isSingleRow
	   * @return {Boolean}
	   */
	  this.isSingleRow = function () {
	    return this.fromRow == this.toRow;
	  };
	
	  /***
	   * Returns whether a range represents a single cell.
	   * @method isSingleCell
	   * @return {Boolean}
	   */
	  this.isSingleCell = function () {
	    return this.fromRow == this.toRow && this.fromCell == this.toCell;
	  };
	
	  /***
	   * Returns whether a range contains a given cell.
	   * @method contains
	   * @param row {Integer}
	   * @param cell {Integer}
	   * @return {Boolean}
	   */
	  this.contains = function (row, cell) {
	    return row >= this.fromRow && row <= this.toRow &&
	        cell >= this.fromCell && cell <= this.toCell;
	  };
	
	  /***
	   * Returns a readable representation of a range.
	   * @method toString
	   * @return {String}
	   */
	  this.toString = function () {
	    if (this.isSingleCell()) {
	      return "(" + this.fromRow + ":" + this.fromCell + ")";
	    }
	    else {
	      return "(" + this.fromRow + ":" + this.fromCell + " - " + this.toRow + ":" + this.toCell + ")";
	    }
	  }
	}
	
	
	/***
	 * A base class that all special / non-data rows (like Group and GroupTotals) derive from.
	 * @class NonDataItem
	 * @constructor
	 */
	function NonDataItem() {
	  this.__nonDataRow = true;
	}
	
	
	/***
	 * Information about a group of rows.
	 * @class Group
	 * @extends Slick.NonDataItem
	 * @constructor
	 */
	function Group() {
	  this.__group = true;
	
	  /**
	   * Grouping level, starting with 0.
	   * @property level
	   * @type {Number}
	   */
	  this.level = 0;
	
	  /***
	   * Number of rows in the group.
	   * @property count
	   * @type {Integer}
	   */
	  this.count = 0;
	
	  /***
	   * Grouping value.
	   * @property value
	   * @type {Object}
	   */
	  this.value = null;
	
	  /***
	   * Formatted display value of the group.
	   * @property title
	   * @type {String}
	   */
	  this.title = null;
	
	  /***
	   * Whether a group is collapsed.
	   * @property collapsed
	   * @type {Boolean}
	   */
	  this.collapsed = false;
	
	  /***
	   * GroupTotals, if any.
	   * @property totals
	   * @type {GroupTotals}
	   */
	  this.totals = null;
	
	  /**
	   * Rows that are part of the group.
	   * @property rows
	   * @type {Array}
	   */
	  this.rows = [];
	
	  /**
	   * Sub-groups that are part of the group.
	   * @property groups
	   * @type {Array}
	   */
	  this.groups = null;
	
	  /**
	   * A unique key used to identify the group.  This key can be used in calls to DataView
	   * collapseGroup() or expandGroup().
	   * @property groupingKey
	   * @type {Object}
	   */
	  this.groupingKey = null;
	}
	
	Group.prototype = new NonDataItem();
	
	/***
	 * Compares two Group instances.
	 * @method equals
	 * @return {Boolean}
	 * @param group {Group} Group instance to compare to.
	 */
	Group.prototype.equals = function (group) {
	  return this.value === group.value &&
	      this.count === group.count &&
	      this.collapsed === group.collapsed &&
	      this.title === group.title;
	};
	
	/***
	 * Information about group totals.
	 * An instance of GroupTotals will be created for each totals row and passed to the aggregators
	 * so that they can store arbitrary data in it.  That data can later be accessed by group totals
	 * formatters during the display.
	 * @class GroupTotals
	 * @extends Slick.NonDataItem
	 * @constructor
	 */
	function GroupTotals() {
	  this.__groupTotals = true;
	
	  /***
	   * Parent Group.
	   * @param group
	   * @type {Group}
	   */
	  this.group = null;
	
	  /***
	   * Whether the totals have been fully initialized / calculated.
	   * Will be set to false for lazy-calculated group totals.
	   * @param initialized
	   * @type {Boolean}
	   */
	  this.initialized = false;
	}
	
	GroupTotals.prototype = new NonDataItem();
	
	/***
	 * A locking helper to track the active edit controller and ensure that only a single controller
	 * can be active at a time.  This prevents a whole class of state and validation synchronization
	 * issues.  An edit controller (such as SlickGrid) can query if an active edit is in progress
	 * and attempt a commit or cancel before proceeding.
	 * @class EditorLock
	 * @constructor
	 */
	function EditorLock() {
	  var activeEditController = null;
	
	  /***
	   * Returns true if a specified edit controller is active (has the edit lock).
	   * If the parameter is not specified, returns true if any edit controller is active.
	   * @method isActive
	   * @param editController {EditController}
	   * @return {Boolean}
	   */
	  this.isActive = function (editController) {
	    return (editController ? activeEditController === editController : activeEditController !== null);
	  };
	
	  /***
	   * Sets the specified edit controller as the active edit controller (acquire edit lock).
	   * If another edit controller is already active, and exception will be thrown.
	   * @method activate
	   * @param editController {EditController} edit controller acquiring the lock
	   */
	  this.activate = function (editController) {
	    if (editController === activeEditController) { // already activated?
	      return;
	    }
	    if (activeEditController !== null) {
	      throw "SlickGrid.EditorLock.activate: an editController is still active, can't activate another editController";
	    }
	    if (!editController.commitCurrentEdit) {
	      throw "SlickGrid.EditorLock.activate: editController must implement .commitCurrentEdit()";
	    }
	    if (!editController.cancelCurrentEdit) {
	      throw "SlickGrid.EditorLock.activate: editController must implement .cancelCurrentEdit()";
	    }
	    activeEditController = editController;
	  };
	
	  /***
	   * Unsets the specified edit controller as the active edit controller (release edit lock).
	   * If the specified edit controller is not the active one, an exception will be thrown.
	   * @method deactivate
	   * @param editController {EditController} edit controller releasing the lock
	   */
	  this.deactivate = function (editController) {
	    if (activeEditController !== editController) {
	      throw "SlickGrid.EditorLock.deactivate: specified editController is not the currently active one";
	    }
	    activeEditController = null;
	  };
	
	  /***
	   * Attempts to commit the current edit by calling "commitCurrentEdit" method on the active edit
	   * controller and returns whether the commit attempt was successful (commit may fail due to validation
	   * errors, etc.).  Edit controller's "commitCurrentEdit" must return true if the commit has succeeded
	   * and false otherwise.  If no edit controller is active, returns true.
	   * @method commitCurrentEdit
	   * @return {Boolean}
	   */
	  this.commitCurrentEdit = function () {
	    return (activeEditController ? activeEditController.commitCurrentEdit() : true);
	  };
	
	  /***
	   * Attempts to cancel the current edit by calling "cancelCurrentEdit" method on the active edit
	   * controller and returns whether the edit was successfully cancelled.  If no edit controller is
	   * active, returns true.
	   * @method cancelCurrentEdit
	   * @return {Boolean}
	   */
	  this.cancelCurrentEdit = function cancelCurrentEdit() {
	    return (activeEditController ? activeEditController.cancelCurrentEdit() : true);
	  };
	}
	


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/**
	 * @license
	 * (c) 2009-2013 Michael Leibman
	 * michael{dot}leibman{at}gmail{dot}com
	 * http://github.com/mleibman/slickgrid
	 *
	 * Distributed under MIT license.
	 * All rights reserved.
	 *
	 * SlickGrid v2.2
	 *
	 * NOTES:
	 *     Cell/row DOM manipulations are done directly bypassing jQuery's DOM manipulation methods.
	 *     This increases the speed dramatically, but can only be done safely because there are no event handlers
	 *     or data associated with any cell/row DOM nodes.  Cell editors must make sure they implement .destroy()
	 *     and do proper cleanup.
	 */
	
	var $ = __webpack_require__(2);
	
	// jquery stuff loves to touch the globals
	__webpack_require__(412);
	
	// for sorting
	__webpack_require__(413);
	
	if (!$.fn.drag) {
	  throw "SlickGrid requires jquery.event.drag module to be loaded";
	}
	
	var Slick = __webpack_require__(410);
	
	
	module.exports = SlickGrid;
	
	// Slick.Grid
	$.extend(true, window, {
	  Slick: {
	    Grid: SlickGrid
	  }
	});
	
	// shared across all grids on the page
	var scrollbarDimensions;
	var maxSupportedCssHeight;  // browser's breaking point
	
	//////////////////////////////////////////////////////////////////////////////////////////////
	// SlickGrid class implementation (available as Slick.Grid)
	
	/**
	 * Creates a new instance of the grid.
	 * @class SlickGrid
	 * @constructor
	 * @param {Node}              container   Container node to create the grid in.
	 * @param {Array,Object}      data        An array of objects for databinding.
	 * @param {Array}             columns     An array of column definitions.
	 * @param {Object}            options     Grid options.
	 **/
	function SlickGrid(container, data, columns, options) {
	  // settings
	  var defaults = {
	    explicitInitialization: false,
	    rowHeight: 25,
	    defaultColumnWidth: 80,
	    enableAddRow: false,
	    leaveSpaceForNewRows: false,
	    editable: false,
	    autoEdit: true,
	    enableCellNavigation: true,
	    enableColumnReorder: true,
	    asyncEditorLoading: false,
	    asyncEditorLoadDelay: 100,
	    forceFitColumns: false,
	    enableAsyncPostRender: false,
	    asyncPostRenderDelay: 50,
	    autoHeight: false,
	    editorLock: Slick.GlobalEditorLock,
	    showHeaderRow: false,
	    headerRowHeight: 25,
	    showTopPanel: false,
	    topPanelHeight: 25,
	    formatterFactory: null,
	    editorFactory: null,
	    cellFlashingCssClass: "flashing",
	    selectedCellCssClass: "selected",
	    multiSelect: true,
	    enableTextSelectionOnCells: false,
	    dataItemColumnValueExtractor: null,
	    fullWidthRows: false,
	    multiColumnSort: false,
	    defaultFormatter: defaultFormatter,
	    forceSyncScrolling: false,
	    addNewRowCssClass: "new-row",
	    disableKeyHandler: false,
	    disableFocusSinkTab: false
	  };
	
	  var columnDefaults = {
	    name: "",
	    resizable: true,
	    sortable: false,
	    minWidth: 30,
	    rerenderOnResize: false,
	    headerCssClass: null,
	    defaultSortAsc: true,
	    focusable: true,
	    selectable: true
	  };
	
	  // scroller
	  var th;   // virtual height
	  var h;    // real scrollable height
	  var ph;   // page height
	  var n;    // number of pages
	  var cj;   // "jumpiness" coefficient
	
	  var page = 0;       // current page
	  var offset = 0;     // current page offset
	  var vScrollDir = 1;
	
	  // private
	  var initialized = false;
	  var $container;
	  var uid = "slickgrid_" + Math.round(1000000 * Math.random());
	  var self = this;
	  var $focusSink, $focusSink2;
	  var $headerScroller;
	  var $headers;
	  var $headerRow, $headerRowScroller, $headerRowSpacer;
	  var $topPanelScroller;
	  var $topPanel;
	  var $viewport;
	  var $canvas;
	  var $style;
	  var $boundAncestors;
	  var stylesheet, columnCssRulesL, columnCssRulesR;
	  var viewportH, viewportW;
	  var canvasWidth;
	  var viewportHasHScroll, viewportHasVScroll;
	  var headerColumnWidthDiff = 0, headerColumnHeightDiff = 0, // border+padding
	      cellWidthDiff = 0, cellHeightDiff = 0;
	  var absoluteColumnMinWidth;
	
	  var tabbingDirection = 1;
	  var activePosX;
	  var activeRow, activeCell;
	  var activeCellNode = null;
	  var currentEditor = null;
	  var serializedEditorValue;
	  var editController;
	
	  var rowsCache = {};
	  var renderedRows = 0;
	  var numVisibleRows;
	  var prevScrollTop = 0;
	  var scrollTop = 0;
	  var lastRenderedScrollTop = 0;
	  var lastRenderedScrollLeft = 0;
	  var prevScrollLeft = 0;
	  var scrollLeft = 0;
	
	  var selectionModel;
	  var selectedRows = [];
	
	  var plugins = [];
	  var cellCssClasses = {};
	
	  var columnsById = {};
	  var sortColumns = [];
	  var columnPosLeft = [];
	  var columnPosRight = [];
	
	
	  // async call handles
	  var h_editorLoader = null;
	  var h_render = null;
	  var h_postrender = null;
	  var postProcessedRows = {};
	  var postProcessToRow = null;
	  var postProcessFromRow = null;
	
	  // perf counters
	  var counter_rows_rendered = 0;
	  var counter_rows_removed = 0;
	
	  // These two variables work around a bug with inertial scrolling in Webkit/Blink on Mac.
	  // See http://crbug.com/312427.
	  var rowNodeFromLastMouseWheelEvent;  // this node must not be deleted while inertial scrolling
	  var zombieRowNodeFromLastMouseWheelEvent;  // node that was hidden instead of getting deleted
	
	
	  //////////////////////////////////////////////////////////////////////////////////////////////
	  // Initialization
	
	  function init() {
	    $container = $(container);
	    if ($container.length < 1) {
	      throw new Error("SlickGrid requires a valid container, " + container + " does not exist in the DOM.");
	    }
	
	    // calculate these only once and share between grid instances
	    maxSupportedCssHeight = maxSupportedCssHeight || getMaxSupportedCssHeight();
	    scrollbarDimensions = scrollbarDimensions || measureScrollbar();
	
	    options = $.extend({}, defaults, options);
	    validateAndEnforceOptions();
	    columnDefaults.width = options.defaultColumnWidth;
	
	    columnsById = {};
	    for (var i = 0; i < columns.length; i++) {
	      var m = columns[i] = $.extend({}, columnDefaults, columns[i]);
	      columnsById[m.id] = i;
	      if (m.minWidth && m.width < m.minWidth) {
	        m.width = m.minWidth;
	      }
	      if (m.maxWidth && m.width > m.maxWidth) {
	        m.width = m.maxWidth;
	      }
	    }
	
	    // validate loaded JavaScript modules against requested options
	    if (options.enableColumnReorder && !$.fn.sortable) {
	      throw new Error("SlickGrid's 'enableColumnReorder = true' option requires jquery-ui.sortable module to be loaded");
	    }
	
	    editController = {
	      "commitCurrentEdit": commitCurrentEdit,
	      "cancelCurrentEdit": cancelCurrentEdit
	    };
	
	    $container
	        .empty()
	        .css("overflow", "hidden")
	        .css("outline", 0)
	        .addClass(uid)
	        .addClass("ui-widget");
	
	    // set up a positioning container if needed
	    if (!/relative|absolute|fixed/.test($container.css("position"))) {
	      $container.css("position", "relative");
	    }
	
	    $focusSink = $("<div tabIndex='0' hideFocus style='position:fixed;width:0;height:0;top:0;left:0;outline:0;'></div>").appendTo($container);
	
	    $headerScroller = $("<div class='slick-header ui-state-default' style='overflow:hidden;position:relative;' />").appendTo($container);
	    $headers = $("<div class='slick-header-columns' style='left:-1000px' />").appendTo($headerScroller);
	    $headers.width(getHeadersWidth());
	
	    $headerRowScroller = $("<div class='slick-headerrow ui-state-default' style='overflow:hidden;position:relative;' />").appendTo($container);
	    $headerRow = $("<div class='slick-headerrow-columns' />").appendTo($headerRowScroller);
	    $headerRowSpacer = $("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>")
	        .css("width", getCanvasWidth() + scrollbarDimensions.width + "px")
	        .appendTo($headerRowScroller);
	
	    $topPanelScroller = $("<div class='slick-top-panel-scroller ui-state-default' style='overflow:hidden;position:relative;' />").appendTo($container);
	    $topPanel = $("<div class='slick-top-panel' style='width:10000px' />").appendTo($topPanelScroller);
	
	    if (!options.showTopPanel) {
	      $topPanelScroller.hide();
	    }
	
	    if (!options.showHeaderRow) {
	      $headerRowScroller.hide();
	    }
	
	    $viewport = $("<div class='slick-viewport' style='width:100%;overflow:auto;outline:0;position:relative;;'>").appendTo($container);
	    $viewport.css("overflow-y", options.autoHeight ? "hidden" : "auto");
	
	    $canvas = $("<div class='grid-canvas' />").appendTo($viewport);
	
	    $focusSink2 = $focusSink.clone().appendTo($container);
	    // tab is set, so remove the focus sink from the tab.
	    // leaving it turns the grid into 2 tab stops.
	    // removing it all the time breaks slick grid tab stealing.
	    if (options.disableFocusSinkTab) {
	      $focusSink2.attr("tabindex", "-1");
	    }
	
	    if (!options.explicitInitialization) {
	      finishInitialization();
	    }
	  }
	
	  function finishInitialization() {
	    if (!initialized) {
	      initialized = true;
	
	      viewportW = parseFloat($.css($container[0], "width", true));
	
	      // header columns and cells may have different padding/border skewing width calculations (box-sizing, hello?)
	      // calculate the diff so we can set consistent sizes
	      measureCellPaddingAndBorder();
	
	      // for usability reasons, all text selection in SlickGrid is disabled
	      // with the exception of input and textarea elements (selection must
	      // be enabled there so that editors work as expected); note that
	      // selection in grid cells (grid body) is already unavailable in
	      // all browsers except IE
	      disableSelection($headers); // disable all text selection in header (including input and textarea)
	
	      if (!options.enableTextSelectionOnCells) {
	        // disable text selection in grid cells except in input and textarea elements
	        // (this is IE-specific, because selectstart event will only fire in IE)
	        $viewport.bind("selectstart.ui", function (event) {
	          return $(event.target).is("input,textarea");
	        });
	      }
	
	      updateColumnCaches();
	      createColumnHeaders();
	      setupColumnSort();
	      createCssRules();
	      resizeCanvas();
	      bindAncestorScrollEvents();
	
	      $container
	          .bind("resize.slickgrid", resizeCanvas);
	      $viewport
	          //.bind("click", handleClick)
	          .bind("scroll", handleScroll);
	      $headerScroller
	          .bind("contextmenu", handleHeaderContextMenu)
	          .bind("click", handleHeaderClick)
	          .delegate(".slick-header-column", "mouseenter", handleHeaderMouseEnter)
	          .delegate(".slick-header-column", "mouseleave", handleHeaderMouseLeave);
	      $headerRowScroller
	          .bind("scroll", handleHeaderRowScroll);
	      if (!self.getOptions().disableKeyHandler) {
	        $focusSink.add($focusSink2)
	            .bind("keydown", handleKeyDown);
	        $canvas
	            .bind("keydown", handleKeyDown)
	      }
	      $canvas
	          .bind("click", handleClick)
	          .bind("dblclick", handleDblClick)
	          .bind("contextmenu", handleContextMenu)
	          .bind("draginit", handleDragInit)
	          .bind("dragstart", {distance: 3}, handleDragStart)
	          .bind("drag", handleDrag)
	          .bind("dragend", handleDragEnd)
	          .delegate(".slick-cell", "mouseenter", handleMouseEnter)
	          .delegate(".slick-cell", "mouseleave", handleMouseLeave);
	
	      // Work around http://crbug.com/312427.
	      if (navigator.userAgent.toLowerCase().match(/webkit/) &&
	          navigator.userAgent.toLowerCase().match(/macintosh/)) {
	        $canvas.bind("mousewheel", handleMouseWheel);
	      }
	    }
	  }
	
	  function registerPlugin(plugin) {
	    plugins.unshift(plugin);
	    plugin.init(self);
	  }
	
	  function unregisterPlugin(plugin) {
	    for (var i = plugins.length; i >= 0; i--) {
	      if (plugins[i] === plugin) {
	        if (plugins[i].destroy) {
	          plugins[i].destroy();
	        }
	        plugins.splice(i, 1);
	        break;
	      }
	    }
	  }
	
	  function setSelectionModel(model) {
	    if (selectionModel) {
	      selectionModel.onSelectedRangesChanged.unsubscribe(handleSelectedRangesChanged);
	      if (selectionModel.destroy) {
	        selectionModel.destroy();
	      }
	    }
	
	    selectionModel = model;
	    if (selectionModel) {
	      selectionModel.init(self);
	      selectionModel.onSelectedRangesChanged.subscribe(handleSelectedRangesChanged);
	    }
	  }
	
	  function getSelectionModel() {
	    return selectionModel;
	  }
	
	  function getCanvasNode() {
	    return $canvas[0];
	  }
	
	  function measureScrollbar() {
	    var $c = $("<div style='position:absolute; top:-10000px; left:-10000px; width:100px; height:100px; overflow:scroll;'></div>").appendTo("body");
	    var dim = {
	      width: $c.width() - $c[0].clientWidth,
	      height: $c.height() - $c[0].clientHeight
	    };
	    $c.remove();
	    return dim;
	  }
	
	  function getHeadersWidth() {
	    var headersWidth = 0;
	    for (var i = 0, ii = columns.length; i < ii; i++) {
	      var width = columns[i].width;
	      headersWidth += width;
	    }
	    headersWidth += scrollbarDimensions.width;
	    return Math.max(headersWidth, viewportW) + 1000;
	  }
	
	  function getCanvasWidth() {
	    var availableWidth = viewportHasVScroll ? viewportW - scrollbarDimensions.width : viewportW;
	    var rowWidth = 0;
	    var i = columns.length;
	    while (i--) {
	      rowWidth += columns[i].width;
	    }
	    return options.fullWidthRows ? Math.max(rowWidth, availableWidth) : rowWidth;
	  }
	
	  function updateCanvasWidth(forceColumnWidthsUpdate) {
	    var oldCanvasWidth = canvasWidth;
	    canvasWidth = getCanvasWidth();
	
	    if (canvasWidth != oldCanvasWidth) {
	      $canvas.width(canvasWidth);
	      $headerRow.width(canvasWidth);
	      $headers.width(getHeadersWidth());
	      viewportHasHScroll = (canvasWidth > viewportW - scrollbarDimensions.width);
	    }
	
	    $headerRowSpacer.width(canvasWidth + (viewportHasVScroll ? scrollbarDimensions.width : 0));
	
	    if (canvasWidth != oldCanvasWidth || forceColumnWidthsUpdate) {
	      applyColumnWidths();
	    }
	  }
	
	  function disableSelection($target) {
	    if ($target && $target.jquery) {
	      $target
	          .attr("unselectable", "on")
	          .css("MozUserSelect", "none")
	          .bind("selectstart.ui", function () {
	            return false;
	          }); // from jquery:ui.core.js 1.7.2
	    }
	  }
	
	  function getMaxSupportedCssHeight() {
	    var supportedHeight = 1000000;
	    // FF reports the height back but still renders blank after ~6M px
	    var testUpTo = navigator.userAgent.toLowerCase().match(/firefox/) ? 6000000 : 1000000000;
	    var div = $("<div style='display:none' />").appendTo(document.body);
	
	    while (true) {
	      var test = supportedHeight * 2;
	      div.css("height", test);
	      if (test > testUpTo || div.height() !== test) {
	        break;
	      } else {
	        supportedHeight = test;
	      }
	    }
	
	    div.remove();
	    return supportedHeight;
	  }
	
	  // TODO:  this is static.  need to handle page mutation.
	  function bindAncestorScrollEvents() {
	    var elem = $canvas[0];
	    while ((elem = elem.parentNode) != document.body && elem != null) {
	      // bind to scroll containers only
	      if (elem == $viewport[0] || elem.scrollWidth != elem.clientWidth || elem.scrollHeight != elem.clientHeight) {
	        var $elem = $(elem);
	        if (!$boundAncestors) {
	          $boundAncestors = $elem;
	        } else {
	          $boundAncestors = $boundAncestors.add($elem);
	        }
	        $elem.bind("scroll." + uid, handleActiveCellPositionChange);
	      }
	    }
	  }
	
	  function unbindAncestorScrollEvents() {
	    if (!$boundAncestors) {
	      return;
	    }
	    $boundAncestors.unbind("scroll." + uid);
	    $boundAncestors = null;
	  }
	
	  function updateColumnHeader(columnId, title, toolTip) {
	    if (!initialized) { return; }
	    var idx = getColumnIndex(columnId);
	    if (idx == null) {
	      return;
	    }
	
	    var columnDef = columns[idx];
	    var $header = $headers.children().eq(idx);
	    if ($header) {
	      if (title !== undefined) {
	        columns[idx].name = title;
	      }
	      if (toolTip !== undefined) {
	        columns[idx].toolTip = toolTip;
	      }
	
	      trigger(self.onBeforeHeaderCellDestroy, {
	        "node": $header[0],
	        "column": columnDef
	      });
	
	      $header
	          .attr("title", toolTip || "")
	          .children().eq(0).html(title);
	
	      trigger(self.onHeaderCellRendered, {
	        "node": $header[0],
	        "column": columnDef
	      });
	    }
	  }
	
	  function getHeaderRow() {
	    return $headerRow[0];
	  }
	
	  function getHeaderRowColumn(columnId) {
	    var idx = getColumnIndex(columnId);
	    var $header = $headerRow.children().eq(idx);
	    return $header && $header[0];
	  }
	
	  function createColumnHeaders() {
	    function onMouseEnter() {
	      $(this).addClass("ui-state-hover");
	    }
	
	    function onMouseLeave() {
	      $(this).removeClass("ui-state-hover");
	    }
	
	    $headers.find(".slick-header-column")
	      .each(function() {
	        var columnDef = $(this).data("column");
	        if (columnDef) {
	          trigger(self.onBeforeHeaderCellDestroy, {
	            "node": this,
	            "column": columnDef
	          });
	        }
	      });
	    $headers.empty();
	    $headers.width(getHeadersWidth());
	
	    $headerRow.find(".slick-headerrow-column")
	      .each(function() {
	        var columnDef = $(this).data("column");
	        if (columnDef) {
	          trigger(self.onBeforeHeaderRowCellDestroy, {
	            "node": this,
	            "column": columnDef
	          });
	        }
	      });
	    $headerRow.empty();
	
	    for (var i = 0; i < columns.length; i++) {
	      var m = columns[i];
	
	      var header = $("<div class='ui-state-default slick-header-column' />")
	          .html("<span class='slick-column-name'>" + m.name + "</span>")
	          .width(m.width - headerColumnWidthDiff)
	          .attr("id", "" + uid + m.id)
	          .attr("title", m.toolTip || "")
	          .data("column", m)
	          .addClass(m.headerCssClass || "")
	          .appendTo($headers);
	
	      if (options.enableColumnReorder || m.sortable) {
	        header
	          .on('mouseenter', onMouseEnter)
	          .on('mouseleave', onMouseLeave);
	      }
	
	      if (m.sortable) {
	        header.addClass("slick-header-sortable");
	        header.append("<span class='slick-sort-indicator' />");
	      }
	
	      trigger(self.onHeaderCellRendered, {
	        "node": header[0],
	        "column": m
	      });
	
	      if (options.showHeaderRow) {
	        var headerRowCell = $("<div class='ui-state-default slick-headerrow-column l" + i + " r" + i + "'></div>")
	            .data("column", m)
	            .appendTo($headerRow);
	
	        trigger(self.onHeaderRowCellRendered, {
	          "node": headerRowCell[0],
	          "column": m
	        });
	      }
	    }
	
	    setSortColumns(sortColumns);
	    setupColumnResize();
	    if (options.enableColumnReorder) {
	      setupColumnReorder();
	    }
	  }
	
	  function setupColumnSort() {
	    $headers.click(function (e) {
	      // temporary workaround for a bug in jQuery 1.7.1 (http://bugs.jquery.com/ticket/11328)
	      e.metaKey = e.metaKey || e.ctrlKey;
	
	      if ($(e.target).hasClass("slick-resizable-handle")) {
	        return;
	      }
	
	      var $col = $(e.target).closest(".slick-header-column");
	      if (!$col.length) {
	        return;
	      }
	
	      var column = $col.data("column");
	      if (column.sortable) {
	        if (!getEditorLock().commitCurrentEdit()) {
	          return;
	        }
	
	        var sortOpts = null;
	        var i = 0;
	        for (; i < sortColumns.length; i++) {
	          if (sortColumns[i].columnId == column.id) {
	            sortOpts = sortColumns[i];
	            sortOpts.sortAsc = !sortOpts.sortAsc;
	            break;
	          }
	        }
	
	        if (e.metaKey && options.multiColumnSort) {
	          if (sortOpts) {
	            sortColumns.splice(i, 1);
	          }
	        }
	        else {
	          if ((!e.shiftKey && !e.metaKey) || !options.multiColumnSort) {
	            sortColumns = [];
	          }
	
	          if (!sortOpts) {
	            sortOpts = { columnId: column.id, sortAsc: column.defaultSortAsc };
	            sortColumns.push(sortOpts);
	          } else if (sortColumns.length == 0) {
	            sortColumns.push(sortOpts);
	          }
	        }
	
	        setSortColumns(sortColumns);
	
	        if (!options.multiColumnSort) {
	          trigger(self.onSort, {
	            multiColumnSort: false,
	            sortCol: column,
	            sortAsc: sortOpts.sortAsc}, e);
	        } else {
	          trigger(self.onSort, {
	            multiColumnSort: true,
	            sortCols: $.map(sortColumns, function(col) {
	              return {sortCol: columns[getColumnIndex(col.columnId)], sortAsc: col.sortAsc };
	            })}, e);
	        }
	      }
	    });
	  }
	
	  function setupColumnReorder() {
	    $headers.filter(":ui-sortable").sortable("destroy");
	    $headers.sortable({
	      containment: "parent",
	      distance: 3,
	      axis: "x",
	      cursor: "default",
	      tolerance: "intersection",
	      helper: "clone",
	      placeholder: "slick-sortable-placeholder ui-state-default slick-header-column",
	      start: function (e, ui) {
	        ui.placeholder.width(ui.helper.outerWidth() - headerColumnWidthDiff);
	        $(ui.helper).addClass("slick-header-column-active");
	      },
	      beforeStop: function (e, ui) {
	        $(ui.helper).removeClass("slick-header-column-active");
	      },
	      stop: function (e) {
	        if (!getEditorLock().commitCurrentEdit()) {
	          $(this).sortable("cancel");
	          return;
	        }
	
	        var reorderedIds = $headers.sortable("toArray");
	        var reorderedColumns = [];
	        for (var i = 0; i < reorderedIds.length; i++) {
	          reorderedColumns.push(columns[getColumnIndex(reorderedIds[i].replace(uid, ""))]);
	        }
	        setColumns(reorderedColumns);
	
	        trigger(self.onColumnsReordered, {});
	        e.stopPropagation();
	        setupColumnResize();
	      }
	    });
	  }
	
	  function setupColumnResize() {
	    var $col, j, c, pageX, columnElements, minPageX, maxPageX, firstResizable, lastResizable;
	    columnElements = $headers.children();
	    columnElements.find(".slick-resizable-handle").remove();
	    columnElements.each(function (i, e) {
	      if (columns[i].resizable) {
	        if (firstResizable === undefined) {
	          firstResizable = i;
	        }
	        lastResizable = i;
	      }
	    });
	    if (firstResizable === undefined) {
	      return;
	    }
	    columnElements.each(function (i, e) {
	      if (i < firstResizable || (options.forceFitColumns && i >= lastResizable)) {
	        return;
	      }
	      $col = $(e);
	      $("<div class='slick-resizable-handle' />")
	          .appendTo(e)
	          .bind("dragstart", function (e, dd) {
	            if (!getEditorLock().commitCurrentEdit()) {
	              return false;
	            }
	            pageX = e.pageX;
	            $(this).parent().addClass("slick-header-column-active");
	            var shrinkLeewayOnRight = null, stretchLeewayOnRight = null;
	            // lock each column's width option to current width
	            columnElements.each(function (i, e) {
	              columns[i].previousWidth = $(e).outerWidth();
	            });
	            if (options.forceFitColumns) {
	              shrinkLeewayOnRight = 0;
	              stretchLeewayOnRight = 0;
	              // colums on right affect maxPageX/minPageX
	              for (j = i + 1; j < columnElements.length; j++) {
	                c = columns[j];
	                if (c.resizable) {
	                  if (stretchLeewayOnRight !== null) {
	                    if (c.maxWidth) {
	                      stretchLeewayOnRight += c.maxWidth - c.previousWidth;
	                    } else {
	                      stretchLeewayOnRight = null;
	                    }
	                  }
	                  shrinkLeewayOnRight += c.previousWidth - Math.max(c.minWidth || 0, absoluteColumnMinWidth);
	                }
	              }
	            }
	            var shrinkLeewayOnLeft = 0, stretchLeewayOnLeft = 0;
	            for (j = 0; j <= i; j++) {
	              // columns on left only affect minPageX
	              c = columns[j];
	              if (c.resizable) {
	                if (stretchLeewayOnLeft !== null) {
	                  if (c.maxWidth) {
	                    stretchLeewayOnLeft += c.maxWidth - c.previousWidth;
	                  } else {
	                    stretchLeewayOnLeft = null;
	                  }
	                }
	                shrinkLeewayOnLeft += c.previousWidth - Math.max(c.minWidth || 0, absoluteColumnMinWidth);
	              }
	            }
	            if (shrinkLeewayOnRight === null) {
	              shrinkLeewayOnRight = 100000;
	            }
	            if (shrinkLeewayOnLeft === null) {
	              shrinkLeewayOnLeft = 100000;
	            }
	            if (stretchLeewayOnRight === null) {
	              stretchLeewayOnRight = 100000;
	            }
	            if (stretchLeewayOnLeft === null) {
	              stretchLeewayOnLeft = 100000;
	            }
	            maxPageX = pageX + Math.min(shrinkLeewayOnRight, stretchLeewayOnLeft);
	            minPageX = pageX - Math.min(shrinkLeewayOnLeft, stretchLeewayOnRight);
	          })
	          .bind("drag", function (e, dd) {
	            var actualMinWidth, d = Math.min(maxPageX, Math.max(minPageX, e.pageX)) - pageX, x;
	            if (d < 0) { // shrink column
	              x = d;
	              for (j = i; j >= 0; j--) {
	                c = columns[j];
	                if (c.resizable) {
	                  actualMinWidth = Math.max(c.minWidth || 0, absoluteColumnMinWidth);
	                  if (x && c.previousWidth + x < actualMinWidth) {
	                    x += c.previousWidth - actualMinWidth;
	                    c.width = actualMinWidth;
	                  } else {
	                    c.width = c.previousWidth + x;
	                    x = 0;
	                  }
	                }
	              }
	
	              if (options.forceFitColumns) {
	                x = -d;
	                for (j = i + 1; j < columnElements.length; j++) {
	                  c = columns[j];
	                  if (c.resizable) {
	                    if (x && c.maxWidth && (c.maxWidth - c.previousWidth < x)) {
	                      x -= c.maxWidth - c.previousWidth;
	                      c.width = c.maxWidth;
	                    } else {
	                      c.width = c.previousWidth + x;
	                      x = 0;
	                    }
	                  }
	                }
	              }
	            } else { // stretch column
	              x = d;
	              for (j = i; j >= 0; j--) {
	                c = columns[j];
	                if (c.resizable) {
	                  if (x && c.maxWidth && (c.maxWidth - c.previousWidth < x)) {
	                    x -= c.maxWidth - c.previousWidth;
	                    c.width = c.maxWidth;
	                  } else {
	                    c.width = c.previousWidth + x;
	                    x = 0;
	                  }
	                }
	              }
	
	              if (options.forceFitColumns) {
	                x = -d;
	                for (j = i + 1; j < columnElements.length; j++) {
	                  c = columns[j];
	                  if (c.resizable) {
	                    actualMinWidth = Math.max(c.minWidth || 0, absoluteColumnMinWidth);
	                    if (x && c.previousWidth + x < actualMinWidth) {
	                      x += c.previousWidth - actualMinWidth;
	                      c.width = actualMinWidth;
	                    } else {
	                      c.width = c.previousWidth + x;
	                      x = 0;
	                    }
	                  }
	                }
	              }
	            }
	            applyColumnHeaderWidths();
	            if (options.syncColumnCellResize) {
	              applyColumnWidths();
	            }
	          })
	          .bind("dragend", function (e, dd) {
	            var newWidth;
	            $(this).parent().removeClass("slick-header-column-active");
	            for (j = 0; j < columnElements.length; j++) {
	              c = columns[j];
	              newWidth = $(columnElements[j]).outerWidth();
	
	              if (c.previousWidth !== newWidth && c.rerenderOnResize) {
	                invalidateAllRows();
	              }
	            }
	            updateCanvasWidth(true);
	            render();
	            trigger(self.onColumnsResized, {});
	          });
	    });
	  }
	
	  function getVBoxDelta($el) {
	    var p = ["borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"];
	    var delta = 0;
	    $.each(p, function (n, val) {
	      delta += parseFloat($el.css(val)) || 0;
	    });
	    return delta;
	  }
	
	  function measureCellPaddingAndBorder() {
	    var el;
	    var h = ["borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight"];
	    var v = ["borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"];
	
	    el = $("<div class='ui-state-default slick-header-column' style='visibility:hidden'>-</div>").appendTo($headers);
	    headerColumnWidthDiff = headerColumnHeightDiff = 0;
	    if (el.css("box-sizing") != "border-box" && el.css("-moz-box-sizing") != "border-box" && el.css("-webkit-box-sizing") != "border-box") {
	      $.each(h, function (n, val) {
	        headerColumnWidthDiff += parseFloat(el.css(val)) || 0;
	      });
	      $.each(v, function (n, val) {
	        headerColumnHeightDiff += parseFloat(el.css(val)) || 0;
	      });
	    }
	    el.remove();
	
	    var r = $("<div class='slick-row' />").appendTo($canvas);
	    el = $("<div class='slick-cell' id='' style='visibility:hidden'>-</div>").appendTo(r);
	    cellWidthDiff = cellHeightDiff = 0;
	    if (el.css("box-sizing") != "border-box" && el.css("-moz-box-sizing") != "border-box" && el.css("-webkit-box-sizing") != "border-box") {
	      $.each(h, function (n, val) {
	        cellWidthDiff += parseFloat(el.css(val)) || 0;
	      });
	      $.each(v, function (n, val) {
	        cellHeightDiff += parseFloat(el.css(val)) || 0;
	      });
	    }
	    r.remove();
	
	    absoluteColumnMinWidth = Math.max(headerColumnWidthDiff, cellWidthDiff);
	  }
	
	  function createCssRules() {
	    $style = $("<style type='text/css' rel='stylesheet' />").appendTo($("head"));
	    var rowHeight = (options.rowHeight - cellHeightDiff);
	    var rules = [
	      "." + uid + " .slick-header-column { left: 1000px; }",
	      "." + uid + " .slick-top-panel { height:" + options.topPanelHeight + "px; }",
	      "." + uid + " .slick-headerrow-columns { height:" + options.headerRowHeight + "px; }",
	      "." + uid + " .slick-cell { height:" + rowHeight + "px; }",
	      "." + uid + " .slick-row { height:" + options.rowHeight + "px; }"
	    ];
	
	    for (var i = 0; i < columns.length; i++) {
	      rules.push("." + uid + " .l" + i + " { }");
	      rules.push("." + uid + " .r" + i + " { }");
	    }
	
	    if ($style[0].styleSheet) { // IE
	      $style[0].styleSheet.cssText = rules.join(" ");
	    } else {
	      $style[0].appendChild(document.createTextNode(rules.join(" ")));
	    }
	
	    stylesheet = $style[0].sheet || $style[0].styleSheet; // IE8 -> styleSheet
	
	    // cache column CSS rules
	    columnCssRulesL = [];
	    columnCssRulesR = [];
	    var cssRules = (stylesheet.cssRules || stylesheet.rules);
	    var matches, columnIdx;
	    for (var i = 0; i < cssRules.length; i++) {
	      var selector = cssRules[i].selectorText;
	      if (matches = /\.l\d+/.exec(selector)) {
	        columnIdx = parseInt(matches[0].substr(2, matches[0].length - 2), 10);
	        columnCssRulesL[columnIdx] = cssRules[i];
	      } else if (matches = /\.r\d+/.exec(selector)) {
	        columnIdx = parseInt(matches[0].substr(2, matches[0].length - 2), 10);
	        columnCssRulesR[columnIdx] = cssRules[i];
	      }
	    }
	  }
	
	  function getColumnCssRules(idx) {
	    if (!stylesheet) {
	      createCssRules()
	    };
	
	    return {
	      "left": columnCssRulesL[idx],
	      "right": columnCssRulesR[idx]
	    };
	  }
	
	  function removeCssRules() {
	    $style.remove();
	    stylesheet = null;
	  }
	
	  function destroy() {
	    getEditorLock().cancelCurrentEdit();
	
	    trigger(self.onBeforeDestroy, {});
	
	    var i = plugins.length;
	    while(i--) {
	      unregisterPlugin(plugins[i]);
	    }
	
	    if (options.enableColumnReorder) {
	        $headers.filter(":ui-sortable").sortable("destroy");
	    }
	
	    unbindAncestorScrollEvents();
	    $container.unbind(".slickgrid");
	    removeCssRules();
	
	    $canvas.unbind("draginit dragstart dragend drag");
	    $container.empty().removeClass(uid);
	  }
	
	
	  //////////////////////////////////////////////////////////////////////////////////////////////
	  // General
	
	  function trigger(evt, args, e) {
	    e = e || new Slick.EventData();
	    args = args || {};
	    args.grid = self;
	    return evt.notify(args, e, self);
	  }
	
	  function getEditorLock() {
	    return options.editorLock;
	  }
	
	  function getEditController() {
	    return editController;
	  }
	
	  function getColumnIndex(id) {
	    return columnsById[id];
	  }
	
	  function autosizeColumns() {
	    var i, c,
	        widths = [],
	        shrinkLeeway = 0,
	        total = 0,
	        prevTotal,
	        availWidth = viewportHasVScroll ? viewportW - scrollbarDimensions.width : viewportW;
	
	    for (i = 0; i < columns.length; i++) {
	      c = columns[i];
	      widths.push(c.width);
	      total += c.width;
	      if (c.resizable) {
	        shrinkLeeway += c.width - Math.max(c.minWidth, absoluteColumnMinWidth);
	      }
	    }
	
	    // shrink
	    prevTotal = total;
	    while (total > availWidth && shrinkLeeway) {
	      var shrinkProportion = (total - availWidth) / shrinkLeeway;
	      for (i = 0; i < columns.length && total > availWidth; i++) {
	        c = columns[i];
	        var width = widths[i];
	        if (!c.resizable || width <= c.minWidth || width <= absoluteColumnMinWidth) {
	          continue;
	        }
	        var absMinWidth = Math.max(c.minWidth, absoluteColumnMinWidth);
	        var shrinkSize = Math.floor(shrinkProportion * (width - absMinWidth)) || 1;
	        shrinkSize = Math.min(shrinkSize, width - absMinWidth);
	        total -= shrinkSize;
	        shrinkLeeway -= shrinkSize;
	        widths[i] -= shrinkSize;
	      }
	      if (prevTotal <= total) {  // avoid infinite loop
	        break;
	      }
	      prevTotal = total;
	    }
	
	    // grow
	    prevTotal = total;
	    while (total < availWidth) {
	      var growProportion = availWidth / total;
	      for (i = 0; i < columns.length && total < availWidth; i++) {
	        c = columns[i];
	        var currentWidth = widths[i];
	        var growSize;
	
	        if (!c.resizable || c.maxWidth <= currentWidth) {
	          growSize = 0;
	        } else {
	          growSize = Math.min(Math.floor(growProportion * currentWidth) - currentWidth, (c.maxWidth - currentWidth) || 1000000) || 1;
	        }
	        total += growSize;
	        widths[i] += growSize;
	      }
	      if (prevTotal >= total) {  // avoid infinite loop
	        break;
	      }
	      prevTotal = total;
	    }
	
	    var reRender = false;
	    for (i = 0; i < columns.length; i++) {
	      if (columns[i].rerenderOnResize && columns[i].width != widths[i]) {
	        reRender = true;
	      }
	      columns[i].width = widths[i];
	    }
	
	    applyColumnHeaderWidths();
	    updateCanvasWidth(true);
	    if (reRender) {
	      invalidateAllRows();
	      render();
	    }
	  }
	
	  function applyColumnHeaderWidths() {
	    if (!initialized) { return; }
	    var h;
	    for (var i = 0, headers = $headers.children(), ii = headers.length; i < ii; i++) {
	      h = $(headers[i]);
	      if (h.width() !== columns[i].width - headerColumnWidthDiff) {
	        h.width(columns[i].width - headerColumnWidthDiff);
	      }
	    }
	
	    updateColumnCaches();
	  }
	
	  function applyColumnWidths() {
	    var x = 0, w, rule;
	    for (var i = 0; i < columns.length; i++) {
	      w = columns[i].width;
	
	      rule = getColumnCssRules(i);
	      rule.left.style.left = x + "px";
	      rule.right.style.right = (canvasWidth - x - w) + "px";
	
	      x += columns[i].width;
	    }
	  }
	
	  function setSortColumn(columnId, ascending) {
	    setSortColumns([{ columnId: columnId, sortAsc: ascending}]);
	  }
	
	  function setSortColumns(cols) {
	    sortColumns = cols;
	
	    var headerColumnEls = $headers.children();
	    headerColumnEls
	        .removeClass("slick-header-column-sorted")
	        .find(".slick-sort-indicator")
	            .removeClass("slick-sort-indicator-asc slick-sort-indicator-desc");
	
	    $.each(sortColumns, function(i, col) {
	      if (col.sortAsc == null) {
	        col.sortAsc = true;
	      }
	      var columnIndex = getColumnIndex(col.columnId);
	      if (columnIndex != null) {
	        headerColumnEls.eq(columnIndex)
	            .addClass("slick-header-column-sorted")
	            .find(".slick-sort-indicator")
	                .addClass(col.sortAsc ? "slick-sort-indicator-asc" : "slick-sort-indicator-desc");
	      }
	    });
	  }
	
	  function getSortColumns() {
	    return sortColumns;
	  }
	
	  function handleSelectedRangesChanged(e, ranges) {
	    selectedRows = [];
	    var hash = {};
	    for (var i = 0; i < ranges.length; i++) {
	      for (var j = ranges[i].fromRow; j <= ranges[i].toRow; j++) {
	        if (!hash[j]) {  // prevent duplicates
	          selectedRows.push(j);
	          hash[j] = {};
	        }
	        for (var k = ranges[i].fromCell; k <= ranges[i].toCell; k++) {
	          if (canCellBeSelected(j, k)) {
	            hash[j][columns[k].id] = options.selectedCellCssClass;
	          }
	        }
	      }
	    }
	
	    setCellCssStyles(options.selectedCellCssClass, hash);
	
	    trigger(self.onSelectedRowsChanged, {rows: getSelectedRows()}, e);
	  }
	
	  function getColumns() {
	    return columns;
	  }
	
	  function updateColumnCaches() {
	    // Pre-calculate cell boundaries.
	    columnPosLeft = [];
	    columnPosRight = [];
	    var x = 0;
	    for (var i = 0, ii = columns.length; i < ii; i++) {
	      columnPosLeft[i] = x;
	      columnPosRight[i] = x + columns[i].width;
	      x += columns[i].width;
	    }
	  }
	
	  function setColumns(columnDefinitions) {
	    columns = columnDefinitions;
	
	    columnsById = {};
	    for (var i = 0; i < columns.length; i++) {
	      var m = columns[i] = $.extend({}, columnDefaults, columns[i]);
	      columnsById[m.id] = i;
	      if (m.minWidth && m.width < m.minWidth) {
	        m.width = m.minWidth;
	      }
	      if (m.maxWidth && m.width > m.maxWidth) {
	        m.width = m.maxWidth;
	      }
	    }
	
	    updateColumnCaches();
	
	    if (initialized) {
	      invalidateAllRows();
	      createColumnHeaders();
	      removeCssRules();
	      createCssRules();
	      resizeCanvas();
	      applyColumnWidths();
	      handleScroll();
	    }
	  }
	
	  function getOptions() {
	    return options;
	  }
	
	  function setOptions(args) {
	    if (!getEditorLock().commitCurrentEdit()) {
	      return;
	    }
	
	    makeActiveCellNormal();
	
	    if (options.enableAddRow !== args.enableAddRow) {
	      invalidateRow(getDataLength());
	    }
	
	    options = $.extend(options, args);
	    validateAndEnforceOptions();
	
	    $viewport.css("overflow-y", options.autoHeight ? "hidden" : "auto");
	    render();
	  }
	
	  function validateAndEnforceOptions() {
	    if (options.autoHeight) {
	      options.leaveSpaceForNewRows = false;
	    }
	  }
	
	  function setData(newData, scrollToTop) {
	    data = newData;
	    invalidateAllRows();
	    updateRowCount();
	    if (scrollToTop) {
	      scrollTo(0);
	    }
	  }
	
	  function getData() {
	    return data;
	  }
	
	  function getDataLength() {
	    if (data.getLength) {
	      return data.getLength();
	    } else {
	      return data.length;
	    }
	  }
	
	  function getDataLengthIncludingAddNew() {
	    return getDataLength() + (options.enableAddRow ? 1 : 0);
	  }
	
	  function getDataItem(i) {
	    if (data.getItem) {
	      return data.getItem(i);
	    } else {
	      return data[i];
	    }
	  }
	
	  function getTopPanel() {
	    return $topPanel[0];
	  }
	
	  function setTopPanelVisibility(visible) {
	    if (options.showTopPanel != visible) {
	      options.showTopPanel = visible;
	      if (visible) {
	        $topPanelScroller.slideDown("fast", resizeCanvas);
	      } else {
	        $topPanelScroller.slideUp("fast", resizeCanvas);
	      }
	    }
	  }
	
	  function setHeaderRowVisibility(visible) {
	    if (options.showHeaderRow != visible) {
	      options.showHeaderRow = visible;
	      if (visible) {
	        $headerRowScroller.slideDown("fast", resizeCanvas);
	      } else {
	        $headerRowScroller.slideUp("fast", resizeCanvas);
	      }
	    }
	  }
	
	  function getContainerNode() {
	    return $container.get(0);
	  }
	
	  //////////////////////////////////////////////////////////////////////////////////////////////
	  // Rendering / Scrolling
	
	  function getRowTop(row) {
	    return options.rowHeight * row - offset;
	  }
	
	  function getRowFromPosition(y) {
	    return Math.floor((y + offset) / options.rowHeight);
	  }
	
	  function scrollTo(y) {
	    y = Math.max(y, 0);
	    y = Math.min(y, th - viewportH + (viewportHasHScroll ? scrollbarDimensions.height : 0));
	
	    var oldOffset = offset;
	
	    page = Math.min(n - 1, Math.floor(y / ph));
	    offset = Math.round(page * cj);
	    var newScrollTop = y - offset;
	
	    if (offset != oldOffset) {
	      var range = getVisibleRange(newScrollTop);
	      cleanupRows(range);
	      updateRowPositions();
	    }
	
	    if (prevScrollTop != newScrollTop) {
	      vScrollDir = (prevScrollTop + oldOffset < newScrollTop + offset) ? 1 : -1;
	      $viewport[0].scrollTop = (lastRenderedScrollTop = scrollTop = prevScrollTop = newScrollTop);
	
	      trigger(self.onViewportChanged, {});
	    }
	  }
	
	  function defaultFormatter(row, cell, value, columnDef, dataContext) {
	    if (value == null) {
	      return "";
	    } else {
	      return (value + "").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
	    }
	  }
	
	  function getFormatter(row, column) {
	    var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
	
	    // look up by id, then index
	    var columnOverrides = rowMetadata &&
	        rowMetadata.columns &&
	        (rowMetadata.columns[column.id] || rowMetadata.columns[getColumnIndex(column.id)]);
	
	    return (columnOverrides && columnOverrides.formatter) ||
	        (rowMetadata && rowMetadata.formatter) ||
	        column.formatter ||
	        (options.formatterFactory && options.formatterFactory.getFormatter(column)) ||
	        options.defaultFormatter;
	  }
	
	  function getEditor(row, cell) {
	    var column = columns[cell];
	    var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
	    var columnMetadata = rowMetadata && rowMetadata.columns;
	
	    if (columnMetadata && columnMetadata[column.id] && columnMetadata[column.id].editor !== undefined) {
	      return columnMetadata[column.id].editor;
	    }
	    if (columnMetadata && columnMetadata[cell] && columnMetadata[cell].editor !== undefined) {
	      return columnMetadata[cell].editor;
	    }
	
	    return column.editor || (options.editorFactory && options.editorFactory.getEditor(column));
	  }
	
	  function getDataItemValueForColumn(item, columnDef) {
	    if (options.dataItemColumnValueExtractor) {
	      return options.dataItemColumnValueExtractor(item, columnDef);
	    }
	    return item[columnDef.field];
	  }
	
	  function appendRowHtml(stringArray, row, range, dataLength) {
	    var d = getDataItem(row);
	    var dataLoading = row < dataLength && !d;
	    var rowCss = "slick-row" +
	        (dataLoading ? " loading" : "") +
	        (row === activeRow ? " active" : "") +
	        (row % 2 == 1 ? " odd" : " even");
	
	    if (!d) {
	      rowCss += " " + options.addNewRowCssClass;
	    }
	
	    var metadata = data.getItemMetadata && data.getItemMetadata(row);
	
	    if (metadata && metadata.cssClasses) {
	      rowCss += " " + metadata.cssClasses;
	    }
	
	    stringArray.push("<div class='ui-widget-content " + rowCss + "' style='top:" + getRowTop(row) + "px'>");
	
	    var colspan, m;
	    for (var i = 0, ii = columns.length; i < ii; i++) {
	      m = columns[i];
	      colspan = 1;
	      if (metadata && metadata.columns) {
	        var columnData = metadata.columns[m.id] || metadata.columns[i];
	        colspan = (columnData && columnData.colspan) || 1;
	        if (colspan === "*") {
	          colspan = ii - i;
	        }
	      }
	
	      // Do not render cells outside of the viewport.
	      if (columnPosRight[Math.min(ii - 1, i + colspan - 1)] > range.leftPx) {
	        if (columnPosLeft[i] > range.rightPx) {
	          // All columns to the right are outside the range.
	          break;
	        }
	
	        appendCellHtml(stringArray, row, i, colspan, d);
	      }
	
	      if (colspan > 1) {
	        i += (colspan - 1);
	      }
	    }
	
	    stringArray.push("</div>");
	  }
	
	  function appendCellHtml(stringArray, row, cell, colspan, item) {
	    var m = columns[cell];
	    var cellCss = "slick-cell l" + cell + " r" + Math.min(columns.length - 1, cell + colspan - 1) +
	        (m.cssClass ? " " + m.cssClass : "");
	    if (row === activeRow && cell === activeCell) {
	      cellCss += (" active");
	    }
	
	    // TODO:  merge them together in the setter
	    for (var key in cellCssClasses) {
	      if (cellCssClasses[key][row] && cellCssClasses[key][row][m.id]) {
	        cellCss += (" " + cellCssClasses[key][row][m.id]);
	      }
	    }
	
	    stringArray.push("<div class='" + cellCss + "'>");
	
	    // if there is a corresponding row (if not, this is the Add New row or this data hasn't been loaded yet)
	    if (item) {
	      var value = getDataItemValueForColumn(item, m);
	      stringArray.push(getFormatter(row, m)(row, cell, value, m, item));
	    }
	
	    stringArray.push("</div>");
	
	    rowsCache[row].cellRenderQueue.push(cell);
	    rowsCache[row].cellColSpans[cell] = colspan;
	  }
	
	
	  function cleanupRows(rangeToKeep) {
	    for (var i in rowsCache) {
	      if (((i = parseInt(i, 10)) !== activeRow) && (i < rangeToKeep.top || i > rangeToKeep.bottom)) {
	        removeRowFromCache(i);
	      }
	    }
	  }
	
	  function invalidate() {
	    updateRowCount();
	    invalidateAllRows();
	    render();
	  }
	
	  function invalidateAllRows() {
	    if (currentEditor) {
	      makeActiveCellNormal();
	    }
	    for (var row in rowsCache) {
	      removeRowFromCache(row);
	    }
	  }
	
	  function removeRowFromCache(row) {
	    var cacheEntry = rowsCache[row];
	    if (!cacheEntry) {
	      return;
	    }
	
	    if (rowNodeFromLastMouseWheelEvent == cacheEntry.rowNode) {
	      cacheEntry.rowNode.style.display = 'none';
	      zombieRowNodeFromLastMouseWheelEvent = rowNodeFromLastMouseWheelEvent;
	    } else {
	      $canvas[0].removeChild(cacheEntry.rowNode);
	    }
	
	    delete rowsCache[row];
	    delete postProcessedRows[row];
	    renderedRows--;
	    counter_rows_removed++;
	  }
	
	  function invalidateRows(rows) {
	    var i, rl;
	    if (!rows || !rows.length) {
	      return;
	    }
	    vScrollDir = 0;
	    for (i = 0, rl = rows.length; i < rl; i++) {
	      if (currentEditor && activeRow === rows[i]) {
	        makeActiveCellNormal();
	      }
	      if (rowsCache[rows[i]]) {
	        removeRowFromCache(rows[i]);
	      }
	    }
	  }
	
	  function invalidateRow(row) {
	    invalidateRows([row]);
	  }
	
	  function updateCell(row, cell) {
	    var cellNode = getCellNode(row, cell);
	    if (!cellNode) {
	      return;
	    }
	
	    var m = columns[cell], d = getDataItem(row);
	    if (currentEditor && activeRow === row && activeCell === cell) {
	      currentEditor.loadValue(d);
	    } else {
	      cellNode.innerHTML = d ? getFormatter(row, m)(row, cell, getDataItemValueForColumn(d, m), m, d) : "";
	      invalidatePostProcessingResults(row);
	    }
	  }
	
	  function updateRow(row) {
	    var cacheEntry = rowsCache[row];
	    if (!cacheEntry) {
	      return;
	    }
	
	    ensureCellNodesInRowsCache(row);
	
	    var d = getDataItem(row);
	
	    for (var columnIdx in cacheEntry.cellNodesByColumnIdx) {
	      if (!cacheEntry.cellNodesByColumnIdx.hasOwnProperty(columnIdx)) {
	        continue;
	      }
	
	      columnIdx = columnIdx | 0;
	      var m = columns[columnIdx],
	          node = cacheEntry.cellNodesByColumnIdx[columnIdx];
	
	      if (row === activeRow && columnIdx === activeCell && currentEditor) {
	        currentEditor.loadValue(d);
	      } else if (d) {
	        node.innerHTML = getFormatter(row, m)(row, columnIdx, getDataItemValueForColumn(d, m), m, d);
	      } else {
	        node.innerHTML = "";
	      }
	    }
	
	    invalidatePostProcessingResults(row);
	  }
	
	  function getViewportHeight() {
	    return parseFloat($.css($container[0], "height", true)) -
	        parseFloat($.css($container[0], "paddingTop", true)) -
	        parseFloat($.css($container[0], "paddingBottom", true)) -
	        parseFloat($.css($headerScroller[0], "height")) - getVBoxDelta($headerScroller) -
	        (options.showTopPanel ? options.topPanelHeight + getVBoxDelta($topPanelScroller) : 0) -
	        (options.showHeaderRow ? options.headerRowHeight + getVBoxDelta($headerRowScroller) : 0);
	  }
	
	  function resizeCanvas() {
	    if (!initialized) { return; }
	    if (options.autoHeight) {
	      viewportH = options.rowHeight * getDataLengthIncludingAddNew();
	    } else {
	      viewportH = getViewportHeight();
	    }
	
	    numVisibleRows = Math.ceil(viewportH / options.rowHeight);
	    viewportW = parseFloat($.css($container[0], "width", true));
	    if (!options.autoHeight) {
	      $viewport.height(viewportH);
	    }
	
	    if (options.forceFitColumns) {
	      autosizeColumns();
	    }
	
	    updateRowCount();
	    handleScroll();
	    // Since the width has changed, force the render() to reevaluate virtually rendered cells.
	    lastRenderedScrollLeft = -1;
	    render();
	  }
	
	  function updateRowCount() {
	    if (!initialized) { return; }
	
	    var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
	    var numberOfRows = dataLengthIncludingAddNew +
	        (options.leaveSpaceForNewRows ? numVisibleRows - 1 : 0);
	
	    var oldViewportHasVScroll = viewportHasVScroll;
	    // with autoHeight, we do not need to accommodate the vertical scroll bar
	    viewportHasVScroll = !options.autoHeight && (numberOfRows * options.rowHeight > viewportH);
	
	    makeActiveCellNormal();
	
	    // remove the rows that are now outside of the data range
	    // this helps avoid redundant calls to .removeRow() when the size of the data decreased by thousands of rows
	    var l = dataLengthIncludingAddNew - 1;
	    for (var i in rowsCache) {
	      if (i >= l) {
	        removeRowFromCache(i);
	      }
	    }
	
	    if (activeCellNode && activeRow > l) {
	      resetActiveCell();
	    }
	
	    var oldH = h;
	    th = Math.max(options.rowHeight * numberOfRows, viewportH - scrollbarDimensions.height);
	    if (th < maxSupportedCssHeight) {
	      // just one page
	      h = ph = th;
	      n = 1;
	      cj = 0;
	    } else {
	      // break into pages
	      h = maxSupportedCssHeight;
	      ph = h / 100;
	      n = Math.floor(th / ph);
	      cj = (th - h) / (n - 1);
	    }
	
	    if (h !== oldH) {
	      $canvas.css("height", h);
	      scrollTop = $viewport[0].scrollTop;
	    }
	
	    var oldScrollTopInRange = (scrollTop + offset <= th - viewportH);
	
	    if (th == 0 || scrollTop == 0) {
	      page = offset = 0;
	    } else if (oldScrollTopInRange) {
	      // maintain virtual position
	      scrollTo(scrollTop + offset);
	    } else {
	      // scroll to bottom
	      scrollTo(th - viewportH);
	    }
	
	    if (h != oldH && options.autoHeight) {
	      resizeCanvas();
	    }
	
	    if (options.forceFitColumns && oldViewportHasVScroll != viewportHasVScroll) {
	      autosizeColumns();
	    }
	    updateCanvasWidth(false);
	  }
	
	  function getVisibleRange(viewportTop, viewportLeft) {
	    if (viewportTop == null) {
	      viewportTop = scrollTop;
	    }
	    if (viewportLeft == null) {
	      viewportLeft = scrollLeft;
	    }
	
	    return {
	      top: getRowFromPosition(viewportTop),
	      bottom: getRowFromPosition(viewportTop + viewportH) + 1,
	      leftPx: viewportLeft,
	      rightPx: viewportLeft + viewportW
	    };
	  }
	
	  function getRenderedRange(viewportTop, viewportLeft) {
	    var range = getVisibleRange(viewportTop, viewportLeft);
	    var buffer = Math.round(viewportH / options.rowHeight);
	    var minBuffer = 3;
	
	    if (vScrollDir == -1) {
	      range.top -= buffer;
	      range.bottom += minBuffer;
	    } else if (vScrollDir == 1) {
	      range.top -= minBuffer;
	      range.bottom += buffer;
	    } else {
	      range.top -= minBuffer;
	      range.bottom += minBuffer;
	    }
	
	    range.top = Math.max(0, range.top);
	    range.bottom = Math.min(getDataLengthIncludingAddNew() - 1, range.bottom);
	
	    range.leftPx -= viewportW;
	    range.rightPx += viewportW;
	
	    range.leftPx = Math.max(0, range.leftPx);
	    range.rightPx = Math.min(canvasWidth, range.rightPx);
	
	    return range;
	  }
	
	  function ensureCellNodesInRowsCache(row) {
	    var cacheEntry = rowsCache[row];
	    if (cacheEntry) {
	      if (cacheEntry.cellRenderQueue.length) {
	        var lastChild = cacheEntry.rowNode.lastChild;
	        while (cacheEntry.cellRenderQueue.length) {
	          var columnIdx = cacheEntry.cellRenderQueue.pop();
	          cacheEntry.cellNodesByColumnIdx[columnIdx] = lastChild;
	          lastChild = lastChild.previousSibling;
	        }
	      }
	    }
	  }
	
	  function cleanUpCells(range, row) {
	    var totalCellsRemoved = 0;
	    var cacheEntry = rowsCache[row];
	
	    // Remove cells outside the range.
	    var cellsToRemove = [];
	    for (var i in cacheEntry.cellNodesByColumnIdx) {
	      // I really hate it when people mess with Array.prototype.
	      if (!cacheEntry.cellNodesByColumnIdx.hasOwnProperty(i)) {
	        continue;
	      }
	
	      // This is a string, so it needs to be cast back to a number.
	      i = i | 0;
	
	      var colspan = cacheEntry.cellColSpans[i];
	      if (columnPosLeft[i] > range.rightPx ||
	        columnPosRight[Math.min(columns.length - 1, i + colspan - 1)] < range.leftPx) {
	        if (!(row == activeRow && i == activeCell)) {
	          cellsToRemove.push(i);
	        }
	      }
	    }
	
	    var cellToRemove;
	    while ((cellToRemove = cellsToRemove.pop()) != null) {
	      cacheEntry.rowNode.removeChild(cacheEntry.cellNodesByColumnIdx[cellToRemove]);
	      delete cacheEntry.cellColSpans[cellToRemove];
	      delete cacheEntry.cellNodesByColumnIdx[cellToRemove];
	      if (postProcessedRows[row]) {
	        delete postProcessedRows[row][cellToRemove];
	      }
	      totalCellsRemoved++;
	    }
	  }
	
	  function cleanUpAndRenderCells(range) {
	    var cacheEntry;
	    var stringArray = [];
	    var processedRows = [];
	    var cellsAdded;
	    var totalCellsAdded = 0;
	    var colspan;
	
	    for (var row = range.top, btm = range.bottom; row <= btm; row++) {
	      cacheEntry = rowsCache[row];
	      if (!cacheEntry) {
	        continue;
	      }
	
	      // cellRenderQueue populated in renderRows() needs to be cleared first
	      ensureCellNodesInRowsCache(row);
	
	      cleanUpCells(range, row);
	
	      // Render missing cells.
	      cellsAdded = 0;
	
	      var metadata = data.getItemMetadata && data.getItemMetadata(row);
	      metadata = metadata && metadata.columns;
	
	      var d = getDataItem(row);
	
	      // TODO:  shorten this loop (index? heuristics? binary search?)
	      for (var i = 0, ii = columns.length; i < ii; i++) {
	        // Cells to the right are outside the range.
	        if (columnPosLeft[i] > range.rightPx) {
	          break;
	        }
	
	        // Already rendered.
	        if ((colspan = cacheEntry.cellColSpans[i]) != null) {
	          i += (colspan > 1 ? colspan - 1 : 0);
	          continue;
	        }
	
	        colspan = 1;
	        if (metadata) {
	          var columnData = metadata[columns[i].id] || metadata[i];
	          colspan = (columnData && columnData.colspan) || 1;
	          if (colspan === "*") {
	            colspan = ii - i;
	          }
	        }
	
	        if (columnPosRight[Math.min(ii - 1, i + colspan - 1)] > range.leftPx) {
	          appendCellHtml(stringArray, row, i, colspan, d);
	          cellsAdded++;
	        }
	
	        i += (colspan > 1 ? colspan - 1 : 0);
	      }
	
	      if (cellsAdded) {
	        totalCellsAdded += cellsAdded;
	        processedRows.push(row);
	      }
	    }
	
	    if (!stringArray.length) {
	      return;
	    }
	
	    var x = document.createElement("div");
	    x.innerHTML = stringArray.join("");
	
	    var processedRow;
	    var node;
	    while ((processedRow = processedRows.pop()) != null) {
	      cacheEntry = rowsCache[processedRow];
	      var columnIdx;
	      while ((columnIdx = cacheEntry.cellRenderQueue.pop()) != null) {
	        node = x.lastChild;
	        cacheEntry.rowNode.appendChild(node);
	        cacheEntry.cellNodesByColumnIdx[columnIdx] = node;
	      }
	    }
	  }
	
	  function renderRows(range) {
	    var parentNode = $canvas[0],
	        stringArray = [],
	        rows = [],
	        needToReselectCell = false,
	        dataLength = getDataLength();
	
	    for (var i = range.top, ii = range.bottom; i <= ii; i++) {
	      if (rowsCache[i]) {
	        continue;
	      }
	      renderedRows++;
	      rows.push(i);
	
	      // Create an entry right away so that appendRowHtml() can
	      // start populatating it.
	      rowsCache[i] = {
	        "rowNode": null,
	
	        // ColSpans of rendered cells (by column idx).
	        // Can also be used for checking whether a cell has been rendered.
	        "cellColSpans": [],
	
	        // Cell nodes (by column idx).  Lazy-populated by ensureCellNodesInRowsCache().
	        "cellNodesByColumnIdx": [],
	
	        // Column indices of cell nodes that have been rendered, but not yet indexed in
	        // cellNodesByColumnIdx.  These are in the same order as cell nodes added at the
	        // end of the row.
	        "cellRenderQueue": []
	      };
	
	      appendRowHtml(stringArray, i, range, dataLength);
	      if (activeCellNode && activeRow === i) {
	        needToReselectCell = true;
	      }
	      counter_rows_rendered++;
	    }
	
	    if (!rows.length) { return; }
	
	    var x = document.createElement("div");
	    x.innerHTML = stringArray.join("");
	
	    for (var i = 0, ii = rows.length; i < ii; i++) {
	      rowsCache[rows[i]].rowNode = parentNode.appendChild(x.firstChild);
	    }
	
	    if (needToReselectCell) {
	      activeCellNode = getCellNode(activeRow, activeCell);
	    }
	  }
	
	  function startPostProcessing() {
	    if (!options.enableAsyncPostRender) {
	      return;
	    }
	    clearTimeout(h_postrender);
	    h_postrender = setTimeout(asyncPostProcessRows, options.asyncPostRenderDelay);
	  }
	
	  function invalidatePostProcessingResults(row) {
	    delete postProcessedRows[row];
	    postProcessFromRow = Math.min(postProcessFromRow, row);
	    postProcessToRow = Math.max(postProcessToRow, row);
	    startPostProcessing();
	  }
	
	  function updateRowPositions() {
	    for (var row in rowsCache) {
	      rowsCache[row].rowNode.style.top = getRowTop(row) + "px";
	    }
	  }
	
	  function render() {
	    if (!initialized) { return; }
	    var visible = getVisibleRange();
	    var rendered = getRenderedRange();
	
	    // remove rows no longer in the viewport
	    cleanupRows(rendered);
	
	    // add new rows & missing cells in existing rows
	    if (lastRenderedScrollLeft != scrollLeft) {
	      cleanUpAndRenderCells(rendered);
	    }
	
	    // render missing rows
	    renderRows(rendered);
	
	    postProcessFromRow = visible.top;
	    postProcessToRow = Math.min(getDataLengthIncludingAddNew() - 1, visible.bottom);
	    startPostProcessing();
	
	    lastRenderedScrollTop = scrollTop;
	    lastRenderedScrollLeft = scrollLeft;
	    h_render = null;
	  }
	
	  function handleHeaderRowScroll() {
	    var scrollLeft = $headerRowScroller[0].scrollLeft;
	    if (scrollLeft != $viewport[0].scrollLeft) {
	      $viewport[0].scrollLeft = scrollLeft;
	    }
	  }
	
	  function handleScroll() {
	    scrollTop = $viewport[0].scrollTop;
	    scrollLeft = $viewport[0].scrollLeft;
	    var vScrollDist = Math.abs(scrollTop - prevScrollTop);
	    var hScrollDist = Math.abs(scrollLeft - prevScrollLeft);
	
	    if (hScrollDist) {
	      prevScrollLeft = scrollLeft;
	      $headerScroller[0].scrollLeft = scrollLeft;
	      $topPanelScroller[0].scrollLeft = scrollLeft;
	      $headerRowScroller[0].scrollLeft = scrollLeft;
	    }
	
	    if (vScrollDist) {
	      vScrollDir = prevScrollTop < scrollTop ? 1 : -1;
	      prevScrollTop = scrollTop;
	
	      // switch virtual pages if needed
	      if (vScrollDist < viewportH) {
	        scrollTo(scrollTop + offset);
	      } else {
	        var oldOffset = offset;
	        if (h == viewportH) {
	          page = 0;
	        } else {
	          page = Math.min(n - 1, Math.floor(scrollTop * ((th - viewportH) / (h - viewportH)) * (1 / ph)));
	        }
	        offset = Math.round(page * cj);
	        if (oldOffset != offset) {
	          invalidateAllRows();
	        }
	      }
	    }
	
	    if (hScrollDist || vScrollDist) {
	      if (h_render) {
	        clearTimeout(h_render);
	      }
	
	      if (Math.abs(lastRenderedScrollTop - scrollTop) > 20 ||
	          Math.abs(lastRenderedScrollLeft - scrollLeft) > 20) {
	        if (options.forceSyncScrolling || (
	            Math.abs(lastRenderedScrollTop - scrollTop) < viewportH &&
	            Math.abs(lastRenderedScrollLeft - scrollLeft) < viewportW)) {
	          render();
	        } else {
	          h_render = setTimeout(render, 50);
	        }
	
	        trigger(self.onViewportChanged, {});
	      }
	    }
	
	    trigger(self.onScroll, {scrollLeft: scrollLeft, scrollTop: scrollTop});
	  }
	
	  function asyncPostProcessRows() {
	    var dataLength = getDataLength();
	    while (postProcessFromRow <= postProcessToRow) {
	      var row = (vScrollDir >= 0) ? postProcessFromRow++ : postProcessToRow--;
	      var cacheEntry = rowsCache[row];
	      if (!cacheEntry || row >= dataLength) {
	        continue;
	      }
	
	      if (!postProcessedRows[row]) {
	        postProcessedRows[row] = {};
	      }
	
	      ensureCellNodesInRowsCache(row);
	      for (var columnIdx in cacheEntry.cellNodesByColumnIdx) {
	        if (!cacheEntry.cellNodesByColumnIdx.hasOwnProperty(columnIdx)) {
	          continue;
	        }
	
	        columnIdx = columnIdx | 0;
	
	        var m = columns[columnIdx];
	        if (m.asyncPostRender && !postProcessedRows[row][columnIdx]) {
	          var node = cacheEntry.cellNodesByColumnIdx[columnIdx];
	          if (node) {
	            m.asyncPostRender(node, row, getDataItem(row), m);
	          }
	          postProcessedRows[row][columnIdx] = true;
	        }
	      }
	
	      h_postrender = setTimeout(asyncPostProcessRows, options.asyncPostRenderDelay);
	      return;
	    }
	  }
	
	  function updateCellCssStylesOnRenderedRows(addedHash, removedHash) {
	    var node, columnId, addedRowHash, removedRowHash;
	    for (var row in rowsCache) {
	      removedRowHash = removedHash && removedHash[row];
	      addedRowHash = addedHash && addedHash[row];
	
	      if (removedRowHash) {
	        for (columnId in removedRowHash) {
	          if (!addedRowHash || removedRowHash[columnId] != addedRowHash[columnId]) {
	            node = getCellNode(row, getColumnIndex(columnId));
	            if (node) {
	              $(node).removeClass(removedRowHash[columnId]);
	            }
	          }
	        }
	      }
	
	      if (addedRowHash) {
	        for (columnId in addedRowHash) {
	          if (!removedRowHash || removedRowHash[columnId] != addedRowHash[columnId]) {
	            node = getCellNode(row, getColumnIndex(columnId));
	            if (node) {
	              $(node).addClass(addedRowHash[columnId]);
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function addCellCssStyles(key, hash) {
	    if (cellCssClasses[key]) {
	      throw "addCellCssStyles: cell CSS hash with key '" + key + "' already exists.";
	    }
	
	    cellCssClasses[key] = hash;
	    updateCellCssStylesOnRenderedRows(hash, null);
	
	    trigger(self.onCellCssStylesChanged, { "key": key, "hash": hash });
	  }
	
	  function removeCellCssStyles(key) {
	    if (!cellCssClasses[key]) {
	      return;
	    }
	
	    updateCellCssStylesOnRenderedRows(null, cellCssClasses[key]);
	    delete cellCssClasses[key];
	
	    trigger(self.onCellCssStylesChanged, { "key": key, "hash": null });
	  }
	
	  function setCellCssStyles(key, hash) {
	    var prevHash = cellCssClasses[key];
	
	    cellCssClasses[key] = hash;
	    updateCellCssStylesOnRenderedRows(hash, prevHash);
	
	    trigger(self.onCellCssStylesChanged, { "key": key, "hash": hash });
	  }
	
	  function getCellCssStyles(key) {
	    return cellCssClasses[key];
	  }
	
	  function flashCell(row, cell, speed) {
	    speed = speed || 100;
	    if (rowsCache[row]) {
	      var $cell = $(getCellNode(row, cell));
	
	      function toggleCellClass(times) {
	        if (!times) {
	          return;
	        }
	        setTimeout(function () {
	              $cell.queue(function () {
	                $cell.toggleClass(options.cellFlashingCssClass).dequeue();
	                toggleCellClass(times - 1);
	              });
	            },
	            speed);
	      }
	
	      toggleCellClass(4);
	    }
	  }
	
	  //////////////////////////////////////////////////////////////////////////////////////////////
	  // Interactivity
	
	  function handleMouseWheel(e) {
	    var rowNode = $(e.target).closest(".slick-row")[0];
	    if (rowNode != rowNodeFromLastMouseWheelEvent) {
	      if (zombieRowNodeFromLastMouseWheelEvent && zombieRowNodeFromLastMouseWheelEvent != rowNode) {
	        $canvas[0].removeChild(zombieRowNodeFromLastMouseWheelEvent);
	        zombieRowNodeFromLastMouseWheelEvent = null;
	      }
	      rowNodeFromLastMouseWheelEvent = rowNode;
	    }
	  }
	
	  function handleDragInit(e, dd) {
	    var cell = getCellFromEvent(e);
	    if (!cell || !cellExists(cell.row, cell.cell)) {
	      return false;
	    }
	
	    var retval = trigger(self.onDragInit, dd, e);
	    if (e.isImmediatePropagationStopped()) {
	      return retval;
	    }
	
	    // if nobody claims to be handling drag'n'drop by stopping immediate propagation,
	    // cancel out of it
	    return false;
	  }
	
	  function handleDragStart(e, dd) {
	    var cell = getCellFromEvent(e);
	    if (!cell || !cellExists(cell.row, cell.cell)) {
	      return false;
	    }
	
	    var retval = trigger(self.onDragStart, dd, e);
	    if (e.isImmediatePropagationStopped()) {
	      return retval;
	    }
	
	    return false;
	  }
	
	  function handleDrag(e, dd) {
	    return trigger(self.onDrag, dd, e);
	  }
	
	  function handleDragEnd(e, dd) {
	    trigger(self.onDragEnd, dd, e);
	  }
	
	  function handleKeyDown(e) {
	    trigger(self.onKeyDown, {row: activeRow, cell: activeCell}, e);
	    var handled = e.isImmediatePropagationStopped();
	
	    if (!handled) {
	      if (!e.shiftKey && !e.altKey && !e.ctrlKey) {
	        if (e.which == 27) { // esc
	          if (!getEditorLock().isActive()) {
	            return; // no editing mode to cancel, allow bubbling and default processing (exit without cancelling the event)
	          }
	          cancelEditAndSetFocus();
	        } else if (e.which == 34) { // space
	          navigatePageDown();
	          handled = true;
	        } else if (e.which == 33) { // pageup
	          navigatePageUp();
	          handled = true;
	        } else if (e.which == 37) { // pagedown
	          handled = navigateLeft();
	        } else if (e.which == 39) { // left
	          handled = navigateRight();
	        } else if (e.which == 38) { // right
	          handled = navigateUp();
	        } else if (e.which == 40) { // down
	          handled = navigateDown();
	        } else if (e.which == 9) { // tab
	          handled = navigateNext();
	        } else if (e.which == 13) { // enter
	          if (options.editable) {
	            if (currentEditor) {
	              // adding new row
	              if (activeRow === getDataLength()) {
	                navigateDown();
	              } else {
	                commitEditAndSetFocus();
	              }
	            } else {
	              if (getEditorLock().commitCurrentEdit()) {
	                makeActiveCellEditable();
	              }
	            }
	          }
	          handled = true;
	        }
	      } else if (e.which == 9 && e.shiftKey && !e.ctrlKey && !e.altKey) {
	        handled = navigatePrev(); // shift tab
	      }
	    }
	
	    if (handled) {
	      // the event has been handled so don't let parent element (bubbling/propagation) or browser (default) handle it
	      e.stopPropagation();
	      e.preventDefault();
	      try {
	        e.originalEvent.keyCode = 0; // prevent default behaviour for special keys in IE browsers (F3, F5, etc.)
	      }
	      // ignore exceptions - setting the original event's keycode throws access denied exception for "Ctrl"
	      // (hitting control key only, nothing else), "Shift" (maybe others)
	      catch (error) {
	      }
	    }
	  }
	
	  function handleClick(e) {
	    if (!currentEditor) {
	      // if this click resulted in some cell child node getting focus,
	      // don't steal it back - keyboard events will still bubble up
	      // IE9+ seems to default DIVs to tabIndex=0 instead of -1, so check for cell clicks directly.
	      if (e.target != document.activeElement || $(e.target).hasClass("slick-cell")) {
	        setFocus();
	      }
	    }
	
	    var cell = getCellFromEvent(e);
	    if (!cell || (currentEditor !== null && activeRow == cell.row && activeCell == cell.cell)) {
	      return;
	    }
	
	    trigger(self.onClick, {row: cell.row, cell: cell.cell}, e);
	    if (e.isImmediatePropagationStopped()) {
	      return;
	    }
	
	    if ((activeCell != cell.cell || activeRow != cell.row) && canCellBeActive(cell.row, cell.cell)) {
	      if (!getEditorLock().isActive() || getEditorLock().commitCurrentEdit()) {
	        scrollRowIntoView(cell.row, false);
	        setActiveCellInternal(getCellNode(cell.row, cell.cell));
	      }
	    }
	  }
	
	  function handleContextMenu(e) {
	    var $cell = $(e.target).closest(".slick-cell", $canvas);
	    if ($cell.length === 0) {
	      return;
	    }
	
	    // are we editing this cell?
	    if (activeCellNode === $cell[0] && currentEditor !== null) {
	      return;
	    }
	
	    trigger(self.onContextMenu, {}, e);
	  }
	
	  function handleDblClick(e) {
	    var cell = getCellFromEvent(e);
	    if (!cell || (currentEditor !== null && activeRow == cell.row && activeCell == cell.cell)) {
	      return;
	    }
	
	    trigger(self.onDblClick, {row: cell.row, cell: cell.cell}, e);
	    if (e.isImmediatePropagationStopped()) {
	      return;
	    }
	
	    if (options.editable) {
	      gotoCell(cell.row, cell.cell, true);
	    }
	  }
	
	  function handleHeaderMouseEnter(e) {
	    trigger(self.onHeaderMouseEnter, {
	      "column": $(this).data("column")
	    }, e);
	  }
	
	  function handleHeaderMouseLeave(e) {
	    trigger(self.onHeaderMouseLeave, {
	      "column": $(this).data("column")
	    }, e);
	  }
	
	  function handleHeaderContextMenu(e) {
	    var $header = $(e.target).closest(".slick-header-column", ".slick-header-columns");
	    var column = $header && $header.data("column");
	    trigger(self.onHeaderContextMenu, {column: column}, e);
	  }
	
	  function handleHeaderClick(e) {
	    var $header = $(e.target).closest(".slick-header-column", ".slick-header-columns");
	    var column = $header && $header.data("column");
	    if (column) {
	      trigger(self.onHeaderClick, {column: column}, e);
	    }
	  }
	
	  function handleMouseEnter(e) {
	    trigger(self.onMouseEnter, {}, e);
	  }
	
	  function handleMouseLeave(e) {
	    trigger(self.onMouseLeave, {}, e);
	  }
	
	  function cellExists(row, cell) {
	    return !(row < 0 || row >= getDataLength() || cell < 0 || cell >= columns.length);
	  }
	
	  function getCellFromPoint(x, y) {
	    var row = getRowFromPosition(y);
	    var cell = 0;
	
	    var w = 0;
	    for (var i = 0; i < columns.length && w < x; i++) {
	      w += columns[i].width;
	      cell++;
	    }
	
	    if (cell < 0) {
	      cell = 0;
	    }
	
	    return {row: row, cell: cell - 1};
	  }
	
	  function getCellFromNode(cellNode) {
	    // read column number from .l<columnNumber> CSS class
	    var cls = /l\d+/.exec(cellNode.className);
	    if (!cls) {
	      throw "getCellFromNode: cannot get cell - " + cellNode.className;
	    }
	    return parseInt(cls[0].substr(1, cls[0].length - 1), 10);
	  }
	
	  function getRowFromNode(rowNode) {
	    for (var row in rowsCache) {
	      if (rowsCache[row].rowNode === rowNode) {
	        return row | 0;
	      }
	    }
	
	    return null;
	  }
	
	  function getCellFromEvent(e) {
	    var $cell = $(e.target).closest(".slick-cell", $canvas);
	    if (!$cell.length) {
	      return null;
	    }
	
	    var row = getRowFromNode($cell[0].parentNode);
	    var cell = getCellFromNode($cell[0]);
	
	    if (row == null || cell == null) {
	      return null;
	    } else {
	      return {
	        "row": row,
	        "cell": cell
	      };
	    }
	  }
	
	  function getCellNodeBox(row, cell) {
	    if (!cellExists(row, cell)) {
	      return null;
	    }
	
	    var y1 = getRowTop(row);
	    var y2 = y1 + options.rowHeight - 1;
	    var x1 = 0;
	    for (var i = 0; i < cell; i++) {
	      x1 += columns[i].width;
	    }
	    var x2 = x1 + columns[cell].width;
	
	    return {
	      top: y1,
	      left: x1,
	      bottom: y2,
	      right: x2
	    };
	  }
	
	  //////////////////////////////////////////////////////////////////////////////////////////////
	  // Cell switching
	
	  function resetActiveCell() {
	    setActiveCellInternal(null, false);
	  }
	
	  function setFocus() {
	    if (tabbingDirection == -1) {
	      $focusSink[0].focus();
	    } else {
	      $focusSink2[0].focus();
	    }
	  }
	
	  function scrollCellIntoView(row, cell, doPaging) {
	    scrollRowIntoView(row, doPaging);
	
	    var colspan = getColspan(row, cell);
	    var left = columnPosLeft[cell],
	      right = columnPosRight[cell + (colspan > 1 ? colspan - 1 : 0)],
	      scrollRight = scrollLeft + viewportW;
	
	    if (left < scrollLeft) {
	      $viewport.scrollLeft(left);
	      handleScroll();
	      render();
	    } else if (right > scrollRight) {
	      $viewport.scrollLeft(Math.min(left, right - $viewport[0].clientWidth));
	      handleScroll();
	      render();
	    }
	  }
	
	  function setActiveCellInternal(newCell, opt_editMode) {
	    if (activeCellNode !== null) {
	      makeActiveCellNormal();
	      $(activeCellNode).removeClass("active");
	      if (rowsCache[activeRow]) {
	        $(rowsCache[activeRow].rowNode).removeClass("active");
	      }
	    }
	
	    var activeCellChanged = (activeCellNode !== newCell);
	    activeCellNode = newCell;
	
	    if (activeCellNode != null) {
	      activeRow = getRowFromNode(activeCellNode.parentNode);
	      activeCell = activePosX = getCellFromNode(activeCellNode);
	
	      if (opt_editMode == null) {
	        opt_editMode = (activeRow == getDataLength()) || options.autoEdit;
	      }
	
	      $(activeCellNode).addClass("active");
	      $(rowsCache[activeRow].rowNode).addClass("active");
	
	      if (options.editable && opt_editMode && isCellPotentiallyEditable(activeRow, activeCell)) {
	        clearTimeout(h_editorLoader);
	
	        if (options.asyncEditorLoading) {
	          h_editorLoader = setTimeout(function () {
	            makeActiveCellEditable();
	          }, options.asyncEditorLoadDelay);
	        } else {
	          makeActiveCellEditable();
	        }
	      }
	    } else {
	      activeRow = activeCell = null;
	    }
	
	    if (activeCellChanged) {
	      trigger(self.onActiveCellChanged, getActiveCell());
	    }
	  }
	
	  function clearTextSelection() {
	    if (document.selection && document.selection.empty) {
	      try {
	        //IE fails here if selected element is not in dom
	        document.selection.empty();
	      } catch (e) { }
	    } else if (window.getSelection) {
	      var sel = window.getSelection();
	      if (sel && sel.removeAllRanges) {
	        sel.removeAllRanges();
	      }
	    }
	  }
	
	  function isCellPotentiallyEditable(row, cell) {
	    var dataLength = getDataLength();
	    // is the data for this row loaded?
	    if (row < dataLength && !getDataItem(row)) {
	      return false;
	    }
	
	    // are we in the Add New row?  can we create new from this cell?
	    if (columns[cell].cannotTriggerInsert && row >= dataLength) {
	      return false;
	    }
	
	    // does this cell have an editor?
	    if (!getEditor(row, cell)) {
	      return false;
	    }
	
	    return true;
	  }
	
	  function makeActiveCellNormal() {
	    if (!currentEditor) {
	      return;
	    }
	    trigger(self.onBeforeCellEditorDestroy, {editor: currentEditor});
	    currentEditor.destroy();
	    currentEditor = null;
	
	    if (activeCellNode) {
	      var d = getDataItem(activeRow);
	      $(activeCellNode).removeClass("editable invalid");
	      if (d) {
	        var column = columns[activeCell];
	        var formatter = getFormatter(activeRow, column);
	        activeCellNode.innerHTML = formatter(activeRow, activeCell, getDataItemValueForColumn(d, column), column, d);
	        invalidatePostProcessingResults(activeRow);
	      }
	    }
	
	    // if there previously was text selected on a page (such as selected text in the edit cell just removed),
	    // IE can't set focus to anything else correctly
	    if (navigator.userAgent.toLowerCase().match(/msie/)) {
	      clearTextSelection();
	    }
	
	    getEditorLock().deactivate(editController);
	  }
	
	  function makeActiveCellEditable(editor) {
	    if (!activeCellNode) {
	      return;
	    }
	    if (!options.editable) {
	      throw "Grid : makeActiveCellEditable : should never get called when options.editable is false";
	    }
	
	    // cancel pending async call if there is one
	    clearTimeout(h_editorLoader);
	
	    if (!isCellPotentiallyEditable(activeRow, activeCell)) {
	      return;
	    }
	
	    var columnDef = columns[activeCell];
	    var item = getDataItem(activeRow);
	
	    if (trigger(self.onBeforeEditCell, {row: activeRow, cell: activeCell, item: item, column: columnDef}) === false) {
	      setFocus();
	      return;
	    }
	
	    getEditorLock().activate(editController);
	    $(activeCellNode).addClass("editable");
	
	    // don't clear the cell if a custom editor is passed through
	    if (!editor) {
	      activeCellNode.innerHTML = "";
	    }
	
	    currentEditor = new (editor || getEditor(activeRow, activeCell))({
	      grid: self,
	      gridPosition: absBox($container[0]),
	      position: absBox(activeCellNode),
	      container: activeCellNode,
	      column: columnDef,
	      item: item || {},
	      commitChanges: commitEditAndSetFocus,
	      cancelChanges: cancelEditAndSetFocus
	    });
	
	    if (item) {
	      currentEditor.loadValue(item);
	    }
	
	    serializedEditorValue = currentEditor.serializeValue();
	
	    if (currentEditor.position) {
	      handleActiveCellPositionChange();
	    }
	  }
	
	  function commitEditAndSetFocus() {
	    // if the commit fails, it would do so due to a validation error
	    // if so, do not steal the focus from the editor
	    if (getEditorLock().commitCurrentEdit()) {
	      setFocus();
	      if (options.autoEdit) {
	        navigateDown();
	      }
	    }
	  }
	
	  function cancelEditAndSetFocus() {
	    if (getEditorLock().cancelCurrentEdit()) {
	      setFocus();
	    }
	  }
	
	  function absBox(elem) {
	    var box = {
	      top: elem.offsetTop,
	      left: elem.offsetLeft,
	      bottom: 0,
	      right: 0,
	      width: $(elem).outerWidth(),
	      height: $(elem).outerHeight(),
	      visible: true};
	    box.bottom = box.top + box.height;
	    box.right = box.left + box.width;
	
	    // walk up the tree
	    var offsetParent = elem.offsetParent;
	    while ((elem = elem.parentNode) != document.body) {
	      if (box.visible && elem.scrollHeight != elem.offsetHeight && $(elem).css("overflowY") != "visible") {
	        box.visible = box.bottom > elem.scrollTop && box.top < elem.scrollTop + elem.clientHeight;
	      }
	
	      if (box.visible && elem.scrollWidth != elem.offsetWidth && $(elem).css("overflowX") != "visible") {
	        box.visible = box.right > elem.scrollLeft && box.left < elem.scrollLeft + elem.clientWidth;
	      }
	
	      box.left -= elem.scrollLeft;
	      box.top -= elem.scrollTop;
	
	      if (elem === offsetParent) {
	        box.left += elem.offsetLeft;
	        box.top += elem.offsetTop;
	        offsetParent = elem.offsetParent;
	      }
	
	      box.bottom = box.top + box.height;
	      box.right = box.left + box.width;
	    }
	
	    return box;
	  }
	
	  function getActiveCellPosition() {
	    return absBox(activeCellNode);
	  }
	
	  function getGridPosition() {
	    return absBox($container[0])
	  }
	
	  function handleActiveCellPositionChange() {
	    if (!activeCellNode) {
	      return;
	    }
	
	    trigger(self.onActiveCellPositionChanged, {});
	
	    if (currentEditor) {
	      var cellBox = getActiveCellPosition();
	      if (currentEditor.show && currentEditor.hide) {
	        if (!cellBox.visible) {
	          currentEditor.hide();
	        } else {
	          currentEditor.show();
	        }
	      }
	
	      if (currentEditor.position) {
	        currentEditor.position(cellBox);
	      }
	    }
	  }
	
	  function getCellEditor() {
	    return currentEditor;
	  }
	
	  function getActiveCell() {
	    if (!activeCellNode) {
	      return null;
	    } else {
	      return {row: activeRow, cell: activeCell};
	    }
	  }
	
	  function getActiveCellNode() {
	    return activeCellNode;
	  }
	
	  function scrollRowIntoView(row, doPaging) {
	    var rowAtTop = row * options.rowHeight;
	    var rowAtBottom = (row + 1) * options.rowHeight - viewportH + (viewportHasHScroll ? scrollbarDimensions.height : 0);
	
	    // need to page down?
	    if ((row + 1) * options.rowHeight > scrollTop + viewportH + offset) {
	      scrollTo(doPaging ? rowAtTop : rowAtBottom);
	      render();
	    }
	    // or page up?
	    else if (row * options.rowHeight < scrollTop + offset) {
	      scrollTo(doPaging ? rowAtBottom : rowAtTop);
	      render();
	    }
	  }
	
	  function scrollRowToTop(row) {
	    scrollTo(row * options.rowHeight);
	    render();
	  }
	
	  function scrollPage(dir) {
	    var deltaRows = dir * numVisibleRows;
	    scrollTo((getRowFromPosition(scrollTop) + deltaRows) * options.rowHeight);
	    render();
	
	    if (options.enableCellNavigation && activeRow != null) {
	      var row = activeRow + deltaRows;
	      var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
	      if (row >= dataLengthIncludingAddNew) {
	        row = dataLengthIncludingAddNew - 1;
	      }
	      if (row < 0) {
	        row = 0;
	      }
	
	      var cell = 0, prevCell = null;
	      var prevActivePosX = activePosX;
	      while (cell <= activePosX) {
	        if (canCellBeActive(row, cell)) {
	          prevCell = cell;
	        }
	        cell += getColspan(row, cell);
	      }
	
	      if (prevCell !== null) {
	        setActiveCellInternal(getCellNode(row, prevCell));
	        activePosX = prevActivePosX;
	      } else {
	        resetActiveCell();
	      }
	    }
	  }
	
	  function navigatePageDown() {
	    scrollPage(1);
	  }
	
	  function navigatePageUp() {
	    scrollPage(-1);
	  }
	
	  function getColspan(row, cell) {
	    var metadata = data.getItemMetadata && data.getItemMetadata(row);
	    if (!metadata || !metadata.columns) {
	      return 1;
	    }
	
	    var columnData = metadata.columns[columns[cell].id] || metadata.columns[cell];
	    var colspan = (columnData && columnData.colspan);
	    if (colspan === "*") {
	      colspan = columns.length - cell;
	    } else {
	      colspan = colspan || 1;
	    }
	
	    return colspan;
	  }
	
	  function findFirstFocusableCell(row) {
	    var cell = 0;
	    while (cell < columns.length) {
	      if (canCellBeActive(row, cell)) {
	        return cell;
	      }
	      cell += getColspan(row, cell);
	    }
	    return null;
	  }
	
	  function findLastFocusableCell(row) {
	    var cell = 0;
	    var lastFocusableCell = null;
	    while (cell < columns.length) {
	      if (canCellBeActive(row, cell)) {
	        lastFocusableCell = cell;
	      }
	      cell += getColspan(row, cell);
	    }
	    return lastFocusableCell;
	  }
	
	  function gotoRight(row, cell, posX) {
	    if (cell >= columns.length) {
	      return null;
	    }
	
	    do {
	      cell += getColspan(row, cell);
	    }
	    while (cell < columns.length && !canCellBeActive(row, cell));
	
	    if (cell < columns.length) {
	      return {
	        "row": row,
	        "cell": cell,
	        "posX": cell
	      };
	    }
	    return null;
	  }
	
	  function gotoLeft(row, cell, posX) {
	    if (cell <= 0) {
	      return null;
	    }
	
	    var firstFocusableCell = findFirstFocusableCell(row);
	    if (firstFocusableCell === null || firstFocusableCell >= cell) {
	      return null;
	    }
	
	    var prev = {
	      "row": row,
	      "cell": firstFocusableCell,
	      "posX": firstFocusableCell
	    };
	    var pos;
	    while (true) {
	      pos = gotoRight(prev.row, prev.cell, prev.posX);
	      if (!pos) {
	        return null;
	      }
	      if (pos.cell >= cell) {
	        return prev;
	      }
	      prev = pos;
	    }
	  }
	
	  function gotoDown(row, cell, posX) {
	    var prevCell;
	    var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
	    while (true) {
	      if (++row >= dataLengthIncludingAddNew) {
	        return null;
	      }
	
	      prevCell = cell = 0;
	      while (cell <= posX) {
	        prevCell = cell;
	        cell += getColspan(row, cell);
	      }
	
	      if (canCellBeActive(row, prevCell)) {
	        return {
	          "row": row,
	          "cell": prevCell,
	          "posX": posX
	        };
	      }
	    }
	  }
	
	  function gotoUp(row, cell, posX) {
	    var prevCell;
	    while (true) {
	      if (--row < 0) {
	        return null;
	      }
	
	      prevCell = cell = 0;
	      while (cell <= posX) {
	        prevCell = cell;
	        cell += getColspan(row, cell);
	      }
	
	      if (canCellBeActive(row, prevCell)) {
	        return {
	          "row": row,
	          "cell": prevCell,
	          "posX": posX
	        };
	      }
	    }
	  }
	
	  function gotoNext(row, cell, posX) {
	    if (row == null && cell == null) {
	      row = cell = posX = 0;
	      if (canCellBeActive(row, cell)) {
	        return {
	          "row": row,
	          "cell": cell,
	          "posX": cell
	        };
	      }
	    }
	
	    var pos = gotoRight(row, cell, posX);
	    if (pos) {
	      return pos;
	    }
	
	    var firstFocusableCell = null;
	    var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
	    while (++row < dataLengthIncludingAddNew) {
	      firstFocusableCell = findFirstFocusableCell(row);
	      if (firstFocusableCell !== null) {
	        return {
	          "row": row,
	          "cell": firstFocusableCell,
	          "posX": firstFocusableCell
	        };
	      }
	    }
	    return null;
	  }
	
	  function gotoPrev(row, cell, posX) {
	    if (row == null && cell == null) {
	      row = getDataLengthIncludingAddNew() - 1;
	      cell = posX = columns.length - 1;
	      if (canCellBeActive(row, cell)) {
	        return {
	          "row": row,
	          "cell": cell,
	          "posX": cell
	        };
	      }
	    }
	
	    var pos;
	    var lastSelectableCell;
	    while (!pos) {
	      pos = gotoLeft(row, cell, posX);
	      if (pos) {
	        break;
	      }
	      if (--row < 0) {
	        return null;
	      }
	
	      cell = 0;
	      lastSelectableCell = findLastFocusableCell(row);
	      if (lastSelectableCell !== null) {
	        pos = {
	          "row": row,
	          "cell": lastSelectableCell,
	          "posX": lastSelectableCell
	        };
	      }
	    }
	    return pos;
	  }
	
	  function navigateRight() {
	    return navigate("right");
	  }
	
	  function navigateLeft() {
	    return navigate("left");
	  }
	
	  function navigateDown() {
	    return navigate("down");
	  }
	
	  function navigateUp() {
	    return navigate("up");
	  }
	
	  function navigateNext() {
	    return navigate("next");
	  }
	
	  function navigatePrev() {
	    return navigate("prev");
	  }
	
	  /**
	   * @param {string} dir Navigation direction.
	   * @return {boolean} Whether navigation resulted in a change of active cell.
	   */
	  function navigate(dir) {
	    if (!options.enableCellNavigation) {
	      return false;
	    }
	
	    if (!activeCellNode && dir != "prev" && dir != "next") {
	      return false;
	    }
	
	    if (!getEditorLock().commitCurrentEdit()) {
	      return true;
	    }
	
	    if (options.editable) {
	      // steals focus from other controls on row navigation
	      setFocus();
	    }
	
	    var tabbingDirections = {
	      "up": -1,
	      "down": 1,
	      "left": -1,
	      "right": 1,
	      "prev": -1,
	      "next": 1
	    };
	    tabbingDirection = tabbingDirections[dir];
	
	    var stepFunctions = {
	      "up": gotoUp,
	      "down": gotoDown,
	      "left": gotoLeft,
	      "right": gotoRight,
	      "prev": gotoPrev,
	      "next": gotoNext
	    };
	    var stepFn = stepFunctions[dir];
	    var pos = stepFn(activeRow, activeCell, activePosX);
	    if (pos) {
	      var isAddNewRow = (pos.row == getDataLength());
	      scrollCellIntoView(pos.row, pos.cell, !isAddNewRow);
	      setActiveCellInternal(getCellNode(pos.row, pos.cell));
	      activePosX = pos.posX;
	      return true;
	    } else {
	      setActiveCellInternal(getCellNode(activeRow, activeCell));
	      return false;
	    }
	  }
	
	  function getCellNode(row, cell) {
	    if (rowsCache[row]) {
	      ensureCellNodesInRowsCache(row);
	      return rowsCache[row].cellNodesByColumnIdx[cell];
	    }
	    return null;
	  }
	
	  function setActiveCell(row, cell) {
	    if (!initialized) { return; }
	    if (row > getDataLength() || row < 0 || cell >= columns.length || cell < 0) {
	      return;
	    }
	
	    if (!options.enableCellNavigation) {
	      return;
	    }
	
	    scrollCellIntoView(row, cell, false);
	    setActiveCellInternal(getCellNode(row, cell), false);
	  }
	
	  function canCellBeActive(row, cell) {
	    if (!options.enableCellNavigation || row >= getDataLengthIncludingAddNew() ||
	        row < 0 || cell >= columns.length || cell < 0) {
	      return false;
	    }
	
	    var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
	    if (rowMetadata && typeof rowMetadata.focusable === "boolean") {
	      return rowMetadata.focusable;
	    }
	
	    var columnMetadata = rowMetadata && rowMetadata.columns;
	    if (columnMetadata && columnMetadata[columns[cell].id] && typeof columnMetadata[columns[cell].id].focusable === "boolean") {
	      return columnMetadata[columns[cell].id].focusable;
	    }
	    if (columnMetadata && columnMetadata[cell] && typeof columnMetadata[cell].focusable === "boolean") {
	      return columnMetadata[cell].focusable;
	    }
	
	    return columns[cell].focusable;
	  }
	
	  function canCellBeSelected(row, cell) {
	    if (row >= getDataLength() || row < 0 || cell >= columns.length || cell < 0) {
	      return false;
	    }
	
	    var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
	    if (rowMetadata && typeof rowMetadata.selectable === "boolean") {
	      return rowMetadata.selectable;
	    }
	
	    var columnMetadata = rowMetadata && rowMetadata.columns && (rowMetadata.columns[columns[cell].id] || rowMetadata.columns[cell]);
	    if (columnMetadata && typeof columnMetadata.selectable === "boolean") {
	      return columnMetadata.selectable;
	    }
	
	    return columns[cell].selectable;
	  }
	
	  function gotoCell(row, cell, forceEdit) {
	    if (!initialized) { return; }
	    if (!canCellBeActive(row, cell)) {
	      return;
	    }
	
	    if (!getEditorLock().commitCurrentEdit()) {
	      return;
	    }
	
	    scrollCellIntoView(row, cell, false);
	
	    var newCell = getCellNode(row, cell);
	
	    // if selecting the 'add new' row, start editing right away
	    setActiveCellInternal(newCell, forceEdit || (row === getDataLength()) || options.autoEdit);
	
	    // if no editor was created, set the focus back on the grid
	    if (!options.editable && $canvas.find(":focus").length !== 0) {
	      // steals focus when a row is programatically updated
	      setFocus();
	    }
	  }
	
	
	  //////////////////////////////////////////////////////////////////////////////////////////////
	  // IEditor implementation for the editor lock
	
	  function commitCurrentEdit() {
	    var item = getDataItem(activeRow);
	    var column = columns[activeCell];
	
	    if (currentEditor) {
	      if (currentEditor.isValueChanged()) {
	        var validationResults = currentEditor.validate();
	
	        if (validationResults.valid) {
	          if (activeRow < getDataLength()) {
	            var editCommand = {
	              row: activeRow,
	              cell: activeCell,
	              editor: currentEditor,
	              serializedValue: currentEditor.serializeValue(),
	              prevSerializedValue: serializedEditorValue,
	              execute: function () {
	                this.editor.applyValue(item, this.serializedValue);
	                updateRow(this.row);
	                trigger(self.onCellChange, {
	                  row: activeRow,
	                  cell: activeCell,
	                  item: item
	                });
	              },
	              undo: function () {
	                this.editor.applyValue(item, this.prevSerializedValue);
	                updateRow(this.row);
	                trigger(self.onCellChange, {
	                  row: activeRow,
	                  cell: activeCell,
	                  item: item
	                });
	              }
	            };
	
	            if (options.editCommandHandler) {
	              makeActiveCellNormal();
	              options.editCommandHandler(item, column, editCommand);
	            } else {
	              editCommand.execute();
	              makeActiveCellNormal();
	            }
	
	          } else {
	            var newItem = {};
	            currentEditor.applyValue(newItem, currentEditor.serializeValue());
	            makeActiveCellNormal();
	            trigger(self.onAddNewRow, {item: newItem, column: column});
	          }
	
	          // check whether the lock has been re-acquired by event handlers
	          return !getEditorLock().isActive();
	        } else {
	          // Re-add the CSS class to trigger transitions, if any.
	          $(activeCellNode).removeClass("invalid");
	          $(activeCellNode).width();  // force layout
	          $(activeCellNode).addClass("invalid");
	
	          trigger(self.onValidationError, {
	            editor: currentEditor,
	            cellNode: activeCellNode,
	            validationResults: validationResults,
	            row: activeRow,
	            cell: activeCell,
	            column: column
	          });
	
	          currentEditor.focus();
	          return false;
	        }
	      }
	
	      makeActiveCellNormal();
	    }
	    return true;
	  }
	
	  function cancelCurrentEdit() {
	    makeActiveCellNormal();
	    return true;
	  }
	
	  function rowsToRanges(rows) {
	    var ranges = [];
	    var lastCell = columns.length - 1;
	    for (var i = 0; i < rows.length; i++) {
	      ranges.push(new Slick.Range(rows[i], 0, rows[i], lastCell));
	    }
	    return ranges;
	  }
	
	  function getSelectedRows() {
	    if (!selectionModel) {
	      throw "Selection model is not set";
	    }
	    return selectedRows;
	  }
	
	  function setSelectedRows(rows) {
	    if (!selectionModel) {
	      throw "Selection model is not set";
	    }
	    selectionModel.setSelectedRanges(rowsToRanges(rows));
	  }
	
	
	  //////////////////////////////////////////////////////////////////////////////////////////////
	  // Debug
	
	  this.debug = function () {
	    var s = "";
	
	    s += ("\n" + "counter_rows_rendered:  " + counter_rows_rendered);
	    s += ("\n" + "counter_rows_removed:  " + counter_rows_removed);
	    s += ("\n" + "renderedRows:  " + renderedRows);
	    s += ("\n" + "numVisibleRows:  " + numVisibleRows);
	    s += ("\n" + "maxSupportedCssHeight:  " + maxSupportedCssHeight);
	    s += ("\n" + "n(umber of pages):  " + n);
	    s += ("\n" + "(current) page:  " + page);
	    s += ("\n" + "page height (ph):  " + ph);
	    s += ("\n" + "vScrollDir:  " + vScrollDir);
	
	    alert(s);
	  };
	
	  // a debug helper to be able to access private members
	  this.eval = function (expr) {
	    return eval(expr);
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////
	  // Public API
	
	  $.extend(this, {
	    "slickGridVersion": "2.1",
	
	    // Events
	    "onScroll": new Slick.Event(),
	    "onSort": new Slick.Event(),
	    "onHeaderMouseEnter": new Slick.Event(),
	    "onHeaderMouseLeave": new Slick.Event(),
	    "onHeaderContextMenu": new Slick.Event(),
	    "onHeaderClick": new Slick.Event(),
	    "onHeaderCellRendered": new Slick.Event(),
	    "onBeforeHeaderCellDestroy": new Slick.Event(),
	    "onHeaderRowCellRendered": new Slick.Event(),
	    "onBeforeHeaderRowCellDestroy": new Slick.Event(),
	    "onMouseEnter": new Slick.Event(),
	    "onMouseLeave": new Slick.Event(),
	    "onClick": new Slick.Event(),
	    "onDblClick": new Slick.Event(),
	    "onContextMenu": new Slick.Event(),
	    "onKeyDown": new Slick.Event(),
	    "onAddNewRow": new Slick.Event(),
	    "onValidationError": new Slick.Event(),
	    "onViewportChanged": new Slick.Event(),
	    "onColumnsReordered": new Slick.Event(),
	    "onColumnsResized": new Slick.Event(),
	    "onCellChange": new Slick.Event(),
	    "onBeforeEditCell": new Slick.Event(),
	    "onBeforeCellEditorDestroy": new Slick.Event(),
	    "onBeforeDestroy": new Slick.Event(),
	    "onActiveCellChanged": new Slick.Event(),
	    "onActiveCellPositionChanged": new Slick.Event(),
	    "onDragInit": new Slick.Event(),
	    "onDragStart": new Slick.Event(),
	    "onDrag": new Slick.Event(),
	    "onDragEnd": new Slick.Event(),
	    "onSelectedRowsChanged": new Slick.Event(),
	    "onCellCssStylesChanged": new Slick.Event(),
	
	    // Methods
	    "registerPlugin": registerPlugin,
	    "unregisterPlugin": unregisterPlugin,
	    "getColumns": getColumns,
	    "setColumns": setColumns,
	    "getColumnIndex": getColumnIndex,
	    "updateColumnHeader": updateColumnHeader,
	    "setSortColumn": setSortColumn,
	    "setSortColumns": setSortColumns,
	    "getSortColumns": getSortColumns,
	    "autosizeColumns": autosizeColumns,
	    "getOptions": getOptions,
	    "setOptions": setOptions,
	    "getData": getData,
	    "getDataLength": getDataLength,
	    "getDataItem": getDataItem,
	    "setData": setData,
	    "getSelectionModel": getSelectionModel,
	    "setSelectionModel": setSelectionModel,
	    "getSelectedRows": getSelectedRows,
	    "setSelectedRows": setSelectedRows,
	    "getContainerNode": getContainerNode,
	
	    "render": render,
	    "invalidate": invalidate,
	    "invalidateRow": invalidateRow,
	    "invalidateRows": invalidateRows,
	    "invalidateAllRows": invalidateAllRows,
	    "updateCell": updateCell,
	    "updateRow": updateRow,
	    "getViewport": getVisibleRange,
	    "getRenderedRange": getRenderedRange,
	    "resizeCanvas": resizeCanvas,
	    "updateRowCount": updateRowCount,
	    "scrollRowIntoView": scrollRowIntoView,
	    "scrollRowToTop": scrollRowToTop,
	    "scrollCellIntoView": scrollCellIntoView,
	    "getCanvasNode": getCanvasNode,
	    "focus": setFocus,
	
	    "getCellFromPoint": getCellFromPoint,
	    "getCellFromEvent": getCellFromEvent,
	    "getActiveCell": getActiveCell,
	    "setActiveCell": setActiveCell,
	    "getActiveCellNode": getActiveCellNode,
	    "getActiveCellPosition": getActiveCellPosition,
	    "resetActiveCell": resetActiveCell,
	    "editActiveCell": makeActiveCellEditable,
	    "getCellEditor": getCellEditor,
	    "getCellNode": getCellNode,
	    "getCellNodeBox": getCellNodeBox,
	    "canCellBeSelected": canCellBeSelected,
	    "canCellBeActive": canCellBeActive,
	    "navigatePrev": navigatePrev,
	    "navigateNext": navigateNext,
	    "navigateUp": navigateUp,
	    "navigateDown": navigateDown,
	    "navigateLeft": navigateLeft,
	    "navigateRight": navigateRight,
	    "navigatePageUp": navigatePageUp,
	    "navigatePageDown": navigatePageDown,
	    "gotoCell": gotoCell,
	    "getTopPanel": getTopPanel,
	    "setTopPanelVisibility": setTopPanelVisibility,
	    "setHeaderRowVisibility": setHeaderRowVisibility,
	    "getHeaderRow": getHeaderRow,
	    "getHeaderRowColumn": getHeaderRowColumn,
	    "getGridPosition": getGridPosition,
	    "flashCell": flashCell,
	    "addCellCssStyles": addCellCssStyles,
	    "setCellCssStyles": setCellCssStyles,
	    "removeCellCssStyles": removeCellCssStyles,
	    "getCellCssStyles": getCellCssStyles,
	
	    "init": finishInitialization,
	    "destroy": destroy,
	
	    // IEditor implementation
	    "getEditorLock": getEditorLock,
	    "getEditController": getEditController
	  });
	
	  init();
	}
	


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*!
	 * jquery.event.drag - v 2.2
	 * Copyright (c) 2010 Three Dub Media - http://threedubmedia.com
	 * Open Source MIT License - http://threedubmedia.com/code/license
	 */
	// Created: 2008-06-04
	// Updated: 2012-05-21
	// REQUIRES: jquery 1.7.x
	
	var $ = __webpack_require__(2);
	
	
	// add the jquery instance method
	$.fn.drag = function( str, arg, opts ){
		// figure out the event type
		var type = typeof str == "string" ? str : "",
		// figure out the event handler...
		fn = $.isFunction( str ) ? str : $.isFunction( arg ) ? arg : null;
		// fix the event type
		if ( type.indexOf("drag") !== 0 )
			type = "drag"+ type;
		// were options passed
		opts = ( str == fn ? arg : opts ) || {};
		// trigger or bind event handler
		return fn ? this.bind( type, opts, fn ) : this.trigger( type );
	};
	
	// local refs (increase compression)
	var $event = $.event,
	$special = $event.special,
	// configure the drag special event
	drag = $special.drag = {
	
		// these are the default settings
		defaults: {
			which: 1, // mouse button pressed to start drag sequence
			distance: 0, // distance dragged before dragstart
			not: ':input', // selector to suppress dragging on target elements
			handle: null, // selector to match handle target elements
			relative: false, // true to use "position", false to use "offset"
			drop: true, // false to suppress drop events, true or selector to allow
			click: false // false to suppress click events after dragend (no proxy)
		},
	
		// the key name for stored drag data
		datakey: "dragdata",
	
		// prevent bubbling for better performance
		noBubble: true,
	
		// count bound related events
		add: function( obj ){
			// read the interaction data
			var data = $.data( this, drag.datakey ),
			// read any passed options
			opts = obj.data || {};
			// count another realted event
			data.related += 1;
			// extend data options bound with this event
			// don't iterate "opts" in case it is a node
			$.each( drag.defaults, function( key, def ){
				if ( opts[ key ] !== undefined )
					data[ key ] = opts[ key ];
			});
		},
	
		// forget unbound related events
		remove: function(){
			$.data( this, drag.datakey ).related -= 1;
		},
	
		// configure interaction, capture settings
		setup: function(){
			// check for related events
			if ( $.data( this, drag.datakey ) )
				return;
			// initialize the drag data with copied defaults
			var data = $.extend({ related:0 }, drag.defaults );
			// store the interaction data
			$.data( this, drag.datakey, data );
			// bind the mousedown event, which starts drag interactions
			$event.add( this, "touchstart mousedown", drag.init, data );
			// prevent image dragging in IE...
			if ( this.attachEvent )
				this.attachEvent("ondragstart", drag.dontstart );
		},
	
		// destroy configured interaction
		teardown: function(){
			var data = $.data( this, drag.datakey ) || {};
			// check for related events
			if ( data.related )
				return;
			// remove the stored data
			$.removeData( this, drag.datakey );
			// remove the mousedown event
			$event.remove( this, "touchstart mousedown", drag.init );
			// enable text selection
			drag.textselect( true );
			// un-prevent image dragging in IE...
			if ( this.detachEvent )
				this.detachEvent("ondragstart", drag.dontstart );
		},
	
		// initialize the interaction
		init: function( event ){
			// sorry, only one touch at a time
			if ( drag.touched )
				return;
			// the drag/drop interaction data
			var dd = event.data, results;
			// check the which directive
			if ( event.which != 0 && dd.which > 0 && event.which != dd.which )
				return;
			// check for suppressed selector
			if ( $( event.target ).is( dd.not ) )
				return;
			// check for handle selector
			if ( dd.handle && !$( event.target ).closest( dd.handle, event.currentTarget ).length )
				return;
	
			drag.touched = event.type == 'touchstart' ? this : null;
			dd.propagates = 1;
			dd.mousedown = this;
			dd.interactions = [ drag.interaction( this, dd ) ];
			dd.target = event.target;
			dd.pageX = event.pageX;
			dd.pageY = event.pageY;
			dd.dragging = null;
			// handle draginit event...
			results = drag.hijack( event, "draginit", dd );
			// early cancel
			if ( !dd.propagates )
				return;
			// flatten the result set
			results = drag.flatten( results );
			// insert new interaction elements
			if ( results && results.length ){
				dd.interactions = [];
				$.each( results, function(){
					dd.interactions.push( drag.interaction( this, dd ) );
				});
			}
			// remember how many interactions are propagating
			dd.propagates = dd.interactions.length;
			// locate and init the drop targets
			if ( dd.drop !== false && $special.drop )
				$special.drop.handler( event, dd );
			// disable text selection
			drag.textselect( false );
			// bind additional events...
			if ( drag.touched )
				$event.add( drag.touched, "touchmove touchend", drag.handler, dd );
			else
				$event.add( document, "mousemove mouseup", drag.handler, dd );
			// helps prevent text selection or scrolling
			if ( !drag.touched || dd.live )
				return false;
		},
	
		// returns an interaction object
		interaction: function( elem, dd ){
			var offset = $( elem )[ dd.relative ? "position" : "offset" ]() || { top:0, left:0 };
			return {
				drag: elem,
				callback: new drag.callback(),
				droppable: [],
				offset: offset
			};
		},
	
		// handle drag-releatd DOM events
		handler: function( event ){
			// read the data before hijacking anything
			var dd = event.data;
			// handle various events
			switch ( event.type ){
				// mousemove, check distance, start dragging
				case !dd.dragging && 'touchmove':
					event.preventDefault();
				case !dd.dragging && 'mousemove':
					//  drag tolerance, x² + y² = distance²
					if ( Math.pow(  event.pageX-dd.pageX, 2 ) + Math.pow(  event.pageY-dd.pageY, 2 ) < Math.pow( dd.distance, 2 ) )
						break; // distance tolerance not reached
					event.target = dd.target; // force target from "mousedown" event (fix distance issue)
					drag.hijack( event, "dragstart", dd ); // trigger "dragstart"
					if ( dd.propagates ) // "dragstart" not rejected
						dd.dragging = true; // activate interaction
				// mousemove, dragging
				case 'touchmove':
					event.preventDefault();
				case 'mousemove':
					if ( dd.dragging ){
						// trigger "drag"
						drag.hijack( event, "drag", dd );
						if ( dd.propagates ){
							// manage drop events
							if ( dd.drop !== false && $special.drop )
								$special.drop.handler( event, dd ); // "dropstart", "dropend"
							break; // "drag" not rejected, stop
						}
						event.type = "mouseup"; // helps "drop" handler behave
					}
				// mouseup, stop dragging
				case 'touchend':
				case 'mouseup':
				default:
					if ( drag.touched )
						$event.remove( drag.touched, "touchmove touchend", drag.handler ); // remove touch events
					else
						$event.remove( document, "mousemove mouseup", drag.handler ); // remove page events
					if ( dd.dragging ){
						if ( dd.drop !== false && $special.drop )
							$special.drop.handler( event, dd ); // "drop"
						drag.hijack( event, "dragend", dd ); // trigger "dragend"
					}
					drag.textselect( true ); // enable text selection
					// if suppressing click events...
					if ( dd.click === false && dd.dragging )
						$.data( dd.mousedown, "suppress.click", new Date().getTime() + 5 );
					dd.dragging = drag.touched = false; // deactivate element
					break;
			}
		},
	
		// re-use event object for custom events
		hijack: function( event, type, dd, x, elem ){
			// not configured
			if ( !dd )
				return;
			// remember the original event and type
			var orig = { event:event.originalEvent, type:event.type },
			// is the event drag related or drog related?
			mode = type.indexOf("drop") ? "drag" : "drop",
			// iteration vars
			result, i = x || 0, ia, $elems, callback,
			len = !isNaN( x ) ? x : dd.interactions.length;
			// modify the event type
			event.type = type;
			// remove the original event
			event.originalEvent = null;
			// initialize the results
			dd.results = [];
			// handle each interacted element
			do if ( ia = dd.interactions[ i ] ){
				// validate the interaction
				if ( type !== "dragend" && ia.cancelled )
					continue;
				// set the dragdrop properties on the event object
				callback = drag.properties( event, dd, ia );
				// prepare for more results
				ia.results = [];
				// handle each element
				$( elem || ia[ mode ] || dd.droppable ).each(function( p, subject ){
					// identify drag or drop targets individually
					callback.target = subject;
					// force propagtion of the custom event
					event.isPropagationStopped = function(){ return false; };
					// handle the event
					result = subject ? $event.dispatch.call( subject, event, callback ) : null;
					// stop the drag interaction for this element
					if ( result === false ){
						if ( mode == "drag" ){
							ia.cancelled = true;
							dd.propagates -= 1;
						}
						if ( type == "drop" ){
							ia[ mode ][p] = null;
						}
					}
					// assign any dropinit elements
					else if ( type == "dropinit" )
						ia.droppable.push( drag.element( result ) || subject );
					// accept a returned proxy element
					if ( type == "dragstart" )
						ia.proxy = $( drag.element( result ) || ia.drag )[0];
					// remember this result
					ia.results.push( result );
					// forget the event result, for recycling
					delete event.result;
					// break on cancelled handler
					if ( type !== "dropinit" )
						return result;
				});
				// flatten the results
				dd.results[ i ] = drag.flatten( ia.results );
				// accept a set of valid drop targets
				if ( type == "dropinit" )
					ia.droppable = drag.flatten( ia.droppable );
				// locate drop targets
				if ( type == "dragstart" && !ia.cancelled )
					callback.update();
			}
			while ( ++i < len )
			// restore the original event & type
			event.type = orig.type;
			event.originalEvent = orig.event;
			// return all handler results
			return drag.flatten( dd.results );
		},
	
		// extend the callback object with drag/drop properties...
		properties: function( event, dd, ia ){
			var obj = ia.callback;
			// elements
			obj.drag = ia.drag;
			obj.proxy = ia.proxy || ia.drag;
			// starting mouse position
			obj.startX = dd.pageX;
			obj.startY = dd.pageY;
			// current distance dragged
			obj.deltaX = event.pageX - dd.pageX;
			obj.deltaY = event.pageY - dd.pageY;
			// original element position
			obj.originalX = ia.offset.left;
			obj.originalY = ia.offset.top;
			// adjusted element position
			obj.offsetX = obj.originalX + obj.deltaX;
			obj.offsetY = obj.originalY + obj.deltaY;
			// assign the drop targets information
			obj.drop = drag.flatten( ( ia.drop || [] ).slice() );
			obj.available = drag.flatten( ( ia.droppable || [] ).slice() );
			return obj;
		},
	
		// determine is the argument is an element or jquery instance
		element: function( arg ){
			if ( arg && ( arg.jquery || arg.nodeType == 1 ) )
				return arg;
		},
	
		// flatten nested jquery objects and arrays into a single dimension array
		flatten: function( arr ){
			return $.map( arr, function( member ){
				return member && member.jquery ? $.makeArray( member ) :
					member && member.length ? drag.flatten( member ) : member;
			});
		},
	
		// toggles text selection attributes ON (true) or OFF (false)
		textselect: function( bool ){
			$( document )[ bool ? "unbind" : "bind" ]("selectstart", drag.dontstart )
				.css("MozUserSelect", bool ? "" : "none" );
			// .attr("unselectable", bool ? "off" : "on" )
			document.unselectable = bool ? "off" : "on";
		},
	
		// suppress "selectstart" and "ondragstart" events
		dontstart: function(){
			return false;
		},
	
		// a callback instance contructor
		callback: function(){}
	
	};
	
	// callback methods
	drag.callback.prototype = {
		update: function(){
			if ( $special.drop && this.available.length )
				$.each( this.available, function( i ){
					$special.drop.locate( this, i );
				});
		}
	};
	
	// patch $.event.$dispatch to allow suppressing clicks
	var $dispatch = $event.dispatch;
	$event.dispatch = function( event ){
		if ( $.data( this, "suppress."+ event.type ) - new Date().getTime() > 0 ){
			$.removeData( this, "suppress."+ event.type );
			return;
		}
		return $dispatch.apply( this, arguments );
	};
	
	// event fix hooks for touch events...
	var touchHooks =
	$event.fixHooks.touchstart =
	$event.fixHooks.touchmove =
	$event.fixHooks.touchend =
	$event.fixHooks.touchcancel = {
		props: "clientX clientY pageX pageY screenX screenY".split( " " ),
		filter: function( event, orig ) {
			if ( orig ){
				var touched = ( orig.touches && orig.touches[0] )
					|| ( orig.changedTouches && orig.changedTouches[0] )
					|| null;
				// iOS webkit: touchstart, touchmove, touchend
				if ( touched )
					$.each( touchHooks.props, function( i, prop ){
						event[ prop ] = touched[ prop ];
					});
			}
			return event;
		}
	};
	
	// share the same special event configuration with related events...
	$special.draginit = $special.dragstart = $special.dragend = drag;
	


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*! jQuery UI - v1.10.1 - 2013-02-21
	* http://jqueryui.com
	* Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.sortable.js
	* Copyright (c) 2013 jQuery Foundation and other contributors Licensed MIT */
	
	var $ = __webpack_require__(2);
	
	(function( undefined ) {
	
	var uuid = 0,
		runiqueId = /^ui-id-\d+$/;
	
	// prevent duplicate loading
	// this is only a problem because we proxy existing functions
	// and we don't want to double proxy them
	$.ui = $.ui || {};
	if ( $.ui.version ) {
		return;
	}
	
	$.extend( $.ui, {
		version: "1.10.1",
	
		keyCode: {
			BACKSPACE: 8,
			COMMA: 188,
			DELETE: 46,
			DOWN: 40,
			END: 35,
			ENTER: 13,
			ESCAPE: 27,
			HOME: 36,
			LEFT: 37,
			NUMPAD_ADD: 107,
			NUMPAD_DECIMAL: 110,
			NUMPAD_DIVIDE: 111,
			NUMPAD_ENTER: 108,
			NUMPAD_MULTIPLY: 106,
			NUMPAD_SUBTRACT: 109,
			PAGE_DOWN: 34,
			PAGE_UP: 33,
			PERIOD: 190,
			RIGHT: 39,
			SPACE: 32,
			TAB: 9,
			UP: 38
		}
	});
	
	// plugins
	$.fn.extend({
		_focus: $.fn.focus,
		focus: function( delay, fn ) {
			return typeof delay === "number" ?
				this.each(function() {
					var elem = this;
					setTimeout(function() {
						$( elem ).focus();
						if ( fn ) {
							fn.call( elem );
						}
					}, delay );
				}) :
				this._focus.apply( this, arguments );
		},
	
		scrollParent: function() {
			var scrollParent;
			if (($.ui.ie && (/(static|relative)/).test(this.css("position"))) || (/absolute/).test(this.css("position"))) {
				scrollParent = this.parents().filter(function() {
					return (/(relative|absolute|fixed)/).test($.css(this,"position")) && (/(auto|scroll)/).test($.css(this,"overflow")+$.css(this,"overflow-y")+$.css(this,"overflow-x"));
				}).eq(0);
			} else {
				scrollParent = this.parents().filter(function() {
					return (/(auto|scroll)/).test($.css(this,"overflow")+$.css(this,"overflow-y")+$.css(this,"overflow-x"));
				}).eq(0);
			}
	
			return (/fixed/).test(this.css("position")) || !scrollParent.length ? $(document) : scrollParent;
		},
	
		zIndex: function( zIndex ) {
			if ( zIndex !== undefined ) {
				return this.css( "zIndex", zIndex );
			}
	
			if ( this.length ) {
				var elem = $( this[ 0 ] ), position, value;
				while ( elem.length && elem[ 0 ] !== document ) {
					// Ignore z-index if position is set to a value where z-index is ignored by the browser
					// This makes behavior of this function consistent across browsers
					// WebKit always returns auto if the element is positioned
					position = elem.css( "position" );
					if ( position === "absolute" || position === "relative" || position === "fixed" ) {
						// IE returns 0 when zIndex is not specified
						// other browsers return a string
						// we ignore the case of nested elements with an explicit value of 0
						// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
						value = parseInt( elem.css( "zIndex" ), 10 );
						if ( !isNaN( value ) && value !== 0 ) {
							return value;
						}
					}
					elem = elem.parent();
				}
			}
	
			return 0;
		},
	
		uniqueId: function() {
			return this.each(function() {
				if ( !this.id ) {
					this.id = "ui-id-" + (++uuid);
				}
			});
		},
	
		removeUniqueId: function() {
			return this.each(function() {
				if ( runiqueId.test( this.id ) ) {
					$( this ).removeAttr( "id" );
				}
			});
		}
	});
	
	// selectors
	function focusable( element, isTabIndexNotNaN ) {
		var map, mapName, img,
			nodeName = element.nodeName.toLowerCase();
		if ( "area" === nodeName ) {
			map = element.parentNode;
			mapName = map.name;
			if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
				return false;
			}
			img = $( "img[usemap=#" + mapName + "]" )[0];
			return !!img && visible( img );
		}
		return ( /input|select|textarea|button|object/.test( nodeName ) ?
			!element.disabled :
			"a" === nodeName ?
				element.href || isTabIndexNotNaN :
				isTabIndexNotNaN) &&
			// the element and all of its ancestors must be visible
			visible( element );
	}
	
	function visible( element ) {
		return $.expr.filters.visible( element ) &&
			!$( element ).parents().addBack().filter(function() {
				return $.css( this, "visibility" ) === "hidden";
			}).length;
	}
	
	$.extend( $.expr[ ":" ], {
		data: $.expr.createPseudo ?
			$.expr.createPseudo(function( dataName ) {
				return function( elem ) {
					return !!$.data( elem, dataName );
				};
			}) :
			// support: jQuery <1.8
			function( elem, i, match ) {
				return !!$.data( elem, match[ 3 ] );
			},
	
		focusable: function( element ) {
			return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
		},
	
		tabbable: function( element ) {
			var tabIndex = $.attr( element, "tabindex" ),
				isTabIndexNaN = isNaN( tabIndex );
			return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
		}
	});
	
	// support: jQuery <1.8
	if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
		$.each( [ "Width", "Height" ], function( i, name ) {
			var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
				type = name.toLowerCase(),
				orig = {
					innerWidth: $.fn.innerWidth,
					innerHeight: $.fn.innerHeight,
					outerWidth: $.fn.outerWidth,
					outerHeight: $.fn.outerHeight
				};
	
			function reduce( elem, size, border, margin ) {
				$.each( side, function() {
					size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
					if ( border ) {
						size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
					}
					if ( margin ) {
						size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
					}
				});
				return size;
			}
	
			$.fn[ "inner" + name ] = function( size ) {
				if ( size === undefined ) {
					return orig[ "inner" + name ].call( this );
				}
	
				return this.each(function() {
					$( this ).css( type, reduce( this, size ) + "px" );
				});
			};
	
			$.fn[ "outer" + name] = function( size, margin ) {
				if ( typeof size !== "number" ) {
					return orig[ "outer" + name ].call( this, size );
				}
	
				return this.each(function() {
					$( this).css( type, reduce( this, size, true, margin ) + "px" );
				});
			};
		});
	}
	
	// support: jQuery <1.8
	if ( !$.fn.addBack ) {
		$.fn.addBack = function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		};
	}
	
	// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
	if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
		$.fn.removeData = (function( removeData ) {
			return function( key ) {
				if ( arguments.length ) {
					return removeData.call( this, $.camelCase( key ) );
				} else {
					return removeData.call( this );
				}
			};
		})( $.fn.removeData );
	}
	
	
	
	
	
	// deprecated
	$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
	
	$.support.selectstart = "onselectstart" in document.createElement( "div" );
	$.fn.extend({
		disableSelection: function() {
			return this.bind( ( $.support.selectstart ? "selectstart" : "mousedown" ) +
				".ui-disableSelection", function( event ) {
					event.preventDefault();
				});
		},
	
		enableSelection: function() {
			return this.unbind( ".ui-disableSelection" );
		}
	});
	
	$.extend( $.ui, {
		// $.ui.plugin is deprecated.  Use the proxy pattern instead.
		plugin: {
			add: function( module, option, set ) {
				var i,
					proto = $.ui[ module ].prototype;
				for ( i in set ) {
					proto.plugins[ i ] = proto.plugins[ i ] || [];
					proto.plugins[ i ].push( [ option, set[ i ] ] );
				}
			},
			call: function( instance, name, args ) {
				var i,
					set = instance.plugins[ name ];
				if ( !set || !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) {
					return;
				}
	
				for ( i = 0; i < set.length; i++ ) {
					if ( instance.options[ set[ i ][ 0 ] ] ) {
						set[ i ][ 1 ].apply( instance.element, args );
					}
				}
			}
		},
	
		// only used by resizable
		hasScroll: function( el, a ) {
	
			//If overflow is hidden, the element might have extra content, but the user wants to hide it
			if ( $( el ).css( "overflow" ) === "hidden") {
				return false;
			}
	
			var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
				has = false;
	
			if ( el[ scroll ] > 0 ) {
				return true;
			}
	
			// TODO: determine which cases actually cause this to happen
			// if the element doesn't have the scroll set, see if it's possible to
			// set the scroll
			el[ scroll ] = 1;
			has = ( el[ scroll ] > 0 );
			el[ scroll ] = 0;
			return has;
		}
	});
	
	})();
	(function( undefined ) {
	
	var uuid = 0,
		slice = Array.prototype.slice,
		_cleanData = $.cleanData;
	$.cleanData = function( elems ) {
		for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
			try {
				$( elem ).triggerHandler( "remove" );
			// http://bugs.jquery.com/ticket/8235
			} catch( e ) {}
		}
		_cleanData( elems );
	};
	
	$.widget = function( name, base, prototype ) {
		var fullName, existingConstructor, constructor, basePrototype,
			// proxiedPrototype allows the provided prototype to remain unmodified
			// so that it can be used as a mixin for multiple widgets (#8876)
			proxiedPrototype = {},
			namespace = name.split( "." )[ 0 ];
	
		name = name.split( "." )[ 1 ];
		fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		// create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
			// allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
		// extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
			// copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
			// track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		});
	
		basePrototype = new base();
		// we need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = (function() {
				var _super = function() {
						return base.prototype[ prop ].apply( this, arguments );
					},
					_superApply = function( args ) {
						return base.prototype[ prop ].apply( this, args );
					};
				return function() {
					var __super = this._super,
						__superApply = this._superApply,
						returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			})();
		});
		constructor.prototype = $.widget.extend( basePrototype, {
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		});
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
			});
			// remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	};
	
	$.widget.extend = function( target ) {
		var input = slice.call( arguments, 1 ),
			inputIndex = 0,
			inputLength = input.length,
			key,
			value;
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string",
				args = slice.call( arguments, 1 ),
				returnValue = this;
	
			// allow multiple hashes to be passed on init
			options = !isMethodCall && args.length ?
				$.widget.extend.apply( null, [ options ].concat(args) ) :
				options;
	
			if ( isMethodCall ) {
				this.each(function() {
					var methodValue,
						instance = $.data( this, fullName );
					if ( !instance ) {
						return $.error( "cannot call methods on " + name + " prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}
					if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name + " widget instance" );
					}
					methodValue = instance[ options ].apply( instance, args );
					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				});
			} else {
				this.each(function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} )._init();
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				});
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
		options: {
			disabled: false,
	
			// callbacks
			create: null
		},
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = uuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				});
				this.document = $( element.style ?
					// element within the document
					element.ownerDocument :
					// element is window or document
					element.document || element );
				this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
			}
	
			this._create();
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
		_getCreateOptions: $.noop,
		_getCreateEventData: $.noop,
		_create: $.noop,
		_init: $.noop,
	
		destroy: function() {
			this._destroy();
			// we can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.unbind( this.eventNamespace )
				// 1.9 BC for #7810
				// TODO remove dual storage
				.removeData( this.widgetName )
				.removeData( this.widgetFullName )
				// support: jquery <1.6.3
				// http://bugs.jquery.com/ticket/9413
				.removeData( $.camelCase( this.widgetFullName ) );
			this.widget()
				.unbind( this.eventNamespace )
				.removeAttr( "aria-disabled" )
				.removeClass(
					this.widgetFullName + "-disabled " +
					"ui-state-disabled" );
	
			// clean up events and states
			this.bindings.unbind( this.eventNamespace );
			this.hoverable.removeClass( "ui-state-hover" );
			this.focusable.removeClass( "ui-state-focus" );
		},
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key,
				parts,
				curOption,
				i;
	
			if ( arguments.length === 0 ) {
				// don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
				// handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( value === undefined ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( value === undefined ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
		_setOption: function( key, value ) {
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this.widget()
					.toggleClass( this.widgetFullName + "-disabled ui-state-disabled", !!value )
					.attr( "aria-disabled", value );
				this.hoverable.removeClass( "ui-state-hover" );
				this.focusable.removeClass( "ui-state-focus" );
			}
	
			return this;
		},
	
		enable: function() {
			return this._setOption( "disabled", false );
		},
		disable: function() {
			return this._setOption( "disabled", true );
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement,
				instance = this;
	
			// no suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// no element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				// accept selectors, DOM elements
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
					// allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
								$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^(\w+)\s*(.*)$/ ),
					eventName = match[1] + instance.eventNamespace,
					selector = match[2];
				if ( selector ) {
					delegateElement.delegate( selector, eventName, handlerProxy );
				} else {
					element.bind( eventName, handlerProxy );
				}
			});
		},
	
		_off: function( element, eventName ) {
			eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) + this.eventNamespace;
			element.unbind( eventName ).undelegate( eventName );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					$( event.currentTarget ).addClass( "ui-state-hover" );
				},
				mouseleave: function( event ) {
					$( event.currentTarget ).removeClass( "ui-state-hover" );
				}
			});
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					$( event.currentTarget ).addClass( "ui-state-focus" );
				},
				focusout: function( event ) {
					$( event.currentTarget ).removeClass( "ui-state-focus" );
				}
			});
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig,
				callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
			// the original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
			var hasOptions,
				effectName = !options ?
					method :
					options === true || typeof options === "number" ?
						defaultEffect :
						options.effect || defaultEffect;
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
			if ( options.delay ) {
				element.delay( options.delay );
			}
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue(function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				});
			}
		};
	});
	
	})();
	(function( undefined ) {
	
	var mouseHandled = false;
	$( document ).mouseup( function() {
		mouseHandled = false;
	});
	
	$.widget("ui.mouse", {
		version: "1.10.1",
		options: {
			cancel: "input,textarea,button,select,option",
			distance: 1,
			delay: 0
		},
		_mouseInit: function() {
			var that = this;
	
			this.element
				.bind("mousedown."+this.widgetName, function(event) {
					return that._mouseDown(event);
				})
				.bind("click."+this.widgetName, function(event) {
					if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
						$.removeData(event.target, that.widgetName + ".preventClickEvent");
						event.stopImmediatePropagation();
						return false;
					}
				});
	
			this.started = false;
		},
	
		// TODO: make sure destroying one instance of mouse doesn't mess with
		// other instances of mouse
		_mouseDestroy: function() {
			this.element.unbind("."+this.widgetName);
			if ( this._mouseMoveDelegate ) {
				$(document)
					.unbind("mousemove."+this.widgetName, this._mouseMoveDelegate)
					.unbind("mouseup."+this.widgetName, this._mouseUpDelegate);
			}
		},
	
		_mouseDown: function(event) {
			// don't let more than one widget handle mouseStart
			if( mouseHandled ) { return; }
	
			// we may have missed mouseup (out of window)
			(this._mouseStarted && this._mouseUp(event));
	
			this._mouseDownEvent = event;
	
			var that = this,
				btnIsLeft = (event.which === 1),
				// event.target.nodeName works around a bug in IE 8 with
				// disabled inputs (#7620)
				elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
			if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
				return true;
			}
	
			this.mouseDelayMet = !this.options.delay;
			if (!this.mouseDelayMet) {
				this._mouseDelayTimer = setTimeout(function() {
					that.mouseDelayMet = true;
				}, this.options.delay);
			}
	
			if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
				this._mouseStarted = (this._mouseStart(event) !== false);
				if (!this._mouseStarted) {
					event.preventDefault();
					return true;
				}
			}
	
			// Click event may never have fired (Gecko & Opera)
			if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
				$.removeData(event.target, this.widgetName + ".preventClickEvent");
			}
	
			// these delegates are required to keep context
			this._mouseMoveDelegate = function(event) {
				return that._mouseMove(event);
			};
			this._mouseUpDelegate = function(event) {
				return that._mouseUp(event);
			};
			$(document)
				.bind("mousemove."+this.widgetName, this._mouseMoveDelegate)
				.bind("mouseup."+this.widgetName, this._mouseUpDelegate);
	
			event.preventDefault();
	
			mouseHandled = true;
			return true;
		},
	
		_mouseMove: function(event) {
			// IE mouseup check - mouseup happened when mouse was out of window
			if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
				return this._mouseUp(event);
			}
	
			if (this._mouseStarted) {
				this._mouseDrag(event);
				return event.preventDefault();
			}
	
			if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
				this._mouseStarted =
					(this._mouseStart(this._mouseDownEvent, event) !== false);
				(this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
			}
	
			return !this._mouseStarted;
		},
	
		_mouseUp: function(event) {
			$(document)
				.unbind("mousemove."+this.widgetName, this._mouseMoveDelegate)
				.unbind("mouseup."+this.widgetName, this._mouseUpDelegate);
	
			if (this._mouseStarted) {
				this._mouseStarted = false;
	
				if (event.target === this._mouseDownEvent.target) {
					$.data(event.target, this.widgetName + ".preventClickEvent", true);
				}
	
				this._mouseStop(event);
			}
	
			return false;
		},
	
		_mouseDistanceMet: function(event) {
			return (Math.max(
					Math.abs(this._mouseDownEvent.pageX - event.pageX),
					Math.abs(this._mouseDownEvent.pageY - event.pageY)
				) >= this.options.distance
			);
		},
	
		_mouseDelayMet: function(/* event */) {
			return this.mouseDelayMet;
		},
	
		// These are placeholder methods, to be overriden by extending plugin
		_mouseStart: function(/* event */) {},
		_mouseDrag: function(/* event */) {},
		_mouseStop: function(/* event */) {},
		_mouseCapture: function(/* event */) { return true; }
	});
	
	})();
	(function( undefined ) {
	
	/*jshint loopfunc: true */
	
	function isOverAxis( x, reference, size ) {
		return ( x > reference ) && ( x < ( reference + size ) );
	}
	
	$.widget("ui.sortable", $.ui.mouse, {
		version: "1.10.1",
		widgetEventPrefix: "sort",
		ready: false,
		options: {
			appendTo: "parent",
			axis: false,
			connectWith: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			dropOnEmpty: true,
			forcePlaceholderSize: false,
			forceHelperSize: false,
			grid: false,
			handle: false,
			helper: "original",
			items: "> *",
			opacity: false,
			placeholder: false,
			revert: false,
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			scope: "default",
			tolerance: "intersect",
			zIndex: 1000,
	
			// callbacks
			activate: null,
			beforeStop: null,
			change: null,
			deactivate: null,
			out: null,
			over: null,
			receive: null,
			remove: null,
			sort: null,
			start: null,
			stop: null,
			update: null
		},
		_create: function() {
	
			var o = this.options;
			this.containerCache = {};
			this.element.addClass("ui-sortable");
	
			//Get the items
			this.refresh();
	
			//Let's determine if the items are being displayed horizontally
			this.floating = this.items.length ? o.axis === "x" || (/left|right/).test(this.items[0].item.css("float")) || (/inline|table-cell/).test(this.items[0].item.css("display")) : false;
	
			//Let's determine the parent's offset
			this.offset = this.element.offset();
	
			//Initialize mouse events for interaction
			this._mouseInit();
	
			//We're ready to go
			this.ready = true;
	
		},
	
		_destroy: function() {
			this.element
				.removeClass("ui-sortable ui-sortable-disabled");
			this._mouseDestroy();
	
			for ( var i = this.items.length - 1; i >= 0; i-- ) {
				this.items[i].item.removeData(this.widgetName + "-item");
			}
	
			return this;
		},
	
		_setOption: function(key, value){
			if ( key === "disabled" ) {
				this.options[ key ] = value;
	
				this.widget().toggleClass( "ui-sortable-disabled", !!value );
			} else {
				// Don't call widget base _setOption for disable as it adds ui-state-disabled class
				$.Widget.prototype._setOption.apply(this, arguments);
			}
		},
	
		_mouseCapture: function(event, overrideHandle) {
			var currentItem = null,
				validHandle = false,
				that = this;
	
			if (this.reverting) {
				return false;
			}
	
			if(this.options.disabled || this.options.type === "static") {
				return false;
			}
	
			//We have to refresh the items data once first
			this._refreshItems(event);
	
			//Find out if the clicked node (or one of its parents) is a actual item in this.items
			$(event.target).parents().each(function() {
				if($.data(this, that.widgetName + "-item") === that) {
					currentItem = $(this);
					return false;
				}
			});
			if($.data(event.target, that.widgetName + "-item") === that) {
				currentItem = $(event.target);
			}
	
			if(!currentItem) {
				return false;
			}
			if(this.options.handle && !overrideHandle) {
				$(this.options.handle, currentItem).find("*").addBack().each(function() {
					if(this === event.target) {
						validHandle = true;
					}
				});
				if(!validHandle) {
					return false;
				}
			}
	
			this.currentItem = currentItem;
			this._removeCurrentsFromItems();
			return true;
	
		},
	
		_mouseStart: function(event, overrideHandle, noActivation) {
	
			var i,
				o = this.options;
	
			this.currentContainer = this;
	
			//We only need to call refreshPositions, because the refreshItems call has been moved to mouseCapture
			this.refreshPositions();
	
			//Create and append the visible helper
			this.helper = this._createHelper(event);
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Get the next scrolling parent
			this.scrollParent = this.helper.scrollParent();
	
			//The element's absolute position on the page minus margins
			this.offset = this.currentItem.offset();
			this.offset = {
				top: this.offset.top - this.margins.top,
				left: this.offset.left - this.margins.left
			};
	
			$.extend(this.offset, {
				click: { //Where the click happened, relative to the element
					left: event.pageX - this.offset.left,
					top: event.pageY - this.offset.top
				},
				parent: this._getParentOffset(),
				relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
			});
	
			// Only after we got the offset, we can change the helper's position to absolute
			// TODO: Still need to figure out a way to make relative sorting possible
			this.helper.css("position", "absolute");
			this.cssPosition = this.helper.css("position");
	
			//Generate the original position
			this.originalPosition = this._generatePosition(event);
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));
	
			//Cache the former DOM position
			this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] };
	
			//If the helper is not the original, hide the original so it's not playing any role during the drag, won't cause anything bad this way
			if(this.helper[0] !== this.currentItem[0]) {
				this.currentItem.hide();
			}
	
			//Create the placeholder
			this._createPlaceholder();
	
			//Set a containment if given in the options
			if(o.containment) {
				this._setContainment();
			}
	
			if(o.cursor) { // cursor option
				if ($("body").css("cursor")) {
					this._storedCursor = $("body").css("cursor");
				}
				$("body").css("cursor", o.cursor);
			}
	
			if(o.opacity) { // opacity option
				if (this.helper.css("opacity")) {
					this._storedOpacity = this.helper.css("opacity");
				}
				this.helper.css("opacity", o.opacity);
			}
	
			if(o.zIndex) { // zIndex option
				if (this.helper.css("zIndex")) {
					this._storedZIndex = this.helper.css("zIndex");
				}
				this.helper.css("zIndex", o.zIndex);
			}
	
			//Prepare scrolling
			if(this.scrollParent[0] !== document && this.scrollParent[0].tagName !== "HTML") {
				this.overflowOffset = this.scrollParent.offset();
			}
	
			//Call callbacks
			this._trigger("start", event, this._uiHash());
	
			//Recache the helper size
			if(!this._preserveHelperProportions) {
				this._cacheHelperProportions();
			}
	
	
			//Post "activate" events to possible containers
			if( !noActivation ) {
				for ( i = this.containers.length - 1; i >= 0; i-- ) {
					this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
				}
			}
	
			//Prepare possible droppables
			if($.ui.ddmanager) {
				$.ui.ddmanager.current = this;
			}
	
			if ($.ui.ddmanager && !o.dropBehaviour) {
				$.ui.ddmanager.prepareOffsets(this, event);
			}
	
			this.dragging = true;
	
			this.helper.addClass("ui-sortable-helper");
			this._mouseDrag(event); //Execute the drag once - this causes the helper not to be visible before getting its correct position
			return true;
	
		},
	
		_mouseDrag: function(event) {
			var i, item, itemElement, intersection,
				o = this.options,
				scrolled = false;
	
			//Compute the helpers position
			this.position = this._generatePosition(event);
			this.positionAbs = this._convertPositionTo("absolute");
	
			if (!this.lastPositionAbs) {
				this.lastPositionAbs = this.positionAbs;
			}
	
			//Do scrolling
			if(this.options.scroll) {
				if(this.scrollParent[0] !== document && this.scrollParent[0].tagName !== "HTML") {
	
					if((this.overflowOffset.top + this.scrollParent[0].offsetHeight) - event.pageY < o.scrollSensitivity) {
						this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop + o.scrollSpeed;
					} else if(event.pageY - this.overflowOffset.top < o.scrollSensitivity) {
						this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop - o.scrollSpeed;
					}
	
					if((this.overflowOffset.left + this.scrollParent[0].offsetWidth) - event.pageX < o.scrollSensitivity) {
						this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft + o.scrollSpeed;
					} else if(event.pageX - this.overflowOffset.left < o.scrollSensitivity) {
						this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft - o.scrollSpeed;
					}
	
				} else {
	
					if(event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
						scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
					} else if($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
						scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
					}
	
					if(event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
						scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
					} else if($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
						scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
					}
	
				}
	
				if(scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
					$.ui.ddmanager.prepareOffsets(this, event);
				}
			}
	
			//Regenerate the absolute position used for position checks
			this.positionAbs = this._convertPositionTo("absolute");
	
			//Set the helper position
			if(!this.options.axis || this.options.axis !== "y") {
				this.helper[0].style.left = this.position.left+"px";
			}
			if(!this.options.axis || this.options.axis !== "x") {
				this.helper[0].style.top = this.position.top+"px";
			}
	
			//Rearrange
			for (i = this.items.length - 1; i >= 0; i--) {
	
				//Cache variables and intersection, continue if no intersection
				item = this.items[i];
				itemElement = item.item[0];
				intersection = this._intersectsWithPointer(item);
				if (!intersection) {
					continue;
				}
	
				// Only put the placeholder inside the current Container, skip all
				// items form other containers. This works because when moving
				// an item from one container to another the
				// currentContainer is switched before the placeholder is moved.
				//
				// Without this moving items in "sub-sortables" can cause the placeholder to jitter
				// beetween the outer and inner container.
				if (item.instance !== this.currentContainer) {
					continue;
				}
	
				// cannot intersect with itself
				// no useless actions that have been done before
				// no action if the item moved is the parent of the item checked
				if (itemElement !== this.currentItem[0] &&
					this.placeholder[intersection === 1 ? "next" : "prev"]()[0] !== itemElement &&
					!$.contains(this.placeholder[0], itemElement) &&
					(this.options.type === "semi-dynamic" ? !$.contains(this.element[0], itemElement) : true)
				) {
	
					this.direction = intersection === 1 ? "down" : "up";
	
					if (this.options.tolerance === "pointer" || this._intersectsWithSides(item)) {
						this._rearrange(event, item);
					} else {
						break;
					}
	
					this._trigger("change", event, this._uiHash());
					break;
				}
			}
	
			//Post events to containers
			this._contactContainers(event);
	
			//Interconnect with droppables
			if($.ui.ddmanager) {
				$.ui.ddmanager.drag(this, event);
			}
	
			//Call callbacks
			this._trigger("sort", event, this._uiHash());
	
			this.lastPositionAbs = this.positionAbs;
			return false;
	
		},
	
		_mouseStop: function(event, noPropagation) {
	
			if(!event) {
				return;
			}
	
			//If we are using droppables, inform the manager about the drop
			if ($.ui.ddmanager && !this.options.dropBehaviour) {
				$.ui.ddmanager.drop(this, event);
			}
	
			if(this.options.revert) {
				var that = this,
					cur = this.placeholder.offset();
	
				this.reverting = true;
	
				$(this.helper).animate({
					left: cur.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === document.body ? 0 : this.offsetParent[0].scrollLeft),
					top: cur.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === document.body ? 0 : this.offsetParent[0].scrollTop)
				}, parseInt(this.options.revert, 10) || 500, function() {
					that._clear(event);
				});
			} else {
				this._clear(event, noPropagation);
			}
	
			return false;
	
		},
	
		cancel: function() {
	
			if(this.dragging) {
	
				this._mouseUp({ target: null });
	
				if(this.options.helper === "original") {
					this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
				} else {
					this.currentItem.show();
				}
	
				//Post deactivating events to containers
				for (var i = this.containers.length - 1; i >= 0; i--){
					this.containers[i]._trigger("deactivate", null, this._uiHash(this));
					if(this.containers[i].containerCache.over) {
						this.containers[i]._trigger("out", null, this._uiHash(this));
						this.containers[i].containerCache.over = 0;
					}
				}
	
			}
	
			if (this.placeholder) {
				//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
				if(this.placeholder[0].parentNode) {
					this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
				}
				if(this.options.helper !== "original" && this.helper && this.helper[0].parentNode) {
					this.helper.remove();
				}
	
				$.extend(this, {
					helper: null,
					dragging: false,
					reverting: false,
					_noFinalSort: null
				});
	
				if(this.domPosition.prev) {
					$(this.domPosition.prev).after(this.currentItem);
				} else {
					$(this.domPosition.parent).prepend(this.currentItem);
				}
			}
	
			return this;
	
		},
	
		serialize: function(o) {
	
			var items = this._getItemsAsjQuery(o && o.connected),
				str = [];
			o = o || {};
	
			$(items).each(function() {
				var res = ($(o.item || this).attr(o.attribute || "id") || "").match(o.expression || (/(.+)[\-=_](.+)/));
				if (res) {
					str.push((o.key || res[1]+"[]")+"="+(o.key && o.expression ? res[1] : res[2]));
				}
			});
	
			if(!str.length && o.key) {
				str.push(o.key + "=");
			}
	
			return str.join("&");
	
		},
	
		toArray: function(o) {
	
			var items = this._getItemsAsjQuery(o && o.connected),
				ret = [];
	
			o = o || {};
	
			items.each(function() { ret.push($(o.item || this).attr(o.attribute || "id") || ""); });
			return ret;
	
		},
	
		/* Be careful with the following core functions */
		_intersectsWith: function(item) {
	
			var x1 = this.positionAbs.left,
				x2 = x1 + this.helperProportions.width,
				y1 = this.positionAbs.top,
				y2 = y1 + this.helperProportions.height,
				l = item.left,
				r = l + item.width,
				t = item.top,
				b = t + item.height,
				dyClick = this.offset.click.top,
				dxClick = this.offset.click.left,
				isOverElement = (y1 + dyClick) > t && (y1 + dyClick) < b && (x1 + dxClick) > l && (x1 + dxClick) < r;
	
			if ( this.options.tolerance === "pointer" ||
				this.options.forcePointerForContainers ||
				(this.options.tolerance !== "pointer" && this.helperProportions[this.floating ? "width" : "height"] > item[this.floating ? "width" : "height"])
			) {
				return isOverElement;
			} else {
	
				return (l < x1 + (this.helperProportions.width / 2) && // Right Half
					x2 - (this.helperProportions.width / 2) < r && // Left Half
					t < y1 + (this.helperProportions.height / 2) && // Bottom Half
					y2 - (this.helperProportions.height / 2) < b ); // Top Half
	
			}
		},
	
		_intersectsWithPointer: function(item) {
	
			var isOverElementHeight = (this.options.axis === "x") || isOverAxis(this.positionAbs.top + this.offset.click.top, item.top, item.height),
				isOverElementWidth = (this.options.axis === "y") || isOverAxis(this.positionAbs.left + this.offset.click.left, item.left, item.width),
				isOverElement = isOverElementHeight && isOverElementWidth,
				verticalDirection = this._getDragVerticalDirection(),
				horizontalDirection = this._getDragHorizontalDirection();
	
			if (!isOverElement) {
				return false;
			}
	
			return this.floating ?
				( ((horizontalDirection && horizontalDirection === "right") || verticalDirection === "down") ? 2 : 1 )
				: ( verticalDirection && (verticalDirection === "down" ? 2 : 1) );
	
		},
	
		_intersectsWithSides: function(item) {
	
			var isOverBottomHalf = isOverAxis(this.positionAbs.top + this.offset.click.top, item.top + (item.height/2), item.height),
				isOverRightHalf = isOverAxis(this.positionAbs.left + this.offset.click.left, item.left + (item.width/2), item.width),
				verticalDirection = this._getDragVerticalDirection(),
				horizontalDirection = this._getDragHorizontalDirection();
	
			if (this.floating && horizontalDirection) {
				return ((horizontalDirection === "right" && isOverRightHalf) || (horizontalDirection === "left" && !isOverRightHalf));
			} else {
				return verticalDirection && ((verticalDirection === "down" && isOverBottomHalf) || (verticalDirection === "up" && !isOverBottomHalf));
			}
	
		},
	
		_getDragVerticalDirection: function() {
			var delta = this.positionAbs.top - this.lastPositionAbs.top;
			return delta !== 0 && (delta > 0 ? "down" : "up");
		},
	
		_getDragHorizontalDirection: function() {
			var delta = this.positionAbs.left - this.lastPositionAbs.left;
			return delta !== 0 && (delta > 0 ? "right" : "left");
		},
	
		refresh: function(event) {
			this._refreshItems(event);
			this.refreshPositions();
			return this;
		},
	
		_connectWith: function() {
			var options = this.options;
			return options.connectWith.constructor === String ? [options.connectWith] : options.connectWith;
		},
	
		_getItemsAsjQuery: function(connected) {
	
			var i, j, cur, inst,
				items = [],
				queries = [],
				connectWith = this._connectWith();
	
			if(connectWith && connected) {
				for (i = connectWith.length - 1; i >= 0; i--){
					cur = $(connectWith[i]);
					for ( j = cur.length - 1; j >= 0; j--){
						inst = $.data(cur[j], this.widgetFullName);
						if(inst && inst !== this && !inst.options.disabled) {
							queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element) : $(inst.options.items, inst.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), inst]);
						}
					}
				}
			}
	
			queries.push([$.isFunction(this.options.items) ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem }) : $(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this]);
	
			for (i = queries.length - 1; i >= 0; i--){
				queries[i][0].each(function() {
					items.push(this);
				});
			}
	
			return $(items);
	
		},
	
		_removeCurrentsFromItems: function() {
	
			var list = this.currentItem.find(":data(" + this.widgetName + "-item)");
	
			this.items = $.grep(this.items, function (item) {
				for (var j=0; j < list.length; j++) {
					if(list[j] === item.item[0]) {
						return false;
					}
				}
				return true;
			});
	
		},
	
		_refreshItems: function(event) {
	
			this.items = [];
			this.containers = [this];
	
			var i, j, cur, inst, targetData, _queries, item, queriesLength,
				items = this.items,
				queries = [[$.isFunction(this.options.items) ? this.options.items.call(this.element[0], event, { item: this.currentItem }) : $(this.options.items, this.element), this]],
				connectWith = this._connectWith();
	
			if(connectWith && this.ready) { //Shouldn't be run the first time through due to massive slow-down
				for (i = connectWith.length - 1; i >= 0; i--){
					cur = $(connectWith[i]);
					for (j = cur.length - 1; j >= 0; j--){
						inst = $.data(cur[j], this.widgetFullName);
						if(inst && inst !== this && !inst.options.disabled) {
							queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element[0], event, { item: this.currentItem }) : $(inst.options.items, inst.element), inst]);
							this.containers.push(inst);
						}
					}
				}
			}
	
			for (i = queries.length - 1; i >= 0; i--) {
				targetData = queries[i][1];
				_queries = queries[i][0];
	
				for (j=0, queriesLength = _queries.length; j < queriesLength; j++) {
					item = $(_queries[j]);
	
					item.data(this.widgetName + "-item", targetData); // Data for target checking (mouse manager)
	
					items.push({
						item: item,
						instance: targetData,
						width: 0, height: 0,
						left: 0, top: 0
					});
				}
			}
	
		},
	
		refreshPositions: function(fast) {
	
			//This has to be redone because due to the item being moved out/into the offsetParent, the offsetParent's position will change
			if(this.offsetParent && this.helper) {
				this.offset.parent = this._getParentOffset();
			}
	
			var i, item, t, p;
	
			for (i = this.items.length - 1; i >= 0; i--){
				item = this.items[i];
	
				//We ignore calculating positions of all connected containers when we're not over them
				if(item.instance !== this.currentContainer && this.currentContainer && item.item[0] !== this.currentItem[0]) {
					continue;
				}
	
				t = this.options.toleranceElement ? $(this.options.toleranceElement, item.item) : item.item;
	
				if (!fast) {
					item.width = t.outerWidth();
					item.height = t.outerHeight();
				}
	
				p = t.offset();
				item.left = p.left;
				item.top = p.top;
			}
	
			if(this.options.custom && this.options.custom.refreshContainers) {
				this.options.custom.refreshContainers.call(this);
			} else {
				for (i = this.containers.length - 1; i >= 0; i--){
					p = this.containers[i].element.offset();
					this.containers[i].containerCache.left = p.left;
					this.containers[i].containerCache.top = p.top;
					this.containers[i].containerCache.width	= this.containers[i].element.outerWidth();
					this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
				}
			}
	
			return this;
		},
	
		_createPlaceholder: function(that) {
			that = that || this;
			var className,
				o = that.options;
	
			if(!o.placeholder || o.placeholder.constructor === String) {
				className = o.placeholder;
				o.placeholder = {
					element: function() {
	
						var el = $(document.createElement(that.currentItem[0].nodeName))
							.addClass(className || that.currentItem[0].className+" ui-sortable-placeholder")
							.removeClass("ui-sortable-helper")[0];
	
						if(!className) {
							el.style.visibility = "hidden";
						}
	
						return el;
					},
					update: function(container, p) {
	
						// 1. If a className is set as 'placeholder option, we don't force sizes - the class is responsible for that
						// 2. The option 'forcePlaceholderSize can be enabled to force it even if a class name is specified
						if(className && !o.forcePlaceholderSize) {
							return;
						}
	
						//If the element doesn't have a actual height by itself (without styles coming from a stylesheet), it receives the inline height from the dragged item
						if(!p.height()) { p.height(that.currentItem.innerHeight() - parseInt(that.currentItem.css("paddingTop")||0, 10) - parseInt(that.currentItem.css("paddingBottom")||0, 10)); }
						if(!p.width()) { p.width(that.currentItem.innerWidth() - parseInt(that.currentItem.css("paddingLeft")||0, 10) - parseInt(that.currentItem.css("paddingRight")||0, 10)); }
					}
				};
			}
	
			//Create the placeholder
			that.placeholder = $(o.placeholder.element.call(that.element, that.currentItem));
	
			//Append it after the actual current item
			that.currentItem.after(that.placeholder);
	
			//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
			o.placeholder.update(that, that.placeholder);
	
		},
	
		_contactContainers: function(event) {
			var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, base, cur, nearBottom,
				innermostContainer = null,
				innermostIndex = null;
	
			// get innermost container that intersects with item
			for (i = this.containers.length - 1; i >= 0; i--) {
	
				// never consider a container that's located within the item itself
				if($.contains(this.currentItem[0], this.containers[i].element[0])) {
					continue;
				}
	
				if(this._intersectsWith(this.containers[i].containerCache)) {
	
					// if we've already found a container and it's more "inner" than this, then continue
					if(innermostContainer && $.contains(this.containers[i].element[0], innermostContainer.element[0])) {
						continue;
					}
	
					innermostContainer = this.containers[i];
					innermostIndex = i;
	
				} else {
					// container doesn't intersect. trigger "out" event if necessary
					if(this.containers[i].containerCache.over) {
						this.containers[i]._trigger("out", event, this._uiHash(this));
						this.containers[i].containerCache.over = 0;
					}
				}
	
			}
	
			// if no intersecting containers found, return
			if(!innermostContainer) {
				return;
			}
	
			// move the item into the container if it's not there already
			if(this.containers.length === 1) {
				this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
				this.containers[innermostIndex].containerCache.over = 1;
			} else {
	
				//When entering a new container, we will find the item with the least distance and append our item near it
				dist = 10000;
				itemWithLeastDistance = null;
				posProperty = this.containers[innermostIndex].floating ? "left" : "top";
				sizeProperty = this.containers[innermostIndex].floating ? "width" : "height";
				base = this.positionAbs[posProperty] + this.offset.click[posProperty];
				for (j = this.items.length - 1; j >= 0; j--) {
					if(!$.contains(this.containers[innermostIndex].element[0], this.items[j].item[0])) {
						continue;
					}
					if(this.items[j].item[0] === this.currentItem[0]) {
						continue;
					}
					cur = this.items[j].item.offset()[posProperty];
					nearBottom = false;
					if(Math.abs(cur - base) > Math.abs(cur + this.items[j][sizeProperty] - base)){
						nearBottom = true;
						cur += this.items[j][sizeProperty];
					}
	
					if(Math.abs(cur - base) < dist) {
						dist = Math.abs(cur - base); itemWithLeastDistance = this.items[j];
						this.direction = nearBottom ? "up": "down";
					}
				}
	
				//Check if dropOnEmpty is enabled
				if(!itemWithLeastDistance && !this.options.dropOnEmpty) {
					return;
				}
	
				this.currentContainer = this.containers[innermostIndex];
				itemWithLeastDistance ? this._rearrange(event, itemWithLeastDistance, null, true) : this._rearrange(event, null, this.containers[innermostIndex].element, true);
				this._trigger("change", event, this._uiHash());
				this.containers[innermostIndex]._trigger("change", event, this._uiHash(this));
	
				//Update the placeholder
				this.options.placeholder.update(this.currentContainer, this.placeholder);
	
				this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
				this.containers[innermostIndex].containerCache.over = 1;
			}
	
	
		},
	
		_createHelper: function(event) {
	
			var o = this.options,
				helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [event, this.currentItem])) : (o.helper === "clone" ? this.currentItem.clone() : this.currentItem);
	
			//Add the helper to the DOM if that didn't happen already
			if(!helper.parents("body").length) {
				$(o.appendTo !== "parent" ? o.appendTo : this.currentItem[0].parentNode)[0].appendChild(helper[0]);
			}
	
			if(helper[0] === this.currentItem[0]) {
				this._storedCSS = { width: this.currentItem[0].style.width, height: this.currentItem[0].style.height, position: this.currentItem.css("position"), top: this.currentItem.css("top"), left: this.currentItem.css("left") };
			}
	
			if(!helper[0].style.width || o.forceHelperSize) {
				helper.width(this.currentItem.width());
			}
			if(!helper[0].style.height || o.forceHelperSize) {
				helper.height(this.currentItem.height());
			}
	
			return helper;
	
		},
	
		_adjustOffsetFromHelper: function(obj) {
			if (typeof obj === "string") {
				obj = obj.split(" ");
			}
			if ($.isArray(obj)) {
				obj = {left: +obj[0], top: +obj[1] || 0};
			}
			if ("left" in obj) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ("right" in obj) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ("top" in obj) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ("bottom" in obj) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_getParentOffset: function() {
	
	
			//Get the offsetParent and cache its position
			this.offsetParent = this.helper.offsetParent();
			var po = this.offsetParent.offset();
	
			// This is a special case where we need to modify a offset calculated on start, since the following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
			//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
			if(this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			// This needs to be actually done for all browsers, since pageX/pageY includes this information
			// with an ugly IE fix
			if( this.offsetParent[0] === document.body || (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() === "html" && $.ui.ie)) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"),10) || 0),
				left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"),10) || 0)
			};
	
		},
	
		_getRelativeOffset: function() {
	
			if(this.cssPosition === "relative") {
				var p = this.currentItem.position();
				return {
					top: p.top - (parseInt(this.helper.css("top"),10) || 0) + this.scrollParent.scrollTop(),
					left: p.left - (parseInt(this.helper.css("left"),10) || 0) + this.scrollParent.scrollLeft()
				};
			} else {
				return { top: 0, left: 0 };
			}
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: (parseInt(this.currentItem.css("marginLeft"),10) || 0),
				top: (parseInt(this.currentItem.css("marginTop"),10) || 0)
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var ce, co, over,
				o = this.options;
			if(o.containment === "parent") {
				o.containment = this.helper[0].parentNode;
			}
			if(o.containment === "document" || o.containment === "window") {
				this.containment = [
					0 - this.offset.relative.left - this.offset.parent.left,
					0 - this.offset.relative.top - this.offset.parent.top,
					$(o.containment === "document" ? document : window).width() - this.helperProportions.width - this.margins.left,
					($(o.containment === "document" ? document : window).height() || document.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
				];
			}
	
			if(!(/^(document|window|parent)$/).test(o.containment)) {
				ce = $(o.containment)[0];
				co = $(o.containment).offset();
				over = ($(ce).css("overflow") !== "hidden");
	
				this.containment = [
					co.left + (parseInt($(ce).css("borderLeftWidth"),10) || 0) + (parseInt($(ce).css("paddingLeft"),10) || 0) - this.margins.left,
					co.top + (parseInt($(ce).css("borderTopWidth"),10) || 0) + (parseInt($(ce).css("paddingTop"),10) || 0) - this.margins.top,
					co.left+(over ? Math.max(ce.scrollWidth,ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderLeftWidth"),10) || 0) - (parseInt($(ce).css("paddingRight"),10) || 0) - this.helperProportions.width - this.margins.left,
					co.top+(over ? Math.max(ce.scrollHeight,ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderTopWidth"),10) || 0) - (parseInt($(ce).css("paddingBottom"),10) || 0) - this.helperProportions.height - this.margins.top
				];
			}
	
		},
	
		_convertPositionTo: function(d, pos) {
	
			if(!pos) {
				pos = this.position;
			}
			var mod = d === "absolute" ? 1 : -1,
				scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent,
				scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);
	
			return {
				top: (
					pos.top	+																// The absolute mouse position
					this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.top * mod -											// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod)
				),
				left: (
					pos.left +																// The absolute mouse position
					this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ) * mod)
				)
			};
	
		},
	
		_generatePosition: function(event) {
	
			var top, left,
				o = this.options,
				pageX = event.pageX,
				pageY = event.pageY,
				scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);
	
			// This is another very weird special case that only happens for relative elements:
			// 1. If the css position is relative
			// 2. and the scroll parent is the document or similar to the offset parent
			// we have to refresh the relative offset during the scroll so there are no jumps
			if(this.cssPosition === "relative" && !(this.scrollParent[0] !== document && this.scrollParent[0] !== this.offsetParent[0])) {
				this.offset.relative = this._getRelativeOffset();
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			if(this.originalPosition) { //If we are not dragging yet, we won't check for options
	
				if(this.containment) {
					if(event.pageX - this.offset.click.left < this.containment[0]) {
						pageX = this.containment[0] + this.offset.click.left;
					}
					if(event.pageY - this.offset.click.top < this.containment[1]) {
						pageY = this.containment[1] + this.offset.click.top;
					}
					if(event.pageX - this.offset.click.left > this.containment[2]) {
						pageX = this.containment[2] + this.offset.click.left;
					}
					if(event.pageY - this.offset.click.top > this.containment[3]) {
						pageY = this.containment[3] + this.offset.click.top;
					}
				}
	
				if(o.grid) {
					top = this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1];
					pageY = this.containment ? ( (top - this.offset.click.top >= this.containment[1] && top - this.offset.click.top <= this.containment[3]) ? top : ((top - this.offset.click.top >= this.containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;
	
					left = this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0];
					pageX = this.containment ? ( (left - this.offset.click.left >= this.containment[0] && left - this.offset.click.left <= this.containment[2]) ? left : ((left - this.offset.click.left >= this.containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
				}
	
			}
	
			return {
				top: (
					pageY -																// The absolute mouse position
					this.offset.click.top -													// Click offset (relative to the element)
					this.offset.relative.top	-											// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ))
				),
				left: (
					pageX -																// The absolute mouse position
					this.offset.click.left -												// Click offset (relative to the element)
					this.offset.relative.left	-											// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ))
				)
			};
	
		},
	
		_rearrange: function(event, i, a, hardRefresh) {
	
			a ? a[0].appendChild(this.placeholder[0]) : i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction === "down" ? i.item[0] : i.item[0].nextSibling));
	
			//Various things done here to improve the performance:
			// 1. we create a setTimeout, that calls refreshPositions
			// 2. on the instance, we have a counter variable, that get's higher after every append
			// 3. on the local scope, we copy the counter variable, and check in the timeout, if it's still the same
			// 4. this lets only the last addition to the timeout stack through
			this.counter = this.counter ? ++this.counter : 1;
			var counter = this.counter;
	
			this._delay(function() {
				if(counter === this.counter) {
					this.refreshPositions(!hardRefresh); //Precompute after each DOM insertion, NOT on mousemove
				}
			});
	
		},
	
		_clear: function(event, noPropagation) {
	
			this.reverting = false;
			// We delay all events that have to be triggered to after the point where the placeholder has been removed and
			// everything else normalized again
			var i,
				delayedTriggers = [];
	
			// We first have to update the dom position of the actual currentItem
			// Note: don't do it if the current item is already removed (by a user), or it gets reappended (see #4088)
			if(!this._noFinalSort && this.currentItem.parent().length) {
				this.placeholder.before(this.currentItem);
			}
			this._noFinalSort = null;
	
			if(this.helper[0] === this.currentItem[0]) {
				for(i in this._storedCSS) {
					if(this._storedCSS[i] === "auto" || this._storedCSS[i] === "static") {
						this._storedCSS[i] = "";
					}
				}
				this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
			} else {
				this.currentItem.show();
			}
	
			if(this.fromOutside && !noPropagation) {
				delayedTriggers.push(function(event) { this._trigger("receive", event, this._uiHash(this.fromOutside)); });
			}
			if((this.fromOutside || this.domPosition.prev !== this.currentItem.prev().not(".ui-sortable-helper")[0] || this.domPosition.parent !== this.currentItem.parent()[0]) && !noPropagation) {
				delayedTriggers.push(function(event) { this._trigger("update", event, this._uiHash()); }); //Trigger update callback if the DOM position has changed
			}
	
			// Check if the items Container has Changed and trigger appropriate
			// events.
			if (this !== this.currentContainer) {
				if(!noPropagation) {
					delayedTriggers.push(function(event) { this._trigger("remove", event, this._uiHash()); });
					delayedTriggers.push((function(c) { return function(event) { c._trigger("receive", event, this._uiHash(this)); };  }).call(this, this.currentContainer));
					delayedTriggers.push((function(c) { return function(event) { c._trigger("update", event, this._uiHash(this));  }; }).call(this, this.currentContainer));
				}
			}
	
	
			//Post events to containers
			for (i = this.containers.length - 1; i >= 0; i--){
				if(!noPropagation) {
					delayedTriggers.push((function(c) { return function(event) { c._trigger("deactivate", event, this._uiHash(this)); };  }).call(this, this.containers[i]));
				}
				if(this.containers[i].containerCache.over) {
					delayedTriggers.push((function(c) { return function(event) { c._trigger("out", event, this._uiHash(this)); };  }).call(this, this.containers[i]));
					this.containers[i].containerCache.over = 0;
				}
			}
	
			//Do what was originally in plugins
			if(this._storedCursor) {
				$("body").css("cursor", this._storedCursor);
			}
			if(this._storedOpacity) {
				this.helper.css("opacity", this._storedOpacity);
			}
			if(this._storedZIndex) {
				this.helper.css("zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex);
			}
	
			this.dragging = false;
			if(this.cancelHelperRemoval) {
				if(!noPropagation) {
					this._trigger("beforeStop", event, this._uiHash());
					for (i=0; i < delayedTriggers.length; i++) {
						delayedTriggers[i].call(this, event);
					} //Trigger all delayed events
					this._trigger("stop", event, this._uiHash());
				}
	
				this.fromOutside = false;
				return false;
			}
	
			if(!noPropagation) {
				this._trigger("beforeStop", event, this._uiHash());
			}
	
			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
			this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
	
			if(this.helper[0] !== this.currentItem[0]) {
				this.helper.remove();
			}
			this.helper = null;
	
			if(!noPropagation) {
				for (i=0; i < delayedTriggers.length; i++) {
					delayedTriggers[i].call(this, event);
				} //Trigger all delayed events
				this._trigger("stop", event, this._uiHash());
			}
	
			this.fromOutside = false;
			return true;
	
		},
	
		_trigger: function() {
			if ($.Widget.prototype._trigger.apply(this, arguments) === false) {
				this.cancel();
			}
		},
	
		_uiHash: function(_inst) {
			var inst = _inst || this;
			return {
				helper: inst.helper,
				placeholder: inst.placeholder || $([]),
				position: inst.position,
				originalPosition: inst.originalPosition,
				offset: inst.positionAbs,
				item: inst.currentItem,
				sender: _inst ? _inst.element : null
			};
		}
	
	});
	
	})();
	


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint unparam:true, todo: true */
	
	"use strict";
	
	var ko = __webpack_require__(9);
	var R = __webpack_require__(7);
	
	var stringUtil = __webpack_require__(13);
	
	var aggregatorFactory = __webpack_require__(415);
	var comparerFactory = __webpack_require__(421);
	var formatterFactory = __webpack_require__(438);
	var groupFactory = __webpack_require__(439);
	var slickData = __webpack_require__(416);
	var util = __webpack_require__(422);
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function findColumn(id, columns) {
	    return R.find(R.propEq("id", id), columns);
	}
	
	
	//-------------------------------------------
	// Looks at next items until a focusable row
	// (not group or totals) is found.  If the end
	// is reached it looks at previous items.
	function findFocus(dataView, row) {
	    var i, item, l = dataView.getLength();
	
	    for (i = row; i < l; i += 1) {
	        item = dataView.getItem(i);
	        if (item && !item.__group && !item.__groupTotals) { return i; }
	    }
	
	    for (i = row - 1; i >= 0; i -= 1) {
	        item = dataView.getItem(i);
	        if (item && !item.__group && !item.__groupTotals) { return i; }
	    }
	
	    return null;
	}
	
	
	//-------------------------------------------
	var isNullOrUndefined = R.either(R.identical(undefined), R.identical(null));
	
	
	//-------------------------------------------
	// Returns true if the value is an object.
	var isObject = R.compose(R.identical("Object"), R.type);
	
	
	//-------------------------------------------
	// Adapts the formatter function to what
	// slickgrid expects.
	function adaptFormatter(formatter, groupFormatter) {
	    if (typeof formatter !== "function") { throw new Error("formatter must be a function."); }
	    return function adaptedFormatter(row, cell, value, columnDef, dataContext) {
	        if (dataContext.__group && dataContext.displayHeaderTotals && dataContext.totals.__groupTotals) {
	            return groupFormatter ? groupFormatter(dataContext.totals) : "";
	        }
	        if (dataContext.__groupTotals) {
	            return groupFormatter ? groupFormatter(dataContext.group.totals) : "";
	        }
	        return formatter(dataContext);
	    };
	}
	
	//-------------------------------------------
	// Create a function that calls "targetFn"
	// (preserving "this" context) and ensuring
	// that "this._internalUpdate" will be
	// true while "targetFn" is running (preventing
	// execution of "_onObservableChanged").
	function createInternalUpdateGuard(targetFn) {
	    return function internalUpdateGuard() {
	        var originalValue = this._internalUpdate;
	        this._internalUpdate = true;
	        try {
	            return targetFn.apply(this, arguments);
	        } finally {
	            this._internalUpdate = originalValue;
	        }
	    };
	}
	
	
	//-------------------------------------------
	// Create a function that ensures the items
	// observable is notified.
	function createItemsModifier(targetFn) {
	    return function () {
	        this.items._innerObservable.valueWillMutate();
	        targetFn.apply(this, arguments);
	        this.items._innerObservable.valueHasMutated();
	    };
	}
	
	
	//-------------------------------------------
	// Creates and returns readonly observable with
	// a default initial value and private inner observable.
	function createReadonlyObservable(defaultValue) {
	    var o = ko.observable(defaultValue),
	        c = ko.computed({
	            read: function () { return o(); },
	            write: function () { throw new Error("Use 'apply()' method to change grid view model"); }
	        });
	    c._innerObservable = o;
	    return c;
	}
	
	
	//-------------------------------------------
	// Transforms an array of columns to the
	// slickgrid representation.
	function mapColumns(columns, factories) {
	    if (!Array.isArray(columns)) { throw new Error("columns must be an array."); }
	    var lookup = { };
	    return R.map(function mapColumn(column) {
	        // Validate
	        if (stringUtil.isNullOrWhitespace(column.id)) { throw new Error("column.id must be non-empty unique string."); }
	        if (lookup[column.id] !== undefined) { throw new Error("column.id must be unique. `".concat(column.id, "` is a duplicate.")); }
	        lookup[column.id] = column;
	        if (stringUtil.isNullOrWhitespace(column.field)) { throw new Error("column.field must be non-empty string."); }
	        if (column.comparer !== undefined && typeof column.comparer !== "function" && stringUtil.isNullOrWhitespace(column.comparer)) {
	            throw new Error("column.comparer must be a string or function.");
	        }
	        if (column.group !== undefined && !isObject(column.group) && stringUtil.isNullOrWhitespace(column.group)) {
	            throw new Error("column.group must be a string or object.");
	        }
	        if (column.groupTotalsFormatter !== undefined && typeof column.groupTotalsFormatter !== "function" && stringUtil.isNullOrWhitespace(column.groupTotalsFormatter)) {
	            throw new Error("column.groupTotalsFormatter must be a string or function.");
	        }
	
	        // default comparer if not specified
	        if (column.comparer === undefined) { column.comparer = column.field.concat(":default"); }
	
	
	        // Map
	        var slickColumn = {
	            field: column.field,
	            id: column.id,
	            resizable: !!column.resizable,
	            sortable: !!column.sortable
	        };
	        slickColumn.formatter = adaptFormatter(
	            factories.formatter(column, column.formatter !== undefined ? column.formatter : column.field.concat(":default")),
	            factories.formatter(column, column.groupTotalsFormatter !== undefined ? column.groupTotalsFormatter : column.field.concat(":aggregate"))
	        );
	        if (column.cssClass !== undefined) { slickColumn.cssClass = column.cssClass; }
	        if (column.filterable !== undefined) { slickColumn.filterable = !!column.filterable; }
	        if (column.filtered !== undefined) { slickColumn.filtered = !!column.filtered; }
	        if (column.headerCssClass !== undefined) { slickColumn.headerCssClass = column.headerCssClass; }
	        if (column.maxWidth !== undefined) { slickColumn.maxWidth = column.maxWidth; }
	        if (column.minWidth !== undefined) { slickColumn.minWidth = column.minWidth; }
	        if (column.title !== undefined || column.titleIcon !== undefined) {
	            slickColumn.name = column.titleIcon
	                ? "<i class='" + column.titleIcon + "'></i>"
	                : column.title;
	        }
	        if (column.title !== undefined && column.titleIcon !== undefined) { slickColumn.toolTip = column.title; }
	        if (column.width !== undefined) { slickColumn.width = column.width; }
	        return slickColumn;
	    }, columns);
	}
	
	
	//-------------------------------------------
	// Transforms an array of sorted columns to the
	// slickgrid representation.
	function mapSortedColumns(sortedColumns, columns) {
	    if (!Array.isArray(sortedColumns)) { throw new Error("sortedColumns must be an array."); }
	    return R.map(function mapSortedColumn(sortedColumn) {
	        if (stringUtil.isNullOrWhitespace(sortedColumn.id)) { throw new Error("sortedColumn.id must be non-empty unique string."); }
	        if (!findColumn(sortedColumn.id, columns)) { throw new Error("sortedColumn.id must match a column id."); }
	        return { columnId: sortedColumn.id, sortAsc: !sortedColumn.isDescending };
	    }, R.filter(function (o) { return o.id !== undefined; }, sortedColumns));
	}
	
	
	//-------------------------------------------
	// Resolves selectedRows and selectedItems.
	// Skips any items that cannot be found.
	function resolveSelected(selectedItems, view, idField) {
	    if (!Array.isArray(selectedItems)) { throw new Error("selectedItems must be an array."); }
	    var i, item, selectedItem, id,
	        l = selectedItems.length,
	        items = [],
	        ids = {};
	    for (i = 0; i < l; i += 1) {
	        selectedItem = selectedItems[i];
	        if (!isNullOrUndefined(selectedItem) && !isNullOrUndefined(selectedItem[idField])) {
	            id = selectedItem[idField];
	            item = view.getItemById(id);
	            if (!isNullOrUndefined(item)) {
	                items.push(item);
	                ids[id] = true;
	            }
	        }
	    }
	    return { ids: ids, items: items };
	}
	
	
	//-------------------------------------------
	// Resolves an array of sorted columns into
	// sorted options (comparer function) and
	// grouping options (array of group definitions)
	// using the built-in factories.
	function resolveSortedColumns(columns, factories, sortedColumns, multiSelect) {
	    var i, column, sortedColumn, groups = [],
	        comparators = [],
	        l = sortedColumns.length;
	
	    for (i = 0; i < l; i += 1) {
	        // if the sorted column contains both a column id and comparer/group properties, then the comparer/group
	        // from the sorted column takes precedence over the comparer/group from the column definition
	        sortedColumn = sortedColumns[i];
	        column = (sortedColumn.id !== undefined ? findColumn(sortedColumn.id, columns) : null);
	        if (sortedColumn.comparer !== undefined || sortedColumn.group !== undefined) {
	            if (sortedColumn.comparer !== undefined) {
	                comparators.push(factories.comparer(column || sortedColumn, sortedColumn.comparer, !!sortedColumn.isDescending));
	            }
	            if (sortedColumn.group !== undefined) {
	                groups = groups.concat(factories.group(column || sortedColumn, sortedColumn.group, !!sortedColumn.isDescending));
	            }
	        } else if (column) {
	            if (column.comparer !== undefined) {
	                comparators.push(factories.comparer(column, column.comparer, !!sortedColumn.isDescending));
	            }
	            if (column.group !== undefined) {
	                groups = groups.concat(factories.group(column, column.group, !!sortedColumn.isDescending));
	            }
	        }
	    }
	
	    for (i = 0, l = groups.length; i < l; i += 1) {
	        if (groups[i].displayHeaderTotals && groups[i].aggregators) {
	            groups[i].headerTitleColspan = util.findFirstAggregateColumn(columns, groups[i].aggregators) + (multiSelect ? 1 : 0);
	        }
	    }
	
	    return {
	        comparer: (comparators.length > 0 ? comparerFactory.composeComparators(comparators) : null),
	        groups: groups
	    };
	}
	
	
	//-------------------------------------------
	// Triggers a grid event that resolves a column.
	function triggerColumnAction(viewModel, properties, propertyName) {
	    var action = viewModel._events[propertyName];
	    if (action === undefined) { return; }
	    var columnId = properties[propertyName];
	    if (columnId === undefined) { return; }
	    action.call(viewModel, findColumn(columnId, viewModel.columns.peek()), properties.mouseX, properties.mouseY);
	}
	
	
	//-------------------------------------------
	// Triggers a grid event that resolves an item.
	function triggerItemAction(viewModel, properties, propertyName) {
	    var action = viewModel._events[propertyName];
	    if (action === undefined) { return; }
	    var rowIndex = properties[propertyName];
	    if (rowIndex === undefined) { return; }
	    var item = viewModel._dataView.getItem(rowIndex);
	    if (item && !item.__group && !item.__groupTotals) { action.call(viewModel, item, properties.mouseX, properties.mouseY); }
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Grid ViewModel
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Initializes a new instance of the GridViewModel.
	function GridViewModel(properties, events) {
	
	    // ensure new instance of the type
	    if (!(this instanceof GridViewModel)) { return new GridViewModel(properties, events); }
	
	    // validate events
	    if (events) {
	        if (events.columnContext !== undefined && typeof events.columnContext !== "function") { throw new Error("events.columnContext must be a function."); }
	        if (events.filterColumn !== undefined && typeof events.filterColumn !== "function") { throw new Error("events.filterColumn must be a function."); }
	        if (events.defaultAction !== undefined && typeof events.defaultAction !== "function") { throw new Error("events.defaultAction must be a function."); }
	        if (events.itemClick !== undefined && typeof events.itemClick !== "function") { throw new Error("events.itemClick must be a function."); }
	        if (events.itemContext !== undefined && typeof events.itemContext !== "function") { throw new Error("events.itemContext must be a function."); }
	    }
	
	    // internal state
	    this._dataView = new slickData.DataView();
	    this._initialMetadataProvider = this._dataView.getItemMetadata;
	    this._events = events;
	    this._idField = "id";
	    this._itemMetadataProvider = R.identity;
	    this._factories = {
	        aggregator: aggregatorFactory.defaultFactory,
	        comparer: comparerFactory.defaultFactory,
	        formatter: formatterFactory.defaultFactory,
	        group: groupFactory.defaultFactory
	    };
	    this._multiSelect = false;
	    this._pushGridState = ko.observable(); // intended to push data to slickgrid binding
	
	    // override the dataview's metadata provider with our own
	    this._dataView.getItemMetadata = this._getItemMetadata.bind(this);
	
	    // external api (read-only observables)
	    this.columns = createReadonlyObservable();
	    this.focusedGroup = createReadonlyObservable(null);
	    this.focusedItem = createReadonlyObservable(null);
	    this.items = createReadonlyObservable();
	    this.options = createReadonlyObservable();
	    this.scrollTop = createReadonlyObservable();
	    this.selectedItems = createReadonlyObservable();
	    this.sortedColumns = createReadonlyObservable();
	
	    if (properties !== undefined) { this.apply(properties); }
	}
	
	
	//-------------------------------------------
	// Adds an item to an underlying array of "items" property.
	// It also updates the grid. This is partial update,
	// i.e. change is reflected, but whole grid is not rerendered.
	GridViewModel.prototype.addItem = createItemsModifier(
	    function gridViewModelAddItem(item) {
	        this._dataView.addItem(item);
	    }
	);
	
	
	//-------------------------------------------
	// Deletes an item from an underlying array of "items" property.
	// It also updates the grid. This is partial update,
	// i.e. change is reflected, but whole grid is not rerendered.
	GridViewModel.prototype.deleteItem = createItemsModifier(
	    function gridViewModelDeleteItem(id) {
	
	        // Get the current focused row (before delete)
	        var focusedItem = this.focusedItem.peek();
	        var focusedRow = (focusedItem
	            ? this._dataView.getRowById(focusedItem[this._idField])
	            : null);
	
	        this._dataView.deleteItem(id);
	
	        var state;
	        if (focusedItem && id === focusedItem[this._idField]) {
	            var row = findFocus(this._dataView, focusedRow);
	            state = { focusedItem: this._dataView.getItem(row) };
	        }
	
	        if (this._multiSelect) {
	            if (state) {
	                state.selectedItems = this.selectedItems.peek();
	            } else {
	                state = { selectedItems: this.selectedItems.peek() };
	            }
	        }
	
	        if (state) { this.apply(state); }
	    }
	);
	
	
	//-------------------------------------------
	// Inserts an item to an underlying array of "items" property.
	// It also updates the grid. This is partial update,
	// i.e. change is reflected, but whole grid is not rerendered.
	GridViewModel.prototype.insertItem = createItemsModifier(
	    function gridViewModelInsertItem(index, item) {
	        this._dataView.insertItem(index, item);
	    }
	);
	
	
	//-------------------------------------------
	// Updates an item in an underlying array of "items" property.
	// It also updates the grid. This is partial update,
	// i.e. change is reflected, but whole grid is not rerendered.
	GridViewModel.prototype.updateItem = createItemsModifier(
	    function gridViewModelUpdateItem(id, item) {
	        this._dataView.updateItem(id, item);
	    }
	);
	
	
	//-------------------------------------------
	// Applies specified properties to the grid.
	// Any properties that are `undefined` are ignored.
	GridViewModel.prototype.apply = createInternalUpdateGuard(function gridViewModelApply(properties) {
	
	    if (!isObject(properties)) { throw new Error("apply properties must be an object."); }
	    if (properties.focusedGroup !== undefined) { throw new Error("Setting 'focusedGroup' programmatically is not supported."); }
	
	    // 1. Initialize factories
	    if (properties.factories !== undefined) {
	        this._factories = {
	            aggregator: (properties.factories.aggregator !== undefined ? aggregatorFactory.init(properties.factories.aggregator) : aggregatorFactory.defaultFactory),
	            comparer: (properties.factories.comparer !== undefined ? comparerFactory.init(properties.factories.comparer) : comparerFactory.defaultFactory),
	            formatter: (properties.factories.formatter !== undefined ? formatterFactory.init(properties.factories.formatter) : formatterFactory.defaultFactory)
	        };
	        this._factories.group = (properties.factories.group !== undefined
	            ? groupFactory.init(properties.factories.group, this._factories.aggregator, this._factories.comparer, this._factories.formatter)
	            : groupFactory.defaultFactory);
	    }
	
	
	
	    // 2. Validate & initialize properties
	    var state = {}, options = {}, optionsAffected = false;
	    if (this.options.peek() === undefined && this._events) {
	        if (this._events.columnContext !== undefined) { options.supportColumnContext = true; optionsAffected = true; }
	        if (this._events.itemContext !== undefined) { options.supportItemContext = true; optionsAffected = true; }
	        if (this._events.filterColumn !== undefined) { options.supportFilterColumn = true; optionsAffected = true; }
	    }
	    if (properties.autoHeight !== undefined) { options.autoHeight = !!properties.autoHeight; optionsAffected = true; }
	    if (properties.disabled !== undefined) {
	        var focusedItem = this.focusedItem.peek();
	        if (!properties.disabled && properties.focusedItem === undefined && focusedItem) {
	            state.focusedRow = this._dataView.getRowById(focusedItem[this._idField]);
	        }
	        options.disabled = !!properties.disabled;
	        optionsAffected = true;
	    }
	    if (properties.forceFitColumns !== undefined) { options.forceFitColumns = !!properties.forceFitColumns; optionsAffected = true; }
	    if (properties.shortcutActions !== undefined) { options.shortcutActions = properties.shortcutActions; optionsAffected = true; }
	    if (properties.multiSelect !== undefined) { options.multiSelect = !!properties.multiSelect; this._multiSelect = options.multiSelect; optionsAffected = true; }
	    if (properties.idField !== undefined) {
	        if (stringUtil.isNullOrWhitespace(properties.idField) && (typeof properties.idField !== "number" || isNaN(properties.idField))) { throw new Error("idField must be a non-empty string or number."); }
	        this._idField = properties.idField;
	        options.idField = properties.idField;
	        optionsAffected = true;
	    }
	    if (properties.rowCssProvider !== undefined) {
	        if (properties.rowCssProvider !== null && stringUtil.isNullOrWhitespace(properties.rowCssProvider) && typeof properties.rowCssProvider !== "function") {
	            throw new Error("rowCssProvider must be a non-empty string, null or a function.");
	        }
	        options.rowCssProvider = properties.rowCssProvider;
	        optionsAffected = true;
	
	        this._itemMetadataProvider = options.rowCssProvider === null
	            ? R.identity
	            : this._createRowCssProvider(properties.rowCssProvider).bind(this);
	    }
	    if (optionsAffected) { state.options = R.merge(this.options.peek(), options); }
	    if (properties.action !== undefined) { state.action = properties.action; }
	    if (properties.columns !== undefined) { state.columns = mapColumns(properties.columns, this._factories); }
	    if (properties.invalidate !== undefined) { state.invalidate = properties.invalidate; }
	    if (properties.items !== undefined && !Array.isArray(properties.items)) { throw new Error("items must be an array."); }
	    if (properties.resize !== undefined) { state.resize = !!properties.resize; }
	    if (properties.scrollTop !== undefined) {
	        if (typeof properties.scrollTop !== "number" || isNaN(properties.scrollTop)) { throw new Error("scrollTop must be a number."); }
	        state.scrollTop = properties.scrollTop;
	    }
	    if (properties.sortedColumns !== undefined) { state.sortCols = mapSortedColumns(properties.sortedColumns, (properties.columns || this.columns.peek() || [])); }
	
	
	
	    // 3. Apply changes to slickgrid view-model (sorting, grouping, ...)
	    var sortedColumns = properties.sortedColumns || this.sortedColumns.peek();
	    var sortColumnsAffected = sortedColumns && (
	        properties.columns !== undefined ||
	        properties.factories !== undefined ||
	        properties.sortedColumns !== undefined
	    );
	    var itemsAffected = properties.items !== undefined;
	    var metadataProviderAffected = properties.rowCssProvider !== undefined;
	    if (sortColumnsAffected || itemsAffected || metadataProviderAffected) {
	        this._dataView.beginUpdate();
	        // set items
	        if (itemsAffected) {
	            this._dataView.setItems(properties.items, this._idField);
	        }
	        if (sortColumnsAffected) {
	            var resolved = resolveSortedColumns(
	                properties.columns || this.columns.peek() || [],
	                this._factories,
	                sortedColumns,
	                this._multiSelect
	            );
	            if (resolved.comparer !== null) { this._dataView.sort(resolved.comparer); }
	            this._dataView.setGrouping(resolved.groups);
	        }
	        this._dataView.endUpdate();
	    }
	
	    // Notify slick.grid of changes (needs to happen after _dataView is updated)
	
	    // 4a. Resolve focused item
	    var resolvedFocusedItem;
	    if (properties.focusedItem !== undefined) {
	        if (properties.focusedItem === null) {
	            state.focusedRow = null;
	            resolvedFocusedItem = null;
	        } else if (!isNullOrUndefined(properties.focusedItem[this._idField])) {
	            var focusedId = properties.focusedItem[this._idField];
	            state.focusedRow = this._dataView.getRowById(focusedId);
	            resolvedFocusedItem = this._dataView.getItemById(focusedId);
	        } else {
	            throw new Error("focusedItem id must be defined and not null.");
	        }
	    }
	
	    // 4b. Resolve selected items (disable selectedItems for single-select)
	    var resolvedSelected;
	    if (this._multiSelect && properties.selectedItems !== undefined) {
	        resolvedSelected = resolveSelected(properties.selectedItems, this._dataView, this._idField);
	        state.selectedIds = resolvedSelected.ids;
	    } else if (!this._multiSelect) {
	        // clear the selectedItems when switching to multi-select
	        var selectedItems = this.selectedItems.peek();
	        if (selectedItems && selectedItems.length > 0) { resolvedSelected = { items: [] }; }
	        if (resolvedFocusedItem) {
	            state.selectedIds = R.fromPairs([[resolvedFocusedItem[this._idField], true]]);
	        }
	    }
	
	
	
	    // 4c. Notify slickgrid state changes
	    this._pushGridState(state);
	
	
	
	    // 5. Notify affected observables
	    if (properties.columns !== undefined) { this.columns._innerObservable(properties.columns); }
	    if (resolvedFocusedItem !== undefined) { this.focusedItem._innerObservable(resolvedFocusedItem); }
	    if (properties.items !== undefined) { this.items._innerObservable(properties.items); }
	    if (optionsAffected) { this.options._innerObservable(state.options); }
	    if (properties.scrollTop !== undefined) { this.scrollTop._innerObservable(properties.scrollTop); }
	    if (properties.sortedColumns !== undefined) { this.sortedColumns._innerObservable(properties.sortedColumns); }
	    if (resolvedSelected !== undefined) { this.selectedItems._innerObservable(resolvedSelected.items); }
	
	});
	
	
	//-------------------------------------------
	// Applies grid state to the view-model.
	GridViewModel.prototype._applyGridState = createInternalUpdateGuard(function applyGridState(properties) {
	
	    // Looks up the focused item and focused group using
	    // the focusedRow sent from slick.grid.
	    if (properties.focusedRow !== undefined) {
	        var focusedItem = null;
	        var focusedGroup = null;
	        if (properties.focusedRow !== null) {
	            var item = this._dataView.getItem(properties.focusedRow);
	            if (!item.__nonDataRow) { // item is a data row
	                focusedItem = item;
	            } else if (item.__group) {
	                focusedGroup = item;
	            }
	        }
	        this.focusedItem._innerObservable(focusedItem);
	        this.focusedGroup._innerObservable(focusedGroup);
	    }
	
	
	    // Updates the order and width with those
	    // sent from slick.grid.
	    if (properties.columns !== undefined) {
	        var current = this.columns.peek();
	        var columns = R.map(
	            function (column) {
	                var actual = findColumn(column.id, current);
	                if (column.width !== undefined) { actual.width = column.width; }
	                return actual;
	            },
	            R.filter(R.complement(R.propEq("id", "_checkbox")), properties.columns)
	        );
	        this.columns._innerObservable(columns);
	    }
	
	    if (properties.scrollTop !== undefined) { this.scrollTop._innerObservable(properties.scrollTop); }
	
	
	    // Updates with the sort columns sent from slick.grid
	    // and apply sorting and grouping to the data view.
	    if (properties.sortCols !== undefined || properties.columns !== undefined) {
	        var sortedColumns = (properties.sortCols
	            ? R.map(function (column) {
	                return {
	                    id: column.sortCol.id,
	                    isDescending: !column.sortAsc
	                };
	            }, properties.sortCols)
	            : this.sortedColumns.peek());
	        var resolved = resolveSortedColumns(
	            this.columns.peek() || [],
	            this._factories,
	            sortedColumns || [],
	            this._multiSelect
	        );
	        if (resolved.comparer !== null) { this._dataView.sort(resolved.comparer); }
	        this._dataView.setGrouping(resolved.groups);
	        this.sortedColumns._innerObservable(sortedColumns);
	    }
	
	    // Looks up the selected items using the selectedIds object
	    // example. => { "task1": true, "task2": false, "task3": true }
	    // would result in an array containing items identified by `task1` and `task3`.
	    // Ignore for single-selection mode.
	    if (this._multiSelect && properties.selectedIds !== undefined) {
	        this.selectedItems._innerObservable(
	            R.map(
	                this._dataView.getItemById,
	                R.filter(R.prop(R.__, properties.selectedIds), R.keys(properties.selectedIds))
	            )
	        );
	    }
	
	
	    // Handle events
	    if (this._events) {
	        triggerColumnAction(this, properties, "columnContext");
	        triggerColumnAction(this, properties, "filterColumn");
	        triggerItemAction(this, properties, "defaultAction");
	        triggerItemAction(this, properties, "itemClick");
	        triggerItemAction(this, properties, "itemContext");
	    }
	});
	
	//-------------------------------------------
	// Called by the groupselectionplugin's metadata provider
	GridViewModel.prototype._getItemMetadata = function getItemMetadata(row) {
	    // call the initial metadata provider
	    // from the dataview to build the
	    // full metadata object which could contain
	    // a lot more information than row css.
	    var metadata = this._initialMetadataProvider(row);
	    return this._itemMetadataProvider(metadata, row);
	};
	
	
	//-------------------------------------------
	// Creates a function to provide row css to the slickgrid's dataview
	// at render time.
	GridViewModel.prototype._createRowCssProvider = function createRowCssProvider(rowCssProvider) {
	    if (rowCssProvider === null) { return this._initialMetadataProvider; }
	
	    var isProviderPath = typeof rowCssProvider === "string";
	    var getPath = isProviderPath ? R.path(rowCssProvider.split(".")) : null;
	    var getPathCss = function getPathCss(row) {
	        var property = getPath(row);
	        if (property === undefined) {
	            return "";
	        }
	        return property;
	    };
	    var getCallbackCss = function getCallbackCss(row) {
	        var result = rowCssProvider(row);
	        if (!R.isArrayLike(result)) { throw new Error("Expected rowCssProvider result to be array-like."); }
	        return R.join(" ", result);
	    };
	    var getCss = isProviderPath
	        ? getPathCss
	        : getCallbackCss;
	
	    return function getRowMetadata(metadata, row) {
	        if (row !== null) {
	            var item = this._dataView.getItem(row);
	
	            // append any css from the rowCssProvider onto what may be added by the original metadata provider.
	            var metadataClasses = (metadata && metadata.cssClasses) || "";
	            metadata = R.merge(metadata, {
	                cssClasses: metadataClasses + getCss(item) + " " // pad with a space for the next metadata provider (group selection plugin) is expecting it.
	            });
	        }
	        return metadata;
	    };
	};
	
	
	module.exports = GridViewModel;
	
	// Export for TypeScript consumers
	module.exports.GridViewModel = GridViewModel;
	


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var R = __webpack_require__(7);
	
	var stringUtil = __webpack_require__(13);
	
	var Aggregators = __webpack_require__(416).Aggregators;
	
	//-------------------------------------------
	// Default implementation of the resolver factory
	// accepts a string id and returns an aggregator.
	// slick.grid sum aggregator example:
	// https://github.com/mleibman/SlickGrid/blob/master/slick.dataview.js#L1101
	function defaultFactory(id) {
	    if (stringUtil.isNullOrWhitespace(id)) { throw new Error("aggregator factory id must be non-empty string."); }
	    var pair = id.split(":");
	    switch (pair[1].toLowerCase()) {
	    case "avg":
	        return new Aggregators.Avg(pair[0]);
	    case "max":
	        return new Aggregators.Max(pair[0]);
	    case "min":
	        return new Aggregators.Min(pair[0]);
	    case "sum":
	        return new Aggregators.Sum(pair[0]);
	    default:
	        throw new Error("`".concat(id, "` aggregator type is not supported."));
	    }
	}
	
	
	//-------------------------------------------
	// Accepts a factory function and returns a function
	// that resolves an aggregator.
	function init(factory) {
	    return function aggregatorResolver(context, value) {
	        var result;
	        if (Array.isArray(value)) {
	            var i, l = value.length, current = [];
	            for (i = 0; i < l; i += 1) {
	                current = current.concat(aggregatorResolver(context, value[i]));
	            }
	            result = current;
	        } else if (R.is(Object, value) && typeof value.accumulate === "function") {
	            result = [value];
	        } else {
	            result = [factory.call(context, value)];
	        }
	        return result;
	    };
	}
	
	
	module.exports = {
	    defaultFactory: init(defaultFactory),
	    init: init
	};
	


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint continue:true, plusplus:true, regexp:true, todo:true */
	
	"use strict";
	
	var GroupItemMetadataProvider = __webpack_require__(417);
	var R = __webpack_require__(7);
	var Slick = __webpack_require__(410);
	
	
	/***
	 * A sample Model implementation.
	 * Provides a filtered view of the underlying data.
	 *
	 * Relies on the data item having an "id" property uniquely identifying it.
	 */
	function DataView(options) {
	    var self = this;
	
	    var defaults = {
	        groupItemMetadataProvider: null,
	        inlineFilters: false
	    };
	
	
	    // private
	    var idProperty = "id";  // property holding a unique row id
	    var items = [];         // data by index
	    var rows = [];          // data by row
	    var idxById = {};       // indexes by id
	    var rowsById = null;    // rows by id; lazy-calculated
	    var filter = null;      // filter function
	    var updated = null;     // updated item ids
	    var suspend = false;    // suspends the recalculation
	    var sortAsc = true;
	    var fastSortField;
	    var sortComparer;
	    var refreshHints = {};
	    var prevRefreshHints = {};
	    var filterArgs;
	    var filteredItems = [];
	    var compiledFilter;
	    var compiledFilterWithCaching;
	    var filterCache = [];
	
	    // grouping
	    var groupingInfoDefaults = {
	        aggregateChildGroups: false,
	        aggregateCollapsed: false,
	        aggregateEmpty: false,
	        aggregators: [],
	        collapsed: false,
	        comparer: function (a, b) { return a.value - b.value; },
	        displayHeaderTotals: false,
	        displayTotalsRow: true,
	        formatter: null,
	        getter: null,
	        hideGroupHeaderWhen: null,
	        lazyTotalsCalculation: false,
	        predefinedValues: [],
	        predefinedValuesByParentGroup: null
	    };
	    var groupingInfos = [];
	    var groups = [];
	    var toggledGroupsByLevel = [];
	    var groupingDelimiter = ':|:';
	
	    var pagesize = 0;
	    var pagenum = 0;
	    var totalRows = 0;
	
	    // events
	    var onRowCountChanged = new Slick.Event();
	    var onRowsChanged = new Slick.Event();
	    var onPagingInfoChanged = new Slick.Event();
	
	    options = R.merge(defaults, options || {});
	
	    function flattenGroupedRows(groups, level) {
	        level = level || 0;
	        var gi = groupingInfos[level];
	        var groupedRows = [], rowsLocal, gl = 0, g;
	        var i, l, j, jj;
	        for (i = 0, l = groups.length; i < l; i++) {
	            g = groups[i];
	            if (!gi.hideGroupHeaderWhen || !gi.hideGroupHeaderWhen(g)) {
	                groupedRows[gl] = g;
	                gl++;
	            }
	
	            if (!g.collapsed) {
	                rowsLocal = g.groups ? flattenGroupedRows(g.groups, level + 1) : g.rows;
	                for (j = 0, jj = rowsLocal.length; j < jj; j++) {
	                    groupedRows[gl] = rowsLocal[j];
	                    gl++;
	                }
	            }
	
	            if (g.totals && gi.displayTotalsRow && (!g.collapsed || gi.aggregateCollapsed)) {
	                groupedRows[gl] = g.totals;
	                gl++;
	            }
	        }
	        return groupedRows;
	    }
	
	    function getFunctionInfo(fn) {
	        var fnRegex = /^function[^(]*\(([^)]*)\)\s*\{([\s\S]*)\}$/;
	        var matches = fn.toString().match(fnRegex);
	        return {
	            params: matches[1].split(","),
	            body: matches[2]
	        };
	    }
	
	    function compileAccumulatorLoop(aggregator) {
	        var accumulatorInfo = getFunctionInfo(aggregator.accumulate);
	        /*jslint evil:true */
	        var fn = new Function(
	            "_items",
	            "for (var " + accumulatorInfo.params[0] + ", _i=0, _il=_items.length; _i<_il; _i++) {" +
	                    accumulatorInfo.params[0] + " = _items[_i]; " +
	                    accumulatorInfo.body +
	                "}"
	        );
	        /*jslint evil:false */
	        // fn.displayName = fn.name = "compiledAccumulatorLoop"; // this is not allowed in strict mode
	        return fn;
	    }
	
	    function compileFilter() {
	        var filterInfo = getFunctionInfo(filter);
	
	        var filterBody = filterInfo.body
	            .replace(/return false\s*([;}]|$)/gi, "{ continue _coreloop; }$1")
	            .replace(/return true\s*([;}]|$)/gi, "{ _retval[_idx++] = $item$; continue _coreloop; }$1")
	            .replace(/return ([^;}]+?)\s*([;}]|$)/gi,
	                "{ if ($1) { _retval[_idx++] = $item$; }; continue _coreloop; }$2");
	
	        // This preserves the function template code after JS compression,
	        // so that replace() commands still work as expected.
	        var tpl = [
	            //"function(_items, _args) { ",
	            "var _retval = [], _idx = 0; ",
	            "var $item$, $args$ = _args; ",
	            "_coreloop: ",
	            "for (var _i = 0, _il = _items.length; _i < _il; _i++) { ",
	            "$item$ = _items[_i]; ",
	            "$filter$; ",
	            "} ",
	            "return _retval; "
	            //"}"
	        ].join("");
	        tpl = tpl.replace(/\$filter\$/gi, filterBody);
	        tpl = tpl.replace(/\$item\$/gi, filterInfo.params[0]);
	        tpl = tpl.replace(/\$args\$/gi, filterInfo.params[1]);
	
	        /*jslint evil:true */
	        var fn = new Function("_items,_args", tpl);
	        /*jslint evil:false */
	        // fn.displayName = fn.name = "compiledFilter"; // this is not allowed in strict mode
	        return fn;
	    }
	
	    function compileFilterWithCaching() {
	        var filterInfo = getFunctionInfo(filter);
	
	        var filterBody = filterInfo.body
	            .replace(/return false\s*([;}]|$)/gi, "{ continue _coreloop; }$1")
	            .replace(/return true\s*([;}]|$)/gi, "{ _cache[_i] = true;_retval[_idx++] = $item$; continue _coreloop; }$1")
	            .replace(/return ([^;}]+?)\s*([;}]|$)/gi,
	                "{ if ((_cache[_i] = $1)) { _retval[_idx++] = $item$; }; continue _coreloop; }$2");
	
	        // This preserves the function template code after JS compression,
	        // so that replace() commands still work as expected.
	        var tpl = [
	            //"function(_items, _args, _cache) { ",
	            "var _retval = [], _idx = 0; ",
	            "var $item$, $args$ = _args; ",
	            "_coreloop: ",
	            "for (var _i = 0, _il = _items.length; _i < _il; _i++) { ",
	            "$item$ = _items[_i]; ",
	            "if (_cache[_i]) { ",
	            "_retval[_idx++] = $item$; ",
	            "continue _coreloop; ",
	            "} ",
	            "$filter$; ",
	            "} ",
	            "return _retval; "
	            //"}"
	        ].join("");
	        tpl = tpl.replace(/\$filter\$/gi, filterBody);
	        tpl = tpl.replace(/\$item\$/gi, filterInfo.params[0]);
	        tpl = tpl.replace(/\$args\$/gi, filterInfo.params[1]);
	        /*jslint evil:true */
	        var fn = new Function("_items,_args,_cache", tpl);
	        /*jslint evil:false */
	        // fn.displayName = fn.name = "compiledFilterWithCaching"; // this is not allowed in strict mode
	        return fn;
	    }
	
	    function uncompiledFilter(items, args) {
	        var retval = [], idx = 0, i, ii;
	
	        for (i = 0, ii = items.length; i < ii; i++) {
	            if (filter(items[i], args)) {
	                retval[idx] = items[i];
	                idx++;
	            }
	        }
	
	        return retval;
	    }
	
	    function uncompiledFilterWithCaching(items, args, cache) {
	        var retval = [], idx = 0, item, i, ii;
	
	        for (i = 0, ii = items.length; i < ii; i++) {
	            item = items[i];
	            if (cache[i]) {
	                retval[idx] = item;
	                idx++;
	            } else if (filter(item, args)) {
	                retval[idx] = item;
	                idx++;
	                cache[i] = true;
	            }
	        }
	
	        return retval;
	    }
	
	    function getFilteredAndPagedItems(items) {
	        if (filter) {
	            var batchFilter = options.inlineFilters ? compiledFilter : uncompiledFilter;
	            var batchFilterWithCaching = options.inlineFilters ? compiledFilterWithCaching : uncompiledFilterWithCaching;
	
	            if (refreshHints.isFilterNarrowing) {
	                filteredItems = batchFilter(filteredItems, filterArgs);
	            } else if (refreshHints.isFilterExpanding) {
	                filteredItems = batchFilterWithCaching(items, filterArgs, filterCache);
	            } else if (!refreshHints.isFilterUnchanged) {
	                filteredItems = batchFilter(items, filterArgs);
	            }
	        } else {
	            // special case:  if not filtering and not paging, the resulting
	            // rows collection needs to be a copy so that changes due to sort
	            // can be caught
	            filteredItems = pagesize ? items : items.concat();
	        }
	
	        // get the current page
	        var paged;
	        if (pagesize) {
	            if (filteredItems.length < pagenum * pagesize) {
	                pagenum = Math.floor(filteredItems.length / pagesize);
	            }
	            paged = filteredItems.slice(pagesize * pagenum, pagesize * pagenum + pagesize);
	        } else {
	            paged = filteredItems;
	        }
	
	        return {totalRows: filteredItems.length, rows: paged};
	    }
	
	    function extractGroups(rows, parentGroup) {
	        var group;
	        var val;
	        var newGroups = [];
	        var groupsByVal = {};
	        var r, i, l;
	        var level = parentGroup ? parentGroup.level + 1 : 0;
	        var gi = groupingInfos[level];
	
	        var predefinedValues = [];
	        if (parentGroup && gi.predefinedValuesByParentGroup) {
	            var predefinedValuesForParent = gi.predefinedValuesByParentGroup[parentGroup.value];
	            if (predefinedValuesForParent !== undefined) {
	                predefinedValues = predefinedValues.concat(predefinedValuesForParent);
	            }
	        }
	        predefinedValues = predefinedValues.concat(gi.predefinedValues);
	
	        for (i = 0, l = predefinedValues.length; i < l; i++) {
	            val = predefinedValues[i];
	            group = groupsByVal[val];
	            if (!group) {
	                group = new Slick.Group();
	                group.value = val;
	                group.level = level;
	                group.groupingKey = (parentGroup ? parentGroup.groupingKey + groupingDelimiter : '') + val;
	                if (gi.displayHeaderTotals !== undefined) { group.displayHeaderTotals = gi.displayHeaderTotals; }
	                if (gi.headerTitleColspan !== undefined) { group.headerTitleColspan = gi.headerTitleColspan; }
	                newGroups[newGroups.length] = group;
	                groupsByVal[val] = group;
	            }
	        }
	
	        for (i = 0, l = rows.length; i < l; i++) {
	            r = rows[i];
	            val = gi.getterIsAFn ? gi.getter(r) : r[gi.getter];
	            group = groupsByVal[val];
	            if (!group) {
	                group = new Slick.Group();
	                group.value = val;
	                group.level = level;
	                group.groupingKey = (parentGroup ? parentGroup.groupingKey + groupingDelimiter : '') + val;
	                if (gi.displayHeaderTotals !== undefined) { group.displayHeaderTotals = gi.displayHeaderTotals; }
	                if (gi.headerTitleColspan !== undefined) { group.headerTitleColspan = gi.headerTitleColspan; }
	                newGroups[newGroups.length] = group;
	                groupsByVal[val] = group;
	            }
	
	            group.rows[group.count++] = r;
	        }
	
	        if (level < groupingInfos.length - 1) {
	            for (i = 0; i < newGroups.length; i++) {
	                group = newGroups[i];
	                group.groups = extractGroups(group.rows, group);
	            }
	        }
	
	        newGroups.sort(groupingInfos[level].comparer);
	
	        return newGroups;
	    }
	
	    function calculateTotals(totals) {
	        var group = totals.group;
	        var gi = groupingInfos[group.level];
	        var isLeafLevel = (group.level === groupingInfos.length);
	        var agg, idx = gi.aggregators.length;
	
	        if (!isLeafLevel && gi.aggregateChildGroups) {
	            // make sure all the subgroups are calculated
	            var i = group.groups.length;
	            while (i--) {
	                if (!group.groups[i].initialized) {
	                    calculateTotals(group.groups[i]);
	                }
	            }
	        }
	
	        while (idx--) {
	            agg = gi.aggregators[idx];
	            agg.init();
	            if (!isLeafLevel && gi.aggregateChildGroups) {
	                gi.compiledAccumulators[idx].call(agg, group.groups);
	            } else {
	                gi.compiledAccumulators[idx].call(agg, group.rows);
	            }
	            agg.storeResult(totals);
	        }
	        totals.initialized = true;
	    }
	
	    function addGroupTotals(group) {
	        var gi = groupingInfos[group.level];
	        var totals = new Slick.GroupTotals();
	        totals.group = group;
	        group.totals = totals;
	        if (!gi.lazyTotalsCalculation) {
	            calculateTotals(totals);
	        }
	    }
	
	    function addTotals(groups, level) {
	        level = level || 0;
	        var gi = groupingInfos[level];
	        var groupCollapsed = gi.collapsed;
	        var toggledGroups = toggledGroupsByLevel[level];
	        var idx = groups.length, g;
	
	        while (idx--) {
	            g = groups[idx];
	
	            if (g.collapsed && !gi.aggregateCollapsed) {
	                continue;
	            }
	
	            // Do a depth-first aggregation so that parent group aggregators can access subgroup totals.
	            if (g.groups) {
	                addTotals(g.groups, level + 1);
	            }
	
	            if (gi.aggregators.length && (gi.aggregateEmpty || g.rows.length || (g.groups && g.groups.length))) {
	                addGroupTotals(g);
	            }
	
	            /*jslint bitwise:true */
	            g.collapsed = groupCollapsed ^ toggledGroups[g.groupingKey];
	            /*jslint bitwise:false */
	            g.title = gi.formatter ? gi.formatter(g) : g.value;
	        }
	    }
	
	    function getRowDiffs(rows, newRows) {
	        var item, r, i, rl, eitherIsNonData, diff = [];
	        var from = 0, to = newRows.length;
	
	        if (refreshHints && refreshHints.ignoreDiffsBefore) {
	            from = Math.max(0,
	                    Math.min(newRows.length, refreshHints.ignoreDiffsBefore));
	        }
	
	        if (refreshHints && refreshHints.ignoreDiffsAfter) {
	            to = Math.min(newRows.length,
	                    Math.max(0, refreshHints.ignoreDiffsAfter));
	        }
	
	        for (i = from, rl = rows.length; i < to; i++) {
	            if (i >= rl) {
	                diff[diff.length] = i;
	            } else {
	                item = newRows[i];
	                r = rows[i];
	
	                eitherIsNonData = (item.__nonDataRow) || (r.__nonDataRow);
	                if ((groupingInfos.length && eitherIsNonData &&
	                        (item.__group !== r.__group ||
	                        (item.__group && !item.equals(r))))
	                        || (eitherIsNonData &&
	                        // no good way to compare totals since they are arbitrary DTOs
	                        // deep object comparison is pretty expensive
	                        // always considering them 'dirty' seems easier for the time being
	                        (item.__groupTotals || r.__groupTotals))
	                        || item[idProperty] !== r[idProperty]
	                        || (updated && updated[item[idProperty]])
	                        ) {
	                    diff[diff.length] = i;
	                }
	            }
	        }
	        return diff;
	    }
	
	    function recalc(_items) {
	        rowsById = null;
	
	        if (refreshHints.isFilterNarrowing !== prevRefreshHints.isFilterNarrowing ||
	                refreshHints.isFilterExpanding !== prevRefreshHints.isFilterExpanding) {
	            filterCache = [];
	        }
	
	        var filteredItemsLocal = getFilteredAndPagedItems(_items);
	        totalRows = filteredItemsLocal.totalRows;
	        var newRows = filteredItemsLocal.rows;
	
	        groups = [];
	        if (groupingInfos.length) {
	            groups = extractGroups(newRows);
	            if (groups.length) {
	                addTotals(groups);
	                newRows = flattenGroupedRows(groups);
	            }
	        }
	
	        var diff = getRowDiffs(rows, newRows);
	
	        rows = newRows;
	
	        return diff;
	    }
	
	    function getPagingInfo() {
	        var totalPages = pagesize ? Math.max(1, Math.ceil(totalRows / pagesize)) : 1;
	        return {pageSize: pagesize, pageNum: pagenum, totalRows: totalRows, totalPages: totalPages};
	    }
	
	    function refresh() {
	        if (suspend) {
	            return;
	        }
	
	        var countBefore = rows.length;
	        var totalRowsBefore = totalRows;
	
	        var diff = recalc(items, filter); // pass as direct refs to avoid closure perf hit
	
	        // if the current page is no longer valid, go to last page and recalc
	        // we suffer a performance penalty here, but the main loop (recalc) remains highly optimized
	        if (pagesize && totalRows < pagenum * pagesize) {
	            pagenum = Math.max(0, Math.ceil(totalRows / pagesize) - 1);
	            diff = recalc(items, filter);
	        }
	
	        updated = null;
	        prevRefreshHints = refreshHints;
	        refreshHints = {};
	
	        if (totalRowsBefore !== totalRows) {
	            onPagingInfoChanged.notify(getPagingInfo(), null, self);
	        }
	        if (countBefore !== rows.length) {
	            onRowCountChanged.notify({previous: countBefore, current: rows.length}, null, self);
	        }
	        if (diff.length > 0) {
	            onRowsChanged.notify({rows: diff}, null, self);
	        }
	    }
	
	    function beginUpdate() {
	        suspend = true;
	    }
	
	    function endUpdate() {
	        suspend = false;
	        refresh();
	    }
	
	    function setRefreshHints(hints) {
	        refreshHints = hints;
	    }
	
	    function setFilterArgs(args) {
	        filterArgs = args;
	    }
	
	    function updateIdxById(startingIndex) {
	        startingIndex = startingIndex || 0;
	        var id, i, l;
	        for (i = startingIndex, l = items.length; i < l; i++) {
	            id = items[i][idProperty];
	            if (id === undefined) {
	                throw new Error("Each data element must implement a unique 'id' property");
	            }
	            idxById[id] = i;
	        }
	    }
	
	    function ensureIdUniqueness() {
	        var id, i, l;
	        for (i = 0, l = items.length; i < l; i++) {
	            id = items[i][idProperty];
	            if (id === undefined || idxById[id] !== i) {
	                throw new Error("Each data element must implement a unique 'id' property");
	            }
	        }
	    }
	
	    function getItems() {
	        return items;
	    }
	
	    function setItems(data, objectIdProperty) {
	        if (objectIdProperty !== undefined) {
	            idProperty = objectIdProperty;
	        }
	        items = filteredItems = data;
	        idxById = {};
	        updateIdxById();
	        ensureIdUniqueness();
	        refresh();
	    }
	
	    function setPagingOptions(args) {
	        if (args.pageSize !== undefined) {
	            pagesize = args.pageSize;
	            pagenum = pagesize ? Math.min(pagenum, Math.max(0, Math.ceil(totalRows / pagesize) - 1)) : 0;
	        }
	
	        if (args.pageNum !== undefined) {
	            pagenum = Math.min(args.pageNum, Math.max(0, Math.ceil(totalRows / pagesize) - 1));
	        }
	
	        onPagingInfoChanged.notify(getPagingInfo(), null, self);
	
	        refresh();
	    }
	
	    function sort(comparer, ascending) {
	        sortAsc = ascending;
	        sortComparer = comparer;
	        fastSortField = null;
	        if (ascending === false) {
	            items.reverse();
	        }
	        items.sort(comparer);
	        if (ascending === false) {
	            items.reverse();
	        }
	        idxById = {};
	        updateIdxById();
	        refresh();
	    }
	
	    /***
	     * Provides a workaround for the extremely slow sorting in IE.
	     * Does a [lexicographic] sort on a give column by temporarily overriding Object.prototype.toString
	     * to return the value of that field and then doing a native Array.sort().
	     */
	    function fastSort(field, ascending) {
	        sortAsc = ascending;
	        fastSortField = field;
	        sortComparer = null;
	        var oldToString = Object.prototype.toString;
	        Object.prototype.toString = (typeof field === "function") ? field : function () {
	            return this[field];
	        };
	        // an extra reversal for descending sort keeps the sort stable
	        // (assuming a stable native sort implementation, which isn't true in some cases)
	        if (ascending === false) {
	            items.reverse();
	        }
	        items.sort();
	        Object.prototype.toString = oldToString;
	        if (ascending === false) {
	            items.reverse();
	        }
	        idxById = {};
	        updateIdxById();
	        refresh();
	    }
	
	    function reSort() {
	        if (sortComparer) {
	            sort(sortComparer, sortAsc);
	        } else if (fastSortField) {
	            fastSort(fastSortField, sortAsc);
	        }
	    }
	
	    function setFilter(filterFn) {
	        filter = filterFn;
	        if (options.inlineFilters) {
	            compiledFilter = compileFilter();
	            compiledFilterWithCaching = compileFilterWithCaching();
	        }
	        refresh();
	    }
	
	    function getGrouping() {
	        return groupingInfos;
	    }
	
	    function setGrouping(groupingInfo) {
	        if (!options.groupItemMetadataProvider) {
	            options.groupItemMetadataProvider = new GroupItemMetadataProvider();
	        }
	
	        groups = [];
	        toggledGroupsByLevel = [];
	        groupingInfo = groupingInfo || [];
	        groupingInfos = (groupingInfo instanceof Array) ? groupingInfo : [groupingInfo];
	        var i, idx, gi, parentGroupValue, isNotUndefined = R.complement(R.equals(undefined));
	        for (i = 0; i < groupingInfos.length; i++) {
	            gi = groupingInfos[i] = R.merge(groupingInfoDefaults, R.pickBy(isNotUndefined, groupingInfos[i]));
	            gi.getterIsAFn = typeof gi.getter === "function";
	
	            // validate grouping info
	            if (gi.hideGroupHeaderWhen && typeof gi.hideGroupHeaderWhen !== "function") {
	                throw new Error("Invalid grouping: `hideGroupHeaderWhen` option must be a function.");
	            }
	            if (!Array.isArray(gi.predefinedValues)) {
	                throw new Error("Invalid grouping: `predefinedValues` option must be an array.");
	            }
	            if (gi.predefinedValuesByParentGroup !== null) {
	                if (Object.prototype.toString.call(gi.predefinedValuesByParentGroup) !== "[object Object]") {
	                    throw new Error("Invalid grouping: `predefinedValuesByParentGroup` option must be an object.");
	                }
	                for (parentGroupValue in gi.predefinedValuesByParentGroup) {
	                    if (gi.predefinedValuesByParentGroup.hasOwnProperty(parentGroupValue)
	                            && !Array.isArray(gi.predefinedValuesByParentGroup[parentGroupValue])) {
	                        throw new Error("Invalid `predefinedValuesByParentGroup` grouping option: Value of '" + parentGroupValue + "' property must be an array of predefined values.");
	                    }
	                }
	            }
	
	            // pre-compile accumulator loops
	            gi.compiledAccumulators = [];
	            idx = gi.aggregators.length;
	
	            while (idx--) {
	                gi.compiledAccumulators[idx] = compileAccumulatorLoop(gi.aggregators[idx]);
	            }
	
	            toggledGroupsByLevel[i] = {};
	        }
	
	        refresh();
	    }
	
	    /**
	     * @deprecated Please use {@link setGrouping}.
	     */
	    function groupBy(valueGetter, valueFormatter, sortComparer) {
	        if (valueGetter === null) {
	            setGrouping([]);
	            return;
	        }
	
	        setGrouping({
	            getter: valueGetter,
	            formatter: valueFormatter,
	            comparer: sortComparer
	        });
	    }
	
	    /**
	     * @deprecated Please use {@link setGrouping}.
	     */
	    function setAggregators(groupAggregators, includeCollapsed) {
	        if (!groupingInfos.length) {
	            throw new Error("At least one grouping must be specified before calling setAggregators().");
	        }
	
	        groupingInfos[0].aggregators = groupAggregators;
	        groupingInfos[0].aggregateCollapsed = includeCollapsed;
	
	        setGrouping(groupingInfos);
	    }
	
	    function getItemByIdx(i) {
	        return items[i];
	    }
	
	    function getIdxById(id) {
	        return idxById[id];
	    }
	
	    function ensureRowsByIdCache() {
	        if (!rowsById) {
	            rowsById = {};
	            var i, l;
	            for (i = 0, l = rows.length; i < l; i++) {
	                rowsById[rows[i][idProperty]] = i;
	            }
	        }
	    }
	
	    function getRowById(id) {
	        ensureRowsByIdCache();
	        return rowsById[id];
	    }
	
	    function getItemById(id) {
	        return items[idxById[id]];
	    }
	
	    function mapIdsToRows(idArray) {
	        var rowsLocal = [], i, l, row;
	        ensureRowsByIdCache();
	        for (i = 0, l = idArray.length; i < l; i++) {
	            row = rowsById[idArray[i]];
	            if (row !== null) {
	                rowsLocal[rowsLocal.length] = row;
	            }
	        }
	        return rowsLocal;
	    }
	
	    function mapRowsToIds(rowArray) {
	        var ids = [], i, l;
	        for (i = 0, l = rowArray.length; i < l; i++) {
	            if (rowArray[i] < rows.length) {
	                ids[ids.length] = rows[rowArray[i]][idProperty];
	            }
	        }
	        return ids;
	    }
	
	    function updateItem(id, item) {
	        if (idxById[id] === undefined || id !== item[idProperty]) {
	            throw new Error("Invalid or non-matching id");
	        }
	        items[idxById[id]] = item;
	        if (!updated) {
	            updated = {};
	        }
	        updated[id] = true;
	        refresh();
	    }
	
	    function insertItem(insertBefore, item) {
	        items.splice(insertBefore, 0, item);
	        updateIdxById(insertBefore);
	        refresh();
	    }
	
	    function addItem(item) {
	        items.push(item);
	        updateIdxById(items.length - 1);
	        refresh();
	    }
	
	    function deleteItem(id) {
	        var idx = idxById[id];
	        if (idx === undefined) {
	            throw new Error("Invalid id");
	        }
	        delete idxById[id];
	        items.splice(idx, 1);
	        updateIdxById(idx);
	        refresh();
	    }
	
	    function getLength() {
	        return rows.length;
	    }
	
	    function getItem(i) {
	        var item = rows[i];
	
	        // if this is a group row, make sure totals are calculated and update the title
	        if (item && item.__group && item.totals && !item.totals.initialized) {
	            var gi = groupingInfos[item.level];
	            if (!gi.displayTotalsRow) {
	                calculateTotals(item.totals);
	                item.title = gi.formatter ? gi.formatter(item) : item.value;
	            }
	        // if this is a totals row, make sure it's calculated
	        } else if (item && item.__groupTotals && !item.initialized) {
	            calculateTotals(item);
	        }
	
	        return item;
	    }
	
	    function getItemMetadata(i) {
	        var item = rows[i];
	        if (item === undefined) {
	            return null;
	        }
	
	        // overrides for grouping rows
	        if (item.__group) {
	            return options.groupItemMetadataProvider.getGroupRowMetadata(item);
	        }
	
	        // overrides for totals rows
	        if (item.__groupTotals) {
	            return options.groupItemMetadataProvider.getTotalsRowMetadata(item);
	        }
	
	        return null;
	    }
	
	    function expandCollapseAllGroups(level, collapse) {
	        if (level === null) {
	            var i;
	            for (i = 0; i < groupingInfos.length; i++) {
	                toggledGroupsByLevel[i] = {};
	                groupingInfos[i].collapsed = collapse;
	            }
	        } else {
	            toggledGroupsByLevel[level] = {};
	            groupingInfos[level].collapsed = collapse;
	        }
	        refresh();
	    }
	
	    /**
	     * @param level {Number} Optional level to collapse.  If not specified, applies to all levels.
	     */
	    function collapseAllGroups(level) {
	        expandCollapseAllGroups(level, true);
	    }
	
	    /**
	     * @param level {Number} Optional level to expand.  If not specified, applies to all levels.
	     */
	    function expandAllGroups(level) {
	        expandCollapseAllGroups(level, false);
	    }
	
	    function expandCollapseGroup(level, groupingKey, collapse) {
	        /*jslint bitwise:true */
	        toggledGroupsByLevel[level][groupingKey] = groupingInfos[level].collapsed ^ collapse;
	        /*jslint bitwise:false */
	        refresh();
	    }
	
	    /**
	     * @param varArgs Either a Slick.Group's "groupingKey" property, or a
	     *     variable argument list of grouping values denoting a unique path to the row.  For
	     *     example, calling collapseGroup('high', '10%') will collapse the '10%' subgroup of
	     *     the 'high' group.
	     */
	    /*jslint unparam:true */
	    function collapseGroup(varArgs) {
	        var args = Array.prototype.slice.call(arguments);
	        var arg0 = args[0];
	        if (args.length === 1 && arg0.indexOf(groupingDelimiter) !== -1) {
	            expandCollapseGroup(arg0.split(groupingDelimiter).length - 1, arg0, true);
	        } else {
	            expandCollapseGroup(args.length - 1, args.join(groupingDelimiter), true);
	        }
	    }
	    /*jslint unparam:false */
	
	    /**
	     * @param varArgs Either a Slick.Group's "groupingKey" property, or a
	     *     variable argument list of grouping values denoting a unique path to the row.  For
	     *     example, calling expandGroup('high', '10%') will expand the '10%' subgroup of
	     *     the 'high' group.
	     */
	    /*jslint unparam:true */
	    function expandGroup(varArgs) {
	        var args = Array.prototype.slice.call(arguments);
	        var arg0 = args[0];
	        if (args.length === 1 && arg0.indexOf(groupingDelimiter) !== -1) {
	            expandCollapseGroup(arg0.split(groupingDelimiter).length - 1, arg0, false);
	        } else {
	            expandCollapseGroup(args.length - 1, args.join(groupingDelimiter), false);
	        }
	    }
	    /*jslint unparam:false */
	
	    function getGroups() {
	        return groups;
	    }
	
	    /***
	     * Wires the grid and the DataView together to keep row selection tied to item ids.
	     * This is useful since, without it, the grid only knows about rows, so if the items
	     * move around, the same rows stay selected instead of the selection moving along
	     * with the items.
	     *
	     * NOTE:  This doesn't work with cell selection model.
	     *
	     * @param grid {Slick.Grid} The grid to sync selection with.
	     * @param preserveHidden {Boolean} Whether to keep selected items that go out of the
	     *     view due to them getting filtered out.
	     * @param preserveHiddenOnSelectionChange {Boolean} Whether to keep selected items
	     *     that are currently out of the view (see preserveHidden) as selected when selection
	     *     changes.
	     * @return {Slick.Event} An event that notifies when an internal list of selected row ids
	     *     changes.  This is useful since, in combination with the above two options, it allows
	     *     access to the full list selected row ids, and not just the ones visible to the grid.
	     * @method syncGridSelection
	     */
	    function syncGridSelection(grid, preserveHidden, preserveHiddenOnSelectionChange) {
	        var selfLocal = this;
	        var inHandler;
	        var selectedRowIds = selfLocal.mapRowsToIds(grid.getSelectedRows());
	        var onSelectedRowIdsChanged = new Slick.Event();
	
	        function setSelectedRowIds(rowIds) {
	            if (selectedRowIds.join(",") === rowIds.join(",")) {
	                return;
	            }
	
	            selectedRowIds = rowIds;
	
	            onSelectedRowIdsChanged.notify({
	                "grid": grid,
	                "ids": selectedRowIds
	            }, new Slick.EventData(), selfLocal);
	        }
	
	        function update() {
	            if (selectedRowIds.length > 0) {
	                inHandler = true;
	                var selectedRows = selfLocal.mapIdsToRows(selectedRowIds);
	                if (!preserveHidden) {
	                    setSelectedRowIds(selfLocal.mapRowsToIds(selectedRows));
	                }
	                grid.setSelectedRows(selectedRows);
	                inHandler = false;
	            }
	        }
	
	        /*jslint unparam:true */
	        grid.onSelectedRowsChanged.subscribe(function (e, args) {
	            if (inHandler) { return; }
	            var newSelectedRowIds = selfLocal.mapRowsToIds(grid.getSelectedRows());
	            if (!preserveHiddenOnSelectionChange || !grid.getOptions().multiSelect) {
	                setSelectedRowIds(newSelectedRowIds);
	            } else {
	                // keep the ones that are hidden
	                var existing = selectedRowIds.filter(function (id) { return selfLocal.getRowById(id) === undefined; });
	                // add the newly selected ones
	                setSelectedRowIds(existing.concat(newSelectedRowIds));
	            }
	        });
	        /*jslint unparam:false */
	
	        this.onRowsChanged.subscribe(update);
	
	        this.onRowCountChanged.subscribe(update);
	
	        return onSelectedRowIdsChanged;
	    }
	
	    function syncGridCellCssStyles(grid, key) {
	        var hashById;
	        var inHandler;
	
	        function storeCellCssStyles(hash) {
	            hashById = {};
	            var row, id;
	            for (row in hash) {
	                if (hash.hasOwnProperty(row)) {
	                    id = rows[row][idProperty];
	                    hashById[id] = hash[row];
	                }
	            }
	        }
	
	        function update() {
	            if (hashById) {
	                inHandler = true;
	                ensureRowsByIdCache();
	                var newHash = {}, id, row;
	                for (id in hashById) {
	                    if (hashById.hasOwnProperty(id)) {
	                        row = rowsById[id];
	                        if (row !== undefined) {
	                            newHash[row] = hashById[id];
	                        }
	                    }
	                }
	                grid.setCellCssStyles(key, newHash);
	                inHandler = false;
	            }
	        }
	
	        // since this method can be called after the cell styles have been set,
	        // get the existing ones right away
	        storeCellCssStyles(grid.getCellCssStyles(key));
	
	        /*jslint unparam:true */
	        grid.onCellCssStylesChanged.subscribe(function (e, args) {
	            if (inHandler) { return; }
	            if (key !== args.key) { return; }
	            if (args.hash) {
	                storeCellCssStyles(args.hash);
	            }
	        });
	        /*jslint unparam:false */
	
	        this.onRowsChanged.subscribe(update);
	
	        this.onRowCountChanged.subscribe(update);
	    }
	
	    // methods
	    this.beginUpdate = beginUpdate;
	    this.endUpdate = endUpdate;
	    this.setPagingOptions = setPagingOptions;
	    this.getPagingInfo = getPagingInfo;
	    this.getItems = getItems;
	    this.setItems = setItems;
	    this.setFilter = setFilter;
	    this.sort = sort;
	    this.fastSort = fastSort;
	    this.reSort = reSort;
	    this.setGrouping = setGrouping;
	    this.getGrouping = getGrouping;
	    this.groupBy = groupBy;
	    this.setAggregators = setAggregators;
	    this.collapseAllGroups = collapseAllGroups;
	    this.expandAllGroups = expandAllGroups;
	    this.collapseGroup = collapseGroup;
	    this.expandGroup = expandGroup;
	    this.getGroups = getGroups;
	    this.getIdxById = getIdxById;
	    this.getRowById = getRowById;
	    this.getItemById = getItemById;
	    this.getItemByIdx = getItemByIdx;
	    this.mapRowsToIds = mapRowsToIds;
	    this.mapIdsToRows = mapIdsToRows;
	    this.setRefreshHints = setRefreshHints;
	    this.setFilterArgs = setFilterArgs;
	    this.refresh = refresh;
	    this.updateItem = updateItem;
	    this.insertItem = insertItem;
	    this.addItem = addItem;
	    this.deleteItem = deleteItem;
	    this.syncGridSelection = syncGridSelection;
	    this.syncGridCellCssStyles = syncGridCellCssStyles;
	
	    // data provider methods
	    this.getLength = getLength;
	    this.getItem = getItem;
	    this.getItemMetadata = getItemMetadata;
	
	    // events
	    this.onRowCountChanged = onRowCountChanged;
	    this.onRowsChanged = onRowsChanged;
	    this.onPagingInfoChanged = onPagingInfoChanged;
	}
	
	function AvgAggregator(field) {
	    this.field_ = field;
	
	    this.init = function () {
	        this.count_ = 0;
	        this.nonNullCount_ = 0;
	        this.sum_ = 0;
	    };
	
	    this.accumulate = function (item) {
	        var val = item[this.field_];
	        this.count_++;
	        if (val !== null && val !== "" && !isNaN(val)) {
	            this.nonNullCount_++;
	            this.sum_ += parseFloat(val);
	        }
	    };
	
	    this.storeResult = function (groupTotals) {
	        if (!groupTotals.avg) {
	            groupTotals.avg = {};
	        }
	        if (this.nonNullCount_ !== 0) {
	            groupTotals.avg[this.field_] = this.sum_ / this.nonNullCount_;
	        }
	    };
	}
	
	function MinAggregator(field) {
	    this.field_ = field;
	
	    this.init = function () {
	        this.min_ = null;
	    };
	
	    this.accumulate = function (item) {
	        var val = item[this.field_];
	        if (val !== null && val !== "" && !isNaN(val)) {
	            if (this.min_ === null || val < this.min_) {
	                this.min_ = val;
	            }
	        }
	    };
	
	    this.storeResult = function (groupTotals) {
	        if (!groupTotals.min) {
	            groupTotals.min = {};
	        }
	        groupTotals.min[this.field_] = this.min_;
	    };
	}
	
	function MaxAggregator(field) {
	    this.field_ = field;
	
	    this.init = function () {
	        this.max_ = null;
	    };
	
	    this.accumulate = function (item) {
	        var val = item[this.field_];
	        if (val !== null && val !== "" && !isNaN(val)) {
	            if (this.max_ === null || val > this.max_) {
	                this.max_ = val;
	            }
	        }
	    };
	
	    this.storeResult = function (groupTotals) {
	        if (!groupTotals.max) {
	            groupTotals.max = {};
	        }
	        groupTotals.max[this.field_] = this.max_;
	    };
	}
	
	function SumAggregator(field) {
	    this.field_ = field;
	
	    this.init = function () {
	        this.sum_ = null;
	    };
	
	    this.accumulate = function (item) {
	        var val = item[this.field_];
	        if (val !== null && val !== "" && !isNaN(val)) {
	            this.sum_ += parseFloat(val);
	        }
	    };
	
	    this.storeResult = function (groupTotals) {
	        if (!groupTotals.sum) {
	            groupTotals.sum = {};
	        }
	        groupTotals.sum[this.field_] = this.sum_;
	    };
	}
	
	// TODO:  add more built-in aggregators
	// TODO:  merge common aggregators in one to prevent needles iterating
	
	module.exports = {
	    DataView: DataView,
	    Aggregators: {
	        Avg: AvgAggregator,
	        Min: MinAggregator,
	        Max: MaxAggregator,
	        Sum: SumAggregator
	    }
	};
	


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	var Slick = __webpack_require__(410);
	
	var extend = __webpack_require__(418);
	
	module.exports = GroupItemMetadataProvider;
	
	/***
	 * Provides item metadata for group (Slick.Group) and totals (Slick.Totals) rows produced by the DataView.
	 * This metadata overrides the default behavior and formatting of those rows so that they appear and function
	 * correctly when processed by the grid.
	 *
	 * This class also acts as a grid plugin providing event handlers to expand & collapse groups.
	 * If "grid.registerPlugin(...)" is not called, expand & collapse will not work.
	 *
	 * @class GroupItemMetadataProvider
	 * @module Data
	 * @namespace Slick.Data
	 * @constructor
	 * @param options
	 */
	function GroupItemMetadataProvider(options) {
	  var _grid;
	  var _defaults = {
	    groupCssClass: "slick-group",
	    groupTitleCssClass: "slick-group-title",
	    totalsCssClass: "slick-group-totals",
	    groupFocusable: true,
	    totalsFocusable: false,
	    toggleCssClass: "slick-group-toggle",
	    toggleExpandedCssClass: "expanded",
	    toggleCollapsedCssClass: "collapsed",
	    enableExpandCollapse: true,
	    groupFormatter: defaultGroupCellFormatter,
	    totalsFormatter: defaultTotalsCellFormatter
	  };
	
	  options = extend(true, {}, _defaults, options);
	
	
	  function defaultGroupCellFormatter(row, cell, value, columnDef, item) {
	    if (!options.enableExpandCollapse) {
	      return item.title;
	    }
	
	    var indentation = item.level * 15 + "px";
	
	    return "<span class='" + options.toggleCssClass + " " +
	        (item.collapsed ? options.toggleCollapsedCssClass : options.toggleExpandedCssClass) +
	        "' style='margin-left:" + indentation +"'>" +
	        "</span>" +
	        "<span class='" + options.groupTitleCssClass + "' level='" + item.level + "'>" +
	          item.title +
	        "</span>";
	  }
	
	  function defaultTotalsCellFormatter(row, cell, value, columnDef, item) {
	    return (columnDef.groupTotalsFormatter && columnDef.groupTotalsFormatter(item, columnDef)) || "";
	  }
	
	
	  function init(grid) {
	    _grid = grid;
	    _grid.onClick.subscribe(handleGridClick);
	    _grid.onKeyDown.subscribe(handleGridKeyDown);
	
	  }
	
	  function destroy() {
	    if (_grid) {
	      _grid.onClick.unsubscribe(handleGridClick);
	      _grid.onKeyDown.unsubscribe(handleGridKeyDown);
	    }
	  }
	
	  function handleGridClick(e, args) {
	    var item = this.getDataItem(args.row);
	    if (item && item instanceof Slick.Group && $(e.target).hasClass(options.toggleCssClass)) {
	      var range = _grid.getRenderedRange();
	      this.getData().setRefreshHints({
	        ignoreDiffsBefore: range.top,
	        ignoreDiffsAfter: range.bottom
	      });
	
	      if (item.collapsed) {
	        this.getData().expandGroup(item.groupingKey);
	      } else {
	        this.getData().collapseGroup(item.groupingKey);
	      }
	
	      e.stopImmediatePropagation();
	      e.preventDefault();
	    }
	  }
	
	  // TODO:  add -/+ handling
	  function handleGridKeyDown(e, args) {
	    if (options.enableExpandCollapse && (e.which == $.ui.keyCode.SPACE)) {
	      var activeCell = this.getActiveCell();
	      if (activeCell) {
	        var item = this.getDataItem(activeCell.row);
	        if (item && item instanceof Slick.Group) {
	          var range = _grid.getRenderedRange();
	          this.getData().setRefreshHints({
	            ignoreDiffsBefore: range.top,
	            ignoreDiffsAfter: range.bottom
	          });
	
	          if (item.collapsed) {
	            this.getData().expandGroup(item.groupingKey);
	          } else {
	            this.getData().collapseGroup(item.groupingKey);
	          }
	
	          e.stopImmediatePropagation();
	          e.preventDefault();
	        }
	      }
	    }
	  }
	
	  function getGroupRowMetadata(item) {
	    return {
	      selectable: false,
	      focusable: options.groupFocusable,
	      cssClasses: options.groupCssClass,
	      columns: {
	        0: {
	          colspan: "*",
	          formatter: options.groupFormatter,
	          editor: null
	        }
	      }
	    };
	  }
	
	  function getTotalsRowMetadata(item) {
	    return {
	      selectable: false,
	      focusable: options.totalsFocusable,
	      cssClasses: options.totalsCssClass,
	      formatter: options.totalsFormatter,
	      editor: null
	    };
	  }
	
	
	  return {
	    "init": init,
	    "destroy": destroy,
	    "getGroupRowMetadata": getGroupRowMetadata,
	    "getTotalsRowMetadata": getTotalsRowMetadata
	  };
	}
	


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	module.exports = __webpack_require__(419);
	


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	/*!
	 * node.extend
	 * Copyright 2011, John Resig
	 * Dual licensed under the MIT or GPL Version 2 licenses.
	 * http://jquery.org/license
	 *
	 * @fileoverview
	 * Port of jQuery.extend that actually works on node.js
	 */
	var is = __webpack_require__(420);
	
	var extend = function extend() {
	  var target = arguments[0] || {};
	  var i = 1;
	  var length = arguments.length;
	  var deep = false;
	  var options, name, src, copy, copyIsArray, clone;
	
	  // Handle a deep copy situation
	  if (typeof target === 'boolean') {
	    deep = target;
	    target = arguments[1] || {};
	    // skip the boolean and the target
	    i = 2;
	  }
	
	  // Handle case when target is a string or something (possible in deep copy)
	  if (typeof target !== 'object' && !is.fn(target)) {
	    target = {};
	  }
	
	  for (; i < length; i++) {
	    // Only deal with non-null/undefined values
	    options = arguments[i];
	    if (options != null) {
	      if (typeof options === 'string') {
	        options = options.split('');
	      }
	      // Extend the base object
	      for (name in options) {
	        src = target[name];
	        copy = options[name];
	
	        // Prevent never-ending loop
	        if (target === copy) {
	          continue;
	        }
	
	        // Recurse if we're merging plain objects or arrays
	        if (deep && copy && (is.hash(copy) || (copyIsArray = is.array(copy)))) {
	          if (copyIsArray) {
	            copyIsArray = false;
	            clone = src && is.array(src) ? src : [];
	          } else {
	            clone = src && is.hash(src) ? src : {};
	          }
	
	          // Never move original objects, clone them
	          target[name] = extend(deep, clone, copy);
	
	        // Don't bring in undefined values
	        } else if (typeof copy !== 'undefined') {
	          target[name] = copy;
	        }
	      }
	    }
	  }
	
	  // Return the modified object
	  return target;
	};
	
	/**
	 * @public
	 */
	extend.version = '1.1.3';
	
	/**
	 * Exports module.
	 */
	module.exports = extend;
	


/***/ }),
/* 420 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/* globals window, HTMLElement */
	
	'use strict';
	
	/**!
	 * is
	 * the definitive JavaScript type testing library
	 *
	 * @copyright 2013-2014 Enrico Marino / Jordan Harband
	 * @license MIT
	 */
	
	var objProto = Object.prototype;
	var owns = objProto.hasOwnProperty;
	var toStr = objProto.toString;
	var symbolValueOf;
	if (typeof Symbol === 'function') {
	  symbolValueOf = Symbol.prototype.valueOf;
	}
	var isActualNaN = function (value) {
	  return value !== value;
	};
	var NON_HOST_TYPES = {
	  'boolean': 1,
	  number: 1,
	  string: 1,
	  undefined: 1
	};
	
	var base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
	var hexRegex = /^[A-Fa-f0-9]+$/;
	
	/**
	 * Expose `is`
	 */
	
	var is = {};
	
	/**
	 * Test general.
	 */
	
	/**
	 * is.type
	 * Test if `value` is a type of `type`.
	 *
	 * @param {Mixed} value value to test
	 * @param {String} type type
	 * @return {Boolean} true if `value` is a type of `type`, false otherwise
	 * @api public
	 */
	
	is.a = is.type = function (value, type) {
	  return typeof value === type;
	};
	
	/**
	 * is.defined
	 * Test if `value` is defined.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if 'value' is defined, false otherwise
	 * @api public
	 */
	
	is.defined = function (value) {
	  return typeof value !== 'undefined';
	};
	
	/**
	 * is.empty
	 * Test if `value` is empty.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is empty, false otherwise
	 * @api public
	 */
	
	is.empty = function (value) {
	  var type = toStr.call(value);
	  var key;
	
	  if (type === '[object Array]' || type === '[object Arguments]' || type === '[object String]') {
	    return value.length === 0;
	  }
	
	  if (type === '[object Object]') {
	    for (key in value) {
	      if (owns.call(value, key)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  return !value;
	};
	
	/**
	 * is.equal
	 * Test if `value` is equal to `other`.
	 *
	 * @param {Mixed} value value to test
	 * @param {Mixed} other value to compare with
	 * @return {Boolean} true if `value` is equal to `other`, false otherwise
	 */
	
	is.equal = function equal(value, other) {
	  if (value === other) {
	    return true;
	  }
	
	  var type = toStr.call(value);
	  var key;
	
	  if (type !== toStr.call(other)) {
	    return false;
	  }
	
	  if (type === '[object Object]') {
	    for (key in value) {
	      if (!is.equal(value[key], other[key]) || !(key in other)) {
	        return false;
	      }
	    }
	    for (key in other) {
	      if (!is.equal(value[key], other[key]) || !(key in value)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  if (type === '[object Array]') {
	    key = value.length;
	    if (key !== other.length) {
	      return false;
	    }
	    while (key--) {
	      if (!is.equal(value[key], other[key])) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  if (type === '[object Function]') {
	    return value.prototype === other.prototype;
	  }
	
	  if (type === '[object Date]') {
	    return value.getTime() === other.getTime();
	  }
	
	  return false;
	};
	
	/**
	 * is.hosted
	 * Test if `value` is hosted by `host`.
	 *
	 * @param {Mixed} value to test
	 * @param {Mixed} host host to test with
	 * @return {Boolean} true if `value` is hosted by `host`, false otherwise
	 * @api public
	 */
	
	is.hosted = function (value, host) {
	  var type = typeof host[value];
	  return type === 'object' ? !!host[value] : !NON_HOST_TYPES[type];
	};
	
	/**
	 * is.instance
	 * Test if `value` is an instance of `constructor`.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is an instance of `constructor`
	 * @api public
	 */
	
	is.instance = is['instanceof'] = function (value, constructor) {
	  return value instanceof constructor;
	};
	
	/**
	 * is.nil / is.null
	 * Test if `value` is null.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is null, false otherwise
	 * @api public
	 */
	
	is.nil = is['null'] = function (value) {
	  return value === null;
	};
	
	/**
	 * is.undef / is.undefined
	 * Test if `value` is undefined.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is undefined, false otherwise
	 * @api public
	 */
	
	is.undef = is.undefined = function (value) {
	  return typeof value === 'undefined';
	};
	
	/**
	 * Test arguments.
	 */
	
	/**
	 * is.args
	 * Test if `value` is an arguments object.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is an arguments object, false otherwise
	 * @api public
	 */
	
	is.args = is.arguments = function (value) {
	  var isStandardArguments = toStr.call(value) === '[object Arguments]';
	  var isOldArguments = !is.array(value) && is.arraylike(value) && is.object(value) && is.fn(value.callee);
	  return isStandardArguments || isOldArguments;
	};
	
	/**
	 * Test array.
	 */
	
	/**
	 * is.array
	 * Test if 'value' is an array.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is an array, false otherwise
	 * @api public
	 */
	
	is.array = Array.isArray || function (value) {
	  return toStr.call(value) === '[object Array]';
	};
	
	/**
	 * is.arguments.empty
	 * Test if `value` is an empty arguments object.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is an empty arguments object, false otherwise
	 * @api public
	 */
	is.args.empty = function (value) {
	  return is.args(value) && value.length === 0;
	};
	
	/**
	 * is.array.empty
	 * Test if `value` is an empty array.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is an empty array, false otherwise
	 * @api public
	 */
	is.array.empty = function (value) {
	  return is.array(value) && value.length === 0;
	};
	
	/**
	 * is.arraylike
	 * Test if `value` is an arraylike object.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is an arguments object, false otherwise
	 * @api public
	 */
	
	is.arraylike = function (value) {
	  return !!value && !is.bool(value)
	    && owns.call(value, 'length')
	    && isFinite(value.length)
	    && is.number(value.length)
	    && value.length >= 0;
	};
	
	/**
	 * Test boolean.
	 */
	
	/**
	 * is.bool
	 * Test if `value` is a boolean.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is a boolean, false otherwise
	 * @api public
	 */
	
	is.bool = is['boolean'] = function (value) {
	  return toStr.call(value) === '[object Boolean]';
	};
	
	/**
	 * is.false
	 * Test if `value` is false.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is false, false otherwise
	 * @api public
	 */
	
	is['false'] = function (value) {
	  return is.bool(value) && Boolean(Number(value)) === false;
	};
	
	/**
	 * is.true
	 * Test if `value` is true.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is true, false otherwise
	 * @api public
	 */
	
	is['true'] = function (value) {
	  return is.bool(value) && Boolean(Number(value)) === true;
	};
	
	/**
	 * Test date.
	 */
	
	/**
	 * is.date
	 * Test if `value` is a date.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is a date, false otherwise
	 * @api public
	 */
	
	is.date = function (value) {
	  return toStr.call(value) === '[object Date]';
	};
	
	/**
	 * is.date.valid
	 * Test if `value` is a valid date.
	 *
	 * @param {Mixed} value value to test
	 * @returns {Boolean} true if `value` is a valid date, false otherwise
	 */
	is.date.valid = function (value) {
	  return is.date(value) && !isNaN(Number(value));
	};
	
	/**
	 * Test element.
	 */
	
	/**
	 * is.element
	 * Test if `value` is an html element.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is an HTML Element, false otherwise
	 * @api public
	 */
	
	is.element = function (value) {
	  return value !== undefined
	    && typeof HTMLElement !== 'undefined'
	    && value instanceof HTMLElement
	    && value.nodeType === 1;
	};
	
	/**
	 * Test error.
	 */
	
	/**
	 * is.error
	 * Test if `value` is an error object.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is an error object, false otherwise
	 * @api public
	 */
	
	is.error = function (value) {
	  return toStr.call(value) === '[object Error]';
	};
	
	/**
	 * Test function.
	 */
	
	/**
	 * is.fn / is.function (deprecated)
	 * Test if `value` is a function.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is a function, false otherwise
	 * @api public
	 */
	
	is.fn = is['function'] = function (value) {
	  var isAlert = typeof window !== 'undefined' && value === window.alert;
	  return isAlert || toStr.call(value) === '[object Function]';
	};
	
	/**
	 * Test number.
	 */
	
	/**
	 * is.number
	 * Test if `value` is a number.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is a number, false otherwise
	 * @api public
	 */
	
	is.number = function (value) {
	  return toStr.call(value) === '[object Number]';
	};
	
	/**
	 * is.infinite
	 * Test if `value` is positive or negative infinity.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is positive or negative Infinity, false otherwise
	 * @api public
	 */
	is.infinite = function (value) {
	  return value === Infinity || value === -Infinity;
	};
	
	/**
	 * is.decimal
	 * Test if `value` is a decimal number.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is a decimal number, false otherwise
	 * @api public
	 */
	
	is.decimal = function (value) {
	  return is.number(value) && !isActualNaN(value) && !is.infinite(value) && value % 1 !== 0;
	};
	
	/**
	 * is.divisibleBy
	 * Test if `value` is divisible by `n`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} n dividend
	 * @return {Boolean} true if `value` is divisible by `n`, false otherwise
	 * @api public
	 */
	
	is.divisibleBy = function (value, n) {
	  var isDividendInfinite = is.infinite(value);
	  var isDivisorInfinite = is.infinite(n);
	  var isNonZeroNumber = is.number(value) && !isActualNaN(value) && is.number(n) && !isActualNaN(n) && n !== 0;
	  return isDividendInfinite || isDivisorInfinite || (isNonZeroNumber && value % n === 0);
	};
	
	/**
	 * is.integer
	 * Test if `value` is an integer.
	 *
	 * @param value to test
	 * @return {Boolean} true if `value` is an integer, false otherwise
	 * @api public
	 */
	
	is.integer = is['int'] = function (value) {
	  return is.number(value) && !isActualNaN(value) && value % 1 === 0;
	};
	
	/**
	 * is.maximum
	 * Test if `value` is greater than 'others' values.
	 *
	 * @param {Number} value value to test
	 * @param {Array} others values to compare with
	 * @return {Boolean} true if `value` is greater than `others` values
	 * @api public
	 */
	
	is.maximum = function (value, others) {
	  if (isActualNaN(value)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.arraylike(others)) {
	    throw new TypeError('second argument must be array-like');
	  }
	  var len = others.length;
	
	  while (--len >= 0) {
	    if (value < others[len]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	/**
	 * is.minimum
	 * Test if `value` is less than `others` values.
	 *
	 * @param {Number} value value to test
	 * @param {Array} others values to compare with
	 * @return {Boolean} true if `value` is less than `others` values
	 * @api public
	 */
	
	is.minimum = function (value, others) {
	  if (isActualNaN(value)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.arraylike(others)) {
	    throw new TypeError('second argument must be array-like');
	  }
	  var len = others.length;
	
	  while (--len >= 0) {
	    if (value > others[len]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	/**
	 * is.nan
	 * Test if `value` is not a number.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is not a number, false otherwise
	 * @api public
	 */
	
	is.nan = function (value) {
	  return !is.number(value) || value !== value;
	};
	
	/**
	 * is.even
	 * Test if `value` is an even number.
	 *
	 * @param {Number} value value to test
	 * @return {Boolean} true if `value` is an even number, false otherwise
	 * @api public
	 */
	
	is.even = function (value) {
	  return is.infinite(value) || (is.number(value) && value === value && value % 2 === 0);
	};
	
	/**
	 * is.odd
	 * Test if `value` is an odd number.
	 *
	 * @param {Number} value value to test
	 * @return {Boolean} true if `value` is an odd number, false otherwise
	 * @api public
	 */
	
	is.odd = function (value) {
	  return is.infinite(value) || (is.number(value) && value === value && value % 2 !== 0);
	};
	
	/**
	 * is.ge
	 * Test if `value` is greater than or equal to `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean}
	 * @api public
	 */
	
	is.ge = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value >= other;
	};
	
	/**
	 * is.gt
	 * Test if `value` is greater than `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean}
	 * @api public
	 */
	
	is.gt = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value > other;
	};
	
	/**
	 * is.le
	 * Test if `value` is less than or equal to `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean} if 'value' is less than or equal to 'other'
	 * @api public
	 */
	
	is.le = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value <= other;
	};
	
	/**
	 * is.lt
	 * Test if `value` is less than `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean} if `value` is less than `other`
	 * @api public
	 */
	
	is.lt = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value < other;
	};
	
	/**
	 * is.within
	 * Test if `value` is within `start` and `finish`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} start lower bound
	 * @param {Number} finish upper bound
	 * @return {Boolean} true if 'value' is is within 'start' and 'finish'
	 * @api public
	 */
	is.within = function (value, start, finish) {
	  if (isActualNaN(value) || isActualNaN(start) || isActualNaN(finish)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.number(value) || !is.number(start) || !is.number(finish)) {
	    throw new TypeError('all arguments must be numbers');
	  }
	  var isAnyInfinite = is.infinite(value) || is.infinite(start) || is.infinite(finish);
	  return isAnyInfinite || (value >= start && value <= finish);
	};
	
	/**
	 * Test object.
	 */
	
	/**
	 * is.object
	 * Test if `value` is an object.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is an object, false otherwise
	 * @api public
	 */
	is.object = function (value) {
	  return toStr.call(value) === '[object Object]';
	};
	
	/**
	 * is.primitive
	 * Test if `value` is a primitive.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is a primitive, false otherwise
	 * @api public
	 */
	is.primitive = function isPrimitive(value) {
	  if (!value) {
	    return true;
	  }
	  if (typeof value === 'object' || is.object(value) || is.fn(value) || is.array(value)) {
	    return false;
	  }
	  return true;
	};
	
	/**
	 * is.hash
	 * Test if `value` is a hash - a plain object literal.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is a hash, false otherwise
	 * @api public
	 */
	
	is.hash = function (value) {
	  return is.object(value) && value.constructor === Object && !value.nodeType && !value.setInterval;
	};
	
	/**
	 * Test regexp.
	 */
	
	/**
	 * is.regexp
	 * Test if `value` is a regular expression.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is a regexp, false otherwise
	 * @api public
	 */
	
	is.regexp = function (value) {
	  return toStr.call(value) === '[object RegExp]';
	};
	
	/**
	 * Test string.
	 */
	
	/**
	 * is.string
	 * Test if `value` is a string.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if 'value' is a string, false otherwise
	 * @api public
	 */
	
	is.string = function (value) {
	  return toStr.call(value) === '[object String]';
	};
	
	/**
	 * Test base64 string.
	 */
	
	/**
	 * is.base64
	 * Test if `value` is a valid base64 encoded string.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if 'value' is a base64 encoded string, false otherwise
	 * @api public
	 */
	
	is.base64 = function (value) {
	  return is.string(value) && (!value.length || base64Regex.test(value));
	};
	
	/**
	 * Test base64 string.
	 */
	
	/**
	 * is.hex
	 * Test if `value` is a valid hex encoded string.
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if 'value' is a hex encoded string, false otherwise
	 * @api public
	 */
	
	is.hex = function (value) {
	  return is.string(value) && (!value.length || hexRegex.test(value));
	};
	
	/**
	 * is.symbol
	 * Test if `value` is an ES6 Symbol
	 *
	 * @param {Mixed} value value to test
	 * @return {Boolean} true if `value` is a Symbol, false otherise
	 * @api public
	 */
	
	is.symbol = function (value) {
	  return typeof Symbol === 'function' && toStr.call(value) === '[object Symbol]' && typeof symbolValueOf.call(value) === 'symbol';
	};
	
	module.exports = is;
	


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var R = __webpack_require__(7);
	var util = __webpack_require__(422);
	var stringUtil = __webpack_require__(13);
	var numberUtil = __webpack_require__(21);
	
	//-------------------------------------------
	// Creates a comparator function that treats
	// null as the lowest value.
	function createNullComparator(getValue) {
	    return function nullComparator(x, y) {
	        var xValue = getValue(x);
	        var yValue = getValue(y);
	
	        if (xValue === yValue) { return 0; }
	        if (xValue === null) { return -1; }
	        if (yValue === null) { return 1; }
	        return (xValue < yValue ? -1 : 1);
	    };
	}
	
	
	//-------------------------------------------
	// Gets a lower-case value and handles `null`
	// or `undefined` at any level. Switched from
	// using ramdajs to compose the function to
	// improve performance for older IE browsers.
	function createCaseInsensitiveGet(field) {
	    return function getCaseInsensitiveValue(value) {
	        if (value === null || value === undefined) { return ""; }
	        var fieldValue = value[field];
	        if (fieldValue === null || fieldValue === undefined) { return ""; }
	        return fieldValue.toString().toLowerCase();
	    };
	}
	
	
	//-------------------------------------------
	// Creates a comparator function that performs
	// a case-insensitive string comparison.
	function createCaseInsensitiveComparer(field) {
	    var getValue = createCaseInsensitiveGet(field);
	    return function caseInsensitiveComparer(x, y) {
	        var xValue = getValue(x);
	        var yValue = getValue(y);
	        return xValue === yValue ? 0 : (xValue < yValue ? -1 : 1);
	    };
	}
	
	
	//-------------------------------------------
	// Creates a comparator function that performs
	// an object comparison.
	function createCaseSensitiveComparer(field) {
	    return createNullComparator(util.propOrDefault(field, null));
	}
	
	
	//-------------------------------------------
	// Creates a comparator function that performs
	// converts the value to a number and compares it.
	function createNumberComparer(field) {
	    return createNullComparator(R.compose(numberUtil.parseNumber, util.propOrDefault(field, null)));
	}
	
	
	//-------------------------------------------
	// Transforms two comparator functions into a
	// single function. The right function is
	// executed if the result of the left equals `0`.
	function composeComparator(left, right) {
	    return function (x, y) {
	        var result = left(x, y);
	        return (result === 0 ? right(x, y) : result);
	    };
	}
	
	
	//-------------------------------------------
	// Transforms an array of comparator functions
	// into a single function.
	function composeComparators(comparators) {
	    var result = function () { return 0; };
	    var i, l = comparators.length;
	    for (i = 0; i < l; i += 1) {
	        result = composeComparator(result, comparators[i]);
	    }
	    return result;
	}
	
	
	//-------------------------------------------
	// Default implementation of the resolver factory
	// accepts a string id and returns a comparer function.
	function defaultFactory(id) {
	    if (stringUtil.isNullOrWhitespace(id)) { throw new Error("comparer factory id must be a string."); }
	    var pair = id.split(":");
	    var comparerType = (pair[1] || "").toLowerCase();
	    var comparerField = pair[0];
	    var comparer;
	    switch (comparerType) {
	    case "default":
	        comparer = createCaseInsensitiveComparer(comparerField);
	        break;
	    case "number":
	        comparer = createNumberComparer(comparerField);
	        break;
	    case "sensitive":
	        comparer = createCaseSensitiveComparer(comparerField);
	        break;
	    default:
	        throw new Error("`".concat(comparerType, "` comparer type is not supported."));
	    }
	    return comparer;
	}
	
	
	//-------------------------------------------
	// Accepts a factory function and returns a function
	// that resolves a comparator.
	function initFactory(factory) {
	    return function comparerResolver(context, value, isDescending) {
	        var comparer;
	        if (Array.isArray(value)) {
	            var i, l = value.length, result = [];
	            for (i = 0; i < l; i += 1) {
	                result.push(comparerResolver(context, value[i]));
	            }
	            comparer = composeComparators(result);
	        } else if (typeof value === "function") {
	            comparer = value;
	        } else {
	            comparer = factory.call(context, value);
	        }
	        return R.bind((isDescending ? R.compose(R.multiply(-1), comparer) : comparer), context);
	    };
	}
	
	
	module.exports = {
	    composeComparators: composeComparators,
	    defaultFactory: initFactory(defaultFactory),
	    init: initFactory
	};
	


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var R = __webpack_require__(7);
	__webpack_require__(423);
	/** A function that returns raw value if it's a date or parses it as a JSON date if it's a string. */
	exports.asDate = R.ifElse(R.is(Date), R.identity, Date.fromJSONDate);
	function debounce(callback, timeout) {
	    var timeoutInstance = -1;
	    return function () {
	        if (timeoutInstance !== -1) {
	            clearTimeout(timeoutInstance);
	        }
	        timeoutInstance = setTimeout(callback, timeout);
	    };
	}
	exports.debounce = debounce;
	function propOrDefault(field, defaultValue) {
	    return function (item) {
	        if (item === undefined || item === null) {
	            return defaultValue;
	        }
	        var value = item[field];
	        if (value === undefined || value === null) {
	            return defaultValue;
	        }
	        return value;
	    };
	}
	exports.propOrDefault = propOrDefault;
	function convertToString(defaultValue) {
	    return function (value) {
	        if (typeof value === "string") {
	            return value;
	        }
	        else if (value !== null && value !== undefined && typeof value.toString === "function") {
	            return value.toString();
	        }
	        else {
	            return defaultValue;
	        }
	    };
	}
	exports.convertToString = convertToString;
	/**
	 * Gets the index of the first column to which an aggregator has been applied.
	 *
	 * @param gridColumns
	 *     Array of grid columns currently being rendered.
	 * @param aggregators
	 *     Array of SlickGrid aggregator instances that contain column name in a "field_" property.
	 * @returns
	 *     Index of the first column to which an aggregator has been applied or -1 if
	 *     no aggregates were specified.
	 */
	function findFirstAggregateColumn(gridColumns, aggregators) {
	    if (!Array.isArray(gridColumns)) {
	        throw new Error("Expected \"gridColumns\" to be an array of grid columns.");
	    }
	    if (!Array.isArray(aggregators)) {
	        throw new Error("Expected \"aggregators\" to be an array of Aggregator objects.");
	    }
	    var aggregatedColumns = R.uniq(R.pluck("field_", aggregators));
	    var index;
	    for (var c = 0; c < gridColumns.length; c += 1) {
	        index = aggregatedColumns.indexOf(gridColumns[c].field);
	        if (index >= 0) {
	            return c;
	        }
	    }
	    return -1;
	}
	exports.findFirstAggregateColumn = findFirstAggregateColumn;
	function stringOrDefault(field, defaultValue) {
	    return R.compose(convertToString(defaultValue), propOrDefault(field, defaultValue));
	}
	exports.stringOrDefault = stringOrDefault;
	



/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	__webpack_require__(424);
	
	__webpack_require__(437);
	
	module.exports = Date;
	


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/**
	 * @overview NPM Module index: include all the core modules, I18n files will be loaded on the fly.
	 * @author Gregory Wild-Smith <gregory@wild-smith.com>
	 */
	__webpack_require__(425);
	__webpack_require__(426);
	__webpack_require__(427);
	__webpack_require__(428);
	__webpack_require__(429);
	__webpack_require__(430);
	__webpack_require__(431);
	__webpack_require__(432);
	__webpack_require__(433);
	__webpack_require__(434);
	__webpack_require__(435);
	__webpack_require__(436);
	/*
	 * Notice that there is no model.export or exports. This is not required as it modifies the Date object and it's prototypes.
	 */


/***/ }),
/* 425 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		var $D = Date;
		var lang = Date.CultureStrings ? Date.CultureStrings.lang : null;
		var loggedKeys = {}; // for debug purposes.
		var getText = {
			getFromKey: function (key, countryCode) {
				var output;
				if (Date.CultureStrings && Date.CultureStrings[countryCode] && Date.CultureStrings[countryCode][key]) {
					output = Date.CultureStrings[countryCode][key];
				} else {
					output = getText.buildFromDefault(key);
				}
				if (key.charAt(0) === "/") { // Assume it's a regex
					output = getText.buildFromRegex(key, countryCode);
				}
				return output;
			},
			getFromObjectValues: function (obj, countryCode) {
				var key, output = {};
				for(key in obj) {
					if (obj.hasOwnProperty(key)) {
						output[key] = getText.getFromKey(obj[key], countryCode);
					}
				}
				return output;
			},
			getFromObjectKeys: function (obj, countryCode) {
				var key, output = {};
				for(key in obj) {
					if (obj.hasOwnProperty(key)) {
						output[getText.getFromKey(key, countryCode)] = obj[key];
					}
				}
				return output;
			},
			getFromArray: function (arr, countryCode) {
				var output = [];
				for (var i=0; i < arr.length; i++){
					if (i in arr) {
						output[i] = getText.getFromKey(arr[i], countryCode);
					}
				}
				return output;
			},
			buildFromDefault: function (key) {
				var output, length, split, last;
				switch(key) {
					case "name":
						output = "en-US";
						break;
					case "englishName":
						output = "English (United States)";
						break;
					case "nativeName":
						output = "English (United States)";
						break;
					case "twoDigitYearMax":
						output = 2049;
						break;
					case "firstDayOfWeek":
						output = 0;
						break;
					default:
						output = key;
						split = key.split("_");
						length = split.length;
						if (length > 1 && key.charAt(0) !== "/") {
							// if the key isn't a regex and it has a split.
							last = split[(length - 1)].toLowerCase();
							if (last === "initial" || last === "abbr") {
								output = split[0];
							}
						}
						break;
				}
				return output;
			},
			buildFromRegex: function (key, countryCode) {
				var output;
				if (Date.CultureStrings && Date.CultureStrings[countryCode] && Date.CultureStrings[countryCode][key]) {
					output = new RegExp(Date.CultureStrings[countryCode][key], "i");
				} else {
					output = new RegExp(key.replace(new RegExp("/", "g"),""), "i");
				}
				return output;
			}
		};
	
		var shallowMerge = function (obj1, obj2) {
			for (var attrname in obj2) {
				if (obj2.hasOwnProperty(attrname)) {
					obj1[attrname] = obj2[attrname];
				}
			}
		};
	
		var __ = function (key, language) {
			var countryCode = (language) ? language : lang;
			loggedKeys[key] = key;
			if (typeof key === "object") {
				if (key instanceof Array) {
					return getText.getFromArray(key, countryCode);
				} else {
					return getText.getFromObjectKeys(key, countryCode);
				}
			} else {
				return getText.getFromKey(key, countryCode);
			}
		};
		
		var loadI18nScript = function (code) {
			// paatterned after jQuery's getScript.
			var url = Date.Config.i18n + code + ".js";
			var head = document.getElementsByTagName("head")[0] || document.documentElement;
			var script = document.createElement("script");
			script.src = url;
	
			var completed = false;
			var events = {
				done: function (){} // placeholder function
			};
			// Attach handlers for all browsers
			script.onload = script.onreadystatechange = function() {
				if ( !completed && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") ) {
					events.done();
					head.removeChild(script);
				}
			};
	
			setTimeout(function() {
				head.insertBefore(script, head.firstChild);
			}, 0); // allows return to execute first
			
			return {
				done: function (cb) {
					events.done = function() {
						if (cb) {
							setTimeout(cb,0);
						}
					};
				}
			};
		};
	
		var buildInfo = {
			buildFromMethodHash: function (obj) {
				var key;
				for(key in obj) {
					if (obj.hasOwnProperty(key)) {
						obj[key] = buildInfo[obj[key]]();
					}
				}
				return obj;
			},
			timeZoneDST: function () {
				var DST = {
					"CHADT": "+1345",
					"NZDT": "+1300",
					"AEDT": "+1100",
					"ACDT": "+1030",
					"AZST": "+0500",
					"IRDT": "+0430",
					"EEST": "+0300",
					"CEST": "+0200",
					"BST": "+0100",
					"PMDT": "-0200",
					"ADT": "-0300",
					"NDT": "-0230",
					"EDT": "-0400",
					"CDT": "-0500",
					"MDT": "-0600",
					"PDT": "-0700",
					"AKDT": "-0800",
					"HADT": "-0900"
				};
				return __(DST);
			},
			timeZoneStandard: function () {
				var standard = {
					"LINT": "+1400",
					"TOT": "+1300",
					"CHAST": "+1245",
					"NZST": "+1200",
					"NFT": "+1130",
					"SBT": "+1100",
					"AEST": "+1000",
					"ACST": "+0930",
					"JST": "+0900",
					"CWST": "+0845",
					"CT": "+0800",
					"ICT": "+0700",
					"MMT": "+0630",
					"BST": "+0600",
					"NPT": "+0545",
					"IST": "+0530",
					"PKT": "+0500",
					"AFT": "+0430",
					"MSK": "+0400",
					"IRST": "+0330",
					"FET": "+0300",
					"EET": "+0200",
					"CET": "+0100",
					"GMT": "+0000",
					"UTC": "+0000",
					"CVT": "-0100",
					"GST": "-0200",
					"BRT": "-0300",
					"NST": "-0330",
					"AST": "-0400",
					"EST": "-0500",
					"CST": "-0600",
					"MST": "-0700",
					"PST": "-0800",
					"AKST": "-0900",
					"MIT": "-0930",
					"HST": "-1000",
					"SST": "-1100",
					"BIT": "-1200"
				};
				return __(standard);
			},
			timeZones: function (data) {
				var zone;
				data.timezones = [];
				for (zone in data.abbreviatedTimeZoneStandard) {
					if (data.abbreviatedTimeZoneStandard.hasOwnProperty(zone)) {
						data.timezones.push({ name: zone, offset: data.abbreviatedTimeZoneStandard[zone]});
					}
				}
				for (zone in data.abbreviatedTimeZoneDST) {
					if (data.abbreviatedTimeZoneDST.hasOwnProperty(zone)) {
						data.timezones.push({ name: zone, offset: data.abbreviatedTimeZoneDST[zone], dst: true});
					}
				}
				return data.timezones;
			},
			days: function () {
				return __(["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]);
			},
			dayAbbr: function () {
				return __(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]);
			},
			dayShortNames: function () {
				return __(["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]);
			},
			dayFirstLetters: function () {
				return __(["S_Sun_Initial", "M_Mon_Initial", "T_Tues_Initial", "W_Wed_Initial", "T_Thu_Initial", "F_Fri_Initial", "S_Sat_Initial"]);
			},
			months: function () {
				return __(["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]);
			},
			monthAbbr: function () {
				return __(["Jan_Abbr", "Feb_Abbr", "Mar_Abbr", "Apr_Abbr", "May_Abbr", "Jun_Abbr", "Jul_Abbr", "Aug_Abbr", "Sep_Abbr", "Oct_Abbr", "Nov_Abbr", "Dec_Abbr"]);
			},
			formatPatterns: function () {
				return getText.getFromObjectValues({
					shortDate: "M/d/yyyy",
					longDate: "dddd, MMMM dd, yyyy",
					shortTime: "h:mm tt",
					longTime: "h:mm:ss tt",
					fullDateTime: "dddd, MMMM dd, yyyy h:mm:ss tt",
					sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
					universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
					rfc1123: "ddd, dd MMM yyyy HH:mm:ss",
					monthDay: "MMMM dd",
					yearMonth: "MMMM, yyyy"
				}, Date.i18n.currentLanguage());
			},
			regex: function () {
				return getText.getFromObjectValues({
					inTheMorning: "/( in the )(morn(ing)?)\\b/",
					thisMorning: "/(this )(morn(ing)?)\\b/",
					amThisMorning: "/(\b\\d(am)? )(this )(morn(ing)?)/",
					inTheEvening: "/( in the )(even(ing)?)\\b/",
					thisEvening: "/(this )(even(ing)?)\\b/",
					pmThisEvening: "/(\b\\d(pm)? )(this )(even(ing)?)/",
					jan: "/jan(uary)?/",
					feb: "/feb(ruary)?/",
					mar: "/mar(ch)?/",
					apr: "/apr(il)?/",
					may: "/may/",
					jun: "/jun(e)?/",
					jul: "/jul(y)?/",
					aug: "/aug(ust)?/",
					sep: "/sep(t(ember)?)?/",
					oct: "/oct(ober)?/",
					nov: "/nov(ember)?/",
					dec: "/dec(ember)?/",
					sun: "/^su(n(day)?)?/",
					mon: "/^mo(n(day)?)?/",
					tue: "/^tu(e(s(day)?)?)?/",
					wed: "/^we(d(nesday)?)?/",
					thu: "/^th(u(r(s(day)?)?)?)?/",
					fri: "/fr(i(day)?)?/",
					sat: "/^sa(t(urday)?)?/",
					future: "/^next/",
					past: "/^last|past|prev(ious)?/",
					add: "/^(\\+|aft(er)?|from|hence)/",
					subtract: "/^(\\-|bef(ore)?|ago)/",
					yesterday: "/^yes(terday)?/",
					today: "/^t(od(ay)?)?/",
					tomorrow: "/^tom(orrow)?/",
					now: "/^n(ow)?/",
					millisecond: "/^ms|milli(second)?s?/",
					second: "/^sec(ond)?s?/",
					minute: "/^mn|min(ute)?s?/",
					hour: "/^h(our)?s?/",
					week: "/^w(eek)?s?/",
					month: "/^m(onth)?s?/",
					day: "/^d(ay)?s?/",
					year: "/^y(ear)?s?/",
					shortMeridian: "/^(a|p)/",
					longMeridian: "/^(a\\.?m?\\.?|p\\.?m?\\.?)/",
					timezone: "/^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\\s*(\\+|\\-)\\s*\\d\\d\\d\\d?)|gmt|utc)/",
					ordinalSuffix: "/^\\s*(st|nd|rd|th)/",
					timeContext: "/^\\s*(\\:|a(?!u|p)|p)/"
				}, Date.i18n.currentLanguage());
			}
		};
	
		var CultureInfo = function () {
			var info = getText.getFromObjectValues({
				name: "name",
				englishName: "englishName",
				nativeName: "nativeName",
				amDesignator: "AM",
				pmDesignator: "PM",
				firstDayOfWeek: "firstDayOfWeek",
				twoDigitYearMax: "twoDigitYearMax",
				dateElementOrder: "mdy"
			}, Date.i18n.currentLanguage());
	
			var constructedInfo = buildInfo.buildFromMethodHash({
				dayNames: "days",
				abbreviatedDayNames: "dayAbbr",
				shortestDayNames: "dayShortNames",
				firstLetterDayNames: "dayFirstLetters",
				monthNames: "months",
				abbreviatedMonthNames: "monthAbbr",
				formatPatterns: "formatPatterns",
				regexPatterns: "regex",
				abbreviatedTimeZoneDST: "timeZoneDST",
				abbreviatedTimeZoneStandard: "timeZoneStandard"
			});
	
			shallowMerge(info, constructedInfo);
			buildInfo.timeZones(info);
			return info;
		};
	
		$D.i18n = {
			__: function (key, lang) {
				return __(key, lang);
			},
			currentLanguage: function () {
				return lang || "en-US";
			},
			setLanguage: function (code, force, cb) {
				var async = false;
				if (force || code === "en-US" || (!!Date.CultureStrings && !!Date.CultureStrings[code])) {
					lang = code;
					Date.CultureStrings = Date.CultureStrings || {};
					Date.CultureStrings.lang = code;
					Date.CultureInfo = new CultureInfo();
				} else {
					if (!(!!Date.CultureStrings && !!Date.CultureStrings[code])) {
						if (typeof exports !== "undefined" && this.exports !== exports) {
							// we're in a Node enviroment, load it using require
							try {
								require("../i18n/" + code + ".js");
								lang = code;
								Date.CultureStrings.lang = code;
								Date.CultureInfo = new CultureInfo();
							} catch (e) {
								// var str = "The language for '" + code + "' could not be loaded by Node. It likely does not exist.";
								throw new Error("The DateJS IETF language tag '" + code + "' could not be loaded by Node. It likely does not exist.");
							}
						} else if (Date.Config && Date.Config.i18n) {
							// we know the location of the files, so lets load them					
							async = true;
							loadI18nScript(code).done(function(){
								lang = code;
								Date.CultureStrings = Date.CultureStrings || {};
								Date.CultureStrings.lang = code;
								Date.CultureInfo = new CultureInfo();
								$D.Parsing.Normalizer.buildReplaceData(); // because this is async
								if ($D.Grammar) {
									$D.Grammar.buildGrammarFormats(); // so we can parse those strings...
								}
								if (cb) {
									setTimeout(cb,0);
								}
							});
						} else {
							Date.console.error("The DateJS IETF language tag '" + code + "' is not available and has not been loaded.");
							return false;
						}
					}
				}
				$D.Parsing.Normalizer.buildReplaceData(); // rebuild normalizer strings
				if ($D.Grammar) {
					$D.Grammar.buildGrammarFormats(); // so we can parse those strings...
				}
				if (!async && cb) {
					setTimeout(cb,0);
				}
			},
			getLoggedKeys: function () {
				return loggedKeys;
			},
			updateCultureInfo: function () {
				Date.CultureInfo = new CultureInfo();
			}
		};
		$D.i18n.updateCultureInfo(); // run automatically
	}());


/***/ }),
/* 426 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		var $D = Date,
			$P = $D.prototype,
			p = function (s, l) {
				if (!l) {
					l = 2;
				}
				return ("000" + s).slice(l * -1);
			};
		
		if (typeof window !== "undefined" && typeof window.console !== "undefined" && typeof window.console.log !== "undefined") {
			$D.console = console; // used only to raise non-critical errors if available
		} else {
			// set mock so we don't give errors.
			$D.console = {
				log: function(){},
				error: function(){}
			};
		}
		$D.Config = $D.Config || {};
	
		$D.initOverloads = function() {
			/** 
			 * Overload of Date.now. Allows an alternate call for Date.now where it returns the 
			 * current Date as an object rather than just milliseconds since the Unix Epoch.
			 *
			 * Also provides an implementation of now() for browsers (IE<9) that don't have it.
			 * 
			 * Backwards compatible so with work with either:
			 *  Date.now() [returns ms]
			 * or
			 *  Date.now(true) [returns Date]
			 */
			if (!$D.now) {
				$D._now = function now() {
					return new Date().getTime();
				};
			} else if (!$D._now) {
				$D._now = $D.now;
			}
	
			$D.now = function (returnObj) {
				if (returnObj) {
					return $D.present();
				} else {
					return $D._now();
				}
			};
	
			if ( !$P.toISOString ) {
				$P.toISOString = function() {
					return this.getUTCFullYear() +
					"-" + p(this.getUTCMonth() + 1) +
					"-" + p(this.getUTCDate()) +
					"T" + p(this.getUTCHours()) +
					":" + p(this.getUTCMinutes()) +
					":" + p(this.getUTCSeconds()) +
					"." + String( (this.getUTCMilliseconds()/1000).toFixed(3)).slice(2, 5) +
					"Z";
				};
			}
			
			// private
			if ( $P._toString === undefined ){
				$P._toString = $P.toString;
			}
	
		};
		$D.initOverloads();
	
	
		/** 
		 * Gets a date that is set to the current date. The time is set to the start of the day (00:00 or 12:00 AM).
		 * @return {Date}    The current date.
		 */
		$D.today = function () {
			return new Date().clearTime();
		};
	
		/** 
		 * Gets a date that is set to the current date and time (same as new Date, but chainable)
		 * @return {Date}    The current date.
		 */
		$D.present = function () {
			return new Date();
		};
	
		/**
		 * Compares the first date to the second date and returns an number indication of their relative values.  
		 * @param {Date}     First Date object to compare [Required].
		 * @param {Date}     Second Date object to compare to [Required].
		 * @return {Number}  -1 = date1 is lessthan date2. 0 = values are equal. 1 = date1 is greaterthan date2.
		 */
		$D.compare = function (date1, date2) {
			if (isNaN(date1) || isNaN(date2)) {
				throw new Error(date1 + " - " + date2);
			} else if (date1 instanceof Date && date2 instanceof Date) {
				return (date1 < date2) ? -1 : (date1 > date2) ? 1 : 0;
			} else {
				throw new TypeError(date1 + " - " + date2);
			}
		};
		
		/**
		 * Compares the first Date object to the second Date object and returns true if they are equal.  
		 * @param {Date}     First Date object to compare [Required]
		 * @param {Date}     Second Date object to compare to [Required]
		 * @return {Boolean} true if dates are equal. false if they are not equal.
		 */
		$D.equals = function (date1, date2) {
			return (date1.compareTo(date2) === 0);
		};
	
		/**
		 * Gets the language appropriate day name when given the day number(0-6)
		 * eg - 0 == Sunday
		 * @return {String}  The day name
		 */
		$D.getDayName = function (n) {
			return Date.CultureInfo.dayNames[n];
		};
	
		/**
		 * Gets the day number (0-6) if given a CultureInfo specific string which is a valid dayName, abbreviatedDayName or shortestDayName (two char).
		 * @param {String}   The name of the day (eg. "Monday, "Mon", "tuesday", "tue", "We", "we").
		 * @return {Number}  The day number
		 */
		$D.getDayNumberFromName = function (name) {
			var n = Date.CultureInfo.dayNames, m = Date.CultureInfo.abbreviatedDayNames, o = Date.CultureInfo.shortestDayNames, s = name.toLowerCase();
			for (var i = 0; i < n.length; i++) {
				if (n[i].toLowerCase() === s || m[i].toLowerCase() === s || o[i].toLowerCase() === s) {
					return i;
				}
			}
			return -1;
		};
		
		/**
		 * Gets the month number (0-11) if given a Culture Info specific string which is a valid monthName or abbreviatedMonthName.
		 * @param {String}   The name of the month (eg. "February, "Feb", "october", "oct").
		 * @return {Number}  The day number
		 */
		$D.getMonthNumberFromName = function (name) {
			var n = Date.CultureInfo.monthNames, m = Date.CultureInfo.abbreviatedMonthNames, s = name.toLowerCase();
			for (var i = 0; i < n.length; i++) {
				if (n[i].toLowerCase() === s || m[i].toLowerCase() === s) {
					return i;
				}
			}
			return -1;
		};
	
		/**
		 * Gets the language appropriate month name when given the month number(0-11)
		 * eg - 0 == January
		 * @return {String}  The month name
		 */
		$D.getMonthName = function (n) {
			return Date.CultureInfo.monthNames[n];
		};
	
		/**
		 * Determines if the current date instance is within a LeapYear.
		 * @param {Number}   The year.
		 * @return {Boolean} true if date is within a LeapYear, otherwise false.
		 */
		$D.isLeapYear = function (year) {
			return ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
		};
	
		/**
		 * Gets the number of days in the month, given a year and month value. Automatically corrects for LeapYear.
		 * @param {Number}   The year.
		 * @param {Number}   The month (0-11).
		 * @return {Number}  The number of days in the month.
		 */
		$D.getDaysInMonth = function (year, month) {
			if (!month && $D.validateMonth(year)) {
					month = year;
					year = Date.today().getFullYear();
			}
			return [31, ($D.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
		};
	
		$P.getDaysInMonth = function () {
			return $D.getDaysInMonth(this.getFullYear(), this.getMonth());
		};
	 
		$D.getTimezoneAbbreviation = function (offset, dst) {
			var p, n = (dst || false) ? Date.CultureInfo.abbreviatedTimeZoneDST : Date.CultureInfo.abbreviatedTimeZoneStandard;
			for (p in n) {
				if (n.hasOwnProperty(p)) {
					if (n[p] === offset) {
						return p;
					}
				}
			}
			return null;
		};
		
		$D.getTimezoneOffset = function (name, dst) {
			var i, a =[], z = Date.CultureInfo.timezones;
			if (!name) { name = (new Date()).getTimezone();}
			for (i = 0; i < z.length; i++) {
				if (z[i].name === name.toUpperCase()) {
					a.push(i);
				}
			}
			if (!z[a[0]]) {
				return null;
			}
			if (a.length === 1 || !dst) {
				return z[a[0]].offset;
			} else {
				for (i=0; i < a.length; i++) {
					if (z[a[i]].dst) {
						return z[a[i]].offset;
					}
				}
			}
		};
	
		$D.getQuarter = function (d) {
			d = d || new Date(); // If no date supplied, use today
			var q = [1,2,3,4];
			return q[Math.floor(d.getMonth() / 3)]; // ~~~ is a bitwise op. Faster than Math.floor
		};
	
		$D.getDaysLeftInQuarter = function (d) {
			d = d || new Date();
			var qEnd = new Date(d);
			qEnd.setMonth(qEnd.getMonth() + 3 - qEnd.getMonth() % 3, 0);
			return Math.floor((qEnd - d) / 8.64e7);
		};
	
		// private
		var validate = function (n, min, max, name) {
			name = name ? name : "Object";
			if (typeof n === "undefined") {
				return false;
			} else if (typeof n !== "number") {
				throw new TypeError(n + " is not a Number.");
			} else if (n < min || n > max) {
				// As failing validation is *not* an exceptional circumstance 
				// lets not throw a RangeError Exception here. 
				// It's semantically correct but it's not sensible.
				return false;
			}
			return true;
		};
	
		/**
		 * Validates the number is within an acceptable range for milliseconds [0-999].
		 * @param {Number}   The number to check if within range.
		 * @return {Boolean} true if within range, otherwise false.
		 */
		$D.validateMillisecond = function (value) {
			return validate(value, 0, 999, "millisecond");
		};
	
		/**
		 * Validates the number is within an acceptable range for seconds [0-59].
		 * @param {Number}   The number to check if within range.
		 * @return {Boolean} true if within range, otherwise false.
		 */
		$D.validateSecond = function (value) {
			return validate(value, 0, 59, "second");
		};
	
		/**
		 * Validates the number is within an acceptable range for minutes [0-59].
		 * @param {Number}   The number to check if within range.
		 * @return {Boolean} true if within range, otherwise false.
		 */
		$D.validateMinute = function (value) {
			return validate(value, 0, 59, "minute");
		};
	
		/**
		 * Validates the number is within an acceptable range for hours [0-23].
		 * @param {Number}   The number to check if within range.
		 * @return {Boolean} true if within range, otherwise false.
		 */
		$D.validateHour = function (value) {
			return validate(value, 0, 23, "hour");
		};
	
		/**
		 * Validates the number is within an acceptable range for the days in a month [0-MaxDaysInMonth].
		 * @param {Number}   The number to check if within range.
		 * @return {Boolean} true if within range, otherwise false.
		 */
		$D.validateDay = function (value, year, month) {
			if (year === undefined || year === null || month === undefined || month === null) { return false;}
			return validate(value, 1, $D.getDaysInMonth(year, month), "day");
		};
	
		/**
		 * Validates the number is within an acceptable range for months [0-11].
		 * @param {Number}   The number to check if within range.
		 * @return {Boolean} true if within range, otherwise false.
		 */
		$D.validateWeek = function (value) {
			return validate(value, 0, 53, "week");
		};
	
		/**
		 * Validates the number is within an acceptable range for months [0-11].
		 * @param {Number}   The number to check if within range.
		 * @return {Boolean} true if within range, otherwise false.
		 */
		$D.validateMonth = function (value) {
			return validate(value, 0, 11, "month");
		};
	
		/**
		 * Validates the number is within an acceptable range for years.
		 * @param {Number}   The number to check if within range.
		 * @return {Boolean} true if within range, otherwise false.
		 */
		$D.validateYear = function (value) {
			/**
			 * Per ECMAScript spec the range of times supported by Date objects is 
			 * exactly -100,000,000 days to +100,000,000 days measured relative to 
			 * midnight at the beginning of 01 January, 1970 UTC. 
			 * This gives a range of 8,640,000,000,000,000 milliseconds to either 
			 * side of 01 January, 1970 UTC.
			 *
			 * Earliest possible date: Tue, 20 Apr 271,822 B.C. 00:00:00 UTC
			 * Latest possible date: Sat, 13 Sep 275,760 00:00:00 UTC
			 */
			return validate(value, -271822, 275760, "year");
		};
		$D.validateTimezone = function(value) {
			var timezones = {"ACDT":1,"ACST":1,"ACT":1,"ADT":1,"AEDT":1,"AEST":1,"AFT":1,"AKDT":1,"AKST":1,"AMST":1,"AMT":1,"ART":1,"AST":1,"AWDT":1,"AWST":1,"AZOST":1,"AZT":1,"BDT":1,"BIOT":1,"BIT":1,"BOT":1,"BRT":1,"BST":1,"BTT":1,"CAT":1,"CCT":1,"CDT":1,"CEDT":1,"CEST":1,"CET":1,"CHADT":1,"CHAST":1,"CHOT":1,"ChST":1,"CHUT":1,"CIST":1,"CIT":1,"CKT":1,"CLST":1,"CLT":1,"COST":1,"COT":1,"CST":1,"CT":1,"CVT":1,"CWST":1,"CXT":1,"DAVT":1,"DDUT":1,"DFT":1,"EASST":1,"EAST":1,"EAT":1,"ECT":1,"EDT":1,"EEDT":1,"EEST":1,"EET":1,"EGST":1,"EGT":1,"EIT":1,"EST":1,"FET":1,"FJT":1,"FKST":1,"FKT":1,"FNT":1,"GALT":1,"GAMT":1,"GET":1,"GFT":1,"GILT":1,"GIT":1,"GMT":1,"GST":1,"GYT":1,"HADT":1,"HAEC":1,"HAST":1,"HKT":1,"HMT":1,"HOVT":1,"HST":1,"ICT":1,"IDT":1,"IOT":1,"IRDT":1,"IRKT":1,"IRST":1,"IST":1,"JST":1,"KGT":1,"KOST":1,"KRAT":1,"KST":1,"LHST":1,"LINT":1,"MAGT":1,"MART":1,"MAWT":1,"MDT":1,"MET":1,"MEST":1,"MHT":1,"MIST":1,"MIT":1,"MMT":1,"MSK":1,"MST":1,"MUT":1,"MVT":1,"MYT":1,"NCT":1,"NDT":1,"NFT":1,"NPT":1,"NST":1,"NT":1,"NUT":1,"NZDT":1,"NZST":1,"OMST":1,"ORAT":1,"PDT":1,"PET":1,"PETT":1,"PGT":1,"PHOT":1,"PHT":1,"PKT":1,"PMDT":1,"PMST":1,"PONT":1,"PST":1,"PYST":1,"PYT":1,"RET":1,"ROTT":1,"SAKT":1,"SAMT":1,"SAST":1,"SBT":1,"SCT":1,"SGT":1,"SLST":1,"SRT":1,"SST":1,"SYOT":1,"TAHT":1,"THA":1,"TFT":1,"TJT":1,"TKT":1,"TLT":1,"TMT":1,"TOT":1,"TVT":1,"UCT":1,"ULAT":1,"UTC":1,"UYST":1,"UYT":1,"UZT":1,"VET":1,"VLAT":1,"VOLT":1,"VOST":1,"VUT":1,"WAKT":1,"WAST":1,"WAT":1,"WEDT":1,"WEST":1,"WET":1,"WST":1,"YAKT":1,"YEKT":1,"Z":1};
			return (timezones[value] === 1);
		};
		$D.validateTimezoneOffset= function(value) {
			// timezones go from +14hrs to -12hrs, the +X hours are negative offsets.
			return (value > -841 && value < 721);
		};
	
	}());
	


/***/ }),
/* 427 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		var $D = Date,
			$P = $D.prototype,
			p = function (s, l) {
				if (!l) {
					l = 2;
				}
				return ("000" + s).slice(l * -1);
			};
	
		var validateConfigObject = function (obj) {
			var result = {}, self = this, prop, testFunc;
			testFunc = function (prop, func, value) {
				if (prop === "day") {
					var month = (obj.month !== undefined) ? obj.month : self.getMonth();
					var year = (obj.year !== undefined) ? obj.year : self.getFullYear();
					return $D[func](value, year, month);
				} else {
					return $D[func](value);
				}
			};
			for (prop in obj) {
				if (hasOwnProperty.call(obj, prop)) {
					var func = "validate" + prop.charAt(0).toUpperCase() + prop.slice(1);
	
					if ($D[func] && obj[prop] !== null && testFunc(prop, func, obj[prop])) {
						result[prop] = obj[prop];
					}
				}
			}
			return result;
		};
		/**
		 * Resets the time of this Date object to 12:00 AM (00:00), which is the start of the day.
		 * @param {Boolean}  .clone() this date instance before clearing Time
		 * @return {Date}    this
		 */
		$P.clearTime = function () {
			this.setHours(0);
			this.setMinutes(0);
			this.setSeconds(0);
			this.setMilliseconds(0);
			return this;
		};
	
		/**
		 * Resets the time of this Date object to the current time ('now').
		 * @return {Date}    this
		 */
		$P.setTimeToNow = function () {
			var n = new Date();
			this.setHours(n.getHours());
			this.setMinutes(n.getMinutes());
			this.setSeconds(n.getSeconds());
			this.setMilliseconds(n.getMilliseconds());
			return this;
		};
		/**
		 * Returns a new Date object that is an exact date and time copy of the original instance.
		 * @return {Date}    A new Date instance
		 */
		$P.clone = function () {
			return new Date(this.getTime());
		};
	
		/**
		 * Compares this instance to a Date object and returns an number indication of their relative values.  
		 * @param {Date}     Date object to compare [Required]
		 * @return {Number}  -1 = this is lessthan date. 0 = values are equal. 1 = this is greaterthan date.
		 */
		$P.compareTo = function (date) {
			return Date.compare(this, date);
		};
	
		/**
		 * Compares this instance to another Date object and returns true if they are equal.  
		 * @param {Date}     Date object to compare. If no date to compare, new Date() [now] is used.
		 * @return {Boolean} true if dates are equal. false if they are not equal.
		 */
		$P.equals = function (date) {
			return Date.equals(this, (date !== undefined ? date : new Date()));
		};
	
		/**
		 * Determines if this instance is between a range of two dates or equal to either the start or end dates.
		 * @param {Date}     Start of range [Required]
		 * @param {Date}     End of range [Required]
		 * @return {Boolean} true is this is between or equal to the start and end dates, else false
		 */
		$P.between = function (start, end) {
			return this.getTime() >= start.getTime() && this.getTime() <= end.getTime();
		};
	
		/**
		 * Determines if this date occurs after the date to compare to.
		 * @param {Date}     Date object to compare. If no date to compare, new Date() ("now") is used.
		 * @return {Boolean} true if this date instance is greater than the date to compare to (or "now"), otherwise false.
		 */
		$P.isAfter = function (date) {
			return this.compareTo(date || new Date()) === 1;
		};
	
		/**
		 * Determines if this date occurs before the date to compare to.
		 * @param {Date}     Date object to compare. If no date to compare, new Date() ("now") is used.
		 * @return {Boolean} true if this date instance is less than the date to compare to (or "now").
		 */
		$P.isBefore = function (date) {
			return (this.compareTo(date || new Date()) === -1);
		};
	
		/**
		 * Determines if the current Date instance occurs today.
		 * @return {Boolean} true if this date instance is 'today', otherwise false.
		 */
		
		/**
		 * Determines if the current Date instance occurs on the same Date as the supplied 'date'. 
		 * If no 'date' to compare to is provided, the current Date instance is compared to 'today'. 
		 * @param {date}     Date object to compare. If no date to compare, the current Date ("now") is used.
		 * @return {Boolean} true if this Date instance occurs on the same Day as the supplied 'date'.
		 */
		$P.isToday = $P.isSameDay = function (date) {
			return this.clone().clearTime().equals((date || new Date()).clone().clearTime());
		};
		
		/**
		 * Adds the specified number of milliseconds to this instance. 
		 * @param {Number}   The number of milliseconds to add. The number can be positive or negative [Required]
		 * @return {Date}    this
		 */
		$P.addMilliseconds = function (value) {
			if (!value) { return this; }
			this.setTime(this.getTime() + value * 1);
			return this;
		};
	
		/**
		 * Adds the specified number of seconds to this instance. 
		 * @param {Number}   The number of seconds to add. The number can be positive or negative [Required]
		 * @return {Date}    this
		 */
		$P.addSeconds = function (value) {
			if (!value) { return this; }
			return this.addMilliseconds(value * 1000);
		};
	
		/**
		 * Adds the specified number of seconds to this instance. 
		 * @param {Number}   The number of seconds to add. The number can be positive or negative [Required]
		 * @return {Date}    this
		 */
		$P.addMinutes = function (value) {
			if (!value) { return this; }
			return this.addMilliseconds(value * 60000); // 60*1000
		};
	
		/**
		 * Adds the specified number of hours to this instance. 
		 * @param {Number}   The number of hours to add. The number can be positive or negative [Required]
		 * @return {Date}    this
		 */
		$P.addHours = function (value) {
			if (!value) { return this; }
			return this.addMilliseconds(value * 3600000); // 60*60*1000
		};
	
		/**
		 * Adds the specified number of days to this instance. 
		 * @param {Number}   The number of days to add. The number can be positive or negative [Required]
		 * @return {Date}    this
		 */
		$P.addDays = function (value) {
			if (!value) { return this; }
			this.setDate(this.getDate() + value * 1);
			return this;
		};
	
		/**
		 * Adds the specified number of weekdays (ie - not sat or sun) to this instance. 
		 * @param {Number}   The number of days to add. The number can be positive or negative [Required]
		 * @return {Date}    this
		 */
		$P.addWeekdays = function (value) {
			if (!value) { return this; }
			var day = this.getDay();
			var weeks = (Math.ceil(Math.abs(value)/7));
			if (day === 0 || day === 6) {
				if (value > 0) {
					this.next().monday();
					this.addDays(-1);
					day = this.getDay();
				}
			}
	
			if (value < 0) {
				while (value < 0) {
					this.addDays(-1);
					day = this.getDay();
					if (day !== 0 && day !== 6) {
						value++;
					}
				}
				return this;
			} else if (value > 5 || (6-day) <= value) {
				value = value + (weeks * 2);
			}
	
			return this.addDays(value);
		};
	
		/**
		 * Adds the specified number of weeks to this instance. 
		 * @param {Number}   The number of weeks to add. The number can be positive or negative [Required]
		 * @return {Date}    this
		 */
		$P.addWeeks = function (value) {
			if (!value) { return this; }
			return this.addDays(value * 7);
		};
	
	
		/**
		 * Adds the specified number of months to this instance. 
		 * @param {Number}   The number of months to add. The number can be positive or negative [Required]
		 * @return {Date}    this
		 */
		$P.addMonths = function (value) {
			if (!value) { return this; }
			var n = this.getDate();
			this.setDate(1);
			this.setMonth(this.getMonth() + value * 1);
			this.setDate(Math.min(n, $D.getDaysInMonth(this.getFullYear(), this.getMonth())));
			return this;
		};
	
		$P.addQuarters = function (value) {
			if (!value) { return this; }
			// note this will take you to the same point in the quarter as you are now.
			// i.e. - if you are 15 days into the quarter you'll be 15 days into the resulting one.
			// bonus: this allows adding fractional quarters
			return this.addMonths(value * 3);
		};
	
		/**
		 * Adds the specified number of years to this instance. 
		 * @param {Number}   The number of years to add. The number can be positive or negative [Required]
		 * @return {Date}    this
		 */
		$P.addYears = function (value) {
			if (!value) { return this; }
			return this.addMonths(value * 12);
		};
	
		/**
		 * Adds (or subtracts) to the value of the years, months, weeks, days, hours, minutes, seconds, milliseconds of the date instance using given configuration object. Positive and Negative values allowed.
		 * Example
		<pre><code>
		Date.today().add( { days: 1, months: 1 } )
		 
		new Date().add( { years: -1 } )
		</code></pre> 
		 * @param {Object}   Configuration object containing attributes (months, days, etc.)
		 * @return {Date}    this
		 */
		$P.add = function (config) {
			if (typeof config === "number") {
				this._orient = config;
				return this;
			}
			
			var x = config;
	
			if (x.day) {
				// If we should be a different date than today (eg: for 'tomorrow -1d', etc).
				// Should only effect parsing, not direct usage (eg, Finish and FinishExact)
				if ((x.day - this.getDate()) !== 0) {
					this.setDate(x.day);
				}
			}
			if (x.milliseconds) {
				this.addMilliseconds(x.milliseconds);
			}
			if (x.seconds) {
				this.addSeconds(x.seconds);
			}
			if (x.minutes) {
				this.addMinutes(x.minutes);
			}
			if (x.hours) {
				this.addHours(x.hours);
			}
			if (x.weeks) {
				this.addWeeks(x.weeks);
			}
			if (x.months) {
				this.addMonths(x.months);
			}
			if (x.years) {
				this.addYears(x.years);
			}
			if (x.days) {
				this.addDays(x.days);
			}
			return this;
		};
		
		/**
		 * Get the week number. Week one (1) is the week which contains the first Thursday of the year. Monday is considered the first day of the week.
		 * The .getWeek() function does NOT convert the date to UTC. The local datetime is used. 
		 * Please use .getISOWeek() to get the week of the UTC converted date.
		 * @return {Number}  1 to 53
		 */
		$P.getWeek = function (utc) {
			// Create a copy of this date object  
			var self, target = new Date(this.valueOf());
			if (utc) {
				target.addMinutes(target.getTimezoneOffset());
				self = target.clone();
			} else {
				self = this;
			}
			// ISO week date weeks start on monday  
			// so correct the day number  
			var dayNr = (self.getDay() + 6) % 7;
			// ISO 8601 states that week 1 is the week  
			// with the first thursday of that year.  
			// Set the target date to the thursday in the target week  
			target.setDate(target.getDate() - dayNr + 3);
			// Store the millisecond value of the target date  
			var firstThursday = target.valueOf();
			// Set the target to the first thursday of the year  
			// First set the target to january first  
			target.setMonth(0, 1);
			// Not a thursday? Correct the date to the next thursday  
			if (target.getDay() !== 4) {
				target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
			}
			// The weeknumber is the number of weeks between the   
			// first thursday of the year and the thursday in the target week  
			return 1 + Math.ceil((firstThursday - target) / 604800000); // 604800000 = 7 * 24 * 3600 * 1000  
		};
		
		/**
		 * Get the ISO 8601 week number. Week one ("01") is the week which contains the first Thursday of the year. Monday is considered the first day of the week.
		 * The .getISOWeek() function does convert the date to it's UTC value. Please use .getWeek() to get the week of the local date.
		 * @return {String}  "01" to "53"
		 */
		$P.getISOWeek = function () {
			return p(this.getWeek(true));
		};
	
		/**
		 * Moves the date to Monday of the week set. Week one (1) is the week which contains the first Thursday of the year.
		 * @param {Number}   A Number (1 to 53) that represents the week of the year.
		 * @return {Date}    this
		 */
		$P.setWeek = function (n) {
			if ((n - this.getWeek()) === 0) {
				if (this.getDay() !== 1) {
					return this.moveToDayOfWeek(1, (this.getDay() > 1 ? -1 : 1));
				} else {
					return this;
				}
			} else {
				return this.moveToDayOfWeek(1, (this.getDay() > 1 ? -1 : 1)).addWeeks(n - this.getWeek());
			}
		};
	
		$P.setQuarter = function (qtr) {
			var month = Math.abs(((qtr-1) * 3) + 1);
			return this.setMonth(month, 1);
		};
	
		$P.getQuarter = function () {
			return Date.getQuarter(this);
		};
	
		$P.getDaysLeftInQuarter = function () {
			return Date.getDaysLeftInQuarter(this);
		};
	
		/**
		 * Moves the date to the next n'th occurrence of the dayOfWeek starting from the beginning of the month. The number (-1) is a magic number and will return the last occurrence of the dayOfWeek in the month.
		 * @param {Number}   The dayOfWeek to move to
		 * @param {Number}   The n'th occurrence to move to. Use (-1) to return the last occurrence in the month
		 * @return {Date}    this
		 */
		$P.moveToNthOccurrence = function (dayOfWeek, occurrence) {
			if (dayOfWeek === "Weekday") {
				if (occurrence > 0) {
					this.moveToFirstDayOfMonth();
					if (this.is().weekday()) {
						occurrence -= 1;
					}
				} else if (occurrence < 0) {
					this.moveToLastDayOfMonth();
					if (this.is().weekday()) {
						occurrence += 1;
					}
				} else {
					return this;
				}
				return this.addWeekdays(occurrence);
			}
			var shift = 0;
			if (occurrence > 0) {
				shift = occurrence - 1;
			}
			else if (occurrence === -1) {
				this.moveToLastDayOfMonth();
				if (this.getDay() !== dayOfWeek) {
					this.moveToDayOfWeek(dayOfWeek, -1);
				}
				return this;
			}
			return this.moveToFirstDayOfMonth().addDays(-1).moveToDayOfWeek(dayOfWeek, +1).addWeeks(shift);
		};
	
	
		var moveToN = function (getFunc, addFunc, nVal) {
			return function (value, orient) {
				var diff = (value - this[getFunc]() + nVal * (orient || +1)) % nVal;
				return this[addFunc]((diff === 0) ? diff += nVal * (orient || +1) : diff);
			};
		};
		/**
		 * Move to the next or last dayOfWeek based on the orient value.
		 * @param {Number}   The dayOfWeek to move to
		 * @param {Number}   Forward (+1) or Back (-1). Defaults to +1. [Optional]
		 * @return {Date}    this
		 */
		$P.moveToDayOfWeek = moveToN("getDay", "addDays", 7);
		/**
		 * Move to the next or last month based on the orient value.
		 * @param {Number}   The month to move to. 0 = January, 11 = December
		 * @param {Number}   Forward (+1) or Back (-1). Defaults to +1. [Optional]
		 * @return {Date}    this
		 */
		$P.moveToMonth = moveToN("getMonth", "addMonths", 12);
		/**
		 * Get the Ordinate of the current day ("th", "st", "rd").
		 * @return {String} 
		 */
		$P.getOrdinate = function () {
			var num = this.getDate();
			return ord(num);
		};
		/**
		 * Get the Ordinal day (numeric day number) of the year, adjusted for leap year.
		 * @return {Number} 1 through 365 (366 in leap years)
		 */
		$P.getOrdinalNumber = function () {
			return Math.ceil((this.clone().clearTime() - new Date(this.getFullYear(), 0, 1)) / 86400000) + 1;
		};
	
		/**
		 * Get the time zone abbreviation of the current date.
		 * @return {String} The abbreviated time zone name (e.g. "EST")
		 */
		$P.getTimezone = function () {
			return $D.getTimezoneAbbreviation(this.getUTCOffset(), this.isDaylightSavingTime());
		};
	
		$P.setTimezoneOffset = function (offset) {
			var here = this.getTimezoneOffset(), there = Number(offset) * -6 / 10;
			return (there || there === 0) ? this.addMinutes(there - here) : this;
		};
	
		$P.setTimezone = function (offset) {
			return this.setTimezoneOffset($D.getTimezoneOffset(offset));
		};
	
		/**
		 * Indicates whether Daylight Saving Time is observed in the current time zone.
		 * @return {Boolean} true|false
		 */
		$P.hasDaylightSavingTime = function () {
			return (Date.today().set({month: 0, day: 1}).getTimezoneOffset() !== Date.today().set({month: 6, day: 1}).getTimezoneOffset());
		};
		
		/**
		 * Indicates whether this Date instance is within the Daylight Saving Time range for the current time zone.
		 * @return {Boolean} true|false
		 */
		$P.isDaylightSavingTime = function () {
			return Date.today().set({month: 0, day: 1}).getTimezoneOffset() !== this.getTimezoneOffset();
		};
	
		/**
		 * Get the offset from UTC of the current date.
		 * @return {String} The 4-character offset string prefixed with + or - (e.g. "-0500")
		 */
		$P.getUTCOffset = function (offset) {
			var n = (offset || this.getTimezoneOffset()) * -10 / 6, r;
			if (n < 0) {
				r = (n - 10000).toString();
				return r.charAt(0) + r.substr(2);
			} else {
				r = (n + 10000).toString();
				return "+" + r.substr(1);
			}
		};
	
		/**
		 * Returns the number of milliseconds between this date and date.
		 * @param {Date} Defaults to now
		 * @return {Number} The diff in milliseconds
		 */
		$P.getElapsed = function (date) {
			return (date || new Date()) - this;
		};
	
		/**
		 * Set the value of year, month, day, hour, minute, second, millisecond of date instance using given configuration object.
		 * Example
		<pre><code>
		Date.today().set( { day: 20, month: 1 } )
	
		new Date().set( { millisecond: 0 } )
		</code></pre>
		 * 
		 * @param {Object}   Configuration object containing attributes (month, day, etc.)
		 * @return {Date}    this
		 */
		$P.set = function (config) {
			config = validateConfigObject.call(this, config);
			var key;
			for (key in config) {
				if (hasOwnProperty.call(config, key)) {
					var name = key.charAt(0).toUpperCase() + key.slice(1);
					var addFunc, getFunc;
					if (key !== "week" && key !== "month" && key !== "timezone" && key !== "timezoneOffset") {
						name += "s";
					}
					addFunc = "add" + name;
					getFunc = "get" + name;
					if (key === "month") {
						addFunc = addFunc + "s";
					} else if (key === "year"){
						getFunc = "getFullYear";
					}
					if (key !== "day" && key !== "timezone" && key !== "timezoneOffset"  && key !== "week" &&  key !== "hour") {
							this[addFunc](config[key] - this[getFunc]());
					} else if ( key === "timezone"|| key === "timezoneOffset" || key === "week" || key === "hour") {
						this["set"+name](config[key]);
					}
				}
			}
			// day has to go last because you can't validate the day without first knowing the month
			if (config.day) {
				this.addDays(config.day - this.getDate());
			}
			
			return this;
		};
	
		/**
		 * Moves the date to the first day of the month.
		 * @return {Date}    this
		 */
		$P.moveToFirstDayOfMonth = function () {
			return this.set({ day: 1 });
		};
	
		/**
		 * Moves the date to the last day of the month.
		 * @return {Date}    this
		 */
		$P.moveToLastDayOfMonth = function () {
			return this.set({ day: $D.getDaysInMonth(this.getFullYear(), this.getMonth())});
		};
	
	
		/**
		 * Converts the value of the current Date object to its equivalent string representation.
		 * Format Specifiers
		 * CUSTOM DATE AND TIME FORMAT STRINGS
		 * Format  Description                                                                  Example
		 * ------  ---------------------------------------------------------------------------  -----------------------
		 * s      The seconds of the minute between 0-59.                                      "0" to "59"
		 * ss     The seconds of the minute with leading zero if required.                     "00" to "59"
		 * 
		 * m      The minute of the hour between 0-59.                                         "0"  or "59"
		 * mm     The minute of the hour with leading zero if required.                        "00" or "59"
		 * 
		 * h      The hour of the day between 1-12.                                            "1"  to "12"
		 * hh     The hour of the day with leading zero if required.                           "01" to "12"
		 * 
		 * H      The hour of the day between 0-23.                                            "0"  to "23"
		 * HH     The hour of the day with leading zero if required.                           "00" to "23"
		 * 
		 * d      The day of the month between 1 and 31.                                       "1"  to "31"
		 * dd     The day of the month with leading zero if required.                          "01" to "31"
		 * ddd    Abbreviated day name. Date.CultureInfo.abbreviatedDayNames.                                "Mon" to "Sun" 
		 * dddd   The full day name. Date.CultureInfo.dayNames.                                              "Monday" to "Sunday"
		 * 
		 * M      The month of the year between 1-12.                                          "1" to "12"
		 * MM     The month of the year with leading zero if required.                         "01" to "12"
		 * MMM    Abbreviated month name. Date.CultureInfo.abbreviatedMonthNames.                            "Jan" to "Dec"
		 * MMMM   The full month name. Date.CultureInfo.monthNames.                                          "January" to "December"
		 *
		 * yy     The year as a two-digit number.                                              "99" or "08"
		 * yyyy   The full four digit year.                                                    "1999" or "2008"
		 * 
		 * t      Displays the first character of the A.M./P.M. designator.                    "A" or "P"
		 *		Date.CultureInfo.amDesignator or Date.CultureInfo.pmDesignator
		 * tt     Displays the A.M./P.M. designator.                                           "AM" or "PM"
		 *		Date.CultureInfo.amDesignator or Date.CultureInfo.pmDesignator
		 * 
		 * S      The ordinal suffix ("st, "nd", "rd" or "th") of the current day.            "st, "nd", "rd" or "th"
		 *
		 * STANDARD DATE AND TIME FORMAT STRINGS
		 * Format  Description                                                                  Example
		 *------  ---------------------------------------------------------------------------  -----------------------
		 * d      The CultureInfo shortDate Format Pattern                                     "M/d/yyyy"
		 * D      The CultureInfo longDate Format Pattern                                      "dddd, MMMM dd, yyyy"
		 * F      The CultureInfo fullDateTime Format Pattern                                  "dddd, MMMM dd, yyyy h:mm:ss tt"
		 * m      The CultureInfo monthDay Format Pattern                                      "MMMM dd"
		 * r      The CultureInfo rfc1123 Format Pattern                                       "ddd, dd MMM yyyy HH:mm:ss GMT"
		 * s      The CultureInfo sortableDateTime Format Pattern                              "yyyy-MM-ddTHH:mm:ss"
		 * t      The CultureInfo shortTime Format Pattern                                     "h:mm tt"
		 * T      The CultureInfo longTime Format Pattern                                      "h:mm:ss tt"
		 * u      The CultureInfo universalSortableDateTime Format Pattern                     "yyyy-MM-dd HH:mm:ssZ"
		 * y      The CultureInfo yearMonth Format Pattern                                     "MMMM, yyyy"
		 *
		 * @param {String}   A format string consisting of one or more format spcifiers [Optional].
		 * @return {String}  A string representation of the current Date object.
		 */
		
		var ord = function (n) {
			switch (n * 1) {
			case 1:
			case 21:
			case 31:
				return "st";
			case 2:
			case 22:
				return "nd";
			case 3:
			case 23:
				return "rd";
			default:
				return "th";
			}
		};
		var parseStandardFormats = function (format) {
			var y, c = Date.CultureInfo.formatPatterns;
			switch (format) {
				case "d":
					return this.toString(c.shortDate);
				case "D":
					return this.toString(c.longDate);
				case "F":
					return this.toString(c.fullDateTime);
				case "m":
					return this.toString(c.monthDay);
				case "r":
				case "R":
					y = this.clone().addMinutes(this.getTimezoneOffset());
					return y.toString(c.rfc1123) + " GMT";
				case "s":
					return this.toString(c.sortableDateTime);
				case "t":
					return this.toString(c.shortTime);
				case "T":
					return this.toString(c.longTime);
				case "u":
					y = this.clone().addMinutes(this.getTimezoneOffset());
					return y.toString(c.universalSortableDateTime);
				case "y":
					return this.toString(c.yearMonth);
				default:
					return false;
			}
		};
		var parseFormatStringsClosure = function (context) {
			return function (m) {
				if (m.charAt(0) === "\\") {
					return m.replace("\\", "");
				}
				switch (m) {
					case "hh":
						return p(context.getHours() < 13 ? (context.getHours() === 0 ? 12 : context.getHours()) : (context.getHours() - 12));
					case "h":
						return context.getHours() < 13 ? (context.getHours() === 0 ? 12 : context.getHours()) : (context.getHours() - 12);
					case "HH":
						return p(context.getHours());
					case "H":
						return context.getHours();
					case "mm":
						return p(context.getMinutes());
					case "m":
						return context.getMinutes();
					case "ss":
						return p(context.getSeconds());
					case "s":
						return context.getSeconds();
					case "yyyy":
						return p(context.getFullYear(), 4);
					case "yy":
						return p(context.getFullYear());
					case "y":
						return context.getFullYear();
					case "E":
					case "dddd":
						return Date.CultureInfo.dayNames[context.getDay()];
					case "ddd":
						return Date.CultureInfo.abbreviatedDayNames[context.getDay()];
					case "dd":
						return p(context.getDate());
					case "d":
						return context.getDate();
					case "MMMM":
						return Date.CultureInfo.monthNames[context.getMonth()];
					case "MMM":
						return Date.CultureInfo.abbreviatedMonthNames[context.getMonth()];
					case "MM":
						return p((context.getMonth() + 1));
					case "M":
						return context.getMonth() + 1;
					case "t":
						return context.getHours() < 12 ? Date.CultureInfo.amDesignator.substring(0, 1) : Date.CultureInfo.pmDesignator.substring(0, 1);
					case "tt":
						return context.getHours() < 12 ? Date.CultureInfo.amDesignator : Date.CultureInfo.pmDesignator;
					case "S":
						return ord(context.getDate());
					case "W":
						return context.getWeek();
					case "WW":
						return context.getISOWeek();
					case "Q":
						return "Q" + context.getQuarter();
					case "q":
						return String(context.getQuarter());
					case "z":
						return context.getTimezone();
					case "Z":
					case "X":
						return Date.getTimezoneOffset(context.getTimezone());
					case "ZZ": // Timezone offset in seconds
						return context.getTimezoneOffset() * -60;
					case "u":
						return context.getDay();
					case "L":
						return ($D.isLeapYear(context.getFullYear())) ? 1 : 0;
					case "B":
						// Swatch Internet Time (.beats)
						return "@"+((context.getUTCSeconds() + (context.getUTCMinutes()*60) + ((context.getUTCHours()+1)*3600))/86.4);
					default:
						return m;
				}
			};
		};
		$P.toString = function (format, ignoreStandards) {
			
			// Standard Date and Time Format Strings. Formats pulled from CultureInfo file and
			// may vary by culture. 
			if (!ignoreStandards && format && format.length === 1) {
				output = parseStandardFormats.call(this, format);
				if (output) {
					return output;
				}
			}
			var parseFormatStrings = parseFormatStringsClosure(this);
			return format ? format.replace(/((\\)?(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|S|q|Q|WW?W?W?)(?![^\[]*\]))/g, parseFormatStrings).replace(/\[|\]/g, "") : this._toString();
		};
	
	}());


/***/ }),
/* 428 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*************************************************************
	 * SugarPak - Domain Specific Language -  Syntactical Sugar  *
	 *************************************************************/
	 
	(function () {
		var $D = Date, $P = $D.prototype, $N = Number.prototype;
	
		// private
		$P._orient = +1;
	
		// private
		$P._nth = null;
	
		// private
		$P._is = false;
	
		// private
		$P._same = false;
		
		// private
		$P._isSecond = false;
	
		// private
		$N._dateElement = "days";
	
		/** 
		 * Moves the date to the next instance of a date as specified by the subsequent date element function (eg. .day(), .month()), month name function (eg. .january(), .jan()) or day name function (eg. .friday(), fri()).
		 * Example
		<pre><code>
		Date.today().next().friday();
		Date.today().next().fri();
		Date.today().next().march();
		Date.today().next().mar();
		Date.today().next().week();
		</code></pre>
		 * 
		 * @return {Date}    date
		 */
		$P.next = function () {
			this._move = true;
			this._orient = +1;
			return this;
		};
	
		/** 
		 * Creates a new Date (Date.today()) and moves the date to the next instance of the date as specified by the subsequent date element function (eg. .day(), .month()), month name function (eg. .january(), .jan()) or day name function (eg. .friday(), fri()).
		 * Example
		<pre><code>
		Date.next().friday();
		Date.next().fri();
		Date.next().march();
		Date.next().mar();
		Date.next().week();
		</code></pre>
		 * 
		 * @return {Date}    date
		 */
		$D.next = function () {
			return $D.today().next();
		};
	
		/** 
		 * Moves the date to the previous instance of a date as specified by the subsequent date element function (eg. .day(), .month()), month name function (eg. .january(), .jan()) or day name function (eg. .friday(), fri()).
		 * Example
		<pre><code>
		Date.today().last().friday();
		Date.today().last().fri();
		Date.today().last().march();
		Date.today().last().mar();
		Date.today().last().week();
		</code></pre>
		 *  
		 * @return {Date}    date
		 */
		$P.last = $P.prev = $P.previous = function () {
			this._move = true;
			this._orient = -1;
			return this;
		};
	
		/** 
		 * Creates a new Date (Date.today()) and moves the date to the previous instance of the date as specified by the subsequent date element function (eg. .day(), .month()), month name function (eg. .january(), .jan()) or day name function (eg. .friday(), fri()).
		 * Example
		<pre><code>
		Date.last().friday();
		Date.last().fri();
		Date.previous().march();
		Date.prev().mar();
		Date.last().week();
		</code></pre>
		 *  
		 * @return {Date}    date
		 */
		$D.last = $D.prev = $D.previous = function () {
			return $D.today().last();
		};
	
		/** 
		 * Performs a equality check when followed by either a month name, day name or .weekday() function.
		 * Example
		<pre><code>
		Date.today().is().friday(); // true|false
		Date.today().is().fri();
		Date.today().is().march();
		Date.today().is().mar();
		</code></pre>
		 *  
		 * @return {Boolean}    true|false
		 */
		$P.is = function () {
			this._is = true;
			return this;
		};
	
		/** 
		 * Determines if two date objects occur on/in exactly the same instance of the subsequent date part function.
		 * The function .same() must be followed by a date part function (example: .day(), .month(), .year(), etc).
		 *
		 * An optional Date can be passed in the date part function. If now date is passed as a parameter, 'Now' is used. 
		 *
		 * The following example demonstrates how to determine if two dates fall on the exact same day.
		 *
		 * Example
		<pre><code>
		var d1 = Date.today(); // today at 00:00
		var d2 = new Date();   // exactly now.
	
		// Do they occur on the same day?
		d1.same().day(d2); // true
		
		// Do they occur on the same hour?
		d1.same().hour(d2); // false, unless d2 hour is '00' (midnight).
		
		// What if it's the same day, but one year apart?
		var nextYear = Date.today().add(1).year();
	
		d1.same().day(nextYear); // false, because the dates must occur on the exact same day. 
		</code></pre>
		 *
		 * Scenario: Determine if a given date occurs during some week period 2 months from now. 
		 *
		 * Example
		<pre><code>
		var future = Date.today().add(2).months();
		return someDate.same().week(future); // true|false;
		</code></pre>
		 *  
		 * @return {Boolean}    true|false
		 */
		$P.same = function () {
			this._same = true;
			this._isSecond = false;
			return this;
		};
	
		/** 
		 * Determines if the current date/time occurs during Today. Must be preceded by the .is() function.
		 * Example
		<pre><code>
		someDate.is().today();    // true|false
		new Date().is().today();  // true
		Date.today().is().today();// true
		Date.today().add(-1).day().is().today(); // false
		</code></pre>
		 *  
		 * @return {Boolean}    true|false
		 */
		$P.today = function () {
			return this.same().day();
		};
	
		/** 
		 * Determines if the current date is a weekday. This function must be preceded by the .is() function.
		 * Example
		<pre><code>
		Date.today().is().weekday(); // true|false
		</code></pre>
		 *  
		 * @return {Boolean}    true|false
		 */
		$P.weekday = function () {
			if (this._nth) {
				return df("Weekday").call(this);
			}
			if (this._move) {
				return this.addWeekdays(this._orient);
			}
			if (this._is) {
				this._is = false;
				return (!this.is().sat() && !this.is().sun());
			}
			return false;
		};
		/** 
		 * Determines if the current date is on the weekend. This function must be preceded by the .is() function.
		 * Example
		<pre><code>
		Date.today().is().weekend(); // true|false
		</code></pre>
		 *  
		 * @return {Boolean}    true|false
		 */
		$P.weekend = function () {
			if (this._is) {
				this._is = false;
				return (this.is().sat() || this.is().sun());
			}
			return false;
		};
	
		/** 
		 * Sets the Time of the current Date instance. A string "6:15 pm" or config object {hour:18, minute:15} are accepted.
		 * Example
		<pre><code>
		// Set time to 6:15pm with a String
		Date.today().at("6:15pm");
	
		// Set time to 6:15pm with a config object
		Date.today().at({hour:18, minute:15});
		</code></pre>
		 *  
		 * @return {Date}    date
		 */
		$P.at = function (time) {
			return (typeof time === "string") ? $D.parse(this.toString("d") + " " + time) : this.set(time);
		};
			
		/** 
		 * Creates a new Date() and adds this (Number) to the date based on the preceding date element function (eg. second|minute|hour|day|month|year).
		 * Example
		<pre><code>
		// Undeclared Numbers must be wrapped with parentheses. Requirment of JavaScript.
		(3).days().fromNow();
		(6).months().fromNow();
	
		// Declared Number variables do not require parentheses. 
		var n = 6;
		n.months().fromNow();
		</code></pre>
		 *  
		 * @return {Date}    A new Date instance
		 */
		$N.fromNow = $N.after = function (date) {
			var c = {};
			c[this._dateElement] = this;
			return ((!date) ? new Date() : date.clone()).add(c);
		};
	
		/** 
		 * Creates a new Date() and subtract this (Number) from the date based on the preceding date element function (eg. second|minute|hour|day|month|year).
		 * Example
		<pre><code>
		// Undeclared Numbers must be wrapped with parentheses. Requirment of JavaScript.
		(3).days().ago();
		(6).months().ago();
	
		// Declared Number variables do not require parentheses. 
		var n = 6;
		n.months().ago();
		</code></pre>
		 *  
		 * @return {Date}    A new Date instance
		 */
		$N.ago = $N.before = function (date) {
			var c = {},
			s = (this._dateElement[this._dateElement.length-1] !== "s") ? this._dateElement + "s" : this._dateElement;
			c[s] = this * -1;
			return ((!date) ? new Date() : date.clone()).add(c);
		};
	
		// Do NOT modify the following string tokens. These tokens are used to build dynamic functions.
		// All culture-specific strings can be found in the CultureInfo files.
		var dx = ("sunday monday tuesday wednesday thursday friday saturday").split(/\s/),
			mx = ("january february march april may june july august september october november december").split(/\s/),
			px = ("Millisecond Second Minute Hour Day Week Month Year Quarter Weekday").split(/\s/),
			pxf = ("Milliseconds Seconds Minutes Hours Date Week Month FullYear Quarter").split(/\s/),
			nth = ("final first second third fourth fifth").split(/\s/),
			de;
	
	   /** 
		 * Returns an object literal of all the date parts.
		 * Example
		<pre><code>
		var o = new Date().toObject();
		
		// { year: 2008, month: 4, week: 20, day: 13, hour: 18, minute: 9, second: 32, millisecond: 812 }
		
		// The object properties can be referenced directly from the object.
		
		alert(o.day);  // alerts "13"
		alert(o.year); // alerts "2008"
		</code></pre>
		 *  
		 * @return {Date}    An object literal representing the original date object.
		 */
		$P.toObject = function () {
			var o = {};
			for (var i = 0; i < px.length; i++) {
				if (this["get" + pxf[i]]) {
					o[px[i].toLowerCase()] = this["get" + pxf[i]]();
				}
			}
			return o;
		};
	   
	   /** 
		 * Returns a date created from an object literal. Ignores the .week property if set in the config. 
		 * Example
		<pre><code>
		var o = new Date().toObject();
		
		return Date.fromObject(o); // will return the same date. 
	
		var o2 = {month: 1, day: 20, hour: 18}; // birthday party!
		Date.fromObject(o2);
		</code></pre>
		 *  
		 * @return {Date}    An object literal representing the original date object.
		 */
		$D.fromObject = function(config) {
			config.week = null;
			return Date.today().set(config);
		};
			
		// Create day name functions and abbreviated day name functions (eg. monday(), friday(), fri()).
		
		var df = function (n) {
			return function () {
				if (this._is) {
					this._is = false;
					return this.getDay() === n;
				}
				if (this._move) { this._move = null; }
				if (this._nth !== null) {
					// If the .second() function was called earlier, remove the _orient 
					// from the date, and then continue.
					// This is required because 'second' can be used in two different context.
					// 
					// Example
					//
					//   Date.today().add(1).second();
					//   Date.march().second().monday();
					// 
					// Things get crazy with the following...
					//   Date.march().add(1).second().second().monday(); // but it works!!
					//  
					if (this._isSecond) {
						this.addSeconds(this._orient * -1);
					}
					// make sure we reset _isSecond
					this._isSecond = false;
	
					var ntemp = this._nth;
					this._nth = null;
					var temp = this.clone().moveToLastDayOfMonth();
					this.moveToNthOccurrence(n, ntemp);
					if (this > temp) {
						throw new RangeError($D.getDayName(n) + " does not occur " + ntemp + " times in the month of " + $D.getMonthName(temp.getMonth()) + " " + temp.getFullYear() + ".");
					}
					return this;
				}
				return this.moveToDayOfWeek(n, this._orient);
			};
		};
		
		var sdf = function (n) {
			return function () {
				var t = $D.today(), shift = n - t.getDay();
				if (n === 0 && Date.CultureInfo.firstDayOfWeek === 1 && t.getDay() !== 0) {
					shift = shift + 7;
				}
				return t.addDays(shift);
			};
		};
		
	
		
		// Create month name functions and abbreviated month name functions (eg. january(), march(), mar()).
		var month_instance_functions = function (n) {
			return function () {
				if (this._is) {
					this._is = false;
					return this.getMonth() === n;
				}
				return this.moveToMonth(n, this._orient);
			};
		};
		
		var month_static_functions = function (n) {
			return function () {
				return $D.today().set({ month: n, day: 1 });
			};
		};
		
		var processTerms = function (names, staticFunc, instanceFunc) {
			for (var i = 0; i < names.length; i++) {
				// Create constant static Name variables.
				$D[names[i].toUpperCase()] = $D[names[i].toUpperCase().substring(0, 3)] = i;
				// Create Name functions.
				$D[names[i]] = $D[names[i].substring(0, 3)] = staticFunc(i);
				// Create Name instance functions.
				$P[names[i]] = $P[names[i].substring(0, 3)] = instanceFunc(i);
			}
	
		};
	
		processTerms(dx, sdf, df);
		processTerms(mx, month_static_functions, month_instance_functions);
		
		// Create date element functions and plural date element functions used with Date (eg. day(), days(), months()).
		var ef = function (j) {
			return function () {
				// if the .second() function was called earlier, the _orient 
				// has alread been added. Just return this and reset _isSecond.
				if (this._isSecond) {
					this._isSecond = false;
					return this;
				}
	
				if (this._same) {
					this._same = this._is = false;
					var o1 = this.toObject(),
						o2 = (arguments[0] || new Date()).toObject(),
						v = "",
						k = j.toLowerCase();
	
					// the substr trick with -1 doesn't work in IE8 or less
					k = (k[k.length-1] === "s") ? k.substring(0,k.length-1) : k;
						
					for (var m = (px.length - 1); m > -1; m--) {
						v = px[m].toLowerCase();
						if (o1[v] !== o2[v]) {
							return false;
						}
						if (k === v) {
							break;
						}
					}
					return true;
				}
				
				if (j.substring(j.length - 1) !== "s") {
					j += "s";
				}
				if (this._move) { this._move = null; }
				return this["add" + j](this._orient);
			};
		};
		
		
		var nf = function (n) {
			return function () {
				this._dateElement = n;
				return this;
			};
		};
	   
		for (var k = 0; k < px.length; k++) {
			de = px[k].toLowerCase();
			if(de !== "weekday") {
				// Create date element functions and plural date element functions used with Date (eg. day(), days(), months()).
				$P[de] = $P[de + "s"] = ef(px[k]);
				
				// Create date element functions and plural date element functions used with Number (eg. day(), days(), months()).
				$N[de] = $N[de + "s"] = nf(de + "s");
			}
		}
		
		$P._ss = ef("Second");
		
		var nthfn = function (n) {
			return function (dayOfWeek) {
				if (this._same) {
					return this._ss(arguments[0]);
				}
				if (dayOfWeek || dayOfWeek === 0) {
					return this.moveToNthOccurrence(dayOfWeek, n);
				}
				this._nth = n;
	
				// if the operator is 'second' add the _orient, then deal with it later...
				if (n === 2 && (dayOfWeek === undefined || dayOfWeek === null)) {
					this._isSecond = true;
					return this.addSeconds(this._orient);
				}
				return this;
			};
		};
	
		for (var l = 0; l < nth.length; l++) {
			$P[nth[l]] = (l === 0) ? nthfn(-1) : nthfn(l);
		}
	}());
	


/***/ }),
/* 429 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		"use strict";
		Date.Parsing = {
			Exception: function (s) {
				this.message = "Parse error at '" + s.substring(0, 10) + " ...'";
			}
		};
		var $P = Date.Parsing;
		var dayOffsets = {
			standard: [0,31,59,90,120,151,181,212,243,273,304,334],
			leap: [0,31,60,91,121,152,182,213,244,274,305,335]
		};
	
		$P.isLeapYear = function(year) {
			return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
		};
	
		var utils = {
			multiReplace : function (str, hash ) {
				var key;
				for (key in hash) {
					if (Object.prototype.hasOwnProperty.call(hash, key)) {
						var regex;
						if (typeof hash[key] === "function") {
	
						} else {
							regex = (hash[key] instanceof RegExp) ? hash[key] : new RegExp(hash[key], "g");
						}
						str = str.replace(regex, key);
					}
				}
				return str;
			},
			getDayOfYearFromWeek : function (obj) {
				var d, jan4, offset;
				obj.weekDay = (!obj.weekDay && obj.weekDay !== 0) ? 1 : obj.weekDay;
				d = new Date(obj.year, 0, 4);
				jan4 = d.getDay() === 0 ? 7 : d.getDay(); // JS is 0 indexed on Sunday.
				offset = jan4+3;
				obj.dayOfYear = ((obj.week * 7) + (obj.weekDay === 0 ? 7 : obj.weekDay))-offset;
				return obj;
			},
			getDayOfYear : function (obj, dayOffset) {
				if (!obj.dayOfYear) {
					obj = utils.getDayOfYearFromWeek(obj);
				}
				for (var i=0;i <= dayOffset.length;i++) {
					if (obj.dayOfYear < dayOffset[i] || i === dayOffset.length) {
						obj.day = obj.day ? obj.day : (obj.dayOfYear - dayOffset[i-1]);
						break;
					} else {
						obj.month = i;
					}
				}
				return obj;
			},
			adjustForTimeZone : function (obj, date) {
				var offset;
				if (obj.zone.toUpperCase() === "Z" || (obj.zone_hours === 0 && obj.zone_minutes === 0)) {
					// it's UTC/GML so work out the current timeszone offset
					offset = -date.getTimezoneOffset();
				} else {
					offset = (obj.zone_hours*60) + (obj.zone_minutes || 0);
					if (obj.zone_sign === "+") {
						offset *= -1;
					}
					offset -= date.getTimezoneOffset();
				}
				date.setMinutes(date.getMinutes()+offset);
				return date;
			},
			setDefaults : function (obj) {
				obj.year = obj.year || Date.today().getFullYear();
				obj.hours = obj.hours || 0;
				obj.minutes = obj.minutes || 0;
				obj.seconds = obj.seconds || 0;
				obj.milliseconds = obj.milliseconds || 0;
				if (!(!obj.month && (obj.week || obj.dayOfYear))) {
					// if we have a month, or if we don't but don't have the day calculation data
					obj.month = obj.month || 0;
					obj.day = obj.day || 1;
				}
				return obj;
			},
			dataNum: function (data, mod, explict, postProcess) {
				var dataNum = data*1;
				if (mod) {
					if (postProcess) {
						return data ? mod(data)*1 : data;
					} else {
						return data ? mod(dataNum) : data;
					}
				} else if (!explict){
					return data ? dataNum : data;
				} else {
					return (data && typeof data !== "undefined") ? dataNum : data;
				}
			},
			timeDataProcess: function (obj) {
				var timeObj = {};
				for (var x in obj.data) {
					if (obj.data.hasOwnProperty(x)) {
						timeObj[x] = obj.ignore[x] ? obj.data[x] : utils.dataNum(obj.data[x], obj.mods[x], obj.explict[x], obj.postProcess[x]);
					}
				}
				if (obj.data.secmins) {
					obj.data.secmins = obj.data.secmins.replace(",", ".") * 60;
					if (!timeObj.minutes) {
						timeObj.minutes = obj.data.secmins;
					} else if (!timeObj.seconds) {
						timeObj.seconds = obj.data.secmins;
					}
					delete obj.secmins;
				}
				return timeObj;
			},
			buildTimeObjectFromData: function (data) {
				var time = utils.timeDataProcess({
					data: {
						year : data[1],
						month : data[5],
						day : data[7],
						week : data[8],
						dayOfYear : data[10],
						hours : data[15],
						zone_hours : data[23],
						zone_minutes : data[24],
						zone : data[21],
						zone_sign : data[22],
						weekDay : data[9],
						minutes: data[16],
						seconds: data[19],
						milliseconds: data[20],
						secmins: data[18]
					},
					mods: {
						month: function(data) {
							return data-1;
						},
						weekDay: function (data) {
							data = Math.abs(data);
							return (data === 7 ? 0 : data);
						},
						minutes: function (data) {
							return data.replace(":","");
						},
						seconds: function (data) {
							return Math.floor( (data.replace(":","").replace(",","."))*1 );
						},
						milliseconds: function (data) {
							return (data.replace(",",".")*1000);
						}
					},
					postProcess: {
						minutes: true,
						seconds: true,
						milliseconds: true
					},
					explict: {
						zone_hours: true,
						zone_minutes: true
					},
					ignore: {
						zone: true,
						zone_sign: true,
						secmins: true
					}
				});
				return time;
			},
			addToHash: function (hash, keys, data) {
				keys = keys;
				data = data;
				var len = keys.length;
				for (var i = 0; i < len; i++) {
				  hash[keys[i]] = data[i];
				}
				return hash;
			},
			combineRegex: function (r1, r2) {
				return new RegExp("(("+r1.source+")\\s("+r2.source+"))");
			},
			getDateNthString: function(add, last, inc){
				if (add) {
					return Date.today().addDays(inc).toString("d");
				} else if (last) {
					return Date.today().last()[inc]().toString("d");
				}
	
			},
			buildRegexData: function (array) {
				var arr = [];
				var len = array.length;
				for (var i=0; i < len; i++) {
					if (Object.prototype.toString.call(array[i]) === '[object Array]') { // oldIE compat version of Array.isArray
						arr.push(this.combineRegex(array[i][0], array[i][1]));
					} else {
						arr.push(array[i]);
					}
				}
				return arr;
			}
		};
	
		$P.processTimeObject = function (obj) {
			var date, dayOffset;
	
			utils.setDefaults(obj);
			dayOffset = ($P.isLeapYear(obj.year)) ? dayOffsets.leap : dayOffsets.standard;
	
			if (!obj.month && (obj.week || obj.dayOfYear)) {
				utils.getDayOfYear(obj, dayOffset);
			} else {
				obj.dayOfYear = dayOffset[obj.month] + obj.day;
			}
	
			date = new Date(obj.year, obj.month, obj.day, obj.hours, obj.minutes, obj.seconds, obj.milliseconds);
	
			if (obj.zone) {
				utils.adjustForTimeZone(obj, date); // adjust (and calculate) for timezone
			}
			return date;
		};
	
		$P.ISO = {
			regex : /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-4])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?\s?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/,
			parse : function (s) {
				var time, data = s.match(this.regex);
				if (!data || !data.length) {
					return null;
				}
	
				time = utils.buildTimeObjectFromData(data);
	
				if (!time.year || (!time.year && (!time.month && !time.day) && (!time.week && !time.dayOfYear)) ) {
					return null;
				}
				return $P.processTimeObject(time);
			}
		};
	
		$P.Numeric = {
			isNumeric: function (e){return!isNaN(parseFloat(e))&&isFinite(e);},
			regex: /\b([0-1]?[0-9])([0-3]?[0-9])([0-2]?[0-9]?[0-9][0-9])\b/i,
			parse: function (s) {
				var data, i,
					time = {},
					order = Date.CultureInfo.dateElementOrder.split("");
				if (!(this.isNumeric(s)) || // if it's non-numeric OR
					(s[0] === "+" && s[0] === "-")) {			// It's an arithmatic string (eg +/-1000)
					return null;
				}
				if (s.length < 5 && s.indexOf(".") < 0 && s.indexOf("/") < 0) { // assume it's just a year.
					time.year = s;
					return $P.processTimeObject(time);
				}
				data = s.match(this.regex);
				if (!data || !data.length) {
					return null;
				}
				for (i=0; i < order.length; i++) {
					switch(order[i]) {
						case "d":
							time.day = data[i+1];
							break;
						case "m":
							time.month = (data[i+1]-1);
							break;
						case "y":
							time.year = data[i+1];
							break;
					}
				}
				return $P.processTimeObject(time);
			}
		};
	
		$P.Normalizer = {
			regexData: function () {
				var $R = Date.CultureInfo.regexPatterns;
				return utils.buildRegexData([
					$R.tomorrow,
					$R.yesterday,
					[$R.past, $R.mon],
					[$R.past, $R.tue],
					[$R.past, $R.wed],
					[$R.past, $R.thu],
					[$R.past, $R.fri],
					[$R.past, $R.sat],
					[$R.past, $R.sun]
				]);
			},
			basicReplaceHash : function() {
				var $R = Date.CultureInfo.regexPatterns;
				return {
					"January": $R.jan.source,
					"February": $R.feb,
					"March": $R.mar,
					"April": $R.apr,
					"May": $R.may,
					"June": $R.jun,
					"July": $R.jul,
					"August": $R.aug,
					"September": $R.sep,
					"October": $R.oct,
					"November": $R.nov,
					"December": $R.dec,
					"": /\bat\b/gi,
					" ": /\s{2,}/,
					"am": $R.inTheMorning,
					"9am": $R.thisMorning,
					"pm": $R.inTheEvening,
					"7pm":$R.thisEvening
				};
			},
			keys : function(){
				return [
					utils.getDateNthString(true, false, 1),				// tomorrow
					utils.getDateNthString(true, false, -1),			// yesterday
					utils.getDateNthString(false, true, "monday"),		//last mon
					utils.getDateNthString(false, true, "tuesday"),		//last tues
					utils.getDateNthString(false, true, "wednesday"),	//last wed
					utils.getDateNthString(false, true, "thursday"),	//last thurs
					utils.getDateNthString(false, true, "friday"),		//last fri
					utils.getDateNthString(false, true, "saturday"),	//last sat
					utils.getDateNthString(false, true, "sunday")		//last sun
				];
			},
			buildRegexFunctions: function () {
				var $R = Date.CultureInfo.regexPatterns;
				var __ = Date.i18n.__;
				var tomorrowRE = new RegExp("(\\b\\d\\d?("+__("AM")+"|"+__("PM")+")? )("+$R.tomorrow.source.slice(1)+")", "i"); // adapted tomorrow regex for AM PM relative dates
				var todayRE = new RegExp($R.today.source + "(?!\\s*([+-]))\\b"); // today, but excludes the math operators (eg "today + 2h")
	
				this.replaceFuncs = [
					[todayRE, function (full) {
						return (full.length > 1) ? Date.today().toString("d") : full;
					}],
					[tomorrowRE,
					function(full, m1) {
						var t = Date.today().addDays(1).toString("d");
						return (t + " " + m1);
					}],
					[$R.amThisMorning, function(str, am){return am;}],
					[$R.pmThisEvening, function(str, pm){return pm;}]
				];
	
			},
			buildReplaceData: function () {
				this.buildRegexFunctions();
				this.replaceHash = utils.addToHash(this.basicReplaceHash(), this.keys(), this.regexData());
			},
			stringReplaceFuncs: function (s) {
				for (var i=0; i < this.replaceFuncs.length; i++) {
					s = s.replace(this.replaceFuncs[i][0], this.replaceFuncs[i][1]);
				}
				return s;
			},
			parse: function (s) {
				s = this.stringReplaceFuncs(s);
				s = utils.multiReplace(s, this.replaceHash);
	
				try {
					var n = s.split(/([\s\-\.\,\/\x27]+)/);
					if (n.length === 3 &&
						$P.Numeric.isNumeric(n[0]) &&
						$P.Numeric.isNumeric(n[2]) &&
						(n[2].length >= 4)) {
							// ok, so we're dealing with x/year. But that's not a full date.
							// This fixes wonky dateElementOrder parsing when set to dmy order.
							if (Date.CultureInfo.dateElementOrder[0] === "d") {
								s = "1/" + n[0] + "/" + n[2]; // set to 1st of month and normalize the seperator
							}
					}
				} catch (e) {}
	
				return s;
			}
		};
		$P.Normalizer.buildReplaceData();
	}());


/***/ }),
/* 430 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		var $P = Date.Parsing;
		var _ = $P.Operators = {
			//
			// Tokenizers
			//
			rtoken: function (r) { // regex token
				return function (s) {
					var mx = s.match(r);
					if (mx) {
						return ([ mx[0], s.substring(mx[0].length) ]);
					} else {
						throw new $P.Exception(s);
					}
				};
			},
			token: function () { // whitespace-eating token
				return function (s) {
					return _.rtoken(new RegExp("^\\s*" + s + "\\s*"))(s);
				};
			},
			stoken: function (s) { // string token
				return _.rtoken(new RegExp("^" + s));
			},
	
			// Atomic Operators
	
			until: function (p) {
				return function (s) {
					var qx = [], rx = null;
					while (s.length) {
						try {
							rx = p.call(this, s);
						} catch (e) {
							qx.push(rx[0]);
							s = rx[1];
							continue;
						}
						break;
					}
					return [ qx, s ];
				};
			},
			many: function (p) {
				return function (s) {
					var rx = [], r = null;
					while (s.length) {
						try {
							r = p.call(this, s);
						} catch (e) {
							return [ rx, s ];
						}
						rx.push(r[0]);
						s = r[1];
					}
					return [ rx, s ];
				};
			},
	
			// generator operators -- see below
			optional: function (p) {
				return function (s) {
					var r = null;
					try {
						r = p.call(this, s);
					} catch (e) {
						return [ null, s ];
					}
					return [ r[0], r[1] ];
				};
			},
			not: function (p) {
				return function (s) {
					try {
						p.call(this, s);
					} catch (e) {
						return [null, s];
					}
					throw new $P.Exception(s);
				};
			},
			ignore: function (p) {
				return p ?
				function (s) {
					var r = null;
					r = p.call(this, s);
					return [null, r[1]];
				} : null;
			},
			product: function () {
				var px = arguments[0],
				qx = Array.prototype.slice.call(arguments, 1), rx = [];
				for (var i = 0 ; i < px.length ; i++) {
					rx.push(_.each(px[i], qx));
				}
				return rx;
			},
			cache: function (rule) {
				var cache = {}, cache_length = 0, cache_keys = [], CACHE_MAX = Date.Config.CACHE_MAX || 100000, r = null;
				var cacheCheck = function () {
					if (cache_length === CACHE_MAX) {
						// kill several keys, don't want to have to do this all the time...
						for (var i=0; i < 10; i++) {
							var key = cache_keys.shift();
							if (key) {
								delete cache[key];
								cache_length--;
							}
						}
					}
				};
				return function (s) {
					cacheCheck();
					try {
						r = cache[s] = (cache[s] || rule.call(this, s));
					} catch (e) {
						r = cache[s] = e;
					}
					cache_length++;
					cache_keys.push(s);
					if (r instanceof $P.Exception) {
						throw r;
					} else {
						return r;
					}
				};
			},
	
			// vector operators -- see below
			any: function () {
				var px = arguments;
				return function (s) {
					var r = null;
					for (var i = 0; i < px.length; i++) {
						if (px[i] == null) {
							continue;
						}
						try {
							r = (px[i].call(this, s));
						} catch (e) {
							r = null;
						}
						if (r) {
							return r;
						}
					}
					throw new $P.Exception(s);
				};
			},
			each: function () {
				var px = arguments;
				return function (s) {
					var rx = [], r = null;
					for (var i = 0; i < px.length ; i++) {
						if (px[i] == null) {
							continue;
						}
						try {
							r = (px[i].call(this, s));
						} catch (e) {
							throw new $P.Exception(s);
						}
						rx.push(r[0]);
						s = r[1];
					}
					return [ rx, s];
				};
			},
			all: function () {
				var px = arguments, _ = _;
				return _.each(_.optional(px));
			},
	
			// delimited operators
			sequence: function (px, d, c) {
				d = d || _.rtoken(/^\s*/);
				c = c || null;
				
				if (px.length === 1) {
					return px[0];
				}
				return function (s) {
					var r = null, q = null;
					var rx = [];
					for (var i = 0; i < px.length ; i++) {
						try {
							r = px[i].call(this, s);
						} catch (e) {
							break;
						}
						rx.push(r[0]);
						try {
							q = d.call(this, r[1]);
						} catch (ex) {
							q = null;
							break;
						}
						s = q[1];
					}
					if (!r) {
						throw new $P.Exception(s);
					}
					if (q) {
						throw new $P.Exception(q[1]);
					}
					if (c) {
						try {
							r = c.call(this, r[1]);
						} catch (ey) {
							throw new $P.Exception(r[1]);
						}
					}
					return [ rx, (r?r[1]:s) ];
				};
			},
	
			//
			// Composite Operators
			//
	
			between: function (d1, p, d2) {
				d2 = d2 || d1;
				var _fn = _.each(_.ignore(d1), p, _.ignore(d2));
				return function (s) {
					var rx = _fn.call(this, s);
					return [[rx[0][0], r[0][2]], rx[1]];
				};
			},
			list: function (p, d, c) {
				d = d || _.rtoken(/^\s*/);
				c = c || null;
				return (p instanceof Array ?
					_.each(_.product(p.slice(0, -1), _.ignore(d)), p.slice(-1), _.ignore(c)) :
					_.each(_.many(_.each(p, _.ignore(d))), px, _.ignore(c)));
			},
			set: function (px, d, c) {
				d = d || _.rtoken(/^\s*/);
				c = c || null;
				return function (s) {
					// r is the current match, best the current 'best' match
					// which means it parsed the most amount of input
					var r = null, p = null, q = null, rx = null, best = [[], s], last = false;
					// go through the rules in the given set
					for (var i = 0; i < px.length ; i++) {
	
						// last is a flag indicating whether this must be the last element
						// if there is only 1 element, then it MUST be the last one
						q = null;
						p = null;
						r = null;
						last = (px.length === 1);
						// first, we try simply to match the current pattern
						// if not, try the next pattern
						try {
							r = px[i].call(this, s);
						} catch (e) {
							continue;
						}
						// since we are matching against a set of elements, the first
						// thing to do is to add r[0] to matched elements
						rx = [[r[0]], r[1]];
						// if we matched and there is still input to parse and 
						// we don't already know this is the last element,
						// we're going to next check for the delimiter ...
						// if there's none, or if there's no input left to parse
						// than this must be the last element after all ...
						if (r[1].length > 0 && ! last) {
							try {
								q = d.call(this, r[1]);
							} catch (ex) {
								last = true;
							}
						} else {
							last = true;
						}
	
						// if we parsed the delimiter and now there's no more input,
						// that means we shouldn't have parsed the delimiter at all
						// so don't update r and mark this as the last element ...
						if (!last && q[1].length === 0) {
							last = true;
						}
	
	
						// so, if this isn't the last element, we're going to see if
						// we can get any more matches from the remaining (unmatched)
						// elements ...
						if (!last) {
							// build a list of the remaining rules we can match against,
							// i.e., all but the one we just matched against
							var qx = [];
							for (var j = 0; j < px.length ; j++) {
								if (i !== j) {
									qx.push(px[j]);
								}
							}
	
							// now invoke recursively set with the remaining input
							// note that we don't include the closing delimiter ...
							// we'll check for that ourselves at the end
							p = _.set(qx, d).call(this, q[1]);
	
							// if we got a non-empty set as a result ...
							// (otw rx already contains everything we want to match)
							if (p[0].length > 0) {
								// update current result, which is stored in rx ...
								// basically, pick up the remaining text from p[1]
								// and concat the result from p[0] so that we don't
								// get endless nesting ...
								rx[0] = rx[0].concat(p[0]);
								rx[1] = p[1];
							}
						}
	
						// at this point, rx either contains the last matched element
						// or the entire matched set that starts with this element.
	
						// now we just check to see if this variation is better than
						// our best so far, in terms of how much of the input is parsed
						if (rx[1].length < best[1].length) {
							best = rx;
						}
	
						// if we've parsed all the input, then we're finished
						if (best[1].length === 0) {
							break;
						}
					}
	
					// so now we've either gone through all the patterns trying them
					// as the initial match; or we found one that parsed the entire
					// input string ...
	
					// if best has no matches, just return empty set ...
					if (best[0].length === 0) {
						return best;
					}
	
					// if a closing delimiter is provided, then we have to check it also
					if (c) {
						// we try this even if there is no remaining input because the pattern
						// may well be optional or match empty input ...
						try {
							q = c.call(this, best[1]);
						} catch (ey) {
							throw new $P.Exception(best[1]);
						}
	
						// it parsed ... be sure to update the best match remaining input
						best[1] = q[1];
					}
					// if we're here, either there was no closing delimiter or we parsed it
					// so now we have the best match; just return it!
					return best;
				};
			},
			forward: function (gr, fname) {
				return function (s) {
					return gr[fname].call(this, s);
				};
			},
	
			//
			// Translation Operators
			//
			replace: function (rule, repl) {
				return function (s) {
					var r = rule.call(this, s);
					return [repl, r[1]];
				};
			},
			process: function (rule, fn) {
				return function (s) {
					var r = rule.call(this, s);
					return [fn.call(this, r[0]), r[1]];
				};
			},
			min: function (min, rule) {
				return function (s) {
					var rx = rule.call(this, s);
					if (rx[0].length < min) {
						throw new $P.Exception(s);
					}
					return rx;
				};
			}
		};
		
	
		// Generator Operators And Vector Operators
	
		// Generators are operators that have a signature of F(R) => R,
		// taking a given rule and returning another rule, such as 
		// ignore, which parses a given rule and throws away the result.
	
		// Vector operators are those that have a signature of F(R1,R2,...) => R,
		// take a list of rules and returning a new rule, such as each.
	
		// Generator operators are converted (via the following _generator
		// function) into functions that can also take a list or array of rules
		// and return an array of new rules as though the function had been
		// called on each rule in turn (which is what actually happens).
	
		// This allows generators to be used with vector operators more easily.
		// Example:
		// each(ignore(foo, bar)) instead of each(ignore(foo), ignore(bar))
	
		// This also turns generators into vector operators, which allows
		// constructs like:
		// not(cache(foo, bar))
		
		var _generator = function (op) {
			function gen() {
				var args = null, rx = [], px, i;
				if (arguments.length > 1) {
					args = Array.prototype.slice.call(arguments);
				} else if (arguments[0] instanceof Array) {
					args = arguments[0];
				}
				if (args) {
					px = args.shift();
					if (px.length > 0) {
						args.unshift(px[i]);
						rx.push(op.apply(null, args));
						args.shift();
						return rx;
					}
				} else {
					return op.apply(null, arguments);
				}
			}
	
			return gen;
		};
		
		var gx = "optional not ignore cache".split(/\s/);
		
		for (var i = 0 ; i < gx.length ; i++) {
			_[gx[i]] = _generator(_[gx[i]]);
		}
	
		var _vector = function (op) {
			return function () {
				if (arguments[0] instanceof Array) {
					return op.apply(null, arguments[0]);
				} else {
					return op.apply(null, arguments);
				}
			};
		};
		
		var vx = "each any all".split(/\s/);
		
		for (var j = 0 ; j < vx.length ; j++) {
			_[vx[j]] = _vector(_[vx[j]]);
		}
		
	}());


/***/ }),
/* 431 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		var $D = Date;
	
		var flattenAndCompact = function (ax) {
			var rx = [];
			for (var i = 0; i < ax.length; i++) {
				if (ax[i] instanceof Array) {
					rx = rx.concat(flattenAndCompact(ax[i]));
				} else {
					if (ax[i]) {
						rx.push(ax[i]);
					}
				}
			}
			return rx;
		};
	
		var parseMeridian = function () {
			if (this.meridian && (this.hour || this.hour === 0)) {
				if (this.meridian === "a" && this.hour > 11 && Date.Config.strict24hr){
					throw "Invalid hour and meridian combination";
				} else if (this.meridian === "p" && this.hour < 12 && Date.Config.strict24hr){
					throw "Invalid hour and meridian combination";
				} else if (this.meridian === "p" && this.hour < 12) {
					this.hour = this.hour + 12;
				} else if (this.meridian === "a" && this.hour === 12) {
					this.hour = 0;
				}
			}
		};
	
		var setDefaults = function () {
			var now = new Date();
			if ((this.hour || this.minute) && (!this.month && !this.year && !this.day)) {
				this.day = now.getDate();
			}
	
			if (!this.year) {
				this.year = now.getFullYear();
			}
			
			if (!this.month && this.month !== 0) {
				this.month = now.getMonth();
			}
			
			if (!this.day) {
				this.day = 1;
			}
			
			if (!this.hour) {
				this.hour = 0;
			}
			
			if (!this.minute) {
				this.minute = 0;
			}
	
			if (!this.second) {
				this.second = 0;
			}
			if (!this.millisecond) {
				this.millisecond = 0;
			}
		};
	
		var finishUtils = {
			getToday: function () {
				 if (this.now || "hour minute second".indexOf(this.unit) !== -1) {
					return new Date();
				} else {
					return $D.today();
				}
			},
			setDaysFromWeekday: function (today, orient){
				var gap;
				orient = orient || 1;
				this.unit = "day";
				gap = ($D.getDayNumberFromName(this.weekday) - today.getDay());
				this.days = gap ? ((gap + (orient * 7)) % 7) : (orient * 7);
				return this;
			},
			setMonthsFromMonth: function (today, orient) {
				var gap;
				orient = orient || 1;
				this.unit = "month";
				gap = (this.month - today.getMonth());
				this.months = gap ? ((gap + (orient * 12)) % 12) : (orient * 12);
				this.month = null;
				return this;
			},
			setDMYFromWeekday: function () {
				var d = Date[this.weekday]();
				this.day = d.getDate();
				if (!this.month) {
					this.month = d.getMonth();
				}
				this.year = d.getFullYear();
				return this;
			},
			setUnitValue: function (orient) {
				if (!this.value && this.operator && this.operator !== null && this[this.unit + "s"] && this[this.unit + "s"] !== null) {
					this[this.unit + "s"] = this[this.unit + "s"] + ((this.operator === "add") ? 1 : -1) + (this.value||0) * orient;
				} else if (this[this.unit + "s"] == null || this.operator != null) {
					if (!this.value) {
						this.value = 1;
					}
					this[this.unit + "s"] = this.value * orient;
				}
			},
			generateDateFromWeeks: function () {
				var weekday = (this.weekday !== undefined) ? this.weekday : "today";
				var d = Date[weekday]().addWeeks(this.weeks);
				if (this.now) {
					d.setTimeToNow();
				}
				return d;
			}
		};
	
		$D.Translator = {
			hour: function (s) {
				return function () {
					this.hour = Number(s);
				};
			},
			minute: function (s) {
				return function () {
					this.minute = Number(s);
				};
			},
			second: function (s) {
				return function () {
					this.second = Number(s);
				};
			},
			/* for ss.s format */
			secondAndMillisecond: function (s) {
				return function () {
					var mx = s.match(/^([0-5][0-9])\.([0-9]{1,3})/);
					this.second = Number(mx[1]);
					this.millisecond = Number(mx[2]);
				};
			},
			meridian: function (s) {
				return function () {
					this.meridian = s.slice(0, 1).toLowerCase();
				};
			},
			timezone: function (s) {
				return function () {
					var n = s.replace(/[^\d\+\-]/g, "");
					if (n.length) {
						this.timezoneOffset = Number(n);
					} else {
						this.timezone = s.toLowerCase();
					}
				};
			},
			day: function (x) {
				var s = x[0];
				return function () {
					this.day = Number(s.match(/\d+/)[0]);
					if (this.day < 1) {
						throw "invalid day";
					}
				};
			},
			month: function (s) {
				return function () {
					this.month = (s.length === 3) ? "jan feb mar apr may jun jul aug sep oct nov dec".indexOf(s)/4 : Number(s) - 1;
					if (this.month < 0) {
						throw "invalid month";
					}
				};
			},
			year: function (s) {
				return function () {
					var n = Number(s);
					this.year = ((s.length > 2) ? n :
						(n + (((n + 2000) < Date.CultureInfo.twoDigitYearMax) ? 2000 : 1900)));
				};
			},
			rday: function (s) {
				return function () {
					switch (s) {
						case "yesterday":
							this.days = -1;
							break;
						case "tomorrow":
							this.days = 1;
							break;
						case "today":
							this.days = 0;
							break;
						case "now":
							this.days = 0;
							this.now = true;
							break;
					}
				};
			},
			finishExact: function (x) {
				var d;
				x = (x instanceof Array) ? x : [x];
	
				for (var i = 0 ; i < x.length ; i++) {
					if (x[i]) {
						x[i].call(this);
					}
				}
				
				setDefaults.call(this);
				parseMeridian.call(this);
	
				if (this.day > $D.getDaysInMonth(this.year, this.month)) {
					throw new RangeError(this.day + " is not a valid value for days.");
				}
	
				d = new Date(this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
				if (this.year < 100) {
					d.setFullYear(this.year); // means years less that 100 are process correctly. JS will parse it otherwise as 1900-1999.
				}
				if (this.timezone) {
					d.set({ timezone: this.timezone });
				} else if (this.timezoneOffset) {
					d.set({ timezoneOffset: this.timezoneOffset });
				}
				
				return d;
			},
			finish: function (x) {
				var today, expression, orient, temp;
	
				x = (x instanceof Array) ? flattenAndCompact(x) : [ x ];
	
				if (x.length === 0) {
					return null;
				}
	
				for (var i = 0 ; i < x.length ; i++) {
					if (typeof x[i] === "function") {
						x[i].call(this);
					}
				}
				if (this.now && !this.unit && !this.operator) {
					return new Date();
				} else {
					today = finishUtils.getToday.call(this);
				}
				
				expression = !!(this.days && this.days !== null || this.orient || this.operator);
				orient = ((this.orient === "past" || this.operator === "subtract") ? -1 : 1);
	
				if (this.month && this.unit === "week") {
					this.value = this.month + 1;
					delete this.month;
					delete this.day;
				}
	
				if ((this.month || this.month === 0) && "year day hour minute second".indexOf(this.unit) !== -1) {
					if (!this.value) {
						this.value = this.month + 1;
					}
					this.month = null;
					expression = true;
				}
	
				if (!expression && this.weekday && !this.day && !this.days) {
					finishUtils.setDMYFromWeekday.call(this);
				}
	
				if (expression && this.weekday && this.unit !== "month" && this.unit !== "week") {
					finishUtils.setDaysFromWeekday.call(this, today, orient);
				}
	
				if (this.weekday && this.unit !== "week" && !this.day && !this.days) {
					temp = Date[this.weekday]();
					this.day = temp.getDate();
					if (temp.getMonth() !== today.getMonth()) {
						this.month = temp.getMonth();
					}
				}
	
				if (this.month && this.unit === "day" && this.operator) {
					if (!this.value) {
						this.value = (this.month + 1);
					}
					this.month = null;
				}
	
				if (this.value != null && this.month != null && this.year != null) {
					this.day = this.value * 1;
				}
	
				if (this.month && !this.day && this.value) {
					today.set({ day: this.value * 1 });
					if (!expression) {
						this.day = this.value * 1;
					}
				}
	
				if (!this.month && this.value && this.unit === "month" && !this.now) {
					this.month = this.value;
					expression = true;
				}
	
				if (expression && (this.month || this.month === 0) && this.unit !== "year") {
					finishUtils.setMonthsFromMonth.call(this, today, orient);
				}
	
				if (!this.unit) {
					this.unit = "day";
				}
	
				finishUtils.setUnitValue.call(this, orient);
				parseMeridian.call(this);
				
				if ((this.month || this.month === 0) && !this.day) {
					this.day = 1;
				}
	
				if (!this.orient && !this.operator && this.unit === "week" && this.value && !this.day && !this.month) {
					return Date.today().setWeek(this.value);
				}
	
				if (this.unit === "week" && this.weeks && !this.day && !this.month) {
					return finishUtils.generateDateFromWeeks.call(this);
				}
	
				if (expression && this.timezone && this.day && this.days) {
					this.day = this.days;
				}
	
				if (expression){
					today.add(this);
				} else {
					today.set(this);
				}
				
				if (this.timezone) {
					this.timezone = this.timezone.toUpperCase();
					var offset = $D.getTimezoneOffset(this.timezone);
					var timezone;
					if (today.hasDaylightSavingTime()) {
						// lets check that we're being sane with timezone setting
						timezone = $D.getTimezoneAbbreviation(offset, today.isDaylightSavingTime());
						if (timezone !== this.timezone) {
							// bugger, we're in a place where things like EST vs EDT matters.
							if (today.isDaylightSavingTime()) {
								today.addHours(-1);
							} else {
								today.addHours(1);
							}
						}
					}
					today.setTimezoneOffset(offset);
				}
	
				return today;
			}
		};
	}());


/***/ }),
/* 432 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		var $D = Date;
		$D.Grammar = {};
		var _ = $D.Parsing.Operators, g = $D.Grammar, t = $D.Translator, _fn;
		// Allow rolling up into general purpose rules
		_fn = function () {
			return _.each(_.any.apply(null, arguments), _.not(g.ctoken2("timeContext")));
		};
		
		g.datePartDelimiter = _.rtoken(/^([\s\-\.\,\/\x27]+)/);
		g.timePartDelimiter = _.stoken(":");
		g.whiteSpace = _.rtoken(/^\s*/);
		g.generalDelimiter = _.rtoken(/^(([\s\,]|at|@|on)+)/);
	  
		var _C = {};
		g.ctoken = function (keys) {
			var fn = _C[keys];
			if (! fn) {
				var c = Date.CultureInfo.regexPatterns;
				var kx = keys.split(/\s+/), px = [];
				for (var i = 0; i < kx.length ; i++) {
					px.push(_.replace(_.rtoken(c[kx[i]]), kx[i]));
				}
				fn = _C[keys] = _.any.apply(null, px);
			}
			return fn;
		};
		g.ctoken2 = function (key) {
			return _.rtoken(Date.CultureInfo.regexPatterns[key]);
		};
		var cacheProcessRtoken = function (key, token, type, eachToken) {
			if (eachToken) {
				g[key] = _.cache(_.process(_.each(_.rtoken(token),_.optional(g.ctoken2(eachToken))), type));
			} else {
				g[key] = _.cache(_.process(_.rtoken(token), type));
			}
		};
		var cacheProcessCtoken = function (token, type) {
			return _.cache(_.process(g.ctoken2(token), type));
		};
		var _F = {}; //function cache
	
		var _get = function (f) {
			_F[f] = (_F[f] || g.format(f)[0]);
			return _F[f];
		};
	
		g.allformats = function (fx) {
			var rx = [];
			if (fx instanceof Array) {
				for (var i = 0; i < fx.length; i++) {
					rx.push(_get(fx[i]));
				}
			} else {
				rx.push(_get(fx));
			}
			return rx;
		};
	  
		g.formats = function (fx) {
			if (fx instanceof Array) {
				var rx = [];
				for (var i = 0 ; i < fx.length ; i++) {
					rx.push(_get(fx[i]));
				}
				return _.any.apply(null, rx);
			} else {
				return _get(fx);
			}
		};
	
		var grammarFormats = {
			 timeFormats: function(){
				var i,
				RTokenKeys = [
					"h",
					"hh",
					"H",
					"HH",
					"m",
					"mm",
					"s",
					"ss",
					"ss.s",
					"z",
					"zz"
				],
				RToken = [
					/^(0[0-9]|1[0-2]|[1-9])/,
					/^(0[0-9]|1[0-2])/,
					/^([0-1][0-9]|2[0-3]|[0-9])/,
					/^([0-1][0-9]|2[0-3])/,
					/^([0-5][0-9]|[0-9])/,
					/^[0-5][0-9]/,
					/^([0-5][0-9]|[0-9])/,
					/^[0-5][0-9]/,
					/^[0-5][0-9]\.[0-9]{1,3}/,
					/^((\+|\-)\s*\d\d\d\d)|((\+|\-)\d\d\:?\d\d)/,
					/^((\+|\-)\s*\d\d\d\d)|((\+|\-)\d\d\:?\d\d)/
				],
				tokens = [
					t.hour,
					t.hour,
					t.hour,
					t.minute,
					t.minute,
					t.second,
					t.second,
					t.secondAndMillisecond,
					t.timezone,
					t.timezone,
					t.timezone
				];
	
				for (i=0; i < RTokenKeys.length; i++) {
					cacheProcessRtoken(RTokenKeys[i], RToken[i], tokens[i]);
				}
	
				g.hms = _.cache(_.sequence([g.H, g.m, g.s], g.timePartDelimiter));
	
				g.t = cacheProcessCtoken("shortMeridian", t.meridian);
				g.tt = cacheProcessCtoken("longMeridian", t.meridian);
				g.zzz = cacheProcessCtoken("timezone", t.timezone);
	
				g.timeSuffix = _.each(_.ignore(g.whiteSpace), _.set([ g.tt, g.zzz ]));
				g.time = _.each(_.optional(_.ignore(_.stoken("T"))), g.hms, g.timeSuffix);
			 },
			 dateFormats: function () {
				// pre-loaded rules for different date part order preferences
				var _setfn = function () {
					return  _.set(arguments, g.datePartDelimiter);
				};
				var i,
				RTokenKeys = [
					"d",
					"dd",
					"M",
					"MM",
					"y",
					"yy",
					"yyy",
					"yyyy"
				],
				RToken = [
					/^([0-2]\d|3[0-1]|\d)/,
					/^([0-2]\d|3[0-1])/,
					/^(1[0-2]|0\d|\d)/,
					/^(1[0-2]|0\d)/,
					/^(\d+)/,
					/^(\d\d)/,
					/^(\d\d?\d?\d?)/,
					/^(\d\d\d\d)/
				],
				tokens = [
					t.day,
					t.day,
					t.month,
					t.month,
					t.year,
					t.year,
					t.year,
					t.year
				],
				eachToken = [
					"ordinalSuffix",
					"ordinalSuffix"
				];
				for (i=0; i < RTokenKeys.length; i++) {
					cacheProcessRtoken(RTokenKeys[i], RToken[i], tokens[i], eachToken[i]);
				}
	
				g.MMM = g.MMMM = _.cache(_.process(g.ctoken("jan feb mar apr may jun jul aug sep oct nov dec"), t.month));
				g.ddd = g.dddd = _.cache(_.process(g.ctoken("sun mon tue wed thu fri sat"),
					function (s) {
						return function () {
							this.weekday = s;
						};
					}
				));
	
				g.day = _fn(g.d, g.dd);
				g.month = _fn(g.M, g.MMM);
				g.year = _fn(g.yyyy, g.yy);
	
				g.mdy = _setfn(g.ddd, g.month, g.day, g.year);
				g.ymd = _setfn(g.ddd, g.year, g.month, g.day);
				g.dmy = _setfn(g.ddd, g.day, g.month, g.year);
							
				g.date = function (s) {
					return ((g[Date.CultureInfo.dateElementOrder] || g.mdy).call(this, s));
				};
			 },
			 relative: function () {
				// relative date / time expressions
				g.orientation = _.process(g.ctoken("past future"),
					function (s) {
						return function () {
							this.orient = s;
						};
					}
				);
	
				g.operator = _.process(g.ctoken("add subtract"),
					function (s) {
						return function () {
							this.operator = s;
						};
					}
				);
				g.rday = _.process(g.ctoken("yesterday tomorrow today now"), t.rday);
				g.unit = _.process(g.ctoken("second minute hour day week month year"),
					function (s) {
						return function () {
							this.unit = s;
						};
					}
				);
			 }
		};
	
		g.buildGrammarFormats = function () {
			// these need to be rebuilt every time the language changes.
			_C = {};
	
			grammarFormats.timeFormats();
			grammarFormats.dateFormats();
			grammarFormats.relative();
	
			
			g.value = _.process(_.rtoken(/^([-+]?\d+)?(st|nd|rd|th)?/),
				function (s) {
					return function () {
						this.value = s.replace(/\D/g, "");
					};
				}
			);
			g.expression = _.set([g.rday, g.operator, g.value, g.unit, g.orientation, g.ddd, g.MMM ]);
	
			g.format = _.process(_.many(
				_.any(
					// translate format specifiers into grammar rules
					_.process(
						_.rtoken(/^(dd?d?d?(?!e)|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|zz?z?)/),
							function (fmt) {
								if (g[fmt]) {
									return g[fmt];
								} else {
									throw $D.Parsing.Exception(fmt);
								}
							}
						),
						// translate separator tokens into token rules
						_.process(_.rtoken(/^[^dMyhHmstz]+/), // all legal separators 
							function (s) {
								return _.ignore(_.stoken(s));
							}
						)
					)
				),
				// construct the parser ...
				function (rules) {
					return _.process(_.each.apply(null, rules), t.finishExact);
				}
			);
	
			// starting rule for general purpose grammar
			g._start = _.process(_.set([ g.date, g.time, g.expression ],
			g.generalDelimiter, g.whiteSpace), t.finish);
		};
	
		g.buildGrammarFormats();
		// parsing date format specifiers - ex: "h:m:s tt" 
		// this little guy will generate a custom parser based
		// on the format string, ex: g.format("h:m:s tt")
		// check for these formats first
		g._formats = g.formats([
			"\"yyyy-MM-ddTHH:mm:ssZ\"",
			"yyyy-MM-ddTHH:mm:ss.sz",
			"yyyy-MM-ddTHH:mm:ssZ",
			"yyyy-MM-ddTHH:mm:ssz",
			"yyyy-MM-ddTHH:mm:ss",
			"yyyy-MM-ddTHH:mmZ",
			"yyyy-MM-ddTHH:mmz",
			"yyyy-MM-ddTHH:mm",
			"ddd, MMM dd, yyyy H:mm:ss tt",
			"ddd MMM d yyyy HH:mm:ss zzz",
			"MMddyyyy",
			"ddMMyyyy",
			"Mddyyyy",
			"ddMyyyy",
			"Mdyyyy",
			"dMyyyy",
			"yyyy",
			"Mdyy",
			"dMyy",
			"d"
		]);
		
		// real starting rule: tries selected formats first, 
		// then general purpose rule
		g.start = function (s) {
			try {
				var r = g._formats.call({}, s);
				if (r[1].length === 0) {
					return r;
				}
			} catch (e) {}
			return g._start.call({}, s);
		};
	}());


/***/ }),
/* 433 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		var $D = Date;
	
		/**
		 * @desc Converts the specified string value into its JavaScript Date equivalent using CultureInfo specific format information.
		 * 
		 * Example
		<pre><code>
		///////////
		// Dates //
		///////////
	
		// 15-Oct-2004
		var d1 = Date.parse("10/15/2004");
	
		// 15-Oct-2004
		var d1 = Date.parse("15-Oct-2004");
	
		// 15-Oct-2004
		var d1 = Date.parse("2004.10.15");
	
		//Fri Oct 15, 2004
		var d1 = Date.parse("Fri Oct 15, 2004");
	
		///////////
		// Times //
		///////////
	
		// Today at 10 PM.
		var d1 = Date.parse("10 PM");
	
		// Today at 10:30 PM.
		var d1 = Date.parse("10:30 P.M.");
	
		// Today at 6 AM.
		var d1 = Date.parse("06am");
	
		/////////////////////
		// Dates and Times //
		/////////////////////
	
		// 8-July-2004 @ 10:30 PM
		var d1 = Date.parse("July 8th, 2004, 10:30 PM");
	
		// 1-July-2004 @ 10:30 PM
		var d1 = Date.parse("2004-07-01T22:30:00");
	
		////////////////////
		// Relative Dates //
		////////////////////
	
		// Returns today's date. The string "today" is culture specific.
		var d1 = Date.parse("today");
	
		// Returns yesterday's date. The string "yesterday" is culture specific.
		var d1 = Date.parse("yesterday");
	
		// Returns the date of the next thursday.
		var d1 = Date.parse("Next thursday");
	
		// Returns the date of the most previous monday.
		var d1 = Date.parse("last monday");
	
		// Returns today's day + one year.
		var d1 = Date.parse("next year");
	
		///////////////
		// Date Math //
		///////////////
	
		// Today + 2 days
		var d1 = Date.parse("t+2");
	
		// Today + 2 days
		var d1 = Date.parse("today + 2 days");
	
		// Today + 3 months
		var d1 = Date.parse("t+3m");
	
		// Today - 1 year
		var d1 = Date.parse("today - 1 year");
	
		// Today - 1 year
		var d1 = Date.parse("t-1y"); 
	
	
		/////////////////////////////
		// Partial Dates and Times //
		/////////////////////////////
	
		// July 15th of this year.
		var d1 = Date.parse("July 15");
	
		// 15th day of current day and year.
		var d1 = Date.parse("15");
	
		// July 1st of current year at 10pm.
		var d1 = Date.parse("7/1 10pm");
		</code></pre>
		 *
		 * @param {String}   The string value to convert into a Date object [Required]
		 * @return {Date}    A Date object or null if the string cannot be converted into a Date.
		 */
		var parseUtils = {
			removeOrds: function (s) {
				ords = s.match(/\b(\d+)(?:st|nd|rd|th)\b/); // find ordinal matches
				s = ((ords && ords.length === 2) ? s.replace(ords[0], ords[1]) : s);
				return s;
			},
			grammarParser: function (s) {
				var r = null;
				try {
					r = $D.Grammar.start.call({}, s.replace(/^\s*(\S*(\s+\S+)*)\s*$/, "$1"));
				} catch (e) {
					return null;
				}
				
				return ((r[1].length === 0) ? r[0] : null);
			},
			nativeFallback: function(s) {
				var t;
				try {
					// ok we haven't parsed it, last ditch attempt with the built-in parser.
					t = Date._parse(s);
					return (t || t === 0) ? new Date(t) : null;
				} catch (e) {
					return null;
				}
			}
		};
		function parse (s) {
			var d;
			if (!s) {
				return null;
			}
			if (s instanceof Date) {
				return s.clone();
			}
			if (s.length >= 4 && s.charAt(0) !== "0" && s.charAt(0) !== "+"&& s.charAt(0) !== "-") { // ie: 2004 will pass, 0800 won't.
				//  Start with specific formats
				d = $D.Parsing.ISO.parse(s) || $D.Parsing.Numeric.parse(s);
			}
			if (d instanceof Date && !isNaN(d.getTime())) {
				return d;
			} else {
				// find ordinal dates (1st, 3rd, 8th, etc and remove them as they cause parsing issues)
				s = $D.Parsing.Normalizer.parse(parseUtils.removeOrds(s));
				d = parseUtils.grammarParser(s);
				if (d !== null) {
					return d;
				} else {
					return parseUtils.nativeFallback(s);
				}
			}
		}
	
		if (!$D._parse) {
			$D._parse = $D.parse;
		}
		$D.parse = parse;
	
		Date.getParseFunction = function (fx) {
			var fns = Date.Grammar.allformats(fx);
			return function (s) {
				var r = null;
				for (var i = 0; i < fns.length; i++) {
					try {
						r = fns[i].call({}, s);
					} catch (e) {
						continue;
					}
					if (r[1].length === 0) {
						return r[0];
					}
				}
				return null;
			};
		};
		
		/**
		 * Converts the specified string value into its JavaScript Date equivalent using the specified format {String} or formats {Array} and the CultureInfo specific format information.
		 * The format of the string value must match one of the supplied formats exactly.
		 * 
		 * Example
		<pre><code>
		// 15-Oct-2004
		var d1 = Date.parseExact("10/15/2004", "M/d/yyyy");
	
		// 15-Oct-2004
		var d1 = Date.parse("15-Oct-2004", "M-ddd-yyyy");
	
		// 15-Oct-2004
		var d1 = Date.parse("2004.10.15", "yyyy.MM.dd");
	
		// Multiple formats
		var d1 = Date.parseExact("10/15/2004", ["M/d/yyyy", "MMMM d, yyyy"]);
		</code></pre>
		 *
		 * @param {String}   The string value to convert into a Date object [Required].
		 * @param {Object}   The expected format {String} or an array of expected formats {Array} of the date string [Required].
		 * @return {Date}    A Date object or null if the string cannot be converted into a Date.
		 */
		$D.parseExact = function (s, fx) {
			return $D.getParseFunction(fx)(s);
		};
	}());
	


/***/ }),
/* 434 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		var $D = Date,
			$P = $D.prototype,
			// $C = $D.CultureInfo, // not used atm
			p = function (s, l) {
				if (!l) {
					l = 2;
				}
				return ("000" + s).slice(l * -1);
			};
		/**
		 * Converts a PHP format string to Java/.NET format string.
		 * A PHP format string can be used with ._format or .format.
		 * A Java/.NET format string can be used with .toString().
		 * The .parseExact function will only accept a Java/.NET format string
		 *
		 * Example
		 * var f1 = "%m/%d/%y"
		 * var f2 = Date.normalizeFormat(f1);	// "MM/dd/yy"
		 *
		 * new Date().format(f1);	// "04/13/08"
		 * new Date()._format(f1);	// "04/13/08"
		 * new Date().toString(f2);	// "04/13/08"
		 *
		 * var date = Date.parseExact("04/13/08", f2); // Sun Apr 13 2008
		 *
		 * @param {String}   A PHP format string consisting of one or more format spcifiers.
		 * @return {String}  The PHP format converted to a Java/.NET format string.
		 */
		 var normalizerSubstitutions = {
			"d" : "dd",
			"%d": "dd",
			"D" : "ddd",
			"%a": "ddd",
			"j" : "dddd",
			"l" : "dddd",
			"%A": "dddd",
			"S" : "S",
			"F" : "MMMM",
			"%B": "MMMM",
			"m" : "MM",
			"%m": "MM",
			"M" : "MMM",
			"%b": "MMM",
			"%h": "MMM",
			"n" : "M",
			"Y" : "yyyy",
			"%Y": "yyyy",
			"y" : "yy",
			"%y": "yy",
			"g" : "h",
			"%I": "h",
			"G" : "H",
			"h" : "hh",
			"H" : "HH",
			"%H": "HH",
			"i" : "mm",
			"%M": "mm",
			"s" : "ss",
			"%S": "ss",
			"%r": "hh:mm tt",
			"%R": "H:mm",
			"%T": "H:mm:ss",
			"%X": "t",
			"%x": "d",
			"%e": "d",
			"%D": "MM/dd/yy",
			"%n": "\\n",
			"%t": "\\t",
			"e" : "z",
			"T" : "z",
			"%z": "z",
			"%Z": "z",
			"Z" : "ZZ",
			"N" : "u",
			"w" : "u",
			"%w": "u",
			"W" : "W",
			"%V": "W"
		};
		var normalizer = {
			substitutes: function (m) {
				return normalizerSubstitutions[m];
			},
			interpreted: function (m, x) {
				var y;
				switch (m) {
					case "%u":
						return x.getDay() + 1;
					case "z":
						return x.getOrdinalNumber();
					case "%j":
						return p(x.getOrdinalNumber(), 3);
					case "%U":
						var d1 = x.clone().set({month: 0, day: 1}).addDays(-1).moveToDayOfWeek(0),
							d2 = x.clone().addDays(1).moveToDayOfWeek(0, -1);
						return (d2 < d1) ? "00" : p((d2.getOrdinalNumber() - d1.getOrdinalNumber()) / 7 + 1);
	
					case "%W":
						return p(x.getWeek());
					case "t":
						return $D.getDaysInMonth(x.getFullYear(), x.getMonth());
					case "o":
					case "%G":
						return x.setWeek(x.getISOWeek()).toString("yyyy");
					case "%g":
						return x._format("%G").slice(-2);
					case "a":
					case "%p":
						return t("tt").toLowerCase();
					case "A":
						return t("tt").toUpperCase();
					case "u":
						return p(x.getMilliseconds(), 3);
					case "I":
						return (x.isDaylightSavingTime()) ? 1 : 0;
					case "O":
						return x.getUTCOffset();
					case "P":
						y = x.getUTCOffset();
						return y.substring(0, y.length - 2) + ":" + y.substring(y.length - 2);
					case "B":
						var now = new Date();
						return Math.floor(((now.getHours() * 3600) + (now.getMinutes() * 60) + now.getSeconds() + (now.getTimezoneOffset() + 60) * 60) / 86.4);
					case "c":
						return x.toISOString().replace(/\"/g, "");
					case "U":
						return $D.strtotime("now");
					case "%c":
						return t("d") + " " + t("t");
					case "%C":
						return Math.floor(x.getFullYear() / 100 + 1);
				}
			},
			shouldOverrideDefaults: function (m) {
				switch (m) {
					case "%e":
						return true;
					default:
						return false;
				}
			},
			parse: function (m, context) {
				var formatString, c = context || new Date();
				formatString = normalizer.substitutes(m);
				if (formatString) {
					return formatString;
				}
				formatString = normalizer.interpreted(m, c);
	
				if (formatString) {
					return formatString;
				} else {
					return m;
				}
			}
		};
	
		$D.normalizeFormat = function (format, context) {
			return format.replace(/(%|\\)?.|%%/g, function(t){
					return normalizer.parse(t, context);
			});
		};
		/**
		 * Format a local Unix timestamp according to locale settings
		 *
		 * Example:
		 * Date.strftime("%m/%d/%y", new Date());		// "04/13/08"
		 * Date.strftime("c", "2008-04-13T17:52:03Z");	// "04/13/08"
		 *
		 * @param {String}   A format string consisting of one or more format spcifiers [Optional].
		 * @param {Number|String}   The number representing the number of seconds that have elapsed since January 1, 1970 (local time).
		 * @return {String}  A string representation of the current Date object.
		 */
		$D.strftime = function (format, time) {
			var d = Date.parse(time);
			return d._format(format);
		};
		/**
		 * Parse any textual datetime description into a Unix timestamp.
		 * A Unix timestamp is the number of seconds that have elapsed since January 1, 1970 (midnight UTC/GMT).
		 *
		 * Example:
		 * Date.strtotime("04/13/08");				// 1208044800
		 * Date.strtotime("1970-01-01T00:00:00Z");	// 0
		 *
		 * @param {String}   A format string consisting of one or more format spcifiers [Optional].
		 * @param {Object}   A string or date object.
		 * @return {String}  A string representation of the current Date object.
		 */
		$D.strtotime = function (time) {
			var d = $D.parse(time);
			return Math.round($D.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()) / 1000);
		};
		/**
		 * Converts the value of the current Date object to its equivalent string representation using a PHP/Unix style of date format specifiers.
		 * Format Specifiers
		 * Format  Description																	Example
		 * ------  ---------------------------------------------------------------------------	-----------------------
		 * %a		abbreviated weekday name according to the current localed					"Mon" through "Sun"
		 * %A		full weekday name according to the current localed							"Sunday" through "Saturday"
		 * %b		abbreviated month name according to the current localed						"Jan" through "Dec"
		 * %B		full month name according to the current locale								"January" through "December"
		 * %c		preferred date and time representation for the current locale				"4/13/2008 12:33 PM"
		 * %C		century number (the year divided by 100 and truncated to an integer)		"00" to "99"
		 * %d		day of the month as a decimal number										"01" to "31"
		 * %D		same as %m/%d/%y															"04/13/08"
		 * %e		day of the month as a decimal number, a single digit is preceded by a space	"1" to "31"
		 * %g		like %G, but without the century											"08"
		 * %G		The 4-digit year corresponding to the ISO week number (see %V).				"2008"
		 *		This has the same format and value as %Y, except that if the ISO week number
		 *		belongs to the previous or next year, that year is used instead.
		 * %h		same as %b																	"Jan" through "Dec"
		 * %H		hour as a decimal number using a 24-hour clock.								"00" to "23"
		 * %I		hour as a decimal number using a 12-hour clock.								"01" to "12"
		 * %j		day of the year as a decimal number.										"001" to "366"
		 * %m		month as a decimal number.													"01" to "12"
		 * %M		minute as a decimal number.													"00" to "59"
		 * %n		newline character		"\n"
		 * %p		either "am" or "pm" according to the given time value, or the				"am" or "pm"
		 *		corresponding strings for the current locale.
		 * %r		time in a.m. and p.m. notation												"8:44 PM"
		 * %R		time in 24 hour notation													"20:44"
		 * %S		second as a decimal number													"00" to "59"
		 * %t		tab character																"\t"
		 * %T		current time, equal to %H:%M:%S												"12:49:11"
		 * %u		weekday as a decimal number ["1", "7"], with "1" representing Monday		"1" to "7"
		 * %U		week number of the current year as a decimal number, starting with the		"0" to ("52" or "53")
		 *		first Sunday as the first day of the first week
		 * %V		The ISO 8601:1988 week number of the current year as a decimal number,		"00" to ("52" or "53")
		 *		range 01 to 53, where week 1 is the first week that has at least 4 days
		 *		in the current year, and with Monday as the first day of the week.
		 *		(Use %G or %g for the year component that corresponds to the week number
		 *		for the specified timestamp.)
		 * %W		week number of the current year as a decimal number, starting with the		"00" to ("52" or "53")
		 *		first Monday as the first day of the first week
		 * %w		day of the week as a decimal, Sunday being "0"								"0" to "6"
		 * %x		preferred date representation for the current locale without the time		"4/13/2008"
		 * %X		preferred time representation for the current locale without the date		"12:53:05"
		 * %y		year as a decimal number without a century									"00" "99"
		 * %Y		year as a decimal number including the century								"2008"
		 * %Z		time zone or name or abbreviation											"UTC", "EST", "PST"
		 * %z		same as %Z
		 * %%		a literal "%" characters													"%"
		 * d		Day of the month, 2 digits with leading zeros								"01" to "31"
		 * D		A textual representation of a day, three letters							"Mon" through "Sun"
		 * j		Day of the month without leading zeros										"1" to "31"
		 * l		A full textual representation of the day of the week (lowercase "L")		"Sunday" through "Saturday"
		 * N		ISO-8601 numeric representation of the day of the week (added in PHP 5.1.0)	"1" (for Monday) through "7" (for Sunday)
		 * S		English ordinal suffix for the day of the month, 2 characters				"st", "nd", "rd" or "th". Works well with j
		 * w		Numeric representation of the day of the week								"0" (for Sunday) through "6" (for Saturday)
		 * z		The day of the year (starting from "0")										"0" through "365"
		 * W		ISO-8601 week number of year, weeks starting on Monday						"00" to ("52" or "53")
		 * F		A full textual representation of a month, such as January or March			"January" through "December"
		 * m		Numeric representation of a month, with leading zeros						"01" through "12"
		 * M		A short textual representation of a month, three letters					"Jan" through "Dec"
		 * n		Numeric representation of a month, without leading zeros					"1" through "12"
		 * t		Number of days in the given month											"28" through "31"
		 * L		Whether it's a leap year													"1" if it is a leap year, "0" otherwise
		 * o		ISO-8601 year number. This has the same value as Y, except that if the		"2008"
		 *		ISO week number (W) belongs to the previous or next year, that year
		 *		is used instead.
		 * Y		A full numeric representation of a year, 4 digits							"2008"
		 * y		A two digit representation of a year										"08"
		 * a		Lowercase Ante meridiem and Post meridiem									"am" or "pm"
		 * A		Uppercase Ante meridiem and Post meridiem									"AM" or "PM"
		 * B		Swatch Internet time														"000" through "999"
		 * g		12-hour format of an hour without leading zeros								"1" through "12"
		 * G		24-hour format of an hour without leading zeros								"0" through "23"
		 * h		12-hour format of an hour with leading zeros								"01" through "12"
		 * H		24-hour format of an hour with leading zeros								"00" through "23"
		 * i		Minutes with leading zeros													"00" to "59"
		 * s		Seconds, with leading zeros													"00" through "59"
		 * u		Milliseconds																"54321"
		 * e		Timezone identifier															"UTC", "EST", "PST"
		 * I		Whether or not the date is in daylight saving time (uppercase i)			"1" if Daylight Saving Time, "0" otherwise
		 * O		Difference to Greenwich time (GMT) in hours									"+0200", "-0600"
		 * P		Difference to Greenwich time (GMT) with colon between hours and minutes		"+02:00", "-06:00"
		 * T		Timezone abbreviation														"UTC", "EST", "PST"
		 * Z		Timezone offset in seconds. The offset for timezones west of UTC is			"-43200" through "50400"
		 *			always negative, and for those east of UTC is always positive.
		 * c		ISO 8601 date																"2004-02-12T15:19:21+00:00"
		 * r		RFC 2822 formatted date														"Thu, 21 Dec 2000 16:01:07 +0200"
		 * U		Seconds since the Unix Epoch (January 1 1970 00:00:00 GMT)					"0"
		 * @param {String}   A format string consisting of one or more format spcifiers [Optional].
		 * @return {String}  A string representation of the current Date object.
		 */
		var formatReplace = function (context) {
			return function (m) {
				var formatString, override = false;
				if (m.charAt(0) === "\\" || m.substring(0, 2) === "%%") {
					return m.replace("\\", "").replace("%%", "%");
				}
	
				override = normalizer.shouldOverrideDefaults(m);
				formatString = $D.normalizeFormat(m, context);
				if (formatString) {
					return context.toString(formatString, override);
				}
			};
		};
		$P._format = function (format) {
			var formatter = formatReplace(this);
			if (!format) {
				return this._toString();
			} else {
				return format.replace(/(%|\\)?.|%%/g, formatter);
			}
		};
	
		if (!$P.format) {
			$P.format = $P._format;
		}
	}());


/***/ }),
/* 435 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		"use strict";
		var attrs = ["years", "months", "days", "hours", "minutes", "seconds", "milliseconds"];
		var gFn = function (attr) {
			return function () {
				return this[attr];
			};
		};
		
		var sFn = function (attr) {
			return function (val) {
				this[attr] = val;
				return this;
			};
		};
		var addSetFuncs = function (context, attrs) {
			for (var i = 0; i < attrs.length ; i++) {
				var $a = attrs[i], $b = $a.slice(0, 1).toUpperCase() + $a.slice(1);
				context.prototype[$a] = 0;
				context.prototype["get" + $b] = gFn($a);
				context.prototype["set" + $b] = sFn($a);
			}
		};
	
		var setMonthsAndYears = function (orient, d1, d2, context) {
			function inc() {
				d1.addMonths(-orient);
				context.months++;
				if (context.months === 12) {
					context.years++;
					context.months = 0;
				}
			}
			if (orient === +1) {
				while (d1 > d2) {
					inc();
				}
			} else {
				while (d1 < d2) {
					inc();
				}
			}
			context.months--;
			context.months *= orient;
			context.years *= orient;
		};
	
		var adjustForDST = function(orient, startDate, endDate) {
			var hasDSTMismatch = (false === (startDate.isDaylightSavingTime() === endDate.isDaylightSavingTime()));
			if (hasDSTMismatch && orient === 1) {
				startDate.addHours(-1);
			} else if (hasDSTMismatch) {
				startDate.addHours(1);
			}
		};
		/**
		 * TimePeriod(startDate, endDate);
		 * TimePeriod(years, months, days, hours, minutes, seconds, milliseconds);
		 */
		var TimePeriod = function (years, months, days, hours, minutes, seconds, milliseconds) {
			if (arguments.length === 7) {
				this.set(years, months, days, hours, minutes, seconds, milliseconds);
			} else if (arguments.length === 2 && arguments[0] instanceof Date && arguments[1] instanceof Date) {
				var startDate = arguments[0].clone();
				var endDate = arguments[1].clone();
				var orient = (startDate > endDate) ? +1 : -1;
				this.dates = {
					start: arguments[0].clone(),
					end: arguments[1].clone()
				};
	
				setMonthsAndYears(orient, startDate, endDate, this);
				adjustForDST(orient, startDate, endDate);
				// // TODO - adjust for DST
				var diff = endDate - startDate;
				if (diff !== 0) {
					var ts = new TimeSpan(diff);
					this.set(this.years, this.months, ts.getDays(), ts.getHours(), ts.getMinutes(), ts.getSeconds(), ts.getMilliseconds());
				}
			}
			return this;
		};
		// create all the set functions.
		addSetFuncs(TimePeriod, attrs);
		TimePeriod.prototype.set = function (years, months, days, hours, minutes, seconds, milliseconds){
			this.setYears(years || this.getYears());
			this.setMonths(months || this.getMonths());
			this.setDays(days || this.getDays());
			this.setHours(hours || this.getHours());
			this.setMinutes(minutes || this.getMinutes());
			this.setSeconds(seconds || this.getSeconds());
			this.setMilliseconds(milliseconds || this.getMilliseconds());
		};
	
		Date.TimePeriod = TimePeriod;
	
		if (typeof window !== "undefined") {
			// keeping API compatible for v1.x 
			window.TimePeriod = TimePeriod;
		}
	}());


/***/ }),
/* 436 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function () {
		"use strict";
		var gFn = function (attr) {
			return function () {
				return this[attr];
			};
		};
		
		var sFn = function (attr) {
			return function (val) {
				this[attr] = val;
				return this;
			};
		};
		var attrs = ["years", "months", "days", "hours", "minutes", "seconds", "milliseconds"];
		var addSetFuncs = function (context, attrs) {
			for (var i = 0; i < attrs.length ; i++) {
				var $a = attrs[i], $b = $a.slice(0, 1).toUpperCase() + $a.slice(1);
				context.prototype[$a] = 0;
				context.prototype["get" + $b] = gFn($a);
				context.prototype["set" + $b] = sFn($a);
			}
		};
		/**
		 * new TimeSpan(milliseconds);
		 * new TimeSpan(days, hours, minutes, seconds);
		 * new TimeSpan(days, hours, minutes, seconds, milliseconds);
		 */
		var TimeSpan = function (days, hours, minutes, seconds, milliseconds) {
			if (arguments.length === 1 && typeof days === "number") {
				var orient = (days < 0) ? -1 : +1;
				var millsLeft = Math.abs(days);
				this.setDays(Math.floor(millsLeft / 86400000) * orient);
				millsLeft = millsLeft % 86400000;
				this.setHours(Math.floor(millsLeft / 3600000) * orient);
				millsLeft = millsLeft % 3600000;
				this.setMinutes(Math.floor(millsLeft / 60000) * orient);
				millsLeft = millsLeft % 60000;
				this.setSeconds(Math.floor(millsLeft / 1000) * orient);
				millsLeft = millsLeft % 1000;
				this.setMilliseconds(millsLeft * orient);
			} else {
				this.set(days, hours, minutes, seconds, milliseconds);
			}
	
			this.getTotalMilliseconds = function () {
				return	(this.getDays() * 86400000) +
						(this.getHours() * 3600000) +
						(this.getMinutes() * 60000) +
						(this.getSeconds() * 1000);
			};
			
			this.compareTo = function (time) {
				var t1 = new Date(1970, 1, 1, this.getHours(), this.getMinutes(), this.getSeconds()), t2;
				if (time === null) {
					t2 = new Date(1970, 1, 1, 0, 0, 0);
				}
				else {
					t2 = new Date(1970, 1, 1, time.getHours(), time.getMinutes(), time.getSeconds());
				}
				return (t1 < t2) ? -1 : (t1 > t2) ? 1 : 0;
			};
	
			this.equals = function (time) {
				return (this.compareTo(time) === 0);
			};
	
			this.add = function (time) {
				return (time === null) ? this : this.addSeconds(time.getTotalMilliseconds() / 1000);
			};
	
			this.subtract = function (time) {
				return (time === null) ? this : this.addSeconds(-time.getTotalMilliseconds() / 1000);
			};
	
			this.addDays = function (n) {
				return new TimeSpan(this.getTotalMilliseconds() + (n * 86400000));
			};
	
			this.addHours = function (n) {
				return new TimeSpan(this.getTotalMilliseconds() + (n * 3600000));
			};
	
			this.addMinutes = function (n) {
				return new TimeSpan(this.getTotalMilliseconds() + (n * 60000));
			};
	
			this.addSeconds = function (n) {
				return new TimeSpan(this.getTotalMilliseconds() + (n * 1000));
			};
	
			this.addMilliseconds = function (n) {
				return new TimeSpan(this.getTotalMilliseconds() + n);
			};
	
			this.get12HourHour = function () {
				return (this.getHours() > 12) ? this.getHours() - 12 : (this.getHours() === 0) ? 12 : this.getHours();
			};
	
			this.getDesignator = function () {
				return (this.getHours() < 12) ? Date.CultureInfo.amDesignator : Date.CultureInfo.pmDesignator;
			};
	
			this.toString = function (format) {
				this._toString = function () {
					if (this.getDays() !== null && this.getDays() > 0) {
						return this.getDays() + "." + this.getHours() + ":" + this.p(this.getMinutes()) + ":" + this.p(this.getSeconds());
					} else {
						return this.getHours() + ":" + this.p(this.getMinutes()) + ":" + this.p(this.getSeconds());
					}
				};
				
				this.p = function (s) {
					return (s.toString().length < 2) ? "0" + s : s;
				};
				
				var me = this;
				
				return format ? format.replace(/dd?|HH?|hh?|mm?|ss?|tt?/g,
				function (format) {
					switch (format) {
					case "d":
						return me.getDays();
					case "dd":
						return me.p(me.getDays());
					case "H":
						return me.getHours();
					case "HH":
						return me.p(me.getHours());
					case "h":
						return me.get12HourHour();
					case "hh":
						return me.p(me.get12HourHour());
					case "m":
						return me.getMinutes();
					case "mm":
						return me.p(me.getMinutes());
					case "s":
						return me.getSeconds();
					case "ss":
						return me.p(me.getSeconds());
					case "t":
						return ((me.getHours() < 12) ? Date.CultureInfo.amDesignator : Date.CultureInfo.pmDesignator).substring(0, 1);
					case "tt":
						return (me.getHours() < 12) ? Date.CultureInfo.amDesignator : Date.CultureInfo.pmDesignator;
					}
				}
				) : this._toString();
			};
			return this;
		};
		addSetFuncs(TimeSpan, attrs.slice(2));
		TimeSpan.prototype.set = function (days, hours, minutes, seconds, milliseconds){
			this.setDays(days || this.getDays());
			this.setHours(hours || this.getHours());
			this.setMinutes(minutes || this.getMinutes());
			this.setSeconds(seconds || this.getSeconds());
			this.setMilliseconds(milliseconds || this.getMilliseconds());
		};
	
	
		/**
		 * Gets the time of day for this date instances. 
		 * @return {TimeSpan} TimeSpan
		 */
		Date.prototype.getTimeOfDay = function () {
			return new TimeSpan(0, this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds());
		};
	
		Date.TimeSpan = TimeSpan;
	
		if (typeof window !== "undefined" ) {
			// keeping API compatible for v1.x 
			window.TimeSpan = TimeSpan;
		}
	}());


/***/ }),
/* 437 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jshint freeze: false */
	"use strict";
	
	//-------------------------------------------
	function pad2(n) {
	    /// <summary>Ensure integers are 2 digits</summary>
	    return n < 10 ? "0".concat(n) : n;
	}
	
	
	//-------------------------------------------
	function pad3(n) {
	    /// <summary>Ensure integers are 3 digits</summary>
	    return n < 100
	        ? (n < 10 ? "00".concat(n) : "0".concat(n))
	        : n;
	}
	
	//-------------------------------------------
	function formatOffset(offset) {
	    var hours, minutes, formatted = null;
	    if (typeof offset === "number" && !isNaN(offset)) {
	        if (offset === 0) {
	            formatted = "Z";
	        } else {
	            formatted = offset < 0 ? "+" : "-";
	            offset = Math.abs(offset);
	            hours = Math.floor(offset / 60);
	            minutes = offset - (hours * 60);
	            formatted = formatted.concat(pad2(hours)).concat(":").concat(pad2(minutes));
	        }
	    }
	    return formatted;
	}
	
	
	//-------------------------------------------
	Date.prototype.toJSON = function dateToJSON() {
	    /// <summary>
	    /// Convert the date to UTC and serialize to the string representation
	    /// of a datetime. Format: (yyyy-MM-ddTHH:mm:ss.fffK)
	    /// </summary>
	    /// <example>1999-12-31T18:01:01.001+01:00</example>
	    return ""
	        .concat(this.getFullYear()).concat("-")
	        .concat(pad2(this.getMonth() + 1)).concat("-")
	        .concat(pad2(this.getDate())).concat("T")
	        .concat(pad2(this.getHours())).concat(":")
	        .concat(pad2(this.getMinutes())).concat(":")
	        .concat(pad2(this.getSeconds())).concat(".")
	        .concat(pad3(this.getMilliseconds()))
	        .concat(formatOffset(this.getTimezoneOffset()));
	};
	
	
	//-------------------------------------------
	Date.prototype.toJSONDate = function dateToJSONDate() {
	    /// <summary>
	    /// Serialize a javascript date to the string representation
	    /// of a date. Format: (yyyy-MM-dd)
	    /// </summary>
	    /// <example>1999-12-31</example>
	    return ""
	        .concat(this.getFullYear()).concat("-")
	        .concat(pad2(this.getMonth() + 1)).concat("-")
	        .concat(pad2(this.getDate()));
	};
	
	
	//-------------------------------------------
	Date.fromJSON = function dateFromJSON(value) {
	    /// <summary>
	    /// De-serialize a ISO 8601 string representation of a UTC datetime to
	    /// the javascript date object in local timezone.
	    /// Expected Format: (yyyy-MM-ddTHH:mm:ss.fffK)
	    /// </summary>
	    if (typeof value !== "string" || value.length < 24) { return null; }
	
	    var hours = 0, minutes = 0, multiplier = 0;
	
	    // Calculate offset (hours and minutes)
	    if (value.length >= 29) {
	        multiplier = value.substr(23, 1) === "-" ? 60000 : -60000;
	        hours = parseInt(value.substr(24, 2), 10);
	        minutes = parseInt(value.substr(27, 2), 10);
	    }
	
	    return new Date(Date.UTC(
	        parseInt(value.substr(0, 4), 10),
	        parseInt(value.substr(5, 2), 10) - 1,
	        parseInt(value.substr(8, 2), 10),
	        parseInt(value.substr(11, 2), 10),
	        parseInt(value.substr(14, 2), 10),
	        parseInt(value.substr(17, 2), 10),
	        parseInt(value.substr(20, 3), 10)
	    ) + multiplier * (60 * hours + minutes));
	};
	
	
	//-------------------------------------------
	Date.fromJSONDate = function dateFromJSONDate(value) {
	    /// <summary>
	    /// De-serialize a ISO 8601 string representation of a date to
	    /// the javascript date object.
	    /// Expected Format: (yyyy-MM-dd)
	    /// </summary>
	    if (typeof value !== "string" || value.length < 10) { return null; }
	    return new Date(
	        parseInt(value.substr(0, 4), 10),
	        parseInt(value.substr(5, 2), 10) - 1,
	        parseInt(value.substr(8, 2), 10)
	    );
	};
	
	
	//-------------------------------------------
	Date.min = Date.min || new Date(-8640000000000000);
	    /// <summary>
	    /// Represents the smallest possible javascript Date.
	    /// More info: http://stackoverflow.com/questions/11526504/minimum-and-maximum-date
	    /// </summary>
	
	module.exports = Date;
	


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var R = __webpack_require__(7);
	var util = __webpack_require__(422);
	var stringUtil = __webpack_require__(13);
	var numberUtil = __webpack_require__(21);
	
	var defaultLabels = {
	    avg: "Avg ",
	    max: "Max ",
	    min: "Min ",
	    sum: ""
	};
	var encodeCharRegex = new RegExp("&|\"|'|<|>", "g");
	var titleCaseRegex = new RegExp("\\w\\S*", "g");
	
	
	/**
	 * HTML-encodes the specified string.
	 *
	 * Legacy implementation:
	 * https://github.com/mleibman/SlickGrid/blob/master/slick.grid.js#L1362
	 *
	 * @param value
	 *     String to be encoded.
	 */
	function encodeHtml(value) {
	    return (value || "")
	        .replace(encodeCharRegex, function (value) {
	            switch (value) {
	            case "&":
	                return "&amp;";
	            case "\"":
	                return "&quot;";
	            case "'":
	                return "&#39;";
	            case "<":
	                return "&lt;";
	            case ">":
	                return "&gt;";
	            default:
	                return value;
	            }
	        });
	}
	
	
	/**
	 * Converts the specified string to title case.
	 *
	 * Example. "sammy tammi" => "Sammy Tammi"
	 *
	 * @param value
	 *     String to be title cased.
	 */
	function toTitleCase(value) {
	    return value.replace(
	        titleCaseRegex,
	        function (value) {
	            return value.charAt(0)
	                .toUpperCase()
	                .concat(value.substr(1).toLowerCase());
	        }
	    );
	}
	
	
	/**
	 * Parses the number, applies numeric formatting and adds bolding.
	 *
	 * Returns empty string `""` if the value is not a number.
	 *
	 * @param field
	 *     Field to be used in the aggregate.
	 */
	function createAggregateFormatter(field) { // jshint validthis:true
	    var getValue = util.propOrDefault(field);
	    var labels = R.merge(defaultLabels, this.formatterLabels || {});
	    var numberFormat = util.stringOrDefault("formatSpecifier", "N")(this);
	    var mapTotals = R.compose(R.join(" "), R.map(function (pair) {
	        var value = numberUtil.parseNumber(getValue(pair[1]));
	        if (numberUtil.isNumber(value)) {
	            var label = util.propOrDefault(pair[0], "")(labels);
	            return label.concat("<b>", numberUtil.formatNumber(value, numberFormat), "</b>");
	        }
	        return "";
	    }), R.toPairs);
	    return function aggregateFormatter(totals) {
	        return mapTotals(totals);
	    };
	}
	
	
	/**
	 * Displays a truthy icon or falsy icon based on the
	 * value of the field.
	 *
	 * Adds an icon `formatterTrueIconClass` if the
	 * value is truthy or `formatterFalseIconClass` if
	 * the value is falsy.
	 *
	 * @param field
	 *     Field to check for truthy/falsy.
	 */
	function createBoolIconFormatter(field) { // jshint validthis:true
	    var getValue = util.propOrDefault(field, false);
	    var truthyIcon = "<i class='".concat(util.stringOrDefault("formatterTrueIconClass", "")(this), "'></i>");
	    var falsyIcon = "<i class='".concat(util.stringOrDefault("formatterFalseIconClass", "")(this), "'></i>");
	    return function iconFormatter(item) {
	        return (getValue(item) ? truthyIcon : falsyIcon);
	    };
	}
	
	
	/**
	 * Formats a slick.grid group title.
	 *
	 * Example. `Aberfeldy (241 items)`
	 *
	 * @param customFormatter
	 *     Custom formatter applied to the group title.
	 */
	function createGroupFormatter(customFormatter) { // jshint validthis:true
	    var prefix = util.stringOrDefault("title", "")(this);
	    return function groupFormatter(item) {
	        return (prefix ? (prefix.concat(": ")) : prefix).concat(
	            customFormatter(item),
	            " (",
	            item.count,
	            (item.count === 1 ? " item)" : " items)")
	        );
	    };
	}
	
	
	/**
	 * Prepends an icon to a column using a string formatter for the field.
	 *
	 * The icon css class may be specified directly in the "formatterIconClass"
	 * property on the column definition.
	 *
	 * The icon css class may also be derived from another field, specified in
	 * the "formatterIconField" property on the column definition (defaults to "icon").
	 *
	 * @param field
	 *     Field to append after the icon.
	 */
	function createIconFormatter(field) { // jshint validthis:true
	    var getValue = R.compose(encodeHtml, util.stringOrDefault(field, ""));
	    var iconClass = util.stringOrDefault("formatterIconClass", "")(this);
	    var getIcon = (iconClass
	        ? R.always("")
	        : util.stringOrDefault(util.stringOrDefault("formatterIconField", "icon")(this), ""));
	    return function iconFormatter(item) {
	        var icon = iconClass || getIcon(item);
	        return icon
	            ? "<i class='".concat(icon, "'></i>", getValue(item))
	            : getValue(item);
	    };
	}
	
	
	/**
	 * Creates a formatter method for date entries.
	 *
	 * Takes date objects or strings formatted like `yyyy-MM-dd`
	 * and formats using `MMM-dd-yyyy` or the format specified in
	 * "formatSpecifier" on the column.
	 *
	 * @param field
	 *     Field to format as a date.
	 */
	function createDateFormatter(field) { // jshint validthis:true
	    var getValue = R.pipe(
	        // get value for 'field'
	        util.propOrDefault(field, ""),
	        util.asDate
	    );
	    var dateFormat = util.stringOrDefault("formatSpecifier", "MMM-dd-yyyy")(this);
	    return function dateFormatter(item) {
	        var dateValue = getValue(item);
	        return (dateValue !== null ? dateValue.toString(dateFormat) : "");
	    };
	}
	
	
	/**
	 * Creates a formatter method for numeric entries.
	 *
	 * Takes number objects or strings and formats
	 * using the default number format or the format specified in
	 * "formatSpecifier" on the column.
	 *
	 * @param field
	 *     Field to format as a number.
	 */
	function createNumberFormatter(field) { // jshint validthis:true
	    var getValue = util.propOrDefault(field, null);
	    var numberFormat = util.stringOrDefault("formatSpecifier", "N")(this);
	
	    return function numberFormatter(item) {
	        var value = getValue(item);
	
	        if (numberUtil.isNumber(value)) {
	            return numberUtil.formatNumber(value, numberFormat);
	        }
	
	        value = numberUtil.parseNumber(value);
	        return numberUtil.formatNumber(value, numberFormat);
	    };
	}
	
	
	/**
	 * Creates a formatter method for validated columns.
	 *
	 * Looks for an error dictionary { [field:string]: message } in the
	 * "errorSpecifier" column property, defaulting to "_errors".
	 *
	 * Error message override may be specified on the column definition
	 * in the "errorMessage" property.
	 *
	 * @param field
	 *     Field to format.
	 * @param defaultColumnErrorMessage
	 *     If specified, will be used as the default value for the column's
	 *     "errorMessage" property, overriding the message in the "_errors"
	 *     dictionary (may still be overriden by column "errorMessage" value).
	 */
	function createValidationFormatter(field, defaultColumnErrorMessage) { // jshint validthis:true
	    var errorSpecifierField = util.stringOrDefault("errorSpecifier", "_errors")(this);
	    var columnErrorMessage = util.stringOrDefault("errorMessage", defaultColumnErrorMessage)(this);
	    var getValue = util.stringOrDefault(field, null);
	    var getErrors = util.propOrDefault(errorSpecifierField, {});
	    return function validationFormatter(item) {
	        var errors = getErrors(item);
	        return (errors[field]
	            ? "<span class='error'>" + encodeHtml(columnErrorMessage || errors[field]) + "</span>"
	            : encodeHtml(getValue(item)));
	    };
	}
	
	
	/**
	 * Default implementation of the formatter factory.
	 *
	 * @param id
	 *     Key-value pair consisting of the column id and format type
	 *     separated by ':'.
	 *
	 *     Example. "startDate:date" - [key] = startDate, [value] = date
	 *
	 * @returns {function}
	 *     Formatter function based off the format type from id parameter.
	 */
	function defaultFactory(id) { // jshint validthis:true
	    if (stringUtil.isNullOrWhitespace(id)) { throw new Error("factory id must be non-empty string."); }
	    var pair = id.split(":");
	    var formatterType = (pair[1] || "").toLowerCase();
	    var formatterField = pair[0];
	    switch (formatterType) {
	    case "aggregate":
	        return createAggregateFormatter.call(this, formatterField);
	    case "blank":
	        return function () { return ""; };
	    case "bool-icon":
	        return createBoolIconFormatter.call(this, formatterField);
	    case "date":
	        return createDateFormatter.call(this, formatterField);
	    case "default":
	        return R.compose(encodeHtml, util.stringOrDefault(formatterField, ""));
	    case "group":
	        var formatter = this.formatter !== undefined
	            ? defaultFactory.call(this, "value:".concat(this.formatter.split(":")[1]))
	            : util.stringOrDefault("value", "Empty");
	        return createGroupFormatter.call(this, formatter);
	    case "group-title":
	        return createGroupFormatter.call(this, R.compose(toTitleCase, util.stringOrDefault("value", "Empty")));
	    case "icon":
	        return createIconFormatter.call(this, formatterField);
	    case "lowercase":
	        return R.compose(encodeHtml, R.toLower, util.stringOrDefault(formatterField, ""));
	    case "number":
	        return createNumberFormatter.call(this, formatterField);
	    case "required":
	        return createValidationFormatter.call(this, formatterField, "Empty");
	    case "validated":
	        return createValidationFormatter.call(this, formatterField);
	    default:
	        throw new Error("`".concat(formatterType, "` formatter type is not supported."));
	    }
	}
	
	
	/**
	 * Creates a function that resolves formatters by forwarding
	 * requests to the specified factory in the specified context.
	 *
	 * @param factory
	 *     Factory is specified so that the returned function can
	 *     forward formatter requests to it via closure.
	 */
	function init(factory) {
	    return function formatterResolver(context, value) {
	        var formatter;
	        if (typeof value === "function") {
	            formatter = value;
	        } else {
	            formatter = factory.call(context, value);
	        }
	        return R.bind(formatter, context);
	    };
	}
	
	
	module.exports = {
	    init: init,
	    defaultFactory: init(defaultFactory)
	};
	


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var R = __webpack_require__(7);
	var stringUtil = __webpack_require__(13);
	
	//-------------------------------------------
	// Creates a function that resolves each of the
	// parameters of a group definition.
	function createGroupResolver(aggregatorFactory, comparerFactory, formatterFactory) {
	    return function (context, group, isDescending) {
	        return R.merge(group, {
	            aggregators: (group.aggregators !== undefined ? aggregatorFactory(context, group.aggregators) : undefined),
	            comparer: (group.comparer !== undefined ? comparerFactory(context, group.comparer, isDescending) : undefined),
	            formatter: (group.formatter !== undefined ? formatterFactory(context, group.formatter) : undefined),
	            getter: (group.getter !== undefined ? formatterFactory(context, group.getter) : undefined)
	        });
	    };
	}
	
	
	//-------------------------------------------
	// Default implementation of the group factory
	function defaultFactory(id) {
	    if (stringUtil.isNullOrWhitespace(id)) { throw new Error("group factory id must be non-empty string."); }
	    var pair = id.split(":");
	    var groupType = (pair[1] || "").toLowerCase();
	    var groupField = pair[0];
	    switch (groupType) {
	    case "default":
	        return {
	            aggregateCollapsed: false,
	            aggregators: [],
	            comparer: "value:default",
	            formatter: "".concat(groupField, ":group-title"),
	            getter: "".concat(groupField, ":lowercase")
	        };
	    case "sensitive":
	        return {
	            aggregateCollapsed: false,
	            aggregators: [],
	            comparer: "value:default",
	            formatter: "".concat(groupField, ":group"),
	            getter: "".concat(groupField, ":default")
	        };
	    default:
	        throw new Error("`".concat(id, "` group type is not supported."));
	    }
	}
	
	
	//-------------------------------------------
	// Accepts a factory function and returns a function
	// that resolves a group.
	function init(factory, aggregatorFactory, comparerFactory, formatterFactory) {
	    var groupResolver = createGroupResolver(aggregatorFactory, comparerFactory, formatterFactory);
	    return function groupFactoryResolver(context, value, isDescending) {
	        var result;
	        if (Array.isArray(value)) {
	            var i, l = value.length, current = [];
	            for (i = 0; i < l; i += 1) {
	                current = current.concat(groupFactoryResolver(context, value[i]));
	            }
	            result = current;
	        } else if (R.is(Object, value)) {
	            result = [groupResolver(context, value, isDescending)];
	        } else {
	            result = [groupResolver(context, factory.call(context, value), isDescending)];
	        }
	        return result;
	    };
	}
	
	
	module.exports = {
	    defaultFactory: init(
	        defaultFactory,
	        __webpack_require__(415).defaultFactory,
	        __webpack_require__(421).defaultFactory,
	        __webpack_require__(438).defaultFactory
	    ),
	    init: init
	};
	


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint unparam:true */
	
	"use strict";
	
	var slickCore = __webpack_require__(410);
	
	var $ = __webpack_require__(1);
	
	var util = __webpack_require__(422);
	
	var defaultOptions = {
	    groupCssClass: "group-header ",
	    totalsCssClass: "slick-group-totals ",
	    groupSelectable: true,
	    groupFocusable: true,
	    totalsSelectable: false,
	    totalsFocusable: false,
	    toggleCssClass: "slick-group-toggle",
	    toggleExpandedCssClass: "expanded",
	    toggleCollapsedCssClass: "collapsed",
	    checkboxCssClass: "slick-group-checkbox",
	    checkboxSelectPlugin: null,
	    columnId: "_checkbox",
	    cssClass: null,
	    toolTip: "Select/Deselect All",
	    width: 30
	};
	
	
	function isDataItem(item) {
	    /// <summary>
	    /// Returns true if item represents actual data item, but not group nor totals.
	    /// </summary>
	
	    return item && !item.__group && !item.__groupTotals;
	}
	
	
	function isDataRow(data, row) {
	    /// <summary>
	    /// Returns true if item at given row is not Group and not Group Total row.
	    /// </summary>
	
	    return isDataItem(data.getItem(row));
	}
	
	
	// --------------------------------------------
	// Groups + checkbox selection plugin
	
	function GroupSelectionPlugin(options) {
	    /// <summary>
	    /// Group item metadata provider that uses checkboxes for multiselect.
	    /// </summary>
	
	    this.handlers = new slickCore.EventHandler();
	    this.options = $.extend({}, defaultOptions, options);
	
	    this.onColumnFilterClick = new slickCore.Event();
	    this.onSelectedIdsChange = new slickCore.Event();
	
	    this.selectedIds = {};
	}
	
	
	GroupSelectionPlugin.prototype.init = function init(grid) {
	    /// <summary>
	    /// Initializes properties and subscriptions.
	    /// </summary>
	
	    var gridData = grid.getData();
	
	    this.grid = grid;
	    this.multiSelect = grid.getOptions().multiSelect;
	
	    // subscribe to grid events
	    this.handlers.subscribe(grid.onClick, GroupSelectionPlugin.prototype._onClickHandler.bind(this));
	    this.handlers.subscribe(grid.onDblClick, GroupSelectionPlugin.prototype._onDblClickHandler.bind(this));
	    this.handlers.subscribe(grid.onHeaderClick, GroupSelectionPlugin.prototype._onHeaderClickHandler.bind(this));
	    this.handlers.subscribe(grid.onActiveCellChanged, GroupSelectionPlugin.prototype._onActiveCellChangedHandler.bind(this));
	    this.handlers.subscribe(grid.onContextMenu, GroupSelectionPlugin.prototype._onContextMenuHandler.bind(this));
	    this.handlers.subscribe(grid.onHeaderCellRendered, GroupSelectionPlugin.prototype._onHeaderCellRenderedHandler.bind(this));
	    this.handlers.subscribe(gridData.onRowCountChanged, GroupSelectionPlugin.prototype._onRowCountChangedHandler.bind(this));
	    this.handlers.subscribe(gridData.onRowsChanged, GroupSelectionPlugin.prototype._onRowsChangedHandler.bind(this));
	
	    // init group item metadata provider
	    this.hookGetItemMetadata();
	};
	
	
	GroupSelectionPlugin.prototype.destroy = function () {
	    /// <summary>
	    /// Disposes all subscriptions.
	    /// </summary>
	
	    this.handlers.unsubscribeAll();
	    this.grid.getData().getItemMetadata = this._originalDataViewGetItemMetadata;
	};
	
	
	GroupSelectionPlugin.prototype.hookGetItemMetadata = function () {
	    /// <summary>
	    /// Initializes provided group item metadata for a data view.
	    /// </summary>
	    /// <param name="provider"></param>
	
	    var data = this.grid.getData(),
	        formatterFactory = this.grid.getOptions().formatterFactory,
	        self = this;
	
	    function getGroupRowMetadata(item) {
	        /// <summary>
	        /// Returns group row metadata, that contains also group cell formatter.
	        /// </summary>
	        self._groupRowMetadata = self._groupRowMetadata || {
	            selectable: self.options.groupSelectable,
	            focusable: self.options.groupFocusable,
	            cssClasses: self.options.groupCssClass,
	            columns: {
	                0: {
	                    formatter: self.defaultGroupCellFormatter.bind(self),
	                    editor: null
	                }
	            }
	        };
	
	        // Adjust width of group title column (0) based on whether
	        // totals are being displayed. These need to be adjusted every
	        // time the metadata is retrieved in case column positions have changed.
	        self._groupRowMetadata.columns[0].colspan = (item.displayHeaderTotals && item.headerTitleColspan >= 0
	            ? item.headerTitleColspan
	            : "*"); // fit to the width of the table by default
	
	        return self._groupRowMetadata;
	    }
	
	    function getTotalsRowMetadata() {
	        /// <summary>
	        /// Returns totals row metadata.
	        /// </summary>
	        self._totalsRowMetadata = self._totalsRowMetadata || {
	            selectable: self.options.totalsSelectable,
	            focusable: self.options.totalsFocusable,
	            cssClasses: self.options.totalsCssClass,
	            formatter: self.options.totalsFormatter || (formatterFactory && formatterFactory.totalsFormatter),
	            editor: null
	        };
	        return self._totalsRowMetadata;
	    }
	
	    this._originalDataViewGetItemMetadata = data.getItemMetadata;
	
	    data.getItemMetadata = function getItemMetadata(row) {
	        var metadata, item = data.getItem(row);
	
	        // overrides for grouping rows
	        if (item && item.__group) {
	            return getGroupRowMetadata(item);
	        }
	
	        // overrides for totals rows
	        if (item && item.__groupTotals) {
	            return getTotalsRowMetadata(item);
	        }
	
	        // get original item metadata
	        metadata = self._originalDataViewGetItemMetadata(row);
	
	        // first group item row decorate with "first" class
	        if (row !== 0 && isDataRow(data, row) && !isDataRow(data, row - 1)) {
	            metadata = metadata || {};
	            metadata.cssClasses = (metadata.cssClasses || "") + "first ";
	        }
	
	        // last group item row decorate with "last" class
	        if (isDataRow(data, row) && !isDataRow(data, row + 1)) {
	            metadata = metadata || {};
	            metadata.cssClasses = (metadata.cssClasses || "") + "last ";
	        }
	
	        return metadata;
	    };
	};
	
	
	GroupSelectionPlugin.prototype.getCheckboxColumnDefinition = function () {
	    /// <summary>
	    /// Returns checkbox column definition (the first column in grid when in multi select mode).
	    /// </summary>
	
	    // Remove row checkboxes out of the tab cycle with tabindex='-1'
	    // so when slickgrid's tab handler is disabled, tabs
	    // are not forced to iterate through each checkbox control.
	    var checkbox = "<input type='checkbox' tabindex='-1'/>";
	    this.checkboxColumnDefinition = this.checkboxColumnDefinition || {
	        id: this.options.columnId,
	        name: checkbox,
	        toolTip: this.options.toolTip,
	        field: "sel",
	        width: this.options.width,
	        resizable: false,
	        sortable: false,
	        movable: false,
	        cssClass: this.options.cssClass,
	        filterable: false,
	        supportsContext: false,
	        formatter: this.checkboxSelectionFormatter.bind(this)
	    };
	    return this.checkboxColumnDefinition;
	};
	
	
	GroupSelectionPlugin.prototype.toggleGroup = function (group) {
	    /// <summary>
	    /// Expands/collapses group depending on it's current state and syncronizes selection.
	    /// </summary>
	    /// <param name="group">Group item.</param>
	
	    if (group.collapsed) {
	        this.grid.getData().expandGroup(group.groupingKey);
	    } else {
	        this.grid.getData().collapseGroup(group.groupingKey);
	    }
	    this.syncSelectedRows();
	};
	
	
	/**
	 * Expands/collapses all groups depending on the state of the provided group.
	 *
	 * @param group
	 *     Group item.
	 */
	GroupSelectionPlugin.prototype.toggleAllGroups = function (group) {
	    if (group.collapsed) {
	        this.grid.getData().expandAllGroups(group.level);
	    } else {
	        this.grid.getData().collapseAllGroups(group.level);
	    }
	    this.syncSelectedRows();
	};
	
	
	GroupSelectionPlugin.prototype.isGroupSelected = function (group) {
	    /// <summary>
	    /// Returns "true" if given group item contains only selected rows.
	    /// </summary>
	    /// <param name="group">Groups item.</param>
	
	    var i, rows, l, id, idField = this.grid.getOptions().idField;
	
	    for (i = 0, rows = group.rows, l = group.rows.length; i < l; i += 1) {
	        id = rows[i][idField];
	        if (!this.selectedIds[id]) {
	            return false;
	        }
	    }
	    return true;
	};
	
	
	GroupSelectionPlugin.prototype.syncSelectedRows = function () {
	    /// <summary>
	    /// Select grid rows depending on selected items.
	    /// </summary>
	
	    this.selectRowsByIds(this.selectedIds);
	};
	
	
	GroupSelectionPlugin.prototype.selectAll = function (all) {
	    /// <summary>
	    /// Checks/unchecks all rows.
	    /// Only makes sense in multi selection mode.
	    /// </summary>
	    /// <param name="all">true to check.</param>
	    var i, id, items, l, idField = this.grid.getOptions().idField;
	
	    if (this.multiSelect) {
	        // check all rows
	        if (all) {
	            for (i = 0, items = this.grid.getData().getItems(), l = items.length; i < l; i += 1) {
	                id = items[i][idField];
	                this.selectedIds[id] = true;
	            }
	        } else {
	            this.selectedIds = {};
	        }
	
	        this.syncSelectedRows();
	
	        this.onSelectedIdsChange.notify({ ids: this.selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);
	    }
	};
	
	
	GroupSelectionPlugin.prototype.selectRowsByIds = function (ids) {
	
	    var item, rows = [], count = 0, id,
	        getRowById = this.grid.getData().getRowById,
	        getItemById = this.grid.getData().getItemById;
	
	    this.selectedIds = ids;
	
	    for (id in ids) {
	        if (ids.hasOwnProperty(id) && ids[id]) {
	            item = getItemById(id);
	            if (item) {
	                rows.push(getRowById(id));
	                count += 1;
	            } else {
	                // remove id from "selected" dictionary
	                // if items array doesn't have an item with given id
	                delete ids[id];
	            }
	        }
	    }
	
	    this.grid.setSelectedRows(rows);
	
	    // invalidate whole grid, so all checkboxes are rerendered
	    if (this.multiSelect) {
	        this.grid.invalidate();
	    }
	
	    // check/uncheck column checkbox
	    // Remove row checkboxes out of the tab cycle with tabindex='-1'
	    // so when slickgrid's tab handler is disabled, tabs
	    // are not forced to iterate through each checkbox control.
	    if (count > 0 && this.grid.getData().getItems().length === count) {
	        this.grid.updateColumnHeader(this.options.columnId, "<input type='checkbox' checked='checked' tabindex='-1' />", this.options.toolTip);
	    } else {
	        this.grid.updateColumnHeader(this.options.columnId, "<input type='checkbox' tabindex='-1' />", this.options.toolTip);
	    }
	};
	
	
	GroupSelectionPlugin.prototype.checkboxSelectionFormatter = function (row, cell, value, columnDef, dataContext) {
	    /// <summary>
	    /// Cell formatter of checkbox column.
	    /// </summary>
	
	    if (dataContext) {
	        var id = this.grid.getData().mapRowsToIds([row])[0];
	        // Remove row checkboxes out of the tab cycle with tabindex='-1'
	        // so when slickgrid's tab handler is disabled, tabs
	        // are not forced to iterate through each checkbox control.
	        return this.selectedIds[id]
	            ? "<input type='checkbox' checked='checked' tabindex='-1' />"
	            : "<input type='checkbox' tabindex='-1' />";
	    }
	    return null;
	};
	
	
	GroupSelectionPlugin.prototype.defaultGroupCellFormatter = function (row, cell, value, columnDef, item) {
	    /// <summary>
	    /// Group cell formatter.
	    /// </summary>
	
	    var indentation = (this.multiSelect ? item.level + 1 : item.level) * 15 + "px",
	        checkbox;
	    if (this.multiSelect) {
	        // Remove row checkboxes out of the tab cycle with tabindex='-1'
	        // so when slickgrid's tab handler is disabled, tabs
	        // are not forced to iterate through each checkbox control.
	        checkbox = this.isGroupSelected(item)
	            ? "<input type='checkbox' tabindex='-1' class='" + this.options.checkboxCssClass + "' checked='checked' />"
	            : "<input type='checkbox' tabindex='-1' class='" + this.options.checkboxCssClass + "' />";
	    } else {
	        checkbox = "";
	    }
	
	    return [
	        checkbox,
	        '<span style="margin-left:',
	        indentation,
	        '" class="',
	        this.options.toggleCssClass,
	        ' ',
	        (item.collapsed ? this.options.toggleCollapsedCssClass : this.options.toggleExpandedCssClass),
	        '"></span>',
	        '<span title="Double Click to ',
	        item.collapsed ? 'Expand ' : 'Collapse ',
	        '">',
	        item.title,
	        '</span>'
	    ].join("");
	};
	
	
	GroupSelectionPlugin.prototype.getClosestFocusableRow = function (grid, row, step) {
	    /// <summary>
	    /// Returns closest focusable row to given one.
	    /// </summary>
	
	    var length = grid.getDataLength();
	    while (row >= 0 && row < length && !grid.canCellBeActive(row, 0)) {
	        row += step;
	    }
	    return row;
	};
	
	
	GroupSelectionPlugin.prototype.navigateAndSelectUpOrDown = function (isDownNav, grid) {
	    /// <summary>
	    /// Selects next row when navigating up/down.
	    /// </summary>
	
	    var activeRow = grid.getActiveCell(),
	        dir = isDownNav ? 1 : -1,
	        id,
	        nextRow,
	        dataLength = grid.getDataLength(),
	        selected = this.selectedIds,
	        idField = this.grid.getOptions().idField;
	
	    if (activeRow) {
	        if (this.multiSelect) {
	            nextRow = activeRow.row;
	
	            id = grid.getDataItem(activeRow.row)[idField];
	            selected[id] = true;
	
	            do {
	                nextRow = nextRow + dir;
	            } while (!grid.canCellBeActive(nextRow, activeRow.cell) && nextRow >= 0 && nextRow < dataLength);
	
	            if (nextRow >= 0 && nextRow < dataLength) {
	                id = grid.getDataItem(nextRow)[idField];
	                selected[id] = true;
	            }
	        } else {
	            selected = {};
	        }
	
	        this.selectedIds = selected;
	        this.syncSelectedRows();
	        this.onSelectedIdsChange.notify({ ids: this.selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);
	
	        if (isDownNav) {
	            grid.navigateDown();
	        } else {
	            grid.navigateUp();
	        }
	    }
	};
	
	
	GroupSelectionPlugin.prototype.navigateHomeOrEnd = function (isHomeNav, selectRows, grid) {
	    /// <summary>
	    /// Selects all rows from currently focused row to the first or last one.
	    /// </summary>
	
	    var i, l, activeRow = grid.getActiveCell(),
	        lastRow = activeRow && activeRow.row,
	        idField = this.grid.getOptions().idField;
	
	    if (activeRow && selectRows) {
	        if (this.multiSelect) {
	            for (i = isHomeNav ? 0 : activeRow.row, l = isHomeNav ? activeRow.row + 1 : grid.getDataLength(); i < l; i += 1) {
	                if (grid.canCellBeActive(i, activeRow.cell)) {
	                    this.selectedIds[grid.getDataItem(i)[idField]] = true;
	                    lastRow = i;
	                }
	            }
	            this.syncSelectedRows();
	
	            grid.gotoCell(isHomeNav ? 0 : lastRow, 0);
	        }
	    } else {
	        if (isHomeNav) {
	            grid.gotoCell(this.getClosestFocusableRow(grid, 0, 1), 0);
	        } else {
	            grid.gotoCell(this.getClosestFocusableRow(grid, grid.getDataLength() - 1, -1), 0);
	        }
	    }
	};
	
	
	
	GroupSelectionPlugin.prototype.toggleRowSelection = function (row) {
	    /// <summary>
	    /// Given grid row, toggles its selection.
	    /// </summary>
	    /// <param name="row">Grid row.</param>
	
	    var i, l, checked, idField, id, item = this.grid.getData().getItem(row);
	
	    if (!item) { return; }
	
	    if (item.__group) {
	        checked = this.isGroupSelected(item);
	        idField = this.grid.getOptions().idField;
	
	        for (i = 0, l = item.rows.length; i < l; i += 1) {
	            this.selectedIds[item.rows[i][idField]] = !checked;
	        }
	    } else {
	        id = item[this.grid.getOptions().idField];
	        this.selectedIds[id] = !this.selectedIds[id];
	    }
	
	    this.syncSelectedRows();
	
	    this.onSelectedIdsChange.notify({ ids: this.selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);
	};
	
	
	// --------------------------------------------
	// Handling Slick Grid events
	
	
	GroupSelectionPlugin.prototype._onClickHandler = function (e, args) {
	    /// <summary>
	    /// Handle click;
	    /// </summary>
	
	    var from, to, cell, i, dir, id,
	        item = args.grid.getDataItem(args.row),
	        idField = this.grid.getOptions().idField,
	        dataView = this.grid.getData();
	
	    if (this.multiSelect && e.ctrlKey) {
	        // ctrl + click: toggle row selection
	
	        cell = args.grid.getCellFromEvent(e);
	        if (item && args.grid.canCellBeActive(cell.row, cell.cell)) {
	            id = item[idField];
	
	            if (isDataItem(item)) {
	                this.selectedIds[id] = !this.selectedIds[id];
	            }
	
	            this.syncSelectedRows();
	            this.onSelectedIdsChange.notify({ ids: this.selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);
	
	            args.grid.gotoCell(cell.row, 0);
	            args.grid.focus();
	        }
	
	        // we don't want to allow slick grid to select anything
	        e.stopImmediatePropagation();
	
	    }
	
	    if (this.multiSelect && e.shiftKey) {
	        // shift + click: select range from last focused to clicked row
	
	        from = args.grid.getActiveCell();
	        to = args.grid.getCellFromEvent(e);
	        if (to && args.grid.canCellBeActive(to.row, to.cell)) {
	            from = from || to;
	
	            from = from.row;
	            to = to.row;
	            dir = (from < to) ? 1 : -1;
	            for (i = from; (dir > 0 && i <= to) || (dir < 0 && i >= to); i += dir) {
	                item = dataView.getItem(i);
	                id = item[idField];
	                if (isDataItem(item)) {
	                    // we care only items itself - not group or total rows
	                    this.selectedIds[id] = true;
	                }
	            }
	
	            this.syncSelectedRows();
	            this.onSelectedIdsChange.notify({ ids: this.selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);
	
	            args.grid.gotoCell(to, 0);
	            args.grid.focus();
	        }
	
	        // we don't want to allow slick grid to select anything
	        e.stopImmediatePropagation();
	    }
	
	    if (item && item.__group) {
	
	        if ($(e.target).hasClass(this.options.toggleCssClass)) {
	            if (e.ctrlKey || e.metaKey) { // ctrl+click or cmd+click
	                this.toggleAllGroups(item);
	            } else {
	                this.toggleGroup(item);
	            }
	        } else if ($(e.target).hasClass(this.options.checkboxCssClass)) {
	            this.toggleRowSelection(args.row);
	        }
	
	        e.stopImmediatePropagation();
	        args.grid.gotoCell(args.row, 0);
	    } else if (!e.shiftKey && args.grid.getColumns()[args.cell].id === this.options.columnId) { // clicking on a row select checkbox
	        this.toggleRowSelection(args.row);
	
	        e.stopImmediatePropagation();
	        args.grid.gotoCell(args.row, 0);
	        args.grid.focus();
	    }
	};
	
	
	GroupSelectionPlugin.prototype._onDblClickHandler = function (e, args) {
	    /// <summary>
	    /// Handles dbl click.
	    /// </summary>
	
	    var item = args.grid.getDataItem(args.row);
	    if (item && item.__group) {
	        this.toggleGroup(item);
	
	        // we don't want to select a text dbl-clicked in group row
	        e.preventDefault();
	    }
	};
	
	
	GroupSelectionPlugin.prototype._onHeaderClickHandler = function (e, args) {
	    /// <summary>
	    /// Handles header checkbox click to select/unselect all.
	    /// </summary>
	
	    if (args.column.id === this.options.columnId && $(e.target).is(":checkbox")) {
	        this.selectAll($(e.target).is(":checked"));
	        e.stopImmediatePropagation();
	
	        // reset focus
	        var active = args.grid.getActiveCell();
	        if (active) {
	            args.grid.gotoCell(active.row, 0);
	            args.grid.focus();
	        }
	    }
	};
	
	
	GroupSelectionPlugin.prototype._onRowCountChangedHandler = function () {
	    /// <summary>
	    /// Rerenders grid when rows count is changed.
	    /// </summary>
	
	    this._requiresRender(this._lastFocused);
	
	    // this flag is used in _onRowsChangedHandler to prevent double rendering
	    this.rendered = true;
	};
	
	
	GroupSelectionPlugin.prototype._onRowsChangedHandler = function () {
	    /// <summary>
	    /// Rerenders grid when rows are changed.
	    /// </summary>
	
	    if (this.rendered === true) {
	        delete this.rendered;
	        return;
	    }
	
	    this._requiresRender(this._lastFocused);
	};
	
	
	GroupSelectionPlugin.prototype._requiresRender = function (lastFocused) {
	    /// <summary>
	    /// Render grid restoring last focus and selection
	    /// </summary>
	
	    this.grid.invalidate();
	
	    if (lastFocused) {
	        // make sure also active row now is not one that cannot be active
	        if (lastFocused.itemId) {
	            var row = this.grid.getData().getRowById(lastFocused.itemId);
	            if (row >= 0) {
	                // we need it after sorting and new items array to refocus previously focused item
	                this.grid.gotoCell(row, 0);
	            } else {
	                // if previously focused item was removed due to new items - focus an item at the same position
	                this.grid.gotoCell(lastFocused.row, 0);
	            }
	        }
	    }
	
	    this.syncSelectedRows();
	};
	
	
	GroupSelectionPlugin.prototype._onActiveCellChangedHandler = function (e, args) {
	    /// <summary>
	    /// Handles header checkbox click to select/unselect all.
	    /// </summary>
	
	    var item, selectedIds, idField;
	
	    this._lastFocused = {
	        row: args.row,
	        itemId: this.grid.getData().mapRowsToIds([args.row])[0]
	    };
	
	    // if args.row is undefined, then resetActiveCell() was called programmatically
	    // in this case e don't need to sync selected IDs
	    if (this.multiSelect || args.row === undefined) { return; }
	
	    item = this.grid.getData().getItem(args.row);
	    idField = this.grid.getOptions().idField;
	    selectedIds = {};
	    if (item && !item.__group) {
	        selectedIds[item[idField]] = true;
	        this.selectedIds = selectedIds;
	        this.syncSelectedRows();
	    }
	
	    this.onSelectedIdsChange.notify({ ids: selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);
	};
	
	
	GroupSelectionPlugin.prototype._onContextMenuHandler = function (e, args) {
	    /// <summary>
	    /// Focuses right clicked row.
	    /// </summary>
	
	    var cell = args.grid.getCellFromEvent(e);
	
	    if (args.grid.canCellBeActive(cell.row, cell.cell)) {
	        args.grid.setActiveCell(cell.row, cell.cell);
	    }
	};
	
	
	GroupSelectionPlugin.prototype._onHeaderCellRenderedHandler = function (e, args) {
	    /// <summary>
	    /// Handles rendering of a column header.
	    /// </summary>
	
	    // stop propagation of "drag" event if it's not movable
	    if (args.column.movable === false) {
	        $(args.node).on("drag", function (e) {
	            e.stopImmediatePropagation();
	        });
	    }
	
	    // render filter icon and subscribe to its "click" event
	    if (this.options.renderColumnFilterIcon && args.column.filterable !== false) {
	        var html = args.column.filtered
	                ? "<div class='slick-column-filter'><i class='sprite-filter-16'></i></div>"
	                : "<div class='slick-column-filter'><i class='sprite-smallArrowDown-16'></i></div>",
	            $html = $(html)
	                .on("click", function (event) {
	                    this.onColumnFilterClick.notify({ grid: this.grid, column: args.column }, event, this.grid);
	
	                    event.stopImmediatePropagation();
	                }.bind(this));
	
	        $(args.node)
	            .addClass("slick-header-filter")
	            .attr("title", args.column.toolTip || args.column.name)
	            .append($html);
	    }
	};
	
	module.exports = GroupSelectionPlugin;
	


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	var R = __webpack_require__(7);
	var Rx = __webpack_require__(27);
	
	var DataState = __webpack_require__(378).DataState;
	var disposeObject = __webpack_require__(375).disposeObject;
	var fromKnockoutObservable = __webpack_require__(376).fromKnockoutObservable;
	var GridViewModel = __webpack_require__(414);
	var QueryOrigin = __webpack_require__(378).QueryOrigin;
	var segmentToClasses = __webpack_require__(442).default;
	var stateOfResponse = __webpack_require__(378).stateOfResponse;
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	/**
	 * Default options to be used by the ko-grid.
	 * @type {Object}
	 */
	var defaultGridOptions = {
	    autoHeight: false,
	    disabled: false,
	    forceFitColumns: true,
	    multiSelect: false,
	    sortedColumns: []
	};
	
	
	/**
	 * Default field name for identifier columns.
	 * @type {String}
	 */
	var defaultIdField = "id";
	
	
	/**
	 * Full list of supported ko-grid properties.
	 * @type {Array}
	 */
	var koGridProperties = [
	    "autoHeight",
	    "columns",
	    "disabled",
	    "factories",
	    "focusedItem",
	    "forceFitColumns",
	    "idField",
	    "items",
	    "multiSelect",
	    "scrollTop",
	    "selectedItems",
	    "shortcutActions",
	    "sortedColumns"
	];
	
	
	/**
	 * Translates a 'groups' object from the view model into a
	 * grid-compatible group factory, or null if no 'groups' entry
	 * exists for the given column ID.
	 * @param  {Object} col      The column we are determining grouping for
	 * @param  {Object} gridData The grid data passed by the view model
	 * @return {Object}          A ko-grid group object or null
	 */
	function getGrouping(col, gridData) {
	    var canBeGrouped = gridData.groups ? gridData.groups[col.id] !== undefined : false;
	    return canBeGrouped ? { formatter: "value:group", getter: col.field.toString() + ":default" } : null;
	}
	
	
	/**
	 * Populates the property specified by 'idField' for a list of items.
	 * If missing, uses the 0-based index as an identifier.
	 */
	function convertGridItems(legacyItems, idField) {
	    if (idField === null || idField === undefined) { idField = defaultIdField; }
	
	    return legacyItems.map(function (legacyItem, index) {
	        var item = R.clone(legacyItem);
	        if (!item[idField]) {
	            item[idField] = index.toString();
	        }
	        return item;
	    });
	}
	
	
	/**
	 * Converts picklist grid data into the format expected by ko-grid.
	 * @param  {Object} gridData
	 *      Data from the view model
	 * @param  {Object} options
	 *      Current options from the ko-grid
	 * @return {Object}
	 *      Options to be passed to the ko-grid
	 */
	function convertGridData(gridData, options) {
	    if (!gridData.columns && (!gridData.views || !gridData.views.standard)) {
	        throw new Error("No picklist grid column specification was provided (required).");
	    }
	
	    var gridOptions = R.clone(options);
	
	    // if gridData does not contain a columns attribute
	    // i.e. is not providing ko-grid styled data, then
	    // convert views to usable columns
	    gridOptions.columns = gridData.columns || gridData.views.standard.map(function (legacyColumn) {
	        return {
	            id: legacyColumn.id.toString(),
	            title: legacyColumn.name,
	            field: legacyColumn.field.toString(),
	            group: getGrouping(legacyColumn, gridData) || undefined,
	            sortable: legacyColumn.sortable,
	            width: legacyColumn.width
	        };
	    });
	
	    gridOptions.items = convertGridItems(gridData.items, gridOptions.idField);
	
	    return gridOptions;
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "PicklistFormViewModel" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	/**
	 * Create a new instance of picklist form viewmodel.
	 *
	 * @param {Function} closeForm
	 *      An action that will hide or close the picklist form on screen.
	 */
	function PicklistFormViewModel(closeForm) {
	    if (!(this instanceof PicklistFormViewModel)) { return new PicklistFormViewModel(closeForm); } // if new was not used, force it now
	    if (typeof closeForm !== "function") { throw new Error("No \"closeForm\" (Forms.js close function) was specified or is not referencing a function (required)"); }
	
	    // private
	    this._closeForm = closeForm;
	    this._containerCss = ko.observable(null);
	    this._error = ko.observable(null);
	    this._gridInitialSelection = null;
	    this._gridView = null;
	    this._hiddenSelectedItems = []; // preserves selected items hidden by a filter
	    this._initialDataSubscription = null;
	    this._itemFilter = null;
	    this._name = ko.observable(null);
	    this._options = ko.observable(null);
	    this._searchStreamSubscription = null;
	    this._selectionSubscription = null;
	    this._text = ko.observable(null);
	    this._totalGridItemsCount = ko.pureComputed(this._getTotalGridItemsCount, this);
	
	    // view properties
	    this.canAccept = ko.pureComputed(this._getCanAccept, this);
	    this.createItemVisible = ko.observable(false);
	    this.filter = ko.observable("");
	    this.filterFocused = ko.observable(true);
	    this.grid = new GridViewModel(defaultGridOptions, { defaultAction: R.bind(this._onDoubleClickOrEnter, this) });
	    this.openSelectedItemVisible = ko.observable(false);
	    this.previewViewModel = ko.observable(null);
	    this.previewTemplateId = ko.observable(this._emptyTemplateId);
	    this.previewTemplateId.subscribe(this._previewCleanupGuard, this);
	    this.searchStream = null;
	    this.selectionInfo = ko.pureComputed(this._getSelectionInfo, this);
	    this.state = ko.observable(null);
	
	    // public functions
	    this.resolveContainerCssWithState = segmentToClasses.bind(null, this.state, this._containerCss, "withState");
	}
	
	
	/**
	 * Accept currently selected value and notify result receiver with this selected value.
	 * Then unsubscribe from data provider and close/hide the form on screen (using action specified in ctor).
	 */
	PicklistFormViewModel.prototype.accept = function acceptPicklist() {
	    if (this.canAccept.peek()) {
	        var selectedItems = this.getSelectedRowsAsItems();
	        if (selectedItems && (this.grid.options.peek().multiSelect || selectedItems.length)) {
	            this._closeAndNotifyResultReceiver(selectedItems);
	        }
	    }
	
	    return false;
	};
	
	
	/**
	 * Cancel this picklist by unsubscribing from data provider and closing/hiding the form on screen.
	 * Uses action specified in ctor.
	 */
	PicklistFormViewModel.prototype.cancel = function cancelPicklist() {
	    // careful; we need to notify result receiver
	    // even though we have no result for it
	    // (using special value, "undefined");
	    // this will unblock editing of the underlying
	    // field/observable
	    this._closeAndNotifyResultReceiver();
	    return false;
	};
	
	
	/**
	 * If options.createItem was specified, call it now using the view model instance as "this".
	 */
	PicklistFormViewModel.prototype.createItem = function createItemForPicklist() {
	    var createItem = this._options().createItem;
	    if (typeof createItem === "function" && this.state().indexOf("data.") === 0) {
	        createItem.call(this);
	    }
	    return false;
	};
	
	
	/**
	 * Get all selected grid items.
	 *
	 * @return {Object[]}
	 *      The items currently selected in the grid, including those hidden by a filter.
	 */
	PicklistFormViewModel.prototype.getSelectedRowsAsItems = function getSelectedPicklistRowsAsItems() {
	    if (this.grid.options.peek().multiSelect) {
	        var items = this.grid.selectedItems() || [];
	        return items.concat(this._hiddenSelectedItems);
	    }
	
	    var focusedItem = this.grid.focusedItem();
	    return focusedItem ? [focusedItem] : [];
	};
	
	
	/**
	 * If options.openSelectedItem was specified call it now.
	 * @this {PicklistFormViewModel} Viewmodel instance.
	 */
	PicklistFormViewModel.prototype.openSelectedItem = function openSelectedItemForPicklist() {
	    var openSelectedItem = this._options().openSelectedItem;
	    if (typeof openSelectedItem === "function" && this.state().indexOf("data.selected.") === 0) {
	        var selectedItems = this.getSelectedRowsAsItems();
	        openSelectedItem.call(this, selectedItems);
	    }
	    return false;
	};
	
	
	/**
	 * Execute progress action (button that is shown when progress/spinner frame shows an error).
	 * (E.g. when data pull failed or returned data set was empty).
	 * Actual action is dependent on the current state.
	 */
	PicklistFormViewModel.prototype.progressAction = function progressActionForPicklist() {
	    switch (this.state()) {
	    case "load.done.error":
	        if (typeof this._options().data.reload === "function") {
	            this._options().data.reload.apply(this);
	        }
	        break;
	    }
	
	    return false;
	};
	
	
	/**
	 * Reset this viewmodel to a "load.active" state, updating texts as specified by options and unsubscribing from data provider.
	 * Will be called before picklist form is shown on screen.
	 * @param {Object} options
	 * @param {Object} options.dataProvider
	 *      Data provider.
	 * @param {Function} options.value
	 *      Result receiver.
	 */
	PicklistFormViewModel.prototype.reset = function resetPicklist(options) {
	    if (!options) { throw new Error("No \"options\" were specified (required)"); }
	    if (!options.dataProvider || !options.dataProvider.search) { throw new Error("No \"options.dataProvider\" (data provider) was specified or it does not conform to the DataProvider interface (required)"); }
	    if (!options.value || typeof options.value !== "function") { throw new Error("No options.value (result receiver) was specified or it is not an observable/function (required)"); }
	    if (typeof options.itemFilterBuilder === "function") { throw new Error("options.itemFilterBuilder is no longer supported. Use a custom DataProvider implementation to customize filtering."); }
	    if (typeof options.filterBuilder === "function") { throw new Error("options.filterBuilder is no longer supported. Use a custom DataProvider implementation to customize filtering."); }
	    if (options.idField === null || options.idField === undefined) {
	        // will default to 'id' if unspecified. If 'id' does not exist, it will
	        // create a row index-based key since ko-grid requires a unique id column
	        options.idField = defaultIdField;
	    }
	
	    this.previewTemplateId(this._emptyTemplateId);
	    this.openSelectedItemVisible(typeof options.openSelectedItem === "function");
	    this.createItemVisible(typeof options.createItem === "function");
	
	    // initialize preview (if specified in options)
	    if (typeof options.previewInit === "function") {
	        if (this.previewViewModel.peek() !== null) { throw new Error("Preview viewmodel has not been cleaned (by last preview)"); }
	        var previewViewModel = options.previewInit(this);
	        if (!previewViewModel) { throw new Error("ViewModel returned by \"options.previewInit\" must be truthy"); }
	        if (typeof previewViewModel.templateId !== "string") { throw new Error("ViewModel returned by \"options.previewInit\" must contain a string property \"templateId\""); }
	        this.previewViewModel(previewViewModel);
	        this.previewTemplateId(previewViewModel.templateId);
	    }
	
	    var css = (this.previewTemplateId.peek() === this._emptyTemplateId ? null : "picklistPreview");
	    css = (options.hideFilter ? (css ? css.concat(" hideFilter") : "hideFilter") : css);
	    css = (options.containerCss ? (css ? css.concat(" ", options.containerCss) : options.containerCss) : css);
	    this._containerCss(css);
	
	    var text = { };
	    ko.utils.extend(text, this._textDefaults);
	    ko.utils.extend(text, options.text);
	    this._text(text);
	
	    this._hiddenSelectedItems = [];
	    this._gridInitialSelection = options.selectedItems && options.selectedItems.length ? options.selectedItems : [0];
	    this._gridView = options.view;
	
	    this._options(options);
	
	    // initialize grid
	    var gridOptions = R.merge(defaultGridOptions, options);
	
	    // selected items will be updated in _onInitialResponse
	    gridOptions.selectedItems = undefined;
	    gridOptions.focusedItem = null;
	
	    this.grid.apply(R.pick(koGridProperties, gridOptions));
	
	    this.state("load.active");
	
	    this.filter(options.filterValue || "");
	    this.searchStream = this
	        ._createSearchStream(fromKnockoutObservable(this.filter, /* omitInitialValue */ true)) // initial value is already handled by "dataProvider.load"
	        .publish()
	        .refCount(); // reference-counted hot observable (created on 1st subscription, disposed on last unsubscription)
	
	    // subscribe to initial data load
	    var initialRequest = Rx.Observable
	        .of({ filter: options.filterValue })
	        .delay(0, options.dataProvider.scheduler); // defer until the next JavaScript engine tick to ensure ko-grid is rendered when visible
	
	    if (this._initialDataSubscription) { this._initialDataSubscription.unsubscribe(); }
	    this._initialDataSubscription = options.dataProvider
	        .search(initialRequest, QueryOrigin.Initial)
	        .subscribe(this._onInitialResponse.bind(this));
	
	    // subscribe to filter changes
	    if (this._searchStreamSubscription) { this._searchStreamSubscription.unsubscribe(); }
	    this._searchStreamSubscription = this.searchStream
	        .subscribe(this._onFilterResponse.bind(this));
	
	    // subscribe to selection changes
	    if (this._selectionSubscription) { this._selectionSubscription.dispose(); }
	    this._selectionSubscription = this.selectionInfo.subscribe(this._onSelectionInfoChanged, this);
	};
	
	
	/**
	 * Compute visibility flag for progress action (button that is shown when progress/spinner frame shows an error).
	 */
	PicklistFormViewModel.prototype.resolveProgressActionVisible = function resolveProgressActionVisibleForPicklist() {
	    switch (this.state()) {
	    case "load.done.error":
	        return typeof this._options().data.reload === "function";
	    }
	
	    return false;
	};
	
	
	/**
	 * Find text for the specified key in "text()" observable.
	 * If no mapping for key can be found, returns an empty string.
	 *
	 * "text()" observable is expected to be an object containing keys and values as either
	 * strings or functions. To resolve keys mapped to functions, "resolveText" will return value
	 * the mapped function returns. The functions will be called with "this" pointing to
	 * this viewmodel instance.
	 *
	 * Any observables read by either "resolveText" or mapped resolver function will be added
	 * to computed observable dependencies that view binding creates, i.e. if any of those
	 * values changes, resolveText for that key will be called again. If this behaviour is
	 * undesirable, use observable's "peek" method.
	 */
	PicklistFormViewModel.prototype.resolveText = function resolveTextForPicklist(key) {
	    if (key) {
	        var text = this._text();
	        if (text) {
	            var item = text[key];
	            if (item) {
	                if (typeof item === "function") { return item.apply(this); }
	                return item.toString();
	            }
	        }
	    }
	    return "";
	};
	
	
	/**
	 * Close/hide the form on screen, then notify result receiver that picklist form has been
	 * dismissed (either accepting selected value or cancelling).
	 */
	PicklistFormViewModel.prototype._closeAndNotifyResultReceiver = function closePicklistFormAndNotifyResultReceiver(result) {
	    if (this._selectionSubscription) {
	        this._selectionSubscription.dispose();
	        this._selectionSubscription = null;
	    }
	    if (this._initialDataSubscription) {
	        this._initialDataSubscription.unsubscribe();
	        this._initialDataSubscription = null;
	    }
	    if (this._searchStreamSubscription) {
	        this._searchStreamSubscription.unsubscribe();
	        this._searchStreamSubscription = null;
	        this.filter("");
	    }
	    this.previewTemplateId(this._emptyTemplateId);
	
	    // To resolve an issue with usage of multi depth pick list dialogs
	    // Issue arises when setting the value of a picklist of a picklist
	    // When "_closeForm()" is executed the previous pick list form state
	    // is loaded thus when setting the value afterwards, it sets the
	    // value in the wrong field.
	    // This solution keeps a reference to the correct field then setting
	    // the value after closing the form
	    var resultReceiver = this._options.peek().value;
	
	    this._closeForm();
	
	    // careful; result receiver must be notified after
	    // the form has closed (on screen, by Forms.js)
	    // because the update of the picklist value
	    // could trigger hash change, which is
	    // not allowed by Forms.js
	    resultReceiver(result);
	};
	
	
	/**
	 * Creates a search result stream from the filter value stream.
	 * @param {Rx.Observable} requestStream
	 *      Observable stream containing user filter requests.
	 * @return {Rx.Observable}
	 *      Search result stream.
	 */
	PicklistFormViewModel.prototype._createSearchStream = function createSearchStream(requestStream) {
	    var viewModel = this;
	    var dataProvider = this._options().dataProvider;
	
	    return dataProvider.search(
	        requestStream.map(function createRequest(filter) {
	            var options = viewModel._options();
	
	            // populate 'currentValue' based on currently focused item
	            // or the initial selection; only practical for single-select
	            // as this may be used to ensure the results that are returned
	            // contain the provided value
	            var currentValue = null;
	            if (!options.multiSelect) {
	                var focusedItem = viewModel.grid.focusedItem();
	                if (focusedItem) {
	                    currentValue = focusedItem[options.idField];
	                } else if (viewModel._gridInitialSelection && typeof viewModel._gridInitialSelection[0] === "object") {
	                    currentValue = viewModel._gridInitialSelection[0][options.idField];
	                }
	            }
	
	            return { filter: filter, currentValue: currentValue };
	        }),
	        QueryOrigin.Grid,
	        {
	            debounceTime: this._options().filterDebounceTimeout
	        }
	    );
	};
	
	
	/**
	 * ID of empty template element (doesn't have any content, used when picklist form is opened without preview template).
	 * @type {String}
	 */
	PicklistFormViewModel.prototype._emptyTemplateId = "picklistFormEmptyTemplate";
	
	
	/**
	 * Gets a value indicating whether the current form can be accepted.
	 * @return {boolean} True if the form can be accepted, false otherwise.
	 */
	PicklistFormViewModel.prototype._getCanAccept = function getPicklistCanAccept() {
	    return (this.grid.options().multiSelect
	        ? this.state().indexOf("data.") === 0
	        : this.state().indexOf("data.selected.") === 0);
	};
	
	
	/**
	 * Implements the selectionInfo interface by retrieving the values from the underlying grid.
	 * @return {Object} SelectionInfo values
	 */
	PicklistFormViewModel.prototype._getSelectionInfo = function getPicklistSelectionInfo() {
	    // capture selected rows so that any
	    // dependent observables are tracked
	    var selectedRows = this.getSelectedRowsAsItems();
	    return {
	        get: R.always(selectedRows),
	        count: selectedRows.length
	    };
	};
	
	
	/**
	 * Gets the total number of grid items.
	 */
	PicklistFormViewModel.prototype._getTotalGridItemsCount = function getTotalGridItemsCount() {
	    var items = this.grid ? this.grid.items() : [];
	    return items ? items.length : 0;
	};
	
	
	/**
	 * On double click or enter accept the current values selected in the grid.
	 * Special case for multi select: On double click select the focused item before accepting.
	 * @param  {Object} data
	 *      Row Selected
	 * @param  {Object} mouseEvent
	 *      Coordinates where the mouse double clicked
	 */
	/*jslint unparam: true */ // needed because 'data' is unused below
	PicklistFormViewModel.prototype._onDoubleClickOrEnter = function onPicklistGridDoubleClickOrEnter(data, mouseEvent) {
	    // double click for multi select has to add the selection to selections before accept
	    var multiSelect = this.grid.options.peek().multiSelect;
	    if (multiSelect && mouseEvent) {
	        var focusedItem = this.grid.focusedItem();
	        var selectedItems = this.grid.selectedItems();
	        var newSelectedItems = selectedItems.indexOf(focusedItem) > -1 ? selectedItems : selectedItems.concat([focusedItem]);
	        this.grid.apply({ selectedItems: newSelectedItems });
	    }
	
	    this.accept();
	};
	/*jslint unparam: false */
	
	
	/**
	 * Filter grid items and preserve selections hidden by new search term.
	 * @param dataResult
	 *      Grid results matching new search filter.
	 */
	PicklistFormViewModel.prototype._onFilterResponse = function onPicklistFilterResponse(dataResult) {
	    var resultState = stateOfResponse(dataResult);
	    if (resultState === DataState.Error) {
	        this._error(dataResult.error);
	        this.state("load.done.error");
	    } else if (resultState === DataState.Ready) {
	        // filter items and reapply to grid
	        var idField = this._options.peek().idField;
	        var filteredItems = convertGridItems(dataResult.data.items, idField);
	        var currentFocusedItem = this.grid.focusedItem.peek();
	        var gridOptions = {
	            items: filteredItems,
	            // if no row has focus after filter, focus the first row
	            focusedItem: R.contains(currentFocusedItem, filteredItems)
	                ? currentFocusedItem
	                : filteredItems[0]
	        };
	
	        // preserve selected items (by idField) that may be hidden by the current filter
	        if (this.grid.options.peek().multiSelect) {
	            var selectedItems = this.getSelectedRowsAsItems();
	            var hiddenSelectedItems = R.differenceWith(R.eqProps(idField), selectedItems, filteredItems);
	            var newSelectedItems = R.intersectionWith(R.eqProps(idField), selectedItems, filteredItems);
	
	            gridOptions.selectedItems = newSelectedItems;
	            this._hiddenSelectedItems = hiddenSelectedItems;
	        }
	
	        // indicate the load operation completed
	        // this must happen *before* applying grid options to avoid slickgrid rendering glitches
	        this.state("data.available");
	
	        this.grid.apply(gridOptions);
	
	        // ensure filter input retains focus after the grid refreshes itself
	        this.filterFocused(true);
	    }
	};
	
	
	/**
	 * Handle initial data results by updating "gridData" and state.
	 */
	PicklistFormViewModel.prototype._onInitialResponse = function onPicklistInitialResponse(dataResult) {
	    // Now update actual grid data
	    this._name((dataResult && dataResult.name) || "value");
	
	    var error = (dataResult && typeof dataResult === "object"
	        ? dataResult.error
	        : "Internal error (missing data provider value)");
	
	    var state = "load.active";
	    var value = null;
	    var resultState = stateOfResponse(dataResult);
	    if (resultState === DataState.Ready) {
	        value = dataResult.data;
	        if (value) {
	            if (typeof value !== "object" || !value.items) {
	                error = "Internal error (invalid data provider value)";
	            }
	        }
	    }
	
	    if (error) {
	        this._error(error);
	        state = "load.done.error";
	    }
	
	    this.state(state);
	
	    if (value) {
	        // apply custom view and convert grid data to a format that the ko-grid can accept
	        var options = convertGridData(
	            this._gridView ? R.merge(value, { views: { standard: this._gridView } }) : value,
	            this.grid.options.peek()
	        );
	
	        // set selected item(s) appropriately
	        options.selectedItems = [];
	        if (this._gridInitialSelection && this._gridInitialSelection.length > 0) {
	            if (typeof this._gridInitialSelection[0] === "number") {
	                options.focusedItem = options.items[this._gridInitialSelection[0]];
	            } else if (!options.multiSelect) {
	                options.focusedItem = convertGridItems(this._gridInitialSelection, options.idField)[0];
	            } else {
	                options.focusedItem = convertGridItems(this._gridInitialSelection, options.idField)[0];
	                options.selectedItems = convertGridItems(this._gridInitialSelection, options.idField);
	            }
	            this._gridInitialSelection = null;
	        } else {
	            // try to preserve previous selections based on their id
	            // because other values may have changed
	            var oldSelectedIds = R.pluck(options.idField, this.getSelectedRowsAsItems());
	            var newSelectedItems = R.filter(function (item) {
	                return R.contains(item[options.idField], oldSelectedIds);
	            }, options.items);
	
	            if (options.multiSelect) {
	                options.selectedItems = newSelectedItems;
	            }
	            if (newSelectedItems.length > 0) {
	                options.focusedItem = newSelectedItems[0];
	            }
	        }
	
	        // indicate the load operation completed
	        // this must happen *before* applying grid options to avoid slickgrid rendering glitches
	        this.state("data.available");
	
	        this.grid.apply(options);
	
	        this.filterFocused(true); // focus must be *after* grid.apply
	    }
	};
	
	
	/**
	 * React to ko-grid selection changes by updating state if needed ("data.available" vs. "data.selected.one" vs "data.selected.many").
	 */
	PicklistFormViewModel.prototype._onSelectionInfoChanged = function onPicklistSelectionInfoChanged(selectionInfo) {
	    var selectionsCount = selectionInfo.count;
	    if (this.state.peek().indexOf("data.") === 0) {
	        this.state(selectionsCount > 0
	            ? selectionsCount === 1 ? "data.selected.one" : "data.selected.many"
	            : "data.available");
	    }
	};
	
	
	/**
	 * Make sure that every time "previewTemplateId" observable is reset we dispose and reset "previewViewModel" to null (if defined).
	 */
	PicklistFormViewModel.prototype._previewCleanupGuard = function picklistPreviewCleanupGuard(previewTemplateIdValue) {
	    var previewViewModel = this.previewViewModel.peek();
	    if (previewViewModel !== null && previewTemplateIdValue === this._emptyTemplateId) {
	        disposeObject(previewViewModel, true); // force-dispose (include "function" containers, i.e. "extras")
	        this.previewViewModel(null);
	    }
	};
	
	
	/**
	 * Define default texts and labels (can be overridden in options.text).
	 */
	PicklistFormViewModel.prototype._textDefaults = {
	    icon: "sprite-pickList-16",
	    title: function () {
	        var title = "Select " + this._name();
	        var totalGridItems = this._totalGridItemsCount();
	        return totalGridItems !== null
	            ? title + " (" + totalGridItems + ")"
	            : title;
	    },
	    subtitle: function () {
	        return (this._options().multiSelect
	            ? "Select one or more items from the grid. Then click the \"Accept\" button"
	            : "Select an item from the grid. Then click the \"Accept\" button");
	    },
	    filterPlaceholder: "Search...",
	    createItemButton: "New",
	    openSelectedItemButton: "Open selected",
	    acceptButton: function () {
	        var selectionsCount = this.selectionInfo().count;
	        return (this._options().multiSelect && selectionsCount > 0
	            ? "Accept (" + selectionsCount + ")"
	            : "Accept");
	    },
	    cancelButton: "Cancel",
	    progressTitle: function () {
	        switch (this.state()) {
	        case "load.done.error":
	            return "Load failed";
	        default:
	            return "Loading...";
	        }
	    },
	    progressSubtitle: function () {
	        switch (this.state()) {
	        case "load.done.error":
	            return this._error() || "(No details)";
	        default:
	            return "Please wait";
	        }
	    },
	    progressActionButton: "Try again"
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = PicklistFormViewModel;
	


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var string_1 = __webpack_require__(13);
	/**
	 * Converts a period-segmented string into a list of CSS classes.
	 *
	 * @param {string|KnockoutObservable<string>} segments
	 *     A string or observable containing the segments to be converted.
	 * @param {string|KnockoutObservable<string>} currentCss
	 *     The current CSS class string. If provided, will be prefixed to the result.
	 * @param {string = ""} prefix
	 *     The prefix to use for each resulting CSS class.
	 * @return {string}
	 *     A space-separated list of classes representing the given segments.
	 *
	 * @example
	 *     stateToCss("good.right", "myClass", "wifState") -> "myClass wifStateGood wifStateRight"
	 */
	function segmentToClasses(segments, currentCss, prefix) {
	    if (prefix === void 0) { prefix = ""; }
	    var cssItems = [];
	    for (var _i = 0, _a = (ko.unwrap(segments) || "").split("."); _i < _a.length; _i++) {
	        var stateItem = _a[_i];
	        if (!string_1.isNullOrWhitespace(stateItem)) {
	            cssItems.push("" + prefix + stateItem[0].toUpperCase() + stateItem.substring(1));
	        }
	    }
	    var cssString = cssItems.join(" ");
	    var currentCssValue = ko.unwrap(currentCss);
	    return (!string_1.isNullOrWhitespace(currentCssValue) ? currentCssValue + " " + cssString : cssString);
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = segmentToClasses;
	;
	



/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true, unparam: true */
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var $ = __webpack_require__(1);
	var setFieldDisabledUpdater = __webpack_require__(402).setFieldDisabledUpdater;
	var setFieldFocusRegistrator = __webpack_require__(403).setFieldFocusRegistrator;
	var setFieldFocusUpdater = __webpack_require__(403).setFieldFocusUpdater;
	var setFieldReadonlyUpdater = __webpack_require__(404).setFieldReadonlyUpdater;
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// The "pliMultiselect" binding
	// The binding that goes with the multiselect behaviour
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function bindSpanToObservable($spanControl, observable) {
	    var updatingFilter = false;
	    $spanControl.bind('blur keyup paste copy cut mouseup', function () {
	        updatingFilter = true;
	        observable($spanControl.text());
	        updatingFilter = false;
	    });
	    observable.subscribe(function (text) {
	        if (!updatingFilter) {
	            $spanControl.text(text);
	        }
	    });
	}
	
	//-------------------------------------------
	function toggleContentEditableAndDisable(element, disabled) {
	    $(element).find("[contenteditable]").attr("contenteditable", !disabled);
	    ko.utils.toggleDomNodeCssClass(element.parentNode.parentNode, "disabled", disabled);
	}
	
	//-------------------------------------------
	function toggleContentEditableAndReadOnly() {
	    throw new Error("Readonly binding is not supported for multiselect controls");
	}
	
	//-------------------------------------------
	ko.bindingHandlers.pliMultiselect = {
	    init: function (element, valueAccessor) {
	        var value = valueAccessor(),
	            $element = $(element),
	            $control,
	            $dropdown,
	            data = {
	                $errorText: $element.find("b.withError"),
	                $p: $element.closest("p, li, div.pliControl"),
	                msViewModel: value.multiSelectViewModel,
	                observable: value
	            };
	
	        if (element.tagName.toUpperCase() !== "SPAN") {
	            throw new Error("pliMultiselect binding may only be applied to SPAN elements");
	        }
	
	        if (!ko.isWriteableObservable(value)) {
	            throw new Error("Target of pliMultiselect binding must be a writeable observable");
	        }
	
	        if (!value.multiSelectViewModel || typeof value.multiSelectViewModel !== "object") {
	            throw new Error("pliMultiselect binding requires target ko.observablePliTextBox instance to use multiSelect behaviour");
	        }
	
	        var placeholder = ((value.behaviourData && value.behaviourData.placeholder)
	            || $element.attr('data-placeholder')
	            || $element.attr('placeholder'));
	
	        if (placeholder) {
	            value.multiSelectViewModel._setPlaceholder(placeholder);
	        }
	
	        // empty old items
	        $element.empty();
	
	        // create items
	        $control = $(ko.bindingHandlers.pliMultiselect.templates.control);
	        $element.append($control);
	        ko.applyBindings(value.multiSelectViewModel, $control[0]);
	
	        // set control to viewModel
	        value.multiSelectViewModel.$container($control);
	
	        // add progress and failure CSS classes based on picklist data state
	        value.state.subscribe(function (state) {
	            data.$p.toggleClass("withProgress", state.isBusy)
	                .toggleClass("withFailure", state.isFailed);
	        });
	
	        // Append the error text DOM element if not available
	        if (!data.$errorText.length) {
	            data.$errorText = $("<b class=\"withError\"></b>");
	            data.$p.append(data.$errorText);
	        }
	
	        // enable picklist icon to open dialog
	        $element.parent().on("mousedown", ">i", function pliMultiselectIconClick() {
	            value.multiSelectViewModel.showDialog();
	        });
	
	        // bind editable span to filter on viewmodel
	        data.$input = $control.find(".ms-input");
	        bindSpanToObservable(data.$input, value.multiSelectViewModel.filter);
	
	        setFieldFocusRegistrator(element, function (handleElementFocusIn, handleElementFocusOut) {
	            var inputSpan = data.$input[0];
	            ko.utils.registerEventHandler(inputSpan, "focus", handleElementFocusIn);
	            ko.utils.registerEventHandler(inputSpan, "focusin", handleElementFocusIn); // for IE
	            ko.utils.registerEventHandler(inputSpan, "blur", handleElementFocusOut);
	            ko.utils.registerEventHandler(inputSpan, "focusout", handleElementFocusOut); // for IE
	        });
	
	        setFieldFocusUpdater(element, function (focusToSet) {
	            data.msViewModel.isFocused(focusToSet);
	        });
	
	        // add dropdown to the bottom of the page, to use with absolute positioning
	        $dropdown = $(ko.bindingHandlers.pliMultiselect.templates.dropdownContainer);
	        $("body").append($dropdown);
	        ko.applyBindings(value.multiSelectViewModel, $dropdown[0]);
	
	        // wrap dropdown with "skipBindings"
	        $dropdown.wrap($(ko.bindingHandlers.pliMultiselect.templates.skipBindings));
	
	        // attach data to element
	        $element.data("data", data);
	
	        // shim controller until multiselect is refactored to use "pliTextBox" binding
	        value._controllers.push({
	            updateView: function () {
	                data.$errorText.text(value._errorMessage || "");
	                if (value._errorMessage) {
	                    data.$p.addClass("withError");
	                } else {
	                    data.$p.removeClass("withError");
	                }
	            },
	            _applyChanges: function () {
	                // _applyChanges required to avoid NPE
	                return; // lint
	            }
	        });
	
	        setFieldDisabledUpdater(element, toggleContentEditableAndDisable);
	        setFieldReadonlyUpdater(element, toggleContentEditableAndReadOnly);
	
	        return { controlsDescendantBindings: true };
	    },
	    update: function (element, valueAccessor) {
	        var $element = $(element),
	            data = $element.data("data"),
	            o = valueAccessor(),
	            stateObservable = o.state;
	
	        // detect changes of the bound observable and update the multiselect view model
	        if (data.observable !== o) {
	            data.observable = o;
	            // temporary disable updates to the bound observable to update mutliSelect view model selected items
	            data.msViewModel.callback = null;
	            data.msViewModel.setSelectedItemsFromArray(o.peek() || []);
	            // set the multiSelect view model callback to the currently bound observable selected items update handler
	            data.msViewModel.callback = o._updateValues;
	        }
	
	        // need to revalidate observables because valueAccessor result could have changed
	        if (!ko.isObservable(stateObservable)) {
	            throw new Error("target of data-binding must have state observable");
	        }
	
	        // Ensure state trigger update
	        var state = stateObservable();
	
	        // re-format error text and error state
	        data.$errorText.text(state.message || "");
	        data.$p.toggleClass("withError", !state.isValid);
	    }
	};
	
	//-------------------------------------------
	ko.bindingHandlers.pliMultiselect.templates = {
	    control:  "<span class='ms-container' data-bind='event: { click: openList, mousedown: focus }, css: { focused: isFocused }'>" +
	                "<!-- ko foreach: selectedItems -->" +
	                    "<span unselectable='on' class='ms-item' data-bind='css: { \"ms-error\": isError, \"ms-category\": isCategory, \"ms-selected\": $root.isCurrentItem($data)}, attr: {id: \"item_\" + index}, event: {click: $root.setCurrentItem } '>" +
	                        "<span unselectable='on' class='ms-text' data-bind='text: text'></span>" +
	                        "<i unselectable='on' class='sprite-smallX-16' data-bind='event: {mousedown: $root.unSelectItem}'></i>" +
	                    "</span>" +
	                "<!-- /ko -->" +
	                // placeholder
	                "<!-- ko if: placeholder && selectedItems && selectedItems().length === 0 && !isFocused() -->" +
	                    "<span class='ms-placeholder' data-bind='text: placeholder'></span>" +
	                "<!-- /ko -->" +
	                // text box
	                "<span class='ms-input' contenteditable='true' data-bind='hasfocus: isFocused, event: { keydown: handleKeyDown, keyup: handleKeyUp, blur: removeFocus }, attr: { contenteditable: isEnabled() }'></span>" +
	              "</span>",
	    dropdownContainer: "<div unselectable='on' class='ms-dropdown-container' data-bind='multiSelectVisibleAnchor: {visible: isListOpen, anchor: $container, width: _options.dropdownWidth }, " +
	                            "multiSelectScrollTop: scrollTop, virtualScroll: { items: filteredItems, size: _options.listItemHeight, " +
	                                "containerTemplate: ko.bindingHandlers.pliMultiselect.templates.dropdown, " +
	                                "itemTemplate: ko.bindingHandlers.pliMultiselect.templates.dropdownItem }," +
	                             "style: {height: listHeight() + \"px\"}' ></div>",
	    // dropdown list template
	    dropdown:   "<ul unselectable='on' class='ms-dropdown'></ul>",
	
	    dropdownItem: "".concat(
	        "<li data-bind='",
	        "click: $root.selectItem.bind($data, $data),",
	        "event: { mouseover: $root.setCurrentListItem.bind(null, $data), mousedown: function() { return false; } },",
	        "css: { category: $data.isCategory, selected: $root.isCurrentListItem($data) },",
	        "value: $data.value'><div data-bind='text: $data.text, style: { lineHeight: $root._options.listItemHeight + \"px\" }'></div></li>"
	    ),
	
	    // div, to mark dropdown list as not allow further bindings
	    skipBindings: "<div data-bind='stopBinding: true'></div>"
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// The "multiSelectScrollTop" binding
	// Two way binding of the scroll top property
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	ko.bindingHandlers.multiSelectScrollTop = {
	    init: function (element, valueAccessor) {
	        var value = valueAccessor(),
	            $element = $(element),
	            timer = 0,
	            delay = 50, //you can tweak this value
	
	            handler = function () {
	                timer = 0;
	                value($element.scrollTop());
	            };
	
	        // on element scroll - update scrollTop value
	        $element.scroll(function () {
	            if (timer) {
	                window.clearTimeout(timer);
	                timer = 0;
	            }
	            timer = setTimeout(handler, delay);
	        });
	    },
	    update: function (element, valueAccessor) {
	        var value = valueAccessor();
	        $(element).scrollTop(ko.utils.unwrapObservable(value));
	    }
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	//  The "multiSelectVisibleAnchor" binding
	//  Shows element at the bottom/top of the anchor element
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	ko.bindingHandlers.multiSelectVisibleAnchor = {
	    init: function (element, valueAccessor) {
	        // if window resized - force update of visibility
	        $(window).resize(function () {
	            var value = ko.utils.unwrapObservable(valueAccessor);
	            value().visible.valueHasMutated();
	        });
	    },
	    update: function (element, valueAccessor) {
	        var viewModel = valueAccessor(),
	            $window = $(window),
	            $element = $(element),
	            isVisible = ko.utils.unwrapObservable(viewModel.visible),
	            anchorElement = ko.utils.unwrapObservable(viewModel.anchor),
	            anchorElementOffset = anchorElement.offset(),
	            anchorElementHeight = anchorElement.outerHeight(false),
	            dropTop = anchorElementOffset.top + anchorElementHeight,
	            dropHeight = $element.outerHeight(false),
	            dropLeft = anchorElementOffset.left,
	            viewportBottom = $window.scrollTop() + $window.height(),
	            width = ko.utils.unwrapObservable(viewModel.width) || (anchorElement.outerWidth() - 2), // fix css border size - 2 px
	            enoughRoomBelow = dropTop + dropHeight <= viewportBottom;
	        if (isVisible) {
	            if (!enoughRoomBelow) {
	                dropTop = anchorElementOffset.top - dropHeight;
	            }
	
	            $element.css({
	                top: dropTop + "px",
	                left : dropLeft + "px",
	                width: width
	            });
	            $element.show();
	        } else {
	            $element.hide();
	        }
	    }
	};
	


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint unparam: true */
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var $ = __webpack_require__(1);
	
	
	// this logic was copied from knockout.js
	function createKoBindingContext(dataItem, parentBindingContext, dataItemAlias) {
	    var context = {};
	
	    if (parentBindingContext) {
	        ko.utils.extend(context, parentBindingContext); // Inherit $root and any custom properties
	        context.$parentContext = parentBindingContext;
	        context.$parent = parentBindingContext.$data;
	        context.$parents = (parentBindingContext.$parents || []).slice(0);
	        context.$parents.unshift(context.$parent);
	    } else {
	        context.$parents = [];
	        context.$root = dataItem;
	        context.ko = ko;
	    }
	    context.$data = dataItem;
	    if (dataItemAlias) {
	        context[dataItemAlias] = dataItem;
	    }
	
	    return context;
	}
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	//  The "VirtualScrollViewModel" class
	//  Implements logic of virtual scrolling
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function VirtualScrollViewModel(items, viewport, content, rowHeight, itemTemplate, rootBindingContext) {
	
	    // save initial values
	    this.$viewport = viewport;
	    this.$content = content;
	    this.itemTemplate = itemTemplate;
	    this.rootBindingContext = rootBindingContext;
	    this.rowHeight = rowHeight;                     // row height
	    this.viewportHeight = viewport.height();        // viewport height
	
	
	    this._virtualHeight = 0;          // virtual height
	    this._realHeight = 0;             // real scrollable height
	    this._pageHeight = 0;             // page height
	    this._pagesNumber = 0;            // number of pages
	    this._jumpCoef = 0;               // "jumpiness" coefficient
	    this._page = 0;                   // current page
	    this._offset = 0;                 // current page offset
	    this._prevScrollTop = 0;          // prvious value of scrollTop
	    this.rows = {};                   // cached row nodes
	
	    this.updateItems(items);
	
	    // add event handler
	    this.$viewport.scroll(this.onScroll.bind(this));
	    // trigger to render initial
	    this.$viewport.trigger("scroll");
	}
	
	//-------------------------------------------
	VirtualScrollViewModel.prototype.onScroll = function virtualScrollViewModelOnScroll() {
	    var scrollTop = this.$viewport.scrollTop();
	    if (Math.abs(scrollTop - this._prevScrollTop) > this.viewportHeight) {
	        this.onJump();
	    } else {
	        this.onNearScroll();
	    }
	
	    this.renderViewport();
	};
	
	//-------------------------------------------
	VirtualScrollViewModel.prototype.updateItems = function virtualScrollViewModelUpdateItems(newItems) {
	    this.items = newItems;
	
	    this._virtualHeight = this.items.length * this.rowHeight;
	    this._realHeight = this.items.length * this.rowHeight;
	    // change these numbers to make scroll to work good in all browsers
	    var pageSmooth = newItems.length < 20 ? 1 : (newItems.length > 500 ? 100 : 10);
	    this._pageHeight = this._realHeight / pageSmooth;
	    this._pagesNumber = Math.ceil(this._virtualHeight / this._pageHeight);
	    this._jumpCoef = (this._virtualHeight - this._realHeight) / (this._pagesNumber - 1);
	
	    this.resetScroll();
	};
	
	//-------------------------------------------
	VirtualScrollViewModel.prototype.resetScroll = function () {
	    this._page = 0;
	    this._offset = 0;
	    this._prevScrollTop = 0;
	
	    this.removeAllRows();
	
	    this.$viewport.css("height", this.viewportHeight);
	    this.$content.css("height", this._realHeight);
	
	    this.onScroll();
	};
	
	//-------------------------------------------
	VirtualScrollViewModel.prototype.onNearScroll = function virtualScrollViewModelOnNearScroll() {
	    var scrollTop = this.$viewport.scrollTop();
	
	    // next page
	    if (scrollTop + this._offset > (this._page + 1) * this._pageHeight) {
	        this._page += 1;
	        this._offset = Math.round(this._page * this._jumpCoef);
	        this._prevScrollTop = scrollTop - this._jumpCoef;
	        this.$viewport.scrollTop(this._prevScrollTop);
	        this.removeAllRows();
	    } else if (scrollTop + this._offset < this._page * this._pageHeight) {
	        // prev page
	        this._page -= 1;
	        this._offset = Math.round(this._page * this._jumpCoef);
	        this._prevScrollTop = scrollTop + this._jumpCoef;
	        this.$viewport.scrollTop(this._prevScrollTop);
	        this.removeAllRows();
	    } else {
	        this._prevScrollTop = scrollTop;
	    }
	};
	
	//-------------------------------------------
	VirtualScrollViewModel.prototype.onJump = function virtualScrollViewModelOnJump() {
	    var scrollTop = this.$viewport.scrollTop();
	
	    this._page = Math.floor(scrollTop * ((this._virtualHeight - this.viewportHeight) / (this._realHeight - this.viewportHeight)) * (1 / this._pageHeight));
	    this._offset = Math.round(this._page * this._jumpCoef);
	    this._prevScrollTop = scrollTop;
	
	    this.removeAllRows();
	};
	
	//-------------------------------------------
	VirtualScrollViewModel.prototype.removeAllRows = function virtualScrollViewModelRemoveAllRows() {
	    var prop;
	    for (prop in this.rows) {
	        if (this.rows.hasOwnProperty(prop)) {
	            this.rows[prop].remove();
	            delete this.rows[prop];
	        }
	    }
	};
	
	//-------------------------------------------
	VirtualScrollViewModel.prototype.renderViewport = function virtualScrollViewModelRenderViewport() {
	    // calculate the viewport + buffer
	    var i,
	        item,
	        y = this.$viewport.scrollTop() + this._offset,
	        buffer = this.viewportHeight,
	        top = Math.floor((y - buffer) / this.rowHeight),
	        bottom = Math.ceil((y + this.viewportHeight + buffer) / this.rowHeight);
	
	    top = Math.max(0, top);
	    bottom = Math.min(this._virtualHeight / this.rowHeight, bottom);
	
	    // remove rows no longer in the viewport
	    for (i in this.rows) {
	        if (this.rows.hasOwnProperty(i)) {
	            if (i < top || i > bottom) {
	                this.rows[i].remove();
	                delete this.rows[i];
	            }
	        }
	    }
	
	    // add new rows
	    for (i = top; i <= bottom; i += 1) {
	        if (!this.rows[i]) {
	            item = this.renderRow(i);
	            if (item) {
	                this.rows[i] = item;
	            }
	        }
	    }
	};
	
	//-------------------------------------------
	VirtualScrollViewModel.prototype.renderRow = function virtualScrollViewModelRenderRow(rowNumber) {
	
	    if (!this.items[rowNumber]) {
	        return null;
	    }
	
	    var bindingContext,
	        item = $(this.itemTemplate);
	
	    // append item to DOM
	    this.$content.append(item);
	
	    // create binding context
	    bindingContext = createKoBindingContext(this.items[rowNumber], this.rootBindingContext);
	
	    // apply binding
	    ko.applyBindings(bindingContext, item[0]);
	    item.css({
	        top: rowNumber * this.rowHeight - this._offset
	    });
	
	    return item;
	};
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	//  The "virtualScroll" binding
	//  Adds virtual scrolling behavior to list of elements
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = {
	    init: function virtualScrollBindingInit(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
	
	        var value = valueAccessor(),
	            vm = ko.utils.unwrapObservable(value),
	            virtualScroll,
	            containerTemplate = ko.utils.unwrapObservable(vm.containerTemplate),
	            itemTemplate = ko.utils.unwrapObservable(vm.itemTemplate),
	            $content = $(containerTemplate);
	
	        $(element).append($content);
	
	        virtualScroll = new VirtualScrollViewModel(ko.utils.unwrapObservable(vm.items),
	                                $(element), $content, ko.utils.unwrapObservable(vm.size),
	                                itemTemplate, bindingContext);
	
	        // store virtualScroll object
	        ko.utils.domData.set(element, "virtualScroll", virtualScroll);
	
	        return { controlsDescendantBindings: true };
	    },
	
	    update: function virtualScrollBindingUpdate(element, valueAccessor) {
	        var value = valueAccessor(),
	            vm = ko.utils.unwrapObservable(value),
	            virtualScroll = ko.utils.domData.get(element, "virtualScroll"); // re-store virtualScroll object
	
	        virtualScroll.updateItems(ko.utils.unwrapObservable(vm.items));
	    }
	};
	


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true, todo: true, unparam: true */
	
	"use strict";
	
	// TODO: Extract jquery-dependent code
	var ko = __webpack_require__(9);
	var R = __webpack_require__(7);
	var Rx = __webpack_require__(27);
	
	var pliObservable = __webpack_require__(15);
	var pli = __webpack_require__(380);
	var subscribeWithChanges = __webpack_require__(446).subscribeWithChanges;
	
	var jQuery = __webpack_require__(1);
	var arrayUtil = __webpack_require__(447);
	var CompositeDisposable = __webpack_require__(375).CompositeDisposable;
	var createKnockoutDataProvider = __webpack_require__(369).createKnockoutDataProvider;
	var QueryOrigin = __webpack_require__(378).QueryOrigin;
	
	
	function ensureElementInView(element) {
	    if (!element) {
	        return;
	    }
	
	    if (element instanceof jQuery) {
	        element.each(function () {
	            ensureElementInView(this);
	        });
	        return;
	    }
	
	    if (typeof element.scrollIntoViewIfNeeded === "function") {
	        element.scrollIntoViewIfNeeded(false);
	        return;
	    }
	
	    var elementRectangle = element.getBoundingClientRect(),
	        container = element.parentNode,
	        containerRectangle = container.getBoundingClientRect();
	
	    while (elementRectangle.top > containerRectangle.top &&
	            elementRectangle.bottom < containerRectangle.bottom &&
	            container.parentNode &&
	            container.scrollHeight > 0) {
	        container = container.parentNode;
	        containerRectangle = container.getBoundingClientRect();
	    }
	
	    if (container.scrollHeight > 0 &&
	            (elementRectangle.top < containerRectangle.top || elementRectangle.bottom > containerRectangle.bottom)) {
	        element.scrollIntoView(elementRectangle.top < containerRectangle.top);
	    }
	}
	
	/**
	 * Sets correct group lengths for supplied picklist data.
	 *
	 * Does not modify original picklist data.
	 *
	 * @returns
	 *     Cloned picklist data with updated group lengths.
	 * @this {ko.MaybeObservable<{ data: any, name: string }>}
	 */
	function transformPicklistData() {
	    var picklistData = ko.unwrap(this); // jshint ignore:line
	
	    if (picklistData.data) {
	
	        // clone
	        var group, i, j, item, newItems = [],
	            data = R.clone(picklistData.data); // deep clone (recursive)
	
	        // clear length of all groups
	        for (group in data.groups) {
	            if (data.groups.hasOwnProperty(group)) {
	                for (i = 0; i < data.groups[group].length; i += 1) {
	                    data.groups[group][i].length = 0;
	                }
	            }
	        }
	
	        // transform data items
	        for (i = 0; i < data.items.length; i += 1) {
	            item = data.items[i];
	            // add new item
	            newItems.push(item);
	
	            // fix group length
	            for (group in data.groups) {
	                if (data.groups.hasOwnProperty(group)) {
	                    for (j = 0; j < data.groups[group].length; j += 1) {
	                        if (item[group] === data.groups[group][j].name) {
	                            data.groups[group][j].length += 1;
	                        }
	                    }
	                }
	            }
	
	        }
	
	        // set filterd items and indices
	        data.items = newItems;
	
	        return { data: data, name: picklistData.name };
	    }
	
	    return picklistData;
	}
	
	function getDataProvider(o) {
	    var d = o.behaviourData;
	    if (d) {
	        if (typeof d.requestHandler === "function") {
	            throw new Error("Multiselect does not support async data");
	        }
	
	        var options = {
	            displayIndex: o.options.textField,
	            searchIndex: o.options.textField,
	            itemFilterBuilder: o.options.itemFilterBuilder
	        };
	        var source = null;
	
	        if (d.subscribe) { // check for the subscribe function instead of ko.isObservable (to handle cross window observables)
	            source = d;
	        } else if (d.picklistData && d.picklistData.subscribe) {
	            source = d.picklistData;
	        } else if (d.picklistData.picklistData && d.picklistData.picklistData.subscribe) {
	            source = d.picklistData.picklistData;
	        }
	
	        if (source) {
	            return createKnockoutDataProvider(ko.pureComputed(transformPicklistData, source), options);
	        }
	    }
	    throw new Error("behaviourData or behaviourData.picklistData must contain an observable containing picklist data");
	}
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Convenience method to create elements of the multiSelect list
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function createMultiSelectItem(value, text, categoryValue, isCategory, isError, isSelected, index) {
	    return {
	        value: value,
	        text: text,
	        categoryValue: categoryValue,
	        isCategory: !!isCategory,
	        isError: !!isError,
	        isSelected: !!isSelected,
	        index: index
	    };
	}
	
	/**
	 * Wrap the function in conditional call to bypass it if the control is disabled or readonly.
	 */
	function inactiveExecutionGuard(functionToExecute, msVm) {
	    if (typeof functionToExecute !== "function") { throw new Error("functionToExecute must be a function"); }
	    return function createOnActiveRunner() {
	        var isEnabled = msVm.isEnabled();
	        if (isEnabled) {
	            return functionToExecute.apply(msVm, arguments);
	        }
	    };
	}
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// The "MultiSelectViewModel" main viewModel of MultiselectBehaviour
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function MultiSelectViewModel(items, categories, options, parent) {
	    this._options = options || {};
	
	    this.items = items || [];
	    this.categories = categories || [];
	
	    this.categoriesAndItems = this.categories.concat(this.items);
	    this.selectedItems = ko.observableArray([]); // selected items
	    this.currentItem = ko.observable(); // current selected item
	    this.currentListItemIndex = ko.observable(-1); // current list item in dropdown list
	    this.filter = ko.observable(""); // current filter
	    this.isFocused = ko.observable(false); // is focused
	    this.isListOpen = ko.observable(false); // shows if dropdown list is open
	    this.scrollTop = ko.observable(0); // dropdown scroll top
	    this.$container = ko.observable(); // container element
	    this.placeholder = null;
	
	    // Dummy observable, used to refresh computed values after update
	    // calling _refreshSignaller.notifySubscribers(); does the trick
	    this._refreshSignaller = ko.observable();
	
	    //-------------------------------------------
	    // computed and subscriptions
	    this.allSelectedItems = ko.computed(MultiSelectViewModel.prototype._allSelectedItems, this);
	    this.notSelectedItems = ko.computed(MultiSelectViewModel.prototype._notSelectedItems, this);
	    this.filteredItems = ko.computed(MultiSelectViewModel.prototype._filteredItems, this);
	    this.hasError = ko.computed(MultiSelectViewModel.prototype._hasError, this);
	    this.filteredItems.subscribe(MultiSelectViewModel.prototype._filteredItemsUpdateHandler, this);
	    this.currentItem.subscribe(MultiSelectViewModel.prototype._scrollToCurrentItem, this);
	    this.currentListItemIndex.subscribe(MultiSelectViewModel.prototype.updateScrollTop, this); // updates scrolling position on change current item in dropdown list
	    this.isFocused.subscribe(MultiSelectViewModel.prototype._focusedUpdateHandler, this);
	    subscribeWithChanges.call(this.selectedItems, MultiSelectViewModel.prototype._selectedItemsUpdateHandler.bind(this));
	    this.listSize = ko.computed(MultiSelectViewModel.prototype._listSize, this);
	    this.listHeight = ko.computed(MultiSelectViewModel.prototype._listHeight, this);
	    this.filter.subscribe(MultiSelectViewModel.prototype._filterUpdateHandler, this);
	
	    // bind this
	    this.updateItemsAndCategories = MultiSelectViewModel.prototype.updateItemsAndCategories.bind(this);
	    this.unSelectItem = inactiveExecutionGuard(MultiSelectViewModel.prototype.unSelectItem, this);
	    this.selectItem = inactiveExecutionGuard(MultiSelectViewModel.prototype.selectItem, this);
	    this.isCurrentItem = MultiSelectViewModel.prototype.isCurrentItem.bind(this);
	    this.isCurrentListItem = MultiSelectViewModel.prototype.isCurrentListItem.bind(this);
	    this.setCurrentItem = inactiveExecutionGuard(MultiSelectViewModel.prototype.setCurrentItem, this);
	    this.setCurrentListItem = inactiveExecutionGuard(MultiSelectViewModel.prototype.setCurrentListItem, this);
	    this.openList = inactiveExecutionGuard(MultiSelectViewModel.prototype.openList, this);
	    this.selectItemsFromDialog = MultiSelectViewModel.prototype.selectItemsFromDialog.bind(this);
	    this.focus = inactiveExecutionGuard(MultiSelectViewModel.prototype.focus, this);
	    this.removeFocus = MultiSelectViewModel.prototype.removeFocus.bind(this);
	    this.showDialog = inactiveExecutionGuard(MultiSelectViewModel.prototype.showDialog, this);
	    this.handleKeyUp = inactiveExecutionGuard(MultiSelectViewModel.prototype.handleKeyUp, this);
	    this.handleKeyDown = inactiveExecutionGuard(MultiSelectViewModel.prototype.handleKeyDown, this);
	
	    // parent (to handle selected items update)
	    if (parent) {
	
	        // set default values from parent observable values (before setting callback to prevent updating parent observable)
	        var parentValue = parent.peek();
	
	        if (Array.isArray(parentValue) && parentValue.length) {
	            this.setSelectedItemsFromArray(parentValue);
	        }
	
	        // set callback function
	        if (typeof parent._updateValues === "function") {
	            this.callback = parent._updateValues;
	        }
	
	        // set data provider
	        this.dataProvider = parent._dataProvider;
	
	        // copy reference to parent state
	        this.state = parent.state || ko.observable({ isValid: true, isBusy: false, isFailed: false, message: null });
	
	        // close list if state is not valid
	        this.state.subscribe(function (newStateValue) {
	            if (newStateValue.isFailed || newStateValue.isBusy || !newStateValue.isValid) {
	                this.closeList();
	            }
	        }, this);
	    }
	}
	
	/**
	 * Returns true when this multiselect control is enabled, false otherwise.
	 */
	MultiSelectViewModel.prototype.isEnabled = function isEnabled() {
	    var $container = this.$container();
	    return !($container && $container.closest(".pliControl").is(".readOnly, .disabled"));
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._allSelectedItems = function multiSelectViewModelAllSelectedItems() {
	    /// <summary>
	    ///     All selected items
	    /// </summary>
	    this._refreshSignaller(); // add to dependencies of this computed (notifying _refreshSignaller will recompute it)
	
	    return ko.utils.arrayFilter(this.categoriesAndItems, function (item) {
	        return !item.isCategory && item.isSelected;
	    });
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._notSelectedItems = function multiSelectViewModelNotSelectedItems() {
	    /// <summary>
	    ///     Not selected items
	    /// </summary>
	    this._refreshSignaller(); // add to dependencies of this computed (notifying _refreshSignaller will recompute it)
	
	    return ko.utils.arrayFilter(this.categoriesAndItems, function (item) {
	        return !item.isSelected;
	    });
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._filteredItems = function multiSelectViewModelFilteredItems() {
	    /// <summary>
	    ///     Not-selected items, filtered by text in input element
	    /// </summary>
	    if (!this.filter() || this.filter().length === 0) {
	        return this.notSelectedItems();
	    }
	
	    var filter = this.filter().toLowerCase();
	    return ko.utils.arrayFilter(this.notSelectedItems(), function (item) {
	        return ko.utils.stringStartsWith(item.text.toLowerCase(), filter);
	    });
	};
	
	 //-------------------------------------------
	MultiSelectViewModel.prototype._filteredItemsUpdateHandler = function multiSelectViewModelFilteredItemsUpdateHandler(filteredItems) {
	    /// <summary>
	    ///     Closes dropdown list if there is no any filtered item left
	    /// </summary>
	
	    // if no itmes left in dropdwon list - close it
	    if (filteredItems.length === 0) {
	        this.closeList();
	        return;
	    }
	
	    // if current dropdown list item index is in filteredItems
	    if (this.currentListItemIndex() > filteredItems.length - 1) {
	        this.currentListItemIndex(0);
	    }
	
	    // re-open list when there are filtered items
	    if (!this.isListOpen() && this.filter() && this.filter().length > 0 && filteredItems.length > 0) {
	        this.openList();
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._focusedUpdateHandler = function multiSelectViewModelFocusedUpdateHandler(newValue) {
	    /// <summary>
	    ///     When focus on control with error, gets it ready to editing
	    /// </summary>
	    if (newValue && this.hasError()) {
	        var item = this.selectedItems()[this.selectedItems().length - 1],
	            errorText = item.text,
	            isFirefox = window.InstallTrigger !== undefined;
	        this.unSelectItem(item);
	        this.filter(errorText);
	        // move selection to end of span
	        setTimeout(function () {
	            var sel, range;
	            if (window.getSelection) {
	                sel = window.getSelection();
	                if (isFirefox) {
	                    sel.selectAllChildren(sel.focusNode);
	                    sel.collapseToEnd();
	                } else {
	                    try {
	                        sel.collapse(sel.focusNode, errorText.length);
	                    } catch (ignore) {}
	                }
	            } else if (window.document.selection) {
	                sel = window.document.selection;
	                if (sel.type !== "Control") {
	                    range = sel.createRange();
	                    range.move("character", errorText.length);
	                    range.select();
	                }
	            }
	        }, 0);
	    }
	
	    if (newValue) {
	        // update position of dropdownlist after focus
	        setTimeout(function () {
	            this.updateListPosition();
	        }.bind(this), this._options.updateDropdownPositionAfterFocusDelay);
	    } else {
	        // close list and remove selection, uses setTimeout, because list item click event should occur before dropdown closed
	        setTimeout(function () {
	            // autocomplete
	            this.autoComplete();
	            // close list
	            this.closeListAndUnselect();
	        }.bind(this), this._options.closeListDelay);
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._filterUpdateHandler = function multiSelectViewModelFilterUpdateHandler() {
	    /// <summary>
	    ///     Ensures dropdownlist position would change accordingly
	    /// </summary>
	    if (this.isListOpen()) {
	        // set delay to allow size of input to be changed first
	        setTimeout(function () {
	            this.updateListPosition();
	        }.bind(this), this._options.updateListPositionAfterFilterTextChangedDelay);
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._selectedItemsUpdateHandler = function multiSelectViewModelSelectedItemsUpdateHandler(added, deleted) {
	    /// <summary>
	    ///     Adds/removes categories and ensure parent observable values are changing accordingly
	    /// </summary>
	    var index,
	        categoriesAdded = [],
	        categoryItems,
	        isAllItemsSelected,
	        i;
	
	    if (!this._internalUpdate) {
	        // mark items as unselected first
	        if (deleted && deleted.length > 0) {
	            // remove item from selected and add it to not selected
	            ko.utils.arrayForEach(deleted, function (item) {
	
	                // select current element
	                index = arrayUtil.binarySearch(item.index, this.categoriesAndItems, "index");
	                if (index >= 0) {
	                    this.categoriesAndItems[index].isSelected = false;
	                }
	
	                if (item.isCategory) {
	                    // mark as not-selected all category items
	                    categoryItems = this._getItemsByCategory(item);
	                    for (i = 0; i < categoryItems.length; i += 1) {
	                        index = arrayUtil.binarySearch(categoryItems[i].index, this.categoriesAndItems, "index");
	                        if (index >= 0) {
	                            this.categoriesAndItems[index].isSelected = false;
	                        }
	                    }
	                }
	            }.bind(this));
	        }
	
	        if (added && added.length > 0) {
	            // add item to selected and remove from not selected
	            ko.utils.arrayForEach(added, function (item) {
	
	                // select current element
	                index = arrayUtil.binarySearch(item.index, this.categoriesAndItems, "index");
	                if (index >= 0) {
	                    this.categoriesAndItems[index].isSelected = true;
	                }
	
	                // if selected element is category
	                if (item.isCategory) {
	                    // mark as selected all category items
	                    categoryItems = this._getItemsByCategory(item);
	                    for (i = 0; i < categoryItems.length; i += 1) {
	                        index = arrayUtil.binarySearch(categoryItems[i].index, this.categoriesAndItems, "index");
	                        if (index >= 0) {
	                            this.categoriesAndItems[index].isSelected = true;
	                        }
	                    }
	                }
	            }.bind(this));
	        }
	
	        this._refreshSignaller.notifySubscribers(); // refresh data in allSelectedItems and notSelectedItems lists
	    }
	
	    // if we have at least one category
	    if (this.categories.length > 0) {
	        ko.utils.arrayForEach(added, function (item) {
	            if (item.isCategory) {
	                // if added category - remove all separate items from this category, selected before
	                if (this.selectedItems().length > 0) {
	                    this._internalUpdate = true;
	                    this.selectedItems.remove(function (selectedItem) {
	                        return !selectedItem.isCategory && selectedItem.categoryValue === item.value;
	                    });
	                    this._internalUpdate = false;
	                }
	            } else {
	                // collect unique category values
	                if (item.categoryValue) {
	                    if (ko.utils.arrayIndexOf(categoriesAdded, item.categoryValue) < 0) {
	                        categoriesAdded.push(item.categoryValue);
	                    }
	                }
	            }
	        }.bind(this));
	
	        if (categoriesAdded.length > 0) {
	            // check if all items of the category is selected
	            ko.utils.arrayForEach(categoriesAdded, function (category) {
	                var categoryItem = ko.utils.arrayFirst(this.categories, function (cat) {
	                    return cat.value === category;
	                }.bind(this));
	
	                // if we have such category in the list
	                if (categoryItem) {
	
	                    // get items of the categor
	                    categoryItems = this._getItemsByCategory(categoryItem);
	
	                    // check if all elements are selected
	                    isAllItemsSelected = !(ko.utils.arrayFirst(categoryItems, function (itemOfCategory) {
	                        return !(ko.utils.arrayFirst(this.allSelectedItems(), function (selItem) {
	                            return itemOfCategory.value === selItem.value;
	                        }));
	                    }.bind(this)));
	
	                    if (isAllItemsSelected) {
	                        // remove all items of the category
	                        this.selectedItems.remove(function (selectedItem) {
	                            return !selectedItem.isCategory && selectedItem.categoryValue === category;
	                        });
	                        // add category
	                        this.selectedItems.push(categoryItem);
	                    }
	                }
	            }.bind(this));
	        }
	    }
	
	    // parent obserbale array update
	    if (this.callback) {
	        this.callback(this.allSelectedItems());
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._hasError = function multiSelectViewModelHasError() {
	    /// <summary>
	    ///     Is last selected item has error
	    /// </summary>
	    this._refreshSignaller(); // add to dependencies of this computed (notifying _refreshSignaller will recompute it)
	
	    return this.selectedItems().length > 0 && this.selectedItems()[this.selectedItems().length - 1].isError;
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._listSize = function multiSelectViewModelListSize() {
	    /// <summary>
	    ///     Returns dropdown list size
	    /// </summary>
	    if (this.filteredItems().length === 0) {
	        return 0;
	    }
	    var size = this.filteredItems().length;
	    return size > this._options.maxListSize ? this._options.maxListSize : size;
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._listHeight = function multiSelectViewModelListHeight() {
	    /// <summary>
	    ///     Returns height of dropdown list
	    /// </summary>
	    return this.listSize() * this._options.listItemHeight;
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._setPlaceholder = function setPlaceholder(placeholder) {
	    if (ko.isObservable(placeholder)) {
	        this.placeholder = placeholder;
	    } else if (typeof placeholder === 'function') {
	        this.placeholder = ko.observable(placeholder());
	    } else {
	        this.placeholder = ko.observable(placeholder);
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.updateItemsAndCategories = function multiSelectViewModelUpdateItemsAndCategories(items, categories) {
	    /// <summary>
	    ///     Updates lists of items and categories after picklist data update
	    /// </summary>
	    this.items = items || [];
	    this.categories = categories || [];
	
	    this.categoriesAndItems = this.categories.concat(this.items);
	
	    // notify everything of the changes
	    this._refreshSignaller.notifySubscribers();
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.unSelectItem = function multiSelectViewModelUnSelectItem(element, event) {
	    /// <summary>
	    ///     Removes element from selected list
	    /// </summary>
	
	    // if clicked not left mouse button
	    if (event && event.which !== 1) {
	        return;
	    }
	
	    if (this.isCurrentItem(element)) {
	        this.currentItem(null); // clear current item
	    }
	    this.selectedItems.remove(element);
	
	    // close list
	    this.closeList();
	
	    // when click on delete button - do not propagate event
	    if (event) {
	        event.stopPropagation();
	        event.preventDefault();
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.selectItem = function multiSelectViewModelSelectItem(element) {
	    /// <summary>
	    ///     Adds element to selection
	    /// </summary>
	    this.selectedItems.push(element);
	    // remove filter
	    this.filter("");
	    // close list
	    this.closeList();
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.isCurrentItem = function multiSelectViewModelIsCurrentItem(element) {
	    /// <summary>
	    ///     Shows if specific element is set as current in selected
	    /// </summary>
	    if (!this.currentItem()) {
	        return false;
	    }
	
	    return element === this.currentItem();
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.isCurrentListItem = function multiSelectViewModelIsCurrentListItem(element) {
	    /// <summary>
	    ///     Shows if specific element is set as current in list
	    /// </summary>
	    if (this.currentListItemIndex() < 0) {
	        return false;
	    }
	
	    return element === this.filteredItems()[this.currentListItemIndex()];
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.setCurrentItem = function multiSelectViewModelSetCurrentItem(value, event) {
	    /// <summary>
	    ///     Sets current item
	    /// </summary>
	    this.currentItem(value);
	    if (event) {
	        event.stopPropagation();
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.setNextCurrentItem = function multiSelectViewModelSetNextCurrentItem() {
	    /// <summary>
	    ///     Sets current next element in selected list
	    /// </summary>
	    if ((this.filter() && this.filter().length > 0) || !this.selectedItems() || this.selectedItems().length === 0) {
	        return;
	    }
	
	    if (this.currentItem()) { // if there is selection
	        var index = ko.utils.arrayIndexOf(this.selectedItems(), this.currentItem());
	        if (index > -1) {
	            if (index < this.selectedItems().length - 1) { // if there are elements to the right
	                this.currentItem(this.selectedItems()[index + 1]); // set next element current
	            } else {
	                this.currentItem(null); // otherwise - remove selection
	                this._scrollToInput();
	            }
	        }
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.setPreviousCurrentItem = function multiSelectViewModelSetPreviousCurrentItem() {
	    /// <summary>
	    ///     Sets current previous element in selected list
	    /// </summary>
	    if (this.filter().length > 0 || !this.selectedItems() || this.selectedItems().length === 0) {
	        return;
	    }
	
	    if (this.currentItem()) { // if there is selection
	        var index = ko.utils.arrayIndexOf(this.selectedItems(), this.currentItem()); // select
	        if (index > 0) { // there are items to the left
	            this.currentItem(this.selectedItems()[index - 1]);
	        }
	    } else {
	        this.currentItem(this.selectedItems()[this.selectedItems().length - 1]); // select last element
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._scrollToCurrentItem = function multiSelectViewModelScrollToCurrentItem(currentItem) {
	    /// <summary>
	    ///     Scrolls the current item into view if it is not in view
	    /// </summary>
	    if (currentItem) {
	        ensureElementInView(this.$container().find('#item_' + currentItem.index));
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._scrollToInput = function multiSelectViewModelScrollToInput() {
	    /// <summary>
	    ///     Scrolls the input span into view if it is not in view
	    /// </summary>
	    ensureElementInView(this.$container().find('.ms-input'));
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.setCurrentListItem = function multiSelectViewModelSetCurrentListItem(item) {
	    /// <summary>
	    ///     Sets current element in dropdown list
	    /// </summary>
	
	    if ((this._keypressed || 0) !== 0) {
	        return;
	    }
	
	    if (this.filteredItems().length === 0 || !this.isListOpen()) {
	        return;
	    }
	
	    var itemIndex = ko.utils.arrayIndexOf(this.filteredItems(), item);
	    if (itemIndex >= 0) {
	        this.currentListItemIndex(itemIndex); // set next element as current
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.setNextCurrentListItem = function multiSelectViewModelSetNextCurrentListItem() {
	    /// <summary>
	    ///     Sets next current element in dropdown list
	    /// </summary>
	    var count = this.filteredItems().length,
	        currentIndex = this.currentListItemIndex();
	
	    if (count === 0) {
	        return;
	    }
	
	    if (!this.isListOpen()) {
	        this.openList();
	    } else {
	        if (currentIndex < count - 1) { // if there are elements left below
	            this.currentListItemIndex(currentIndex + 1); // set next element as current
	        }
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.setNextPageCurrentListItem = function multiSelectViewModelSetNextPageCurrentListItem() {
	    /// <summary>
	    ///     Sets next N element as current element in dropdown list
	    /// </summary>
	    var count = this.filteredItems().length,
	        currentIndex = this.currentListItemIndex();
	
	    if (count === 0 || !this.isListOpen()) {
	        return;
	    }
	
	    currentIndex = count - 1 < currentIndex + this._options.maxListSize ? count - 1 : currentIndex + this._options.maxListSize;
	    this.currentListItemIndex(currentIndex); // set next page element as current
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.setPreviousPageCurrentListItem = function multiSelectViewModelSetPreviousPageCurrentListItem() {
	    /// <summary>
	    ///     Sets previous N element as current element in dropdown list
	    /// </summary>
	    var count = this.filteredItems().length,
	        currentIndex = this.currentListItemIndex();
	
	    if (count === 0 || !this.isListOpen()) {
	        return;
	    }
	
	    currentIndex = currentIndex - this._options.maxListSize < 0 ? 0 : currentIndex - this._options.maxListSize;
	    this.currentListItemIndex(currentIndex); // set next page element as current
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.setPreviousCurrentListItem = function multiSelectViewModelSetPreviousCurrentListItem() {
	    /// <summary>
	    ///     Sets previous current element in dropdown list
	    /// </summary>
	    var count = this.filteredItems().length,
	        currentIndex = this.currentListItemIndex();
	
	    if (count === 0) {
	        return;
	    }
	
	    if (currentIndex > 0) { // if there are elements above
	        this.currentListItemIndex(currentIndex - 1); // set next element current
	    } else {
	        this.closeList();
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.openList = function multiSelectViewModelOpenList() {
	    /// <summary>
	    ///     Opens dropdown list with items
	    /// </summary>
	    if (!this.state().isFailed && !this.state().isBusy && !this.isListOpen() && this.filteredItems().length > 0) {
	        this.isListOpen(true);
	
	        // select first element
	        this.currentListItemIndex(0);
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.closeList = function multiSelectViewModelCloseList() {
	    /// <summary>
	    ///     Closes dropdown list with items
	    /// </summary>
	    if (this.isListOpen()) {
	        this.isListOpen(false);
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.closeListAndUnselect = function multiSelectViewModelCloseListAndUnselect() {
	    /// <summary>
	    ///     Closes dropdown list with items  and unselects current
	    /// </summary>
	    this.closeList();
	    this.currentItem(null);
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.selectCurrentListItem = function multiSelectViewModelSelectCurrentListItem() {
	    /// <summary>
	    ///     Adds current item from dropdown list to selection
	    /// </summary>
	    if (this.isListOpen() && this.currentListItemIndex() >= 0) {
	        this.selectItem(this.filteredItems()[this.currentListItemIndex()]);
	        this.currentListItemIndex(-1);
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.removeLastSelectedElementIfEmptyFilter = function multiSelectViewModelRemoveLastSelectedElementIfEmptyFilter() {
	    /// <summary>
	    ///     Removes element, that is last in the list of selected items
	    /// </summary>
	    if (!this.selectedItems() || this.selectedItems().length === 0) {
	        return;
	    }
	
	    if (!this.filter() || this.filter().length === 0) { // remove element only if filter is empty
	        this.unSelectItem(this.selectedItems()[this.selectedItems().length - 1]);
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._getItemsByCategory = function multiSelectViewModelGetItemsByCategory(category) {
	    /// <summary>
	    ///     Gets all items from the list, that have same category
	    /// </summary>
	    return ko.utils.arrayFilter(this.items, function (item) {
	        return item.categoryValue === category.value;
	    });
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype._getItemByValue = function multiSelectViewModelGetItemByValue(value) {
	    /// <summary>
	    ///     Gets element from the list by value, case insensitive
	    /// </summary>
	    if (!value || value.length === 0) {
	        return null;
	    }
	    value = value.toLowerCase();
	    return ko.utils.arrayFirst(this.items, function (item) {
	        return item.value && value === item.value.toLowerCase();
	    });
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.setSelectedItemsFromArray = function multiSelectViewModelSetSelectedItemsFromArray(selectItemsArray) {
	    /// <summary>
	    ///     Marks items from array as selected
	    ///     Plain array of element values is expected
	    /// </summary>
	    var selectedItems = [];
	    ko.utils.arrayForEach(selectItemsArray, function (selItem) {
	        if (selItem) {
	            var found = this._getItemByValue(selItem);
	
	            if (found) {
	                selectedItems.push(found);
	            }
	        }
	    }.bind(this));
	
	    this.selectedItems(selectedItems);
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.selectItemsFromDialog = function multiSelectViewModelSelectItemsFromDialog(picklistValues) {
	    /// <summary>
	    ///     Selects items from pickList form dialog
	    /// </summary>
	    var found, selectedItems = [],
	        errorItem = this.hasError() && this.selectedItems()[this.selectedItems().length - 1];
	
	    if (picklistValues) {
	        if (errorItem) {
	            this.unSelectItem(errorItem);
	        }
	
	        if (Array.isArray(picklistValues) && picklistValues.length === 0) {
	            // no results
	            this.selectedItems(selectedItems);
	        } else if (Array.isArray(picklistValues) && picklistValues.length > 0 &&
	                (Array.isArray(picklistValues[0]) || typeof picklistValues[0] === "object")) {
	
	            // multiple results
	            ko.utils.arrayForEach(picklistValues, function (item) {
	                found = this._getItemByValue(item[this._options.dataField]);
	                if (found) {
	                    selectedItems.push(found);
	                }
	            }.bind(this));
	
	            this.selectedItems(selectedItems);
	        } else {
	            // on element selected
	            found = this._getItemByValue(picklistValues[this._options.dataField]);
	            if (found) {
	                this.selectItem(found);
	            }
	        }
	
	        if (errorItem) {
	            this.selectItem(errorItem);
	        }
	
	        // focus element after dialog is closed
	        this.focus();
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.focus = function multiSelectViewModelFocus(sender, event) {
	    /// <summary>
	    ///     Sets focus on element
	    /// </summary>
	    var targetClassname = event && (event.target || event.srcElement).className;
	
	    // if clicked not left mouse button
	    if (event && event.which !== 1) {
	        return false;
	    }
	
	    this.isFocused(true);
	
	    // If an item was not selected, scroll so the input box is in view
	    if (targetClassname !== "ms-text" && targetClassname !== "ms-item") {
	        this._scrollToInput();
	    }
	
	    // allow clicks through to reposition the cursor
	    if (targetClassname === "ms-input") {
	        return true;
	    }
	
	    return false;
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.removeFocus = function multiSelectViewModelRemoveFocus() {
	    /// <summary>
	    ///     Removes focus from element
	    /// </summary>
	    this.isFocused(false);
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.updateScrollTop = function multiSelectViewModelUpdateScrollTop() {
	    /// <summary>
	    ///     Changes scrolling position, depends on current selected item from in dropdown list
	    /// </summary>
	    var currentItemPosition = this.currentListItemIndex(), // current item position
	        top = this.scrollTop() / this._options.listItemHeight, // top position
	        bottom = top + this._options.maxListSize - 1; // bottom position
	
	    if (currentItemPosition > bottom) {
	        this.scrollTop((top + (currentItemPosition - bottom)) * this._options.listItemHeight);
	    }
	
	    if (currentItemPosition < top) {
	        this.scrollTop(currentItemPosition * this._options.listItemHeight);
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.showDialog = function multiSelectViewModelShowDialog(sender, event) {
	    /// <summary>
	    ///     Shows pli form dialog
	    /// </summary>
	    this.closeList();
	
	    var idField = this._options.dataField;
	    pli.forms.registry.picklistForm.open({
	        dataProvider: this.dataProvider,
	        filterValue: null,
	        value: this.selectItemsFromDialog,
	        multiSelect: true,
	        idField: idField,
	        selectedItems: R.map(
	            R.pipe(
	                R.prop("value"), // extract 'value'
	                R.partialRight(R.flip(R.assoc), [idField, {}]) // create new object { [idField]: value }
	            ),
	            this.allSelectedItems.peek()
	        ),
	        view: this._options.view || null,
	        text: this._options.text || null
	    });
	
	    if (event) {
	        event.stopPropagation();
	    }
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.autoComplete = function multiSelectViewModelAutoComplete() {
	    /// <summary>
	    ///     Autocompletes filter value or adds error item
	    /// </summary>
	    var item, result = false;
	
	    // if filter is not empty
	    if (this.filter().length > 0) {
	
	        //  only one element left
	        if (this.filteredItems().length === 1) {
	            item = this.filteredItems()[0];
	            result = true;
	        }
	
	        // if item was not found - add error item instead
	        item = item || createMultiSelectItem(null, this.filter(), null, false, true, false, this.categoriesAndItems.length);
	
	        // select found item or item with error
	        this.selectItem(item);
	    }
	    return result;
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.handleKeyUp = function multiSelectViewModelHandleKeyUp() {
	    /// <summary>
	    ///     Handles keyup event
	    /// </summary>
	    this._keypressed = false;
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.handleKeyDown = function multiSelectViewModelHandleKeyDown(sender, event) {
	    /// <summary>
	    ///     Handles keydown event
	    /// </summary>
	    switch (event.which) {
	    // up arrow
	    case 38:
	        this.setPreviousCurrentListItem();
	        this._keypressed = true;
	        event.preventDefault();
	        break;
	    // down arrow
	    case 40:
	        this.setNextCurrentListItem();
	        this._keypressed = true;
	        event.preventDefault();
	        break;
	    // home
	    case 36:
	        this.currentItem(this.selectedItems()[0]);
	        event.stopPropagation();
	        event.preventDefault();
	        break;
	    // end
	    case 35:
	        this.currentItem(null);
	        break;
	    // left arrow
	    case 37:
	        this.setPreviousCurrentItem();
	        event.preventDefault();
	        break;
	    // right arrow
	    case 39:
	        this.setNextCurrentItem();
	        event.preventDefault();
	        break;
	    // delete
	    case 46:
	        if (this.currentItem()) {
	            var itemToDelete = this.currentItem();
	            this.setNextCurrentItem();
	            this.unSelectItem(itemToDelete);
	            event.stopPropagation();
	            event.preventDefault();
	        }
	        break;
	    // Escape
	    case 27:
	        this.closeListAndUnselect();
	        break;
	    // Enter
	    case 13:
	        this.selectCurrentListItem();
	        event.preventDefault();
	        break;
	    // Backspace
	    case 8:
	        this.removeLastSelectedElementIfEmptyFilter();
	        break;
	    // tab
	    case 9:
	        if (!event.shiftKey && this.filter().length > 0) {
	            if (this.autoComplete()) {
	                event.preventDefault();
	            }
	        }
	        break;
	    // pagedown
	    case 34:
	        this.setNextPageCurrentListItem();
	        this._keypressed = true;
	        break;
	    // pageup
	    case 33:
	        this.setPreviousPageCurrentListItem();
	        this._keypressed = true;
	        break;
	    // F3
	    case 114:
	        this.showDialog();
	        break;
	    }
	    return true;
	};
	
	//-------------------------------------------
	MultiSelectViewModel.prototype.updateListPosition = function multiSelectViewModelUpdateListPosition() {
	    /// <summary>
	    ///     Updates dropdown list position
	    /// </summary>
	    this.isListOpen.valueHasMutated();
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "MultiselectBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Behaviour for a multi-select pick-list.
	function MultiselectBehaviour() {
	    this.defer = true;
	}
	
	//-------------------------------------------
	MultiselectBehaviour.prototype.dispose = function picklistBehaviourDispose() {
	    if (this._disposables) {
	        this._disposables.dispose();
	    }
	};
	
	//-------------------------------------------
	MultiselectBehaviour.prototype.init = function picklistBehaviourInit() {
	    // state is not defined by observablePliTextBox any more, bring it back until multiselect is refactored to use "pliTextBox" binding
	    this.state = ko.observable({
	        isBusy: false,
	        isFailed: false,
	        isValid: true,
	        message: null
	    });
	
	    // options
	    this.options = R.merge({
	        textField: 0,       // name or number of the field, used to show text of the item
	        dataField: 0,       // name or number of the field, used to unique identify the item
	        category: null,     // name of the group of the pickList, used to create categories
	        maxListSize: 8,     // number of elements in the dropdown list
	        listItemHeight: 22, // height of the one item in the dropdown list
	        initialCategories: null, // initial categories
	        dropdownWidth: null, // dropdown width, if null equals the with of the input
	        // delays
	        updateDropdownPositionAfterFocusDelay : 160,
	        closeListDelay : 150,
	        updateListPositionAfterFilterTextChangedDelay : 10
	
	    }, this.behaviourData || {});
	
	    // internal update values
	    this._updateValues = MultiselectBehaviour.prototype._updateValues.bind(this);
	
	    this._dataProvider = getDataProvider(this);
	
	    // "multiSelectViewModel" must be initialized for
	    // pliMultiselect "init" binding to succeed; "items"
	    // and "categories" will be updated when the data from
	    // the data-provider is available
	    this.multiSelectViewModel = new MultiSelectViewModel(
	        [], // items
	        [], // categories
	        this.options,
	        this
	    );
	
	    this._disposables = new CompositeDisposable(
	        this._dataProvider,
	        // subscribe to data provider changes
	        this._dataProvider.search(Rx.Observable.of({}), QueryOrigin.Initial).subscribe(MultiselectBehaviour.prototype._onDataChanged.bind(this)),
	        // subscribe to main observable changes
	        this.subscribe(MultiselectBehaviour.prototype._onObservableChanged, this)
	    );
	};
	
	//-------------------------------------------
	MultiselectBehaviour.prototype.validate = function multiselectBehaviourValidate() {
	    return (this.multiSelectViewModel && !this.multiSelectViewModel.hasError()
	        ? null
	        : MultiselectBehaviour.prototype._getErrorMessage);
	};
	
	//-------------------------------------------
	MultiselectBehaviour.prototype._getErrorMessage = pliObservable.shared.createGetErrorMessage("errorInvalidValue", "Invalid value");
	
	//-------------------------------------------
	// Parses data from pickList observable.
	//
	// Expects "this" to be a observable array.
	MultiselectBehaviour.prototype._parseData = function multiselectBehaviourParseData(pickListData) {
	    var o = this,
	        i,
	        item,
	        categories = [],
	        items = [],
	        text,
	        value,
	        groupValue,
	        categoriesItems;
	
	    if (pickListData.data) {
	        if (o.options.category && o.options.category.length && pickListData.data.groups[o.options.category]) {
	            for (i = 0; i < pickListData.data.groups[o.options.category].length; i += 1) {
	                item = pickListData.data.groups[o.options.category][i];
	                value = item.name === "(Empty)" ? null : item.name;
	                categories.push(createMultiSelectItem(value, item.name, null, true, false, false, (pickListData.data.groups[o.options.category].length - i) * -1));
	            }
	        }
	
	        // parse items
	        for (i = 0; i < pickListData.data.items.length; i += 1) {
	            item = pickListData.data.items[i];
	            text = item[o.options.textField];
	            value = item[o.options.dataField];
	            groupValue = null;
	
	            // get item category
	            if (o.options.category && o.options.category.length) {
	                groupValue = item[o.options.category];
	            }
	
	            items.push(createMultiSelectItem(value, text, groupValue, false, false, false, i));
	        }
	    }
	
	    // child view model
	    if (!o.multiSelectViewModel) {
	        o.multiSelectViewModel = new MultiSelectViewModel(items, categories, o.options, o);
	    } else {
	        o.multiSelectViewModel.updateItemsAndCategories(items, categories);
	    }
	
	    // set initial categories
	    if (categories.length > 0 && Array.isArray(o.options.initialCategories) && o.options.initialCategories.length > 0) {
	        categoriesItems = ko.utils.arrayFilter(categories, function (category) {
	            return ko.utils.arrayIndexOf(o.options.initialCategories, category.value) >= 0;
	        });
	        o.multiSelectViewModel.selectedItems.push.apply(o.multiSelectViewModel.selectedItems, categoriesItems);
	    }
	};
	
	//-------------------------------------------
	// Handle update of the root observable.
	// Updates child viewModel selectedItems
	//
	// Expects "this" to be picklist observable.
	MultiselectBehaviour.prototype._onObservableChanged = function multiselectBehaviourOnObservableChanged(values) {
	    var o = this;
	    if (o._isChildViewUpdate) {
	        return;
	    }
	
	    if (values === null) { values = []; }
	    if (!Array.isArray(values)) { throw new Error("Multiselect observable value can only be an array or null"); }
	    o.multiSelectViewModel.setSelectedItemsFromArray(values); // update values of child viewModel
	};
	
	//-------------------------------------------
	// Handle update of the selectedItems of
	// child viewModel.
	//
	// Expects "this" to be picklist observable.
	MultiselectBehaviour.prototype._updateValues = function multiselectBehaviourUpdateValues(values) {
	    var o = this,
	        pliValues = [];
	
	    if (values && values.length >= 0) {
	        pliValues = ko.utils.arrayMap(values, function (item) {
	            return item.value;
	        });
	    }
	
	    // to prevent double update
	    o._isChildViewUpdate = true;
	    if (pliValues.length > 0) {
	        o.load(pliValues);
	    } else {
	        o.load(null);
	    }
	    o._isChildViewUpdate = false;
	};
	
	//-------------------------------------------
	// Update the state based on the changes to
	// the data.  Parse the value if the data
	// has been loaded.
	//
	// Expects "this" to be picklist observable.
	MultiselectBehaviour.prototype._onDataChanged = function multiselectBehaviourOnDataChanged(value) {
	    // reset the state.
	    var state = this.state.peek();
	    state.isValid = true;
	    state.isFailed = false;
	    state.isBusy = false;
	
	    if (value && value.data) { // data load succeeded (parse value)
	        MultiselectBehaviour.prototype._parseData.call(this, value);
	        this.valueHasMutated();
	    } else if (value && value.error) { // data load failed
	        state.isFailed = true;
	    } else { // data load in progress
	        state.isBusy = true;
	    }
	
	    this.state.valueHasMutated();
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Public
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = new MultiselectBehaviour();
	


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	/**
	 * Subcribes to an observable array and tracks added/deleted items.
	 *
	 * @param callback
	 *      Called on change with two parameters, (added, deleted), which
	 *      contain the added and deleted elements, respectively.
	 * @return
	 *      The knockout subscription object that can be used to dispose this subscription.
	 */
	function subscribeWithChanges(callback) {
	    if (typeof callback !== "function") {
	        throw new Error("subscribeWithChanges requires valid callback function");
	    }
	    var self = this;
	    var oldArray = self.peek().slice(0);
	    return self.subscribe(function (items) {
	        var changes = ko.utils.compareArrays(oldArray, items), added = [], deleted = [];
	        for (var _i = 0, changes_1 = changes; _i < changes_1.length; _i++) {
	            var item = changes_1[_i];
	            switch (item.status) {
	                case "added":
	                    added.push(item.value);
	                    break;
	                case "deleted":
	                    deleted.push(item.value);
	                    break;
	                default:
	            }
	        }
	        oldArray = items.slice();
	        // call callback function
	        if (added.length > 0 || deleted.length > 0) {
	            callback(added, deleted);
	        }
	    });
	}
	exports.subscribeWithChanges = subscribeWithChanges;
	/**
	 * Activates the 'subscribeWithChanges' method on observable arrays.
	 */
	function activateSubscribeWithChanges() {
	    if (!ko.observableArray.fn.subscribeWithChanges) {
	        ko.observableArray.fn.subscribeWithChanges = subscribeWithChanges;
	    }
	}
	exports.activateSubscribeWithChanges = activateSubscribeWithChanges;
	



/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	/**
	 * Searches for an element in a sorted collection by an item key.
	 *
	 * @param key
	 *     Item key to search for.
	 * @param collection
	 *     Array or observable array to search.
	 * @param keyProvider
	 *     - When null (default), "key" is compared directly against each traversed array element (identity)
	 *     - When string, "key" is compared against each traversed array element's property with this name
	 *     - When function, "key" is compared against return value of this function for each traversed array element
	 * @returns
	 *     Index of the found element or a negative value (the insertion point) if no element was found.
	 */
	function binarySearch(key, collection, keyProvider) {
	    if (keyProvider === void 0) { keyProvider = null; }
	    var unwrappedCollection = ko.unwrap(collection);
	    var keyProviderFn = (keyProvider === null
	        ? function (t) { return t; }
	        : (typeof keyProvider === "string"
	            ? function (o) { return o[keyProvider]; }
	            : keyProvider));
	    var left = 0; // inclusive
	    var right = collection.length; // exclusive
	    var found;
	    while (left < right) {
	        var middle = (left + right) >> 1;
	        var middleKey = keyProviderFn(unwrappedCollection[middle]);
	        var compareResult = key > middleKey
	            ? 1
	            : key < middleKey ? -1 : 0;
	        if (compareResult > 0) {
	            left = middle + 1;
	        }
	        else {
	            right = middle;
	            // We are looking for the lowest index so we can't return immediately.
	            found = !compareResult;
	        }
	    }
	    // left is the index if found, or the insertion point otherwise.
	    return found ? left : -left - 1;
	}
	exports.binarySearch = binarySearch;
	/**
	 * Returns true if the given enumerable is empty; false otherwise.
	 */
	function isEmpty(e) {
	    for (var k in e) {
	        if (e.hasOwnProperty(k)) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.isEmpty = isEmpty;
	



/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var pliObservable = __webpack_require__(449);
	var stringUtil = __webpack_require__(13);
	
	var shared = __webpack_require__(22);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// RangeAdvancedSearchItem template
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	var parseRangeRegex = new RegExp("(.+)(?:\\.\\.)(.+)|(>=|<=)*(.*)");
	
	
	//-------------------------------------------
	function RangeAdvancedSearchItem(behaviourName, behaviourData) {
	    if (!(this instanceof RangeAdvancedSearchItem)) { return new RangeAdvancedSearchItem(); } // if new was not used, force it now
	
	    // indicates how number fields are searched
	    // - `equals` includes any items that match the number exactly.
	    // - `between` includes any items between the numbers specified including the numbers themselves. (default)
	    // - `not` excludes any items that match the number exactly.
	    // - `>=` includes any items greater than or equal to the number specified.
	    // - `<=` incluces any items less than or equal to the number specified.
	    // - `is empty` includes items that do not have a value (`enableEmpty` must be set on behaviourData)
	    // - `is not empty` includes items that have any value (`enableEmpty` must be set on behaviourData)
	    this.operator = ko.observable("equals");
	
	    this.behaviourName = behaviourName;
	    this.lower = pliObservable(null, behaviourData, behaviourName); // lower is used for `<=`, `>=` and `equals`
	    this.upper = pliObservable(null, behaviourData, behaviourName);
	
	    // extras
	    this.extras = function rangeAdvancedSearchItemExtras() { return; };
	    this.extras.enableEmpty = !!(behaviourData && behaviourData.enableEmpty);
	    this.extras.isEmpty = ko.pureComputed(shared.containsEmpty, this.operator);
	}
	
	
	//-------------------------------------------
	RangeAdvancedSearchItem.prototype.templateId = "rangeAdvancedSearchItem";
	
	
	//-------------------------------------------
	// Loads the value of this view-model from the
	// advancedSearch item.
	RangeAdvancedSearchItem.prototype.load = function rangeAdvancedSearchItemLoad(phrase, not) {
	    var operatorValue = "equals",
	        lower = null,
	        upper = null,
	        range = parseRangeRegex.exec(phrase) || [],
	        lowerRange = range[1],
	        upperRange = range[2],
	        operator = range[3],
	        value = range[4];
	
	    if (!stringUtil.isNullOrWhitespace(lowerRange) && !stringUtil.isNullOrWhitespace(upperRange)) {
	        lower = lowerRange;
	        upper = upperRange;
	        operatorValue = "between";
	    } else if (value === "[empty]") {
	        operatorValue = not ? "is not empty" : "is empty";
	    } else {
	        lower = typeof value === "string" ? value : null;
	        operatorValue = not ? "not" : (operator || operatorValue);
	    }
	
	    this.lower.load(lower);
	    this.upper.load(upper);
	    this.operator(operatorValue);
	};
	
	
	
	//-------------------------------------------
	// Saves the value of this view-model to the
	// advancedSearch item. Expects `this` to be the advancedSearch item.
	RangeAdvancedSearchItem.prototype.save = function  rangeAdvancedSearchItemSave() {
	    this.lower();
	    this.upper();
	    var phrase = "",
	        not = false,
	        operator = this.operator(),
	        lower = this.lower.format(),
	        upper = this.upper.format();
	
	    switch (operator) {
	    case ">=":
	        if (lower) {
	            phrase = ">=" + lower;
	        }
	        break;
	    case "<=":
	        if (lower) {
	            phrase = "<=" + lower;
	        }
	        break;
	    case "equals":
	        phrase = "".concat(lower);
	        break;
	    case "between":
	        if (lower && upper) {
	            phrase = lower + ".." + upper;
	            break;
	        }
	        if (lower) {
	            phrase = ">=" + lower;
	            break;
	        }
	        if (upper) {
	            phrase = "<=" + upper;
	            break;
	        }
	        break;
	    case "not":
	        phrase = "".concat(lower);
	        not = true;
	        break;
	    case "is empty":
	        phrase = "[empty]";
	        not = false;
	        break;
	    case "is not empty":
	        phrase = "[empty]";
	        not = true;
	        break;
	    }
	
	    return [phrase, not];
	};
	
	
	//-------------------------------------------
	function initializeRangeAdvancedSearch(behaviour, templateId, defaultValue) {
	
	    var f = function (behaviourData) {
	        return new RangeAdvancedSearchItem(behaviour, behaviourData);
	    };
	
	    f.prototype.templateId = (!!templateId && typeof templateId === "string") ? templateId : RangeAdvancedSearchItem.prototype.templateId;
	    f.prototype.defaultValue = defaultValue;
	
	    return f;
	}
	
	module.exports = {
	    date: initializeRangeAdvancedSearch("date"),
	    initializeRangeAdvancedSearch: initializeRangeAdvancedSearch,
	    number: initializeRangeAdvancedSearch("numeric")
	};
	


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var pliObservable = __webpack_require__(15);
	
	var control = __webpack_require__(450);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	pliObservable.behaviours.date = control.behaviours.date;
	pliObservable.behaviours.month = control.behaviours.month;
	
	module.exports = pliObservable;
	


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	var dateUtil = __webpack_require__(451);
	
	__webpack_require__(423);
	
	if (__webpack_require__(3).isBrowser) {
	    __webpack_require__(452);
	}
	
	var defaultDateFormat = "MMM-dd-yyyy",
	    /// <summary>Specifies the default date format</summary>;
	
	    defaultMonthFormat = "MMM-yyyy",
	    /// <summary>Specifies the default month format</summary>
	
	    monthParseFormats = [
	        "yyyy M", "yy M", "yyyy-M", "yy-M", "yy/M", "yyyyM", "yyM",
	        "yyyy MM", "yy MM", "yyyy-MM", "yy-MM", "yy/MM", "yyyyMM", "yyMM",
	        "yyyy MMM", "yy MMM", "yyyy-MMM", "yy-MMM", "yy/MMM", "yyyyMMM", "yyMMM",
	        "yyyy MMMM", "yy MMMM", "yyyy-MMMM", "yy-MMMM", "yy/MMMM",  "yyyyMMMM", "yyMMMM"];
	    /// <summary>Specifies the default parse formats for month/year</summary>
	
	
	//-------------------------------------------
	// Extract the parse formats from the specified
	// "behaviourData" or return the default
	// (if not specified by "behaviourData").
	function getCustomParseFormatsOrDefault(behaviourData, defaultFormat) {
	    return (behaviourData && Array.isArray(behaviourData.parseFormats))
	        ? behaviourData.parseFormats
	        : defaultFormat;
	}
	
	//-------------------------------------------
	// Serialize a javascript date to the string representation
	// of a month. Format: (yyyy-MM) Example. `1999-12`
	var toJSONMonth = function toJSONMonth() {
	    var month = (this.getMonth() + 1);
	    return "".concat(
	        this.getFullYear(),
	        "-",
	        (month < 10 ? "0".concat(month) : month)
	    );
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "DateBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Create behaviour for a date type.
	function createDateBehaviour(defaultFormat, extraParseFormats, formId, behaviourDataErrorMessageProperty, errorMessage, toJSON) {
	
	    //-------------------------------------------
	    function DateBehaviour() {
	        return this;
	    }
	
	
	    //-------------------------------------------
	    DateBehaviour.prototype.format = function dateBehaviourFormat(value, format) {
	        return dateUtil.formatDate(value, format || pliObservable.shared.getCustomFormatOrDefault(this.behaviourData, defaultFormat));
	    };
	
	
	    //-------------------------------------------
	    DateBehaviour.prototype.parse = function dateBehaviourParse(value, format) {
	        var d = dateUtil.parseDate(
	                value,
	                format || pliObservable.shared.getCustomFormatOrDefault(this.behaviourData, defaultFormat),
	                getCustomParseFormatsOrDefault(this.behaviourData, extraParseFormats)
	            );
	        return (d === undefined ? DateBehaviour.prototype._getErrorMessage : d);
	    };
	
	
	    //-------------------------------------------
	    DateBehaviour.prototype.show = function dateBehaviourShow(options) {
	        pli.forms.registry[formId].load({
	            value: function (v) {
	                return options.onShowDone.call(options.onShowDoneContext, v);
	            },
	            $element: options.$input
	        });
	        return false;
	    };
	
	
	    //-------------------------------------------
	    DateBehaviour.prototype.validate = function dateBehaviourValidate(value) {
	        var isValid = (value === null || dateUtil.isDate(value));
	
	        // Specify custom toJSON function to serialize date without time
	        // since time is not specified by the user we should exclude in serialization
	        if (isValid && value) {
	            value.toJSON = toJSON;
	        } // requires DateExtensions.js
	
	        return isValid ? null : DateBehaviour.prototype._getErrorMessage;
	    };
	
	
	    //-------------------------------------------
	    DateBehaviour.prototype._getErrorMessage = pliObservable.shared.createGetErrorMessage(behaviourDataErrorMessageProperty, errorMessage);
	
	
	    return new DateBehaviour();
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = {
	    behaviours: {
	        date: createDateBehaviour(defaultDateFormat, null, "dateSelector", "errorDateValue", "Invalid date", Date.prototype.toJSONDate),
	        month: createDateBehaviour(defaultMonthFormat, monthParseFormats, "monthSelector", "errorMonthValue", "Invalid month", toJSONMonth)
	    }
	};
	


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	__webpack_require__(423);
	var string_1 = __webpack_require__(13);
	/**
	 * Adds the specified number of days to a new instance instance.The number can be positive or negative.
	 */
	function addDays(value, days) {
	    var clone = value.clone();
	    clone.addDays(days);
	    return clone;
	}
	exports.addDays = addDays;
	/**
	 * Adds the specified number of days to a new instance.The number can be positive or negative.
	 */
	function addMonths(value, months) {
	    var clone = value.clone();
	    clone.addMonths(months);
	    return clone;
	}
	exports.addMonths = addMonths;
	/**
	 * Adds the specified number of years to a new instance.The number can be positive or negative.
	 */
	function addYears(value, years) {
	    var clone = value.clone();
	    clone.addYears(years);
	    return clone;
	}
	exports.addYears = addYears;
	/**
	 * Resets the time of a new instance Date object to 12:00 AM(00:00), which is the start of the day.
	 */
	function clearTime(value) {
	    var clone = value.clone();
	    clone.clearTime();
	    return clone;
	}
	exports.clearTime = clearTime;
	/**
	 * Determine if the value specified is a Date object
	 * @param  {Any}  value
	 *         The value to test.
	 * @return {Boolean}
	 *         Returns true if the value is a date otherwise false.
	 */
	function isDate(value) {
	    return (value && value.getTime ? isFinite(value) : false);
	}
	exports.isDate = isDate;
	/**
	 * Moves the date to the first day of the month on a new date instance.
	 */
	function moveToFirstDayOfMonth(value) {
	    var clone = value.clone();
	    clone.moveToFirstDayOfMonth();
	    return clone;
	}
	exports.moveToFirstDayOfMonth = moveToFirstDayOfMonth;
	/**
	 * Moves the date to the last day of the month on a new date instance.
	 */
	function moveToLastDayOfMonth(value) {
	    var clone = value.clone();
	    clone.moveToLastDayOfMonth();
	    return clone;
	}
	exports.moveToLastDayOfMonth = moveToLastDayOfMonth;
	/**
	 * Sets the day of a new date instance relative to the beginning of the currently set month.
	 */
	function setDate(value, day) {
	    var clone = value.clone();
	    clone.setDate(day);
	    return clone;
	}
	exports.setDate = setDate;
	/**
	 * Sets the month of a new date instance according to the currently set year.
	 */
	function setMonth(value, month) {
	    var clone = value.clone();
	    clone.setMonth(month);
	    return clone;
	}
	exports.setMonth = setMonth;
	/**
	 * Formats the date according to the specified format.
	 */
	function formatDate(value, format) {
	    return isDate(value) ? value.toString(format) : "";
	}
	exports.formatDate = formatDate;
	/**
	 * Attempts to parse a value as a Date instance.
	 * Uses DateJS parseExact method if a format string is specified,
	 * otherwise uses DateJS parse method.
	 * @param {string} value
	 *     Value to parse.
	 * @param {string = null} format
	 *     Format string to use for DateJS parseExact method.
	 * @param {string[] = null} extraParseFormats
	 *     Array of format strings to pass to DateJS parseExact method.
	 * @returns {Date}
	 *     Parsed Date instance, null if empty value provided, or undefined if value was unparseable.
	 */
	function parseDate(value, format, extraParseFormats) {
	    if (format === void 0) { format = ""; }
	    if (extraParseFormats === void 0) { extraParseFormats = null; }
	    // ignore white-space or empty
	    if (value === undefined || value === null || (typeof value === "string" && string_1.isNullOrWhitespace(value))) {
	        return null;
	    }
	    // DateJS dies on non-string/Date input
	    if (typeof value !== "string") {
	        throw new Error("parseDate expects a string for 'value'");
	    }
	    // parseExact guarantees the value is correctly parsed using custom/default format
	    // (especially important for ambigious date formats such as MM/dd/yyyy & dd/MM/yyyy)
	    // the parse fallback supports values such as (today, tomorrow, next week, next thursday, June 15 1997, ...)
	    var d = Date.parseExact(value, format);
	    if (extraParseFormats && !d) {
	        d = Date.parseExact(value, extraParseFormats);
	    }
	    if (!d) {
	        d = Date.parse(value);
	    }
	    return (isDate(d) ? d : undefined);
	}
	exports.parseDate = parseDate;
	



/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true, todo: true */
	
	"use strict";
	
	var $ = __webpack_require__(1);
	var dateUtil = __webpack_require__(451);
	var pli = __webpack_require__(380);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function daysEquals(left, right) {
	    /// <summary>
	    /// Compares the Date (day, month, year) of two javascript dates.
	    /// </summary>
	    return left.getDate() === right.getDate()
	        && left.getMonth() === right.getMonth()
	        && left.getFullYear() === right.getFullYear();
	}
	
	
	//-------------------------------------------
	function monthsEquals(left, right) {
	    /// <summary>
	    /// Compares the Month (month, year) of two javascript dates.
	    /// </summary>
	    return left.getMonth() === right.getMonth()
	        && left.getFullYear() === right.getFullYear();
	}
	
	
	//-------------------------------------------
	function buildDays(selected) {
	    /// <summary>
	    /// Builds the table body containing the calendar days
	    /// </summary>
	    var w, d,
	        className = "",
	        day = selected,
	        html = "",
	        today = new Date();
	
	    // Initialize the first date in the calendar (offset the first day of the month by the day of the week index)
	    day = dateUtil.moveToFirstDayOfMonth(day);
	    day = dateUtil.addDays(day, day.getDay() * -1);
	
	    // Add a spacer row for a gap between header row and days
	    html = html.concat("<tr class=\"spacer\"></tr>");
	
	    for (w = 0; w < 6; w += 1) {
	        html = html.concat("<tr>");
	
	        for (d = 0; d < 7; d += 1) {
	
	            // build className (out: outside of current month)
	            if (daysEquals(day, today)) { className = className.concat("today "); }
	            if (day.getMonth() !== selected.getMonth()) { className = className.concat("out "); }
	            if (daysEquals(day, selected)) { className = className.concat("selected"); }
	
	            // build table cell for a calendar day
	            html = html.concat(className
	                ? "<td class=\"".concat(className).concat("\">")
	                : "<td>")
	                .concat(day.getDate())
	                .concat("</td>");
	
	            className = "";
	            day = dateUtil.addDays(day, 1); // increment the day
	        }
	
	        html = html.concat("</tr>");
	    }
	    return html;
	}
	
	
	//-------------------------------------------
	function buildMonths(selected) {
	    /// <summary>
	    /// Builds the table body of months 4x3
	    /// </summary>
	    var r, m, month = selected, html = "";
	    month = dateUtil.setMonth(month, 0);
	
	    // creates a 4x3 table of months (MMM)
	    for (r = 0; r < 3; r += 1) {
	        html = html.concat("<tr>");
	        for (m = 0; m < 4; m += 1) {
	            html = html.concat((monthsEquals(month, selected) ? "<td class=\"selected\">" : "<td>"))
	                .concat(month.toString("MMM"))
	                .concat("</td>");
	            month = dateUtil.addMonths(month, 1); // increment the month
	        }
	        html = html.concat("</tr>");
	    }
	    return html;
	}
	
	
	//-------------------------------------------
	function buildCalendarHtml(selected) {
	    /// <summary>
	    /// Build the html for the calendar control
	    /// </summary>
	    return "<div id=\"calendarPopup\" class=\"calendarPopup\">"
	
	        // Header
	        .concat("<header>")
	        .concat("<a class=\"leftNav\"><span class=\"sprite-blueArrowLeft-16\"></span></a>")
	        .concat("<div>")
	        .concat(selected.toString("MMMM yyyy"))
	        .concat("</div>")
	        .concat("<a class=\"rightNav\"><span class=\"sprite-blueArrowRight-16\"></span></a>")
	        .concat("</header>")
	
	        // Table
	        .concat("<section><table>")
	
	        // Week Days
	        .concat("<thead>")
	        .concat("<tr><th>Su</th><th>Mo</th><th>Tu</th><th>We</th><th>Th</th><th>Fr</th><th>Sa</th></tr>")
	        .concat("</thead>")
	
	        // Days
	        .concat("<tbody>")
	        .concat(buildDays(selected))
	        .concat("</tbody>")
	
	        .concat("</table></section>");
	}
	
	
	//-------------------------------------------
	function buildMonthHtml(selected) {
	    /// <summary>
	    /// Build the html for the month calendar control
	    /// </summary>
	    return "<div id=\"monthPopup\" class=\"calendarPopup monthPopup\">"
	
	        // Header
	        .concat("<header>")
	        .concat("<a class=\"leftNav\"><span class=\"sprite-blueArrowLeft-16\"></span></a>")
	        .concat("<div>")
	        .concat(selected.toString("yyyy"))
	        .concat("</div>")
	        .concat("<a class=\"rightNav\"><span class=\"sprite-blueArrowRight-16\"></span></a>")
	        .concat("</header>")
	
	        // Table
	        .concat("<section><table>")
	
	        // Months
	        .concat("<tbody>")
	        .concat(buildMonths(selected))
	        .concat("</tbody>")
	
	        .concat("</table></section>");
	}
	
	
	//-------------------------------------------
	function positionCalendar($calendar, $document, $element) {
	    /// <summary>
	    /// Positions the calendar relative to the $element specified
	    /// </summary>
	    var vw = $document.width(),
	        vh = $document.height(),
	        offset = $element.offset(),
	        cw = $calendar.outerWidth(),
	        ch = $calendar.outerHeight(),
	        ih = $element.outerHeight();
	
	    // if the calendar is outside of the current document (horizontally)
	    // offset by the calendarWidth - width of the input.
	    if (offset.left + cw > vw) {
	        offset.left = offset.left - (cw - $element.outerWidth());
	    }
	
	    // if the calendar is outside of the current document (vertically)
	    // offset by the height of the calendar + top border
	    // otherwise offset by the height of the input - bottom border
	    // border adjustment ensures that the input and calendar borders overlap.
	    if (offset.top + ch + ih > vh) {
	        offset.top = offset.top - ch + 1;
	    } else {
	        offset.top = offset.top + ih - 1;
	    }
	    $calendar.offset(offset);
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// PopupControl class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function PopupControl() {
	    /// <summary>
	    /// Initializes a new instance of the popup control
	    /// </summary>
	    return;
	}
	
	
	//-------------------------------------------
	PopupControl.prototype._internalClose = function popupControlInternalClose(updateValue) {
	    /// <summary></summary>
	
	    // Call close handler before data is removed
	    this.$calendar.addClass("hidden");
	    this._value(updateValue ? this._selected : undefined);
	
	    // Remove event handlers
	    this._$element.off("keydown", this._keyDownHandler);
	    this.$document.off("mousedown", this._globalMouseDown)
	        .off("focusin", this._globalFocus);
	
	    // delete temporary variables
	    delete this._value;
	    delete this._selected;
	    delete this._$element;
	    return false;
	};
	
	
	//-------------------------------------------
	PopupControl.prototype._globalFocus = function popupControlGlobalFocus() {
	    /// <summary>
	    /// Cancels calendar pop-up if global focus is lost.
	    /// Mostly intended when moving from the address bar back
	    /// into the form or when navigating to another page.
	    /// </summary>
	    if (this._eventInCalendar) { // focus was triggered by clicking within calendar (ignore)
	        this._eventInCalendar = false;
	    } else if (document.activeElement !== this._$element[0]) {
	        this.cancel();
	    }
	};
	
	
	//-------------------------------------------
	PopupControl.prototype._normalizeFocus = function popupControlNormalizeFocus() {
	    /// <summary>
	    /// In IE versions < 9, focus cannot be cancelled
	    /// from the mousedown event.  Instead setTimeout is used
	    /// to re-focus after the click event has finished.
	    /// More Information: http://bugs.jquery.com/ticket/10345
	    /// </summary>
	    if (document.activeElement !== this._$element[0]) { // re-focus if necessary
	        this._eventInCalendar = true;
	        this._$element.focus();
	    }
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// CalendarControl class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function CalendarControl() {
	    /// <summary>
	    /// Initializes a new instance of the calendar control
	    /// </summary>
	    this.$document = $(document);
	
	    this._globalMouseDown = this._globalMouseDown.bind(this);
	    this._globalFocus = this._globalFocus.bind(this);
	    this._keyDownHandler = this._keyDownHandler.bind(this);
	    this._normalizeFocus = this._normalizeFocus.bind(this);
	}
	
	
	//-------------------------------------------
	CalendarControl.prototype.accept = function calendarControlAccept() {
	    /// <summary>
	    /// Accept the selected date and close the popup.
	    /// </summary>
	    return this._internalClose(true);
	};
	
	
	//-------------------------------------------
	CalendarControl.prototype.cancel = function calendarControlCancel() {
	    /// <summary>
	    /// Ignore the selected date and close the form
	    /// </summary>
	    return this._internalClose(false);
	};
	
	
	//-------------------------------------------
	CalendarControl.prototype.load = function calendarControlLoad(options) {
	    /// <summary>
	    /// Loads the selected date and displays the calendar popup.
	    /// </summary
	    if (typeof options.value !== "function") { throw new Error("options.value must be an observable or function"); }
	    var selected = options.value();
	    selected = selected || new Date();
	
	    // show the calendar if it exists
	    if (this.$calendar) {
	        if (!this.$calendar.is(":hidden")) { this.cancel(); } // ensure calendar is cleaned up.
	        this.$days.html(buildDays(selected));
	        this.$monthHeader.text(selected.toString("MMMM yyyy"));
	        this.$calendar.removeClass("hidden");
	
	    // otherwise build the calendar DOM
	    } else {
	        $("body").append(buildCalendarHtml(selected));
	        this.$calendar = $("#calendarPopup");
	        this.$days = this.$calendar.find("tbody");
	        this.$monthHeader = this.$calendar.find("header > div");
	    }
	    this._storeAdjustment();
	
	    this._value = options.value;
	    this._selected = selected;
	    this._$element = options.$element;
	    positionCalendar(this.$calendar, this.$document, this._$element);
	    this._$element.focus();
	    this._$element.on("keydown", this._keyDownHandler);
	    this.$document.on("mousedown", this._globalMouseDown).on("focusin", this._globalFocus);
	};
	
	
	
	//-------------------------------------------
	CalendarControl.prototype._adjust = function calendarControlAdjust() {
	    /// <summary>
	    /// Adjusts the date to the last selected date or
	    /// last day of the month.  Meant to be used with PageUp and PageDown
	    /// to keep the last selected date via arrow keys.
	    /// </summary>
	    if (this._isLastDay) {
	        this._selected = dateUtil.moveToLastDayOfMonth(this._selected);
	    } else if (this._selected.getDate() !== this._adjustment.getDate() && this._adjustment.getDate() >= 28) {
	        this._selected = dateUtil.setDate(this._selected, Math.min(
	            Date.getDaysInMonth(this._selected.getFullYear(), this._selected.getMonth()),
	            this._adjustment.getDate()
	        ));
	    }
	};
	
	
	//-------------------------------------------
	CalendarControl.prototype._internalClose = PopupControl.prototype._internalClose;
	
	
	//-------------------------------------------
	CalendarControl.prototype._storeAdjustment = function calendarControlStoreAdjustment() {
	    /// <summary>
	    /// Stores the last selected date in order to adjust the date to
	    /// maintain the last selected date.  (used by _adjust function)
	    /// </summary>
	    this._adjustment = new Date(this._selected);
	    this._isLastDay = this._adjustment.getDate() === Date.getDaysInMonth(this._adjustment.getFullYear(), this._adjustment.getMonth());
	};
	
	
	//-------------------------------------------
	CalendarControl.prototype._globalMouseDown = function calendarControlGlobalMouseDown(e) {
	    /// <summary>
	    /// Handles the global mouse down click.
	    /// Cancels the calendar popup if clicking outside of the calendar.
	    /// </summary>
	    var $a, d,
	        $target = $(e.target),
	        $popup = $target.closest(".calendarPopup");
	
	    if ($popup.length !== 0) {
	
	        // Handle left/right arrows or cell
	        $a = $target.closest(".leftNav, .rightNav, td");
	        if ($a.length !== 0) {
	            if ($a.is(".leftNav")) {
	                this._selected = dateUtil.addMonths(this._selected, -1);
	                this._adjust();
	                this._refresh();
	            } else if ($a.is(".rightNav")) {
	                this._selected = dateUtil.addMonths(this._selected, 1);
	                this._adjust();
	                this._refresh();
	            } else {
	                d = parseInt($a.text(), 10);
	                if ($a.is(".out")) { this._selected = dateUtil.addMonths(this._selected, d > 15 ? -1 : 1); }
	                this._selected = dateUtil.setDate(this._selected, d);
	                this.accept();
	                return false;
	            }
	        }
	        this._eventInCalendar = true;
	        setTimeout(this._normalizeFocus, 0);
	
	    } else {
	        this.cancel();
	    }
	};
	
	
	//-------------------------------------------
	CalendarControl.prototype._globalFocus = PopupControl.prototype._globalFocus;
	
	
	//-------------------------------------------
	CalendarControl.prototype._keyDownHandler = function calendarControlKeyDownHandler(e) {
	    /// <summary>
	    /// Handles keyboard accessibility of the calendar pop-up.
	    /// </summary>
	    switch (e.which) {
	    case 13: // Enter
	        this.accept();
	        return false;
	    case 27: // Escape
	        this.cancel();
	        return false;
	    case 9: // Tab
	        this._selected = dateUtil.addDays(this._selected, e.shiftKey ? -1 : 1);
	        this._refresh(true);
	        this._$element.focus();
	        return false;
	    case 33: // PageUp
	        this._selected = dateUtil.addMonths(this._selected, -1);
	        this._adjust();
	        this._refresh();
	        return false;
	    case 34: // PageDown
	        this._selected = dateUtil.addMonths(this._selected, 1);
	        this._adjust();
	        this._refresh();
	        return false;
	    case 38: // Up
	        this._selected = dateUtil.addDays(this._selected, -7);
	        this._refresh(true);
	        return false;
	    case 37: // Left
	        this._selected = dateUtil.addDays(this._selected, -1);
	        this._refresh(true);
	        return false;
	    case 39: // Right
	        this._selected = dateUtil.addDays(this._selected, 1);
	        this._refresh(true);
	        return false;
	    case 40: // Down
	        this._selected = dateUtil.addDays(this._selected, 7);
	        this._refresh(true);
	        return false;
	    }
	};
	
	
	//-------------------------------------------
	CalendarControl.prototype._normalizeFocus = PopupControl.prototype._normalizeFocus;
	
	
	//-------------------------------------------
	CalendarControl.prototype._refresh = function calendarControlRefresh(storeAdjustment) {
	    /// <summary>
	    /// Re-renders the calendar days based on the selection.
	    /// </summary>
	    /// <param name="storeAdjustment">
	    /// true if the last selected date is stored otherwise false
	    /// </summary>
	    this.$days.html(buildDays(this._selected));
	    this.$monthHeader.text(this._selected.toString("MMMM yyyy"));
	    if (storeAdjustment) { this._storeAdjustment(); }
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// MonthControl class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function MonthControl() {
	    /// <summary>
	    /// Initializes a new instance of the month calendar control
	    /// </summary>
	    this.$document = $(document);
	
	    this._globalMouseDown = this._globalMouseDown.bind(this);
	    this._globalFocus = this._globalFocus.bind(this);
	    this._keyDownHandler = this._keyDownHandler.bind(this);
	    this._normalizeFocus = this._normalizeFocus.bind(this);
	}
	
	
	//-------------------------------------------
	MonthControl.prototype.accept = function MonthControlAccept() {
	    /// <summary>
	    /// Accept the selected date and close the popup.
	    /// </summary>
	    return this._internalClose(true);
	};
	
	
	//-------------------------------------------
	MonthControl.prototype.cancel = function MonthControlCancel() {
	    /// <summary>
	    /// Ignore the selected date and close the form
	    /// </summary>
	    return this._internalClose();
	};
	
	
	//-------------------------------------------
	MonthControl.prototype.load = function MonthControlLoad(options) {
	    /// <summary>
	    /// Loads the selected date and displays the month calendar popup.
	    /// </summary
	    if (typeof options.value !== "function") { throw new Error("options.value must be an observable or function"); }
	    var selected = options.value();
	    selected = selected || new Date();
	    selected = dateUtil.moveToFirstDayOfMonth(selected); // clear date and time
	    selected = dateUtil.clearTime(selected);
	
	    // show the month calendar if it exists
	    if (this.$calendar) {
	        if (!this.$calendar.is(":hidden")) { this.cancel(); } // ensure calendar is cleaned up.
	        this.$months.removeClass("selected");
	        this.$months.eq(selected.getMonth()).addClass("selected");
	        this.$yearHeader.text(selected.toString("yyyy"));
	        this.$calendar.removeClass("hidden");
	
	    // otherwise build the calendar DOM
	    } else {
	        $("body").append(buildMonthHtml(selected));
	        this.$calendar = $("#monthPopup");
	        this.$months = this.$calendar.find("td");
	        this.$yearHeader = this.$calendar.find("header > div");
	    }
	
	    this._value = options.value;
	    this._selected = selected;
	    this._$element = options.$element;
	    positionCalendar(this.$calendar, this.$document, this._$element);
	    this._$element.focus();
	    this._$element.on("keydown", this._keyDownHandler);
	    this.$document.on("mousedown", this._globalMouseDown).on("focusin", this._globalFocus);
	};
	
	
	//-------------------------------------------
	MonthControl.prototype._internalClose = PopupControl.prototype._internalClose;
	
	
	//-------------------------------------------
	MonthControl.prototype._globalMouseDown = function MonthControlGlobalMouseDown(e) {
	    /// <summary>
	    /// Handles the global mouse down click.
	    /// Cancels the calendar popup if clicking outside of the calendar.
	    /// </summary>
	    var $a,
	        $target = $(e.target),
	        $popup = $target.closest(".calendarPopup");
	
	    if ($popup.length !== 0) {
	
	        // Handle left/right arrows or cell
	        $a = $target.closest(".leftNav, .rightNav, td");
	        if ($a.length !== 0) {
	            if ($a.is(".leftNav")) {
	                this._selected = dateUtil.addYears(this._selected, -1);
	                this._refresh();
	            } else if ($a.is(".rightNav")) {
	                this._selected = dateUtil.addYears(this._selected, 1);
	                this._refresh();
	            } else {
	                this._selected = dateUtil.setMonth(this._selected, Date.getMonthNumberFromName($a.text()));
	                this.accept();
	                return false;
	            }
	        }
	        this._eventInCalendar = true;
	        setTimeout(this._normalizeFocus, 0);
	
	    } else {
	        this.cancel();
	    }
	};
	
	
	//-------------------------------------------
	MonthControl.prototype._globalFocus = PopupControl.prototype._globalFocus;
	
	
	//-------------------------------------------
	MonthControl.prototype._keyDownHandler = function MonthControlKeyDownHandler(e) {
	    /// <summary>
	    /// Handles keyboard accessibility of the month calendar pop-up.
	    /// </summary>
	    switch (e.which) {
	    case 13: // Enter
	        this.accept();
	        return false;
	    case 27: // Escape
	        this.cancel();
	        return false;
	    case 9: // Tab
	        this._selected = dateUtil.addMonths(this._selected, e.shiftKey ? -1 : 1);
	        this._refresh();
	        this._$element.focus();
	        return false;
	    case 33: // PageUp
	        this._selected = dateUtil.addYears(this._selected, -1);
	        this._refresh();
	        return false;
	    case 34: // PageDown
	        this._selected = dateUtil.addYears(this._selected, 1);
	        this._refresh();
	        return false;
	    case 38: // Up
	        this._selected = dateUtil.addMonths(this._selected, -4);
	        this._refresh();
	        return false;
	    case 37: // Left
	        this._selected = dateUtil.addMonths(this._selected, -1);
	        this._refresh();
	        return false;
	    case 39: // Right
	        this._selected = dateUtil.addMonths(this._selected, 1);
	        this._refresh();
	        return false;
	    case 40: // Down
	        this._selected = dateUtil.addMonths(this._selected, 4);
	        this._refresh();
	        return false;
	    }
	};
	
	
	//-------------------------------------------
	MonthControl.prototype._normalizeFocus = PopupControl.prototype._normalizeFocus;
	
	
	//-------------------------------------------
	MonthControl.prototype._refresh = function MonthControlRefresh() {
	    /// <summary>
	    /// Re-renders the calendar days based on the selection.
	    /// </summary>
	    this.$months.removeClass("selected");
	    this.$months.eq(this._selected.getMonth()).addClass("selected");
	    this.$yearHeader.text(this._selected.toString("yyyy"));
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	// TODO: Create separate modules
	pli.forms.registry.dateSelector = new CalendarControl();
	pli.forms.registry.monthSelector = new MonthControl();
	
	module.exports = pli;
	


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var pliObservable = __webpack_require__(15);
	var stringUtil = __webpack_require__(13);
	
	var shared = __webpack_require__(22);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// StringAdvancedSearchItem template
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	/**
	 * Advanced search item for doing basic string comparisons.
	 */
	function StringAdvancedSearchItem(behaviourData) {
	    if (!(this instanceof StringAdvancedSearchItem)) { return new StringAdvancedSearchItem(behaviourData); } // if new was not used, force it now
	
	    // indicates how the string fields are searched
	    // - `contains` includes any items with partial matches (default)
	    // - `not contain` excludes any items with partial matches
	    // - `is` include any items with exact matches
	    // - `is not` excludes any items with exact matches
	    // - `is empty` includes items that do not have a value (`enableEmpty` must be set on behaviourData)
	    // - `is not empty` includes items that have any value (`enableEmpty` must be set on behaviourData)
	    this.operator = ko.observable("contains");
	
	    // contains value of the phrase to match
	    this.value = pliObservable();
	
	    // extras
	    this.extras = function stringAdvancedSearchItemExtras() { return; };
	    this.extras.enableEmpty = !!(behaviourData && behaviourData.enableEmpty);
	    this.extras.isEmpty = ko.pureComputed(shared.containsEmpty, this.operator);
	}
	
	
	/**
	 * Gets the id used by the browser to uniquely identify the dom element.
	 * @type {String}
	 */
	StringAdvancedSearchItem.prototype.templateId = "stringAdvancedSearchItem";
	
	
	/**
	 * Loads the value of this view-model from the advancedSearch item.
	 * @param {string} phrase
	 *      The search phrase.
	 * @param {boolean} not
	 *      Whether to invert the search.
	 */
	StringAdvancedSearchItem.prototype.load = function stringAdvancedSearchItemLoad(phrase, not) {
	    var textValue, operatorValue = "contains"; // default is "contains"
	    if (not) {
	        phrase = phrase.trim();
	        textValue = phrase.replace(shared.removeSurroundingWildcards, "");
	        operatorValue = phrase === "[empty]"
	            ? "is not empty"
	            : (phrase[0] === "*" && phrase[phrase.length - 1] === "*") ? "not contain" : "not";
	
	    } else if (stringUtil.isNullOrWhitespace(phrase)) {
	        textValue = "";
	    } else {
	        phrase = phrase.trim();
	        textValue = phrase.replace(shared.removeSurroundingWildcards, "");
	        if (phrase === "[empty]") {
	            operatorValue = "is empty";
	        } else if (textValue[0] === phrase[0] || textValue[textValue.length - 1] === phrase[phrase.length - 1]) {
	            // if "*" were not removed at the start and end of the string, then operator is "is" for string queries
	            operatorValue = "is";
	            textValue = phrase;
	        }
	    }
	
	    this.operator(operatorValue);
	    this.value.load(textValue);
	};
	
	
	/**
	 * Saves the value of this view-model to the advancedSearch item.
	 * @return {any[]}
	 *      An array tuple containing [phrase, not] - the phrase and whether the search should be inverted.
	 */
	StringAdvancedSearchItem.prototype.save = function stringAdvancedSearchItemSave() {
	    var phrase, not,
	        operator = this.operator(),
	        value = this.value();
	    value = stringUtil.isNullOrWhitespace(value) ? "" : value;
	
	    switch (operator) {
	    case "not":
	        phrase = value;
	        not = true;
	        break;
	    case "is":
	        phrase = value;
	        not = false;
	        break;
	    case "is empty":
	        phrase = "[empty]";
	        not = false;
	        break;
	    case "is not empty":
	        phrase = "[empty]";
	        not = true;
	        break;
	    case "not contain":
	        phrase = (value === ""
	            ? value
	            : "*".concat(value.replace(shared.removeSurroundingWildcards, ""), "*"));
	        not = true;
	        break;
	    default:
	        phrase = (value === ""
	            ? value
	            : "*".concat(value.replace(shared.removeSurroundingWildcards, ""), "*"));
	        not = false;
	        break;
	    }
	
	    return [phrase, not];
	};
	
	module.exports = StringAdvancedSearchItem;
	


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var searchQuery = __webpack_require__(455);
	var stringUtil = __webpack_require__(13);
	
	var AdvancedSearchItemViewModel = __webpack_require__(456);
	var DefaultAdvancedSearchItem = __webpack_require__(14);
	var shared = __webpack_require__(22);
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	// Creates the picklist data based on the
	// properties specified for the advancedSearch.
	function buildPropertyPicklistData(properties, excludeAnything) {
	    var id, items = [];
	    if (!excludeAnything) {
	        items.push({ name: "Anything", id: "" });
	    }
	    for (id in properties) {
	        if (properties.hasOwnProperty(id)) {
	            items.push({ name: properties[id].name, id: id });
	        }
	    }
	    return items;
	}
	
	
	//-------------------------------------------
	// Converts the parsed search query to advancedSearch
	// items.  The view-model currently does not
	// handle `or` binary expressions or nested
	// expressions.
	function load(advancedSearch, excludeAnything, result, stop) {
	    if (result !== null && typeof result === "object") {
	        switch (result.type) {
	        case "default":
	            return excludeAnything ? null : [new AdvancedSearchItemViewModel(advancedSearch, "", result.phrase, false)];
	        case "property":
	            return [new AdvancedSearchItemViewModel(advancedSearch, result.property.toLowerCase(), result.phrase, false)];
	        case "not":
	            var not = result.children[0];
	            if (not.type === "property" || not.type === "default") {
	                return [new AdvancedSearchItemViewModel(advancedSearch, not.property.toLowerCase(), not.phrase, true)];
	            }
	            break;
	        case "and":
	            if (!stop) {
	                var i, l, and = [], child;
	                for (i = 0, l = result.children.length; i < l; i += 1) {
	                    child = load(advancedSearch, excludeAnything, result.children[i], true);
	                    if (child === null) { return null; }
	                    and = and.concat(child);
	                }
	                return and;
	            }
	            break;
	        }
	    }
	    return null;
	}
	
	
	//-------------------------------------------
	// Parses the specified search phrase.
	function parse(advancedSearch, excludeAnything, phrase) {
	    var defaultValue = [new AdvancedSearchItemViewModel(advancedSearch)];
	    if (stringUtil.isNullOrWhitespace(phrase)) { return { phrase: defaultValue, supportedQuery: true }; }
	    var results = load(advancedSearch, excludeAnything, searchQuery.parse(phrase));
	    return (Array.isArray(results) && results.length > 0)
	        ? { phrase: results, supportedQuery: true }
	        : { phrase: defaultValue, supportedQuery: false };
	}
	
	
	//-------------------------------------------
	// Converts the items to the string representation.
	function save(items, supportedQuery, phrase) {
	    if (!supportedQuery) {
	        return phrase;
	    }
	    var result = "";
	    if (Array.isArray(items) && items.length > 0) {
	        var i, l, item, results = [];
	        for (i = 0, l = items.length; i < l; i += 1) {
	            item = items[i];
	            if (item instanceof AdvancedSearchItemViewModel) {
	                item = item.toSearchQuery();
	                if (item !== null) { results.push(item); }
	            }
	        }
	        if (results.length === 1) {
	            result = results[0].toString();
	        } else if (results.length > 1) {
	            result = searchQuery.buildBinary("and", results).toString();
	        }
	    }
	    return result;
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// AdvancedSearch view-model
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function AdvancedSearchViewModel(config) {
	    if (!(this instanceof AdvancedSearchViewModel)) { return new AdvancedSearchViewModel(config); } // if new was not used, force it now
	
	    // validate and normalize config.
	    config = config || {};
	    var hidden = (typeof config.hidden !== "boolean" ? true : !!config.hidden);
	    var phrase = (typeof config.phrase === "string" ? config.phrase : "");
	    var excludeAnything = (typeof config.excludeAnything === "boolean" ? config.excludeAnything : false);
	    var hideOnReset = (typeof config.hideOnReset === "boolean" ? config.hideOnReset : false);
	    var id, lower, property, properties = config.properties || {};
	    this._excludeAnything = excludeAnything;
	    this._properties = {};
	    for (id in properties) {
	        if (properties.hasOwnProperty(id)) {
	            lower = id.toLowerCase();
	            property = properties[id] || {};
	            if (typeof property.viewModel !== "function") { throw new Error("properties.viewModel must be a function."); }
	            this._properties[lower] = { name: property.name || id, data: property.data, id: id, viewModel: property.viewModel };
	        }
	    }
	    this.options = buildPropertyPicklistData(this._properties, excludeAnything);
	
	    // initialize
	    this.hidden = ko.observable(hidden);
	    this.phrase = ko.observable(phrase);
	    this._internalUpdate = false;
	    this._hideOnReset = hideOnReset;
	    this.items = ko.observableArray();
	    this.supportedQuery = ko.observable(false);
	
	    // bound functions
	    this.add = AdvancedSearchViewModel.prototype.add.bind(this);
	    this.remove = AdvancedSearchViewModel.prototype.remove.bind(this);
	    this.reset = AdvancedSearchViewModel.prototype.reset.bind(this);
	    this.toggle = AdvancedSearchViewModel.prototype.toggle.bind(this);
	
	    // subscriptions
	    this._items = ko.computed(this._itemsChanged, this);
	    this._hiddenSubscription = this.hidden.subscribe(this._phraseChanged, this);
	    this._phraseSubscription = this.phrase.subscribe(this._phraseChanged, this);
	
	    // trigger parsing of initial phrase and update of items & supportedQuery (if not hidden)
	    this.phrase.valueHasMutated();
	}
	
	
	//-------------------------------------------
	AdvancedSearchViewModel.prototype.add = function advancedSearchViewModelAdd() {
	    this.items.push(new AdvancedSearchItemViewModel(this, undefined, undefined, undefined, true));
	    return false;
	};
	
	
	//-------------------------------------------
	AdvancedSearchViewModel.prototype.remove = function advancedSearchViewModelRemove(item) {
	    var items = this.items.peek();
	    if (Array.isArray(items) && items.length > 1) {
	        var removedItems = this.items.remove(item), len = removedItems.length, i;
	        for (i = 0; i < len; i += 1) {
	            removedItems[i].dispose();
	        }
	    } else {
	        this.reset();
	        this.hidden(true);
	    }
	    return false;
	};
	
	
	//-------------------------------------------
	AdvancedSearchViewModel.prototype.reset = function advancedSearchViewModelReset() {
	    this.phrase("");
	    var item = this.items.peek();
	    item = item && item[0];
	    if (typeof item.property === "function") { item.property(""); }
	    if (this._hideOnReset) { this.hidden(true); }
	    return false;
	};
	
	
	//-------------------------------------------
	AdvancedSearchViewModel.prototype.toggle = function advancedSearchViewModelToggle() {
	    this.hidden(!this.hidden.peek());
	    return false;
	};
	
	
	//-------------------------------------------
	// Refreshes the search phrase when anything
	// within the items is updated.
	AdvancedSearchViewModel.prototype._itemsChanged = shared.createInternalSubscription(
	    "items",
	    shared.createInternalUpdateGuard(
	        function advancedSearchViewModelItemsComputed() {
	            this.phrase(save(this.items(), this.supportedQuery.peek(), this.phrase.peek()));
	        }
	    )
	);
	
	
	//-------------------------------------------
	// The function is passed to the advancedSearch item
	// used to lookup the property type.
	AdvancedSearchViewModel.prototype.lookupPropertyType = function advancedSearchViewModelLookupPropertyType(id) {
	    id = (typeof id === "string" ? id.toLowerCase() : "default");
	    var property = this._properties[id];
	    return property
	        ? { data: property.data, id: id, viewModel: property.viewModel }
	        : { id: id, viewModel: DefaultAdvancedSearchItem };
	};
	
	
	//-------------------------------------------
	// Reloads the `items` if either the
	// `phrase` or `hidden` observables have changed.
	AdvancedSearchViewModel.prototype._phraseChanged = shared.createInternalUpdateGuard(
	    function advancedSearchViewModelPhraseChanged() {
	        if (!this.hidden.peek()) {
	            var parsed = parse(this, this._excludeAnything, this.phrase.peek());
	            this.items(parsed.phrase);
	            this.supportedQuery(parsed.supportedQuery);
	        }
	    }
	);
	
	module.exports = AdvancedSearchViewModel;
	


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	module.exports = __webpack_require__(371);
	


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var searchQuery = __webpack_require__(455);
	var disposeObject = __webpack_require__(375).disposeObject;
	var stringUtil = __webpack_require__(13);
	
	var shared = __webpack_require__(22);
	
	//-------------------------------------------
	// Retrieves default value (phrase) for particular property,
	// specified via [template data].defaultValue or [*AdvancedSearchItem].prototype.defaultValue.
	// Returns empty string if neither specified of above was defined.
	var getDefaultPhrase = shared.createDefaultValueResolverFunction("", "defaultValue", "viewModel.prototype.defaultValue");
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// AdvancedSearchItem view-model
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Initializes the view-model for a new
	// advanced search item.  Essentially a key (property)
	// value (phrase) pair.
	function AdvancedSearchItemViewModel(owner, property, phrase, not, hasFocus) {
	    if (!(this instanceof AdvancedSearchItemViewModel)) { return new AdvancedSearchItemViewModel(owner, property, phrase, not, hasFocus); } // if new was not used, force it now
	
	    // the advancedSearchViewModel used to resolve the type from a property name.
	    if (owner && typeof owner.lookupPropertyType !== "function") { throw new Error("owner.propertyLookup must be a function"); }
	
	    // normalize parameters
	    not = !!not;
	    property = (typeof property === "string") ? property : "";
	    // Use default if and only if input phrase is undefined (not specified),
	    // otherwise we might override user's input.
	    var template = owner.lookupPropertyType(property);
	    phrase = (phrase === undefined)
	        ? getDefaultPhrase(template)
	        : (typeof phrase === "string") ? phrase : "";
	
	    // state
	    this.not = ko.observable(not);
	    this.property = ko.observable(property);
	    this.phrase = ko.observable(phrase);
	
	    // initialize
	    this.extras = function advancedSearchItemExtras() { return; };
	    this.extras.owner = owner;
	    this.extras.template = ko.observable(this._loadViewModel(template));
	    this.extras.hasFocus = ko.observable(!!hasFocus);
	
	    // subscriptions
	    this._propertySubscription = this.property.subscribe(this._propertyChanged, this);
	    this._phraseSubscription = this.phrase.subscribe(this._phraseChanged, this);
	    this._notSubscription = this.not.subscribe(this._phraseChanged, this);
	    this._templateComputed = ko.computed(this._templateViewModelChanged, this);
	}
	
	
	//-------------------------------------------
	// Disposes of the current view-model item.
	AdvancedSearchItemViewModel.prototype.dispose = function advancedSearchItemViewModelDispose() {
	    this._templateComputed.dispose();
	    this._notSubscription.dispose();
	    this._phraseSubscription.dispose();
	    this._propertySubscription.dispose();
	    disposeObject(this.extras.template(), true);
	};
	
	
	//-------------------------------------------
	// Converts the advanced search item to a search query
	AdvancedSearchItemViewModel.prototype.toSearchQuery = function advancedSearchItemViewModelToSearchQuery() {
	    var property = this.property(),
	        phrase = this.phrase(),
	        not = this.not();
	    if (stringUtil.isNullOrWhitespace(phrase)) { return null; }
	    var query = stringUtil.isNullOrWhitespace(property)
	        ? searchQuery.buildPhrase(phrase)
	        : searchQuery.buildProperty(property, phrase);
	    return (not ? searchQuery.buildBinary("not", query) : query);
	};
	
	
	//-------------------------------------------
	AdvancedSearchItemViewModel.prototype._loadViewModel = function advancedSearchItemViewModelLoadViewModel(template) {
	    var viewModel = template.viewModel(template.data);
	    viewModel.load(this.phrase.peek(), this.not.peek());
	    return { name: template.viewModel.prototype.templateId, data: viewModel };
	};
	
	
	//-------------------------------------------
	// Update `template` if `property` and resolved
	// template have changed.
	AdvancedSearchItemViewModel.prototype._propertyChanged = shared.createInternalUpdateGuard(
	    function advancedSearchItemViewModelPropertyChanged(value) {
	        var template = this.extras.owner.lookupPropertyType(value);
	        this.phrase(getDefaultPhrase(template));
	        this.extras.template(this._loadViewModel(template));
	    }
	);
	
	
	//-------------------------------------------
	// Reloads the `templateViewModel` if either the
	// `phrase` or `not` observables have changed.
	AdvancedSearchItemViewModel.prototype._phraseChanged = shared.createInternalUpdateGuard(
	    function advancedSearchItemViewModelPhraseChanged() {
	        var phrase = this.phrase.peek(),
	            not = this.not.peek(),
	            viewModel = this.extras.template();
	        viewModel = viewModel && viewModel.data;
	        if (viewModel && typeof viewModel.load === "function") { viewModel.load(phrase, not); }
	    }
	);
	
	
	//-------------------------------------------
	// Updates the phrase and not when any changes
	// are made to the `templateViewModel`.
	AdvancedSearchItemViewModel.prototype._templateViewModelChanged = shared.createInternalSubscription(
	    "extras.template",
	    shared.createInternalUpdateGuard(
	        function advancedSearchItemViewModelTemplateViewModelChanged() {
	            var viewModel = this.extras.template();
	            viewModel = viewModel && viewModel.data;
	            if (viewModel && typeof viewModel.save === "function") {
	                var result = viewModel.save(), phrase = result[0];
	                this.phrase(typeof phrase === "string" ? phrase : "");
	                this.not(!!result[1]);
	            }
	        }
	    )
	);
	
	
	module.exports = AdvancedSearchItemViewModel;
	


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/**
	 * TODO: Remove in v8.
	 */
	"use strict";
	var ko = __webpack_require__(9);
	__webpack_require__(458);
	var targetenv_1 = __webpack_require__(3);
	var debug_1 = __webpack_require__(459);
	var disposable_1 = __webpack_require__(375);
	var pliBindings_1 = __webpack_require__(460);
	var subscribeWithChanges_1 = __webpack_require__(446);
	var util_1 = __webpack_require__(386);
	subscribeWithChanges_1.activateSubscribeWithChanges();
	/** @deprecated Use 'dirtyFlag' from 'knockout/util'. TODO: Remove in v8. */
	ko.dirtyFlag = util_1.dirtyFlag;
	/** @deprecated Use 'disposeObject' from 'util/disposable'. TODO: Remove in v8. */
	ko.disposeObject = disposable_1.disposeObject;
	if (targetenv_1.isBrowser) {
	    pliBindings_1.activateAllPliBindings();
	    debug_1.exportInGlobalDbg("ko", ko);
	}
	module.exports = ko;
	



/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	// knockout-postbox 0.5.2 | (c) 2015 Ryan Niemeyer |  http://www.opensource.org/licenses/mit-license
	;(function(factory) {
	    //CommonJS
	    if (true) {
	        factory(__webpack_require__(9), exports);
	    //AMD
	    } else if (typeof define === "function" && define.amd) {
	        define(["knockout", "exports"], factory);
	    //normal script tag
	    } else {
	        factory(ko, ko.postbox = {});
	    }
	}(function(ko, exports, undefined) {
	    var disposeTopicSubscription, existingSubscribe,
			subscriptions = {},
			subId = 1;
	
		exports.subscriptions = subscriptions;
	
	    //create a global postbox that supports subscribing/publishing
	    ko.subscribable.call(exports);
	
	    //keep a cache of the latest value and subscribers
	    exports.topicCache = {};
	
	    //allow customization of the function used to serialize values for the topic cache
	    exports.serializer = ko.toJSON;
	
	    //wrap notifySubscribers passing topic first and caching latest value
	    exports.publish = function(topic, value) {
	        if (topic) {
	            //keep the value and a serialized version for comparison
	            exports.topicCache[topic] = {
	                value: value,
	                serialized: exports.serializer(value)
	            };
	            exports.notifySubscribers(value, topic);
	        }
	    };
	
	    //provide a subscribe API for the postbox that takes in the topic as first arg
	    existingSubscribe = exports.subscribe;
	    exports.subscribe = function(topic, action, target, initializeWithLatestValue) {
	        var subscription, current, existingDispose;
	
	        if (topic) {
	            if (typeof target === "boolean") {
	                initializeWithLatestValue = target;
	                target = undefined;
	            }
	
	            subscription = existingSubscribe.call(exports, action, target, topic);
				subscription.subId = ++subId;
				subscriptions[ subId ] = subscription;
	
	            if (initializeWithLatestValue) {
	                current = exports.topicCache[topic];
	
	                if (current !== undefined) {
	                    action.call(target, current.value);
	                }
	            }
	
				existingDispose = subscription.dispose;
				subscription.dispose = function() {
					delete subscriptions[subscription.subId];
					existingDispose.call(subscription);
				};
	
	            return subscription;
	        }
	    };
	
		//clean up all subscriptions and references
		exports.reset = function() {
			var subscription;
	
			for (var id in subscriptions) {
				if (subscriptions.hasOwnProperty(id)) {
					subscription = subscriptions[id];
	
					if (subscription && typeof subscription.dispose === "function") {
						subscription.dispose();
					}
				}
			}
	
			exports.topicCache = {};
		};
	
	    //by default publish when the previous cached value does not equal the new value
	    exports.defaultComparer = function(newValue, cacheItem) {
	        return cacheItem && exports.serializer(newValue) === cacheItem.serialized;
	    };
	
	    //augment observables/computeds with the ability to automatically publish updates on a topic
	    ko.subscribable.fn.publishOn = function(topic, skipInitialOrEqualityComparer, equalityComparer) {
	        var skipInitialPublish, subscription, existingDispose;
	
	        if (topic) {
	            //allow passing the equalityComparer as the second argument
	            if (typeof skipInitialOrEqualityComparer === "function") {
	                equalityComparer = skipInitialOrEqualityComparer;
	            } else {
	                skipInitialPublish = skipInitialOrEqualityComparer;
	            }
	
	            equalityComparer = equalityComparer || exports.defaultComparer;
	
	            //remove any existing subs
	            disposeTopicSubscription.call(this, topic, "publishOn");
	
	            //keep a reference to the subscription, so we can stop publishing
	            subscription = this.subscribe(function(newValue) {
					if (!equalityComparer.call(this, newValue, exports.topicCache[topic])) {
						exports.publish(topic, newValue);
					}
				}, this);
	
				//track the subscription in case of a reset
				subscription.id = ++subId;
				subscriptions[subId] = subscription;
	
				//ensure that we cleanup pointers to subscription on dispose
				existingDispose = subscription.dispose;
				subscription.dispose = function() {
					delete this.postboxSubs[topic].publishOn;
					delete subscriptions[subscription.id];
	
					existingDispose.call(subscription);
				}.bind(this);
	
				this.postboxSubs[topic].publishOn = subscription;
	
	            //do an initial publish
	            if (!skipInitialPublish) {
	                exports.publish(topic, this());
	            }
	        }
	
	        return this;
	    };
	
	    //handle disposing a subscription used to publish or subscribe to a topic
	    disposeTopicSubscription = function(topic, type) {
	        var subs = this.postboxSubs = this.postboxSubs || {};
	        subs[topic] = subs[topic] || {};
	
	        if (subs[topic][type]) {
	            subs[topic][type].dispose();
	        }
	    };
	
	    //discontinue automatically publishing on a topic
	    ko.subscribable.fn.stopPublishingOn = function(topic) {
	        disposeTopicSubscription.call(this, topic, "publishOn");
	
	        return this;
	    };
	
	    //augment observables/computeds to automatically be updated by notifications on a topic
	    ko.subscribable.fn.subscribeTo = function(topic, initializeWithLatestValueOrTransform, transform) {
	        var initializeWithLatestValue, current, callback, subscription, existingDispose,
	            self = this;
	
	        //allow passing the filter as the second argument
	        if (typeof initializeWithLatestValueOrTransform === "function") {
	            transform = initializeWithLatestValueOrTransform;
	        } else {
	            initializeWithLatestValue = initializeWithLatestValueOrTransform;
	        }
	
	        if (topic && ko.isWriteableObservable(this)) {
	            //remove any existing subs
	            disposeTopicSubscription.call(this, topic, "subscribeTo");
	
	            //if specified, apply a filter function in the subscription
	            callback = function(newValue) {
	                self(transform ? transform.call(self, newValue) : newValue);
	            };
	
				////keep a reference to the subscription, so we can unsubscribe, if necessary
				subscription = exports.subscribe(topic, callback);
				this.postboxSubs[topic].subscribeTo = subscription;
	
				//ensure that we cleanup pointers to subscription on dispose
				existingDispose = subscription.dispose;
				subscription.dispose = function() {
					delete this.postboxSubs[topic].subscribeTo;
					existingDispose.call(subscription);
				}.bind(this);
	
	            if (initializeWithLatestValue) {
	                current = exports.topicCache[topic];
	
	                if (current !== undefined) {
	                    callback(current.value);
	                }
	            }
	        }
	
	        return this;
	    };
	
	    //discontinue receiving updates on a topic
	    ko.subscribable.fn.unsubscribeFrom = function(topic) {
	        disposeTopicSubscription.call(this, topic, "subscribeTo");
	
	        return this;
	    };
	
	    // both subscribe and publish on the same topic
	    //   -allows the ability to sync an observable/writeable computed/observableArray between view models
	    //   -subscribeTo should really not use a filter function, as it would likely cause infinite recursion
	    ko.subscribable.fn.syncWith = function(topic, initializeWithLatestValue, skipInitialOrEqualityComparer, equalityComparer) {
	        this.subscribeTo(topic, initializeWithLatestValue).publishOn(topic, skipInitialOrEqualityComparer, equalityComparer);
	
	        return this;
	    };
	
	    ko.postbox = exports;
	}));
	


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var targetEnv = __webpack_require__(3);
	/**
	 * Adds an object to the global variable's 'dbg' object for the purposes of browser debugging.
	 */
	function exportInGlobalDbg(name, debugObj) {
	    if (typeof name !== "string" || name.length === 0) {
	        throw new Error("A name must be specified for the object");
	    }
	    if (targetEnv.isBrowser) {
	        var expandableGlobal = global;
	        if (!expandableGlobal.dbg) {
	            expandableGlobal.dbg = {};
	        }
	        expandableGlobal.dbg[name] = debugObj;
	    }
	    return debugObj;
	}
	exports.exportInGlobalDbg = exportInGlobalDbg;
	

	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var pliButtonText_1 = __webpack_require__(461);
	var pliDisableButton_1 = __webpack_require__(462);
	var pliDisableField_1 = __webpack_require__(402);
	var pliEnableButton_1 = __webpack_require__(463);
	var pliEnableField_1 = __webpack_require__(464);
	var pliHasFocus_1 = __webpack_require__(403);
	var pliReadOnlyField_1 = __webpack_require__(404);
	var stopBinding_1 = __webpack_require__(385);
	function activateAllPliBindings() {
	    return {
	        pliButtonText: pliButtonText_1.activatePliButtonTextBinding(),
	        pliDisableButton: pliDisableButton_1.activatePliDisableButtonBinding(),
	        pliDisableField: pliDisableField_1.activatePliDisableFieldBinding(),
	        pliButtonTextpliEnableButton: pliEnableButton_1.activatePliEnableButtonBinding(),
	        pliEnableField: pliEnableField_1.activatePliEnableFieldBinding(),
	        pliHasFocus: pliHasFocus_1.activatePliHasFocusBinding(),
	        pliReadOnlyField: pliReadOnlyField_1.activatePliReadOnlyFieldBinding(),
	        stopBinding: stopBinding_1.activateStopBinding()
	    };
	}
	exports.activateAllPliBindings = activateAllPliBindings;
	



/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var $ = __webpack_require__(1);
	var util_1 = __webpack_require__(386);
	/**
	 * Returns true if the element assigned to "this" is a Text node (node type = 3).
	 *
	 * TODO Uncomment "this"" typing for TypeScript 2.0.
	 */
	function isTextNode() {
	    return this.nodeType === 3;
	}
	var pliButtonTextBinding = {
	    update: function (element, valueAccessor) {
	        var text = ko.unwrap(valueAccessor()) || "-";
	        // set title without removing child elements (span with icon); see http://stackoverflow.com/questions/4106809/in-jquery-how-can-i-change-an-elements-text-without-changing-its-child-elements/4106957#4106957
	        $(element)
	            .find("span")
	            .contents() // enumerate children
	            .filter(isTextNode)
	            .eq(0) // first text node
	            .replaceWith(text);
	    }
	};
	/**
	 * Activates the 'pliButtonText' binding.
	 */
	function activatePliButtonTextBinding() {
	    return util_1.addBindingHandler("pliButtonText", pliButtonTextBinding);
	}
	exports.activatePliButtonTextBinding = activatePliButtonTextBinding;
	



/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var pliEnableButton_1 = __webpack_require__(463);
	var util_1 = __webpack_require__(386);
	var pliDisableButtonBinding = {
	    update: function (element, valueAccessor) {
	        var enabled = !ko.unwrap(valueAccessor());
	        pliEnableButton_1.setButtonEnabledState(element, enabled);
	    }
	};
	/**
	 * Activates the 'pliDisableButton' binding.
	 */
	function activatePliDisableButtonBinding() {
	    return util_1.addBindingHandler("pliDisableButton", pliDisableButtonBinding);
	}
	exports.activatePliDisableButtonBinding = activatePliDisableButtonBinding;
	



/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var util_1 = __webpack_require__(386);
	function setButtonEnabledState(element, enabled) {
	    ko.bindingHandlers.enable.update(element, function () { return enabled; });
	    ko.utils.toggleDomNodeCssClass(element.parentElement, "disabled", !enabled);
	}
	exports.setButtonEnabledState = setButtonEnabledState;
	var pliEnableButtonBinding = {
	    update: function (element, valueAccessor) {
	        var enabled = ko.unwrap(valueAccessor());
	        setButtonEnabledState(element, enabled);
	    }
	};
	/**
	 * Activates the 'pliEnableButton' binding.
	 */
	function activatePliEnableButtonBinding() {
	    return util_1.addBindingHandler("pliEnableButton", pliEnableButtonBinding);
	}
	exports.activatePliEnableButtonBinding = activatePliEnableButtonBinding;
	



/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var pliDisableField_1 = __webpack_require__(402);
	var util_1 = __webpack_require__(386);
	var pliEnableFieldBinding = {
	    update: function (element, valueAccessor) {
	        var enabled = ko.unwrap(valueAccessor());
	        pliDisableField_1.setFieldEnabledState(element, enabled);
	    }
	};
	/**
	 * Activates the 'pliEnableField' binding.
	 */
	function activatePliEnableFieldBinding() {
	    return util_1.addBindingHandler("pliEnableField", pliEnableFieldBinding);
	}
	exports.activatePliEnableFieldBinding = activatePliEnableFieldBinding;
	



/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	// for backwards compatibility, also export "viewModelInit" on "pli" object
	var pli = __webpack_require__(380);
	pli.viewModelInit = __webpack_require__(466);
	module.exports = pli.viewModelInit;
	


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true, regexp: true, todo: true */
	
	"use strict";
	
	var ko = __webpack_require__(9);
	var targetenv = __webpack_require__(3);
	
	var pli = __webpack_require__(380);
	var knockoutUtil = __webpack_require__(386);
	var crumbIdUtil = __webpack_require__(387);
	var reloadPageIfObsolete = __webpack_require__(467);
	
	var shared = __webpack_require__(469);
	
	
	var viewModel = null;
	var showSpinnerTimeout = null;
	var creationContributors = []; // functions to be called immediately after 'ViewModelInit.createRoot'
	var appliedContributors = []; // functions to be called immediately after 'ko.applyBindings' of pli.viewModel
	
	
	//-------------------------------------------
	function executeCallbacks(callbacks, viewModel, viewModelInit) {
	    if (callbacks) {
	        var i, l;
	        for (i = 0, l = callbacks.length; i < l; i += 1) {
	            callbacks[i](viewModel, viewModelInit);
	        }
	    }
	}
	
	
	//-------------------------------------------
	// Process both successful and failing
	// document load attempts.
	function processLoadResponse(response) {
	    var result = response.result,
	        rootData = viewModel.extras.rootData || {};
	
	    // check whether there is need to reload current page due to incompatible client and server versions
	    if (reloadPageIfObsolete(response)) { return; }
	
	    // cleanup
	    rootData.call = null;
	    if (showSpinnerTimeout !== null) { // in case load finished before progress was shown, cancel the pending timeout
	        clearTimeout(showSpinnerTimeout);
	        showSpinnerTimeout = null;
	    }
	
	    // process response
	    if (console.group) { console.group("viewModel load response:", response); }
	    if (response.isError) {
	        if (console.warn) { console.warn("Document load failed:", response); }
	        if (response.clientXhr && response.clientXhr.status === 403) { // "Forbidden" => we probably need to logon
	            location.reload(true); // force reload should redirect us to logon page (and include current URL as return address); TODO: should be handled by Pli.call (which should show popup dialog instead of redirecting to login dialog)
	        } else {
	            rootData.value = result || { message: "Document could not be loaded" }; // used by progress indicator (failure subtitle)
	            viewModel.extras.state("init.visible.failed");
	        }
	    } else {
	        viewModel.load(result);
	        if (response.clientXhr) { // if response was not immediate (i.e. server call), process the location hash again -- maybe we can get further this time if navigation pages were enabled; otherwise (immediate response) we are still in the middle of processing location hash and shouldn't re-process it
	            pli.forms.onHashChange();
	        }
	        viewModel.extras.state("ready");
	        pli.forms.resetActivationFocus();
	    }
	    if (console.groupEnd) { console.groupEnd(); }
	}
	
	
	//-------------------------------------------
	// Load viewModel (as referenced by the module
	// variable) from the specified record.
	function loadViewModel(record) {
	    var viewModelId;
	
	    viewModel.extras.rootData.value = record;
	    viewModel.extras.dirty.suspend();
	    viewModel.loaded(record);
	
	    // if viewModel ID changed, update URL hash
	    viewModelId = (viewModel.id ? viewModel.id() : null);
	    if (viewModelId && !crumbIdUtil.areEqual(viewModel.extras.rootData.id, viewModelId)) {
	        viewModel.extras.rootData.id = viewModelId;
	        viewModel.extras.rootForm.open({
	            id: viewModelId,
	            replaceId: true,
	            replacePreservesCrumbsTail: true,
	            includeInHash: true,
	            doNotUpdateHistory: true
	        });
	        pli.forms.onHashChange(); // make sure crumbs are updated at this point
	    }
	
	    // resume and reset dirty flag tracking
	    viewModel.extras.dirty.resume(true);
	}
	
	
	//---------------------------------------
	// Save viewModel changes.
	function saveViewModel() {
	    var busyState = "busy.saving",
	        rootForm = pli.forms.root,
	        failedState = viewModel.extras.state.peek() + ".failed",
	        useBusyIndicator = pli.forms.registry.busyIndicator && !viewModel.extras.suppressBusyIndicator;
	    if (viewModel.extras.dirty() && shared.validateDeep(viewModel)) {
	        if (viewModel.saving) { viewModel.saving(); }
	        if (useBusyIndicator) {
	            pli.forms.registry.busyIndicator.open({
	                state: busyState,
	                message: "Saving, please wait...",
	                title: "Save in progress"
	            });
	        } else {
	            viewModel.extras.state(busyState);
	        }
	        pli.call({ name: rootForm.saveCallName, jsonData: viewModel.extras.dirty.currentJSON() }).always(function processSaveResponse(response) {
	            if (console.group) { console.group("viewModel save response:", response); }
	            if (response.isError) {
	                // if (console.warn) { console.warn("viewModel save failed"); }
	                var validationErrors = response.result.validationErrors;
	                if (useBusyIndicator) {
	                    pli.forms.registry.busyIndicator.complete({
	                        state: failedState,
	                        failed: true,
	                        message: response.result.message || "Unexpected save error",
	                        title: "Save failed",
	                        onClosed: (!validationErrors
	                            ? null
	                            : function () { shared.applyValidationErrors(viewModel, validationErrors); })
	                    });
	                } else {
	                    shared.applyValidationErrors(viewModel, validationErrors);
	                    viewModel.extras.state(failedState);
	                }
	            } else {
	                if (useBusyIndicator) {
	                    pli.forms.registry.busyIndicator.close({ // forced close
	                        state: busyState,
	                        force: true
	                    });
	                }
	                viewModel.load(response.result);
	                viewModel.extras.state("ready.saved");
	            }
	            if (console.groupEnd) { console.groupEnd(); }
	        });
	    }
	    return false;
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// ViewModelInit class (singleton)
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Create new instance of ViewModelInit class.
	// Set properties to initial values, no other action.
	function ViewModelInit() {
	    this.createRoot = null; // how to create "root" viewmodel (Pli.viewModel); expected to be set to a valid function by a JavaScript component included after this one
	    this.defaultKeymap = { // last-chance keyboard handling, can't be prevented
	        "Esc": false,
	        "F1": false,
	        "F3": false,
	        "F5": false
	    };
	    this.keymap = {}; // main keymap for rootForm
	}
	
	
	//-------------------------------------------
	// Creates or updates viewmodel associated with the root crumb.
	//
	// Handles "pliInitializingFormData" event. If no viewmodel
	// is active, a new instance is created using "createRoot",
	// then initialized and a new async data load operation
	// is started; if a viewmodel is already active, a new async
	// load operation is started (assuming root document ID has changed).
	ViewModelInit.prototype.setViewModelAsFormData = function setViewModelAsFormData(event) {
	    var value, init = this;
	    var rootForm = pli.forms.root;
	    if (viewModel === null) { // is this the first time form is being initialized?
	        // create viewmodel instance + give other scripts
	        // a chance to initialize/extend it
	        if (typeof init.createRoot !== "function") {
	            throw new Error("ViewModelInit.setViewModelAsFormData: ViewModelInit.createRoot must be a valid function");
	        }
	
	        if (init.disableLegacyCallbacks) {
	            if (creationContributors && creationContributors.length > 0) { throw new Error("Legacy callbacks are disabled, unable to register \"onViewModelCreated\""); }
	            creationContributors = null;
	
	            if (appliedContributors && appliedContributors.length > 0) { throw new Error("Legacy callbacks are disabled, unable to register \"onBindingsApplied\""); }
	            appliedContributors = null;
	        }
	
	        var newViewModel = init.createRoot();
	        if (!newViewModel) {
	            throw new Error("ViewModelInit.setViewModelAsFormData: ViewModelInit.createRoot was expected to return an object");
	        }
	        pli.viewModel = viewModel = newViewModel;
	        if (!viewModel.extras) {
	            viewModel.extras = function ViewModelExtras() { return; };
	        }
	        if (!viewModel.extras.state) {
	            viewModel.extras.state = shared.createViewModelState();
	            viewModel.extras.state.syncWith("state");
	        }
	        viewModel.extras.rootForm = rootForm;
	        viewModel.extras.rootData = null;
	        viewModel.load = loadViewModel;
	        viewModel.save = saveViewModel;
	        executeCallbacks(creationContributors, viewModel, init);
	        creationContributors = null;
	        if (typeof viewModel.created === "function") {
	            viewModel.created(init);
	        }
	        if (!viewModel.extras.dirty) { // initialize dirty tracking as the last thing to happen on viewmodel before binding (if not yet initialized)
	            viewModel.extras.dirty = knockoutUtil.dirtyFlag(viewModel, true, false); // create suspended, non-persistent dirty flag
	        }
	
	        // register root & default keymaps
	        rootForm.page.keymap = rootForm.id;
	        if (typeof viewModel.createKeymapSpec === "function") {
	            var keymapSpec = viewModel.createKeymapSpec();
	            if (keymapSpec) {
	                pli.keys.registerKeymap(rootForm.id, keymapSpec.formKeymap);
	                pli.keys.registerKeymap("default", keymapSpec.defaultKeymap);
	                pli.keys.setSchema(keymapSpec.formSchema);
	            }
	        } else {
	            pli.keys.registerKeymap(rootForm.id, init.keymap);
	            pli.keys.registerKeymap("default", init.defaultKeymap);
	        }
	        pli.viewModelInit = null; // only reset for backward compatiblity
	
	        // connect (bind) viewModel to HTML
	        if (targetenv.isBrowser) {
	            ko.applyBindings(viewModel);
	        }
	
	        executeCallbacks(appliedContributors, viewModel, init);
	        appliedContributors = null;
	        if (typeof viewModel.appliedBindings === "function") {
	            viewModel.appliedBindings(init);
	        }
	    } else { // nope, form data has been initialized before (just reset state)
	        if (viewModel.extras.rootData) {
	            if (crumbIdUtil.areEqual(viewModel.extras.rootData.id, event.pli.data.id)) { // we are just updating URL hash after updating viewModel.id
	                event.pli.data.value = viewModel.extras.rootData.value;
	                event.pli.data.form = viewModel.extras.rootData.form;
	                viewModel.extras.rootData = event.pli.data;
	                return viewModel;
	            }
	            viewModel.extras.rootData.value = null;
	        }
	        viewModel.extras.state("init");
	    }
	
	    // kickstart data loading (if needed)
	    viewModel.extras.rootData = event.pli.data;
	    if (typeof viewModel.loading === "function") {
	        value = viewModel.loading(event.pli.data);
	    }
	    if (value) {
	        processLoadResponse({ result: value });
	    } else {
	        if (typeof rootForm.loadCallName !== "string") {
	            processLoadResponse({ isError: true, result: { message: "Expected string property \"rootForm.loadCallName\" (name of PLI call to load document data)" } });
	        } else if (typeof rootForm.saveCallName !== "string") {
	            processLoadResponse({ isError: true, result: { message: "Expected string property \"rootForm.saveCallName\" (name of PLI call to save document data)" } });
	        } else {
	            showSpinnerTimeout = setTimeout(function () {
	                showSpinnerTimeout = null;
	                viewModel.extras.state("init.visible");
	            }, 250);
	
	            var loadData = viewModel.extras.rootData.loadData;
	            if (loadData) {
	                viewModel.extras.rootData.loadData = null;
	            } else {
	                loadData = { id: viewModel.extras.rootData.id };
	            }
	            event.pli.data.call = pli.call({
	                name: rootForm.loadCallName,
	                data: loadData,
	                deferSignInUiClosingUntil: viewModel.extras.state && viewModel.extras.state.isLoaded
	            }).always(processLoadResponse);
	        }
	    }
	
	    return viewModel;
	};
	
	
	//-------------------------------------------
	// Obsolete, do not use (use require("shared").applyValidationErrors instead).
	ViewModelInit.prototype.applyValidationErrors = function (validationErrors) {
	    shared.applyValidationErrors(this, validationErrors);
	};
	
	
	//-------------------------------------------
	// Obsolete, do not use (use direct require/import instead).
	ViewModelInit.prototype.createGridViewModelFactory = __webpack_require__(470);
	
	
	//-------------------------------------------
	// Flag that controls support for legacy callbacks
	// ("onBindingsApplied" and "onViewModelCreated").
	// When false (default), callbacks can be used.
	// When true, all attempts to register legacy
	// callbacks will throw an exception.
	// It is strongly recommended that all new code
	// disables legacy callbacks.
	ViewModelInit.prototype.disableLegacyCallbacks = false;
	
	
	//-------------------------------------------
	// Obsolete, do not use (use direct require/import instead).
	ViewModelInit.prototype.enableSlideTransitions = __webpack_require__(471);
	
	
	//-------------------------------------------
	// Register a new callback to be called after
	// ko.applyBindings is called for viewModel.
	// Callbacks will be called in the order in
	// which they were registered.
	ViewModelInit.prototype.onBindingsApplied = function (callback) {
	    if (appliedContributors === null) { throw new Error("Legacy callbacks are disabled, unable to register \"onBindingsApplied\""); }
	    appliedContributors.push(callback);
	};
	
	
	//-------------------------------------------
	// Register a new callback to be called after
	// viewmodel is created. Callbacks will be called
	// in the order in which they were registered.
	ViewModelInit.prototype.onViewModelCreated = function (callback) {
	    if (creationContributors === null) { throw new Error("Legacy callbacks are disabled, unable to register \"onViewModelCreated\""); }
	    creationContributors.push(callback);
	};
	
	
	//-------------------------------------------
	// Resets "ViewModelInit" environment to be able to create a new root viewmodel.
	ViewModelInit.prototype.reset = function resetViewModelInit(viewModelSpec) {
	    // cancel async operations (that we know of)
	    if (showSpinnerTimeout !== null) {
	        clearTimeout(showSpinnerTimeout);
	        showSpinnerTimeout = null;
	    }
	
	    viewModel = null;
	    creationContributors = null;
	    appliedContributors = null;
	
	    pli.viewModel = null;
	    pli.viewModelInit = this;
	
	    var lastViewModelSpec = { createRoot: this.createRoot, disableLegacyCallbacks: this.disableLegacyCallbacks };
	
	    if (viewModelSpec) {
	        this.disableLegacyCallbacks = !!(viewModelSpec.disableLegacyCallbacks);
	        if (viewModelSpec.rootViewModelClass) {
	            this.createRoot = function createRootViewModelFromClass() { return new viewModelSpec.rootViewModelClass(); };
	        } else if (viewModelSpec.createRoot) {
	            this.createRoot = viewModelSpec.createRoot;
	        }
	    } else {
	        this.createRoot = null;
	        this.disableLegacyCallbacks = false;
	    }
	    return lastViewModelSpec;
	};
	
	
	//-------------------------------------------
	// Obsolete, do not use (use require("shared").computeErrorsCount instead).
	ViewModelInit.prototype.computeErrorsCount = function () {
	    return shared.computeErrorsCount(this);
	};
	
	
	//-------------------------------------------
	// Obsolete, do not use (use require("shared").validateDeep instead).
	ViewModelInit.prototype.validateDeep = function () {
	    return shared.validateDeep(this);
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	var viewModelInit = new ViewModelInit();
	if (targetenv.isBrowser) {
	    // set viewmodel as root form data (triggered for the first time just after scripts are loaded and Pli.forms (navigation) module finishes its initialization)
	    pli.forms.root.$form.on("pliInitializingFormData", function initializeFormData(event) {
	        if (event.pli.data.form === pli.forms.root) { // ignore pliInitializingFormData events for non-root (e.g. nested) forms
	            viewModelInit.setViewModelAsFormData(event);
	            return false; // mark this event as handled
	        }
	    });
	}
	
	module.exports = viewModelInit;
	


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var window_1 = __webpack_require__(468);
	module.exports = window_1.reloadPageIfObsolete;
	



/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var pli_1 = __webpack_require__(6);
	/**
	 * The name of the Pli version header.
	 */
	exports.versionHeaderConst = "X-Pli-Server-Version";
	/**
	 * Force-reloads current browser page if "Pli.call" response version doesn't match page version.
	 *
	 * No reload is triggered if the response doesn't have version info.
	 *
	 * @returns
	 *     "true" if the current page was force-reloaded, false otherwise.
	 */
	function reloadPageIfObsolete(response) {
	    if (!response) {
	        throw new Error("Expected response object");
	    }
	    // reload page if client version doesn't match server's one
	    var serverVersion = response.clientXhr && response.clientXhr.getResponseHeader && response.clientXhr.getResponseHeader(exports.versionHeaderConst);
	    if (serverVersion && serverVersion !== pli_1.pli.config.appVersion) {
	        location.reload(true);
	        return true;
	    }
	    return false;
	}
	exports.reloadPageIfObsolete = reloadPageIfObsolete;
	/**
	 * Inject "versionHeader" property to "reloadPageIfObsolete" function.
	 *
	 * TODO Remove in next major version.
	 */
	var reloadPageIfObsolete;
	(function (reloadPageIfObsolete) {
	    /**
	     * Name of the Pli call response header that carries server-version information.
	     */
	    reloadPageIfObsolete.versionHeader = exports.versionHeaderConst;
	})(reloadPageIfObsolete = exports.reloadPageIfObsolete || (exports.reloadPageIfObsolete = {}));
	



/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var ko = __webpack_require__(9);
	var isBrowser = __webpack_require__(3).isBrowser;
	
	/**
	 * Applies a validation error to an observable at the specified viewmodel path.
	 *
	 * Walks up the path, starting at the end, looking for
	 * a "setErrorMessage" function. Once found, the function
	 * will be passed the error message and the remaining path
	 * component as parameters.
	 *
	 * @param viewModel
	 *     Viewmodel that contains the target observable path.
	 * @param path
	 *     Path to the observable. All indexers in the path are
	 *     assumed to be observables and will be evaluated prior
	 *     to indexing. E.g., foo[1].bar["b"] will be evaluated
	 *     as foo()[1].bar()["b"].
	 * @param message
	 *     Error message to set on the property.
	 */
	function applyErrorMessage(viewModel, path, message) {
	    var i = path.length;
	    var target, remainder;
	    var resolveFn, resolvedItem;
	
	    while (i >= 0) {
	        target = path.slice(0, i);
	        remainder = path.slice(path[i] === "." ? i + 1 : i); // strip leading "."
	
	        /*jslint evil: true */// inspired by knockout binding evaluation
	        resolveFn = new Function("viewModel", "with (viewModel) { return (".concat(target.replace(/\[/g, "()["), "); }"));
	        /*jslint evil: false */
	
	        resolvedItem = resolveFn(viewModel);
	        if (resolvedItem && typeof resolvedItem.setErrorMessage === "function") {
	            resolvedItem.setErrorMessage(message, remainder);
	            return;
	        }
	
	        // current split point didn't yield a "setErrorMessage" handler,
	        // move split point to parent (if any)
	        i = Math.max(
	            path.lastIndexOf(".", i - 1),
	            path.lastIndexOf("[", i - 1)
	        );
	    }
	
	    if (typeof viewModel.setErrorMessage === "function") {
	        viewModel.setErrorMessage(message, path);
	    } else if (isBrowser && console.warn) {
	        console.warn("Unable to set validation error for:", path);
	    }
	}
	
	
	/**
	 * Applies specified validation errors to the specified viewmodel.
	 *
	 * Expects validation errors to contain a map, keys being
	 * paths to "viewModel" fields/properties, values being
	 * error messages to set.
	 */
	function applyValidationErrors(viewModel, validationErrors) {
	    if (validationErrors) {
	        delete validationErrors.master;
	
	        var path;
	        for (path in validationErrors) {
	            if (validationErrors.hasOwnProperty(path)) {
	                applyErrorMessage(viewModel, path, validationErrors[path]);
	            }
	        }
	    }
	}
	
	
	/**
	 * Counts number of properties with "isValid" property set to "false" (single level, no recursion).
	 *
	 * This method is directly compatible with PliObservables.
	 * Instead of using this method directly, it is recommended
	 * that you create a pure computed observable using
	 * "createErrorsCountObservable" from this module.
	 */
	function computeErrorsCount(viewModel) {
	    var k, o, sum = 0;
	    for (k in viewModel) {
	        if (viewModel.hasOwnProperty(k) && k !== "extras" && k !== "id") {
	            o = viewModel[k];
	            if (o && ko.unwrap(o.isValid) === false) { // explicit check for "false", do not replace with "truthy" test; notice that we subscribe to all "isValid" observables we can find
	                sum += 1;
	            }
	        }
	    }
	    return sum;
	}
	
	
	/**
	 * Creates a computed observable that determines how many properties of the specified viewmodel have a validation error (single level, no recursion).
	 *
	 * If "isViewModelInitializing" is specified, errors count will be zero
	 * while the initializing flag remains true.
	 */
	function createErrorsCountObservable(viewModel, isViewModelInitializing) {
	    return ko.pureComputed(function computeErrorsCountObservable() {
	        return (ko.unwrap(isViewModelInitializing)
	            ? 0
	            : computeErrorsCount(viewModel));
	    });
	}
	
	
	/**
	 * Initializes a viewmodel state observable with a subscription to state changes.
	 */
	function createViewModelState(initialState) {
	    var state = ko.observable(initialState || "init");
	
	    state.isInitializing = ko.observable(true);
	    state.isReady = ko.observable(false);
	    state.isBusy = ko.observable(false);
	    state.isLoaded = ko.observable(false); // will switch to true when initial load is over (successfuly or not); used to control sign-on form visibility
	    state.subscribe(function viewModelStateChanged(stateValue) {
	        if (stateValue) {
	            if (stateValue.indexOf("ready") === 0) {
	                this.isInitializing(false);
	                this.isReady(true);
	                this.isBusy(false);
	                this.isLoaded(true);
	                return;
	            }
	            if (stateValue.indexOf("busy") === 0) {
	                this.isInitializing(false);
	                this.isReady(false);
	                this.isBusy(true);
	                this.isLoaded(true);
	                return;
	            }
	            if (stateValue.indexOf("init") === 0) {
	                this.isInitializing(true);
	                this.isReady(false);
	                this.isBusy(false);
	                this.isLoaded(stateValue === "init.visible.failed");
	                return;
	            }
	        }
	        this.isInitializing(false);
	        this.isReady(false);
	        this.isBusy(false);
	        this.isLoaded(false);
	    }, state);
	
	    return state;
	}
	
	
	/**
	 * Recursively traverses the object/observable properties and arrays and calls "validate" method" (if available).
	 *
	 * Difference between computeErrorsCount and validateDeep
	 * is that validateDeep will activate delayed behaviours
	 * (e.g. required) and is recursive.
	 *
	 * @returns {boolean}
	 *     Returns "true" if the specified object is valid (i.e. all
	 *     child objects are also valid), "false" otherwise.
	 */
	function validateDeep(o) {
	    if (o && (typeof o === "object" || ko.isObservable(o))) { // validate only observable and object
	        if (o.validate) {
	            if (typeof o.validate !== "function") {
	                throw new Error("validate must be a function");
	            }
	            return o.validate();
	        }
	
	        if (ko.isObservable(o) && o.indexOf) { // (naive detection of observableArray)
	            return validateDeep(o()); // recursive call; in case of observableArray we want to validate each item in the array, thus "o()"
	        }
	
	        if (typeof o === "object") {
	            // in case of object (includes arrays) we want to validate each property of the object except "extras"
	            var k, isValid = true;
	            for (k in o) {
	                if (o.hasOwnProperty(k)) {
	                    if (k !== "extras" && !validateDeep(o[k])) { // recursive call
	                        isValid = false; // do not exit early to activate all delayed behaviours
	                    }
	                }
	            }
	            return isValid;
	        }
	    }
	
	    return true;
	}
	
	
	module.exports = {
	    applyValidationErrors: applyValidationErrors,
	    computeErrorsCount: computeErrorsCount,
	    createErrorsCountObservable: createErrorsCountObservable,
	    createViewModelState: createViewModelState,
	    validateDeep: validateDeep
	};
	


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true */
	
	"use strict";
	
	var ko = __webpack_require__(9);
	
	var pli = __webpack_require__(380);
	var disposeObject = __webpack_require__(375).disposeObject;
	
	
	//-------------------------------------------
	function disposeGridItem(item) {
	    var owner = item.extras.owner;
	    item.extras.owner = null; // if we didn't remove this property, disposeObject would throw stack overflow exception
	    disposeObject(item, true); // force-dispose (include "function" containers, i.e. "extras")
	    item.extras.owner = owner;
	
	    return item;
	}
	
	
	//-------------------------------------------
	function arrayFirstIndexOf(array, predicate, predicateOwner) {
	    var i, j;
	    for (i = 0, j = array.length; i < j; i += 1) {
	        if (predicate.call(predicateOwner, array[i])) {
	            return i;
	        }
	    }
	    return -1;
	}
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// GridViewModelFactory class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Constructor (expects "new").
	function GridViewModelFactory(factories, ItemClass, itemComparer, apiVersion) {
	    if (!(this instanceof GridViewModelFactory)) { // if new was not used, force it now
	        return new GridViewModelFactory(factories, ItemClass, itemComparer, apiVersion);
	    }
	
	    if (typeof factories !== "object") { throw new Error("factories was expected to be an object"); }
	    if (typeof ItemClass !== "function") { throw new Error("ItemClass was expected to be a constructor function"); }
	
	    this.apiVersion = (apiVersion || 1);
	    this.factories = factories;
	    this.ItemClass = ItemClass;
	    this.itemComparer = (typeof itemComparer === "function"
	        ? itemComparer
	        : ItemClass.prototype.itemComparer === null || typeof ItemClass.prototype.itemComparer === "function"
	            ? ItemClass.prototype.itemComparer
	            : GridViewModelFactory.prototype._defaultItemComparer
	    );
	
	    this.navigationInitialized = ko.observable(false);
	    this.gridPage = null; // will be initialized in "initializeNavigation"
	    this.detailsPage = null; // -||-
	    this.baseHash = ko.computed(GridViewModelFactory.prototype._computeBaseHash, this);
	}
	
	
	//-------------------------------------------
	// Close currently opened "item details" page.
	//
	// Will be attached to observableArray instances
	// created by "GridViewModelFactory.prototype.createObservableArray",
	// i.e. expects "this" to be an observable array.
	GridViewModelFactory.prototype._closeCurrentItem = function closeCurrentItem() {
	    this.factory.detailsPage.form.close();
	};
	
	
	//-------------------------------------------
	// Compute display ID for "this" item.
	//
	// Will be attached to instances of ItemClass,
	// i.e. expects "this" to be an item.
	GridViewModelFactory.prototype._computeDisplayId = function computeDisplayId() {
	    var safeId, result = this.id();
	    if (!result) {
	        safeId = this.extras.safeId().substring(1); // safeId for items with falsey "id()" will be ".", ".(2)", ".(3)", etc -- substring will cut off the dot
	        result = "(New";
	        if (safeId) {
	            result = result.concat(" ", safeId, ")");
	        } else {
	            result = result.concat(")");
	        }
	    }
	    return result;
	};
	
	
	//-------------------------------------------
	// Compute URL hash for "this" item.
	//
	// Will be attached to instances of ItemClass,
	// i.e. expects "this" to be an item.
	GridViewModelFactory.prototype._computeItemHash = function computeItemHash() {
	    var itemHash, factory = this.extras.owner.factory;
	    if (factory.gridPage) {
	        if (factory.gridPage.defaultChildFormId === factory.detailsPage.id) {
	            itemHash = factory.baseHash().concat("/", encodeURIComponent(this.extras.safeId()));
	        } else {
	            itemHash = factory.baseHash().concat("/", factory.detailsPage.id, ":", encodeURIComponent(this.extras.safeId()));
	        }
	    } else {
	        factory.navigationInitialized(); // subscribe to "navigationInitialized" observable so that this computed observable is recomputed when factory is initialized
	        itemHash = "#";
	    }
	    return itemHash;
	};
	
	
	//-------------------------------------------
	// Create new "item" object for "this"
	// observable array.
	//
	// Will be attached to observableArray instances
	// created by "GridViewModelFactory.prototype.createObservableArray",
	// i.e. expects "this" to be an observable array
	// that owns the item.
	GridViewModelFactory.prototype._createItem = function createItem(record) {
	    // step 1: make new instance of item
	    var apiVersion = this.factory.apiVersion;
	    var i = (apiVersion > 1
	        ? new this.factory.ItemClass(this.factory.factories, this) // factories + owner
	        : new this.factory.ItemClass(record, this.factory.factories) // deprecated
	    );
	    if (!ko.isObservable(i.id)) {
	        throw new Error("GridViewModel requires items to define an observable property \"id\"");
	    }
	
	    // step 2: populate item with data (if valid record)
	    if (this.factory.apiVersion > 1 && record !== undefined && record !== null && typeof i.loadViewModel === "function") {
	        i.loadViewModel(record);
	    }
	
	    // step 3: define system properties and computeds
	    if (!i.hasOwnProperty("extras")) {
	        Object.defineProperty(i, "extras", { enumerable: false, value: {} });
	    }
	    i.extras.owner = this;
	    i.extras.safeId = ko.observable(i.id() || ".");
	    i.extras.hash = ko.computed(GridViewModelFactory.prototype._computeItemHash, i);
	    i.extras.displayId = ko.computed(GridViewModelFactory.prototype._computeDisplayId, i);
	
	    // step 4: complete item creation
	    if (this.factory.apiVersion > 1) {
	        if (typeof i.completeViewModel === "function") {
	            i.completeViewModel(record);
	        }
	    } else {
	        if (typeof i.created === "function") {
	            i.created();
	        }
	    }
	
	    return i;
	};
	
	
	//-------------------------------------------
	// Simple case-insensitive ID comparer.
	// Used as a default comparer when ItemClass
	// does not define a comparer.
	//
	// Does not use "this".
	GridViewModelFactory.prototype._defaultItemComparer = function defaultItemComparer(left, right) {
	    var leftId = ((left && left.id()) || "").toLowerCase(),
	        rightId = ((right && right.id()) || "").toLowerCase();
	    return leftId < rightId ? -1 : leftId > rightId ? 1 : 0;
	};
	
	
	//-------------------------------------------
	// Will be attached to observableArray instances
	// created by "GridViewModelFactory.prototype.createObservableArray",
	// i.e. expects "this" to be an observable array.
	GridViewModelFactory.prototype._deleteAndCloseCurrentItem = function deleteAndCloseCurrentItem() {
	    if (ko.unwrap(this.disableDelete)) {
	        return;
	    }
	
	    var current = this.current();
	    this.remove(current);
	    disposeGridItem(current);
	    this.closeCurrent();
	};
	
	
	//-------------------------------------------
	// Will be attached to observableArray instances
	// created by "GridViewModelFactory.prototype.createObservableArray",
	// i.e. expects "this" to be an observable array.
	GridViewModelFactory.prototype._disposeObservableArray = function disposeObservableArray() {
	    var i, l, a = this();
	    for (i = 0, l = a.length; i < l; i += 1) {
	        disposeGridItem(a[i]);
	    }
	};
	
	
	//-------------------------------------------
	// Computes total errors count for all items
	// currently included in "this" array. Expects
	// each item to have an observable "extras.errorsCount()"
	// and expects "this" to be an observable array.
	GridViewModelFactory.prototype._errorsCount = function gridErrorsCount() {
	    var i, l, o,
	        sum = 0,
	        a = this();
	    for (i = 0, l = a.length; i < l; i += 1) {
	        o = a[i];
	        if (o && o.extras && o.extras.errorsCount) {
	            sum += o.extras.errorsCount();
	        }
	    }
	    return sum;
	};
	
	
	//-------------------------------------------
	// Load items into "this" observable array.
	//
	// Will be attached to observableArray instances
	// created by "GridViewModelFactory.prototype.createObservableArray",
	// i.e. expects "this" to be an observable array.
	GridViewModelFactory.prototype._loadItems = function loadItems(records) {
	    var i, l, item,
	        loadMethodName = (this.factory.apiVersion > 1 ? "loadViewModel" : "loaded"),
	        o = this(),
	        oLength = o.length,
	        recordsLength = (records ? records.length : 0),
	        currentItemSafeId = this.current().extras.safeId(),
	        currentItemIndex = ko.utils.arrayIndexOf(o, this.current());
	
	    // start loading items
	    this._isLoading(true);
	
	    // update existing items
	    for (i = 0, l = Math.min(recordsLength, oLength); i < l; i += 1) {
	        o[i][loadMethodName](records[i]);
	    }
	
	    // create new items (if any)
	    for (l = recordsLength; i < l; i += 1) {
	        o.push(this.createItem(records[i]));
	    }
	
	    // dispose old items (if any)
	    for (l = oLength - i, i = 0; i < l; i += 1) {
	        item = o.pop();
	        // if (window.console && window.console.group) { window.console.log("Disposing:", item); }
	        disposeGridItem(item);
	    }
	
	    // end loading items
	    // forces calculation safeId and hash
	    this._isLoading(false);
	
	    // if current item index changed - set new element as current
	    if (currentItemIndex >= 0) {
	        i = arrayFirstIndexOf(o, function (el) { return el.extras.safeId() === currentItemSafeId; });
	        // index changed
	        if (i !== currentItemIndex) {
	            if (i >= 0) {
	                // if item with the current safeId found select it
	                this.current(o[i]);
	            } else {
	                // items don't contain item with current safeId
	                // set current to default empty item
	                this.current(this.factory.ItemClass.defaultEmptyItem);
	                // close current
	                this.closeCurrent();
	            }
	        }
	    }
	
	    // if there were changes to the underlying array, notify subscribers
	    if (oLength !== o.length) {
	        this.valueHasMutated();
	    }
	
	    return this;
	};
	
	
	//-------------------------------------------
	// Create a new item, add it to viewModel
	// and navigate to the newly created item
	// in browser.
	//
	// Will be attached to observableArray instances
	// created by "GridViewModelFactory.prototype.createObservableArray",
	// i.e. expects "this" to be an observable array.
	GridViewModelFactory.prototype._openNewItem = function openNewItem() {
	    if (ko.unwrap(this.disableNew)) {
	        return;
	    }
	
	    var o = this.createItem(),
	        a = this();
	    a.push(o);
	    // does not notify subscribers that there is a new item, so force sort to send notification
	    this.sort(null, a, true);
	    this.factory.detailsPage.$focus = null; // reset details page focus to default
	    location.hash = o.extras.hash();
	    pli.forms.onHashChange();
	};
	
	
	//-------------------------------------------
	// Will be attached to observableArray instances
	// created by "GridViewModelFactory.prototype.createObservableArray",
	// i.e. expects "this" to be an observable array.
	GridViewModelFactory.prototype._openNextItem = function openNextItem() {
	    var o = this.next();
	    if (o) {
	        location.hash = o.extras.hash();
	    }
	};
	
	
	//-------------------------------------------
	// Will be attached to observableArray instances
	// created by "GridViewModelFactory.prototype.createObservableArray",
	// i.e. expects "this" to be an observable array.
	GridViewModelFactory.prototype._openPreviousItem = function openPreviousItem() {
	    var o = this.previous();
	    if (o) {
	        location.hash = o.extras.hash();
	    }
	};
	
	
	//-------------------------------------------
	// If newItems are specified, they are converted
	// into an array (if not already), then sorted,
	// then set as value of "this" observable array
	// (generating a single subscribers notification).
	// Otherwise current observable array items are
	// sorted (in place, generating a single subscribers
	// notification).
	// If no item comparer is specified, default
	// comparer (as defined by factory that created
	// this observable array) will be used.
	// Will be attached to observableArray instances
	// created by "GridViewModelFactory.prototype.createObservableArray",
	// i.e. expects "this" to be an observable array.
	GridViewModelFactory.prototype._sort = function sort(itemComparer, newItems, forceNotify) {
	    if (typeof itemComparer !== "function") {
	        itemComparer = this.factory.itemComparer; // could be null
	    }
	
	    var a = this.peek();
	    if (typeof newItems === "object" && newItems !== null && newItems !== a) {
	        if (itemComparer) {
	            newItems = newItems.sort(itemComparer);
	        }
	        if (newItems !== a) {
	            this(newItems);
	            a = newItems;
	        }
	    } else {
	        if (itemComparer) {
	            // only sort if unsorted, to ensure that viewing sorted data does not trigger the dirty flag
	            var sorted = true,
	                index;
	            for (index = 1; index < a.length; index += 1) {
	                if (itemComparer(a[index - 1], a[index]) > 0) {
	                    sorted = false;
	                    break;
	                }
	            }
	            if (!sorted) {
	                this.valueWillMutate();
	                a = a.sort(itemComparer);
	                forceNotify = true;
	            }
	        }
	
	        if (forceNotify) {
	            this.valueHasMutated();
	        }
	    }
	
	    return a;
	};
	
	
	//-------------------------------------------
	// Compute base hash for "this" factory.
	GridViewModelFactory.prototype._computeBaseHash = function computeBaseHash() {
	    var gridPage = this.gridPage, crumbs, c;
	    if (gridPage) {
	        crumbs = pli.forms.crumbs();
	        c = crumbs.end;
	        while (c) {
	            if (c.page === gridPage) {
	                return c.hash;
	            }
	            c = c.previous;
	        }
	    } else { // grid page can only be falsy if factory has not been initialized yet
	        this.navigationInitialized(); // subscribe to "navigationInitialized" observable so that this computed observable is recomputed when factory is initialized
	    }
	
	    return (this.baseHash ? this.baseHash.peek() : "#"); // if we can't determine current baseHash (and we determined it before), use last valid value
	};
	
	
	//-------------------------------------------
	// Create a new observable array.
	//
	// options.disableNew and options.disableDelete can be
	// truthy/falsy or an observable. If undefined, they
	// will default to false. If disableNew is truthy, calling
	// openNew does nothing, otherwise calling openNew
	// behaves normally. If disableDelete is truthy, calling
	// deleteAndCloseCurrent does nothing, otherwise
	// calling deleteAndCloseCurrent behaves normally.
	//
	// Will be attached to GridViewModelFactory,
	// i.e. expects "this" to be a factory.
	GridViewModelFactory.prototype.createObservableArray = function createObservableArray(options) {
	    var a = ko.observableArray();
	
	    options = options || {};
	
	    // direct functions and properties
	    a.closeCurrent = GridViewModelFactory.prototype._closeCurrentItem.bind(a);
	    a.createItem = GridViewModelFactory.prototype._createItem;
	    a.deleteAndCloseCurrent = GridViewModelFactory.prototype._deleteAndCloseCurrentItem.bind(a);
	    a.disableDelete = options.disableDelete;
	    a.dispose = GridViewModelFactory.prototype._disposeObservableArray;
	    a.factory = this;
	    if (this.apiVersion > 1) {
	        a.loadViewModel = GridViewModelFactory.prototype._loadItems;
	    } else {
	        a.load = GridViewModelFactory.prototype._loadItems;
	    }
	    a.openNew = GridViewModelFactory.prototype._openNewItem.bind(a);
	    a.disableNew = options.disableNew;
	    a.openNext = GridViewModelFactory.prototype._openNextItem.bind(a);
	    a.openPrevious = GridViewModelFactory.prototype._openPreviousItem.bind(a);
	    a.sort = GridViewModelFactory.prototype._sort;
	
	    // knockout properties
	    a.current = ko.observable(null);
	    a.next = ko.observable(null);
	    a.previous = ko.observable(null);
	    a.errorsCount = ko.computed(GridViewModelFactory.prototype._errorsCount, a);
	
	    // notify item class (if requested)
	    var initGridArray = this.ItemClass.prototype && this.ItemClass.prototype.initGridArray;
	    if (typeof initGridArray === "function") {
	        initGridArray.call(this.ItemClass.prototype, a);
	    }
	
	    // if not yet created, create default empty item (disposed)
	    if (!this.ItemClass.defaultEmptyItem) {
	        this.ItemClass.defaultEmptyItem = disposeGridItem(a.createItem()); // we dispose the default item because we don't want it recomputing observables; it is only a placeholder for bindings that are using "current" observable
	        this.ItemClass.defaultEmptyItemJson = ko.toJSON(this.ItemClass.defaultEmptyItem);
	    }
	    a.current(this.ItemClass.defaultEmptyItem);
	    a._isLoading = ko.observable(false);
	
	    return a;
	};
	
	
	//-------------------------------------------
	// Important: "itemsObservable" is expected to
	// be an observable that resolves to
	// (its value is) "observableArray".
	//
	// Will be attached to GridViewModelFactory,
	// i.e. expects "this" to be a factory.
	GridViewModelFactory.prototype.initializeNavigation = function initializeGridNavigation(gridPage, detailsPage, itemsObservable) {
	    if (typeof gridPage !== "object" || gridPage.type !== "PLI navigation page") { throw new Error("gridPage was expected to be a valid navigation page"); }
	    if (typeof detailsPage !== "object" || detailsPage.type !== "PLI navigation page" || typeof detailsPage.form !== "object") { throw new Error("detailsPage was expected to be a valid navigation (form) page"); }
	    if (!ko.isObservable(itemsObservable)) { throw new Error("itemsObservable was expected to be an observable"); }
	
	    // Remember pages as properties in factory object
	    // (in case caller ever needs them)
	    this.gridPage = gridPage;
	    this.detailsPage = detailsPage;
	
	    // Local variables (used in closures below)
	    var activeDetailsSafeId = null; // Remember safeId of the last item that was successfully activated via navigation
	
	    // Find data for details form when it is
	    // being activated.
	    detailsPage.$page.on("pliInitializingFormData", function initializeDetailsData(event) {
	        var a, i, l, item,
	            items = itemsObservable(),
	            id = event.pli.data.id.toLowerCase();
	        for (a = items(), i = 0, l = a.length; i < l; i += 1) {
	            item = a[i];
	            if (item.extras.safeId().toLowerCase() === id) {
	                activeDetailsSafeId = item.extras.safeId();
	                event.pli.data.value = true;
	                items.current(item);
	                items.previous(i === 0 ? null : a[i - 1]);
	                items.next(i === (l - 1) ? null : a[i + 1]);
	                break;
	            }
	        }
	    });
	
	    // When deactivating details form, sort all items
	    // (because some properties that affect sort order
	    // might have been edited in the form);
	    // then find index of the current item and make sure
	    // we update saved page focus to reference correct
	    // <a>nchor element
	    detailsPage.$page.on("pliDeactivated", function deactivateDetails() {
	        var $found, $anchors, i, l,
	            items = itemsObservable(),
	            current = items.current(),
	            currentHash = current.extras.hash(),
	            currentJson = ko.toJSON(current);
	
	        var crumb = pli.forms.crumbs().begin;
	
	        while (crumb.next) {
	            crumb = crumb.next;
	        }
	
	        if (crumb.hash.lastIndexOf(currentHash, 0) !== 0) {
	            activeDetailsSafeId = null;
	            if (currentJson === items.factory.ItemClass.defaultEmptyItemJson) {
	                if (window.console) { window.console.log("Deactivating empty!"); }
	                items.remove(current);
	                disposeGridItem(current);
	                current = null;
	            }
	        }
	
	        items.sort();
	
	        if (current) {
	            $anchors = gridPage.$page.find("a");
	            for (i = 0, l = $anchors.length; i < l; i += 1) {
	                $found = $anchors.eq(i);
	                if ($found.attr("href") === currentHash) {
	                    break;
	                }
	                $found = null;
	            }
	        } else {
	            $found = null;
	        }
	        if ($found && $found.length) {
	            gridPage.$focus = $found;
	        } else {
	            delete gridPage.$focus;
	        }
	    });
	
	    // Ensure hash is synchronized with ID
	    // of the currently selected grid item
	    ko.computed(function () {
	        var items = itemsObservable();
	
	        // don't update hash if items are loading
	        if (items._isLoading()) { return; }
	
	        // get current item safeId value
	        var safeId = items.current().extras.safeId();
	
	        if (activeDetailsSafeId !== null && activeDetailsSafeId.toLowerCase() !== safeId.toLowerCase()) { // only update hash if details page is active and entered ID differs from hash ID (case-insensitive)
	            detailsPage.form.open({
	                id: safeId,
	                replaceId: true,
	                replacePreservesCrumbsTail: true,
	                includeInHash: true,
	                doNotUpdateHistory: true
	            });
	            pli.forms.onHashChange(); // make sure crumbs are updated at this point
	
	            // Reset the value for the case when the hash changes *for the current
	            // form*. This can happen when a form value that contributes to
	            // safeId is changed; the hash changes but it does not result in a
	            // new `initializingFormData` event, so `activeDetailsSafeId` will not
	            // have its value reset.
	            activeDetailsSafeId = safeId;
	        }
	    });
	
	    // Ensure safe IDs are recomputed when
	    // items collection changes or ID of any
	    // item in this collection changes
	    ko.computed(function () {
	        var items = itemsObservable();
	
	        // don't update safeId if items are loading
	        if (items._isLoading()) { return; }
	
	        var a = items();
	        var known = {};
	
	        var i, l, safeId, lowercaseId, count;
	        for (i = 0, l = a.length; i < l; i += 1) {
	            safeId = a[i].id() || ".";
	            lowercaseId = safeId.toLowerCase(); // counting for safeId is case-insensitive, e.g. "bpo", "Bpo(2)", "BPO(3)"
	            count = (known[lowercaseId] || 0) + 1;
	            if (count > 1) {
	                safeId = safeId.concat("(", count, ")");
	            }
	            known[lowercaseId] = count;
	            a[i].extras.safeId(safeId);
	        }
	    });
	
	    // Trigger recomputation of baseHash values
	    // that were computed before this initialization
	    this.navigationInitialized(true);
	    this.navigationInitialized = null; // release for GC
	};
	
	
	module.exports = GridViewModelFactory;
	


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true */
	
	"use strict";
	
	var ko = __webpack_require__(9);
	__webpack_require__(458);
	
	var $ = __webpack_require__(1);
	var pli = __webpack_require__(380);
	
	if (__webpack_require__(3).isBrowser) {
	    __webpack_require__(472);
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// FormState class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function FormState(crumb) {
	    /// <summary>
	    /// Initializes an instance of the form page
	    /// used in transition.
	    /// </summary>
	
	    // find current and parent forms
	    var form, c = crumb;
	    while (c) {
	        if (c.page.form) {
	            if (form) {
	                this.$parents = this.$parents ? this.$parents.add(c.page.$page) : c.page.$page;
	            } else {
	                form = c.page.form;
	            }
	        }
	        c = c.previous;
	    }
	    this.$parents = this.$parents || $();
	
	
	    this.crumb = crumb;
	    this.id = (form && form.id) || "";
	    this.$page = (form && form.page.$page) || $();
	}
	
	
	//---------------------------------------
	FormState.prototype.clear = function clearFormState() {
	    /// <summary>
	    /// Clears custom state (styles) applied with reset.
	    /// </summary>
	    this.$page.removeAttr("style");
	    if (this._tab) {
	        this._tab.removeClass("animationActive");
	        this._tab = null;
	    }
	};
	
	
	//---------------------------------------
	FormState.prototype.reset = function resetFormState(width, left) {
	    /// <summary>
	    /// Sets custom state (styles) of the form before transition.
	    /// </summary>
	    this.$page.css({ right: "auto", left: left, display: "block", width: width });
	    if (this.crumb && !this.crumb.page.form) {
	        this._tab = this.crumb.page.$activationIndicatedBy.add(this.crumb.page.$page);
	        this._tab.addClass("animationActive");
	    }
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Transition class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function Transition(to, previous, duration) {
	    /// <summary>
	    /// Initializes a new form transition.
	    /// </summary>
	    this.previous = previous;
	    this.from = (this.previous && this.previous.to) || new FormState(null);
	    this.to = new FormState(to);
	    this.duration = duration;
	    this.up = (this.from.id.length > this.to.id.length);
	    this.width = this.to.$page.width();
	    this.$pages = this.to.$page.add(this.from.$page);
	    this.$parents = (this.up ? this.to.$parents : this.from.$parents);
	}
	
	
	//---------------------------------------
	Transition.prototype.execute = function executeTransition() {
	    /// <summary></summary>
	    // skip if form did not change
	    if (this.from.id.length === 0 || this.to.id === this.from.id) { return; }
	    this.previous.stop();
	    this.resetState();
	    this.start();
	};
	
	
	//---------------------------------------
	Transition.prototype.resetState = function resetTransitionState() {
	    /// <summary>
	    /// Sets custom state (styles) of the form before transition.
	    /// </summary>
	    this.from.reset(this.width, 0);
	    this.to.reset(this.width, (this.up ? -1 : 1) * this.width);
	    this.$parents.css("display", "none");
	};
	
	
	//---------------------------------------
	Transition.prototype.start = function startTransition() {
	    /// <summary>
	    /// Starts the slide animation between pages.
	    /// </summary>
	    this._animation = this.$pages.animate({
	        left: (this.up ? "+=" : "-=").concat(this.width).concat("px"),
	        avoidCSSTransitions: document.documentMode >= 8 // disable css transitions for IE (they are still flaky/crashing in IE10)
	    }, this.duration, this.stop.bind(this));
	};
	
	
	//---------------------------------------
	Transition.prototype.stop = function stopTransition() {
	    /// <summary>
	    /// Stop the currently running animation
	    /// </summary>
	    if (this._animation) {
	        this._animation.stop(true, false);
	        this._animation = null;
	        this.from.clear();
	        this.to.clear();
	        this.$parents.removeAttr("style");
	        this.previous = null;
	    }
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// TransitionsManager class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function TransitionsManager(duration, onBeforeTransition, onBeforeTransitionContext) {
	    this._crumbsSubscription = null;
	    this._duration = duration;
	    this._isDisposed = true;
	    this._lastTransition = null;
	    this._onStateChannelSubscription = null;
	    this._onBeforeTransitionSubscription = null;
	
	    if (duration > 0) {
	        this._isDisposed = false;
	        this._lastTransition = ko.observable(null);
	
	        this._onStateChannelSubscription = ko.postbox.subscribe( // start following "state" channel (this is what triggers transitions)
	            "state",
	            this._onStateChange,
	            this, // context
	            true // initializeWithLatestValue
	        );
	
	        this._onBeforeTransitionSubscription = (onBeforeTransition
	            ? this._lastTransition.subscribe(onBeforeTransition, onBeforeTransitionContext)
	            : null);
	    }
	}
	
	
	//---------------------------------------
	TransitionsManager.prototype.dispose = function disposeTransitionsManager() {
	    var wasDisposed = this._isDisposed;
	    if (!wasDisposed) {
	        if (this._crumbsSubscription) {
	            this._crumbsSubscription.dispose();
	            this._crumbsSubscription = null;
	        }
	        if (this._onBeforeTransitionSubscription) {
	            this._onBeforeTransitionSubscription.dispose();
	            this._onBeforeTransitionSubscription = null;
	        }
	        if (this._onStateChannelSubscription) {
	            this._onStateChannelSubscription.dispose();
	            this._onStateChannelSubscription = null;
	        }
	        this._lastTransition = null;
	        this._isDisposed = true;
	    }
	    return !wasDisposed;
	};
	
	
	//---------------------------------------
	TransitionsManager.prototype.isDisposed = function isTransitionsManagerDisposed() {
	    return this._isDisposed;
	};
	
	
	//---------------------------------------
	function isCrumbModal(crumb) {
	    return crumb && crumb.page && crumb.page.form && crumb.page.form.isModal;
	}
	
	
	//---------------------------------------
	TransitionsManager.prototype._onCrumbsChange = function onTransitionManagerCrumbsChange(crumbs) {
	    var lastTransition = this._lastTransition.peek();
	    if (isCrumbModal(crumbs.end) || isCrumbModal(lastTransition.to.crumb)) { return; }
	    var currentTransition = new Transition(crumbs.end, lastTransition, this._duration);
	    this._lastTransition(currentTransition);
	    currentTransition.execute();
	};
	
	
	//---------------------------------------
	TransitionsManager.prototype._onStateChange = function onTransitionManagerStateChange(newState) {
	    var crumbs = pli.forms.crumbs;
	    if (newState && newState.indexOf("ready") === 0) {
	        if (!isCrumbModal(crumbs.peek().end)) {
	            this._lastTransition(new Transition(crumbs().end, null, this._duration));
	            this._crumbsSubscription = crumbs.subscribe(this._onCrumbsChange, /*context*/ this);
	        }
	    } else {
	        if (this._crumbsSubscription) {
	            this._crumbsSubscription.dispose();
	            this._crumbsSubscription = null;
	        }
	    }
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	var transitionsManager = null;
	
	
	//---------------------------------------
	/**
	 * Enable slide transitions in the current form (once it leaves initialization state).
	 * Can be called multiple times (does nothing 2nd+ time).
	 * @param {Object} options - Extra options for enabling slide transitions (optional).
	 * @param {number} options.duration - Transition duration in milliseconds. Defaults to 300. Zero and negative values will disable transitions.
	 * @param {Function} options.onBeforeTransition - Callback invoked just before a transition animation starts. Defaults to no callback.
	 * @param {Object} options.onBeforeTransitionContext - Context in which "onBeforeTransition" will be called ("this" value). Defaults to undefined.
	 * @returns {Object} transition manager object; it exposes a "dispose" method that will disable slide transitions when called
	 */
	function enableSlideTransitions(options) {
	    if (!transitionsManager || transitionsManager.isDisposed()) { // prevent re-initialization
	        // process options (if specified)
	        var duration = 300;
	        var onBeforeTransition = null;
	        if (options) {
	            if (typeof options !== "object") { throw new Error("\"options\" parameter for \"enableSlideTransitions\" must be an object"); }
	            if (options.duration !== undefined && options.duration !== null) {
	                if (typeof options.duration !== "number") { throw new Error("\"options.duration\" parameter for \"enableSlideTransitions\" must be a number"); }
	                duration = options.duration;
	            }
	            if (options.onBeforeTransition !== undefined && options.onBeforeTransition !== null) {
	                if (typeof options.onBeforeTransition !== "function") { throw new Error("\"options.onBeforeTransition\" parameter for \"enableSlideTransitions\" must be a function"); }
	                onBeforeTransition = options.onBeforeTransition;
	            }
	        }
	
	        // create new manager with the processed options
	        transitionsManager = new TransitionsManager(duration, onBeforeTransition, options && options.onBeforeTransitionContext);
	    }
	
	    return transitionsManager;
	}
	
	
	//---------------------------------------
	module.exports = enableSlideTransitions;
	module.exports.enableSlideTransitions = enableSlideTransitions; // Export for TypeScript consumers
	


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*
	jquery.animate-enhanced plugin v1.10
	---
	http://github.com/benbarnett/jQuery-Animate-Enhanced
	http://benbarnett.net
	@benpbarnett
	---
	Copyright (c) 2013 Ben Barnett
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	---
	Extends jQuery.animate() to automatically use CSS3 transformations where applicable.
	Tested with jQuery 1.3.2+
	
	Supports -moz-transition, -webkit-transition, -o-transition, transition
	
	Targetted properties (for now):
		- left
		- top
		- opacity
		- width
		- height
	
	Usage (exactly the same as it would be normally):
	
		jQuery(element).animate({left: 200},  500, function() {
			// callback
		});
	
	Changelog:
		1.10 (09/04/2014):
			- Merging PR #153 Don't try to restore values which weren't saved
	
		1.09 (09/04/2014):
			- Merging PR #154 Added support of AMD and Node.js (via browserify) environments
	
		1.08 (16/01/2014):
			- Merging PR #147 Access element tag name appropriately
	
		1.07 (06/12/2013):
			- Merging PR #139 Other units, beside '%' should also be kept
	
		1.06 (06/12/2013):
			- Merging PR #140 Do not change a user defined display mode for elements, after show/hide
	
		1.05 (14/08/2013):
			- Merging PR #124 fix for highcharts clash. Thanks @bensonc!
	
		1.04 (14/08/2013):
			- Using fix from issue #69 by @rickyk586 to support percentages
	
		1.03 (19/7/2013):
			- Merge PR #129 (Use originalAnimateMethod if a step callback function is provided.) /thx @lehni
	
		1.02 (8/5/2013):
			- Fixing use3D default flags. It must explicitly be set to false to disable 3d now, the plugin by default will use it if available.
	
		1.01 (8/5/2013):
			- Adding appropriate display value for wider range of elements (issue #121 - thanks smacky)
	
		1.0 (8/5/2103):
			- Fix avoidTransforms: true behaviour for directional transitions
	
		0.99.1 (3/4/2013):
			- Add Set or unset the 'disabled by default' value (PR #117)
	
		0.99 (5/12/2012):
			- PR #109 Added support for list-item nodes. FadeIn on tags was omitting the list-style support. (thx @SeanCannon)
	
		0.98 (12/11/2012):
			- Merging pull request #106 thx @gboysko - checking for ownerDocument before using getComputedStyle
	
		0.97 (6/11/2012):
			- Merging pull request #104 thx @gavrochelegnou - .bind instead of .one
	
		0.96a (20/08/2012):
			- Checking event is from dispatch target (issue #58)
	
		0.96 (20/08/2012):
			- Fixes for context, all elements returned as context (issue #84)
			- Reset position with leaveTransforms !== true fixes (issue #93)
	
	
		0.95 (20/08/2012):
			- If target opacity == current opacity, pass back to jquery native to get callback firing (#94)
	
		0.94 (20/08/2012):
			- Addresses Firefox callback mechanisms (issue #94)
			- using $.one() to bind to CSS callbacks in a more generic way
	
		0.93 (6/8/2012):
			- Adding other Opera 'transitionend' event (re: issue #90)
	
		0.92 (6/8/2012):
			- Seperate unbinds into different threads (re: issue #91)
	
		0.91 (2/4/2012):
			- Merge Pull Request #74 - Unit Management
	
		0.90 (7/3/2012):
			- Adding public $.toggleDisabledByDefault() feature to disable entire plugin by default (Issue #73)
	
		0.89 (24/1/2012):
			- Adding 'avoidCSSTransitions' property. Set to true to disable entire plugin. (Issue #47)
	
		0.88 (24/1/2012):
			- Fix Issue #67 for HighchartsJS compatibility
	
		0.87 (24/1/2012):
			- Fix Issue #66 selfCSSData.original is undefined
	
		0.86 (9/1/2012):
			- Strict JS fix for undefined variable
	
		0.85 (20/12/2011):
			- Merge Pull request #57 from Kronuz
			- Codebase cleaned and now passes jshint.
			- Fixed a few bugs (it now saves and restores the original css transition properties).
			- fadeOut() is fixed, it wasn't restoring the opacity after hiding it.
	
		0.80 (13/09/2011):
			- Issue #28 - Report $(el).is(':animated') fix
	
		0.79 (06/09/2011):
			- Issue #42 - Right negative position animation: please see issue notes on Github.
	
		0.78 (02/09/2011):
			- Issue #18 - jQuery/$ reference joys
	
		0.77 (02/09/2011):
			- Adding feature on Github issue #44 - Use 3D Transitions by default
	
		0.76 (28/06/2011):
			- Fixing issue #37 - fixed stop() method (with gotoEnd == false)
	
		0.75 (15/06/2011):
			- Fixing issue #35 to pass actual object back as context for callback
	
		0.74 (28/05/2011):
			- Fixing issue #29 to play nice with 1.6+
	
		0.73 (05/03/2011):
			- Merged Pull Request #26: Fixed issue with fadeOut() / "hide" shortcut
	
		0.72 (05/03/2011):
			- Merged Pull Request #23: Added Penner equation approximations from Matthew Lein's Ceaser, and added failsafe fallbacks
	
		0.71 (05/03/2011):
			- Merged Pull Request #24: Changes translation object to integers instead of strings to fix relative values bug with leaveTransforms = true
	
		0.70 (17/03/2011):
			- Merged Pull Request from amlw-nyt to add bottom/right handling
	
		0.68 (15/02/2011):
			- width/height fixes & queue issues resolved.
	
		0.67 (15/02/2011):
			- Code cleanups & file size improvements for compression.
	
		0.66 (15/02/2011):
			- Zero second fadeOut(), fadeIn() fixes
	
		0.65 (01/02/2011):
			- Callbacks with queue() support refactored to support element arrays
	
		0.64 (27/01/2011):
			- BUGFIX #13: .slideUp(), .slideToggle(), .slideDown() bugfixes in Webkit
	
		0.63 (12/01/2011):
			- BUGFIX #11: callbacks not firing when new value == old value
	
		0.62 (10/01/2011):
			- BUGFIX #11: queue is not a function issue fixed
	
		0.61 (10/01/2011):
			- BUGFIX #10: Negative positions converting to positive
	
		0.60 (06/01/2011):
			- Animate function rewrite in accordance with new queue system
			- BUGFIX #8: Left/top position values always assumed relative rather than absolute
			- BUGFIX #9: animation as last item in a chain - the chain is ignored?
			- BUGFIX: width/height CSS3 transformation with left/top working
	
		0.55 (22/12/2010):
			- isEmptyObject function for <jQuery 1.4 (requires 1.3.2)
	
		0.54a (22/12/2010):
			- License changed to MIT (http://www.opensource.org/licenses/mit-license.php)
	
		0.54 (22/12/2010):
			- Removed silly check for 'jQuery UI' bailouts. Sorry.
			- Scoping issues fixed - Issue #4: $(this) should give you a reference to the selector being animated.. per jquery's core animation funciton.
	
		0.53 (17/11/2010):
			- New $.translate() method to easily calculate current transformed translation
			- Repeater callback bug fix for leaveTransforms:true (was constantly appending properties)
	
		0.52 (16/11/2010):
			- leaveTransforms: true bug fixes
			- 'Applying' user callback function to retain 'this' context
	
		0.51 (08/11/2010):
			- Bailing out with jQuery UI. This is only so the plugin plays nice with others and is TEMPORARY.
	
		0.50 (08/11/2010):
			- Support for $.fn.stop()
			- Fewer jQuery.fn entries to preserve namespace
			- All references $ converted to jQuery
			- jsDoc Toolkit style commenting for docs (coming soon)
	
		0.49 (19/10/2010):
			- Handling of 'undefined' errors for secondary CSS objects
			- Support to enhance 'width' and 'height' properties (except shortcuts involving jQuery.fx.step, e.g slideToggle)
			- Bugfix: Positioning when using avoidTransforms: true (thanks Ralf Santbergen reports)
			- Bugfix: Callbacks and Scope issues
	
		0.48 (13/10/2010):
			- Checks for 3d support before applying
	
		0.47 (12/10/2010);
			- Compatible with .fadeIn(), .fadeOut()
			- Use shortcuts, no duration for jQuery default or "fast" and "slow"
			- Clean up callback event listeners on complete (preventing multiple callbacks)
	
		0.46 (07/10/2010);
			- Compatible with .slideUp(), .slideDown(), .slideToggle()
	
		0.45 (06/10/2010):
			- 'Zero' position bug fix (was originally translating by 0 zero pixels, i.e. no movement)
	
		0.4 (05/10/2010):
			- Iterate over multiple elements and store transforms in jQuery.data per element
			- Include support for relative values (+= / -=)
			- Better unit sanitization
			- Performance tweaks
			- Fix for optional callback function (was required)
			- Applies data[translateX] and data[translateY] to elements for easy access
			- Added 'easeInOutQuint' easing function for CSS transitions (requires jQuery UI for JS anims)
			- Less need for leaveTransforms = true due to better position detections
	*/
	
	(function (window, factory) {
	    if (typeof define === 'function' && define.amd) {
	        // AMD. Register as an anonymous module.
	        define(['jquery'], function(){
	            return factory.apply(window, arguments);
	        });
	    } else if (typeof module === 'object' && module.exports) {
	        // NodeJS.
	        module.exports = factory.call(window, __webpack_require__(2));
	    } else {
	        // Browser globals
	        factory.call(window, window.jQuery);
	    }
	}(typeof global === 'object' ? global : this, function (jQuery) {
	    var originalAnimateMethod = jQuery.fn.animate,
	        originalStopMethod = jQuery.fn.stop;
	
		// ----------
		// Plugin variables
		// ----------
		var	cssTransitionProperties = ['top', 'right', 'bottom', 'left', 'opacity', 'height', 'width'],
			directions = ['top', 'right', 'bottom', 'left'],
			cssPrefixes = ['-webkit-', '-moz-', '-o-', ''],
			pluginOptions = ['avoidTransforms', 'useTranslate3d', 'leaveTransforms'],
			rfxnum = /^([+-]=)?([\d+-.]+)(.*)$/,
			rupper = /([A-Z])/g,
			defaultEnhanceData = {
				secondary: {},
				meta: {
					top : 0,
					right : 0,
					bottom : 0,
					left : 0
				}
			},
			valUnit = 'px',
	
			DATA_KEY = 'jQe',
			CUBIC_BEZIER_OPEN = 'cubic-bezier(',
			CUBIC_BEZIER_CLOSE = ')',
	
			originalAnimatedFilter = null,
			pluginDisabledDefault = false;
	
	
		// ----------
		// Check if this browser supports CSS3 transitions
		// ----------
		var thisBody = document.body || document.documentElement,
			thisStyle = thisBody.style,
			transitionEndEvent = 'webkitTransitionEnd oTransitionEnd transitionend',
			cssTransitionsSupported = thisStyle.WebkitTransition !== undefined || thisStyle.MozTransition !== undefined || thisStyle.OTransition !== undefined || thisStyle.transition !== undefined,
			has3D = ('WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix()),
			use3DByDefault = has3D;
	
	
	
		// ----------
		// Extended :animated filter
		// ----------
		if ( jQuery.expr && jQuery.expr.filters ) {
			originalAnimatedFilter = jQuery.expr.filters.animated;
			jQuery.expr.filters.animated = function(elem) {
				return jQuery(elem).data('events') && jQuery(elem).data('events')[transitionEndEvent] ? true : originalAnimatedFilter.call(this, elem);
			};
		}
	
	
		/**
			@private
			@name _getUnit
			@function
			@description Return unit value ("px", "%", "em" for re-use correct one when translating)
			@param {variant} [val] Target value
		*/
		function _getUnit(val){
			return val.match(/\D+$/);
		}
	
	
		/**
			@private
			@name _interpretValue
			@function
			@description Interpret value ("px", "+=" and "-=" sanitisation)
			@param {object} [element] The Element for current CSS analysis
			@param {variant} [val] Target value
			@param {string} [prop] The property we're looking at
			@param {boolean} [isTransform] Is this a CSS3 transform?
		*/
		function _interpretValue(e, val, prop, isTransform) {
			// this is a nasty fix, but we check for prop == 'd' to see if we're dealing with SVG, and abort
			if (prop == "d") return;
			if (!_isValidElement(e)) return;
	
			var parts = rfxnum.exec(val),
				start = e.css(prop) === 'auto' ? 0 : e.css(prop),
				cleanCSSStart = typeof start == 'string' ? _cleanValue(start) : start,
				cleanTarget = typeof val == 'string' ? _cleanValue(val) : val,
				cleanStart = isTransform === true ? 0 : cleanCSSStart,
				hidden = e.is(':hidden'),
				translation = e.translation();
	
			if (prop == 'left') cleanStart = parseInt(cleanCSSStart, 10) + translation.x;
			if (prop == 'right') cleanStart = parseInt(cleanCSSStart, 10) + translation.x;
			if (prop == 'top') cleanStart = parseInt(cleanCSSStart, 10) + translation.y;
			if (prop == 'bottom') cleanStart = parseInt(cleanCSSStart, 10) + translation.y;
	
			// deal with shortcuts
			if (!parts && val == 'show') {
				cleanStart = 1;
				if (hidden) {
					elem = e[0];
					if (elem.style) {
						display = elem.style.display;
	
						// Reset the inline display of this element to learn if it is
						// being hidden by cascaded rules or not
						if (!jQuery._data(elem, 'olddisplay') && display === 'none') {
							display = elem.style.display = '';
						}
	
						// Set elements which have been overridden with display: none
						// in a stylesheet to whatever the default browser style is
						// for such an element
						if ( display === '' && jQuery.css(elem, 'display') === 'none' ) {
							jQuery._data(elem, 'olddisplay', _domElementVisibleDisplayValue(elem.tagName));
						}
	
						if (display === '' || display === 'none') {
							elem.style.display = jQuery._data(elem, 'olddisplay') || '';
						}
					}
					e.css('opacity', 0);
				}
			} else if (!parts && val == 'hide') {
				cleanStart = 0;
			}
	
			if (parts) {
				var end = parseFloat(parts[2]);
	
				// If a +=/-= token was provided, we're doing a relative animation
				if (parts[1]) end = ((parts[1] === '-=' ? -1 : 1) * end) + parseInt(cleanStart, 10);
	
				// check for unit  as per issue #69
				if (parts[3] && parts[3] != 'px') end = end + parts[3];
	
				return end;
			} else {
				return cleanStart;
			}
		}
	
		/**
			@private
			@name _getTranslation
			@function
			@description Make a translate or translate3d string
			@param {integer} [x]
			@param {integer} [y]
			@param {boolean} [use3D] Use translate3d if available?
		*/
		function _getTranslation(x, y, use3D) {
			return ((use3D === true || ((use3DByDefault === true && use3D !== false)) && has3D)) ? 'translate3d(' + x + 'px, ' + y + 'px, 0)' : 'translate(' + x + 'px,' + y + 'px)';
		}
	
	
		/**
			@private
			@name _applyCSSTransition
			@function
			@description Build up the CSS object
			@param {object} [e] Element
			@param {string} [property] Property we're dealing with
			@param {integer} [duration] Duration
			@param {string} [easing] Easing function
			@param {variant} [value] String/integer for target value
			@param {boolean} [isTransform] Is this a CSS transformation?
			@param {boolean} [isTranslatable] Is this a CSS translation?
			@param {boolean} [use3D] Use translate3d if available?
		*/
		function _applyCSSTransition(e, property, duration, easing, value, isTransform, isTranslatable, use3D) {
			var eCSSData = e.data(DATA_KEY),
				enhanceData = eCSSData && !_isEmptyObject(eCSSData) ? eCSSData : jQuery.extend(true, {}, defaultEnhanceData),
				offsetPosition = value,
				isDirection = jQuery.inArray(property, directions) > -1;
	
	
			if (isDirection) {
				var meta = enhanceData.meta,
					cleanPropertyValue = _cleanValue(e.css(property)) || 0,
					stashedProperty = property + '_o';
	
				offsetPosition = value - cleanPropertyValue;
	
	
				meta[property] = offsetPosition;
				meta[stashedProperty] = e.css(property) == 'auto' ? 0 + offsetPosition : cleanPropertyValue + offsetPosition || 0;
				enhanceData.meta = meta;
	
				// fix 0 issue (transition by 0 = nothing)
				if (isTranslatable && offsetPosition === 0) {
					offsetPosition = 0 - meta[stashedProperty];
					meta[property] = offsetPosition;
					meta[stashedProperty] = 0;
				}
			}
	
			// reapply data and return
			return e.data(DATA_KEY, _applyCSSWithPrefix(e, enhanceData, property, duration, easing, offsetPosition, isTransform, isTranslatable, use3D));
		}
	
		/**
			@private
			@name _applyCSSWithPrefix
			@function
			@description Helper function to build up CSS properties using the various prefixes
			@param {object} [cssProperties] Current CSS object to merge with
			@param {string} [property]
			@param {integer} [duration]
			@param {string} [easing]
			@param {variant} [value]
			@param {boolean} [isTransform] Is this a CSS transformation?
			@param {boolean} [isTranslatable] Is this a CSS translation?
			@param {boolean} [use3D] Use translate3d if available?
		*/
		function _applyCSSWithPrefix(e, cssProperties, property, duration, easing, value, isTransform, isTranslatable, use3D) {
			var saveOriginal = false,
				transform = isTransform === true && isTranslatable === true;
	
	
			cssProperties = cssProperties || {};
			if (!cssProperties.original) {
				cssProperties.original = {};
				saveOriginal = true;
			}
			cssProperties.properties = cssProperties.properties || {};
			cssProperties.secondary = cssProperties.secondary || {};
	
			var meta = cssProperties.meta,
				original = cssProperties.original,
				properties = cssProperties.properties,
				secondary = cssProperties.secondary;
	
			for (var i = cssPrefixes.length - 1; i >= 0; i--) {
				var tp = cssPrefixes[i] + 'transition-property',
					td = cssPrefixes[i] + 'transition-duration',
					tf = cssPrefixes[i] + 'transition-timing-function';
	
				property = (transform ? cssPrefixes[i] + 'transform' : property);
	
				if (saveOriginal) {
					original[tp] = e.css(tp) || '';
					original[td] = e.css(td) || '';
					original[tf] = e.css(tf) || '';
				}
	
				secondary[property] = transform ? _getTranslation(meta.left, meta.top, use3D) : value;
	
				properties[tp] = (properties[tp] ? properties[tp] + ',' : '') + property;
				properties[td] = (properties[td] ? properties[td] + ',' : '') + duration + 'ms';
				properties[tf] = (properties[tf] ? properties[tf] + ',' : '') + easing;
			}
	
			return cssProperties;
		}
	
		/**
			@private
			@name _isBoxShortcut
			@function
			@description Shortcut to detect if we need to step away from slideToggle, CSS accelerated transitions (to come later with fx.step support)
			@param {object} [prop]
		*/
		function _isBoxShortcut(prop) {
			for (var property in prop) {
				if ((property == 'width' || property == 'height') && (prop[property] == 'show' || prop[property] == 'hide' || prop[property] == 'toggle')) {
					return true;
				}
			}
			return false;
		}
	
	
		/**
			@private
			@name _isEmptyObject
			@function
			@description Check if object is empty (<1.4 compatibility)
			@param {object} [obj]
		*/
		function _isEmptyObject(obj) {
			for (var i in obj) {
				return false;
			}
			return true;
		}
	
		/**
		 * Fetch most appropriate display value for element types
		 * @see  https://github.com/benbarnett/jQuery-Animate-Enhanced/issues/121
		 * @private
		 * @param  {[type]} tagName [description]
		 * @return {[type]}         [description]
		 */
		function _domElementVisibleDisplayValue(tagName) {
			tagName = tagName.toUpperCase();
			var displayValues = {
				'LI'       : 'list-item',
				'TR'       : 'table-row',
				'TD'       : 'table-cell',
				'TH'       : 'table-cell',
				'CAPTION'  : 'table-caption',
				'COL'      : 'table-column',
				'COLGROUP' : 'table-column-group',
				'TFOOT'      : 'table-footer-group',
				'THEAD'      : 'table-header-group',
				'TBODY'      : 'table-row-group'
			};
	
			return typeof displayValues[tagName] == 'string' ? displayValues[tagName] : 'block';
		}
	
	
		/**
			@private
			@name _cleanValue
			@function
			@description Remove 'px' and other artifacts
			@param {variant} [val]
		*/
		function _cleanValue(val) {
			return parseFloat(val.replace(_getUnit(val), ''));
		}
	
	
		function _isValidElement(element) {
			var allValid=true;
			element.each(function(index, el) {
				allValid = allValid && el.ownerDocument;
				return allValid;
			});
			return allValid;
		}
	
		/**
			@private
			@name _appropriateProperty
			@function
			@description Function to check if property should be handled by plugin
			@param {string} [prop]
			@param {variant} [value]
		*/
		function _appropriateProperty(prop, value, element) {
			if (!_isValidElement(element)) {
				return false;
			}
	
			var is = jQuery.inArray(prop, cssTransitionProperties) > -1;
			if ((prop == 'width' || prop == 'height' || prop == 'opacity') && (parseFloat(value) === parseFloat(element.css(prop)))) is = false;
			return is;
		}
	
	
		jQuery.extend({
			/**
				@public
				@name toggle3DByDefault
				@function
				@description Toggle for plugin settings to automatically use translate3d (where available). Usage: $.toggle3DByDefault
			*/
			toggle3DByDefault: function() {
				return use3DByDefault = !use3DByDefault;
			},
	
	
			/**
				@public
				@name toggleDisabledByDefault
				@function
				@description Toggle the plugin to be disabled by default (can be overridden per animation with avoidCSSTransitions)
			*/
			toggleDisabledByDefault: function() {
				return pluginDisabledDefault = !pluginDisabledDefault;
			},
	
	
			/**
				@public
				@name setDisabledByDefault
				@function
				@description Set or unset the 'disabled by default' value
			*/
			setDisabledByDefault: function(newValue) {
				return pluginDisabledDefault = newValue;
			}
		});
	
	
		/**
			@public
			@name translation
			@function
			@description Get current X and Y translations
		*/
		jQuery.fn.translation = function() {
			if (!this[0]) {
				return null;
			}
	
			var	elem = this[0],
				cStyle = window.getComputedStyle(elem, null),
				translation = {
					x: 0,
					y: 0
				};
	
			if (cStyle) {
				for (var i = cssPrefixes.length - 1; i >= 0; i--) {
					var transform = cStyle.getPropertyValue(cssPrefixes[i] + 'transform');
					if (transform && (/matrix/i).test(transform)) {
						var explodedMatrix = transform.replace(/^matrix\(/i, '').split(/, |\)$/g);
						translation = {
							x: parseInt(explodedMatrix[4], 10),
							y: parseInt(explodedMatrix[5], 10)
						};
	
						break;
					}
				}
			}
	
			return translation;
		};
	
	
	
		/**
			@public
			@name jQuery.fn.animate
			@function
			@description The enhanced jQuery.animate function
			@param {string} [property]
			@param {string} [speed]
			@param {string} [easing]
			@param {function} [callback]
		*/
		jQuery.fn.animate = function(prop, speed, easing, callback) {
			prop = prop || {};
			var isTranslatable = !(typeof prop['bottom'] !== 'undefined' || typeof prop['right'] !== 'undefined'),
				optall = jQuery.speed(speed, easing, callback),
				callbackQueue = 0,
				propertyCallback = function() {
					callbackQueue--;
					if (callbackQueue === 0) {
						// we're done, trigger the user callback
						if (typeof optall.complete === 'function') {
							optall.complete.apply(this, arguments);
						}
					}
				},
				bypassPlugin = (typeof prop['avoidCSSTransitions'] !== 'undefined') ? prop['avoidCSSTransitions'] : pluginDisabledDefault;
	
			if (bypassPlugin === true || !cssTransitionsSupported || _isEmptyObject(prop) || _isBoxShortcut(prop) || optall.duration <= 0 || optall.step) {
				return originalAnimateMethod.apply(this, arguments);
			}
	
			return this[ optall.queue === true ? 'queue' : 'each' ](function() {
				var self = jQuery(this),
					opt = jQuery.extend({}, optall),
					cssCallback = function(e) {
						var selfCSSData = self.data(DATA_KEY) || { original: {} },
							restore = {};
	
						if (e.eventPhase != 2)  // not at dispatching target (thanks @warappa issue #58)
							return;
	
						// convert translations to left & top for layout
						if (prop.leaveTransforms !== true) {
							for (var i = cssPrefixes.length - 1; i >= 0; i--) {
								restore[cssPrefixes[i] + 'transform'] = '';
							}
							if (isTranslatable && typeof selfCSSData.meta !== 'undefined') {
								for (var j = 0, dir; (dir = directions[j]); ++j) {
									var stashedProperty = selfCSSData.meta[dir + '_o'];
									if (stashedProperty) {
										restore[dir] = stashedProperty + valUnit;
										jQuery(this).css(dir, restore[dir]);
									}
								}
							}
						}
	
						// remove transition timing functions
						self.
							unbind(transitionEndEvent).
							css(selfCSSData.original).
							css(restore).
							data(DATA_KEY, null);
	
						// if we used the fadeOut shortcut make sure elements are display:none
						if (prop.opacity === 'hide') {
							elem = self[0];
							if (elem.style) {
								display = jQuery.css(elem, 'display');
	
								if (display !== 'none' && !jQuery._data(elem, 'olddisplay')) {
									jQuery._data(elem, 'olddisplay', display);
								}
								elem.style.display = 'none';
							}
	
							self.css('opacity', '');
						}
	
						// run the main callback function
						propertyCallback.call(this);
					},
					easings = {
						bounce: CUBIC_BEZIER_OPEN + '0.0, 0.35, .5, 1.3' + CUBIC_BEZIER_CLOSE,
						linear: 'linear',
						swing: 'ease-in-out',
	
						// Penner equation approximations from Matthew Lein's Ceaser: http://matthewlein.com/ceaser/
						easeInQuad:     CUBIC_BEZIER_OPEN + '0.550, 0.085, 0.680, 0.530' + CUBIC_BEZIER_CLOSE,
						easeInCubic:    CUBIC_BEZIER_OPEN + '0.550, 0.055, 0.675, 0.190' + CUBIC_BEZIER_CLOSE,
						easeInQuart:    CUBIC_BEZIER_OPEN + '0.895, 0.030, 0.685, 0.220' + CUBIC_BEZIER_CLOSE,
						easeInQuint:    CUBIC_BEZIER_OPEN + '0.755, 0.050, 0.855, 0.060' + CUBIC_BEZIER_CLOSE,
						easeInSine:     CUBIC_BEZIER_OPEN + '0.470, 0.000, 0.745, 0.715' + CUBIC_BEZIER_CLOSE,
						easeInExpo:     CUBIC_BEZIER_OPEN + '0.950, 0.050, 0.795, 0.035' + CUBIC_BEZIER_CLOSE,
						easeInCirc:     CUBIC_BEZIER_OPEN + '0.600, 0.040, 0.980, 0.335' + CUBIC_BEZIER_CLOSE,
						easeInBack:     CUBIC_BEZIER_OPEN + '0.600, -0.280, 0.735, 0.045' + CUBIC_BEZIER_CLOSE,
						easeOutQuad:    CUBIC_BEZIER_OPEN + '0.250, 0.460, 0.450, 0.940' + CUBIC_BEZIER_CLOSE,
						easeOutCubic:   CUBIC_BEZIER_OPEN + '0.215, 0.610, 0.355, 1.000' + CUBIC_BEZIER_CLOSE,
						easeOutQuart:   CUBIC_BEZIER_OPEN + '0.165, 0.840, 0.440, 1.000' + CUBIC_BEZIER_CLOSE,
						easeOutQuint:   CUBIC_BEZIER_OPEN + '0.230, 1.000, 0.320, 1.000' + CUBIC_BEZIER_CLOSE,
						easeOutSine:    CUBIC_BEZIER_OPEN + '0.390, 0.575, 0.565, 1.000' + CUBIC_BEZIER_CLOSE,
						easeOutExpo:    CUBIC_BEZIER_OPEN + '0.190, 1.000, 0.220, 1.000' + CUBIC_BEZIER_CLOSE,
						easeOutCirc:    CUBIC_BEZIER_OPEN + '0.075, 0.820, 0.165, 1.000' + CUBIC_BEZIER_CLOSE,
						easeOutBack:    CUBIC_BEZIER_OPEN + '0.175, 0.885, 0.320, 1.275' + CUBIC_BEZIER_CLOSE,
						easeInOutQuad:  CUBIC_BEZIER_OPEN + '0.455, 0.030, 0.515, 0.955' + CUBIC_BEZIER_CLOSE,
						easeInOutCubic: CUBIC_BEZIER_OPEN + '0.645, 0.045, 0.355, 1.000' + CUBIC_BEZIER_CLOSE,
						easeInOutQuart: CUBIC_BEZIER_OPEN + '0.770, 0.000, 0.175, 1.000' + CUBIC_BEZIER_CLOSE,
						easeInOutQuint: CUBIC_BEZIER_OPEN + '0.860, 0.000, 0.070, 1.000' + CUBIC_BEZIER_CLOSE,
						easeInOutSine:  CUBIC_BEZIER_OPEN + '0.445, 0.050, 0.550, 0.950' + CUBIC_BEZIER_CLOSE,
						easeInOutExpo:  CUBIC_BEZIER_OPEN + '1.000, 0.000, 0.000, 1.000' + CUBIC_BEZIER_CLOSE,
						easeInOutCirc:  CUBIC_BEZIER_OPEN + '0.785, 0.135, 0.150, 0.860' + CUBIC_BEZIER_CLOSE,
						easeInOutBack:  CUBIC_BEZIER_OPEN + '0.680, -0.550, 0.265, 1.550' + CUBIC_BEZIER_CLOSE
					},
					domProperties = {},
					cssEasing = easings[opt.easing || 'swing'] ? easings[opt.easing || 'swing'] : opt.easing || 'swing';
	
				// seperate out the properties for the relevant animation functions
				for (var p in prop) {
					if (jQuery.inArray(p, pluginOptions) === -1) {
						var isDirection = jQuery.inArray(p, directions) > -1,
							cleanVal = _interpretValue(self, prop[p], p, (isDirection && prop.avoidTransforms !== true));
	
	
						if (/**prop.avoidTransforms !== true && **/_appropriateProperty(p, cleanVal, self)) {
							_applyCSSTransition(
								self,
								p,
								opt.duration,
								cssEasing,
								cleanVal, //isDirection && prop.avoidTransforms === true ? cleanVal + valUnit : cleanVal,
								isDirection && prop.avoidTransforms !== true,
								isTranslatable,
								prop.useTranslate3d);
	
						}
						else {
							domProperties[p] = prop[p];
						}
					}
				}
	
				self.unbind(transitionEndEvent);
	
				var selfCSSData = self.data(DATA_KEY);
	
	
				if (selfCSSData && !_isEmptyObject(selfCSSData) && !_isEmptyObject(selfCSSData.secondary)) {
					callbackQueue++;
	
					self.css(selfCSSData.properties);
	
					// store in a var to avoid any timing issues, depending on animation duration
					var secondary = selfCSSData.secondary;
	
					// has to be done in a timeout to ensure transition properties are set
					setTimeout(function() {
						self.bind(transitionEndEvent, cssCallback).css(secondary);
					});
				}
				else {
					// it won't get fired otherwise
					opt.queue = false;
				}
	
				// fire up DOM based animations
				if (!_isEmptyObject(domProperties)) {
					callbackQueue++;
					originalAnimateMethod.apply(self, [domProperties, {
						duration: opt.duration,
						easing: jQuery.easing[opt.easing] ? opt.easing : (jQuery.easing.swing ? 'swing' : 'linear'),
						complete: propertyCallback,
						queue: opt.queue
					}]);
				}
	
				// strict JS compliance
				return true;
			});
		};
	
	    jQuery.fn.animate.defaults = {};
	
	
		/**
			@public
			@name jQuery.fn.stop
			@function
			@description The enhanced jQuery.stop function (resets transforms to left/top)
			@param {boolean} [clearQueue]
			@param {boolean} [gotoEnd]
			@param {boolean} [leaveTransforms] Leave transforms/translations as they are? Default: false (reset translations to calculated explicit left/top props)
		*/
		jQuery.fn.stop = function(clearQueue, gotoEnd, leaveTransforms) {
			if (!cssTransitionsSupported) return originalStopMethod.apply(this, [clearQueue, gotoEnd]);
	
			// clear the queue?
			if (clearQueue) this.queue([]);
	
			// route to appropriate stop methods
			this.each(function() {
				var self = jQuery(this),
					selfCSSData = self.data(DATA_KEY);
	
				// is this a CSS transition?
				if (selfCSSData && !_isEmptyObject(selfCSSData)) {
					var i, restore = {};
	
					if (gotoEnd) {
						// grab end state properties
						restore = selfCSSData.secondary;
	
						if (!leaveTransforms && typeof selfCSSData.meta['left_o'] !== undefined || typeof selfCSSData.meta['top_o'] !== undefined) {
							restore['left'] = typeof selfCSSData.meta['left_o'] !== undefined ? selfCSSData.meta['left_o'] : 'auto';
							restore['top'] = typeof selfCSSData.meta['top_o'] !== undefined ? selfCSSData.meta['top_o'] : 'auto';
	
							// remove the transformations
							for (i = cssPrefixes.length - 1; i >= 0; i--) {
								restore[cssPrefixes[i]+'transform'] = '';
							}
						}
					} else if (!_isEmptyObject(selfCSSData.secondary)) {
						var cStyle = window.getComputedStyle(self[0], null);
						if (cStyle) {
							// grab current properties
							for (var prop in selfCSSData.secondary) {
								if(selfCSSData.secondary.hasOwnProperty(prop)) {
									prop = prop.replace(rupper, '-$1').toLowerCase();
									restore[prop] = cStyle.getPropertyValue(prop);
	
									// is this a matrix property? extract left and top and apply
									if (!leaveTransforms && (/matrix/i).test(restore[prop])) {
										var explodedMatrix = restore[prop].replace(/^matrix\(/i, '').split(/, |\)$/g);
	
										// apply the explicit left/top props
										restore['left'] = (parseFloat(explodedMatrix[4]) + parseFloat(self.css('left')) + valUnit) || 'auto';
										restore['top'] = (parseFloat(explodedMatrix[5]) + parseFloat(self.css('top')) + valUnit) || 'auto';
	
										// remove the transformations
										for (i = cssPrefixes.length - 1; i >= 0; i--) {
											restore[cssPrefixes[i]+'transform'] = '';
										}
									}
								}
							}
						}
					}
	
					// Remove transition timing functions
					// Moving to seperate thread (re: Animation reverts when finished in Android - issue #91)
					self.unbind(transitionEndEvent);
					self.
						css(selfCSSData.original).
						css(restore).
						data(DATA_KEY, null);
				}
				else {
					// dom transition
					originalStopMethod.apply(self, [clearQueue, gotoEnd]);
				}
			});
	
			return this;
		};
	}));
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var breadcrumbs_1 = __webpack_require__(474);
	if (console.warn) {
	    console.warn("pli/breadcrumbs is deprecated and will be removed in pli@8.0. Use import { createBreadCrumbs } from \"pli/forms/breadcrumbs\" instead.");
	}
	var breadcrumbs = breadcrumbs_1.createBreadcrumbs;
	module.exports = breadcrumbs;
	



/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var safeIdRegEx = new RegExp("^\\.(?:\\(\\d*\\))?$");
	/**
	 * Defines a custom knockout binding for breadcrumbs.
	 */
	ko.bindingHandlers.pliBreadcrumbs = {
	    /**
	     * Modifies the element by adding a list element for breadcrumbs.
	     *
	     * @param element
	     *     The HTML element that the knockout binding is applied to.
	     * @param valueAccessor
	     *     An array containing breadcrumb segments.
	     */
	    update: function (element, valueAccessor) {
	        var html = "";
	        var crumbs = ko.unwrap(valueAccessor());
	        if (crumbs && crumbs.length > 0) {
	            var l = crumbs.length;
	            for (var i = 0; i < l; i++) {
	                if (typeof crumbs[i].name !== "string" || typeof crumbs[i].href !== "string") {
	                    throw new Error("pliBreadcrumbs.update: each crumb requires a 'name' and 'href'.");
	                }
	                html = (i === l - 1) // last item (exclude href + add active class)
	                    ? html.concat("<li class=\"active\"><a>")
	                    : html.concat("<li><a href=\"").concat(crumbs[i].href).concat("\">");
	                html = html.concat(crumbs[i].name).concat("</a></li>");
	            }
	        }
	        if (html !== "" && element) {
	            element.innerHTML = html;
	        }
	    }
	};
	/**
	 * Recursively find the display ID for the item with the given safe ID.
	 *
	 * This must be recursive because we always start at the page
	 * viewmodel level.
	 *
	 * @param safeId
	 *     The value which should match a safeId property value on the given model's
	 *     extra object or from a child property' extra object.
	 * @param modelObject
	 *     The model object to look on for a display ID.
	 * @returns
	 *     The display ID on the model object or null if not found.
	 */
	function findDisplayId(safeId, modelObject) {
	    // If no model object is given, revert to old behaviour (return null)
	    if (!modelObject) {
	        return null;
	    }
	    // If the model object has a defined safeID and it matches
	    // use either the property specified by displayIdObservable
	    // or extras.displayId
	    if (modelObject.extras && ko.isObservable(modelObject.extras.safeId) && modelObject.extras.safeId() === safeId) {
	        if (modelObject.displayIdObservable && ko.isObservable(modelObject[modelObject.displayIdObservable])) {
	            return modelObject[modelObject.displayIdObservable]();
	        }
	        if (ko.isObservable(modelObject.extras.displayId)) {
	            return modelObject.extras.displayId();
	        }
	    }
	    // If the safeId doesn't match, one of our children might have
	    // that safeId, so check all arrays for view models and try
	    // recursively.
	    for (var prop in modelObject) {
	        if (modelObject.hasOwnProperty(prop) && modelObject[prop] && modelObject[prop].removeAll) {
	            var array = modelObject[prop]();
	            for (var i = 0; i < array.length; i++) {
	                var displayId = findDisplayId(safeId, array[i]);
	                if (displayId) {
	                    return displayId;
	                }
	            }
	        }
	    }
	    return null;
	}
	/**
	 * Creates an observable containing an array of breadcrumb navigation links.
	 *
	 * Changes to the crumbs observable will modify the contents of the breadcrumbs
	 * computed observable.
	 *
	 * @param crumbs
	 *     The navigation objects to create bredcrumbs from.
	 * @param viewModel
	 *     An optional viewmodel used in creating a breadcrumb title if it contains a safe ID property.
	 * @returns
	 *     A read-only observable containing an array of breadcrumbs constructed from the crumbs observable.
	 */
	function createBreadcrumbs(crumbs, viewModel) {
	    if (!ko.isObservable(crumbs)) {
	        throw new Error("createBreadcrumbs: \"crumbs\" must be an observable.");
	    }
	    return ko.pureComputed(function () {
	        var result = [];
	        var crumbsValue = crumbs();
	        if (crumbsValue) {
	            var currentCrumb = crumbsValue.begin;
	            while (currentCrumb) {
	                if (currentCrumb.page && currentCrumb.page.form && !currentCrumb.inLocationHash) {
	                    break;
	                }
	                var title = (result.length === 0
	                    ? ""
	                    : (currentCrumb.page && currentCrumb.page.title)
	                        || (currentCrumb.data && viewModel && findDisplayId(currentCrumb.data.id, viewModel))
	                        || (currentCrumb.data && safeIdRegEx.test(currentCrumb.data.id) ? "(New)" : currentCrumb.data.id));
	                result.push({ name: title, href: currentCrumb.hash });
	                currentCrumb = currentCrumb.next;
	            }
	        }
	        return result;
	    });
	}
	exports.createBreadcrumbs = createBreadcrumbs;
	



/***/ }),
/* 475 */,
/* 476 */,
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var exportInGlobalDbg = __webpack_require__(459).exportInGlobalDbg;
	
	var ClientBroadcastManager = __webpack_require__(478);
	var SignalRConnection = __webpack_require__(480);
	
	var clientBroadcastManager = new ClientBroadcastManager(SignalRConnection);
	
	module.exports = exportInGlobalDbg("clientBroadcastManager", clientBroadcastManager);
	


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var $ = __webpack_require__(1);
	var pli = __webpack_require__(5);
	var simpleDialogRegistry = __webpack_require__(390);
	
	var CallbackSubscribable = __webpack_require__(479);
	
	var parentBroadcastManager = pli.findComponent("clientBroadcastManager"),
	    nextPersistentMessageNumber = 1;
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Class "ClientBroadcastManager"
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-----------------------------------------------
	// Create new instance of ClientBroadcastManager (singleton,
	// one instance per browser window).
	function ClientBroadcastManager(connectionType) {
	    if (typeof connectionType !== "function") {
	        throw new Error("Expected a `connectionType` function");
	    }
	
	    this._connection = null;
	    this._connectionType = connectionType;
	    this._isConnected = false;
	    this._persistentMessages = {};
	    this._updatedCallbacks = new $.Callbacks();
	    this._updatedSubscribable = new CallbackSubscribable(this._updatedCallbacks);
	
	    this._sendMessages = this._sendMessages.bind(this);
	}
	
	
	//-----------------------------------------------
	// Disconnect from parent or dispose of connection and reset to initial state.
	ClientBroadcastManager.prototype._dispose = function disposeBroadcastManager() {
	    if (parentBroadcastManager &&
	            // ensure parent isn't disposing too (if so, don't bother unregistering)
	            !(simpleDialogRegistry && simpleDialogRegistry._isUnloading)) {
	        parentBroadcastManager.offUpdated(this._sendMessages);
	    }
	    if (this._connection && typeof this._connection._dispose === "function") {
	        this._connection._dispose();
	        this._connection = null;
	    }
	    this._isConnected = false;
	    this._persistentMessages = null;
	    this._updatedSubscribable = null;
	};
	
	
	//-----------------------------------------------
	// Fires callbacks for each of the messages.
	// Expects the raw message(s) to be sent
	ClientBroadcastManager.prototype._sendMessages = function sendMessages(raw) {
	    if (!raw) { return; } // no messages defined (ignore)
	
	    var i, length, messages, message;
	    messages = Array.isArray(raw) ? raw : [raw];
	    for (i = 0, length = messages.length; i < length; i += 1) { // Loop through and trigger each received message individually
	        message = messages[i];
	        this._updatedCallbacks.fire(message);
	        // store persistent messages (to send to new connections)
	        if (message.id) {
	            // add messageNumber to message to allow recovery of order for new connections
	            message.messageNumber = nextPersistentMessageNumber;
	            nextPersistentMessageNumber += 1;
	            this._persistentMessages[message.type + "+" + message.id] = message;
	        }
	    }
	};
	
	
	//-----------------------------------------------
	// Gets all of the persistent messages in the same order as they were sent
	// from the server.  This requires that the messages be sorted by their
	// messageNumber property to put them back into the correct order.
	ClientBroadcastManager.prototype._getPersistentMessages = function getPersistentMessages() {
	    var messages,
	        messageId;
	
	    if (parentBroadcastManager) {
	        return parentBroadcastManager._getPersistentMessages();
	    }
	
	    messages = [];
	
	    for (messageId in this._persistentMessages) {
	        if (this._persistentMessages.hasOwnProperty(messageId)) {
	            messages.push(this._persistentMessages[messageId]);
	        }
	    }
	
	    messages.sort(function (left, right) {
	        return left.messageNumber - right.messageNumber;
	    });
	
	    return messages;
	};
	
	
	//-----------------------------------------------
	// Ensures a connection to the server.  Will connect to the parent client broadcast
	// manager instance if available otherwise starts up the connection to the server.
	ClientBroadcastManager.prototype._ensureConnectionToServer = function ensureConnectionToServer() {
	    if (!this._isConnected) {
	        if (parentBroadcastManager) {
	            parentBroadcastManager.onUpdated(this._sendMessages);
	            this._isConnected = true;
	        } else {
	            var config = (pli.config && pli.config.clientBroadcastManager) || {};
	            this._connection = new this._connectionType(config, this._sendMessages);
	            this._isConnected = true;
	        }
	
	        // if we connected, setup disposal on window close
	        if (this._isConnected && global.addEventListener !== undefined) {
	            global.addEventListener("unload", this._dispose);
	        }
	    }
	};
	
	
	//-----------------------------------------------
	// Add a callback that is triggered when any message is received
	// from the server.  The message format is follows:
	// {
	//   type: "dataCache",
	//   id: "messageId",
	//   data: { }
	// }
	ClientBroadcastManager.prototype.onUpdated = function onUpdatedEvent(callback) {
	    // delay server connection until first event handler is added
	    this._ensureConnectionToServer();
	
	    this._updatedSubscribable.add(callback);
	
	    // Send persistent messages
	    var key, messages = this._getPersistentMessages();
	    if (messages) {
	        for (key in messages) {
	            if (messages.hasOwnProperty(key)) { callback(messages[key]); }
	        }
	    }
	};
	
	
	//-----------------------------------------------
	// Remove an existing callback from updated event.
	ClientBroadcastManager.prototype.offUpdated = function offUpdatedEvent(callback) {
	    this._updatedSubscribable.remove(callback);
	};
	
	
	// return the singleton client broadcast manager
	module.exports = ClientBroadcastManager;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	//-------------------------------------------
	function findCallbackInArray(callback, callbacks) {
	    /// <summary>
	    /// Searchs the array for the index of the original function
	    /// and the wrapper function.
	    /// </summary>
	    var i, length;
	    // loop through and look for match of the original function
	    for (i = 0, length = callbacks.length; i < length; i += 1) {
	        if (callbacks[i][0] === callback) { return i; }
	    }
	    return -1;
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// CallbackSubscribable class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function CallbackSubscribable($callback) {
	    /// <summary>
	    /// Initializes a subscribable which is a wrapper for a
	    /// jQuery.Callbacks that hides disable/fire/fired/fireWith/lock/locked
	    /// Also add/remove only support a function (not an array of functions).
	    /// Addresses issue with IE passing functions between windows
	    /// (http://stackoverflow.com/questions/10499623/cant-pass-a-function-from-one-window-to-another-in-ie/10524514#10524514)
	    /// </summary>
	
	    // Allow instantiation without the 'new' keyword
	    if (!(this instanceof CallbackSubscribable)) { return new CallbackSubscribable($callback); }
	
	    this._$callback = $callback;
	    this._callbackMap = []; // map of IE "object-functions" (from another window) to wrapper-function
	    return this;
	
	}
	
	
	//-------------------------------------------
	CallbackSubscribable.prototype.add = function subscribableAdd(callback) {
	    /// <summary>
	    /// Registers a callback if it is not already registered.
	    /// An error is thrown if the callback is not a function.
	    /// </summary>
	    /// <param name="callback">
	    /// A function that is to be added to the callback list.
	    /// </param>
	
	    if (typeof callback === "function") {
	        this._$callback.add(callback);
	
	    // Handle invalid type of function in IE when passed accross windows
	    } else if (callback && callback.call) {
	        var tempCallback = function handler(data) { callback(data); },
	            i = findCallbackInArray(callback, this._callbackMap);
	        if (i < 0) {
	            this._callbackMap.push([callback, tempCallback]);
	            this._$callback.add(tempCallback);
	        }
	
	    } else {
	        throw new Error("$.Callbacks.Subscribable.add requires a callback function");
	    }
	
	    return this;
	
	};
	
	
	//-------------------------------------------
	CallbackSubscribable.prototype.empty = function subscribableEmpty() {
	    /// <summary>
	    /// Removes all of registered callbacks
	    /// </summary>
	    this._$callback.empty();
	    this._callbackMap.length = 0; // empty the callbacks array -> http://css-tricks.com/snippets/javascript/empty-an-array/
	    return this;
	};
	
	
	//-------------------------------------------
	CallbackSubscribable.prototype.has = function subscribableHas(callback) {
	    /// <summary>
	    /// Determine whether the callback is registered
	    /// </summary>
	    return (typeof callback === "function")
	        ? this._$callback.has(callback)
	        : (findCallbackInArray(callback, this._callbackMap) >= 0);
	};
	
	
	//-------------------------------------------
	CallbackSubscribable.prototype.remove = function subscribableRemove(callback) {
	    /// <summary>
	    /// Removes a registered callback
	    /// </summary>
	
	    if (typeof callback === "function") {
	        this._$callback.remove(callback);
	
	    // Handle invalid type of function in IE when passed accross windows
	    } else if (callback && callback.call) {
	        var i = findCallbackInArray(callback, this._callbackMap);
	        if (i >= 0) {
	            this._$callback.remove(this._callbackMap[i][1]);
	            this._callbackMap.splice(i, 1);
	        }
	    }
	
	    return this;
	};
	
	module.exports = CallbackSubscribable;
	


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint browser: true */
	
	"use strict";
	
	__webpack_require__(481); // defines $.signalR
	
	var $ = __webpack_require__(1);
	var pli = __webpack_require__(5);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Class "ClientBroadcastManagerSignalRConnection"
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-----------------------------------------------
	function ClientBroadcastManagerSignalRConnection(config, sendMessagesCallback) {
	    /// <summary></summary>
	    var url = typeof config.url === "string" ? "~" + config.url : "~/ClientBroadcastManager";
	
	    this._sendMessagesCallback = sendMessagesCallback;
	    this._signalRInstance = new $.signalR(pli.resolveUrl(url));
	    this._signalRInstance.data = window.location.href; // specify the appUrl so we can determine the partition.
	    this._signalRInstance.received(ClientBroadcastManagerSignalRConnection.prototype._received.bind(this));
	    this._signalRInstance.start(ClientBroadcastManagerSignalRConnection.prototype._started.bind(this));
	}
	
	
	//-----------------------------------------------
	ClientBroadcastManagerSignalRConnection.prototype._dispose = function disposeClientBroadcastManagerSignalRConnection() {
	    this._signalRInstance.stop();
	};
	
	
	//-----------------------------------------------
	// Called when SignalR starts successfully.
	// Initiates conversation with server
	// (sending an empty message causes server
	// to respond with persistent messages).
	ClientBroadcastManagerSignalRConnection.prototype._started = function startClientBroadcastManagerSignalRConnection() {
	    this._signalRInstance.send("In ClientBroadcastManagerSignalRConnection.prototype._started.");
	};
	
	
	//-----------------------------------------------
	// Handles the signalR received event
	ClientBroadcastManagerSignalRConnection.prototype._received = function receivedClientBroadcastManagerSignalRConnection(result) {
	    this._sendMessagesCallback(JSON.parse(result));
	};
	
	module.exports = ClientBroadcastManagerSignalRConnection;
	


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(global, module) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	
	; jQuery = global.jQuery = __webpack_require__(2);
	; var __browserify_shim_require__=require;(function browserifyShim(module, define, require) {
	/* jquery.signalR.core.js */
	/*global window:false */
	/*!
	 * ASP.NET SignalR JavaScript Library v2.1.1
	 * http://signalr.net/
	 *
	 * Copyright (C) Microsoft Corporation. All rights reserved.
	 *
	 */
	
	/// <reference path="Scripts/jquery-1.6.4.js" />
	/// <reference path="jquery.signalR.version.js" />
	(function ($, window, undefined) {
	
	    var resources = {
	        nojQuery: "jQuery was not found. Please ensure jQuery is referenced before the SignalR client JavaScript file.",
	        noTransportOnInit: "No transport could be initialized successfully. Try specifying a different transport or none at all for auto initialization.",
	        errorOnNegotiate: "Error during negotiation request.",
	        stoppedWhileLoading: "The connection was stopped during page load.",
	        stoppedWhileNegotiating: "The connection was stopped during the negotiate request.",
	        errorParsingNegotiateResponse: "Error parsing negotiate response.",
	        errorDuringStartRequest: "Error during start request. Stopping the connection.",
	        stoppedDuringStartRequest: "The connection was stopped during the start request.",
	        errorParsingStartResponse: "Error parsing start response: '{0}'. Stopping the connection.",
	        invalidStartResponse: "Invalid start response: '{0}'. Stopping the connection.",
	        protocolIncompatible: "You are using a version of the client that isn't compatible with the server. Client version {0}, server version {1}.",
	        sendFailed: "Send failed.",
	        parseFailed: "Failed at parsing response: {0}",
	        longPollFailed: "Long polling request failed.",
	        eventSourceFailedToConnect: "EventSource failed to connect.",
	        eventSourceError: "Error raised by EventSource",
	        webSocketClosed: "WebSocket closed.",
	        pingServerFailedInvalidResponse: "Invalid ping response when pinging server: '{0}'.",
	        pingServerFailed: "Failed to ping server.",
	        pingServerFailedStatusCode: "Failed to ping server.  Server responded with status code {0}, stopping the connection.",
	        pingServerFailedParse: "Failed to parse ping server response, stopping the connection.",
	        noConnectionTransport: "Connection is in an invalid state, there is no transport active.",
	        webSocketsInvalidState: "The Web Socket transport is in an invalid state, transitioning into reconnecting.",
	        reconnectTimeout: "Couldn't reconnect within the configured timeout of {0} ms, disconnecting.",
	        reconnectWindowTimeout: "The client has been inactive since {0} and it has exceeded the inactivity timeout of {1} ms. Stopping the connection."
	    };
	
	    if (typeof ($) !== "function") {
	        // no jQuery!
	        throw new Error(resources.nojQuery);
	    }
	
	    var signalR,
	        _connection,
	        _pageLoaded = (window.document.readyState === "complete"),
	        _pageWindow = $(window),
	        _negotiateAbortText = "__Negotiate Aborted__",
	        events = {
	            onStart: "onStart",
	            onStarting: "onStarting",
	            onReceived: "onReceived",
	            onError: "onError",
	            onConnectionSlow: "onConnectionSlow",
	            onReconnecting: "onReconnecting",
	            onReconnect: "onReconnect",
	            onStateChanged: "onStateChanged",
	            onDisconnect: "onDisconnect"
	        },
	        ajaxDefaults = {
	            processData: true,
	            timeout: null,
	            async: true,
	            global: false,
	            cache: false
	        },
	        log = function (msg, logging) {
	            if (logging === false) {
	                return;
	            }
	            var m;
	            if (typeof (window.console) === "undefined") {
	                return;
	            }
	            m = "[" + new Date().toTimeString() + "] SignalR: " + msg;
	            if (window.console.debug) {
	                window.console.debug(m);
	            } else if (window.console.log) {
	                window.console.log(m);
	            }
	        },
	
	        changeState = function (connection, expectedState, newState) {
	            if (expectedState === connection.state) {
	                connection.state = newState;
	
	                $(connection).triggerHandler(events.onStateChanged, [{ oldState: expectedState, newState: newState }]);
	                return true;
	            }
	
	            return false;
	        },
	
	        isDisconnecting = function (connection) {
	            return connection.state === signalR.connectionState.disconnected;
	        },
	        
	        supportsKeepAlive = function (connection) {
	            return connection._.keepAliveData.activated &&
	                   connection.transport.supportsKeepAlive(connection);
	        },
	
	        configureStopReconnectingTimeout = function (connection) {
	            var stopReconnectingTimeout,
	                onReconnectTimeout;
	
	            // Check if this connection has already been configured to stop reconnecting after a specified timeout.
	            // Without this check if a connection is stopped then started events will be bound multiple times.
	            if (!connection._.configuredStopReconnectingTimeout) {
	                onReconnectTimeout = function (connection) {
	                    var message = signalR._.format(signalR.resources.reconnectTimeout, connection.disconnectTimeout);
	                    connection.log(message);
	                    $(connection).triggerHandler(events.onError, [signalR._.error(message, /* source */ "TimeoutException")]);
	                    connection.stop(/* async */ false, /* notifyServer */ false);
	                };
	
	                connection.reconnecting(function () {
	                    var connection = this;
	
	                    // Guard against state changing in a previous user defined even handler
	                    if (connection.state === signalR.connectionState.reconnecting) {
	                        stopReconnectingTimeout = window.setTimeout(function () { onReconnectTimeout(connection); }, connection.disconnectTimeout);
	                    }
	                });
	
	                connection.stateChanged(function (data) {
	                    if (data.oldState === signalR.connectionState.reconnecting) {
	                        // Clear the pending reconnect timeout check
	                        window.clearTimeout(stopReconnectingTimeout);
	                    }
	                });
	
	                connection._.configuredStopReconnectingTimeout = true;
	            }
	        };
	
	    signalR = function (url, qs, logging) {
	        /// <summary>Creates a new SignalR connection for the given url</summary>
	        /// <param name="url" type="String">The URL of the long polling endpoint</param>
	        /// <param name="qs" type="Object">
	        ///     [Optional] Custom querystring parameters to add to the connection URL.
	        ///     If an object, every non-function member will be added to the querystring.
	        ///     If a string, it's added to the QS as specified.
	        /// </param>
	        /// <param name="logging" type="Boolean">
	        ///     [Optional] A flag indicating whether connection logging is enabled to the browser
	        ///     console/log. Defaults to false.
	        /// </param>
	
	        return new signalR.fn.init(url, qs, logging);
	    };
	
	    signalR._ = {
	        defaultContentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
	        ieVersion: (function () {
	            var version,
	                matches;
	
	            if (window.navigator.appName === 'Microsoft Internet Explorer') {
	                // Check if the user agent has the pattern "MSIE (one or more numbers).(one or more numbers)";
	                matches = /MSIE ([0-9]+\.[0-9]+)/.exec(window.navigator.userAgent);
	
	                if (matches) {
	                    version = window.parseFloat(matches[1]);
	                }
	            }
	
	            // undefined value means not IE
	            return version;
	        })(),
	
	        error: function (message, source, context) {
	            var e = new Error(message);
	            e.source = source;
	
	            if (typeof context !== "undefined") {
	                e.context = context;
	            }
	
	            return e;
	        },
	
	        transportError: function (message, transport, source, context) {
	            var e = this.error(message, source, context);
	            e.transport = transport ? transport.name : undefined;
	            return e;
	        },
	
	        format: function () {
	            /// <summary>Usage: format("Hi {0}, you are {1}!", "Foo", 100) </summary>
	            var s = arguments[0];
	            for (var i = 0; i < arguments.length - 1; i++) {
	                s = s.replace("{" + i + "}", arguments[i + 1]);
	            }
	            return s;
	        },
	
	        firefoxMajorVersion: function (userAgent) {
	            // Firefox user agents: http://useragentstring.com/pages/Firefox/
	            var matches = userAgent.match(/Firefox\/(\d+)/);
	            if (!matches || !matches.length || matches.length < 2) {
	                return 0;
	            }
	            return parseInt(matches[1], 10 /* radix */);
	        },
	
	        configurePingInterval: function (connection) {
	            var config = connection._.config,
	                onFail = function (error) {
	                    $(connection).triggerHandler(events.onError, [error]);
	                };
	
	            if (config && !connection._.pingIntervalId && config.pingInterval) {
	                connection._.pingIntervalId = window.setInterval(function () {
	                    signalR.transports._logic.pingServer(connection).fail(onFail);
	                }, config.pingInterval);
	            }
	        }
	    };
	
	    signalR.events = events;
	
	    signalR.resources = resources;
	
	    signalR.ajaxDefaults = ajaxDefaults;
	
	    signalR.changeState = changeState;
	
	    signalR.isDisconnecting = isDisconnecting;
	
	    signalR.connectionState = {
	        connecting: 0,
	        connected: 1,
	        reconnecting: 2,
	        disconnected: 4
	    };
	
	    signalR.hub = {
	        start: function () {
	            // This will get replaced with the real hub connection start method when hubs is referenced correctly
	            throw new Error("SignalR: Error loading hubs. Ensure your hubs reference is correct, e.g. <script src='/signalr/js'></script>.");
	        }
	    };
	
	    _pageWindow.load(function () { _pageLoaded = true; });
	
	    function validateTransport(requestedTransport, connection) {
	        /// <summary>Validates the requested transport by cross checking it with the pre-defined signalR.transports</summary>
	        /// <param name="requestedTransport" type="Object">The designated transports that the user has specified.</param>
	        /// <param name="connection" type="signalR">The connection that will be using the requested transports.  Used for logging purposes.</param>
	        /// <returns type="Object" />
	
	        if ($.isArray(requestedTransport)) {
	            // Go through transport array and remove an "invalid" tranports
	            for (var i = requestedTransport.length - 1; i >= 0; i--) {
	                var transport = requestedTransport[i];
	                if ($.type(transport) !== "string" || !signalR.transports[transport]) {
	                    connection.log("Invalid transport: " + transport + ", removing it from the transports list.");
	                    requestedTransport.splice(i, 1);
	                }
	            }
	
	            // Verify we still have transports left, if we dont then we have invalid transports
	            if (requestedTransport.length === 0) {
	                connection.log("No transports remain within the specified transport array.");
	                requestedTransport = null;
	            }
	        } else if (!signalR.transports[requestedTransport] && requestedTransport !== "auto") {
	            connection.log("Invalid transport: " + requestedTransport.toString() + ".");
	            requestedTransport = null;
	        } else if (requestedTransport === "auto" && signalR._.ieVersion <= 8) {
	            // If we're doing an auto transport and we're IE8 then force longPolling, #1764
	            return ["longPolling"];
	
	        }
	
	        return requestedTransport;
	    }
	
	    function getDefaultPort(protocol) {
	        if (protocol === "http:") {
	            return 80;
	        } else if (protocol === "https:") {
	            return 443;
	        }
	    }
	
	    function addDefaultPort(protocol, url) {
	        // Remove ports  from url.  We have to check if there's a / or end of line
	        // following the port in order to avoid removing ports such as 8080.
	        if (url.match(/:\d+$/)) {
	            return url;
	        } else {
	            return url + ":" + getDefaultPort(protocol);
	        }
	    }
	
	    function ConnectingMessageBuffer(connection, drainCallback) {
	        var that = this,
	            buffer = [];
	
	        that.tryBuffer = function (message) {
	            if (connection.state === $.signalR.connectionState.connecting) {
	                buffer.push(message);
	
	                return true;
	            }
	
	            return false;
	        };
	
	        that.drain = function () {
	            // Ensure that the connection is connected when we drain (do not want to drain while a connection is not active)
	            if (connection.state === $.signalR.connectionState.connected) {
	                while (buffer.length > 0) {
	                    drainCallback(buffer.shift());
	                }
	            }
	        };
	
	        that.clear = function () {
	            buffer = [];
	        };
	    }
	
	    signalR.fn = signalR.prototype = {
	        init: function (url, qs, logging) {
	            var $connection = $(this);
	
	            this.url = url;
	            this.qs = qs;
	            this.lastError = null;
	            this._ = {
	                keepAliveData: {},
	                connectingMessageBuffer: new ConnectingMessageBuffer(this, function (message) {
	                    $connection.triggerHandler(events.onReceived, [message]);
	                }),
	                onFailedTimeoutHandle: null,
	                lastMessageAt: new Date().getTime(),
	                lastActiveAt: new Date().getTime(),
	                beatInterval: 5000, // Default value, will only be overridden if keep alive is enabled,
	                beatHandle: null,
	                totalTransportConnectTimeout: 0 // This will be the sum of the TransportConnectTimeout sent in response to negotiate and connection.transportConnectTimeout
	            };
	            if (typeof (logging) === "boolean") {
	                this.logging = logging;
	            }
	        },
	
	        _parseResponse: function (response) {
	            var that = this;
	
	            if (!response) {
	                return response;
	            } else if (typeof response === "string") {
	                return that.json.parse(response);
	            } else {
	                return response;
	            }
	        },
	
	        _originalJson: window.JSON,
	
	        json: window.JSON,
	
	        isCrossDomain: function (url, against) {
	            /// <summary>Checks if url is cross domain</summary>
	            /// <param name="url" type="String">The base URL</param>
	            /// <param name="against" type="Object">
	            ///     An optional argument to compare the URL against, if not specified it will be set to window.location.
	            ///     If specified it must contain a protocol and a host property.
	            /// </param>
	            var link;
	
	            url = $.trim(url);
	
	            against = against || window.location;
	
	            if (url.indexOf("http") !== 0) {
	                return false;
	            }
	
	            // Create an anchor tag.
	            link = window.document.createElement("a");
	            link.href = url;
	
	            // When checking for cross domain we have to special case port 80 because the window.location will remove the 
	            return link.protocol + addDefaultPort(link.protocol, link.host) !== against.protocol + addDefaultPort(against.protocol, against.host);
	        },
	
	        ajaxDataType: "text",
	
	        contentType: "application/json; charset=UTF-8",
	
	        logging: false,
	
	        state: signalR.connectionState.disconnected,
	
	        clientProtocol: "1.4",
	
	        reconnectDelay: 2000,
	
	        transportConnectTimeout: 0,
	
	        disconnectTimeout: 30000, // This should be set by the server in response to the negotiate request (30s default)
	
	        reconnectWindow: 30000, // This should be set by the server in response to the negotiate request 
	
	        keepAliveWarnAt: 2 / 3, // Warn user of slow connection if we breach the X% mark of the keep alive timeout
	
	        start: function (options, callback) {
	            /// <summary>Starts the connection</summary>
	            /// <param name="options" type="Object">Options map</param>
	            /// <param name="callback" type="Function">A callback function to execute when the connection has started</param>
	            var connection = this,
	                config = {
	                    pingInterval: 300000,
	                    waitForPageLoad: true,
	                    transport: "auto",
	                    jsonp: false
	                },
	                initialize,
	                deferred = connection._deferral || $.Deferred(), // Check to see if there is a pre-existing deferral that's being built on, if so we want to keep using it
	                parser = window.document.createElement("a");
	
	            connection.lastError = null;
	
	            // Persist the deferral so that if start is called multiple times the same deferral is used.
	            connection._deferral = deferred;
	
	            if (!connection.json) {
	                // no JSON!
	                throw new Error("SignalR: No JSON parser found. Please ensure json2.js is referenced before the SignalR.js file if you need to support clients without native JSON parsing support, e.g. IE<8.");
	            }
	
	            if ($.type(options) === "function") {
	                // Support calling with single callback parameter
	                callback = options;
	            } else if ($.type(options) === "object") {
	                $.extend(config, options);
	                if ($.type(config.callback) === "function") {
	                    callback = config.callback;
	                }
	            }
	
	            config.transport = validateTransport(config.transport, connection);
	
	            // If the transport is invalid throw an error and abort start
	            if (!config.transport) {
	                throw new Error("SignalR: Invalid transport(s) specified, aborting start.");
	            }
	
	            connection._.config = config;
	
	            // Check to see if start is being called prior to page load
	            // If waitForPageLoad is true we then want to re-direct function call to the window load event
	            if (!_pageLoaded && config.waitForPageLoad === true) {
	                connection._.deferredStartHandler = function () {
	                    connection.start(options, callback);
	                };
	                _pageWindow.bind("load", connection._.deferredStartHandler);
	
	                return deferred.promise();
	            }
	
	            // If we're already connecting just return the same deferral as the original connection start
	            if (connection.state === signalR.connectionState.connecting) {
	                return deferred.promise();
	            } else if (changeState(connection,
	                            signalR.connectionState.disconnected,
	                            signalR.connectionState.connecting) === false) {
	                // We're not connecting so try and transition into connecting.
	                // If we fail to transition then we're either in connected or reconnecting.
	
	                deferred.resolve(connection);
	                return deferred.promise();
	            }
	
	            configureStopReconnectingTimeout(connection);
	
	            // Resolve the full url
	            parser.href = connection.url;
	            if (!parser.protocol || parser.protocol === ":") {
	                connection.protocol = window.document.location.protocol;
	                connection.host = parser.host || window.document.location.host;
	            } else {
	                connection.protocol = parser.protocol;
	                connection.host = parser.host;
	            }
	
	            connection.baseUrl = connection.protocol + "//" + connection.host;
	
	            // Set the websocket protocol
	            connection.wsProtocol = connection.protocol === "https:" ? "wss://" : "ws://";
	
	            // If jsonp with no/auto transport is specified, then set the transport to long polling
	            // since that is the only transport for which jsonp really makes sense.
	            // Some developers might actually choose to specify jsonp for same origin requests
	            // as demonstrated by Issue #623.
	            if (config.transport === "auto" && config.jsonp === true) {
	                config.transport = "longPolling";
	            }
	
	            // If the url is protocol relative, prepend the current windows protocol to the url. 
	            if (connection.url.indexOf("//") === 0) {
	                connection.url = window.location.protocol + connection.url;
	                connection.log("Protocol relative URL detected, normalizing it to '" + connection.url + "'.");
	            }
	
	            if (this.isCrossDomain(connection.url)) {
	                connection.log("Auto detected cross domain url.");
	
	                if (config.transport === "auto") {
	                    // TODO: Support XDM with foreverFrame
	                    config.transport = ["webSockets", "serverSentEvents", "longPolling"];
	                }
	
	                if (typeof (config.withCredentials) === "undefined") {
	                    config.withCredentials = true;
	                }
	
	                // Determine if jsonp is the only choice for negotiation, ajaxSend and ajaxAbort.
	                // i.e. if the browser doesn't supports CORS
	                // If it is, ignore any preference to the contrary, and switch to jsonp.
	                if (!config.jsonp) {
	                    config.jsonp = !$.support.cors;
	
	                    if (config.jsonp) {
	                        connection.log("Using jsonp because this browser doesn't support CORS.");
	                    }
	                }
	
	                connection.contentType = signalR._.defaultContentType;
	            }
	
	            connection.withCredentials = config.withCredentials;
	
	            connection.ajaxDataType = config.jsonp ? "jsonp" : "text";
	
	            $(connection).bind(events.onStart, function (e, data) {
	                if ($.type(callback) === "function") {
	                    callback.call(connection);
	                }
	                deferred.resolve(connection);
	            });
	
	            initialize = function (transports, index) {
	                var noTransportError = signalR._.error(resources.noTransportOnInit);
	
	                index = index || 0;
	                if (index >= transports.length) {
	                    // No transport initialized successfully
	                    $(connection).triggerHandler(events.onError, [noTransportError]);
	                    deferred.reject(noTransportError);
	                    // Stop the connection if it has connected and move it into the disconnected state
	                    connection.stop();
	                    return;
	                }
	
	                // The connection was aborted
	                if (connection.state === signalR.connectionState.disconnected) {
	                    return;
	                }
	
	                var transportName = transports[index],
	                    transport = signalR.transports[transportName],
	                    initializationComplete = false,
	                    onFailed = function () {
	                        // Check if we've already triggered onFailed, onStart
	                        if (!initializationComplete) {
	                            initializationComplete = true;
	                            window.clearTimeout(connection._.onFailedTimeoutHandle);
	                            transport.stop(connection);
	                            initialize(transports, index + 1);
	                        }
	                    };
	
	                connection.transport = transport;
	
	                try {
	                    connection._.onFailedTimeoutHandle = window.setTimeout(function () {
	                        connection.log(transport.name + " timed out when trying to connect.");
	                        onFailed();
	                    }, connection._.totalTransportConnectTimeout);
	
	                    transport.start(connection, function () { // success
	                        var onStartSuccess = function () {
	                                // Firefox 11+ doesn't allow sync XHR withCredentials: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#withCredentials
	                                var isFirefox11OrGreater = signalR._.firefoxMajorVersion(window.navigator.userAgent) >= 11,
	                                    asyncAbort = !!connection.withCredentials && isFirefox11OrGreater;
	
	                                connection.log("The start request succeeded. Transitioning to the connected state.");
	
	                                if (supportsKeepAlive(connection)) {
	                                    signalR.transports._logic.monitorKeepAlive(connection);
	                                }
	
	                                signalR.transports._logic.startHeartbeat(connection);
	
	                                // Used to ensure low activity clients maintain their authentication.
	                                // Must be configured once a transport has been decided to perform valid ping requests.
	                                signalR._.configurePingInterval(connection);
	
	                                if (!changeState(connection,
	                                                 signalR.connectionState.connecting,
	                                                 signalR.connectionState.connected)) {
	                                    connection.log("WARNING! The connection was not in the connecting state.");
	                                }
	
	                                // Drain any incoming buffered messages (messages that came in prior to connect)
	                                connection._.connectingMessageBuffer.drain();
	
	                                $(connection).triggerHandler(events.onStart);
	
	                                // wire the stop handler for when the user leaves the page
	                                _pageWindow.bind("unload", function () {
	                                    connection.log("Window unloading, stopping the connection.");
	
	                                    connection.stop(asyncAbort);
	                                });
	
	                                if (isFirefox11OrGreater) {
	                                    // Firefox does not fire cross-domain XHRs in the normal unload handler on tab close.
	                                    // #2400
	                                    _pageWindow.bind("beforeunload", function () {
	                                        // If connection.stop() runs runs in beforeunload and fails, it will also fail
	                                        // in unload unless connection.stop() runs after a timeout.
	                                        window.setTimeout(function () {
	                                            connection.stop(asyncAbort);
	                                        }, 0);
	                                    });
	                                }
	                            };
	
	                        if (!initializationComplete) {
	                            initializationComplete = true;
	                            // Prevent transport fallback
	                            window.clearTimeout(connection._.onFailedTimeoutHandle);
	
	                            // The connection was aborted while initializing transports
	                            if (connection.state === signalR.connectionState.disconnected) {
	                                return;
	                            }
	
	                            connection.log(transport.name + " transport selected. Initiating start request.");
	                            signalR.transports._logic.ajaxStart(connection, onStartSuccess);
	                        }
	                    }, onFailed);
	                }
	                catch (error) {
	                    connection.log(transport.name + " transport threw '" + error.message + "' when attempting to start.");
	                    onFailed();
	                }
	            };
	
	            var url = connection.url + "/negotiate",
	                onFailed = function (error, connection) {
	                    var err = signalR._.error(resources.errorOnNegotiate, error, connection._.negotiateRequest);
	
	                    $(connection).triggerHandler(events.onError, err);
	                    deferred.reject(err);
	                    // Stop the connection if negotiate failed
	                    connection.stop();
	                };
	
	            $(connection).triggerHandler(events.onStarting);
	
	            url = signalR.transports._logic.prepareQueryString(connection, url);
	
	            connection.log("Negotiating with '" + url + "'.");
	
	            // Save the ajax negotiate request object so we can abort it if stop is called while the request is in flight.
	            connection._.negotiateRequest = signalR.transports._logic.ajax(connection, {
	                url: url,
	                error: function (error, statusText) {
	                    // We don't want to cause any errors if we're aborting our own negotiate request.
	                    if (statusText !== _negotiateAbortText) {
	                        onFailed(error, connection);
	                    } else {
	                        // This rejection will noop if the deferred has already been resolved or rejected.
	                        deferred.reject(signalR._.error(resources.stoppedWhileNegotiating, null /* error */, connection._.negotiateRequest));
	                    }
	                },
	                success: function (result) {
	                    var res,
	                        keepAliveData,
	                        protocolError,
	                        transports = [],
	                        supportedTransports = [];
	
	                    try {
	                        res = connection._parseResponse(result);
	                    } catch (error) {
	                        onFailed(signalR._.error(resources.errorParsingNegotiateResponse, error), connection);
	                        return;
	                    }
	
	                    keepAliveData = connection._.keepAliveData;
	                    connection.appRelativeUrl = res.Url;
	                    connection.id = res.ConnectionId;
	                    connection.token = res.ConnectionToken;
	                    connection.webSocketServerUrl = res.WebSocketServerUrl;
	                    connection._.longPollDelay = res.LongPollDelay * 1000; // in ms
	
	                    // Once the server has labeled the PersistentConnection as Disconnected, we should stop attempting to reconnect
	                    // after res.DisconnectTimeout seconds.
	                    connection.disconnectTimeout = res.DisconnectTimeout * 1000; // in ms
	
	                    // Add the TransportConnectTimeout from the response to the transportConnectTimeout from the client to calculate the total timeout
	                    connection._.totalTransportConnectTimeout = connection.transportConnectTimeout + res.TransportConnectTimeout * 1000;
	
	                    // If we have a keep alive
	                    if (res.KeepAliveTimeout) {
	                        // Register the keep alive data as activated
	                        keepAliveData.activated = true;
	
	                        // Timeout to designate when to force the connection into reconnecting converted to milliseconds
	                        keepAliveData.timeout = res.KeepAliveTimeout * 1000;
	
	                        // Timeout to designate when to warn the developer that the connection may be dead or is not responding.
	                        keepAliveData.timeoutWarning = keepAliveData.timeout * connection.keepAliveWarnAt;
	
	                        // Instantiate the frequency in which we check the keep alive.  It must be short in order to not miss/pick up any changes
	                        connection._.beatInterval = (keepAliveData.timeout - keepAliveData.timeoutWarning) / 3;
	                    } else {
	                        keepAliveData.activated = false;
	                    }
	
	                    connection.reconnectWindow = connection.disconnectTimeout + (keepAliveData.timeout || 0);
	
	                    if (!res.ProtocolVersion || res.ProtocolVersion !== connection.clientProtocol) {
	                        protocolError = signalR._.error(signalR._.format(resources.protocolIncompatible, connection.clientProtocol, res.ProtocolVersion));
	                        $(connection).triggerHandler(events.onError, [protocolError]);
	                        deferred.reject(protocolError);
	
	                        return;
	                    }
	
	                    $.each(signalR.transports, function (key) {
	                        if ((key.indexOf("_") === 0) || (key === "webSockets" && !res.TryWebSockets)) {
	                            return true;
	                        }
	                        supportedTransports.push(key);
	                    });
	
	                    if ($.isArray(config.transport)) {
	                        $.each(config.transport, function (_, transport) {
	                            if ($.inArray(transport, supportedTransports) >= 0) {
	                                transports.push(transport);
	                            }
	                        });
	                    } else if (config.transport === "auto") {
	                        transports = supportedTransports;
	                    } else if ($.inArray(config.transport, supportedTransports) >= 0) {
	                        transports.push(config.transport);
	                    }
	
	                    initialize(transports);
	                }
	            });
	
	            return deferred.promise();
	        },
	
	        starting: function (callback) {
	            /// <summary>Adds a callback that will be invoked before anything is sent over the connection</summary>
	            /// <param name="callback" type="Function">A callback function to execute before the connection is fully instantiated.</param>
	            /// <returns type="signalR" />
	            var connection = this;
	            $(connection).bind(events.onStarting, function (e, data) {
	                callback.call(connection);
	            });
	            return connection;
	        },
	
	        send: function (data) {
	            /// <summary>Sends data over the connection</summary>
	            /// <param name="data" type="String">The data to send over the connection</param>
	            /// <returns type="signalR" />
	            var connection = this;
	
	            if (connection.state === signalR.connectionState.disconnected) {
	                // Connection hasn't been started yet
	                throw new Error("SignalR: Connection must be started before data can be sent. Call .start() before .send()");
	            }
	
	            if (connection.state === signalR.connectionState.connecting) {
	                // Connection hasn't been started yet
	                throw new Error("SignalR: Connection has not been fully initialized. Use .start().done() or .start().fail() to run logic after the connection has started.");
	            }
	
	            connection.transport.send(connection, data);
	            // REVIEW: Should we return deferred here?
	            return connection;
	        },
	
	        received: function (callback) {
	            /// <summary>Adds a callback that will be invoked after anything is received over the connection</summary>
	            /// <param name="callback" type="Function">A callback function to execute when any data is received on the connection</param>
	            /// <returns type="signalR" />
	            var connection = this;
	            $(connection).bind(events.onReceived, function (e, data) {
	                callback.call(connection, data);
	            });
	            return connection;
	        },
	
	        stateChanged: function (callback) {
	            /// <summary>Adds a callback that will be invoked when the connection state changes</summary>
	            /// <param name="callback" type="Function">A callback function to execute when the connection state changes</param>
	            /// <returns type="signalR" />
	            var connection = this;
	            $(connection).bind(events.onStateChanged, function (e, data) {
	                callback.call(connection, data);
	            });
	            return connection;
	        },
	
	        error: function (callback) {
	            /// <summary>Adds a callback that will be invoked after an error occurs with the connection</summary>
	            /// <param name="callback" type="Function">A callback function to execute when an error occurs on the connection</param>
	            /// <returns type="signalR" />
	            var connection = this;
	            $(connection).bind(events.onError, function (e, errorData, sendData) {
	                connection.lastError = errorData;
	                // In practice 'errorData' is the SignalR built error object.
	                // In practice 'sendData' is undefined for all error events except those triggered by
	                // 'ajaxSend' and 'webSockets.send'.'sendData' is the original send payload.
	                callback.call(connection, errorData, sendData);
	            });
	            return connection;
	        },
	
	        disconnected: function (callback) {
	            /// <summary>Adds a callback that will be invoked when the client disconnects</summary>
	            /// <param name="callback" type="Function">A callback function to execute when the connection is broken</param>
	            /// <returns type="signalR" />
	            var connection = this;
	            $(connection).bind(events.onDisconnect, function (e, data) {
	                callback.call(connection);
	            });
	            return connection;
	        },
	
	        connectionSlow: function (callback) {
	            /// <summary>Adds a callback that will be invoked when the client detects a slow connection</summary>
	            /// <param name="callback" type="Function">A callback function to execute when the connection is slow</param>
	            /// <returns type="signalR" />
	            var connection = this;
	            $(connection).bind(events.onConnectionSlow, function (e, data) {
	                callback.call(connection);
	            });
	
	            return connection;
	        },
	
	        reconnecting: function (callback) {
	            /// <summary>Adds a callback that will be invoked when the underlying transport begins reconnecting</summary>
	            /// <param name="callback" type="Function">A callback function to execute when the connection enters a reconnecting state</param>
	            /// <returns type="signalR" />
	            var connection = this;
	            $(connection).bind(events.onReconnecting, function (e, data) {
	                callback.call(connection);
	            });
	            return connection;
	        },
	
	        reconnected: function (callback) {
	            /// <summary>Adds a callback that will be invoked when the underlying transport reconnects</summary>
	            /// <param name="callback" type="Function">A callback function to execute when the connection is restored</param>
	            /// <returns type="signalR" />
	            var connection = this;
	            $(connection).bind(events.onReconnect, function (e, data) {
	                callback.call(connection);
	            });
	            return connection;
	        },
	
	        stop: function (async, notifyServer) {
	            /// <summary>Stops listening</summary>
	            /// <param name="async" type="Boolean">Whether or not to asynchronously abort the connection</param>
	            /// <param name="notifyServer" type="Boolean">Whether we want to notify the server that we are aborting the connection</param>
	            /// <returns type="signalR" />
	            var connection = this,
	                // Save deferral because this is always cleaned up
	                deferral = connection._deferral;
	
	            // Verify that we've bound a load event.
	            if (connection._.deferredStartHandler) {
	                // Unbind the event.
	                _pageWindow.unbind("load", connection._.deferredStartHandler);
	            }
	
	            // Always clean up private non-timeout based state.
	            delete connection._.config;
	            delete connection._.deferredStartHandler;
	
	            // This needs to be checked despite the connection state because a connection start can be deferred until page load.
	            // If we've deferred the start due to a page load we need to unbind the "onLoad" -> start event.
	            if (!_pageLoaded && (!connection._.config || connection._.config.waitForPageLoad === true)) {
	                connection.log("Stopping connection prior to negotiate.");
	
	                // If we have a deferral we should reject it
	                if (deferral) {
	                    deferral.reject(signalR._.error(resources.stoppedWhileLoading));
	                }
	
	                // Short-circuit because the start has not been fully started.
	                return;
	            }
	
	            if (connection.state === signalR.connectionState.disconnected) {
	                return;
	            }
	
	            connection.log("Stopping connection.");
	
	            changeState(connection, connection.state, signalR.connectionState.disconnected);
	
	            // Clear this no matter what
	            window.clearTimeout(connection._.beatHandle);
	            window.clearTimeout(connection._.onFailedTimeoutHandle);
	            window.clearInterval(connection._.pingIntervalId);
	
	            if (connection.transport) {
	                connection.transport.stop(connection);
	
	                if (notifyServer !== false) {
	                    connection.transport.abort(connection, async);
	                }
	
	                if (supportsKeepAlive(connection)) {
	                    signalR.transports._logic.stopMonitoringKeepAlive(connection);
	                }
	
	                connection.transport = null;
	            }
	
	            if (connection._.negotiateRequest) {
	                // If the negotiation request has already completed this will noop.
	                connection._.negotiateRequest.abort(_negotiateAbortText);
	                delete connection._.negotiateRequest;
	            }
	
	            // Ensure that tryAbortStartRequest is called before connection._deferral is deleted
	            signalR.transports._logic.tryAbortStartRequest(connection);
	
	            // Trigger the disconnect event
	            $(connection).triggerHandler(events.onDisconnect);
	
	            delete connection._deferral;
	            delete connection.messageId;
	            delete connection.groupsToken;
	            delete connection.id;
	            delete connection._.pingIntervalId;
	            delete connection._.lastMessageAt;
	            delete connection._.lastActiveAt;
	            delete connection._.longPollDelay;
	
	            // Clear out our message buffer
	            connection._.connectingMessageBuffer.clear();
	
	            return connection;
	        },
	
	        log: function (msg) {
	            log(msg, this.logging);
	        }
	    };
	
	    signalR.fn.init.prototype = signalR.fn;
	
	    signalR.noConflict = function () {
	        /// <summary>Reinstates the original value of $.connection and returns the signalR object for manual assignment</summary>
	        /// <returns type="signalR" />
	        if ($.connection === signalR) {
	            $.connection = _connection;
	        }
	        return signalR;
	    };
	
	    if ($.connection) {
	        _connection = $.connection;
	    }
	
	    $.connection = $.signalR = signalR;
	
	}(window.jQuery, window));
	/* jquery.signalR.transports.common.js */
	// Copyright (c) Microsoft Open Technologies, Inc. All rights reserved. See License.md in the project root for license information.
	
	/*global window:false */
	/// <reference path="jquery.signalR.core.js" />
	
	(function ($, window, undefined) {
	
	    var signalR = $.signalR,
	        events = $.signalR.events,
	        changeState = $.signalR.changeState,
	        startAbortText = "__Start Aborted__",
	        transportLogic;
	
	    signalR.transports = {};
	
	    function beat(connection) {
	        if (connection._.keepAliveData.monitoring) {
	            checkIfAlive(connection);
	        }
	
	        // Ensure that we successfully marked active before continuing the heartbeat.
	        if (transportLogic.markActive(connection)) {
	            connection._.beatHandle = window.setTimeout(function () {
	                beat(connection);
	            }, connection._.beatInterval);
	        }
	    }
	
	    function checkIfAlive(connection) {
	        var keepAliveData = connection._.keepAliveData,
	            timeElapsed;
	
	        // Only check if we're connected
	        if (connection.state === signalR.connectionState.connected) {
	            timeElapsed = new Date().getTime() - connection._.lastMessageAt;
	
	            // Check if the keep alive has completely timed out
	            if (timeElapsed >= keepAliveData.timeout) {
	                connection.log("Keep alive timed out.  Notifying transport that connection has been lost.");
	
	                // Notify transport that the connection has been lost
	                connection.transport.lostConnection(connection);
	            } else if (timeElapsed >= keepAliveData.timeoutWarning) {
	                // This is to assure that the user only gets a single warning
	                if (!keepAliveData.userNotified) {
	                    connection.log("Keep alive has been missed, connection may be dead/slow.");
	                    $(connection).triggerHandler(events.onConnectionSlow);
	                    keepAliveData.userNotified = true;
	                }
	            } else {
	                keepAliveData.userNotified = false;
	            }
	        }
	    }
	
	    function getAjaxUrl(connection, path) {
	        var url = connection.url + path;
	
	        if (connection.transport) {
	            url += "?transport=" + connection.transport.name;
	        }
	
	        return transportLogic.prepareQueryString(connection, url);
	    }
	
	    transportLogic = signalR.transports._logic = {
	        ajax: function (connection, options) {
	            return $.ajax(
	                $.extend(/*deep copy*/ true, {}, $.signalR.ajaxDefaults, {
	                    type: "GET",
	                    data: {},
	                    xhrFields: { withCredentials: connection.withCredentials },
	                    contentType: connection.contentType,
	                    dataType: connection.ajaxDataType
	                }, options));
	        },
	
	        pingServer: function (connection) {
	            /// <summary>Pings the server</summary>
	            /// <param name="connection" type="signalr">Connection associated with the server ping</param>
	            /// <returns type="signalR" />
	            var url,
	                xhr,
	                deferral = $.Deferred();
	
	            if (connection.transport) {
	                url = connection.url + "/ping";
	
	                url = transportLogic.addQs(url, connection.qs);
	
	                xhr = transportLogic.ajax(connection, {
	                    url: url,
	                    success: function (result) {
	                        var data;
	
	                        try {
	                            data = connection._parseResponse(result);
	                        }
	                        catch (error) {
	                            deferral.reject(
	                                signalR._.transportError(
	                                    signalR.resources.pingServerFailedParse,
	                                    connection.transport,
	                                    error,
	                                    xhr
	                                )
	                            );
	                            connection.stop();
	                            return;
	                        }
	
	                        if (data.Response === "pong") {
	                            deferral.resolve();
	                        }
	                        else {
	                            deferral.reject(
	                                signalR._.transportError(
	                                    signalR._.format(signalR.resources.pingServerFailedInvalidResponse, result),
	                                    connection.transport,
	                                    null /* error */,
	                                    xhr
	                                )
	                            );
	                        }
	                    },
	                    error: function (error) {
	                        if (error.status === 401 || error.status === 403) {
	                            deferral.reject(
	                                signalR._.transportError(
	                                    signalR._.format(signalR.resources.pingServerFailedStatusCode, error.status),
	                                    connection.transport,
	                                    error,
	                                    xhr
	                                )
	                            );
	                            connection.stop();
	                        }
	                        else {
	                            deferral.reject(
	                                signalR._.transportError(
	                                    signalR.resources.pingServerFailed,
	                                    connection.transport,
	                                    error,
	                                    xhr
	                                )
	                            );
	                        }
	                    }
	                });
	            }
	            else {
	                deferral.reject(
	                    signalR._.transportError(
	                        signalR.resources.noConnectionTransport,
	                        connection.transport
	                    )
	                );
	            }
	
	            return deferral.promise();
	        },
	
	        prepareQueryString: function (connection, url) {
	            var preparedUrl;
	
	            // Use addQs to start since it handles the ?/& prefix for us
	            preparedUrl = transportLogic.addQs(url, "clientProtocol=" + connection.clientProtocol);
	
	            // Add the user-specified query string params if any
	            preparedUrl = transportLogic.addQs(preparedUrl, connection.qs);
	
	            if (connection.token) {
	                preparedUrl += "&connectionToken=" + window.encodeURIComponent(connection.token);
	            }
	
	            if (connection.data) {
	                preparedUrl += "&connectionData=" + window.encodeURIComponent(connection.data);
	            }
	
	            return preparedUrl;
	        },
	
	        addQs: function (url, qs) {
	            var appender = url.indexOf("?") !== -1 ? "&" : "?",
	                firstChar;
	
	            if (!qs) {
	                return url;
	            }
	
	            if (typeof (qs) === "object") {
	                return url + appender + $.param(qs);
	            }
	
	            if (typeof (qs) === "string") {
	                firstChar = qs.charAt(0);
	
	                if (firstChar === "?" || firstChar === "&") {
	                    appender = "";
	                }
	
	                return url + appender + qs;
	            }
	
	            throw new Error("Query string property must be either a string or object.");
	        },
	
	        getUrl: function (connection, transport, reconnecting, poll) {
	            /// <summary>Gets the url for making a GET based connect request</summary>
	            var baseUrl = transport === "webSockets" ? "" : connection.baseUrl,
	                url = baseUrl + connection.appRelativeUrl,
	                qs = "transport=" + transport;
	
	            if (connection.groupsToken) {
	                qs += "&groupsToken=" + window.encodeURIComponent(connection.groupsToken);
	            }
	
	            if (!reconnecting) {
	                url += "/connect";
	            } else {
	                if (poll) {
	                    // longPolling transport specific
	                    url += "/poll";
	                } else {
	                    url += "/reconnect";
	                }
	
	                if (connection.messageId) {
	                    qs += "&messageId=" + window.encodeURIComponent(connection.messageId);
	                }
	            }
	            url += "?" + qs;
	            url = transportLogic.prepareQueryString(connection, url);
	            url += "&tid=" + Math.floor(Math.random() * 11);
	            return url;
	        },
	
	        maximizePersistentResponse: function (minPersistentResponse) {
	            return {
	                MessageId: minPersistentResponse.C,
	                Messages: minPersistentResponse.M,
	                Initialized: typeof (minPersistentResponse.S) !== "undefined" ? true : false,
	                Disconnect: typeof (minPersistentResponse.D) !== "undefined" ? true : false,
	                ShouldReconnect: typeof (minPersistentResponse.T) !== "undefined" ? true : false,
	                LongPollDelay: minPersistentResponse.L,
	                GroupsToken: minPersistentResponse.G
	            };
	        },
	
	        updateGroups: function (connection, groupsToken) {
	            if (groupsToken) {
	                connection.groupsToken = groupsToken;
	            }
	        },
	
	        stringifySend: function (connection, message) {
	            if (typeof (message) === "string" || typeof (message) === "undefined" || message === null) {
	                return message;
	            }
	            return connection.json.stringify(message);
	        },
	
	        ajaxSend: function (connection, data) {
	            var payload = transportLogic.stringifySend(connection, data),
	                url = getAjaxUrl(connection, "/send"),
	                xhr,
	                onFail = function (error, connection) {
	                    $(connection).triggerHandler(events.onError, [signalR._.transportError(signalR.resources.sendFailed, connection.transport, error, xhr), data]);
	                };
	
	
	            xhr = transportLogic.ajax(connection, {
	                url: url,
	                type: connection.ajaxDataType === "jsonp" ? "GET" : "POST",
	                contentType: signalR._.defaultContentType,
	                data: {
	                    data: payload
	                },
	                success: function (result) {
	                    var res;
	
	                    if (result) {
	                        try {
	                            res = connection._parseResponse(result);
	                        }
	                        catch (error) {
	                            onFail(error, connection);
	                            connection.stop();
	                            return;
	                        }
	
	                        transportLogic.triggerReceived(connection, res);
	                    }
	                },
	                error: function (error, textStatus) {
	                    if (textStatus === "abort" || textStatus === "parsererror") {
	                        // The parsererror happens for sends that don't return any data, and hence
	                        // don't write the jsonp callback to the response. This is harder to fix on the server
	                        // so just hack around it on the client for now.
	                        return;
	                    }
	
	                    onFail(error, connection);
	                }
	            });
	
	            return xhr;
	        },
	
	        ajaxAbort: function (connection, async) {
	            if (typeof (connection.transport) === "undefined") {
	                return;
	            }
	
	            // Async by default unless explicitly overidden
	            async = typeof async === "undefined" ? true : async;
	
	            var url = getAjaxUrl(connection, "/abort");
	
	            transportLogic.ajax(connection, {
	                url: url,
	                async: async,
	                timeout: 1000,
	                type: "POST"
	            });
	
	            connection.log("Fired ajax abort async = " + async + ".");
	        },
	
	        ajaxStart: function (connection, onSuccess) {
	            var rejectDeferred = function (error) {
	                    var deferred = connection._deferral;
	                    if (deferred) {
	                        deferred.reject(error);
	                    }
	                },
	                triggerStartError = function (error) {
	                    connection.log("The start request failed. Stopping the connection.");
	                    $(connection).triggerHandler(events.onError, [error]);
	                    rejectDeferred(error);
	                    connection.stop();
	                };
	
	            connection._.startRequest = transportLogic.ajax(connection, {
	                url: getAjaxUrl(connection, "/start"),
	                success: function (result, statusText, xhr) {
	                    var data;
	
	                    try {
	                        data = connection._parseResponse(result);
	                    } catch (error) {
	                        triggerStartError(signalR._.error(
	                            signalR._.format(signalR.resources.errorParsingStartResponse, result),
	                            error, xhr));
	                        return;
	                    }
	
	                    if (data.Response === "started") {
	                        onSuccess();
	                    } else {
	                        triggerStartError(signalR._.error(
	                            signalR._.format(signalR.resources.invalidStartResponse, result),
	                            null /* error */, xhr));
	                    }
	                },
	                error: function (xhr, statusText, error) {
	                    if (statusText !== startAbortText) {
	                        triggerStartError(signalR._.error(
	                            signalR.resources.errorDuringStartRequest,
	                            error, xhr));
	                    } else {
	                        // Stop has been called, no need to trigger the error handler
	                        // or stop the connection again with onStartError
	                        connection.log("The start request aborted because connection.stop() was called.");
	                        rejectDeferred(signalR._.error(
	                            signalR.resources.stoppedDuringStartRequest,
	                            null /* error */, xhr));
	                    }
	                }
	            });
	        },
	
	        tryAbortStartRequest: function (connection) {
	            if (connection._.startRequest) {
	                // If the start request has already completed this will noop.
	                connection._.startRequest.abort(startAbortText);
	                delete connection._.startRequest;
	            }
	        },
	
	        tryInitialize: function (persistentResponse, onInitialized) {
	            if (persistentResponse.Initialized) {
	                onInitialized();
	            }
	        },
	
	        triggerReceived: function (connection, data) {
	            if (!connection._.connectingMessageBuffer.tryBuffer(data)) {
	                $(connection).triggerHandler(events.onReceived, [data]);
	            }
	        },
	
	        processMessages: function (connection, minData, onInitialized) {
	            var data;
	
	            // Update the last message time stamp
	            transportLogic.markLastMessage(connection);
	
	            if (minData) {
	                data = transportLogic.maximizePersistentResponse(minData);
	
	                transportLogic.updateGroups(connection, data.GroupsToken);
	
	                if (data.MessageId) {
	                    connection.messageId = data.MessageId;
	                }
	
	                if (data.Messages) {
	                    $.each(data.Messages, function (index, message) {
	                        transportLogic.triggerReceived(connection, message);
	                    });
	
	                    transportLogic.tryInitialize(data, onInitialized);
	                }
	            }
	        },
	
	        monitorKeepAlive: function (connection) {
	            var keepAliveData = connection._.keepAliveData;
	
	            // If we haven't initiated the keep alive timeouts then we need to
	            if (!keepAliveData.monitoring) {
	                keepAliveData.monitoring = true;
	
	                transportLogic.markLastMessage(connection);
	
	                // Save the function so we can unbind it on stop
	                connection._.keepAliveData.reconnectKeepAliveUpdate = function () {
	                    // Mark a new message so that keep alive doesn't time out connections
	                    transportLogic.markLastMessage(connection);
	                };
	
	                // Update Keep alive on reconnect
	                $(connection).bind(events.onReconnect, connection._.keepAliveData.reconnectKeepAliveUpdate);
	
	                connection.log("Now monitoring keep alive with a warning timeout of " + keepAliveData.timeoutWarning + " and a connection lost timeout of " + keepAliveData.timeout + ".");
	            } else {
	                connection.log("Tried to monitor keep alive but it's already being monitored.");
	            }
	        },
	
	        stopMonitoringKeepAlive: function (connection) {
	            var keepAliveData = connection._.keepAliveData;
	
	            // Only attempt to stop the keep alive monitoring if its being monitored
	            if (keepAliveData.monitoring) {
	                // Stop monitoring
	                keepAliveData.monitoring = false;
	
	                // Remove the updateKeepAlive function from the reconnect event
	                $(connection).unbind(events.onReconnect, connection._.keepAliveData.reconnectKeepAliveUpdate);
	
	                // Clear all the keep alive data
	                connection._.keepAliveData = {};
	                connection.log("Stopping the monitoring of the keep alive.");
	            }
	        },
	
	        startHeartbeat: function (connection) {
	            connection._.lastActiveAt = new Date().getTime();
	            beat(connection);
	        },
	
	        markLastMessage: function (connection) {
	            connection._.lastMessageAt = new Date().getTime();
	        },
	
	        markActive: function (connection) {
	            if (transportLogic.verifyLastActive(connection)) {
	                connection._.lastActiveAt = new Date().getTime();
	                return true;
	            }
	
	            return false;
	        },
	
	        isConnectedOrReconnecting: function (connection) {
	            return connection.state === signalR.connectionState.connected ||
	                   connection.state === signalR.connectionState.reconnecting;
	        },
	
	        ensureReconnectingState: function (connection) {
	            if (changeState(connection,
	                        signalR.connectionState.connected,
	                        signalR.connectionState.reconnecting) === true) {
	                $(connection).triggerHandler(events.onReconnecting);
	            }
	            return connection.state === signalR.connectionState.reconnecting;
	        },
	
	        clearReconnectTimeout: function (connection) {
	            if (connection && connection._.reconnectTimeout) {
	                window.clearTimeout(connection._.reconnectTimeout);
	                delete connection._.reconnectTimeout;
	            }
	        },
	
	        verifyLastActive: function (connection) {
	            if (new Date().getTime() - connection._.lastActiveAt >= connection.reconnectWindow) {
	                var message = signalR._.format(signalR.resources.reconnectWindowTimeout, new Date(connection._.lastActiveAt), connection.reconnectWindow);
	                connection.log(message);
	                $(connection).triggerHandler(events.onError, [signalR._.error(message, /* source */ "TimeoutException")]);
	                connection.stop(/* async */ false, /* notifyServer */ false);
	                return false;
	            }
	
	            return true;
	        },
	
	        reconnect: function (connection, transportName) {
	            var transport = signalR.transports[transportName];
	
	            // We should only set a reconnectTimeout if we are currently connected
	            // and a reconnectTimeout isn't already set.
	            if (transportLogic.isConnectedOrReconnecting(connection) && !connection._.reconnectTimeout) {
	                // Need to verify before the setTimeout occurs because an application sleep could occur during the setTimeout duration.
	                if (!transportLogic.verifyLastActive(connection)) {
	                    return;
	                }
	
	                connection._.reconnectTimeout = window.setTimeout(function () {
	                    if (!transportLogic.verifyLastActive(connection)) {
	                        return;
	                    }
	
	                    transport.stop(connection);
	
	                    if (transportLogic.ensureReconnectingState(connection)) {
	                        connection.log(transportName + " reconnecting.");
	                        transport.start(connection);
	                    }
	                }, connection.reconnectDelay);
	            }
	        },
	
	        handleParseFailure: function (connection, result, error, onFailed, context) {
	            // If we're in the initialization phase trigger onFailed, otherwise stop the connection.
	            if (connection.state === signalR.connectionState.connecting) {
	                connection.log("Failed to parse server response while attempting to connect.");
	                onFailed();
	            } else {
	                $(connection).triggerHandler(events.onError, [
	                    signalR._.transportError(
	                        signalR._.format(signalR.resources.parseFailed, result),
	                        connection.transport,
	                        error,
	                        context)]);
	                connection.stop();
	            }
	        },
	
	        foreverFrame: {
	            count: 0,
	            connections: {}
	        }
	    };
	
	}(window.jQuery, window));
	/* jquery.signalR.transports.webSockets.js */
	// Copyright (c) Microsoft Open Technologies, Inc. All rights reserved. See License.md in the project root for license information.
	
	/*global window:false */
	/// <reference path="jquery.signalR.transports.common.js" />
	
	(function ($, window, undefined) {
	
	    var signalR = $.signalR,
	        events = $.signalR.events,
	        changeState = $.signalR.changeState,
	        transportLogic = signalR.transports._logic;
	
	    signalR.transports.webSockets = {
	        name: "webSockets",
	
	        supportsKeepAlive: function () {
	            return true;
	        },
	
	        send: function (connection, data) {
	            var payload = transportLogic.stringifySend(connection, data);
	
	            try {
	                connection.socket.send(payload);
	            } catch (ex) {
	                $(connection).triggerHandler(events.onError,
	                    [signalR._.transportError(
	                        signalR.resources.webSocketsInvalidState,
	                        connection.transport,
	                        ex,
	                        connection.socket
	                    ),
	                    data]);
	            }
	        },
	
	        start: function (connection, onSuccess, onFailed) {
	            var url,
	                opened = false,
	                that = this,
	                reconnecting = !onSuccess,
	                $connection = $(connection);
	
	            if (!window.WebSocket) {
	                onFailed();
	                return;
	            }
	
	            if (!connection.socket) {
	                if (connection.webSocketServerUrl) {
	                    url = connection.webSocketServerUrl;
	                } else {
	                    url = connection.wsProtocol + connection.host;
	                }
	
	                url += transportLogic.getUrl(connection, this.name, reconnecting);
	
	                connection.log("Connecting to websocket endpoint '" + url + "'.");
	                connection.socket = new window.WebSocket(url);
	
	                connection.socket.onopen = function () {
	                    opened = true;
	                    connection.log("Websocket opened.");
	
	                    transportLogic.clearReconnectTimeout(connection);
	
	                    if (changeState(connection,
	                                    signalR.connectionState.reconnecting,
	                                    signalR.connectionState.connected) === true) {
	                        $connection.triggerHandler(events.onReconnect);
	                    }
	                };
	
	                connection.socket.onclose = function (event) {
	                    // Only handle a socket close if the close is from the current socket.
	                    // Sometimes on disconnect the server will push down an onclose event
	                    // to an expired socket.
	
	                    if (this === connection.socket) {
	                        if (!opened) {
	                            if (onFailed) {
	                                onFailed();
	                            } else if (reconnecting) {
	                                that.reconnect(connection);
	                            }
	                            return;
	                        } else if (typeof event.wasClean !== "undefined" && event.wasClean === false) {
	                            // Ideally this would use the websocket.onerror handler (rather than checking wasClean in onclose) but
	                            // I found in some circumstances Chrome won't call onerror. This implementation seems to work on all browsers.
	                            $(connection).triggerHandler(events.onError, [signalR._.transportError(
	                                signalR.resources.webSocketClosed,
	                                connection.transport,
	                                event)]);
	                            connection.log("Unclean disconnect from websocket: " + event.reason || "[no reason given].");
	                        } else {
	                            connection.log("Websocket closed.");
	                        }
	
	                        that.reconnect(connection);
	                    }
	                };
	
	                connection.socket.onmessage = function (event) {
	                    var data;
	
	                    try {
	                        data = connection._parseResponse(event.data);
	                    }
	                    catch (error) {
	                        transportLogic.handleParseFailure(connection, event.data, error, onFailed, event);
	                        return;
	                    }
	
	                    if (data) {
	                        // data.M is PersistentResponse.Messages
	                        if ($.isEmptyObject(data) || data.M) {
	                            transportLogic.processMessages(connection, data, onSuccess);
	                        } else {
	                            // For websockets we need to trigger onReceived
	                            // for callbacks to outgoing hub calls.
	                            transportLogic.triggerReceived(connection, data);
	                        }
	                    }
	                };
	            }
	        },
	
	        reconnect: function (connection) {
	            transportLogic.reconnect(connection, this.name);
	        },
	
	        lostConnection: function (connection) {
	            this.reconnect(connection);
	        },
	
	        stop: function (connection) {
	            // Don't trigger a reconnect after stopping
	            transportLogic.clearReconnectTimeout(connection);
	
	            if (connection.socket) {
	                connection.log("Closing the Websocket.");
	                connection.socket.close();
	                connection.socket = null;
	            }
	        },
	
	        abort: function (connection, async) {
	            transportLogic.ajaxAbort(connection, async);
	        }
	    };
	
	}(window.jQuery, window));
	/* jquery.signalR.transports.serverSentEvents.js */
	// Copyright (c) Microsoft Open Technologies, Inc. All rights reserved. See License.md in the project root for license information.
	
	/*global window:false */
	/// <reference path="jquery.signalR.transports.common.js" />
	
	(function ($, window, undefined) {
	
	    var signalR = $.signalR,
	        events = $.signalR.events,
	        changeState = $.signalR.changeState,
	        transportLogic = signalR.transports._logic,
	        clearReconnectAttemptTimeout = function (connection) {
	            window.clearTimeout(connection._.reconnectAttemptTimeoutHandle);
	            delete connection._.reconnectAttemptTimeoutHandle;
	        };
	
	    signalR.transports.serverSentEvents = {
	        name: "serverSentEvents",
	
	        supportsKeepAlive: function () {
	            return true;
	        },
	
	        timeOut: 3000,
	
	        start: function (connection, onSuccess, onFailed) {
	            var that = this,
	                opened = false,
	                $connection = $(connection),
	                reconnecting = !onSuccess,
	                url;
	
	            if (connection.eventSource) {
	                connection.log("The connection already has an event source. Stopping it.");
	                connection.stop();
	            }
	
	            if (!window.EventSource) {
	                if (onFailed) {
	                    connection.log("This browser doesn't support SSE.");
	                    onFailed();
	                }
	                return;
	            }
	
	            url = transportLogic.getUrl(connection, this.name, reconnecting);
	
	            try {
	                connection.log("Attempting to connect to SSE endpoint '" + url + "'.");
	                connection.eventSource = new window.EventSource(url, { withCredentials: connection.withCredentials });
	            }
	            catch (e) {
	                connection.log("EventSource failed trying to connect with error " + e.Message + ".");
	                if (onFailed) {
	                    // The connection failed, call the failed callback
	                    onFailed();
	                } else {
	                    $connection.triggerHandler(events.onError, [signalR._.transportError(signalR.resources.eventSourceFailedToConnect, connection.transport, e)]);
	                    if (reconnecting) {
	                        // If we were reconnecting, rather than doing initial connect, then try reconnect again
	                        that.reconnect(connection);
	                    }
	                }
	                return;
	            }
	
	            if (reconnecting) {
	                connection._.reconnectAttemptTimeoutHandle = window.setTimeout(function () {
	                    if (opened === false) {
	                        // If we're reconnecting and the event source is attempting to connect,
	                        // don't keep retrying. This causes duplicate connections to spawn.
	                        if (connection.eventSource.readyState !== window.EventSource.OPEN) {
	                            // If we were reconnecting, rather than doing initial connect, then try reconnect again
	                            that.reconnect(connection);
	                        }
	                    }
	                },
	                that.timeOut);
	            }
	
	            connection.eventSource.addEventListener("open", function (e) {
	                connection.log("EventSource connected.");
	
	                clearReconnectAttemptTimeout(connection);
	                transportLogic.clearReconnectTimeout(connection);
	
	                if (opened === false) {
	                    opened = true;
	
	                    if (changeState(connection,
	                                         signalR.connectionState.reconnecting,
	                                         signalR.connectionState.connected) === true) {
	                        $connection.triggerHandler(events.onReconnect);
	                    }
	                }
	            }, false);
	
	            connection.eventSource.addEventListener("message", function (e) {
	                var res;
	
	                // process messages
	                if (e.data === "initialized") {
	                    return;
	                }
	
	                try {
	                    res = connection._parseResponse(e.data);
	                }
	                catch (error) {
	                    transportLogic.handleParseFailure(connection, e.data, error, onFailed, e);
	                    return;
	                }
	
	                transportLogic.processMessages(connection, res, onSuccess);
	            }, false);
	
	            connection.eventSource.addEventListener("error", function (e) {
	                // Only handle an error if the error is from the current Event Source.
	                // Sometimes on disconnect the server will push down an error event
	                // to an expired Event Source.
	                if (this !== connection.eventSource) {
	                    return;
	                }
	
	                if (!opened) {
	                    if (onFailed) {
	                        onFailed();
	                    }
	
	                    return;
	                }
	
	                connection.log("EventSource readyState: " + connection.eventSource.readyState + ".");
	
	                if (e.eventPhase === window.EventSource.CLOSED) {
	                    // We don't use the EventSource's native reconnect function as it
	                    // doesn't allow us to change the URL when reconnecting. We need
	                    // to change the URL to not include the /connect suffix, and pass
	                    // the last message id we received.
	                    connection.log("EventSource reconnecting due to the server connection ending.");
	                    that.reconnect(connection);
	                } else {
	                    // connection error
	                    connection.log("EventSource error.");
	                    $connection.triggerHandler(events.onError, [signalR._.transportError(signalR.resources.eventSourceError, connection.transport, e)]);
	                }
	            }, false);
	        },
	
	        reconnect: function (connection) {
	            transportLogic.reconnect(connection, this.name);
	        },
	
	        lostConnection: function (connection) {
	            this.reconnect(connection);
	        },
	
	        send: function (connection, data) {
	            transportLogic.ajaxSend(connection, data);
	        },
	
	        stop: function (connection) {
	            // Don't trigger a reconnect after stopping
	            clearReconnectAttemptTimeout(connection);
	            transportLogic.clearReconnectTimeout(connection);
	
	            if (connection && connection.eventSource) {
	                connection.log("EventSource calling close().");
	                connection.eventSource.close();
	                connection.eventSource = null;
	                delete connection.eventSource;
	            }
	        },
	
	        abort: function (connection, async) {
	            transportLogic.ajaxAbort(connection, async);
	        }
	    };
	
	}(window.jQuery, window));
	/* jquery.signalR.transports.foreverFrame.js */
	// Copyright (c) Microsoft Open Technologies, Inc. All rights reserved. See License.md in the project root for license information.
	
	/*global window:false */
	/// <reference path="jquery.signalR.transports.common.js" />
	
	(function ($, window, undefined) {
	
	    var signalR = $.signalR,
	        events = $.signalR.events,
	        changeState = $.signalR.changeState,
	        transportLogic = signalR.transports._logic,
	        createFrame = function () {
	            var frame = window.document.createElement("iframe");
	            frame.setAttribute("style", "position:absolute;top:0;left:0;width:0;height:0;visibility:hidden;");
	            return frame;
	        },
	        // Used to prevent infinite loading icon spins in older versions of ie
	        // We build this object inside a closure so we don't pollute the rest of   
	        // the foreverFrame transport with unnecessary functions/utilities.
	        loadPreventer = (function () {
	            var loadingFixIntervalId = null,
	                loadingFixInterval = 1000,
	                attachedTo = 0;
	
	            return {
	                prevent: function () {
	                    // Prevent additional iframe removal procedures from newer browsers
	                    if (signalR._.ieVersion <= 8) {
	                        // We only ever want to set the interval one time, so on the first attachedTo
	                        if (attachedTo === 0) {
	                            // Create and destroy iframe every 3 seconds to prevent loading icon, super hacky
	                            loadingFixIntervalId = window.setInterval(function () {
	                                var tempFrame = createFrame();
	
	                                window.document.body.appendChild(tempFrame);
	                                window.document.body.removeChild(tempFrame);
	
	                                tempFrame = null;
	                            }, loadingFixInterval);
	                        }
	
	                        attachedTo++;
	                    }
	                },
	                cancel: function () {
	                    // Only clear the interval if there's only one more object that the loadPreventer is attachedTo
	                    if (attachedTo === 1) {
	                        window.clearInterval(loadingFixIntervalId);
	                    }
	
	                    if (attachedTo > 0) {
	                        attachedTo--;
	                    }
	                }
	            };
	        })();
	
	    signalR.transports.foreverFrame = {
	        name: "foreverFrame",
	
	        supportsKeepAlive: function () {
	            return true;
	        },
	
	        // Added as a value here so we can create tests to verify functionality
	        iframeClearThreshold: 50,
	
	        start: function (connection, onSuccess, onFailed) {
	            var that = this,
	                frameId = (transportLogic.foreverFrame.count += 1),
	                url,
	                frame = createFrame(),
	                frameLoadHandler = function () {
	                    connection.log("Forever frame iframe finished loading and is no longer receiving messages.");
	                    that.reconnect(connection);
	                };
	
	            if (window.EventSource) {
	                // If the browser supports SSE, don't use Forever Frame
	                if (onFailed) {
	                    connection.log("This browser supports SSE, skipping Forever Frame.");
	                    onFailed();
	                }
	                return;
	            }
	
	            frame.setAttribute("data-signalr-connection-id", connection.id);
	
	            // Start preventing loading icon
	            // This will only perform work if the loadPreventer is not attached to another connection.
	            loadPreventer.prevent();
	
	            // Build the url
	            url = transportLogic.getUrl(connection, this.name);
	            url += "&frameId=" + frameId;
	
	            // Set body prior to setting URL to avoid caching issues.
	            window.document.body.appendChild(frame);
	
	            connection.log("Binding to iframe's load event.");
	
	            if (frame.addEventListener) {
	                frame.addEventListener("load", frameLoadHandler, false);
	            } else if (frame.attachEvent) {
	                frame.attachEvent("onload", frameLoadHandler);
	            }
	
	            frame.src = url;
	            transportLogic.foreverFrame.connections[frameId] = connection;
	
	            connection.frame = frame;
	            connection.frameId = frameId;
	
	            if (onSuccess) {
	                connection.onSuccess = function () {
	                    connection.log("Iframe transport started.");
	                    onSuccess();
	                };
	            }
	        },
	
	        reconnect: function (connection) {
	            var that = this;
	
	            // Need to verify connection state and verify before the setTimeout occurs because an application sleep could occur during the setTimeout duration.
	            if (transportLogic.isConnectedOrReconnecting(connection) && transportLogic.verifyLastActive(connection)) {
	                window.setTimeout(function () {
	                    // Verify that we're ok to reconnect.
	                    if (!transportLogic.verifyLastActive(connection)) {
	                        return;
	                    }
	
	                    if (connection.frame && transportLogic.ensureReconnectingState(connection)) {
	                        var frame = connection.frame,
	                            src = transportLogic.getUrl(connection, that.name, true) + "&frameId=" + connection.frameId;
	                        connection.log("Updating iframe src to '" + src + "'.");
	                        frame.src = src;
	                    }
	                }, connection.reconnectDelay);
	            }
	        },
	
	        lostConnection: function (connection) {
	            this.reconnect(connection);
	        },
	
	        send: function (connection, data) {
	            transportLogic.ajaxSend(connection, data);
	        },
	
	        receive: function (connection, data) {
	            var cw,
	                body,
	                response;
	
	            if (connection.json !== connection._originalJson) {
	                // If there's a custom JSON parser configured then serialize the object
	                // using the original (browser) JSON parser and then deserialize it using
	                // the custom parser (connection._parseResponse does that). This is so we
	                // can easily send the response from the server as "raw" JSON but still 
	                // support custom JSON deserialization in the browser.
	                data = connection._originalJson.stringify(data);
	            }
	
	            response = connection._parseResponse(data);
	
	            transportLogic.processMessages(connection, response, connection.onSuccess);
	
	            // Protect against connection stopping from a callback trigger within the processMessages above.
	            if (connection.state === $.signalR.connectionState.connected) {
	                // Delete the script & div elements
	                connection.frameMessageCount = (connection.frameMessageCount || 0) + 1;
	                if (connection.frameMessageCount > signalR.transports.foreverFrame.iframeClearThreshold) {
	                    connection.frameMessageCount = 0;
	                    cw = connection.frame.contentWindow || connection.frame.contentDocument;
	                    if (cw && cw.document && cw.document.body) {
	                        body = cw.document.body;
	
	                        // Remove all the child elements from the iframe's body to conserver memory
	                        while (body.firstChild) {
	                            body.removeChild(body.firstChild);
	                        }
	                    }
	                }
	            }
	        },
	
	        stop: function (connection) {
	            var cw = null;
	
	            // Stop attempting to prevent loading icon
	            loadPreventer.cancel();
	
	            if (connection.frame) {
	                if (connection.frame.stop) {
	                    connection.frame.stop();
	                } else {
	                    try {
	                        cw = connection.frame.contentWindow || connection.frame.contentDocument;
	                        if (cw.document && cw.document.execCommand) {
	                            cw.document.execCommand("Stop");
	                        }
	                    }
	                    catch (e) {
	                        connection.log("Error occured when stopping foreverFrame transport. Message = " + e.message + ".");
	                    }
	                }
	
	                // Ensure the iframe is where we left it
	                if (connection.frame.parentNode === window.document.body) {
	                    window.document.body.removeChild(connection.frame);
	                }
	
	                delete transportLogic.foreverFrame.connections[connection.frameId];
	                connection.frame = null;
	                connection.frameId = null;
	                delete connection.frame;
	                delete connection.frameId;
	                delete connection.onSuccess;
	                delete connection.frameMessageCount;
	                connection.log("Stopping forever frame.");
	            }
	        },
	
	        abort: function (connection, async) {
	            transportLogic.ajaxAbort(connection, async);
	        },
	
	        getConnection: function (id) {
	            return transportLogic.foreverFrame.connections[id];
	        },
	
	        started: function (connection) {
	            if (changeState(connection,
	                signalR.connectionState.reconnecting,
	                signalR.connectionState.connected) === true) {
	                // If there's no onSuccess handler we assume this is a reconnect
	                $(connection).triggerHandler(events.onReconnect);
	            }
	        }
	    };
	
	}(window.jQuery, window));
	/* jquery.signalR.transports.longPolling.js */
	// Copyright (c) Microsoft Open Technologies, Inc. All rights reserved. See License.md in the project root for license information.
	
	/*global window:false */
	/// <reference path="jquery.signalR.transports.common.js" />
	
	(function ($, window, undefined) {
	
	    var signalR = $.signalR,
	        events = $.signalR.events,
	        changeState = $.signalR.changeState,
	        isDisconnecting = $.signalR.isDisconnecting,
	        transportLogic = signalR.transports._logic,
	        browserSupportsXHRProgress = (function () {
	                try {
	                    return "onprogress" in new window.XMLHttpRequest();
	                } catch (e) {
	                    // No XHR means no XHR progress event
	                    return false;
	                }
	            })();
	
	    signalR.transports.longPolling = {
	        name: "longPolling",
	
	        supportsKeepAlive: function (connection) {
	            return browserSupportsXHRProgress &&
	                   connection.ajaxDataType !== "jsonp" &&
	                   // Don't check for keep alives if there is a delay configured between poll requests.
	                   // Don't check for keep alives if the server didn't send back the "LongPollDelay" as
	                   // part of the response to /negotiate. That indicates the server is running an older
	                   // version of SignalR that doesn't send long polling keep alives.
	                   connection._.longPollDelay === 0;
	        },
	
	        reconnectDelay: 3000,
	
	        start: function (connection, onSuccess, onFailed) {
	            /// <summary>Starts the long polling connection</summary>
	            /// <param name="connection" type="signalR">The SignalR connection to start</param>
	            var that = this,
	                fireConnect = function () {
	                    fireConnect = $.noop;
	
	                    // Reset onFailed to null because it shouldn't be called again
	                    onFailed = null;
	
	                    connection.log("LongPolling connected.");
	                    onSuccess();
	                },
	                tryFailConnect = function () {
	                    if (onFailed) {
	                        onFailed();
	                        onFailed = null;
	                        connection.log("LongPolling failed to connect.");
	                        return true;
	                    }
	
	                    return false;
	                },
	                privateData = connection._,
	                reconnectErrors = 0,
	                fireReconnected = function (instance) {
	                    window.clearTimeout(privateData.reconnectTimeoutId);
	                    privateData.reconnectTimeoutId = null;
	
	                    if (changeState(instance,
	                                    signalR.connectionState.reconnecting,
	                                    signalR.connectionState.connected) === true) {
	                        // Successfully reconnected!
	                        instance.log("Raising the reconnect event");
	                        $(instance).triggerHandler(events.onReconnect);
	                    }
	                },
	                // 1 hour
	                maxFireReconnectedTimeout = 3600000;
	
	            if (connection.pollXhr) {
	                connection.log("Polling xhr requests already exists, aborting.");
	                connection.stop();
	            }
	
	            connection.messageId = null;
	
	            privateData.reconnectTimeoutId = null;
	
	            privateData.pollTimeoutId = window.setTimeout(function () {
	                (function poll(instance, raiseReconnect) {
	                    var messageId = instance.messageId,
	                        connect = (messageId === null),
	                        reconnecting = !connect,
	                        polling = !raiseReconnect,
	                        url = transportLogic.getUrl(instance, that.name, reconnecting, polling);
	
	                    // If we've disconnected during the time we've tried to re-instantiate the poll then stop.
	                    if (isDisconnecting(instance) === true) {
	                        return;
	                    }
	
	                    connection.log("Opening long polling request to '" + url + "'.");
	                    instance.pollXhr = transportLogic.ajax(connection, {
	                        xhrFields: {
	                            onprogress: function () {
	                                transportLogic.markLastMessage(connection);
	                            }
	                        },
	                        url: url,
	                        success: function (result) {
	                            var minData,
	                                delay = 0,
	                                data,
	                                shouldReconnect;
	
	                            connection.log("Long poll complete.");
	
	                            // Reset our reconnect errors so if we transition into a reconnecting state again we trigger
	                            // reconnected quickly
	                            reconnectErrors = 0;
	
	                            try {
	                                // Remove any keep-alives from the beginning of the result
	                                minData = connection._parseResponse(result);
	                            }
	                            catch (error) {
	                                transportLogic.handleParseFailure(instance, result, error, tryFailConnect, instance.pollXhr);
	                                return;
	                            }
	
	                            // If there's currently a timeout to trigger reconnect, fire it now before processing messages
	                            if (privateData.reconnectTimeoutId !== null) {
	                                fireReconnected(instance);
	                            }
	
	                            if (minData) {
	                                data = transportLogic.maximizePersistentResponse(minData);
	                            }
	
	                            transportLogic.processMessages(instance, minData, fireConnect);
	
	                            if (data &&
	                                $.type(data.LongPollDelay) === "number") {
	                                delay = data.LongPollDelay;
	                            }
	
	                            if (data && data.Disconnect) {
	                                return;
	                            }
	
	                            if (isDisconnecting(instance) === true) {
	                                return;
	                            }
	
	                            shouldReconnect = data && data.ShouldReconnect;
	                            if (shouldReconnect) {
	                                // Transition into the reconnecting state
	                                // If this fails then that means that the user transitioned the connection into a invalid state in processMessages.
	                                if (!transportLogic.ensureReconnectingState(instance)) {
	                                    return;
	                                }
	                            }
	
	                            // We never want to pass a raiseReconnect flag after a successful poll.  This is handled via the error function
	                            if (delay > 0) {
	                                privateData.pollTimeoutId = window.setTimeout(function () {
	                                    poll(instance, shouldReconnect);
	                                }, delay);
	                            } else {
	                                poll(instance, shouldReconnect);
	                            }
	                        },
	
	                        error: function (data, textStatus) {
	                            // Stop trying to trigger reconnect, connection is in an error state
	                            // If we're not in the reconnect state this will noop
	                            window.clearTimeout(privateData.reconnectTimeoutId);
	                            privateData.reconnectTimeoutId = null;
	
	                            if (textStatus === "abort") {
	                                connection.log("Aborted xhr request.");
	                                return;
	                            }
	
	                            if (!tryFailConnect()) {
	
	                                // Increment our reconnect errors, we assume all errors to be reconnect errors
	                                // In the case that it's our first error this will cause Reconnect to be fired
	                                // after 1 second due to reconnectErrors being = 1.
	                                reconnectErrors++;
	
	                                if (connection.state !== signalR.connectionState.reconnecting) {
	                                    connection.log("An error occurred using longPolling. Status = " + textStatus + ".  Response = " + data.responseText + ".");
	                                    $(instance).triggerHandler(events.onError, [signalR._.transportError(signalR.resources.longPollFailed, connection.transport, data, instance.pollXhr)]);
	                                }
	
	                                // We check the state here to verify that we're not in an invalid state prior to verifying Reconnect.
	                                // If we're not in connected or reconnecting then the next ensureReconnectingState check will fail and will return.
	                                // Therefore we don't want to change that failure code path.
	                                if ((connection.state === signalR.connectionState.connected ||
	                                    connection.state === signalR.connectionState.reconnecting) &&
	                                    !transportLogic.verifyLastActive(connection)) {
	                                    return;
	                                }
	
	                                // Transition into the reconnecting state
	                                // If this fails then that means that the user transitioned the connection into the disconnected or connecting state within the above error handler trigger.
	                                if (!transportLogic.ensureReconnectingState(instance)) {
	                                    return;
	                                }
	
	                                // Call poll with the raiseReconnect flag as true after the reconnect delay
	                                privateData.pollTimeoutId = window.setTimeout(function () {
	                                    poll(instance, true);
	                                }, that.reconnectDelay);
	                            }
	                        }
	                    });
	
	                    // This will only ever pass after an error has occured via the poll ajax procedure.
	                    if (reconnecting && raiseReconnect === true) {
	                        // We wait to reconnect depending on how many times we've failed to reconnect.
	                        // This is essentially a heuristic that will exponentially increase in wait time before
	                        // triggering reconnected.  This depends on the "error" handler of Poll to cancel this 
	                        // timeout if it triggers before the Reconnected event fires.
	                        // The Math.min at the end is to ensure that the reconnect timeout does not overflow.
	                        privateData.reconnectTimeoutId = window.setTimeout(function () { fireReconnected(instance); }, Math.min(1000 * (Math.pow(2, reconnectErrors) - 1), maxFireReconnectedTimeout));
	                    }
	                }(connection));
	            }, 250); // Have to delay initial poll so Chrome doesn't show loader spinner in tab
	        },
	
	        lostConnection: function (connection) {
	            if (connection.pollXhr) {
	                connection.pollXhr.abort("lostConnection");
	            }
	        },
	
	        send: function (connection, data) {
	            transportLogic.ajaxSend(connection, data);
	        },
	
	        stop: function (connection) {
	            /// <summary>Stops the long polling connection</summary>
	            /// <param name="connection" type="signalR">The SignalR connection to stop</param>
	
	            window.clearTimeout(connection._.pollTimeoutId);
	            window.clearTimeout(connection._.reconnectTimeoutId);
	
	            delete connection._.pollTimeoutId;
	            delete connection._.reconnectTimeoutId;
	
	            if (connection.pollXhr) {
	                connection.pollXhr.abort();
	                connection.pollXhr = null;
	                delete connection.pollXhr;
	            }
	        },
	
	        abort: function (connection, async) {
	            transportLogic.ajaxAbort(connection, async);
	        }
	    };
	
	}(window.jQuery, window));
	/* jquery.signalR.hubs.js */
	// Copyright (c) Microsoft Open Technologies, Inc. All rights reserved. See License.md in the project root for license information.
	
	/*global window:false */
	/// <reference path="jquery.signalR.core.js" />
	
	(function ($, window, undefined) {
	
	    var eventNamespace = ".hubProxy",
	        signalR = $.signalR;
	
	    function makeEventName(event) {
	        return event + eventNamespace;
	    }
	
	    // Equivalent to Array.prototype.map
	    function map(arr, fun, thisp) {
	        var i,
	            length = arr.length,
	            result = [];
	        for (i = 0; i < length; i += 1) {
	            if (arr.hasOwnProperty(i)) {
	                result[i] = fun.call(thisp, arr[i], i, arr);
	            }
	        }
	        return result;
	    }
	
	    function getArgValue(a) {
	        return $.isFunction(a) ? null : ($.type(a) === "undefined" ? null : a);
	    }
	
	    function hasMembers(obj) {
	        for (var key in obj) {
	            // If we have any properties in our callback map then we have callbacks and can exit the loop via return
	            if (obj.hasOwnProperty(key)) {
	                return true;
	            }
	        }
	
	        return false;
	    }
	
	    function clearInvocationCallbacks(connection, error) {
	        /// <param name="connection" type="hubConnection" />
	        var callbacks = connection._.invocationCallbacks,
	            callback;
	
	        if (hasMembers(callbacks)) {
	            connection.log("Clearing hub invocation callbacks with error: " + error + ".");
	        }
	
	        // Reset the callback cache now as we have a local var referencing it
	        connection._.invocationCallbackId = 0;
	        delete connection._.invocationCallbacks;
	        connection._.invocationCallbacks = {};
	
	        // Loop over the callbacks and invoke them.
	        // We do this using a local var reference and *after* we've cleared the cache
	        // so that if a fail callback itself tries to invoke another method we don't 
	        // end up with its callback in the list we're looping over.
	        for (var callbackId in callbacks) {
	            callback = callbacks[callbackId];
	            callback.method.call(callback.scope, { E: error });
	        }
	    }
	
	    // hubProxy
	    function hubProxy(hubConnection, hubName) {
	        /// <summary>
	        ///     Creates a new proxy object for the given hub connection that can be used to invoke
	        ///     methods on server hubs and handle client method invocation requests from the server.
	        /// </summary>
	        return new hubProxy.fn.init(hubConnection, hubName);
	    }
	
	    hubProxy.fn = hubProxy.prototype = {
	        init: function (connection, hubName) {
	            this.state = {};
	            this.connection = connection;
	            this.hubName = hubName;
	            this._ = {
	                callbackMap: {}
	            };
	        },
	
	        hasSubscriptions: function () {
	            return hasMembers(this._.callbackMap);
	        },
	
	        on: function (eventName, callback) {
	            /// <summary>Wires up a callback to be invoked when a invocation request is received from the server hub.</summary>
	            /// <param name="eventName" type="String">The name of the hub event to register the callback for.</param>
	            /// <param name="callback" type="Function">The callback to be invoked.</param>
	            var that = this,
	                callbackMap = that._.callbackMap;
	
	            // Normalize the event name to lowercase
	            eventName = eventName.toLowerCase();
	
	            // If there is not an event registered for this callback yet we want to create its event space in the callback map.
	            if (!callbackMap[eventName]) {
	                callbackMap[eventName] = {};
	            }
	
	            // Map the callback to our encompassed function
	            callbackMap[eventName][callback] = function (e, data) {
	                callback.apply(that, data);
	            };
	
	            $(that).bind(makeEventName(eventName), callbackMap[eventName][callback]);
	
	            return that;
	        },
	
	        off: function (eventName, callback) {
	            /// <summary>Removes the callback invocation request from the server hub for the given event name.</summary>
	            /// <param name="eventName" type="String">The name of the hub event to unregister the callback for.</param>
	            /// <param name="callback" type="Function">The callback to be invoked.</param>
	            var that = this,
	                callbackMap = that._.callbackMap,
	                callbackSpace;
	
	            // Normalize the event name to lowercase
	            eventName = eventName.toLowerCase();
	
	            callbackSpace = callbackMap[eventName];
	
	            // Verify that there is an event space to unbind
	            if (callbackSpace) {
	                // Only unbind if there's an event bound with eventName and a callback with the specified callback
	                if (callbackSpace[callback]) {
	                    $(that).unbind(makeEventName(eventName), callbackSpace[callback]);
	
	                    // Remove the callback from the callback map
	                    delete callbackSpace[callback];
	
	                    // Check if there are any members left on the event, if not we need to destroy it.
	                    if (!hasMembers(callbackSpace)) {
	                        delete callbackMap[eventName];
	                    }
	                } else if (!callback) { // Check if we're removing the whole event and we didn't error because of an invalid callback
	                    $(that).unbind(makeEventName(eventName));
	
	                    delete callbackMap[eventName];
	                }
	            }
	
	            return that;
	        },
	
	        invoke: function (methodName) {
	            /// <summary>Invokes a server hub method with the given arguments.</summary>
	            /// <param name="methodName" type="String">The name of the server hub method.</param>
	
	            var that = this,
	                connection = that.connection,
	                args = $.makeArray(arguments).slice(1),
	                argValues = map(args, getArgValue),
	                data = { H: that.hubName, M: methodName, A: argValues, I: connection._.invocationCallbackId },
	                d = $.Deferred(),
	                callback = function (minResult) {
	                    var result = that._maximizeHubResponse(minResult),
	                        source,
	                        error;
	
	                    // Update the hub state
	                    $.extend(that.state, result.State);
	
	                    if (result.Progress) {
	                        if (d.notifyWith) {
	                            // Progress is only supported in jQuery 1.7+
	                            d.notifyWith(that, [result.Progress.Data]);
	                        } else if(!connection._.progressjQueryVersionLogged) {
	                            connection.log("A hub method invocation progress update was received but the version of jQuery in use (" + $.prototype.jquery + ") does not support progress updates. Upgrade to jQuery 1.7+ to receive progress notifications.");
	                            connection._.progressjQueryVersionLogged = true;
	                        }
	                    } else if (result.Error) {
	                        // Server hub method threw an exception, log it & reject the deferred
	                        if (result.StackTrace) {
	                            connection.log(result.Error + "\n" + result.StackTrace + ".");
	                        }
	
	                        // result.ErrorData is only set if a HubException was thrown
	                        source = result.IsHubException ? "HubException" : "Exception";
	                        error = signalR._.error(result.Error, source);
	                        error.data = result.ErrorData;
	
	                        connection.log(that.hubName + "." + methodName + " failed to execute. Error: " + error.message);
	                        d.rejectWith(that, [error]);
	                    } else {
	                        // Server invocation succeeded, resolve the deferred
	                        connection.log("Invoked " + that.hubName + "." + methodName);
	                        d.resolveWith(that, [result.Result]);
	                    }
	                };
	
	            connection._.invocationCallbacks[connection._.invocationCallbackId.toString()] = { scope: that, method: callback };
	            connection._.invocationCallbackId += 1;
	
	            if (!$.isEmptyObject(that.state)) {
	                data.S = that.state;
	            }
	
	            connection.log("Invoking " + that.hubName + "." + methodName);
	            connection.send(data);
	
	            return d.promise();
	        },
	
	        _maximizeHubResponse: function (minHubResponse) {
	            return {
	                State: minHubResponse.S,
	                Result: minHubResponse.R,
	                Progress: minHubResponse.P ? {
	                    Id: minHubResponse.P.I,
	                    Data: minHubResponse.P.D
	                } : null,
	                Id: minHubResponse.I,
	                IsHubException: minHubResponse.H,
	                Error: minHubResponse.E,
	                StackTrace: minHubResponse.T,
	                ErrorData: minHubResponse.D
	            };
	        }
	    };
	
	    hubProxy.fn.init.prototype = hubProxy.fn;
	
	    // hubConnection
	    function hubConnection(url, options) {
	        /// <summary>Creates a new hub connection.</summary>
	        /// <param name="url" type="String">[Optional] The hub route url, defaults to "/signalr".</param>
	        /// <param name="options" type="Object">[Optional] Settings to use when creating the hubConnection.</param>
	        var settings = {
	            qs: null,
	            logging: false,
	            useDefaultPath: true
	        };
	
	        $.extend(settings, options);
	
	        if (!url || settings.useDefaultPath) {
	            url = (url || "") + "/signalr";
	        }
	        return new hubConnection.fn.init(url, settings);
	    }
	
	    hubConnection.fn = hubConnection.prototype = $.connection();
	
	    hubConnection.fn.init = function (url, options) {
	        var settings = {
	                qs: null,
	                logging: false,
	                useDefaultPath: true
	            },
	            connection = this;
	
	        $.extend(settings, options);
	
	        // Call the base constructor
	        $.signalR.fn.init.call(connection, url, settings.qs, settings.logging);
	
	        // Object to store hub proxies for this connection
	        connection.proxies = {};
	
	        connection._.invocationCallbackId = 0;
	        connection._.invocationCallbacks = {};
	
	        // Wire up the received handler
	        connection.received(function (minData) {
	            var data, proxy, dataCallbackId, callback, hubName, eventName;
	            if (!minData) {
	                return;
	            }
	
	            // We have to handle progress updates first in order to ensure old clients that receive
	            // progress updates enter the return value branch and then no-op when they can't find
	            // the callback in the map (because the minData.I value will not be a valid callback ID)
	            if (typeof (minData.P) !== "undefined") {
	                // Process progress notification
	                dataCallbackId = minData.P.I.toString();
	                callback = connection._.invocationCallbacks[dataCallbackId];
	                if (callback) {
	                    callback.method.call(callback.scope, minData);
	                }
	            } else if (typeof (minData.I) !== "undefined") {
	                // We received the return value from a server method invocation, look up callback by id and call it
	                dataCallbackId = minData.I.toString();
	                callback = connection._.invocationCallbacks[dataCallbackId];
	                if (callback) {
	                    // Delete the callback from the proxy
	                    connection._.invocationCallbacks[dataCallbackId] = null;
	                    delete connection._.invocationCallbacks[dataCallbackId];
	
	                    // Invoke the callback
	                    callback.method.call(callback.scope, minData);
	                }
	            } else {
	                data = this._maximizeClientHubInvocation(minData);
	
	                // We received a client invocation request, i.e. broadcast from server hub
	                connection.log("Triggering client hub event '" + data.Method + "' on hub '" + data.Hub + "'.");
	
	                // Normalize the names to lowercase
	                hubName = data.Hub.toLowerCase();
	                eventName = data.Method.toLowerCase();
	
	                // Trigger the local invocation event
	                proxy = this.proxies[hubName];
	
	                // Update the hub state
	                $.extend(proxy.state, data.State);
	                $(proxy).triggerHandler(makeEventName(eventName), [data.Args]);
	            }
	        });
	
	        connection.error(function (errData, origData) {
	            var callbackId, callback;
	
	            if (!origData) {
	                // No original data passed so this is not a send error
	                return;
	            }
	
	            callbackId = origData.I;
	            callback = connection._.invocationCallbacks[callbackId];
	
	            // Verify that there is a callback bound (could have been cleared)
	            if (callback) {
	                // Delete the callback
	                connection._.invocationCallbacks[callbackId] = null;
	                delete connection._.invocationCallbacks[callbackId];
	
	                // Invoke the callback with an error to reject the promise
	                callback.method.call(callback.scope, { E: errData });
	            }
	        });
	
	        connection.reconnecting(function () {
	            if (connection.transport && connection.transport.name === "webSockets") {
	                clearInvocationCallbacks(connection, "Connection started reconnecting before invocation result was received.");
	            }
	        });
	
	        connection.disconnected(function () {
	            clearInvocationCallbacks(connection, "Connection was disconnected before invocation result was received.");
	        });
	    };
	
	    hubConnection.fn._maximizeClientHubInvocation = function (minClientHubInvocation) {
	        return {
	            Hub: minClientHubInvocation.H,
	            Method: minClientHubInvocation.M,
	            Args: minClientHubInvocation.A,
	            State: minClientHubInvocation.S
	        };
	    };
	
	    hubConnection.fn._registerSubscribedHubs = function () {
	        /// <summary>
	        ///     Sets the starting event to loop through the known hubs and register any new hubs 
	        ///     that have been added to the proxy.
	        /// </summary>
	        var connection = this;
	
	        if (!connection._subscribedToHubs) {
	            connection._subscribedToHubs = true;
	            connection.starting(function () {
	                // Set the connection's data object with all the hub proxies with active subscriptions.
	                // These proxies will receive notifications from the server.
	                var subscribedHubs = [];
	
	                $.each(connection.proxies, function (key) {
	                    if (this.hasSubscriptions()) {
	                        subscribedHubs.push({ name: key });
	                        connection.log("Client subscribed to hub '" + key + "'.");
	                    }
	                });
	
	                if (subscribedHubs.length === 0) {
	                    connection.log("No hubs have been subscribed to.  The client will not receive data from hubs.  To fix, declare at least one client side function prior to connection start for each hub you wish to subscribe to.");
	                }
	
	                connection.data = connection.json.stringify(subscribedHubs);
	            });
	        }
	    };
	
	    hubConnection.fn.createHubProxy = function (hubName) {
	        /// <summary>
	        ///     Creates a new proxy object for the given hub connection that can be used to invoke
	        ///     methods on server hubs and handle client method invocation requests from the server.
	        /// </summary>
	        /// <param name="hubName" type="String">
	        ///     The name of the hub on the server to create the proxy for.
	        /// </param>
	
	        // Normalize the name to lowercase
	        hubName = hubName.toLowerCase();
	
	        var proxy = this.proxies[hubName];
	        if (!proxy) {
	            proxy = hubProxy(this, hubName);
	            this.proxies[hubName] = proxy;
	        }
	
	        this._registerSubscribedHubs();
	
	        return proxy;
	    };
	
	    hubConnection.fn.init.prototype = hubConnection.fn;
	
	    $.hubConnection = hubConnection;
	
	}(window.jQuery, window));
	/* jquery.signalR.version.js */
	// Copyright (c) Microsoft Open Technologies, Inc. All rights reserved. See License.md in the project root for license information.
	
	/*global window:false */
	/// <reference path="jquery.signalR.core.js" />
	(function ($, undefined) {
	    $.signalR.version = "2.1.1";
	}(window.jQuery));
	
	}).call(global, module, undefined, undefined);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(19)(module)))

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var $ = __webpack_require__(1);
	var pli = __webpack_require__(380);
	
	__webpack_require__(465);
	
	//---------------------------------------
	function DownloadContext(id) {
	    this.id = id;
	    this.d = new $.Deferred();
	}
	
	
	//---------------------------------------
	DownloadContext.prototype.verify = function verifyDownload(response) {
	    if (response.isError || !response.result) {
	        this.d.reject({ isError: true });
	    } else {
	        if (typeof pli.dialogClosingMessage === "function") { // temporarily ignore closing message
	            this.originalDialogClosingMessage = pli.dialogClosingMessage;
	            pli.dialogClosingMessage = this.preventClosingMessage.bind(this);
	        }
	        window.location = pli.resolveUrl("~/Download/".concat(response.result));
	        this.d.resolve({ isError: false });
	    }
	};
	
	
	//---------------------------------------
	DownloadContext.prototype.preventClosingMessage = function preventDownloadClosingMessage() {
	    pli.dialogClosingMessage = this.originalDialogClosingMessage;
	    this.originalDialogClosingMessage = null;
	    return null;
	};
	
	
	//---------------------------------------
	pli.download = pli.download || function downloadFile(id) {
	    /// <summary>
	    /// Downloads a file from the filestore
	    /// using the specified id.
	    /// </summary>
	    /// <returns>
	    /// A jQuery Deferred promise indicating either
	    /// success or failure.
	    /// </returns>
	    if (typeof id !== "string" && id.length === 0) { throw new Error("id must be non-empty string"); }
	    var context = new DownloadContext(id);
	    pli.call({
	        name: "Geo-FileStore-Download",
	        data: id
	    }).always(context.verify.bind(context));
	    return context.d.promise();
	};
	
	module.exports = pli.download;

/***/ }),
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	var DataCache = __webpack_require__(489);
	var dataCache = new DataCache();
	
	module.exports = dataCache;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true, plusplus: true*/
	"use strict";
	
	var $ = __webpack_require__(1);
	var clientBroadcastManager = __webpack_require__(477);
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(5);
	
	var trackedCacheItems = {},
	    stateChangedCallbacks,
	    stateChangedSubscribable;
	
	__webpack_require__(490);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Class "DataCacheItem"
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-----------------------------------------------
	function DataCacheItem(name) {
	    /// <summary>
	    /// Create new instance of DataCacheItem.
	    /// Initializes properties to default values
	    /// </summary>
	    this.name = name;
	    this.data = null;
	    this.version = null;
	    this.observables = [];
	    this.activeCall = null;
	    this.activeCallDeferred = null;
	    this.error = null;
	    this._handleGetCallResponseInstance = DataCacheItem.prototype._handleGetCallResponse.bind(this);
	}
	
	
	//-----------------------------------------------
	DataCacheItem.prototype._observableDispose = function dataCacheObservableDispose() {
	    /// <summary>
	    /// Define logic for dispose method of observables
	    /// that are stored in DataCacheItem.observables array.
	    /// Expects "this" to be ko.observable.
	    /// </summary>
	    var trackedCacheItem = this(),
	        i = ko.utils.arrayIndexOf(trackedCacheItem.observables, this);
	    if (i !== -1) {
	        ko.utils.arrayRemoveItem(trackedCacheItem.observables, i);
	    }
	};
	
	
	//-----------------------------------------------
	DataCacheItem.prototype._observableReload = function dataCacheObservableReload() {
	    /// <summary>
	    /// Re-loads the observable data.
	    /// Expects "this" to be ko.observable.
	    /// </summary>
	    var trackedCacheItem = this();
	    return trackedCacheItem.load();
	};
	
	
	//-----------------------------------------------
	DataCacheItem.prototype._handleGetCallResponse = function dataCacheHandleGetCallResponse(response) {
	    /// <summary>
	    /// Always handles the response of the activeCall whether it is resolved or rejected.
	    /// Expects "this" to be DataCacheItem.
	    /// </summary>
	    var message, i, l;
	    if (!response.isError) { // replace the data in the cache
	        this.data = response.result.data;
	        this.version = response.result.version;
	    } else { // remove the data from the cache.
	        message = "Failed to load data cache entry, ".concat(this.name);
	        if (window.console) { window.console.warn(message, response); }
	        this.error = (response.result && response.result.message) || message;
	    }
	
	    this.activeCall = null;
	    for (i = 0, l = this.observables.length; i < l; ++i) {
	        this.observables[i].valueHasMutated();
	    }
	
	    if (this.error) {
	        this.activeCallDeferred.reject(this);
	    } else {
	        this.activeCallDeferred.resolve(this);
	    }
	};
	
	
	//-----------------------------------------------
	DataCacheItem.prototype.load = function loadDataCacheItem() {
	    /// <summary>
	    /// Initiate Geo-DataCache-Get to pull data for
	    /// this DataCacheItem unless a call is already
	    /// in progress.
	    /// </summary>
	    var i, l;
	
	    if (!this.activeCall) {
	        this.data = null;
	        this.version = null;
	        this.error = null;
	        this.activeCallDeferred = new $.Deferred();
	        this.activeCall = (pli.global.dataCacheOptions && pli.global.dataCacheOptions.call(this.name))
	            || pli.call({
	                name: "Geo-DataCache-Get",
	                data: { id: this.name }
	            });
	        this.activeCall.always(this._handleGetCallResponseInstance);
	
	        if (this.activeCall) { // usually truthy; could be falsey if "activeCall.always" already called the handler (e.g. fatal network error) - handler will have set activeCall to null
	            for (i = 0, l = this.observables.length; i < l; ++i) {
	                this.observables[i].valueHasMutated();
	            }
	        }
	    }
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Class "DataCache"
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-----------------------------------------------
	function DataCache() {
	    /// <summary>
	    /// Create new instance of DataCache (singleton,
	    /// one instance per browser window).
	    /// </summary>
	    // Do not use parent instance in IE as access to parent objects is extremely slow.
	    this.parent = (document.documentMode >= 8
	        ? null
	        : pli.findComponent("dataCache"));
	    stateChangedCallbacks = new $.Callbacks();
	    stateChangedSubscribable = new $.Callbacks.Subscribable(stateChangedCallbacks);
	}
	
	
	//-----------------------------------------------
	function findTrackedCacheItem(name) {
	    /// <summary>
	    /// Get instance of DataCacheItem as specified by
	    /// options and stored in trackedCacheItems. If no
	    /// such instance is tracked yet, creates a new
	    /// instance and adds it to trackedCacheItems.
	    /// </summary>
	    var trackedCacheItem = trackedCacheItems[name];
	    if (!trackedCacheItem) {
	        trackedCacheItem = trackedCacheItems[name] = new DataCacheItem(name);
	    }
	    return trackedCacheItem;
	}
	
	
	//-----------------------------------------------
	DataCache.prototype.dispose = function disposeDataCache() {
	    /// <summary>
	    /// Releases connections to the client broadcast
	    /// manager or parent data cache instance.
	    /// </summary>
	    if (this._handleServerEventInstance) {
	        if (this.parent) {
	            this.parent.offStateChanged(this._handleServerEventInstance);
	        } else if (pli.global.dataCacheOptions && pli.global.dataCacheOptions.offUpdated) {
	            pli.global.dataCacheOptions.offUpdated(this._handleServerEventInstance);
	        } else {
	            clientBroadcastManager.offUpdated(this._handleServerEventInstance);
	        }
	    }
	};
	
	
	//-----------------------------------------------
	DataCache.prototype.get = function getDataCacheItem(name) {
	    /// <summary>
	    /// Gets the specified data cache item.
	    /// </summary>
	    /// <param name="name">
	    /// string that uniquely identifies the cache entry.
	    /// </param>
	    /// <returns type="promise">
	    /// Returns jQuery's promise object (http://api.jquery.com/deferred.promise/).
	    /// This object will be resolved when data is retrieved
	    /// from the server or the current version of the data
	    /// already exists on the client.  This object is rejected
	    /// when the call to the server fails.
	    /// </returns>
	    this._ensureServerEventsActive();
	
	    // forward event to parent if available.
	    if (this.parent) { return this.parent.get(name); }
	
	    var trackedCacheItem = findTrackedCacheItem(name);
	
	    // start loading if no data (even if previous load had an error)
	    // initialize activeCallDeferred if not already available
	    if (!trackedCacheItem.data) { trackedCacheItem.load(); }
	
	    return trackedCacheItem.activeCallDeferred.promise();
	};
	
	
	//-----------------------------------------------
	DataCache.prototype.getObservable = function getDataCacheItemObservable(name) {
	    /// <summary>
	    /// Gets an observable for the specified data cache item.
	    /// This observable always resolves to DataCacheItem
	    /// instance. It will notify subscribers when anything
	    /// in this instance changes (e.g. a new activeCall
	    /// is started, new data was retrieved or data
	    /// retrieval failed).
	    /// </summary>
	    /// <param name="name">
	    /// string that uniquely identifies the cache entry.
	    /// </param>
	    /// <remarks>
	    /// Returned observable contains a "dispose" method
	    /// that should be called when the observable should
	    /// not notify subscribers anymore.
	    /// </remarks>
	
	    this._ensureServerEventsActive();
	
	    // forward event to parent if available.
	    if (this.parent) { return this.parent.getObservable(name); }
	
	    var trackedCacheItem = findTrackedCacheItem(name),
	        o = ko.observable(trackedCacheItem);
	
	    o.dispose = DataCacheItem.prototype._observableDispose;
	    o.reload = DataCacheItem.prototype._observableReload;
	    trackedCacheItem.observables.push(o);
	
	    // start loading only if no data and previous load didn't have an error (i.e. this is a newly created trackedCacheItem)
	    if (!trackedCacheItem.data && !trackedCacheItem.error) { trackedCacheItem.load(); }
	
	    return o;
	};
	
	
	//-----------------------------------------------
	DataCache.prototype.offStateChanged = function offStateChangedDataCache(callback) {
	    /// <summary>
	    /// Remove an existing callback from state changed event.
	    /// </summary>
	    stateChangedSubscribable.remove(callback);
	};
	
	
	//-----------------------------------------------
	DataCache.prototype.onStateChanged = function onStateChanged(callback) {
	    /// <summary>
	    /// Add a callback that is fired when the state of any data cache
	    /// item changes.
	    /// </summary>
	    stateChangedSubscribable.add(callback);
	};
	
	
	//-----------------------------------------------
	DataCache.prototype._ensureServerEventsActive = function ensureServerEventsActiveDataCache() {
	    /// <summary>
	    /// Defers starting the clientBroadcastManager until the first item is requested.
	    /// This function is intended to be called from get and getObservable.
	    /// </summary>
	    if (!this._handleServerEventInstance) {
	        this._handleServerEventInstance = DataCache.prototype._handleServerEvent.bind(this);
	        if (this.parent) {
	            this.parent.onStateChanged(this._handleServerEventInstance);
	        } else if (pli.global.dataCacheOptions && pli.global.dataCacheOptions.offUpdated) {
	            pli.global.dataCacheOptions.onUpdated(this._handleServerEventInstance);
	        } else {
	            clientBroadcastManager.onUpdated(this._handleServerEventInstance);
	        }
	        $(window).unload(DataCache.prototype.dispose.bind(this));
	    }
	};
	
	
	//-----------------------------------------------
	DataCache.prototype._handleServerEvent = function handleServerDataCacheEvent(message) {
	    /// <summary>
	    /// Handles server events. Ignores non-dataCache
	    /// events. For each dataCache event will trigger
	    /// DataCache.events.stateChanged.
	    /// </summary>
	
	    if (this.parent) { // if parent forward event from parent.
	        stateChangedCallbacks.fire(message);
	        return;
	    }
	
	    if (message.type === "dataCache") {
	        var trackedCacheItem = trackedCacheItems[message.id];
	        if (trackedCacheItem) {
	
	            // Apply server-side state to client cache item
	            trackedCacheItem.previousState = message.data.previousState;
	            trackedCacheItem.currentState = message.data.currentState;
	
	            if (trackedCacheItem.data && message.data.previousState === "Loaded") { // if the data was invalidated remove from local cache (and abort active call if re-pulling data for observables)
	                trackedCacheItem.data = null;
	            }
	            if (trackedCacheItem.data === null && trackedCacheItem.observables.length) { // if we have no data and we have observables, initiate data get now
	                trackedCacheItem.load(false); // do not return promise object
	            }
	            stateChangedCallbacks.fire(trackedCacheItem);
	        }
	    }
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//------------------------------------------
	module.exports = DataCache;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(491);


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var $ = __webpack_require__(1);
	
	//-------------------------------------------
	function findCallbackInArray(callback, callbacks) {
	    /// <summary>
	    /// Searchs the array for the index of the original function
	    /// and the wrapper function.
	    /// </summary>
	    var i, length;
	    // loop through and look for match of the original function
	    for (i = 0, length = callbacks.length; i < length; i += 1) {
	        if (callbacks[i][0] === callback) { return i; }
	    }
	    return -1;
	}
	
	
	//-------------------------------------------
	$.Callbacks.Subscribable = function subscribable($callback) {
	    /// <summary>
	    /// Initializes a subscribable which is a wrapper for a
	    /// jQuery.Callbacks that hides disable/fire/fired/fireWith/lock/locked
	    /// Also add/remove only support a function (not an array of functions).
	    /// Addresses issue with IE passing functions between windows
	    /// (http://stackoverflow.com/questions/10499623/cant-pass-a-function-from-one-window-to-another-in-ie/10524514#10524514)
	    /// </summary>
	
	    // Allow instantiation without the 'new' keyword
	    if (!(this instanceof $.Callbacks.Subscribable)) { return new $.Callbacks.Subscribable($callback); }
	
	    this._$callback = $callback;
	    this._callbackMap = []; // map of IE "object-functions" (from another window) to wrapper-function
	    return this;
	
	};
	
	
	//-------------------------------------------
	$.Callbacks.Subscribable.prototype.add = function subscribableAdd(callback) {
	    /// <summary>
	    /// Registers a callback if it is not already registered.
	    /// An error is thrown if the callback is not a function.
	    /// </summary>
	    /// <param name="callback">
	    /// A function that is to be added to the calllback list.
	    /// </param>
	
	    if (typeof callback === "function") {
	        this._$callback.add(callback);
	
	    // Handle invalid type of function in IE when passed accross windows
	    } else if (callback && callback.call) {
	        var tempCallback = function handler(data) { callback(data); },
	            i = findCallbackInArray(callback, this._callbackMap);
	        if (i < 0) {
	            this._callbackMap.push([callback, tempCallback]);
	            this._$callback.add(tempCallback);
	        }
	
	    } else {
	        throw new Error("$.Callbacks.Subscribable.add requires a callback function");
	    }
	
	    return this;
	
	};
	
	
	//-------------------------------------------
	$.Callbacks.Subscribable.prototype.empty = function subscribableEmpty() {
	    /// <summary>
	    /// Removes all of registered callbacks
	    /// </summary>
	    this._$callback.empty();
	    this._callbackMap.length = 0; // empty the callbacks array -> http://css-tricks.com/snippets/javascript/empty-an-array/
	    return this;
	};
	
	
	//-------------------------------------------
	$.Callbacks.Subscribable.prototype.has = function subscribableHas(callback) {
	    /// <summary>
	    /// Determine whether the callback is registered
	    /// </summary>
	    return (typeof callback === "function")
	        ? this._$callback.has(callback)
	        : (findCallbackInArray(callback, this._callbackMap) >= 0);
	};
	
	
	//-------------------------------------------
	$.Callbacks.Subscribable.prototype.remove = function subscribableRemove(callback) {
	    /// <summary>
	    /// Removes a registered callback
	    /// </summary>
	
	    if (typeof callback === "function") {
	        this._$callback.remove(callback);
	
	    // Handle invalid type of function in IE when passed accross windows
	    } else if (callback && callback.call) {
	        var i = findCallbackInArray(callback, this._callbackMap);
	        if (i >= 0) {
	            this._$callback.remove(this._callbackMap[i][1]);
	            this._callbackMap.splice(i, 1);
	        }
	    }
	
	    return this;
	};
	
	
	//-------------------------------------------
	$.fn.resetPopupFocus = function resetPopupFocus() {
	    /// <summary>
	    /// Set input focus to the first failing
	    /// field or first field if no failing
	    /// field can be found. Returns jQuery
	    /// array containing the focused field.
	    /// </summary>
	
	    var $found = this.find("p.withError:first>span>input"); // first invalid field
	    if (!$found.length) {
	        $found = this.find("p:nth-child(2)>span>input"); // first field (ignores the message bar)
	    }
	    return $found.focus();
	};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	var entityRegistry = __webpack_require__(493);
	
	module.exports = entityRegistry;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, todo: true*/
	"use strict";
	
	var $ = __webpack_require__(1);
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var KnockoutDataProvider = __webpack_require__(369).KnockoutDataProvider;
	var R = __webpack_require__(7);
	
	var dataCache = __webpack_require__(488);
	
	__webpack_require__(494);
	
	var registry = {},
	    reportDefaults = { width: 820, height: 630 },
	    contextMenuNotifier = $.Callbacks();
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function parseId(data, preferName) {
	    var id = preferName
	        ? (data && (data.uniqueName || data.id))
	        : (data && (data.id || data.uniqueName));
	    return id || data || "";
	}
	
	//-------------------------------------------
	function deleteActionHandler(settings) {
	    settings = settings || {};
	    pli.viewModel.contentDeleteForm.open({ displayName: settings.uniqueName || settings.id, id: settings.guid || settings.id });
	}
	
	
	//--------------------------------------------------
	function reportStartHandler(response) {
	    /// <summary>
	    ///  Handles start percent and status call response
	    ///  Expects response.result.token on success, or response.result.statusDescription on error
	    /// </summary>
	    if (!response.isError && response.result) {
	        pli.dialog.open({ targetUrl: "~~/Reports/Generate#" + response.result.token, width: 1000, height: 700, windowType: "window" });
	    }
	}
	
	//-------------------------------------------
	function buildSearchResultOpener(settings) {
	    var width = (settings && settings.width) || 1000,
	        height = (settings && settings.height) || 700,
	        url;
	    return function (value) {
	        if (value && value.url) {
	            url = value.url;
	            height = (value.data && value.data.height) || height;
	            width = (value.data && value.data.width) || width;
	        } else if (value.data) {
	            url = value.data[value.data.length - 2];
	        }
	        return (url
	            ? pli.dialog.open({ targetUrl: url, width: width, height: height, windowType: "window", resizable: true})
	            : false);
	    };
	}
	
	//-------------------------------------------
	function buildReportOpener(settings) {
	    var width = (settings && settings.width) || reportDefaults.width,
	        height = (settings && settings.height) || reportDefaults.height,
	        url;
	
	    return function (value) {
	        if (value) {
	            // Extract url
	            if (value.url) {
	                url = value.url;
	            } else if (value.data) {
	                url = value.data.url;
	            }
	
	            if (value.data) {
	                if (value.data.autorun) {
	                    // Set the report title to be used in the child report window
	                    pli.reportTitle = value.data.name;
	
	                    // start report
	                    return pli.call({
	                        name: "Geo-Report-Start",
	                        data: { reportId: value.data.type, reportData: ko.toJSON(value.data) }
	                    }).always(reportStartHandler);
	                }
	                if (url) {
	                // If report to be opened are "CustomExport" or "WellImport", just open them, no need for modal form
	                    if (value.data.type === "CustomExport" || value.data.type === "WellImport") {
	                        return pli.dialog.open({ targetUrl: url, width: width, height: height, windowType: "window", resizable: true });
	                    }
	                    // Displays report action form where user can select existing saved presets
	                    // copy saved presets or open last run
	                    return pli.forms.registry.reportActionForm.open(value.data);
	                }
	            }
	        }
	
	        return false;
	    };
	}
	
	//-------------------------------------------
	function buildDocumentPrintHandler(reportType) {
	    return function open(data) {
	        var docId = parseId(data, true);
	
	        if (pli.viewModel && pli.viewModel.extras && pli.viewModel.extras.title) {
	            pli.reportTitle = pli.viewModel.extras.title();
	        } else {
	            pli.reportTitle = reportType;
	        }
	
	        // start report
	        pli.call({
	            name: "Geo-Report-Start",
	            data: { reportId: reportType, reportData: ko.toJSON({ id: docId }) }
	        }).always(reportStartHandler);
	    };
	}
	
	//-------------------------------------------
	function buildAddToProjectWindowHandler() {
	    return function open(documentsToAdd) {
	        var docs = documentsToAdd;
	        // ignore case when searching and search the project name column (index 0)
	        var dataProvider = new KnockoutDataProvider(dataCache.getObservable("project"), { exactMatchIgnoresCase: true, searchIndex: 0 });
	        pli.forms.registry.picklistForm.open({
	            dataProvider: dataProvider,
	            value: function (project) {
	                if (project !== undefined) {
	                    var projectData = {
	                        id: project[0][0],
	                        guid: project[0][2],
	                        projectItems: docs
	                    };
	                    pli.forms.registry.busyIndicator.open({
	                        title: "Adding items, please wait..."
	                    });
	                    pli.call({
	                        name: "Geo-Project-AddItems",
	                        data: projectData
	                    }).always(function addItemsResult(response) {
	                        if (response.isError) {
	                            var message = (response && response.message) || "Unable to add project items";
	                            pli.forms.registry.busyIndicator.complete({
	                                failed: true,
	                                message: message,
	                                title: "Unable to add project items",
	                                onClosed: this.close
	                            });
	                        } else {
	                            pli.forms.registry.busyIndicator.close({ force: true });
	                        }
	                    });
	                }
	            }
	        });
	    };
	}
	
	
	//-------------------------------------------
	function buildPicklistOpen(picklistInfo) {
	    /// <summary>
	    /// Initializes the picklist entity
	    /// with behaviour data (for picklist behaviour),
	    /// icon and open actions.
	    /// </summary>
	    var defaultData = {
	        hasCategory: !!picklistInfo.hasCategory,
	        categoryName: picklistInfo.categoryName,
	        type: picklistInfo.type,
	        typeDisplayName: picklistInfo.displayName || picklistInfo.type || ""
	    },
	        edit = function editPicklist(settings) {
	            var data = (settings && settings.data) || settings;
	
	            // Add logic to extract the array of array from multi-select picklist
	            // Check to see if data[0] is an array and extract that out
	            var item = ((data !== undefined) && (Object.prototype.toString.call(data[0]) === '[object Array]'))
	                ? data[0]
	                : data;
	
	            item = item || [];
	            return pli.forms.registry.picklistItemForm.viewModel.open($.extend({
	                guid: item.guid || (item[item.length - 1]) || "",
	                code: item.code || (item[0]) || "",
	                description: item.description || (item[1]) || "",
	                category: item.category || (item.length > 3 && item[2]) || ""
	            }, defaultData));
	        };
	    return $.extend({
	        getPicklistBehaviourData: function getBehaviourData() {
	            return {
	                onNewItem: edit,
	                onOpenItem: edit,
	                picklistData: dataCache.getObservable(picklistInfo.dataCacheId)
	            };
	        },
	        icon: { small: "sprite-editDocument-16" },
	        open: {
	            create: edit,
	            edit: edit,
	            remove: deleteActionHandler
	        }
	    }, picklistInfo);
	}
	
	
	//-------------------------------------------
	function projectPrintHandler(data) {
	    var localData = data;
	    // ignore case when searching and search the project name column (index 0)
	    var dataProvider = new KnockoutDataProvider(dataCache.getObservable("projectPrintStyle"), { exactMatchIgnoresCase: true, searchIndex: 0 });
	    // TODO: put a nicer hook into Pli for the button text
	    pli.forms.registry.picklistForm.$form.find('#picklistForm_buttonBar_accept>span').text('Print');
	    pli.forms.registry.picklistForm.open({
	        dataProvider: dataProvider,
	        value: function (printStyle) {
	            if (printStyle !== undefined) {
	                pli.config.entityRegistry.project.open.printers[printStyle[0][0]](localData);
	            }
	            // TODO: remove this after hook exists
	            pli.forms.registry.picklistForm.$form.find('#picklistForm_buttonBar_accept>span').text('Accept');
	        }
	    });
	}
	
	//-------------------------------------------
	function showContext(data) {
	    if (data.id && data.e && data.entityId) {
	        contextMenuNotifier.fire(data.e, data);
	    }
	}
	
	//-------------------------------------------
	// context menu item click handler
	function onItemCommand(item, command) {
	    var entity;
	    if (command && item.id && item.entityId) {
	        entity = pli.config.entityRegistry[item.entityId];
	
	        if (entity) {
	            switch (command) {
	            case "deleteId":
	                if (entity.open && entity.open.remove) {
	                    entity.open.remove(item);
	                }
	                break;
	            case "editId":
	                if (entity.open && entity.open.edit) {
	                    entity.open.edit(item);
	                }
	                break;
	            case "printId":
	                if (entity.open && entity.open.print) {
	                    entity.open.print(item);
	                }
	                break;
	            case "removeFavoriteId":
	                pli.call({ name: "Geo-Favorites-Remove", data: item.id }); //We don't implement done or fail because we won't yet provide feedback to the user
	                break;
	            case "addFavoriteId":
	                pli.call({ name: "Geo-Favorites-Add", data: item.id }); //We don't implement done or fail because we won't yet provide feedback to the user
	                break;
	            case "addToProjectId":
	                if (entity.open && entity.open.addToProject) {
	                    // Multiple items are selected
	                    if (item.selectedItems && item.selectedItems.length) {
	                        var documents = [];
	
	                        // Build object needed to add to project
	                        ko.utils.arrayForEach(item.selectedItems, function (selectedItem) {
	                            documents.push({
	                                id: selectedItem.id,
	                                classId: selectedItem.classId,
	                                guid: selectedItem.guid,
	                                type: selectedItem.entityName
	                            });
	                        });
	
	                        entity.open.addToProject(documents);
	                    } else {
	                        // Focused item selected
	                        entity.open.addToProject([
	                            {
	                                id: item.uniqueName,
	                                classId: entity.typeId,
	                                guid: item.id,
	                                type: item.entityId
	                            }
	                        ]);
	                    }
	                }
	                break;
	            }
	        }
	    }
	}
	
	
	//-------------------------------------------
	// Return a function that will open a new window
	// with specified dimensions and pointing at
	// the specified URL. ID will be appended to
	// the specified URL as a hash segment (url#id).
	function createNavigableWindowOpener(url, forcedId, width, height, dialogIdPrefix) {
	    return function openNavigableWindow(data) {
	        var id = (typeof forcedId === "string" ? forcedId : (data && (data.uniqueName || data.id)) || ""),
	            customUrl = data && data.url,
	            dialogId = (id && dialogIdPrefix ? dialogIdPrefix + id : null);
	        pli.dialog.open({
	            targetUrl: url.concat("#").concat(customUrl || encodeURIComponent(id)),
	            width: width || 1000,
	            height: height || 700,
	            windowType: "window",
	            id: dialogId
	        });
	    };
	}
	
	//-------------------------------------------
	// Return a function that will open a new report window
	// for the particular report type and report id
	function createReportCriteriaWindowOpener(width, height, defaultUrl, dialogIdPrefix) {
	    return function openNavigableWindow(value) {
	        var id = (value && value.uniqueName) || (value && value.data && (value.data.reportName || value.data.id)) || "",
	            url = (value && value.url) || (value.data && value.data.reportType && defaultUrl.concat("/").concat(value.data.reportType)) || "",
	            dialogId = (id && dialogIdPrefix && (value && value.data && value.data.reportType) ? dialogIdPrefix + value.data.reportType + "-" + id : null);
	        pli.dialog.open({
	            targetUrl: url.concat("#").concat(encodeURIComponent(id)),
	            width: width || 1000,
	            height: height || 700,
	            windowType: "window",
	            id: dialogId
	        });
	    };
	}
	
	
	//-------------------------------------------
	// Setup entity context menu
	if (pli.menu && pli.menu.setup) {
	    pli.menu.setup({
	        notifier: contextMenuNotifier,
	        itemsCallData: function (content) {
	            return {
	                name: "Geo-ContextMenu-Get",
	                data: {
	                    contentGuid: content.id,
	                    menuId: "menuGeoContext",
	                    rootPath: pli.global.config.rootPath,
	                    multipleSelection: (content.selectedItems && content.selectedItems.length > 1) // If multiple selection, display only "Add to Project" option
	                }
	            };
	        },
	        click: function (menuItem, content) { onItemCommand(content, menuItem.name()); }
	    });
	}
	
	
	//-------------------------------------------
	// Creates contactsWithGroups to pass to multiselect
	// ko.observablePliTextBox(null, pli.config.entityRegistry.contactsWithGroups, "multiselect");
	function buildContactsWithGroups() {
	
	    function ContactsWithGroups() {
	
	        var picklistObservable = dataCache.getObservable("contact"),
	            data = picklistObservable().data;
	
	        this.picklistData = ko.observable({ data: data });
	
	        // add groups if cache is already loaded
	        if (data) {
	            this._addGroups();
	        }
	
	        // add group on data change
	        picklistObservable.subscribe(ContactsWithGroups.prototype._addGroups, this);
	    }
	
	    //-------------------------------------------
	    // Adds group to contacts pickList
	    ContactsWithGroups.prototype._addGroups = function addGroups() {
	        var pickListData = (dataCache.getObservable("contact")()) ? dataCache.getObservable("contact")().data : null,
	            data,
	            group,
	            usGroup,
	            us = [],
	            notUs = [];
	
	        if (!pickListData || !pickListData.items) {
	            return;
	        }
	
	        data = $.extend(true, {}, pickListData);
	        group = data.items[0].length.toString();
	        usGroup = (data.items[0].length + 1).toString();
	
	        // groups already added
	        if (data.groups[group] && data.groups[usGroup]) {
	            return;
	        }
	
	        data.groups[group] = [{ name: "US" }, { name: "ANYONE BUT US" }];
	        data.groups[usGroup] = [{ name: "US" }];
	
	        $.each(data.items, function (index, value) {
	            if (value[5] === "true") {
	                this[group] = data.groups[group][0].name;
	                this[usGroup] = data.groups[usGroup][0].name;
	                us.push(index);
	            } else {
	                this[group] = data.groups[group][1].name;
	                notUs.push(index);
	            }
	        });
	
	        data.indices[group] = us.concat(notUs);
	        data.indices[usGroup] = us;
	
	        this.picklistData({ data: data });
	    };
	
	    return { picklistData: new ContactsWithGroups(), category: "9" };
	}
	
	
	function buildFilterPicklistData(filterPicklistInfo) {
	
	    function FilterPicklist() {
	
	        var picklistObservable = dataCache.getObservable(filterPicklistInfo.dataCacheId),
	            data = picklistObservable().data;
	
	        this.picklistData = ko.observable({ data: data });
	
	        if (data) {
	            this._filterPicklist();
	        }
	
	        // Filter on data change
	        picklistObservable.subscribe(FilterPicklist.prototype._filterPicklist, this);
	    }
	
	    //-------------------------------------------
	    // Filter the picklist based on isGroup property
	    FilterPicklist.prototype._filterPicklist = function filterPicklistData() {
	        var plData = (dataCache.getObservable(filterPicklistInfo.dataCacheId)()) ? dataCache.getObservable(filterPicklistInfo.dataCacheId)().data : null;
	
	        if (!plData || !plData.items) {
	            return;
	        }
	
	        var filteredData = ko.utils.arrayFilter(plData.items, filterPicklistInfo.applyFilter);
	
	        var plDataClone = R.clone(plData);
	
	        // Update the items, count and name
	        plDataClone.items = filteredData;
	        plDataClone.count = filteredData.length;
	        plDataClone.name = filterPicklistInfo.displayName;
	
	        this.picklistData({ data: plDataClone, name: filterPicklistInfo.name });
	    };
	
	    return new FilterPicklist();
	}
	
	
	//-------------------------------------------
	function fillOwnerCompanyNames(o, isSingleSelect) {
	    var picklistContact = dataCache.get("contact");
	
	    picklistContact
	        .done(function (picklistData) {
	            var data = picklistData.data,
	                ownerCompanies,
	                ownerCompanyNames;
	
	            if (!data || !data.items) {
	                return;
	            }
	
	            ownerCompanies = ko.utils.arrayFilter(data.items, function (item) {
	                return (item[5]); // IsOwner property
	            });
	
	            if (isSingleSelect) {
	                o.load(ownerCompanies.length === 1 ? ownerCompanies[0][0] : null); // load null if owner companies more than 1
	            } else {
	
	                ownerCompanyNames = ko.utils.arrayMap(ownerCompanies, function (company) {
	                    return company[0]; // Company code property
	                });
	                o.load(ownerCompanyNames);
	            }
	        });
	}
	
	//-------------------------------------------
	function setCategoryGroup(o, picklistType, categoryGroupNames) {
	    var picklist = dataCache.get(picklistType);
	
	    picklist
	        .done(function (picklistData) {
	            var data = picklistData.data,
	                categoryGroupItems,
	                categoryCodes;
	
	            if (!data || !data.items) {
	                return;
	            }
	
	            categoryGroupItems = ko.utils.arrayFilter(data.items, function (item) {
	                return (categoryGroupNames.indexOf(item[2]) > -1); // Filter category
	            });
	
	            categoryCodes = ko.utils.arrayMap(categoryGroupItems, function (item) {
	                return item[0]; // Code property
	            });
	
	            o.load(categoryCodes);
	        });
	
	    return picklist;
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Public
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	registry = {
	
	    //-------------------------------------------
	    acquisitionMethod: buildPicklistOpen({ dataCacheId: "acquisitionMethod", type: "Acquisition Method", typeId: "8b9db083-9b2a-4377-b1e3-fb9fa7030954" }),
	
	    //-------------------------------------------
	    amendmentType: buildPicklistOpen({ dataCacheId: "amendmentType", type: "Amendment Type", typeId: "49a9aeb1-cfda-4af9-92db-ddad7577e847" }),
	
	    //-------------------------------------------
	    area: { // create/edit are assigned via AreaViewModel.js
	        icon: { small: "sprite-editDocument-16" },
	        open: { remove: deleteActionHandler },
	        type: "Area",
	        typeId: "0871C209-E3AD-4D07-995F-CF468556EC15"
	    },
	
	    //-------------------------------------------
	    businessArea: buildPicklistOpen({ dataCacheId: "businessArea", type: "Business Area", displayName: "Business Area" }),
	
	    //-------------------------------------------
	    contact: { // create/edit are assigned via ContactViewModel.js
	        icon: { small: "sprite-editDocument-16" },
	        open: { remove: deleteActionHandler },
	        type: "Contact",
	        typeId: "4B1ADE3C-DB6C-4EDA-80DE-B014A6E9EEAB"
	    },
	
	    contactsWithGroups: buildContactsWithGroups(),
	
	    //-------------------------------------------
	    contract: {
	        open: {
	            create: createNavigableWindowOpener("~~/Contract", null, 1035, null, "contract-"),
	            context: showContext,
	            edit: createNavigableWindowOpener("~~/Contract", null, 1035, null, "contract-"),
	            print: buildDocumentPrintHandler("ContractAbstract"),
	            remove: deleteActionHandler,
	            addToProject: buildAddToProjectWindowHandler()
	        },
	        icon: {
	            small: "sprite-forms-16",
	            medium: "sprite-forms-32"
	        },
	        type: "Contract",
	        typeId: "4D07D189-AEBA-4261-97DF-A6E05E824A21",
	        createHint: "Enter a unique contract file number",
	        createFileNumberHint: "e.g. C0042 (required)"
	    },
	
	    //-------------------------------------------
	    contractSplit: {
	        icon: { small: "sprite-split-16" },
	        open: { edit: buildSearchResultOpener({ width: 1035 }) }
	    },
	
	    //-------------------------------------------
	    contractSplitLand: {
	        icon: { small: "sprite-land-16" },
	        open: { edit: buildSearchResultOpener({ width: 1035 }) }
	    },
	
	    //-------------------------------------------
	    contractStatus: buildPicklistOpen({ dataCacheId: "contractStatus", type: "Contract Status", hasCategory: true, categoryName: "documentStatusCategory", typeId: "587a4437-abbb-4182-a9f7-cd6daa57e222" }),
	
	    //-------------------------------------------
	    contractTerm: buildPicklistOpen({ dataCacheId: "contractTerm", type: "Contract Term", displayName: "Contract Term", typeId: "bf28092c-8459-47ba-ac22-225806d4fcdf" }),
	
	    //-------------------------------------------
	    contractType: buildPicklistOpen({ dataCacheId: "contractType", type: "Contract Type", displayName: "Contract Type", typeId: "004b7911-ecfe-43a4-a877-55d225e60178" }),
	
	    //-------------------------------------------
	    country: buildPicklistOpen({ dataCacheId: "country", type: "Country", typeId: "37ba304e-890b-4ce8-824b-5d39ed6b35bf" }),
	
	    //-------------------------------------------
	    exports: {
	        displayName: "Export",
	        icon: { small: "sprite-export-16" },
	        open: { edit: buildReportOpener(reportDefaults) },
	        typeId: "54099717-10AD-4F94-AA0B-FB27C63C3228"
	    },
	
	    //-------------------------------------------
	    externalContractType: buildPicklistOpen({ dataCacheId: "externalContractType", type: "External Contract Type", displayName: "External Contract Type", typeId: "6b38f2aa-25f4-44a9-b4ee-dba860aeba13" }),
	
	    //-------------------------------------------
	    favorites: {
	        displayName: "Favorite",
	        open: {
	            addToProject: buildAddToProjectWindowHandler()
	        }
	    },
	
	    //-------------------------------------------
	    file: {
	        icon: { small: "sprite-editDocument-16" },
	        open: {
	            edit: buildSearchResultOpener({ width: 1035 }),
	            upload: function (splitId) {
	                return pli.dialog.open({
	                    targetUrl: "~~/fileupload/".concat(splitId),
	                    width: 611,
	                    height: 480,
	                    windowType: "modal"
	                });
	            }
	        }
	    },
	
	    //-------------------------------------------
	    formation: {
	        open: function (suffix) {
	            var targetUrl = "http://formationfinder.com/";
	
	            if (suffix) {
	                targetUrl += suffix;
	            }
	
	            pli.dialog.open({ targetUrl: targetUrl, width: 1000, height: 700, windowType: "window", resizable: true });
	        }
	    },
	
	    //-------------------------------------------
	    // Remark: Use this instead of the one in datacache as this one remove the "None" item
	    fromZoneQualifier: buildFilterPicklistData({ dataCacheId: "fromZoneQualifier", displayName: "From Qualifier", name: "fromZoneQualifier", applyFilter: function (item) { return (item[0] !== "None"); } }),
	
	    //-------------------------------------------
	    help: {
	        show: function (options) {
	            if (!options || typeof options === "string") {
	                options = {
	                    url: options
	                };
	            }
	            pli.dialog.open({
	                targetUrl: options.url || pli.global.resolveUrl("~/Support/GeoNexus"),
	                windowType: "window",
	                top: 5,
	                left: 5
	            });
	        },
	        type: "Help"
	    },
	
	    //-------------------------------------------
	    imports: {
	        displayName: "Import",
	        icon: { small: "sprite-import-16" },
	        open: { edit: buildReportOpener(reportDefaults) },
	        typeId: "8D396E3D-71FA-4120-B3C4-F02BE7D5889C"
	    },
	
	    //-------------------------------------------
	    interestType: buildPicklistOpen({ dataCacheId: "interestType", type: "Interest Type", hasCategory: true, categoryName: "interestTypeCategory", typeId: "707fd7b9-39d4-4cc6-bdc7-14cfa12de60e" }),
	
	    //-------------------------------------------
	    leaseStatus: buildPicklistOpen({ dataCacheId: "leaseStatus", type: "Lease Status", hasCategory: true, categoryName: "documentStatusCategory", typeId: "3eb4a639-7b0a-46e4-96b6-d800f9740f83" }),
	
	    //-------------------------------------------
	    legacy: {
	        getDialogLoader: function getDialogLoader(url, sourceId) {
	            /// <summary>
	            /// </summary>
	
	            var base = url, sourceIdRegex = new RegExp("".concat(sourceId).concat("\/?"), "i");
	
	            // remove source guid (it could change)
	            base = base.replace(sourceIdRegex, "");
	
	            // append leading slash
	            if (base.substr(0, 1) !== "/") {
	                base = "/".concat(base);
	            }
	
	            // append trailing slash
	            if (base.substr(base.length - 1) !== "/") {
	                base = base.concat("/");
	            }
	
	            return function loader(id, type, targetId, width, height, navItemToSelect) {
	                var result = base;
	                result = result.concat(id).concat("/").concat(type);
	                if (typeof targetId === "string" && targetId.length === 36) {
	                    result = result.concat("/").concat(targetId);
	                }
	                return pli.dialog.open({
	                    width: (typeof width === "number" ? width : 625),
	                    height: (typeof height === "number" ? height : 545),
	                    resizable: true,
	                    windowType: "modal",
	                    dialogId: "".concat(type).concat("-").concat(targetId || "new"),
	                    useLoader: false,
	                    targetUrl: result,
	                    navItem: navItemToSelect
	                });
	            };
	        }
	    },
	
	    //-------------------------------------------
	    legalDescription: {
	        open: {
	            addToProject: buildAddToProjectWindowHandler()
	        }
	    },
	
	    //-------------------------------------------
	    mineralLease: {
	        open: {
	            create: createNavigableWindowOpener("~~/MineralLease", null, 1035, null, "mineralLease-"),
	            context: showContext,
	            edit: createNavigableWindowOpener("~~/MineralLease", null, 1035, null, "mineralLease-"),
	            print: buildDocumentPrintHandler("MineralLeaseAbstract"),
	            remove: deleteActionHandler,
	            addToProject: buildAddToProjectWindowHandler()
	        },
	        icon: {
	            small: "sprite-mineralLease-16",
	            medium: "sprite-mineralLease-32"
	        },
	        type: "Mineral Lease",
	        typeId: "F22F76ED-99AE-4814-8FD7-4FAAE46FD8A9",
	        createHint: "Enter a unique mineral lease file number",
	        createFileNumberHint: "e.g. L0042 (required)"
	    },
	
	    //-------------------------------------------
	    mineralLeaseSplit: {
	        icon: { small: "sprite-split-16" },
	        open: { edit: buildSearchResultOpener({ width: 1035 }) }
	    },
	
	    //-------------------------------------------
	    mineralLeaseSplitLand: {
	        icon: { small: "sprite-land-16" },
	        open: { edit: buildSearchResultOpener({ width: 1035 }) }
	    },
	
	    //-------------------------------------------
	    mineralLeaseType: buildPicklistOpen({ dataCacheId: "mineralLeaseType", type: "Mineral Lease Type", typeId: "bca9c498-327a-4250-aee7-8ca54ef40e9b" }),
	
	    //-------------------------------------------
	    obligationType: buildPicklistOpen({ dataCacheId: "obligationType", type: "Obligation Type", typeId: "5ada76db-faaf-4351-9d21-ced7b2965e80" }),
	
	    //-------------------------------------------
	    organizationalLevel: buildPicklistOpen({ dataCacheId: "organizationalLevel", type: "Organizational Level", displayName: "Organizational Level" }),
	
	    //-------------------------------------------
	    // NOTE: This is temporary to set the "US" group for company picklist until
	    // https://github.com/pandell/web-pli/issues/11 is resolved
	    fillOwnerCompanies: fillOwnerCompanyNames,
	
	    //-------------------------------------------
	    payorPayee: {
	        open: {
	            addToProject: buildAddToProjectWindowHandler()
	        }
	    },
	
	    //-------------------------------------------
	    personResponsible: buildPicklistOpen({ dataCacheId: "personResponsible", type: "Person Responsible", typeId: "96431a88-2213-4f98-a7da-94b4cab86635" }),
	
	    //-------------------------------------------
	    position: buildPicklistOpen({ dataCacheId: "position", type: "Position", displayName: "Position" }),
	
	    //-------------------------------------------
	    project: {
	        open: {
	            create: createNavigableWindowOpener("~~/Project", null, 1035, null, "project-"),
	            context: showContext,
	            edit: createNavigableWindowOpener("~~/Project", null, 1035, null, "project-"),
	            print: projectPrintHandler,
	            printers: {
	                Summary: buildDocumentPrintHandler("ProjectSummary"),
	                MineralLeaseAbstracts: buildDocumentPrintHandler("ProjectMineralLeaseAbstract"),
	                WellAbstracts: buildDocumentPrintHandler("ProjectWellAbstract"),
	                ContractAbstracts: buildDocumentPrintHandler("ProjectContractAbstract"),
	                SurfaceLeaseAbstracts: buildDocumentPrintHandler("ProjectSurfaceLeaseAbstract")
	            },
	            remove: deleteActionHandler
	        },
	        icon: {
	            small: "sprite-project-16",
	            medium: "sprite-project-32"
	        },
	        type: "Project",
	        typeId: "E6964647-EB54-4D8F-B313-B281B12A2400"
	    },
	
	    //-------------------------------------------
	    provinceState: { // create/edit are assigned via ProvinceStateViewModel.js
	        icon: { small: "sprite-editDocument-16" },
	        open: { remove: deleteActionHandler },
	        type: "Province-State",
	        typeId: "0DE9688C-8931-4971-9F31-67B3611298A6"
	    },
	
	    //-------------------------------------------
	    provisionCriteria: {
	        open: function () {
	            pli.dialog.open({ targetUrl: "~~/Reports/ProvisionSearchExport", width: reportDefaults.width, height: reportDefaults.height, windowType: "window" });
	        }
	    },
	
	    //-------------------------------------------
	    provisionType: buildPicklistOpen({ dataCacheId: "provisionType", type: "Provision Type", hasCategory: true, categoryName: "provisionTypeCategory" }),
	
	    //-------------------------------------------
	    recentlyRun: {
	        displayName: "Recently Run",
	        icon: { small: "sprite-clock-16" },
	        open: {
	            edit: function (value) {
	                pli.download(value.data.fileId);
	            }
	        },
	        type: "Recently Run",
	        typeId: "26026E42-AE38-4791-8918-94C9171C5931"
	    },
	
	    //-------------------------------------------
	    reports: {
	        displayName: "Report",
	        icon: { small: "sprite-report-16" },
	        open: { edit: buildReportOpener(reportDefaults) },
	        typeId: "C66D5053-80CE-4C71-8858-29ACBFC8B192"
	    },
	
	    //-------------------------------------------
	    right: {
	        open: {
	            addToProject: buildAddToProjectWindowHandler()
	        }
	    },
	
	    //-------------------------------------------
	    rightsProduct: buildPicklistOpen({ dataCacheId: "rightsProduct", type: "Rights Product", typeId: "066301a4-ceaa-4d6d-bf28-45b1156647eb" }),
	
	
	    //-------------------------------------------
	    rightsProductBase: buildFilterPicklistData({ dataCacheId: "rightsProduct", displayName: "Rights Product Base", name: "rightsProductBase", applyFilter: function (item) { return (item[2] !== "true"); } }),
	
	
	    //-------------------------------------------
	    royaltyType: buildPicklistOpen({ dataCacheId: "royaltyType", type: "Royalty Type", typeId: "c1d3bb41-01c0-41d3-8499-121d114d4f64" }),
	
	    //-------------------------------------------
	    savedPresets: {
	        displayName: "Saved Presets",
	        icon: { small: "sprite-save-16" },
	        open: {
	            edit: createReportCriteriaWindowOpener(reportDefaults.width, reportDefaults.height, "~~/Reports", "reports-"),
	            remove: deleteActionHandler
	        },
	        type: "Saved Presets",
	        typeId: "741EB758-E34E-42F3-A6DF-5A947D631C03"
	    },
	
	    //-------------------------------------------
	    searchAll: {
	        open: {
	            remove: deleteActionHandler,
	            addToProject: buildAddToProjectWindowHandler()
	        }
	    },
	
	    //-------------------------------------------
	    setCategoryGroup: setCategoryGroup,
	
	    //-------------------------------------------
	    setting: { // create/edit are assigned via settingsViewModel.js
	        icon: { small: "sprite-configure-16" },
	        open: { },
	        type: "Setting",
	        typeId: "314534F6-5A7E-43ED-A6E2-56C44E7B6CB1"
	    },
	
	    //-------------------------------------------
	    splitStatus: buildPicklistOpen({ dataCacheId: "splitStatus", type: "Split Status", hasCategory: true, categoryName: "splitStatusCategory", typeId: "901FB8AC-5C88-4CC6-8BC3-8138F0D0C57F" }),
	
	    //-------------------------------------------
	    surfaceLease: {
	        open: {
	            create: createNavigableWindowOpener("~~/SurfaceLease", null, 1035, null, "surfaceLease-"),
	            context: showContext,
	            edit: createNavigableWindowOpener("~~/SurfaceLease", null, 1035, null, "surfaceLease-"),
	            print: buildDocumentPrintHandler("SurfaceLeaseAbstract"),
	            remove: deleteActionHandler,
	            addToProject: buildAddToProjectWindowHandler()
	        },
	        icon: {
	            small: "sprite-surfaceLease-16",
	            medium: "sprite-surfaceLease-32"
	        },
	        type: "Surface Lease",
	        typeId: "9FA4C840-49AD-408A-AC0F-198DF04B9596",
	        createHint: "Enter a unique surface lease file number",
	        createFileNumberHint: "e.g. E0042 (required)"
	    },
	
	    //-------------------------------------------
	    surfaceLeaseSplit: {
	        icon: { small: "sprite-split-16" },
	        open: { edit: buildSearchResultOpener({ width: 1035 }) }
	    },
	
	    //-------------------------------------------
	    surfaceLeaseSplitLand: {
	        icon: { small: "sprite-land-16" },
	        open: { edit: buildSearchResultOpener({ width: 1035 }) }
	    },
	
	    //-------------------------------------------
	    surfaceLeaseType: buildPicklistOpen({ dataCacheId: "surfaceLeaseType", type: "Surface Lease Type", hasCategory: true, categoryName: "surfaceLeasetypeCategory", typeId: "4f2779d0-aec6-4df0-ae84-3d1cfa337eae" }),
	
	    //-------------------------------------------
	    titleEventType: buildPicklistOpen({ dataCacheId: "titleEventType", displayName: "Title Event Type", type: "Title Event Type", typeId: "a29af8e6-8a8d-4c5c-b9aa-8d1807e9111c" }),
	
	    //-------------------------------------------
	    // Remark: Use this instead of the one in datacache as this one remove the "None" item
	    toZoneQualifier: buildFilterPicklistData({ dataCacheId: "toZoneQualifier", displayName: "To Qualifier", name: "toZoneQualifier", applyFilter: function (item) { return (item[0] !== "None"); } }),
	
	    //-------------------------------------------
	    user: {
	        icon: { small: "sprite-formalUserBlue-16" },
	        open: {
	            create: createNavigableWindowOpener("~~/user", null, 1035, null, "user-"),
	            edit: createNavigableWindowOpener("~~/user", null, 1035, null, "user-")
	        },
	        typeId: "304F56E7-CBB4-49AA-8113-1EA6A4650396",
	        type: "User"
	    },
	
	    //-------------------------------------------
	    well: {
	        open: {
	            create: createNavigableWindowOpener("~~/Well", null, 1035, null, "well-"),
	            context: showContext,
	            edit: createNavigableWindowOpener("~~/Well", null, 1035, null, "well-"),
	            print: buildDocumentPrintHandler("WellAbstract"),
	            remove: deleteActionHandler,
	            addToProject: buildAddToProjectWindowHandler()
	        },
	        icon: {
	            small: "sprite-well-16",
	            medium: "sprite-well-32"
	        },
	        type: "Well",
	        typeId: "181296AD-1A78-4DDA-BDFF-F54D188B95EB"
	    },
	
	    //-------------------------------------------
	    wellStatus: { // create/edit are assigned via WellStatusViewModel.js
	        icon: { small: "sprite-editDocument-16" },
	        open: { remove: deleteActionHandler },
	        type: "Well Status",
	        typeId: "D2BFB20B-6048-4612-9026-F963E3979721"
	    },
	
	    //-------------------------------------------
	    wellType: buildPicklistOpen({ dataCacheId: "wellType", type: "Well Type", typeId: "8bb06972-3d0d-4257-abb1-472f7f91919e" }),
	
	    //-------------------------------------------
	    wiPartner: {
	        open: {
	            addToProject: buildAddToProjectWindowHandler()
	        }
	    },
	
	    //-------------------------------------------
	    zone: buildPicklistOpen({ dataCacheId: "zone", type: "Zone", typeId: "1c29f243-f22a-4106-9c8a-4fb431523f36" }),
	
	    //-------------------------------------------
	    zoneBase: buildFilterPicklistData({ dataCacheId: "zone", displayName: "Zone Base", name: "zoneBase", applyFilter: function (item) { return (item[2] !== "true"); } })
	
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = pli.config.entityRegistry = registry;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(495);


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	var picklistBehaviour = __webpack_require__(25);
	
	var dataCache = __webpack_require__(488);
	var dependentRequiredBehaviour = __webpack_require__(496);
	var picklistItemExtensions = __webpack_require__(498);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// PicklistItemViewModel
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function PicklistItemViewModel(form) {
	    this.initPicklistItem("Geo-PicklistItem-", form);
	
	    // initialize properties (non-serialized)
	    this.extras.categoryData = ko.observable();
	    this.extras.hasCategory = ko.observable(false);
	    this.extras.typeDisplayName = ko.observable();
	
	    // initialize properties (serialized)
	    this.code = this.id = pliObservable(null, null, "required");
	    this.description = pliObservable();
	    this.category = pliObservable(null, { trigger: this.extras.hasCategory, expectedValue: true, picklistData: this.extras.categoryData }, picklistBehaviour, dependentRequiredBehaviour);
	    this.type = ko.observable();
	
	    this.extras.displayName = ko.computed(PicklistItemViewModel.prototype._computeDisplayName, this);
	}
	
	
	//-------------------------------------------
	PicklistItemViewModel.prototype.load = function loadPicklistItem(record) {
	    record = record || {};
	
	    // clean-up category subscription
	    if (this.extras._categorySubscription && this.extras._categorySubscription.dispose) {
	        this.extras._categorySubscription.dispose();
	        this.extras._categorySubscription = null;
	    }
	
	    // initialize category
	    if (record.categoryName) {
	        var o = dataCache.getObservable(record.categoryName);
	        this.extras._categorySubscription = o.subscribe(PicklistItemViewModel.prototype._updateCategory, this);
	        this._updateCategory(o());
	        this.extras.hasCategory(true);
	    } else {
	        this.extras.categoryData(null);
	        this.extras.hasCategory(false);
	    }
	
	    this.code.reset();
	    this.description.reset();
	    this.category.reset();
	
	    // initialize picklist item data
	    this.guid(record.guid || null);
	    this.code.load(record.code);
	    this.description.load(record.description);
	    this.category.load(record.category);
	    this.type(record.type || null);
	    this.extras.typeDisplayName(record.typeDisplayName || null);
	};
	
	
	//-------------------------------------------
	PicklistItemViewModel.prototype._computeDisplayName = function computePicklistItemDisplayName() {
	    var id = this.id(), typeDisplayName = this.extras.typeDisplayName();
	    return (id ? "".concat(typeDisplayName).concat(" ").concat(id) : "(No code yet)");
	};
	
	
	//-------------------------------------------
	PicklistItemViewModel.prototype._updateCategory = function updatePicklistItemCategory(value) {
	    this.extras.categoryData(value);
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	var picklistItemForm = pli.forms.registry.picklistItemForm;
	
	if (typeof picklistItemForm !== "object") { throw new Error("Picklist item form element could not be found - did you render it using CreatePicklistItemForm?"); }
	if (picklistItemForm.viewModel) { throw new Error("Picklist item form has already been initialized"); }
	
	ko.utils.extend(PicklistItemViewModel.prototype, picklistItemExtensions.mixins);
	picklistItemForm.viewModel = new PicklistItemViewModel(picklistItemForm);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = PicklistItemViewModel;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(497);


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	var pliObservable = __webpack_require__(15);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "DependentRequiredBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function DependentRequiredBehaviour() {
	    /// <summary>
	    /// Behaviour ensuring a value is specified
	    /// </summary>
	    this.defer = true;
	}
	
	//-------------------------------------------
	DependentRequiredBehaviour.prototype.validate = function dependentRequiredBehaviourValidate(value) {
	    /// <summary>
	    /// Only validate this observable as required
	    /// if the specified trigger has expected value.
	    /// </summary>
	    var trigger = this.behaviourData && this.behaviourData.trigger;
	    if (ko.isObservable(trigger)) {
	        var currentValue = ko.utils.unwrapObservable(trigger),
	            expectedValue = this.behaviourData && this.behaviourData.expectedValue;
	        if (currentValue === expectedValue) {
	            return pliObservable.behaviours.required.validate(value);
	        }
	    }
	    return null;
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Export
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = new DependentRequiredBehaviour();


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	"use strict";
	
	var busyIndicator = __webpack_require__(499);
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var viewModelInit = __webpack_require__(465);
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// PicklistItemViewModelExtensions
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function PicklistItemViewModelExtensions(apiPrefix, form) {
	
	    // Initialize default properties (serialized)
	    this.guid = ko.observable();
	
	    // Initialize default properties (non-serialized)
	    this.extras = function picklistItemExtras() { return; };
	    this.extras.apiPrefix = apiPrefix;
	    this.extras.apiSave = "".concat(this.extras.apiPrefix).concat("Save");
	    this.extras.apiLoad = "".concat(this.extras.apiPrefix).concat("Load");
	    this.extras.dirty = ko.dirtyFlag(this);
	    this.extras.form = form;
	    this.extras.message = ko.observable();
	    this.extras.state = ko.observable("ready");
	
	    // Initialize default actions
	    this.close = PicklistItemViewModelExtensions.prototype.close.bind(this);
	    this.open = PicklistItemViewModelExtensions.prototype.open.bind(this);
	    this.save = PicklistItemViewModelExtensions.prototype.save.bind(this);
	    this.handleEnter = PicklistItemViewModelExtensions.prototype.handleEnter.bind(this);
	
	    // private actions
	    this._applyValidationErrors = PicklistItemViewModelExtensions.prototype._applyValidationErrors.bind(this);
	    this._processSaveResponse = PicklistItemViewModelExtensions.prototype._processSaveResponse.bind(this);
	    this._processLoadResponse = PicklistItemViewModelExtensions.prototype._processLoadResponse.bind(this);
	    this._validateDeep = PicklistItemViewModelExtensions.prototype._validateDeep.bind(this);
	
	    // Initialize default keymap
	    pli.keys.registerKeymap(form.id, ko.utils.extend(
	        ko.utils.extend({}, pli.config.defaultKeymap),
	        {
	            "Accept": this.handleEnter,
	            "Save": this.save,
	            "Close": this.close
	        }
	    ));
	    form.page.keymap = form.id;
	}
	
	
	//-------------------------------------------
	PicklistItemViewModelExtensions.prototype.close = function closePicklistItem(force) {
	    /// <summary>
	    /// Closes a picklist form if the form is
	    /// not busy (unless forced).
	    /// </summary>
	    if (force || this.extras.state() !== "busy") { pli.forms.close(this.extras.form.id); }
	    return false; // prevent default behaviour
	};
	
	
	//-------------------------------------------
	PicklistItemViewModelExtensions.prototype.open = function openPicklistItem(settings) {
	    /// <summary>
	    /// Opens a picklist form with the data
	    /// specified.
	    /// </summary>
	
	    // load/reset view model properties.
	    this.extras.dirty.reset();
	    this.extras.message("Details");
	    this.extras.state("ready");
	
	    // Load details from cache
	    // Add logic to extract the array of array from multi-select picklist
	    // There are currently 3 forms of data structure that come in opening a picklist item
	    // 1) settings.data = from opening a custom picklist on the main landing page (ie. Area picklist)
	    // 2) settings[0] = from opening a custom picklist in a document by selecting a picklist item and clicking "Open Selected"
	    // 3) settings = from opening a generic picklist on the main landing page (ie. Acquisition Method)
	    //
	    // NOTE: settings.data no longer is passed in as an array but it is now a record.  No need to convert array to record
	    // in majority of the 'fromCacheItem' call.
	    var data = (typeof this.fromCacheItem === "function")
	        ? this.fromCacheItem((settings && (settings[0] || settings.data)) || settings)
	        : ((settings && settings.data) || settings);
	
	    if (typeof this.load === "function") {
	        this.extras.dirty.suspend();
	        this.load(data);
	        this.extras.dirty.resume(true);
	    }
	
	    // bind the form if it is not already
	    if (!this.isBound) {
	        ko.applyBindings(this, this.extras.form.$form[0]);
	        this.isBound = true;
	    }
	
	    // show the inline form
	    pli.forms.open(this.extras.form.id);
	
	    if (this.extras.state() === "loading" && this.guid()) {
	        busyIndicator.open({
	            title: "Loading, please wait..."
	        });
	
	        pli.call({
	            name: this.extras.apiLoad,
	            jsonData: JSON.stringify({ id: this.guid() })
	        }).always(this._processLoadResponse);
	    }
	
	    return false;// prevent default behaviour
	};
	
	
	PicklistItemViewModelExtensions.prototype.handleEnter = function saveIfNotInTextArea(event) {
	    /// <summary>
	    /// Handle submission of picklist editor as a result of the enter key.
	    /// Calls save if we are not in a textarea or multiselect picklist
	    /// (to allow enter in these boxes).
	    /// </summary>
	    if (document.activeElement.type !== "textarea" && document.activeElement.className !== "ms-input") {
	        this.save();
	    }
	    event.stopPropagation();
	};
	
	
	//-------------------------------------------
	PicklistItemViewModelExtensions.prototype.save = function savePicklistItem() {
	    /// <summary>
	    /// Handle submission of default picklist editor dialog
	    /// (ENTER key or 'Save' button click).
	    /// </summary>
	    var state = this.extras.state();
	    if ((state ===  "ready" || state === "fail") && this.extras.dirty()) {
	        if (this._validateDeep()) {
	            if (this.useSaveDialog) {
	                busyIndicator.open({
	                    title: "Saving, please wait..."
	                });
	            } else {
	                this.extras.state("busy");
	                this.extras.message("Saving, please wait...");
	            }
	            pli.call({
	                name: this.extras.apiSave,
	                jsonData: this.extras.dirty.currentJSON()
	            }).always(this._processSaveResponse);
	        } else {
	            this.extras.state("fail");
	            this.extras.message("Saving failed.");
	            this.extras.form.$form.resetPopupFocus();
	        }
	    }
	
	    return false;
	};
	
	
	//-------------------------------------------
	PicklistItemViewModelExtensions.prototype._applyValidationErrors = viewModelInit.applyValidationErrors;
	
	
	//-------------------------------------------
	PicklistItemViewModelExtensions.prototype._processLoadResponse = function processPicklistLoadResponse(response) {
	    /// <summary>
	    /// Process server-side response to the load PLI call (both success
	    /// and failure responses will arrive here).
	    /// </summary>
	    if (response.isError) {
	        if (window.console) { window.console.warn("Picklist item loading failed:", this, response); }
	        var r = response.result;
	        var message = (r && r.message) || "Unable to load picklist item";
	        this.extras.state("fail");
	        this.extras.message(message);
	        this._applyValidationErrors(r && r.validationErrors);
	        this.extras.form.$form.resetPopupFocus();
	        busyIndicator.complete({
	            failed: true,
	            message: message,
	            title: "Unable to load picklist item",
	            onClosed: this.close
	        });
	    } else {
	        if (window.console) { window.console.log("Picklist item loading succeeded", response); }
	
	        this.extras.dirty.suspend();
	        this.load(response.result);
	        this.extras.dirty.resume(true);
	
	        busyIndicator.close({ force: true });
	        this.extras.state("ready");
	    }
	};
	
	
	//-------------------------------------------
	PicklistItemViewModelExtensions.prototype._processSaveResponse = function processPicklistSaveResponse(response) {
	    /// <summary>
	    /// Process server-side response to the
	    /// save PLI call (both success
	    /// and failure responses will arrive here).
	    /// </summary>
	    if (response.isError) {
	        if (window.console) { window.console.warn("Picklist item saving failed:", this, response); }
	        var r = response.result;
	        var message = (r && r.message) || "Unable to save picklist item";
	        this.extras.state("fail");
	        this.extras.message(message);
	        this._applyValidationErrors(r && r.validationErrors);
	        this.extras.form.$form.resetPopupFocus();
	        busyIndicator.close({ force: true });
	    } else {
	        if (window.console) { window.console.log("Picklist item saving succeeded", response); }
	        busyIndicator.close({ force: true });
	        this.close(true);
	    }
	};
	
	
	//-------------------------------------------
	PicklistItemViewModelExtensions.prototype._validateDeep = viewModelInit.validateDeep;
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = {
	    mixins: { initPicklistItem: PicklistItemViewModelExtensions }
	};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	var pli = __webpack_require__(380);
	
	if (typeof pli.forms.registry.busyIndicator !== "object") {
	    throw new Error("Form busyIndicator has not been registered in Pli.forms.registry (did you call CreateBusyIndicatorForm?)");
	}
	
	module.exports = __webpack_require__(500);
	


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*jslint todo: true */
	"use strict";
	
	// Display busy indicator dialog (and an
	// eventual error, if any) on any form.
	
	var ko = __webpack_require__(9);
	__webpack_require__(458);
	
	var pli = __webpack_require__(380);
	
	
	// TODO: Refactor this so that it can be used outside of forms
	//  -> Allow methods to accept 'form' as a parameter (defaults to busyIndicatorForm)
	//  -> Accept 'form' in BusyIndicatorViewModel constructor, pass to open|close|complete
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// BusyIndicatorViewModel class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// View-model object for busy indicator dialog
	// (must be instantiated using 'new').
	function BusyIndicatorViewModel() {
	    this.state = ko.observable("init").subscribeTo("state", true); // true => initializeWithLatestValue
	    this.completed = ko.observable(0); // 0 for not completed, 1 for completed successfully, 2 for completed with failure
	    this.message = ko.observable("");
	    this.title = ko.observable("");
	    this.icon = ko.observable("sprite-save-16");
	    this.closeFocused = ko.observable(false);
	    this.onClosed = [];
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Local
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	var busyIndicatorForm; // shortcut for Pli.forms.registry.busyIndicator
	
	
	//-------------------------------------------
	function closeBusyIndicator(options) {
	    /// <summary>
	    /// Close busy form using the specified options
	    /// (dialog is hidden). If open/complete method
	    /// specified an options.onClosed function,
	    /// it will be called now (after the form
	    /// is closed successfully).
	    /// </summary>
	    /// <param name="options">
	    /// A JavaScript object (set of key/value pairs)
	    /// that configures close behaviour.
	    /// <para>force (optional) - Flag indicating
	    /// whether close should be forced. If false,
	    /// close calls will be ignored if complete
	    /// was not called first. If not specified,
	    /// defaults to false.</para>
	    /// <para>state (optional) - State to publish
	    /// to "state" postbox topic as soon as the
	    /// dialog is closed. If not specified,
	    /// defaults to state that was active
	    /// when open method was called
	    /// (restores original state).</para>
	    /// </param>
	    var i, l, m = busyIndicatorForm.viewModel;
	    if (!m || !m.stateOnOpen) { return false; } // reject calls on inactive busy indicator
	
	    if (!options) { options = {}; }
	    if (!m.completed() && !options.force) { return false; } // reject calls if incomplete
	
	    pli.forms.close("busyIndicator");
	    ko.postbox.publish("state", options.state || m.stateOnOpen);
	    delete m.stateOnOpen;
	    if (m.onClosed.length) {
	        for (i = 0, l = m.onClosed.length; i < l; i += 1) {
	            m.onClosed[i].call(busyIndicatorForm);
	        }
	        m.onClosed.length = 0;
	    }
	
	    return false;
	}
	
	
	//-------------------------------------------
	function completeBusyIndicator(options) {
	    /// <summary>
	    /// Switch busy form to 'succeeded' or 'failed'
	    /// mode (still visible, but shows status
	    /// bar with caller-specified message;
	    /// user must dismiss the dialog by clicking
	    /// close button or pressing ESC key).
	    /// </summary>
	    /// <param name="options">
	    /// A JavaScript object (set of key/value pairs)
	    /// that configures complete behaviour.
	    /// <para>failed (optional) - Flag indicating
	    /// whether operation failed (true) or
	    /// succeeded (false). If not specified,
	    /// defaults to false (i.e. assumes operation
	    /// succeeded).</para>
	    /// <para>message (optional) - Message to show
	    /// in dialog content area. If not specified,
	    /// defaults to either "Unspecified error" or
	    /// "Completed successfully" depending
	    /// on options.failed value.</para>
	    /// <para>title (optional) - Title of dialog
	    /// that will be shown. If not specified,
	    /// defaults to either "Operation failed" or
	    /// "Operation succeeded" depending
	    /// on options.failed value.</para>
	    /// <para>state (optional) - State to publish
	    /// to "state" postbox topic. If not specified,
	    /// defaults to either "busy.fail" or "busy.done"
	    /// depending on options.failed value.</para>
	    /// <para>onClosed (optional) - Function to call
	    /// when the dialog is closed.</para>
	    /// </param>
	    var success, m = busyIndicatorForm.viewModel;
	    if (!m || !m.stateOnOpen) { return false; } // reject calls on inactive busy indicator
	
	    if (!options) { options = {}; }
	
	    success = !options.failed;
	    m.completed(success ? 1 : 2);
	    m.title(options.title || (success ? "Operation succeeded" : "Operation failed"));
	    m.message(options.message || (success ? "Completed successfully" : "Unspecified error"));
	    ko.postbox.publish("state", options.state || (success ? "busy.done" : "busy.fail"));
	    m.closeFocused(true);
	    if (typeof options.onClosed === "function") {
	        m.onClosed.push(options.onClosed);
	    }
	    return false;
	}
	
	
	//-------------------------------------------
	function openBusyIndicator(options) {
	    /// <summary>
	    /// Show busy form using the specified options.
	    /// (dialog is shown).
	    /// </summary>
	    /// <param name="options">
	    /// A JavaScript object (set of key/value pairs)
	    /// that configures open behaviour.
	    /// <para>message (optional) - Message to show
	    /// in dialog content area. If not specified,
	    /// defaults to "Please wait...".</para>
	    /// <para>title (optional) - Title of dialog
	    /// that will be shown. If not specified,
	    /// defaults to "Operation in progress".</para>
	    /// <para>icon (optional) - Icon next to title
	    /// of dialog that will be shown. If not specified,
	    /// defaults to "sprite-save-16".</para>
	    /// <para>state (optional) - State to publish
	    /// to "state" postbox topic as soon as the
	    /// dialog is shown. If not specified,
	    /// defaults to "busy".</para>
	    /// <para>onClosed (optional) - Function to call
	    /// when the dialog is closed.</para>
	    /// </param>
	    if (!options) { options = {}; }
	
	    var m = busyIndicatorForm.viewModel;
	    if (!m) {
	        BusyIndicatorViewModel.prototype.close = closeBusyIndicator;
	        busyIndicatorForm.viewModel = m = new BusyIndicatorViewModel();
	        ko.applyBindings(m, busyIndicatorForm.$form[0]);
	    }
	
	    m.completed(0);
	    m.icon(options.icon || "sprite-save-16");
	    m.title(options.title || "Operation in progress");
	    m.message(options.message || "Please wait...");
	    m.stateOnOpen = m.state();
	    ko.postbox.publish("state", options.state || "busy");
	    if (typeof options.onClosed === "function") {
	        m.onClosed.push(options.onClosed);
	    }
	    pli.forms.open("busyIndicator", {});
	
	    return false;
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	// define API
	busyIndicatorForm = pli.forms.registry.busyIndicator;
	busyIndicatorForm.close = closeBusyIndicator;
	busyIndicatorForm.complete = completeBusyIndicator;
	busyIndicatorForm.open = openBusyIndicator;
	
	// configure keyboard
	busyIndicatorForm.page.keymap = "busyIndicator";
	pli.keys.registerKeymap("busyIndicator", {
	    "esc": closeBusyIndicator
	});
	
	module.exports = busyIndicatorForm;
	


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	"use strict";
	
	var createBreadcrumbs = __webpack_require__(473);
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var viewModelInit = __webpack_require__(465);
	
	var createFileViewModel = __webpack_require__(502).fileViewModel;
	var createReportCriteriaViewModel = __webpack_require__(509);
	var createUploadViewModelExtras = __webpack_require__(502).uploadViewModelExtras;
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	
	__webpack_require__(511);
	
	//---------------------------------------
	viewModelInit.enableSlideTransitions();
	
	//-------------------------------------------
	function getReportTypeFromUrl() {
	    var pathArray = window.location.pathname.split("/"),
	        id = pathArray[pathArray.length - 1];
	
	    return id;
	}
	
	//-------------------------------------------
	function getReportDescription(reportsData, reportType, o) {
	    var result,
	        data = reportsData.data;
	
	    if (!data || !data.items) {
	        return;
	    }
	
	    result = ko.utils.arrayFirst(data.items, function (item) {
	        return item.type === reportType;
	    });
	
	    if (result && result.description) {
	        o(result.description);
	    }
	}
	
	//-------------------------------------------
	function getReportTitle(reportsData, reportType, o) {
	    var result,
	        data = reportsData.data;
	
	    if (!data || !data.items) {
	        return;
	    }
	
	    result = ko.utils.arrayFirst(data.items, function (item) {
	        return item.type === reportType;
	    });
	
	    if (result && result.name) {
	        o(result.name);
	    }
	}
	
	//---------------------------------------
	function setReportHeaderInfo(reportType, titleObservable, descriptionObservable) {
	    var reports = dataCache.get("reports"),
	        exports = dataCache.get("exports"),
	        imports = dataCache.get("imports");
	
	    reports.done(function (reportsData) {
	        getReportTitle(reportsData, reportType, titleObservable);
	        getReportDescription(reportsData, reportType, descriptionObservable);
	    });
	
	    exports.done(function (reportsData) {
	        getReportTitle(reportsData, reportType, titleObservable);
	        getReportDescription(reportsData, reportType, descriptionObservable);
	    });
	
	    imports.done(function (reportsData) {
	        getReportTitle(reportsData, reportType, titleObservable);
	        getReportDescription(reportsData, reportType, descriptionObservable);
	    });
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	viewModelInit.createRoot = function createReportForm() {
	    var viewModelRoot,
	        factories,
	        entityViewModelCreator = createReportCriteriaViewModel;
	
	    if (typeof entityViewModelCreator !== "function") {
	        throw new Error("Required method createReportCriteriaViewModel is not defined");
	    }
	
	    if (!entityViewModelCreator.viewModelPrototype) {
	        throw new Error("Required property createReportCriteriaViewModel.viewModelPrototype is not defined");
	    }
	
	    //--------------------------------------------------
	    //  Closes window (if it was open by window.open)
	    entityViewModelCreator.viewModelPrototype.close = function reportFormClose() {
	        window.close();
	    };
	
	    entityViewModelCreator.viewModelPrototype.closeMessage = function reportCloseHeaderMessage() {
	        viewModelRoot.extras.isHeaderMessageVisible(false);
	    };
	
	    //---------------------------------------
	    // Duplicate this saved report.
	    entityViewModelCreator.viewModelPrototype.duplicate = function reportDuplicate() {
	        viewModelRoot.extras.state("busy.duplicate");
	        viewModelRoot.guid(null);
	
	        viewModelRoot.extras.rootData.id = '';
	        location.hash = '';
	        viewModelRoot.id("DUPLICATE OF " + viewModelRoot.id());
	
	        // select the name field, but do it in just a moment to give the UI a chance to update first
	        setTimeout(function afterDuplicate() {
	            viewModelRoot.extras.state("ready.dirty");
	            viewModelRoot.extras.isEditable(true);
	            pli.forms.crumbs.peek().begin.page.findActivationFocus().focus().select();
	        }, 400);
	
	        return false;
	    };
	
	    //---------------------------------------
	    // Show help for this document.
	    entityViewModelCreator.viewModelPrototype.help = function reportFormHelp() {
	        entityRegistry.help.show();
	        return false;
	    };
	
	    //---------------------------------------
	    // Goes to the root of the form.
	    entityViewModelCreator.viewModelPrototype.home = function reportHome() {
	        location.hash = pli.forms.crumbs().begin.hash;
	        return false;
	    };
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.loaded = function reportFormLoaded(record) {
	        // If report is 'Custom Export' or 'Well Import', make the UI non editable (ie Disable Save button)
	        // Reason: they are one off reports that don't need to be saved
	        if (this.reportType === "CustomExport" || this.reportType === "WellImport") {
	            this.extras.isEditable(false);
	            this.extras.isHeaderMessageVisible(false);
	        } else {
	            ko.postbox.publish("state.isEditable", (record ? record.editable : true));
	            this.extras.isHeaderMessageVisible(record ? !record.editable : false);
	        }
	
	        this.loadViewModel(record);
	    };
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.up = function moveUpReportHierarchy() {
	        var c = pli.forms.crumbs().end;
	        if (c.previous && c.previous.hash) {
	            location.hash = c.previous.hash;
	        }
	        return false;
	    };
	
	    //--------------------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeDirtyState = function reportFormComputeDirtyState() {
	        var s = this.extras.state();
	        if (s === "ready" || s === "ready.saved") {
	            if (this.extras.dirty()) {
	                this.extras.state("ready.dirty");
	            }
	        }
	    };
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeDuplicateStateMessage = function computeDuplicateStateMessage() {
	        if (this.extras.state() === "busy.duplicate") {
	            return { message: "Duplicating", stateIndicationClass: "fileDuplicating" };
	        }
	        return { message: "Duplicate", stateIndicationClass: "noChanges" };
	    };
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeReadOnly = function computereportFormReadOnly() {
	        return !this.extras.isEditable() || this.extras.state().indexOf("ready") !== 0;
	    };
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeReady = function computeDocumentReady() {
	        return this.extras.state().indexOf("ready") === 0;
	    };
	
	    //---------------------------------------
	    // Compute and set tool tip for Save button
	    entityViewModelCreator.viewModelPrototype._computeSaveButtonToolTip = function computeSaveButtonToolTip() {
	        if (this.extras.state().indexOf('.failed') === -1) {
	            return "Save all changes to this report (Ctrl+S)";
	        }
	
	        return "";
	    };
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.showErrorList = function showErrorList() {
	        return false;
	    };
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.moveOutErrorList = function moveOutErrorList() {
	        return false;
	    };
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeSaveStateMessage = function computereportFormSaveStateMessage() {
	        switch (this.extras.state()) {
	        case "busy.saving":
	            return { message: "Saving", stateIndicationClass: "fileSaving" };
	        case "ready.saved":
	            return { message: "Saved", stateIndicationClass: "fileSaved" };
	        default:
	            return { message: "Save", stateIndicationClass: "noChanges" };
	        }
	    };
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeWarningState = function computeWarningState() {
	        var s = this.extras.state();
	        if (s) {
	            s = s.replace(".failed", "");
	            if (s.indexOf("ready") === 0) {
	                if (this.extras.errorsCount && this.extras.errorsCount() > 0) {
	                    this.extras.state(s + ".failed");
	                } else {
	                    this.extras.state(s);
	                    this.extras.isErrorListVisible(false); // explicit hiding error list menu
	                }
	            }
	        }
	    };
	
	    //---------------------------------------
	    // Hide tooltip list
	    entityViewModelCreator.viewModelPrototype._hideErrorList = function hideErrorList() {
	        this.extras.isErrorListVisible(false);
	        return true; // allow event propagation & default handling
	    };
	
	    //---------------------------------------
	    /*jslint unparam: true*/
	    entityViewModelCreator.viewModelPrototype._safeSaving = function reportFormSafeSaving(data, e) {
	        if (e && e.stopImmediatePropagation) {
	            e.stopImmediatePropagation(); // prevent hiding the tool tip while it showing by click on Save button
	        }
	
	        // Check if viewModel has errors before saving then showing tooltip list
	        if (this.extras.errorsCount && this.extras.errorsCount() === 0) {
	            this.save();
	        }
	
	        return false; // stop propagation & default (if keyboard event)
	    };
	    /*jslint unparam: false*/
	
	
	    //--------------------------------------
	    // Show notification error panel in case if viewModel state is "failed" and errors count is 0 (unknown server-side error)
	    // or show error list tooltip if errors count isn't 0 (known server-side error)
	    entityViewModelCreator.viewModelPrototype._showErrorPanelAfterSaving = function showErrorPanelAfterSaving() {
	        var s = this.extras.state(), p = this.extras.prevState();
	        if ((s === "ready.failed" || s === "ready.saved.failed" || s === "ready.dirty.failed") && p === "busy.saving") {
	            if (this.extras.errorsCount() === 0) {
	                this.extras.notificationErrorPanel.show({
	                    title: "Save failed",
	                    message: "Unexpected save error"
	                });
	            }
	
	            this.extras.prevState(s); // reset previous state observable
	        }
	    };
	
	    //--------------------------------------
	    // Computes if a report is dirty
	    // "Custom Export" and "Well Import" are not saved so their "dirty" is always false
	    entityViewModelCreator.viewModelPrototype._computeReportDirty = function computeReportDirty() {
	        return this.extras.dirty() && this.reportType !== "CustomExport" && this.reportType !== "WellImport";
	    };
	
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	    // ViewModel initialization
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	    //--------------------------------------------------
	    viewModelInit.onViewModelCreated(function onreportFormCreated(viewModel, viewModelInit) {
	        viewModel.extras.dirty = ko.dirtyFlag(viewModel, true, true); // create suspended
	        viewModel.extras.isReportDirty = ko.computed(viewModel._computeReportDirty, viewModel);
	        viewModel.extras.breadcrumbs = createBreadcrumbs(pli.forms.crumbs);
	        viewModel.extras.isEditable = ko.observable().subscribeTo("state.isEditable");
	        viewModel.extras.isHeaderMessageVisible = ko.observable(false).subscribeTo("state.isEditable");
	        viewModel.extras.isReadOnly = ko.computed(viewModel._computeReadOnly, viewModel);
	        viewModel.extras.isReadOnly.publishOn("state.isReadOnly");
	        viewModel.extras.isReady = ko.computed(viewModel._computeReady, viewModel);
	        viewModel.extras.isReady.publishOn("state.isReady");
	        viewModel.extras.saveButtonTooltip = ko.computed(viewModel._computeSaveButtonToolTip, viewModel);
	
	        viewModel.extras.prevState = ko.observable(viewModel.extras.state());
	        viewModel.extras.state.subscribe(function (oldValue) {
	            viewModel.extras.prevState(oldValue);
	        }, viewModel, "beforeChange");
	
	        viewModel.extras.isErrorListVisible = ko.observable(false);
	        viewModel.extras.suppressBusyIndicator = true;
	        viewModel.extras.saveStateMessage = ko.computed(viewModel._computeSaveStateMessage, viewModel);
	        viewModel.extras.duplicateStateMessage = ko.computed(viewModel._computeDuplicateStateMessage, viewModel);
	
	        viewModel.hideErrorList = viewModel._hideErrorList.bind(viewModel);
	        viewModel.safeSaving = viewModel._safeSaving.bind(viewModel);
	
	        ko.computed(viewModel._computeDirtyState, viewModel);
	        ko.computed(viewModel._computeWarningState, viewModel);
	        ko.computed(viewModel._showErrorPanelAfterSaving, viewModel);
	        ko.computed(function () {
	            // Load parameters from query string if any
	            if (viewModel.extras.state() === "ready" && window.location.search.length > 1) {
	                viewModel._loadCriteriasFromQueryString(window.location.search.substring(1));
	            }
	        }, viewModel);
	
	        viewModelInit.defaultKeymap = ko.utils.extend(
	            ko.utils.extend({}, pli.config.defaultKeymap),
	            {
	                "Back": viewModel.up,
	                "Close": viewModel.close,
	                "Help": viewModel.help,
	                "Home": viewModel.home,
	                "Save": viewModel.safeSaving,
	                "Duplicate": viewModel.duplicate
	            }
	        );
	    });
	
	    factories = {
	        main: viewModelInit.createMainViewModel,
	        advanced: viewModelInit.createAdvancedViewModel,
	        loadWidgetRecord: viewModelInit.loadWidgetRecord,
	        createUploadExtras: createUploadViewModelExtras,
	        createFileViewModel: createFileViewModel,
	        computeErrorsCount: viewModelInit.computeErrorsCount,
	        createFactory: viewModelInit.createGridViewModelFactory,
	        setReportHeaderInfo: setReportHeaderInfo,
	        getReportType: getReportTypeFromUrl
	    };
	
	    viewModelRoot = entityViewModelCreator(factories);
	
	    // define methods for dialog registry
	    pli.dialogClosingMessage = function computeReportClosingMessage() {
	        return (viewModelRoot.extras.isReportDirty()
	            ? "This report has unsaved changes"
	            : null);
	    };
	    pli.dialogId = function computeDocumentId() {
	        return "reports-" + factories.getReportType() + "-" + viewModelRoot.id();
	    };
	
	    return viewModelRoot;
	};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	"use strict";
	
	__webpack_require__(503);
	__webpack_require__(504);
	__webpack_require__(505);
	
	__webpack_require__(506);
	
	var fileStoreDownload = __webpack_require__(482);
	var fileViewModel = __webpack_require__(507);
	var uploadViewModelExtras = __webpack_require__(508);
	
	module.exports = {
	    fileStoreDownload: fileStoreDownload,
	    fileViewModel: fileViewModel,
	    uploadViewModelExtras: uploadViewModelExtras
	};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * jQuery UI Widget 1.10.1+amd
	 * https://github.com/blueimp/jQuery-File-Upload
	 *
	 * Copyright 2013 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/jQuery.widget/
	 */
	
	(function (factory) {
	    if (true) {
	        // Register as an anonymous AMD module:
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // Browser globals:
	        factory(jQuery);
	    }
	}(function( $, undefined ) {
	
	var uuid = 0,
		slice = Array.prototype.slice,
		_cleanData = $.cleanData;
	$.cleanData = function( elems ) {
		for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
			try {
				$( elem ).triggerHandler( "remove" );
			// http://bugs.jquery.com/ticket/8235
			} catch( e ) {}
		}
		_cleanData( elems );
	};
	
	$.widget = function( name, base, prototype ) {
		var fullName, existingConstructor, constructor, basePrototype,
			// proxiedPrototype allows the provided prototype to remain unmodified
			// so that it can be used as a mixin for multiple widgets (#8876)
			proxiedPrototype = {},
			namespace = name.split( "." )[ 0 ];
	
		name = name.split( "." )[ 1 ];
		fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		// create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
			// allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
		// extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
			// copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
			// track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		});
	
		basePrototype = new base();
		// we need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = (function() {
				var _super = function() {
						return base.prototype[ prop ].apply( this, arguments );
					},
					_superApply = function( args ) {
						return base.prototype[ prop ].apply( this, args );
					};
				return function() {
					var __super = this._super,
						__superApply = this._superApply,
						returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			})();
		});
		constructor.prototype = $.widget.extend( basePrototype, {
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		});
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
			});
			// remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	};
	
	$.widget.extend = function( target ) {
		var input = slice.call( arguments, 1 ),
			inputIndex = 0,
			inputLength = input.length,
			key,
			value;
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string",
				args = slice.call( arguments, 1 ),
				returnValue = this;
	
			// allow multiple hashes to be passed on init
			options = !isMethodCall && args.length ?
				$.widget.extend.apply( null, [ options ].concat(args) ) :
				options;
	
			if ( isMethodCall ) {
				this.each(function() {
					var methodValue,
						instance = $.data( this, fullName );
					if ( !instance ) {
						return $.error( "cannot call methods on " + name + " prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}
					if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name + " widget instance" );
					}
					methodValue = instance[ options ].apply( instance, args );
					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				});
			} else {
				this.each(function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} )._init();
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				});
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
		options: {
			disabled: false,
	
			// callbacks
			create: null
		},
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = uuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				});
				this.document = $( element.style ?
					// element within the document
					element.ownerDocument :
					// element is window or document
					element.document || element );
				this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
			}
	
			this._create();
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
		_getCreateOptions: $.noop,
		_getCreateEventData: $.noop,
		_create: $.noop,
		_init: $.noop,
	
		destroy: function() {
			this._destroy();
			// we can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.unbind( this.eventNamespace )
				// 1.9 BC for #7810
				// TODO remove dual storage
				.removeData( this.widgetName )
				.removeData( this.widgetFullName )
				// support: jquery <1.6.3
				// http://bugs.jquery.com/ticket/9413
				.removeData( $.camelCase( this.widgetFullName ) );
			this.widget()
				.unbind( this.eventNamespace )
				.removeAttr( "aria-disabled" )
				.removeClass(
					this.widgetFullName + "-disabled " +
					"ui-state-disabled" );
	
			// clean up events and states
			this.bindings.unbind( this.eventNamespace );
			this.hoverable.removeClass( "ui-state-hover" );
			this.focusable.removeClass( "ui-state-focus" );
		},
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key,
				parts,
				curOption,
				i;
	
			if ( arguments.length === 0 ) {
				// don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
				// handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( value === undefined ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( value === undefined ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
		_setOption: function( key, value ) {
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this.widget()
					.toggleClass( this.widgetFullName + "-disabled ui-state-disabled", !!value )
					.attr( "aria-disabled", value );
				this.hoverable.removeClass( "ui-state-hover" );
				this.focusable.removeClass( "ui-state-focus" );
			}
	
			return this;
		},
	
		enable: function() {
			return this._setOption( "disabled", false );
		},
		disable: function() {
			return this._setOption( "disabled", true );
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement,
				instance = this;
	
			// no suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// no element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				// accept selectors, DOM elements
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
					// allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
								$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^(\w+)\s*(.*)$/ ),
					eventName = match[1] + instance.eventNamespace,
					selector = match[2];
				if ( selector ) {
					delegateElement.delegate( selector, eventName, handlerProxy );
				} else {
					element.bind( eventName, handlerProxy );
				}
			});
		},
	
		_off: function( element, eventName ) {
			eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) + this.eventNamespace;
			element.unbind( eventName ).undelegate( eventName );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					$( event.currentTarget ).addClass( "ui-state-hover" );
				},
				mouseleave: function( event ) {
					$( event.currentTarget ).removeClass( "ui-state-hover" );
				}
			});
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					$( event.currentTarget ).addClass( "ui-state-focus" );
				},
				focusout: function( event ) {
					$( event.currentTarget ).removeClass( "ui-state-focus" );
				}
			});
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig,
				callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
			// the original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
			var hasOptions,
				effectName = !options ?
					method :
					options === true || typeof options === "number" ?
						defaultEffect :
						options.effect || defaultEffect;
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
			if ( options.delay ) {
				element.delay( options.delay );
			}
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue(function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				});
			}
		};
	});
	
	}));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * jQuery Iframe Transport Plugin 1.6.1
	 * https://github.com/blueimp/jQuery-File-Upload
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * http://www.opensource.org/licenses/MIT
	 */
	
	/*jslint unparam: true, nomen: true */
	/*global define, window, document */
	
	(function (factory) {
	    'use strict';
	    if (true) {
	        // Register as an anonymous AMD module:
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // Browser globals:
	        factory(window.jQuery);
	    }
	}(function ($) {
	    'use strict';
	
	    // Helper variable to create unique names for the transport iframes:
	    var counter = 0;
	
	    // The iframe transport accepts three additional options:
	    // options.fileInput: a jQuery collection of file input fields
	    // options.paramName: the parameter name for the file form data,
	    //  overrides the name property of the file input field(s),
	    //  can be a string or an array of strings.
	    // options.formData: an array of objects with name and value properties,
	    //  equivalent to the return data of .serializeArray(), e.g.:
	    //  [{name: 'a', value: 1}, {name: 'b', value: 2}]
	    $.ajaxTransport('iframe', function (options) {
	        if (options.async) {
	            var form,
	                iframe,
	                addParamChar;
	            return {
	                send: function (_, completeCallback) {
	                    form = $('<form style="display:none;"></form>');
	                    form.attr('accept-charset', options.formAcceptCharset);
	                    addParamChar = /\?/.test(options.url) ? '&' : '?';
	                    // XDomainRequest only supports GET and POST:
	                    if (options.type === 'DELETE') {
	                        options.url = options.url + addParamChar + '_method=DELETE';
	                        options.type = 'POST';
	                    } else if (options.type === 'PUT') {
	                        options.url = options.url + addParamChar + '_method=PUT';
	                        options.type = 'POST';
	                    } else if (options.type === 'PATCH') {
	                        options.url = options.url + addParamChar + '_method=PATCH';
	                        options.type = 'POST';
	                    }
	                    // javascript:false as initial iframe src
	                    // prevents warning popups on HTTPS in IE6.
	                    // IE versions below IE8 cannot set the name property of
	                    // elements that have already been added to the DOM,
	                    // so we set the name along with the iframe HTML markup:
	                    iframe = $(
	                        '<iframe src="javascript:false;" name="iframe-transport-' +
	                            (counter += 1) + '"></iframe>'
	                    ).bind('load', function () {
	                        var fileInputClones,
	                            paramNames = $.isArray(options.paramName) ?
	                                    options.paramName : [options.paramName];
	                        iframe
	                            .unbind('load')
	                            .bind('load', function () {
	                                var response;
	                                // Wrap in a try/catch block to catch exceptions thrown
	                                // when trying to access cross-domain iframe contents:
	                                try {
	                                    response = iframe.contents();
	                                    // Google Chrome and Firefox do not throw an
	                                    // exception when calling iframe.contents() on
	                                    // cross-domain requests, so we unify the response:
	                                    if (!response.length || !response[0].firstChild) {
	                                        throw new Error();
	                                    }
	                                } catch (e) {
	                                    response = undefined;
	                                }
	                                // The complete callback returns the
	                                // iframe content document as response object:
	                                completeCallback(
	                                    200,
	                                    'success',
	                                    {'iframe': response}
	                                );
	                                // Fix for IE endless progress bar activity bug
	                                // (happens on form submits to iframe targets):
	                                $('<iframe src="javascript:false;"></iframe>')
	                                    .appendTo(form);
	                                form.remove();
	                            });
	                        form
	                            .prop('target', iframe.prop('name'))
	                            .prop('action', options.url)
	                            .prop('method', options.type);
	                        if (options.formData) {
	                            $.each(options.formData, function (index, field) {
	                                $('<input type="hidden"/>')
	                                    .prop('name', field.name)
	                                    .val(field.value)
	                                    .appendTo(form);
	                            });
	                        }
	                        if (options.fileInput && options.fileInput.length &&
	                                options.type === 'POST') {
	                            fileInputClones = options.fileInput.clone();
	                            // Insert a clone for each file input field:
	                            options.fileInput.after(function (index) {
	                                return fileInputClones[index];
	                            });
	                            if (options.paramName) {
	                                options.fileInput.each(function (index) {
	                                    $(this).prop(
	                                        'name',
	                                        paramNames[index] || options.paramName
	                                    );
	                                });
	                            }
	                            // Appending the file input fields to the hidden form
	                            // removes them from their original location:
	                            form
	                                .append(options.fileInput)
	                                .prop('enctype', 'multipart/form-data')
	                                // enctype must be set as encoding for IE:
	                                .prop('encoding', 'multipart/form-data');
	                        }
	                        form.submit();
	                        // Insert the file input fields at their original location
	                        // by replacing the clones with the originals:
	                        if (fileInputClones && fileInputClones.length) {
	                            options.fileInput.each(function (index, input) {
	                                var clone = $(fileInputClones[index]);
	                                $(input).prop('name', clone.prop('name'));
	                                clone.replaceWith(input);
	                            });
	                        }
	                    });
	                    form.append(iframe).appendTo(document.body);
	                },
	                abort: function () {
	                    if (iframe) {
	                        // javascript:false as iframe src aborts the request
	                        // and prevents warning popups on HTTPS in IE6.
	                        // concat is used to avoid the "Script URL" JSLint error:
	                        iframe
	                            .unbind('load')
	                            .prop('src', 'javascript'.concat(':false;'));
	                    }
	                    if (form) {
	                        form.remove();
	                    }
	                }
	            };
	        }
	    });
	
	    // The iframe transport returns the iframe content document as response.
	    // The following adds converters from iframe to text, json, html, and script:
	    $.ajaxSetup({
	        converters: {
	            'iframe text': function (iframe) {
	                return iframe && $(iframe[0].body).text();
	            },
	            'iframe json': function (iframe) {
	                return iframe && $.parseJSON($(iframe[0].body).text());
	            },
	            'iframe html': function (iframe) {
	                return iframe && $(iframe[0].body).html();
	            },
	            'iframe script': function (iframe) {
	                return iframe && $.globalEval($(iframe[0].body).text());
	            }
	        }
	    });
	
	}));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * jQuery File Upload Plugin 5.26
	 * https://github.com/blueimp/jQuery-File-Upload
	 *
	 * Copyright 2010, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * http://www.opensource.org/licenses/MIT
	 */
	
	/*jslint nomen: true, unparam: true, regexp: true */
	/*global define, window, document, File, Blob, FormData, location */
	
	(function (factory) {
	    'use strict';
	    if (true) {
	        // Register as an anonymous AMD module:
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	            __webpack_require__(2),
	            __webpack_require__(503)
	        ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // Browser globals:
	        factory(window.jQuery);
	    }
	}(function ($) {
	    'use strict';
	
	    // The FileReader API is not actually used, but works as feature detection,
	    // as e.g. Safari supports XHR file uploads via the FormData API,
	    // but not non-multipart XHR file uploads:
	    $.support.xhrFileUpload = !!(window.XMLHttpRequestUpload && window.FileReader);
	    $.support.xhrFormDataFileUpload = !!window.FormData;
	
	    // The fileupload widget listens for change events on file input fields defined
	    // via fileInput setting and paste or drop events of the given dropZone.
	    // In addition to the default jQuery Widget methods, the fileupload widget
	    // exposes the "add" and "send" methods, to add or directly send files using
	    // the fileupload API.
	    // By default, files added via file input selection, paste, drag & drop or
	    // "add" method are uploaded immediately, but it is possible to override
	    // the "add" callback option to queue file uploads.
	    $.widget('blueimp.fileupload', {
	
	        options: {
	            // The drop target element(s), by the default the complete document.
	            // Set to null to disable drag & drop support:
	            dropZone: $(document),
	            // The paste target element(s), by the default the complete document.
	            // Set to null to disable paste support:
	            pasteZone: $(document),
	            // The file input field(s), that are listened to for change events.
	            // If undefined, it is set to the file input fields inside
	            // of the widget element on plugin initialization.
	            // Set to null to disable the change listener.
	            fileInput: undefined,
	            // By default, the file input field is replaced with a clone after
	            // each input field change event. This is required for iframe transport
	            // queues and allows change events to be fired for the same file
	            // selection, but can be disabled by setting the following option to false:
	            replaceFileInput: true,
	            // The parameter name for the file form data (the request argument name).
	            // If undefined or empty, the name property of the file input field is
	            // used, or "files[]" if the file input name property is also empty,
	            // can be a string or an array of strings:
	            paramName: undefined,
	            // By default, each file of a selection is uploaded using an individual
	            // request for XHR type uploads. Set to false to upload file
	            // selections in one request each:
	            singleFileUploads: true,
	            // To limit the number of files uploaded with one XHR request,
	            // set the following option to an integer greater than 0:
	            limitMultiFileUploads: undefined,
	            // Set the following option to true to issue all file upload requests
	            // in a sequential order:
	            sequentialUploads: false,
	            // To limit the number of concurrent uploads,
	            // set the following option to an integer greater than 0:
	            limitConcurrentUploads: undefined,
	            // Set the following option to true to force iframe transport uploads:
	            forceIframeTransport: false,
	            // Set the following option to the location of a redirect url on the
	            // origin server, for cross-domain iframe transport uploads:
	            redirect: undefined,
	            // The parameter name for the redirect url, sent as part of the form
	            // data and set to 'redirect' if this option is empty:
	            redirectParamName: undefined,
	            // Set the following option to the location of a postMessage window,
	            // to enable postMessage transport uploads:
	            postMessage: undefined,
	            // By default, XHR file uploads are sent as multipart/form-data.
	            // The iframe transport is always using multipart/form-data.
	            // Set to false to enable non-multipart XHR uploads:
	            multipart: true,
	            // To upload large files in smaller chunks, set the following option
	            // to a preferred maximum chunk size. If set to 0, null or undefined,
	            // or the browser does not support the required Blob API, files will
	            // be uploaded as a whole.
	            maxChunkSize: undefined,
	            // When a non-multipart upload or a chunked multipart upload has been
	            // aborted, this option can be used to resume the upload by setting
	            // it to the size of the already uploaded bytes. This option is most
	            // useful when modifying the options object inside of the "add" or
	            // "send" callbacks, as the options are cloned for each file upload.
	            uploadedBytes: undefined,
	            // By default, failed (abort or error) file uploads are removed from the
	            // global progress calculation. Set the following option to false to
	            // prevent recalculating the global progress data:
	            recalculateProgress: true,
	            // Interval in milliseconds to calculate and trigger progress events:
	            progressInterval: 100,
	            // Interval in milliseconds to calculate progress bitrate:
	            bitrateInterval: 500,
	            // By default, uploads are started automatically when adding files:
	            autoUpload: true,
	
	            // Additional form data to be sent along with the file uploads can be set
	            // using this option, which accepts an array of objects with name and
	            // value properties, a function returning such an array, a FormData
	            // object (for XHR file uploads), or a simple object.
	            // The form of the first fileInput is given as parameter to the function:
	            formData: function (form) {
	                return form.serializeArray();
	            },
	
	            // The add callback is invoked as soon as files are added to the fileupload
	            // widget (via file input selection, drag & drop, paste or add API call).
	            // If the singleFileUploads option is enabled, this callback will be
	            // called once for each file in the selection for XHR file uplaods, else
	            // once for each file selection.
	            // The upload starts when the submit method is invoked on the data parameter.
	            // The data object contains a files property holding the added files
	            // and allows to override plugin options as well as define ajax settings.
	            // Listeners for this callback can also be bound the following way:
	            // .bind('fileuploadadd', func);
	            // data.submit() returns a Promise object and allows to attach additional
	            // handlers using jQuery's Deferred callbacks:
	            // data.submit().done(func).fail(func).always(func);
	            add: function (e, data) {
	                if (data.autoUpload || (data.autoUpload !== false &&
	                        ($(this).data('blueimp-fileupload') ||
	                        $(this).data('fileupload')).options.autoUpload)) {
	                    data.submit();
	                }
	            },
	
	            // Other callbacks:
	
	            // Callback for the submit event of each file upload:
	            // submit: function (e, data) {}, // .bind('fileuploadsubmit', func);
	
	            // Callback for the start of each file upload request:
	            // send: function (e, data) {}, // .bind('fileuploadsend', func);
	
	            // Callback for successful uploads:
	            // done: function (e, data) {}, // .bind('fileuploaddone', func);
	
	            // Callback for failed (abort or error) uploads:
	            // fail: function (e, data) {}, // .bind('fileuploadfail', func);
	
	            // Callback for completed (success, abort or error) requests:
	            // always: function (e, data) {}, // .bind('fileuploadalways', func);
	
	            // Callback for upload progress events:
	            // progress: function (e, data) {}, // .bind('fileuploadprogress', func);
	
	            // Callback for global upload progress events:
	            // progressall: function (e, data) {}, // .bind('fileuploadprogressall', func);
	
	            // Callback for uploads start, equivalent to the global ajaxStart event:
	            // start: function (e) {}, // .bind('fileuploadstart', func);
	
	            // Callback for uploads stop, equivalent to the global ajaxStop event:
	            // stop: function (e) {}, // .bind('fileuploadstop', func);
	
	            // Callback for change events of the fileInput(s):
	            // change: function (e, data) {}, // .bind('fileuploadchange', func);
	
	            // Callback for paste events to the pasteZone(s):
	            // paste: function (e, data) {}, // .bind('fileuploadpaste', func);
	
	            // Callback for drop events of the dropZone(s):
	            // drop: function (e, data) {}, // .bind('fileuploaddrop', func);
	
	            // Callback for dragover events of the dropZone(s):
	            // dragover: function (e) {}, // .bind('fileuploaddragover', func);
	
	            // Callback for the start of each chunk upload request:
	            // chunksend: function (e, data) {}, // .bind('fileuploadchunksend', func);
	
	            // Callback for successful chunk uploads:
	            // chunkdone: function (e, data) {}, // .bind('fileuploadchunkdone', func);
	
	            // Callback for failed (abort or error) chunk uploads:
	            // chunkfail: function (e, data) {}, // .bind('fileuploadchunkfail', func);
	
	            // Callback for completed (success, abort or error) chunk upload requests:
	            // chunkalways: function (e, data) {}, // .bind('fileuploadchunkalways', func);
	
	            // The plugin options are used as settings object for the ajax calls.
	            // The following are jQuery ajax settings required for the file uploads:
	            processData: false,
	            contentType: false,
	            cache: false
	        },
	
	        // A list of options that require a refresh after assigning a new value:
	        _refreshOptionsList: [
	            'fileInput',
	            'dropZone',
	            'pasteZone',
	            'multipart',
	            'forceIframeTransport'
	        ],
	
	        _BitrateTimer: function () {
	            this.timestamp = +(new Date());
	            this.loaded = 0;
	            this.bitrate = 0;
	            this.getBitrate = function (now, loaded, interval) {
	                var timeDiff = now - this.timestamp;
	                if (!this.bitrate || !interval || timeDiff > interval) {
	                    this.bitrate = (loaded - this.loaded) * (1000 / timeDiff) * 8;
	                    this.loaded = loaded;
	                    this.timestamp = now;
	                }
	                return this.bitrate;
	            };
	        },
	
	        _isXHRUpload: function (options) {
	            return !options.forceIframeTransport &&
	                ((!options.multipart && $.support.xhrFileUpload) ||
	                $.support.xhrFormDataFileUpload);
	        },
	
	        _getFormData: function (options) {
	            var formData;
	            if (typeof options.formData === 'function') {
	                return options.formData(options.form);
	            }
	            if ($.isArray(options.formData)) {
	                return options.formData;
	            }
	            if (options.formData) {
	                formData = [];
	                $.each(options.formData, function (name, value) {
	                    formData.push({name: name, value: value});
	                });
	                return formData;
	            }
	            return [];
	        },
	
	        _getTotal: function (files) {
	            var total = 0;
	            $.each(files, function (index, file) {
	                total += file.size || 1;
	            });
	            return total;
	        },
	
	        _initProgressObject: function (obj) {
	            obj._progress = {
	                loaded: 0,
	                total: 0,
	                bitrate: 0
	            };
	        },
	
	        _onProgress: function (e, data) {
	            if (e.lengthComputable) {
	                var now = +(new Date()),
	                    loaded;
	                if (data._time && data.progressInterval &&
	                        (now - data._time < data.progressInterval) &&
	                        e.loaded !== e.total) {
	                    return;
	                }
	                data._time = now;
	                loaded = Math.floor(
	                    e.loaded / e.total * (data.chunkSize || data._progress.total)
	                ) + (data.uploadedBytes || 0);
	                // Add the difference from the previously loaded state
	                // to the global loaded counter:
	                this._progress.loaded += (loaded - data._progress.loaded);
	                this._progress.bitrate = this._bitrateTimer.getBitrate(
	                    now,
	                    this._progress.loaded,
	                    data.bitrateInterval
	                );
	                data._progress.loaded = data.loaded = loaded;
	                data._progress.bitrate = data.bitrate = data._bitrateTimer.getBitrate(
	                    now,
	                    loaded,
	                    data.bitrateInterval
	                );
	                // Trigger a custom progress event with a total data property set
	                // to the file size(s) of the current upload and a loaded data
	                // property calculated accordingly:
	                this._trigger('progress', e, data);
	                // Trigger a global progress event for all current file uploads,
	                // including ajax calls queued for sequential file uploads:
	                this._trigger('progressall', e, this._progress);
	            }
	        },
	
	        _initProgressListener: function (options) {
	            var that = this,
	                xhr = options.xhr ? options.xhr() : $.ajaxSettings.xhr();
	            // Accesss to the native XHR object is required to add event listeners
	            // for the upload progress event:
	            if (xhr.upload) {
	                $(xhr.upload).bind('progress', function (e) {
	                    var oe = e.originalEvent;
	                    // Make sure the progress event properties get copied over:
	                    e.lengthComputable = oe.lengthComputable;
	                    e.loaded = oe.loaded;
	                    e.total = oe.total;
	                    that._onProgress(e, options);
	                });
	                options.xhr = function () {
	                    return xhr;
	                };
	            }
	        },
	
	        _initXHRData: function (options) {
	            var formData,
	                file = options.files[0],
	                // Ignore non-multipart setting if not supported:
	                multipart = options.multipart || !$.support.xhrFileUpload,
	                paramName = options.paramName[0];
	            options.headers = options.headers || {};
	            if (options.contentRange) {
	                options.headers['Content-Range'] = options.contentRange;
	            }
	            if (!multipart) {
	                options.headers['Content-Disposition'] = 'attachment; filename="' +
	                    encodeURI(file.name) + '"';
	                options.contentType = file.type;
	                options.data = options.blob || file;
	            } else if ($.support.xhrFormDataFileUpload) {
	                if (options.postMessage) {
	                    // window.postMessage does not allow sending FormData
	                    // objects, so we just add the File/Blob objects to
	                    // the formData array and let the postMessage window
	                    // create the FormData object out of this array:
	                    formData = this._getFormData(options);
	                    if (options.blob) {
	                        formData.push({
	                            name: paramName,
	                            value: options.blob
	                        });
	                    } else {
	                        $.each(options.files, function (index, file) {
	                            formData.push({
	                                name: options.paramName[index] || paramName,
	                                value: file
	                            });
	                        });
	                    }
	                } else {
	                    if (options.formData instanceof FormData) {
	                        formData = options.formData;
	                    } else {
	                        formData = new FormData();
	                        $.each(this._getFormData(options), function (index, field) {
	                            formData.append(field.name, field.value);
	                        });
	                    }
	                    if (options.blob) {
	                        options.headers['Content-Disposition'] = 'attachment; filename="' +
	                            encodeURI(file.name) + '"';
	                        formData.append(paramName, options.blob, file.name);
	                    } else {
	                        $.each(options.files, function (index, file) {
	                            // Files are also Blob instances, but some browsers
	                            // (Firefox 3.6) support the File API but not Blobs.
	                            // This check allows the tests to run with
	                            // dummy objects:
	                            if ((window.Blob && file instanceof Blob) ||
	                                    (window.File && file instanceof File)) {
	                                formData.append(
	                                    options.paramName[index] || paramName,
	                                    file,
	                                    file.name
	                                );
	                            }
	                        });
	                    }
	                }
	                options.data = formData;
	            }
	            // Blob reference is not needed anymore, free memory:
	            options.blob = null;
	        },
	
	        _initIframeSettings: function (options) {
	            // Setting the dataType to iframe enables the iframe transport:
	            options.dataType = 'iframe ' + (options.dataType || '');
	            // The iframe transport accepts a serialized array as form data:
	            options.formData = this._getFormData(options);
	            // Add redirect url to form data on cross-domain uploads:
	            if (options.redirect && $('<a></a>').prop('href', options.url)
	                    .prop('host') !== location.host) {
	                options.formData.push({
	                    name: options.redirectParamName || 'redirect',
	                    value: options.redirect
	                });
	            }
	        },
	
	        _initDataSettings: function (options) {
	            if (this._isXHRUpload(options)) {
	                if (!this._chunkedUpload(options, true)) {
	                    if (!options.data) {
	                        this._initXHRData(options);
	                    }
	                    this._initProgressListener(options);
	                }
	                if (options.postMessage) {
	                    // Setting the dataType to postmessage enables the
	                    // postMessage transport:
	                    options.dataType = 'postmessage ' + (options.dataType || '');
	                }
	            } else {
	                this._initIframeSettings(options, 'iframe');
	            }
	        },
	
	        _getParamName: function (options) {
	            var fileInput = $(options.fileInput),
	                paramName = options.paramName;
	            if (!paramName) {
	                paramName = [];
	                fileInput.each(function () {
	                    var input = $(this),
	                        name = input.prop('name') || 'files[]',
	                        i = (input.prop('files') || [1]).length;
	                    while (i) {
	                        paramName.push(name);
	                        i -= 1;
	                    }
	                });
	                if (!paramName.length) {
	                    paramName = [fileInput.prop('name') || 'files[]'];
	                }
	            } else if (!$.isArray(paramName)) {
	                paramName = [paramName];
	            }
	            return paramName;
	        },
	
	        _initFormSettings: function (options) {
	            // Retrieve missing options from the input field and the
	            // associated form, if available:
	            if (!options.form || !options.form.length) {
	                options.form = $(options.fileInput.prop('form'));
	                // If the given file input doesn't have an associated form,
	                // use the default widget file input's form:
	                if (!options.form.length) {
	                    options.form = $(this.options.fileInput.prop('form'));
	                }
	            }
	            options.paramName = this._getParamName(options);
	            if (!options.url) {
	                options.url = options.form.prop('action') || location.href;
	            }
	            // The HTTP request method must be "POST" or "PUT":
	            options.type = (options.type || options.form.prop('method') || '')
	                .toUpperCase();
	            if (options.type !== 'POST' && options.type !== 'PUT' &&
	                    options.type !== 'PATCH') {
	                options.type = 'POST';
	            }
	            if (!options.formAcceptCharset) {
	                options.formAcceptCharset = options.form.attr('accept-charset');
	            }
	        },
	
	        _getAJAXSettings: function (data) {
	            var options = $.extend({}, this.options, data);
	            this._initFormSettings(options);
	            this._initDataSettings(options);
	            return options;
	        },
	
	        // jQuery 1.6 doesn't provide .state(),
	        // while jQuery 1.8+ removed .isRejected() and .isResolved():
	        _getDeferredState: function (deferred) {
	            if (deferred.state) {
	                return deferred.state();
	            }
	            if (deferred.isResolved()) {
	                return 'resolved';
	            }
	            if (deferred.isRejected()) {
	                return 'rejected';
	            }
	            return 'pending';
	        },
	
	        // Maps jqXHR callbacks to the equivalent
	        // methods of the given Promise object:
	        _enhancePromise: function (promise) {
	            promise.success = promise.done;
	            promise.error = promise.fail;
	            promise.complete = promise.always;
	            return promise;
	        },
	
	        // Creates and returns a Promise object enhanced with
	        // the jqXHR methods abort, success, error and complete:
	        _getXHRPromise: function (resolveOrReject, context, args) {
	            var dfd = $.Deferred(),
	                promise = dfd.promise();
	            context = context || this.options.context || promise;
	            if (resolveOrReject === true) {
	                dfd.resolveWith(context, args);
	            } else if (resolveOrReject === false) {
	                dfd.rejectWith(context, args);
	            }
	            promise.abort = dfd.promise;
	            return this._enhancePromise(promise);
	        },
	
	        // Adds convenience methods to the callback arguments:
	        _addConvenienceMethods: function (e, data) {
	            var that = this;
	            data.submit = function () {
	                if (this.state() !== 'pending') {
	                    data.jqXHR = this.jqXHR =
	                        (that._trigger('submit', e, this) !== false) &&
	                        that._onSend(e, this);
	                }
	                return this.jqXHR || that._getXHRPromise();
	            };
	            data.abort = function () {
	                if (this.jqXHR) {
	                    return this.jqXHR.abort();
	                }
	                return this._getXHRPromise();
	            };
	            data.state = function () {
	                if (this.jqXHR) {
	                    return that._getDeferredState(this.jqXHR);
	                }
	            };
	            data.progress = function () {
	                return this._progress;
	            };
	        },
	
	        // Parses the Range header from the server response
	        // and returns the uploaded bytes:
	        _getUploadedBytes: function (jqXHR) {
	            var range = jqXHR.getResponseHeader('Range'),
	                parts = range && range.split('-'),
	                upperBytesPos = parts && parts.length > 1 &&
	                    parseInt(parts[1], 10);
	            return upperBytesPos && upperBytesPos + 1;
	        },
	
	        // Uploads a file in multiple, sequential requests
	        // by splitting the file up in multiple blob chunks.
	        // If the second parameter is true, only tests if the file
	        // should be uploaded in chunks, but does not invoke any
	        // upload requests:
	        _chunkedUpload: function (options, testOnly) {
	            var that = this,
	                file = options.files[0],
	                fs = file.size,
	                ub = options.uploadedBytes = options.uploadedBytes || 0,
	                mcs = options.maxChunkSize || fs,
	                slice = file.slice || file.webkitSlice || file.mozSlice,
	                dfd = $.Deferred(),
	                promise = dfd.promise(),
	                jqXHR,
	                upload;
	            if (!(this._isXHRUpload(options) && slice && (ub || mcs < fs)) ||
	                    options.data) {
	                return false;
	            }
	            if (testOnly) {
	                return true;
	            }
	            if (ub >= fs) {
	                file.error = 'Uploaded bytes exceed file size';
	                return this._getXHRPromise(
	                    false,
	                    options.context,
	                    [null, 'error', file.error]
	                );
	            }
	            // The chunk upload method:
	            upload = function () {
	                // Clone the options object for each chunk upload:
	                var o = $.extend({}, options),
	                    currentLoaded = o._progress.loaded;
	                o.blob = slice.call(
	                    file,
	                    ub,
	                    ub + mcs,
	                    file.type
	                );
	                // Store the current chunk size, as the blob itself
	                // will be dereferenced after data processing:
	                o.chunkSize = o.blob.size;
	                // Expose the chunk bytes position range:
	                o.contentRange = 'bytes ' + ub + '-' +
	                    (ub + o.chunkSize - 1) + '/' + fs;
	                // Process the upload data (the blob and potential form data):
	                that._initXHRData(o);
	                // Add progress listeners for this chunk upload:
	                that._initProgressListener(o);
	                jqXHR = ((that._trigger('chunksend', null, o) !== false && $.ajax(o)) ||
	                        that._getXHRPromise(false, o.context))
	                    .done(function (result, textStatus, jqXHR) {
	                        ub = that._getUploadedBytes(jqXHR) ||
	                            (ub + o.chunkSize);
	                        // Create a progress event if no final progress event
	                        // with loaded equaling total has been triggered
	                        // for this chunk:
	                        if (o._progress.loaded === currentLoaded) {
	                            that._onProgress($.Event('progress', {
	                                lengthComputable: true,
	                                loaded: ub - o.uploadedBytes,
	                                total: ub - o.uploadedBytes
	                            }), o);
	                        }
	                        options.uploadedBytes = o.uploadedBytes = ub;
	                        o.result = result;
	                        o.textStatus = textStatus;
	                        o.jqXHR = jqXHR;
	                        that._trigger('chunkdone', null, o);
	                        that._trigger('chunkalways', null, o);
	                        if (ub < fs) {
	                            // File upload not yet complete,
	                            // continue with the next chunk:
	                            upload();
	                        } else {
	                            dfd.resolveWith(
	                                o.context,
	                                [result, textStatus, jqXHR]
	                            );
	                        }
	                    })
	                    .fail(function (jqXHR, textStatus, errorThrown) {
	                        o.jqXHR = jqXHR;
	                        o.textStatus = textStatus;
	                        o.errorThrown = errorThrown;
	                        that._trigger('chunkfail', null, o);
	                        that._trigger('chunkalways', null, o);
	                        dfd.rejectWith(
	                            o.context,
	                            [jqXHR, textStatus, errorThrown]
	                        );
	                    });
	            };
	            this._enhancePromise(promise);
	            promise.abort = function () {
	                return jqXHR.abort();
	            };
	            upload();
	            return promise;
	        },
	
	        _beforeSend: function (e, data) {
	            if (this._active === 0) {
	                // the start callback is triggered when an upload starts
	                // and no other uploads are currently running,
	                // equivalent to the global ajaxStart event:
	                this._trigger('start');
	                // Set timer for global bitrate progress calculation:
	                this._bitrateTimer = new this._BitrateTimer();
	                // Reset the global progress values:
	                this._progress.loaded = this._progress.total = 0;
	                this._progress.bitrate = 0;
	            }
	            if (!data._progress) {
	                data._progress = {};
	            }
	            data._progress.loaded = data.loaded = data.uploadedBytes || 0;
	            data._progress.total = data.total = this._getTotal(data.files) || 1;
	            data._progress.bitrate = data.bitrate = 0;
	            this._active += 1;
	            // Initialize the global progress values:
	            this._progress.loaded += data.loaded;
	            this._progress.total += data.total;
	        },
	
	        _onDone: function (result, textStatus, jqXHR, options) {
	            var total = options._progress.total;
	            if (options._progress.loaded < total) {
	                // Create a progress event if no final progress event
	                // with loaded equaling total has been triggered:
	                this._onProgress($.Event('progress', {
	                    lengthComputable: true,
	                    loaded: total,
	                    total: total
	                }), options);
	            }
	            options.result = result;
	            options.textStatus = textStatus;
	            options.jqXHR = jqXHR;
	            this._trigger('done', null, options);
	        },
	
	        _onFail: function (jqXHR, textStatus, errorThrown, options) {
	            options.jqXHR = jqXHR;
	            options.textStatus = textStatus;
	            options.errorThrown = errorThrown;
	            this._trigger('fail', null, options);
	            if (options.recalculateProgress) {
	                // Remove the failed (error or abort) file upload from
	                // the global progress calculation:
	                this._progress.loaded -= options._progress.loaded;
	                this._progress.total -= options._progress.total;
	            }
	        },
	
	        _onAlways: function (jqXHRorResult, textStatus, jqXHRorError, options) {
	            // jqXHRorResult, textStatus and jqXHRorError are added to the
	            // options object via done and fail callbacks
	            this._active -= 1;
	            this._trigger('always', null, options);
	            if (this._active === 0) {
	                // The stop callback is triggered when all uploads have
	                // been completed, equivalent to the global ajaxStop event:
	                this._trigger('stop');
	            }
	        },
	
	        _onSend: function (e, data) {
	            if (!data.submit) {
	                this._addConvenienceMethods(e, data);
	            }
	            var that = this,
	                jqXHR,
	                aborted,
	                slot,
	                pipe,
	                options = that._getAJAXSettings(data),
	                send = function () {
	                    that._sending += 1;
	                    // Set timer for bitrate progress calculation:
	                    options._bitrateTimer = new that._BitrateTimer();
	                    jqXHR = jqXHR || (
	                        ((aborted || that._trigger('send', e, options) === false) &&
	                        that._getXHRPromise(false, options.context, aborted)) ||
	                        that._chunkedUpload(options) || $.ajax(options)
	                    ).done(function (result, textStatus, jqXHR) {
	                        that._onDone(result, textStatus, jqXHR, options);
	                    }).fail(function (jqXHR, textStatus, errorThrown) {
	                        that._onFail(jqXHR, textStatus, errorThrown, options);
	                    }).always(function (jqXHRorResult, textStatus, jqXHRorError) {
	                        that._sending -= 1;
	                        that._onAlways(
	                            jqXHRorResult,
	                            textStatus,
	                            jqXHRorError,
	                            options
	                        );
	                        if (options.limitConcurrentUploads &&
	                                options.limitConcurrentUploads > that._sending) {
	                            // Start the next queued upload,
	                            // that has not been aborted:
	                            var nextSlot = that._slots.shift();
	                            while (nextSlot) {
	                                if (that._getDeferredState(nextSlot) === 'pending') {
	                                    nextSlot.resolve();
	                                    break;
	                                }
	                                nextSlot = that._slots.shift();
	                            }
	                        }
	                    });
	                    return jqXHR;
	                };
	            this._beforeSend(e, options);
	            if (this.options.sequentialUploads ||
	                    (this.options.limitConcurrentUploads &&
	                    this.options.limitConcurrentUploads <= this._sending)) {
	                if (this.options.limitConcurrentUploads > 1) {
	                    slot = $.Deferred();
	                    this._slots.push(slot);
	                    pipe = slot.pipe(send);
	                } else {
	                    pipe = (this._sequence = this._sequence.pipe(send, send));
	                }
	                // Return the piped Promise object, enhanced with an abort method,
	                // which is delegated to the jqXHR object of the current upload,
	                // and jqXHR callbacks mapped to the equivalent Promise methods:
	                pipe.abort = function () {
	                    aborted = [undefined, 'abort', 'abort'];
	                    if (!jqXHR) {
	                        if (slot) {
	                            slot.rejectWith(options.context, aborted);
	                        }
	                        return send();
	                    }
	                    return jqXHR.abort();
	                };
	                return this._enhancePromise(pipe);
	            }
	            return send();
	        },
	
	        _onAdd: function (e, data) {
	            var that = this,
	                result = true,
	                options = $.extend({}, this.options, data),
	                limit = options.limitMultiFileUploads,
	                paramName = this._getParamName(options),
	                paramNameSet,
	                paramNameSlice,
	                fileSet,
	                i;
	            if (!(options.singleFileUploads || limit) ||
	                    !this._isXHRUpload(options)) {
	                fileSet = [data.files];
	                paramNameSet = [paramName];
	            } else if (!options.singleFileUploads && limit) {
	                fileSet = [];
	                paramNameSet = [];
	                for (i = 0; i < data.files.length; i += limit) {
	                    fileSet.push(data.files.slice(i, i + limit));
	                    paramNameSlice = paramName.slice(i, i + limit);
	                    if (!paramNameSlice.length) {
	                        paramNameSlice = paramName;
	                    }
	                    paramNameSet.push(paramNameSlice);
	                }
	            } else {
	                paramNameSet = paramName;
	            }
	            data.originalFiles = data.files;
	            $.each(fileSet || data.files, function (index, element) {
	                var newData = $.extend({}, data);
	                newData.files = fileSet ? element : [element];
	                newData.paramName = paramNameSet[index];
	                that._initProgressObject(newData);
	                that._addConvenienceMethods(e, newData);
	                result = that._trigger('add', e, newData);
	                return result;
	            });
	            return result;
	        },
	
	        _replaceFileInput: function (input) {
	            var inputClone = input.clone(true);
	            $('<form></form>').append(inputClone)[0].reset();
	            // Detaching allows to insert the fileInput on another form
	            // without loosing the file input value:
	            input.after(inputClone).detach();
	            // Avoid memory leaks with the detached file input:
	            $.cleanData(input.unbind('remove'));
	            // Replace the original file input element in the fileInput
	            // elements set with the clone, which has been copied including
	            // event handlers:
	            this.options.fileInput = this.options.fileInput.map(function (i, el) {
	                if (el === input[0]) {
	                    return inputClone[0];
	                }
	                return el;
	            });
	            // If the widget has been initialized on the file input itself,
	            // override this.element with the file input clone:
	            if (input[0] === this.element[0]) {
	                this.element = inputClone;
	            }
	        },
	
	        _handleFileTreeEntry: function (entry, path) {
	            var that = this,
	                dfd = $.Deferred(),
	                errorHandler = function (e) {
	                    if (e && !e.entry) {
	                        e.entry = entry;
	                    }
	                    // Since $.when returns immediately if one
	                    // Deferred is rejected, we use resolve instead.
	                    // This allows valid files and invalid items
	                    // to be returned together in one set:
	                    dfd.resolve([e]);
	                },
	                dirReader;
	            path = path || '';
	            if (entry.isFile) {
	                if (entry._file) {
	                    // Workaround for Chrome bug #149735
	                    entry._file.relativePath = path;
	                    dfd.resolve(entry._file);
	                } else {
	                    entry.file(function (file) {
	                        file.relativePath = path;
	                        dfd.resolve(file);
	                    }, errorHandler);
	                }
	            } else if (entry.isDirectory) {
	                dirReader = entry.createReader();
	                dirReader.readEntries(function (entries) {
	                    that._handleFileTreeEntries(
	                        entries,
	                        path + entry.name + '/'
	                    ).done(function (files) {
	                        dfd.resolve(files);
	                    }).fail(errorHandler);
	                }, errorHandler);
	            } else {
	                // Return an empy list for file system items
	                // other than files or directories:
	                dfd.resolve([]);
	            }
	            return dfd.promise();
	        },
	
	        _handleFileTreeEntries: function (entries, path) {
	            var that = this;
	            return $.when.apply(
	                $,
	                $.map(entries, function (entry) {
	                    return that._handleFileTreeEntry(entry, path);
	                })
	            ).pipe(function () {
	                return Array.prototype.concat.apply(
	                    [],
	                    arguments
	                );
	            });
	        },
	
	        _getDroppedFiles: function (dataTransfer) {
	            dataTransfer = dataTransfer || {};
	            var items = dataTransfer.items;
	            if (items && items.length && (items[0].webkitGetAsEntry ||
	                    items[0].getAsEntry)) {
	                return this._handleFileTreeEntries(
	                    $.map(items, function (item) {
	                        var entry;
	                        if (item.webkitGetAsEntry) {
	                            entry = item.webkitGetAsEntry();
	                            if (entry) {
	                                // Workaround for Chrome bug #149735:
	                                entry._file = item.getAsFile();
	                            }
	                            return entry;
	                        }
	                        return item.getAsEntry();
	                    })
	                );
	            }
	            return $.Deferred().resolve(
	                $.makeArray(dataTransfer.files)
	            ).promise();
	        },
	
	        _getSingleFileInputFiles: function (fileInput) {
	            fileInput = $(fileInput);
	            var entries = fileInput.prop('webkitEntries') ||
	                    fileInput.prop('entries'),
	                files,
	                value;
	            if (entries && entries.length) {
	                return this._handleFileTreeEntries(entries);
	            }
	            files = $.makeArray(fileInput.prop('files'));
	            if (!files.length) {
	                value = fileInput.prop('value');
	                if (!value) {
	                    return $.Deferred().resolve([]).promise();
	                }
	                // If the files property is not available, the browser does not
	                // support the File API and we add a pseudo File object with
	                // the input value as name with path information removed:
	                files = [{name: value.replace(/^.*\\/, '')}];
	            } else if (files[0].name === undefined && files[0].fileName) {
	                // File normalization for Safari 4 and Firefox 3:
	                $.each(files, function (index, file) {
	                    file.name = file.fileName;
	                    file.size = file.fileSize;
	                });
	            }
	            return $.Deferred().resolve(files).promise();
	        },
	
	        _getFileInputFiles: function (fileInput) {
	            if (!(fileInput instanceof $) || fileInput.length === 1) {
	                return this._getSingleFileInputFiles(fileInput);
	            }
	            return $.when.apply(
	                $,
	                $.map(fileInput, this._getSingleFileInputFiles)
	            ).pipe(function () {
	                return Array.prototype.concat.apply(
	                    [],
	                    arguments
	                );
	            });
	        },
	
	        _onChange: function (e) {
	            var that = this,
	                data = {
	                    fileInput: $(e.target),
	                    form: $(e.target.form)
	                };
	            this._getFileInputFiles(data.fileInput).always(function (files) {
	                data.files = files;
	                if (that.options.replaceFileInput) {
	                    that._replaceFileInput(data.fileInput);
	                }
	                if (that._trigger('change', e, data) !== false) {
	                    that._onAdd(e, data);
	                }
	            });
	        },
	
	        _onPaste: function (e) {
	            var cbd = e.originalEvent.clipboardData,
	                items = (cbd && cbd.items) || [],
	                data = {files: []};
	            $.each(items, function (index, item) {
	                var file = item.getAsFile && item.getAsFile();
	                if (file) {
	                    data.files.push(file);
	                }
	            });
	            if (this._trigger('paste', e, data) === false ||
	                    this._onAdd(e, data) === false) {
	                return false;
	            }
	        },
	
	        _onDrop: function (e) {
	            var that = this,
	                dataTransfer = e.dataTransfer = e.originalEvent.dataTransfer,
	                data = {};
	            if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
	                e.preventDefault();
	            }
	            this._getDroppedFiles(dataTransfer).always(function (files) {
	                data.files = files;
	                if (that._trigger('drop', e, data) !== false) {
	                    that._onAdd(e, data);
	                }
	            });
	        },
	
	        _onDragOver: function (e) {
	            var dataTransfer = e.dataTransfer = e.originalEvent.dataTransfer;
	            if (this._trigger('dragover', e) === false) {
	                return false;
	            }
	            if (dataTransfer && $.inArray('Files', dataTransfer.types) !== -1) {
	                dataTransfer.dropEffect = 'copy';
	                e.preventDefault();
	            }
	        },
	
	        _initEventHandlers: function () {
	            if (this._isXHRUpload(this.options)) {
	                this._on(this.options.dropZone, {
	                    dragover: this._onDragOver,
	                    drop: this._onDrop
	                });
	                this._on(this.options.pasteZone, {
	                    paste: this._onPaste
	                });
	            }
	            this._on(this.options.fileInput, {
	                change: this._onChange
	            });
	        },
	
	        _destroyEventHandlers: function () {
	            this._off(this.options.dropZone, 'dragover drop');
	            this._off(this.options.pasteZone, 'paste');
	            this._off(this.options.fileInput, 'change');
	        },
	
	        _setOption: function (key, value) {
	            var refresh = $.inArray(key, this._refreshOptionsList) !== -1;
	            if (refresh) {
	                this._destroyEventHandlers();
	            }
	            this._super(key, value);
	            if (refresh) {
	                this._initSpecialOptions();
	                this._initEventHandlers();
	            }
	        },
	
	        _initSpecialOptions: function () {
	            var options = this.options;
	            if (options.fileInput === undefined) {
	                options.fileInput = this.element.is('input[type="file"]') ?
	                        this.element : this.element.find('input[type="file"]');
	            } else if (!(options.fileInput instanceof $)) {
	                options.fileInput = $(options.fileInput);
	            }
	            if (!(options.dropZone instanceof $)) {
	                options.dropZone = $(options.dropZone);
	            }
	            if (!(options.pasteZone instanceof $)) {
	                options.pasteZone = $(options.pasteZone);
	            }
	        },
	
	        _create: function () {
	            var options = this.options;
	            // Initialize options set via HTML5 data-attributes:
	            $.extend(options, $(this.element[0].cloneNode(false)).data());
	            this._initSpecialOptions();
	            this._slots = [];
	            this._sequence = this._getXHRPromise(true);
	            this._sending = this._active = 0;
	            this._initProgressObject(this);
	            this._initEventHandlers();
	        },
	
	        // This method is exposed to the widget API and allows to query
	        // the widget upload progress.
	        // It returns an object with loaded, total and bitrate properties
	        // for the running uploads:
	        progress: function () {
	            return this._progress;
	        },
	
	        // This method is exposed to the widget API and allows adding files
	        // using the fileupload API. The data parameter accepts an object which
	        // must have a files property and can contain additional options:
	        // .fileupload('add', {files: filesList});
	        add: function (data) {
	            var that = this;
	            if (!data || this.options.disabled) {
	                return;
	            }
	            if (data.fileInput && !data.files) {
	                this._getFileInputFiles(data.fileInput).always(function (files) {
	                    data.files = files;
	                    that._onAdd(null, data);
	                });
	            } else {
	                data.files = $.makeArray(data.files);
	                this._onAdd(null, data);
	            }
	        },
	
	        // This method is exposed to the widget API and allows sending files
	        // using the fileupload API. The data parameter accepts an object which
	        // must have a files or fileInput property and can contain additional options:
	        // .fileupload('send', {files: filesList});
	        // The method returns a Promise object for the file upload call.
	        send: function (data) {
	            if (data && !this.options.disabled) {
	                if (data.fileInput && !data.files) {
	                    var that = this,
	                        dfd = $.Deferred(),
	                        promise = dfd.promise(),
	                        jqXHR,
	                        aborted;
	                    promise.abort = function () {
	                        aborted = true;
	                        if (jqXHR) {
	                            return jqXHR.abort();
	                        }
	                        dfd.reject(null, 'abort', 'abort');
	                        return promise;
	                    };
	                    this._getFileInputFiles(data.fileInput).always(
	                        function (files) {
	                            if (aborted) {
	                                return;
	                            }
	                            data.files = files;
	                            jqXHR = that._onSend(null, data).then(
	                                function (result, textStatus, jqXHR) {
	                                    dfd.resolve(result, textStatus, jqXHR);
	                                },
	                                function (jqXHR, textStatus, errorThrown) {
	                                    dfd.reject(jqXHR, textStatus, errorThrown);
	                                }
	                            );
	                        }
	                    );
	                    return this._enhancePromise(promise);
	                }
	                data.files = $.makeArray(data.files);
	                if (data.files.length) {
	                    return this._onSend(null, data);
	                }
	            }
	            return this._getXHRPromise(false, data && data.context);
	        }
	
	    });
	
	}));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true, unparam: true*/
	
	"use strict";
	
	var $ = __webpack_require__(1);
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	
	//-------------------------------------------
	function Upload(element, valueAccessor, isDisabled, multiple) {
	    this.dataType = "json";
	    this.dragoverClass = "in";
	    this.valueAccessor = valueAccessor;
	    this.isDisabled = isDisabled;
	    this.url = pli.resolveUrl('~/Upload');
	    this.$element = $(element);
	    this.$container = this.$element.closest("li");
	    this.dropZone = this.$dropZone = this.$container.closest(".dropZone");
	    this.$dragMessage = this.$dropZone.find(".dragMessage");
	    this.multiple = multiple;
	    this.fileInput = this.$file = $("<input type=\"file\" name=\"files[]\"" + (this.multiple ? " multiple=\"multiple\"" : "") + " />");
	
	    this._clearDragover = this._clearDragover.bind(this);
	    this.add = this.add.bind(this);
	    this.done = this.done.bind(this);
	    this.dragover = this.dragover.bind(this);
	    this.fail = this.fail.bind(this);
	    this.progress = this.progress.bind(this);
	}
	
	
	//-------------------------------------------
	Upload.prototype.add = function addUpload(e, data) {
	    /// <summary>
	    /// Calls attachFiles on the grid view models and
	    /// automatically starts uploading files.
	    /// </summary>
	    var value = this.valueAccessor();
	    if (!value || typeof value.attachFiles !== "function") {
	        throw new Error("geoUploadButton valueAccessor requires attachFiles function");
	    }
	    data.context = value.attachFiles(data.files); // store attached files update in (done, fail, progress) handlers
	    data.submit();
	};
	
	
	//-------------------------------------------
	Upload.prototype.done = function uploadDone(e, data) {
	    /// <summary>
	    /// Updates the state of uploaded files to done.
	    /// Includes the id used to identify the uploaded
	    /// file.
	    /// </summary>
	    var i, l, f;
	    for (i = 0, l = data.context.length; i < l; i += 1) {
	        f = data.context[i];
	        f.updateAttachedFile("done", data.result && data.result[i]);
	    }
	};
	
	
	//-------------------------------------------
	Upload.prototype.dragover = function uploadDragover() {
	    /// <summary>
	    /// The dragover event is contiuously triggered while
	    /// dragging a file over the dropzone.  This method ensures
	    /// the dragoverClass is added/removed on the dropZone.
	    /// </summary>
	    if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	    } else {
	        this.$dropZone.addClass(this.dragoverClass);
	        if (this.$dragMessage) {
	            this.$dragMessage.offset({ top: this.$dropZone.offset().top });
	            this.$dragMessage.outerHeight(this.$dropZone.outerHeight());
	        }
	    }
	    this.timeout = setTimeout(this._clearDragover, 100);
	};
	
	
	//-------------------------------------------
	Upload.prototype.fail = function uploadFail(e, data) {
	    /// <summary>
	    /// Updates the state of uploaded files to fail
	    /// </summary>
	    var i, l, f;
	    for (i = 0, l = data.context.length; i < l; i += 1) {
	        f = data.context[i];
	        f.updateAttachedFile("fail", "Upload failed. Please try again.");
	    }
	};
	
	
	//-------------------------------------------
	Upload.prototype.progress = function uploadProgress(e, data) {
	    /// <summary>
	    /// Updates the progress of uploaded files.
	    /// </summary>
	    var i, l, f, p = parseInt(data.loaded / data.total * 100, 10);
	    for (i = 0, l = data.context.length; i < l; i += 1) {
	        f = data.context[i];
	        f.updateAttachedFile("busy", p);
	    }
	};
	
	
	//-------------------------------------------
	Upload.prototype._clearDragover = function uploadClearDragover() {
	    /// <summary>
	    /// Removes dragoverClass from dropzone when
	    /// no longer dragging file.
	    /// </summary>
	    this.$dropZone.removeClass(this.dragoverClass);
	    this.timeout = null;
	};
	
	
	//-------------------------------------------
	Upload.prototype._destroy = function destroyUpload() {
	    this.$element("destroy");
	    this.$container.remove(this.$file);
	    if (this.isDisabledSubscription && typeof this.isDisabledSubscription.dispose === "function") {
	        this.isDisabledSubscription.dispose();
	    }
	};
	
	
	//-------------------------------------------
	Upload.prototype._init = function initUpload() {
	    this.$container.append(this.$file);
	    this.$element.fileupload(this);
	    if (ko.isObservable(this.isDisabled)) {
	        this.isDisabledSubscription = this.isDisabled.subscribe(this._updateState, this);
	        this._updateState(this.isDisabled());
	    }
	};
	
	
	//-------------------------------------------
	Upload.prototype._updateState = function updateUploadState(value) {
	    this.$element.fileupload(value === true ? "disable" : "enable");
	};
	
	
	//-------------------------------------------
	ko.bindingHandlers.geoUploadButton = {
	    init: function geoUploadButton(element, valueAccessor, allBindingsAccessor) {
	        var upload = new Upload(element, valueAccessor, allBindingsAccessor().geoUploadButtonDisabled, allBindingsAccessor().multiple);
	        upload._init();
	    }
	};
	
	// prevent default file drag and drop (only allow over drop zone)
	$(document).on('drop dragover', function preventDefaultDrop(e) {
	    e.preventDefault();
	    return false;
	});
	


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	"use strict";
	
	var ko = __webpack_require__(457);
	
	//-------------------------------------------
	function FileViewModel() {
	
	    this.id = ko.observable();
	    this.fileName = ko.observable();
	
	    // non-serialized properties
	    this.extras = function FileViewModelExtras() { return; };
	    this.extras.uploadProgress = ko.observable();
	    this.extras.uploadState = ko.observable();
	    this.extras.uploadMessage = ko.observable();
	    this.extras.allowedExtensions = null;  // Support for multiple file extensions (ie. this.extras.allowedExtensions = "xls,jpg,png,pdf")
	}
	
	//-------------------------------------------
	FileViewModel.prototype.reset = function resetFileViewModel() {
	    this.id(null);
	    this.fileName(null);
	    this.extras.uploadProgress(null);
	    this.extras.uploadState(null);
	    this.extras.uploadMessage(null);
	};
	
	//-------------------------------------------
	FileViewModel.prototype.attachFiles = function attachFile(files) {
	    /// <summary>
	    /// Attaches uploaded file to the view model
	    /// </summary>
	
	    if (files.length === 1) {
	        // set values for file
	        this.fileName(files[0].name);
	
	        if (this.validateFileExtension()) {
	            this.extras.uploadProgress("0%");
	
	            var f = [];
	            f[0] = this;
	            return f;
	        }
	
	        this.updateAttachedFile("fail", "Invalid file '" + this.fileName() + "'.  Only '" + this.extras.allowedExtensions + "' file types are allowed.");
	    }
	
	    return null;
	};
	
	//-------------------------------------------
	FileViewModel.prototype.updateAttachedFile = function updateFile(state, value) {
	    /// <summary>
	    /// Updates the state of an attached file.
	    /// </summary>
	    switch (state) {
	    case "done":
	        this.id(value || null);
	        this.extras.uploadProgress(null);
	        break;
	    case "fail":
	        this.extras.uploadProgress(null);
	        this.extras.uploadMessage(value);
	        break;
	    default:
	        this.extras.uploadProgress(typeof value === "number" ? "".concat(value).concat("%") : null);
	        break;
	    }
	
	    this.extras.uploadState(state);
	};
	
	//-------------------------------------------
	FileViewModel.prototype.getFileExtension = function getFileExtension() {
	    if (this.fileName()) {
	        return this.fileName().split('.').pop().toLowerCase();
	    }
	
	    return null;
	};
	
	//-------------------------------------------
	FileViewModel.prototype.validateFileExtension = function validateFileExtension() {
	    if (!this.extras.allowedExtensions) {
	        return true;
	    }
	
	    // Split extensions into array if there are multiple file extensions
	    var validExtensions = this.extras.allowedExtensions.toLowerCase().split(","),
	        fileExtension = this.getFileExtension();
	
	    return ko.utils.arrayFirst(validExtensions, function (ext) { return (fileExtension === ext); });
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = function createFileViewModel() {
	    return new FileViewModel();
	};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true, nomen: true */
	
	"use strict";
	
	var ko = __webpack_require__(457);
	
	//-------------------------------------------
	function UploadViewModelExtras(factories) {
	    this.file = factories.createFileViewModel();
	    this.iconClass = ko.computed(this._getIconClass, this);
	    this.message = ko.computed(this._getMessage, this);
	    this.fileDragDropSupported = !!window.FileReader;
	}
	
	//-------------------------------------------
	UploadViewModelExtras.prototype._getIconClass = function getIconClass() {
	    switch (this.file.extras.uploadState()) {
	    case "done":
	        return "sprite-checked-16";
	    case "fail":
	        return "sprite-warning-16";
	    default:
	        return "sprite-progress-15 sprite-spin";
	    }
	};
	
	//-------------------------------------------
	UploadViewModelExtras.prototype._getMessage = function getMessage() {
	    switch (this.file.extras.uploadState()) {
	    case "done":
	        if (typeof this.getUploadCompleteMessage === "function") {
	            return this.getUploadCompleteMessage(this.file.fileName());
	        }
	
	        return "File " + this.file.fileName() + " has been uploaded.";
	    case "fail":
	        return this.file.extras.uploadMessage();
	    default:
	        return "Uploading file " + this.file.fileName() + ". Completed: " + this.file.extras.uploadProgress();
	    }
	};
	
	module.exports = function createUploadViewModelExtras(factories) {
	    return new UploadViewModelExtras(factories);
	};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	"use strict";
	
	var $ = __webpack_require__(1);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	var viewModelInit = __webpack_require__(465);
	
	var dependentRequiredBehaviour = __webpack_require__(496);
	var ko = __webpack_require__(510);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Class "ReportCriteriaViewModel"
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	function ReportCriteriaViewModel(factories) {
	    if (!(this instanceof ReportCriteriaViewModel)) { return new ReportCriteriaViewModel(factories); } // if new was not used, force it now
	
	    //--------------------------------------------------
	    this.extras = function ReportCriteriaViewModelExtras() { return; };
	    this.extras.reportTypeTitle = ko.observable(null);
	    this.extras.description = ko.observable(null);
	    this.extras.requireReportName = ko.observable(true);
	    this.extras.forceRun = ko.observable(false);
	    this.extras.saveRunConfirmForm = pli.forms.registry.saveRunConfirmationForm;
	
	    this.id = this.reportName = pliObservable(null, { trigger: this.extras.requireReportName, expectedValue: true }, dependentRequiredBehaviour);
	    this.guid = ko.observable(null);
	    this.reportType = "Unknown";
	
	    if (factories) {
	        if (factories.main) {
	            this.main = ReportCriteriaViewModel.prototype._extend(new factories.main(factories));
	        }
	
	        if (factories.advanced) {
	            this.advanced = ReportCriteriaViewModel.prototype._extend(new factories.advanced(factories));
	        }
	
	        if (factories.computeErrorsCount) {
	            this.extras.errorsCountFlat = ko.computed(factories.computeErrorsCount, this);
	            this.extras.errorsCountMain = ko.computed(ReportCriteriaViewModel.prototype._computeErrorsCountMain, this);
	            this.extras.errorsCount = ko.computed(ReportCriteriaViewModel.prototype._computeErrorsCount, this);
	        }
	
	        if (typeof factories.getReportType === "function") {
	            this.reportType = factories.getReportType();
	        }
	
	        if (typeof factories.setReportHeaderInfo === "function") {
	            factories.setReportHeaderInfo(this.reportType, this.extras.reportTypeTitle, this.extras.description);
	        }
	
	        if (typeof factories.loadWidgetRecord === "function") {
	            this._loadWidgetRecord = factories.loadWidgetRecord;
	        }
	    }
	
	    this.extras.title = ko.computed(ReportCriteriaViewModel.prototype._computeTitle, this);
	
	    if ((this.main && this.main.isCategoryGroupLoaded) || (this.advanced && this.advanced.isCategoryGroupLoaded)) {
	        this._isLoaded = $.when(this.main.isCategoryGroupLoaded, this.advanced.isCategoryGroupLoaded);
	    }
	
	    this._reportStartHandler = this._reportStartHandler.bind(this);
	}
	
	//--------------------------------------------------
	ReportCriteriaViewModel.prototype.closeConfirm = function cancelReportConfirm() {
	    this.extras.saveRunConfirmForm.close();
	};
	
	//--------------------------------------------------
	ReportCriteriaViewModel.prototype.loadViewModel = function loadViewModel(record) {
	    if (window.console && window.console.group) { window.console.group("ReportCriteriaViewModel.loadViewModel", record); }
	
	    if (!record) { record = {}; }
	
	    this.guid(record.guid || null);
	    this.id.load(record.id);
	    this.reportName.load(record.reportName || null);
	
	    if (this.main && typeof this.main.loadViewModel === "function") {
	        this.main.loadViewModel(record.main);
	    }
	
	    if (this.advanced && typeof this.advanced.loadViewModel === "function") {
	        this.advanced.loadViewModel(record.advanced);
	    }
	
	    if (window.console && window.console.groupEnd) { window.console.groupEnd(); }
	};
	
	//--------------------------------------------------
	ReportCriteriaViewModel.prototype.run = function runReport() {
	    if (this.extras.isReportDirty() && !this.extras.forceRun()) {
	        pli.forms.open(this.extras.saveRunConfirmForm.id);
	        return;
	    }
	
	    // When running a report, having a report name filled shouldn't be required
	    // This flag is to turn off the requirement during validation of view model
	    // before running the report
	    this.extras.requireReportName(false);
	
	    if (!this.validateDeep()) {
	        this.extras.requireReportName(true);
	        return;
	    }
	
	    this.extras.requireReportName(true);
	
	    // Used in the report generation page to display the title in the header
	    pli.reportTitle = this.extras.title();
	
	    // Build report criteria only object
	    var criteria = {};
	    ko.utils.extend(criteria, this.main);
	    ko.utils.extend(criteria, this.advanced);
	
	    // start report
	    pli.call({
	        name: "Geo-Report-Start",
	        data: { reportId: this.reportType, reportData: ko.toJSON(criteria), criteriaPoco: ko.toJS(this) }
	    }).always(this._reportStartHandler);
	};
	
	//--------------------------------------------------
	ReportCriteriaViewModel.prototype.runOnly = function runReportOnly() {
	    this.extras.forceRun(true);
	    this.run();
	    this.extras.forceRun(false);
	
	    this.closeConfirm();
	};
	
	//--------------------------------------------------
	ReportCriteriaViewModel.prototype.saveAndRun = function saveAndRunReport() {
	    // Create a subscription to run report after report is saved.
	    if (!this.extras.runAfterSaveSubscription) {
	        this.extras.runAfterSaveSubscription = ko.computed(ReportCriteriaViewModel.prototype._runReportAfterSave, this);
	    }
	
	    // Save report
	    this.safeSaving();
	
	    // Close dialog
	    this.closeConfirm();
	};
	
	//--------------------------------------------------
	ReportCriteriaViewModel.prototype._computeTitle = function computeReportTitle() {
	    if (this.reportName()) {
	        return this.extras.reportTypeTitle() + " - " + this.reportName();
	    }
	
	    return this.extras.reportTypeTitle();
	};
	
	//-------------------------------------------
	// Calculates number of errors on all navigation pages for report criteria
	ReportCriteriaViewModel.prototype._computeErrorsCount = function ReportCriteriaViewModelComputeErrorsCount() {
	    var sum = this.extras.errorsCountFlat();
	
	    if (this.main && this.main.extras && this.main.extras.errorsCount) {
	        sum += this.main.extras.errorsCount();
	    }
	
	    if (this.advanced && this.advanced.extras && this.advanced.extras.errorsCount) {
	        sum += this.advanced.extras.errorsCount();
	    }
	
	    return sum;
	};
	
	//-------------------------------------------
	// Since report name textbox is on the main tab on the UI but is in the ReportCriteriaViewModel,
	// we must add the error count for report name to the main error count
	ReportCriteriaViewModel.prototype._computeErrorsCountMain = function ReportCriteriaViewModelComputeErrorsCountMain() {
	    var sum = this.extras.errorsCountFlat();
	
	    if (this.main && this.main.extras && this.main.extras.errorsCount) {
	        sum += this.main.extras.errorsCount();
	    }
	
	    return sum;
	};
	
	//-------------------------------------------
	// Extends viewModel with extras.errorsCount
	ReportCriteriaViewModel.prototype._extend = function ReportCriteriaViewModelAddExtras(viewModel) {
	    if (viewModel) {
	        if (!viewModel.extras) {
	            viewModel.extras = function viewModelExtras() { return; };
	        }
	
	        viewModel.extras.errorsCount = ko.computed(viewModelInit.computeErrorsCount, viewModel);
	    }
	
	    return viewModel;
	};
	
	//--------------------------------------------------
	// Loads criterias values if passed in from query string
	ReportCriteriaViewModel.prototype._loadCriteriasFromQueryString = function loadCriteriasFromQueryString(queryString) {
	    var queries = queryString.split("&"),
	        queryObject = [],
	        record,
	        pair,
	        i,
	        l,
	        self = this;
	
	    if (queries.length === 0) { return; }
	
	    // Parse query string into an array of key/value pairs
	    for (i = 0, l = queries.length; i < l; i += 1) {
	        pair = queries[i].split('=');
	        queryObject[pair[0]] = pair[1];
	    }
	
	    // Validate the parameters
	    if (queryObject.date && !ko.reportUtils.validateParametersFromUpcomingEvents(queryObject.date)) {
	        return;
	    }
	
	    // Duplicating existing criterias, return no need to load widget record
	    if (queryObject.duplicate) {
	        if (this._isLoaded) {
	            this._isLoaded.done(function () {
	                self.duplicate();
	            });
	        } else {
	            this.duplicate();
	        }
	
	        return;
	    }
	
	    if (typeof this._loadWidgetRecord === "function") {
	        record = this._loadWidgetRecord(queryObject);
	
	        if (record.main && this.main && typeof this.main.loadFromWidget === "function") {
	            this.main.loadFromWidget(record.main);
	        }
	
	        if (record.advanced && this.advanced && typeof this.advanced.loadFromWidget === "function") {
	            this.advanced.loadFromWidget(record.advanced);
	        }
	    }
	
	    if (queryObject.run) {
	        if (this._isLoaded) {
	            this._isLoaded.done(function () {
	                self.runOnly();
	            });
	        } else {
	            this.runOnly();
	        }
	    }
	};
	
	//--------------------------------------------------
	//  Handles start percent and status call response
	ReportCriteriaViewModel.prototype._reportStartHandler = function ReportCriteriaViewModelReportStartHandler(response) {
	    if (!response.isError && response.result) {
	        pli.dialog.open({ targetUrl: "~~/Reports/Generate#" + response.result.token, width: 1000, height: 700, windowType: "window" });
	    }
	};
	
	//--------------------------------------------------
	//  Handles running the report after saving
	ReportCriteriaViewModel.prototype._runReportAfterSave = function computeRunReportAfterSave() {
	    if (this.extras.state() === "ready.saved" && this.extras.runAfterSaveSubscription) {
	        this.run();
	
	        // Dispose subscription
	        this.extras.runAfterSaveSubscription.dispose();
	        this.extras.runAfterSaveSubscription = null;
	    }
	};
	
	//-------------------------------------------
	ReportCriteriaViewModel.prototype.validateDeep = viewModelInit.validateDeep;
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = ReportCriteriaViewModel;
	module.exports.viewModelPrototype = ReportCriteriaViewModel.prototype;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var $ = __webpack_require__(1);
	var ko = __webpack_require__(457);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Help functions for reporting criterias
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function computeLegalDescription() {
	    /// <summary>
	    /// Computes the label for the legal field based on
	    /// NTS -> Units otherwise Sections
	    ///
	    /// Expects this to be legal Format value
	    /// </summary>
	
	    /*jshint validthis: true */
	    switch (ko.utils.unwrapObservable(this)) {
	    case "FREE":
	        return "Enter any text";
	    case "NTS":
	        return "Example 94 A 12 H";
	    case "PLSS":
	        return "Example 5N 1W";
	    default:
	        return "Example 25 10 4";
	    }
	}
	
	
	//-------------------------------------------
	function getRawValuesFromMultiSelect() {
	    /// <summary>
	    /// Get items from MultiSelect selected by user(items and groups without replace),
	    /// e.g. if selected "Us" it returns "Us"(instead of "PANDELL", "PANDELLSSH" )
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be ko.observable
	    /// </remarks>
	
	    /*jshint validthis: true */
	    var v = this.multiSelectViewModel;
	    if (v && ko.isObservable(v.selectedItems) && $.isArray(v.selectedItems())) {
	        return ko.utils.arrayMap(v.selectedItems(), function (item) {
	            return item.value;
	        });
	    }
	}
	
	
	//-------------------------------------------
	function validateParametersFromUpcomingEvents(paramDate) {
	    var dateFormatRegEx = /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\-\d{4}$/i;
	
	    return (dateFormatRegEx.test(paramDate));
	}
	
	
	//-------------------------------------------
	function validateDateParam(paramDate) {
	    var dateFormatRegEx = /^(Jan|January|Feb|February|Mar|March|Apr|April|May|Jun|June|Jul|July|Aug|August|Sep|September|Oct|October|Nov|November|Dec|December)(\-| )\d{4}$/i;
	
	    return (dateFormatRegEx.test(paramDate));
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	if (!ko.reportUtils) { ko.reportUtils = {}; }
	
	ko.reportUtils.computeLegalDescription = computeLegalDescription;
	ko.reportUtils.getRawValuesFromMultiSelect = getRawValuesFromMultiSelect;
	ko.reportUtils.validateParametersFromUpcomingEvents = validateParametersFromUpcomingEvents;
	ko.reportUtils.validateDateParam = validateDateParam;
	
	module.exports = ko;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(512);


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	"use strict";
	
	var pli = __webpack_require__(380);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Define the standard keyboard shortcut
	// schema for GeoNexus.  The first key
	// combination defined for each entry
	// should be used when shortcut is displayed.
	pli.keys.setSchema({
	    "Accept": "Enter",
	    "Back": "Ctrl+Up, Command+Up, Alt+Up",
	    "Close": "Esc",
	    "Copy": "Ctrl+K, Command+K",
	    "Delete": "Ctrl+Delete, Command+Delete",
	    "Duplicate": "Ctrl+D, Command+D",
	    "Help": "F1",
	    "Home": "Ctrl+H, Command+H",
	    "Link": "Ctrl+L, Command+L",
	    "New": "Ctrl+I, Command+I",
	    "NextSibling": "Ctrl+>, Command+>",
	    "NextTab": "Ctrl+], Command+]",
	    "Open": "Ctrl+O, Command+O",
	    "PreviousSibling": "Ctrl+<, Command+<",
	    "PreviousTab": "Ctrl+[, Command+[",
	    "Print": "Ctrl+P, Command+P",
	    "Save": "Ctrl+S, Command+S, F2"
	});
	
	//-------------------------------------------
	// Define the default keymap for forms
	// should be extended by root form and
	// modal dialogs
	pli.config.defaultKeymap = {
	    "Back": false,
	    "Close": false,
	    "F3": false,
	    "F5": false,
	    "Help": false,
	    "Open": false,
	    "Print": false,
	    "Save": false
	};


/***/ }),
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(519);


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "FormattedBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Adds formatted observable in places where
	// raw was used to access the formatted value.
	function FormattedBehaviour() {
	    return this;
	}
	
	//-------------------------------------------
	FormattedBehaviour.prototype.init = function FormattedBehaviourInit() {
	    this.formatted = ko.observable("");
	    this.subscribe(FormattedBehaviour.prototype._valueUpdated, this);
	    FormattedBehaviour.prototype._valueUpdated.call(this);
	};
	
	//-------------------------------------------
	FormattedBehaviour.prototype._valueUpdated = function FormattedBehaviourValueUpdated() {
	    this.formatted(this.format());
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Export
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = new FormattedBehaviour();


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	"use strict";
	
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	
	var SelectionFormViewModel = __webpack_require__(521);
	var selectionFormUtils = __webpack_require__(525);
	
	var selectionForm = pli.forms.registry.selectionForm;
	if (typeof selectionForm !== "object") { throw new Error("Selection form element could not be found - did you render it using CreateSelectionForm?"); }
	
	selectionForm.viewModel = new SelectionFormViewModel(ko, pli, selectionForm);
	selectionForm.utils = selectionFormUtils;
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = selectionForm;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var slickGrid = __webpack_require__(522);
	var AlternateGrouping = __webpack_require__(524);
	
	//-------------------------------------------
	function adaptData(data) {
	    /// <summary>
	    /// Adapts the grid data JSON object to functional version for grid
	    /// </summary>
	    return {
	        getColumns: function getItem(key) { return data.views && data.views[key]; },
	        getItem:    function getItem(i) { return data.items && data.items[i]; },
	        getLength:  function getLength() { return data.items && data.items.length; },
	        getIndex:   function getIndex(i) { return data.indices ? data.indices[i] : null; },
	        getGroups:  function getGroups(i) { return data.groups ? data.groups[i] : null; }
	    };
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "SelectionFormViewModel" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function SelectionFormViewModel(ko, pli, selectionForm) {
	    /// <summary>
	    /// Create new instance of viewmodel for
	    /// selection form dialog.
	    /// <summary>
	    this.data = ko.observable(null);
	    this.iconClass = ko.observable(""); // we need an extra observable to set "overwriteCss" flag on it (otherwise we could just use text)
	    this.phrase = ko.observable(""); // current search phrase (used during server search)
	    this.phraseFocused = ko.observable(false);
	    this.state = ko.observable("ready");
	    this.state.progressVisible = ko.computed(function () { return this().indexOf("ing") > 0; }, this.state);
	    this.text = ko.observable(this._textDefaults); // currently active UI texts and labels ("_textDefaults" combined with "options.text" in "open" method)
	    this.progressButton = ko.observable(this._textDefaults.searchingButton);
	    this.progressTitle = ko.observable(this._textDefaults.searchingTitle);
	    this.progressSubtitle = ko.observable(this._textDefaults.searchingSubtitle);
	    this._call = null; // currently active PLI call (either search or get-details)
	    this._options = null; // will be set in every "open", reset in "close" calls
	    this._slick = null; // will be created every time data changes
	    this._$grid = null; // will be initialized in first "open" call
	
	    this.accept = this.accept.bind(this);
	    this.close = selectionForm.close = this.close.bind(selectionForm);
	    this.closeProgress = this.closeProgress.bind(this);
	    this.open = selectionForm.open = this.open.bind(selectionForm);
	    this.search = this.search.bind(this);
	    this._createGrid = this._createGrid.bind(this);
	    this._focusPhrase = function () { this.phraseFocused(true); }.bind(this);
	    this._getDetailsComplete = this._getDetailsComplete.bind(this);
	    this._handleGridKeyDown = this._handleGridKeyDown.bind(this);
	    this._searchComplete = this._searchComplete.bind(this);
	    this._selectionChanged = this._selectionChanged.bind(this);
	
	    pli.keys.registerKeymap(selectionForm.id, ko.utils.extend(
	        ko.utils.extend({}, pli.config.defaultKeymap),
	        {
	            "Accept": this.accept,
	            "Close": this.close
	        }
	    ));
	    selectionForm.page.keymap = selectionForm.id;
	
	    this.data.subscribe( // we need to delay _createGrid (relative to data-change-notification), because SlickGrid needs its container to be visible + container will be made visible by reacting to data-change-notification
	        function selectionFormDataChanged() { setTimeout(this, 1); }, // "this" is bound to "_createGrid" method
	        this._createGrid
	    );
	}
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype.accept = function acceptSelectionFormViewModel() {
	    /// <summary>
	    /// Accept currently selected records.
	    /// </summary>
	    switch (this.state()) {
	    case "ready":
	        return this.search();
	    case "searchingNow":
	    case "searchingFailed":
	    case "gettingNow":
	    case "gettingFailed":
	        return this.closeProgress();
	    case "selectable":
	    case "selected":
	        if (this.phraseFocused()) {
	            this.search();
	        } else {
	            var selected = this._slick && this._slick.getSelectedRows();
	            if (selected.length) {
	                // convert selected row indexes to items
	                var i, l, items = [];
	                for (i = 0, l = selected.length; i < l; i += 1) {
	                    items.push(this._slick.getDataItem(selected[i]));
	                }
	
	                // if caller requested search-only selection, notify them
	                if (!this._options.getDetailsApi) {
	                    var onAccepted = this._options.onAccepted,
	                        onAcceptedContext = this._options.onAcceptedContext || this._options;
	                    this.close();
	                    if (typeof onAccepted === "function") {
	                        onAccepted.call(onAcceptedContext, items);
	                    }
	                } else {
	                    // caller requested search-getDetails selection, get details now
	                    this.state("gettingNow");
	                    this.progressTitle(this.text().gettingTitle);
	                    this.progressSubtitle(this.text().gettingSubtitle);
	                    this.progressButton(this.text().gettingButton);
	                    var getRequestData = (this._options.getDetailsDataBuilder
	                        ? this._options.getDetailsDataBuilder(items)
	                        : { id: ko.utils.arrayMap(items, function (row) { return row[row.length - 1]; }) }
	                    );
	                    this._call = pli.call({
	                        name: this._options.getDetailsApi,
	                        data: getRequestData
	                    });
	                    this._call.always(this._getDetailsComplete);
	                }
	            }
	        }
	        break;
	    }
	    return false;
	};
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype.close = function closeSelectionForm(options) {
	    /// <summary>
	    /// Close this selection form. If a call
	    /// is currently active (searching or getting
	    /// details), "close" method will cancel the call
	    /// (instead of closing the selection form).
	    /// This behaviour can be suppressed by using
	    /// "{ force: true }" options object (forced-close).
	    /// </summary>
	    /// <remarks>
	    /// Assumes "this" is form, and "this.viewModel"
	    /// is an instance of SelectionFormViewModel.
	    /// <remarks>
	    var state = this.viewModel.state();
	    if (options && options.force) { // forced close
	        state = "ready";
	    }
	
	    switch (state) {
	    case "searchingNow":
	    case "searchingFailed":
	    case "gettingNow":
	    case "gettingFailed":
	        return this.viewModel.closeProgress();
	
	    default:
	        pli.forms.close(this.id);
	        this.viewModel.data(null);
	        this.viewModel._call = null;
	        this.viewModel._options = null;
	        return false;
	    }
	};
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype.closeProgress = function closeSelectionFormProgressView() {
	    /// <summary>
	    /// Either cancel current PLI call OR dismiss
	    /// failure screen for either initial search
	    /// or get-details PLI call.
	    /// </summary>
	    this._call = null;
	
	    switch (this.state()) {
	    case "searchingNow":
	    case "searchingFailed":
	        this.state("ready");
	        this.phraseFocused(true);
	        break;
	    case "gettingNow":
	    case "gettingFailed":
	        this.state("selected");
	        this._slick.focus();
	        break;
	    }
	
	    return false;
	};
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype.search = function selectionFormViewModelSearch() {
	    /// <summary>
	    /// Execute a search on the server using
	    /// the user-specified phrase.
	    /// </summary>
	    switch (this.state()) {
	    case "ready":
	    case "selectable":
	    case "selected":
	        this.state("searchingNow");
	        this.data(null);
	        this.progressTitle(this.text().searchingTitle);
	        this.progressSubtitle(this.text().searchingSubtitle);
	        this.progressButton(this.text().searchingButton);
	        this._call = pli.call({
	            name: this._options.searchApi,
	            data: {
	                criteria: this.phrase()
	            }
	        });
	        this._call.always(this._searchComplete);
	        break;
	    }
	    return false;
	};
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype.open = function openSelectionForm(options) {
	    /// <summary>
	    /// Loads a search selection dialog.
	    /// </summary>
	    /// <remarks>
	    /// Assumes "this" is a form object, and "this.viewModel"
	    /// is an instance of SelectionFormViewModel.
	    /// <remarks>
	
	    // validation
	    if (typeof options !== "object" || typeof options.searchApi !== "string") { throw new Error("options.searchApi is required (string)"); }
	    if (typeof options.onAccepted !== "function") { throw new Error("options.onAccepted is required (function)"); }
	
	    // reset
	    var viewModel = this.viewModel; // see remarks
	    viewModel._options = options;
	    viewModel.data(null);
	    viewModel.phrase("");
	    viewModel.state("ready");
	    viewModel.text(ko.utils.extend(ko.utils.extend({}, viewModel._textDefaults), options.text));
	    viewModel.iconClass(viewModel.text().iconClass);
	
	    // apply knockout bindings if not bound yet
	    if (!viewModel._$grid) {
	        viewModel._$grid = this.$form.find(".grid");
	        if (this.$form.length) {
	            ko.applyBindings(viewModel, this.$form[0]); // dereference "$form" jQuery collection because Knockout expects a raw DOM node
	        }
	    }
	
	    pli.forms.open(this.id);
	    viewModel.phraseFocused(true);
	    return false;
	};
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype._createGrid = function createSelectionFormGrid() {
	    /// <summary>
	    /// Initializes a new slick grid instance
	    /// for the current data.
	    /// </summary>
	    if (this._slick) {
	        this._slick.destroy();
	        this._slick = null;
	    }
	
	    var newData = this.data.peek();
	    if (newData && this._$grid && this._$grid.length) {
	        // initialize slick.grid
	        this._slick = new slickGrid.Grid(
	            this._$grid,
	            adaptData(newData),
	            newData.views.standard,
	            { enableColumnReorder: false, multiSelect: !!this._options.multiSelect, rowHeight: 30 }
	        );
	
	        // register grid event handlers
	        this._slick.onSelectedRowsChanged.subscribe(this._selectionChanged);
	        this._slick.onKeyDown.subscribe(this._handleGridKeyDown);
	        this._slick.onDblClick.subscribe(this.accept);
	        this._slick.registerPlugin(
	            new AlternateGrouping({ defaultSort: { field: "0" } })
	        );
	
	        // set initial selection
	        this._slick.setActiveCell(0, 0);
	        this._slick.focus();
	    }
	};
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype._getDetailsComplete = function selectionFormGetDetailsComplete(response) {
	    if (!this._call || this._call.xhr !== response.clientXhr) {
	        if (window.console) { window.console.warn("Ignoring get details response:", response); }
	        return;
	    }
	
	    this._call = null;
	    if (response.isError) {
	        this.progressTitle(this.text().gettingFailedTitle);
	        this.progressSubtitle((response.result && response.result.message) || "(No details)");
	        this.progressButton(this.text().gettingFailedButton);
	        this.state("gettingFailed");
	    } else { // success
	        var onAccepted = this._options.onAccepted,
	            onAcceptedContext = this._options.onAcceptedContext || this._options;
	        this.close({ force: true });
	        if (typeof onAccepted === "function") {
	            onAccepted.call(onAcceptedContext, response.result);
	        }
	    }
	};
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype._handleGridKeyDown = function selectionFormGridKeyDown(e) {
	    /// <summary>
	    /// This is needed because of slickgrid's terrible
	    /// key-event-handling implementation.
	    /// </summary>
	    switch (e.which) {
	    case 9: // tab
	        setTimeout(this._focusPhrase, 1); // wait for slickgrid key handling to finish before changing focus
	        break;
	    case 13: // enter
	        this.accept();
	        break;
	    }
	};
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype._searchComplete = function selectionFormSearchComplete(response) {
	    if (!this._call || this._call.xhr !== response.clientXhr) {
	        if (window.console) { window.console.warn("Ignoring search response:", response); }
	        return;
	    }
	
	    this._call = null;
	    if (response.isError) {
	        this.progressTitle(this.text().searchingFailedTitle);
	        this.progressSubtitle((response.result && response.result.message) || "(No details)");
	        this.progressButton(this.text().searchingFailedButton);
	        this.state("searchingFailed");
	    } else { // success
	        this.state("selectable");
	        if (response.result && response.result.items && response.result.items.length) {
	            this.data(response.result);
	        } else {
	            this.phraseFocused(true);
	        }
	    }
	};
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype._selectionChanged = function selectionFormSelectionChanged(e, data) {
	    /// <summary>
	    /// Update state based on current slickgrid
	    /// selection (i.e. indirectly enable or
	    /// disable accept button).
	    /// </summary>
	    if (e && e.preventDefault) { e.preventDefault(); }
	    switch (this.state()) {
	    case "selectable":
	        if (data.rows.length) {
	            this.state("selected");
	        }
	        break;
	    case "selected":
	        if (!data.rows.length) {
	            this.state("selectable");
	        }
	        break;
	    }
	};
	
	
	//-------------------------------------------
	SelectionFormViewModel.prototype._textDefaults = {
	    /// <summary>
	    /// Define default texts and labels (can be
	    /// overridden in "open" method).
	    /// </summary>
	    acceptButton: "Accept",
	    cancelButton: "Cancel",
	    exampleHeader: "Examples",
	    examples: ["Calgary", "Pandell"],
	    failButton: "Stop",
	    gettingButton: "Stop load",
	    gettingFailedButton: "Dismiss",
	    gettingSubtitle: "Please wait...",
	    gettingTitle: "Loading selection details",
	    iconClass: "sprite-pickList-16",
	    instructionHtml: "Please type a search phrase into the <strong>Search</strong> box and press <strong>[Enter]</strong>",
	    searchButton: "Search",
	    searchingButton: "Stop search",
	    searchingFailedButton: "Dismiss",
	    searchingSubtitle: "Please wait...",
	    searchingTitle: "Searching",
	    searchingFailedTitle: "Search Failed",
	    title: "Selection Form"
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = SelectionFormViewModel;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Slick;
	if (console.warn) { console.warn("pli/slickgrid is deprecated and will be removed in pli@7.0"); }
	Slick = __webpack_require__(410);
	
	Slick.Grid = __webpack_require__(411);
	Slick.AlternateRowSelectionModel = __webpack_require__(523);
	Slick.AlternateGrouping = __webpack_require__(524);
	
	module.exports = Slick;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint browser: true */
	"use strict";
	
	var $ = __webpack_require__(1);
	var Slick = __webpack_require__(410);
	
	
	//-------------------------------------------
	function AlternateRowSelectionModel() {
	    /// <summary>Pli row selection plug-in for slick grid</summary>
	
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	    // Private Members
	
	    var self = {},
	        /// <summary>The current instance of the plug-in.</summary>
	
	        selectedRows = [],
	        /// <summary>The array containing the rows that are currently selected.</summary>
	
	        selectedRanges = [],
	        /// <summary>The array containing the ranges (Slick.range) that are currently selected.</summary>
	
	        pivotRow,
	        /// <summary>Determines the row to pivot shift+(up|down) from.</summary>
	
	        grid;
	        /// <summary>The current instance of slick.grid</summary>
	
	
	
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	    // Private Methods
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	    //-------------------------------------------
	    function calculateItemsPerPage() {
	        var $container = $(grid.getCanvasNode()).parent(),
	            height = $container && $container.height(),
	            options = grid.getOptions(),
	            rowHeight = options && options.rowHeight;
	        if (height > 0 && rowHeight > 0) {
	            return Math.floor(height / rowHeight) - 2; // 1 less row than a page and also exclude header
	        }
	        return 0;
	    }
	
	
	    //-------------------------------------------
	    function toRows(sourceRanges) {
	        /// <summary>Converts an array of ranges to an array of rows.</summary>
	        var rows = [], i, j, range;
	        for (i = 0; i < sourceRanges.length; i = i + 1) {
	            range = sourceRanges[i];
	            for (j = range.fromRow; j <= range.toRow; j = j + 1) {
	                rows.push(j);
	            }
	        }
	        return rows;
	    }
	
	
	    //-------------------------------------------
	    function toRanges(sourceRows) {
	        /// <summary>Converts an array of rows to an array of ranges.</summary>
	        var ranges = [], i, row;
	        for (i = 0; i < sourceRows.length; i = i + 1) {
	            row = sourceRows[i];
	            ranges.push(new Slick.Range(row, 0, row, grid.getColumns().length - 1));
	        }
	        return ranges;
	    }
	
	
	    //-------------------------------------------
	    function calculateRange(start, end) {
	        /// <summary>Calculates the includes items from start position to end position inclusive.</summary>
	        /// <param name="from">The starting position to calculate from</param>
	        /// <param name="to">The end position to calculate to</param>
	        var i, range = [];
	
	        // start is less than end (create array start - end)
	        if (start < end) {
	            for (i = start; i <= end; i = i + 1) {
	                range.push(i);
	            }
	
	        // start is greater than end (create array end - start)
	        } else if (start > end) {
	            for (i = start; i >= end; i = i - 1) {
	                range.push(i);
	            }
	
	        // start equals end (create an array containing either)
	        } else {
	            range.push(end);
	        }
	
	        return range;
	    }
	
	
	    //-------------------------------------------
	    function nextActiveRow(currentRow, cell, increment, canSelect) {
	        /// <summary>Gets the next focusable row relative to the current row.</summary>
	        /// <returns>the current cell or the next focusable cell.  null if there is not a focusable.</returns>
	        var row = currentRow,
	            i = 1;
	
	        canSelect = grid.getOptions().multiSelect !== true ? grid.canCellBeSelected : canSelect || grid.canCellBeActive;
	        while (canSelect(row, cell) !== true) {
	            row = increment(row, i);
	            if (row >= grid.getDataLength() || row < 0) {
	                row = null;
	                break;
	            }
	            i = i + 1;
	        }
	
	        return row;
	    }
	
	
	    //-------------------------------------------
	    function resolveSelection(row, cell) {
	        /// <summary>Resolves the selected rows for the current row.</summary>
	        var rows = [],
	            gridData = grid.getData(),
	            metaData;
	
	        // Add the current row if it is selectable
	        if (grid.canCellBeSelected(row, cell)) {
	            rows.push(row);
	        }
	
	        // Check for a select function on meta data and add results.
	        if ($.isFunction(gridData.getItemMetadata)) {
	            metaData = gridData.getItemMetadata(row);
	            if ($.isPlainObject(metaData) === true && typeof metaData.select === "function") {
	                rows = rows.concat(metaData.select());
	            }
	        }
	
	        return rows;
	    }
	
	
	    //-------------------------------------------
	    function calculateSelection(pivot, rows) {
	        /// <summary>Calculates the selection between the pivot and the rows specified.</summary>
	        var result;
	
	        // the active row is after the selection.
	        if (pivot > rows[rows.length - 1]) {
	            result = calculateRange(pivot, rows[0]);
	
	        // the active row is before the selection.
	        } else if (pivot < rows[0]) {
	            result = calculateRange(pivot, rows[rows.length - 1]);
	
	        // the active cell is within the selected rows.
	        } else {
	            result = rows;
	        }
	
	        return result;
	    }
	
	
	    //-------------------------------------------
	    function toggleSelected(rows, selection, forceSelected) {
	        /// <summary>updates the rows passed in and adds the selection
	        /// if the first row is not in the rows collection otherwise
	        /// removes the selection from the rows collection</summary>
	        var position;
	
	        // handle single selection.
	        if (grid.getOptions().multiSelect !== true) {
	            if (rows[0] === selection[0]) {
	                rows = [];
	            } else {
	                rows = $.extend(true, [], selection);
	            }
	            return rows;
	        }
	
	        // if the first value in the selection is selected then remove all in selection
	        if ($.inArray(selection[0], rows) > -1 && forceSelected !== true) {
	            $.each(selection, function eachSelection() {
	                position = $.inArray(this, rows);
	                if (position > -1) {
	                    rows.splice(position, 1);
	                }
	            });
	
	        // otherwise first value is not selected so add all in the selection
	        } else {
	            $.each(selection, function eachSelection() {
	                rows.push(this);
	            });
	        }
	        return rows;
	
	    }
	
	
	    //-------------------------------------------
	    function move(e, increment, canSelect) {
	        /// <summary>Handle keyboard event</summary>
	        /// <param name="canSelect">The delegate that accepts (row, cell) and returns true or
	        /// false whether this cell can be selected.</param>
	        var activeCell = grid.getActiveCell(),
	            targetRow,
	            isMultiSelect = grid.getOptions().multiSelect !== false;
	
	        if (activeCell === undefined || activeCell === null) {
	            return false;
	        }
	
	        targetRow = nextActiveRow(increment(activeCell.row, 0), activeCell.cell, increment, canSelect);
	        if (targetRow === undefined || targetRow === null) {
	            return false;
	        }
	
	        // select everything from pivot cell to target cell.
	        if (e.shiftKey === true && isMultiSelect === true) {
	            pivotRow = typeof pivotRow === "number" ? pivotRow : activeCell.row;
	            self.setSelectedRows(calculateSelection(pivotRow, resolveSelection(targetRow, activeCell.cell)));
	            self.onSelectedReset.notify();
	
	        // clear selection and select current cell.
	        } else if (e.ctrlKey !== true) {
	            self.setSelectedRows(resolveSelection(targetRow, activeCell.cell));
	            pivotRow = targetRow;
	            self.onSelectedReset.notify();
	        }
	
	        grid.setActiveCell(targetRow, activeCell.cell);
	        if (!grid.getActiveCell()) { grid.setActiveCell(targetRow, 0); }
	        e.stopImmediatePropagation();
	    }
	
	
	
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	    // Event Handlers
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	    //-------------------------------------------
	    function handleClick(e) {
	        /// <summary>Handles the click event of the slick.grid</summary>
	        var clickedCell = grid.getCellFromEvent(e),
	            clickedRow = nextActiveRow(clickedCell.row, clickedCell.cell, function next(i) {
	                return i + 1;
	            }),
	            activeCell,
	            selection = resolveSelection(clickedRow, clickedCell.cell),
	            rows,
	            isMultiSelect = grid.getOptions().multiSelect !== false;
	
	        if (selection.length <= 0) {
	            grid.setActiveCell(clickedRow, clickedCell.cell);
	            e.stopImmediatePropagation();
	            return false;
	        }
	
	        // (ctrl+shift) - retain current selection and select everything up to and including last selected item.
	        if (e.ctrlKey === true && e.shiftKey === true && isMultiSelect === true) {
	            activeCell = grid.getActiveCell();
	            rows = selectedRows.concat(calculateSelection(activeCell.row, selection));
	
	
	        // (ctrl) - retain current selection and toggle selection of current item.
	        } else if (e.ctrlKey === true) {
	            rows = $.extend(true, [], selectedRows);
	            rows = toggleSelected(rows, selection);
	            pivotRow = clickedRow;
	
	
	        // (shift) - clear current selection and select everything up to and including last selected item.
	        } else if (e.shiftKey === true && isMultiSelect === true) {
	            activeCell = grid.getActiveCell();
	            rows = calculateSelection(typeof pivotRow === "number" ? pivotRow : activeCell.row, selection);
	            self.onSelectedReset.notify();
	
	
	        // (no modifier key) - clear current selection and select current item.
	        } else {
	            rows = selection;
	            pivotRow = clickedRow;
	            self.onSelectedReset.notify();
	        }
	
	        grid.setActiveCell(clickedRow, clickedCell.cell);
	        self.setSelectedRows(rows);
	        e.stopImmediatePropagation();
	
	    }
	
	
	    //-------------------------------------------
	    function handleKeyDown(e) {
	        /// <summary>Handles the keydown event of the slick.grid</summary>
	        var activeCell = grid.getActiveCell(),
	            selection,
	            isMultiSelect = grid.getOptions().multiSelect !== false;
	
	        if (activeCell === undefined || activeCell === null) {
	            return false;
	        }
	
	
	        switch (e.which) {
	
	        // space
	        case 32:
	            selection = resolveSelection(activeCell.row, activeCell.cell);
	            selectedRows = toggleSelected(selectedRows, selection, e.ctrlKey !== true);
	            pivotRow = activeCell.row;
	            self.setSelectedRows(selectedRows);
	            e.stopImmediatePropagation();
	            break;
	
	        // up arrow
	        case 38:
	        case 104:
	            move(e, function increment(i) {
	                return i - 1;
	            });
	            break;
	
	        // down arrow
	        case 40:
	        case 98:
	            move(e, function increment(i) {
	                return i + 1;
	            });
	            break;
	
	        // home
	        case 36:
	            move(e, function increment(position, i) {
	                return (i === 0) ? 0 : position + 1;
	            }, grid.canCellBeSelected);
	            break;
	
	        // end
	        case 35:
	            move(e, function increment(position, i) {
	                return (i === 0) ? grid.getDataLength() - 1 : position - 1;
	            }, grid.canCellBeSelected);
	            break;
	
	        // pageup
	        case 33:
	            move(e, function increment(position, i) {
	                return (i === 0) ? Math.max(0, position - calculateItemsPerPage()) : position + 1;
	            }, grid.canCellBeSelected);
	            break;
	
	        // pagedown
	        case 34:
	            move(e, function increment(position, i) {
	                return (i === 0) ? Math.min((grid.getDataLength() - 1), position + calculateItemsPerPage()) : position - 1;
	            }, grid.canCellBeSelected);
	            break;
	
	        // ctrl + a
	        case 65:
	            if (e.ctrlKey === true && isMultiSelect) {
	                self.setSelectedRows(calculateRange(0, grid.getDataLength() - 1));
	                e.stopImmediatePropagation();
	            }
	            break;
	
	        }
	
	    }
	
	
	
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	    // Public Api
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	    //-------------------------------------------
	    function getSelectedRows() {
	        /// <summary>Gets the current array of rows that are selected.</summary>
	        return selectedRows;
	    }
	
	
	    //-------------------------------------------
	    function setSelectedRows(rows) {
	        /// <summary>Sets the array of rows that are currently selected.</summary>
	        if (grid.getOptions().multiSelect !== true) {
	            selectedRows = rows.length > 0 ? [rows[0]] : rows;
	        } else {
	            selectedRows = rows;
	        }
	        selectedRanges = toRanges(selectedRows);
	        self.onSelectedRangesChanged.notify(selectedRanges);
	    }
	
	
	    //-------------------------------------------
	    function getSelectedRanges() {
	        /// <summary>Gets the current array of ranges that are selected.</summary>
	        return selectedRanges;
	    }
	
	
	    //-------------------------------------------
	    function setSelectedRanges(ranges) {
	        /// <summary>Sets the array of ranges that are currently selected.</summary>
	        self.setSelectedRows(toRows(ranges));
	    }
	
	
	    //-------------------------------------------
	    function init(sourceGrid) {
	        /// <summary>Initialize the pli row selection plug-in.</summary>
	        /// <param name="grid">The current instance of slick.grid</param>
	        grid = sourceGrid;
	        grid.onClick.subscribe(handleClick);
	        grid.onKeyDown.subscribe(handleKeyDown);
	    }
	
	
	    //-------------------------------------------
	    function destroy() {
	        /// <summary>De-initialize the row selection plug-in.</summary>
	        grid.onClick.unsubscribe(handleClick);
	        grid.onKeyDown.unsubscribe(handleKeyDown);
	    }
	
	
	    self = $.extend(self, {
	
	        //-------------------------------------------
	        getSelectedRanges: getSelectedRanges,
	
	        //-------------------------------------------
	        setSelectedRanges: setSelectedRanges,
	
	        //-------------------------------------------
	        getSelectedRows: getSelectedRows,
	
	        //-------------------------------------------
	        setSelectedRows: setSelectedRows,
	
	        //-------------------------------------------
	        init: init,
	
	        //-------------------------------------------
	        destroy: destroy,
	
	        //-------------------------------------------
	        onSelectedRangesChanged: new Slick.Event(),
	
	        //-------------------------------------------
	        onSelectedReset: new Slick.Event()
	        /// <summary>triggers whenever the selected rows are cleared</summary>
	
	    });
	
	
	    return self;
	
	}
	
	module.exports = AlternateRowSelectionModel;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint unparam: true */
	"use strict";
	
	var $ = __webpack_require__(1);
	var AlternateRowSelectionModel = __webpack_require__(523);
	
	
	//-------------------------------------------
	function AlternateGrouping(sourceOptions) {
	    /// <summary>Pli grouped index plugin for slick grid</summary>
	    /// <remarks>
	    /// Does not support editable grids because there is no way to recompute groups/indicies.
	    /// updates slick.grid data to support two additional methods on data (getIndex - and getGroups)
	    /// getIndex    - returns an array specifying the sorted position in the raw data.
	    /// getGroups   - returns an array of groups is an array of group defintion. The group definition properties are as follows:
	    ///                 name        - the name displayed for the group. (required)
	    ///                 length      - the number of items in the group. (required)
	    ///                 isCollapsed - true if the group is collapsed otherwise false. default(false)
	    ///                 min         - the lower boundary of the group (computed)
	    ///                 max         - the upper boundary of the group (computed)
	    ///                 offset      - the start position in the array of data (computed)
	    /// </remarks>
	    var self = {},
	        /// <summary>The current instance of the plugin.</summary>
	
	        currentIndex,
	        /// <summary>The current index in use.</summary>
	
	        currentGroupSet,
	        /// <summary>The current set of groups set in use.</summary>
	
	        defaultOptions = {
	
	            defaultSort: null,
	            /// <summary>The object used to identify the column to initialize sort by. { field: "fieldName", isDescending: false }</summary>
	
	            groupHeaderRenderer: null,
	            /// <summary>A delegate of the form function(row, cell, value, columnDef, dataContext, options) {} for custom group header rendering.</summary>
	
	            disableCollapse: false,
	            /// <summary>A boolean indicating whether groups are collapsible.</summary>
	
	            hasNoGroupSpacer: false
	            /// <summary>A boolean indicating there is a spacer row above groups.</summary>
	
	        },
	        /// <summary>The default set of options for the control.</summary>
	
	        hiddenSelected = [],
	        /// <summary>an array containing the data index of items that are hidden in the grid but still selected.
	        /// Used to maintain selected items when collapsing expanding a group and filtering.</summary>
	
	        isDescending = false,
	        /// <summary>Indicates the current sort direction.</summary>
	
	        grid,
	        /// <summary>The current instance of slick.grid</summary>
	
	        gridOptions,
	        /// <summary>The current instance of slick.grid options</summary>
	
	        gridData,
	        /// <summary>The current instance of slick.grid data</summary>
	
	        gridColumns,
	        /// <summary>The current instance of slick.grid columns</summary>
	
	        groupsSets = {},
	        /// <summary>The collection of the array of sets of groups per column.</summary>
	
	        filter,
	        /// <summary>Provides the filtered data.</summary>
	
	        length,
	        /// <summary>The cached length of the data.</summary>
	
	        lastIndex,
	        /// <summary>The last index that was retrieved from getItem</summary>
	
	        lastGroupIndex,
	        /// <summary>The index of the last group that was retrieved from getItem</summary>
	
	        lastRow,
	        /// <summary>The last row of data that was retrieved from getItem</summary>
	
	        lastSortColumn,
	        /// <summary></summary>
	
	        selectionModel,
	        /// <summary></summary>
	
	        options = $.extend(true, {}, defaultOptions, sourceOptions);
	        /// <summary>The current instance of the options for the plugin</summary>
	
	
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	    // Private Methods
	
	    //-------------------------------------------
	    function getSelectedDataIndex() {
	        /// <summary>Gets the selected items by data index.</summary>
	        var current = grid.getSelectedRows(),
	            i,
	            selectedDataIndex = [];
	        for (i = 0; i < current.length; i = i + 1) {
	            selectedDataIndex.push(grid.getDataItem(current[i]).dataIndex);
	        }
	        return {
	            rows: selectedDataIndex,
	            lastRow: (current.length > 0 ? current[current.length - 1] : null)
	        };
	    }
	
	
	    //-------------------------------------------
	    function getGroupRows(group) {
	        /// <summary>Returns the selected rows for the group specified.</summary>
	        var result = [], i;
	        if (group) {
	            for (i = group.min + (options.hasNoGroupSpacer ? 1 : 2); i <= group.max; i = i + 1) {
	                result.push(isDescending ? length - (i - (options.hasNoGroupSpacer ? 0 : 1)) : i);
	            }
	        }
	        return result;
	    }
	
	
	    //-------------------------------------------
	    function initHeaderRenderer(customFormatter) {
	        /// <summary>Initializes the renderer for groups</summary>
	        return function renderHeader(row, cell, value, columnDef, dataContext) {
	            /// <summary>Renders the group header/spacer.</summary>
	            var header, result;
	
	            if (!dataContext || dataContext.isHeader !== true || dataContext.isSpacer) {
	                //if the row is neither a header or a spacer then render the custom formatter
	                //which was specified in the original column definition
	                return typeof customFormatter === "function"
	                        ? customFormatter(row, cell, value, columnDef, dataContext)
	                        : value || "";
	            }
	
	            if (dataContext.isHeader === true) {
	                // Check for custom group header rendering
	                if (typeof defaultOptions.groupHeaderRenderer === "function") {
	                    result = defaultOptions.groupHeaderRenderer(row, cell, value, columnDef, dataContext, options);
	                } else {
	                    // Default group Header Rendering
	                    header = "";
	                    if (options.disableCollapse !== true) {
	                        header = header.concat("<span class=\"slick-group-toggle ")
	                            .concat(dataContext.isCollapsed ? "collapsed" : "expanded")
	                            .concat("\"></span>");
	                    }
	                    result = header.concat(dataContext.name || "");
	                }
	                return result;
	            }
	        };
	    }
	
	
	    //-------------------------------------------
	    function computeGroup(group, start) {
	        /// <summary>Computes the min, max and offset for each group.</summary>
	        /// <param name="group">The array of group definition to compute</param>
	        /// <param name="start">The index to compute the start of the group from.  This can be used when collapsing/expanding
	        /// because only need to compute after and including the group being collapsed/expanded.</param>
	        var lastMax,
	            offset,
	            min = 0,
	            max = 0,
	            adjustment = 0,
	            current,
	            i;
	
	        start = start || 0;
	        lastMax = (group[start].min || 0) - 1;
	        offset = (group[start].offset || 0);
	
	        for (i = start; i < group.length; i += 1) { // Compute the min/max and offset.
	            current = group[i];
	            min = lastMax + 1;
	            adjustment = adjustment - ((current.isCollapsed && !options.disableCollapse) ? current.length : 0); // Adjust for collapsed.
	            max = lastMax = min + current.length + (options.hasNoGroupSpacer ? 0 : 1) - ((current.isCollapsed && !options.disableCollapse) ? current.length : 0);
	            current = $.extend(current, { min: min, max: max, offset: offset });
	            offset = offset + current.length;
	        }
	
	        return adjustment;
	    }
	
	
	    //-------------------------------------------
	    function binarySearchGroup(items, value) {
	        /// <summary>Searchs the specified array until it meets the
	        /// comparer function returns zero.</summary>
	        /// <param name="items">An array of items to search</param>
	        /// <param name="comparer">A function that returns -1 when the
	        /// target is greater than the item, 0 when the target is equal or
	        /// 1 when the target is less than the item</param>
	        /// <returns>The index of the item or null if the item was not found</returns>
	        var low = 0, high = items.length - 1, index, current;
	
	        while (low <= high) {
	            index = Math.floor((low + high) / 2);
	            current = items[index];
	            if (value > current.max) {
	                low += 1;
	            } else if (value < current.min) {
	                high -= 1;
	            } else {
	                return index;
	            }
	        }
	        return null; // no results
	    }
	
	
	    //-------------------------------------------
	    function searchGroupByIndex(items, value) {
	        /// <summary></summary>
	        var pos = 0, foundIndex = null;
	        $.each(items, function eachGroup(groupIndex, targetGroup) {
	            pos = pos + targetGroup.length;
	            if (value < pos) {
	                foundIndex = { index: groupIndex, group: targetGroup };
	                return false;
	            }
	        });
	        return foundIndex;
	    }
	
	
	    //-------------------------------------------
	    function getItem(rowIndex) {
	        /// <summary>Returns the data for the specified row to slick grid at the specified index.</summary>
	        /// <param name="rowIndex">The current index in slick.grid</param>
	
	        var relativeRowIndex, dataIndex, group, header, spacer, previous, next, item;
	
	        // Verify if the target item was the last item accessed.
	        // (The last item is cached for performance because getItem
	        // is called for each field in a row.)
	        if (lastIndex === rowIndex && lastRow) {
	            return lastRow;
	        }
	        lastIndex = rowIndex;
	
	        // Calculate the inverse of the rowIndex if the sort order is descending.
	        relativeRowIndex = (isDescending ? (length - 1 - rowIndex) : rowIndex);
	
	        if (!currentGroupSet) { // no group specified.
	
	            dataIndex = currentIndex
	                ? currentIndex[relativeRowIndex]
	                : relativeRowIndex;
	            lastRow = gridData.getItem(dataIndex);
	            item = $.extend(lastRow, { dataIndex: dataIndex });
	
	        } else { // handle groups.
	
	            // Verify if this item is in the last group that was used.
	            // (The group is cached for performance so that we don't need to look it up
	            // for each row.)
	            group = currentGroupSet[lastGroupIndex];
	            if (group && (relativeRowIndex < group.min || relativeRowIndex > group.max)) {
	                group = null; // reset if this is not the correct group
	            }
	
	            if (group ===  null || group === undefined) { // if the group is not set find the current group based on the realtive row index.
	
	                // first we check the previous and next groups for performance.  If it is neither
	                // we use the binary search to locate the current group.
	                previous = currentGroupSet[lastGroupIndex - 1];
	                next = currentGroupSet[lastGroupIndex + 1];
	                if (previous && relativeRowIndex >= previous.min && relativeRowIndex <= previous.max) {
	                    lastGroupIndex -= 1;
	                } else if (next && relativeRowIndex >= next.min && relativeRowIndex <= next.max) {
	                    lastGroupIndex += 1;
	                } else {
	                    lastGroupIndex = binarySearchGroup(currentGroupSet, relativeRowIndex);
	                }
	
	            }
	
	            // Check if the current row is a header or a spacer. In the case of a header
	            // igorne actual data and return fake row.
	            group = currentGroupSet[lastGroupIndex];
	            spacer = (isDescending ? group.max : group.min) + ((options.hasNoGroupSpacer ? 1 : 0) * (isDescending ? 1 : -1));
	            header = (isDescending ? spacer - 1 : spacer + 1);
	            if (relativeRowIndex === spacer) {
	                lastRow = { isSpacer: true };
	                item = lastRow;
	            } else if (relativeRowIndex === header) {
	                lastRow = $.extend({ isHeader: true, index: lastGroupIndex, isCollapsed: (group.isCollapsed ? true : false) }, group);
	                item = lastRow;
	            } else {
	                // Compute the index in the raw data.
	                dataIndex = relativeRowIndex - group.min; // Calculate the position within the group.
	                dataIndex = dataIndex + group.offset; // determine the position within the raw data
	
	                if (isDescending !== true) {
	                    dataIndex = dataIndex - 1; // Accomodate for the header.
	                    if (options.hasNoGroupSpacer !== true) {
	                        dataIndex = dataIndex - 1; // Accomodate for the spacer.
	                    }
	                }
	
	                if (currentIndex === null || currentIndex === undefined) {
	                    lastRow = gridData.getItem(dataIndex); // otherwise access raw data directly.
	                    item = $.extend(lastRow, { dataIndex: dataIndex });
	                } else {
	                    dataIndex = currentIndex[dataIndex];
	                    lastRow = gridData.getItem(dataIndex); // if there is an index use it to lookup position.
	                    item = $.extend(lastRow, { dataIndex: dataIndex });
	                }
	            }
	
	        }
	        return item;
	
	    }
	
	
	    //-------------------------------------------
	    function getLength() {
	        /// <summary>Returns the length of the grid to slick grid.</summary>
	        return length;
	    }
	
	
	    //-------------------------------------------
	    function extendGetItemMetadata(current) {
	        return function getItemMetadata(row) {
	            /// <summary>Adds metadata (row classes) for groups and spacers</summary>
	            var metaData = $.isFunction(current) ? current(row) : {},
	                activeCell = grid.getActiveCell(),
	                activeRow = activeCell ? activeCell.row : null,
	                selected,
	                dataRow;
	
	            if (row === lastIndex) {
	                dataRow = lastRow;
	            } else {
	                dataRow = getItem(row);
	            }
	            dataRow = dataRow || {};
	
	            if (dataRow.isSpacer) {
	
	                metaData = $.extend(metaData, {
	                    cssClasses: "group-spacer",
	                    columns: { 0: { colspan: "*" } },
	                    selectable: false,
	                    focusable: false
	                });
	
	            } else if (dataRow.isHeader) {
	
	                metaData = $.extend(metaData, {
	                    cssClasses: "group-header",
	                    columns: { 0: { colspan: "*" } },
	                    selectable: false,
	                    focusable: true,
	                    select: function select() {
	                        return getGroupRows(dataRow);
	                    }
	                });
	
	            } else {
	                selected = grid.getSelectedRows();
	                if ($.inArray(row, selected) >= 0 && grid.canCellBeSelected(current, (activeCell ? activeCell.cell : 0))) {
	                    metaData = $.extend(metaData, { cssClasses: (metaData.cssClasses || "").concat(" selected") });
	                }
	
	            }
	
	            if (current === activeRow) {
	                metaData = $.extend(metaData, { cssClasses: (metaData.cssClasses || "").concat(" active") });
	            }
	
	            return metaData;
	        };
	    }
	
	
	    //--------------------------------------------------
	    function sort(preSelected, adjustPosition) {
	        /// <summary>Re-sorts the data based on the last index.</summary>
	        /// <param name="preSelected">An object containing the following to properties
	        ///  - rows - an array of the selected data index
	        ///  - lastRow - the index of the lastRow selected</param>
	        /// <param name="adjustPosition">true if adjust the position to keep the last row in view otherwise false.</param>
	        var field,
	            postSelectedRows = [],
	            i,
	            position,
	            dataIndex;
	
	        if (lastSortColumn === null || lastSortColumn === undefined) {
	            // Set it to the data.
	            lastGroupIndex = lastIndex = currentIndex = currentGroupSet = null;
	            if (filter) {
	                currentIndex = filter.items;
	                length = filter.length;
	            } else {
	                length = gridData.getLength();
	            }
	
	        } else {
	            field = lastSortColumn.field;
	
	            // Set it to the data at the lastSortColumn
	            lastGroupIndex = lastIndex = null;
	            if (filter) {
	                currentIndex = filter.indices[field] || filter.items;
	                currentGroupSet = filter.groupsSets[field];
	                length = filter.length;
	            } else {
	                currentIndex = gridData.getIndex(field);
	                currentGroupSet = groupsSets[field];
	                length = gridData.getLength();
	            }
	
	            if (currentGroupSet) {
	                length = currentGroupSet.resolvedLength;
	            }
	        }
	
	        // restore selected items
	        if (!preSelected) { return; }
	        if (preSelected.rows.length > 0 || hiddenSelected.length > 0) {
	            for (i = 0; i < getLength(); i = i + 1) {
	                dataIndex = getItem(i).dataIndex;
	
	                // Check if the data index is in the preselected items.
	                position = $.inArray(dataIndex, preSelected.rows);
	                if (position > -1) {
	                    if (grid.canCellBeSelected(i, 0)) {
	                        postSelectedRows.push(i);
	                    }
	                    preSelected.rows.splice(position, 1);
	                }
	
	                // Check if the data index is in the hidden items.
	                position = $.inArray(dataIndex, hiddenSelected);
	                if (position > -1) {
	                    if (grid.canCellBeSelected(i, 0)) {
	                        postSelectedRows.push(i);
	                    }
	                    hiddenSelected.splice(position, 1);
	                }
	
	                if (preSelected.rows.length === 0 && hiddenSelected.length === 0) {
	                    break;
	                }
	            }
	            grid.setSelectedRows(postSelectedRows);
	        }
	
	        for (i = 0; i < preSelected.rows.length; i = i + 1) {
	            hiddenSelected.push(preSelected.rows[i]);
	        }
	
	        grid.invalidate();
	
	        // restore selected position
	        if (adjustPosition && postSelectedRows.length > 0) {
	            grid.setActiveCell(postSelectedRows[postSelectedRows.length - 1], 0);
	        }
	    }
	
	
	    //-------------------------------------------
	    function onSort(scope, e) {
	        /// <summary>Handles slick.grid onSort event</summary>
	        var preSelected = getSelectedDataIndex(),
	            adjustPosition = e.adjustPosition === undefined ? true : !!e.adjustPosition;
	        lastSortColumn = e.sortCol;
	        isDescending = e.sortAsc !== true;
	
	        sort(preSelected, adjustPosition);
	    }
	
	
	    //-------------------------------------------
	    function onSelectedRowsChanged(e, data) {
	        /// <summary></summary>
	        var rows = data.rows,
	            container = $(grid.getCanvasNode()),
	            i,
	            row;
	        $(".slick-row").removeClass("selected");
	        for (i = 0; i < rows.length; i = i + 1) {
	            row = rows[i];
	            if (grid.canCellBeSelected(row, 0) === true) {
	                $(".slick-row[row=".concat(row).concat("]"), container).addClass("selected"); // add active if visible.
	            }
	        }
	        if (grid.getOptions().multiSelect !== true && rows.length > 0) {
	            hiddenSelected = [];
	        }
	    }
	
	
	    //-------------------------------------------
	    function onActiveCellChanged(e, data) {
	        /// <summary></summary>
	        var activeRow = data.row,
	            container = $(grid.getCanvasNode());
	        $(".slick-row", container).removeClass("active"); // remove any active
	        $(".slick-row[row=".concat(activeRow).concat("]"), container).addClass("active"); // add active if visible.
	    }
	
	
	    //-------------------------------------------
	    function onSelectedReset() {
	        /// <summary></summary>
	        hiddenSelected = [];
	    }
	
	
	    //-------------------------------------------
	    function toggleGroupCollapsed(e, data) {
	        /// <summary>Toggles whether the group is collapsed or not.</summary>
	        var clicked = $(e.target),
	            group,
	            rowItem,
	            preSelected;
	        if (clicked.is(".slick-group-toggle") === true) {
	            preSelected = getSelectedDataIndex();
	            rowItem = data.grid.getDataItem(data.row);
	            group = currentGroupSet[rowItem.index];
	            group.isCollapsed = group.isCollapsed === true ? false : true;
	            currentGroupSet.resolvedLength = currentGroupSet.resolvedLength + (group.isCollapsed ? (-1 * group.length) : group.length);
	            length = currentGroupSet.resolvedLength;
	            computeGroup(currentGroupSet, rowItem.index);
	            sort(preSelected);
	            e.stopImmediatePropagation();
	        }
	    }
	
	
	    //-------------------------------------------
	    function applyFilter(filterRowDelegate) {
	        var currentItem,
	            i,
	            preSelected = getSelectedDataIndex();
	
	        filter = { items: [], indices: {}, groupsSets: {} };
	
	        // Filter the results.
	
	        for (i = 0; i < gridData.getLength(); i = i + 1) {
	            currentItem = gridData.getItem(i);
	            if (filterRowDelegate(currentItem) === true) { // Verify that the item is included in the filter.
	                filter.items.push(i);
	            }
	        }
	        filter.length = filter.items.length;
	
	        if (filter.length > 0) {
	
	            // Re-build Indices (and groups that have indices)
	
	            $.each(gridColumns, function eachColumn(key, value) { // Iterate indices
	
	                var selectedGroupSet = groupsSets[value.field],
	                    selectedIndex = gridData.getIndex(value.field),
	                    position,
	                    selectedGroup,
	                    previousGroup = {},
	                    filterIndex = [],
	                    filterGroupSet = [];
	
	                if ((selectedIndex === null || selectedIndex === undefined) && (selectedGroupSet === null || selectedGroupSet === undefined)) {
	                    return true; // no index or group for the column continue - eachColumn
	                }
	
	                if (selectedIndex === null || selectedIndex === undefined) { // group only
	
	                     // Iterate each of the filtered values and add to the group
	                    for (i = 0; i < filter.items.length; i = i + 1) {
	
	                        // find the group by index (then either increment existing or add new)
	                        selectedGroup = searchGroupByIndex(selectedGroupSet, i);
	                        if (selectedGroup.index === previousGroup.index) {
	                            filterGroupSet[filterGroupSet.length - 1].length += 1;
	                        } else {
	                            filterGroupSet.push({ name: selectedGroup.group.name, length: 1, isCollapsed: selectedGroup.group.isCollapsed });
	                        }
	                        previousGroup = selectedGroup;
	
	                    }
	
	                    // Add the group.
	                    filterGroupSet.resolvedLength = filter.items.length + computeGroup(filterGroupSet) + (filterGroupSet.length * (options.hasNoGroupSpacer ? 1 : 2));
	                    filter.groupsSets[value.field] = filterGroupSet;
	
	
	                } else { // index (and possibly a group)
	
	                    // Iterate each of the values in the index and add to the filtered index and group (if specified)
	                    for (i = 0; i < selectedIndex.length; i = i + 1) {
	                        position = selectedIndex[i];
	                        if ($.inArray(position, filter.items) > -1) {
	
	                            filterIndex.push(position); // add the position to the filter index.
	
	                            if (selectedGroupSet !== null && selectedGroupSet !== undefined) {
	                                // find the group by index (then either increment existing or add new)
	                                selectedGroup = searchGroupByIndex(selectedGroupSet, i);
	                                if (selectedGroup.index === previousGroup.index) {
	                                    filterGroupSet[filterGroupSet.length - 1].length += 1;
	                                } else {
	                                    filterGroupSet.push({ name: selectedGroup.group.name, length: 1, isCollapsed: selectedGroup.group.isCollapsed });
	                                }
	                                previousGroup = selectedGroup;
	                            }
	
	                        }
	                    }
	
	                    // Add the group and indices.
	                    filter.indices[value.field] = filterIndex;
	                    if (filterGroupSet.length > 0) {
	                        filterGroupSet.resolvedLength = filter.items.length + computeGroup(filterGroupSet) + (filterGroupSet.length * (options.hasNoGroupSpacer ? 1 : 2));
	                        filter.groupsSets[value.field] = filterGroupSet;
	                    } else {
	                        return false; // continue
	                    }
	
	                }
	
	            });
	        }
	        sort(preSelected);
	    }
	
	
	    //-------------------------------------------
	    self = $.extend(self, {
	
	
	        //-------------------------------------------
	        init: function initialize(sourceGrid) {
	            /// <summary>Initializes the group plugin</summary>
	
	            var internalSetData;
	
	            grid = sourceGrid;
	            internalSetData = grid.setData;
	            gridOptions = grid.getOptions();
	            gridData = grid.getData();
	            gridColumns = grid.getColumns();
	
	            // validation
	
	            // Does not support editable grid because there is no way to recompute indices/groups
	            if (gridOptions.editable === true) {
	                throw new Error("PliGroupedIndexedGridPlugin.js does not support editable grids because there is no way to recompute indices/groups.");
	            }
	
	            if ($.isFunction(gridData.getIndex) !== true) {
	                throw new Error("slick.grid data must provide a getIndex function");
	            }
	
	            if ($.isFunction(gridData.getGroups) !== true) {
	                throw new Error("slick.grid data must provide a getGroups function");
	            }
	
	            // if collapsing is available add click handler. (need to register before selection model so it overrides)
	            if (options.disableCollapse === false) {
	                grid.onClick.subscribe(toggleGroupCollapsed);
	            }
	
	            if (typeof gridOptions.groupHeaderRenderer === "function") {
	                defaultOptions.groupHeaderRenderer = gridOptions.groupHeaderRenderer;
	            }
	
	            // Set the selection model
	            if (typeof AlternateRowSelectionModel === "function") {
	                selectionModel = new AlternateRowSelectionModel();
	                grid.setSelectionModel(selectionModel);
	                selectionModel.onSelectedReset.subscribe(onSelectedReset);
	            }
	
	            // Add header formatter to the current columns.
	            if (gridColumns.length > 0) {
	                gridColumns[0].formatter = initHeaderRenderer(gridColumns[0].formatter);
	            }
	
	            // Subscribe to the sort event.
	            grid.onSort.subscribe(onSort);
	
	            // add css styles for active and selected on change.
	            grid.onSelectedRowsChanged.subscribe(onSelectedRowsChanged);
	            grid.onActiveCellChanged.subscribe(onActiveCellChanged);
	
	            // Set the data.
	            grid.setData = function setData(data) {
	                lastIndex = lastGroupIndex = lastRow = currentIndex = currentGroupSet = null; // reset cached values.
	                gridData = data;
	
	                // Compute cached length.
	                length = gridData.getLength();
	
	                // initialize groups.
	
	                // Loop through and the group sets and initialize computed field and copy groups.
	                $.each(gridColumns, function eachColumn(columnIndex, columnValue) {
	                    var groups = gridData.getGroups(columnValue.field);
	                    if (groups && groups.length > 0) {
	                        // copy the group
	                        groups = groupsSets[columnValue.field] = $.extend(true, [], groups);
	
	                        // compute each of the groups.
	                        groups.resolvedLength = length + computeGroup(groups) + (groups.length * (options.hasNoGroupSpacer ? 1 : 2));
	                    }
	                });
	                internalSetData({ getItem: getItem, getLength: getLength, getItemMetadata: extendGetItemMetadata(gridData.getItemMetadata) });
	
	                if (lastSortColumn) { // restore existing column
	                    grid.setSortColumn(lastSortColumn.field, isDescending);
	                    grid.onSort.notify({
	                        sortCol: lastSortColumn,
	                        sortAsc: options.defaultSort.isDescending !== true,
	                        adjustPosition: false
	                    });
	                } else { // set default.
	                    if ($.isPlainObject(options.defaultSort) === true && options.defaultSort.field) {
	                        grid.setSortColumn(options.defaultSort.field, options.defaultSort.isDescending !== true);
	                        grid.onSort.notify({
	                            sortCol: grid.getColumns()[grid.getColumnIndex(options.defaultSort.field)],
	                            sortAsc: options.defaultSort.isDescending !== true,
	                            adjustPosition: false
	                        });
	                    }
	                }
	
	            };
	            grid.setData(gridData, false);
	
	        },
	
	
	        //-------------------------------------------
	        destroy: function destroy() {
	            /// <summary>Removes the grid functionality</summary>
	            grid.onSort.unsubscribe(onSort);
	            grid.onSelectedRowsChanged.unsubscribe(onSelectedRowsChanged);
	            grid.onActiveCellChanged.unsubscribe(onActiveCellChanged);
	            grid.setData(gridData);
	
	            if (options.disableCollapse === false) {
	                grid.onClick.unsubscribe(toggleGroupCollapsed);
	            }
	
	            if (typeof AlternateRowSelectionModel === "function") {
	                selectionModel.onSelectedReset.unsubscribe(onSelectedReset);
	                selectionModel.destroy();
	            }
	        },
	
	
	        //-------------------------------------------
	        applyFilter: applyFilter,
	        /// <summary>Applies a filter to the current data.</summary>
	        /// <param name='filterRowDelegate'>A delegate that is passed the item.  If the return value is true (not truthy) the item will be included otherwise it will not.</param>
	
	
	        //-------------------------------------------
	        clearFilter: function clearFilter() {
	            var preSelected = getSelectedDataIndex();
	            filter = lastGroupIndex = lastIndex = null;
	            sort(preSelected);
	        },
	        /// <summary>Clears the current filter if there is one.</summary>
	
	
	        //-------------------------------------------
	        getSelectedItems: function getSelectedItems() {
	            var selectedItems = [],
	                item,
	                selectedData = hiddenSelected.concat(getSelectedDataIndex().rows),
	                i;
	            for (i = 0; i < selectedData.length; i = i + 1) {
	                item = gridData.getItem(selectedData[i]);
	                if (item) {
	                    selectedItems.push(item);
	                }
	            }
	            return selectedItems;
	        }
	        /// <summary>Gets all the data that is currently selected in the including those that are not visible</summary>
	
	    });
	
	
	    return self;
	
	}
	
	
	module.exports = AlternateGrouping;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	"use strict";
	
	var ko = __webpack_require__(457);
	
	//-------------------------------------------
	function createNormalItem(options, record) {
	    return options.targetArray.createItem(record);
	}
	
	
	//-------------------------------------------
	function createMappedItem(options, record) {
	    var key, o = {};
	    for (key in options.rowMap) {
	        if (options.rowMap.hasOwnProperty(key)) {
	            o[key] = record[options.rowMap[key]];
	        }
	    }
	    return createNormalItem(options, o);
	}
	
	
	//-------------------------------------------
	function pushItems(options, targetItemCreator) {
	    var target = options.targetArray.peek();
	    var getIdentity = (typeof options.getIdentity === "function" ? options.getIdentity : null);
	    var targetChanged = false;
	    var records = options.records;
	
	    var i, l, j, m, newItem, newIdentity, targetIdentity;
	    for (i = 0, l = records.length; i < l; i += 1) {
	        newItem = targetItemCreator(options, records[i]);
	        if (getIdentity) {
	            newIdentity = getIdentity(newItem);
	            if (newIdentity !== null) {
	                for (j = 0, m = target.length; j < m; j += 1) {
	                    targetIdentity = getIdentity(target[j]);
	                    if (targetIdentity !== null) {
	                        if (newIdentity === targetIdentity) {
	                            ko.disposeObject(newItem);
	                            newItem = null;
	                            break;
	                        }
	                    }
	                }
	            }
	        }
	        if (newItem !== null) {
	            targetChanged = true;
	            target.push(newItem);
	        }
	    }
	    if (targetChanged) {
	        // sort with forced notification
	        options.targetArray.sort(null, target, true);
	    }
	    return options.targetArray;
	}
	
	
	//-------------------------------------------
	function pushObjectItems(options) {
	    return pushItems(options, createNormalItem);
	}
	
	
	//-------------------------------------------
	function pushRowItems(options) {
	    return pushItems(options, createMappedItem);
	}
	
	
	//-------------------------------------------
	function resetGuids(root) {
	    /// <summary>
	    /// Utility method exposed via "selectionForm.utils"
	    /// that recursively traverses specified object
	    /// and arrays and sets all properties called
	    /// "guid" to null. Useful when copying (as opposed
	    /// to linking).
	    /// </summary>
	    if (root !== null && typeof root === "object") {
	        var i, l;
	        if (root.indexOf) { // naive array detection
	            root = ko.utils.unwrapObservable(root); // unwrap if observable array
	            for (i = 0, l = root.length; i < l; i += 1) {
	                resetGuids(root[i]);
	            }
	        } else {
	            var key, guidValue, child;
	            if (!ko.utils.unwrapObservable(root.link)) {
	                for (key in root) {
	                    if (root.hasOwnProperty(key)) {
	                        if (key === "guid") {
	                            guidValue = root[key];
	                            if (ko.isObservable(guidValue)) {
	                                guidValue(null);
	                            } else {
	                                root[key] = null;
	                            }
	                        } else {
	                            child = ko.utils.unwrapObservable(root[key]); // unwrap child, if observable
	                            resetGuids(child);
	                        }
	                    }
	                }
	            }
	        }
	    }
	    return root;
	}
	
	module.exports = {
	    pushObjectItems: pushObjectItems,
	    pushRowItems: pushRowItems,
	    resetGuids: resetGuids
	};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true, todo: true*/
	
	"use strict";
	
	var initializeBreadcrumbs = __webpack_require__(473);
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var ServerCalculation = __webpack_require__(527).default;
	
	var entityRegistry = __webpack_require__(492);
	var NotificationMessage = __webpack_require__(528);
	var selectionForm = __webpack_require__(520);
	var viewModelInit = __webpack_require__(532);
	
	__webpack_require__(465).enableSlideTransitions();
	__webpack_require__(511);
	
	
	//-------------------------------------------
	viewModelInit.createRoot = function createDocumentViewModelRoot() {
	
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	    // ViewModel extensions
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	    // This section defines methods that apply to
	    // any type of document. They will be available
	    // in viewmodel creator function for current
	    // document and can be overridden by assigning
	    // a function to a viewmodel property of
	    // the same name.
	
	    var viewModel = null, // extension methods use closure to this value
	        entityName = pli.forms.root.id,
	        entityViewModelCreatorMethod = "create".concat(entityName.substring(0, 1).toUpperCase(), entityName.substring(1), "ViewModel"),
	        entityViewModelCreator = viewModelInit[entityViewModelCreatorMethod], // e.g. "createSurfaceLeaseViewModel"
	        entityFactoriesCreatorMethod = entityViewModelCreatorMethod.replace("ViewModel", "Factories"),
	        entityFactoriesCreator = viewModelInit[entityFactoriesCreatorMethod]; // e.g. "createSurfaceLeaseFactories"
	
	    if (typeof entityViewModelCreator !== "function") {
	        throw new Error("Required method pli.viewModelInit." + entityViewModelCreatorMethod + " is not defined");
	    }
	    if (!entityViewModelCreator.viewModelPrototype) {
	        throw new Error("Required property pli.viewModelInit." + entityViewModelCreatorMethod + ".viewModelPrototype is not defined");
	    }
	    if (!entityFactoriesCreator) {
	        throw new Error("Required property pli.viewModelInit." + entityFactoriesCreatorMethod + " is not defined");
	    }
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.close = function documentClose() {
	        /// <summary>
	        /// Close this document's window.
	        /// </summary>
	        var rootForm = pli.forms.root,
	            forms = pli.forms,
	            f = forms.getCurrentForm();
	        while (f !== rootForm) {
	            f.close();
	            f = forms.getCurrentForm();
	        }
	        rootForm.close();
	        return false;
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.help = function documentHelp() {
	        /// <summary>
	        /// Show help for this document.
	        /// </summary>
	        entityRegistry.help.show(viewModel.extras.helpUrl);
	        return false;
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.home = function documentHome() {
	        /// <summary>
	        /// Goes to the root of the form.
	        /// </summary>
	        location.hash = pli.forms.crumbs().begin.hash;
	        return false;
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.nextTab = function documentNextTab() {
	        /// <summary></summary>
	        /// <summary></summary>
	        return entityViewModelCreator.viewModelPrototype._switchTab(1);
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.previousTab = function documentPreviousTab() {
	        /// <summary></summary>
	        return entityViewModelCreator.viewModelPrototype._switchTab(-1);
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.print = function documentPrint() {
	        /// <summary>
	        /// Print this document.
	        /// </summary>
	        entityRegistry[entityName].open.print({
	            id: viewModel.guid(),
	            uniqueName: viewModel.id()
	        });
	        return false;
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.duplicate = function documentDuplicate() {
	        /// <summary>
	        /// Duplicate this document.  This means that we need to clear the GUID of this
	        /// document and all of the owned child documents.
	        /// </summary>
	        viewModel.extras.state("busy.duplicate");
	        selectionForm.utils.resetGuids(viewModel);
	
	        // if the viewModel has splits, we need to check for a lands/rights grid.
	        if (viewModel.splits) {
	            // The lands/rights grids maintain their own list of guids for the tracts, so
	            // we have to reset them separately.
	            viewModel.splits().forEach(function (split) {
	                if (split.extras.landsRightsEditGrid) {
	                    split.extras.landsRightsEditGrid.resetTractIds();
	                }
	            }, this);
	        }
	
	        viewModel.extras.rootData.id = '';
	        location.hash = '';
	        viewModel.id("DUPLICATE OF " + viewModel.id());
	
	        // select the name field, but do it in just a moment to give the UI a chance to update first
	        setTimeout(function afterDuplicate() {
	            viewModel.extras.state("ready.dirty");
	            pli.forms.crumbs.peek().begin.page.findActivationFocus().focus().select();
	        }, 400);
	
	        return false;
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.up = function moveUpDocumentHierarchy() {
	        /// <summary></summary>
	        var c = pli.forms.crumbs().end;
	        if (c.previous && c.previous.hash) {
	            location.hash = c.previous.hash;
	        }
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeDirtyState = function computeDirtyState() {
	        var s = this.extras.state();
	        if (s === "ready" || s === "ready.saved") {
	            if (this.extras.dirty()) {
	                this.extras.state("ready.dirty");
	            }
	        }
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeWarningState = function computeWarningState() {
	        var s = this.extras.state();
	        if (s) {
	            s = s.replace(".failed", "");
	            if (s.indexOf("ready") === 0) {
	                if (this.extras.errorsCount && this.extras.errorsCount() > 0) {
	                    this.extras.state(s + ".failed");
	                } else {
	                    this.extras.state(s);
	                    this.extras.isErrorListVisible(false); // explicit hiding error list menu
	                }
	            }
	        }
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeSaveStateMessage = function computeSaveStateMessage() {
	        switch (this.extras.state()) {
	        case "busy.saving":
	            return { message: "Saving", stateIndicationClass: "fileSaving" };
	        case "ready.saved":
	            return { message: "Saved", stateIndicationClass: "fileSaved" };
	        case "ready.dirty":
	        case "ready.failed":
	        case "ready.saved.failed":
	        case "ready.dirty.failed":
	        case "ready":
	            return { message: "Save", stateIndicationClass: "noChanges" };
	        default:
	            return { message: "Save", stateIndicationClass: "noChanges" };
	        }
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeDuplicateStateMessage = function computeDuplicateStateMessage() {
	        if (this.extras.state() === "busy.duplicate") {
	            return { message: "Duplicating", stateIndicationClass: "fileDuplicating" };
	        }
	        return { message: "Duplicate", stateIndicationClass: "noChanges" };
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeReadOnly = function computeDocumentReadOnly() {
	        return !this.extras.isEditable() || this.extras.state().indexOf("ready") !== 0;
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeReady = function computeDocumentReady() {
	        return this.extras.state().indexOf("ready") === 0;
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeStatus = function computeDocumentStatus() {
	        if (ko.isObservable(this.extras.statusText)) {
	            return this.extras.statusText() || "";
	        }
	
	        if (ko.isObservable(this.status)) {
	            var status = this.status && this.status.item(),
	                withCategory = status && status.length > 3;
	
	            return (status
	                ? "".concat(status[1] || status[0], withCategory ? " (".concat(status[2], ")") : "")
	                : "(No status yet)");
	        }
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeSubtitle = function computeDocumentSubtitle() {
	        if (ko.isObservable(this.extras.subtitleField)) {
	            return (this.extras.subtitleField() || "(No ".concat(this.extras.subtitleFieldName.toLowerCase(), " yet)"));
	        }
	
	        if (ko.isObservable(this.area)) {
	            var area = this.area.item();
	            return (area
	                ? "".concat(area[0], ", ", area[1], ", ", area[2])
	                : "(No area yet)");
	        }
	
	        if (ko.isObservable(this.workTitle)) {
	            var workTitle = this.workTitle();
	            return (workTitle || "(No work title yet)");
	        }
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeTitle = function computeDocumentTitle() {
	        /// <summary>
	        /// Compute and set browser window title
	        /// + return it (to bind it to form header
	        /// title as well).
	        /// </summary>
	        var title,
	            entityDisplayName = entityRegistry[entityName].type;
	
	        if (this.extras.state().substring(0, 4) === "init") {
	            title = "Loading ".concat(entityDisplayName, "...");
	        } else if (ko.isObservable(this.extras.titleOverride)) {
	            title = this.extras.titleOverride();
	        } else {
	            title = ko.utils.stringTrim(this.id());
	            title = (title.length === 0
	                ? "(No ".concat(entityDisplayName.toLowerCase(), " number yet)")
	                : entityDisplayName.concat(" ", title));
	        }
	        document.title = title;
	        return title;
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._computeSaveButtonToolTip = function computeSaveButtonToolTip() {
	        /// <summary>
	        /// Compute and set tool tip for Save button
	        /// </summary>
	        var entityDisplayName = entityRegistry[entityName].type;
	
	        if (this.extras.state().indexOf('.failed') === -1) {
	            return "Save all changes to this ".concat(entityDisplayName.toLowerCase()).concat(" (Ctrl+S)");
	        }
	        return "";
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._loadDocument = function documentLoad(record) {
	        /// <remarks>
	        /// TODO: This should become part of ViewModelInit.js's
	        /// loadViewModel function (save original loadViewModel method
	        /// as _loadViewModelOriginal, then define loadViewModel that points
	        /// to a function that calls _loadViewModelOriginal and
	        /// at the end runs applyResult on server calculation,
	        /// if server calculation is active in that viewmodel).
	        /// </remarks>
	        ko.postbox.publish("state.isEditable", (record ? record.editable : true));
	        this.loadViewModel(record);
	        if (this.extras._serverCalculation) {
	            this.extras._serverCalculation.applyResult(record);
	        }
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._switchTab = function switchDocumentTab(offset) {
	        /// <summary>
	        /// Switches the currently active tab
	        /// backward or forward based on the offset
	        /// specified.
	        /// </summary>
	        var c = pli.forms.crumbs().end, i, l;
	        if (c && c.page && c.page.parent && c.page.parent.children && c.page.parent.children.length > 1) { // do we have a sibling?
	            l = c.page.parent.children.length;
	            for (i = 0; i < l; i += 1) {
	                if (c.page === c.page.parent.children[i]) { break; }
	            }
	            i += offset;
	            if (i < 0) {
	                i = l - 1;
	            } else if (i > (l - 1)) {
	                i = 0;
	            }
	            window.location.hash = c.page.parent.children[i].activationHash;
	            return false;
	        }
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.showErrorList = function showErrorList() {
	        /// <summary>
	        /// Show tooltip list
	        /// </summary>
	        if (this.extras.errorsCount && this.extras.errorsCount() > 0) {
	            this.extras.isErrorListVisible(true);
	        }
	        return false;
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype._hideErrorList = function hideErrorList() {
	        /// <summary>
	        /// Hide tooltip list
	        /// </summary>
	        this.extras.isErrorListVisible(false);
	        return true; // allow event propagation & default handling
	    };
	
	
	    //---------------------------------------
	    entityViewModelCreator.viewModelPrototype.moveOutErrorList = function moveOutErrorList() {
	        /// <summary>
	        /// Move cursor out the errorlist or the save button tooltip list
	        /// </summary>
	        if (this.extras.disableMouseOutHiding()) {
	            return false;
	        }
	        this.extras.isErrorListVisible(false);
	        return true;
	    };
	
	
	    //---------------------------------------
	    /*jslint unparam: true*/
	    entityViewModelCreator.viewModelPrototype._safeSaving = function safeSaving(data, e) {
	        if (e && e.stopImmediatePropagation) {
	            e.stopImmediatePropagation(); // prevent hiding the tool tip while it showing by click on Save button
	        }
	
	        this.extras.disableMouseOutHiding(true);
	        // Check if viewModel has errors before saving then showing tooltip list
	        if (this.extras.errorsCount && this.extras.errorsCount() > 0) {
	            this.extras.isErrorListVisible(true);
	        } else {
	            this.extras.disableMouseOutHiding(false);
	            this.save();
	        }
	        return false; // stop propagation & default (if keyboard event)
	    };
	    /*jslint unparam: false*/
	
	    //--------------------------------------
	    entityViewModelCreator.viewModelPrototype._showErrorPanelAfterSaving = function showErrorPanelAfterSaving() {
	        /// <summary>
	        /// Show notification error panel in case if viewModel state is "failed" and errors count is 0 (unknown server-side error)
	        /// or show error list tooltip if errors count isn't 0 (known server-side error)
	        /// </summary>
	        var s = this.extras.state(), p = this.extras.prevState();
	        if ((s === "ready.failed" || s === "ready.saved.failed" || s === "ready.dirty.failed") && p === "busy.saving") {
	            if (this.extras.errorsCount() === 0) {
	                this.extras.notificationErrorPanel.show({
	                    title: "Save failed",
	                    message: "Unexpected save error"
	                });
	            } else {
	                this.extras.disableMouseOutHiding(true);
	                this.extras.isErrorListVisible(true);
	            }
	            this.extras.prevState(s); // reset previous state observable
	        }
	    };
	
	
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	    // ViewModel initialization
	    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	    // extra steps to run after all modules finish creating viewmodel
	    viewModelInit.onViewModelCreated(function onDocumentViewModelCreated(viewModel, viewModelInit) {
	        viewModel.extras.dirty = ko.dirtyFlag(viewModel, true, true); // create suspended
	        viewModel.extras.breadcrumbs = initializeBreadcrumbs(pli.forms.crumbs);
	        viewModel.extras.crumbData = ko.computed(function () {
	            var crumbs = pli.forms.crumbs();
	            return (crumbs && crumbs.end && crumbs.end.data && crumbs.end.data.value) ? crumbs.end.data.value : {};
	        });
	        viewModel.extras.isEditable = ko.observable().subscribeTo("state.isEditable");
	        viewModel.extras.isReadOnly = ko.computed(viewModel._computeReadOnly, viewModel);
	        viewModel.extras.isReadOnly.publishOn("state.isReadOnly");
	        viewModel.extras.isReady = ko.computed(viewModel._computeReady, viewModel);
	        viewModel.extras.isReady.publishOn("state.isReady");
	        viewModel.extras.status = ko.computed(viewModel._computeStatus, viewModel);
	        viewModel.extras.subtitle = ko.computed(viewModel._computeSubtitle, viewModel);
	        viewModel.extras.title = ko.computed(viewModel._computeTitle, viewModel);
	        viewModel.extras.saveButtonTooltip = ko.computed(viewModel._computeSaveButtonToolTip, viewModel);
	
	        viewModel.extras.prevState = ko.observable(viewModel.extras.state());
	        viewModel.extras.state.subscribe(function (oldValue) {
	            viewModel.extras.prevState(oldValue);
	        }, viewModel, "beforeChange");
	
	        viewModel.extras.isErrorListVisible = ko.observable(false).extend({ rateLimit: 0 });
	        viewModel.extras.disableMouseOutHiding = ko.observable(false);
	        viewModel.extras.isErrorListVisible.subscribe(function (newValue) {
	            if (!newValue) {
	                viewModel.extras.disableMouseOutHiding(false);
	            }
	        });
	
	        viewModel.extras.notificationMessage = new NotificationMessage();
	        viewModel.extras.notificationErrorPanel = new NotificationMessage();
	        viewModel.hideErrorList = viewModel._hideErrorList.bind(viewModel);
	        viewModel.safeSaving = viewModel._safeSaving.bind(viewModel);
	
	        viewModel.extras.suppressBusyIndicator = true;
	        viewModel.extras.saveStateMessage = ko.computed(viewModel._computeSaveStateMessage, viewModel);
	        viewModel.extras.duplicateStateMessage = ko.computed(viewModel._computeDuplicateStateMessage, viewModel);
	        ko.computed(viewModel._computeDirtyState, viewModel);
	        ko.computed(viewModel._computeWarningState, viewModel);
	        ko.computed(viewModel._showErrorPanelAfterSaving, viewModel);
	
	        viewModel.extras._serverCalculation = viewModel.extras.calculationCallName ? new ServerCalculation(viewModel.extras.calculationCallName, viewModel, 200) : null;
	
	        viewModel.save = viewModelInit.secureAction(viewModel.save, viewModel);
	        viewModelInit.defaultKeymap = ko.utils.extend(
	            ko.utils.extend({}, pli.config.defaultKeymap),
	            {
	                "Back": viewModel.up,
	                "Close": viewModel.close,
	                "Help": viewModel.help,
	                "Home": viewModel.home,
	                "NextTab": viewModel.nextTab,
	                "PreviousTab": viewModel.previousTab,
	                "Print": viewModel.print,
	                "Save": viewModel.safeSaving,
	                "Duplicate": viewModel.duplicate
	            }
	        );
	    });
	
	    // create root document viewModel
	    var factories = entityFactoriesCreator(entityName);
	    factories.computeErrorsCount = viewModelInit.computeErrorsCount;
	    viewModel = entityViewModelCreator(factories);
	    viewModelInit.finalizeFactories(factories, viewModel);
	    viewModelInit.assignKeymaps();
	
	    // create adapter (TODO: update ViewModelInit.js and delete)
	    if (viewModel.loaded) { throw new Error("Root viewModel defined method \"loaded\" -- this is now deprecated, please define \"loadViewModel\" instead"); }
	    entityViewModelCreator.viewModelPrototype.loaded = entityViewModelCreator.viewModelPrototype._loadDocument;
	    if (viewModel.created) { throw new Error("Root viewModel defined method \"created\" -- this is now deprecated, please define \"completeViewModel\" instead"); }
	    entityViewModelCreator.viewModelPrototype.created = viewModel.completeViewModel;
	
	    // define methods for dialog registry
	    pli.dialogClosingMessage = function computeDocumentClosingMessage(isRootLevel) {
	        var entityDisplayName = entityRegistry[entityName].type;
	        return (viewModel.extras.dirty()
	            ? isRootLevel
	                ? "This ".concat(entityDisplayName, " has unsaved changes")
	                : entityDisplayName.concat(" ", viewModel.id(), " has unsaved changes")
	            : null);
	    };
	    pli.dialogId = function computeDocumentId() {
	        return entityName.concat("-", viewModel.id());
	    };
	
	    return viewModel;
	};
	
	module.exports = viewModelInit;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var call_1 = __webpack_require__(8);
	var ko = __webpack_require__(9);
	/**
	 * Information and operations relevant to the current position in the viewmodel when gathering/building calculation input or applying calculation result.
	 *
	 * Should only be created by "ServerCalculation", will be passed to
	 * "applyServerCalculationResult" and "buidServerCalculationData" as a parameter.
	 *
	 * For more info, see https://github.com/pandell/web-pli/wiki/Server-Calculations
	 */
	var ServerCalculationContext = (function () {
	    /**
	     * Create a new instance of server calculation context.
	     *
	     * Every time we traverse a viewmodel (either to gather inputs or apply result),
	     * new context instance will be created, but the same context instance is used
	     * to visit all contributors during viewmodel traversal.
	     *
	     * @param {string} methodName
	     *     Either "applyServerCalculationResult" or "buildServerCalculationData".
	     * @param {any = null} rootData
	     *     Result data to apply to root contributor (and its children via recursive "visit" calls).
	     *     Only specified when "methodName==='applyServerCalculationResult'".
	     */
	    function ServerCalculationContext(methodName, rootData) {
	        if (rootData === void 0) { rootData = null; }
	        /**
	         * Gets name of the collection (observable array) that we last visited.
	         *
	         * In other words, what collection is the current contributor member of.
	         * When null, we are still visiting the root contributor.
	         */
	        this.currentCollectionName = null; // changed in "visit"
	        this.rootData = this.currentData = rootData;
	        this._methodName = methodName;
	    }
	    /**
	     * Visit a new contributor (usually a child of the current contributor).
	     *
	     * @param {any} contributor
	     *     Reference to the contributor to visit (typically child property of current contributor).
	     * @param {string} dataKey
	     *     Key to use to get from "this.currentData" (result data applicable to the current contributor) to result data applicable to "contributor".
	     *     Only required when calling "visit" in "applyServerCalculationResult" methods.
	     *
	     * @returns {any}
	     *     Result of invoking the "_methodName" on the specified contributor.
	     */
	    ServerCalculationContext.prototype.visit = function (contributor, dataKey) {
	        var methodToCall;
	        var result = null;
	        var originalData = this.currentData;
	        var currentData = (typeof this.currentData === "object" && this.currentData !== null && typeof dataKey === "string"
	            ? this.currentData[dataKey]
	            : this.currentData);
	        if (ko.isObservable(contributor) && contributor.indexOf) {
	            var originalCollectionName = this.currentCollectionName;
	            this.currentCollectionName = dataKey;
	            methodToCall = contributor[this._methodName];
	            if (typeof methodToCall === "function") {
	                methodToCall.call(contributor, this);
	            }
	            this.currentData = currentData;
	            var a = contributor(), b = [], foundResult = false, itemResult = void 0;
	            for (var i = 0, l = a.length; i < l; i += 1) {
	                itemResult = this.visit(a[i], i.toString());
	                if (itemResult === undefined) {
	                    itemResult = null;
	                }
	                if (itemResult !== null) {
	                    foundResult = true;
	                }
	                b.push(itemResult);
	            }
	            this.currentCollectionName = originalCollectionName;
	            if (foundResult) {
	                result = b;
	            }
	        }
	        else if (typeof contributor === "object") {
	            this.currentData = currentData;
	            methodToCall = contributor[this._methodName];
	            if (typeof methodToCall === "function") {
	                result = methodToCall.call(contributor, this);
	                if (result === undefined) {
	                    result = null;
	                }
	            }
	        }
	        this.currentData = originalData;
	        return result;
	    };
	    return ServerCalculationContext;
	}());
	exports.ServerCalculationContext = ServerCalculationContext;
	/**
	 * Move complicated or precision-sensitive calculations to the server.
	 *
	 * For more info, see https://github.com/pandell/web-pli/wiki/Server-Calculations
	 */
	var ServerCalculation = (function () {
	    /**
	     * Creates and starts a new instance of server calculation engine.
	     * If falsy "calculationPliCallName" or "target" is specified,
	     * the created calculation engine instance will be inactive.
	     *
	     * @param {string | KnockoutObservable<string>} calculationPliCallName
	     *     Name of the Pli call that will be invoked every time a change is detected.
	     * @param {ServerCalculationContributor} target
	     *     Root of the viewmodel for which we are performing calculations.
	     * @param {number} throttleEvaluationMilliseconds
	     *     Bundle all changes that happen within this period into a single server call.
	     *     When negative value or 0 is specified, no throttling is used.
	     *     @default 250 milliseconds
	     * @param {boolean = true} verbose
	     *     Write diagnostic information using "console.log" (true) or not (false, default).
	     *     @default false
	     */
	    function ServerCalculation(calculationPliCallName, target, throttleEvaluationMilliseconds, verbose) {
	        if (throttleEvaluationMilliseconds === void 0) { throttleEvaluationMilliseconds = 250; }
	        if (verbose === void 0) { verbose = false; }
	        /**
	         * Gets an observable flag that indicates whether server calculation is currently talking to Pli server (true) or is idle (false).
	         *
	         * Can be used to update UI to indicate communication with the server
	         * (e.g. make some fields readonly or show a spinner).
	         *
	         * Should be treated as a readonly property.
	         */
	        this.calculating = ko.observable(false);
	        this._call = null;
	        this._callName = null;
	        this._target = null;
	        this._verbose = verbose;
	        this._watcher = null;
	        var callName = (ko.unwrap(calculationPliCallName) || "").toString();
	        if (callName && target) {
	            this._callName = callName;
	            this._target = target;
	            this._watcher = ko.computed({
	                read: this._beginCalculation,
	                owner: this,
	                deferEvaluation: true,
	                pure: false // keep updating even when it has no subscribers
	            });
	            if (throttleEvaluationMilliseconds > 0) {
	                this._watcher.extend({ rateLimit: throttleEvaluationMilliseconds }); // see http://knockoutjs.com/documentation/rateLimit-observable.html
	            }
	            this._watcher(); // manually trigger first evaluation (that is expected to build a list of observable dependencies)
	        }
	    }
	    /**
	     * Apply specified calculation result to the viewmodel for which we are performing calculations.
	     *
	     * Exposed publically so that it can be called manually, e.g. during viewmodel load
	     * (this is in addition to the automatic calls invoked internally by
	     * this calculation engine).
	     *
	     * @param {any} result
	     *     Result of server calculation to apply to root contributor (and its children via recursive "visit" calls).
	     *     Will be available as "context.rootData" in "applyServerCalculationResult" methods).
	     */
	    ServerCalculation.prototype.applyResult = function (result) {
	        new ServerCalculationContext("applyServerCalculationResult", result).visit(this._target);
	    };
	    /**
	     * Stop observing target viewmodel.
	     */
	    ServerCalculation.prototype.dispose = function () {
	        this._watcher.dispose();
	    };
	    // -------------------------------------------------------------------------
	    // Private
	    // -------------------------------------------------------------------------
	    /**
	     * Traverse target viewmodel, extracting data for server calculation and setting up observable dependencies
	     *
	     * The dependencies are used to re-trigger calculation in the future
	     * if any calculation input changes.
	     */
	    ServerCalculation.prototype._beginCalculation = function () {
	        var targetAny = this._target;
	        var state = (targetAny && targetAny.extras && targetAny.extras.state);
	        if (!state || ko.unwrap(state.isReady)) {
	            var calculationData = new ServerCalculationContext("buildServerCalculationData").visit(this._target); // create dependency on all observables used in calculation request
	            if (calculationData) {
	                var callPromise = call_1.default({
	                    name: this._callName,
	                    data: calculationData,
	                    owner: this
	                });
	                this._call = callPromise;
	                this.calculating(true); // notify subscribers that we are calculating
	                callPromise.always(ServerCalculation._endCalculation);
	            }
	        }
	    };
	    /**
	     * Process result of server calculation. Calls "applyResult" unless there were problems.
	     */
	    ServerCalculation._endCalculation = function (response) {
	        if (response.owner._call.xhr !== response.clientXhr) {
	            if (response.owner._verbose) {
	                console.warn("Ignoring server calculation response", response);
	            }
	        }
	        else {
	            if (response.isError) {
	                if (response.owner._verbose) {
	                    console.error("Server calculation failed", response);
	                }
	            }
	            else {
	                if (response.owner._verbose) {
	                    console.log("Server calculation complete", response);
	                }
	                response.owner.applyResult(response.result);
	            }
	            response.owner._call = null;
	            response.owner.calculating(false); // notify subscribers that we are done calculating
	        }
	    };
	    return ServerCalculation;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ServerCalculation;
	



/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	var NotificationMessage = __webpack_require__(529);
	
	module.exports = NotificationMessage;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	
	__webpack_require__(530);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "NotificationMessage" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//----------------------------------------
	function NotificationMessage() {
	    /// <summary>
	    /// Define viewmodel.
	    /// </summary>
	    if (!(this instanceof NotificationMessage)) { return new NotificationMessage(); } // if new was not used, force it now
	
	    this.title = ko.observable("");
	    this.message = ko.observable("");
	    this.isVisible = ko.observable(false);
	
	    this.hide = this.hide.bind(this);
	}
	
	
	//----------------------------------------
	NotificationMessage.prototype.show = function showNotification(options) {
	    /// <summary>
	    /// Show notification error message.
	    /// </summary>
	    if (!options) { options = {}; }
	
	    this.title(options.title || "");
	    this.message(options.message || "");
	    this.isVisible(true);
	};
	
	
	//----------------------------------------
	NotificationMessage.prototype.hide = function hideNotification() {
	    /// <summary>
	    /// Hide notification error message.
	    /// </summary>
	    this.isVisible(false);
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//----------------------------------------
	module.exports = NotificationMessage;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(531);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var $ = __webpack_require__(1);
	var ko = __webpack_require__(457);
	
	//-------------------------------------------
	// Defines a custom knockout binding for tooltip menu.
	ko.bindingHandlers.visibleNotification = {
	    init: function visibleNotificationInit(element, valueAccessor) {
	        var value = valueAccessor(),
	            $element = $(element);
	
	        $('html').click(function () { // define an onClick handle on html page
	            if (ko.utils.domData.get(element, element.needToCloseOnClickOutside)) {
	                value(false);
	                ko.utils.domData.set(element, element.needToCloseOnClickOutside, false);
	            }
	        });
	
	        $element.click(function (event) { // define an onClick handle on the element to prevent global click event
	            event.stopPropagation();
	        });
	    },
	    update: function visibleNotificationUpdate(element, valueAccessor) {
	        var value = valueAccessor(),
	            $element = $(element);
	        if (ko.unwrap(value)) {
	            $element.show();
	            setTimeout(function () { ko.utils.domData.set(element, element.needToCloseOnClickOutside, true); }, 250); // make a delay to prevent hiding the tool tip while it showing by click from tool tip's outside
	        } else {
	            $element.hide();
	        }
	    }
	};
	
	
	//-------------------------------------------
	module.exports = ko;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true, sub: true, todo: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var viewModelInit = __webpack_require__(465);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function resolveKeymapHandler(gridObservable, name) {
	    /// <summary>
	    /// Attempts to resolve the keymap handler
	    /// on grid observable for name specified.
	    /// </summary>
	
	    // check grid observable
	    var v = gridObservable[name];
	    if (typeof v === "function") {
	        return function simpleKeymapHandler() {
	            v.apply(gridObservable, arguments);
	            return false;
	        };
	    }
	
	    return function keymapHandler() {
	        // check grid observable value
	        v = ko.isObservable(gridObservable)
	            && ko.utils.unwrapObservable(gridObservable);
	        if (v && typeof v[name] === "function") {
	            v[name].apply(v, arguments);
	            return false;
	        }
	    };
	
	}
	
	//---------------------------------------
	function extendKeymap(gridPage, formPage, o) {
	    /// <summary>
	    /// Initializes standard keymap configuration for grid/form pages.
	    /// Specify `keymapData` on either `gridPage` or `formPage` to
	    /// overwrite/append to standard keymap entries.
	    /// </summary>
	
	    // extend keymap data.
	    // TODO - remove exclusion for root form once keymap handling is rejiggered into ViewModelInit.js
	    if (!(gridPage.form && gridPage.form.isRoot)) {
	        gridPage.keymapData = ko.utils.extend({
	            "Copy": resolveKeymapHandler(o, "copyItems"),
	            "Link": resolveKeymapHandler(o, "linkItems"),
	            "New": resolveKeymapHandler(o, "openNew")
	        }, gridPage.keymapData);
	    }
	
	    // initialize form keymap
	    formPage.keymapData = ko.utils.extend({
	        "Back": resolveKeymapHandler(o, "closeCurrent"),
	        "Delete": resolveKeymapHandler(o, "deleteAndCloseCurrent"),
	        "NextSibling": resolveKeymapHandler(o, "openNext"),
	        "Open": resolveKeymapHandler(o, "openTarget"),
	        "PreviousSibling": resolveKeymapHandler(o, "openPrevious")
	    }, formPage.keymapData);
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// ViewModelInit extensions
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	viewModelInit.standardFactoryCreatorFor = function standardFactoryCreatorFor(itemClass, itemAccessor, extraFactoriesProvider, extraFactoryFinalizer, gridEmbeddedOnForm) {
	    /// <summary>Note: could be added to GridViewModel.js</summary>
	    return function createGridViewModelFactoryFor(originalRootId) {
	        var rootId = originalRootId;
	        if (!gridEmbeddedOnForm) {
	            rootId = originalRootId.concat("_", itemAccessor);
	        }
	        var parentPage = pli.forms.navigationPages[rootId],
	            formId = (parentPage && parentPage.defaultChildFormId) || rootId.concat("_form"),
	            childPage = pli.forms.navigationPages[formId],
	            haveExtraFactoriesProvider = (typeof extraFactoriesProvider === "function");
	        var newArguments = arguments;
	        newArguments[0] = formId;
	        var factory = viewModelInit.createGridViewModelFactory(
	            ko.utils.extend(
	                {
	                    computeErrorsCount: viewModelInit.computeErrorsCount,
	                    finalize: function finalizeGridViewModelFactory(rootObject) {
	                        if (parentPage && childPage) {
	                            var itemObservable = (ko.isObservable(rootObject)
	                                ? ko.computed(function () { return ko.utils.unwrapObservable(rootObject)[itemAccessor]; })
	                                : ko.observable(ko.utils.unwrapObservable(rootObject)[itemAccessor])
	                            );
	                            factory.initializeNavigation(
	                                parentPage,
	                                childPage,
	                                itemObservable
	                            );
	                            extendKeymap(
	                                parentPage,
	                                childPage,
	                                itemObservable
	                            );
	                        } else {
	                            if (window.console && window.console.warn) { window.console.warn("Grid navigation init skipped because of missing navigation page:", { parentId: rootId, parentPage: parentPage, childId: formId, childPage: childPage }); }
	                        }
	
	                        if (typeof extraFactoryFinalizer === "function") {
	                            extraFactoryFinalizer.call(factory, rootObject);
	                        }
	
	                        return (haveExtraFactoriesProvider
	                            ? ko.computed(function () { return ko.utils.unwrapObservable(rootObject)[itemAccessor].current(); })
	                            : null
	                        );
	                    },
	                    secureAction: viewModelInit.secureAction,
	                    checkForDependencies: viewModelInit.checkForDependencies
	                },
	                haveExtraFactoriesProvider ? extraFactoriesProvider.apply(rootId, newArguments) : null
	            ),
	            itemClass,
	            null,
	            2 // apiVersion
	        );
	        return factory;
	    };
	};
	
	
	//-------------------------------------------
	// TODO: rename to "completeFactories" to be
	// compatible with current viewmodel vocabulary.
	viewModelInit.finalizeFactories = function finalizeFactoriesRecursive(factories, rootObject) {
	    /// <summary></summary>
	    if (factories.hasOwnProperty("factories")) {
	        factories = factories.factories;
	    }
	    var childObject = rootObject;
	    if (typeof factories.finalize === "function") {
	        childObject = factories.finalize(rootObject);
	    }
	    var name, childFactories;
	    for (name in factories) {
	        if (factories.hasOwnProperty(name)) {
	            childFactories = factories[name];
	            if (typeof childFactories === "object") {
	                viewModelInit.finalizeFactories(childFactories, childObject);
	            }
	        }
	    }
	};
	
	
	//-------------------------------------------
	viewModelInit.assignKeymaps = function assignPageKeymaps() {
	    /// <summary></summary>
	    var key, page;
	    for (key in pli.forms.navigationPages) {
	        if (pli.forms.navigationPages.hasOwnProperty(key)) {
	            page = pli.forms.navigationPages[key];
	            if (page.keymapData) {
	                if (!page.keymapData.hasOwnProperty("New")) { page.keymapData["New"] = false; } // block new (when not assigned)
	                pli.keys.registerKeymap(key, page.keymapData);
	                page.keymap = key;
	                delete page.keymapData;
	            }
	        }
	    }
	};
	
	
	//-------------------------------------------
	viewModelInit.secureAction = function secureViewModelAction(action, context, isReadOnly) {
	    /// <summary>
	    /// Ensures an view-model action does not
	    /// fire if the entity is read-only.
	    /// </summary>
	    /// <param name="action">The action to fire if allowed</param>
	    /// <param name="context">The value of 'this' for the action</param>
	    /// <param name="isReadOnly">Custom function used to determine whether action cannot execute</param>
	    if (typeof action !== "function") { throw new Error("action must be a function"); }
	    if (typeof isReadOnly === "function") {
	        return function customSecuredAction() {
	            if (isReadOnly() || pli.viewModel.extras.isReadOnly()) { return; }
	            return action.apply(context, arguments);
	        };
	    }
	    return function defaultSecuredAction() {
	        if (pli.viewModel.extras.isReadOnly()) { return; }
	        return action.apply(context, arguments);
	    };
	};
	
	
	//-------------------------------------------
	viewModelInit.checkForDependencies = function checkForDependencies() {
	    var current = this.current(),
	        dependencies = current.extras.dependencies && current.extras.dependencies(),
	        message,
	        index;
	
	    if (dependencies && dependencies.indexOf && dependencies.length > 0) {
	        message = "Cannot delete this item; it is used by";
	
	        for (index = 0; index < dependencies.length && index < 3; index += 1) {
	            message += (index === 0 ? " " : ", ") + dependencies[index];
	        }
	
	        message += (dependencies.length > 3 ? " and others." : ".");
	
	        if (current.extras && current.extras.dependencyHint) {
	            message += current.extras.dependencyHint;
	        }
	
	        pli.viewModel.extras.notificationMessage.show({
	            title: "Cannot delete split",
	            message: message
	        });
	
	        return true;
	    }
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = viewModelInit;


/***/ }),
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(541);


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var dateBehaviour = __webpack_require__(449).behaviours.date;
	var ko = __webpack_require__(457);
	var pliObservable = __webpack_require__(15);
	
	var formattedBehaviour = __webpack_require__(518);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// ReminderViewModelExtensions static class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function ReminderViewModelExtensions() {
	    this.recur = pliObservable(null, "N0", "numeric");
	    this.recurUnit = ko.observable("M");
	    this.start = pliObservable(null, null, "required", dateBehaviour, formattedBehaviour);
	    this.completion = pliObservable(null, null, dateBehaviour, formattedBehaviour);
	    this.extras.reminder = ko.computed(ReminderViewModelExtensions.prototype._computeReminder, this);
	}
	
	
	//---------------------------------------
	ReminderViewModelExtensions.prototype.loadViewModel = function loadReminder(record) {
	    this.recur.load(record.recur);
	    this.recurUnit(record.recurUnit || "M");
	    this.start.load(record.start);
	    this.completion.load(record.completion);
	};
	
	
	//---------------------------------------
	ReminderViewModelExtensions.prototype._computeReminder = function computeReminderValue() {
	    /// <summary>
	    /// Computes a readable string used to represent
	    /// the reminder.
	    /// </summary>
	    this.start(); // create subscription to start
	    var recur = this.recur(),
	        recurUnit = this.recurUnit(),
	        result;
	    if (recur === 1) {
	        result = "".concat(this.start.format()).concat(" every ").concat(recurUnit === "Y" ? "year" : "month");
	    } else if (recur > 1) {
	        result = "".concat(this.start.format()).concat(" every ").concat(this.recur.format()).concat(recurUnit === "Y" ? " years" : " months");
	    } else {
	        result = this.start.formatted();
	    }
	    return result;
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = {
	    mixins: {
	        initReminder: ReminderViewModelExtensions,
	        loadReminder: ReminderViewModelExtensions.prototype.loadViewModel
	    }
	};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(543);


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var $ = __webpack_require__(1);
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var createContactPercentageFactory = __webpack_require__(544);
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	var formattedBehaviour = __webpack_require__(518);
	var selectionForm = __webpack_require__(520);
	var viewModelInit = __webpack_require__(532);
	
	//-------------------------------------------
	function selectRoyalties(royaltiesArray, link) {
	    /// <summary>
	    /// Show royalties selection form and either
	    /// copy (if "link" is falsy) or link (if "link" is truthy)
	    /// selected royalties to the specified array.
	    /// </summary>
	    selectionForm.open({
	        getDetailsApi: "Geo-CopyLinkDocument-GetDetails",
	        getDetailsDataBuilder: function (items) { // needed to adapt request for Geo-CopyLinkDocument-GetDetails
	            var guidIndex = items[0].length - 1;
	            return {
	                documentType: "Royalty",
	                actionType: (link ? "Link" : "Copy"),
	                copyLinkFrom: ko.utils.arrayMap(items, function (item) {
	                    return {
	                        name: item[0],
	                        guid: item[guidIndex]
	                    };
	                })
	            };
	        },
	        multiSelect: true,
	        onAcceptedContext: royaltiesArray,
	        onAccepted: function (newRoyalties) {
	            if (!link) { // if copying, reset all guid-s (so that save will create a new, copied content)
	                newRoyalties = selectionForm.utils.resetGuids(newRoyalties);
	            }
	            selectionForm.utils.pushObjectItems({
	                targetArray: royaltiesArray,
	                records: newRoyalties,
	                getIdentity: (!link ? null : function (royalty) { return royalty.guid(); })
	            });
	        },
	        searchApi: "Geo-Document-SearchRoyalties",
	        text: {
	            acceptButton: (link ? "Link" : "Copy"),
	            examples: [
	                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
	            ],
	            iconClass: (link ? "sprite-link-16" : "sprite-copy-16"),
	            title: (link ? "Link Royalties" : "Copy Royalties")
	        }
	    });
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Royalty class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	// Create new Royalty object, populating
	// it with values from the specified
	// record (if any).
	function Royalty(factories) {
	    if (window.console && window.console.group) { window.console.group("Royalty.ctor", factories); }
	
	    this.comments = ko.observable("");
	    this.convertible = ko.observable(false);
	    this.convertibleAsOf = ko.observable("");
	    this.convertibleTo = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric");
	    this.deductionAmount = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric");
	    this.deductionFor = ko.observable("");
	    this.gasPriceBrackets = ko.observable("");
	    this.guid = ko.observable(null);
	    this.oilSlidingScaleFactor = pliObservable(null, null, "numeric");
	    this.oilSlidingScaleMax = pliObservable(null, null, "numeric");
	    this.oilSlidingScaleMin = pliObservable(null, null, "numeric");
	    this.payees = factories.payee.createObservableArray();
	    this.payors = factories.payor.createObservableArray();
	    this.percentageModel = pliObservable(null, dataCache.getObservable("productPercentageModel"), "required", "picklist");
	    this.percentageAll = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric");
	    this.percentageGas = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric");
	    this.percentageGasMinDollars = pliObservable(null, "C2", "numeric");
	    this.percentageOil = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric");
	    this.productionPercentage = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric", formattedBehaviour);
	    this.takeInKind = ko.observable(false);
	    this.type = this.id = pliObservable(null, entityRegistry.royaltyType.getPicklistBehaviourData(), "required", "picklist"); // type and id point to the same observable
	    this.link = ko.observable(null);
	
	    // non-serialized properties
	    this.extras = function RoyaltyExtras() { return; };
	    this.extras.percentageModelType = ko.computed(Royalty.prototype.computePercentageModelType, this);
	    this.extras.calculation = ko.computed(Royalty.prototype.computeCalculation, this);
	    this.extras.convertibility = ko.computed(Royalty.prototype.computeConvertibility, this);
	    this.extras.errorsCountFlat = ko.computed(factories.computeErrorsCount, this);
	    this.extras.errorsCountPayor = ko.computed(Royalty.prototype._computePayorErrorsCount, this);
	    this.extras.errorsCountPayee = ko.computed(Royalty.prototype._computePayeeErrorsCount, this);
	    this.extras.errorsCount = ko.computed(Royalty.prototype.computeErrorsCount, this);
	    this.extras.fieldsetGap = ko.computed(Royalty.prototype.computeFieldsetGap, this);
	    this.extras.globalIsReadOnly = ko.observable().subscribeTo("state.isReadOnly", true);
	    this.extras.isReadOnly = ko.computed(this._computeReadOnlyFlag, this); // has to be after stateIsReady
	    this.extras.dependencies = ko.observableArray();
	
	    if (window.console && window.console.groupEnd) { window.console.groupEnd(); }
	}
	
	
	//---------------------------------------
	Royalty.prototype.computeCalculation = function computeCalculation() {
	    var v, a, result = "", percentageModelType = this.extras.percentageModelType();
	    if (percentageModelType === 1) { // "all"
	        a = this.percentageAll();
	        result = "".concat(a || 0, "% of all products");
	    } else if (percentageModelType === 2) { // "custom"
	        v = this.percentageOil();
	        if (v) {
	            result += "".concat(v, "% of Oil");
	        }
	        v = this.percentageGas();
	        if (v) {
	            a = this.percentageGasMinDollars();
	            result += (result ? ", " : "").concat(v, "% of Gas", a ? " (min. $" + a + ")" : "");
	        }
	        if (result) {
	            return result;
	        }
	        v = this.oilSlidingScaleFactor();
	        if (v) {
	            result = "".concat("Oil S/S:1/", v);
	        }
	        v = this.oilSlidingScaleMin();
	        if (v) {
	            a = this.oilSlidingScaleMax();
	            if (a) {
	                result += (result ? "," : "Oil S/S:").concat("$", v, "-", a);
	            }
	        }
	
	        result = result || "Custom (no parameters)";
	    } else if (percentageModelType === 3) {
	        result = "Crown Sliding Scale";
	    } else {
	        result = "";
	    }
	    return result;
	};
	
	
	//---------------------------------------
	Royalty.prototype.computeConvertibility = function computeConvertibility() {
	    if (this.convertible()) {
	        var to = this.convertibleTo() || 0,
	            asOf = this.convertibleAsOf() || "";
	
	        return "".concat(to, "%", asOf ? ", as of " : "", asOf);
	    }
	    return "Non-Conv.";
	};
	
	
	//---------------------------------------
	Royalty.prototype.computeErrorsCount = function computeRoyaltyErrorsCount() {
	    return (this.extras.errorsCountFlat()
	        + this.extras.errorsCountPayor()
	        + this.extras.errorsCountPayee());
	};
	
	
	//---------------------------------------
	Royalty.prototype._computePayorErrorsCount = function computePayorErrorsCount() {
	    var totalError = (this.payors().length > 0 && this.payors.totalPercentage.invalid()) ? 1 : 0;
	    return this.payors.errorsCount() + totalError;
	};
	
	
	//---------------------------------------
	Royalty.prototype._computePayeeErrorsCount = function computePayeeErrorsCount() {
	    var totalError = (this.payees().length > 0 && this.payees.totalPercentage.invalid()) ? 1 : 0;
	    return this.payees.errorsCount() + totalError;
	};
	
	
	//---------------------------------------
	Royalty.prototype.computeErrorsCountFlat = viewModelInit.computeErrorsCount;
	Royalty.prototype.itemComparer = null; // disable client-side sorting
	
	
	//---------------------------------------
	// compute brackets field height based on properties
	// that affect field visibility to keep payor
	// and payee grids vertically aligned
	Royalty.prototype.computeFieldsetGap = function computeFieldsetGap() {
	    if (this.convertible()) {
	        switch (this.extras.percentageModelType()) {
	        case 1: // "all"
	            return 91;
	        case 2: // "custom"
	            return 0;
	        default:
	            return 117;
	        }
	    }
	    switch (this.extras.percentageModelType()) {
	    case 1: // "all"
	        return 39;
	    case 2: // "custom"
	        return 0;
	    default:
	        return 65;
	    }
	};
	
	
	//---------------------------------------
	// convert string in percentageModel property
	// (case-insensitively) into an integer that
	// we can use to bind visibility attributes
	Royalty.prototype.computePercentageModelType = function computePercentageModelType() {
	    var model = this.percentageModel();
	    if (model) {
	        model = $.trim(model.toLowerCase());
	        if (model === "all") {
	            return 1;
	        }
	        if (model === "custom") {
	            return 2;
	        }
	        if (model === "css") {
	            return 3;
	        }
	    }
	    return 0;
	};
	
	
	//---------------------------------------
	Royalty.prototype.initGridArray = function initRoyaltyGridArray(gridArray) {
	    /// <summary>
	    /// Add extra methods to the specified
	    /// royalties grid array (that has just
	    /// been created).
	    /// </summary>
	    gridArray.copyItems = gridArray.factory.factories.secureAction(Royalty.prototype._copyItems, gridArray);
	    gridArray.linkItems = gridArray.factory.factories.secureAction(Royalty.prototype._linkItems, gridArray);
	    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray, gridArray.factory.factories.checkForDependencies.bind(gridArray));
	    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);
	};
	
	
	//---------------------------------------
	Royalty.prototype.loadViewModel = function loadRoyalty(record) {
	    if (window.console && window.console.group) { window.console.group("Royalty.loadViewModel", record); }
	
	    if (!record) { record = {}; }
	
	    this.comments(record.comments || "");
	    this.convertible(!!record.convertible);
	    this.convertibleAsOf(record.convertibleAsOf || "");
	    this.convertibleTo.load(record.convertibleTo);
	    this.deductionAmount.load(record.deductionAmount);
	    this.deductionFor(record.deductionFor || "");
	    this.gasPriceBrackets(record.gasPriceBrackets || "");
	    this.guid = ko.observable(record.guid || null);
	    this.link(record.link || null);
	    this.oilSlidingScaleFactor.load(record.oilSlidingScaleFactor);
	    this.oilSlidingScaleMax.load(record.oilSlidingScaleMax);
	    this.oilSlidingScaleMin.load(record.oilSlidingScaleMin);
	    this.payees.loadViewModel(record.payees);
	    this.payees.isReadOnly(!!this.link());
	    this.payors.loadViewModel(record.payors);
	    this.payors.isReadOnly(!!this.link());
	    this.percentageModel.load(record.percentageModel);
	    this.percentageAll.load(record.percentageAll);
	    this.percentageGas.load(record.percentageGas);
	    this.percentageGasMinDollars.load(record.percentageGasMinDollars);
	    this.percentageOil.load(record.percentageOil);
	    this.productionPercentage.load(record.productionPercentage);
	    this.takeInKind(!!record.takeInKind);
	    this.type.load(record.type || "");
	
	    this.extras.dependencies(record.dependencies || []);
	
	    if (window.console && window.console.groupEnd) { window.console.groupEnd(); }
	};
	
	
	//---------------------------------------
	Royalty.prototype._computeReadOnlyFlag = function computeRoyaltyReadOnlyFlag() {
	    var readonly = this.extras.globalIsReadOnly(), link = this.link();
	    return readonly || link;
	};
	
	
	//---------------------------------------
	Royalty.prototype._copyItems = function copyRoyalties() {
	    /// <summary>
	    /// Copy royalties from other documents. Shows
	    /// a selection form that allows user to select
	    /// and accept royalties to copy.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores royalties.
	    /// </remarks>
	    selectRoyalties(this, false); // false => copy
	};
	
	
	//---------------------------------------
	Royalty.prototype._linkItems = function linkRoyalties() {
	    /// <summary>
	    /// Link royalties from other documents. Shows
	    /// a selection form that allows user to select
	    /// and accept royalties to link.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores royalties.
	    /// </remarks>
	    selectRoyalties(this, true); // true => link
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Export
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = viewModelInit.standardFactoryCreatorFor(
	    Royalty,
	    "royalties",
	    function createExtraRoyaltyFactories(rootId) {
	        return {
	            payor: createContactPercentageFactory(rootId, "payors", true), // true => client total percentage calculation
	            payee: createContactPercentageFactory(rootId, "payees", true)  // true => client total percentage calculation
	        };
	    }
	);


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	var numberUtil = __webpack_require__(21);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var formattedBehaviour = __webpack_require__(518);
	var entityRegistry = __webpack_require__(492);
	var viewModelInit = __webpack_require__(532);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function extractNumber(record, name) {
	    var value = record && record[name];
	    return (numberUtil.isNumber(value) ? value : null);
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// ContactPercentage class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function ContactPercentage(factories) {
	    /// <summary>
	    /// Define viewmodel.
	    /// </summary>
	    if (window.console && window.console.group) { window.console.log("ContactPercentage.ctor", factories); }
	
	    this.guid = ko.observable(null);
	    this.contact = this.id = pliObservable(null, entityRegistry.contact.getPicklistBehaviourData(), "required", "picklist");
	    this.silent = ko.observable(false);
	    this.contactInNetCalcs = ko.observable(false);
	    this.percentage = pliObservable(null, pli.config.editorPrecisionPercentFormat, "required", "numeric", formattedBehaviour);
	
	    // non-serialized properties
	    this.extras = function ContactPercentageExtras() { return; };
	    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);
	    this.extras.rental = ko.observable(null);
	    this.extras.codeAndFullName = ko.observable(null);
	    this.extras._subscriptionUpdateInfo = null;
	    if (ko.isObservable(this.id.item)) {
	        this.extras._subscriptionUpdateInfo = this.id.item.subscribe(this._updateInfo, this);
	        this._updateInfo(this.id.item()); // force initial update
	    }
	
	    this.extras.rental.currency = ko.pureComputed(function () {
	        return numberUtil.formatNumber(this.extras.rental(), 'C2');
	    }, this);
	}
	
	
	//---------------------------------------
	ContactPercentage.prototype.applyServerCalculationResult = function applyContactPercentageResult(context) {
	    var record = context.currentData;
	    this.extras.rental(extractNumber(record, "rental"));
	};
	
	
	//---------------------------------------
	ContactPercentage.prototype.buildServerCalculationData = function buildContactPercentageData() {
	    return {
	        contact: this.contact(),
	        silent: this.silent(),
	        contactInNetCalcs: this.contactInNetCalcs(),
	        percentage: this.percentage()
	    };
	};
	
	
	//---------------------------------------
	ContactPercentage.prototype.initGridArray = function initContactPercentageGridArray(gridArray) {
	    /// <summary>
	    /// Add extra methods to the specified
	    /// contact percentages grid array (that has just
	    /// been created).
	    /// </summary>
	    gridArray.isReadOnly = ko.observable();
	    gridArray.applyServerCalculationResult = ContactPercentage.prototype._applyResultToGridArray;
	    gridArray.ownerPercentage = ko.observable(null);
	    gridArray.totalPercentage = (gridArray.factory.factories.calculateTotalPercentageOnClient
	        ? ko.computed(ContactPercentage.prototype._computeTotalPercentage, gridArray)
	        : ko.observable(null));
	    gridArray.totalPercentage.invalid = ko.computed(ContactPercentage.prototype._computeTotalPercentageInvalid, gridArray.totalPercentage);
	    gridArray.totalRental = ko.observable(null);
	
	    gridArray.totalRental.currency = ko.pureComputed(function () {
	        return numberUtil.formatNumber(gridArray.totalRental(), 'C2');
	    }, gridArray);
	
	    gridArray.totalPercentage.precision = ko.pureComputed(function () {
	        return numberUtil.formatNumber(gridArray.totalPercentage(), pli.config.editorPrecisionPercentFormat);
	    }, gridArray);
	
	    gridArray._originalDispose = gridArray.dispose;
	    gridArray.dispose = ContactPercentage.prototype._disposeGridArray;
	
	    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray, gridArray.isReadOnly);
	    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray, gridArray.isReadOnly);
	    if (gridArray.factory.factories.copyItems) {
	        gridArray.copyItems = gridArray.factory.factories.secureAction(gridArray.factory.factories.copyItems, gridArray);
	    }
	};
	
	
	//-------------------------------------------
	ContactPercentage.prototype.loadViewModel = function loadContactPercentage(record) {
	    /// <summary>
	    /// Populate viewmodel with data.
	    /// </summary>
	    if (window.console && window.console.group) { window.console.log("ContactPercentage.loadViewModel", record); }
	
	    if (!record) { record = {}; }
	
	    this.contact.load(record.contact);
	    this.guid(record.guid || null);
	    this.percentage.load(record.percentage);
	
	    if (typeof record.silent === "string") {
	        this.silent(record.silent === "Yes");
	    } else {
	        this.silent(!!record.silent);
	    }
	    this.contactInNetCalcs(!!record.contactInNetCalcs);
	};
	
	
	//---------------------------------------
	ContactPercentage.prototype._applyResultToGridArray = function contactPercentageApplyResultToCollection(context) {
	    if (ko.isObservable(this.ownerPercentage)) {
	        this.ownerPercentage(extractNumber(context.currentData, context.currentCollectionName + "OwnerPercentage"));
	    }
	    if (ko.isObservable(this.totalPercentage)) {
	        this.totalPercentage(extractNumber(context.currentData, context.currentCollectionName + "TotalPercentage"));
	    }
	    if (ko.isObservable(this.totalRental)) {
	        this.totalRental(extractNumber(context.currentData, context.currentCollectionName + "TotalRental"));
	    }
	};
	
	
	//---------------------------------------
	ContactPercentage.prototype._computeTotalPercentage = function computeTotalPercentage() {
	    /// <summary>
	    /// Sum all percentages in this grid array.
	    /// This method is only used if this grid array
	    /// was created with calculateTotalPercentageOnClient
	    /// flag set to true.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid array.
	    /// </remarks>
	    var i, l, t = 0, a = this(), precision = pli.config.editorPrecision || 5;
	    for (i = 0, l = a.length; i < l; i += 1) {
	        // Round contact percentage by editor precision before adding to the total
	        t += Math.round(a[i].percentage() * Math.pow(10, precision)) / Math.pow(10, precision);
	    }
	    return t;
	};
	
	
	//---------------------------------------
	ContactPercentage.prototype._computeTotalPercentageInvalid = function computeTotalPercentageInvalid() {
	    var totalPercentage = this();
	
	    // Calculate the delta used for javascript floating point precision problem
	    // using the decimal precision settings
	    // http://stackoverflow.com/questions/588004/is-floating-point-math-broken
	    var precision = pli.config.editorPrecision || 5;
	    var delta = Math.pow(10, -(precision + 1));
	
	    return (totalPercentage !== null && totalPercentage < 100 && Math.abs(100 - totalPercentage) > delta);
	};
	
	
	//---------------------------------------
	ContactPercentage.prototype._disposeGridArray = function disposeGridArray() {
	    /// <summary>
	    /// This method is only used if this grid array
	    /// was created with calculateTotalPercentageOnClient
	    /// flag set to true.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid array.
	    /// </remarks>
	    this.totalPercentage.invalid.dispose();
	    if (this.totalPercentage.dispose) { this.totalPercentage.dispose(); }
	    this._originalDispose();
	};
	
	//---------------------------------------
	ContactPercentage.prototype._updateInfo = function updateRelatedContactInfo(contactRow) {
	    /// <remarks>
	    /// Assumes "this" points to a related contact.
	    /// </remarks>
	
	    if (!contactRow) {
	        this.extras.codeAndFullName(null);
	        return;
	    }
	
	    var code = contactRow[0],
	        fullName = contactRow[2];
	
	    if (fullName && fullName.length > 0 && fullName !== " " && fullName !== code) {
	        this.extras.codeAndFullName(code + " (" + fullName + ")");
	    } else {
	        this.extras.codeAndFullName(code);
	    }
	};
	
	
	//-------------------------------------------
	ContactPercentage.prototype.itemComparer = null; // disable client-side sorting
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Export
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = function createContactPercentageFactory(rootId, itemAccessor, calculateTotalPercentageOnClient, copyItems) {
	    var factoryCreator = viewModelInit.standardFactoryCreatorFor(
	        ContactPercentage,
	        itemAccessor,
	        function createExtraContactPercentageFactories() {
	            return {
	                calculateTotalPercentageOnClient: !!calculateTotalPercentageOnClient,
	                copyItems: copyItems
	            };
	        }
	    );
	    return factoryCreator(rootId);
	};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var createCommentsFactory = __webpack_require__(546);
	var createDoisFactory = __webpack_require__(549);
	var createObligationsFactory = __webpack_require__(551);
	var createRelatedDocsFactory = __webpack_require__(553);
	var createRelatedWellsFactory = __webpack_require__(555);
	var entityRegistry = __webpack_require__(492);
	var selectionForm = __webpack_require__(520);
	var viewModelInit = __webpack_require__(532);
	var LandsRightsEditGridViewModel = __webpack_require__(557);
	
	__webpack_require__(564).registerEditGridBinding();
	__webpack_require__(566);
	__webpack_require__(567);
	
	//-------------------------------------------
	function findMaxSplitNumber(splits) {
	    var l, i, n, max = 0;
	    if (splits) {
	        for (i = 0, l = splits.length; i < l; i += 1) {
	            n = splits[i].number();
	            if (n > max) { max = n; }
	        }
	    }
	    return max;
	}
	
	
	//-------------------------------------------
	function renumberSplits(splits, start) {
	    var l, i;
	    if (splits) {
	        for (i = 0, l = splits.length; i < l; i += 1) {
	            splits[i].number = start + i + 1;
	        }
	    }
	    return splits;
	}
	
	
	//-------------------------------------------
	function getRelatedDocumentId(relatedDoc) {
	    return relatedDoc.id();
	}
	
	
	//-------------------------------------------
	function checkCanDeleteSplit() {
	    /// <summary>
	    /// Check if split isn't last, don't use in sibling splits
	    /// and doesn't have dependencies
	    /// </summary>
	    /*jshint validthis: true */
	    var i, l, splitName, splits, relDocs;
	    if (this().length === 1) {
	        pli.viewModel.extras.notificationMessage.show({
	            title: "Cannot delete split",
	            message: "The document must contain at least one split"
	        });
	        return true;
	    }
	    splits = this();
	    splitName = pli.viewModel.id.peek() + " - " + this.current().id.peek();
	    for (i = 0, l = splits.length; i < l; i += 1) {
	        relDocs = ko.utils.arrayMap(splits[i].relatedDocs(), getRelatedDocumentId);
	        if (ko.utils.arrayIndexOf(relDocs, splitName) >= 0) {
	            pli.viewModel.extras.notificationMessage.show({
	                title: "Cannot delete split",
	                message: "This split has a relationship with split " + splits[i].id.peek() + " on this document."
	            });
	            return true;
	        }
	    }
	
	    return this.factory.factories.checkForDependencies.bind(this)();
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// SplitViewModelExtensions static class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function SplitViewModelExtensions(factories) {
	    this.guid = ko.observable(null);
	    this.number = pliObservable(null, "N0", "required", "numeric");
	    this.number.dispose = SplitViewModelExtensions.prototype._disposeNumber;
	    this.id = ko.computed(SplitViewModelExtensions.prototype._computeId, this);
	    this.status = pliObservable(null, entityRegistry.splitStatus.getPicklistBehaviourData(), "picklist");
	    this.status.updateDate = pliObservable(null, null, "date");
	    this.status.isActive = ko.computed(SplitViewModelExtensions.prototype._computeIsStatusActive, this.status);
	    this.operator = pliObservable(null, entityRegistry.contact.getPicklistBehaviourData(), "picklist");
	    this.description = pliObservable();
	
	    this.dois = factories.dois.createObservableArray();
	    this.obligations = factories.obligations.createObservableArray();
	    this.relatedDocs = factories.relatedDocs.createObservableArray();
	    this.relatedDocs.owner = this; // store link to the current split
	    this.relatedWells = factories.relatedWells.createObservableArray();
	    this.remarks = factories.comments.createObservableArray();
	    this.tracts = ko.observableArray();
	
	    this.addComment = SplitViewModelExtensions.prototype.addComment.bind(this);
	    this.editComment = SplitViewModelExtensions.prototype.editComment.bind(this);
	    this.deleteComment = SplitViewModelExtensions.prototype.deleteComment.bind(this);
	
	    if (!this.extras) {
	        this.extras = function SplitViewExtensionsExtras() { return; };
	    }
	
	    this.extras.newRemark = ko.observable();
	    this.extras.newRemark.expanded = ko.observable();
	    this.extras.dependencies = ko.observableArray();
	    this.extras.dependencyHint = "  You may set the status of this split to 'Inactive'. All Related Document entries and links (DOI & Royalty) must be removed, and any changes must be saved, before this Split may be deleted.";
	    this.extras.statusDescription = ko.computed(SplitViewModelExtensions.prototype._computeStatusDescription, this);
	    this.extras.remarksLink = ko.computed(SplitViewModelExtensions.prototype._computeRemarksLink, this);
	    this.extras.commentTitle = ko.computed(SplitViewModelExtensions.prototype._commentTitleComputed, this);
	    this.extras.commentButtonEnabled = ko.computed(SplitViewModelExtensions.prototype._commentButtonEnabledComputed, this);
	
	    this.extras.landsRightsEditGrid = new LandsRightsEditGridViewModel(this.tracts);
	
	    // this is needed so that if there are server side errors, they are remembered when the user switches items.
	    this.extras.landsRightsEditGrid.editGrid.focusedItem.subscribe(function (item) {
	        if (item && item._errors) {
	            if (item._errors.location) {
	                this.extras.landsRightsEditGrid.editGrid.viewItem().location.setErrorMessage(item._errors.location);
	            }
	            if (item._errors.sections) {
	                this.extras.landsRightsEditGrid.editGrid.viewItem().sections.setErrorMessage(item._errors.sections);
	            }
	        }
	    }, this);
	}
	
	//---------------------------------------
	SplitViewModelExtensions.prototype.completeViewModel = function completeSplit() {
	    if (this.number() === null) {
	        this.number(findMaxSplitNumber(this.extras.owner()) + 1);
	    }
	};
	
	
	//---------------------------------------
	SplitViewModelExtensions.prototype.initGridArray = function initSplitGridArray(gridArray) {
	    gridArray.copyItems = gridArray.factory.factories.secureAction(SplitViewModelExtensions.prototype._copyItems, gridArray);
	    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray, checkCanDeleteSplit.bind(gridArray));
	    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);
	};
	
	
	//---------------------------------------
	SplitViewModelExtensions.prototype.loadViewModel = function loadSplit(record) {
	    this.guid(record.guid || null);
	    this.number.load(record.number);
	    this.status.load(record.status);
	    this.status.updateDate.load(record.statusUpdateDate);
	    this.operator.load(record.operator);
	    this.description.load(record.description);
	
	    this.dois.loadViewModel(record.dois || []);
	    this.obligations.loadViewModel(record.obligations);
	    this.relatedDocs.loadViewModel(record.relatedDocs);
	    this.relatedWells.loadViewModel(record.relatedWells);
	    this.remarks.loadViewModel(record.remarks);
	
	    this.tracts(record.tracts);
	
	    this.extras.dependencies(record.dependencies || []);
	    this.extras.landsRightsEditGrid.loadViewModel(record.tracts || []);
	};
	
	
	//---------------------------------------
	SplitViewModelExtensions.prototype.addComment = function addComment() {
	    var value = this.extras.newRemark.peek();
	    if (value) {
	        var newRemark = this.remarks.createItem();
	
	        newRemark.message(value);
	        newRemark.extras.createdByName(pli.viewModel.extras.userName());
	        newRemark.extras.editMessage(value);
	        newRemark.extras.editMode(false);
	
	        // Insert remark at the front of the collection
	        this.remarks.unshift(newRemark);
	
	        //clear the textarea, and refocus it
	        this.extras.newRemark("");
	        this.extras.newRemark.expanded(true);
	    }
	};
	
	
	//---------------------------------------
	SplitViewModelExtensions.prototype.editComment = function editComment(comment) {
	    // Enforces editability of only one comment at a time
	    if (this.remarks) {
	        ko.utils.arrayForEach(this.remarks(), function (remark) {
	            if (remark.extras) {
	                remark.extras.editMode(false);
	            }
	        });
	    }
	
	    // Enable edit mode for the target comment
	    if (comment && comment.extras) {
	        comment.extras.editMode(true);
	    }
	};
	
	
	//---------------------------------------
	SplitViewModelExtensions.prototype.deleteComment = function deleteComment(comment) {
	    var self = this;
	
	    // Open comment delete confirmation dialog
	    pli.forms.registry.deleteCommentForm.open(function () {
	        if (comment) {
	            self.remarks.remove(comment);
	        }
	    });
	};
	
	//---------------------------------------
	SplitViewModelExtensions.prototype._computeId = function computeSplitId() {
	    /// <summary>
	    /// Convert split id (numeric) to string value when
	    /// `number` is updated.
	    /// </summary>
	    var value = this.number();
	    return (typeof value === "number" ? value.toString() : null);
	};
	
	
	//-------------------------------------------
	SplitViewModelExtensions.prototype._computeIsStatusActive = function computeIsStatusActive() {
	    /// <summary>
	    /// Compute whether "this" split status
	    /// is active or not (boolean flag).
	    /// </summary>
	    var statusDescriptorArray = (this.item && this.item());
	    return (statusDescriptorArray && statusDescriptorArray.length > 2 && statusDescriptorArray[2].toUpperCase() === "ACTIVE");
	};
	
	
	//-------------------------------------------
	SplitViewModelExtensions.prototype._computeStatusDescription = function computeStatusDescription() {
	    /// <summary>
	    /// Compute the description text under the status.
	    /// This holds the last updated date for the status.
	    /// </summary>
	    var date = this.status.updateDate;
	
	    return date && date.raw ? "Updated on " + date.raw() : null;
	};
	
	
	//-------------------------------------------
	SplitViewModelExtensions.prototype._copyItems = function copyContractSplits() {
	    /// <summary>
	    /// Show selection form that allows users
	    /// to find and copy splits to this array.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores contract splits.
	    /// </remarks>
	    var entity = entityRegistry[pli.forms.root.id],
	        getDetailsApi = "Geo-".concat(pli.forms.root.pascalCaseId).concat("-GetSplitDetails"),
	        searchApi = "Geo-".concat(pli.forms.root.pascalCaseId).concat("-SearchSplits"),
	        selectionTitle = "Copy ".concat((entity && entity.type) || pli.forms.root.pascalCaseId).concat(" Splits");
	
	    selectionForm.open({
	        getDetailsApi: getDetailsApi,
	        getDetailsDataBuilder: function (items) { // send only the guids
	            var guidIndex = items[0].length - 1;
	            return ko.utils.arrayMap(items, function (item) { return item[guidIndex]; });
	        },
	        searchApi: searchApi,
	        multiSelect: true,
	        text: {
	            acceptButton: "Copy",
	            iconClass: "sprite-copy-16",
	            examples: [
	                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
	            ],
	            title: selectionTitle
	        },
	        onAcceptedContext: this,
	        onAccepted: function (newSplits) {
	            newSplits = selectionForm.utils.resetGuids(newSplits);
	            selectionForm.utils.pushObjectItems({
	                targetArray: this,
	                records: renumberSplits(newSplits, findMaxSplitNumber(this()))
	            });
	        }
	    });
	};
	
	
	//---------------------------------------
	SplitViewModelExtensions.prototype._computeRemarksLink = function computeRemarksLink() {
	    var h = pli.forms.crumbs().end;
	    if (h && h.previous) {
	        return h.previous.hash.concat("/remarks");
	    }
	    return null;
	};
	
	
	//-------------------------------------------
	SplitViewModelExtensions.prototype._commentTitleComputed = function commentTitleComputed() {
	    /// <summary>
	    /// Computes a string indicating how many comments are in the list
	    /// </summary>
	    /// <returns type="string">Returns a string, ex: '10 Comments'</returns>
	
	    var count = this.remarks().length;
	    return count + " Comment" + ((count === 1) ? "" : "s");
	};
	
	
	//-------------------------------------------
	SplitViewModelExtensions.prototype._commentButtonEnabledComputed = function commentButtonEnabledComputed() {
	    /// <summary>
	    /// Computes if to activate the button or not, depending on if there are any text entered
	    /// </summary>
	
	    var v = this.extras.newRemark();
	    return (v && ko.utils.stringTrim(v) !== "");
	};
	
	
	//---------------------------------------
	SplitViewModelExtensions.prototype._disposeNumber = function disposeSplitNumber() {
	    this.load(null);
	};
	
	
	viewModelInit.onBindingsApplied(function startSearchBindingsApplied(viewModel) {
	    // setup menu for lands rights new button
	    var menuItems = [
	        { title: "Land", sprite: "sprite-land-16", name: "land" },
	        { title: "Comment", sprite: "sprite-comment-16", name: "comment" },
	        { type: "Separator" },
	        { title: "Copy From...", sprite: "sprite-copy-16", name: "copy" }
	    ];
	
	    if (!pli.forms.navigationPages.surfaceLease_splits_form_landsRights) {
	        menuItems.splice(1, 0, { title: "Right", sprite: "sprite-right-16", name: "right" });
	    }
	
	    var menuHash = "#anonymous_new";
	
	    if (pli.forms.navigationPages.mineralLease_splits_form_landsRights) {
	        menuHash = "#mineralLease_splits_form_landsRights_new";
	    } else if (pli.forms.navigationPages.surfaceLease_splits_form_landsRights) {
	        menuHash = "#surfaceLease_splits_form_landsRights_new";
	    } else if (pli.forms.navigationPages.contract_splits_form_landsRights) {
	        menuHash = "#contract_splits_form_landsRights_new";
	    }
	
	    pli.menu.setup({
	        clickSelector: menuHash,
	        items: menuItems,
	        click: function (menuItem) {
	            if (menuItem.name() === "copy") {
	                viewModel.splits.current().extras.landsRightsEditGrid.copyItems();
	            } else {
	                viewModel.splits.current().extras.landsRightsEditGrid.addItem(menuItem.name());
	            }
	        }
	    });
	});
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Export
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = {
	    createFactories: function createExtraSplitFactories(rootId, calculateTotalDoiPercentageOnClient) {
	        return {
	            dois: createDoisFactory(rootId, calculateTotalDoiPercentageOnClient),
	            obligations: createObligationsFactory(rootId),
	            relatedDocs: createRelatedDocsFactory(rootId),
	            relatedWells: createRelatedWellsFactory(rootId),
	            comments: createCommentsFactory(rootId)
	        };
	    },
	    mixins: {
	        completeSplit: SplitViewModelExtensions.prototype.completeViewModel,
	        initSplit: SplitViewModelExtensions,
	        initSplitGridArray: SplitViewModelExtensions.prototype.initGridArray,
	        loadSplit: SplitViewModelExtensions.prototype.loadViewModel
	    }
	};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	"use strict";
	
	var dateFormatter = __webpack_require__(451).formatDate;
	var ko = __webpack_require__(457);
	var pliObservable = __webpack_require__(15);
	
	var viewModelInit = __webpack_require__(532);
	
	__webpack_require__(547);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Comment class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// Define CommentViewModel
	function CommentViewModel(factories) {
	    if (window.console && window.console.group) { window.console.log("CommentViewModel.ctor", factories); }
	
	    // serializable properties
	    this.guid = ko.observable(null);
	    this.id = ko.observable(null);
	    this.message = ko.observable(null);
	
	    // extra properties
	    this.extras = function CommentExtras() { return; };
	    this.extras.createdDate = ko.observable(null);
	    this.extras.createdByName = ko.observable(null);
	    this.extras.updatedDate = ko.observable(null);
	    this.extras.updatedByName = ko.observable(null);
	
	    this.extras.editMode = ko.observable(false);
	    this.extras.editMessage = ko.observable(null);
	    this.extras.editedBy = ko.computed(CommentViewModel.prototype.editBySummary, this);
	}
	
	
	//-------------------------------------------
	CommentViewModel.prototype.loadViewModel = function commentsLoaded(record) {
	    if (window.console && window.console.group) { window.console.log("CommentViewModel.loadViewModel", record); }
	
	    if (!record) { record = {}; }
	
	    this.guid(record.guid || null);
	    this.id(record.id || null);
	    this.message(record.message || null);
	
	    this.extras.createdDate(record.createdDate || null);
	    this.extras.createdByName(record.createdByName || null);
	    this.extras.updatedDate(record.updatedDate || null);
	    this.extras.updatedByName(record.updatedByName || null);
	
	    this.extras.editMessage(record.message || null);
	};
	
	
	//-------------------------------------------
	CommentViewModel.prototype.convertToLocalDateTimeString = function convertLocalDateTime(dateString) {
	    if (dateString) {
	        // Given an UTC datetime string, Date constructor will automatically convert it to the local date time
	        var localDate = new Date(dateString);
	
	        return dateFormatter(localDate, "MMM-dd-yyyy @ HH:mm");
	    }
	};
	
	
	//-------------------------------------------
	CommentViewModel.prototype.editBySummary = function editBySummary() {
	    if (this.extras.updatedByName() && this.extras.updatedDate()) {
	        return " | Edited by " + this.extras.updatedByName() + " " + this.convertToLocalDateTimeString(this.extras.updatedDate());
	    }
	
	    return null;
	};
	
	
	//-------------------------------------------
	// Revert the editMessage back to the original message since user cancelled edit
	CommentViewModel.prototype.cancel = function cancelEdit() {
	    this.extras.editMessage(this.message());
	    this.extras.editMode(false);
	};
	
	
	//-------------------------------------------
	// Update message to the editMessage and update updated info
	CommentViewModel.prototype.update = function updateEdit() {
	    this.message(this.extras.editMessage());
	
	    this.extras.editMode(false);
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = viewModelInit.standardFactoryCreatorFor(
	    CommentViewModel,
	    "comments"
	);


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(548);


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// ExpandText knockout binding
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	///<summary>
	///     Creates a binding that displays what looks like a textbox,
	///     and upon clicking expands into a textarea
	///</summary>
	///<param name='settings' type='object'>
	///     <param name='value' type='observable'>
	///         The observable to bind to the textarea value
	///     </param>
	///     <param name='expanded' type='observable'>
	///         An observable that is notified of the state of the expandText. if it is focused/expanded or not
	///         programtically setting it to true will also trigger the element to focus
	///     </param>
	///     <param name='minHeight' type='number=25'>
	///         A number that specifies the height that the textarea collapses to
	///     </param>
	///     <param name='maxHeight' type='number=75'>
	///         A number that specifies the height that the textarea expands to
	///     </param>
	///</param>
	///--------------------------------------------------
	ko.bindingHandlers.expandText = {
	    init: function (element, valueAccessor, allBindings) {
	        var val, height, settings = valueAccessor(),
	            focus = ko.observable(false),
	            minHeight = 25,
	            maxHeight = 75,
	            expanded = ko.observable();
	
	        //validate input
	        if (typeof settings !== "object") { throw new Error("An object is expected for this binding"); }
	        if (!ko.isObservable(settings.value)) { throw new Error("The value was expected to be an observable"); }
	
	        //assign values
	        val = settings.value;
	        minHeight = !isNaN(parseInt(settings.minHeight, 10)) ? parseInt(settings.minHeight, 10) : minHeight;
	        maxHeight = !isNaN(parseInt(settings.maxHeight, 10)) ? parseInt(settings.maxHeight, 10) : maxHeight;
	        expanded = ko.isObservable(settings.expanded) ? settings.expanded : expanded;
	
	        //compute if the textarea is focused and/or has values
	        ko.computed(function () {
	            var v = val();
	            expanded((v !== null && v !== undefined && v !== '') || focus());
	        });
	
	        //ensure there is focus, if there is values or if programitcally expanded
	        expanded.subscribe(function (v) {
	            focus(v);
	        });
	
	        //compute which height to use
	        height = ko.computed(function () {
	            return (expanded() ? maxHeight : minHeight) + "px";
	        });
	
	        //attach necessary bindings to the node
	        ko.applyBindingsToNode(element, {
	            value: val,
	            hasFocus: focus,
	            style: { height: height },
	            valueUpdate: allBindings.has('valueUpdate') ? allBindings.get('valueUpdate') : undefined,
	            enable: allBindings.has('enable') ? allBindings.get('enable') : true
	        });
	    }
	};
	
	
	//-------------------------------------------
	module.exports = ko;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(550);


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	var pliObservable = __webpack_require__(15);
	
	var createContactPercentageFactory = __webpack_require__(544);
	var selectionForm = __webpack_require__(520);
	var viewModelInit = __webpack_require__(532);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function createFlagObserver(name) {
	    /// <summary>
	    /// Create a function that can be used
	    /// to observe isActive or isRental flags
	    /// and update owner.currentActive or
	    /// owner.currentRental appropriately.
	    /// </summary>
	    /// <remarks>
	    /// Returned observer function expects
	    /// "this" to be pointing to the DOI
	    /// that owns the observed flag.
	    /// </remarks>
	    return function doiToggleObserver(newFlagValue) {
	        var dois = this.extras.owner,
	            oldCurrent = dois["current" + name]();
	        if (newFlagValue) { // toggling "false" => "true"
	            if (oldCurrent !== this) {
	                dois["current" + name](this);
	                if (oldCurrent) {
	                    oldCurrent["is" + name](false);
	                }
	            }
	        } else { // toggling "true" => "false"
	            if (oldCurrent === this) {
	                dois["current" + name](null);
	            }
	        }
	    };
	}
	
	
	//-------------------------------------------
	function selectDois(doisArray, link) {
	    /// <summary>
	    /// Show dois selection form and either
	    /// copy (if "link" is falsy) or link (if "link" is truthy)
	    /// selected dois to the specified array.
	    /// </summary>
	    selectionForm.open({
	        getDetailsApi: "Geo-CopyLinkDocument-GetDetails",
	        getDetailsDataBuilder: function (items) { // needed to adapt request for Geo-CopyLinkDocument-GetDetails
	            var guidIndex = items[0].length - 1;
	            return {
	                documentType: "Doi",
	                actionType: (link ? "Link" : "Copy"),
	                copyLinkFrom: ko.utils.arrayMap(items, function (item) {
	                    return {
	                        name: item[0],
	                        guid: item[guidIndex]
	                    };
	                })
	            };
	        },
	        multiSelect: true,
	        onAcceptedContext: doisArray,
	        onAccepted: function (newDois) {
	            if (!link) { // if copying, reset all guid-s (so that save will create a new, copied content)
	                newDois = selectionForm.utils.resetGuids(newDois);
	            } else if (newDois.length > 0) { // ensure only the first new line is marked active
	                newDois[0].isNewLink = true;
	            }
	            selectionForm.utils.pushObjectItems({
	                targetArray: doisArray,
	                records: newDois,
	                getIdentity: (!link ? null : function (royalty) { return royalty.guid(); })
	            });
	            // added multiple new items, so we need to undo the selection of the first that was added
	            if (newDois.length > 1 && doisArray().length === newDois.length) {
	                var firstDoi = doisArray.peek()[0];
	                firstDoi.isActive(false);
	                firstDoi.isRental(false);
	            }
	        },
	        searchApi: "Geo-Document-SearchDois",
	        text: {
	            acceptButton: (link ? "Link" : "Copy"),
	            iconClass: (link ? "sprite-link-16" : "sprite-copy-16"),
	            examples: [
	                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
	            ],
	            title: (link ? "Link Divisions of Interest" : "Copy Divisions of Interest")
	        }
	    });
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Doi class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function Doi(factories, owner) {
	    /// <summary>
	    /// Define viewmodel.
	    /// </summary>
	    if (window.console && window.console.group) { window.console.group("Doi.ctor", factories); }
	
	    this.description = pliObservable();
	    this.guid = ko.observable(null);
	    this.id = this.doiName = pliObservable(null, null, "required");
	    this.interestLines = factories.doiLines.createObservableArray();
	    this.isActive = ko.observable(false);
	    this.isRental = ko.observable(false);
	    this.link = ko.observable(null);
	
	    // extras
	    this.extras = function DoiExtras() { return; };
	    this.extras.errorsCount = ko.computed(this._computeErrorsCount, this);
	    this.extras.owner = owner;
	    this.extras.globalIsReadOnly = ko.observable().subscribeTo("state.isReadOnly", true);
	    this.extras.isReadOnly = ko.computed(this._computeReadOnlyFlag, this); // has to be after stateIsReady
	    this.extras.dependencies = ko.observableArray();
	    this.extras.dependencyHint = "  You may set the status to 'Inactive'. All Related Document entries and links (DOI & Royalty) must be removed, and any changes must be saved, before this Split may be deleted.";
	
	    // bound methods
	    this.toggleIsActive = this._toggleFlag.bind(this.isActive);
	    this.toggleIsRental = this._toggleFlag.bind(this.isRental);
	
	    if (window.console && window.console.groupEnd) { window.console.groupEnd(); }
	} // end function Doi
	
	
	//---------------------------------------
	Doi.prototype.applyServerCalculationResult = function applyDoiResult(context) {
	    context.visit(this.interestLines, "interestLines");
	};
	
	
	//---------------------------------------
	Doi.prototype.buildServerCalculationData = function buildDoiData(context) {
	    return {
	        interestLines: context.visit(this.interestLines),
	        isActive: this.isActive(),
	        isRental: this.isRental()
	    };
	};
	
	
	//---------------------------------------
	Doi.prototype.completeViewModel = function completeDoi() {
	    /// <summary>
	    /// Finish defining viewmodel.
	    /// </summary>
	
	    // only automatically activate newly added owned or linked dois
	    // verify new owned dois by checking for no `guid`
	    // verify new linked dois by checking for `extras._isNewLink`
	    if (this.extras.owner().length === 0 && (!this.guid() || (this.link() && this.extras._isNewLink))) {
	        this.isActive(true);
	        this.isRental(true);
	    }
	    this.extras._isActiveSubscription = this.isActive.subscribe(this._isActiveObserver, this);
	    this._isActiveObserver(this.isActive()); // synchronize observer with current value
	    this.extras._isRentalSubscription = this.isRental.subscribe(this._isRentalObserver, this);
	    this._isRentalObserver(this.isRental()); // synchronize observer with current value
	    this.extras._onDisposeResetFlagObservers = { // this object makes sure _resetFlagObservers is run when this item is disposed
	        doi: this,
	        dois: this.extras.owner,
	        dispose: this._resetFlagObservers
	    };
	};
	
	
	//---------------------------------------
	Doi.prototype.initGridArray = function initDoiGridArray(gridArray) {
	    /// <summary>
	    /// Add extra methods to the specified DOIs
	    /// grid array (that has just been created).
	    /// </summary>
	    gridArray.copyItems = gridArray.factory.factories.secureAction(Doi.prototype._copyItems, gridArray);
	    gridArray.linkItems = gridArray.factory.factories.secureAction(Doi.prototype._linkItems, gridArray);
	    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray, gridArray.factory.factories.checkForDependencies.bind(gridArray));
	    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);
	
	    gridArray.currentActive = ko.observable(null);
	    gridArray.currentRental = ko.observable(null);
	};
	
	
	
	//-------------------------------------------
	Doi.prototype.loadViewModel = function loadDoi(record) {
	    /// <summary>
	    /// Populate viewmodel with data.
	    /// </summary>
	    if (window.console && window.console.group) { window.console.group("Doi.loadViewModel", record); }
	
	    if (!record) { record = {}; }
	
	    this.description(record.description || "");
	    this.guid(record.guid || null);
	    this.id.load(record.id);
	    this.interestLines.loadViewModel(record.interestLines);
	    this.isActive(!!record.isActive);
	    this.isRental(!!record.isRental);
	    this.link(record.link || null);
	    if (record.isNewLink) { this.extras._isNewLink = true; }
	    this.interestLines.isReadOnly(!!this.link());
	
	    this.extras.dependencies(record.dependencies || []);
	
	    if (window.console && window.console.groupEnd) { window.console.groupEnd(); }
	};
	
	
	//---------------------------------------
	Doi.prototype._computeErrorsCount = function doiComputeErrorsCount() {
	    var totalError = (this.interestLines().length > 0 && this.interestLines.totalPercentage.invalid()) ? 1 : 0;
	    return this._computeErrorsCountFlat() + this.interestLines.errorsCount() + totalError;
	};
	
	
	//---------------------------------------
	Doi.prototype._computeErrorsCountFlat = viewModelInit.computeErrorsCount;
	
	
	//---------------------------------------
	Doi.prototype._computeReadOnlyFlag = function computeDoiReadOnlyFlag() {
	    var readonly = this.extras.globalIsReadOnly(), link = this.link();
	    return readonly || link;
	};
	
	
	//---------------------------------------
	Doi.prototype._copyItems = function copyDois() {
	    /// <summary>
	    /// Copy dois from other documents. Shows
	    /// a selection form that allows user to select
	    /// and accept dois to copy.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores dois.
	    /// </remarks>
	    selectDois(this, false); // false => copy
	};
	
	
	//---------------------------------------
	Doi.prototype._isActiveObserver = createFlagObserver("Active");
	
	
	//---------------------------------------
	Doi.prototype._isRentalObserver = createFlagObserver("Rental");
	
	
	//---------------------------------------
	Doi.prototype._linkItems = function linkDois() {
	    /// <summary>
	    /// Link dois from other documents. Shows
	    /// a selection form that allows user to select
	    /// and accept dois to link.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores dois.
	    /// </remarks>
	    selectDois(this, true); // true => link
	};
	
	
	//---------------------------------------
	Doi.prototype._resetFlagObservers = function resetDoiFlagObservers() {
	    /// <summary>
	    /// If an item that is current active
	    /// or rental working interest is disposed (e.g. deleted),
	    /// this method resets owner.currentActive
	    /// and/or owner.currentRental to null.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to point to _onDisposeResetFlagObservers object.
	    /// </remarks>
	    if (this.dois) {
	        if (this.dois.currentActive() === this.doi) { this.dois.currentActive(null); }
	        if (this.dois.currentRental() === this.doi) { this.dois.currentRental(null); }
	        this.doi = null;
	        this.dois = null;
	    }
	};
	
	
	//---------------------------------------
	Doi.prototype._toggleFlag = function toggleDoiFlag() {
	    /// <summary>
	    /// Toggle the specified flag.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to point to the flag to toggle.
	    /// </remarks>
	    this(!this());
	};
	
	
	//---------------------------------------
	Doi.prototype.itemComparer = null; // disable client-side sorting
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = viewModelInit.standardFactoryCreatorFor(
	    Doi,
	    "dois",
	    function createExtraDoiFactories(rootId, calculateTotalPercentageOnClient) {
	        rootId = rootId.replace("_interestLines", ""); // adjust rootId (remove interestLines)
	        return {
	            doiLines: createContactPercentageFactory(rootId, "interestLines", calculateTotalPercentageOnClient)
	        };
	    }
	);


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(552);


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	
	var ko = __webpack_require__(457);
	var pliObservable = __webpack_require__(15);
	
	var entityRegistry = __webpack_require__(492);
	var reminderExtensions = __webpack_require__(540);
	var selectionForm = __webpack_require__(520);
	var viewModelInit = __webpack_require__(532);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Obligation class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function Obligation(factories) {
	    /// <summary>
	    /// Define viewmodel.
	    /// </summary>
	    if (window.console && window.console.group) { window.console.log("Obligation.ctor", factories); }
	
	    // initialize base mixins
	    this.extras = function ObligationExtras() { return; };
	    this.initReminder();
	
	    // serializable properties
	    this.guid = ko.observable(null);
	    this.id = this.type = pliObservable(null, entityRegistry.obligationType.getPicklistBehaviourData(), "required", "picklist");
	    this.description = pliObservable();
	    this.personResponsible = pliObservable(null, entityRegistry.personResponsible.getPicklistBehaviourData(), "picklist");
	
	    // non-serializable properties
	    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);
	}
	
	
	//---------------------------------------
	Obligation.prototype.initGridArray = function initObligationsGridArray(gridArray) {
	    /// <summary>
	    /// Add extra methods to the specified
	    /// obligations grid array (that has just
	    /// been created).
	    /// </summary>
	    gridArray.copyItems = gridArray.factory.factories.secureAction(Obligation.prototype._copyItems, gridArray);
	    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray);
	    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);
	};
	
	
	//-------------------------------------------
	Obligation.prototype.loadViewModel = function obligationLoaded(record) {
	    if (window.console && window.console.group) { window.console.log("Obligation.loadViewModel", record); }
	
	    if (!record) { record = {}; }
	
	    this.loadReminder(record);
	
	    this.guid(record.guid || null);
	    this.type.load(record.type);
	    this.description.load(record.description);
	    this.personResponsible.load(record.personResponsible);
	};
	
	
	//-------------------------------------------
	Obligation.prototype._copyItems = function copyObligations() {
	    /// <summary>
	    /// Show selection form that allows users
	    /// to find and copy obligations to this array.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores obligations.
	    /// </remarks>
	    selectionForm.open({
	        multiSelect: true,
	        searchApi: "Geo-Document-SearchObligations",
	        text: {
	            acceptButton: "Copy",
	            iconClass: "sprite-copy-16",
	            examples: [
	                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
	            ],
	            title: "Copy Obligations"
	        },
	        onAcceptedContext: this,
	        onAccepted: function (newObligationRows) {
	            var i, l;
	            for (i = 0, l = newObligationRows.length; i < l; i += 1) {
	                newObligationRows[i][3] = parseInt(newObligationRows[i][3], 10);
	            }
	            selectionForm.utils.pushRowItems({
	                targetArray: this,
	                records: newObligationRows,
	                rowMap: { recur: 3, recurUnit: 4, start: 5, type: 6, description: 7, personResponsible: 8 }
	            });
	        }
	    });
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	ko.utils.extend(Obligation.prototype, reminderExtensions.mixins);
	Obligation.prototype.itemComparer = null; // disable client-side sorting
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = viewModelInit.standardFactoryCreatorFor(
	    Obligation,
	    "obligations"
	);


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(502);
	module.exports = __webpack_require__(554);


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var dateBehaviour = __webpack_require__(449).behaviours.date;
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var dataCache = __webpack_require__(488);
	var dependentRequiredBehaviour = __webpack_require__(496);
	var entityRegistry = __webpack_require__(492);
	var formattedBehaviour = __webpack_require__(518);
	var selectionForm = __webpack_require__(520);
	var viewModelInit = __webpack_require__(532);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// RelatedDoc class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function RelatedDoc(factories) {
	    /// <summary>
	    /// Define viewmodel.
	    /// </summary>
	    if (window.console && window.console.group) { window.console.log("RelatedDoc.ctor", factories); }
	
	    this.guid = ko.observable(null);
	    this.type = pliObservable("ExternalAgreement", dataCache.getObservable("relatedDocType"), "required", "picklist");
	
	    this.agreementDate = pliObservable(null, null, dateBehaviour, formattedBehaviour);
	    this.agreementId = pliObservable("", { trigger: this.type, expectedValue: "ExternalAgreement" }, dependentRequiredBehaviour);
	    this.agreementType = pliObservable(null, entityRegistry.externalContractType.getPicklistBehaviourData(), "picklist");
	    this.description = pliObservable();
	    this.fileCreatedBy = ko.observable("");
	    this.fileCreatedOn = ko.observable("");
	    this.fileKeywords = pliObservable();
	    this.fileName = pliObservable();
	    this.fileSize = ko.observable();
	    this.shortDescription = pliObservable();
	    this.fileUploadId = ko.observable(null);
	    this.fileStoreId = ko.observable(null);
	    this.documentDate = ko.observable(null);
	    this.documentType = ko.observable(null);
	    this.documentSplitGuid = ko.observable(null);
	    this.documentFileNumber = pliObservable();
	    this.documentSplitNumber = pliObservable();
	    this.documentSplitDescription = ko.observable();
	
	    this.id = ko.computed(this._computeId, this);
	
	    // non-serialized properties
	    this.extras = function RelatedDocExtras() { return; };
	    this.extras.isLinked = ko.computed(this._computeIsLinked, this);
	    this.extras.specificDate = ko.computed(this._computeSpecificDate, this);
	    this.extras.specificType = ko.computed(this._computeSpecificType, this);
	    this.extras.fileDownloadMessage = ko.observable(null);
	    this.extras.uploadMessage = ko.observable(null);
	    this.extras.uploadProgress = ko.observable(null);
	    this.extras.uploadState = ko.observable(null);
	    this.extras.errorsCountFlat = ko.computed(factories.computeErrorsCount, this);
	    this.extras.errorsCount = ko.computed(this._computeErrors, this);
	    this.extras.icon = ko.computed(this._computeIcon, this);
	    this.extras.computedSplitId = pliObservable();
	    this.extras.details = ko.computed(this._computeDetails, this);
	
	    ko.computed(this._computeSplitNumber, this);
	}
	
	
	//---------------------------------------
	RelatedDoc.prototype.initGridArray = function initRelatedDocGridArray(gridArray) {
	    /// <summary>
	    /// Add extra methods to the specified
	    /// related documents grid array (that has just
	    /// been created).
	    /// </summary>
	    gridArray.attachFiles = RelatedDoc.prototype._attachFiles.bind(gridArray);
	    gridArray.linkItems = gridArray.factory.factories.secureAction(RelatedDoc.prototype._linkItems, gridArray);
	    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray);
	    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);
	
	    gridArray.openTarget = RelatedDoc.prototype._openTarget.bind(gridArray);
	    gridArray.fileDragDropSupported = !!window.FileReader;
	    gridArray.copyItems = gridArray.factory.factories.secureAction(RelatedDoc.prototype._copyItems, gridArray);
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype.itemComparer = null; // disable client-side sorting
	
	
	//-------------------------------------------
	RelatedDoc.prototype.loadViewModel = function loadRelatedDoc(record) {
	    if (window.console && window.console.group) { window.console.log("RelatedDoc.loadViewModel", record); }
	
	    if (!record) { record = {}; }
	
	    this.type.load(record.type || "ExternalAgreement");
	
	    this.agreementDate.load(record.agreementDate);
	    this.agreementId.load(record.agreementId);
	    this.agreementType.load(record.agreementType);
	    this.description.load(record.description);
	    this.documentType(record.documentType || "");
	    this.documentDate(record.documentDate || "");
	    this.documentFileNumber.load(record.documentFileNumber || "");
	    this.documentSplitNumber.load(record.documentSplitNumber || "");
	    this.documentSplitGuid(record.documentSplitGuid || null);
	    this.documentSplitDescription(record.documentSplitDescription || "");
	    this.fileCreatedBy(record.fileCreatedBy || "");
	    this.fileCreatedOn(record.fileCreatedOn || "");
	    this.fileKeywords.load(record.fileKeywords);
	    this.fileName.load(record.fileName);
	    this.fileSize(record.fileSize || "");
	    this.shortDescription.load(record.shortDescription || record.documentFileNumber);
	    this.guid(record.guid || null);
	    this.fileUploadId(record.fileUploadId || null);
	    this.fileStoreId(record.fileStoreId || null);
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype.updateAttachedFile = function updateRelatedDocFile(state, value) {
	    /// <summary>
	    /// Updates the state of an attached file.
	    /// </summary>
	    switch (state) {
	    case "done":
	        this.fileUploadId(value || null);
	        this.extras.uploadProgress(null);
	        this.shortDescription.load(this.fileName.peekValue()); // default the title to the same as the file name
	        break;
	    case "fail":
	        this.extras.uploadProgress(null);
	        this.extras.uploadMessage(value);
	        break;
	    default:
	        this.extras.uploadProgress(typeof value === "number" ? "".concat(value).concat("%") : null);
	        break;
	    }
	    this.extras.uploadState(state);
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._attachFiles = function attachRelatedFiles(files) {
	    /// <summary>
	    /// Attachs uploaded file to the grid view
	    /// model of related documents.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores related documents.
	    /// </remarks>
	    var i, l, f = [];
	    for (i = 0, l = files.length; i < l; i += 1) {
	        f[i] = this.createItem({ fileName: files[i].name, type: "UploadedFile" });
	        f[i].extras.uploadProgress("0%");
	    }
	    ko.utils.arrayPushAll(this, f);
	    this.valueHasMutated();
	    this.sort();
	    return f;
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._computeIcon = function computeIcon() {
	    var t = this.type(), errors = this.extras.errorsCount();
	    if (errors > 0) { return "sprite-warning-16"; }
	    switch (t) {
	    case "ContractSplit":
	        return "sprite-forms-16";
	    case "MineralLeaseSplit":
	        return "sprite-mineralLease-16";
	    case "SurfaceLeaseSplit":
	        return "sprite-surfaceLease-16";
	    case "UploadedFile":
	        return "sprite-editDocument-16";
	    default: // ExternalAgreement
	        return "sprite-linkedDoc-16";
	    }
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._computeErrors = function computeRelatedDocErrors() {
	    return this.extras.errorsCountFlat()
	        + ((this.extras.uploadState() === "fail" || this.extras.uploadState() === "busy") ? 1 : 0);
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._computeId = function computeRelatedDocId() {
	    var value;
	    switch (this.type()) {
	    case "ContractSplit":
	    case "MineralLeaseSplit":
	    case "SurfaceLeaseSplit":
	        value = this.extras.computedSplitId();
	        break;
	    case "ExternalAgreement":
	        value = this.agreementId();
	        break;
	    case "UploadedFile":
	        value = this.fileName();
	        break;
	    }
	    return value || "";
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._computeIsLinked = function computeIsLinked() {
	    switch (this.type()) {
	    case "ContractSplit":
	    case "MineralLeaseSplit":
	    case "SurfaceLeaseSplit":
	        return true;
	    default:
	        return false;
	    }
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._computeSpecificDate = function computeRelatedDocSpecificDate() {
	    var value;
	    switch (this.type()) {
	    case "ContractSplit":
	    case "MineralLeaseSplit":
	    case "SurfaceLeaseSplit":
	        value = this.documentDate();
	        break;
	    case "ExternalAgreement":
	        value = this.agreementDate.formatted();
	        break;
	    case "UploadedFile":
	        value = this.fileCreatedOn();
	        break;
	    }
	    return value || "";
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._computeSpecificType = function computeRelatedDocSpecificType() {
	    var value;
	    switch (this.type()) {
	    case "ContractSplit":
	    case "MineralLeaseSplit":
	    case "SurfaceLeaseSplit":
	        value = this.documentType();
	        break;
	    case "ExternalAgreement":
	        value = this.agreementType();
	        break;
	    case "UploadedFile":
	        if (this.extras.uploadState() === "busy") {
	            value = "File uploading. Please wait...";
	        } else {
	            value = "Uploaded file";
	        }
	        break;
	    }
	    return value || "";
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._computeDetails = function computeDetails() {
	    var d, s;
	    d = this.extras.specificDate();
	    s = this.documentSplitDescription();
	    return this.extras.specificType() + (d ? " - ".concat(d) : "") + (s ? " - ".concat(s) : "");
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._computeSplitNumber = function computeSplitNumber() {
	    var value = null;
	    if (this.extras.isLinked() && this.documentFileNumber() && this.documentSplitNumber()) {
	        value = this.documentFileNumber() + " - " + this.documentSplitNumber();
	    }
	    this.extras.computedSplitId.load(value);
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._downloadCompleted = function uploadedFileCompleted(response) {
	    this.extras.fileDownloadMessage(response.isError ? "File not found" : null);
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype.getNavigationUrl = function getNavigationUrl() {
	    return "".concat(
	        encodeURIComponent(this.documentFileNumber()),
	        "/splits/",
	        encodeURIComponent(this.documentSplitNumber())
	    );
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._linkItems = function linkDocs() {
	    /// <summary>
	    /// Show selection form that allows users
	    /// to find and add related documents to this array.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores related documents.
	    /// </remarks>
	    selectionForm.open({
	        multiSelect: true,
	        searchApi: "Geo-Document-SearchRelated",
	        text: {
	            acceptButton: "Link",
	            iconClass: "sprite-link-16",
	            examples: [
	                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
	            ],
	            title: "Link Documents"
	        },
	        onAcceptedContext: this,
	        onAccepted: function (newDocRows) {
	            var currentSplitGuid = this.owner && ko.isObservable(this.owner.guid) && this.owner.guid(),
	                rows = !!currentSplitGuid ? ko.utils.arrayFilter(newDocRows, function (item) {
	                    return item[6] && item[6].toUpperCase() !== currentSplitGuid.toUpperCase();
	                }) : newDocRows;
	
	            selectionForm.utils.pushRowItems({
	                targetArray: this,
	                records: rows,
	                rowMap: { type: 3, documentFileNumber: 4, documentSplitNumber: 5, documentSplitGuid: 6, documentDate: 7, documentType: 8, documentSplitDescription: 9 },
	                getIdentity: function (relatedDoc) { return relatedDoc.id(); }
	            });
	        }
	    });
	};
	
	
	//-------------------------------------------
	RelatedDoc.prototype._openTarget = function openRelatedDoc() {
	    var current = this.current();
	
	    switch (current.type()) {
	    case "ContractSplit":
	        entityRegistry.contract.open.edit({ url: current.getNavigationUrl() });
	        break;
	    case "MineralLeaseSplit":
	        entityRegistry.mineralLease.open.edit({ url: current.getNavigationUrl() });
	        break;
	    case "SurfaceLeaseSplit":
	        entityRegistry.surfaceLease.open.edit({ url: current.getNavigationUrl() });
	        break;
	    case "UploadedFile":
	        pli.download(current.fileStoreId()).always(current._downloadCompleted.bind(current));
	        break;
	    }
	
	    return false;
	};
	
	
	//---------------------------------------
	RelatedDoc.prototype._copyItems = function copyRelatedDocuments() {
	    /// <summary>
	    /// Show selection form that allows users
	    /// to find and add related documents to this array.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores related documents.
	    /// </remarks>
	    selectionForm.open({
	        multiSelect: true,
	        searchApi: "Geo-Document-SearchRelatedDocuments",
	        text: {
	            acceptButton: "Copy",
	            iconClass: "sprite-link-16",
	            examples: [
	                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
	            ],
	            title: "Copy Documents"
	        },
	        onAcceptedContext: this,
	        onAccepted: function (newDocRows) {
	            // 0 - document ID (File # + " - " + Split ID + " - " + Related Document #)
	            // 1 - area
	            // 2 - lands
	            // 3 - related document formated type
	            // 4 - documentType
	            // 5 - description
	            // Linked documents: documentFileNumber: 6, documentSplitNumber: 7, documentSplitGuid: 8, documentDate: 9, documentType: 10
	            // ExternalAgreement: agreementId: 6, agreementType: 7, agreementDate: 8
	            // UploadFile: fileName: 6, fileStoreId: 7, fileCreatedOn: 8, fileKeywords: 9
	
	            var i,
	                documentsToLink = [],
	                externalDocuments = [],
	                uploadedFiles = [],
	                currentSplitGuid = this.owner && ko.isObservable(this.owner.guid) && this.owner.guid();
	
	            for (i = 0; i < newDocRows.length; i += 1) {
	                switch (newDocRows[i][4]) { // related document type
	                case "ContractSplit":
	                case "MineralLeaseSplit":
	                case "SurfaceLeaseSplit":
	                    if (!currentSplitGuid || !newDocRows[i][8] || newDocRows[i][8].toUpperCase() !== currentSplitGuid.toUpperCase()) {
	                        documentsToLink.push(newDocRows[i]);
	                    }
	                    break;
	                case "ExternalAgreement":
	                    externalDocuments.push(newDocRows[i]);
	                    break;
	                case "UploadedFile":
	                    uploadedFiles.push(newDocRows[i]);
	                    break;
	                }
	            }
	
	            // link documents
	            if (documentsToLink.length > 0) {
	                selectionForm.utils.pushRowItems({
	                    targetArray: this,
	                    records: documentsToLink,
	                    rowMap: { type: 4, description: 5, documentFileNumber: 6, documentSplitNumber: 7, documentSplitGuid: 8, documentDate: 9, documentType: 10, documentSplitDescription: 11 },
	                    getIdentity: function (relatedDoc) { return relatedDoc.id(); }
	                });
	            }
	
	            // add external documents
	            if (externalDocuments.length > 0) {
	                selectionForm.utils.pushRowItems({
	                    targetArray: this,
	                    records: externalDocuments,
	                    rowMap: { type: 4, description: 5, agreementId: 6, agreementType: 7, agreementDate: 8 }
	                });
	            }
	
	            // uploaded files
	            if (uploadedFiles.length > 0) {
	                selectionForm.utils.pushRowItems({
	                    targetArray: this,
	                    records: uploadedFiles,
	                    rowMap: { type: 4, description: 5, fileName: 6, fileStoreId: 7, fileCreatedOn: 8, fileKeywords: 9 }
	                });
	            }
	        }
	    });
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = viewModelInit.standardFactoryCreatorFor(
	    RelatedDoc,
	    "relatedDocs"
	);


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(556);


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var ko = __webpack_require__(457);
	var pliObservable = __webpack_require__(15);
	
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	var selectionForm = __webpack_require__(520);
	var viewModelInit = __webpack_require__(532);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// RelatedWell class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function RelatedWell(factories) {
	    /// <summary>
	    /// Define viewmodel.
	    /// </summary>
	    if (window.console && window.console.group) { window.console.log("RelatedWell.ctor", factories); }
	
	    this.guid = ko.observable(null);
	    this.id = this.wellNumber = pliObservable(null, dataCache.getObservable("well"), "required", "picklist");
	
	    // non-serialized properties
	    this.extras = function RelatedWellExtras() { return; };
	    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);
	    this.extras.license = ko.observable(null);
	    this.extras.operator = ko.observable(null);
	    this.extras.released = ko.observable(null);
	    this.extras.spud = ko.observable(null);
	    this.extras.wellStatus = pliObservable(null, dataCache.getObservable("wellStatus"), "picklist");
	    this.extras.producingStatus = ko.observable(null);
	    this.extras._subscriptionUpdateInfo = null;
	    if (ko.isObservable(this.id.item)) {
	        this.extras._subscriptionUpdateInfo = this.id.item.subscribe(this._updateInfo, this);
	        this._updateInfo(this.id.item()); // force initial update
	    }
	}
	
	
	//---------------------------------------
	RelatedWell.prototype.initGridArray = function initRelatedWellGridArray(gridArray) {
	    /// <summary>
	    /// Add extra methods to the specified
	    /// related wells grid array (that has just
	    /// been created).
	    /// </summary>
	    gridArray.linkItems = gridArray.factory.factories.secureAction(RelatedWell.prototype._linkItems, gridArray);
	    gridArray.copyItems = gridArray.factory.factories.secureAction(RelatedWell.prototype._copyItems, gridArray);
	    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray);
	    gridArray.openNew = null;
	
	    gridArray.openTarget = RelatedWell.prototype._openTarget.bind(gridArray);
	};
	
	
	//-------------------------------------------
	RelatedWell.prototype.itemComparer = null; // disable client-side sorting
	
	
	//-------------------------------------------
	RelatedWell.prototype.loadViewModel = function loadRelatedWell(record) {
	    if (window.console && window.console.group) { window.console.log("RelatedWell.loadViewModel", record); }
	
	    this.guid(record.guid || null);
	    this.id.load((record && record.id) || null);
	};
	
	
	//-------------------------------------------
	RelatedWell.prototype._linkItems = function linkWells() {
	    /// <summary>
	    /// Show selection form that allows users
	    /// to find and add related wells to this array.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores related wells.
	    /// </remarks>
	    selectionForm.open({
	        multiSelect: true,
	        searchApi: "Geo-Well-SearchUwi",
	        text: {
	            acceptButton: "Link",
	            iconClass: "sprite-link-16",
	            examples: [
	                "<strong>06-22-057-15-W4</strong>",
	                "<strong>121/06-22-057-15-W4/00</strong>"
	            ],
	            title: "Link Wells"
	        },
	        onAcceptedContext: this,
	        onAccepted: function (newWellRows) {
	            selectionForm.utils.pushRowItems({
	                targetArray: this,
	                records: newWellRows,
	                rowMap: { id: 0 },
	                getIdentity: function (relatedWell) { return relatedWell.id(); }
	            });
	        }
	    });
	};
	
	
	//-------------------------------------------
	RelatedWell.prototype._copyItems = function copyWells() {
	    /// <summary>
	    /// Show selection form that allows users
	    /// to find and add related wells to this array.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores related wells.
	    /// </remarks>
	    selectionForm.open({
	        multiSelect: true,
	        searchApi: "Geo-Document-SearchRelatedWells",
	        text: {
	            acceptButton: "Copy",
	            iconClass: "sprite-link-16",
	            examples: [
	                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"],
	            title: "Copy Wells"
	        },
	        onAcceptedContext: this,
	        onAccepted: function (newWellRows) {
	            selectionForm.utils.pushRowItems({
	                targetArray: this,
	                records: newWellRows,
	                rowMap: { id: 4 }
	            });
	        }
	    });
	};
	
	
	//-------------------------------------------
	RelatedWell.prototype._openTarget = function openRelatedWell() {
	    var targetId = this.current().id();
	    if (targetId) {
	        entityRegistry.well.open.edit({ uniqueName: targetId });
	    }
	};
	
	
	//-------------------------------------------
	RelatedWell.prototype._updateInfo = function updateRelatedWellInfo(wellRow) {
	    /// <remarks>
	    /// Assumes "this" points to a related well.
	    /// </remarks>
	    this.extras.license(wellRow ? wellRow[5] : null);
	    this.extras.operator(wellRow ? wellRow[2] : null);
	    this.extras.released(wellRow && wellRow[7] ? wellRow[7] : null);
	    this.extras.spud(wellRow && wellRow[6] ? wellRow[6] : null);
	    this.extras.wellStatus.load(wellRow ? wellRow[4] : null);
	    var producingStatus = this.extras.wellStatus && this.extras.wellStatus.item() && this.extras.wellStatus.item()[2];
	    this.extras.producingStatus(producingStatus ? (producingStatus === "P" ? "Producing" : "Non-producing") : null);
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = viewModelInit.standardFactoryCreatorFor(
	    RelatedWell,
	    "relatedWells"
	);


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ko = __webpack_require__(9);
	var pli = __webpack_require__(380);
	var editGrid_1 = __webpack_require__(558);
	var utils_1 = __webpack_require__(560);
	var landsRightsViewModel_1 = __webpack_require__(561);
	/* tslint:disable */
	var selectionForm = __webpack_require__(520);
	/* tslint:enable */
	var columns = [
	    { id: "description", field: "description", width: 569, title: "Description" },
	    { id: "tractNumber", field: "tractNumber", width: 60, title: "Group" },
	    { id: "hasNotes", field: "hasNotes", width: 60, title: "Notes", formatter: "hasNotes:bool-icon", formatterTrueIconClass: "sprite-note-16", cssClass: "center" }
	];
	/**
	 * Returns true if a row has errors.
	 *
	 * TODO: Remove once https://github.com/pandell/web-pli/issues/394 has been addressed.
	 */
	function rowHasErrors(row) {
	    var errors = row._errors;
	    if (typeof errors !== "object") {
	        return false;
	    }
	    ;
	    for (var k in errors) {
	        if (errors.hasOwnProperty(k) && errors[k] !== undefined) {
	            return true;
	        }
	    }
	    return false;
	}
	/**
	 * Computes the description to be display on the edit grid
	 * based on the different tract item types.
	 *
	 * Example.
	 * Land: "TWP 16-RGE 22-W4M S 21"
	 *
	 * Right: "PNG from SURFACE to BASEMENT"
	 *
	 * Comment: "This is a comment for the tract"
	 *
	 * @param record
	 *     The tract record to compute the description string.
	 */
	function computeDescription(record) {
	    switch (record.type) {
	        case "land":
	            var landItem = record;
	            var location_1 = landItem.location || "";
	            var sections = landItem.sections;
	            if (landItem.sections && landItem.sections.length > 0) {
	                return "".concat(location_1).concat(" ").concat(sections);
	            }
	            return location_1 || "(Empty)";
	        case "right":
	            var rightItem = record;
	            var from = utils_1.buildQualifiedZone(rightItem.from, rightItem.fromZone);
	            var to = utils_1.buildQualifiedZone(rightItem.to, rightItem.toZone);
	            var result = (rightItem.excluding ? "Excl. " : "");
	            result = result + (rightItem.product || "");
	            if (from) {
	                result = result + " from " + from;
	            }
	            if (to) {
	                result = result + " to " + to;
	            }
	            return result || "(Empty)";
	        case "comment":
	            var commentItem = record;
	            return commentItem.comment || "(Empty)";
	        default:
	            return "";
	    }
	}
	exports.computeDescription = computeDescription;
	;
	/**
	 * Computes whether the tract item record has notes
	 * entered or not.
	 *
	 * @param notes
	 *     String representing the note value.
	 */
	function computeHasNotes(notes) {
	    return !!notes && notes !== "";
	}
	;
	/**
	 * Computes the tract item description and notes columns
	 *
	 * @param tractItemRecords
	 *     The tractItemRecords from the grid that need to have
	 *     their columns computed.
	 */
	function computeColumns(tractItemRecords) {
	    for (var _i = 0, tractItemRecords_1 = tractItemRecords; _i < tractItemRecords_1.length; _i++) {
	        var item = tractItemRecords_1[_i];
	        item.description = computeDescription(item);
	        item.hasNotes = computeHasNotes(item.notes);
	    }
	}
	/**
	 * Determines the max group number in the array of
	 * tract item records.
	 *
	 * @param tractItems
	 *     Array of tract item records.
	 */
	function findMaxGroupNumber(tractItems) {
	    var l, i, n, max = 0;
	    if (tractItems) {
	        for (i = 0, l = tractItems.length; i < l; i += 1) {
	            n = tractItems[i].tractNumber;
	            if (n > max) {
	                max = n;
	            }
	        }
	    }
	    return max;
	}
	/**
	 * Determines the max group number per tract item type.
	 *
	 * @param tractItems
	 *     Array of tract item records.
	 *
	 * @param type
	 *     The type of tract item records to find the max
	 *     group number.
	 */
	function findMaxGroupNumberPerType(tractItems, type) {
	    var max = 0;
	    var items = tractItems.filter(function (item) {
	        return item.type === type;
	    });
	    max = findMaxGroupNumber(items);
	    return max + 1;
	}
	/**
	 * Renumbers the tract number when copying tract items
	 * from a different document.
	 *
	 * @param tracts
	 *     Array of tracts to be renumbered.
	 *
	 * @param start
	 *     Starting tract number from existing tracts.
	 */
	function renumberTractNum(tracts, start) {
	    var l, i;
	    if (tracts) {
	        for (i = 0, l = tracts.length; i < l; i += 1) {
	            tracts[i].id = start + i + 1;
	            tracts[i].name = start + i + 1;
	        }
	    }
	    return tracts;
	}
	/**
	 * Edit grid view model used for lands and rights tab.
	 */
	var LandsRightsEditGridViewModel = (function () {
	    /**
	     * Create a new LandsRightsEditGridViewModel instance.
	     *
	     * @param items
	     *     Observable field outside of the LandsRightsEditGridViewModel
	     *     to detect changes within the edit grid in order
	     *     to correctly set the global dirty flag.
	     */
	    function LandsRightsEditGridViewModel(items) {
	        var _this = this;
	        this._pendingErrors = {};
	        this._tracts = items || ko.observableArray();
	        this._tractIds = [];
	        var onItemsCommitted = function (committedItems) {
	            computeColumns(committedItems);
	            _this._buildTracts(_this.editGrid.items());
	        };
	        this.editGrid = new editGrid_1.EditGrid({
	            columns: columns,
	            // TODO: remove custom rowCssProvider once https://github.com/pandell/web-pli/issues/394 has been addressed
	            rowCssProvider: function (row) { return rowHasErrors(row)
	                ? ["error"]
	                : (!!row.isNewRecord ? ["new"] : []); },
	            id: "landsRightsEditGrid",
	            idField: "rowId",
	            shortcutActions: {},
	            createViewItem: function (records) {
	                if (records.length > 0) {
	                    return records[0].type === "land"
	                        ? new landsRightsViewModel_1.LandItem(records[0])
	                        : records[0].type === "right"
	                            ? new landsRightsViewModel_1.RightItem(records[0])
	                            : new landsRightsViewModel_1.CommentItem(records[0], _this.editGrid);
	                }
	                return new landsRightsViewModel_1.LandItem();
	            },
	            onItemsCommitted: onItemsCommitted,
	            multiSelect: false
	        });
	    }
	    // -------------------------------------------------------------------------
	    // Public methods
	    // -------------------------------------------------------------------------
	    /**
	     * Adds a new tract item record to the edit grid.
	     *
	     * @param type
	     *     The type of tract item to be added.
	     *
	     *     Available types: Land, right and comment.
	     */
	    LandsRightsEditGridViewModel.prototype.addItem = function (type) {
	        var uniqueId = utils_1.GenerateGuid();
	        // if it is a new land, default the format to DLS
	        if (type === "land") {
	            this.editGrid.addItem({ rowId: uniqueId, type: type, format: "DLS", tractNumber: findMaxGroupNumberPerType(this.editGrid.items(), type), isNewRecord: true });
	        }
	        else {
	            this.editGrid.addItem({ rowId: uniqueId, type: type, tractNumber: findMaxGroupNumberPerType(this.editGrid.items(), type), isNewRecord: true });
	        }
	        // make sure the observable is up to date
	        this._buildTracts(this.editGrid.items());
	        this.editGrid.apply({ resize: true });
	        return false;
	    };
	    /**
	     * Copy tract items from another document
	     * using the selection from.
	     */
	    LandsRightsEditGridViewModel.prototype.copyItems = function () {
	        /**
	         * Show selection form that allows users
	         * to find and copy tracts to this array.
	         *
	         * @remarks
	         *     Expects "this" to be a grid observable
	         *     array that creates and stores tracts.
	         */
	        selectionForm.open({
	            getDetailsApi: "Geo-Tract-GetDetails",
	            getDetailsDataBuilder: function (items) {
	                var guidIndex = items[0].length - 1;
	                return {
	                    removeRights: (pli.viewModel.extras.title().indexOf("Surface Lease") > -1),
	                    copyTractFrom: ko.utils.arrayMap(items, function (item) {
	                        return {
	                            guid: item[guidIndex],
	                            type: item[3]
	                        };
	                    })
	                };
	            },
	            multiSelect: true,
	            searchApi: "Geo-Document-SearchTracts",
	            text: {
	                acceptButton: "Copy",
	                iconClass: "sprite-copy-16",
	                examples: [
	                    "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                    "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                    "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                    "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
	                ],
	                title: "Copy Tracts"
	            },
	            onAcceptedContext: this,
	            onAccepted: function (newTracts) {
	                newTracts = selectionForm.utils.resetGuids(newTracts);
	                var records = renumberTractNum(newTracts, findMaxGroupNumber(this.editGrid.items.peek()));
	                var newTractItems = this._flattenTracts(records);
	                // these newly copied tractItems don't have rowIds yet, so give them one
	                for (var _i = 0, newTractItems_1 = newTractItems; _i < newTractItems_1.length; _i++) {
	                    var tractItem = newTractItems_1[_i];
	                    tractItem.rowId = utils_1.GenerateGuid();
	                }
	                // add the copied tractItems to the existing ones
	                newTractItems = this.editGrid.items().concat(newTractItems);
	                computeColumns(newTractItems);
	                this.editGrid.apply({ items: newTractItems });
	                // make sure the observable is up to date
	                this._buildTracts(this.editGrid.items());
	            }
	        });
	    };
	    /**
	     * Removes a tract item record from the edit grid.
	     */
	    LandsRightsEditGridViewModel.prototype.deleteItem = function () {
	        var itemToRemove = this.editGrid.currentItems();
	        if (itemToRemove.length !== 0) {
	            this.editGrid.deleteItems(itemToRemove);
	        }
	        // make sure the observable is up to date
	        this._buildTracts(this.editGrid.items());
	        return false;
	    };
	    /**
	     * Returns the error count of the items in the
	     * edit grid.
	     *
	     * TODO: set back to this.editGrid.errorsCount() once https://github.com/pandell/web-pli/issues/394 has been addressed
	     */
	    LandsRightsEditGridViewModel.prototype.errorsCount = function () {
	        return this.editGrid.items().filter(rowHasErrors).length;
	    };
	    /**
	     * Clear out _tractIds. This is useful when duplicating a file
	     */
	    LandsRightsEditGridViewModel.prototype.resetTractIds = function () {
	        this._tractIds = [];
	    };
	    /**
	     * Load an array of tract ids which is a flattened mapping
	     * of the tract guid and tract item guid.
	     *
	     * This mapping array is required to build the tract
	     * items from the edit grid back to the tracts.
	     */
	    LandsRightsEditGridViewModel.prototype.loadViewModel = function (tracts) {
	        var _this = this;
	        /**
	         * Fixes EditGrid bug https://github.com/pandell/web-pli/issues/625
	         * TODO: Remove when fixed in web-pli
	         */
	        var focusedItem = this.editGrid.focusedItem();
	        this.editGrid.apply({ focusedItem: null });
	        this._tractIds = [];
	        if (tracts) {
	            tracts.forEach(function (tract) {
	                if (tract.tractItems && tract.tractItems.length > 0) {
	                    tract.tractItems.forEach(function (tractItem) {
	                        this._tractIds.push({ tractGuid: tract.guid, tractNum: tract.name, tractItemGuid: tractItem.isRight ? tractItem.right.guid : tractItem.land.guid });
	                    }, this);
	                }
	                else {
	                    this._tractIds.push({ tractGuid: tract.guid, tractNum: tract.name, tractItemGuid: null });
	                }
	            }, this);
	        }
	        var flattenTracts = this._flattenTracts(tracts);
	        computeColumns(flattenTracts);
	        var shortcutActions = {
	            "ctrl+i": this.addItem.bind(this),
	            "ctrl+delete": this.deleteItem.bind(this)
	        };
	        var onItemsCommitted = function (committedItems) {
	            computeColumns(committedItems);
	            _this._buildTracts(_this.editGrid.items());
	        };
	        this.editGrid.apply({
	            columns: columns,
	            idField: "rowId",
	            multiSelect: false,
	            shortcutActions: shortcutActions,
	            onItemsCommitted: onItemsCommitted,
	            items: flattenTracts,
	            focusedItem: focusedItem
	        });
	    };
	    // -------------------------------------------------------------------------
	    // Private methods
	    // -------------------------------------------------------------------------
	    /**
	     * Builds the tract items back into tracts.
	     */
	    LandsRightsEditGridViewModel.prototype._buildTracts = function (tractItems) {
	        // if we set tracts to a simple array, we run into problems when
	        // the user sets the tract number to 999999 because we then get
	        // an array with 999999 elements that are mostly undefined.
	        var tracts = {};
	        var tractsDictionary = this._tractIds;
	        ko.utils.arrayForEach(tractItems, function (item) {
	            if (item.tractNumber) {
	                var num = item.tractNumber;
	                var tractInfo = ko.utils.arrayFirst(tractsDictionary, function (id) {
	                    return id.tractNum === item.tractNumber;
	                });
	                tracts[num] = {
	                    id: num,
	                    guid: tractInfo ? tractInfo.tractGuid : "",
	                    number: num,
	                    name: num,
	                    description: null,
	                    tractItems: []
	                };
	            }
	        });
	        ko.utils.arrayForEach(tractItems, function (item, index) {
	            var tractItem = { land: {}, right: {} };
	            var num = item.tractNumber;
	            var guid = item.guid;
	            var tractInfo = ko.utils.arrayFirst(tractsDictionary, function (id) {
	                return id.tractNum === num && id.tractItemGuid === guid;
	            });
	            // if the user removes the group number for some reason, we don't want to throw an error
	            if (num) {
	                if (item.type === "land") {
	                    var landItem = item;
	                    tractItem.land.id = landItem.description;
	                    tractItem.land.guid = tractInfo ? landItem.guid : "";
	                    tractItem.land.format = landItem.format;
	                    tractItem.land.location = landItem.location;
	                    tractItem.land.sections = landItem.sections;
	                    tractItem.land.lease = landItem.lease;
	                    tractItem.land.lessor = landItem.lessor;
	                    tractItem.land.productionType = landItem.productionType;
	                    tractItem.land.description = landItem.notes;
	                    tractItem.isRight = false;
	                    tractItem.originalIndex = index;
	                    tracts[num].tractItems.push(tractItem);
	                }
	                else if (item.type === "right") {
	                    var rightItem = item;
	                    tractItem.right.id = rightItem.description;
	                    tractItem.right.guid = tractInfo ? rightItem.guid : "";
	                    tractItem.right.excluding = rightItem.excluding;
	                    tractItem.right.product = rightItem.product;
	                    tractItem.right.from = rightItem.from;
	                    tractItem.right.fromZone = rightItem.fromZone;
	                    tractItem.right.to = rightItem.to;
	                    tractItem.right.toZone = rightItem.toZone;
	                    tractItem.right.description = rightItem.notes;
	                    tractItem.isRight = true;
	                    tractItem.originalIndex = index;
	                    tracts[num].tractItems.push(tractItem);
	                }
	                else if (item.type === "comment") {
	                    var commentItem = item;
	                    tracts[num].description = commentItem.comment;
	                }
	            }
	        });
	        // convert the tracts dictionary back into an array so we can give it to the observable
	        var tempTracts = [];
	        for (var key in tracts) {
	            if (tracts.hasOwnProperty(key)) {
	                tempTracts.push(tracts[key]);
	            }
	        }
	        this._tracts(tempTracts);
	    };
	    /**
	     * Flattens the tracts into the tract items.
	     */
	    LandsRightsEditGridViewModel.prototype._flattenTracts = function (tracts) {
	        var tractItems = [];
	        if (tracts) {
	            // flatten the data so it displays properly in the grid
	            for (var _i = 0, tracts_1 = tracts; _i < tracts_1.length; _i++) {
	                var tract = tracts_1[_i];
	                for (var _a = 0, _b = tract.tractItems; _a < _b.length; _a++) {
	                    var tractItem = _b[_a];
	                    if (tractItem.isRight) {
	                        // if the items are coming from a copied split, all the guids have been cleared.
	                        var guid = tractItem.right.guid === null ? utils_1.GenerateGuid() : tractItem.right.guid;
	                        tractItems.push({
	                            guid: guid,
	                            rowId: guid,
	                            tractNumber: tract.name,
	                            type: "right",
	                            notes: tractItem.right.description,
	                            excluding: tractItem.right.excluding,
	                            product: tractItem.right.product,
	                            from: tractItem.right.from,
	                            fromZone: tractItem.right.fromZone,
	                            to: tractItem.right.to,
	                            toZone: tractItem.right.toZone
	                        });
	                    }
	                    else {
	                        // if the items are coming from a copied split, all the guids have been cleared.
	                        var guid = tractItem.land.guid === null ? utils_1.GenerateGuid() : tractItem.land.guid;
	                        tractItems.push({
	                            guid: guid,
	                            rowId: guid,
	                            tractNumber: tract.name,
	                            type: "land",
	                            notes: tractItem.land.description,
	                            format: tractItem.land.format,
	                            location: tractItem.land.location,
	                            sections: tractItem.land.sections,
	                            lease: tractItem.land.lease,
	                            lessor: tractItem.land.lessor,
	                            productionType: tractItem.land.productionType
	                        });
	                    }
	                }
	                if (tract.description && tract.description !== "") {
	                    // if the items are coming from a copied split, all the guids have been cleared.
	                    var guid = tract.guid === null ? utils_1.GenerateGuid() : tract.guid;
	                    tractItems.push({
	                        guid: guid,
	                        rowId: guid,
	                        tractNumber: tract.name,
	                        type: "comment",
	                        comment: tract.description
	                    });
	                }
	            }
	        }
	        return tractItems;
	    };
	    return LandsRightsEditGridViewModel;
	}());
	exports.LandsRightsEditGridViewModel = LandsRightsEditGridViewModel;
	module.exports = LandsRightsEditGridViewModel;
	module.exports.computeDescription = computeDescription;
	


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var R = __webpack_require__(7);
	var targetenv_1 = __webpack_require__(3);
	var knockoutGridViewModel_1 = __webpack_require__(414);
	var itemFilter_1 = __webpack_require__(370);
	var array_1 = __webpack_require__(447);
	var disposable_1 = __webpack_require__(375);
	var string_1 = __webpack_require__(13);
	var shared_1 = __webpack_require__(559);
	/** TODO: Remove in web-pli v8. */
	/**
	 * Default edit grid settings.
	 */
	var defaultSettings = {
	    disabled: false,
	    multiSelect: true,
	    rowCssProvider: defaultRowCssProvider
	};
	/** Classes returned when a row has errors. */
	var errorClasses = ["error"];
	/** Classes returned when a row is new. */
	var newClasses = ["new"];
	/** Classes returned when a row is neither new nor empty. */
	var noClasses = [];
	/** Regex to extract item index and property name for setErrorMessage. */
	var indexPropertyMatcher = /^(items)?\[(\d+)\].(\S+)$/;
	/**
	 * The default row css provider.
	 *
	 * @param row
	 *     Current row item.
	 * @returns
	 *     Array of css classes to be applied to the current row (["error"] if item has errors,
	 *     ["new"] if item is new, or []).
	 */
	function defaultRowCssProvider(row) {
	    return (rowHasErrors(row)
	        ? errorClasses
	        : (!!row.isNewRecord ? newClasses : noClasses));
	}
	/**
	 * Returns true if a row has errors.
	 * Inspects "extras.errorsCount" and "_errors", in that order.
	 */
	function rowHasErrors(row) {
	    var extras = row.extras;
	    var errors = row._errors;
	    return (extras && ko.isObservable(extras.errorsCount) && !!extras.errorsCount.peek())
	        || (typeof errors === "object" && !array_1.isEmpty(errors));
	}
	exports.rowHasErrors = rowHasErrors;
	/**
	 * Possible behaviours for committing pending changes.
	 */
	(function (CommitMode) {
	    /**
	     * Auto-commit when editing a single item, manual commit when editing multiple items (default mode).
	     */
	    CommitMode[CommitMode["Mixed"] = 0] = "Mixed";
	    /**
	     * Auto-commit regardless of number of items being edited.
	     */
	    CommitMode[CommitMode["Auto"] = 1] = "Auto";
	    /**
	     * Manual commit regardless of number of items being edited.
	     */
	    CommitMode[CommitMode["Manual"] = 2] = "Manual";
	})(exports.CommitMode || (exports.CommitMode = {}));
	var CommitMode = exports.CommitMode;
	/** Settings keys unique to EditGrid (used in EditGrid::apply()) */
	var editGridSettingsKeys = [
	    "active",
	    "commitMode",
	    "createViewItem",
	    "editRequiresSelection",
	    "filter",
	    "filterColumns",
	    "itemFilterBuilder",
	    "onItemsCommitted",
	    "viewItemClass"
	];
	/**
	 * Bridges a ko-grid to an item edit panel, allowing for fast, keyboard-driven editing.
	 */
	var EditGrid = (function () {
	    /**
	     * Creates a new EditGrid instance.
	     *
	     * @param settings
	     *     Initial settings to apply. "createViewItem" or "viewItemClass" is required.
	     */
	    function EditGrid(settings) {
	        var _this = this;
	        /** Stores the items that are currently being edited. */
	        this._currentItems = ko.observable([]);
	        /** Instructs EditWrapper to defer validation if, e.g., the current item is newly created. */
	        this._deferValidate = false;
	        /** Stores the dirty state of the current items. */
	        this._dirty = ko.observable(false);
	        /** Active filter string. */
	        this._filter = "";
	        /** Item commit callback function. */
	        this._onItemsCommitted = null;
	        /** Combines user-defined shortcuts with a list of defaults. */
	        this._combineDefaultShortcutsWith = R.merge({
	            "ctrl+1": this._performGridAction("FocusField", 0),
	            "ctrl+2": this._performGridAction("FocusField", 1),
	            "ctrl+3": this._performGridAction("FocusField", 2),
	            "ctrl+4": this._performGridAction("FocusField", 3),
	            "ctrl+5": this._performGridAction("FocusField", 4),
	            "ctrl+6": this._performGridAction("FocusField", 5),
	            "ctrl+7": this._performGridAction("FocusField", 6),
	            "ctrl+8": this._performGridAction("FocusField", 7),
	            "ctrl+9": this._performGridAction("FocusField", 8),
	            "ctrl+0": this._performGridAction("FocusField", 9),
	            "ctrl+down": this._performGridAction("MoveNextAndFocus"),
	            "ctrl+end": this._performGridAction("MoveEnd"),
	            "ctrl+enter": function () { return _this.commit(); },
	            "ctrl+home": this._performGridAction("MoveHome"),
	            "ctrl+shift+down": this._performGridAction("SelectNext"),
	            "ctrl+shift+end": this._performGridAction("SelectEnd"),
	            "ctrl+shift+home": this._performGridAction("SelectHome"),
	            "ctrl+shift+space,ctrl+shift+a": function () { return _this._selectAllOrNone(); },
	            "ctrl+shift+up": this._performGridAction("SelectPrevious"),
	            "ctrl+space": this._performGridAction("Select"),
	            "ctrl+up": this._performGridAction("MovePreviousAndFocus"),
	            "ctrl+[": function () { return _this._shiftSelectionPrevious(); },
	            "ctrl+]": function () { return _this._shiftSelectionNext(); },
	            "down": this._performGridAction("MoveNextAndFocus"),
	            "enter": this._performGridAction("FocusNext"),
	            "esc": function () { return _this.reject(); },
	            "pagedown": this._performGridAction("PageDown"),
	            "pageup": this._performGridAction("PageUp"),
	            "shift+tab": null,
	            "tab": null,
	            "up": this._performGridAction("MovePreviousAndFocus")
	        });
	        if (typeof settings.id !== "string") {
	            throw new Error("\"settings.id\" is required");
	        }
	        if (!settings.createViewItem && !settings.viewItemClass) {
	            throw new Error("Either \"settings.viewItemClass\" or \"settings.createViewItem\" is required");
	        }
	        this._active = ko.observable(false);
	        this._commitMode = CommitMode.Mixed;
	        this._customActions = {};
	        this._editRequiresSelection = false;
	        this._grid = new knockoutGridViewModel_1.GridViewModel();
	        this._idField = "id";
	        this._itemFilterBuilder = itemFilter_1.defaultItemFilterBuilder;
	        this._items = ko.observable([]);
	        this._viewItemClass = settings.viewItemClass;
	        this._viewItemFactory = settings.createViewItem;
	        this._viewItem = ko.observable(this._createViewItem([]));
	        this._filterColumns = Object.keys(this._viewItem());
	        var itemsSorter = (settings.sortKeyProvider
	            ? R.sort(function (a, b) {
	                var propertyA = settings.sortKeyProvider(a);
	                var propertyB = settings.sortKeyProvider(b);
	                return propertyA > propertyB ? 1 : (propertyA < propertyB ? -1 : 0);
	            })
	            : R.identity);
	        this.active = ko.pureComputed(this._active, this);
	        this.commitConfirmMessage = ko.pureComputed(this._computeCommitConfirmMessage, this);
	        this.currentItems = ko.pureComputed(this._currentItems, this);
	        this.currentItemsCount = ko.pureComputed(function () { return _this._currentItems().length; }, this);
	        this.dirty = ko.pureComputed(this._dirty, this);
	        this.errorsCount = ko.pureComputed(function () { return _this._items().filter(rowHasErrors).length; });
	        this.filteredItems = ko.pureComputed(function () { return _this._grid.items() || []; });
	        this.focusedItem = ko.pureComputed(function () { return _this._grid.focusedItem(); });
	        this.keyMap = this._combineDefaultShortcutsWith({});
	        this.id = settings.id;
	        this.items = ko.pureComputed(function () { return itemsSorter(_this._items()); });
	        this.items.setErrorMessage = this.setErrorMessage.bind(this);
	        this.readOnly = ko.pureComputed(function () { return _this._editRequiresSelection && _this.selectedItems().length === 0; }, this);
	        this.selectedItems = ko.pureComputed(function () { return _this._grid.selectedItems() || []; }, this);
	        this.viewItem = ko.pureComputed(this._viewItem, this);
	        this._byId = this._byId.bind(this);
	        this.commit = this.commit.bind(this);
	        this.reject = this.reject.bind(this);
	        this._disposables = new disposable_1.CompositeDisposable(this._grid.focusedItem.subscribe(this._syncFocusedItem, this), this._grid.selectedItems.subscribe(this._syncFocusedItem, this));
	        this.apply(R.merge(defaultSettings, settings));
	    }
	    // -------------------------------------------------------------------------
	    // Public actions
	    // -------------------------------------------------------------------------
	    /**
	     * Adds a new item to the grid and adjusts grid state accordingly.
	     * Only allows a single "new" item to be in the array. If the last item is
	     * a "new" item, it will simply focus that row.
	     *
	     * @param item
	     *     Item to append to the grid.
	     */
	    EditGrid.prototype.addItem = function (item) {
	        var items = this._items.peek();
	        if (items.length > 0 && items[items.length - 1].isNewRecord) {
	            this.apply({ focusedItem: items[items.length - 1], invalidate: true });
	        }
	        else {
	            item.isNewRecord = true;
	            var newSelectedItems = void 0;
	            if (this._editRequiresSelection) {
	                newSelectedItems = [item];
	            }
	            else {
	                newSelectedItems = this.selectedItems.peek().length ? [] : undefined;
	            }
	            this._deferValidate = true;
	            items.push(item);
	            this.apply({
	                filter: "",
	                focusedItem: item,
	                invalidate: true,
	                items: items,
	                selectedItems: newSelectedItems
	            });
	        }
	    };
	    /**
	     * Applies specified settings to the grid.
	     *
	     * @param settings
	     *     EditGridSettings to apply. Any settings that are "undefined" are ignored.
	     */
	    EditGrid.prototype.apply = function (settings) {
	        var _this = this;
	        var properties = R.omit(editGridSettingsKeys, settings);
	        // 1. Initialize properties
	        if (settings.commitMode !== undefined) {
	            this._commitMode = settings.commitMode;
	        }
	        if (settings.editRequiresSelection !== undefined) {
	            this._editRequiresSelection = !!settings.editRequiresSelection;
	        }
	        if (settings.filter !== undefined) {
	            this._filter = settings.filter;
	        }
	        if (settings.filterColumns !== undefined) {
	            this._filterColumns = settings.filterColumns;
	        }
	        if (settings.idField !== undefined) {
	            this._idField = settings.idField;
	            properties.idField = settings.idField;
	        }
	        if (settings.itemFilterBuilder !== undefined) {
	            this._itemFilterBuilder = settings.itemFilterBuilder;
	        }
	        if (settings.items !== undefined) {
	            properties.items = settings.items;
	        }
	        if (settings.onItemsCommitted !== undefined) {
	            this._onItemsCommitted = settings.onItemsCommitted;
	        }
	        if (settings.shortcutActions !== undefined) {
	            this.keyMap = this._combineDefaultShortcutsWith(settings.shortcutActions || {});
	            // set every action to 'false' for the keys defined in keymap
	            // to prevent the default SlickGrid action for that key
	            var disabledActions = R.map(function () { return false; }, this.keyMap);
	            properties.shortcutActions = disabledActions;
	        }
	        // 2. Set dependent properties
	        if (settings.active === true && settings.focusedItem === undefined) {
	            if (!this._grid.focusedItem()) {
	                properties.focusedItem = this._items.peek()[0];
	            }
	        }
	        if (settings.filter !== undefined || settings.items !== undefined) {
	            if (properties.items === undefined) {
	                properties.items = this._items.peek();
	            }
	            if (this._filter.length > 0) {
	                var itemFilter = this._itemFilterBuilder(properties.items, this._filterColumns);
	                // TODO: support real async item filters!
	                itemFilter(this._filter, function (items) { properties.items = items; });
	            }
	        }
	        if (properties.items !== undefined) {
	            if (properties.items.length > 0) {
	                // Pick new focused item if necessary
	                if (properties.focusedItem === undefined) {
	                    var focusedItem_1 = this._grid.focusedItem();
	                    if (!focusedItem_1 || !properties.items.some(function (item) { return item[_this._idField] === focusedItem_1[_this._idField]; })) {
	                        properties.focusedItem = properties.items[0];
	                    }
	                }
	                // Adjust selected items
	                if (properties.selectedItems === undefined) {
	                    var selectedItems = this.selectedItems();
	                    if (selectedItems.length > 0) {
	                        var newSelectedItems = R.intersectionWith(this._byId, selectedItems, properties.items);
	                        if (R.differenceWith(this._byId, selectedItems, newSelectedItems).length > 0) {
	                            properties.selectedItems = newSelectedItems;
	                        }
	                    }
	                }
	            }
	            else {
	                properties.focusedItem = null;
	                properties.selectedItems = [];
	            }
	        }
	        // 3. Update ko-grid instance
	        if (settings.active === true && !this._active.peek()) {
	            // 'resize' will completely redraw the grid, which may be necessary if
	            // it was bound when the container element was hidden. SlickGrid
	            // relies on having actual container dimensions for rendering.
	            // This must be done in a separate call to 'apply', otherwise changes
	            // in focus/selection may be obscured by an incorrect scroll position.
	            this._grid.apply({ resize: true });
	        }
	        if (!array_1.isEmpty(properties)) {
	            this._grid.apply(properties);
	        }
	        // 4. Update affected observables
	        if (settings.active !== undefined) {
	            this._active(settings.active);
	        }
	        if (settings.items !== undefined) {
	            this._items(settings.items);
	        }
	        if (properties.items !== undefined || properties.focusedItem !== undefined || properties.selectedItems !== undefined) {
	            // The edit wrapper might need to be updated
	            this._syncFocusedItem();
	        }
	    };
	    /**
	     * Commits any pending changes to the current items.
	     */
	    EditGrid.prototype.commit = function () {
	        if (this._editWrapper) {
	            this._editWrapper.commit();
	            return false;
	        }
	        return true;
	    };
	    /**
	     * Deletes items from the grid and sets focus appropriately.
	     *
	     * @param itemsToDelete
	     *     Items to remove from the grid.
	     */
	    EditGrid.prototype.deleteItems = function (itemsToDelete) {
	        var _this = this;
	        var oldItems = this._items.peek();
	        var items = R.differenceWith(this._byId, oldItems, itemsToDelete);
	        var idsToDelete = itemsToDelete.map(function (item) { return item[_this._idField]; });
	        var focusedItemId = (this.focusedItem.peek() || {})[this._idField];
	        var focusedItemIndex = focusedItemId
	            ? R.findIndex(function (item) { return item[_this._idField] === focusedItemId; }, oldItems)
	            : 0;
	        // find the first non-deleted item before the previously focused item
	        while (focusedItemIndex >= 0 && idsToDelete.indexOf(oldItems[focusedItemIndex][this._idField]) >= 0) {
	            focusedItemIndex--;
	        }
	        var focusedItem = focusedItemIndex === -1 ? items[0] : oldItems[focusedItemIndex];
	        this.apply({ items: items, focusedItem: focusedItem });
	    };
	    /**
	     * Disposes any resources/subscriptions used by the EditGrid.
	     */
	    EditGrid.prototype.dispose = function () {
	        if (this._editWrapper) {
	            this._editWrapper.dispose();
	        }
	        this._disposables.dispose();
	        disposable_1.disposeObject(this.viewItem(), true);
	    };
	    /**
	     * Rejects any pending changes on the current items.
	     */
	    EditGrid.prototype.reject = function () {
	        if (this._editWrapper) {
	            this._editWrapper.reject();
	            return false;
	        }
	        return true;
	    };
	    /**
	     * Sets the error message for the item at the given path and applies it to the grid.
	     *
	     * This is not intended to be called directly. Rather, it will be
	     * called when a view model that contains an EditGrid instance
	     * receives server-side validation results from a "Save" call.
	     *
	     * @param message
	     *     Error message to set.
	     * @param path
	     *     Path to the target item/property.
	     */
	    EditGrid.prototype.setErrorMessage = function (message, path) {
	        var matches = indexPropertyMatcher.exec(path);
	        if (matches !== null) {
	            var index = parseInt(matches[2], 10);
	            var items = this.items();
	            var item = items[index];
	            if (item) {
	                var key = matches[3];
	                shared_1.setItemError(item, key, message);
	                // TODO: queue item errors and apply one time?
	                this.apply({ items: items });
	                return;
	            }
	        }
	        // unable to apply
	        if (targetenv_1.isBrowser && console.warn) {
	            console.warn("EditGrid " + this.id + ": unable to set error message for path \"" + path + "\"");
	        }
	    };
	    // -------------------------------------------------------------------------
	    // Internal actions
	    // -------------------------------------------------------------------------
	    /**
	     * Registers a named action that can be bound to a shortcut key.
	     * @param name
	     *     Action name.
	     * @param action
	     *     Function to execute when action invoked.
	     * @param context
	     *     Value to use for 'this' when invoking action.
	     */
	    EditGrid.prototype._registerAction = function (name, action, context) {
	        if (string_1.isNullOrWhitespace(name)) {
	            throw new Error("Expected \"name\" to contain an action name.");
	        }
	        if (typeof action !== "function") {
	            throw new Error("Expected \"action\" to be a function.");
	        }
	        this._customActions[name.toLowerCase()] = [action, context];
	    };
	    // -------------------------------------------------------------------------
	    // Private
	    // -------------------------------------------------------------------------
	    /**
	     * Predicate that compares by the value in "this._idField".
	     */
	    EditGrid.prototype._byId = function (a, b) {
	        return a[this._idField] === b[this._idField];
	    };
	    /**
	     * Gets the text for the Commit Confirmation panel.
	     */
	    EditGrid.prototype._computeCommitConfirmMessage = function () {
	        var count = this.currentItemsCount();
	        return "Confirm edits (" + count + " " + (count === 1 ? "row" : "rows") + ")?";
	    };
	    /**
	     * Creates a viewItem and sets updateDelay to 0 on any pliTextBox fields.
	     */
	    EditGrid.prototype._createViewItem = function (items) {
	        var viewItem = this._viewItemClass
	            ? new this._viewItemClass(items)
	            : this._viewItemFactory(items);
	        // Set updateDelay=0 on any pliTextBox fields to ensure
	        // that value updates are propagated immediately. This is
	        // necessary because the default update delay is 500ms;
	        // when speed-editing a single field, this may cause updates
	        // to be missed because the field focus will not change and
	        // the row might be switched long before the 500ms timeout.
	        shared_1.forEachWriteableField(viewItem, function (key, o) {
	            if (typeof o.load === "function") {
	                if (!!o.behaviourData && typeof o.behaviourData === "string") {
	                    o.behaviourData = { format: o.behaviourData };
	                }
	                else if (!!o.behaviourData && typeof o.behaviourData !== "object" && typeof o.behaviourData !== "function") {
	                    throw new Error(("Unsupported behaviour data for property \"" + key + "\". ") +
	                        ("The edit grid supports an \"object\", \"function\" or \"null\" but got \"" + typeof o.behaviourData + "\"."));
	                }
	                if (!o.behaviourData) {
	                    o.behaviourData = {};
	                }
	                if (typeof o.behaviourData.updateDelay !== "number") {
	                    o.behaviourData.updateDelay = 0;
	                }
	            }
	        });
	        return viewItem;
	    };
	    /**
	     * Construct a new EditWrapper each time focus or selection changes.
	     */
	    EditGrid.prototype._initEditWrapper = function (items) {
	        if (this._editWrapper) {
	            // if items haven't changed, don't do anything to the edit wrapper
	            // this most often occurs when deselecting a single item
	            if (R.equals(items, this._editWrapper.items)) {
	                // if there is a change in selection state and editing requires selection,
	                // reject any pending changes
	                if (this._dirty() && this._editRequiresSelection) {
	                    this.reject();
	                }
	                // ensure view item's validation state is in sync with
	                // errors for the currently selected item(s)
	                this._editWrapper.updateErrors();
	                return;
	            }
	            this._editWrapper.dispose();
	            this._dirtySubscription.dispose();
	        }
	        // only update the view item if it has a different shape for this set of items
	        var currentViewItem = this.viewItem.peek();
	        var newViewItem = this._createViewItem(items);
	        if (!R.equals(Object.keys(currentViewItem), Object.keys(newViewItem))) {
	            this._viewItem(newViewItem);
	        }
	        var editWrapper = new shared_1.BatchEditWrapper(items, this.viewItem(), this.readOnly, this._deferValidate);
	        this._currentItems(editWrapper.items);
	        this._editWrapper = editWrapper;
	        this._deferValidate = false;
	        this._dirtySubscription = editWrapper.dirty.subscribe(this._onEditWrapperDirtyChanged, this);
	    };
	    /**
	     * Handles changes to 'dirty' state on the edit wrapper.
	     */
	    EditGrid.prototype._onEditWrapperDirtyChanged = function (dirty) {
	        if (dirty) {
	            if (this._commitMode === CommitMode.Auto || (this._commitMode === CommitMode.Mixed && this.currentItemsCount() === 1)) {
	                this._editWrapper.commit();
	            }
	            else {
	                this._dirty(true);
	            }
	        }
	        else {
	            if (typeof this._onItemsCommitted === "function") {
	                this._onItemsCommitted(this._currentItems());
	            }
	            // only invalidate if dirty state reverts to 'false' because
	            // this indicates either a commit or a reject operation
	            this._grid.apply({ invalidate: true });
	            // ensure any _items subscriptions are notified (e.g., errorsCount)
	            this._items.valueHasMutated();
	            this._dirty(false);
	        }
	    };
	    /**
	     * Returns a function that invokes either a custom action or a named grid action.
	     */
	    EditGrid.prototype._performGridAction = function (action) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var viewModel = this;
	        return function actionInvoker() {
	            var customActionEntry = viewModel._customActions[action.toLowerCase()];
	            if (customActionEntry) {
	                var customAction = customActionEntry[0];
	                var context_1 = customActionEntry[1];
	                return customAction.apply(context_1, args.concat(Array.prototype.slice.call(arguments)));
	            }
	            viewModel._grid.apply({ action: action });
	            return false;
	        };
	    };
	    /**
	     * Checks or unchecks all rows.
	     */
	    EditGrid.prototype._selectAllOrNone = function () {
	        if (this.selectedItems().length < this._grid.items().length) {
	            this._grid.apply({ action: "SelectAll" });
	        }
	        else {
	            this._grid.apply({ action: "SelectNone" });
	        }
	        return false;
	    };
	    /**
	     * Moves the selected item "down" by 1 or shifts the focus down in single select mode.
	     */
	    EditGrid.prototype._shiftSelectionNext = function () {
	        if (!this.dirty()) {
	            var selectedItems = this.selectedItems();
	            if (selectedItems.length === 1) {
	                this._grid.apply({ focusedItem: selectedItems[0] });
	                this._grid.apply({ action: "SelectNone" });
	                this._grid.apply({ action: "MoveNext" });
	                this._grid.apply({ action: "Select" });
	            }
	            else if (selectedItems.length === 0) {
	                this._grid.apply({ action: "MoveNext" });
	            }
	        }
	        return false;
	    };
	    /**
	     * Moves the selected item "up" by 1 or shifts the focus up in single select mode.
	     */
	    EditGrid.prototype._shiftSelectionPrevious = function () {
	        if (!this.dirty()) {
	            var selectedItems = this.selectedItems();
	            if (selectedItems.length === 1) {
	                this._grid.apply({ focusedItem: selectedItems[0] });
	                this._grid.apply({ action: "SelectNone" });
	                this._grid.apply({ action: "MovePrevious" });
	                this._grid.apply({ action: "Select" });
	            }
	            else if (selectedItems.length === 0) {
	                this._grid.apply({ action: "MovePrevious" });
	            }
	        }
	        return false;
	    };
	    /**
	     * Merges selectedItems/focusedItems update events and initializes the edit wrapper accordingly.
	     */
	    EditGrid.prototype._syncFocusedItem = function () {
	        var selectedItems = this._grid.selectedItems();
	        var focusedItem = this._grid.focusedItem();
	        if ((!selectedItems || selectedItems.length === 0) && (!focusedItem || this.filteredItems().length === 0)) {
	            this._initEditWrapper([]);
	        }
	        else {
	            var items = (selectedItems && selectedItems.length > 0
	                ? selectedItems
	                : [focusedItem]);
	            this._initEditWrapper(items);
	        }
	    };
	    return EditGrid;
	}());
	exports.EditGrid = EditGrid;
	



/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var util_1 = __webpack_require__(386);
	/**
	 * Unwraps the raw and display value of an item at the given key.
	 */
	function getValue(item, key) {
	    var o = item[key];
	    if (o && typeof o.peekValue === "function") {
	        return { raw: o._raw, value: o.peekValue() };
	    }
	    if (o && typeof o.peek === "function") {
	        return { raw: null, value: o.peek() };
	    }
	    return { raw: null, value: o };
	}
	/**
	 * Returns the error message or "null" after validating a given observable property.
	 */
	function getValidationError(item, key) {
	    var o = item[key];
	    if (o && typeof o.validate === "function") {
	        var isValid = o.validate();
	        return isValid ? null : o._errorMessage;
	    }
	    return null;
	}
	/**
	 * Returns true if the given observable is a TextBoxObservable (i.e., has a 'reset' function).
	 */
	function isTextBoxObservable(o) {
	    var oAny = o;
	    return oAny && typeof oAny.reset === "function";
	}
	/**
	 * Sets the error message for TextBoxObservables if a matching error is present on a record.
	 */
	function setObservableError(item, key, record) {
	    var o = item[key];
	    var e = record._errors && record._errors[key];
	    if (e && o && typeof o.setErrorMessage === "function") {
	        o.setErrorMessage(e);
	    }
	}
	/**
	 * Calls 'load' if the given observable is a TextBoxObservable, otherwise uses the normal write function.
	 */
	function setObservableValue(item, key, value, deferValidate) {
	    var o = item[key];
	    if (isTextBoxObservable(o)) {
	        if (deferValidate) {
	            // reset to ensure previous validation errors and activated state are cleared
	            o.reset();
	        }
	        o.load(value, /* ignoreFocus */ true); // update view even if currently focused
	        if (!deferValidate) {
	            o.validate();
	        }
	    }
	    else if (ko.isWritableObservable(o)) {
	        o(value);
	    }
	    else {
	        item[key] = value;
	    }
	}
	/**
	 * Iterates the writeable observables on an item and executes an action on each field.
	 * @param item
	 *     Item to iterate.
	 * @param action
	 *     Action to invoke on each pair (key, field observable).
	 */
	function forEachWriteableField(item, action) {
	    var keys = Object.keys(item).filter(function (name) { return ko.isWriteableObservable(item[name]); });
	    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
	        var key = keys_1[_i];
	        var o = item[key];
	        action(key, o);
	    }
	}
	exports.forEachWriteableField = forEachWriteableField;
	/**
	 * For non-observable properties, adds or removes the given error string to an _errors dictionary on the item.
	 */
	function setItemError(item, key, error) {
	    // synchronize pliObservable's error
	    var targetProperty = item[key];
	    if (targetProperty && targetProperty.setErrorMessage) {
	        targetProperty.setErrorMessage(error);
	    }
	    // update "_errors" property
	    var errors = item._errors; // cache in local var to avoid prototype chain lookup overhead
	    if (error) {
	        if (!errors) {
	            errors = item._errors = {};
	        }
	        errors[key] = error;
	    }
	    else {
	        if (errors) {
	            errors[key] = undefined;
	        }
	    }
	}
	exports.setItemError = setItemError;
	/**
	 * Allows efficient batch editing of a set of items.
	 */
	var BatchEditWrapper = (function () {
	    function BatchEditWrapper(items, itemView, readOnly, deferValidate) {
	        if (readOnly === void 0) { readOnly = false; }
	        if (deferValidate === void 0) { deferValidate = false; }
	        this._deferValidate = deferValidate || items.length > 1;
	        this._itemView = itemView;
	        this._readOnly = typeof readOnly === "function" ? readOnly : function () { return readOnly; };
	        this.items = items;
	        if (this.items.length > 0) {
	            this._initializeValues();
	            if (!this._deferValidate) {
	                this.updateErrors();
	            }
	        }
	        // create tracking dirty flag; in suspended state if there are no items
	        this.dirty = util_1.dirtyFlag(this._itemView, this.items.length === 0, false);
	    }
	    // -------------------------------------------------------------------------
	    // Wrapper actions
	    // -------------------------------------------------------------------------
	    /**
	     * Commits any pending changes to the contained items and resets dirty state.
	     */
	    BatchEditWrapper.prototype.commit = function () {
	        var _this = this;
	        if (!this._readOnly() && !this.dirty.isSuspended()) {
	            var original_1 = JSON.parse(this.dirty.originalJSON());
	            forEachWriteableField(this._itemView, function (key, o) {
	                var value = o.peek();
	                if (value !== original_1[key]) {
	                    var raw = o._raw;
	                    var error = getValidationError(_this._itemView, key);
	                    for (var _i = 0, _a = _this.items; _i < _a.length; _i++) {
	                        var item = _a[_i];
	                        // passing (raw || value) ensures that both valid and
	                        // invalid (i.e. unparsable) values are propagated to the
	                        // item
	                        setObservableValue(item, key, (raw || value), false);
	                        // update _errors dictionary for non-observable properties
	                        setItemError(item, key, error);
	                        // indicate item is no longer "new"
	                        if (item.isNewRecord) {
	                            item.isNewRecord = false;
	                        }
	                    }
	                }
	            });
	            this.dirty.reset();
	        }
	    };
	    /**
	     * Aborts pending changes and disposes item property subscriptions.
	     */
	    BatchEditWrapper.prototype.dispose = function () {
	        var _this = this;
	        var forceNotify = false;
	        // Validate single-item deferred batches, which are probably "new" items.
	        // These are deferred to avoid showing validation errors before the user
	        // has entered any data.
	        //
	        // But since items may be plain records (i.e., fields are not observable),
	        // we can only validate based on the values in _itemView. When there are
	        // multiple items, conflicting values will be set to "null" which means
	        // they cannot be properly validated. This is not so important because
	        // multi-item batches will be validated during "commit".
	        if (this._deferValidate && this.items.length === 1) {
	            forEachWriteableField(this._itemView, function (key) {
	                var item = _this.items[0];
	                var o = item[key];
	                if (o && typeof o.validate === "function") {
	                    var wasValid = o.isValid.peek();
	                    var isValid = o.validate();
	                    if (wasValid !== isValid) {
	                        // only notify if there was a change in validation state
	                        // to avoid unnecessary redraws
	                        forceNotify = true;
	                    }
	                }
	                else {
	                    var error = getValidationError(_this._itemView, key);
	                    setItemError(item, key, error);
	                }
	            });
	        }
	        this.dirty.reset();
	        this.dirty.suspend();
	        if (forceNotify) {
	            this.dirty.valueHasMutated();
	        }
	    };
	    /**
	     * Rejects pending changes and resets the dirty state.
	     */
	    BatchEditWrapper.prototype.reject = function () {
	        this._initializeValues();
	        this.dirty.reset();
	    };
	    /**
	     * Updates error state for all properties with a common value.
	     *
	     * If multiple items contain an error for a single property,
	     * only the last item's error message will be used.
	     */
	    BatchEditWrapper.prototype.updateErrors = function () {
	        var _this = this;
	        forEachWriteableField(this._itemView, function (key) {
	            var value = getValue(_this._itemView, key).value;
	            // if only one item, we can apply the error regardless of the value;
	            // otherwise, only apply if items have same value for this key
	            if (_this.items.length === 1 || value !== null) {
	                for (var _i = 0, _a = _this.items; _i < _a.length; _i++) {
	                    var item = _a[_i];
	                    setObservableError(_this._itemView, key, item);
	                }
	            }
	        });
	    };
	    // -------------------------------------------------------------------------
	    // Private
	    // -------------------------------------------------------------------------
	    /**
	     * Enumerates writeable fields on item view and sets common values for all items.
	     *
	     * For each view model property, if all items have the same value,
	     * that value will be set. If one of the items has a different
	     * value, the property will be set to "null".
	     *
	     * If the item viewmodel defines an "initializeValues" function,
	     * that function will be passed the map of keys to common values;
	     * otherwise, the properties will be initialized in no particular
	     * order.
	     */
	    BatchEditWrapper.prototype._initializeValues = function () {
	        var _this = this;
	        var commonValues = {};
	        forEachWriteableField(this._itemView, function (key) {
	            var commonValue = null;
	            for (var _i = 0, _a = _this.items; _i < _a.length; _i++) {
	                var item = _a[_i];
	                if (!commonValue) {
	                    commonValue = getValue(item, key);
	                }
	                else {
	                    if (commonValue.value !== getValue(item, key).value) {
	                        commonValue = null;
	                        break;
	                    }
	                }
	            }
	            commonValues[key] = commonValue;
	        });
	        if (typeof this._itemView.initializeValues === "function") {
	            this._itemView.initializeValues(commonValues, this._deferValidate);
	        }
	        else {
	            for (var key in commonValues) {
	                if (commonValues.hasOwnProperty(key)) {
	                    var commonValue = commonValues[key];
	                    setObservableValue(this._itemView, key, commonValue && (commonValue.raw || commonValue.value), this._deferValidate);
	                }
	            }
	        }
	    };
	    return BatchEditWrapper;
	}());
	exports.BatchEditWrapper = BatchEditWrapper;
	



/***/ }),
/* 560 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Generates a random guid.
	 *
	 * This is currently used to generate a unique id
	 * for new tract item records added to the edit grid.
	 */
	function GenerateGuid() {
	    function s4() {
	        return Math.floor((1 + Math.random()) * 0x10000)
	            .toString(16)
	            .substring(1);
	    }
	    return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
	        s4() + "-" + s4() + s4() + s4();
	}
	exports.GenerateGuid = GenerateGuid;
	/**
	 * Helper function that builds a string with the zone
	 * and zone qualifier.
	 *
	 * @param qualifier
	 *     The zone qualifier.
	 *
	 *     Example: TOP, BASE, SURFACE
	 *
	 * @param zone
	 *     The zone name.
	 *
	 *     Example: VIKING, COLONY
	 */
	function buildQualifiedZone(qualifier, zone) {
	    var zoneSummary = "";
	    if (qualifier && (qualifier.toLowerCase() === "surface" || qualifier.toLowerCase() === "basement")) {
	        zoneSummary = qualifier;
	    }
	    else if (zone) {
	        if (!qualifier) {
	            zoneSummary += zone;
	        }
	        else {
	            zoneSummary += qualifier + " " + zone;
	        }
	    }
	    return zoneSummary;
	}
	exports.buildQualifiedZone = buildQualifiedZone;
	


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ko = __webpack_require__(457);
	var pliObservable = __webpack_require__(15);
	var shared_1 = __webpack_require__(469);
	/* tslint:disable */
	var DataCache = __webpack_require__(488);
	var EntityRegistry = __webpack_require__(492);
	var uniqueCommentBehaviour = __webpack_require__(562);
	__webpack_require__(25);
	/**
	 * Land item class.
	 */
	var LandItem = (function () {
	    function LandItem(record) {
	        if (record === void 0) { record = { isNewRecord: false }; }
	        // common properties
	        this.guid = ko.observable();
	        this.rowId = ko.observable();
	        this.tractNumber = pliObservable(null, null, "required", "numeric");
	        this.type = ko.observable("");
	        this.notes = pliObservable();
	        // land specific properties
	        this.format = pliObservable("DLS", { behaviours: "picklist", picklistData: DataCache.getObservable("landSystemType") }, "required");
	        this.lease = pliObservable();
	        this.lessor = pliObservable();
	        this.location = pliObservable("", null, "required");
	        this.productionType = pliObservable();
	        this.sections = pliObservable();
	        this.guid(record.guid || "");
	        this.notes.load(record.notes || "");
	        this.rowId(record.rowId);
	        this.tractNumber.load(Number(record.tractNumber));
	        this.type(record.type || "");
	        this.format.load(record.format || "DLS");
	        this.lease.load(record.lease || "");
	        this.lessor.load(record.lessor || "");
	        this.location.load(record.location || "");
	        this.notes.load(record.notes || "");
	        this.productionType.load(record.productionType || "");
	        this.sections.load(record.sections || "");
	        this.extras = {
	            errorsCount: shared_1.createErrorsCountObservable(this),
	            locationDescription: ko.computed(this._computeLocationDescription, this),
	            sectionsDescription: ko.computed(this._computeSectionsDescription, this),
	            sectionsLabel: ko.computed(this._computeSectionsLabel, this)
	        };
	    }
	    /**
	     * Computes the hint for the location field based on
	     * the format
	     */
	    LandItem.prototype._computeLocationDescription = function () {
	        switch (this.format()) {
	            case "Free":
	                return "Enter any text";
	            case "NTS":
	                return "Example 94 A 12 H";
	            case "PLSS":
	                return "Example 5N 1W";
	            default:
	                return "Example 25 10 4";
	        }
	    };
	    ;
	    /**
	     * Computes the hint for the sections field based on
	     * the format
	     */
	    LandItem.prototype._computeSectionsDescription = function () {
	        switch (this.format()) {
	            case "Free":
	                return "Enter any text";
	            case "NTS":
	                return "Example 1,2,20-35";
	            case "PLSS":
	                return "Example 1,2,3-4,SW20,N/SW20";
	            default:
	                return "Example 1,4-7,N8,SW8,9(LSD 3,7-10)";
	        }
	    };
	    ;
	    /**
	     * Computes the label for the sections field based on
	     * NTS -> Units, otherwise Sections
	     */
	    LandItem.prototype._computeSectionsLabel = function () {
	        switch (this.format()) {
	            case "NTS":
	                return "Units";
	            default:
	                return "Sections";
	        }
	    };
	    ;
	    return LandItem;
	}());
	exports.LandItem = LandItem;
	/**
	 * Right item class.
	 */
	var RightItem = (function () {
	    function RightItem(record) {
	        if (record === void 0) { record = { isNewRecord: false }; }
	        var _this = this;
	        // common properties
	        this.guid = ko.observable();
	        this.rowId = ko.observable();
	        this.tractNumber = pliObservable(null, null, "required", "numeric");
	        this.type = ko.observable("");
	        this.notes = pliObservable();
	        // right specific properties
	        this.excluding = pliObservable(false);
	        this.from = pliObservable(null, EntityRegistry.fromZoneQualifier, "picklist");
	        this.fromZone = pliObservable(null, EntityRegistry.zone.getPicklistBehaviourData(), "picklist");
	        this.product = pliObservable(null, EntityRegistry.rightsProduct.getPicklistBehaviourData(), "required", "picklist");
	        this.to = pliObservable(null, EntityRegistry.toZoneQualifier, "picklist");
	        this.toZone = pliObservable(null, EntityRegistry.zone.getPicklistBehaviourData(), "picklist");
	        this.guid(record.guid || "");
	        this.notes.load(record.notes || "");
	        this.rowId(record.rowId);
	        this.tractNumber.load(Number(record.tractNumber));
	        this.type(record.type || "");
	        this.excluding.load(record.excluding);
	        this.from.load(record.from || null);
	        this.fromZone.load(record.fromZone || null);
	        this.notes.load(record.notes || "");
	        this.product.load(record.product || null);
	        this.to.load(record.to || null);
	        this.toZone.load(record.toZone || null);
	        this.from.subscribe(function (f) { return f && f.toLowerCase() === "surface" ? _this.fromZone.reset() : null; });
	        this.to.subscribe(function (f) { return f && f.toLowerCase() === "basement" ? _this.toZone.reset() : null; });
	        this.extras = {
	            errorsCount: shared_1.createErrorsCountObservable(this)
	        };
	    }
	    return RightItem;
	}());
	exports.RightItem = RightItem;
	/**
	 * Comment item class.
	 */
	var CommentItem = (function () {
	    function CommentItem(record, editGridReference) {
	        if (record === void 0) { record = { isNewRecord: false }; }
	        // common properties
	        this.guid = ko.observable();
	        this.rowId = ko.observable();
	        this.type = ko.observable("");
	        this.notes = pliObservable();
	        // comment specific property
	        this.comment = pliObservable("", null, "required");
	        this.guid(record.guid || "");
	        this.notes.load(record.notes || "");
	        this.rowId(record.rowId);
	        this.tractNumber = pliObservable(Number(record.tractNumber), { editGridRef: editGridReference }, "required", uniqueCommentBehaviour, "numeric");
	        this.type(record.type || "");
	        this.comment.load(record.comment || "");
	        this.extras = {
	            errorsCount: shared_1.createErrorsCountObservable(this)
	        };
	    }
	    return CommentItem;
	}());
	exports.CommentItem = CommentItem;
	


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(563);


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "UniqueTractCommentBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function UniqueTractCommentBehaviour() {
	    /// <summary>
	    /// Behaviour ensuring a value is unique
	    /// </summary>
	    this.defer = true;
	}
	
	//-------------------------------------------
	UniqueTractCommentBehaviour.prototype.validate = function uniqueTractCommentBehaviourValidate(value) {
	    var editGridRef = this.behaviourData && this.behaviourData.editGridRef;
	    var viewItem = editGridRef.viewItem.peek();
	
	    if (ko.isObservable(editGridRef.items)) {
	        var items = editGridRef.items.peek(),
	            commentItems = ko.utils.arrayFilter(items, function (item) {
	                if (item.guid) {
	                    return item.type === "comment" && item.tractNumber === value && item.guid !== viewItem.guid.peek();
	                }
	
	                return item.type === "comment" && item.tractNumber === value && item.rowId !== viewItem.rowId.peek();
	
	            }, this);
	
	        if (commentItems && commentItems.length > 0) {
	            return "Only one comment per group is allowed";
	        }
	    }
	
	    return null;
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Export
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = new UniqueTractCommentBehaviour();


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var editGridBinding_1 = __webpack_require__(565);
	/**
	 * Registers the 'editgrid' knockout binding.
	 */
	function registerEditGridBinding() {
	    ko.bindingHandlers.editgrid = {
	        init: editGridBinding_1.init, update: editGridBinding_1.update
	    };
	}
	exports.registerEditGridBinding = registerEditGridBinding;
	



/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var $ = __webpack_require__(2);
	var ko = __webpack_require__(9);
	var Rx = __webpack_require__(27);
	var pli = __webpack_require__(380);
	var knockoutGridBinding_1 = __webpack_require__(408);
	var disposable_1 = __webpack_require__(375);
	var editGrid_1 = __webpack_require__(558);
	/** Key to use when storing the EditGridController reference on its container element. */
	var elementKey = "__kopli__editgrid";
	/**
	 * Possible states for the PliNavigationPage that contains the edit grid.
	 */
	var PageActivationStatus;
	(function (PageActivationStatus) {
	    /** Unable to determine activation status because the grid is not associated with a page. */
	    PageActivationStatus[PageActivationStatus["Unknown"] = 0] = "Unknown";
	    /** Grid container page is not active. */
	    PageActivationStatus[PageActivationStatus["Inactive"] = 1] = "Inactive";
	    /** Grid container page is active. */
	    PageActivationStatus[PageActivationStatus["Active"] = 2] = "Active";
	})(PageActivationStatus || (PageActivationStatus = {}));
	/**
	 * Synchronize EditGrid updates with its bound element.
	 */
	var EditGridController = (function () {
	    function EditGridController(element, viewModel) {
	        var _this = this;
	        this.viewModel = ko.unwrap(viewModel);
	        if (!(this.viewModel instanceof editGrid_1.EditGrid)) {
	            throw new Error("viewModel must be an EditGrid instance");
	        }
	        this.$editGrid = $(".ko-editgrid", element);
	        if (this.$editGrid.length !== 1) {
	            throw new Error("Expected exactly one \".ko-editgrid\" element but found " + this.$editGrid.length);
	        }
	        this.$confirmationPanel = $(".ko-editgrid-confirm", element);
	        if (this.$confirmationPanel.length !== 1) {
	            throw new Error("Expected exactly one \".ko-editgrid-confirm\" element but found " + this.$confirmationPanel.length);
	        }
	        this.$editGridEmpty = $(".ko-editgrid-empty", element);
	        if (this.$editGridEmpty.length !== 1) {
	            throw new Error("Expected exactly one \".ko-editgrid-empty\" element but found " + this.$editGridEmpty.length);
	        }
	        this.$editPanel = $(".ko-editgrid-panel", element);
	        if (this.$editPanel.length !== 1) {
	            throw new Error("Expected exactly one \".ko-editgrid-panel\" element but found " + this.$editPanel.length);
	        }
	        this.viewModel._registerAction("FocusField", this._focusField, this);
	        this.viewModel._registerAction("FocusNext", this._focusNext, this);
	        this.viewModel._registerAction("MoveNextAndFocus", function () {
	            _this.viewModel.apply({ action: "MoveNext" });
	            _this._focusFirst(false);
	            _this._ensureSelected();
	            return false;
	        });
	        this.viewModel._registerAction("MovePreviousAndFocus", function () {
	            _this.viewModel.apply({ action: "MovePrevious" });
	            _this._focusFirst(false);
	            _this._ensureSelected();
	            return false;
	        });
	        pli.keys.registerKeymap(this.viewModel.id, this.viewModel.keyMap);
	        this._disposables = new disposable_1.CompositeDisposable(this.viewModel.active.subscribe(this._onActivated, this), this.viewModel.dirty.subscribe(this._onDirtyChanged, this), this.viewModel.currentItems.subscribe(function (_) { return _this._focusFirst(true); }, this), pli.forms.crumbs.subscribe(this._onCrumbsChanging, this, "changing"), pli.forms.crumbs.subscribe(this._onCrumbsChanged, this));
	        // Find navigation page that contains this grid
	        this.page = null;
	        var $page = $(element).closest("[data-pli-navigation-page]");
	        if ($page.length === 1) {
	            this.page = $page.data("pliNavigationPage");
	            if (!this.page || this.page.$page[0] !== $page[0]) {
	                throw new Error("Invalid Pli navigation page.");
	            }
	        }
	        if (this.page) {
	            // Subscribe to pliDeactivating to handle hash changes triggered by
	            // "closeForm". This path notifies crumb changes _after_ deactivating
	            // the keymap, so we need to deactivate ours in the event handler, which
	            // is triggered before the keymap deactivation.
	            this._disposables.add(Rx.Observable
	                .fromEvent($page, "pliDeactivating")
	                .subscribe(function (e) { return _this.viewModel.apply({ active: false }); }));
	        }
	        else {
	            console.warn("EditGrid \"" + this.viewModel.id + "\" not part of navigation page hierarchy; automatic activation/deactivation will be disabled.");
	        }
	        // seed with current values
	        this._onDirtyChanged(this.viewModel.dirty.peek());
	    }
	    /**
	     * Cleans up the controller binding, removing the viewmodel and disposing subscriptions.
	     */
	    EditGridController.prototype.dispose = function () {
	        if (this.viewModel.active.peek()) {
	            this.viewModel.apply({ active: false });
	        }
	        pli.keys.unregisterKeymap(this.viewModel.id);
	        this._disposables.dispose();
	        this.viewModel = null;
	    };
	    /**
	     * If the currently focused field is not selected, select its text.
	     */
	    EditGridController.prototype._ensureSelected = function () {
	        this.$editPanel.find(":focus").select();
	    };
	    /**
	     * Focuses the nth tabbable input in the edit panel.
	     * @param index
	     *     Zero-based index of the input to focus.
	     * @param e
	     *     JQuery key event object.
	     * @return
	     *     False to prevent event bubbling.
	     */
	    EditGridController.prototype._focusField = function (index, e) {
	        if (e) {
	            e.preventDefault();
	        }
	        this.$editPanel.find(":tabbable").eq(index).focus().select();
	        return false;
	    };
	    /**
	     * Focuses the first input in the edit panel if current focus is outside the panel and not another input.
	     */
	    EditGridController.prototype._focusFirst = function (respectCurrentFocus) {
	        if (respectCurrentFocus === void 0) { respectCurrentFocus = true; }
	        var editPanelHasFocus = this.$editPanel.find(":focus").length > 0;
	        var anotherInputHasFocus = document.activeElement && document.activeElement.tagName.toLowerCase() === "input";
	        if (!editPanelHasFocus && !(respectCurrentFocus && anotherInputHasFocus)) {
	            this._focusField(0);
	        }
	    };
	    /**
	     * Focuses the next tabbable input in the edit panel.
	     * @param e
	     *     JQuery key event object.
	     * @return
	     *     True if the event should bubble up; false otherwise.
	     */
	    EditGridController.prototype._focusNext = function (e) {
	        var focusSinks = this.$editGrid.children("[hidefocus]");
	        var focusSink1 = focusSinks.first()[0];
	        var focusSink2 = focusSinks.last()[0];
	        if (focusSink1 === document.activeElement ||
	            focusSink2 === document.activeElement) {
	            return this._focusField(0, e);
	        }
	        else if ($(document.activeElement).is(":text")) {
	            e.preventDefault();
	            var activeInput = $(document.activeElement);
	            $(document.activeElement).blur();
	            var tabbableInputs = this.$editPanel.find(":input:tabbable");
	            var nextIndex = tabbableInputs.index(activeInput) + 1;
	            if (nextIndex >= tabbableInputs.length) {
	                nextIndex = 0;
	            }
	            tabbableInputs.eq(nextIndex).focus().select();
	            return false;
	        }
	        return true;
	    };
	    /**
	     * Returns the activation status for the grid container page.
	     *
	     * Grid is considered active if the last crumb page contains this
	     * grid or is a child of the grid page and has "keepGridActive": "true".
	     */
	    EditGridController.prototype._getPageActivationStatus = function (crumbs) {
	        if (!this.page) {
	            return PageActivationStatus.Unknown;
	        }
	        var crumb = crumbs.end;
	        while (crumb) {
	            if (this.page === crumb.page) {
	                return PageActivationStatus.Active;
	            }
	            if (!crumb.page.keepGridActive) {
	                return PageActivationStatus.Inactive;
	            }
	            crumb = crumb.previous;
	        }
	        return PageActivationStatus.Inactive;
	    };
	    /*
	     * Toggles keymap activation when the grid becomes active/inactive.
	     * @param isActive
	     *     True if the grid is now active; false if inactive.
	     */
	    EditGridController.prototype._onActivated = function (isActive) {
	        if (isActive) {
	            pli.keys.activateKeymap(this.viewModel.id);
	        }
	        else {
	            pli.keys.deactivateKeymap(this.viewModel.id);
	        }
	    };
	    /**
	     * Deactivates the grid if the new URL will not point to a page containing this grid.
	     */
	    EditGridController.prototype._onCrumbsChanging = function (crumbs) {
	        if (this._getPageActivationStatus(crumbs) === PageActivationStatus.Inactive) {
	            this.viewModel.apply({ active: false });
	        }
	    };
	    /**
	     * Activates the grid if the current URL does point to a page containing this grid.
	     */
	    EditGridController.prototype._onCrumbsChanged = function (crumbs) {
	        if (this._getPageActivationStatus(crumbs) === PageActivationStatus.Active) {
	            var focusedItem = this.viewModel.focusedItem() || this.viewModel.items()[0];
	            var selectedItems = this.viewModel.selectedItems() || [];
	            this.viewModel.apply({
	                active: true,
	                focusedItem: focusedItem,
	                selectedItems: selectedItems
	            });
	        }
	    };
	    /**
	     * Slide confirmation panel in/out when the dirty state changes.
	     */
	    EditGridController.prototype._onDirtyChanged = function (dirty) {
	        var translate = (dirty
	            ? ["0px", "50px"]
	            : ["50px", "0px"]);
	        var opacity = (dirty
	            ? [1, 0, "linear"]
	            : [0, 1, "linear"]);
	        this.$confirmationPanel.velocity({
	            properties: { translateY: translate, opacity: opacity },
	            options: {
	                duration: 500,
	                easing: "easeOutSine",
	                delay: 250
	            }
	        });
	    };
	    return EditGridController;
	}());
	/**
	 * Retrieves the EditGridController instance from the given element.
	 */
	function requireController(element) {
	    var controller = (element && element[elementKey]);
	    if (!controller) {
	        throw new Error("Target element has not been bound using \"editgrid\" binding");
	    }
	    return controller;
	}
	/**
	 * Binding handler 'init' function for EditGrid binding.
	 */
	function init(element, valueAccessor) {
	    var viewModel = ko.unwrap(valueAccessor());
	    var controller = new EditGridController(element, viewModel);
	    knockoutGridBinding_1.init(controller.$editGrid[0], function () { return viewModel._grid; });
	    // Relocate confirmation panel to inside the grid container to simplify
	    // the "slide-in"/"slide-out" animation (uses overflow property of
	    // the grid container to obscure panel as it slides up/down).
	    // Slickgrid rewrites the contents of the container when it is initialized,
	    // so this must be called _after_ koGridInit.
	    controller.$editGrid.append(controller.$confirmationPanel.detach());
	    element[elementKey] = controller;
	}
	exports.init = init;
	/**
	 * Binding handler 'update' function for EditGrid binding.
	 */
	function update(element, valueAccessor) {
	    var viewModel = ko.unwrap(valueAccessor());
	    var controller = requireController(element);
	    // Relocate confirmation panel back out of the grid container because
	    // 1) the grid *may* be re-initialized in the call to koGridUpdate; and
	    // 2) we might create a new EditGridController instance, which expects
	    // the panel to be a child of "element"
	    $(element).append(controller.$confirmationPanel.detach());
	    if (controller.viewModel !== viewModel) {
	        controller.dispose();
	        controller = new EditGridController(element, viewModel);
	        element[elementKey] = controller;
	    }
	    knockoutGridBinding_1.update(controller.$editGrid[0], function () { return viewModel._grid; });
	    // Relocate confirmation panel back inside the grid container
	    // (see comment in "init").
	    controller.$editGrid.append(controller.$confirmationPanel.detach());
	    ko.bindingHandlers.visible.update(controller.$editGrid[0], function () { return ko.pureComputed(function () { return viewModel.filteredItems().length > 0; }); });
	    ko.bindingHandlers.visible.update(controller.$confirmationPanel[0], function () { return ko.pureComputed(function () { return viewModel.dirty(); }); });
	    ko.bindingHandlers.visible.update(controller.$editGridEmpty[0], function () { return ko.pureComputed(function () { return viewModel.filteredItems().length === 0; }); });
	    ko.bindingHandlers.visible.update(controller.$editPanel[0], function () { return ko.pureComputed(function () { return viewModel.filteredItems().length > 0; }); });
	}
	exports.update = update;
	



/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Comment Delete Form class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	// View model for comment delete confirmation dialog
	function CommentDeleteForm(form) {
	
	    if (!form) { throw new Error("Comment delete form is not defined"); }
	
	    this.form = form;
	    this.open = CommentDeleteForm.prototype.open.bind(this);
	}
	
	
	//-------------------------------------------
	// Opens the comment delete confirmation dialog
	CommentDeleteForm.prototype.open = function open(deleteComment) {
	    if (typeof deleteComment !== "function") { throw new Error("deleteComment should be function"); }
	
	    this._deleteComment = deleteComment;
	
	    // bind the form if it is not already
	    if (!this.isBound) {
	        ko.applyBindings(this, this.form.$form[0]);
	        this.isBound = true;
	    }
	
	    // show the inline form
	    pli.forms.open(this.form.id);
	
	    return false; // prevent default behaviour
	};
	
	//---------------------------------------
	CommentDeleteForm.prototype.cancel = function cancel() {
	    this.form.close();
	};
	
	//---------------------------------------
	CommentDeleteForm.prototype.deleteConfirm = function deleteConfirm() {
	    this.form.close();
	    this._deleteComment();
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	// Get delete comment form
	var deleteForm = pli.forms.registry.deleteCommentForm;
	if (!deleteForm) {
	    throw new Error("Comment delete form is not found. Did you create it with CreateCommentDeleteConfirmationForm() method?");
	}
	
	// Create and set viewModel
	if (!deleteForm.viewModel) {
	    deleteForm.viewModel = new CommentDeleteForm(deleteForm);
	    deleteForm.open = deleteForm.viewModel.open;
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	module.exports = CommentDeleteForm;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(568);
	__webpack_require__(569);


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	var picklistItemExtensions = __webpack_require__(498);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// ContactViewModel
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	
	function ContactViewModel(form) {
	    this.initPicklistItem("Geo-Contact-", form);
	
	    this.code = this.id = pliObservable(null, null, "required");
	    this.isCompany = ko.observable(false);
	    this.isLessor = ko.observable(false);
	    this.fullName = pliObservable();
	    this.gst = pliObservable();
	    this.energyLinkPartner = pliObservable();
	    this.phone = pliObservable();
	    this.mobile = pliObservable();
	    this.fax = pliObservable();
	    this.email = pliObservable();
	    this.accountingCode = pliObservable();
	    this.bankFee = pliObservable(null, "C2", "numeric");
	    this.withholdingPercentage = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric");
	    this.currency = pliObservable(null, dataCache.getObservable("currency"), "picklist");
	    this.depositorySameAsMailing = ko.observable(false);
	    this.isOwner = ko.observable(false);
	    this.useInNetCalcs = ko.observable(false);
	    this.qbytePartner = pliObservable();
	    this.mailingAddress = {
	        guid: ko.observable(),
	        address: pliObservable(),
	        attention: pliObservable()
	    };
	
	    this.depositoryAddress = {
	        guid: ko.observable(),
	        address: pliObservable(),
	        attention: pliObservable()
	    };
	
	    this.savedAddress = "";
	    this.savedAttention = "";
	
	    //this.depositoryAddress.attentionComputed = ko.computed()
	
	    this.updateDepositoryFromCheckbox = function () {
	        if (this.depositorySameAsMailing()) {
	            this.savedAddress = this.depositoryAddress.address();
	            this.savedAttention = this.depositoryAddress.attention();
	            this.depositoryAddress.address(this.mailingAddress.address());
	            this.depositoryAddress.attention(this.mailingAddress.attention());
	        } else {
	            this.depositoryAddress.address(this.savedAddress);
	            this.depositoryAddress.attention(this.savedAttention);
	            this.savedAddress = "";
	            this.savedAttention = "";
	        }
	        return true;
	    };
	
	    this.extras.displayName = ko.computed(ContactViewModel.prototype._computeDisplayName, this);
	    this.useSaveDialog = true;
	}
	
	
	//-------------------------------------------
	ContactViewModel.prototype.fromCacheItem = function contactFromCacheItem(item) {
	    var record;
	    if (item && item.length) { // Handle array item (existing contact)
	        record = {
	            guid: item[item.length - 1],
	            code: item[0],
	            isLessor: (item[1] === "LESSOR" || item[1] === "BOTH"),
	            isCompany: (item[1] === "COMPANY" || item[1] === "BOTH"),
	            fullName: item[2],
	            phone: item[3],
	            fax: item[4],
	            isOwner: item[5],
	            useInNetCalcs: item[6]
	        };
	        this.extras.state("loading");
	    } else if (item && item.guid) { // Handle object item (existing contact)
	        record = item;
	        this.extras.state("loading");
	    } else { // Handle new contact
	        record = null;
	    }
	
	    return record;
	};
	
	
	//-------------------------------------------
	ContactViewModel.prototype.load = function loadContact(record) {
	    record = record || {};
	
	    this.code.reset();
	    this.fullName.reset();
	    this.gst.reset();
	    this.energyLinkPartner.reset();
	    this.phone.reset();
	    this.mobile.reset();
	    this.fax.reset();
	    this.email.reset();
	    this.accountingCode.reset();
	    this.bankFee.reset();
	    this.withholdingPercentage.reset();
	    this.currency.reset();
	    this.mailingAddress.attention.reset();
	    this.depositoryAddress.attention.reset();
	    this.qbytePartner.reset();
	
	    this.guid(record.guid || null);
	    this.code.load(record.code);
	    this.isCompany(!!record.isCompany);
	    this.isLessor(!!record.isLessor);
	    this.fullName.load(record.fullName);
	    this.gst.load(record.gst);
	    this.energyLinkPartner.load(record.energyLinkPartner);
	    this.phone.load(record.phone);
	    this.mobile.load(record.mobile);
	    this.fax.load(record.fax);
	    this.email.load(record.email);
	    this.accountingCode.load(record.accountingCode);
	    this.bankFee.load(record.bankFee);
	    this.withholdingPercentage.load(record.withholdingPercentage);
	    this.currency.load(record.currency === "CAN" ? "CDN" : record.currency);
	    this.depositorySameAsMailing(!!record.depositorySameAsMailing);
	    this.mailingAddress.address.load(record.mailingAddress && record.mailingAddress.address);
	    this.mailingAddress.attention.load(record.mailingAddress && record.mailingAddress.attention);
	    this.isOwner(!!record.isOwner);
	    this.useInNetCalcs(!!record.useInNetCalcs);
	    this.qbytePartner.load(record.qbytePartner);
	    if (this.depositorySameAsMailing()) {
	        this.savedAddress = "";
	        this.savedAttention = "";
	        this.depositoryAddress.address.load(this.mailingAddress.address());
	        this.depositoryAddress.attention.load(this.mailingAddress.attention());
	    } else {
	        this.depositoryAddress.address.load(record.depositoryAddress && record.depositoryAddress.address);
	        this.depositoryAddress.attention.load(record.depositoryAddress && record.depositoryAddress.attention);
	    }
	};
	
	
	//-------------------------------------------
	ContactViewModel.prototype._computeDisplayName = function computeContactDisplayName() {
	    var code = this.code();
	    return (code ? "Contact ".concat(code) : "(No contact code yet)");
	};
	
	
	//-------------------------------------------
	ContactViewModel.prototype.acquire = function acquire() {
	    pli.forms.registry.contactAcquireForm.viewModel.open(this.id());
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	var contactForm = pli.forms.registry.contactForm;
	
	if (typeof contactForm !== "object") { throw new Error("Contact form element could not be found - did you render it using CreateContactForm?"); }
	if (contactForm.viewModel) { throw new Error("Contact form has already been initialized"); }
	
	ko.utils.extend(ContactViewModel.prototype, picklistItemExtensions.mixins);
	contactForm.viewModel = new ContactViewModel(contactForm);
	
	entityRegistry.contact.open.create = entityRegistry.contact.open.edit = contactForm.viewModel.open;
	entityRegistry.contact.getPicklistBehaviourData = function getPicklistBehaviourData() {
	    return {
	        onNewItem: contactForm.viewModel.open,
	        onOpenItem: contactForm.viewModel.open,
	        picklistData: dataCache.getObservable("contact")
	    };
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = ContactViewModel;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	"use strict";
	
	var $ = __webpack_require__(1);
	var clientBroadcastManager = __webpack_require__(477);
	var ko = __webpack_require__(457);
	var picklistBehaviour = __webpack_require__(25);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	var viewModelInit = __webpack_require__(465);
	
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	
	__webpack_require__(568);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Private
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function filterPicklist(pickListData, filter) {
	    /// <summary>
	    /// Filters picklist data items
	    /// </summary>
	
	    if (!pickListData || !pickListData.items) { throw new Error("picklistData is expected to be an pickListData object"); }
	    if (typeof filter !== "function") { throw new Error("filterPicklist is expected to be a function"); }
	
	    var group, ind, i, j, item, index, newItems = [],
	        data = $.extend(true, {}, pickListData),
	        newIndices = $.extend(true, {}, data.indices);
	
	    // clear lenght of groups
	    for (group in data.groups) {
	        if (data.groups.hasOwnProperty(group)) {
	            for (i = 0; i < data.groups[group].length; i += 1) {
	                data.groups[group][i].length = 0;
	            }
	        }
	    }
	
	    // filter data items
	    for (i = 0; i < data.items.length; i += 1) {
	
	        item = data.items[i];
	        item.dataIndex = newItems.length + 1; // update item dataIndex
	
	        if (filter(item)) {
	            // add new item
	            newItems.push(item);
	
	            // fix group length
	            for (group in data.groups) {
	                if (data.groups.hasOwnProperty(group)) {
	                    for (j = 0; j < data.groups[group].length; j += 1) {
	                        if (item[group] === data.groups[group][j].name) {
	                            data.groups[group][j].length += 1;
	                        }
	                    }
	                }
	            }
	
	            // change indicies
	            for (ind in data.indices) {
	                if (data.indices.hasOwnProperty(ind)) {
	                    index = ko.utils.arrayIndexOf(newIndices[ind], i);
	                    if (index >= 0) {
	                        newIndices[ind][index] = newItems.length - 1;
	                    }
	                }
	            }
	        } else {
	            // remove indicies
	            for (ind in data.indices) {
	                if (data.indices.hasOwnProperty(ind)) {
	                    index = ko.utils.arrayIndexOf(newIndices[ind], i);
	                    if (index >= 0) {
	                        newIndices[ind].splice(index, 1);
	                    }
	                }
	            }
	        }
	    }
	
	    // set filterd items and inicies
	    data.items = newItems;
	    data.indices = newIndices;
	    data.count = newItems.length;
	
	    return data;
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// ContactAcquireDetailsViewModel
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function ContactAcquireDetailViewModel() {
	    this.id = ko.observable();
	    this.code = ko.observable();
	    this.mainContactValue = ko.observable();
	    this.acquireContactValue = ko.observable();
	}
	
	//-------------------------------------------
	ContactAcquireDetailViewModel.prototype.loadViewModel = function loadContactAcquireDetailViewModel(record) {
	    this.id(record.id || "");
	    this.code(record.code);
	    this.mainContactValue(record.mainContactValue);
	    this.acquireContactValue(record.acquireContactValue);
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// ContactAcquireViewModel
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function ContactAcquireViewModel(form, factories) {
	
	    this.contact = pliObservable(null, dataCache.getObservable("contact"), picklistBehaviour, "required"); // main contact
	    this.acquireContact = pliObservable(null, ko.observable({ picklistData: entityRegistry.contact.getPicklistBehaviourData().picklistData().data }), picklistBehaviour, "required"); // acquire contact
	    this.removeAfterAcquire = ko.observable(false);
	    this.remark = pliObservable(null); // acquire remark
	
	    // private actions
	    this._updateUsagesCount = ContactAcquireViewModel.prototype._updateUsagesCount.bind(this);
	    this._acquireCompleteHandler = ContactAcquireViewModel.prototype._acquireCompleteHandler.bind(this);
	    this._exportingStartHandler = ContactAcquireViewModel.prototype._exportingStartHandler.bind(this);
	    this._exportingStatusUpdateHandler = ContactAcquireViewModel.prototype._exportingStatusUpdateHandler.bind(this);
	
	    // non-serialized properties
	    this.extras = function ContactAcquireViewModelExtras() { return; };
	    this.extras.form = form;
	    this.extras.state = ko.observable("ready");
	    this.extras.displayName = ko.observable();
	    this.extras.values = factories.details.createObservableArray(); // details list
	    this.extras.usagesCount = ko.observable(0); // usages count
	    this.extras.errorsCount = ko.observable(0); // validation errors count
	    this.extras.acquiresLabel = ko.observable("Acquires");
	    this.extras.showInfoMessage = ko.observable(false);
	    this.extras.oldAcquireContact = ko.observable("Contact");
	
	    this.extras.progressMessage = ko.computed(ContactAcquireViewModel.prototype._getProgressMessage, this);
	    this.extras.progressIconClass = ko.computed(ContactAcquireViewModel.prototype._getProgressIconClass, this);
	
	    // subscriptions
	    this.extras._contactChanged = this.contact.item.subscribe(ContactAcquireViewModel.prototype._contactChanged, this);
	    this.extras._acquireContactChanged = this.acquireContact.subscribe(ContactAcquireViewModel.prototype._updateInfo, this);
	
	    // register keymap
	    pli.keys.registerKeymap(this.extras.form.id,
	        ko.utils.extend(
	            ko.utils.extend({}, pli.config.defaultKeymap),
	            {
	                "Close": this.close
	            }
	        ));
	    this.extras.form.page.keymap = this.extras.form.id;
	}
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype.init = function initContactAcquireViewModel(contact) {
	    /// <summary>
	    /// Sets initial values
	    /// </summary>
	
	    // set main contact
	    this.contact(contact);
	
	    this.reset();
	};
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype.reset = function resetContactAcquireViewModel() {
	    /// <summary>
	    /// Reset view
	    /// </summary>
	
	    // default values
	    this.removeAfterAcquire(false);
	    this.remark(null);
	
	    // reset acquire contact
	    this.acquireContact.reset();
	
	    // set status
	    this.extras.state("ready");
	};
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype.open = function openContactAcquireViewModel(contact) {
	    /// <summary>
	    /// Opens acquire contact form
	    /// </summary>
	
	    this.init(contact);
	
	    // bind the form if it is not already
	    if (!this.isBound) {
	        ko.applyBindings(this, this.extras.form.$form[0]);
	        this.isBound = true;
	    }
	
	    // show the inline form
	    pli.forms.open(this.extras.form.id);
	
	    return false;// prevent default behaviour
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype.close = function closeContactAcquireViewModel(force) {
	    /// <summary>
	    /// Closes form if the form is
	    /// not busy (unless forced).
	    /// </summary>
	
	    if (force || this.extras.state().indexOf("active") < 0) {
	        // Reset info message
	        this.extras.oldAcquireContact("Contact");
	        this.extras.showInfoMessage(false);
	
	        pli.forms.close(this.extras.form.id);
	    }
	    return false; // prevent default behaviour
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype.loadUsages = function loadUsagesContactAcquireViewModel() {
	    this.extras.state("selected.active");
	    pli.call({
	        name: "Geo-Contact-GetUsagesCount",
	        data: { contact: this.acquireContact() }
	    }).always(this._updateUsagesCount);
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype.acquire = function acquireContactAcquireViewModel() {
	    /// <summary>
	    /// Acquire contacts
	    /// </summary>
	    this.extras.state("acquisition.active");
	    pli.call({
	        name: "Geo-Contact-Acquire",
	        jsonData: ko.toJSON(this)
	    }).always(this._acquireCompleteHandler);
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype.exportUsages = function exportUsagesContactAcquireViewModel() {
	    /// <summary>
	    /// Exports usages
	    /// </summary>
	    this.extras.state("exporting.active");
	    pli.call({
	        name: "Geo-Report-Start",
	        data: { reportId: "ContactUsages", reportData: this.acquireContact() }
	    }).always(this._exportingStartHandler);
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype._contactChanged = function contactChangedContactAcquireViewModel(contactItem) {
	
	    this.extras.acquiresLabel(contactItem ? contactItem[0] + " acquires" : "Acquires");
	
	    if (contactItem) {
	        // filter list of contacts to exclude
	        var contactPicklist = dataCache.getObservable("contact"),
	            data = filterPicklist(contactPicklist().data, function (item) {
	                return item[0] !== contactItem[0];
	            });
	
	        // update picklistData
	        this.acquireContact.behaviourData().data = data;
	        this.acquireContact.behaviourData.valueHasMutated();
	
	        // update info
	        this._updateInfo();
	    }
	};
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype._updateInfo = function updateInfoContactAcquireViewModel() {
	    /// <summary>
	    /// Updates information about contact and acquire contact
	    /// </summary>
	
	    // set display name
	    this.extras.displayName(this.contact().concat(" acquires ").concat(this.acquireContact() || "..."));
	
	    if (this.acquireContact()) {
	        // new contact selected, hide info message
	        this.extras.showInfoMessage(false);
	
	        var contactItem = this.contact.item() || new Array(7),
	            acquireItem = this.acquireContact() ? this.acquireContact.item() : new Array(7);
	
	        // set values grid data
	        this.extras.values.loadViewModel([
	            { code: "Description", mainContactValue: contactItem[2], acquireContactValue: acquireItem[2] },
	            { code: "Phone", mainContactValue: contactItem[3], acquireContactValue: acquireItem[3] },
	            { code: "Fax", mainContactValue: contactItem[4], acquireContactValue: acquireItem[4] },
	            { code: "Type", mainContactValue: contactItem[1], acquireContactValue: acquireItem[1] }
	        ]);
	
	        // if acquire contact is selected - load usages count
	        this.loadUsages();
	    } else {
	        this.extras.state("ready");
	    }
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype._getProgressMessage = function getProgressMessageContactAcquireViewModel() {
	
	    switch (this.extras.state()) {
	    case "exporting.active":
	        return "Generating file with usages of " + this.acquireContact() + "...";
	    case "selected.active":
	        return "Loading usages of " + this.acquireContact() + "...";
	    case "selected.error":
	        return "Failed to load usages of " + this.acquireContact();
	    case "selected.done":
	        return (this.extras.usagesCount() > 0 ? this.extras.usagesCount() : "No") + " usages of " + this.acquireContact() + " found";
	    case "selected.validationError":
	        return (this.extras.usagesCount() > 0 ? this.extras.usagesCount() : "No") + " usages of " + this.acquireContact() + " found "
	                + (this.extras.errorsCount() > 0 ? "but " + this.extras.errorsCount() + " validation error(s) exist." : "");
	    case "acquisition.active":
	        return this.contact() + " is acquiring " + this.acquireContact() + "...";
	    case "acquisition.error":
	        return "Failed to acquire " + this.acquireContact();
	    case "acquisition.done":
	        return this.contact() + " successfully acquired " + this.acquireContact();
	    default:
	        return "";
	    }
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype._getProgressIconClass = function getProgressIconClassContactAcquireViewModel() {
	
	    switch (this.extras.state()) {
	    case "selected.active":
	    case "acquisition.active":
	    case "exporting.active":
	        return "sprite-progress-15 sprite-spin";
	    case "selected.error":
	    case "acquisition.error":
	    case "exporting.error":
	        return "sprite-warning-16";
	    case "selected.validationError":
	        return "sprite-x-16";
	    case "selected.done":
	    case "acquisition.done":
	    case "exporting.done":
	        return "sprite-checked-16";
	    default:
	        return "";
	    }
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype._acquireCompleteHandler = function acquireCompleteHandlerContactAcquireViewModel(response) {
	    /// <summary>
	    /// Handles acquire process completness
	    /// </summary>
	    if (response.isError) {
	        this.extras.state("acquisition.error");
	    } else {
	        this.extras.state("acquisition.done");
	        if (this.removeAfterAcquire()) {
	            this.extras.oldAcquireContact(this.acquireContact());
	            this.reset();
	            this.extras.showInfoMessage(true);
	        }
	    }
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype._exportingStartHandler = function exportingeStartHandlerContactAcquireViewModel(response) {
	    /// <summary>
	    /// Handles exporting process start
	    /// </summary>
	    if (response.isError) {
	        this.extras.state("exporting.error");
	    } else {
	        if (response.result) {
	            // set token
	            this.extras.exportToken = response.result.token;
	            // subscribe
	            clientBroadcastManager.onUpdated(this._exportingStatusUpdateHandler);
	        }
	    }
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype._exportingStatusUpdateHandler = function exportingStartHandlerContactAcquireViewModel(result) {
	    /// <summary>
	    /// Handles export status change
	    /// </summary>
	    if (result.data && result.data.token === this.extras.exportToken) {
	        if (result.data.status === 2) { // completed
	            if (this.extras.errorsCount() > 0) {
	                this.extras.state("selected.validationError");
	            } else {
	                this.extras.state("selected.done"); // set status to ready to acquire again
	            }
	            window.location = pli.resolveUrl("~/Reports/Download/" + this.extras.exportToken + "?forceDownload=true"); // force download the file
	        } else if (result.data.status === 4) { // failed
	            this.extras.state("exporting.error");
	        }
	
	        if (result.data.status !== 1) { // status is not generating anymore - unsubscribe from BroadcastManager messages
	            clientBroadcastManager.offUpdated(this._exportingStatusUpdateHandler);
	        }
	    }
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype._updateUsagesCount = function updateUsagesCountContactAcquireViewModel(response) {
	    /// <summary>
	    /// Updates usages count
	    /// </summary>
	    if (response.isError || response.result === undefined) {
	        this.extras.state("selected.error");
	    } else {
	        this.extras.usagesCount(response.result.usagesCount);
	        if (response.result.errorsCount) {
	            this.extras.errorsCount(response.result.errorsCount);
	            this.extras.state("selected.validationError");
	        } else if (this.extras.state() === "selected.active") { // change the state to done only if state is active
	            this.extras.state("selected.done");
	        }
	    }
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype.resolveContainerCssWithState = function resolveContainerCssWithStateForPicklist() {
	    /// <summary>
	    /// Computes composite container CSS by combining
	    /// base CSS (_containerCss) with one CSS class
	    /// per state segment (i.e. "my.segmented.value"
	    /// would produce "withStateMy", "withStateSegmented",
	    /// "withStateValue").
	    /// </summary>
	    //-------------------------------------------
	    var i, l,
	        stateItems = this.extras.state().split(".");
	    for (i = 0, l = stateItems.length; i < l; i += 1) {
	        stateItems[i] = "withState".concat(stateItems[i][0].toUpperCase(), stateItems[i].substring(1));
	    }
	    return stateItems.join(" ");
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype.isAcquireEnabled = function isAcquireEnabledContactAcquireViewModel() {
	    return this.extras.state() !== 'ready'
	        && this.extras.state() !== 'acquisition.active'
	        && this.extras.state() !== 'exporting.active'
	        && this.extras.state() !== 'acquisition.done'
	        && this.extras.state() !== 'selected.validationError'
	        && this.extras.state() !== 'selected.active';
	};
	
	
	//-------------------------------------------
	ContactAcquireViewModel.prototype.isAcquiring = function isAcquiringContactAcquireViewModel() {
	    return this.extras.state() === 'acquisition.active'
	        || this.extras.state() === 'exporting.active'
	        || this.extras.state() === 'acquisition.done';
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	// find contact acquire form
	var contactAcquireForm = pli.forms.registry.contactAcquireForm;
	if (contactAcquireForm === null || typeof contactAcquireForm !== "object") { throw new Error("Acquire Contact form element could not be found - did you render it using CreateContactAcquireForm?"); }
	
	// factories
	viewModelInit.createContactAcquireFactories = function createContactAcquireFactories() {
	    return {
	        details: viewModelInit.createGridViewModelFactory({ computeErrorsCount: viewModelInit.computeErrorsCount }, ContactAcquireDetailViewModel, null, 2)
	    };
	};
	
	// set contact Acquire form viewModel
	contactAcquireForm.viewModel = new ContactAcquireViewModel(contactAcquireForm, viewModelInit.createContactAcquireFactories(contactAcquireForm.id));
	contactAcquireForm.open = contactAcquireForm.viewModel.open;
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = ContactAcquireViewModel;


/***/ }),
/* 570 */,
/* 571 */,
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var ko = __webpack_require__(457);
	
	//-------------------------------------------
	function createErrorsSummaryObservable(pages) {
	    /// <summary>
	    /// Create dependable observable for errors tool tip
	    /// </summary>
	    /// <param name="pages">The array to fire if allowed</param>
	    if (Array.isArray(pages) && pages.map(function (item) {
	            if (item) {
	                if (!item.page || !item.page.title) {
	                    throw new Error("item.page with title property is required");
	                }
	                if (!item.errors || !ko.isObservable(item.errors)) {
	                    throw new Error("item.errors observable is required");
	                }
	            }
	        })) {
	        return ko.computed(function () {
	            return pages.filter(function (item) {
	                return item && item.errors() > 0;
	            }).map(function (item) {
	                return { name: item.page.title, hash: item.page.activationHash, count: item.errors() };
	            });
	        });
	    }
	}
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Export
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = {
	    createErrorsSummaryObservable: createErrorsSummaryObservable
	};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(574);


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var ko = __webpack_require__(457);
	var pliObservable = __webpack_require__(15);
	
	var entityRegistry = __webpack_require__(492);
	var selectionForm = __webpack_require__(520);
	var viewModelInit = __webpack_require__(532);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Provision class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function Provision(factories) {
	    /// <summary>
	    /// Define viewmodel.
	    /// </summary>
	    if (window.console && window.console.group) { window.console.log("Provision.ctor", factories); }
	
	    // serializable properties
	    this.guid = ko.observable(null);
	    this.type = this.id = pliObservable(null, entityRegistry.provisionType.getPicklistBehaviourData(), "required", "picklist");
	    this.applicable = ko.observable(false);
	    this.numDays = pliObservable(null, "N0", "numeric");
	    this.otherData = pliObservable();
	    this.page = pliObservable();
	    this.paragraph = pliObservable();
	    this.comments = pliObservable();
	
	    // non-serializable properties
	    this.extras = function ProvisionExtras() { return; };
	    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);
	
	    this.extras.description = ko.computed(function () {
	        var provisionItem = this.type.item();
	        return provisionItem ? provisionItem[1] : "";
	    }, this);
	}
	
	
	//---------------------------------------
	Provision.prototype.initGridArray = function initProvisionGridArray(gridArray) {
	    /// <summary>
	    /// Add extra methods to the specified
	    /// terms grid array (that has just
	    /// been created).
	    /// </summary>
	    gridArray.copyItems = gridArray.factory.factories.secureAction(Provision.prototype._copyItems, gridArray);
	    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray);
	    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);
	};
	
	
	//-------------------------------------------
	Provision.prototype.loadViewModel = function loadProvision(record) {
	    if (window.console && window.console.group) { window.console.log("Provision.loadViewModel", record); }
	
	    if (!record) { record = {}; }
	
	    this.guid(record.guid || null);
	    this.type.load(record.type);
	    this.applicable(record.applicable || false);
	    this.numDays.load(record.numDays);
	    this.otherData.load(record.otherData);
	    this.page.load(record.page);
	    this.paragraph.load(record.paragraph);
	    this.comments.load(record.comments);
	};
	
	
	//-------------------------------------------
	Provision.prototype._copyItems = function copyProvisions() {
	    /// <summary>
	    /// Show selection form that allows users
	    /// to find and copy provision to this array.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores provisions.
	    /// </remarks>
	    selectionForm.open({
	        searchApi: "Geo-Document-SearchProvisions",
	        multiSelect: true,
	        text: {
	            acceptButton: "Copy",
	            iconClass: "sprite-copy-16",
	            instructionHtml:
	                "The search phrase can be a combination of file numbers, areas or lands.<br/>" +
	                "To copy all provisions from a specific file to the current file:" +
	                "<ol><li>Type in a search phrase</li><li>Click <strong>Search</strong></li><li>Press <strong>Ctrl+A</strong> to select all results</li><li>Click <strong>Copy</strong></li></ol>",
	            title: "Copy Provisions",
	            examples: [
	                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
	            ]
	        },
	        onAcceptedContext: this,
	        onAccepted: function (newProvisionRows) {
	            selectionForm.utils.pushRowItems({
	                targetArray: this,
	                records: newProvisionRows,
	                rowMap: { type: 3, applicable: 4, numDays: 5, otherData: 6, page: 7, paragraph: 8, comments: 9 }
	            });
	        }
	    });
	};
	
	
	//-------------------------------------------
	Provision.prototype.itemComparer = null; // disable client-side sorting
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = viewModelInit.standardFactoryCreatorFor(
	    Provision,
	    "provisions"
	);


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true, todo: true*/
	"use strict";
	
	var $ = __webpack_require__(1);
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	var map = __webpack_require__(576);
	var computeDescription = __webpack_require__(557).computeDescription;
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// DocumentViewModelExtensions mixin class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function DocumentViewModelExtensions(factories) {
	    /// <summary>
	    /// Define viewmodel.
	    /// </summary>
	    this.guid = ko.observable(null);
	    this.id = this.number = pliObservable(null, null, "required");
	    this.splits = factories.splits.createObservableArray();
	
	    this.toggleMapOff = DocumentViewModelExtensions.prototype.toggleMapOff.bind(this);
	    this.toggleMapOn = DocumentViewModelExtensions.prototype.toggleMapOn.bind(this);
	    this.printMap = DocumentViewModelExtensions.prototype.printMap.bind(this);
	
	    this.extras.userName = ko.observable();
	    this.extras.mapOn = ko.observable(false);
	}
	
	
	//---------------------------------------
	DocumentViewModelExtensions.prototype.applyServerCalculationResult = function applyDocumentResult(context) {
	    context.visit(this.splits, "splits");
	};
	
	
	//---------------------------------------
	DocumentViewModelExtensions.prototype.buildServerCalculationData = function buildDocumentData(context) {
	    var splits = context.visit(this.splits);
	    return (splits === null ? null : { splits: splits });
	};
	
	
	//---------------------------------------
	DocumentViewModelExtensions.prototype.completeViewModel = function completeDocument() {
	    this.extras.map = new map.MapServerComputed({
	        mapRequestData: ko.computed(DocumentViewModelExtensions.prototype._getMapRequestData, this),
	        mapFeatureCallback: DocumentViewModelExtensions.prototype._mapFeatureCallback.bind(this),
	        isReady: this.extras.isReady,
	        emptyMessage: "There are no legal descriptions for this split."
	    });
	
	    ko.computed(function () {
	        var crumbs = pli.forms.crumbs();
	        if (crumbs.end && crumbs.end.hash.indexOf("landsRights", crumbs.end.hash.length - "landsRights".length) !== -1) {
	            this.showControls();
	            return;
	        }
	        this.hideControls();
	    }, this.extras.map);
	
	    // TODO: Remove setTimeout once https://github.com/pandell/web-pli/issues/440 is fixed
	    // SlickGrid does not render the grid correctly if the grid is activated
	    // before the page is visible. This ensures the grid dimensions are recomputed
	    // if the grid is already active when the form initially becomes visible.
	    var initialGridResizeComputed = ko.computed(function () {
	        if (this.extras.state.isReady() && this.splits.current()) {
	            var editGrid = this.splits.current().extras.landsRightsEditGrid.editGrid;
	            if (editGrid.active()) {
	
	                setTimeout(function () { editGrid.apply({ resize: true }); }, 0);
	            }
	            initialGridResizeComputed.dispose();
	        }
	    }, this);
	};
	
	
	//---------------------------------------
	DocumentViewModelExtensions.prototype.loadViewModel = function loadDocument(record) {
	    this.guid(record.guid || null);
	    this.id.load(record.id);
	    this.splits.loadViewModel(record.splits);
	    if (this.splits.peek().length === 0) {
	        var newSplit = this.splits.createItem();
	
	        if (ko.isObservable(newSplit.rentalPercentage)) {
	            newSplit.rentalPercentage(100);
	        }
	
	        this.splits.push(newSplit);
	    }
	    this.extras.userName(record.userName || "Unknown");
	};
	
	
	//-------------------------------------------
	DocumentViewModelExtensions.prototype.toggleMapOff = function toggleMapOff(document) {
	    document.extras.mapOn(false);
	};
	
	
	//-------------------------------------------
	DocumentViewModelExtensions.prototype.toggleMapOn = function toggleMapOn(document) {
	    document.extras.mapOn(true);
	};
	
	
	//-------------------------------------------
	DocumentViewModelExtensions.prototype.printMap = function printMap() {
	    // open the default print dialogue
	    // the print style we added to document.css will take care of the rest
	    window.print();
	};
	
	
	//---------------------------------------
	DocumentViewModelExtensions.prototype._getMapRequestData = function getMapRequestData() {
	    var locations = [];
	    var currentSplit = this.splits.current();
	
	    if (currentSplit.tracts.peek()) {
	        ko.utils.arrayForEach(currentSplit.tracts(), function (tract) {
	            var tractId = tract.id;
	
	            if (tract.tractItems) {
	                ko.utils.arrayForEach(tract.tractItems, function (item) {
	                    if (!item.isRight) {
	                        var land = item.land,
	                            landId = (land.location + " " + land.sections).trim();
	
	                        if (landId) {
	                            locations.push(
	                                {
	                                    id: tractId + ":" + landId,
	                                    isValid: true,
	                                    legalDescription: {
	                                        format: land.format,
	                                        location: land.location,
	                                        sections: land.sections
	                                    },
	                                    shortDisplayName: landId,
	                                    longDisplayName: landId
	                                }
	                            );
	                        }
	                    }
	                });
	            }
	        });
	    }
	
	    return locations;
	};
	
	
	//-------------------------------------------
	DocumentViewModelExtensions.prototype._mapFeatureCallback = function mapFeatureCallback(feature) {
	    var featureIds = feature.properties.docId.split("|"),
	        featureId = featureIds[0],
	        tractId = featureId.split(":")[0],
	        landId = featureId.split(":")[1];
	
	    var tract = ko.utils.arrayFirst(this.splits.current.peek().tracts.peek(), function (tracts) {
	        return tracts.name === tractId;
	    });
	
	    if (tract) {
	        var popupHtml = ko.pureComputed(DocumentViewModelExtensions.prototype._mapPopupContentFactory(tract, landId), this);
	        feature.bindPopup(popupHtml, { customLayout: true, closeButton: ".close" });
	    }
	};
	
	
	//-------------------------------------------
	DocumentViewModelExtensions.prototype._mapPopupContentFactory = function createPopupContentFactory(tract, landId) {
	    // Extract the land
	    var landItem = ko.utils.arrayFirst(tract.tractItems, function (item) {
	        if (!item.isRight) {
	            var id = computeDescription(ko.utils.extend({ type: "land" }, item.land));
	            return id === landId;
	        }
	
	        return null;
	    });
	
	    // Extract the rights
	    var rightItems = ko.utils.arrayFilter(tract.tractItems, function (item) {
	        return item.isRight;
	    });
	
	    return function computePopupContent() {
	        // Build popup div container
	        var popupDiv = $("<div class='pliTooltip'>"
	            + "<div class='pliTooltip-content'>"
	            + "<div class='pliTooltip-header'>Tract " + tract.name + "</div>"
	            + "<div class='pliTooltip-list-container'></div>"
	            + "<div class='pliTooltip-footer'><a class='close'><i></i> close</a></div>"
	            + "</div>"
	            + "</div>");
	
	        var $listContainer = $(".pliTooltip-list-container", popupDiv);
	
	        // Builds the land details and inject as a line item in popup div
	        if (landItem) {
	            var landDescription = computeDescription(ko.utils.extend({ type: "land" }, landItem.land));
	            var landDetails = "";
	
	            landDetails += "<div>" + landDescription + "</div>";
	
	            // Land production
	            if (landItem.productionType) {
	                if (landItem.productionType === "P") {
	                    landDetails += "<div class='producing'>Producing</div>";
	                } else if (landItem.productionType === "NP") {
	                    landDetails += "<div class='nonProducing'>Non-producing</div>";
	                }
	            }
	
	            // Inject the land details into the land item row.
	            var landLi = $("<li class='toolTipRow'>"
	                + "<a>"
	                + "<span class='toolTip-icon sprite-land-16'></span>"
	                + "<span class='toolTip-details'>"
	                + landDetails
	                + "</span>"
	                + "</a></li>");
	
	            $listContainer.append(landLi); // Add the land details row
	        }
	
	        // Build the right details and inject as line items in div
	        ko.utils.arrayForEach(rightItems, function (item) {
	            var rightDescription = computeDescription(ko.utils.extend({ type: "right" }, item.right));
	            var rightDetails = "<div>" + rightDescription + "</div>";
	
	            var rightLi = $("<li class='toolTipRow'>"
	                + "<a>"
	                + "<span class='toolTip-icon sprite-right-16'></span>"
	                + "<span class='toolTip-details'>"
	                + rightDetails
	                + "</span>"
	                + "</a></li>");
	
	            $listContainer.append(rightLi); // Add the right details row
	        });
	
	        return popupDiv[0];
	    };
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	module.exports = {
	    createFactories: function createExtraDocumentFactories(rootId, createSplitsFactory) {
	        return {
	            splits: createSplitsFactory(rootId)
	        };
	    },
	    mixins: {
	        applyDocumentResult: DocumentViewModelExtensions.prototype.applyServerCalculationResult,
	        buildDocumentData: DocumentViewModelExtensions.prototype.buildServerCalculationData,
	        completeDocument: DocumentViewModelExtensions.prototype.completeViewModel,
	        initDocument: DocumentViewModelExtensions,
	        loadDocument: DocumentViewModelExtensions.prototype.loadViewModel
	    }
	};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	/// <reference path="../../typings/app.d.ts" />
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(577));
	


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	/// <reference path="../../typings/app.d.ts" />
	"use strict";
	var mapping_1 = __webpack_require__(578);
	var forms_map_1 = __webpack_require__(628);
	var ko = __webpack_require__(457);
	var common_server_computed_ts_1 = __webpack_require__(634);
	var LocationDictionary = (function () {
	    function LocationDictionary() {
	    }
	    return LocationDictionary;
	}());
	/**
	 * A view model for loading and displaying a map.
	 */
	var MapServerComputed = (function () {
	    /**
	     * Creates a new instance of the MapDataViewModel class.
	     */
	    function MapServerComputed(options) {
	        var _this = this;
	        if (!options) {
	            throw new Error("options must be defined.");
	        }
	        if (!ko.isObservable(options.mapRequestData)) {
	            throw new Error("options.mapRequestData must an observable.");
	        }
	        if (options.mapFeatureCallback && typeof options.mapFeatureCallback !== "function") {
	            throw new Error("options.mapFeatureCallback must be a function.");
	        }
	        if (options.mapFocusCallback && typeof options.mapFocusCallback !== "function") {
	            throw new Error("options.mapFocusCallback must be a function.");
	        }
	        if (options.callName && typeof options.callName !== "string") {
	            throw new Error("options.callName must be a string.");
	        }
	        if (options.emptyMessage && typeof options.emptyMessage !== "string") {
	            throw new Error("options.emptyMessage must be a string.");
	        }
	        if (options.pluralEntityType && typeof options.pluralEntityType !== "string") {
	            throw new Error("options.pluralEntityType must be a string.");
	        }
	        // If options.mapFocusCallback is explicitly undefined, use default focus
	        this._mapFocusCallback = options.mapFocusCallback !== undefined ? options.mapFocusCallback : function () {
	            if (!_this.mapData.map.adapter()) {
	                // If no map bound, nothing to focus
	                return;
	            }
	            if (!_this.mapData.map.hasFeatures(mapping_1.FeatureType.Land)) {
	                return;
	            }
	            _this.mapData.map.center(mapping_1.FeatureType.Land, true); // true: zoomToBounds
	        };
	        this._hasGenericError = ko.observable(false);
	        this._hideControls = ko.observable(false);
	        this._refreshObservable = ko.observable();
	        this.mapData = new forms_map_1.PliMapViewModel({
	            mapFeatureCallback: options.mapFeatureCallback,
	            mapFocusCallback: this._mapFocusCallback,
	            emptyMessage: options.emptyMessage,
	            pluralEntityType: options.pluralEntityType,
	            refreshData: function () { return _this.refresh(); },
	            focusMapOnLoad: true,
	            getLocationData: function (featureProperties) { return _this._getLocationData(featureProperties); },
	            hideControls: this._hideControls,
	            showFullscreenButton: true,
	            onFullscreenToggle: function (isFullscreen) { return _this.focusMap(); }
	        });
	        this._rawMapRequestData = options.mapRequestData;
	        this.extras = function () { return; };
	        this.extras.state = {
	            isReady: options.isReady
	                ? options.isReady
	                : ko.observable(true)
	        };
	        // Calculate mapRequestData outside of buildServerCalculationData so that
	        // we recalculate state without waiting for the 2000ms timeout
	        this._mapRequestData = ko.computed(function () {
	            // Hack - subscribe to refresh observable so we can force refresh
	            _this._refreshObservable();
	            _this.mapData.loadViewModel({
	                isLoading: true,
	                unmappableLocations: [],
	                hasGenericError: false,
	                hasMultipleLocations: false
	            });
	            var rawMapRequestData = _this._rawMapRequestData() || [];
	            return rawMapRequestData.filter(function (location) {
	                // Don't send locations to the server we know to be invalid
	                return location.isValid;
	            });
	        });
	        var contributor = {
	            applyServerCalculationResult: function (context) { return _this._applyServerCalculationResult(context); },
	            buildServerCalculationData: function () { return _this._buildServerCalculationData(); },
	            state: this.extras.state
	        };
	        this.extras.serverCalculation = new common_server_computed_ts_1.ServerCalculation(options.callName || "Geo-Map-LoadMapData", contributor, 2000);
	        this.focusMap = function () {
	            if (_this._mapFocusCallback) {
	                _this._mapFocusCallback();
	            }
	        };
	    }
	    /**
	     * Refreshes the map with new data from the server.
	     */
	    MapServerComputed.prototype.refresh = function () {
	        this._refreshObservable.valueHasMutated();
	    };
	    MapServerComputed.prototype.hideControls = function () {
	        this._hideControls(true);
	    };
	    MapServerComputed.prototype.showControls = function () {
	        this._hideControls(false);
	    };
	    MapServerComputed.prototype.forceLoadingState = function () {
	        this.mapData.loadViewModel({
	            isLoading: true,
	            hasGenericError: false,
	            hasMultipleLocations: false,
	            unmappableLocations: []
	        });
	    };
	    /**
	     * Applies the response from the api call.
	     * @param {Object} serverCalculationContext The context to apply from the serverComputed.
	     */
	    MapServerComputed.prototype._applyServerCalculationResult = function (serverCalculationContext) {
	        var response = serverCalculationContext.rootData;
	        if (response.isError) {
	            this.mapData.loadViewModel({
	                isLoading: false,
	                hasGenericError: true,
	                hasMultipleLocations: false,
	                unmappableLocations: []
	            });
	        }
	        else {
	            var result = response.result;
	            var locationErrors = this._mergeLocationErrors(result.unmappableLocations);
	            var rawData = this._rawMapRequestData.peek();
	            this.mapData.loadViewModel({
	                isLoading: false,
	                hasGenericError: false,
	                hasMultipleLocations: rawData && rawData.length > 1,
	                unmappableLocations: this._locationErrorsToUnmappableLocations(locationErrors),
	                landData: result.data
	            });
	        }
	    };
	    /**
	     * Creates the data required for the api call.
	     */
	    MapServerComputed.prototype._buildServerCalculationData = function () {
	        var _this = this;
	        var data = this._mapRequestData();
	        var rawData = this._rawMapRequestData.peek();
	        this._locationDictionary = {};
	        rawData.forEach(function (location) {
	            _this._locationDictionary[location.id] = location;
	        });
	        if (!data || !data.length) {
	            var locationErrors = this._mergeLocationErrors([]);
	            this.mapData.loadViewModel({
	                isLoading: false,
	                hasGenericError: false,
	                hasMultipleLocations: rawData && rawData.length > 1,
	                unmappableLocations: this._locationErrorsToUnmappableLocations(locationErrors)
	            });
	            return null; // No call will be made
	        }
	        return data;
	    };
	    /**
	     * Merges unmappable locations returned from the api call with invalid locations from the raw map data.
	     * @param {Array} unmappableLocations The unmappable locations returned from the api call.
	     */
	    MapServerComputed.prototype._mergeLocationErrors = function (unmappableLocations) {
	        unmappableLocations = unmappableLocations || [];
	        var rawMapRequestData = this._rawMapRequestData();
	        if (rawMapRequestData && rawMapRequestData.length) {
	            unmappableLocations = unmappableLocations.concat(rawMapRequestData.filter(function (location) {
	                return !location.isValid;
	            }).map(function (location) {
	                return {
	                    id: location.id,
	                    errorLevel: "error",
	                    message: (location.legalDescription.format === "nts" ? "The NTS" : "The DLS") + " location is not entered correctly"
	                };
	            }));
	        }
	        return unmappableLocations;
	    };
	    MapServerComputed.prototype._locationErrorsToUnmappableLocations = function (locationErrors) {
	        var _this = this;
	        return locationErrors.map(function (error) {
	            var location = _this._locationDictionary[error.id];
	            return {
	                id: location.id,
	                errorLevel: error.errorLevel === "warning" ? forms_map_1.ErrorLevel.Warning : forms_map_1.ErrorLevel.Error,
	                message: error.message,
	                titleDisplayName: location.shortDisplayName,
	                tooltipDisplayName: location.longDisplayName,
	                openItem: location.openItem
	            };
	        });
	    };
	    MapServerComputed.prototype._getLocationData = function (properties) {
	        var _this = this;
	        var ids = properties.docId.split("|");
	        return ids.map(function (id) {
	            var location = _this._locationDictionary[id];
	            return {
	                id: location.id,
	                type: location.legalDescription.format === "nts" ? forms_map_1.LocationType.Nts : forms_map_1.LocationType.Dls,
	                titleDisplayName: location.shortDisplayName,
	                tooltipDisplayName: location.longDisplayName,
	                openItem: location.openItem
	            };
	        });
	    };
	    return MapServerComputed;
	}());
	exports.MapServerComputed = MapServerComputed;
	


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var binding_1 = __webpack_require__(579);
	exports.pliMap = binding_1.pliMap;
	ko.bindingHandlers["pliMap"] = binding_1.pliMap;
	var api_1 = __webpack_require__(618);
	exports.FeatureType = api_1.FeatureType;
	var mapViewModel_1 = __webpack_require__(627);
	exports.MapViewModel = mapViewModel_1.MapViewModel;
	


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var mapboxAdapter_1 = __webpack_require__(580);
	var mapViewModel_1 = __webpack_require__(627);
	/**
	 * pliMap knockout binding
	 */
	exports.pliMap = {
	    init: function initPliMapBinding(element, valueAccessor, allBindings) {
	        var mapViewModel = ko.unwrap(valueAccessor());
	        if (!(mapViewModel instanceof mapViewModel_1.MapViewModel)) {
	            throw new Error("Expected instance of 'MapViewModel' for 'pliMap' binding");
	        }
	        if (element.tagName !== "DIV") {
	            throw new Error("Expected 'div' for element with 'pliMap' binding");
	        }
	        var adapter;
	        var options = allBindings.get("mapOptions") || {};
	        switch (options.adapter) {
	            case "mapbox":
	            default:
	                adapter = new mapboxAdapter_1.MapboxAdapter(element, mapViewModel, options);
	        }
	        ko.utils.domData.set(element, "map-adapter", adapter);
	    },
	    update: function updatePliMapBinding(element, valueAccessor) {
	        var mapViewModel = ko.unwrap(valueAccessor());
	        var adapter = ko.utils.domData.get(element, "map-adapter");
	        adapter.viewModel(mapViewModel);
	    }
	};
	


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var L = __webpack_require__(581);
	var api_1 = __webpack_require__(618);
	var common_1 = __webpack_require__(619);
	var landLayer_1 = __webpack_require__(620);
	var wellLayer_1 = __webpack_require__(621);
	var PandellDlsTileUrl = "http://maptiles.pandell.com/v2/DLS/{z}/{x}/{y}.png";
	var PandellMapboxAccessToken = "pk.eyJ1IjoicGFuZGVsbC10ZXN0IiwiYSI6ImZyOVE4TzAifQ.3nl0eDsG7FusR7Hegqw0hw";
	var PandellMapboxTerrainTileUrl = "pandell-test.ii2j3i26";
	var PandellMapboxSatelliteTileUrl = "pandell-test.158o90k7";
	function createColorWheel(colors) {
	    var markerOrdinal = 0;
	    return function () {
	        markerOrdinal += 1;
	        return colors[markerOrdinal % colors.length];
	    };
	}
	function getFeatures(layer, map, type, propFilter) {
	    if (layer) {
	        var featureLayers = layer.getLayers();
	        var filteredLayers = (propFilter
	            ? featureLayers.filter(function (l) { return propFilter(l.feature.properties); })
	            : featureLayers);
	        return filteredLayers.map(function (l) { return common_1.createFeature(l, map, type); });
	    }
	    return [];
	}
	function createMapInstance(element, options, adapter) {
	    // -------------------------------------------
	    // Mapbox initialization
	    L.mapbox.accessToken = options.mapboxAccessToken;
	    var allowDraw = options.allowDraw, drawnLayer = options.drawnLayer, showDlsGrid = options.showDlsGrid, showSatelliteMap = options.showSatelliteMap, terrainTileUrl = options.terrainTileUrl, satelliteTileUrl = options.satelliteTileUrl;
	    var terrainLayer = L.mapbox.tileLayer(terrainTileUrl);
	    var dlsGridLayer = L.tileLayer(options.dlsTileUrl, {
	        attribution: "Pandell Tiles",
	        minZoom: 8,
	        maxNativeZoom: 14,
	        opacity: 0.4
	    });
	    // null second parameter is the layer, which we specify in the
	    // options (in the case we have two layers, terrain and DLS)
	    var map = L.mapbox.map(element, null, {
	        attributionControl: false,
	        doubleClickZoom: options.doubleClickZoom,
	        center: options.initialLatLong,
	        minZoom: options.minZoom,
	        maxZoom: options.maxZoom,
	        zoom: options.initialZoom,
	        layers: showDlsGrid ? [terrainLayer, dlsGridLayer] : [terrainLayer]
	    });
	    var baseMaps = {
	        "Terrain": terrainLayer
	    };
	    if (showSatelliteMap) {
	        baseMaps["Satellite"] = L.mapbox.tileLayer(satelliteTileUrl);
	    }
	    var overlayMaps = showDlsGrid ? {
	        "DLS Grid": dlsGridLayer
	    } : null;
	    if (showSatelliteMap || showDlsGrid) {
	        L.control.layers(baseMaps, overlayMaps).addTo(map);
	    }
	    // -------------------------------------------
	    // Minimap
	    var showMinimap = options.showMinimap;
	    var miniMap;
	    // TODO: refactor to avoid side effects
	    ko.computed(function toggleMinimap() {
	        if (ko.unwrap(showMinimap)) {
	            if (!miniMap) {
	                var miniMapTerrainLayer = L.mapbox.tileLayer(terrainTileUrl);
	                miniMap = L.control.minimap(miniMapTerrainLayer, {
	                    autoToggleDisplay: true,
	                    toggleDisplay: true,
	                    zoomLevelOffset: -5,
	                    width: 200,
	                    height: 200
	                });
	            }
	            map.addControl(miniMap);
	        }
	        else {
	            if (miniMap) {
	                map.removeControl(miniMap);
	            }
	        }
	    });
	    // Leaflet.Draw
	    if (allowDraw) {
	        var drawOptions = options.drawOptions;
	        var drawControl = new L.Control.Draw({
	            draw: {
	                polyline: drawOptions.drawPolyline
	                    ?
	                        drawOptions.colorPolyline
	                            ? {
	                                shapeOptions: {
	                                    color: drawOptions.colorPolyline
	                                }
	                            }
	                            : {}
	                    : false,
	                polygon: drawOptions.drawPolygon
	                    ?
	                        drawOptions.colorPolygon
	                            ? {
	                                shapeOptions: {
	                                    color: drawOptions.colorPolygon
	                                }
	                            }
	                            : {}
	                    : false,
	                rectangle: drawOptions.drawRectangle
	                    ?
	                        drawOptions.colorRectangle
	                            ? {
	                                shapeOptions: {
	                                    color: drawOptions.colorRectangle
	                                }
	                            }
	                            : {}
	                    : false,
	                circle: drawOptions.drawCircle
	                    ?
	                        drawOptions.colorCircle
	                            ? {
	                                shapeOptions: {
	                                    color: drawOptions.colorCircle
	                                }
	                            }
	                            : {}
	                    : false,
	                marker: drawOptions.drawMarker ? {} : false
	            },
	            edit: {
	                featureGroup: drawnLayer,
	                edit: drawOptions.editShapes,
	                remove: drawOptions.deleteShapes
	            }
	        });
	        map.addLayer(drawnLayer);
	        map.addControl(drawControl);
	        map.on("draw:created", function (e) {
	            drawnLayer.addLayer(e.layer);
	            adapter.drawnObjects(drawnLayer.toGeoJSON());
	        });
	        map.on("draw:edited", function (e) {
	            adapter.drawnObjects(drawnLayer.toGeoJSON());
	        });
	        map.on("draw:deleted", function (e) {
	            adapter.drawnObjects(drawnLayer.toGeoJSON());
	        });
	    }
	    var moveendQueue = [];
	    // -------------------------------------------
	    // Bounds & Lat/long
	    map.on("moveend", function () {
	        var center = map.getCenter();
	        adapter.latLong({ lat: center.lat, lng: center.lng });
	        var mapBounds = map.getBounds();
	        adapter.bounds({ northEast: mapBounds.getNorthEast(), southWest: mapBounds.getSouthWest() });
	        while (moveendQueue.length > 0) {
	            var action = moveendQueue.pop();
	            action();
	        }
	    });
	    // -------------------------------------------
	    // Zoom
	    map.on("zoomend", function () {
	        adapter.zoom(map.getZoom());
	    });
	    // -------------------------------------------
	    // Fullscreen
	    var hashChangeEvent = "hashchange";
	    var hashChangeListener = function () { return map.toggleFullscreen(); };
	    map.on("fullscreenchange", function () {
	        // We can't call the adapter.onFullscreenToggle callback here because the map hasn't finished moving/resizing yet
	        // and won't be guaranteed to be resized. Call the callback on "moveend" event.
	        moveendQueue.push(function () { return adapter.onFullscreenToggle(); });
	        if (window && window.addEventListener) {
	            if (map.isFullscreen()) {
	                // Exit fullscreen on hash change (popup clicked, etc.)
	                window.addEventListener(hashChangeEvent, hashChangeListener, false);
	            }
	            else {
	                window.removeEventListener(hashChangeEvent, hashChangeListener, false);
	            }
	        }
	    });
	    return map;
	}
	var MapboxAdapter = (function () {
	    function MapboxAdapter(element, initialViewModel, bindingOptions) {
	        var _this = this;
	        var options = ko.utils.extend({
	            allowDraw: false,
	            dlsTileUrl: PandellDlsTileUrl,
	            doubleClickZoom: false,
	            initialLatLong: { lat: 53.52617, lng: -113.492175 },
	            initialZoom: 4,
	            loadFeaturesByArray: false,
	            mapboxAccessToken: PandellMapboxAccessToken,
	            maxZoom: 16,
	            minZoom: 4,
	            satelliteTileUrl: PandellMapboxSatelliteTileUrl,
	            showDlsGrid: true,
	            showMinimap: ko.observable(false),
	            showSatelliteMap: false,
	            terrainTileUrl: PandellMapboxTerrainTileUrl
	        }, ko.unwrap(bindingOptions));
	        options.drawOptions = ko.utils.extend({
	            editShapes: true,
	            deleteShapes: true,
	            drawPolygon: true,
	            drawPolyline: true,
	            drawRectangle: true,
	            drawCircle: true,
	            drawMarker: true
	        }, ko.unwrap(bindingOptions.drawOptions));
	        options.dialogOptions = ko.utils.extend({
	            anchor: [-150, 0],
	            size: [150, 0],
	            position: "bottomleft",
	            initOpen: false
	        }, ko.unwrap(bindingOptions.dialogOptions));
	        var clusterPluginName = bindingOptions.clusterPlugin || "MarkerCluster";
	        var clusterPlugin = common_1.ClusterPlugin[clusterPluginName];
	        if (clusterPlugin !== null && clusterPlugin !== undefined) {
	            options.clusterPlugin = clusterPlugin;
	        }
	        else {
	            throw new Error("Unsupported ClusterPlugin: " + clusterPluginName);
	        }
	        this.bounds = ko.observable(null);
	        this.drawnObjects = ko.observable(null);
	        this.latLong = ko.observable(options.initialLatLong);
	        this.zoom = ko.observable(options.initialZoom);
	        this.viewModel = ko.observable(initialViewModel);
	        this.viewModel.subscribe(this._viewModelConnected, this);
	        this.viewModel.subscribe(this._viewModelDisconnected, this, "beforeChange");
	        this._lastCenter = null;
	        this._map = null;
	        this._onMarkerClick = null;
	        this._dialogOptions = options.dialogOptions;
	        this._landLayer = new landLayer_1.LandLayer(options);
	        this._wellLayer = new wellLayer_1.WellLayer(options);
	        if (options.allowDraw) {
	            this._drawnLayer = L.featureGroup();
	            options.drawnLayer = this._drawnLayer;
	        }
	        this.zoom.subscribe(function () { return _this._landLayer.toggleLandMarkers(_this._map); }, this);
	        // HACKITY HACK HACK:
	        // If the map is rendered to an element that is not visible, it
	        // may appear in the wrong spot when it does become visible. This
	        // can occur when loading a form, for example, and in PLI, it is very
	        // difficult to detect when the form is actually visible. Hence, this
	        // ridiculous hack. Any other ideas?
	        var interval = setInterval(function () {
	            if (element.offsetParent !== null) {
	                clearInterval(interval);
	                var viewModel = _this.viewModel();
	                _this._map = createMapInstance(element, options, _this);
	                _this._layersUpdated(viewModel.layers());
	                var bounds = viewModel.bounds();
	                if (bounds) {
	                    _this._updateBounds(bounds);
	                }
	                else if (_this._lastCenter !== null && _this._hasLayer(_this._lastCenter)) {
	                    _this.center(_this._lastCenter, _this._lastZoomToBounds);
	                }
	                else {
	                    _this._map.setView(viewModel.latLong(), viewModel.zoom());
	                }
	                if (viewModel.onResetFocus) {
	                    _this._map.addControl(_this._getResetFocusControl());
	                }
	                if (viewModel.showFullscreenButton) {
	                    _this._map.addControl(_this._getFullscreenControl());
	                }
	                if (typeof options.onMapCreated === "function") {
	                    options.onMapCreated(_this._map);
	                }
	                if (options.showDialog) {
	                    _this._map.addControl(_this._getDialog());
	                }
	            }
	        }, 100);
	    }
	    MapboxAdapter.prototype.center = function (feature, zoomToBounds) {
	        this._lastCenter = feature;
	        this._lastZoomToBounds = zoomToBounds;
	        if (!this._map) {
	            return;
	        }
	        var featureType = typeof feature === "number" ? feature : feature.type;
	        var mapLayer = this._getLayerByFeatureType(featureType);
	        if (!mapLayer) {
	            throw new Error("Layer for feature type '" + featureType + "' does not exist.");
	        }
	        var bounds = mapLayer.getBounds();
	        this._updateBounds({ northEast: bounds.getNorthEast(), southWest: bounds.getSouthWest(), zoom: zoomToBounds });
	    };
	    MapboxAdapter.prototype.getFeatures = function (type, propFilter) {
	        var mapLayer = this._getLayerByFeatureType(type);
	        return mapLayer
	            ? getFeatures(mapLayer, this._map, type, propFilter)
	            : [];
	    };
	    MapboxAdapter.prototype.onFullscreenToggle = function () {
	        var viewModel = this.viewModel();
	        if (viewModel.onFullscreenToggle) {
	            viewModel.onFullscreenToggle(this._map.isFullscreen());
	        }
	    };
	    MapboxAdapter.prototype._getFullscreenControl = function () {
	        if (!this._fullscreenControl) {
	            this._fullscreenControl = L.control.fullscreen({ position: "topleft" });
	        }
	        return this._fullscreenControl;
	    };
	    MapboxAdapter.prototype._getResetFocusControl = function () {
	        var _this = this;
	        if (this._resetFocusControl) {
	            return this._resetFocusControl;
	        }
	        this._resetFocusControl = new L.Control({ position: "topleft" });
	        this._resetFocusControl.onAdd = function (map) {
	            var resetDiv = L.DomUtil.create("div", "leaflet-control-reset leaflet-bar");
	            var resetA = L.DomUtil.create("a", "", resetDiv);
	            L.DomUtil.create("i", "", resetA);
	            L.DomEvent
	                .addListener(resetA, "click", function (e) {
	                e.stopPropagation();
	                e.preventDefault();
	                var viewModel = _this.viewModel();
	                if (viewModel && viewModel.onResetFocus) {
	                    viewModel.onResetFocus();
	                }
	            });
	            resetA.title = "Reset map";
	            return resetDiv;
	        };
	        return this._resetFocusControl;
	    };
	    MapboxAdapter.prototype._getDialog = function () {
	        if (!this._dialogControl) {
	            this._dialogControl = L.control.dialog(this._dialogOptions);
	        }
	        return this._dialogControl;
	    };
	    MapboxAdapter.prototype._addLayer = function (layer) {
	        if (!layer || !this._map) {
	            return;
	        }
	        this._map.addLayer(layer);
	    };
	    MapboxAdapter.prototype._createFeatureAddCallback = function (layer) {
	        var colorWheel = createColorWheel(this.viewModel().colors);
	        switch (layer.featureType) {
	            case api_1.FeatureType.Land:
	                return this._landLayer.createLayerAdded(this._map, colorWheel, layer.featureAddCallback);
	            case api_1.FeatureType.Well:
	                return this._wellLayer.createLayerAdded(this._map, layer.featureAddCallback);
	            default:
	                throw new Error("Unsupported feature type: '" + layer.featureType + "'");
	        }
	    };
	    MapboxAdapter.prototype._getLayerByFeatureType = function (featureType) {
	        switch (featureType) {
	            case api_1.FeatureType.Land:
	                return this._landLayer.getFeatureLayer();
	            case api_1.FeatureType.Well:
	                return this._wellLayer.getFeatureLayer();
	            default:
	                throw new Error("Unsupported feature type: '" + featureType + "'");
	        }
	    };
	    MapboxAdapter.prototype._hasLayer = function (feature) {
	        if (typeof feature === "number") {
	            return this._getLayerByFeatureType(feature) !== null;
	        }
	        else {
	            return this._getLayerByFeatureType(feature.type) !== null;
	        }
	    };
	    MapboxAdapter.prototype._layersUpdated = function (layers) {
	        // Remove previous layers
	        if (!this._map) {
	            return;
	        }
	        this._map.closePopup();
	        // Remove layers from map
	        this._removeLayer(this._landLayer.getFeatureLayer());
	        this._removeLayer(this._wellLayer.getMarkerClusterGroup());
	        // Set the underlying feature layer data to null
	        // This will create a new and empty feature layer
	        this._landLayer.resetFeatureLayer();
	        this._wellLayer.resetFeatureLayer();
	        // Create new layers
	        for (var _i = 0, layers_1 = layers; _i < layers_1.length; _i++) {
	            var layer = layers_1[_i];
	            switch (layer.featureType) {
	                case api_1.FeatureType.Land:
	                    this._landLayer.setFeatureLayer(layer.geoData, this._createFeatureAddCallback(layer));
	                    // Populate land layer on map
	                    this._addLayer(this._landLayer.getFeatureLayer());
	                    this._landLayer.toggleLandMarkersOnLayerUpdate(this._map);
	                    break;
	                case api_1.FeatureType.Well:
	                    this._wellLayer.setFeatureLayer(layer.geoData, this._createFeatureAddCallback(layer), this._map, this._onMarkerClick);
	                    // Populate well layer on map
	                    this._addLayer(this._wellLayer.getMarkerClusterGroup());
	                    break;
	                default:
	                    throw new Error("Unsupported feature type: '" + layer.featureType + "'");
	            }
	        }
	    };
	    MapboxAdapter.prototype._removeLayer = function (layer) {
	        if (!layer || !this._map) {
	            return;
	        }
	        this._map.removeLayer(layer);
	    };
	    MapboxAdapter.prototype._updateBounds = function (bounds) {
	        if (bounds.northEast && bounds.southWest) {
	            this.bounds(bounds);
	            if (this._map) {
	                var latLngBounds = L.latLngBounds(bounds.southWest, bounds.northEast);
	                if (bounds.zoom) {
	                    this._map.fitBounds(latLngBounds);
	                }
	                else {
	                    this._map.setView(latLngBounds.getCenter());
	                }
	            }
	        }
	    };
	    MapboxAdapter.prototype._updateSummaryContent = function (contentHtml) {
	        var dialog = this._getDialog();
	        if (contentHtml.length > 0) {
	            dialog.setContent(contentHtml);
	            dialog.update();
	        }
	    };
	    MapboxAdapter.prototype._updateSummaryVisibility = function (visible) {
	        var dialog = this._getDialog();
	        if (visible) {
	            dialog.open();
	        }
	        else {
	            dialog.close();
	        }
	    };
	    MapboxAdapter.prototype._viewModelConnected = function (viewModel) {
	        viewModel.adapter(this);
	        this._layerSubscription = viewModel.layers.subscribe(this._layersUpdated, this);
	        this._dialogContentSubscription = viewModel.dialogContent.subscribe(this._updateSummaryContent, this);
	        this._dialogVisibleSubscription = viewModel.dialogVisible.subscribe(this._updateSummaryVisibility, this);
	        this._layersUpdated(viewModel.layers());
	        if (viewModel.onMarkerClick) {
	            this._onMarkerClick = viewModel.onMarkerClick;
	        }
	        if (viewModel.onResetFocus && this._map) {
	            this._map.addControl(this._getResetFocusControl());
	        }
	        if (viewModel.showFullscreenButton && this._map) {
	            this._map.addControl(this._getFullscreenControl());
	        }
	    };
	    MapboxAdapter.prototype._viewModelDisconnected = function (viewModel) {
	        viewModel.adapter(null);
	        if (this._layerSubscription) {
	            this._layerSubscription.dispose();
	        }
	        if (this._dialogContentSubscription) {
	            this._dialogContentSubscription.dispose();
	        }
	        if (this._dialogVisibleSubscription) {
	            this._dialogVisibleSubscription.dispose();
	        }
	        if (this._onMarkerClick) {
	            this._onMarkerClick = null;
	            if (this._wellLayer) {
	                this._wellLayer.clearClickHandler();
	            }
	        }
	        if (this._map && this._resetFocusControl) {
	            this._map.removeControl(this._resetFocusControl);
	        }
	        if (this._map && this._fullscreenControl) {
	            this._map.removeControl(this._fullscreenControl);
	        }
	    };
	    return MapboxAdapter;
	}());
	exports.MapboxAdapter = MapboxAdapter;
	


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	
	if (__webpack_require__(3).isBrowser) {
	    __webpack_require__(582); // creates global.L
	    __webpack_require__(583); // attaches to global.L
	    __webpack_require__(613); // attaches to L.Control.Fullscreen
	    __webpack_require__(614); // attaches to L.Control.MiniMap
	    __webpack_require__(615); // attaches to L.MarkerClusterGroup
	    __webpack_require__(616);
	    __webpack_require__(617);
	    module.exports = global.L;
	} else {
	    module.exports = {
	        mapbox: {
	            map: function mapShim() {
	                throw new Error("Mapbox may only be used in a browser environment.");
	            }
	        }
	    };
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*
	 Leaflet, a JavaScript library for mobile-friendly interactive maps. http://leafletjs.com
	 (c) 2010-2013, Vladimir Agafonkin
	 (c) 2010-2011, CloudMade
	*/
	(function (window, document, undefined) {
	var oldL = window.L,
	    L = {};
	
	L.version = '0.7.7';
	
	// define Leaflet for Node module pattern loaders, including Browserify
	if (typeof module === 'object' && typeof module.exports === 'object') {
		module.exports = L;
	
	// define Leaflet as an AMD module
	} else if (typeof define === 'function' && define.amd) {
		define(L);
	}
	
	// define Leaflet as a global L variable, saving the original L to restore later if needed
	
	L.noConflict = function () {
		window.L = oldL;
		return this;
	};
	
	window.L = L;
	
	
	/*
	 * L.Util contains various utility functions used throughout Leaflet code.
	 */
	
	L.Util = {
		extend: function (dest) { // (Object[, Object, ...]) ->
			var sources = Array.prototype.slice.call(arguments, 1),
			    i, j, len, src;
	
			for (j = 0, len = sources.length; j < len; j++) {
				src = sources[j] || {};
				for (i in src) {
					if (src.hasOwnProperty(i)) {
						dest[i] = src[i];
					}
				}
			}
			return dest;
		},
	
		bind: function (fn, obj) { // (Function, Object) -> Function
			var args = arguments.length > 2 ? Array.prototype.slice.call(arguments, 2) : null;
			return function () {
				return fn.apply(obj, args || arguments);
			};
		},
	
		stamp: (function () {
			var lastId = 0,
			    key = '_leaflet_id';
			return function (obj) {
				obj[key] = obj[key] || ++lastId;
				return obj[key];
			};
		}()),
	
		invokeEach: function (obj, method, context) {
			var i, args;
	
			if (typeof obj === 'object') {
				args = Array.prototype.slice.call(arguments, 3);
	
				for (i in obj) {
					method.apply(context, [i, obj[i]].concat(args));
				}
				return true;
			}
	
			return false;
		},
	
		limitExecByInterval: function (fn, time, context) {
			var lock, execOnUnlock;
	
			return function wrapperFn() {
				var args = arguments;
	
				if (lock) {
					execOnUnlock = true;
					return;
				}
	
				lock = true;
	
				setTimeout(function () {
					lock = false;
	
					if (execOnUnlock) {
						wrapperFn.apply(context, args);
						execOnUnlock = false;
					}
				}, time);
	
				fn.apply(context, args);
			};
		},
	
		falseFn: function () {
			return false;
		},
	
		formatNum: function (num, digits) {
			var pow = Math.pow(10, digits || 5);
			return Math.round(num * pow) / pow;
		},
	
		trim: function (str) {
			return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
		},
	
		splitWords: function (str) {
			return L.Util.trim(str).split(/\s+/);
		},
	
		setOptions: function (obj, options) {
			obj.options = L.extend({}, obj.options, options);
			return obj.options;
		},
	
		getParamString: function (obj, existingUrl, uppercase) {
			var params = [];
			for (var i in obj) {
				params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
			}
			return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
		},
		template: function (str, data) {
			return str.replace(/\{ *([\w_]+) *\}/g, function (str, key) {
				var value = data[key];
				if (value === undefined) {
					throw new Error('No value provided for variable ' + str);
				} else if (typeof value === 'function') {
					value = value(data);
				}
				return value;
			});
		},
	
		isArray: Array.isArray || function (obj) {
			return (Object.prototype.toString.call(obj) === '[object Array]');
		},
	
		emptyImageUrl: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
	};
	
	(function () {
	
		// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
		function getPrefixed(name) {
			var i, fn,
			    prefixes = ['webkit', 'moz', 'o', 'ms'];
	
			for (i = 0; i < prefixes.length && !fn; i++) {
				fn = window[prefixes[i] + name];
			}
	
			return fn;
		}
	
		var lastTime = 0;
	
		function timeoutDefer(fn) {
			var time = +new Date(),
			    timeToCall = Math.max(0, 16 - (time - lastTime));
	
			lastTime = time + timeToCall;
			return window.setTimeout(fn, timeToCall);
		}
	
		var requestFn = window.requestAnimationFrame ||
		        getPrefixed('RequestAnimationFrame') || timeoutDefer;
	
		var cancelFn = window.cancelAnimationFrame ||
		        getPrefixed('CancelAnimationFrame') ||
		        getPrefixed('CancelRequestAnimationFrame') ||
		        function (id) { window.clearTimeout(id); };
	
	
		L.Util.requestAnimFrame = function (fn, context, immediate, element) {
			fn = L.bind(fn, context);
	
			if (immediate && requestFn === timeoutDefer) {
				fn();
			} else {
				return requestFn.call(window, fn, element);
			}
		};
	
		L.Util.cancelAnimFrame = function (id) {
			if (id) {
				cancelFn.call(window, id);
			}
		};
	
	}());
	
	// shortcuts for most used utility functions
	L.extend = L.Util.extend;
	L.bind = L.Util.bind;
	L.stamp = L.Util.stamp;
	L.setOptions = L.Util.setOptions;
	
	
	/*
	 * L.Class powers the OOP facilities of the library.
	 * Thanks to John Resig and Dean Edwards for inspiration!
	 */
	
	L.Class = function () {};
	
	L.Class.extend = function (props) {
	
		// extended class with the new prototype
		var NewClass = function () {
	
			// call the constructor
			if (this.initialize) {
				this.initialize.apply(this, arguments);
			}
	
			// call all constructor hooks
			if (this._initHooks) {
				this.callInitHooks();
			}
		};
	
		// instantiate class without calling constructor
		var F = function () {};
		F.prototype = this.prototype;
	
		var proto = new F();
		proto.constructor = NewClass;
	
		NewClass.prototype = proto;
	
		//inherit parent's statics
		for (var i in this) {
			if (this.hasOwnProperty(i) && i !== 'prototype') {
				NewClass[i] = this[i];
			}
		}
	
		// mix static properties into the class
		if (props.statics) {
			L.extend(NewClass, props.statics);
			delete props.statics;
		}
	
		// mix includes into the prototype
		if (props.includes) {
			L.Util.extend.apply(null, [proto].concat(props.includes));
			delete props.includes;
		}
	
		// merge options
		if (props.options && proto.options) {
			props.options = L.extend({}, proto.options, props.options);
		}
	
		// mix given properties into the prototype
		L.extend(proto, props);
	
		proto._initHooks = [];
	
		var parent = this;
		// jshint camelcase: false
		NewClass.__super__ = parent.prototype;
	
		// add method for calling all hooks
		proto.callInitHooks = function () {
	
			if (this._initHooksCalled) { return; }
	
			if (parent.prototype.callInitHooks) {
				parent.prototype.callInitHooks.call(this);
			}
	
			this._initHooksCalled = true;
	
			for (var i = 0, len = proto._initHooks.length; i < len; i++) {
				proto._initHooks[i].call(this);
			}
		};
	
		return NewClass;
	};
	
	
	// method for adding properties to prototype
	L.Class.include = function (props) {
		L.extend(this.prototype, props);
	};
	
	// merge new default options to the Class
	L.Class.mergeOptions = function (options) {
		L.extend(this.prototype.options, options);
	};
	
	// add a constructor hook
	L.Class.addInitHook = function (fn) { // (Function) || (String, args...)
		var args = Array.prototype.slice.call(arguments, 1);
	
		var init = typeof fn === 'function' ? fn : function () {
			this[fn].apply(this, args);
		};
	
		this.prototype._initHooks = this.prototype._initHooks || [];
		this.prototype._initHooks.push(init);
	};
	
	
	/*
	 * L.Mixin.Events is used to add custom events functionality to Leaflet classes.
	 */
	
	var eventsKey = '_leaflet_events';
	
	L.Mixin = {};
	
	L.Mixin.Events = {
	
		addEventListener: function (types, fn, context) { // (String, Function[, Object]) or (Object[, Object])
	
			// types can be a map of types/handlers
			if (L.Util.invokeEach(types, this.addEventListener, this, fn, context)) { return this; }
	
			var events = this[eventsKey] = this[eventsKey] || {},
			    contextId = context && context !== this && L.stamp(context),
			    i, len, event, type, indexKey, indexLenKey, typeIndex;
	
			// types can be a string of space-separated words
			types = L.Util.splitWords(types);
	
			for (i = 0, len = types.length; i < len; i++) {
				event = {
					action: fn,
					context: context || this
				};
				type = types[i];
	
				if (contextId) {
					// store listeners of a particular context in a separate hash (if it has an id)
					// gives a major performance boost when removing thousands of map layers
	
					indexKey = type + '_idx';
					indexLenKey = indexKey + '_len';
	
					typeIndex = events[indexKey] = events[indexKey] || {};
	
					if (!typeIndex[contextId]) {
						typeIndex[contextId] = [];
	
						// keep track of the number of keys in the index to quickly check if it's empty
						events[indexLenKey] = (events[indexLenKey] || 0) + 1;
					}
	
					typeIndex[contextId].push(event);
	
	
				} else {
					events[type] = events[type] || [];
					events[type].push(event);
				}
			}
	
			return this;
		},
	
		hasEventListeners: function (type) { // (String) -> Boolean
			var events = this[eventsKey];
			return !!events && ((type in events && events[type].length > 0) ||
			                    (type + '_idx' in events && events[type + '_idx_len'] > 0));
		},
	
		removeEventListener: function (types, fn, context) { // ([String, Function, Object]) or (Object[, Object])
	
			if (!this[eventsKey]) {
				return this;
			}
	
			if (!types) {
				return this.clearAllEventListeners();
			}
	
			if (L.Util.invokeEach(types, this.removeEventListener, this, fn, context)) { return this; }
	
			var events = this[eventsKey],
			    contextId = context && context !== this && L.stamp(context),
			    i, len, type, listeners, j, indexKey, indexLenKey, typeIndex, removed;
	
			types = L.Util.splitWords(types);
	
			for (i = 0, len = types.length; i < len; i++) {
				type = types[i];
				indexKey = type + '_idx';
				indexLenKey = indexKey + '_len';
	
				typeIndex = events[indexKey];
	
				if (!fn) {
					// clear all listeners for a type if function isn't specified
					delete events[type];
					delete events[indexKey];
					delete events[indexLenKey];
	
				} else {
					listeners = contextId && typeIndex ? typeIndex[contextId] : events[type];
	
					if (listeners) {
						for (j = listeners.length - 1; j >= 0; j--) {
							if ((listeners[j].action === fn) && (!context || (listeners[j].context === context))) {
								removed = listeners.splice(j, 1);
								// set the old action to a no-op, because it is possible
								// that the listener is being iterated over as part of a dispatch
								removed[0].action = L.Util.falseFn;
							}
						}
	
						if (context && typeIndex && (listeners.length === 0)) {
							delete typeIndex[contextId];
							events[indexLenKey]--;
						}
					}
				}
			}
	
			return this;
		},
	
		clearAllEventListeners: function () {
			delete this[eventsKey];
			return this;
		},
	
		fireEvent: function (type, data) { // (String[, Object])
			if (!this.hasEventListeners(type)) {
				return this;
			}
	
			var event = L.Util.extend({}, data, { type: type, target: this });
	
			var events = this[eventsKey],
			    listeners, i, len, typeIndex, contextId;
	
			if (events[type]) {
				// make sure adding/removing listeners inside other listeners won't cause infinite loop
				listeners = events[type].slice();
	
				for (i = 0, len = listeners.length; i < len; i++) {
					listeners[i].action.call(listeners[i].context, event);
				}
			}
	
			// fire event for the context-indexed listeners as well
			typeIndex = events[type + '_idx'];
	
			for (contextId in typeIndex) {
				listeners = typeIndex[contextId].slice();
	
				if (listeners) {
					for (i = 0, len = listeners.length; i < len; i++) {
						listeners[i].action.call(listeners[i].context, event);
					}
				}
			}
	
			return this;
		},
	
		addOneTimeEventListener: function (types, fn, context) {
	
			if (L.Util.invokeEach(types, this.addOneTimeEventListener, this, fn, context)) { return this; }
	
			var handler = L.bind(function () {
				this
				    .removeEventListener(types, fn, context)
				    .removeEventListener(types, handler, context);
			}, this);
	
			return this
			    .addEventListener(types, fn, context)
			    .addEventListener(types, handler, context);
		}
	};
	
	L.Mixin.Events.on = L.Mixin.Events.addEventListener;
	L.Mixin.Events.off = L.Mixin.Events.removeEventListener;
	L.Mixin.Events.once = L.Mixin.Events.addOneTimeEventListener;
	L.Mixin.Events.fire = L.Mixin.Events.fireEvent;
	
	
	/*
	 * L.Browser handles different browser and feature detections for internal Leaflet use.
	 */
	
	(function () {
	
		var ie = 'ActiveXObject' in window,
			ielt9 = ie && !document.addEventListener,
	
		    // terrible browser detection to work around Safari / iOS / Android browser bugs
		    ua = navigator.userAgent.toLowerCase(),
		    webkit = ua.indexOf('webkit') !== -1,
		    chrome = ua.indexOf('chrome') !== -1,
		    phantomjs = ua.indexOf('phantom') !== -1,
		    android = ua.indexOf('android') !== -1,
		    android23 = ua.search('android [23]') !== -1,
			gecko = ua.indexOf('gecko') !== -1,
	
		    mobile = typeof orientation !== undefined + '',
		    msPointer = !window.PointerEvent && window.MSPointerEvent,
			pointer = (window.PointerEvent && window.navigator.pointerEnabled) ||
					  msPointer,
		    retina = ('devicePixelRatio' in window && window.devicePixelRatio > 1) ||
		             ('matchMedia' in window && window.matchMedia('(min-resolution:144dpi)') &&
		              window.matchMedia('(min-resolution:144dpi)').matches),
	
		    doc = document.documentElement,
		    ie3d = ie && ('transition' in doc.style),
		    webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23,
		    gecko3d = 'MozPerspective' in doc.style,
		    opera3d = 'OTransition' in doc.style,
		    any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d || opera3d) && !phantomjs;
	
		var touch = !window.L_NO_TOUCH && !phantomjs && (pointer || 'ontouchstart' in window ||
			(window.DocumentTouch && document instanceof window.DocumentTouch));
	
		L.Browser = {
			ie: ie,
			ielt9: ielt9,
			webkit: webkit,
			gecko: gecko && !webkit && !window.opera && !ie,
	
			android: android,
			android23: android23,
	
			chrome: chrome,
	
			ie3d: ie3d,
			webkit3d: webkit3d,
			gecko3d: gecko3d,
			opera3d: opera3d,
			any3d: any3d,
	
			mobile: mobile,
			mobileWebkit: mobile && webkit,
			mobileWebkit3d: mobile && webkit3d,
			mobileOpera: mobile && window.opera,
	
			touch: touch,
			msPointer: msPointer,
			pointer: pointer,
	
			retina: retina
		};
	
	}());
	
	
	/*
	 * L.Point represents a point with x and y coordinates.
	 */
	
	L.Point = function (/*Number*/ x, /*Number*/ y, /*Boolean*/ round) {
		this.x = (round ? Math.round(x) : x);
		this.y = (round ? Math.round(y) : y);
	};
	
	L.Point.prototype = {
	
		clone: function () {
			return new L.Point(this.x, this.y);
		},
	
		// non-destructive, returns a new point
		add: function (point) {
			return this.clone()._add(L.point(point));
		},
	
		// destructive, used directly for performance in situations where it's safe to modify existing point
		_add: function (point) {
			this.x += point.x;
			this.y += point.y;
			return this;
		},
	
		subtract: function (point) {
			return this.clone()._subtract(L.point(point));
		},
	
		_subtract: function (point) {
			this.x -= point.x;
			this.y -= point.y;
			return this;
		},
	
		divideBy: function (num) {
			return this.clone()._divideBy(num);
		},
	
		_divideBy: function (num) {
			this.x /= num;
			this.y /= num;
			return this;
		},
	
		multiplyBy: function (num) {
			return this.clone()._multiplyBy(num);
		},
	
		_multiplyBy: function (num) {
			this.x *= num;
			this.y *= num;
			return this;
		},
	
		round: function () {
			return this.clone()._round();
		},
	
		_round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			return this;
		},
	
		floor: function () {
			return this.clone()._floor();
		},
	
		_floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			return this;
		},
	
		distanceTo: function (point) {
			point = L.point(point);
	
			var x = point.x - this.x,
			    y = point.y - this.y;
	
			return Math.sqrt(x * x + y * y);
		},
	
		equals: function (point) {
			point = L.point(point);
	
			return point.x === this.x &&
			       point.y === this.y;
		},
	
		contains: function (point) {
			point = L.point(point);
	
			return Math.abs(point.x) <= Math.abs(this.x) &&
			       Math.abs(point.y) <= Math.abs(this.y);
		},
	
		toString: function () {
			return 'Point(' +
			        L.Util.formatNum(this.x) + ', ' +
			        L.Util.formatNum(this.y) + ')';
		}
	};
	
	L.point = function (x, y, round) {
		if (x instanceof L.Point) {
			return x;
		}
		if (L.Util.isArray(x)) {
			return new L.Point(x[0], x[1]);
		}
		if (x === undefined || x === null) {
			return x;
		}
		return new L.Point(x, y, round);
	};
	
	
	/*
	 * L.Bounds represents a rectangular area on the screen in pixel coordinates.
	 */
	
	L.Bounds = function (a, b) { //(Point, Point) or Point[]
		if (!a) { return; }
	
		var points = b ? [a, b] : a;
	
		for (var i = 0, len = points.length; i < len; i++) {
			this.extend(points[i]);
		}
	};
	
	L.Bounds.prototype = {
		// extend the bounds to contain the given point
		extend: function (point) { // (Point)
			point = L.point(point);
	
			if (!this.min && !this.max) {
				this.min = point.clone();
				this.max = point.clone();
			} else {
				this.min.x = Math.min(point.x, this.min.x);
				this.max.x = Math.max(point.x, this.max.x);
				this.min.y = Math.min(point.y, this.min.y);
				this.max.y = Math.max(point.y, this.max.y);
			}
			return this;
		},
	
		getCenter: function (round) { // (Boolean) -> Point
			return new L.Point(
			        (this.min.x + this.max.x) / 2,
			        (this.min.y + this.max.y) / 2, round);
		},
	
		getBottomLeft: function () { // -> Point
			return new L.Point(this.min.x, this.max.y);
		},
	
		getTopRight: function () { // -> Point
			return new L.Point(this.max.x, this.min.y);
		},
	
		getSize: function () {
			return this.max.subtract(this.min);
		},
	
		contains: function (obj) { // (Bounds) or (Point) -> Boolean
			var min, max;
	
			if (typeof obj[0] === 'number' || obj instanceof L.Point) {
				obj = L.point(obj);
			} else {
				obj = L.bounds(obj);
			}
	
			if (obj instanceof L.Bounds) {
				min = obj.min;
				max = obj.max;
			} else {
				min = max = obj;
			}
	
			return (min.x >= this.min.x) &&
			       (max.x <= this.max.x) &&
			       (min.y >= this.min.y) &&
			       (max.y <= this.max.y);
		},
	
		intersects: function (bounds) { // (Bounds) -> Boolean
			bounds = L.bounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
			    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
			return xIntersects && yIntersects;
		},
	
		isValid: function () {
			return !!(this.min && this.max);
		}
	};
	
	L.bounds = function (a, b) { // (Bounds) or (Point, Point) or (Point[])
		if (!a || a instanceof L.Bounds) {
			return a;
		}
		return new L.Bounds(a, b);
	};
	
	
	/*
	 * L.Transformation is an utility class to perform simple point transformations through a 2d-matrix.
	 */
	
	L.Transformation = function (a, b, c, d) {
		this._a = a;
		this._b = b;
		this._c = c;
		this._d = d;
	};
	
	L.Transformation.prototype = {
		transform: function (point, scale) { // (Point, Number) -> Point
			return this._transform(point.clone(), scale);
		},
	
		// destructive transform (faster)
		_transform: function (point, scale) {
			scale = scale || 1;
			point.x = scale * (this._a * point.x + this._b);
			point.y = scale * (this._c * point.y + this._d);
			return point;
		},
	
		untransform: function (point, scale) {
			scale = scale || 1;
			return new L.Point(
			        (point.x / scale - this._b) / this._a,
			        (point.y / scale - this._d) / this._c);
		}
	};
	
	
	/*
	 * L.DomUtil contains various utility functions for working with DOM.
	 */
	
	L.DomUtil = {
		get: function (id) {
			return (typeof id === 'string' ? document.getElementById(id) : id);
		},
	
		getStyle: function (el, style) {
	
			var value = el.style[style];
	
			if (!value && el.currentStyle) {
				value = el.currentStyle[style];
			}
	
			if ((!value || value === 'auto') && document.defaultView) {
				var css = document.defaultView.getComputedStyle(el, null);
				value = css ? css[style] : null;
			}
	
			return value === 'auto' ? null : value;
		},
	
		getViewportOffset: function (element) {
	
			var top = 0,
			    left = 0,
			    el = element,
			    docBody = document.body,
			    docEl = document.documentElement,
			    pos;
	
			do {
				top  += el.offsetTop  || 0;
				left += el.offsetLeft || 0;
	
				//add borders
				top += parseInt(L.DomUtil.getStyle(el, 'borderTopWidth'), 10) || 0;
				left += parseInt(L.DomUtil.getStyle(el, 'borderLeftWidth'), 10) || 0;
	
				pos = L.DomUtil.getStyle(el, 'position');
	
				if (el.offsetParent === docBody && pos === 'absolute') { break; }
	
				if (pos === 'fixed') {
					top  += docBody.scrollTop  || docEl.scrollTop  || 0;
					left += docBody.scrollLeft || docEl.scrollLeft || 0;
					break;
				}
	
				if (pos === 'relative' && !el.offsetLeft) {
					var width = L.DomUtil.getStyle(el, 'width'),
					    maxWidth = L.DomUtil.getStyle(el, 'max-width'),
					    r = el.getBoundingClientRect();
	
					if (width !== 'none' || maxWidth !== 'none') {
						left += r.left + el.clientLeft;
					}
	
					//calculate full y offset since we're breaking out of the loop
					top += r.top + (docBody.scrollTop  || docEl.scrollTop  || 0);
	
					break;
				}
	
				el = el.offsetParent;
	
			} while (el);
	
			el = element;
	
			do {
				if (el === docBody) { break; }
	
				top  -= el.scrollTop  || 0;
				left -= el.scrollLeft || 0;
	
				el = el.parentNode;
			} while (el);
	
			return new L.Point(left, top);
		},
	
		documentIsLtr: function () {
			if (!L.DomUtil._docIsLtrCached) {
				L.DomUtil._docIsLtrCached = true;
				L.DomUtil._docIsLtr = L.DomUtil.getStyle(document.body, 'direction') === 'ltr';
			}
			return L.DomUtil._docIsLtr;
		},
	
		create: function (tagName, className, container) {
	
			var el = document.createElement(tagName);
			el.className = className;
	
			if (container) {
				container.appendChild(el);
			}
	
			return el;
		},
	
		hasClass: function (el, name) {
			if (el.classList !== undefined) {
				return el.classList.contains(name);
			}
			var className = L.DomUtil._getClass(el);
			return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
		},
	
		addClass: function (el, name) {
			if (el.classList !== undefined) {
				var classes = L.Util.splitWords(name);
				for (var i = 0, len = classes.length; i < len; i++) {
					el.classList.add(classes[i]);
				}
			} else if (!L.DomUtil.hasClass(el, name)) {
				var className = L.DomUtil._getClass(el);
				L.DomUtil._setClass(el, (className ? className + ' ' : '') + name);
			}
		},
	
		removeClass: function (el, name) {
			if (el.classList !== undefined) {
				el.classList.remove(name);
			} else {
				L.DomUtil._setClass(el, L.Util.trim((' ' + L.DomUtil._getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
			}
		},
	
		_setClass: function (el, name) {
			if (el.className.baseVal === undefined) {
				el.className = name;
			} else {
				// in case of SVG element
				el.className.baseVal = name;
			}
		},
	
		_getClass: function (el) {
			return el.className.baseVal === undefined ? el.className : el.className.baseVal;
		},
	
		setOpacity: function (el, value) {
	
			if ('opacity' in el.style) {
				el.style.opacity = value;
	
			} else if ('filter' in el.style) {
	
				var filter = false,
				    filterName = 'DXImageTransform.Microsoft.Alpha';
	
				// filters collection throws an error if we try to retrieve a filter that doesn't exist
				try {
					filter = el.filters.item(filterName);
				} catch (e) {
					// don't set opacity to 1 if we haven't already set an opacity,
					// it isn't needed and breaks transparent pngs.
					if (value === 1) { return; }
				}
	
				value = Math.round(value * 100);
	
				if (filter) {
					filter.Enabled = (value !== 100);
					filter.Opacity = value;
				} else {
					el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
				}
			}
		},
	
		testProp: function (props) {
	
			var style = document.documentElement.style;
	
			for (var i = 0; i < props.length; i++) {
				if (props[i] in style) {
					return props[i];
				}
			}
			return false;
		},
	
		getTranslateString: function (point) {
			// on WebKit browsers (Chrome/Safari/iOS Safari/Android) using translate3d instead of translate
			// makes animation smoother as it ensures HW accel is used. Firefox 13 doesn't care
			// (same speed either way), Opera 12 doesn't support translate3d
	
			var is3d = L.Browser.webkit3d,
			    open = 'translate' + (is3d ? '3d' : '') + '(',
			    close = (is3d ? ',0' : '') + ')';
	
			return open + point.x + 'px,' + point.y + 'px' + close;
		},
	
		getScaleString: function (scale, origin) {
	
			var preTranslateStr = L.DomUtil.getTranslateString(origin.add(origin.multiplyBy(-1 * scale))),
			    scaleStr = ' scale(' + scale + ') ';
	
			return preTranslateStr + scaleStr;
		},
	
		setPosition: function (el, point, disable3D) { // (HTMLElement, Point[, Boolean])
	
			// jshint camelcase: false
			el._leaflet_pos = point;
	
			if (!disable3D && L.Browser.any3d) {
				el.style[L.DomUtil.TRANSFORM] =  L.DomUtil.getTranslateString(point);
			} else {
				el.style.left = point.x + 'px';
				el.style.top = point.y + 'px';
			}
		},
	
		getPosition: function (el) {
			// this method is only used for elements previously positioned using setPosition,
			// so it's safe to cache the position for performance
	
			// jshint camelcase: false
			return el._leaflet_pos;
		}
	};
	
	
	// prefix style property names
	
	L.DomUtil.TRANSFORM = L.DomUtil.testProp(
	        ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	// webkitTransition comes first because some browser versions that drop vendor prefix don't do
	// the same for the transitionend event, in particular the Android 4.1 stock browser
	
	L.DomUtil.TRANSITION = L.DomUtil.testProp(
	        ['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
	L.DomUtil.TRANSITION_END =
	        L.DomUtil.TRANSITION === 'webkitTransition' || L.DomUtil.TRANSITION === 'OTransition' ?
	        L.DomUtil.TRANSITION + 'End' : 'transitionend';
	
	(function () {
	    if ('onselectstart' in document) {
	        L.extend(L.DomUtil, {
	            disableTextSelection: function () {
	                L.DomEvent.on(window, 'selectstart', L.DomEvent.preventDefault);
	            },
	
	            enableTextSelection: function () {
	                L.DomEvent.off(window, 'selectstart', L.DomEvent.preventDefault);
	            }
	        });
	    } else {
	        var userSelectProperty = L.DomUtil.testProp(
	            ['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
	        L.extend(L.DomUtil, {
	            disableTextSelection: function () {
	                if (userSelectProperty) {
	                    var style = document.documentElement.style;
	                    this._userSelect = style[userSelectProperty];
	                    style[userSelectProperty] = 'none';
	                }
	            },
	
	            enableTextSelection: function () {
	                if (userSelectProperty) {
	                    document.documentElement.style[userSelectProperty] = this._userSelect;
	                    delete this._userSelect;
	                }
	            }
	        });
	    }
	
		L.extend(L.DomUtil, {
			disableImageDrag: function () {
				L.DomEvent.on(window, 'dragstart', L.DomEvent.preventDefault);
			},
	
			enableImageDrag: function () {
				L.DomEvent.off(window, 'dragstart', L.DomEvent.preventDefault);
			}
		});
	})();
	
	
	/*
	 * L.LatLng represents a geographical point with latitude and longitude coordinates.
	 */
	
	L.LatLng = function (lat, lng, alt) { // (Number, Number, Number)
		lat = parseFloat(lat);
		lng = parseFloat(lng);
	
		if (isNaN(lat) || isNaN(lng)) {
			throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
		}
	
		this.lat = lat;
		this.lng = lng;
	
		if (alt !== undefined) {
			this.alt = parseFloat(alt);
		}
	};
	
	L.extend(L.LatLng, {
		DEG_TO_RAD: Math.PI / 180,
		RAD_TO_DEG: 180 / Math.PI,
		MAX_MARGIN: 1.0E-9 // max margin of error for the "equals" check
	});
	
	L.LatLng.prototype = {
		equals: function (obj) { // (LatLng) -> Boolean
			if (!obj) { return false; }
	
			obj = L.latLng(obj);
	
			var margin = Math.max(
			        Math.abs(this.lat - obj.lat),
			        Math.abs(this.lng - obj.lng));
	
			return margin <= L.LatLng.MAX_MARGIN;
		},
	
		toString: function (precision) { // (Number) -> String
			return 'LatLng(' +
			        L.Util.formatNum(this.lat, precision) + ', ' +
			        L.Util.formatNum(this.lng, precision) + ')';
		},
	
		// Haversine distance formula, see http://en.wikipedia.org/wiki/Haversine_formula
		// TODO move to projection code, LatLng shouldn't know about Earth
		distanceTo: function (other) { // (LatLng) -> Number
			other = L.latLng(other);
	
			var R = 6378137, // earth radius in meters
			    d2r = L.LatLng.DEG_TO_RAD,
			    dLat = (other.lat - this.lat) * d2r,
			    dLon = (other.lng - this.lng) * d2r,
			    lat1 = this.lat * d2r,
			    lat2 = other.lat * d2r,
			    sin1 = Math.sin(dLat / 2),
			    sin2 = Math.sin(dLon / 2);
	
			var a = sin1 * sin1 + sin2 * sin2 * Math.cos(lat1) * Math.cos(lat2);
	
			return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		},
	
		wrap: function (a, b) { // (Number, Number) -> LatLng
			var lng = this.lng;
	
			a = a || -180;
			b = b ||  180;
	
			lng = (lng + b) % (b - a) + (lng < a || lng === b ? b : a);
	
			return new L.LatLng(this.lat, lng);
		}
	};
	
	L.latLng = function (a, b) { // (LatLng) or ([Number, Number]) or (Number, Number)
		if (a instanceof L.LatLng) {
			return a;
		}
		if (L.Util.isArray(a)) {
			if (typeof a[0] === 'number' || typeof a[0] === 'string') {
				return new L.LatLng(a[0], a[1], a[2]);
			} else {
				return null;
			}
		}
		if (a === undefined || a === null) {
			return a;
		}
		if (typeof a === 'object' && 'lat' in a) {
			return new L.LatLng(a.lat, 'lng' in a ? a.lng : a.lon);
		}
		if (b === undefined) {
			return null;
		}
		return new L.LatLng(a, b);
	};
	
	
	
	/*
	 * L.LatLngBounds represents a rectangular area on the map in geographical coordinates.
	 */
	
	L.LatLngBounds = function (southWest, northEast) { // (LatLng, LatLng) or (LatLng[])
		if (!southWest) { return; }
	
		var latlngs = northEast ? [southWest, northEast] : southWest;
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			this.extend(latlngs[i]);
		}
	};
	
	L.LatLngBounds.prototype = {
		// extend the bounds to contain the given point or bounds
		extend: function (obj) { // (LatLng) or (LatLngBounds)
			if (!obj) { return this; }
	
			var latLng = L.latLng(obj);
			if (latLng !== null) {
				obj = latLng;
			} else {
				obj = L.latLngBounds(obj);
			}
	
			if (obj instanceof L.LatLng) {
				if (!this._southWest && !this._northEast) {
					this._southWest = new L.LatLng(obj.lat, obj.lng);
					this._northEast = new L.LatLng(obj.lat, obj.lng);
				} else {
					this._southWest.lat = Math.min(obj.lat, this._southWest.lat);
					this._southWest.lng = Math.min(obj.lng, this._southWest.lng);
	
					this._northEast.lat = Math.max(obj.lat, this._northEast.lat);
					this._northEast.lng = Math.max(obj.lng, this._northEast.lng);
				}
			} else if (obj instanceof L.LatLngBounds) {
				this.extend(obj._southWest);
				this.extend(obj._northEast);
			}
			return this;
		},
	
		// extend the bounds by a percentage
		pad: function (bufferRatio) { // (Number) -> LatLngBounds
			var sw = this._southWest,
			    ne = this._northEast,
			    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
			    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
			return new L.LatLngBounds(
			        new L.LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
			        new L.LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
		},
	
		getCenter: function () { // -> LatLng
			return new L.LatLng(
			        (this._southWest.lat + this._northEast.lat) / 2,
			        (this._southWest.lng + this._northEast.lng) / 2);
		},
	
		getSouthWest: function () {
			return this._southWest;
		},
	
		getNorthEast: function () {
			return this._northEast;
		},
	
		getNorthWest: function () {
			return new L.LatLng(this.getNorth(), this.getWest());
		},
	
		getSouthEast: function () {
			return new L.LatLng(this.getSouth(), this.getEast());
		},
	
		getWest: function () {
			return this._southWest.lng;
		},
	
		getSouth: function () {
			return this._southWest.lat;
		},
	
		getEast: function () {
			return this._northEast.lng;
		},
	
		getNorth: function () {
			return this._northEast.lat;
		},
	
		contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
			if (typeof obj[0] === 'number' || obj instanceof L.LatLng) {
				obj = L.latLng(obj);
			} else {
				obj = L.latLngBounds(obj);
			}
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof L.LatLngBounds) {
				sw2 = obj.getSouthWest();
				ne2 = obj.getNorthEast();
			} else {
				sw2 = ne2 = obj;
			}
	
			return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
			       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
		},
	
		intersects: function (bounds) { // (LatLngBounds)
			bounds = L.latLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
			    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
			return latIntersects && lngIntersects;
		},
	
		toBBoxString: function () {
			return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
		},
	
		equals: function (bounds) { // (LatLngBounds)
			if (!bounds) { return false; }
	
			bounds = L.latLngBounds(bounds);
	
			return this._southWest.equals(bounds.getSouthWest()) &&
			       this._northEast.equals(bounds.getNorthEast());
		},
	
		isValid: function () {
			return !!(this._southWest && this._northEast);
		}
	};
	
	//TODO International date line?
	
	L.latLngBounds = function (a, b) { // (LatLngBounds) or (LatLng, LatLng)
		if (!a || a instanceof L.LatLngBounds) {
			return a;
		}
		return new L.LatLngBounds(a, b);
	};
	
	
	/*
	 * L.Projection contains various geographical projections used by CRS classes.
	 */
	
	L.Projection = {};
	
	
	/*
	 * Spherical Mercator is the most popular map projection, used by EPSG:3857 CRS used by default.
	 */
	
	L.Projection.SphericalMercator = {
		MAX_LATITUDE: 85.0511287798,
	
		project: function (latlng) { // (LatLng) -> Point
			var d = L.LatLng.DEG_TO_RAD,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    x = latlng.lng * d,
			    y = lat * d;
	
			y = Math.log(Math.tan((Math.PI / 4) + (y / 2)));
	
			return new L.Point(x, y);
		},
	
		unproject: function (point) { // (Point, Boolean) -> LatLng
			var d = L.LatLng.RAD_TO_DEG,
			    lng = point.x * d,
			    lat = (2 * Math.atan(Math.exp(point.y)) - (Math.PI / 2)) * d;
	
			return new L.LatLng(lat, lng);
		}
	};
	
	
	/*
	 * Simple equirectangular (Plate Carree) projection, used by CRS like EPSG:4326 and Simple.
	 */
	
	L.Projection.LonLat = {
		project: function (latlng) {
			return new L.Point(latlng.lng, latlng.lat);
		},
	
		unproject: function (point) {
			return new L.LatLng(point.y, point.x);
		}
	};
	
	
	/*
	 * L.CRS is a base object for all defined CRS (Coordinate Reference Systems) in Leaflet.
	 */
	
	L.CRS = {
		latLngToPoint: function (latlng, zoom) { // (LatLng, Number) -> Point
			var projectedPoint = this.projection.project(latlng),
			    scale = this.scale(zoom);
	
			return this.transformation._transform(projectedPoint, scale);
		},
	
		pointToLatLng: function (point, zoom) { // (Point, Number[, Boolean]) -> LatLng
			var scale = this.scale(zoom),
			    untransformedPoint = this.transformation.untransform(point, scale);
	
			return this.projection.unproject(untransformedPoint);
		},
	
		project: function (latlng) {
			return this.projection.project(latlng);
		},
	
		scale: function (zoom) {
			return 256 * Math.pow(2, zoom);
		},
	
		getSize: function (zoom) {
			var s = this.scale(zoom);
			return L.point(s, s);
		}
	};
	
	
	/*
	 * A simple CRS that can be used for flat non-Earth maps like panoramas or game maps.
	 */
	
	L.CRS.Simple = L.extend({}, L.CRS, {
		projection: L.Projection.LonLat,
		transformation: new L.Transformation(1, 0, -1, 0),
	
		scale: function (zoom) {
			return Math.pow(2, zoom);
		}
	});
	
	
	/*
	 * L.CRS.EPSG3857 (Spherical Mercator) is the most common CRS for web mapping
	 * and is used by Leaflet by default.
	 */
	
	L.CRS.EPSG3857 = L.extend({}, L.CRS, {
		code: 'EPSG:3857',
	
		projection: L.Projection.SphericalMercator,
		transformation: new L.Transformation(0.5 / Math.PI, 0.5, -0.5 / Math.PI, 0.5),
	
		project: function (latlng) { // (LatLng) -> Point
			var projectedPoint = this.projection.project(latlng),
			    earthRadius = 6378137;
			return projectedPoint.multiplyBy(earthRadius);
		}
	});
	
	L.CRS.EPSG900913 = L.extend({}, L.CRS.EPSG3857, {
		code: 'EPSG:900913'
	});
	
	
	/*
	 * L.CRS.EPSG4326 is a CRS popular among advanced GIS specialists.
	 */
	
	L.CRS.EPSG4326 = L.extend({}, L.CRS, {
		code: 'EPSG:4326',
	
		projection: L.Projection.LonLat,
		transformation: new L.Transformation(1 / 360, 0.5, -1 / 360, 0.5)
	});
	
	
	/*
	 * L.Map is the central class of the API - it is used to create a map.
	 */
	
	L.Map = L.Class.extend({
	
		includes: L.Mixin.Events,
	
		options: {
			crs: L.CRS.EPSG3857,
	
			/*
			center: LatLng,
			zoom: Number,
			layers: Array,
			*/
	
			fadeAnimation: L.DomUtil.TRANSITION && !L.Browser.android23,
			trackResize: true,
			markerZoomAnimation: L.DomUtil.TRANSITION && L.Browser.any3d
		},
	
		initialize: function (id, options) { // (HTMLElement or String, Object)
			options = L.setOptions(this, options);
	
	
			this._initContainer(id);
			this._initLayout();
	
			// hack for https://github.com/Leaflet/Leaflet/issues/1980
			this._onResize = L.bind(this._onResize, this);
	
			this._initEvents();
	
			if (options.maxBounds) {
				this.setMaxBounds(options.maxBounds);
			}
	
			if (options.center && options.zoom !== undefined) {
				this.setView(L.latLng(options.center), options.zoom, {reset: true});
			}
	
			this._handlers = [];
	
			this._layers = {};
			this._zoomBoundLayers = {};
			this._tileLayersNum = 0;
	
			this.callInitHooks();
	
			this._addLayers(options.layers);
		},
	
	
		// public methods that modify map state
	
		// replaced by animation-powered implementation in Map.PanAnimation.js
		setView: function (center, zoom) {
			zoom = zoom === undefined ? this.getZoom() : zoom;
			this._resetView(L.latLng(center), this._limitZoom(zoom));
			return this;
		},
	
		setZoom: function (zoom, options) {
			if (!this._loaded) {
				this._zoom = this._limitZoom(zoom);
				return this;
			}
			return this.setView(this.getCenter(), zoom, {zoom: options});
		},
	
		zoomIn: function (delta, options) {
			return this.setZoom(this._zoom + (delta || 1), options);
		},
	
		zoomOut: function (delta, options) {
			return this.setZoom(this._zoom - (delta || 1), options);
		},
	
		setZoomAround: function (latlng, zoom, options) {
			var scale = this.getZoomScale(zoom),
			    viewHalf = this.getSize().divideBy(2),
			    containerPoint = latlng instanceof L.Point ? latlng : this.latLngToContainerPoint(latlng),
	
			    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
			    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
			return this.setView(newCenter, zoom, {zoom: options});
		},
	
		fitBounds: function (bounds, options) {
	
			options = options || {};
			bounds = bounds.getBounds ? bounds.getBounds() : L.latLngBounds(bounds);
	
			var paddingTL = L.point(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = L.point(options.paddingBottomRight || options.padding || [0, 0]),
	
			    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
			zoom = (options.maxZoom) ? Math.min(options.maxZoom, zoom) : zoom;
	
			var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
			    swPoint = this.project(bounds.getSouthWest(), zoom),
			    nePoint = this.project(bounds.getNorthEast(), zoom),
			    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
			return this.setView(center, zoom, options);
		},
	
		fitWorld: function (options) {
			return this.fitBounds([[-90, -180], [90, 180]], options);
		},
	
		panTo: function (center, options) { // (LatLng)
			return this.setView(center, this._zoom, {pan: options});
		},
	
		panBy: function (offset) { // (Point)
			// replaced with animated panBy in Map.PanAnimation.js
			this.fire('movestart');
	
			this._rawPanBy(L.point(offset));
	
			this.fire('move');
			return this.fire('moveend');
		},
	
		setMaxBounds: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			this.options.maxBounds = bounds;
	
			if (!bounds) {
				return this.off('moveend', this._panInsideMaxBounds, this);
			}
	
			if (this._loaded) {
				this._panInsideMaxBounds();
			}
	
			return this.on('moveend', this._panInsideMaxBounds, this);
		},
	
		panInsideBounds: function (bounds, options) {
			var center = this.getCenter(),
				newCenter = this._limitCenter(center, this._zoom, bounds);
	
			if (center.equals(newCenter)) { return this; }
	
			return this.panTo(newCenter, options);
		},
	
		addLayer: function (layer) {
			// TODO method is too big, refactor
	
			var id = L.stamp(layer);
	
			if (this._layers[id]) { return this; }
	
			this._layers[id] = layer;
	
			// TODO getMaxZoom, getMinZoom in ILayer (instead of options)
			if (layer.options && (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom))) {
				this._zoomBoundLayers[id] = layer;
				this._updateZoomLevels();
			}
	
			// TODO looks ugly, refactor!!!
			if (this.options.zoomAnimation && L.TileLayer && (layer instanceof L.TileLayer)) {
				this._tileLayersNum++;
				this._tileLayersToLoad++;
				layer.on('load', this._onTileLayerLoad, this);
			}
	
			if (this._loaded) {
				this._layerAdd(layer);
			}
	
			return this;
		},
	
		removeLayer: function (layer) {
			var id = L.stamp(layer);
	
			if (!this._layers[id]) { return this; }
	
			if (this._loaded) {
				layer.onRemove(this);
			}
	
			delete this._layers[id];
	
			if (this._loaded) {
				this.fire('layerremove', {layer: layer});
			}
	
			if (this._zoomBoundLayers[id]) {
				delete this._zoomBoundLayers[id];
				this._updateZoomLevels();
			}
	
			// TODO looks ugly, refactor
			if (this.options.zoomAnimation && L.TileLayer && (layer instanceof L.TileLayer)) {
				this._tileLayersNum--;
				this._tileLayersToLoad--;
				layer.off('load', this._onTileLayerLoad, this);
			}
	
			return this;
		},
	
		hasLayer: function (layer) {
			if (!layer) { return false; }
	
			return (L.stamp(layer) in this._layers);
		},
	
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		invalidateSize: function (options) {
			if (!this._loaded) { return this; }
	
			options = L.extend({
				animate: false,
				pan: true
			}, options === true ? {animate: true} : options);
	
			var oldSize = this.getSize();
			this._sizeChanged = true;
			this._initialCenter = null;
	
			var newSize = this.getSize(),
			    oldCenter = oldSize.divideBy(2).round(),
			    newCenter = newSize.divideBy(2).round(),
			    offset = oldCenter.subtract(newCenter);
	
			if (!offset.x && !offset.y) { return this; }
	
			if (options.animate && options.pan) {
				this.panBy(offset);
	
			} else {
				if (options.pan) {
					this._rawPanBy(offset);
				}
	
				this.fire('move');
	
				if (options.debounceMoveend) {
					clearTimeout(this._sizeTimer);
					this._sizeTimer = setTimeout(L.bind(this.fire, this, 'moveend'), 200);
				} else {
					this.fire('moveend');
				}
			}
	
			return this.fire('resize', {
				oldSize: oldSize,
				newSize: newSize
			});
		},
	
		// TODO handler.addTo
		addHandler: function (name, HandlerClass) {
			if (!HandlerClass) { return this; }
	
			var handler = this[name] = new HandlerClass(this);
	
			this._handlers.push(handler);
	
			if (this.options[name]) {
				handler.enable();
			}
	
			return this;
		},
	
		remove: function () {
			if (this._loaded) {
				this.fire('unload');
			}
	
			this._initEvents('off');
	
			try {
				// throws error in IE6-8
				delete this._container._leaflet;
			} catch (e) {
				this._container._leaflet = undefined;
			}
	
			this._clearPanes();
			if (this._clearControlPos) {
				this._clearControlPos();
			}
	
			this._clearHandlers();
	
			return this;
		},
	
	
		// public methods for getting map state
	
		getCenter: function () { // (Boolean) -> LatLng
			this._checkIfLoaded();
	
			if (this._initialCenter && !this._moved()) {
				return this._initialCenter;
			}
			return this.layerPointToLatLng(this._getCenterLayerPoint());
		},
	
		getZoom: function () {
			return this._zoom;
		},
	
		getBounds: function () {
			var bounds = this.getPixelBounds(),
			    sw = this.unproject(bounds.getBottomLeft()),
			    ne = this.unproject(bounds.getTopRight());
	
			return new L.LatLngBounds(sw, ne);
		},
	
		getMinZoom: function () {
			return this.options.minZoom === undefined ?
				(this._layersMinZoom === undefined ? 0 : this._layersMinZoom) :
				this.options.minZoom;
		},
	
		getMaxZoom: function () {
			return this.options.maxZoom === undefined ?
				(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
				this.options.maxZoom;
		},
	
		getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
			bounds = L.latLngBounds(bounds);
	
			var zoom = this.getMinZoom() - (inside ? 1 : 0),
			    maxZoom = this.getMaxZoom(),
			    size = this.getSize(),
	
			    nw = bounds.getNorthWest(),
			    se = bounds.getSouthEast(),
	
			    zoomNotFound = true,
			    boundsSize;
	
			padding = L.point(padding || [0, 0]);
	
			do {
				zoom++;
				boundsSize = this.project(se, zoom).subtract(this.project(nw, zoom)).add(padding);
				zoomNotFound = !inside ? size.contains(boundsSize) : boundsSize.x < size.x || boundsSize.y < size.y;
	
			} while (zoomNotFound && zoom <= maxZoom);
	
			if (zoomNotFound && inside) {
				return null;
			}
	
			return inside ? zoom : zoom - 1;
		},
	
		getSize: function () {
			if (!this._size || this._sizeChanged) {
				this._size = new L.Point(
					this._container.clientWidth,
					this._container.clientHeight);
	
				this._sizeChanged = false;
			}
			return this._size.clone();
		},
	
		getPixelBounds: function () {
			var topLeftPoint = this._getTopLeftPoint();
			return new L.Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
		},
	
		getPixelOrigin: function () {
			this._checkIfLoaded();
			return this._initialTopLeftPoint;
		},
	
		getPanes: function () {
			return this._panes;
		},
	
		getContainer: function () {
			return this._container;
		},
	
	
		// TODO replace with universal implementation after refactoring projections
	
		getZoomScale: function (toZoom) {
			var crs = this.options.crs;
			return crs.scale(toZoom) / crs.scale(this._zoom);
		},
	
		getScaleZoom: function (scale) {
			return this._zoom + (Math.log(scale) / Math.LN2);
		},
	
	
		// conversion methods
	
		project: function (latlng, zoom) { // (LatLng[, Number]) -> Point
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.latLngToPoint(L.latLng(latlng), zoom);
		},
	
		unproject: function (point, zoom) { // (Point[, Number]) -> LatLng
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.pointToLatLng(L.point(point), zoom);
		},
	
		layerPointToLatLng: function (point) { // (Point)
			var projectedPoint = L.point(point).add(this.getPixelOrigin());
			return this.unproject(projectedPoint);
		},
	
		latLngToLayerPoint: function (latlng) { // (LatLng)
			var projectedPoint = this.project(L.latLng(latlng))._round();
			return projectedPoint._subtract(this.getPixelOrigin());
		},
	
		containerPointToLayerPoint: function (point) { // (Point)
			return L.point(point).subtract(this._getMapPanePos());
		},
	
		layerPointToContainerPoint: function (point) { // (Point)
			return L.point(point).add(this._getMapPanePos());
		},
	
		containerPointToLatLng: function (point) {
			var layerPoint = this.containerPointToLayerPoint(L.point(point));
			return this.layerPointToLatLng(layerPoint);
		},
	
		latLngToContainerPoint: function (latlng) {
			return this.layerPointToContainerPoint(this.latLngToLayerPoint(L.latLng(latlng)));
		},
	
		mouseEventToContainerPoint: function (e) { // (MouseEvent)
			return L.DomEvent.getMousePosition(e, this._container);
		},
	
		mouseEventToLayerPoint: function (e) { // (MouseEvent)
			return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
		},
	
		mouseEventToLatLng: function (e) { // (MouseEvent)
			return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
		},
	
	
		// map initialization methods
	
		_initContainer: function (id) {
			var container = this._container = L.DomUtil.get(id);
	
			if (!container) {
				throw new Error('Map container not found.');
			} else if (container._leaflet) {
				throw new Error('Map container is already initialized.');
			}
	
			container._leaflet = true;
		},
	
		_initLayout: function () {
			var container = this._container;
	
			L.DomUtil.addClass(container, 'leaflet-container' +
				(L.Browser.touch ? ' leaflet-touch' : '') +
				(L.Browser.retina ? ' leaflet-retina' : '') +
				(L.Browser.ielt9 ? ' leaflet-oldie' : '') +
				(this.options.fadeAnimation ? ' leaflet-fade-anim' : ''));
	
			var position = L.DomUtil.getStyle(container, 'position');
	
			if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
				container.style.position = 'relative';
			}
	
			this._initPanes();
	
			if (this._initControlPos) {
				this._initControlPos();
			}
		},
	
		_initPanes: function () {
			var panes = this._panes = {};
	
			this._mapPane = panes.mapPane = this._createPane('leaflet-map-pane', this._container);
	
			this._tilePane = panes.tilePane = this._createPane('leaflet-tile-pane', this._mapPane);
			panes.objectsPane = this._createPane('leaflet-objects-pane', this._mapPane);
			panes.shadowPane = this._createPane('leaflet-shadow-pane');
			panes.overlayPane = this._createPane('leaflet-overlay-pane');
			panes.markerPane = this._createPane('leaflet-marker-pane');
			panes.popupPane = this._createPane('leaflet-popup-pane');
	
			var zoomHide = ' leaflet-zoom-hide';
	
			if (!this.options.markerZoomAnimation) {
				L.DomUtil.addClass(panes.markerPane, zoomHide);
				L.DomUtil.addClass(panes.shadowPane, zoomHide);
				L.DomUtil.addClass(panes.popupPane, zoomHide);
			}
		},
	
		_createPane: function (className, container) {
			return L.DomUtil.create('div', className, container || this._panes.objectsPane);
		},
	
		_clearPanes: function () {
			this._container.removeChild(this._mapPane);
		},
	
		_addLayers: function (layers) {
			layers = layers ? (L.Util.isArray(layers) ? layers : [layers]) : [];
	
			for (var i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		},
	
	
		// private methods that modify map state
	
		_resetView: function (center, zoom, preserveMapOffset, afterZoomAnim) {
	
			var zoomChanged = (this._zoom !== zoom);
	
			if (!afterZoomAnim) {
				this.fire('movestart');
	
				if (zoomChanged) {
					this.fire('zoomstart');
				}
			}
	
			this._zoom = zoom;
			this._initialCenter = center;
	
			this._initialTopLeftPoint = this._getNewTopLeftPoint(center);
	
			if (!preserveMapOffset) {
				L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));
			} else {
				this._initialTopLeftPoint._add(this._getMapPanePos());
			}
	
			this._tileLayersToLoad = this._tileLayersNum;
	
			var loading = !this._loaded;
			this._loaded = true;
	
			this.fire('viewreset', {hard: !preserveMapOffset});
	
			if (loading) {
				this.fire('load');
				this.eachLayer(this._layerAdd, this);
			}
	
			this.fire('move');
	
			if (zoomChanged || afterZoomAnim) {
				this.fire('zoomend');
			}
	
			this.fire('moveend', {hard: !preserveMapOffset});
		},
	
		_rawPanBy: function (offset) {
			L.DomUtil.setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
		},
	
		_getZoomSpan: function () {
			return this.getMaxZoom() - this.getMinZoom();
		},
	
		_updateZoomLevels: function () {
			var i,
				minZoom = Infinity,
				maxZoom = -Infinity,
				oldZoomSpan = this._getZoomSpan();
	
			for (i in this._zoomBoundLayers) {
				var layer = this._zoomBoundLayers[i];
				if (!isNaN(layer.options.minZoom)) {
					minZoom = Math.min(minZoom, layer.options.minZoom);
				}
				if (!isNaN(layer.options.maxZoom)) {
					maxZoom = Math.max(maxZoom, layer.options.maxZoom);
				}
			}
	
			if (i === undefined) { // we have no tilelayers
				this._layersMaxZoom = this._layersMinZoom = undefined;
			} else {
				this._layersMaxZoom = maxZoom;
				this._layersMinZoom = minZoom;
			}
	
			if (oldZoomSpan !== this._getZoomSpan()) {
				this.fire('zoomlevelschange');
			}
		},
	
		_panInsideMaxBounds: function () {
			this.panInsideBounds(this.options.maxBounds);
		},
	
		_checkIfLoaded: function () {
			if (!this._loaded) {
				throw new Error('Set map center and zoom first.');
			}
		},
	
		// map events
	
		_initEvents: function (onOff) {
			if (!L.DomEvent) { return; }
	
			onOff = onOff || 'on';
	
			L.DomEvent[onOff](this._container, 'click', this._onMouseClick, this);
	
			var events = ['dblclick', 'mousedown', 'mouseup', 'mouseenter',
			              'mouseleave', 'mousemove', 'contextmenu'],
			    i, len;
	
			for (i = 0, len = events.length; i < len; i++) {
				L.DomEvent[onOff](this._container, events[i], this._fireMouseEvent, this);
			}
	
			if (this.options.trackResize) {
				L.DomEvent[onOff](window, 'resize', this._onResize, this);
			}
		},
	
		_onResize: function () {
			L.Util.cancelAnimFrame(this._resizeRequest);
			this._resizeRequest = L.Util.requestAnimFrame(
			        function () { this.invalidateSize({debounceMoveend: true}); }, this, false, this._container);
		},
	
		_onMouseClick: function (e) {
			if (!this._loaded || (!e._simulated &&
			        ((this.dragging && this.dragging.moved()) ||
			         (this.boxZoom  && this.boxZoom.moved()))) ||
			            L.DomEvent._skipped(e)) { return; }
	
			this.fire('preclick');
			this._fireMouseEvent(e);
		},
	
		_fireMouseEvent: function (e) {
			if (!this._loaded || L.DomEvent._skipped(e)) { return; }
	
			var type = e.type;
	
			type = (type === 'mouseenter' ? 'mouseover' : (type === 'mouseleave' ? 'mouseout' : type));
	
			if (!this.hasEventListeners(type)) { return; }
	
			if (type === 'contextmenu') {
				L.DomEvent.preventDefault(e);
			}
	
			var containerPoint = this.mouseEventToContainerPoint(e),
			    layerPoint = this.containerPointToLayerPoint(containerPoint),
			    latlng = this.layerPointToLatLng(layerPoint);
	
			this.fire(type, {
				latlng: latlng,
				layerPoint: layerPoint,
				containerPoint: containerPoint,
				originalEvent: e
			});
		},
	
		_onTileLayerLoad: function () {
			this._tileLayersToLoad--;
			if (this._tileLayersNum && !this._tileLayersToLoad) {
				this.fire('tilelayersload');
			}
		},
	
		_clearHandlers: function () {
			for (var i = 0, len = this._handlers.length; i < len; i++) {
				this._handlers[i].disable();
			}
		},
	
		whenReady: function (callback, context) {
			if (this._loaded) {
				callback.call(context || this, this);
			} else {
				this.on('load', callback, context);
			}
			return this;
		},
	
		_layerAdd: function (layer) {
			layer.onAdd(this);
			this.fire('layeradd', {layer: layer});
		},
	
	
		// private methods for getting map state
	
		_getMapPanePos: function () {
			return L.DomUtil.getPosition(this._mapPane);
		},
	
		_moved: function () {
			var pos = this._getMapPanePos();
			return pos && !pos.equals([0, 0]);
		},
	
		_getTopLeftPoint: function () {
			return this.getPixelOrigin().subtract(this._getMapPanePos());
		},
	
		_getNewTopLeftPoint: function (center, zoom) {
			var viewHalf = this.getSize()._divideBy(2);
			// TODO round on display, not calculation to increase precision?
			return this.project(center, zoom)._subtract(viewHalf)._round();
		},
	
		_latLngToNewLayerPoint: function (latlng, newZoom, newCenter) {
			var topLeft = this._getNewTopLeftPoint(newCenter, newZoom).add(this._getMapPanePos());
			return this.project(latlng, newZoom)._subtract(topLeft);
		},
	
		// layer point of the current center
		_getCenterLayerPoint: function () {
			return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
		},
	
		// offset of the specified place to the current center in pixels
		_getCenterOffset: function (latlng) {
			return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
		},
	
		// adjust center for view to get inside bounds
		_limitCenter: function (center, zoom, bounds) {
	
			if (!bounds) { return center; }
	
			var centerPoint = this.project(center, zoom),
			    viewHalf = this.getSize().divideBy(2),
			    viewBounds = new L.Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
			    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
			return this.unproject(centerPoint.add(offset), zoom);
		},
	
		// adjust offset for view to get inside bounds
		_limitOffset: function (offset, bounds) {
			if (!bounds) { return offset; }
	
			var viewBounds = this.getPixelBounds(),
			    newBounds = new L.Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
			return offset.add(this._getBoundsOffset(newBounds, bounds));
		},
	
		// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
		_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
			var nwOffset = this.project(maxBounds.getNorthWest(), zoom).subtract(pxBounds.min),
			    seOffset = this.project(maxBounds.getSouthEast(), zoom).subtract(pxBounds.max),
	
			    dx = this._rebound(nwOffset.x, -seOffset.x),
			    dy = this._rebound(nwOffset.y, -seOffset.y);
	
			return new L.Point(dx, dy);
		},
	
		_rebound: function (left, right) {
			return left + right > 0 ?
				Math.round(left - right) / 2 :
				Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
		},
	
		_limitZoom: function (zoom) {
			var min = this.getMinZoom(),
			    max = this.getMaxZoom();
	
			return Math.max(min, Math.min(max, zoom));
		}
	});
	
	L.map = function (id, options) {
		return new L.Map(id, options);
	};
	
	
	/*
	 * Mercator projection that takes into account that the Earth is not a perfect sphere.
	 * Less popular than spherical mercator; used by projections like EPSG:3395.
	 */
	
	L.Projection.Mercator = {
		MAX_LATITUDE: 85.0840591556,
	
		R_MINOR: 6356752.314245179,
		R_MAJOR: 6378137,
	
		project: function (latlng) { // (LatLng) -> Point
			var d = L.LatLng.DEG_TO_RAD,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    r = this.R_MAJOR,
			    r2 = this.R_MINOR,
			    x = latlng.lng * d * r,
			    y = lat * d,
			    tmp = r2 / r,
			    eccent = Math.sqrt(1.0 - tmp * tmp),
			    con = eccent * Math.sin(y);
	
			con = Math.pow((1 - con) / (1 + con), eccent * 0.5);
	
			var ts = Math.tan(0.5 * ((Math.PI * 0.5) - y)) / con;
			y = -r * Math.log(ts);
	
			return new L.Point(x, y);
		},
	
		unproject: function (point) { // (Point, Boolean) -> LatLng
			var d = L.LatLng.RAD_TO_DEG,
			    r = this.R_MAJOR,
			    r2 = this.R_MINOR,
			    lng = point.x * d / r,
			    tmp = r2 / r,
			    eccent = Math.sqrt(1 - (tmp * tmp)),
			    ts = Math.exp(- point.y / r),
			    phi = (Math.PI / 2) - 2 * Math.atan(ts),
			    numIter = 15,
			    tol = 1e-7,
			    i = numIter,
			    dphi = 0.1,
			    con;
	
			while ((Math.abs(dphi) > tol) && (--i > 0)) {
				con = eccent * Math.sin(phi);
				dphi = (Math.PI / 2) - 2 * Math.atan(ts *
				            Math.pow((1.0 - con) / (1.0 + con), 0.5 * eccent)) - phi;
				phi += dphi;
			}
	
			return new L.LatLng(phi * d, lng);
		}
	};
	
	
	
	L.CRS.EPSG3395 = L.extend({}, L.CRS, {
		code: 'EPSG:3395',
	
		projection: L.Projection.Mercator,
	
		transformation: (function () {
			var m = L.Projection.Mercator,
			    r = m.R_MAJOR,
			    scale = 0.5 / (Math.PI * r);
	
			return new L.Transformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	
	/*
	 * L.TileLayer is used for standard xyz-numbered tile layers.
	 */
	
	L.TileLayer = L.Class.extend({
		includes: L.Mixin.Events,
	
		options: {
			minZoom: 0,
			maxZoom: 18,
			tileSize: 256,
			subdomains: 'abc',
			errorTileUrl: '',
			attribution: '',
			zoomOffset: 0,
			opacity: 1,
			/*
			maxNativeZoom: null,
			zIndex: null,
			tms: false,
			continuousWorld: false,
			noWrap: false,
			zoomReverse: false,
			detectRetina: false,
			reuseTiles: false,
			bounds: false,
			*/
			unloadInvisibleTiles: L.Browser.mobile,
			updateWhenIdle: L.Browser.mobile
		},
	
		initialize: function (url, options) {
			options = L.setOptions(this, options);
	
			// detecting retina displays, adjusting tileSize and zoom levels
			if (options.detectRetina && L.Browser.retina && options.maxZoom > 0) {
	
				options.tileSize = Math.floor(options.tileSize / 2);
				options.zoomOffset++;
	
				if (options.minZoom > 0) {
					options.minZoom--;
				}
				this.options.maxZoom--;
			}
	
			if (options.bounds) {
				options.bounds = L.latLngBounds(options.bounds);
			}
	
			this._url = url;
	
			var subdomains = this.options.subdomains;
	
			if (typeof subdomains === 'string') {
				this.options.subdomains = subdomains.split('');
			}
		},
	
		onAdd: function (map) {
			this._map = map;
			this._animated = map._zoomAnimated;
	
			// create a container div for tiles
			this._initContainer();
	
			// set up events
			map.on({
				'viewreset': this._reset,
				'moveend': this._update
			}, this);
	
			if (this._animated) {
				map.on({
					'zoomanim': this._animateZoom,
					'zoomend': this._endZoomAnim
				}, this);
			}
	
			if (!this.options.updateWhenIdle) {
				this._limitedUpdate = L.Util.limitExecByInterval(this._update, 150, this);
				map.on('move', this._limitedUpdate, this);
			}
	
			this._reset();
			this._update();
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		onRemove: function (map) {
			this._container.parentNode.removeChild(this._container);
	
			map.off({
				'viewreset': this._reset,
				'moveend': this._update
			}, this);
	
			if (this._animated) {
				map.off({
					'zoomanim': this._animateZoom,
					'zoomend': this._endZoomAnim
				}, this);
			}
	
			if (!this.options.updateWhenIdle) {
				map.off('move', this._limitedUpdate, this);
			}
	
			this._container = null;
			this._map = null;
		},
	
		bringToFront: function () {
			var pane = this._map._panes.tilePane;
	
			if (this._container) {
				pane.appendChild(this._container);
				this._setAutoZIndex(pane, Math.max);
			}
	
			return this;
		},
	
		bringToBack: function () {
			var pane = this._map._panes.tilePane;
	
			if (this._container) {
				pane.insertBefore(this._container, pane.firstChild);
				this._setAutoZIndex(pane, Math.min);
			}
	
			return this;
		},
	
		getAttribution: function () {
			return this.options.attribution;
		},
	
		getContainer: function () {
			return this._container;
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		setZIndex: function (zIndex) {
			this.options.zIndex = zIndex;
			this._updateZIndex();
	
			return this;
		},
	
		setUrl: function (url, noRedraw) {
			this._url = url;
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		},
	
		redraw: function () {
			if (this._map) {
				this._reset({hard: true});
				this._update();
			}
			return this;
		},
	
		_updateZIndex: function () {
			if (this._container && this.options.zIndex !== undefined) {
				this._container.style.zIndex = this.options.zIndex;
			}
		},
	
		_setAutoZIndex: function (pane, compare) {
	
			var layers = pane.children,
			    edgeZIndex = -compare(Infinity, -Infinity), // -Infinity for max, Infinity for min
			    zIndex, i, len;
	
			for (i = 0, len = layers.length; i < len; i++) {
	
				if (layers[i] !== this._container) {
					zIndex = parseInt(layers[i].style.zIndex, 10);
	
					if (!isNaN(zIndex)) {
						edgeZIndex = compare(edgeZIndex, zIndex);
					}
				}
			}
	
			this.options.zIndex = this._container.style.zIndex =
			        (isFinite(edgeZIndex) ? edgeZIndex : 0) + compare(1, -1);
		},
	
		_updateOpacity: function () {
			var i,
			    tiles = this._tiles;
	
			if (L.Browser.ielt9) {
				for (i in tiles) {
					L.DomUtil.setOpacity(tiles[i], this.options.opacity);
				}
			} else {
				L.DomUtil.setOpacity(this._container, this.options.opacity);
			}
		},
	
		_initContainer: function () {
			var tilePane = this._map._panes.tilePane;
	
			if (!this._container) {
				this._container = L.DomUtil.create('div', 'leaflet-layer');
	
				this._updateZIndex();
	
				if (this._animated) {
					var className = 'leaflet-tile-container';
	
					this._bgBuffer = L.DomUtil.create('div', className, this._container);
					this._tileContainer = L.DomUtil.create('div', className, this._container);
	
				} else {
					this._tileContainer = this._container;
				}
	
				tilePane.appendChild(this._container);
	
				if (this.options.opacity < 1) {
					this._updateOpacity();
				}
			}
		},
	
		_reset: function (e) {
			for (var key in this._tiles) {
				this.fire('tileunload', {tile: this._tiles[key]});
			}
	
			this._tiles = {};
			this._tilesToLoad = 0;
	
			if (this.options.reuseTiles) {
				this._unusedTiles = [];
			}
	
			this._tileContainer.innerHTML = '';
	
			if (this._animated && e && e.hard) {
				this._clearBgBuffer();
			}
	
			this._initContainer();
		},
	
		_getTileSize: function () {
			var map = this._map,
			    zoom = map.getZoom() + this.options.zoomOffset,
			    zoomN = this.options.maxNativeZoom,
			    tileSize = this.options.tileSize;
	
			if (zoomN && zoom > zoomN) {
				tileSize = Math.round(map.getZoomScale(zoom) / map.getZoomScale(zoomN) * tileSize);
			}
	
			return tileSize;
		},
	
		_update: function () {
	
			if (!this._map) { return; }
	
			var map = this._map,
			    bounds = map.getPixelBounds(),
			    zoom = map.getZoom(),
			    tileSize = this._getTileSize();
	
			if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
				return;
			}
	
			var tileBounds = L.bounds(
			        bounds.min.divideBy(tileSize)._floor(),
			        bounds.max.divideBy(tileSize)._floor());
	
			this._addTilesFromCenterOut(tileBounds);
	
			if (this.options.unloadInvisibleTiles || this.options.reuseTiles) {
				this._removeOtherTiles(tileBounds);
			}
		},
	
		_addTilesFromCenterOut: function (bounds) {
			var queue = [],
			    center = bounds.getCenter();
	
			var j, i, point;
	
			for (j = bounds.min.y; j <= bounds.max.y; j++) {
				for (i = bounds.min.x; i <= bounds.max.x; i++) {
					point = new L.Point(i, j);
	
					if (this._tileShouldBeLoaded(point)) {
						queue.push(point);
					}
				}
			}
	
			var tilesToLoad = queue.length;
	
			if (tilesToLoad === 0) { return; }
	
			// load tiles in order of their distance to center
			queue.sort(function (a, b) {
				return a.distanceTo(center) - b.distanceTo(center);
			});
	
			var fragment = document.createDocumentFragment();
	
			// if its the first batch of tiles to load
			if (!this._tilesToLoad) {
				this.fire('loading');
			}
	
			this._tilesToLoad += tilesToLoad;
	
			for (i = 0; i < tilesToLoad; i++) {
				this._addTile(queue[i], fragment);
			}
	
			this._tileContainer.appendChild(fragment);
		},
	
		_tileShouldBeLoaded: function (tilePoint) {
			if ((tilePoint.x + ':' + tilePoint.y) in this._tiles) {
				return false; // already loaded
			}
	
			var options = this.options;
	
			if (!options.continuousWorld) {
				var limit = this._getWrapTileNum();
	
				// don't load if exceeds world bounds
				if ((options.noWrap && (tilePoint.x < 0 || tilePoint.x >= limit.x)) ||
					tilePoint.y < 0 || tilePoint.y >= limit.y) { return false; }
			}
	
			if (options.bounds) {
				var tileSize = this._getTileSize(),
				    nwPoint = tilePoint.multiplyBy(tileSize),
				    sePoint = nwPoint.add([tileSize, tileSize]),
				    nw = this._map.unproject(nwPoint),
				    se = this._map.unproject(sePoint);
	
				// TODO temporary hack, will be removed after refactoring projections
				// https://github.com/Leaflet/Leaflet/issues/1618
				if (!options.continuousWorld && !options.noWrap) {
					nw = nw.wrap();
					se = se.wrap();
				}
	
				if (!options.bounds.intersects([nw, se])) { return false; }
			}
	
			return true;
		},
	
		_removeOtherTiles: function (bounds) {
			var kArr, x, y, key;
	
			for (key in this._tiles) {
				kArr = key.split(':');
				x = parseInt(kArr[0], 10);
				y = parseInt(kArr[1], 10);
	
				// remove tile if it's out of bounds
				if (x < bounds.min.x || x > bounds.max.x || y < bounds.min.y || y > bounds.max.y) {
					this._removeTile(key);
				}
			}
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
	
			this.fire('tileunload', {tile: tile, url: tile.src});
	
			if (this.options.reuseTiles) {
				L.DomUtil.removeClass(tile, 'leaflet-tile-loaded');
				this._unusedTiles.push(tile);
	
			} else if (tile.parentNode === this._tileContainer) {
				this._tileContainer.removeChild(tile);
			}
	
			// for https://github.com/CloudMade/Leaflet/issues/137
			if (!L.Browser.android) {
				tile.onload = null;
				tile.src = L.Util.emptyImageUrl;
			}
	
			delete this._tiles[key];
		},
	
		_addTile: function (tilePoint, container) {
			var tilePos = this._getTilePos(tilePoint);
	
			// get unused tile - or create a new tile
			var tile = this._getTile();
	
			/*
			Chrome 20 layouts much faster with top/left (verify with timeline, frames)
			Android 4 browser has display issues with top/left and requires transform instead
			(other browsers don't currently care) - see debug/hacks/jitter.html for an example
			*/
			L.DomUtil.setPosition(tile, tilePos, L.Browser.chrome);
	
			this._tiles[tilePoint.x + ':' + tilePoint.y] = tile;
	
			this._loadTile(tile, tilePoint);
	
			if (tile.parentNode !== this._tileContainer) {
				container.appendChild(tile);
			}
		},
	
		_getZoomForUrl: function () {
	
			var options = this.options,
			    zoom = this._map.getZoom();
	
			if (options.zoomReverse) {
				zoom = options.maxZoom - zoom;
			}
	
			zoom += options.zoomOffset;
	
			return options.maxNativeZoom ? Math.min(zoom, options.maxNativeZoom) : zoom;
		},
	
		_getTilePos: function (tilePoint) {
			var origin = this._map.getPixelOrigin(),
			    tileSize = this._getTileSize();
	
			return tilePoint.multiplyBy(tileSize).subtract(origin);
		},
	
		// image-specific code (override to implement e.g. Canvas or SVG tile layer)
	
		getTileUrl: function (tilePoint) {
			return L.Util.template(this._url, L.extend({
				s: this._getSubdomain(tilePoint),
				z: tilePoint.z,
				x: tilePoint.x,
				y: tilePoint.y
			}, this.options));
		},
	
		_getWrapTileNum: function () {
			var crs = this._map.options.crs,
			    size = crs.getSize(this._map.getZoom());
			return size.divideBy(this._getTileSize())._floor();
		},
	
		_adjustTilePoint: function (tilePoint) {
	
			var limit = this._getWrapTileNum();
	
			// wrap tile coordinates
			if (!this.options.continuousWorld && !this.options.noWrap) {
				tilePoint.x = ((tilePoint.x % limit.x) + limit.x) % limit.x;
			}
	
			if (this.options.tms) {
				tilePoint.y = limit.y - tilePoint.y - 1;
			}
	
			tilePoint.z = this._getZoomForUrl();
		},
	
		_getSubdomain: function (tilePoint) {
			var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
			return this.options.subdomains[index];
		},
	
		_getTile: function () {
			if (this.options.reuseTiles && this._unusedTiles.length > 0) {
				var tile = this._unusedTiles.pop();
				this._resetTile(tile);
				return tile;
			}
			return this._createTile();
		},
	
		// Override if data stored on a tile needs to be cleaned up before reuse
		_resetTile: function (/*tile*/) {},
	
		_createTile: function () {
			var tile = L.DomUtil.create('img', 'leaflet-tile');
			tile.style.width = tile.style.height = this._getTileSize() + 'px';
			tile.galleryimg = 'no';
	
			tile.onselectstart = tile.onmousemove = L.Util.falseFn;
	
			if (L.Browser.ielt9 && this.options.opacity !== undefined) {
				L.DomUtil.setOpacity(tile, this.options.opacity);
			}
			// without this hack, tiles disappear after zoom on Chrome for Android
			// https://github.com/Leaflet/Leaflet/issues/2078
			if (L.Browser.mobileWebkit3d) {
				tile.style.WebkitBackfaceVisibility = 'hidden';
			}
			return tile;
		},
	
		_loadTile: function (tile, tilePoint) {
			tile._layer  = this;
			tile.onload  = this._tileOnLoad;
			tile.onerror = this._tileOnError;
	
			this._adjustTilePoint(tilePoint);
			tile.src     = this.getTileUrl(tilePoint);
	
			this.fire('tileloadstart', {
				tile: tile,
				url: tile.src
			});
		},
	
		_tileLoaded: function () {
			this._tilesToLoad--;
	
			if (this._animated) {
				L.DomUtil.addClass(this._tileContainer, 'leaflet-zoom-animated');
			}
	
			if (!this._tilesToLoad) {
				this.fire('load');
	
				if (this._animated) {
					// clear scaled tiles after all new tiles are loaded (for performance)
					clearTimeout(this._clearBgBufferTimer);
					this._clearBgBufferTimer = setTimeout(L.bind(this._clearBgBuffer, this), 500);
				}
			}
		},
	
		_tileOnLoad: function () {
			var layer = this._layer;
	
			//Only if we are loading an actual image
			if (this.src !== L.Util.emptyImageUrl) {
				L.DomUtil.addClass(this, 'leaflet-tile-loaded');
	
				layer.fire('tileload', {
					tile: this,
					url: this.src
				});
			}
	
			layer._tileLoaded();
		},
	
		_tileOnError: function () {
			var layer = this._layer;
	
			layer.fire('tileerror', {
				tile: this,
				url: this.src
			});
	
			var newUrl = layer.options.errorTileUrl;
			if (newUrl) {
				this.src = newUrl;
			}
	
			layer._tileLoaded();
		}
	});
	
	L.tileLayer = function (url, options) {
		return new L.TileLayer(url, options);
	};
	
	
	/*
	 * L.TileLayer.WMS is used for putting WMS tile layers on the map.
	 */
	
	L.TileLayer.WMS = L.TileLayer.extend({
	
		defaultWmsParams: {
			service: 'WMS',
			request: 'GetMap',
			version: '1.1.1',
			layers: '',
			styles: '',
			format: 'image/jpeg',
			transparent: false
		},
	
		initialize: function (url, options) { // (String, Object)
	
			this._url = url;
	
			var wmsParams = L.extend({}, this.defaultWmsParams),
			    tileSize = options.tileSize || this.options.tileSize;
	
			if (options.detectRetina && L.Browser.retina) {
				wmsParams.width = wmsParams.height = tileSize * 2;
			} else {
				wmsParams.width = wmsParams.height = tileSize;
			}
	
			for (var i in options) {
				// all keys that are not TileLayer options go to WMS params
				if (!this.options.hasOwnProperty(i) && i !== 'crs') {
					wmsParams[i] = options[i];
				}
			}
	
			this.wmsParams = wmsParams;
	
			L.setOptions(this, options);
		},
	
		onAdd: function (map) {
	
			this._crs = this.options.crs || map.options.crs;
	
			this._wmsVersion = parseFloat(this.wmsParams.version);
	
			var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
			this.wmsParams[projectionKey] = this._crs.code;
	
			L.TileLayer.prototype.onAdd.call(this, map);
		},
	
		getTileUrl: function (tilePoint) { // (Point, Number) -> String
	
			var map = this._map,
			    tileSize = this.options.tileSize,
	
			    nwPoint = tilePoint.multiplyBy(tileSize),
			    sePoint = nwPoint.add([tileSize, tileSize]),
	
			    nw = this._crs.project(map.unproject(nwPoint, tilePoint.z)),
			    se = this._crs.project(map.unproject(sePoint, tilePoint.z)),
			    bbox = this._wmsVersion >= 1.3 && this._crs === L.CRS.EPSG4326 ?
			        [se.y, nw.x, nw.y, se.x].join(',') :
			        [nw.x, se.y, se.x, nw.y].join(','),
	
			    url = L.Util.template(this._url, {s: this._getSubdomain(tilePoint)});
	
			return url + L.Util.getParamString(this.wmsParams, url, true) + '&BBOX=' + bbox;
		},
	
		setParams: function (params, noRedraw) {
	
			L.extend(this.wmsParams, params);
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		}
	});
	
	L.tileLayer.wms = function (url, options) {
		return new L.TileLayer.WMS(url, options);
	};
	
	
	/*
	 * L.TileLayer.Canvas is a class that you can use as a base for creating
	 * dynamically drawn Canvas-based tile layers.
	 */
	
	L.TileLayer.Canvas = L.TileLayer.extend({
		options: {
			async: false
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		redraw: function () {
			if (this._map) {
				this._reset({hard: true});
				this._update();
			}
	
			for (var i in this._tiles) {
				this._redrawTile(this._tiles[i]);
			}
			return this;
		},
	
		_redrawTile: function (tile) {
			this.drawTile(tile, tile._tilePoint, this._map._zoom);
		},
	
		_createTile: function () {
			var tile = L.DomUtil.create('canvas', 'leaflet-tile');
			tile.width = tile.height = this.options.tileSize;
			tile.onselectstart = tile.onmousemove = L.Util.falseFn;
			return tile;
		},
	
		_loadTile: function (tile, tilePoint) {
			tile._layer = this;
			tile._tilePoint = tilePoint;
	
			this._redrawTile(tile);
	
			if (!this.options.async) {
				this.tileDrawn(tile);
			}
		},
	
		drawTile: function (/*tile, tilePoint*/) {
			// override with rendering code
		},
	
		tileDrawn: function (tile) {
			this._tileOnLoad.call(tile);
		}
	});
	
	
	L.tileLayer.canvas = function (options) {
		return new L.TileLayer.Canvas(options);
	};
	
	
	/*
	 * L.ImageOverlay is used to overlay images over the map (to specific geographical bounds).
	 */
	
	L.ImageOverlay = L.Class.extend({
		includes: L.Mixin.Events,
	
		options: {
			opacity: 1
		},
	
		initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
			this._url = url;
			this._bounds = L.latLngBounds(bounds);
	
			L.setOptions(this, options);
		},
	
		onAdd: function (map) {
			this._map = map;
	
			if (!this._image) {
				this._initImage();
			}
	
			map._panes.overlayPane.appendChild(this._image);
	
			map.on('viewreset', this._reset, this);
	
			if (map.options.zoomAnimation && L.Browser.any3d) {
				map.on('zoomanim', this._animateZoom, this);
			}
	
			this._reset();
		},
	
		onRemove: function (map) {
			map.getPanes().overlayPane.removeChild(this._image);
	
			map.off('viewreset', this._reset, this);
	
			if (map.options.zoomAnimation) {
				map.off('zoomanim', this._animateZoom, this);
			}
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			this._updateOpacity();
			return this;
		},
	
		// TODO remove bringToFront/bringToBack duplication from TileLayer/Path
		bringToFront: function () {
			if (this._image) {
				this._map._panes.overlayPane.appendChild(this._image);
			}
			return this;
		},
	
		bringToBack: function () {
			var pane = this._map._panes.overlayPane;
			if (this._image) {
				pane.insertBefore(this._image, pane.firstChild);
			}
			return this;
		},
	
		setUrl: function (url) {
			this._url = url;
			this._image.src = this._url;
		},
	
		getAttribution: function () {
			return this.options.attribution;
		},
	
		_initImage: function () {
			this._image = L.DomUtil.create('img', 'leaflet-image-layer');
	
			if (this._map.options.zoomAnimation && L.Browser.any3d) {
				L.DomUtil.addClass(this._image, 'leaflet-zoom-animated');
			} else {
				L.DomUtil.addClass(this._image, 'leaflet-zoom-hide');
			}
	
			this._updateOpacity();
	
			//TODO createImage util method to remove duplication
			L.extend(this._image, {
				galleryimg: 'no',
				onselectstart: L.Util.falseFn,
				onmousemove: L.Util.falseFn,
				onload: L.bind(this._onImageLoad, this),
				src: this._url
			});
		},
	
		_animateZoom: function (e) {
			var map = this._map,
			    image = this._image,
			    scale = map.getZoomScale(e.zoom),
			    nw = this._bounds.getNorthWest(),
			    se = this._bounds.getSouthEast(),
	
			    topLeft = map._latLngToNewLayerPoint(nw, e.zoom, e.center),
			    size = map._latLngToNewLayerPoint(se, e.zoom, e.center)._subtract(topLeft),
			    origin = topLeft._add(size._multiplyBy((1 / 2) * (1 - 1 / scale)));
	
			image.style[L.DomUtil.TRANSFORM] =
			        L.DomUtil.getTranslateString(origin) + ' scale(' + scale + ') ';
		},
	
		_reset: function () {
			var image   = this._image,
			    topLeft = this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
			    size = this._map.latLngToLayerPoint(this._bounds.getSouthEast())._subtract(topLeft);
	
			L.DomUtil.setPosition(image, topLeft);
	
			image.style.width  = size.x + 'px';
			image.style.height = size.y + 'px';
		},
	
		_onImageLoad: function () {
			this.fire('load');
		},
	
		_updateOpacity: function () {
			L.DomUtil.setOpacity(this._image, this.options.opacity);
		}
	});
	
	L.imageOverlay = function (url, bounds, options) {
		return new L.ImageOverlay(url, bounds, options);
	};
	
	
	/*
	 * L.Icon is an image-based icon class that you can use with L.Marker for custom markers.
	 */
	
	L.Icon = L.Class.extend({
		options: {
			/*
			iconUrl: (String) (required)
			iconRetinaUrl: (String) (optional, used for retina devices if detected)
			iconSize: (Point) (can be set through CSS)
			iconAnchor: (Point) (centered by default, can be set in CSS with negative margins)
			popupAnchor: (Point) (if not specified, popup opens in the anchor point)
			shadowUrl: (String) (no shadow by default)
			shadowRetinaUrl: (String) (optional, used for retina devices if detected)
			shadowSize: (Point)
			shadowAnchor: (Point)
			*/
			className: ''
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		createIcon: function (oldIcon) {
			return this._createIcon('icon', oldIcon);
		},
	
		createShadow: function (oldIcon) {
			return this._createIcon('shadow', oldIcon);
		},
	
		_createIcon: function (name, oldIcon) {
			var src = this._getIconUrl(name);
	
			if (!src) {
				if (name === 'icon') {
					throw new Error('iconUrl not set in Icon options (see the docs).');
				}
				return null;
			}
	
			var img;
			if (!oldIcon || oldIcon.tagName !== 'IMG') {
				img = this._createImg(src);
			} else {
				img = this._createImg(src, oldIcon);
			}
			this._setIconStyles(img, name);
	
			return img;
		},
	
		_setIconStyles: function (img, name) {
			var options = this.options,
			    size = L.point(options[name + 'Size']),
			    anchor;
	
			if (name === 'shadow') {
				anchor = L.point(options.shadowAnchor || options.iconAnchor);
			} else {
				anchor = L.point(options.iconAnchor);
			}
	
			if (!anchor && size) {
				anchor = size.divideBy(2, true);
			}
	
			img.className = 'leaflet-marker-' + name + ' ' + options.className;
	
			if (anchor) {
				img.style.marginLeft = (-anchor.x) + 'px';
				img.style.marginTop  = (-anchor.y) + 'px';
			}
	
			if (size) {
				img.style.width  = size.x + 'px';
				img.style.height = size.y + 'px';
			}
		},
	
		_createImg: function (src, el) {
			el = el || document.createElement('img');
			el.src = src;
			return el;
		},
	
		_getIconUrl: function (name) {
			if (L.Browser.retina && this.options[name + 'RetinaUrl']) {
				return this.options[name + 'RetinaUrl'];
			}
			return this.options[name + 'Url'];
		}
	});
	
	L.icon = function (options) {
		return new L.Icon(options);
	};
	
	
	/*
	 * L.Icon.Default is the blue marker icon used by default in Leaflet.
	 */
	
	L.Icon.Default = L.Icon.extend({
	
		options: {
			iconSize: [25, 41],
			iconAnchor: [12, 41],
			popupAnchor: [1, -34],
	
			shadowSize: [41, 41]
		},
	
		_getIconUrl: function (name) {
			var key = name + 'Url';
	
			if (this.options[key]) {
				return this.options[key];
			}
	
			if (L.Browser.retina && name === 'icon') {
				name += '-2x';
			}
	
			var path = L.Icon.Default.imagePath;
	
			if (!path) {
				throw new Error('Couldn\'t autodetect L.Icon.Default.imagePath, set it manually.');
			}
	
			return path + '/marker-' + name + '.png';
		}
	});
	
	L.Icon.Default.imagePath = (function () {
		var scripts = document.getElementsByTagName('script'),
		    leafletRe = /[\/^]leaflet[\-\._]?([\w\-\._]*)\.js\??/;
	
		var i, len, src, matches, path;
	
		for (i = 0, len = scripts.length; i < len; i++) {
			src = scripts[i].src;
			matches = src.match(leafletRe);
	
			if (matches) {
				path = src.split(leafletRe)[0];
				return (path ? path + '/' : '') + 'images';
			}
		}
	}());
	
	
	/*
	 * L.Marker is used to display clickable/draggable icons on the map.
	 */
	
	L.Marker = L.Class.extend({
	
		includes: L.Mixin.Events,
	
		options: {
			icon: new L.Icon.Default(),
			title: '',
			alt: '',
			clickable: true,
			draggable: false,
			keyboard: true,
			zIndexOffset: 0,
			opacity: 1,
			riseOnHover: false,
			riseOffset: 250
		},
	
		initialize: function (latlng, options) {
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
		},
	
		onAdd: function (map) {
			this._map = map;
	
			map.on('viewreset', this.update, this);
	
			this._initIcon();
			this.update();
			this.fire('add');
	
			if (map.options.zoomAnimation && map.options.markerZoomAnimation) {
				map.on('zoomanim', this._animateZoom, this);
			}
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		onRemove: function (map) {
			if (this.dragging) {
				this.dragging.disable();
			}
	
			this._removeIcon();
			this._removeShadow();
	
			this.fire('remove');
	
			map.off({
				'viewreset': this.update,
				'zoomanim': this._animateZoom
			}, this);
	
			this._map = null;
		},
	
		getLatLng: function () {
			return this._latlng;
		},
	
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
	
			this.update();
	
			return this.fire('move', { latlng: this._latlng });
		},
	
		setZIndexOffset: function (offset) {
			this.options.zIndexOffset = offset;
			this.update();
	
			return this;
		},
	
		setIcon: function (icon) {
	
			this.options.icon = icon;
	
			if (this._map) {
				this._initIcon();
				this.update();
			}
	
			if (this._popup) {
				this.bindPopup(this._popup);
			}
	
			return this;
		},
	
		update: function () {
			if (this._icon) {
				this._setPos(this._map.latLngToLayerPoint(this._latlng).round());
			}
			return this;
		},
	
		_initIcon: function () {
			var options = this.options,
			    map = this._map,
			    animation = (map.options.zoomAnimation && map.options.markerZoomAnimation),
			    classToAdd = animation ? 'leaflet-zoom-animated' : 'leaflet-zoom-hide';
	
			var icon = options.icon.createIcon(this._icon),
				addIcon = false;
	
			// if we're not reusing the icon, remove the old one and init new one
			if (icon !== this._icon) {
				if (this._icon) {
					this._removeIcon();
				}
				addIcon = true;
	
				if (options.title) {
					icon.title = options.title;
				}
	
				if (options.alt) {
					icon.alt = options.alt;
				}
			}
	
			L.DomUtil.addClass(icon, classToAdd);
	
			if (options.keyboard) {
				icon.tabIndex = '0';
			}
	
			this._icon = icon;
	
			this._initInteraction();
	
			if (options.riseOnHover) {
				L.DomEvent
					.on(icon, 'mouseover', this._bringToFront, this)
					.on(icon, 'mouseout', this._resetZIndex, this);
			}
	
			var newShadow = options.icon.createShadow(this._shadow),
				addShadow = false;
	
			if (newShadow !== this._shadow) {
				this._removeShadow();
				addShadow = true;
			}
	
			if (newShadow) {
				L.DomUtil.addClass(newShadow, classToAdd);
			}
			this._shadow = newShadow;
	
	
			if (options.opacity < 1) {
				this._updateOpacity();
			}
	
	
			var panes = this._map._panes;
	
			if (addIcon) {
				panes.markerPane.appendChild(this._icon);
			}
	
			if (newShadow && addShadow) {
				panes.shadowPane.appendChild(this._shadow);
			}
		},
	
		_removeIcon: function () {
			if (this.options.riseOnHover) {
				L.DomEvent
				    .off(this._icon, 'mouseover', this._bringToFront)
				    .off(this._icon, 'mouseout', this._resetZIndex);
			}
	
			this._map._panes.markerPane.removeChild(this._icon);
	
			this._icon = null;
		},
	
		_removeShadow: function () {
			if (this._shadow) {
				this._map._panes.shadowPane.removeChild(this._shadow);
			}
			this._shadow = null;
		},
	
		_setPos: function (pos) {
			L.DomUtil.setPosition(this._icon, pos);
	
			if (this._shadow) {
				L.DomUtil.setPosition(this._shadow, pos);
			}
	
			this._zIndex = pos.y + this.options.zIndexOffset;
	
			this._resetZIndex();
		},
	
		_updateZIndex: function (offset) {
			this._icon.style.zIndex = this._zIndex + offset;
		},
	
		_animateZoom: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
			this._setPos(pos);
		},
	
		_initInteraction: function () {
	
			if (!this.options.clickable) { return; }
	
			// TODO refactor into something shared with Map/Path/etc. to DRY it up
	
			var icon = this._icon,
			    events = ['dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu'];
	
			L.DomUtil.addClass(icon, 'leaflet-clickable');
			L.DomEvent.on(icon, 'click', this._onMouseClick, this);
			L.DomEvent.on(icon, 'keypress', this._onKeyPress, this);
	
			for (var i = 0; i < events.length; i++) {
				L.DomEvent.on(icon, events[i], this._fireMouseEvent, this);
			}
	
			if (L.Handler.MarkerDrag) {
				this.dragging = new L.Handler.MarkerDrag(this);
	
				if (this.options.draggable) {
					this.dragging.enable();
				}
			}
		},
	
		_onMouseClick: function (e) {
			var wasDragged = this.dragging && this.dragging.moved();
	
			if (this.hasEventListeners(e.type) || wasDragged) {
				L.DomEvent.stopPropagation(e);
			}
	
			if (wasDragged) { return; }
	
			if ((!this.dragging || !this.dragging._enabled) && this._map.dragging && this._map.dragging.moved()) { return; }
	
			this.fire(e.type, {
				originalEvent: e,
				latlng: this._latlng
			});
		},
	
		_onKeyPress: function (e) {
			if (e.keyCode === 13) {
				this.fire('click', {
					originalEvent: e,
					latlng: this._latlng
				});
			}
		},
	
		_fireMouseEvent: function (e) {
	
			this.fire(e.type, {
				originalEvent: e,
				latlng: this._latlng
			});
	
			// TODO proper custom event propagation
			// this line will always be called if marker is in a FeatureGroup
			if (e.type === 'contextmenu' && this.hasEventListeners(e.type)) {
				L.DomEvent.preventDefault(e);
			}
			if (e.type !== 'mousedown') {
				L.DomEvent.stopPropagation(e);
			} else {
				L.DomEvent.preventDefault(e);
			}
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		_updateOpacity: function () {
			L.DomUtil.setOpacity(this._icon, this.options.opacity);
			if (this._shadow) {
				L.DomUtil.setOpacity(this._shadow, this.options.opacity);
			}
		},
	
		_bringToFront: function () {
			this._updateZIndex(this.options.riseOffset);
		},
	
		_resetZIndex: function () {
			this._updateZIndex(0);
		}
	});
	
	L.marker = function (latlng, options) {
		return new L.Marker(latlng, options);
	};
	
	
	/*
	 * L.DivIcon is a lightweight HTML-based icon class (as opposed to the image-based L.Icon)
	 * to use with L.Marker.
	 */
	
	L.DivIcon = L.Icon.extend({
		options: {
			iconSize: [12, 12], // also can be set through CSS
			/*
			iconAnchor: (Point)
			popupAnchor: (Point)
			html: (String)
			bgPos: (Point)
			*/
			className: 'leaflet-div-icon',
			html: false
		},
	
		createIcon: function (oldIcon) {
			var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
			    options = this.options;
	
			if (options.html !== false) {
				div.innerHTML = options.html;
			} else {
				div.innerHTML = '';
			}
	
			if (options.bgPos) {
				div.style.backgroundPosition =
				        (-options.bgPos.x) + 'px ' + (-options.bgPos.y) + 'px';
			}
	
			this._setIconStyles(div, 'icon');
			return div;
		},
	
		createShadow: function () {
			return null;
		}
	});
	
	L.divIcon = function (options) {
		return new L.DivIcon(options);
	};
	
	
	/*
	 * L.Popup is used for displaying popups on the map.
	 */
	
	L.Map.mergeOptions({
		closePopupOnClick: true
	});
	
	L.Popup = L.Class.extend({
		includes: L.Mixin.Events,
	
		options: {
			minWidth: 50,
			maxWidth: 300,
			// maxHeight: null,
			autoPan: true,
			closeButton: true,
			offset: [0, 7],
			autoPanPadding: [5, 5],
			// autoPanPaddingTopLeft: null,
			// autoPanPaddingBottomRight: null,
			keepInView: false,
			className: '',
			zoomAnimation: true
		},
	
		initialize: function (options, source) {
			L.setOptions(this, options);
	
			this._source = source;
			this._animated = L.Browser.any3d && this.options.zoomAnimation;
			this._isOpen = false;
		},
	
		onAdd: function (map) {
			this._map = map;
	
			if (!this._container) {
				this._initLayout();
			}
	
			var animFade = map.options.fadeAnimation;
	
			if (animFade) {
				L.DomUtil.setOpacity(this._container, 0);
			}
			map._panes.popupPane.appendChild(this._container);
	
			map.on(this._getEvents(), this);
	
			this.update();
	
			if (animFade) {
				L.DomUtil.setOpacity(this._container, 1);
			}
	
			this.fire('open');
	
			map.fire('popupopen', {popup: this});
	
			if (this._source) {
				this._source.fire('popupopen', {popup: this});
			}
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		openOn: function (map) {
			map.openPopup(this);
			return this;
		},
	
		onRemove: function (map) {
			map._panes.popupPane.removeChild(this._container);
	
			L.Util.falseFn(this._container.offsetWidth); // force reflow
	
			map.off(this._getEvents(), this);
	
			if (map.options.fadeAnimation) {
				L.DomUtil.setOpacity(this._container, 0);
			}
	
			this._map = null;
	
			this.fire('close');
	
			map.fire('popupclose', {popup: this});
	
			if (this._source) {
				this._source.fire('popupclose', {popup: this});
			}
		},
	
		getLatLng: function () {
			return this._latlng;
		},
	
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
			if (this._map) {
				this._updatePosition();
				this._adjustPan();
			}
			return this;
		},
	
		getContent: function () {
			return this._content;
		},
	
		setContent: function (content) {
			this._content = content;
			this.update();
			return this;
		},
	
		update: function () {
			if (!this._map) { return; }
	
			this._container.style.visibility = 'hidden';
	
			this._updateContent();
			this._updateLayout();
			this._updatePosition();
	
			this._container.style.visibility = '';
	
			this._adjustPan();
		},
	
		_getEvents: function () {
			var events = {
				viewreset: this._updatePosition
			};
	
			if (this._animated) {
				events.zoomanim = this._zoomAnimation;
			}
			if ('closeOnClick' in this.options ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
				events.preclick = this._close;
			}
			if (this.options.keepInView) {
				events.moveend = this._adjustPan;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closePopup(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-popup',
				containerClass = prefix + ' ' + this.options.className + ' leaflet-zoom-' +
				        (this._animated ? 'animated' : 'hide'),
				container = this._container = L.DomUtil.create('div', containerClass),
				closeButton;
	
			if (this.options.closeButton) {
				closeButton = this._closeButton =
				        L.DomUtil.create('a', prefix + '-close-button', container);
				closeButton.href = '#close';
				closeButton.innerHTML = '&#215;';
				L.DomEvent.disableClickPropagation(closeButton);
	
				L.DomEvent.on(closeButton, 'click', this._onCloseButtonClick, this);
			}
	
			var wrapper = this._wrapper =
			        L.DomUtil.create('div', prefix + '-content-wrapper', container);
			L.DomEvent.disableClickPropagation(wrapper);
	
			this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);
	
			L.DomEvent.disableScrollPropagation(this._contentNode);
			L.DomEvent.on(wrapper, 'contextmenu', L.DomEvent.stopPropagation);
	
			this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
			this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
		},
	
		_updateContent: function () {
			if (!this._content) { return; }
	
			if (typeof this._content === 'string') {
				this._contentNode.innerHTML = this._content;
			} else {
				while (this._contentNode.hasChildNodes()) {
					this._contentNode.removeChild(this._contentNode.firstChild);
				}
				this._contentNode.appendChild(this._content);
			}
			this.fire('contentupdate');
		},
	
		_updateLayout: function () {
			var container = this._contentNode,
			    style = container.style;
	
			style.width = '';
			style.whiteSpace = 'nowrap';
	
			var width = container.offsetWidth;
			width = Math.min(width, this.options.maxWidth);
			width = Math.max(width, this.options.minWidth);
	
			style.width = (width + 1) + 'px';
			style.whiteSpace = '';
	
			style.height = '';
	
			var height = container.offsetHeight,
			    maxHeight = this.options.maxHeight,
			    scrolledClass = 'leaflet-popup-scrolled';
	
			if (maxHeight && height > maxHeight) {
				style.height = maxHeight + 'px';
				L.DomUtil.addClass(container, scrolledClass);
			} else {
				L.DomUtil.removeClass(container, scrolledClass);
			}
	
			this._containerWidth = this._container.offsetWidth;
		},
	
		_updatePosition: function () {
			if (!this._map) { return; }
	
			var pos = this._map.latLngToLayerPoint(this._latlng),
			    animated = this._animated,
			    offset = L.point(this.options.offset);
	
			if (animated) {
				L.DomUtil.setPosition(this._container, pos);
			}
	
			this._containerBottom = -offset.y - (animated ? 0 : pos.y);
			this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x + (animated ? 0 : pos.x);
	
			// bottom position the popup in case the height of the popup changes (images loading etc)
			this._container.style.bottom = this._containerBottom + 'px';
			this._container.style.left = this._containerLeft + 'px';
		},
	
		_zoomAnimation: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center);
	
			L.DomUtil.setPosition(this._container, pos);
		},
	
		_adjustPan: function () {
			if (!this.options.autoPan) { return; }
	
			var map = this._map,
			    containerHeight = this._container.offsetHeight,
			    containerWidth = this._containerWidth,
	
			    layerPos = new L.Point(this._containerLeft, -containerHeight - this._containerBottom);
	
			if (this._animated) {
				layerPos._add(L.DomUtil.getPosition(this._container));
			}
	
			var containerPos = map.layerPointToContainerPoint(layerPos),
			    padding = L.point(this.options.autoPanPadding),
			    paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding),
			    paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding),
			    size = map.getSize(),
			    dx = 0,
			    dy = 0;
	
			if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
				dx = containerPos.x + containerWidth - size.x + paddingBR.x;
			}
			if (containerPos.x - dx - paddingTL.x < 0) { // left
				dx = containerPos.x - paddingTL.x;
			}
			if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
				dy = containerPos.y + containerHeight - size.y + paddingBR.y;
			}
			if (containerPos.y - dy - paddingTL.y < 0) { // top
				dy = containerPos.y - paddingTL.y;
			}
	
			if (dx || dy) {
				map
				    .fire('autopanstart')
				    .panBy([dx, dy]);
			}
		},
	
		_onCloseButtonClick: function (e) {
			this._close();
			L.DomEvent.stop(e);
		}
	});
	
	L.popup = function (options, source) {
		return new L.Popup(options, source);
	};
	
	
	L.Map.include({
		openPopup: function (popup, latlng, options) { // (Popup) or (String || HTMLElement, LatLng[, Object])
			this.closePopup();
	
			if (!(popup instanceof L.Popup)) {
				var content = popup;
	
				popup = new L.Popup(options)
				    .setLatLng(latlng)
				    .setContent(content);
			}
			popup._isOpen = true;
	
			this._popup = popup;
			return this.addLayer(popup);
		},
	
		closePopup: function (popup) {
			if (!popup || popup === this._popup) {
				popup = this._popup;
				this._popup = null;
			}
			if (popup) {
				this.removeLayer(popup);
				popup._isOpen = false;
			}
			return this;
		}
	});
	
	
	/*
	 * Popup extension to L.Marker, adding popup-related methods.
	 */
	
	L.Marker.include({
		openPopup: function () {
			if (this._popup && this._map && !this._map.hasLayer(this._popup)) {
				this._popup.setLatLng(this._latlng);
				this._map.openPopup(this._popup);
			}
	
			return this;
		},
	
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		togglePopup: function () {
			if (this._popup) {
				if (this._popup._isOpen) {
					this.closePopup();
				} else {
					this.openPopup();
				}
			}
			return this;
		},
	
		bindPopup: function (content, options) {
			var anchor = L.point(this.options.icon.options.popupAnchor || [0, 0]);
	
			anchor = anchor.add(L.Popup.prototype.options.offset);
	
			if (options && options.offset) {
				anchor = anchor.add(options.offset);
			}
	
			options = L.extend({offset: anchor}, options);
	
			if (!this._popupHandlersAdded) {
				this
				    .on('click', this.togglePopup, this)
				    .on('remove', this.closePopup, this)
				    .on('move', this._movePopup, this);
				this._popupHandlersAdded = true;
			}
	
			if (content instanceof L.Popup) {
				L.setOptions(content, options);
				this._popup = content;
				content._source = this;
			} else {
				this._popup = new L.Popup(options, this)
					.setContent(content);
			}
	
			return this;
		},
	
		setPopupContent: function (content) {
			if (this._popup) {
				this._popup.setContent(content);
			}
			return this;
		},
	
		unbindPopup: function () {
			if (this._popup) {
				this._popup = null;
				this
				    .off('click', this.togglePopup, this)
				    .off('remove', this.closePopup, this)
				    .off('move', this._movePopup, this);
				this._popupHandlersAdded = false;
			}
			return this;
		},
	
		getPopup: function () {
			return this._popup;
		},
	
		_movePopup: function (e) {
			this._popup.setLatLng(e.latlng);
		}
	});
	
	
	/*
	 * L.LayerGroup is a class to combine several layers into one so that
	 * you can manipulate the group (e.g. add/remove it) as one layer.
	 */
	
	L.LayerGroup = L.Class.extend({
		initialize: function (layers) {
			this._layers = {};
	
			var i, len;
	
			if (layers) {
				for (i = 0, len = layers.length; i < len; i++) {
					this.addLayer(layers[i]);
				}
			}
		},
	
		addLayer: function (layer) {
			var id = this.getLayerId(layer);
	
			this._layers[id] = layer;
	
			if (this._map) {
				this._map.addLayer(layer);
			}
	
			return this;
		},
	
		removeLayer: function (layer) {
			var id = layer in this._layers ? layer : this.getLayerId(layer);
	
			if (this._map && this._layers[id]) {
				this._map.removeLayer(this._layers[id]);
			}
	
			delete this._layers[id];
	
			return this;
		},
	
		hasLayer: function (layer) {
			if (!layer) { return false; }
	
			return (layer in this._layers || this.getLayerId(layer) in this._layers);
		},
	
		clearLayers: function () {
			this.eachLayer(this.removeLayer, this);
			return this;
		},
	
		invoke: function (methodName) {
			var args = Array.prototype.slice.call(arguments, 1),
			    i, layer;
	
			for (i in this._layers) {
				layer = this._layers[i];
	
				if (layer[methodName]) {
					layer[methodName].apply(layer, args);
				}
			}
	
			return this;
		},
	
		onAdd: function (map) {
			this._map = map;
			this.eachLayer(map.addLayer, map);
		},
	
		onRemove: function (map) {
			this.eachLayer(map.removeLayer, map);
			this._map = null;
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		getLayer: function (id) {
			return this._layers[id];
		},
	
		getLayers: function () {
			var layers = [];
	
			for (var i in this._layers) {
				layers.push(this._layers[i]);
			}
			return layers;
		},
	
		setZIndex: function (zIndex) {
			return this.invoke('setZIndex', zIndex);
		},
	
		getLayerId: function (layer) {
			return L.stamp(layer);
		}
	});
	
	L.layerGroup = function (layers) {
		return new L.LayerGroup(layers);
	};
	
	
	/*
	 * L.FeatureGroup extends L.LayerGroup by introducing mouse events and additional methods
	 * shared between a group of interactive layers (like vectors or markers).
	 */
	
	L.FeatureGroup = L.LayerGroup.extend({
		includes: L.Mixin.Events,
	
		statics: {
			EVENTS: 'click dblclick mouseover mouseout mousemove contextmenu popupopen popupclose'
		},
	
		addLayer: function (layer) {
			if (this.hasLayer(layer)) {
				return this;
			}
	
			if ('on' in layer) {
				layer.on(L.FeatureGroup.EVENTS, this._propagateEvent, this);
			}
	
			L.LayerGroup.prototype.addLayer.call(this, layer);
	
			if (this._popupContent && layer.bindPopup) {
				layer.bindPopup(this._popupContent, this._popupOptions);
			}
	
			return this.fire('layeradd', {layer: layer});
		},
	
		removeLayer: function (layer) {
			if (!this.hasLayer(layer)) {
				return this;
			}
			if (layer in this._layers) {
				layer = this._layers[layer];
			}
	
			if ('off' in layer) {
				layer.off(L.FeatureGroup.EVENTS, this._propagateEvent, this);
			}
	
			L.LayerGroup.prototype.removeLayer.call(this, layer);
	
			if (this._popupContent) {
				this.invoke('unbindPopup');
			}
	
			return this.fire('layerremove', {layer: layer});
		},
	
		bindPopup: function (content, options) {
			this._popupContent = content;
			this._popupOptions = options;
			return this.invoke('bindPopup', content, options);
		},
	
		openPopup: function (latlng) {
			// open popup on the first layer
			for (var id in this._layers) {
				this._layers[id].openPopup(latlng);
				break;
			}
			return this;
		},
	
		setStyle: function (style) {
			return this.invoke('setStyle', style);
		},
	
		bringToFront: function () {
			return this.invoke('bringToFront');
		},
	
		bringToBack: function () {
			return this.invoke('bringToBack');
		},
	
		getBounds: function () {
			var bounds = new L.LatLngBounds();
	
			this.eachLayer(function (layer) {
				bounds.extend(layer instanceof L.Marker ? layer.getLatLng() : layer.getBounds());
			});
	
			return bounds;
		},
	
		_propagateEvent: function (e) {
			e = L.extend({
				layer: e.target,
				target: this
			}, e);
			this.fire(e.type, e);
		}
	});
	
	L.featureGroup = function (layers) {
		return new L.FeatureGroup(layers);
	};
	
	
	/*
	 * L.Path is a base class for rendering vector paths on a map. Inherited by Polyline, Circle, etc.
	 */
	
	L.Path = L.Class.extend({
		includes: [L.Mixin.Events],
	
		statics: {
			// how much to extend the clip area around the map view
			// (relative to its size, e.g. 0.5 is half the screen in each direction)
			// set it so that SVG element doesn't exceed 1280px (vectors flicker on dragend if it is)
			CLIP_PADDING: (function () {
				var max = L.Browser.mobile ? 1280 : 2000,
				    target = (max / Math.max(window.outerWidth, window.outerHeight) - 1) / 2;
				return Math.max(0, Math.min(0.5, target));
			})()
		},
	
		options: {
			stroke: true,
			color: '#0033ff',
			dashArray: null,
			lineCap: null,
			lineJoin: null,
			weight: 5,
			opacity: 0.5,
	
			fill: false,
			fillColor: null, //same as color by default
			fillOpacity: 0.2,
	
			clickable: true
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		onAdd: function (map) {
			this._map = map;
	
			if (!this._container) {
				this._initElements();
				this._initEvents();
			}
	
			this.projectLatlngs();
			this._updatePath();
	
			if (this._container) {
				this._map._pathRoot.appendChild(this._container);
			}
	
			this.fire('add');
	
			map.on({
				'viewreset': this.projectLatlngs,
				'moveend': this._updatePath
			}, this);
		},
	
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		onRemove: function (map) {
			map._pathRoot.removeChild(this._container);
	
			// Need to fire remove event before we set _map to null as the event hooks might need the object
			this.fire('remove');
			this._map = null;
	
			if (L.Browser.vml) {
				this._container = null;
				this._stroke = null;
				this._fill = null;
			}
	
			map.off({
				'viewreset': this.projectLatlngs,
				'moveend': this._updatePath
			}, this);
		},
	
		projectLatlngs: function () {
			// do all projection stuff here
		},
	
		setStyle: function (style) {
			L.setOptions(this, style);
	
			if (this._container) {
				this._updateStyle();
			}
	
			return this;
		},
	
		redraw: function () {
			if (this._map) {
				this.projectLatlngs();
				this._updatePath();
			}
			return this;
		}
	});
	
	L.Map.include({
		_updatePathViewport: function () {
			var p = L.Path.CLIP_PADDING,
			    size = this.getSize(),
			    panePos = L.DomUtil.getPosition(this._mapPane),
			    min = panePos.multiplyBy(-1)._subtract(size.multiplyBy(p)._round()),
			    max = min.add(size.multiplyBy(1 + p * 2)._round());
	
			this._pathViewport = new L.Bounds(min, max);
		}
	});
	
	
	/*
	 * Extends L.Path with SVG-specific rendering code.
	 */
	
	L.Path.SVG_NS = 'http://www.w3.org/2000/svg';
	
	L.Browser.svg = !!(document.createElementNS && document.createElementNS(L.Path.SVG_NS, 'svg').createSVGRect);
	
	L.Path = L.Path.extend({
		statics: {
			SVG: L.Browser.svg
		},
	
		bringToFront: function () {
			var root = this._map._pathRoot,
			    path = this._container;
	
			if (path && root.lastChild !== path) {
				root.appendChild(path);
			}
			return this;
		},
	
		bringToBack: function () {
			var root = this._map._pathRoot,
			    path = this._container,
			    first = root.firstChild;
	
			if (path && first !== path) {
				root.insertBefore(path, first);
			}
			return this;
		},
	
		getPathString: function () {
			// form path string here
		},
	
		_createElement: function (name) {
			return document.createElementNS(L.Path.SVG_NS, name);
		},
	
		_initElements: function () {
			this._map._initPathRoot();
			this._initPath();
			this._initStyle();
		},
	
		_initPath: function () {
			this._container = this._createElement('g');
	
			this._path = this._createElement('path');
	
			if (this.options.className) {
				L.DomUtil.addClass(this._path, this.options.className);
			}
	
			this._container.appendChild(this._path);
		},
	
		_initStyle: function () {
			if (this.options.stroke) {
				this._path.setAttribute('stroke-linejoin', 'round');
				this._path.setAttribute('stroke-linecap', 'round');
			}
			if (this.options.fill) {
				this._path.setAttribute('fill-rule', 'evenodd');
			}
			if (this.options.pointerEvents) {
				this._path.setAttribute('pointer-events', this.options.pointerEvents);
			}
			if (!this.options.clickable && !this.options.pointerEvents) {
				this._path.setAttribute('pointer-events', 'none');
			}
			this._updateStyle();
		},
	
		_updateStyle: function () {
			if (this.options.stroke) {
				this._path.setAttribute('stroke', this.options.color);
				this._path.setAttribute('stroke-opacity', this.options.opacity);
				this._path.setAttribute('stroke-width', this.options.weight);
				if (this.options.dashArray) {
					this._path.setAttribute('stroke-dasharray', this.options.dashArray);
				} else {
					this._path.removeAttribute('stroke-dasharray');
				}
				if (this.options.lineCap) {
					this._path.setAttribute('stroke-linecap', this.options.lineCap);
				}
				if (this.options.lineJoin) {
					this._path.setAttribute('stroke-linejoin', this.options.lineJoin);
				}
			} else {
				this._path.setAttribute('stroke', 'none');
			}
			if (this.options.fill) {
				this._path.setAttribute('fill', this.options.fillColor || this.options.color);
				this._path.setAttribute('fill-opacity', this.options.fillOpacity);
			} else {
				this._path.setAttribute('fill', 'none');
			}
		},
	
		_updatePath: function () {
			var str = this.getPathString();
			if (!str) {
				// fix webkit empty string parsing bug
				str = 'M0 0';
			}
			this._path.setAttribute('d', str);
		},
	
		// TODO remove duplication with L.Map
		_initEvents: function () {
			if (this.options.clickable) {
				if (L.Browser.svg || !L.Browser.vml) {
					L.DomUtil.addClass(this._path, 'leaflet-clickable');
				}
	
				L.DomEvent.on(this._container, 'click', this._onMouseClick, this);
	
				var events = ['dblclick', 'mousedown', 'mouseover',
				              'mouseout', 'mousemove', 'contextmenu'];
				for (var i = 0; i < events.length; i++) {
					L.DomEvent.on(this._container, events[i], this._fireMouseEvent, this);
				}
			}
		},
	
		_onMouseClick: function (e) {
			if (this._map.dragging && this._map.dragging.moved()) { return; }
	
			this._fireMouseEvent(e);
		},
	
		_fireMouseEvent: function (e) {
			if (!this._map || !this.hasEventListeners(e.type)) { return; }
	
			var map = this._map,
			    containerPoint = map.mouseEventToContainerPoint(e),
			    layerPoint = map.containerPointToLayerPoint(containerPoint),
			    latlng = map.layerPointToLatLng(layerPoint);
	
			this.fire(e.type, {
				latlng: latlng,
				layerPoint: layerPoint,
				containerPoint: containerPoint,
				originalEvent: e
			});
	
			if (e.type === 'contextmenu') {
				L.DomEvent.preventDefault(e);
			}
			if (e.type !== 'mousemove') {
				L.DomEvent.stopPropagation(e);
			}
		}
	});
	
	L.Map.include({
		_initPathRoot: function () {
			if (!this._pathRoot) {
				this._pathRoot = L.Path.prototype._createElement('svg');
				this._panes.overlayPane.appendChild(this._pathRoot);
	
				if (this.options.zoomAnimation && L.Browser.any3d) {
					L.DomUtil.addClass(this._pathRoot, 'leaflet-zoom-animated');
	
					this.on({
						'zoomanim': this._animatePathZoom,
						'zoomend': this._endPathZoom
					});
				} else {
					L.DomUtil.addClass(this._pathRoot, 'leaflet-zoom-hide');
				}
	
				this.on('moveend', this._updateSvgViewport);
				this._updateSvgViewport();
			}
		},
	
		_animatePathZoom: function (e) {
			var scale = this.getZoomScale(e.zoom),
			    offset = this._getCenterOffset(e.center)._multiplyBy(-scale)._add(this._pathViewport.min);
	
			this._pathRoot.style[L.DomUtil.TRANSFORM] =
			        L.DomUtil.getTranslateString(offset) + ' scale(' + scale + ') ';
	
			this._pathZooming = true;
		},
	
		_endPathZoom: function () {
			this._pathZooming = false;
		},
	
		_updateSvgViewport: function () {
	
			if (this._pathZooming) {
				// Do not update SVGs while a zoom animation is going on otherwise the animation will break.
				// When the zoom animation ends we will be updated again anyway
				// This fixes the case where you do a momentum move and zoom while the move is still ongoing.
				return;
			}
	
			this._updatePathViewport();
	
			var vp = this._pathViewport,
			    min = vp.min,
			    max = vp.max,
			    width = max.x - min.x,
			    height = max.y - min.y,
			    root = this._pathRoot,
			    pane = this._panes.overlayPane;
	
			// Hack to make flicker on drag end on mobile webkit less irritating
			if (L.Browser.mobileWebkit) {
				pane.removeChild(root);
			}
	
			L.DomUtil.setPosition(root, min);
			root.setAttribute('width', width);
			root.setAttribute('height', height);
			root.setAttribute('viewBox', [min.x, min.y, width, height].join(' '));
	
			if (L.Browser.mobileWebkit) {
				pane.appendChild(root);
			}
		}
	});
	
	
	/*
	 * Popup extension to L.Path (polylines, polygons, circles), adding popup-related methods.
	 */
	
	L.Path.include({
	
		bindPopup: function (content, options) {
	
			if (content instanceof L.Popup) {
				this._popup = content;
			} else {
				if (!this._popup || options) {
					this._popup = new L.Popup(options, this);
				}
				this._popup.setContent(content);
			}
	
			if (!this._popupHandlersAdded) {
				this
				    .on('click', this._openPopup, this)
				    .on('remove', this.closePopup, this);
	
				this._popupHandlersAdded = true;
			}
	
			return this;
		},
	
		unbindPopup: function () {
			if (this._popup) {
				this._popup = null;
				this
				    .off('click', this._openPopup)
				    .off('remove', this.closePopup);
	
				this._popupHandlersAdded = false;
			}
			return this;
		},
	
		openPopup: function (latlng) {
	
			if (this._popup) {
				// open the popup from one of the path's points if not specified
				latlng = latlng || this._latlng ||
				         this._latlngs[Math.floor(this._latlngs.length / 2)];
	
				this._openPopup({latlng: latlng});
			}
	
			return this;
		},
	
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		_openPopup: function (e) {
			this._popup.setLatLng(e.latlng);
			this._map.openPopup(this._popup);
		}
	});
	
	
	/*
	 * Vector rendering for IE6-8 through VML.
	 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	 */
	
	L.Browser.vml = !L.Browser.svg && (function () {
		try {
			var div = document.createElement('div');
			div.innerHTML = '<v:shape adj="1"/>';
	
			var shape = div.firstChild;
			shape.style.behavior = 'url(#default#VML)';
	
			return shape && (typeof shape.adj === 'object');
	
		} catch (e) {
			return false;
		}
	}());
	
	L.Path = L.Browser.svg || !L.Browser.vml ? L.Path : L.Path.extend({
		statics: {
			VML: true,
			CLIP_PADDING: 0.02
		},
	
		_createElement: (function () {
			try {
				document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
				return function (name) {
					return document.createElement('<lvml:' + name + ' class="lvml">');
				};
			} catch (e) {
				return function (name) {
					return document.createElement(
					        '<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
				};
			}
		}()),
	
		_initPath: function () {
			var container = this._container = this._createElement('shape');
	
			L.DomUtil.addClass(container, 'leaflet-vml-shape' +
				(this.options.className ? ' ' + this.options.className : ''));
	
			if (this.options.clickable) {
				L.DomUtil.addClass(container, 'leaflet-clickable');
			}
	
			container.coordsize = '1 1';
	
			this._path = this._createElement('path');
			container.appendChild(this._path);
	
			this._map._pathRoot.appendChild(container);
		},
	
		_initStyle: function () {
			this._updateStyle();
		},
	
		_updateStyle: function () {
			var stroke = this._stroke,
			    fill = this._fill,
			    options = this.options,
			    container = this._container;
	
			container.stroked = options.stroke;
			container.filled = options.fill;
	
			if (options.stroke) {
				if (!stroke) {
					stroke = this._stroke = this._createElement('stroke');
					stroke.endcap = 'round';
					container.appendChild(stroke);
				}
				stroke.weight = options.weight + 'px';
				stroke.color = options.color;
				stroke.opacity = options.opacity;
	
				if (options.dashArray) {
					stroke.dashStyle = L.Util.isArray(options.dashArray) ?
					    options.dashArray.join(' ') :
					    options.dashArray.replace(/( *, *)/g, ' ');
				} else {
					stroke.dashStyle = '';
				}
				if (options.lineCap) {
					stroke.endcap = options.lineCap.replace('butt', 'flat');
				}
				if (options.lineJoin) {
					stroke.joinstyle = options.lineJoin;
				}
	
			} else if (stroke) {
				container.removeChild(stroke);
				this._stroke = null;
			}
	
			if (options.fill) {
				if (!fill) {
					fill = this._fill = this._createElement('fill');
					container.appendChild(fill);
				}
				fill.color = options.fillColor || options.color;
				fill.opacity = options.fillOpacity;
	
			} else if (fill) {
				container.removeChild(fill);
				this._fill = null;
			}
		},
	
		_updatePath: function () {
			var style = this._container.style;
	
			style.display = 'none';
			this._path.v = this.getPathString() + ' '; // the space fixes IE empty path string bug
			style.display = '';
		}
	});
	
	L.Map.include(L.Browser.svg || !L.Browser.vml ? {} : {
		_initPathRoot: function () {
			if (this._pathRoot) { return; }
	
			var root = this._pathRoot = document.createElement('div');
			root.className = 'leaflet-vml-container';
			this._panes.overlayPane.appendChild(root);
	
			this.on('moveend', this._updatePathViewport);
			this._updatePathViewport();
		}
	});
	
	
	/*
	 * Vector rendering for all browsers that support canvas.
	 */
	
	L.Browser.canvas = (function () {
		return !!document.createElement('canvas').getContext;
	}());
	
	L.Path = (L.Path.SVG && !window.L_PREFER_CANVAS) || !L.Browser.canvas ? L.Path : L.Path.extend({
		statics: {
			//CLIP_PADDING: 0.02, // not sure if there's a need to set it to a small value
			CANVAS: true,
			SVG: false
		},
	
		redraw: function () {
			if (this._map) {
				this.projectLatlngs();
				this._requestUpdate();
			}
			return this;
		},
	
		setStyle: function (style) {
			L.setOptions(this, style);
	
			if (this._map) {
				this._updateStyle();
				this._requestUpdate();
			}
			return this;
		},
	
		onRemove: function (map) {
			map
			    .off('viewreset', this.projectLatlngs, this)
			    .off('moveend', this._updatePath, this);
	
			if (this.options.clickable) {
				this._map.off('click', this._onClick, this);
				this._map.off('mousemove', this._onMouseMove, this);
			}
	
			this._requestUpdate();
			
			this.fire('remove');
			this._map = null;
		},
	
		_requestUpdate: function () {
			if (this._map && !L.Path._updateRequest) {
				L.Path._updateRequest = L.Util.requestAnimFrame(this._fireMapMoveEnd, this._map);
			}
		},
	
		_fireMapMoveEnd: function () {
			L.Path._updateRequest = null;
			this.fire('moveend');
		},
	
		_initElements: function () {
			this._map._initPathRoot();
			this._ctx = this._map._canvasCtx;
		},
	
		_updateStyle: function () {
			var options = this.options;
	
			if (options.stroke) {
				this._ctx.lineWidth = options.weight;
				this._ctx.strokeStyle = options.color;
			}
			if (options.fill) {
				this._ctx.fillStyle = options.fillColor || options.color;
			}
	
			if (options.lineCap) {
				this._ctx.lineCap = options.lineCap;
			}
			if (options.lineJoin) {
				this._ctx.lineJoin = options.lineJoin;
			}
		},
	
		_drawPath: function () {
			var i, j, len, len2, point, drawMethod;
	
			this._ctx.beginPath();
	
			for (i = 0, len = this._parts.length; i < len; i++) {
				for (j = 0, len2 = this._parts[i].length; j < len2; j++) {
					point = this._parts[i][j];
					drawMethod = (j === 0 ? 'move' : 'line') + 'To';
	
					this._ctx[drawMethod](point.x, point.y);
				}
				// TODO refactor ugly hack
				if (this instanceof L.Polygon) {
					this._ctx.closePath();
				}
			}
		},
	
		_checkIfEmpty: function () {
			return !this._parts.length;
		},
	
		_updatePath: function () {
			if (this._checkIfEmpty()) { return; }
	
			var ctx = this._ctx,
			    options = this.options;
	
			this._drawPath();
			ctx.save();
			this._updateStyle();
	
			if (options.fill) {
				ctx.globalAlpha = options.fillOpacity;
				ctx.fill(options.fillRule || 'evenodd');
			}
	
			if (options.stroke) {
				ctx.globalAlpha = options.opacity;
				ctx.stroke();
			}
	
			ctx.restore();
	
			// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
		},
	
		_initEvents: function () {
			if (this.options.clickable) {
				this._map.on('mousemove', this._onMouseMove, this);
				this._map.on('click dblclick contextmenu', this._fireMouseEvent, this);
			}
		},
	
		_fireMouseEvent: function (e) {
			if (this._containsPoint(e.layerPoint)) {
				this.fire(e.type, e);
			}
		},
	
		_onMouseMove: function (e) {
			if (!this._map || this._map._animatingZoom) { return; }
	
			// TODO don't do on each move
			if (this._containsPoint(e.layerPoint)) {
				this._ctx.canvas.style.cursor = 'pointer';
				this._mouseInside = true;
				this.fire('mouseover', e);
	
			} else if (this._mouseInside) {
				this._ctx.canvas.style.cursor = '';
				this._mouseInside = false;
				this.fire('mouseout', e);
			}
		}
	});
	
	L.Map.include((L.Path.SVG && !window.L_PREFER_CANVAS) || !L.Browser.canvas ? {} : {
		_initPathRoot: function () {
			var root = this._pathRoot,
			    ctx;
	
			if (!root) {
				root = this._pathRoot = document.createElement('canvas');
				root.style.position = 'absolute';
				ctx = this._canvasCtx = root.getContext('2d');
	
				ctx.lineCap = 'round';
				ctx.lineJoin = 'round';
	
				this._panes.overlayPane.appendChild(root);
	
				if (this.options.zoomAnimation) {
					this._pathRoot.className = 'leaflet-zoom-animated';
					this.on('zoomanim', this._animatePathZoom);
					this.on('zoomend', this._endPathZoom);
				}
				this.on('moveend', this._updateCanvasViewport);
				this._updateCanvasViewport();
			}
		},
	
		_updateCanvasViewport: function () {
			// don't redraw while zooming. See _updateSvgViewport for more details
			if (this._pathZooming) { return; }
			this._updatePathViewport();
	
			var vp = this._pathViewport,
			    min = vp.min,
			    size = vp.max.subtract(min),
			    root = this._pathRoot;
	
			//TODO check if this works properly on mobile webkit
			L.DomUtil.setPosition(root, min);
			root.width = size.x;
			root.height = size.y;
			root.getContext('2d').translate(-min.x, -min.y);
		}
	});
	
	
	/*
	 * L.LineUtil contains different utility functions for line segments
	 * and polylines (clipping, simplification, distances, etc.)
	 */
	
	/*jshint bitwise:false */ // allow bitwise operations for this file
	
	L.LineUtil = {
	
		// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
		// Improves rendering performance dramatically by lessening the number of points to draw.
	
		simplify: function (/*Point[]*/ points, /*Number*/ tolerance) {
			if (!tolerance || !points.length) {
				return points.slice();
			}
	
			var sqTolerance = tolerance * tolerance;
	
			// stage 1: vertex reduction
			points = this._reducePoints(points, sqTolerance);
	
			// stage 2: Douglas-Peucker simplification
			points = this._simplifyDP(points, sqTolerance);
	
			return points;
		},
	
		// distance from a point to a segment between two points
		pointToSegmentDistance:  function (/*Point*/ p, /*Point*/ p1, /*Point*/ p2) {
			return Math.sqrt(this._sqClosestPointOnSegment(p, p1, p2, true));
		},
	
		closestPointOnSegment: function (/*Point*/ p, /*Point*/ p1, /*Point*/ p2) {
			return this._sqClosestPointOnSegment(p, p1, p2);
		},
	
		// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
		_simplifyDP: function (points, sqTolerance) {
	
			var len = points.length,
			    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
			    markers = new ArrayConstructor(len);
	
			markers[0] = markers[len - 1] = 1;
	
			this._simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
			var i,
			    newPoints = [];
	
			for (i = 0; i < len; i++) {
				if (markers[i]) {
					newPoints.push(points[i]);
				}
			}
	
			return newPoints;
		},
	
		_simplifyDPStep: function (points, markers, sqTolerance, first, last) {
	
			var maxSqDist = 0,
			    index, i, sqDist;
	
			for (i = first + 1; i <= last - 1; i++) {
				sqDist = this._sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
				if (sqDist > maxSqDist) {
					index = i;
					maxSqDist = sqDist;
				}
			}
	
			if (maxSqDist > sqTolerance) {
				markers[index] = 1;
	
				this._simplifyDPStep(points, markers, sqTolerance, first, index);
				this._simplifyDPStep(points, markers, sqTolerance, index, last);
			}
		},
	
		// reduce points that are too close to each other to a single point
		_reducePoints: function (points, sqTolerance) {
			var reducedPoints = [points[0]];
	
			for (var i = 1, prev = 0, len = points.length; i < len; i++) {
				if (this._sqDist(points[i], points[prev]) > sqTolerance) {
					reducedPoints.push(points[i]);
					prev = i;
				}
			}
			if (prev < len - 1) {
				reducedPoints.push(points[len - 1]);
			}
			return reducedPoints;
		},
	
		// Cohen-Sutherland line clipping algorithm.
		// Used to avoid rendering parts of a polyline that are not currently visible.
	
		clipSegment: function (a, b, bounds, useLastCode) {
			var codeA = useLastCode ? this._lastCode : this._getBitCode(a, bounds),
			    codeB = this._getBitCode(b, bounds),
	
			    codeOut, p, newCode;
	
			// save 2nd code to avoid calculating it on the next segment
			this._lastCode = codeB;
	
			while (true) {
				// if a,b is inside the clip window (trivial accept)
				if (!(codeA | codeB)) {
					return [a, b];
				// if a,b is outside the clip window (trivial reject)
				} else if (codeA & codeB) {
					return false;
				// other cases
				} else {
					codeOut = codeA || codeB;
					p = this._getEdgeIntersection(a, b, codeOut, bounds);
					newCode = this._getBitCode(p, bounds);
	
					if (codeOut === codeA) {
						a = p;
						codeA = newCode;
					} else {
						b = p;
						codeB = newCode;
					}
				}
			}
		},
	
		_getEdgeIntersection: function (a, b, code, bounds) {
			var dx = b.x - a.x,
			    dy = b.y - a.y,
			    min = bounds.min,
			    max = bounds.max;
	
			if (code & 8) { // top
				return new L.Point(a.x + dx * (max.y - a.y) / dy, max.y);
			} else if (code & 4) { // bottom
				return new L.Point(a.x + dx * (min.y - a.y) / dy, min.y);
			} else if (code & 2) { // right
				return new L.Point(max.x, a.y + dy * (max.x - a.x) / dx);
			} else if (code & 1) { // left
				return new L.Point(min.x, a.y + dy * (min.x - a.x) / dx);
			}
		},
	
		_getBitCode: function (/*Point*/ p, bounds) {
			var code = 0;
	
			if (p.x < bounds.min.x) { // left
				code |= 1;
			} else if (p.x > bounds.max.x) { // right
				code |= 2;
			}
			if (p.y < bounds.min.y) { // bottom
				code |= 4;
			} else if (p.y > bounds.max.y) { // top
				code |= 8;
			}
	
			return code;
		},
	
		// square distance (to avoid unnecessary Math.sqrt calls)
		_sqDist: function (p1, p2) {
			var dx = p2.x - p1.x,
			    dy = p2.y - p1.y;
			return dx * dx + dy * dy;
		},
	
		// return closest point on segment or distance to that point
		_sqClosestPointOnSegment: function (p, p1, p2, sqDist) {
			var x = p1.x,
			    y = p1.y,
			    dx = p2.x - x,
			    dy = p2.y - y,
			    dot = dx * dx + dy * dy,
			    t;
	
			if (dot > 0) {
				t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
				if (t > 1) {
					x = p2.x;
					y = p2.y;
				} else if (t > 0) {
					x += dx * t;
					y += dy * t;
				}
			}
	
			dx = p.x - x;
			dy = p.y - y;
	
			return sqDist ? dx * dx + dy * dy : new L.Point(x, y);
		}
	};
	
	
	/*
	 * L.Polyline is used to display polylines on a map.
	 */
	
	L.Polyline = L.Path.extend({
		initialize: function (latlngs, options) {
			L.Path.prototype.initialize.call(this, options);
	
			this._latlngs = this._convertLatLngs(latlngs);
		},
	
		options: {
			// how much to simplify the polyline on each zoom level
			// more = better performance and smoother look, less = more accurate
			smoothFactor: 1.0,
			noClip: false
		},
	
		projectLatlngs: function () {
			this._originalPoints = [];
	
			for (var i = 0, len = this._latlngs.length; i < len; i++) {
				this._originalPoints[i] = this._map.latLngToLayerPoint(this._latlngs[i]);
			}
		},
	
		getPathString: function () {
			for (var i = 0, len = this._parts.length, str = ''; i < len; i++) {
				str += this._getPathPartStr(this._parts[i]);
			}
			return str;
		},
	
		getLatLngs: function () {
			return this._latlngs;
		},
	
		setLatLngs: function (latlngs) {
			this._latlngs = this._convertLatLngs(latlngs);
			return this.redraw();
		},
	
		addLatLng: function (latlng) {
			this._latlngs.push(L.latLng(latlng));
			return this.redraw();
		},
	
		spliceLatLngs: function () { // (Number index, Number howMany)
			var removed = [].splice.apply(this._latlngs, arguments);
			this._convertLatLngs(this._latlngs, true);
			this.redraw();
			return removed;
		},
	
		closestLayerPoint: function (p) {
			var minDistance = Infinity, parts = this._parts, p1, p2, minPoint = null;
	
			for (var j = 0, jLen = parts.length; j < jLen; j++) {
				var points = parts[j];
				for (var i = 1, len = points.length; i < len; i++) {
					p1 = points[i - 1];
					p2 = points[i];
					var sqDist = L.LineUtil._sqClosestPointOnSegment(p, p1, p2, true);
					if (sqDist < minDistance) {
						minDistance = sqDist;
						minPoint = L.LineUtil._sqClosestPointOnSegment(p, p1, p2);
					}
				}
			}
			if (minPoint) {
				minPoint.distance = Math.sqrt(minDistance);
			}
			return minPoint;
		},
	
		getBounds: function () {
			return new L.LatLngBounds(this.getLatLngs());
		},
	
		_convertLatLngs: function (latlngs, overwrite) {
			var i, len, target = overwrite ? latlngs : [];
	
			for (i = 0, len = latlngs.length; i < len; i++) {
				if (L.Util.isArray(latlngs[i]) && typeof latlngs[i][0] !== 'number') {
					return;
				}
				target[i] = L.latLng(latlngs[i]);
			}
			return target;
		},
	
		_initEvents: function () {
			L.Path.prototype._initEvents.call(this);
		},
	
		_getPathPartStr: function (points) {
			var round = L.Path.VML;
	
			for (var j = 0, len2 = points.length, str = '', p; j < len2; j++) {
				p = points[j];
				if (round) {
					p._round();
				}
				str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
			}
			return str;
		},
	
		_clipPoints: function () {
			var points = this._originalPoints,
			    len = points.length,
			    i, k, segment;
	
			if (this.options.noClip) {
				this._parts = [points];
				return;
			}
	
			this._parts = [];
	
			var parts = this._parts,
			    vp = this._map._pathViewport,
			    lu = L.LineUtil;
	
			for (i = 0, k = 0; i < len - 1; i++) {
				segment = lu.clipSegment(points[i], points[i + 1], vp, i);
				if (!segment) {
					continue;
				}
	
				parts[k] = parts[k] || [];
				parts[k].push(segment[0]);
	
				// if segment goes out of screen, or it's the last one, it's the end of the line part
				if ((segment[1] !== points[i + 1]) || (i === len - 2)) {
					parts[k].push(segment[1]);
					k++;
				}
			}
		},
	
		// simplify each clipped part of the polyline
		_simplifyPoints: function () {
			var parts = this._parts,
			    lu = L.LineUtil;
	
			for (var i = 0, len = parts.length; i < len; i++) {
				parts[i] = lu.simplify(parts[i], this.options.smoothFactor);
			}
		},
	
		_updatePath: function () {
			if (!this._map) { return; }
	
			this._clipPoints();
			this._simplifyPoints();
	
			L.Path.prototype._updatePath.call(this);
		}
	});
	
	L.polyline = function (latlngs, options) {
		return new L.Polyline(latlngs, options);
	};
	
	
	/*
	 * L.PolyUtil contains utility functions for polygons (clipping, etc.).
	 */
	
	/*jshint bitwise:false */ // allow bitwise operations here
	
	L.PolyUtil = {};
	
	/*
	 * Sutherland-Hodgeman polygon clipping algorithm.
	 * Used to avoid rendering parts of a polygon that are not currently visible.
	 */
	L.PolyUtil.clipPolygon = function (points, bounds) {
		var clippedPoints,
		    edges = [1, 4, 2, 8],
		    i, j, k,
		    a, b,
		    len, edge, p,
		    lu = L.LineUtil;
	
		for (i = 0, len = points.length; i < len; i++) {
			points[i]._code = lu._getBitCode(points[i], bounds);
		}
	
		// for each edge (left, bottom, right, top)
		for (k = 0; k < 4; k++) {
			edge = edges[k];
			clippedPoints = [];
	
			for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
				a = points[i];
				b = points[j];
	
				// if a is inside the clip window
				if (!(a._code & edge)) {
					// if b is outside the clip window (a->b goes out of screen)
					if (b._code & edge) {
						p = lu._getEdgeIntersection(b, a, edge, bounds);
						p._code = lu._getBitCode(p, bounds);
						clippedPoints.push(p);
					}
					clippedPoints.push(a);
	
				// else if b is inside the clip window (a->b enters the screen)
				} else if (!(b._code & edge)) {
					p = lu._getEdgeIntersection(b, a, edge, bounds);
					p._code = lu._getBitCode(p, bounds);
					clippedPoints.push(p);
				}
			}
			points = clippedPoints;
		}
	
		return points;
	};
	
	
	/*
	 * L.Polygon is used to display polygons on a map.
	 */
	
	L.Polygon = L.Polyline.extend({
		options: {
			fill: true
		},
	
		initialize: function (latlngs, options) {
			L.Polyline.prototype.initialize.call(this, latlngs, options);
			this._initWithHoles(latlngs);
		},
	
		_initWithHoles: function (latlngs) {
			var i, len, hole;
			if (latlngs && L.Util.isArray(latlngs[0]) && (typeof latlngs[0][0] !== 'number')) {
				this._latlngs = this._convertLatLngs(latlngs[0]);
				this._holes = latlngs.slice(1);
	
				for (i = 0, len = this._holes.length; i < len; i++) {
					hole = this._holes[i] = this._convertLatLngs(this._holes[i]);
					if (hole[0].equals(hole[hole.length - 1])) {
						hole.pop();
					}
				}
			}
	
			// filter out last point if its equal to the first one
			latlngs = this._latlngs;
	
			if (latlngs.length >= 2 && latlngs[0].equals(latlngs[latlngs.length - 1])) {
				latlngs.pop();
			}
		},
	
		projectLatlngs: function () {
			L.Polyline.prototype.projectLatlngs.call(this);
	
			// project polygon holes points
			// TODO move this logic to Polyline to get rid of duplication
			this._holePoints = [];
	
			if (!this._holes) { return; }
	
			var i, j, len, len2;
	
			for (i = 0, len = this._holes.length; i < len; i++) {
				this._holePoints[i] = [];
	
				for (j = 0, len2 = this._holes[i].length; j < len2; j++) {
					this._holePoints[i][j] = this._map.latLngToLayerPoint(this._holes[i][j]);
				}
			}
		},
	
		setLatLngs: function (latlngs) {
			if (latlngs && L.Util.isArray(latlngs[0]) && (typeof latlngs[0][0] !== 'number')) {
				this._initWithHoles(latlngs);
				return this.redraw();
			} else {
				return L.Polyline.prototype.setLatLngs.call(this, latlngs);
			}
		},
	
		_clipPoints: function () {
			var points = this._originalPoints,
			    newParts = [];
	
			this._parts = [points].concat(this._holePoints);
	
			if (this.options.noClip) { return; }
	
			for (var i = 0, len = this._parts.length; i < len; i++) {
				var clipped = L.PolyUtil.clipPolygon(this._parts[i], this._map._pathViewport);
				if (clipped.length) {
					newParts.push(clipped);
				}
			}
	
			this._parts = newParts;
		},
	
		_getPathPartStr: function (points) {
			var str = L.Polyline.prototype._getPathPartStr.call(this, points);
			return str + (L.Browser.svg ? 'z' : 'x');
		}
	});
	
	L.polygon = function (latlngs, options) {
		return new L.Polygon(latlngs, options);
	};
	
	
	/*
	 * Contains L.MultiPolyline and L.MultiPolygon layers.
	 */
	
	(function () {
		function createMulti(Klass) {
	
			return L.FeatureGroup.extend({
	
				initialize: function (latlngs, options) {
					this._layers = {};
					this._options = options;
					this.setLatLngs(latlngs);
				},
	
				setLatLngs: function (latlngs) {
					var i = 0,
					    len = latlngs.length;
	
					this.eachLayer(function (layer) {
						if (i < len) {
							layer.setLatLngs(latlngs[i++]);
						} else {
							this.removeLayer(layer);
						}
					}, this);
	
					while (i < len) {
						this.addLayer(new Klass(latlngs[i++], this._options));
					}
	
					return this;
				},
	
				getLatLngs: function () {
					var latlngs = [];
	
					this.eachLayer(function (layer) {
						latlngs.push(layer.getLatLngs());
					});
	
					return latlngs;
				}
			});
		}
	
		L.MultiPolyline = createMulti(L.Polyline);
		L.MultiPolygon = createMulti(L.Polygon);
	
		L.multiPolyline = function (latlngs, options) {
			return new L.MultiPolyline(latlngs, options);
		};
	
		L.multiPolygon = function (latlngs, options) {
			return new L.MultiPolygon(latlngs, options);
		};
	}());
	
	
	/*
	 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	 */
	
	L.Rectangle = L.Polygon.extend({
		initialize: function (latLngBounds, options) {
			L.Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
		},
	
		setBounds: function (latLngBounds) {
			this.setLatLngs(this._boundsToLatLngs(latLngBounds));
		},
	
		_boundsToLatLngs: function (latLngBounds) {
			latLngBounds = L.latLngBounds(latLngBounds);
			return [
				latLngBounds.getSouthWest(),
				latLngBounds.getNorthWest(),
				latLngBounds.getNorthEast(),
				latLngBounds.getSouthEast()
			];
		}
	});
	
	L.rectangle = function (latLngBounds, options) {
		return new L.Rectangle(latLngBounds, options);
	};
	
	
	/*
	 * L.Circle is a circle overlay (with a certain radius in meters).
	 */
	
	L.Circle = L.Path.extend({
		initialize: function (latlng, radius, options) {
			L.Path.prototype.initialize.call(this, options);
	
			this._latlng = L.latLng(latlng);
			this._mRadius = radius;
		},
	
		options: {
			fill: true
		},
	
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
			return this.redraw();
		},
	
		setRadius: function (radius) {
			this._mRadius = radius;
			return this.redraw();
		},
	
		projectLatlngs: function () {
			var lngRadius = this._getLngRadius(),
			    latlng = this._latlng,
			    pointLeft = this._map.latLngToLayerPoint([latlng.lat, latlng.lng - lngRadius]);
	
			this._point = this._map.latLngToLayerPoint(latlng);
			this._radius = Math.max(this._point.x - pointLeft.x, 1);
		},
	
		getBounds: function () {
			var lngRadius = this._getLngRadius(),
			    latRadius = (this._mRadius / 40075017) * 360,
			    latlng = this._latlng;
	
			return new L.LatLngBounds(
			        [latlng.lat - latRadius, latlng.lng - lngRadius],
			        [latlng.lat + latRadius, latlng.lng + lngRadius]);
		},
	
		getLatLng: function () {
			return this._latlng;
		},
	
		getPathString: function () {
			var p = this._point,
			    r = this._radius;
	
			if (this._checkIfEmpty()) {
				return '';
			}
	
			if (L.Browser.svg) {
				return 'M' + p.x + ',' + (p.y - r) +
				       'A' + r + ',' + r + ',0,1,1,' +
				       (p.x - 0.1) + ',' + (p.y - r) + ' z';
			} else {
				p._round();
				r = Math.round(r);
				return 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r + ' 0,' + (65535 * 360);
			}
		},
	
		getRadius: function () {
			return this._mRadius;
		},
	
		// TODO Earth hardcoded, move into projection code!
	
		_getLatRadius: function () {
			return (this._mRadius / 40075017) * 360;
		},
	
		_getLngRadius: function () {
			return this._getLatRadius() / Math.cos(L.LatLng.DEG_TO_RAD * this._latlng.lat);
		},
	
		_checkIfEmpty: function () {
			if (!this._map) {
				return false;
			}
			var vp = this._map._pathViewport,
			    r = this._radius,
			    p = this._point;
	
			return p.x - r > vp.max.x || p.y - r > vp.max.y ||
			       p.x + r < vp.min.x || p.y + r < vp.min.y;
		}
	});
	
	L.circle = function (latlng, radius, options) {
		return new L.Circle(latlng, radius, options);
	};
	
	
	/*
	 * L.CircleMarker is a circle overlay with a permanent pixel radius.
	 */
	
	L.CircleMarker = L.Circle.extend({
		options: {
			radius: 10,
			weight: 2
		},
	
		initialize: function (latlng, options) {
			L.Circle.prototype.initialize.call(this, latlng, null, options);
			this._radius = this.options.radius;
		},
	
		projectLatlngs: function () {
			this._point = this._map.latLngToLayerPoint(this._latlng);
		},
	
		_updateStyle : function () {
			L.Circle.prototype._updateStyle.call(this);
			this.setRadius(this.options.radius);
		},
	
		setLatLng: function (latlng) {
			L.Circle.prototype.setLatLng.call(this, latlng);
			if (this._popup && this._popup._isOpen) {
				this._popup.setLatLng(latlng);
			}
			return this;
		},
	
		setRadius: function (radius) {
			this.options.radius = this._radius = radius;
			return this.redraw();
		},
	
		getRadius: function () {
			return this._radius;
		}
	});
	
	L.circleMarker = function (latlng, options) {
		return new L.CircleMarker(latlng, options);
	};
	
	
	/*
	 * Extends L.Polyline to be able to manually detect clicks on Canvas-rendered polylines.
	 */
	
	L.Polyline.include(!L.Path.CANVAS ? {} : {
		_containsPoint: function (p, closed) {
			var i, j, k, len, len2, dist, part,
			    w = this.options.weight / 2;
	
			if (L.Browser.touch) {
				w += 10; // polyline click tolerance on touch devices
			}
	
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					if (!closed && (j === 0)) {
						continue;
					}
	
					dist = L.LineUtil.pointToSegmentDistance(p, part[k], part[j]);
	
					if (dist <= w) {
						return true;
					}
				}
			}
			return false;
		}
	});
	
	
	/*
	 * Extends L.Polygon to be able to manually detect clicks on Canvas-rendered polygons.
	 */
	
	L.Polygon.include(!L.Path.CANVAS ? {} : {
		_containsPoint: function (p) {
			var inside = false,
			    part, p1, p2,
			    i, j, k,
			    len, len2;
	
			// TODO optimization: check if within bounds first
	
			if (L.Polyline.prototype._containsPoint.call(this, p, true)) {
				// click on polygon border
				return true;
			}
	
			// ray casting algorithm for detecting if point is in polygon
	
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
	
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					p1 = part[j];
					p2 = part[k];
	
					if (((p1.y > p.y) !== (p2.y > p.y)) &&
							(p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
						inside = !inside;
					}
				}
			}
	
			return inside;
		}
	});
	
	
	/*
	 * Extends L.Circle with Canvas-specific code.
	 */
	
	L.Circle.include(!L.Path.CANVAS ? {} : {
		_drawPath: function () {
			var p = this._point;
			this._ctx.beginPath();
			this._ctx.arc(p.x, p.y, this._radius, 0, Math.PI * 2, false);
		},
	
		_containsPoint: function (p) {
			var center = this._point,
			    w2 = this.options.stroke ? this.options.weight / 2 : 0;
	
			return (p.distanceTo(center) <= this._radius + w2);
		}
	});
	
	
	/*
	 * CircleMarker canvas specific drawing parts.
	 */
	
	L.CircleMarker.include(!L.Path.CANVAS ? {} : {
		_updateStyle: function () {
			L.Path.prototype._updateStyle.call(this);
		}
	});
	
	
	/*
	 * L.GeoJSON turns any GeoJSON data into a Leaflet layer.
	 */
	
	L.GeoJSON = L.FeatureGroup.extend({
	
		initialize: function (geojson, options) {
			L.setOptions(this, options);
	
			this._layers = {};
	
			if (geojson) {
				this.addData(geojson);
			}
		},
	
		addData: function (geojson) {
			var features = L.Util.isArray(geojson) ? geojson : geojson.features,
			    i, len, feature;
	
			if (features) {
				for (i = 0, len = features.length; i < len; i++) {
					// Only add this if geometry or geometries are set and not null
					feature = features[i];
					if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
						this.addData(features[i]);
					}
				}
				return this;
			}
	
			var options = this.options;
	
			if (options.filter && !options.filter(geojson)) { return; }
	
			var layer = L.GeoJSON.geometryToLayer(geojson, options.pointToLayer, options.coordsToLatLng, options);
			layer.feature = L.GeoJSON.asFeature(geojson);
	
			layer.defaultOptions = layer.options;
			this.resetStyle(layer);
	
			if (options.onEachFeature) {
				options.onEachFeature(geojson, layer);
			}
	
			return this.addLayer(layer);
		},
	
		resetStyle: function (layer) {
			var style = this.options.style;
			if (style) {
				// reset any custom styles
				L.Util.extend(layer.options, layer.defaultOptions);
	
				this._setLayerStyle(layer, style);
			}
		},
	
		setStyle: function (style) {
			this.eachLayer(function (layer) {
				this._setLayerStyle(layer, style);
			}, this);
		},
	
		_setLayerStyle: function (layer, style) {
			if (typeof style === 'function') {
				style = style(layer.feature);
			}
			if (layer.setStyle) {
				layer.setStyle(style);
			}
		}
	});
	
	L.extend(L.GeoJSON, {
		geometryToLayer: function (geojson, pointToLayer, coordsToLatLng, vectorOptions) {
			var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
			    coords = geometry.coordinates,
			    layers = [],
			    latlng, latlngs, i, len;
	
			coordsToLatLng = coordsToLatLng || this.coordsToLatLng;
	
			switch (geometry.type) {
			case 'Point':
				latlng = coordsToLatLng(coords);
				return pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng);
	
			case 'MultiPoint':
				for (i = 0, len = coords.length; i < len; i++) {
					latlng = coordsToLatLng(coords[i]);
					layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng));
				}
				return new L.FeatureGroup(layers);
	
			case 'LineString':
				latlngs = this.coordsToLatLngs(coords, 0, coordsToLatLng);
				return new L.Polyline(latlngs, vectorOptions);
	
			case 'Polygon':
				if (coords.length === 2 && !coords[1].length) {
					throw new Error('Invalid GeoJSON object.');
				}
				latlngs = this.coordsToLatLngs(coords, 1, coordsToLatLng);
				return new L.Polygon(latlngs, vectorOptions);
	
			case 'MultiLineString':
				latlngs = this.coordsToLatLngs(coords, 1, coordsToLatLng);
				return new L.MultiPolyline(latlngs, vectorOptions);
	
			case 'MultiPolygon':
				latlngs = this.coordsToLatLngs(coords, 2, coordsToLatLng);
				return new L.MultiPolygon(latlngs, vectorOptions);
	
			case 'GeometryCollection':
				for (i = 0, len = geometry.geometries.length; i < len; i++) {
	
					layers.push(this.geometryToLayer({
						geometry: geometry.geometries[i],
						type: 'Feature',
						properties: geojson.properties
					}, pointToLayer, coordsToLatLng, vectorOptions));
				}
				return new L.FeatureGroup(layers);
	
			default:
				throw new Error('Invalid GeoJSON object.');
			}
		},
	
		coordsToLatLng: function (coords) { // (Array[, Boolean]) -> LatLng
			return new L.LatLng(coords[1], coords[0], coords[2]);
		},
	
		coordsToLatLngs: function (coords, levelsDeep, coordsToLatLng) { // (Array[, Number, Function]) -> Array
			var latlng, i, len,
			    latlngs = [];
	
			for (i = 0, len = coords.length; i < len; i++) {
				latlng = levelsDeep ?
				        this.coordsToLatLngs(coords[i], levelsDeep - 1, coordsToLatLng) :
				        (coordsToLatLng || this.coordsToLatLng)(coords[i]);
	
				latlngs.push(latlng);
			}
	
			return latlngs;
		},
	
		latLngToCoords: function (latlng) {
			var coords = [latlng.lng, latlng.lat];
	
			if (latlng.alt !== undefined) {
				coords.push(latlng.alt);
			}
			return coords;
		},
	
		latLngsToCoords: function (latLngs) {
			var coords = [];
	
			for (var i = 0, len = latLngs.length; i < len; i++) {
				coords.push(L.GeoJSON.latLngToCoords(latLngs[i]));
			}
	
			return coords;
		},
	
		getFeature: function (layer, newGeometry) {
			return layer.feature ? L.extend({}, layer.feature, {geometry: newGeometry}) : L.GeoJSON.asFeature(newGeometry);
		},
	
		asFeature: function (geoJSON) {
			if (geoJSON.type === 'Feature') {
				return geoJSON;
			}
	
			return {
				type: 'Feature',
				properties: {},
				geometry: geoJSON
			};
		}
	});
	
	var PointToGeoJSON = {
		toGeoJSON: function () {
			return L.GeoJSON.getFeature(this, {
				type: 'Point',
				coordinates: L.GeoJSON.latLngToCoords(this.getLatLng())
			});
		}
	};
	
	L.Marker.include(PointToGeoJSON);
	L.Circle.include(PointToGeoJSON);
	L.CircleMarker.include(PointToGeoJSON);
	
	L.Polyline.include({
		toGeoJSON: function () {
			return L.GeoJSON.getFeature(this, {
				type: 'LineString',
				coordinates: L.GeoJSON.latLngsToCoords(this.getLatLngs())
			});
		}
	});
	
	L.Polygon.include({
		toGeoJSON: function () {
			var coords = [L.GeoJSON.latLngsToCoords(this.getLatLngs())],
			    i, len, hole;
	
			coords[0].push(coords[0][0]);
	
			if (this._holes) {
				for (i = 0, len = this._holes.length; i < len; i++) {
					hole = L.GeoJSON.latLngsToCoords(this._holes[i]);
					hole.push(hole[0]);
					coords.push(hole);
				}
			}
	
			return L.GeoJSON.getFeature(this, {
				type: 'Polygon',
				coordinates: coords
			});
		}
	});
	
	(function () {
		function multiToGeoJSON(type) {
			return function () {
				var coords = [];
	
				this.eachLayer(function (layer) {
					coords.push(layer.toGeoJSON().geometry.coordinates);
				});
	
				return L.GeoJSON.getFeature(this, {
					type: type,
					coordinates: coords
				});
			};
		}
	
		L.MultiPolyline.include({toGeoJSON: multiToGeoJSON('MultiLineString')});
		L.MultiPolygon.include({toGeoJSON: multiToGeoJSON('MultiPolygon')});
	
		L.LayerGroup.include({
			toGeoJSON: function () {
	
				var geometry = this.feature && this.feature.geometry,
					jsons = [],
					json;
	
				if (geometry && geometry.type === 'MultiPoint') {
					return multiToGeoJSON('MultiPoint').call(this);
				}
	
				var isGeometryCollection = geometry && geometry.type === 'GeometryCollection';
	
				this.eachLayer(function (layer) {
					if (layer.toGeoJSON) {
						json = layer.toGeoJSON();
						jsons.push(isGeometryCollection ? json.geometry : L.GeoJSON.asFeature(json));
					}
				});
	
				if (isGeometryCollection) {
					return L.GeoJSON.getFeature(this, {
						geometries: jsons,
						type: 'GeometryCollection'
					});
				}
	
				return {
					type: 'FeatureCollection',
					features: jsons
				};
			}
		});
	}());
	
	L.geoJson = function (geojson, options) {
		return new L.GeoJSON(geojson, options);
	};
	
	
	/*
	 * L.DomEvent contains functions for working with DOM events.
	 */
	
	L.DomEvent = {
		/* inspired by John Resig, Dean Edwards and YUI addEvent implementations */
		addListener: function (obj, type, fn, context) { // (HTMLElement, String, Function[, Object])
	
			var id = L.stamp(fn),
			    key = '_leaflet_' + type + id,
			    handler, originalHandler, newType;
	
			if (obj[key]) { return this; }
	
			handler = function (e) {
				return fn.call(context || obj, e || L.DomEvent._getEvent());
			};
	
			if (L.Browser.pointer && type.indexOf('touch') === 0) {
				return this.addPointerListener(obj, type, handler, id);
			}
			if (L.Browser.touch && (type === 'dblclick') && this.addDoubleTapListener) {
				this.addDoubleTapListener(obj, handler, id);
			}
	
			if ('addEventListener' in obj) {
	
				if (type === 'mousewheel') {
					obj.addEventListener('DOMMouseScroll', handler, false);
					obj.addEventListener(type, handler, false);
	
				} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
	
					originalHandler = handler;
					newType = (type === 'mouseenter' ? 'mouseover' : 'mouseout');
	
					handler = function (e) {
						if (!L.DomEvent._checkMouse(obj, e)) { return; }
						return originalHandler(e);
					};
	
					obj.addEventListener(newType, handler, false);
	
				} else if (type === 'click' && L.Browser.android) {
					originalHandler = handler;
					handler = function (e) {
						return L.DomEvent._filterClick(e, originalHandler);
					};
	
					obj.addEventListener(type, handler, false);
				} else {
					obj.addEventListener(type, handler, false);
				}
	
			} else if ('attachEvent' in obj) {
				obj.attachEvent('on' + type, handler);
			}
	
			obj[key] = handler;
	
			return this;
		},
	
		removeListener: function (obj, type, fn) {  // (HTMLElement, String, Function)
	
			var id = L.stamp(fn),
			    key = '_leaflet_' + type + id,
			    handler = obj[key];
	
			if (!handler) { return this; }
	
			if (L.Browser.pointer && type.indexOf('touch') === 0) {
				this.removePointerListener(obj, type, id);
			} else if (L.Browser.touch && (type === 'dblclick') && this.removeDoubleTapListener) {
				this.removeDoubleTapListener(obj, id);
	
			} else if ('removeEventListener' in obj) {
	
				if (type === 'mousewheel') {
					obj.removeEventListener('DOMMouseScroll', handler, false);
					obj.removeEventListener(type, handler, false);
	
				} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
					obj.removeEventListener((type === 'mouseenter' ? 'mouseover' : 'mouseout'), handler, false);
				} else {
					obj.removeEventListener(type, handler, false);
				}
			} else if ('detachEvent' in obj) {
				obj.detachEvent('on' + type, handler);
			}
	
			obj[key] = null;
	
			return this;
		},
	
		stopPropagation: function (e) {
	
			if (e.stopPropagation) {
				e.stopPropagation();
			} else {
				e.cancelBubble = true;
			}
			L.DomEvent._skipped(e);
	
			return this;
		},
	
		disableScrollPropagation: function (el) {
			var stop = L.DomEvent.stopPropagation;
	
			return L.DomEvent
				.on(el, 'mousewheel', stop)
				.on(el, 'MozMousePixelScroll', stop);
		},
	
		disableClickPropagation: function (el) {
			var stop = L.DomEvent.stopPropagation;
	
			for (var i = L.Draggable.START.length - 1; i >= 0; i--) {
				L.DomEvent.on(el, L.Draggable.START[i], stop);
			}
	
			return L.DomEvent
				.on(el, 'click', L.DomEvent._fakeStop)
				.on(el, 'dblclick', stop);
		},
	
		preventDefault: function (e) {
	
			if (e.preventDefault) {
				e.preventDefault();
			} else {
				e.returnValue = false;
			}
			return this;
		},
	
		stop: function (e) {
			return L.DomEvent
				.preventDefault(e)
				.stopPropagation(e);
		},
	
		getMousePosition: function (e, container) {
			if (!container) {
				return new L.Point(e.clientX, e.clientY);
			}
	
			var rect = container.getBoundingClientRect();
	
			return new L.Point(
				e.clientX - rect.left - container.clientLeft,
				e.clientY - rect.top - container.clientTop);
		},
	
		getWheelDelta: function (e) {
	
			var delta = 0;
	
			if (e.wheelDelta) {
				delta = e.wheelDelta / 120;
			}
			if (e.detail) {
				delta = -e.detail / 3;
			}
			return delta;
		},
	
		_skipEvents: {},
	
		_fakeStop: function (e) {
			// fakes stopPropagation by setting a special event flag, checked/reset with L.DomEvent._skipped(e)
			L.DomEvent._skipEvents[e.type] = true;
		},
	
		_skipped: function (e) {
			var skipped = this._skipEvents[e.type];
			// reset when checking, as it's only used in map container and propagates outside of the map
			this._skipEvents[e.type] = false;
			return skipped;
		},
	
		// check if element really left/entered the event target (for mouseenter/mouseleave)
		_checkMouse: function (el, e) {
	
			var related = e.relatedTarget;
	
			if (!related) { return true; }
	
			try {
				while (related && (related !== el)) {
					related = related.parentNode;
				}
			} catch (err) {
				return false;
			}
			return (related !== el);
		},
	
		_getEvent: function () { // evil magic for IE
			/*jshint noarg:false */
			var e = window.event;
			if (!e) {
				var caller = arguments.callee.caller;
				while (caller) {
					e = caller['arguments'][0];
					if (e && window.Event === e.constructor) {
						break;
					}
					caller = caller.caller;
				}
			}
			return e;
		},
	
		// this is a horrible workaround for a bug in Android where a single touch triggers two click events
		_filterClick: function (e, handler) {
			var timeStamp = (e.timeStamp || e.originalEvent.timeStamp),
				elapsed = L.DomEvent._lastClick && (timeStamp - L.DomEvent._lastClick);
	
			// are they closer together than 500ms yet more than 100ms?
			// Android typically triggers them ~300ms apart while multiple listeners
			// on the same event should be triggered far faster;
			// or check if click is simulated on the element, and if it is, reject any non-simulated events
	
			if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
				L.DomEvent.stop(e);
				return;
			}
			L.DomEvent._lastClick = timeStamp;
	
			return handler(e);
		}
	};
	
	L.DomEvent.on = L.DomEvent.addListener;
	L.DomEvent.off = L.DomEvent.removeListener;
	
	
	/*
	 * L.Draggable allows you to add dragging capabilities to any element. Supports mobile devices too.
	 */
	
	L.Draggable = L.Class.extend({
		includes: L.Mixin.Events,
	
		statics: {
			START: L.Browser.touch ? ['touchstart', 'mousedown'] : ['mousedown'],
			END: {
				mousedown: 'mouseup',
				touchstart: 'touchend',
				pointerdown: 'touchend',
				MSPointerDown: 'touchend'
			},
			MOVE: {
				mousedown: 'mousemove',
				touchstart: 'touchmove',
				pointerdown: 'touchmove',
				MSPointerDown: 'touchmove'
			}
		},
	
		initialize: function (element, dragStartTarget) {
			this._element = element;
			this._dragStartTarget = dragStartTarget || element;
		},
	
		enable: function () {
			if (this._enabled) { return; }
	
			for (var i = L.Draggable.START.length - 1; i >= 0; i--) {
				L.DomEvent.on(this._dragStartTarget, L.Draggable.START[i], this._onDown, this);
			}
	
			this._enabled = true;
		},
	
		disable: function () {
			if (!this._enabled) { return; }
	
			for (var i = L.Draggable.START.length - 1; i >= 0; i--) {
				L.DomEvent.off(this._dragStartTarget, L.Draggable.START[i], this._onDown, this);
			}
	
			this._enabled = false;
			this._moved = false;
		},
	
		_onDown: function (e) {
			this._moved = false;
	
			if (e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
	
			L.DomEvent.stopPropagation(e);
	
			if (L.Draggable._disabled) { return; }
	
			L.DomUtil.disableImageDrag();
			L.DomUtil.disableTextSelection();
	
			if (this._moving) { return; }
	
			var first = e.touches ? e.touches[0] : e;
	
			this._startPoint = new L.Point(first.clientX, first.clientY);
			this._startPos = this._newPos = L.DomUtil.getPosition(this._element);
	
			L.DomEvent
			    .on(document, L.Draggable.MOVE[e.type], this._onMove, this)
			    .on(document, L.Draggable.END[e.type], this._onUp, this);
		},
	
		_onMove: function (e) {
			if (e.touches && e.touches.length > 1) {
				this._moved = true;
				return;
			}
	
			var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
			    newPoint = new L.Point(first.clientX, first.clientY),
			    offset = newPoint.subtract(this._startPoint);
	
			if (!offset.x && !offset.y) { return; }
			if (L.Browser.touch && Math.abs(offset.x) + Math.abs(offset.y) < 3) { return; }
	
			L.DomEvent.preventDefault(e);
	
			if (!this._moved) {
				this.fire('dragstart');
	
				this._moved = true;
				this._startPos = L.DomUtil.getPosition(this._element).subtract(offset);
	
				L.DomUtil.addClass(document.body, 'leaflet-dragging');
				this._lastTarget = e.target || e.srcElement;
				L.DomUtil.addClass(this._lastTarget, 'leaflet-drag-target');
			}
	
			this._newPos = this._startPos.add(offset);
			this._moving = true;
	
			L.Util.cancelAnimFrame(this._animRequest);
			this._animRequest = L.Util.requestAnimFrame(this._updatePosition, this, true, this._dragStartTarget);
		},
	
		_updatePosition: function () {
			this.fire('predrag');
			L.DomUtil.setPosition(this._element, this._newPos);
			this.fire('drag');
		},
	
		_onUp: function () {
			L.DomUtil.removeClass(document.body, 'leaflet-dragging');
	
			if (this._lastTarget) {
				L.DomUtil.removeClass(this._lastTarget, 'leaflet-drag-target');
				this._lastTarget = null;
			}
	
			for (var i in L.Draggable.MOVE) {
				L.DomEvent
				    .off(document, L.Draggable.MOVE[i], this._onMove)
				    .off(document, L.Draggable.END[i], this._onUp);
			}
	
			L.DomUtil.enableImageDrag();
			L.DomUtil.enableTextSelection();
	
			if (this._moved && this._moving) {
				// ensure drag is not fired after dragend
				L.Util.cancelAnimFrame(this._animRequest);
	
				this.fire('dragend', {
					distance: this._newPos.distanceTo(this._startPos)
				});
			}
	
			this._moving = false;
		}
	});
	
	
	/*
		L.Handler is a base class for handler classes that are used internally to inject
		interaction features like dragging to classes like Map and Marker.
	*/
	
	L.Handler = L.Class.extend({
		initialize: function (map) {
			this._map = map;
		},
	
		enable: function () {
			if (this._enabled) { return; }
	
			this._enabled = true;
			this.addHooks();
		},
	
		disable: function () {
			if (!this._enabled) { return; }
	
			this._enabled = false;
			this.removeHooks();
		},
	
		enabled: function () {
			return !!this._enabled;
		}
	});
	
	
	/*
	 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	 */
	
	L.Map.mergeOptions({
		dragging: true,
	
		inertia: !L.Browser.android23,
		inertiaDeceleration: 3400, // px/s^2
		inertiaMaxSpeed: Infinity, // px/s
		inertiaThreshold: L.Browser.touch ? 32 : 18, // ms
		easeLinearity: 0.25,
	
		// TODO refactor, move to CRS
		worldCopyJump: false
	});
	
	L.Map.Drag = L.Handler.extend({
		addHooks: function () {
			if (!this._draggable) {
				var map = this._map;
	
				this._draggable = new L.Draggable(map._mapPane, map._container);
	
				this._draggable.on({
					'dragstart': this._onDragStart,
					'drag': this._onDrag,
					'dragend': this._onDragEnd
				}, this);
	
				if (map.options.worldCopyJump) {
					this._draggable.on('predrag', this._onPreDrag, this);
					map.on('viewreset', this._onViewReset, this);
	
					map.whenReady(this._onViewReset, this);
				}
			}
			this._draggable.enable();
		},
	
		removeHooks: function () {
			this._draggable.disable();
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_onDragStart: function () {
			var map = this._map;
	
			if (map._panAnim) {
				map._panAnim.stop();
			}
	
			map
			    .fire('movestart')
			    .fire('dragstart');
	
			if (map.options.inertia) {
				this._positions = [];
				this._times = [];
			}
		},
	
		_onDrag: function () {
			if (this._map.options.inertia) {
				var time = this._lastTime = +new Date(),
				    pos = this._lastPos = this._draggable._newPos;
	
				this._positions.push(pos);
				this._times.push(time);
	
				if (time - this._times[0] > 200) {
					this._positions.shift();
					this._times.shift();
				}
			}
	
			this._map
			    .fire('move')
			    .fire('drag');
		},
	
		_onViewReset: function () {
			// TODO fix hardcoded Earth values
			var pxCenter = this._map.getSize()._divideBy(2),
			    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
			this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
			this._worldWidth = this._map.project([0, 180]).x;
		},
	
		_onPreDrag: function () {
			// TODO refactor to be able to adjust map pane position after zoom
			var worldWidth = this._worldWidth,
			    halfWidth = Math.round(worldWidth / 2),
			    dx = this._initialWorldOffset,
			    x = this._draggable._newPos.x,
			    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
			    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
			    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
			this._draggable._newPos.x = newX;
		},
	
		_onDragEnd: function (e) {
			var map = this._map,
			    options = map.options,
			    delay = +new Date() - this._lastTime,
	
			    noInertia = !options.inertia || delay > options.inertiaThreshold || !this._positions[0];
	
			map.fire('dragend', e);
	
			if (noInertia) {
				map.fire('moveend');
	
			} else {
	
				var direction = this._lastPos.subtract(this._positions[0]),
				    duration = (this._lastTime + delay - this._times[0]) / 1000,
				    ease = options.easeLinearity,
	
				    speedVector = direction.multiplyBy(ease / duration),
				    speed = speedVector.distanceTo([0, 0]),
	
				    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
				    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
				    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
				    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
				if (!offset.x || !offset.y) {
					map.fire('moveend');
	
				} else {
					offset = map._limitOffset(offset, map.options.maxBounds);
	
					L.Util.requestAnimFrame(function () {
						map.panBy(offset, {
							duration: decelerationDuration,
							easeLinearity: ease,
							noMoveStart: true
						});
					});
				}
			}
		}
	});
	
	L.Map.addInitHook('addHandler', 'dragging', L.Map.Drag);
	
	
	/*
	 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	 */
	
	L.Map.mergeOptions({
		doubleClickZoom: true
	});
	
	L.Map.DoubleClickZoom = L.Handler.extend({
		addHooks: function () {
			this._map.on('dblclick', this._onDoubleClick, this);
		},
	
		removeHooks: function () {
			this._map.off('dblclick', this._onDoubleClick, this);
		},
	
		_onDoubleClick: function (e) {
			var map = this._map,
			    zoom = map.getZoom() + (e.originalEvent.shiftKey ? -1 : 1);
	
			if (map.options.doubleClickZoom === 'center') {
				map.setZoom(zoom);
			} else {
				map.setZoomAround(e.containerPoint, zoom);
			}
		}
	});
	
	L.Map.addInitHook('addHandler', 'doubleClickZoom', L.Map.DoubleClickZoom);
	
	
	/*
	 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	 */
	
	L.Map.mergeOptions({
		scrollWheelZoom: true
	});
	
	L.Map.ScrollWheelZoom = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'mousewheel', this._onWheelScroll, this);
			L.DomEvent.on(this._map._container, 'MozMousePixelScroll', L.DomEvent.preventDefault);
			this._delta = 0;
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'mousewheel', this._onWheelScroll);
			L.DomEvent.off(this._map._container, 'MozMousePixelScroll', L.DomEvent.preventDefault);
		},
	
		_onWheelScroll: function (e) {
			var delta = L.DomEvent.getWheelDelta(e);
	
			this._delta += delta;
			this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
			if (!this._startTime) {
				this._startTime = +new Date();
			}
	
			var left = Math.max(40 - (+new Date() - this._startTime), 0);
	
			clearTimeout(this._timer);
			this._timer = setTimeout(L.bind(this._performZoom, this), left);
	
			L.DomEvent.preventDefault(e);
			L.DomEvent.stopPropagation(e);
		},
	
		_performZoom: function () {
			var map = this._map,
			    delta = this._delta,
			    zoom = map.getZoom();
	
			delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
			delta = Math.max(Math.min(delta, 4), -4);
			delta = map._limitZoom(zoom + delta) - zoom;
	
			this._delta = 0;
			this._startTime = null;
	
			if (!delta) { return; }
	
			if (map.options.scrollWheelZoom === 'center') {
				map.setZoom(zoom + delta);
			} else {
				map.setZoomAround(this._lastMousePos, zoom + delta);
			}
		}
	});
	
	L.Map.addInitHook('addHandler', 'scrollWheelZoom', L.Map.ScrollWheelZoom);
	
	
	/*
	 * Extends the event handling code with double tap support for mobile browsers.
	 */
	
	L.extend(L.DomEvent, {
	
		_touchstart: L.Browser.msPointer ? 'MSPointerDown' : L.Browser.pointer ? 'pointerdown' : 'touchstart',
		_touchend: L.Browser.msPointer ? 'MSPointerUp' : L.Browser.pointer ? 'pointerup' : 'touchend',
	
		// inspired by Zepto touch code by Thomas Fuchs
		addDoubleTapListener: function (obj, handler, id) {
			var last,
			    doubleTap = false,
			    delay = 250,
			    touch,
			    pre = '_leaflet_',
			    touchstart = this._touchstart,
			    touchend = this._touchend,
			    trackedTouches = [];
	
			function onTouchStart(e) {
				var count;
	
				if (L.Browser.pointer) {
					trackedTouches.push(e.pointerId);
					count = trackedTouches.length;
				} else {
					count = e.touches.length;
				}
				if (count > 1) {
					return;
				}
	
				var now = Date.now(),
					delta = now - (last || now);
	
				touch = e.touches ? e.touches[0] : e;
				doubleTap = (delta > 0 && delta <= delay);
				last = now;
			}
	
			function onTouchEnd(e) {
				if (L.Browser.pointer) {
					var idx = trackedTouches.indexOf(e.pointerId);
					if (idx === -1) {
						return;
					}
					trackedTouches.splice(idx, 1);
				}
	
				if (doubleTap) {
					if (L.Browser.pointer) {
						// work around .type being readonly with MSPointer* events
						var newTouch = { },
							prop;
	
						// jshint forin:false
						for (var i in touch) {
							prop = touch[i];
							if (typeof prop === 'function') {
								newTouch[i] = prop.bind(touch);
							} else {
								newTouch[i] = prop;
							}
						}
						touch = newTouch;
					}
					touch.type = 'dblclick';
					handler(touch);
					last = null;
				}
			}
			obj[pre + touchstart + id] = onTouchStart;
			obj[pre + touchend + id] = onTouchEnd;
	
			// on pointer we need to listen on the document, otherwise a drag starting on the map and moving off screen
			// will not come through to us, so we will lose track of how many touches are ongoing
			var endElement = L.Browser.pointer ? document.documentElement : obj;
	
			obj.addEventListener(touchstart, onTouchStart, false);
			endElement.addEventListener(touchend, onTouchEnd, false);
	
			if (L.Browser.pointer) {
				endElement.addEventListener(L.DomEvent.POINTER_CANCEL, onTouchEnd, false);
			}
	
			return this;
		},
	
		removeDoubleTapListener: function (obj, id) {
			var pre = '_leaflet_';
	
			obj.removeEventListener(this._touchstart, obj[pre + this._touchstart + id], false);
			(L.Browser.pointer ? document.documentElement : obj).removeEventListener(
			        this._touchend, obj[pre + this._touchend + id], false);
	
			if (L.Browser.pointer) {
				document.documentElement.removeEventListener(L.DomEvent.POINTER_CANCEL, obj[pre + this._touchend + id],
					false);
			}
	
			return this;
		}
	});
	
	
	/*
	 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	 */
	
	L.extend(L.DomEvent, {
	
		//static
		POINTER_DOWN: L.Browser.msPointer ? 'MSPointerDown' : 'pointerdown',
		POINTER_MOVE: L.Browser.msPointer ? 'MSPointerMove' : 'pointermove',
		POINTER_UP: L.Browser.msPointer ? 'MSPointerUp' : 'pointerup',
		POINTER_CANCEL: L.Browser.msPointer ? 'MSPointerCancel' : 'pointercancel',
	
		_pointers: [],
		_pointerDocumentListener: false,
	
		// Provides a touch events wrapper for (ms)pointer events.
		// Based on changes by veproza https://github.com/CloudMade/Leaflet/pull/1019
		//ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
		addPointerListener: function (obj, type, handler, id) {
	
			switch (type) {
			case 'touchstart':
				return this.addPointerListenerStart(obj, type, handler, id);
			case 'touchend':
				return this.addPointerListenerEnd(obj, type, handler, id);
			case 'touchmove':
				return this.addPointerListenerMove(obj, type, handler, id);
			default:
				throw 'Unknown touch event type';
			}
		},
	
		addPointerListenerStart: function (obj, type, handler, id) {
			var pre = '_leaflet_',
			    pointers = this._pointers;
	
			var cb = function (e) {
				if (e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
					L.DomEvent.preventDefault(e);
				}
	
				var alreadyInArray = false;
				for (var i = 0; i < pointers.length; i++) {
					if (pointers[i].pointerId === e.pointerId) {
						alreadyInArray = true;
						break;
					}
				}
				if (!alreadyInArray) {
					pointers.push(e);
				}
	
				e.touches = pointers.slice();
				e.changedTouches = [e];
	
				handler(e);
			};
	
			obj[pre + 'touchstart' + id] = cb;
			obj.addEventListener(this.POINTER_DOWN, cb, false);
	
			// need to also listen for end events to keep the _pointers list accurate
			// this needs to be on the body and never go away
			if (!this._pointerDocumentListener) {
				var internalCb = function (e) {
					for (var i = 0; i < pointers.length; i++) {
						if (pointers[i].pointerId === e.pointerId) {
							pointers.splice(i, 1);
							break;
						}
					}
				};
				//We listen on the documentElement as any drags that end by moving the touch off the screen get fired there
				document.documentElement.addEventListener(this.POINTER_UP, internalCb, false);
				document.documentElement.addEventListener(this.POINTER_CANCEL, internalCb, false);
	
				this._pointerDocumentListener = true;
			}
	
			return this;
		},
	
		addPointerListenerMove: function (obj, type, handler, id) {
			var pre = '_leaflet_',
			    touches = this._pointers;
	
			function cb(e) {
	
				// don't fire touch moves when mouse isn't down
				if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }
	
				for (var i = 0; i < touches.length; i++) {
					if (touches[i].pointerId === e.pointerId) {
						touches[i] = e;
						break;
					}
				}
	
				e.touches = touches.slice();
				e.changedTouches = [e];
	
				handler(e);
			}
	
			obj[pre + 'touchmove' + id] = cb;
			obj.addEventListener(this.POINTER_MOVE, cb, false);
	
			return this;
		},
	
		addPointerListenerEnd: function (obj, type, handler, id) {
			var pre = '_leaflet_',
			    touches = this._pointers;
	
			var cb = function (e) {
				for (var i = 0; i < touches.length; i++) {
					if (touches[i].pointerId === e.pointerId) {
						touches.splice(i, 1);
						break;
					}
				}
	
				e.touches = touches.slice();
				e.changedTouches = [e];
	
				handler(e);
			};
	
			obj[pre + 'touchend' + id] = cb;
			obj.addEventListener(this.POINTER_UP, cb, false);
			obj.addEventListener(this.POINTER_CANCEL, cb, false);
	
			return this;
		},
	
		removePointerListener: function (obj, type, id) {
			var pre = '_leaflet_',
			    cb = obj[pre + type + id];
	
			switch (type) {
			case 'touchstart':
				obj.removeEventListener(this.POINTER_DOWN, cb, false);
				break;
			case 'touchmove':
				obj.removeEventListener(this.POINTER_MOVE, cb, false);
				break;
			case 'touchend':
				obj.removeEventListener(this.POINTER_UP, cb, false);
				obj.removeEventListener(this.POINTER_CANCEL, cb, false);
				break;
			}
	
			return this;
		}
	});
	
	
	/*
	 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	 */
	
	L.Map.mergeOptions({
		touchZoom: L.Browser.touch && !L.Browser.android23,
		bounceAtZoomLimits: true
	});
	
	L.Map.TouchZoom = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		_onTouchStart: function (e) {
			var map = this._map;
	
			if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
			var p1 = map.mouseEventToLayerPoint(e.touches[0]),
			    p2 = map.mouseEventToLayerPoint(e.touches[1]),
			    viewCenter = map._getCenterLayerPoint();
	
			this._startCenter = p1.add(p2)._divideBy(2);
			this._startDist = p1.distanceTo(p2);
	
			this._moved = false;
			this._zooming = true;
	
			this._centerOffset = viewCenter.subtract(this._startCenter);
	
			if (map._panAnim) {
				map._panAnim.stop();
			}
	
			L.DomEvent
			    .on(document, 'touchmove', this._onTouchMove, this)
			    .on(document, 'touchend', this._onTouchEnd, this);
	
			L.DomEvent.preventDefault(e);
		},
	
		_onTouchMove: function (e) {
			var map = this._map;
	
			if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
			var p1 = map.mouseEventToLayerPoint(e.touches[0]),
			    p2 = map.mouseEventToLayerPoint(e.touches[1]);
	
			this._scale = p1.distanceTo(p2) / this._startDist;
			this._delta = p1._add(p2)._divideBy(2)._subtract(this._startCenter);
	
			if (this._scale === 1) { return; }
	
			if (!map.options.bounceAtZoomLimits) {
				if ((map.getZoom() === map.getMinZoom() && this._scale < 1) ||
				    (map.getZoom() === map.getMaxZoom() && this._scale > 1)) { return; }
			}
	
			if (!this._moved) {
				L.DomUtil.addClass(map._mapPane, 'leaflet-touching');
	
				map
				    .fire('movestart')
				    .fire('zoomstart');
	
				this._moved = true;
			}
	
			L.Util.cancelAnimFrame(this._animRequest);
			this._animRequest = L.Util.requestAnimFrame(
			        this._updateOnMove, this, true, this._map._container);
	
			L.DomEvent.preventDefault(e);
		},
	
		_updateOnMove: function () {
			var map = this._map,
			    origin = this._getScaleOrigin(),
			    center = map.layerPointToLatLng(origin),
			    zoom = map.getScaleZoom(this._scale);
	
			map._animateZoom(center, zoom, this._startCenter, this._scale, this._delta, false, true);
		},
	
		_onTouchEnd: function () {
			if (!this._moved || !this._zooming) {
				this._zooming = false;
				return;
			}
	
			var map = this._map;
	
			this._zooming = false;
			L.DomUtil.removeClass(map._mapPane, 'leaflet-touching');
			L.Util.cancelAnimFrame(this._animRequest);
	
			L.DomEvent
			    .off(document, 'touchmove', this._onTouchMove)
			    .off(document, 'touchend', this._onTouchEnd);
	
			var origin = this._getScaleOrigin(),
			    center = map.layerPointToLatLng(origin),
	
			    oldZoom = map.getZoom(),
			    floatZoomDelta = map.getScaleZoom(this._scale) - oldZoom,
			    roundZoomDelta = (floatZoomDelta > 0 ?
			            Math.ceil(floatZoomDelta) : Math.floor(floatZoomDelta)),
	
			    zoom = map._limitZoom(oldZoom + roundZoomDelta),
			    scale = map.getZoomScale(zoom) / this._scale;
	
			map._animateZoom(center, zoom, origin, scale);
		},
	
		_getScaleOrigin: function () {
			var centerOffset = this._centerOffset.subtract(this._delta).divideBy(this._scale);
			return this._startCenter.add(centerOffset);
		}
	});
	
	L.Map.addInitHook('addHandler', 'touchZoom', L.Map.TouchZoom);
	
	
	/*
	 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	 */
	
	L.Map.mergeOptions({
		tap: true,
		tapTolerance: 15
	});
	
	L.Map.Tap = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'touchstart', this._onDown, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'touchstart', this._onDown, this);
		},
	
		_onDown: function (e) {
			if (!e.touches) { return; }
	
			L.DomEvent.preventDefault(e);
	
			this._fireClick = true;
	
			// don't simulate click or track longpress if more than 1 touch
			if (e.touches.length > 1) {
				this._fireClick = false;
				clearTimeout(this._holdTimeout);
				return;
			}
	
			var first = e.touches[0],
			    el = first.target;
	
			this._startPos = this._newPos = new L.Point(first.clientX, first.clientY);
	
			// if touching a link, highlight it
			if (el.tagName && el.tagName.toLowerCase() === 'a') {
				L.DomUtil.addClass(el, 'leaflet-active');
			}
	
			// simulate long hold but setting a timeout
			this._holdTimeout = setTimeout(L.bind(function () {
				if (this._isTapValid()) {
					this._fireClick = false;
					this._onUp();
					this._simulateEvent('contextmenu', first);
				}
			}, this), 1000);
	
			L.DomEvent
				.on(document, 'touchmove', this._onMove, this)
				.on(document, 'touchend', this._onUp, this);
		},
	
		_onUp: function (e) {
			clearTimeout(this._holdTimeout);
	
			L.DomEvent
				.off(document, 'touchmove', this._onMove, this)
				.off(document, 'touchend', this._onUp, this);
	
			if (this._fireClick && e && e.changedTouches) {
	
				var first = e.changedTouches[0],
				    el = first.target;
	
				if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
					L.DomUtil.removeClass(el, 'leaflet-active');
				}
	
				// simulate click if the touch didn't move too much
				if (this._isTapValid()) {
					this._simulateEvent('click', first);
				}
			}
		},
	
		_isTapValid: function () {
			return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
		},
	
		_onMove: function (e) {
			var first = e.touches[0];
			this._newPos = new L.Point(first.clientX, first.clientY);
		},
	
		_simulateEvent: function (type, e) {
			var simulatedEvent = document.createEvent('MouseEvents');
	
			simulatedEvent._simulated = true;
			e.target._simulatedClick = true;
	
			simulatedEvent.initMouseEvent(
			        type, true, true, window, 1,
			        e.screenX, e.screenY,
			        e.clientX, e.clientY,
			        false, false, false, false, 0, null);
	
			e.target.dispatchEvent(simulatedEvent);
		}
	});
	
	if (L.Browser.touch && !L.Browser.pointer) {
		L.Map.addInitHook('addHandler', 'tap', L.Map.Tap);
	}
	
	
	/*
	 * L.Handler.ShiftDragZoom is used to add shift-drag zoom interaction to the map
	  * (zoom to a selected bounding box), enabled by default.
	 */
	
	L.Map.mergeOptions({
		boxZoom: true
	});
	
	L.Map.BoxZoom = L.Handler.extend({
		initialize: function (map) {
			this._map = map;
			this._container = map._container;
			this._pane = map._panes.overlayPane;
			this._moved = false;
		},
	
		addHooks: function () {
			L.DomEvent.on(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._container, 'mousedown', this._onMouseDown);
			this._moved = false;
		},
	
		moved: function () {
			return this._moved;
		},
	
		_onMouseDown: function (e) {
			this._moved = false;
	
			if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
			L.DomUtil.disableTextSelection();
			L.DomUtil.disableImageDrag();
	
			this._startLayerPoint = this._map.mouseEventToLayerPoint(e);
	
			L.DomEvent
			    .on(document, 'mousemove', this._onMouseMove, this)
			    .on(document, 'mouseup', this._onMouseUp, this)
			    .on(document, 'keydown', this._onKeyDown, this);
		},
	
		_onMouseMove: function (e) {
			if (!this._moved) {
				this._box = L.DomUtil.create('div', 'leaflet-zoom-box', this._pane);
				L.DomUtil.setPosition(this._box, this._startLayerPoint);
	
				//TODO refactor: move cursor to styles
				this._container.style.cursor = 'crosshair';
				this._map.fire('boxzoomstart');
			}
	
			var startPoint = this._startLayerPoint,
			    box = this._box,
	
			    layerPoint = this._map.mouseEventToLayerPoint(e),
			    offset = layerPoint.subtract(startPoint),
	
			    newPos = new L.Point(
			        Math.min(layerPoint.x, startPoint.x),
			        Math.min(layerPoint.y, startPoint.y));
	
			L.DomUtil.setPosition(box, newPos);
	
			this._moved = true;
	
			// TODO refactor: remove hardcoded 4 pixels
			box.style.width  = (Math.max(0, Math.abs(offset.x) - 4)) + 'px';
			box.style.height = (Math.max(0, Math.abs(offset.y) - 4)) + 'px';
		},
	
		_finish: function () {
			if (this._moved) {
				this._pane.removeChild(this._box);
				this._container.style.cursor = '';
			}
	
			L.DomUtil.enableTextSelection();
			L.DomUtil.enableImageDrag();
	
			L.DomEvent
			    .off(document, 'mousemove', this._onMouseMove)
			    .off(document, 'mouseup', this._onMouseUp)
			    .off(document, 'keydown', this._onKeyDown);
		},
	
		_onMouseUp: function (e) {
	
			this._finish();
	
			var map = this._map,
			    layerPoint = map.mouseEventToLayerPoint(e);
	
			if (this._startLayerPoint.equals(layerPoint)) { return; }
	
			var bounds = new L.LatLngBounds(
			        map.layerPointToLatLng(this._startLayerPoint),
			        map.layerPointToLatLng(layerPoint));
	
			map.fitBounds(bounds);
	
			map.fire('boxzoomend', {
				boxZoomBounds: bounds
			});
		},
	
		_onKeyDown: function (e) {
			if (e.keyCode === 27) {
				this._finish();
			}
		}
	});
	
	L.Map.addInitHook('addHandler', 'boxZoom', L.Map.BoxZoom);
	
	
	/*
	 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	 */
	
	L.Map.mergeOptions({
		keyboard: true,
		keyboardPanOffset: 80,
		keyboardZoomOffset: 1
	});
	
	L.Map.Keyboard = L.Handler.extend({
	
		keyCodes: {
			left:    [37],
			right:   [39],
			down:    [40],
			up:      [38],
			zoomIn:  [187, 107, 61, 171],
			zoomOut: [189, 109, 173]
		},
	
		initialize: function (map) {
			this._map = map;
	
			this._setPanOffset(map.options.keyboardPanOffset);
			this._setZoomOffset(map.options.keyboardZoomOffset);
		},
	
		addHooks: function () {
			var container = this._map._container;
	
			// make the container focusable by tabbing
			if (container.tabIndex === -1) {
				container.tabIndex = '0';
			}
	
			L.DomEvent
			    .on(container, 'focus', this._onFocus, this)
			    .on(container, 'blur', this._onBlur, this)
			    .on(container, 'mousedown', this._onMouseDown, this);
	
			this._map
			    .on('focus', this._addHooks, this)
			    .on('blur', this._removeHooks, this);
		},
	
		removeHooks: function () {
			this._removeHooks();
	
			var container = this._map._container;
	
			L.DomEvent
			    .off(container, 'focus', this._onFocus, this)
			    .off(container, 'blur', this._onBlur, this)
			    .off(container, 'mousedown', this._onMouseDown, this);
	
			this._map
			    .off('focus', this._addHooks, this)
			    .off('blur', this._removeHooks, this);
		},
	
		_onMouseDown: function () {
			if (this._focused) { return; }
	
			var body = document.body,
			    docEl = document.documentElement,
			    top = body.scrollTop || docEl.scrollTop,
			    left = body.scrollLeft || docEl.scrollLeft;
	
			this._map._container.focus();
	
			window.scrollTo(left, top);
		},
	
		_onFocus: function () {
			this._focused = true;
			this._map.fire('focus');
		},
	
		_onBlur: function () {
			this._focused = false;
			this._map.fire('blur');
		},
	
		_setPanOffset: function (pan) {
			var keys = this._panKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.left.length; i < len; i++) {
				keys[codes.left[i]] = [-1 * pan, 0];
			}
			for (i = 0, len = codes.right.length; i < len; i++) {
				keys[codes.right[i]] = [pan, 0];
			}
			for (i = 0, len = codes.down.length; i < len; i++) {
				keys[codes.down[i]] = [0, pan];
			}
			for (i = 0, len = codes.up.length; i < len; i++) {
				keys[codes.up[i]] = [0, -1 * pan];
			}
		},
	
		_setZoomOffset: function (zoom) {
			var keys = this._zoomKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.zoomIn.length; i < len; i++) {
				keys[codes.zoomIn[i]] = zoom;
			}
			for (i = 0, len = codes.zoomOut.length; i < len; i++) {
				keys[codes.zoomOut[i]] = -zoom;
			}
		},
	
		_addHooks: function () {
			L.DomEvent.on(document, 'keydown', this._onKeyDown, this);
		},
	
		_removeHooks: function () {
			L.DomEvent.off(document, 'keydown', this._onKeyDown, this);
		},
	
		_onKeyDown: function (e) {
			var key = e.keyCode,
			    map = this._map;
	
			if (key in this._panKeys) {
	
				if (map._panAnim && map._panAnim._inProgress) { return; }
	
				map.panBy(this._panKeys[key]);
	
				if (map.options.maxBounds) {
					map.panInsideBounds(map.options.maxBounds);
				}
	
			} else if (key in this._zoomKeys) {
				map.setZoom(map.getZoom() + this._zoomKeys[key]);
	
			} else {
				return;
			}
	
			L.DomEvent.stop(e);
		}
	});
	
	L.Map.addInitHook('addHandler', 'keyboard', L.Map.Keyboard);
	
	
	/*
	 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	 */
	
	L.Handler.MarkerDrag = L.Handler.extend({
		initialize: function (marker) {
			this._marker = marker;
		},
	
		addHooks: function () {
			var icon = this._marker._icon;
			if (!this._draggable) {
				this._draggable = new L.Draggable(icon, icon);
			}
	
			this._draggable
				.on('dragstart', this._onDragStart, this)
				.on('drag', this._onDrag, this)
				.on('dragend', this._onDragEnd, this);
			this._draggable.enable();
			L.DomUtil.addClass(this._marker._icon, 'leaflet-marker-draggable');
		},
	
		removeHooks: function () {
			this._draggable
				.off('dragstart', this._onDragStart, this)
				.off('drag', this._onDrag, this)
				.off('dragend', this._onDragEnd, this);
	
			this._draggable.disable();
			L.DomUtil.removeClass(this._marker._icon, 'leaflet-marker-draggable');
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_onDragStart: function () {
			this._marker
			    .closePopup()
			    .fire('movestart')
			    .fire('dragstart');
		},
	
		_onDrag: function () {
			var marker = this._marker,
			    shadow = marker._shadow,
			    iconPos = L.DomUtil.getPosition(marker._icon),
			    latlng = marker._map.layerPointToLatLng(iconPos);
	
			// update shadow position
			if (shadow) {
				L.DomUtil.setPosition(shadow, iconPos);
			}
	
			marker._latlng = latlng;
	
			marker
			    .fire('move', {latlng: latlng})
			    .fire('drag');
		},
	
		_onDragEnd: function (e) {
			this._marker
			    .fire('moveend')
			    .fire('dragend', e);
		}
	});
	
	
	/*
	 * L.Control is a base class for implementing map controls. Handles positioning.
	 * All other controls extend from this class.
	 */
	
	L.Control = L.Class.extend({
		options: {
			position: 'topright'
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		getPosition: function () {
			return this.options.position;
		},
	
		setPosition: function (position) {
			var map = this._map;
	
			if (map) {
				map.removeControl(this);
			}
	
			this.options.position = position;
	
			if (map) {
				map.addControl(this);
			}
	
			return this;
		},
	
		getContainer: function () {
			return this._container;
		},
	
		addTo: function (map) {
			this._map = map;
	
			var container = this._container = this.onAdd(map),
			    pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			L.DomUtil.addClass(container, 'leaflet-control');
	
			if (pos.indexOf('bottom') !== -1) {
				corner.insertBefore(container, corner.firstChild);
			} else {
				corner.appendChild(container);
			}
	
			return this;
		},
	
		removeFrom: function (map) {
			var pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			corner.removeChild(this._container);
			this._map = null;
	
			if (this.onRemove) {
				this.onRemove(map);
			}
	
			return this;
		},
	
		_refocusOnMap: function () {
			if (this._map) {
				this._map.getContainer().focus();
			}
		}
	});
	
	L.control = function (options) {
		return new L.Control(options);
	};
	
	
	// adds control-related methods to L.Map
	
	L.Map.include({
		addControl: function (control) {
			control.addTo(this);
			return this;
		},
	
		removeControl: function (control) {
			control.removeFrom(this);
			return this;
		},
	
		_initControlPos: function () {
			var corners = this._controlCorners = {},
			    l = 'leaflet-',
			    container = this._controlContainer =
			            L.DomUtil.create('div', l + 'control-container', this._container);
	
			function createCorner(vSide, hSide) {
				var className = l + vSide + ' ' + l + hSide;
	
				corners[vSide + hSide] = L.DomUtil.create('div', className, container);
			}
	
			createCorner('top', 'left');
			createCorner('top', 'right');
			createCorner('bottom', 'left');
			createCorner('bottom', 'right');
		},
	
		_clearControlPos: function () {
			this._container.removeChild(this._controlContainer);
		}
	});
	
	
	/*
	 * L.Control.Zoom is used for the default zoom buttons on the map.
	 */
	
	L.Control.Zoom = L.Control.extend({
		options: {
			position: 'topleft',
			zoomInText: '+',
			zoomInTitle: 'Zoom in',
			zoomOutText: '-',
			zoomOutTitle: 'Zoom out'
		},
	
		onAdd: function (map) {
			var zoomName = 'leaflet-control-zoom',
			    container = L.DomUtil.create('div', zoomName + ' leaflet-bar');
	
			this._map = map;
	
			this._zoomInButton  = this._createButton(
			        this.options.zoomInText, this.options.zoomInTitle,
			        zoomName + '-in',  container, this._zoomIn,  this);
			this._zoomOutButton = this._createButton(
			        this.options.zoomOutText, this.options.zoomOutTitle,
			        zoomName + '-out', container, this._zoomOut, this);
	
			this._updateDisabled();
			map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off('zoomend zoomlevelschange', this._updateDisabled, this);
		},
	
		_zoomIn: function (e) {
			this._map.zoomIn(e.shiftKey ? 3 : 1);
		},
	
		_zoomOut: function (e) {
			this._map.zoomOut(e.shiftKey ? 3 : 1);
		},
	
		_createButton: function (html, title, className, container, fn, context) {
			var link = L.DomUtil.create('a', className, container);
			link.innerHTML = html;
			link.href = '#';
			link.title = title;
	
			var stop = L.DomEvent.stopPropagation;
	
			L.DomEvent
			    .on(link, 'click', stop)
			    .on(link, 'mousedown', stop)
			    .on(link, 'dblclick', stop)
			    .on(link, 'click', L.DomEvent.preventDefault)
			    .on(link, 'click', fn, context)
			    .on(link, 'click', this._refocusOnMap, context);
	
			return link;
		},
	
		_updateDisabled: function () {
			var map = this._map,
				className = 'leaflet-disabled';
	
			L.DomUtil.removeClass(this._zoomInButton, className);
			L.DomUtil.removeClass(this._zoomOutButton, className);
	
			if (map._zoom === map.getMinZoom()) {
				L.DomUtil.addClass(this._zoomOutButton, className);
			}
			if (map._zoom === map.getMaxZoom()) {
				L.DomUtil.addClass(this._zoomInButton, className);
			}
		}
	});
	
	L.Map.mergeOptions({
		zoomControl: true
	});
	
	L.Map.addInitHook(function () {
		if (this.options.zoomControl) {
			this.zoomControl = new L.Control.Zoom();
			this.addControl(this.zoomControl);
		}
	});
	
	L.control.zoom = function (options) {
		return new L.Control.Zoom(options);
	};
	
	
	
	/*
	 * L.Control.Attribution is used for displaying attribution on the map (added by default).
	 */
	
	L.Control.Attribution = L.Control.extend({
		options: {
			position: 'bottomright',
			prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
	
			this._attributions = {};
		},
	
		onAdd: function (map) {
			this._container = L.DomUtil.create('div', 'leaflet-control-attribution');
			L.DomEvent.disableClickPropagation(this._container);
	
			for (var i in map._layers) {
				if (map._layers[i].getAttribution) {
					this.addAttribution(map._layers[i].getAttribution());
				}
			}
			
			map
			    .on('layeradd', this._onLayerAdd, this)
			    .on('layerremove', this._onLayerRemove, this);
	
			this._update();
	
			return this._container;
		},
	
		onRemove: function (map) {
			map
			    .off('layeradd', this._onLayerAdd)
			    .off('layerremove', this._onLayerRemove);
	
		},
	
		setPrefix: function (prefix) {
			this.options.prefix = prefix;
			this._update();
			return this;
		},
	
		addAttribution: function (text) {
			if (!text) { return; }
	
			if (!this._attributions[text]) {
				this._attributions[text] = 0;
			}
			this._attributions[text]++;
	
			this._update();
	
			return this;
		},
	
		removeAttribution: function (text) {
			if (!text) { return; }
	
			if (this._attributions[text]) {
				this._attributions[text]--;
				this._update();
			}
	
			return this;
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			var attribs = [];
	
			for (var i in this._attributions) {
				if (this._attributions[i]) {
					attribs.push(i);
				}
			}
	
			var prefixAndAttribs = [];
	
			if (this.options.prefix) {
				prefixAndAttribs.push(this.options.prefix);
			}
			if (attribs.length) {
				prefixAndAttribs.push(attribs.join(', '));
			}
	
			this._container.innerHTML = prefixAndAttribs.join(' | ');
		},
	
		_onLayerAdd: function (e) {
			if (e.layer.getAttribution) {
				this.addAttribution(e.layer.getAttribution());
			}
		},
	
		_onLayerRemove: function (e) {
			if (e.layer.getAttribution) {
				this.removeAttribution(e.layer.getAttribution());
			}
		}
	});
	
	L.Map.mergeOptions({
		attributionControl: true
	});
	
	L.Map.addInitHook(function () {
		if (this.options.attributionControl) {
			this.attributionControl = (new L.Control.Attribution()).addTo(this);
		}
	});
	
	L.control.attribution = function (options) {
		return new L.Control.Attribution(options);
	};
	
	
	/*
	 * L.Control.Scale is used for displaying metric/imperial scale on the map.
	 */
	
	L.Control.Scale = L.Control.extend({
		options: {
			position: 'bottomleft',
			maxWidth: 100,
			metric: true,
			imperial: true,
			updateWhenIdle: false
		},
	
		onAdd: function (map) {
			this._map = map;
	
			var className = 'leaflet-control-scale',
			    container = L.DomUtil.create('div', className),
			    options = this.options;
	
			this._addScales(options, className, container);
	
			map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
			map.whenReady(this._update, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		},
	
		_addScales: function (options, className, container) {
			if (options.metric) {
				this._mScale = L.DomUtil.create('div', className + '-line', container);
			}
			if (options.imperial) {
				this._iScale = L.DomUtil.create('div', className + '-line', container);
			}
		},
	
		_update: function () {
			var bounds = this._map.getBounds(),
			    centerLat = bounds.getCenter().lat,
			    halfWorldMeters = 6378137 * Math.PI * Math.cos(centerLat * Math.PI / 180),
			    dist = halfWorldMeters * (bounds.getNorthEast().lng - bounds.getSouthWest().lng) / 180,
	
			    size = this._map.getSize(),
			    options = this.options,
			    maxMeters = 0;
	
			if (size.x > 0) {
				maxMeters = dist * (options.maxWidth / size.x);
			}
	
			this._updateScales(options, maxMeters);
		},
	
		_updateScales: function (options, maxMeters) {
			if (options.metric && maxMeters) {
				this._updateMetric(maxMeters);
			}
	
			if (options.imperial && maxMeters) {
				this._updateImperial(maxMeters);
			}
		},
	
		_updateMetric: function (maxMeters) {
			var meters = this._getRoundNum(maxMeters);
	
			this._mScale.style.width = this._getScaleWidth(meters / maxMeters) + 'px';
			this._mScale.innerHTML = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
		},
	
		_updateImperial: function (maxMeters) {
			var maxFeet = maxMeters * 3.2808399,
			    scale = this._iScale,
			    maxMiles, miles, feet;
	
			if (maxFeet > 5280) {
				maxMiles = maxFeet / 5280;
				miles = this._getRoundNum(maxMiles);
	
				scale.style.width = this._getScaleWidth(miles / maxMiles) + 'px';
				scale.innerHTML = miles + ' mi';
	
			} else {
				feet = this._getRoundNum(maxFeet);
	
				scale.style.width = this._getScaleWidth(feet / maxFeet) + 'px';
				scale.innerHTML = feet + ' ft';
			}
		},
	
		_getScaleWidth: function (ratio) {
			return Math.round(this.options.maxWidth * ratio) - 10;
		},
	
		_getRoundNum: function (num) {
			var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
			    d = num / pow10;
	
			d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
	
			return pow10 * d;
		}
	});
	
	L.control.scale = function (options) {
		return new L.Control.Scale(options);
	};
	
	
	/*
	 * L.Control.Layers is a control to allow users to switch between different layers on the map.
	 */
	
	L.Control.Layers = L.Control.extend({
		options: {
			collapsed: true,
			position: 'topright',
			autoZIndex: true
		},
	
		initialize: function (baseLayers, overlays, options) {
			L.setOptions(this, options);
	
			this._layers = {};
			this._lastZIndex = 0;
			this._handlingClick = false;
	
			for (var i in baseLayers) {
				this._addLayer(baseLayers[i], i);
			}
	
			for (i in overlays) {
				this._addLayer(overlays[i], i, true);
			}
		},
	
		onAdd: function (map) {
			this._initLayout();
			this._update();
	
			map
			    .on('layeradd', this._onLayerChange, this)
			    .on('layerremove', this._onLayerChange, this);
	
			return this._container;
		},
	
		onRemove: function (map) {
			map
			    .off('layeradd', this._onLayerChange, this)
			    .off('layerremove', this._onLayerChange, this);
		},
	
		addBaseLayer: function (layer, name) {
			this._addLayer(layer, name);
			this._update();
			return this;
		},
	
		addOverlay: function (layer, name) {
			this._addLayer(layer, name, true);
			this._update();
			return this;
		},
	
		removeLayer: function (layer) {
			var id = L.stamp(layer);
			delete this._layers[id];
			this._update();
			return this;
		},
	
		_initLayout: function () {
			var className = 'leaflet-control-layers',
			    container = this._container = L.DomUtil.create('div', className);
	
			//Makes this work on IE10 Touch devices by stopping it from firing a mouseout event when the touch is released
			container.setAttribute('aria-haspopup', true);
	
			if (!L.Browser.touch) {
				L.DomEvent
					.disableClickPropagation(container)
					.disableScrollPropagation(container);
			} else {
				L.DomEvent.on(container, 'click', L.DomEvent.stopPropagation);
			}
	
			var form = this._form = L.DomUtil.create('form', className + '-list');
	
			if (this.options.collapsed) {
				if (!L.Browser.android) {
					L.DomEvent
					    .on(container, 'mouseover', this._expand, this)
					    .on(container, 'mouseout', this._collapse, this);
				}
				var link = this._layersLink = L.DomUtil.create('a', className + '-toggle', container);
				link.href = '#';
				link.title = 'Layers';
	
				if (L.Browser.touch) {
					L.DomEvent
					    .on(link, 'click', L.DomEvent.stop)
					    .on(link, 'click', this._expand, this);
				}
				else {
					L.DomEvent.on(link, 'focus', this._expand, this);
				}
				//Work around for Firefox android issue https://github.com/Leaflet/Leaflet/issues/2033
				L.DomEvent.on(form, 'click', function () {
					setTimeout(L.bind(this._onInputClick, this), 0);
				}, this);
	
				this._map.on('click', this._collapse, this);
				// TODO keyboard accessibility
			} else {
				this._expand();
			}
	
			this._baseLayersList = L.DomUtil.create('div', className + '-base', form);
			this._separator = L.DomUtil.create('div', className + '-separator', form);
			this._overlaysList = L.DomUtil.create('div', className + '-overlays', form);
	
			container.appendChild(form);
		},
	
		_addLayer: function (layer, name, overlay) {
			var id = L.stamp(layer);
	
			this._layers[id] = {
				layer: layer,
				name: name,
				overlay: overlay
			};
	
			if (this.options.autoZIndex && layer.setZIndex) {
				this._lastZIndex++;
				layer.setZIndex(this._lastZIndex);
			}
		},
	
		_update: function () {
			if (!this._container) {
				return;
			}
	
			this._baseLayersList.innerHTML = '';
			this._overlaysList.innerHTML = '';
	
			var baseLayersPresent = false,
			    overlaysPresent = false,
			    i, obj;
	
			for (i in this._layers) {
				obj = this._layers[i];
				this._addItem(obj);
				overlaysPresent = overlaysPresent || obj.overlay;
				baseLayersPresent = baseLayersPresent || !obj.overlay;
			}
	
			this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
		},
	
		_onLayerChange: function (e) {
			var obj = this._layers[L.stamp(e.layer)];
	
			if (!obj) { return; }
	
			if (!this._handlingClick) {
				this._update();
			}
	
			var type = obj.overlay ?
				(e.type === 'layeradd' ? 'overlayadd' : 'overlayremove') :
				(e.type === 'layeradd' ? 'baselayerchange' : null);
	
			if (type) {
				this._map.fire(type, obj);
			}
		},
	
		// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
		_createRadioElement: function (name, checked) {
	
			var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"';
			if (checked) {
				radioHtml += ' checked="checked"';
			}
			radioHtml += '/>';
	
			var radioFragment = document.createElement('div');
			radioFragment.innerHTML = radioHtml;
	
			return radioFragment.firstChild;
		},
	
		_addItem: function (obj) {
			var label = document.createElement('label'),
			    input,
			    checked = this._map.hasLayer(obj.layer);
	
			if (obj.overlay) {
				input = document.createElement('input');
				input.type = 'checkbox';
				input.className = 'leaflet-control-layers-selector';
				input.defaultChecked = checked;
			} else {
				input = this._createRadioElement('leaflet-base-layers', checked);
			}
	
			input.layerId = L.stamp(obj.layer);
	
			L.DomEvent.on(input, 'click', this._onInputClick, this);
	
			var name = document.createElement('span');
			name.innerHTML = ' ' + obj.name;
	
			label.appendChild(input);
			label.appendChild(name);
	
			var container = obj.overlay ? this._overlaysList : this._baseLayersList;
			container.appendChild(label);
	
			return label;
		},
	
		_onInputClick: function () {
			var i, input, obj,
			    inputs = this._form.getElementsByTagName('input'),
			    inputsLen = inputs.length;
	
			this._handlingClick = true;
	
			for (i = 0; i < inputsLen; i++) {
				input = inputs[i];
				obj = this._layers[input.layerId];
	
				if (input.checked && !this._map.hasLayer(obj.layer)) {
					this._map.addLayer(obj.layer);
	
				} else if (!input.checked && this._map.hasLayer(obj.layer)) {
					this._map.removeLayer(obj.layer);
				}
			}
	
			this._handlingClick = false;
	
			this._refocusOnMap();
		},
	
		_expand: function () {
			L.DomUtil.addClass(this._container, 'leaflet-control-layers-expanded');
		},
	
		_collapse: function () {
			this._container.className = this._container.className.replace(' leaflet-control-layers-expanded', '');
		}
	});
	
	L.control.layers = function (baseLayers, overlays, options) {
		return new L.Control.Layers(baseLayers, overlays, options);
	};
	
	
	/*
	 * L.PosAnimation is used by Leaflet internally for pan animations.
	 */
	
	L.PosAnimation = L.Class.extend({
		includes: L.Mixin.Events,
	
		run: function (el, newPos, duration, easeLinearity) { // (HTMLElement, Point[, Number, Number])
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._newPos = newPos;
	
			this.fire('start');
	
			el.style[L.DomUtil.TRANSITION] = 'all ' + (duration || 0.25) +
			        's cubic-bezier(0,0,' + (easeLinearity || 0.5) + ',1)';
	
			L.DomEvent.on(el, L.DomUtil.TRANSITION_END, this._onTransitionEnd, this);
			L.DomUtil.setPosition(el, newPos);
	
			// toggle reflow, Chrome flickers for some reason if you don't do this
			L.Util.falseFn(el.offsetWidth);
	
			// there's no native way to track value updates of transitioned properties, so we imitate this
			this._stepTimer = setInterval(L.bind(this._onStep, this), 50);
		},
	
		stop: function () {
			if (!this._inProgress) { return; }
	
			// if we just removed the transition property, the element would jump to its final position,
			// so we need to make it stay at the current position
	
			L.DomUtil.setPosition(this._el, this._getPos());
			this._onTransitionEnd();
			L.Util.falseFn(this._el.offsetWidth); // force reflow in case we are about to start a new animation
		},
	
		_onStep: function () {
			var stepPos = this._getPos();
			if (!stepPos) {
				this._onTransitionEnd();
				return;
			}
			// jshint camelcase: false
			// make L.DomUtil.getPosition return intermediate position value during animation
			this._el._leaflet_pos = stepPos;
	
			this.fire('step');
		},
	
		// you can't easily get intermediate values of properties animated with CSS3 Transitions,
		// we need to parse computed style (in case of transform it returns matrix string)
	
		_transformRe: /([-+]?(?:\d*\.)?\d+)\D*, ([-+]?(?:\d*\.)?\d+)\D*\)/,
	
		_getPos: function () {
			var left, top, matches,
			    el = this._el,
			    style = window.getComputedStyle(el);
	
			if (L.Browser.any3d) {
				matches = style[L.DomUtil.TRANSFORM].match(this._transformRe);
				if (!matches) { return; }
				left = parseFloat(matches[1]);
				top  = parseFloat(matches[2]);
			} else {
				left = parseFloat(style.left);
				top  = parseFloat(style.top);
			}
	
			return new L.Point(left, top, true);
		},
	
		_onTransitionEnd: function () {
			L.DomEvent.off(this._el, L.DomUtil.TRANSITION_END, this._onTransitionEnd, this);
	
			if (!this._inProgress) { return; }
			this._inProgress = false;
	
			this._el.style[L.DomUtil.TRANSITION] = '';
	
			// jshint camelcase: false
			// make sure L.DomUtil.getPosition returns the final position value after animation
			this._el._leaflet_pos = this._newPos;
	
			clearInterval(this._stepTimer);
	
			this.fire('step').fire('end');
		}
	
	});
	
	
	/*
	 * Extends L.Map to handle panning animations.
	 */
	
	L.Map.include({
	
		setView: function (center, zoom, options) {
	
			zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
			center = this._limitCenter(L.latLng(center), zoom, this.options.maxBounds);
			options = options || {};
	
			if (this._panAnim) {
				this._panAnim.stop();
			}
	
			if (this._loaded && !options.reset && options !== true) {
	
				if (options.animate !== undefined) {
					options.zoom = L.extend({animate: options.animate}, options.zoom);
					options.pan = L.extend({animate: options.animate}, options.pan);
				}
	
				// try animating pan or zoom
				var animated = (this._zoom !== zoom) ?
					this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
					this._tryAnimatedPan(center, options.pan);
	
				if (animated) {
					// prevent resize handler call, the view will refresh after animation anyway
					clearTimeout(this._sizeTimer);
					return this;
				}
			}
	
			// animation didn't start, just reset the map view
			this._resetView(center, zoom);
	
			return this;
		},
	
		panBy: function (offset, options) {
			offset = L.point(offset).round();
			options = options || {};
	
			if (!offset.x && !offset.y) {
				return this;
			}
	
			if (!this._panAnim) {
				this._panAnim = new L.PosAnimation();
	
				this._panAnim.on({
					'step': this._onPanTransitionStep,
					'end': this._onPanTransitionEnd
				}, this);
			}
	
			// don't fire movestart if animating inertia
			if (!options.noMoveStart) {
				this.fire('movestart');
			}
	
			// animate pan unless animate: false specified
			if (options.animate !== false) {
				L.DomUtil.addClass(this._mapPane, 'leaflet-pan-anim');
	
				var newPos = this._getMapPanePos().subtract(offset);
				this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
			} else {
				this._rawPanBy(offset);
				this.fire('move').fire('moveend');
			}
	
			return this;
		},
	
		_onPanTransitionStep: function () {
			this.fire('move');
		},
	
		_onPanTransitionEnd: function () {
			L.DomUtil.removeClass(this._mapPane, 'leaflet-pan-anim');
			this.fire('moveend');
		},
	
		_tryAnimatedPan: function (center, options) {
			// difference between the new and current centers in pixels
			var offset = this._getCenterOffset(center)._floor();
	
			// don't animate too far unless animate: true specified in options
			if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
			this.panBy(offset, options);
	
			return true;
		}
	});
	
	
	/*
	 * L.PosAnimation fallback implementation that powers Leaflet pan animations
	 * in browsers that don't support CSS3 Transitions.
	 */
	
	L.PosAnimation = L.DomUtil.TRANSITION ? L.PosAnimation : L.PosAnimation.extend({
	
		run: function (el, newPos, duration, easeLinearity) { // (HTMLElement, Point[, Number, Number])
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._duration = duration || 0.25;
			this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
			this._startPos = L.DomUtil.getPosition(el);
			this._offset = newPos.subtract(this._startPos);
			this._startTime = +new Date();
	
			this.fire('start');
	
			this._animate();
		},
	
		stop: function () {
			if (!this._inProgress) { return; }
	
			this._step();
			this._complete();
		},
	
		_animate: function () {
			// animation loop
			this._animId = L.Util.requestAnimFrame(this._animate, this);
			this._step();
		},
	
		_step: function () {
			var elapsed = (+new Date()) - this._startTime,
			    duration = this._duration * 1000;
	
			if (elapsed < duration) {
				this._runFrame(this._easeOut(elapsed / duration));
			} else {
				this._runFrame(1);
				this._complete();
			}
		},
	
		_runFrame: function (progress) {
			var pos = this._startPos.add(this._offset.multiplyBy(progress));
			L.DomUtil.setPosition(this._el, pos);
	
			this.fire('step');
		},
	
		_complete: function () {
			L.Util.cancelAnimFrame(this._animId);
	
			this._inProgress = false;
			this.fire('end');
		},
	
		_easeOut: function (t) {
			return 1 - Math.pow(1 - t, this._easeOutPower);
		}
	});
	
	
	/*
	 * Extends L.Map to handle zoom animations.
	 */
	
	L.Map.mergeOptions({
		zoomAnimation: true,
		zoomAnimationThreshold: 4
	});
	
	if (L.DomUtil.TRANSITION) {
	
		L.Map.addInitHook(function () {
			// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
			this._zoomAnimated = this.options.zoomAnimation && L.DomUtil.TRANSITION &&
					L.Browser.any3d && !L.Browser.android23 && !L.Browser.mobileOpera;
	
			// zoom transitions run with the same duration for all layers, so if one of transitionend events
			// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
			if (this._zoomAnimated) {
				L.DomEvent.on(this._mapPane, L.DomUtil.TRANSITION_END, this._catchTransitionEnd, this);
			}
		});
	}
	
	L.Map.include(!L.DomUtil.TRANSITION ? {} : {
	
		_catchTransitionEnd: function (e) {
			if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
				this._onZoomTransitionEnd();
			}
		},
	
		_nothingToAnimate: function () {
			return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
		},
	
		_tryAnimatedZoom: function (center, zoom, options) {
	
			if (this._animatingZoom) { return true; }
	
			options = options || {};
	
			// don't animate if disabled, not supported or zoom difference is too large
			if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
			        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
			// offset is the pixel coords of the zoom origin relative to the current center
			var scale = this.getZoomScale(zoom),
			    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale),
				origin = this._getCenterLayerPoint()._add(offset);
	
			// don't animate if the zoom origin isn't within one screen from the current center, unless forced
			if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
			this
			    .fire('movestart')
			    .fire('zoomstart');
	
			this._animateZoom(center, zoom, origin, scale, null, true);
	
			return true;
		},
	
		_animateZoom: function (center, zoom, origin, scale, delta, backwards, forTouchZoom) {
	
			if (!forTouchZoom) {
				this._animatingZoom = true;
			}
	
			// put transform transition on all layers with leaflet-zoom-animated class
			L.DomUtil.addClass(this._mapPane, 'leaflet-zoom-anim');
	
			// remember what center/zoom to set after animation
			this._animateToCenter = center;
			this._animateToZoom = zoom;
	
			// disable any dragging during animation
			if (L.Draggable) {
				L.Draggable._disabled = true;
			}
	
			L.Util.requestAnimFrame(function () {
				this.fire('zoomanim', {
					center: center,
					zoom: zoom,
					origin: origin,
					scale: scale,
					delta: delta,
					backwards: backwards
				});
				// horrible hack to work around a Chrome bug https://github.com/Leaflet/Leaflet/issues/3689
				setTimeout(L.bind(this._onZoomTransitionEnd, this), 250);
			}, this);
		},
	
		_onZoomTransitionEnd: function () {
			if (!this._animatingZoom) { return; }
	
			this._animatingZoom = false;
	
			L.DomUtil.removeClass(this._mapPane, 'leaflet-zoom-anim');
	
			L.Util.requestAnimFrame(function () {
				this._resetView(this._animateToCenter, this._animateToZoom, true, true);
	
				if (L.Draggable) {
					L.Draggable._disabled = false;
				}
			}, this);
		}
	});
	
	
	/*
		Zoom animation logic for L.TileLayer.
	*/
	
	L.TileLayer.include({
		_animateZoom: function (e) {
			if (!this._animating) {
				this._animating = true;
				this._prepareBgBuffer();
			}
	
			var bg = this._bgBuffer,
			    transform = L.DomUtil.TRANSFORM,
			    initialTransform = e.delta ? L.DomUtil.getTranslateString(e.delta) : bg.style[transform],
			    scaleStr = L.DomUtil.getScaleString(e.scale, e.origin);
	
			bg.style[transform] = e.backwards ?
					scaleStr + ' ' + initialTransform :
					initialTransform + ' ' + scaleStr;
		},
	
		_endZoomAnim: function () {
			var front = this._tileContainer,
			    bg = this._bgBuffer;
	
			front.style.visibility = '';
			front.parentNode.appendChild(front); // Bring to fore
	
			// force reflow
			L.Util.falseFn(bg.offsetWidth);
	
			var zoom = this._map.getZoom();
			if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
				this._clearBgBuffer();
			}
	
			this._animating = false;
		},
	
		_clearBgBuffer: function () {
			var map = this._map;
	
			if (map && !map._animatingZoom && !map.touchZoom._zooming) {
				this._bgBuffer.innerHTML = '';
				this._bgBuffer.style[L.DomUtil.TRANSFORM] = '';
			}
		},
	
		_prepareBgBuffer: function () {
	
			var front = this._tileContainer,
			    bg = this._bgBuffer;
	
			// if foreground layer doesn't have many tiles but bg layer does,
			// keep the existing bg layer and just zoom it some more
	
			var bgLoaded = this._getLoadedTilesPercentage(bg),
			    frontLoaded = this._getLoadedTilesPercentage(front);
	
			if (bg && bgLoaded > 0.5 && frontLoaded < 0.5) {
	
				front.style.visibility = 'hidden';
				this._stopLoadingImages(front);
				return;
			}
	
			// prepare the buffer to become the front tile pane
			bg.style.visibility = 'hidden';
			bg.style[L.DomUtil.TRANSFORM] = '';
	
			// switch out the current layer to be the new bg layer (and vice-versa)
			this._tileContainer = bg;
			bg = this._bgBuffer = front;
	
			this._stopLoadingImages(bg);
	
			//prevent bg buffer from clearing right after zoom
			clearTimeout(this._clearBgBufferTimer);
		},
	
		_getLoadedTilesPercentage: function (container) {
			var tiles = container.getElementsByTagName('img'),
			    i, len, count = 0;
	
			for (i = 0, len = tiles.length; i < len; i++) {
				if (tiles[i].complete) {
					count++;
				}
			}
			return count / len;
		},
	
		// stops loading all tiles in the background layer
		_stopLoadingImages: function (container) {
			var tiles = Array.prototype.slice.call(container.getElementsByTagName('img')),
			    i, len, tile;
	
			for (i = 0, len = tiles.length; i < len; i++) {
				tile = tiles[i];
	
				if (!tile.complete) {
					tile.onload = L.Util.falseFn;
					tile.onerror = L.Util.falseFn;
					tile.src = L.Util.emptyImageUrl;
	
					tile.parentNode.removeChild(tile);
				}
			}
		}
	});
	
	
	/*
	 * Provides L.Map with convenient shortcuts for using browser geolocation features.
	 */
	
	L.Map.include({
		_defaultLocateOptions: {
			watch: false,
			setView: false,
			maxZoom: Infinity,
			timeout: 10000,
			maximumAge: 0,
			enableHighAccuracy: false
		},
	
		locate: function (/*Object*/ options) {
	
			options = this._locateOptions = L.extend(this._defaultLocateOptions, options);
	
			if (!navigator.geolocation) {
				this._handleGeolocationError({
					code: 0,
					message: 'Geolocation not supported.'
				});
				return this;
			}
	
			var onResponse = L.bind(this._handleGeolocationResponse, this),
				onError = L.bind(this._handleGeolocationError, this);
	
			if (options.watch) {
				this._locationWatchId =
				        navigator.geolocation.watchPosition(onResponse, onError, options);
			} else {
				navigator.geolocation.getCurrentPosition(onResponse, onError, options);
			}
			return this;
		},
	
		stopLocate: function () {
			if (navigator.geolocation) {
				navigator.geolocation.clearWatch(this._locationWatchId);
			}
			if (this._locateOptions) {
				this._locateOptions.setView = false;
			}
			return this;
		},
	
		_handleGeolocationError: function (error) {
			var c = error.code,
			    message = error.message ||
			            (c === 1 ? 'permission denied' :
			            (c === 2 ? 'position unavailable' : 'timeout'));
	
			if (this._locateOptions.setView && !this._loaded) {
				this.fitWorld();
			}
	
			this.fire('locationerror', {
				code: c,
				message: 'Geolocation error: ' + message + '.'
			});
		},
	
		_handleGeolocationResponse: function (pos) {
			var lat = pos.coords.latitude,
			    lng = pos.coords.longitude,
			    latlng = new L.LatLng(lat, lng),
	
			    latAccuracy = 180 * pos.coords.accuracy / 40075017,
			    lngAccuracy = latAccuracy / Math.cos(L.LatLng.DEG_TO_RAD * lat),
	
			    bounds = L.latLngBounds(
			            [lat - latAccuracy, lng - lngAccuracy],
			            [lat + latAccuracy, lng + lngAccuracy]),
	
			    options = this._locateOptions;
	
			if (options.setView) {
				var zoom = Math.min(this.getBoundsZoom(bounds), options.maxZoom);
				this.setView(latlng, zoom);
			}
	
			var data = {
				latlng: latlng,
				bounds: bounds,
				timestamp: pos.timestamp
			};
	
			for (var i in pos.coords) {
				if (typeof pos.coords[i] === 'number') {
					data[i] = pos.coords[i];
				}
			}
	
			this.fire('locationfound', data);
		}
	});
	
	
	}(window, document));


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var leaflet = __webpack_require__(584);
	
	__webpack_require__(585);
	
	module.exports = leaflet;
	


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	module.exports = window.L = __webpack_require__(582);
	


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var geocoderControl = __webpack_require__(586),
	    gridControl = __webpack_require__(596),
	    featureLayer = __webpack_require__(600),
	    legendControl = __webpack_require__(603),
	    shareControl = __webpack_require__(604),
	    tileLayer = __webpack_require__(606),
	    infoControl = __webpack_require__(607),
	    map = __webpack_require__(608),
	    gridLayer = __webpack_require__(609),
	    styleLayer = __webpack_require__(612);
	
	L.mapbox = module.exports = {
	    VERSION: __webpack_require__(592).version,
	    geocoder: __webpack_require__(587),
	    marker: __webpack_require__(601),
	    simplestyle: __webpack_require__(602),
	    tileLayer: tileLayer.tileLayer,
	    TileLayer: tileLayer.TileLayer,
	    styleLayer: styleLayer.styleLayer,
	    StyleLayer: styleLayer.StyleLayer,
	    infoControl: infoControl.infoControl,
	    InfoControl: infoControl.InfoControl,
	    shareControl: shareControl.shareControl,
	    ShareControl: shareControl.ShareControl,
	    legendControl: legendControl.legendControl,
	    LegendControl: legendControl.LegendControl,
	    geocoderControl: geocoderControl.geocoderControl,
	    GeocoderControl: geocoderControl.GeocoderControl,
	    gridControl: gridControl.gridControl,
	    GridControl: gridControl.GridControl,
	    gridLayer: gridLayer.gridLayer,
	    GridLayer: gridLayer.GridLayer,
	    featureLayer: featureLayer.featureLayer,
	    FeatureLayer: featureLayer.FeatureLayer,
	    map: map.map,
	    Map: map.Map,
	    config: __webpack_require__(591),
	    sanitize: __webpack_require__(598),
	    template: __webpack_require__(597).to_html,
	    feedback: __webpack_require__(593)
	};
	
	
	// Hardcode image path, because Leaflet's autodetection
	// fails, because mapbox.js is not named leaflet.js
	window.L.Icon.Default.imagePath =
	    // Detect bad-news protocols like file:// and hardcode
	    // to https if they're detected.
	    ((document.location.protocol === 'https:' ||
	    document.location.protocol === 'http:') ? '' : 'https:') +
	    '//api.tiles.mapbox.com/mapbox.js/' + 'v' +
	    __webpack_require__(592).version + '/images';
	


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var geocoder = __webpack_require__(587),
	    util = __webpack_require__(589);
	
	var GeocoderControl = L.Control.extend({
	    includes: L.Mixin.Events,
	
	    options: {
	        proximity: true,
	        position: 'topleft',
	        pointZoom: 16,
	        keepOpen: false,
	        autocomplete: false,
	        queryOptions: {}
	    },
	
	    initialize: function(_, options) {
	        L.Util.setOptions(this, options);
	        this.setURL(_);
	        this._updateSubmit = L.bind(this._updateSubmit, this);
	        this._updateAutocomplete = L.bind(this._updateAutocomplete, this);
	        this._chooseResult = L.bind(this._chooseResult, this);
	    },
	
	    setURL: function(_) {
	        this.geocoder = geocoder(_, {
	            accessToken: this.options.accessToken
	        });
	        return this;
	    },
	
	    getURL: function() {
	        return this.geocoder.getURL();
	    },
	
	    setID: function(_) {
	        return this.setURL(_);
	    },
	
	    setTileJSON: function(_) {
	        return this.setURL(_.geocoder);
	    },
	
	    _toggle: function(e) {
	        if (e) L.DomEvent.stop(e);
	        if (L.DomUtil.hasClass(this._container, 'active')) {
	            L.DomUtil.removeClass(this._container, 'active');
	            this._results.innerHTML = '';
	            this._input.blur();
	        } else {
	            L.DomUtil.addClass(this._container, 'active');
	            this._input.focus();
	            this._input.select();
	        }
	    },
	
	    _closeIfOpen: function() {
	        if (L.DomUtil.hasClass(this._container, 'active') &&
	            !this.options.keepOpen) {
	            L.DomUtil.removeClass(this._container, 'active');
	            this._results.innerHTML = '';
	            this._input.blur();
	        }
	    },
	
	    onAdd: function(map) {
	
	        var container = L.DomUtil.create('div', 'leaflet-control-mapbox-geocoder leaflet-bar leaflet-control'),
	            link = L.DomUtil.create('a', 'leaflet-control-mapbox-geocoder-toggle mapbox-icon mapbox-icon-geocoder', container),
	            results = L.DomUtil.create('div', 'leaflet-control-mapbox-geocoder-results', container),
	            wrap = L.DomUtil.create('div', 'leaflet-control-mapbox-geocoder-wrap', container),
	            form = L.DomUtil.create('form', 'leaflet-control-mapbox-geocoder-form', wrap),
	            input = L.DomUtil.create('input', '', form);
	
	        link.href = '#';
	        link.innerHTML = '&nbsp;';
	
	        input.type = 'text';
	        input.setAttribute('placeholder', 'Search');
	
	        L.DomEvent.addListener(form, 'submit', this._geocode, this);
	        L.DomEvent.addListener(input, 'keyup', this._autocomplete, this);
	        L.DomEvent.disableClickPropagation(container);
	
	        this._map = map;
	        this._results = results;
	        this._input = input;
	        this._form = form;
	
	        if (this.options.keepOpen) {
	            L.DomUtil.addClass(container, 'active');
	        } else {
	            this._map.on('click', this._closeIfOpen, this);
	            L.DomEvent.addListener(link, 'click', this._toggle, this);
	        }
	
	        return container;
	    },
	
	    _updateSubmit: function(err, resp) {
	        L.DomUtil.removeClass(this._container, 'searching');
	        this._results.innerHTML = '';
	        if (err || !resp) {
	            this.fire('error', {error: err});
	        } else {
	            var features = [];
	            if (resp.results && resp.results.features) {
	                features = resp.results.features;
	            }
	            if (features.length === 1) {
	                this.fire('autoselect', { feature: features[0] });
	                this.fire('found', {results: resp.results});
	                this._chooseResult(features[0]);
	                this._closeIfOpen();
	            } else if (features.length > 1) {
	                this.fire('found', {results: resp.results});
	                this._displayResults(features);
	            } else {
	                this.fire('notfound');
	                this._displayResults(features);
	            }
	        }
	    },
	
	    _updateAutocomplete: function(err, resp) {
	        this._results.innerHTML = '';
	        if (err || !resp) {
	            this.fire('error', {error: err});
	        } else {
	            var features = [];
	            if (resp.results && resp.results.features) {
	                features = resp.results.features;
	            }
	            if (features.length) {
	                this.fire('found', {results: resp.results});
	            } else {
	                this.fire('notfound');
	            }
	            this._displayResults(features);
	        }
	    },
	
	    _displayResults: function(features) {
	        for (var i = 0, l = Math.min(features.length, 5); i < l; i++) {
	            var feature = features[i];
	            var name = feature.place_name;
	            if (!name.length) continue;
	
	            var r = L.DomUtil.create('a', '', this._results);
	            var text = ('innerText' in r) ? 'innerText' : 'textContent';
	            r[text] = name;
	            r.setAttribute('title', name);
	            r.href = '#';
	
	            (L.bind(function(feature) {
	                L.DomEvent.addListener(r, 'click', function(e) {
	                    this._chooseResult(feature);
	                    L.DomEvent.stop(e);
	                    this.fire('select', { feature: feature });
	                }, this);
	            }, this))(feature);
	        }
	        if (features.length > 5) {
	            var outof = L.DomUtil.create('span', '', this._results);
	            outof.innerHTML = 'Top 5 of ' + features.length + '  results';
	        }
	    },
	
	    _chooseResult: function(result) {
	        if (result.bbox) {
	            this._map.fitBounds(util.lbounds(result.bbox));
	        } else if (result.center) {
	            this._map.setView([result.center[1], result.center[0]], (this._map.getZoom() === undefined) ?
	                this.options.pointZoom :
	                Math.max(this._map.getZoom(), this.options.pointZoom));
	        }
	    },
	
	    _geocode: function(e) {
	        L.DomEvent.preventDefault(e);
	        if (this._input.value === '') return this._updateSubmit();
	        L.DomUtil.addClass(this._container, 'searching');
	        this.geocoder.query(L.Util.extend({
	            query: this._input.value,
	            proximity: this.options.proximity ? this._map.getCenter() : false
	        }, this.options.queryOptions), this._updateSubmit);
	    },
	
	    _autocomplete: function() {
	        if (!this.options.autocomplete) return;
	        if (this._input.value === '') return this._updateAutocomplete();
	        this.geocoder.query(L.Util.extend({
	            query: this._input.value,
	            proximity: this.options.proximity ? this._map.getCenter() : false
	        }, this.options.queryOptions), this._updateAutocomplete);
	    }
	});
	
	module.exports.GeocoderControl = GeocoderControl;
	
	module.exports.geocoderControl = function(_, options) {
	    return new GeocoderControl(_, options);
	};
	


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var isArray = __webpack_require__(588),
	    util = __webpack_require__(589),
	    format_url = __webpack_require__(590),
	    feedback = __webpack_require__(593),
	    request = __webpack_require__(594);
	
	// Low-level geocoding interface - wraps specific API calls and their
	// return values.
	module.exports = function(url, options) {
	    if (!options) options = {};
	    var geocoder = {};
	
	    util.strict(url, 'string');
	
	    if (url.indexOf('/') === -1) {
	        url = format_url('/geocoding/v5/' + url + '/{query}.json', options.accessToken, 5);
	    }
	
	    function roundTo(latLng, precision) {
	        var mult = Math.pow(10, precision);
	        latLng.lat = Math.round(latLng.lat * mult) / mult;
	        latLng.lng = Math.round(latLng.lng * mult) / mult;
	        return latLng;
	    }
	
	    geocoder.getURL = function() {
	        return url;
	    };
	
	    geocoder.queryURL = function(_) {
	        var isObject = !(isArray(_) || typeof _ === 'string'),
	            query = isObject ? _.query : _;
	
	        if (isArray(query)) {
	            var parts = [];
	            for (var i = 0; i < query.length; i++) {
	                parts[i] = encodeURIComponent(query[i]);
	            }
	            query = parts.join(';');
	        } else {
	            query = encodeURIComponent(query);
	        }
	
	        feedback.record({ geocoding: query });
	
	        var url = L.Util.template(geocoder.getURL(), {query: query});
	
	        if (isObject) {
	            if (_.types) {
	                if (isArray(_.types)) {
	                    url += '&types=' + _.types.join();
	                } else {
	                    url += '&types=' + _.types;
	                }
	            }
	
	            if (_.country) {
	                if (isArray(_.country)) {
	                    url += '&country=' + _.country.join();
	                } else {
	                    url += '&country=' + _.country;
	                }
	            }
	
	            if (_.proximity) {
	                var proximity = roundTo(L.latLng(_.proximity), 3);
	                url += '&proximity=' + proximity.lng + ',' + proximity.lat;
	            }
	
	            if (typeof _.autocomplete === 'boolean') {
	                url += '&autocomplete=' + _.autocomplete;
	            }
	        }
	
	        return url;
	    };
	
	    geocoder.query = function(_, callback) {
	        util.strict(callback, 'function');
	
	        request(geocoder.queryURL(_), function(err, json) {
	            if (json && (json.length || json.features)) {
	                var res = {
	                    results: json
	                };
	                if (json.features && json.features.length) {
	                    res.latlng = [
	                        json.features[0].center[1],
	                        json.features[0].center[0]];
	
	                    if (json.features[0].bbox) {
	                        res.bounds = json.features[0].bbox;
	                        res.lbounds = util.lbounds(res.bounds);
	                    }
	                }
	                callback(null, res);
	            } else callback(err || true);
	        });
	
	        return geocoder;
	    };
	
	    // a reverse geocode:
	    //
	    //  geocoder.reverseQuery([80, 20])
	    geocoder.reverseQuery = function(_, callback) {
	        var q = '';
	
	        // sort through different ways people represent lat and lon pairs
	        function normalize(x) {
	            var latLng;
	            if (x.lat !== undefined && x.lng !== undefined) {
	                latLng = L.latLng(x.lat, x.lng);
	            } else if (x.lat !== undefined && x.lon !== undefined) {
	                latLng = L.latLng(x.lat, x.lon);
	            } else {
	                latLng = L.latLng(x[1], x[0]);
	            }
	            latLng = roundTo(latLng, 5);
	            return latLng.lng + ',' + latLng.lat;
	        }
	
	        if (_.length && _[0].length) {
	            for (var i = 0, pts = []; i < _.length; i++) {
	                pts.push(normalize(_[i]));
	            }
	            q = pts.join(';');
	        } else {
	            q = normalize(_);
	        }
	
	        request(geocoder.queryURL(q), function(err, json) {
	            callback(err, json);
	        });
	
	        return geocoder;
	    };
	
	    return geocoder;
	};
	


/***/ }),
/* 588 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	


/***/ }),
/* 589 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	function contains(item, list) {
	    if (!list || !list.length) return false;
	    for (var i = 0; i < list.length; i++) {
	        if (list[i] === item) return true;
	    }
	    return false;
	}
	
	module.exports = {
	    idUrl: function(_, t) {
	        if (_.indexOf('/') === -1) t.loadID(_);
	        else t.loadURL(_);
	    },
	    log: function(_) {
	        if (typeof console === 'object' &&
	            typeof console.error === 'function') {
	            console.error(_);
	        }
	    },
	    strict: function(_, type) {
	        if (typeof _ !== type) {
	            throw new Error('Invalid argument: ' + type + ' expected');
	        }
	    },
	    strict_instance: function(_, klass, name) {
	        if (!(_ instanceof klass)) {
	            throw new Error('Invalid argument: ' + name + ' expected');
	        }
	    },
	    strict_oneof: function(_, values) {
	        if (!contains(_, values)) {
	            throw new Error('Invalid argument: ' + _ + ' given, valid values are ' +
	                values.join(', '));
	        }
	    },
	    strip_tags: function(_) {
	        return _.replace(/<[^<]+>/g, '');
	    },
	    lbounds: function(_) {
	        // leaflet-compatible bounds, since leaflet does not do geojson
	        return new L.LatLngBounds([[_[1], _[0]], [_[3], _[2]]]);
	    }
	};
	


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var config = __webpack_require__(591),
	    version = __webpack_require__(592).version;
	
	module.exports = function(path, accessToken) {
	    accessToken = accessToken || L.mapbox.accessToken;
	
	    if (!accessToken && config.REQUIRE_ACCESS_TOKEN) {
	        throw new Error('An API access token is required to use Mapbox.js. ' +
	            'See https://www.mapbox.com/mapbox.js/api/v' + version + '/api-access-tokens/');
	    }
	
	    var url = (document.location.protocol === 'https:' || config.FORCE_HTTPS) ? config.HTTPS_URL : config.HTTP_URL;
	    url = url.replace(/\/v4$/, '');
	    url += path;
	
	    if (config.REQUIRE_ACCESS_TOKEN) {
	        if (accessToken[0] === 's') {
	            throw new Error('Use a public access token (pk.*) with Mapbox.js, not a secret access token (sk.*). ' +
	                'See https://www.mapbox.com/mapbox.js/api/v' + version + '/api-access-tokens/');
	        }
	
	        url += url.indexOf('?') !== -1 ? '&access_token=' : '?access_token=';
	        url += accessToken;
	    }
	
	    return url;
	};
	
	module.exports.tileJSON = function(urlOrMapID, accessToken) {
	
	    if (urlOrMapID.indexOf('mapbox://styles') === 0) {
	        throw new Error('Styles created with Mapbox Studio need to be used with ' +
	            'L.mapbox.styleLayer, not L.mapbox.tileLayer');
	    }
	
	    if (urlOrMapID.indexOf('/') !== -1)
	        return urlOrMapID;
	
	    var url = module.exports('/v4/' + urlOrMapID + '.json', accessToken);
	
	    // TileJSON requests need a secure flag appended to their URLs so
	    // that the server knows to send SSL-ified resource references.
	    if (url.indexOf('https') === 0)
	        url += '&secure';
	
	    return url;
	};
	
	
	module.exports.style = function(styleURL, accessToken) {
	    if (styleURL.indexOf('mapbox://styles/') === -1) throw new Error('Incorrectly formatted Mapbox style at ' + styleURL);
	
	    var ownerIDStyle = styleURL.split('mapbox://styles/')[1];
	    var url = module.exports('/styles/v1/' + ownerIDStyle, accessToken)
	        .replace('http://', 'https://');
	
	    return url;
	};
	


/***/ }),
/* 591 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	module.exports = {
	    HTTP_URL: 'http://a.tiles.mapbox.com/v4',
	    HTTPS_URL: 'https://a.tiles.mapbox.com/v4',
	    FORCE_HTTPS: false,
	    REQUIRE_ACCESS_TOKEN: true
	};
	


/***/ }),
/* 592 */
/***/ (function(module, exports) {

	module.exports = {
		"author": "Mapbox",
		"name": "mapbox.js",
		"description": "mapbox javascript api",
		"version": "2.4.0",
		"homepage": "http://mapbox.com/",
		"repository": {
			"type": "git",
			"url": "git://github.com/mapbox/mapbox.js.git"
		},
		"main": "src/index.js",
		"dependencies": {
			"corslite": "0.0.6",
			"isarray": "0.0.1",
			"leaflet": "0.7.7",
			"mustache": "2.2.1",
			"sanitize-caja": "0.1.3"
		},
		"scripts": {
			"test": "eslint --no-eslintrc -c .eslintrc src && mocha-phantomjs test/index.html"
		},
		"license": "BSD-3-Clause",
		"devDependencies": {
			"browserify": "^13.0.0",
			"clean-css": "~2.0.7",
			"eslint": "^0.23.0",
			"expect.js": "0.3.1",
			"happen": "0.1.3",
			"leaflet-fullscreen": "0.0.4",
			"leaflet-hash": "0.2.1",
			"marked": "~0.3.0",
			"minifyify": "^6.1.0",
			"minimist": "0.0.5",
			"mocha": "2.4.5",
			"mocha-phantomjs": "4.0.2",
			"sinon": "1.10.2"
		},
		"optionalDependencies": {},
		"engines": {
			"node": "*"
		}
	}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var Feedback = L.Class.extend({
	    includes: L.Mixin.Events,
	    data: {},
	    record: function(data) {
	        L.extend(this.data, data);
	        this.fire('change');
	    }
	});
	
	module.exports = new Feedback();
	


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var corslite = __webpack_require__(595),
	    strict = __webpack_require__(589).strict,
	    config = __webpack_require__(591);
	
	var protocol = /^(https?:)?(?=\/\/(.|api)\.tiles\.mapbox\.com\/)/;
	
	module.exports = function(url, callback) {
	    strict(url, 'string');
	    strict(callback, 'function');
	
	    url = url.replace(protocol, function(match, protocol) {
	        if (!('withCredentials' in new window.XMLHttpRequest())) {
	            // XDomainRequest in use; doesn't support cross-protocol requests
	            return document.location.protocol;
	        } else if (protocol === 'https:' || document.location.protocol === 'https:' || config.FORCE_HTTPS) {
	            return 'https:';
	        } else {
	            return 'http:';
	        }
	    });
	
	    function onload(err, resp) {
	        if (!err && resp) {
	            resp = JSON.parse(resp.responseText);
	        }
	        callback(err, resp);
	    }
	
	    return corslite(url, onload);
	};
	


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	function corslite(url, callback, cors) {
	    var sent = false;
	
	    if (typeof window.XMLHttpRequest === 'undefined') {
	        return callback(Error('Browser not supported'));
	    }
	
	    if (typeof cors === 'undefined') {
	        var m = url.match(/^\s*https?:\/\/[^\/]*/);
	        cors = m && (m[0] !== location.protocol + '//' + location.domain +
	                (location.port ? ':' + location.port : ''));
	    }
	
	    var x = new window.XMLHttpRequest();
	
	    function isSuccessful(status) {
	        return status >= 200 && status < 300 || status === 304;
	    }
	
	    if (cors && !('withCredentials' in x)) {
	        // IE8-9
	        x = new window.XDomainRequest();
	
	        // Ensure callback is never called synchronously, i.e., before
	        // x.send() returns (this has been observed in the wild).
	        // See https://github.com/mapbox/mapbox.js/issues/472
	        var original = callback;
	        callback = function() {
	            if (sent) {
	                original.apply(this, arguments);
	            } else {
	                var that = this, args = arguments;
	                setTimeout(function() {
	                    original.apply(that, args);
	                }, 0);
	            }
	        }
	    }
	
	    function loaded() {
	        if (
	            // XDomainRequest
	            x.status === undefined ||
	            // modern browsers
	            isSuccessful(x.status)) callback.call(x, null, x);
	        else callback.call(x, x, null);
	    }
	
	    // Both `onreadystatechange` and `onload` can fire. `onreadystatechange`
	    // has [been supported for longer](http://stackoverflow.com/a/9181508/229001).
	    if ('onload' in x) {
	        x.onload = loaded;
	    } else {
	        x.onreadystatechange = function readystate() {
	            if (x.readyState === 4) {
	                loaded();
	            }
	        };
	    }
	
	    // Call the callback with the XMLHttpRequest object as an error and prevent
	    // it from ever being called again by reassigning it to `noop`
	    x.onerror = function error(evt) {
	        // XDomainRequest provides no evt parameter
	        callback.call(this, evt || true, null);
	        callback = function() { };
	    };
	
	    // IE9 must have onprogress be set to a unique function.
	    x.onprogress = function() { };
	
	    x.ontimeout = function(evt) {
	        callback.call(this, evt, null);
	        callback = function() { };
	    };
	
	    x.onabort = function(evt) {
	        callback.call(this, evt, null);
	        callback = function() { };
	    };
	
	    // GET is the only supported HTTP Verb by XDomainRequest and is the
	    // only one supported here.
	    x.open('GET', url, true);
	
	    // Send the request. Sending data is not supported.
	    x.send(null);
	    sent = true;
	
	    return x;
	}
	
	if (true) module.exports = corslite;
	


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var util = __webpack_require__(589),
	    Mustache = __webpack_require__(597);
	
	var GridControl = L.Control.extend({
	
	    options: {
	        pinnable: true,
	        follow: false,
	        sanitizer: __webpack_require__(598),
	        touchTeaser: true,
	        location: true
	    },
	
	    _currentContent: '',
	
	    // pinned means that this control is on a feature and the user has likely
	    // clicked. pinned will not become false unless the user clicks off
	    // of the feature onto another or clicks x
	    _pinned: false,
	
	    initialize: function(_, options) {
	        L.Util.setOptions(this, options);
	        util.strict_instance(_, L.Class, 'L.mapbox.gridLayer');
	        this._layer = _;
	    },
	
	    setTemplate: function(template) {
	        util.strict(template, 'string');
	        this.options.template = template;
	        return this;
	    },
	
	    _template: function(format, data) {
	        if (!data) return;
	        var template = this.options.template || this._layer.getTileJSON().template;
	        if (template) {
	            var d = {};
	            d['__' + format + '__'] = true;
	            return this.options.sanitizer(
	                Mustache.to_html(template, L.extend(d, data)));
	        }
	    },
	
	    // change the content of the tooltip HTML if it has changed, otherwise
	    // noop
	    _show: function(content, o) {
	        if (content === this._currentContent) return;
	
	        this._currentContent = content;
	
	        if (this.options.follow) {
	            this._popup.setContent(content)
	                .setLatLng(o.latLng);
	            if (this._map._popup !== this._popup) this._popup.openOn(this._map);
	        } else {
	            this._container.style.display = 'block';
	            this._contentWrapper.innerHTML = content;
	        }
	    },
	
	    hide: function() {
	        this._pinned = false;
	        this._currentContent = '';
	
	        this._map.closePopup();
	        this._container.style.display = 'none';
	        this._contentWrapper.innerHTML = '';
	
	        L.DomUtil.removeClass(this._container, 'closable');
	
	        return this;
	    },
	
	    _mouseover: function(o) {
	        if (o.data) {
	            L.DomUtil.addClass(this._map._container, 'map-clickable');
	        } else {
	            L.DomUtil.removeClass(this._map._container, 'map-clickable');
	        }
	
	        if (this._pinned) return;
	
	        var content = this._template('teaser', o.data);
	        if (content) {
	            this._show(content, o);
	        } else {
	            this.hide();
	        }
	    },
	
	    _mousemove: function(o) {
	        if (this._pinned) return;
	        if (!this.options.follow) return;
	
	        this._popup.setLatLng(o.latLng);
	    },
	
	    _navigateTo: function(url) {
	        window.top.location.href = url;
	    },
	
	    _click: function(o) {
	
	        var location_formatted = this._template('location', o.data);
	        if (this.options.location && location_formatted &&
	            location_formatted.search(/^https?:/) === 0) {
	            return this._navigateTo(this._template('location', o.data));
	        }
	
	        if (!this.options.pinnable) return;
	
	        var content = this._template('full', o.data);
	
	        if (!content && this.options.touchTeaser && L.Browser.touch) {
	            content = this._template('teaser', o.data);
	        }
	
	        if (content) {
	            L.DomUtil.addClass(this._container, 'closable');
	            this._pinned = true;
	            this._show(content, o);
	        } else if (this._pinned) {
	            L.DomUtil.removeClass(this._container, 'closable');
	            this._pinned = false;
	            this.hide();
	        }
	    },
	
	    _onPopupClose: function() {
	        this._currentContent = null;
	        this._pinned = false;
	    },
	
	    _createClosebutton: function(container, fn) {
	        var link = L.DomUtil.create('a', 'close', container);
	
	        link.innerHTML = 'close';
	        link.href = '#';
	        link.title = 'close';
	
	        L.DomEvent
	            .on(link, 'click', L.DomEvent.stopPropagation)
	            .on(link, 'mousedown', L.DomEvent.stopPropagation)
	            .on(link, 'dblclick', L.DomEvent.stopPropagation)
	            .on(link, 'click', L.DomEvent.preventDefault)
	            .on(link, 'click', fn, this);
	
	        return link;
	    },
	
	    onAdd: function(map) {
	        this._map = map;
	
	        var className = 'leaflet-control-grid map-tooltip',
	            container = L.DomUtil.create('div', className),
	            contentWrapper = L.DomUtil.create('div', 'map-tooltip-content');
	
	        // hide the container element initially
	        container.style.display = 'none';
	        this._createClosebutton(container, this.hide);
	        container.appendChild(contentWrapper);
	
	        this._contentWrapper = contentWrapper;
	        this._popup = new L.Popup({ autoPan: false, closeOnClick: false });
	
	        map.on('popupclose', this._onPopupClose, this);
	
	        L.DomEvent
	            .disableClickPropagation(container)
	            // allow people to scroll tooltips with mousewheel
	            .addListener(container, 'mousewheel', L.DomEvent.stopPropagation);
	
	        this._layer
	            .on('mouseover', this._mouseover, this)
	            .on('mousemove', this._mousemove, this)
	            .on('click', this._click, this);
	
	        return container;
	    },
	
	    onRemove: function (map) {
	
	        map.off('popupclose', this._onPopupClose, this);
	
	        this._layer
	            .off('mouseover', this._mouseover, this)
	            .off('mousemove', this._mousemove, this)
	            .off('click', this._click, this);
	    }
	});
	
	module.exports.GridControl = GridControl;
	
	module.exports.gridControl = function(_, options) {
	    return new GridControl(_, options);
	};
	


/***/ }),
/* 597 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*!
	 * mustache.js - Logic-less {{mustache}} templates with JavaScript
	 * http://github.com/janl/mustache.js
	 */
	
	/*global define: false Mustache: true*/
	
	(function defineMustache (global, factory) {
	  if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
	    factory(exports); // CommonJS
	  } else if (typeof define === 'function' && define.amd) {
	    define(['exports'], factory); // AMD
	  } else {
	    global.Mustache = {};
	    factory(global.Mustache); // script, wsh, asp
	  }
	}(this, function mustacheFactory (mustache) {
	
	  var objectToString = Object.prototype.toString;
	  var isArray = Array.isArray || function isArrayPolyfill (object) {
	    return objectToString.call(object) === '[object Array]';
	  };
	
	  function isFunction (object) {
	    return typeof object === 'function';
	  }
	
	  /**
	   * More correct typeof string handling array
	   * which normally returns typeof 'object'
	   */
	  function typeStr (obj) {
	    return isArray(obj) ? 'array' : typeof obj;
	  }
	
	  function escapeRegExp (string) {
	    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
	  }
	
	  /**
	   * Null safe way of checking whether or not an object,
	   * including its prototype, has a given property
	   */
	  function hasProperty (obj, propName) {
	    return obj != null && typeof obj === 'object' && (propName in obj);
	  }
	
	  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
	  // See https://github.com/janl/mustache.js/issues/189
	  var regExpTest = RegExp.prototype.test;
	  function testRegExp (re, string) {
	    return regExpTest.call(re, string);
	  }
	
	  var nonSpaceRe = /\S/;
	  function isWhitespace (string) {
	    return !testRegExp(nonSpaceRe, string);
	  }
	
	  var entityMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '/': '&#x2F;',
	    '`': '&#x60;',
	    '=': '&#x3D;'
	  };
	
	  function escapeHtml (string) {
	    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
	      return entityMap[s];
	    });
	  }
	
	  var whiteRe = /\s*/;
	  var spaceRe = /\s+/;
	  var equalsRe = /\s*=/;
	  var curlyRe = /\s*\}/;
	  var tagRe = /#|\^|\/|>|\{|&|=|!/;
	
	  /**
	   * Breaks up the given `template` string into a tree of tokens. If the `tags`
	   * argument is given here it must be an array with two string values: the
	   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
	   * course, the default is to use mustaches (i.e. mustache.tags).
	   *
	   * A token is an array with at least 4 elements. The first element is the
	   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
	   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
	   * all text that appears outside a symbol this element is "text".
	   *
	   * The second element of a token is its "value". For mustache tags this is
	   * whatever else was inside the tag besides the opening symbol. For text tokens
	   * this is the text itself.
	   *
	   * The third and fourth elements of the token are the start and end indices,
	   * respectively, of the token in the original template.
	   *
	   * Tokens that are the root node of a subtree contain two more elements: 1) an
	   * array of tokens in the subtree and 2) the index in the original template at
	   * which the closing tag for that section begins.
	   */
	  function parseTemplate (template, tags) {
	    if (!template)
	      return [];
	
	    var sections = [];     // Stack to hold section tokens
	    var tokens = [];       // Buffer to hold the tokens
	    var spaces = [];       // Indices of whitespace tokens on the current line
	    var hasTag = false;    // Is there a {{tag}} on the current line?
	    var nonSpace = false;  // Is there a non-space char on the current line?
	
	    // Strips all whitespace tokens array for the current line
	    // if there was a {{#tag}} on it and otherwise only space.
	    function stripSpace () {
	      if (hasTag && !nonSpace) {
	        while (spaces.length)
	          delete tokens[spaces.pop()];
	      } else {
	        spaces = [];
	      }
	
	      hasTag = false;
	      nonSpace = false;
	    }
	
	    var openingTagRe, closingTagRe, closingCurlyRe;
	    function compileTags (tagsToCompile) {
	      if (typeof tagsToCompile === 'string')
	        tagsToCompile = tagsToCompile.split(spaceRe, 2);
	
	      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
	        throw new Error('Invalid tags: ' + tagsToCompile);
	
	      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
	      closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
	      closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
	    }
	
	    compileTags(tags || mustache.tags);
	
	    var scanner = new Scanner(template);
	
	    var start, type, value, chr, token, openSection;
	    while (!scanner.eos()) {
	      start = scanner.pos;
	
	      // Match any text between tags.
	      value = scanner.scanUntil(openingTagRe);
	
	      if (value) {
	        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
	          chr = value.charAt(i);
	
	          if (isWhitespace(chr)) {
	            spaces.push(tokens.length);
	          } else {
	            nonSpace = true;
	          }
	
	          tokens.push([ 'text', chr, start, start + 1 ]);
	          start += 1;
	
	          // Check for whitespace on the current line.
	          if (chr === '\n')
	            stripSpace();
	        }
	      }
	
	      // Match the opening tag.
	      if (!scanner.scan(openingTagRe))
	        break;
	
	      hasTag = true;
	
	      // Get the tag type.
	      type = scanner.scan(tagRe) || 'name';
	      scanner.scan(whiteRe);
	
	      // Get the tag value.
	      if (type === '=') {
	        value = scanner.scanUntil(equalsRe);
	        scanner.scan(equalsRe);
	        scanner.scanUntil(closingTagRe);
	      } else if (type === '{') {
	        value = scanner.scanUntil(closingCurlyRe);
	        scanner.scan(curlyRe);
	        scanner.scanUntil(closingTagRe);
	        type = '&';
	      } else {
	        value = scanner.scanUntil(closingTagRe);
	      }
	
	      // Match the closing tag.
	      if (!scanner.scan(closingTagRe))
	        throw new Error('Unclosed tag at ' + scanner.pos);
	
	      token = [ type, value, start, scanner.pos ];
	      tokens.push(token);
	
	      if (type === '#' || type === '^') {
	        sections.push(token);
	      } else if (type === '/') {
	        // Check section nesting.
	        openSection = sections.pop();
	
	        if (!openSection)
	          throw new Error('Unopened section "' + value + '" at ' + start);
	
	        if (openSection[1] !== value)
	          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
	      } else if (type === 'name' || type === '{' || type === '&') {
	        nonSpace = true;
	      } else if (type === '=') {
	        // Set the tags for the next time around.
	        compileTags(value);
	      }
	    }
	
	    // Make sure there are no open sections when we're done.
	    openSection = sections.pop();
	
	    if (openSection)
	      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
	
	    return nestTokens(squashTokens(tokens));
	  }
	
	  /**
	   * Combines the values of consecutive text tokens in the given `tokens` array
	   * to a single token.
	   */
	  function squashTokens (tokens) {
	    var squashedTokens = [];
	
	    var token, lastToken;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      token = tokens[i];
	
	      if (token) {
	        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
	          lastToken[1] += token[1];
	          lastToken[3] = token[3];
	        } else {
	          squashedTokens.push(token);
	          lastToken = token;
	        }
	      }
	    }
	
	    return squashedTokens;
	  }
	
	  /**
	   * Forms the given array of `tokens` into a nested tree structure where
	   * tokens that represent a section have two additional items: 1) an array of
	   * all tokens that appear in that section and 2) the index in the original
	   * template that represents the end of that section.
	   */
	  function nestTokens (tokens) {
	    var nestedTokens = [];
	    var collector = nestedTokens;
	    var sections = [];
	
	    var token, section;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      token = tokens[i];
	
	      switch (token[0]) {
	        case '#':
	        case '^':
	          collector.push(token);
	          sections.push(token);
	          collector = token[4] = [];
	          break;
	        case '/':
	          section = sections.pop();
	          section[5] = token[2];
	          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
	          break;
	        default:
	          collector.push(token);
	      }
	    }
	
	    return nestedTokens;
	  }
	
	  /**
	   * A simple string scanner that is used by the template parser to find
	   * tokens in template strings.
	   */
	  function Scanner (string) {
	    this.string = string;
	    this.tail = string;
	    this.pos = 0;
	  }
	
	  /**
	   * Returns `true` if the tail is empty (end of string).
	   */
	  Scanner.prototype.eos = function eos () {
	    return this.tail === '';
	  };
	
	  /**
	   * Tries to match the given regular expression at the current position.
	   * Returns the matched text if it can match, the empty string otherwise.
	   */
	  Scanner.prototype.scan = function scan (re) {
	    var match = this.tail.match(re);
	
	    if (!match || match.index !== 0)
	      return '';
	
	    var string = match[0];
	
	    this.tail = this.tail.substring(string.length);
	    this.pos += string.length;
	
	    return string;
	  };
	
	  /**
	   * Skips all text until the given regular expression can be matched. Returns
	   * the skipped string, which is the entire tail if no match can be made.
	   */
	  Scanner.prototype.scanUntil = function scanUntil (re) {
	    var index = this.tail.search(re), match;
	
	    switch (index) {
	      case -1:
	        match = this.tail;
	        this.tail = '';
	        break;
	      case 0:
	        match = '';
	        break;
	      default:
	        match = this.tail.substring(0, index);
	        this.tail = this.tail.substring(index);
	    }
	
	    this.pos += match.length;
	
	    return match;
	  };
	
	  /**
	   * Represents a rendering context by wrapping a view object and
	   * maintaining a reference to the parent context.
	   */
	  function Context (view, parentContext) {
	    this.view = view;
	    this.cache = { '.': this.view };
	    this.parent = parentContext;
	  }
	
	  /**
	   * Creates a new context using the given view with this context
	   * as the parent.
	   */
	  Context.prototype.push = function push (view) {
	    return new Context(view, this);
	  };
	
	  /**
	   * Returns the value of the given name in this context, traversing
	   * up the context hierarchy if the value is absent in this context's view.
	   */
	  Context.prototype.lookup = function lookup (name) {
	    var cache = this.cache;
	
	    var value;
	    if (cache.hasOwnProperty(name)) {
	      value = cache[name];
	    } else {
	      var context = this, names, index, lookupHit = false;
	
	      while (context) {
	        if (name.indexOf('.') > 0) {
	          value = context.view;
	          names = name.split('.');
	          index = 0;
	
	          /**
	           * Using the dot notion path in `name`, we descend through the
	           * nested objects.
	           *
	           * To be certain that the lookup has been successful, we have to
	           * check if the last object in the path actually has the property
	           * we are looking for. We store the result in `lookupHit`.
	           *
	           * This is specially necessary for when the value has been set to
	           * `undefined` and we want to avoid looking up parent contexts.
	           **/
	          while (value != null && index < names.length) {
	            if (index === names.length - 1)
	              lookupHit = hasProperty(value, names[index]);
	
	            value = value[names[index++]];
	          }
	        } else {
	          value = context.view[name];
	          lookupHit = hasProperty(context.view, name);
	        }
	
	        if (lookupHit)
	          break;
	
	        context = context.parent;
	      }
	
	      cache[name] = value;
	    }
	
	    if (isFunction(value))
	      value = value.call(this.view);
	
	    return value;
	  };
	
	  /**
	   * A Writer knows how to take a stream of tokens and render them to a
	   * string, given a context. It also maintains a cache of templates to
	   * avoid the need to parse the same template twice.
	   */
	  function Writer () {
	    this.cache = {};
	  }
	
	  /**
	   * Clears all cached templates in this writer.
	   */
	  Writer.prototype.clearCache = function clearCache () {
	    this.cache = {};
	  };
	
	  /**
	   * Parses and caches the given `template` and returns the array of tokens
	   * that is generated from the parse.
	   */
	  Writer.prototype.parse = function parse (template, tags) {
	    var cache = this.cache;
	    var tokens = cache[template];
	
	    if (tokens == null)
	      tokens = cache[template] = parseTemplate(template, tags);
	
	    return tokens;
	  };
	
	  /**
	   * High-level method that is used to render the given `template` with
	   * the given `view`.
	   *
	   * The optional `partials` argument may be an object that contains the
	   * names and templates of partials that are used in the template. It may
	   * also be a function that is used to load partial templates on the fly
	   * that takes a single argument: the name of the partial.
	   */
	  Writer.prototype.render = function render (template, view, partials) {
	    var tokens = this.parse(template);
	    var context = (view instanceof Context) ? view : new Context(view);
	    return this.renderTokens(tokens, context, partials, template);
	  };
	
	  /**
	   * Low-level method that renders the given array of `tokens` using
	   * the given `context` and `partials`.
	   *
	   * Note: The `originalTemplate` is only ever used to extract the portion
	   * of the original template that was contained in a higher-order section.
	   * If the template doesn't use higher-order sections, this argument may
	   * be omitted.
	   */
	  Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate) {
	    var buffer = '';
	
	    var token, symbol, value;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      value = undefined;
	      token = tokens[i];
	      symbol = token[0];
	
	      if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
	      else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
	      else if (symbol === '>') value = this.renderPartial(token, context, partials, originalTemplate);
	      else if (symbol === '&') value = this.unescapedValue(token, context);
	      else if (symbol === 'name') value = this.escapedValue(token, context);
	      else if (symbol === 'text') value = this.rawValue(token);
	
	      if (value !== undefined)
	        buffer += value;
	    }
	
	    return buffer;
	  };
	
	  Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
	    var self = this;
	    var buffer = '';
	    var value = context.lookup(token[1]);
	
	    // This function is used to render an arbitrary template
	    // in the current context by higher-order sections.
	    function subRender (template) {
	      return self.render(template, context, partials);
	    }
	
	    if (!value) return;
	
	    if (isArray(value)) {
	      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
	        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
	      }
	    } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
	      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
	    } else if (isFunction(value)) {
	      if (typeof originalTemplate !== 'string')
	        throw new Error('Cannot use higher-order sections without the original template');
	
	      // Extract the portion of the original template that the section contains.
	      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
	
	      if (value != null)
	        buffer += value;
	    } else {
	      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
	    }
	    return buffer;
	  };
	
	  Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
	    var value = context.lookup(token[1]);
	
	    // Use JavaScript's definition of falsy. Include empty arrays.
	    // See https://github.com/janl/mustache.js/issues/186
	    if (!value || (isArray(value) && value.length === 0))
	      return this.renderTokens(token[4], context, partials, originalTemplate);
	  };
	
	  Writer.prototype.renderPartial = function renderPartial (token, context, partials) {
	    if (!partials) return;
	
	    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
	    if (value != null)
	      return this.renderTokens(this.parse(value), context, partials, value);
	  };
	
	  Writer.prototype.unescapedValue = function unescapedValue (token, context) {
	    var value = context.lookup(token[1]);
	    if (value != null)
	      return value;
	  };
	
	  Writer.prototype.escapedValue = function escapedValue (token, context) {
	    var value = context.lookup(token[1]);
	    if (value != null)
	      return mustache.escape(value);
	  };
	
	  Writer.prototype.rawValue = function rawValue (token) {
	    return token[1];
	  };
	
	  mustache.name = 'mustache.js';
	  mustache.version = '2.2.1';
	  mustache.tags = [ '{{', '}}' ];
	
	  // All high-level mustache.* functions use this writer.
	  var defaultWriter = new Writer();
	
	  /**
	   * Clears all cached templates in the default writer.
	   */
	  mustache.clearCache = function clearCache () {
	    return defaultWriter.clearCache();
	  };
	
	  /**
	   * Parses and caches the given template in the default writer and returns the
	   * array of tokens it contains. Doing this ahead of time avoids the need to
	   * parse templates on the fly as they are rendered.
	   */
	  mustache.parse = function parse (template, tags) {
	    return defaultWriter.parse(template, tags);
	  };
	
	  /**
	   * Renders the `template` with the given `view` and `partials` using the
	   * default writer.
	   */
	  mustache.render = function render (template, view, partials) {
	    if (typeof template !== 'string') {
	      throw new TypeError('Invalid template! Template should be a "string" ' +
	                          'but "' + typeStr(template) + '" was given as the first ' +
	                          'argument for mustache#render(template, view, partials)');
	    }
	
	    return defaultWriter.render(template, view, partials);
	  };
	
	  // This is here for backwards compatibility with 0.4.x.,
	  /*eslint-disable */ // eslint wants camel cased function name
	  mustache.to_html = function to_html (template, view, partials, send) {
	    /*eslint-enable*/
	
	    var result = mustache.render(template, view, partials);
	
	    if (isFunction(send)) {
	      send(result);
	    } else {
	      return result;
	    }
	  };
	
	  // Export the escaping function so that the user may override it.
	  // See https://github.com/janl/mustache.js/issues/244
	  mustache.escape = escapeHtml;
	
	  // Export these mainly for testing, but also for advanced usage.
	  mustache.Scanner = Scanner;
	  mustache.Context = Context;
	  mustache.Writer = Writer;
	
	}));
	


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	var html_sanitize = __webpack_require__(599);
	
	module.exports = function(_) {
	    if (!_) return '';
	    return html_sanitize(_, cleanUrl, cleanId);
	};
	
	// https://bugzilla.mozilla.org/show_bug.cgi?id=255107
	function cleanUrl(url) {
	    'use strict';
	    if (/^https?/.test(url.getScheme())) return url.toString();
	    if (/^mailto?/.test(url.getScheme())) return url.toString();
	    if ('data' == url.getScheme() && /^image/.test(url.getPath())) {
	        return url.toString();
	    }
	}
	
	function cleanId(id) { return id; }
	


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	
	// Copyright (C) 2010 Google Inc.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	/**
	 * @fileoverview
	 * Implements RFC 3986 for parsing/formatting URIs.
	 *
	 * @author mikesamuel@gmail.com
	 * \@provides URI
	 * \@overrides window
	 */
	
	var URI = (function () {
	
	/**
	 * creates a uri from the string form.  The parser is relaxed, so special
	 * characters that aren't escaped but don't cause ambiguities will not cause
	 * parse failures.
	 *
	 * @return {URI|null}
	 */
	function parse(uriStr) {
	  var m = ('' + uriStr).match(URI_RE_);
	  if (!m) { return null; }
	  return new URI(
	      nullIfAbsent(m[1]),
	      nullIfAbsent(m[2]),
	      nullIfAbsent(m[3]),
	      nullIfAbsent(m[4]),
	      nullIfAbsent(m[5]),
	      nullIfAbsent(m[6]),
	      nullIfAbsent(m[7]));
	}
	
	
	/**
	 * creates a uri from the given parts.
	 *
	 * @param scheme {string} an unencoded scheme such as "http" or null
	 * @param credentials {string} unencoded user credentials or null
	 * @param domain {string} an unencoded domain name or null
	 * @param port {number} a port number in [1, 32768].
	 *    -1 indicates no port, as does null.
	 * @param path {string} an unencoded path
	 * @param query {Array.<string>|string|null} a list of unencoded cgi
	 *   parameters where even values are keys and odds the corresponding values
	 *   or an unencoded query.
	 * @param fragment {string} an unencoded fragment without the "#" or null.
	 * @return {URI}
	 */
	function create(scheme, credentials, domain, port, path, query, fragment) {
	  var uri = new URI(
	      encodeIfExists2(scheme, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_),
	      encodeIfExists2(
	          credentials, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_),
	      encodeIfExists(domain),
	      port > 0 ? port.toString() : null,
	      encodeIfExists2(path, URI_DISALLOWED_IN_PATH_),
	      null,
	      encodeIfExists(fragment));
	  if (query) {
	    if ('string' === typeof query) {
	      uri.setRawQuery(query.replace(/[^?&=0-9A-Za-z_\-~.%]/g, encodeOne));
	    } else {
	      uri.setAllParameters(query);
	    }
	  }
	  return uri;
	}
	function encodeIfExists(unescapedPart) {
	  if ('string' == typeof unescapedPart) {
	    return encodeURIComponent(unescapedPart);
	  }
	  return null;
	};
	/**
	 * if unescapedPart is non null, then escapes any characters in it that aren't
	 * valid characters in a url and also escapes any special characters that
	 * appear in extra.
	 *
	 * @param unescapedPart {string}
	 * @param extra {RegExp} a character set of characters in [\01-\177].
	 * @return {string|null} null iff unescapedPart == null.
	 */
	function encodeIfExists2(unescapedPart, extra) {
	  if ('string' == typeof unescapedPart) {
	    return encodeURI(unescapedPart).replace(extra, encodeOne);
	  }
	  return null;
	};
	/** converts a character in [\01-\177] to its url encoded equivalent. */
	function encodeOne(ch) {
	  var n = ch.charCodeAt(0);
	  return '%' + '0123456789ABCDEF'.charAt((n >> 4) & 0xf) +
	      '0123456789ABCDEF'.charAt(n & 0xf);
	}
	
	/**
	 * {@updoc
	 *  $ normPath('foo/./bar')
	 *  # 'foo/bar'
	 *  $ normPath('./foo')
	 *  # 'foo'
	 *  $ normPath('foo/.')
	 *  # 'foo'
	 *  $ normPath('foo//bar')
	 *  # 'foo/bar'
	 * }
	 */
	function normPath(path) {
	  return path.replace(/(^|\/)\.(?:\/|$)/g, '$1').replace(/\/{2,}/g, '/');
	}
	
	var PARENT_DIRECTORY_HANDLER = new RegExp(
	    ''
	    // A path break
	    + '(/|^)'
	    // followed by a non .. path element
	    // (cannot be . because normPath is used prior to this RegExp)
	    + '(?:[^./][^/]*|\\.{2,}(?:[^./][^/]*)|\\.{3,}[^/]*)'
	    // followed by .. followed by a path break.
	    + '/\\.\\.(?:/|$)');
	
	var PARENT_DIRECTORY_HANDLER_RE = new RegExp(PARENT_DIRECTORY_HANDLER);
	
	var EXTRA_PARENT_PATHS_RE = /^(?:\.\.\/)*(?:\.\.$)?/;
	
	/**
	 * Normalizes its input path and collapses all . and .. sequences except for
	 * .. sequences that would take it above the root of the current parent
	 * directory.
	 * {@updoc
	 *  $ collapse_dots('foo/../bar')
	 *  # 'bar'
	 *  $ collapse_dots('foo/./bar')
	 *  # 'foo/bar'
	 *  $ collapse_dots('foo/../bar/./../../baz')
	 *  # 'baz'
	 *  $ collapse_dots('../foo')
	 *  # '../foo'
	 *  $ collapse_dots('../foo').replace(EXTRA_PARENT_PATHS_RE, '')
	 *  # 'foo'
	 * }
	 */
	function collapse_dots(path) {
	  if (path === null) { return null; }
	  var p = normPath(path);
	  // Only /../ left to flatten
	  var r = PARENT_DIRECTORY_HANDLER_RE;
	  // We replace with $1 which matches a / before the .. because this
	  // guarantees that:
	  // (1) we have at most 1 / between the adjacent place,
	  // (2) always have a slash if there is a preceding path section, and
	  // (3) we never turn a relative path into an absolute path.
	  for (var q; (q = p.replace(r, '$1')) != p; p = q) {};
	  return p;
	}
	
	/**
	 * resolves a relative url string to a base uri.
	 * @return {URI}
	 */
	function resolve(baseUri, relativeUri) {
	  // there are several kinds of relative urls:
	  // 1. //foo - replaces everything from the domain on.  foo is a domain name
	  // 2. foo - replaces the last part of the path, the whole query and fragment
	  // 3. /foo - replaces the the path, the query and fragment
	  // 4. ?foo - replace the query and fragment
	  // 5. #foo - replace the fragment only
	
	  var absoluteUri = baseUri.clone();
	  // we satisfy these conditions by looking for the first part of relativeUri
	  // that is not blank and applying defaults to the rest
	
	  var overridden = relativeUri.hasScheme();
	
	  if (overridden) {
	    absoluteUri.setRawScheme(relativeUri.getRawScheme());
	  } else {
	    overridden = relativeUri.hasCredentials();
	  }
	
	  if (overridden) {
	    absoluteUri.setRawCredentials(relativeUri.getRawCredentials());
	  } else {
	    overridden = relativeUri.hasDomain();
	  }
	
	  if (overridden) {
	    absoluteUri.setRawDomain(relativeUri.getRawDomain());
	  } else {
	    overridden = relativeUri.hasPort();
	  }
	
	  var rawPath = relativeUri.getRawPath();
	  var simplifiedPath = collapse_dots(rawPath);
	  if (overridden) {
	    absoluteUri.setPort(relativeUri.getPort());
	    simplifiedPath = simplifiedPath
	        && simplifiedPath.replace(EXTRA_PARENT_PATHS_RE, '');
	  } else {
	    overridden = !!rawPath;
	    if (overridden) {
	      // resolve path properly
	      if (simplifiedPath.charCodeAt(0) !== 0x2f /* / */) {  // path is relative
	        var absRawPath = collapse_dots(absoluteUri.getRawPath() || '')
	            .replace(EXTRA_PARENT_PATHS_RE, '');
	        var slash = absRawPath.lastIndexOf('/') + 1;
	        simplifiedPath = collapse_dots(
	            (slash ? absRawPath.substring(0, slash) : '')
	            + collapse_dots(rawPath))
	            .replace(EXTRA_PARENT_PATHS_RE, '');
	      }
	    } else {
	      simplifiedPath = simplifiedPath
	          && simplifiedPath.replace(EXTRA_PARENT_PATHS_RE, '');
	      if (simplifiedPath !== rawPath) {
	        absoluteUri.setRawPath(simplifiedPath);
	      }
	    }
	  }
	
	  if (overridden) {
	    absoluteUri.setRawPath(simplifiedPath);
	  } else {
	    overridden = relativeUri.hasQuery();
	  }
	
	  if (overridden) {
	    absoluteUri.setRawQuery(relativeUri.getRawQuery());
	  } else {
	    overridden = relativeUri.hasFragment();
	  }
	
	  if (overridden) {
	    absoluteUri.setRawFragment(relativeUri.getRawFragment());
	  }
	
	  return absoluteUri;
	}
	
	/**
	 * a mutable URI.
	 *
	 * This class contains setters and getters for the parts of the URI.
	 * The <tt>getXYZ</tt>/<tt>setXYZ</tt> methods return the decoded part -- so
	 * <code>uri.parse('/foo%20bar').getPath()</code> will return the decoded path,
	 * <tt>/foo bar</tt>.
	 *
	 * <p>The raw versions of fields are available too.
	 * <code>uri.parse('/foo%20bar').getRawPath()</code> will return the raw path,
	 * <tt>/foo%20bar</tt>.  Use the raw setters with care, since
	 * <code>URI::toString</code> is not guaranteed to return a valid url if a
	 * raw setter was used.
	 *
	 * <p>All setters return <tt>this</tt> and so may be chained, a la
	 * <code>uri.parse('/foo').setFragment('part').toString()</code>.
	 *
	 * <p>You should not use this constructor directly -- please prefer the factory
	 * functions {@link uri.parse}, {@link uri.create}, {@link uri.resolve}
	 * instead.</p>
	 *
	 * <p>The parameters are all raw (assumed to be properly escaped) parts, and
	 * any (but not all) may be null.  Undefined is not allowed.</p>
	 *
	 * @constructor
	 */
	function URI(
	    rawScheme,
	    rawCredentials, rawDomain, port,
	    rawPath, rawQuery, rawFragment) {
	  this.scheme_ = rawScheme;
	  this.credentials_ = rawCredentials;
	  this.domain_ = rawDomain;
	  this.port_ = port;
	  this.path_ = rawPath;
	  this.query_ = rawQuery;
	  this.fragment_ = rawFragment;
	  /**
	   * @type {Array|null}
	   */
	  this.paramCache_ = null;
	}
	
	/** returns the string form of the url. */
	URI.prototype.toString = function () {
	  var out = [];
	  if (null !== this.scheme_) { out.push(this.scheme_, ':'); }
	  if (null !== this.domain_) {
	    out.push('//');
	    if (null !== this.credentials_) { out.push(this.credentials_, '@'); }
	    out.push(this.domain_);
	    if (null !== this.port_) { out.push(':', this.port_.toString()); }
	  }
	  if (null !== this.path_) { out.push(this.path_); }
	  if (null !== this.query_) { out.push('?', this.query_); }
	  if (null !== this.fragment_) { out.push('#', this.fragment_); }
	  return out.join('');
	};
	
	URI.prototype.clone = function () {
	  return new URI(this.scheme_, this.credentials_, this.domain_, this.port_,
	                 this.path_, this.query_, this.fragment_);
	};
	
	URI.prototype.getScheme = function () {
	  // HTML5 spec does not require the scheme to be lowercased but
	  // all common browsers except Safari lowercase the scheme.
	  return this.scheme_ && decodeURIComponent(this.scheme_).toLowerCase();
	};
	URI.prototype.getRawScheme = function () {
	  return this.scheme_;
	};
	URI.prototype.setScheme = function (newScheme) {
	  this.scheme_ = encodeIfExists2(
	      newScheme, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_);
	  return this;
	};
	URI.prototype.setRawScheme = function (newScheme) {
	  this.scheme_ = newScheme ? newScheme : null;
	  return this;
	};
	URI.prototype.hasScheme = function () {
	  return null !== this.scheme_;
	};
	
	
	URI.prototype.getCredentials = function () {
	  return this.credentials_ && decodeURIComponent(this.credentials_);
	};
	URI.prototype.getRawCredentials = function () {
	  return this.credentials_;
	};
	URI.prototype.setCredentials = function (newCredentials) {
	  this.credentials_ = encodeIfExists2(
	      newCredentials, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_);
	
	  return this;
	};
	URI.prototype.setRawCredentials = function (newCredentials) {
	  this.credentials_ = newCredentials ? newCredentials : null;
	  return this;
	};
	URI.prototype.hasCredentials = function () {
	  return null !== this.credentials_;
	};
	
	
	URI.prototype.getDomain = function () {
	  return this.domain_ && decodeURIComponent(this.domain_);
	};
	URI.prototype.getRawDomain = function () {
	  return this.domain_;
	};
	URI.prototype.setDomain = function (newDomain) {
	  return this.setRawDomain(newDomain && encodeURIComponent(newDomain));
	};
	URI.prototype.setRawDomain = function (newDomain) {
	  this.domain_ = newDomain ? newDomain : null;
	  // Maintain the invariant that paths must start with a slash when the URI
	  // is not path-relative.
	  return this.setRawPath(this.path_);
	};
	URI.prototype.hasDomain = function () {
	  return null !== this.domain_;
	};
	
	
	URI.prototype.getPort = function () {
	  return this.port_ && decodeURIComponent(this.port_);
	};
	URI.prototype.setPort = function (newPort) {
	  if (newPort) {
	    newPort = Number(newPort);
	    if (newPort !== (newPort & 0xffff)) {
	      throw new Error('Bad port number ' + newPort);
	    }
	    this.port_ = '' + newPort;
	  } else {
	    this.port_ = null;
	  }
	  return this;
	};
	URI.prototype.hasPort = function () {
	  return null !== this.port_;
	};
	
	
	URI.prototype.getPath = function () {
	  return this.path_ && decodeURIComponent(this.path_);
	};
	URI.prototype.getRawPath = function () {
	  return this.path_;
	};
	URI.prototype.setPath = function (newPath) {
	  return this.setRawPath(encodeIfExists2(newPath, URI_DISALLOWED_IN_PATH_));
	};
	URI.prototype.setRawPath = function (newPath) {
	  if (newPath) {
	    newPath = String(newPath);
	    this.path_ = 
	      // Paths must start with '/' unless this is a path-relative URL.
	      (!this.domain_ || /^\//.test(newPath)) ? newPath : '/' + newPath;
	  } else {
	    this.path_ = null;
	  }
	  return this;
	};
	URI.prototype.hasPath = function () {
	  return null !== this.path_;
	};
	
	
	URI.prototype.getQuery = function () {
	  // From http://www.w3.org/Addressing/URL/4_URI_Recommentations.html
	  // Within the query string, the plus sign is reserved as shorthand notation
	  // for a space.
	  return this.query_ && decodeURIComponent(this.query_).replace(/\+/g, ' ');
	};
	URI.prototype.getRawQuery = function () {
	  return this.query_;
	};
	URI.prototype.setQuery = function (newQuery) {
	  this.paramCache_ = null;
	  this.query_ = encodeIfExists(newQuery);
	  return this;
	};
	URI.prototype.setRawQuery = function (newQuery) {
	  this.paramCache_ = null;
	  this.query_ = newQuery ? newQuery : null;
	  return this;
	};
	URI.prototype.hasQuery = function () {
	  return null !== this.query_;
	};
	
	/**
	 * sets the query given a list of strings of the form
	 * [ key0, value0, key1, value1, ... ].
	 *
	 * <p><code>uri.setAllParameters(['a', 'b', 'c', 'd']).getQuery()</code>
	 * will yield <code>'a=b&c=d'</code>.
	 */
	URI.prototype.setAllParameters = function (params) {
	  if (typeof params === 'object') {
	    if (!(params instanceof Array)
	        && (params instanceof Object
	            || Object.prototype.toString.call(params) !== '[object Array]')) {
	      var newParams = [];
	      var i = -1;
	      for (var k in params) {
	        var v = params[k];
	        if ('string' === typeof v) {
	          newParams[++i] = k;
	          newParams[++i] = v;
	        }
	      }
	      params = newParams;
	    }
	  }
	  this.paramCache_ = null;
	  var queryBuf = [];
	  var separator = '';
	  for (var j = 0; j < params.length;) {
	    var k = params[j++];
	    var v = params[j++];
	    queryBuf.push(separator, encodeURIComponent(k.toString()));
	    separator = '&';
	    if (v) {
	      queryBuf.push('=', encodeURIComponent(v.toString()));
	    }
	  }
	  this.query_ = queryBuf.join('');
	  return this;
	};
	URI.prototype.checkParameterCache_ = function () {
	  if (!this.paramCache_) {
	    var q = this.query_;
	    if (!q) {
	      this.paramCache_ = [];
	    } else {
	      var cgiParams = q.split(/[&\?]/);
	      var out = [];
	      var k = -1;
	      for (var i = 0; i < cgiParams.length; ++i) {
	        var m = cgiParams[i].match(/^([^=]*)(?:=(.*))?$/);
	        // From http://www.w3.org/Addressing/URL/4_URI_Recommentations.html
	        // Within the query string, the plus sign is reserved as shorthand
	        // notation for a space.
	        out[++k] = decodeURIComponent(m[1]).replace(/\+/g, ' ');
	        out[++k] = decodeURIComponent(m[2] || '').replace(/\+/g, ' ');
	      }
	      this.paramCache_ = out;
	    }
	  }
	};
	/**
	 * sets the values of the named cgi parameters.
	 *
	 * <p>So, <code>uri.parse('foo?a=b&c=d&e=f').setParameterValues('c', ['new'])
	 * </code> yields <tt>foo?a=b&c=new&e=f</tt>.</p>
	 *
	 * @param key {string}
	 * @param values {Array.<string>} the new values.  If values is a single string
	 *   then it will be treated as the sole value.
	 */
	URI.prototype.setParameterValues = function (key, values) {
	  // be nice and avoid subtle bugs where [] operator on string performs charAt
	  // on some browsers and crashes on IE
	  if (typeof values === 'string') {
	    values = [ values ];
	  }
	
	  this.checkParameterCache_();
	  var newValueIndex = 0;
	  var pc = this.paramCache_;
	  var params = [];
	  for (var i = 0, k = 0; i < pc.length; i += 2) {
	    if (key === pc[i]) {
	      if (newValueIndex < values.length) {
	        params.push(key, values[newValueIndex++]);
	      }
	    } else {
	      params.push(pc[i], pc[i + 1]);
	    }
	  }
	  while (newValueIndex < values.length) {
	    params.push(key, values[newValueIndex++]);
	  }
	  this.setAllParameters(params);
	  return this;
	};
	URI.prototype.removeParameter = function (key) {
	  return this.setParameterValues(key, []);
	};
	/**
	 * returns the parameters specified in the query part of the uri as a list of
	 * keys and values like [ key0, value0, key1, value1, ... ].
	 *
	 * @return {Array.<string>}
	 */
	URI.prototype.getAllParameters = function () {
	  this.checkParameterCache_();
	  return this.paramCache_.slice(0, this.paramCache_.length);
	};
	/**
	 * returns the value<b>s</b> for a given cgi parameter as a list of decoded
	 * query parameter values.
	 * @return {Array.<string>}
	 */
	URI.prototype.getParameterValues = function (paramNameUnescaped) {
	  this.checkParameterCache_();
	  var values = [];
	  for (var i = 0; i < this.paramCache_.length; i += 2) {
	    if (paramNameUnescaped === this.paramCache_[i]) {
	      values.push(this.paramCache_[i + 1]);
	    }
	  }
	  return values;
	};
	/**
	 * returns a map of cgi parameter names to (non-empty) lists of values.
	 * @return {Object.<string,Array.<string>>}
	 */
	URI.prototype.getParameterMap = function (paramNameUnescaped) {
	  this.checkParameterCache_();
	  var paramMap = {};
	  for (var i = 0; i < this.paramCache_.length; i += 2) {
	    var key = this.paramCache_[i++],
	      value = this.paramCache_[i++];
	    if (!(key in paramMap)) {
	      paramMap[key] = [value];
	    } else {
	      paramMap[key].push(value);
	    }
	  }
	  return paramMap;
	};
	/**
	 * returns the first value for a given cgi parameter or null if the given
	 * parameter name does not appear in the query string.
	 * If the given parameter name does appear, but has no '<tt>=</tt>' following
	 * it, then the empty string will be returned.
	 * @return {string|null}
	 */
	URI.prototype.getParameterValue = function (paramNameUnescaped) {
	  this.checkParameterCache_();
	  for (var i = 0; i < this.paramCache_.length; i += 2) {
	    if (paramNameUnescaped === this.paramCache_[i]) {
	      return this.paramCache_[i + 1];
	    }
	  }
	  return null;
	};
	
	URI.prototype.getFragment = function () {
	  return this.fragment_ && decodeURIComponent(this.fragment_);
	};
	URI.prototype.getRawFragment = function () {
	  return this.fragment_;
	};
	URI.prototype.setFragment = function (newFragment) {
	  this.fragment_ = newFragment ? encodeURIComponent(newFragment) : null;
	  return this;
	};
	URI.prototype.setRawFragment = function (newFragment) {
	  this.fragment_ = newFragment ? newFragment : null;
	  return this;
	};
	URI.prototype.hasFragment = function () {
	  return null !== this.fragment_;
	};
	
	function nullIfAbsent(matchPart) {
	  return ('string' == typeof matchPart) && (matchPart.length > 0)
	         ? matchPart
	         : null;
	}
	
	
	
	
	/**
	 * a regular expression for breaking a URI into its component parts.
	 *
	 * <p>http://www.gbiv.com/protocols/uri/rfc/rfc3986.html#RFC2234 says
	 * As the "first-match-wins" algorithm is identical to the "greedy"
	 * disambiguation method used by POSIX regular expressions, it is natural and
	 * commonplace to use a regular expression for parsing the potential five
	 * components of a URI reference.
	 *
	 * <p>The following line is the regular expression for breaking-down a
	 * well-formed URI reference into its components.
	 *
	 * <pre>
	 * ^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?
	 *  12            3  4          5       6  7        8 9
	 * </pre>
	 *
	 * <p>The numbers in the second line above are only to assist readability; they
	 * indicate the reference points for each subexpression (i.e., each paired
	 * parenthesis). We refer to the value matched for subexpression <n> as $<n>.
	 * For example, matching the above expression to
	 * <pre>
	 *     http://www.ics.uci.edu/pub/ietf/uri/#Related
	 * </pre>
	 * results in the following subexpression matches:
	 * <pre>
	 *    $1 = http:
	 *    $2 = http
	 *    $3 = //www.ics.uci.edu
	 *    $4 = www.ics.uci.edu
	 *    $5 = /pub/ietf/uri/
	 *    $6 = <undefined>
	 *    $7 = <undefined>
	 *    $8 = #Related
	 *    $9 = Related
	 * </pre>
	 * where <undefined> indicates that the component is not present, as is the
	 * case for the query component in the above example. Therefore, we can
	 * determine the value of the five components as
	 * <pre>
	 *    scheme    = $2
	 *    authority = $4
	 *    path      = $5
	 *    query     = $7
	 *    fragment  = $9
	 * </pre>
	 *
	 * <p>msamuel: I have modified the regular expression slightly to expose the
	 * credentials, domain, and port separately from the authority.
	 * The modified version yields
	 * <pre>
	 *    $1 = http              scheme
	 *    $2 = <undefined>       credentials -\
	 *    $3 = www.ics.uci.edu   domain       | authority
	 *    $4 = <undefined>       port        -/
	 *    $5 = /pub/ietf/uri/    path
	 *    $6 = <undefined>       query without ?
	 *    $7 = Related           fragment without #
	 * </pre>
	 */
	var URI_RE_ = new RegExp(
	      "^" +
	      "(?:" +
	        "([^:/?#]+)" +         // scheme
	      ":)?" +
	      "(?://" +
	        "(?:([^/?#]*)@)?" +    // credentials
	        "([^/?#:@]*)" +        // domain
	        "(?::([0-9]+))?" +     // port
	      ")?" +
	      "([^?#]+)?" +            // path
	      "(?:\\?([^#]*))?" +      // query
	      "(?:#(.*))?" +           // fragment
	      "$"
	      );
	
	var URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_ = /[#\/\?@]/g;
	var URI_DISALLOWED_IN_PATH_ = /[\#\?]/g;
	
	URI.parse = parse;
	URI.create = create;
	URI.resolve = resolve;
	URI.collapse_dots = collapse_dots;  // Visible for testing.
	
	// lightweight string-based api for loadModuleMaker
	URI.utils = {
	  mimeTypeOf: function (uri) {
	    var uriObj = parse(uri);
	    if (/\.html$/.test(uriObj.getPath())) {
	      return 'text/html';
	    } else {
	      return 'application/javascript';
	    }
	  },
	  resolve: function (base, uri) {
	    if (base) {
	      return resolve(parse(base), parse(uri)).toString();
	    } else {
	      return '' + uri;
	    }
	  }
	};
	
	
	return URI;
	})();
	
	// Copyright Google Inc.
	// Licensed under the Apache Licence Version 2.0
	// Autogenerated at Mon Feb 25 13:05:42 EST 2013
	// @overrides window
	// @provides html4
	var html4 = {};
	html4.atype = {
	  'NONE': 0,
	  'URI': 1,
	  'URI_FRAGMENT': 11,
	  'SCRIPT': 2,
	  'STYLE': 3,
	  'HTML': 12,
	  'ID': 4,
	  'IDREF': 5,
	  'IDREFS': 6,
	  'GLOBAL_NAME': 7,
	  'LOCAL_NAME': 8,
	  'CLASSES': 9,
	  'FRAME_TARGET': 10,
	  'MEDIA_QUERY': 13
	};
	html4[ 'atype' ] = html4.atype;
	html4.ATTRIBS = {
	  '*::class': 9,
	  '*::dir': 0,
	  '*::draggable': 0,
	  '*::hidden': 0,
	  '*::id': 4,
	  '*::inert': 0,
	  '*::itemprop': 0,
	  '*::itemref': 6,
	  '*::itemscope': 0,
	  '*::lang': 0,
	  '*::onblur': 2,
	  '*::onchange': 2,
	  '*::onclick': 2,
	  '*::ondblclick': 2,
	  '*::onfocus': 2,
	  '*::onkeydown': 2,
	  '*::onkeypress': 2,
	  '*::onkeyup': 2,
	  '*::onload': 2,
	  '*::onmousedown': 2,
	  '*::onmousemove': 2,
	  '*::onmouseout': 2,
	  '*::onmouseover': 2,
	  '*::onmouseup': 2,
	  '*::onreset': 2,
	  '*::onscroll': 2,
	  '*::onselect': 2,
	  '*::onsubmit': 2,
	  '*::onunload': 2,
	  '*::spellcheck': 0,
	  '*::style': 3,
	  '*::title': 0,
	  '*::translate': 0,
	  'a::accesskey': 0,
	  'a::coords': 0,
	  'a::href': 1,
	  'a::hreflang': 0,
	  'a::name': 7,
	  'a::onblur': 2,
	  'a::onfocus': 2,
	  'a::shape': 0,
	  'a::tabindex': 0,
	  'a::target': 10,
	  'a::type': 0,
	  'area::accesskey': 0,
	  'area::alt': 0,
	  'area::coords': 0,
	  'area::href': 1,
	  'area::nohref': 0,
	  'area::onblur': 2,
	  'area::onfocus': 2,
	  'area::shape': 0,
	  'area::tabindex': 0,
	  'area::target': 10,
	  'audio::controls': 0,
	  'audio::loop': 0,
	  'audio::mediagroup': 5,
	  'audio::muted': 0,
	  'audio::preload': 0,
	  'bdo::dir': 0,
	  'blockquote::cite': 1,
	  'br::clear': 0,
	  'button::accesskey': 0,
	  'button::disabled': 0,
	  'button::name': 8,
	  'button::onblur': 2,
	  'button::onfocus': 2,
	  'button::tabindex': 0,
	  'button::type': 0,
	  'button::value': 0,
	  'canvas::height': 0,
	  'canvas::width': 0,
	  'caption::align': 0,
	  'col::align': 0,
	  'col::char': 0,
	  'col::charoff': 0,
	  'col::span': 0,
	  'col::valign': 0,
	  'col::width': 0,
	  'colgroup::align': 0,
	  'colgroup::char': 0,
	  'colgroup::charoff': 0,
	  'colgroup::span': 0,
	  'colgroup::valign': 0,
	  'colgroup::width': 0,
	  'command::checked': 0,
	  'command::command': 5,
	  'command::disabled': 0,
	  'command::icon': 1,
	  'command::label': 0,
	  'command::radiogroup': 0,
	  'command::type': 0,
	  'data::value': 0,
	  'del::cite': 1,
	  'del::datetime': 0,
	  'details::open': 0,
	  'dir::compact': 0,
	  'div::align': 0,
	  'dl::compact': 0,
	  'fieldset::disabled': 0,
	  'font::color': 0,
	  'font::face': 0,
	  'font::size': 0,
	  'form::accept': 0,
	  'form::action': 1,
	  'form::autocomplete': 0,
	  'form::enctype': 0,
	  'form::method': 0,
	  'form::name': 7,
	  'form::novalidate': 0,
	  'form::onreset': 2,
	  'form::onsubmit': 2,
	  'form::target': 10,
	  'h1::align': 0,
	  'h2::align': 0,
	  'h3::align': 0,
	  'h4::align': 0,
	  'h5::align': 0,
	  'h6::align': 0,
	  'hr::align': 0,
	  'hr::noshade': 0,
	  'hr::size': 0,
	  'hr::width': 0,
	  'iframe::align': 0,
	  'iframe::frameborder': 0,
	  'iframe::height': 0,
	  'iframe::marginheight': 0,
	  'iframe::marginwidth': 0,
	  'iframe::width': 0,
	  'img::align': 0,
	  'img::alt': 0,
	  'img::border': 0,
	  'img::height': 0,
	  'img::hspace': 0,
	  'img::ismap': 0,
	  'img::name': 7,
	  'img::src': 1,
	  'img::usemap': 11,
	  'img::vspace': 0,
	  'img::width': 0,
	  'input::accept': 0,
	  'input::accesskey': 0,
	  'input::align': 0,
	  'input::alt': 0,
	  'input::autocomplete': 0,
	  'input::checked': 0,
	  'input::disabled': 0,
	  'input::inputmode': 0,
	  'input::ismap': 0,
	  'input::list': 5,
	  'input::max': 0,
	  'input::maxlength': 0,
	  'input::min': 0,
	  'input::multiple': 0,
	  'input::name': 8,
	  'input::onblur': 2,
	  'input::onchange': 2,
	  'input::onfocus': 2,
	  'input::onselect': 2,
	  'input::placeholder': 0,
	  'input::readonly': 0,
	  'input::required': 0,
	  'input::size': 0,
	  'input::src': 1,
	  'input::step': 0,
	  'input::tabindex': 0,
	  'input::type': 0,
	  'input::usemap': 11,
	  'input::value': 0,
	  'ins::cite': 1,
	  'ins::datetime': 0,
	  'label::accesskey': 0,
	  'label::for': 5,
	  'label::onblur': 2,
	  'label::onfocus': 2,
	  'legend::accesskey': 0,
	  'legend::align': 0,
	  'li::type': 0,
	  'li::value': 0,
	  'map::name': 7,
	  'menu::compact': 0,
	  'menu::label': 0,
	  'menu::type': 0,
	  'meter::high': 0,
	  'meter::low': 0,
	  'meter::max': 0,
	  'meter::min': 0,
	  'meter::value': 0,
	  'ol::compact': 0,
	  'ol::reversed': 0,
	  'ol::start': 0,
	  'ol::type': 0,
	  'optgroup::disabled': 0,
	  'optgroup::label': 0,
	  'option::disabled': 0,
	  'option::label': 0,
	  'option::selected': 0,
	  'option::value': 0,
	  'output::for': 6,
	  'output::name': 8,
	  'p::align': 0,
	  'pre::width': 0,
	  'progress::max': 0,
	  'progress::min': 0,
	  'progress::value': 0,
	  'q::cite': 1,
	  'select::autocomplete': 0,
	  'select::disabled': 0,
	  'select::multiple': 0,
	  'select::name': 8,
	  'select::onblur': 2,
	  'select::onchange': 2,
	  'select::onfocus': 2,
	  'select::required': 0,
	  'select::size': 0,
	  'select::tabindex': 0,
	  'source::type': 0,
	  'table::align': 0,
	  'table::bgcolor': 0,
	  'table::border': 0,
	  'table::cellpadding': 0,
	  'table::cellspacing': 0,
	  'table::frame': 0,
	  'table::rules': 0,
	  'table::summary': 0,
	  'table::width': 0,
	  'tbody::align': 0,
	  'tbody::char': 0,
	  'tbody::charoff': 0,
	  'tbody::valign': 0,
	  'td::abbr': 0,
	  'td::align': 0,
	  'td::axis': 0,
	  'td::bgcolor': 0,
	  'td::char': 0,
	  'td::charoff': 0,
	  'td::colspan': 0,
	  'td::headers': 6,
	  'td::height': 0,
	  'td::nowrap': 0,
	  'td::rowspan': 0,
	  'td::scope': 0,
	  'td::valign': 0,
	  'td::width': 0,
	  'textarea::accesskey': 0,
	  'textarea::autocomplete': 0,
	  'textarea::cols': 0,
	  'textarea::disabled': 0,
	  'textarea::inputmode': 0,
	  'textarea::name': 8,
	  'textarea::onblur': 2,
	  'textarea::onchange': 2,
	  'textarea::onfocus': 2,
	  'textarea::onselect': 2,
	  'textarea::placeholder': 0,
	  'textarea::readonly': 0,
	  'textarea::required': 0,
	  'textarea::rows': 0,
	  'textarea::tabindex': 0,
	  'textarea::wrap': 0,
	  'tfoot::align': 0,
	  'tfoot::char': 0,
	  'tfoot::charoff': 0,
	  'tfoot::valign': 0,
	  'th::abbr': 0,
	  'th::align': 0,
	  'th::axis': 0,
	  'th::bgcolor': 0,
	  'th::char': 0,
	  'th::charoff': 0,
	  'th::colspan': 0,
	  'th::headers': 6,
	  'th::height': 0,
	  'th::nowrap': 0,
	  'th::rowspan': 0,
	  'th::scope': 0,
	  'th::valign': 0,
	  'th::width': 0,
	  'thead::align': 0,
	  'thead::char': 0,
	  'thead::charoff': 0,
	  'thead::valign': 0,
	  'tr::align': 0,
	  'tr::bgcolor': 0,
	  'tr::char': 0,
	  'tr::charoff': 0,
	  'tr::valign': 0,
	  'track::default': 0,
	  'track::kind': 0,
	  'track::label': 0,
	  'track::srclang': 0,
	  'ul::compact': 0,
	  'ul::type': 0,
	  'video::controls': 0,
	  'video::height': 0,
	  'video::loop': 0,
	  'video::mediagroup': 5,
	  'video::muted': 0,
	  'video::poster': 1,
	  'video::preload': 0,
	  'video::width': 0
	};
	html4[ 'ATTRIBS' ] = html4.ATTRIBS;
	html4.eflags = {
	  'OPTIONAL_ENDTAG': 1,
	  'EMPTY': 2,
	  'CDATA': 4,
	  'RCDATA': 8,
	  'UNSAFE': 16,
	  'FOLDABLE': 32,
	  'SCRIPT': 64,
	  'STYLE': 128,
	  'VIRTUALIZED': 256
	};
	html4[ 'eflags' ] = html4.eflags;
	// these are bitmasks of the eflags above.
	html4.ELEMENTS = {
	  'a': 0,
	  'abbr': 0,
	  'acronym': 0,
	  'address': 0,
	  'applet': 272,
	  'area': 2,
	  'article': 0,
	  'aside': 0,
	  'audio': 0,
	  'b': 0,
	  'base': 274,
	  'basefont': 274,
	  'bdi': 0,
	  'bdo': 0,
	  'big': 0,
	  'blockquote': 0,
	  'body': 305,
	  'br': 2,
	  'button': 0,
	  'canvas': 0,
	  'caption': 0,
	  'center': 0,
	  'cite': 0,
	  'code': 0,
	  'col': 2,
	  'colgroup': 1,
	  'command': 2,
	  'data': 0,
	  'datalist': 0,
	  'dd': 1,
	  'del': 0,
	  'details': 0,
	  'dfn': 0,
	  'dialog': 272,
	  'dir': 0,
	  'div': 0,
	  'dl': 0,
	  'dt': 1,
	  'em': 0,
	  'fieldset': 0,
	  'figcaption': 0,
	  'figure': 0,
	  'font': 0,
	  'footer': 0,
	  'form': 0,
	  'frame': 274,
	  'frameset': 272,
	  'h1': 0,
	  'h2': 0,
	  'h3': 0,
	  'h4': 0,
	  'h5': 0,
	  'h6': 0,
	  'head': 305,
	  'header': 0,
	  'hgroup': 0,
	  'hr': 2,
	  'html': 305,
	  'i': 0,
	  'iframe': 16,
	  'img': 2,
	  'input': 2,
	  'ins': 0,
	  'isindex': 274,
	  'kbd': 0,
	  'keygen': 274,
	  'label': 0,
	  'legend': 0,
	  'li': 1,
	  'link': 274,
	  'map': 0,
	  'mark': 0,
	  'menu': 0,
	  'meta': 274,
	  'meter': 0,
	  'nav': 0,
	  'nobr': 0,
	  'noembed': 276,
	  'noframes': 276,
	  'noscript': 276,
	  'object': 272,
	  'ol': 0,
	  'optgroup': 0,
	  'option': 1,
	  'output': 0,
	  'p': 1,
	  'param': 274,
	  'pre': 0,
	  'progress': 0,
	  'q': 0,
	  's': 0,
	  'samp': 0,
	  'script': 84,
	  'section': 0,
	  'select': 0,
	  'small': 0,
	  'source': 2,
	  'span': 0,
	  'strike': 0,
	  'strong': 0,
	  'style': 148,
	  'sub': 0,
	  'summary': 0,
	  'sup': 0,
	  'table': 0,
	  'tbody': 1,
	  'td': 1,
	  'textarea': 8,
	  'tfoot': 1,
	  'th': 1,
	  'thead': 1,
	  'time': 0,
	  'title': 280,
	  'tr': 1,
	  'track': 2,
	  'tt': 0,
	  'u': 0,
	  'ul': 0,
	  'var': 0,
	  'video': 0,
	  'wbr': 2
	};
	html4[ 'ELEMENTS' ] = html4.ELEMENTS;
	html4.ELEMENT_DOM_INTERFACES = {
	  'a': 'HTMLAnchorElement',
	  'abbr': 'HTMLElement',
	  'acronym': 'HTMLElement',
	  'address': 'HTMLElement',
	  'applet': 'HTMLAppletElement',
	  'area': 'HTMLAreaElement',
	  'article': 'HTMLElement',
	  'aside': 'HTMLElement',
	  'audio': 'HTMLAudioElement',
	  'b': 'HTMLElement',
	  'base': 'HTMLBaseElement',
	  'basefont': 'HTMLBaseFontElement',
	  'bdi': 'HTMLElement',
	  'bdo': 'HTMLElement',
	  'big': 'HTMLElement',
	  'blockquote': 'HTMLQuoteElement',
	  'body': 'HTMLBodyElement',
	  'br': 'HTMLBRElement',
	  'button': 'HTMLButtonElement',
	  'canvas': 'HTMLCanvasElement',
	  'caption': 'HTMLTableCaptionElement',
	  'center': 'HTMLElement',
	  'cite': 'HTMLElement',
	  'code': 'HTMLElement',
	  'col': 'HTMLTableColElement',
	  'colgroup': 'HTMLTableColElement',
	  'command': 'HTMLCommandElement',
	  'data': 'HTMLElement',
	  'datalist': 'HTMLDataListElement',
	  'dd': 'HTMLElement',
	  'del': 'HTMLModElement',
	  'details': 'HTMLDetailsElement',
	  'dfn': 'HTMLElement',
	  'dialog': 'HTMLDialogElement',
	  'dir': 'HTMLDirectoryElement',
	  'div': 'HTMLDivElement',
	  'dl': 'HTMLDListElement',
	  'dt': 'HTMLElement',
	  'em': 'HTMLElement',
	  'fieldset': 'HTMLFieldSetElement',
	  'figcaption': 'HTMLElement',
	  'figure': 'HTMLElement',
	  'font': 'HTMLFontElement',
	  'footer': 'HTMLElement',
	  'form': 'HTMLFormElement',
	  'frame': 'HTMLFrameElement',
	  'frameset': 'HTMLFrameSetElement',
	  'h1': 'HTMLHeadingElement',
	  'h2': 'HTMLHeadingElement',
	  'h3': 'HTMLHeadingElement',
	  'h4': 'HTMLHeadingElement',
	  'h5': 'HTMLHeadingElement',
	  'h6': 'HTMLHeadingElement',
	  'head': 'HTMLHeadElement',
	  'header': 'HTMLElement',
	  'hgroup': 'HTMLElement',
	  'hr': 'HTMLHRElement',
	  'html': 'HTMLHtmlElement',
	  'i': 'HTMLElement',
	  'iframe': 'HTMLIFrameElement',
	  'img': 'HTMLImageElement',
	  'input': 'HTMLInputElement',
	  'ins': 'HTMLModElement',
	  'isindex': 'HTMLUnknownElement',
	  'kbd': 'HTMLElement',
	  'keygen': 'HTMLKeygenElement',
	  'label': 'HTMLLabelElement',
	  'legend': 'HTMLLegendElement',
	  'li': 'HTMLLIElement',
	  'link': 'HTMLLinkElement',
	  'map': 'HTMLMapElement',
	  'mark': 'HTMLElement',
	  'menu': 'HTMLMenuElement',
	  'meta': 'HTMLMetaElement',
	  'meter': 'HTMLMeterElement',
	  'nav': 'HTMLElement',
	  'nobr': 'HTMLElement',
	  'noembed': 'HTMLElement',
	  'noframes': 'HTMLElement',
	  'noscript': 'HTMLElement',
	  'object': 'HTMLObjectElement',
	  'ol': 'HTMLOListElement',
	  'optgroup': 'HTMLOptGroupElement',
	  'option': 'HTMLOptionElement',
	  'output': 'HTMLOutputElement',
	  'p': 'HTMLParagraphElement',
	  'param': 'HTMLParamElement',
	  'pre': 'HTMLPreElement',
	  'progress': 'HTMLProgressElement',
	  'q': 'HTMLQuoteElement',
	  's': 'HTMLElement',
	  'samp': 'HTMLElement',
	  'script': 'HTMLScriptElement',
	  'section': 'HTMLElement',
	  'select': 'HTMLSelectElement',
	  'small': 'HTMLElement',
	  'source': 'HTMLSourceElement',
	  'span': 'HTMLSpanElement',
	  'strike': 'HTMLElement',
	  'strong': 'HTMLElement',
	  'style': 'HTMLStyleElement',
	  'sub': 'HTMLElement',
	  'summary': 'HTMLElement',
	  'sup': 'HTMLElement',
	  'table': 'HTMLTableElement',
	  'tbody': 'HTMLTableSectionElement',
	  'td': 'HTMLTableDataCellElement',
	  'textarea': 'HTMLTextAreaElement',
	  'tfoot': 'HTMLTableSectionElement',
	  'th': 'HTMLTableHeaderCellElement',
	  'thead': 'HTMLTableSectionElement',
	  'time': 'HTMLTimeElement',
	  'title': 'HTMLTitleElement',
	  'tr': 'HTMLTableRowElement',
	  'track': 'HTMLTrackElement',
	  'tt': 'HTMLElement',
	  'u': 'HTMLElement',
	  'ul': 'HTMLUListElement',
	  'var': 'HTMLElement',
	  'video': 'HTMLVideoElement',
	  'wbr': 'HTMLElement'
	};
	html4[ 'ELEMENT_DOM_INTERFACES' ] = html4.ELEMENT_DOM_INTERFACES;
	html4.ueffects = {
	  'NOT_LOADED': 0,
	  'SAME_DOCUMENT': 1,
	  'NEW_DOCUMENT': 2
	};
	html4[ 'ueffects' ] = html4.ueffects;
	html4.URIEFFECTS = {
	  'a::href': 2,
	  'area::href': 2,
	  'blockquote::cite': 0,
	  'command::icon': 1,
	  'del::cite': 0,
	  'form::action': 2,
	  'img::src': 1,
	  'input::src': 1,
	  'ins::cite': 0,
	  'q::cite': 0,
	  'video::poster': 1
	};
	html4[ 'URIEFFECTS' ] = html4.URIEFFECTS;
	html4.ltypes = {
	  'UNSANDBOXED': 2,
	  'SANDBOXED': 1,
	  'DATA': 0
	};
	html4[ 'ltypes' ] = html4.ltypes;
	html4.LOADERTYPES = {
	  'a::href': 2,
	  'area::href': 2,
	  'blockquote::cite': 2,
	  'command::icon': 1,
	  'del::cite': 2,
	  'form::action': 2,
	  'img::src': 1,
	  'input::src': 1,
	  'ins::cite': 2,
	  'q::cite': 2,
	  'video::poster': 1
	};
	html4[ 'LOADERTYPES' ] = html4.LOADERTYPES;
	
	// Copyright (C) 2006 Google Inc.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	/**
	 * @fileoverview
	 * An HTML sanitizer that can satisfy a variety of security policies.
	 *
	 * <p>
	 * The HTML sanitizer is built around a SAX parser and HTML element and
	 * attributes schemas.
	 *
	 * If the cssparser is loaded, inline styles are sanitized using the
	 * css property and value schemas.  Else they are remove during
	 * sanitization.
	 *
	 * If it exists, uses parseCssDeclarations, sanitizeCssProperty,  cssSchema
	 *
	 * @author mikesamuel@gmail.com
	 * @author jasvir@gmail.com
	 * \@requires html4, URI
	 * \@overrides window
	 * \@provides html, html_sanitize
	 */
	
	// The Turkish i seems to be a non-issue, but abort in case it is.
	if ('I'.toLowerCase() !== 'i') { throw 'I/i problem'; }
	
	/**
	 * \@namespace
	 */
	var html = (function(html4) {
	
	  // For closure compiler
	  var parseCssDeclarations, sanitizeCssProperty, cssSchema;
	  if ('undefined' !== typeof window) {
	    parseCssDeclarations = window['parseCssDeclarations'];
	    sanitizeCssProperty = window['sanitizeCssProperty'];
	    cssSchema = window['cssSchema'];
	  }
	
	  // The keys of this object must be 'quoted' or JSCompiler will mangle them!
	  // This is a partial list -- lookupEntity() uses the host browser's parser
	  // (when available) to implement full entity lookup.
	  // Note that entities are in general case-sensitive; the uppercase ones are
	  // explicitly defined by HTML5 (presumably as compatibility).
	  var ENTITIES = {
	    'lt': '<',
	    'LT': '<',
	    'gt': '>',
	    'GT': '>',
	    'amp': '&',
	    'AMP': '&',
	    'quot': '"',
	    'apos': '\'',
	    'nbsp': '\240'
	  };
	
	  // Patterns for types of entity/character reference names.
	  var decimalEscapeRe = /^#(\d+)$/;
	  var hexEscapeRe = /^#x([0-9A-Fa-f]+)$/;
	  // contains every entity per http://www.w3.org/TR/2011/WD-html5-20110113/named-character-references.html
	  var safeEntityNameRe = /^[A-Za-z][A-za-z0-9]+$/;
	  // Used as a hook to invoke the browser's entity parsing. <textarea> is used
	  // because its content is parsed for entities but not tags.
	  // TODO(kpreid): This retrieval is a kludge and leads to silent loss of
	  // functionality if the document isn't available.
	  var entityLookupElement =
	      ('undefined' !== typeof window && window['document'])
	          ? window['document'].createElement('textarea') : null;
	  /**
	   * Decodes an HTML entity.
	   *
	   * {\@updoc
	   * $ lookupEntity('lt')
	   * # '<'
	   * $ lookupEntity('GT')
	   * # '>'
	   * $ lookupEntity('amp')
	   * # '&'
	   * $ lookupEntity('nbsp')
	   * # '\xA0'
	   * $ lookupEntity('apos')
	   * # "'"
	   * $ lookupEntity('quot')
	   * # '"'
	   * $ lookupEntity('#xa')
	   * # '\n'
	   * $ lookupEntity('#10')
	   * # '\n'
	   * $ lookupEntity('#x0a')
	   * # '\n'
	   * $ lookupEntity('#010')
	   * # '\n'
	   * $ lookupEntity('#x00A')
	   * # '\n'
	   * $ lookupEntity('Pi')      // Known failure
	   * # '\u03A0'
	   * $ lookupEntity('pi')      // Known failure
	   * # '\u03C0'
	   * }
	   *
	   * @param {string} name the content between the '&' and the ';'.
	   * @return {string} a single unicode code-point as a string.
	   */
	  function lookupEntity(name) {
	    // TODO: entity lookup as specified by HTML5 actually depends on the
	    // presence of the ";".
	    if (ENTITIES.hasOwnProperty(name)) { return ENTITIES[name]; }
	    var m = name.match(decimalEscapeRe);
	    if (m) {
	      return String.fromCharCode(parseInt(m[1], 10));
	    } else if (!!(m = name.match(hexEscapeRe))) {
	      return String.fromCharCode(parseInt(m[1], 16));
	    } else if (entityLookupElement && safeEntityNameRe.test(name)) {
	      entityLookupElement.innerHTML = '&' + name + ';';
	      var text = entityLookupElement.textContent;
	      ENTITIES[name] = text;
	      return text;
	    } else {
	      return '&' + name + ';';
	    }
	  }
	
	  function decodeOneEntity(_, name) {
	    return lookupEntity(name);
	  }
	
	  var nulRe = /\0/g;
	  function stripNULs(s) {
	    return s.replace(nulRe, '');
	  }
	
	  var ENTITY_RE_1 = /&(#[0-9]+|#[xX][0-9A-Fa-f]+|\w+);/g;
	  var ENTITY_RE_2 = /^(#[0-9]+|#[xX][0-9A-Fa-f]+|\w+);/;
	  /**
	   * The plain text of a chunk of HTML CDATA which possibly containing.
	   *
	   * {\@updoc
	   * $ unescapeEntities('')
	   * # ''
	   * $ unescapeEntities('hello World!')
	   * # 'hello World!'
	   * $ unescapeEntities('1 &lt; 2 &amp;&AMP; 4 &gt; 3&#10;')
	   * # '1 < 2 && 4 > 3\n'
	   * $ unescapeEntities('&lt;&lt <- unfinished entity&gt;')
	   * # '<&lt <- unfinished entity>'
	   * $ unescapeEntities('/foo?bar=baz&copy=true')  // & often unescaped in URLS
	   * # '/foo?bar=baz&copy=true'
	   * $ unescapeEntities('pi=&pi;&#x3c0;, Pi=&Pi;\u03A0') // FIXME: known failure
	   * # 'pi=\u03C0\u03c0, Pi=\u03A0\u03A0'
	   * }
	   *
	   * @param {string} s a chunk of HTML CDATA.  It must not start or end inside
	   *     an HTML entity.
	   */
	  function unescapeEntities(s) {
	    return s.replace(ENTITY_RE_1, decodeOneEntity);
	  }
	
	  var ampRe = /&/g;
	  var looseAmpRe = /&([^a-z#]|#(?:[^0-9x]|x(?:[^0-9a-f]|$)|$)|$)/gi;
	  var ltRe = /[<]/g;
	  var gtRe = />/g;
	  var quotRe = /\"/g;
	
	  /**
	   * Escapes HTML special characters in attribute values.
	   *
	   * {\@updoc
	   * $ escapeAttrib('')
	   * # ''
	   * $ escapeAttrib('"<<&==&>>"')  // Do not just escape the first occurrence.
	   * # '&#34;&lt;&lt;&amp;&#61;&#61;&amp;&gt;&gt;&#34;'
	   * $ escapeAttrib('Hello <World>!')
	   * # 'Hello &lt;World&gt;!'
	   * }
	   */
	  function escapeAttrib(s) {
	    return ('' + s).replace(ampRe, '&amp;').replace(ltRe, '&lt;')
	        .replace(gtRe, '&gt;').replace(quotRe, '&#34;');
	  }
	
	  /**
	   * Escape entities in RCDATA that can be escaped without changing the meaning.
	   * {\@updoc
	   * $ normalizeRCData('1 < 2 &&amp; 3 > 4 &amp;& 5 &lt; 7&8')
	   * # '1 &lt; 2 &amp;&amp; 3 &gt; 4 &amp;&amp; 5 &lt; 7&amp;8'
	   * }
	   */
	  function normalizeRCData(rcdata) {
	    return rcdata
	        .replace(looseAmpRe, '&amp;$1')
	        .replace(ltRe, '&lt;')
	        .replace(gtRe, '&gt;');
	  }
	
	  // TODO(felix8a): validate sanitizer regexs against the HTML5 grammar at
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/syntax.html
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html
	
	  // We initially split input so that potentially meaningful characters
	  // like '<' and '>' are separate tokens, using a fast dumb process that
	  // ignores quoting.  Then we walk that token stream, and when we see a
	  // '<' that's the start of a tag, we use ATTR_RE to extract tag
	  // attributes from the next token.  That token will never have a '>'
	  // character.  However, it might have an unbalanced quote character, and
	  // when we see that, we combine additional tokens to balance the quote.
	
	  var ATTR_RE = new RegExp(
	    '^\\s*' +
	    '([-.:\\w]+)' +             // 1 = Attribute name
	    '(?:' + (
	      '\\s*(=)\\s*' +           // 2 = Is there a value?
	      '(' + (                   // 3 = Attribute value
	        // TODO(felix8a): maybe use backref to match quotes
	        '(\")[^\"]*(\"|$)' +    // 4, 5 = Double-quoted string
	        '|' +
	        '(\')[^\']*(\'|$)' +    // 6, 7 = Single-quoted string
	        '|' +
	        // Positive lookahead to prevent interpretation of
	        // <foo a= b=c> as <foo a='b=c'>
	        // TODO(felix8a): might be able to drop this case
	        '(?=[a-z][-\\w]*\\s*=)' +
	        '|' +
	        // Unquoted value that isn't an attribute name
	        // (since we didn't match the positive lookahead above)
	        '[^\"\'\\s]*' ) +
	      ')' ) +
	    ')?',
	    'i');
	
	  // false on IE<=8, true on most other browsers
	  var splitWillCapture = ('a,b'.split(/(,)/).length === 3);
	
	  // bitmask for tags with special parsing, like <script> and <textarea>
	  var EFLAGS_TEXT = html4.eflags['CDATA'] | html4.eflags['RCDATA'];
	
	  /**
	   * Given a SAX-like event handler, produce a function that feeds those
	   * events and a parameter to the event handler.
	   *
	   * The event handler has the form:{@code
	   * {
	   *   // Name is an upper-case HTML tag name.  Attribs is an array of
	   *   // alternating upper-case attribute names, and attribute values.  The
	   *   // attribs array is reused by the parser.  Param is the value passed to
	   *   // the saxParser.
	   *   startTag: function (name, attribs, param) { ... },
	   *   endTag:   function (name, param) { ... },
	   *   pcdata:   function (text, param) { ... },
	   *   rcdata:   function (text, param) { ... },
	   *   cdata:    function (text, param) { ... },
	   *   startDoc: function (param) { ... },
	   *   endDoc:   function (param) { ... }
	   * }}
	   *
	   * @param {Object} handler a record containing event handlers.
	   * @return {function(string, Object)} A function that takes a chunk of HTML
	   *     and a parameter.  The parameter is passed on to the handler methods.
	   */
	  function makeSaxParser(handler) {
	    // Accept quoted or unquoted keys (Closure compat)
	    var hcopy = {
	      cdata: handler.cdata || handler['cdata'],
	      comment: handler.comment || handler['comment'],
	      endDoc: handler.endDoc || handler['endDoc'],
	      endTag: handler.endTag || handler['endTag'],
	      pcdata: handler.pcdata || handler['pcdata'],
	      rcdata: handler.rcdata || handler['rcdata'],
	      startDoc: handler.startDoc || handler['startDoc'],
	      startTag: handler.startTag || handler['startTag']
	    };
	    return function(htmlText, param) {
	      return parse(htmlText, hcopy, param);
	    };
	  }
	
	  // Parsing strategy is to split input into parts that might be lexically
	  // meaningful (every ">" becomes a separate part), and then recombine
	  // parts if we discover they're in a different context.
	
	  // TODO(felix8a): Significant performance regressions from -legacy,
	  // tested on
	  //    Chrome 18.0
	  //    Firefox 11.0
	  //    IE 6, 7, 8, 9
	  //    Opera 11.61
	  //    Safari 5.1.3
	  // Many of these are unusual patterns that are linearly slower and still
	  // pretty fast (eg 1ms to 5ms), so not necessarily worth fixing.
	
	  // TODO(felix8a): "<script> && && && ... <\/script>" is slower on all
	  // browsers.  The hotspot is htmlSplit.
	
	  // TODO(felix8a): "<p title='>>>>...'><\/p>" is slower on all browsers.
	  // This is partly htmlSplit, but the hotspot is parseTagAndAttrs.
	
	  // TODO(felix8a): "<a><\/a><a><\/a>..." is slower on IE9.
	  // "<a>1<\/a><a>1<\/a>..." is faster, "<a><\/a>2<a><\/a>2..." is faster.
	
	  // TODO(felix8a): "<p<p<p..." is slower on IE[6-8]
	
	  var continuationMarker = {};
	  function parse(htmlText, handler, param) {
	    var m, p, tagName;
	    var parts = htmlSplit(htmlText);
	    var state = {
	      noMoreGT: false,
	      noMoreEndComments: false
	    };
	    parseCPS(handler, parts, 0, state, param);
	  }
	
	  function continuationMaker(h, parts, initial, state, param) {
	    return function () {
	      parseCPS(h, parts, initial, state, param);
	    };
	  }
	
	  function parseCPS(h, parts, initial, state, param) {
	    try {
	      if (h.startDoc && initial == 0) { h.startDoc(param); }
	      var m, p, tagName;
	      for (var pos = initial, end = parts.length; pos < end;) {
	        var current = parts[pos++];
	        var next = parts[pos];
	        switch (current) {
	        case '&':
	          if (ENTITY_RE_2.test(next)) {
	            if (h.pcdata) {
	              h.pcdata('&' + next, param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	            pos++;
	          } else {
	            if (h.pcdata) { h.pcdata("&amp;", param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          }
	          break;
	        case '<\/':
	          if (m = /^([-\w:]+)[^\'\"]*/.exec(next)) {
	            if (m[0].length === next.length && parts[pos + 1] === '>') {
	              // fast case, no attribute parsing needed
	              pos += 2;
	              tagName = m[1].toLowerCase();
	              if (h.endTag) {
	                h.endTag(tagName, param, continuationMarker,
	                  continuationMaker(h, parts, pos, state, param));
	              }
	            } else {
	              // slow case, need to parse attributes
	              // TODO(felix8a): do we really care about misparsing this?
	              pos = parseEndTag(
	                parts, pos, h, param, continuationMarker, state);
	            }
	          } else {
	            if (h.pcdata) {
	              h.pcdata('&lt;/', param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          }
	          break;
	        case '<':
	          if (m = /^([-\w:]+)\s*\/?/.exec(next)) {
	            if (m[0].length === next.length && parts[pos + 1] === '>') {
	              // fast case, no attribute parsing needed
	              pos += 2;
	              tagName = m[1].toLowerCase();
	              if (h.startTag) {
	                h.startTag(tagName, [], param, continuationMarker,
	                  continuationMaker(h, parts, pos, state, param));
	              }
	              // tags like <script> and <textarea> have special parsing
	              var eflags = html4.ELEMENTS[tagName];
	              if (eflags & EFLAGS_TEXT) {
	                var tag = { name: tagName, next: pos, eflags: eflags };
	                pos = parseText(
	                  parts, tag, h, param, continuationMarker, state);
	              }
	            } else {
	              // slow case, need to parse attributes
	              pos = parseStartTag(
	                parts, pos, h, param, continuationMarker, state);
	            }
	          } else {
	            if (h.pcdata) {
	              h.pcdata('&lt;', param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          }
	          break;
	        case '<\!--':
	          // The pathological case is n copies of '<\!--' without '-->', and
	          // repeated failure to find '-->' is quadratic.  We avoid that by
	          // remembering when search for '-->' fails.
	          if (!state.noMoreEndComments) {
	            // A comment <\!--x--> is split into three tokens:
	            //   '<\!--', 'x--', '>'
	            // We want to find the next '>' token that has a preceding '--'.
	            // pos is at the 'x--'.
	            for (p = pos + 1; p < end; p++) {
	              if (parts[p] === '>' && /--$/.test(parts[p - 1])) { break; }
	            }
	            if (p < end) {
	              if (h.comment) {
	                var comment = parts.slice(pos, p).join('');
	                h.comment(
	                  comment.substr(0, comment.length - 2), param,
	                  continuationMarker,
	                  continuationMaker(h, parts, p + 1, state, param));
	              }
	              pos = p + 1;
	            } else {
	              state.noMoreEndComments = true;
	            }
	          }
	          if (state.noMoreEndComments) {
	            if (h.pcdata) {
	              h.pcdata('&lt;!--', param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          }
	          break;
	        case '<\!':
	          if (!/^\w/.test(next)) {
	            if (h.pcdata) {
	              h.pcdata('&lt;!', param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          } else {
	            // similar to noMoreEndComment logic
	            if (!state.noMoreGT) {
	              for (p = pos + 1; p < end; p++) {
	                if (parts[p] === '>') { break; }
	              }
	              if (p < end) {
	                pos = p + 1;
	              } else {
	                state.noMoreGT = true;
	              }
	            }
	            if (state.noMoreGT) {
	              if (h.pcdata) {
	                h.pcdata('&lt;!', param, continuationMarker,
	                  continuationMaker(h, parts, pos, state, param));
	              }
	            }
	          }
	          break;
	        case '<?':
	          // similar to noMoreEndComment logic
	          if (!state.noMoreGT) {
	            for (p = pos + 1; p < end; p++) {
	              if (parts[p] === '>') { break; }
	            }
	            if (p < end) {
	              pos = p + 1;
	            } else {
	              state.noMoreGT = true;
	            }
	          }
	          if (state.noMoreGT) {
	            if (h.pcdata) {
	              h.pcdata('&lt;?', param, continuationMarker,
	                continuationMaker(h, parts, pos, state, param));
	            }
	          }
	          break;
	        case '>':
	          if (h.pcdata) {
	            h.pcdata("&gt;", param, continuationMarker,
	              continuationMaker(h, parts, pos, state, param));
	          }
	          break;
	        case '':
	          break;
	        default:
	          if (h.pcdata) {
	            h.pcdata(current, param, continuationMarker,
	              continuationMaker(h, parts, pos, state, param));
	          }
	          break;
	        }
	      }
	      if (h.endDoc) { h.endDoc(param); }
	    } catch (e) {
	      if (e !== continuationMarker) { throw e; }
	    }
	  }
	
	  // Split str into parts for the html parser.
	  function htmlSplit(str) {
	    // can't hoist this out of the function because of the re.exec loop.
	    var re = /(<\/|<\!--|<[!?]|[&<>])/g;
	    str += '';
	    if (splitWillCapture) {
	      return str.split(re);
	    } else {
	      var parts = [];
	      var lastPos = 0;
	      var m;
	      while ((m = re.exec(str)) !== null) {
	        parts.push(str.substring(lastPos, m.index));
	        parts.push(m[0]);
	        lastPos = m.index + m[0].length;
	      }
	      parts.push(str.substring(lastPos));
	      return parts;
	    }
	  }
	
	  function parseEndTag(parts, pos, h, param, continuationMarker, state) {
	    var tag = parseTagAndAttrs(parts, pos);
	    // drop unclosed tags
	    if (!tag) { return parts.length; }
	    if (h.endTag) {
	      h.endTag(tag.name, param, continuationMarker,
	        continuationMaker(h, parts, pos, state, param));
	    }
	    return tag.next;
	  }
	
	  function parseStartTag(parts, pos, h, param, continuationMarker, state) {
	    var tag = parseTagAndAttrs(parts, pos);
	    // drop unclosed tags
	    if (!tag) { return parts.length; }
	    if (h.startTag) {
	      h.startTag(tag.name, tag.attrs, param, continuationMarker,
	        continuationMaker(h, parts, tag.next, state, param));
	    }
	    // tags like <script> and <textarea> have special parsing
	    if (tag.eflags & EFLAGS_TEXT) {
	      return parseText(parts, tag, h, param, continuationMarker, state);
	    } else {
	      return tag.next;
	    }
	  }
	
	  var endTagRe = {};
	
	  // Tags like <script> and <textarea> are flagged as CDATA or RCDATA,
	  // which means everything is text until we see the correct closing tag.
	  function parseText(parts, tag, h, param, continuationMarker, state) {
	    var end = parts.length;
	    if (!endTagRe.hasOwnProperty(tag.name)) {
	      endTagRe[tag.name] = new RegExp('^' + tag.name + '(?:[\\s\\/]|$)', 'i');
	    }
	    var re = endTagRe[tag.name];
	    var first = tag.next;
	    var p = tag.next + 1;
	    for (; p < end; p++) {
	      if (parts[p - 1] === '<\/' && re.test(parts[p])) { break; }
	    }
	    if (p < end) { p -= 1; }
	    var buf = parts.slice(first, p).join('');
	    if (tag.eflags & html4.eflags['CDATA']) {
	      if (h.cdata) {
	        h.cdata(buf, param, continuationMarker,
	          continuationMaker(h, parts, p, state, param));
	      }
	    } else if (tag.eflags & html4.eflags['RCDATA']) {
	      if (h.rcdata) {
	        h.rcdata(normalizeRCData(buf), param, continuationMarker,
	          continuationMaker(h, parts, p, state, param));
	      }
	    } else {
	      throw new Error('bug');
	    }
	    return p;
	  }
	
	  // at this point, parts[pos-1] is either "<" or "<\/".
	  function parseTagAndAttrs(parts, pos) {
	    var m = /^([-\w:]+)/.exec(parts[pos]);
	    var tag = {};
	    tag.name = m[1].toLowerCase();
	    tag.eflags = html4.ELEMENTS[tag.name];
	    var buf = parts[pos].substr(m[0].length);
	    // Find the next '>'.  We optimistically assume this '>' is not in a
	    // quoted context, and further down we fix things up if it turns out to
	    // be quoted.
	    var p = pos + 1;
	    var end = parts.length;
	    for (; p < end; p++) {
	      if (parts[p] === '>') { break; }
	      buf += parts[p];
	    }
	    if (end <= p) { return void 0; }
	    var attrs = [];
	    while (buf !== '') {
	      m = ATTR_RE.exec(buf);
	      if (!m) {
	        // No attribute found: skip garbage
	        buf = buf.replace(/^[\s\S][^a-z\s]*/, '');
	
	      } else if ((m[4] && !m[5]) || (m[6] && !m[7])) {
	        // Unterminated quote: slurp to the next unquoted '>'
	        var quote = m[4] || m[6];
	        var sawQuote = false;
	        var abuf = [buf, parts[p++]];
	        for (; p < end; p++) {
	          if (sawQuote) {
	            if (parts[p] === '>') { break; }
	          } else if (0 <= parts[p].indexOf(quote)) {
	            sawQuote = true;
	          }
	          abuf.push(parts[p]);
	        }
	        // Slurp failed: lose the garbage
	        if (end <= p) { break; }
	        // Otherwise retry attribute parsing
	        buf = abuf.join('');
	        continue;
	
	      } else {
	        // We have an attribute
	        var aName = m[1].toLowerCase();
	        var aValue = m[2] ? decodeValue(m[3]) : '';
	        attrs.push(aName, aValue);
	        buf = buf.substr(m[0].length);
	      }
	    }
	    tag.attrs = attrs;
	    tag.next = p + 1;
	    return tag;
	  }
	
	  function decodeValue(v) {
	    var q = v.charCodeAt(0);
	    if (q === 0x22 || q === 0x27) { // " or '
	      v = v.substr(1, v.length - 2);
	    }
	    return unescapeEntities(stripNULs(v));
	  }
	
	  /**
	   * Returns a function that strips unsafe tags and attributes from html.
	   * @param {function(string, Array.<string>): ?Array.<string>} tagPolicy
	   *     A function that takes (tagName, attribs[]), where tagName is a key in
	   *     html4.ELEMENTS and attribs is an array of alternating attribute names
	   *     and values.  It should return a record (as follows), or null to delete
	   *     the element.  It's okay for tagPolicy to modify the attribs array,
	   *     but the same array is reused, so it should not be held between calls.
	   *     Record keys:
	   *        attribs: (required) Sanitized attributes array.
	   *        tagName: Replacement tag name.
	   * @return {function(string, Array)} A function that sanitizes a string of
	   *     HTML and appends result strings to the second argument, an array.
	   */
	  function makeHtmlSanitizer(tagPolicy) {
	    var stack;
	    var ignoring;
	    var emit = function (text, out) {
	      if (!ignoring) { out.push(text); }
	    };
	    return makeSaxParser({
	      'startDoc': function(_) {
	        stack = [];
	        ignoring = false;
	      },
	      'startTag': function(tagNameOrig, attribs, out) {
	        if (ignoring) { return; }
	        if (!html4.ELEMENTS.hasOwnProperty(tagNameOrig)) { return; }
	        var eflagsOrig = html4.ELEMENTS[tagNameOrig];
	        if (eflagsOrig & html4.eflags['FOLDABLE']) {
	          return;
	        }
	
	        var decision = tagPolicy(tagNameOrig, attribs);
	        if (!decision) {
	          ignoring = !(eflagsOrig & html4.eflags['EMPTY']);
	          return;
	        } else if (typeof decision !== 'object') {
	          throw new Error('tagPolicy did not return object (old API?)');
	        }
	        if ('attribs' in decision) {
	          attribs = decision['attribs'];
	        } else {
	          throw new Error('tagPolicy gave no attribs');
	        }
	        var eflagsRep;
	        var tagNameRep;
	        if ('tagName' in decision) {
	          tagNameRep = decision['tagName'];
	          eflagsRep = html4.ELEMENTS[tagNameRep];
	        } else {
	          tagNameRep = tagNameOrig;
	          eflagsRep = eflagsOrig;
	        }
	        // TODO(mikesamuel): relying on tagPolicy not to insert unsafe
	        // attribute names.
	
	        // If this is an optional-end-tag element and either this element or its
	        // previous like sibling was rewritten, then insert a close tag to
	        // preserve structure.
	        if (eflagsOrig & html4.eflags['OPTIONAL_ENDTAG']) {
	          var onStack = stack[stack.length - 1];
	          if (onStack && onStack.orig === tagNameOrig &&
	              (onStack.rep !== tagNameRep || tagNameOrig !== tagNameRep)) {
	                out.push('<\/', onStack.rep, '>');
	          }
	        }
	
	        if (!(eflagsOrig & html4.eflags['EMPTY'])) {
	          stack.push({orig: tagNameOrig, rep: tagNameRep});
	        }
	
	        out.push('<', tagNameRep);
	        for (var i = 0, n = attribs.length; i < n; i += 2) {
	          var attribName = attribs[i],
	              value = attribs[i + 1];
	          if (value !== null && value !== void 0) {
	            out.push(' ', attribName, '="', escapeAttrib(value), '"');
	          }
	        }
	        out.push('>');
	
	        if ((eflagsOrig & html4.eflags['EMPTY'])
	            && !(eflagsRep & html4.eflags['EMPTY'])) {
	          // replacement is non-empty, synthesize end tag
	          out.push('<\/', tagNameRep, '>');
	        }
	      },
	      'endTag': function(tagName, out) {
	        if (ignoring) {
	          ignoring = false;
	          return;
	        }
	        if (!html4.ELEMENTS.hasOwnProperty(tagName)) { return; }
	        var eflags = html4.ELEMENTS[tagName];
	        if (!(eflags & (html4.eflags['EMPTY'] | html4.eflags['FOLDABLE']))) {
	          var index;
	          if (eflags & html4.eflags['OPTIONAL_ENDTAG']) {
	            for (index = stack.length; --index >= 0;) {
	              var stackElOrigTag = stack[index].orig;
	              if (stackElOrigTag === tagName) { break; }
	              if (!(html4.ELEMENTS[stackElOrigTag] &
	                    html4.eflags['OPTIONAL_ENDTAG'])) {
	                // Don't pop non optional end tags looking for a match.
	                return;
	              }
	            }
	          } else {
	            for (index = stack.length; --index >= 0;) {
	              if (stack[index].orig === tagName) { break; }
	            }
	          }
	          if (index < 0) { return; }  // Not opened.
	          for (var i = stack.length; --i > index;) {
	            var stackElRepTag = stack[i].rep;
	            if (!(html4.ELEMENTS[stackElRepTag] &
	                  html4.eflags['OPTIONAL_ENDTAG'])) {
	              out.push('<\/', stackElRepTag, '>');
	            }
	          }
	          if (index < stack.length) {
	            tagName = stack[index].rep;
	          }
	          stack.length = index;
	          out.push('<\/', tagName, '>');
	        }
	      },
	      'pcdata': emit,
	      'rcdata': emit,
	      'cdata': emit,
	      'endDoc': function(out) {
	        for (; stack.length; stack.length--) {
	          out.push('<\/', stack[stack.length - 1].rep, '>');
	        }
	      }
	    });
	  }
	
	  var ALLOWED_URI_SCHEMES = /^(?:https?|mailto|data)$/i;
	
	  function safeUri(uri, effect, ltype, hints, naiveUriRewriter) {
	    if (!naiveUriRewriter) { return null; }
	    try {
	      var parsed = URI.parse('' + uri);
	      if (parsed) {
	        if (!parsed.hasScheme() ||
	            ALLOWED_URI_SCHEMES.test(parsed.getScheme())) {
	          var safe = naiveUriRewriter(parsed, effect, ltype, hints);
	          return safe ? safe.toString() : null;
	        }
	      }
	    } catch (e) {
	      return null;
	    }
	    return null;
	  }
	
	  function log(logger, tagName, attribName, oldValue, newValue) {
	    if (!attribName) {
	      logger(tagName + " removed", {
	        change: "removed",
	        tagName: tagName
	      });
	    }
	    if (oldValue !== newValue) {
	      var changed = "changed";
	      if (oldValue && !newValue) {
	        changed = "removed";
	      } else if (!oldValue && newValue)  {
	        changed = "added";
	      }
	      logger(tagName + "." + attribName + " " + changed, {
	        change: changed,
	        tagName: tagName,
	        attribName: attribName,
	        oldValue: oldValue,
	        newValue: newValue
	      });
	    }
	  }
	
	  function lookupAttribute(map, tagName, attribName) {
	    var attribKey;
	    attribKey = tagName + '::' + attribName;
	    if (map.hasOwnProperty(attribKey)) {
	      return map[attribKey];
	    }
	    attribKey = '*::' + attribName;
	    if (map.hasOwnProperty(attribKey)) {
	      return map[attribKey];
	    }
	    return void 0;
	  }
	  function getAttributeType(tagName, attribName) {
	    return lookupAttribute(html4.ATTRIBS, tagName, attribName);
	  }
	  function getLoaderType(tagName, attribName) {
	    return lookupAttribute(html4.LOADERTYPES, tagName, attribName);
	  }
	  function getUriEffect(tagName, attribName) {
	    return lookupAttribute(html4.URIEFFECTS, tagName, attribName);
	  }
	
	  /**
	   * Sanitizes attributes on an HTML tag.
	   * @param {string} tagName An HTML tag name in lowercase.
	   * @param {Array.<?string>} attribs An array of alternating names and values.
	   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
	   *     apply to URI attributes; it can return a new string value, or null to
	   *     delete the attribute.  If unspecified, URI attributes are deleted.
	   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
	   *     to attributes containing HTML names, element IDs, and space-separated
	   *     lists of classes; it can return a new string value, or null to delete
	   *     the attribute.  If unspecified, these attributes are kept unchanged.
	   * @return {Array.<?string>} The sanitized attributes as a list of alternating
	   *     names and values, where a null value means to omit the attribute.
	   */
	  function sanitizeAttribs(tagName, attribs,
	    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
	    // TODO(felix8a): it's obnoxious that domado duplicates much of this
	    // TODO(felix8a): maybe consistently enforce constraints like target=
	    for (var i = 0; i < attribs.length; i += 2) {
	      var attribName = attribs[i];
	      var value = attribs[i + 1];
	      var oldValue = value;
	      var atype = null, attribKey;
	      if ((attribKey = tagName + '::' + attribName,
	           html4.ATTRIBS.hasOwnProperty(attribKey)) ||
	          (attribKey = '*::' + attribName,
	           html4.ATTRIBS.hasOwnProperty(attribKey))) {
	        atype = html4.ATTRIBS[attribKey];
	      }
	      if (atype !== null) {
	        switch (atype) {
	          case html4.atype['NONE']: break;
	          case html4.atype['SCRIPT']:
	            value = null;
	            if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	          case html4.atype['STYLE']:
	            if ('undefined' === typeof parseCssDeclarations) {
	              value = null;
	              if (opt_logger) {
	                log(opt_logger, tagName, attribName, oldValue, value);
		      }
	              break;
	            }
	            var sanitizedDeclarations = [];
	            parseCssDeclarations(
	                value,
	                {
	                  declaration: function (property, tokens) {
	                    var normProp = property.toLowerCase();
	                    var schema = cssSchema[normProp];
	                    if (!schema) {
	                      return;
	                    }
	                    sanitizeCssProperty(
	                        normProp, schema, tokens,
	                        opt_naiveUriRewriter
	                        ? function (url) {
	                            return safeUri(
	                                url, html4.ueffects.SAME_DOCUMENT,
	                                html4.ltypes.SANDBOXED,
	                                {
	                                  "TYPE": "CSS",
	                                  "CSS_PROP": normProp
	                                }, opt_naiveUriRewriter);
	                          }
	                        : null);
	                    sanitizedDeclarations.push(property + ': ' + tokens.join(' '));
	                  }
	                });
	            value = sanitizedDeclarations.length > 0 ?
	              sanitizedDeclarations.join(' ; ') : null;
	            if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	          case html4.atype['ID']:
	          case html4.atype['IDREF']:
	          case html4.atype['IDREFS']:
	          case html4.atype['GLOBAL_NAME']:
	          case html4.atype['LOCAL_NAME']:
	          case html4.atype['CLASSES']:
	            value = opt_nmTokenPolicy ? opt_nmTokenPolicy(value) : value;
	            if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	          case html4.atype['URI']:
	            value = safeUri(value,
	              getUriEffect(tagName, attribName),
	              getLoaderType(tagName, attribName),
	              {
	                "TYPE": "MARKUP",
	                "XML_ATTR": attribName,
	                "XML_TAG": tagName
	              }, opt_naiveUriRewriter);
	              if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	          case html4.atype['URI_FRAGMENT']:
	            if (value && '#' === value.charAt(0)) {
	              value = value.substring(1);  // remove the leading '#'
	              value = opt_nmTokenPolicy ? opt_nmTokenPolicy(value) : value;
	              if (value !== null && value !== void 0) {
	                value = '#' + value;  // restore the leading '#'
	              }
	            } else {
	              value = null;
	            }
	            if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	          default:
	            value = null;
	            if (opt_logger) {
	              log(opt_logger, tagName, attribName, oldValue, value);
	            }
	            break;
	        }
	      } else {
	        value = null;
	        if (opt_logger) {
	          log(opt_logger, tagName, attribName, oldValue, value);
	        }
	      }
	      attribs[i + 1] = value;
	    }
	    return attribs;
	  }
	
	  /**
	   * Creates a tag policy that omits all tags marked UNSAFE in html4-defs.js
	   * and applies the default attribute sanitizer with the supplied policy for
	   * URI attributes and NMTOKEN attributes.
	   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
	   *     apply to URI attributes.  If not given, URI attributes are deleted.
	   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
	   *     to attributes containing HTML names, element IDs, and space-separated
	   *     lists of classes.  If not given, such attributes are left unchanged.
	   * @return {function(string, Array.<?string>)} A tagPolicy suitable for
	   *     passing to html.sanitize.
	   */
	  function makeTagPolicy(
	    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
	    return function(tagName, attribs) {
	      if (!(html4.ELEMENTS[tagName] & html4.eflags['UNSAFE'])) {
	        return {
	          'attribs': sanitizeAttribs(tagName, attribs,
	            opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger)
	        };
	      } else {
	        if (opt_logger) {
	          log(opt_logger, tagName, undefined, undefined, undefined);
	        }
	      }
	    };
	  }
	
	  /**
	   * Sanitizes HTML tags and attributes according to a given policy.
	   * @param {string} inputHtml The HTML to sanitize.
	   * @param {function(string, Array.<?string>)} tagPolicy A function that
	   *     decides which tags to accept and sanitizes their attributes (see
	   *     makeHtmlSanitizer above for details).
	   * @return {string} The sanitized HTML.
	   */
	  function sanitizeWithPolicy(inputHtml, tagPolicy) {
	    var outputArray = [];
	    makeHtmlSanitizer(tagPolicy)(inputHtml, outputArray);
	    return outputArray.join('');
	  }
	
	  /**
	   * Strips unsafe tags and attributes from HTML.
	   * @param {string} inputHtml The HTML to sanitize.
	   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
	   *     apply to URI attributes.  If not given, URI attributes are deleted.
	   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
	   *     to attributes containing HTML names, element IDs, and space-separated
	   *     lists of classes.  If not given, such attributes are left unchanged.
	   */
	  function sanitize(inputHtml,
	    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
	    var tagPolicy = makeTagPolicy(
	      opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger);
	    return sanitizeWithPolicy(inputHtml, tagPolicy);
	  }
	
	  // Export both quoted and unquoted names for Closure linkage.
	  var html = {};
	  html.escapeAttrib = html['escapeAttrib'] = escapeAttrib;
	  html.makeHtmlSanitizer = html['makeHtmlSanitizer'] = makeHtmlSanitizer;
	  html.makeSaxParser = html['makeSaxParser'] = makeSaxParser;
	  html.makeTagPolicy = html['makeTagPolicy'] = makeTagPolicy;
	  html.normalizeRCData = html['normalizeRCData'] = normalizeRCData;
	  html.sanitize = html['sanitize'] = sanitize;
	  html.sanitizeAttribs = html['sanitizeAttribs'] = sanitizeAttribs;
	  html.sanitizeWithPolicy = html['sanitizeWithPolicy'] = sanitizeWithPolicy;
	  html.unescapeEntities = html['unescapeEntities'] = unescapeEntities;
	  return html;
	})(html4);
	
	var html_sanitize = html['sanitize'];
	
	// Loosen restrictions of Caja's
	// html-sanitizer to allow for styling
	html4.ATTRIBS['*::style'] = 0;
	html4.ELEMENTS['style'] = 0;
	html4.ATTRIBS['a::target'] = 0;
	html4.ELEMENTS['video'] = 0;
	html4.ATTRIBS['video::src'] = 0;
	html4.ATTRIBS['video::poster'] = 0;
	html4.ATTRIBS['video::controls'] = 0;
	html4.ELEMENTS['audio'] = 0;
	html4.ATTRIBS['audio::src'] = 0;
	html4.ATTRIBS['video::autoplay'] = 0;
	html4.ATTRIBS['video::controls'] = 0;
	
	if (true) {
	    module.exports = html_sanitize;
	}
	


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var util = __webpack_require__(589),
	    format_url = __webpack_require__(590),
	    request = __webpack_require__(594),
	    marker = __webpack_require__(601),
	    simplestyle = __webpack_require__(602);
	
	// # featureLayer
	//
	// A layer of features, loaded from Mapbox or else. Adds the ability
	// to reset features, filter them, and load them from a GeoJSON URL.
	var FeatureLayer = L.FeatureGroup.extend({
	    options: {
	        filter: function() { return true; },
	        sanitizer: __webpack_require__(598),
	        style: simplestyle.style,
	        popupOptions: { closeButton: false }
	    },
	
	    initialize: function(_, options) {
	        L.setOptions(this, options);
	
	        this._layers = {};
	
	        if (typeof _ === 'string') {
	            util.idUrl(_, this);
	        // javascript object of TileJSON data
	        } else if (_ && typeof _ === 'object') {
	            this.setGeoJSON(_);
	        }
	    },
	
	    setGeoJSON: function(_) {
	        this._geojson = _;
	        this.clearLayers();
	        this._initialize(_);
	        return this;
	    },
	
	    getGeoJSON: function() {
	        return this._geojson;
	    },
	
	    loadURL: function(url) {
	        if (this._request && 'abort' in this._request) this._request.abort();
	        this._request = request(url, L.bind(function(err, json) {
	            this._request = null;
	            if (err && err.type !== 'abort') {
	                util.log('could not load features at ' + url);
	                this.fire('error', {error: err});
	            } else if (json) {
	                this.setGeoJSON(json);
	                this.fire('ready');
	            }
	        }, this));
	        return this;
	    },
	
	    loadID: function(id) {
	        return this.loadURL(format_url('/v4/' + id + '/features.json', this.options.accessToken));
	    },
	
	    setFilter: function(_) {
	        this.options.filter = _;
	        if (this._geojson) {
	            this.clearLayers();
	            this._initialize(this._geojson);
	        }
	        return this;
	    },
	
	    getFilter: function() {
	        return this.options.filter;
	    },
	
	    _initialize: function(json) {
	        var features = L.Util.isArray(json) ? json : json.features,
	            i, len;
	
	        if (features) {
	            for (i = 0, len = features.length; i < len; i++) {
	                // Only add this if geometry or geometries are set and not null
	                if (features[i].geometries || features[i].geometry || features[i].features) {
	                    this._initialize(features[i]);
	                }
	            }
	        } else if (this.options.filter(json)) {
	
	            var opts = {accessToken: this.options.accessToken},
	                pointToLayer = this.options.pointToLayer || function(feature, latlon) {
	                  return marker.style(feature, latlon, opts);
	                },
	                layer = L.GeoJSON.geometryToLayer(json, pointToLayer),
	                popupHtml = marker.createPopup(json, this.options.sanitizer),
	                style = this.options.style,
	                defaultStyle = style === simplestyle.style;
	
	            if (style && 'setStyle' in layer &&
	                // if the style method is the simplestyle default, then
	                // never style L.Circle or L.CircleMarker because
	                // simplestyle has no rules over them, only over geometry
	                // primitives directly from GeoJSON
	                (!(defaultStyle && (layer instanceof L.Circle ||
	                  layer instanceof L.CircleMarker)))) {
	                if (typeof style === 'function') {
	                    style = style(json);
	                }
	                layer.setStyle(style);
	            }
	
	            layer.feature = json;
	
	            if (popupHtml) {
	                layer.bindPopup(popupHtml, this.options.popupOptions);
	            }
	
	            this.addLayer(layer);
	        }
	    }
	});
	
	module.exports.FeatureLayer = FeatureLayer;
	
	module.exports.featureLayer = function(_, options) {
	    return new FeatureLayer(_, options);
	};
	


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var format_url = __webpack_require__(590),
	    util = __webpack_require__(589),
	    sanitize = __webpack_require__(598);
	
	// mapbox-related markers functionality
	// provide an icon from mapbox's simple-style spec and hosted markers
	// service
	function icon(fp, options) {
	    fp = fp || {};
	
	    var sizes = {
	            small: [20, 50],
	            medium: [30, 70],
	            large: [35, 90]
	        },
	        size = fp['marker-size'] || 'medium',
	        symbol = ('marker-symbol' in fp && fp['marker-symbol'] !== '') ? '-' + fp['marker-symbol'] : '',
	        color = (fp['marker-color'] || '7e7e7e').replace('#', '');
	
	    return L.icon({
	        iconUrl: format_url('/v4/marker/' +
	            'pin-' + size.charAt(0) + symbol + '+' + color +
	            // detect and use retina markers, which are x2 resolution
	            (L.Browser.retina ? '@2x' : '') + '.png', options && options.accessToken),
	        iconSize: sizes[size],
	        iconAnchor: [sizes[size][0] / 2, sizes[size][1] / 2],
	        popupAnchor: [0, -sizes[size][1] / 2]
	    });
	}
	
	// a factory that provides markers for Leaflet from Mapbox's
	// [simple-style specification](https://github.com/mapbox/simplestyle-spec)
	// and [Markers API](http://mapbox.com/developers/api/#markers).
	function style(f, latlon, options) {
	    return L.marker(latlon, {
	        icon: icon(f.properties, options),
	        title: util.strip_tags(
	            sanitize((f.properties && f.properties.title) || ''))
	    });
	}
	
	// Sanitize and format properties of a GeoJSON Feature object in order
	// to form the HTML string used as the argument for `L.createPopup`
	function createPopup(f, sanitizer) {
	    if (!f || !f.properties) return '';
	    var popup = '';
	
	    if (f.properties.title) {
	        popup += '<div class="marker-title">' + f.properties.title + '</div>';
	    }
	
	    if (f.properties.description) {
	        popup += '<div class="marker-description">' + f.properties.description + '</div>';
	    }
	
	    return (sanitizer || sanitize)(popup);
	}
	
	module.exports = {
	    icon: icon,
	    style: style,
	    createPopup: createPopup
	};
	


/***/ }),
/* 602 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	// an implementation of the simplestyle spec for polygon and linestring features
	// https://github.com/mapbox/simplestyle-spec
	var defaults = {
	    stroke: '#555555',
	    'stroke-width': 2,
	    'stroke-opacity': 1,
	    fill: '#555555',
	    'fill-opacity': 0.5
	};
	
	var mapping = [
	    ['stroke', 'color'],
	    ['stroke-width', 'weight'],
	    ['stroke-opacity', 'opacity'],
	    ['fill', 'fillColor'],
	    ['fill-opacity', 'fillOpacity']
	];
	
	function fallback(a, b) {
	    var c = {};
	    for (var k in b) {
	        if (a[k] === undefined) c[k] = b[k];
	        else c[k] = a[k];
	    }
	    return c;
	}
	
	function remap(a) {
	    var d = {};
	    for (var i = 0; i < mapping.length; i++) {
	        d[mapping[i][1]] = a[mapping[i][0]];
	    }
	    return d;
	}
	
	function style(feature) {
	    return remap(fallback(feature.properties || {}, defaults));
	}
	
	module.exports = {
	    style: style,
	    defaults: defaults
	};
	


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var LegendControl = L.Control.extend({
	
	    options: {
	        position: 'bottomright',
	        sanitizer: __webpack_require__(598)
	    },
	
	    initialize: function(options) {
	        L.setOptions(this, options);
	        this._legends = {};
	    },
	
	    onAdd: function() {
	        this._container = L.DomUtil.create('div', 'map-legends wax-legends');
	        L.DomEvent.disableClickPropagation(this._container);
	
	        this._update();
	
	        return this._container;
	    },
	
	    addLegend: function(text) {
	        if (!text) { return this; }
	
	        if (!this._legends[text]) {
	            this._legends[text] = 0;
	        }
	
	        this._legends[text]++;
	        return this._update();
	    },
	
	    removeLegend: function(text) {
	        if (!text) { return this; }
	        if (this._legends[text]) this._legends[text]--;
	        return this._update();
	    },
	
	    _update: function() {
	        if (!this._map) { return this; }
	
	        this._container.innerHTML = '';
	        var hide = 'none';
	
	        for (var i in this._legends) {
	            if (this._legends.hasOwnProperty(i) && this._legends[i]) {
	                var div = L.DomUtil.create('div', 'map-legend wax-legend', this._container);
	                div.innerHTML = this.options.sanitizer(i);
	                hide = 'block';
	            }
	        }
	
	        // hide the control entirely unless there is at least one legend;
	        // otherwise there will be a small grey blemish on the map.
	        this._container.style.display = hide;
	
	        return this;
	    }
	});
	
	module.exports.LegendControl = LegendControl;
	
	module.exports.legendControl = function(options) {
	    return new LegendControl(options);
	};
	


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var format_url = __webpack_require__(590);
	
	var ShareControl = L.Control.extend({
	    includes: [__webpack_require__(605)],
	
	    options: {
	        position: 'topleft',
	        url: ''
	    },
	
	    initialize: function(_, options) {
	        L.setOptions(this, options);
	        this._loadTileJSON(_);
	    },
	
	    _setTileJSON: function(json) {
	        this._tilejson = json;
	    },
	
	    onAdd: function(map) {
	        this._map = map;
	
	        var container = L.DomUtil.create('div', 'leaflet-control-mapbox-share leaflet-bar');
	        var link = L.DomUtil.create('a', 'mapbox-share mapbox-icon mapbox-icon-share', container);
	        link.href = '#';
	
	        this._modal = L.DomUtil.create('div', 'mapbox-modal', this._map._container);
	        this._mask = L.DomUtil.create('div', 'mapbox-modal-mask', this._modal);
	        this._content = L.DomUtil.create('div', 'mapbox-modal-content', this._modal);
	
	        L.DomEvent.addListener(link, 'click', this._shareClick, this);
	        L.DomEvent.disableClickPropagation(container);
	
	        this._map.on('mousedown', this._clickOut, this);
	
	        return container;
	    },
	
	    _clickOut: function(e) {
	        if (this._sharing) {
	            L.DomEvent.preventDefault(e);
	            L.DomUtil.removeClass(this._modal, 'active');
	            this._content.innerHTML = '';
	            this._sharing = null;
	            return;
	        }
	    },
	
	    _shareClick: function(e) {
	        L.DomEvent.stop(e);
	        if (this._sharing) return this._clickOut(e);
	
	        var tilejson = this._tilejson || this._map._tilejson || {},
	            url = encodeURIComponent(this.options.url || tilejson.webpage || window.location),
	            name = encodeURIComponent(tilejson.name),
	            image = format_url('/v4/' + tilejson.id + '/' + this._map.getCenter().lng + ',' + this._map.getCenter().lat + ',' + this._map.getZoom() + '/600x600.png', this.options.accessToken),
	            embed = format_url('/v4/' + tilejson.id + '.html', this.options.accessToken),
	            twitterURL = '//twitter.com/intent/tweet?status=' + name + ' ' + url,
	            facebookURL = '//www.facebook.com/sharer.php?u=' + url + '&t=' + name,
	            pinterestURL = '//www.pinterest.com/pin/create/button/?url=' + url + '&media=' + image + '&description=' + name,
	            embedValue = '<iframe width="100%" height="500px" frameBorder="0" src="' + embed + '"></iframe>',
	            embedLabel = 'Copy and paste this <strong>HTML code</strong> into documents to embed this map on web pages.';
	
	        function createShareButton(buttonClass, href, socialMediaName) {
	            var elem = document.createElement('a');
	            elem.setAttribute('class', buttonClass);
	            elem.setAttribute('href', href);
	            elem.setAttribute('target', '_blank');
	            socialMediaName = document.createTextNode(socialMediaName);
	            elem.appendChild(socialMediaName);
	
	            return elem;
	        }
	
	        L.DomUtil.addClass(this._modal, 'active');
	
	        this._sharing = L.DomUtil.create('div', 'mapbox-modal-body', this._content);
	
	        var twitterButton = createShareButton('mapbox-button mapbox-button-icon mapbox-icon-twitter', twitterURL, 'Twitter');
	        var facebookButton = createShareButton('mapbox-button mapbox-button-icon mapbox-icon-facebook', facebookURL, 'Facebook');
	        var pinterestButton = createShareButton('mapbox-button mapbox-button-icon mapbox-icon-pinterest', pinterestURL, 'Pinterest');
	
	        var shareHeader = document.createElement('h3');
	        var shareText = document.createTextNode('Share this map');
	        shareHeader.appendChild(shareText);
	
	        var shareButtons = document.createElement('div');
	        shareButtons.setAttribute('class', 'mapbox-share-buttons');
	        shareButtons.appendChild(facebookButton);
	        shareButtons.appendChild(twitterButton);
	        shareButtons.appendChild(pinterestButton);
	
	        this._sharing.appendChild(shareHeader);
	        this._sharing.appendChild(shareButtons);
	
	        var input = L.DomUtil.create('input', 'mapbox-embed', this._sharing);
	        input.type = 'text';
	        input.value = embedValue;
	
	        var label = L.DomUtil.create('label', 'mapbox-embed-description', this._sharing);
	        label.innerHTML = embedLabel;
	
	        var close = L.DomUtil.create('a', 'leaflet-popup-close-button', this._sharing);
	        close.href = '#';
	
	        L.DomEvent.disableClickPropagation(this._sharing);
	        L.DomEvent.addListener(close, 'click', this._clickOut, this);
	        L.DomEvent.addListener(input, 'click', function(e) {
	            e.target.focus();
	            e.target.select();
	        });
	    }
	});
	
	module.exports.ShareControl = ShareControl;
	
	module.exports.shareControl = function(_, options) {
	    return new ShareControl(_, options);
	};
	


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var request = __webpack_require__(594),
	    format_url = __webpack_require__(590),
	    util = __webpack_require__(589);
	
	module.exports = {
	    _loadTileJSON: function(_) {
	        if (typeof _ === 'string') {
	            _ = format_url.tileJSON(_, this.options && this.options.accessToken);
	            request(_, L.bind(function(err, json) {
	                if (err) {
	                    util.log('could not load TileJSON at ' + _);
	                    this.fire('error', {error: err});
	                } else if (json) {
	                    this._setTileJSON(json);
	                    this.fire('ready');
	                }
	            }, this));
	        } else if (_ && typeof _ === 'object') {
	            this._setTileJSON(_);
	        }
	    }
	};
	


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var util = __webpack_require__(589);
	var formatPattern = /\.((?:png|jpg)\d*)(?=$|\?)/;
	
	var TileLayer = L.TileLayer.extend({
	    includes: [__webpack_require__(605)],
	
	    options: {
	        sanitizer: __webpack_require__(598)
	    },
	
	    // http://mapbox.com/developers/api/#image_quality
	    formats: [
	        'png', 'jpg',
	        // PNG
	        'png32', 'png64', 'png128', 'png256',
	        // JPG
	        'jpg70', 'jpg80', 'jpg90'],
	
	    scalePrefix: '@2x.',
	
	    initialize: function(_, options) {
	        L.TileLayer.prototype.initialize.call(this, undefined, options);
	
	        this._tilejson = {};
	
	        if (options && options.format) {
	            util.strict_oneof(options.format, this.formats);
	        }
	
	        this._loadTileJSON(_);
	    },
	
	    setFormat: function(_) {
	        util.strict(_, 'string');
	        this.options.format = _;
	        this.redraw();
	        return this;
	    },
	
	    // disable the setUrl function, which is not available on mapbox tilelayers
	    setUrl: null,
	
	    _setTileJSON: function(json) {
	        util.strict(json, 'object');
	
	        this.options.format = this.options.format ||
	            json.tiles[0].match(formatPattern)[1];
	
	        L.extend(this.options, {
	            tiles: json.tiles,
	            attribution: this.options.sanitizer(json.attribution),
	            minZoom: json.minzoom || 0,
	            maxZoom: json.maxzoom || 18,
	            tms: json.scheme === 'tms',
	            bounds: json.bounds && util.lbounds(json.bounds)
	        });
	
	        this._tilejson = json;
	        this.redraw();
	        return this;
	    },
	
	    getTileJSON: function() {
	        return this._tilejson;
	    },
	
	    // this is an exception to mapbox.js naming rules because it's called
	    // by `L.map`
	    getTileUrl: function(tilePoint) {
	        var tiles = this.options.tiles,
	            index = Math.floor(Math.abs(tilePoint.x + tilePoint.y) % tiles.length),
	            url = tiles[index];
	
	        var templated = L.Util.template(url, tilePoint);
	        if (!templated) {
	            return templated;
	        } else {
	            return templated.replace(formatPattern,
	                (L.Browser.retina ? this.scalePrefix : '.') + this.options.format);
	        }
	    },
	
	    // TileJSON.TileLayers are added to the map immediately, so that they get
	    // the desired z-index, but do not update until the TileJSON has been loaded.
	    _update: function() {
	        if (this.options.tiles) {
	            L.TileLayer.prototype._update.call(this);
	        }
	    }
	});
	
	module.exports.TileLayer = TileLayer;
	
	module.exports.tileLayer = function(_, options) {
	    return new TileLayer(_, options);
	};
	


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var InfoControl = L.Control.extend({
	    options: {
	        position: 'bottomright',
	        sanitizer: __webpack_require__(598)
	    },
	
	    initialize: function(options) {
	        L.setOptions(this, options);
	        this._info = {};
	        console.warn('infoControl has been deprecated and will be removed in mapbox.js v3.0.0. Use the default attribution control instead, which is now responsive.');
	    },
	
	    onAdd: function(map) {
	        this._container = L.DomUtil.create('div', 'mapbox-control-info mapbox-small');
	        this._content = L.DomUtil.create('div', 'map-info-container', this._container);
	
	        var link = L.DomUtil.create('a', 'mapbox-info-toggle mapbox-icon mapbox-icon-info', this._container);
	        link.href = '#';
	
	        L.DomEvent.addListener(link, 'click', this._showInfo, this);
	        L.DomEvent.disableClickPropagation(this._container);
	
	        for (var i in map._layers) {
	            if (map._layers[i].getAttribution) {
	                this.addInfo(map._layers[i].getAttribution());
	            }
	        }
	
	        map
	            .on('layeradd', this._onLayerAdd, this)
	            .on('layerremove', this._onLayerRemove, this);
	
	        this._update();
	        return this._container;
	    },
	
	    onRemove: function(map) {
	        map
	            .off('layeradd', this._onLayerAdd, this)
	            .off('layerremove', this._onLayerRemove, this);
	    },
	
	    addInfo: function(text) {
	        if (!text) return this;
	        if (!this._info[text]) this._info[text] = 0;
	        this._info[text] = true;
	        return this._update();
	    },
	
	    removeInfo: function (text) {
	        if (!text) return this;
	        if (this._info[text]) this._info[text] = false;
	        return this._update();
	    },
	
	    _showInfo: function(e) {
	        L.DomEvent.preventDefault(e);
	        if (this._active === true) return this._hidecontent();
	
	        L.DomUtil.addClass(this._container, 'active');
	        this._active = true;
	        this._update();
	    },
	
	    _hidecontent: function() {
	        this._content.innerHTML = '';
	        this._active = false;
	        L.DomUtil.removeClass(this._container, 'active');
	        return;
	    },
	
	    _update: function() {
	        if (!this._map) { return this; }
	        this._content.innerHTML = '';
	        var hide = 'none';
	        var info = [];
	
	        for (var i in this._info) {
	            if (this._info.hasOwnProperty(i) && this._info[i]) {
	                info.push(this.options.sanitizer(i));
	                hide = 'block';
	            }
	        }
	
	        this._content.innerHTML += info.join(' | ');
	
	        // If there are no results in _info then hide this.
	        this._container.style.display = hide;
	        return this;
	    },
	
	    _onLayerAdd: function(e) {
	        if (e.layer.getAttribution && e.layer.getAttribution()) {
	            this.addInfo(e.layer.getAttribution());
	        } else if ('on' in e.layer && e.layer.getAttribution) {
	            e.layer.on('ready', L.bind(function() {
	                this.addInfo(e.layer.getAttribution());
	            }, this));
	        }
	    },
	
	    _onLayerRemove: function (e) {
	        if (e.layer.getAttribution) {
	            this.removeInfo(e.layer.getAttribution());
	        }
	    }
	});
	
	module.exports.InfoControl = InfoControl;
	
	module.exports.infoControl = function(options) {
	    return new InfoControl(options);
	};
	


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var tileLayer = __webpack_require__(606).tileLayer,
	    featureLayer = __webpack_require__(600).featureLayer,
	    gridLayer = __webpack_require__(609).gridLayer,
	    gridControl = __webpack_require__(596).gridControl,
	    infoControl = __webpack_require__(607).infoControl,
	    shareControl = __webpack_require__(604).shareControl,
	    legendControl = __webpack_require__(603).legendControl,
	    mapboxLogoControl = __webpack_require__(611).mapboxLogoControl,
	    feedback = __webpack_require__(593);
	
	function withAccessToken(options, accessToken) {
	    if (!accessToken || options.accessToken)
	        return options;
	    return L.extend({accessToken: accessToken}, options);
	}
	
	var LMap = L.Map.extend({
	    includes: [__webpack_require__(605)],
	
	    options: {
	        tileLayer: {},
	        featureLayer: {},
	        gridLayer: {},
	        legendControl: {},
	        gridControl: {},
	        infoControl: false,
	        shareControl: false,
	        sanitizer: __webpack_require__(598)
	    },
	
	    _tilejson: {},
	
	    initialize: function(element, _, options) {
	
	        L.Map.prototype.initialize.call(this, element,
	            L.extend({}, L.Map.prototype.options, options));
	
	        // Disable the default 'Leaflet' text
	        if (this.attributionControl) {
	            this.attributionControl.setPrefix('');
	
	            var compact = this.options.attributionControl.compact;
	            // Set a compact display if map container width is < 640 or
	            // compact is set to `true` in attributionControl options.
	            if (compact || (compact !== false && this._container.offsetWidth <= 640)) {
	                L.DomUtil.addClass(this.attributionControl._container, 'leaflet-compact-attribution');
	            }
	
	            if (compact === undefined) {
	                this.on('resize', function() {
	                    if (this._container.offsetWidth > 640) {
	                        L.DomUtil.removeClass(this.attributionControl._container, 'leaflet-compact-attribution');
	                    } else {
	                        L.DomUtil.addClass(this.attributionControl._container, 'leaflet-compact-attribution');
	                    }
	                });
	            }
	        }
	
	        if (this.options.tileLayer) {
	            this.tileLayer = tileLayer(undefined,
	                withAccessToken(this.options.tileLayer, this.options.accessToken));
	            this.addLayer(this.tileLayer);
	        }
	
	        if (this.options.featureLayer) {
	            this.featureLayer = featureLayer(undefined,
	                withAccessToken(this.options.featureLayer, this.options.accessToken));
	            this.addLayer(this.featureLayer);
	        }
	
	        if (this.options.gridLayer) {
	            this.gridLayer = gridLayer(undefined,
	                withAccessToken(this.options.gridLayer, this.options.accessToken));
	            this.addLayer(this.gridLayer);
	        }
	
	        if (this.options.gridLayer && this.options.gridControl) {
	            this.gridControl = gridControl(this.gridLayer, this.options.gridControl);
	            this.addControl(this.gridControl);
	        }
	
	        if (this.options.infoControl) {
	            this.infoControl = infoControl(this.options.infoControl);
	            this.addControl(this.infoControl);
	        }
	
	        if (this.options.legendControl) {
	            this.legendControl = legendControl(this.options.legendControl);
	            this.addControl(this.legendControl);
	        }
	
	        if (this.options.shareControl) {
	            this.shareControl = shareControl(undefined,
	                withAccessToken(this.options.shareControl, this.options.accessToken));
	            this.addControl(this.shareControl);
	        }
	
	        this._mapboxLogoControl = mapboxLogoControl(this.options.mapboxLogoControl);
	        this.addControl(this._mapboxLogoControl);
	
	        this._loadTileJSON(_);
	
	        this.on('layeradd', this._onLayerAdd, this)
	            .on('layerremove', this._onLayerRemove, this)
	            .on('moveend', this._updateMapFeedbackLink, this);
	
	        this.whenReady(function () {
	            feedback.on('change', this._updateMapFeedbackLink, this);
	        });
	
	        this.on('unload', function () {
	            feedback.off('change', this._updateMapFeedbackLink, this);
	        });
	    },
	
	    // use a javascript object of tilejson data to configure this layer
	    _setTileJSON: function(_) {
	        this._tilejson = _;
	        this._initialize(_);
	        return this;
	    },
	
	    getTileJSON: function() {
	        return this._tilejson;
	    },
	
	    _initialize: function(json) {
	        if (this.tileLayer) {
	            this.tileLayer._setTileJSON(json);
	            this._updateLayer(this.tileLayer);
	        }
	
	        if (this.featureLayer && !this.featureLayer.getGeoJSON() && json.data && json.data[0]) {
	            this.featureLayer.loadURL(json.data[0]);
	        }
	
	        if (this.gridLayer) {
	            this.gridLayer._setTileJSON(json);
	            this._updateLayer(this.gridLayer);
	        }
	
	        if (this.infoControl && json.attribution) {
	            this.infoControl.addInfo(this.options.sanitizer(json.attribution));
	            this._updateMapFeedbackLink();
	        }
	
	        if (this.legendControl && json.legend) {
	            this.legendControl.addLegend(json.legend);
	        }
	
	        if (this.shareControl) {
	            this.shareControl._setTileJSON(json);
	        }
	
	        this._mapboxLogoControl._setTileJSON(json);
	
	        if (!this._loaded && json.center) {
	            var zoom = this.getZoom() !== undefined ? this.getZoom() : json.center[2],
	                center = L.latLng(json.center[1], json.center[0]);
	
	            this.setView(center, zoom);
	        }
	    },
	
	    _updateMapFeedbackLink: function() {
	        if (!this._controlContainer.getElementsByClassName) return;
	        var link = this._controlContainer.getElementsByClassName('mapbox-improve-map');
	        if (link.length && this._loaded) {
	            var center = this.getCenter().wrap();
	            var tilejson = this._tilejson || {};
	            var id = tilejson.id || '';
	
	            var hash = '#' + id + '/' +
	                center.lng.toFixed(3) + '/' +
	                center.lat.toFixed(3) + '/' +
	                this.getZoom();
	
	            for (var key in feedback.data) {
	                hash += '/' + key + '=' + feedback.data[key];
	            }
	
	            for (var i = 0; i < link.length; i++) {
	                link[i].hash = hash;
	            }
	        }
	    },
	
	    _onLayerAdd: function(e) {
	        if ('on' in e.layer) {
	            e.layer.on('ready', this._onLayerReady, this);
	        }
	        window.setTimeout(L.bind(this._updateMapFeedbackLink, this), 0); // Update after attribution control resets the HTML.
	    },
	
	    _onLayerRemove: function(e) {
	        if ('on' in e.layer) {
	            e.layer.off('ready', this._onLayerReady, this);
	        }
	        window.setTimeout(L.bind(this._updateMapFeedbackLink, this), 0); // Update after attribution control resets the HTML.
	    },
	
	    _onLayerReady: function(e) {
	        this._updateLayer(e.target);
	    },
	
	    _updateLayer: function(layer) {
	        if (!layer.options) return;
	
	        if (this.infoControl && this._loaded) {
	            this.infoControl.addInfo(layer.options.infoControl);
	        }
	
	        if (this.attributionControl && this._loaded && layer.getAttribution) {
	            this.attributionControl.addAttribution(layer.getAttribution());
	        }
	
	        if (!(L.stamp(layer) in this._zoomBoundLayers) &&
	                (layer.options.maxZoom || layer.options.minZoom)) {
	            this._zoomBoundLayers[L.stamp(layer)] = layer;
	        }
	
	        this._updateMapFeedbackLink();
	        this._updateZoomLevels();
	    }
	});
	
	module.exports.Map = LMap;
	
	module.exports.map = function(element, _, options) {
	    return new LMap(element, _, options);
	};
	


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var util = __webpack_require__(589),
	    request = __webpack_require__(594),
	    grid = __webpack_require__(610);
	
	// forked from danzel/L.UTFGrid
	var GridLayer = L.Class.extend({
	    includes: [L.Mixin.Events, __webpack_require__(605)],
	
	    options: {
	        template: function() { return ''; }
	    },
	
	    _mouseOn: null,
	    _tilejson: {},
	    _cache: {},
	
	    initialize: function(_, options) {
	        L.Util.setOptions(this, options);
	        this._loadTileJSON(_);
	    },
	
	    _setTileJSON: function(json) {
	        util.strict(json, 'object');
	
	        L.extend(this.options, {
	            grids: json.grids,
	            minZoom: json.minzoom,
	            maxZoom: json.maxzoom,
	            bounds: json.bounds && util.lbounds(json.bounds)
	        });
	
	        this._tilejson = json;
	        this._cache = {};
	        this._update();
	
	        return this;
	    },
	
	    getTileJSON: function() {
	        return this._tilejson;
	    },
	
	    active: function() {
	        return !!(this._map && this.options.grids && this.options.grids.length);
	    },
	
	    addTo: function (map) {
	        map.addLayer(this);
	        return this;
	    },
	
	    onAdd: function(map) {
	        this._map = map;
	        this._update();
	
	        this._map
	            .on('click', this._click, this)
	            .on('mousemove', this._move, this)
	            .on('moveend', this._update, this);
	    },
	
	    onRemove: function() {
	        this._map
	            .off('click', this._click, this)
	            .off('mousemove', this._move, this)
	            .off('moveend', this._update, this);
	    },
	
	    getData: function(latlng, callback) {
	        if (!this.active()) return;
	
	        var map = this._map,
	            point = map.project(latlng.wrap()),
	            tileSize = 256,
	            resolution = 4,
	            x = Math.floor(point.x / tileSize),
	            y = Math.floor(point.y / tileSize),
	            max = map.options.crs.scale(map.getZoom()) / tileSize;
	
	        x = (x + max) % max;
	        y = (y + max) % max;
	
	        this._getTile(map.getZoom(), x, y, function(grid) {
	            var gridX = Math.floor((point.x - (x * tileSize)) / resolution),
	                gridY = Math.floor((point.y - (y * tileSize)) / resolution);
	
	            callback(grid(gridX, gridY));
	        });
	
	        return this;
	    },
	
	    _click: function(e) {
	        this.getData(e.latlng, L.bind(function(data) {
	            this.fire('click', {
	                latLng: e.latlng,
	                data: data
	            });
	        }, this));
	    },
	
	    _move: function(e) {
	        this.getData(e.latlng, L.bind(function(data) {
	            if (data !== this._mouseOn) {
	                if (this._mouseOn) {
	                    this.fire('mouseout', {
	                        latLng: e.latlng,
	                        data: this._mouseOn
	                    });
	                }
	
	                this.fire('mouseover', {
	                    latLng: e.latlng,
	                    data: data
	                });
	
	                this._mouseOn = data;
	            } else {
	                this.fire('mousemove', {
	                    latLng: e.latlng,
	                    data: data
	                });
	            }
	        }, this));
	    },
	
	    _getTileURL: function(tilePoint) {
	        var urls = this.options.grids,
	            index = (tilePoint.x + tilePoint.y) % urls.length,
	            url = urls[index];
	
	        return L.Util.template(url, tilePoint);
	    },
	
	    // Load up all required json grid files
	    _update: function() {
	        if (!this.active()) return;
	
	        var bounds = this._map.getPixelBounds(),
	            z = this._map.getZoom(),
	            tileSize = 256;
	
	        if (z > this.options.maxZoom || z < this.options.minZoom) return;
	
	        var tileBounds = L.bounds(
	                bounds.min.divideBy(tileSize)._floor(),
	                bounds.max.divideBy(tileSize)._floor()),
	            max = this._map.options.crs.scale(z) / tileSize;
	
	        for (var x = tileBounds.min.x; x <= tileBounds.max.x; x++) {
	            for (var y = tileBounds.min.y; y <= tileBounds.max.y; y++) {
	                // x wrapped
	                this._getTile(z, ((x % max) + max) % max, ((y % max) + max) % max);
	            }
	        }
	    },
	
	    _getTile: function(z, x, y, callback) {
	        var key = z + '_' + x + '_' + y,
	            tilePoint = L.point(x, y);
	
	        tilePoint.z = z;
	
	        if (!this._tileShouldBeLoaded(tilePoint)) {
	            return;
	        }
	
	        if (key in this._cache) {
	            if (!callback) return;
	
	            if (typeof this._cache[key] === 'function') {
	                callback(this._cache[key]); // Already loaded
	            } else {
	                this._cache[key].push(callback); // Pending
	            }
	
	            return;
	        }
	
	        this._cache[key] = [];
	
	        if (callback) {
	            this._cache[key].push(callback);
	        }
	
	        request(this._getTileURL(tilePoint), L.bind(function(err, json) {
	            var callbacks = this._cache[key];
	            this._cache[key] = grid(json);
	            for (var i = 0; i < callbacks.length; ++i) {
	                callbacks[i](this._cache[key]);
	            }
	        }, this));
	    },
	
	    _tileShouldBeLoaded: function(tilePoint) {
	        if (tilePoint.z > this.options.maxZoom || tilePoint.z < this.options.minZoom) {
	            return false;
	        }
	
	        if (this.options.bounds) {
	            var tileSize = 256,
	                nwPoint = tilePoint.multiplyBy(tileSize),
	                sePoint = nwPoint.add(new L.Point(tileSize, tileSize)),
	                nw = this._map.unproject(nwPoint),
	                se = this._map.unproject(sePoint),
	                bounds = new L.LatLngBounds([nw, se]);
	
	            if (!this.options.bounds.intersects(bounds)) {
	                return false;
	            }
	        }
	
	        return true;
	    }
	});
	
	module.exports.GridLayer = GridLayer;
	
	module.exports.gridLayer = function(_, options) {
	    return new GridLayer(_, options);
	};
	


/***/ }),
/* 610 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	function utfDecode(c) {
	    if (c >= 93) c--;
	    if (c >= 35) c--;
	    return c - 32;
	}
	
	module.exports = function(data) {
	    return function(x, y) {
	        if (!data) return;
	        var idx = utfDecode(data.grid[y].charCodeAt(x)),
	            key = data.keys[idx];
	        return data.data[key];
	    };
	};
	


/***/ }),
/* 611 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var MapboxLogoControl = L.Control.extend({
	
	    options: {
	        position: 'bottomleft'
	    },
	
	    initialize: function(options) {
	        L.setOptions(this, options);
	    },
	
	    onAdd: function() {
	        this._container = L.DomUtil.create('div', 'mapbox-logo');
	        return this._container;
	    },
	
	    _setTileJSON: function(json) {
	        // Check if account referenced by the accessToken
	        // is asscociated with the Mapbox Logo
	        // as determined by mapbox-maps.
	        if (json.mapbox_logo) {
	            L.DomUtil.addClass(this._container, 'mapbox-logo-true');
	        }
	    }
	});
	
	module.exports.MapboxLogoControl = MapboxLogoControl;
	
	module.exports.mapboxLogoControl = function(options) {
	    return new MapboxLogoControl(options);
	};
	


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var util = __webpack_require__(589);
	var format_url = __webpack_require__(590);
	var request = __webpack_require__(594);
	
	var StyleLayer = L.TileLayer.extend({
	
	    options: {
	        sanitizer: __webpack_require__(598)
	    },
	
	    initialize: function(_, options) {
	        L.TileLayer.prototype.initialize.call(this, undefined, options);
	
	        this.options.tiles = this._formatTileURL(_);
	        this.options.tileSize = 512;
	        this.options.zoomOffset = -1;
	        this.options.tms = false;
	
	        this._getAttribution(_);
	    },
	
	    _getAttribution: function(_) {
	        var styleURL = format_url.style(_, this.options && this.options.accessToken);
	        request(styleURL, L.bind(function(err, style) {
	            if (err) {
	                util.log('could not load Mapbox style at ' + styleURL);
	                this.fire('error', {error: err});
	            }
	            var sources = [];
	            for (var id in style.sources) {
	                var source = style.sources[id].url.split('mapbox://')[1];
	                sources.push(source);
	            }
	            request(format_url.tileJSON(sources.join(), this.options.accessToken), L.bind(function(err, json) {
	                if (err) {
	                    util.log('could not load TileJSON at ' + _);
	                    this.fire('error', {error: err});
	                } else if (json) {
	                    util.strict(json, 'object');
	
	                    this.options.attribution = this.options.sanitizer(json.attribution);
	
	                    this._tilejson = json;
	                    this.fire('ready');
	                }
	            }, this));
	        }, this));
	    },
	
	    // disable the setUrl function, which is not available on mapbox tilelayers
	    setUrl: null,
	
	    _formatTileURL: function(style) {
	        var retina = L.Browser.retina ? '@2x' : '';
	        if (typeof style === 'string') {
	            if (style.indexOf('mapbox://styles/') === -1) {
	                util.log('Incorrectly formatted Mapbox style at ' + style);
	                this.fire('error');
	            }
	            var ownerIDStyle = style.split('mapbox://styles/')[1];
	            return format_url('/styles/v1/' + ownerIDStyle + '/tiles/{z}/{x}/{y}' + retina, this.options.accessToken);
	        } else if (typeof style === 'object') {
	            return format_url('/styles/v1/' + style.owner + '/' + style.id + '/tiles/{z}/{x}/{y}' + retina, this.options.accessToken);
	        }
	    },
	
	    // this is an exception to mapbox.js naming rules because it's called
	    // by `L.map`
	    getTileUrl: function(tilePoint) {
	        var templated = L.Util.template(this.options.tiles, tilePoint);
	        return templated;
	    }
	});
	
	module.exports.StyleLayer = StyleLayer;
	
	module.exports.styleLayer = function(_, options) {
	    return new StyleLayer(_, options);
	};
	


/***/ }),
/* 613 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	L.Control.Fullscreen = L.Control.extend({
	    options: {
	        position: 'topleft',
	        title: {
	            'false': 'View Fullscreen',
	            'true': 'Exit Fullscreen'
	        }
	    },
	
	    onAdd: function (map) {
	        var container = L.DomUtil.create('div', 'leaflet-control-fullscreen leaflet-bar leaflet-control');
	
	        this.link = L.DomUtil.create('a', 'leaflet-control-fullscreen-button leaflet-bar-part', container);
	        this.link.href = '#';
	
	        this._map = map;
	        this._map.on('fullscreenchange', this._toggleTitle, this);
	        this._toggleTitle();
	
	        L.DomEvent.on(this.link, 'click', this._click, this);
	
	        return container;
	    },
	
	    _click: function (e) {
	        L.DomEvent.stopPropagation(e);
	        L.DomEvent.preventDefault(e);
	        this._map.toggleFullscreen();
	    },
	
	    _toggleTitle: function() {
	        this.link.title = this.options.title[this._map.isFullscreen()];
	    }
	});
	
	L.Map.include({
	    isFullscreen: function () {
	        return this._isFullscreen || false;
	    },
	
	    toggleFullscreen: function () {
	        var container = this.getContainer();
	        if (this.isFullscreen()) {
	            if (document.exitFullscreen) {
	                document.exitFullscreen();
	            } else if (document.mozCancelFullScreen) {
	                document.mozCancelFullScreen();
	            } else if (document.webkitCancelFullScreen) {
	                document.webkitCancelFullScreen();
	            } else if (document.msExitFullscreen) {
	                document.msExitFullscreen();
	            } else {
	                L.DomUtil.removeClass(container, 'leaflet-pseudo-fullscreen');
	                this._setFullscreen(false);
	                this.invalidateSize();
	                this.fire('fullscreenchange');
	            }
	        } else {
	            if (container.requestFullscreen) {
	                container.requestFullscreen();
	            } else if (container.mozRequestFullScreen) {
	                container.mozRequestFullScreen();
	            } else if (container.webkitRequestFullscreen) {
	                container.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
	            } else if (container.msRequestFullscreen) {
	                container.msRequestFullscreen();
	            } else {
	                L.DomUtil.addClass(container, 'leaflet-pseudo-fullscreen');
	                this._setFullscreen(true);
	                this.invalidateSize();
	                this.fire('fullscreenchange');
	            }
	        }
	    },
	
	    _setFullscreen: function(fullscreen) {
	        this._isFullscreen = fullscreen;
	        var container = this.getContainer();
	        if (fullscreen) {
	            L.DomUtil.addClass(container, 'leaflet-fullscreen-on');
	        } else {
	            L.DomUtil.removeClass(container, 'leaflet-fullscreen-on');
	        }
	    },
	
	    _onFullscreenChange: function (e) {
	        var fullscreenElement =
	            document.fullscreenElement ||
	            document.mozFullScreenElement ||
	            document.webkitFullscreenElement ||
	            document.msFullscreenElement;
	
	        if (fullscreenElement === this.getContainer() && !this._isFullscreen) {
	            this._setFullscreen(true);
	            this.fire('fullscreenchange');
	        } else if (fullscreenElement !== this.getContainer() && this._isFullscreen) {
	            this._setFullscreen(false);
	            this.fire('fullscreenchange');
	        }
	    }
	});
	
	L.Map.mergeOptions({
	    fullscreenControl: false
	});
	
	L.Map.addInitHook(function () {
	    if (this.options.fullscreenControl) {
	        this.fullscreenControl = new L.Control.Fullscreen();
	        this.addControl(this.fullscreenControl);
	    }
	
	    var fullscreenchange;
	
	    if ('onfullscreenchange' in document) {
	        fullscreenchange = 'fullscreenchange';
	    } else if ('onmozfullscreenchange' in document) {
	        fullscreenchange = 'mozfullscreenchange';
	    } else if ('onwebkitfullscreenchange' in document) {
	        fullscreenchange = 'webkitfullscreenchange';
	    } else if ('onmsfullscreenchange' in document) {
	        fullscreenchange = 'MSFullscreenChange';
	    }
	
	    if (fullscreenchange) {
	        var onFullscreenChange = L.bind(this._onFullscreenChange, this);
	
	        this.whenReady(function () {
	            L.DomEvent.on(document, fullscreenchange, onFullscreenChange);
	        });
	
	        this.on('unload', function () {
	            L.DomEvent.off(document, fullscreenchange, onFullscreenChange);
	        });
	    }
	});
	
	L.control.fullscreen = function (options) {
	    return new L.Control.Fullscreen(options);
	};
	


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function(factory,window){if(typeof define==="function"&&define.amd){define(["leaflet"],factory)}else if(true){module.exports=factory(__webpack_require__(582))}if(typeof window!=="undefined"&&window.L){window.L.Control.MiniMap=factory(L);window.L.control.minimap=function(layer,options){return new window.L.Control.MiniMap(layer,options)}}})(function(L){var MiniMap=L.Control.extend({options:{position:"bottomright",toggleDisplay:false,zoomLevelOffset:-5,zoomLevelFixed:false,zoomAnimation:false,autoToggleDisplay:false,width:150,height:150,collapsedWidth:19,collapsedHeight:19,aimingRectOptions:{color:"#ff7800",weight:1,clickable:false},shadowRectOptions:{color:"#000000",weight:1,clickable:false,opacity:0,fillOpacity:0}},hideText:"Hide MiniMap",showText:"Show MiniMap",initialize:function(layer,options){L.Util.setOptions(this,options);this.options.aimingRectOptions.clickable=false;this.options.shadowRectOptions.clickable=false;this._layer=layer},onAdd:function(map){this._mainMap=map;this._container=L.DomUtil.create("div","leaflet-control-minimap");this._container.style.width=this.options.width+"px";this._container.style.height=this.options.height+"px";L.DomEvent.disableClickPropagation(this._container);L.DomEvent.on(this._container,"mousewheel",L.DomEvent.stopPropagation);this._miniMap=new L.Map(this._container,{attributionControl:false,zoomControl:false,zoomAnimation:this.options.zoomAnimation,autoToggleDisplay:this.options.autoToggleDisplay,touchZoom:!this.options.zoomLevelFixed,scrollWheelZoom:!this.options.zoomLevelFixed,doubleClickZoom:!this.options.zoomLevelFixed,boxZoom:!this.options.zoomLevelFixed,crs:map.options.crs});this._miniMap.addLayer(this._layer);this._mainMapMoving=false;this._miniMapMoving=false;this._userToggledDisplay=false;this._minimized=false;if(this.options.toggleDisplay){this._addToggleButton()}this._miniMap.whenReady(L.Util.bind(function(){this._aimingRect=L.rectangle(this._mainMap.getBounds(),this.options.aimingRectOptions).addTo(this._miniMap);this._shadowRect=L.rectangle(this._mainMap.getBounds(),this.options.shadowRectOptions).addTo(this._miniMap);this._mainMap.on("moveend",this._onMainMapMoved,this);this._mainMap.on("move",this._onMainMapMoving,this);this._miniMap.on("movestart",this._onMiniMapMoveStarted,this);this._miniMap.on("move",this._onMiniMapMoving,this);this._miniMap.on("moveend",this._onMiniMapMoved,this)},this));return this._container},addTo:function(map){L.Control.prototype.addTo.call(this,map);this._miniMap.setView(this._mainMap.getCenter(),this._decideZoom(true));this._setDisplay(this._decideMinimized());return this},onRemove:function(map){this._mainMap.off("moveend",this._onMainMapMoved,this);this._mainMap.off("move",this._onMainMapMoving,this);this._miniMap.off("moveend",this._onMiniMapMoved,this);this._miniMap.removeLayer(this._layer)},changeLayer:function(layer){this._miniMap.removeLayer(this._layer);this._layer=layer;this._miniMap.addLayer(this._layer)},_addToggleButton:function(){this._toggleDisplayButton=this.options.toggleDisplay?this._createButton("",this.hideText,"leaflet-control-minimap-toggle-display leaflet-control-minimap-toggle-display-"+this.options.position,this._container,this._toggleDisplayButtonClicked,this):undefined;this._toggleDisplayButton.style.width=this.options.collapsedWidth+"px";this._toggleDisplayButton.style.height=this.options.collapsedHeight+"px"},_createButton:function(html,title,className,container,fn,context){var link=L.DomUtil.create("a",className,container);link.innerHTML=html;link.href="#";link.title=title;var stop=L.DomEvent.stopPropagation;L.DomEvent.on(link,"click",stop).on(link,"mousedown",stop).on(link,"dblclick",stop).on(link,"click",L.DomEvent.preventDefault).on(link,"click",fn,context);return link},_toggleDisplayButtonClicked:function(){this._userToggledDisplay=true;if(!this._minimized){this._minimize();this._toggleDisplayButton.title=this.showText}else{this._restore();this._toggleDisplayButton.title=this.hideText}},_setDisplay:function(minimize){if(minimize!=this._minimized){if(!this._minimized){this._minimize()}else{this._restore()}}},_minimize:function(){if(this.options.toggleDisplay){this._container.style.width=this.options.collapsedWidth+"px";this._container.style.height=this.options.collapsedHeight+"px";this._toggleDisplayButton.className+=" minimized-"+this.options.position}else{this._container.style.display="none"}this._minimized=true},_restore:function(){if(this.options.toggleDisplay){this._container.style.width=this.options.width+"px";this._container.style.height=this.options.height+"px";this._toggleDisplayButton.className=this._toggleDisplayButton.className.replace("minimized-"+this.options.position,"")}else{this._container.style.display="block"}this._minimized=false},_onMainMapMoved:function(e){if(!this._miniMapMoving){this._mainMapMoving=true;this._miniMap.setView(this._mainMap.getCenter(),this._decideZoom(true));this._setDisplay(this._decideMinimized())}else{this._miniMapMoving=false}this._aimingRect.setBounds(this._mainMap.getBounds())},_onMainMapMoving:function(e){this._aimingRect.setBounds(this._mainMap.getBounds())},_onMiniMapMoveStarted:function(e){var lastAimingRect=this._aimingRect.getBounds();var sw=this._miniMap.latLngToContainerPoint(lastAimingRect.getSouthWest());var ne=this._miniMap.latLngToContainerPoint(lastAimingRect.getNorthEast());this._lastAimingRectPosition={sw:sw,ne:ne}},_onMiniMapMoving:function(e){if(!this._mainMapMoving&&this._lastAimingRectPosition){this._shadowRect.setBounds(new L.LatLngBounds(this._miniMap.containerPointToLatLng(this._lastAimingRectPosition.sw),this._miniMap.containerPointToLatLng(this._lastAimingRectPosition.ne)));this._shadowRect.setStyle({opacity:1,fillOpacity:.3})}},_onMiniMapMoved:function(e){if(!this._mainMapMoving){this._miniMapMoving=true;this._mainMap.setView(this._miniMap.getCenter(),this._decideZoom(false));this._shadowRect.setStyle({opacity:0,fillOpacity:0})}else{this._mainMapMoving=false}},_decideZoom:function(fromMaintoMini){if(!this.options.zoomLevelFixed){if(fromMaintoMini)return this._mainMap.getZoom()+this.options.zoomLevelOffset;else{var currentDiff=this._miniMap.getZoom()-this._mainMap.getZoom();var proposedZoom=this._miniMap.getZoom()-this.options.zoomLevelOffset;var toRet;if(currentDiff>this.options.zoomLevelOffset&&this._mainMap.getZoom()<this._miniMap.getMinZoom()-this.options.zoomLevelOffset){if(this._miniMap.getZoom()>this._lastMiniMapZoom){toRet=this._mainMap.getZoom()+1;this._miniMap.setZoom(this._miniMap.getZoom()-1)}else{toRet=this._mainMap.getZoom()}}else{toRet=proposedZoom}this._lastMiniMapZoom=this._miniMap.getZoom();return toRet}}else{if(fromMaintoMini)return this.options.zoomLevelFixed;else return this._mainMap.getZoom()}},_decideMinimized:function(){if(this._userToggledDisplay){return this._minimized}if(this.options.autoToggleDisplay){if(this._mainMap.getBounds().contains(this._miniMap.getBounds())){return true}return false}return this._minimized}});L.Map.mergeOptions({miniMapControl:false});L.Map.addInitHook(function(){if(this.options.miniMapControl){this.miniMapControl=(new MiniMap).addTo(this)}});return MiniMap},window);


/***/ }),
/* 615 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*
	 Leaflet.markercluster, Provides Beautiful Animated Marker Clustering functionality for Leaflet, a JS library for interactive maps.
	 https://github.com/Leaflet/Leaflet.markercluster
	 (c) 2012-2013, Dave Leaver, smartrak
	*/
	(function (window, document, undefined) {
	/*
	 * L.MarkerClusterGroup extends L.FeatureGroup by clustering the markers contained within
	 */
	
	L.MarkerClusterGroup = L.FeatureGroup.extend({
	
		options: {
			maxClusterRadius: 80, //A cluster will cover at most this many pixels from its center
			iconCreateFunction: null,
	
			spiderfyOnMaxZoom: true,
			showCoverageOnHover: true,
			zoomToBoundsOnClick: true,
			singleMarkerMode: false,
	
			disableClusteringAtZoom: null,
	
			// Setting this to false prevents the removal of any clusters outside of the viewpoint, which
			// is the default behaviour for performance reasons.
			removeOutsideVisibleBounds: true,
	
			//Whether to animate adding markers after adding the MarkerClusterGroup to the map
			// If you are adding individual markers set to true, if adding bulk markers leave false for massive performance gains.
			animateAddingMarkers: false,
	
			//Increase to increase the distance away that spiderfied markers appear from the center
			spiderfyDistanceMultiplier: 1,
	
			//Options to pass to the L.Polygon constructor
			polygonOptions: {}
		},
	
		initialize: function (options) {
			L.Util.setOptions(this, options);
			if (!this.options.iconCreateFunction) {
				this.options.iconCreateFunction = this._defaultIconCreateFunction;
			}
	
			this._featureGroup = L.featureGroup();
			this._featureGroup.on(L.FeatureGroup.EVENTS, this._propagateEvent, this);
	
			this._nonPointGroup = L.featureGroup();
			this._nonPointGroup.on(L.FeatureGroup.EVENTS, this._propagateEvent, this);
	
			this._inZoomAnimation = 0;
			this._needsClustering = [];
			this._needsRemoving = []; //Markers removed while we aren't on the map need to be kept track of
			//The bounds of the currently shown area (from _getExpandedVisibleBounds) Updated on zoom/move
			this._currentShownBounds = null;
	
			this._queue = [];
		},
	
		addLayer: function (layer) {
	
			if (layer instanceof L.LayerGroup) {
				var array = [];
				for (var i in layer._layers) {
					array.push(layer._layers[i]);
				}
				return this.addLayers(array);
			}
	
			//Don't cluster non point data
			if (!layer.getLatLng) {
				this._nonPointGroup.addLayer(layer);
				return this;
			}
	
			if (!this._map) {
				this._needsClustering.push(layer);
				return this;
			}
	
			if (this.hasLayer(layer)) {
				return this;
			}
	
	
			//If we have already clustered we'll need to add this one to a cluster
	
			if (this._unspiderfy) {
				this._unspiderfy();
			}
	
			this._addLayer(layer, this._maxZoom);
	
			//Work out what is visible
			var visibleLayer = layer,
				currentZoom = this._map.getZoom();
			if (layer.__parent) {
				while (visibleLayer.__parent._zoom >= currentZoom) {
					visibleLayer = visibleLayer.__parent;
				}
			}
	
			if (this._currentShownBounds.contains(visibleLayer.getLatLng())) {
				if (this.options.animateAddingMarkers) {
					this._animationAddLayer(layer, visibleLayer);
				} else {
					this._animationAddLayerNonAnimated(layer, visibleLayer);
				}
			}
			return this;
		},
	
		removeLayer: function (layer) {
	
			if (layer instanceof L.LayerGroup)
			{
				var array = [];
				for (var i in layer._layers) {
					array.push(layer._layers[i]);
				}
				return this.removeLayers(array);
			}
	
			//Non point layers
			if (!layer.getLatLng) {
				this._nonPointGroup.removeLayer(layer);
				return this;
			}
	
			if (!this._map) {
				if (!this._arraySplice(this._needsClustering, layer) && this.hasLayer(layer)) {
					this._needsRemoving.push(layer);
				}
				return this;
			}
	
			if (!layer.__parent) {
				return this;
			}
	
			if (this._unspiderfy) {
				this._unspiderfy();
				this._unspiderfyLayer(layer);
			}
	
			//Remove the marker from clusters
			this._removeLayer(layer, true);
	
			if (this._featureGroup.hasLayer(layer)) {
				this._featureGroup.removeLayer(layer);
				if (layer.setOpacity) {
					layer.setOpacity(1);
				}
			}
	
			return this;
		},
	
		//Takes an array of markers and adds them in bulk
		addLayers: function (layersArray) {
			var i, l, m,
				onMap = this._map,
				fg = this._featureGroup,
				npg = this._nonPointGroup;
	
			for (i = 0, l = layersArray.length; i < l; i++) {
				m = layersArray[i];
	
				//Not point data, can't be clustered
				if (!m.getLatLng) {
					npg.addLayer(m);
					continue;
				}
	
				if (this.hasLayer(m)) {
					continue;
				}
	
				if (!onMap) {
					this._needsClustering.push(m);
					continue;
				}
	
				this._addLayer(m, this._maxZoom);
	
				//If we just made a cluster of size 2 then we need to remove the other marker from the map (if it is) or we never will
				if (m.__parent) {
					if (m.__parent.getChildCount() === 2) {
						var markers = m.__parent.getAllChildMarkers(),
							otherMarker = markers[0] === m ? markers[1] : markers[0];
						fg.removeLayer(otherMarker);
					}
				}
			}
	
			if (onMap) {
				//Update the icons of all those visible clusters that were affected
				fg.eachLayer(function (c) {
					if (c instanceof L.MarkerCluster && c._iconNeedsUpdate) {
						c._updateIcon();
					}
				});
	
				this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
			}
	
			return this;
		},
	
		//Takes an array of markers and removes them in bulk
		removeLayers: function (layersArray) {
			var i, l, m,
				fg = this._featureGroup,
				npg = this._nonPointGroup;
	
			if (!this._map) {
				for (i = 0, l = layersArray.length; i < l; i++) {
					m = layersArray[i];
					this._arraySplice(this._needsClustering, m);
					npg.removeLayer(m);
				}
				return this;
			}
	
			for (i = 0, l = layersArray.length; i < l; i++) {
				m = layersArray[i];
	
				if (!m.__parent) {
					npg.removeLayer(m);
					continue;
				}
	
				this._removeLayer(m, true, true);
	
				if (fg.hasLayer(m)) {
					fg.removeLayer(m);
					if (m.setOpacity) {
						m.setOpacity(1);
					}
				}
			}
	
			//Fix up the clusters and markers on the map
			this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
	
			fg.eachLayer(function (c) {
				if (c instanceof L.MarkerCluster) {
					c._updateIcon();
				}
			});
	
			return this;
		},
	
		//Removes all layers from the MarkerClusterGroup
		clearLayers: function () {
			//Need our own special implementation as the LayerGroup one doesn't work for us
	
			//If we aren't on the map (yet), blow away the markers we know of
			if (!this._map) {
				this._needsClustering = [];
				delete this._gridClusters;
				delete this._gridUnclustered;
			}
	
			if (this._noanimationUnspiderfy) {
				this._noanimationUnspiderfy();
			}
	
			//Remove all the visible layers
			this._featureGroup.clearLayers();
			this._nonPointGroup.clearLayers();
	
			this.eachLayer(function (marker) {
				delete marker.__parent;
			});
	
			if (this._map) {
				//Reset _topClusterLevel and the DistanceGrids
				this._generateInitialClusters();
			}
	
			return this;
		},
	
		//Override FeatureGroup.getBounds as it doesn't work
		getBounds: function () {
			var bounds = new L.LatLngBounds();
			if (this._topClusterLevel) {
				bounds.extend(this._topClusterLevel._bounds);
			} else {
				for (var i = this._needsClustering.length - 1; i >= 0; i--) {
					bounds.extend(this._needsClustering[i].getLatLng());
				}
			}
	
			bounds.extend(this._nonPointGroup.getBounds());
	
			return bounds;
		},
	
		//Overrides LayerGroup.eachLayer
		eachLayer: function (method, context) {
			var markers = this._needsClustering.slice(),
			    i;
	
			if (this._topClusterLevel) {
				this._topClusterLevel.getAllChildMarkers(markers);
			}
	
			for (i = markers.length - 1; i >= 0; i--) {
				method.call(context, markers[i]);
			}
	
			this._nonPointGroup.eachLayer(method, context);
		},
	
		//Overrides LayerGroup.getLayers
		getLayers: function () {
			var layers = [];
			this.eachLayer(function (l) {
				layers.push(l);
			});
			return layers;
		},
	
		//Overrides LayerGroup.getLayer, WARNING: Really bad performance
		getLayer: function (id) {
			var result = null;
	
			this.eachLayer(function (l) {
				if (L.stamp(l) === id) {
					result = l;
				}
			});
	
			return result;
		},
	
		//Returns true if the given layer is in this MarkerClusterGroup
		hasLayer: function (layer) {
			if (!layer) {
				return false;
			}
	
			var i, anArray = this._needsClustering;
	
			for (i = anArray.length - 1; i >= 0; i--) {
				if (anArray[i] === layer) {
					return true;
				}
			}
	
			anArray = this._needsRemoving;
			for (i = anArray.length - 1; i >= 0; i--) {
				if (anArray[i] === layer) {
					return false;
				}
			}
	
			return !!(layer.__parent && layer.__parent._group === this) || this._nonPointGroup.hasLayer(layer);
		},
	
		//Zoom down to show the given layer (spiderfying if necessary) then calls the callback
		zoomToShowLayer: function (layer, callback) {
	
			var showMarker = function () {
				if ((layer._icon || layer.__parent._icon) && !this._inZoomAnimation) {
					this._map.off('moveend', showMarker, this);
					this.off('animationend', showMarker, this);
	
					if (layer._icon) {
						callback();
					} else if (layer.__parent._icon) {
						var afterSpiderfy = function () {
							this.off('spiderfied', afterSpiderfy, this);
							callback();
						};
	
						this.on('spiderfied', afterSpiderfy, this);
						layer.__parent.spiderfy();
					}
				}
			};
	
			if (layer._icon && this._map.getBounds().contains(layer.getLatLng())) {
				callback();
			} else if (layer.__parent._zoom < this._map.getZoom()) {
				//Layer should be visible now but isn't on screen, just pan over to it
				this._map.on('moveend', showMarker, this);
				this._map.panTo(layer.getLatLng());
			} else {
				this._map.on('moveend', showMarker, this);
				this.on('animationend', showMarker, this);
				this._map.setView(layer.getLatLng(), layer.__parent._zoom + 1);
				layer.__parent.zoomToBounds();
			}
		},
	
		//Overrides FeatureGroup.onAdd
		onAdd: function (map) {
			this._map = map;
			var i, l, layer;
	
			if (!isFinite(this._map.getMaxZoom())) {
				throw "Map has no maxZoom specified";
			}
	
			this._featureGroup.onAdd(map);
			this._nonPointGroup.onAdd(map);
	
			if (!this._gridClusters) {
				this._generateInitialClusters();
			}
	
			for (i = 0, l = this._needsRemoving.length; i < l; i++) {
				layer = this._needsRemoving[i];
				this._removeLayer(layer, true);
			}
			this._needsRemoving = [];
	
			for (i = 0, l = this._needsClustering.length; i < l; i++) {
				layer = this._needsClustering[i];
	
				//If the layer doesn't have a getLatLng then we can't cluster it, so add it to our child featureGroup
				if (!layer.getLatLng) {
					this._featureGroup.addLayer(layer);
					continue;
				}
	
	
				if (layer.__parent) {
					continue;
				}
				this._addLayer(layer, this._maxZoom);
			}
			this._needsClustering = [];
	
	
			this._map.on('zoomend', this._zoomEnd, this);
			this._map.on('moveend', this._moveEnd, this);
	
			if (this._spiderfierOnAdd) { //TODO FIXME: Not sure how to have spiderfier add something on here nicely
				this._spiderfierOnAdd();
			}
	
			this._bindEvents();
	
	
			//Actually add our markers to the map:
	
			//Remember the current zoom level and bounds
			this._zoom = this._map.getZoom();
			this._currentShownBounds = this._getExpandedVisibleBounds();
	
			//Make things appear on the map
			this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
		},
	
		//Overrides FeatureGroup.onRemove
		onRemove: function (map) {
			map.off('zoomend', this._zoomEnd, this);
			map.off('moveend', this._moveEnd, this);
	
			this._unbindEvents();
	
			//In case we are in a cluster animation
			this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
	
			if (this._spiderfierOnRemove) { //TODO FIXME: Not sure how to have spiderfier add something on here nicely
				this._spiderfierOnRemove();
			}
	
	
	
			//Clean up all the layers we added to the map
			this._hideCoverage();
			this._featureGroup.onRemove(map);
			this._nonPointGroup.onRemove(map);
	
			this._featureGroup.clearLayers();
	
			this._map = null;
		},
	
		getVisibleParent: function (marker) {
			var vMarker = marker;
			while (vMarker && !vMarker._icon) {
				vMarker = vMarker.__parent;
			}
			return vMarker || null;
		},
	
		//Remove the given object from the given array
		_arraySplice: function (anArray, obj) {
			for (var i = anArray.length - 1; i >= 0; i--) {
				if (anArray[i] === obj) {
					anArray.splice(i, 1);
					return true;
				}
			}
		},
	
		//Internal function for removing a marker from everything.
		//dontUpdateMap: set to true if you will handle updating the map manually (for bulk functions)
		_removeLayer: function (marker, removeFromDistanceGrid, dontUpdateMap) {
			var gridClusters = this._gridClusters,
				gridUnclustered = this._gridUnclustered,
				fg = this._featureGroup,
				map = this._map;
	
			//Remove the marker from distance clusters it might be in
			if (removeFromDistanceGrid) {
				for (var z = this._maxZoom; z >= 0; z--) {
					if (!gridUnclustered[z].removeObject(marker, map.project(marker.getLatLng(), z))) {
						break;
					}
				}
			}
	
			//Work our way up the clusters removing them as we go if required
			var cluster = marker.__parent,
				markers = cluster._markers,
				otherMarker;
	
			//Remove the marker from the immediate parents marker list
			this._arraySplice(markers, marker);
	
			while (cluster) {
				cluster._childCount--;
	
				if (cluster._zoom < 0) {
					//Top level, do nothing
					break;
				} else if (removeFromDistanceGrid && cluster._childCount <= 1) { //Cluster no longer required
					//We need to push the other marker up to the parent
					otherMarker = cluster._markers[0] === marker ? cluster._markers[1] : cluster._markers[0];
	
					//Update distance grid
					gridClusters[cluster._zoom].removeObject(cluster, map.project(cluster._cLatLng, cluster._zoom));
					gridUnclustered[cluster._zoom].addObject(otherMarker, map.project(otherMarker.getLatLng(), cluster._zoom));
	
					//Move otherMarker up to parent
					this._arraySplice(cluster.__parent._childClusters, cluster);
					cluster.__parent._markers.push(otherMarker);
					otherMarker.__parent = cluster.__parent;
	
					if (cluster._icon) {
						//Cluster is currently on the map, need to put the marker on the map instead
						fg.removeLayer(cluster);
						if (!dontUpdateMap) {
							fg.addLayer(otherMarker);
						}
					}
				} else {
					cluster._recalculateBounds();
					if (!dontUpdateMap || !cluster._icon) {
						cluster._updateIcon();
					}
				}
	
				cluster = cluster.__parent;
			}
	
			delete marker.__parent;
		},
	
		_isOrIsParent: function (el, oel) {
			while (oel) {
				if (el === oel) {
					return true;
				}
				oel = oel.parentNode;
			}
			return false;
		},
	
		_propagateEvent: function (e) {
			if (e.layer instanceof L.MarkerCluster) {
				//Prevent multiple clustermouseover/off events if the icon is made up of stacked divs (Doesn't work in ie <= 8, no relatedTarget)
				if (e.originalEvent && this._isOrIsParent(e.layer._icon, e.originalEvent.relatedTarget)) {
					return;
				}
				e.type = 'cluster' + e.type;
			}
	
			this.fire(e.type, e);
		},
	
		//Default functionality
		_defaultIconCreateFunction: function (cluster) {
			var childCount = cluster.getChildCount();
	
			var c = ' marker-cluster-';
			if (childCount < 10) {
				c += 'small';
			} else if (childCount < 100) {
				c += 'medium';
			} else {
				c += 'large';
			}
	
			return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', className: 'marker-cluster' + c, iconSize: new L.Point(40, 40) });
		},
	
		_bindEvents: function () {
			var map = this._map,
			    spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom,
			    showCoverageOnHover = this.options.showCoverageOnHover,
			    zoomToBoundsOnClick = this.options.zoomToBoundsOnClick;
	
			//Zoom on cluster click or spiderfy if we are at the lowest level
			if (spiderfyOnMaxZoom || zoomToBoundsOnClick) {
				this.on('clusterclick', this._zoomOrSpiderfy, this);
			}
	
			//Show convex hull (boundary) polygon on mouse over
			if (showCoverageOnHover) {
				this.on('clustermouseover', this._showCoverage, this);
				this.on('clustermouseout', this._hideCoverage, this);
				map.on('zoomend', this._hideCoverage, this);
			}
		},
	
		_zoomOrSpiderfy: function (e) {
			var map = this._map;
			if (map.getMaxZoom() === map.getZoom()) {
				if (this.options.spiderfyOnMaxZoom) {
					e.layer.spiderfy();
				}
			} else if (this.options.zoomToBoundsOnClick) {
				e.layer.zoomToBounds();
			}
	
	    // Focus the map again for keyboard users.
			if (e.originalEvent && e.originalEvent.keyCode === 13) {
				map._container.focus();
			}
		},
	
		_showCoverage: function (e) {
			var map = this._map;
			if (this._inZoomAnimation) {
				return;
			}
			if (this._shownPolygon) {
				map.removeLayer(this._shownPolygon);
			}
			if (e.layer.getChildCount() > 2 && e.layer !== this._spiderfied) {
				this._shownPolygon = new L.Polygon(e.layer.getConvexHull(), this.options.polygonOptions);
				map.addLayer(this._shownPolygon);
			}
		},
	
		_hideCoverage: function () {
			if (this._shownPolygon) {
				this._map.removeLayer(this._shownPolygon);
				this._shownPolygon = null;
			}
		},
	
		_unbindEvents: function () {
			var spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom,
				showCoverageOnHover = this.options.showCoverageOnHover,
				zoomToBoundsOnClick = this.options.zoomToBoundsOnClick,
				map = this._map;
	
			if (spiderfyOnMaxZoom || zoomToBoundsOnClick) {
				this.off('clusterclick', this._zoomOrSpiderfy, this);
			}
			if (showCoverageOnHover) {
				this.off('clustermouseover', this._showCoverage, this);
				this.off('clustermouseout', this._hideCoverage, this);
				map.off('zoomend', this._hideCoverage, this);
			}
		},
	
		_zoomEnd: function () {
			if (!this._map) { //May have been removed from the map by a zoomEnd handler
				return;
			}
			this._mergeSplitClusters();
	
			this._zoom = this._map._zoom;
			this._currentShownBounds = this._getExpandedVisibleBounds();
		},
	
		_moveEnd: function () {
			if (this._inZoomAnimation) {
				return;
			}
	
			var newBounds = this._getExpandedVisibleBounds();
	
			this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, this._zoom, newBounds);
			this._topClusterLevel._recursivelyAddChildrenToMap(null, this._map._zoom, newBounds);
	
			this._currentShownBounds = newBounds;
			return;
		},
	
		_generateInitialClusters: function () {
			var maxZoom = this._map.getMaxZoom(),
				radius = this.options.maxClusterRadius;
	
			if (this.options.disableClusteringAtZoom) {
				maxZoom = this.options.disableClusteringAtZoom - 1;
			}
			this._maxZoom = maxZoom;
			this._gridClusters = {};
			this._gridUnclustered = {};
	
			//Set up DistanceGrids for each zoom
			for (var zoom = maxZoom; zoom >= 0; zoom--) {
				this._gridClusters[zoom] = new L.DistanceGrid(radius);
				this._gridUnclustered[zoom] = new L.DistanceGrid(radius);
			}
	
			this._topClusterLevel = new L.MarkerCluster(this, -1);
		},
	
		//Zoom: Zoom to start adding at (Pass this._maxZoom to start at the bottom)
		_addLayer: function (layer, zoom) {
			var gridClusters = this._gridClusters,
			    gridUnclustered = this._gridUnclustered,
			    markerPoint, z;
	
			if (this.options.singleMarkerMode) {
				layer.options.icon = this.options.iconCreateFunction({
					getChildCount: function () {
						return 1;
					},
					getAllChildMarkers: function () {
						return [layer];
					}
				});
			}
	
			//Find the lowest zoom level to slot this one in
			for (; zoom >= 0; zoom--) {
				markerPoint = this._map.project(layer.getLatLng(), zoom); // calculate pixel position
	
				//Try find a cluster close by
				var closest = gridClusters[zoom].getNearObject(markerPoint);
				if (closest) {
					closest._addChild(layer);
					layer.__parent = closest;
					return;
				}
	
				//Try find a marker close by to form a new cluster with
				closest = gridUnclustered[zoom].getNearObject(markerPoint);
				if (closest) {
					var parent = closest.__parent;
					if (parent) {
						this._removeLayer(closest, false);
					}
	
					//Create new cluster with these 2 in it
	
					var newCluster = new L.MarkerCluster(this, zoom, closest, layer);
					gridClusters[zoom].addObject(newCluster, this._map.project(newCluster._cLatLng, zoom));
					closest.__parent = newCluster;
					layer.__parent = newCluster;
	
					//First create any new intermediate parent clusters that don't exist
					var lastParent = newCluster;
					for (z = zoom - 1; z > parent._zoom; z--) {
						lastParent = new L.MarkerCluster(this, z, lastParent);
						gridClusters[z].addObject(lastParent, this._map.project(closest.getLatLng(), z));
					}
					parent._addChild(lastParent);
	
					//Remove closest from this zoom level and any above that it is in, replace with newCluster
					for (z = zoom; z >= 0; z--) {
						if (!gridUnclustered[z].removeObject(closest, this._map.project(closest.getLatLng(), z))) {
							break;
						}
					}
	
					return;
				}
	
				//Didn't manage to cluster in at this zoom, record us as a marker here and continue upwards
				gridUnclustered[zoom].addObject(layer, markerPoint);
			}
	
			//Didn't get in anything, add us to the top
			this._topClusterLevel._addChild(layer);
			layer.__parent = this._topClusterLevel;
			return;
		},
	
		//Enqueue code to fire after the marker expand/contract has happened
		_enqueue: function (fn) {
			this._queue.push(fn);
			if (!this._queueTimeout) {
				this._queueTimeout = setTimeout(L.bind(this._processQueue, this), 300);
			}
		},
		_processQueue: function () {
			for (var i = 0; i < this._queue.length; i++) {
				this._queue[i].call(this);
			}
			this._queue.length = 0;
			clearTimeout(this._queueTimeout);
			this._queueTimeout = null;
		},
	
		//Merge and split any existing clusters that are too big or small
		_mergeSplitClusters: function () {
	
			//Incase we are starting to split before the animation finished
			this._processQueue();
	
			if (this._zoom < this._map._zoom && this._currentShownBounds.contains(this._getExpandedVisibleBounds())) { //Zoom in, split
				this._animationStart();
				//Remove clusters now off screen
				this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, this._zoom, this._getExpandedVisibleBounds());
	
				this._animationZoomIn(this._zoom, this._map._zoom);
	
			} else if (this._zoom > this._map._zoom) { //Zoom out, merge
				this._animationStart();
	
				this._animationZoomOut(this._zoom, this._map._zoom);
			} else {
				this._moveEnd();
			}
		},
	
		//Gets the maps visible bounds expanded in each direction by the size of the screen (so the user cannot see an area we do not cover in one pan)
		_getExpandedVisibleBounds: function () {
			if (!this.options.removeOutsideVisibleBounds) {
				return this.getBounds();
			}
	
			var map = this._map,
				bounds = map.getBounds(),
				sw = bounds._southWest,
				ne = bounds._northEast,
				latDiff = L.Browser.mobile ? 0 : Math.abs(sw.lat - ne.lat),
				lngDiff = L.Browser.mobile ? 0 : Math.abs(sw.lng - ne.lng);
	
			return new L.LatLngBounds(
				new L.LatLng(sw.lat - latDiff, sw.lng - lngDiff, true),
				new L.LatLng(ne.lat + latDiff, ne.lng + lngDiff, true));
		},
	
		//Shared animation code
		_animationAddLayerNonAnimated: function (layer, newCluster) {
			if (newCluster === layer) {
				this._featureGroup.addLayer(layer);
			} else if (newCluster._childCount === 2) {
				newCluster._addToMap();
	
				var markers = newCluster.getAllChildMarkers();
				this._featureGroup.removeLayer(markers[0]);
				this._featureGroup.removeLayer(markers[1]);
			} else {
				newCluster._updateIcon();
			}
		}
	});
	
	L.MarkerClusterGroup.include(!L.DomUtil.TRANSITION ? {
	
		//Non Animated versions of everything
		_animationStart: function () {
			//Do nothing...
		},
		_animationZoomIn: function (previousZoomLevel, newZoomLevel) {
			this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, previousZoomLevel);
			this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
		},
		_animationZoomOut: function (previousZoomLevel, newZoomLevel) {
			this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, previousZoomLevel);
			this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
		},
		_animationAddLayer: function (layer, newCluster) {
			this._animationAddLayerNonAnimated(layer, newCluster);
		}
	} : {
	
		//Animated versions here
		_animationStart: function () {
			this._map._mapPane.className += ' leaflet-cluster-anim';
			this._inZoomAnimation++;
		},
		_animationEnd: function () {
			if (this._map) {
				this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
			}
			this._inZoomAnimation--;
			this.fire('animationend');
		},
		_animationZoomIn: function (previousZoomLevel, newZoomLevel) {
			var bounds = this._getExpandedVisibleBounds(),
			    fg = this._featureGroup,
			    i;
	
			//Add all children of current clusters to map and remove those clusters from map
			this._topClusterLevel._recursively(bounds, previousZoomLevel, 0, function (c) {
				var startPos = c._latlng,
					markers = c._markers,
					m;
	
				if (!bounds.contains(startPos)) {
					startPos = null;
				}
	
				if (c._isSingleParent() && previousZoomLevel + 1 === newZoomLevel) { //Immediately add the new child and remove us
					fg.removeLayer(c);
					c._recursivelyAddChildrenToMap(null, newZoomLevel, bounds);
				} else {
					//Fade out old cluster
					c.setOpacity(0);
					c._recursivelyAddChildrenToMap(startPos, newZoomLevel, bounds);
				}
	
				//Remove all markers that aren't visible any more
				//TODO: Do we actually need to do this on the higher levels too?
				for (i = markers.length - 1; i >= 0; i--) {
					m = markers[i];
					if (!bounds.contains(m._latlng)) {
						fg.removeLayer(m);
					}
				}
	
			});
	
			this._forceLayout();
	
			//Update opacities
			this._topClusterLevel._recursivelyBecomeVisible(bounds, newZoomLevel);
			//TODO Maybe? Update markers in _recursivelyBecomeVisible
			fg.eachLayer(function (n) {
				if (!(n instanceof L.MarkerCluster) && n._icon) {
					n.setOpacity(1);
				}
			});
	
			//update the positions of the just added clusters/markers
			this._topClusterLevel._recursively(bounds, previousZoomLevel, newZoomLevel, function (c) {
				c._recursivelyRestoreChildPositions(newZoomLevel);
			});
	
			//Remove the old clusters and close the zoom animation
			this._enqueue(function () {
				//update the positions of the just added clusters/markers
				this._topClusterLevel._recursively(bounds, previousZoomLevel, 0, function (c) {
					fg.removeLayer(c);
					c.setOpacity(1);
				});
	
				this._animationEnd();
			});
		},
	
		_animationZoomOut: function (previousZoomLevel, newZoomLevel) {
			this._animationZoomOutSingle(this._topClusterLevel, previousZoomLevel - 1, newZoomLevel);
	
			//Need to add markers for those that weren't on the map before but are now
			this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
			//Remove markers that were on the map before but won't be now
			this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, previousZoomLevel, this._getExpandedVisibleBounds());
		},
		_animationZoomOutSingle: function (cluster, previousZoomLevel, newZoomLevel) {
			var bounds = this._getExpandedVisibleBounds();
	
			//Animate all of the markers in the clusters to move to their cluster center point
			cluster._recursivelyAnimateChildrenInAndAddSelfToMap(bounds, previousZoomLevel + 1, newZoomLevel);
	
			var me = this;
	
			//Update the opacity (If we immediately set it they won't animate)
			this._forceLayout();
			cluster._recursivelyBecomeVisible(bounds, newZoomLevel);
	
			//TODO: Maybe use the transition timing stuff to make this more reliable
			//When the animations are done, tidy up
			this._enqueue(function () {
	
				//This cluster stopped being a cluster before the timeout fired
				if (cluster._childCount === 1) {
					var m = cluster._markers[0];
					//If we were in a cluster animation at the time then the opacity and position of our child could be wrong now, so fix it
					m.setLatLng(m.getLatLng());
					m.setOpacity(1);
				} else {
					cluster._recursively(bounds, newZoomLevel, 0, function (c) {
						c._recursivelyRemoveChildrenFromMap(bounds, previousZoomLevel + 1);
					});
				}
				me._animationEnd();
			});
		},
		_animationAddLayer: function (layer, newCluster) {
			var me = this,
				fg = this._featureGroup;
	
			fg.addLayer(layer);
			if (newCluster !== layer) {
				if (newCluster._childCount > 2) { //Was already a cluster
	
					newCluster._updateIcon();
					this._forceLayout();
					this._animationStart();
	
					layer._setPos(this._map.latLngToLayerPoint(newCluster.getLatLng()));
					layer.setOpacity(0);
	
					this._enqueue(function () {
						fg.removeLayer(layer);
						layer.setOpacity(1);
	
						me._animationEnd();
					});
	
				} else { //Just became a cluster
					this._forceLayout();
	
					me._animationStart();
					me._animationZoomOutSingle(newCluster, this._map.getMaxZoom(), this._map.getZoom());
				}
			}
		},
	
		//Force a browser layout of stuff in the map
		// Should apply the current opacity and location to all elements so we can update them again for an animation
		_forceLayout: function () {
			//In my testing this works, infact offsetWidth of any element seems to work.
			//Could loop all this._layers and do this for each _icon if it stops working
	
			L.Util.falseFn(document.body.offsetWidth);
		}
	});
	
	L.markerClusterGroup = function (options) {
		return new L.MarkerClusterGroup(options);
	};
	
	
	L.MarkerCluster = L.Marker.extend({
		initialize: function (group, zoom, a, b) {
	
			L.Marker.prototype.initialize.call(this, a ? (a._cLatLng || a.getLatLng()) : new L.LatLng(0, 0), { icon: this });
	
	
			this._group = group;
			this._zoom = zoom;
	
			this._markers = [];
			this._childClusters = [];
			this._childCount = 0;
			this._iconNeedsUpdate = true;
	
			this._bounds = new L.LatLngBounds();
	
			if (a) {
				this._addChild(a);
			}
			if (b) {
				this._addChild(b);
			}
		},
	
		//Recursively retrieve all child markers of this cluster
		getAllChildMarkers: function (storageArray) {
			storageArray = storageArray || [];
	
			for (var i = this._childClusters.length - 1; i >= 0; i--) {
				this._childClusters[i].getAllChildMarkers(storageArray);
			}
	
			for (var j = this._markers.length - 1; j >= 0; j--) {
				storageArray.push(this._markers[j]);
			}
	
			return storageArray;
		},
	
		//Returns the count of how many child markers we have
		getChildCount: function () {
			return this._childCount;
		},
	
		//Zoom to the minimum of showing all of the child markers, or the extents of this cluster
		zoomToBounds: function () {
			var childClusters = this._childClusters.slice(),
				map = this._group._map,
				boundsZoom = map.getBoundsZoom(this._bounds),
				zoom = this._zoom + 1,
				mapZoom = map.getZoom(),
				i;
	
			//calculate how fare we need to zoom down to see all of the markers
			while (childClusters.length > 0 && boundsZoom > zoom) {
				zoom++;
				var newClusters = [];
				for (i = 0; i < childClusters.length; i++) {
					newClusters = newClusters.concat(childClusters[i]._childClusters);
				}
				childClusters = newClusters;
			}
	
			if (boundsZoom > zoom) {
				this._group._map.setView(this._latlng, zoom);
			} else if (boundsZoom <= mapZoom) { //If fitBounds wouldn't zoom us down, zoom us down instead
				this._group._map.setView(this._latlng, mapZoom + 1);
			} else {
				this._group._map.fitBounds(this._bounds);
			}
		},
	
		getBounds: function () {
			var bounds = new L.LatLngBounds();
			bounds.extend(this._bounds);
			return bounds;
		},
	
		_updateIcon: function () {
			this._iconNeedsUpdate = true;
			if (this._icon) {
				this.setIcon(this);
			}
		},
	
		//Cludge for Icon, we pretend to be an icon for performance
		createIcon: function () {
			if (this._iconNeedsUpdate) {
				this._iconObj = this._group.options.iconCreateFunction(this);
				this._iconNeedsUpdate = false;
			}
			return this._iconObj.createIcon();
		},
		createShadow: function () {
			return this._iconObj.createShadow();
		},
	
	
		_addChild: function (new1, isNotificationFromChild) {
	
			this._iconNeedsUpdate = true;
			this._expandBounds(new1);
	
			if (new1 instanceof L.MarkerCluster) {
				if (!isNotificationFromChild) {
					this._childClusters.push(new1);
					new1.__parent = this;
				}
				this._childCount += new1._childCount;
			} else {
				if (!isNotificationFromChild) {
					this._markers.push(new1);
				}
				this._childCount++;
			}
	
			if (this.__parent) {
				this.__parent._addChild(new1, true);
			}
		},
	
		//Expand our bounds and tell our parent to
		_expandBounds: function (marker) {
			var addedCount,
			    addedLatLng = marker._wLatLng || marker._latlng;
	
			if (marker instanceof L.MarkerCluster) {
				this._bounds.extend(marker._bounds);
				addedCount = marker._childCount;
			} else {
				this._bounds.extend(addedLatLng);
				addedCount = 1;
			}
	
			if (!this._cLatLng) {
				// when clustering, take position of the first point as the cluster center
				this._cLatLng = marker._cLatLng || addedLatLng;
			}
	
			// when showing clusters, take weighted average of all points as cluster center
			var totalCount = this._childCount + addedCount;
	
			//Calculate weighted latlng for display
			if (!this._wLatLng) {
				this._latlng = this._wLatLng = new L.LatLng(addedLatLng.lat, addedLatLng.lng);
			} else {
				this._wLatLng.lat = (addedLatLng.lat * addedCount + this._wLatLng.lat * this._childCount) / totalCount;
				this._wLatLng.lng = (addedLatLng.lng * addedCount + this._wLatLng.lng * this._childCount) / totalCount;
			}
		},
	
		//Set our markers position as given and add it to the map
		_addToMap: function (startPos) {
			if (startPos) {
				this._backupLatlng = this._latlng;
				this.setLatLng(startPos);
			}
			this._group._featureGroup.addLayer(this);
		},
	
		_recursivelyAnimateChildrenIn: function (bounds, center, maxZoom) {
			this._recursively(bounds, 0, maxZoom - 1,
				function (c) {
					var markers = c._markers,
						i, m;
					for (i = markers.length - 1; i >= 0; i--) {
						m = markers[i];
	
						//Only do it if the icon is still on the map
						if (m._icon) {
							m._setPos(center);
							m.setOpacity(0);
						}
					}
				},
				function (c) {
					var childClusters = c._childClusters,
						j, cm;
					for (j = childClusters.length - 1; j >= 0; j--) {
						cm = childClusters[j];
						if (cm._icon) {
							cm._setPos(center);
							cm.setOpacity(0);
						}
					}
				}
			);
		},
	
		_recursivelyAnimateChildrenInAndAddSelfToMap: function (bounds, previousZoomLevel, newZoomLevel) {
			this._recursively(bounds, newZoomLevel, 0,
				function (c) {
					c._recursivelyAnimateChildrenIn(bounds, c._group._map.latLngToLayerPoint(c.getLatLng()).round(), previousZoomLevel);
	
					//TODO: depthToAnimateIn affects _isSingleParent, if there is a multizoom we may/may not be.
					//As a hack we only do a animation free zoom on a single level zoom, if someone does multiple levels then we always animate
					if (c._isSingleParent() && previousZoomLevel - 1 === newZoomLevel) {
						c.setOpacity(1);
						c._recursivelyRemoveChildrenFromMap(bounds, previousZoomLevel); //Immediately remove our children as we are replacing them. TODO previousBounds not bounds
					} else {
						c.setOpacity(0);
					}
	
					c._addToMap();
				}
			);
		},
	
		_recursivelyBecomeVisible: function (bounds, zoomLevel) {
			this._recursively(bounds, 0, zoomLevel, null, function (c) {
				c.setOpacity(1);
			});
		},
	
		_recursivelyAddChildrenToMap: function (startPos, zoomLevel, bounds) {
			this._recursively(bounds, -1, zoomLevel,
				function (c) {
					if (zoomLevel === c._zoom) {
						return;
					}
	
					//Add our child markers at startPos (so they can be animated out)
					for (var i = c._markers.length - 1; i >= 0; i--) {
						var nm = c._markers[i];
	
						if (!bounds.contains(nm._latlng)) {
							continue;
						}
	
						if (startPos) {
							nm._backupLatlng = nm.getLatLng();
	
							nm.setLatLng(startPos);
							if (nm.setOpacity) {
								nm.setOpacity(0);
							}
						}
	
						c._group._featureGroup.addLayer(nm);
					}
				},
				function (c) {
					c._addToMap(startPos);
				}
			);
		},
	
		_recursivelyRestoreChildPositions: function (zoomLevel) {
			//Fix positions of child markers
			for (var i = this._markers.length - 1; i >= 0; i--) {
				var nm = this._markers[i];
				if (nm._backupLatlng) {
					nm.setLatLng(nm._backupLatlng);
					delete nm._backupLatlng;
				}
			}
	
			if (zoomLevel - 1 === this._zoom) {
				//Reposition child clusters
				for (var j = this._childClusters.length - 1; j >= 0; j--) {
					this._childClusters[j]._restorePosition();
				}
			} else {
				for (var k = this._childClusters.length - 1; k >= 0; k--) {
					this._childClusters[k]._recursivelyRestoreChildPositions(zoomLevel);
				}
			}
		},
	
		_restorePosition: function () {
			if (this._backupLatlng) {
				this.setLatLng(this._backupLatlng);
				delete this._backupLatlng;
			}
		},
	
		//exceptBounds: If set, don't remove any markers/clusters in it
		_recursivelyRemoveChildrenFromMap: function (previousBounds, zoomLevel, exceptBounds) {
			var m, i;
			this._recursively(previousBounds, -1, zoomLevel - 1,
				function (c) {
					//Remove markers at every level
					for (i = c._markers.length - 1; i >= 0; i--) {
						m = c._markers[i];
						if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
							c._group._featureGroup.removeLayer(m);
							if (m.setOpacity) {
								m.setOpacity(1);
							}
						}
					}
				},
				function (c) {
					//Remove child clusters at just the bottom level
					for (i = c._childClusters.length - 1; i >= 0; i--) {
						m = c._childClusters[i];
						if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
							c._group._featureGroup.removeLayer(m);
							if (m.setOpacity) {
								m.setOpacity(1);
							}
						}
					}
				}
			);
		},
	
		//Run the given functions recursively to this and child clusters
		// boundsToApplyTo: a L.LatLngBounds representing the bounds of what clusters to recurse in to
		// zoomLevelToStart: zoom level to start running functions (inclusive)
		// zoomLevelToStop: zoom level to stop running functions (inclusive)
		// runAtEveryLevel: function that takes an L.MarkerCluster as an argument that should be applied on every level
		// runAtBottomLevel: function that takes an L.MarkerCluster as an argument that should be applied at only the bottom level
		_recursively: function (boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel) {
			var childClusters = this._childClusters,
			    zoom = this._zoom,
				i, c;
	
			if (zoomLevelToStart > zoom) { //Still going down to required depth, just recurse to child clusters
				for (i = childClusters.length - 1; i >= 0; i--) {
					c = childClusters[i];
					if (boundsToApplyTo.intersects(c._bounds)) {
						c._recursively(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel);
					}
				}
			} else { //In required depth
	
				if (runAtEveryLevel) {
					runAtEveryLevel(this);
				}
				if (runAtBottomLevel && this._zoom === zoomLevelToStop) {
					runAtBottomLevel(this);
				}
	
				//TODO: This loop is almost the same as above
				if (zoomLevelToStop > zoom) {
					for (i = childClusters.length - 1; i >= 0; i--) {
						c = childClusters[i];
						if (boundsToApplyTo.intersects(c._bounds)) {
							c._recursively(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel);
						}
					}
				}
			}
		},
	
		_recalculateBounds: function () {
			var markers = this._markers,
				childClusters = this._childClusters,
				i;
	
			this._bounds = new L.LatLngBounds();
			delete this._wLatLng;
	
			for (i = markers.length - 1; i >= 0; i--) {
				this._expandBounds(markers[i]);
			}
			for (i = childClusters.length - 1; i >= 0; i--) {
				this._expandBounds(childClusters[i]);
			}
		},
	
	
		//Returns true if we are the parent of only one cluster and that cluster is the same as us
		_isSingleParent: function () {
			//Don't need to check this._markers as the rest won't work if there are any
			return this._childClusters.length > 0 && this._childClusters[0]._childCount === this._childCount;
		}
	});
	
	
	
	L.DistanceGrid = function (cellSize) {
		this._cellSize = cellSize;
		this._sqCellSize = cellSize * cellSize;
		this._grid = {};
		this._objectPoint = { };
	};
	
	L.DistanceGrid.prototype = {
	
		addObject: function (obj, point) {
			var x = this._getCoord(point.x),
			    y = this._getCoord(point.y),
			    grid = this._grid,
			    row = grid[y] = grid[y] || {},
			    cell = row[x] = row[x] || [],
			    stamp = L.Util.stamp(obj);
	
			this._objectPoint[stamp] = point;
	
			cell.push(obj);
		},
	
		updateObject: function (obj, point) {
			this.removeObject(obj);
			this.addObject(obj, point);
		},
	
		//Returns true if the object was found
		removeObject: function (obj, point) {
			var x = this._getCoord(point.x),
			    y = this._getCoord(point.y),
			    grid = this._grid,
			    row = grid[y] = grid[y] || {},
			    cell = row[x] = row[x] || [],
			    i, len;
	
			delete this._objectPoint[L.Util.stamp(obj)];
	
			for (i = 0, len = cell.length; i < len; i++) {
				if (cell[i] === obj) {
	
					cell.splice(i, 1);
	
					if (len === 1) {
						delete row[x];
					}
	
					return true;
				}
			}
	
		},
	
		eachObject: function (fn, context) {
			var i, j, k, len, row, cell, removed,
			    grid = this._grid;
	
			for (i in grid) {
				row = grid[i];
	
				for (j in row) {
					cell = row[j];
	
					for (k = 0, len = cell.length; k < len; k++) {
						removed = fn.call(context, cell[k]);
						if (removed) {
							k--;
							len--;
						}
					}
				}
			}
		},
	
		getNearObject: function (point) {
			var x = this._getCoord(point.x),
			    y = this._getCoord(point.y),
			    i, j, k, row, cell, len, obj, dist,
			    objectPoint = this._objectPoint,
			    closestDistSq = this._sqCellSize,
			    closest = null;
	
			for (i = y - 1; i <= y + 1; i++) {
				row = this._grid[i];
				if (row) {
	
					for (j = x - 1; j <= x + 1; j++) {
						cell = row[j];
						if (cell) {
	
							for (k = 0, len = cell.length; k < len; k++) {
								obj = cell[k];
								dist = this._sqDist(objectPoint[L.Util.stamp(obj)], point);
								if (dist < closestDistSq) {
									closestDistSq = dist;
									closest = obj;
								}
							}
						}
					}
				}
			}
			return closest;
		},
	
		_getCoord: function (x) {
			return Math.floor(x / this._cellSize);
		},
	
		_sqDist: function (p, p2) {
			var dx = p2.x - p.x,
			    dy = p2.y - p.y;
			return dx * dx + dy * dy;
		}
	};
	
	
	/* Copyright (c) 2012 the authors listed at the following URL, and/or
	the authors of referenced articles or incorporated external code:
	http://en.literateprograms.org/Quickhull_(Javascript)?action=history&offset=20120410175256
	
	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:
	
	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	Retrieved from: http://en.literateprograms.org/Quickhull_(Javascript)?oldid=18434
	*/
	
	(function () {
		L.QuickHull = {
	
			/*
			 * @param {Object} cpt a point to be measured from the baseline
			 * @param {Array} bl the baseline, as represented by a two-element
			 *   array of latlng objects.
			 * @returns {Number} an approximate distance measure
			 */
			getDistant: function (cpt, bl) {
				var vY = bl[1].lat - bl[0].lat,
					vX = bl[0].lng - bl[1].lng;
				return (vX * (cpt.lat - bl[0].lat) + vY * (cpt.lng - bl[0].lng));
			},
	
			/*
			 * @param {Array} baseLine a two-element array of latlng objects
			 *   representing the baseline to project from
			 * @param {Array} latLngs an array of latlng objects
			 * @returns {Object} the maximum point and all new points to stay
			 *   in consideration for the hull.
			 */
			findMostDistantPointFromBaseLine: function (baseLine, latLngs) {
				var maxD = 0,
					maxPt = null,
					newPoints = [],
					i, pt, d;
	
				for (i = latLngs.length - 1; i >= 0; i--) {
					pt = latLngs[i];
					d = this.getDistant(pt, baseLine);
	
					if (d > 0) {
						newPoints.push(pt);
					} else {
						continue;
					}
	
					if (d > maxD) {
						maxD = d;
						maxPt = pt;
					}
				}
	
				return { maxPoint: maxPt, newPoints: newPoints };
			},
	
	
			/*
			 * Given a baseline, compute the convex hull of latLngs as an array
			 * of latLngs.
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */
			buildConvexHull: function (baseLine, latLngs) {
				var convexHullBaseLines = [],
					t = this.findMostDistantPointFromBaseLine(baseLine, latLngs);
	
				if (t.maxPoint) { // if there is still a point "outside" the base line
					convexHullBaseLines =
						convexHullBaseLines.concat(
							this.buildConvexHull([baseLine[0], t.maxPoint], t.newPoints)
						);
					convexHullBaseLines =
						convexHullBaseLines.concat(
							this.buildConvexHull([t.maxPoint, baseLine[1]], t.newPoints)
						);
					return convexHullBaseLines;
				} else {  // if there is no more point "outside" the base line, the current base line is part of the convex hull
					return [baseLine[0]];
				}
			},
	
			/*
			 * Given an array of latlngs, compute a convex hull as an array
			 * of latlngs
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */
			getConvexHull: function (latLngs) {
				// find first baseline
				var maxLat = false, minLat = false,
					maxPt = null, minPt = null,
					i;
	
				for (i = latLngs.length - 1; i >= 0; i--) {
					var pt = latLngs[i];
					if (maxLat === false || pt.lat > maxLat) {
						maxPt = pt;
						maxLat = pt.lat;
					}
					if (minLat === false || pt.lat < minLat) {
						minPt = pt;
						minLat = pt.lat;
					}
				}
				var ch = [].concat(this.buildConvexHull([minPt, maxPt], latLngs),
									this.buildConvexHull([maxPt, minPt], latLngs));
				return ch;
			}
		};
	}());
	
	L.MarkerCluster.include({
		getConvexHull: function () {
			var childMarkers = this.getAllChildMarkers(),
				points = [],
				p, i;
	
			for (i = childMarkers.length - 1; i >= 0; i--) {
				p = childMarkers[i].getLatLng();
				points.push(p);
			}
	
			return L.QuickHull.getConvexHull(points);
		}
	});
	
	
	//This code is 100% based on https://github.com/jawj/OverlappingMarkerSpiderfier-Leaflet
	//Huge thanks to jawj for implementing it first to make my job easy :-)
	
	L.MarkerCluster.include({
	
		_2PI: Math.PI * 2,
		_circleFootSeparation: 25, //related to circumference of circle
		_circleStartAngle: Math.PI / 6,
	
		_spiralFootSeparation:  28, //related to size of spiral (experiment!)
		_spiralLengthStart: 11,
		_spiralLengthFactor: 5,
	
		_circleSpiralSwitchover: 9, //show spiral instead of circle from this marker count upwards.
									// 0 -> always spiral; Infinity -> always circle
	
		spiderfy: function () {
			if (this._group._spiderfied === this || this._group._inZoomAnimation) {
				return;
			}
	
			var childMarkers = this.getAllChildMarkers(),
				group = this._group,
				map = group._map,
				center = map.latLngToLayerPoint(this._latlng),
				positions;
	
			this._group._unspiderfy();
			this._group._spiderfied = this;
	
			//TODO Maybe: childMarkers order by distance to center
	
			if (childMarkers.length >= this._circleSpiralSwitchover) {
				positions = this._generatePointsSpiral(childMarkers.length, center);
			} else {
				center.y += 10; //Otherwise circles look wrong
				positions = this._generatePointsCircle(childMarkers.length, center);
			}
	
			this._animationSpiderfy(childMarkers, positions);
		},
	
		unspiderfy: function (zoomDetails) {
			/// <param Name="zoomDetails">Argument from zoomanim if being called in a zoom animation or null otherwise</param>
			if (this._group._inZoomAnimation) {
				return;
			}
			this._animationUnspiderfy(zoomDetails);
	
			this._group._spiderfied = null;
		},
	
		_generatePointsCircle: function (count, centerPt) {
			var circumference = this._group.options.spiderfyDistanceMultiplier * this._circleFootSeparation * (2 + count),
				legLength = circumference / this._2PI,  //radius from circumference
				angleStep = this._2PI / count,
				res = [],
				i, angle;
	
			res.length = count;
	
			for (i = count - 1; i >= 0; i--) {
				angle = this._circleStartAngle + i * angleStep;
				res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
			}
	
			return res;
		},
	
		_generatePointsSpiral: function (count, centerPt) {
			var legLength = this._group.options.spiderfyDistanceMultiplier * this._spiralLengthStart,
				separation = this._group.options.spiderfyDistanceMultiplier * this._spiralFootSeparation,
				lengthFactor = this._group.options.spiderfyDistanceMultiplier * this._spiralLengthFactor,
				angle = 0,
				res = [],
				i;
	
			res.length = count;
	
			for (i = count - 1; i >= 0; i--) {
				angle += separation / legLength + i * 0.0005;
				res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
				legLength += this._2PI * lengthFactor / angle;
			}
			return res;
		},
	
		_noanimationUnspiderfy: function () {
			var group = this._group,
				map = group._map,
				fg = group._featureGroup,
				childMarkers = this.getAllChildMarkers(),
				m, i;
	
			this.setOpacity(1);
			for (i = childMarkers.length - 1; i >= 0; i--) {
				m = childMarkers[i];
	
				fg.removeLayer(m);
	
				if (m._preSpiderfyLatlng) {
					m.setLatLng(m._preSpiderfyLatlng);
					delete m._preSpiderfyLatlng;
				}
				if (m.setZIndexOffset) {
					m.setZIndexOffset(0);
				}
	
				if (m._spiderLeg) {
					map.removeLayer(m._spiderLeg);
					delete m._spiderLeg;
				}
			}
	
			group._spiderfied = null;
		}
	});
	
	L.MarkerCluster.include(!L.DomUtil.TRANSITION ? {
		//Non Animated versions of everything
		_animationSpiderfy: function (childMarkers, positions) {
			var group = this._group,
				map = group._map,
				fg = group._featureGroup,
				i, m, leg, newPos;
	
			for (i = childMarkers.length - 1; i >= 0; i--) {
				newPos = map.layerPointToLatLng(positions[i]);
				m = childMarkers[i];
	
				m._preSpiderfyLatlng = m._latlng;
				m.setLatLng(newPos);
				if (m.setZIndexOffset) {
					m.setZIndexOffset(1000000); //Make these appear on top of EVERYTHING
				}
	
				fg.addLayer(m);
	
	
				leg = new L.Polyline([this._latlng, newPos], { weight: 1.5, color: '#222' });
				map.addLayer(leg);
				m._spiderLeg = leg;
			}
			this.setOpacity(0.3);
			group.fire('spiderfied');
		},
	
		_animationUnspiderfy: function () {
			this._noanimationUnspiderfy();
		}
	} : {
		//Animated versions here
		SVG_ANIMATION: (function () {
			return document.createElementNS('http://www.w3.org/2000/svg', 'animate').toString().indexOf('SVGAnimate') > -1;
		}()),
	
		_animationSpiderfy: function (childMarkers, positions) {
			var me = this,
				group = this._group,
				map = group._map,
				fg = group._featureGroup,
				thisLayerPos = map.latLngToLayerPoint(this._latlng),
				i, m, leg, newPos;
	
			//Add markers to map hidden at our center point
			for (i = childMarkers.length - 1; i >= 0; i--) {
				m = childMarkers[i];
	
				//If it is a marker, add it now and we'll animate it out
				if (m.setOpacity) {
					m.setZIndexOffset(1000000); //Make these appear on top of EVERYTHING
					m.setOpacity(0);
				
					fg.addLayer(m);
	
					m._setPos(thisLayerPos);
				} else {
					//Vectors just get immediately added
					fg.addLayer(m);
				}
			}
	
			group._forceLayout();
			group._animationStart();
	
			var initialLegOpacity = L.Path.SVG ? 0 : 0.3,
				xmlns = L.Path.SVG_NS;
	
	
			for (i = childMarkers.length - 1; i >= 0; i--) {
				newPos = map.layerPointToLatLng(positions[i]);
				m = childMarkers[i];
	
				//Move marker to new position
				m._preSpiderfyLatlng = m._latlng;
				m.setLatLng(newPos);
				
				if (m.setOpacity) {
					m.setOpacity(1);
				}
	
	
				//Add Legs.
				leg = new L.Polyline([me._latlng, newPos], { weight: 1.5, color: '#222', opacity: initialLegOpacity });
				map.addLayer(leg);
				m._spiderLeg = leg;
	
				//Following animations don't work for canvas
				if (!L.Path.SVG || !this.SVG_ANIMATION) {
					continue;
				}
	
				//How this works:
				//http://stackoverflow.com/questions/5924238/how-do-you-animate-an-svg-path-in-ios
				//http://dev.opera.com/articles/view/advanced-svg-animation-techniques/
	
				//Animate length
				var length = leg._path.getTotalLength();
				leg._path.setAttribute("stroke-dasharray", length + "," + length);
	
				var anim = document.createElementNS(xmlns, "animate");
				anim.setAttribute("attributeName", "stroke-dashoffset");
				anim.setAttribute("begin", "indefinite");
				anim.setAttribute("from", length);
				anim.setAttribute("to", 0);
				anim.setAttribute("dur", 0.25);
				leg._path.appendChild(anim);
				anim.beginElement();
	
				//Animate opacity
				anim = document.createElementNS(xmlns, "animate");
				anim.setAttribute("attributeName", "stroke-opacity");
				anim.setAttribute("attributeName", "stroke-opacity");
				anim.setAttribute("begin", "indefinite");
				anim.setAttribute("from", 0);
				anim.setAttribute("to", 0.5);
				anim.setAttribute("dur", 0.25);
				leg._path.appendChild(anim);
				anim.beginElement();
			}
			me.setOpacity(0.3);
	
			//Set the opacity of the spiderLegs back to their correct value
			// The animations above override this until they complete.
			// If the initial opacity of the spiderlegs isn't 0 then they appear before the animation starts.
			if (L.Path.SVG) {
				this._group._forceLayout();
	
				for (i = childMarkers.length - 1; i >= 0; i--) {
					m = childMarkers[i]._spiderLeg;
	
					m.options.opacity = 0.5;
					m._path.setAttribute('stroke-opacity', 0.5);
				}
			}
	
			setTimeout(function () {
				group._animationEnd();
				group.fire('spiderfied');
			}, 200);
		},
	
		_animationUnspiderfy: function (zoomDetails) {
			var group = this._group,
				map = group._map,
				fg = group._featureGroup,
				thisLayerPos = zoomDetails ? map._latLngToNewLayerPoint(this._latlng, zoomDetails.zoom, zoomDetails.center) : map.latLngToLayerPoint(this._latlng),
				childMarkers = this.getAllChildMarkers(),
				svg = L.Path.SVG && this.SVG_ANIMATION,
				m, i, a;
	
			group._animationStart();
	
			//Make us visible and bring the child markers back in
			this.setOpacity(1);
			for (i = childMarkers.length - 1; i >= 0; i--) {
				m = childMarkers[i];
	
				//Marker was added to us after we were spidified
				if (!m._preSpiderfyLatlng) {
					continue;
				}
	
				//Fix up the location to the real one
				m.setLatLng(m._preSpiderfyLatlng);
				delete m._preSpiderfyLatlng;
				//Hack override the location to be our center
				if (m.setOpacity) {
					m._setPos(thisLayerPos);
					m.setOpacity(0);
				} else {
					fg.removeLayer(m);
				}
	
				//Animate the spider legs back in
				if (svg) {
					a = m._spiderLeg._path.childNodes[0];
					a.setAttribute('to', a.getAttribute('from'));
					a.setAttribute('from', 0);
					a.beginElement();
	
					a = m._spiderLeg._path.childNodes[1];
					a.setAttribute('from', 0.5);
					a.setAttribute('to', 0);
					a.setAttribute('stroke-opacity', 0);
					a.beginElement();
	
					m._spiderLeg._path.setAttribute('stroke-opacity', 0);
				}
			}
	
			setTimeout(function () {
				//If we have only <= one child left then that marker will be shown on the map so don't remove it!
				var stillThereChildCount = 0;
				for (i = childMarkers.length - 1; i >= 0; i--) {
					m = childMarkers[i];
					if (m._spiderLeg) {
						stillThereChildCount++;
					}
				}
	
	
				for (i = childMarkers.length - 1; i >= 0; i--) {
					m = childMarkers[i];
	
					if (!m._spiderLeg) { //Has already been unspiderfied
						continue;
					}
	
	
					if (m.setOpacity) {
						m.setOpacity(1);
						m.setZIndexOffset(0);
					}
	
					if (stillThereChildCount > 1) {
						fg.removeLayer(m);
					}
	
					map.removeLayer(m._spiderLeg);
					delete m._spiderLeg;
				}
				group._animationEnd();
			}, 200);
		}
	});
	
	
	L.MarkerClusterGroup.include({
		//The MarkerCluster currently spiderfied (if any)
		_spiderfied: null,
	
		_spiderfierOnAdd: function () {
			this._map.on('click', this._unspiderfyWrapper, this);
	
			if (this._map.options.zoomAnimation) {
				this._map.on('zoomstart', this._unspiderfyZoomStart, this);
			}
			//Browsers without zoomAnimation or a big zoom don't fire zoomstart
			this._map.on('zoomend', this._noanimationUnspiderfy, this);
	
			if (L.Path.SVG && !L.Browser.touch) {
				this._map._initPathRoot();
				//Needs to happen in the pageload, not after, or animations don't work in webkit
				//  http://stackoverflow.com/questions/8455200/svg-animate-with-dynamically-added-elements
				//Disable on touch browsers as the animation messes up on a touch zoom and isn't very noticable
			}
		},
	
		_spiderfierOnRemove: function () {
			this._map.off('click', this._unspiderfyWrapper, this);
			this._map.off('zoomstart', this._unspiderfyZoomStart, this);
			this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
	
			this._unspiderfy(); //Ensure that markers are back where they should be
		},
	
	
		//On zoom start we add a zoomanim handler so that we are guaranteed to be last (after markers are animated)
		//This means we can define the animation they do rather than Markers doing an animation to their actual location
		_unspiderfyZoomStart: function () {
			if (!this._map) { //May have been removed from the map by a zoomEnd handler
				return;
			}
	
			this._map.on('zoomanim', this._unspiderfyZoomAnim, this);
		},
		_unspiderfyZoomAnim: function (zoomDetails) {
			//Wait until the first zoomanim after the user has finished touch-zooming before running the animation
			if (L.DomUtil.hasClass(this._map._mapPane, 'leaflet-touching')) {
				return;
			}
	
			this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
			this._unspiderfy(zoomDetails);
		},
	
	
		_unspiderfyWrapper: function () {
			/// <summary>_unspiderfy but passes no arguments</summary>
			this._unspiderfy();
		},
	
		_unspiderfy: function (zoomDetails) {
			if (this._spiderfied) {
				this._spiderfied.unspiderfy(zoomDetails);
			}
		},
	
		_noanimationUnspiderfy: function () {
			if (this._spiderfied) {
				this._spiderfied._noanimationUnspiderfy();
			}
		},
	
		//If the given layer is currently being spiderfied then we unspiderfy it so it isn't on the map anymore etc
		_unspiderfyLayer: function (layer) {
			if (layer._spiderLeg) {
				this._featureGroup.removeLayer(layer);
	
				layer.setOpacity(1);
				//Position will be fixed up immediately in _animationUnspiderfy
				layer.setZIndexOffset(0);
	
				this._map.removeLayer(layer._spiderLeg);
				delete layer._spiderLeg;
			}
		}
	});
	
	
	}(window, document));


/***/ }),
/* 616 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*
		Leaflet.draw, a plugin that adds drawing and editing tools to Leaflet powered maps.
		(c) 2012-2016, Jacob Toye, Smartrak, Leaflet
	
		https://github.com/Leaflet/Leaflet.draw
		http://leafletjs.com
	*/
	!function(t,e,i){L.drawVersion="0.3.0-dev",L.drawLocal={draw:{toolbar:{actions:{title:"Cancel drawing",text:"Cancel"},finish:{title:"Finish drawing",text:"Finish"},undo:{title:"Delete last point drawn",text:"Delete last point"},buttons:{polyline:"Draw a polyline",polygon:"Draw a polygon",rectangle:"Draw a rectangle",circle:"Draw a circle",marker:"Draw a marker"}},handlers:{circle:{tooltip:{start:"Click and drag to draw circle."},radius:"Radius"},marker:{tooltip:{start:"Click map to place marker."}},polygon:{tooltip:{start:"Click to start drawing shape.",cont:"Click to continue drawing shape.",end:"Click first point to close this shape."}},polyline:{error:"<strong>Error:</strong> shape edges cannot cross!",tooltip:{start:"Click to start drawing line.",cont:"Click to continue drawing line.",end:"Click last point to finish line."}},rectangle:{tooltip:{start:"Click and drag to draw rectangle."}},simpleshape:{tooltip:{end:"Release mouse to finish drawing."}}}},edit:{toolbar:{actions:{save:{title:"Save changes.",text:"Save"},cancel:{title:"Cancel editing, discards all changes.",text:"Cancel"}},buttons:{edit:"Edit layers.",editDisabled:"No layers to edit.",remove:"Delete layers.",removeDisabled:"No layers to delete."}},handlers:{edit:{tooltip:{text:"Drag handles, or marker to edit feature.",subtext:"Click cancel to undo changes."}},remove:{tooltip:{text:"Click on a feature to remove"}}}}},L.Draw={},L.Draw.Feature=L.Handler.extend({includes:L.Mixin.Events,initialize:function(t,e){this._map=t,this._container=t._container,this._overlayPane=t._panes.overlayPane,this._popupPane=t._panes.popupPane,e&&e.shapeOptions&&(e.shapeOptions=L.Util.extend({},this.options.shapeOptions,e.shapeOptions)),L.setOptions(this,e)},enable:function(){this._enabled||(L.Handler.prototype.enable.call(this),this.fire("enabled",{handler:this.type}),this._map.fire("draw:drawstart",{layerType:this.type}))},disable:function(){this._enabled&&(L.Handler.prototype.disable.call(this),this._map.fire("draw:drawstop",{layerType:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(L.DomUtil.disableTextSelection(),t.getContainer().focus(),this._tooltip=new L.Tooltip(this._map),L.DomEvent.on(this._container,"keyup",this._cancelDrawing,this))},removeHooks:function(){this._map&&(L.DomUtil.enableTextSelection(),this._tooltip.dispose(),this._tooltip=null,L.DomEvent.off(this._container,"keyup",this._cancelDrawing,this))},setOptions:function(t){L.setOptions(this,t)},_fireCreatedEvent:function(t){this._map.fire("draw:created",{layer:t,layerType:this.type})},_cancelDrawing:function(t){this._map.fire("draw:canceled",{layerType:this.type}),27===t.keyCode&&this.disable()}}),L.Draw.Polyline=L.Draw.Feature.extend({statics:{TYPE:"polyline"},Poly:L.Polyline,options:{allowIntersection:!0,repeatMode:!1,drawError:{color:"#b00b00",timeout:2500},icon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon"}),touchIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"}),guidelineDistance:20,maxGuideLineLength:4e3,shapeOptions:{stroke:!0,color:"#f06eaa",weight:4,opacity:.5,fill:!1,clickable:!0},metric:!0,feet:!0,showLength:!0,zIndexOffset:2e3},initialize:function(t,e){L.Browser.touch&&(this.options.icon=this.options.touchIcon),this.options.drawError.message=L.drawLocal.draw.handlers.polyline.error,e&&e.drawError&&(e.drawError=L.Util.extend({},this.options.drawError,e.drawError)),this.type=L.Draw.Polyline.TYPE,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._markers=[],this._markerGroup=new L.LayerGroup,this._map.addLayer(this._markerGroup),this._poly=new L.Polyline([],this.options.shapeOptions),this._tooltip.updateContent(this._getTooltipText()),this._mouseMarker||(this._mouseMarker=L.marker(this._map.getCenter(),{icon:L.divIcon({className:"leaflet-mouse-marker",iconAnchor:[20,20],iconSize:[40,40]}),opacity:0,zIndexOffset:this.options.zIndexOffset})),L.Browser.touch||this._map.on("mouseup",this._onMouseUp,this),this._mouseMarker.on("mousedown",this._onMouseDown,this).on("mouseout",this._onMouseOut,this).on("mouseup",this._onMouseUp,this).on("mousemove",this._onMouseMove,this).addTo(this._map),this._map.on("mouseup",this._onMouseUp,this).on("mousemove",this._onMouseMove,this).on("zoomlevelschange",this._onZoomEnd,this).on("click",this._onTouch,this).on("zoomend",this._onZoomEnd,this))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._clearHideErrorTimeout(),this._cleanUpShape(),this._map.removeLayer(this._markerGroup),delete this._markerGroup,delete this._markers,this._map.removeLayer(this._poly),delete this._poly,this._mouseMarker.off("mousedown",this._onMouseDown,this).off("mouseout",this._onMouseOut,this).off("mouseup",this._onMouseUp,this).off("mousemove",this._onMouseMove,this),this._map.removeLayer(this._mouseMarker),delete this._mouseMarker,this._clearGuides(),this._map.off("mouseup",this._onMouseUp,this).off("mousemove",this._onMouseMove,this).off("zoomlevelschange",this._onZoomEnd,this).off("zoomend",this._onZoomEnd,this).off("click",this._onTouch,this)},deleteLastVertex:function(){if(!(this._markers.length<=1)){var t=this._markers.pop(),e=this._poly,i=this._poly.spliceLatLngs(e.getLatLngs().length-1,1)[0];this._markerGroup.removeLayer(t),e.getLatLngs().length<2&&this._map.removeLayer(e),this._vertexChanged(i,!1)}},addVertex:function(t){var e=this._markers.length;return e>0&&!this.options.allowIntersection&&this._poly.newLatLngIntersects(t)?void this._showErrorTooltip():(this._errorShown&&this._hideErrorTooltip(),this._markers.push(this._createMarker(t)),this._poly.addLatLng(t),2===this._poly.getLatLngs().length&&this._map.addLayer(this._poly),void this._vertexChanged(t,!0))},completeShape:function(){this._markers.length<=1||(this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable())},_finishShape:function(){var t=this._poly.newLatLngIntersects(this._poly.getLatLngs()[this._poly.getLatLngs().length-1]);return!this.options.allowIntersection&&t||!this._shapeIsValid()?void this._showErrorTooltip():(this._fireCreatedEvent(),this.disable(),void(this.options.repeatMode&&this.enable()))},_shapeIsValid:function(){return!0},_onZoomEnd:function(){null!==this._markers&&this._updateGuide()},_onMouseMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent),i=this._map.layerPointToLatLng(e);this._currentLatLng=i,this._updateTooltip(i),this._updateGuide(e),this._mouseMarker.setLatLng(i),L.DomEvent.preventDefault(t.originalEvent)},_vertexChanged:function(t,e){this._map.fire("draw:drawvertex",{layers:this._markerGroup}),this._updateFinishHandler(),this._updateRunningMeasure(t,e),this._clearGuides(),this._updateTooltip()},_onMouseDown:function(t){var e=t.originalEvent;this._mouseDownOrigin=L.point(e.clientX,e.clientY)},_onMouseUp:function(e){if(this._mouseDownOrigin){var i=L.point(e.originalEvent.clientX,e.originalEvent.clientY).distanceTo(this._mouseDownOrigin);Math.abs(i)<9*(t.devicePixelRatio||1)&&this.addVertex(e.latlng)}this._mouseDownOrigin=null},_onTouch:function(t){L.Browser.touch&&(this._onMouseDown(t),this._onMouseUp(t))},_onMouseOut:function(){this._tooltip&&this._tooltip._onMouseOut.call(this._tooltip)},_updateFinishHandler:function(){var t=this._markers.length;t>1&&this._markers[t-1].on("click",this._finishShape,this),t>2&&this._markers[t-2].off("click",this._finishShape,this)},_createMarker:function(t){var e=new L.Marker(t,{icon:this.options.icon,zIndexOffset:2*this.options.zIndexOffset});return this._markerGroup.addLayer(e),e},_updateGuide:function(t){var e=this._markers?this._markers.length:0;e>0&&(t=t||this._map.latLngToLayerPoint(this._currentLatLng),this._clearGuides(),this._drawGuide(this._map.latLngToLayerPoint(this._markers[e-1].getLatLng()),t))},_updateTooltip:function(t){var e=this._getTooltipText();t&&this._tooltip.updatePosition(t),this._errorShown||this._tooltip.updateContent(e)},_drawGuide:function(t,e){var i,o,n,s=Math.floor(Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))),a=this.options.guidelineDistance,r=this.options.maxGuideLineLength,h=s>r?s-r:a;for(this._guidesContainer||(this._guidesContainer=L.DomUtil.create("div","leaflet-draw-guides",this._overlayPane));s>h;h+=this.options.guidelineDistance)i=h/s,o={x:Math.floor(t.x*(1-i)+i*e.x),y:Math.floor(t.y*(1-i)+i*e.y)},n=L.DomUtil.create("div","leaflet-draw-guide-dash",this._guidesContainer),n.style.backgroundColor=this._errorShown?this.options.drawError.color:this.options.shapeOptions.color,L.DomUtil.setPosition(n,o)},_updateGuideColor:function(t){if(this._guidesContainer)for(var e=0,i=this._guidesContainer.childNodes.length;i>e;e++)this._guidesContainer.childNodes[e].style.backgroundColor=t},_clearGuides:function(){if(this._guidesContainer)for(;this._guidesContainer.firstChild;)this._guidesContainer.removeChild(this._guidesContainer.firstChild)},_getTooltipText:function(){var t,e,i=this.options.showLength;return 0===this._markers.length?t={text:L.drawLocal.draw.handlers.polyline.tooltip.start}:(e=i?this._getMeasurementString():"",t=1===this._markers.length?{text:L.drawLocal.draw.handlers.polyline.tooltip.cont,subtext:e}:{text:L.drawLocal.draw.handlers.polyline.tooltip.end,subtext:e}),t},_updateRunningMeasure:function(t,e){var i,o,n=this._markers.length;1===this._markers.length?this._measurementRunningTotal=0:(i=n-(e?2:1),o=t.distanceTo(this._markers[i].getLatLng()),this._measurementRunningTotal+=o*(e?1:-1))},_getMeasurementString:function(){var t,e=this._currentLatLng,i=this._markers[this._markers.length-1].getLatLng();return t=this._measurementRunningTotal+e.distanceTo(i),L.GeometryUtil.readableDistance(t,this.options.metric,this.options.feet)},_showErrorTooltip:function(){this._errorShown=!0,this._tooltip.showAsError().updateContent({text:this.options.drawError.message}),this._updateGuideColor(this.options.drawError.color),this._poly.setStyle({color:this.options.drawError.color}),this._clearHideErrorTimeout(),this._hideErrorTimeout=setTimeout(L.Util.bind(this._hideErrorTooltip,this),this.options.drawError.timeout)},_hideErrorTooltip:function(){this._errorShown=!1,this._clearHideErrorTimeout(),this._tooltip.removeError().updateContent(this._getTooltipText()),this._updateGuideColor(this.options.shapeOptions.color),this._poly.setStyle({color:this.options.shapeOptions.color})},_clearHideErrorTimeout:function(){this._hideErrorTimeout&&(clearTimeout(this._hideErrorTimeout),this._hideErrorTimeout=null)},_cleanUpShape:function(){this._markers.length>1&&this._markers[this._markers.length-1].off("click",this._finishShape,this)},_fireCreatedEvent:function(){var t=new this.Poly(this._poly.getLatLngs(),this.options.shapeOptions);L.Draw.Feature.prototype._fireCreatedEvent.call(this,t)}}),L.Draw.Polygon=L.Draw.Polyline.extend({statics:{TYPE:"polygon"},Poly:L.Polygon,options:{showArea:!1,shapeOptions:{stroke:!0,color:"#f06eaa",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0},metric:!0},initialize:function(t,e){L.Draw.Polyline.prototype.initialize.call(this,t,e),this.type=L.Draw.Polygon.TYPE},_updateFinishHandler:function(){var t=this._markers.length;1===t&&this._markers[0].on("click",this._finishShape,this),t>2&&(this._markers[t-1].on("dblclick",this._finishShape,this),t>3&&this._markers[t-2].off("dblclick",this._finishShape,this))},_getTooltipText:function(){var t,e;return 0===this._markers.length?t=L.drawLocal.draw.handlers.polygon.tooltip.start:this._markers.length<3?t=L.drawLocal.draw.handlers.polygon.tooltip.cont:(t=L.drawLocal.draw.handlers.polygon.tooltip.end,e=this._getMeasurementString()),{text:t,subtext:e}},_getMeasurementString:function(){var t=this._area;return t?L.GeometryUtil.readableArea(t,this.options.metric):null},_shapeIsValid:function(){return this._markers.length>=3},_vertexChanged:function(t,e){var i;!this.options.allowIntersection&&this.options.showArea&&(i=this._poly.getLatLngs(),this._area=L.GeometryUtil.geodesicArea(i)),L.Draw.Polyline.prototype._vertexChanged.call(this,t,e)},_cleanUpShape:function(){var t=this._markers.length;t>0&&(this._markers[0].off("click",this._finishShape,this),t>2&&this._markers[t-1].off("dblclick",this._finishShape,this))}}),L.SimpleShape={},L.Draw.SimpleShape=L.Draw.Feature.extend({options:{repeatMode:!1},initialize:function(t,e){this._endLabelText=L.drawLocal.draw.handlers.simpleshape.tooltip.end,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._mapDraggable=this._map.dragging.enabled(),this._mapDraggable&&this._map.dragging.disable(),this._container.style.cursor="crosshair",this._tooltip.updateContent({text:this._initialLabelText}),this._map.on("mousedown",this._onMouseDown,this).on("mousemove",this._onMouseMove,this).on("touchstart",this._onMouseDown,this).on("touchmove",this._onMouseMove,this))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._map&&(this._mapDraggable&&this._map.dragging.enable(),this._container.style.cursor="",this._map.off("mousedown",this._onMouseDown,this).off("mousemove",this._onMouseMove,this).off("touchstart",this._onMouseDown,this).off("touchmove",this._onMouseMove,this),L.DomEvent.off(e,"mouseup",this._onMouseUp,this),L.DomEvent.off(e,"touchend",this._onMouseUp,this),this._shape&&(this._map.removeLayer(this._shape),delete this._shape)),this._isDrawing=!1},_getTooltipText:function(){return{text:this._endLabelText}},_onMouseDown:function(t){this._isDrawing=!0,this._startLatLng=t.latlng,L.DomEvent.on(e,"mouseup",this._onMouseUp,this).on(e,"touchend",this._onMouseUp,this).preventDefault(t.originalEvent)},_onMouseMove:function(t){var e=t.latlng;this._tooltip.updatePosition(e),this._isDrawing&&(this._tooltip.updateContent(this._getTooltipText()),this._drawShape(e))},_onMouseUp:function(){this._shape&&this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable()}}),L.Draw.Rectangle=L.Draw.SimpleShape.extend({statics:{TYPE:"rectangle"},options:{shapeOptions:{stroke:!0,color:"#f06eaa",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0},metric:!0},initialize:function(t,e){this.type=L.Draw.Rectangle.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.rectangle.tooltip.start,L.Draw.SimpleShape.prototype.initialize.call(this,t,e)},_drawShape:function(t){this._shape?this._shape.setBounds(new L.LatLngBounds(this._startLatLng,t)):(this._shape=new L.Rectangle(new L.LatLngBounds(this._startLatLng,t),this.options.shapeOptions),this._map.addLayer(this._shape))},_fireCreatedEvent:function(){var t=new L.Rectangle(this._shape.getBounds(),this.options.shapeOptions);L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this,t)},_getTooltipText:function(){var t,e,i,o=L.Draw.SimpleShape.prototype._getTooltipText.call(this),n=this._shape;return n&&(t=this._shape.getLatLngs(),e=L.GeometryUtil.geodesicArea(t),i=L.GeometryUtil.readableArea(e,this.options.metric)),{text:o.text,subtext:i}}}),L.Draw.Circle=L.Draw.SimpleShape.extend({statics:{TYPE:"circle"},options:{shapeOptions:{stroke:!0,color:"#f06eaa",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0},showRadius:!0,metric:!0,feet:!0},initialize:function(t,e){this.type=L.Draw.Circle.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.circle.tooltip.start,L.Draw.SimpleShape.prototype.initialize.call(this,t,e)},_drawShape:function(t){this._shape?this._shape.setRadius(this._startLatLng.distanceTo(t)):(this._shape=new L.Circle(this._startLatLng,this._startLatLng.distanceTo(t),this.options.shapeOptions),this._map.addLayer(this._shape))},_fireCreatedEvent:function(){var t=new L.Circle(this._startLatLng,this._shape.getRadius(),this.options.shapeOptions);L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this,t)},_onMouseMove:function(t){var e,i=t.latlng,o=this.options.showRadius,n=this.options.metric;this._tooltip.updatePosition(i),this._isDrawing&&(this._drawShape(i),e=this._shape.getRadius().toFixed(1),this._tooltip.updateContent({text:this._endLabelText,subtext:o?L.drawLocal.draw.handlers.circle.radius+": "+L.GeometryUtil.readableDistance(e,n,this.options.feet):""}))}}),L.Draw.Marker=L.Draw.Feature.extend({statics:{TYPE:"marker"},options:{icon:new L.Icon.Default,repeatMode:!1,zIndexOffset:2e3},initialize:function(t,e){this.type=L.Draw.Marker.TYPE,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._tooltip.updateContent({text:L.drawLocal.draw.handlers.marker.tooltip.start}),this._mouseMarker||(this._mouseMarker=L.marker(this._map.getCenter(),{icon:L.divIcon({className:"leaflet-mouse-marker",iconAnchor:[20,20],iconSize:[40,40]}),opacity:0,zIndexOffset:this.options.zIndexOffset})),this._mouseMarker.on("click",this._onClick,this).addTo(this._map),this._map.on("mousemove",this._onMouseMove,this),this._map.on("click",this._onTouch,this))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._map&&(this._marker&&(this._marker.off("click",this._onClick,this),this._map.off("click",this._onClick,this).off("click",this._onTouch,this).removeLayer(this._marker),delete this._marker),this._mouseMarker.off("click",this._onClick,this),this._map.removeLayer(this._mouseMarker),delete this._mouseMarker,this._map.off("mousemove",this._onMouseMove,this))},_onMouseMove:function(t){var e=t.latlng;this._tooltip.updatePosition(e),this._mouseMarker.setLatLng(e),this._marker?(e=this._mouseMarker.getLatLng(),this._marker.setLatLng(e)):(this._marker=new L.Marker(e,{icon:this.options.icon,zIndexOffset:this.options.zIndexOffset}),this._marker.on("click",this._onClick,this),this._map.on("click",this._onClick,this).addLayer(this._marker))},_onClick:function(){this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable()},_onTouch:function(t){this._onMouseMove(t),this._onClick()},_fireCreatedEvent:function(){var t=new L.Marker.Touch(this._marker.getLatLng(),{icon:this.options.icon});L.Draw.Feature.prototype._fireCreatedEvent.call(this,t)}}),L.Edit=L.Edit||{},L.Edit.Marker=L.Handler.extend({initialize:function(t,e){this._marker=t,L.setOptions(this,e)},addHooks:function(){var t=this._marker;t.dragging.enable(),t.on("dragend",this._onDragEnd,t),this._toggleMarkerHighlight()},removeHooks:function(){var t=this._marker;t.dragging.disable(),t.off("dragend",this._onDragEnd,t),this._toggleMarkerHighlight()},_onDragEnd:function(t){var e=t.target;e.edited=!0,this._map.fire("draw:editmove",{layer:e})},_toggleMarkerHighlight:function(){var t=this._marker._icon;t&&(t.style.display="none",L.DomUtil.hasClass(t,"leaflet-edit-marker-selected")?(L.DomUtil.removeClass(t,"leaflet-edit-marker-selected"),this._offsetMarker(t,-4)):(L.DomUtil.addClass(t,"leaflet-edit-marker-selected"),this._offsetMarker(t,4)),t.style.display="")},_offsetMarker:function(t,e){var i=parseInt(t.style.marginTop,10)-e,o=parseInt(t.style.marginLeft,10)-e;t.style.marginTop=i+"px",t.style.marginLeft=o+"px"}}),L.Marker.addInitHook(function(){L.Edit.Marker&&(this.editing=new L.Edit.Marker(this),this.options.editable&&this.editing.enable())}),L.Edit=L.Edit||{},L.Edit.Poly=L.Handler.extend({options:{},initialize:function(t,e){this.latlngs=[t._latlngs],t._holes&&(this.latlngs=this.latlngs.concat(t._holes)),this._poly=t,L.setOptions(this,e),this._poly.on("revert-edited",this._updateLatLngs,this)},_eachVertexHandler:function(t){for(var e=0;e<this._verticesHandlers.length;e++)t(this._verticesHandlers[e])},addHooks:function(){this._initHandlers(),this._eachVertexHandler(function(t){t.addHooks()})},removeHooks:function(){this._eachVertexHandler(function(t){t.removeHooks()})},updateMarkers:function(){this._eachVertexHandler(function(t){t.updateMarkers()})},_initHandlers:function(){this._verticesHandlers=[];for(var t=0;t<this.latlngs.length;t++)this._verticesHandlers.push(new L.Edit.PolyVerticesEdit(this._poly,this.latlngs[t],this.options))},_updateLatLngs:function(t){this.latlngs=[t.layer._latlngs],t.layer._holes&&(this.latlngs=this.latlngs.concat(t.layer._holes))}}),L.Edit.PolyVerticesEdit=L.Handler.extend({options:{icon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon"}),touchIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"}),drawError:{color:"#b00b00",timeout:1e3}},initialize:function(t,e,i){L.Browser.touch&&(this.options.icon=this.options.touchIcon),this._poly=t,i&&i.drawError&&(i.drawError=L.Util.extend({},this.options.drawError,i.drawError)),this._latlngs=e,L.setOptions(this,i)},addHooks:function(){var t=this._poly;t instanceof L.Polygon||(t.options.fill=!1),t.setStyle(t.options.editing),this._poly._map&&(this._map=this._poly._map,this._markerGroup||this._initMarkers(),this._poly._map.addLayer(this._markerGroup))},removeHooks:function(){var t=this._poly;t.setStyle(t.options.original),t._map&&(t._map.removeLayer(this._markerGroup),delete this._markerGroup,delete this._markers)},updateMarkers:function(){this._markerGroup.clearLayers(),this._initMarkers()},_initMarkers:function(){this._markerGroup||(this._markerGroup=new L.LayerGroup),this._markers=[];var t,e,i,o,n=this._latlngs;for(t=0,i=n.length;i>t;t++)o=this._createMarker(n[t],t),o.on("click",this._onMarkerClick,this),this._markers.push(o);var s,a;for(t=0,e=i-1;i>t;e=t++)(0!==t||L.Polygon&&this._poly instanceof L.Polygon)&&(s=this._markers[e],a=this._markers[t],this._createMiddleMarker(s,a),this._updatePrevNext(s,a))},_createMarker:function(t,e){var i=new L.Marker.Touch(t,{draggable:!0,icon:this.options.icon});return i._origLatLng=t,i._index=e,i.on("dragstart",this._onMarkerDragStart,this).on("drag",this._onMarkerDrag,this).on("dragend",this._fireEdit,this).on("touchmove",this._onTouchMove,this).on("MSPointerMove",this._onTouchMove,this).on("touchend",this._fireEdit,this).on("MSPointerUp",this._fireEdit,this),this._markerGroup.addLayer(i),i},_onMarkerDragStart:function(){this._poly.fire("editstart")},_spliceLatLngs:function(){var t=[].splice.apply(this._latlngs,arguments);return this._poly._convertLatLngs(this._latlngs,!0),this._poly.redraw(),t},_removeMarker:function(t){var e=t._index;this._markerGroup.removeLayer(t),this._markers.splice(e,1),this._spliceLatLngs(e,1),this._updateIndexes(e,-1),t.off("dragstart",this._onMarkerDragStart,this).off("drag",this._onMarkerDrag,this).off("dragend",this._fireEdit,this).off("touchmove",this._onMarkerDrag,this).off("touchend",this._fireEdit,this).off("click",this._onMarkerClick,this).off("MSPointerMove",this._onTouchMove,this).off("MSPointerUp",this._fireEdit,this)},_fireEdit:function(){this._poly.edited=!0,this._poly.fire("edit"),this._poly._map.fire("draw:editvertex",{layers:this._markerGroup})},_onMarkerDrag:function(t){var e=t.target,i=this._poly;if(L.extend(e._origLatLng,e._latlng),e._middleLeft&&e._middleLeft.setLatLng(this._getMiddleLatLng(e._prev,e)),e._middleRight&&e._middleRight.setLatLng(this._getMiddleLatLng(e,e._next)),i.options.poly){var o=i._map._editTooltip;if(!i.options.poly.allowIntersection&&i.intersects()){var n=i.options.color;i.setStyle({color:this.options.drawError.color}),o&&o.updateContent({text:L.drawLocal.draw.handlers.polyline.error}),setTimeout(function(){i.setStyle({color:n}),o&&o.updateContent({text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext})},1e3),this._onMarkerClick(t)}}this._poly.redraw(),this._poly.fire("editdrag")},_onMarkerClick:function(t){var e=L.Polygon&&this._poly instanceof L.Polygon?4:3,i=t.target;this._latlngs.length<e||(this._removeMarker(i),this._updatePrevNext(i._prev,i._next),i._middleLeft&&this._markerGroup.removeLayer(i._middleLeft),i._middleRight&&this._markerGroup.removeLayer(i._middleRight),i._prev&&i._next?this._createMiddleMarker(i._prev,i._next):i._prev?i._next||(i._prev._middleRight=null):i._next._middleLeft=null,this._fireEdit())},_onTouchMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]),i=this._map.layerPointToLatLng(e),o=t.target;L.extend(o._origLatLng,i),o._middleLeft&&o._middleLeft.setLatLng(this._getMiddleLatLng(o._prev,o)),o._middleRight&&o._middleRight.setLatLng(this._getMiddleLatLng(o,o._next)),this._poly.redraw(),this.updateMarkers()},_updateIndexes:function(t,e){this._markerGroup.eachLayer(function(i){i._index>t&&(i._index+=e)})},_createMiddleMarker:function(t,e){var i,o,n,s=this._getMiddleLatLng(t,e),a=this._createMarker(s);a.setOpacity(.6),t._middleRight=e._middleLeft=a,o=function(){a.off("touchmove",o,this);var n=e._index;a._index=n,a.off("click",i,this).on("click",this._onMarkerClick,this),s.lat=a.getLatLng().lat,s.lng=a.getLatLng().lng,this._spliceLatLngs(n,0,s),this._markers.splice(n,0,a),a.setOpacity(1),this._updateIndexes(n,1),e._index++,this._updatePrevNext(t,a),this._updatePrevNext(a,e),this._poly.fire("editstart")},n=function(){a.off("dragstart",o,this),a.off("dragend",n,this),a.off("touchmove",o,this),this._createMiddleMarker(t,a),this._createMiddleMarker(a,e)},i=function(){o.call(this),n.call(this),this._fireEdit()},a.on("click",i,this).on("dragstart",o,this).on("dragend",n,this).on("touchmove",o,this),this._markerGroup.addLayer(a)},_updatePrevNext:function(t,e){t&&(t._next=e),e&&(e._prev=t)},_getMiddleLatLng:function(t,e){var i=this._poly._map,o=i.project(t.getLatLng()),n=i.project(e.getLatLng());return i.unproject(o._add(n)._divideBy(2))}}),L.Polyline.addInitHook(function(){this.editing||(L.Edit.Poly&&(this.editing=new L.Edit.Poly(this,this.options.poly),this.options.editable&&this.editing.enable()),this.on("add",function(){this.editing&&this.editing.enabled()&&this.editing.addHooks()}),this.on("remove",function(){this.editing&&this.editing.enabled()&&this.editing.removeHooks()}))}),L.Edit=L.Edit||{},L.Edit.SimpleShape=L.Handler.extend({options:{moveIcon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-move"}),resizeIcon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-resize"}),touchMoveIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-move leaflet-touch-icon"}),touchResizeIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-resize leaflet-touch-icon"})},initialize:function(t,e){L.Browser.touch&&(this.options.moveIcon=this.options.touchMoveIcon,this.options.resizeIcon=this.options.touchResizeIcon),this._shape=t,L.Util.setOptions(this,e)},addHooks:function(){var t=this._shape;this._shape._map&&(this._map=this._shape._map,t.setStyle(t.options.editing),t._map&&(this._map=t._map,this._markerGroup||this._initMarkers(),this._map.addLayer(this._markerGroup)))},removeHooks:function(){var t=this._shape;if(t.setStyle(t.options.original),t._map){this._unbindMarker(this._moveMarker);for(var e=0,i=this._resizeMarkers.length;i>e;e++)this._unbindMarker(this._resizeMarkers[e]);this._resizeMarkers=null,this._map.removeLayer(this._markerGroup),delete this._markerGroup}this._map=null},updateMarkers:function(){this._markerGroup.clearLayers(),this._initMarkers()},_initMarkers:function(){this._markerGroup||(this._markerGroup=new L.LayerGroup),this._createMoveMarker(),this._createResizeMarker()},_createMoveMarker:function(){},_createResizeMarker:function(){},_createMarker:function(t,e){var i=new L.Marker.Touch(t,{draggable:!0,icon:e,zIndexOffset:10});return this._bindMarker(i),this._markerGroup.addLayer(i),i},_bindMarker:function(t){t.on("dragstart",this._onMarkerDragStart,this).on("drag",this._onMarkerDrag,this).on("dragend",this._onMarkerDragEnd,this).on("touchstart",this._onTouchStart,this).on("touchmove",this._onTouchMove,this).on("MSPointerMove",this._onTouchMove,this).on("touchend",this._onTouchEnd,this).on("MSPointerUp",this._onTouchEnd,this)},_unbindMarker:function(t){t.off("dragstart",this._onMarkerDragStart,this).off("drag",this._onMarkerDrag,this).off("dragend",this._onMarkerDragEnd,this).off("touchstart",this._onTouchStart,this).off("touchmove",this._onTouchMove,this).off("MSPointerMove",this._onTouchMove,this).off("touchend",this._onTouchEnd,this).off("MSPointerUp",this._onTouchEnd,this)},_onMarkerDragStart:function(t){var e=t.target;e.setOpacity(0),this._shape.fire("editstart")},_fireEdit:function(){this._shape.edited=!0,this._shape.fire("edit")},_onMarkerDrag:function(t){var e=t.target,i=e.getLatLng();e===this._moveMarker?this._move(i):this._resize(i),this._shape.redraw(),this._shape.fire("editdrag")},_onMarkerDragEnd:function(t){var e=t.target;e.setOpacity(1),this._fireEdit()},_onTouchStart:function(t){if(L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this,t),"function"==typeof this._getCorners){var e=this._getCorners(),i=t.target,o=i._cornerIndex;i.setOpacity(0),this._oppositeCorner=e[(o+2)%4],this._toggleCornerMarkers(0,o)}this._shape.fire("editstart")},_onTouchMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]),i=this._map.layerPointToLatLng(e),o=t.target;return o===this._moveMarker?this._move(i):this._resize(i),this._shape.redraw(),!1},_onTouchEnd:function(t){var e=t.target;e.setOpacity(1),this.updateMarkers(),this._fireEdit()},_move:function(){},_resize:function(){}}),L.Edit=L.Edit||{},L.Edit.Rectangle=L.Edit.SimpleShape.extend({_createMoveMarker:function(){var t=this._shape.getBounds(),e=t.getCenter();this._moveMarker=this._createMarker(e,this.options.moveIcon)},_createResizeMarker:function(){var t=this._getCorners();this._resizeMarkers=[];for(var e=0,i=t.length;i>e;e++)this._resizeMarkers.push(this._createMarker(t[e],this.options.resizeIcon)),this._resizeMarkers[e]._cornerIndex=e},_onMarkerDragStart:function(t){L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this,t);var e=this._getCorners(),i=t.target,o=i._cornerIndex;this._oppositeCorner=e[(o+2)%4],this._toggleCornerMarkers(0,o)},_onMarkerDragEnd:function(t){var e,i,o=t.target;o===this._moveMarker&&(e=this._shape.getBounds(),i=e.getCenter(),o.setLatLng(i)),this._toggleCornerMarkers(1),this._repositionCornerMarkers(),L.Edit.SimpleShape.prototype._onMarkerDragEnd.call(this,t)},_move:function(t){for(var e,i=this._shape.getLatLngs(),o=this._shape.getBounds(),n=o.getCenter(),s=[],a=0,r=i.length;r>a;a++)e=[i[a].lat-n.lat,i[a].lng-n.lng],s.push([t.lat+e[0],t.lng+e[1]]);this._shape.setLatLngs(s),this._repositionCornerMarkers(),this._map.fire("draw:editmove",{layer:this._shape})},_resize:function(t){var e;this._shape.setBounds(L.latLngBounds(t,this._oppositeCorner)),e=this._shape.getBounds(),this._moveMarker.setLatLng(e.getCenter()),this._map.fire("draw:editresize",{layer:this._shape})},_getCorners:function(){var t=this._shape.getBounds(),e=t.getNorthWest(),i=t.getNorthEast(),o=t.getSouthEast(),n=t.getSouthWest();return[e,i,o,n]},_toggleCornerMarkers:function(t){for(var e=0,i=this._resizeMarkers.length;i>e;e++)this._resizeMarkers[e].setOpacity(t)},_repositionCornerMarkers:function(){for(var t=this._getCorners(),e=0,i=this._resizeMarkers.length;i>e;e++)this._resizeMarkers[e].setLatLng(t[e])}}),L.Rectangle.addInitHook(function(){L.Edit.Rectangle&&(this.editing=new L.Edit.Rectangle(this),this.options.editable&&this.editing.enable())}),L.Edit=L.Edit||{},L.Edit.Circle=L.Edit.SimpleShape.extend({_createMoveMarker:function(){var t=this._shape.getLatLng();this._moveMarker=this._createMarker(t,this.options.moveIcon)},_createResizeMarker:function(){var t=this._shape.getLatLng(),e=this._getResizeMarkerPoint(t);this._resizeMarkers=[],this._resizeMarkers.push(this._createMarker(e,this.options.resizeIcon))},_getResizeMarkerPoint:function(t){var e=this._shape._radius*Math.cos(Math.PI/4),i=this._map.project(t);return this._map.unproject([i.x+e,i.y-e])},_move:function(t){var e=this._getResizeMarkerPoint(t);this._resizeMarkers[0].setLatLng(e),this._shape.setLatLng(t),this._map.fire("draw:editmove",{layer:this._shape})},_resize:function(t){
	var e=this._moveMarker.getLatLng(),i=e.distanceTo(t);this._shape.setRadius(i),this._map.fire("draw:editresize",{layer:this._shape})}}),L.Circle.addInitHook(function(){L.Edit.Circle&&(this.editing=new L.Edit.Circle(this),this.options.editable&&this.editing.enable()),this.on("add",function(){this.editing&&this.editing.enabled()&&this.editing.addHooks()}),this.on("remove",function(){this.editing&&this.editing.enabled()&&this.editing.removeHooks()})}),L.Map.mergeOptions({touchExtend:!0}),L.Map.TouchExtend=L.Handler.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane},addHooks:function(){L.DomEvent.on(this._container,"touchstart",this._onTouchStart,this),L.DomEvent.on(this._container,"touchend",this._onTouchEnd,this),L.DomEvent.on(this._container,"touchmove",this._onTouchMove,this),this._detectIE()?(L.DomEvent.on(this._container,"MSPointerDown",this._onTouchStart,this),L.DomEvent.on(this._container,"MSPointerUp",this._onTouchEnd,this),L.DomEvent.on(this._container,"MSPointerMove",this._onTouchMove,this),L.DomEvent.on(this._container,"MSPointerCancel",this._onTouchCancel,this)):(L.DomEvent.on(this._container,"touchcancel",this._onTouchCancel,this),L.DomEvent.on(this._container,"touchleave",this._onTouchLeave,this))},removeHooks:function(){L.DomEvent.off(this._container,"touchstart",this._onTouchStart),L.DomEvent.off(this._container,"touchend",this._onTouchEnd),L.DomEvent.off(this._container,"touchmove",this._onTouchMove),this._detectIE()?(L.DomEvent.off(this._container,"MSPointerDowm",this._onTouchStart),L.DomEvent.off(this._container,"MSPointerUp",this._onTouchEnd),L.DomEvent.off(this._container,"MSPointerMove",this._onTouchMove),L.DomEvent.off(this._container,"MSPointerCancel",this._onTouchCancel)):(L.DomEvent.off(this._container,"touchcancel",this._onTouchCancel),L.DomEvent.off(this._container,"touchleave",this._onTouchLeave))},_touchEvent:function(t,e){var i={};if("undefined"!=typeof t.touches){if(!t.touches.length)return;i=t.touches[0]}else{if("touch"!==t.pointerType)return;if(i=t,!this._filterClick(t))return}var o=this._map.mouseEventToContainerPoint(i),n=this._map.mouseEventToLayerPoint(i),s=this._map.layerPointToLatLng(n);this._map.fire(e,{latlng:s,layerPoint:n,containerPoint:o,pageX:i.pageX,pageY:i.pageY,originalEvent:t})},_filterClick:function(t){var e=t.timeStamp||t.originalEvent.timeStamp,i=L.DomEvent._lastClick&&e-L.DomEvent._lastClick;return i&&i>100&&500>i||t.target._simulatedClick&&!t._simulated?(L.DomEvent.stop(t),!1):(L.DomEvent._lastClick=e,!0)},_onTouchStart:function(t){if(this._map._loaded){var e="touchstart";this._touchEvent(t,e)}},_onTouchEnd:function(t){if(this._map._loaded){var e="touchend";this._touchEvent(t,e)}},_onTouchCancel:function(t){if(this._map._loaded){var e="touchcancel";this._detectIE()&&(e="pointercancel"),this._touchEvent(t,e)}},_onTouchLeave:function(t){if(this._map._loaded){var e="touchleave";this._touchEvent(t,e)}},_onTouchMove:function(t){if(this._map._loaded){var e="touchmove";this._touchEvent(t,e)}},_detectIE:function(){var e=t.navigator.userAgent,i=e.indexOf("MSIE ");if(i>0)return parseInt(e.substring(i+5,e.indexOf(".",i)),10);var o=e.indexOf("Trident/");if(o>0){var n=e.indexOf("rv:");return parseInt(e.substring(n+3,e.indexOf(".",n)),10)}var s=e.indexOf("Edge/");return s>0?parseInt(e.substring(s+5,e.indexOf(".",s)),10):!1}}),L.Map.addInitHook("addHandler","touchExtend",L.Map.TouchExtend),L.Marker.Touch=L.Marker.extend({_initInteraction:function(){if(this.options.clickable){var t=this._icon,e=["dblclick","mousedown","mouseover","mouseout","contextmenu","touchstart","touchend","touchmove"];this._detectIE?e.concat(["MSPointerDown","MSPointerUp","MSPointerMove","MSPointerCancel"]):e.concat(["touchcancel"]),L.DomUtil.addClass(t,"leaflet-clickable"),L.DomEvent.on(t,"click",this._onMouseClick,this),L.DomEvent.on(t,"keypress",this._onKeyPress,this);for(var i=0;i<e.length;i++)L.DomEvent.on(t,e[i],this._fireMouseEvent,this);L.Handler.MarkerDrag&&(this.dragging=new L.Handler.MarkerDrag(this),this.options.draggable&&this.dragging.enable())}},_detectIE:function(){var e=t.navigator.userAgent,i=e.indexOf("MSIE ");if(i>0)return parseInt(e.substring(i+5,e.indexOf(".",i)),10);var o=e.indexOf("Trident/");if(o>0){var n=e.indexOf("rv:");return parseInt(e.substring(n+3,e.indexOf(".",n)),10)}var s=e.indexOf("Edge/");return s>0?parseInt(e.substring(s+5,e.indexOf(".",s)),10):!1}}),L.LatLngUtil={cloneLatLngs:function(t){for(var e=[],i=0,o=t.length;o>i;i++)e.push(this.cloneLatLng(t[i]));return e},cloneLatLng:function(t){return L.latLng(t.lat,t.lng)}},L.GeometryUtil=L.extend(L.GeometryUtil||{},{geodesicArea:function(t){var e,i,o=t.length,n=0,s=L.LatLng.DEG_TO_RAD;if(o>2){for(var a=0;o>a;a++)e=t[a],i=t[(a+1)%o],n+=(i.lng-e.lng)*s*(2+Math.sin(e.lat*s)+Math.sin(i.lat*s));n=6378137*n*6378137/2}return Math.abs(n)},readableArea:function(t,e){var i;return e?i=t>=1e4?(1e-4*t).toFixed(2)+" ha":t.toFixed(2)+" m&sup2;":(t/=.836127,i=t>=3097600?(t/3097600).toFixed(2)+" mi&sup2;":t>=4840?(t/4840).toFixed(2)+" acres":Math.ceil(t)+" yd&sup2;"),i},readableDistance:function(t,e,i){var o;if(e)o=t>1e3?(t/1e3).toFixed(2)+" km":Math.ceil(t)+" m";else if(t*=1.09361,t>1760)o=(t/1760).toFixed(2)+" miles";else{var n=" yd";i&&(t=3*t,n=" ft"),o=Math.ceil(t)+n}return o}}),L.Util.extend(L.LineUtil,{segmentsIntersect:function(t,e,i,o){return this._checkCounterclockwise(t,i,o)!==this._checkCounterclockwise(e,i,o)&&this._checkCounterclockwise(t,e,i)!==this._checkCounterclockwise(t,e,o)},_checkCounterclockwise:function(t,e,i){return(i.y-t.y)*(e.x-t.x)>(e.y-t.y)*(i.x-t.x)}}),L.Polyline.include({intersects:function(){var t,e,i,o=this._originalPoints,n=o?o.length:0;if(this._tooFewPointsForIntersection())return!1;for(t=n-1;t>=3;t--)if(e=o[t-1],i=o[t],this._lineSegmentsIntersectsRange(e,i,t-2))return!0;return!1},newLatLngIntersects:function(t,e){return this._map?this.newPointIntersects(this._map.latLngToLayerPoint(t),e):!1},newPointIntersects:function(t,e){var i=this._originalPoints,o=i?i.length:0,n=i?i[o-1]:null,s=o-2;return this._tooFewPointsForIntersection(1)?!1:this._lineSegmentsIntersectsRange(n,t,s,e?1:0)},_tooFewPointsForIntersection:function(t){var e=this._originalPoints,i=e?e.length:0;return i+=t||0,!this._originalPoints||3>=i},_lineSegmentsIntersectsRange:function(t,e,i,o){var n,s,a=this._originalPoints;o=o||0;for(var r=i;r>o;r--)if(n=a[r-1],s=a[r],L.LineUtil.segmentsIntersect(t,e,n,s))return!0;return!1}}),L.Polygon.include({intersects:function(){var t,e,i,o,n,s=this._originalPoints;return this._tooFewPointsForIntersection()?!1:(t=L.Polyline.prototype.intersects.call(this))?!0:(e=s.length,i=s[0],o=s[e-1],n=e-2,this._lineSegmentsIntersectsRange(o,i,n,1))}}),L.Control.Draw=L.Control.extend({options:{position:"topleft",draw:{},edit:!1},initialize:function(t){if(L.version<"0.7")throw new Error("Leaflet.draw 0.2.3+ requires Leaflet 0.7.0+. Download latest from https://github.com/Leaflet/Leaflet/");L.Control.prototype.initialize.call(this,t);var e;this._toolbars={},L.DrawToolbar&&this.options.draw&&(e=new L.DrawToolbar(this.options.draw),this._toolbars[L.DrawToolbar.TYPE]=e,this._toolbars[L.DrawToolbar.TYPE].on("enable",this._toolbarEnabled,this)),L.EditToolbar&&this.options.edit&&(e=new L.EditToolbar(this.options.edit),this._toolbars[L.EditToolbar.TYPE]=e,this._toolbars[L.EditToolbar.TYPE].on("enable",this._toolbarEnabled,this)),L.toolbar=this},onAdd:function(t){var e,i=L.DomUtil.create("div","leaflet-draw"),o=!1,n="leaflet-draw-toolbar-top";for(var s in this._toolbars)this._toolbars.hasOwnProperty(s)&&(e=this._toolbars[s].addToolbar(t),e&&(o||(L.DomUtil.hasClass(e,n)||L.DomUtil.addClass(e.childNodes[0],n),o=!0),i.appendChild(e)));return i},onRemove:function(){for(var t in this._toolbars)this._toolbars.hasOwnProperty(t)&&this._toolbars[t].removeToolbar()},setDrawingOptions:function(t){for(var e in this._toolbars)this._toolbars[e]instanceof L.DrawToolbar&&this._toolbars[e].setOptions(t)},_toolbarEnabled:function(t){var e=t.target;for(var i in this._toolbars)this._toolbars[i]!==e&&this._toolbars[i].disable()}}),L.Map.mergeOptions({drawControlTooltips:!0,drawControl:!1}),L.Map.addInitHook(function(){this.options.drawControl&&(this.drawControl=new L.Control.Draw,this.addControl(this.drawControl))}),L.Toolbar=L.Class.extend({includes:[L.Mixin.Events],initialize:function(t){L.setOptions(this,t),this._modes={},this._actionButtons=[],this._activeMode=null},enabled:function(){return null!==this._activeMode},disable:function(){this.enabled()&&this._activeMode.handler.disable()},addToolbar:function(t){var e,i=L.DomUtil.create("div","leaflet-draw-section"),o=0,n=this._toolbarClass||"",s=this.getModeHandlers(t);for(this._toolbarContainer=L.DomUtil.create("div","leaflet-draw-toolbar leaflet-bar"),this._map=t,e=0;e<s.length;e++)s[e].enabled&&this._initModeHandler(s[e].handler,this._toolbarContainer,o++,n,s[e].title);return o?(this._lastButtonIndex=--o,this._actionsContainer=L.DomUtil.create("ul","leaflet-draw-actions"),i.appendChild(this._toolbarContainer),i.appendChild(this._actionsContainer),i):void 0},removeToolbar:function(){for(var t in this._modes)this._modes.hasOwnProperty(t)&&(this._disposeButton(this._modes[t].button,this._modes[t].handler.enable,this._modes[t].handler),this._modes[t].handler.disable(),this._modes[t].handler.off("enabled",this._handlerActivated,this).off("disabled",this._handlerDeactivated,this));this._modes={};for(var e=0,i=this._actionButtons.length;i>e;e++)this._disposeButton(this._actionButtons[e].button,this._actionButtons[e].callback,this);this._actionButtons=[],this._actionsContainer=null},_initModeHandler:function(t,e,i,o,n){var s=t.type;this._modes[s]={},this._modes[s].handler=t,this._modes[s].button=this._createButton({type:s,title:n,className:o+"-"+s,container:e,callback:this._modes[s].handler.enable,context:this._modes[s].handler}),this._modes[s].buttonIndex=i,this._modes[s].handler.on("enabled",this._handlerActivated,this).on("disabled",this._handlerDeactivated,this)},_createButton:function(t){var e=L.DomUtil.create("a",t.className||"",t.container);return e.href="#",t.text&&(e.innerHTML=t.text),t.title&&(e.title=t.title),L.DomEvent.on(e,"click",L.DomEvent.stopPropagation).on(e,"mousedown",L.DomEvent.stopPropagation).on(e,"dblclick",L.DomEvent.stopPropagation).on(e,"click",L.DomEvent.preventDefault).on(e,"click",t.callback,t.context),e},_disposeButton:function(t,e){L.DomEvent.off(t,"click",L.DomEvent.stopPropagation).off(t,"mousedown",L.DomEvent.stopPropagation).off(t,"dblclick",L.DomEvent.stopPropagation).off(t,"click",L.DomEvent.preventDefault).off(t,"click",e)},_handlerActivated:function(t){this.disable(),this._activeMode=this._modes[t.handler],L.DomUtil.addClass(this._activeMode.button,"leaflet-draw-toolbar-button-enabled"),this._showActionsToolbar(),this.fire("enable")},_handlerDeactivated:function(){this._hideActionsToolbar(),L.DomUtil.removeClass(this._activeMode.button,"leaflet-draw-toolbar-button-enabled"),this._activeMode=null,this.fire("disable")},_createActions:function(t){var e,i,o,n,s=this._actionsContainer,a=this.getActions(t),r=a.length;for(i=0,o=this._actionButtons.length;o>i;i++)this._disposeButton(this._actionButtons[i].button,this._actionButtons[i].callback);for(this._actionButtons=[];s.firstChild;)s.removeChild(s.firstChild);for(var h=0;r>h;h++)"enabled"in a[h]&&!a[h].enabled||(e=L.DomUtil.create("li","",s),n=this._createButton({title:a[h].title,text:a[h].text,container:e,callback:a[h].callback,context:a[h].context}),this._actionButtons.push({button:n,callback:a[h].callback}))},_showActionsToolbar:function(){var t=this._activeMode.buttonIndex,e=this._lastButtonIndex,i=this._activeMode.button.offsetTop-1;this._createActions(this._activeMode.handler),this._actionsContainer.style.top=i+"px",0===t&&(L.DomUtil.addClass(this._toolbarContainer,"leaflet-draw-toolbar-notop"),L.DomUtil.addClass(this._actionsContainer,"leaflet-draw-actions-top")),t===e&&(L.DomUtil.addClass(this._toolbarContainer,"leaflet-draw-toolbar-nobottom"),L.DomUtil.addClass(this._actionsContainer,"leaflet-draw-actions-bottom")),this._actionsContainer.style.display="block"},_hideActionsToolbar:function(){this._actionsContainer.style.display="none",L.DomUtil.removeClass(this._toolbarContainer,"leaflet-draw-toolbar-notop"),L.DomUtil.removeClass(this._toolbarContainer,"leaflet-draw-toolbar-nobottom"),L.DomUtil.removeClass(this._actionsContainer,"leaflet-draw-actions-top"),L.DomUtil.removeClass(this._actionsContainer,"leaflet-draw-actions-bottom")}}),L.Tooltip=L.Class.extend({initialize:function(t){this._map=t,this._popupPane=t._panes.popupPane,this._container=t.options.drawControlTooltips?L.DomUtil.create("div","leaflet-draw-tooltip",this._popupPane):null,this._singleLineLabel=!1,this._map.on("mouseout",this._onMouseOut,this)},dispose:function(){this._map.off("mouseout",this._onMouseOut,this),this._container&&(this._popupPane.removeChild(this._container),this._container=null)},updateContent:function(t){return this._container?(t.subtext=t.subtext||"",0!==t.subtext.length||this._singleLineLabel?t.subtext.length>0&&this._singleLineLabel&&(L.DomUtil.removeClass(this._container,"leaflet-draw-tooltip-single"),this._singleLineLabel=!1):(L.DomUtil.addClass(this._container,"leaflet-draw-tooltip-single"),this._singleLineLabel=!0),this._container.innerHTML=(t.subtext.length>0?'<span class="leaflet-draw-tooltip-subtext">'+t.subtext+"</span><br />":"")+"<span>"+t.text+"</span>",this):this},updatePosition:function(t){var e=this._map.latLngToLayerPoint(t),i=this._container;return this._container&&(i.style.visibility="inherit",L.DomUtil.setPosition(i,e)),this},showAsError:function(){return this._container&&L.DomUtil.addClass(this._container,"leaflet-error-draw-tooltip"),this},removeError:function(){return this._container&&L.DomUtil.removeClass(this._container,"leaflet-error-draw-tooltip"),this},_onMouseOut:function(){this._container&&(this._container.style.visibility="hidden")}}),L.DrawToolbar=L.Toolbar.extend({statics:{TYPE:"draw"},options:{polyline:{},polygon:{},rectangle:{},circle:{},marker:{}},initialize:function(t){for(var e in this.options)this.options.hasOwnProperty(e)&&t[e]&&(t[e]=L.extend({},this.options[e],t[e]));this._toolbarClass="leaflet-draw-draw",L.Toolbar.prototype.initialize.call(this,t)},getModeHandlers:function(t){return[{enabled:this.options.polyline,handler:new L.Draw.Polyline(t,this.options.polyline),title:L.drawLocal.draw.toolbar.buttons.polyline},{enabled:this.options.polygon,handler:new L.Draw.Polygon(t,this.options.polygon),title:L.drawLocal.draw.toolbar.buttons.polygon},{enabled:this.options.rectangle,handler:new L.Draw.Rectangle(t,this.options.rectangle),title:L.drawLocal.draw.toolbar.buttons.rectangle},{enabled:this.options.circle,handler:new L.Draw.Circle(t,this.options.circle),title:L.drawLocal.draw.toolbar.buttons.circle},{enabled:this.options.marker,handler:new L.Draw.Marker(t,this.options.marker),title:L.drawLocal.draw.toolbar.buttons.marker}]},getActions:function(t){return[{enabled:t.completeShape,title:L.drawLocal.draw.toolbar.finish.title,text:L.drawLocal.draw.toolbar.finish.text,callback:t.completeShape,context:t},{enabled:t.deleteLastVertex,title:L.drawLocal.draw.toolbar.undo.title,text:L.drawLocal.draw.toolbar.undo.text,callback:t.deleteLastVertex,context:t},{title:L.drawLocal.draw.toolbar.actions.title,text:L.drawLocal.draw.toolbar.actions.text,callback:this.disable,context:this}]},setOptions:function(t){L.setOptions(this,t);for(var e in this._modes)this._modes.hasOwnProperty(e)&&t.hasOwnProperty(e)&&this._modes[e].handler.setOptions(t[e])}}),L.EditToolbar=L.Toolbar.extend({statics:{TYPE:"edit"},options:{edit:{selectedPathOptions:{dashArray:"10, 10",fill:!0,fillColor:"#fe57a1",fillOpacity:.1,maintainColor:!1}},remove:{},poly:null,featureGroup:null},initialize:function(t){t.edit&&("undefined"==typeof t.edit.selectedPathOptions&&(t.edit.selectedPathOptions=this.options.edit.selectedPathOptions),t.edit.selectedPathOptions=L.extend({},this.options.edit.selectedPathOptions,t.edit.selectedPathOptions)),t.remove&&(t.remove=L.extend({},this.options.remove,t.remove)),t.poly&&(t.poly=L.extend({},this.options.poly,t.poly)),this._toolbarClass="leaflet-draw-edit",L.Toolbar.prototype.initialize.call(this,t),this._selectedFeatureCount=0},getModeHandlers:function(t){var e=this.options.featureGroup;return[{enabled:this.options.edit,handler:new L.EditToolbar.Edit(t,{featureGroup:e,selectedPathOptions:this.options.edit.selectedPathOptions,poly:this.options.poly}),title:L.drawLocal.edit.toolbar.buttons.edit},{enabled:this.options.remove,handler:new L.EditToolbar.Delete(t,{featureGroup:e}),title:L.drawLocal.edit.toolbar.buttons.remove}]},getActions:function(){return[{title:L.drawLocal.edit.toolbar.actions.save.title,text:L.drawLocal.edit.toolbar.actions.save.text,callback:this._save,context:this},{title:L.drawLocal.edit.toolbar.actions.cancel.title,text:L.drawLocal.edit.toolbar.actions.cancel.text,callback:this.disable,context:this}]},addToolbar:function(t){var e=L.Toolbar.prototype.addToolbar.call(this,t);return this._checkDisabled(),this.options.featureGroup.on("layeradd layerremove",this._checkDisabled,this),e},removeToolbar:function(){this.options.featureGroup.off("layeradd layerremove",this._checkDisabled,this),L.Toolbar.prototype.removeToolbar.call(this)},disable:function(){this.enabled()&&(this._activeMode.handler.revertLayers(),L.Toolbar.prototype.disable.call(this))},_save:function(){this._activeMode.handler.save(),this._activeMode&&this._activeMode.handler.disable()},_checkDisabled:function(){var t,e=this.options.featureGroup,i=0!==e.getLayers().length;this.options.edit&&(t=this._modes[L.EditToolbar.Edit.TYPE].button,i?L.DomUtil.removeClass(t,"leaflet-disabled"):L.DomUtil.addClass(t,"leaflet-disabled"),t.setAttribute("title",i?L.drawLocal.edit.toolbar.buttons.edit:L.drawLocal.edit.toolbar.buttons.editDisabled)),this.options.remove&&(t=this._modes[L.EditToolbar.Delete.TYPE].button,i?L.DomUtil.removeClass(t,"leaflet-disabled"):L.DomUtil.addClass(t,"leaflet-disabled"),t.setAttribute("title",i?L.drawLocal.edit.toolbar.buttons.remove:L.drawLocal.edit.toolbar.buttons.removeDisabled))}}),L.EditToolbar.Edit=L.Handler.extend({statics:{TYPE:"edit"},includes:L.Mixin.Events,initialize:function(t,e){if(L.Handler.prototype.initialize.call(this,t),L.setOptions(this,e),this._featureGroup=e.featureGroup,!(this._featureGroup instanceof L.FeatureGroup))throw new Error("options.featureGroup must be a L.FeatureGroup");this._uneditedLayerProps={},this.type=L.EditToolbar.Edit.TYPE},enable:function(){!this._enabled&&this._hasAvailableLayers()&&(this.fire("enabled",{handler:this.type}),this._map.fire("draw:editstart",{handler:this.type}),L.Handler.prototype.enable.call(this),this._featureGroup.on("layeradd",this._enableLayerEdit,this).on("layerremove",this._disableLayerEdit,this))},disable:function(){this._enabled&&(this._featureGroup.off("layeradd",this._enableLayerEdit,this).off("layerremove",this._disableLayerEdit,this),L.Handler.prototype.disable.call(this),this._map.fire("draw:editstop",{handler:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(t.getContainer().focus(),this._featureGroup.eachLayer(this._enableLayerEdit,this),this._tooltip=new L.Tooltip(this._map),this._tooltip.updateContent({text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext}),t._editTooltip=this._tooltip,this._updateTooltip(),this._map.on("mousemove",this._onMouseMove,this).on("touchmove",this._onMouseMove,this).on("MSPointerMove",this._onMouseMove,this).on("click",this._editStyle,this).on("draw:editvertex",this._updateTooltip,this))},removeHooks:function(){this._map&&(this._featureGroup.eachLayer(this._disableLayerEdit,this),this._uneditedLayerProps={},this._tooltip.dispose(),this._tooltip=null,this._map.off("mousemove",this._onMouseMove,this).off("touchmove",this._onMouseMove,this).off("MSPointerMove",this._onMouseMove,this).off("click",this._editStyle,this).off("draw:editvertex",this._updateTooltip,this))},revertLayers:function(){this._featureGroup.eachLayer(function(t){this._revertLayer(t)},this)},save:function(){var t=new L.LayerGroup;this._featureGroup.eachLayer(function(e){e.edited&&(t.addLayer(e),e.edited=!1)}),this._map.fire("draw:edited",{layers:t})},_backupLayer:function(t){var e=L.Util.stamp(t);this._uneditedLayerProps[e]||(t instanceof L.Polyline||t instanceof L.Polygon||t instanceof L.Rectangle?this._uneditedLayerProps[e]={latlngs:L.LatLngUtil.cloneLatLngs(t.getLatLngs())}:t instanceof L.Circle?this._uneditedLayerProps[e]={latlng:L.LatLngUtil.cloneLatLng(t.getLatLng()),radius:t.getRadius()}:t instanceof L.Marker&&(this._uneditedLayerProps[e]={latlng:L.LatLngUtil.cloneLatLng(t.getLatLng())}))},_getTooltipText:function(){return{text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext}},_updateTooltip:function(){this._tooltip.updateContent(this._getTooltipText())},_revertLayer:function(t){var e=L.Util.stamp(t);t.edited=!1,this._uneditedLayerProps.hasOwnProperty(e)&&(t instanceof L.Polyline||t instanceof L.Polygon||t instanceof L.Rectangle?t.setLatLngs(this._uneditedLayerProps[e].latlngs):t instanceof L.Circle?(t.setLatLng(this._uneditedLayerProps[e].latlng),t.setRadius(this._uneditedLayerProps[e].radius)):t instanceof L.Marker&&t.setLatLng(this._uneditedLayerProps[e].latlng),t.fire("revert-edited",{layer:t}))},_enableLayerEdit:function(t){var e,i,o=t.layer||t.target||t;this._backupLayer(o),this.options.poly&&(i=L.Util.extend({},this.options.poly),o.options.poly=i),this.options.selectedPathOptions&&(e=L.Util.extend({},this.options.selectedPathOptions),e.maintainColor&&(e.color=o.options.color,e.fillColor=o.options.fillColor),o.options.original=L.extend({},o.options),o.options.editing=e),this.isMarker?(o.dragging.enable(),o.on("dragend",this._onMarkerDragEnd).on("touchmove",this._onTouchMove,this).on("MSPointerMove",this._onTouchMove,this).on("touchend",this._onMarkerDragEnd,this).on("MSPointerUp",this._onMarkerDragEnd,this)):o.editing.enable()},_disableLayerEdit:function(t){var e=t.layer||t.target||t;e.edited=!1,e.editing.disable(),delete e.options.editing,delete e.options.original,this._selectedPathOptions&&(e instanceof L.Marker?this._toggleMarkerHighlight(e):(e.setStyle(e.options.previousOptions),delete e.options.previousOptions)),e instanceof L.Marker?(e.dragging.disable(),e.off("dragend",this._onMarkerDragEnd,this).off("touchmove",this._onTouchMove,this).off("MSPointerMove",this._onTouchMove,this).off("touchend",this._onMarkerDragEnd,this).off("MSPointerUp",this._onMarkerDragEnd,this)):e.editing.disable()},_onMouseMove:function(t){this._tooltip.updatePosition(t.latlng)},_onTouchMove:function(t){var e=t.originalEvent.changedTouches[0],i=this._map.mouseEventToLayerPoint(e),o=this._map.layerPointToLatLng(i);t.target.setLatLng(o)},_hasAvailableLayers:function(){return 0!==this._featureGroup.getLayers().length}}),L.EditToolbar.Delete=L.Handler.extend({statics:{TYPE:"remove"},includes:L.Mixin.Events,initialize:function(t,e){if(L.Handler.prototype.initialize.call(this,t),L.Util.setOptions(this,e),this._deletableLayers=this.options.featureGroup,!(this._deletableLayers instanceof L.FeatureGroup))throw new Error("options.featureGroup must be a L.FeatureGroup");this.type=L.EditToolbar.Delete.TYPE},enable:function(){!this._enabled&&this._hasAvailableLayers()&&(this.fire("enabled",{handler:this.type}),this._map.fire("draw:deletestart",{handler:this.type}),L.Handler.prototype.enable.call(this),this._deletableLayers.on("layeradd",this._enableLayerDelete,this).on("layerremove",this._disableLayerDelete,this))},disable:function(){this._enabled&&(this._deletableLayers.off("layeradd",this._enableLayerDelete,this).off("layerremove",this._disableLayerDelete,this),L.Handler.prototype.disable.call(this),this._map.fire("draw:deletestop",{handler:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(t.getContainer().focus(),this._deletableLayers.eachLayer(this._enableLayerDelete,this),this._deletedLayers=new L.LayerGroup,this._tooltip=new L.Tooltip(this._map),this._tooltip.updateContent({text:L.drawLocal.edit.handlers.remove.tooltip.text}),this._map.on("mousemove",this._onMouseMove,this))},removeHooks:function(){this._map&&(this._deletableLayers.eachLayer(this._disableLayerDelete,this),this._deletedLayers=null,this._tooltip.dispose(),this._tooltip=null,this._map.off("mousemove",this._onMouseMove,this))},revertLayers:function(){this._deletedLayers.eachLayer(function(t){this._deletableLayers.addLayer(t),t.fire("revert-deleted",{layer:t})},this)},save:function(){this._map.fire("draw:deleted",{layers:this._deletedLayers})},_enableLayerDelete:function(t){var e=t.layer||t.target||t;e.on("click",this._removeLayer,this)},_disableLayerDelete:function(t){var e=t.layer||t.target||t;e.off("click",this._removeLayer,this),this._deletedLayers.removeLayer(e)},_removeLayer:function(t){var e=t.layer||t.target||t;this._deletableLayers.removeLayer(e),this._deletedLayers.addLayer(e),e.fire("deleted")},_onMouseMove:function(t){this._tooltip.updatePosition(t.latlng)},_hasAvailableLayers:function(){return 0!==this._deletableLayers.getLayers().length}})}(window,document);


/***/ }),
/* 617 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	L.Control.Dialog = L.Control.extend({
	  options: {
	    size: [ 300, 300 ],
	    minSize: [ 100, 100 ],
	    maxSize: [ 350, 350 ],
	    anchor: [ 250, 250 ],
	    position: 'topleft',
	    initOpen: true
	  },
	
	  initialize: function (options){
	    L.setOptions(this, options);
	
	    this._attributions = {};
	  },
	
	  onAdd: function (map){
	
	    this._initLayout();
	    this._map = map;
	
	    this.update();
	
	    if(!this.options.initOpen){
	      this.close();
	    }
	
	    return this._container;
	  },
	
	  open: function(){
	    if(!this._map){
	      return;
	    }
	    this._container.style.visibility = '';
	
	    this._map.fire('dialog:opened', this);
	
	    return this;
	  },
	
	  close: function(){
	    this._container.style.visibility = 'hidden';
	
	    this._map.fire('dialog:closed', this);
	    return this;
	  },
	
	  destroy: function(){
	    if(!this._map){ return this; }
	
	    this.removeFrom(this._map);
	
	    if (this.onRemove) {
				this.onRemove(this._map);
			}
	
	    this._map.fire('dialog:destroyed', this);
	    return this;
	  },
	
	  setLocation: function(location){
	    location = location || [ 250, 250 ];
	
	    this.options.anchor[0] = 0;
	    this.options.anchor[1] = 0;
	    this._oldMousePos.x = 0;
	    this._oldMousePos.y = 0;
	
	    this._move(location[1], location[0]);
	
	    return this;
	  },
	
	  setSize: function(size){
	    size = size || [ 300, 300 ];
	
	    this.options.size[0] = 0;
	    this.options.size[1] = 0;
	    this._oldMousePos.x = 0;
	    this._oldMousePos.y = 0;
	
	    this._resize(size[0], size[1]);
	
	    return this;
	  },
	
	  lock: function(){
	    this._resizerNode.style.visibility = 'hidden';
	    this._grabberNode.style.visibility = 'hidden';
	    this._closeNode.style.visibility = 'hidden';
	
	    this._map.fire('dialog:locked', this);
	    return this;
	  },
	
	  unlock: function(){
	    this._resizerNode.style.visibility = '';
	    this._grabberNode.style.visibility = '';
	    this._closeNode.style.visibility = '';
	
	    this._map.fire('dialog:unlocked', this);
	    return this;
	  },
	
	  freeze: function(){
	    this._resizerNode.style.visibility = 'hidden';
	    this._grabberNode.style.visibility = 'hidden';
	
	    this._map.fire('dialog:frozen', this);
	    return this;
	  },
	
	  unfreeze : function(){
	    this._resizerNode.style.visibility = '';
	    this._grabberNode.style.visibility = '';
	
	    this._map.fire('dialog:unfrozen', this);
	    return this;
	  },
	
	  setContent: function(content){
	    this._content = content;
	    this.update();
	    return this;
	  },
	
	  getContent: function(){
	    return this._content;
	  },
	
	  getElement: function(){
	    return this._container;
	  },
	
	  update: function(){
	    if (!this._map) { return; }
	
	    this._container.style.visibility = 'hidden';
	
	    this._updateContent();
	    this._updateLayout();
	
	    this._container.style.visibility = '';
	    this._map.fire('dialog:updated', this);
	
	  },
	
	  _initLayout: function(){
	    var className = 'leaflet-control-dialog',
	      container = this._container = L.DomUtil.create('div', className);
	
	    container.style.width = this.options.size[0] + 'px';
	    container.style.height = this.options.size[1] + 'px';
	
	    container.style.top = this.options.anchor[0] + 'px';
	    container.style.left = this.options.anchor[1] + 'px';
	
	    var stop = L.DomEvent.stopPropagation;
	    L.DomEvent
	        .on(container, 'click', stop)
	        .on(container, 'mousedown', stop)
	        .on(container, 'touchstart', stop)
	        .on(container, 'dblclick', stop)
	        .on(container, 'mousewheel', stop)
	        .on(container, 'contextmenu', stop)
	        .on(container, 'MozMousePixelScroll', stop);
	
	    var innerContainer = this._innerContainer = L.DomUtil.create('div', className + '-inner');
	
	    var grabberNode = this._grabberNode = L.DomUtil.create('div', className + '-grabber');
	    var grabberIcon = L.DomUtil.create('i', 'fa fa-arrows');
	    grabberNode.appendChild(grabberIcon);
	
	    L.DomEvent.on(grabberNode, 'mousedown', this._handleMoveStart, this);
	
	    var closeNode = this._closeNode = L.DomUtil.create('div', className + '-close');
	    var closeIcon = L.DomUtil.create('i', 'fa fa-times');
	    closeNode.appendChild(closeIcon);
	    L.DomEvent.on(closeNode, 'click', this._handleClose, this);
	
	    var resizerNode = this._resizerNode = L.DomUtil.create('div', className + '-resizer');
	    var resizeIcon = L.DomUtil.create('i', 'fa fa-arrows-h fa-rotate-45');
	    resizerNode.appendChild(resizeIcon);
	
	    L.DomEvent.on(resizerNode, 'mousedown', this._handleResizeStart, this);
	
	    var contentNode = this._contentNode = L.DomUtil.create('div', className + "-contents");
	
	    container.appendChild(innerContainer);
	
	    innerContainer.appendChild(contentNode);
	    innerContainer.appendChild(grabberNode);
	    innerContainer.appendChild(closeNode);
	    innerContainer.appendChild(resizerNode);
	
	    this._oldMousePos = { x: 0, y: 0 };
	
	  },
	
	  _handleClose: function(){
	    this.close();
	  },
	
	  _handleResizeStart: function(e){
	    this._oldMousePos.x = e.clientX;
	    this._oldMousePos.y = e.clientY;
	
	    L.DomEvent.on(this._map, 'mousemove', this._handleMouseMove, this);
	    L.DomEvent.on(this._map, 'mouseup', this._handleMouseUp, this);
	
	    this._map.fire('dialog:resizestart', this);
	    this._resizing = true;
	  },
	
	  _handleMoveStart: function(e){
	    this._oldMousePos.x = e.clientX;
	    this._oldMousePos.y = e.clientY;
	
	    L.DomEvent.on(this._map, 'mousemove', this._handleMouseMove, this);
	    L.DomEvent.on(this._map, 'mouseup', this._handleMouseUp, this);
	
	    this._map.fire('dialog:movestart', this);
	    this._moving = true;
	  },
	
	  _handleMouseMove: function(e){
	    var diffX = e.originalEvent.clientX - this._oldMousePos.x,
	      diffY = e.originalEvent.clientY - this._oldMousePos.y;
	
	      // this helps prevent accidental highlighting on drag:
	    if(e.originalEvent.stopPropagation){ e.originalEvent.stopPropagation(); }
	    if(e.originalEvent.preventDefault){ e.originalEvent.preventDefault(); }
	
	    if(this._resizing){
	      this._resize(diffX, diffY);
	    }
	
	    if(this._moving){
	      this._move(diffX, diffY);
	    }
	  },
	
	  _handleMouseUp: function(){
	    L.DomEvent.off(this._map, 'mousemove', this._handleMouseMove, this);
	    L.DomEvent.off(this._map, 'mouseup', this._handleMouseUp, this);
	
	    if(this._resizing){
	      this._resizing = false;
	      this._map.fire('dialog:resizeend', this);
	    }
	
	    if(this._moving){
	      this._moving = false;
	      this._map.fire('dialog:moveend', this);
	    }
	  },
	
	  _move: function(diffX, diffY){
	    var newY = this.options.anchor[0] + diffY;
	    var newX = this.options.anchor[1] + diffX;
	
	    this.options.anchor[0] = newY;
	    this.options.anchor[1] = newX;
	
	    this._container.style.top = this.options.anchor[0] + 'px';
	    this._container.style.left = this.options.anchor[1] + 'px';
	
	    this._map.fire('dialog:moving', this);
	
	    this._oldMousePos.y += diffY;
	    this._oldMousePos.x += diffX;
	  },
	
	  _resize: function(diffX, diffY){
	    var newX = this.options.size[0] + diffX;
	    var newY = this.options.size[1] + diffY;
	
	    if( newX <= this.options.maxSize[0] && newX >= this.options.minSize[0]){
	      this.options.size[0] = newX;
	      this._container.style.width = this.options.size[0] + 'px';
	      this._oldMousePos.x += diffX;
	    }
	
	    if(newY <= this.options.maxSize[1] && newY >= this.options.minSize[1] ){
	      this.options.size[1] = newY;
	      this._container.style.height = this.options.size[1] + 'px';
	      this._oldMousePos.y += diffY;
	    }
	
	    this._map.fire('dialog:resizing', this);
	  },
	
	  _updateContent: function(){
	
	    if(!this._content){ return; }
	
	    var node = this._contentNode;
	    var content = (typeof this._content === 'function') ? this._content(this) : this._content;
	
	    if(typeof content === 'string'){
	      node.innerHTML = content;
	    }
	    else{
	      while(node.hasChildNodes()){
	        node.removeChild(node.firstChild);
	      }
	      node.appendChild(content);
	    }
	
	  },
	
	  _updateLayout: function(){
	
	    this._container.style.width = this.options.size[0] + 'px';
	    this._container.style.height = this.options.size[1] + 'px';
	
	    this._container.style.top = this.options.anchor[0] + 'px';
	    this._container.style.left = this.options.anchor[1] + 'px';
	
	  }
	
	});
	
	L.control.dialog = function (options) {
	  return new L.Control.Dialog(options);
	};
	


/***/ }),
/* 618 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	(function (FeatureType) {
	    FeatureType[FeatureType["Land"] = 0] = "Land";
	    FeatureType[FeatureType["Well"] = 1] = "Well";
	})(exports.FeatureType || (exports.FeatureType = {}));
	var FeatureType = exports.FeatureType;
	


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var L = __webpack_require__(581);
	/**
	 * Creates a Pli Map Feature from a Mapbox layer
	 */
	function createFeature(layer, map, type) {
	    var contentSubscription = null;
	    var popupLayer = null;
	    return {
	        _internalId: layer._leaflet_id,
	        properties: layer.feature.properties,
	        type: type,
	        bindPopup: function (content, options) {
	            var leafletOptions = {
	                className: options && options.customLayout ? "mapping-custom-popup" : "",
	                closeButton: options && (options.closeButton === true || options.closeButton === undefined)
	            };
	            // TODO: When leaflet 1.0 is released, it will accept a function for content
	            if (typeof content === "string") {
	                layer.bindPopup(content, leafletOptions);
	            }
	            else {
	                if (contentSubscription) {
	                    contentSubscription.dispose();
	                }
	                contentSubscription = content.subscribe(function (html) {
	                    this.unbindPopup();
	                    this.bindPopup(html, options);
	                }, layer);
	                layer.bindPopup(content(), leafletOptions);
	            }
	            var closeButton = options && options.closeButton;
	            if (typeof closeButton === "string") {
	                layer.on("popupopen", function (popupEvent) {
	                    if (!map) {
	                        return;
	                    } // Map not yet rendered, do nothing
	                    var container$ = map.getContainer();
	                    var closeButton$ = container$.querySelector(closeButton);
	                    // If multi-polygon group feature, e.layer will be the polygon with the popup.
	                    popupLayer = popupEvent.layer || layer;
	                    if (closeButton$) {
	                        function closePopup(closeEvent) {
	                            L.DomEvent.preventDefault(closeEvent);
	                            popupLayer.closePopup();
	                            L.DomEvent.off(closeButton$, "click", closePopup);
	                        }
	                        L.DomEvent.on(closeButton$, "click", closePopup);
	                    }
	                });
	            }
	        },
	        openPopup: function () { map.closePopup(); popupLayer.openPopup(); },
	        closePopup: function () { popupLayer.closePopup(); },
	        unbindPopup: function () {
	            if (contentSubscription !== null) {
	                contentSubscription.dispose();
	                contentSubscription = null;
	            }
	            layer.closePopup();
	            layer.unbindPopup();
	        },
	        on: layer.on.bind(layer),
	        off: layer.off.bind(layer),
	        once: layer.once.bind(layer)
	    };
	}
	exports.createFeature = createFeature;
	(function (ClusterPlugin) {
	    ClusterPlugin[ClusterPlugin["MarkerCluster"] = 0] = "MarkerCluster";
	    ClusterPlugin[ClusterPlugin["SuperCluster"] = 1] = "SuperCluster";
	})(exports.ClusterPlugin || (exports.ClusterPlugin = {}));
	var ClusterPlugin = exports.ClusterPlugin;
	


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var L = __webpack_require__(581);
	var common_1 = __webpack_require__(619);
	var api_1 = __webpack_require__(618);
	var LandLayer = (function () {
	    function LandLayer(_a) {
	        var _b = _a.landMarkerThreshold, landMarkerThreshold = _b === void 0 ? 85 : _b;
	        this._landMarkerThreshold = landMarkerThreshold;
	        this._featureLayer = null;
	    }
	    LandLayer.prototype.createLayerAdded = function (map, nextColor, featureAddCallback) {
	        return function (e) {
	            var layer = e.layer;
	            var properties = layer.feature.properties;
	            layer.setStyle({
	                fillColor: properties.fillColor || nextColor(),
	                fillOpacity: 0.5
	            });
	            if (properties.title) {
	                layer.bindPopup("<div class='popup-title'>" + properties.title + "</div>");
	            }
	            if (typeof featureAddCallback === "function") {
	                featureAddCallback(common_1.createFeature(layer, map, api_1.FeatureType.Land));
	            }
	        };
	    };
	    LandLayer.prototype.getFeatureLayer = function () {
	        return this._featureLayer;
	    };
	    LandLayer.prototype.resetFeatureLayer = function () {
	        // Creates new empty land feature layer
	        this._featureLayer = L.mapbox.featureLayer();
	    };
	    LandLayer.prototype.setFeatureLayer = function (geoJson, onLayerAdded) {
	        if (geoJson === null) {
	            throw new Error("geoJson can not be null.");
	        }
	        this.resetFeatureLayer();
	        this._featureLayer.on("layeradd", onLayerAdded);
	        this._featureLayer.setGeoJSON(geoJson);
	    };
	    LandLayer.prototype.toggleLandMarkers = function (map) {
	        var _this = this;
	        var mapLayer = this._featureLayer;
	        if (!mapLayer) {
	            return;
	        }
	        var showMarker = mapLayer.getLayers().some(function (layer) {
	            var layerBounds = layer.getBounds();
	            var pixelBounds = L.bounds(map.latLngToContainerPoint(layerBounds.getNorthEast()), map.latLngToContainerPoint(layerBounds.getSouthWest()));
	            var pixelSize = pixelBounds.getSize();
	            return pixelSize.x * pixelSize.y < _this._landMarkerThreshold;
	        });
	        if (!showMarker && this._landMarkerGroup) {
	            map.removeLayer(this._landMarkerGroup);
	            this._landMarkerGroup = null;
	        }
	        else if (showMarker && !this._landMarkerGroup) {
	            this._landMarkerGroup = this._createLandMarkerGroup(mapLayer);
	            map.addLayer(this._landMarkerGroup);
	        }
	    };
	    LandLayer.prototype.toggleLandMarkersOnLayerUpdate = function (map) {
	        // Recreate marker groups if necessary
	        if (this._landMarkerGroup) {
	            map.removeLayer(this._landMarkerGroup);
	            this._landMarkerGroup = null;
	        }
	        this.toggleLandMarkers(map);
	    };
	    LandLayer.prototype._createLandMarkerGroup = function (layerGroup) {
	        var markerGroup = L.markerClusterGroup({ animateAddingMarkers: true });
	        for (var _i = 0, _a = layerGroup.getLayers(); _i < _a.length; _i++) {
	            var layer = _a[_i];
	            var marker = L.marker(layer.getBounds().getCenter());
	            marker.on("click", function (l) {
	                return function () { l.openPopup(); };
	            }(layer));
	            markerGroup.addLayer(marker);
	        }
	        return markerGroup;
	    };
	    return LandLayer;
	}());
	exports.LandLayer = LandLayer;
	


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var L = __webpack_require__(581);
	var common_1 = __webpack_require__(619);
	var api_1 = __webpack_require__(618);
	/* tslint:disable:no-var-requires no-require-imports */
	var supercluster = __webpack_require__(622);
	var WellLayer = (function () {
	    function WellLayer(options) {
	        this._loadByArray = options && options.loadFeaturesByArray || false;
	        this._clusterPlugin = options && options.clusterPlugin || common_1.ClusterPlugin.MarkerCluster;
	        this._featureLayerJson = null;
	        this._featureLayerArray = null;
	        if (this._clusterPlugin === common_1.ClusterPlugin.SuperCluster) {
	            this._supercluster = supercluster({ radius: 60, extent: 256, maxZoom: 17 });
	            this._wellSuperclusterGroup = L.geoJson(null, { pointToLayer: this._createClusterIcon });
	        }
	    }
	    WellLayer.prototype.clearClickHandler = function () {
	        if (this._featureLayerJson && this._featureLayerJson.hasEventListeners("click")) {
	            this._featureLayerJson.removeEventListener("click");
	        }
	        if (this._featureLayerArray && this._featureLayerArray.hasEventListeners("click")) {
	            this._featureLayerArray.removeEventListener("click");
	        }
	        if (this._wellSuperclusterGroup && this._wellSuperclusterGroup.hasEventListeners("click")) {
	            this._wellSuperclusterGroup.removeEventListener("click");
	        }
	    };
	    WellLayer.prototype.createLayerAdded = function (map, featureAddCallback) {
	        return function (e) {
	            var layer = e.layer;
	            var properties = layer.feature.properties;
	            if (properties.icon) {
	                layer.setIcon(L.divIcon(properties.icon));
	            }
	            else {
	            }
	            if (properties.title) {
	                layer.bindPopup("<div class='popup-title'>" + properties.title + "</div>");
	            }
	            else if (properties.id) {
	                layer.bindPopup("Loading...");
	            }
	            if (typeof featureAddCallback === "function") {
	                featureAddCallback(common_1.createFeature(layer, map, api_1.FeatureType.Well));
	            }
	        };
	    };
	    /**
	     * Gets the wrapper layer that should be added to the map instance.
	     *
	     * @returns
	     *     Clustered wells
	     */
	    WellLayer.prototype.getMarkerClusterGroup = function () {
	        return this._clusterPlugin === common_1.ClusterPlugin.SuperCluster
	            ? this._wellSuperclusterGroup
	            : this._wellMarkerGroup;
	    };
	    /**
	     * Gets the layer used for interacting with the feature.
	     *
	     * @returns
	     *     The feature layer
	     */
	    WellLayer.prototype.getFeatureLayer = function () {
	        return this._loadByArray ? this._featureLayerArray : this._featureLayerJson;
	    };
	    WellLayer.prototype.resetFeatureLayer = function () {
	        // Creates new empty well feature layer
	        this._featureLayerJson = L.mapbox.featureLayer();
	        this._featureLayerArray = L.mapbox.featureLayer();
	    };
	    WellLayer.prototype.setFeatureLayer = function (data, onLayerAdded, map, onClick) {
	        var _this = this;
	        this.resetFeatureLayer();
	        if (Array.isArray(data)) {
	            this._setFeatureLayerArray(data, onLayerAdded, onClick);
	        }
	        else {
	            this._setFeatureLayerJson(data, onLayerAdded, onClick);
	        }
	        if (this._clusterPlugin === common_1.ClusterPlugin.SuperCluster) {
	            this._wellSuperclusterGroup.on("layeradd", onLayerAdded);
	            if (onClick) {
	                this._wellSuperclusterGroup.on("click", onClick);
	            }
	            this._adjustClusterView(map);
	            map.addEventListener("moveend", function (e) {
	                _this._adjustClusterView(map);
	            }, this);
	        }
	    };
	    WellLayer.prototype._setFeatureLayerJson = function (geoJson, onLayerAdded, onClick) {
	        if (geoJson === null) {
	            throw new Error("geoJson can not be null.");
	        }
	        this._featureLayerJson.on("layeradd", onLayerAdded);
	        this._featureLayerJson.setGeoJSON(geoJson);
	        if (onClick) {
	            this._featureLayerJson.on("click", onClick);
	        }
	        if (this._clusterPlugin === common_1.ClusterPlugin.MarkerCluster) {
	            this._wellMarkerGroup = this._createWellMarkerCluster(this._featureLayerJson);
	        }
	        else if (this._clusterPlugin === common_1.ClusterPlugin.SuperCluster) {
	            this._supercluster.load(geoJson.features);
	        }
	    };
	    /**
	     * Adds markers to the feature layer using an array of arrays.
	     *
	     * Internal array is structured as:
	     * a[0]: Longitude
	     * a[1]: Latitude
	     * a[2]: Title
	     * This is to follow the structure of GeoJSON's `coordinates` property.
	     */
	    WellLayer.prototype._setFeatureLayerArray = function (geoArray, onLayerAdded, onClick) {
	        if (geoArray === null) {
	            throw new Error("geoArray cannot be null.");
	        }
	        if (onClick) {
	            this._featureLayerArray.on("click", onClick);
	        }
	        for (var _i = 0, geoArray_1 = geoArray; _i < geoArray_1.length; _i++) {
	            var point = geoArray_1[_i];
	            var title = point[2];
	            var marker = L.marker(L.latLng(point[1], point[0]), { title: title });
	            this._featureLayerArray.addLayer(marker);
	        }
	        if (this._clusterPlugin === common_1.ClusterPlugin.MarkerCluster) {
	            this._wellMarkerGroup = this._createWellMarkerCluster(this._featureLayerArray);
	        }
	        else if (this._clusterPlugin === common_1.ClusterPlugin.SuperCluster) {
	            this._supercluster.load(this._featureLayerArray.toGeoJSON().features);
	        }
	    };
	    WellLayer.prototype._createWellMarkerCluster = function (layerGroup) {
	        var markerGroup = L.markerClusterGroup();
	        var markerArray = [];
	        layerGroup.eachLayer(function (marker) {
	            markerArray.push(marker);
	        });
	        markerGroup.addLayers(markerArray);
	        return markerGroup;
	    };
	    WellLayer.prototype._createClusterIcon = function (feature, latLng) {
	        if (!feature.properties.cluster) {
	            return L.marker(latLng);
	        }
	        var count = feature.properties.point_count;
	        var size = count < 100 ? "small" :
	            count < 1000 ? "medium" : "large";
	        var icon = L.divIcon({
	            html: "<div><span>" + feature.properties.point_count_abbreviated + "</span></div>",
	            className: "marker-cluster marker-cluster-" + size,
	            iconSize: L.point(40, 40)
	        });
	        return L.marker(latLng, { icon: icon });
	    };
	    WellLayer.prototype._adjustClusterView = function (map) {
	        var bounds = map.getBounds();
	        var bbox = [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()];
	        var zoom = map.getZoom();
	        this._wellSuperclusterGroup.clearLayers();
	        this._wellSuperclusterGroup.addData(this._supercluster.getClusters(bbox, zoom));
	    };
	    return WellLayer;
	}());
	exports.WellLayer = WellLayer;
	


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var kdbush = __webpack_require__(623);
	
	module.exports = supercluster;
	
	function supercluster(options) {
	    return new SuperCluster(options);
	}
	
	function SuperCluster(options) {
	    this.options = extend(Object.create(this.options), options);
	    this.trees = new Array(this.options.maxZoom + 1);
	}
	
	SuperCluster.prototype = {
	    options: {
	        minZoom: 0,   // min zoom to generate clusters on
	        maxZoom: 16,  // max zoom level to cluster the points on
	        radius: 40,   // cluster radius in pixels
	        extent: 512,  // tile extent (radius is calculated relative to it)
	        nodeSize: 64, // size of the KD-tree leaf node, affects performance
	        log: false    // whether to log timing info
	    },
	
	    load: function (points) {
	        var log = this.options.log;
	
	        if (log) console.time('total time');
	
	        var timerId = 'prepare ' + points.length + ' points';
	        if (log) console.time(timerId);
	
	        this.points = points;
	
	        // generate a cluster object for each point
	        var clusters = points.map(createPointCluster);
	        if (log) console.timeEnd(timerId);
	
	        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
	        // results in a cluster hierarchy across zoom levels
	        for (var z = this.options.maxZoom; z >= this.options.minZoom; z--) {
	            var now = +Date.now();
	
	            // index input points into a KD-tree
	            this.trees[z + 1] = kdbush(clusters, getX, getY, this.options.nodeSize, Float32Array);
	
	            clusters = this._cluster(clusters, z); // create a new set of clusters for the zoom
	
	            if (log) console.log('z%d: %d clusters in %dms', z, clusters.length, +Date.now() - now);
	        }
	
	        // index top-level clusters
	        this.trees[this.options.minZoom] = kdbush(clusters, getX, getY, this.options.nodeSize, Float32Array);
	
	        if (log) console.timeEnd('total time');
	
	        return this;
	    },
	
	    getClusters: function (bbox, zoom) {
	        var tree = this.trees[this._limitZoom(zoom)];
	        var ids = tree.range(lngX(bbox[0]), latY(bbox[3]), lngX(bbox[2]), latY(bbox[1]));
	        var clusters = [];
	        for (var i = 0; i < ids.length; i++) {
	            var c = tree.points[ids[i]];
	            clusters.push(c.id !== -1 ? this.points[c.id] : getClusterJSON(c));
	        }
	        return clusters;
	    },
	
	    getTile: function (z, x, y) {
	        var z2 = Math.pow(2, z);
	        var extent = this.options.extent;
	        var p = this.options.radius / extent;
	        var tree = this.trees[this._limitZoom(z)];
	        var ids = tree.range(
	            (x - p) / z2,
	            (y - p) / z2,
	            (x + 1 + p) / z2,
	            (y + 1 + p) / z2);
	
	        if (!ids.length) return null;
	
	        var tile = {
	            features: []
	        };
	        for (var i = 0; i < ids.length; i++) {
	            var c = tree.points[ids[i]];
	            var feature = {
	                type: 1,
	                geometry: [[
	                    Math.round(extent * (c.x * z2 - x)),
	                    Math.round(extent * (c.y * z2 - y))
	                ]],
	                tags: c.id !== -1 ? this.points[c.id].properties : getClusterProperties(c)
	            };
	            tile.features.push(feature);
	        }
	        return tile;
	    },
	
	    _limitZoom: function (z) {
	        return Math.max(this.options.minZoom, Math.min(z, this.options.maxZoom + 1));
	    },
	
	    _cluster: function (points, zoom) {
	        var clusters = [];
	        var r = this.options.radius / (this.options.extent * Math.pow(2, zoom));
	
	        // loop through each point
	        for (var i = 0; i < points.length; i++) {
	            var p = points[i];
	            // if we've already visited the point at this zoom level, skip it
	            if (p.zoom <= zoom) continue;
	            p.zoom = zoom;
	
	            // find all nearby points
	            var tree = this.trees[zoom + 1];
	            var neighborIds = tree.within(p.x, p.y, r);
	
	            var foundNeighbors = false;
	            var numPoints = p.numPoints;
	            var wx = p.x * numPoints;
	            var wy = p.y * numPoints;
	
	            for (var j = 0; j < neighborIds.length; j++) {
	                var b = tree.points[neighborIds[j]];
	                // filter out neighbors that are too far or already processed
	                if (zoom < b.zoom) {
	                    foundNeighbors = true;
	                    b.zoom = zoom; // save the zoom (so it doesn't get processed twice)
	                    wx += b.x * b.numPoints; // accumulate coordinates for calculating weighted center
	                    wy += b.y * b.numPoints;
	                    numPoints += b.numPoints;
	                }
	            }
	
	            clusters.push(foundNeighbors ? createCluster(wx / numPoints, wy / numPoints, numPoints, -1) : p);
	        }
	
	        return clusters;
	    }
	};
	
	function createCluster(x, y, numPoints, id) {
	    return {
	        x: x, // weighted cluster center
	        y: y,
	        zoom: Infinity, // the last zoom the cluster was processed at
	        id: id, // index of the source feature in the original input array
	        numPoints: numPoints
	    };
	}
	
	function createPointCluster(p, i) {
	    var coords = p.geometry.coordinates;
	    return createCluster(lngX(coords[0]), latY(coords[1]), 1, i);
	}
	
	function getClusterJSON(cluster) {
	    return {
	        type: 'Feature',
	        properties: getClusterProperties(cluster),
	        geometry: {
	            type: 'Point',
	            coordinates: [xLng(cluster.x), yLat(cluster.y)]
	        }
	    };
	}
	
	function getClusterProperties(cluster) {
	    var count = cluster.numPoints;
	    var abbrev = count >= 10000 ? Math.round(count / 1000) + 'k' :
	                 count >= 1000 ? (Math.round(count / 100) / 10) + 'k' : count;
	    return {
	        cluster: true,
	        point_count: count,
	        point_count_abbreviated: abbrev
	    };
	}
	
	// longitude/latitude to spherical mercator in [0..1] range
	function lngX(lng) {
	    return lng / 360 + 0.5;
	}
	function latY(lat) {
	    var sin = Math.sin(lat * Math.PI / 180),
	        y = (0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI);
	    return y < 0 ? 0 :
	           y > 1 ? 1 : y;
	}
	
	// spherical mercator to longitude/latitude
	function xLng(x) {
	    return (x - 0.5) * 360;
	}
	function yLat(y) {
	    var y2 = (180 - y * 360) * Math.PI / 180;
	    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
	}
	
	function extend(dest, src) {
	    for (var id in src) dest[id] = src[id];
	    return dest;
	}
	
	function getX(p) {
	    return p.x;
	}
	function getY(p) {
	    return p.y;
	}
	


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	var sort = __webpack_require__(624);
	var range = __webpack_require__(625);
	var within = __webpack_require__(626);
	
	module.exports = kdbush;
	
	function kdbush(points, getX, getY, nodeSize, ArrayType) {
	    return new KDBush(points, getX, getY, nodeSize, ArrayType);
	}
	
	function KDBush(points, getX, getY, nodeSize, ArrayType) {
	    getX = getX || defaultGetX;
	    getY = getY || defaultGetY;
	    ArrayType = ArrayType || Array;
	
	    this.nodeSize = nodeSize || 64;
	    this.points = points;
	
	    this.ids = new ArrayType(points.length);
	    this.coords = new ArrayType(points.length * 2);
	
	    for (var i = 0; i < points.length; i++) {
	        this.ids[i] = i;
	        this.coords[2 * i] = getX(points[i]);
	        this.coords[2 * i + 1] = getY(points[i]);
	    }
	
	    sort(this.ids, this.coords, this.nodeSize, 0, this.ids.length - 1, 0);
	}
	
	KDBush.prototype = {
	    range: function (minX, minY, maxX, maxY) {
	        return range(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
	    },
	
	    within: function (x, y, r) {
	        return within(this.ids, this.coords, x, y, r, this.nodeSize);
	    }
	};
	
	function defaultGetX(p) { return p[0]; }
	function defaultGetY(p) { return p[1]; }
	


/***/ }),
/* 624 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	module.exports = sortKD;
	
	function sortKD(ids, coords, nodeSize, left, right, depth) {
	    if (right - left <= nodeSize) return;
	
	    var m = Math.floor((left + right) / 2);
	
	    select(ids, coords, m, left, right, depth % 2);
	
	    sortKD(ids, coords, nodeSize, left, m - 1, depth + 1);
	    sortKD(ids, coords, nodeSize, m + 1, right, depth + 1);
	}
	
	function select(ids, coords, k, left, right, inc) {
	
	    while (right > left) {
	        if (right - left > 600) {
	            var n = right - left + 1;
	            var m = k - left + 1;
	            var z = Math.log(n);
	            var s = 0.5 * Math.exp(2 * z / 3);
	            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
	            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
	            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
	            select(ids, coords, k, newLeft, newRight, inc);
	        }
	
	        var t = coords[2 * k + inc];
	        var i = left;
	        var j = right;
	
	        swapItem(ids, coords, left, k);
	        if (coords[2 * right + inc] > t) swapItem(ids, coords, left, right);
	
	        while (i < j) {
	            swapItem(ids, coords, i, j);
	            i++;
	            j--;
	            while (coords[2 * i + inc] < t) i++;
	            while (coords[2 * j + inc] > t) j--;
	        }
	
	        if (coords[2 * left + inc] === t) swapItem(ids, coords, left, j);
	        else {
	            j++;
	            swapItem(ids, coords, j, right);
	        }
	
	        if (j <= k) left = j + 1;
	        if (k <= j) right = j - 1;
	    }
	}
	
	function swapItem(ids, coords, i, j) {
	    swap(ids, i, j);
	    swap(coords, 2 * i, 2 * j);
	    swap(coords, 2 * i + 1, 2 * j + 1);
	}
	
	function swap(arr, i, j) {
	    var tmp = arr[i];
	    arr[i] = arr[j];
	    arr[j] = tmp;
	}
	


/***/ }),
/* 625 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	module.exports = range;
	
	function range(ids, coords, minX, minY, maxX, maxY, nodeSize) {
	    var stack = [0, ids.length - 1, 0];
	    var result = [];
	    var x, y;
	
	    while (stack.length) {
	        var axis = stack.pop();
	        var right = stack.pop();
	        var left = stack.pop();
	
	        if (right - left <= nodeSize) {
	            for (var i = left; i <= right; i++) {
	                x = coords[2 * i];
	                y = coords[2 * i + 1];
	                if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
	            }
	            continue;
	        }
	
	        var m = Math.floor((left + right) / 2);
	
	        x = coords[2 * m];
	        y = coords[2 * m + 1];
	
	        if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);
	
	        var nextAxis = (axis + 1) % 2;
	
	        if (axis === 0 ? minX <= x : minY <= y) {
	            stack.push(left);
	            stack.push(m - 1);
	            stack.push(nextAxis);
	        }
	        if (axis === 0 ? maxX >= x : maxY >= y) {
	            stack.push(m + 1);
	            stack.push(right);
	            stack.push(nextAxis);
	        }
	    }
	
	    return result;
	}
	


/***/ }),
/* 626 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	'use strict';
	
	module.exports = within;
	
	function within(ids, coords, qx, qy, r, nodeSize) {
	    var stack = [0, ids.length - 1, 0];
	    var result = [];
	    var r2 = r * r;
	
	    while (stack.length) {
	        var axis = stack.pop();
	        var right = stack.pop();
	        var left = stack.pop();
	
	        if (right - left <= nodeSize) {
	            for (var i = left; i <= right; i++) {
	                if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
	            }
	            continue;
	        }
	
	        var m = Math.floor((left + right) / 2);
	
	        var x = coords[2 * m];
	        var y = coords[2 * m + 1];
	
	        if (sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
	
	        var nextAxis = (axis + 1) % 2;
	
	        if (axis === 0 ? qx - r <= x : qy - r <= y) {
	            stack.push(left);
	            stack.push(m - 1);
	            stack.push(nextAxis);
	        }
	        if (axis === 0 ? qx + r >= x : qy + r >= y) {
	            stack.push(m + 1);
	            stack.push(right);
	            stack.push(nextAxis);
	        }
	    }
	
	    return result;
	}
	
	function sqDist(ax, ay, bx, by) {
	    var dx = ax - bx;
	    var dy = ay - by;
	    return dx * dx + dy * dy;
	}
	


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var api_1 = __webpack_require__(618);
	/**
	 * View model for a map instance.
	 */
	var MapViewModel = (function () {
	    /**
	     * Creates a new MapViewModel instance.
	     */
	    function MapViewModel(properties) {
	        var _this = this;
	        if (properties === void 0) { properties = {}; }
	        this.adapter = ko.observable(null); // initialized by binding
	        this.layers = ko.observable([]);
	        this.bounds = ko.pureComputed(function () {
	            var adapter = _this.adapter();
	            return adapter ? adapter.bounds() : null;
	        });
	        this.drawnObjects = ko.pureComputed(function () {
	            var adapter = _this.adapter();
	            return adapter ? adapter.drawnObjects() : null;
	        });
	        this.latLong = ko.pureComputed(function () {
	            var adapter = _this.adapter();
	            return adapter ? adapter.latLong() : null;
	        });
	        this.zoom = ko.pureComputed(function () {
	            var adapter = _this.adapter();
	            return adapter ? adapter.zoom() : null;
	        });
	        this.colors = properties.colors || [
	            "#5DA5DA", "#FAA43A", "#60BD68", "#F17CB0",
	            "#B2912F", "#B276B2", "#DECF3F", "#F15854",
	            "#4D4D4D"
	        ];
	        this.dialogContent = ko.observable(null);
	        this.dialogVisible = ko.observable(false);
	        this.onResetFocus = properties.onResetFocus;
	        this.showFullscreenButton = properties.showFullscreenButton || false;
	        this.onFullscreenToggle = properties.onFullscreenToggle;
	        this.onMarkerClick = properties.onMarkerClick;
	    }
	    /**
	     * Centers the map on a given feature and optionally zooms to the bounds of the feature.
	     */
	    MapViewModel.prototype.center = function (feature, zoomToBounds) {
	        var adapter = this.adapter();
	        if (!adapter) {
	            throw new Error("MapViewModel instance must be bound to a map.");
	        }
	        adapter.center(feature, zoomToBounds);
	    };
	    /**
	     * Removes the feature layer of the specified type or all if no type specified.
	     */
	    MapViewModel.prototype.clearFeatures = function (type) {
	        this.layers(type !== undefined
	            ? this.layers().filter(function (layer) { return layer.featureType !== type; })
	            : []);
	    };
	    /**
	     * Returns true if a layer with the given feature type has been added to this map.
	     */
	    MapViewModel.prototype.hasFeatures = function (type) {
	        return this.layers().filter(function (layer) { return layer.featureType === type; }).length > 0;
	    };
	    /**
	     * Gets the current collection of land features and their associated properties, optionally filtering by a predicate on those properties.
	     */
	    MapViewModel.prototype.getLandFeatures = function (propFilter) {
	        var adapter = this.adapter();
	        if (!adapter) {
	            throw new Error("MapViewModel instance must be bound to a map.");
	        }
	        return adapter.getFeatures(api_1.FeatureType.Land, propFilter);
	    };
	    /**
	     * Add or replace land features.
	     */
	    MapViewModel.prototype.setLandFeatures = function (geoData, featureAddCallback) {
	        if (global.console && global.console.group) {
	            global.console.group("land feature layer");
	            global.console.log(geoData);
	        }
	        var oldLayers = this.layers.peek();
	        var newLayers = oldLayers.filter(function (l) { return l.featureType !== api_1.FeatureType.Land; })
	            .concat({ featureType: api_1.FeatureType.Land, geoData: geoData, featureAddCallback: featureAddCallback });
	        this.layers(newLayers);
	        if (global.console && global.console.groupEnd) {
	            global.console.groupEnd();
	        }
	    };
	    /**
	     * Add or replace well features.
	     */
	    MapViewModel.prototype.setWellFeatures = function (geoData, featureAddCallback) {
	        if (global.console && global.console.group) {
	            global.console.group("well feature layer");
	            global.console.log(geoData);
	        }
	        var oldLayers = this.layers.peek();
	        var newLayers = oldLayers.filter(function (l) { return l.featureType !== api_1.FeatureType.Well; })
	            .concat({ featureType: api_1.FeatureType.Well, geoData: geoData, featureAddCallback: featureAddCallback });
	        this.layers(newLayers);
	        if (global.console && global.console.groupEnd) {
	            global.console.groupEnd();
	        }
	    };
	    return MapViewModel;
	}());
	exports.MapViewModel = MapViewModel;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var binding_1 = __webpack_require__(629);
	exports.pliMapTooltipButton = binding_1.pliMapTooltipButton;
	exports.pliMapVisibleTooltip = binding_1.pliMapVisibleTooltip;
	ko.bindingHandlers["pliMapTooltipButton"] = binding_1.pliMapTooltipButton;
	ko.bindingHandlers["pliMapVisibleTooltip"] = binding_1.pliMapVisibleTooltip;
	var api_1 = __webpack_require__(630);
	exports.ErrorLevel = api_1.ErrorLevel;
	exports.LocationType = api_1.LocationType;
	var pliMapViewModel_1 = __webpack_require__(631);
	exports.PliMapViewModel = pliMapViewModel_1.PliMapViewModel;
	


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	function openTooltip(tooltip) {
	    // Position tooltip below progress button
	    var toolTipContainer = L.DomUtil.get(tooltip.id);
	    var mapContainer = toolTipContainer.parentElement;
	    var progressButton = mapContainer
	        .getElementsByClassName("mapProgress")[0]
	        .getElementsByClassName("pliButtonBar")[0]
	        .getElementsByTagName("button")[0];
	    var buttonOffset = L.DomUtil.getViewportOffset(progressButton);
	    var mapOffset = L.DomUtil.getViewportOffset(mapContainer);
	    var buttonLeft = buttonOffset.x - mapOffset.x;
	    var buttonTop = buttonOffset.y - mapOffset.y;
	    var halfTooltipWidth = parseInt(L.DomUtil.getStyle(toolTipContainer, "width"), 10) / 2; // Tooltip could be hidden, get width from style
	    var halfButtonWidth = progressButton.offsetWidth / 2;
	    var tooltipLeft = buttonLeft + halfButtonWidth - halfTooltipWidth;
	    var tooltipRight = buttonTop + progressButton.offsetHeight + 7;
	    L.DomUtil.setPosition(toolTipContainer, new L.Point(tooltipLeft, tooltipRight), true);
	    return tooltip.show();
	}
	function createEventHandler(handler) {
	    return function (event) {
	        if (!handler()) {
	            event.stopPropagation();
	            event.preventDefault();
	        }
	    };
	}
	/**
	 * pliMapTooltipButton knockout binding
	 */
	exports.pliMapTooltipButton = {
	    init: function initMapTooltipButton(element, valueAccessor) {
	        element.addEventListener("click", createEventHandler(function () {
	            var tooltip = valueAccessor();
	            tooltip.disableMouseOutHiding();
	            return openTooltip(tooltip);
	        }));
	        element.addEventListener("mouseenter", createEventHandler(function () { return openTooltip(valueAccessor()); }));
	        element.addEventListener("mouseleave", createEventHandler(function () { return valueAccessor().mouseOut(); }));
	    }
	};
	/**
	 * pliMapVisibleTooltip knockout binding
	 */
	exports.pliMapVisibleTooltip = {
	    init: function initMapVisibleTooltip(element, valueAccessor) {
	        // define an onClick handle on html page
	        document.getElementsByTagName("html")[0].addEventListener("click", createEventHandler(function () {
	            var tooltip = valueAccessor();
	            if (ko.utils.domData.get(element, element.needToCloseOnClickOutside)) {
	                tooltip.hide();
	                ko.utils.domData.set(element, element.needToCloseOnClickOutside, false);
	            }
	            return true;
	        }));
	        element.addEventListener("mouseenter", createEventHandler(function () { return openTooltip(valueAccessor()); }));
	        element.addEventListener("mouseleave", createEventHandler(function () { return valueAccessor().mouseOut(); }));
	        // define an onClick handle on the element to prevent global click event
	        element.addEventListener("click", function (event) { return event.stopPropagation(); });
	    },
	    update: function updateMapVisibleTooltip(element, valueAccessor) {
	        var tooltip = valueAccessor();
	        if (ko.unwrap(tooltip.visible)) {
	            element.style.display = "block";
	            // make a delay to prevent hiding the tool tip while it showing by click from tool tip's outside
	            setTimeout(function () { return ko.utils.domData.set(element, element.needToCloseOnClickOutside, true); }, 250);
	        }
	        else {
	            element.style.display = "none";
	        }
	    }
	};
	


/***/ }),
/* 630 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	/**
	 * Map location type.
	 */
	(function (LocationType) {
	    /**
	     * Dls location type.
	     */
	    LocationType[LocationType["Dls"] = 0] = "Dls";
	    /**
	     * Nts location type.
	     */
	    LocationType[LocationType["Nts"] = 1] = "Nts";
	})(exports.LocationType || (exports.LocationType = {}));
	var LocationType = exports.LocationType;
	/**
	 * Map error level.
	 */
	(function (ErrorLevel) {
	    /**
	     * Error level for errors.
	     */
	    ErrorLevel[ErrorLevel["Error"] = 0] = "Error";
	    /**
	     * Error level for warnings.
	     */
	    ErrorLevel[ErrorLevel["Warning"] = 1] = "Warning";
	})(exports.ErrorLevel || (exports.ErrorLevel = {}));
	var ErrorLevel = exports.ErrorLevel;
	


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var api_1 = __webpack_require__(618);
	var mapViewModel_1 = __webpack_require__(627);
	var api_2 = __webpack_require__(630);
	var mapProgressIndicator_1 = __webpack_require__(632);
	/**
	 * A view model for displaying a map with a progres indicator.
	 */
	var PliMapViewModel = (function () {
	    /**
	     * Creates a new instance of the PliMapViewModel class.
	     */
	    function PliMapViewModel(options) {
	        var _this = this;
	        if (!options) {
	            throw new Error("options is required.");
	        }
	        if (typeof options.refreshData !== "function") {
	            throw new Error("options.refreshData must be a function.");
	        }
	        if (typeof options.getLocationData !== "function") {
	            throw new Error("options.refreshgetLocationDataData must be a function.");
	        }
	        this.hideControls = options.hideControls || ko.observable(false);
	        this.emptyMessage = options.emptyMessage || "No locations to show.";
	        this._getLocationData = options.getLocationData;
	        this._landGeoJson = ko.observable(null);
	        this._wellGeoJson = ko.observable(null);
	        var hideProgressIndicator = ko.observable(false);
	        this.map = new mapViewModel_1.MapViewModel({
	            onResetFocus: options.mapFocusCallback,
	            showFullscreenButton: options.showFullscreenButton,
	            onFullscreenToggle: function (isFullscreen) {
	                // Don't show the progress indicator in fullscreen mode
	                hideProgressIndicator(isFullscreen);
	                if (options.onFullscreenToggle) {
	                    options.onFullscreenToggle(isFullscreen);
	                }
	            }
	        });
	        this.isEmpty = ko.pureComputed(function () {
	            return !_this._landGeoJson()
	                && !_this._wellGeoJson()
	                && !_this.progressIndicator.isBusy()
	                && _this.progressIndicator.state() === mapProgressIndicator_1.MapProgressState.None;
	        });
	        // Progress indicator
	        this.progressIndicator = new mapProgressIndicator_1.MapProgressIndicator({
	            pluralEntityType: options.pluralEntityType,
	            refreshMap: options.refreshData,
	            hide: ko.computed(function () { return _this.hideControls() || hideProgressIndicator(); })
	        });
	        var mapFocusCallback = options.focusMapOnLoad ? options.mapFocusCallback : null;
	        this._landGeoJson.subscribe(function (geoJson) {
	            return _this._updateFeature(geoJson, api_1.FeatureType.Land, options.mapFeatureCallback, mapFocusCallback);
	        });
	        this._wellGeoJson.subscribe(function (geoJson) {
	            return _this._updateFeature(geoJson, api_1.FeatureType.Well, options.mapFeatureCallback, mapFocusCallback);
	        });
	    }
	    /**
	     * Loads data into this PliMapViewModel.
	     * @param {PliMapRecord} record The data to load.
	     */
	    PliMapViewModel.prototype.loadViewModel = function (record) {
	        if (record.isLoading) {
	            this.progressIndicator.loadViewModel({
	                hasGenericError: false,
	                hasMultipleLocations: false,
	                isBusy: true,
	                unmappableLocations: []
	            });
	            return;
	        }
	        if (record.hasGenericError) {
	            this.progressIndicator.loadViewModel({
	                hasGenericError: true,
	                hasMultipleLocations: false,
	                isBusy: false,
	                unmappableLocations: []
	            });
	            return;
	        }
	        var unmappableLocations = record.unmappableLocations;
	        var landGeoJson = !record.landData ? null : JSON.parse(record.landData);
	        if (!landGeoJson || !landGeoJson.features || !landGeoJson.features.length) {
	            landGeoJson = null;
	        }
	        else {
	            unmappableLocations = unmappableLocations.concat(this._findOutOfRangeLocations(landGeoJson.features));
	        }
	        var wellGeoJson = !record.wellData ? null : JSON.parse(record.wellData);
	        if (!wellGeoJson || !wellGeoJson.features || !wellGeoJson.features.length) {
	            wellGeoJson = null;
	        }
	        else {
	            unmappableLocations = unmappableLocations.concat(this._findOutOfRangeLocations(wellGeoJson.features));
	        }
	        this._landGeoJson(landGeoJson);
	        this._wellGeoJson(wellGeoJson);
	        this.progressIndicator.loadViewModel({
	            hasGenericError: false,
	            isBusy: false,
	            hasMultipleLocations: record.hasMultipleLocations,
	            unmappableLocations: unmappableLocations
	        });
	    };
	    ;
	    PliMapViewModel.prototype._updateFeature = function (geoJson, featureType, mapFeatureCallback, mapFocusCallback) {
	        if (!geoJson) {
	            this.map.clearFeatures(featureType);
	            return;
	        }
	        switch (featureType) {
	            case api_1.FeatureType.Land:
	                this.map.setLandFeatures(geoJson, mapFeatureCallback);
	                break;
	            case api_1.FeatureType.Well:
	                this.map.setWellFeatures(geoJson, mapFeatureCallback);
	                break;
	            default:
	                break;
	        }
	        // Set map focus
	        if (mapFocusCallback) {
	            mapFocusCallback();
	        }
	    };
	    PliMapViewModel.prototype._findOutOfRangeLocations = function (features) {
	        var _this = this;
	        return features
	            .filter(function (feature) {
	            // geometry property is falsy if location is outside of supported region
	            return feature && !feature.geometry;
	        })
	            .map(function (feature) {
	            return _this._getLocationData(feature.properties).map(function (locationData) {
	                return {
	                    id: locationData.id,
	                    errorLevel: api_2.ErrorLevel.Warning,
	                    message: "The " + api_2.LocationType[locationData.type].toUpperCase() + " location is valid but is out of range of this map",
	                    titleDisplayName: locationData.titleDisplayName,
	                    tooltipDisplayName: locationData.tooltipDisplayName,
	                    openItem: locationData.openItem
	                };
	            });
	        })
	            .reduce(function (result, current) { return result.concat(current); }, []); // flatten array
	    };
	    return PliMapViewModel;
	}());
	exports.PliMapViewModel = PliMapViewModel;
	


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var api_1 = __webpack_require__(630);
	var mapProgressTooltip_1 = __webpack_require__(633);
	/**
	 * The state of a MapProgressIndicator.
	 */
	(function (MapProgressState) {
	    /**
	     * Default state.
	     */
	    MapProgressState[MapProgressState["None"] = 0] = "None";
	    /**
	     * An unexpected error was encountered.
	     */
	    MapProgressState[MapProgressState["UnexpectedError"] = 1] = "UnexpectedError";
	    /**
	     * A single location has an error.
	     */
	    MapProgressState[MapProgressState["Error"] = 2] = "Error";
	    /**
	     * A single location has a warning.
	     */
	    MapProgressState[MapProgressState["Warning"] = 3] = "Warning";
	    /**
	     * Multiple locations have errors and possibly warnings.
	     */
	    MapProgressState[MapProgressState["MultipleErrors"] = 4] = "MultipleErrors";
	    /**
	     * Multiple locations have warnings (but not errors).
	     */
	    MapProgressState[MapProgressState["MultipleWarnings"] = 5] = "MultipleWarnings";
	})(exports.MapProgressState || (exports.MapProgressState = {}));
	var MapProgressState = exports.MapProgressState;
	/**
	 * A view model for displaying a map progress indicator.
	 */
	var MapProgressIndicator = (function () {
	    /**
	     * Creates a new instance of the MapProgressIndicator class.
	     */
	    function MapProgressIndicator(options) {
	        var _this = this;
	        if (!options) {
	            throw new Error("options is required.");
	        }
	        if (typeof options.refreshMap !== "function") {
	            throw new Error("options.refreshMap must be a function.");
	        }
	        if (!ko.isObservable(options.hide)) {
	            throw new Error("options.hide must be an observable.");
	        }
	        this.errorsTooltip = new mapProgressTooltip_1.MapProgressTooltip();
	        this.isBusy = ko.observable(false);
	        this._closed = ko.observable(false);
	        this._hasError = ko.observable(false);
	        this._hasMultipleLocations = ko.observable(false);
	        this._refreshMap = options.refreshMap;
	        this.state = ko.pureComputed(function () { return _this._computeState(); });
	        this.css = ko.pureComputed(function () { return _this._computeCss(); });
	        this.buttonText = ko.pureComputed(function () { return _this._computeButtonText(); });
	        this.title = ko.pureComputed(function () { return _this._computeTitle(options.pluralEntityType); });
	        this.subtitle = ko.pureComputed(function () { return _this._computeSubtitle(); });
	        this.show = ko.pureComputed(function () {
	            return (_this.isBusy() || _this.state() !== MapProgressState.None) && options.hide() === false && !_this._closed();
	        });
	        this.show.subscribe(function (newValue) {
	            if (!newValue) {
	                // If hiding the progress indicator, hide the tooltip.
	                _this.errorsTooltip.hide();
	            }
	        });
	        ko.computed(function () { return _this._hideOrShowTooltip(); });
	        ko.computed(function () { return _this._resetClosedState(); });
	    }
	    /**
	     * Loads the given data into the progress indicator.
	     * @param {MapProgressRecord} record The data to load.
	     */
	    MapProgressIndicator.prototype.loadViewModel = function (record) {
	        if (record) {
	            this.isBusy(record.isBusy);
	            this._hasError(record.hasGenericError);
	            this._hasMultipleLocations(record.hasMultipleLocations);
	            this.errorsTooltip.loadViewModel(record.unmappableLocations);
	        }
	    };
	    /**
	     * The action to perform when the progress indicator button is clicked.
	     */
	    MapProgressIndicator.prototype.onButtonClick = function () {
	        switch (this.state()) {
	            case MapProgressState.Error:
	                // Edit Location
	                this.errorsTooltip.unmappableLocations()[0].openItem();
	                return false;
	            case MapProgressState.MultipleErrors:
	            case MapProgressState.MultipleWarnings:
	                // Why ?
	                // Tooltip open handled by pliMapTooltipButton binding
	                return false;
	            default:
	                // Try Again
	                this._refreshMap();
	                return false;
	        }
	    };
	    /**
	     * Hides the progress indicator.
	     */
	    MapProgressIndicator.prototype.onCloseClick = function () {
	        this._closed(true);
	        return false;
	    };
	    ;
	    MapProgressIndicator.prototype._computeButtonText = function () {
	        switch (this.state()) {
	            case MapProgressState.Error:
	                return "Fix";
	            case MapProgressState.MultipleErrors:
	            case MapProgressState.MultipleWarnings:
	                return "Why?";
	            default:
	                return "Try Again";
	        }
	    };
	    MapProgressIndicator.prototype._computeCss = function () {
	        switch (this.state()) {
	            case MapProgressState.Error:
	                return "error showButtonBar showEditButtonIcon";
	            case MapProgressState.MultipleErrors:
	                return "error showButtonBar showPopupButtonIcon";
	            case MapProgressState.UnexpectedError:
	                return "error showButtonBar showRefreshButtonIcon";
	            case MapProgressState.MultipleWarnings:
	                return "warning showButtonBar showPopupButtonIcon";
	            case MapProgressState.Warning:
	                return "warning";
	            default:
	                return "";
	        }
	    };
	    MapProgressIndicator.prototype._computeState = function () {
	        if (this.isBusy()) {
	            return MapProgressState.None;
	        }
	        if (this._hasError()) {
	            return MapProgressState.UnexpectedError;
	        }
	        var unmappableLocations = this.errorsTooltip.unmappableLocations();
	        if (unmappableLocations && unmappableLocations.length) {
	            var hasErrors = unmappableLocations.some(function (location) {
	                return location.errorLevel === api_1.ErrorLevel.Error;
	            });
	            if (hasErrors) {
	                return unmappableLocations.length > 1 ? MapProgressState.MultipleErrors : MapProgressState.Error;
	            }
	            var hasWarnings = unmappableLocations.some(function (location) {
	                return location.errorLevel === api_1.ErrorLevel.Warning;
	            });
	            if (hasWarnings) {
	                return unmappableLocations.length > 1 ? MapProgressState.MultipleWarnings : MapProgressState.Warning;
	            }
	        }
	        return MapProgressState.None;
	    };
	    MapProgressIndicator.prototype._computeSubtitle = function () {
	        var state = this.state();
	        if (this.isBusy()) {
	            return "Please wait...";
	        }
	        switch (state) {
	            case MapProgressState.UnexpectedError:
	                return "Sorry there was an unexpected error while loading the map";
	            case MapProgressState.Error:
	            case MapProgressState.Warning:
	                return this.errorsTooltip.unmappableLocations()[0].message;
	            default:
	                return "";
	        }
	    };
	    MapProgressIndicator.prototype._computeTitle = function (pluralEntityType) {
	        var state = this.state();
	        if (this.isBusy()) {
	            return "LOADING";
	        }
	        if (state === MapProgressState.UnexpectedError) {
	            return "UNEXPECTED ERROR";
	        }
	        if (state === MapProgressState.None) {
	            return "";
	        }
	        if (this._hasMultipleLocations()) {
	            pluralEntityType = !pluralEntityType ? "LOCATIONS" : pluralEntityType.toUpperCase();
	            switch (state) {
	                case MapProgressState.Error:
	                case MapProgressState.Warning:
	                    return this.errorsTooltip.unmappableLocations()[0].titleDisplayName.toUpperCase() + " - COULD NOT BE DISPLAYED";
	                case MapProgressState.MultipleErrors:
	                case MapProgressState.MultipleWarnings:
	                    return "MULTIPLE " + pluralEntityType + " COULD NOT BE DISPLAYED";
	                default:
	                    break;
	            }
	        }
	        return "LOCATION COULD NOT BE DISPLAYED";
	    };
	    MapProgressIndicator.prototype._hideOrShowTooltip = function () {
	        var state = this.state();
	        var isBusy = this.isBusy();
	        if (isBusy) {
	            this.errorsTooltip.disable();
	            return;
	        }
	        switch (state) {
	            case MapProgressState.MultipleErrors:
	            case MapProgressState.MultipleWarnings:
	                this.errorsTooltip.enable();
	                return;
	            default:
	                this.errorsTooltip.disable();
	                return;
	        }
	    };
	    MapProgressIndicator.prototype._resetClosedState = function () {
	        // Subscribe to data changes
	        this.errorsTooltip.unmappableLocations();
	        // Subscribe to isBusy
	        this.isBusy();
	        this._closed(false);
	    };
	    return MapProgressIndicator;
	}());
	exports.MapProgressIndicator = MapProgressIndicator;
	


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";
	var ko = __webpack_require__(9);
	var api_1 = __webpack_require__(630);
	function getUniqueNumber() {
	    return new Date().getTime() + Math.floor(Math.random() * 1000);
	}
	/**
	 * A view model for displaying a map progress indicator error tooltip.
	 */
	var MapProgressTooltip = (function () {
	    /**
	     * Creates a new instance of the MapProgressTooltip class.
	     */
	    function MapProgressTooltip() {
	        var _this = this;
	        this.id = getUniqueNumber().toString();
	        this.unmappableLocations = ko.observableArray([]);
	        this.visible = ko.observable(false);
	        this._disableMouseOutHiding = ko.observable(false);
	        this._enabled = ko.observable(true);
	        this.title = ko.pureComputed(function () { return _this._computeTitle(); });
	        this.visible.subscribe(function (isVisible) {
	            if (!isVisible) {
	                _this.enableMouseOutHiding();
	            }
	        });
	    }
	    /**
	     * Sorts and loads the given unmappable locations into the tooltip.
	     * @param {UnmappableLocation[]} record The locations to load.
	     */
	    MapProgressTooltip.prototype.loadViewModel = function (record) {
	        if (record) {
	            record.sort(function (a, b) {
	                // Sort errors before warnings
	                if (a.errorLevel === api_1.ErrorLevel.Error && b.errorLevel !== api_1.ErrorLevel.Error) {
	                    return -1;
	                }
	                if (a.errorLevel !== api_1.ErrorLevel.Error && b.errorLevel === api_1.ErrorLevel.Error) {
	                    return 1;
	                }
	                return a.titleDisplayName > b.titleDisplayName ? 1 : a.titleDisplayName < b.titleDisplayName ? -1 : 0;
	            });
	            this.unmappableLocations(record);
	        }
	    };
	    /**
	     * Called when the mouse leaves the tooltip.
	     */
	    MapProgressTooltip.prototype.mouseOut = function () {
	        if (this._disableMouseOutHiding()) {
	            return false;
	        }
	        return this.hide();
	    };
	    /**
	     * Shows the tooltip.
	     */
	    MapProgressTooltip.prototype.show = function () {
	        if (!this._enabled()) {
	            return false;
	        }
	        this.visible(true);
	        return false;
	    };
	    /**
	     * Hides the tooltip.
	     */
	    MapProgressTooltip.prototype.hide = function () {
	        if (!this._enabled()) {
	            return false;
	        }
	        this.visible(false);
	        return true; // allow event propagation & default handling
	    };
	    /**
	     * Hides the MapProgressTooltip and navigates to an unmappable location.
	     * @param {UnmappableLocation} location The unmappable location to navigate to.
	     */
	    MapProgressTooltip.prototype.openItem = function (location) {
	        this.hide();
	        location.openItem();
	        return false;
	    };
	    /**
	     * Enables this tooltip.
	     */
	    MapProgressTooltip.prototype.enable = function () {
	        this._enabled(true);
	    };
	    /**
	     * Disables this tooltip.
	     */
	    MapProgressTooltip.prototype.disable = function () {
	        this._enabled(false);
	        this.visible(false);
	    };
	    /**
	     * Enables hiding this tooltip when the mouse leaves it.
	     */
	    MapProgressTooltip.prototype.enableMouseOutHiding = function () {
	        this._disableMouseOutHiding(false);
	    };
	    /**
	     * Disables hiding this tooltip when the mouse leaves it.
	     */
	    MapProgressTooltip.prototype.disableMouseOutHiding = function () {
	        this._disableMouseOutHiding(true);
	    };
	    /**
	     * Get the css class for a given tooltip location item.
	     * @param  {UnmappableLocation} location
	     *         The item to get the css class for.
	     * @return {string}
	     *         The css class for the item.
	     */
	    MapProgressTooltip.prototype.getItemCss = function (location) {
	        switch (location.errorLevel) {
	            case api_1.ErrorLevel.Error:
	                return "error";
	            default:
	                return "warning";
	        }
	    };
	    MapProgressTooltip.prototype._computeTitle = function () {
	        var unmappableLocations = this.unmappableLocations() || [];
	        var hasWarnings = unmappableLocations.some(function (location) {
	            return location.errorLevel === api_1.ErrorLevel.Warning;
	        });
	        if (hasWarnings) {
	            var hasErrors = unmappableLocations.some(function (location) {
	                return location.errorLevel === api_1.ErrorLevel.Error;
	            });
	            if (hasErrors) {
	                return "Errors & Warnings";
	            }
	            return "Warnings";
	        }
	        return "Errors";
	    };
	    return MapProgressTooltip;
	}());
	exports.MapProgressTooltip = MapProgressTooltip;
	


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	/// <reference path="../../typings/app.d.ts" />
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(635));
	


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   Copied from web-pli: https://github.com/pandell/web-pli/blob/90be145156d256c6d34e625393e9f739d4f73077/util/serverComputed.ts
	   Adds functionality to inform the ServerCalculationContributor of call failure which won't be added to the web-pli version:
	   https://github.com/pandell/web-pli/issues/208
	*/
	"use strict";
	/// <reference path="../../typings/app.d.ts" />
	/* tslint:disable:no-var-requires no-require-imports */
	var pli = __webpack_require__(5);
	var ko = __webpack_require__(457);
	/**
	 * Information and operations relevant to the current position in the viewmodel when gathering/building calculation input or applying calculation result.
	 *
	 * Should only be created by "ServerCalculation", will be passed to
	 * "applyServerCalculationResult" and "buidServerCalculationData" as a parameter.
	 *
	 * For more info, see https://github.com/pandell/web-pli/wiki/Server-Calculations
	 */
	var ServerCalculationContext = (function () {
	    /**
	     * Create a new instance of server calculation context.
	     *
	     * Every time we traverse a viewmodel (either to gather inputs or apply result),
	     * new context instance will be created, but the same context instance is used
	     * to visit all contributors during viewmodel traversal.
	     *
	     * @param {string} methodName
	     *     Either "applyServerCalculationResult" or "buildServerCalculationData".
	     * @param {any = null} rootData
	     *     Result data to apply to root contributor (and its children via recursive "visit" calls).
	     *     Only specified when "methodName==='applyServerCalculationResult'".
	     */
	    function ServerCalculationContext(methodName, rootData) {
	        if (rootData === void 0) { rootData = null; }
	        /**
	         * Gets name of the collection (observable array) that we last visited.
	         *
	         * In other words, what collection is the current contributor member of.
	         * When null, we are still visiting the root contributor.
	         */
	        this.currentCollectionName = null; // changed in "visit"
	        this.rootData = this.currentData = rootData;
	        this._methodName = methodName;
	    }
	    /**
	     * Visit a new contributor (usually a child of the current contributor).
	     *
	     * @param {any} contributor
	     *     Reference to the contributor to visit (typically child property of current contributor).
	     * @param {string} dataKey
	     *     Key to use to get from "this.currentData" (result data applicable to the current contributor) to result data applicable to "contributor".
	     *     Only required when calling "visit" in "applyServerCalculationResult" methods.
	     *
	     * @returns {any}
	     *     Result of invoking the "_methodName" on the specified contributor.
	     */
	    ServerCalculationContext.prototype.visit = function (contributor, dataKey) {
	        var methodToCall;
	        var result = null;
	        var originalData = this.currentData;
	        var currentData = (typeof this.currentData === "object" && this.currentData !== null && typeof dataKey === "string"
	            ? this.currentData[dataKey]
	            : this.currentData);
	        if (ko.isObservable(contributor) && typeof contributor.indexOf === "function") {
	            var originalCollectionName = this.currentCollectionName;
	            this.currentCollectionName = dataKey;
	            methodToCall = contributor[this._methodName];
	            if (typeof methodToCall === "function") {
	                methodToCall.call(contributor, this);
	            }
	            this.currentData = currentData;
	            var a = contributor(), b = [], foundResult = false, itemResult = void 0;
	            for (var i = 0, l = a.length; i < l; i += 1) {
	                itemResult = this.visit(a[i], i.toString());
	                if (itemResult === undefined) {
	                    itemResult = null;
	                }
	                if (itemResult !== null) {
	                    foundResult = true;
	                }
	                b.push(itemResult);
	            }
	            this.currentCollectionName = originalCollectionName;
	            if (foundResult) {
	                result = b;
	            }
	        }
	        else if (typeof contributor === "object") {
	            this.currentData = currentData;
	            methodToCall = contributor[this._methodName];
	            if (typeof methodToCall === "function") {
	                result = methodToCall.call(contributor, this);
	                if (result === undefined) {
	                    result = null;
	                }
	            }
	        }
	        this.currentData = originalData;
	        return result;
	    };
	    return ServerCalculationContext;
	}());
	exports.ServerCalculationContext = ServerCalculationContext;
	/**
	 * Move complicated or precision-sensitive calculations to the server.
	 *
	 * For more info, see https://github.com/pandell/web-pli/wiki/Server-Calculations
	 */
	var ServerCalculation = (function () {
	    /**
	     * Creates and starts a new instance of server calculation engine.
	     * If falsy "calculationPliCallName" or "target" is specified,
	     * the created calculation engine instance will be inactive.
	     *
	     * @param {string | KnockoutObservable<string>} calculationPliCallName
	     *     Name of the Pli call that will be invoked every time a change is detected.
	     * @param {ServerCalculationContributor} target
	     *     Root of the viewmodel for which we are performing calculations.
	     * @param {number} throttleEvaluationMilliseconds
	     *     Bundle all changes that happen within this period into a single server call.
	     *     When negative value or 0 is specified, no throttling is used.
	     *     @default 250 milliseconds
	     * @param {boolean = true} verbose
	     *     Write diagnostic information using "console.log" (true) or not (false, default).
	     *     @default false
	     */
	    function ServerCalculation(calculationPliCallName, target, throttleEvaluationMilliseconds, verbose) {
	        if (throttleEvaluationMilliseconds === void 0) { throttleEvaluationMilliseconds = 250; }
	        if (verbose === void 0) { verbose = false; }
	        /**
	         * Gets an observable flag that indicates whether server calculation is currently talking to Pli server (true) or is idle (false).
	         *
	         * Can be used to update UI to indicate communication with the server
	         * (e.g. make some fields readonly or show a spinner).
	         *
	         * Should be treated as a readonly property.
	         */
	        this.calculating = ko.observable(false);
	        this._call = null;
	        this._callName = null;
	        this._target = null;
	        this._verbose = verbose;
	        this._watcher = null;
	        var callName = (ko.unwrap(calculationPliCallName) || "").toString();
	        if (callName && target) {
	            this._callName = callName;
	            this._target = target;
	            this._watcher = ko.computed({
	                read: this._beginCalculation,
	                owner: this,
	                deferEvaluation: true,
	                pure: false // keep updating even when it has no subscribers
	            });
	            if (throttleEvaluationMilliseconds > 0) {
	                this._watcher.extend({ rateLimit: throttleEvaluationMilliseconds }); // see http://knockoutjs.com/documentation/rateLimit-observable.html
	            }
	            this._watcher(); // manually trigger first evaluation (that is expected to build a list of observable dependencies)
	        }
	    }
	    /**
	     * Apply specified calculation result to the viewmodel for which we are performing calculations.
	     *
	     * Exposed publically so that it can be called manually, e.g. during viewmodel load
	     * (this is in addition to the automatic calls invoked internally by
	     * this calculation engine).
	     *
	     * @param {any} result
	     *     Result of server calculation to apply to root contributor (and its children via recursive "visit" calls).
	     *     Will be available as "context.rootData" in "applyServerCalculationResult" methods).
	     */
	    ServerCalculation.prototype.applyResult = function (result) {
	        new ServerCalculationContext("applyServerCalculationResult", result).visit(this._target);
	    };
	    // -------------------------------------------------------------------------
	    // Private
	    // -------------------------------------------------------------------------
	    /**
	     * Traverse target viewmodel, extracting data for server calculation and setting up observable dependencies
	     *
	     * The dependencies are used to re-trigger calculation in the future
	     * if any calculation input changes.
	     */
	    ServerCalculation.prototype._beginCalculation = function () {
	        var state = (this._target && this._target.state);
	        if (!state || ko.unwrap(state.isReady)) {
	            var calculationData = new ServerCalculationContext("buildServerCalculationData").visit(this._target); // create dependency on all observables used in calculation request
	            if (calculationData) {
	                var callPromise = pli.call({
	                    name: this._callName,
	                    data: calculationData,
	                    owner: this
	                });
	                this._call = callPromise.xhr;
	                this.calculating(true); // notify subscribers that we are calculating
	                callPromise.always(ServerCalculation._endCalculation);
	            }
	        }
	    };
	    /**
	     * Process result of server calculation. Calls "applyResult" unless there were problems.
	     */
	    ServerCalculation._endCalculation = function (response) {
	        if (response.owner._call !== response.clientXhr) {
	            if (response.owner._verbose) {
	                console.warn("Ignoring server calculation response", response);
	            }
	        }
	        else {
	            response.owner.applyResult(response);
	            response.owner._call = null;
	            response.owner.calculating(false); // notify subscribers that we are done calculating
	        }
	    };
	    return ServerCalculation;
	}());
	exports.ServerCalculation = ServerCalculation;
	


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(637);


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	var picklistItemExtensions = __webpack_require__(498);
	
	__webpack_require__(638);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// AreaViewModel
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function AreaViewModel(form) {
	    this.initPicklistItem("Geo-Area-", form);
	
	    this.name = this.id = pliObservable(null, null, "required");
	    this.provinceState = pliObservable(null, entityRegistry.provinceState.getPicklistBehaviourData(), "picklist", "required");
	    this.country = pliObservable(null, entityRegistry.country.getPicklistBehaviourData(), "picklist", "required");
	    this.costCentre = pliObservable();
	
	    this.extras.displayName = ko.computed(AreaViewModel.prototype._computeDisplayName, this);
	}
	
	
	//-------------------------------------------
	AreaViewModel.prototype.fromCacheItem = function areaFromCacheItem(item) {
	    var record;
	    if (item && item.length) {
	        record = {
	            guid: item[item.length - 1],
	            name: item[0],
	            provinceState: item[1],
	            country: item[2],
	            costCentre: item[3]
	        };
	    } else {
	        record = item;
	    }
	    return record;
	};
	
	
	//-------------------------------------------
	AreaViewModel.prototype.load = function loadArea(record) {
	    record = record || {};
	
	    this.name.reset();
	    this.provinceState.reset();
	    this.country.reset();
	
	    this.guid(record.guid || null);
	    this.name.load(record.name);
	    this.provinceState.load(record.provinceState);
	    this.country.load(record.country);
	    this.costCentre.load(record.costCentre);
	};
	
	
	//-------------------------------------------
	AreaViewModel.prototype._computeDisplayName = function computeAreaDisplayName() {
	    var id = this.id();
	    return (id ? "Area ".concat(id) : "(No area name yet)");
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	var areaForm = pli.forms.registry.areaForm;
	
	if (typeof areaForm !== "object") { throw new Error("Area form element could not be found - did you render it using CreateAreaForm?"); }
	if (areaForm.viewModel) { throw new Error("Area form has already been initialized"); }
	
	ko.utils.extend(AreaViewModel.prototype, picklistItemExtensions.mixins);
	areaForm.viewModel = new AreaViewModel(areaForm);
	
	entityRegistry.area.open.create = entityRegistry.area.open.edit = areaForm.viewModel.open;
	entityRegistry.area.getPicklistBehaviourData = function getPicklistBehaviourData() {
	    return {
	        onNewItem: areaForm.viewModel.open,
	        onOpenItem: areaForm.viewModel.open,
	        picklistData: dataCache.getObservable("area")
	    };
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = AreaViewModel;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(639);


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	var picklistItemExtensions = __webpack_require__(498);
	
	
	//-------------------------------------------
	var defaultConversionFactor = 2.47105381,
	    provinceStateForm = pli.forms.registry.provinceStateForm;
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// ProvinceStateViewModel
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function ProvinceStateViewModel(form) {
	    this.initPicklistItem("Geo-ProvinceState-", form);
	
	    this.code = this.id = pliObservable(null, null, "required");
	    this.description = pliObservable();
	    this.crownConversion = pliObservable(null, null, "required", "numeric");
	    this.freeholdConversion = pliObservable(null, null, "required", "numeric");
	
	    this.extras.isFixed = ko.observable(false);
	    this.extras.displayName = ko.computed(ProvinceStateViewModel.prototype._computeDisplayName, this);
	}
	
	
	//-------------------------------------------
	ProvinceStateViewModel.prototype.fromCacheItem = function provinceStateFromCacheItem(item) {
	    var record;
	    if (item && item.length) {
	        record = {
	            guid: item[item.length - 1],
	            code: item[0],
	            description: item[1],
	            crownConversion: (item[2] ? parseFloat(item[2]) : null),
	            freeholdConversion: (item[3] ? parseFloat(item[3]) : null),
	            isFixed: item[4] || false
	        };
	    } else {
	        record = item;
	    }
	    return record;
	};
	
	
	//-------------------------------------------
	ProvinceStateViewModel.prototype.load = function loadProvinceState(record) {
	    record = record || {};
	
	    this.code.reset();
	    this.description.reset();
	    this.crownConversion.reset();
	    this.freeholdConversion.reset();
	
	    this.guid(record.guid || null);
	    this.code.load(record.code);
	    this.description.load(record.description);
	    this.crownConversion.load(record.crownConversion || defaultConversionFactor);
	    this.freeholdConversion.load(record.freeholdConversion || defaultConversionFactor);
	
	    this.extras.isFixed(record.isFixed);
	};
	
	
	//-------------------------------------------
	ProvinceStateViewModel.prototype._computeDisplayName = function computeProvinceStateDisplayName() {
	    var id = this.id();
	    return (id ? "Province/State ".concat(id) : "(No province/state name yet)");
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	if (typeof provinceStateForm !== "object") { throw new Error("Province/State form element could not be found - did you render it using CreateProvinceStateForm?"); }
	if (provinceStateForm.viewModel) { throw new Error("Province/State form has already been initialized"); }
	ko.utils.extend(ProvinceStateViewModel.prototype, picklistItemExtensions.mixins);
	provinceStateForm.viewModel = new ProvinceStateViewModel(provinceStateForm);
	
	entityRegistry.provinceState.open.create = entityRegistry.provinceState.open.edit = provinceStateForm.viewModel.open;
	entityRegistry.provinceState.getPicklistBehaviourData = function getPicklistBehaviourData() {
	    return {
	        onNewItem: provinceStateForm.viewModel.open,
	        onOpenItem: provinceStateForm.viewModel.open,
	        picklistData: dataCache.getObservable("provinceState")
	    };
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = ProvinceStateViewModel;


/***/ }),
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(646);


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	"use strict";
	
	var dependentRequiredBehaviour = __webpack_require__(496);
	var ko = __webpack_require__(457);
	var multiselectBehaviour = __webpack_require__(24);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	var picklistItemExtensions = __webpack_require__(498);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Rights Product View Model
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function RightsProductViewModel(form) {
	    this.initPicklistItem("Geo-RightsProduct-", form);
	
	    this.code = this.id = pliObservable(null, null, "required");
	    this.description = pliObservable("");
	    this.isGroup = ko.observable(false);
	    this.baseProducts = pliObservable(null, { trigger: this.isGroup, expectedValue: true, picklistData: entityRegistry.rightsProductBase }, dependentRequiredBehaviour, multiselectBehaviour);
	
	    this.extras.displayName = ko.computed(RightsProductViewModel.prototype._computeDisplayName, this);
	    this.extras.isFixed = ko.observable(false);
	
	    this.extras.isFixed.subscribe(function (isFixedValue) {
	        if (isFixedValue) {
	            this.extras.message("Standardized products may not be modified.");
	        }
	    }, this);
	}
	
	
	//-------------------------------------------
	RightsProductViewModel.prototype.fromCacheItem = function rightsProductFromCacheItem(item) {
	    var record;
	    if (item && item.length) {
	        record = {
	            guid: item[item.length - 1],
	            code: item[0],
	            description: item[1],
	            isGroup: item[2],
	            isFixed: item[3]
	        };
	
	        // If is a group products, we need to query db for the base products
	        // Setting the state to "loading" will make a PLI call to get the
	        // rest of the details.
	        if (record.isGroup) {
	            this.extras.state("loading");
	        }
	
	    } else {
	        record = item;
	
	        // splits the string into an array of string values
	        if (record && typeof record.baseProducts === "string") {
	            record.baseProducts = record.baseProducts.split(', ');
	        }
	    }
	    return record;
	};
	
	
	//-------------------------------------------
	RightsProductViewModel.prototype.load = function loadRightsProduct(record) {
	    if (window.console && window.console.group) { window.console.group("RightsProductViewModel.loadViewModel", record); }
	
	    record = record || {};
	
	    this.code.reset();
	    this.description.reset();
	    this.baseProducts.reset();
	    this.extras.isFixed(false);
	
	    this.guid(record.guid || null);
	    this.code.load(record.code);
	    this.description.load(record.description);
	    this.isGroup(!!record.isGroup);
	    this.baseProducts.load(record.baseProducts);
	
	    this.extras.isFixed(!!record.isFixed);
	
	    if (window.console && window.console.groupEnd) { window.console.groupEnd(); }
	};
	
	
	//-------------------------------------------
	RightsProductViewModel.prototype._computeDisplayName = function computeRightsProductDisplayName() {
	    var id = this.id();
	    return (id ? "Rights product ".concat(id) : "(No rights product name yet)");
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	var rightsProductForm = pli.forms.registry.rightsProductForm;
	
	if (typeof rightsProductForm !== "object") { throw new Error("Rights product form element could not be found - did you render it using CreateRightsProductForm?"); }
	if (rightsProductForm.viewModel) { throw new Error("Rights product form has already been initialized"); }
	
	ko.utils.extend(RightsProductViewModel.prototype, picklistItemExtensions.mixins);
	rightsProductForm.viewModel = new RightsProductViewModel(rightsProductForm);
	
	entityRegistry.rightsProduct.open.create = entityRegistry.rightsProduct.open.edit = rightsProductForm.viewModel.open;
	entityRegistry.rightsProduct.getPicklistBehaviourData = function getPicklistBehaviourData() {
	    return {
	        onNewItem: rightsProductForm.viewModel.open,
	        onOpenItem: rightsProductForm.viewModel.open,
	        picklistData: dataCache.getObservable("rightsProduct")
	    };
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = RightsProductViewModel;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(648);


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	"use strict";
	
	var dependentRequiredBehaviour = __webpack_require__(496);
	var ko = __webpack_require__(457);
	var multiselectBehaviour = __webpack_require__(24);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	var picklistItemExtensions = __webpack_require__(498);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Zone View Model
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function ZoneViewModel(form) {
	    this.initPicklistItem("Geo-Zone-", form);
	
	    this.code = this.id = pliObservable(null, null, "required");
	    this.description = pliObservable("");
	    this.isGroup = ko.observable(false);
	    this.baseZones = pliObservable(null, { trigger: this.isGroup, expectedValue: true, picklistData: entityRegistry.zoneBase }, dependentRequiredBehaviour, multiselectBehaviour);
	    this.startAge = pliObservable(null, "N2", "numeric");
	    this.endAge = pliObservable(null, "N2", "numeric");
	
	    this.extras.displayName = ko.computed(ZoneViewModel.prototype._computeDisplayName, this);
	    this.extras.isFixed = ko.observable(false);
	
	    this.extras.isFixed.subscribe(function (isFixedValue) {
	        if (isFixedValue) {
	            this.extras.message("This is a standardized zone, it cannot be modified.");
	        }
	    }, this);
	
	    ko.computed(ZoneViewModel.prototype._computeZoneAges, this);
	}
	
	
	//-------------------------------------------
	ZoneViewModel.prototype.fromCacheItem = function zoneFromCacheItem(item) {
	    var record;
	    if (item && item.length) {
	        record = {
	            guid: item[item.length - 1],
	            code: item[0],
	            description: item[1],
	            startAge: item[2],
	            endAge: item[3],
	            isGroup: item[4],
	            isFixed: item[5]
	        };
	
	        // If record is a group zone, we need to query db for the base zones
	        // Setting the state to "loading" will make a PLI call to get the
	        // rest of the details.
	        if (record.isGroup) {
	            this.extras.state("loading");
	        }
	
	    } else {
	        record = item;
	
	        // splits the string into an array of string values
	        if (record && typeof record.baseZones === "string") {
	            record.baseZones = record.baseZones.split(', ');
	        }
	    }
	    return record;
	};
	
	
	//-------------------------------------------
	ZoneViewModel.prototype.load = function loadZone(record) {
	    if (window.console && window.console.group) { window.console.group("ZoneViewModel.loadViewModel", record); }
	
	    record = record || {};
	
	    this.code.reset();
	    this.description.reset();
	    this.baseZones.reset();
	    this.startAge.reset();
	    this.endAge.reset();
	    this.extras.isFixed(false);
	
	    this.guid(record.guid || null);
	    this.code.load(record.code);
	    this.description.load(record.description);
	    this.isGroup(!!record.isGroup);
	    this.baseZones.load(record.baseZones);
	    this.startAge.load(record.startAge);
	    this.endAge.load(record.endAge);
	
	    this.extras.isFixed(!!record.isFixed);
	
	    if (window.console && window.console.groupEnd) { window.console.groupEnd(); }
	};
	
	
	//-------------------------------------------
	ZoneViewModel.prototype._computeZoneAges = function computeZoneAges() {
	    var selectedBaseZones = this.baseZones(),
	        baseZoneDataList = entityRegistry.zoneBase.picklistData.peek();
	
	    // compute zone ages based on the max and min of the base zones
	    if (selectedBaseZones && baseZoneDataList) {
	        var result = ko.utils.arrayFilter(baseZoneDataList.data.items, function (item) {
	            return ko.utils.arrayFirst(selectedBaseZones, function (selected) {return selected === item[0]; }) !== null;
	        });
	
	        var startAges = result.map(function (resultItem) { return Number(resultItem[2]); });
	        var endAges = result.map(function (resultItem) { return Number(resultItem[3]); });
	
	        if (startAges && endAges) {
	            this.startAge.load(Math.min.apply(Math, startAges));
	            this.endAge.load(Math.max.apply(Math, endAges));
	        }
	    }
	};
	
	
	//-------------------------------------------
	ZoneViewModel.prototype._computeDisplayName = function computeZoneDisplayName() {
	    var id = this.id();
	    return (id ? "Zone ".concat(id) : "(No zone name yet)");
	};
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	var zoneForm = pli.forms.registry.zoneForm;
	
	if (typeof zoneForm !== "object") { throw new Error("Zone form element could not be found - did you render it using CreateZoneForm?"); }
	if (zoneForm.viewModel) { throw new Error("Zone form has already been initialized"); }
	
	ko.utils.extend(ZoneViewModel.prototype, picklistItemExtensions.mixins);
	zoneForm.viewModel = new ZoneViewModel(zoneForm);
	
	entityRegistry.zone.open.create = entityRegistry.zone.open.edit = zoneForm.viewModel.open;
	entityRegistry.zone.getPicklistBehaviourData = function getPicklistBehaviourData() {
	    return {
	        onNewItem: zoneForm.viewModel.open,
	        onOpenItem: zoneForm.viewModel.open,
	        picklistData: dataCache.getObservable("zone")
	    };
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = ZoneViewModel;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(650);


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	"use strict";
	
	var dateBehaviour = __webpack_require__(449).behaviours.date;
	var ko = __webpack_require__(457);
	var numberUtil = __webpack_require__(21);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var createUnitsFactory = __webpack_require__(651);
	var formattedBehaviour = __webpack_require__(518);
	var splitExtensions = __webpack_require__(545);
	
	
	//---------------------------------------
	function extractNumber(record, name) {
	    var value = record && record[name];
	    return (numberUtil.isNumber(value) ? value : null);
	}
	
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// LeaseSplitViewModelExtensions static class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function LeaseSplitViewModelExtensions(factories) {
	    this.initSplit(factories);
	
	    this.accountingCode = ko.observable("");
	    this.acquired = pliObservable(null, null, dateBehaviour);
	    this.expired = pliObservable(null, null, dateBehaviour, formattedBehaviour);
	    this.extensionCode = ko.observable("");
	    this.rentalPercentage = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric", formattedBehaviour);
	    this.terminated = pliObservable(null, null, dateBehaviour);
	
	    this.acreage = factories.createAcreage(factories);
	    this.units = factories.units.createObservableArray();
	
	    this.extras.rentalGross = ko.observable(null);
	    this.extras.rentalTotalNet = ko.observable(null);
	    this.extras.producingStatus = ko.computed(LeaseSplitViewModelExtensions.prototype._computeProducingStatus, this);
	
	    this.extras.rentalGross.currency = ko.pureComputed(function () {
	        return numberUtil.formatNumber(this.extras.rentalGross(), 'C2');
	    }, this);
	
	    this.extras.rentalTotalNet.currency = ko.pureComputed(function () {
	        return numberUtil.formatNumber(this.extras.rentalTotalNet(), 'C2');
	    }, this);
	}
	
	
	//---------------------------------------
	LeaseSplitViewModelExtensions.prototype.applyServerCalculationResult = function applyLeaseSplitResult(context) {
	    var record = context.currentData;
	    this.extras.rentalGross(extractNumber(record, "rentalGross"));
	    this.extras.rentalTotalNet(extractNumber(record, "rentalTotalNet"));
	
	    context.visit(this.acreage, "acreage");
	    context.visit(this.dois, "dois");
	};
	
	
	//---------------------------------------
	LeaseSplitViewModelExtensions.prototype.buildServerCalculationData = function buildLeaseSplitData(context) {
	    return {
	        acreage: context.visit(this.acreage),
	        dois: context.visit(this.dois),
	        rentalPercentage: this.rentalPercentage(),
	        status: this.status()
	    };
	};
	
	
	//---------------------------------------
	LeaseSplitViewModelExtensions.prototype.completeViewModel = function completeLeaseSplit() {
	    this.completeSplit();
	};
	
	
	//---------------------------------------
	LeaseSplitViewModelExtensions.prototype.initGridArray = function initLeaseSplitGridArray(gridArray) {
	    this.initSplitGridArray(gridArray);
	};
	
	
	//---------------------------------------
	LeaseSplitViewModelExtensions.prototype.loadViewModel = function loadLeaseSplit(record) {
	    this.loadSplit(record);
	
	    this.accountingCode(record.accountingCode || "");
	    this.acquired.load(record.acquired);
	    this.expired.load(record.expired);
	    this.extensionCode(record.extensionCode || "");
	    this.rentalPercentage.load(record.rentalPercentage);
	    this.terminated.load(record.terminated);
	
	    this.acreage.loadViewModel(record.acreage);
	    this.units.loadViewModel(record.units);
	};
	
	
	//-------------------------------------------
	LeaseSplitViewModelExtensions.prototype._computeProducingStatus = function computeSplitProducingStatus() {
	    var index, status,
	        producing = false;
	
	    if (this.status.isActive()) {
	        for (index = 0; !producing && index < this.relatedWells().length; index += 1) {
	            status = this.relatedWells()[index].extras.producingStatus();
	            if (status && status[0] === "P") { producing = true; }
	        }
	    }
	
	    return (producing ? "Producing" : "Non-producing");
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Export
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = {
	    createFactories: function createExtraLeaseSplitFactories(rootId, isRightsDisabled) {
	        return ko.utils.extend({
	            units: createUnitsFactory(rootId)
	        }, splitExtensions.createFactories(rootId, false, isRightsDisabled));
	    },
	    mixins: ko.utils.extend({
	        applyLeaseSplitResult: LeaseSplitViewModelExtensions.prototype.applyServerCalculationResult,
	        buildLeaseSplitData: LeaseSplitViewModelExtensions.prototype.buildServerCalculationData,
	        completeLeaseSplit: LeaseSplitViewModelExtensions.prototype.completeViewModel,
	        initLeaseSplit: LeaseSplitViewModelExtensions,
	        initLeaseSplitGridArray: LeaseSplitViewModelExtensions.prototype.initGridArray,
	        loadLeaseSplit: LeaseSplitViewModelExtensions.prototype.loadViewModel
	    }, splitExtensions.mixins)
	};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(652);


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var dateBehaviour = __webpack_require__(449).behaviours.date;
	var ko = __webpack_require__(457);
	var pliObservable = __webpack_require__(15);
	
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	var formattedBehaviour = __webpack_require__(518);
	var selectionForm = __webpack_require__(520);
	var viewModelInit = __webpack_require__(532);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Unit class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function Unit(factories) {
	    /// <summary>
	    /// Define viewmodel.
	    /// </summary>
	    if (window.console && window.console.group) { window.console.log("Unit.ctor", factories); }
	
	    this.effective = pliObservable(null, null, dateBehaviour, formattedBehaviour);
	    this.guid = ko.observable(null);
	    this.id = this.tractNumber = pliObservable(null, null, "required");
	    this.operator = pliObservable(null, entityRegistry.contact.getPicklistBehaviourData(), "picklist");
	    this.participation = pliObservable(null, "N", "numeric");
	    this.unitAgreement = pliObservable(null, dataCache.getObservable("contract"), "picklist");
	    this.unitName = ko.observable("");
	    this.unitNumber = ko.observable("");
	    this.zone = pliObservable(null, entityRegistry.zone.getPicklistBehaviourData(), "picklist");
	
	    // non-serialized properties
	    this.extras = function UnitExtras() { return; };
	    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);
	}
	
	
	//-------------------------------------------
	Unit.prototype.loadViewModel = function loadUnit(record) {
	    /// <summary>
	    /// Populate viewmodel with data.
	    /// </summary>
	    if (window.console && window.console.group) { window.console.log("Unit.loadViewModel", record); }
	
	    if (!record) { record = {}; }
	    this.effective(Date.fromJSONDate(record.effective));
	    this.guid(record.guid || null);
	    this.id.load(record.id);
	    this.operator.load(record.operator);
	    this.participation.load(record.participation);
	    this.unitAgreement.load(record.unitAgreement);
	    this.unitName(record.unitName || "");
	    this.unitNumber(record.unitNumber || "");
	    this.zone.load(record.zone);
	};
	
	
	//-------------------------------------------
	Unit.prototype.initGridArray = function initUnitGridArray(gridArray) {
	    /// <summary>
	    /// Add extra methods to the specified
	    /// terms grid array (that has just
	    /// been created).
	    /// </summary>
	    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray);
	    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);
	    gridArray.copyItems = gridArray.factory.factories.secureAction(Unit.prototype._copyItems, gridArray);
	};
	
	
	//---------------------------------------
	Unit.prototype._copyItems = function copytUnitInfo() {
	    /// <summary>
	    /// Show selection form that allows users
	    /// to find and copy unit info to this array.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores unit infos.
	    /// </remarks>
	    selectionForm.open({
	        searchApi: "Geo-Document-SearchUnits",
	        multiSelect: true,
	        text: {
	            acceptButton: "Copy",
	            iconClass: "sprite-copy-16",
	            examples: [
	                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
	            ],
	            title: "Copy Unit Info"
	        },
	        onAcceptedContext: this,
	        onAccepted: function (newUnitRows) {
	            // push to array
	            selectionForm.utils.pushRowItems({
	                targetArray: this,
	                records: newUnitRows,
	                rowMap: { id: 3, participation: 4, unitNumber: 5, unitName: 6, effective: 7, operator: 8, zone: 9, unitAgreement: 10 }
	            });
	        }
	    });
	};
	
	
	//-------------------------------------------
	Unit.prototype.itemComparer = null; // disable client-side sorting
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = viewModelInit.standardFactoryCreatorFor(
	    Unit,
	    "units"
	);


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(654);


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	var numberFormatter = __webpack_require__(21).formatNumber;
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var createContactPercentageFactory = __webpack_require__(544);
	var createLeaseRentalInformation = __webpack_require__(655);
	var createProvisionsFactory = __webpack_require__(573);
	var dataCache = __webpack_require__(488);
	var dateBehaviour = __webpack_require__(449).behaviours.date;
	var documentExtensions = __webpack_require__(575);
	var entityRegistry = __webpack_require__(492);
	var selectionForm = __webpack_require__(520);
	
	__webpack_require__(636);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// LeaseViewModelExtensions class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//---------------------------------------
	function LeaseViewModelExtensions(factories) {
	    /// <summary>
	    /// Define viewmodel.
	    /// </summary>
	
	    // initialize base mixins
	    this.initDocument(factories);
	
	    // serializable properties
	    this.leaseStatus = pliObservable(null, entityRegistry.leaseStatus.getPicklistBehaviourData(), "picklist");
	    this.leaseStatus.isActive = ko.computed(LeaseViewModelExtensions.prototype._computeIsStatusActive, this.leaseStatus);
	
	    this.holdingType = pliObservable(null, dataCache.getObservable("holdingType"), "required", "picklist");
	    this.lessorNumber = ko.observable("");
	    this.originalNumber = ko.observable("");
	    this.area = pliObservable(null, entityRegistry.area.getPicklistBehaviourData(), "required", "picklist");
	
	    this.acquisitionMethod = pliObservable(null, entityRegistry.acquisitionMethod.getPicklistBehaviourData(), "picklist");
	    this.acreageEntryType = pliObservable("Acres", dataCache.getObservable("acreageEntryType"), "required", "picklist");
	    this.acreageEntryType.publishOn("acreageEntryType");
	
	    this.acquired = pliObservable(null, null, dateBehaviour);
	    this.terminated = pliObservable(null, null, dateBehaviour);
	    this.leased = pliObservable(null, null, dateBehaviour);
	    this.effective = pliObservable(null, null, dateBehaviour);
	    this.termType = ko.observable("Years");
	    this.term = pliObservable(null, "N0", "numeric");
	    this.expired = pliObservable(null, null, dateBehaviour);
	    this.extras._effectiveCalculation = ko.computed(LeaseViewModelExtensions.prototype._computeExpiryDate, this);
	
	    this.mainCost = pliObservable(null, "C2", "numeric");
	    this.extraCost = pliObservable(null, "C2", "numeric");
	    this.cost = ko.computed(LeaseViewModelExtensions.prototype._computeTotalCost, this);
	    this.acquisitionPercentage = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric");
	    this.acquisitionShare = pliObservable(null, "C2", "numeric");
	    this.extras._acquisitionShareSubscription = this.acquisitionShare.subscribe(LeaseViewModelExtensions.prototype._computeAcquisitionPercentage, this); // store in field to auto-dispose
	    this.extras._acquisitionShareComputation = ko.computed(LeaseViewModelExtensions.prototype._computeAcquisitionShare, this); // store in field to auto-dispose
	
	    this.lessees = factories.lessee.createObservableArray();
	    this.lessors = factories.lessor.createObservableArray();
	    this.provisions = factories.provisions.createObservableArray();
	    this.rental = createLeaseRentalInformation(factories);
	    this.extras._firstRentCalculation = ko.computed(LeaseViewModelExtensions.prototype._computeFirstRentDate, this);
	
	    // non-serialized properties
	    this.extras.errorsCountRental = ko.computed(LeaseViewModelExtensions.prototype._computeRentalErrorsCount, this);
	    this.extras.errorsCountLessees = ko.computed(LeaseViewModelExtensions.prototype._computeLessesErrorsCount, this);
	    this.extras.producingStatus = ko.computed(LeaseViewModelExtensions.prototype._computeProducingStatus, this);
	}
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype.applyServerCalculationResult = function applyLeaseResult(context) {
	    this.applyDocumentResult(context);
	    context.visit(this.lessors, "lessors");
	    context.visit(this.rental, "rental");
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype.buildServerCalculationData = function buildLeaseData(context) {
	    var documentData = this.buildDocumentData(context);
	    if (documentData) {
	        documentData.acreageEntryType = this.acreageEntryType();
	        documentData.area = this.area();
	        documentData.holdingType = this.holdingType();
	        documentData.lessors = context.visit(this.lessors);
	        documentData.rental = context.visit(this.rental);
	    }
	
	    return documentData;
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype.loadViewModel = function loadLease(record) {
	    this.loadDocument(record);
	
	    this.leaseStatus.load(record.leaseStatus);
	    this.holdingType.load(record.holdingType);
	    this.lessorNumber(record.lessorNumber || "");
	    this.originalNumber(record.originalNumber || "");
	    this.area.load(record.area);
	
	    this.acquisitionMethod.load(record.acquisitionMethod);
	    this.acreageEntryType.load(record.acreageEntryType || "Acres");
	
	    this.acquired.load(record.acquired);
	    this.terminated.load(record.terminated);
	    this.leased.load(record.leased);
	    this.effective.load(record.effective);
	    this.term.load(record.term);
	    this.termType(record.termType || "Years");
	    this.expired.load(record.expired);
	
	    this.mainCost.load(record.mainCost);
	    this.extraCost.load(record.extraCost);
	    this.acquisitionPercentage.load(record.acquisitionPercentage);
	
	    this.lessees.loadViewModel(record.lessees);
	    this.lessors.loadViewModel(record.lessors);
	    this.provisions.loadViewModel(record.provisions);
	    this.rental.loadViewModel(record.rental);
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype._computeRentalErrorsCount = function computeLeaseRentalErrorsCount() {
	    var totalError = (this.lessors().length > 0 && this.lessors.totalPercentage.invalid()) ? 1 : 0;
	    return this.rental.extras.errorsCount() + this.lessors.errorsCount() + totalError;
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype._computeLessesErrorsCount = function computeLeaseLessesErrorsCount() {
	    var totalError = (this.lessees().length > 0 && this.lessees.totalPercentage.invalid()) ? 1 : 0;
	    return this.lessees.errorsCount() + totalError;
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype._computeTotalCost = function computeLeaseTotalCost() {
	    return numberFormatter((this.mainCost() || 0) + (this.extraCost() || 0), "C2");
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype._computeAcquisitionPercentage = function computeLeaseAcquisitionPercentage() {
	    var percentage, newPercentage,
	        total = (this.mainCost() || 0) + (this.extraCost() || 0);
	
	    if (total !== 0) {
	        percentage = this.acquisitionPercentage() || 0;
	        newPercentage = this.acquisitionShare() * 100 / total;
	        if (Math.abs(percentage - newPercentage) > 0.00001) {
	            this.acquisitionPercentage(newPercentage);
	        }
	    }
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype._computeAcquisitionShare = function computeLeaseAcquisitionShare() {
	    var share, newShare,
	        total = (this.mainCost() || 0) + (this.extraCost() || 0);
	
	    if (total !== 0) {
	        share = this.acquisitionShare() || 0;
	        newShare = total * this.acquisitionPercentage() / 100;
	        if (Math.abs(share - newShare) > 0.00001) {
	            this.acquisitionShare(newShare);
	        }
	    }
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype._computeExpiryDate = function computeExpiryDate() {
	    var termType = this.termType(), t = this.term(), e = this.effective(), c;
	    // set expired date if termType is not custom
	    // Expiry date = Effective Date + term - 1 day
	    if (t && e && termType !== "Custom") {
	        c = new Date(e);
	        if (termType === "Months") {
	            c.setMonth(e.getMonth() + t);
	        } else if (termType === "Years") {
	            c.setFullYear(e.getFullYear() + t);
	        }
	        c.setDate(c.getDate() - 1);
	        this.expired(c);
	    }
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype._computeFirstRentDate = function computeFirstRentDate() {
	    var d = this.effective(), c;
	    if (d) {
	        c = new Date(d);
	        c.setFullYear(d.getFullYear() + 1);
	        c.setDate(c.getDate() - 1); //decrease the date by day
	        this.rental.firstRent(c);
	    }
	};
	
	
	//-------------------------------------------
	LeaseViewModelExtensions.prototype._computeIsStatusActive = function computeIsStatusActive() {
	    /// <summary>
	    /// Compute whether "this" lease status
	    /// is active or not (boolean flag).
	    /// </summary>
	    var statusDescriptorArray = (this.item && this.item());
	    return (statusDescriptorArray && statusDescriptorArray.length > 2 && statusDescriptorArray[2].toUpperCase() === "ACTIVE");
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype._computeProducingStatus = function computeLeaseProducingStatus() {
	    var index,
	        producing = false;
	
	    if (this.leaseStatus && this.leaseStatus.isActive()) {
	        for (index = 0; !producing && index < this.splits().length; index += 1) {
	            if (this.splits()[index].status.isActive() && this.splits()[index].extras.producingStatus()[0] === "P") {
	                producing = true;
	            }
	        }
	    }
	
	    return producing ? "Producing" : "Non-producing";
	};
	
	
	//---------------------------------------
	LeaseViewModelExtensions.prototype._copyLessees = function copyLessees() {
	    /// <summary>
	    /// Show selection form that allows users
	    /// to find and copy contract percentage to this array.
	    /// </summary>
	    /// <remarks>
	    /// Expects "this" to be a grid observable
	    /// array that creates and stores contract percentages.
	    /// </remarks>
	    selectionForm.open({
	        searchApi: "Geo-Document-SearchLessees",
	        multiSelect: true,
	        text: {
	            acceptButton: "Copy",
	            iconClass: "sprite-copy-16",
	            examples: [
	                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
	                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
	                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
	                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
	            ],
	            title: "Copy Lessees"
	        },
	        onAcceptedContext: this,
	        onAccepted: function (newContactPercentageRows) {
	            // push to array
	            selectionForm.utils.pushRowItems({
	                targetArray: this,
	                records: newContactPercentageRows,
	                rowMap: { contact: 3, silent: 6, percentage: 7 }
	            });
	        }
	    });
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Export
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = {
	    createFactories: function createExtraLeaseSplitFactories(rootId, createSplitsFactory) {
	        return ko.utils.extend({
	            lessee: createContactPercentageFactory(rootId, "lessees", true, LeaseViewModelExtensions.prototype._copyLessees), // true => client total percentage calculation
	            lessor: createContactPercentageFactory(rootId, "lessors", false), // false => server total percentage calculation
	            provisions: createProvisionsFactory(rootId)
	        }, documentExtensions.createFactories(rootId, createSplitsFactory));
	    },
	    mixins: ko.utils.extend({
	        applyLeaseResult: LeaseViewModelExtensions.prototype.applyServerCalculationResult,
	        buildLeaseData: LeaseViewModelExtensions.prototype.buildServerCalculationData,
	        initLease: LeaseViewModelExtensions,
	        loadLease: LeaseViewModelExtensions.prototype.loadViewModel
	    }, documentExtensions.mixins)
	};


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(656);


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	
	"use strict";
	
	var ko = __webpack_require__(457);
	var numberUtil = __webpack_require__(21);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	
	//-------------------------------------------
	function extractNumber(record, name) {
	    var value = record && record[name];
	    return (numberUtil.isNumber(value) ? value : null);
	}
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// RentalInformation class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function RentalInformation(factories) {
	    /// <summary>
	    /// Create a new RentalInformation object,
	    /// populating it with values from the specified
	    /// record (if any).
	    /// </summary>
	    if (!(this instanceof RentalInformation)) { return new RentalInformation(factories); } // if new was not used, force it now
	    if (window.console && window.console.group) { window.console.log("RentalInformation.ctor()", factories); }
	
	    this.amount = pliObservable(null, "C2", "numeric");
	    this.firstRent = pliObservable(null, null, "date");
	    this.frequency = pliObservable("Annual", dataCache.getObservable("rentalFrequency"), "picklist");
	    this.payor = pliObservable(null, entityRegistry.contact.getPicklistBehaviourData(), "picklist");
	    this.unitOfMeasure = pliObservable(null, dataCache.getObservable("rentalUnitOfMeasure"), "picklist");
	
	    // non-serialized properties
	    this.extras = function RentalInformationExtras() { return; };
	    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);
	    this.extras.gross = ko.observable(null);
	    this.extras.totalGross = ko.observable(null);
	    this.extras.totalNet = ko.observable(null);
	    this.extras.totalPercentage = ko.observable(null);
	    this.extras.totalPercentage.invalid = ko.computed(this._computeTotalPercentageInvalid, this.extras.totalPercentage);
	    this.extras._totalPercentageInvalid = this.extras.totalPercentage.invalid; // store in extras field to ensure disposal
	
	    this.extras._amountSubscription = this.amount.subscribe(function (newValue) {
	        if ((newValue === 0 || newValue === null) && !this.unitOfMeasure()) {
	            // Clean error message that comes from server-side validation 
	            this.unitOfMeasure.validate();
	        }
	    }, this);
	
	    this.extras.gross.currency = ko.pureComputed(function () {
	        return numberUtil.formatNumber(this.extras.gross(), 'C2');
	    }, this);
	
	    this.extras.totalNet.currency = ko.pureComputed(function () {
	        return numberUtil.formatNumber(this.extras.totalNet(), 'C2');
	    }, this);
	
	    this.extras.totalPercentage.precision = ko.pureComputed(function () {
	        return numberUtil.formatNumber(this.extras.totalPercentage(), pli.config.editorPrecisionPercentFormat);
	    }, this);
	}
	
	
	//---------------------------------------
	RentalInformation.prototype.applyServerCalculationResult = function applyResultToRental(context) {
	    var record = context.currentData;
	    this.extras.gross(extractNumber(record, "gross"));
	    this.extras.totalGross(extractNumber(record, "totalGross"));
	    this.extras.totalNet(extractNumber(record, "totalNet"));
	    this.extras.totalPercentage(extractNumber(record, "totalPercentage"));
	};
	
	
	//---------------------------------------
	RentalInformation.prototype.buildServerCalculationData = function buildDataForRental() {
	    return {
	        amount: this.amount(),
	        payor: this.payor(),
	        unitOfMeasure: this.unitOfMeasure()
	    };
	};
	
	
	//-------------------------------------------
	RentalInformation.prototype.loadViewModel = function loadRentalInformation(record) {
	    if (window.console && window.console.group) { window.console.log("RentalInformation.load", record); }
	
	    if (!record) { record = {}; }
	
	    this.firstRent.load(record.firstRent);
	    this.amount.load(record.amount);
	    this.frequency.load(record.frequency || "Annual");
	    this.payor.load(record.payor);
	    this.unitOfMeasure.load(record.unitOfMeasure);
	};
	
	
	//---------------------------------------
	RentalInformation.prototype._computeTotalPercentageInvalid = function computeTotalPercentageInvalid() {
	    var totalPercentage = this(),
	    // Calculate the delta used for javascript floating point precision problem
	    // using the decimal precision settings
	    // http://stackoverflow.com/questions/588004/is-floating-point-math-broken
	        precision = pli.config.editorPrecision || 5,
	        delta = Math.pow(10, -(precision + 1));
	
	    return (totalPercentage !== null && Math.abs(100 - totalPercentage) > delta);
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	module.exports = RentalInformation;


/***/ }),
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(700);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(701);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(311)))

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}


/***/ }),
/* 701 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}
	


/***/ }),
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	__webpack_require__(716);


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	var pli = __webpack_require__(380);
	var pliObservable = __webpack_require__(15);
	
	var dataCache = __webpack_require__(488);
	var entityRegistry = __webpack_require__(492);
	var picklistItemExtensions = __webpack_require__(498);
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// WellStatusViewModel
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function WellStatusViewModel(form) {
	    this.initPicklistItem("Geo-WellStatus-", form);
	
	    this.code = this.id = pliObservable(null, null, "required");
	    this.description = pliObservable(null);
	    this.producingStatus = pliObservable(null, dataCache.getObservable("producingCode"), "picklist", "required");
	
	    this.extras.displayName = ko.computed(WellStatusViewModel.prototype._computeDisplayName, this);
	}
	
	
	//-------------------------------------------
	WellStatusViewModel.prototype.fromCacheItem = function wellStatusFromCacheItem(item) {
	    var record;
	    if (item && item.length) {
	        record = {
	            guid: item[item.length - 1],
	            code: item[0],
	            description: item[1],
	            producingStatus: item[2]
	        };
	    } else {
	        record = item;
	    }
	    return record;
	};
	
	
	//-------------------------------------------
	WellStatusViewModel.prototype.load = function loadWellStatus(record) {
	    record = record || {};
	
	    this.code.reset();
	    this.producingStatus.reset();
	
	    this.guid(record.guid || null);
	    this.code(record.code || null);
	    this.description(record.description || null);
	    this.producingStatus(record.producingStatus || null);
	};
	
	
	//-------------------------------------------
	WellStatusViewModel.prototype._computeDisplayName = function computeWellStatusDisplayName() {
	    var id = this.id();
	    return (id ? "Well Status ".concat(id) : "(No code yet)");
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Initialization
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	var wellStatusForm = pli.forms.registry.wellStatusForm;
	if (typeof wellStatusForm !== "object") { throw new Error("Well Status form element could not be found - did you render it using CreateWellStatusForm?"); }
	if (wellStatusForm.viewModel) { throw new Error("Well Status form has already been initialized"); }
	
	ko.utils.extend(WellStatusViewModel.prototype, picklistItemExtensions.mixins);
	wellStatusForm.viewModel = new WellStatusViewModel(wellStatusForm);
	
	entityRegistry.wellStatus.open.create = entityRegistry.wellStatus.open.edit = wellStatusForm.viewModel.open;
	entityRegistry.wellStatus.getPicklistBehaviourData = function getPicklistBehaviourData() {
	    return {
	        onNewItem: wellStatusForm.viewModel.open,
	        onOpenItem: wellStatusForm.viewModel.open,
	        picklistData: dataCache.getObservable("wellStatus")
	    };
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = WellStatusViewModel;


/***/ }),
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	
	module.exports = __webpack_require__(737);


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "SingleItemArrayBehaviour" class
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	function SingleItemArrayBehaviour() {
	    /// <summary>
	    /// Behaviour for a single item array
	    /// Only one option is possible, if no one or more then one item is selected
	    /// value of the observable would be reset to default
	    /// </summary>
	    return this; // keep JSLint happy
	}
	
	//-------------------------------------------
	SingleItemArrayBehaviour.prototype.init = function picklistBehaviourInit() {
	    var options = this.behaviourData;
	    this.defaultValue = (options && options.defaultValue) || "";
	
	    this.array = ko.observableArray();
	    this.array.subscribe(SingleItemArrayBehaviour.prototype._arrayValueChanged, this);
	
	    this.subscribe(SingleItemArrayBehaviour.prototype._parse, this);
	    this.valueHasMutated();
	};
	
	
	//-------------------------------------------
	SingleItemArrayBehaviour.prototype._parse = function singleItemArrayBehaviourParse() {
	    if (this._internalUpdate) { return; }
	    if (this()) { this.array([this()]); }
	};
	
	
	//-------------------------------------------
	SingleItemArrayBehaviour.prototype._arrayValueChanged = function singleItemArrayBehaviourArrayValueChanged(value) {
	    var newValue = (value && value.length === 1) ? value[0] : this.defaultValue;
	    if (this() !== newValue) { this(newValue); }
	};
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = new SingleItemArrayBehaviour();


/***/ }),
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint node: true, browser: true*/
	"use strict";
	
	var ko = __webpack_require__(457);
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// "ReportHistoryItem" view model
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	function ReportHistoryItemViewModel() {
	
	    this.id = ko.observable();
	    this.fileStoreId = ko.observable();
	    this.fileName = ko.observable();
	    this.fileCreatedBy = ko.observable();
	    this.criteriaJson = ko.observable();
	
	    this.extras = function ReportHistoryViewModelExtras() { return; };
	    this.extras.criteria = ko.computed(ReportHistoryItemViewModel.prototype._parseCriteria, this);
	}
	
	
	//-------------------------------------------
	ReportHistoryItemViewModel.prototype._parseCriteria = function parseCriteria() {
	    if (!this.criteriaJson()) { return {}; }
	    return JSON.parse(this.criteriaJson());
	};
	
	
	//-------------------------------------------
	ReportHistoryItemViewModel.prototype.loadViewModel = function loadViewModel(record) {
	    if (!record) { record = {}; }
	    this.id(record.fileStoreId);
	    this.fileStoreId(record.fileStoreId);
	    this.fileName(record.fileName);
	    this.criteriaJson(record.criteria);
	    this.fileCreatedBy(record.fileCreatedBy);
	};
	
	
	//-------------------------------------------
	ReportHistoryItemViewModel.prototype.itemComparer = null; // rely on server-side sorting (append-only on the client)
	
	
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// Exports
	//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	//-------------------------------------------
	module.exports = ReportHistoryItemViewModel;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.js